import * as React from "react";
import React__default, { useContext, useMemo as useMemo$1, forwardRef, Component, createContext, useState, Suspense, memo, useRef, useCallback, useEffect, Fragment, PureComponent, lazy, useLayoutEffect as useLayoutEffect$1, createElement, Children, Profiler as Profiler$1, version, isValidElement, useSyncExternalStore, cloneElement, useId } from "react";
import ReactDOM, { unstable_batchedUpdates, flushSync } from "react-dom";
var commonjsGlobal$1 = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function getDefaultExportFromCjs(o) {
  return o && o.__esModule && Object.prototype.hasOwnProperty.call(o, "default") ? o.default : o;
}
function getAugmentedNamespace(o) {
  if (Object.prototype.hasOwnProperty.call(o, "__esModule")) return o;
  var E = o.default;
  if (typeof E == "function") {
    var A = function g() {
      var e = !1;
      try {
        e = this instanceof g;
      } catch {
      }
      return e ? Reflect.construct(E, arguments, this.constructor) : E.apply(this, arguments);
    };
    A.prototype = E.prototype;
  } else A = {};
  return Object.defineProperty(A, "__esModule", { value: !0 }), Object.keys(o).forEach(function(g) {
    var e = Object.getOwnPropertyDescriptor(o, g);
    Object.defineProperty(A, g, e.get ? e : {
      enumerable: !0,
      get: function() {
        return o[g];
      }
    });
  }), A;
}
var jsxRuntime = { exports: {} }, reactJsxRuntime_production_min = {};
var hasRequiredReactJsxRuntime_production_min;
function requireReactJsxRuntime_production_min() {
  if (hasRequiredReactJsxRuntime_production_min) return reactJsxRuntime_production_min;
  hasRequiredReactJsxRuntime_production_min = 1;
  var o = React__default, E = Symbol.for("react.element"), A = Symbol.for("react.fragment"), g = Object.prototype.hasOwnProperty, e = o.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, t = { key: !0, ref: !0, __self: !0, __source: !0 };
  function c(n, h, d) {
    var k, p = {}, M = null, S = null;
    d !== void 0 && (M = "" + d), h.key !== void 0 && (M = "" + h.key), h.ref !== void 0 && (S = h.ref);
    for (k in h) g.call(h, k) && !t.hasOwnProperty(k) && (p[k] = h[k]);
    if (n && n.defaultProps) for (k in h = n.defaultProps, h) p[k] === void 0 && (p[k] = h[k]);
    return { $$typeof: E, type: n, key: M, ref: S, props: p, _owner: e.current };
  }
  return reactJsxRuntime_production_min.Fragment = A, reactJsxRuntime_production_min.jsx = c, reactJsxRuntime_production_min.jsxs = c, reactJsxRuntime_production_min;
}
var reactJsxRuntime_development = {};
var hasRequiredReactJsxRuntime_development;
function requireReactJsxRuntime_development() {
  return hasRequiredReactJsxRuntime_development || (hasRequiredReactJsxRuntime_development = 1, process.env.NODE_ENV !== "production" && (function() {
    var o = React__default, E = Symbol.for("react.element"), A = Symbol.for("react.portal"), g = Symbol.for("react.fragment"), e = Symbol.for("react.strict_mode"), t = Symbol.for("react.profiler"), c = Symbol.for("react.provider"), n = Symbol.for("react.context"), h = Symbol.for("react.forward_ref"), d = Symbol.for("react.suspense"), k = Symbol.for("react.suspense_list"), p = Symbol.for("react.memo"), M = Symbol.for("react.lazy"), S = Symbol.for("react.offscreen"), AA = Symbol.iterator, H = "@@iterator";
    function gA(rA) {
      if (rA === null || typeof rA != "object")
        return null;
      var SA = AA && rA[AA] || rA[H];
      return typeof SA == "function" ? SA : null;
    }
    var CA = o.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function IA(rA) {
      {
        for (var SA = arguments.length, qA = new Array(SA > 1 ? SA - 1 : 0), _A = 1; _A < SA; _A++)
          qA[_A - 1] = arguments[_A];
        BA("error", rA, qA);
      }
    }
    function BA(rA, SA, qA) {
      {
        var _A = CA.ReactDebugCurrentFrame, ag = _A.getStackAddendum();
        ag !== "" && (SA += "%s", qA = qA.concat([ag]));
        var lg = qA.map(function(Eg) {
          return String(Eg);
        });
        lg.unshift("Warning: " + SA), Function.prototype.apply.call(console[rA], console, lg);
      }
    }
    var QA = !1, EA = !1, oA = !1, iA = !1, aA = !1, tA;
    tA = Symbol.for("react.module.reference");
    function eA(rA) {
      return !!(typeof rA == "string" || typeof rA == "function" || rA === g || rA === t || aA || rA === e || rA === d || rA === k || iA || rA === S || QA || EA || oA || typeof rA == "object" && rA !== null && (rA.$$typeof === M || rA.$$typeof === p || rA.$$typeof === c || rA.$$typeof === n || rA.$$typeof === h || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      rA.$$typeof === tA || rA.getModuleId !== void 0));
    }
    function cA(rA, SA, qA) {
      var _A = rA.displayName;
      if (_A)
        return _A;
      var ag = SA.displayName || SA.name || "";
      return ag !== "" ? qA + "(" + ag + ")" : qA;
    }
    function DA(rA) {
      return rA.displayName || "Context";
    }
    function nA(rA) {
      if (rA == null)
        return null;
      if (typeof rA.tag == "number" && IA("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof rA == "function")
        return rA.displayName || rA.name || null;
      if (typeof rA == "string")
        return rA;
      switch (rA) {
        case g:
          return "Fragment";
        case A:
          return "Portal";
        case t:
          return "Profiler";
        case e:
          return "StrictMode";
        case d:
          return "Suspense";
        case k:
          return "SuspenseList";
      }
      if (typeof rA == "object")
        switch (rA.$$typeof) {
          case n:
            var SA = rA;
            return DA(SA) + ".Consumer";
          case c:
            var qA = rA;
            return DA(qA._context) + ".Provider";
          case h:
            return cA(rA, rA.render, "ForwardRef");
          case p:
            var _A = rA.displayName || null;
            return _A !== null ? _A : nA(rA.type) || "Memo";
          case M: {
            var ag = rA, lg = ag._payload, Eg = ag._init;
            try {
              return nA(Eg(lg));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var wA = Object.assign, lA = 0, NA, RA, KA, vA, GA, FA, HA;
    function sA() {
    }
    sA.__reactDisabledLog = !0;
    function mA() {
      {
        if (lA === 0) {
          NA = console.log, RA = console.info, KA = console.warn, vA = console.error, GA = console.group, FA = console.groupCollapsed, HA = console.groupEnd;
          var rA = {
            configurable: !0,
            enumerable: !0,
            value: sA,
            writable: !0
          };
          Object.defineProperties(console, {
            info: rA,
            log: rA,
            warn: rA,
            error: rA,
            group: rA,
            groupCollapsed: rA,
            groupEnd: rA
          });
        }
        lA++;
      }
    }
    function xA() {
      {
        if (lA--, lA === 0) {
          var rA = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: wA({}, rA, {
              value: NA
            }),
            info: wA({}, rA, {
              value: RA
            }),
            warn: wA({}, rA, {
              value: KA
            }),
            error: wA({}, rA, {
              value: vA
            }),
            group: wA({}, rA, {
              value: GA
            }),
            groupCollapsed: wA({}, rA, {
              value: FA
            }),
            groupEnd: wA({}, rA, {
              value: HA
            })
          });
        }
        lA < 0 && IA("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var hA = CA.ReactCurrentDispatcher, MA;
    function YA(rA, SA, qA) {
      {
        if (MA === void 0)
          try {
            throw Error();
          } catch (ag) {
            var _A = ag.stack.trim().match(/\n( *(at )?)/);
            MA = _A && _A[1] || "";
          }
        return `
` + MA + rA;
      }
    }
    var LA = !1, WA;
    {
      var zA = typeof WeakMap == "function" ? WeakMap : Map;
      WA = new zA();
    }
    function ZA(rA, SA) {
      if (!rA || LA)
        return "";
      {
        var qA = WA.get(rA);
        if (qA !== void 0)
          return qA;
      }
      var _A;
      LA = !0;
      var ag = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var lg;
      lg = hA.current, hA.current = null, mA();
      try {
        if (SA) {
          var Eg = function() {
            throw Error();
          };
          if (Object.defineProperty(Eg.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(Eg, []);
            } catch (Fg) {
              _A = Fg;
            }
            Reflect.construct(rA, [], Eg);
          } else {
            try {
              Eg.call();
            } catch (Fg) {
              _A = Fg;
            }
            rA.call(Eg.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Fg) {
            _A = Fg;
          }
          rA();
        }
      } catch (Fg) {
        if (Fg && _A && typeof Fg.stack == "string") {
          for (var Qg = Fg.stack.split(`
`), dg = _A.stack.split(`
`), wg = Qg.length - 1, yg = dg.length - 1; wg >= 1 && yg >= 0 && Qg[wg] !== dg[yg]; )
            yg--;
          for (; wg >= 1 && yg >= 0; wg--, yg--)
            if (Qg[wg] !== dg[yg]) {
              if (wg !== 1 || yg !== 1)
                do
                  if (wg--, yg--, yg < 0 || Qg[wg] !== dg[yg]) {
                    var kg = `
` + Qg[wg].replace(" at new ", " at ");
                    return rA.displayName && kg.includes("<anonymous>") && (kg = kg.replace("<anonymous>", rA.displayName)), typeof rA == "function" && WA.set(rA, kg), kg;
                  }
                while (wg >= 1 && yg >= 0);
              break;
            }
        }
      } finally {
        LA = !1, hA.current = lg, xA(), Error.prepareStackTrace = ag;
      }
      var Lg = rA ? rA.displayName || rA.name : "", Sg = Lg ? YA(Lg) : "";
      return typeof rA == "function" && WA.set(rA, Sg), Sg;
    }
    function Ag(rA, SA, qA) {
      return ZA(rA, !1);
    }
    function UA(rA) {
      var SA = rA.prototype;
      return !!(SA && SA.isReactComponent);
    }
    function ig(rA, SA, qA) {
      if (rA == null)
        return "";
      if (typeof rA == "function")
        return ZA(rA, UA(rA));
      if (typeof rA == "string")
        return YA(rA);
      switch (rA) {
        case d:
          return YA("Suspense");
        case k:
          return YA("SuspenseList");
      }
      if (typeof rA == "object")
        switch (rA.$$typeof) {
          case h:
            return Ag(rA.render);
          case p:
            return ig(rA.type, SA, qA);
          case M: {
            var _A = rA, ag = _A._payload, lg = _A._init;
            try {
              return ig(lg(ag), SA, qA);
            } catch {
            }
          }
        }
      return "";
    }
    var og = Object.prototype.hasOwnProperty, PA = {}, Gg = CA.ReactDebugCurrentFrame;
    function gg(rA) {
      if (rA) {
        var SA = rA._owner, qA = ig(rA.type, rA._source, SA ? SA.type : null);
        Gg.setExtraStackFrame(qA);
      } else
        Gg.setExtraStackFrame(null);
    }
    function eg(rA, SA, qA, _A, ag) {
      {
        var lg = Function.call.bind(og);
        for (var Eg in rA)
          if (lg(rA, Eg)) {
            var Qg = void 0;
            try {
              if (typeof rA[Eg] != "function") {
                var dg = Error((_A || "React class") + ": " + qA + " type `" + Eg + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof rA[Eg] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw dg.name = "Invariant Violation", dg;
              }
              Qg = rA[Eg](SA, Eg, _A, qA, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (wg) {
              Qg = wg;
            }
            Qg && !(Qg instanceof Error) && (gg(ag), IA("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", _A || "React class", qA, Eg, typeof Qg), gg(null)), Qg instanceof Error && !(Qg.message in PA) && (PA[Qg.message] = !0, gg(ag), IA("Failed %s type: %s", qA, Qg.message), gg(null));
          }
      }
    }
    var Dg = Array.isArray;
    function rg(rA) {
      return Dg(rA);
    }
    function cg(rA) {
      {
        var SA = typeof Symbol == "function" && Symbol.toStringTag, qA = SA && rA[Symbol.toStringTag] || rA.constructor.name || "Object";
        return qA;
      }
    }
    function hg(rA) {
      try {
        return Cg(rA), !1;
      } catch {
        return !0;
      }
    }
    function Cg(rA) {
      return "" + rA;
    }
    function dA(rA) {
      if (hg(rA))
        return IA("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", cg(rA)), Cg(rA);
    }
    var pA = CA.ReactCurrentOwner, XA = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, jA, OA;
    function VA(rA) {
      if (og.call(rA, "ref")) {
        var SA = Object.getOwnPropertyDescriptor(rA, "ref").get;
        if (SA && SA.isReactWarning)
          return !1;
      }
      return rA.ref !== void 0;
    }
    function $A(rA) {
      if (og.call(rA, "key")) {
        var SA = Object.getOwnPropertyDescriptor(rA, "key").get;
        if (SA && SA.isReactWarning)
          return !1;
      }
      return rA.key !== void 0;
    }
    function fA(rA, SA) {
      typeof rA.ref == "string" && pA.current;
    }
    function yA(rA, SA) {
      {
        var qA = function() {
          jA || (jA = !0, IA("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", SA));
        };
        qA.isReactWarning = !0, Object.defineProperty(rA, "key", {
          get: qA,
          configurable: !0
        });
      }
    }
    function bA(rA, SA) {
      {
        var qA = function() {
          OA || (OA = !0, IA("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", SA));
        };
        qA.isReactWarning = !0, Object.defineProperty(rA, "ref", {
          get: qA,
          configurable: !0
        });
      }
    }
    var kA = function(rA, SA, qA, _A, ag, lg, Eg) {
      var Qg = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: E,
        // Built-in properties that belong on the element
        type: rA,
        key: SA,
        ref: qA,
        props: Eg,
        // Record the component responsible for creating this element.
        _owner: lg
      };
      return Qg._store = {}, Object.defineProperty(Qg._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(Qg, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: _A
      }), Object.defineProperty(Qg, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: ag
      }), Object.freeze && (Object.freeze(Qg.props), Object.freeze(Qg)), Qg;
    };
    function JA(rA, SA, qA, _A, ag) {
      {
        var lg, Eg = {}, Qg = null, dg = null;
        qA !== void 0 && (dA(qA), Qg = "" + qA), $A(SA) && (dA(SA.key), Qg = "" + SA.key), VA(SA) && (dg = SA.ref, fA(SA, ag));
        for (lg in SA)
          og.call(SA, lg) && !XA.hasOwnProperty(lg) && (Eg[lg] = SA[lg]);
        if (rA && rA.defaultProps) {
          var wg = rA.defaultProps;
          for (lg in wg)
            Eg[lg] === void 0 && (Eg[lg] = wg[lg]);
        }
        if (Qg || dg) {
          var yg = typeof rA == "function" ? rA.displayName || rA.name || "Unknown" : rA;
          Qg && yA(Eg, yg), dg && bA(Eg, yg);
        }
        return kA(rA, Qg, dg, ag, _A, pA.current, Eg);
      }
    }
    var uA = CA.ReactCurrentOwner, TA = CA.ReactDebugCurrentFrame;
    function Bg(rA) {
      if (rA) {
        var SA = rA._owner, qA = ig(rA.type, rA._source, SA ? SA.type : null);
        TA.setExtraStackFrame(qA);
      } else
        TA.setExtraStackFrame(null);
    }
    var ng;
    ng = !1;
    function sg(rA) {
      return typeof rA == "object" && rA !== null && rA.$$typeof === E;
    }
    function Rg() {
      {
        if (uA.current) {
          var rA = nA(uA.current.type);
          if (rA)
            return `

Check the render method of \`` + rA + "`.";
        }
        return "";
      }
    }
    function mg(rA) {
      return "";
    }
    var Yg = {};
    function gI(rA) {
      {
        var SA = Rg();
        if (!SA) {
          var qA = typeof rA == "string" ? rA : rA.displayName || rA.name;
          qA && (SA = `

Check the top-level render call using <` + qA + ">.");
        }
        return SA;
      }
    }
    function Jg(rA, SA) {
      {
        if (!rA._store || rA._store.validated || rA.key != null)
          return;
        rA._store.validated = !0;
        var qA = gI(SA);
        if (Yg[qA])
          return;
        Yg[qA] = !0;
        var _A = "";
        rA && rA._owner && rA._owner !== uA.current && (_A = " It was passed a child from " + nA(rA._owner.type) + "."), Bg(rA), IA('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', qA, _A), Bg(null);
      }
    }
    function II(rA, SA) {
      {
        if (typeof rA != "object")
          return;
        if (rg(rA))
          for (var qA = 0; qA < rA.length; qA++) {
            var _A = rA[qA];
            sg(_A) && Jg(_A, SA);
          }
        else if (sg(rA))
          rA._store && (rA._store.validated = !0);
        else if (rA) {
          var ag = gA(rA);
          if (typeof ag == "function" && ag !== rA.entries)
            for (var lg = ag.call(rA), Eg; !(Eg = lg.next()).done; )
              sg(Eg.value) && Jg(Eg.value, SA);
        }
      }
    }
    function CI(rA) {
      {
        var SA = rA.type;
        if (SA == null || typeof SA == "string")
          return;
        var qA;
        if (typeof SA == "function")
          qA = SA.propTypes;
        else if (typeof SA == "object" && (SA.$$typeof === h || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        SA.$$typeof === p))
          qA = SA.propTypes;
        else
          return;
        if (qA) {
          var _A = nA(SA);
          eg(qA, rA.props, "prop", _A, rA);
        } else if (SA.PropTypes !== void 0 && !ng) {
          ng = !0;
          var ag = nA(SA);
          IA("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", ag || "Unknown");
        }
        typeof SA.getDefaultProps == "function" && !SA.getDefaultProps.isReactClassApproved && IA("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Xg(rA) {
      {
        for (var SA = Object.keys(rA.props), qA = 0; qA < SA.length; qA++) {
          var _A = SA[qA];
          if (_A !== "children" && _A !== "key") {
            Bg(rA), IA("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", _A), Bg(null);
            break;
          }
        }
        rA.ref !== null && (Bg(rA), IA("Invalid attribute `ref` supplied to `React.Fragment`."), Bg(null));
      }
    }
    var BI = {};
    function qg(rA, SA, qA, _A, ag, lg) {
      {
        var Eg = eA(rA);
        if (!Eg) {
          var Qg = "";
          (rA === void 0 || typeof rA == "object" && rA !== null && Object.keys(rA).length === 0) && (Qg += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var dg = mg();
          dg ? Qg += dg : Qg += Rg();
          var wg;
          rA === null ? wg = "null" : rg(rA) ? wg = "array" : rA !== void 0 && rA.$$typeof === E ? (wg = "<" + (nA(rA.type) || "Unknown") + " />", Qg = " Did you accidentally export a JSX literal instead of a component?") : wg = typeof rA, IA("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", wg, Qg);
        }
        var yg = JA(rA, SA, qA, ag, lg);
        if (yg == null)
          return yg;
        if (Eg) {
          var kg = SA.children;
          if (kg !== void 0)
            if (_A)
              if (rg(kg)) {
                for (var Lg = 0; Lg < kg.length; Lg++)
                  II(kg[Lg], rA);
                Object.freeze && Object.freeze(kg);
              } else
                IA("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              II(kg, rA);
        }
        if (og.call(SA, "key")) {
          var Sg = nA(rA), Fg = Object.keys(SA).filter(function(sI) {
            return sI !== "key";
          }), EI = Fg.length > 0 ? "{key: someKey, " + Fg.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!BI[Sg + EI]) {
            var DI = Fg.length > 0 ? "{" + Fg.join(": ..., ") + ": ...}" : "{}";
            IA(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, EI, Sg, DI, Sg), BI[Sg + EI] = !0;
          }
        }
        return rA === g ? Xg(yg) : CI(yg), yg;
      }
    }
    function Ig(rA, SA, qA) {
      return qg(rA, SA, qA, !0);
    }
    function tg(rA, SA, qA) {
      return qg(rA, SA, qA, !1);
    }
    var Ng = tg, bg = Ig;
    reactJsxRuntime_development.Fragment = g, reactJsxRuntime_development.jsx = Ng, reactJsxRuntime_development.jsxs = bg;
  })()), reactJsxRuntime_development;
}
var hasRequiredJsxRuntime;
function requireJsxRuntime() {
  return hasRequiredJsxRuntime || (hasRequiredJsxRuntime = 1, process.env.NODE_ENV === "production" ? jsxRuntime.exports = requireReactJsxRuntime_production_min() : jsxRuntime.exports = requireReactJsxRuntime_development()), jsxRuntime.exports;
}
var jsxRuntimeExports = requireJsxRuntime(), loglevel$3 = { exports: {} }, loglevel$2 = loglevel$3.exports, hasRequiredLoglevel$1;
function requireLoglevel$1() {
  return hasRequiredLoglevel$1 || (hasRequiredLoglevel$1 = 1, (function(o) {
    (function(E, A) {
      o.exports ? o.exports = A() : E.log = A();
    })(loglevel$2, function() {
      var E = function() {
      }, A = "undefined", g = typeof window !== A && typeof window.navigator !== A && /Trident\/|MSIE /.test(window.navigator.userAgent), e = [
        "trace",
        "debug",
        "info",
        "warn",
        "error"
      ], t = {}, c = null;
      function n(H, gA) {
        var CA = H[gA];
        if (typeof CA.bind == "function")
          return CA.bind(H);
        try {
          return Function.prototype.bind.call(CA, H);
        } catch {
          return function() {
            return Function.prototype.apply.apply(CA, [H, arguments]);
          };
        }
      }
      function h() {
        console.log && (console.log.apply ? console.log.apply(console, arguments) : Function.prototype.apply.apply(console.log, [console, arguments])), console.trace && console.trace();
      }
      function d(H) {
        return H === "debug" && (H = "log"), typeof console === A ? !1 : H === "trace" && g ? h : console[H] !== void 0 ? n(console, H) : console.log !== void 0 ? n(console, "log") : E;
      }
      function k() {
        for (var H = this.getLevel(), gA = 0; gA < e.length; gA++) {
          var CA = e[gA];
          this[CA] = gA < H ? E : this.methodFactory(CA, H, this.name);
        }
        if (this.log = this.debug, typeof console === A && H < this.levels.SILENT)
          return "No console available for logging";
      }
      function p(H) {
        return function() {
          typeof console !== A && (k.call(this), this[H].apply(this, arguments));
        };
      }
      function M(H, gA, CA) {
        return d(H) || p.apply(this, arguments);
      }
      function S(H, gA) {
        var CA = this, IA, BA, QA, EA = "loglevel";
        typeof H == "string" ? EA += ":" + H : typeof H == "symbol" && (EA = void 0);
        function oA(cA) {
          var DA = (e[cA] || "silent").toUpperCase();
          if (!(typeof window === A || !EA)) {
            try {
              window.localStorage[EA] = DA;
              return;
            } catch {
            }
            try {
              window.document.cookie = encodeURIComponent(EA) + "=" + DA + ";";
            } catch {
            }
          }
        }
        function iA() {
          var cA;
          if (!(typeof window === A || !EA)) {
            try {
              cA = window.localStorage[EA];
            } catch {
            }
            if (typeof cA === A)
              try {
                var DA = window.document.cookie, nA = encodeURIComponent(EA), wA = DA.indexOf(nA + "=");
                wA !== -1 && (cA = /^([^;]+)/.exec(
                  DA.slice(wA + nA.length + 1)
                )[1]);
              } catch {
              }
            return CA.levels[cA] === void 0 && (cA = void 0), cA;
          }
        }
        function aA() {
          if (!(typeof window === A || !EA)) {
            try {
              window.localStorage.removeItem(EA);
            } catch {
            }
            try {
              window.document.cookie = encodeURIComponent(EA) + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC";
            } catch {
            }
          }
        }
        function tA(cA) {
          var DA = cA;
          if (typeof DA == "string" && CA.levels[DA.toUpperCase()] !== void 0 && (DA = CA.levels[DA.toUpperCase()]), typeof DA == "number" && DA >= 0 && DA <= CA.levels.SILENT)
            return DA;
          throw new TypeError("log.setLevel() called with invalid level: " + cA);
        }
        CA.name = H, CA.levels = {
          TRACE: 0,
          DEBUG: 1,
          INFO: 2,
          WARN: 3,
          ERROR: 4,
          SILENT: 5
        }, CA.methodFactory = gA || M, CA.getLevel = function() {
          return QA ?? BA ?? IA;
        }, CA.setLevel = function(cA, DA) {
          return QA = tA(cA), DA !== !1 && oA(QA), k.call(CA);
        }, CA.setDefaultLevel = function(cA) {
          BA = tA(cA), iA() || CA.setLevel(cA, !1);
        }, CA.resetLevel = function() {
          QA = null, aA(), k.call(CA);
        }, CA.enableAll = function(cA) {
          CA.setLevel(CA.levels.TRACE, cA);
        }, CA.disableAll = function(cA) {
          CA.setLevel(CA.levels.SILENT, cA);
        }, CA.rebuild = function() {
          if (c !== CA && (IA = tA(c.getLevel())), k.call(CA), c === CA)
            for (var cA in t)
              t[cA].rebuild();
        }, IA = tA(
          c ? c.getLevel() : "WARN"
        );
        var eA = iA();
        eA != null && (QA = tA(eA)), k.call(CA);
      }
      c = new S(), c.getLogger = function(gA) {
        if (typeof gA != "symbol" && typeof gA != "string" || gA === "")
          throw new TypeError("You must supply a name when creating a logger.");
        var CA = t[gA];
        return CA || (CA = t[gA] = new S(
          gA,
          c.methodFactory
        )), CA;
      };
      var AA = typeof window !== A ? window.log : void 0;
      return c.noConflict = function() {
        return typeof window !== A && window.log === c && (window.log = AA), c;
      }, c.getLoggers = function() {
        return t;
      }, c.default = c, c;
    });
  })(loglevel$3)), loglevel$3.exports;
}
var loglevelExports$1 = requireLoglevel$1();
const log = /* @__PURE__ */ getDefaultExportFromCjs(loglevelExports$1), StliteKernelContext = React__default.createContext(void 0), Provider$2 = StliteKernelContext.Provider;
function StliteKernelProvider(o) {
  const {
    children: E,
    kernel: A
  } = o, g = useMemo$1(() => ({
    kernel: A
  }), [A]);
  return jsxRuntimeExports.jsx(Provider$2, {
    value: g,
    children: E
  });
}
function useStliteKernel() {
  const o = useContext(StliteKernelContext);
  if (o == null)
    throw new Error("useStliteKernel() must be inside <StliteKernelProvider />");
  return o.kernel;
}
function sheetForTag(o) {
  if (o.sheet)
    return o.sheet;
  for (var E = 0; E < document.styleSheets.length; E++)
    if (document.styleSheets[E].ownerNode === o)
      return document.styleSheets[E];
}
function createStyleElement(o) {
  var E = document.createElement("style");
  return E.setAttribute("data-emotion", o.key), o.nonce !== void 0 && E.setAttribute("nonce", o.nonce), E.appendChild(document.createTextNode("")), E.setAttribute("data-s", ""), E;
}
var StyleSheet = /* @__PURE__ */ (function() {
  function o(A) {
    var g = this;
    this._insertTag = function(e) {
      var t;
      g.tags.length === 0 ? g.insertionPoint ? t = g.insertionPoint.nextSibling : g.prepend ? t = g.container.firstChild : t = g.before : t = g.tags[g.tags.length - 1].nextSibling, g.container.insertBefore(e, t), g.tags.push(e);
    }, this.isSpeedy = A.speedy === void 0 ? !0 : A.speedy, this.tags = [], this.ctr = 0, this.nonce = A.nonce, this.key = A.key, this.container = A.container, this.prepend = A.prepend, this.insertionPoint = A.insertionPoint, this.before = null;
  }
  var E = o.prototype;
  return E.hydrate = function(g) {
    g.forEach(this._insertTag);
  }, E.insert = function(g) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(createStyleElement(this));
    var e = this.tags[this.tags.length - 1];
    if (this.isSpeedy) {
      var t = sheetForTag(e);
      try {
        t.insertRule(g, t.cssRules.length);
      } catch {
      }
    } else
      e.appendChild(document.createTextNode(g));
    this.ctr++;
  }, E.flush = function() {
    this.tags.forEach(function(g) {
      var e;
      return (e = g.parentNode) == null ? void 0 : e.removeChild(g);
    }), this.tags = [], this.ctr = 0;
  }, o;
})(), MS = "-ms-", MOZ = "-moz-", WEBKIT = "-webkit-", COMMENT = "comm", RULESET = "rule", DECLARATION = "decl", IMPORT = "@import", KEYFRAMES = "@keyframes", LAYER = "@layer", abs = Math.abs, from = String.fromCharCode, assign$1 = Object.assign;
function hash$1(o, E) {
  return charat(o, 0) ^ 45 ? (((E << 2 ^ charat(o, 0)) << 2 ^ charat(o, 1)) << 2 ^ charat(o, 2)) << 2 ^ charat(o, 3) : 0;
}
function trim(o) {
  return o.trim();
}
function match(o, E) {
  return (o = E.exec(o)) ? o[0] : o;
}
function replace$1(o, E, A) {
  return o.replace(E, A);
}
function indexof(o, E) {
  return o.indexOf(E);
}
function charat(o, E) {
  return o.charCodeAt(E) | 0;
}
function substr(o, E, A) {
  return o.slice(E, A);
}
function strlen(o) {
  return o.length;
}
function sizeof(o) {
  return o.length;
}
function append(o, E) {
  return E.push(o), o;
}
function combine(o, E) {
  return o.map(E).join("");
}
var line = 1, column = 1, length = 0, position$3 = 0, character = 0, characters = "";
function node$1(o, E, A, g, e, t, c) {
  return { value: o, root: E, parent: A, type: g, props: e, children: t, line, column, length: c, return: "" };
}
function copy(o, E) {
  return assign$1(node$1("", null, null, "", null, null, 0), o, { length: -o.length }, E);
}
function char() {
  return character;
}
function prev() {
  return character = position$3 > 0 ? charat(characters, --position$3) : 0, column--, character === 10 && (column = 1, line--), character;
}
function next() {
  return character = position$3 < length ? charat(characters, position$3++) : 0, column++, character === 10 && (column = 1, line++), character;
}
function peek$1() {
  return charat(characters, position$3);
}
function caret() {
  return position$3;
}
function slice(o, E) {
  return substr(characters, o, E);
}
function token(o) {
  switch (o) {
    // \0 \t \n \r \s whitespace token
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    // ! + , / > @ ~ isolate token
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    // ; { } breakpoint token
    case 59:
    case 123:
    case 125:
      return 4;
    // : accompanied token
    case 58:
      return 3;
    // " ' ( [ opening delimit token
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    // ) ] closing delimit token
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function alloc(o) {
  return line = column = 1, length = strlen(characters = o), position$3 = 0, [];
}
function dealloc(o) {
  return characters = "", o;
}
function delimit(o) {
  return trim(slice(position$3 - 1, delimiter(o === 91 ? o + 2 : o === 40 ? o + 1 : o)));
}
function whitespace$1(o) {
  for (; (character = peek$1()) && character < 33; )
    next();
  return token(o) > 2 || token(character) > 3 ? "" : " ";
}
function escaping(o, E) {
  for (; --E && next() && !(character < 48 || character > 102 || character > 57 && character < 65 || character > 70 && character < 97); )
    ;
  return slice(o, caret() + (E < 6 && peek$1() == 32 && next() == 32));
}
function delimiter(o) {
  for (; next(); )
    switch (character) {
      // ] ) " '
      case o:
        return position$3;
      // " '
      case 34:
      case 39:
        o !== 34 && o !== 39 && delimiter(character);
        break;
      // (
      case 40:
        o === 41 && delimiter(o);
        break;
      // \
      case 92:
        next();
        break;
    }
  return position$3;
}
function commenter(o, E) {
  for (; next() && o + character !== 57; )
    if (o + character === 84 && peek$1() === 47)
      break;
  return "/*" + slice(E, position$3 - 1) + "*" + from(o === 47 ? o : next());
}
function identifier(o) {
  for (; !token(peek$1()); )
    next();
  return slice(o, position$3);
}
function compile(o) {
  return dealloc(parse$3("", null, null, null, [""], o = alloc(o), 0, [0], o));
}
function parse$3(o, E, A, g, e, t, c, n, h) {
  for (var d = 0, k = 0, p = c, M = 0, S = 0, AA = 0, H = 1, gA = 1, CA = 1, IA = 0, BA = "", QA = e, EA = t, oA = g, iA = BA; gA; )
    switch (AA = IA, IA = next()) {
      // (
      case 40:
        if (AA != 108 && charat(iA, p - 1) == 58) {
          indexof(iA += replace$1(delimit(IA), "&", "&\f"), "&\f") != -1 && (CA = -1);
          break;
        }
      // " ' [
      case 34:
      case 39:
      case 91:
        iA += delimit(IA);
        break;
      // \t \n \r \s
      case 9:
      case 10:
      case 13:
      case 32:
        iA += whitespace$1(AA);
        break;
      // \
      case 92:
        iA += escaping(caret() - 1, 7);
        continue;
      // /
      case 47:
        switch (peek$1()) {
          case 42:
          case 47:
            append(comment(commenter(next(), caret()), E, A), h);
            break;
          default:
            iA += "/";
        }
        break;
      // {
      case 123 * H:
        n[d++] = strlen(iA) * CA;
      // } ; \0
      case 125 * H:
      case 59:
      case 0:
        switch (IA) {
          // \0 }
          case 0:
          case 125:
            gA = 0;
          // ;
          case 59 + k:
            CA == -1 && (iA = replace$1(iA, /\f/g, "")), S > 0 && strlen(iA) - p && append(S > 32 ? declaration(iA + ";", g, A, p - 1) : declaration(replace$1(iA, " ", "") + ";", g, A, p - 2), h);
            break;
          // @ ;
          case 59:
            iA += ";";
          // { rule/at-rule
          default:
            if (append(oA = ruleset(iA, E, A, d, k, e, n, BA, QA = [], EA = [], p), t), IA === 123)
              if (k === 0)
                parse$3(iA, E, oA, oA, QA, t, p, n, EA);
              else
                switch (M === 99 && charat(iA, 3) === 110 ? 100 : M) {
                  // d l m s
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    parse$3(o, oA, oA, g && append(ruleset(o, oA, oA, 0, 0, e, n, BA, e, QA = [], p), EA), e, EA, p, n, g ? QA : EA);
                    break;
                  default:
                    parse$3(iA, oA, oA, oA, [""], EA, 0, n, EA);
                }
        }
        d = k = S = 0, H = CA = 1, BA = iA = "", p = c;
        break;
      // :
      case 58:
        p = 1 + strlen(iA), S = AA;
      default:
        if (H < 1) {
          if (IA == 123)
            --H;
          else if (IA == 125 && H++ == 0 && prev() == 125)
            continue;
        }
        switch (iA += from(IA), IA * H) {
          // &
          case 38:
            CA = k > 0 ? 1 : (iA += "\f", -1);
            break;
          // ,
          case 44:
            n[d++] = (strlen(iA) - 1) * CA, CA = 1;
            break;
          // @
          case 64:
            peek$1() === 45 && (iA += delimit(next())), M = peek$1(), k = p = strlen(BA = iA += identifier(caret())), IA++;
            break;
          // -
          case 45:
            AA === 45 && strlen(iA) == 2 && (H = 0);
        }
    }
  return t;
}
function ruleset(o, E, A, g, e, t, c, n, h, d, k) {
  for (var p = e - 1, M = e === 0 ? t : [""], S = sizeof(M), AA = 0, H = 0, gA = 0; AA < g; ++AA)
    for (var CA = 0, IA = substr(o, p + 1, p = abs(H = c[AA])), BA = o; CA < S; ++CA)
      (BA = trim(H > 0 ? M[CA] + " " + IA : replace$1(IA, /&\f/g, M[CA]))) && (h[gA++] = BA);
  return node$1(o, E, A, e === 0 ? RULESET : n, h, d, k);
}
function comment(o, E, A) {
  return node$1(o, E, A, COMMENT, from(char()), substr(o, 2, -2), 0);
}
function declaration(o, E, A, g) {
  return node$1(o, E, A, DECLARATION, substr(o, 0, g), substr(o, g + 1, -1), g);
}
function serialize$2(o, E) {
  for (var A = "", g = sizeof(o), e = 0; e < g; e++)
    A += E(o[e], e, o, E) || "";
  return A;
}
function stringify$2(o, E, A, g) {
  switch (o.type) {
    case LAYER:
      if (o.children.length) break;
    case IMPORT:
    case DECLARATION:
      return o.return = o.return || o.value;
    case COMMENT:
      return "";
    case KEYFRAMES:
      return o.return = o.value + "{" + serialize$2(o.children, g) + "}";
    case RULESET:
      o.value = o.props.join(",");
  }
  return strlen(A = serialize$2(o.children, g)) ? o.return = o.value + "{" + A + "}" : "";
}
function middleware(o) {
  var E = sizeof(o);
  return function(A, g, e, t) {
    for (var c = "", n = 0; n < E; n++)
      c += o[n](A, g, e, t) || "";
    return c;
  };
}
function rulesheet(o) {
  return function(E) {
    E.root || (E = E.return) && o(E);
  };
}
var weakMemoize = function(E) {
  var A = /* @__PURE__ */ new WeakMap();
  return function(g) {
    if (A.has(g))
      return A.get(g);
    var e = E(g);
    return A.set(g, e), e;
  };
};
function memoize$1(o) {
  var E = /* @__PURE__ */ Object.create(null);
  return function(A) {
    return E[A] === void 0 && (E[A] = o(A)), E[A];
  };
}
var identifierWithPointTracking = function(E, A, g) {
  for (var e = 0, t = 0; e = t, t = peek$1(), e === 38 && t === 12 && (A[g] = 1), !token(t); )
    next();
  return slice(E, position$3);
}, toRules = function(E, A) {
  var g = -1, e = 44;
  do
    switch (token(e)) {
      case 0:
        e === 38 && peek$1() === 12 && (A[g] = 1), E[g] += identifierWithPointTracking(position$3 - 1, A, g);
        break;
      case 2:
        E[g] += delimit(e);
        break;
      case 4:
        if (e === 44) {
          E[++g] = peek$1() === 58 ? "&\f" : "", A[g] = E[g].length;
          break;
        }
      // fallthrough
      default:
        E[g] += from(e);
    }
  while (e = next());
  return E;
}, getRules = function(E, A) {
  return dealloc(toRules(alloc(E), A));
}, fixedElements = /* @__PURE__ */ new WeakMap(), compat = function(E) {
  if (!(E.type !== "rule" || !E.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  E.length < 1)) {
    for (var A = E.value, g = E.parent, e = E.column === g.column && E.line === g.line; g.type !== "rule"; )
      if (g = g.parent, !g) return;
    if (!(E.props.length === 1 && A.charCodeAt(0) !== 58 && !fixedElements.get(g)) && !e) {
      fixedElements.set(E, !0);
      for (var t = [], c = getRules(A, t), n = g.props, h = 0, d = 0; h < c.length; h++)
        for (var k = 0; k < n.length; k++, d++)
          E.props[d] = t[h] ? c[h].replace(/&\f/g, n[k]) : n[k] + " " + c[h];
    }
  }
}, removeLabel = function(E) {
  if (E.type === "decl") {
    var A = E.value;
    // charcode for l
    A.charCodeAt(0) === 108 && // charcode for b
    A.charCodeAt(2) === 98 && (E.return = "", E.value = "");
  }
};
function prefix$1(o, E) {
  switch (hash$1(o, E)) {
    // color-adjust
    case 5103:
      return WEBKIT + "print-" + o + o;
    // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return WEBKIT + o + o;
    // appearance, user-select, transform, hyphens, text-size-adjust
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return WEBKIT + o + MOZ + o + MS + o + o;
    // flex, flex-direction
    case 6828:
    case 4268:
      return WEBKIT + o + MS + o + o;
    // order
    case 6165:
      return WEBKIT + o + MS + "flex-" + o + o;
    // align-items
    case 5187:
      return WEBKIT + o + replace$1(o, /(\w+).+(:[^]+)/, WEBKIT + "box-$1$2" + MS + "flex-$1$2") + o;
    // align-self
    case 5443:
      return WEBKIT + o + MS + "flex-item-" + replace$1(o, /flex-|-self/, "") + o;
    // align-content
    case 4675:
      return WEBKIT + o + MS + "flex-line-pack" + replace$1(o, /align-content|flex-|-self/, "") + o;
    // flex-shrink
    case 5548:
      return WEBKIT + o + MS + replace$1(o, "shrink", "negative") + o;
    // flex-basis
    case 5292:
      return WEBKIT + o + MS + replace$1(o, "basis", "preferred-size") + o;
    // flex-grow
    case 6060:
      return WEBKIT + "box-" + replace$1(o, "-grow", "") + WEBKIT + o + MS + replace$1(o, "grow", "positive") + o;
    // transition
    case 4554:
      return WEBKIT + replace$1(o, /([^-])(transform)/g, "$1" + WEBKIT + "$2") + o;
    // cursor
    case 6187:
      return replace$1(replace$1(replace$1(o, /(zoom-|grab)/, WEBKIT + "$1"), /(image-set)/, WEBKIT + "$1"), o, "") + o;
    // background, background-image
    case 5495:
    case 3959:
      return replace$1(o, /(image-set\([^]*)/, WEBKIT + "$1$`$1");
    // justify-content
    case 4968:
      return replace$1(replace$1(o, /(.+:)(flex-)?(.*)/, WEBKIT + "box-pack:$3" + MS + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + WEBKIT + o + o;
    // (margin|padding)-inline-(start|end)
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return replace$1(o, /(.+)-inline(.+)/, WEBKIT + "$1$2") + o;
    // (min|max)?(width|height|inline-size|block-size)
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (strlen(o) - 1 - E > 6) switch (charat(o, E + 1)) {
        // (m)ax-content, (m)in-content
        case 109:
          if (charat(o, E + 4) !== 45) break;
        // (f)ill-available, (f)it-content
        case 102:
          return replace$1(o, /(.+:)(.+)-([^]+)/, "$1" + WEBKIT + "$2-$3$1" + MOZ + (charat(o, E + 3) == 108 ? "$3" : "$2-$3")) + o;
        // (s)tretch
        case 115:
          return ~indexof(o, "stretch") ? prefix$1(replace$1(o, "stretch", "fill-available"), E) + o : o;
      }
      break;
    // position: sticky
    case 4949:
      if (charat(o, E + 1) !== 115) break;
    // display: (flex|inline-flex)
    case 6444:
      switch (charat(o, strlen(o) - 3 - (~indexof(o, "!important") && 10))) {
        // stic(k)y
        case 107:
          return replace$1(o, ":", ":" + WEBKIT) + o;
        // (inline-)?fl(e)x
        case 101:
          return replace$1(o, /(.+:)([^;!]+)(;|!.+)?/, "$1" + WEBKIT + (charat(o, 14) === 45 ? "inline-" : "") + "box$3$1" + WEBKIT + "$2$3$1" + MS + "$2box$3") + o;
      }
      break;
    // writing-mode
    case 5936:
      switch (charat(o, E + 11)) {
        // vertical-l(r)
        case 114:
          return WEBKIT + o + MS + replace$1(o, /[svh]\w+-[tblr]{2}/, "tb") + o;
        // vertical-r(l)
        case 108:
          return WEBKIT + o + MS + replace$1(o, /[svh]\w+-[tblr]{2}/, "tb-rl") + o;
        // horizontal(-)tb
        case 45:
          return WEBKIT + o + MS + replace$1(o, /[svh]\w+-[tblr]{2}/, "lr") + o;
      }
      return WEBKIT + o + MS + o + o;
  }
  return o;
}
var prefixer = function(E, A, g, e) {
  if (E.length > -1 && !E.return) switch (E.type) {
    case DECLARATION:
      E.return = prefix$1(E.value, E.length);
      break;
    case KEYFRAMES:
      return serialize$2([copy(E, {
        value: replace$1(E.value, "@", "@" + WEBKIT)
      })], e);
    case RULESET:
      if (E.length) return combine(E.props, function(t) {
        switch (match(t, /(::plac\w+|:read-\w+)/)) {
          // :read-(only|write)
          case ":read-only":
          case ":read-write":
            return serialize$2([copy(E, {
              props: [replace$1(t, /:(read-\w+)/, ":" + MOZ + "$1")]
            })], e);
          // :placeholder
          case "::placeholder":
            return serialize$2([copy(E, {
              props: [replace$1(t, /:(plac\w+)/, ":" + WEBKIT + "input-$1")]
            }), copy(E, {
              props: [replace$1(t, /:(plac\w+)/, ":" + MOZ + "$1")]
            }), copy(E, {
              props: [replace$1(t, /:(plac\w+)/, MS + "input-$1")]
            })], e);
        }
        return "";
      });
  }
}, defaultStylisPlugins = [prefixer], createCache = function(E) {
  var A = E.key;
  if (A === "css") {
    var g = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(g, function(H) {
      var gA = H.getAttribute("data-emotion");
      gA.indexOf(" ") !== -1 && (document.head.appendChild(H), H.setAttribute("data-s", ""));
    });
  }
  var e = E.stylisPlugins || defaultStylisPlugins, t = {}, c, n = [];
  c = E.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + A + ' "]'),
    function(H) {
      for (var gA = H.getAttribute("data-emotion").split(" "), CA = 1; CA < gA.length; CA++)
        t[gA[CA]] = !0;
      n.push(H);
    }
  );
  var h, d = [compat, removeLabel];
  {
    var k, p = [stringify$2, rulesheet(function(H) {
      k.insert(H);
    })], M = middleware(d.concat(e, p)), S = function(gA) {
      return serialize$2(compile(gA), M);
    };
    h = function(gA, CA, IA, BA) {
      k = IA, S(gA ? gA + "{" + CA.styles + "}" : CA.styles), BA && (AA.inserted[CA.name] = !0);
    };
  }
  var AA = {
    key: A,
    sheet: new StyleSheet({
      key: A,
      container: c,
      nonce: E.nonce,
      speedy: E.speedy,
      prepend: E.prepend,
      insertionPoint: E.insertionPoint
    }),
    nonce: E.nonce,
    inserted: t,
    registered: {},
    insert: h
  };
  return AA.sheet.hydrate(n), AA;
};
function _extends$C() {
  return _extends$C = Object.assign ? Object.assign.bind() : function(o) {
    for (var E = 1; E < arguments.length; E++) {
      var A = arguments[E];
      for (var g in A) ({}).hasOwnProperty.call(A, g) && (o[g] = A[g]);
    }
    return o;
  }, _extends$C.apply(null, arguments);
}
var reactIs$1 = { exports: {} }, reactIs_production_min$1 = {};
var hasRequiredReactIs_production_min$1;
function requireReactIs_production_min$1() {
  if (hasRequiredReactIs_production_min$1) return reactIs_production_min$1;
  hasRequiredReactIs_production_min$1 = 1;
  var o = typeof Symbol == "function" && Symbol.for, E = o ? Symbol.for("react.element") : 60103, A = o ? Symbol.for("react.portal") : 60106, g = o ? Symbol.for("react.fragment") : 60107, e = o ? Symbol.for("react.strict_mode") : 60108, t = o ? Symbol.for("react.profiler") : 60114, c = o ? Symbol.for("react.provider") : 60109, n = o ? Symbol.for("react.context") : 60110, h = o ? Symbol.for("react.async_mode") : 60111, d = o ? Symbol.for("react.concurrent_mode") : 60111, k = o ? Symbol.for("react.forward_ref") : 60112, p = o ? Symbol.for("react.suspense") : 60113, M = o ? Symbol.for("react.suspense_list") : 60120, S = o ? Symbol.for("react.memo") : 60115, AA = o ? Symbol.for("react.lazy") : 60116, H = o ? Symbol.for("react.block") : 60121, gA = o ? Symbol.for("react.fundamental") : 60117, CA = o ? Symbol.for("react.responder") : 60118, IA = o ? Symbol.for("react.scope") : 60119;
  function BA(EA) {
    if (typeof EA == "object" && EA !== null) {
      var oA = EA.$$typeof;
      switch (oA) {
        case E:
          switch (EA = EA.type, EA) {
            case h:
            case d:
            case g:
            case t:
            case e:
            case p:
              return EA;
            default:
              switch (EA = EA && EA.$$typeof, EA) {
                case n:
                case k:
                case AA:
                case S:
                case c:
                  return EA;
                default:
                  return oA;
              }
          }
        case A:
          return oA;
      }
    }
  }
  function QA(EA) {
    return BA(EA) === d;
  }
  return reactIs_production_min$1.AsyncMode = h, reactIs_production_min$1.ConcurrentMode = d, reactIs_production_min$1.ContextConsumer = n, reactIs_production_min$1.ContextProvider = c, reactIs_production_min$1.Element = E, reactIs_production_min$1.ForwardRef = k, reactIs_production_min$1.Fragment = g, reactIs_production_min$1.Lazy = AA, reactIs_production_min$1.Memo = S, reactIs_production_min$1.Portal = A, reactIs_production_min$1.Profiler = t, reactIs_production_min$1.StrictMode = e, reactIs_production_min$1.Suspense = p, reactIs_production_min$1.isAsyncMode = function(EA) {
    return QA(EA) || BA(EA) === h;
  }, reactIs_production_min$1.isConcurrentMode = QA, reactIs_production_min$1.isContextConsumer = function(EA) {
    return BA(EA) === n;
  }, reactIs_production_min$1.isContextProvider = function(EA) {
    return BA(EA) === c;
  }, reactIs_production_min$1.isElement = function(EA) {
    return typeof EA == "object" && EA !== null && EA.$$typeof === E;
  }, reactIs_production_min$1.isForwardRef = function(EA) {
    return BA(EA) === k;
  }, reactIs_production_min$1.isFragment = function(EA) {
    return BA(EA) === g;
  }, reactIs_production_min$1.isLazy = function(EA) {
    return BA(EA) === AA;
  }, reactIs_production_min$1.isMemo = function(EA) {
    return BA(EA) === S;
  }, reactIs_production_min$1.isPortal = function(EA) {
    return BA(EA) === A;
  }, reactIs_production_min$1.isProfiler = function(EA) {
    return BA(EA) === t;
  }, reactIs_production_min$1.isStrictMode = function(EA) {
    return BA(EA) === e;
  }, reactIs_production_min$1.isSuspense = function(EA) {
    return BA(EA) === p;
  }, reactIs_production_min$1.isValidElementType = function(EA) {
    return typeof EA == "string" || typeof EA == "function" || EA === g || EA === d || EA === t || EA === e || EA === p || EA === M || typeof EA == "object" && EA !== null && (EA.$$typeof === AA || EA.$$typeof === S || EA.$$typeof === c || EA.$$typeof === n || EA.$$typeof === k || EA.$$typeof === gA || EA.$$typeof === CA || EA.$$typeof === IA || EA.$$typeof === H);
  }, reactIs_production_min$1.typeOf = BA, reactIs_production_min$1;
}
var reactIs_development$1 = {};
var hasRequiredReactIs_development$1;
function requireReactIs_development$1() {
  return hasRequiredReactIs_development$1 || (hasRequiredReactIs_development$1 = 1, process.env.NODE_ENV !== "production" && (function() {
    var o = typeof Symbol == "function" && Symbol.for, E = o ? Symbol.for("react.element") : 60103, A = o ? Symbol.for("react.portal") : 60106, g = o ? Symbol.for("react.fragment") : 60107, e = o ? Symbol.for("react.strict_mode") : 60108, t = o ? Symbol.for("react.profiler") : 60114, c = o ? Symbol.for("react.provider") : 60109, n = o ? Symbol.for("react.context") : 60110, h = o ? Symbol.for("react.async_mode") : 60111, d = o ? Symbol.for("react.concurrent_mode") : 60111, k = o ? Symbol.for("react.forward_ref") : 60112, p = o ? Symbol.for("react.suspense") : 60113, M = o ? Symbol.for("react.suspense_list") : 60120, S = o ? Symbol.for("react.memo") : 60115, AA = o ? Symbol.for("react.lazy") : 60116, H = o ? Symbol.for("react.block") : 60121, gA = o ? Symbol.for("react.fundamental") : 60117, CA = o ? Symbol.for("react.responder") : 60118, IA = o ? Symbol.for("react.scope") : 60119;
    function BA(ZA) {
      return typeof ZA == "string" || typeof ZA == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      ZA === g || ZA === d || ZA === t || ZA === e || ZA === p || ZA === M || typeof ZA == "object" && ZA !== null && (ZA.$$typeof === AA || ZA.$$typeof === S || ZA.$$typeof === c || ZA.$$typeof === n || ZA.$$typeof === k || ZA.$$typeof === gA || ZA.$$typeof === CA || ZA.$$typeof === IA || ZA.$$typeof === H);
    }
    function QA(ZA) {
      if (typeof ZA == "object" && ZA !== null) {
        var Ag = ZA.$$typeof;
        switch (Ag) {
          case E:
            var UA = ZA.type;
            switch (UA) {
              case h:
              case d:
              case g:
              case t:
              case e:
              case p:
                return UA;
              default:
                var ig = UA && UA.$$typeof;
                switch (ig) {
                  case n:
                  case k:
                  case AA:
                  case S:
                  case c:
                    return ig;
                  default:
                    return Ag;
                }
            }
          case A:
            return Ag;
        }
      }
    }
    var EA = h, oA = d, iA = n, aA = c, tA = E, eA = k, cA = g, DA = AA, nA = S, wA = A, lA = t, NA = e, RA = p, KA = !1;
    function vA(ZA) {
      return KA || (KA = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), GA(ZA) || QA(ZA) === h;
    }
    function GA(ZA) {
      return QA(ZA) === d;
    }
    function FA(ZA) {
      return QA(ZA) === n;
    }
    function HA(ZA) {
      return QA(ZA) === c;
    }
    function sA(ZA) {
      return typeof ZA == "object" && ZA !== null && ZA.$$typeof === E;
    }
    function mA(ZA) {
      return QA(ZA) === k;
    }
    function xA(ZA) {
      return QA(ZA) === g;
    }
    function hA(ZA) {
      return QA(ZA) === AA;
    }
    function MA(ZA) {
      return QA(ZA) === S;
    }
    function YA(ZA) {
      return QA(ZA) === A;
    }
    function LA(ZA) {
      return QA(ZA) === t;
    }
    function WA(ZA) {
      return QA(ZA) === e;
    }
    function zA(ZA) {
      return QA(ZA) === p;
    }
    reactIs_development$1.AsyncMode = EA, reactIs_development$1.ConcurrentMode = oA, reactIs_development$1.ContextConsumer = iA, reactIs_development$1.ContextProvider = aA, reactIs_development$1.Element = tA, reactIs_development$1.ForwardRef = eA, reactIs_development$1.Fragment = cA, reactIs_development$1.Lazy = DA, reactIs_development$1.Memo = nA, reactIs_development$1.Portal = wA, reactIs_development$1.Profiler = lA, reactIs_development$1.StrictMode = NA, reactIs_development$1.Suspense = RA, reactIs_development$1.isAsyncMode = vA, reactIs_development$1.isConcurrentMode = GA, reactIs_development$1.isContextConsumer = FA, reactIs_development$1.isContextProvider = HA, reactIs_development$1.isElement = sA, reactIs_development$1.isForwardRef = mA, reactIs_development$1.isFragment = xA, reactIs_development$1.isLazy = hA, reactIs_development$1.isMemo = MA, reactIs_development$1.isPortal = YA, reactIs_development$1.isProfiler = LA, reactIs_development$1.isStrictMode = WA, reactIs_development$1.isSuspense = zA, reactIs_development$1.isValidElementType = BA, reactIs_development$1.typeOf = QA;
  })()), reactIs_development$1;
}
var hasRequiredReactIs$1;
function requireReactIs$1() {
  return hasRequiredReactIs$1 || (hasRequiredReactIs$1 = 1, process.env.NODE_ENV === "production" ? reactIs$1.exports = requireReactIs_production_min$1() : reactIs$1.exports = requireReactIs_development$1()), reactIs$1.exports;
}
var hoistNonReactStatics_cjs, hasRequiredHoistNonReactStatics_cjs;
function requireHoistNonReactStatics_cjs() {
  if (hasRequiredHoistNonReactStatics_cjs) return hoistNonReactStatics_cjs;
  hasRequiredHoistNonReactStatics_cjs = 1;
  var o = requireReactIs$1(), E = {
    childContextTypes: !0,
    contextType: !0,
    contextTypes: !0,
    defaultProps: !0,
    displayName: !0,
    getDefaultProps: !0,
    getDerivedStateFromError: !0,
    getDerivedStateFromProps: !0,
    mixins: !0,
    propTypes: !0,
    type: !0
  }, A = {
    name: !0,
    length: !0,
    prototype: !0,
    caller: !0,
    callee: !0,
    arguments: !0,
    arity: !0
  }, g = {
    $$typeof: !0,
    render: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0
  }, e = {
    $$typeof: !0,
    compare: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0,
    type: !0
  }, t = {};
  t[o.ForwardRef] = g, t[o.Memo] = e;
  function c(AA) {
    return o.isMemo(AA) ? e : t[AA.$$typeof] || E;
  }
  var n = Object.defineProperty, h = Object.getOwnPropertyNames, d = Object.getOwnPropertySymbols, k = Object.getOwnPropertyDescriptor, p = Object.getPrototypeOf, M = Object.prototype;
  function S(AA, H, gA) {
    if (typeof H != "string") {
      if (M) {
        var CA = p(H);
        CA && CA !== M && S(AA, CA, gA);
      }
      var IA = h(H);
      d && (IA = IA.concat(d(H)));
      for (var BA = c(AA), QA = c(H), EA = 0; EA < IA.length; ++EA) {
        var oA = IA[EA];
        if (!A[oA] && !(gA && gA[oA]) && !(QA && QA[oA]) && !(BA && BA[oA])) {
          var iA = k(H, oA);
          try {
            n(AA, oA, iA);
          } catch {
          }
        }
      }
    }
    return AA;
  }
  return hoistNonReactStatics_cjs = S, hoistNonReactStatics_cjs;
}
var hoistNonReactStatics_cjsExports = requireHoistNonReactStatics_cjs();
const hoistNonReactStatics = /* @__PURE__ */ getDefaultExportFromCjs(hoistNonReactStatics_cjsExports);
var isBrowser$2 = !0;
function getRegisteredStyles(o, E, A) {
  var g = "";
  return A.split(" ").forEach(function(e) {
    o[e] !== void 0 ? E.push(o[e] + ";") : e && (g += e + " ");
  }), g;
}
var registerStyles = function(E, A, g) {
  var e = E.key + "-" + A.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (g === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  isBrowser$2 === !1) && E.registered[e] === void 0 && (E.registered[e] = A.styles);
}, insertStyles = function(E, A, g) {
  registerStyles(E, A, g);
  var e = E.key + "-" + A.name;
  if (E.inserted[A.name] === void 0) {
    var t = A;
    do
      E.insert(A === t ? "." + e : "", t, E.sheet, !0), t = t.next;
    while (t !== void 0);
  }
};
function murmur2(o) {
  for (var E = 0, A, g = 0, e = o.length; e >= 4; ++g, e -= 4)
    A = o.charCodeAt(g) & 255 | (o.charCodeAt(++g) & 255) << 8 | (o.charCodeAt(++g) & 255) << 16 | (o.charCodeAt(++g) & 255) << 24, A = /* Math.imul(k, m): */
    (A & 65535) * 1540483477 + ((A >>> 16) * 59797 << 16), A ^= /* k >>> r: */
    A >>> 24, E = /* Math.imul(k, m): */
    (A & 65535) * 1540483477 + ((A >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (E & 65535) * 1540483477 + ((E >>> 16) * 59797 << 16);
  switch (e) {
    case 3:
      E ^= (o.charCodeAt(g + 2) & 255) << 16;
    case 2:
      E ^= (o.charCodeAt(g + 1) & 255) << 8;
    case 1:
      E ^= o.charCodeAt(g) & 255, E = /* Math.imul(h, m): */
      (E & 65535) * 1540483477 + ((E >>> 16) * 59797 << 16);
  }
  return E ^= E >>> 13, E = /* Math.imul(h, m): */
  (E & 65535) * 1540483477 + ((E >>> 16) * 59797 << 16), ((E ^ E >>> 15) >>> 0).toString(36);
}
var unitlessKeys = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  scale: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, hyphenateRegex = /[A-Z]|^ms/g, animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g, isCustomProperty = function(E) {
  return E.charCodeAt(1) === 45;
}, isProcessableValue = function(E) {
  return E != null && typeof E != "boolean";
}, processStyleName = /* @__PURE__ */ memoize$1(function(o) {
  return isCustomProperty(o) ? o : o.replace(hyphenateRegex, "-$&").toLowerCase();
}), processStyleValue = function(E, A) {
  switch (E) {
    case "animation":
    case "animationName":
      if (typeof A == "string")
        return A.replace(animationRegex, function(g, e, t) {
          return cursor$1 = {
            name: e,
            styles: t,
            next: cursor$1
          }, e;
        });
  }
  return unitlessKeys[E] !== 1 && !isCustomProperty(E) && typeof A == "number" && A !== 0 ? A + "px" : A;
};
function handleInterpolation(o, E, A) {
  if (A == null)
    return "";
  var g = A;
  if (g.__emotion_styles !== void 0)
    return g;
  switch (typeof A) {
    case "boolean":
      return "";
    case "object": {
      var e = A;
      if (e.anim === 1)
        return cursor$1 = {
          name: e.name,
          styles: e.styles,
          next: cursor$1
        }, e.name;
      var t = A;
      if (t.styles !== void 0) {
        var c = t.next;
        if (c !== void 0)
          for (; c !== void 0; )
            cursor$1 = {
              name: c.name,
              styles: c.styles,
              next: cursor$1
            }, c = c.next;
        var n = t.styles + ";";
        return n;
      }
      return createStringFromObject(o, E, A);
    }
    case "function": {
      if (o !== void 0) {
        var h = cursor$1, d = A(o);
        return cursor$1 = h, handleInterpolation(o, E, d);
      }
      break;
    }
  }
  var k = A;
  if (E == null)
    return k;
  var p = E[k];
  return p !== void 0 ? p : k;
}
function createStringFromObject(o, E, A) {
  var g = "";
  if (Array.isArray(A))
    for (var e = 0; e < A.length; e++)
      g += handleInterpolation(o, E, A[e]) + ";";
  else
    for (var t in A) {
      var c = A[t];
      if (typeof c != "object") {
        var n = c;
        E != null && E[n] !== void 0 ? g += t + "{" + E[n] + "}" : isProcessableValue(n) && (g += processStyleName(t) + ":" + processStyleValue(t, n) + ";");
      } else if (Array.isArray(c) && typeof c[0] == "string" && (E == null || E[c[0]] === void 0))
        for (var h = 0; h < c.length; h++)
          isProcessableValue(c[h]) && (g += processStyleName(t) + ":" + processStyleValue(t, c[h]) + ";");
      else {
        var d = handleInterpolation(o, E, c);
        switch (t) {
          case "animation":
          case "animationName": {
            g += processStyleName(t) + ":" + d + ";";
            break;
          }
          default:
            g += t + "{" + d + "}";
        }
      }
    }
  return g;
}
var labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g, cursor$1;
function serializeStyles(o, E, A) {
  if (o.length === 1 && typeof o[0] == "object" && o[0] !== null && o[0].styles !== void 0)
    return o[0];
  var g = !0, e = "";
  cursor$1 = void 0;
  var t = o[0];
  if (t == null || t.raw === void 0)
    g = !1, e += handleInterpolation(A, E, t);
  else {
    var c = t;
    e += c[0];
  }
  for (var n = 1; n < o.length; n++)
    if (e += handleInterpolation(A, E, o[n]), g) {
      var h = t;
      e += h[n];
    }
  labelPattern.lastIndex = 0;
  for (var d = "", k; (k = labelPattern.exec(e)) !== null; )
    d += "-" + k[1];
  var p = murmur2(e) + d;
  return {
    name: p,
    styles: e,
    next: cursor$1
  };
}
var syncFallback = function(E) {
  return E();
}, useInsertionEffect = React.useInsertionEffect ? React.useInsertionEffect : !1, useInsertionEffectAlwaysWithSyncFallback = useInsertionEffect || syncFallback, useInsertionEffectWithLayoutFallback = useInsertionEffect || React.useLayoutEffect, EmotionCacheContext = /* @__PURE__ */ React.createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement < "u" ? /* @__PURE__ */ createCache({
    key: "css"
  }) : null
), CacheProvider = EmotionCacheContext.Provider, withEmotionCache = function(E) {
  return /* @__PURE__ */ forwardRef(function(A, g) {
    var e = useContext(EmotionCacheContext);
    return E(A, e, g);
  });
}, ThemeContext$2 = /* @__PURE__ */ React.createContext({}), useTheme = function() {
  return React.useContext(ThemeContext$2);
}, getTheme = function(E, A) {
  if (typeof A == "function") {
    var g = A(E);
    return g;
  }
  return _extends$C({}, E, A);
}, createCacheWithTheme = /* @__PURE__ */ weakMemoize(function(o) {
  return weakMemoize(function(E) {
    return getTheme(o, E);
  });
}), ThemeProvider$2 = function(E) {
  var A = React.useContext(ThemeContext$2);
  return E.theme !== A && (A = createCacheWithTheme(A)(E.theme)), /* @__PURE__ */ React.createElement(ThemeContext$2.Provider, {
    value: A
  }, E.children);
}, hasOwn = {}.hasOwnProperty, typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", createEmotionProps = function(E, A) {
  var g = {};
  for (var e in A)
    hasOwn.call(A, e) && (g[e] = A[e]);
  return g[typePropName] = E, g;
}, Insertion$2 = function(E) {
  var A = E.cache, g = E.serialized, e = E.isStringTag;
  return registerStyles(A, g, e), useInsertionEffectAlwaysWithSyncFallback(function() {
    return insertStyles(A, g, e);
  }), null;
}, Emotion = /* @__PURE__ */ withEmotionCache(function(o, E, A) {
  var g = o.css;
  typeof g == "string" && E.registered[g] !== void 0 && (g = E.registered[g]);
  var e = o[typePropName], t = [g], c = "";
  typeof o.className == "string" ? c = getRegisteredStyles(E.registered, t, o.className) : o.className != null && (c = o.className + " ");
  var n = serializeStyles(t, void 0, React.useContext(ThemeContext$2));
  c += E.key + "-" + n.name;
  var h = {};
  for (var d in o)
    hasOwn.call(o, d) && d !== "css" && d !== typePropName && (h[d] = o[d]);
  return h.className = c, A && (h.ref = A), /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Insertion$2, {
    cache: E,
    serialized: n,
    isStringTag: typeof e == "string"
  }), /* @__PURE__ */ React.createElement(e, h));
}), Emotion$1 = Emotion, jsx = function(E, A) {
  var g = arguments;
  if (A == null || !hasOwn.call(A, "css"))
    return React.createElement.apply(void 0, g);
  var e = g.length, t = new Array(e);
  t[0] = Emotion$1, t[1] = createEmotionProps(E, A);
  for (var c = 2; c < e; c++)
    t[c] = g[c];
  return React.createElement.apply(null, t);
};
(function(o) {
  var E;
  E || (E = o.JSX || (o.JSX = {}));
})(jsx || (jsx = {}));
var Global = /* @__PURE__ */ withEmotionCache(function(o, E) {
  var A = o.styles, g = serializeStyles([A], void 0, React.useContext(ThemeContext$2)), e = React.useRef();
  return useInsertionEffectWithLayoutFallback(function() {
    var t = E.key + "-global", c = new E.sheet.constructor({
      key: t,
      nonce: E.sheet.nonce,
      container: E.sheet.container,
      speedy: E.sheet.isSpeedy
    }), n = !1, h = document.querySelector('style[data-emotion="' + t + " " + g.name + '"]');
    return E.sheet.tags.length && (c.before = E.sheet.tags[0]), h !== null && (n = !0, h.setAttribute("data-emotion", t), c.hydrate([h])), e.current = [c, n], function() {
      c.flush();
    };
  }, [E]), useInsertionEffectWithLayoutFallback(function() {
    var t = e.current, c = t[0], n = t[1];
    if (n) {
      t[1] = !1;
      return;
    }
    if (g.next !== void 0 && insertStyles(E, g.next, !0), c.tags.length) {
      var h = c.tags[c.tags.length - 1].nextElementSibling;
      c.before = h, c.flush();
    }
    E.insert("", g, c, !1);
  }, [E, g.name]), null;
});
function css() {
  for (var o = arguments.length, E = new Array(o), A = 0; A < o; A++)
    E[A] = arguments[A];
  return serializeStyles(E);
}
function keyframes() {
  var o = css.apply(void 0, arguments), E = "animation-" + o.name;
  return {
    name: E,
    styles: "@keyframes " + E + "{" + o.styles + "}",
    anim: 1,
    toString: function() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
}
var classnames$1 = function o(E) {
  for (var A = E.length, g = 0, e = ""; g < A; g++) {
    var t = E[g];
    if (t != null) {
      var c = void 0;
      switch (typeof t) {
        case "boolean":
          break;
        case "object": {
          if (Array.isArray(t))
            c = o(t);
          else {
            c = "";
            for (var n in t)
              t[n] && n && (c && (c += " "), c += n);
          }
          break;
        }
        default:
          c = t;
      }
      c && (e && (e += " "), e += c);
    }
  }
  return e;
};
function merge$2(o, E, A) {
  var g = [], e = getRegisteredStyles(o, g, A);
  return g.length < 2 ? A : e + E(g);
}
var Insertion$1 = function(E) {
  var A = E.cache, g = E.serializedArr;
  return useInsertionEffectAlwaysWithSyncFallback(function() {
    for (var e = 0; e < g.length; e++)
      insertStyles(A, g[e], !1);
  }), null;
}, ClassNames = /* @__PURE__ */ withEmotionCache(function(o, E) {
  var A = [], g = function() {
    for (var h = arguments.length, d = new Array(h), k = 0; k < h; k++)
      d[k] = arguments[k];
    var p = serializeStyles(d, E.registered);
    return A.push(p), registerStyles(E, p, !1), E.key + "-" + p.name;
  }, e = function() {
    for (var h = arguments.length, d = new Array(h), k = 0; k < h; k++)
      d[k] = arguments[k];
    return merge$2(E.registered, g, classnames$1(d));
  }, t = {
    css: g,
    cx: e,
    theme: React.useContext(ThemeContext$2)
  }, c = o.children(t);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Insertion$1, {
    cache: E,
    serializedArr: A
  }), c);
});
const FontFaceDeclaration = ({
  fontFaces: o
}) => {
  const E = o.map((A) => {
    const {
      family: g,
      weight: e,
      weightRange: t,
      url: c,
      style: n,
      unicodeRange: h
    } = A, d = t || e;
    return `
      @font-face {
        font-family: ${g};
        src: url(${c}) format("woff2");
        font-display: swap;
        ${n ? `font-style: ${n};` : ""}
        ${d ? `font-weight: ${d};` : ""}
        ${h ? `unicode-range: ${h};` : ""}
      }
    `;
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Global, { styles: /* @__PURE__ */ css(E, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:FontFaceDeclaration;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */") });
};
var reactFastCompare, hasRequiredReactFastCompare;
function requireReactFastCompare() {
  if (hasRequiredReactFastCompare) return reactFastCompare;
  hasRequiredReactFastCompare = 1;
  var o = typeof Element < "u", E = typeof Map == "function", A = typeof Set == "function", g = typeof ArrayBuffer == "function" && !!ArrayBuffer.isView;
  function e(t, c) {
    if (t === c) return !0;
    if (t && c && typeof t == "object" && typeof c == "object") {
      if (t.constructor !== c.constructor) return !1;
      var n, h, d;
      if (Array.isArray(t)) {
        if (n = t.length, n != c.length) return !1;
        for (h = n; h-- !== 0; )
          if (!e(t[h], c[h])) return !1;
        return !0;
      }
      var k;
      if (E && t instanceof Map && c instanceof Map) {
        if (t.size !== c.size) return !1;
        for (k = t.entries(); !(h = k.next()).done; )
          if (!c.has(h.value[0])) return !1;
        for (k = t.entries(); !(h = k.next()).done; )
          if (!e(h.value[1], c.get(h.value[0]))) return !1;
        return !0;
      }
      if (A && t instanceof Set && c instanceof Set) {
        if (t.size !== c.size) return !1;
        for (k = t.entries(); !(h = k.next()).done; )
          if (!c.has(h.value[0])) return !1;
        return !0;
      }
      if (g && ArrayBuffer.isView(t) && ArrayBuffer.isView(c)) {
        if (n = t.length, n != c.length) return !1;
        for (h = n; h-- !== 0; )
          if (t[h] !== c[h]) return !1;
        return !0;
      }
      if (t.constructor === RegExp) return t.source === c.source && t.flags === c.flags;
      if (t.valueOf !== Object.prototype.valueOf && typeof t.valueOf == "function" && typeof c.valueOf == "function") return t.valueOf() === c.valueOf();
      if (t.toString !== Object.prototype.toString && typeof t.toString == "function" && typeof c.toString == "function") return t.toString() === c.toString();
      if (d = Object.keys(t), n = d.length, n !== Object.keys(c).length) return !1;
      for (h = n; h-- !== 0; )
        if (!Object.prototype.hasOwnProperty.call(c, d[h])) return !1;
      if (o && t instanceof Element) return !1;
      for (h = n; h-- !== 0; )
        if (!((d[h] === "_owner" || d[h] === "__v" || d[h] === "__o") && t.$$typeof) && !e(t[d[h]], c[d[h]]))
          return !1;
      return !0;
    }
    return t !== t && c !== c;
  }
  return reactFastCompare = function(c, n) {
    try {
      return e(c, n);
    } catch (h) {
      if ((h.message || "").match(/stack|recursion/i))
        return console.warn("react-fast-compare cannot handle circular refs"), !1;
      throw h;
    }
  }, reactFastCompare;
}
var reactFastCompareExports = requireReactFastCompare();
const fastCompare = /* @__PURE__ */ getDefaultExportFromCjs(reactFastCompareExports);
var browser, hasRequiredBrowser;
function requireBrowser() {
  if (hasRequiredBrowser) return browser;
  hasRequiredBrowser = 1;
  var o = function(E, A, g, e, t, c, n, h) {
    if (process.env.NODE_ENV !== "production" && A === void 0)
      throw new Error("invariant requires an error message argument");
    if (!E) {
      var d;
      if (A === void 0)
        d = new Error(
          "Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings."
        );
      else {
        var k = [g, e, t, c, n, h], p = 0;
        d = new Error(
          A.replace(/%s/g, function() {
            return k[p++];
          })
        ), d.name = "Invariant Violation";
      }
      throw d.framesToPop = 1, d;
    }
  };
  return browser = o, browser;
}
var browserExports = requireBrowser();
const invariant = /* @__PURE__ */ getDefaultExportFromCjs(browserExports);
var shallowequal, hasRequiredShallowequal;
function requireShallowequal() {
  return hasRequiredShallowequal || (hasRequiredShallowequal = 1, shallowequal = function(E, A, g, e) {
    var t = g ? g.call(e, E, A) : void 0;
    if (t !== void 0)
      return !!t;
    if (E === A)
      return !0;
    if (typeof E != "object" || !E || typeof A != "object" || !A)
      return !1;
    var c = Object.keys(E), n = Object.keys(A);
    if (c.length !== n.length)
      return !1;
    for (var h = Object.prototype.hasOwnProperty.bind(A), d = 0; d < c.length; d++) {
      var k = c[d];
      if (!h(k))
        return !1;
      var p = E[k], M = A[k];
      if (t = g ? g.call(e, p, M, k) : void 0, t === !1 || t === void 0 && p !== M)
        return !1;
    }
    return !0;
  }), shallowequal;
}
var shallowequalExports = requireShallowequal();
const shallowEqual = /* @__PURE__ */ getDefaultExportFromCjs(shallowequalExports);
var TAG_NAMES = /* @__PURE__ */ ((o) => (o.BASE = "base", o.BODY = "body", o.HEAD = "head", o.HTML = "html", o.LINK = "link", o.META = "meta", o.NOSCRIPT = "noscript", o.SCRIPT = "script", o.STYLE = "style", o.TITLE = "title", o.FRAGMENT = "Symbol(react.fragment)", o))(TAG_NAMES || {}), SEO_PRIORITY_TAGS = {
  link: { rel: ["amphtml", "canonical", "alternate"] },
  script: { type: ["application/ld+json"] },
  meta: {
    charset: "",
    name: ["generator", "robots", "description"],
    property: [
      "og:type",
      "og:title",
      "og:url",
      "og:image",
      "og:image:alt",
      "og:description",
      "twitter:url",
      "twitter:title",
      "twitter:description",
      "twitter:image",
      "twitter:image:alt",
      "twitter:card",
      "twitter:site"
    ]
  }
}, VALID_TAG_NAMES = Object.values(TAG_NAMES), REACT_TAG_MAP = {
  accesskey: "accessKey",
  charset: "charSet",
  class: "className",
  contenteditable: "contentEditable",
  contextmenu: "contextMenu",
  "http-equiv": "httpEquiv",
  itemprop: "itemProp",
  tabindex: "tabIndex"
}, HTML_TAG_MAP = Object.entries(REACT_TAG_MAP).reduce(
  (o, [E, A]) => (o[A] = E, o),
  {}
), HELMET_ATTRIBUTE = "data-rh", HELMET_PROPS = {
  DEFAULT_TITLE: "defaultTitle",
  DEFER: "defer",
  ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
  ON_CHANGE_CLIENT_STATE: "onChangeClientState",
  TITLE_TEMPLATE: "titleTemplate",
  PRIORITIZE_SEO_TAGS: "prioritizeSeoTags"
}, getInnermostProperty = (o, E) => {
  for (let A = o.length - 1; A >= 0; A -= 1) {
    const g = o[A];
    if (Object.prototype.hasOwnProperty.call(g, E))
      return g[E];
  }
  return null;
}, getTitleFromPropsList = (o) => {
  let E = getInnermostProperty(
    o,
    "title"
    /* TITLE */
  );
  const A = getInnermostProperty(o, HELMET_PROPS.TITLE_TEMPLATE);
  if (Array.isArray(E) && (E = E.join("")), A && E)
    return A.replace(/%s/g, () => E);
  const g = getInnermostProperty(o, HELMET_PROPS.DEFAULT_TITLE);
  return E || g || void 0;
}, getOnChangeClientState = (o) => getInnermostProperty(o, HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || (() => {
}), getAttributesFromPropsList = (o, E) => E.filter((A) => typeof A[o] < "u").map((A) => A[o]).reduce((A, g) => ({ ...A, ...g }), {}), getBaseTagFromPropsList = (o, E) => E.filter((A) => typeof A.base < "u").map((A) => A.base).reverse().reduce((A, g) => {
  if (!A.length) {
    const e = Object.keys(g);
    for (let t = 0; t < e.length; t += 1) {
      const n = e[t].toLowerCase();
      if (o.indexOf(n) !== -1 && g[n])
        return A.concat(g);
    }
  }
  return A;
}, []), warn = (o) => console && typeof console.warn == "function" && console.warn(o), getTagsFromPropsList = (o, E, A) => {
  const g = {};
  return A.filter((e) => Array.isArray(e[o]) ? !0 : (typeof e[o] < "u" && warn(
    `Helmet: ${o} should be of type "Array". Instead found type "${typeof e[o]}"`
  ), !1)).map((e) => e[o]).reverse().reduce((e, t) => {
    const c = {};
    t.filter((h) => {
      let d;
      const k = Object.keys(h);
      for (let M = 0; M < k.length; M += 1) {
        const S = k[M], AA = S.toLowerCase();
        E.indexOf(AA) !== -1 && !(d === "rel" && h[d].toLowerCase() === "canonical") && !(AA === "rel" && h[AA].toLowerCase() === "stylesheet") && (d = AA), E.indexOf(S) !== -1 && (S === "innerHTML" || S === "cssText" || S === "itemprop") && (d = S);
      }
      if (!d || !h[d])
        return !1;
      const p = h[d].toLowerCase();
      return g[d] || (g[d] = {}), c[d] || (c[d] = {}), g[d][p] ? !1 : (c[d][p] = !0, !0);
    }).reverse().forEach((h) => e.push(h));
    const n = Object.keys(c);
    for (let h = 0; h < n.length; h += 1) {
      const d = n[h], k = {
        ...g[d],
        ...c[d]
      };
      g[d] = k;
    }
    return e;
  }, []).reverse();
}, getAnyTrueFromPropsList = (o, E) => {
  if (Array.isArray(o) && o.length) {
    for (let A = 0; A < o.length; A += 1)
      if (o[A][E])
        return !0;
  }
  return !1;
}, reducePropsToState$1 = (o) => ({
  baseTag: getBaseTagFromPropsList([
    "href"
    /* HREF */
  ], o),
  bodyAttributes: getAttributesFromPropsList("bodyAttributes", o),
  defer: getInnermostProperty(o, HELMET_PROPS.DEFER),
  encode: getInnermostProperty(o, HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
  htmlAttributes: getAttributesFromPropsList("htmlAttributes", o),
  linkTags: getTagsFromPropsList(
    "link",
    [
      "rel",
      "href"
      /* HREF */
    ],
    o
  ),
  metaTags: getTagsFromPropsList(
    "meta",
    [
      "name",
      "charset",
      "http-equiv",
      "property",
      "itemprop"
      /* ITEM_PROP */
    ],
    o
  ),
  noscriptTags: getTagsFromPropsList("noscript", [
    "innerHTML"
    /* INNER_HTML */
  ], o),
  onChangeClientState: getOnChangeClientState(o),
  scriptTags: getTagsFromPropsList(
    "script",
    [
      "src",
      "innerHTML"
      /* INNER_HTML */
    ],
    o
  ),
  styleTags: getTagsFromPropsList("style", [
    "cssText"
    /* CSS_TEXT */
  ], o),
  title: getTitleFromPropsList(o),
  titleAttributes: getAttributesFromPropsList("titleAttributes", o),
  prioritizeSeoTags: getAnyTrueFromPropsList(o, HELMET_PROPS.PRIORITIZE_SEO_TAGS)
}), flattenArray = (o) => Array.isArray(o) ? o.join("") : o, checkIfPropsMatch = (o, E) => {
  const A = Object.keys(o);
  for (let g = 0; g < A.length; g += 1)
    if (E[A[g]] && E[A[g]].includes(o[A[g]]))
      return !0;
  return !1;
}, prioritizer = (o, E) => Array.isArray(o) ? o.reduce(
  (A, g) => (checkIfPropsMatch(g, E) ? A.priority.push(g) : A.default.push(g), A),
  { priority: [], default: [] }
) : { default: o, priority: [] }, without = (o, E) => ({
  ...o,
  [E]: void 0
}), SELF_CLOSING_TAGS = [
  "noscript",
  "script",
  "style"
  /* STYLE */
], encodeSpecialCharacters = (o, E = !0) => E === !1 ? String(o) : String(o).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;"), generateElementAttributesAsString = (o) => Object.keys(o).reduce((E, A) => {
  const g = typeof o[A] < "u" ? `${A}="${o[A]}"` : `${A}`;
  return E ? `${E} ${g}` : g;
}, ""), generateTitleAsString = (o, E, A, g) => {
  const e = generateElementAttributesAsString(A), t = flattenArray(E);
  return e ? `<${o} ${HELMET_ATTRIBUTE}="true" ${e}>${encodeSpecialCharacters(
    t,
    g
  )}</${o}>` : `<${o} ${HELMET_ATTRIBUTE}="true">${encodeSpecialCharacters(
    t,
    g
  )}</${o}>`;
}, generateTagsAsString = (o, E, A = !0) => E.reduce((g, e) => {
  const t = e, c = Object.keys(t).filter(
    (d) => !(d === "innerHTML" || d === "cssText")
  ).reduce((d, k) => {
    const p = typeof t[k] > "u" ? k : `${k}="${encodeSpecialCharacters(t[k], A)}"`;
    return d ? `${d} ${p}` : p;
  }, ""), n = t.innerHTML || t.cssText || "", h = SELF_CLOSING_TAGS.indexOf(o) === -1;
  return `${g}<${o} ${HELMET_ATTRIBUTE}="true" ${c}${h ? "/>" : `>${n}</${o}>`}`;
}, ""), convertElementAttributesToReactProps = (o, E = {}) => Object.keys(o).reduce((A, g) => {
  const e = REACT_TAG_MAP[g];
  return A[e || g] = o[g], A;
}, E), generateTitleAsReactComponent = (o, E, A) => {
  const g = {
    key: E,
    [HELMET_ATTRIBUTE]: !0
  }, e = convertElementAttributesToReactProps(A, g);
  return [React__default.createElement("title", e, E)];
}, generateTagsAsReactComponent = (o, E) => E.map((A, g) => {
  const e = {
    key: g,
    [HELMET_ATTRIBUTE]: !0
  };
  return Object.keys(A).forEach((t) => {
    const n = REACT_TAG_MAP[t] || t;
    if (n === "innerHTML" || n === "cssText") {
      const h = A.innerHTML || A.cssText;
      e.dangerouslySetInnerHTML = { __html: h };
    } else
      e[n] = A[t];
  }), React__default.createElement(o, e);
}), getMethodsForTag = (o, E, A = !0) => {
  switch (o) {
    case "title":
      return {
        toComponent: () => generateTitleAsReactComponent(o, E.title, E.titleAttributes),
        toString: () => generateTitleAsString(o, E.title, E.titleAttributes, A)
      };
    case "bodyAttributes":
    case "htmlAttributes":
      return {
        toComponent: () => convertElementAttributesToReactProps(E),
        toString: () => generateElementAttributesAsString(E)
      };
    default:
      return {
        toComponent: () => generateTagsAsReactComponent(o, E),
        toString: () => generateTagsAsString(o, E, A)
      };
  }
}, getPriorityMethods = ({ metaTags: o, linkTags: E, scriptTags: A, encode: g }) => {
  const e = prioritizer(o, SEO_PRIORITY_TAGS.meta), t = prioritizer(E, SEO_PRIORITY_TAGS.link), c = prioritizer(A, SEO_PRIORITY_TAGS.script);
  return {
    priorityMethods: {
      toComponent: () => [
        ...generateTagsAsReactComponent("meta", e.priority),
        ...generateTagsAsReactComponent("link", t.priority),
        ...generateTagsAsReactComponent("script", c.priority)
      ],
      toString: () => (
        // generate all the tags as strings and concatenate them
        `${getMethodsForTag("meta", e.priority, g)} ${getMethodsForTag(
          "link",
          t.priority,
          g
        )} ${getMethodsForTag("script", c.priority, g)}`
      )
    },
    metaTags: e.default,
    linkTags: t.default,
    scriptTags: c.default
  };
}, mapStateOnServer = (o) => {
  const {
    baseTag: E,
    bodyAttributes: A,
    encode: g = !0,
    htmlAttributes: e,
    noscriptTags: t,
    styleTags: c,
    title: n = "",
    titleAttributes: h,
    prioritizeSeoTags: d
  } = o;
  let { linkTags: k, metaTags: p, scriptTags: M } = o, S = {
    toComponent: () => {
    },
    toString: () => ""
  };
  return d && ({ priorityMethods: S, linkTags: k, metaTags: p, scriptTags: M } = getPriorityMethods(o)), {
    priority: S,
    base: getMethodsForTag("base", E, g),
    bodyAttributes: getMethodsForTag("bodyAttributes", A, g),
    htmlAttributes: getMethodsForTag("htmlAttributes", e, g),
    link: getMethodsForTag("link", k, g),
    meta: getMethodsForTag("meta", p, g),
    noscript: getMethodsForTag("noscript", t, g),
    script: getMethodsForTag("script", M, g),
    style: getMethodsForTag("style", c, g),
    title: getMethodsForTag("title", { title: n, titleAttributes: h }, g)
  };
}, server_default = mapStateOnServer, instances = [], isDocument = !!(typeof window < "u" && window.document && window.document.createElement), HelmetData = class {
  instances = [];
  canUseDOM = isDocument;
  context;
  value = {
    setHelmet: (o) => {
      this.context.helmet = o;
    },
    helmetInstances: {
      get: () => this.canUseDOM ? instances : this.instances,
      add: (o) => {
        (this.canUseDOM ? instances : this.instances).push(o);
      },
      remove: (o) => {
        const E = (this.canUseDOM ? instances : this.instances).indexOf(o);
        (this.canUseDOM ? instances : this.instances).splice(E, 1);
      }
    }
  };
  constructor(o, E) {
    this.context = o, this.canUseDOM = E || !1, E || (o.helmet = server_default({
      baseTag: [],
      bodyAttributes: {},
      htmlAttributes: {},
      linkTags: [],
      metaTags: [],
      noscriptTags: [],
      scriptTags: [],
      styleTags: [],
      title: "",
      titleAttributes: {}
    }));
  }
}, defaultValue = {}, Context = React__default.createContext(defaultValue), HelmetProvider = class aI extends Component {
  static canUseDOM = isDocument;
  helmetData;
  constructor(E) {
    super(E), this.helmetData = new HelmetData(this.props.context || {}, aI.canUseDOM);
  }
  render() {
    return /* @__PURE__ */ React__default.createElement(Context.Provider, { value: this.helmetData.value }, this.props.children);
  }
}, updateTags = (o, E) => {
  const A = document.head || document.querySelector(
    "head"
    /* HEAD */
  ), g = A.querySelectorAll(`${o}[${HELMET_ATTRIBUTE}]`), e = [].slice.call(g), t = [];
  let c;
  return E && E.length && E.forEach((n) => {
    const h = document.createElement(o);
    for (const d in n)
      if (Object.prototype.hasOwnProperty.call(n, d))
        if (d === "innerHTML")
          h.innerHTML = n.innerHTML;
        else if (d === "cssText")
          h.styleSheet ? h.styleSheet.cssText = n.cssText : h.appendChild(document.createTextNode(n.cssText));
        else {
          const k = d, p = typeof n[k] > "u" ? "" : n[k];
          h.setAttribute(d, p);
        }
    h.setAttribute(HELMET_ATTRIBUTE, "true"), e.some((d, k) => (c = k, h.isEqualNode(d))) ? e.splice(c, 1) : t.push(h);
  }), e.forEach((n) => n.parentNode?.removeChild(n)), t.forEach((n) => A.appendChild(n)), {
    oldTags: e,
    newTags: t
  };
}, updateAttributes = (o, E) => {
  const A = document.getElementsByTagName(o)[0];
  if (!A)
    return;
  const g = A.getAttribute(HELMET_ATTRIBUTE), e = g ? g.split(",") : [], t = [...e], c = Object.keys(E);
  for (const n of c) {
    const h = E[n] || "";
    A.getAttribute(n) !== h && A.setAttribute(n, h), e.indexOf(n) === -1 && e.push(n);
    const d = t.indexOf(n);
    d !== -1 && t.splice(d, 1);
  }
  for (let n = t.length - 1; n >= 0; n -= 1)
    A.removeAttribute(t[n]);
  e.length === t.length ? A.removeAttribute(HELMET_ATTRIBUTE) : A.getAttribute(HELMET_ATTRIBUTE) !== c.join(",") && A.setAttribute(HELMET_ATTRIBUTE, c.join(","));
}, updateTitle = (o, E) => {
  typeof o < "u" && document.title !== o && (document.title = flattenArray(o)), updateAttributes("title", E);
}, commitTagChanges = (o, E) => {
  const {
    baseTag: A,
    bodyAttributes: g,
    htmlAttributes: e,
    linkTags: t,
    metaTags: c,
    noscriptTags: n,
    onChangeClientState: h,
    scriptTags: d,
    styleTags: k,
    title: p,
    titleAttributes: M
  } = o;
  updateAttributes("body", g), updateAttributes("html", e), updateTitle(p, M);
  const S = {
    baseTag: updateTags("base", A),
    linkTags: updateTags("link", t),
    metaTags: updateTags("meta", c),
    noscriptTags: updateTags("noscript", n),
    scriptTags: updateTags("script", d),
    styleTags: updateTags("style", k)
  }, AA = {}, H = {};
  Object.keys(S).forEach((gA) => {
    const { newTags: CA, oldTags: IA } = S[gA];
    CA.length && (AA[gA] = CA), IA.length && (H[gA] = S[gA].oldTags);
  }), E && E(), h(o, AA, H);
}, _helmetCallback = null, handleStateChangeOnClient$1 = (o) => {
  _helmetCallback && cancelAnimationFrame(_helmetCallback), o.defer ? _helmetCallback = requestAnimationFrame(() => {
    commitTagChanges(o, () => {
      _helmetCallback = null;
    });
  }) : (commitTagChanges(o), _helmetCallback = null);
}, client_default = handleStateChangeOnClient$1, HelmetDispatcher = class extends Component {
  rendered = !1;
  shouldComponentUpdate(o) {
    return !shallowEqual(o, this.props);
  }
  componentDidUpdate() {
    this.emitChange();
  }
  componentWillUnmount() {
    const { helmetInstances: o } = this.props.context;
    o.remove(this), this.emitChange();
  }
  emitChange() {
    const { helmetInstances: o, setHelmet: E } = this.props.context;
    let A = null;
    const g = reducePropsToState$1(
      o.get().map((e) => {
        const t = { ...e.props };
        return delete t.context, t;
      })
    );
    HelmetProvider.canUseDOM ? client_default(g) : server_default && (A = server_default(g)), E(A);
  }
  // componentWillMount will be deprecated
  // for SSR, initialize on first render
  // constructor is also unsafe in StrictMode
  init() {
    if (this.rendered)
      return;
    this.rendered = !0;
    const { helmetInstances: o } = this.props.context;
    o.add(this), this.emitChange();
  }
  render() {
    return this.init(), null;
  }
}, Helmet = class extends Component {
  static defaultProps = {
    defer: !0,
    encodeSpecialCharacters: !0,
    prioritizeSeoTags: !1
  };
  shouldComponentUpdate(o) {
    return !fastCompare(without(this.props, "helmetData"), without(o, "helmetData"));
  }
  mapNestedChildrenToProps(o, E) {
    if (!E)
      return null;
    switch (o.type) {
      case "script":
      case "noscript":
        return {
          innerHTML: E
        };
      case "style":
        return {
          cssText: E
        };
      default:
        throw new Error(
          `<${o.type} /> elements are self-closing and can not contain children. Refer to our API for more information.`
        );
    }
  }
  flattenArrayTypeChildren(o, E, A, g) {
    return {
      ...E,
      [o.type]: [
        ...E[o.type] || [],
        {
          ...A,
          ...this.mapNestedChildrenToProps(o, g)
        }
      ]
    };
  }
  mapObjectTypeChildren(o, E, A, g) {
    switch (o.type) {
      case "title":
        return {
          ...E,
          [o.type]: g,
          titleAttributes: { ...A }
        };
      case "body":
        return {
          ...E,
          bodyAttributes: { ...A }
        };
      case "html":
        return {
          ...E,
          htmlAttributes: { ...A }
        };
      default:
        return {
          ...E,
          [o.type]: { ...A }
        };
    }
  }
  mapArrayTypeChildrenToProps(o, E) {
    let A = { ...E };
    return Object.keys(o).forEach((g) => {
      A = {
        ...A,
        [g]: o[g]
      };
    }), A;
  }
  warnOnInvalidChildren(o, E) {
    return invariant(
      VALID_TAG_NAMES.some((A) => o.type === A),
      typeof o.type == "function" ? "You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information." : `Only elements types ${VALID_TAG_NAMES.join(
        ", "
      )} are allowed. Helmet does not support rendering <${o.type}> elements. Refer to our API for more information.`
    ), invariant(
      !E || typeof E == "string" || Array.isArray(E) && !E.some((A) => typeof A != "string"),
      `Helmet expects a string as a child of <${o.type}>. Did you forget to wrap your children in braces? ( <${o.type}>{\`\`}</${o.type}> ) Refer to our API for more information.`
    ), !0;
  }
  mapChildrenToProps(o, E) {
    let A = {};
    return React__default.Children.forEach(o, (g) => {
      if (!g || !g.props)
        return;
      const { children: e, ...t } = g.props, c = Object.keys(t).reduce((h, d) => (h[HTML_TAG_MAP[d] || d] = t[d], h), {});
      let { type: n } = g;
      switch (typeof n == "symbol" ? n = n.toString() : this.warnOnInvalidChildren(g, e), n) {
        case "Symbol(react.fragment)":
          E = this.mapChildrenToProps(e, E);
          break;
        case "link":
        case "meta":
        case "noscript":
        case "script":
        case "style":
          A = this.flattenArrayTypeChildren(
            g,
            A,
            c,
            e
          );
          break;
        default:
          E = this.mapObjectTypeChildren(g, E, c, e);
          break;
      }
    }), this.mapArrayTypeChildrenToProps(A, E);
  }
  render() {
    const { children: o, ...E } = this.props;
    let A = { ...E }, { helmetData: g } = E;
    if (o && (A = this.mapChildrenToProps(o, A)), g && !(g instanceof HelmetData)) {
      const e = g;
      g = new HelmetData(e.context, !0), delete A.helmetData;
    }
    return g ? /* @__PURE__ */ React__default.createElement(HelmetDispatcher, { ...A, context: g.value }) : /* @__PURE__ */ React__default.createElement(Context.Consumer, null, (e) => /* @__PURE__ */ React__default.createElement(HelmetDispatcher, { ...A, context: e }));
  }
};
const FontSources = ({
  fontSources: o
}) => /* @__PURE__ */ jsxRuntimeExports.jsx(Helmet, { children: Object.entries(o).map(([E, A]) => /* @__PURE__ */ jsxRuntimeExports.jsx("link", { id: E, rel: "stylesheet", href: A }, E)) });
typeof Promise.withResolvers > "u" && (Promise.withResolvers = () => {
  let o, E;
  const A = new Promise((g, e) => {
    o = g, E = e;
  });
  return {
    resolve: o,
    reject: E,
    promise: A
  };
});
function getCookie(o) {
  const E = document.cookie.match(`\\b${o}=([^;]*)\\b`);
  return E ? E[1] : void 0;
}
function localStorageAvailable() {
  const o = "testData";
  try {
    const {
      localStorage: E
    } = window;
    E.setItem(o, o), E.getItem(o), E.removeItem(o);
  } catch {
    return !1;
  }
  return !0;
}
function notNullOrUndefined(o) {
  return o != null;
}
function isNullOrUndefined(o) {
  return o == null;
}
const isLocalhost = () => window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";
var indexMinimal$1 = {}, minimal$3 = {}, aspromise$1, hasRequiredAspromise$1;
function requireAspromise$1() {
  if (hasRequiredAspromise$1) return aspromise$1;
  hasRequiredAspromise$1 = 1, aspromise$1 = o;
  function o(E, A) {
    for (var g = new Array(arguments.length - 1), e = 0, t = 2, c = !0; t < arguments.length; )
      g[e++] = arguments[t++];
    return new Promise(function(h, d) {
      g[e] = function(p) {
        if (c)
          if (c = !1, p)
            d(p);
          else {
            for (var M = new Array(arguments.length - 1), S = 0; S < M.length; )
              M[S++] = arguments[S];
            h.apply(null, M);
          }
      };
      try {
        E.apply(A || null, g);
      } catch (k) {
        c && (c = !1, d(k));
      }
    });
  }
  return aspromise$1;
}
var base64$1 = {}, hasRequiredBase64$1;
function requireBase64$1() {
  return hasRequiredBase64$1 || (hasRequiredBase64$1 = 1, (function(o) {
    var E = o;
    E.length = function(n) {
      var h = n.length;
      if (!h)
        return 0;
      for (var d = 0; --h % 4 > 1 && n.charAt(h) === "="; )
        ++d;
      return Math.ceil(n.length * 3) / 4 - d;
    };
    for (var A = new Array(64), g = new Array(123), e = 0; e < 64; )
      g[A[e] = e < 26 ? e + 65 : e < 52 ? e + 71 : e < 62 ? e - 4 : e - 59 | 43] = e++;
    E.encode = function(n, h, d) {
      for (var k = null, p = [], M = 0, S = 0, AA; h < d; ) {
        var H = n[h++];
        switch (S) {
          case 0:
            p[M++] = A[H >> 2], AA = (H & 3) << 4, S = 1;
            break;
          case 1:
            p[M++] = A[AA | H >> 4], AA = (H & 15) << 2, S = 2;
            break;
          case 2:
            p[M++] = A[AA | H >> 6], p[M++] = A[H & 63], S = 0;
            break;
        }
        M > 8191 && ((k || (k = [])).push(String.fromCharCode.apply(String, p)), M = 0);
      }
      return S && (p[M++] = A[AA], p[M++] = 61, S === 1 && (p[M++] = 61)), k ? (M && k.push(String.fromCharCode.apply(String, p.slice(0, M))), k.join("")) : String.fromCharCode.apply(String, p.slice(0, M));
    };
    var t = "invalid encoding";
    E.decode = function(n, h, d) {
      for (var k = d, p = 0, M, S = 0; S < n.length; ) {
        var AA = n.charCodeAt(S++);
        if (AA === 61 && p > 1)
          break;
        if ((AA = g[AA]) === void 0)
          throw Error(t);
        switch (p) {
          case 0:
            M = AA, p = 1;
            break;
          case 1:
            h[d++] = M << 2 | (AA & 48) >> 4, M = AA, p = 2;
            break;
          case 2:
            h[d++] = (M & 15) << 4 | (AA & 60) >> 2, M = AA, p = 3;
            break;
          case 3:
            h[d++] = (M & 3) << 6 | AA, p = 0;
            break;
        }
      }
      if (p === 1)
        throw Error(t);
      return d - k;
    }, E.test = function(n) {
      return /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/.test(n);
    };
  })(base64$1)), base64$1;
}
var eventemitter$1, hasRequiredEventemitter$1;
function requireEventemitter$1() {
  if (hasRequiredEventemitter$1) return eventemitter$1;
  hasRequiredEventemitter$1 = 1, eventemitter$1 = o;
  function o() {
    this._listeners = {};
  }
  return o.prototype.on = function(A, g, e) {
    return (this._listeners[A] || (this._listeners[A] = [])).push({
      fn: g,
      ctx: e || this
    }), this;
  }, o.prototype.off = function(A, g) {
    if (A === void 0)
      this._listeners = {};
    else if (g === void 0)
      this._listeners[A] = [];
    else
      for (var e = this._listeners[A], t = 0; t < e.length; )
        e[t].fn === g ? e.splice(t, 1) : ++t;
    return this;
  }, o.prototype.emit = function(A) {
    var g = this._listeners[A];
    if (g) {
      for (var e = [], t = 1; t < arguments.length; )
        e.push(arguments[t++]);
      for (t = 0; t < g.length; )
        g[t].fn.apply(g[t++].ctx, e);
    }
    return this;
  }, eventemitter$1;
}
var float$1, hasRequiredFloat$1;
function requireFloat$1() {
  if (hasRequiredFloat$1) return float$1;
  hasRequiredFloat$1 = 1, float$1 = o(o);
  function o(t) {
    return typeof Float32Array < "u" ? (function() {
      var c = new Float32Array([-0]), n = new Uint8Array(c.buffer), h = n[3] === 128;
      function d(S, AA, H) {
        c[0] = S, AA[H] = n[0], AA[H + 1] = n[1], AA[H + 2] = n[2], AA[H + 3] = n[3];
      }
      function k(S, AA, H) {
        c[0] = S, AA[H] = n[3], AA[H + 1] = n[2], AA[H + 2] = n[1], AA[H + 3] = n[0];
      }
      t.writeFloatLE = h ? d : k, t.writeFloatBE = h ? k : d;
      function p(S, AA) {
        return n[0] = S[AA], n[1] = S[AA + 1], n[2] = S[AA + 2], n[3] = S[AA + 3], c[0];
      }
      function M(S, AA) {
        return n[3] = S[AA], n[2] = S[AA + 1], n[1] = S[AA + 2], n[0] = S[AA + 3], c[0];
      }
      t.readFloatLE = h ? p : M, t.readFloatBE = h ? M : p;
    })() : (function() {
      function c(h, d, k, p) {
        var M = d < 0 ? 1 : 0;
        if (M && (d = -d), d === 0)
          h(1 / d > 0 ? (
            /* positive */
            0
          ) : (
            /* negative 0 */
            2147483648
          ), k, p);
        else if (isNaN(d))
          h(2143289344, k, p);
        else if (d > 34028234663852886e22)
          h((M << 31 | 2139095040) >>> 0, k, p);
        else if (d < 11754943508222875e-54)
          h((M << 31 | Math.round(d / 1401298464324817e-60)) >>> 0, k, p);
        else {
          var S = Math.floor(Math.log(d) / Math.LN2), AA = Math.round(d * Math.pow(2, -S) * 8388608) & 8388607;
          h((M << 31 | S + 127 << 23 | AA) >>> 0, k, p);
        }
      }
      t.writeFloatLE = c.bind(null, E), t.writeFloatBE = c.bind(null, A);
      function n(h, d, k) {
        var p = h(d, k), M = (p >> 31) * 2 + 1, S = p >>> 23 & 255, AA = p & 8388607;
        return S === 255 ? AA ? NaN : M * (1 / 0) : S === 0 ? M * 1401298464324817e-60 * AA : M * Math.pow(2, S - 150) * (AA + 8388608);
      }
      t.readFloatLE = n.bind(null, g), t.readFloatBE = n.bind(null, e);
    })(), typeof Float64Array < "u" ? (function() {
      var c = new Float64Array([-0]), n = new Uint8Array(c.buffer), h = n[7] === 128;
      function d(S, AA, H) {
        c[0] = S, AA[H] = n[0], AA[H + 1] = n[1], AA[H + 2] = n[2], AA[H + 3] = n[3], AA[H + 4] = n[4], AA[H + 5] = n[5], AA[H + 6] = n[6], AA[H + 7] = n[7];
      }
      function k(S, AA, H) {
        c[0] = S, AA[H] = n[7], AA[H + 1] = n[6], AA[H + 2] = n[5], AA[H + 3] = n[4], AA[H + 4] = n[3], AA[H + 5] = n[2], AA[H + 6] = n[1], AA[H + 7] = n[0];
      }
      t.writeDoubleLE = h ? d : k, t.writeDoubleBE = h ? k : d;
      function p(S, AA) {
        return n[0] = S[AA], n[1] = S[AA + 1], n[2] = S[AA + 2], n[3] = S[AA + 3], n[4] = S[AA + 4], n[5] = S[AA + 5], n[6] = S[AA + 6], n[7] = S[AA + 7], c[0];
      }
      function M(S, AA) {
        return n[7] = S[AA], n[6] = S[AA + 1], n[5] = S[AA + 2], n[4] = S[AA + 3], n[3] = S[AA + 4], n[2] = S[AA + 5], n[1] = S[AA + 6], n[0] = S[AA + 7], c[0];
      }
      t.readDoubleLE = h ? p : M, t.readDoubleBE = h ? M : p;
    })() : (function() {
      function c(h, d, k, p, M, S) {
        var AA = p < 0 ? 1 : 0;
        if (AA && (p = -p), p === 0)
          h(0, M, S + d), h(1 / p > 0 ? (
            /* positive */
            0
          ) : (
            /* negative 0 */
            2147483648
          ), M, S + k);
        else if (isNaN(p))
          h(0, M, S + d), h(2146959360, M, S + k);
        else if (p > 17976931348623157e292)
          h(0, M, S + d), h((AA << 31 | 2146435072) >>> 0, M, S + k);
        else {
          var H;
          if (p < 22250738585072014e-324)
            H = p / 5e-324, h(H >>> 0, M, S + d), h((AA << 31 | H / 4294967296) >>> 0, M, S + k);
          else {
            var gA = Math.floor(Math.log(p) / Math.LN2);
            gA === 1024 && (gA = 1023), H = p * Math.pow(2, -gA), h(H * 4503599627370496 >>> 0, M, S + d), h((AA << 31 | gA + 1023 << 20 | H * 1048576 & 1048575) >>> 0, M, S + k);
          }
        }
      }
      t.writeDoubleLE = c.bind(null, E, 0, 4), t.writeDoubleBE = c.bind(null, A, 4, 0);
      function n(h, d, k, p, M) {
        var S = h(p, M + d), AA = h(p, M + k), H = (AA >> 31) * 2 + 1, gA = AA >>> 20 & 2047, CA = 4294967296 * (AA & 1048575) + S;
        return gA === 2047 ? CA ? NaN : H * (1 / 0) : gA === 0 ? H * 5e-324 * CA : H * Math.pow(2, gA - 1075) * (CA + 4503599627370496);
      }
      t.readDoubleLE = n.bind(null, g, 0, 4), t.readDoubleBE = n.bind(null, e, 4, 0);
    })(), t;
  }
  function E(t, c, n) {
    c[n] = t & 255, c[n + 1] = t >>> 8 & 255, c[n + 2] = t >>> 16 & 255, c[n + 3] = t >>> 24;
  }
  function A(t, c, n) {
    c[n] = t >>> 24, c[n + 1] = t >>> 16 & 255, c[n + 2] = t >>> 8 & 255, c[n + 3] = t & 255;
  }
  function g(t, c) {
    return (t[c] | t[c + 1] << 8 | t[c + 2] << 16 | t[c + 3] << 24) >>> 0;
  }
  function e(t, c) {
    return (t[c] << 24 | t[c + 1] << 16 | t[c + 2] << 8 | t[c + 3]) >>> 0;
  }
  return float$1;
}
var inquire_1$1, hasRequiredInquire$1;
function requireInquire$1() {
  if (hasRequiredInquire$1) return inquire_1$1;
  hasRequiredInquire$1 = 1, inquire_1$1 = inquire;
  function inquire(moduleName) {
    try {
      var mod = eval("quire".replace(/^/, "re"))(moduleName);
      if (mod && (mod.length || Object.keys(mod).length))
        return mod;
    } catch (o) {
    }
    return null;
  }
  return inquire_1$1;
}
var utf8$1 = {}, hasRequiredUtf8$1;
function requireUtf8$1() {
  return hasRequiredUtf8$1 || (hasRequiredUtf8$1 = 1, (function(o) {
    var E = o;
    E.length = function(g) {
      for (var e = 0, t = 0, c = 0; c < g.length; ++c)
        t = g.charCodeAt(c), t < 128 ? e += 1 : t < 2048 ? e += 2 : (t & 64512) === 55296 && (g.charCodeAt(c + 1) & 64512) === 56320 ? (++c, e += 4) : e += 3;
      return e;
    }, E.read = function(g, e, t) {
      var c = t - e;
      if (c < 1)
        return "";
      for (var n = null, h = [], d = 0, k; e < t; )
        k = g[e++], k < 128 ? h[d++] = k : k > 191 && k < 224 ? h[d++] = (k & 31) << 6 | g[e++] & 63 : k > 239 && k < 365 ? (k = ((k & 7) << 18 | (g[e++] & 63) << 12 | (g[e++] & 63) << 6 | g[e++] & 63) - 65536, h[d++] = 55296 + (k >> 10), h[d++] = 56320 + (k & 1023)) : h[d++] = (k & 15) << 12 | (g[e++] & 63) << 6 | g[e++] & 63, d > 8191 && ((n || (n = [])).push(String.fromCharCode.apply(String, h)), d = 0);
      return n ? (d && n.push(String.fromCharCode.apply(String, h.slice(0, d))), n.join("")) : String.fromCharCode.apply(String, h.slice(0, d));
    }, E.write = function(g, e, t) {
      for (var c = t, n, h, d = 0; d < g.length; ++d)
        n = g.charCodeAt(d), n < 128 ? e[t++] = n : n < 2048 ? (e[t++] = n >> 6 | 192, e[t++] = n & 63 | 128) : (n & 64512) === 55296 && ((h = g.charCodeAt(d + 1)) & 64512) === 56320 ? (n = 65536 + ((n & 1023) << 10) + (h & 1023), ++d, e[t++] = n >> 18 | 240, e[t++] = n >> 12 & 63 | 128, e[t++] = n >> 6 & 63 | 128, e[t++] = n & 63 | 128) : (e[t++] = n >> 12 | 224, e[t++] = n >> 6 & 63 | 128, e[t++] = n & 63 | 128);
      return t - c;
    };
  })(utf8$1)), utf8$1;
}
var pool_1$1, hasRequiredPool$1;
function requirePool$1() {
  if (hasRequiredPool$1) return pool_1$1;
  hasRequiredPool$1 = 1, pool_1$1 = o;
  function o(E, A, g) {
    var e = g || 8192, t = e >>> 1, c = null, n = e;
    return function(d) {
      if (d < 1 || d > t)
        return E(d);
      n + d > e && (c = E(e), n = 0);
      var k = A.call(c, n, n += d);
      return n & 7 && (n = (n | 7) + 1), k;
    };
  }
  return pool_1$1;
}
var longbits$1, hasRequiredLongbits$1;
function requireLongbits$1() {
  if (hasRequiredLongbits$1) return longbits$1;
  hasRequiredLongbits$1 = 1, longbits$1 = E;
  var o = requireMinimal$3();
  function E(t, c) {
    this.lo = t >>> 0, this.hi = c >>> 0;
  }
  var A = E.zero = new E(0, 0);
  A.toNumber = function() {
    return 0;
  }, A.zzEncode = A.zzDecode = function() {
    return this;
  }, A.length = function() {
    return 1;
  };
  var g = E.zeroHash = "\0\0\0\0\0\0\0\0";
  E.fromNumber = function(c) {
    if (c === 0)
      return A;
    var n = c < 0;
    n && (c = -c);
    var h = c >>> 0, d = (c - h) / 4294967296 >>> 0;
    return n && (d = ~d >>> 0, h = ~h >>> 0, ++h > 4294967295 && (h = 0, ++d > 4294967295 && (d = 0))), new E(h, d);
  }, E.from = function(c) {
    if (typeof c == "number")
      return E.fromNumber(c);
    if (o.isString(c))
      if (o.Long)
        c = o.Long.fromString(c);
      else
        return E.fromNumber(parseInt(c, 10));
    return c.low || c.high ? new E(c.low >>> 0, c.high >>> 0) : A;
  }, E.prototype.toNumber = function(c) {
    if (!c && this.hi >>> 31) {
      var n = ~this.lo + 1 >>> 0, h = ~this.hi >>> 0;
      return n || (h = h + 1 >>> 0), -(n + h * 4294967296);
    }
    return this.lo + this.hi * 4294967296;
  }, E.prototype.toLong = function(c) {
    return o.Long ? new o.Long(this.lo | 0, this.hi | 0, !!c) : { low: this.lo | 0, high: this.hi | 0, unsigned: !!c };
  };
  var e = String.prototype.charCodeAt;
  return E.fromHash = function(c) {
    return c === g ? A : new E(
      (e.call(c, 0) | e.call(c, 1) << 8 | e.call(c, 2) << 16 | e.call(c, 3) << 24) >>> 0,
      (e.call(c, 4) | e.call(c, 5) << 8 | e.call(c, 6) << 16 | e.call(c, 7) << 24) >>> 0
    );
  }, E.prototype.toHash = function() {
    return String.fromCharCode(
      this.lo & 255,
      this.lo >>> 8 & 255,
      this.lo >>> 16 & 255,
      this.lo >>> 24,
      this.hi & 255,
      this.hi >>> 8 & 255,
      this.hi >>> 16 & 255,
      this.hi >>> 24
    );
  }, E.prototype.zzEncode = function() {
    var c = this.hi >> 31;
    return this.hi = ((this.hi << 1 | this.lo >>> 31) ^ c) >>> 0, this.lo = (this.lo << 1 ^ c) >>> 0, this;
  }, E.prototype.zzDecode = function() {
    var c = -(this.lo & 1);
    return this.lo = ((this.lo >>> 1 | this.hi << 31) ^ c) >>> 0, this.hi = (this.hi >>> 1 ^ c) >>> 0, this;
  }, E.prototype.length = function() {
    var c = this.lo, n = (this.lo >>> 28 | this.hi << 4) >>> 0, h = this.hi >>> 24;
    return h === 0 ? n === 0 ? c < 16384 ? c < 128 ? 1 : 2 : c < 2097152 ? 3 : 4 : n < 16384 ? n < 128 ? 5 : 6 : n < 2097152 ? 7 : 8 : h < 128 ? 9 : 10;
  }, longbits$1;
}
var hasRequiredMinimal$3;
function requireMinimal$3() {
  return hasRequiredMinimal$3 || (hasRequiredMinimal$3 = 1, (function(o) {
    var E = o;
    E.asPromise = requireAspromise$1(), E.base64 = requireBase64$1(), E.EventEmitter = requireEventemitter$1(), E.float = requireFloat$1(), E.inquire = requireInquire$1(), E.utf8 = requireUtf8$1(), E.pool = requirePool$1(), E.LongBits = requireLongbits$1(), E.isNode = !!(typeof commonjsGlobal$1 < "u" && commonjsGlobal$1 && commonjsGlobal$1.process && commonjsGlobal$1.process.versions && commonjsGlobal$1.process.versions.node), E.global = E.isNode && commonjsGlobal$1 || typeof window < "u" && window || typeof self < "u" && self || minimal$3, E.emptyArray = Object.freeze ? Object.freeze([]) : (
      /* istanbul ignore next */
      []
    ), E.emptyObject = Object.freeze ? Object.freeze({}) : (
      /* istanbul ignore next */
      {}
    ), E.isInteger = Number.isInteger || /* istanbul ignore next */
    function(t) {
      return typeof t == "number" && isFinite(t) && Math.floor(t) === t;
    }, E.isString = function(t) {
      return typeof t == "string" || t instanceof String;
    }, E.isObject = function(t) {
      return t && typeof t == "object";
    }, E.isset = /**
     * Checks if a property on a message is considered to be present.
     * @param {Object} obj Plain object or message instance
     * @param {string} prop Property name
     * @returns {boolean} `true` if considered to be present, otherwise `false`
     */
    E.isSet = function(t, c) {
      var n = t[c];
      return n != null && t.hasOwnProperty(c) ? typeof n != "object" || (Array.isArray(n) ? n.length : Object.keys(n).length) > 0 : !1;
    }, E.Buffer = (function() {
      try {
        var e = E.inquire("buffer").Buffer;
        return e.prototype.utf8Write ? e : (
          /* istanbul ignore next */
          null
        );
      } catch {
        return null;
      }
    })(), E._Buffer_from = null, E._Buffer_allocUnsafe = null, E.newBuffer = function(t) {
      return typeof t == "number" ? E.Buffer ? E._Buffer_allocUnsafe(t) : new E.Array(t) : E.Buffer ? E._Buffer_from(t) : typeof Uint8Array > "u" ? t : new Uint8Array(t);
    }, E.Array = typeof Uint8Array < "u" ? Uint8Array : Array, E.Long = /* istanbul ignore next */
    E.global.dcodeIO && /* istanbul ignore next */
    E.global.dcodeIO.Long || /* istanbul ignore next */
    E.global.Long || E.inquire("long"), E.key2Re = /^true|false|0|1$/, E.key32Re = /^-?(?:0|[1-9][0-9]*)$/, E.key64Re = /^(?:[\\x00-\\xff]{8}|-?(?:0|[1-9][0-9]*))$/, E.longToHash = function(t) {
      return t ? E.LongBits.from(t).toHash() : E.LongBits.zeroHash;
    }, E.longFromHash = function(t, c) {
      var n = E.LongBits.fromHash(t);
      return E.Long ? E.Long.fromBits(n.lo, n.hi, c) : n.toNumber(!!c);
    };
    function A(e, t, c) {
      for (var n = Object.keys(t), h = 0; h < n.length; ++h)
        (e[n[h]] === void 0 || !c) && (e[n[h]] = t[n[h]]);
      return e;
    }
    E.merge = A, E.lcFirst = function(t) {
      return t.charAt(0).toLowerCase() + t.substring(1);
    };
    function g(e) {
      function t(c, n) {
        if (!(this instanceof t))
          return new t(c, n);
        Object.defineProperty(this, "message", { get: function() {
          return c;
        } }), Error.captureStackTrace ? Error.captureStackTrace(this, t) : Object.defineProperty(this, "stack", { value: new Error().stack || "" }), n && A(this, n);
      }
      return t.prototype = Object.create(Error.prototype, {
        constructor: {
          value: t,
          writable: !0,
          enumerable: !1,
          configurable: !0
        },
        name: {
          get: function() {
            return e;
          },
          set: void 0,
          enumerable: !1,
          // configurable: false would accurately preserve the behavior of
          // the original, but I'm guessing that was not intentional.
          // For an actual error subclass, this property would
          // be configurable.
          configurable: !0
        },
        toString: {
          value: function() {
            return this.name + ": " + this.message;
          },
          writable: !0,
          enumerable: !1,
          configurable: !0
        }
      }), t;
    }
    E.newError = g, E.ProtocolError = g("ProtocolError"), E.oneOfGetter = function(t) {
      for (var c = {}, n = 0; n < t.length; ++n)
        c[t[n]] = 1;
      return function() {
        for (var h = Object.keys(this), d = h.length - 1; d > -1; --d)
          if (c[h[d]] === 1 && this[h[d]] !== void 0 && this[h[d]] !== null)
            return h[d];
      };
    }, E.oneOfSetter = function(t) {
      return function(c) {
        for (var n = 0; n < t.length; ++n)
          t[n] !== c && delete this[t[n]];
      };
    }, E.toJSONOptions = {
      longs: String,
      enums: String,
      bytes: String,
      json: !0
    }, E._configure = function() {
      var e = E.Buffer;
      if (!e) {
        E._Buffer_from = E._Buffer_allocUnsafe = null;
        return;
      }
      E._Buffer_from = e.from !== Uint8Array.from && e.from || /* istanbul ignore next */
      function(c, n) {
        return new e(c, n);
      }, E._Buffer_allocUnsafe = e.allocUnsafe || /* istanbul ignore next */
      function(c) {
        return new e(c);
      };
    };
  })(minimal$3)), minimal$3;
}
var writer$1, hasRequiredWriter$1;
function requireWriter$1() {
  if (hasRequiredWriter$1) return writer$1;
  hasRequiredWriter$1 = 1, writer$1 = h;
  var o = requireMinimal$3(), E, A = o.LongBits, g = o.base64, e = o.utf8;
  function t(gA, CA, IA) {
    this.fn = gA, this.len = CA, this.next = void 0, this.val = IA;
  }
  function c() {
  }
  function n(gA) {
    this.head = gA.head, this.tail = gA.tail, this.len = gA.len, this.next = gA.states;
  }
  function h() {
    this.len = 0, this.head = new t(c, 0, 0), this.tail = this.head, this.states = null;
  }
  var d = function() {
    return o.Buffer ? function() {
      return (h.create = function() {
        return new E();
      })();
    } : function() {
      return new h();
    };
  };
  h.create = d(), h.alloc = function(CA) {
    return new o.Array(CA);
  }, o.Array !== Array && (h.alloc = o.pool(h.alloc, o.Array.prototype.subarray)), h.prototype._push = function(CA, IA, BA) {
    return this.tail = this.tail.next = new t(CA, IA, BA), this.len += IA, this;
  };
  function k(gA, CA, IA) {
    CA[IA] = gA & 255;
  }
  function p(gA, CA, IA) {
    for (; gA > 127; )
      CA[IA++] = gA & 127 | 128, gA >>>= 7;
    CA[IA] = gA;
  }
  function M(gA, CA) {
    this.len = gA, this.next = void 0, this.val = CA;
  }
  M.prototype = Object.create(t.prototype), M.prototype.fn = p, h.prototype.uint32 = function(CA) {
    return this.len += (this.tail = this.tail.next = new M(
      (CA = CA >>> 0) < 128 ? 1 : CA < 16384 ? 2 : CA < 2097152 ? 3 : CA < 268435456 ? 4 : 5,
      CA
    )).len, this;
  }, h.prototype.int32 = function(CA) {
    return CA < 0 ? this._push(S, 10, A.fromNumber(CA)) : this.uint32(CA);
  }, h.prototype.sint32 = function(CA) {
    return this.uint32((CA << 1 ^ CA >> 31) >>> 0);
  };
  function S(gA, CA, IA) {
    for (; gA.hi; )
      CA[IA++] = gA.lo & 127 | 128, gA.lo = (gA.lo >>> 7 | gA.hi << 25) >>> 0, gA.hi >>>= 7;
    for (; gA.lo > 127; )
      CA[IA++] = gA.lo & 127 | 128, gA.lo = gA.lo >>> 7;
    CA[IA++] = gA.lo;
  }
  h.prototype.uint64 = function(CA) {
    var IA = A.from(CA);
    return this._push(S, IA.length(), IA);
  }, h.prototype.int64 = h.prototype.uint64, h.prototype.sint64 = function(CA) {
    var IA = A.from(CA).zzEncode();
    return this._push(S, IA.length(), IA);
  }, h.prototype.bool = function(CA) {
    return this._push(k, 1, CA ? 1 : 0);
  };
  function AA(gA, CA, IA) {
    CA[IA] = gA & 255, CA[IA + 1] = gA >>> 8 & 255, CA[IA + 2] = gA >>> 16 & 255, CA[IA + 3] = gA >>> 24;
  }
  h.prototype.fixed32 = function(CA) {
    return this._push(AA, 4, CA >>> 0);
  }, h.prototype.sfixed32 = h.prototype.fixed32, h.prototype.fixed64 = function(CA) {
    var IA = A.from(CA);
    return this._push(AA, 4, IA.lo)._push(AA, 4, IA.hi);
  }, h.prototype.sfixed64 = h.prototype.fixed64, h.prototype.float = function(CA) {
    return this._push(o.float.writeFloatLE, 4, CA);
  }, h.prototype.double = function(CA) {
    return this._push(o.float.writeDoubleLE, 8, CA);
  };
  var H = o.Array.prototype.set ? function(CA, IA, BA) {
    IA.set(CA, BA);
  } : function(CA, IA, BA) {
    for (var QA = 0; QA < CA.length; ++QA)
      IA[BA + QA] = CA[QA];
  };
  return h.prototype.bytes = function(CA) {
    var IA = CA.length >>> 0;
    if (!IA)
      return this._push(k, 1, 0);
    if (o.isString(CA)) {
      var BA = h.alloc(IA = g.length(CA));
      g.decode(CA, BA, 0), CA = BA;
    }
    return this.uint32(IA)._push(H, IA, CA);
  }, h.prototype.string = function(CA) {
    var IA = e.length(CA);
    return IA ? this.uint32(IA)._push(e.write, IA, CA) : this._push(k, 1, 0);
  }, h.prototype.fork = function() {
    return this.states = new n(this), this.head = this.tail = new t(c, 0, 0), this.len = 0, this;
  }, h.prototype.reset = function() {
    return this.states ? (this.head = this.states.head, this.tail = this.states.tail, this.len = this.states.len, this.states = this.states.next) : (this.head = this.tail = new t(c, 0, 0), this.len = 0), this;
  }, h.prototype.ldelim = function() {
    var CA = this.head, IA = this.tail, BA = this.len;
    return this.reset().uint32(BA), BA && (this.tail.next = CA.next, this.tail = IA, this.len += BA), this;
  }, h.prototype.finish = function() {
    for (var CA = this.head.next, IA = this.constructor.alloc(this.len), BA = 0; CA; )
      CA.fn(CA.val, IA, BA), BA += CA.len, CA = CA.next;
    return IA;
  }, h._configure = function(gA) {
    E = gA, h.create = d(), E._configure();
  }, writer$1;
}
var writer_buffer$1, hasRequiredWriter_buffer$1;
function requireWriter_buffer$1() {
  if (hasRequiredWriter_buffer$1) return writer_buffer$1;
  hasRequiredWriter_buffer$1 = 1, writer_buffer$1 = A;
  var o = requireWriter$1();
  (A.prototype = Object.create(o.prototype)).constructor = A;
  var E = requireMinimal$3();
  function A() {
    o.call(this);
  }
  A._configure = function() {
    A.alloc = E._Buffer_allocUnsafe, A.writeBytesBuffer = E.Buffer && E.Buffer.prototype instanceof Uint8Array && E.Buffer.prototype.set.name === "set" ? function(t, c, n) {
      c.set(t, n);
    } : function(t, c, n) {
      if (t.copy)
        t.copy(c, n, 0, t.length);
      else for (var h = 0; h < t.length; )
        c[n++] = t[h++];
    };
  }, A.prototype.bytes = function(t) {
    E.isString(t) && (t = E._Buffer_from(t, "base64"));
    var c = t.length >>> 0;
    return this.uint32(c), c && this._push(A.writeBytesBuffer, c, t), this;
  };
  function g(e, t, c) {
    e.length < 40 ? E.utf8.write(e, t, c) : t.utf8Write ? t.utf8Write(e, c) : t.write(e, c);
  }
  return A.prototype.string = function(t) {
    var c = E.Buffer.byteLength(t);
    return this.uint32(c), c && this._push(g, c, t), this;
  }, A._configure(), writer_buffer$1;
}
var reader$1, hasRequiredReader$1;
function requireReader$1() {
  if (hasRequiredReader$1) return reader$1;
  hasRequiredReader$1 = 1, reader$1 = t;
  var o = requireMinimal$3(), E, A = o.LongBits, g = o.utf8;
  function e(p, M) {
    return RangeError("index out of range: " + p.pos + " + " + (M || 1) + " > " + p.len);
  }
  function t(p) {
    this.buf = p, this.pos = 0, this.len = p.length;
  }
  var c = typeof Uint8Array < "u" ? function(M) {
    if (M instanceof Uint8Array || Array.isArray(M))
      return new t(M);
    throw Error("illegal buffer");
  } : function(M) {
    if (Array.isArray(M))
      return new t(M);
    throw Error("illegal buffer");
  }, n = function() {
    return o.Buffer ? function(S) {
      return (t.create = function(H) {
        return o.Buffer.isBuffer(H) ? new E(H) : c(H);
      })(S);
    } : c;
  };
  t.create = n(), t.prototype._slice = o.Array.prototype.subarray || /* istanbul ignore next */
  o.Array.prototype.slice, t.prototype.uint32 = /* @__PURE__ */ (function() {
    var M = 4294967295;
    return function() {
      if (M = (this.buf[this.pos] & 127) >>> 0, this.buf[this.pos++] < 128 || (M = (M | (this.buf[this.pos] & 127) << 7) >>> 0, this.buf[this.pos++] < 128) || (M = (M | (this.buf[this.pos] & 127) << 14) >>> 0, this.buf[this.pos++] < 128) || (M = (M | (this.buf[this.pos] & 127) << 21) >>> 0, this.buf[this.pos++] < 128) || (M = (M | (this.buf[this.pos] & 15) << 28) >>> 0, this.buf[this.pos++] < 128)) return M;
      if ((this.pos += 5) > this.len)
        throw this.pos = this.len, e(this, 10);
      return M;
    };
  })(), t.prototype.int32 = function() {
    return this.uint32() | 0;
  }, t.prototype.sint32 = function() {
    var M = this.uint32();
    return M >>> 1 ^ -(M & 1) | 0;
  };
  function h() {
    var p = new A(0, 0), M = 0;
    if (this.len - this.pos > 4) {
      for (; M < 4; ++M)
        if (p.lo = (p.lo | (this.buf[this.pos] & 127) << M * 7) >>> 0, this.buf[this.pos++] < 128)
          return p;
      if (p.lo = (p.lo | (this.buf[this.pos] & 127) << 28) >>> 0, p.hi = (p.hi | (this.buf[this.pos] & 127) >> 4) >>> 0, this.buf[this.pos++] < 128)
        return p;
      M = 0;
    } else {
      for (; M < 3; ++M) {
        if (this.pos >= this.len)
          throw e(this);
        if (p.lo = (p.lo | (this.buf[this.pos] & 127) << M * 7) >>> 0, this.buf[this.pos++] < 128)
          return p;
      }
      return p.lo = (p.lo | (this.buf[this.pos++] & 127) << M * 7) >>> 0, p;
    }
    if (this.len - this.pos > 4) {
      for (; M < 5; ++M)
        if (p.hi = (p.hi | (this.buf[this.pos] & 127) << M * 7 + 3) >>> 0, this.buf[this.pos++] < 128)
          return p;
    } else
      for (; M < 5; ++M) {
        if (this.pos >= this.len)
          throw e(this);
        if (p.hi = (p.hi | (this.buf[this.pos] & 127) << M * 7 + 3) >>> 0, this.buf[this.pos++] < 128)
          return p;
      }
    throw Error("invalid varint encoding");
  }
  t.prototype.bool = function() {
    return this.uint32() !== 0;
  };
  function d(p, M) {
    return (p[M - 4] | p[M - 3] << 8 | p[M - 2] << 16 | p[M - 1] << 24) >>> 0;
  }
  t.prototype.fixed32 = function() {
    if (this.pos + 4 > this.len)
      throw e(this, 4);
    return d(this.buf, this.pos += 4);
  }, t.prototype.sfixed32 = function() {
    if (this.pos + 4 > this.len)
      throw e(this, 4);
    return d(this.buf, this.pos += 4) | 0;
  };
  function k() {
    if (this.pos + 8 > this.len)
      throw e(this, 8);
    return new A(d(this.buf, this.pos += 4), d(this.buf, this.pos += 4));
  }
  return t.prototype.float = function() {
    if (this.pos + 4 > this.len)
      throw e(this, 4);
    var M = o.float.readFloatLE(this.buf, this.pos);
    return this.pos += 4, M;
  }, t.prototype.double = function() {
    if (this.pos + 8 > this.len)
      throw e(this, 4);
    var M = o.float.readDoubleLE(this.buf, this.pos);
    return this.pos += 8, M;
  }, t.prototype.bytes = function() {
    var M = this.uint32(), S = this.pos, AA = this.pos + M;
    if (AA > this.len)
      throw e(this, M);
    if (this.pos += M, Array.isArray(this.buf))
      return this.buf.slice(S, AA);
    if (S === AA) {
      var H = o.Buffer;
      return H ? H.alloc(0) : new this.buf.constructor(0);
    }
    return this._slice.call(this.buf, S, AA);
  }, t.prototype.string = function() {
    var M = this.bytes();
    return g.read(M, 0, M.length);
  }, t.prototype.skip = function(M) {
    if (typeof M == "number") {
      if (this.pos + M > this.len)
        throw e(this, M);
      this.pos += M;
    } else
      do
        if (this.pos >= this.len)
          throw e(this);
      while (this.buf[this.pos++] & 128);
    return this;
  }, t.prototype.skipType = function(p) {
    switch (p) {
      case 0:
        this.skip();
        break;
      case 1:
        this.skip(8);
        break;
      case 2:
        this.skip(this.uint32());
        break;
      case 3:
        for (; (p = this.uint32() & 7) !== 4; )
          this.skipType(p);
        break;
      case 5:
        this.skip(4);
        break;
      /* istanbul ignore next */
      default:
        throw Error("invalid wire type " + p + " at offset " + this.pos);
    }
    return this;
  }, t._configure = function(p) {
    E = p, t.create = n(), E._configure();
    var M = o.Long ? "toLong" : (
      /* istanbul ignore next */
      "toNumber"
    );
    o.merge(t.prototype, {
      int64: function() {
        return h.call(this)[M](!1);
      },
      uint64: function() {
        return h.call(this)[M](!0);
      },
      sint64: function() {
        return h.call(this).zzDecode()[M](!1);
      },
      fixed64: function() {
        return k.call(this)[M](!0);
      },
      sfixed64: function() {
        return k.call(this)[M](!1);
      }
    });
  }, reader$1;
}
var reader_buffer$1, hasRequiredReader_buffer$1;
function requireReader_buffer$1() {
  if (hasRequiredReader_buffer$1) return reader_buffer$1;
  hasRequiredReader_buffer$1 = 1, reader_buffer$1 = A;
  var o = requireReader$1();
  (A.prototype = Object.create(o.prototype)).constructor = A;
  var E = requireMinimal$3();
  function A(g) {
    o.call(this, g);
  }
  return A._configure = function() {
    E.Buffer && (A.prototype._slice = E.Buffer.prototype.slice);
  }, A.prototype.string = function() {
    var e = this.uint32();
    return this.buf.utf8Slice ? this.buf.utf8Slice(this.pos, this.pos = Math.min(this.pos + e, this.len)) : this.buf.toString("utf-8", this.pos, this.pos = Math.min(this.pos + e, this.len));
  }, A._configure(), reader_buffer$1;
}
var rpc$1 = {}, service$2, hasRequiredService$2;
function requireService$2() {
  if (hasRequiredService$2) return service$2;
  hasRequiredService$2 = 1, service$2 = E;
  var o = requireMinimal$3();
  (E.prototype = Object.create(o.EventEmitter.prototype)).constructor = E;
  function E(A, g, e) {
    if (typeof A != "function")
      throw TypeError("rpcImpl must be a function");
    o.EventEmitter.call(this), this.rpcImpl = A, this.requestDelimited = !!g, this.responseDelimited = !!e;
  }
  return E.prototype.rpcCall = function A(g, e, t, c, n) {
    if (!c)
      throw TypeError("request must be specified");
    var h = this;
    if (!n)
      return o.asPromise(A, h, g, e, t, c);
    if (!h.rpcImpl) {
      setTimeout(function() {
        n(Error("already ended"));
      }, 0);
      return;
    }
    try {
      return h.rpcImpl(
        g,
        e[h.requestDelimited ? "encodeDelimited" : "encode"](c).finish(),
        function(k, p) {
          if (k)
            return h.emit("error", k, g), n(k);
          if (p === null) {
            h.end(
              /* endedByRPC */
              !0
            );
            return;
          }
          if (!(p instanceof t))
            try {
              p = t[h.responseDelimited ? "decodeDelimited" : "decode"](p);
            } catch (M) {
              return h.emit("error", M, g), n(M);
            }
          return h.emit("data", p, g), n(null, p);
        }
      );
    } catch (d) {
      h.emit("error", d, g), setTimeout(function() {
        n(d);
      }, 0);
      return;
    }
  }, E.prototype.end = function(g) {
    return this.rpcImpl && (g || this.rpcImpl(null, null, null), this.rpcImpl = null, this.emit("end").off()), this;
  }, service$2;
}
var hasRequiredRpc$1;
function requireRpc$1() {
  return hasRequiredRpc$1 || (hasRequiredRpc$1 = 1, (function(o) {
    var E = o;
    E.Service = requireService$2();
  })(rpc$1)), rpc$1;
}
var roots$1, hasRequiredRoots$1;
function requireRoots$1() {
  return hasRequiredRoots$1 || (hasRequiredRoots$1 = 1, roots$1 = {}), roots$1;
}
var hasRequiredIndexMinimal$1;
function requireIndexMinimal$1() {
  return hasRequiredIndexMinimal$1 || (hasRequiredIndexMinimal$1 = 1, (function(o) {
    var E = o;
    E.build = "minimal", E.Writer = requireWriter$1(), E.BufferWriter = requireWriter_buffer$1(), E.Reader = requireReader$1(), E.BufferReader = requireReader_buffer$1(), E.util = requireMinimal$3(), E.rpc = requireRpc$1(), E.roots = requireRoots$1(), E.configure = A;
    function A() {
      E.util._configure(), E.Writer._configure(E.BufferWriter), E.Reader._configure(E.BufferReader);
    }
    A();
  })(indexMinimal$1)), indexMinimal$1;
}
var minimal$2, hasRequiredMinimal$2;
function requireMinimal$2() {
  return hasRequiredMinimal$2 || (hasRequiredMinimal$2 = 1, minimal$2 = requireIndexMinimal$1()), minimal$2;
}
var minimalExports$1 = requireMinimal$2();
const $Reader$1 = minimalExports$1.Reader, $Writer$1 = minimalExports$1.Writer, $util$1 = minimalExports$1.util, $root$1 = minimalExports$1.roots.default || (minimalExports$1.roots.default = {}), Alert = $root$1.Alert = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.body = "", o.prototype.format = 0, o.prototype.icon = "", o.prototype.widthConfig = null, o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    return g || (g = $Writer$1.create()), A.body != null && Object.hasOwnProperty.call(A, "body") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(A.body), A.format != null && Object.hasOwnProperty.call(A, "format") && g.uint32(
      /* id 2, wireType 0 =*/
      16
    ).int32(A.format), A.icon != null && Object.hasOwnProperty.call(A, "icon") && g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(A.icon), A.widthConfig != null && Object.hasOwnProperty.call(A, "widthConfig") && $root$1.streamlit.WidthConfig.encode(A.widthConfig, g.uint32(
      /* id 4, wireType 2 =*/
      34
    ).fork()).ldelim(), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader$1 || (A = $Reader$1.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root$1.Alert();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.body = A.string();
          break;
        }
        case 2: {
          c.format = A.int32();
          break;
        }
        case 3: {
          c.icon = A.string();
          break;
        }
        case 4: {
          c.widthConfig = $root$1.streamlit.WidthConfig.decode(A, A.uint32());
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root$1.Alert) return A;
    let g = new $root$1.Alert();
    switch (A.body != null && (g.body = String(A.body)), A.format) {
      default:
        if (typeof A.format == "number") {
          g.format = A.format;
          break;
        }
        break;
      case "UNUSED":
      case 0:
        g.format = 0;
        break;
      case "ERROR":
      case 1:
        g.format = 1;
        break;
      case "WARNING":
      case 2:
        g.format = 2;
        break;
      case "INFO":
      case 3:
        g.format = 3;
        break;
      case "SUCCESS":
      case 4:
        g.format = 4;
        break;
    }
    if (A.icon != null && (g.icon = String(A.icon)), A.widthConfig != null) {
      if (typeof A.widthConfig != "object") throw TypeError(".Alert.widthConfig: object expected");
      g.widthConfig = $root$1.streamlit.WidthConfig.fromObject(A.widthConfig);
    }
    return g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    return g.defaults && (e.body = "", e.format = g.enums === String ? "UNUSED" : 0, e.icon = "", e.widthConfig = null), A.body != null && A.hasOwnProperty("body") && (e.body = A.body), A.format != null && A.hasOwnProperty("format") && (e.format = g.enums === String ? $root$1.Alert.Format[A.format] === void 0 ? A.format : $root$1.Alert.Format[A.format] : A.format), A.icon != null && A.hasOwnProperty("icon") && (e.icon = A.icon), A.widthConfig != null && A.hasOwnProperty("widthConfig") && (e.widthConfig = $root$1.streamlit.WidthConfig.toObject(A.widthConfig, g)), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/Alert";
  }, o.Format = (function() {
    const E = {}, A = Object.create(E);
    return A[E[0] = "UNUSED"] = 0, A[E[1] = "ERROR"] = 1, A[E[2] = "WARNING"] = 2, A[E[3] = "INFO"] = 3, A[E[4] = "SUCCESS"] = 4, A;
  })(), o;
})(), streamlit = $root$1.streamlit = (() => {
  const o = {};
  return o.WidthConfig = (function() {
    function E(g) {
      if (g) for (let e = Object.keys(g), t = 0; t < e.length; ++t) g[e[t]] != null && (this[e[t]] = g[e[t]]);
    }
    E.prototype.useStretch = null, E.prototype.useContent = null, E.prototype.pixelWidth = null, E.prototype.remWidth = null;
    let A;
    return Object.defineProperty(E.prototype, "widthSpec", { get: $util$1.oneOfGetter(A = ["useStretch", "useContent", "pixelWidth", "remWidth"]), set: $util$1.oneOfSetter(A) }), E.create = function(e) {
      return new E(e);
    }, E.encode = function(e, t) {
      return t || (t = $Writer$1.create()), e.useStretch != null && Object.hasOwnProperty.call(e, "useStretch") && t.uint32(
        /* id 1, wireType 0 =*/
        8
      ).bool(e.useStretch), e.useContent != null && Object.hasOwnProperty.call(e, "useContent") && t.uint32(
        /* id 2, wireType 0 =*/
        16
      ).bool(e.useContent), e.pixelWidth != null && Object.hasOwnProperty.call(e, "pixelWidth") && t.uint32(
        /* id 3, wireType 0 =*/
        24
      ).uint32(e.pixelWidth), e.remWidth != null && Object.hasOwnProperty.call(e, "remWidth") && t.uint32(
        /* id 4, wireType 5 =*/
        37
      ).float(e.remWidth), t;
    }, E.decode = function(e, t, c) {
      e instanceof $Reader$1 || (e = $Reader$1.create(e));
      let n = t === void 0 ? e.len : e.pos + t, h = new $root$1.streamlit.WidthConfig();
      for (; e.pos < n; ) {
        let d = e.uint32();
        if (d === c) break;
        switch (d >>> 3) {
          case 1: {
            h.useStretch = e.bool();
            break;
          }
          case 2: {
            h.useContent = e.bool();
            break;
          }
          case 3: {
            h.pixelWidth = e.uint32();
            break;
          }
          case 4: {
            h.remWidth = e.float();
            break;
          }
          default:
            e.skipType(d & 7);
            break;
        }
      }
      return h;
    }, E.fromObject = function(e) {
      if (e instanceof $root$1.streamlit.WidthConfig) return e;
      let t = new $root$1.streamlit.WidthConfig();
      return e.useStretch != null && (t.useStretch = !!e.useStretch), e.useContent != null && (t.useContent = !!e.useContent), e.pixelWidth != null && (t.pixelWidth = e.pixelWidth >>> 0), e.remWidth != null && (t.remWidth = Number(e.remWidth)), t;
    }, E.toObject = function(e, t) {
      t || (t = {});
      let c = {};
      return e.useStretch != null && e.hasOwnProperty("useStretch") && (c.useStretch = e.useStretch, t.oneofs && (c.widthSpec = "useStretch")), e.useContent != null && e.hasOwnProperty("useContent") && (c.useContent = e.useContent, t.oneofs && (c.widthSpec = "useContent")), e.pixelWidth != null && e.hasOwnProperty("pixelWidth") && (c.pixelWidth = e.pixelWidth, t.oneofs && (c.widthSpec = "pixelWidth")), e.remWidth != null && e.hasOwnProperty("remWidth") && (c.remWidth = t.json && !isFinite(e.remWidth) ? String(e.remWidth) : e.remWidth, t.oneofs && (c.widthSpec = "remWidth")), c;
    }, E.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
    }, E.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/streamlit.WidthConfig";
    }, E;
  })(), o.HeightConfig = (function() {
    function E(g) {
      if (g) for (let e = Object.keys(g), t = 0; t < e.length; ++t) g[e[t]] != null && (this[e[t]] = g[e[t]]);
    }
    E.prototype.useStretch = null, E.prototype.useContent = null, E.prototype.pixelHeight = null, E.prototype.remHeight = null;
    let A;
    return Object.defineProperty(E.prototype, "heightSpec", { get: $util$1.oneOfGetter(A = ["useStretch", "useContent", "pixelHeight", "remHeight"]), set: $util$1.oneOfSetter(A) }), E.create = function(e) {
      return new E(e);
    }, E.encode = function(e, t) {
      return t || (t = $Writer$1.create()), e.useStretch != null && Object.hasOwnProperty.call(e, "useStretch") && t.uint32(
        /* id 1, wireType 0 =*/
        8
      ).bool(e.useStretch), e.useContent != null && Object.hasOwnProperty.call(e, "useContent") && t.uint32(
        /* id 2, wireType 0 =*/
        16
      ).bool(e.useContent), e.pixelHeight != null && Object.hasOwnProperty.call(e, "pixelHeight") && t.uint32(
        /* id 3, wireType 0 =*/
        24
      ).uint32(e.pixelHeight), e.remHeight != null && Object.hasOwnProperty.call(e, "remHeight") && t.uint32(
        /* id 4, wireType 5 =*/
        37
      ).float(e.remHeight), t;
    }, E.decode = function(e, t, c) {
      e instanceof $Reader$1 || (e = $Reader$1.create(e));
      let n = t === void 0 ? e.len : e.pos + t, h = new $root$1.streamlit.HeightConfig();
      for (; e.pos < n; ) {
        let d = e.uint32();
        if (d === c) break;
        switch (d >>> 3) {
          case 1: {
            h.useStretch = e.bool();
            break;
          }
          case 2: {
            h.useContent = e.bool();
            break;
          }
          case 3: {
            h.pixelHeight = e.uint32();
            break;
          }
          case 4: {
            h.remHeight = e.float();
            break;
          }
          default:
            e.skipType(d & 7);
            break;
        }
      }
      return h;
    }, E.fromObject = function(e) {
      if (e instanceof $root$1.streamlit.HeightConfig) return e;
      let t = new $root$1.streamlit.HeightConfig();
      return e.useStretch != null && (t.useStretch = !!e.useStretch), e.useContent != null && (t.useContent = !!e.useContent), e.pixelHeight != null && (t.pixelHeight = e.pixelHeight >>> 0), e.remHeight != null && (t.remHeight = Number(e.remHeight)), t;
    }, E.toObject = function(e, t) {
      t || (t = {});
      let c = {};
      return e.useStretch != null && e.hasOwnProperty("useStretch") && (c.useStretch = e.useStretch, t.oneofs && (c.heightSpec = "useStretch")), e.useContent != null && e.hasOwnProperty("useContent") && (c.useContent = e.useContent, t.oneofs && (c.heightSpec = "useContent")), e.pixelHeight != null && e.hasOwnProperty("pixelHeight") && (c.pixelHeight = e.pixelHeight, t.oneofs && (c.heightSpec = "pixelHeight")), e.remHeight != null && e.hasOwnProperty("remHeight") && (c.remHeight = t.json && !isFinite(e.remHeight) ? String(e.remHeight) : e.remHeight, t.oneofs && (c.heightSpec = "remHeight")), c;
    }, E.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
    }, E.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/streamlit.HeightConfig";
    }, E;
  })(), o.GapSize = (function() {
    const E = {}, A = Object.create(E);
    return A[E[0] = "GAP_UNDEFINED"] = 0, A[E[1] = "SMALL"] = 1, A[E[2] = "MEDIUM"] = 2, A[E[3] = "LARGE"] = 3, A[E[4] = "NONE"] = 4, A;
  })(), o.GapConfig = (function() {
    function E(g) {
      if (g) for (let e = Object.keys(g), t = 0; t < e.length; ++t) g[e[t]] != null && (this[e[t]] = g[e[t]]);
    }
    E.prototype.gapSize = null;
    let A;
    return Object.defineProperty(E.prototype, "gapSpec", { get: $util$1.oneOfGetter(A = ["gapSize"]), set: $util$1.oneOfSetter(A) }), E.create = function(e) {
      return new E(e);
    }, E.encode = function(e, t) {
      return t || (t = $Writer$1.create()), e.gapSize != null && Object.hasOwnProperty.call(e, "gapSize") && t.uint32(
        /* id 1, wireType 0 =*/
        8
      ).int32(e.gapSize), t;
    }, E.decode = function(e, t, c) {
      e instanceof $Reader$1 || (e = $Reader$1.create(e));
      let n = t === void 0 ? e.len : e.pos + t, h = new $root$1.streamlit.GapConfig();
      for (; e.pos < n; ) {
        let d = e.uint32();
        if (d === c) break;
        switch (d >>> 3) {
          case 1: {
            h.gapSize = e.int32();
            break;
          }
          default:
            e.skipType(d & 7);
            break;
        }
      }
      return h;
    }, E.fromObject = function(e) {
      if (e instanceof $root$1.streamlit.GapConfig) return e;
      let t = new $root$1.streamlit.GapConfig();
      switch (e.gapSize) {
        default:
          if (typeof e.gapSize == "number") {
            t.gapSize = e.gapSize;
            break;
          }
          break;
        case "GAP_UNDEFINED":
        case 0:
          t.gapSize = 0;
          break;
        case "SMALL":
        case 1:
          t.gapSize = 1;
          break;
        case "MEDIUM":
        case 2:
          t.gapSize = 2;
          break;
        case "LARGE":
        case 3:
          t.gapSize = 3;
          break;
        case "NONE":
        case 4:
          t.gapSize = 4;
          break;
      }
      return t;
    }, E.toObject = function(e, t) {
      t || (t = {});
      let c = {};
      return e.gapSize != null && e.hasOwnProperty("gapSize") && (c.gapSize = t.enums === String ? $root$1.streamlit.GapSize[e.gapSize] === void 0 ? e.gapSize : $root$1.streamlit.GapSize[e.gapSize] : e.gapSize, t.oneofs && (c.gapSpec = "gapSize")), c;
    }, E.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
    }, E.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/streamlit.GapConfig";
    }, E;
  })(), o.TextAlignmentConfig = (function() {
    function E(A) {
      if (A) for (let g = Object.keys(A), e = 0; e < g.length; ++e) A[g[e]] != null && (this[g[e]] = A[g[e]]);
    }
    return E.prototype.alignment = 0, E.create = function(g) {
      return new E(g);
    }, E.encode = function(g, e) {
      return e || (e = $Writer$1.create()), g.alignment != null && Object.hasOwnProperty.call(g, "alignment") && e.uint32(
        /* id 1, wireType 0 =*/
        8
      ).int32(g.alignment), e;
    }, E.decode = function(g, e, t) {
      g instanceof $Reader$1 || (g = $Reader$1.create(g));
      let c = e === void 0 ? g.len : g.pos + e, n = new $root$1.streamlit.TextAlignmentConfig();
      for (; g.pos < c; ) {
        let h = g.uint32();
        if (h === t) break;
        switch (h >>> 3) {
          case 1: {
            n.alignment = g.int32();
            break;
          }
          default:
            g.skipType(h & 7);
            break;
        }
      }
      return n;
    }, E.fromObject = function(g) {
      if (g instanceof $root$1.streamlit.TextAlignmentConfig) return g;
      let e = new $root$1.streamlit.TextAlignmentConfig();
      switch (g.alignment) {
        default:
          if (typeof g.alignment == "number") {
            e.alignment = g.alignment;
            break;
          }
          break;
        case "UNSPECIFIED":
        case 0:
          e.alignment = 0;
          break;
        case "LEFT":
        case 1:
          e.alignment = 1;
          break;
        case "CENTER":
        case 2:
          e.alignment = 2;
          break;
        case "RIGHT":
        case 3:
          e.alignment = 3;
          break;
        case "JUSTIFY":
        case 4:
          e.alignment = 4;
          break;
      }
      return e;
    }, E.toObject = function(g, e) {
      e || (e = {});
      let t = {};
      return e.defaults && (t.alignment = e.enums === String ? "UNSPECIFIED" : 0), g.alignment != null && g.hasOwnProperty("alignment") && (t.alignment = e.enums === String ? $root$1.streamlit.TextAlignmentConfig.Alignment[g.alignment] === void 0 ? g.alignment : $root$1.streamlit.TextAlignmentConfig.Alignment[g.alignment] : g.alignment), t;
    }, E.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
    }, E.getTypeUrl = function(g) {
      return g === void 0 && (g = "type.googleapis.com"), g + "/streamlit.TextAlignmentConfig";
    }, E.Alignment = (function() {
      const A = {}, g = Object.create(A);
      return g[A[0] = "UNSPECIFIED"] = 0, g[A[1] = "LEFT"] = 1, g[A[2] = "CENTER"] = 2, g[A[3] = "RIGHT"] = 3, g[A[4] = "JUSTIFY"] = 4, g;
    })(), E;
  })(), o;
})();
$root$1.AppPage = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.pageScriptHash = "", o.prototype.pageName = "", o.prototype.icon = "", o.prototype.isDefault = !1, o.prototype.sectionHeader = "", o.prototype.urlPathname = "", o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    return g || (g = $Writer$1.create()), A.pageScriptHash != null && Object.hasOwnProperty.call(A, "pageScriptHash") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(A.pageScriptHash), A.pageName != null && Object.hasOwnProperty.call(A, "pageName") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(A.pageName), A.icon != null && Object.hasOwnProperty.call(A, "icon") && g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(A.icon), A.isDefault != null && Object.hasOwnProperty.call(A, "isDefault") && g.uint32(
      /* id 4, wireType 0 =*/
      32
    ).bool(A.isDefault), A.sectionHeader != null && Object.hasOwnProperty.call(A, "sectionHeader") && g.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(A.sectionHeader), A.urlPathname != null && Object.hasOwnProperty.call(A, "urlPathname") && g.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(A.urlPathname), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader$1 || (A = $Reader$1.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root$1.AppPage();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.pageScriptHash = A.string();
          break;
        }
        case 2: {
          c.pageName = A.string();
          break;
        }
        case 3: {
          c.icon = A.string();
          break;
        }
        case 4: {
          c.isDefault = A.bool();
          break;
        }
        case 5: {
          c.sectionHeader = A.string();
          break;
        }
        case 6: {
          c.urlPathname = A.string();
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root$1.AppPage) return A;
    let g = new $root$1.AppPage();
    return A.pageScriptHash != null && (g.pageScriptHash = String(A.pageScriptHash)), A.pageName != null && (g.pageName = String(A.pageName)), A.icon != null && (g.icon = String(A.icon)), A.isDefault != null && (g.isDefault = !!A.isDefault), A.sectionHeader != null && (g.sectionHeader = String(A.sectionHeader)), A.urlPathname != null && (g.urlPathname = String(A.urlPathname)), g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    return g.defaults && (e.pageScriptHash = "", e.pageName = "", e.icon = "", e.isDefault = !1, e.sectionHeader = "", e.urlPathname = ""), A.pageScriptHash != null && A.hasOwnProperty("pageScriptHash") && (e.pageScriptHash = A.pageScriptHash), A.pageName != null && A.hasOwnProperty("pageName") && (e.pageName = A.pageName), A.icon != null && A.hasOwnProperty("icon") && (e.icon = A.icon), A.isDefault != null && A.hasOwnProperty("isDefault") && (e.isDefault = A.isDefault), A.sectionHeader != null && A.hasOwnProperty("sectionHeader") && (e.sectionHeader = A.sectionHeader), A.urlPathname != null && A.hasOwnProperty("urlPathname") && (e.urlPathname = A.urlPathname), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/AppPage";
  }, o;
})();
const Arrow$2 = $root$1.Arrow = (() => {
  function o(A) {
    if (this.columnOrder = [], this.selectionMode = [], A) for (let g = Object.keys(A), e = 0; e < g.length; ++e) A[g[e]] != null && (this[g[e]] = A[g[e]]);
  }
  o.prototype.data = $util$1.newBuffer([]), o.prototype.styler = null, o.prototype.width = 0, o.prototype.height = 0, o.prototype.useContainerWidth = !1, o.prototype.id = "", o.prototype.columns = "", o.prototype.editingMode = 0, o.prototype.disabled = !1, o.prototype.formId = "", o.prototype.columnOrder = $util$1.emptyArray, o.prototype.selectionMode = $util$1.emptyArray, o.prototype.rowHeight = null, o.prototype.borderMode = 0, o.prototype.placeholder = null;
  let E;
  return Object.defineProperty(o.prototype, "_rowHeight", { get: $util$1.oneOfGetter(E = ["rowHeight"]), set: $util$1.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_placeholder", { get: $util$1.oneOfGetter(E = ["placeholder"]), set: $util$1.oneOfSetter(E) }), o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, e) {
    if (e || (e = $Writer$1.create()), g.data != null && Object.hasOwnProperty.call(g, "data") && e.uint32(
      /* id 1, wireType 2 =*/
      10
    ).bytes(g.data), g.styler != null && Object.hasOwnProperty.call(g, "styler") && $root$1.Styler.encode(g.styler, e.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), g.width != null && Object.hasOwnProperty.call(g, "width") && e.uint32(
      /* id 3, wireType 0 =*/
      24
    ).uint32(g.width), g.height != null && Object.hasOwnProperty.call(g, "height") && e.uint32(
      /* id 4, wireType 0 =*/
      32
    ).uint32(g.height), g.useContainerWidth != null && Object.hasOwnProperty.call(g, "useContainerWidth") && e.uint32(
      /* id 5, wireType 0 =*/
      40
    ).bool(g.useContainerWidth), g.id != null && Object.hasOwnProperty.call(g, "id") && e.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(g.id), g.columns != null && Object.hasOwnProperty.call(g, "columns") && e.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(g.columns), g.editingMode != null && Object.hasOwnProperty.call(g, "editingMode") && e.uint32(
      /* id 8, wireType 0 =*/
      64
    ).int32(g.editingMode), g.disabled != null && Object.hasOwnProperty.call(g, "disabled") && e.uint32(
      /* id 9, wireType 0 =*/
      72
    ).bool(g.disabled), g.formId != null && Object.hasOwnProperty.call(g, "formId") && e.uint32(
      /* id 10, wireType 2 =*/
      82
    ).string(g.formId), g.columnOrder != null && g.columnOrder.length) for (let t = 0; t < g.columnOrder.length; ++t) e.uint32(
      /* id 11, wireType 2 =*/
      90
    ).string(g.columnOrder[t]);
    if (g.selectionMode != null && g.selectionMode.length) {
      e.uint32(
        /* id 12, wireType 2 =*/
        98
      ).fork();
      for (let t = 0; t < g.selectionMode.length; ++t) e.int32(g.selectionMode[t]);
      e.ldelim();
    }
    return g.rowHeight != null && Object.hasOwnProperty.call(g, "rowHeight") && e.uint32(
      /* id 13, wireType 0 =*/
      104
    ).uint32(g.rowHeight), g.borderMode != null && Object.hasOwnProperty.call(g, "borderMode") && e.uint32(
      /* id 14, wireType 0 =*/
      112
    ).int32(g.borderMode), g.placeholder != null && Object.hasOwnProperty.call(g, "placeholder") && e.uint32(
      /* id 15, wireType 2 =*/
      122
    ).string(g.placeholder), e;
  }, o.decode = function(g, e, t) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let c = e === void 0 ? g.len : g.pos + e, n = new $root$1.Arrow();
    for (; g.pos < c; ) {
      let h = g.uint32();
      if (h === t) break;
      switch (h >>> 3) {
        case 1: {
          n.data = g.bytes();
          break;
        }
        case 2: {
          n.styler = $root$1.Styler.decode(g, g.uint32());
          break;
        }
        case 3: {
          n.width = g.uint32();
          break;
        }
        case 4: {
          n.height = g.uint32();
          break;
        }
        case 5: {
          n.useContainerWidth = g.bool();
          break;
        }
        case 6: {
          n.id = g.string();
          break;
        }
        case 7: {
          n.columns = g.string();
          break;
        }
        case 8: {
          n.editingMode = g.int32();
          break;
        }
        case 9: {
          n.disabled = g.bool();
          break;
        }
        case 10: {
          n.formId = g.string();
          break;
        }
        case 11: {
          n.columnOrder && n.columnOrder.length || (n.columnOrder = []), n.columnOrder.push(g.string());
          break;
        }
        case 12: {
          if (n.selectionMode && n.selectionMode.length || (n.selectionMode = []), (h & 7) === 2) {
            let d = g.uint32() + g.pos;
            for (; g.pos < d; ) n.selectionMode.push(g.int32());
          } else n.selectionMode.push(g.int32());
          break;
        }
        case 13: {
          n.rowHeight = g.uint32();
          break;
        }
        case 14: {
          n.borderMode = g.int32();
          break;
        }
        case 15: {
          n.placeholder = g.string();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.Arrow) return g;
    let e = new $root$1.Arrow();
    if (g.data != null && (typeof g.data == "string" ? $util$1.base64.decode(g.data, e.data = $util$1.newBuffer($util$1.base64.length(g.data)), 0) : g.data.length >= 0 && (e.data = g.data)), g.styler != null) {
      if (typeof g.styler != "object") throw TypeError(".Arrow.styler: object expected");
      e.styler = $root$1.Styler.fromObject(g.styler);
    }
    switch (g.width != null && (e.width = g.width >>> 0), g.height != null && (e.height = g.height >>> 0), g.useContainerWidth != null && (e.useContainerWidth = !!g.useContainerWidth), g.id != null && (e.id = String(g.id)), g.columns != null && (e.columns = String(g.columns)), g.editingMode) {
      default:
        if (typeof g.editingMode == "number") {
          e.editingMode = g.editingMode;
          break;
        }
        break;
      case "READ_ONLY":
      case 0:
        e.editingMode = 0;
        break;
      case "FIXED":
      case 1:
        e.editingMode = 1;
        break;
      case "DYNAMIC":
      case 2:
        e.editingMode = 2;
        break;
    }
    if (g.disabled != null && (e.disabled = !!g.disabled), g.formId != null && (e.formId = String(g.formId)), g.columnOrder) {
      if (!Array.isArray(g.columnOrder)) throw TypeError(".Arrow.columnOrder: array expected");
      e.columnOrder = [];
      for (let t = 0; t < g.columnOrder.length; ++t) e.columnOrder[t] = String(g.columnOrder[t]);
    }
    if (g.selectionMode) {
      if (!Array.isArray(g.selectionMode)) throw TypeError(".Arrow.selectionMode: array expected");
      e.selectionMode = [];
      for (let t = 0; t < g.selectionMode.length; ++t) switch (g.selectionMode[t]) {
        default:
          if (typeof g.selectionMode[t] == "number") {
            e.selectionMode[t] = g.selectionMode[t];
            break;
          }
        case "SINGLE_ROW":
        case 0:
          e.selectionMode[t] = 0;
          break;
        case "MULTI_ROW":
        case 1:
          e.selectionMode[t] = 1;
          break;
        case "SINGLE_COLUMN":
        case 2:
          e.selectionMode[t] = 2;
          break;
        case "MULTI_COLUMN":
        case 3:
          e.selectionMode[t] = 3;
          break;
        case "SINGLE_CELL":
        case 4:
          e.selectionMode[t] = 4;
          break;
        case "MULTI_CELL":
        case 5:
          e.selectionMode[t] = 5;
          break;
      }
    }
    switch (g.rowHeight != null && (e.rowHeight = g.rowHeight >>> 0), g.borderMode) {
      default:
        if (typeof g.borderMode == "number") {
          e.borderMode = g.borderMode;
          break;
        }
        break;
      case "ALL":
      case 0:
        e.borderMode = 0;
        break;
      case "NONE":
      case 1:
        e.borderMode = 1;
        break;
      case "HORIZONTAL":
      case 2:
        e.borderMode = 2;
        break;
    }
    return g.placeholder != null && (e.placeholder = String(g.placeholder)), e;
  }, o.toObject = function(g, e) {
    e || (e = {});
    let t = {};
    if ((e.arrays || e.defaults) && (t.columnOrder = [], t.selectionMode = []), e.defaults && (e.bytes === String ? t.data = "" : (t.data = [], e.bytes !== Array && (t.data = $util$1.newBuffer(t.data))), t.styler = null, t.width = 0, t.height = 0, t.useContainerWidth = !1, t.id = "", t.columns = "", t.editingMode = e.enums === String ? "READ_ONLY" : 0, t.disabled = !1, t.formId = "", t.borderMode = e.enums === String ? "ALL" : 0), g.data != null && g.hasOwnProperty("data") && (t.data = e.bytes === String ? $util$1.base64.encode(g.data, 0, g.data.length) : e.bytes === Array ? Array.prototype.slice.call(g.data) : g.data), g.styler != null && g.hasOwnProperty("styler") && (t.styler = $root$1.Styler.toObject(g.styler, e)), g.width != null && g.hasOwnProperty("width") && (t.width = g.width), g.height != null && g.hasOwnProperty("height") && (t.height = g.height), g.useContainerWidth != null && g.hasOwnProperty("useContainerWidth") && (t.useContainerWidth = g.useContainerWidth), g.id != null && g.hasOwnProperty("id") && (t.id = g.id), g.columns != null && g.hasOwnProperty("columns") && (t.columns = g.columns), g.editingMode != null && g.hasOwnProperty("editingMode") && (t.editingMode = e.enums === String ? $root$1.Arrow.EditingMode[g.editingMode] === void 0 ? g.editingMode : $root$1.Arrow.EditingMode[g.editingMode] : g.editingMode), g.disabled != null && g.hasOwnProperty("disabled") && (t.disabled = g.disabled), g.formId != null && g.hasOwnProperty("formId") && (t.formId = g.formId), g.columnOrder && g.columnOrder.length) {
      t.columnOrder = [];
      for (let c = 0; c < g.columnOrder.length; ++c) t.columnOrder[c] = g.columnOrder[c];
    }
    if (g.selectionMode && g.selectionMode.length) {
      t.selectionMode = [];
      for (let c = 0; c < g.selectionMode.length; ++c) t.selectionMode[c] = e.enums === String ? $root$1.Arrow.SelectionMode[g.selectionMode[c]] === void 0 ? g.selectionMode[c] : $root$1.Arrow.SelectionMode[g.selectionMode[c]] : g.selectionMode[c];
    }
    return g.rowHeight != null && g.hasOwnProperty("rowHeight") && (t.rowHeight = g.rowHeight, e.oneofs && (t._rowHeight = "rowHeight")), g.borderMode != null && g.hasOwnProperty("borderMode") && (t.borderMode = e.enums === String ? $root$1.Arrow.BorderMode[g.borderMode] === void 0 ? g.borderMode : $root$1.Arrow.BorderMode[g.borderMode] : g.borderMode), g.placeholder != null && g.hasOwnProperty("placeholder") && (t.placeholder = g.placeholder, e.oneofs && (t._placeholder = "placeholder")), t;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/Arrow";
  }, o.EditingMode = (function() {
    const A = {}, g = Object.create(A);
    return g[A[0] = "READ_ONLY"] = 0, g[A[1] = "FIXED"] = 1, g[A[2] = "DYNAMIC"] = 2, g;
  })(), o.SelectionMode = (function() {
    const A = {}, g = Object.create(A);
    return g[A[0] = "SINGLE_ROW"] = 0, g[A[1] = "MULTI_ROW"] = 1, g[A[2] = "SINGLE_COLUMN"] = 2, g[A[3] = "MULTI_COLUMN"] = 3, g[A[4] = "SINGLE_CELL"] = 4, g[A[5] = "MULTI_CELL"] = 5, g;
  })(), o.BorderMode = (function() {
    const A = {}, g = Object.create(A);
    return g[A[0] = "ALL"] = 0, g[A[1] = "NONE"] = 1, g[A[2] = "HORIZONTAL"] = 2, g;
  })(), o;
})();
$root$1.Styler = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.uuid = "", o.prototype.caption = "", o.prototype.styles = "", o.prototype.displayValues = $util$1.newBuffer([]), o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    return g || (g = $Writer$1.create()), A.uuid != null && Object.hasOwnProperty.call(A, "uuid") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(A.uuid), A.caption != null && Object.hasOwnProperty.call(A, "caption") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(A.caption), A.styles != null && Object.hasOwnProperty.call(A, "styles") && g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(A.styles), A.displayValues != null && Object.hasOwnProperty.call(A, "displayValues") && g.uint32(
      /* id 4, wireType 2 =*/
      34
    ).bytes(A.displayValues), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader$1 || (A = $Reader$1.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root$1.Styler();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.uuid = A.string();
          break;
        }
        case 2: {
          c.caption = A.string();
          break;
        }
        case 3: {
          c.styles = A.string();
          break;
        }
        case 4: {
          c.displayValues = A.bytes();
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root$1.Styler) return A;
    let g = new $root$1.Styler();
    return A.uuid != null && (g.uuid = String(A.uuid)), A.caption != null && (g.caption = String(A.caption)), A.styles != null && (g.styles = String(A.styles)), A.displayValues != null && (typeof A.displayValues == "string" ? $util$1.base64.decode(A.displayValues, g.displayValues = $util$1.newBuffer($util$1.base64.length(A.displayValues)), 0) : A.displayValues.length >= 0 && (g.displayValues = A.displayValues)), g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    return g.defaults && (e.uuid = "", e.caption = "", e.styles = "", g.bytes === String ? e.displayValues = "" : (e.displayValues = [], g.bytes !== Array && (e.displayValues = $util$1.newBuffer(e.displayValues)))), A.uuid != null && A.hasOwnProperty("uuid") && (e.uuid = A.uuid), A.caption != null && A.hasOwnProperty("caption") && (e.caption = A.caption), A.styles != null && A.hasOwnProperty("styles") && (e.styles = A.styles), A.displayValues != null && A.hasOwnProperty("displayValues") && (e.displayValues = g.bytes === String ? $util$1.base64.encode(A.displayValues, 0, A.displayValues.length) : g.bytes === Array ? Array.prototype.slice.call(A.displayValues) : A.displayValues), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/Styler";
  }, o;
})();
$root$1.ArrowData = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.data = $util$1.newBuffer([]), o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    return g || (g = $Writer$1.create()), A.data != null && Object.hasOwnProperty.call(A, "data") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).bytes(A.data), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader$1 || (A = $Reader$1.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root$1.ArrowData();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.data = A.bytes();
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root$1.ArrowData) return A;
    let g = new $root$1.ArrowData();
    return A.data != null && (typeof A.data == "string" ? $util$1.base64.decode(A.data, g.data = $util$1.newBuffer($util$1.base64.length(A.data)), 0) : A.data.length >= 0 && (g.data = A.data)), g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    return g.defaults && (g.bytes === String ? e.data = "" : (e.data = [], g.bytes !== Array && (e.data = $util$1.newBuffer(e.data)))), A.data != null && A.hasOwnProperty("data") && (e.data = g.bytes === String ? $util$1.base64.encode(A.data, 0, A.data.length) : g.bytes === Array ? Array.prototype.slice.call(A.data) : A.data), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/ArrowData";
  }, o;
})();
$root$1.ArrowNamedDataSet = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.name = "", o.prototype.hasName = !1, o.prototype.data = null, o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    return g || (g = $Writer$1.create()), A.name != null && Object.hasOwnProperty.call(A, "name") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(A.name), A.data != null && Object.hasOwnProperty.call(A, "data") && $root$1.Arrow.encode(A.data, g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), A.hasName != null && Object.hasOwnProperty.call(A, "hasName") && g.uint32(
      /* id 3, wireType 0 =*/
      24
    ).bool(A.hasName), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader$1 || (A = $Reader$1.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root$1.ArrowNamedDataSet();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.name = A.string();
          break;
        }
        case 3: {
          c.hasName = A.bool();
          break;
        }
        case 2: {
          c.data = $root$1.Arrow.decode(A, A.uint32());
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root$1.ArrowNamedDataSet) return A;
    let g = new $root$1.ArrowNamedDataSet();
    if (A.name != null && (g.name = String(A.name)), A.hasName != null && (g.hasName = !!A.hasName), A.data != null) {
      if (typeof A.data != "object") throw TypeError(".ArrowNamedDataSet.data: object expected");
      g.data = $root$1.Arrow.fromObject(A.data);
    }
    return g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    return g.defaults && (e.name = "", e.data = null, e.hasName = !1), A.name != null && A.hasOwnProperty("name") && (e.name = A.name), A.data != null && A.hasOwnProperty("data") && (e.data = $root$1.Arrow.toObject(A.data, g)), A.hasName != null && A.hasOwnProperty("hasName") && (e.hasName = A.hasName), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/ArrowNamedDataSet";
  }, o;
})();
$root$1.ArrowVegaLiteChart = (() => {
  function o(E) {
    if (this.datasets = [], this.selectionMode = [], E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.spec = "", o.prototype.data = null, o.prototype.datasets = $util$1.emptyArray, o.prototype.useContainerWidth = !1, o.prototype.theme = "", o.prototype.id = "", o.prototype.selectionMode = $util$1.emptyArray, o.prototype.formId = "", o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    if (g || (g = $Writer$1.create()), A.spec != null && Object.hasOwnProperty.call(A, "spec") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(A.spec), A.data != null && Object.hasOwnProperty.call(A, "data") && $root$1.Arrow.encode(A.data, g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), A.datasets != null && A.datasets.length) for (let e = 0; e < A.datasets.length; ++e) $root$1.ArrowNamedDataSet.encode(A.datasets[e], g.uint32(
      /* id 4, wireType 2 =*/
      34
    ).fork()).ldelim();
    if (A.useContainerWidth != null && Object.hasOwnProperty.call(A, "useContainerWidth") && g.uint32(
      /* id 5, wireType 0 =*/
      40
    ).bool(A.useContainerWidth), A.theme != null && Object.hasOwnProperty.call(A, "theme") && g.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(A.theme), A.id != null && Object.hasOwnProperty.call(A, "id") && g.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(A.id), A.selectionMode != null && A.selectionMode.length) for (let e = 0; e < A.selectionMode.length; ++e) g.uint32(
      /* id 8, wireType 2 =*/
      66
    ).string(A.selectionMode[e]);
    return A.formId != null && Object.hasOwnProperty.call(A, "formId") && g.uint32(
      /* id 9, wireType 2 =*/
      74
    ).string(A.formId), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader$1 || (A = $Reader$1.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root$1.ArrowVegaLiteChart();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.spec = A.string();
          break;
        }
        case 2: {
          c.data = $root$1.Arrow.decode(A, A.uint32());
          break;
        }
        case 4: {
          c.datasets && c.datasets.length || (c.datasets = []), c.datasets.push($root$1.ArrowNamedDataSet.decode(A, A.uint32()));
          break;
        }
        case 5: {
          c.useContainerWidth = A.bool();
          break;
        }
        case 6: {
          c.theme = A.string();
          break;
        }
        case 7: {
          c.id = A.string();
          break;
        }
        case 8: {
          c.selectionMode && c.selectionMode.length || (c.selectionMode = []), c.selectionMode.push(A.string());
          break;
        }
        case 9: {
          c.formId = A.string();
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root$1.ArrowVegaLiteChart) return A;
    let g = new $root$1.ArrowVegaLiteChart();
    if (A.spec != null && (g.spec = String(A.spec)), A.data != null) {
      if (typeof A.data != "object") throw TypeError(".ArrowVegaLiteChart.data: object expected");
      g.data = $root$1.Arrow.fromObject(A.data);
    }
    if (A.datasets) {
      if (!Array.isArray(A.datasets)) throw TypeError(".ArrowVegaLiteChart.datasets: array expected");
      g.datasets = [];
      for (let e = 0; e < A.datasets.length; ++e) {
        if (typeof A.datasets[e] != "object") throw TypeError(".ArrowVegaLiteChart.datasets: object expected");
        g.datasets[e] = $root$1.ArrowNamedDataSet.fromObject(A.datasets[e]);
      }
    }
    if (A.useContainerWidth != null && (g.useContainerWidth = !!A.useContainerWidth), A.theme != null && (g.theme = String(A.theme)), A.id != null && (g.id = String(A.id)), A.selectionMode) {
      if (!Array.isArray(A.selectionMode)) throw TypeError(".ArrowVegaLiteChart.selectionMode: array expected");
      g.selectionMode = [];
      for (let e = 0; e < A.selectionMode.length; ++e) g.selectionMode[e] = String(A.selectionMode[e]);
    }
    return A.formId != null && (g.formId = String(A.formId)), g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    if ((g.arrays || g.defaults) && (e.datasets = [], e.selectionMode = []), g.defaults && (e.spec = "", e.data = null, e.useContainerWidth = !1, e.theme = "", e.id = "", e.formId = ""), A.spec != null && A.hasOwnProperty("spec") && (e.spec = A.spec), A.data != null && A.hasOwnProperty("data") && (e.data = $root$1.Arrow.toObject(A.data, g)), A.datasets && A.datasets.length) {
      e.datasets = [];
      for (let t = 0; t < A.datasets.length; ++t) e.datasets[t] = $root$1.ArrowNamedDataSet.toObject(A.datasets[t], g);
    }
    if (A.useContainerWidth != null && A.hasOwnProperty("useContainerWidth") && (e.useContainerWidth = A.useContainerWidth), A.theme != null && A.hasOwnProperty("theme") && (e.theme = A.theme), A.id != null && A.hasOwnProperty("id") && (e.id = A.id), A.selectionMode && A.selectionMode.length) {
      e.selectionMode = [];
      for (let t = 0; t < A.selectionMode.length; ++t) e.selectionMode[t] = A.selectionMode[t];
    }
    return A.formId != null && A.hasOwnProperty("formId") && (e.formId = A.formId), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/ArrowVegaLiteChart";
  }, o;
})();
$root$1.Audio = (() => {
  function o(A) {
    if (A) for (let g = Object.keys(A), e = 0; e < g.length; ++e) A[g[e]] != null && (this[g[e]] = A[g[e]]);
  }
  o.prototype.url = "", o.prototype.startTime = 0, o.prototype.endTime = 0, o.prototype.loop = !1, o.prototype.autoplay = !1, o.prototype.id = "", o.prototype.widthConfig = null;
  let E;
  return Object.defineProperty(o.prototype, "_widthConfig", { get: $util$1.oneOfGetter(E = ["widthConfig"]), set: $util$1.oneOfSetter(E) }), o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, e) {
    return e || (e = $Writer$1.create()), g.startTime != null && Object.hasOwnProperty.call(g, "startTime") && e.uint32(
      /* id 3, wireType 0 =*/
      24
    ).int32(g.startTime), g.url != null && Object.hasOwnProperty.call(g, "url") && e.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(g.url), g.endTime != null && Object.hasOwnProperty.call(g, "endTime") && e.uint32(
      /* id 6, wireType 0 =*/
      48
    ).int32(g.endTime), g.loop != null && Object.hasOwnProperty.call(g, "loop") && e.uint32(
      /* id 7, wireType 0 =*/
      56
    ).bool(g.loop), g.autoplay != null && Object.hasOwnProperty.call(g, "autoplay") && e.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(g.autoplay), g.id != null && Object.hasOwnProperty.call(g, "id") && e.uint32(
      /* id 9, wireType 2 =*/
      74
    ).string(g.id), g.widthConfig != null && Object.hasOwnProperty.call(g, "widthConfig") && $root$1.streamlit.WidthConfig.encode(g.widthConfig, e.uint32(
      /* id 10, wireType 2 =*/
      82
    ).fork()).ldelim(), e;
  }, o.decode = function(g, e, t) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let c = e === void 0 ? g.len : g.pos + e, n = new $root$1.Audio();
    for (; g.pos < c; ) {
      let h = g.uint32();
      if (h === t) break;
      switch (h >>> 3) {
        case 5: {
          n.url = g.string();
          break;
        }
        case 3: {
          n.startTime = g.int32();
          break;
        }
        case 6: {
          n.endTime = g.int32();
          break;
        }
        case 7: {
          n.loop = g.bool();
          break;
        }
        case 8: {
          n.autoplay = g.bool();
          break;
        }
        case 9: {
          n.id = g.string();
          break;
        }
        case 10: {
          n.widthConfig = $root$1.streamlit.WidthConfig.decode(g, g.uint32());
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.Audio) return g;
    let e = new $root$1.Audio();
    if (g.url != null && (e.url = String(g.url)), g.startTime != null && (e.startTime = g.startTime | 0), g.endTime != null && (e.endTime = g.endTime | 0), g.loop != null && (e.loop = !!g.loop), g.autoplay != null && (e.autoplay = !!g.autoplay), g.id != null && (e.id = String(g.id)), g.widthConfig != null) {
      if (typeof g.widthConfig != "object") throw TypeError(".Audio.widthConfig: object expected");
      e.widthConfig = $root$1.streamlit.WidthConfig.fromObject(g.widthConfig);
    }
    return e;
  }, o.toObject = function(g, e) {
    e || (e = {});
    let t = {};
    return e.defaults && (t.startTime = 0, t.url = "", t.endTime = 0, t.loop = !1, t.autoplay = !1, t.id = ""), g.startTime != null && g.hasOwnProperty("startTime") && (t.startTime = g.startTime), g.url != null && g.hasOwnProperty("url") && (t.url = g.url), g.endTime != null && g.hasOwnProperty("endTime") && (t.endTime = g.endTime), g.loop != null && g.hasOwnProperty("loop") && (t.loop = g.loop), g.autoplay != null && g.hasOwnProperty("autoplay") && (t.autoplay = g.autoplay), g.id != null && g.hasOwnProperty("id") && (t.id = g.id), g.widthConfig != null && g.hasOwnProperty("widthConfig") && (t.widthConfig = $root$1.streamlit.WidthConfig.toObject(g.widthConfig, e), e.oneofs && (t._widthConfig = "widthConfig")), t;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/Audio";
  }, o;
})();
$root$1.AudioInput = (() => {
  function o(A) {
    if (A) for (let g = Object.keys(A), e = 0; e < g.length; ++e) A[g[e]] != null && (this[g[e]] = A[g[e]]);
  }
  o.prototype.id = "", o.prototype.label = "", o.prototype.help = "", o.prototype.formId = "", o.prototype.disabled = !1, o.prototype.labelVisibility = null, o.prototype.sampleRate = null;
  let E;
  return Object.defineProperty(o.prototype, "_sampleRate", { get: $util$1.oneOfGetter(E = ["sampleRate"]), set: $util$1.oneOfSetter(E) }), o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, e) {
    return e || (e = $Writer$1.create()), g.id != null && Object.hasOwnProperty.call(g, "id") && e.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.id), g.label != null && Object.hasOwnProperty.call(g, "label") && e.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.label), g.help != null && Object.hasOwnProperty.call(g, "help") && e.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(g.help), g.formId != null && Object.hasOwnProperty.call(g, "formId") && e.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(g.formId), g.disabled != null && Object.hasOwnProperty.call(g, "disabled") && e.uint32(
      /* id 5, wireType 0 =*/
      40
    ).bool(g.disabled), g.labelVisibility != null && Object.hasOwnProperty.call(g, "labelVisibility") && $root$1.LabelVisibilityMessage.encode(g.labelVisibility, e.uint32(
      /* id 6, wireType 2 =*/
      50
    ).fork()).ldelim(), g.sampleRate != null && Object.hasOwnProperty.call(g, "sampleRate") && e.uint32(
      /* id 7, wireType 0 =*/
      56
    ).int32(g.sampleRate), e;
  }, o.decode = function(g, e, t) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let c = e === void 0 ? g.len : g.pos + e, n = new $root$1.AudioInput();
    for (; g.pos < c; ) {
      let h = g.uint32();
      if (h === t) break;
      switch (h >>> 3) {
        case 1: {
          n.id = g.string();
          break;
        }
        case 2: {
          n.label = g.string();
          break;
        }
        case 3: {
          n.help = g.string();
          break;
        }
        case 4: {
          n.formId = g.string();
          break;
        }
        case 5: {
          n.disabled = g.bool();
          break;
        }
        case 6: {
          n.labelVisibility = $root$1.LabelVisibilityMessage.decode(g, g.uint32());
          break;
        }
        case 7: {
          n.sampleRate = g.int32();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.AudioInput) return g;
    let e = new $root$1.AudioInput();
    if (g.id != null && (e.id = String(g.id)), g.label != null && (e.label = String(g.label)), g.help != null && (e.help = String(g.help)), g.formId != null && (e.formId = String(g.formId)), g.disabled != null && (e.disabled = !!g.disabled), g.labelVisibility != null) {
      if (typeof g.labelVisibility != "object") throw TypeError(".AudioInput.labelVisibility: object expected");
      e.labelVisibility = $root$1.LabelVisibilityMessage.fromObject(g.labelVisibility);
    }
    return g.sampleRate != null && (e.sampleRate = g.sampleRate | 0), e;
  }, o.toObject = function(g, e) {
    e || (e = {});
    let t = {};
    return e.defaults && (t.id = "", t.label = "", t.help = "", t.formId = "", t.disabled = !1, t.labelVisibility = null), g.id != null && g.hasOwnProperty("id") && (t.id = g.id), g.label != null && g.hasOwnProperty("label") && (t.label = g.label), g.help != null && g.hasOwnProperty("help") && (t.help = g.help), g.formId != null && g.hasOwnProperty("formId") && (t.formId = g.formId), g.disabled != null && g.hasOwnProperty("disabled") && (t.disabled = g.disabled), g.labelVisibility != null && g.hasOwnProperty("labelVisibility") && (t.labelVisibility = $root$1.LabelVisibilityMessage.toObject(g.labelVisibility, e)), g.sampleRate != null && g.hasOwnProperty("sampleRate") && (t.sampleRate = g.sampleRate, e.oneofs && (t._sampleRate = "sampleRate")), t;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/AudioInput";
  }, o;
})();
const LabelVisibilityMessage = $root$1.LabelVisibilityMessage = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.value = 0, o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    return g || (g = $Writer$1.create()), A.value != null && Object.hasOwnProperty.call(A, "value") && g.uint32(
      /* id 1, wireType 0 =*/
      8
    ).int32(A.value), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader$1 || (A = $Reader$1.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root$1.LabelVisibilityMessage();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.value = A.int32();
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root$1.LabelVisibilityMessage) return A;
    let g = new $root$1.LabelVisibilityMessage();
    switch (A.value) {
      default:
        if (typeof A.value == "number") {
          g.value = A.value;
          break;
        }
        break;
      case "VISIBLE":
      case 0:
        g.value = 0;
        break;
      case "HIDDEN":
      case 1:
        g.value = 1;
        break;
      case "COLLAPSED":
      case 2:
        g.value = 2;
        break;
    }
    return g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    return g.defaults && (e.value = g.enums === String ? "VISIBLE" : 0), A.value != null && A.hasOwnProperty("value") && (e.value = g.enums === String ? $root$1.LabelVisibilityMessage.LabelVisibilityOptions[A.value] === void 0 ? A.value : $root$1.LabelVisibilityMessage.LabelVisibilityOptions[A.value] : A.value), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/LabelVisibilityMessage";
  }, o.LabelVisibilityOptions = (function() {
    const E = {}, A = Object.create(E);
    return A[E[0] = "VISIBLE"] = 0, A[E[1] = "HIDDEN"] = 1, A[E[2] = "COLLAPSED"] = 2, A;
  })(), o;
})();
$root$1.AuthRedirect = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.url = "", o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    return g || (g = $Writer$1.create()), A.url != null && Object.hasOwnProperty.call(A, "url") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(A.url), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader$1 || (A = $Reader$1.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root$1.AuthRedirect();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.url = A.string();
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root$1.AuthRedirect) return A;
    let g = new $root$1.AuthRedirect();
    return A.url != null && (g.url = String(A.url)), g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    return g.defaults && (e.url = ""), A.url != null && A.hasOwnProperty("url") && (e.url = A.url), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/AuthRedirect";
  }, o;
})();
$root$1.AutoRerun = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.interval = 0, o.prototype.fragmentId = "", o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    return g || (g = $Writer$1.create()), A.interval != null && Object.hasOwnProperty.call(A, "interval") && g.uint32(
      /* id 1, wireType 5 =*/
      13
    ).float(A.interval), A.fragmentId != null && Object.hasOwnProperty.call(A, "fragmentId") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(A.fragmentId), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader$1 || (A = $Reader$1.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root$1.AutoRerun();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.interval = A.float();
          break;
        }
        case 2: {
          c.fragmentId = A.string();
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root$1.AutoRerun) return A;
    let g = new $root$1.AutoRerun();
    return A.interval != null && (g.interval = Number(A.interval)), A.fragmentId != null && (g.fragmentId = String(A.fragmentId)), g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    return g.defaults && (e.interval = 0, e.fragmentId = ""), A.interval != null && A.hasOwnProperty("interval") && (e.interval = g.json && !isFinite(A.interval) ? String(A.interval) : A.interval), A.fragmentId != null && A.hasOwnProperty("fragmentId") && (e.fragmentId = A.fragmentId), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/AutoRerun";
  }, o;
})();
const BackMsg = $root$1.BackMsg = (() => {
  function o(A) {
    if (A) for (let g = Object.keys(A), e = 0; e < g.length; ++e) A[g[e]] != null && (this[g[e]] = A[g[e]]);
  }
  o.prototype.clearCache = null, o.prototype.setRunOnSave = null, o.prototype.stopScript = null, o.prototype.rerunScript = null, o.prototype.loadGitInfo = null, o.prototype.debugDisconnectWebsocket = null, o.prototype.debugShutdownRuntime = null, o.prototype.fileUrlsRequest = null, o.prototype.appHeartbeat = null, o.prototype.deferredFileRequest = null, o.prototype.debugLastBackmsgId = "";
  let E;
  return Object.defineProperty(o.prototype, "type", { get: $util$1.oneOfGetter(E = ["clearCache", "setRunOnSave", "stopScript", "rerunScript", "loadGitInfo", "debugDisconnectWebsocket", "debugShutdownRuntime", "fileUrlsRequest", "appHeartbeat", "deferredFileRequest"]), set: $util$1.oneOfSetter(E) }), o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, e) {
    return e || (e = $Writer$1.create()), g.clearCache != null && Object.hasOwnProperty.call(g, "clearCache") && e.uint32(
      /* id 5, wireType 0 =*/
      40
    ).bool(g.clearCache), g.setRunOnSave != null && Object.hasOwnProperty.call(g, "setRunOnSave") && e.uint32(
      /* id 6, wireType 0 =*/
      48
    ).bool(g.setRunOnSave), g.stopScript != null && Object.hasOwnProperty.call(g, "stopScript") && e.uint32(
      /* id 7, wireType 0 =*/
      56
    ).bool(g.stopScript), g.rerunScript != null && Object.hasOwnProperty.call(g, "rerunScript") && $root$1.ClientState.encode(g.rerunScript, e.uint32(
      /* id 11, wireType 2 =*/
      90
    ).fork()).ldelim(), g.loadGitInfo != null && Object.hasOwnProperty.call(g, "loadGitInfo") && e.uint32(
      /* id 12, wireType 0 =*/
      96
    ).bool(g.loadGitInfo), g.debugLastBackmsgId != null && Object.hasOwnProperty.call(g, "debugLastBackmsgId") && e.uint32(
      /* id 13, wireType 2 =*/
      106
    ).string(g.debugLastBackmsgId), g.debugDisconnectWebsocket != null && Object.hasOwnProperty.call(g, "debugDisconnectWebsocket") && e.uint32(
      /* id 14, wireType 0 =*/
      112
    ).bool(g.debugDisconnectWebsocket), g.debugShutdownRuntime != null && Object.hasOwnProperty.call(g, "debugShutdownRuntime") && e.uint32(
      /* id 15, wireType 0 =*/
      120
    ).bool(g.debugShutdownRuntime), g.fileUrlsRequest != null && Object.hasOwnProperty.call(g, "fileUrlsRequest") && $root$1.FileURLsRequest.encode(g.fileUrlsRequest, e.uint32(
      /* id 16, wireType 2 =*/
      130
    ).fork()).ldelim(), g.appHeartbeat != null && Object.hasOwnProperty.call(g, "appHeartbeat") && e.uint32(
      /* id 17, wireType 0 =*/
      136
    ).bool(g.appHeartbeat), g.deferredFileRequest != null && Object.hasOwnProperty.call(g, "deferredFileRequest") && $root$1.DeferredFileRequest.encode(g.deferredFileRequest, e.uint32(
      /* id 18, wireType 2 =*/
      146
    ).fork()).ldelim(), e;
  }, o.decode = function(g, e, t) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let c = e === void 0 ? g.len : g.pos + e, n = new $root$1.BackMsg();
    for (; g.pos < c; ) {
      let h = g.uint32();
      if (h === t) break;
      switch (h >>> 3) {
        case 5: {
          n.clearCache = g.bool();
          break;
        }
        case 6: {
          n.setRunOnSave = g.bool();
          break;
        }
        case 7: {
          n.stopScript = g.bool();
          break;
        }
        case 11: {
          n.rerunScript = $root$1.ClientState.decode(g, g.uint32());
          break;
        }
        case 12: {
          n.loadGitInfo = g.bool();
          break;
        }
        case 14: {
          n.debugDisconnectWebsocket = g.bool();
          break;
        }
        case 15: {
          n.debugShutdownRuntime = g.bool();
          break;
        }
        case 16: {
          n.fileUrlsRequest = $root$1.FileURLsRequest.decode(g, g.uint32());
          break;
        }
        case 17: {
          n.appHeartbeat = g.bool();
          break;
        }
        case 18: {
          n.deferredFileRequest = $root$1.DeferredFileRequest.decode(g, g.uint32());
          break;
        }
        case 13: {
          n.debugLastBackmsgId = g.string();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.BackMsg) return g;
    let e = new $root$1.BackMsg();
    if (g.clearCache != null && (e.clearCache = !!g.clearCache), g.setRunOnSave != null && (e.setRunOnSave = !!g.setRunOnSave), g.stopScript != null && (e.stopScript = !!g.stopScript), g.rerunScript != null) {
      if (typeof g.rerunScript != "object") throw TypeError(".BackMsg.rerunScript: object expected");
      e.rerunScript = $root$1.ClientState.fromObject(g.rerunScript);
    }
    if (g.loadGitInfo != null && (e.loadGitInfo = !!g.loadGitInfo), g.debugDisconnectWebsocket != null && (e.debugDisconnectWebsocket = !!g.debugDisconnectWebsocket), g.debugShutdownRuntime != null && (e.debugShutdownRuntime = !!g.debugShutdownRuntime), g.fileUrlsRequest != null) {
      if (typeof g.fileUrlsRequest != "object") throw TypeError(".BackMsg.fileUrlsRequest: object expected");
      e.fileUrlsRequest = $root$1.FileURLsRequest.fromObject(g.fileUrlsRequest);
    }
    if (g.appHeartbeat != null && (e.appHeartbeat = !!g.appHeartbeat), g.deferredFileRequest != null) {
      if (typeof g.deferredFileRequest != "object") throw TypeError(".BackMsg.deferredFileRequest: object expected");
      e.deferredFileRequest = $root$1.DeferredFileRequest.fromObject(g.deferredFileRequest);
    }
    return g.debugLastBackmsgId != null && (e.debugLastBackmsgId = String(g.debugLastBackmsgId)), e;
  }, o.toObject = function(g, e) {
    e || (e = {});
    let t = {};
    return e.defaults && (t.debugLastBackmsgId = ""), g.clearCache != null && g.hasOwnProperty("clearCache") && (t.clearCache = g.clearCache, e.oneofs && (t.type = "clearCache")), g.setRunOnSave != null && g.hasOwnProperty("setRunOnSave") && (t.setRunOnSave = g.setRunOnSave, e.oneofs && (t.type = "setRunOnSave")), g.stopScript != null && g.hasOwnProperty("stopScript") && (t.stopScript = g.stopScript, e.oneofs && (t.type = "stopScript")), g.rerunScript != null && g.hasOwnProperty("rerunScript") && (t.rerunScript = $root$1.ClientState.toObject(g.rerunScript, e), e.oneofs && (t.type = "rerunScript")), g.loadGitInfo != null && g.hasOwnProperty("loadGitInfo") && (t.loadGitInfo = g.loadGitInfo, e.oneofs && (t.type = "loadGitInfo")), g.debugLastBackmsgId != null && g.hasOwnProperty("debugLastBackmsgId") && (t.debugLastBackmsgId = g.debugLastBackmsgId), g.debugDisconnectWebsocket != null && g.hasOwnProperty("debugDisconnectWebsocket") && (t.debugDisconnectWebsocket = g.debugDisconnectWebsocket, e.oneofs && (t.type = "debugDisconnectWebsocket")), g.debugShutdownRuntime != null && g.hasOwnProperty("debugShutdownRuntime") && (t.debugShutdownRuntime = g.debugShutdownRuntime, e.oneofs && (t.type = "debugShutdownRuntime")), g.fileUrlsRequest != null && g.hasOwnProperty("fileUrlsRequest") && (t.fileUrlsRequest = $root$1.FileURLsRequest.toObject(g.fileUrlsRequest, e), e.oneofs && (t.type = "fileUrlsRequest")), g.appHeartbeat != null && g.hasOwnProperty("appHeartbeat") && (t.appHeartbeat = g.appHeartbeat, e.oneofs && (t.type = "appHeartbeat")), g.deferredFileRequest != null && g.hasOwnProperty("deferredFileRequest") && (t.deferredFileRequest = $root$1.DeferredFileRequest.toObject(g.deferredFileRequest, e), e.oneofs && (t.type = "deferredFileRequest")), t;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/BackMsg";
  }, o;
})();
$root$1.DeferredFileRequest = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.fileId = "", o.prototype.sessionId = "", o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    return g || (g = $Writer$1.create()), A.fileId != null && Object.hasOwnProperty.call(A, "fileId") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(A.fileId), A.sessionId != null && Object.hasOwnProperty.call(A, "sessionId") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(A.sessionId), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader$1 || (A = $Reader$1.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root$1.DeferredFileRequest();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.fileId = A.string();
          break;
        }
        case 2: {
          c.sessionId = A.string();
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root$1.DeferredFileRequest) return A;
    let g = new $root$1.DeferredFileRequest();
    return A.fileId != null && (g.fileId = String(A.fileId)), A.sessionId != null && (g.sessionId = String(A.sessionId)), g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    return g.defaults && (e.fileId = "", e.sessionId = ""), A.fileId != null && A.hasOwnProperty("fileId") && (e.fileId = A.fileId), A.sessionId != null && A.hasOwnProperty("sessionId") && (e.sessionId = A.sessionId), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/DeferredFileRequest";
  }, o;
})();
$root$1.ContextInfo = (() => {
  function o(A) {
    if (A) for (let g = Object.keys(A), e = 0; e < g.length; ++e) A[g[e]] != null && (this[g[e]] = A[g[e]]);
  }
  o.prototype.timezone = null, o.prototype.timezoneOffset = null, o.prototype.locale = null, o.prototype.url = null, o.prototype.isEmbedded = null, o.prototype.colorScheme = null;
  let E;
  return Object.defineProperty(o.prototype, "_timezone", { get: $util$1.oneOfGetter(E = ["timezone"]), set: $util$1.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_timezoneOffset", { get: $util$1.oneOfGetter(E = ["timezoneOffset"]), set: $util$1.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_locale", { get: $util$1.oneOfGetter(E = ["locale"]), set: $util$1.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_url", { get: $util$1.oneOfGetter(E = ["url"]), set: $util$1.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_isEmbedded", { get: $util$1.oneOfGetter(E = ["isEmbedded"]), set: $util$1.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_colorScheme", { get: $util$1.oneOfGetter(E = ["colorScheme"]), set: $util$1.oneOfSetter(E) }), o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, e) {
    return e || (e = $Writer$1.create()), g.timezone != null && Object.hasOwnProperty.call(g, "timezone") && e.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.timezone), g.timezoneOffset != null && Object.hasOwnProperty.call(g, "timezoneOffset") && e.uint32(
      /* id 2, wireType 0 =*/
      16
    ).int32(g.timezoneOffset), g.locale != null && Object.hasOwnProperty.call(g, "locale") && e.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(g.locale), g.url != null && Object.hasOwnProperty.call(g, "url") && e.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(g.url), g.isEmbedded != null && Object.hasOwnProperty.call(g, "isEmbedded") && e.uint32(
      /* id 5, wireType 0 =*/
      40
    ).bool(g.isEmbedded), g.colorScheme != null && Object.hasOwnProperty.call(g, "colorScheme") && e.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(g.colorScheme), e;
  }, o.decode = function(g, e, t) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let c = e === void 0 ? g.len : g.pos + e, n = new $root$1.ContextInfo();
    for (; g.pos < c; ) {
      let h = g.uint32();
      if (h === t) break;
      switch (h >>> 3) {
        case 1: {
          n.timezone = g.string();
          break;
        }
        case 2: {
          n.timezoneOffset = g.int32();
          break;
        }
        case 3: {
          n.locale = g.string();
          break;
        }
        case 4: {
          n.url = g.string();
          break;
        }
        case 5: {
          n.isEmbedded = g.bool();
          break;
        }
        case 6: {
          n.colorScheme = g.string();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.ContextInfo) return g;
    let e = new $root$1.ContextInfo();
    return g.timezone != null && (e.timezone = String(g.timezone)), g.timezoneOffset != null && (e.timezoneOffset = g.timezoneOffset | 0), g.locale != null && (e.locale = String(g.locale)), g.url != null && (e.url = String(g.url)), g.isEmbedded != null && (e.isEmbedded = !!g.isEmbedded), g.colorScheme != null && (e.colorScheme = String(g.colorScheme)), e;
  }, o.toObject = function(g, e) {
    e || (e = {});
    let t = {};
    return g.timezone != null && g.hasOwnProperty("timezone") && (t.timezone = g.timezone, e.oneofs && (t._timezone = "timezone")), g.timezoneOffset != null && g.hasOwnProperty("timezoneOffset") && (t.timezoneOffset = g.timezoneOffset, e.oneofs && (t._timezoneOffset = "timezoneOffset")), g.locale != null && g.hasOwnProperty("locale") && (t.locale = g.locale, e.oneofs && (t._locale = "locale")), g.url != null && g.hasOwnProperty("url") && (t.url = g.url, e.oneofs && (t._url = "url")), g.isEmbedded != null && g.hasOwnProperty("isEmbedded") && (t.isEmbedded = g.isEmbedded, e.oneofs && (t._isEmbedded = "isEmbedded")), g.colorScheme != null && g.hasOwnProperty("colorScheme") && (t.colorScheme = g.colorScheme, e.oneofs && (t._colorScheme = "colorScheme")), t;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/ContextInfo";
  }, o;
})();
$root$1.ClientState = (() => {
  function o(E) {
    if (this.cachedMessageHashes = [], E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.queryString = "", o.prototype.widgetStates = null, o.prototype.pageScriptHash = "", o.prototype.pageName = "", o.prototype.fragmentId = "", o.prototype.isAutoRerun = !1, o.prototype.cachedMessageHashes = $util$1.emptyArray, o.prototype.contextInfo = null, o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    if (g || (g = $Writer$1.create()), A.queryString != null && Object.hasOwnProperty.call(A, "queryString") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(A.queryString), A.widgetStates != null && Object.hasOwnProperty.call(A, "widgetStates") && $root$1.WidgetStates.encode(A.widgetStates, g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), A.pageScriptHash != null && Object.hasOwnProperty.call(A, "pageScriptHash") && g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(A.pageScriptHash), A.pageName != null && Object.hasOwnProperty.call(A, "pageName") && g.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(A.pageName), A.fragmentId != null && Object.hasOwnProperty.call(A, "fragmentId") && g.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(A.fragmentId), A.isAutoRerun != null && Object.hasOwnProperty.call(A, "isAutoRerun") && g.uint32(
      /* id 6, wireType 0 =*/
      48
    ).bool(A.isAutoRerun), A.cachedMessageHashes != null && A.cachedMessageHashes.length) for (let e = 0; e < A.cachedMessageHashes.length; ++e) g.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(A.cachedMessageHashes[e]);
    return A.contextInfo != null && Object.hasOwnProperty.call(A, "contextInfo") && $root$1.ContextInfo.encode(A.contextInfo, g.uint32(
      /* id 8, wireType 2 =*/
      66
    ).fork()).ldelim(), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader$1 || (A = $Reader$1.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root$1.ClientState();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.queryString = A.string();
          break;
        }
        case 2: {
          c.widgetStates = $root$1.WidgetStates.decode(A, A.uint32());
          break;
        }
        case 3: {
          c.pageScriptHash = A.string();
          break;
        }
        case 4: {
          c.pageName = A.string();
          break;
        }
        case 5: {
          c.fragmentId = A.string();
          break;
        }
        case 6: {
          c.isAutoRerun = A.bool();
          break;
        }
        case 7: {
          c.cachedMessageHashes && c.cachedMessageHashes.length || (c.cachedMessageHashes = []), c.cachedMessageHashes.push(A.string());
          break;
        }
        case 8: {
          c.contextInfo = $root$1.ContextInfo.decode(A, A.uint32());
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root$1.ClientState) return A;
    let g = new $root$1.ClientState();
    if (A.queryString != null && (g.queryString = String(A.queryString)), A.widgetStates != null) {
      if (typeof A.widgetStates != "object") throw TypeError(".ClientState.widgetStates: object expected");
      g.widgetStates = $root$1.WidgetStates.fromObject(A.widgetStates);
    }
    if (A.pageScriptHash != null && (g.pageScriptHash = String(A.pageScriptHash)), A.pageName != null && (g.pageName = String(A.pageName)), A.fragmentId != null && (g.fragmentId = String(A.fragmentId)), A.isAutoRerun != null && (g.isAutoRerun = !!A.isAutoRerun), A.cachedMessageHashes) {
      if (!Array.isArray(A.cachedMessageHashes)) throw TypeError(".ClientState.cachedMessageHashes: array expected");
      g.cachedMessageHashes = [];
      for (let e = 0; e < A.cachedMessageHashes.length; ++e) g.cachedMessageHashes[e] = String(A.cachedMessageHashes[e]);
    }
    if (A.contextInfo != null) {
      if (typeof A.contextInfo != "object") throw TypeError(".ClientState.contextInfo: object expected");
      g.contextInfo = $root$1.ContextInfo.fromObject(A.contextInfo);
    }
    return g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    if ((g.arrays || g.defaults) && (e.cachedMessageHashes = []), g.defaults && (e.queryString = "", e.widgetStates = null, e.pageScriptHash = "", e.pageName = "", e.fragmentId = "", e.isAutoRerun = !1, e.contextInfo = null), A.queryString != null && A.hasOwnProperty("queryString") && (e.queryString = A.queryString), A.widgetStates != null && A.hasOwnProperty("widgetStates") && (e.widgetStates = $root$1.WidgetStates.toObject(A.widgetStates, g)), A.pageScriptHash != null && A.hasOwnProperty("pageScriptHash") && (e.pageScriptHash = A.pageScriptHash), A.pageName != null && A.hasOwnProperty("pageName") && (e.pageName = A.pageName), A.fragmentId != null && A.hasOwnProperty("fragmentId") && (e.fragmentId = A.fragmentId), A.isAutoRerun != null && A.hasOwnProperty("isAutoRerun") && (e.isAutoRerun = A.isAutoRerun), A.cachedMessageHashes && A.cachedMessageHashes.length) {
      e.cachedMessageHashes = [];
      for (let t = 0; t < A.cachedMessageHashes.length; ++t) e.cachedMessageHashes[t] = A.cachedMessageHashes[t];
    }
    return A.contextInfo != null && A.hasOwnProperty("contextInfo") && (e.contextInfo = $root$1.ContextInfo.toObject(A.contextInfo, g)), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/ClientState";
  }, o;
})();
const WidgetStates = $root$1.WidgetStates = (() => {
  function o(E) {
    if (this.widgets = [], E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.widgets = $util$1.emptyArray, o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    if (g || (g = $Writer$1.create()), A.widgets != null && A.widgets.length) for (let e = 0; e < A.widgets.length; ++e) $root$1.WidgetState.encode(A.widgets[e], g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim();
    return g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader$1 || (A = $Reader$1.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root$1.WidgetStates();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.widgets && c.widgets.length || (c.widgets = []), c.widgets.push($root$1.WidgetState.decode(A, A.uint32()));
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root$1.WidgetStates) return A;
    let g = new $root$1.WidgetStates();
    if (A.widgets) {
      if (!Array.isArray(A.widgets)) throw TypeError(".WidgetStates.widgets: array expected");
      g.widgets = [];
      for (let e = 0; e < A.widgets.length; ++e) {
        if (typeof A.widgets[e] != "object") throw TypeError(".WidgetStates.widgets: object expected");
        g.widgets[e] = $root$1.WidgetState.fromObject(A.widgets[e]);
      }
    }
    return g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    if ((g.arrays || g.defaults) && (e.widgets = []), A.widgets && A.widgets.length) {
      e.widgets = [];
      for (let t = 0; t < A.widgets.length; ++t) e.widgets[t] = $root$1.WidgetState.toObject(A.widgets[t], g);
    }
    return e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/WidgetStates";
  }, o;
})(), WidgetState = $root$1.WidgetState = (() => {
  function o(A) {
    if (A) for (let g = Object.keys(A), e = 0; e < g.length; ++e) A[g[e]] != null && (this[g[e]] = A[g[e]]);
  }
  o.prototype.id = "", o.prototype.triggerValue = null, o.prototype.boolValue = null, o.prototype.doubleValue = null, o.prototype.intValue = null, o.prototype.stringValue = null, o.prototype.doubleArrayValue = null, o.prototype.intArrayValue = null, o.prototype.stringArrayValue = null, o.prototype.jsonValue = null, o.prototype.arrowValue = null, o.prototype.bytesValue = null, o.prototype.fileUploaderStateValue = null, o.prototype.stringTriggerValue = null, o.prototype.chatInputValue = null, o.prototype.jsonTriggerValue = null;
  let E;
  return Object.defineProperty(o.prototype, "value", { get: $util$1.oneOfGetter(E = ["triggerValue", "boolValue", "doubleValue", "intValue", "stringValue", "doubleArrayValue", "intArrayValue", "stringArrayValue", "jsonValue", "arrowValue", "bytesValue", "fileUploaderStateValue", "stringTriggerValue", "chatInputValue", "jsonTriggerValue"]), set: $util$1.oneOfSetter(E) }), o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, e) {
    return e || (e = $Writer$1.create()), g.id != null && Object.hasOwnProperty.call(g, "id") && e.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.id), g.triggerValue != null && Object.hasOwnProperty.call(g, "triggerValue") && e.uint32(
      /* id 2, wireType 0 =*/
      16
    ).bool(g.triggerValue), g.boolValue != null && Object.hasOwnProperty.call(g, "boolValue") && e.uint32(
      /* id 3, wireType 0 =*/
      24
    ).bool(g.boolValue), g.doubleValue != null && Object.hasOwnProperty.call(g, "doubleValue") && e.uint32(
      /* id 4, wireType 1 =*/
      33
    ).double(g.doubleValue), g.intValue != null && Object.hasOwnProperty.call(g, "intValue") && e.uint32(
      /* id 5, wireType 0 =*/
      40
    ).sint64(g.intValue), g.stringValue != null && Object.hasOwnProperty.call(g, "stringValue") && e.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(g.stringValue), g.doubleArrayValue != null && Object.hasOwnProperty.call(g, "doubleArrayValue") && $root$1.DoubleArray.encode(g.doubleArrayValue, e.uint32(
      /* id 7, wireType 2 =*/
      58
    ).fork()).ldelim(), g.intArrayValue != null && Object.hasOwnProperty.call(g, "intArrayValue") && $root$1.SInt64Array.encode(g.intArrayValue, e.uint32(
      /* id 8, wireType 2 =*/
      66
    ).fork()).ldelim(), g.stringArrayValue != null && Object.hasOwnProperty.call(g, "stringArrayValue") && $root$1.StringArray.encode(g.stringArrayValue, e.uint32(
      /* id 9, wireType 2 =*/
      74
    ).fork()).ldelim(), g.jsonValue != null && Object.hasOwnProperty.call(g, "jsonValue") && e.uint32(
      /* id 10, wireType 2 =*/
      82
    ).string(g.jsonValue), g.arrowValue != null && Object.hasOwnProperty.call(g, "arrowValue") && $root$1.ArrowTable.encode(g.arrowValue, e.uint32(
      /* id 11, wireType 2 =*/
      90
    ).fork()).ldelim(), g.bytesValue != null && Object.hasOwnProperty.call(g, "bytesValue") && e.uint32(
      /* id 12, wireType 2 =*/
      98
    ).bytes(g.bytesValue), g.fileUploaderStateValue != null && Object.hasOwnProperty.call(g, "fileUploaderStateValue") && $root$1.FileUploaderState.encode(g.fileUploaderStateValue, e.uint32(
      /* id 13, wireType 2 =*/
      106
    ).fork()).ldelim(), g.stringTriggerValue != null && Object.hasOwnProperty.call(g, "stringTriggerValue") && $root$1.StringTriggerValue.encode(g.stringTriggerValue, e.uint32(
      /* id 14, wireType 2 =*/
      114
    ).fork()).ldelim(), g.chatInputValue != null && Object.hasOwnProperty.call(g, "chatInputValue") && $root$1.ChatInputValue.encode(g.chatInputValue, e.uint32(
      /* id 15, wireType 2 =*/
      122
    ).fork()).ldelim(), g.jsonTriggerValue != null && Object.hasOwnProperty.call(g, "jsonTriggerValue") && e.uint32(
      /* id 16, wireType 2 =*/
      130
    ).string(g.jsonTriggerValue), e;
  }, o.decode = function(g, e, t) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let c = e === void 0 ? g.len : g.pos + e, n = new $root$1.WidgetState();
    for (; g.pos < c; ) {
      let h = g.uint32();
      if (h === t) break;
      switch (h >>> 3) {
        case 1: {
          n.id = g.string();
          break;
        }
        case 2: {
          n.triggerValue = g.bool();
          break;
        }
        case 3: {
          n.boolValue = g.bool();
          break;
        }
        case 4: {
          n.doubleValue = g.double();
          break;
        }
        case 5: {
          n.intValue = g.sint64();
          break;
        }
        case 6: {
          n.stringValue = g.string();
          break;
        }
        case 7: {
          n.doubleArrayValue = $root$1.DoubleArray.decode(g, g.uint32());
          break;
        }
        case 8: {
          n.intArrayValue = $root$1.SInt64Array.decode(g, g.uint32());
          break;
        }
        case 9: {
          n.stringArrayValue = $root$1.StringArray.decode(g, g.uint32());
          break;
        }
        case 10: {
          n.jsonValue = g.string();
          break;
        }
        case 11: {
          n.arrowValue = $root$1.ArrowTable.decode(g, g.uint32());
          break;
        }
        case 12: {
          n.bytesValue = g.bytes();
          break;
        }
        case 13: {
          n.fileUploaderStateValue = $root$1.FileUploaderState.decode(g, g.uint32());
          break;
        }
        case 14: {
          n.stringTriggerValue = $root$1.StringTriggerValue.decode(g, g.uint32());
          break;
        }
        case 15: {
          n.chatInputValue = $root$1.ChatInputValue.decode(g, g.uint32());
          break;
        }
        case 16: {
          n.jsonTriggerValue = g.string();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.WidgetState) return g;
    let e = new $root$1.WidgetState();
    if (g.id != null && (e.id = String(g.id)), g.triggerValue != null && (e.triggerValue = !!g.triggerValue), g.boolValue != null && (e.boolValue = !!g.boolValue), g.doubleValue != null && (e.doubleValue = Number(g.doubleValue)), g.intValue != null && ($util$1.Long ? (e.intValue = $util$1.Long.fromValue(g.intValue)).unsigned = !1 : typeof g.intValue == "string" ? e.intValue = parseInt(g.intValue, 10) : typeof g.intValue == "number" ? e.intValue = g.intValue : typeof g.intValue == "object" && (e.intValue = new $util$1.LongBits(g.intValue.low >>> 0, g.intValue.high >>> 0).toNumber())), g.stringValue != null && (e.stringValue = String(g.stringValue)), g.doubleArrayValue != null) {
      if (typeof g.doubleArrayValue != "object") throw TypeError(".WidgetState.doubleArrayValue: object expected");
      e.doubleArrayValue = $root$1.DoubleArray.fromObject(g.doubleArrayValue);
    }
    if (g.intArrayValue != null) {
      if (typeof g.intArrayValue != "object") throw TypeError(".WidgetState.intArrayValue: object expected");
      e.intArrayValue = $root$1.SInt64Array.fromObject(g.intArrayValue);
    }
    if (g.stringArrayValue != null) {
      if (typeof g.stringArrayValue != "object") throw TypeError(".WidgetState.stringArrayValue: object expected");
      e.stringArrayValue = $root$1.StringArray.fromObject(g.stringArrayValue);
    }
    if (g.jsonValue != null && (e.jsonValue = String(g.jsonValue)), g.arrowValue != null) {
      if (typeof g.arrowValue != "object") throw TypeError(".WidgetState.arrowValue: object expected");
      e.arrowValue = $root$1.ArrowTable.fromObject(g.arrowValue);
    }
    if (g.bytesValue != null && (typeof g.bytesValue == "string" ? $util$1.base64.decode(g.bytesValue, e.bytesValue = $util$1.newBuffer($util$1.base64.length(g.bytesValue)), 0) : g.bytesValue.length >= 0 && (e.bytesValue = g.bytesValue)), g.fileUploaderStateValue != null) {
      if (typeof g.fileUploaderStateValue != "object") throw TypeError(".WidgetState.fileUploaderStateValue: object expected");
      e.fileUploaderStateValue = $root$1.FileUploaderState.fromObject(g.fileUploaderStateValue);
    }
    if (g.stringTriggerValue != null) {
      if (typeof g.stringTriggerValue != "object") throw TypeError(".WidgetState.stringTriggerValue: object expected");
      e.stringTriggerValue = $root$1.StringTriggerValue.fromObject(g.stringTriggerValue);
    }
    if (g.chatInputValue != null) {
      if (typeof g.chatInputValue != "object") throw TypeError(".WidgetState.chatInputValue: object expected");
      e.chatInputValue = $root$1.ChatInputValue.fromObject(g.chatInputValue);
    }
    return g.jsonTriggerValue != null && (e.jsonTriggerValue = String(g.jsonTriggerValue)), e;
  }, o.toObject = function(g, e) {
    e || (e = {});
    let t = {};
    return e.defaults && (t.id = ""), g.id != null && g.hasOwnProperty("id") && (t.id = g.id), g.triggerValue != null && g.hasOwnProperty("triggerValue") && (t.triggerValue = g.triggerValue, e.oneofs && (t.value = "triggerValue")), g.boolValue != null && g.hasOwnProperty("boolValue") && (t.boolValue = g.boolValue, e.oneofs && (t.value = "boolValue")), g.doubleValue != null && g.hasOwnProperty("doubleValue") && (t.doubleValue = e.json && !isFinite(g.doubleValue) ? String(g.doubleValue) : g.doubleValue, e.oneofs && (t.value = "doubleValue")), g.intValue != null && g.hasOwnProperty("intValue") && (typeof g.intValue == "number" ? t.intValue = e.longs === String ? String(g.intValue) : g.intValue : t.intValue = e.longs === String ? $util$1.Long.prototype.toString.call(g.intValue) : e.longs === Number ? new $util$1.LongBits(g.intValue.low >>> 0, g.intValue.high >>> 0).toNumber() : g.intValue, e.oneofs && (t.value = "intValue")), g.stringValue != null && g.hasOwnProperty("stringValue") && (t.stringValue = g.stringValue, e.oneofs && (t.value = "stringValue")), g.doubleArrayValue != null && g.hasOwnProperty("doubleArrayValue") && (t.doubleArrayValue = $root$1.DoubleArray.toObject(g.doubleArrayValue, e), e.oneofs && (t.value = "doubleArrayValue")), g.intArrayValue != null && g.hasOwnProperty("intArrayValue") && (t.intArrayValue = $root$1.SInt64Array.toObject(g.intArrayValue, e), e.oneofs && (t.value = "intArrayValue")), g.stringArrayValue != null && g.hasOwnProperty("stringArrayValue") && (t.stringArrayValue = $root$1.StringArray.toObject(g.stringArrayValue, e), e.oneofs && (t.value = "stringArrayValue")), g.jsonValue != null && g.hasOwnProperty("jsonValue") && (t.jsonValue = g.jsonValue, e.oneofs && (t.value = "jsonValue")), g.arrowValue != null && g.hasOwnProperty("arrowValue") && (t.arrowValue = $root$1.ArrowTable.toObject(g.arrowValue, e), e.oneofs && (t.value = "arrowValue")), g.bytesValue != null && g.hasOwnProperty("bytesValue") && (t.bytesValue = e.bytes === String ? $util$1.base64.encode(g.bytesValue, 0, g.bytesValue.length) : e.bytes === Array ? Array.prototype.slice.call(g.bytesValue) : g.bytesValue, e.oneofs && (t.value = "bytesValue")), g.fileUploaderStateValue != null && g.hasOwnProperty("fileUploaderStateValue") && (t.fileUploaderStateValue = $root$1.FileUploaderState.toObject(g.fileUploaderStateValue, e), e.oneofs && (t.value = "fileUploaderStateValue")), g.stringTriggerValue != null && g.hasOwnProperty("stringTriggerValue") && (t.stringTriggerValue = $root$1.StringTriggerValue.toObject(g.stringTriggerValue, e), e.oneofs && (t.value = "stringTriggerValue")), g.chatInputValue != null && g.hasOwnProperty("chatInputValue") && (t.chatInputValue = $root$1.ChatInputValue.toObject(g.chatInputValue, e), e.oneofs && (t.value = "chatInputValue")), g.jsonTriggerValue != null && g.hasOwnProperty("jsonTriggerValue") && (t.jsonTriggerValue = g.jsonTriggerValue, e.oneofs && (t.value = "jsonTriggerValue")), t;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/WidgetState";
  }, o;
})(), StringArray = $root$1.StringArray = (() => {
  function o(E) {
    if (this.data = [], E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.data = $util$1.emptyArray, o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    if (g || (g = $Writer$1.create()), A.data != null && A.data.length) for (let e = 0; e < A.data.length; ++e) g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(A.data[e]);
    return g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader$1 || (A = $Reader$1.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root$1.StringArray();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.data && c.data.length || (c.data = []), c.data.push(A.string());
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root$1.StringArray) return A;
    let g = new $root$1.StringArray();
    if (A.data) {
      if (!Array.isArray(A.data)) throw TypeError(".StringArray.data: array expected");
      g.data = [];
      for (let e = 0; e < A.data.length; ++e) g.data[e] = String(A.data[e]);
    }
    return g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    if ((g.arrays || g.defaults) && (e.data = []), A.data && A.data.length) {
      e.data = [];
      for (let t = 0; t < A.data.length; ++t) e.data[t] = A.data[t];
    }
    return e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/StringArray";
  }, o;
})(), DoubleArray = $root$1.DoubleArray = (() => {
  function o(E) {
    if (this.data = [], E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.data = $util$1.emptyArray, o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    if (g || (g = $Writer$1.create()), A.data != null && A.data.length) {
      g.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork();
      for (let e = 0; e < A.data.length; ++e) g.double(A.data[e]);
      g.ldelim();
    }
    return g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader$1 || (A = $Reader$1.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root$1.DoubleArray();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          if (c.data && c.data.length || (c.data = []), (n & 7) === 2) {
            let h = A.uint32() + A.pos;
            for (; A.pos < h; ) c.data.push(A.double());
          } else c.data.push(A.double());
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root$1.DoubleArray) return A;
    let g = new $root$1.DoubleArray();
    if (A.data) {
      if (!Array.isArray(A.data)) throw TypeError(".DoubleArray.data: array expected");
      g.data = [];
      for (let e = 0; e < A.data.length; ++e) g.data[e] = Number(A.data[e]);
    }
    return g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    if ((g.arrays || g.defaults) && (e.data = []), A.data && A.data.length) {
      e.data = [];
      for (let t = 0; t < A.data.length; ++t) e.data[t] = g.json && !isFinite(A.data[t]) ? String(A.data[t]) : A.data[t];
    }
    return e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/DoubleArray";
  }, o;
})();
$root$1.Int32Array = (() => {
  function o(E) {
    if (this.data = [], E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.data = $util$1.emptyArray, o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    if (g || (g = $Writer$1.create()), A.data != null && A.data.length) {
      g.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork();
      for (let e = 0; e < A.data.length; ++e) g.int32(A.data[e]);
      g.ldelim();
    }
    return g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader$1 || (A = $Reader$1.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root$1.Int32Array();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          if (c.data && c.data.length || (c.data = []), (n & 7) === 2) {
            let h = A.uint32() + A.pos;
            for (; A.pos < h; ) c.data.push(A.int32());
          } else c.data.push(A.int32());
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root$1.Int32Array) return A;
    let g = new $root$1.Int32Array();
    if (A.data) {
      if (!Array.isArray(A.data)) throw TypeError(".Int32Array.data: array expected");
      g.data = [];
      for (let e = 0; e < A.data.length; ++e) g.data[e] = A.data[e] | 0;
    }
    return g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    if ((g.arrays || g.defaults) && (e.data = []), A.data && A.data.length) {
      e.data = [];
      for (let t = 0; t < A.data.length; ++t) e.data[t] = A.data[t];
    }
    return e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/Int32Array";
  }, o;
})();
$root$1.Int64Array = (() => {
  function o(E) {
    if (this.data = [], E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.data = $util$1.emptyArray, o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    if (g || (g = $Writer$1.create()), A.data != null && A.data.length) {
      g.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork();
      for (let e = 0; e < A.data.length; ++e) g.int64(A.data[e]);
      g.ldelim();
    }
    return g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader$1 || (A = $Reader$1.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root$1.Int64Array();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          if (c.data && c.data.length || (c.data = []), (n & 7) === 2) {
            let h = A.uint32() + A.pos;
            for (; A.pos < h; ) c.data.push(A.int64());
          } else c.data.push(A.int64());
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root$1.Int64Array) return A;
    let g = new $root$1.Int64Array();
    if (A.data) {
      if (!Array.isArray(A.data)) throw TypeError(".Int64Array.data: array expected");
      g.data = [];
      for (let e = 0; e < A.data.length; ++e) $util$1.Long ? (g.data[e] = $util$1.Long.fromValue(A.data[e])).unsigned = !1 : typeof A.data[e] == "string" ? g.data[e] = parseInt(A.data[e], 10) : typeof A.data[e] == "number" ? g.data[e] = A.data[e] : typeof A.data[e] == "object" && (g.data[e] = new $util$1.LongBits(A.data[e].low >>> 0, A.data[e].high >>> 0).toNumber());
    }
    return g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    if ((g.arrays || g.defaults) && (e.data = []), A.data && A.data.length) {
      e.data = [];
      for (let t = 0; t < A.data.length; ++t) typeof A.data[t] == "number" ? e.data[t] = g.longs === String ? String(A.data[t]) : A.data[t] : e.data[t] = g.longs === String ? $util$1.Long.prototype.toString.call(A.data[t]) : g.longs === Number ? new $util$1.LongBits(A.data[t].low >>> 0, A.data[t].high >>> 0).toNumber() : A.data[t];
    }
    return e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/Int64Array";
  }, o;
})();
const SInt64Array = $root$1.SInt64Array = (() => {
  function o(E) {
    if (this.data = [], E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.data = $util$1.emptyArray, o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    if (g || (g = $Writer$1.create()), A.data != null && A.data.length) {
      g.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork();
      for (let e = 0; e < A.data.length; ++e) g.sint64(A.data[e]);
      g.ldelim();
    }
    return g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader$1 || (A = $Reader$1.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root$1.SInt64Array();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          if (c.data && c.data.length || (c.data = []), (n & 7) === 2) {
            let h = A.uint32() + A.pos;
            for (; A.pos < h; ) c.data.push(A.sint64());
          } else c.data.push(A.sint64());
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root$1.SInt64Array) return A;
    let g = new $root$1.SInt64Array();
    if (A.data) {
      if (!Array.isArray(A.data)) throw TypeError(".SInt64Array.data: array expected");
      g.data = [];
      for (let e = 0; e < A.data.length; ++e) $util$1.Long ? (g.data[e] = $util$1.Long.fromValue(A.data[e])).unsigned = !1 : typeof A.data[e] == "string" ? g.data[e] = parseInt(A.data[e], 10) : typeof A.data[e] == "number" ? g.data[e] = A.data[e] : typeof A.data[e] == "object" && (g.data[e] = new $util$1.LongBits(A.data[e].low >>> 0, A.data[e].high >>> 0).toNumber());
    }
    return g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    if ((g.arrays || g.defaults) && (e.data = []), A.data && A.data.length) {
      e.data = [];
      for (let t = 0; t < A.data.length; ++t) typeof A.data[t] == "number" ? e.data[t] = g.longs === String ? String(A.data[t]) : A.data[t] : e.data[t] = g.longs === String ? $util$1.Long.prototype.toString.call(A.data[t]) : g.longs === Number ? new $util$1.LongBits(A.data[t].low >>> 0, A.data[t].high >>> 0).toNumber() : A.data[t];
    }
    return e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/SInt64Array";
  }, o;
})();
$root$1.UInt32Array = (() => {
  function o(E) {
    if (this.data = [], E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.data = $util$1.emptyArray, o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    if (g || (g = $Writer$1.create()), A.data != null && A.data.length) {
      g.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork();
      for (let e = 0; e < A.data.length; ++e) g.uint32(A.data[e]);
      g.ldelim();
    }
    return g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader$1 || (A = $Reader$1.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root$1.UInt32Array();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          if (c.data && c.data.length || (c.data = []), (n & 7) === 2) {
            let h = A.uint32() + A.pos;
            for (; A.pos < h; ) c.data.push(A.uint32());
          } else c.data.push(A.uint32());
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root$1.UInt32Array) return A;
    let g = new $root$1.UInt32Array();
    if (A.data) {
      if (!Array.isArray(A.data)) throw TypeError(".UInt32Array.data: array expected");
      g.data = [];
      for (let e = 0; e < A.data.length; ++e) g.data[e] = A.data[e] >>> 0;
    }
    return g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    if ((g.arrays || g.defaults) && (e.data = []), A.data && A.data.length) {
      e.data = [];
      for (let t = 0; t < A.data.length; ++t) e.data[t] = A.data[t];
    }
    return e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/UInt32Array";
  }, o;
})();
$root$1.StringTriggerValue = (() => {
  function o(A) {
    if (A) for (let g = Object.keys(A), e = 0; e < g.length; ++e) A[g[e]] != null && (this[g[e]] = A[g[e]]);
  }
  o.prototype.data = null;
  let E;
  return Object.defineProperty(o.prototype, "_data", { get: $util$1.oneOfGetter(E = ["data"]), set: $util$1.oneOfSetter(E) }), o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, e) {
    return e || (e = $Writer$1.create()), g.data != null && Object.hasOwnProperty.call(g, "data") && e.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.data), e;
  }, o.decode = function(g, e, t) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let c = e === void 0 ? g.len : g.pos + e, n = new $root$1.StringTriggerValue();
    for (; g.pos < c; ) {
      let h = g.uint32();
      if (h === t) break;
      switch (h >>> 3) {
        case 1: {
          n.data = g.string();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.StringTriggerValue) return g;
    let e = new $root$1.StringTriggerValue();
    return g.data != null && (e.data = String(g.data)), e;
  }, o.toObject = function(g, e) {
    e || (e = {});
    let t = {};
    return g.data != null && g.hasOwnProperty("data") && (t.data = g.data, e.oneofs && (t._data = "data")), t;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/StringTriggerValue";
  }, o;
})();
$root$1.FileURLsRequest = (() => {
  function o(E) {
    if (this.fileNames = [], E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.requestId = "", o.prototype.fileNames = $util$1.emptyArray, o.prototype.sessionId = "", o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    if (g || (g = $Writer$1.create()), A.requestId != null && Object.hasOwnProperty.call(A, "requestId") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(A.requestId), A.fileNames != null && A.fileNames.length) for (let e = 0; e < A.fileNames.length; ++e) g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(A.fileNames[e]);
    return A.sessionId != null && Object.hasOwnProperty.call(A, "sessionId") && g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(A.sessionId), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader$1 || (A = $Reader$1.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root$1.FileURLsRequest();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.requestId = A.string();
          break;
        }
        case 2: {
          c.fileNames && c.fileNames.length || (c.fileNames = []), c.fileNames.push(A.string());
          break;
        }
        case 3: {
          c.sessionId = A.string();
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root$1.FileURLsRequest) return A;
    let g = new $root$1.FileURLsRequest();
    if (A.requestId != null && (g.requestId = String(A.requestId)), A.fileNames) {
      if (!Array.isArray(A.fileNames)) throw TypeError(".FileURLsRequest.fileNames: array expected");
      g.fileNames = [];
      for (let e = 0; e < A.fileNames.length; ++e) g.fileNames[e] = String(A.fileNames[e]);
    }
    return A.sessionId != null && (g.sessionId = String(A.sessionId)), g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    if ((g.arrays || g.defaults) && (e.fileNames = []), g.defaults && (e.requestId = "", e.sessionId = ""), A.requestId != null && A.hasOwnProperty("requestId") && (e.requestId = A.requestId), A.fileNames && A.fileNames.length) {
      e.fileNames = [];
      for (let t = 0; t < A.fileNames.length; ++t) e.fileNames[t] = A.fileNames[t];
    }
    return A.sessionId != null && A.hasOwnProperty("sessionId") && (e.sessionId = A.sessionId), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/FileURLsRequest";
  }, o;
})();
$root$1.FileURLs = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.fileId = "", o.prototype.uploadUrl = "", o.prototype.deleteUrl = "", o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    return g || (g = $Writer$1.create()), A.fileId != null && Object.hasOwnProperty.call(A, "fileId") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(A.fileId), A.uploadUrl != null && Object.hasOwnProperty.call(A, "uploadUrl") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(A.uploadUrl), A.deleteUrl != null && Object.hasOwnProperty.call(A, "deleteUrl") && g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(A.deleteUrl), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader$1 || (A = $Reader$1.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root$1.FileURLs();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.fileId = A.string();
          break;
        }
        case 2: {
          c.uploadUrl = A.string();
          break;
        }
        case 3: {
          c.deleteUrl = A.string();
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root$1.FileURLs) return A;
    let g = new $root$1.FileURLs();
    return A.fileId != null && (g.fileId = String(A.fileId)), A.uploadUrl != null && (g.uploadUrl = String(A.uploadUrl)), A.deleteUrl != null && (g.deleteUrl = String(A.deleteUrl)), g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    return g.defaults && (e.fileId = "", e.uploadUrl = "", e.deleteUrl = ""), A.fileId != null && A.hasOwnProperty("fileId") && (e.fileId = A.fileId), A.uploadUrl != null && A.hasOwnProperty("uploadUrl") && (e.uploadUrl = A.uploadUrl), A.deleteUrl != null && A.hasOwnProperty("deleteUrl") && (e.deleteUrl = A.deleteUrl), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/FileURLs";
  }, o;
})();
$root$1.FileURLsResponse = (() => {
  function o(E) {
    if (this.fileUrls = [], E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.responseId = "", o.prototype.fileUrls = $util$1.emptyArray, o.prototype.errorMsg = "", o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    if (g || (g = $Writer$1.create()), A.responseId != null && Object.hasOwnProperty.call(A, "responseId") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(A.responseId), A.fileUrls != null && A.fileUrls.length) for (let e = 0; e < A.fileUrls.length; ++e) $root$1.FileURLs.encode(A.fileUrls[e], g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim();
    return A.errorMsg != null && Object.hasOwnProperty.call(A, "errorMsg") && g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(A.errorMsg), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader$1 || (A = $Reader$1.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root$1.FileURLsResponse();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.responseId = A.string();
          break;
        }
        case 2: {
          c.fileUrls && c.fileUrls.length || (c.fileUrls = []), c.fileUrls.push($root$1.FileURLs.decode(A, A.uint32()));
          break;
        }
        case 3: {
          c.errorMsg = A.string();
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root$1.FileURLsResponse) return A;
    let g = new $root$1.FileURLsResponse();
    if (A.responseId != null && (g.responseId = String(A.responseId)), A.fileUrls) {
      if (!Array.isArray(A.fileUrls)) throw TypeError(".FileURLsResponse.fileUrls: array expected");
      g.fileUrls = [];
      for (let e = 0; e < A.fileUrls.length; ++e) {
        if (typeof A.fileUrls[e] != "object") throw TypeError(".FileURLsResponse.fileUrls: object expected");
        g.fileUrls[e] = $root$1.FileURLs.fromObject(A.fileUrls[e]);
      }
    }
    return A.errorMsg != null && (g.errorMsg = String(A.errorMsg)), g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    if ((g.arrays || g.defaults) && (e.fileUrls = []), g.defaults && (e.responseId = "", e.errorMsg = ""), A.responseId != null && A.hasOwnProperty("responseId") && (e.responseId = A.responseId), A.fileUrls && A.fileUrls.length) {
      e.fileUrls = [];
      for (let t = 0; t < A.fileUrls.length; ++t) e.fileUrls[t] = $root$1.FileURLs.toObject(A.fileUrls[t], g);
    }
    return A.errorMsg != null && A.hasOwnProperty("errorMsg") && (e.errorMsg = A.errorMsg), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/FileURLsResponse";
  }, o;
})();
const UploadedFileInfo = $root$1.UploadedFileInfo = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.id = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, o.prototype.name = "", o.prototype.size = $util$1.Long ? $util$1.Long.fromBits(0, 0, !0) : 0, o.prototype.fileId = "", o.prototype.fileUrls = null, o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    return g || (g = $Writer$1.create()), A.id != null && Object.hasOwnProperty.call(A, "id") && g.uint32(
      /* id 1, wireType 0 =*/
      8
    ).sint64(A.id), A.name != null && Object.hasOwnProperty.call(A, "name") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(A.name), A.size != null && Object.hasOwnProperty.call(A, "size") && g.uint32(
      /* id 3, wireType 0 =*/
      24
    ).uint64(A.size), A.fileId != null && Object.hasOwnProperty.call(A, "fileId") && g.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(A.fileId), A.fileUrls != null && Object.hasOwnProperty.call(A, "fileUrls") && $root$1.FileURLs.encode(A.fileUrls, g.uint32(
      /* id 5, wireType 2 =*/
      42
    ).fork()).ldelim(), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader$1 || (A = $Reader$1.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root$1.UploadedFileInfo();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.id = A.sint64();
          break;
        }
        case 2: {
          c.name = A.string();
          break;
        }
        case 3: {
          c.size = A.uint64();
          break;
        }
        case 4: {
          c.fileId = A.string();
          break;
        }
        case 5: {
          c.fileUrls = $root$1.FileURLs.decode(A, A.uint32());
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root$1.UploadedFileInfo) return A;
    let g = new $root$1.UploadedFileInfo();
    if (A.id != null && ($util$1.Long ? (g.id = $util$1.Long.fromValue(A.id)).unsigned = !1 : typeof A.id == "string" ? g.id = parseInt(A.id, 10) : typeof A.id == "number" ? g.id = A.id : typeof A.id == "object" && (g.id = new $util$1.LongBits(A.id.low >>> 0, A.id.high >>> 0).toNumber())), A.name != null && (g.name = String(A.name)), A.size != null && ($util$1.Long ? (g.size = $util$1.Long.fromValue(A.size)).unsigned = !0 : typeof A.size == "string" ? g.size = parseInt(A.size, 10) : typeof A.size == "number" ? g.size = A.size : typeof A.size == "object" && (g.size = new $util$1.LongBits(A.size.low >>> 0, A.size.high >>> 0).toNumber(!0))), A.fileId != null && (g.fileId = String(A.fileId)), A.fileUrls != null) {
      if (typeof A.fileUrls != "object") throw TypeError(".UploadedFileInfo.fileUrls: object expected");
      g.fileUrls = $root$1.FileURLs.fromObject(A.fileUrls);
    }
    return g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    if (g.defaults) {
      if ($util$1.Long) {
        let t = new $util$1.Long(0, 0, !1);
        e.id = g.longs === String ? t.toString() : g.longs === Number ? t.toNumber() : t;
      } else e.id = g.longs === String ? "0" : 0;
      if (e.name = "", $util$1.Long) {
        let t = new $util$1.Long(0, 0, !0);
        e.size = g.longs === String ? t.toString() : g.longs === Number ? t.toNumber() : t;
      } else e.size = g.longs === String ? "0" : 0;
      e.fileId = "", e.fileUrls = null;
    }
    return A.id != null && A.hasOwnProperty("id") && (typeof A.id == "number" ? e.id = g.longs === String ? String(A.id) : A.id : e.id = g.longs === String ? $util$1.Long.prototype.toString.call(A.id) : g.longs === Number ? new $util$1.LongBits(A.id.low >>> 0, A.id.high >>> 0).toNumber() : A.id), A.name != null && A.hasOwnProperty("name") && (e.name = A.name), A.size != null && A.hasOwnProperty("size") && (typeof A.size == "number" ? e.size = g.longs === String ? String(A.size) : A.size : e.size = g.longs === String ? $util$1.Long.prototype.toString.call(A.size) : g.longs === Number ? new $util$1.LongBits(A.size.low >>> 0, A.size.high >>> 0).toNumber(!0) : A.size), A.fileId != null && A.hasOwnProperty("fileId") && (e.fileId = A.fileId), A.fileUrls != null && A.hasOwnProperty("fileUrls") && (e.fileUrls = $root$1.FileURLs.toObject(A.fileUrls, g)), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/UploadedFileInfo";
  }, o;
})(), FileUploaderState = $root$1.FileUploaderState = (() => {
  function o(E) {
    if (this.uploadedFileInfo = [], E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.maxFileId = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, o.prototype.uploadedFileInfo = $util$1.emptyArray, o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    if (g || (g = $Writer$1.create()), A.maxFileId != null && Object.hasOwnProperty.call(A, "maxFileId") && g.uint32(
      /* id 1, wireType 0 =*/
      8
    ).sint64(A.maxFileId), A.uploadedFileInfo != null && A.uploadedFileInfo.length) for (let e = 0; e < A.uploadedFileInfo.length; ++e) $root$1.UploadedFileInfo.encode(A.uploadedFileInfo[e], g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim();
    return g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader$1 || (A = $Reader$1.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root$1.FileUploaderState();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.maxFileId = A.sint64();
          break;
        }
        case 2: {
          c.uploadedFileInfo && c.uploadedFileInfo.length || (c.uploadedFileInfo = []), c.uploadedFileInfo.push($root$1.UploadedFileInfo.decode(A, A.uint32()));
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root$1.FileUploaderState) return A;
    let g = new $root$1.FileUploaderState();
    if (A.maxFileId != null && ($util$1.Long ? (g.maxFileId = $util$1.Long.fromValue(A.maxFileId)).unsigned = !1 : typeof A.maxFileId == "string" ? g.maxFileId = parseInt(A.maxFileId, 10) : typeof A.maxFileId == "number" ? g.maxFileId = A.maxFileId : typeof A.maxFileId == "object" && (g.maxFileId = new $util$1.LongBits(A.maxFileId.low >>> 0, A.maxFileId.high >>> 0).toNumber())), A.uploadedFileInfo) {
      if (!Array.isArray(A.uploadedFileInfo)) throw TypeError(".FileUploaderState.uploadedFileInfo: array expected");
      g.uploadedFileInfo = [];
      for (let e = 0; e < A.uploadedFileInfo.length; ++e) {
        if (typeof A.uploadedFileInfo[e] != "object") throw TypeError(".FileUploaderState.uploadedFileInfo: object expected");
        g.uploadedFileInfo[e] = $root$1.UploadedFileInfo.fromObject(A.uploadedFileInfo[e]);
      }
    }
    return g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    if ((g.arrays || g.defaults) && (e.uploadedFileInfo = []), g.defaults) if ($util$1.Long) {
      let t = new $util$1.Long(0, 0, !1);
      e.maxFileId = g.longs === String ? t.toString() : g.longs === Number ? t.toNumber() : t;
    } else e.maxFileId = g.longs === String ? "0" : 0;
    if (A.maxFileId != null && A.hasOwnProperty("maxFileId") && (typeof A.maxFileId == "number" ? e.maxFileId = g.longs === String ? String(A.maxFileId) : A.maxFileId : e.maxFileId = g.longs === String ? $util$1.Long.prototype.toString.call(A.maxFileId) : g.longs === Number ? new $util$1.LongBits(A.maxFileId.low >>> 0, A.maxFileId.high >>> 0).toNumber() : A.maxFileId), A.uploadedFileInfo && A.uploadedFileInfo.length) {
      e.uploadedFileInfo = [];
      for (let t = 0; t < A.uploadedFileInfo.length; ++t) e.uploadedFileInfo[t] = $root$1.UploadedFileInfo.toObject(A.uploadedFileInfo[t], g);
    }
    return e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/FileUploaderState";
  }, o;
})(), ChatInputValue = $root$1.ChatInputValue = (() => {
  function o(A) {
    if (A) for (let g = Object.keys(A), e = 0; e < g.length; ++e) A[g[e]] != null && (this[g[e]] = A[g[e]]);
  }
  o.prototype.data = null, o.prototype.fileUploaderState = null, o.prototype.audioFileInfo = null;
  let E;
  return Object.defineProperty(o.prototype, "_data", { get: $util$1.oneOfGetter(E = ["data"]), set: $util$1.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_fileUploaderState", { get: $util$1.oneOfGetter(E = ["fileUploaderState"]), set: $util$1.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_audioFileInfo", { get: $util$1.oneOfGetter(E = ["audioFileInfo"]), set: $util$1.oneOfSetter(E) }), o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, e) {
    return e || (e = $Writer$1.create()), g.data != null && Object.hasOwnProperty.call(g, "data") && e.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.data), g.fileUploaderState != null && Object.hasOwnProperty.call(g, "fileUploaderState") && $root$1.FileUploaderState.encode(g.fileUploaderState, e.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), g.audioFileInfo != null && Object.hasOwnProperty.call(g, "audioFileInfo") && $root$1.UploadedFileInfo.encode(g.audioFileInfo, e.uint32(
      /* id 3, wireType 2 =*/
      26
    ).fork()).ldelim(), e;
  }, o.decode = function(g, e, t) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let c = e === void 0 ? g.len : g.pos + e, n = new $root$1.ChatInputValue();
    for (; g.pos < c; ) {
      let h = g.uint32();
      if (h === t) break;
      switch (h >>> 3) {
        case 1: {
          n.data = g.string();
          break;
        }
        case 2: {
          n.fileUploaderState = $root$1.FileUploaderState.decode(g, g.uint32());
          break;
        }
        case 3: {
          n.audioFileInfo = $root$1.UploadedFileInfo.decode(g, g.uint32());
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.ChatInputValue) return g;
    let e = new $root$1.ChatInputValue();
    if (g.data != null && (e.data = String(g.data)), g.fileUploaderState != null) {
      if (typeof g.fileUploaderState != "object") throw TypeError(".ChatInputValue.fileUploaderState: object expected");
      e.fileUploaderState = $root$1.FileUploaderState.fromObject(g.fileUploaderState);
    }
    if (g.audioFileInfo != null) {
      if (typeof g.audioFileInfo != "object") throw TypeError(".ChatInputValue.audioFileInfo: object expected");
      e.audioFileInfo = $root$1.UploadedFileInfo.fromObject(g.audioFileInfo);
    }
    return e;
  }, o.toObject = function(g, e) {
    e || (e = {});
    let t = {};
    return g.data != null && g.hasOwnProperty("data") && (t.data = g.data, e.oneofs && (t._data = "data")), g.fileUploaderState != null && g.hasOwnProperty("fileUploaderState") && (t.fileUploaderState = $root$1.FileUploaderState.toObject(g.fileUploaderState, e), e.oneofs && (t._fileUploaderState = "fileUploaderState")), g.audioFileInfo != null && g.hasOwnProperty("audioFileInfo") && (t.audioFileInfo = $root$1.UploadedFileInfo.toObject(g.audioFileInfo, e), e.oneofs && (t._audioFileInfo = "audioFileInfo")), t;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/ChatInputValue";
  }, o;
})();
$root$1.ComponentInstance = (() => {
  function o(A) {
    if (this.specialArgs = [], A) for (let g = Object.keys(A), e = 0; e < g.length; ++e) A[g[e]] != null && (this[g[e]] = A[g[e]]);
  }
  o.prototype.id = "", o.prototype.jsonArgs = "", o.prototype.specialArgs = $util$1.emptyArray, o.prototype.componentName = "", o.prototype.url = "", o.prototype.formId = "", o.prototype.tabIndex = null;
  let E;
  return Object.defineProperty(o.prototype, "_tabIndex", { get: $util$1.oneOfGetter(E = ["tabIndex"]), set: $util$1.oneOfSetter(E) }), o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, e) {
    if (e || (e = $Writer$1.create()), g.id != null && Object.hasOwnProperty.call(g, "id") && e.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.id), g.jsonArgs != null && Object.hasOwnProperty.call(g, "jsonArgs") && e.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.jsonArgs), g.specialArgs != null && g.specialArgs.length) for (let t = 0; t < g.specialArgs.length; ++t) $root$1.SpecialArg.encode(g.specialArgs[t], e.uint32(
      /* id 3, wireType 2 =*/
      26
    ).fork()).ldelim();
    return g.componentName != null && Object.hasOwnProperty.call(g, "componentName") && e.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(g.componentName), g.url != null && Object.hasOwnProperty.call(g, "url") && e.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(g.url), g.formId != null && Object.hasOwnProperty.call(g, "formId") && e.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(g.formId), g.tabIndex != null && Object.hasOwnProperty.call(g, "tabIndex") && e.uint32(
      /* id 7, wireType 0 =*/
      56
    ).int32(g.tabIndex), e;
  }, o.decode = function(g, e, t) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let c = e === void 0 ? g.len : g.pos + e, n = new $root$1.ComponentInstance();
    for (; g.pos < c; ) {
      let h = g.uint32();
      if (h === t) break;
      switch (h >>> 3) {
        case 1: {
          n.id = g.string();
          break;
        }
        case 2: {
          n.jsonArgs = g.string();
          break;
        }
        case 3: {
          n.specialArgs && n.specialArgs.length || (n.specialArgs = []), n.specialArgs.push($root$1.SpecialArg.decode(g, g.uint32()));
          break;
        }
        case 4: {
          n.componentName = g.string();
          break;
        }
        case 5: {
          n.url = g.string();
          break;
        }
        case 6: {
          n.formId = g.string();
          break;
        }
        case 7: {
          n.tabIndex = g.int32();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.ComponentInstance) return g;
    let e = new $root$1.ComponentInstance();
    if (g.id != null && (e.id = String(g.id)), g.jsonArgs != null && (e.jsonArgs = String(g.jsonArgs)), g.specialArgs) {
      if (!Array.isArray(g.specialArgs)) throw TypeError(".ComponentInstance.specialArgs: array expected");
      e.specialArgs = [];
      for (let t = 0; t < g.specialArgs.length; ++t) {
        if (typeof g.specialArgs[t] != "object") throw TypeError(".ComponentInstance.specialArgs: object expected");
        e.specialArgs[t] = $root$1.SpecialArg.fromObject(g.specialArgs[t]);
      }
    }
    return g.componentName != null && (e.componentName = String(g.componentName)), g.url != null && (e.url = String(g.url)), g.formId != null && (e.formId = String(g.formId)), g.tabIndex != null && (e.tabIndex = g.tabIndex | 0), e;
  }, o.toObject = function(g, e) {
    e || (e = {});
    let t = {};
    if ((e.arrays || e.defaults) && (t.specialArgs = []), e.defaults && (t.id = "", t.jsonArgs = "", t.componentName = "", t.url = "", t.formId = ""), g.id != null && g.hasOwnProperty("id") && (t.id = g.id), g.jsonArgs != null && g.hasOwnProperty("jsonArgs") && (t.jsonArgs = g.jsonArgs), g.specialArgs && g.specialArgs.length) {
      t.specialArgs = [];
      for (let c = 0; c < g.specialArgs.length; ++c) t.specialArgs[c] = $root$1.SpecialArg.toObject(g.specialArgs[c], e);
    }
    return g.componentName != null && g.hasOwnProperty("componentName") && (t.componentName = g.componentName), g.url != null && g.hasOwnProperty("url") && (t.url = g.url), g.formId != null && g.hasOwnProperty("formId") && (t.formId = g.formId), g.tabIndex != null && g.hasOwnProperty("tabIndex") && (t.tabIndex = g.tabIndex, e.oneofs && (t._tabIndex = "tabIndex")), t;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/ComponentInstance";
  }, o;
})();
$root$1.SpecialArg = (() => {
  function o(A) {
    if (A) for (let g = Object.keys(A), e = 0; e < g.length; ++e) A[g[e]] != null && (this[g[e]] = A[g[e]]);
  }
  o.prototype.key = "", o.prototype.arrowDataframe = null, o.prototype.bytes = null;
  let E;
  return Object.defineProperty(o.prototype, "value", { get: $util$1.oneOfGetter(E = ["arrowDataframe", "bytes"]), set: $util$1.oneOfSetter(E) }), o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, e) {
    return e || (e = $Writer$1.create()), g.key != null && Object.hasOwnProperty.call(g, "key") && e.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.key), g.arrowDataframe != null && Object.hasOwnProperty.call(g, "arrowDataframe") && $root$1.ArrowDataframe.encode(g.arrowDataframe, e.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), g.bytes != null && Object.hasOwnProperty.call(g, "bytes") && e.uint32(
      /* id 3, wireType 2 =*/
      26
    ).bytes(g.bytes), e;
  }, o.decode = function(g, e, t) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let c = e === void 0 ? g.len : g.pos + e, n = new $root$1.SpecialArg();
    for (; g.pos < c; ) {
      let h = g.uint32();
      if (h === t) break;
      switch (h >>> 3) {
        case 1: {
          n.key = g.string();
          break;
        }
        case 2: {
          n.arrowDataframe = $root$1.ArrowDataframe.decode(g, g.uint32());
          break;
        }
        case 3: {
          n.bytes = g.bytes();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.SpecialArg) return g;
    let e = new $root$1.SpecialArg();
    if (g.key != null && (e.key = String(g.key)), g.arrowDataframe != null) {
      if (typeof g.arrowDataframe != "object") throw TypeError(".SpecialArg.arrowDataframe: object expected");
      e.arrowDataframe = $root$1.ArrowDataframe.fromObject(g.arrowDataframe);
    }
    return g.bytes != null && (typeof g.bytes == "string" ? $util$1.base64.decode(g.bytes, e.bytes = $util$1.newBuffer($util$1.base64.length(g.bytes)), 0) : g.bytes.length >= 0 && (e.bytes = g.bytes)), e;
  }, o.toObject = function(g, e) {
    e || (e = {});
    let t = {};
    return e.defaults && (t.key = ""), g.key != null && g.hasOwnProperty("key") && (t.key = g.key), g.arrowDataframe != null && g.hasOwnProperty("arrowDataframe") && (t.arrowDataframe = $root$1.ArrowDataframe.toObject(g.arrowDataframe, e), e.oneofs && (t.value = "arrowDataframe")), g.bytes != null && g.hasOwnProperty("bytes") && (t.bytes = e.bytes === String ? $util$1.base64.encode(g.bytes, 0, g.bytes.length) : e.bytes === Array ? Array.prototype.slice.call(g.bytes) : g.bytes, e.oneofs && (t.value = "bytes")), t;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/SpecialArg";
  }, o;
})();
const ArrowDataframe = $root$1.ArrowDataframe = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.data = null, o.prototype.height = 0, o.prototype.width = 0, o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    return g || (g = $Writer$1.create()), A.data != null && Object.hasOwnProperty.call(A, "data") && $root$1.ArrowTable.encode(A.data, g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim(), A.height != null && Object.hasOwnProperty.call(A, "height") && g.uint32(
      /* id 2, wireType 0 =*/
      16
    ).uint32(A.height), A.width != null && Object.hasOwnProperty.call(A, "width") && g.uint32(
      /* id 3, wireType 0 =*/
      24
    ).uint32(A.width), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader$1 || (A = $Reader$1.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root$1.ArrowDataframe();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.data = $root$1.ArrowTable.decode(A, A.uint32());
          break;
        }
        case 2: {
          c.height = A.uint32();
          break;
        }
        case 3: {
          c.width = A.uint32();
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root$1.ArrowDataframe) return A;
    let g = new $root$1.ArrowDataframe();
    if (A.data != null) {
      if (typeof A.data != "object") throw TypeError(".ArrowDataframe.data: object expected");
      g.data = $root$1.ArrowTable.fromObject(A.data);
    }
    return A.height != null && (g.height = A.height >>> 0), A.width != null && (g.width = A.width >>> 0), g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    return g.defaults && (e.data = null, e.height = 0, e.width = 0), A.data != null && A.hasOwnProperty("data") && (e.data = $root$1.ArrowTable.toObject(A.data, g)), A.height != null && A.hasOwnProperty("height") && (e.height = A.height), A.width != null && A.hasOwnProperty("width") && (e.width = A.width), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/ArrowDataframe";
  }, o;
})();
$root$1.ArrowTable = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.data = $util$1.newBuffer([]), o.prototype.index = $util$1.newBuffer([]), o.prototype.columns = $util$1.newBuffer([]), o.prototype.styler = null, o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    return g || (g = $Writer$1.create()), A.data != null && Object.hasOwnProperty.call(A, "data") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).bytes(A.data), A.index != null && Object.hasOwnProperty.call(A, "index") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).bytes(A.index), A.columns != null && Object.hasOwnProperty.call(A, "columns") && g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).bytes(A.columns), A.styler != null && Object.hasOwnProperty.call(A, "styler") && $root$1.ArrowTableStyler.encode(A.styler, g.uint32(
      /* id 5, wireType 2 =*/
      42
    ).fork()).ldelim(), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader$1 || (A = $Reader$1.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root$1.ArrowTable();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.data = A.bytes();
          break;
        }
        case 2: {
          c.index = A.bytes();
          break;
        }
        case 3: {
          c.columns = A.bytes();
          break;
        }
        case 5: {
          c.styler = $root$1.ArrowTableStyler.decode(A, A.uint32());
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root$1.ArrowTable) return A;
    let g = new $root$1.ArrowTable();
    if (A.data != null && (typeof A.data == "string" ? $util$1.base64.decode(A.data, g.data = $util$1.newBuffer($util$1.base64.length(A.data)), 0) : A.data.length >= 0 && (g.data = A.data)), A.index != null && (typeof A.index == "string" ? $util$1.base64.decode(A.index, g.index = $util$1.newBuffer($util$1.base64.length(A.index)), 0) : A.index.length >= 0 && (g.index = A.index)), A.columns != null && (typeof A.columns == "string" ? $util$1.base64.decode(A.columns, g.columns = $util$1.newBuffer($util$1.base64.length(A.columns)), 0) : A.columns.length >= 0 && (g.columns = A.columns)), A.styler != null) {
      if (typeof A.styler != "object") throw TypeError(".ArrowTable.styler: object expected");
      g.styler = $root$1.ArrowTableStyler.fromObject(A.styler);
    }
    return g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    return g.defaults && (g.bytes === String ? e.data = "" : (e.data = [], g.bytes !== Array && (e.data = $util$1.newBuffer(e.data))), g.bytes === String ? e.index = "" : (e.index = [], g.bytes !== Array && (e.index = $util$1.newBuffer(e.index))), g.bytes === String ? e.columns = "" : (e.columns = [], g.bytes !== Array && (e.columns = $util$1.newBuffer(e.columns))), e.styler = null), A.data != null && A.hasOwnProperty("data") && (e.data = g.bytes === String ? $util$1.base64.encode(A.data, 0, A.data.length) : g.bytes === Array ? Array.prototype.slice.call(A.data) : A.data), A.index != null && A.hasOwnProperty("index") && (e.index = g.bytes === String ? $util$1.base64.encode(A.index, 0, A.index.length) : g.bytes === Array ? Array.prototype.slice.call(A.index) : A.index), A.columns != null && A.hasOwnProperty("columns") && (e.columns = g.bytes === String ? $util$1.base64.encode(A.columns, 0, A.columns.length) : g.bytes === Array ? Array.prototype.slice.call(A.columns) : A.columns), A.styler != null && A.hasOwnProperty("styler") && (e.styler = $root$1.ArrowTableStyler.toObject(A.styler, g)), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/ArrowTable";
  }, o;
})();
$root$1.ArrowTableStyler = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.uuid = "", o.prototype.caption = "", o.prototype.styles = "", o.prototype.displayValues = $util$1.newBuffer([]), o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    return g || (g = $Writer$1.create()), A.uuid != null && Object.hasOwnProperty.call(A, "uuid") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(A.uuid), A.caption != null && Object.hasOwnProperty.call(A, "caption") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(A.caption), A.styles != null && Object.hasOwnProperty.call(A, "styles") && g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(A.styles), A.displayValues != null && Object.hasOwnProperty.call(A, "displayValues") && g.uint32(
      /* id 4, wireType 2 =*/
      34
    ).bytes(A.displayValues), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader$1 || (A = $Reader$1.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root$1.ArrowTableStyler();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.uuid = A.string();
          break;
        }
        case 2: {
          c.caption = A.string();
          break;
        }
        case 3: {
          c.styles = A.string();
          break;
        }
        case 4: {
          c.displayValues = A.bytes();
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root$1.ArrowTableStyler) return A;
    let g = new $root$1.ArrowTableStyler();
    return A.uuid != null && (g.uuid = String(A.uuid)), A.caption != null && (g.caption = String(A.caption)), A.styles != null && (g.styles = String(A.styles)), A.displayValues != null && (typeof A.displayValues == "string" ? $util$1.base64.decode(A.displayValues, g.displayValues = $util$1.newBuffer($util$1.base64.length(A.displayValues)), 0) : A.displayValues.length >= 0 && (g.displayValues = A.displayValues)), g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    return g.defaults && (e.uuid = "", e.caption = "", e.styles = "", g.bytes === String ? e.displayValues = "" : (e.displayValues = [], g.bytes !== Array && (e.displayValues = $util$1.newBuffer(e.displayValues)))), A.uuid != null && A.hasOwnProperty("uuid") && (e.uuid = A.uuid), A.caption != null && A.hasOwnProperty("caption") && (e.caption = A.caption), A.styles != null && A.hasOwnProperty("styles") && (e.styles = A.styles), A.displayValues != null && A.hasOwnProperty("displayValues") && (e.displayValues = g.bytes === String ? $util$1.base64.encode(A.displayValues, 0, A.displayValues.length) : g.bytes === Array ? Array.prototype.slice.call(A.displayValues) : A.displayValues), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/ArrowTableStyler";
  }, o;
})();
$root$1.Balloons = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.show = !1, o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    return g || (g = $Writer$1.create()), A.show != null && Object.hasOwnProperty.call(A, "show") && g.uint32(
      /* id 3, wireType 0 =*/
      24
    ).bool(A.show), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader$1 || (A = $Reader$1.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root$1.Balloons();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 3: {
          c.show = A.bool();
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root$1.Balloons) return A;
    let g = new $root$1.Balloons();
    return A.show != null && (g.show = !!A.show), g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    return g.defaults && (e.show = !1), A.show != null && A.hasOwnProperty("show") && (e.show = A.show), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/Balloons";
  }, o;
})();
$root$1.MixedData = (() => {
  function o(E) {
    if (this.arrowBlobs = {}, E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.json = "", o.prototype.arrowBlobs = $util$1.emptyObject, o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    if (g || (g = $Writer$1.create()), A.json != null && Object.hasOwnProperty.call(A, "json") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(A.json), A.arrowBlobs != null && Object.hasOwnProperty.call(A, "arrowBlobs")) for (let e = Object.keys(A.arrowBlobs), t = 0; t < e.length; ++t)
      g.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork().uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e[t]), $root$1.ArrowData.encode(A.arrowBlobs[e[t]], g.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim().ldelim();
    return g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader$1 || (A = $Reader$1.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root$1.MixedData(), n, h;
    for (; A.pos < t; ) {
      let d = A.uint32();
      if (d === e) break;
      switch (d >>> 3) {
        case 1: {
          c.json = A.string();
          break;
        }
        case 2: {
          c.arrowBlobs === $util$1.emptyObject && (c.arrowBlobs = {});
          let k = A.uint32() + A.pos;
          for (n = "", h = null; A.pos < k; ) {
            let p = A.uint32();
            switch (p >>> 3) {
              case 1:
                n = A.string();
                break;
              case 2:
                h = $root$1.ArrowData.decode(A, A.uint32());
                break;
              default:
                A.skipType(p & 7);
                break;
            }
          }
          c.arrowBlobs[n] = h;
          break;
        }
        default:
          A.skipType(d & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root$1.MixedData) return A;
    let g = new $root$1.MixedData();
    if (A.json != null && (g.json = String(A.json)), A.arrowBlobs) {
      if (typeof A.arrowBlobs != "object") throw TypeError(".MixedData.arrowBlobs: object expected");
      g.arrowBlobs = {};
      for (let e = Object.keys(A.arrowBlobs), t = 0; t < e.length; ++t) {
        if (typeof A.arrowBlobs[e[t]] != "object") throw TypeError(".MixedData.arrowBlobs: object expected");
        g.arrowBlobs[e[t]] = $root$1.ArrowData.fromObject(A.arrowBlobs[e[t]]);
      }
    }
    return g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    (g.objects || g.defaults) && (e.arrowBlobs = {}), g.defaults && (e.json = ""), A.json != null && A.hasOwnProperty("json") && (e.json = A.json);
    let t;
    if (A.arrowBlobs && (t = Object.keys(A.arrowBlobs)).length) {
      e.arrowBlobs = {};
      for (let c = 0; c < t.length; ++c) e.arrowBlobs[t[c]] = $root$1.ArrowData.toObject(A.arrowBlobs[t[c]], g);
    }
    return e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/MixedData";
  }, o;
})();
$root$1.BidiComponent = (() => {
  function o(A) {
    if (A) for (let g = Object.keys(A), e = 0; e < g.length; ++e) A[g[e]] != null && (this[g[e]] = A[g[e]]);
  }
  o.prototype.id = "", o.prototype.componentName = "", o.prototype.jsContent = null, o.prototype.jsSourcePath = null, o.prototype.formId = "", o.prototype.htmlContent = null, o.prototype.cssContent = null, o.prototype.cssSourcePath = null, o.prototype.isolateStyles = !1, o.prototype.json = null, o.prototype.arrowData = null, o.prototype.bytes = null, o.prototype.mixed = null;
  let E;
  return Object.defineProperty(o.prototype, "_jsContent", { get: $util$1.oneOfGetter(E = ["jsContent"]), set: $util$1.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_jsSourcePath", { get: $util$1.oneOfGetter(E = ["jsSourcePath"]), set: $util$1.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_htmlContent", { get: $util$1.oneOfGetter(E = ["htmlContent"]), set: $util$1.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_cssContent", { get: $util$1.oneOfGetter(E = ["cssContent"]), set: $util$1.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_cssSourcePath", { get: $util$1.oneOfGetter(E = ["cssSourcePath"]), set: $util$1.oneOfSetter(E) }), Object.defineProperty(o.prototype, "data", { get: $util$1.oneOfGetter(E = ["json", "arrowData", "bytes", "mixed"]), set: $util$1.oneOfSetter(E) }), o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, e) {
    return e || (e = $Writer$1.create()), g.id != null && Object.hasOwnProperty.call(g, "id") && e.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.id), g.componentName != null && Object.hasOwnProperty.call(g, "componentName") && e.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.componentName), g.jsContent != null && Object.hasOwnProperty.call(g, "jsContent") && e.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(g.jsContent), g.jsSourcePath != null && Object.hasOwnProperty.call(g, "jsSourcePath") && e.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(g.jsSourcePath), g.formId != null && Object.hasOwnProperty.call(g, "formId") && e.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(g.formId), g.htmlContent != null && Object.hasOwnProperty.call(g, "htmlContent") && e.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(g.htmlContent), g.cssContent != null && Object.hasOwnProperty.call(g, "cssContent") && e.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(g.cssContent), g.cssSourcePath != null && Object.hasOwnProperty.call(g, "cssSourcePath") && e.uint32(
      /* id 8, wireType 2 =*/
      66
    ).string(g.cssSourcePath), g.isolateStyles != null && Object.hasOwnProperty.call(g, "isolateStyles") && e.uint32(
      /* id 9, wireType 0 =*/
      72
    ).bool(g.isolateStyles), g.json != null && Object.hasOwnProperty.call(g, "json") && e.uint32(
      /* id 10, wireType 2 =*/
      82
    ).string(g.json), g.arrowData != null && Object.hasOwnProperty.call(g, "arrowData") && $root$1.ArrowData.encode(g.arrowData, e.uint32(
      /* id 11, wireType 2 =*/
      90
    ).fork()).ldelim(), g.bytes != null && Object.hasOwnProperty.call(g, "bytes") && e.uint32(
      /* id 12, wireType 2 =*/
      98
    ).bytes(g.bytes), g.mixed != null && Object.hasOwnProperty.call(g, "mixed") && $root$1.MixedData.encode(g.mixed, e.uint32(
      /* id 13, wireType 2 =*/
      106
    ).fork()).ldelim(), e;
  }, o.decode = function(g, e, t) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let c = e === void 0 ? g.len : g.pos + e, n = new $root$1.BidiComponent();
    for (; g.pos < c; ) {
      let h = g.uint32();
      if (h === t) break;
      switch (h >>> 3) {
        case 1: {
          n.id = g.string();
          break;
        }
        case 2: {
          n.componentName = g.string();
          break;
        }
        case 3: {
          n.jsContent = g.string();
          break;
        }
        case 4: {
          n.jsSourcePath = g.string();
          break;
        }
        case 5: {
          n.formId = g.string();
          break;
        }
        case 6: {
          n.htmlContent = g.string();
          break;
        }
        case 7: {
          n.cssContent = g.string();
          break;
        }
        case 8: {
          n.cssSourcePath = g.string();
          break;
        }
        case 9: {
          n.isolateStyles = g.bool();
          break;
        }
        case 10: {
          n.json = g.string();
          break;
        }
        case 11: {
          n.arrowData = $root$1.ArrowData.decode(g, g.uint32());
          break;
        }
        case 12: {
          n.bytes = g.bytes();
          break;
        }
        case 13: {
          n.mixed = $root$1.MixedData.decode(g, g.uint32());
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.BidiComponent) return g;
    let e = new $root$1.BidiComponent();
    if (g.id != null && (e.id = String(g.id)), g.componentName != null && (e.componentName = String(g.componentName)), g.jsContent != null && (e.jsContent = String(g.jsContent)), g.jsSourcePath != null && (e.jsSourcePath = String(g.jsSourcePath)), g.formId != null && (e.formId = String(g.formId)), g.htmlContent != null && (e.htmlContent = String(g.htmlContent)), g.cssContent != null && (e.cssContent = String(g.cssContent)), g.cssSourcePath != null && (e.cssSourcePath = String(g.cssSourcePath)), g.isolateStyles != null && (e.isolateStyles = !!g.isolateStyles), g.json != null && (e.json = String(g.json)), g.arrowData != null) {
      if (typeof g.arrowData != "object") throw TypeError(".BidiComponent.arrowData: object expected");
      e.arrowData = $root$1.ArrowData.fromObject(g.arrowData);
    }
    if (g.bytes != null && (typeof g.bytes == "string" ? $util$1.base64.decode(g.bytes, e.bytes = $util$1.newBuffer($util$1.base64.length(g.bytes)), 0) : g.bytes.length >= 0 && (e.bytes = g.bytes)), g.mixed != null) {
      if (typeof g.mixed != "object") throw TypeError(".BidiComponent.mixed: object expected");
      e.mixed = $root$1.MixedData.fromObject(g.mixed);
    }
    return e;
  }, o.toObject = function(g, e) {
    e || (e = {});
    let t = {};
    return e.defaults && (t.id = "", t.componentName = "", t.formId = "", t.isolateStyles = !1), g.id != null && g.hasOwnProperty("id") && (t.id = g.id), g.componentName != null && g.hasOwnProperty("componentName") && (t.componentName = g.componentName), g.jsContent != null && g.hasOwnProperty("jsContent") && (t.jsContent = g.jsContent, e.oneofs && (t._jsContent = "jsContent")), g.jsSourcePath != null && g.hasOwnProperty("jsSourcePath") && (t.jsSourcePath = g.jsSourcePath, e.oneofs && (t._jsSourcePath = "jsSourcePath")), g.formId != null && g.hasOwnProperty("formId") && (t.formId = g.formId), g.htmlContent != null && g.hasOwnProperty("htmlContent") && (t.htmlContent = g.htmlContent, e.oneofs && (t._htmlContent = "htmlContent")), g.cssContent != null && g.hasOwnProperty("cssContent") && (t.cssContent = g.cssContent, e.oneofs && (t._cssContent = "cssContent")), g.cssSourcePath != null && g.hasOwnProperty("cssSourcePath") && (t.cssSourcePath = g.cssSourcePath, e.oneofs && (t._cssSourcePath = "cssSourcePath")), g.isolateStyles != null && g.hasOwnProperty("isolateStyles") && (t.isolateStyles = g.isolateStyles), g.json != null && g.hasOwnProperty("json") && (t.json = g.json, e.oneofs && (t.data = "json")), g.arrowData != null && g.hasOwnProperty("arrowData") && (t.arrowData = $root$1.ArrowData.toObject(g.arrowData, e), e.oneofs && (t.data = "arrowData")), g.bytes != null && g.hasOwnProperty("bytes") && (t.bytes = e.bytes === String ? $util$1.base64.encode(g.bytes, 0, g.bytes.length) : e.bytes === Array ? Array.prototype.slice.call(g.bytes) : g.bytes, e.oneofs && (t.data = "bytes")), g.mixed != null && g.hasOwnProperty("mixed") && (t.mixed = $root$1.MixedData.toObject(g.mixed, e), e.oneofs && (t.data = "mixed")), t;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/BidiComponent";
  }, o;
})();
const Block$1 = $root$1.Block = (() => {
  function o(A) {
    if (A) for (let g = Object.keys(A), e = 0; e < g.length; ++e) A[g[e]] != null && (this[g[e]] = A[g[e]]);
  }
  o.prototype.vertical = null, o.prototype.horizontal = null, o.prototype.column = null, o.prototype.expandable = null, o.prototype.form = null, o.prototype.tabContainer = null, o.prototype.tab = null, o.prototype.chatMessage = null, o.prototype.popover = null, o.prototype.dialog = null, o.prototype.flexContainer = null, o.prototype.allowEmpty = !1, o.prototype.id = null, o.prototype.heightConfig = null, o.prototype.widthConfig = null;
  let E;
  return Object.defineProperty(o.prototype, "type", { get: $util$1.oneOfGetter(E = ["vertical", "horizontal", "column", "expandable", "form", "tabContainer", "tab", "chatMessage", "popover", "dialog", "flexContainer"]), set: $util$1.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_id", { get: $util$1.oneOfGetter(E = ["id"]), set: $util$1.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_heightConfig", { get: $util$1.oneOfGetter(E = ["heightConfig"]), set: $util$1.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_widthConfig", { get: $util$1.oneOfGetter(E = ["widthConfig"]), set: $util$1.oneOfSetter(E) }), o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, e) {
    return e || (e = $Writer$1.create()), g.vertical != null && Object.hasOwnProperty.call(g, "vertical") && $root$1.Block.Vertical.encode(g.vertical, e.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim(), g.horizontal != null && Object.hasOwnProperty.call(g, "horizontal") && $root$1.Block.Horizontal.encode(g.horizontal, e.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), g.column != null && Object.hasOwnProperty.call(g, "column") && $root$1.Block.Column.encode(g.column, e.uint32(
      /* id 3, wireType 2 =*/
      26
    ).fork()).ldelim(), g.expandable != null && Object.hasOwnProperty.call(g, "expandable") && $root$1.Block.Expandable.encode(g.expandable, e.uint32(
      /* id 4, wireType 2 =*/
      34
    ).fork()).ldelim(), g.form != null && Object.hasOwnProperty.call(g, "form") && $root$1.Block.Form.encode(g.form, e.uint32(
      /* id 5, wireType 2 =*/
      42
    ).fork()).ldelim(), g.tabContainer != null && Object.hasOwnProperty.call(g, "tabContainer") && $root$1.Block.TabContainer.encode(g.tabContainer, e.uint32(
      /* id 6, wireType 2 =*/
      50
    ).fork()).ldelim(), g.tab != null && Object.hasOwnProperty.call(g, "tab") && $root$1.Block.Tab.encode(g.tab, e.uint32(
      /* id 7, wireType 2 =*/
      58
    ).fork()).ldelim(), g.allowEmpty != null && Object.hasOwnProperty.call(g, "allowEmpty") && e.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(g.allowEmpty), g.chatMessage != null && Object.hasOwnProperty.call(g, "chatMessage") && $root$1.Block.ChatMessage.encode(g.chatMessage, e.uint32(
      /* id 9, wireType 2 =*/
      74
    ).fork()).ldelim(), g.popover != null && Object.hasOwnProperty.call(g, "popover") && $root$1.Block.Popover.encode(g.popover, e.uint32(
      /* id 10, wireType 2 =*/
      82
    ).fork()).ldelim(), g.dialog != null && Object.hasOwnProperty.call(g, "dialog") && $root$1.Block.Dialog.encode(g.dialog, e.uint32(
      /* id 11, wireType 2 =*/
      90
    ).fork()).ldelim(), g.id != null && Object.hasOwnProperty.call(g, "id") && e.uint32(
      /* id 12, wireType 2 =*/
      98
    ).string(g.id), g.flexContainer != null && Object.hasOwnProperty.call(g, "flexContainer") && $root$1.Block.FlexContainer.encode(g.flexContainer, e.uint32(
      /* id 13, wireType 2 =*/
      106
    ).fork()).ldelim(), g.heightConfig != null && Object.hasOwnProperty.call(g, "heightConfig") && $root$1.streamlit.HeightConfig.encode(g.heightConfig, e.uint32(
      /* id 14, wireType 2 =*/
      114
    ).fork()).ldelim(), g.widthConfig != null && Object.hasOwnProperty.call(g, "widthConfig") && $root$1.streamlit.WidthConfig.encode(g.widthConfig, e.uint32(
      /* id 15, wireType 2 =*/
      122
    ).fork()).ldelim(), e;
  }, o.decode = function(g, e, t) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let c = e === void 0 ? g.len : g.pos + e, n = new $root$1.Block();
    for (; g.pos < c; ) {
      let h = g.uint32();
      if (h === t) break;
      switch (h >>> 3) {
        case 1: {
          n.vertical = $root$1.Block.Vertical.decode(g, g.uint32());
          break;
        }
        case 2: {
          n.horizontal = $root$1.Block.Horizontal.decode(g, g.uint32());
          break;
        }
        case 3: {
          n.column = $root$1.Block.Column.decode(g, g.uint32());
          break;
        }
        case 4: {
          n.expandable = $root$1.Block.Expandable.decode(g, g.uint32());
          break;
        }
        case 5: {
          n.form = $root$1.Block.Form.decode(g, g.uint32());
          break;
        }
        case 6: {
          n.tabContainer = $root$1.Block.TabContainer.decode(g, g.uint32());
          break;
        }
        case 7: {
          n.tab = $root$1.Block.Tab.decode(g, g.uint32());
          break;
        }
        case 9: {
          n.chatMessage = $root$1.Block.ChatMessage.decode(g, g.uint32());
          break;
        }
        case 10: {
          n.popover = $root$1.Block.Popover.decode(g, g.uint32());
          break;
        }
        case 11: {
          n.dialog = $root$1.Block.Dialog.decode(g, g.uint32());
          break;
        }
        case 13: {
          n.flexContainer = $root$1.Block.FlexContainer.decode(g, g.uint32());
          break;
        }
        case 8: {
          n.allowEmpty = g.bool();
          break;
        }
        case 12: {
          n.id = g.string();
          break;
        }
        case 14: {
          n.heightConfig = $root$1.streamlit.HeightConfig.decode(g, g.uint32());
          break;
        }
        case 15: {
          n.widthConfig = $root$1.streamlit.WidthConfig.decode(g, g.uint32());
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.Block) return g;
    let e = new $root$1.Block();
    if (g.vertical != null) {
      if (typeof g.vertical != "object") throw TypeError(".Block.vertical: object expected");
      e.vertical = $root$1.Block.Vertical.fromObject(g.vertical);
    }
    if (g.horizontal != null) {
      if (typeof g.horizontal != "object") throw TypeError(".Block.horizontal: object expected");
      e.horizontal = $root$1.Block.Horizontal.fromObject(g.horizontal);
    }
    if (g.column != null) {
      if (typeof g.column != "object") throw TypeError(".Block.column: object expected");
      e.column = $root$1.Block.Column.fromObject(g.column);
    }
    if (g.expandable != null) {
      if (typeof g.expandable != "object") throw TypeError(".Block.expandable: object expected");
      e.expandable = $root$1.Block.Expandable.fromObject(g.expandable);
    }
    if (g.form != null) {
      if (typeof g.form != "object") throw TypeError(".Block.form: object expected");
      e.form = $root$1.Block.Form.fromObject(g.form);
    }
    if (g.tabContainer != null) {
      if (typeof g.tabContainer != "object") throw TypeError(".Block.tabContainer: object expected");
      e.tabContainer = $root$1.Block.TabContainer.fromObject(g.tabContainer);
    }
    if (g.tab != null) {
      if (typeof g.tab != "object") throw TypeError(".Block.tab: object expected");
      e.tab = $root$1.Block.Tab.fromObject(g.tab);
    }
    if (g.chatMessage != null) {
      if (typeof g.chatMessage != "object") throw TypeError(".Block.chatMessage: object expected");
      e.chatMessage = $root$1.Block.ChatMessage.fromObject(g.chatMessage);
    }
    if (g.popover != null) {
      if (typeof g.popover != "object") throw TypeError(".Block.popover: object expected");
      e.popover = $root$1.Block.Popover.fromObject(g.popover);
    }
    if (g.dialog != null) {
      if (typeof g.dialog != "object") throw TypeError(".Block.dialog: object expected");
      e.dialog = $root$1.Block.Dialog.fromObject(g.dialog);
    }
    if (g.flexContainer != null) {
      if (typeof g.flexContainer != "object") throw TypeError(".Block.flexContainer: object expected");
      e.flexContainer = $root$1.Block.FlexContainer.fromObject(g.flexContainer);
    }
    if (g.allowEmpty != null && (e.allowEmpty = !!g.allowEmpty), g.id != null && (e.id = String(g.id)), g.heightConfig != null) {
      if (typeof g.heightConfig != "object") throw TypeError(".Block.heightConfig: object expected");
      e.heightConfig = $root$1.streamlit.HeightConfig.fromObject(g.heightConfig);
    }
    if (g.widthConfig != null) {
      if (typeof g.widthConfig != "object") throw TypeError(".Block.widthConfig: object expected");
      e.widthConfig = $root$1.streamlit.WidthConfig.fromObject(g.widthConfig);
    }
    return e;
  }, o.toObject = function(g, e) {
    e || (e = {});
    let t = {};
    return e.defaults && (t.allowEmpty = !1), g.vertical != null && g.hasOwnProperty("vertical") && (t.vertical = $root$1.Block.Vertical.toObject(g.vertical, e), e.oneofs && (t.type = "vertical")), g.horizontal != null && g.hasOwnProperty("horizontal") && (t.horizontal = $root$1.Block.Horizontal.toObject(g.horizontal, e), e.oneofs && (t.type = "horizontal")), g.column != null && g.hasOwnProperty("column") && (t.column = $root$1.Block.Column.toObject(g.column, e), e.oneofs && (t.type = "column")), g.expandable != null && g.hasOwnProperty("expandable") && (t.expandable = $root$1.Block.Expandable.toObject(g.expandable, e), e.oneofs && (t.type = "expandable")), g.form != null && g.hasOwnProperty("form") && (t.form = $root$1.Block.Form.toObject(g.form, e), e.oneofs && (t.type = "form")), g.tabContainer != null && g.hasOwnProperty("tabContainer") && (t.tabContainer = $root$1.Block.TabContainer.toObject(g.tabContainer, e), e.oneofs && (t.type = "tabContainer")), g.tab != null && g.hasOwnProperty("tab") && (t.tab = $root$1.Block.Tab.toObject(g.tab, e), e.oneofs && (t.type = "tab")), g.allowEmpty != null && g.hasOwnProperty("allowEmpty") && (t.allowEmpty = g.allowEmpty), g.chatMessage != null && g.hasOwnProperty("chatMessage") && (t.chatMessage = $root$1.Block.ChatMessage.toObject(g.chatMessage, e), e.oneofs && (t.type = "chatMessage")), g.popover != null && g.hasOwnProperty("popover") && (t.popover = $root$1.Block.Popover.toObject(g.popover, e), e.oneofs && (t.type = "popover")), g.dialog != null && g.hasOwnProperty("dialog") && (t.dialog = $root$1.Block.Dialog.toObject(g.dialog, e), e.oneofs && (t.type = "dialog")), g.id != null && g.hasOwnProperty("id") && (t.id = g.id, e.oneofs && (t._id = "id")), g.flexContainer != null && g.hasOwnProperty("flexContainer") && (t.flexContainer = $root$1.Block.FlexContainer.toObject(g.flexContainer, e), e.oneofs && (t.type = "flexContainer")), g.heightConfig != null && g.hasOwnProperty("heightConfig") && (t.heightConfig = $root$1.streamlit.HeightConfig.toObject(g.heightConfig, e), e.oneofs && (t._heightConfig = "heightConfig")), g.widthConfig != null && g.hasOwnProperty("widthConfig") && (t.widthConfig = $root$1.streamlit.WidthConfig.toObject(g.widthConfig, e), e.oneofs && (t._widthConfig = "widthConfig")), t;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/Block";
  }, o.Vertical = (function() {
    function A(g) {
      if (g) for (let e = Object.keys(g), t = 0; t < e.length; ++t) g[e[t]] != null && (this[e[t]] = g[e[t]]);
    }
    return A.prototype.border = !1, A.prototype.height = 0, A.create = function(e) {
      return new A(e);
    }, A.encode = function(e, t) {
      return t || (t = $Writer$1.create()), e.border != null && Object.hasOwnProperty.call(e, "border") && t.uint32(
        /* id 1, wireType 0 =*/
        8
      ).bool(e.border), e.height != null && Object.hasOwnProperty.call(e, "height") && t.uint32(
        /* id 2, wireType 0 =*/
        16
      ).uint32(e.height), t;
    }, A.decode = function(e, t, c) {
      e instanceof $Reader$1 || (e = $Reader$1.create(e));
      let n = t === void 0 ? e.len : e.pos + t, h = new $root$1.Block.Vertical();
      for (; e.pos < n; ) {
        let d = e.uint32();
        if (d === c) break;
        switch (d >>> 3) {
          case 1: {
            h.border = e.bool();
            break;
          }
          case 2: {
            h.height = e.uint32();
            break;
          }
          default:
            e.skipType(d & 7);
            break;
        }
      }
      return h;
    }, A.fromObject = function(e) {
      if (e instanceof $root$1.Block.Vertical) return e;
      let t = new $root$1.Block.Vertical();
      return e.border != null && (t.border = !!e.border), e.height != null && (t.height = e.height >>> 0), t;
    }, A.toObject = function(e, t) {
      t || (t = {});
      let c = {};
      return t.defaults && (c.border = !1, c.height = 0), e.border != null && e.hasOwnProperty("border") && (c.border = e.border), e.height != null && e.hasOwnProperty("height") && (c.height = e.height), c;
    }, A.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
    }, A.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/Block.Vertical";
    }, A;
  })(), o.Horizontal = (function() {
    function A(g) {
      if (g) for (let e = Object.keys(g), t = 0; t < e.length; ++t) g[e[t]] != null && (this[e[t]] = g[e[t]]);
    }
    return A.prototype.gap = "", A.create = function(e) {
      return new A(e);
    }, A.encode = function(e, t) {
      return t || (t = $Writer$1.create()), e.gap != null && Object.hasOwnProperty.call(e, "gap") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.gap), t;
    }, A.decode = function(e, t, c) {
      e instanceof $Reader$1 || (e = $Reader$1.create(e));
      let n = t === void 0 ? e.len : e.pos + t, h = new $root$1.Block.Horizontal();
      for (; e.pos < n; ) {
        let d = e.uint32();
        if (d === c) break;
        switch (d >>> 3) {
          case 1: {
            h.gap = e.string();
            break;
          }
          default:
            e.skipType(d & 7);
            break;
        }
      }
      return h;
    }, A.fromObject = function(e) {
      if (e instanceof $root$1.Block.Horizontal) return e;
      let t = new $root$1.Block.Horizontal();
      return e.gap != null && (t.gap = String(e.gap)), t;
    }, A.toObject = function(e, t) {
      t || (t = {});
      let c = {};
      return t.defaults && (c.gap = ""), e.gap != null && e.hasOwnProperty("gap") && (c.gap = e.gap), c;
    }, A.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
    }, A.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/Block.Horizontal";
    }, A;
  })(), o.FlexContainer = (function() {
    function A(g) {
      if (g) for (let e = Object.keys(g), t = 0; t < e.length; ++t) g[e[t]] != null && (this[e[t]] = g[e[t]]);
    }
    return A.prototype.border = !1, A.prototype.gapConfig = null, A.prototype.scale = 0, A.prototype.direction = 0, A.prototype.wrap = !1, A.prototype.justify = 0, A.prototype.align = 0, A.create = function(e) {
      return new A(e);
    }, A.encode = function(e, t) {
      return t || (t = $Writer$1.create()), e.border != null && Object.hasOwnProperty.call(e, "border") && t.uint32(
        /* id 1, wireType 0 =*/
        8
      ).bool(e.border), e.gapConfig != null && Object.hasOwnProperty.call(e, "gapConfig") && $root$1.streamlit.GapConfig.encode(e.gapConfig, t.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), e.scale != null && Object.hasOwnProperty.call(e, "scale") && t.uint32(
        /* id 3, wireType 5 =*/
        29
      ).float(e.scale), e.direction != null && Object.hasOwnProperty.call(e, "direction") && t.uint32(
        /* id 4, wireType 0 =*/
        32
      ).int32(e.direction), e.wrap != null && Object.hasOwnProperty.call(e, "wrap") && t.uint32(
        /* id 5, wireType 0 =*/
        40
      ).bool(e.wrap), e.justify != null && Object.hasOwnProperty.call(e, "justify") && t.uint32(
        /* id 7, wireType 0 =*/
        56
      ).int32(e.justify), e.align != null && Object.hasOwnProperty.call(e, "align") && t.uint32(
        /* id 8, wireType 0 =*/
        64
      ).int32(e.align), t;
    }, A.decode = function(e, t, c) {
      e instanceof $Reader$1 || (e = $Reader$1.create(e));
      let n = t === void 0 ? e.len : e.pos + t, h = new $root$1.Block.FlexContainer();
      for (; e.pos < n; ) {
        let d = e.uint32();
        if (d === c) break;
        switch (d >>> 3) {
          case 1: {
            h.border = e.bool();
            break;
          }
          case 2: {
            h.gapConfig = $root$1.streamlit.GapConfig.decode(e, e.uint32());
            break;
          }
          case 3: {
            h.scale = e.float();
            break;
          }
          case 4: {
            h.direction = e.int32();
            break;
          }
          case 5: {
            h.wrap = e.bool();
            break;
          }
          case 7: {
            h.justify = e.int32();
            break;
          }
          case 8: {
            h.align = e.int32();
            break;
          }
          default:
            e.skipType(d & 7);
            break;
        }
      }
      return h;
    }, A.fromObject = function(e) {
      if (e instanceof $root$1.Block.FlexContainer) return e;
      let t = new $root$1.Block.FlexContainer();
      if (e.border != null && (t.border = !!e.border), e.gapConfig != null) {
        if (typeof e.gapConfig != "object") throw TypeError(".Block.FlexContainer.gapConfig: object expected");
        t.gapConfig = $root$1.streamlit.GapConfig.fromObject(e.gapConfig);
      }
      switch (e.scale != null && (t.scale = Number(e.scale)), e.direction) {
        default:
          if (typeof e.direction == "number") {
            t.direction = e.direction;
            break;
          }
          break;
        case "DIRECTION_UNDEFINED":
        case 0:
          t.direction = 0;
          break;
        case "VERTICAL":
        case 1:
          t.direction = 1;
          break;
        case "HORIZONTAL":
        case 2:
          t.direction = 2;
          break;
      }
      switch (e.wrap != null && (t.wrap = !!e.wrap), e.justify) {
        default:
          if (typeof e.justify == "number") {
            t.justify = e.justify;
            break;
          }
          break;
        case "JUSTIFY_UNDEFINED":
        case 0:
          t.justify = 0;
          break;
        case "JUSTIFY_START":
        case 1:
          t.justify = 1;
          break;
        case "JUSTIFY_END":
        case 2:
          t.justify = 2;
          break;
        case "JUSTIFY_CENTER":
        case 3:
          t.justify = 3;
          break;
        case "SPACE_BETWEEN":
        case 4:
          t.justify = 4;
          break;
      }
      switch (e.align) {
        default:
          if (typeof e.align == "number") {
            t.align = e.align;
            break;
          }
          break;
        case "ALIGN_UNDEFINED":
        case 0:
          t.align = 0;
          break;
        case "ALIGN_START":
        case 1:
          t.align = 1;
          break;
        case "ALIGN_END":
        case 2:
          t.align = 2;
          break;
        case "ALIGN_CENTER":
        case 3:
          t.align = 3;
          break;
        case "STRETCH":
        case 4:
          t.align = 4;
          break;
      }
      return t;
    }, A.toObject = function(e, t) {
      t || (t = {});
      let c = {};
      return t.defaults && (c.border = !1, c.gapConfig = null, c.scale = 0, c.direction = t.enums === String ? "DIRECTION_UNDEFINED" : 0, c.wrap = !1, c.justify = t.enums === String ? "JUSTIFY_UNDEFINED" : 0, c.align = t.enums === String ? "ALIGN_UNDEFINED" : 0), e.border != null && e.hasOwnProperty("border") && (c.border = e.border), e.gapConfig != null && e.hasOwnProperty("gapConfig") && (c.gapConfig = $root$1.streamlit.GapConfig.toObject(e.gapConfig, t)), e.scale != null && e.hasOwnProperty("scale") && (c.scale = t.json && !isFinite(e.scale) ? String(e.scale) : e.scale), e.direction != null && e.hasOwnProperty("direction") && (c.direction = t.enums === String ? $root$1.Block.FlexContainer.Direction[e.direction] === void 0 ? e.direction : $root$1.Block.FlexContainer.Direction[e.direction] : e.direction), e.wrap != null && e.hasOwnProperty("wrap") && (c.wrap = e.wrap), e.justify != null && e.hasOwnProperty("justify") && (c.justify = t.enums === String ? $root$1.Block.FlexContainer.Justify[e.justify] === void 0 ? e.justify : $root$1.Block.FlexContainer.Justify[e.justify] : e.justify), e.align != null && e.hasOwnProperty("align") && (c.align = t.enums === String ? $root$1.Block.FlexContainer.Align[e.align] === void 0 ? e.align : $root$1.Block.FlexContainer.Align[e.align] : e.align), c;
    }, A.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
    }, A.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/Block.FlexContainer";
    }, A.Direction = (function() {
      const g = {}, e = Object.create(g);
      return e[g[0] = "DIRECTION_UNDEFINED"] = 0, e[g[1] = "VERTICAL"] = 1, e[g[2] = "HORIZONTAL"] = 2, e;
    })(), A.Justify = (function() {
      const g = {}, e = Object.create(g);
      return e[g[0] = "JUSTIFY_UNDEFINED"] = 0, e[g[1] = "JUSTIFY_START"] = 1, e[g[2] = "JUSTIFY_END"] = 2, e[g[3] = "JUSTIFY_CENTER"] = 3, e[g[4] = "SPACE_BETWEEN"] = 4, e;
    })(), A.Align = (function() {
      const g = {}, e = Object.create(g);
      return e[g[0] = "ALIGN_UNDEFINED"] = 0, e[g[1] = "ALIGN_START"] = 1, e[g[2] = "ALIGN_END"] = 2, e[g[3] = "ALIGN_CENTER"] = 3, e[g[4] = "STRETCH"] = 4, e;
    })(), A;
  })(), o.Column = (function() {
    function A(e) {
      if (e) for (let t = Object.keys(e), c = 0; c < t.length; ++c) e[t[c]] != null && (this[t[c]] = e[t[c]]);
    }
    A.prototype.weight = 0, A.prototype.gap = "", A.prototype.verticalAlignment = 0, A.prototype.showBorder = !1, A.prototype.gapConfig = null;
    let g;
    return Object.defineProperty(A.prototype, "_gapConfig", { get: $util$1.oneOfGetter(g = ["gapConfig"]), set: $util$1.oneOfSetter(g) }), A.create = function(t) {
      return new A(t);
    }, A.encode = function(t, c) {
      return c || (c = $Writer$1.create()), t.weight != null && Object.hasOwnProperty.call(t, "weight") && c.uint32(
        /* id 1, wireType 1 =*/
        9
      ).double(t.weight), t.gap != null && Object.hasOwnProperty.call(t, "gap") && c.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(t.gap), t.verticalAlignment != null && Object.hasOwnProperty.call(t, "verticalAlignment") && c.uint32(
        /* id 3, wireType 0 =*/
        24
      ).int32(t.verticalAlignment), t.showBorder != null && Object.hasOwnProperty.call(t, "showBorder") && c.uint32(
        /* id 4, wireType 0 =*/
        32
      ).bool(t.showBorder), t.gapConfig != null && Object.hasOwnProperty.call(t, "gapConfig") && $root$1.streamlit.GapConfig.encode(t.gapConfig, c.uint32(
        /* id 5, wireType 2 =*/
        42
      ).fork()).ldelim(), c;
    }, A.decode = function(t, c, n) {
      t instanceof $Reader$1 || (t = $Reader$1.create(t));
      let h = c === void 0 ? t.len : t.pos + c, d = new $root$1.Block.Column();
      for (; t.pos < h; ) {
        let k = t.uint32();
        if (k === n) break;
        switch (k >>> 3) {
          case 1: {
            d.weight = t.double();
            break;
          }
          case 2: {
            d.gap = t.string();
            break;
          }
          case 3: {
            d.verticalAlignment = t.int32();
            break;
          }
          case 4: {
            d.showBorder = t.bool();
            break;
          }
          case 5: {
            d.gapConfig = $root$1.streamlit.GapConfig.decode(t, t.uint32());
            break;
          }
          default:
            t.skipType(k & 7);
            break;
        }
      }
      return d;
    }, A.fromObject = function(t) {
      if (t instanceof $root$1.Block.Column) return t;
      let c = new $root$1.Block.Column();
      switch (t.weight != null && (c.weight = Number(t.weight)), t.gap != null && (c.gap = String(t.gap)), t.verticalAlignment) {
        default:
          if (typeof t.verticalAlignment == "number") {
            c.verticalAlignment = t.verticalAlignment;
            break;
          }
          break;
        case "TOP":
        case 0:
          c.verticalAlignment = 0;
          break;
        case "CENTER":
        case 1:
          c.verticalAlignment = 1;
          break;
        case "BOTTOM":
        case 2:
          c.verticalAlignment = 2;
          break;
      }
      if (t.showBorder != null && (c.showBorder = !!t.showBorder), t.gapConfig != null) {
        if (typeof t.gapConfig != "object") throw TypeError(".Block.Column.gapConfig: object expected");
        c.gapConfig = $root$1.streamlit.GapConfig.fromObject(t.gapConfig);
      }
      return c;
    }, A.toObject = function(t, c) {
      c || (c = {});
      let n = {};
      return c.defaults && (n.weight = 0, n.gap = "", n.verticalAlignment = c.enums === String ? "TOP" : 0, n.showBorder = !1), t.weight != null && t.hasOwnProperty("weight") && (n.weight = c.json && !isFinite(t.weight) ? String(t.weight) : t.weight), t.gap != null && t.hasOwnProperty("gap") && (n.gap = t.gap), t.verticalAlignment != null && t.hasOwnProperty("verticalAlignment") && (n.verticalAlignment = c.enums === String ? $root$1.Block.Column.VerticalAlignment[t.verticalAlignment] === void 0 ? t.verticalAlignment : $root$1.Block.Column.VerticalAlignment[t.verticalAlignment] : t.verticalAlignment), t.showBorder != null && t.hasOwnProperty("showBorder") && (n.showBorder = t.showBorder), t.gapConfig != null && t.hasOwnProperty("gapConfig") && (n.gapConfig = $root$1.streamlit.GapConfig.toObject(t.gapConfig, c), c.oneofs && (n._gapConfig = "gapConfig")), n;
    }, A.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
    }, A.getTypeUrl = function(t) {
      return t === void 0 && (t = "type.googleapis.com"), t + "/Block.Column";
    }, A.VerticalAlignment = (function() {
      const e = {}, t = Object.create(e);
      return t[e[0] = "TOP"] = 0, t[e[1] = "CENTER"] = 1, t[e[2] = "BOTTOM"] = 2, t;
    })(), A;
  })(), o.Expandable = (function() {
    function A(e) {
      if (e) for (let t = Object.keys(e), c = 0; c < t.length; ++c) e[t[c]] != null && (this[t[c]] = e[t[c]]);
    }
    A.prototype.label = "", A.prototype.expanded = null, A.prototype.icon = "";
    let g;
    return Object.defineProperty(A.prototype, "_expanded", { get: $util$1.oneOfGetter(g = ["expanded"]), set: $util$1.oneOfSetter(g) }), A.create = function(t) {
      return new A(t);
    }, A.encode = function(t, c) {
      return c || (c = $Writer$1.create()), t.label != null && Object.hasOwnProperty.call(t, "label") && c.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(t.label), t.expanded != null && Object.hasOwnProperty.call(t, "expanded") && c.uint32(
        /* id 2, wireType 0 =*/
        16
      ).bool(t.expanded), t.icon != null && Object.hasOwnProperty.call(t, "icon") && c.uint32(
        /* id 3, wireType 2 =*/
        26
      ).string(t.icon), c;
    }, A.decode = function(t, c, n) {
      t instanceof $Reader$1 || (t = $Reader$1.create(t));
      let h = c === void 0 ? t.len : t.pos + c, d = new $root$1.Block.Expandable();
      for (; t.pos < h; ) {
        let k = t.uint32();
        if (k === n) break;
        switch (k >>> 3) {
          case 1: {
            d.label = t.string();
            break;
          }
          case 2: {
            d.expanded = t.bool();
            break;
          }
          case 3: {
            d.icon = t.string();
            break;
          }
          default:
            t.skipType(k & 7);
            break;
        }
      }
      return d;
    }, A.fromObject = function(t) {
      if (t instanceof $root$1.Block.Expandable) return t;
      let c = new $root$1.Block.Expandable();
      return t.label != null && (c.label = String(t.label)), t.expanded != null && (c.expanded = !!t.expanded), t.icon != null && (c.icon = String(t.icon)), c;
    }, A.toObject = function(t, c) {
      c || (c = {});
      let n = {};
      return c.defaults && (n.label = "", n.icon = ""), t.label != null && t.hasOwnProperty("label") && (n.label = t.label), t.expanded != null && t.hasOwnProperty("expanded") && (n.expanded = t.expanded, c.oneofs && (n._expanded = "expanded")), t.icon != null && t.hasOwnProperty("icon") && (n.icon = t.icon), n;
    }, A.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
    }, A.getTypeUrl = function(t) {
      return t === void 0 && (t = "type.googleapis.com"), t + "/Block.Expandable";
    }, A;
  })(), o.Dialog = (function() {
    function A(e) {
      if (e) for (let t = Object.keys(e), c = 0; c < t.length; ++c) e[t[c]] != null && (this[t[c]] = e[t[c]]);
    }
    A.prototype.title = "", A.prototype.dismissible = !1, A.prototype.width = 0, A.prototype.isOpen = null, A.prototype.id = "";
    let g;
    return Object.defineProperty(A.prototype, "_isOpen", { get: $util$1.oneOfGetter(g = ["isOpen"]), set: $util$1.oneOfSetter(g) }), A.create = function(t) {
      return new A(t);
    }, A.encode = function(t, c) {
      return c || (c = $Writer$1.create()), t.title != null && Object.hasOwnProperty.call(t, "title") && c.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(t.title), t.dismissible != null && Object.hasOwnProperty.call(t, "dismissible") && c.uint32(
        /* id 2, wireType 0 =*/
        16
      ).bool(t.dismissible), t.width != null && Object.hasOwnProperty.call(t, "width") && c.uint32(
        /* id 3, wireType 0 =*/
        24
      ).int32(t.width), t.isOpen != null && Object.hasOwnProperty.call(t, "isOpen") && c.uint32(
        /* id 4, wireType 0 =*/
        32
      ).bool(t.isOpen), t.id != null && Object.hasOwnProperty.call(t, "id") && c.uint32(
        /* id 5, wireType 2 =*/
        42
      ).string(t.id), c;
    }, A.decode = function(t, c, n) {
      t instanceof $Reader$1 || (t = $Reader$1.create(t));
      let h = c === void 0 ? t.len : t.pos + c, d = new $root$1.Block.Dialog();
      for (; t.pos < h; ) {
        let k = t.uint32();
        if (k === n) break;
        switch (k >>> 3) {
          case 1: {
            d.title = t.string();
            break;
          }
          case 2: {
            d.dismissible = t.bool();
            break;
          }
          case 3: {
            d.width = t.int32();
            break;
          }
          case 4: {
            d.isOpen = t.bool();
            break;
          }
          case 5: {
            d.id = t.string();
            break;
          }
          default:
            t.skipType(k & 7);
            break;
        }
      }
      return d;
    }, A.fromObject = function(t) {
      if (t instanceof $root$1.Block.Dialog) return t;
      let c = new $root$1.Block.Dialog();
      switch (t.title != null && (c.title = String(t.title)), t.dismissible != null && (c.dismissible = !!t.dismissible), t.width) {
        default:
          if (typeof t.width == "number") {
            c.width = t.width;
            break;
          }
          break;
        case "SMALL":
        case 0:
          c.width = 0;
          break;
        case "LARGE":
        case 1:
          c.width = 1;
          break;
        case "MEDIUM":
        case 2:
          c.width = 2;
          break;
      }
      return t.isOpen != null && (c.isOpen = !!t.isOpen), t.id != null && (c.id = String(t.id)), c;
    }, A.toObject = function(t, c) {
      c || (c = {});
      let n = {};
      return c.defaults && (n.title = "", n.dismissible = !1, n.width = c.enums === String ? "SMALL" : 0, n.id = ""), t.title != null && t.hasOwnProperty("title") && (n.title = t.title), t.dismissible != null && t.hasOwnProperty("dismissible") && (n.dismissible = t.dismissible), t.width != null && t.hasOwnProperty("width") && (n.width = c.enums === String ? $root$1.Block.Dialog.DialogWidth[t.width] === void 0 ? t.width : $root$1.Block.Dialog.DialogWidth[t.width] : t.width), t.isOpen != null && t.hasOwnProperty("isOpen") && (n.isOpen = t.isOpen, c.oneofs && (n._isOpen = "isOpen")), t.id != null && t.hasOwnProperty("id") && (n.id = t.id), n;
    }, A.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
    }, A.getTypeUrl = function(t) {
      return t === void 0 && (t = "type.googleapis.com"), t + "/Block.Dialog";
    }, A.DialogWidth = (function() {
      const e = {}, t = Object.create(e);
      return t[e[0] = "SMALL"] = 0, t[e[1] = "LARGE"] = 1, t[e[2] = "MEDIUM"] = 2, t;
    })(), A;
  })(), o.Form = (function() {
    function A(g) {
      if (g) for (let e = Object.keys(g), t = 0; t < e.length; ++t) g[e[t]] != null && (this[e[t]] = g[e[t]]);
    }
    return A.prototype.formId = "", A.prototype.clearOnSubmit = !1, A.prototype.border = !1, A.prototype.enterToSubmit = !1, A.create = function(e) {
      return new A(e);
    }, A.encode = function(e, t) {
      return t || (t = $Writer$1.create()), e.formId != null && Object.hasOwnProperty.call(e, "formId") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.formId), e.clearOnSubmit != null && Object.hasOwnProperty.call(e, "clearOnSubmit") && t.uint32(
        /* id 2, wireType 0 =*/
        16
      ).bool(e.clearOnSubmit), e.border != null && Object.hasOwnProperty.call(e, "border") && t.uint32(
        /* id 3, wireType 0 =*/
        24
      ).bool(e.border), e.enterToSubmit != null && Object.hasOwnProperty.call(e, "enterToSubmit") && t.uint32(
        /* id 4, wireType 0 =*/
        32
      ).bool(e.enterToSubmit), t;
    }, A.decode = function(e, t, c) {
      e instanceof $Reader$1 || (e = $Reader$1.create(e));
      let n = t === void 0 ? e.len : e.pos + t, h = new $root$1.Block.Form();
      for (; e.pos < n; ) {
        let d = e.uint32();
        if (d === c) break;
        switch (d >>> 3) {
          case 1: {
            h.formId = e.string();
            break;
          }
          case 2: {
            h.clearOnSubmit = e.bool();
            break;
          }
          case 3: {
            h.border = e.bool();
            break;
          }
          case 4: {
            h.enterToSubmit = e.bool();
            break;
          }
          default:
            e.skipType(d & 7);
            break;
        }
      }
      return h;
    }, A.fromObject = function(e) {
      if (e instanceof $root$1.Block.Form) return e;
      let t = new $root$1.Block.Form();
      return e.formId != null && (t.formId = String(e.formId)), e.clearOnSubmit != null && (t.clearOnSubmit = !!e.clearOnSubmit), e.border != null && (t.border = !!e.border), e.enterToSubmit != null && (t.enterToSubmit = !!e.enterToSubmit), t;
    }, A.toObject = function(e, t) {
      t || (t = {});
      let c = {};
      return t.defaults && (c.formId = "", c.clearOnSubmit = !1, c.border = !1, c.enterToSubmit = !1), e.formId != null && e.hasOwnProperty("formId") && (c.formId = e.formId), e.clearOnSubmit != null && e.hasOwnProperty("clearOnSubmit") && (c.clearOnSubmit = e.clearOnSubmit), e.border != null && e.hasOwnProperty("border") && (c.border = e.border), e.enterToSubmit != null && e.hasOwnProperty("enterToSubmit") && (c.enterToSubmit = e.enterToSubmit), c;
    }, A.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
    }, A.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/Block.Form";
    }, A;
  })(), o.TabContainer = (function() {
    function A(g) {
      if (g) for (let e = Object.keys(g), t = 0; t < e.length; ++t) g[e[t]] != null && (this[e[t]] = g[e[t]]);
    }
    return A.prototype.defaultTabIndex = 0, A.create = function(e) {
      return new A(e);
    }, A.encode = function(e, t) {
      return t || (t = $Writer$1.create()), e.defaultTabIndex != null && Object.hasOwnProperty.call(e, "defaultTabIndex") && t.uint32(
        /* id 1, wireType 0 =*/
        8
      ).int32(e.defaultTabIndex), t;
    }, A.decode = function(e, t, c) {
      e instanceof $Reader$1 || (e = $Reader$1.create(e));
      let n = t === void 0 ? e.len : e.pos + t, h = new $root$1.Block.TabContainer();
      for (; e.pos < n; ) {
        let d = e.uint32();
        if (d === c) break;
        switch (d >>> 3) {
          case 1: {
            h.defaultTabIndex = e.int32();
            break;
          }
          default:
            e.skipType(d & 7);
            break;
        }
      }
      return h;
    }, A.fromObject = function(e) {
      if (e instanceof $root$1.Block.TabContainer) return e;
      let t = new $root$1.Block.TabContainer();
      return e.defaultTabIndex != null && (t.defaultTabIndex = e.defaultTabIndex | 0), t;
    }, A.toObject = function(e, t) {
      t || (t = {});
      let c = {};
      return t.defaults && (c.defaultTabIndex = 0), e.defaultTabIndex != null && e.hasOwnProperty("defaultTabIndex") && (c.defaultTabIndex = e.defaultTabIndex), c;
    }, A.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
    }, A.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/Block.TabContainer";
    }, A;
  })(), o.Tab = (function() {
    function A(g) {
      if (g) for (let e = Object.keys(g), t = 0; t < e.length; ++t) g[e[t]] != null && (this[e[t]] = g[e[t]]);
    }
    return A.prototype.label = "", A.create = function(e) {
      return new A(e);
    }, A.encode = function(e, t) {
      return t || (t = $Writer$1.create()), e.label != null && Object.hasOwnProperty.call(e, "label") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.label), t;
    }, A.decode = function(e, t, c) {
      e instanceof $Reader$1 || (e = $Reader$1.create(e));
      let n = t === void 0 ? e.len : e.pos + t, h = new $root$1.Block.Tab();
      for (; e.pos < n; ) {
        let d = e.uint32();
        if (d === c) break;
        switch (d >>> 3) {
          case 1: {
            h.label = e.string();
            break;
          }
          default:
            e.skipType(d & 7);
            break;
        }
      }
      return h;
    }, A.fromObject = function(e) {
      if (e instanceof $root$1.Block.Tab) return e;
      let t = new $root$1.Block.Tab();
      return e.label != null && (t.label = String(e.label)), t;
    }, A.toObject = function(e, t) {
      t || (t = {});
      let c = {};
      return t.defaults && (c.label = ""), e.label != null && e.hasOwnProperty("label") && (c.label = e.label), c;
    }, A.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
    }, A.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/Block.Tab";
    }, A;
  })(), o.Popover = (function() {
    function A(g) {
      if (g) for (let e = Object.keys(g), t = 0; t < e.length; ++t) g[e[t]] != null && (this[e[t]] = g[e[t]]);
    }
    return A.prototype.label = "", A.prototype.useContainerWidth = !1, A.prototype.help = "", A.prototype.disabled = !1, A.prototype.icon = "", A.prototype.type = "", A.create = function(e) {
      return new A(e);
    }, A.encode = function(e, t) {
      return t || (t = $Writer$1.create()), e.label != null && Object.hasOwnProperty.call(e, "label") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.label), e.useContainerWidth != null && Object.hasOwnProperty.call(e, "useContainerWidth") && t.uint32(
        /* id 2, wireType 0 =*/
        16
      ).bool(e.useContainerWidth), e.help != null && Object.hasOwnProperty.call(e, "help") && t.uint32(
        /* id 3, wireType 2 =*/
        26
      ).string(e.help), e.disabled != null && Object.hasOwnProperty.call(e, "disabled") && t.uint32(
        /* id 4, wireType 0 =*/
        32
      ).bool(e.disabled), e.icon != null && Object.hasOwnProperty.call(e, "icon") && t.uint32(
        /* id 5, wireType 2 =*/
        42
      ).string(e.icon), e.type != null && Object.hasOwnProperty.call(e, "type") && t.uint32(
        /* id 6, wireType 2 =*/
        50
      ).string(e.type), t;
    }, A.decode = function(e, t, c) {
      e instanceof $Reader$1 || (e = $Reader$1.create(e));
      let n = t === void 0 ? e.len : e.pos + t, h = new $root$1.Block.Popover();
      for (; e.pos < n; ) {
        let d = e.uint32();
        if (d === c) break;
        switch (d >>> 3) {
          case 1: {
            h.label = e.string();
            break;
          }
          case 2: {
            h.useContainerWidth = e.bool();
            break;
          }
          case 3: {
            h.help = e.string();
            break;
          }
          case 4: {
            h.disabled = e.bool();
            break;
          }
          case 5: {
            h.icon = e.string();
            break;
          }
          case 6: {
            h.type = e.string();
            break;
          }
          default:
            e.skipType(d & 7);
            break;
        }
      }
      return h;
    }, A.fromObject = function(e) {
      if (e instanceof $root$1.Block.Popover) return e;
      let t = new $root$1.Block.Popover();
      return e.label != null && (t.label = String(e.label)), e.useContainerWidth != null && (t.useContainerWidth = !!e.useContainerWidth), e.help != null && (t.help = String(e.help)), e.disabled != null && (t.disabled = !!e.disabled), e.icon != null && (t.icon = String(e.icon)), e.type != null && (t.type = String(e.type)), t;
    }, A.toObject = function(e, t) {
      t || (t = {});
      let c = {};
      return t.defaults && (c.label = "", c.useContainerWidth = !1, c.help = "", c.disabled = !1, c.icon = "", c.type = ""), e.label != null && e.hasOwnProperty("label") && (c.label = e.label), e.useContainerWidth != null && e.hasOwnProperty("useContainerWidth") && (c.useContainerWidth = e.useContainerWidth), e.help != null && e.hasOwnProperty("help") && (c.help = e.help), e.disabled != null && e.hasOwnProperty("disabled") && (c.disabled = e.disabled), e.icon != null && e.hasOwnProperty("icon") && (c.icon = e.icon), e.type != null && e.hasOwnProperty("type") && (c.type = e.type), c;
    }, A.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
    }, A.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/Block.Popover";
    }, A;
  })(), o.ChatMessage = (function() {
    function A(g) {
      if (g) for (let e = Object.keys(g), t = 0; t < e.length; ++t) g[e[t]] != null && (this[e[t]] = g[e[t]]);
    }
    return A.prototype.name = "", A.prototype.avatar = "", A.prototype.avatarType = 0, A.create = function(e) {
      return new A(e);
    }, A.encode = function(e, t) {
      return t || (t = $Writer$1.create()), e.name != null && Object.hasOwnProperty.call(e, "name") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.name), e.avatar != null && Object.hasOwnProperty.call(e, "avatar") && t.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(e.avatar), e.avatarType != null && Object.hasOwnProperty.call(e, "avatarType") && t.uint32(
        /* id 3, wireType 0 =*/
        24
      ).int32(e.avatarType), t;
    }, A.decode = function(e, t, c) {
      e instanceof $Reader$1 || (e = $Reader$1.create(e));
      let n = t === void 0 ? e.len : e.pos + t, h = new $root$1.Block.ChatMessage();
      for (; e.pos < n; ) {
        let d = e.uint32();
        if (d === c) break;
        switch (d >>> 3) {
          case 1: {
            h.name = e.string();
            break;
          }
          case 2: {
            h.avatar = e.string();
            break;
          }
          case 3: {
            h.avatarType = e.int32();
            break;
          }
          default:
            e.skipType(d & 7);
            break;
        }
      }
      return h;
    }, A.fromObject = function(e) {
      if (e instanceof $root$1.Block.ChatMessage) return e;
      let t = new $root$1.Block.ChatMessage();
      switch (e.name != null && (t.name = String(e.name)), e.avatar != null && (t.avatar = String(e.avatar)), e.avatarType) {
        default:
          if (typeof e.avatarType == "number") {
            t.avatarType = e.avatarType;
            break;
          }
          break;
        case "IMAGE":
        case 0:
          t.avatarType = 0;
          break;
        case "EMOJI":
        case 1:
          t.avatarType = 1;
          break;
        case "ICON":
        case 2:
          t.avatarType = 2;
          break;
      }
      return t;
    }, A.toObject = function(e, t) {
      t || (t = {});
      let c = {};
      return t.defaults && (c.name = "", c.avatar = "", c.avatarType = t.enums === String ? "IMAGE" : 0), e.name != null && e.hasOwnProperty("name") && (c.name = e.name), e.avatar != null && e.hasOwnProperty("avatar") && (c.avatar = e.avatar), e.avatarType != null && e.hasOwnProperty("avatarType") && (c.avatarType = t.enums === String ? $root$1.Block.ChatMessage.AvatarType[e.avatarType] === void 0 ? e.avatarType : $root$1.Block.ChatMessage.AvatarType[e.avatarType] : e.avatarType), c;
    }, A.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
    }, A.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/Block.ChatMessage";
    }, A.AvatarType = (function() {
      const g = {}, e = Object.create(g);
      return e[g[0] = "IMAGE"] = 0, e[g[1] = "EMOJI"] = 1, e[g[2] = "ICON"] = 2, e;
    })(), A;
  })(), o;
})();
$root$1.BokehChart = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.figure = "", o.prototype.useContainerWidth = !1, o.prototype.elementId = "", o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    return g || (g = $Writer$1.create()), A.figure != null && Object.hasOwnProperty.call(A, "figure") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(A.figure), A.useContainerWidth != null && Object.hasOwnProperty.call(A, "useContainerWidth") && g.uint32(
      /* id 2, wireType 0 =*/
      16
    ).bool(A.useContainerWidth), A.elementId != null && Object.hasOwnProperty.call(A, "elementId") && g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(A.elementId), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader$1 || (A = $Reader$1.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root$1.BokehChart();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.figure = A.string();
          break;
        }
        case 2: {
          c.useContainerWidth = A.bool();
          break;
        }
        case 3: {
          c.elementId = A.string();
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root$1.BokehChart) return A;
    let g = new $root$1.BokehChart();
    return A.figure != null && (g.figure = String(A.figure)), A.useContainerWidth != null && (g.useContainerWidth = !!A.useContainerWidth), A.elementId != null && (g.elementId = String(A.elementId)), g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    return g.defaults && (e.figure = "", e.useContainerWidth = !1, e.elementId = ""), A.figure != null && A.hasOwnProperty("figure") && (e.figure = A.figure), A.useContainerWidth != null && A.hasOwnProperty("useContainerWidth") && (e.useContainerWidth = A.useContainerWidth), A.elementId != null && A.hasOwnProperty("elementId") && (e.elementId = A.elementId), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/BokehChart";
  }, o;
})();
$root$1.Button = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.id = "", o.prototype.label = "", o.prototype.default = !1, o.prototype.help = "", o.prototype.formId = "", o.prototype.isFormSubmitter = !1, o.prototype.type = "", o.prototype.disabled = !1, o.prototype.useContainerWidth = !1, o.prototype.icon = "", o.prototype.shortcut = "", o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    return g || (g = $Writer$1.create()), A.id != null && Object.hasOwnProperty.call(A, "id") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(A.id), A.label != null && Object.hasOwnProperty.call(A, "label") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(A.label), A.default != null && Object.hasOwnProperty.call(A, "default") && g.uint32(
      /* id 3, wireType 0 =*/
      24
    ).bool(A.default), A.help != null && Object.hasOwnProperty.call(A, "help") && g.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(A.help), A.formId != null && Object.hasOwnProperty.call(A, "formId") && g.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(A.formId), A.isFormSubmitter != null && Object.hasOwnProperty.call(A, "isFormSubmitter") && g.uint32(
      /* id 6, wireType 0 =*/
      48
    ).bool(A.isFormSubmitter), A.type != null && Object.hasOwnProperty.call(A, "type") && g.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(A.type), A.disabled != null && Object.hasOwnProperty.call(A, "disabled") && g.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(A.disabled), A.useContainerWidth != null && Object.hasOwnProperty.call(A, "useContainerWidth") && g.uint32(
      /* id 9, wireType 0 =*/
      72
    ).bool(A.useContainerWidth), A.icon != null && Object.hasOwnProperty.call(A, "icon") && g.uint32(
      /* id 10, wireType 2 =*/
      82
    ).string(A.icon), A.shortcut != null && Object.hasOwnProperty.call(A, "shortcut") && g.uint32(
      /* id 11, wireType 2 =*/
      90
    ).string(A.shortcut), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader$1 || (A = $Reader$1.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root$1.Button();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.id = A.string();
          break;
        }
        case 2: {
          c.label = A.string();
          break;
        }
        case 3: {
          c.default = A.bool();
          break;
        }
        case 4: {
          c.help = A.string();
          break;
        }
        case 5: {
          c.formId = A.string();
          break;
        }
        case 6: {
          c.isFormSubmitter = A.bool();
          break;
        }
        case 7: {
          c.type = A.string();
          break;
        }
        case 8: {
          c.disabled = A.bool();
          break;
        }
        case 9: {
          c.useContainerWidth = A.bool();
          break;
        }
        case 10: {
          c.icon = A.string();
          break;
        }
        case 11: {
          c.shortcut = A.string();
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root$1.Button) return A;
    let g = new $root$1.Button();
    return A.id != null && (g.id = String(A.id)), A.label != null && (g.label = String(A.label)), A.default != null && (g.default = !!A.default), A.help != null && (g.help = String(A.help)), A.formId != null && (g.formId = String(A.formId)), A.isFormSubmitter != null && (g.isFormSubmitter = !!A.isFormSubmitter), A.type != null && (g.type = String(A.type)), A.disabled != null && (g.disabled = !!A.disabled), A.useContainerWidth != null && (g.useContainerWidth = !!A.useContainerWidth), A.icon != null && (g.icon = String(A.icon)), A.shortcut != null && (g.shortcut = String(A.shortcut)), g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    return g.defaults && (e.id = "", e.label = "", e.default = !1, e.help = "", e.formId = "", e.isFormSubmitter = !1, e.type = "", e.disabled = !1, e.useContainerWidth = !1, e.icon = "", e.shortcut = ""), A.id != null && A.hasOwnProperty("id") && (e.id = A.id), A.label != null && A.hasOwnProperty("label") && (e.label = A.label), A.default != null && A.hasOwnProperty("default") && (e.default = A.default), A.help != null && A.hasOwnProperty("help") && (e.help = A.help), A.formId != null && A.hasOwnProperty("formId") && (e.formId = A.formId), A.isFormSubmitter != null && A.hasOwnProperty("isFormSubmitter") && (e.isFormSubmitter = A.isFormSubmitter), A.type != null && A.hasOwnProperty("type") && (e.type = A.type), A.disabled != null && A.hasOwnProperty("disabled") && (e.disabled = A.disabled), A.useContainerWidth != null && A.hasOwnProperty("useContainerWidth") && (e.useContainerWidth = A.useContainerWidth), A.icon != null && A.hasOwnProperty("icon") && (e.icon = A.icon), A.shortcut != null && A.hasOwnProperty("shortcut") && (e.shortcut = A.shortcut), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/Button";
  }, o;
})();
const ButtonGroup$1 = $root$1.ButtonGroup = (() => {
  function o(A) {
    if (this.options = [], this.default = [], this.value = [], A) for (let g = Object.keys(A), e = 0; e < g.length; ++e) A[g[e]] != null && (this[g[e]] = A[g[e]]);
  }
  o.prototype.id = "", o.prototype.options = $util$1.emptyArray, o.prototype.default = $util$1.emptyArray, o.prototype.disabled = !1, o.prototype.clickMode = 0, o.prototype.formId = "", o.prototype.value = $util$1.emptyArray, o.prototype.setValue = !1, o.prototype.selectionVisualization = 0, o.prototype.style = 0, o.prototype.label = "", o.prototype.labelVisibility = null, o.prototype.help = null;
  let E;
  return Object.defineProperty(o.prototype, "_help", { get: $util$1.oneOfGetter(E = ["help"]), set: $util$1.oneOfSetter(E) }), o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, e) {
    if (e || (e = $Writer$1.create()), g.id != null && Object.hasOwnProperty.call(g, "id") && e.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.id), g.options != null && g.options.length) for (let t = 0; t < g.options.length; ++t) $root$1.ButtonGroup.Option.encode(g.options[t], e.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim();
    if (g.default != null && g.default.length) {
      e.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork();
      for (let t = 0; t < g.default.length; ++t) e.uint32(g.default[t]);
      e.ldelim();
    }
    if (g.disabled != null && Object.hasOwnProperty.call(g, "disabled") && e.uint32(
      /* id 4, wireType 0 =*/
      32
    ).bool(g.disabled), g.clickMode != null && Object.hasOwnProperty.call(g, "clickMode") && e.uint32(
      /* id 5, wireType 0 =*/
      40
    ).int32(g.clickMode), g.formId != null && Object.hasOwnProperty.call(g, "formId") && e.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(g.formId), g.value != null && g.value.length) {
      e.uint32(
        /* id 7, wireType 2 =*/
        58
      ).fork();
      for (let t = 0; t < g.value.length; ++t) e.uint32(g.value[t]);
      e.ldelim();
    }
    return g.setValue != null && Object.hasOwnProperty.call(g, "setValue") && e.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(g.setValue), g.selectionVisualization != null && Object.hasOwnProperty.call(g, "selectionVisualization") && e.uint32(
      /* id 9, wireType 0 =*/
      72
    ).int32(g.selectionVisualization), g.style != null && Object.hasOwnProperty.call(g, "style") && e.uint32(
      /* id 10, wireType 0 =*/
      80
    ).int32(g.style), g.label != null && Object.hasOwnProperty.call(g, "label") && e.uint32(
      /* id 11, wireType 2 =*/
      90
    ).string(g.label), g.labelVisibility != null && Object.hasOwnProperty.call(g, "labelVisibility") && $root$1.LabelVisibilityMessage.encode(g.labelVisibility, e.uint32(
      /* id 12, wireType 2 =*/
      98
    ).fork()).ldelim(), g.help != null && Object.hasOwnProperty.call(g, "help") && e.uint32(
      /* id 13, wireType 2 =*/
      106
    ).string(g.help), e;
  }, o.decode = function(g, e, t) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let c = e === void 0 ? g.len : g.pos + e, n = new $root$1.ButtonGroup();
    for (; g.pos < c; ) {
      let h = g.uint32();
      if (h === t) break;
      switch (h >>> 3) {
        case 1: {
          n.id = g.string();
          break;
        }
        case 2: {
          n.options && n.options.length || (n.options = []), n.options.push($root$1.ButtonGroup.Option.decode(g, g.uint32()));
          break;
        }
        case 3: {
          if (n.default && n.default.length || (n.default = []), (h & 7) === 2) {
            let d = g.uint32() + g.pos;
            for (; g.pos < d; ) n.default.push(g.uint32());
          } else n.default.push(g.uint32());
          break;
        }
        case 4: {
          n.disabled = g.bool();
          break;
        }
        case 5: {
          n.clickMode = g.int32();
          break;
        }
        case 6: {
          n.formId = g.string();
          break;
        }
        case 7: {
          if (n.value && n.value.length || (n.value = []), (h & 7) === 2) {
            let d = g.uint32() + g.pos;
            for (; g.pos < d; ) n.value.push(g.uint32());
          } else n.value.push(g.uint32());
          break;
        }
        case 8: {
          n.setValue = g.bool();
          break;
        }
        case 9: {
          n.selectionVisualization = g.int32();
          break;
        }
        case 10: {
          n.style = g.int32();
          break;
        }
        case 11: {
          n.label = g.string();
          break;
        }
        case 12: {
          n.labelVisibility = $root$1.LabelVisibilityMessage.decode(g, g.uint32());
          break;
        }
        case 13: {
          n.help = g.string();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.ButtonGroup) return g;
    let e = new $root$1.ButtonGroup();
    if (g.id != null && (e.id = String(g.id)), g.options) {
      if (!Array.isArray(g.options)) throw TypeError(".ButtonGroup.options: array expected");
      e.options = [];
      for (let t = 0; t < g.options.length; ++t) {
        if (typeof g.options[t] != "object") throw TypeError(".ButtonGroup.options: object expected");
        e.options[t] = $root$1.ButtonGroup.Option.fromObject(g.options[t]);
      }
    }
    if (g.default) {
      if (!Array.isArray(g.default)) throw TypeError(".ButtonGroup.default: array expected");
      e.default = [];
      for (let t = 0; t < g.default.length; ++t) e.default[t] = g.default[t] >>> 0;
    }
    switch (g.disabled != null && (e.disabled = !!g.disabled), g.clickMode) {
      default:
        if (typeof g.clickMode == "number") {
          e.clickMode = g.clickMode;
          break;
        }
        break;
      case "SINGLE_SELECT":
      case 0:
        e.clickMode = 0;
        break;
      case "MULTI_SELECT":
      case 1:
        e.clickMode = 1;
        break;
    }
    if (g.formId != null && (e.formId = String(g.formId)), g.value) {
      if (!Array.isArray(g.value)) throw TypeError(".ButtonGroup.value: array expected");
      e.value = [];
      for (let t = 0; t < g.value.length; ++t) e.value[t] = g.value[t] >>> 0;
    }
    switch (g.setValue != null && (e.setValue = !!g.setValue), g.selectionVisualization) {
      default:
        if (typeof g.selectionVisualization == "number") {
          e.selectionVisualization = g.selectionVisualization;
          break;
        }
        break;
      case "ONLY_SELECTED":
      case 0:
        e.selectionVisualization = 0;
        break;
      case "ALL_UP_TO_SELECTED":
      case 1:
        e.selectionVisualization = 1;
        break;
    }
    switch (g.style) {
      default:
        if (typeof g.style == "number") {
          e.style = g.style;
          break;
        }
        break;
      case "SEGMENTED_CONTROL":
      case 0:
        e.style = 0;
        break;
      case "PILLS":
      case 1:
        e.style = 1;
        break;
      case "BORDERLESS":
      case 2:
        e.style = 2;
        break;
    }
    if (g.label != null && (e.label = String(g.label)), g.labelVisibility != null) {
      if (typeof g.labelVisibility != "object") throw TypeError(".ButtonGroup.labelVisibility: object expected");
      e.labelVisibility = $root$1.LabelVisibilityMessage.fromObject(g.labelVisibility);
    }
    return g.help != null && (e.help = String(g.help)), e;
  }, o.toObject = function(g, e) {
    e || (e = {});
    let t = {};
    if ((e.arrays || e.defaults) && (t.options = [], t.default = [], t.value = []), e.defaults && (t.id = "", t.disabled = !1, t.clickMode = e.enums === String ? "SINGLE_SELECT" : 0, t.formId = "", t.setValue = !1, t.selectionVisualization = e.enums === String ? "ONLY_SELECTED" : 0, t.style = e.enums === String ? "SEGMENTED_CONTROL" : 0, t.label = "", t.labelVisibility = null), g.id != null && g.hasOwnProperty("id") && (t.id = g.id), g.options && g.options.length) {
      t.options = [];
      for (let c = 0; c < g.options.length; ++c) t.options[c] = $root$1.ButtonGroup.Option.toObject(g.options[c], e);
    }
    if (g.default && g.default.length) {
      t.default = [];
      for (let c = 0; c < g.default.length; ++c) t.default[c] = g.default[c];
    }
    if (g.disabled != null && g.hasOwnProperty("disabled") && (t.disabled = g.disabled), g.clickMode != null && g.hasOwnProperty("clickMode") && (t.clickMode = e.enums === String ? $root$1.ButtonGroup.ClickMode[g.clickMode] === void 0 ? g.clickMode : $root$1.ButtonGroup.ClickMode[g.clickMode] : g.clickMode), g.formId != null && g.hasOwnProperty("formId") && (t.formId = g.formId), g.value && g.value.length) {
      t.value = [];
      for (let c = 0; c < g.value.length; ++c) t.value[c] = g.value[c];
    }
    return g.setValue != null && g.hasOwnProperty("setValue") && (t.setValue = g.setValue), g.selectionVisualization != null && g.hasOwnProperty("selectionVisualization") && (t.selectionVisualization = e.enums === String ? $root$1.ButtonGroup.SelectionVisualization[g.selectionVisualization] === void 0 ? g.selectionVisualization : $root$1.ButtonGroup.SelectionVisualization[g.selectionVisualization] : g.selectionVisualization), g.style != null && g.hasOwnProperty("style") && (t.style = e.enums === String ? $root$1.ButtonGroup.Style[g.style] === void 0 ? g.style : $root$1.ButtonGroup.Style[g.style] : g.style), g.label != null && g.hasOwnProperty("label") && (t.label = g.label), g.labelVisibility != null && g.hasOwnProperty("labelVisibility") && (t.labelVisibility = $root$1.LabelVisibilityMessage.toObject(g.labelVisibility, e)), g.help != null && g.hasOwnProperty("help") && (t.help = g.help, e.oneofs && (t._help = "help")), t;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/ButtonGroup";
  }, o.ClickMode = (function() {
    const A = {}, g = Object.create(A);
    return g[A[0] = "SINGLE_SELECT"] = 0, g[A[1] = "MULTI_SELECT"] = 1, g;
  })(), o.Option = (function() {
    function A(e) {
      if (e) for (let t = Object.keys(e), c = 0; c < t.length; ++c) e[t[c]] != null && (this[t[c]] = e[t[c]]);
    }
    A.prototype.content = "", A.prototype.selectedContent = null, A.prototype.contentIcon = null, A.prototype.selectedContentIcon = null;
    let g;
    return Object.defineProperty(A.prototype, "_selectedContent", { get: $util$1.oneOfGetter(g = ["selectedContent"]), set: $util$1.oneOfSetter(g) }), Object.defineProperty(A.prototype, "_contentIcon", { get: $util$1.oneOfGetter(g = ["contentIcon"]), set: $util$1.oneOfSetter(g) }), Object.defineProperty(A.prototype, "_selectedContentIcon", { get: $util$1.oneOfGetter(g = ["selectedContentIcon"]), set: $util$1.oneOfSetter(g) }), A.create = function(t) {
      return new A(t);
    }, A.encode = function(t, c) {
      return c || (c = $Writer$1.create()), t.content != null && Object.hasOwnProperty.call(t, "content") && c.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(t.content), t.selectedContent != null && Object.hasOwnProperty.call(t, "selectedContent") && c.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(t.selectedContent), t.contentIcon != null && Object.hasOwnProperty.call(t, "contentIcon") && c.uint32(
        /* id 3, wireType 2 =*/
        26
      ).string(t.contentIcon), t.selectedContentIcon != null && Object.hasOwnProperty.call(t, "selectedContentIcon") && c.uint32(
        /* id 4, wireType 2 =*/
        34
      ).string(t.selectedContentIcon), c;
    }, A.decode = function(t, c, n) {
      t instanceof $Reader$1 || (t = $Reader$1.create(t));
      let h = c === void 0 ? t.len : t.pos + c, d = new $root$1.ButtonGroup.Option();
      for (; t.pos < h; ) {
        let k = t.uint32();
        if (k === n) break;
        switch (k >>> 3) {
          case 1: {
            d.content = t.string();
            break;
          }
          case 2: {
            d.selectedContent = t.string();
            break;
          }
          case 3: {
            d.contentIcon = t.string();
            break;
          }
          case 4: {
            d.selectedContentIcon = t.string();
            break;
          }
          default:
            t.skipType(k & 7);
            break;
        }
      }
      return d;
    }, A.fromObject = function(t) {
      if (t instanceof $root$1.ButtonGroup.Option) return t;
      let c = new $root$1.ButtonGroup.Option();
      return t.content != null && (c.content = String(t.content)), t.selectedContent != null && (c.selectedContent = String(t.selectedContent)), t.contentIcon != null && (c.contentIcon = String(t.contentIcon)), t.selectedContentIcon != null && (c.selectedContentIcon = String(t.selectedContentIcon)), c;
    }, A.toObject = function(t, c) {
      c || (c = {});
      let n = {};
      return c.defaults && (n.content = ""), t.content != null && t.hasOwnProperty("content") && (n.content = t.content), t.selectedContent != null && t.hasOwnProperty("selectedContent") && (n.selectedContent = t.selectedContent, c.oneofs && (n._selectedContent = "selectedContent")), t.contentIcon != null && t.hasOwnProperty("contentIcon") && (n.contentIcon = t.contentIcon, c.oneofs && (n._contentIcon = "contentIcon")), t.selectedContentIcon != null && t.hasOwnProperty("selectedContentIcon") && (n.selectedContentIcon = t.selectedContentIcon, c.oneofs && (n._selectedContentIcon = "selectedContentIcon")), n;
    }, A.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
    }, A.getTypeUrl = function(t) {
      return t === void 0 && (t = "type.googleapis.com"), t + "/ButtonGroup.Option";
    }, A;
  })(), o.SelectionVisualization = (function() {
    const A = {}, g = Object.create(A);
    return g[A[0] = "ONLY_SELECTED"] = 0, g[A[1] = "ALL_UP_TO_SELECTED"] = 1, g;
  })(), o.Style = (function() {
    const A = {}, g = Object.create(A);
    return g[A[0] = "SEGMENTED_CONTROL"] = 0, g[A[1] = "PILLS"] = 1, g[A[2] = "BORDERLESS"] = 2, g;
  })(), o;
})();
$root$1.CameraInput = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.id = "", o.prototype.label = "", o.prototype.help = "", o.prototype.formId = "", o.prototype.disabled = !1, o.prototype.labelVisibility = null, o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    return g || (g = $Writer$1.create()), A.id != null && Object.hasOwnProperty.call(A, "id") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(A.id), A.label != null && Object.hasOwnProperty.call(A, "label") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(A.label), A.help != null && Object.hasOwnProperty.call(A, "help") && g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(A.help), A.formId != null && Object.hasOwnProperty.call(A, "formId") && g.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(A.formId), A.disabled != null && Object.hasOwnProperty.call(A, "disabled") && g.uint32(
      /* id 5, wireType 0 =*/
      40
    ).bool(A.disabled), A.labelVisibility != null && Object.hasOwnProperty.call(A, "labelVisibility") && $root$1.LabelVisibilityMessage.encode(A.labelVisibility, g.uint32(
      /* id 6, wireType 2 =*/
      50
    ).fork()).ldelim(), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader$1 || (A = $Reader$1.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root$1.CameraInput();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.id = A.string();
          break;
        }
        case 2: {
          c.label = A.string();
          break;
        }
        case 3: {
          c.help = A.string();
          break;
        }
        case 4: {
          c.formId = A.string();
          break;
        }
        case 5: {
          c.disabled = A.bool();
          break;
        }
        case 6: {
          c.labelVisibility = $root$1.LabelVisibilityMessage.decode(A, A.uint32());
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root$1.CameraInput) return A;
    let g = new $root$1.CameraInput();
    if (A.id != null && (g.id = String(A.id)), A.label != null && (g.label = String(A.label)), A.help != null && (g.help = String(A.help)), A.formId != null && (g.formId = String(A.formId)), A.disabled != null && (g.disabled = !!A.disabled), A.labelVisibility != null) {
      if (typeof A.labelVisibility != "object") throw TypeError(".CameraInput.labelVisibility: object expected");
      g.labelVisibility = $root$1.LabelVisibilityMessage.fromObject(A.labelVisibility);
    }
    return g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    return g.defaults && (e.id = "", e.label = "", e.help = "", e.formId = "", e.disabled = !1, e.labelVisibility = null), A.id != null && A.hasOwnProperty("id") && (e.id = A.id), A.label != null && A.hasOwnProperty("label") && (e.label = A.label), A.help != null && A.hasOwnProperty("help") && (e.help = A.help), A.formId != null && A.hasOwnProperty("formId") && (e.formId = A.formId), A.disabled != null && A.hasOwnProperty("disabled") && (e.disabled = A.disabled), A.labelVisibility != null && A.hasOwnProperty("labelVisibility") && (e.labelVisibility = $root$1.LabelVisibilityMessage.toObject(A.labelVisibility, g)), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/CameraInput";
  }, o;
})();
const ChatInput$1 = $root$1.ChatInput = (() => {
  function o(A) {
    if (this.fileType = [], A) for (let g = Object.keys(A), e = 0; e < g.length; ++e) A[g[e]] != null && (this[g[e]] = A[g[e]]);
  }
  o.prototype.id = "", o.prototype.placeholder = "", o.prototype.maxChars = 0, o.prototype.disabled = !1, o.prototype.value = "", o.prototype.setValue = !1, o.prototype.default = "", o.prototype.position = 0, o.prototype.acceptFile = 0, o.prototype.fileType = $util$1.emptyArray, o.prototype.maxUploadSizeMb = 0, o.prototype.acceptAudio = !1, o.prototype.audioSampleRate = null;
  let E;
  return Object.defineProperty(o.prototype, "_audioSampleRate", { get: $util$1.oneOfGetter(E = ["audioSampleRate"]), set: $util$1.oneOfSetter(E) }), o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, e) {
    if (e || (e = $Writer$1.create()), g.id != null && Object.hasOwnProperty.call(g, "id") && e.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.id), g.placeholder != null && Object.hasOwnProperty.call(g, "placeholder") && e.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.placeholder), g.maxChars != null && Object.hasOwnProperty.call(g, "maxChars") && e.uint32(
      /* id 3, wireType 0 =*/
      24
    ).uint32(g.maxChars), g.disabled != null && Object.hasOwnProperty.call(g, "disabled") && e.uint32(
      /* id 4, wireType 0 =*/
      32
    ).bool(g.disabled), g.value != null && Object.hasOwnProperty.call(g, "value") && e.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(g.value), g.setValue != null && Object.hasOwnProperty.call(g, "setValue") && e.uint32(
      /* id 6, wireType 0 =*/
      48
    ).bool(g.setValue), g.default != null && Object.hasOwnProperty.call(g, "default") && e.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(g.default), g.position != null && Object.hasOwnProperty.call(g, "position") && e.uint32(
      /* id 8, wireType 0 =*/
      64
    ).int32(g.position), g.acceptFile != null && Object.hasOwnProperty.call(g, "acceptFile") && e.uint32(
      /* id 9, wireType 0 =*/
      72
    ).int32(g.acceptFile), g.fileType != null && g.fileType.length) for (let t = 0; t < g.fileType.length; ++t) e.uint32(
      /* id 10, wireType 2 =*/
      82
    ).string(g.fileType[t]);
    return g.maxUploadSizeMb != null && Object.hasOwnProperty.call(g, "maxUploadSizeMb") && e.uint32(
      /* id 11, wireType 0 =*/
      88
    ).int32(g.maxUploadSizeMb), g.acceptAudio != null && Object.hasOwnProperty.call(g, "acceptAudio") && e.uint32(
      /* id 12, wireType 0 =*/
      96
    ).bool(g.acceptAudio), g.audioSampleRate != null && Object.hasOwnProperty.call(g, "audioSampleRate") && e.uint32(
      /* id 13, wireType 0 =*/
      104
    ).int32(g.audioSampleRate), e;
  }, o.decode = function(g, e, t) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let c = e === void 0 ? g.len : g.pos + e, n = new $root$1.ChatInput();
    for (; g.pos < c; ) {
      let h = g.uint32();
      if (h === t) break;
      switch (h >>> 3) {
        case 1: {
          n.id = g.string();
          break;
        }
        case 2: {
          n.placeholder = g.string();
          break;
        }
        case 3: {
          n.maxChars = g.uint32();
          break;
        }
        case 4: {
          n.disabled = g.bool();
          break;
        }
        case 5: {
          n.value = g.string();
          break;
        }
        case 6: {
          n.setValue = g.bool();
          break;
        }
        case 7: {
          n.default = g.string();
          break;
        }
        case 8: {
          n.position = g.int32();
          break;
        }
        case 9: {
          n.acceptFile = g.int32();
          break;
        }
        case 10: {
          n.fileType && n.fileType.length || (n.fileType = []), n.fileType.push(g.string());
          break;
        }
        case 11: {
          n.maxUploadSizeMb = g.int32();
          break;
        }
        case 12: {
          n.acceptAudio = g.bool();
          break;
        }
        case 13: {
          n.audioSampleRate = g.int32();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.ChatInput) return g;
    let e = new $root$1.ChatInput();
    switch (g.id != null && (e.id = String(g.id)), g.placeholder != null && (e.placeholder = String(g.placeholder)), g.maxChars != null && (e.maxChars = g.maxChars >>> 0), g.disabled != null && (e.disabled = !!g.disabled), g.value != null && (e.value = String(g.value)), g.setValue != null && (e.setValue = !!g.setValue), g.default != null && (e.default = String(g.default)), g.position) {
      default:
        if (typeof g.position == "number") {
          e.position = g.position;
          break;
        }
        break;
      case "BOTTOM":
      case 0:
        e.position = 0;
        break;
    }
    switch (g.acceptFile) {
      default:
        if (typeof g.acceptFile == "number") {
          e.acceptFile = g.acceptFile;
          break;
        }
        break;
      case "NONE":
      case 0:
        e.acceptFile = 0;
        break;
      case "SINGLE":
      case 1:
        e.acceptFile = 1;
        break;
      case "MULTIPLE":
      case 2:
        e.acceptFile = 2;
        break;
      case "DIRECTORY":
      case 3:
        e.acceptFile = 3;
        break;
    }
    if (g.fileType) {
      if (!Array.isArray(g.fileType)) throw TypeError(".ChatInput.fileType: array expected");
      e.fileType = [];
      for (let t = 0; t < g.fileType.length; ++t) e.fileType[t] = String(g.fileType[t]);
    }
    return g.maxUploadSizeMb != null && (e.maxUploadSizeMb = g.maxUploadSizeMb | 0), g.acceptAudio != null && (e.acceptAudio = !!g.acceptAudio), g.audioSampleRate != null && (e.audioSampleRate = g.audioSampleRate | 0), e;
  }, o.toObject = function(g, e) {
    e || (e = {});
    let t = {};
    if ((e.arrays || e.defaults) && (t.fileType = []), e.defaults && (t.id = "", t.placeholder = "", t.maxChars = 0, t.disabled = !1, t.value = "", t.setValue = !1, t.default = "", t.position = e.enums === String ? "BOTTOM" : 0, t.acceptFile = e.enums === String ? "NONE" : 0, t.maxUploadSizeMb = 0, t.acceptAudio = !1), g.id != null && g.hasOwnProperty("id") && (t.id = g.id), g.placeholder != null && g.hasOwnProperty("placeholder") && (t.placeholder = g.placeholder), g.maxChars != null && g.hasOwnProperty("maxChars") && (t.maxChars = g.maxChars), g.disabled != null && g.hasOwnProperty("disabled") && (t.disabled = g.disabled), g.value != null && g.hasOwnProperty("value") && (t.value = g.value), g.setValue != null && g.hasOwnProperty("setValue") && (t.setValue = g.setValue), g.default != null && g.hasOwnProperty("default") && (t.default = g.default), g.position != null && g.hasOwnProperty("position") && (t.position = e.enums === String ? $root$1.ChatInput.Position[g.position] === void 0 ? g.position : $root$1.ChatInput.Position[g.position] : g.position), g.acceptFile != null && g.hasOwnProperty("acceptFile") && (t.acceptFile = e.enums === String ? $root$1.ChatInput.AcceptFile[g.acceptFile] === void 0 ? g.acceptFile : $root$1.ChatInput.AcceptFile[g.acceptFile] : g.acceptFile), g.fileType && g.fileType.length) {
      t.fileType = [];
      for (let c = 0; c < g.fileType.length; ++c) t.fileType[c] = g.fileType[c];
    }
    return g.maxUploadSizeMb != null && g.hasOwnProperty("maxUploadSizeMb") && (t.maxUploadSizeMb = g.maxUploadSizeMb), g.acceptAudio != null && g.hasOwnProperty("acceptAudio") && (t.acceptAudio = g.acceptAudio), g.audioSampleRate != null && g.hasOwnProperty("audioSampleRate") && (t.audioSampleRate = g.audioSampleRate, e.oneofs && (t._audioSampleRate = "audioSampleRate")), t;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/ChatInput";
  }, o.Position = (function() {
    const A = {}, g = Object.create(A);
    return g[A[0] = "BOTTOM"] = 0, g;
  })(), o.AcceptFile = (function() {
    const A = {}, g = Object.create(A);
    return g[A[0] = "NONE"] = 0, g[A[1] = "SINGLE"] = 1, g[A[2] = "MULTIPLE"] = 2, g[A[3] = "DIRECTORY"] = 3, g;
  })(), o;
})(), Checkbox$1 = $root$1.Checkbox = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.id = "", o.prototype.label = "", o.prototype.default = !1, o.prototype.help = "", o.prototype.formId = "", o.prototype.value = !1, o.prototype.setValue = !1, o.prototype.disabled = !1, o.prototype.labelVisibility = null, o.prototype.type = 0, o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    return g || (g = $Writer$1.create()), A.id != null && Object.hasOwnProperty.call(A, "id") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(A.id), A.label != null && Object.hasOwnProperty.call(A, "label") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(A.label), A.default != null && Object.hasOwnProperty.call(A, "default") && g.uint32(
      /* id 3, wireType 0 =*/
      24
    ).bool(A.default), A.help != null && Object.hasOwnProperty.call(A, "help") && g.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(A.help), A.formId != null && Object.hasOwnProperty.call(A, "formId") && g.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(A.formId), A.value != null && Object.hasOwnProperty.call(A, "value") && g.uint32(
      /* id 6, wireType 0 =*/
      48
    ).bool(A.value), A.setValue != null && Object.hasOwnProperty.call(A, "setValue") && g.uint32(
      /* id 7, wireType 0 =*/
      56
    ).bool(A.setValue), A.disabled != null && Object.hasOwnProperty.call(A, "disabled") && g.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(A.disabled), A.labelVisibility != null && Object.hasOwnProperty.call(A, "labelVisibility") && $root$1.LabelVisibilityMessage.encode(A.labelVisibility, g.uint32(
      /* id 9, wireType 2 =*/
      74
    ).fork()).ldelim(), A.type != null && Object.hasOwnProperty.call(A, "type") && g.uint32(
      /* id 10, wireType 0 =*/
      80
    ).int32(A.type), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader$1 || (A = $Reader$1.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root$1.Checkbox();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.id = A.string();
          break;
        }
        case 2: {
          c.label = A.string();
          break;
        }
        case 3: {
          c.default = A.bool();
          break;
        }
        case 4: {
          c.help = A.string();
          break;
        }
        case 5: {
          c.formId = A.string();
          break;
        }
        case 6: {
          c.value = A.bool();
          break;
        }
        case 7: {
          c.setValue = A.bool();
          break;
        }
        case 8: {
          c.disabled = A.bool();
          break;
        }
        case 9: {
          c.labelVisibility = $root$1.LabelVisibilityMessage.decode(A, A.uint32());
          break;
        }
        case 10: {
          c.type = A.int32();
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root$1.Checkbox) return A;
    let g = new $root$1.Checkbox();
    if (A.id != null && (g.id = String(A.id)), A.label != null && (g.label = String(A.label)), A.default != null && (g.default = !!A.default), A.help != null && (g.help = String(A.help)), A.formId != null && (g.formId = String(A.formId)), A.value != null && (g.value = !!A.value), A.setValue != null && (g.setValue = !!A.setValue), A.disabled != null && (g.disabled = !!A.disabled), A.labelVisibility != null) {
      if (typeof A.labelVisibility != "object") throw TypeError(".Checkbox.labelVisibility: object expected");
      g.labelVisibility = $root$1.LabelVisibilityMessage.fromObject(A.labelVisibility);
    }
    switch (A.type) {
      default:
        if (typeof A.type == "number") {
          g.type = A.type;
          break;
        }
        break;
      case "DEFAULT":
      case 0:
        g.type = 0;
        break;
      case "TOGGLE":
      case 1:
        g.type = 1;
        break;
    }
    return g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    return g.defaults && (e.id = "", e.label = "", e.default = !1, e.help = "", e.formId = "", e.value = !1, e.setValue = !1, e.disabled = !1, e.labelVisibility = null, e.type = g.enums === String ? "DEFAULT" : 0), A.id != null && A.hasOwnProperty("id") && (e.id = A.id), A.label != null && A.hasOwnProperty("label") && (e.label = A.label), A.default != null && A.hasOwnProperty("default") && (e.default = A.default), A.help != null && A.hasOwnProperty("help") && (e.help = A.help), A.formId != null && A.hasOwnProperty("formId") && (e.formId = A.formId), A.value != null && A.hasOwnProperty("value") && (e.value = A.value), A.setValue != null && A.hasOwnProperty("setValue") && (e.setValue = A.setValue), A.disabled != null && A.hasOwnProperty("disabled") && (e.disabled = A.disabled), A.labelVisibility != null && A.hasOwnProperty("labelVisibility") && (e.labelVisibility = $root$1.LabelVisibilityMessage.toObject(A.labelVisibility, g)), A.type != null && A.hasOwnProperty("type") && (e.type = g.enums === String ? $root$1.Checkbox.StyleType[A.type] === void 0 ? A.type : $root$1.Checkbox.StyleType[A.type] : A.type), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/Checkbox";
  }, o.StyleType = (function() {
    const E = {}, A = Object.create(E);
    return A[E[0] = "DEFAULT"] = 0, A[E[1] = "TOGGLE"] = 1, A;
  })(), o;
})();
$root$1.Code = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.codeText = "", o.prototype.language = "", o.prototype.showLineNumbers = !1, o.prototype.wrapLines = !1, o.prototype.height = 0, o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    return g || (g = $Writer$1.create()), A.codeText != null && Object.hasOwnProperty.call(A, "codeText") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(A.codeText), A.language != null && Object.hasOwnProperty.call(A, "language") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(A.language), A.showLineNumbers != null && Object.hasOwnProperty.call(A, "showLineNumbers") && g.uint32(
      /* id 3, wireType 0 =*/
      24
    ).bool(A.showLineNumbers), A.wrapLines != null && Object.hasOwnProperty.call(A, "wrapLines") && g.uint32(
      /* id 4, wireType 0 =*/
      32
    ).bool(A.wrapLines), A.height != null && Object.hasOwnProperty.call(A, "height") && g.uint32(
      /* id 5, wireType 0 =*/
      40
    ).uint32(A.height), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader$1 || (A = $Reader$1.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root$1.Code();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.codeText = A.string();
          break;
        }
        case 2: {
          c.language = A.string();
          break;
        }
        case 3: {
          c.showLineNumbers = A.bool();
          break;
        }
        case 4: {
          c.wrapLines = A.bool();
          break;
        }
        case 5: {
          c.height = A.uint32();
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root$1.Code) return A;
    let g = new $root$1.Code();
    return A.codeText != null && (g.codeText = String(A.codeText)), A.language != null && (g.language = String(A.language)), A.showLineNumbers != null && (g.showLineNumbers = !!A.showLineNumbers), A.wrapLines != null && (g.wrapLines = !!A.wrapLines), A.height != null && (g.height = A.height >>> 0), g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    return g.defaults && (e.codeText = "", e.language = "", e.showLineNumbers = !1, e.wrapLines = !1, e.height = 0), A.codeText != null && A.hasOwnProperty("codeText") && (e.codeText = A.codeText), A.language != null && A.hasOwnProperty("language") && (e.language = A.language), A.showLineNumbers != null && A.hasOwnProperty("showLineNumbers") && (e.showLineNumbers = A.showLineNumbers), A.wrapLines != null && A.hasOwnProperty("wrapLines") && (e.wrapLines = A.wrapLines), A.height != null && A.hasOwnProperty("height") && (e.height = A.height), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/Code";
  }, o;
})();
$root$1.ColorPicker = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.id = "", o.prototype.label = "", o.prototype.default = "", o.prototype.help = "", o.prototype.formId = "", o.prototype.value = "", o.prototype.setValue = !1, o.prototype.disabled = !1, o.prototype.labelVisibility = null, o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    return g || (g = $Writer$1.create()), A.id != null && Object.hasOwnProperty.call(A, "id") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(A.id), A.label != null && Object.hasOwnProperty.call(A, "label") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(A.label), A.default != null && Object.hasOwnProperty.call(A, "default") && g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(A.default), A.help != null && Object.hasOwnProperty.call(A, "help") && g.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(A.help), A.formId != null && Object.hasOwnProperty.call(A, "formId") && g.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(A.formId), A.value != null && Object.hasOwnProperty.call(A, "value") && g.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(A.value), A.setValue != null && Object.hasOwnProperty.call(A, "setValue") && g.uint32(
      /* id 7, wireType 0 =*/
      56
    ).bool(A.setValue), A.disabled != null && Object.hasOwnProperty.call(A, "disabled") && g.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(A.disabled), A.labelVisibility != null && Object.hasOwnProperty.call(A, "labelVisibility") && $root$1.LabelVisibilityMessage.encode(A.labelVisibility, g.uint32(
      /* id 9, wireType 2 =*/
      74
    ).fork()).ldelim(), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader$1 || (A = $Reader$1.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root$1.ColorPicker();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.id = A.string();
          break;
        }
        case 2: {
          c.label = A.string();
          break;
        }
        case 3: {
          c.default = A.string();
          break;
        }
        case 4: {
          c.help = A.string();
          break;
        }
        case 5: {
          c.formId = A.string();
          break;
        }
        case 6: {
          c.value = A.string();
          break;
        }
        case 7: {
          c.setValue = A.bool();
          break;
        }
        case 8: {
          c.disabled = A.bool();
          break;
        }
        case 9: {
          c.labelVisibility = $root$1.LabelVisibilityMessage.decode(A, A.uint32());
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root$1.ColorPicker) return A;
    let g = new $root$1.ColorPicker();
    if (A.id != null && (g.id = String(A.id)), A.label != null && (g.label = String(A.label)), A.default != null && (g.default = String(A.default)), A.help != null && (g.help = String(A.help)), A.formId != null && (g.formId = String(A.formId)), A.value != null && (g.value = String(A.value)), A.setValue != null && (g.setValue = !!A.setValue), A.disabled != null && (g.disabled = !!A.disabled), A.labelVisibility != null) {
      if (typeof A.labelVisibility != "object") throw TypeError(".ColorPicker.labelVisibility: object expected");
      g.labelVisibility = $root$1.LabelVisibilityMessage.fromObject(A.labelVisibility);
    }
    return g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    return g.defaults && (e.id = "", e.label = "", e.default = "", e.help = "", e.formId = "", e.value = "", e.setValue = !1, e.disabled = !1, e.labelVisibility = null), A.id != null && A.hasOwnProperty("id") && (e.id = A.id), A.label != null && A.hasOwnProperty("label") && (e.label = A.label), A.default != null && A.hasOwnProperty("default") && (e.default = A.default), A.help != null && A.hasOwnProperty("help") && (e.help = A.help), A.formId != null && A.hasOwnProperty("formId") && (e.formId = A.formId), A.value != null && A.hasOwnProperty("value") && (e.value = A.value), A.setValue != null && A.hasOwnProperty("setValue") && (e.setValue = A.setValue), A.disabled != null && A.hasOwnProperty("disabled") && (e.disabled = A.disabled), A.labelVisibility != null && A.hasOwnProperty("labelVisibility") && (e.labelVisibility = $root$1.LabelVisibilityMessage.toObject(A.labelVisibility, g)), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/ColorPicker";
  }, o;
})();
$root$1.DataFrame = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.data = null, o.prototype.index = null, o.prototype.columns = null, o.prototype.style = null, o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    return g || (g = $Writer$1.create()), A.data != null && Object.hasOwnProperty.call(A, "data") && $root$1.Table.encode(A.data, g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim(), A.index != null && Object.hasOwnProperty.call(A, "index") && $root$1.Index.encode(A.index, g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), A.columns != null && Object.hasOwnProperty.call(A, "columns") && $root$1.Index.encode(A.columns, g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).fork()).ldelim(), A.style != null && Object.hasOwnProperty.call(A, "style") && $root$1.TableStyle.encode(A.style, g.uint32(
      /* id 4, wireType 2 =*/
      34
    ).fork()).ldelim(), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader$1 || (A = $Reader$1.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root$1.DataFrame();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.data = $root$1.Table.decode(A, A.uint32());
          break;
        }
        case 2: {
          c.index = $root$1.Index.decode(A, A.uint32());
          break;
        }
        case 3: {
          c.columns = $root$1.Index.decode(A, A.uint32());
          break;
        }
        case 4: {
          c.style = $root$1.TableStyle.decode(A, A.uint32());
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root$1.DataFrame) return A;
    let g = new $root$1.DataFrame();
    if (A.data != null) {
      if (typeof A.data != "object") throw TypeError(".DataFrame.data: object expected");
      g.data = $root$1.Table.fromObject(A.data);
    }
    if (A.index != null) {
      if (typeof A.index != "object") throw TypeError(".DataFrame.index: object expected");
      g.index = $root$1.Index.fromObject(A.index);
    }
    if (A.columns != null) {
      if (typeof A.columns != "object") throw TypeError(".DataFrame.columns: object expected");
      g.columns = $root$1.Index.fromObject(A.columns);
    }
    if (A.style != null) {
      if (typeof A.style != "object") throw TypeError(".DataFrame.style: object expected");
      g.style = $root$1.TableStyle.fromObject(A.style);
    }
    return g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    return g.defaults && (e.data = null, e.index = null, e.columns = null, e.style = null), A.data != null && A.hasOwnProperty("data") && (e.data = $root$1.Table.toObject(A.data, g)), A.index != null && A.hasOwnProperty("index") && (e.index = $root$1.Index.toObject(A.index, g)), A.columns != null && A.hasOwnProperty("columns") && (e.columns = $root$1.Index.toObject(A.columns, g)), A.style != null && A.hasOwnProperty("style") && (e.style = $root$1.TableStyle.toObject(A.style, g)), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/DataFrame";
  }, o;
})();
$root$1.Index = (() => {
  function o(A) {
    if (A) for (let g = Object.keys(A), e = 0; e < g.length; ++e) A[g[e]] != null && (this[g[e]] = A[g[e]]);
  }
  o.prototype.plainIndex = null, o.prototype.rangeIndex = null, o.prototype.multiIndex = null, o.prototype.datetimeIndex = null, o.prototype.timedeltaIndex = null, o.prototype.int_64Index = null, o.prototype.float_64Index = null;
  let E;
  return Object.defineProperty(o.prototype, "type", { get: $util$1.oneOfGetter(E = ["plainIndex", "rangeIndex", "multiIndex", "datetimeIndex", "timedeltaIndex", "int_64Index", "float_64Index"]), set: $util$1.oneOfSetter(E) }), o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, e) {
    return e || (e = $Writer$1.create()), g.plainIndex != null && Object.hasOwnProperty.call(g, "plainIndex") && $root$1.PlainIndex.encode(g.plainIndex, e.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim(), g.rangeIndex != null && Object.hasOwnProperty.call(g, "rangeIndex") && $root$1.RangeIndex.encode(g.rangeIndex, e.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), g.multiIndex != null && Object.hasOwnProperty.call(g, "multiIndex") && $root$1.MultiIndex.encode(g.multiIndex, e.uint32(
      /* id 4, wireType 2 =*/
      34
    ).fork()).ldelim(), g.datetimeIndex != null && Object.hasOwnProperty.call(g, "datetimeIndex") && $root$1.DatetimeIndex.encode(g.datetimeIndex, e.uint32(
      /* id 6, wireType 2 =*/
      50
    ).fork()).ldelim(), g.timedeltaIndex != null && Object.hasOwnProperty.call(g, "timedeltaIndex") && $root$1.TimedeltaIndex.encode(g.timedeltaIndex, e.uint32(
      /* id 7, wireType 2 =*/
      58
    ).fork()).ldelim(), g.int_64Index != null && Object.hasOwnProperty.call(g, "int_64Index") && $root$1.Int64Index.encode(g.int_64Index, e.uint32(
      /* id 9, wireType 2 =*/
      74
    ).fork()).ldelim(), g.float_64Index != null && Object.hasOwnProperty.call(g, "float_64Index") && $root$1.Float64Index.encode(g.float_64Index, e.uint32(
      /* id 11, wireType 2 =*/
      90
    ).fork()).ldelim(), e;
  }, o.decode = function(g, e, t) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let c = e === void 0 ? g.len : g.pos + e, n = new $root$1.Index();
    for (; g.pos < c; ) {
      let h = g.uint32();
      if (h === t) break;
      switch (h >>> 3) {
        case 1: {
          n.plainIndex = $root$1.PlainIndex.decode(g, g.uint32());
          break;
        }
        case 2: {
          n.rangeIndex = $root$1.RangeIndex.decode(g, g.uint32());
          break;
        }
        case 4: {
          n.multiIndex = $root$1.MultiIndex.decode(g, g.uint32());
          break;
        }
        case 6: {
          n.datetimeIndex = $root$1.DatetimeIndex.decode(g, g.uint32());
          break;
        }
        case 7: {
          n.timedeltaIndex = $root$1.TimedeltaIndex.decode(g, g.uint32());
          break;
        }
        case 9: {
          n.int_64Index = $root$1.Int64Index.decode(g, g.uint32());
          break;
        }
        case 11: {
          n.float_64Index = $root$1.Float64Index.decode(g, g.uint32());
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.Index) return g;
    let e = new $root$1.Index();
    if (g.plainIndex != null) {
      if (typeof g.plainIndex != "object") throw TypeError(".Index.plainIndex: object expected");
      e.plainIndex = $root$1.PlainIndex.fromObject(g.plainIndex);
    }
    if (g.rangeIndex != null) {
      if (typeof g.rangeIndex != "object") throw TypeError(".Index.rangeIndex: object expected");
      e.rangeIndex = $root$1.RangeIndex.fromObject(g.rangeIndex);
    }
    if (g.multiIndex != null) {
      if (typeof g.multiIndex != "object") throw TypeError(".Index.multiIndex: object expected");
      e.multiIndex = $root$1.MultiIndex.fromObject(g.multiIndex);
    }
    if (g.datetimeIndex != null) {
      if (typeof g.datetimeIndex != "object") throw TypeError(".Index.datetimeIndex: object expected");
      e.datetimeIndex = $root$1.DatetimeIndex.fromObject(g.datetimeIndex);
    }
    if (g.timedeltaIndex != null) {
      if (typeof g.timedeltaIndex != "object") throw TypeError(".Index.timedeltaIndex: object expected");
      e.timedeltaIndex = $root$1.TimedeltaIndex.fromObject(g.timedeltaIndex);
    }
    if (g.int_64Index != null) {
      if (typeof g.int_64Index != "object") throw TypeError(".Index.int_64Index: object expected");
      e.int_64Index = $root$1.Int64Index.fromObject(g.int_64Index);
    }
    if (g.float_64Index != null) {
      if (typeof g.float_64Index != "object") throw TypeError(".Index.float_64Index: object expected");
      e.float_64Index = $root$1.Float64Index.fromObject(g.float_64Index);
    }
    return e;
  }, o.toObject = function(g, e) {
    e || (e = {});
    let t = {};
    return g.plainIndex != null && g.hasOwnProperty("plainIndex") && (t.plainIndex = $root$1.PlainIndex.toObject(g.plainIndex, e), e.oneofs && (t.type = "plainIndex")), g.rangeIndex != null && g.hasOwnProperty("rangeIndex") && (t.rangeIndex = $root$1.RangeIndex.toObject(g.rangeIndex, e), e.oneofs && (t.type = "rangeIndex")), g.multiIndex != null && g.hasOwnProperty("multiIndex") && (t.multiIndex = $root$1.MultiIndex.toObject(g.multiIndex, e), e.oneofs && (t.type = "multiIndex")), g.datetimeIndex != null && g.hasOwnProperty("datetimeIndex") && (t.datetimeIndex = $root$1.DatetimeIndex.toObject(g.datetimeIndex, e), e.oneofs && (t.type = "datetimeIndex")), g.timedeltaIndex != null && g.hasOwnProperty("timedeltaIndex") && (t.timedeltaIndex = $root$1.TimedeltaIndex.toObject(g.timedeltaIndex, e), e.oneofs && (t.type = "timedeltaIndex")), g.int_64Index != null && g.hasOwnProperty("int_64Index") && (t.int_64Index = $root$1.Int64Index.toObject(g.int_64Index, e), e.oneofs && (t.type = "int_64Index")), g.float_64Index != null && g.hasOwnProperty("float_64Index") && (t.float_64Index = $root$1.Float64Index.toObject(g.float_64Index, e), e.oneofs && (t.type = "float_64Index")), t;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/Index";
  }, o;
})();
$root$1.PlainIndex = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.data = null, o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    return g || (g = $Writer$1.create()), A.data != null && Object.hasOwnProperty.call(A, "data") && $root$1.AnyArray.encode(A.data, g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim(), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader$1 || (A = $Reader$1.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root$1.PlainIndex();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.data = $root$1.AnyArray.decode(A, A.uint32());
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root$1.PlainIndex) return A;
    let g = new $root$1.PlainIndex();
    if (A.data != null) {
      if (typeof A.data != "object") throw TypeError(".PlainIndex.data: object expected");
      g.data = $root$1.AnyArray.fromObject(A.data);
    }
    return g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    return g.defaults && (e.data = null), A.data != null && A.hasOwnProperty("data") && (e.data = $root$1.AnyArray.toObject(A.data, g)), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/PlainIndex";
  }, o;
})();
$root$1.RangeIndex = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.start = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, o.prototype.stop = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    return g || (g = $Writer$1.create()), A.start != null && Object.hasOwnProperty.call(A, "start") && g.uint32(
      /* id 1, wireType 0 =*/
      8
    ).int64(A.start), A.stop != null && Object.hasOwnProperty.call(A, "stop") && g.uint32(
      /* id 2, wireType 0 =*/
      16
    ).int64(A.stop), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader$1 || (A = $Reader$1.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root$1.RangeIndex();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.start = A.int64();
          break;
        }
        case 2: {
          c.stop = A.int64();
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root$1.RangeIndex) return A;
    let g = new $root$1.RangeIndex();
    return A.start != null && ($util$1.Long ? (g.start = $util$1.Long.fromValue(A.start)).unsigned = !1 : typeof A.start == "string" ? g.start = parseInt(A.start, 10) : typeof A.start == "number" ? g.start = A.start : typeof A.start == "object" && (g.start = new $util$1.LongBits(A.start.low >>> 0, A.start.high >>> 0).toNumber())), A.stop != null && ($util$1.Long ? (g.stop = $util$1.Long.fromValue(A.stop)).unsigned = !1 : typeof A.stop == "string" ? g.stop = parseInt(A.stop, 10) : typeof A.stop == "number" ? g.stop = A.stop : typeof A.stop == "object" && (g.stop = new $util$1.LongBits(A.stop.low >>> 0, A.stop.high >>> 0).toNumber())), g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    if (g.defaults) {
      if ($util$1.Long) {
        let t = new $util$1.Long(0, 0, !1);
        e.start = g.longs === String ? t.toString() : g.longs === Number ? t.toNumber() : t;
      } else e.start = g.longs === String ? "0" : 0;
      if ($util$1.Long) {
        let t = new $util$1.Long(0, 0, !1);
        e.stop = g.longs === String ? t.toString() : g.longs === Number ? t.toNumber() : t;
      } else e.stop = g.longs === String ? "0" : 0;
    }
    return A.start != null && A.hasOwnProperty("start") && (typeof A.start == "number" ? e.start = g.longs === String ? String(A.start) : A.start : e.start = g.longs === String ? $util$1.Long.prototype.toString.call(A.start) : g.longs === Number ? new $util$1.LongBits(A.start.low >>> 0, A.start.high >>> 0).toNumber() : A.start), A.stop != null && A.hasOwnProperty("stop") && (typeof A.stop == "number" ? e.stop = g.longs === String ? String(A.stop) : A.stop : e.stop = g.longs === String ? $util$1.Long.prototype.toString.call(A.stop) : g.longs === Number ? new $util$1.LongBits(A.stop.low >>> 0, A.stop.high >>> 0).toNumber() : A.stop), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/RangeIndex";
  }, o;
})();
$root$1.MultiIndex = (() => {
  function o(E) {
    if (this.levels = [], this.labels = [], E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.levels = $util$1.emptyArray, o.prototype.labels = $util$1.emptyArray, o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    if (g || (g = $Writer$1.create()), A.levels != null && A.levels.length) for (let e = 0; e < A.levels.length; ++e) $root$1.Index.encode(A.levels[e], g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim();
    if (A.labels != null && A.labels.length) for (let e = 0; e < A.labels.length; ++e) $root$1.Int32Array.encode(A.labels[e], g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim();
    return g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader$1 || (A = $Reader$1.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root$1.MultiIndex();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.levels && c.levels.length || (c.levels = []), c.levels.push($root$1.Index.decode(A, A.uint32()));
          break;
        }
        case 2: {
          c.labels && c.labels.length || (c.labels = []), c.labels.push($root$1.Int32Array.decode(A, A.uint32()));
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root$1.MultiIndex) return A;
    let g = new $root$1.MultiIndex();
    if (A.levels) {
      if (!Array.isArray(A.levels)) throw TypeError(".MultiIndex.levels: array expected");
      g.levels = [];
      for (let e = 0; e < A.levels.length; ++e) {
        if (typeof A.levels[e] != "object") throw TypeError(".MultiIndex.levels: object expected");
        g.levels[e] = $root$1.Index.fromObject(A.levels[e]);
      }
    }
    if (A.labels) {
      if (!Array.isArray(A.labels)) throw TypeError(".MultiIndex.labels: array expected");
      g.labels = [];
      for (let e = 0; e < A.labels.length; ++e) {
        if (typeof A.labels[e] != "object") throw TypeError(".MultiIndex.labels: object expected");
        g.labels[e] = $root$1.Int32Array.fromObject(A.labels[e]);
      }
    }
    return g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    if ((g.arrays || g.defaults) && (e.levels = [], e.labels = []), A.levels && A.levels.length) {
      e.levels = [];
      for (let t = 0; t < A.levels.length; ++t) e.levels[t] = $root$1.Index.toObject(A.levels[t], g);
    }
    if (A.labels && A.labels.length) {
      e.labels = [];
      for (let t = 0; t < A.labels.length; ++t) e.labels[t] = $root$1.Int32Array.toObject(A.labels[t], g);
    }
    return e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/MultiIndex";
  }, o;
})();
$root$1.DatetimeIndex = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.data = null, o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    return g || (g = $Writer$1.create()), A.data != null && Object.hasOwnProperty.call(A, "data") && $root$1.StringArray.encode(A.data, g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim(), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader$1 || (A = $Reader$1.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root$1.DatetimeIndex();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.data = $root$1.StringArray.decode(A, A.uint32());
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root$1.DatetimeIndex) return A;
    let g = new $root$1.DatetimeIndex();
    if (A.data != null) {
      if (typeof A.data != "object") throw TypeError(".DatetimeIndex.data: object expected");
      g.data = $root$1.StringArray.fromObject(A.data);
    }
    return g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    return g.defaults && (e.data = null), A.data != null && A.hasOwnProperty("data") && (e.data = $root$1.StringArray.toObject(A.data, g)), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/DatetimeIndex";
  }, o;
})();
$root$1.TimedeltaIndex = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.data = null, o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    return g || (g = $Writer$1.create()), A.data != null && Object.hasOwnProperty.call(A, "data") && $root$1.Int64Array.encode(A.data, g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim(), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader$1 || (A = $Reader$1.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root$1.TimedeltaIndex();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.data = $root$1.Int64Array.decode(A, A.uint32());
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root$1.TimedeltaIndex) return A;
    let g = new $root$1.TimedeltaIndex();
    if (A.data != null) {
      if (typeof A.data != "object") throw TypeError(".TimedeltaIndex.data: object expected");
      g.data = $root$1.Int64Array.fromObject(A.data);
    }
    return g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    return g.defaults && (e.data = null), A.data != null && A.hasOwnProperty("data") && (e.data = $root$1.Int64Array.toObject(A.data, g)), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/TimedeltaIndex";
  }, o;
})();
$root$1.Int64Index = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.data = null, o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    return g || (g = $Writer$1.create()), A.data != null && Object.hasOwnProperty.call(A, "data") && $root$1.Int64Array.encode(A.data, g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim(), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader$1 || (A = $Reader$1.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root$1.Int64Index();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.data = $root$1.Int64Array.decode(A, A.uint32());
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root$1.Int64Index) return A;
    let g = new $root$1.Int64Index();
    if (A.data != null) {
      if (typeof A.data != "object") throw TypeError(".Int64Index.data: object expected");
      g.data = $root$1.Int64Array.fromObject(A.data);
    }
    return g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    return g.defaults && (e.data = null), A.data != null && A.hasOwnProperty("data") && (e.data = $root$1.Int64Array.toObject(A.data, g)), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/Int64Index";
  }, o;
})();
$root$1.Float64Index = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.data = null, o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    return g || (g = $Writer$1.create()), A.data != null && Object.hasOwnProperty.call(A, "data") && $root$1.DoubleArray.encode(A.data, g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim(), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader$1 || (A = $Reader$1.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root$1.Float64Index();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.data = $root$1.DoubleArray.decode(A, A.uint32());
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root$1.Float64Index) return A;
    let g = new $root$1.Float64Index();
    if (A.data != null) {
      if (typeof A.data != "object") throw TypeError(".Float64Index.data: object expected");
      g.data = $root$1.DoubleArray.fromObject(A.data);
    }
    return g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    return g.defaults && (e.data = null), A.data != null && A.hasOwnProperty("data") && (e.data = $root$1.DoubleArray.toObject(A.data, g)), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/Float64Index";
  }, o;
})();
$root$1.CSSStyle = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.property = "", o.prototype.value = "", o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    return g || (g = $Writer$1.create()), A.property != null && Object.hasOwnProperty.call(A, "property") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(A.property), A.value != null && Object.hasOwnProperty.call(A, "value") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(A.value), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader$1 || (A = $Reader$1.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root$1.CSSStyle();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.property = A.string();
          break;
        }
        case 2: {
          c.value = A.string();
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root$1.CSSStyle) return A;
    let g = new $root$1.CSSStyle();
    return A.property != null && (g.property = String(A.property)), A.value != null && (g.value = String(A.value)), g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    return g.defaults && (e.property = "", e.value = ""), A.property != null && A.hasOwnProperty("property") && (e.property = A.property), A.value != null && A.hasOwnProperty("value") && (e.value = A.value), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/CSSStyle";
  }, o;
})();
$root$1.CellStyle = (() => {
  function o(E) {
    if (this.css = [], E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.css = $util$1.emptyArray, o.prototype.displayValue = "", o.prototype.hasDisplayValue = !1, o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    if (g || (g = $Writer$1.create()), A.css != null && A.css.length) for (let e = 0; e < A.css.length; ++e) $root$1.CSSStyle.encode(A.css[e], g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim();
    return A.displayValue != null && Object.hasOwnProperty.call(A, "displayValue") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(A.displayValue), A.hasDisplayValue != null && Object.hasOwnProperty.call(A, "hasDisplayValue") && g.uint32(
      /* id 3, wireType 0 =*/
      24
    ).bool(A.hasDisplayValue), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader$1 || (A = $Reader$1.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root$1.CellStyle();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.css && c.css.length || (c.css = []), c.css.push($root$1.CSSStyle.decode(A, A.uint32()));
          break;
        }
        case 2: {
          c.displayValue = A.string();
          break;
        }
        case 3: {
          c.hasDisplayValue = A.bool();
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root$1.CellStyle) return A;
    let g = new $root$1.CellStyle();
    if (A.css) {
      if (!Array.isArray(A.css)) throw TypeError(".CellStyle.css: array expected");
      g.css = [];
      for (let e = 0; e < A.css.length; ++e) {
        if (typeof A.css[e] != "object") throw TypeError(".CellStyle.css: object expected");
        g.css[e] = $root$1.CSSStyle.fromObject(A.css[e]);
      }
    }
    return A.displayValue != null && (g.displayValue = String(A.displayValue)), A.hasDisplayValue != null && (g.hasDisplayValue = !!A.hasDisplayValue), g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    if ((g.arrays || g.defaults) && (e.css = []), g.defaults && (e.displayValue = "", e.hasDisplayValue = !1), A.css && A.css.length) {
      e.css = [];
      for (let t = 0; t < A.css.length; ++t) e.css[t] = $root$1.CSSStyle.toObject(A.css[t], g);
    }
    return A.displayValue != null && A.hasOwnProperty("displayValue") && (e.displayValue = A.displayValue), A.hasDisplayValue != null && A.hasOwnProperty("hasDisplayValue") && (e.hasDisplayValue = A.hasDisplayValue), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/CellStyle";
  }, o;
})();
$root$1.CellStyleArray = (() => {
  function o(E) {
    if (this.styles = [], E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.styles = $util$1.emptyArray, o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    if (g || (g = $Writer$1.create()), A.styles != null && A.styles.length) for (let e = 0; e < A.styles.length; ++e) $root$1.CellStyle.encode(A.styles[e], g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim();
    return g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader$1 || (A = $Reader$1.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root$1.CellStyleArray();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.styles && c.styles.length || (c.styles = []), c.styles.push($root$1.CellStyle.decode(A, A.uint32()));
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root$1.CellStyleArray) return A;
    let g = new $root$1.CellStyleArray();
    if (A.styles) {
      if (!Array.isArray(A.styles)) throw TypeError(".CellStyleArray.styles: array expected");
      g.styles = [];
      for (let e = 0; e < A.styles.length; ++e) {
        if (typeof A.styles[e] != "object") throw TypeError(".CellStyleArray.styles: object expected");
        g.styles[e] = $root$1.CellStyle.fromObject(A.styles[e]);
      }
    }
    return g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    if ((g.arrays || g.defaults) && (e.styles = []), A.styles && A.styles.length) {
      e.styles = [];
      for (let t = 0; t < A.styles.length; ++t) e.styles[t] = $root$1.CellStyle.toObject(A.styles[t], g);
    }
    return e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/CellStyleArray";
  }, o;
})();
$root$1.AnyArray = (() => {
  function o(A) {
    if (A) for (let g = Object.keys(A), e = 0; e < g.length; ++e) A[g[e]] != null && (this[g[e]] = A[g[e]]);
  }
  o.prototype.strings = null, o.prototype.doubles = null, o.prototype.int64s = null, o.prototype.datetimes = null, o.prototype.timedeltas = null;
  let E;
  return Object.defineProperty(o.prototype, "type", { get: $util$1.oneOfGetter(E = ["strings", "doubles", "int64s", "datetimes", "timedeltas"]), set: $util$1.oneOfSetter(E) }), o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, e) {
    return e || (e = $Writer$1.create()), g.strings != null && Object.hasOwnProperty.call(g, "strings") && $root$1.StringArray.encode(g.strings, e.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim(), g.doubles != null && Object.hasOwnProperty.call(g, "doubles") && $root$1.DoubleArray.encode(g.doubles, e.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), g.int64s != null && Object.hasOwnProperty.call(g, "int64s") && $root$1.Int64Array.encode(g.int64s, e.uint32(
      /* id 3, wireType 2 =*/
      26
    ).fork()).ldelim(), g.datetimes != null && Object.hasOwnProperty.call(g, "datetimes") && $root$1.StringArray.encode(g.datetimes, e.uint32(
      /* id 4, wireType 2 =*/
      34
    ).fork()).ldelim(), g.timedeltas != null && Object.hasOwnProperty.call(g, "timedeltas") && $root$1.Int64Array.encode(g.timedeltas, e.uint32(
      /* id 5, wireType 2 =*/
      42
    ).fork()).ldelim(), e;
  }, o.decode = function(g, e, t) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let c = e === void 0 ? g.len : g.pos + e, n = new $root$1.AnyArray();
    for (; g.pos < c; ) {
      let h = g.uint32();
      if (h === t) break;
      switch (h >>> 3) {
        case 1: {
          n.strings = $root$1.StringArray.decode(g, g.uint32());
          break;
        }
        case 2: {
          n.doubles = $root$1.DoubleArray.decode(g, g.uint32());
          break;
        }
        case 3: {
          n.int64s = $root$1.Int64Array.decode(g, g.uint32());
          break;
        }
        case 4: {
          n.datetimes = $root$1.StringArray.decode(g, g.uint32());
          break;
        }
        case 5: {
          n.timedeltas = $root$1.Int64Array.decode(g, g.uint32());
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.AnyArray) return g;
    let e = new $root$1.AnyArray();
    if (g.strings != null) {
      if (typeof g.strings != "object") throw TypeError(".AnyArray.strings: object expected");
      e.strings = $root$1.StringArray.fromObject(g.strings);
    }
    if (g.doubles != null) {
      if (typeof g.doubles != "object") throw TypeError(".AnyArray.doubles: object expected");
      e.doubles = $root$1.DoubleArray.fromObject(g.doubles);
    }
    if (g.int64s != null) {
      if (typeof g.int64s != "object") throw TypeError(".AnyArray.int64s: object expected");
      e.int64s = $root$1.Int64Array.fromObject(g.int64s);
    }
    if (g.datetimes != null) {
      if (typeof g.datetimes != "object") throw TypeError(".AnyArray.datetimes: object expected");
      e.datetimes = $root$1.StringArray.fromObject(g.datetimes);
    }
    if (g.timedeltas != null) {
      if (typeof g.timedeltas != "object") throw TypeError(".AnyArray.timedeltas: object expected");
      e.timedeltas = $root$1.Int64Array.fromObject(g.timedeltas);
    }
    return e;
  }, o.toObject = function(g, e) {
    e || (e = {});
    let t = {};
    return g.strings != null && g.hasOwnProperty("strings") && (t.strings = $root$1.StringArray.toObject(g.strings, e), e.oneofs && (t.type = "strings")), g.doubles != null && g.hasOwnProperty("doubles") && (t.doubles = $root$1.DoubleArray.toObject(g.doubles, e), e.oneofs && (t.type = "doubles")), g.int64s != null && g.hasOwnProperty("int64s") && (t.int64s = $root$1.Int64Array.toObject(g.int64s, e), e.oneofs && (t.type = "int64s")), g.datetimes != null && g.hasOwnProperty("datetimes") && (t.datetimes = $root$1.StringArray.toObject(g.datetimes, e), e.oneofs && (t.type = "datetimes")), g.timedeltas != null && g.hasOwnProperty("timedeltas") && (t.timedeltas = $root$1.Int64Array.toObject(g.timedeltas, e), e.oneofs && (t.type = "timedeltas")), t;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/AnyArray";
  }, o;
})();
$root$1.Table = (() => {
  function o(E) {
    if (this.cols = [], E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.cols = $util$1.emptyArray, o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    if (g || (g = $Writer$1.create()), A.cols != null && A.cols.length) for (let e = 0; e < A.cols.length; ++e) $root$1.AnyArray.encode(A.cols[e], g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim();
    return g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader$1 || (A = $Reader$1.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root$1.Table();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.cols && c.cols.length || (c.cols = []), c.cols.push($root$1.AnyArray.decode(A, A.uint32()));
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root$1.Table) return A;
    let g = new $root$1.Table();
    if (A.cols) {
      if (!Array.isArray(A.cols)) throw TypeError(".Table.cols: array expected");
      g.cols = [];
      for (let e = 0; e < A.cols.length; ++e) {
        if (typeof A.cols[e] != "object") throw TypeError(".Table.cols: object expected");
        g.cols[e] = $root$1.AnyArray.fromObject(A.cols[e]);
      }
    }
    return g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    if ((g.arrays || g.defaults) && (e.cols = []), A.cols && A.cols.length) {
      e.cols = [];
      for (let t = 0; t < A.cols.length; ++t) e.cols[t] = $root$1.AnyArray.toObject(A.cols[t], g);
    }
    return e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/Table";
  }, o;
})();
$root$1.TableStyle = (() => {
  function o(E) {
    if (this.cols = [], E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.cols = $util$1.emptyArray, o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    if (g || (g = $Writer$1.create()), A.cols != null && A.cols.length) for (let e = 0; e < A.cols.length; ++e) $root$1.CellStyleArray.encode(A.cols[e], g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim();
    return g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader$1 || (A = $Reader$1.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root$1.TableStyle();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.cols && c.cols.length || (c.cols = []), c.cols.push($root$1.CellStyleArray.decode(A, A.uint32()));
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root$1.TableStyle) return A;
    let g = new $root$1.TableStyle();
    if (A.cols) {
      if (!Array.isArray(A.cols)) throw TypeError(".TableStyle.cols: array expected");
      g.cols = [];
      for (let e = 0; e < A.cols.length; ++e) {
        if (typeof A.cols[e] != "object") throw TypeError(".TableStyle.cols: object expected");
        g.cols[e] = $root$1.CellStyleArray.fromObject(A.cols[e]);
      }
    }
    return g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    if ((g.arrays || g.defaults) && (e.cols = []), A.cols && A.cols.length) {
      e.cols = [];
      for (let t = 0; t < A.cols.length; ++t) e.cols[t] = $root$1.CellStyleArray.toObject(A.cols[t], g);
    }
    return e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/TableStyle";
  }, o;
})();
$root$1.DateInput = (() => {
  function o(E) {
    if (this.default = [], this.value = [], E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.id = "", o.prototype.label = "", o.prototype.default = $util$1.emptyArray, o.prototype.min = "", o.prototype.max = "", o.prototype.isRange = !1, o.prototype.help = "", o.prototype.formId = "", o.prototype.value = $util$1.emptyArray, o.prototype.setValue = !1, o.prototype.disabled = !1, o.prototype.labelVisibility = null, o.prototype.format = "", o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    if (g || (g = $Writer$1.create()), A.id != null && Object.hasOwnProperty.call(A, "id") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(A.id), A.label != null && Object.hasOwnProperty.call(A, "label") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(A.label), A.default != null && A.default.length) for (let e = 0; e < A.default.length; ++e) g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(A.default[e]);
    if (A.min != null && Object.hasOwnProperty.call(A, "min") && g.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(A.min), A.max != null && Object.hasOwnProperty.call(A, "max") && g.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(A.max), A.isRange != null && Object.hasOwnProperty.call(A, "isRange") && g.uint32(
      /* id 6, wireType 0 =*/
      48
    ).bool(A.isRange), A.help != null && Object.hasOwnProperty.call(A, "help") && g.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(A.help), A.formId != null && Object.hasOwnProperty.call(A, "formId") && g.uint32(
      /* id 8, wireType 2 =*/
      66
    ).string(A.formId), A.value != null && A.value.length) for (let e = 0; e < A.value.length; ++e) g.uint32(
      /* id 9, wireType 2 =*/
      74
    ).string(A.value[e]);
    return A.setValue != null && Object.hasOwnProperty.call(A, "setValue") && g.uint32(
      /* id 10, wireType 0 =*/
      80
    ).bool(A.setValue), A.disabled != null && Object.hasOwnProperty.call(A, "disabled") && g.uint32(
      /* id 11, wireType 0 =*/
      88
    ).bool(A.disabled), A.labelVisibility != null && Object.hasOwnProperty.call(A, "labelVisibility") && $root$1.LabelVisibilityMessage.encode(A.labelVisibility, g.uint32(
      /* id 12, wireType 2 =*/
      98
    ).fork()).ldelim(), A.format != null && Object.hasOwnProperty.call(A, "format") && g.uint32(
      /* id 13, wireType 2 =*/
      106
    ).string(A.format), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader$1 || (A = $Reader$1.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root$1.DateInput();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.id = A.string();
          break;
        }
        case 2: {
          c.label = A.string();
          break;
        }
        case 3: {
          c.default && c.default.length || (c.default = []), c.default.push(A.string());
          break;
        }
        case 4: {
          c.min = A.string();
          break;
        }
        case 5: {
          c.max = A.string();
          break;
        }
        case 6: {
          c.isRange = A.bool();
          break;
        }
        case 7: {
          c.help = A.string();
          break;
        }
        case 8: {
          c.formId = A.string();
          break;
        }
        case 9: {
          c.value && c.value.length || (c.value = []), c.value.push(A.string());
          break;
        }
        case 10: {
          c.setValue = A.bool();
          break;
        }
        case 11: {
          c.disabled = A.bool();
          break;
        }
        case 12: {
          c.labelVisibility = $root$1.LabelVisibilityMessage.decode(A, A.uint32());
          break;
        }
        case 13: {
          c.format = A.string();
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root$1.DateInput) return A;
    let g = new $root$1.DateInput();
    if (A.id != null && (g.id = String(A.id)), A.label != null && (g.label = String(A.label)), A.default) {
      if (!Array.isArray(A.default)) throw TypeError(".DateInput.default: array expected");
      g.default = [];
      for (let e = 0; e < A.default.length; ++e) g.default[e] = String(A.default[e]);
    }
    if (A.min != null && (g.min = String(A.min)), A.max != null && (g.max = String(A.max)), A.isRange != null && (g.isRange = !!A.isRange), A.help != null && (g.help = String(A.help)), A.formId != null && (g.formId = String(A.formId)), A.value) {
      if (!Array.isArray(A.value)) throw TypeError(".DateInput.value: array expected");
      g.value = [];
      for (let e = 0; e < A.value.length; ++e) g.value[e] = String(A.value[e]);
    }
    if (A.setValue != null && (g.setValue = !!A.setValue), A.disabled != null && (g.disabled = !!A.disabled), A.labelVisibility != null) {
      if (typeof A.labelVisibility != "object") throw TypeError(".DateInput.labelVisibility: object expected");
      g.labelVisibility = $root$1.LabelVisibilityMessage.fromObject(A.labelVisibility);
    }
    return A.format != null && (g.format = String(A.format)), g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    if ((g.arrays || g.defaults) && (e.default = [], e.value = []), g.defaults && (e.id = "", e.label = "", e.min = "", e.max = "", e.isRange = !1, e.help = "", e.formId = "", e.setValue = !1, e.disabled = !1, e.labelVisibility = null, e.format = ""), A.id != null && A.hasOwnProperty("id") && (e.id = A.id), A.label != null && A.hasOwnProperty("label") && (e.label = A.label), A.default && A.default.length) {
      e.default = [];
      for (let t = 0; t < A.default.length; ++t) e.default[t] = A.default[t];
    }
    if (A.min != null && A.hasOwnProperty("min") && (e.min = A.min), A.max != null && A.hasOwnProperty("max") && (e.max = A.max), A.isRange != null && A.hasOwnProperty("isRange") && (e.isRange = A.isRange), A.help != null && A.hasOwnProperty("help") && (e.help = A.help), A.formId != null && A.hasOwnProperty("formId") && (e.formId = A.formId), A.value && A.value.length) {
      e.value = [];
      for (let t = 0; t < A.value.length; ++t) e.value[t] = A.value[t];
    }
    return A.setValue != null && A.hasOwnProperty("setValue") && (e.setValue = A.setValue), A.disabled != null && A.hasOwnProperty("disabled") && (e.disabled = A.disabled), A.labelVisibility != null && A.hasOwnProperty("labelVisibility") && (e.labelVisibility = $root$1.LabelVisibilityMessage.toObject(A.labelVisibility, g)), A.format != null && A.hasOwnProperty("format") && (e.format = A.format), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/DateInput";
  }, o;
})();
$root$1.DateTimeInput = (() => {
  function o(E) {
    if (this.default = [], this.value = [], E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.id = "", o.prototype.label = "", o.prototype.default = $util$1.emptyArray, o.prototype.min = "", o.prototype.max = "", o.prototype.help = "", o.prototype.formId = "", o.prototype.value = $util$1.emptyArray, o.prototype.setValue = !1, o.prototype.disabled = !1, o.prototype.labelVisibility = null, o.prototype.format = "", o.prototype.step = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, o.prototype.isRange = !1, o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    if (g || (g = $Writer$1.create()), A.id != null && Object.hasOwnProperty.call(A, "id") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(A.id), A.label != null && Object.hasOwnProperty.call(A, "label") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(A.label), A.default != null && A.default.length) for (let e = 0; e < A.default.length; ++e) g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(A.default[e]);
    if (A.min != null && Object.hasOwnProperty.call(A, "min") && g.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(A.min), A.max != null && Object.hasOwnProperty.call(A, "max") && g.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(A.max), A.help != null && Object.hasOwnProperty.call(A, "help") && g.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(A.help), A.formId != null && Object.hasOwnProperty.call(A, "formId") && g.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(A.formId), A.value != null && A.value.length) for (let e = 0; e < A.value.length; ++e) g.uint32(
      /* id 8, wireType 2 =*/
      66
    ).string(A.value[e]);
    return A.setValue != null && Object.hasOwnProperty.call(A, "setValue") && g.uint32(
      /* id 9, wireType 0 =*/
      72
    ).bool(A.setValue), A.disabled != null && Object.hasOwnProperty.call(A, "disabled") && g.uint32(
      /* id 10, wireType 0 =*/
      80
    ).bool(A.disabled), A.labelVisibility != null && Object.hasOwnProperty.call(A, "labelVisibility") && $root$1.LabelVisibilityMessage.encode(A.labelVisibility, g.uint32(
      /* id 11, wireType 2 =*/
      90
    ).fork()).ldelim(), A.format != null && Object.hasOwnProperty.call(A, "format") && g.uint32(
      /* id 12, wireType 2 =*/
      98
    ).string(A.format), A.step != null && Object.hasOwnProperty.call(A, "step") && g.uint32(
      /* id 13, wireType 0 =*/
      104
    ).int64(A.step), A.isRange != null && Object.hasOwnProperty.call(A, "isRange") && g.uint32(
      /* id 14, wireType 0 =*/
      112
    ).bool(A.isRange), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader$1 || (A = $Reader$1.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root$1.DateTimeInput();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.id = A.string();
          break;
        }
        case 2: {
          c.label = A.string();
          break;
        }
        case 3: {
          c.default && c.default.length || (c.default = []), c.default.push(A.string());
          break;
        }
        case 4: {
          c.min = A.string();
          break;
        }
        case 5: {
          c.max = A.string();
          break;
        }
        case 6: {
          c.help = A.string();
          break;
        }
        case 7: {
          c.formId = A.string();
          break;
        }
        case 8: {
          c.value && c.value.length || (c.value = []), c.value.push(A.string());
          break;
        }
        case 9: {
          c.setValue = A.bool();
          break;
        }
        case 10: {
          c.disabled = A.bool();
          break;
        }
        case 11: {
          c.labelVisibility = $root$1.LabelVisibilityMessage.decode(A, A.uint32());
          break;
        }
        case 12: {
          c.format = A.string();
          break;
        }
        case 13: {
          c.step = A.int64();
          break;
        }
        case 14: {
          c.isRange = A.bool();
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root$1.DateTimeInput) return A;
    let g = new $root$1.DateTimeInput();
    if (A.id != null && (g.id = String(A.id)), A.label != null && (g.label = String(A.label)), A.default) {
      if (!Array.isArray(A.default)) throw TypeError(".DateTimeInput.default: array expected");
      g.default = [];
      for (let e = 0; e < A.default.length; ++e) g.default[e] = String(A.default[e]);
    }
    if (A.min != null && (g.min = String(A.min)), A.max != null && (g.max = String(A.max)), A.help != null && (g.help = String(A.help)), A.formId != null && (g.formId = String(A.formId)), A.value) {
      if (!Array.isArray(A.value)) throw TypeError(".DateTimeInput.value: array expected");
      g.value = [];
      for (let e = 0; e < A.value.length; ++e) g.value[e] = String(A.value[e]);
    }
    if (A.setValue != null && (g.setValue = !!A.setValue), A.disabled != null && (g.disabled = !!A.disabled), A.labelVisibility != null) {
      if (typeof A.labelVisibility != "object") throw TypeError(".DateTimeInput.labelVisibility: object expected");
      g.labelVisibility = $root$1.LabelVisibilityMessage.fromObject(A.labelVisibility);
    }
    return A.format != null && (g.format = String(A.format)), A.step != null && ($util$1.Long ? (g.step = $util$1.Long.fromValue(A.step)).unsigned = !1 : typeof A.step == "string" ? g.step = parseInt(A.step, 10) : typeof A.step == "number" ? g.step = A.step : typeof A.step == "object" && (g.step = new $util$1.LongBits(A.step.low >>> 0, A.step.high >>> 0).toNumber())), A.isRange != null && (g.isRange = !!A.isRange), g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    if ((g.arrays || g.defaults) && (e.default = [], e.value = []), g.defaults) {
      if (e.id = "", e.label = "", e.min = "", e.max = "", e.help = "", e.formId = "", e.setValue = !1, e.disabled = !1, e.labelVisibility = null, e.format = "", $util$1.Long) {
        let t = new $util$1.Long(0, 0, !1);
        e.step = g.longs === String ? t.toString() : g.longs === Number ? t.toNumber() : t;
      } else e.step = g.longs === String ? "0" : 0;
      e.isRange = !1;
    }
    if (A.id != null && A.hasOwnProperty("id") && (e.id = A.id), A.label != null && A.hasOwnProperty("label") && (e.label = A.label), A.default && A.default.length) {
      e.default = [];
      for (let t = 0; t < A.default.length; ++t) e.default[t] = A.default[t];
    }
    if (A.min != null && A.hasOwnProperty("min") && (e.min = A.min), A.max != null && A.hasOwnProperty("max") && (e.max = A.max), A.help != null && A.hasOwnProperty("help") && (e.help = A.help), A.formId != null && A.hasOwnProperty("formId") && (e.formId = A.formId), A.value && A.value.length) {
      e.value = [];
      for (let t = 0; t < A.value.length; ++t) e.value[t] = A.value[t];
    }
    return A.setValue != null && A.hasOwnProperty("setValue") && (e.setValue = A.setValue), A.disabled != null && A.hasOwnProperty("disabled") && (e.disabled = A.disabled), A.labelVisibility != null && A.hasOwnProperty("labelVisibility") && (e.labelVisibility = $root$1.LabelVisibilityMessage.toObject(A.labelVisibility, g)), A.format != null && A.hasOwnProperty("format") && (e.format = A.format), A.step != null && A.hasOwnProperty("step") && (typeof A.step == "number" ? e.step = g.longs === String ? String(A.step) : A.step : e.step = g.longs === String ? $util$1.Long.prototype.toString.call(A.step) : g.longs === Number ? new $util$1.LongBits(A.step.low >>> 0, A.step.high >>> 0).toNumber() : A.step), A.isRange != null && A.hasOwnProperty("isRange") && (e.isRange = A.isRange), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/DateTimeInput";
  }, o;
})();
const DeckGlJsonChart$1 = $root$1.DeckGlJsonChart = (() => {
  function o(E) {
    if (this.selectionMode = [], E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.json = "", o.prototype.tooltip = "", o.prototype.useContainerWidth = !1, o.prototype.id = "", o.prototype.mapboxToken = "", o.prototype.width = 0, o.prototype.height = 0, o.prototype.selectionMode = $util$1.emptyArray, o.prototype.formId = "", o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    if (g || (g = $Writer$1.create()), A.json != null && Object.hasOwnProperty.call(A, "json") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(A.json), A.tooltip != null && Object.hasOwnProperty.call(A, "tooltip") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(A.tooltip), A.useContainerWidth != null && Object.hasOwnProperty.call(A, "useContainerWidth") && g.uint32(
      /* id 4, wireType 0 =*/
      32
    ).bool(A.useContainerWidth), A.id != null && Object.hasOwnProperty.call(A, "id") && g.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(A.id), A.mapboxToken != null && Object.hasOwnProperty.call(A, "mapboxToken") && g.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(A.mapboxToken), A.width != null && Object.hasOwnProperty.call(A, "width") && g.uint32(
      /* id 7, wireType 0 =*/
      56
    ).uint32(A.width), A.height != null && Object.hasOwnProperty.call(A, "height") && g.uint32(
      /* id 8, wireType 0 =*/
      64
    ).uint32(A.height), A.selectionMode != null && A.selectionMode.length) {
      g.uint32(
        /* id 9, wireType 2 =*/
        74
      ).fork();
      for (let e = 0; e < A.selectionMode.length; ++e) g.int32(A.selectionMode[e]);
      g.ldelim();
    }
    return A.formId != null && Object.hasOwnProperty.call(A, "formId") && g.uint32(
      /* id 10, wireType 2 =*/
      82
    ).string(A.formId), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader$1 || (A = $Reader$1.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root$1.DeckGlJsonChart();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.json = A.string();
          break;
        }
        case 2: {
          c.tooltip = A.string();
          break;
        }
        case 4: {
          c.useContainerWidth = A.bool();
          break;
        }
        case 5: {
          c.id = A.string();
          break;
        }
        case 6: {
          c.mapboxToken = A.string();
          break;
        }
        case 7: {
          c.width = A.uint32();
          break;
        }
        case 8: {
          c.height = A.uint32();
          break;
        }
        case 9: {
          if (c.selectionMode && c.selectionMode.length || (c.selectionMode = []), (n & 7) === 2) {
            let h = A.uint32() + A.pos;
            for (; A.pos < h; ) c.selectionMode.push(A.int32());
          } else c.selectionMode.push(A.int32());
          break;
        }
        case 10: {
          c.formId = A.string();
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root$1.DeckGlJsonChart) return A;
    let g = new $root$1.DeckGlJsonChart();
    if (A.json != null && (g.json = String(A.json)), A.tooltip != null && (g.tooltip = String(A.tooltip)), A.useContainerWidth != null && (g.useContainerWidth = !!A.useContainerWidth), A.id != null && (g.id = String(A.id)), A.mapboxToken != null && (g.mapboxToken = String(A.mapboxToken)), A.width != null && (g.width = A.width >>> 0), A.height != null && (g.height = A.height >>> 0), A.selectionMode) {
      if (!Array.isArray(A.selectionMode)) throw TypeError(".DeckGlJsonChart.selectionMode: array expected");
      g.selectionMode = [];
      for (let e = 0; e < A.selectionMode.length; ++e) switch (A.selectionMode[e]) {
        default:
          if (typeof A.selectionMode[e] == "number") {
            g.selectionMode[e] = A.selectionMode[e];
            break;
          }
        case "SINGLE_OBJECT":
        case 0:
          g.selectionMode[e] = 0;
          break;
        case "MULTI_OBJECT":
        case 1:
          g.selectionMode[e] = 1;
          break;
      }
    }
    return A.formId != null && (g.formId = String(A.formId)), g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    if ((g.arrays || g.defaults) && (e.selectionMode = []), g.defaults && (e.json = "", e.tooltip = "", e.useContainerWidth = !1, e.id = "", e.mapboxToken = "", e.width = 0, e.height = 0, e.formId = ""), A.json != null && A.hasOwnProperty("json") && (e.json = A.json), A.tooltip != null && A.hasOwnProperty("tooltip") && (e.tooltip = A.tooltip), A.useContainerWidth != null && A.hasOwnProperty("useContainerWidth") && (e.useContainerWidth = A.useContainerWidth), A.id != null && A.hasOwnProperty("id") && (e.id = A.id), A.mapboxToken != null && A.hasOwnProperty("mapboxToken") && (e.mapboxToken = A.mapboxToken), A.width != null && A.hasOwnProperty("width") && (e.width = A.width), A.height != null && A.hasOwnProperty("height") && (e.height = A.height), A.selectionMode && A.selectionMode.length) {
      e.selectionMode = [];
      for (let t = 0; t < A.selectionMode.length; ++t) e.selectionMode[t] = g.enums === String ? $root$1.DeckGlJsonChart.SelectionMode[A.selectionMode[t]] === void 0 ? A.selectionMode[t] : $root$1.DeckGlJsonChart.SelectionMode[A.selectionMode[t]] : A.selectionMode[t];
    }
    return A.formId != null && A.hasOwnProperty("formId") && (e.formId = A.formId), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/DeckGlJsonChart";
  }, o.SelectionMode = (function() {
    const E = {}, A = Object.create(E);
    return A[E[0] = "SINGLE_OBJECT"] = 0, A[E[1] = "MULTI_OBJECT"] = 1, A;
  })(), o;
})();
$root$1.Delta = (() => {
  function o(A) {
    if (A) for (let g = Object.keys(A), e = 0; e < g.length; ++e) A[g[e]] != null && (this[g[e]] = A[g[e]]);
  }
  o.prototype.newElement = null, o.prototype.addBlock = null, o.prototype.addRows = null, o.prototype.arrowAddRows = null, o.prototype.fragmentId = "";
  let E;
  return Object.defineProperty(o.prototype, "type", { get: $util$1.oneOfGetter(E = ["newElement", "addBlock", "addRows", "arrowAddRows"]), set: $util$1.oneOfSetter(E) }), o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, e) {
    return e || (e = $Writer$1.create()), g.newElement != null && Object.hasOwnProperty.call(g, "newElement") && $root$1.Element.encode(g.newElement, e.uint32(
      /* id 3, wireType 2 =*/
      26
    ).fork()).ldelim(), g.addRows != null && Object.hasOwnProperty.call(g, "addRows") && $root$1.NamedDataSet.encode(g.addRows, e.uint32(
      /* id 5, wireType 2 =*/
      42
    ).fork()).ldelim(), g.addBlock != null && Object.hasOwnProperty.call(g, "addBlock") && $root$1.Block.encode(g.addBlock, e.uint32(
      /* id 6, wireType 2 =*/
      50
    ).fork()).ldelim(), g.arrowAddRows != null && Object.hasOwnProperty.call(g, "arrowAddRows") && $root$1.ArrowNamedDataSet.encode(g.arrowAddRows, e.uint32(
      /* id 7, wireType 2 =*/
      58
    ).fork()).ldelim(), g.fragmentId != null && Object.hasOwnProperty.call(g, "fragmentId") && e.uint32(
      /* id 8, wireType 2 =*/
      66
    ).string(g.fragmentId), e;
  }, o.decode = function(g, e, t) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let c = e === void 0 ? g.len : g.pos + e, n = new $root$1.Delta();
    for (; g.pos < c; ) {
      let h = g.uint32();
      if (h === t) break;
      switch (h >>> 3) {
        case 3: {
          n.newElement = $root$1.Element.decode(g, g.uint32());
          break;
        }
        case 6: {
          n.addBlock = $root$1.Block.decode(g, g.uint32());
          break;
        }
        case 5: {
          n.addRows = $root$1.NamedDataSet.decode(g, g.uint32());
          break;
        }
        case 7: {
          n.arrowAddRows = $root$1.ArrowNamedDataSet.decode(g, g.uint32());
          break;
        }
        case 8: {
          n.fragmentId = g.string();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.Delta) return g;
    let e = new $root$1.Delta();
    if (g.newElement != null) {
      if (typeof g.newElement != "object") throw TypeError(".Delta.newElement: object expected");
      e.newElement = $root$1.Element.fromObject(g.newElement);
    }
    if (g.addBlock != null) {
      if (typeof g.addBlock != "object") throw TypeError(".Delta.addBlock: object expected");
      e.addBlock = $root$1.Block.fromObject(g.addBlock);
    }
    if (g.addRows != null) {
      if (typeof g.addRows != "object") throw TypeError(".Delta.addRows: object expected");
      e.addRows = $root$1.NamedDataSet.fromObject(g.addRows);
    }
    if (g.arrowAddRows != null) {
      if (typeof g.arrowAddRows != "object") throw TypeError(".Delta.arrowAddRows: object expected");
      e.arrowAddRows = $root$1.ArrowNamedDataSet.fromObject(g.arrowAddRows);
    }
    return g.fragmentId != null && (e.fragmentId = String(g.fragmentId)), e;
  }, o.toObject = function(g, e) {
    e || (e = {});
    let t = {};
    return e.defaults && (t.fragmentId = ""), g.newElement != null && g.hasOwnProperty("newElement") && (t.newElement = $root$1.Element.toObject(g.newElement, e), e.oneofs && (t.type = "newElement")), g.addRows != null && g.hasOwnProperty("addRows") && (t.addRows = $root$1.NamedDataSet.toObject(g.addRows, e), e.oneofs && (t.type = "addRows")), g.addBlock != null && g.hasOwnProperty("addBlock") && (t.addBlock = $root$1.Block.toObject(g.addBlock, e), e.oneofs && (t.type = "addBlock")), g.arrowAddRows != null && g.hasOwnProperty("arrowAddRows") && (t.arrowAddRows = $root$1.ArrowNamedDataSet.toObject(g.arrowAddRows, e), e.oneofs && (t.type = "arrowAddRows")), g.fragmentId != null && g.hasOwnProperty("fragmentId") && (t.fragmentId = g.fragmentId), t;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/Delta";
  }, o;
})();
const Element$1 = $root$1.Element = (() => {
  function o(A) {
    if (A) for (let g = Object.keys(A), e = 0; e < g.length; ++e) A[g[e]] != null && (this[g[e]] = A[g[e]]);
  }
  o.prototype.heightConfig = null, o.prototype.widthConfig = null, o.prototype.textAlignmentConfig = null, o.prototype.alert = null, o.prototype.arrowDataFrame = null, o.prototype.arrowTable = null, o.prototype.arrowVegaLiteChart = null, o.prototype.audio = null, o.prototype.audioInput = null, o.prototype.balloons = null, o.prototype.bidiComponent = null, o.prototype.bokehChart = null, o.prototype.button = null, o.prototype.buttonGroup = null, o.prototype.downloadButton = null, o.prototype.cameraInput = null, o.prototype.chatInput = null, o.prototype.checkbox = null, o.prototype.colorPicker = null, o.prototype.componentInstance = null, o.prototype.dataFrame = null, o.prototype.table = null, o.prototype.dateInput = null, o.prototype.deckGlJsonChart = null, o.prototype.docString = null, o.prototype.empty = null, o.prototype.exception = null, o.prototype.favicon = null, o.prototype.fileUploader = null, o.prototype.graphvizChart = null, o.prototype.html = null, o.prototype.iframe = null, o.prototype.imgs = null, o.prototype.json = null, o.prototype.linkButton = null, o.prototype.markdown = null, o.prototype.metric = null, o.prototype.multiselect = null, o.prototype.numberInput = null, o.prototype.pageLink = null, o.prototype.plotlyChart = null, o.prototype.progress = null, o.prototype.radio = null, o.prototype.selectbox = null, o.prototype.skeleton = null, o.prototype.slider = null, o.prototype.snow = null, o.prototype.space = null, o.prototype.spinner = null, o.prototype.text = null, o.prototype.textArea = null, o.prototype.textInput = null, o.prototype.timeInput = null, o.prototype.dateTimeInput = null, o.prototype.toast = null, o.prototype.vegaLiteChart = null, o.prototype.video = null, o.prototype.heading = null, o.prototype.code = null;
  let E;
  return Object.defineProperty(o.prototype, "_heightConfig", { get: $util$1.oneOfGetter(E = ["heightConfig"]), set: $util$1.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_widthConfig", { get: $util$1.oneOfGetter(E = ["widthConfig"]), set: $util$1.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_textAlignmentConfig", { get: $util$1.oneOfGetter(E = ["textAlignmentConfig"]), set: $util$1.oneOfSetter(E) }), Object.defineProperty(o.prototype, "type", { get: $util$1.oneOfGetter(E = ["alert", "arrowDataFrame", "arrowTable", "arrowVegaLiteChart", "audio", "audioInput", "balloons", "bidiComponent", "bokehChart", "button", "buttonGroup", "downloadButton", "cameraInput", "chatInput", "checkbox", "colorPicker", "componentInstance", "dataFrame", "table", "dateInput", "deckGlJsonChart", "docString", "empty", "exception", "favicon", "fileUploader", "graphvizChart", "html", "iframe", "imgs", "json", "linkButton", "markdown", "metric", "multiselect", "numberInput", "pageLink", "plotlyChart", "progress", "radio", "selectbox", "skeleton", "slider", "snow", "space", "spinner", "text", "textArea", "textInput", "timeInput", "dateTimeInput", "toast", "vegaLiteChart", "video", "heading", "code"]), set: $util$1.oneOfSetter(E) }), o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, e) {
    return e || (e = $Writer$1.create()), g.text != null && Object.hasOwnProperty.call(g, "text") && $root$1.Text.encode(g.text, e.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim(), g.empty != null && Object.hasOwnProperty.call(g, "empty") && $root$1.Empty.encode(g.empty, e.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), g.dataFrame != null && Object.hasOwnProperty.call(g, "dataFrame") && $root$1.DataFrame.encode(g.dataFrame, e.uint32(
      /* id 3, wireType 2 =*/
      26
    ).fork()).ldelim(), g.progress != null && Object.hasOwnProperty.call(g, "progress") && $root$1.Progress.encode(g.progress, e.uint32(
      /* id 5, wireType 2 =*/
      42
    ).fork()).ldelim(), g.imgs != null && Object.hasOwnProperty.call(g, "imgs") && $root$1.ImageList.encode(g.imgs, e.uint32(
      /* id 6, wireType 2 =*/
      50
    ).fork()).ldelim(), g.docString != null && Object.hasOwnProperty.call(g, "docString") && $root$1.DocString.encode(g.docString, e.uint32(
      /* id 7, wireType 2 =*/
      58
    ).fork()).ldelim(), g.exception != null && Object.hasOwnProperty.call(g, "exception") && $root$1.Exception.encode(g.exception, e.uint32(
      /* id 8, wireType 2 =*/
      66
    ).fork()).ldelim(), g.vegaLiteChart != null && Object.hasOwnProperty.call(g, "vegaLiteChart") && $root$1.VegaLiteChart.encode(g.vegaLiteChart, e.uint32(
      /* id 10, wireType 2 =*/
      82
    ).fork()).ldelim(), g.table != null && Object.hasOwnProperty.call(g, "table") && $root$1.DataFrame.encode(g.table, e.uint32(
      /* id 11, wireType 2 =*/
      90
    ).fork()).ldelim(), g.balloons != null && Object.hasOwnProperty.call(g, "balloons") && $root$1.Balloons.encode(g.balloons, e.uint32(
      /* id 12, wireType 2 =*/
      98
    ).fork()).ldelim(), g.audio != null && Object.hasOwnProperty.call(g, "audio") && $root$1.Audio.encode(g.audio, e.uint32(
      /* id 13, wireType 2 =*/
      106
    ).fork()).ldelim(), g.video != null && Object.hasOwnProperty.call(g, "video") && $root$1.Video.encode(g.video, e.uint32(
      /* id 14, wireType 2 =*/
      114
    ).fork()).ldelim(), g.plotlyChart != null && Object.hasOwnProperty.call(g, "plotlyChart") && $root$1.PlotlyChart.encode(g.plotlyChart, e.uint32(
      /* id 16, wireType 2 =*/
      130
    ).fork()).ldelim(), g.bokehChart != null && Object.hasOwnProperty.call(g, "bokehChart") && $root$1.BokehChart.encode(g.bokehChart, e.uint32(
      /* id 17, wireType 2 =*/
      138
    ).fork()).ldelim(), g.graphvizChart != null && Object.hasOwnProperty.call(g, "graphvizChart") && $root$1.GraphVizChart.encode(g.graphvizChart, e.uint32(
      /* id 18, wireType 2 =*/
      146
    ).fork()).ldelim(), g.button != null && Object.hasOwnProperty.call(g, "button") && $root$1.Button.encode(g.button, e.uint32(
      /* id 19, wireType 2 =*/
      154
    ).fork()).ldelim(), g.checkbox != null && Object.hasOwnProperty.call(g, "checkbox") && $root$1.Checkbox.encode(g.checkbox, e.uint32(
      /* id 20, wireType 2 =*/
      162
    ).fork()).ldelim(), g.slider != null && Object.hasOwnProperty.call(g, "slider") && $root$1.Slider.encode(g.slider, e.uint32(
      /* id 21, wireType 2 =*/
      170
    ).fork()).ldelim(), g.textArea != null && Object.hasOwnProperty.call(g, "textArea") && $root$1.TextArea.encode(g.textArea, e.uint32(
      /* id 22, wireType 2 =*/
      178
    ).fork()).ldelim(), g.radio != null && Object.hasOwnProperty.call(g, "radio") && $root$1.Radio.encode(g.radio, e.uint32(
      /* id 23, wireType 2 =*/
      186
    ).fork()).ldelim(), g.textInput != null && Object.hasOwnProperty.call(g, "textInput") && $root$1.TextInput.encode(g.textInput, e.uint32(
      /* id 24, wireType 2 =*/
      194
    ).fork()).ldelim(), g.selectbox != null && Object.hasOwnProperty.call(g, "selectbox") && $root$1.Selectbox.encode(g.selectbox, e.uint32(
      /* id 25, wireType 2 =*/
      202
    ).fork()).ldelim(), g.timeInput != null && Object.hasOwnProperty.call(g, "timeInput") && $root$1.TimeInput.encode(g.timeInput, e.uint32(
      /* id 26, wireType 2 =*/
      210
    ).fork()).ldelim(), g.dateInput != null && Object.hasOwnProperty.call(g, "dateInput") && $root$1.DateInput.encode(g.dateInput, e.uint32(
      /* id 27, wireType 2 =*/
      218
    ).fork()).ldelim(), g.multiselect != null && Object.hasOwnProperty.call(g, "multiselect") && $root$1.MultiSelect.encode(g.multiselect, e.uint32(
      /* id 28, wireType 2 =*/
      226
    ).fork()).ldelim(), g.markdown != null && Object.hasOwnProperty.call(g, "markdown") && $root$1.Markdown.encode(g.markdown, e.uint32(
      /* id 29, wireType 2 =*/
      234
    ).fork()).ldelim(), g.alert != null && Object.hasOwnProperty.call(g, "alert") && $root$1.Alert.encode(g.alert, e.uint32(
      /* id 30, wireType 2 =*/
      242
    ).fork()).ldelim(), g.json != null && Object.hasOwnProperty.call(g, "json") && $root$1.Json.encode(g.json, e.uint32(
      /* id 31, wireType 2 =*/
      250
    ).fork()).ldelim(), g.numberInput != null && Object.hasOwnProperty.call(g, "numberInput") && $root$1.NumberInput.encode(g.numberInput, e.uint32(
      /* id 32, wireType 2 =*/
      258
    ).fork()).ldelim(), g.fileUploader != null && Object.hasOwnProperty.call(g, "fileUploader") && $root$1.FileUploader.encode(g.fileUploader, e.uint32(
      /* id 33, wireType 2 =*/
      266
    ).fork()).ldelim(), g.deckGlJsonChart != null && Object.hasOwnProperty.call(g, "deckGlJsonChart") && $root$1.DeckGlJsonChart.encode(g.deckGlJsonChart, e.uint32(
      /* id 34, wireType 2 =*/
      274
    ).fork()).ldelim(), g.colorPicker != null && Object.hasOwnProperty.call(g, "colorPicker") && $root$1.ColorPicker.encode(g.colorPicker, e.uint32(
      /* id 35, wireType 2 =*/
      282
    ).fork()).ldelim(), g.favicon != null && Object.hasOwnProperty.call(g, "favicon") && $root$1.Favicon.encode(g.favicon, e.uint32(
      /* id 36, wireType 2 =*/
      290
    ).fork()).ldelim(), g.componentInstance != null && Object.hasOwnProperty.call(g, "componentInstance") && $root$1.ComponentInstance.encode(g.componentInstance, e.uint32(
      /* id 37, wireType 2 =*/
      298
    ).fork()).ldelim(), g.iframe != null && Object.hasOwnProperty.call(g, "iframe") && $root$1.IFrame.encode(g.iframe, e.uint32(
      /* id 38, wireType 2 =*/
      306
    ).fork()).ldelim(), g.arrowTable != null && Object.hasOwnProperty.call(g, "arrowTable") && $root$1.Arrow.encode(g.arrowTable, e.uint32(
      /* id 39, wireType 2 =*/
      314
    ).fork()).ldelim(), g.arrowDataFrame != null && Object.hasOwnProperty.call(g, "arrowDataFrame") && $root$1.Arrow.encode(g.arrowDataFrame, e.uint32(
      /* id 40, wireType 2 =*/
      322
    ).fork()).ldelim(), g.arrowVegaLiteChart != null && Object.hasOwnProperty.call(g, "arrowVegaLiteChart") && $root$1.ArrowVegaLiteChart.encode(g.arrowVegaLiteChart, e.uint32(
      /* id 41, wireType 2 =*/
      330
    ).fork()).ldelim(), g.metric != null && Object.hasOwnProperty.call(g, "metric") && $root$1.Metric.encode(g.metric, e.uint32(
      /* id 42, wireType 2 =*/
      338
    ).fork()).ldelim(), g.downloadButton != null && Object.hasOwnProperty.call(g, "downloadButton") && $root$1.DownloadButton.encode(g.downloadButton, e.uint32(
      /* id 43, wireType 2 =*/
      346
    ).fork()).ldelim(), g.spinner != null && Object.hasOwnProperty.call(g, "spinner") && $root$1.Spinner.encode(g.spinner, e.uint32(
      /* id 44, wireType 2 =*/
      354
    ).fork()).ldelim(), g.cameraInput != null && Object.hasOwnProperty.call(g, "cameraInput") && $root$1.CameraInput.encode(g.cameraInput, e.uint32(
      /* id 45, wireType 2 =*/
      362
    ).fork()).ldelim(), g.snow != null && Object.hasOwnProperty.call(g, "snow") && $root$1.Snow.encode(g.snow, e.uint32(
      /* id 46, wireType 2 =*/
      370
    ).fork()).ldelim(), g.heading != null && Object.hasOwnProperty.call(g, "heading") && $root$1.Heading.encode(g.heading, e.uint32(
      /* id 47, wireType 2 =*/
      378
    ).fork()).ldelim(), g.code != null && Object.hasOwnProperty.call(g, "code") && $root$1.Code.encode(g.code, e.uint32(
      /* id 48, wireType 2 =*/
      386
    ).fork()).ldelim(), g.chatInput != null && Object.hasOwnProperty.call(g, "chatInput") && $root$1.ChatInput.encode(g.chatInput, e.uint32(
      /* id 49, wireType 2 =*/
      394
    ).fork()).ldelim(), g.toast != null && Object.hasOwnProperty.call(g, "toast") && $root$1.Toast.encode(g.toast, e.uint32(
      /* id 50, wireType 2 =*/
      402
    ).fork()).ldelim(), g.linkButton != null && Object.hasOwnProperty.call(g, "linkButton") && $root$1.LinkButton.encode(g.linkButton, e.uint32(
      /* id 51, wireType 2 =*/
      410
    ).fork()).ldelim(), g.skeleton != null && Object.hasOwnProperty.call(g, "skeleton") && $root$1.Skeleton.encode(g.skeleton, e.uint32(
      /* id 52, wireType 2 =*/
      418
    ).fork()).ldelim(), g.pageLink != null && Object.hasOwnProperty.call(g, "pageLink") && $root$1.PageLink.encode(g.pageLink, e.uint32(
      /* id 53, wireType 2 =*/
      426
    ).fork()).ldelim(), g.html != null && Object.hasOwnProperty.call(g, "html") && $root$1.Html.encode(g.html, e.uint32(
      /* id 54, wireType 2 =*/
      434
    ).fork()).ldelim(), g.buttonGroup != null && Object.hasOwnProperty.call(g, "buttonGroup") && $root$1.ButtonGroup.encode(g.buttonGroup, e.uint32(
      /* id 55, wireType 2 =*/
      442
    ).fork()).ldelim(), g.audioInput != null && Object.hasOwnProperty.call(g, "audioInput") && $root$1.AudioInput.encode(g.audioInput, e.uint32(
      /* id 56, wireType 2 =*/
      450
    ).fork()).ldelim(), g.heightConfig != null && Object.hasOwnProperty.call(g, "heightConfig") && $root$1.streamlit.HeightConfig.encode(g.heightConfig, e.uint32(
      /* id 57, wireType 2 =*/
      458
    ).fork()).ldelim(), g.widthConfig != null && Object.hasOwnProperty.call(g, "widthConfig") && $root$1.streamlit.WidthConfig.encode(g.widthConfig, e.uint32(
      /* id 58, wireType 2 =*/
      466
    ).fork()).ldelim(), g.bidiComponent != null && Object.hasOwnProperty.call(g, "bidiComponent") && $root$1.BidiComponent.encode(g.bidiComponent, e.uint32(
      /* id 59, wireType 2 =*/
      474
    ).fork()).ldelim(), g.space != null && Object.hasOwnProperty.call(g, "space") && $root$1.Space.encode(g.space, e.uint32(
      /* id 60, wireType 2 =*/
      482
    ).fork()).ldelim(), g.textAlignmentConfig != null && Object.hasOwnProperty.call(g, "textAlignmentConfig") && $root$1.streamlit.TextAlignmentConfig.encode(g.textAlignmentConfig, e.uint32(
      /* id 61, wireType 2 =*/
      490
    ).fork()).ldelim(), g.dateTimeInput != null && Object.hasOwnProperty.call(g, "dateTimeInput") && $root$1.DateTimeInput.encode(g.dateTimeInput, e.uint32(
      /* id 62, wireType 2 =*/
      498
    ).fork()).ldelim(), e;
  }, o.decode = function(g, e, t) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let c = e === void 0 ? g.len : g.pos + e, n = new $root$1.Element();
    for (; g.pos < c; ) {
      let h = g.uint32();
      if (h === t) break;
      switch (h >>> 3) {
        case 57: {
          n.heightConfig = $root$1.streamlit.HeightConfig.decode(g, g.uint32());
          break;
        }
        case 58: {
          n.widthConfig = $root$1.streamlit.WidthConfig.decode(g, g.uint32());
          break;
        }
        case 61: {
          n.textAlignmentConfig = $root$1.streamlit.TextAlignmentConfig.decode(g, g.uint32());
          break;
        }
        case 30: {
          n.alert = $root$1.Alert.decode(g, g.uint32());
          break;
        }
        case 40: {
          n.arrowDataFrame = $root$1.Arrow.decode(g, g.uint32());
          break;
        }
        case 39: {
          n.arrowTable = $root$1.Arrow.decode(g, g.uint32());
          break;
        }
        case 41: {
          n.arrowVegaLiteChart = $root$1.ArrowVegaLiteChart.decode(g, g.uint32());
          break;
        }
        case 13: {
          n.audio = $root$1.Audio.decode(g, g.uint32());
          break;
        }
        case 56: {
          n.audioInput = $root$1.AudioInput.decode(g, g.uint32());
          break;
        }
        case 12: {
          n.balloons = $root$1.Balloons.decode(g, g.uint32());
          break;
        }
        case 59: {
          n.bidiComponent = $root$1.BidiComponent.decode(g, g.uint32());
          break;
        }
        case 17: {
          n.bokehChart = $root$1.BokehChart.decode(g, g.uint32());
          break;
        }
        case 19: {
          n.button = $root$1.Button.decode(g, g.uint32());
          break;
        }
        case 55: {
          n.buttonGroup = $root$1.ButtonGroup.decode(g, g.uint32());
          break;
        }
        case 43: {
          n.downloadButton = $root$1.DownloadButton.decode(g, g.uint32());
          break;
        }
        case 45: {
          n.cameraInput = $root$1.CameraInput.decode(g, g.uint32());
          break;
        }
        case 49: {
          n.chatInput = $root$1.ChatInput.decode(g, g.uint32());
          break;
        }
        case 20: {
          n.checkbox = $root$1.Checkbox.decode(g, g.uint32());
          break;
        }
        case 35: {
          n.colorPicker = $root$1.ColorPicker.decode(g, g.uint32());
          break;
        }
        case 37: {
          n.componentInstance = $root$1.ComponentInstance.decode(g, g.uint32());
          break;
        }
        case 3: {
          n.dataFrame = $root$1.DataFrame.decode(g, g.uint32());
          break;
        }
        case 11: {
          n.table = $root$1.DataFrame.decode(g, g.uint32());
          break;
        }
        case 27: {
          n.dateInput = $root$1.DateInput.decode(g, g.uint32());
          break;
        }
        case 34: {
          n.deckGlJsonChart = $root$1.DeckGlJsonChart.decode(g, g.uint32());
          break;
        }
        case 7: {
          n.docString = $root$1.DocString.decode(g, g.uint32());
          break;
        }
        case 2: {
          n.empty = $root$1.Empty.decode(g, g.uint32());
          break;
        }
        case 8: {
          n.exception = $root$1.Exception.decode(g, g.uint32());
          break;
        }
        case 36: {
          n.favicon = $root$1.Favicon.decode(g, g.uint32());
          break;
        }
        case 33: {
          n.fileUploader = $root$1.FileUploader.decode(g, g.uint32());
          break;
        }
        case 18: {
          n.graphvizChart = $root$1.GraphVizChart.decode(g, g.uint32());
          break;
        }
        case 54: {
          n.html = $root$1.Html.decode(g, g.uint32());
          break;
        }
        case 38: {
          n.iframe = $root$1.IFrame.decode(g, g.uint32());
          break;
        }
        case 6: {
          n.imgs = $root$1.ImageList.decode(g, g.uint32());
          break;
        }
        case 31: {
          n.json = $root$1.Json.decode(g, g.uint32());
          break;
        }
        case 51: {
          n.linkButton = $root$1.LinkButton.decode(g, g.uint32());
          break;
        }
        case 29: {
          n.markdown = $root$1.Markdown.decode(g, g.uint32());
          break;
        }
        case 42: {
          n.metric = $root$1.Metric.decode(g, g.uint32());
          break;
        }
        case 28: {
          n.multiselect = $root$1.MultiSelect.decode(g, g.uint32());
          break;
        }
        case 32: {
          n.numberInput = $root$1.NumberInput.decode(g, g.uint32());
          break;
        }
        case 53: {
          n.pageLink = $root$1.PageLink.decode(g, g.uint32());
          break;
        }
        case 16: {
          n.plotlyChart = $root$1.PlotlyChart.decode(g, g.uint32());
          break;
        }
        case 5: {
          n.progress = $root$1.Progress.decode(g, g.uint32());
          break;
        }
        case 23: {
          n.radio = $root$1.Radio.decode(g, g.uint32());
          break;
        }
        case 25: {
          n.selectbox = $root$1.Selectbox.decode(g, g.uint32());
          break;
        }
        case 52: {
          n.skeleton = $root$1.Skeleton.decode(g, g.uint32());
          break;
        }
        case 21: {
          n.slider = $root$1.Slider.decode(g, g.uint32());
          break;
        }
        case 46: {
          n.snow = $root$1.Snow.decode(g, g.uint32());
          break;
        }
        case 60: {
          n.space = $root$1.Space.decode(g, g.uint32());
          break;
        }
        case 44: {
          n.spinner = $root$1.Spinner.decode(g, g.uint32());
          break;
        }
        case 1: {
          n.text = $root$1.Text.decode(g, g.uint32());
          break;
        }
        case 22: {
          n.textArea = $root$1.TextArea.decode(g, g.uint32());
          break;
        }
        case 24: {
          n.textInput = $root$1.TextInput.decode(g, g.uint32());
          break;
        }
        case 26: {
          n.timeInput = $root$1.TimeInput.decode(g, g.uint32());
          break;
        }
        case 62: {
          n.dateTimeInput = $root$1.DateTimeInput.decode(g, g.uint32());
          break;
        }
        case 50: {
          n.toast = $root$1.Toast.decode(g, g.uint32());
          break;
        }
        case 10: {
          n.vegaLiteChart = $root$1.VegaLiteChart.decode(g, g.uint32());
          break;
        }
        case 14: {
          n.video = $root$1.Video.decode(g, g.uint32());
          break;
        }
        case 47: {
          n.heading = $root$1.Heading.decode(g, g.uint32());
          break;
        }
        case 48: {
          n.code = $root$1.Code.decode(g, g.uint32());
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.Element) return g;
    let e = new $root$1.Element();
    if (g.heightConfig != null) {
      if (typeof g.heightConfig != "object") throw TypeError(".Element.heightConfig: object expected");
      e.heightConfig = $root$1.streamlit.HeightConfig.fromObject(g.heightConfig);
    }
    if (g.widthConfig != null) {
      if (typeof g.widthConfig != "object") throw TypeError(".Element.widthConfig: object expected");
      e.widthConfig = $root$1.streamlit.WidthConfig.fromObject(g.widthConfig);
    }
    if (g.textAlignmentConfig != null) {
      if (typeof g.textAlignmentConfig != "object") throw TypeError(".Element.textAlignmentConfig: object expected");
      e.textAlignmentConfig = $root$1.streamlit.TextAlignmentConfig.fromObject(g.textAlignmentConfig);
    }
    if (g.alert != null) {
      if (typeof g.alert != "object") throw TypeError(".Element.alert: object expected");
      e.alert = $root$1.Alert.fromObject(g.alert);
    }
    if (g.arrowDataFrame != null) {
      if (typeof g.arrowDataFrame != "object") throw TypeError(".Element.arrowDataFrame: object expected");
      e.arrowDataFrame = $root$1.Arrow.fromObject(g.arrowDataFrame);
    }
    if (g.arrowTable != null) {
      if (typeof g.arrowTable != "object") throw TypeError(".Element.arrowTable: object expected");
      e.arrowTable = $root$1.Arrow.fromObject(g.arrowTable);
    }
    if (g.arrowVegaLiteChart != null) {
      if (typeof g.arrowVegaLiteChart != "object") throw TypeError(".Element.arrowVegaLiteChart: object expected");
      e.arrowVegaLiteChart = $root$1.ArrowVegaLiteChart.fromObject(g.arrowVegaLiteChart);
    }
    if (g.audio != null) {
      if (typeof g.audio != "object") throw TypeError(".Element.audio: object expected");
      e.audio = $root$1.Audio.fromObject(g.audio);
    }
    if (g.audioInput != null) {
      if (typeof g.audioInput != "object") throw TypeError(".Element.audioInput: object expected");
      e.audioInput = $root$1.AudioInput.fromObject(g.audioInput);
    }
    if (g.balloons != null) {
      if (typeof g.balloons != "object") throw TypeError(".Element.balloons: object expected");
      e.balloons = $root$1.Balloons.fromObject(g.balloons);
    }
    if (g.bidiComponent != null) {
      if (typeof g.bidiComponent != "object") throw TypeError(".Element.bidiComponent: object expected");
      e.bidiComponent = $root$1.BidiComponent.fromObject(g.bidiComponent);
    }
    if (g.bokehChart != null) {
      if (typeof g.bokehChart != "object") throw TypeError(".Element.bokehChart: object expected");
      e.bokehChart = $root$1.BokehChart.fromObject(g.bokehChart);
    }
    if (g.button != null) {
      if (typeof g.button != "object") throw TypeError(".Element.button: object expected");
      e.button = $root$1.Button.fromObject(g.button);
    }
    if (g.buttonGroup != null) {
      if (typeof g.buttonGroup != "object") throw TypeError(".Element.buttonGroup: object expected");
      e.buttonGroup = $root$1.ButtonGroup.fromObject(g.buttonGroup);
    }
    if (g.downloadButton != null) {
      if (typeof g.downloadButton != "object") throw TypeError(".Element.downloadButton: object expected");
      e.downloadButton = $root$1.DownloadButton.fromObject(g.downloadButton);
    }
    if (g.cameraInput != null) {
      if (typeof g.cameraInput != "object") throw TypeError(".Element.cameraInput: object expected");
      e.cameraInput = $root$1.CameraInput.fromObject(g.cameraInput);
    }
    if (g.chatInput != null) {
      if (typeof g.chatInput != "object") throw TypeError(".Element.chatInput: object expected");
      e.chatInput = $root$1.ChatInput.fromObject(g.chatInput);
    }
    if (g.checkbox != null) {
      if (typeof g.checkbox != "object") throw TypeError(".Element.checkbox: object expected");
      e.checkbox = $root$1.Checkbox.fromObject(g.checkbox);
    }
    if (g.colorPicker != null) {
      if (typeof g.colorPicker != "object") throw TypeError(".Element.colorPicker: object expected");
      e.colorPicker = $root$1.ColorPicker.fromObject(g.colorPicker);
    }
    if (g.componentInstance != null) {
      if (typeof g.componentInstance != "object") throw TypeError(".Element.componentInstance: object expected");
      e.componentInstance = $root$1.ComponentInstance.fromObject(g.componentInstance);
    }
    if (g.dataFrame != null) {
      if (typeof g.dataFrame != "object") throw TypeError(".Element.dataFrame: object expected");
      e.dataFrame = $root$1.DataFrame.fromObject(g.dataFrame);
    }
    if (g.table != null) {
      if (typeof g.table != "object") throw TypeError(".Element.table: object expected");
      e.table = $root$1.DataFrame.fromObject(g.table);
    }
    if (g.dateInput != null) {
      if (typeof g.dateInput != "object") throw TypeError(".Element.dateInput: object expected");
      e.dateInput = $root$1.DateInput.fromObject(g.dateInput);
    }
    if (g.deckGlJsonChart != null) {
      if (typeof g.deckGlJsonChart != "object") throw TypeError(".Element.deckGlJsonChart: object expected");
      e.deckGlJsonChart = $root$1.DeckGlJsonChart.fromObject(g.deckGlJsonChart);
    }
    if (g.docString != null) {
      if (typeof g.docString != "object") throw TypeError(".Element.docString: object expected");
      e.docString = $root$1.DocString.fromObject(g.docString);
    }
    if (g.empty != null) {
      if (typeof g.empty != "object") throw TypeError(".Element.empty: object expected");
      e.empty = $root$1.Empty.fromObject(g.empty);
    }
    if (g.exception != null) {
      if (typeof g.exception != "object") throw TypeError(".Element.exception: object expected");
      e.exception = $root$1.Exception.fromObject(g.exception);
    }
    if (g.favicon != null) {
      if (typeof g.favicon != "object") throw TypeError(".Element.favicon: object expected");
      e.favicon = $root$1.Favicon.fromObject(g.favicon);
    }
    if (g.fileUploader != null) {
      if (typeof g.fileUploader != "object") throw TypeError(".Element.fileUploader: object expected");
      e.fileUploader = $root$1.FileUploader.fromObject(g.fileUploader);
    }
    if (g.graphvizChart != null) {
      if (typeof g.graphvizChart != "object") throw TypeError(".Element.graphvizChart: object expected");
      e.graphvizChart = $root$1.GraphVizChart.fromObject(g.graphvizChart);
    }
    if (g.html != null) {
      if (typeof g.html != "object") throw TypeError(".Element.html: object expected");
      e.html = $root$1.Html.fromObject(g.html);
    }
    if (g.iframe != null) {
      if (typeof g.iframe != "object") throw TypeError(".Element.iframe: object expected");
      e.iframe = $root$1.IFrame.fromObject(g.iframe);
    }
    if (g.imgs != null) {
      if (typeof g.imgs != "object") throw TypeError(".Element.imgs: object expected");
      e.imgs = $root$1.ImageList.fromObject(g.imgs);
    }
    if (g.json != null) {
      if (typeof g.json != "object") throw TypeError(".Element.json: object expected");
      e.json = $root$1.Json.fromObject(g.json);
    }
    if (g.linkButton != null) {
      if (typeof g.linkButton != "object") throw TypeError(".Element.linkButton: object expected");
      e.linkButton = $root$1.LinkButton.fromObject(g.linkButton);
    }
    if (g.markdown != null) {
      if (typeof g.markdown != "object") throw TypeError(".Element.markdown: object expected");
      e.markdown = $root$1.Markdown.fromObject(g.markdown);
    }
    if (g.metric != null) {
      if (typeof g.metric != "object") throw TypeError(".Element.metric: object expected");
      e.metric = $root$1.Metric.fromObject(g.metric);
    }
    if (g.multiselect != null) {
      if (typeof g.multiselect != "object") throw TypeError(".Element.multiselect: object expected");
      e.multiselect = $root$1.MultiSelect.fromObject(g.multiselect);
    }
    if (g.numberInput != null) {
      if (typeof g.numberInput != "object") throw TypeError(".Element.numberInput: object expected");
      e.numberInput = $root$1.NumberInput.fromObject(g.numberInput);
    }
    if (g.pageLink != null) {
      if (typeof g.pageLink != "object") throw TypeError(".Element.pageLink: object expected");
      e.pageLink = $root$1.PageLink.fromObject(g.pageLink);
    }
    if (g.plotlyChart != null) {
      if (typeof g.plotlyChart != "object") throw TypeError(".Element.plotlyChart: object expected");
      e.plotlyChart = $root$1.PlotlyChart.fromObject(g.plotlyChart);
    }
    if (g.progress != null) {
      if (typeof g.progress != "object") throw TypeError(".Element.progress: object expected");
      e.progress = $root$1.Progress.fromObject(g.progress);
    }
    if (g.radio != null) {
      if (typeof g.radio != "object") throw TypeError(".Element.radio: object expected");
      e.radio = $root$1.Radio.fromObject(g.radio);
    }
    if (g.selectbox != null) {
      if (typeof g.selectbox != "object") throw TypeError(".Element.selectbox: object expected");
      e.selectbox = $root$1.Selectbox.fromObject(g.selectbox);
    }
    if (g.skeleton != null) {
      if (typeof g.skeleton != "object") throw TypeError(".Element.skeleton: object expected");
      e.skeleton = $root$1.Skeleton.fromObject(g.skeleton);
    }
    if (g.slider != null) {
      if (typeof g.slider != "object") throw TypeError(".Element.slider: object expected");
      e.slider = $root$1.Slider.fromObject(g.slider);
    }
    if (g.snow != null) {
      if (typeof g.snow != "object") throw TypeError(".Element.snow: object expected");
      e.snow = $root$1.Snow.fromObject(g.snow);
    }
    if (g.space != null) {
      if (typeof g.space != "object") throw TypeError(".Element.space: object expected");
      e.space = $root$1.Space.fromObject(g.space);
    }
    if (g.spinner != null) {
      if (typeof g.spinner != "object") throw TypeError(".Element.spinner: object expected");
      e.spinner = $root$1.Spinner.fromObject(g.spinner);
    }
    if (g.text != null) {
      if (typeof g.text != "object") throw TypeError(".Element.text: object expected");
      e.text = $root$1.Text.fromObject(g.text);
    }
    if (g.textArea != null) {
      if (typeof g.textArea != "object") throw TypeError(".Element.textArea: object expected");
      e.textArea = $root$1.TextArea.fromObject(g.textArea);
    }
    if (g.textInput != null) {
      if (typeof g.textInput != "object") throw TypeError(".Element.textInput: object expected");
      e.textInput = $root$1.TextInput.fromObject(g.textInput);
    }
    if (g.timeInput != null) {
      if (typeof g.timeInput != "object") throw TypeError(".Element.timeInput: object expected");
      e.timeInput = $root$1.TimeInput.fromObject(g.timeInput);
    }
    if (g.dateTimeInput != null) {
      if (typeof g.dateTimeInput != "object") throw TypeError(".Element.dateTimeInput: object expected");
      e.dateTimeInput = $root$1.DateTimeInput.fromObject(g.dateTimeInput);
    }
    if (g.toast != null) {
      if (typeof g.toast != "object") throw TypeError(".Element.toast: object expected");
      e.toast = $root$1.Toast.fromObject(g.toast);
    }
    if (g.vegaLiteChart != null) {
      if (typeof g.vegaLiteChart != "object") throw TypeError(".Element.vegaLiteChart: object expected");
      e.vegaLiteChart = $root$1.VegaLiteChart.fromObject(g.vegaLiteChart);
    }
    if (g.video != null) {
      if (typeof g.video != "object") throw TypeError(".Element.video: object expected");
      e.video = $root$1.Video.fromObject(g.video);
    }
    if (g.heading != null) {
      if (typeof g.heading != "object") throw TypeError(".Element.heading: object expected");
      e.heading = $root$1.Heading.fromObject(g.heading);
    }
    if (g.code != null) {
      if (typeof g.code != "object") throw TypeError(".Element.code: object expected");
      e.code = $root$1.Code.fromObject(g.code);
    }
    return e;
  }, o.toObject = function(g, e) {
    e || (e = {});
    let t = {};
    return g.text != null && g.hasOwnProperty("text") && (t.text = $root$1.Text.toObject(g.text, e), e.oneofs && (t.type = "text")), g.empty != null && g.hasOwnProperty("empty") && (t.empty = $root$1.Empty.toObject(g.empty, e), e.oneofs && (t.type = "empty")), g.dataFrame != null && g.hasOwnProperty("dataFrame") && (t.dataFrame = $root$1.DataFrame.toObject(g.dataFrame, e), e.oneofs && (t.type = "dataFrame")), g.progress != null && g.hasOwnProperty("progress") && (t.progress = $root$1.Progress.toObject(g.progress, e), e.oneofs && (t.type = "progress")), g.imgs != null && g.hasOwnProperty("imgs") && (t.imgs = $root$1.ImageList.toObject(g.imgs, e), e.oneofs && (t.type = "imgs")), g.docString != null && g.hasOwnProperty("docString") && (t.docString = $root$1.DocString.toObject(g.docString, e), e.oneofs && (t.type = "docString")), g.exception != null && g.hasOwnProperty("exception") && (t.exception = $root$1.Exception.toObject(g.exception, e), e.oneofs && (t.type = "exception")), g.vegaLiteChart != null && g.hasOwnProperty("vegaLiteChart") && (t.vegaLiteChart = $root$1.VegaLiteChart.toObject(g.vegaLiteChart, e), e.oneofs && (t.type = "vegaLiteChart")), g.table != null && g.hasOwnProperty("table") && (t.table = $root$1.DataFrame.toObject(g.table, e), e.oneofs && (t.type = "table")), g.balloons != null && g.hasOwnProperty("balloons") && (t.balloons = $root$1.Balloons.toObject(g.balloons, e), e.oneofs && (t.type = "balloons")), g.audio != null && g.hasOwnProperty("audio") && (t.audio = $root$1.Audio.toObject(g.audio, e), e.oneofs && (t.type = "audio")), g.video != null && g.hasOwnProperty("video") && (t.video = $root$1.Video.toObject(g.video, e), e.oneofs && (t.type = "video")), g.plotlyChart != null && g.hasOwnProperty("plotlyChart") && (t.plotlyChart = $root$1.PlotlyChart.toObject(g.plotlyChart, e), e.oneofs && (t.type = "plotlyChart")), g.bokehChart != null && g.hasOwnProperty("bokehChart") && (t.bokehChart = $root$1.BokehChart.toObject(g.bokehChart, e), e.oneofs && (t.type = "bokehChart")), g.graphvizChart != null && g.hasOwnProperty("graphvizChart") && (t.graphvizChart = $root$1.GraphVizChart.toObject(g.graphvizChart, e), e.oneofs && (t.type = "graphvizChart")), g.button != null && g.hasOwnProperty("button") && (t.button = $root$1.Button.toObject(g.button, e), e.oneofs && (t.type = "button")), g.checkbox != null && g.hasOwnProperty("checkbox") && (t.checkbox = $root$1.Checkbox.toObject(g.checkbox, e), e.oneofs && (t.type = "checkbox")), g.slider != null && g.hasOwnProperty("slider") && (t.slider = $root$1.Slider.toObject(g.slider, e), e.oneofs && (t.type = "slider")), g.textArea != null && g.hasOwnProperty("textArea") && (t.textArea = $root$1.TextArea.toObject(g.textArea, e), e.oneofs && (t.type = "textArea")), g.radio != null && g.hasOwnProperty("radio") && (t.radio = $root$1.Radio.toObject(g.radio, e), e.oneofs && (t.type = "radio")), g.textInput != null && g.hasOwnProperty("textInput") && (t.textInput = $root$1.TextInput.toObject(g.textInput, e), e.oneofs && (t.type = "textInput")), g.selectbox != null && g.hasOwnProperty("selectbox") && (t.selectbox = $root$1.Selectbox.toObject(g.selectbox, e), e.oneofs && (t.type = "selectbox")), g.timeInput != null && g.hasOwnProperty("timeInput") && (t.timeInput = $root$1.TimeInput.toObject(g.timeInput, e), e.oneofs && (t.type = "timeInput")), g.dateInput != null && g.hasOwnProperty("dateInput") && (t.dateInput = $root$1.DateInput.toObject(g.dateInput, e), e.oneofs && (t.type = "dateInput")), g.multiselect != null && g.hasOwnProperty("multiselect") && (t.multiselect = $root$1.MultiSelect.toObject(g.multiselect, e), e.oneofs && (t.type = "multiselect")), g.markdown != null && g.hasOwnProperty("markdown") && (t.markdown = $root$1.Markdown.toObject(g.markdown, e), e.oneofs && (t.type = "markdown")), g.alert != null && g.hasOwnProperty("alert") && (t.alert = $root$1.Alert.toObject(g.alert, e), e.oneofs && (t.type = "alert")), g.json != null && g.hasOwnProperty("json") && (t.json = $root$1.Json.toObject(g.json, e), e.oneofs && (t.type = "json")), g.numberInput != null && g.hasOwnProperty("numberInput") && (t.numberInput = $root$1.NumberInput.toObject(g.numberInput, e), e.oneofs && (t.type = "numberInput")), g.fileUploader != null && g.hasOwnProperty("fileUploader") && (t.fileUploader = $root$1.FileUploader.toObject(g.fileUploader, e), e.oneofs && (t.type = "fileUploader")), g.deckGlJsonChart != null && g.hasOwnProperty("deckGlJsonChart") && (t.deckGlJsonChart = $root$1.DeckGlJsonChart.toObject(g.deckGlJsonChart, e), e.oneofs && (t.type = "deckGlJsonChart")), g.colorPicker != null && g.hasOwnProperty("colorPicker") && (t.colorPicker = $root$1.ColorPicker.toObject(g.colorPicker, e), e.oneofs && (t.type = "colorPicker")), g.favicon != null && g.hasOwnProperty("favicon") && (t.favicon = $root$1.Favicon.toObject(g.favicon, e), e.oneofs && (t.type = "favicon")), g.componentInstance != null && g.hasOwnProperty("componentInstance") && (t.componentInstance = $root$1.ComponentInstance.toObject(g.componentInstance, e), e.oneofs && (t.type = "componentInstance")), g.iframe != null && g.hasOwnProperty("iframe") && (t.iframe = $root$1.IFrame.toObject(g.iframe, e), e.oneofs && (t.type = "iframe")), g.arrowTable != null && g.hasOwnProperty("arrowTable") && (t.arrowTable = $root$1.Arrow.toObject(g.arrowTable, e), e.oneofs && (t.type = "arrowTable")), g.arrowDataFrame != null && g.hasOwnProperty("arrowDataFrame") && (t.arrowDataFrame = $root$1.Arrow.toObject(g.arrowDataFrame, e), e.oneofs && (t.type = "arrowDataFrame")), g.arrowVegaLiteChart != null && g.hasOwnProperty("arrowVegaLiteChart") && (t.arrowVegaLiteChart = $root$1.ArrowVegaLiteChart.toObject(g.arrowVegaLiteChart, e), e.oneofs && (t.type = "arrowVegaLiteChart")), g.metric != null && g.hasOwnProperty("metric") && (t.metric = $root$1.Metric.toObject(g.metric, e), e.oneofs && (t.type = "metric")), g.downloadButton != null && g.hasOwnProperty("downloadButton") && (t.downloadButton = $root$1.DownloadButton.toObject(g.downloadButton, e), e.oneofs && (t.type = "downloadButton")), g.spinner != null && g.hasOwnProperty("spinner") && (t.spinner = $root$1.Spinner.toObject(g.spinner, e), e.oneofs && (t.type = "spinner")), g.cameraInput != null && g.hasOwnProperty("cameraInput") && (t.cameraInput = $root$1.CameraInput.toObject(g.cameraInput, e), e.oneofs && (t.type = "cameraInput")), g.snow != null && g.hasOwnProperty("snow") && (t.snow = $root$1.Snow.toObject(g.snow, e), e.oneofs && (t.type = "snow")), g.heading != null && g.hasOwnProperty("heading") && (t.heading = $root$1.Heading.toObject(g.heading, e), e.oneofs && (t.type = "heading")), g.code != null && g.hasOwnProperty("code") && (t.code = $root$1.Code.toObject(g.code, e), e.oneofs && (t.type = "code")), g.chatInput != null && g.hasOwnProperty("chatInput") && (t.chatInput = $root$1.ChatInput.toObject(g.chatInput, e), e.oneofs && (t.type = "chatInput")), g.toast != null && g.hasOwnProperty("toast") && (t.toast = $root$1.Toast.toObject(g.toast, e), e.oneofs && (t.type = "toast")), g.linkButton != null && g.hasOwnProperty("linkButton") && (t.linkButton = $root$1.LinkButton.toObject(g.linkButton, e), e.oneofs && (t.type = "linkButton")), g.skeleton != null && g.hasOwnProperty("skeleton") && (t.skeleton = $root$1.Skeleton.toObject(g.skeleton, e), e.oneofs && (t.type = "skeleton")), g.pageLink != null && g.hasOwnProperty("pageLink") && (t.pageLink = $root$1.PageLink.toObject(g.pageLink, e), e.oneofs && (t.type = "pageLink")), g.html != null && g.hasOwnProperty("html") && (t.html = $root$1.Html.toObject(g.html, e), e.oneofs && (t.type = "html")), g.buttonGroup != null && g.hasOwnProperty("buttonGroup") && (t.buttonGroup = $root$1.ButtonGroup.toObject(g.buttonGroup, e), e.oneofs && (t.type = "buttonGroup")), g.audioInput != null && g.hasOwnProperty("audioInput") && (t.audioInput = $root$1.AudioInput.toObject(g.audioInput, e), e.oneofs && (t.type = "audioInput")), g.heightConfig != null && g.hasOwnProperty("heightConfig") && (t.heightConfig = $root$1.streamlit.HeightConfig.toObject(g.heightConfig, e), e.oneofs && (t._heightConfig = "heightConfig")), g.widthConfig != null && g.hasOwnProperty("widthConfig") && (t.widthConfig = $root$1.streamlit.WidthConfig.toObject(g.widthConfig, e), e.oneofs && (t._widthConfig = "widthConfig")), g.bidiComponent != null && g.hasOwnProperty("bidiComponent") && (t.bidiComponent = $root$1.BidiComponent.toObject(g.bidiComponent, e), e.oneofs && (t.type = "bidiComponent")), g.space != null && g.hasOwnProperty("space") && (t.space = $root$1.Space.toObject(g.space, e), e.oneofs && (t.type = "space")), g.textAlignmentConfig != null && g.hasOwnProperty("textAlignmentConfig") && (t.textAlignmentConfig = $root$1.streamlit.TextAlignmentConfig.toObject(g.textAlignmentConfig, e), e.oneofs && (t._textAlignmentConfig = "textAlignmentConfig")), g.dateTimeInput != null && g.hasOwnProperty("dateTimeInput") && (t.dateTimeInput = $root$1.DateTimeInput.toObject(g.dateTimeInput, e), e.oneofs && (t.type = "dateTimeInput")), t;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/Element";
  }, o;
})();
$root$1.DownloadButton = (() => {
  function o(A) {
    if (A) for (let g = Object.keys(A), e = 0; e < g.length; ++e) A[g[e]] != null && (this[g[e]] = A[g[e]]);
  }
  o.prototype.id = "", o.prototype.label = "", o.prototype.default = !1, o.prototype.help = "", o.prototype.formId = "", o.prototype.url = "", o.prototype.disabled = !1, o.prototype.useContainerWidth = !1, o.prototype.type = "", o.prototype.icon = "", o.prototype.ignoreRerun = !1, o.prototype.deferredFileId = null, o.prototype.shortcut = "";
  let E;
  return Object.defineProperty(o.prototype, "_deferredFileId", { get: $util$1.oneOfGetter(E = ["deferredFileId"]), set: $util$1.oneOfSetter(E) }), o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, e) {
    return e || (e = $Writer$1.create()), g.id != null && Object.hasOwnProperty.call(g, "id") && e.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.id), g.label != null && Object.hasOwnProperty.call(g, "label") && e.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.label), g.default != null && Object.hasOwnProperty.call(g, "default") && e.uint32(
      /* id 3, wireType 0 =*/
      24
    ).bool(g.default), g.help != null && Object.hasOwnProperty.call(g, "help") && e.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(g.help), g.formId != null && Object.hasOwnProperty.call(g, "formId") && e.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(g.formId), g.url != null && Object.hasOwnProperty.call(g, "url") && e.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(g.url), g.disabled != null && Object.hasOwnProperty.call(g, "disabled") && e.uint32(
      /* id 7, wireType 0 =*/
      56
    ).bool(g.disabled), g.useContainerWidth != null && Object.hasOwnProperty.call(g, "useContainerWidth") && e.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(g.useContainerWidth), g.type != null && Object.hasOwnProperty.call(g, "type") && e.uint32(
      /* id 9, wireType 2 =*/
      74
    ).string(g.type), g.icon != null && Object.hasOwnProperty.call(g, "icon") && e.uint32(
      /* id 10, wireType 2 =*/
      82
    ).string(g.icon), g.ignoreRerun != null && Object.hasOwnProperty.call(g, "ignoreRerun") && e.uint32(
      /* id 11, wireType 0 =*/
      88
    ).bool(g.ignoreRerun), g.deferredFileId != null && Object.hasOwnProperty.call(g, "deferredFileId") && e.uint32(
      /* id 12, wireType 2 =*/
      98
    ).string(g.deferredFileId), g.shortcut != null && Object.hasOwnProperty.call(g, "shortcut") && e.uint32(
      /* id 13, wireType 2 =*/
      106
    ).string(g.shortcut), e;
  }, o.decode = function(g, e, t) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let c = e === void 0 ? g.len : g.pos + e, n = new $root$1.DownloadButton();
    for (; g.pos < c; ) {
      let h = g.uint32();
      if (h === t) break;
      switch (h >>> 3) {
        case 1: {
          n.id = g.string();
          break;
        }
        case 2: {
          n.label = g.string();
          break;
        }
        case 3: {
          n.default = g.bool();
          break;
        }
        case 4: {
          n.help = g.string();
          break;
        }
        case 5: {
          n.formId = g.string();
          break;
        }
        case 6: {
          n.url = g.string();
          break;
        }
        case 7: {
          n.disabled = g.bool();
          break;
        }
        case 8: {
          n.useContainerWidth = g.bool();
          break;
        }
        case 9: {
          n.type = g.string();
          break;
        }
        case 10: {
          n.icon = g.string();
          break;
        }
        case 11: {
          n.ignoreRerun = g.bool();
          break;
        }
        case 12: {
          n.deferredFileId = g.string();
          break;
        }
        case 13: {
          n.shortcut = g.string();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.DownloadButton) return g;
    let e = new $root$1.DownloadButton();
    return g.id != null && (e.id = String(g.id)), g.label != null && (e.label = String(g.label)), g.default != null && (e.default = !!g.default), g.help != null && (e.help = String(g.help)), g.formId != null && (e.formId = String(g.formId)), g.url != null && (e.url = String(g.url)), g.disabled != null && (e.disabled = !!g.disabled), g.useContainerWidth != null && (e.useContainerWidth = !!g.useContainerWidth), g.type != null && (e.type = String(g.type)), g.icon != null && (e.icon = String(g.icon)), g.ignoreRerun != null && (e.ignoreRerun = !!g.ignoreRerun), g.deferredFileId != null && (e.deferredFileId = String(g.deferredFileId)), g.shortcut != null && (e.shortcut = String(g.shortcut)), e;
  }, o.toObject = function(g, e) {
    e || (e = {});
    let t = {};
    return e.defaults && (t.id = "", t.label = "", t.default = !1, t.help = "", t.formId = "", t.url = "", t.disabled = !1, t.useContainerWidth = !1, t.type = "", t.icon = "", t.ignoreRerun = !1, t.shortcut = ""), g.id != null && g.hasOwnProperty("id") && (t.id = g.id), g.label != null && g.hasOwnProperty("label") && (t.label = g.label), g.default != null && g.hasOwnProperty("default") && (t.default = g.default), g.help != null && g.hasOwnProperty("help") && (t.help = g.help), g.formId != null && g.hasOwnProperty("formId") && (t.formId = g.formId), g.url != null && g.hasOwnProperty("url") && (t.url = g.url), g.disabled != null && g.hasOwnProperty("disabled") && (t.disabled = g.disabled), g.useContainerWidth != null && g.hasOwnProperty("useContainerWidth") && (t.useContainerWidth = g.useContainerWidth), g.type != null && g.hasOwnProperty("type") && (t.type = g.type), g.icon != null && g.hasOwnProperty("icon") && (t.icon = g.icon), g.ignoreRerun != null && g.hasOwnProperty("ignoreRerun") && (t.ignoreRerun = g.ignoreRerun), g.deferredFileId != null && g.hasOwnProperty("deferredFileId") && (t.deferredFileId = g.deferredFileId, e.oneofs && (t._deferredFileId = "deferredFileId")), g.shortcut != null && g.hasOwnProperty("shortcut") && (t.shortcut = g.shortcut), t;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/DownloadButton";
  }, o;
})();
$root$1.DocString = (() => {
  function o(E) {
    if (this.members = [], E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.docString = "", o.prototype.type = "", o.prototype.name = "", o.prototype.value = "", o.prototype.members = $util$1.emptyArray, o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    if (g || (g = $Writer$1.create()), A.docString != null && Object.hasOwnProperty.call(A, "docString") && g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(A.docString), A.type != null && Object.hasOwnProperty.call(A, "type") && g.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(A.type), A.name != null && Object.hasOwnProperty.call(A, "name") && g.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(A.name), A.value != null && Object.hasOwnProperty.call(A, "value") && g.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(A.value), A.members != null && A.members.length) for (let e = 0; e < A.members.length; ++e) $root$1.Member.encode(A.members[e], g.uint32(
      /* id 8, wireType 2 =*/
      66
    ).fork()).ldelim();
    return g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader$1 || (A = $Reader$1.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root$1.DocString();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 3: {
          c.docString = A.string();
          break;
        }
        case 4: {
          c.type = A.string();
          break;
        }
        case 6: {
          c.name = A.string();
          break;
        }
        case 7: {
          c.value = A.string();
          break;
        }
        case 8: {
          c.members && c.members.length || (c.members = []), c.members.push($root$1.Member.decode(A, A.uint32()));
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root$1.DocString) return A;
    let g = new $root$1.DocString();
    if (A.docString != null && (g.docString = String(A.docString)), A.type != null && (g.type = String(A.type)), A.name != null && (g.name = String(A.name)), A.value != null && (g.value = String(A.value)), A.members) {
      if (!Array.isArray(A.members)) throw TypeError(".DocString.members: array expected");
      g.members = [];
      for (let e = 0; e < A.members.length; ++e) {
        if (typeof A.members[e] != "object") throw TypeError(".DocString.members: object expected");
        g.members[e] = $root$1.Member.fromObject(A.members[e]);
      }
    }
    return g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    if ((g.arrays || g.defaults) && (e.members = []), g.defaults && (e.docString = "", e.type = "", e.name = "", e.value = ""), A.docString != null && A.hasOwnProperty("docString") && (e.docString = A.docString), A.type != null && A.hasOwnProperty("type") && (e.type = A.type), A.name != null && A.hasOwnProperty("name") && (e.name = A.name), A.value != null && A.hasOwnProperty("value") && (e.value = A.value), A.members && A.members.length) {
      e.members = [];
      for (let t = 0; t < A.members.length; ++t) e.members[t] = $root$1.Member.toObject(A.members[t], g);
    }
    return e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/DocString";
  }, o;
})();
$root$1.Member = (() => {
  function o(A) {
    if (A) for (let g = Object.keys(A), e = 0; e < g.length; ++e) A[g[e]] != null && (this[g[e]] = A[g[e]]);
  }
  o.prototype.name = "", o.prototype.type = "", o.prototype.value = null, o.prototype.docString = null;
  let E;
  return Object.defineProperty(o.prototype, "contents", { get: $util$1.oneOfGetter(E = ["value", "docString"]), set: $util$1.oneOfSetter(E) }), o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, e) {
    return e || (e = $Writer$1.create()), g.name != null && Object.hasOwnProperty.call(g, "name") && e.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.name), g.type != null && Object.hasOwnProperty.call(g, "type") && e.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.type), g.value != null && Object.hasOwnProperty.call(g, "value") && e.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(g.value), g.docString != null && Object.hasOwnProperty.call(g, "docString") && e.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(g.docString), e;
  }, o.decode = function(g, e, t) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let c = e === void 0 ? g.len : g.pos + e, n = new $root$1.Member();
    for (; g.pos < c; ) {
      let h = g.uint32();
      if (h === t) break;
      switch (h >>> 3) {
        case 1: {
          n.name = g.string();
          break;
        }
        case 2: {
          n.type = g.string();
          break;
        }
        case 3: {
          n.value = g.string();
          break;
        }
        case 4: {
          n.docString = g.string();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.Member) return g;
    let e = new $root$1.Member();
    return g.name != null && (e.name = String(g.name)), g.type != null && (e.type = String(g.type)), g.value != null && (e.value = String(g.value)), g.docString != null && (e.docString = String(g.docString)), e;
  }, o.toObject = function(g, e) {
    e || (e = {});
    let t = {};
    return e.defaults && (t.name = "", t.type = ""), g.name != null && g.hasOwnProperty("name") && (t.name = g.name), g.type != null && g.hasOwnProperty("type") && (t.type = g.type), g.value != null && g.hasOwnProperty("value") && (t.value = g.value, e.oneofs && (t.contents = "value")), g.docString != null && g.hasOwnProperty("docString") && (t.docString = g.docString, e.oneofs && (t.contents = "docString")), t;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/Member";
  }, o;
})();
$root$1.Empty = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    return g || (g = $Writer$1.create()), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader$1 || (A = $Reader$1.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root$1.Empty();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    return A instanceof $root$1.Empty ? A : new $root$1.Empty();
  }, o.toObject = function() {
    return {};
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/Empty";
  }, o;
})();
$root$1.Exception = (() => {
  function o(E) {
    if (this.stackTrace = [], E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.type = "", o.prototype.message = "", o.prototype.messageIsMarkdown = !1, o.prototype.stackTrace = $util$1.emptyArray, o.prototype.isWarning = !1, o.prototype.widthConfig = null, o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    if (g || (g = $Writer$1.create()), A.type != null && Object.hasOwnProperty.call(A, "type") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(A.type), A.message != null && Object.hasOwnProperty.call(A, "message") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(A.message), A.stackTrace != null && A.stackTrace.length) for (let e = 0; e < A.stackTrace.length; ++e) g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(A.stackTrace[e]);
    return A.messageIsMarkdown != null && Object.hasOwnProperty.call(A, "messageIsMarkdown") && g.uint32(
      /* id 4, wireType 0 =*/
      32
    ).bool(A.messageIsMarkdown), A.isWarning != null && Object.hasOwnProperty.call(A, "isWarning") && g.uint32(
      /* id 5, wireType 0 =*/
      40
    ).bool(A.isWarning), A.widthConfig != null && Object.hasOwnProperty.call(A, "widthConfig") && $root$1.streamlit.WidthConfig.encode(A.widthConfig, g.uint32(
      /* id 6, wireType 2 =*/
      50
    ).fork()).ldelim(), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader$1 || (A = $Reader$1.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root$1.Exception();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.type = A.string();
          break;
        }
        case 2: {
          c.message = A.string();
          break;
        }
        case 4: {
          c.messageIsMarkdown = A.bool();
          break;
        }
        case 3: {
          c.stackTrace && c.stackTrace.length || (c.stackTrace = []), c.stackTrace.push(A.string());
          break;
        }
        case 5: {
          c.isWarning = A.bool();
          break;
        }
        case 6: {
          c.widthConfig = $root$1.streamlit.WidthConfig.decode(A, A.uint32());
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root$1.Exception) return A;
    let g = new $root$1.Exception();
    if (A.type != null && (g.type = String(A.type)), A.message != null && (g.message = String(A.message)), A.messageIsMarkdown != null && (g.messageIsMarkdown = !!A.messageIsMarkdown), A.stackTrace) {
      if (!Array.isArray(A.stackTrace)) throw TypeError(".Exception.stackTrace: array expected");
      g.stackTrace = [];
      for (let e = 0; e < A.stackTrace.length; ++e) g.stackTrace[e] = String(A.stackTrace[e]);
    }
    if (A.isWarning != null && (g.isWarning = !!A.isWarning), A.widthConfig != null) {
      if (typeof A.widthConfig != "object") throw TypeError(".Exception.widthConfig: object expected");
      g.widthConfig = $root$1.streamlit.WidthConfig.fromObject(A.widthConfig);
    }
    return g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    if ((g.arrays || g.defaults) && (e.stackTrace = []), g.defaults && (e.type = "", e.message = "", e.messageIsMarkdown = !1, e.isWarning = !1, e.widthConfig = null), A.type != null && A.hasOwnProperty("type") && (e.type = A.type), A.message != null && A.hasOwnProperty("message") && (e.message = A.message), A.stackTrace && A.stackTrace.length) {
      e.stackTrace = [];
      for (let t = 0; t < A.stackTrace.length; ++t) e.stackTrace[t] = A.stackTrace[t];
    }
    return A.messageIsMarkdown != null && A.hasOwnProperty("messageIsMarkdown") && (e.messageIsMarkdown = A.messageIsMarkdown), A.isWarning != null && A.hasOwnProperty("isWarning") && (e.isWarning = A.isWarning), A.widthConfig != null && A.hasOwnProperty("widthConfig") && (e.widthConfig = $root$1.streamlit.WidthConfig.toObject(A.widthConfig, g)), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/Exception";
  }, o;
})();
$root$1.Favicon = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.url = "", o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    return g || (g = $Writer$1.create()), A.url != null && Object.hasOwnProperty.call(A, "url") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(A.url), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader$1 || (A = $Reader$1.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root$1.Favicon();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.url = A.string();
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root$1.Favicon) return A;
    let g = new $root$1.Favicon();
    return A.url != null && (g.url = String(A.url)), g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    return g.defaults && (e.url = ""), A.url != null && A.hasOwnProperty("url") && (e.url = A.url), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/Favicon";
  }, o;
})();
$root$1.FileUploader = (() => {
  function o(E) {
    if (this.type = [], E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.id = "", o.prototype.label = "", o.prototype.type = $util$1.emptyArray, o.prototype.maxUploadSizeMb = 0, o.prototype.multipleFiles = !1, o.prototype.help = "", o.prototype.formId = "", o.prototype.disabled = !1, o.prototype.labelVisibility = null, o.prototype.acceptDirectory = !1, o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    if (g || (g = $Writer$1.create()), A.id != null && Object.hasOwnProperty.call(A, "id") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(A.id), A.label != null && Object.hasOwnProperty.call(A, "label") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(A.label), A.type != null && A.type.length) for (let e = 0; e < A.type.length; ++e) g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(A.type[e]);
    return A.maxUploadSizeMb != null && Object.hasOwnProperty.call(A, "maxUploadSizeMb") && g.uint32(
      /* id 4, wireType 0 =*/
      32
    ).int32(A.maxUploadSizeMb), A.multipleFiles != null && Object.hasOwnProperty.call(A, "multipleFiles") && g.uint32(
      /* id 6, wireType 0 =*/
      48
    ).bool(A.multipleFiles), A.help != null && Object.hasOwnProperty.call(A, "help") && g.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(A.help), A.formId != null && Object.hasOwnProperty.call(A, "formId") && g.uint32(
      /* id 8, wireType 2 =*/
      66
    ).string(A.formId), A.disabled != null && Object.hasOwnProperty.call(A, "disabled") && g.uint32(
      /* id 9, wireType 0 =*/
      72
    ).bool(A.disabled), A.labelVisibility != null && Object.hasOwnProperty.call(A, "labelVisibility") && $root$1.LabelVisibilityMessage.encode(A.labelVisibility, g.uint32(
      /* id 10, wireType 2 =*/
      82
    ).fork()).ldelim(), A.acceptDirectory != null && Object.hasOwnProperty.call(A, "acceptDirectory") && g.uint32(
      /* id 11, wireType 0 =*/
      88
    ).bool(A.acceptDirectory), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader$1 || (A = $Reader$1.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root$1.FileUploader();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.id = A.string();
          break;
        }
        case 2: {
          c.label = A.string();
          break;
        }
        case 3: {
          c.type && c.type.length || (c.type = []), c.type.push(A.string());
          break;
        }
        case 4: {
          c.maxUploadSizeMb = A.int32();
          break;
        }
        case 6: {
          c.multipleFiles = A.bool();
          break;
        }
        case 7: {
          c.help = A.string();
          break;
        }
        case 8: {
          c.formId = A.string();
          break;
        }
        case 9: {
          c.disabled = A.bool();
          break;
        }
        case 10: {
          c.labelVisibility = $root$1.LabelVisibilityMessage.decode(A, A.uint32());
          break;
        }
        case 11: {
          c.acceptDirectory = A.bool();
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root$1.FileUploader) return A;
    let g = new $root$1.FileUploader();
    if (A.id != null && (g.id = String(A.id)), A.label != null && (g.label = String(A.label)), A.type) {
      if (!Array.isArray(A.type)) throw TypeError(".FileUploader.type: array expected");
      g.type = [];
      for (let e = 0; e < A.type.length; ++e) g.type[e] = String(A.type[e]);
    }
    if (A.maxUploadSizeMb != null && (g.maxUploadSizeMb = A.maxUploadSizeMb | 0), A.multipleFiles != null && (g.multipleFiles = !!A.multipleFiles), A.help != null && (g.help = String(A.help)), A.formId != null && (g.formId = String(A.formId)), A.disabled != null && (g.disabled = !!A.disabled), A.labelVisibility != null) {
      if (typeof A.labelVisibility != "object") throw TypeError(".FileUploader.labelVisibility: object expected");
      g.labelVisibility = $root$1.LabelVisibilityMessage.fromObject(A.labelVisibility);
    }
    return A.acceptDirectory != null && (g.acceptDirectory = !!A.acceptDirectory), g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    if ((g.arrays || g.defaults) && (e.type = []), g.defaults && (e.id = "", e.label = "", e.maxUploadSizeMb = 0, e.multipleFiles = !1, e.help = "", e.formId = "", e.disabled = !1, e.labelVisibility = null, e.acceptDirectory = !1), A.id != null && A.hasOwnProperty("id") && (e.id = A.id), A.label != null && A.hasOwnProperty("label") && (e.label = A.label), A.type && A.type.length) {
      e.type = [];
      for (let t = 0; t < A.type.length; ++t) e.type[t] = A.type[t];
    }
    return A.maxUploadSizeMb != null && A.hasOwnProperty("maxUploadSizeMb") && (e.maxUploadSizeMb = A.maxUploadSizeMb), A.multipleFiles != null && A.hasOwnProperty("multipleFiles") && (e.multipleFiles = A.multipleFiles), A.help != null && A.hasOwnProperty("help") && (e.help = A.help), A.formId != null && A.hasOwnProperty("formId") && (e.formId = A.formId), A.disabled != null && A.hasOwnProperty("disabled") && (e.disabled = A.disabled), A.labelVisibility != null && A.hasOwnProperty("labelVisibility") && (e.labelVisibility = $root$1.LabelVisibilityMessage.toObject(A.labelVisibility, g)), A.acceptDirectory != null && A.hasOwnProperty("acceptDirectory") && (e.acceptDirectory = A.acceptDirectory), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/FileUploader";
  }, o;
})();
$root$1.GraphVizChart = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.spec = "", o.prototype.useContainerWidth = !1, o.prototype.elementId = "", o.prototype.engine = "", o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    return g || (g = $Writer$1.create()), A.spec != null && Object.hasOwnProperty.call(A, "spec") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(A.spec), A.useContainerWidth != null && Object.hasOwnProperty.call(A, "useContainerWidth") && g.uint32(
      /* id 4, wireType 0 =*/
      32
    ).bool(A.useContainerWidth), A.elementId != null && Object.hasOwnProperty.call(A, "elementId") && g.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(A.elementId), A.engine != null && Object.hasOwnProperty.call(A, "engine") && g.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(A.engine), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader$1 || (A = $Reader$1.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root$1.GraphVizChart();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.spec = A.string();
          break;
        }
        case 4: {
          c.useContainerWidth = A.bool();
          break;
        }
        case 5: {
          c.elementId = A.string();
          break;
        }
        case 6: {
          c.engine = A.string();
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root$1.GraphVizChart) return A;
    let g = new $root$1.GraphVizChart();
    return A.spec != null && (g.spec = String(A.spec)), A.useContainerWidth != null && (g.useContainerWidth = !!A.useContainerWidth), A.elementId != null && (g.elementId = String(A.elementId)), A.engine != null && (g.engine = String(A.engine)), g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    return g.defaults && (e.spec = "", e.useContainerWidth = !1, e.elementId = "", e.engine = ""), A.spec != null && A.hasOwnProperty("spec") && (e.spec = A.spec), A.useContainerWidth != null && A.hasOwnProperty("useContainerWidth") && (e.useContainerWidth = A.useContainerWidth), A.elementId != null && A.hasOwnProperty("elementId") && (e.elementId = A.elementId), A.engine != null && A.hasOwnProperty("engine") && (e.engine = A.engine), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/GraphVizChart";
  }, o;
})();
$root$1.Html = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.body = "", o.prototype.unsafeAllowJavascript = !1, o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    return g || (g = $Writer$1.create()), A.body != null && Object.hasOwnProperty.call(A, "body") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(A.body), A.unsafeAllowJavascript != null && Object.hasOwnProperty.call(A, "unsafeAllowJavascript") && g.uint32(
      /* id 2, wireType 0 =*/
      16
    ).bool(A.unsafeAllowJavascript), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader$1 || (A = $Reader$1.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root$1.Html();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.body = A.string();
          break;
        }
        case 2: {
          c.unsafeAllowJavascript = A.bool();
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root$1.Html) return A;
    let g = new $root$1.Html();
    return A.body != null && (g.body = String(A.body)), A.unsafeAllowJavascript != null && (g.unsafeAllowJavascript = !!A.unsafeAllowJavascript), g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    return g.defaults && (e.body = "", e.unsafeAllowJavascript = !1), A.body != null && A.hasOwnProperty("body") && (e.body = A.body), A.unsafeAllowJavascript != null && A.hasOwnProperty("unsafeAllowJavascript") && (e.unsafeAllowJavascript = A.unsafeAllowJavascript), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/Html";
  }, o;
})();
$root$1.IFrame = (() => {
  function o(A) {
    if (A) for (let g = Object.keys(A), e = 0; e < g.length; ++e) A[g[e]] != null && (this[g[e]] = A[g[e]]);
  }
  o.prototype.src = null, o.prototype.srcdoc = null, o.prototype.width = 0, o.prototype.hasWidth = !1, o.prototype.height = 0, o.prototype.scrolling = !1, o.prototype.tabIndex = null;
  let E;
  return Object.defineProperty(o.prototype, "type", { get: $util$1.oneOfGetter(E = ["src", "srcdoc"]), set: $util$1.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_tabIndex", { get: $util$1.oneOfGetter(E = ["tabIndex"]), set: $util$1.oneOfSetter(E) }), o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, e) {
    return e || (e = $Writer$1.create()), g.src != null && Object.hasOwnProperty.call(g, "src") && e.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.src), g.srcdoc != null && Object.hasOwnProperty.call(g, "srcdoc") && e.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.srcdoc), g.width != null && Object.hasOwnProperty.call(g, "width") && e.uint32(
      /* id 3, wireType 5 =*/
      29
    ).float(g.width), g.hasWidth != null && Object.hasOwnProperty.call(g, "hasWidth") && e.uint32(
      /* id 4, wireType 0 =*/
      32
    ).bool(g.hasWidth), g.height != null && Object.hasOwnProperty.call(g, "height") && e.uint32(
      /* id 5, wireType 5 =*/
      45
    ).float(g.height), g.scrolling != null && Object.hasOwnProperty.call(g, "scrolling") && e.uint32(
      /* id 7, wireType 0 =*/
      56
    ).bool(g.scrolling), g.tabIndex != null && Object.hasOwnProperty.call(g, "tabIndex") && e.uint32(
      /* id 8, wireType 0 =*/
      64
    ).int32(g.tabIndex), e;
  }, o.decode = function(g, e, t) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let c = e === void 0 ? g.len : g.pos + e, n = new $root$1.IFrame();
    for (; g.pos < c; ) {
      let h = g.uint32();
      if (h === t) break;
      switch (h >>> 3) {
        case 1: {
          n.src = g.string();
          break;
        }
        case 2: {
          n.srcdoc = g.string();
          break;
        }
        case 3: {
          n.width = g.float();
          break;
        }
        case 4: {
          n.hasWidth = g.bool();
          break;
        }
        case 5: {
          n.height = g.float();
          break;
        }
        case 7: {
          n.scrolling = g.bool();
          break;
        }
        case 8: {
          n.tabIndex = g.int32();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.IFrame) return g;
    let e = new $root$1.IFrame();
    return g.src != null && (e.src = String(g.src)), g.srcdoc != null && (e.srcdoc = String(g.srcdoc)), g.width != null && (e.width = Number(g.width)), g.hasWidth != null && (e.hasWidth = !!g.hasWidth), g.height != null && (e.height = Number(g.height)), g.scrolling != null && (e.scrolling = !!g.scrolling), g.tabIndex != null && (e.tabIndex = g.tabIndex | 0), e;
  }, o.toObject = function(g, e) {
    e || (e = {});
    let t = {};
    return e.defaults && (t.width = 0, t.hasWidth = !1, t.height = 0, t.scrolling = !1), g.src != null && g.hasOwnProperty("src") && (t.src = g.src, e.oneofs && (t.type = "src")), g.srcdoc != null && g.hasOwnProperty("srcdoc") && (t.srcdoc = g.srcdoc, e.oneofs && (t.type = "srcdoc")), g.width != null && g.hasOwnProperty("width") && (t.width = e.json && !isFinite(g.width) ? String(g.width) : g.width), g.hasWidth != null && g.hasOwnProperty("hasWidth") && (t.hasWidth = g.hasWidth), g.height != null && g.hasOwnProperty("height") && (t.height = e.json && !isFinite(g.height) ? String(g.height) : g.height), g.scrolling != null && g.hasOwnProperty("scrolling") && (t.scrolling = g.scrolling), g.tabIndex != null && g.hasOwnProperty("tabIndex") && (t.tabIndex = g.tabIndex, e.oneofs && (t._tabIndex = "tabIndex")), t;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/IFrame";
  }, o;
})();
$root$1.Image = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.url = "", o.prototype.caption = "", o.prototype.markup = "", o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    return g || (g = $Writer$1.create()), A.caption != null && Object.hasOwnProperty.call(A, "caption") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(A.caption), A.url != null && Object.hasOwnProperty.call(A, "url") && g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(A.url), A.markup != null && Object.hasOwnProperty.call(A, "markup") && g.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(A.markup), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader$1 || (A = $Reader$1.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root$1.Image();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 3: {
          c.url = A.string();
          break;
        }
        case 2: {
          c.caption = A.string();
          break;
        }
        case 4: {
          c.markup = A.string();
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root$1.Image) return A;
    let g = new $root$1.Image();
    return A.url != null && (g.url = String(A.url)), A.caption != null && (g.caption = String(A.caption)), A.markup != null && (g.markup = String(A.markup)), g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    return g.defaults && (e.caption = "", e.url = "", e.markup = ""), A.caption != null && A.hasOwnProperty("caption") && (e.caption = A.caption), A.url != null && A.hasOwnProperty("url") && (e.url = A.url), A.markup != null && A.hasOwnProperty("markup") && (e.markup = A.markup), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/Image";
  }, o;
})();
$root$1.ImageList = (() => {
  function o(E) {
    if (this.imgs = [], E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.imgs = $util$1.emptyArray, o.prototype.width = 0, o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    if (g || (g = $Writer$1.create()), A.imgs != null && A.imgs.length) for (let e = 0; e < A.imgs.length; ++e) $root$1.Image.encode(A.imgs[e], g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim();
    return A.width != null && Object.hasOwnProperty.call(A, "width") && g.uint32(
      /* id 2, wireType 0 =*/
      16
    ).int32(A.width), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader$1 || (A = $Reader$1.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root$1.ImageList();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.imgs && c.imgs.length || (c.imgs = []), c.imgs.push($root$1.Image.decode(A, A.uint32()));
          break;
        }
        case 2: {
          c.width = A.int32();
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root$1.ImageList) return A;
    let g = new $root$1.ImageList();
    if (A.imgs) {
      if (!Array.isArray(A.imgs)) throw TypeError(".ImageList.imgs: array expected");
      g.imgs = [];
      for (let e = 0; e < A.imgs.length; ++e) {
        if (typeof A.imgs[e] != "object") throw TypeError(".ImageList.imgs: object expected");
        g.imgs[e] = $root$1.Image.fromObject(A.imgs[e]);
      }
    }
    return A.width != null && (g.width = A.width | 0), g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    if ((g.arrays || g.defaults) && (e.imgs = []), g.defaults && (e.width = 0), A.imgs && A.imgs.length) {
      e.imgs = [];
      for (let t = 0; t < A.imgs.length; ++t) e.imgs[t] = $root$1.Image.toObject(A.imgs[t], g);
    }
    return A.width != null && A.hasOwnProperty("width") && (e.width = A.width), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/ImageList";
  }, o;
})();
$root$1.Json = (() => {
  function o(A) {
    if (A) for (let g = Object.keys(A), e = 0; e < g.length; ++e) A[g[e]] != null && (this[g[e]] = A[g[e]]);
  }
  o.prototype.body = "", o.prototype.expanded = !1, o.prototype.maxExpandDepth = null;
  let E;
  return Object.defineProperty(o.prototype, "_maxExpandDepth", { get: $util$1.oneOfGetter(E = ["maxExpandDepth"]), set: $util$1.oneOfSetter(E) }), o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, e) {
    return e || (e = $Writer$1.create()), g.body != null && Object.hasOwnProperty.call(g, "body") && e.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.body), g.expanded != null && Object.hasOwnProperty.call(g, "expanded") && e.uint32(
      /* id 2, wireType 0 =*/
      16
    ).bool(g.expanded), g.maxExpandDepth != null && Object.hasOwnProperty.call(g, "maxExpandDepth") && e.uint32(
      /* id 3, wireType 0 =*/
      24
    ).int32(g.maxExpandDepth), e;
  }, o.decode = function(g, e, t) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let c = e === void 0 ? g.len : g.pos + e, n = new $root$1.Json();
    for (; g.pos < c; ) {
      let h = g.uint32();
      if (h === t) break;
      switch (h >>> 3) {
        case 1: {
          n.body = g.string();
          break;
        }
        case 2: {
          n.expanded = g.bool();
          break;
        }
        case 3: {
          n.maxExpandDepth = g.int32();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.Json) return g;
    let e = new $root$1.Json();
    return g.body != null && (e.body = String(g.body)), g.expanded != null && (e.expanded = !!g.expanded), g.maxExpandDepth != null && (e.maxExpandDepth = g.maxExpandDepth | 0), e;
  }, o.toObject = function(g, e) {
    e || (e = {});
    let t = {};
    return e.defaults && (t.body = "", t.expanded = !1), g.body != null && g.hasOwnProperty("body") && (t.body = g.body), g.expanded != null && g.hasOwnProperty("expanded") && (t.expanded = g.expanded), g.maxExpandDepth != null && g.hasOwnProperty("maxExpandDepth") && (t.maxExpandDepth = g.maxExpandDepth, e.oneofs && (t._maxExpandDepth = "maxExpandDepth")), t;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/Json";
  }, o;
})();
$root$1.LinkButton = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.id = "", o.prototype.label = "", o.prototype.help = "", o.prototype.url = "", o.prototype.disabled = !1, o.prototype.useContainerWidth = !1, o.prototype.type = "", o.prototype.icon = "", o.prototype.shortcut = "", o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    return g || (g = $Writer$1.create()), A.id != null && Object.hasOwnProperty.call(A, "id") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(A.id), A.label != null && Object.hasOwnProperty.call(A, "label") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(A.label), A.help != null && Object.hasOwnProperty.call(A, "help") && g.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(A.help), A.url != null && Object.hasOwnProperty.call(A, "url") && g.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(A.url), A.disabled != null && Object.hasOwnProperty.call(A, "disabled") && g.uint32(
      /* id 7, wireType 0 =*/
      56
    ).bool(A.disabled), A.useContainerWidth != null && Object.hasOwnProperty.call(A, "useContainerWidth") && g.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(A.useContainerWidth), A.type != null && Object.hasOwnProperty.call(A, "type") && g.uint32(
      /* id 9, wireType 2 =*/
      74
    ).string(A.type), A.icon != null && Object.hasOwnProperty.call(A, "icon") && g.uint32(
      /* id 10, wireType 2 =*/
      82
    ).string(A.icon), A.shortcut != null && Object.hasOwnProperty.call(A, "shortcut") && g.uint32(
      /* id 11, wireType 2 =*/
      90
    ).string(A.shortcut), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader$1 || (A = $Reader$1.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root$1.LinkButton();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.id = A.string();
          break;
        }
        case 2: {
          c.label = A.string();
          break;
        }
        case 4: {
          c.help = A.string();
          break;
        }
        case 6: {
          c.url = A.string();
          break;
        }
        case 7: {
          c.disabled = A.bool();
          break;
        }
        case 8: {
          c.useContainerWidth = A.bool();
          break;
        }
        case 9: {
          c.type = A.string();
          break;
        }
        case 10: {
          c.icon = A.string();
          break;
        }
        case 11: {
          c.shortcut = A.string();
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root$1.LinkButton) return A;
    let g = new $root$1.LinkButton();
    return A.id != null && (g.id = String(A.id)), A.label != null && (g.label = String(A.label)), A.help != null && (g.help = String(A.help)), A.url != null && (g.url = String(A.url)), A.disabled != null && (g.disabled = !!A.disabled), A.useContainerWidth != null && (g.useContainerWidth = !!A.useContainerWidth), A.type != null && (g.type = String(A.type)), A.icon != null && (g.icon = String(A.icon)), A.shortcut != null && (g.shortcut = String(A.shortcut)), g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    return g.defaults && (e.id = "", e.label = "", e.help = "", e.url = "", e.disabled = !1, e.useContainerWidth = !1, e.type = "", e.icon = "", e.shortcut = ""), A.id != null && A.hasOwnProperty("id") && (e.id = A.id), A.label != null && A.hasOwnProperty("label") && (e.label = A.label), A.help != null && A.hasOwnProperty("help") && (e.help = A.help), A.url != null && A.hasOwnProperty("url") && (e.url = A.url), A.disabled != null && A.hasOwnProperty("disabled") && (e.disabled = A.disabled), A.useContainerWidth != null && A.hasOwnProperty("useContainerWidth") && (e.useContainerWidth = A.useContainerWidth), A.type != null && A.hasOwnProperty("type") && (e.type = A.type), A.icon != null && A.hasOwnProperty("icon") && (e.icon = A.icon), A.shortcut != null && A.hasOwnProperty("shortcut") && (e.shortcut = A.shortcut), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/LinkButton";
  }, o;
})();
const NumberInput$1 = $root$1.NumberInput = (() => {
  function o(A) {
    if (A) for (let g = Object.keys(A), e = 0; e < g.length; ++e) A[g[e]] != null && (this[g[e]] = A[g[e]]);
  }
  o.prototype.id = "", o.prototype.label = "", o.prototype.formId = "", o.prototype.format = "", o.prototype.hasMin = !1, o.prototype.hasMax = !1, o.prototype.dataType = 0, o.prototype.default = null, o.prototype.step = 0, o.prototype.min = 0, o.prototype.max = 0, o.prototype.help = "", o.prototype.value = null, o.prototype.setValue = !1, o.prototype.disabled = !1, o.prototype.labelVisibility = null, o.prototype.placeholder = "", o.prototype.icon = "";
  let E;
  return Object.defineProperty(o.prototype, "_default", { get: $util$1.oneOfGetter(E = ["default"]), set: $util$1.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_value", { get: $util$1.oneOfGetter(E = ["value"]), set: $util$1.oneOfSetter(E) }), o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, e) {
    return e || (e = $Writer$1.create()), g.id != null && Object.hasOwnProperty.call(g, "id") && e.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.id), g.label != null && Object.hasOwnProperty.call(g, "label") && e.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.label), g.formId != null && Object.hasOwnProperty.call(g, "formId") && e.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(g.formId), g.format != null && Object.hasOwnProperty.call(g, "format") && e.uint32(
      /* id 8, wireType 2 =*/
      66
    ).string(g.format), g.hasMin != null && Object.hasOwnProperty.call(g, "hasMin") && e.uint32(
      /* id 11, wireType 0 =*/
      88
    ).bool(g.hasMin), g.hasMax != null && Object.hasOwnProperty.call(g, "hasMax") && e.uint32(
      /* id 12, wireType 0 =*/
      96
    ).bool(g.hasMax), g.dataType != null && Object.hasOwnProperty.call(g, "dataType") && e.uint32(
      /* id 13, wireType 0 =*/
      104
    ).int32(g.dataType), g.default != null && Object.hasOwnProperty.call(g, "default") && e.uint32(
      /* id 14, wireType 1 =*/
      113
    ).double(g.default), g.step != null && Object.hasOwnProperty.call(g, "step") && e.uint32(
      /* id 15, wireType 1 =*/
      121
    ).double(g.step), g.min != null && Object.hasOwnProperty.call(g, "min") && e.uint32(
      /* id 16, wireType 1 =*/
      129
    ).double(g.min), g.max != null && Object.hasOwnProperty.call(g, "max") && e.uint32(
      /* id 17, wireType 1 =*/
      137
    ).double(g.max), g.help != null && Object.hasOwnProperty.call(g, "help") && e.uint32(
      /* id 18, wireType 2 =*/
      146
    ).string(g.help), g.value != null && Object.hasOwnProperty.call(g, "value") && e.uint32(
      /* id 19, wireType 1 =*/
      153
    ).double(g.value), g.setValue != null && Object.hasOwnProperty.call(g, "setValue") && e.uint32(
      /* id 20, wireType 0 =*/
      160
    ).bool(g.setValue), g.disabled != null && Object.hasOwnProperty.call(g, "disabled") && e.uint32(
      /* id 21, wireType 0 =*/
      168
    ).bool(g.disabled), g.labelVisibility != null && Object.hasOwnProperty.call(g, "labelVisibility") && $root$1.LabelVisibilityMessage.encode(g.labelVisibility, e.uint32(
      /* id 22, wireType 2 =*/
      178
    ).fork()).ldelim(), g.placeholder != null && Object.hasOwnProperty.call(g, "placeholder") && e.uint32(
      /* id 23, wireType 2 =*/
      186
    ).string(g.placeholder), g.icon != null && Object.hasOwnProperty.call(g, "icon") && e.uint32(
      /* id 24, wireType 2 =*/
      194
    ).string(g.icon), e;
  }, o.decode = function(g, e, t) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let c = e === void 0 ? g.len : g.pos + e, n = new $root$1.NumberInput();
    for (; g.pos < c; ) {
      let h = g.uint32();
      if (h === t) break;
      switch (h >>> 3) {
        case 1: {
          n.id = g.string();
          break;
        }
        case 2: {
          n.label = g.string();
          break;
        }
        case 3: {
          n.formId = g.string();
          break;
        }
        case 8: {
          n.format = g.string();
          break;
        }
        case 11: {
          n.hasMin = g.bool();
          break;
        }
        case 12: {
          n.hasMax = g.bool();
          break;
        }
        case 13: {
          n.dataType = g.int32();
          break;
        }
        case 14: {
          n.default = g.double();
          break;
        }
        case 15: {
          n.step = g.double();
          break;
        }
        case 16: {
          n.min = g.double();
          break;
        }
        case 17: {
          n.max = g.double();
          break;
        }
        case 18: {
          n.help = g.string();
          break;
        }
        case 19: {
          n.value = g.double();
          break;
        }
        case 20: {
          n.setValue = g.bool();
          break;
        }
        case 21: {
          n.disabled = g.bool();
          break;
        }
        case 22: {
          n.labelVisibility = $root$1.LabelVisibilityMessage.decode(g, g.uint32());
          break;
        }
        case 23: {
          n.placeholder = g.string();
          break;
        }
        case 24: {
          n.icon = g.string();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.NumberInput) return g;
    let e = new $root$1.NumberInput();
    switch (g.id != null && (e.id = String(g.id)), g.label != null && (e.label = String(g.label)), g.formId != null && (e.formId = String(g.formId)), g.format != null && (e.format = String(g.format)), g.hasMin != null && (e.hasMin = !!g.hasMin), g.hasMax != null && (e.hasMax = !!g.hasMax), g.dataType) {
      default:
        if (typeof g.dataType == "number") {
          e.dataType = g.dataType;
          break;
        }
        break;
      case "INT":
      case 0:
        e.dataType = 0;
        break;
      case "FLOAT":
      case 1:
        e.dataType = 1;
        break;
    }
    if (g.default != null && (e.default = Number(g.default)), g.step != null && (e.step = Number(g.step)), g.min != null && (e.min = Number(g.min)), g.max != null && (e.max = Number(g.max)), g.help != null && (e.help = String(g.help)), g.value != null && (e.value = Number(g.value)), g.setValue != null && (e.setValue = !!g.setValue), g.disabled != null && (e.disabled = !!g.disabled), g.labelVisibility != null) {
      if (typeof g.labelVisibility != "object") throw TypeError(".NumberInput.labelVisibility: object expected");
      e.labelVisibility = $root$1.LabelVisibilityMessage.fromObject(g.labelVisibility);
    }
    return g.placeholder != null && (e.placeholder = String(g.placeholder)), g.icon != null && (e.icon = String(g.icon)), e;
  }, o.toObject = function(g, e) {
    e || (e = {});
    let t = {};
    return e.defaults && (t.id = "", t.label = "", t.formId = "", t.format = "", t.hasMin = !1, t.hasMax = !1, t.dataType = e.enums === String ? "INT" : 0, t.step = 0, t.min = 0, t.max = 0, t.help = "", t.setValue = !1, t.disabled = !1, t.labelVisibility = null, t.placeholder = "", t.icon = ""), g.id != null && g.hasOwnProperty("id") && (t.id = g.id), g.label != null && g.hasOwnProperty("label") && (t.label = g.label), g.formId != null && g.hasOwnProperty("formId") && (t.formId = g.formId), g.format != null && g.hasOwnProperty("format") && (t.format = g.format), g.hasMin != null && g.hasOwnProperty("hasMin") && (t.hasMin = g.hasMin), g.hasMax != null && g.hasOwnProperty("hasMax") && (t.hasMax = g.hasMax), g.dataType != null && g.hasOwnProperty("dataType") && (t.dataType = e.enums === String ? $root$1.NumberInput.DataType[g.dataType] === void 0 ? g.dataType : $root$1.NumberInput.DataType[g.dataType] : g.dataType), g.default != null && g.hasOwnProperty("default") && (t.default = e.json && !isFinite(g.default) ? String(g.default) : g.default, e.oneofs && (t._default = "default")), g.step != null && g.hasOwnProperty("step") && (t.step = e.json && !isFinite(g.step) ? String(g.step) : g.step), g.min != null && g.hasOwnProperty("min") && (t.min = e.json && !isFinite(g.min) ? String(g.min) : g.min), g.max != null && g.hasOwnProperty("max") && (t.max = e.json && !isFinite(g.max) ? String(g.max) : g.max), g.help != null && g.hasOwnProperty("help") && (t.help = g.help), g.value != null && g.hasOwnProperty("value") && (t.value = e.json && !isFinite(g.value) ? String(g.value) : g.value, e.oneofs && (t._value = "value")), g.setValue != null && g.hasOwnProperty("setValue") && (t.setValue = g.setValue), g.disabled != null && g.hasOwnProperty("disabled") && (t.disabled = g.disabled), g.labelVisibility != null && g.hasOwnProperty("labelVisibility") && (t.labelVisibility = $root$1.LabelVisibilityMessage.toObject(g.labelVisibility, e)), g.placeholder != null && g.hasOwnProperty("placeholder") && (t.placeholder = g.placeholder), g.icon != null && g.hasOwnProperty("icon") && (t.icon = g.icon), t;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/NumberInput";
  }, o.DataType = (function() {
    const A = {}, g = Object.create(A);
    return g[A[0] = "INT"] = 0, g[A[1] = "FLOAT"] = 1, g;
  })(), o;
})(), Markdown$3 = $root$1.Markdown = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.body = "", o.prototype.allowHtml = !1, o.prototype.isCaption = !1, o.prototype.elementType = 0, o.prototype.help = "", o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    return g || (g = $Writer$1.create()), A.body != null && Object.hasOwnProperty.call(A, "body") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(A.body), A.allowHtml != null && Object.hasOwnProperty.call(A, "allowHtml") && g.uint32(
      /* id 2, wireType 0 =*/
      16
    ).bool(A.allowHtml), A.isCaption != null && Object.hasOwnProperty.call(A, "isCaption") && g.uint32(
      /* id 3, wireType 0 =*/
      24
    ).bool(A.isCaption), A.elementType != null && Object.hasOwnProperty.call(A, "elementType") && g.uint32(
      /* id 4, wireType 0 =*/
      32
    ).int32(A.elementType), A.help != null && Object.hasOwnProperty.call(A, "help") && g.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(A.help), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader$1 || (A = $Reader$1.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root$1.Markdown();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.body = A.string();
          break;
        }
        case 2: {
          c.allowHtml = A.bool();
          break;
        }
        case 3: {
          c.isCaption = A.bool();
          break;
        }
        case 4: {
          c.elementType = A.int32();
          break;
        }
        case 5: {
          c.help = A.string();
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root$1.Markdown) return A;
    let g = new $root$1.Markdown();
    switch (A.body != null && (g.body = String(A.body)), A.allowHtml != null && (g.allowHtml = !!A.allowHtml), A.isCaption != null && (g.isCaption = !!A.isCaption), A.elementType) {
      default:
        if (typeof A.elementType == "number") {
          g.elementType = A.elementType;
          break;
        }
        break;
      case "UNSPECIFIED":
      case 0:
        g.elementType = 0;
        break;
      case "NATIVE":
      case 1:
        g.elementType = 1;
        break;
      case "CAPTION":
      case 2:
        g.elementType = 2;
        break;
      case "CODE":
      case 3:
        g.elementType = 3;
        break;
      case "LATEX":
      case 4:
        g.elementType = 4;
        break;
      case "DIVIDER":
      case 5:
        g.elementType = 5;
        break;
    }
    return A.help != null && (g.help = String(A.help)), g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    return g.defaults && (e.body = "", e.allowHtml = !1, e.isCaption = !1, e.elementType = g.enums === String ? "UNSPECIFIED" : 0, e.help = ""), A.body != null && A.hasOwnProperty("body") && (e.body = A.body), A.allowHtml != null && A.hasOwnProperty("allowHtml") && (e.allowHtml = A.allowHtml), A.isCaption != null && A.hasOwnProperty("isCaption") && (e.isCaption = A.isCaption), A.elementType != null && A.hasOwnProperty("elementType") && (e.elementType = g.enums === String ? $root$1.Markdown.Type[A.elementType] === void 0 ? A.elementType : $root$1.Markdown.Type[A.elementType] : A.elementType), A.help != null && A.hasOwnProperty("help") && (e.help = A.help), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/Markdown";
  }, o.Type = (function() {
    const E = {}, A = Object.create(E);
    return A[E[0] = "UNSPECIFIED"] = 0, A[E[1] = "NATIVE"] = 1, A[E[2] = "CAPTION"] = 2, A[E[3] = "CODE"] = 3, A[E[4] = "LATEX"] = 4, A[E[5] = "DIVIDER"] = 5, A;
  })(), o;
})(), Metric$1 = $root$1.Metric = (() => {
  function o(E) {
    if (this.chartData = [], E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.label = "", o.prototype.body = "", o.prototype.delta = "", o.prototype.direction = 0, o.prototype.color = 0, o.prototype.help = "", o.prototype.labelVisibility = null, o.prototype.showBorder = !1, o.prototype.chartData = $util$1.emptyArray, o.prototype.chartType = 0, o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    if (g || (g = $Writer$1.create()), A.label != null && Object.hasOwnProperty.call(A, "label") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(A.label), A.body != null && Object.hasOwnProperty.call(A, "body") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(A.body), A.delta != null && Object.hasOwnProperty.call(A, "delta") && g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(A.delta), A.direction != null && Object.hasOwnProperty.call(A, "direction") && g.uint32(
      /* id 4, wireType 0 =*/
      32
    ).int32(A.direction), A.color != null && Object.hasOwnProperty.call(A, "color") && g.uint32(
      /* id 5, wireType 0 =*/
      40
    ).int32(A.color), A.help != null && Object.hasOwnProperty.call(A, "help") && g.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(A.help), A.labelVisibility != null && Object.hasOwnProperty.call(A, "labelVisibility") && $root$1.LabelVisibilityMessage.encode(A.labelVisibility, g.uint32(
      /* id 7, wireType 2 =*/
      58
    ).fork()).ldelim(), A.showBorder != null && Object.hasOwnProperty.call(A, "showBorder") && g.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(A.showBorder), A.chartData != null && A.chartData.length) {
      g.uint32(
        /* id 9, wireType 2 =*/
        74
      ).fork();
      for (let e = 0; e < A.chartData.length; ++e) g.double(A.chartData[e]);
      g.ldelim();
    }
    return A.chartType != null && Object.hasOwnProperty.call(A, "chartType") && g.uint32(
      /* id 10, wireType 0 =*/
      80
    ).int32(A.chartType), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader$1 || (A = $Reader$1.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root$1.Metric();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.label = A.string();
          break;
        }
        case 2: {
          c.body = A.string();
          break;
        }
        case 3: {
          c.delta = A.string();
          break;
        }
        case 4: {
          c.direction = A.int32();
          break;
        }
        case 5: {
          c.color = A.int32();
          break;
        }
        case 6: {
          c.help = A.string();
          break;
        }
        case 7: {
          c.labelVisibility = $root$1.LabelVisibilityMessage.decode(A, A.uint32());
          break;
        }
        case 8: {
          c.showBorder = A.bool();
          break;
        }
        case 9: {
          if (c.chartData && c.chartData.length || (c.chartData = []), (n & 7) === 2) {
            let h = A.uint32() + A.pos;
            for (; A.pos < h; ) c.chartData.push(A.double());
          } else c.chartData.push(A.double());
          break;
        }
        case 10: {
          c.chartType = A.int32();
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root$1.Metric) return A;
    let g = new $root$1.Metric();
    switch (A.label != null && (g.label = String(A.label)), A.body != null && (g.body = String(A.body)), A.delta != null && (g.delta = String(A.delta)), A.direction) {
      default:
        if (typeof A.direction == "number") {
          g.direction = A.direction;
          break;
        }
        break;
      case "DOWN":
      case 0:
        g.direction = 0;
        break;
      case "UP":
      case 1:
        g.direction = 1;
        break;
      case "NONE":
      case 2:
        g.direction = 2;
        break;
    }
    switch (A.color) {
      default:
        if (typeof A.color == "number") {
          g.color = A.color;
          break;
        }
        break;
      case "RED":
      case 0:
        g.color = 0;
        break;
      case "GREEN":
      case 1:
        g.color = 1;
        break;
      case "GRAY":
      case 2:
        g.color = 2;
        break;
    }
    if (A.help != null && (g.help = String(A.help)), A.labelVisibility != null) {
      if (typeof A.labelVisibility != "object") throw TypeError(".Metric.labelVisibility: object expected");
      g.labelVisibility = $root$1.LabelVisibilityMessage.fromObject(A.labelVisibility);
    }
    if (A.showBorder != null && (g.showBorder = !!A.showBorder), A.chartData) {
      if (!Array.isArray(A.chartData)) throw TypeError(".Metric.chartData: array expected");
      g.chartData = [];
      for (let e = 0; e < A.chartData.length; ++e) g.chartData[e] = Number(A.chartData[e]);
    }
    switch (A.chartType) {
      default:
        if (typeof A.chartType == "number") {
          g.chartType = A.chartType;
          break;
        }
        break;
      case "LINE":
      case 0:
        g.chartType = 0;
        break;
      case "BAR":
      case 1:
        g.chartType = 1;
        break;
      case "AREA":
      case 2:
        g.chartType = 2;
        break;
    }
    return g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    if ((g.arrays || g.defaults) && (e.chartData = []), g.defaults && (e.label = "", e.body = "", e.delta = "", e.direction = g.enums === String ? "DOWN" : 0, e.color = g.enums === String ? "RED" : 0, e.help = "", e.labelVisibility = null, e.showBorder = !1, e.chartType = g.enums === String ? "LINE" : 0), A.label != null && A.hasOwnProperty("label") && (e.label = A.label), A.body != null && A.hasOwnProperty("body") && (e.body = A.body), A.delta != null && A.hasOwnProperty("delta") && (e.delta = A.delta), A.direction != null && A.hasOwnProperty("direction") && (e.direction = g.enums === String ? $root$1.Metric.MetricDirection[A.direction] === void 0 ? A.direction : $root$1.Metric.MetricDirection[A.direction] : A.direction), A.color != null && A.hasOwnProperty("color") && (e.color = g.enums === String ? $root$1.Metric.MetricColor[A.color] === void 0 ? A.color : $root$1.Metric.MetricColor[A.color] : A.color), A.help != null && A.hasOwnProperty("help") && (e.help = A.help), A.labelVisibility != null && A.hasOwnProperty("labelVisibility") && (e.labelVisibility = $root$1.LabelVisibilityMessage.toObject(A.labelVisibility, g)), A.showBorder != null && A.hasOwnProperty("showBorder") && (e.showBorder = A.showBorder), A.chartData && A.chartData.length) {
      e.chartData = [];
      for (let t = 0; t < A.chartData.length; ++t) e.chartData[t] = g.json && !isFinite(A.chartData[t]) ? String(A.chartData[t]) : A.chartData[t];
    }
    return A.chartType != null && A.hasOwnProperty("chartType") && (e.chartType = g.enums === String ? $root$1.Metric.ChartType[A.chartType] === void 0 ? A.chartType : $root$1.Metric.ChartType[A.chartType] : A.chartType), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/Metric";
  }, o.MetricDirection = (function() {
    const E = {}, A = Object.create(E);
    return A[E[0] = "DOWN"] = 0, A[E[1] = "UP"] = 1, A[E[2] = "NONE"] = 2, A;
  })(), o.MetricColor = (function() {
    const E = {}, A = Object.create(E);
    return A[E[0] = "RED"] = 0, A[E[1] = "GREEN"] = 1, A[E[2] = "GRAY"] = 2, A;
  })(), o.ChartType = (function() {
    const E = {}, A = Object.create(E);
    return A[E[0] = "LINE"] = 0, A[E[1] = "BAR"] = 1, A[E[2] = "AREA"] = 2, A;
  })(), o;
})();
$root$1.MultiSelect = (() => {
  function o(A) {
    if (this.default = [], this.options = [], this.value = [], this.rawValues = [], A) for (let g = Object.keys(A), e = 0; e < g.length; ++e) A[g[e]] != null && (this[g[e]] = A[g[e]]);
  }
  o.prototype.id = "", o.prototype.label = "", o.prototype.default = $util$1.emptyArray, o.prototype.options = $util$1.emptyArray, o.prototype.help = "", o.prototype.formId = "", o.prototype.value = $util$1.emptyArray, o.prototype.rawValues = $util$1.emptyArray, o.prototype.setValue = !1, o.prototype.disabled = !1, o.prototype.labelVisibility = null, o.prototype.maxSelections = 0, o.prototype.placeholder = "", o.prototype.acceptNewOptions = null;
  let E;
  return Object.defineProperty(o.prototype, "_acceptNewOptions", { get: $util$1.oneOfGetter(E = ["acceptNewOptions"]), set: $util$1.oneOfSetter(E) }), o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, e) {
    if (e || (e = $Writer$1.create()), g.id != null && Object.hasOwnProperty.call(g, "id") && e.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.id), g.label != null && Object.hasOwnProperty.call(g, "label") && e.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.label), g.default != null && g.default.length) {
      e.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork();
      for (let t = 0; t < g.default.length; ++t) e.int32(g.default[t]);
      e.ldelim();
    }
    if (g.options != null && g.options.length) for (let t = 0; t < g.options.length; ++t) e.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(g.options[t]);
    if (g.help != null && Object.hasOwnProperty.call(g, "help") && e.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(g.help), g.formId != null && Object.hasOwnProperty.call(g, "formId") && e.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(g.formId), g.value != null && g.value.length) {
      e.uint32(
        /* id 7, wireType 2 =*/
        58
      ).fork();
      for (let t = 0; t < g.value.length; ++t) e.int32(g.value[t]);
      e.ldelim();
    }
    if (g.setValue != null && Object.hasOwnProperty.call(g, "setValue") && e.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(g.setValue), g.disabled != null && Object.hasOwnProperty.call(g, "disabled") && e.uint32(
      /* id 9, wireType 0 =*/
      72
    ).bool(g.disabled), g.labelVisibility != null && Object.hasOwnProperty.call(g, "labelVisibility") && $root$1.LabelVisibilityMessage.encode(g.labelVisibility, e.uint32(
      /* id 10, wireType 2 =*/
      82
    ).fork()).ldelim(), g.maxSelections != null && Object.hasOwnProperty.call(g, "maxSelections") && e.uint32(
      /* id 11, wireType 0 =*/
      88
    ).int32(g.maxSelections), g.placeholder != null && Object.hasOwnProperty.call(g, "placeholder") && e.uint32(
      /* id 12, wireType 2 =*/
      98
    ).string(g.placeholder), g.acceptNewOptions != null && Object.hasOwnProperty.call(g, "acceptNewOptions") && e.uint32(
      /* id 13, wireType 0 =*/
      104
    ).bool(g.acceptNewOptions), g.rawValues != null && g.rawValues.length) for (let t = 0; t < g.rawValues.length; ++t) e.uint32(
      /* id 14, wireType 2 =*/
      114
    ).string(g.rawValues[t]);
    return e;
  }, o.decode = function(g, e, t) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let c = e === void 0 ? g.len : g.pos + e, n = new $root$1.MultiSelect();
    for (; g.pos < c; ) {
      let h = g.uint32();
      if (h === t) break;
      switch (h >>> 3) {
        case 1: {
          n.id = g.string();
          break;
        }
        case 2: {
          n.label = g.string();
          break;
        }
        case 3: {
          if (n.default && n.default.length || (n.default = []), (h & 7) === 2) {
            let d = g.uint32() + g.pos;
            for (; g.pos < d; ) n.default.push(g.int32());
          } else n.default.push(g.int32());
          break;
        }
        case 4: {
          n.options && n.options.length || (n.options = []), n.options.push(g.string());
          break;
        }
        case 5: {
          n.help = g.string();
          break;
        }
        case 6: {
          n.formId = g.string();
          break;
        }
        case 7: {
          if (n.value && n.value.length || (n.value = []), (h & 7) === 2) {
            let d = g.uint32() + g.pos;
            for (; g.pos < d; ) n.value.push(g.int32());
          } else n.value.push(g.int32());
          break;
        }
        case 14: {
          n.rawValues && n.rawValues.length || (n.rawValues = []), n.rawValues.push(g.string());
          break;
        }
        case 8: {
          n.setValue = g.bool();
          break;
        }
        case 9: {
          n.disabled = g.bool();
          break;
        }
        case 10: {
          n.labelVisibility = $root$1.LabelVisibilityMessage.decode(g, g.uint32());
          break;
        }
        case 11: {
          n.maxSelections = g.int32();
          break;
        }
        case 12: {
          n.placeholder = g.string();
          break;
        }
        case 13: {
          n.acceptNewOptions = g.bool();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.MultiSelect) return g;
    let e = new $root$1.MultiSelect();
    if (g.id != null && (e.id = String(g.id)), g.label != null && (e.label = String(g.label)), g.default) {
      if (!Array.isArray(g.default)) throw TypeError(".MultiSelect.default: array expected");
      e.default = [];
      for (let t = 0; t < g.default.length; ++t) e.default[t] = g.default[t] | 0;
    }
    if (g.options) {
      if (!Array.isArray(g.options)) throw TypeError(".MultiSelect.options: array expected");
      e.options = [];
      for (let t = 0; t < g.options.length; ++t) e.options[t] = String(g.options[t]);
    }
    if (g.help != null && (e.help = String(g.help)), g.formId != null && (e.formId = String(g.formId)), g.value) {
      if (!Array.isArray(g.value)) throw TypeError(".MultiSelect.value: array expected");
      e.value = [];
      for (let t = 0; t < g.value.length; ++t) e.value[t] = g.value[t] | 0;
    }
    if (g.rawValues) {
      if (!Array.isArray(g.rawValues)) throw TypeError(".MultiSelect.rawValues: array expected");
      e.rawValues = [];
      for (let t = 0; t < g.rawValues.length; ++t) e.rawValues[t] = String(g.rawValues[t]);
    }
    if (g.setValue != null && (e.setValue = !!g.setValue), g.disabled != null && (e.disabled = !!g.disabled), g.labelVisibility != null) {
      if (typeof g.labelVisibility != "object") throw TypeError(".MultiSelect.labelVisibility: object expected");
      e.labelVisibility = $root$1.LabelVisibilityMessage.fromObject(g.labelVisibility);
    }
    return g.maxSelections != null && (e.maxSelections = g.maxSelections | 0), g.placeholder != null && (e.placeholder = String(g.placeholder)), g.acceptNewOptions != null && (e.acceptNewOptions = !!g.acceptNewOptions), e;
  }, o.toObject = function(g, e) {
    e || (e = {});
    let t = {};
    if ((e.arrays || e.defaults) && (t.default = [], t.options = [], t.value = [], t.rawValues = []), e.defaults && (t.id = "", t.label = "", t.help = "", t.formId = "", t.setValue = !1, t.disabled = !1, t.labelVisibility = null, t.maxSelections = 0, t.placeholder = ""), g.id != null && g.hasOwnProperty("id") && (t.id = g.id), g.label != null && g.hasOwnProperty("label") && (t.label = g.label), g.default && g.default.length) {
      t.default = [];
      for (let c = 0; c < g.default.length; ++c) t.default[c] = g.default[c];
    }
    if (g.options && g.options.length) {
      t.options = [];
      for (let c = 0; c < g.options.length; ++c) t.options[c] = g.options[c];
    }
    if (g.help != null && g.hasOwnProperty("help") && (t.help = g.help), g.formId != null && g.hasOwnProperty("formId") && (t.formId = g.formId), g.value && g.value.length) {
      t.value = [];
      for (let c = 0; c < g.value.length; ++c) t.value[c] = g.value[c];
    }
    if (g.setValue != null && g.hasOwnProperty("setValue") && (t.setValue = g.setValue), g.disabled != null && g.hasOwnProperty("disabled") && (t.disabled = g.disabled), g.labelVisibility != null && g.hasOwnProperty("labelVisibility") && (t.labelVisibility = $root$1.LabelVisibilityMessage.toObject(g.labelVisibility, e)), g.maxSelections != null && g.hasOwnProperty("maxSelections") && (t.maxSelections = g.maxSelections), g.placeholder != null && g.hasOwnProperty("placeholder") && (t.placeholder = g.placeholder), g.acceptNewOptions != null && g.hasOwnProperty("acceptNewOptions") && (t.acceptNewOptions = g.acceptNewOptions, e.oneofs && (t._acceptNewOptions = "acceptNewOptions")), g.rawValues && g.rawValues.length) {
      t.rawValues = [];
      for (let c = 0; c < g.rawValues.length; ++c) t.rawValues[c] = g.rawValues[c];
    }
    return t;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/MultiSelect";
  }, o;
})();
$root$1.PageLink = (() => {
  function o(A) {
    if (A) for (let g = Object.keys(A), e = 0; e < g.length; ++e) A[g[e]] != null && (this[g[e]] = A[g[e]]);
  }
  o.prototype.page = "", o.prototype.label = "", o.prototype.icon = "", o.prototype.pageScriptHash = "", o.prototype.help = "", o.prototype.useContainerWidth = null, o.prototype.disabled = !1, o.prototype.external = !1, o.prototype.queryString = "";
  let E;
  return Object.defineProperty(o.prototype, "_useContainerWidth", { get: $util$1.oneOfGetter(E = ["useContainerWidth"]), set: $util$1.oneOfSetter(E) }), o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, e) {
    return e || (e = $Writer$1.create()), g.page != null && Object.hasOwnProperty.call(g, "page") && e.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.page), g.label != null && Object.hasOwnProperty.call(g, "label") && e.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.label), g.icon != null && Object.hasOwnProperty.call(g, "icon") && e.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(g.icon), g.pageScriptHash != null && Object.hasOwnProperty.call(g, "pageScriptHash") && e.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(g.pageScriptHash), g.help != null && Object.hasOwnProperty.call(g, "help") && e.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(g.help), g.useContainerWidth != null && Object.hasOwnProperty.call(g, "useContainerWidth") && e.uint32(
      /* id 6, wireType 0 =*/
      48
    ).bool(g.useContainerWidth), g.disabled != null && Object.hasOwnProperty.call(g, "disabled") && e.uint32(
      /* id 7, wireType 0 =*/
      56
    ).bool(g.disabled), g.external != null && Object.hasOwnProperty.call(g, "external") && e.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(g.external), g.queryString != null && Object.hasOwnProperty.call(g, "queryString") && e.uint32(
      /* id 9, wireType 2 =*/
      74
    ).string(g.queryString), e;
  }, o.decode = function(g, e, t) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let c = e === void 0 ? g.len : g.pos + e, n = new $root$1.PageLink();
    for (; g.pos < c; ) {
      let h = g.uint32();
      if (h === t) break;
      switch (h >>> 3) {
        case 1: {
          n.page = g.string();
          break;
        }
        case 2: {
          n.label = g.string();
          break;
        }
        case 3: {
          n.icon = g.string();
          break;
        }
        case 4: {
          n.pageScriptHash = g.string();
          break;
        }
        case 5: {
          n.help = g.string();
          break;
        }
        case 6: {
          n.useContainerWidth = g.bool();
          break;
        }
        case 7: {
          n.disabled = g.bool();
          break;
        }
        case 8: {
          n.external = g.bool();
          break;
        }
        case 9: {
          n.queryString = g.string();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.PageLink) return g;
    let e = new $root$1.PageLink();
    return g.page != null && (e.page = String(g.page)), g.label != null && (e.label = String(g.label)), g.icon != null && (e.icon = String(g.icon)), g.pageScriptHash != null && (e.pageScriptHash = String(g.pageScriptHash)), g.help != null && (e.help = String(g.help)), g.useContainerWidth != null && (e.useContainerWidth = !!g.useContainerWidth), g.disabled != null && (e.disabled = !!g.disabled), g.external != null && (e.external = !!g.external), g.queryString != null && (e.queryString = String(g.queryString)), e;
  }, o.toObject = function(g, e) {
    e || (e = {});
    let t = {};
    return e.defaults && (t.page = "", t.label = "", t.icon = "", t.pageScriptHash = "", t.help = "", t.disabled = !1, t.external = !1, t.queryString = ""), g.page != null && g.hasOwnProperty("page") && (t.page = g.page), g.label != null && g.hasOwnProperty("label") && (t.label = g.label), g.icon != null && g.hasOwnProperty("icon") && (t.icon = g.icon), g.pageScriptHash != null && g.hasOwnProperty("pageScriptHash") && (t.pageScriptHash = g.pageScriptHash), g.help != null && g.hasOwnProperty("help") && (t.help = g.help), g.useContainerWidth != null && g.hasOwnProperty("useContainerWidth") && (t.useContainerWidth = g.useContainerWidth, e.oneofs && (t._useContainerWidth = "useContainerWidth")), g.disabled != null && g.hasOwnProperty("disabled") && (t.disabled = g.disabled), g.external != null && g.hasOwnProperty("external") && (t.external = g.external), g.queryString != null && g.hasOwnProperty("queryString") && (t.queryString = g.queryString), t;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/PageLink";
  }, o;
})();
const PlotlyChart$1 = $root$1.PlotlyChart = (() => {
  function o(A) {
    if (this.selectionMode = [], A) for (let g = Object.keys(A), e = 0; e < g.length; ++e) A[g[e]] != null && (this[g[e]] = A[g[e]]);
  }
  o.prototype.useContainerWidth = !1, o.prototype.theme = "", o.prototype.id = "", o.prototype.selectionMode = $util$1.emptyArray, o.prototype.formId = "", o.prototype.spec = "", o.prototype.config = "", o.prototype.url = null, o.prototype.figure = null;
  let E;
  return Object.defineProperty(o.prototype, "chart", { get: $util$1.oneOfGetter(E = ["url", "figure"]), set: $util$1.oneOfSetter(E) }), o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, e) {
    if (e || (e = $Writer$1.create()), g.url != null && Object.hasOwnProperty.call(g, "url") && e.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.url), g.figure != null && Object.hasOwnProperty.call(g, "figure") && $root$1.Figure.encode(g.figure, e.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), g.useContainerWidth != null && Object.hasOwnProperty.call(g, "useContainerWidth") && e.uint32(
      /* id 5, wireType 0 =*/
      40
    ).bool(g.useContainerWidth), g.theme != null && Object.hasOwnProperty.call(g, "theme") && e.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(g.theme), g.id != null && Object.hasOwnProperty.call(g, "id") && e.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(g.id), g.selectionMode != null && g.selectionMode.length) {
      e.uint32(
        /* id 8, wireType 2 =*/
        66
      ).fork();
      for (let t = 0; t < g.selectionMode.length; ++t) e.int32(g.selectionMode[t]);
      e.ldelim();
    }
    return g.formId != null && Object.hasOwnProperty.call(g, "formId") && e.uint32(
      /* id 9, wireType 2 =*/
      74
    ).string(g.formId), g.spec != null && Object.hasOwnProperty.call(g, "spec") && e.uint32(
      /* id 10, wireType 2 =*/
      82
    ).string(g.spec), g.config != null && Object.hasOwnProperty.call(g, "config") && e.uint32(
      /* id 11, wireType 2 =*/
      90
    ).string(g.config), e;
  }, o.decode = function(g, e, t) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let c = e === void 0 ? g.len : g.pos + e, n = new $root$1.PlotlyChart();
    for (; g.pos < c; ) {
      let h = g.uint32();
      if (h === t) break;
      switch (h >>> 3) {
        case 5: {
          n.useContainerWidth = g.bool();
          break;
        }
        case 6: {
          n.theme = g.string();
          break;
        }
        case 7: {
          n.id = g.string();
          break;
        }
        case 8: {
          if (n.selectionMode && n.selectionMode.length || (n.selectionMode = []), (h & 7) === 2) {
            let d = g.uint32() + g.pos;
            for (; g.pos < d; ) n.selectionMode.push(g.int32());
          } else n.selectionMode.push(g.int32());
          break;
        }
        case 9: {
          n.formId = g.string();
          break;
        }
        case 10: {
          n.spec = g.string();
          break;
        }
        case 11: {
          n.config = g.string();
          break;
        }
        case 1: {
          n.url = g.string();
          break;
        }
        case 2: {
          n.figure = $root$1.Figure.decode(g, g.uint32());
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.PlotlyChart) return g;
    let e = new $root$1.PlotlyChart();
    if (g.useContainerWidth != null && (e.useContainerWidth = !!g.useContainerWidth), g.theme != null && (e.theme = String(g.theme)), g.id != null && (e.id = String(g.id)), g.selectionMode) {
      if (!Array.isArray(g.selectionMode)) throw TypeError(".PlotlyChart.selectionMode: array expected");
      e.selectionMode = [];
      for (let t = 0; t < g.selectionMode.length; ++t) switch (g.selectionMode[t]) {
        default:
          if (typeof g.selectionMode[t] == "number") {
            e.selectionMode[t] = g.selectionMode[t];
            break;
          }
        case "POINTS":
        case 0:
          e.selectionMode[t] = 0;
          break;
        case "BOX":
        case 1:
          e.selectionMode[t] = 1;
          break;
        case "LASSO":
        case 2:
          e.selectionMode[t] = 2;
          break;
      }
    }
    if (g.formId != null && (e.formId = String(g.formId)), g.spec != null && (e.spec = String(g.spec)), g.config != null && (e.config = String(g.config)), g.url != null && (e.url = String(g.url)), g.figure != null) {
      if (typeof g.figure != "object") throw TypeError(".PlotlyChart.figure: object expected");
      e.figure = $root$1.Figure.fromObject(g.figure);
    }
    return e;
  }, o.toObject = function(g, e) {
    e || (e = {});
    let t = {};
    if ((e.arrays || e.defaults) && (t.selectionMode = []), e.defaults && (t.useContainerWidth = !1, t.theme = "", t.id = "", t.formId = "", t.spec = "", t.config = ""), g.url != null && g.hasOwnProperty("url") && (t.url = g.url, e.oneofs && (t.chart = "url")), g.figure != null && g.hasOwnProperty("figure") && (t.figure = $root$1.Figure.toObject(g.figure, e), e.oneofs && (t.chart = "figure")), g.useContainerWidth != null && g.hasOwnProperty("useContainerWidth") && (t.useContainerWidth = g.useContainerWidth), g.theme != null && g.hasOwnProperty("theme") && (t.theme = g.theme), g.id != null && g.hasOwnProperty("id") && (t.id = g.id), g.selectionMode && g.selectionMode.length) {
      t.selectionMode = [];
      for (let c = 0; c < g.selectionMode.length; ++c) t.selectionMode[c] = e.enums === String ? $root$1.PlotlyChart.SelectionMode[g.selectionMode[c]] === void 0 ? g.selectionMode[c] : $root$1.PlotlyChart.SelectionMode[g.selectionMode[c]] : g.selectionMode[c];
    }
    return g.formId != null && g.hasOwnProperty("formId") && (t.formId = g.formId), g.spec != null && g.hasOwnProperty("spec") && (t.spec = g.spec), g.config != null && g.hasOwnProperty("config") && (t.config = g.config), t;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/PlotlyChart";
  }, o.SelectionMode = (function() {
    const A = {}, g = Object.create(A);
    return g[A[0] = "POINTS"] = 0, g[A[1] = "BOX"] = 1, g[A[2] = "LASSO"] = 2, g;
  })(), o;
})();
$root$1.Figure = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.spec = "", o.prototype.config = "", o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    return g || (g = $Writer$1.create()), A.spec != null && Object.hasOwnProperty.call(A, "spec") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(A.spec), A.config != null && Object.hasOwnProperty.call(A, "config") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(A.config), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader$1 || (A = $Reader$1.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root$1.Figure();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.spec = A.string();
          break;
        }
        case 2: {
          c.config = A.string();
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root$1.Figure) return A;
    let g = new $root$1.Figure();
    return A.spec != null && (g.spec = String(A.spec)), A.config != null && (g.config = String(A.config)), g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    return g.defaults && (e.spec = "", e.config = ""), A.spec != null && A.hasOwnProperty("spec") && (e.spec = A.spec), A.config != null && A.hasOwnProperty("config") && (e.config = A.config), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/Figure";
  }, o;
})();
$root$1.Progress = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.value = 0, o.prototype.text = "", o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    return g || (g = $Writer$1.create()), A.value != null && Object.hasOwnProperty.call(A, "value") && g.uint32(
      /* id 1, wireType 0 =*/
      8
    ).uint32(A.value), A.text != null && Object.hasOwnProperty.call(A, "text") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(A.text), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader$1 || (A = $Reader$1.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root$1.Progress();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.value = A.uint32();
          break;
        }
        case 2: {
          c.text = A.string();
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root$1.Progress) return A;
    let g = new $root$1.Progress();
    return A.value != null && (g.value = A.value >>> 0), A.text != null && (g.text = String(A.text)), g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    return g.defaults && (e.value = 0, e.text = ""), A.value != null && A.hasOwnProperty("value") && (e.value = A.value), A.text != null && A.hasOwnProperty("text") && (e.text = A.text), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/Progress";
  }, o;
})();
$root$1.Snow = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.show = !1, o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    return g || (g = $Writer$1.create()), A.show != null && Object.hasOwnProperty.call(A, "show") && g.uint32(
      /* id 1, wireType 0 =*/
      8
    ).bool(A.show), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader$1 || (A = $Reader$1.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root$1.Snow();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.show = A.bool();
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root$1.Snow) return A;
    let g = new $root$1.Snow();
    return A.show != null && (g.show = !!A.show), g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    return g.defaults && (e.show = !1), A.show != null && A.hasOwnProperty("show") && (e.show = A.show), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/Snow";
  }, o;
})();
$root$1.Spinner = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.text = "", o.prototype.cache = !1, o.prototype.showTime = !1, o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    return g || (g = $Writer$1.create()), A.text != null && Object.hasOwnProperty.call(A, "text") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(A.text), A.cache != null && Object.hasOwnProperty.call(A, "cache") && g.uint32(
      /* id 2, wireType 0 =*/
      16
    ).bool(A.cache), A.showTime != null && Object.hasOwnProperty.call(A, "showTime") && g.uint32(
      /* id 3, wireType 0 =*/
      24
    ).bool(A.showTime), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader$1 || (A = $Reader$1.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root$1.Spinner();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.text = A.string();
          break;
        }
        case 2: {
          c.cache = A.bool();
          break;
        }
        case 3: {
          c.showTime = A.bool();
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root$1.Spinner) return A;
    let g = new $root$1.Spinner();
    return A.text != null && (g.text = String(A.text)), A.cache != null && (g.cache = !!A.cache), A.showTime != null && (g.showTime = !!A.showTime), g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    return g.defaults && (e.text = "", e.cache = !1, e.showTime = !1), A.text != null && A.hasOwnProperty("text") && (e.text = A.text), A.cache != null && A.hasOwnProperty("cache") && (e.cache = A.cache), A.showTime != null && A.hasOwnProperty("showTime") && (e.showTime = A.showTime), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/Spinner";
  }, o;
})();
$root$1.Radio = (() => {
  function o(A) {
    if (this.options = [], this.captions = [], A) for (let g = Object.keys(A), e = 0; e < g.length; ++e) A[g[e]] != null && (this[g[e]] = A[g[e]]);
  }
  o.prototype.id = "", o.prototype.label = "", o.prototype.default = null, o.prototype.options = $util$1.emptyArray, o.prototype.help = "", o.prototype.formId = "", o.prototype.value = null, o.prototype.setValue = !1, o.prototype.disabled = !1, o.prototype.horizontal = !1, o.prototype.labelVisibility = null, o.prototype.captions = $util$1.emptyArray;
  let E;
  return Object.defineProperty(o.prototype, "_default", { get: $util$1.oneOfGetter(E = ["default"]), set: $util$1.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_value", { get: $util$1.oneOfGetter(E = ["value"]), set: $util$1.oneOfSetter(E) }), o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, e) {
    if (e || (e = $Writer$1.create()), g.id != null && Object.hasOwnProperty.call(g, "id") && e.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.id), g.label != null && Object.hasOwnProperty.call(g, "label") && e.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.label), g.default != null && Object.hasOwnProperty.call(g, "default") && e.uint32(
      /* id 3, wireType 0 =*/
      24
    ).int32(g.default), g.options != null && g.options.length) for (let t = 0; t < g.options.length; ++t) e.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(g.options[t]);
    if (g.help != null && Object.hasOwnProperty.call(g, "help") && e.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(g.help), g.formId != null && Object.hasOwnProperty.call(g, "formId") && e.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(g.formId), g.value != null && Object.hasOwnProperty.call(g, "value") && e.uint32(
      /* id 7, wireType 0 =*/
      56
    ).int32(g.value), g.setValue != null && Object.hasOwnProperty.call(g, "setValue") && e.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(g.setValue), g.disabled != null && Object.hasOwnProperty.call(g, "disabled") && e.uint32(
      /* id 9, wireType 0 =*/
      72
    ).bool(g.disabled), g.horizontal != null && Object.hasOwnProperty.call(g, "horizontal") && e.uint32(
      /* id 10, wireType 0 =*/
      80
    ).bool(g.horizontal), g.labelVisibility != null && Object.hasOwnProperty.call(g, "labelVisibility") && $root$1.LabelVisibilityMessage.encode(g.labelVisibility, e.uint32(
      /* id 11, wireType 2 =*/
      90
    ).fork()).ldelim(), g.captions != null && g.captions.length) for (let t = 0; t < g.captions.length; ++t) e.uint32(
      /* id 12, wireType 2 =*/
      98
    ).string(g.captions[t]);
    return e;
  }, o.decode = function(g, e, t) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let c = e === void 0 ? g.len : g.pos + e, n = new $root$1.Radio();
    for (; g.pos < c; ) {
      let h = g.uint32();
      if (h === t) break;
      switch (h >>> 3) {
        case 1: {
          n.id = g.string();
          break;
        }
        case 2: {
          n.label = g.string();
          break;
        }
        case 3: {
          n.default = g.int32();
          break;
        }
        case 4: {
          n.options && n.options.length || (n.options = []), n.options.push(g.string());
          break;
        }
        case 5: {
          n.help = g.string();
          break;
        }
        case 6: {
          n.formId = g.string();
          break;
        }
        case 7: {
          n.value = g.int32();
          break;
        }
        case 8: {
          n.setValue = g.bool();
          break;
        }
        case 9: {
          n.disabled = g.bool();
          break;
        }
        case 10: {
          n.horizontal = g.bool();
          break;
        }
        case 11: {
          n.labelVisibility = $root$1.LabelVisibilityMessage.decode(g, g.uint32());
          break;
        }
        case 12: {
          n.captions && n.captions.length || (n.captions = []), n.captions.push(g.string());
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.Radio) return g;
    let e = new $root$1.Radio();
    if (g.id != null && (e.id = String(g.id)), g.label != null && (e.label = String(g.label)), g.default != null && (e.default = g.default | 0), g.options) {
      if (!Array.isArray(g.options)) throw TypeError(".Radio.options: array expected");
      e.options = [];
      for (let t = 0; t < g.options.length; ++t) e.options[t] = String(g.options[t]);
    }
    if (g.help != null && (e.help = String(g.help)), g.formId != null && (e.formId = String(g.formId)), g.value != null && (e.value = g.value | 0), g.setValue != null && (e.setValue = !!g.setValue), g.disabled != null && (e.disabled = !!g.disabled), g.horizontal != null && (e.horizontal = !!g.horizontal), g.labelVisibility != null) {
      if (typeof g.labelVisibility != "object") throw TypeError(".Radio.labelVisibility: object expected");
      e.labelVisibility = $root$1.LabelVisibilityMessage.fromObject(g.labelVisibility);
    }
    if (g.captions) {
      if (!Array.isArray(g.captions)) throw TypeError(".Radio.captions: array expected");
      e.captions = [];
      for (let t = 0; t < g.captions.length; ++t) e.captions[t] = String(g.captions[t]);
    }
    return e;
  }, o.toObject = function(g, e) {
    e || (e = {});
    let t = {};
    if ((e.arrays || e.defaults) && (t.options = [], t.captions = []), e.defaults && (t.id = "", t.label = "", t.help = "", t.formId = "", t.setValue = !1, t.disabled = !1, t.horizontal = !1, t.labelVisibility = null), g.id != null && g.hasOwnProperty("id") && (t.id = g.id), g.label != null && g.hasOwnProperty("label") && (t.label = g.label), g.default != null && g.hasOwnProperty("default") && (t.default = g.default, e.oneofs && (t._default = "default")), g.options && g.options.length) {
      t.options = [];
      for (let c = 0; c < g.options.length; ++c) t.options[c] = g.options[c];
    }
    if (g.help != null && g.hasOwnProperty("help") && (t.help = g.help), g.formId != null && g.hasOwnProperty("formId") && (t.formId = g.formId), g.value != null && g.hasOwnProperty("value") && (t.value = g.value, e.oneofs && (t._value = "value")), g.setValue != null && g.hasOwnProperty("setValue") && (t.setValue = g.setValue), g.disabled != null && g.hasOwnProperty("disabled") && (t.disabled = g.disabled), g.horizontal != null && g.hasOwnProperty("horizontal") && (t.horizontal = g.horizontal), g.labelVisibility != null && g.hasOwnProperty("labelVisibility") && (t.labelVisibility = $root$1.LabelVisibilityMessage.toObject(g.labelVisibility, e)), g.captions && g.captions.length) {
      t.captions = [];
      for (let c = 0; c < g.captions.length; ++c) t.captions[c] = g.captions[c];
    }
    return t;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/Radio";
  }, o;
})();
$root$1.Selectbox = (() => {
  function o(A) {
    if (this.options = [], A) for (let g = Object.keys(A), e = 0; e < g.length; ++e) A[g[e]] != null && (this[g[e]] = A[g[e]]);
  }
  o.prototype.id = "", o.prototype.label = "", o.prototype.default = null, o.prototype.options = $util$1.emptyArray, o.prototype.help = "", o.prototype.formId = "", o.prototype.value = null, o.prototype.rawValue = null, o.prototype.setValue = !1, o.prototype.disabled = !1, o.prototype.labelVisibility = null, o.prototype.placeholder = "", o.prototype.acceptNewOptions = null;
  let E;
  return Object.defineProperty(o.prototype, "_default", { get: $util$1.oneOfGetter(E = ["default"]), set: $util$1.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_value", { get: $util$1.oneOfGetter(E = ["value"]), set: $util$1.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_rawValue", { get: $util$1.oneOfGetter(E = ["rawValue"]), set: $util$1.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_acceptNewOptions", { get: $util$1.oneOfGetter(E = ["acceptNewOptions"]), set: $util$1.oneOfSetter(E) }), o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, e) {
    if (e || (e = $Writer$1.create()), g.id != null && Object.hasOwnProperty.call(g, "id") && e.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.id), g.label != null && Object.hasOwnProperty.call(g, "label") && e.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.label), g.default != null && Object.hasOwnProperty.call(g, "default") && e.uint32(
      /* id 3, wireType 0 =*/
      24
    ).int32(g.default), g.options != null && g.options.length) for (let t = 0; t < g.options.length; ++t) e.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(g.options[t]);
    return g.help != null && Object.hasOwnProperty.call(g, "help") && e.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(g.help), g.formId != null && Object.hasOwnProperty.call(g, "formId") && e.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(g.formId), g.value != null && Object.hasOwnProperty.call(g, "value") && e.uint32(
      /* id 7, wireType 0 =*/
      56
    ).int32(g.value), g.setValue != null && Object.hasOwnProperty.call(g, "setValue") && e.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(g.setValue), g.disabled != null && Object.hasOwnProperty.call(g, "disabled") && e.uint32(
      /* id 9, wireType 0 =*/
      72
    ).bool(g.disabled), g.labelVisibility != null && Object.hasOwnProperty.call(g, "labelVisibility") && $root$1.LabelVisibilityMessage.encode(g.labelVisibility, e.uint32(
      /* id 10, wireType 2 =*/
      82
    ).fork()).ldelim(), g.placeholder != null && Object.hasOwnProperty.call(g, "placeholder") && e.uint32(
      /* id 11, wireType 2 =*/
      90
    ).string(g.placeholder), g.acceptNewOptions != null && Object.hasOwnProperty.call(g, "acceptNewOptions") && e.uint32(
      /* id 12, wireType 0 =*/
      96
    ).bool(g.acceptNewOptions), g.rawValue != null && Object.hasOwnProperty.call(g, "rawValue") && e.uint32(
      /* id 13, wireType 2 =*/
      106
    ).string(g.rawValue), e;
  }, o.decode = function(g, e, t) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let c = e === void 0 ? g.len : g.pos + e, n = new $root$1.Selectbox();
    for (; g.pos < c; ) {
      let h = g.uint32();
      if (h === t) break;
      switch (h >>> 3) {
        case 1: {
          n.id = g.string();
          break;
        }
        case 2: {
          n.label = g.string();
          break;
        }
        case 3: {
          n.default = g.int32();
          break;
        }
        case 4: {
          n.options && n.options.length || (n.options = []), n.options.push(g.string());
          break;
        }
        case 5: {
          n.help = g.string();
          break;
        }
        case 6: {
          n.formId = g.string();
          break;
        }
        case 7: {
          n.value = g.int32();
          break;
        }
        case 13: {
          n.rawValue = g.string();
          break;
        }
        case 8: {
          n.setValue = g.bool();
          break;
        }
        case 9: {
          n.disabled = g.bool();
          break;
        }
        case 10: {
          n.labelVisibility = $root$1.LabelVisibilityMessage.decode(g, g.uint32());
          break;
        }
        case 11: {
          n.placeholder = g.string();
          break;
        }
        case 12: {
          n.acceptNewOptions = g.bool();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.Selectbox) return g;
    let e = new $root$1.Selectbox();
    if (g.id != null && (e.id = String(g.id)), g.label != null && (e.label = String(g.label)), g.default != null && (e.default = g.default | 0), g.options) {
      if (!Array.isArray(g.options)) throw TypeError(".Selectbox.options: array expected");
      e.options = [];
      for (let t = 0; t < g.options.length; ++t) e.options[t] = String(g.options[t]);
    }
    if (g.help != null && (e.help = String(g.help)), g.formId != null && (e.formId = String(g.formId)), g.value != null && (e.value = g.value | 0), g.rawValue != null && (e.rawValue = String(g.rawValue)), g.setValue != null && (e.setValue = !!g.setValue), g.disabled != null && (e.disabled = !!g.disabled), g.labelVisibility != null) {
      if (typeof g.labelVisibility != "object") throw TypeError(".Selectbox.labelVisibility: object expected");
      e.labelVisibility = $root$1.LabelVisibilityMessage.fromObject(g.labelVisibility);
    }
    return g.placeholder != null && (e.placeholder = String(g.placeholder)), g.acceptNewOptions != null && (e.acceptNewOptions = !!g.acceptNewOptions), e;
  }, o.toObject = function(g, e) {
    e || (e = {});
    let t = {};
    if ((e.arrays || e.defaults) && (t.options = []), e.defaults && (t.id = "", t.label = "", t.help = "", t.formId = "", t.setValue = !1, t.disabled = !1, t.labelVisibility = null, t.placeholder = ""), g.id != null && g.hasOwnProperty("id") && (t.id = g.id), g.label != null && g.hasOwnProperty("label") && (t.label = g.label), g.default != null && g.hasOwnProperty("default") && (t.default = g.default, e.oneofs && (t._default = "default")), g.options && g.options.length) {
      t.options = [];
      for (let c = 0; c < g.options.length; ++c) t.options[c] = g.options[c];
    }
    return g.help != null && g.hasOwnProperty("help") && (t.help = g.help), g.formId != null && g.hasOwnProperty("formId") && (t.formId = g.formId), g.value != null && g.hasOwnProperty("value") && (t.value = g.value, e.oneofs && (t._value = "value")), g.setValue != null && g.hasOwnProperty("setValue") && (t.setValue = g.setValue), g.disabled != null && g.hasOwnProperty("disabled") && (t.disabled = g.disabled), g.labelVisibility != null && g.hasOwnProperty("labelVisibility") && (t.labelVisibility = $root$1.LabelVisibilityMessage.toObject(g.labelVisibility, e)), g.placeholder != null && g.hasOwnProperty("placeholder") && (t.placeholder = g.placeholder), g.acceptNewOptions != null && g.hasOwnProperty("acceptNewOptions") && (t.acceptNewOptions = g.acceptNewOptions, e.oneofs && (t._acceptNewOptions = "acceptNewOptions")), g.rawValue != null && g.hasOwnProperty("rawValue") && (t.rawValue = g.rawValue, e.oneofs && (t._rawValue = "rawValue")), t;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/Selectbox";
  }, o;
})();
const Skeleton$1 = $root$1.Skeleton = (() => {
  function o(A) {
    if (A) for (let g = Object.keys(A), e = 0; e < g.length; ++e) A[g[e]] != null && (this[g[e]] = A[g[e]]);
  }
  o.prototype.style = 0, o.prototype.height = null;
  let E;
  return Object.defineProperty(o.prototype, "_height", { get: $util$1.oneOfGetter(E = ["height"]), set: $util$1.oneOfSetter(E) }), o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, e) {
    return e || (e = $Writer$1.create()), g.style != null && Object.hasOwnProperty.call(g, "style") && e.uint32(
      /* id 1, wireType 0 =*/
      8
    ).int32(g.style), g.height != null && Object.hasOwnProperty.call(g, "height") && e.uint32(
      /* id 2, wireType 0 =*/
      16
    ).int32(g.height), e;
  }, o.decode = function(g, e, t) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let c = e === void 0 ? g.len : g.pos + e, n = new $root$1.Skeleton();
    for (; g.pos < c; ) {
      let h = g.uint32();
      if (h === t) break;
      switch (h >>> 3) {
        case 1: {
          n.style = g.int32();
          break;
        }
        case 2: {
          n.height = g.int32();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.Skeleton) return g;
    let e = new $root$1.Skeleton();
    switch (g.style) {
      default:
        if (typeof g.style == "number") {
          e.style = g.style;
          break;
        }
        break;
      case "ELEMENT":
      case 0:
        e.style = 0;
        break;
      case "APP":
      case 1:
        e.style = 1;
        break;
    }
    return g.height != null && (e.height = g.height | 0), e;
  }, o.toObject = function(g, e) {
    e || (e = {});
    let t = {};
    return e.defaults && (t.style = e.enums === String ? "ELEMENT" : 0), g.style != null && g.hasOwnProperty("style") && (t.style = e.enums === String ? $root$1.Skeleton.SkeletonStyle[g.style] === void 0 ? g.style : $root$1.Skeleton.SkeletonStyle[g.style] : g.style), g.height != null && g.hasOwnProperty("height") && (t.height = g.height, e.oneofs && (t._height = "height")), t;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/Skeleton";
  }, o.SkeletonStyle = (function() {
    const A = {}, g = Object.create(A);
    return g[A[0] = "ELEMENT"] = 0, g[A[1] = "APP"] = 1, g;
  })(), o;
})(), Slider$1 = $root$1.Slider = (() => {
  function o(E) {
    if (this.default = [], this.value = [], this.options = [], E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.id = "", o.prototype.formId = "", o.prototype.label = "", o.prototype.format = "", o.prototype.dataType = 0, o.prototype.default = $util$1.emptyArray, o.prototype.min = 0, o.prototype.max = 0, o.prototype.step = 0, o.prototype.value = $util$1.emptyArray, o.prototype.setValue = !1, o.prototype.options = $util$1.emptyArray, o.prototype.help = "", o.prototype.disabled = !1, o.prototype.labelVisibility = null, o.prototype.type = 0, o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    if (g || (g = $Writer$1.create()), A.id != null && Object.hasOwnProperty.call(A, "id") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(A.id), A.formId != null && Object.hasOwnProperty.call(A, "formId") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(A.formId), A.label != null && Object.hasOwnProperty.call(A, "label") && g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(A.label), A.format != null && Object.hasOwnProperty.call(A, "format") && g.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(A.format), A.dataType != null && Object.hasOwnProperty.call(A, "dataType") && g.uint32(
      /* id 5, wireType 0 =*/
      40
    ).int32(A.dataType), A.default != null && A.default.length) {
      g.uint32(
        /* id 6, wireType 2 =*/
        50
      ).fork();
      for (let e = 0; e < A.default.length; ++e) g.double(A.default[e]);
      g.ldelim();
    }
    if (A.min != null && Object.hasOwnProperty.call(A, "min") && g.uint32(
      /* id 7, wireType 1 =*/
      57
    ).double(A.min), A.max != null && Object.hasOwnProperty.call(A, "max") && g.uint32(
      /* id 8, wireType 1 =*/
      65
    ).double(A.max), A.step != null && Object.hasOwnProperty.call(A, "step") && g.uint32(
      /* id 9, wireType 1 =*/
      73
    ).double(A.step), A.value != null && A.value.length) {
      g.uint32(
        /* id 10, wireType 2 =*/
        82
      ).fork();
      for (let e = 0; e < A.value.length; ++e) g.double(A.value[e]);
      g.ldelim();
    }
    if (A.setValue != null && Object.hasOwnProperty.call(A, "setValue") && g.uint32(
      /* id 11, wireType 0 =*/
      88
    ).bool(A.setValue), A.options != null && A.options.length) for (let e = 0; e < A.options.length; ++e) g.uint32(
      /* id 13, wireType 2 =*/
      106
    ).string(A.options[e]);
    return A.help != null && Object.hasOwnProperty.call(A, "help") && g.uint32(
      /* id 14, wireType 2 =*/
      114
    ).string(A.help), A.disabled != null && Object.hasOwnProperty.call(A, "disabled") && g.uint32(
      /* id 15, wireType 0 =*/
      120
    ).bool(A.disabled), A.labelVisibility != null && Object.hasOwnProperty.call(A, "labelVisibility") && $root$1.LabelVisibilityMessage.encode(A.labelVisibility, g.uint32(
      /* id 16, wireType 2 =*/
      130
    ).fork()).ldelim(), A.type != null && Object.hasOwnProperty.call(A, "type") && g.uint32(
      /* id 17, wireType 0 =*/
      136
    ).int32(A.type), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader$1 || (A = $Reader$1.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root$1.Slider();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.id = A.string();
          break;
        }
        case 2: {
          c.formId = A.string();
          break;
        }
        case 3: {
          c.label = A.string();
          break;
        }
        case 4: {
          c.format = A.string();
          break;
        }
        case 5: {
          c.dataType = A.int32();
          break;
        }
        case 6: {
          if (c.default && c.default.length || (c.default = []), (n & 7) === 2) {
            let h = A.uint32() + A.pos;
            for (; A.pos < h; ) c.default.push(A.double());
          } else c.default.push(A.double());
          break;
        }
        case 7: {
          c.min = A.double();
          break;
        }
        case 8: {
          c.max = A.double();
          break;
        }
        case 9: {
          c.step = A.double();
          break;
        }
        case 10: {
          if (c.value && c.value.length || (c.value = []), (n & 7) === 2) {
            let h = A.uint32() + A.pos;
            for (; A.pos < h; ) c.value.push(A.double());
          } else c.value.push(A.double());
          break;
        }
        case 11: {
          c.setValue = A.bool();
          break;
        }
        case 13: {
          c.options && c.options.length || (c.options = []), c.options.push(A.string());
          break;
        }
        case 14: {
          c.help = A.string();
          break;
        }
        case 15: {
          c.disabled = A.bool();
          break;
        }
        case 16: {
          c.labelVisibility = $root$1.LabelVisibilityMessage.decode(A, A.uint32());
          break;
        }
        case 17: {
          c.type = A.int32();
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root$1.Slider) return A;
    let g = new $root$1.Slider();
    switch (A.id != null && (g.id = String(A.id)), A.formId != null && (g.formId = String(A.formId)), A.label != null && (g.label = String(A.label)), A.format != null && (g.format = String(A.format)), A.dataType) {
      default:
        if (typeof A.dataType == "number") {
          g.dataType = A.dataType;
          break;
        }
        break;
      case "INT":
      case 0:
        g.dataType = 0;
        break;
      case "FLOAT":
      case 1:
        g.dataType = 1;
        break;
      case "DATETIME":
      case 2:
        g.dataType = 2;
        break;
      case "DATE":
      case 3:
        g.dataType = 3;
        break;
      case "TIME":
      case 4:
        g.dataType = 4;
        break;
    }
    if (A.default) {
      if (!Array.isArray(A.default)) throw TypeError(".Slider.default: array expected");
      g.default = [];
      for (let e = 0; e < A.default.length; ++e) g.default[e] = Number(A.default[e]);
    }
    if (A.min != null && (g.min = Number(A.min)), A.max != null && (g.max = Number(A.max)), A.step != null && (g.step = Number(A.step)), A.value) {
      if (!Array.isArray(A.value)) throw TypeError(".Slider.value: array expected");
      g.value = [];
      for (let e = 0; e < A.value.length; ++e) g.value[e] = Number(A.value[e]);
    }
    if (A.setValue != null && (g.setValue = !!A.setValue), A.options) {
      if (!Array.isArray(A.options)) throw TypeError(".Slider.options: array expected");
      g.options = [];
      for (let e = 0; e < A.options.length; ++e) g.options[e] = String(A.options[e]);
    }
    if (A.help != null && (g.help = String(A.help)), A.disabled != null && (g.disabled = !!A.disabled), A.labelVisibility != null) {
      if (typeof A.labelVisibility != "object") throw TypeError(".Slider.labelVisibility: object expected");
      g.labelVisibility = $root$1.LabelVisibilityMessage.fromObject(A.labelVisibility);
    }
    switch (A.type) {
      default:
        if (typeof A.type == "number") {
          g.type = A.type;
          break;
        }
        break;
      case "UNSPECIFIED":
      case 0:
        g.type = 0;
        break;
      case "SLIDER":
      case 1:
        g.type = 1;
        break;
      case "SELECT_SLIDER":
      case 2:
        g.type = 2;
        break;
    }
    return g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    if ((g.arrays || g.defaults) && (e.default = [], e.value = [], e.options = []), g.defaults && (e.id = "", e.formId = "", e.label = "", e.format = "", e.dataType = g.enums === String ? "INT" : 0, e.min = 0, e.max = 0, e.step = 0, e.setValue = !1, e.help = "", e.disabled = !1, e.labelVisibility = null, e.type = g.enums === String ? "UNSPECIFIED" : 0), A.id != null && A.hasOwnProperty("id") && (e.id = A.id), A.formId != null && A.hasOwnProperty("formId") && (e.formId = A.formId), A.label != null && A.hasOwnProperty("label") && (e.label = A.label), A.format != null && A.hasOwnProperty("format") && (e.format = A.format), A.dataType != null && A.hasOwnProperty("dataType") && (e.dataType = g.enums === String ? $root$1.Slider.DataType[A.dataType] === void 0 ? A.dataType : $root$1.Slider.DataType[A.dataType] : A.dataType), A.default && A.default.length) {
      e.default = [];
      for (let t = 0; t < A.default.length; ++t) e.default[t] = g.json && !isFinite(A.default[t]) ? String(A.default[t]) : A.default[t];
    }
    if (A.min != null && A.hasOwnProperty("min") && (e.min = g.json && !isFinite(A.min) ? String(A.min) : A.min), A.max != null && A.hasOwnProperty("max") && (e.max = g.json && !isFinite(A.max) ? String(A.max) : A.max), A.step != null && A.hasOwnProperty("step") && (e.step = g.json && !isFinite(A.step) ? String(A.step) : A.step), A.value && A.value.length) {
      e.value = [];
      for (let t = 0; t < A.value.length; ++t) e.value[t] = g.json && !isFinite(A.value[t]) ? String(A.value[t]) : A.value[t];
    }
    if (A.setValue != null && A.hasOwnProperty("setValue") && (e.setValue = A.setValue), A.options && A.options.length) {
      e.options = [];
      for (let t = 0; t < A.options.length; ++t) e.options[t] = A.options[t];
    }
    return A.help != null && A.hasOwnProperty("help") && (e.help = A.help), A.disabled != null && A.hasOwnProperty("disabled") && (e.disabled = A.disabled), A.labelVisibility != null && A.hasOwnProperty("labelVisibility") && (e.labelVisibility = $root$1.LabelVisibilityMessage.toObject(A.labelVisibility, g)), A.type != null && A.hasOwnProperty("type") && (e.type = g.enums === String ? $root$1.Slider.Type[A.type] === void 0 ? A.type : $root$1.Slider.Type[A.type] : A.type), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/Slider";
  }, o.DataType = (function() {
    const E = {}, A = Object.create(E);
    return A[E[0] = "INT"] = 0, A[E[1] = "FLOAT"] = 1, A[E[2] = "DATETIME"] = 2, A[E[3] = "DATE"] = 3, A[E[4] = "TIME"] = 4, A;
  })(), o.Type = (function() {
    const E = {}, A = Object.create(E);
    return A[E[0] = "UNSPECIFIED"] = 0, A[E[1] = "SLIDER"] = 1, A[E[2] = "SELECT_SLIDER"] = 2, A;
  })(), o;
})();
$root$1.Space = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    return g || (g = $Writer$1.create()), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader$1 || (A = $Reader$1.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root$1.Space();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    return A instanceof $root$1.Space ? A : new $root$1.Space();
  }, o.toObject = function() {
    return {};
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/Space";
  }, o;
})();
$root$1.Text = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.body = "", o.prototype.help = "", o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    return g || (g = $Writer$1.create()), A.body != null && Object.hasOwnProperty.call(A, "body") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(A.body), A.help != null && Object.hasOwnProperty.call(A, "help") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(A.help), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader$1 || (A = $Reader$1.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root$1.Text();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.body = A.string();
          break;
        }
        case 2: {
          c.help = A.string();
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root$1.Text) return A;
    let g = new $root$1.Text();
    return A.body != null && (g.body = String(A.body)), A.help != null && (g.help = String(A.help)), g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    return g.defaults && (e.body = "", e.help = ""), A.body != null && A.hasOwnProperty("body") && (e.body = A.body), A.help != null && A.hasOwnProperty("help") && (e.help = A.help), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/Text";
  }, o;
})();
$root$1.TextArea = (() => {
  function o(A) {
    if (A) for (let g = Object.keys(A), e = 0; e < g.length; ++e) A[g[e]] != null && (this[g[e]] = A[g[e]]);
  }
  o.prototype.id = "", o.prototype.label = "", o.prototype.default = null, o.prototype.height = 0, o.prototype.maxChars = 0, o.prototype.help = "", o.prototype.formId = "", o.prototype.value = null, o.prototype.setValue = !1, o.prototype.placeholder = "", o.prototype.disabled = !1, o.prototype.labelVisibility = null;
  let E;
  return Object.defineProperty(o.prototype, "_default", { get: $util$1.oneOfGetter(E = ["default"]), set: $util$1.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_value", { get: $util$1.oneOfGetter(E = ["value"]), set: $util$1.oneOfSetter(E) }), o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, e) {
    return e || (e = $Writer$1.create()), g.id != null && Object.hasOwnProperty.call(g, "id") && e.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.id), g.label != null && Object.hasOwnProperty.call(g, "label") && e.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.label), g.default != null && Object.hasOwnProperty.call(g, "default") && e.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(g.default), g.height != null && Object.hasOwnProperty.call(g, "height") && e.uint32(
      /* id 4, wireType 0 =*/
      32
    ).uint32(g.height), g.maxChars != null && Object.hasOwnProperty.call(g, "maxChars") && e.uint32(
      /* id 5, wireType 0 =*/
      40
    ).uint32(g.maxChars), g.help != null && Object.hasOwnProperty.call(g, "help") && e.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(g.help), g.formId != null && Object.hasOwnProperty.call(g, "formId") && e.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(g.formId), g.value != null && Object.hasOwnProperty.call(g, "value") && e.uint32(
      /* id 8, wireType 2 =*/
      66
    ).string(g.value), g.setValue != null && Object.hasOwnProperty.call(g, "setValue") && e.uint32(
      /* id 9, wireType 0 =*/
      72
    ).bool(g.setValue), g.placeholder != null && Object.hasOwnProperty.call(g, "placeholder") && e.uint32(
      /* id 10, wireType 2 =*/
      82
    ).string(g.placeholder), g.disabled != null && Object.hasOwnProperty.call(g, "disabled") && e.uint32(
      /* id 11, wireType 0 =*/
      88
    ).bool(g.disabled), g.labelVisibility != null && Object.hasOwnProperty.call(g, "labelVisibility") && $root$1.LabelVisibilityMessage.encode(g.labelVisibility, e.uint32(
      /* id 12, wireType 2 =*/
      98
    ).fork()).ldelim(), e;
  }, o.decode = function(g, e, t) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let c = e === void 0 ? g.len : g.pos + e, n = new $root$1.TextArea();
    for (; g.pos < c; ) {
      let h = g.uint32();
      if (h === t) break;
      switch (h >>> 3) {
        case 1: {
          n.id = g.string();
          break;
        }
        case 2: {
          n.label = g.string();
          break;
        }
        case 3: {
          n.default = g.string();
          break;
        }
        case 4: {
          n.height = g.uint32();
          break;
        }
        case 5: {
          n.maxChars = g.uint32();
          break;
        }
        case 6: {
          n.help = g.string();
          break;
        }
        case 7: {
          n.formId = g.string();
          break;
        }
        case 8: {
          n.value = g.string();
          break;
        }
        case 9: {
          n.setValue = g.bool();
          break;
        }
        case 10: {
          n.placeholder = g.string();
          break;
        }
        case 11: {
          n.disabled = g.bool();
          break;
        }
        case 12: {
          n.labelVisibility = $root$1.LabelVisibilityMessage.decode(g, g.uint32());
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.TextArea) return g;
    let e = new $root$1.TextArea();
    if (g.id != null && (e.id = String(g.id)), g.label != null && (e.label = String(g.label)), g.default != null && (e.default = String(g.default)), g.height != null && (e.height = g.height >>> 0), g.maxChars != null && (e.maxChars = g.maxChars >>> 0), g.help != null && (e.help = String(g.help)), g.formId != null && (e.formId = String(g.formId)), g.value != null && (e.value = String(g.value)), g.setValue != null && (e.setValue = !!g.setValue), g.placeholder != null && (e.placeholder = String(g.placeholder)), g.disabled != null && (e.disabled = !!g.disabled), g.labelVisibility != null) {
      if (typeof g.labelVisibility != "object") throw TypeError(".TextArea.labelVisibility: object expected");
      e.labelVisibility = $root$1.LabelVisibilityMessage.fromObject(g.labelVisibility);
    }
    return e;
  }, o.toObject = function(g, e) {
    e || (e = {});
    let t = {};
    return e.defaults && (t.id = "", t.label = "", t.height = 0, t.maxChars = 0, t.help = "", t.formId = "", t.setValue = !1, t.placeholder = "", t.disabled = !1, t.labelVisibility = null), g.id != null && g.hasOwnProperty("id") && (t.id = g.id), g.label != null && g.hasOwnProperty("label") && (t.label = g.label), g.default != null && g.hasOwnProperty("default") && (t.default = g.default, e.oneofs && (t._default = "default")), g.height != null && g.hasOwnProperty("height") && (t.height = g.height), g.maxChars != null && g.hasOwnProperty("maxChars") && (t.maxChars = g.maxChars), g.help != null && g.hasOwnProperty("help") && (t.help = g.help), g.formId != null && g.hasOwnProperty("formId") && (t.formId = g.formId), g.value != null && g.hasOwnProperty("value") && (t.value = g.value, e.oneofs && (t._value = "value")), g.setValue != null && g.hasOwnProperty("setValue") && (t.setValue = g.setValue), g.placeholder != null && g.hasOwnProperty("placeholder") && (t.placeholder = g.placeholder), g.disabled != null && g.hasOwnProperty("disabled") && (t.disabled = g.disabled), g.labelVisibility != null && g.hasOwnProperty("labelVisibility") && (t.labelVisibility = $root$1.LabelVisibilityMessage.toObject(g.labelVisibility, e)), t;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/TextArea";
  }, o;
})();
const TextInput$1 = $root$1.TextInput = (() => {
  function o(A) {
    if (A) for (let g = Object.keys(A), e = 0; e < g.length; ++e) A[g[e]] != null && (this[g[e]] = A[g[e]]);
  }
  o.prototype.id = "", o.prototype.label = "", o.prototype.default = null, o.prototype.type = 0, o.prototype.maxChars = 0, o.prototype.help = "", o.prototype.formId = "", o.prototype.value = null, o.prototype.setValue = !1, o.prototype.autocomplete = "", o.prototype.placeholder = "", o.prototype.disabled = !1, o.prototype.labelVisibility = null, o.prototype.icon = "";
  let E;
  return Object.defineProperty(o.prototype, "_default", { get: $util$1.oneOfGetter(E = ["default"]), set: $util$1.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_value", { get: $util$1.oneOfGetter(E = ["value"]), set: $util$1.oneOfSetter(E) }), o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, e) {
    return e || (e = $Writer$1.create()), g.id != null && Object.hasOwnProperty.call(g, "id") && e.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.id), g.label != null && Object.hasOwnProperty.call(g, "label") && e.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.label), g.default != null && Object.hasOwnProperty.call(g, "default") && e.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(g.default), g.type != null && Object.hasOwnProperty.call(g, "type") && e.uint32(
      /* id 4, wireType 0 =*/
      32
    ).int32(g.type), g.maxChars != null && Object.hasOwnProperty.call(g, "maxChars") && e.uint32(
      /* id 5, wireType 0 =*/
      40
    ).uint32(g.maxChars), g.help != null && Object.hasOwnProperty.call(g, "help") && e.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(g.help), g.formId != null && Object.hasOwnProperty.call(g, "formId") && e.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(g.formId), g.value != null && Object.hasOwnProperty.call(g, "value") && e.uint32(
      /* id 8, wireType 2 =*/
      66
    ).string(g.value), g.setValue != null && Object.hasOwnProperty.call(g, "setValue") && e.uint32(
      /* id 9, wireType 0 =*/
      72
    ).bool(g.setValue), g.autocomplete != null && Object.hasOwnProperty.call(g, "autocomplete") && e.uint32(
      /* id 10, wireType 2 =*/
      82
    ).string(g.autocomplete), g.placeholder != null && Object.hasOwnProperty.call(g, "placeholder") && e.uint32(
      /* id 11, wireType 2 =*/
      90
    ).string(g.placeholder), g.disabled != null && Object.hasOwnProperty.call(g, "disabled") && e.uint32(
      /* id 12, wireType 0 =*/
      96
    ).bool(g.disabled), g.labelVisibility != null && Object.hasOwnProperty.call(g, "labelVisibility") && $root$1.LabelVisibilityMessage.encode(g.labelVisibility, e.uint32(
      /* id 13, wireType 2 =*/
      106
    ).fork()).ldelim(), g.icon != null && Object.hasOwnProperty.call(g, "icon") && e.uint32(
      /* id 14, wireType 2 =*/
      114
    ).string(g.icon), e;
  }, o.decode = function(g, e, t) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let c = e === void 0 ? g.len : g.pos + e, n = new $root$1.TextInput();
    for (; g.pos < c; ) {
      let h = g.uint32();
      if (h === t) break;
      switch (h >>> 3) {
        case 1: {
          n.id = g.string();
          break;
        }
        case 2: {
          n.label = g.string();
          break;
        }
        case 3: {
          n.default = g.string();
          break;
        }
        case 4: {
          n.type = g.int32();
          break;
        }
        case 5: {
          n.maxChars = g.uint32();
          break;
        }
        case 6: {
          n.help = g.string();
          break;
        }
        case 7: {
          n.formId = g.string();
          break;
        }
        case 8: {
          n.value = g.string();
          break;
        }
        case 9: {
          n.setValue = g.bool();
          break;
        }
        case 10: {
          n.autocomplete = g.string();
          break;
        }
        case 11: {
          n.placeholder = g.string();
          break;
        }
        case 12: {
          n.disabled = g.bool();
          break;
        }
        case 13: {
          n.labelVisibility = $root$1.LabelVisibilityMessage.decode(g, g.uint32());
          break;
        }
        case 14: {
          n.icon = g.string();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.TextInput) return g;
    let e = new $root$1.TextInput();
    switch (g.id != null && (e.id = String(g.id)), g.label != null && (e.label = String(g.label)), g.default != null && (e.default = String(g.default)), g.type) {
      default:
        if (typeof g.type == "number") {
          e.type = g.type;
          break;
        }
        break;
      case "DEFAULT":
      case 0:
        e.type = 0;
        break;
      case "PASSWORD":
      case 1:
        e.type = 1;
        break;
    }
    if (g.maxChars != null && (e.maxChars = g.maxChars >>> 0), g.help != null && (e.help = String(g.help)), g.formId != null && (e.formId = String(g.formId)), g.value != null && (e.value = String(g.value)), g.setValue != null && (e.setValue = !!g.setValue), g.autocomplete != null && (e.autocomplete = String(g.autocomplete)), g.placeholder != null && (e.placeholder = String(g.placeholder)), g.disabled != null && (e.disabled = !!g.disabled), g.labelVisibility != null) {
      if (typeof g.labelVisibility != "object") throw TypeError(".TextInput.labelVisibility: object expected");
      e.labelVisibility = $root$1.LabelVisibilityMessage.fromObject(g.labelVisibility);
    }
    return g.icon != null && (e.icon = String(g.icon)), e;
  }, o.toObject = function(g, e) {
    e || (e = {});
    let t = {};
    return e.defaults && (t.id = "", t.label = "", t.type = e.enums === String ? "DEFAULT" : 0, t.maxChars = 0, t.help = "", t.formId = "", t.setValue = !1, t.autocomplete = "", t.placeholder = "", t.disabled = !1, t.labelVisibility = null, t.icon = ""), g.id != null && g.hasOwnProperty("id") && (t.id = g.id), g.label != null && g.hasOwnProperty("label") && (t.label = g.label), g.default != null && g.hasOwnProperty("default") && (t.default = g.default, e.oneofs && (t._default = "default")), g.type != null && g.hasOwnProperty("type") && (t.type = e.enums === String ? $root$1.TextInput.Type[g.type] === void 0 ? g.type : $root$1.TextInput.Type[g.type] : g.type), g.maxChars != null && g.hasOwnProperty("maxChars") && (t.maxChars = g.maxChars), g.help != null && g.hasOwnProperty("help") && (t.help = g.help), g.formId != null && g.hasOwnProperty("formId") && (t.formId = g.formId), g.value != null && g.hasOwnProperty("value") && (t.value = g.value, e.oneofs && (t._value = "value")), g.setValue != null && g.hasOwnProperty("setValue") && (t.setValue = g.setValue), g.autocomplete != null && g.hasOwnProperty("autocomplete") && (t.autocomplete = g.autocomplete), g.placeholder != null && g.hasOwnProperty("placeholder") && (t.placeholder = g.placeholder), g.disabled != null && g.hasOwnProperty("disabled") && (t.disabled = g.disabled), g.labelVisibility != null && g.hasOwnProperty("labelVisibility") && (t.labelVisibility = $root$1.LabelVisibilityMessage.toObject(g.labelVisibility, e)), g.icon != null && g.hasOwnProperty("icon") && (t.icon = g.icon), t;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/TextInput";
  }, o.Type = (function() {
    const A = {}, g = Object.create(A);
    return g[A[0] = "DEFAULT"] = 0, g[A[1] = "PASSWORD"] = 1, g;
  })(), o;
})();
$root$1.TimeInput = (() => {
  function o(A) {
    if (A) for (let g = Object.keys(A), e = 0; e < g.length; ++e) A[g[e]] != null && (this[g[e]] = A[g[e]]);
  }
  o.prototype.id = "", o.prototype.label = "", o.prototype.default = null, o.prototype.help = "", o.prototype.formId = "", o.prototype.value = null, o.prototype.setValue = !1, o.prototype.disabled = !1, o.prototype.labelVisibility = null, o.prototype.step = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0;
  let E;
  return Object.defineProperty(o.prototype, "_default", { get: $util$1.oneOfGetter(E = ["default"]), set: $util$1.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_value", { get: $util$1.oneOfGetter(E = ["value"]), set: $util$1.oneOfSetter(E) }), o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, e) {
    return e || (e = $Writer$1.create()), g.id != null && Object.hasOwnProperty.call(g, "id") && e.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.id), g.label != null && Object.hasOwnProperty.call(g, "label") && e.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.label), g.default != null && Object.hasOwnProperty.call(g, "default") && e.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(g.default), g.help != null && Object.hasOwnProperty.call(g, "help") && e.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(g.help), g.formId != null && Object.hasOwnProperty.call(g, "formId") && e.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(g.formId), g.value != null && Object.hasOwnProperty.call(g, "value") && e.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(g.value), g.setValue != null && Object.hasOwnProperty.call(g, "setValue") && e.uint32(
      /* id 7, wireType 0 =*/
      56
    ).bool(g.setValue), g.disabled != null && Object.hasOwnProperty.call(g, "disabled") && e.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(g.disabled), g.labelVisibility != null && Object.hasOwnProperty.call(g, "labelVisibility") && $root$1.LabelVisibilityMessage.encode(g.labelVisibility, e.uint32(
      /* id 9, wireType 2 =*/
      74
    ).fork()).ldelim(), g.step != null && Object.hasOwnProperty.call(g, "step") && e.uint32(
      /* id 10, wireType 0 =*/
      80
    ).int64(g.step), e;
  }, o.decode = function(g, e, t) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let c = e === void 0 ? g.len : g.pos + e, n = new $root$1.TimeInput();
    for (; g.pos < c; ) {
      let h = g.uint32();
      if (h === t) break;
      switch (h >>> 3) {
        case 1: {
          n.id = g.string();
          break;
        }
        case 2: {
          n.label = g.string();
          break;
        }
        case 3: {
          n.default = g.string();
          break;
        }
        case 4: {
          n.help = g.string();
          break;
        }
        case 5: {
          n.formId = g.string();
          break;
        }
        case 6: {
          n.value = g.string();
          break;
        }
        case 7: {
          n.setValue = g.bool();
          break;
        }
        case 8: {
          n.disabled = g.bool();
          break;
        }
        case 9: {
          n.labelVisibility = $root$1.LabelVisibilityMessage.decode(g, g.uint32());
          break;
        }
        case 10: {
          n.step = g.int64();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.TimeInput) return g;
    let e = new $root$1.TimeInput();
    if (g.id != null && (e.id = String(g.id)), g.label != null && (e.label = String(g.label)), g.default != null && (e.default = String(g.default)), g.help != null && (e.help = String(g.help)), g.formId != null && (e.formId = String(g.formId)), g.value != null && (e.value = String(g.value)), g.setValue != null && (e.setValue = !!g.setValue), g.disabled != null && (e.disabled = !!g.disabled), g.labelVisibility != null) {
      if (typeof g.labelVisibility != "object") throw TypeError(".TimeInput.labelVisibility: object expected");
      e.labelVisibility = $root$1.LabelVisibilityMessage.fromObject(g.labelVisibility);
    }
    return g.step != null && ($util$1.Long ? (e.step = $util$1.Long.fromValue(g.step)).unsigned = !1 : typeof g.step == "string" ? e.step = parseInt(g.step, 10) : typeof g.step == "number" ? e.step = g.step : typeof g.step == "object" && (e.step = new $util$1.LongBits(g.step.low >>> 0, g.step.high >>> 0).toNumber())), e;
  }, o.toObject = function(g, e) {
    e || (e = {});
    let t = {};
    if (e.defaults)
      if (t.id = "", t.label = "", t.help = "", t.formId = "", t.setValue = !1, t.disabled = !1, t.labelVisibility = null, $util$1.Long) {
        let c = new $util$1.Long(0, 0, !1);
        t.step = e.longs === String ? c.toString() : e.longs === Number ? c.toNumber() : c;
      } else t.step = e.longs === String ? "0" : 0;
    return g.id != null && g.hasOwnProperty("id") && (t.id = g.id), g.label != null && g.hasOwnProperty("label") && (t.label = g.label), g.default != null && g.hasOwnProperty("default") && (t.default = g.default, e.oneofs && (t._default = "default")), g.help != null && g.hasOwnProperty("help") && (t.help = g.help), g.formId != null && g.hasOwnProperty("formId") && (t.formId = g.formId), g.value != null && g.hasOwnProperty("value") && (t.value = g.value, e.oneofs && (t._value = "value")), g.setValue != null && g.hasOwnProperty("setValue") && (t.setValue = g.setValue), g.disabled != null && g.hasOwnProperty("disabled") && (t.disabled = g.disabled), g.labelVisibility != null && g.hasOwnProperty("labelVisibility") && (t.labelVisibility = $root$1.LabelVisibilityMessage.toObject(g.labelVisibility, e)), g.step != null && g.hasOwnProperty("step") && (typeof g.step == "number" ? t.step = e.longs === String ? String(g.step) : g.step : t.step = e.longs === String ? $util$1.Long.prototype.toString.call(g.step) : e.longs === Number ? new $util$1.LongBits(g.step.low >>> 0, g.step.high >>> 0).toNumber() : g.step), t;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/TimeInput";
  }, o;
})();
$root$1.Toast = (() => {
  function o(A) {
    if (A) for (let g = Object.keys(A), e = 0; e < g.length; ++e) A[g[e]] != null && (this[g[e]] = A[g[e]]);
  }
  o.prototype.body = "", o.prototype.icon = "", o.prototype.duration = null;
  let E;
  return Object.defineProperty(o.prototype, "_duration", { get: $util$1.oneOfGetter(E = ["duration"]), set: $util$1.oneOfSetter(E) }), o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, e) {
    return e || (e = $Writer$1.create()), g.body != null && Object.hasOwnProperty.call(g, "body") && e.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.body), g.icon != null && Object.hasOwnProperty.call(g, "icon") && e.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.icon), g.duration != null && Object.hasOwnProperty.call(g, "duration") && e.uint32(
      /* id 3, wireType 0 =*/
      24
    ).int32(g.duration), e;
  }, o.decode = function(g, e, t) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let c = e === void 0 ? g.len : g.pos + e, n = new $root$1.Toast();
    for (; g.pos < c; ) {
      let h = g.uint32();
      if (h === t) break;
      switch (h >>> 3) {
        case 1: {
          n.body = g.string();
          break;
        }
        case 2: {
          n.icon = g.string();
          break;
        }
        case 3: {
          n.duration = g.int32();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.Toast) return g;
    let e = new $root$1.Toast();
    return g.body != null && (e.body = String(g.body)), g.icon != null && (e.icon = String(g.icon)), g.duration != null && (e.duration = g.duration | 0), e;
  }, o.toObject = function(g, e) {
    e || (e = {});
    let t = {};
    return e.defaults && (t.body = "", t.icon = ""), g.body != null && g.hasOwnProperty("body") && (t.body = g.body), g.icon != null && g.hasOwnProperty("icon") && (t.icon = g.icon), g.duration != null && g.hasOwnProperty("duration") && (t.duration = g.duration, e.oneofs && (t._duration = "duration")), t;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/Toast";
  }, o;
})();
$root$1.VegaLiteChart = (() => {
  function o(E) {
    if (this.datasets = [], E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.spec = "", o.prototype.data = null, o.prototype.datasets = $util$1.emptyArray, o.prototype.useContainerWidth = !1, o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    if (g || (g = $Writer$1.create()), A.spec != null && Object.hasOwnProperty.call(A, "spec") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(A.spec), A.data != null && Object.hasOwnProperty.call(A, "data") && $root$1.DataFrame.encode(A.data, g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), A.datasets != null && A.datasets.length) for (let e = 0; e < A.datasets.length; ++e) $root$1.NamedDataSet.encode(A.datasets[e], g.uint32(
      /* id 4, wireType 2 =*/
      34
    ).fork()).ldelim();
    return A.useContainerWidth != null && Object.hasOwnProperty.call(A, "useContainerWidth") && g.uint32(
      /* id 5, wireType 0 =*/
      40
    ).bool(A.useContainerWidth), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader$1 || (A = $Reader$1.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root$1.VegaLiteChart();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.spec = A.string();
          break;
        }
        case 2: {
          c.data = $root$1.DataFrame.decode(A, A.uint32());
          break;
        }
        case 4: {
          c.datasets && c.datasets.length || (c.datasets = []), c.datasets.push($root$1.NamedDataSet.decode(A, A.uint32()));
          break;
        }
        case 5: {
          c.useContainerWidth = A.bool();
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root$1.VegaLiteChart) return A;
    let g = new $root$1.VegaLiteChart();
    if (A.spec != null && (g.spec = String(A.spec)), A.data != null) {
      if (typeof A.data != "object") throw TypeError(".VegaLiteChart.data: object expected");
      g.data = $root$1.DataFrame.fromObject(A.data);
    }
    if (A.datasets) {
      if (!Array.isArray(A.datasets)) throw TypeError(".VegaLiteChart.datasets: array expected");
      g.datasets = [];
      for (let e = 0; e < A.datasets.length; ++e) {
        if (typeof A.datasets[e] != "object") throw TypeError(".VegaLiteChart.datasets: object expected");
        g.datasets[e] = $root$1.NamedDataSet.fromObject(A.datasets[e]);
      }
    }
    return A.useContainerWidth != null && (g.useContainerWidth = !!A.useContainerWidth), g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    if ((g.arrays || g.defaults) && (e.datasets = []), g.defaults && (e.spec = "", e.data = null, e.useContainerWidth = !1), A.spec != null && A.hasOwnProperty("spec") && (e.spec = A.spec), A.data != null && A.hasOwnProperty("data") && (e.data = $root$1.DataFrame.toObject(A.data, g)), A.datasets && A.datasets.length) {
      e.datasets = [];
      for (let t = 0; t < A.datasets.length; ++t) e.datasets[t] = $root$1.NamedDataSet.toObject(A.datasets[t], g);
    }
    return A.useContainerWidth != null && A.hasOwnProperty("useContainerWidth") && (e.useContainerWidth = A.useContainerWidth), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/VegaLiteChart";
  }, o;
})();
$root$1.NamedDataSet = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.name = "", o.prototype.hasName = !1, o.prototype.data = null, o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    return g || (g = $Writer$1.create()), A.name != null && Object.hasOwnProperty.call(A, "name") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(A.name), A.data != null && Object.hasOwnProperty.call(A, "data") && $root$1.DataFrame.encode(A.data, g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), A.hasName != null && Object.hasOwnProperty.call(A, "hasName") && g.uint32(
      /* id 3, wireType 0 =*/
      24
    ).bool(A.hasName), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader$1 || (A = $Reader$1.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root$1.NamedDataSet();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.name = A.string();
          break;
        }
        case 3: {
          c.hasName = A.bool();
          break;
        }
        case 2: {
          c.data = $root$1.DataFrame.decode(A, A.uint32());
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root$1.NamedDataSet) return A;
    let g = new $root$1.NamedDataSet();
    if (A.name != null && (g.name = String(A.name)), A.hasName != null && (g.hasName = !!A.hasName), A.data != null) {
      if (typeof A.data != "object") throw TypeError(".NamedDataSet.data: object expected");
      g.data = $root$1.DataFrame.fromObject(A.data);
    }
    return g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    return g.defaults && (e.name = "", e.data = null, e.hasName = !1), A.name != null && A.hasOwnProperty("name") && (e.name = A.name), A.data != null && A.hasOwnProperty("data") && (e.data = $root$1.DataFrame.toObject(A.data, g)), A.hasName != null && A.hasOwnProperty("hasName") && (e.hasName = A.hasName), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/NamedDataSet";
  }, o;
})();
$root$1.SubtitleTrack = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.label = "", o.prototype.url = "", o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    return g || (g = $Writer$1.create()), A.label != null && Object.hasOwnProperty.call(A, "label") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(A.label), A.url != null && Object.hasOwnProperty.call(A, "url") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(A.url), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader$1 || (A = $Reader$1.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root$1.SubtitleTrack();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.label = A.string();
          break;
        }
        case 2: {
          c.url = A.string();
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root$1.SubtitleTrack) return A;
    let g = new $root$1.SubtitleTrack();
    return A.label != null && (g.label = String(A.label)), A.url != null && (g.url = String(A.url)), g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    return g.defaults && (e.label = "", e.url = ""), A.label != null && A.hasOwnProperty("label") && (e.label = A.label), A.url != null && A.hasOwnProperty("url") && (e.url = A.url), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/SubtitleTrack";
  }, o;
})();
const Video$1 = $root$1.Video = (() => {
  function o(A) {
    if (this.subtitles = [], A) for (let g = Object.keys(A), e = 0; e < g.length; ++e) A[g[e]] != null && (this[g[e]] = A[g[e]]);
  }
  o.prototype.url = "", o.prototype.startTime = 0, o.prototype.type = 0, o.prototype.subtitles = $util$1.emptyArray, o.prototype.endTime = 0, o.prototype.loop = !1, o.prototype.autoplay = !1, o.prototype.muted = !1, o.prototype.id = "", o.prototype.widthConfig = null;
  let E;
  return Object.defineProperty(o.prototype, "_widthConfig", { get: $util$1.oneOfGetter(E = ["widthConfig"]), set: $util$1.oneOfSetter(E) }), o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, e) {
    if (e || (e = $Writer$1.create()), g.startTime != null && Object.hasOwnProperty.call(g, "startTime") && e.uint32(
      /* id 3, wireType 0 =*/
      24
    ).int32(g.startTime), g.type != null && Object.hasOwnProperty.call(g, "type") && e.uint32(
      /* id 5, wireType 0 =*/
      40
    ).int32(g.type), g.url != null && Object.hasOwnProperty.call(g, "url") && e.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(g.url), g.subtitles != null && g.subtitles.length) for (let t = 0; t < g.subtitles.length; ++t) $root$1.SubtitleTrack.encode(g.subtitles[t], e.uint32(
      /* id 7, wireType 2 =*/
      58
    ).fork()).ldelim();
    return g.endTime != null && Object.hasOwnProperty.call(g, "endTime") && e.uint32(
      /* id 8, wireType 0 =*/
      64
    ).int32(g.endTime), g.loop != null && Object.hasOwnProperty.call(g, "loop") && e.uint32(
      /* id 9, wireType 0 =*/
      72
    ).bool(g.loop), g.autoplay != null && Object.hasOwnProperty.call(g, "autoplay") && e.uint32(
      /* id 10, wireType 0 =*/
      80
    ).bool(g.autoplay), g.muted != null && Object.hasOwnProperty.call(g, "muted") && e.uint32(
      /* id 11, wireType 0 =*/
      88
    ).bool(g.muted), g.id != null && Object.hasOwnProperty.call(g, "id") && e.uint32(
      /* id 12, wireType 2 =*/
      98
    ).string(g.id), g.widthConfig != null && Object.hasOwnProperty.call(g, "widthConfig") && $root$1.streamlit.WidthConfig.encode(g.widthConfig, e.uint32(
      /* id 13, wireType 2 =*/
      106
    ).fork()).ldelim(), e;
  }, o.decode = function(g, e, t) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let c = e === void 0 ? g.len : g.pos + e, n = new $root$1.Video();
    for (; g.pos < c; ) {
      let h = g.uint32();
      if (h === t) break;
      switch (h >>> 3) {
        case 6: {
          n.url = g.string();
          break;
        }
        case 3: {
          n.startTime = g.int32();
          break;
        }
        case 5: {
          n.type = g.int32();
          break;
        }
        case 7: {
          n.subtitles && n.subtitles.length || (n.subtitles = []), n.subtitles.push($root$1.SubtitleTrack.decode(g, g.uint32()));
          break;
        }
        case 8: {
          n.endTime = g.int32();
          break;
        }
        case 9: {
          n.loop = g.bool();
          break;
        }
        case 10: {
          n.autoplay = g.bool();
          break;
        }
        case 11: {
          n.muted = g.bool();
          break;
        }
        case 12: {
          n.id = g.string();
          break;
        }
        case 13: {
          n.widthConfig = $root$1.streamlit.WidthConfig.decode(g, g.uint32());
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.Video) return g;
    let e = new $root$1.Video();
    switch (g.url != null && (e.url = String(g.url)), g.startTime != null && (e.startTime = g.startTime | 0), g.type) {
      default:
        if (typeof g.type == "number") {
          e.type = g.type;
          break;
        }
        break;
      case "UNUSED":
      case 0:
        e.type = 0;
        break;
      case "NATIVE":
      case 1:
        e.type = 1;
        break;
      case "YOUTUBE_IFRAME":
      case 2:
        e.type = 2;
        break;
    }
    if (g.subtitles) {
      if (!Array.isArray(g.subtitles)) throw TypeError(".Video.subtitles: array expected");
      e.subtitles = [];
      for (let t = 0; t < g.subtitles.length; ++t) {
        if (typeof g.subtitles[t] != "object") throw TypeError(".Video.subtitles: object expected");
        e.subtitles[t] = $root$1.SubtitleTrack.fromObject(g.subtitles[t]);
      }
    }
    if (g.endTime != null && (e.endTime = g.endTime | 0), g.loop != null && (e.loop = !!g.loop), g.autoplay != null && (e.autoplay = !!g.autoplay), g.muted != null && (e.muted = !!g.muted), g.id != null && (e.id = String(g.id)), g.widthConfig != null) {
      if (typeof g.widthConfig != "object") throw TypeError(".Video.widthConfig: object expected");
      e.widthConfig = $root$1.streamlit.WidthConfig.fromObject(g.widthConfig);
    }
    return e;
  }, o.toObject = function(g, e) {
    e || (e = {});
    let t = {};
    if ((e.arrays || e.defaults) && (t.subtitles = []), e.defaults && (t.startTime = 0, t.type = e.enums === String ? "UNUSED" : 0, t.url = "", t.endTime = 0, t.loop = !1, t.autoplay = !1, t.muted = !1, t.id = ""), g.startTime != null && g.hasOwnProperty("startTime") && (t.startTime = g.startTime), g.type != null && g.hasOwnProperty("type") && (t.type = e.enums === String ? $root$1.Video.Type[g.type] === void 0 ? g.type : $root$1.Video.Type[g.type] : g.type), g.url != null && g.hasOwnProperty("url") && (t.url = g.url), g.subtitles && g.subtitles.length) {
      t.subtitles = [];
      for (let c = 0; c < g.subtitles.length; ++c) t.subtitles[c] = $root$1.SubtitleTrack.toObject(g.subtitles[c], e);
    }
    return g.endTime != null && g.hasOwnProperty("endTime") && (t.endTime = g.endTime), g.loop != null && g.hasOwnProperty("loop") && (t.loop = g.loop), g.autoplay != null && g.hasOwnProperty("autoplay") && (t.autoplay = g.autoplay), g.muted != null && g.hasOwnProperty("muted") && (t.muted = g.muted), g.id != null && g.hasOwnProperty("id") && (t.id = g.id), g.widthConfig != null && g.hasOwnProperty("widthConfig") && (t.widthConfig = $root$1.streamlit.WidthConfig.toObject(g.widthConfig, e), e.oneofs && (t._widthConfig = "widthConfig")), t;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/Video";
  }, o.Type = (function() {
    const A = {}, g = Object.create(A);
    return g[A[0] = "UNUSED"] = 0, g[A[1] = "NATIVE"] = 1, g[A[2] = "YOUTUBE_IFRAME"] = 2, g;
  })(), o;
})();
$root$1.Heading = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.tag = "", o.prototype.anchor = "", o.prototype.body = "", o.prototype.help = "", o.prototype.hideAnchor = !1, o.prototype.divider = "", o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    return g || (g = $Writer$1.create()), A.tag != null && Object.hasOwnProperty.call(A, "tag") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(A.tag), A.anchor != null && Object.hasOwnProperty.call(A, "anchor") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(A.anchor), A.body != null && Object.hasOwnProperty.call(A, "body") && g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(A.body), A.help != null && Object.hasOwnProperty.call(A, "help") && g.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(A.help), A.hideAnchor != null && Object.hasOwnProperty.call(A, "hideAnchor") && g.uint32(
      /* id 5, wireType 0 =*/
      40
    ).bool(A.hideAnchor), A.divider != null && Object.hasOwnProperty.call(A, "divider") && g.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(A.divider), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader$1 || (A = $Reader$1.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root$1.Heading();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.tag = A.string();
          break;
        }
        case 2: {
          c.anchor = A.string();
          break;
        }
        case 3: {
          c.body = A.string();
          break;
        }
        case 4: {
          c.help = A.string();
          break;
        }
        case 5: {
          c.hideAnchor = A.bool();
          break;
        }
        case 6: {
          c.divider = A.string();
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root$1.Heading) return A;
    let g = new $root$1.Heading();
    return A.tag != null && (g.tag = String(A.tag)), A.anchor != null && (g.anchor = String(A.anchor)), A.body != null && (g.body = String(A.body)), A.help != null && (g.help = String(A.help)), A.hideAnchor != null && (g.hideAnchor = !!A.hideAnchor), A.divider != null && (g.divider = String(A.divider)), g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    return g.defaults && (e.tag = "", e.anchor = "", e.body = "", e.help = "", e.hideAnchor = !1, e.divider = ""), A.tag != null && A.hasOwnProperty("tag") && (e.tag = A.tag), A.anchor != null && A.hasOwnProperty("anchor") && (e.anchor = A.anchor), A.body != null && A.hasOwnProperty("body") && (e.body = A.body), A.help != null && A.hasOwnProperty("help") && (e.help = A.help), A.hideAnchor != null && A.hasOwnProperty("hideAnchor") && (e.hideAnchor = A.hideAnchor), A.divider != null && A.hasOwnProperty("divider") && (e.divider = A.divider), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/Heading";
  }, o;
})();
const ForwardMsg = $root$1.ForwardMsg = (() => {
  function o(A) {
    if (A) for (let g = Object.keys(A), e = 0; e < g.length; ++e) A[g[e]] != null && (this[g[e]] = A[g[e]]);
  }
  o.prototype.hash = "", o.prototype.metadata = null, o.prototype.newSession = null, o.prototype.delta = null, o.prototype.pageInfoChanged = null, o.prototype.pageConfigChanged = null, o.prototype.scriptFinished = null, o.prototype.gitInfoChanged = null, o.prototype.pageProfile = null, o.prototype.sessionStatusChanged = null, o.prototype.sessionEvent = null, o.prototype.navigation = null, o.prototype.pageNotFound = null, o.prototype.pagesChanged = null, o.prototype.fileUrlsResponse = null, o.prototype.autoRerun = null, o.prototype.logo = null, o.prototype.authRedirect = null, o.prototype.parentMessage = null, o.prototype.refHash = null, o.prototype.deferredFileResponse = null, o.prototype.debugLastBackmsgId = "";
  let E;
  return Object.defineProperty(o.prototype, "type", { get: $util$1.oneOfGetter(E = ["newSession", "delta", "pageInfoChanged", "pageConfigChanged", "scriptFinished", "gitInfoChanged", "pageProfile", "sessionStatusChanged", "sessionEvent", "navigation", "pageNotFound", "pagesChanged", "fileUrlsResponse", "autoRerun", "logo", "authRedirect", "parentMessage", "refHash", "deferredFileResponse"]), set: $util$1.oneOfSetter(E) }), o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, e) {
    return e || (e = $Writer$1.create()), g.hash != null && Object.hasOwnProperty.call(g, "hash") && e.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.hash), g.metadata != null && Object.hasOwnProperty.call(g, "metadata") && $root$1.ForwardMsgMetadata.encode(g.metadata, e.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), g.newSession != null && Object.hasOwnProperty.call(g, "newSession") && $root$1.NewSession.encode(g.newSession, e.uint32(
      /* id 4, wireType 2 =*/
      34
    ).fork()).ldelim(), g.delta != null && Object.hasOwnProperty.call(g, "delta") && $root$1.Delta.encode(g.delta, e.uint32(
      /* id 5, wireType 2 =*/
      42
    ).fork()).ldelim(), g.scriptFinished != null && Object.hasOwnProperty.call(g, "scriptFinished") && e.uint32(
      /* id 6, wireType 0 =*/
      48
    ).int32(g.scriptFinished), g.sessionStatusChanged != null && Object.hasOwnProperty.call(g, "sessionStatusChanged") && $root$1.SessionStatus.encode(g.sessionStatusChanged, e.uint32(
      /* id 9, wireType 2 =*/
      74
    ).fork()).ldelim(), g.sessionEvent != null && Object.hasOwnProperty.call(g, "sessionEvent") && $root$1.SessionEvent.encode(g.sessionEvent, e.uint32(
      /* id 10, wireType 2 =*/
      82
    ).fork()).ldelim(), g.refHash != null && Object.hasOwnProperty.call(g, "refHash") && e.uint32(
      /* id 11, wireType 2 =*/
      90
    ).string(g.refHash), g.pageInfoChanged != null && Object.hasOwnProperty.call(g, "pageInfoChanged") && $root$1.PageInfo.encode(g.pageInfoChanged, e.uint32(
      /* id 12, wireType 2 =*/
      98
    ).fork()).ldelim(), g.pageConfigChanged != null && Object.hasOwnProperty.call(g, "pageConfigChanged") && $root$1.PageConfig.encode(g.pageConfigChanged, e.uint32(
      /* id 13, wireType 2 =*/
      106
    ).fork()).ldelim(), g.gitInfoChanged != null && Object.hasOwnProperty.call(g, "gitInfoChanged") && $root$1.GitInfo.encode(g.gitInfoChanged, e.uint32(
      /* id 14, wireType 2 =*/
      114
    ).fork()).ldelim(), g.pageNotFound != null && Object.hasOwnProperty.call(g, "pageNotFound") && $root$1.PageNotFound.encode(g.pageNotFound, e.uint32(
      /* id 15, wireType 2 =*/
      122
    ).fork()).ldelim(), g.pagesChanged != null && Object.hasOwnProperty.call(g, "pagesChanged") && $root$1.PagesChanged.encode(g.pagesChanged, e.uint32(
      /* id 16, wireType 2 =*/
      130
    ).fork()).ldelim(), g.debugLastBackmsgId != null && Object.hasOwnProperty.call(g, "debugLastBackmsgId") && e.uint32(
      /* id 17, wireType 2 =*/
      138
    ).string(g.debugLastBackmsgId), g.pageProfile != null && Object.hasOwnProperty.call(g, "pageProfile") && $root$1.PageProfile.encode(g.pageProfile, e.uint32(
      /* id 18, wireType 2 =*/
      146
    ).fork()).ldelim(), g.fileUrlsResponse != null && Object.hasOwnProperty.call(g, "fileUrlsResponse") && $root$1.FileURLsResponse.encode(g.fileUrlsResponse, e.uint32(
      /* id 19, wireType 2 =*/
      154
    ).fork()).ldelim(), g.parentMessage != null && Object.hasOwnProperty.call(g, "parentMessage") && $root$1.ParentMessage.encode(g.parentMessage, e.uint32(
      /* id 20, wireType 2 =*/
      162
    ).fork()).ldelim(), g.autoRerun != null && Object.hasOwnProperty.call(g, "autoRerun") && $root$1.AutoRerun.encode(g.autoRerun, e.uint32(
      /* id 21, wireType 2 =*/
      170
    ).fork()).ldelim(), g.logo != null && Object.hasOwnProperty.call(g, "logo") && $root$1.Logo.encode(g.logo, e.uint32(
      /* id 22, wireType 2 =*/
      178
    ).fork()).ldelim(), g.navigation != null && Object.hasOwnProperty.call(g, "navigation") && $root$1.Navigation.encode(g.navigation, e.uint32(
      /* id 23, wireType 2 =*/
      186
    ).fork()).ldelim(), g.authRedirect != null && Object.hasOwnProperty.call(g, "authRedirect") && $root$1.AuthRedirect.encode(g.authRedirect, e.uint32(
      /* id 24, wireType 2 =*/
      194
    ).fork()).ldelim(), g.deferredFileResponse != null && Object.hasOwnProperty.call(g, "deferredFileResponse") && $root$1.DeferredFileResponse.encode(g.deferredFileResponse, e.uint32(
      /* id 25, wireType 2 =*/
      202
    ).fork()).ldelim(), e;
  }, o.decode = function(g, e, t) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let c = e === void 0 ? g.len : g.pos + e, n = new $root$1.ForwardMsg();
    for (; g.pos < c; ) {
      let h = g.uint32();
      if (h === t) break;
      switch (h >>> 3) {
        case 1: {
          n.hash = g.string();
          break;
        }
        case 2: {
          n.metadata = $root$1.ForwardMsgMetadata.decode(g, g.uint32());
          break;
        }
        case 4: {
          n.newSession = $root$1.NewSession.decode(g, g.uint32());
          break;
        }
        case 5: {
          n.delta = $root$1.Delta.decode(g, g.uint32());
          break;
        }
        case 12: {
          n.pageInfoChanged = $root$1.PageInfo.decode(g, g.uint32());
          break;
        }
        case 13: {
          n.pageConfigChanged = $root$1.PageConfig.decode(g, g.uint32());
          break;
        }
        case 6: {
          n.scriptFinished = g.int32();
          break;
        }
        case 14: {
          n.gitInfoChanged = $root$1.GitInfo.decode(g, g.uint32());
          break;
        }
        case 18: {
          n.pageProfile = $root$1.PageProfile.decode(g, g.uint32());
          break;
        }
        case 9: {
          n.sessionStatusChanged = $root$1.SessionStatus.decode(g, g.uint32());
          break;
        }
        case 10: {
          n.sessionEvent = $root$1.SessionEvent.decode(g, g.uint32());
          break;
        }
        case 23: {
          n.navigation = $root$1.Navigation.decode(g, g.uint32());
          break;
        }
        case 15: {
          n.pageNotFound = $root$1.PageNotFound.decode(g, g.uint32());
          break;
        }
        case 16: {
          n.pagesChanged = $root$1.PagesChanged.decode(g, g.uint32());
          break;
        }
        case 19: {
          n.fileUrlsResponse = $root$1.FileURLsResponse.decode(g, g.uint32());
          break;
        }
        case 21: {
          n.autoRerun = $root$1.AutoRerun.decode(g, g.uint32());
          break;
        }
        case 22: {
          n.logo = $root$1.Logo.decode(g, g.uint32());
          break;
        }
        case 24: {
          n.authRedirect = $root$1.AuthRedirect.decode(g, g.uint32());
          break;
        }
        case 20: {
          n.parentMessage = $root$1.ParentMessage.decode(g, g.uint32());
          break;
        }
        case 11: {
          n.refHash = g.string();
          break;
        }
        case 25: {
          n.deferredFileResponse = $root$1.DeferredFileResponse.decode(g, g.uint32());
          break;
        }
        case 17: {
          n.debugLastBackmsgId = g.string();
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.ForwardMsg) return g;
    let e = new $root$1.ForwardMsg();
    if (g.hash != null && (e.hash = String(g.hash)), g.metadata != null) {
      if (typeof g.metadata != "object") throw TypeError(".ForwardMsg.metadata: object expected");
      e.metadata = $root$1.ForwardMsgMetadata.fromObject(g.metadata);
    }
    if (g.newSession != null) {
      if (typeof g.newSession != "object") throw TypeError(".ForwardMsg.newSession: object expected");
      e.newSession = $root$1.NewSession.fromObject(g.newSession);
    }
    if (g.delta != null) {
      if (typeof g.delta != "object") throw TypeError(".ForwardMsg.delta: object expected");
      e.delta = $root$1.Delta.fromObject(g.delta);
    }
    if (g.pageInfoChanged != null) {
      if (typeof g.pageInfoChanged != "object") throw TypeError(".ForwardMsg.pageInfoChanged: object expected");
      e.pageInfoChanged = $root$1.PageInfo.fromObject(g.pageInfoChanged);
    }
    if (g.pageConfigChanged != null) {
      if (typeof g.pageConfigChanged != "object") throw TypeError(".ForwardMsg.pageConfigChanged: object expected");
      e.pageConfigChanged = $root$1.PageConfig.fromObject(g.pageConfigChanged);
    }
    switch (g.scriptFinished) {
      default:
        if (typeof g.scriptFinished == "number") {
          e.scriptFinished = g.scriptFinished;
          break;
        }
        break;
      case "FINISHED_SUCCESSFULLY":
      case 0:
        e.scriptFinished = 0;
        break;
      case "FINISHED_WITH_COMPILE_ERROR":
      case 1:
        e.scriptFinished = 1;
        break;
      case "FINISHED_EARLY_FOR_RERUN":
      case 2:
        e.scriptFinished = 2;
        break;
      case "FINISHED_FRAGMENT_RUN_SUCCESSFULLY":
      case 3:
        e.scriptFinished = 3;
        break;
    }
    if (g.gitInfoChanged != null) {
      if (typeof g.gitInfoChanged != "object") throw TypeError(".ForwardMsg.gitInfoChanged: object expected");
      e.gitInfoChanged = $root$1.GitInfo.fromObject(g.gitInfoChanged);
    }
    if (g.pageProfile != null) {
      if (typeof g.pageProfile != "object") throw TypeError(".ForwardMsg.pageProfile: object expected");
      e.pageProfile = $root$1.PageProfile.fromObject(g.pageProfile);
    }
    if (g.sessionStatusChanged != null) {
      if (typeof g.sessionStatusChanged != "object") throw TypeError(".ForwardMsg.sessionStatusChanged: object expected");
      e.sessionStatusChanged = $root$1.SessionStatus.fromObject(g.sessionStatusChanged);
    }
    if (g.sessionEvent != null) {
      if (typeof g.sessionEvent != "object") throw TypeError(".ForwardMsg.sessionEvent: object expected");
      e.sessionEvent = $root$1.SessionEvent.fromObject(g.sessionEvent);
    }
    if (g.navigation != null) {
      if (typeof g.navigation != "object") throw TypeError(".ForwardMsg.navigation: object expected");
      e.navigation = $root$1.Navigation.fromObject(g.navigation);
    }
    if (g.pageNotFound != null) {
      if (typeof g.pageNotFound != "object") throw TypeError(".ForwardMsg.pageNotFound: object expected");
      e.pageNotFound = $root$1.PageNotFound.fromObject(g.pageNotFound);
    }
    if (g.pagesChanged != null) {
      if (typeof g.pagesChanged != "object") throw TypeError(".ForwardMsg.pagesChanged: object expected");
      e.pagesChanged = $root$1.PagesChanged.fromObject(g.pagesChanged);
    }
    if (g.fileUrlsResponse != null) {
      if (typeof g.fileUrlsResponse != "object") throw TypeError(".ForwardMsg.fileUrlsResponse: object expected");
      e.fileUrlsResponse = $root$1.FileURLsResponse.fromObject(g.fileUrlsResponse);
    }
    if (g.autoRerun != null) {
      if (typeof g.autoRerun != "object") throw TypeError(".ForwardMsg.autoRerun: object expected");
      e.autoRerun = $root$1.AutoRerun.fromObject(g.autoRerun);
    }
    if (g.logo != null) {
      if (typeof g.logo != "object") throw TypeError(".ForwardMsg.logo: object expected");
      e.logo = $root$1.Logo.fromObject(g.logo);
    }
    if (g.authRedirect != null) {
      if (typeof g.authRedirect != "object") throw TypeError(".ForwardMsg.authRedirect: object expected");
      e.authRedirect = $root$1.AuthRedirect.fromObject(g.authRedirect);
    }
    if (g.parentMessage != null) {
      if (typeof g.parentMessage != "object") throw TypeError(".ForwardMsg.parentMessage: object expected");
      e.parentMessage = $root$1.ParentMessage.fromObject(g.parentMessage);
    }
    if (g.refHash != null && (e.refHash = String(g.refHash)), g.deferredFileResponse != null) {
      if (typeof g.deferredFileResponse != "object") throw TypeError(".ForwardMsg.deferredFileResponse: object expected");
      e.deferredFileResponse = $root$1.DeferredFileResponse.fromObject(g.deferredFileResponse);
    }
    return g.debugLastBackmsgId != null && (e.debugLastBackmsgId = String(g.debugLastBackmsgId)), e;
  }, o.toObject = function(g, e) {
    e || (e = {});
    let t = {};
    return e.defaults && (t.hash = "", t.metadata = null, t.debugLastBackmsgId = ""), g.hash != null && g.hasOwnProperty("hash") && (t.hash = g.hash), g.metadata != null && g.hasOwnProperty("metadata") && (t.metadata = $root$1.ForwardMsgMetadata.toObject(g.metadata, e)), g.newSession != null && g.hasOwnProperty("newSession") && (t.newSession = $root$1.NewSession.toObject(g.newSession, e), e.oneofs && (t.type = "newSession")), g.delta != null && g.hasOwnProperty("delta") && (t.delta = $root$1.Delta.toObject(g.delta, e), e.oneofs && (t.type = "delta")), g.scriptFinished != null && g.hasOwnProperty("scriptFinished") && (t.scriptFinished = e.enums === String ? $root$1.ForwardMsg.ScriptFinishedStatus[g.scriptFinished] === void 0 ? g.scriptFinished : $root$1.ForwardMsg.ScriptFinishedStatus[g.scriptFinished] : g.scriptFinished, e.oneofs && (t.type = "scriptFinished")), g.sessionStatusChanged != null && g.hasOwnProperty("sessionStatusChanged") && (t.sessionStatusChanged = $root$1.SessionStatus.toObject(g.sessionStatusChanged, e), e.oneofs && (t.type = "sessionStatusChanged")), g.sessionEvent != null && g.hasOwnProperty("sessionEvent") && (t.sessionEvent = $root$1.SessionEvent.toObject(g.sessionEvent, e), e.oneofs && (t.type = "sessionEvent")), g.refHash != null && g.hasOwnProperty("refHash") && (t.refHash = g.refHash, e.oneofs && (t.type = "refHash")), g.pageInfoChanged != null && g.hasOwnProperty("pageInfoChanged") && (t.pageInfoChanged = $root$1.PageInfo.toObject(g.pageInfoChanged, e), e.oneofs && (t.type = "pageInfoChanged")), g.pageConfigChanged != null && g.hasOwnProperty("pageConfigChanged") && (t.pageConfigChanged = $root$1.PageConfig.toObject(g.pageConfigChanged, e), e.oneofs && (t.type = "pageConfigChanged")), g.gitInfoChanged != null && g.hasOwnProperty("gitInfoChanged") && (t.gitInfoChanged = $root$1.GitInfo.toObject(g.gitInfoChanged, e), e.oneofs && (t.type = "gitInfoChanged")), g.pageNotFound != null && g.hasOwnProperty("pageNotFound") && (t.pageNotFound = $root$1.PageNotFound.toObject(g.pageNotFound, e), e.oneofs && (t.type = "pageNotFound")), g.pagesChanged != null && g.hasOwnProperty("pagesChanged") && (t.pagesChanged = $root$1.PagesChanged.toObject(g.pagesChanged, e), e.oneofs && (t.type = "pagesChanged")), g.debugLastBackmsgId != null && g.hasOwnProperty("debugLastBackmsgId") && (t.debugLastBackmsgId = g.debugLastBackmsgId), g.pageProfile != null && g.hasOwnProperty("pageProfile") && (t.pageProfile = $root$1.PageProfile.toObject(g.pageProfile, e), e.oneofs && (t.type = "pageProfile")), g.fileUrlsResponse != null && g.hasOwnProperty("fileUrlsResponse") && (t.fileUrlsResponse = $root$1.FileURLsResponse.toObject(g.fileUrlsResponse, e), e.oneofs && (t.type = "fileUrlsResponse")), g.parentMessage != null && g.hasOwnProperty("parentMessage") && (t.parentMessage = $root$1.ParentMessage.toObject(g.parentMessage, e), e.oneofs && (t.type = "parentMessage")), g.autoRerun != null && g.hasOwnProperty("autoRerun") && (t.autoRerun = $root$1.AutoRerun.toObject(g.autoRerun, e), e.oneofs && (t.type = "autoRerun")), g.logo != null && g.hasOwnProperty("logo") && (t.logo = $root$1.Logo.toObject(g.logo, e), e.oneofs && (t.type = "logo")), g.navigation != null && g.hasOwnProperty("navigation") && (t.navigation = $root$1.Navigation.toObject(g.navigation, e), e.oneofs && (t.type = "navigation")), g.authRedirect != null && g.hasOwnProperty("authRedirect") && (t.authRedirect = $root$1.AuthRedirect.toObject(g.authRedirect, e), e.oneofs && (t.type = "authRedirect")), g.deferredFileResponse != null && g.hasOwnProperty("deferredFileResponse") && (t.deferredFileResponse = $root$1.DeferredFileResponse.toObject(g.deferredFileResponse, e), e.oneofs && (t.type = "deferredFileResponse")), t;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/ForwardMsg";
  }, o.ScriptFinishedStatus = (function() {
    const A = {}, g = Object.create(A);
    return g[A[0] = "FINISHED_SUCCESSFULLY"] = 0, g[A[1] = "FINISHED_WITH_COMPILE_ERROR"] = 1, g[A[2] = "FINISHED_EARLY_FOR_RERUN"] = 2, g[A[3] = "FINISHED_FRAGMENT_RUN_SUCCESSFULLY"] = 3, g;
  })(), o;
})();
$root$1.DeferredFileResponse = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.fileId = "", o.prototype.url = "", o.prototype.errorMsg = "", o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    return g || (g = $Writer$1.create()), A.fileId != null && Object.hasOwnProperty.call(A, "fileId") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(A.fileId), A.url != null && Object.hasOwnProperty.call(A, "url") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(A.url), A.errorMsg != null && Object.hasOwnProperty.call(A, "errorMsg") && g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(A.errorMsg), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader$1 || (A = $Reader$1.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root$1.DeferredFileResponse();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.fileId = A.string();
          break;
        }
        case 2: {
          c.url = A.string();
          break;
        }
        case 3: {
          c.errorMsg = A.string();
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root$1.DeferredFileResponse) return A;
    let g = new $root$1.DeferredFileResponse();
    return A.fileId != null && (g.fileId = String(A.fileId)), A.url != null && (g.url = String(A.url)), A.errorMsg != null && (g.errorMsg = String(A.errorMsg)), g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    return g.defaults && (e.fileId = "", e.url = "", e.errorMsg = ""), A.fileId != null && A.hasOwnProperty("fileId") && (e.fileId = A.fileId), A.url != null && A.hasOwnProperty("url") && (e.url = A.url), A.errorMsg != null && A.hasOwnProperty("errorMsg") && (e.errorMsg = A.errorMsg), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/DeferredFileResponse";
  }, o;
})();
const ForwardMsgMetadata = $root$1.ForwardMsgMetadata = (() => {
  function o(E) {
    if (this.deltaPath = [], E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.cacheable = !1, o.prototype.deltaPath = $util$1.emptyArray, o.prototype.elementDimensionSpec = null, o.prototype.activeScriptHash = "", o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    if (g || (g = $Writer$1.create()), A.cacheable != null && Object.hasOwnProperty.call(A, "cacheable") && g.uint32(
      /* id 1, wireType 0 =*/
      8
    ).bool(A.cacheable), A.deltaPath != null && A.deltaPath.length) {
      g.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork();
      for (let e = 0; e < A.deltaPath.length; ++e) g.uint32(A.deltaPath[e]);
      g.ldelim();
    }
    return A.elementDimensionSpec != null && Object.hasOwnProperty.call(A, "elementDimensionSpec") && $root$1.ElementDimensionSpec.encode(A.elementDimensionSpec, g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).fork()).ldelim(), A.activeScriptHash != null && Object.hasOwnProperty.call(A, "activeScriptHash") && g.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(A.activeScriptHash), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader$1 || (A = $Reader$1.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root$1.ForwardMsgMetadata();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.cacheable = A.bool();
          break;
        }
        case 2: {
          if (c.deltaPath && c.deltaPath.length || (c.deltaPath = []), (n & 7) === 2) {
            let h = A.uint32() + A.pos;
            for (; A.pos < h; ) c.deltaPath.push(A.uint32());
          } else c.deltaPath.push(A.uint32());
          break;
        }
        case 3: {
          c.elementDimensionSpec = $root$1.ElementDimensionSpec.decode(A, A.uint32());
          break;
        }
        case 4: {
          c.activeScriptHash = A.string();
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root$1.ForwardMsgMetadata) return A;
    let g = new $root$1.ForwardMsgMetadata();
    if (A.cacheable != null && (g.cacheable = !!A.cacheable), A.deltaPath) {
      if (!Array.isArray(A.deltaPath)) throw TypeError(".ForwardMsgMetadata.deltaPath: array expected");
      g.deltaPath = [];
      for (let e = 0; e < A.deltaPath.length; ++e) g.deltaPath[e] = A.deltaPath[e] >>> 0;
    }
    if (A.elementDimensionSpec != null) {
      if (typeof A.elementDimensionSpec != "object") throw TypeError(".ForwardMsgMetadata.elementDimensionSpec: object expected");
      g.elementDimensionSpec = $root$1.ElementDimensionSpec.fromObject(A.elementDimensionSpec);
    }
    return A.activeScriptHash != null && (g.activeScriptHash = String(A.activeScriptHash)), g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    if ((g.arrays || g.defaults) && (e.deltaPath = []), g.defaults && (e.cacheable = !1, e.elementDimensionSpec = null, e.activeScriptHash = ""), A.cacheable != null && A.hasOwnProperty("cacheable") && (e.cacheable = A.cacheable), A.deltaPath && A.deltaPath.length) {
      e.deltaPath = [];
      for (let t = 0; t < A.deltaPath.length; ++t) e.deltaPath[t] = A.deltaPath[t];
    }
    return A.elementDimensionSpec != null && A.hasOwnProperty("elementDimensionSpec") && (e.elementDimensionSpec = $root$1.ElementDimensionSpec.toObject(A.elementDimensionSpec, g)), A.activeScriptHash != null && A.hasOwnProperty("activeScriptHash") && (e.activeScriptHash = A.activeScriptHash), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/ForwardMsgMetadata";
  }, o;
})();
$root$1.ElementDimensionSpec = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.width = 0, o.prototype.height = 0, o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    return g || (g = $Writer$1.create()), A.width != null && Object.hasOwnProperty.call(A, "width") && g.uint32(
      /* id 1, wireType 0 =*/
      8
    ).uint32(A.width), A.height != null && Object.hasOwnProperty.call(A, "height") && g.uint32(
      /* id 2, wireType 0 =*/
      16
    ).uint32(A.height), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader$1 || (A = $Reader$1.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root$1.ElementDimensionSpec();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.width = A.uint32();
          break;
        }
        case 2: {
          c.height = A.uint32();
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root$1.ElementDimensionSpec) return A;
    let g = new $root$1.ElementDimensionSpec();
    return A.width != null && (g.width = A.width >>> 0), A.height != null && (g.height = A.height >>> 0), g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    return g.defaults && (e.width = 0, e.height = 0), A.width != null && A.hasOwnProperty("width") && (e.width = A.width), A.height != null && A.hasOwnProperty("height") && (e.height = A.height), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/ElementDimensionSpec";
  }, o;
})();
$root$1.ForwardMsgList = (() => {
  function o(E) {
    if (this.messages = [], E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.messages = $util$1.emptyArray, o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    if (g || (g = $Writer$1.create()), A.messages != null && A.messages.length) for (let e = 0; e < A.messages.length; ++e) $root$1.ForwardMsg.encode(A.messages[e], g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim();
    return g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader$1 || (A = $Reader$1.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root$1.ForwardMsgList();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.messages && c.messages.length || (c.messages = []), c.messages.push($root$1.ForwardMsg.decode(A, A.uint32()));
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root$1.ForwardMsgList) return A;
    let g = new $root$1.ForwardMsgList();
    if (A.messages) {
      if (!Array.isArray(A.messages)) throw TypeError(".ForwardMsgList.messages: array expected");
      g.messages = [];
      for (let e = 0; e < A.messages.length; ++e) {
        if (typeof A.messages[e] != "object") throw TypeError(".ForwardMsgList.messages: object expected");
        g.messages[e] = $root$1.ForwardMsg.fromObject(A.messages[e]);
      }
    }
    return g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    if ((g.arrays || g.defaults) && (e.messages = []), A.messages && A.messages.length) {
      e.messages = [];
      for (let t = 0; t < A.messages.length; ++t) e.messages[t] = $root$1.ForwardMsg.toObject(A.messages[t], g);
    }
    return e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/ForwardMsgList";
  }, o;
})();
const GitInfo = $root$1.GitInfo = (() => {
  function o(E) {
    if (this.untrackedFiles = [], this.uncommittedFiles = [], E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.repository = "", o.prototype.branch = "", o.prototype.module = "", o.prototype.untrackedFiles = $util$1.emptyArray, o.prototype.uncommittedFiles = $util$1.emptyArray, o.prototype.state = 0, o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    if (g || (g = $Writer$1.create()), A.repository != null && Object.hasOwnProperty.call(A, "repository") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(A.repository), A.branch != null && Object.hasOwnProperty.call(A, "branch") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(A.branch), A.module != null && Object.hasOwnProperty.call(A, "module") && g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(A.module), A.untrackedFiles != null && A.untrackedFiles.length) for (let e = 0; e < A.untrackedFiles.length; ++e) g.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(A.untrackedFiles[e]);
    if (A.uncommittedFiles != null && A.uncommittedFiles.length) for (let e = 0; e < A.uncommittedFiles.length; ++e) g.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(A.uncommittedFiles[e]);
    return A.state != null && Object.hasOwnProperty.call(A, "state") && g.uint32(
      /* id 6, wireType 0 =*/
      48
    ).int32(A.state), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader$1 || (A = $Reader$1.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root$1.GitInfo();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.repository = A.string();
          break;
        }
        case 2: {
          c.branch = A.string();
          break;
        }
        case 3: {
          c.module = A.string();
          break;
        }
        case 4: {
          c.untrackedFiles && c.untrackedFiles.length || (c.untrackedFiles = []), c.untrackedFiles.push(A.string());
          break;
        }
        case 5: {
          c.uncommittedFiles && c.uncommittedFiles.length || (c.uncommittedFiles = []), c.uncommittedFiles.push(A.string());
          break;
        }
        case 6: {
          c.state = A.int32();
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root$1.GitInfo) return A;
    let g = new $root$1.GitInfo();
    if (A.repository != null && (g.repository = String(A.repository)), A.branch != null && (g.branch = String(A.branch)), A.module != null && (g.module = String(A.module)), A.untrackedFiles) {
      if (!Array.isArray(A.untrackedFiles)) throw TypeError(".GitInfo.untrackedFiles: array expected");
      g.untrackedFiles = [];
      for (let e = 0; e < A.untrackedFiles.length; ++e) g.untrackedFiles[e] = String(A.untrackedFiles[e]);
    }
    if (A.uncommittedFiles) {
      if (!Array.isArray(A.uncommittedFiles)) throw TypeError(".GitInfo.uncommittedFiles: array expected");
      g.uncommittedFiles = [];
      for (let e = 0; e < A.uncommittedFiles.length; ++e) g.uncommittedFiles[e] = String(A.uncommittedFiles[e]);
    }
    switch (A.state) {
      default:
        if (typeof A.state == "number") {
          g.state = A.state;
          break;
        }
        break;
      case "DEFAULT":
      case 0:
        g.state = 0;
        break;
      case "HEAD_DETACHED":
      case 1:
        g.state = 1;
        break;
      case "AHEAD_OF_REMOTE":
      case 2:
        g.state = 2;
        break;
    }
    return g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    if ((g.arrays || g.defaults) && (e.untrackedFiles = [], e.uncommittedFiles = []), g.defaults && (e.repository = "", e.branch = "", e.module = "", e.state = g.enums === String ? "DEFAULT" : 0), A.repository != null && A.hasOwnProperty("repository") && (e.repository = A.repository), A.branch != null && A.hasOwnProperty("branch") && (e.branch = A.branch), A.module != null && A.hasOwnProperty("module") && (e.module = A.module), A.untrackedFiles && A.untrackedFiles.length) {
      e.untrackedFiles = [];
      for (let t = 0; t < A.untrackedFiles.length; ++t) e.untrackedFiles[t] = A.untrackedFiles[t];
    }
    if (A.uncommittedFiles && A.uncommittedFiles.length) {
      e.uncommittedFiles = [];
      for (let t = 0; t < A.uncommittedFiles.length; ++t) e.uncommittedFiles[t] = A.uncommittedFiles[t];
    }
    return A.state != null && A.hasOwnProperty("state") && (e.state = g.enums === String ? $root$1.GitInfo.GitStates[A.state] === void 0 ? A.state : $root$1.GitInfo.GitStates[A.state] : A.state), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/GitInfo";
  }, o.GitStates = (function() {
    const E = {}, A = Object.create(E);
    return A[E[0] = "DEFAULT"] = 0, A[E[1] = "HEAD_DETACHED"] = 1, A[E[2] = "AHEAD_OF_REMOTE"] = 2, A;
  })(), o;
})();
$root$1.Logo = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.image = "", o.prototype.link = "", o.prototype.iconImage = "", o.prototype.size = "", o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    return g || (g = $Writer$1.create()), A.image != null && Object.hasOwnProperty.call(A, "image") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(A.image), A.link != null && Object.hasOwnProperty.call(A, "link") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(A.link), A.iconImage != null && Object.hasOwnProperty.call(A, "iconImage") && g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(A.iconImage), A.size != null && Object.hasOwnProperty.call(A, "size") && g.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(A.size), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader$1 || (A = $Reader$1.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root$1.Logo();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.image = A.string();
          break;
        }
        case 2: {
          c.link = A.string();
          break;
        }
        case 3: {
          c.iconImage = A.string();
          break;
        }
        case 4: {
          c.size = A.string();
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root$1.Logo) return A;
    let g = new $root$1.Logo();
    return A.image != null && (g.image = String(A.image)), A.link != null && (g.link = String(A.link)), A.iconImage != null && (g.iconImage = String(A.iconImage)), A.size != null && (g.size = String(A.size)), g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    return g.defaults && (e.image = "", e.link = "", e.iconImage = "", e.size = ""), A.image != null && A.hasOwnProperty("image") && (e.image = A.image), A.link != null && A.hasOwnProperty("link") && (e.link = A.link), A.iconImage != null && A.hasOwnProperty("iconImage") && (e.iconImage = A.iconImage), A.size != null && A.hasOwnProperty("size") && (e.size = A.size), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/Logo";
  }, o;
})();
const Navigation = $root$1.Navigation = (() => {
  function o(E) {
    if (this.sections = [], this.appPages = [], E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.sections = $util$1.emptyArray, o.prototype.appPages = $util$1.emptyArray, o.prototype.position = 0, o.prototype.pageScriptHash = "", o.prototype.expanded = !1, o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    if (g || (g = $Writer$1.create()), A.sections != null && A.sections.length) for (let e = 0; e < A.sections.length; ++e) g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(A.sections[e]);
    if (A.appPages != null && A.appPages.length) for (let e = 0; e < A.appPages.length; ++e) $root$1.AppPage.encode(A.appPages[e], g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim();
    return A.position != null && Object.hasOwnProperty.call(A, "position") && g.uint32(
      /* id 3, wireType 0 =*/
      24
    ).int32(A.position), A.pageScriptHash != null && Object.hasOwnProperty.call(A, "pageScriptHash") && g.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(A.pageScriptHash), A.expanded != null && Object.hasOwnProperty.call(A, "expanded") && g.uint32(
      /* id 5, wireType 0 =*/
      40
    ).bool(A.expanded), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader$1 || (A = $Reader$1.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root$1.Navigation();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.sections && c.sections.length || (c.sections = []), c.sections.push(A.string());
          break;
        }
        case 2: {
          c.appPages && c.appPages.length || (c.appPages = []), c.appPages.push($root$1.AppPage.decode(A, A.uint32()));
          break;
        }
        case 3: {
          c.position = A.int32();
          break;
        }
        case 4: {
          c.pageScriptHash = A.string();
          break;
        }
        case 5: {
          c.expanded = A.bool();
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root$1.Navigation) return A;
    let g = new $root$1.Navigation();
    if (A.sections) {
      if (!Array.isArray(A.sections)) throw TypeError(".Navigation.sections: array expected");
      g.sections = [];
      for (let e = 0; e < A.sections.length; ++e) g.sections[e] = String(A.sections[e]);
    }
    if (A.appPages) {
      if (!Array.isArray(A.appPages)) throw TypeError(".Navigation.appPages: array expected");
      g.appPages = [];
      for (let e = 0; e < A.appPages.length; ++e) {
        if (typeof A.appPages[e] != "object") throw TypeError(".Navigation.appPages: object expected");
        g.appPages[e] = $root$1.AppPage.fromObject(A.appPages[e]);
      }
    }
    switch (A.position) {
      default:
        if (typeof A.position == "number") {
          g.position = A.position;
          break;
        }
        break;
      case "HIDDEN":
      case 0:
        g.position = 0;
        break;
      case "SIDEBAR":
      case 1:
        g.position = 1;
        break;
      case "TOP":
      case 2:
        g.position = 2;
        break;
    }
    return A.pageScriptHash != null && (g.pageScriptHash = String(A.pageScriptHash)), A.expanded != null && (g.expanded = !!A.expanded), g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    if ((g.arrays || g.defaults) && (e.sections = [], e.appPages = []), g.defaults && (e.position = g.enums === String ? "HIDDEN" : 0, e.pageScriptHash = "", e.expanded = !1), A.sections && A.sections.length) {
      e.sections = [];
      for (let t = 0; t < A.sections.length; ++t) e.sections[t] = A.sections[t];
    }
    if (A.appPages && A.appPages.length) {
      e.appPages = [];
      for (let t = 0; t < A.appPages.length; ++t) e.appPages[t] = $root$1.AppPage.toObject(A.appPages[t], g);
    }
    return A.position != null && A.hasOwnProperty("position") && (e.position = g.enums === String ? $root$1.Navigation.Position[A.position] === void 0 ? A.position : $root$1.Navigation.Position[A.position] : A.position), A.pageScriptHash != null && A.hasOwnProperty("pageScriptHash") && (e.pageScriptHash = A.pageScriptHash), A.expanded != null && A.hasOwnProperty("expanded") && (e.expanded = A.expanded), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/Navigation";
  }, o.Position = (function() {
    const E = {}, A = Object.create(E);
    return A[E[0] = "HIDDEN"] = 0, A[E[1] = "SIDEBAR"] = 1, A[E[2] = "TOP"] = 2, A;
  })(), o;
})();
$root$1.NewSession = (() => {
  function o(E) {
    if (this.appPages = [], this.fragmentIdsThisRun = [], E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.initialize = null, o.prototype.scriptRunId = "", o.prototype.name = "", o.prototype.mainScriptPath = "", o.prototype.config = null, o.prototype.customTheme = null, o.prototype.appPages = $util$1.emptyArray, o.prototype.pageScriptHash = "", o.prototype.fragmentIdsThisRun = $util$1.emptyArray, o.prototype.mainScriptHash = "", o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    if (g || (g = $Writer$1.create()), A.initialize != null && Object.hasOwnProperty.call(A, "initialize") && $root$1.Initialize.encode(A.initialize, g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim(), A.scriptRunId != null && Object.hasOwnProperty.call(A, "scriptRunId") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(A.scriptRunId), A.name != null && Object.hasOwnProperty.call(A, "name") && g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(A.name), A.mainScriptPath != null && Object.hasOwnProperty.call(A, "mainScriptPath") && g.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(A.mainScriptPath), A.config != null && Object.hasOwnProperty.call(A, "config") && $root$1.Config.encode(A.config, g.uint32(
      /* id 6, wireType 2 =*/
      50
    ).fork()).ldelim(), A.customTheme != null && Object.hasOwnProperty.call(A, "customTheme") && $root$1.CustomThemeConfig.encode(A.customTheme, g.uint32(
      /* id 7, wireType 2 =*/
      58
    ).fork()).ldelim(), A.appPages != null && A.appPages.length) for (let e = 0; e < A.appPages.length; ++e) $root$1.AppPage.encode(A.appPages[e], g.uint32(
      /* id 8, wireType 2 =*/
      66
    ).fork()).ldelim();
    if (A.pageScriptHash != null && Object.hasOwnProperty.call(A, "pageScriptHash") && g.uint32(
      /* id 9, wireType 2 =*/
      74
    ).string(A.pageScriptHash), A.fragmentIdsThisRun != null && A.fragmentIdsThisRun.length) for (let e = 0; e < A.fragmentIdsThisRun.length; ++e) g.uint32(
      /* id 10, wireType 2 =*/
      82
    ).string(A.fragmentIdsThisRun[e]);
    return A.mainScriptHash != null && Object.hasOwnProperty.call(A, "mainScriptHash") && g.uint32(
      /* id 11, wireType 2 =*/
      90
    ).string(A.mainScriptHash), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader$1 || (A = $Reader$1.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root$1.NewSession();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.initialize = $root$1.Initialize.decode(A, A.uint32());
          break;
        }
        case 2: {
          c.scriptRunId = A.string();
          break;
        }
        case 3: {
          c.name = A.string();
          break;
        }
        case 4: {
          c.mainScriptPath = A.string();
          break;
        }
        case 6: {
          c.config = $root$1.Config.decode(A, A.uint32());
          break;
        }
        case 7: {
          c.customTheme = $root$1.CustomThemeConfig.decode(A, A.uint32());
          break;
        }
        case 8: {
          c.appPages && c.appPages.length || (c.appPages = []), c.appPages.push($root$1.AppPage.decode(A, A.uint32()));
          break;
        }
        case 9: {
          c.pageScriptHash = A.string();
          break;
        }
        case 10: {
          c.fragmentIdsThisRun && c.fragmentIdsThisRun.length || (c.fragmentIdsThisRun = []), c.fragmentIdsThisRun.push(A.string());
          break;
        }
        case 11: {
          c.mainScriptHash = A.string();
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root$1.NewSession) return A;
    let g = new $root$1.NewSession();
    if (A.initialize != null) {
      if (typeof A.initialize != "object") throw TypeError(".NewSession.initialize: object expected");
      g.initialize = $root$1.Initialize.fromObject(A.initialize);
    }
    if (A.scriptRunId != null && (g.scriptRunId = String(A.scriptRunId)), A.name != null && (g.name = String(A.name)), A.mainScriptPath != null && (g.mainScriptPath = String(A.mainScriptPath)), A.config != null) {
      if (typeof A.config != "object") throw TypeError(".NewSession.config: object expected");
      g.config = $root$1.Config.fromObject(A.config);
    }
    if (A.customTheme != null) {
      if (typeof A.customTheme != "object") throw TypeError(".NewSession.customTheme: object expected");
      g.customTheme = $root$1.CustomThemeConfig.fromObject(A.customTheme);
    }
    if (A.appPages) {
      if (!Array.isArray(A.appPages)) throw TypeError(".NewSession.appPages: array expected");
      g.appPages = [];
      for (let e = 0; e < A.appPages.length; ++e) {
        if (typeof A.appPages[e] != "object") throw TypeError(".NewSession.appPages: object expected");
        g.appPages[e] = $root$1.AppPage.fromObject(A.appPages[e]);
      }
    }
    if (A.pageScriptHash != null && (g.pageScriptHash = String(A.pageScriptHash)), A.fragmentIdsThisRun) {
      if (!Array.isArray(A.fragmentIdsThisRun)) throw TypeError(".NewSession.fragmentIdsThisRun: array expected");
      g.fragmentIdsThisRun = [];
      for (let e = 0; e < A.fragmentIdsThisRun.length; ++e) g.fragmentIdsThisRun[e] = String(A.fragmentIdsThisRun[e]);
    }
    return A.mainScriptHash != null && (g.mainScriptHash = String(A.mainScriptHash)), g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    if ((g.arrays || g.defaults) && (e.appPages = [], e.fragmentIdsThisRun = []), g.defaults && (e.initialize = null, e.scriptRunId = "", e.name = "", e.mainScriptPath = "", e.config = null, e.customTheme = null, e.pageScriptHash = "", e.mainScriptHash = ""), A.initialize != null && A.hasOwnProperty("initialize") && (e.initialize = $root$1.Initialize.toObject(A.initialize, g)), A.scriptRunId != null && A.hasOwnProperty("scriptRunId") && (e.scriptRunId = A.scriptRunId), A.name != null && A.hasOwnProperty("name") && (e.name = A.name), A.mainScriptPath != null && A.hasOwnProperty("mainScriptPath") && (e.mainScriptPath = A.mainScriptPath), A.config != null && A.hasOwnProperty("config") && (e.config = $root$1.Config.toObject(A.config, g)), A.customTheme != null && A.hasOwnProperty("customTheme") && (e.customTheme = $root$1.CustomThemeConfig.toObject(A.customTheme, g)), A.appPages && A.appPages.length) {
      e.appPages = [];
      for (let t = 0; t < A.appPages.length; ++t) e.appPages[t] = $root$1.AppPage.toObject(A.appPages[t], g);
    }
    if (A.pageScriptHash != null && A.hasOwnProperty("pageScriptHash") && (e.pageScriptHash = A.pageScriptHash), A.fragmentIdsThisRun && A.fragmentIdsThisRun.length) {
      e.fragmentIdsThisRun = [];
      for (let t = 0; t < A.fragmentIdsThisRun.length; ++t) e.fragmentIdsThisRun[t] = A.fragmentIdsThisRun[t];
    }
    return A.mainScriptHash != null && A.hasOwnProperty("mainScriptHash") && (e.mainScriptHash = A.mainScriptHash), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/NewSession";
  }, o;
})();
$root$1.Initialize = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.userInfo = null, o.prototype.environmentInfo = null, o.prototype.sessionStatus = null, o.prototype.commandLine = "", o.prototype.sessionId = "", o.prototype.isHello = !1, o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    return g || (g = $Writer$1.create()), A.userInfo != null && Object.hasOwnProperty.call(A, "userInfo") && $root$1.UserInfo.encode(A.userInfo, g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim(), A.environmentInfo != null && Object.hasOwnProperty.call(A, "environmentInfo") && $root$1.EnvironmentInfo.encode(A.environmentInfo, g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).fork()).ldelim(), A.sessionStatus != null && Object.hasOwnProperty.call(A, "sessionStatus") && $root$1.SessionStatus.encode(A.sessionStatus, g.uint32(
      /* id 4, wireType 2 =*/
      34
    ).fork()).ldelim(), A.commandLine != null && Object.hasOwnProperty.call(A, "commandLine") && g.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(A.commandLine), A.sessionId != null && Object.hasOwnProperty.call(A, "sessionId") && g.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(A.sessionId), A.isHello != null && Object.hasOwnProperty.call(A, "isHello") && g.uint32(
      /* id 7, wireType 0 =*/
      56
    ).bool(A.isHello), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader$1 || (A = $Reader$1.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root$1.Initialize();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.userInfo = $root$1.UserInfo.decode(A, A.uint32());
          break;
        }
        case 3: {
          c.environmentInfo = $root$1.EnvironmentInfo.decode(A, A.uint32());
          break;
        }
        case 4: {
          c.sessionStatus = $root$1.SessionStatus.decode(A, A.uint32());
          break;
        }
        case 5: {
          c.commandLine = A.string();
          break;
        }
        case 6: {
          c.sessionId = A.string();
          break;
        }
        case 7: {
          c.isHello = A.bool();
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root$1.Initialize) return A;
    let g = new $root$1.Initialize();
    if (A.userInfo != null) {
      if (typeof A.userInfo != "object") throw TypeError(".Initialize.userInfo: object expected");
      g.userInfo = $root$1.UserInfo.fromObject(A.userInfo);
    }
    if (A.environmentInfo != null) {
      if (typeof A.environmentInfo != "object") throw TypeError(".Initialize.environmentInfo: object expected");
      g.environmentInfo = $root$1.EnvironmentInfo.fromObject(A.environmentInfo);
    }
    if (A.sessionStatus != null) {
      if (typeof A.sessionStatus != "object") throw TypeError(".Initialize.sessionStatus: object expected");
      g.sessionStatus = $root$1.SessionStatus.fromObject(A.sessionStatus);
    }
    return A.commandLine != null && (g.commandLine = String(A.commandLine)), A.sessionId != null && (g.sessionId = String(A.sessionId)), A.isHello != null && (g.isHello = !!A.isHello), g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    return g.defaults && (e.userInfo = null, e.environmentInfo = null, e.sessionStatus = null, e.commandLine = "", e.sessionId = "", e.isHello = !1), A.userInfo != null && A.hasOwnProperty("userInfo") && (e.userInfo = $root$1.UserInfo.toObject(A.userInfo, g)), A.environmentInfo != null && A.hasOwnProperty("environmentInfo") && (e.environmentInfo = $root$1.EnvironmentInfo.toObject(A.environmentInfo, g)), A.sessionStatus != null && A.hasOwnProperty("sessionStatus") && (e.sessionStatus = $root$1.SessionStatus.toObject(A.sessionStatus, g)), A.commandLine != null && A.hasOwnProperty("commandLine") && (e.commandLine = A.commandLine), A.sessionId != null && A.hasOwnProperty("sessionId") && (e.sessionId = A.sessionId), A.isHello != null && A.hasOwnProperty("isHello") && (e.isHello = A.isHello), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/Initialize";
  }, o;
})();
const Config = $root$1.Config = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.gatherUsageStats = !1, o.prototype.maxCachedMessageAge = 0, o.prototype.mapboxToken = "", o.prototype.allowRunOnSave = !1, o.prototype.hideTopBar = !1, o.prototype.hideSidebarNav = !1, o.prototype.toolbarMode = 0, o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    return g || (g = $Writer$1.create()), A.gatherUsageStats != null && Object.hasOwnProperty.call(A, "gatherUsageStats") && g.uint32(
      /* id 2, wireType 0 =*/
      16
    ).bool(A.gatherUsageStats), A.maxCachedMessageAge != null && Object.hasOwnProperty.call(A, "maxCachedMessageAge") && g.uint32(
      /* id 3, wireType 0 =*/
      24
    ).int32(A.maxCachedMessageAge), A.mapboxToken != null && Object.hasOwnProperty.call(A, "mapboxToken") && g.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(A.mapboxToken), A.allowRunOnSave != null && Object.hasOwnProperty.call(A, "allowRunOnSave") && g.uint32(
      /* id 5, wireType 0 =*/
      40
    ).bool(A.allowRunOnSave), A.hideTopBar != null && Object.hasOwnProperty.call(A, "hideTopBar") && g.uint32(
      /* id 6, wireType 0 =*/
      48
    ).bool(A.hideTopBar), A.hideSidebarNav != null && Object.hasOwnProperty.call(A, "hideSidebarNav") && g.uint32(
      /* id 7, wireType 0 =*/
      56
    ).bool(A.hideSidebarNav), A.toolbarMode != null && Object.hasOwnProperty.call(A, "toolbarMode") && g.uint32(
      /* id 8, wireType 0 =*/
      64
    ).int32(A.toolbarMode), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader$1 || (A = $Reader$1.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root$1.Config();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 2: {
          c.gatherUsageStats = A.bool();
          break;
        }
        case 3: {
          c.maxCachedMessageAge = A.int32();
          break;
        }
        case 4: {
          c.mapboxToken = A.string();
          break;
        }
        case 5: {
          c.allowRunOnSave = A.bool();
          break;
        }
        case 6: {
          c.hideTopBar = A.bool();
          break;
        }
        case 7: {
          c.hideSidebarNav = A.bool();
          break;
        }
        case 8: {
          c.toolbarMode = A.int32();
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root$1.Config) return A;
    let g = new $root$1.Config();
    switch (A.gatherUsageStats != null && (g.gatherUsageStats = !!A.gatherUsageStats), A.maxCachedMessageAge != null && (g.maxCachedMessageAge = A.maxCachedMessageAge | 0), A.mapboxToken != null && (g.mapboxToken = String(A.mapboxToken)), A.allowRunOnSave != null && (g.allowRunOnSave = !!A.allowRunOnSave), A.hideTopBar != null && (g.hideTopBar = !!A.hideTopBar), A.hideSidebarNav != null && (g.hideSidebarNav = !!A.hideSidebarNav), A.toolbarMode) {
      default:
        if (typeof A.toolbarMode == "number") {
          g.toolbarMode = A.toolbarMode;
          break;
        }
        break;
      case "AUTO":
      case 0:
        g.toolbarMode = 0;
        break;
      case "DEVELOPER":
      case 1:
        g.toolbarMode = 1;
        break;
      case "VIEWER":
      case 2:
        g.toolbarMode = 2;
        break;
      case "MINIMAL":
      case 3:
        g.toolbarMode = 3;
        break;
    }
    return g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    return g.defaults && (e.gatherUsageStats = !1, e.maxCachedMessageAge = 0, e.mapboxToken = "", e.allowRunOnSave = !1, e.hideTopBar = !1, e.hideSidebarNav = !1, e.toolbarMode = g.enums === String ? "AUTO" : 0), A.gatherUsageStats != null && A.hasOwnProperty("gatherUsageStats") && (e.gatherUsageStats = A.gatherUsageStats), A.maxCachedMessageAge != null && A.hasOwnProperty("maxCachedMessageAge") && (e.maxCachedMessageAge = A.maxCachedMessageAge), A.mapboxToken != null && A.hasOwnProperty("mapboxToken") && (e.mapboxToken = A.mapboxToken), A.allowRunOnSave != null && A.hasOwnProperty("allowRunOnSave") && (e.allowRunOnSave = A.allowRunOnSave), A.hideTopBar != null && A.hasOwnProperty("hideTopBar") && (e.hideTopBar = A.hideTopBar), A.hideSidebarNav != null && A.hasOwnProperty("hideSidebarNav") && (e.hideSidebarNav = A.hideSidebarNav), A.toolbarMode != null && A.hasOwnProperty("toolbarMode") && (e.toolbarMode = g.enums === String ? $root$1.Config.ToolbarMode[A.toolbarMode] === void 0 ? A.toolbarMode : $root$1.Config.ToolbarMode[A.toolbarMode] : A.toolbarMode), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/Config";
  }, o.ToolbarMode = (function() {
    const E = {}, A = Object.create(E);
    return A[E[0] = "AUTO"] = 0, A[E[1] = "DEVELOPER"] = 1, A[E[2] = "VIEWER"] = 2, A[E[3] = "MINIMAL"] = 3, A;
  })(), o;
})(), CustomThemeConfig = $root$1.CustomThemeConfig = (() => {
  function o(A) {
    if (this.fontFaces = [], this.fontSources = [], this.headingFontSizes = [], this.headingFontWeights = [], this.chartCategoricalColors = [], this.chartSequentialColors = [], A) for (let g = Object.keys(A), e = 0; e < g.length; ++e) A[g[e]] != null && (this[g[e]] = A[g[e]]);
  }
  o.prototype.primaryColor = "", o.prototype.secondaryBackgroundColor = "", o.prototype.backgroundColor = "", o.prototype.textColor = "", o.prototype.font = 0, o.prototype.base = 0, o.prototype.widgetBackgroundColor = "", o.prototype.widgetBorderColor = "", o.prototype.radii = null, o.prototype.headingFont = "", o.prototype.bodyFont = "", o.prototype.codeFont = "", o.prototype.fontFaces = $util$1.emptyArray, o.prototype.fontSources = $util$1.emptyArray, o.prototype.fontSizes = null, o.prototype.skeletonBackgroundColor = "", o.prototype.baseRadius = null, o.prototype.buttonRadius = null, o.prototype.borderColor = null, o.prototype.dataframeBorderColor = null, o.prototype.showWidgetBorder = null, o.prototype.linkColor = null, o.prototype.linkUnderline = null, o.prototype.baseFontSize = null, o.prototype.baseFontWeight = null, o.prototype.codeFontWeight = null, o.prototype.codeFontSize = null, o.prototype.headingFontSizes = $util$1.emptyArray, o.prototype.headingFontWeights = $util$1.emptyArray, o.prototype.showSidebarBorder = null, o.prototype.codeTextColor = null, o.prototype.codeBackgroundColor = null, o.prototype.dataframeHeaderBackgroundColor = null, o.prototype.chartCategoricalColors = $util$1.emptyArray, o.prototype.chartSequentialColors = $util$1.emptyArray, o.prototype.redColor = null, o.prototype.orangeColor = null, o.prototype.yellowColor = null, o.prototype.blueColor = null, o.prototype.greenColor = null, o.prototype.violetColor = null, o.prototype.grayColor = null, o.prototype.redBackgroundColor = null, o.prototype.orangeBackgroundColor = null, o.prototype.yellowBackgroundColor = null, o.prototype.blueBackgroundColor = null, o.prototype.greenBackgroundColor = null, o.prototype.violetBackgroundColor = null, o.prototype.grayBackgroundColor = null, o.prototype.redTextColor = null, o.prototype.orangeTextColor = null, o.prototype.yellowTextColor = null, o.prototype.blueTextColor = null, o.prototype.greenTextColor = null, o.prototype.violetTextColor = null, o.prototype.grayTextColor = null, o.prototype.sidebar = null, o.prototype.light = null, o.prototype.dark = null;
  let E;
  return Object.defineProperty(o.prototype, "_baseRadius", { get: $util$1.oneOfGetter(E = ["baseRadius"]), set: $util$1.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_buttonRadius", { get: $util$1.oneOfGetter(E = ["buttonRadius"]), set: $util$1.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_borderColor", { get: $util$1.oneOfGetter(E = ["borderColor"]), set: $util$1.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_dataframeBorderColor", { get: $util$1.oneOfGetter(E = ["dataframeBorderColor"]), set: $util$1.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_showWidgetBorder", { get: $util$1.oneOfGetter(E = ["showWidgetBorder"]), set: $util$1.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_linkColor", { get: $util$1.oneOfGetter(E = ["linkColor"]), set: $util$1.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_linkUnderline", { get: $util$1.oneOfGetter(E = ["linkUnderline"]), set: $util$1.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_baseFontSize", { get: $util$1.oneOfGetter(E = ["baseFontSize"]), set: $util$1.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_baseFontWeight", { get: $util$1.oneOfGetter(E = ["baseFontWeight"]), set: $util$1.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_codeFontWeight", { get: $util$1.oneOfGetter(E = ["codeFontWeight"]), set: $util$1.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_codeFontSize", { get: $util$1.oneOfGetter(E = ["codeFontSize"]), set: $util$1.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_showSidebarBorder", { get: $util$1.oneOfGetter(E = ["showSidebarBorder"]), set: $util$1.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_codeTextColor", { get: $util$1.oneOfGetter(E = ["codeTextColor"]), set: $util$1.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_codeBackgroundColor", { get: $util$1.oneOfGetter(E = ["codeBackgroundColor"]), set: $util$1.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_dataframeHeaderBackgroundColor", { get: $util$1.oneOfGetter(E = ["dataframeHeaderBackgroundColor"]), set: $util$1.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_redColor", { get: $util$1.oneOfGetter(E = ["redColor"]), set: $util$1.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_orangeColor", { get: $util$1.oneOfGetter(E = ["orangeColor"]), set: $util$1.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_yellowColor", { get: $util$1.oneOfGetter(E = ["yellowColor"]), set: $util$1.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_blueColor", { get: $util$1.oneOfGetter(E = ["blueColor"]), set: $util$1.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_greenColor", { get: $util$1.oneOfGetter(E = ["greenColor"]), set: $util$1.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_violetColor", { get: $util$1.oneOfGetter(E = ["violetColor"]), set: $util$1.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_grayColor", { get: $util$1.oneOfGetter(E = ["grayColor"]), set: $util$1.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_redBackgroundColor", { get: $util$1.oneOfGetter(E = ["redBackgroundColor"]), set: $util$1.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_orangeBackgroundColor", { get: $util$1.oneOfGetter(E = ["orangeBackgroundColor"]), set: $util$1.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_yellowBackgroundColor", { get: $util$1.oneOfGetter(E = ["yellowBackgroundColor"]), set: $util$1.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_blueBackgroundColor", { get: $util$1.oneOfGetter(E = ["blueBackgroundColor"]), set: $util$1.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_greenBackgroundColor", { get: $util$1.oneOfGetter(E = ["greenBackgroundColor"]), set: $util$1.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_violetBackgroundColor", { get: $util$1.oneOfGetter(E = ["violetBackgroundColor"]), set: $util$1.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_grayBackgroundColor", { get: $util$1.oneOfGetter(E = ["grayBackgroundColor"]), set: $util$1.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_redTextColor", { get: $util$1.oneOfGetter(E = ["redTextColor"]), set: $util$1.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_orangeTextColor", { get: $util$1.oneOfGetter(E = ["orangeTextColor"]), set: $util$1.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_yellowTextColor", { get: $util$1.oneOfGetter(E = ["yellowTextColor"]), set: $util$1.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_blueTextColor", { get: $util$1.oneOfGetter(E = ["blueTextColor"]), set: $util$1.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_greenTextColor", { get: $util$1.oneOfGetter(E = ["greenTextColor"]), set: $util$1.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_violetTextColor", { get: $util$1.oneOfGetter(E = ["violetTextColor"]), set: $util$1.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_grayTextColor", { get: $util$1.oneOfGetter(E = ["grayTextColor"]), set: $util$1.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_sidebar", { get: $util$1.oneOfGetter(E = ["sidebar"]), set: $util$1.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_light", { get: $util$1.oneOfGetter(E = ["light"]), set: $util$1.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_dark", { get: $util$1.oneOfGetter(E = ["dark"]), set: $util$1.oneOfSetter(E) }), o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, e) {
    if (e || (e = $Writer$1.create()), g.primaryColor != null && Object.hasOwnProperty.call(g, "primaryColor") && e.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.primaryColor), g.secondaryBackgroundColor != null && Object.hasOwnProperty.call(g, "secondaryBackgroundColor") && e.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.secondaryBackgroundColor), g.backgroundColor != null && Object.hasOwnProperty.call(g, "backgroundColor") && e.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(g.backgroundColor), g.textColor != null && Object.hasOwnProperty.call(g, "textColor") && e.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(g.textColor), g.font != null && Object.hasOwnProperty.call(g, "font") && e.uint32(
      /* id 5, wireType 0 =*/
      40
    ).int32(g.font), g.base != null && Object.hasOwnProperty.call(g, "base") && e.uint32(
      /* id 6, wireType 0 =*/
      48
    ).int32(g.base), g.widgetBackgroundColor != null && Object.hasOwnProperty.call(g, "widgetBackgroundColor") && e.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(g.widgetBackgroundColor), g.widgetBorderColor != null && Object.hasOwnProperty.call(g, "widgetBorderColor") && e.uint32(
      /* id 8, wireType 2 =*/
      66
    ).string(g.widgetBorderColor), g.radii != null && Object.hasOwnProperty.call(g, "radii") && $root$1.Radii.encode(g.radii, e.uint32(
      /* id 9, wireType 2 =*/
      74
    ).fork()).ldelim(), g.headingFont != null && Object.hasOwnProperty.call(g, "headingFont") && e.uint32(
      /* id 12, wireType 2 =*/
      98
    ).string(g.headingFont), g.bodyFont != null && Object.hasOwnProperty.call(g, "bodyFont") && e.uint32(
      /* id 13, wireType 2 =*/
      106
    ).string(g.bodyFont), g.codeFont != null && Object.hasOwnProperty.call(g, "codeFont") && e.uint32(
      /* id 14, wireType 2 =*/
      114
    ).string(g.codeFont), g.fontFaces != null && g.fontFaces.length) for (let t = 0; t < g.fontFaces.length; ++t) $root$1.FontFace.encode(g.fontFaces[t], e.uint32(
      /* id 15, wireType 2 =*/
      122
    ).fork()).ldelim();
    if (g.fontSizes != null && Object.hasOwnProperty.call(g, "fontSizes") && $root$1.FontSizes.encode(g.fontSizes, e.uint32(
      /* id 16, wireType 2 =*/
      130
    ).fork()).ldelim(), g.skeletonBackgroundColor != null && Object.hasOwnProperty.call(g, "skeletonBackgroundColor") && e.uint32(
      /* id 17, wireType 2 =*/
      138
    ).string(g.skeletonBackgroundColor), g.baseRadius != null && Object.hasOwnProperty.call(g, "baseRadius") && e.uint32(
      /* id 18, wireType 2 =*/
      146
    ).string(g.baseRadius), g.borderColor != null && Object.hasOwnProperty.call(g, "borderColor") && e.uint32(
      /* id 19, wireType 2 =*/
      154
    ).string(g.borderColor), g.showWidgetBorder != null && Object.hasOwnProperty.call(g, "showWidgetBorder") && e.uint32(
      /* id 20, wireType 0 =*/
      160
    ).bool(g.showWidgetBorder), g.linkColor != null && Object.hasOwnProperty.call(g, "linkColor") && e.uint32(
      /* id 21, wireType 2 =*/
      170
    ).string(g.linkColor), g.baseFontSize != null && Object.hasOwnProperty.call(g, "baseFontSize") && e.uint32(
      /* id 22, wireType 0 =*/
      176
    ).int32(g.baseFontSize), g.showSidebarBorder != null && Object.hasOwnProperty.call(g, "showSidebarBorder") && e.uint32(
      /* id 23, wireType 0 =*/
      184
    ).bool(g.showSidebarBorder), g.sidebar != null && Object.hasOwnProperty.call(g, "sidebar") && $root$1.CustomThemeConfig.encode(g.sidebar, e.uint32(
      /* id 24, wireType 2 =*/
      194
    ).fork()).ldelim(), g.codeBackgroundColor != null && Object.hasOwnProperty.call(g, "codeBackgroundColor") && e.uint32(
      /* id 25, wireType 2 =*/
      202
    ).string(g.codeBackgroundColor), g.buttonRadius != null && Object.hasOwnProperty.call(g, "buttonRadius") && e.uint32(
      /* id 26, wireType 2 =*/
      210
    ).string(g.buttonRadius), g.dataframeBorderColor != null && Object.hasOwnProperty.call(g, "dataframeBorderColor") && e.uint32(
      /* id 27, wireType 2 =*/
      218
    ).string(g.dataframeBorderColor), g.codeFontSize != null && Object.hasOwnProperty.call(g, "codeFontSize") && e.uint32(
      /* id 28, wireType 2 =*/
      226
    ).string(g.codeFontSize), g.linkUnderline != null && Object.hasOwnProperty.call(g, "linkUnderline") && e.uint32(
      /* id 29, wireType 0 =*/
      232
    ).bool(g.linkUnderline), g.baseFontWeight != null && Object.hasOwnProperty.call(g, "baseFontWeight") && e.uint32(
      /* id 30, wireType 0 =*/
      240
    ).int32(g.baseFontWeight), g.dataframeHeaderBackgroundColor != null && Object.hasOwnProperty.call(g, "dataframeHeaderBackgroundColor") && e.uint32(
      /* id 31, wireType 2 =*/
      250
    ).string(g.dataframeHeaderBackgroundColor), g.codeFontWeight != null && Object.hasOwnProperty.call(g, "codeFontWeight") && e.uint32(
      /* id 32, wireType 0 =*/
      256
    ).int32(g.codeFontWeight), g.chartCategoricalColors != null && g.chartCategoricalColors.length) for (let t = 0; t < g.chartCategoricalColors.length; ++t) e.uint32(
      /* id 33, wireType 2 =*/
      266
    ).string(g.chartCategoricalColors[t]);
    if (g.headingFontWeights != null && g.headingFontWeights.length) {
      e.uint32(
        /* id 34, wireType 2 =*/
        274
      ).fork();
      for (let t = 0; t < g.headingFontWeights.length; ++t) e.int32(g.headingFontWeights[t]);
      e.ldelim();
    }
    if (g.headingFontSizes != null && g.headingFontSizes.length) for (let t = 0; t < g.headingFontSizes.length; ++t) e.uint32(
      /* id 35, wireType 2 =*/
      282
    ).string(g.headingFontSizes[t]);
    if (g.chartSequentialColors != null && g.chartSequentialColors.length) for (let t = 0; t < g.chartSequentialColors.length; ++t) e.uint32(
      /* id 36, wireType 2 =*/
      290
    ).string(g.chartSequentialColors[t]);
    if (g.fontSources != null && g.fontSources.length) for (let t = 0; t < g.fontSources.length; ++t) $root$1.FontSource.encode(g.fontSources[t], e.uint32(
      /* id 37, wireType 2 =*/
      298
    ).fork()).ldelim();
    return g.redColor != null && Object.hasOwnProperty.call(g, "redColor") && e.uint32(
      /* id 38, wireType 2 =*/
      306
    ).string(g.redColor), g.orangeColor != null && Object.hasOwnProperty.call(g, "orangeColor") && e.uint32(
      /* id 39, wireType 2 =*/
      314
    ).string(g.orangeColor), g.yellowColor != null && Object.hasOwnProperty.call(g, "yellowColor") && e.uint32(
      /* id 40, wireType 2 =*/
      322
    ).string(g.yellowColor), g.blueColor != null && Object.hasOwnProperty.call(g, "blueColor") && e.uint32(
      /* id 41, wireType 2 =*/
      330
    ).string(g.blueColor), g.greenColor != null && Object.hasOwnProperty.call(g, "greenColor") && e.uint32(
      /* id 42, wireType 2 =*/
      338
    ).string(g.greenColor), g.violetColor != null && Object.hasOwnProperty.call(g, "violetColor") && e.uint32(
      /* id 43, wireType 2 =*/
      346
    ).string(g.violetColor), g.grayColor != null && Object.hasOwnProperty.call(g, "grayColor") && e.uint32(
      /* id 44, wireType 2 =*/
      354
    ).string(g.grayColor), g.redBackgroundColor != null && Object.hasOwnProperty.call(g, "redBackgroundColor") && e.uint32(
      /* id 45, wireType 2 =*/
      362
    ).string(g.redBackgroundColor), g.orangeBackgroundColor != null && Object.hasOwnProperty.call(g, "orangeBackgroundColor") && e.uint32(
      /* id 46, wireType 2 =*/
      370
    ).string(g.orangeBackgroundColor), g.yellowBackgroundColor != null && Object.hasOwnProperty.call(g, "yellowBackgroundColor") && e.uint32(
      /* id 47, wireType 2 =*/
      378
    ).string(g.yellowBackgroundColor), g.blueBackgroundColor != null && Object.hasOwnProperty.call(g, "blueBackgroundColor") && e.uint32(
      /* id 48, wireType 2 =*/
      386
    ).string(g.blueBackgroundColor), g.greenBackgroundColor != null && Object.hasOwnProperty.call(g, "greenBackgroundColor") && e.uint32(
      /* id 49, wireType 2 =*/
      394
    ).string(g.greenBackgroundColor), g.violetBackgroundColor != null && Object.hasOwnProperty.call(g, "violetBackgroundColor") && e.uint32(
      /* id 50, wireType 2 =*/
      402
    ).string(g.violetBackgroundColor), g.grayBackgroundColor != null && Object.hasOwnProperty.call(g, "grayBackgroundColor") && e.uint32(
      /* id 51, wireType 2 =*/
      410
    ).string(g.grayBackgroundColor), g.redTextColor != null && Object.hasOwnProperty.call(g, "redTextColor") && e.uint32(
      /* id 52, wireType 2 =*/
      418
    ).string(g.redTextColor), g.orangeTextColor != null && Object.hasOwnProperty.call(g, "orangeTextColor") && e.uint32(
      /* id 53, wireType 2 =*/
      426
    ).string(g.orangeTextColor), g.yellowTextColor != null && Object.hasOwnProperty.call(g, "yellowTextColor") && e.uint32(
      /* id 54, wireType 2 =*/
      434
    ).string(g.yellowTextColor), g.blueTextColor != null && Object.hasOwnProperty.call(g, "blueTextColor") && e.uint32(
      /* id 55, wireType 2 =*/
      442
    ).string(g.blueTextColor), g.greenTextColor != null && Object.hasOwnProperty.call(g, "greenTextColor") && e.uint32(
      /* id 56, wireType 2 =*/
      450
    ).string(g.greenTextColor), g.violetTextColor != null && Object.hasOwnProperty.call(g, "violetTextColor") && e.uint32(
      /* id 57, wireType 2 =*/
      458
    ).string(g.violetTextColor), g.grayTextColor != null && Object.hasOwnProperty.call(g, "grayTextColor") && e.uint32(
      /* id 58, wireType 2 =*/
      466
    ).string(g.grayTextColor), g.codeTextColor != null && Object.hasOwnProperty.call(g, "codeTextColor") && e.uint32(
      /* id 59, wireType 2 =*/
      474
    ).string(g.codeTextColor), g.light != null && Object.hasOwnProperty.call(g, "light") && $root$1.CustomThemeConfig.encode(g.light, e.uint32(
      /* id 60, wireType 2 =*/
      482
    ).fork()).ldelim(), g.dark != null && Object.hasOwnProperty.call(g, "dark") && $root$1.CustomThemeConfig.encode(g.dark, e.uint32(
      /* id 61, wireType 2 =*/
      490
    ).fork()).ldelim(), e;
  }, o.decode = function(g, e, t) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let c = e === void 0 ? g.len : g.pos + e, n = new $root$1.CustomThemeConfig();
    for (; g.pos < c; ) {
      let h = g.uint32();
      if (h === t) break;
      switch (h >>> 3) {
        case 1: {
          n.primaryColor = g.string();
          break;
        }
        case 2: {
          n.secondaryBackgroundColor = g.string();
          break;
        }
        case 3: {
          n.backgroundColor = g.string();
          break;
        }
        case 4: {
          n.textColor = g.string();
          break;
        }
        case 5: {
          n.font = g.int32();
          break;
        }
        case 6: {
          n.base = g.int32();
          break;
        }
        case 7: {
          n.widgetBackgroundColor = g.string();
          break;
        }
        case 8: {
          n.widgetBorderColor = g.string();
          break;
        }
        case 9: {
          n.radii = $root$1.Radii.decode(g, g.uint32());
          break;
        }
        case 12: {
          n.headingFont = g.string();
          break;
        }
        case 13: {
          n.bodyFont = g.string();
          break;
        }
        case 14: {
          n.codeFont = g.string();
          break;
        }
        case 15: {
          n.fontFaces && n.fontFaces.length || (n.fontFaces = []), n.fontFaces.push($root$1.FontFace.decode(g, g.uint32()));
          break;
        }
        case 37: {
          n.fontSources && n.fontSources.length || (n.fontSources = []), n.fontSources.push($root$1.FontSource.decode(g, g.uint32()));
          break;
        }
        case 16: {
          n.fontSizes = $root$1.FontSizes.decode(g, g.uint32());
          break;
        }
        case 17: {
          n.skeletonBackgroundColor = g.string();
          break;
        }
        case 18: {
          n.baseRadius = g.string();
          break;
        }
        case 26: {
          n.buttonRadius = g.string();
          break;
        }
        case 19: {
          n.borderColor = g.string();
          break;
        }
        case 27: {
          n.dataframeBorderColor = g.string();
          break;
        }
        case 20: {
          n.showWidgetBorder = g.bool();
          break;
        }
        case 21: {
          n.linkColor = g.string();
          break;
        }
        case 29: {
          n.linkUnderline = g.bool();
          break;
        }
        case 22: {
          n.baseFontSize = g.int32();
          break;
        }
        case 30: {
          n.baseFontWeight = g.int32();
          break;
        }
        case 32: {
          n.codeFontWeight = g.int32();
          break;
        }
        case 28: {
          n.codeFontSize = g.string();
          break;
        }
        case 35: {
          n.headingFontSizes && n.headingFontSizes.length || (n.headingFontSizes = []), n.headingFontSizes.push(g.string());
          break;
        }
        case 34: {
          if (n.headingFontWeights && n.headingFontWeights.length || (n.headingFontWeights = []), (h & 7) === 2) {
            let d = g.uint32() + g.pos;
            for (; g.pos < d; ) n.headingFontWeights.push(g.int32());
          } else n.headingFontWeights.push(g.int32());
          break;
        }
        case 23: {
          n.showSidebarBorder = g.bool();
          break;
        }
        case 59: {
          n.codeTextColor = g.string();
          break;
        }
        case 25: {
          n.codeBackgroundColor = g.string();
          break;
        }
        case 31: {
          n.dataframeHeaderBackgroundColor = g.string();
          break;
        }
        case 33: {
          n.chartCategoricalColors && n.chartCategoricalColors.length || (n.chartCategoricalColors = []), n.chartCategoricalColors.push(g.string());
          break;
        }
        case 36: {
          n.chartSequentialColors && n.chartSequentialColors.length || (n.chartSequentialColors = []), n.chartSequentialColors.push(g.string());
          break;
        }
        case 38: {
          n.redColor = g.string();
          break;
        }
        case 39: {
          n.orangeColor = g.string();
          break;
        }
        case 40: {
          n.yellowColor = g.string();
          break;
        }
        case 41: {
          n.blueColor = g.string();
          break;
        }
        case 42: {
          n.greenColor = g.string();
          break;
        }
        case 43: {
          n.violetColor = g.string();
          break;
        }
        case 44: {
          n.grayColor = g.string();
          break;
        }
        case 45: {
          n.redBackgroundColor = g.string();
          break;
        }
        case 46: {
          n.orangeBackgroundColor = g.string();
          break;
        }
        case 47: {
          n.yellowBackgroundColor = g.string();
          break;
        }
        case 48: {
          n.blueBackgroundColor = g.string();
          break;
        }
        case 49: {
          n.greenBackgroundColor = g.string();
          break;
        }
        case 50: {
          n.violetBackgroundColor = g.string();
          break;
        }
        case 51: {
          n.grayBackgroundColor = g.string();
          break;
        }
        case 52: {
          n.redTextColor = g.string();
          break;
        }
        case 53: {
          n.orangeTextColor = g.string();
          break;
        }
        case 54: {
          n.yellowTextColor = g.string();
          break;
        }
        case 55: {
          n.blueTextColor = g.string();
          break;
        }
        case 56: {
          n.greenTextColor = g.string();
          break;
        }
        case 57: {
          n.violetTextColor = g.string();
          break;
        }
        case 58: {
          n.grayTextColor = g.string();
          break;
        }
        case 24: {
          n.sidebar = $root$1.CustomThemeConfig.decode(g, g.uint32());
          break;
        }
        case 60: {
          n.light = $root$1.CustomThemeConfig.decode(g, g.uint32());
          break;
        }
        case 61: {
          n.dark = $root$1.CustomThemeConfig.decode(g, g.uint32());
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.CustomThemeConfig) return g;
    let e = new $root$1.CustomThemeConfig();
    switch (g.primaryColor != null && (e.primaryColor = String(g.primaryColor)), g.secondaryBackgroundColor != null && (e.secondaryBackgroundColor = String(g.secondaryBackgroundColor)), g.backgroundColor != null && (e.backgroundColor = String(g.backgroundColor)), g.textColor != null && (e.textColor = String(g.textColor)), g.font) {
      default:
        if (typeof g.font == "number") {
          e.font = g.font;
          break;
        }
        break;
      case "SANS_SERIF":
      case 0:
        e.font = 0;
        break;
      case "SERIF":
      case 1:
        e.font = 1;
        break;
      case "MONOSPACE":
      case 2:
        e.font = 2;
        break;
    }
    switch (g.base) {
      default:
        if (typeof g.base == "number") {
          e.base = g.base;
          break;
        }
        break;
      case "LIGHT":
      case 0:
        e.base = 0;
        break;
      case "DARK":
      case 1:
        e.base = 1;
        break;
    }
    if (g.widgetBackgroundColor != null && (e.widgetBackgroundColor = String(g.widgetBackgroundColor)), g.widgetBorderColor != null && (e.widgetBorderColor = String(g.widgetBorderColor)), g.radii != null) {
      if (typeof g.radii != "object") throw TypeError(".CustomThemeConfig.radii: object expected");
      e.radii = $root$1.Radii.fromObject(g.radii);
    }
    if (g.headingFont != null && (e.headingFont = String(g.headingFont)), g.bodyFont != null && (e.bodyFont = String(g.bodyFont)), g.codeFont != null && (e.codeFont = String(g.codeFont)), g.fontFaces) {
      if (!Array.isArray(g.fontFaces)) throw TypeError(".CustomThemeConfig.fontFaces: array expected");
      e.fontFaces = [];
      for (let t = 0; t < g.fontFaces.length; ++t) {
        if (typeof g.fontFaces[t] != "object") throw TypeError(".CustomThemeConfig.fontFaces: object expected");
        e.fontFaces[t] = $root$1.FontFace.fromObject(g.fontFaces[t]);
      }
    }
    if (g.fontSources) {
      if (!Array.isArray(g.fontSources)) throw TypeError(".CustomThemeConfig.fontSources: array expected");
      e.fontSources = [];
      for (let t = 0; t < g.fontSources.length; ++t) {
        if (typeof g.fontSources[t] != "object") throw TypeError(".CustomThemeConfig.fontSources: object expected");
        e.fontSources[t] = $root$1.FontSource.fromObject(g.fontSources[t]);
      }
    }
    if (g.fontSizes != null) {
      if (typeof g.fontSizes != "object") throw TypeError(".CustomThemeConfig.fontSizes: object expected");
      e.fontSizes = $root$1.FontSizes.fromObject(g.fontSizes);
    }
    if (g.skeletonBackgroundColor != null && (e.skeletonBackgroundColor = String(g.skeletonBackgroundColor)), g.baseRadius != null && (e.baseRadius = String(g.baseRadius)), g.buttonRadius != null && (e.buttonRadius = String(g.buttonRadius)), g.borderColor != null && (e.borderColor = String(g.borderColor)), g.dataframeBorderColor != null && (e.dataframeBorderColor = String(g.dataframeBorderColor)), g.showWidgetBorder != null && (e.showWidgetBorder = !!g.showWidgetBorder), g.linkColor != null && (e.linkColor = String(g.linkColor)), g.linkUnderline != null && (e.linkUnderline = !!g.linkUnderline), g.baseFontSize != null && (e.baseFontSize = g.baseFontSize | 0), g.baseFontWeight != null && (e.baseFontWeight = g.baseFontWeight | 0), g.codeFontWeight != null && (e.codeFontWeight = g.codeFontWeight | 0), g.codeFontSize != null && (e.codeFontSize = String(g.codeFontSize)), g.headingFontSizes) {
      if (!Array.isArray(g.headingFontSizes)) throw TypeError(".CustomThemeConfig.headingFontSizes: array expected");
      e.headingFontSizes = [];
      for (let t = 0; t < g.headingFontSizes.length; ++t) e.headingFontSizes[t] = String(g.headingFontSizes[t]);
    }
    if (g.headingFontWeights) {
      if (!Array.isArray(g.headingFontWeights)) throw TypeError(".CustomThemeConfig.headingFontWeights: array expected");
      e.headingFontWeights = [];
      for (let t = 0; t < g.headingFontWeights.length; ++t) e.headingFontWeights[t] = g.headingFontWeights[t] | 0;
    }
    if (g.showSidebarBorder != null && (e.showSidebarBorder = !!g.showSidebarBorder), g.codeTextColor != null && (e.codeTextColor = String(g.codeTextColor)), g.codeBackgroundColor != null && (e.codeBackgroundColor = String(g.codeBackgroundColor)), g.dataframeHeaderBackgroundColor != null && (e.dataframeHeaderBackgroundColor = String(g.dataframeHeaderBackgroundColor)), g.chartCategoricalColors) {
      if (!Array.isArray(g.chartCategoricalColors)) throw TypeError(".CustomThemeConfig.chartCategoricalColors: array expected");
      e.chartCategoricalColors = [];
      for (let t = 0; t < g.chartCategoricalColors.length; ++t) e.chartCategoricalColors[t] = String(g.chartCategoricalColors[t]);
    }
    if (g.chartSequentialColors) {
      if (!Array.isArray(g.chartSequentialColors)) throw TypeError(".CustomThemeConfig.chartSequentialColors: array expected");
      e.chartSequentialColors = [];
      for (let t = 0; t < g.chartSequentialColors.length; ++t) e.chartSequentialColors[t] = String(g.chartSequentialColors[t]);
    }
    if (g.redColor != null && (e.redColor = String(g.redColor)), g.orangeColor != null && (e.orangeColor = String(g.orangeColor)), g.yellowColor != null && (e.yellowColor = String(g.yellowColor)), g.blueColor != null && (e.blueColor = String(g.blueColor)), g.greenColor != null && (e.greenColor = String(g.greenColor)), g.violetColor != null && (e.violetColor = String(g.violetColor)), g.grayColor != null && (e.grayColor = String(g.grayColor)), g.redBackgroundColor != null && (e.redBackgroundColor = String(g.redBackgroundColor)), g.orangeBackgroundColor != null && (e.orangeBackgroundColor = String(g.orangeBackgroundColor)), g.yellowBackgroundColor != null && (e.yellowBackgroundColor = String(g.yellowBackgroundColor)), g.blueBackgroundColor != null && (e.blueBackgroundColor = String(g.blueBackgroundColor)), g.greenBackgroundColor != null && (e.greenBackgroundColor = String(g.greenBackgroundColor)), g.violetBackgroundColor != null && (e.violetBackgroundColor = String(g.violetBackgroundColor)), g.grayBackgroundColor != null && (e.grayBackgroundColor = String(g.grayBackgroundColor)), g.redTextColor != null && (e.redTextColor = String(g.redTextColor)), g.orangeTextColor != null && (e.orangeTextColor = String(g.orangeTextColor)), g.yellowTextColor != null && (e.yellowTextColor = String(g.yellowTextColor)), g.blueTextColor != null && (e.blueTextColor = String(g.blueTextColor)), g.greenTextColor != null && (e.greenTextColor = String(g.greenTextColor)), g.violetTextColor != null && (e.violetTextColor = String(g.violetTextColor)), g.grayTextColor != null && (e.grayTextColor = String(g.grayTextColor)), g.sidebar != null) {
      if (typeof g.sidebar != "object") throw TypeError(".CustomThemeConfig.sidebar: object expected");
      e.sidebar = $root$1.CustomThemeConfig.fromObject(g.sidebar);
    }
    if (g.light != null) {
      if (typeof g.light != "object") throw TypeError(".CustomThemeConfig.light: object expected");
      e.light = $root$1.CustomThemeConfig.fromObject(g.light);
    }
    if (g.dark != null) {
      if (typeof g.dark != "object") throw TypeError(".CustomThemeConfig.dark: object expected");
      e.dark = $root$1.CustomThemeConfig.fromObject(g.dark);
    }
    return e;
  }, o.toObject = function(g, e) {
    e || (e = {});
    let t = {};
    if ((e.arrays || e.defaults) && (t.fontFaces = [], t.chartCategoricalColors = [], t.headingFontWeights = [], t.headingFontSizes = [], t.chartSequentialColors = [], t.fontSources = []), e.defaults && (t.primaryColor = "", t.secondaryBackgroundColor = "", t.backgroundColor = "", t.textColor = "", t.font = e.enums === String ? "SANS_SERIF" : 0, t.base = e.enums === String ? "LIGHT" : 0, t.widgetBackgroundColor = "", t.widgetBorderColor = "", t.radii = null, t.headingFont = "", t.bodyFont = "", t.codeFont = "", t.fontSizes = null, t.skeletonBackgroundColor = ""), g.primaryColor != null && g.hasOwnProperty("primaryColor") && (t.primaryColor = g.primaryColor), g.secondaryBackgroundColor != null && g.hasOwnProperty("secondaryBackgroundColor") && (t.secondaryBackgroundColor = g.secondaryBackgroundColor), g.backgroundColor != null && g.hasOwnProperty("backgroundColor") && (t.backgroundColor = g.backgroundColor), g.textColor != null && g.hasOwnProperty("textColor") && (t.textColor = g.textColor), g.font != null && g.hasOwnProperty("font") && (t.font = e.enums === String ? $root$1.CustomThemeConfig.FontFamily[g.font] === void 0 ? g.font : $root$1.CustomThemeConfig.FontFamily[g.font] : g.font), g.base != null && g.hasOwnProperty("base") && (t.base = e.enums === String ? $root$1.CustomThemeConfig.BaseTheme[g.base] === void 0 ? g.base : $root$1.CustomThemeConfig.BaseTheme[g.base] : g.base), g.widgetBackgroundColor != null && g.hasOwnProperty("widgetBackgroundColor") && (t.widgetBackgroundColor = g.widgetBackgroundColor), g.widgetBorderColor != null && g.hasOwnProperty("widgetBorderColor") && (t.widgetBorderColor = g.widgetBorderColor), g.radii != null && g.hasOwnProperty("radii") && (t.radii = $root$1.Radii.toObject(g.radii, e)), g.headingFont != null && g.hasOwnProperty("headingFont") && (t.headingFont = g.headingFont), g.bodyFont != null && g.hasOwnProperty("bodyFont") && (t.bodyFont = g.bodyFont), g.codeFont != null && g.hasOwnProperty("codeFont") && (t.codeFont = g.codeFont), g.fontFaces && g.fontFaces.length) {
      t.fontFaces = [];
      for (let c = 0; c < g.fontFaces.length; ++c) t.fontFaces[c] = $root$1.FontFace.toObject(g.fontFaces[c], e);
    }
    if (g.fontSizes != null && g.hasOwnProperty("fontSizes") && (t.fontSizes = $root$1.FontSizes.toObject(g.fontSizes, e)), g.skeletonBackgroundColor != null && g.hasOwnProperty("skeletonBackgroundColor") && (t.skeletonBackgroundColor = g.skeletonBackgroundColor), g.baseRadius != null && g.hasOwnProperty("baseRadius") && (t.baseRadius = g.baseRadius, e.oneofs && (t._baseRadius = "baseRadius")), g.borderColor != null && g.hasOwnProperty("borderColor") && (t.borderColor = g.borderColor, e.oneofs && (t._borderColor = "borderColor")), g.showWidgetBorder != null && g.hasOwnProperty("showWidgetBorder") && (t.showWidgetBorder = g.showWidgetBorder, e.oneofs && (t._showWidgetBorder = "showWidgetBorder")), g.linkColor != null && g.hasOwnProperty("linkColor") && (t.linkColor = g.linkColor, e.oneofs && (t._linkColor = "linkColor")), g.baseFontSize != null && g.hasOwnProperty("baseFontSize") && (t.baseFontSize = g.baseFontSize, e.oneofs && (t._baseFontSize = "baseFontSize")), g.showSidebarBorder != null && g.hasOwnProperty("showSidebarBorder") && (t.showSidebarBorder = g.showSidebarBorder, e.oneofs && (t._showSidebarBorder = "showSidebarBorder")), g.sidebar != null && g.hasOwnProperty("sidebar") && (t.sidebar = $root$1.CustomThemeConfig.toObject(g.sidebar, e), e.oneofs && (t._sidebar = "sidebar")), g.codeBackgroundColor != null && g.hasOwnProperty("codeBackgroundColor") && (t.codeBackgroundColor = g.codeBackgroundColor, e.oneofs && (t._codeBackgroundColor = "codeBackgroundColor")), g.buttonRadius != null && g.hasOwnProperty("buttonRadius") && (t.buttonRadius = g.buttonRadius, e.oneofs && (t._buttonRadius = "buttonRadius")), g.dataframeBorderColor != null && g.hasOwnProperty("dataframeBorderColor") && (t.dataframeBorderColor = g.dataframeBorderColor, e.oneofs && (t._dataframeBorderColor = "dataframeBorderColor")), g.codeFontSize != null && g.hasOwnProperty("codeFontSize") && (t.codeFontSize = g.codeFontSize, e.oneofs && (t._codeFontSize = "codeFontSize")), g.linkUnderline != null && g.hasOwnProperty("linkUnderline") && (t.linkUnderline = g.linkUnderline, e.oneofs && (t._linkUnderline = "linkUnderline")), g.baseFontWeight != null && g.hasOwnProperty("baseFontWeight") && (t.baseFontWeight = g.baseFontWeight, e.oneofs && (t._baseFontWeight = "baseFontWeight")), g.dataframeHeaderBackgroundColor != null && g.hasOwnProperty("dataframeHeaderBackgroundColor") && (t.dataframeHeaderBackgroundColor = g.dataframeHeaderBackgroundColor, e.oneofs && (t._dataframeHeaderBackgroundColor = "dataframeHeaderBackgroundColor")), g.codeFontWeight != null && g.hasOwnProperty("codeFontWeight") && (t.codeFontWeight = g.codeFontWeight, e.oneofs && (t._codeFontWeight = "codeFontWeight")), g.chartCategoricalColors && g.chartCategoricalColors.length) {
      t.chartCategoricalColors = [];
      for (let c = 0; c < g.chartCategoricalColors.length; ++c) t.chartCategoricalColors[c] = g.chartCategoricalColors[c];
    }
    if (g.headingFontWeights && g.headingFontWeights.length) {
      t.headingFontWeights = [];
      for (let c = 0; c < g.headingFontWeights.length; ++c) t.headingFontWeights[c] = g.headingFontWeights[c];
    }
    if (g.headingFontSizes && g.headingFontSizes.length) {
      t.headingFontSizes = [];
      for (let c = 0; c < g.headingFontSizes.length; ++c) t.headingFontSizes[c] = g.headingFontSizes[c];
    }
    if (g.chartSequentialColors && g.chartSequentialColors.length) {
      t.chartSequentialColors = [];
      for (let c = 0; c < g.chartSequentialColors.length; ++c) t.chartSequentialColors[c] = g.chartSequentialColors[c];
    }
    if (g.fontSources && g.fontSources.length) {
      t.fontSources = [];
      for (let c = 0; c < g.fontSources.length; ++c) t.fontSources[c] = $root$1.FontSource.toObject(g.fontSources[c], e);
    }
    return g.redColor != null && g.hasOwnProperty("redColor") && (t.redColor = g.redColor, e.oneofs && (t._redColor = "redColor")), g.orangeColor != null && g.hasOwnProperty("orangeColor") && (t.orangeColor = g.orangeColor, e.oneofs && (t._orangeColor = "orangeColor")), g.yellowColor != null && g.hasOwnProperty("yellowColor") && (t.yellowColor = g.yellowColor, e.oneofs && (t._yellowColor = "yellowColor")), g.blueColor != null && g.hasOwnProperty("blueColor") && (t.blueColor = g.blueColor, e.oneofs && (t._blueColor = "blueColor")), g.greenColor != null && g.hasOwnProperty("greenColor") && (t.greenColor = g.greenColor, e.oneofs && (t._greenColor = "greenColor")), g.violetColor != null && g.hasOwnProperty("violetColor") && (t.violetColor = g.violetColor, e.oneofs && (t._violetColor = "violetColor")), g.grayColor != null && g.hasOwnProperty("grayColor") && (t.grayColor = g.grayColor, e.oneofs && (t._grayColor = "grayColor")), g.redBackgroundColor != null && g.hasOwnProperty("redBackgroundColor") && (t.redBackgroundColor = g.redBackgroundColor, e.oneofs && (t._redBackgroundColor = "redBackgroundColor")), g.orangeBackgroundColor != null && g.hasOwnProperty("orangeBackgroundColor") && (t.orangeBackgroundColor = g.orangeBackgroundColor, e.oneofs && (t._orangeBackgroundColor = "orangeBackgroundColor")), g.yellowBackgroundColor != null && g.hasOwnProperty("yellowBackgroundColor") && (t.yellowBackgroundColor = g.yellowBackgroundColor, e.oneofs && (t._yellowBackgroundColor = "yellowBackgroundColor")), g.blueBackgroundColor != null && g.hasOwnProperty("blueBackgroundColor") && (t.blueBackgroundColor = g.blueBackgroundColor, e.oneofs && (t._blueBackgroundColor = "blueBackgroundColor")), g.greenBackgroundColor != null && g.hasOwnProperty("greenBackgroundColor") && (t.greenBackgroundColor = g.greenBackgroundColor, e.oneofs && (t._greenBackgroundColor = "greenBackgroundColor")), g.violetBackgroundColor != null && g.hasOwnProperty("violetBackgroundColor") && (t.violetBackgroundColor = g.violetBackgroundColor, e.oneofs && (t._violetBackgroundColor = "violetBackgroundColor")), g.grayBackgroundColor != null && g.hasOwnProperty("grayBackgroundColor") && (t.grayBackgroundColor = g.grayBackgroundColor, e.oneofs && (t._grayBackgroundColor = "grayBackgroundColor")), g.redTextColor != null && g.hasOwnProperty("redTextColor") && (t.redTextColor = g.redTextColor, e.oneofs && (t._redTextColor = "redTextColor")), g.orangeTextColor != null && g.hasOwnProperty("orangeTextColor") && (t.orangeTextColor = g.orangeTextColor, e.oneofs && (t._orangeTextColor = "orangeTextColor")), g.yellowTextColor != null && g.hasOwnProperty("yellowTextColor") && (t.yellowTextColor = g.yellowTextColor, e.oneofs && (t._yellowTextColor = "yellowTextColor")), g.blueTextColor != null && g.hasOwnProperty("blueTextColor") && (t.blueTextColor = g.blueTextColor, e.oneofs && (t._blueTextColor = "blueTextColor")), g.greenTextColor != null && g.hasOwnProperty("greenTextColor") && (t.greenTextColor = g.greenTextColor, e.oneofs && (t._greenTextColor = "greenTextColor")), g.violetTextColor != null && g.hasOwnProperty("violetTextColor") && (t.violetTextColor = g.violetTextColor, e.oneofs && (t._violetTextColor = "violetTextColor")), g.grayTextColor != null && g.hasOwnProperty("grayTextColor") && (t.grayTextColor = g.grayTextColor, e.oneofs && (t._grayTextColor = "grayTextColor")), g.codeTextColor != null && g.hasOwnProperty("codeTextColor") && (t.codeTextColor = g.codeTextColor, e.oneofs && (t._codeTextColor = "codeTextColor")), g.light != null && g.hasOwnProperty("light") && (t.light = $root$1.CustomThemeConfig.toObject(g.light, e), e.oneofs && (t._light = "light")), g.dark != null && g.hasOwnProperty("dark") && (t.dark = $root$1.CustomThemeConfig.toObject(g.dark, e), e.oneofs && (t._dark = "dark")), t;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/CustomThemeConfig";
  }, o.BaseTheme = (function() {
    const A = {}, g = Object.create(A);
    return g[A[0] = "LIGHT"] = 0, g[A[1] = "DARK"] = 1, g;
  })(), o.FontFamily = (function() {
    const A = {}, g = Object.create(A);
    return g[A[0] = "SANS_SERIF"] = 0, g[A[1] = "SERIF"] = 1, g[A[2] = "MONOSPACE"] = 2, g;
  })(), o;
})();
$root$1.FontFace = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.url = "", o.prototype.family = "", o.prototype.weight = 0, o.prototype.weightRange = "", o.prototype.style = "", o.prototype.unicodeRange = "", o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    return g || (g = $Writer$1.create()), A.url != null && Object.hasOwnProperty.call(A, "url") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(A.url), A.family != null && Object.hasOwnProperty.call(A, "family") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(A.family), A.weight != null && Object.hasOwnProperty.call(A, "weight") && g.uint32(
      /* id 3, wireType 0 =*/
      24
    ).int32(A.weight), A.style != null && Object.hasOwnProperty.call(A, "style") && g.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(A.style), A.weightRange != null && Object.hasOwnProperty.call(A, "weightRange") && g.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(A.weightRange), A.unicodeRange != null && Object.hasOwnProperty.call(A, "unicodeRange") && g.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(A.unicodeRange), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader$1 || (A = $Reader$1.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root$1.FontFace();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.url = A.string();
          break;
        }
        case 2: {
          c.family = A.string();
          break;
        }
        case 3: {
          c.weight = A.int32();
          break;
        }
        case 5: {
          c.weightRange = A.string();
          break;
        }
        case 4: {
          c.style = A.string();
          break;
        }
        case 6: {
          c.unicodeRange = A.string();
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root$1.FontFace) return A;
    let g = new $root$1.FontFace();
    return A.url != null && (g.url = String(A.url)), A.family != null && (g.family = String(A.family)), A.weight != null && (g.weight = A.weight | 0), A.weightRange != null && (g.weightRange = String(A.weightRange)), A.style != null && (g.style = String(A.style)), A.unicodeRange != null && (g.unicodeRange = String(A.unicodeRange)), g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    return g.defaults && (e.url = "", e.family = "", e.weight = 0, e.style = "", e.weightRange = "", e.unicodeRange = ""), A.url != null && A.hasOwnProperty("url") && (e.url = A.url), A.family != null && A.hasOwnProperty("family") && (e.family = A.family), A.weight != null && A.hasOwnProperty("weight") && (e.weight = A.weight), A.style != null && A.hasOwnProperty("style") && (e.style = A.style), A.weightRange != null && A.hasOwnProperty("weightRange") && (e.weightRange = A.weightRange), A.unicodeRange != null && A.hasOwnProperty("unicodeRange") && (e.unicodeRange = A.unicodeRange), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/FontFace";
  }, o;
})();
$root$1.FontSource = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.configName = "", o.prototype.sourceUrl = "", o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    return g || (g = $Writer$1.create()), A.configName != null && Object.hasOwnProperty.call(A, "configName") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(A.configName), A.sourceUrl != null && Object.hasOwnProperty.call(A, "sourceUrl") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(A.sourceUrl), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader$1 || (A = $Reader$1.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root$1.FontSource();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.configName = A.string();
          break;
        }
        case 2: {
          c.sourceUrl = A.string();
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root$1.FontSource) return A;
    let g = new $root$1.FontSource();
    return A.configName != null && (g.configName = String(A.configName)), A.sourceUrl != null && (g.sourceUrl = String(A.sourceUrl)), g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    return g.defaults && (e.configName = "", e.sourceUrl = ""), A.configName != null && A.hasOwnProperty("configName") && (e.configName = A.configName), A.sourceUrl != null && A.hasOwnProperty("sourceUrl") && (e.sourceUrl = A.sourceUrl), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/FontSource";
  }, o;
})();
$root$1.Radii = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.baseWidgetRadius = 0, o.prototype.checkboxRadius = 0, o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    return g || (g = $Writer$1.create()), A.baseWidgetRadius != null && Object.hasOwnProperty.call(A, "baseWidgetRadius") && g.uint32(
      /* id 1, wireType 0 =*/
      8
    ).int32(A.baseWidgetRadius), A.checkboxRadius != null && Object.hasOwnProperty.call(A, "checkboxRadius") && g.uint32(
      /* id 2, wireType 0 =*/
      16
    ).int32(A.checkboxRadius), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader$1 || (A = $Reader$1.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root$1.Radii();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.baseWidgetRadius = A.int32();
          break;
        }
        case 2: {
          c.checkboxRadius = A.int32();
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root$1.Radii) return A;
    let g = new $root$1.Radii();
    return A.baseWidgetRadius != null && (g.baseWidgetRadius = A.baseWidgetRadius | 0), A.checkboxRadius != null && (g.checkboxRadius = A.checkboxRadius | 0), g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    return g.defaults && (e.baseWidgetRadius = 0, e.checkboxRadius = 0), A.baseWidgetRadius != null && A.hasOwnProperty("baseWidgetRadius") && (e.baseWidgetRadius = A.baseWidgetRadius), A.checkboxRadius != null && A.hasOwnProperty("checkboxRadius") && (e.checkboxRadius = A.checkboxRadius), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/Radii";
  }, o;
})();
$root$1.FontSizes = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.tinyFontSize = 0, o.prototype.smallFontSize = 0, o.prototype.baseFontSize = 0, o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    return g || (g = $Writer$1.create()), A.tinyFontSize != null && Object.hasOwnProperty.call(A, "tinyFontSize") && g.uint32(
      /* id 1, wireType 0 =*/
      8
    ).int32(A.tinyFontSize), A.smallFontSize != null && Object.hasOwnProperty.call(A, "smallFontSize") && g.uint32(
      /* id 2, wireType 0 =*/
      16
    ).int32(A.smallFontSize), A.baseFontSize != null && Object.hasOwnProperty.call(A, "baseFontSize") && g.uint32(
      /* id 3, wireType 0 =*/
      24
    ).int32(A.baseFontSize), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader$1 || (A = $Reader$1.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root$1.FontSizes();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.tinyFontSize = A.int32();
          break;
        }
        case 2: {
          c.smallFontSize = A.int32();
          break;
        }
        case 3: {
          c.baseFontSize = A.int32();
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root$1.FontSizes) return A;
    let g = new $root$1.FontSizes();
    return A.tinyFontSize != null && (g.tinyFontSize = A.tinyFontSize | 0), A.smallFontSize != null && (g.smallFontSize = A.smallFontSize | 0), A.baseFontSize != null && (g.baseFontSize = A.baseFontSize | 0), g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    return g.defaults && (e.tinyFontSize = 0, e.smallFontSize = 0, e.baseFontSize = 0), A.tinyFontSize != null && A.hasOwnProperty("tinyFontSize") && (e.tinyFontSize = A.tinyFontSize), A.smallFontSize != null && A.hasOwnProperty("smallFontSize") && (e.smallFontSize = A.smallFontSize), A.baseFontSize != null && A.hasOwnProperty("baseFontSize") && (e.baseFontSize = A.baseFontSize), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/FontSizes";
  }, o;
})();
$root$1.UserInfo = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.installationId = "", o.prototype.installationIdV3 = "", o.prototype.installationIdV4 = "", o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    return g || (g = $Writer$1.create()), A.installationId != null && Object.hasOwnProperty.call(A, "installationId") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(A.installationId), A.installationIdV3 != null && Object.hasOwnProperty.call(A, "installationIdV3") && g.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(A.installationIdV3), A.installationIdV4 != null && Object.hasOwnProperty.call(A, "installationIdV4") && g.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(A.installationIdV4), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader$1 || (A = $Reader$1.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root$1.UserInfo();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.installationId = A.string();
          break;
        }
        case 5: {
          c.installationIdV3 = A.string();
          break;
        }
        case 6: {
          c.installationIdV4 = A.string();
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root$1.UserInfo) return A;
    let g = new $root$1.UserInfo();
    return A.installationId != null && (g.installationId = String(A.installationId)), A.installationIdV3 != null && (g.installationIdV3 = String(A.installationIdV3)), A.installationIdV4 != null && (g.installationIdV4 = String(A.installationIdV4)), g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    return g.defaults && (e.installationId = "", e.installationIdV3 = "", e.installationIdV4 = ""), A.installationId != null && A.hasOwnProperty("installationId") && (e.installationId = A.installationId), A.installationIdV3 != null && A.hasOwnProperty("installationIdV3") && (e.installationIdV3 = A.installationIdV3), A.installationIdV4 != null && A.hasOwnProperty("installationIdV4") && (e.installationIdV4 = A.installationIdV4), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/UserInfo";
  }, o;
})();
$root$1.EnvironmentInfo = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.streamlitVersion = "", o.prototype.pythonVersion = "", o.prototype.serverOs = "", o.prototype.hasDisplay = !1, o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    return g || (g = $Writer$1.create()), A.streamlitVersion != null && Object.hasOwnProperty.call(A, "streamlitVersion") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(A.streamlitVersion), A.pythonVersion != null && Object.hasOwnProperty.call(A, "pythonVersion") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(A.pythonVersion), A.serverOs != null && Object.hasOwnProperty.call(A, "serverOs") && g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(A.serverOs), A.hasDisplay != null && Object.hasOwnProperty.call(A, "hasDisplay") && g.uint32(
      /* id 4, wireType 0 =*/
      32
    ).bool(A.hasDisplay), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader$1 || (A = $Reader$1.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root$1.EnvironmentInfo();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.streamlitVersion = A.string();
          break;
        }
        case 2: {
          c.pythonVersion = A.string();
          break;
        }
        case 3: {
          c.serverOs = A.string();
          break;
        }
        case 4: {
          c.hasDisplay = A.bool();
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root$1.EnvironmentInfo) return A;
    let g = new $root$1.EnvironmentInfo();
    return A.streamlitVersion != null && (g.streamlitVersion = String(A.streamlitVersion)), A.pythonVersion != null && (g.pythonVersion = String(A.pythonVersion)), A.serverOs != null && (g.serverOs = String(A.serverOs)), A.hasDisplay != null && (g.hasDisplay = !!A.hasDisplay), g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    return g.defaults && (e.streamlitVersion = "", e.pythonVersion = "", e.serverOs = "", e.hasDisplay = !1), A.streamlitVersion != null && A.hasOwnProperty("streamlitVersion") && (e.streamlitVersion = A.streamlitVersion), A.pythonVersion != null && A.hasOwnProperty("pythonVersion") && (e.pythonVersion = A.pythonVersion), A.serverOs != null && A.hasOwnProperty("serverOs") && (e.serverOs = A.serverOs), A.hasDisplay != null && A.hasOwnProperty("hasDisplay") && (e.hasDisplay = A.hasDisplay), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/EnvironmentInfo";
  }, o;
})();
$root$1.SessionStatus = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.runOnSave = !1, o.prototype.scriptIsRunning = !1, o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    return g || (g = $Writer$1.create()), A.runOnSave != null && Object.hasOwnProperty.call(A, "runOnSave") && g.uint32(
      /* id 1, wireType 0 =*/
      8
    ).bool(A.runOnSave), A.scriptIsRunning != null && Object.hasOwnProperty.call(A, "scriptIsRunning") && g.uint32(
      /* id 2, wireType 0 =*/
      16
    ).bool(A.scriptIsRunning), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader$1 || (A = $Reader$1.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root$1.SessionStatus();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.runOnSave = A.bool();
          break;
        }
        case 2: {
          c.scriptIsRunning = A.bool();
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root$1.SessionStatus) return A;
    let g = new $root$1.SessionStatus();
    return A.runOnSave != null && (g.runOnSave = !!A.runOnSave), A.scriptIsRunning != null && (g.scriptIsRunning = !!A.scriptIsRunning), g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    return g.defaults && (e.runOnSave = !1, e.scriptIsRunning = !1), A.runOnSave != null && A.hasOwnProperty("runOnSave") && (e.runOnSave = A.runOnSave), A.scriptIsRunning != null && A.hasOwnProperty("scriptIsRunning") && (e.scriptIsRunning = A.scriptIsRunning), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/SessionStatus";
  }, o;
})();
const PageConfig = $root$1.PageConfig = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.title = "", o.prototype.favicon = "", o.prototype.layout = 0, o.prototype.initialSidebarState = 0, o.prototype.menuItems = null, o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    return g || (g = $Writer$1.create()), A.title != null && Object.hasOwnProperty.call(A, "title") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(A.title), A.favicon != null && Object.hasOwnProperty.call(A, "favicon") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(A.favicon), A.layout != null && Object.hasOwnProperty.call(A, "layout") && g.uint32(
      /* id 3, wireType 0 =*/
      24
    ).int32(A.layout), A.initialSidebarState != null && Object.hasOwnProperty.call(A, "initialSidebarState") && g.uint32(
      /* id 4, wireType 0 =*/
      32
    ).int32(A.initialSidebarState), A.menuItems != null && Object.hasOwnProperty.call(A, "menuItems") && $root$1.PageConfig.MenuItems.encode(A.menuItems, g.uint32(
      /* id 5, wireType 2 =*/
      42
    ).fork()).ldelim(), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader$1 || (A = $Reader$1.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root$1.PageConfig();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.title = A.string();
          break;
        }
        case 2: {
          c.favicon = A.string();
          break;
        }
        case 3: {
          c.layout = A.int32();
          break;
        }
        case 4: {
          c.initialSidebarState = A.int32();
          break;
        }
        case 5: {
          c.menuItems = $root$1.PageConfig.MenuItems.decode(A, A.uint32());
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root$1.PageConfig) return A;
    let g = new $root$1.PageConfig();
    switch (A.title != null && (g.title = String(A.title)), A.favicon != null && (g.favicon = String(A.favicon)), A.layout) {
      default:
        if (typeof A.layout == "number") {
          g.layout = A.layout;
          break;
        }
        break;
      case "CENTERED":
      case 0:
        g.layout = 0;
        break;
      case "WIDE":
      case 1:
        g.layout = 1;
        break;
      case "LAYOUT_UNSET":
      case 2:
        g.layout = 2;
        break;
    }
    switch (A.initialSidebarState) {
      default:
        if (typeof A.initialSidebarState == "number") {
          g.initialSidebarState = A.initialSidebarState;
          break;
        }
        break;
      case "AUTO":
      case 0:
        g.initialSidebarState = 0;
        break;
      case "EXPANDED":
      case 1:
        g.initialSidebarState = 1;
        break;
      case "COLLAPSED":
      case 2:
        g.initialSidebarState = 2;
        break;
      case "SIDEBAR_UNSET":
      case 3:
        g.initialSidebarState = 3;
        break;
    }
    if (A.menuItems != null) {
      if (typeof A.menuItems != "object") throw TypeError(".PageConfig.menuItems: object expected");
      g.menuItems = $root$1.PageConfig.MenuItems.fromObject(A.menuItems);
    }
    return g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    return g.defaults && (e.title = "", e.favicon = "", e.layout = g.enums === String ? "CENTERED" : 0, e.initialSidebarState = g.enums === String ? "AUTO" : 0, e.menuItems = null), A.title != null && A.hasOwnProperty("title") && (e.title = A.title), A.favicon != null && A.hasOwnProperty("favicon") && (e.favicon = A.favicon), A.layout != null && A.hasOwnProperty("layout") && (e.layout = g.enums === String ? $root$1.PageConfig.Layout[A.layout] === void 0 ? A.layout : $root$1.PageConfig.Layout[A.layout] : A.layout), A.initialSidebarState != null && A.hasOwnProperty("initialSidebarState") && (e.initialSidebarState = g.enums === String ? $root$1.PageConfig.SidebarState[A.initialSidebarState] === void 0 ? A.initialSidebarState : $root$1.PageConfig.SidebarState[A.initialSidebarState] : A.initialSidebarState), A.menuItems != null && A.hasOwnProperty("menuItems") && (e.menuItems = $root$1.PageConfig.MenuItems.toObject(A.menuItems, g)), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/PageConfig";
  }, o.MenuItems = (function() {
    function E(A) {
      if (A) for (let g = Object.keys(A), e = 0; e < g.length; ++e) A[g[e]] != null && (this[g[e]] = A[g[e]]);
    }
    return E.prototype.getHelpUrl = "", E.prototype.hideGetHelp = !1, E.prototype.reportABugUrl = "", E.prototype.hideReportABug = !1, E.prototype.aboutSectionMd = "", E.prototype.clearAboutMd = !1, E.create = function(g) {
      return new E(g);
    }, E.encode = function(g, e) {
      return e || (e = $Writer$1.create()), g.getHelpUrl != null && Object.hasOwnProperty.call(g, "getHelpUrl") && e.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(g.getHelpUrl), g.hideGetHelp != null && Object.hasOwnProperty.call(g, "hideGetHelp") && e.uint32(
        /* id 2, wireType 0 =*/
        16
      ).bool(g.hideGetHelp), g.reportABugUrl != null && Object.hasOwnProperty.call(g, "reportABugUrl") && e.uint32(
        /* id 3, wireType 2 =*/
        26
      ).string(g.reportABugUrl), g.hideReportABug != null && Object.hasOwnProperty.call(g, "hideReportABug") && e.uint32(
        /* id 4, wireType 0 =*/
        32
      ).bool(g.hideReportABug), g.aboutSectionMd != null && Object.hasOwnProperty.call(g, "aboutSectionMd") && e.uint32(
        /* id 5, wireType 2 =*/
        42
      ).string(g.aboutSectionMd), g.clearAboutMd != null && Object.hasOwnProperty.call(g, "clearAboutMd") && e.uint32(
        /* id 6, wireType 0 =*/
        48
      ).bool(g.clearAboutMd), e;
    }, E.decode = function(g, e, t) {
      g instanceof $Reader$1 || (g = $Reader$1.create(g));
      let c = e === void 0 ? g.len : g.pos + e, n = new $root$1.PageConfig.MenuItems();
      for (; g.pos < c; ) {
        let h = g.uint32();
        if (h === t) break;
        switch (h >>> 3) {
          case 1: {
            n.getHelpUrl = g.string();
            break;
          }
          case 2: {
            n.hideGetHelp = g.bool();
            break;
          }
          case 3: {
            n.reportABugUrl = g.string();
            break;
          }
          case 4: {
            n.hideReportABug = g.bool();
            break;
          }
          case 5: {
            n.aboutSectionMd = g.string();
            break;
          }
          case 6: {
            n.clearAboutMd = g.bool();
            break;
          }
          default:
            g.skipType(h & 7);
            break;
        }
      }
      return n;
    }, E.fromObject = function(g) {
      if (g instanceof $root$1.PageConfig.MenuItems) return g;
      let e = new $root$1.PageConfig.MenuItems();
      return g.getHelpUrl != null && (e.getHelpUrl = String(g.getHelpUrl)), g.hideGetHelp != null && (e.hideGetHelp = !!g.hideGetHelp), g.reportABugUrl != null && (e.reportABugUrl = String(g.reportABugUrl)), g.hideReportABug != null && (e.hideReportABug = !!g.hideReportABug), g.aboutSectionMd != null && (e.aboutSectionMd = String(g.aboutSectionMd)), g.clearAboutMd != null && (e.clearAboutMd = !!g.clearAboutMd), e;
    }, E.toObject = function(g, e) {
      e || (e = {});
      let t = {};
      return e.defaults && (t.getHelpUrl = "", t.hideGetHelp = !1, t.reportABugUrl = "", t.hideReportABug = !1, t.aboutSectionMd = "", t.clearAboutMd = !1), g.getHelpUrl != null && g.hasOwnProperty("getHelpUrl") && (t.getHelpUrl = g.getHelpUrl), g.hideGetHelp != null && g.hasOwnProperty("hideGetHelp") && (t.hideGetHelp = g.hideGetHelp), g.reportABugUrl != null && g.hasOwnProperty("reportABugUrl") && (t.reportABugUrl = g.reportABugUrl), g.hideReportABug != null && g.hasOwnProperty("hideReportABug") && (t.hideReportABug = g.hideReportABug), g.aboutSectionMd != null && g.hasOwnProperty("aboutSectionMd") && (t.aboutSectionMd = g.aboutSectionMd), g.clearAboutMd != null && g.hasOwnProperty("clearAboutMd") && (t.clearAboutMd = g.clearAboutMd), t;
    }, E.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
    }, E.getTypeUrl = function(g) {
      return g === void 0 && (g = "type.googleapis.com"), g + "/PageConfig.MenuItems";
    }, E;
  })(), o.Layout = (function() {
    const E = {}, A = Object.create(E);
    return A[E[0] = "CENTERED"] = 0, A[E[1] = "WIDE"] = 1, A[E[2] = "LAYOUT_UNSET"] = 2, A;
  })(), o.SidebarState = (function() {
    const E = {}, A = Object.create(E);
    return A[E[0] = "AUTO"] = 0, A[E[1] = "EXPANDED"] = 1, A[E[2] = "COLLAPSED"] = 2, A[E[3] = "SIDEBAR_UNSET"] = 3, A;
  })(), o;
})();
$root$1.PageInfo = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.queryString = "", o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    return g || (g = $Writer$1.create()), A.queryString != null && Object.hasOwnProperty.call(A, "queryString") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(A.queryString), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader$1 || (A = $Reader$1.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root$1.PageInfo();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.queryString = A.string();
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root$1.PageInfo) return A;
    let g = new $root$1.PageInfo();
    return A.queryString != null && (g.queryString = String(A.queryString)), g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    return g.defaults && (e.queryString = ""), A.queryString != null && A.hasOwnProperty("queryString") && (e.queryString = A.queryString), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/PageInfo";
  }, o;
})();
const PageProfile = $root$1.PageProfile = (() => {
  function o(E) {
    if (this.commands = [], this.config = [], this.attributions = [], E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.commands = $util$1.emptyArray, o.prototype.execTime = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, o.prototype.prepTime = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, o.prototype.config = $util$1.emptyArray, o.prototype.uncaughtException = "", o.prototype.attributions = $util$1.emptyArray, o.prototype.os = "", o.prototype.timezone = "", o.prototype.headless = !1, o.prototype.isFragmentRun = !1, o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    if (g || (g = $Writer$1.create()), A.commands != null && A.commands.length) for (let e = 0; e < A.commands.length; ++e) $root$1.Command.encode(A.commands[e], g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim();
    if (A.execTime != null && Object.hasOwnProperty.call(A, "execTime") && g.uint32(
      /* id 2, wireType 0 =*/
      16
    ).int64(A.execTime), A.prepTime != null && Object.hasOwnProperty.call(A, "prepTime") && g.uint32(
      /* id 3, wireType 0 =*/
      24
    ).int64(A.prepTime), A.config != null && A.config.length) for (let e = 0; e < A.config.length; ++e) g.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(A.config[e]);
    if (A.uncaughtException != null && Object.hasOwnProperty.call(A, "uncaughtException") && g.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(A.uncaughtException), A.attributions != null && A.attributions.length) for (let e = 0; e < A.attributions.length; ++e) g.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(A.attributions[e]);
    return A.os != null && Object.hasOwnProperty.call(A, "os") && g.uint32(
      /* id 8, wireType 2 =*/
      66
    ).string(A.os), A.timezone != null && Object.hasOwnProperty.call(A, "timezone") && g.uint32(
      /* id 9, wireType 2 =*/
      74
    ).string(A.timezone), A.headless != null && Object.hasOwnProperty.call(A, "headless") && g.uint32(
      /* id 10, wireType 0 =*/
      80
    ).bool(A.headless), A.isFragmentRun != null && Object.hasOwnProperty.call(A, "isFragmentRun") && g.uint32(
      /* id 11, wireType 0 =*/
      88
    ).bool(A.isFragmentRun), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader$1 || (A = $Reader$1.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root$1.PageProfile();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.commands && c.commands.length || (c.commands = []), c.commands.push($root$1.Command.decode(A, A.uint32()));
          break;
        }
        case 2: {
          c.execTime = A.int64();
          break;
        }
        case 3: {
          c.prepTime = A.int64();
          break;
        }
        case 5: {
          c.config && c.config.length || (c.config = []), c.config.push(A.string());
          break;
        }
        case 6: {
          c.uncaughtException = A.string();
          break;
        }
        case 7: {
          c.attributions && c.attributions.length || (c.attributions = []), c.attributions.push(A.string());
          break;
        }
        case 8: {
          c.os = A.string();
          break;
        }
        case 9: {
          c.timezone = A.string();
          break;
        }
        case 10: {
          c.headless = A.bool();
          break;
        }
        case 11: {
          c.isFragmentRun = A.bool();
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root$1.PageProfile) return A;
    let g = new $root$1.PageProfile();
    if (A.commands) {
      if (!Array.isArray(A.commands)) throw TypeError(".PageProfile.commands: array expected");
      g.commands = [];
      for (let e = 0; e < A.commands.length; ++e) {
        if (typeof A.commands[e] != "object") throw TypeError(".PageProfile.commands: object expected");
        g.commands[e] = $root$1.Command.fromObject(A.commands[e]);
      }
    }
    if (A.execTime != null && ($util$1.Long ? (g.execTime = $util$1.Long.fromValue(A.execTime)).unsigned = !1 : typeof A.execTime == "string" ? g.execTime = parseInt(A.execTime, 10) : typeof A.execTime == "number" ? g.execTime = A.execTime : typeof A.execTime == "object" && (g.execTime = new $util$1.LongBits(A.execTime.low >>> 0, A.execTime.high >>> 0).toNumber())), A.prepTime != null && ($util$1.Long ? (g.prepTime = $util$1.Long.fromValue(A.prepTime)).unsigned = !1 : typeof A.prepTime == "string" ? g.prepTime = parseInt(A.prepTime, 10) : typeof A.prepTime == "number" ? g.prepTime = A.prepTime : typeof A.prepTime == "object" && (g.prepTime = new $util$1.LongBits(A.prepTime.low >>> 0, A.prepTime.high >>> 0).toNumber())), A.config) {
      if (!Array.isArray(A.config)) throw TypeError(".PageProfile.config: array expected");
      g.config = [];
      for (let e = 0; e < A.config.length; ++e) g.config[e] = String(A.config[e]);
    }
    if (A.uncaughtException != null && (g.uncaughtException = String(A.uncaughtException)), A.attributions) {
      if (!Array.isArray(A.attributions)) throw TypeError(".PageProfile.attributions: array expected");
      g.attributions = [];
      for (let e = 0; e < A.attributions.length; ++e) g.attributions[e] = String(A.attributions[e]);
    }
    return A.os != null && (g.os = String(A.os)), A.timezone != null && (g.timezone = String(A.timezone)), A.headless != null && (g.headless = !!A.headless), A.isFragmentRun != null && (g.isFragmentRun = !!A.isFragmentRun), g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    if ((g.arrays || g.defaults) && (e.commands = [], e.config = [], e.attributions = []), g.defaults) {
      if ($util$1.Long) {
        let t = new $util$1.Long(0, 0, !1);
        e.execTime = g.longs === String ? t.toString() : g.longs === Number ? t.toNumber() : t;
      } else e.execTime = g.longs === String ? "0" : 0;
      if ($util$1.Long) {
        let t = new $util$1.Long(0, 0, !1);
        e.prepTime = g.longs === String ? t.toString() : g.longs === Number ? t.toNumber() : t;
      } else e.prepTime = g.longs === String ? "0" : 0;
      e.uncaughtException = "", e.os = "", e.timezone = "", e.headless = !1, e.isFragmentRun = !1;
    }
    if (A.commands && A.commands.length) {
      e.commands = [];
      for (let t = 0; t < A.commands.length; ++t) e.commands[t] = $root$1.Command.toObject(A.commands[t], g);
    }
    if (A.execTime != null && A.hasOwnProperty("execTime") && (typeof A.execTime == "number" ? e.execTime = g.longs === String ? String(A.execTime) : A.execTime : e.execTime = g.longs === String ? $util$1.Long.prototype.toString.call(A.execTime) : g.longs === Number ? new $util$1.LongBits(A.execTime.low >>> 0, A.execTime.high >>> 0).toNumber() : A.execTime), A.prepTime != null && A.hasOwnProperty("prepTime") && (typeof A.prepTime == "number" ? e.prepTime = g.longs === String ? String(A.prepTime) : A.prepTime : e.prepTime = g.longs === String ? $util$1.Long.prototype.toString.call(A.prepTime) : g.longs === Number ? new $util$1.LongBits(A.prepTime.low >>> 0, A.prepTime.high >>> 0).toNumber() : A.prepTime), A.config && A.config.length) {
      e.config = [];
      for (let t = 0; t < A.config.length; ++t) e.config[t] = A.config[t];
    }
    if (A.uncaughtException != null && A.hasOwnProperty("uncaughtException") && (e.uncaughtException = A.uncaughtException), A.attributions && A.attributions.length) {
      e.attributions = [];
      for (let t = 0; t < A.attributions.length; ++t) e.attributions[t] = A.attributions[t];
    }
    return A.os != null && A.hasOwnProperty("os") && (e.os = A.os), A.timezone != null && A.hasOwnProperty("timezone") && (e.timezone = A.timezone), A.headless != null && A.hasOwnProperty("headless") && (e.headless = A.headless), A.isFragmentRun != null && A.hasOwnProperty("isFragmentRun") && (e.isFragmentRun = A.isFragmentRun), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/PageProfile";
  }, o;
})();
$root$1.Argument = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.k = "", o.prototype.t = "", o.prototype.m = "", o.prototype.p = 0, o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    return g || (g = $Writer$1.create()), A.k != null && Object.hasOwnProperty.call(A, "k") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(A.k), A.t != null && Object.hasOwnProperty.call(A, "t") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(A.t), A.m != null && Object.hasOwnProperty.call(A, "m") && g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(A.m), A.p != null && Object.hasOwnProperty.call(A, "p") && g.uint32(
      /* id 5, wireType 0 =*/
      40
    ).int32(A.p), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader$1 || (A = $Reader$1.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root$1.Argument();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.k = A.string();
          break;
        }
        case 2: {
          c.t = A.string();
          break;
        }
        case 3: {
          c.m = A.string();
          break;
        }
        case 5: {
          c.p = A.int32();
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root$1.Argument) return A;
    let g = new $root$1.Argument();
    return A.k != null && (g.k = String(A.k)), A.t != null && (g.t = String(A.t)), A.m != null && (g.m = String(A.m)), A.p != null && (g.p = A.p | 0), g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    return g.defaults && (e.k = "", e.t = "", e.m = "", e.p = 0), A.k != null && A.hasOwnProperty("k") && (e.k = A.k), A.t != null && A.hasOwnProperty("t") && (e.t = A.t), A.m != null && A.hasOwnProperty("m") && (e.m = A.m), A.p != null && A.hasOwnProperty("p") && (e.p = A.p), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/Argument";
  }, o;
})();
$root$1.Command = (() => {
  function o(E) {
    if (this.args = [], E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.name = "", o.prototype.args = $util$1.emptyArray, o.prototype.time = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    if (g || (g = $Writer$1.create()), A.name != null && Object.hasOwnProperty.call(A, "name") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(A.name), A.args != null && A.args.length) for (let e = 0; e < A.args.length; ++e) $root$1.Argument.encode(A.args[e], g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim();
    return A.time != null && Object.hasOwnProperty.call(A, "time") && g.uint32(
      /* id 4, wireType 0 =*/
      32
    ).int64(A.time), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader$1 || (A = $Reader$1.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root$1.Command();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.name = A.string();
          break;
        }
        case 2: {
          c.args && c.args.length || (c.args = []), c.args.push($root$1.Argument.decode(A, A.uint32()));
          break;
        }
        case 4: {
          c.time = A.int64();
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root$1.Command) return A;
    let g = new $root$1.Command();
    if (A.name != null && (g.name = String(A.name)), A.args) {
      if (!Array.isArray(A.args)) throw TypeError(".Command.args: array expected");
      g.args = [];
      for (let e = 0; e < A.args.length; ++e) {
        if (typeof A.args[e] != "object") throw TypeError(".Command.args: object expected");
        g.args[e] = $root$1.Argument.fromObject(A.args[e]);
      }
    }
    return A.time != null && ($util$1.Long ? (g.time = $util$1.Long.fromValue(A.time)).unsigned = !1 : typeof A.time == "string" ? g.time = parseInt(A.time, 10) : typeof A.time == "number" ? g.time = A.time : typeof A.time == "object" && (g.time = new $util$1.LongBits(A.time.low >>> 0, A.time.high >>> 0).toNumber())), g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    if ((g.arrays || g.defaults) && (e.args = []), g.defaults)
      if (e.name = "", $util$1.Long) {
        let t = new $util$1.Long(0, 0, !1);
        e.time = g.longs === String ? t.toString() : g.longs === Number ? t.toNumber() : t;
      } else e.time = g.longs === String ? "0" : 0;
    if (A.name != null && A.hasOwnProperty("name") && (e.name = A.name), A.args && A.args.length) {
      e.args = [];
      for (let t = 0; t < A.args.length; ++t) e.args[t] = $root$1.Argument.toObject(A.args[t], g);
    }
    return A.time != null && A.hasOwnProperty("time") && (typeof A.time == "number" ? e.time = g.longs === String ? String(A.time) : A.time : e.time = g.longs === String ? $util$1.Long.prototype.toString.call(A.time) : g.longs === Number ? new $util$1.LongBits(A.time.low >>> 0, A.time.high >>> 0).toNumber() : A.time), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/Command";
  }, o;
})();
$root$1.PageNotFound = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.pageName = "", o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    return g || (g = $Writer$1.create()), A.pageName != null && Object.hasOwnProperty.call(A, "pageName") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(A.pageName), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader$1 || (A = $Reader$1.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root$1.PageNotFound();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.pageName = A.string();
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root$1.PageNotFound) return A;
    let g = new $root$1.PageNotFound();
    return A.pageName != null && (g.pageName = String(A.pageName)), g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    return g.defaults && (e.pageName = ""), A.pageName != null && A.hasOwnProperty("pageName") && (e.pageName = A.pageName), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/PageNotFound";
  }, o;
})();
$root$1.PagesChanged = (() => {
  function o(E) {
    if (this.appPages = [], E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.appPages = $util$1.emptyArray, o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    if (g || (g = $Writer$1.create()), A.appPages != null && A.appPages.length) for (let e = 0; e < A.appPages.length; ++e) $root$1.AppPage.encode(A.appPages[e], g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim();
    return g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader$1 || (A = $Reader$1.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root$1.PagesChanged();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.appPages && c.appPages.length || (c.appPages = []), c.appPages.push($root$1.AppPage.decode(A, A.uint32()));
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root$1.PagesChanged) return A;
    let g = new $root$1.PagesChanged();
    if (A.appPages) {
      if (!Array.isArray(A.appPages)) throw TypeError(".PagesChanged.appPages: array expected");
      g.appPages = [];
      for (let e = 0; e < A.appPages.length; ++e) {
        if (typeof A.appPages[e] != "object") throw TypeError(".PagesChanged.appPages: object expected");
        g.appPages[e] = $root$1.AppPage.fromObject(A.appPages[e]);
      }
    }
    return g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    if ((g.arrays || g.defaults) && (e.appPages = []), A.appPages && A.appPages.length) {
      e.appPages = [];
      for (let t = 0; t < A.appPages.length; ++t) e.appPages[t] = $root$1.AppPage.toObject(A.appPages[t], g);
    }
    return e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/PagesChanged";
  }, o;
})();
$root$1.ParentMessage = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.message = "", o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    return g || (g = $Writer$1.create()), A.message != null && Object.hasOwnProperty.call(A, "message") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(A.message), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader$1 || (A = $Reader$1.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root$1.ParentMessage();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.message = A.string();
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root$1.ParentMessage) return A;
    let g = new $root$1.ParentMessage();
    return A.message != null && (g.message = String(A.message)), g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    return g.defaults && (e.message = ""), A.message != null && A.hasOwnProperty("message") && (e.message = A.message), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/ParentMessage";
  }, o;
})();
$root$1.SessionEvent = (() => {
  function o(A) {
    if (A) for (let g = Object.keys(A), e = 0; e < g.length; ++e) A[g[e]] != null && (this[g[e]] = A[g[e]]);
  }
  o.prototype.scriptChangedOnDisk = null, o.prototype.scriptWasManuallyStopped = null, o.prototype.scriptCompilationException = null;
  let E;
  return Object.defineProperty(o.prototype, "type", { get: $util$1.oneOfGetter(E = ["scriptChangedOnDisk", "scriptWasManuallyStopped", "scriptCompilationException"]), set: $util$1.oneOfSetter(E) }), o.create = function(g) {
    return new o(g);
  }, o.encode = function(g, e) {
    return e || (e = $Writer$1.create()), g.scriptChangedOnDisk != null && Object.hasOwnProperty.call(g, "scriptChangedOnDisk") && e.uint32(
      /* id 1, wireType 0 =*/
      8
    ).bool(g.scriptChangedOnDisk), g.scriptWasManuallyStopped != null && Object.hasOwnProperty.call(g, "scriptWasManuallyStopped") && e.uint32(
      /* id 2, wireType 0 =*/
      16
    ).bool(g.scriptWasManuallyStopped), g.scriptCompilationException != null && Object.hasOwnProperty.call(g, "scriptCompilationException") && $root$1.Exception.encode(g.scriptCompilationException, e.uint32(
      /* id 3, wireType 2 =*/
      26
    ).fork()).ldelim(), e;
  }, o.decode = function(g, e, t) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let c = e === void 0 ? g.len : g.pos + e, n = new $root$1.SessionEvent();
    for (; g.pos < c; ) {
      let h = g.uint32();
      if (h === t) break;
      switch (h >>> 3) {
        case 1: {
          n.scriptChangedOnDisk = g.bool();
          break;
        }
        case 2: {
          n.scriptWasManuallyStopped = g.bool();
          break;
        }
        case 3: {
          n.scriptCompilationException = $root$1.Exception.decode(g, g.uint32());
          break;
        }
        default:
          g.skipType(h & 7);
          break;
      }
    }
    return n;
  }, o.fromObject = function(g) {
    if (g instanceof $root$1.SessionEvent) return g;
    let e = new $root$1.SessionEvent();
    if (g.scriptChangedOnDisk != null && (e.scriptChangedOnDisk = !!g.scriptChangedOnDisk), g.scriptWasManuallyStopped != null && (e.scriptWasManuallyStopped = !!g.scriptWasManuallyStopped), g.scriptCompilationException != null) {
      if (typeof g.scriptCompilationException != "object") throw TypeError(".SessionEvent.scriptCompilationException: object expected");
      e.scriptCompilationException = $root$1.Exception.fromObject(g.scriptCompilationException);
    }
    return e;
  }, o.toObject = function(g, e) {
    e || (e = {});
    let t = {};
    return g.scriptChangedOnDisk != null && g.hasOwnProperty("scriptChangedOnDisk") && (t.scriptChangedOnDisk = g.scriptChangedOnDisk, e.oneofs && (t.type = "scriptChangedOnDisk")), g.scriptWasManuallyStopped != null && g.hasOwnProperty("scriptWasManuallyStopped") && (t.scriptWasManuallyStopped = g.scriptWasManuallyStopped, e.oneofs && (t.type = "scriptWasManuallyStopped")), g.scriptCompilationException != null && g.hasOwnProperty("scriptCompilationException") && (t.scriptCompilationException = $root$1.Exception.toObject(g.scriptCompilationException, e), e.oneofs && (t.type = "scriptCompilationException")), t;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/SessionEvent";
  }, o;
})();
const MetricsEvent = $root$1.MetricsEvent = (() => {
  function o(E) {
    if (this.commands = [], this.config = [], this.attributions = [], E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.event = "", o.prototype.anonymousId = "", o.prototype.machineIdV3 = "", o.prototype.machineIdV4 = "", o.prototype.reportHash = "", o.prototype.dev = !1, o.prototype.source = "", o.prototype.streamlitVersion = "", o.prototype.isHello = !1, o.prototype.appId = "", o.prototype.sessionId = "", o.prototype.pythonVersion = "", o.prototype.serverOs = "", o.prototype.hasDisplay = !1, o.prototype.isWebdriver = !1, o.prototype.hostedAt = "", o.prototype.owner = "", o.prototype.repo = "", o.prototype.branch = "", o.prototype.mainModule = "", o.prototype.creatorId = "", o.prototype.contextPageUrl = "", o.prototype.contextPageTitle = "", o.prototype.contextPagePath = "", o.prototype.contextPageReferrer = "", o.prototype.contextPageSearch = "", o.prototype.contextLocale = "", o.prototype.contextUserAgent = "", o.prototype.label = "", o.prototype.commands = $util$1.emptyArray, o.prototype.execTime = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, o.prototype.prepTime = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, o.prototype.config = $util$1.emptyArray, o.prototype.uncaughtException = "", o.prototype.attributions = $util$1.emptyArray, o.prototype.os = "", o.prototype.timezone = "", o.prototype.headless = !1, o.prototype.isFragmentRun = !1, o.prototype.numPages = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, o.prototype.pageScriptHash = "", o.prototype.activeTheme = "", o.prototype.totalLoadTime = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, o.prototype.browserInfo = null, o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    if (g || (g = $Writer$1.create()), A.event != null && Object.hasOwnProperty.call(A, "event") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(A.event), A.anonymousId != null && Object.hasOwnProperty.call(A, "anonymousId") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(A.anonymousId), A.machineIdV3 != null && Object.hasOwnProperty.call(A, "machineIdV3") && g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(A.machineIdV3), A.reportHash != null && Object.hasOwnProperty.call(A, "reportHash") && g.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(A.reportHash), A.dev != null && Object.hasOwnProperty.call(A, "dev") && g.uint32(
      /* id 5, wireType 0 =*/
      40
    ).bool(A.dev), A.source != null && Object.hasOwnProperty.call(A, "source") && g.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(A.source), A.streamlitVersion != null && Object.hasOwnProperty.call(A, "streamlitVersion") && g.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(A.streamlitVersion), A.isHello != null && Object.hasOwnProperty.call(A, "isHello") && g.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(A.isHello), A.hostedAt != null && Object.hasOwnProperty.call(A, "hostedAt") && g.uint32(
      /* id 9, wireType 2 =*/
      74
    ).string(A.hostedAt), A.owner != null && Object.hasOwnProperty.call(A, "owner") && g.uint32(
      /* id 10, wireType 2 =*/
      82
    ).string(A.owner), A.repo != null && Object.hasOwnProperty.call(A, "repo") && g.uint32(
      /* id 11, wireType 2 =*/
      90
    ).string(A.repo), A.branch != null && Object.hasOwnProperty.call(A, "branch") && g.uint32(
      /* id 12, wireType 2 =*/
      98
    ).string(A.branch), A.mainModule != null && Object.hasOwnProperty.call(A, "mainModule") && g.uint32(
      /* id 13, wireType 2 =*/
      106
    ).string(A.mainModule), A.creatorId != null && Object.hasOwnProperty.call(A, "creatorId") && g.uint32(
      /* id 14, wireType 2 =*/
      114
    ).string(A.creatorId), A.contextPageUrl != null && Object.hasOwnProperty.call(A, "contextPageUrl") && g.uint32(
      /* id 15, wireType 2 =*/
      122
    ).string(A.contextPageUrl), A.contextPageTitle != null && Object.hasOwnProperty.call(A, "contextPageTitle") && g.uint32(
      /* id 16, wireType 2 =*/
      130
    ).string(A.contextPageTitle), A.contextPagePath != null && Object.hasOwnProperty.call(A, "contextPagePath") && g.uint32(
      /* id 17, wireType 2 =*/
      138
    ).string(A.contextPagePath), A.contextPageReferrer != null && Object.hasOwnProperty.call(A, "contextPageReferrer") && g.uint32(
      /* id 18, wireType 2 =*/
      146
    ).string(A.contextPageReferrer), A.contextPageSearch != null && Object.hasOwnProperty.call(A, "contextPageSearch") && g.uint32(
      /* id 19, wireType 2 =*/
      154
    ).string(A.contextPageSearch), A.contextLocale != null && Object.hasOwnProperty.call(A, "contextLocale") && g.uint32(
      /* id 20, wireType 2 =*/
      162
    ).string(A.contextLocale), A.contextUserAgent != null && Object.hasOwnProperty.call(A, "contextUserAgent") && g.uint32(
      /* id 21, wireType 2 =*/
      170
    ).string(A.contextUserAgent), A.label != null && Object.hasOwnProperty.call(A, "label") && g.uint32(
      /* id 22, wireType 2 =*/
      178
    ).string(A.label), A.commands != null && A.commands.length) for (let e = 0; e < A.commands.length; ++e) $root$1.Command.encode(A.commands[e], g.uint32(
      /* id 23, wireType 2 =*/
      186
    ).fork()).ldelim();
    if (A.execTime != null && Object.hasOwnProperty.call(A, "execTime") && g.uint32(
      /* id 24, wireType 0 =*/
      192
    ).int64(A.execTime), A.prepTime != null && Object.hasOwnProperty.call(A, "prepTime") && g.uint32(
      /* id 25, wireType 0 =*/
      200
    ).int64(A.prepTime), A.config != null && A.config.length) for (let e = 0; e < A.config.length; ++e) g.uint32(
      /* id 26, wireType 2 =*/
      210
    ).string(A.config[e]);
    if (A.uncaughtException != null && Object.hasOwnProperty.call(A, "uncaughtException") && g.uint32(
      /* id 27, wireType 2 =*/
      218
    ).string(A.uncaughtException), A.attributions != null && A.attributions.length) for (let e = 0; e < A.attributions.length; ++e) g.uint32(
      /* id 28, wireType 2 =*/
      226
    ).string(A.attributions[e]);
    return A.os != null && Object.hasOwnProperty.call(A, "os") && g.uint32(
      /* id 29, wireType 2 =*/
      234
    ).string(A.os), A.timezone != null && Object.hasOwnProperty.call(A, "timezone") && g.uint32(
      /* id 30, wireType 2 =*/
      242
    ).string(A.timezone), A.headless != null && Object.hasOwnProperty.call(A, "headless") && g.uint32(
      /* id 31, wireType 0 =*/
      248
    ).bool(A.headless), A.isFragmentRun != null && Object.hasOwnProperty.call(A, "isFragmentRun") && g.uint32(
      /* id 32, wireType 0 =*/
      256
    ).bool(A.isFragmentRun), A.appId != null && Object.hasOwnProperty.call(A, "appId") && g.uint32(
      /* id 33, wireType 2 =*/
      266
    ).string(A.appId), A.numPages != null && Object.hasOwnProperty.call(A, "numPages") && g.uint32(
      /* id 34, wireType 0 =*/
      272
    ).int64(A.numPages), A.sessionId != null && Object.hasOwnProperty.call(A, "sessionId") && g.uint32(
      /* id 35, wireType 2 =*/
      282
    ).string(A.sessionId), A.pythonVersion != null && Object.hasOwnProperty.call(A, "pythonVersion") && g.uint32(
      /* id 36, wireType 2 =*/
      290
    ).string(A.pythonVersion), A.pageScriptHash != null && Object.hasOwnProperty.call(A, "pageScriptHash") && g.uint32(
      /* id 37, wireType 2 =*/
      298
    ).string(A.pageScriptHash), A.activeTheme != null && Object.hasOwnProperty.call(A, "activeTheme") && g.uint32(
      /* id 38, wireType 2 =*/
      306
    ).string(A.activeTheme), A.totalLoadTime != null && Object.hasOwnProperty.call(A, "totalLoadTime") && g.uint32(
      /* id 39, wireType 0 =*/
      312
    ).int64(A.totalLoadTime), A.browserInfo != null && Object.hasOwnProperty.call(A, "browserInfo") && $root$1.BrowserInfo.encode(A.browserInfo, g.uint32(
      /* id 40, wireType 2 =*/
      322
    ).fork()).ldelim(), A.machineIdV4 != null && Object.hasOwnProperty.call(A, "machineIdV4") && g.uint32(
      /* id 41, wireType 2 =*/
      330
    ).string(A.machineIdV4), A.serverOs != null && Object.hasOwnProperty.call(A, "serverOs") && g.uint32(
      /* id 42, wireType 2 =*/
      338
    ).string(A.serverOs), A.hasDisplay != null && Object.hasOwnProperty.call(A, "hasDisplay") && g.uint32(
      /* id 43, wireType 0 =*/
      344
    ).bool(A.hasDisplay), A.isWebdriver != null && Object.hasOwnProperty.call(A, "isWebdriver") && g.uint32(
      /* id 44, wireType 0 =*/
      352
    ).bool(A.isWebdriver), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader$1 || (A = $Reader$1.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root$1.MetricsEvent();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.event = A.string();
          break;
        }
        case 2: {
          c.anonymousId = A.string();
          break;
        }
        case 3: {
          c.machineIdV3 = A.string();
          break;
        }
        case 41: {
          c.machineIdV4 = A.string();
          break;
        }
        case 4: {
          c.reportHash = A.string();
          break;
        }
        case 5: {
          c.dev = A.bool();
          break;
        }
        case 6: {
          c.source = A.string();
          break;
        }
        case 7: {
          c.streamlitVersion = A.string();
          break;
        }
        case 8: {
          c.isHello = A.bool();
          break;
        }
        case 33: {
          c.appId = A.string();
          break;
        }
        case 35: {
          c.sessionId = A.string();
          break;
        }
        case 36: {
          c.pythonVersion = A.string();
          break;
        }
        case 42: {
          c.serverOs = A.string();
          break;
        }
        case 43: {
          c.hasDisplay = A.bool();
          break;
        }
        case 44: {
          c.isWebdriver = A.bool();
          break;
        }
        case 9: {
          c.hostedAt = A.string();
          break;
        }
        case 10: {
          c.owner = A.string();
          break;
        }
        case 11: {
          c.repo = A.string();
          break;
        }
        case 12: {
          c.branch = A.string();
          break;
        }
        case 13: {
          c.mainModule = A.string();
          break;
        }
        case 14: {
          c.creatorId = A.string();
          break;
        }
        case 15: {
          c.contextPageUrl = A.string();
          break;
        }
        case 16: {
          c.contextPageTitle = A.string();
          break;
        }
        case 17: {
          c.contextPagePath = A.string();
          break;
        }
        case 18: {
          c.contextPageReferrer = A.string();
          break;
        }
        case 19: {
          c.contextPageSearch = A.string();
          break;
        }
        case 20: {
          c.contextLocale = A.string();
          break;
        }
        case 21: {
          c.contextUserAgent = A.string();
          break;
        }
        case 22: {
          c.label = A.string();
          break;
        }
        case 23: {
          c.commands && c.commands.length || (c.commands = []), c.commands.push($root$1.Command.decode(A, A.uint32()));
          break;
        }
        case 24: {
          c.execTime = A.int64();
          break;
        }
        case 25: {
          c.prepTime = A.int64();
          break;
        }
        case 26: {
          c.config && c.config.length || (c.config = []), c.config.push(A.string());
          break;
        }
        case 27: {
          c.uncaughtException = A.string();
          break;
        }
        case 28: {
          c.attributions && c.attributions.length || (c.attributions = []), c.attributions.push(A.string());
          break;
        }
        case 29: {
          c.os = A.string();
          break;
        }
        case 30: {
          c.timezone = A.string();
          break;
        }
        case 31: {
          c.headless = A.bool();
          break;
        }
        case 32: {
          c.isFragmentRun = A.bool();
          break;
        }
        case 34: {
          c.numPages = A.int64();
          break;
        }
        case 37: {
          c.pageScriptHash = A.string();
          break;
        }
        case 38: {
          c.activeTheme = A.string();
          break;
        }
        case 39: {
          c.totalLoadTime = A.int64();
          break;
        }
        case 40: {
          c.browserInfo = $root$1.BrowserInfo.decode(A, A.uint32());
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root$1.MetricsEvent) return A;
    let g = new $root$1.MetricsEvent();
    if (A.event != null && (g.event = String(A.event)), A.anonymousId != null && (g.anonymousId = String(A.anonymousId)), A.machineIdV3 != null && (g.machineIdV3 = String(A.machineIdV3)), A.machineIdV4 != null && (g.machineIdV4 = String(A.machineIdV4)), A.reportHash != null && (g.reportHash = String(A.reportHash)), A.dev != null && (g.dev = !!A.dev), A.source != null && (g.source = String(A.source)), A.streamlitVersion != null && (g.streamlitVersion = String(A.streamlitVersion)), A.isHello != null && (g.isHello = !!A.isHello), A.appId != null && (g.appId = String(A.appId)), A.sessionId != null && (g.sessionId = String(A.sessionId)), A.pythonVersion != null && (g.pythonVersion = String(A.pythonVersion)), A.serverOs != null && (g.serverOs = String(A.serverOs)), A.hasDisplay != null && (g.hasDisplay = !!A.hasDisplay), A.isWebdriver != null && (g.isWebdriver = !!A.isWebdriver), A.hostedAt != null && (g.hostedAt = String(A.hostedAt)), A.owner != null && (g.owner = String(A.owner)), A.repo != null && (g.repo = String(A.repo)), A.branch != null && (g.branch = String(A.branch)), A.mainModule != null && (g.mainModule = String(A.mainModule)), A.creatorId != null && (g.creatorId = String(A.creatorId)), A.contextPageUrl != null && (g.contextPageUrl = String(A.contextPageUrl)), A.contextPageTitle != null && (g.contextPageTitle = String(A.contextPageTitle)), A.contextPagePath != null && (g.contextPagePath = String(A.contextPagePath)), A.contextPageReferrer != null && (g.contextPageReferrer = String(A.contextPageReferrer)), A.contextPageSearch != null && (g.contextPageSearch = String(A.contextPageSearch)), A.contextLocale != null && (g.contextLocale = String(A.contextLocale)), A.contextUserAgent != null && (g.contextUserAgent = String(A.contextUserAgent)), A.label != null && (g.label = String(A.label)), A.commands) {
      if (!Array.isArray(A.commands)) throw TypeError(".MetricsEvent.commands: array expected");
      g.commands = [];
      for (let e = 0; e < A.commands.length; ++e) {
        if (typeof A.commands[e] != "object") throw TypeError(".MetricsEvent.commands: object expected");
        g.commands[e] = $root$1.Command.fromObject(A.commands[e]);
      }
    }
    if (A.execTime != null && ($util$1.Long ? (g.execTime = $util$1.Long.fromValue(A.execTime)).unsigned = !1 : typeof A.execTime == "string" ? g.execTime = parseInt(A.execTime, 10) : typeof A.execTime == "number" ? g.execTime = A.execTime : typeof A.execTime == "object" && (g.execTime = new $util$1.LongBits(A.execTime.low >>> 0, A.execTime.high >>> 0).toNumber())), A.prepTime != null && ($util$1.Long ? (g.prepTime = $util$1.Long.fromValue(A.prepTime)).unsigned = !1 : typeof A.prepTime == "string" ? g.prepTime = parseInt(A.prepTime, 10) : typeof A.prepTime == "number" ? g.prepTime = A.prepTime : typeof A.prepTime == "object" && (g.prepTime = new $util$1.LongBits(A.prepTime.low >>> 0, A.prepTime.high >>> 0).toNumber())), A.config) {
      if (!Array.isArray(A.config)) throw TypeError(".MetricsEvent.config: array expected");
      g.config = [];
      for (let e = 0; e < A.config.length; ++e) g.config[e] = String(A.config[e]);
    }
    if (A.uncaughtException != null && (g.uncaughtException = String(A.uncaughtException)), A.attributions) {
      if (!Array.isArray(A.attributions)) throw TypeError(".MetricsEvent.attributions: array expected");
      g.attributions = [];
      for (let e = 0; e < A.attributions.length; ++e) g.attributions[e] = String(A.attributions[e]);
    }
    if (A.os != null && (g.os = String(A.os)), A.timezone != null && (g.timezone = String(A.timezone)), A.headless != null && (g.headless = !!A.headless), A.isFragmentRun != null && (g.isFragmentRun = !!A.isFragmentRun), A.numPages != null && ($util$1.Long ? (g.numPages = $util$1.Long.fromValue(A.numPages)).unsigned = !1 : typeof A.numPages == "string" ? g.numPages = parseInt(A.numPages, 10) : typeof A.numPages == "number" ? g.numPages = A.numPages : typeof A.numPages == "object" && (g.numPages = new $util$1.LongBits(A.numPages.low >>> 0, A.numPages.high >>> 0).toNumber())), A.pageScriptHash != null && (g.pageScriptHash = String(A.pageScriptHash)), A.activeTheme != null && (g.activeTheme = String(A.activeTheme)), A.totalLoadTime != null && ($util$1.Long ? (g.totalLoadTime = $util$1.Long.fromValue(A.totalLoadTime)).unsigned = !1 : typeof A.totalLoadTime == "string" ? g.totalLoadTime = parseInt(A.totalLoadTime, 10) : typeof A.totalLoadTime == "number" ? g.totalLoadTime = A.totalLoadTime : typeof A.totalLoadTime == "object" && (g.totalLoadTime = new $util$1.LongBits(A.totalLoadTime.low >>> 0, A.totalLoadTime.high >>> 0).toNumber())), A.browserInfo != null) {
      if (typeof A.browserInfo != "object") throw TypeError(".MetricsEvent.browserInfo: object expected");
      g.browserInfo = $root$1.BrowserInfo.fromObject(A.browserInfo);
    }
    return g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    if ((g.arrays || g.defaults) && (e.commands = [], e.config = [], e.attributions = []), g.defaults) {
      if (e.event = "", e.anonymousId = "", e.machineIdV3 = "", e.reportHash = "", e.dev = !1, e.source = "", e.streamlitVersion = "", e.isHello = !1, e.hostedAt = "", e.owner = "", e.repo = "", e.branch = "", e.mainModule = "", e.creatorId = "", e.contextPageUrl = "", e.contextPageTitle = "", e.contextPagePath = "", e.contextPageReferrer = "", e.contextPageSearch = "", e.contextLocale = "", e.contextUserAgent = "", e.label = "", $util$1.Long) {
        let t = new $util$1.Long(0, 0, !1);
        e.execTime = g.longs === String ? t.toString() : g.longs === Number ? t.toNumber() : t;
      } else e.execTime = g.longs === String ? "0" : 0;
      if ($util$1.Long) {
        let t = new $util$1.Long(0, 0, !1);
        e.prepTime = g.longs === String ? t.toString() : g.longs === Number ? t.toNumber() : t;
      } else e.prepTime = g.longs === String ? "0" : 0;
      if (e.uncaughtException = "", e.os = "", e.timezone = "", e.headless = !1, e.isFragmentRun = !1, e.appId = "", $util$1.Long) {
        let t = new $util$1.Long(0, 0, !1);
        e.numPages = g.longs === String ? t.toString() : g.longs === Number ? t.toNumber() : t;
      } else e.numPages = g.longs === String ? "0" : 0;
      if (e.sessionId = "", e.pythonVersion = "", e.pageScriptHash = "", e.activeTheme = "", $util$1.Long) {
        let t = new $util$1.Long(0, 0, !1);
        e.totalLoadTime = g.longs === String ? t.toString() : g.longs === Number ? t.toNumber() : t;
      } else e.totalLoadTime = g.longs === String ? "0" : 0;
      e.browserInfo = null, e.machineIdV4 = "", e.serverOs = "", e.hasDisplay = !1, e.isWebdriver = !1;
    }
    if (A.event != null && A.hasOwnProperty("event") && (e.event = A.event), A.anonymousId != null && A.hasOwnProperty("anonymousId") && (e.anonymousId = A.anonymousId), A.machineIdV3 != null && A.hasOwnProperty("machineIdV3") && (e.machineIdV3 = A.machineIdV3), A.reportHash != null && A.hasOwnProperty("reportHash") && (e.reportHash = A.reportHash), A.dev != null && A.hasOwnProperty("dev") && (e.dev = A.dev), A.source != null && A.hasOwnProperty("source") && (e.source = A.source), A.streamlitVersion != null && A.hasOwnProperty("streamlitVersion") && (e.streamlitVersion = A.streamlitVersion), A.isHello != null && A.hasOwnProperty("isHello") && (e.isHello = A.isHello), A.hostedAt != null && A.hasOwnProperty("hostedAt") && (e.hostedAt = A.hostedAt), A.owner != null && A.hasOwnProperty("owner") && (e.owner = A.owner), A.repo != null && A.hasOwnProperty("repo") && (e.repo = A.repo), A.branch != null && A.hasOwnProperty("branch") && (e.branch = A.branch), A.mainModule != null && A.hasOwnProperty("mainModule") && (e.mainModule = A.mainModule), A.creatorId != null && A.hasOwnProperty("creatorId") && (e.creatorId = A.creatorId), A.contextPageUrl != null && A.hasOwnProperty("contextPageUrl") && (e.contextPageUrl = A.contextPageUrl), A.contextPageTitle != null && A.hasOwnProperty("contextPageTitle") && (e.contextPageTitle = A.contextPageTitle), A.contextPagePath != null && A.hasOwnProperty("contextPagePath") && (e.contextPagePath = A.contextPagePath), A.contextPageReferrer != null && A.hasOwnProperty("contextPageReferrer") && (e.contextPageReferrer = A.contextPageReferrer), A.contextPageSearch != null && A.hasOwnProperty("contextPageSearch") && (e.contextPageSearch = A.contextPageSearch), A.contextLocale != null && A.hasOwnProperty("contextLocale") && (e.contextLocale = A.contextLocale), A.contextUserAgent != null && A.hasOwnProperty("contextUserAgent") && (e.contextUserAgent = A.contextUserAgent), A.label != null && A.hasOwnProperty("label") && (e.label = A.label), A.commands && A.commands.length) {
      e.commands = [];
      for (let t = 0; t < A.commands.length; ++t) e.commands[t] = $root$1.Command.toObject(A.commands[t], g);
    }
    if (A.execTime != null && A.hasOwnProperty("execTime") && (typeof A.execTime == "number" ? e.execTime = g.longs === String ? String(A.execTime) : A.execTime : e.execTime = g.longs === String ? $util$1.Long.prototype.toString.call(A.execTime) : g.longs === Number ? new $util$1.LongBits(A.execTime.low >>> 0, A.execTime.high >>> 0).toNumber() : A.execTime), A.prepTime != null && A.hasOwnProperty("prepTime") && (typeof A.prepTime == "number" ? e.prepTime = g.longs === String ? String(A.prepTime) : A.prepTime : e.prepTime = g.longs === String ? $util$1.Long.prototype.toString.call(A.prepTime) : g.longs === Number ? new $util$1.LongBits(A.prepTime.low >>> 0, A.prepTime.high >>> 0).toNumber() : A.prepTime), A.config && A.config.length) {
      e.config = [];
      for (let t = 0; t < A.config.length; ++t) e.config[t] = A.config[t];
    }
    if (A.uncaughtException != null && A.hasOwnProperty("uncaughtException") && (e.uncaughtException = A.uncaughtException), A.attributions && A.attributions.length) {
      e.attributions = [];
      for (let t = 0; t < A.attributions.length; ++t) e.attributions[t] = A.attributions[t];
    }
    return A.os != null && A.hasOwnProperty("os") && (e.os = A.os), A.timezone != null && A.hasOwnProperty("timezone") && (e.timezone = A.timezone), A.headless != null && A.hasOwnProperty("headless") && (e.headless = A.headless), A.isFragmentRun != null && A.hasOwnProperty("isFragmentRun") && (e.isFragmentRun = A.isFragmentRun), A.appId != null && A.hasOwnProperty("appId") && (e.appId = A.appId), A.numPages != null && A.hasOwnProperty("numPages") && (typeof A.numPages == "number" ? e.numPages = g.longs === String ? String(A.numPages) : A.numPages : e.numPages = g.longs === String ? $util$1.Long.prototype.toString.call(A.numPages) : g.longs === Number ? new $util$1.LongBits(A.numPages.low >>> 0, A.numPages.high >>> 0).toNumber() : A.numPages), A.sessionId != null && A.hasOwnProperty("sessionId") && (e.sessionId = A.sessionId), A.pythonVersion != null && A.hasOwnProperty("pythonVersion") && (e.pythonVersion = A.pythonVersion), A.pageScriptHash != null && A.hasOwnProperty("pageScriptHash") && (e.pageScriptHash = A.pageScriptHash), A.activeTheme != null && A.hasOwnProperty("activeTheme") && (e.activeTheme = A.activeTheme), A.totalLoadTime != null && A.hasOwnProperty("totalLoadTime") && (typeof A.totalLoadTime == "number" ? e.totalLoadTime = g.longs === String ? String(A.totalLoadTime) : A.totalLoadTime : e.totalLoadTime = g.longs === String ? $util$1.Long.prototype.toString.call(A.totalLoadTime) : g.longs === Number ? new $util$1.LongBits(A.totalLoadTime.low >>> 0, A.totalLoadTime.high >>> 0).toNumber() : A.totalLoadTime), A.browserInfo != null && A.hasOwnProperty("browserInfo") && (e.browserInfo = $root$1.BrowserInfo.toObject(A.browserInfo, g)), A.machineIdV4 != null && A.hasOwnProperty("machineIdV4") && (e.machineIdV4 = A.machineIdV4), A.serverOs != null && A.hasOwnProperty("serverOs") && (e.serverOs = A.serverOs), A.hasDisplay != null && A.hasOwnProperty("hasDisplay") && (e.hasDisplay = A.hasDisplay), A.isWebdriver != null && A.hasOwnProperty("isWebdriver") && (e.isWebdriver = A.isWebdriver), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/MetricsEvent";
  }, o;
})();
$root$1.BrowserInfo = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.browserName = "", o.prototype.browserVersion = "", o.prototype.deviceType = "", o.prototype.os = "", o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    return g || (g = $Writer$1.create()), A.browserName != null && Object.hasOwnProperty.call(A, "browserName") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(A.browserName), A.browserVersion != null && Object.hasOwnProperty.call(A, "browserVersion") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(A.browserVersion), A.deviceType != null && Object.hasOwnProperty.call(A, "deviceType") && g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(A.deviceType), A.os != null && Object.hasOwnProperty.call(A, "os") && g.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(A.os), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader$1 || (A = $Reader$1.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root$1.BrowserInfo();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.browserName = A.string();
          break;
        }
        case 2: {
          c.browserVersion = A.string();
          break;
        }
        case 3: {
          c.deviceType = A.string();
          break;
        }
        case 4: {
          c.os = A.string();
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root$1.BrowserInfo) return A;
    let g = new $root$1.BrowserInfo();
    return A.browserName != null && (g.browserName = String(A.browserName)), A.browserVersion != null && (g.browserVersion = String(A.browserVersion)), A.deviceType != null && (g.deviceType = String(A.deviceType)), A.os != null && (g.os = String(A.os)), g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    return g.defaults && (e.browserName = "", e.browserVersion = "", e.deviceType = "", e.os = ""), A.browserName != null && A.hasOwnProperty("browserName") && (e.browserName = A.browserName), A.browserVersion != null && A.hasOwnProperty("browserVersion") && (e.browserVersion = A.browserVersion), A.deviceType != null && A.hasOwnProperty("deviceType") && (e.deviceType = A.deviceType), A.os != null && A.hasOwnProperty("os") && (e.os = A.os), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/BrowserInfo";
  }, o;
})();
$root$1.openmetrics = (() => {
  const o = {};
  return o.MetricSet = (function() {
    function E(A) {
      if (this.metricFamilies = [], A) for (let g = Object.keys(A), e = 0; e < g.length; ++e) A[g[e]] != null && (this[g[e]] = A[g[e]]);
    }
    return E.prototype.metricFamilies = $util$1.emptyArray, E.create = function(g) {
      return new E(g);
    }, E.encode = function(g, e) {
      if (e || (e = $Writer$1.create()), g.metricFamilies != null && g.metricFamilies.length) for (let t = 0; t < g.metricFamilies.length; ++t) $root$1.openmetrics.MetricFamily.encode(g.metricFamilies[t], e.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim();
      return e;
    }, E.decode = function(g, e, t) {
      g instanceof $Reader$1 || (g = $Reader$1.create(g));
      let c = e === void 0 ? g.len : g.pos + e, n = new $root$1.openmetrics.MetricSet();
      for (; g.pos < c; ) {
        let h = g.uint32();
        if (h === t) break;
        switch (h >>> 3) {
          case 1: {
            n.metricFamilies && n.metricFamilies.length || (n.metricFamilies = []), n.metricFamilies.push($root$1.openmetrics.MetricFamily.decode(g, g.uint32()));
            break;
          }
          default:
            g.skipType(h & 7);
            break;
        }
      }
      return n;
    }, E.fromObject = function(g) {
      if (g instanceof $root$1.openmetrics.MetricSet) return g;
      let e = new $root$1.openmetrics.MetricSet();
      if (g.metricFamilies) {
        if (!Array.isArray(g.metricFamilies)) throw TypeError(".openmetrics.MetricSet.metricFamilies: array expected");
        e.metricFamilies = [];
        for (let t = 0; t < g.metricFamilies.length; ++t) {
          if (typeof g.metricFamilies[t] != "object") throw TypeError(".openmetrics.MetricSet.metricFamilies: object expected");
          e.metricFamilies[t] = $root$1.openmetrics.MetricFamily.fromObject(g.metricFamilies[t]);
        }
      }
      return e;
    }, E.toObject = function(g, e) {
      e || (e = {});
      let t = {};
      if ((e.arrays || e.defaults) && (t.metricFamilies = []), g.metricFamilies && g.metricFamilies.length) {
        t.metricFamilies = [];
        for (let c = 0; c < g.metricFamilies.length; ++c) t.metricFamilies[c] = $root$1.openmetrics.MetricFamily.toObject(g.metricFamilies[c], e);
      }
      return t;
    }, E.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
    }, E.getTypeUrl = function(g) {
      return g === void 0 && (g = "type.googleapis.com"), g + "/openmetrics.MetricSet";
    }, E;
  })(), o.MetricFamily = (function() {
    function E(A) {
      if (this.metrics = [], A) for (let g = Object.keys(A), e = 0; e < g.length; ++e) A[g[e]] != null && (this[g[e]] = A[g[e]]);
    }
    return E.prototype.name = "", E.prototype.type = 0, E.prototype.unit = "", E.prototype.help = "", E.prototype.metrics = $util$1.emptyArray, E.create = function(g) {
      return new E(g);
    }, E.encode = function(g, e) {
      if (e || (e = $Writer$1.create()), g.name != null && Object.hasOwnProperty.call(g, "name") && e.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(g.name), g.type != null && Object.hasOwnProperty.call(g, "type") && e.uint32(
        /* id 2, wireType 0 =*/
        16
      ).int32(g.type), g.unit != null && Object.hasOwnProperty.call(g, "unit") && e.uint32(
        /* id 3, wireType 2 =*/
        26
      ).string(g.unit), g.help != null && Object.hasOwnProperty.call(g, "help") && e.uint32(
        /* id 4, wireType 2 =*/
        34
      ).string(g.help), g.metrics != null && g.metrics.length) for (let t = 0; t < g.metrics.length; ++t) $root$1.Metric.encode(g.metrics[t], e.uint32(
        /* id 5, wireType 2 =*/
        42
      ).fork()).ldelim();
      return e;
    }, E.decode = function(g, e, t) {
      g instanceof $Reader$1 || (g = $Reader$1.create(g));
      let c = e === void 0 ? g.len : g.pos + e, n = new $root$1.openmetrics.MetricFamily();
      for (; g.pos < c; ) {
        let h = g.uint32();
        if (h === t) break;
        switch (h >>> 3) {
          case 1: {
            n.name = g.string();
            break;
          }
          case 2: {
            n.type = g.int32();
            break;
          }
          case 3: {
            n.unit = g.string();
            break;
          }
          case 4: {
            n.help = g.string();
            break;
          }
          case 5: {
            n.metrics && n.metrics.length || (n.metrics = []), n.metrics.push($root$1.Metric.decode(g, g.uint32()));
            break;
          }
          default:
            g.skipType(h & 7);
            break;
        }
      }
      return n;
    }, E.fromObject = function(g) {
      if (g instanceof $root$1.openmetrics.MetricFamily) return g;
      let e = new $root$1.openmetrics.MetricFamily();
      switch (g.name != null && (e.name = String(g.name)), g.type) {
        default:
          if (typeof g.type == "number") {
            e.type = g.type;
            break;
          }
          break;
        case "UNKNOWN":
        case 0:
          e.type = 0;
          break;
        case "GAUGE":
        case 1:
          e.type = 1;
          break;
        case "COUNTER":
        case 2:
          e.type = 2;
          break;
        case "STATE_SET":
        case 3:
          e.type = 3;
          break;
        case "INFO":
        case 4:
          e.type = 4;
          break;
        case "HISTOGRAM":
        case 5:
          e.type = 5;
          break;
        case "GAUGE_HISTOGRAM":
        case 6:
          e.type = 6;
          break;
        case "SUMMARY":
        case 7:
          e.type = 7;
          break;
      }
      if (g.unit != null && (e.unit = String(g.unit)), g.help != null && (e.help = String(g.help)), g.metrics) {
        if (!Array.isArray(g.metrics)) throw TypeError(".openmetrics.MetricFamily.metrics: array expected");
        e.metrics = [];
        for (let t = 0; t < g.metrics.length; ++t) {
          if (typeof g.metrics[t] != "object") throw TypeError(".openmetrics.MetricFamily.metrics: object expected");
          e.metrics[t] = $root$1.Metric.fromObject(g.metrics[t]);
        }
      }
      return e;
    }, E.toObject = function(g, e) {
      e || (e = {});
      let t = {};
      if ((e.arrays || e.defaults) && (t.metrics = []), e.defaults && (t.name = "", t.type = e.enums === String ? "UNKNOWN" : 0, t.unit = "", t.help = ""), g.name != null && g.hasOwnProperty("name") && (t.name = g.name), g.type != null && g.hasOwnProperty("type") && (t.type = e.enums === String ? $root$1.openmetrics.MetricType[g.type] === void 0 ? g.type : $root$1.openmetrics.MetricType[g.type] : g.type), g.unit != null && g.hasOwnProperty("unit") && (t.unit = g.unit), g.help != null && g.hasOwnProperty("help") && (t.help = g.help), g.metrics && g.metrics.length) {
        t.metrics = [];
        for (let c = 0; c < g.metrics.length; ++c) t.metrics[c] = $root$1.Metric.toObject(g.metrics[c], e);
      }
      return t;
    }, E.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
    }, E.getTypeUrl = function(g) {
      return g === void 0 && (g = "type.googleapis.com"), g + "/openmetrics.MetricFamily";
    }, E;
  })(), o.MetricType = (function() {
    const E = {}, A = Object.create(E);
    return A[E[0] = "UNKNOWN"] = 0, A[E[1] = "GAUGE"] = 1, A[E[2] = "COUNTER"] = 2, A[E[3] = "STATE_SET"] = 3, A[E[4] = "INFO"] = 4, A[E[5] = "HISTOGRAM"] = 5, A[E[6] = "GAUGE_HISTOGRAM"] = 6, A[E[7] = "SUMMARY"] = 7, A;
  })(), o.Metric = (function() {
    function E(A) {
      if (this.labels = [], this.metricPoints = [], A) for (let g = Object.keys(A), e = 0; e < g.length; ++e) A[g[e]] != null && (this[g[e]] = A[g[e]]);
    }
    return E.prototype.labels = $util$1.emptyArray, E.prototype.metricPoints = $util$1.emptyArray, E.create = function(g) {
      return new E(g);
    }, E.encode = function(g, e) {
      if (e || (e = $Writer$1.create()), g.labels != null && g.labels.length) for (let t = 0; t < g.labels.length; ++t) $root$1.openmetrics.Label.encode(g.labels[t], e.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim();
      if (g.metricPoints != null && g.metricPoints.length) for (let t = 0; t < g.metricPoints.length; ++t) $root$1.openmetrics.MetricPoint.encode(g.metricPoints[t], e.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim();
      return e;
    }, E.decode = function(g, e, t) {
      g instanceof $Reader$1 || (g = $Reader$1.create(g));
      let c = e === void 0 ? g.len : g.pos + e, n = new $root$1.openmetrics.Metric();
      for (; g.pos < c; ) {
        let h = g.uint32();
        if (h === t) break;
        switch (h >>> 3) {
          case 1: {
            n.labels && n.labels.length || (n.labels = []), n.labels.push($root$1.openmetrics.Label.decode(g, g.uint32()));
            break;
          }
          case 2: {
            n.metricPoints && n.metricPoints.length || (n.metricPoints = []), n.metricPoints.push($root$1.openmetrics.MetricPoint.decode(g, g.uint32()));
            break;
          }
          default:
            g.skipType(h & 7);
            break;
        }
      }
      return n;
    }, E.fromObject = function(g) {
      if (g instanceof $root$1.openmetrics.Metric) return g;
      let e = new $root$1.openmetrics.Metric();
      if (g.labels) {
        if (!Array.isArray(g.labels)) throw TypeError(".openmetrics.Metric.labels: array expected");
        e.labels = [];
        for (let t = 0; t < g.labels.length; ++t) {
          if (typeof g.labels[t] != "object") throw TypeError(".openmetrics.Metric.labels: object expected");
          e.labels[t] = $root$1.openmetrics.Label.fromObject(g.labels[t]);
        }
      }
      if (g.metricPoints) {
        if (!Array.isArray(g.metricPoints)) throw TypeError(".openmetrics.Metric.metricPoints: array expected");
        e.metricPoints = [];
        for (let t = 0; t < g.metricPoints.length; ++t) {
          if (typeof g.metricPoints[t] != "object") throw TypeError(".openmetrics.Metric.metricPoints: object expected");
          e.metricPoints[t] = $root$1.openmetrics.MetricPoint.fromObject(g.metricPoints[t]);
        }
      }
      return e;
    }, E.toObject = function(g, e) {
      e || (e = {});
      let t = {};
      if ((e.arrays || e.defaults) && (t.labels = [], t.metricPoints = []), g.labels && g.labels.length) {
        t.labels = [];
        for (let c = 0; c < g.labels.length; ++c) t.labels[c] = $root$1.openmetrics.Label.toObject(g.labels[c], e);
      }
      if (g.metricPoints && g.metricPoints.length) {
        t.metricPoints = [];
        for (let c = 0; c < g.metricPoints.length; ++c) t.metricPoints[c] = $root$1.openmetrics.MetricPoint.toObject(g.metricPoints[c], e);
      }
      return t;
    }, E.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
    }, E.getTypeUrl = function(g) {
      return g === void 0 && (g = "type.googleapis.com"), g + "/openmetrics.Metric";
    }, E;
  })(), o.Label = (function() {
    function E(A) {
      if (A) for (let g = Object.keys(A), e = 0; e < g.length; ++e) A[g[e]] != null && (this[g[e]] = A[g[e]]);
    }
    return E.prototype.name = "", E.prototype.value = "", E.create = function(g) {
      return new E(g);
    }, E.encode = function(g, e) {
      return e || (e = $Writer$1.create()), g.name != null && Object.hasOwnProperty.call(g, "name") && e.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(g.name), g.value != null && Object.hasOwnProperty.call(g, "value") && e.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(g.value), e;
    }, E.decode = function(g, e, t) {
      g instanceof $Reader$1 || (g = $Reader$1.create(g));
      let c = e === void 0 ? g.len : g.pos + e, n = new $root$1.openmetrics.Label();
      for (; g.pos < c; ) {
        let h = g.uint32();
        if (h === t) break;
        switch (h >>> 3) {
          case 1: {
            n.name = g.string();
            break;
          }
          case 2: {
            n.value = g.string();
            break;
          }
          default:
            g.skipType(h & 7);
            break;
        }
      }
      return n;
    }, E.fromObject = function(g) {
      if (g instanceof $root$1.openmetrics.Label) return g;
      let e = new $root$1.openmetrics.Label();
      return g.name != null && (e.name = String(g.name)), g.value != null && (e.value = String(g.value)), e;
    }, E.toObject = function(g, e) {
      e || (e = {});
      let t = {};
      return e.defaults && (t.name = "", t.value = ""), g.name != null && g.hasOwnProperty("name") && (t.name = g.name), g.value != null && g.hasOwnProperty("value") && (t.value = g.value), t;
    }, E.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
    }, E.getTypeUrl = function(g) {
      return g === void 0 && (g = "type.googleapis.com"), g + "/openmetrics.Label";
    }, E;
  })(), o.MetricPoint = (function() {
    function E(g) {
      if (g) for (let e = Object.keys(g), t = 0; t < e.length; ++t) g[e[t]] != null && (this[e[t]] = g[e[t]]);
    }
    E.prototype.unknownValue = null, E.prototype.gaugeValue = null, E.prototype.counterValue = null, E.prototype.histogramValue = null, E.prototype.stateSetValue = null, E.prototype.infoValue = null, E.prototype.summaryValue = null, E.prototype.timestamp = null;
    let A;
    return Object.defineProperty(E.prototype, "value", { get: $util$1.oneOfGetter(A = ["unknownValue", "gaugeValue", "counterValue", "histogramValue", "stateSetValue", "infoValue", "summaryValue"]), set: $util$1.oneOfSetter(A) }), E.create = function(e) {
      return new E(e);
    }, E.encode = function(e, t) {
      return t || (t = $Writer$1.create()), e.unknownValue != null && Object.hasOwnProperty.call(e, "unknownValue") && $root$1.openmetrics.UnknownValue.encode(e.unknownValue, t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), e.gaugeValue != null && Object.hasOwnProperty.call(e, "gaugeValue") && $root$1.openmetrics.GaugeValue.encode(e.gaugeValue, t.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), e.counterValue != null && Object.hasOwnProperty.call(e, "counterValue") && $root$1.openmetrics.CounterValue.encode(e.counterValue, t.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork()).ldelim(), e.histogramValue != null && Object.hasOwnProperty.call(e, "histogramValue") && $root$1.openmetrics.HistogramValue.encode(e.histogramValue, t.uint32(
        /* id 4, wireType 2 =*/
        34
      ).fork()).ldelim(), e.stateSetValue != null && Object.hasOwnProperty.call(e, "stateSetValue") && $root$1.openmetrics.StateSetValue.encode(e.stateSetValue, t.uint32(
        /* id 5, wireType 2 =*/
        42
      ).fork()).ldelim(), e.infoValue != null && Object.hasOwnProperty.call(e, "infoValue") && $root$1.openmetrics.InfoValue.encode(e.infoValue, t.uint32(
        /* id 6, wireType 2 =*/
        50
      ).fork()).ldelim(), e.summaryValue != null && Object.hasOwnProperty.call(e, "summaryValue") && $root$1.openmetrics.SummaryValue.encode(e.summaryValue, t.uint32(
        /* id 7, wireType 2 =*/
        58
      ).fork()).ldelim(), e.timestamp != null && Object.hasOwnProperty.call(e, "timestamp") && $root$1.google.protobuf.Timestamp.encode(e.timestamp, t.uint32(
        /* id 8, wireType 2 =*/
        66
      ).fork()).ldelim(), t;
    }, E.decode = function(e, t, c) {
      e instanceof $Reader$1 || (e = $Reader$1.create(e));
      let n = t === void 0 ? e.len : e.pos + t, h = new $root$1.openmetrics.MetricPoint();
      for (; e.pos < n; ) {
        let d = e.uint32();
        if (d === c) break;
        switch (d >>> 3) {
          case 1: {
            h.unknownValue = $root$1.openmetrics.UnknownValue.decode(e, e.uint32());
            break;
          }
          case 2: {
            h.gaugeValue = $root$1.openmetrics.GaugeValue.decode(e, e.uint32());
            break;
          }
          case 3: {
            h.counterValue = $root$1.openmetrics.CounterValue.decode(e, e.uint32());
            break;
          }
          case 4: {
            h.histogramValue = $root$1.openmetrics.HistogramValue.decode(e, e.uint32());
            break;
          }
          case 5: {
            h.stateSetValue = $root$1.openmetrics.StateSetValue.decode(e, e.uint32());
            break;
          }
          case 6: {
            h.infoValue = $root$1.openmetrics.InfoValue.decode(e, e.uint32());
            break;
          }
          case 7: {
            h.summaryValue = $root$1.openmetrics.SummaryValue.decode(e, e.uint32());
            break;
          }
          case 8: {
            h.timestamp = $root$1.google.protobuf.Timestamp.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(d & 7);
            break;
        }
      }
      return h;
    }, E.fromObject = function(e) {
      if (e instanceof $root$1.openmetrics.MetricPoint) return e;
      let t = new $root$1.openmetrics.MetricPoint();
      if (e.unknownValue != null) {
        if (typeof e.unknownValue != "object") throw TypeError(".openmetrics.MetricPoint.unknownValue: object expected");
        t.unknownValue = $root$1.openmetrics.UnknownValue.fromObject(e.unknownValue);
      }
      if (e.gaugeValue != null) {
        if (typeof e.gaugeValue != "object") throw TypeError(".openmetrics.MetricPoint.gaugeValue: object expected");
        t.gaugeValue = $root$1.openmetrics.GaugeValue.fromObject(e.gaugeValue);
      }
      if (e.counterValue != null) {
        if (typeof e.counterValue != "object") throw TypeError(".openmetrics.MetricPoint.counterValue: object expected");
        t.counterValue = $root$1.openmetrics.CounterValue.fromObject(e.counterValue);
      }
      if (e.histogramValue != null) {
        if (typeof e.histogramValue != "object") throw TypeError(".openmetrics.MetricPoint.histogramValue: object expected");
        t.histogramValue = $root$1.openmetrics.HistogramValue.fromObject(e.histogramValue);
      }
      if (e.stateSetValue != null) {
        if (typeof e.stateSetValue != "object") throw TypeError(".openmetrics.MetricPoint.stateSetValue: object expected");
        t.stateSetValue = $root$1.openmetrics.StateSetValue.fromObject(e.stateSetValue);
      }
      if (e.infoValue != null) {
        if (typeof e.infoValue != "object") throw TypeError(".openmetrics.MetricPoint.infoValue: object expected");
        t.infoValue = $root$1.openmetrics.InfoValue.fromObject(e.infoValue);
      }
      if (e.summaryValue != null) {
        if (typeof e.summaryValue != "object") throw TypeError(".openmetrics.MetricPoint.summaryValue: object expected");
        t.summaryValue = $root$1.openmetrics.SummaryValue.fromObject(e.summaryValue);
      }
      if (e.timestamp != null) {
        if (typeof e.timestamp != "object") throw TypeError(".openmetrics.MetricPoint.timestamp: object expected");
        t.timestamp = $root$1.google.protobuf.Timestamp.fromObject(e.timestamp);
      }
      return t;
    }, E.toObject = function(e, t) {
      t || (t = {});
      let c = {};
      return t.defaults && (c.timestamp = null), e.unknownValue != null && e.hasOwnProperty("unknownValue") && (c.unknownValue = $root$1.openmetrics.UnknownValue.toObject(e.unknownValue, t), t.oneofs && (c.value = "unknownValue")), e.gaugeValue != null && e.hasOwnProperty("gaugeValue") && (c.gaugeValue = $root$1.openmetrics.GaugeValue.toObject(e.gaugeValue, t), t.oneofs && (c.value = "gaugeValue")), e.counterValue != null && e.hasOwnProperty("counterValue") && (c.counterValue = $root$1.openmetrics.CounterValue.toObject(e.counterValue, t), t.oneofs && (c.value = "counterValue")), e.histogramValue != null && e.hasOwnProperty("histogramValue") && (c.histogramValue = $root$1.openmetrics.HistogramValue.toObject(e.histogramValue, t), t.oneofs && (c.value = "histogramValue")), e.stateSetValue != null && e.hasOwnProperty("stateSetValue") && (c.stateSetValue = $root$1.openmetrics.StateSetValue.toObject(e.stateSetValue, t), t.oneofs && (c.value = "stateSetValue")), e.infoValue != null && e.hasOwnProperty("infoValue") && (c.infoValue = $root$1.openmetrics.InfoValue.toObject(e.infoValue, t), t.oneofs && (c.value = "infoValue")), e.summaryValue != null && e.hasOwnProperty("summaryValue") && (c.summaryValue = $root$1.openmetrics.SummaryValue.toObject(e.summaryValue, t), t.oneofs && (c.value = "summaryValue")), e.timestamp != null && e.hasOwnProperty("timestamp") && (c.timestamp = $root$1.google.protobuf.Timestamp.toObject(e.timestamp, t)), c;
    }, E.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
    }, E.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/openmetrics.MetricPoint";
    }, E;
  })(), o.UnknownValue = (function() {
    function E(g) {
      if (g) for (let e = Object.keys(g), t = 0; t < e.length; ++t) g[e[t]] != null && (this[e[t]] = g[e[t]]);
    }
    E.prototype.doubleValue = null, E.prototype.intValue = null;
    let A;
    return Object.defineProperty(E.prototype, "value", { get: $util$1.oneOfGetter(A = ["doubleValue", "intValue"]), set: $util$1.oneOfSetter(A) }), E.create = function(e) {
      return new E(e);
    }, E.encode = function(e, t) {
      return t || (t = $Writer$1.create()), e.doubleValue != null && Object.hasOwnProperty.call(e, "doubleValue") && t.uint32(
        /* id 1, wireType 1 =*/
        9
      ).double(e.doubleValue), e.intValue != null && Object.hasOwnProperty.call(e, "intValue") && t.uint32(
        /* id 2, wireType 0 =*/
        16
      ).int64(e.intValue), t;
    }, E.decode = function(e, t, c) {
      e instanceof $Reader$1 || (e = $Reader$1.create(e));
      let n = t === void 0 ? e.len : e.pos + t, h = new $root$1.openmetrics.UnknownValue();
      for (; e.pos < n; ) {
        let d = e.uint32();
        if (d === c) break;
        switch (d >>> 3) {
          case 1: {
            h.doubleValue = e.double();
            break;
          }
          case 2: {
            h.intValue = e.int64();
            break;
          }
          default:
            e.skipType(d & 7);
            break;
        }
      }
      return h;
    }, E.fromObject = function(e) {
      if (e instanceof $root$1.openmetrics.UnknownValue) return e;
      let t = new $root$1.openmetrics.UnknownValue();
      return e.doubleValue != null && (t.doubleValue = Number(e.doubleValue)), e.intValue != null && ($util$1.Long ? (t.intValue = $util$1.Long.fromValue(e.intValue)).unsigned = !1 : typeof e.intValue == "string" ? t.intValue = parseInt(e.intValue, 10) : typeof e.intValue == "number" ? t.intValue = e.intValue : typeof e.intValue == "object" && (t.intValue = new $util$1.LongBits(e.intValue.low >>> 0, e.intValue.high >>> 0).toNumber())), t;
    }, E.toObject = function(e, t) {
      t || (t = {});
      let c = {};
      return e.doubleValue != null && e.hasOwnProperty("doubleValue") && (c.doubleValue = t.json && !isFinite(e.doubleValue) ? String(e.doubleValue) : e.doubleValue, t.oneofs && (c.value = "doubleValue")), e.intValue != null && e.hasOwnProperty("intValue") && (typeof e.intValue == "number" ? c.intValue = t.longs === String ? String(e.intValue) : e.intValue : c.intValue = t.longs === String ? $util$1.Long.prototype.toString.call(e.intValue) : t.longs === Number ? new $util$1.LongBits(e.intValue.low >>> 0, e.intValue.high >>> 0).toNumber() : e.intValue, t.oneofs && (c.value = "intValue")), c;
    }, E.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
    }, E.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/openmetrics.UnknownValue";
    }, E;
  })(), o.GaugeValue = (function() {
    function E(g) {
      if (g) for (let e = Object.keys(g), t = 0; t < e.length; ++t) g[e[t]] != null && (this[e[t]] = g[e[t]]);
    }
    E.prototype.doubleValue = null, E.prototype.intValue = null;
    let A;
    return Object.defineProperty(E.prototype, "value", { get: $util$1.oneOfGetter(A = ["doubleValue", "intValue"]), set: $util$1.oneOfSetter(A) }), E.create = function(e) {
      return new E(e);
    }, E.encode = function(e, t) {
      return t || (t = $Writer$1.create()), e.doubleValue != null && Object.hasOwnProperty.call(e, "doubleValue") && t.uint32(
        /* id 1, wireType 1 =*/
        9
      ).double(e.doubleValue), e.intValue != null && Object.hasOwnProperty.call(e, "intValue") && t.uint32(
        /* id 2, wireType 0 =*/
        16
      ).int64(e.intValue), t;
    }, E.decode = function(e, t, c) {
      e instanceof $Reader$1 || (e = $Reader$1.create(e));
      let n = t === void 0 ? e.len : e.pos + t, h = new $root$1.openmetrics.GaugeValue();
      for (; e.pos < n; ) {
        let d = e.uint32();
        if (d === c) break;
        switch (d >>> 3) {
          case 1: {
            h.doubleValue = e.double();
            break;
          }
          case 2: {
            h.intValue = e.int64();
            break;
          }
          default:
            e.skipType(d & 7);
            break;
        }
      }
      return h;
    }, E.fromObject = function(e) {
      if (e instanceof $root$1.openmetrics.GaugeValue) return e;
      let t = new $root$1.openmetrics.GaugeValue();
      return e.doubleValue != null && (t.doubleValue = Number(e.doubleValue)), e.intValue != null && ($util$1.Long ? (t.intValue = $util$1.Long.fromValue(e.intValue)).unsigned = !1 : typeof e.intValue == "string" ? t.intValue = parseInt(e.intValue, 10) : typeof e.intValue == "number" ? t.intValue = e.intValue : typeof e.intValue == "object" && (t.intValue = new $util$1.LongBits(e.intValue.low >>> 0, e.intValue.high >>> 0).toNumber())), t;
    }, E.toObject = function(e, t) {
      t || (t = {});
      let c = {};
      return e.doubleValue != null && e.hasOwnProperty("doubleValue") && (c.doubleValue = t.json && !isFinite(e.doubleValue) ? String(e.doubleValue) : e.doubleValue, t.oneofs && (c.value = "doubleValue")), e.intValue != null && e.hasOwnProperty("intValue") && (typeof e.intValue == "number" ? c.intValue = t.longs === String ? String(e.intValue) : e.intValue : c.intValue = t.longs === String ? $util$1.Long.prototype.toString.call(e.intValue) : t.longs === Number ? new $util$1.LongBits(e.intValue.low >>> 0, e.intValue.high >>> 0).toNumber() : e.intValue, t.oneofs && (c.value = "intValue")), c;
    }, E.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
    }, E.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/openmetrics.GaugeValue";
    }, E;
  })(), o.CounterValue = (function() {
    function E(g) {
      if (g) for (let e = Object.keys(g), t = 0; t < e.length; ++t) g[e[t]] != null && (this[e[t]] = g[e[t]]);
    }
    E.prototype.doubleValue = null, E.prototype.intValue = null, E.prototype.created = null, E.prototype.exemplar = null;
    let A;
    return Object.defineProperty(E.prototype, "total", { get: $util$1.oneOfGetter(A = ["doubleValue", "intValue"]), set: $util$1.oneOfSetter(A) }), E.create = function(e) {
      return new E(e);
    }, E.encode = function(e, t) {
      return t || (t = $Writer$1.create()), e.doubleValue != null && Object.hasOwnProperty.call(e, "doubleValue") && t.uint32(
        /* id 1, wireType 1 =*/
        9
      ).double(e.doubleValue), e.intValue != null && Object.hasOwnProperty.call(e, "intValue") && t.uint32(
        /* id 2, wireType 0 =*/
        16
      ).uint64(e.intValue), e.created != null && Object.hasOwnProperty.call(e, "created") && $root$1.google.protobuf.Timestamp.encode(e.created, t.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork()).ldelim(), e.exemplar != null && Object.hasOwnProperty.call(e, "exemplar") && $root$1.openmetrics.Exemplar.encode(e.exemplar, t.uint32(
        /* id 4, wireType 2 =*/
        34
      ).fork()).ldelim(), t;
    }, E.decode = function(e, t, c) {
      e instanceof $Reader$1 || (e = $Reader$1.create(e));
      let n = t === void 0 ? e.len : e.pos + t, h = new $root$1.openmetrics.CounterValue();
      for (; e.pos < n; ) {
        let d = e.uint32();
        if (d === c) break;
        switch (d >>> 3) {
          case 1: {
            h.doubleValue = e.double();
            break;
          }
          case 2: {
            h.intValue = e.uint64();
            break;
          }
          case 3: {
            h.created = $root$1.google.protobuf.Timestamp.decode(e, e.uint32());
            break;
          }
          case 4: {
            h.exemplar = $root$1.openmetrics.Exemplar.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(d & 7);
            break;
        }
      }
      return h;
    }, E.fromObject = function(e) {
      if (e instanceof $root$1.openmetrics.CounterValue) return e;
      let t = new $root$1.openmetrics.CounterValue();
      if (e.doubleValue != null && (t.doubleValue = Number(e.doubleValue)), e.intValue != null && ($util$1.Long ? (t.intValue = $util$1.Long.fromValue(e.intValue)).unsigned = !0 : typeof e.intValue == "string" ? t.intValue = parseInt(e.intValue, 10) : typeof e.intValue == "number" ? t.intValue = e.intValue : typeof e.intValue == "object" && (t.intValue = new $util$1.LongBits(e.intValue.low >>> 0, e.intValue.high >>> 0).toNumber(!0))), e.created != null) {
        if (typeof e.created != "object") throw TypeError(".openmetrics.CounterValue.created: object expected");
        t.created = $root$1.google.protobuf.Timestamp.fromObject(e.created);
      }
      if (e.exemplar != null) {
        if (typeof e.exemplar != "object") throw TypeError(".openmetrics.CounterValue.exemplar: object expected");
        t.exemplar = $root$1.openmetrics.Exemplar.fromObject(e.exemplar);
      }
      return t;
    }, E.toObject = function(e, t) {
      t || (t = {});
      let c = {};
      return t.defaults && (c.created = null, c.exemplar = null), e.doubleValue != null && e.hasOwnProperty("doubleValue") && (c.doubleValue = t.json && !isFinite(e.doubleValue) ? String(e.doubleValue) : e.doubleValue, t.oneofs && (c.total = "doubleValue")), e.intValue != null && e.hasOwnProperty("intValue") && (typeof e.intValue == "number" ? c.intValue = t.longs === String ? String(e.intValue) : e.intValue : c.intValue = t.longs === String ? $util$1.Long.prototype.toString.call(e.intValue) : t.longs === Number ? new $util$1.LongBits(e.intValue.low >>> 0, e.intValue.high >>> 0).toNumber(!0) : e.intValue, t.oneofs && (c.total = "intValue")), e.created != null && e.hasOwnProperty("created") && (c.created = $root$1.google.protobuf.Timestamp.toObject(e.created, t)), e.exemplar != null && e.hasOwnProperty("exemplar") && (c.exemplar = $root$1.openmetrics.Exemplar.toObject(e.exemplar, t)), c;
    }, E.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
    }, E.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/openmetrics.CounterValue";
    }, E;
  })(), o.HistogramValue = (function() {
    function E(g) {
      if (this.buckets = [], g) for (let e = Object.keys(g), t = 0; t < e.length; ++t) g[e[t]] != null && (this[e[t]] = g[e[t]]);
    }
    E.prototype.doubleValue = null, E.prototype.intValue = null, E.prototype.count = $util$1.Long ? $util$1.Long.fromBits(0, 0, !0) : 0, E.prototype.created = null, E.prototype.buckets = $util$1.emptyArray;
    let A;
    return Object.defineProperty(E.prototype, "sum", { get: $util$1.oneOfGetter(A = ["doubleValue", "intValue"]), set: $util$1.oneOfSetter(A) }), E.create = function(e) {
      return new E(e);
    }, E.encode = function(e, t) {
      if (t || (t = $Writer$1.create()), e.doubleValue != null && Object.hasOwnProperty.call(e, "doubleValue") && t.uint32(
        /* id 1, wireType 1 =*/
        9
      ).double(e.doubleValue), e.intValue != null && Object.hasOwnProperty.call(e, "intValue") && t.uint32(
        /* id 2, wireType 0 =*/
        16
      ).int64(e.intValue), e.count != null && Object.hasOwnProperty.call(e, "count") && t.uint32(
        /* id 3, wireType 0 =*/
        24
      ).uint64(e.count), e.created != null && Object.hasOwnProperty.call(e, "created") && $root$1.google.protobuf.Timestamp.encode(e.created, t.uint32(
        /* id 4, wireType 2 =*/
        34
      ).fork()).ldelim(), e.buckets != null && e.buckets.length) for (let c = 0; c < e.buckets.length; ++c) $root$1.openmetrics.HistogramValue.Bucket.encode(e.buckets[c], t.uint32(
        /* id 5, wireType 2 =*/
        42
      ).fork()).ldelim();
      return t;
    }, E.decode = function(e, t, c) {
      e instanceof $Reader$1 || (e = $Reader$1.create(e));
      let n = t === void 0 ? e.len : e.pos + t, h = new $root$1.openmetrics.HistogramValue();
      for (; e.pos < n; ) {
        let d = e.uint32();
        if (d === c) break;
        switch (d >>> 3) {
          case 1: {
            h.doubleValue = e.double();
            break;
          }
          case 2: {
            h.intValue = e.int64();
            break;
          }
          case 3: {
            h.count = e.uint64();
            break;
          }
          case 4: {
            h.created = $root$1.google.protobuf.Timestamp.decode(e, e.uint32());
            break;
          }
          case 5: {
            h.buckets && h.buckets.length || (h.buckets = []), h.buckets.push($root$1.openmetrics.HistogramValue.Bucket.decode(e, e.uint32()));
            break;
          }
          default:
            e.skipType(d & 7);
            break;
        }
      }
      return h;
    }, E.fromObject = function(e) {
      if (e instanceof $root$1.openmetrics.HistogramValue) return e;
      let t = new $root$1.openmetrics.HistogramValue();
      if (e.doubleValue != null && (t.doubleValue = Number(e.doubleValue)), e.intValue != null && ($util$1.Long ? (t.intValue = $util$1.Long.fromValue(e.intValue)).unsigned = !1 : typeof e.intValue == "string" ? t.intValue = parseInt(e.intValue, 10) : typeof e.intValue == "number" ? t.intValue = e.intValue : typeof e.intValue == "object" && (t.intValue = new $util$1.LongBits(e.intValue.low >>> 0, e.intValue.high >>> 0).toNumber())), e.count != null && ($util$1.Long ? (t.count = $util$1.Long.fromValue(e.count)).unsigned = !0 : typeof e.count == "string" ? t.count = parseInt(e.count, 10) : typeof e.count == "number" ? t.count = e.count : typeof e.count == "object" && (t.count = new $util$1.LongBits(e.count.low >>> 0, e.count.high >>> 0).toNumber(!0))), e.created != null) {
        if (typeof e.created != "object") throw TypeError(".openmetrics.HistogramValue.created: object expected");
        t.created = $root$1.google.protobuf.Timestamp.fromObject(e.created);
      }
      if (e.buckets) {
        if (!Array.isArray(e.buckets)) throw TypeError(".openmetrics.HistogramValue.buckets: array expected");
        t.buckets = [];
        for (let c = 0; c < e.buckets.length; ++c) {
          if (typeof e.buckets[c] != "object") throw TypeError(".openmetrics.HistogramValue.buckets: object expected");
          t.buckets[c] = $root$1.openmetrics.HistogramValue.Bucket.fromObject(e.buckets[c]);
        }
      }
      return t;
    }, E.toObject = function(e, t) {
      t || (t = {});
      let c = {};
      if ((t.arrays || t.defaults) && (c.buckets = []), t.defaults) {
        if ($util$1.Long) {
          let n = new $util$1.Long(0, 0, !0);
          c.count = t.longs === String ? n.toString() : t.longs === Number ? n.toNumber() : n;
        } else c.count = t.longs === String ? "0" : 0;
        c.created = null;
      }
      if (e.doubleValue != null && e.hasOwnProperty("doubleValue") && (c.doubleValue = t.json && !isFinite(e.doubleValue) ? String(e.doubleValue) : e.doubleValue, t.oneofs && (c.sum = "doubleValue")), e.intValue != null && e.hasOwnProperty("intValue") && (typeof e.intValue == "number" ? c.intValue = t.longs === String ? String(e.intValue) : e.intValue : c.intValue = t.longs === String ? $util$1.Long.prototype.toString.call(e.intValue) : t.longs === Number ? new $util$1.LongBits(e.intValue.low >>> 0, e.intValue.high >>> 0).toNumber() : e.intValue, t.oneofs && (c.sum = "intValue")), e.count != null && e.hasOwnProperty("count") && (typeof e.count == "number" ? c.count = t.longs === String ? String(e.count) : e.count : c.count = t.longs === String ? $util$1.Long.prototype.toString.call(e.count) : t.longs === Number ? new $util$1.LongBits(e.count.low >>> 0, e.count.high >>> 0).toNumber(!0) : e.count), e.created != null && e.hasOwnProperty("created") && (c.created = $root$1.google.protobuf.Timestamp.toObject(e.created, t)), e.buckets && e.buckets.length) {
        c.buckets = [];
        for (let n = 0; n < e.buckets.length; ++n) c.buckets[n] = $root$1.openmetrics.HistogramValue.Bucket.toObject(e.buckets[n], t);
      }
      return c;
    }, E.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
    }, E.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/openmetrics.HistogramValue";
    }, E.Bucket = (function() {
      function g(e) {
        if (e) for (let t = Object.keys(e), c = 0; c < t.length; ++c) e[t[c]] != null && (this[t[c]] = e[t[c]]);
      }
      return g.prototype.count = $util$1.Long ? $util$1.Long.fromBits(0, 0, !0) : 0, g.prototype.upperBound = 0, g.prototype.exemplar = null, g.create = function(t) {
        return new g(t);
      }, g.encode = function(t, c) {
        return c || (c = $Writer$1.create()), t.count != null && Object.hasOwnProperty.call(t, "count") && c.uint32(
          /* id 1, wireType 0 =*/
          8
        ).uint64(t.count), t.upperBound != null && Object.hasOwnProperty.call(t, "upperBound") && c.uint32(
          /* id 2, wireType 1 =*/
          17
        ).double(t.upperBound), t.exemplar != null && Object.hasOwnProperty.call(t, "exemplar") && $root$1.openmetrics.Exemplar.encode(t.exemplar, c.uint32(
          /* id 3, wireType 2 =*/
          26
        ).fork()).ldelim(), c;
      }, g.decode = function(t, c, n) {
        t instanceof $Reader$1 || (t = $Reader$1.create(t));
        let h = c === void 0 ? t.len : t.pos + c, d = new $root$1.openmetrics.HistogramValue.Bucket();
        for (; t.pos < h; ) {
          let k = t.uint32();
          if (k === n) break;
          switch (k >>> 3) {
            case 1: {
              d.count = t.uint64();
              break;
            }
            case 2: {
              d.upperBound = t.double();
              break;
            }
            case 3: {
              d.exemplar = $root$1.openmetrics.Exemplar.decode(t, t.uint32());
              break;
            }
            default:
              t.skipType(k & 7);
              break;
          }
        }
        return d;
      }, g.fromObject = function(t) {
        if (t instanceof $root$1.openmetrics.HistogramValue.Bucket) return t;
        let c = new $root$1.openmetrics.HistogramValue.Bucket();
        if (t.count != null && ($util$1.Long ? (c.count = $util$1.Long.fromValue(t.count)).unsigned = !0 : typeof t.count == "string" ? c.count = parseInt(t.count, 10) : typeof t.count == "number" ? c.count = t.count : typeof t.count == "object" && (c.count = new $util$1.LongBits(t.count.low >>> 0, t.count.high >>> 0).toNumber(!0))), t.upperBound != null && (c.upperBound = Number(t.upperBound)), t.exemplar != null) {
          if (typeof t.exemplar != "object") throw TypeError(".openmetrics.HistogramValue.Bucket.exemplar: object expected");
          c.exemplar = $root$1.openmetrics.Exemplar.fromObject(t.exemplar);
        }
        return c;
      }, g.toObject = function(t, c) {
        c || (c = {});
        let n = {};
        if (c.defaults) {
          if ($util$1.Long) {
            let h = new $util$1.Long(0, 0, !0);
            n.count = c.longs === String ? h.toString() : c.longs === Number ? h.toNumber() : h;
          } else n.count = c.longs === String ? "0" : 0;
          n.upperBound = 0, n.exemplar = null;
        }
        return t.count != null && t.hasOwnProperty("count") && (typeof t.count == "number" ? n.count = c.longs === String ? String(t.count) : t.count : n.count = c.longs === String ? $util$1.Long.prototype.toString.call(t.count) : c.longs === Number ? new $util$1.LongBits(t.count.low >>> 0, t.count.high >>> 0).toNumber(!0) : t.count), t.upperBound != null && t.hasOwnProperty("upperBound") && (n.upperBound = c.json && !isFinite(t.upperBound) ? String(t.upperBound) : t.upperBound), t.exemplar != null && t.hasOwnProperty("exemplar") && (n.exemplar = $root$1.openmetrics.Exemplar.toObject(t.exemplar, c)), n;
      }, g.prototype.toJSON = function() {
        return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
      }, g.getTypeUrl = function(t) {
        return t === void 0 && (t = "type.googleapis.com"), t + "/openmetrics.HistogramValue.Bucket";
      }, g;
    })(), E;
  })(), o.Exemplar = (function() {
    function E(A) {
      if (this.label = [], A) for (let g = Object.keys(A), e = 0; e < g.length; ++e) A[g[e]] != null && (this[g[e]] = A[g[e]]);
    }
    return E.prototype.value = 0, E.prototype.timestamp = null, E.prototype.label = $util$1.emptyArray, E.create = function(g) {
      return new E(g);
    }, E.encode = function(g, e) {
      if (e || (e = $Writer$1.create()), g.value != null && Object.hasOwnProperty.call(g, "value") && e.uint32(
        /* id 1, wireType 1 =*/
        9
      ).double(g.value), g.timestamp != null && Object.hasOwnProperty.call(g, "timestamp") && $root$1.google.protobuf.Timestamp.encode(g.timestamp, e.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), g.label != null && g.label.length) for (let t = 0; t < g.label.length; ++t) $root$1.openmetrics.Label.encode(g.label[t], e.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork()).ldelim();
      return e;
    }, E.decode = function(g, e, t) {
      g instanceof $Reader$1 || (g = $Reader$1.create(g));
      let c = e === void 0 ? g.len : g.pos + e, n = new $root$1.openmetrics.Exemplar();
      for (; g.pos < c; ) {
        let h = g.uint32();
        if (h === t) break;
        switch (h >>> 3) {
          case 1: {
            n.value = g.double();
            break;
          }
          case 2: {
            n.timestamp = $root$1.google.protobuf.Timestamp.decode(g, g.uint32());
            break;
          }
          case 3: {
            n.label && n.label.length || (n.label = []), n.label.push($root$1.openmetrics.Label.decode(g, g.uint32()));
            break;
          }
          default:
            g.skipType(h & 7);
            break;
        }
      }
      return n;
    }, E.fromObject = function(g) {
      if (g instanceof $root$1.openmetrics.Exemplar) return g;
      let e = new $root$1.openmetrics.Exemplar();
      if (g.value != null && (e.value = Number(g.value)), g.timestamp != null) {
        if (typeof g.timestamp != "object") throw TypeError(".openmetrics.Exemplar.timestamp: object expected");
        e.timestamp = $root$1.google.protobuf.Timestamp.fromObject(g.timestamp);
      }
      if (g.label) {
        if (!Array.isArray(g.label)) throw TypeError(".openmetrics.Exemplar.label: array expected");
        e.label = [];
        for (let t = 0; t < g.label.length; ++t) {
          if (typeof g.label[t] != "object") throw TypeError(".openmetrics.Exemplar.label: object expected");
          e.label[t] = $root$1.openmetrics.Label.fromObject(g.label[t]);
        }
      }
      return e;
    }, E.toObject = function(g, e) {
      e || (e = {});
      let t = {};
      if ((e.arrays || e.defaults) && (t.label = []), e.defaults && (t.value = 0, t.timestamp = null), g.value != null && g.hasOwnProperty("value") && (t.value = e.json && !isFinite(g.value) ? String(g.value) : g.value), g.timestamp != null && g.hasOwnProperty("timestamp") && (t.timestamp = $root$1.google.protobuf.Timestamp.toObject(g.timestamp, e)), g.label && g.label.length) {
        t.label = [];
        for (let c = 0; c < g.label.length; ++c) t.label[c] = $root$1.openmetrics.Label.toObject(g.label[c], e);
      }
      return t;
    }, E.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
    }, E.getTypeUrl = function(g) {
      return g === void 0 && (g = "type.googleapis.com"), g + "/openmetrics.Exemplar";
    }, E;
  })(), o.StateSetValue = (function() {
    function E(A) {
      if (this.states = [], A) for (let g = Object.keys(A), e = 0; e < g.length; ++e) A[g[e]] != null && (this[g[e]] = A[g[e]]);
    }
    return E.prototype.states = $util$1.emptyArray, E.create = function(g) {
      return new E(g);
    }, E.encode = function(g, e) {
      if (e || (e = $Writer$1.create()), g.states != null && g.states.length) for (let t = 0; t < g.states.length; ++t) $root$1.openmetrics.StateSetValue.State.encode(g.states[t], e.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim();
      return e;
    }, E.decode = function(g, e, t) {
      g instanceof $Reader$1 || (g = $Reader$1.create(g));
      let c = e === void 0 ? g.len : g.pos + e, n = new $root$1.openmetrics.StateSetValue();
      for (; g.pos < c; ) {
        let h = g.uint32();
        if (h === t) break;
        switch (h >>> 3) {
          case 1: {
            n.states && n.states.length || (n.states = []), n.states.push($root$1.openmetrics.StateSetValue.State.decode(g, g.uint32()));
            break;
          }
          default:
            g.skipType(h & 7);
            break;
        }
      }
      return n;
    }, E.fromObject = function(g) {
      if (g instanceof $root$1.openmetrics.StateSetValue) return g;
      let e = new $root$1.openmetrics.StateSetValue();
      if (g.states) {
        if (!Array.isArray(g.states)) throw TypeError(".openmetrics.StateSetValue.states: array expected");
        e.states = [];
        for (let t = 0; t < g.states.length; ++t) {
          if (typeof g.states[t] != "object") throw TypeError(".openmetrics.StateSetValue.states: object expected");
          e.states[t] = $root$1.openmetrics.StateSetValue.State.fromObject(g.states[t]);
        }
      }
      return e;
    }, E.toObject = function(g, e) {
      e || (e = {});
      let t = {};
      if ((e.arrays || e.defaults) && (t.states = []), g.states && g.states.length) {
        t.states = [];
        for (let c = 0; c < g.states.length; ++c) t.states[c] = $root$1.openmetrics.StateSetValue.State.toObject(g.states[c], e);
      }
      return t;
    }, E.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
    }, E.getTypeUrl = function(g) {
      return g === void 0 && (g = "type.googleapis.com"), g + "/openmetrics.StateSetValue";
    }, E.State = (function() {
      function A(g) {
        if (g) for (let e = Object.keys(g), t = 0; t < e.length; ++t) g[e[t]] != null && (this[e[t]] = g[e[t]]);
      }
      return A.prototype.enabled = !1, A.prototype.name = "", A.create = function(e) {
        return new A(e);
      }, A.encode = function(e, t) {
        return t || (t = $Writer$1.create()), e.enabled != null && Object.hasOwnProperty.call(e, "enabled") && t.uint32(
          /* id 1, wireType 0 =*/
          8
        ).bool(e.enabled), e.name != null && Object.hasOwnProperty.call(e, "name") && t.uint32(
          /* id 2, wireType 2 =*/
          18
        ).string(e.name), t;
      }, A.decode = function(e, t, c) {
        e instanceof $Reader$1 || (e = $Reader$1.create(e));
        let n = t === void 0 ? e.len : e.pos + t, h = new $root$1.openmetrics.StateSetValue.State();
        for (; e.pos < n; ) {
          let d = e.uint32();
          if (d === c) break;
          switch (d >>> 3) {
            case 1: {
              h.enabled = e.bool();
              break;
            }
            case 2: {
              h.name = e.string();
              break;
            }
            default:
              e.skipType(d & 7);
              break;
          }
        }
        return h;
      }, A.fromObject = function(e) {
        if (e instanceof $root$1.openmetrics.StateSetValue.State) return e;
        let t = new $root$1.openmetrics.StateSetValue.State();
        return e.enabled != null && (t.enabled = !!e.enabled), e.name != null && (t.name = String(e.name)), t;
      }, A.toObject = function(e, t) {
        t || (t = {});
        let c = {};
        return t.defaults && (c.enabled = !1, c.name = ""), e.enabled != null && e.hasOwnProperty("enabled") && (c.enabled = e.enabled), e.name != null && e.hasOwnProperty("name") && (c.name = e.name), c;
      }, A.prototype.toJSON = function() {
        return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
      }, A.getTypeUrl = function(e) {
        return e === void 0 && (e = "type.googleapis.com"), e + "/openmetrics.StateSetValue.State";
      }, A;
    })(), E;
  })(), o.InfoValue = (function() {
    function E(A) {
      if (this.info = [], A) for (let g = Object.keys(A), e = 0; e < g.length; ++e) A[g[e]] != null && (this[g[e]] = A[g[e]]);
    }
    return E.prototype.info = $util$1.emptyArray, E.create = function(g) {
      return new E(g);
    }, E.encode = function(g, e) {
      if (e || (e = $Writer$1.create()), g.info != null && g.info.length) for (let t = 0; t < g.info.length; ++t) $root$1.openmetrics.Label.encode(g.info[t], e.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim();
      return e;
    }, E.decode = function(g, e, t) {
      g instanceof $Reader$1 || (g = $Reader$1.create(g));
      let c = e === void 0 ? g.len : g.pos + e, n = new $root$1.openmetrics.InfoValue();
      for (; g.pos < c; ) {
        let h = g.uint32();
        if (h === t) break;
        switch (h >>> 3) {
          case 1: {
            n.info && n.info.length || (n.info = []), n.info.push($root$1.openmetrics.Label.decode(g, g.uint32()));
            break;
          }
          default:
            g.skipType(h & 7);
            break;
        }
      }
      return n;
    }, E.fromObject = function(g) {
      if (g instanceof $root$1.openmetrics.InfoValue) return g;
      let e = new $root$1.openmetrics.InfoValue();
      if (g.info) {
        if (!Array.isArray(g.info)) throw TypeError(".openmetrics.InfoValue.info: array expected");
        e.info = [];
        for (let t = 0; t < g.info.length; ++t) {
          if (typeof g.info[t] != "object") throw TypeError(".openmetrics.InfoValue.info: object expected");
          e.info[t] = $root$1.openmetrics.Label.fromObject(g.info[t]);
        }
      }
      return e;
    }, E.toObject = function(g, e) {
      e || (e = {});
      let t = {};
      if ((e.arrays || e.defaults) && (t.info = []), g.info && g.info.length) {
        t.info = [];
        for (let c = 0; c < g.info.length; ++c) t.info[c] = $root$1.openmetrics.Label.toObject(g.info[c], e);
      }
      return t;
    }, E.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
    }, E.getTypeUrl = function(g) {
      return g === void 0 && (g = "type.googleapis.com"), g + "/openmetrics.InfoValue";
    }, E;
  })(), o.SummaryValue = (function() {
    function E(g) {
      if (this.quantile = [], g) for (let e = Object.keys(g), t = 0; t < e.length; ++t) g[e[t]] != null && (this[e[t]] = g[e[t]]);
    }
    E.prototype.doubleValue = null, E.prototype.intValue = null, E.prototype.count = $util$1.Long ? $util$1.Long.fromBits(0, 0, !0) : 0, E.prototype.created = null, E.prototype.quantile = $util$1.emptyArray;
    let A;
    return Object.defineProperty(E.prototype, "sum", { get: $util$1.oneOfGetter(A = ["doubleValue", "intValue"]), set: $util$1.oneOfSetter(A) }), E.create = function(e) {
      return new E(e);
    }, E.encode = function(e, t) {
      if (t || (t = $Writer$1.create()), e.doubleValue != null && Object.hasOwnProperty.call(e, "doubleValue") && t.uint32(
        /* id 1, wireType 1 =*/
        9
      ).double(e.doubleValue), e.intValue != null && Object.hasOwnProperty.call(e, "intValue") && t.uint32(
        /* id 2, wireType 0 =*/
        16
      ).int64(e.intValue), e.count != null && Object.hasOwnProperty.call(e, "count") && t.uint32(
        /* id 3, wireType 0 =*/
        24
      ).uint64(e.count), e.created != null && Object.hasOwnProperty.call(e, "created") && $root$1.google.protobuf.Timestamp.encode(e.created, t.uint32(
        /* id 4, wireType 2 =*/
        34
      ).fork()).ldelim(), e.quantile != null && e.quantile.length) for (let c = 0; c < e.quantile.length; ++c) $root$1.openmetrics.SummaryValue.Quantile.encode(e.quantile[c], t.uint32(
        /* id 5, wireType 2 =*/
        42
      ).fork()).ldelim();
      return t;
    }, E.decode = function(e, t, c) {
      e instanceof $Reader$1 || (e = $Reader$1.create(e));
      let n = t === void 0 ? e.len : e.pos + t, h = new $root$1.openmetrics.SummaryValue();
      for (; e.pos < n; ) {
        let d = e.uint32();
        if (d === c) break;
        switch (d >>> 3) {
          case 1: {
            h.doubleValue = e.double();
            break;
          }
          case 2: {
            h.intValue = e.int64();
            break;
          }
          case 3: {
            h.count = e.uint64();
            break;
          }
          case 4: {
            h.created = $root$1.google.protobuf.Timestamp.decode(e, e.uint32());
            break;
          }
          case 5: {
            h.quantile && h.quantile.length || (h.quantile = []), h.quantile.push($root$1.openmetrics.SummaryValue.Quantile.decode(e, e.uint32()));
            break;
          }
          default:
            e.skipType(d & 7);
            break;
        }
      }
      return h;
    }, E.fromObject = function(e) {
      if (e instanceof $root$1.openmetrics.SummaryValue) return e;
      let t = new $root$1.openmetrics.SummaryValue();
      if (e.doubleValue != null && (t.doubleValue = Number(e.doubleValue)), e.intValue != null && ($util$1.Long ? (t.intValue = $util$1.Long.fromValue(e.intValue)).unsigned = !1 : typeof e.intValue == "string" ? t.intValue = parseInt(e.intValue, 10) : typeof e.intValue == "number" ? t.intValue = e.intValue : typeof e.intValue == "object" && (t.intValue = new $util$1.LongBits(e.intValue.low >>> 0, e.intValue.high >>> 0).toNumber())), e.count != null && ($util$1.Long ? (t.count = $util$1.Long.fromValue(e.count)).unsigned = !0 : typeof e.count == "string" ? t.count = parseInt(e.count, 10) : typeof e.count == "number" ? t.count = e.count : typeof e.count == "object" && (t.count = new $util$1.LongBits(e.count.low >>> 0, e.count.high >>> 0).toNumber(!0))), e.created != null) {
        if (typeof e.created != "object") throw TypeError(".openmetrics.SummaryValue.created: object expected");
        t.created = $root$1.google.protobuf.Timestamp.fromObject(e.created);
      }
      if (e.quantile) {
        if (!Array.isArray(e.quantile)) throw TypeError(".openmetrics.SummaryValue.quantile: array expected");
        t.quantile = [];
        for (let c = 0; c < e.quantile.length; ++c) {
          if (typeof e.quantile[c] != "object") throw TypeError(".openmetrics.SummaryValue.quantile: object expected");
          t.quantile[c] = $root$1.openmetrics.SummaryValue.Quantile.fromObject(e.quantile[c]);
        }
      }
      return t;
    }, E.toObject = function(e, t) {
      t || (t = {});
      let c = {};
      if ((t.arrays || t.defaults) && (c.quantile = []), t.defaults) {
        if ($util$1.Long) {
          let n = new $util$1.Long(0, 0, !0);
          c.count = t.longs === String ? n.toString() : t.longs === Number ? n.toNumber() : n;
        } else c.count = t.longs === String ? "0" : 0;
        c.created = null;
      }
      if (e.doubleValue != null && e.hasOwnProperty("doubleValue") && (c.doubleValue = t.json && !isFinite(e.doubleValue) ? String(e.doubleValue) : e.doubleValue, t.oneofs && (c.sum = "doubleValue")), e.intValue != null && e.hasOwnProperty("intValue") && (typeof e.intValue == "number" ? c.intValue = t.longs === String ? String(e.intValue) : e.intValue : c.intValue = t.longs === String ? $util$1.Long.prototype.toString.call(e.intValue) : t.longs === Number ? new $util$1.LongBits(e.intValue.low >>> 0, e.intValue.high >>> 0).toNumber() : e.intValue, t.oneofs && (c.sum = "intValue")), e.count != null && e.hasOwnProperty("count") && (typeof e.count == "number" ? c.count = t.longs === String ? String(e.count) : e.count : c.count = t.longs === String ? $util$1.Long.prototype.toString.call(e.count) : t.longs === Number ? new $util$1.LongBits(e.count.low >>> 0, e.count.high >>> 0).toNumber(!0) : e.count), e.created != null && e.hasOwnProperty("created") && (c.created = $root$1.google.protobuf.Timestamp.toObject(e.created, t)), e.quantile && e.quantile.length) {
        c.quantile = [];
        for (let n = 0; n < e.quantile.length; ++n) c.quantile[n] = $root$1.openmetrics.SummaryValue.Quantile.toObject(e.quantile[n], t);
      }
      return c;
    }, E.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
    }, E.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/openmetrics.SummaryValue";
    }, E.Quantile = (function() {
      function g(e) {
        if (e) for (let t = Object.keys(e), c = 0; c < t.length; ++c) e[t[c]] != null && (this[t[c]] = e[t[c]]);
      }
      return g.prototype.quantile = 0, g.prototype.value = 0, g.create = function(t) {
        return new g(t);
      }, g.encode = function(t, c) {
        return c || (c = $Writer$1.create()), t.quantile != null && Object.hasOwnProperty.call(t, "quantile") && c.uint32(
          /* id 1, wireType 1 =*/
          9
        ).double(t.quantile), t.value != null && Object.hasOwnProperty.call(t, "value") && c.uint32(
          /* id 2, wireType 1 =*/
          17
        ).double(t.value), c;
      }, g.decode = function(t, c, n) {
        t instanceof $Reader$1 || (t = $Reader$1.create(t));
        let h = c === void 0 ? t.len : t.pos + c, d = new $root$1.openmetrics.SummaryValue.Quantile();
        for (; t.pos < h; ) {
          let k = t.uint32();
          if (k === n) break;
          switch (k >>> 3) {
            case 1: {
              d.quantile = t.double();
              break;
            }
            case 2: {
              d.value = t.double();
              break;
            }
            default:
              t.skipType(k & 7);
              break;
          }
        }
        return d;
      }, g.fromObject = function(t) {
        if (t instanceof $root$1.openmetrics.SummaryValue.Quantile) return t;
        let c = new $root$1.openmetrics.SummaryValue.Quantile();
        return t.quantile != null && (c.quantile = Number(t.quantile)), t.value != null && (c.value = Number(t.value)), c;
      }, g.toObject = function(t, c) {
        c || (c = {});
        let n = {};
        return c.defaults && (n.quantile = 0, n.value = 0), t.quantile != null && t.hasOwnProperty("quantile") && (n.quantile = c.json && !isFinite(t.quantile) ? String(t.quantile) : t.quantile), t.value != null && t.hasOwnProperty("value") && (n.value = c.json && !isFinite(t.value) ? String(t.value) : t.value), n;
      }, g.prototype.toJSON = function() {
        return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
      }, g.getTypeUrl = function(t) {
        return t === void 0 && (t = "type.googleapis.com"), t + "/openmetrics.SummaryValue.Quantile";
      }, g;
    })(), E;
  })(), o;
})();
$root$1.google = (() => {
  const o = {};
  return o.protobuf = (function() {
    const E = {};
    return E.Timestamp = (function() {
      function A(g) {
        if (g) for (let e = Object.keys(g), t = 0; t < e.length; ++t) g[e[t]] != null && (this[e[t]] = g[e[t]]);
      }
      return A.prototype.seconds = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, A.prototype.nanos = 0, A.create = function(e) {
        return new A(e);
      }, A.encode = function(e, t) {
        return t || (t = $Writer$1.create()), e.seconds != null && Object.hasOwnProperty.call(e, "seconds") && t.uint32(
          /* id 1, wireType 0 =*/
          8
        ).int64(e.seconds), e.nanos != null && Object.hasOwnProperty.call(e, "nanos") && t.uint32(
          /* id 2, wireType 0 =*/
          16
        ).int32(e.nanos), t;
      }, A.decode = function(e, t, c) {
        e instanceof $Reader$1 || (e = $Reader$1.create(e));
        let n = t === void 0 ? e.len : e.pos + t, h = new $root$1.google.protobuf.Timestamp();
        for (; e.pos < n; ) {
          let d = e.uint32();
          if (d === c) break;
          switch (d >>> 3) {
            case 1: {
              h.seconds = e.int64();
              break;
            }
            case 2: {
              h.nanos = e.int32();
              break;
            }
            default:
              e.skipType(d & 7);
              break;
          }
        }
        return h;
      }, A.fromObject = function(e) {
        if (e instanceof $root$1.google.protobuf.Timestamp) return e;
        let t = new $root$1.google.protobuf.Timestamp();
        return e.seconds != null && ($util$1.Long ? (t.seconds = $util$1.Long.fromValue(e.seconds)).unsigned = !1 : typeof e.seconds == "string" ? t.seconds = parseInt(e.seconds, 10) : typeof e.seconds == "number" ? t.seconds = e.seconds : typeof e.seconds == "object" && (t.seconds = new $util$1.LongBits(e.seconds.low >>> 0, e.seconds.high >>> 0).toNumber())), e.nanos != null && (t.nanos = e.nanos | 0), t;
      }, A.toObject = function(e, t) {
        t || (t = {});
        let c = {};
        if (t.defaults) {
          if ($util$1.Long) {
            let n = new $util$1.Long(0, 0, !1);
            c.seconds = t.longs === String ? n.toString() : t.longs === Number ? n.toNumber() : n;
          } else c.seconds = t.longs === String ? "0" : 0;
          c.nanos = 0;
        }
        return e.seconds != null && e.hasOwnProperty("seconds") && (typeof e.seconds == "number" ? c.seconds = t.longs === String ? String(e.seconds) : e.seconds : c.seconds = t.longs === String ? $util$1.Long.prototype.toString.call(e.seconds) : t.longs === Number ? new $util$1.LongBits(e.seconds.low >>> 0, e.seconds.high >>> 0).toNumber() : e.seconds), e.nanos != null && e.hasOwnProperty("nanos") && (c.nanos = e.nanos), c;
      }, A.prototype.toJSON = function() {
        return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
      }, A.getTypeUrl = function(e) {
        return e === void 0 && (e = "type.googleapis.com"), e + "/google.protobuf.Timestamp";
      }, A;
    })(), E;
  })(), o;
})();
$root$1.RootContainer = (() => {
  const o = {}, E = Object.create(o);
  return E[o[0] = "MAIN"] = 0, E[o[1] = "SIDEBAR"] = 1, E[o[2] = "EVENT"] = 2, E[o[3] = "BOTTOM"] = 3, E;
})();
function ensureError(o) {
  return o instanceof Error ? o : new Error(`${o}`);
}
const handlePreserveConsecutiveUppercase = (o, E) => (o = o.replace(
  new RegExp("((?<![\\p{Uppercase_Letter}\\d])[\\p{Uppercase_Letter}\\d](?![\\p{Uppercase_Letter}\\d]))", "gu"),
  (A) => A.toLowerCase()
), o.replace(
  new RegExp("(?<!\\p{Uppercase_Letter})(\\p{Uppercase_Letter}+)(\\p{Uppercase_Letter}\\p{Lowercase_Letter}+)", "gu"),
  (A, g, e) => g + E + e.toLowerCase()
));
function decamelize$1(o, {
  separator: E = "_",
  preserveConsecutiveUppercase: A = !1
} = {}) {
  if (!(typeof o == "string" && typeof E == "string"))
    throw new TypeError(
      "The `text` and `separator` arguments should be of type `string`"
    );
  if (o.length < 2)
    return A ? o : o.toLowerCase();
  const g = `$1${E}$2`, e = o.replace(
    new RegExp("([\\p{Lowercase_Letter}\\d])(\\p{Uppercase_Letter})", "gu"),
    g
  );
  return A ? handlePreserveConsecutiveUppercase(e, E) : e.replace(
    new RegExp("(\\p{Uppercase_Letter})(\\p{Uppercase_Letter}\\p{Lowercase_Letter}+)", "gu"),
    g
  ).toLowerCase();
}
var freeGlobal = typeof global == "object" && global && global.Object === Object && global, freeSelf = typeof self == "object" && self && self.Object === Object && self, root$4 = freeGlobal || freeSelf || Function("return this")(), Symbol$1 = root$4.Symbol, objectProto$g = Object.prototype, hasOwnProperty$e = objectProto$g.hasOwnProperty, nativeObjectToString$1 = objectProto$g.toString, symToStringTag$1 = Symbol$1 ? Symbol$1.toStringTag : void 0;
function getRawTag(o) {
  var E = hasOwnProperty$e.call(o, symToStringTag$1), A = o[symToStringTag$1];
  try {
    o[symToStringTag$1] = void 0;
    var g = !0;
  } catch {
  }
  var e = nativeObjectToString$1.call(o);
  return g && (E ? o[symToStringTag$1] = A : delete o[symToStringTag$1]), e;
}
var objectProto$f = Object.prototype, nativeObjectToString = objectProto$f.toString;
function objectToString(o) {
  return nativeObjectToString.call(o);
}
var nullTag = "[object Null]", undefinedTag = "[object Undefined]", symToStringTag = Symbol$1 ? Symbol$1.toStringTag : void 0;
function baseGetTag(o) {
  return o == null ? o === void 0 ? undefinedTag : nullTag : symToStringTag && symToStringTag in Object(o) ? getRawTag(o) : objectToString(o);
}
function isObjectLike(o) {
  return o != null && typeof o == "object";
}
var symbolTag$3 = "[object Symbol]";
function isSymbol(o) {
  return typeof o == "symbol" || isObjectLike(o) && baseGetTag(o) == symbolTag$3;
}
function arrayMap(o, E) {
  for (var A = -1, g = o == null ? 0 : o.length, e = Array(g); ++A < g; )
    e[A] = E(o[A], A, o);
  return e;
}
var isArray = Array.isArray, symbolProto$2 = Symbol$1 ? Symbol$1.prototype : void 0, symbolToString = symbolProto$2 ? symbolProto$2.toString : void 0;
function baseToString(o) {
  if (typeof o == "string")
    return o;
  if (isArray(o))
    return arrayMap(o, baseToString) + "";
  if (isSymbol(o))
    return symbolToString ? symbolToString.call(o) : "";
  var E = o + "";
  return E == "0" && 1 / o == -1 / 0 ? "-0" : E;
}
var reWhitespace = /\s/;
function trimmedEndIndex(o) {
  for (var E = o.length; E-- && reWhitespace.test(o.charAt(E)); )
    ;
  return E;
}
var reTrimStart = /^\s+/;
function baseTrim(o) {
  return o && o.slice(0, trimmedEndIndex(o) + 1).replace(reTrimStart, "");
}
function isObject$3(o) {
  var E = typeof o;
  return o != null && (E == "object" || E == "function");
}
var NAN = NaN, reIsBadHex = /^[-+]0x[0-9a-f]+$/i, reIsBinary = /^0b[01]+$/i, reIsOctal = /^0o[0-7]+$/i, freeParseInt = parseInt;
function toNumber(o) {
  if (typeof o == "number")
    return o;
  if (isSymbol(o))
    return NAN;
  if (isObject$3(o)) {
    var E = typeof o.valueOf == "function" ? o.valueOf() : o;
    o = isObject$3(E) ? E + "" : E;
  }
  if (typeof o != "string")
    return o === 0 ? o : +o;
  o = baseTrim(o);
  var A = reIsBinary.test(o);
  return A || reIsOctal.test(o) ? freeParseInt(o.slice(2), A ? 2 : 8) : reIsBadHex.test(o) ? NAN : +o;
}
var INFINITY = 1 / 0, MAX_INTEGER = 17976931348623157e292;
function toFinite(o) {
  if (!o)
    return o === 0 ? o : 0;
  if (o = toNumber(o), o === INFINITY || o === -INFINITY) {
    var E = o < 0 ? -1 : 1;
    return E * MAX_INTEGER;
  }
  return o === o ? o : 0;
}
function toInteger(o) {
  var E = toFinite(o), A = E % 1;
  return E === E ? A ? E - A : E : 0;
}
function identity(o) {
  return o;
}
var asyncTag = "[object AsyncFunction]", funcTag$2 = "[object Function]", genTag$1 = "[object GeneratorFunction]", proxyTag = "[object Proxy]";
function isFunction$3(o) {
  if (!isObject$3(o))
    return !1;
  var E = baseGetTag(o);
  return E == funcTag$2 || E == genTag$1 || E == asyncTag || E == proxyTag;
}
var coreJsData = root$4["__core-js_shared__"], maskSrcKey = (function() {
  var o = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
  return o ? "Symbol(src)_1." + o : "";
})();
function isMasked(o) {
  return !!maskSrcKey && maskSrcKey in o;
}
var funcProto$2 = Function.prototype, funcToString$2 = funcProto$2.toString;
function toSource(o) {
  if (o != null) {
    try {
      return funcToString$2.call(o);
    } catch {
    }
    try {
      return o + "";
    } catch {
    }
  }
  return "";
}
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reIsHostCtor = /^\[object .+?Constructor\]$/, funcProto$1 = Function.prototype, objectProto$e = Object.prototype, funcToString$1 = funcProto$1.toString, hasOwnProperty$d = objectProto$e.hasOwnProperty, reIsNative = RegExp(
  "^" + funcToString$1.call(hasOwnProperty$d).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function baseIsNative(o) {
  if (!isObject$3(o) || isMasked(o))
    return !1;
  var E = isFunction$3(o) ? reIsNative : reIsHostCtor;
  return E.test(toSource(o));
}
function getValue(o, E) {
  return o?.[E];
}
function getNative(o, E) {
  var A = getValue(o, E);
  return baseIsNative(A) ? A : void 0;
}
var WeakMap$1 = getNative(root$4, "WeakMap"), objectCreate = Object.create, baseCreate = /* @__PURE__ */ (function() {
  function o() {
  }
  return function(E) {
    if (!isObject$3(E))
      return {};
    if (objectCreate)
      return objectCreate(E);
    o.prototype = E;
    var A = new o();
    return o.prototype = void 0, A;
  };
})();
function apply(o, E, A) {
  switch (A.length) {
    case 0:
      return o.call(E);
    case 1:
      return o.call(E, A[0]);
    case 2:
      return o.call(E, A[0], A[1]);
    case 3:
      return o.call(E, A[0], A[1], A[2]);
  }
  return o.apply(E, A);
}
function copyArray(o, E) {
  var A = -1, g = o.length;
  for (E || (E = Array(g)); ++A < g; )
    E[A] = o[A];
  return E;
}
var HOT_COUNT = 800, HOT_SPAN = 16, nativeNow = Date.now;
function shortOut(o) {
  var E = 0, A = 0;
  return function() {
    var g = nativeNow(), e = HOT_SPAN - (g - A);
    if (A = g, e > 0) {
      if (++E >= HOT_COUNT)
        return arguments[0];
    } else
      E = 0;
    return o.apply(void 0, arguments);
  };
}
function constant(o) {
  return function() {
    return o;
  };
}
var defineProperty$1 = (function() {
  try {
    var o = getNative(Object, "defineProperty");
    return o({}, "", {}), o;
  } catch {
  }
})(), baseSetToString = defineProperty$1 ? function(o, E) {
  return defineProperty$1(o, "toString", {
    configurable: !0,
    enumerable: !1,
    value: constant(E),
    writable: !0
  });
} : identity, setToString = shortOut(baseSetToString);
function arrayEach(o, E) {
  for (var A = -1, g = o == null ? 0 : o.length; ++A < g && E(o[A], A, o) !== !1; )
    ;
  return o;
}
var MAX_SAFE_INTEGER$1 = 9007199254740991, reIsUint = /^(?:0|[1-9]\d*)$/;
function isIndex(o, E) {
  var A = typeof o;
  return E = E ?? MAX_SAFE_INTEGER$1, !!E && (A == "number" || A != "symbol" && reIsUint.test(o)) && o > -1 && o % 1 == 0 && o < E;
}
function baseAssignValue(o, E, A) {
  E == "__proto__" && defineProperty$1 ? defineProperty$1(o, E, {
    configurable: !0,
    enumerable: !0,
    value: A,
    writable: !0
  }) : o[E] = A;
}
function eq(o, E) {
  return o === E || o !== o && E !== E;
}
var objectProto$d = Object.prototype, hasOwnProperty$c = objectProto$d.hasOwnProperty;
function assignValue(o, E, A) {
  var g = o[E];
  (!(hasOwnProperty$c.call(o, E) && eq(g, A)) || A === void 0 && !(E in o)) && baseAssignValue(o, E, A);
}
function copyObject(o, E, A, g) {
  var e = !A;
  A || (A = {});
  for (var t = -1, c = E.length; ++t < c; ) {
    var n = E[t], h = void 0;
    h === void 0 && (h = o[n]), e ? baseAssignValue(A, n, h) : assignValue(A, n, h);
  }
  return A;
}
var nativeMax$2 = Math.max;
function overRest(o, E, A) {
  return E = nativeMax$2(E === void 0 ? o.length - 1 : E, 0), function() {
    for (var g = arguments, e = -1, t = nativeMax$2(g.length - E, 0), c = Array(t); ++e < t; )
      c[e] = g[E + e];
    e = -1;
    for (var n = Array(E + 1); ++e < E; )
      n[e] = g[e];
    return n[E] = A(c), apply(o, this, n);
  };
}
function baseRest(o, E) {
  return setToString(overRest(o, E, identity), o + "");
}
var MAX_SAFE_INTEGER = 9007199254740991;
function isLength(o) {
  return typeof o == "number" && o > -1 && o % 1 == 0 && o <= MAX_SAFE_INTEGER;
}
function isArrayLike(o) {
  return o != null && isLength(o.length) && !isFunction$3(o);
}
function isIterateeCall(o, E, A) {
  if (!isObject$3(A))
    return !1;
  var g = typeof E;
  return (g == "number" ? isArrayLike(A) && isIndex(E, A.length) : g == "string" && E in A) ? eq(A[E], o) : !1;
}
function createAssigner(o) {
  return baseRest(function(E, A) {
    var g = -1, e = A.length, t = e > 1 ? A[e - 1] : void 0, c = e > 2 ? A[2] : void 0;
    for (t = o.length > 3 && typeof t == "function" ? (e--, t) : void 0, c && isIterateeCall(A[0], A[1], c) && (t = e < 3 ? void 0 : t, e = 1), E = Object(E); ++g < e; ) {
      var n = A[g];
      n && o(E, n, g, t);
    }
    return E;
  });
}
var objectProto$c = Object.prototype;
function isPrototype(o) {
  var E = o && o.constructor, A = typeof E == "function" && E.prototype || objectProto$c;
  return o === A;
}
function baseTimes(o, E) {
  for (var A = -1, g = Array(o); ++A < o; )
    g[A] = E(A);
  return g;
}
var argsTag$3 = "[object Arguments]";
function baseIsArguments(o) {
  return isObjectLike(o) && baseGetTag(o) == argsTag$3;
}
var objectProto$b = Object.prototype, hasOwnProperty$b = objectProto$b.hasOwnProperty, propertyIsEnumerable$1 = objectProto$b.propertyIsEnumerable, isArguments = baseIsArguments(/* @__PURE__ */ (function() {
  return arguments;
})()) ? baseIsArguments : function(o) {
  return isObjectLike(o) && hasOwnProperty$b.call(o, "callee") && !propertyIsEnumerable$1.call(o, "callee");
};
function stubFalse() {
  return !1;
}
var freeExports$2 = typeof exports == "object" && exports && !exports.nodeType && exports, freeModule$2 = freeExports$2 && typeof module == "object" && module && !module.nodeType && module, moduleExports$2 = freeModule$2 && freeModule$2.exports === freeExports$2, Buffer$3 = moduleExports$2 ? root$4.Buffer : void 0, nativeIsBuffer = Buffer$3 ? Buffer$3.isBuffer : void 0, isBuffer = nativeIsBuffer || stubFalse, argsTag$2 = "[object Arguments]", arrayTag$2 = "[object Array]", boolTag$3 = "[object Boolean]", dateTag$3 = "[object Date]", errorTag$2 = "[object Error]", funcTag$1 = "[object Function]", mapTag$5 = "[object Map]", numberTag$3 = "[object Number]", objectTag$4 = "[object Object]", regexpTag$3 = "[object RegExp]", setTag$5 = "[object Set]", stringTag$3 = "[object String]", weakMapTag$2 = "[object WeakMap]", arrayBufferTag$3 = "[object ArrayBuffer]", dataViewTag$4 = "[object DataView]", float32Tag$2 = "[object Float32Array]", float64Tag$2 = "[object Float64Array]", int8Tag$2 = "[object Int8Array]", int16Tag$2 = "[object Int16Array]", int32Tag$2 = "[object Int32Array]", uint8Tag$2 = "[object Uint8Array]", uint8ClampedTag$2 = "[object Uint8ClampedArray]", uint16Tag$2 = "[object Uint16Array]", uint32Tag$2 = "[object Uint32Array]", typedArrayTags = {};
typedArrayTags[float32Tag$2] = typedArrayTags[float64Tag$2] = typedArrayTags[int8Tag$2] = typedArrayTags[int16Tag$2] = typedArrayTags[int32Tag$2] = typedArrayTags[uint8Tag$2] = typedArrayTags[uint8ClampedTag$2] = typedArrayTags[uint16Tag$2] = typedArrayTags[uint32Tag$2] = !0;
typedArrayTags[argsTag$2] = typedArrayTags[arrayTag$2] = typedArrayTags[arrayBufferTag$3] = typedArrayTags[boolTag$3] = typedArrayTags[dataViewTag$4] = typedArrayTags[dateTag$3] = typedArrayTags[errorTag$2] = typedArrayTags[funcTag$1] = typedArrayTags[mapTag$5] = typedArrayTags[numberTag$3] = typedArrayTags[objectTag$4] = typedArrayTags[regexpTag$3] = typedArrayTags[setTag$5] = typedArrayTags[stringTag$3] = typedArrayTags[weakMapTag$2] = !1;
function baseIsTypedArray(o) {
  return isObjectLike(o) && isLength(o.length) && !!typedArrayTags[baseGetTag(o)];
}
function baseUnary(o) {
  return function(E) {
    return o(E);
  };
}
var freeExports$1 = typeof exports == "object" && exports && !exports.nodeType && exports, freeModule$1 = freeExports$1 && typeof module == "object" && module && !module.nodeType && module, moduleExports$1 = freeModule$1 && freeModule$1.exports === freeExports$1, freeProcess = moduleExports$1 && freeGlobal.process, nodeUtil = (function() {
  try {
    var o = freeModule$1 && freeModule$1.require && freeModule$1.require("util").types;
    return o || freeProcess && freeProcess.binding && freeProcess.binding("util");
  } catch {
  }
})(), nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray, isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray, objectProto$a = Object.prototype, hasOwnProperty$a = objectProto$a.hasOwnProperty;
function arrayLikeKeys(o, E) {
  var A = isArray(o), g = !A && isArguments(o), e = !A && !g && isBuffer(o), t = !A && !g && !e && isTypedArray(o), c = A || g || e || t, n = c ? baseTimes(o.length, String) : [], h = n.length;
  for (var d in o)
    (E || hasOwnProperty$a.call(o, d)) && !(c && // Safari 9 has enumerable `arguments.length` in strict mode.
    (d == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    e && (d == "offset" || d == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    t && (d == "buffer" || d == "byteLength" || d == "byteOffset") || // Skip index properties.
    isIndex(d, h))) && n.push(d);
  return n;
}
function overArg(o, E) {
  return function(A) {
    return o(E(A));
  };
}
var nativeKeys = overArg(Object.keys, Object), objectProto$9 = Object.prototype, hasOwnProperty$9 = objectProto$9.hasOwnProperty;
function baseKeys(o) {
  if (!isPrototype(o))
    return nativeKeys(o);
  var E = [];
  for (var A in Object(o))
    hasOwnProperty$9.call(o, A) && A != "constructor" && E.push(A);
  return E;
}
function keys$1(o) {
  return isArrayLike(o) ? arrayLikeKeys(o) : baseKeys(o);
}
function nativeKeysIn(o) {
  var E = [];
  if (o != null)
    for (var A in Object(o))
      E.push(A);
  return E;
}
var objectProto$8 = Object.prototype, hasOwnProperty$8 = objectProto$8.hasOwnProperty;
function baseKeysIn(o) {
  if (!isObject$3(o))
    return nativeKeysIn(o);
  var E = isPrototype(o), A = [];
  for (var g in o)
    g == "constructor" && (E || !hasOwnProperty$8.call(o, g)) || A.push(g);
  return A;
}
function keysIn(o) {
  return isArrayLike(o) ? arrayLikeKeys(o, !0) : baseKeysIn(o);
}
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/;
function isKey(o, E) {
  if (isArray(o))
    return !1;
  var A = typeof o;
  return A == "number" || A == "symbol" || A == "boolean" || o == null || isSymbol(o) ? !0 : reIsPlainProp.test(o) || !reIsDeepProp.test(o) || E != null && o in Object(E);
}
var nativeCreate = getNative(Object, "create");
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {}, this.size = 0;
}
function hashDelete(o) {
  var E = this.has(o) && delete this.__data__[o];
  return this.size -= E ? 1 : 0, E;
}
var HASH_UNDEFINED$2 = "__lodash_hash_undefined__", objectProto$7 = Object.prototype, hasOwnProperty$7 = objectProto$7.hasOwnProperty;
function hashGet(o) {
  var E = this.__data__;
  if (nativeCreate) {
    var A = E[o];
    return A === HASH_UNDEFINED$2 ? void 0 : A;
  }
  return hasOwnProperty$7.call(E, o) ? E[o] : void 0;
}
var objectProto$6 = Object.prototype, hasOwnProperty$6 = objectProto$6.hasOwnProperty;
function hashHas(o) {
  var E = this.__data__;
  return nativeCreate ? E[o] !== void 0 : hasOwnProperty$6.call(E, o);
}
var HASH_UNDEFINED$1 = "__lodash_hash_undefined__";
function hashSet(o, E) {
  var A = this.__data__;
  return this.size += this.has(o) ? 0 : 1, A[o] = nativeCreate && E === void 0 ? HASH_UNDEFINED$1 : E, this;
}
function Hash(o) {
  var E = -1, A = o == null ? 0 : o.length;
  for (this.clear(); ++E < A; ) {
    var g = o[E];
    this.set(g[0], g[1]);
  }
}
Hash.prototype.clear = hashClear;
Hash.prototype.delete = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
function listCacheClear() {
  this.__data__ = [], this.size = 0;
}
function assocIndexOf(o, E) {
  for (var A = o.length; A--; )
    if (eq(o[A][0], E))
      return A;
  return -1;
}
var arrayProto = Array.prototype, splice$1 = arrayProto.splice;
function listCacheDelete(o) {
  var E = this.__data__, A = assocIndexOf(E, o);
  if (A < 0)
    return !1;
  var g = E.length - 1;
  return A == g ? E.pop() : splice$1.call(E, A, 1), --this.size, !0;
}
function listCacheGet(o) {
  var E = this.__data__, A = assocIndexOf(E, o);
  return A < 0 ? void 0 : E[A][1];
}
function listCacheHas(o) {
  return assocIndexOf(this.__data__, o) > -1;
}
function listCacheSet(o, E) {
  var A = this.__data__, g = assocIndexOf(A, o);
  return g < 0 ? (++this.size, A.push([o, E])) : A[g][1] = E, this;
}
function ListCache(o) {
  var E = -1, A = o == null ? 0 : o.length;
  for (this.clear(); ++E < A; ) {
    var g = o[E];
    this.set(g[0], g[1]);
  }
}
ListCache.prototype.clear = listCacheClear;
ListCache.prototype.delete = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
var Map$2 = getNative(root$4, "Map");
function mapCacheClear() {
  this.size = 0, this.__data__ = {
    hash: new Hash(),
    map: new (Map$2 || ListCache)(),
    string: new Hash()
  };
}
function isKeyable(o) {
  var E = typeof o;
  return E == "string" || E == "number" || E == "symbol" || E == "boolean" ? o !== "__proto__" : o === null;
}
function getMapData(o, E) {
  var A = o.__data__;
  return isKeyable(E) ? A[typeof E == "string" ? "string" : "hash"] : A.map;
}
function mapCacheDelete(o) {
  var E = getMapData(this, o).delete(o);
  return this.size -= E ? 1 : 0, E;
}
function mapCacheGet(o) {
  return getMapData(this, o).get(o);
}
function mapCacheHas(o) {
  return getMapData(this, o).has(o);
}
function mapCacheSet(o, E) {
  var A = getMapData(this, o), g = A.size;
  return A.set(o, E), this.size += A.size == g ? 0 : 1, this;
}
function MapCache(o) {
  var E = -1, A = o == null ? 0 : o.length;
  for (this.clear(); ++E < A; ) {
    var g = o[E];
    this.set(g[0], g[1]);
  }
}
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype.delete = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
var FUNC_ERROR_TEXT$1 = "Expected a function";
function memoize(o, E) {
  if (typeof o != "function" || E != null && typeof E != "function")
    throw new TypeError(FUNC_ERROR_TEXT$1);
  var A = function() {
    var g = arguments, e = E ? E.apply(this, g) : g[0], t = A.cache;
    if (t.has(e))
      return t.get(e);
    var c = o.apply(this, g);
    return A.cache = t.set(e, c) || t, c;
  };
  return A.cache = new (memoize.Cache || MapCache)(), A;
}
memoize.Cache = MapCache;
var MAX_MEMOIZE_SIZE = 500;
function memoizeCapped(o) {
  var E = memoize(o, function(g) {
    return A.size === MAX_MEMOIZE_SIZE && A.clear(), g;
  }), A = E.cache;
  return E;
}
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, reEscapeChar = /\\(\\)?/g, stringToPath = memoizeCapped(function(o) {
  var E = [];
  return o.charCodeAt(0) === 46 && E.push(""), o.replace(rePropName, function(A, g, e, t) {
    E.push(e ? t.replace(reEscapeChar, "$1") : g || A);
  }), E;
});
function toString$3(o) {
  return o == null ? "" : baseToString(o);
}
function castPath(o, E) {
  return isArray(o) ? o : isKey(o, E) ? [o] : stringToPath(toString$3(o));
}
function toKey(o) {
  if (typeof o == "string" || isSymbol(o))
    return o;
  var E = o + "";
  return E == "0" && 1 / o == -1 / 0 ? "-0" : E;
}
function baseGet(o, E) {
  E = castPath(E, o);
  for (var A = 0, g = E.length; o != null && A < g; )
    o = o[toKey(E[A++])];
  return A && A == g ? o : void 0;
}
function get$1(o, E, A) {
  var g = o == null ? void 0 : baseGet(o, E);
  return g === void 0 ? A : g;
}
function arrayPush(o, E) {
  for (var A = -1, g = E.length, e = o.length; ++A < g; )
    o[e + A] = E[A];
  return o;
}
var spreadableSymbol = Symbol$1 ? Symbol$1.isConcatSpreadable : void 0;
function isFlattenable(o) {
  return isArray(o) || isArguments(o) || !!(spreadableSymbol && o && o[spreadableSymbol]);
}
function baseFlatten(o, E, A, g, e) {
  var t = -1, c = o.length;
  for (A || (A = isFlattenable), e || (e = []); ++t < c; ) {
    var n = o[t];
    A(n) ? arrayPush(e, n) : e[e.length] = n;
  }
  return e;
}
function flatten(o) {
  var E = o == null ? 0 : o.length;
  return E ? baseFlatten(o) : [];
}
function flatRest(o) {
  return setToString(overRest(o, void 0, flatten), o + "");
}
var getPrototype = overArg(Object.getPrototypeOf, Object), objectTag$3 = "[object Object]", funcProto = Function.prototype, objectProto$5 = Object.prototype, funcToString = funcProto.toString, hasOwnProperty$5 = objectProto$5.hasOwnProperty, objectCtorString$1 = funcToString.call(Object);
function isPlainObject$3(o) {
  if (!isObjectLike(o) || baseGetTag(o) != objectTag$3)
    return !1;
  var E = getPrototype(o);
  if (E === null)
    return !0;
  var A = hasOwnProperty$5.call(E, "constructor") && E.constructor;
  return typeof A == "function" && A instanceof A && funcToString.call(A) == objectCtorString$1;
}
var FUNC_ERROR_TEXT = "Expected a function";
function before(o, E) {
  var A;
  if (typeof E != "function")
    throw new TypeError(FUNC_ERROR_TEXT);
  return o = toInteger(o), function() {
    return --o > 0 && (A = E.apply(this, arguments)), o <= 1 && (E = void 0), A;
  };
}
function baseSlice(o, E, A) {
  var g = -1, e = o.length;
  E < 0 && (E = -E > e ? 0 : e + E), A = A > e ? e : A, A < 0 && (A += e), e = E > A ? 0 : A - E >>> 0, E >>>= 0;
  for (var t = Array(e); ++g < e; )
    t[g] = o[g + E];
  return t;
}
function stackClear() {
  this.__data__ = new ListCache(), this.size = 0;
}
function stackDelete(o) {
  var E = this.__data__, A = E.delete(o);
  return this.size = E.size, A;
}
function stackGet(o) {
  return this.__data__.get(o);
}
function stackHas(o) {
  return this.__data__.has(o);
}
var LARGE_ARRAY_SIZE = 200;
function stackSet(o, E) {
  var A = this.__data__;
  if (A instanceof ListCache) {
    var g = A.__data__;
    if (!Map$2 || g.length < LARGE_ARRAY_SIZE - 1)
      return g.push([o, E]), this.size = ++A.size, this;
    A = this.__data__ = new MapCache(g);
  }
  return A.set(o, E), this.size = A.size, this;
}
function Stack(o) {
  var E = this.__data__ = new ListCache(o);
  this.size = E.size;
}
Stack.prototype.clear = stackClear;
Stack.prototype.delete = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
function baseAssign(o, E) {
  return o && copyObject(E, keys$1(E), o);
}
function baseAssignIn(o, E) {
  return o && copyObject(E, keysIn(E), o);
}
var freeExports = typeof exports == "object" && exports && !exports.nodeType && exports, freeModule = freeExports && typeof module == "object" && module && !module.nodeType && module, moduleExports = freeModule && freeModule.exports === freeExports, Buffer$2 = moduleExports ? root$4.Buffer : void 0, allocUnsafe = Buffer$2 ? Buffer$2.allocUnsafe : void 0;
function cloneBuffer(o, E) {
  if (E)
    return o.slice();
  var A = o.length, g = allocUnsafe ? allocUnsafe(A) : new o.constructor(A);
  return o.copy(g), g;
}
function arrayFilter(o, E) {
  for (var A = -1, g = o == null ? 0 : o.length, e = 0, t = []; ++A < g; ) {
    var c = o[A];
    E(c, A, o) && (t[e++] = c);
  }
  return t;
}
function stubArray() {
  return [];
}
var objectProto$4 = Object.prototype, propertyIsEnumerable = objectProto$4.propertyIsEnumerable, nativeGetSymbols$1 = Object.getOwnPropertySymbols, getSymbols = nativeGetSymbols$1 ? function(o) {
  return o == null ? [] : (o = Object(o), arrayFilter(nativeGetSymbols$1(o), function(E) {
    return propertyIsEnumerable.call(o, E);
  }));
} : stubArray;
function copySymbols(o, E) {
  return copyObject(o, getSymbols(o), E);
}
var nativeGetSymbols = Object.getOwnPropertySymbols, getSymbolsIn = nativeGetSymbols ? function(o) {
  for (var E = []; o; )
    arrayPush(E, getSymbols(o)), o = getPrototype(o);
  return E;
} : stubArray;
function copySymbolsIn(o, E) {
  return copyObject(o, getSymbolsIn(o), E);
}
function baseGetAllKeys(o, E, A) {
  var g = E(o);
  return isArray(o) ? g : arrayPush(g, A(o));
}
function getAllKeys(o) {
  return baseGetAllKeys(o, keys$1, getSymbols);
}
function getAllKeysIn(o) {
  return baseGetAllKeys(o, keysIn, getSymbolsIn);
}
var DataView$1 = getNative(root$4, "DataView"), Promise$1 = getNative(root$4, "Promise"), Set$1 = getNative(root$4, "Set"), mapTag$4 = "[object Map]", objectTag$2 = "[object Object]", promiseTag = "[object Promise]", setTag$4 = "[object Set]", weakMapTag$1 = "[object WeakMap]", dataViewTag$3 = "[object DataView]", dataViewCtorString = toSource(DataView$1), mapCtorString = toSource(Map$2), promiseCtorString = toSource(Promise$1), setCtorString = toSource(Set$1), weakMapCtorString = toSource(WeakMap$1), getTag = baseGetTag;
(DataView$1 && getTag(new DataView$1(new ArrayBuffer(1))) != dataViewTag$3 || Map$2 && getTag(new Map$2()) != mapTag$4 || Promise$1 && getTag(Promise$1.resolve()) != promiseTag || Set$1 && getTag(new Set$1()) != setTag$4 || WeakMap$1 && getTag(new WeakMap$1()) != weakMapTag$1) && (getTag = function(o) {
  var E = baseGetTag(o), A = E == objectTag$2 ? o.constructor : void 0, g = A ? toSource(A) : "";
  if (g)
    switch (g) {
      case dataViewCtorString:
        return dataViewTag$3;
      case mapCtorString:
        return mapTag$4;
      case promiseCtorString:
        return promiseTag;
      case setCtorString:
        return setTag$4;
      case weakMapCtorString:
        return weakMapTag$1;
    }
  return E;
});
var objectProto$3 = Object.prototype, hasOwnProperty$4 = objectProto$3.hasOwnProperty;
function initCloneArray(o) {
  var E = o.length, A = new o.constructor(E);
  return E && typeof o[0] == "string" && hasOwnProperty$4.call(o, "index") && (A.index = o.index, A.input = o.input), A;
}
var Uint8Array$1 = root$4.Uint8Array;
function cloneArrayBuffer(o) {
  var E = new o.constructor(o.byteLength);
  return new Uint8Array$1(E).set(new Uint8Array$1(o)), E;
}
function cloneDataView(o, E) {
  var A = E ? cloneArrayBuffer(o.buffer) : o.buffer;
  return new o.constructor(A, o.byteOffset, o.byteLength);
}
var reFlags = /\w*$/;
function cloneRegExp(o) {
  var E = new o.constructor(o.source, reFlags.exec(o));
  return E.lastIndex = o.lastIndex, E;
}
var symbolProto$1 = Symbol$1 ? Symbol$1.prototype : void 0, symbolValueOf$1 = symbolProto$1 ? symbolProto$1.valueOf : void 0;
function cloneSymbol(o) {
  return symbolValueOf$1 ? Object(symbolValueOf$1.call(o)) : {};
}
function cloneTypedArray(o, E) {
  var A = E ? cloneArrayBuffer(o.buffer) : o.buffer;
  return new o.constructor(A, o.byteOffset, o.length);
}
var boolTag$2 = "[object Boolean]", dateTag$2 = "[object Date]", mapTag$3 = "[object Map]", numberTag$2 = "[object Number]", regexpTag$2 = "[object RegExp]", setTag$3 = "[object Set]", stringTag$2 = "[object String]", symbolTag$2 = "[object Symbol]", arrayBufferTag$2 = "[object ArrayBuffer]", dataViewTag$2 = "[object DataView]", float32Tag$1 = "[object Float32Array]", float64Tag$1 = "[object Float64Array]", int8Tag$1 = "[object Int8Array]", int16Tag$1 = "[object Int16Array]", int32Tag$1 = "[object Int32Array]", uint8Tag$1 = "[object Uint8Array]", uint8ClampedTag$1 = "[object Uint8ClampedArray]", uint16Tag$1 = "[object Uint16Array]", uint32Tag$1 = "[object Uint32Array]";
function initCloneByTag(o, E, A) {
  var g = o.constructor;
  switch (E) {
    case arrayBufferTag$2:
      return cloneArrayBuffer(o);
    case boolTag$2:
    case dateTag$2:
      return new g(+o);
    case dataViewTag$2:
      return cloneDataView(o, A);
    case float32Tag$1:
    case float64Tag$1:
    case int8Tag$1:
    case int16Tag$1:
    case int32Tag$1:
    case uint8Tag$1:
    case uint8ClampedTag$1:
    case uint16Tag$1:
    case uint32Tag$1:
      return cloneTypedArray(o, A);
    case mapTag$3:
      return new g();
    case numberTag$2:
    case stringTag$2:
      return new g(o);
    case regexpTag$2:
      return cloneRegExp(o);
    case setTag$3:
      return new g();
    case symbolTag$2:
      return cloneSymbol(o);
  }
}
function initCloneObject(o) {
  return typeof o.constructor == "function" && !isPrototype(o) ? baseCreate(getPrototype(o)) : {};
}
var mapTag$2 = "[object Map]";
function baseIsMap(o) {
  return isObjectLike(o) && getTag(o) == mapTag$2;
}
var nodeIsMap = nodeUtil && nodeUtil.isMap, isMap$1 = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap, setTag$2 = "[object Set]";
function baseIsSet(o) {
  return isObjectLike(o) && getTag(o) == setTag$2;
}
var nodeIsSet = nodeUtil && nodeUtil.isSet, isSet$1 = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet, CLONE_DEEP_FLAG$2 = 1, CLONE_FLAT_FLAG$1 = 2, CLONE_SYMBOLS_FLAG$2 = 4, argsTag$1 = "[object Arguments]", arrayTag$1 = "[object Array]", boolTag$1 = "[object Boolean]", dateTag$1 = "[object Date]", errorTag$1 = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag$1 = "[object Map]", numberTag$1 = "[object Number]", objectTag$1 = "[object Object]", regexpTag$1 = "[object RegExp]", setTag$1 = "[object Set]", stringTag$1 = "[object String]", symbolTag$1 = "[object Symbol]", weakMapTag = "[object WeakMap]", arrayBufferTag$1 = "[object ArrayBuffer]", dataViewTag$1 = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]", cloneableTags = {};
cloneableTags[argsTag$1] = cloneableTags[arrayTag$1] = cloneableTags[arrayBufferTag$1] = cloneableTags[dataViewTag$1] = cloneableTags[boolTag$1] = cloneableTags[dateTag$1] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag$1] = cloneableTags[numberTag$1] = cloneableTags[objectTag$1] = cloneableTags[regexpTag$1] = cloneableTags[setTag$1] = cloneableTags[stringTag$1] = cloneableTags[symbolTag$1] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = !0;
cloneableTags[errorTag$1] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = !1;
function baseClone(o, E, A, g, e, t) {
  var c, n = E & CLONE_DEEP_FLAG$2, h = E & CLONE_FLAT_FLAG$1, d = E & CLONE_SYMBOLS_FLAG$2;
  if (A && (c = e ? A(o, g, e, t) : A(o)), c !== void 0)
    return c;
  if (!isObject$3(o))
    return o;
  var k = isArray(o);
  if (k) {
    if (c = initCloneArray(o), !n)
      return copyArray(o, c);
  } else {
    var p = getTag(o), M = p == funcTag || p == genTag;
    if (isBuffer(o))
      return cloneBuffer(o, n);
    if (p == objectTag$1 || p == argsTag$1 || M && !e) {
      if (c = h || M ? {} : initCloneObject(o), !n)
        return h ? copySymbolsIn(o, baseAssignIn(c, o)) : copySymbols(o, baseAssign(c, o));
    } else {
      if (!cloneableTags[p])
        return e ? o : {};
      c = initCloneByTag(o, p, n);
    }
  }
  t || (t = new Stack());
  var S = t.get(o);
  if (S)
    return S;
  t.set(o, c), isSet$1(o) ? o.forEach(function(gA) {
    c.add(baseClone(gA, E, A, gA, o, t));
  }) : isMap$1(o) && o.forEach(function(gA, CA) {
    c.set(CA, baseClone(gA, E, A, CA, o, t));
  });
  var AA = d ? h ? getAllKeysIn : getAllKeys : h ? keysIn : keys$1, H = k ? void 0 : AA(o);
  return arrayEach(H || o, function(gA, CA) {
    H && (CA = gA, gA = o[CA]), assignValue(c, CA, baseClone(gA, E, A, CA, o, t));
  }), c;
}
var CLONE_DEEP_FLAG$1 = 1, CLONE_SYMBOLS_FLAG$1 = 4;
function cloneDeep(o) {
  return baseClone(o, CLONE_DEEP_FLAG$1 | CLONE_SYMBOLS_FLAG$1);
}
var HASH_UNDEFINED = "__lodash_hash_undefined__";
function setCacheAdd(o) {
  return this.__data__.set(o, HASH_UNDEFINED), this;
}
function setCacheHas(o) {
  return this.__data__.has(o);
}
function SetCache(o) {
  var E = -1, A = o == null ? 0 : o.length;
  for (this.__data__ = new MapCache(); ++E < A; )
    this.add(o[E]);
}
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
function arraySome(o, E) {
  for (var A = -1, g = o == null ? 0 : o.length; ++A < g; )
    if (E(o[A], A, o))
      return !0;
  return !1;
}
function cacheHas(o, E) {
  return o.has(E);
}
var COMPARE_PARTIAL_FLAG$5 = 1, COMPARE_UNORDERED_FLAG$3 = 2;
function equalArrays(o, E, A, g, e, t) {
  var c = A & COMPARE_PARTIAL_FLAG$5, n = o.length, h = E.length;
  if (n != h && !(c && h > n))
    return !1;
  var d = t.get(o), k = t.get(E);
  if (d && k)
    return d == E && k == o;
  var p = -1, M = !0, S = A & COMPARE_UNORDERED_FLAG$3 ? new SetCache() : void 0;
  for (t.set(o, E), t.set(E, o); ++p < n; ) {
    var AA = o[p], H = E[p];
    if (g)
      var gA = c ? g(H, AA, p, E, o, t) : g(AA, H, p, o, E, t);
    if (gA !== void 0) {
      if (gA)
        continue;
      M = !1;
      break;
    }
    if (S) {
      if (!arraySome(E, function(CA, IA) {
        if (!cacheHas(S, IA) && (AA === CA || e(AA, CA, A, g, t)))
          return S.push(IA);
      })) {
        M = !1;
        break;
      }
    } else if (!(AA === H || e(AA, H, A, g, t))) {
      M = !1;
      break;
    }
  }
  return t.delete(o), t.delete(E), M;
}
function mapToArray(o) {
  var E = -1, A = Array(o.size);
  return o.forEach(function(g, e) {
    A[++E] = [e, g];
  }), A;
}
function setToArray(o) {
  var E = -1, A = Array(o.size);
  return o.forEach(function(g) {
    A[++E] = g;
  }), A;
}
var COMPARE_PARTIAL_FLAG$4 = 1, COMPARE_UNORDERED_FLAG$2 = 2, boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", mapTag = "[object Map]", numberTag = "[object Number]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", symbolProto = Symbol$1 ? Symbol$1.prototype : void 0, symbolValueOf = symbolProto ? symbolProto.valueOf : void 0;
function equalByTag(o, E, A, g, e, t, c) {
  switch (A) {
    case dataViewTag:
      if (o.byteLength != E.byteLength || o.byteOffset != E.byteOffset)
        return !1;
      o = o.buffer, E = E.buffer;
    case arrayBufferTag:
      return !(o.byteLength != E.byteLength || !t(new Uint8Array$1(o), new Uint8Array$1(E)));
    case boolTag:
    case dateTag:
    case numberTag:
      return eq(+o, +E);
    case errorTag:
      return o.name == E.name && o.message == E.message;
    case regexpTag:
    case stringTag:
      return o == E + "";
    case mapTag:
      var n = mapToArray;
    case setTag:
      var h = g & COMPARE_PARTIAL_FLAG$4;
      if (n || (n = setToArray), o.size != E.size && !h)
        return !1;
      var d = c.get(o);
      if (d)
        return d == E;
      g |= COMPARE_UNORDERED_FLAG$2, c.set(o, E);
      var k = equalArrays(n(o), n(E), g, e, t, c);
      return c.delete(o), k;
    case symbolTag:
      if (symbolValueOf)
        return symbolValueOf.call(o) == symbolValueOf.call(E);
  }
  return !1;
}
var COMPARE_PARTIAL_FLAG$3 = 1, objectProto$2 = Object.prototype, hasOwnProperty$3 = objectProto$2.hasOwnProperty;
function equalObjects(o, E, A, g, e, t) {
  var c = A & COMPARE_PARTIAL_FLAG$3, n = getAllKeys(o), h = n.length, d = getAllKeys(E), k = d.length;
  if (h != k && !c)
    return !1;
  for (var p = h; p--; ) {
    var M = n[p];
    if (!(c ? M in E : hasOwnProperty$3.call(E, M)))
      return !1;
  }
  var S = t.get(o), AA = t.get(E);
  if (S && AA)
    return S == E && AA == o;
  var H = !0;
  t.set(o, E), t.set(E, o);
  for (var gA = c; ++p < h; ) {
    M = n[p];
    var CA = o[M], IA = E[M];
    if (g)
      var BA = c ? g(IA, CA, M, E, o, t) : g(CA, IA, M, o, E, t);
    if (!(BA === void 0 ? CA === IA || e(CA, IA, A, g, t) : BA)) {
      H = !1;
      break;
    }
    gA || (gA = M == "constructor");
  }
  if (H && !gA) {
    var QA = o.constructor, EA = E.constructor;
    QA != EA && "constructor" in o && "constructor" in E && !(typeof QA == "function" && QA instanceof QA && typeof EA == "function" && EA instanceof EA) && (H = !1);
  }
  return t.delete(o), t.delete(E), H;
}
var COMPARE_PARTIAL_FLAG$2 = 1, argsTag = "[object Arguments]", arrayTag = "[object Array]", objectTag = "[object Object]", objectProto$1 = Object.prototype, hasOwnProperty$2 = objectProto$1.hasOwnProperty;
function baseIsEqualDeep(o, E, A, g, e, t) {
  var c = isArray(o), n = isArray(E), h = c ? arrayTag : getTag(o), d = n ? arrayTag : getTag(E);
  h = h == argsTag ? objectTag : h, d = d == argsTag ? objectTag : d;
  var k = h == objectTag, p = d == objectTag, M = h == d;
  if (M && isBuffer(o)) {
    if (!isBuffer(E))
      return !1;
    c = !0, k = !1;
  }
  if (M && !k)
    return t || (t = new Stack()), c || isTypedArray(o) ? equalArrays(o, E, A, g, e, t) : equalByTag(o, E, h, A, g, e, t);
  if (!(A & COMPARE_PARTIAL_FLAG$2)) {
    var S = k && hasOwnProperty$2.call(o, "__wrapped__"), AA = p && hasOwnProperty$2.call(E, "__wrapped__");
    if (S || AA) {
      var H = S ? o.value() : o, gA = AA ? E.value() : E;
      return t || (t = new Stack()), e(H, gA, A, g, t);
    }
  }
  return M ? (t || (t = new Stack()), equalObjects(o, E, A, g, e, t)) : !1;
}
function baseIsEqual(o, E, A, g, e) {
  return o === E ? !0 : o == null || E == null || !isObjectLike(o) && !isObjectLike(E) ? o !== o && E !== E : baseIsEqualDeep(o, E, A, g, baseIsEqual, e);
}
var COMPARE_PARTIAL_FLAG$1 = 1, COMPARE_UNORDERED_FLAG$1 = 2;
function baseIsMatch(o, E, A, g) {
  var e = A.length, t = e;
  if (o == null)
    return !t;
  for (o = Object(o); e--; ) {
    var c = A[e];
    if (c[2] ? c[1] !== o[c[0]] : !(c[0] in o))
      return !1;
  }
  for (; ++e < t; ) {
    c = A[e];
    var n = c[0], h = o[n], d = c[1];
    if (c[2]) {
      if (h === void 0 && !(n in o))
        return !1;
    } else {
      var k = new Stack(), p;
      if (!(p === void 0 ? baseIsEqual(d, h, COMPARE_PARTIAL_FLAG$1 | COMPARE_UNORDERED_FLAG$1, g, k) : p))
        return !1;
    }
  }
  return !0;
}
function isStrictComparable(o) {
  return o === o && !isObject$3(o);
}
function getMatchData(o) {
  for (var E = keys$1(o), A = E.length; A--; ) {
    var g = E[A], e = o[g];
    E[A] = [g, e, isStrictComparable(e)];
  }
  return E;
}
function matchesStrictComparable(o, E) {
  return function(A) {
    return A == null ? !1 : A[o] === E && (E !== void 0 || o in Object(A));
  };
}
function baseMatches(o) {
  var E = getMatchData(o);
  return E.length == 1 && E[0][2] ? matchesStrictComparable(E[0][0], E[0][1]) : function(A) {
    return A === o || baseIsMatch(A, o, E);
  };
}
function baseHasIn(o, E) {
  return o != null && E in Object(o);
}
function hasPath(o, E, A) {
  E = castPath(E, o);
  for (var g = -1, e = E.length, t = !1; ++g < e; ) {
    var c = toKey(E[g]);
    if (!(t = o != null && A(o, c)))
      break;
    o = o[c];
  }
  return t || ++g != e ? t : (e = o == null ? 0 : o.length, !!e && isLength(e) && isIndex(c, e) && (isArray(o) || isArguments(o)));
}
function hasIn(o, E) {
  return o != null && hasPath(o, E, baseHasIn);
}
var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
function baseMatchesProperty(o, E) {
  return isKey(o) && isStrictComparable(E) ? matchesStrictComparable(toKey(o), E) : function(A) {
    var g = get$1(A, o);
    return g === void 0 && g === E ? hasIn(A, o) : baseIsEqual(E, g, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}
function baseProperty(o) {
  return function(E) {
    return E?.[o];
  };
}
function basePropertyDeep(o) {
  return function(E) {
    return baseGet(E, o);
  };
}
function property(o) {
  return isKey(o) ? baseProperty(toKey(o)) : basePropertyDeep(o);
}
function baseIteratee(o) {
  return typeof o == "function" ? o : o == null ? identity : typeof o == "object" ? isArray(o) ? baseMatchesProperty(o[0], o[1]) : baseMatches(o) : property(o);
}
function arrayAggregator(o, E, A, g) {
  for (var e = -1, t = o == null ? 0 : o.length; ++e < t; ) {
    var c = o[e];
    E(g, c, A(c), o);
  }
  return g;
}
function createBaseFor(o) {
  return function(E, A, g) {
    for (var e = -1, t = Object(E), c = g(E), n = c.length; n--; ) {
      var h = c[++e];
      if (A(t[h], h, t) === !1)
        break;
    }
    return E;
  };
}
var baseFor = createBaseFor();
function baseForOwn(o, E) {
  return o && baseFor(o, E, keys$1);
}
function createBaseEach(o, E) {
  return function(A, g) {
    if (A == null)
      return A;
    if (!isArrayLike(A))
      return o(A, g);
    for (var e = A.length, t = -1, c = Object(A); ++t < e && g(c[t], t, c) !== !1; )
      ;
    return A;
  };
}
var baseEach = createBaseEach(baseForOwn);
function baseAggregator(o, E, A, g) {
  return baseEach(o, function(e, t, c) {
    E(g, e, A(e), c);
  }), g;
}
function createAggregator(o, E) {
  return function(A, g) {
    var e = isArray(A) ? arrayAggregator : baseAggregator, t = E ? E() : {};
    return e(A, o, baseIteratee(g), t);
  };
}
function assignMergeValue(o, E, A) {
  (A !== void 0 && !eq(o[E], A) || A === void 0 && !(E in o)) && baseAssignValue(o, E, A);
}
function isArrayLikeObject(o) {
  return isObjectLike(o) && isArrayLike(o);
}
function safeGet(o, E) {
  if (!(E === "constructor" && typeof o[E] == "function") && E != "__proto__")
    return o[E];
}
function toPlainObject(o) {
  return copyObject(o, keysIn(o));
}
function baseMergeDeep(o, E, A, g, e, t, c) {
  var n = safeGet(o, A), h = safeGet(E, A), d = c.get(h);
  if (d) {
    assignMergeValue(o, A, d);
    return;
  }
  var k = t ? t(n, h, A + "", o, E, c) : void 0, p = k === void 0;
  if (p) {
    var M = isArray(h), S = !M && isBuffer(h), AA = !M && !S && isTypedArray(h);
    k = h, M || S || AA ? isArray(n) ? k = n : isArrayLikeObject(n) ? k = copyArray(n) : S ? (p = !1, k = cloneBuffer(h, !0)) : AA ? (p = !1, k = cloneTypedArray(h, !0)) : k = [] : isPlainObject$3(h) || isArguments(h) ? (k = n, isArguments(n) ? k = toPlainObject(n) : (!isObject$3(n) || isFunction$3(n)) && (k = initCloneObject(h))) : p = !1;
  }
  p && (c.set(h, k), e(k, h, g, t, c), c.delete(h)), assignMergeValue(o, A, k);
}
function baseMerge(o, E, A, g, e) {
  o !== E && baseFor(E, function(t, c) {
    if (e || (e = new Stack()), isObject$3(t))
      baseMergeDeep(o, E, c, A, baseMerge, g, e);
    else {
      var n = g ? g(safeGet(o, c), t, c + "", o, E, e) : void 0;
      n === void 0 && (n = t), assignMergeValue(o, c, n);
    }
  }, keysIn);
}
var mergeWith = createAssigner(function(o, E, A, g) {
  baseMerge(o, E, A, g);
});
function last(o) {
  var E = o == null ? 0 : o.length;
  return E ? o[E - 1] : void 0;
}
function baseMap(o, E) {
  var A = -1, g = isArrayLike(o) ? Array(o.length) : [];
  return baseEach(o, function(e, t, c) {
    g[++A] = E(e, t, c);
  }), g;
}
var objectProto = Object.prototype, hasOwnProperty$1 = objectProto.hasOwnProperty, groupBy = createAggregator(function(o, E, A) {
  hasOwnProperty$1.call(o, A) ? o[A].push(E) : baseAssignValue(o, A, [E]);
});
function parent(o, E) {
  return E.length < 2 ? o : baseGet(o, baseSlice(E, 0, -1));
}
function isEqual$1(o, E) {
  return baseIsEqual(o, E);
}
var merge$1 = createAssigner(function(o, E, A) {
  baseMerge(o, E, A);
});
function baseUnset(o, E) {
  return E = castPath(E, o), o = parent(o, E), o == null || delete o[toKey(last(E))];
}
function customOmitClone(o) {
  return isPlainObject$3(o) ? void 0 : o;
}
var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4, omit = flatRest(function(o, E) {
  var A = {};
  if (o == null)
    return A;
  var g = !1;
  E = arrayMap(E, function(t) {
    return t = castPath(t, o), g || (g = t.length > 1), t;
  }), copyObject(o, getAllKeysIn(o), A), g && (A = baseClone(A, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone));
  for (var e = E.length; e--; )
    baseUnset(A, E[e]);
  return A;
});
function baseSet(o, E, A, g) {
  if (!isObject$3(o))
    return o;
  E = castPath(E, o);
  for (var e = -1, t = E.length, c = t - 1, n = o; n != null && ++e < t; ) {
    var h = toKey(E[e]), d = A;
    if (h === "__proto__" || h === "constructor" || h === "prototype")
      return o;
    if (e != c) {
      var k = n[h];
      d = void 0, d === void 0 && (d = isObject$3(k) ? k : isIndex(E[e + 1]) ? [] : {});
    }
    assignValue(n, h, d), n = n[h];
  }
  return o;
}
function basePickBy(o, E, A) {
  for (var g = -1, e = E.length, t = {}; ++g < e; ) {
    var c = E[g], n = baseGet(o, c);
    A(n, c) && baseSet(t, castPath(c, o), n);
  }
  return t;
}
function once$1(o) {
  return before(2, o);
}
function baseSortBy(o, E) {
  var A = o.length;
  for (o.sort(E); A--; )
    o[A] = o[A].value;
  return o;
}
function compareAscending(o, E) {
  if (o !== E) {
    var A = o !== void 0, g = o === null, e = o === o, t = isSymbol(o), c = E !== void 0, n = E === null, h = E === E, d = isSymbol(E);
    if (!n && !d && !t && o > E || t && c && h && !n && !d || g && c && h || !A && h || !e)
      return 1;
    if (!g && !t && !d && o < E || d && A && e && !g && !t || n && A && e || !c && e || !h)
      return -1;
  }
  return 0;
}
function compareMultiple(o, E, A) {
  for (var g = -1, e = o.criteria, t = E.criteria, c = e.length, n = A.length; ++g < c; ) {
    var h = compareAscending(e[g], t[g]);
    if (h) {
      if (g >= n)
        return h;
      var d = A[g];
      return h * (d == "desc" ? -1 : 1);
    }
  }
  return o.index - E.index;
}
function baseOrderBy(o, E, A) {
  E.length ? E = arrayMap(E, function(t) {
    return isArray(t) ? function(c) {
      return baseGet(c, t.length === 1 ? t[0] : t);
    } : t;
  }) : E = [identity];
  var g = -1;
  E = arrayMap(E, baseUnary(baseIteratee));
  var e = baseMap(o, function(t, c, n) {
    var h = arrayMap(E, function(d) {
      return d(t);
    });
    return { criteria: h, index: ++g, value: t };
  });
  return baseSortBy(e, function(t, c) {
    return compareMultiple(t, c, A);
  });
}
function basePick(o, E) {
  return basePickBy(o, E, function(A, g) {
    return hasIn(o, g);
  });
}
var pick$1 = flatRest(function(o, E) {
  return o == null ? {} : basePick(o, E);
}), nativeCeil = Math.ceil, nativeMax$1 = Math.max;
function baseRange(o, E, A, g) {
  for (var e = -1, t = nativeMax$1(nativeCeil((E - o) / (A || 1)), 0), c = Array(t); t--; )
    c[++e] = o, o += A;
  return c;
}
function createRange(o) {
  return function(E, A, g) {
    return g && typeof g != "number" && isIterateeCall(E, A, g) && (A = g = void 0), E = toFinite(E), A === void 0 ? (A = E, E = 0) : A = toFinite(A), g = g === void 0 ? E < A ? 1 : -1 : toFinite(g), baseRange(E, A, g);
  };
}
var range$1 = createRange(), sortBy = baseRest(function(o, E) {
  if (o == null)
    return [];
  var A = E.length;
  return A > 1 && isIterateeCall(o, E[0], E[1]) ? E = [] : A > 2 && isIterateeCall(E[0], E[1], E[2]) && (E = [E[0]]), baseOrderBy(o, baseFlatten(E), []);
}), nativeMax = Math.max;
function unzip(o) {
  if (!(o && o.length))
    return [];
  var E = 0;
  return o = arrayFilter(o, function(A) {
    if (isArrayLikeObject(A))
      return E = nativeMax(A.length, E), !0;
  }), baseTimes(E, function(A) {
    return arrayMap(o, baseProperty(A));
  });
}
var zip$1 = baseRest(unzip), cuint = {}, uint32$1 = { exports: {} }, uint32 = uint32$1.exports, hasRequiredUint32;
function requireUint32() {
  return hasRequiredUint32 || (hasRequiredUint32 = 1, (function(o) {
    (function(E) {
      A(Math.pow(36, 5)), A(Math.pow(16, 7)), A(Math.pow(10, 9)), A(Math.pow(2, 30)), A(36), A(16), A(10), A(2);
      function A(c, n) {
        if (!(this instanceof A))
          return new A(c, n);
        if (this._low = 0, this._high = 0, this.remainder = null, typeof n > "u")
          return e.call(this, c);
        if (typeof c == "string")
          return t.call(this, c, n);
        g.call(this, c, n);
      }
      function g(c, n) {
        return this._low = c | 0, this._high = n | 0, this;
      }
      A.prototype.fromBits = g;
      function e(c) {
        return this._low = c & 65535, this._high = c >>> 16, this;
      }
      A.prototype.fromNumber = e;
      function t(c, n) {
        var h = parseInt(c, n || 10);
        return this._low = h & 65535, this._high = h >>> 16, this;
      }
      A.prototype.fromString = t, A.prototype.toNumber = function() {
        return this._high * 65536 + this._low;
      }, A.prototype.toString = function(c) {
        return this.toNumber().toString(c || 10);
      }, A.prototype.add = function(c) {
        var n = this._low + c._low, h = n >>> 16;
        return h += this._high + c._high, this._low = n & 65535, this._high = h & 65535, this;
      }, A.prototype.subtract = function(c) {
        return this.add(c.clone().negate());
      }, A.prototype.multiply = function(c) {
        var n = this._high, h = this._low, d = c._high, k = c._low, p, M;
        return M = h * k, p = M >>> 16, p += n * k, p &= 65535, p += h * d, this._low = M & 65535, this._high = p & 65535, this;
      }, A.prototype.div = function(c) {
        if (c._low == 0 && c._high == 0) throw Error("division by zero");
        if (c._high == 0 && c._low == 1)
          return this.remainder = new A(0), this;
        if (c.gt(this))
          return this.remainder = this.clone(), this._low = 0, this._high = 0, this;
        if (this.eq(c))
          return this.remainder = new A(0), this._low = 1, this._high = 0, this;
        for (var n = c.clone(), h = -1; !this.lt(n); )
          n.shiftLeft(1, !0), h++;
        for (this.remainder = this.clone(), this._low = 0, this._high = 0; h >= 0; h--)
          n.shiftRight(1), this.remainder.lt(n) || (this.remainder.subtract(n), h >= 16 ? this._high |= 1 << h - 16 : this._low |= 1 << h);
        return this;
      }, A.prototype.negate = function() {
        var c = (~this._low & 65535) + 1;
        return this._low = c & 65535, this._high = ~this._high + (c >>> 16) & 65535, this;
      }, A.prototype.equals = A.prototype.eq = function(c) {
        return this._low == c._low && this._high == c._high;
      }, A.prototype.greaterThan = A.prototype.gt = function(c) {
        return this._high > c._high ? !0 : this._high < c._high ? !1 : this._low > c._low;
      }, A.prototype.lessThan = A.prototype.lt = function(c) {
        return this._high < c._high ? !0 : this._high > c._high ? !1 : this._low < c._low;
      }, A.prototype.or = function(c) {
        return this._low |= c._low, this._high |= c._high, this;
      }, A.prototype.and = function(c) {
        return this._low &= c._low, this._high &= c._high, this;
      }, A.prototype.not = function() {
        return this._low = ~this._low & 65535, this._high = ~this._high & 65535, this;
      }, A.prototype.xor = function(c) {
        return this._low ^= c._low, this._high ^= c._high, this;
      }, A.prototype.shiftRight = A.prototype.shiftr = function(c) {
        return c > 16 ? (this._low = this._high >> c - 16, this._high = 0) : c == 16 ? (this._low = this._high, this._high = 0) : (this._low = this._low >> c | this._high << 16 - c & 65535, this._high >>= c), this;
      }, A.prototype.shiftLeft = A.prototype.shiftl = function(c, n) {
        return c > 16 ? (this._high = this._low << c - 16, this._low = 0, n || (this._high &= 65535)) : c == 16 ? (this._high = this._low, this._low = 0) : (this._high = this._high << c | this._low >> 16 - c, this._low = this._low << c & 65535, n || (this._high &= 65535)), this;
      }, A.prototype.rotateLeft = A.prototype.rotl = function(c) {
        var n = this._high << 16 | this._low;
        return n = n << c | n >>> 32 - c, this._low = n & 65535, this._high = n >>> 16, this;
      }, A.prototype.rotateRight = A.prototype.rotr = function(c) {
        var n = this._high << 16 | this._low;
        return n = n >>> c | n << 32 - c, this._low = n & 65535, this._high = n >>> 16, this;
      }, A.prototype.clone = function() {
        return new A(this._low, this._high);
      }, o.exports ? o.exports = A : E.UINT32 = A;
    })(uint32);
  })(uint32$1)), uint32$1.exports;
}
var uint64$1 = { exports: {} }, uint64 = uint64$1.exports, hasRequiredUint64;
function requireUint64() {
  return hasRequiredUint64 || (hasRequiredUint64 = 1, (function(o) {
    (function(E) {
      var A = {
        16: e(Math.pow(16, 5)),
        10: e(Math.pow(10, 5)),
        2: e(Math.pow(2, 5))
      }, g = {
        16: e(16),
        10: e(10),
        2: e(2)
      };
      function e(h, d, k, p) {
        if (!(this instanceof e))
          return new e(h, d, k, p);
        if (this.remainder = null, typeof h == "string")
          return n.call(this, h, d);
        if (typeof d > "u")
          return c.call(this, h);
        t.apply(this, arguments);
      }
      function t(h, d, k, p) {
        return typeof k > "u" ? (this._a00 = h & 65535, this._a16 = h >>> 16, this._a32 = d & 65535, this._a48 = d >>> 16, this) : (this._a00 = h | 0, this._a16 = d | 0, this._a32 = k | 0, this._a48 = p | 0, this);
      }
      e.prototype.fromBits = t;
      function c(h) {
        return this._a00 = h & 65535, this._a16 = h >>> 16, this._a32 = 0, this._a48 = 0, this;
      }
      e.prototype.fromNumber = c;
      function n(h, d) {
        d = d || 10, this._a00 = 0, this._a16 = 0, this._a32 = 0, this._a48 = 0;
        for (var k = A[d] || new e(Math.pow(d, 5)), p = 0, M = h.length; p < M; p += 5) {
          var S = Math.min(5, M - p), AA = parseInt(h.slice(p, p + S), d);
          this.multiply(
            S < 5 ? new e(Math.pow(d, S)) : k
          ).add(new e(AA));
        }
        return this;
      }
      e.prototype.fromString = n, e.prototype.toNumber = function() {
        return this._a16 * 65536 + this._a00;
      }, e.prototype.toString = function(h) {
        h = h || 10;
        var d = g[h] || new e(h);
        if (!this.gt(d)) return this.toNumber().toString(h);
        for (var k = this.clone(), p = new Array(64), M = 63; M >= 0 && (k.div(d), p[M] = k.remainder.toNumber().toString(h), !!k.gt(d)); M--)
          ;
        return p[M - 1] = k.toNumber().toString(h), p.join("");
      }, e.prototype.add = function(h) {
        var d = this._a00 + h._a00, k = d >>> 16;
        k += this._a16 + h._a16;
        var p = k >>> 16;
        p += this._a32 + h._a32;
        var M = p >>> 16;
        return M += this._a48 + h._a48, this._a00 = d & 65535, this._a16 = k & 65535, this._a32 = p & 65535, this._a48 = M & 65535, this;
      }, e.prototype.subtract = function(h) {
        return this.add(h.clone().negate());
      }, e.prototype.multiply = function(h) {
        var d = this._a00, k = this._a16, p = this._a32, M = this._a48, S = h._a00, AA = h._a16, H = h._a32, gA = h._a48, CA = d * S, IA = CA >>> 16;
        IA += d * AA;
        var BA = IA >>> 16;
        IA &= 65535, IA += k * S, BA += IA >>> 16, BA += d * H;
        var QA = BA >>> 16;
        return BA &= 65535, BA += k * AA, QA += BA >>> 16, BA &= 65535, BA += p * S, QA += BA >>> 16, QA += d * gA, QA &= 65535, QA += k * H, QA &= 65535, QA += p * AA, QA &= 65535, QA += M * S, this._a00 = CA & 65535, this._a16 = IA & 65535, this._a32 = BA & 65535, this._a48 = QA & 65535, this;
      }, e.prototype.div = function(h) {
        if (h._a16 == 0 && h._a32 == 0 && h._a48 == 0) {
          if (h._a00 == 0) throw Error("division by zero");
          if (h._a00 == 1)
            return this.remainder = new e(0), this;
        }
        if (h.gt(this))
          return this.remainder = this.clone(), this._a00 = 0, this._a16 = 0, this._a32 = 0, this._a48 = 0, this;
        if (this.eq(h))
          return this.remainder = new e(0), this._a00 = 1, this._a16 = 0, this._a32 = 0, this._a48 = 0, this;
        for (var d = h.clone(), k = -1; !this.lt(d); )
          d.shiftLeft(1, !0), k++;
        for (this.remainder = this.clone(), this._a00 = 0, this._a16 = 0, this._a32 = 0, this._a48 = 0; k >= 0; k--)
          d.shiftRight(1), this.remainder.lt(d) || (this.remainder.subtract(d), k >= 48 ? this._a48 |= 1 << k - 48 : k >= 32 ? this._a32 |= 1 << k - 32 : k >= 16 ? this._a16 |= 1 << k - 16 : this._a00 |= 1 << k);
        return this;
      }, e.prototype.negate = function() {
        var h = (~this._a00 & 65535) + 1;
        return this._a00 = h & 65535, h = (~this._a16 & 65535) + (h >>> 16), this._a16 = h & 65535, h = (~this._a32 & 65535) + (h >>> 16), this._a32 = h & 65535, this._a48 = ~this._a48 + (h >>> 16) & 65535, this;
      }, e.prototype.equals = e.prototype.eq = function(h) {
        return this._a48 == h._a48 && this._a00 == h._a00 && this._a32 == h._a32 && this._a16 == h._a16;
      }, e.prototype.greaterThan = e.prototype.gt = function(h) {
        return this._a48 > h._a48 ? !0 : this._a48 < h._a48 ? !1 : this._a32 > h._a32 ? !0 : this._a32 < h._a32 ? !1 : this._a16 > h._a16 ? !0 : this._a16 < h._a16 ? !1 : this._a00 > h._a00;
      }, e.prototype.lessThan = e.prototype.lt = function(h) {
        return this._a48 < h._a48 ? !0 : this._a48 > h._a48 ? !1 : this._a32 < h._a32 ? !0 : this._a32 > h._a32 ? !1 : this._a16 < h._a16 ? !0 : this._a16 > h._a16 ? !1 : this._a00 < h._a00;
      }, e.prototype.or = function(h) {
        return this._a00 |= h._a00, this._a16 |= h._a16, this._a32 |= h._a32, this._a48 |= h._a48, this;
      }, e.prototype.and = function(h) {
        return this._a00 &= h._a00, this._a16 &= h._a16, this._a32 &= h._a32, this._a48 &= h._a48, this;
      }, e.prototype.xor = function(h) {
        return this._a00 ^= h._a00, this._a16 ^= h._a16, this._a32 ^= h._a32, this._a48 ^= h._a48, this;
      }, e.prototype.not = function() {
        return this._a00 = ~this._a00 & 65535, this._a16 = ~this._a16 & 65535, this._a32 = ~this._a32 & 65535, this._a48 = ~this._a48 & 65535, this;
      }, e.prototype.shiftRight = e.prototype.shiftr = function(h) {
        return h %= 64, h >= 48 ? (this._a00 = this._a48 >> h - 48, this._a16 = 0, this._a32 = 0, this._a48 = 0) : h >= 32 ? (h -= 32, this._a00 = (this._a32 >> h | this._a48 << 16 - h) & 65535, this._a16 = this._a48 >> h & 65535, this._a32 = 0, this._a48 = 0) : h >= 16 ? (h -= 16, this._a00 = (this._a16 >> h | this._a32 << 16 - h) & 65535, this._a16 = (this._a32 >> h | this._a48 << 16 - h) & 65535, this._a32 = this._a48 >> h & 65535, this._a48 = 0) : (this._a00 = (this._a00 >> h | this._a16 << 16 - h) & 65535, this._a16 = (this._a16 >> h | this._a32 << 16 - h) & 65535, this._a32 = (this._a32 >> h | this._a48 << 16 - h) & 65535, this._a48 = this._a48 >> h & 65535), this;
      }, e.prototype.shiftLeft = e.prototype.shiftl = function(h, d) {
        return h %= 64, h >= 48 ? (this._a48 = this._a00 << h - 48, this._a32 = 0, this._a16 = 0, this._a00 = 0) : h >= 32 ? (h -= 32, this._a48 = this._a16 << h | this._a00 >> 16 - h, this._a32 = this._a00 << h & 65535, this._a16 = 0, this._a00 = 0) : h >= 16 ? (h -= 16, this._a48 = this._a32 << h | this._a16 >> 16 - h, this._a32 = (this._a16 << h | this._a00 >> 16 - h) & 65535, this._a16 = this._a00 << h & 65535, this._a00 = 0) : (this._a48 = this._a48 << h | this._a32 >> 16 - h, this._a32 = (this._a32 << h | this._a16 >> 16 - h) & 65535, this._a16 = (this._a16 << h | this._a00 >> 16 - h) & 65535, this._a00 = this._a00 << h & 65535), d || (this._a48 &= 65535), this;
      }, e.prototype.rotateLeft = e.prototype.rotl = function(h) {
        if (h %= 64, h == 0) return this;
        if (h >= 32) {
          var d = this._a00;
          if (this._a00 = this._a32, this._a32 = d, d = this._a48, this._a48 = this._a16, this._a16 = d, h == 32) return this;
          h -= 32;
        }
        var k = this._a48 << 16 | this._a32, p = this._a16 << 16 | this._a00, M = k << h | p >>> 32 - h, S = p << h | k >>> 32 - h;
        return this._a00 = S & 65535, this._a16 = S >>> 16, this._a32 = M & 65535, this._a48 = M >>> 16, this;
      }, e.prototype.rotateRight = e.prototype.rotr = function(h) {
        if (h %= 64, h == 0) return this;
        if (h >= 32) {
          var d = this._a00;
          if (this._a00 = this._a32, this._a32 = d, d = this._a48, this._a48 = this._a16, this._a16 = d, h == 32) return this;
          h -= 32;
        }
        var k = this._a48 << 16 | this._a32, p = this._a16 << 16 | this._a00, M = k >>> h | p << 32 - h, S = p >>> h | k << 32 - h;
        return this._a00 = S & 65535, this._a16 = S >>> 16, this._a32 = M & 65535, this._a48 = M >>> 16, this;
      }, e.prototype.clone = function() {
        return new e(this._a00, this._a16, this._a32, this._a48);
      }, o.exports ? o.exports = e : E.UINT64 = e;
    })(uint64);
  })(uint64$1)), uint64$1.exports;
}
var hasRequiredCuint;
function requireCuint() {
  return hasRequiredCuint || (hasRequiredCuint = 1, cuint.UINT32 = requireUint32(), cuint.UINT64 = requireUint64()), cuint;
}
var xxhash$1, hasRequiredXxhash;
function requireXxhash() {
  if (hasRequiredXxhash) return xxhash$1;
  hasRequiredXxhash = 1;
  var o = requireCuint().UINT32;
  o.prototype.xxh_update = function(d, k) {
    var p = A._low, M = A._high, S, AA;
    AA = d * p, S = AA >>> 16, S += k * p, S &= 65535, S += d * M;
    var H = this._low + (AA & 65535), gA = H >>> 16;
    gA += this._high + (S & 65535);
    var CA = gA << 16 | H & 65535;
    CA = CA << 13 | CA >>> 19, H = CA & 65535, gA = CA >>> 16, p = E._low, M = E._high, AA = H * p, S = AA >>> 16, S += gA * p, S &= 65535, S += H * M, this._low = AA & 65535, this._high = S & 65535;
  };
  var E = o("2654435761"), A = o("2246822519"), g = o("3266489917"), e = o("668265263"), t = o("374761393");
  function c(d) {
    for (var k = [], p = 0, M = d.length; p < M; p++) {
      var S = d.charCodeAt(p);
      S < 128 ? k.push(S) : S < 2048 ? k.push(
        192 | S >> 6,
        128 | S & 63
      ) : S < 55296 || S >= 57344 ? k.push(
        224 | S >> 12,
        128 | S >> 6 & 63,
        128 | S & 63
      ) : (p++, S = 65536 + ((S & 1023) << 10 | d.charCodeAt(p) & 1023), k.push(
        240 | S >> 18,
        128 | S >> 12 & 63,
        128 | S >> 6 & 63,
        128 | S & 63
      ));
    }
    return new Uint8Array(k);
  }
  function n() {
    if (arguments.length == 2)
      return new n(arguments[1]).update(arguments[0]).digest();
    if (!(this instanceof n))
      return new n(arguments[0]);
    h.call(this, arguments[0]);
  }
  function h(d) {
    return this.seed = d instanceof o ? d.clone() : o(d), this.v1 = this.seed.clone().add(E).add(A), this.v2 = this.seed.clone().add(A), this.v3 = this.seed.clone(), this.v4 = this.seed.clone().subtract(E), this.total_len = 0, this.memsize = 0, this.memory = null, this;
  }
  return n.prototype.init = h, n.prototype.update = function(d) {
    var k = typeof d == "string", p;
    k && (d = c(d), k = !1, p = !0), typeof ArrayBuffer < "u" && d instanceof ArrayBuffer && (p = !0, d = new Uint8Array(d));
    var M = 0, S = d.length, AA = M + S;
    if (S == 0) return this;
    if (this.total_len += S, this.memsize == 0 && (k ? this.memory = "" : p ? this.memory = new Uint8Array(16) : this.memory = new Buffer(16)), this.memsize + S < 16)
      return k ? this.memory += d : p ? this.memory.set(d.subarray(0, S), this.memsize) : d.copy(this.memory, this.memsize, 0, S), this.memsize += S, this;
    if (this.memsize > 0) {
      k ? this.memory += d.slice(0, 16 - this.memsize) : p ? this.memory.set(d.subarray(0, 16 - this.memsize), this.memsize) : d.copy(this.memory, this.memsize, 0, 16 - this.memsize);
      var H = 0;
      k ? (this.v1.xxh_update(
        this.memory.charCodeAt(H + 1) << 8 | this.memory.charCodeAt(H),
        this.memory.charCodeAt(H + 3) << 8 | this.memory.charCodeAt(H + 2)
      ), H += 4, this.v2.xxh_update(
        this.memory.charCodeAt(H + 1) << 8 | this.memory.charCodeAt(H),
        this.memory.charCodeAt(H + 3) << 8 | this.memory.charCodeAt(H + 2)
      ), H += 4, this.v3.xxh_update(
        this.memory.charCodeAt(H + 1) << 8 | this.memory.charCodeAt(H),
        this.memory.charCodeAt(H + 3) << 8 | this.memory.charCodeAt(H + 2)
      ), H += 4, this.v4.xxh_update(
        this.memory.charCodeAt(H + 1) << 8 | this.memory.charCodeAt(H),
        this.memory.charCodeAt(H + 3) << 8 | this.memory.charCodeAt(H + 2)
      )) : (this.v1.xxh_update(
        this.memory[H + 1] << 8 | this.memory[H],
        this.memory[H + 3] << 8 | this.memory[H + 2]
      ), H += 4, this.v2.xxh_update(
        this.memory[H + 1] << 8 | this.memory[H],
        this.memory[H + 3] << 8 | this.memory[H + 2]
      ), H += 4, this.v3.xxh_update(
        this.memory[H + 1] << 8 | this.memory[H],
        this.memory[H + 3] << 8 | this.memory[H + 2]
      ), H += 4, this.v4.xxh_update(
        this.memory[H + 1] << 8 | this.memory[H],
        this.memory[H + 3] << 8 | this.memory[H + 2]
      )), M += 16 - this.memsize, this.memsize = 0, k && (this.memory = "");
    }
    if (M <= AA - 16) {
      var gA = AA - 16;
      do
        k ? (this.v1.xxh_update(
          d.charCodeAt(M + 1) << 8 | d.charCodeAt(M),
          d.charCodeAt(M + 3) << 8 | d.charCodeAt(M + 2)
        ), M += 4, this.v2.xxh_update(
          d.charCodeAt(M + 1) << 8 | d.charCodeAt(M),
          d.charCodeAt(M + 3) << 8 | d.charCodeAt(M + 2)
        ), M += 4, this.v3.xxh_update(
          d.charCodeAt(M + 1) << 8 | d.charCodeAt(M),
          d.charCodeAt(M + 3) << 8 | d.charCodeAt(M + 2)
        ), M += 4, this.v4.xxh_update(
          d.charCodeAt(M + 1) << 8 | d.charCodeAt(M),
          d.charCodeAt(M + 3) << 8 | d.charCodeAt(M + 2)
        )) : (this.v1.xxh_update(
          d[M + 1] << 8 | d[M],
          d[M + 3] << 8 | d[M + 2]
        ), M += 4, this.v2.xxh_update(
          d[M + 1] << 8 | d[M],
          d[M + 3] << 8 | d[M + 2]
        ), M += 4, this.v3.xxh_update(
          d[M + 1] << 8 | d[M],
          d[M + 3] << 8 | d[M + 2]
        ), M += 4, this.v4.xxh_update(
          d[M + 1] << 8 | d[M],
          d[M + 3] << 8 | d[M + 2]
        )), M += 4;
      while (M <= gA);
    }
    return M < AA && (k ? this.memory += d.slice(M) : p ? this.memory.set(d.subarray(M, AA), this.memsize) : d.copy(this.memory, this.memsize, M, AA), this.memsize = AA - M), this;
  }, n.prototype.digest = function() {
    var d = this.memory, k = typeof d == "string", p = 0, M = this.memsize, S, AA, H = new o();
    for (this.total_len >= 16 ? S = this.v1.rotl(1).add(this.v2.rotl(7).add(this.v3.rotl(12).add(this.v4.rotl(18)))) : S = this.seed.clone().add(t), S.add(H.fromNumber(this.total_len)); p <= M - 4; )
      k ? H.fromBits(
        d.charCodeAt(p + 1) << 8 | d.charCodeAt(p),
        d.charCodeAt(p + 3) << 8 | d.charCodeAt(p + 2)
      ) : H.fromBits(
        d[p + 1] << 8 | d[p],
        d[p + 3] << 8 | d[p + 2]
      ), S.add(H.multiply(g)).rotl(17).multiply(e), p += 4;
    for (; p < M; )
      H.fromBits(k ? d.charCodeAt(p++) : d[p++], 0), S.add(H.multiply(t)).rotl(11).multiply(E);
    return AA = S.clone().shiftRight(15), S.xor(AA).multiply(A), AA = S.clone().shiftRight(13), S.xor(AA).multiply(g), AA = S.clone().shiftRight(16), S.xor(AA), this.init(this.seed), S;
  }, xxhash$1 = n, xxhash$1;
}
var xxhash64, hasRequiredXxhash64;
function requireXxhash64() {
  if (hasRequiredXxhash64) return xxhash64;
  hasRequiredXxhash64 = 1;
  var o = requireCuint().UINT64, E = o("11400714785074694791"), A = o("14029467366897019727"), g = o("1609587929392839161"), e = o("9650029242287828579"), t = o("2870177450012600261");
  function c(d) {
    for (var k = [], p = 0, M = d.length; p < M; p++) {
      var S = d.charCodeAt(p);
      S < 128 ? k.push(S) : S < 2048 ? k.push(
        192 | S >> 6,
        128 | S & 63
      ) : S < 55296 || S >= 57344 ? k.push(
        224 | S >> 12,
        128 | S >> 6 & 63,
        128 | S & 63
      ) : (p++, S = 65536 + ((S & 1023) << 10 | d.charCodeAt(p) & 1023), k.push(
        240 | S >> 18,
        128 | S >> 12 & 63,
        128 | S >> 6 & 63,
        128 | S & 63
      ));
    }
    return new Uint8Array(k);
  }
  function n() {
    if (arguments.length == 2)
      return new n(arguments[1]).update(arguments[0]).digest();
    if (!(this instanceof n))
      return new n(arguments[0]);
    h.call(this, arguments[0]);
  }
  function h(d) {
    return this.seed = d instanceof o ? d.clone() : o(d), this.v1 = this.seed.clone().add(E).add(A), this.v2 = this.seed.clone().add(A), this.v3 = this.seed.clone(), this.v4 = this.seed.clone().subtract(E), this.total_len = 0, this.memsize = 0, this.memory = null, this;
  }
  return n.prototype.init = h, n.prototype.update = function(d) {
    var k = typeof d == "string", p;
    k && (d = c(d), k = !1, p = !0), typeof ArrayBuffer < "u" && d instanceof ArrayBuffer && (p = !0, d = new Uint8Array(d));
    var M = 0, S = d.length, AA = M + S;
    if (S == 0) return this;
    if (this.total_len += S, this.memsize == 0 && (k ? this.memory = "" : p ? this.memory = new Uint8Array(32) : this.memory = new Buffer(32)), this.memsize + S < 32)
      return k ? this.memory += d : p ? this.memory.set(d.subarray(0, S), this.memsize) : d.copy(this.memory, this.memsize, 0, S), this.memsize += S, this;
    if (this.memsize > 0) {
      k ? this.memory += d.slice(0, 32 - this.memsize) : p ? this.memory.set(d.subarray(0, 32 - this.memsize), this.memsize) : d.copy(this.memory, this.memsize, 0, 32 - this.memsize);
      var H = 0;
      if (k) {
        var gA;
        gA = o(
          this.memory.charCodeAt(H + 1) << 8 | this.memory.charCodeAt(H),
          this.memory.charCodeAt(H + 3) << 8 | this.memory.charCodeAt(H + 2),
          this.memory.charCodeAt(H + 5) << 8 | this.memory.charCodeAt(H + 4),
          this.memory.charCodeAt(H + 7) << 8 | this.memory.charCodeAt(H + 6)
        ), this.v1.add(gA.multiply(A)).rotl(31).multiply(E), H += 8, gA = o(
          this.memory.charCodeAt(H + 1) << 8 | this.memory.charCodeAt(H),
          this.memory.charCodeAt(H + 3) << 8 | this.memory.charCodeAt(H + 2),
          this.memory.charCodeAt(H + 5) << 8 | this.memory.charCodeAt(H + 4),
          this.memory.charCodeAt(H + 7) << 8 | this.memory.charCodeAt(H + 6)
        ), this.v2.add(gA.multiply(A)).rotl(31).multiply(E), H += 8, gA = o(
          this.memory.charCodeAt(H + 1) << 8 | this.memory.charCodeAt(H),
          this.memory.charCodeAt(H + 3) << 8 | this.memory.charCodeAt(H + 2),
          this.memory.charCodeAt(H + 5) << 8 | this.memory.charCodeAt(H + 4),
          this.memory.charCodeAt(H + 7) << 8 | this.memory.charCodeAt(H + 6)
        ), this.v3.add(gA.multiply(A)).rotl(31).multiply(E), H += 8, gA = o(
          this.memory.charCodeAt(H + 1) << 8 | this.memory.charCodeAt(H),
          this.memory.charCodeAt(H + 3) << 8 | this.memory.charCodeAt(H + 2),
          this.memory.charCodeAt(H + 5) << 8 | this.memory.charCodeAt(H + 4),
          this.memory.charCodeAt(H + 7) << 8 | this.memory.charCodeAt(H + 6)
        ), this.v4.add(gA.multiply(A)).rotl(31).multiply(E);
      } else {
        var gA;
        gA = o(
          this.memory[H + 1] << 8 | this.memory[H],
          this.memory[H + 3] << 8 | this.memory[H + 2],
          this.memory[H + 5] << 8 | this.memory[H + 4],
          this.memory[H + 7] << 8 | this.memory[H + 6]
        ), this.v1.add(gA.multiply(A)).rotl(31).multiply(E), H += 8, gA = o(
          this.memory[H + 1] << 8 | this.memory[H],
          this.memory[H + 3] << 8 | this.memory[H + 2],
          this.memory[H + 5] << 8 | this.memory[H + 4],
          this.memory[H + 7] << 8 | this.memory[H + 6]
        ), this.v2.add(gA.multiply(A)).rotl(31).multiply(E), H += 8, gA = o(
          this.memory[H + 1] << 8 | this.memory[H],
          this.memory[H + 3] << 8 | this.memory[H + 2],
          this.memory[H + 5] << 8 | this.memory[H + 4],
          this.memory[H + 7] << 8 | this.memory[H + 6]
        ), this.v3.add(gA.multiply(A)).rotl(31).multiply(E), H += 8, gA = o(
          this.memory[H + 1] << 8 | this.memory[H],
          this.memory[H + 3] << 8 | this.memory[H + 2],
          this.memory[H + 5] << 8 | this.memory[H + 4],
          this.memory[H + 7] << 8 | this.memory[H + 6]
        ), this.v4.add(gA.multiply(A)).rotl(31).multiply(E);
      }
      M += 32 - this.memsize, this.memsize = 0, k && (this.memory = "");
    }
    if (M <= AA - 32) {
      var CA = AA - 32;
      do {
        if (k) {
          var gA;
          gA = o(
            d.charCodeAt(M + 1) << 8 | d.charCodeAt(M),
            d.charCodeAt(M + 3) << 8 | d.charCodeAt(M + 2),
            d.charCodeAt(M + 5) << 8 | d.charCodeAt(M + 4),
            d.charCodeAt(M + 7) << 8 | d.charCodeAt(M + 6)
          ), this.v1.add(gA.multiply(A)).rotl(31).multiply(E), M += 8, gA = o(
            d.charCodeAt(M + 1) << 8 | d.charCodeAt(M),
            d.charCodeAt(M + 3) << 8 | d.charCodeAt(M + 2),
            d.charCodeAt(M + 5) << 8 | d.charCodeAt(M + 4),
            d.charCodeAt(M + 7) << 8 | d.charCodeAt(M + 6)
          ), this.v2.add(gA.multiply(A)).rotl(31).multiply(E), M += 8, gA = o(
            d.charCodeAt(M + 1) << 8 | d.charCodeAt(M),
            d.charCodeAt(M + 3) << 8 | d.charCodeAt(M + 2),
            d.charCodeAt(M + 5) << 8 | d.charCodeAt(M + 4),
            d.charCodeAt(M + 7) << 8 | d.charCodeAt(M + 6)
          ), this.v3.add(gA.multiply(A)).rotl(31).multiply(E), M += 8, gA = o(
            d.charCodeAt(M + 1) << 8 | d.charCodeAt(M),
            d.charCodeAt(M + 3) << 8 | d.charCodeAt(M + 2),
            d.charCodeAt(M + 5) << 8 | d.charCodeAt(M + 4),
            d.charCodeAt(M + 7) << 8 | d.charCodeAt(M + 6)
          ), this.v4.add(gA.multiply(A)).rotl(31).multiply(E);
        } else {
          var gA;
          gA = o(
            d[M + 1] << 8 | d[M],
            d[M + 3] << 8 | d[M + 2],
            d[M + 5] << 8 | d[M + 4],
            d[M + 7] << 8 | d[M + 6]
          ), this.v1.add(gA.multiply(A)).rotl(31).multiply(E), M += 8, gA = o(
            d[M + 1] << 8 | d[M],
            d[M + 3] << 8 | d[M + 2],
            d[M + 5] << 8 | d[M + 4],
            d[M + 7] << 8 | d[M + 6]
          ), this.v2.add(gA.multiply(A)).rotl(31).multiply(E), M += 8, gA = o(
            d[M + 1] << 8 | d[M],
            d[M + 3] << 8 | d[M + 2],
            d[M + 5] << 8 | d[M + 4],
            d[M + 7] << 8 | d[M + 6]
          ), this.v3.add(gA.multiply(A)).rotl(31).multiply(E), M += 8, gA = o(
            d[M + 1] << 8 | d[M],
            d[M + 3] << 8 | d[M + 2],
            d[M + 5] << 8 | d[M + 4],
            d[M + 7] << 8 | d[M + 6]
          ), this.v4.add(gA.multiply(A)).rotl(31).multiply(E);
        }
        M += 8;
      } while (M <= CA);
    }
    return M < AA && (k ? this.memory += d.slice(M) : p ? this.memory.set(d.subarray(M, AA), this.memsize) : d.copy(this.memory, this.memsize, M, AA), this.memsize = AA - M), this;
  }, n.prototype.digest = function() {
    var d = this.memory, k = typeof d == "string", p = 0, M = this.memsize, S, AA, H = new o();
    for (this.total_len >= 32 ? (S = this.v1.clone().rotl(1), S.add(this.v2.clone().rotl(7)), S.add(this.v3.clone().rotl(12)), S.add(this.v4.clone().rotl(18)), S.xor(this.v1.multiply(A).rotl(31).multiply(E)), S.multiply(E).add(e), S.xor(this.v2.multiply(A).rotl(31).multiply(E)), S.multiply(E).add(e), S.xor(this.v3.multiply(A).rotl(31).multiply(E)), S.multiply(E).add(e), S.xor(this.v4.multiply(A).rotl(31).multiply(E)), S.multiply(E).add(e)) : S = this.seed.clone().add(t), S.add(H.fromNumber(this.total_len)); p <= M - 8; )
      k ? H.fromBits(
        d.charCodeAt(p + 1) << 8 | d.charCodeAt(p),
        d.charCodeAt(p + 3) << 8 | d.charCodeAt(p + 2),
        d.charCodeAt(p + 5) << 8 | d.charCodeAt(p + 4),
        d.charCodeAt(p + 7) << 8 | d.charCodeAt(p + 6)
      ) : H.fromBits(
        d[p + 1] << 8 | d[p],
        d[p + 3] << 8 | d[p + 2],
        d[p + 5] << 8 | d[p + 4],
        d[p + 7] << 8 | d[p + 6]
      ), H.multiply(A).rotl(31).multiply(E), S.xor(H).rotl(27).multiply(E).add(e), p += 8;
    for (p + 4 <= M && (k ? H.fromBits(
      d.charCodeAt(p + 1) << 8 | d.charCodeAt(p),
      d.charCodeAt(p + 3) << 8 | d.charCodeAt(p + 2),
      0,
      0
    ) : H.fromBits(
      d[p + 1] << 8 | d[p],
      d[p + 3] << 8 | d[p + 2],
      0,
      0
    ), S.xor(H.multiply(E)).rotl(23).multiply(A).add(g), p += 4); p < M; )
      H.fromBits(k ? d.charCodeAt(p++) : d[p++], 0, 0, 0), S.xor(H.multiply(t)).rotl(11).multiply(E);
    return AA = S.clone().shiftRight(33), S.xor(AA).multiply(A), AA = S.clone().shiftRight(29), S.xor(AA).multiply(g), AA = S.clone().shiftRight(32), S.xor(AA), this.init(this.seed), S;
  }, xxhash64 = n, xxhash64;
}
var lib$1, hasRequiredLib$1;
function requireLib$1() {
  return hasRequiredLib$1 || (hasRequiredLib$1 = 1, lib$1 = {
    h32: requireXxhash(),
    h64: requireXxhash64()
  }), lib$1;
}
var libExports$1 = requireLib$1();
const xxhash = /* @__PURE__ */ getDefaultExportFromCjs(libExports$1), assertNever = (o) => {
  throw new Error(`Reached a branch with non-exhaustive item: ${o}`);
}, GENERATED_ELEMENT_ID_PREFIX = "$$ID";
function debounce$2(o, E) {
  let A;
  return (...g) => {
    A && clearTimeout(A), A = setTimeout(() => {
      E(...g), A = null;
    }, o);
  };
}
const EMBED_QUERY_PARAM_KEY = "embed", EMBED_OPTIONS_QUERY_PARAM_KEY = "embed_options", EMBED_SHOW_TOOLBAR = "show_toolbar", EMBED_SHOW_PADDING = "show_padding", EMBED_DISABLE_SCROLLING = "disable_scrolling", EMBED_LIGHT_THEME = "light_theme", EMBED_DARK_THEME = "dark_theme", EMBED_TRUE = "true", EMBED_HIDE_LOADING_SCREEN = "hide_loading_screen", EMBED_SHOW_LOADING_SCREEN_V1 = "show_loading_screen_v1", EMBED_SHOW_LOADING_SCREEN_V2 = "show_loading_screen_v2", EMBED_QUERY_PARAM_VALUES = [EMBED_SHOW_TOOLBAR, EMBED_SHOW_PADDING, EMBED_DISABLE_SCROLLING, EMBED_LIGHT_THEME, EMBED_DARK_THEME, EMBED_HIDE_LOADING_SCREEN, EMBED_SHOW_LOADING_SCREEN_V1, EMBED_SHOW_LOADING_SCREEN_V2, EMBED_TRUE];
var LoadingScreenType = /* @__PURE__ */ ((o) => (o[o.NONE = 0] = "NONE", o[o.V1 = 1] = "V1", o[o.V2 = 2] = "V2", o))(LoadingScreenType || {});
function getEmbedUrlParams(o) {
  const E = /* @__PURE__ */ new Set();
  return new URLSearchParams(window.location.search).forEach((g, e) => {
    e = e.toString().toLowerCase(), g = g.toString().toLowerCase(), e === o && EMBED_QUERY_PARAM_VALUES.includes(g) && E.add(g);
  }), E;
}
function preserveEmbedQueryParams() {
  if (!isEmbed())
    return "";
  const o = new URLSearchParams(window.location.search).getAll(EMBED_OPTIONS_QUERY_PARAM_KEY), E = [];
  return E.push([EMBED_QUERY_PARAM_KEY, EMBED_TRUE]), o.forEach((A) => {
    E.push([EMBED_OPTIONS_QUERY_PARAM_KEY, A]);
  }), new URLSearchParams(E).toString();
}
function getQueryString(o, E) {
  return o !== void 0 ? E ? o ? `${E}&${o}` : E : o : E;
}
function isEmbed() {
  return getEmbedUrlParams(EMBED_QUERY_PARAM_KEY).has(EMBED_TRUE);
}
function isToolbarDisplayed() {
  return isEmbed() && getEmbedUrlParams(EMBED_OPTIONS_QUERY_PARAM_KEY).has(EMBED_SHOW_TOOLBAR);
}
function isScrollingHidden() {
  return isEmbed() && getEmbedUrlParams(EMBED_OPTIONS_QUERY_PARAM_KEY).has(EMBED_DISABLE_SCROLLING);
}
function isPaddingDisplayed() {
  return isEmbed() && getEmbedUrlParams(EMBED_OPTIONS_QUERY_PARAM_KEY).has(EMBED_SHOW_PADDING);
}
function isLightThemeInQueryParams() {
  return getEmbedUrlParams(EMBED_OPTIONS_QUERY_PARAM_KEY).has(EMBED_LIGHT_THEME);
}
function isDarkThemeInQueryParams() {
  return getEmbedUrlParams(EMBED_OPTIONS_QUERY_PARAM_KEY).has(EMBED_DARK_THEME);
}
function isInChildFrame() {
  return window.parent !== window;
}
function getUrl() {
  let o;
  try {
    isInChildFrame() && window.top ? o = window.top.location.href : o = document.location.href;
  } catch {
    o = document.location.href;
  }
  const E = new URL(o);
  return E.search = "", E.hash = "", E.toString();
}
function getScreencastTimestamp() {
  const o = /* @__PURE__ */ new Date(), E = o.getFullYear(), A = String(o.getMonth() + 1).padStart(2, "0"), g = String(o.getDate()).padStart(2, "0"), e = String(o.getHours()).padStart(2, "0"), t = String(o.getMinutes()).padStart(2, "0"), c = String(o.getSeconds()).padStart(2, "0");
  return `${E}-${A}-${g}-${e}-${t}-${c}`;
}
function getTimezone$1() {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}
function getTimezoneOffset() {
  return (/* @__PURE__ */ new Date()).getTimezoneOffset();
}
function getLocaleLanguage() {
  return navigator.language;
}
function getLoadingScreenType() {
  const o = getEmbedUrlParams(EMBED_OPTIONS_QUERY_PARAM_KEY);
  return o.has(EMBED_HIDE_LOADING_SCREEN) ? 0 : o.has(EMBED_SHOW_LOADING_SCREEN_V1) ? 1 : 2;
}
function makeElementWithInfoText(o) {
  return new Element$1({
    alert: {
      body: o,
      format: Alert.Format.INFO
    }
  });
}
function makeElementWithErrorText(o) {
  return new Element$1({
    alert: {
      body: o,
      format: Alert.Format.ERROR
    }
  });
}
function makeAppSkeletonElement() {
  return new Element$1({
    skeleton: {
      style: Skeleton$1.SkeletonStyle.APP
    }
  });
}
function hashString(o) {
  return xxhash.h32(o, 3735928559).toString(16);
}
function requireNonNull(o) {
  if (isNullOrUndefined(o))
    throw new Error("value is null");
  return o;
}
function notUndefined(o) {
  return o !== void 0;
}
function isFromMac() {
  return /Mac/i.test(navigator.platform);
}
function isFromWindows() {
  return /^Win/i.test(navigator.platform);
}
function setCookie(o, E, A) {
  const g = E ? A : /* @__PURE__ */ new Date(), e = g ? `expires=${g.toUTCString()};` : "";
  document.cookie = `${o}=${E};${e}path=/`;
}
function isValidElementId(o) {
  return o ? o.startsWith(GENERATED_ELEMENT_ID_PREFIX) && // There must be at least 3 parts: $$ID-<hash>-<userKey>
  o.split("-").length >= 3 : !1;
}
function getElementId(o) {
  const E = get$1(o, [requireNonNull(o.type), "id"]);
  if (E && isValidElementId(E))
    return E;
}
function isValidFormId(o) {
  return notNullOrUndefined(o) && o.length > 0;
}
function isInForm(o) {
  return isValidFormId(o.formId);
}
function getSelectPlaceholder(o, E, A, g = !1) {
  let e = !1;
  return o !== "" ? {
    placeholder: o,
    shouldDisable: e
  } : (E.length === 0 ? A ? o = g ? "Add options" : "Add an option" : (o = "No options to select", e = !0) : A ? o = g ? "Choose or add options" : "Choose or add an option" : o = g ? "Choose options" : "Choose an option", {
    placeholder: o,
    shouldDisable: e
  });
}
var LabelVisibilityOptions = /* @__PURE__ */ ((o) => (o[o.Visible = 0] = "Visible", o[o.Hidden = 1] = "Hidden", o[o.Collapsed = 2] = "Collapsed", o))(LabelVisibilityOptions || {});
function labelVisibilityProtoValueToEnum(o) {
  switch (o) {
    case LabelVisibilityMessage.LabelVisibilityOptions.VISIBLE:
      return 0;
    case LabelVisibilityMessage.LabelVisibilityOptions.HIDDEN:
      return 1;
    case LabelVisibilityMessage.LabelVisibilityOptions.COLLAPSED:
      return 2;
    default:
      return 0;
  }
}
var AcceptFileValue = /* @__PURE__ */ ((o) => (o[o.None = 0] = "None", o[o.Single = 1] = "Single", o[o.Multiple = 2] = "Multiple", o[o.Directory = 3] = "Directory", o))(AcceptFileValue || {});
function chatInputAcceptFileProtoValueToEnum(o) {
  switch (o) {
    case ChatInput$1.AcceptFile.NONE:
      return 0;
    case ChatInput$1.AcceptFile.SINGLE:
      return 1;
    case ChatInput$1.AcceptFile.MULTIPLE:
      return 2;
    case ChatInput$1.AcceptFile.DIRECTORY:
      return 3;
    default:
      return assertNever(o), 0;
  }
}
function findAnIFrameWithClassName(o, E) {
  for (let A = 0; A < o.length; A++) {
    const g = o[A].contentDocument;
    if (g && g.getElementsByClassName(E).length > 0)
      return o[A];
  }
  return null;
}
function canAccessIFrame(o) {
  try {
    if (o.contentWindow === null) return !1;
    const A = (o.contentDocument || o.contentWindow.document).body.innerHTML;
    return A !== null && A !== "";
  } catch {
    return !1;
  }
}
function getIFrameEnclosingApp(o) {
  if (!isInChildFrame())
    return null;
  const E = getEmbeddingIdClassName(o), A = 'iframe[title="streamlitApp"]';
  let g = window.document.querySelectorAll(A), e = findAnIFrameWithClassName(g, E);
  if (e && !canAccessIFrame(e))
    return null;
  if (e)
    return e;
  if (window.parent && (g = window.parent.document.querySelectorAll(A)), e = findAnIFrameWithClassName(g, E), e && !canAccessIFrame(e))
    return null;
  if (e)
    return e;
  let t = window.document.getElementsByTagName("iframe");
  return e = findAnIFrameWithClassName(t, E), e && !canAccessIFrame(e) ? null : e || (window.parent && (t = window.parent.document.getElementsByTagName("iframe")), e = findAnIFrameWithClassName(t, E), e && !canAccessIFrame(e) ? null : e);
}
function generateUID$2() {
  return Math.floor(Date.now() / 1e3).toString(36) + Math.random().toString(36).slice(-6);
}
function getEmbeddingIdClassName(o) {
  return `stAppEmbeddingId-${o}`;
}
function extractPageNameFromPathName(o, E) {
  return decodeURIComponent(o.replace(E, "").replace(new RegExp("^/?"), "").replace(new RegExp("/$"), ""));
}
function keysToSnakeCase(o) {
  return Object.keys(o).reduce(
    (E, A) => {
      const g = decamelize$1(A, {
        preserveConsecutiveUppercase: !0
      }).replace(".", "_");
      let e = o[A];
      return e && typeof e == "object" && !Array.isArray(e) && (e = keysToSnakeCase(e)), Array.isArray(e) && (e = e.map((t) => t !== null && typeof t == "object" ? keysToSnakeCase(t) : t)), E[g] = e, E;
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace 'any' with a more specific type.
    {}
  );
}
const NO_SCRIPT_RUN_ID = "NO_SCRIPT_RUN_ID", MAX_HASH_LENGTH = 6;
class DebugVisitor {
  constructor(E = "", A = !0) {
    this.prefix = E, this.isLast = A;
  }
  visitBlockNode(E) {
    const A = this.isLast ? "└── " : "├── ", g = this.prefix + (this.isLast ? "    " : "│   ");
    let e = `${this.prefix}${A}BlockNode [${E.children.length} children]`;
    return E.scriptRunId !== NO_SCRIPT_RUN_ID && (e += ` (run: ${E.scriptRunId.substring(0, MAX_HASH_LENGTH)})`), e += `
`, E.children.forEach((t, c) => {
      const n = c === E.children.length - 1, h = new DebugVisitor(g, n);
      e += t.accept(h);
    }), e;
  }
  visitElementNode(E) {
    const A = this.isLast ? "└── " : "├── ";
    let g = `${this.prefix}${A}ElementNode [${E.element.type}]`;
    if (E.element.type === "text" && E.element.text?.body) {
      const e = E.element.text.body.length > 30 ? `${E.element.text.body.slice(0, 30)}...` : E.element.text.body;
      g += ` "${e}"`;
    }
    return E.scriptRunId !== NO_SCRIPT_RUN_ID && (g += ` (run: ${E.scriptRunId.substring(0, MAX_HASH_LENGTH)})`), E.fragmentId && (g += ` (fragment: ${E.fragmentId.substring(0, MAX_HASH_LENGTH)})`), g += ` (activeScriptHash: ${E.activeScriptHash.substring(0, MAX_HASH_LENGTH)})`, g += `
`, g;
  }
  /**
   * Static helper method to generate debug output for any AppNode.
   */
  static generateDebugString(E, A = "", g = !0) {
    const e = new DebugVisitor(A, g);
    return E.accept(e);
  }
}
class BlockNode {
  constructor(E, A, g, e, t, c) {
    this.activeScriptHash = E, this.children = A ?? [], this.deltaBlock = g ?? new Block$1({}), this.scriptRunId = e ?? NO_SCRIPT_RUN_ID, this.fragmentId = t, this.deltaMsgReceivedAt = c;
  }
  /** True if this Block has no children. */
  get isEmpty() {
    return this.children.length === 0;
  }
  /**
   * Accept a visitor.
   * @param visitor - The visitor to accept.
   * @returns The result of the visitor's visitBlockNode method.
   * @example
   * const visitor = new DebugVisitor()
   * const result = blockNode.accept(visitor)
   * console.log(result)
   */
  accept(E) {
    return E.visitBlockNode(this);
  }
  /**
   * Returns a string representation of this BlockNode and its children,
   * primarily for debugging or logging purposes.
   *
   * @returns {string} A debug string describing the structure of this BlockNode.
   */
  debug() {
    return this.accept(new DebugVisitor());
  }
}
var NOTHING = Symbol.for("immer-nothing"), DRAFTABLE = Symbol.for("immer-draftable"), DRAFT_STATE = Symbol.for("immer-state"), errors = process.env.NODE_ENV !== "production" ? [
  // All error codes, starting by 0:
  function(o) {
    return `The plugin for '${o}' has not been loaded into Immer. To enable the plugin, import and call \`enable${o}()\` when initializing your application.`;
  },
  function(o) {
    return `produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '${o}'`;
  },
  "This object has been frozen and should not be mutated",
  function(o) {
    return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + o;
  },
  "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
  "Immer forbids circular references",
  "The first or second argument to `produce` must be a function",
  "The third argument to `produce` must be a function or undefined",
  "First argument to `createDraft` must be a plain object, an array, or an immerable object",
  "First argument to `finishDraft` must be a draft returned by `createDraft`",
  function(o) {
    return `'current' expects a draft, got: ${o}`;
  },
  "Object.defineProperty() cannot be used on an Immer draft",
  "Object.setPrototypeOf() cannot be used on an Immer draft",
  "Immer only supports deleting array indices",
  "Immer only supports setting array indices and the 'length' property",
  function(o) {
    return `'original' expects a draft, got: ${o}`;
  }
  // Note: if more errors are added, the errorOffset in Patches.ts should be increased
  // See Patches.ts for additional errors
] : [];
function die(o, ...E) {
  if (process.env.NODE_ENV !== "production") {
    const A = errors[o], g = typeof A == "function" ? A.apply(null, E) : A;
    throw new Error(`[Immer] ${g}`);
  }
  throw new Error(
    `[Immer] minified error nr: ${o}. Full error at: https://bit.ly/3cXEKWf`
  );
}
var getPrototypeOf = Object.getPrototypeOf;
function isDraft(o) {
  return !!o && !!o[DRAFT_STATE];
}
function isDraftable(o) {
  return o ? isPlainObject$2(o) || Array.isArray(o) || !!o[DRAFTABLE] || !!o.constructor?.[DRAFTABLE] || isMap(o) || isSet(o) : !1;
}
var objectCtorString = Object.prototype.constructor.toString(), cachedCtorStrings = /* @__PURE__ */ new WeakMap();
function isPlainObject$2(o) {
  if (!o || typeof o != "object")
    return !1;
  const E = Object.getPrototypeOf(o);
  if (E === null || E === Object.prototype)
    return !0;
  const A = Object.hasOwnProperty.call(E, "constructor") && E.constructor;
  if (A === Object)
    return !0;
  if (typeof A != "function")
    return !1;
  let g = cachedCtorStrings.get(A);
  return g === void 0 && (g = Function.toString.call(A), cachedCtorStrings.set(A, g)), g === objectCtorString;
}
function each$1(o, E, A = !0) {
  getArchtype(o) === 0 ? (A ? Reflect.ownKeys(o) : Object.keys(o)).forEach((e) => {
    E(e, o[e], o);
  }) : o.forEach((g, e) => E(e, g, o));
}
function getArchtype(o) {
  const E = o[DRAFT_STATE];
  return E ? E.type_ : Array.isArray(o) ? 1 : isMap(o) ? 2 : isSet(o) ? 3 : 0;
}
function has$1(o, E) {
  return getArchtype(o) === 2 ? o.has(E) : Object.prototype.hasOwnProperty.call(o, E);
}
function get(o, E) {
  return getArchtype(o) === 2 ? o.get(E) : o[E];
}
function set(o, E, A) {
  const g = getArchtype(o);
  g === 2 ? o.set(E, A) : g === 3 ? o.add(A) : o[E] = A;
}
function is(o, E) {
  return o === E ? o !== 0 || 1 / o === 1 / E : o !== o && E !== E;
}
function isMap(o) {
  return o instanceof Map;
}
function isSet(o) {
  return o instanceof Set;
}
function latest(o) {
  return o.copy_ || o.base_;
}
function shallowCopy(o, E) {
  if (isMap(o))
    return new Map(o);
  if (isSet(o))
    return new Set(o);
  if (Array.isArray(o))
    return Array.prototype.slice.call(o);
  const A = isPlainObject$2(o);
  if (E === !0 || E === "class_only" && !A) {
    const g = Object.getOwnPropertyDescriptors(o);
    delete g[DRAFT_STATE];
    let e = Reflect.ownKeys(g);
    for (let t = 0; t < e.length; t++) {
      const c = e[t], n = g[c];
      n.writable === !1 && (n.writable = !0, n.configurable = !0), (n.get || n.set) && (g[c] = {
        configurable: !0,
        writable: !0,
        // could live with !!desc.set as well here...
        enumerable: n.enumerable,
        value: o[c]
      });
    }
    return Object.create(getPrototypeOf(o), g);
  } else {
    const g = getPrototypeOf(o);
    if (g !== null && A)
      return { ...o };
    const e = Object.create(g);
    return Object.assign(e, o);
  }
}
function freeze(o, E = !1) {
  return isFrozen(o) || isDraft(o) || !isDraftable(o) || (getArchtype(o) > 1 && Object.defineProperties(o, {
    set: dontMutateMethodOverride,
    add: dontMutateMethodOverride,
    clear: dontMutateMethodOverride,
    delete: dontMutateMethodOverride
  }), Object.freeze(o), E && Object.values(o).forEach((A) => freeze(A, !0))), o;
}
function dontMutateFrozenCollections() {
  die(2);
}
var dontMutateMethodOverride = {
  value: dontMutateFrozenCollections
};
function isFrozen(o) {
  return o === null || typeof o != "object" ? !0 : Object.isFrozen(o);
}
var plugins$1 = {};
function getPlugin(o) {
  const E = plugins$1[o];
  return E || die(0, o), E;
}
function loadPlugin(o, E) {
  plugins$1[o] || (plugins$1[o] = E);
}
var currentScope;
function getCurrentScope() {
  return currentScope;
}
function createScope(o, E) {
  return {
    drafts_: [],
    parent_: o,
    immer_: E,
    // Whenever the modified draft contains a draft from another scope, we
    // need to prevent auto-freezing so the unowned draft can be finalized.
    canAutoFreeze_: !0,
    unfinalizedDrafts_: 0
  };
}
function usePatchesInScope(o, E) {
  E && (getPlugin("Patches"), o.patches_ = [], o.inversePatches_ = [], o.patchListener_ = E);
}
function revokeScope(o) {
  leaveScope(o), o.drafts_.forEach(revokeDraft), o.drafts_ = null;
}
function leaveScope(o) {
  o === currentScope && (currentScope = o.parent_);
}
function enterScope(o) {
  return currentScope = createScope(currentScope, o);
}
function revokeDraft(o) {
  const E = o[DRAFT_STATE];
  E.type_ === 0 || E.type_ === 1 ? E.revoke_() : E.revoked_ = !0;
}
function processResult(o, E) {
  E.unfinalizedDrafts_ = E.drafts_.length;
  const A = E.drafts_[0];
  return o !== void 0 && o !== A ? (A[DRAFT_STATE].modified_ && (revokeScope(E), die(4)), isDraftable(o) && (o = finalize(E, o), E.parent_ || maybeFreeze(E, o)), E.patches_ && getPlugin("Patches").generateReplacementPatches_(
    A[DRAFT_STATE].base_,
    o,
    E.patches_,
    E.inversePatches_
  )) : o = finalize(E, A, []), revokeScope(E), E.patches_ && E.patchListener_(E.patches_, E.inversePatches_), o !== NOTHING ? o : void 0;
}
function finalize(o, E, A) {
  if (isFrozen(E))
    return E;
  const g = o.immer_.shouldUseStrictIteration(), e = E[DRAFT_STATE];
  if (!e)
    return each$1(
      E,
      (t, c) => finalizeProperty(o, e, E, t, c, A),
      g
    ), E;
  if (e.scope_ !== o)
    return E;
  if (!e.modified_)
    return maybeFreeze(o, e.base_, !0), e.base_;
  if (!e.finalized_) {
    e.finalized_ = !0, e.scope_.unfinalizedDrafts_--;
    const t = e.copy_;
    let c = t, n = !1;
    e.type_ === 3 && (c = new Set(t), t.clear(), n = !0), each$1(
      c,
      (h, d) => finalizeProperty(
        o,
        e,
        t,
        h,
        d,
        A,
        n
      ),
      g
    ), maybeFreeze(o, t, !1), A && o.patches_ && getPlugin("Patches").generatePatches_(
      e,
      A,
      o.patches_,
      o.inversePatches_
    );
  }
  return e.copy_;
}
function finalizeProperty(o, E, A, g, e, t, c) {
  if (e == null || typeof e != "object" && !c)
    return;
  const n = isFrozen(e);
  if (!(n && !c)) {
    if (process.env.NODE_ENV !== "production" && e === A && die(5), isDraft(e)) {
      const h = t && E && E.type_ !== 3 && // Set objects are atomic since they have no keys.
      !has$1(E.assigned_, g) ? t.concat(g) : void 0, d = finalize(o, e, h);
      if (set(A, g, d), isDraft(d))
        o.canAutoFreeze_ = !1;
      else
        return;
    } else c && A.add(e);
    if (isDraftable(e) && !n) {
      if (!o.immer_.autoFreeze_ && o.unfinalizedDrafts_ < 1 || E && E.base_ && E.base_[g] === e && n)
        return;
      finalize(o, e), (!E || !E.scope_.parent_) && typeof g != "symbol" && (isMap(A) ? A.has(g) : Object.prototype.propertyIsEnumerable.call(A, g)) && maybeFreeze(o, e);
    }
  }
}
function maybeFreeze(o, E, A = !1) {
  !o.parent_ && o.immer_.autoFreeze_ && o.canAutoFreeze_ && freeze(E, A);
}
function createProxyProxy(o, E) {
  const A = Array.isArray(o), g = {
    type_: A ? 1 : 0,
    // Track which produce call this is associated with.
    scope_: E ? E.scope_ : getCurrentScope(),
    // True for both shallow and deep changes.
    modified_: !1,
    // Used during finalization.
    finalized_: !1,
    // Track which properties have been assigned (true) or deleted (false).
    assigned_: {},
    // The parent draft state.
    parent_: E,
    // The base state.
    base_: o,
    // The base proxy.
    draft_: null,
    // set below
    // The base copy with any updated values.
    copy_: null,
    // Called by the `produce` function.
    revoke_: null,
    isManual_: !1
  };
  let e = g, t = objectTraps;
  A && (e = [g], t = arrayTraps);
  const { revoke: c, proxy: n } = Proxy.revocable(e, t);
  return g.draft_ = n, g.revoke_ = c, n;
}
var objectTraps = {
  get(o, E) {
    if (E === DRAFT_STATE)
      return o;
    const A = latest(o);
    if (!has$1(A, E))
      return readPropFromProto(o, A, E);
    const g = A[E];
    return o.finalized_ || !isDraftable(g) ? g : g === peek(o.base_, E) ? (prepareCopy(o), o.copy_[E] = createProxy(g, o)) : g;
  },
  has(o, E) {
    return E in latest(o);
  },
  ownKeys(o) {
    return Reflect.ownKeys(latest(o));
  },
  set(o, E, A) {
    const g = getDescriptorFromProto(latest(o), E);
    if (g?.set)
      return g.set.call(o.draft_, A), !0;
    if (!o.modified_) {
      const e = peek(latest(o), E), t = e?.[DRAFT_STATE];
      if (t && t.base_ === A)
        return o.copy_[E] = A, o.assigned_[E] = !1, !0;
      if (is(A, e) && (A !== void 0 || has$1(o.base_, E)))
        return !0;
      prepareCopy(o), markChanged(o);
    }
    return o.copy_[E] === A && // special case: handle new props with value 'undefined'
    (A !== void 0 || E in o.copy_) || // special case: NaN
    Number.isNaN(A) && Number.isNaN(o.copy_[E]) || (o.copy_[E] = A, o.assigned_[E] = !0), !0;
  },
  deleteProperty(o, E) {
    return peek(o.base_, E) !== void 0 || E in o.base_ ? (o.assigned_[E] = !1, prepareCopy(o), markChanged(o)) : delete o.assigned_[E], o.copy_ && delete o.copy_[E], !0;
  },
  // Note: We never coerce `desc.value` into an Immer draft, because we can't make
  // the same guarantee in ES5 mode.
  getOwnPropertyDescriptor(o, E) {
    const A = latest(o), g = Reflect.getOwnPropertyDescriptor(A, E);
    return g && {
      writable: !0,
      configurable: o.type_ !== 1 || E !== "length",
      enumerable: g.enumerable,
      value: A[E]
    };
  },
  defineProperty() {
    die(11);
  },
  getPrototypeOf(o) {
    return getPrototypeOf(o.base_);
  },
  setPrototypeOf() {
    die(12);
  }
}, arrayTraps = {};
each$1(objectTraps, (o, E) => {
  arrayTraps[o] = function() {
    return arguments[0] = arguments[0][0], E.apply(this, arguments);
  };
});
arrayTraps.deleteProperty = function(o, E) {
  return process.env.NODE_ENV !== "production" && isNaN(parseInt(E)) && die(13), arrayTraps.set.call(this, o, E, void 0);
};
arrayTraps.set = function(o, E, A) {
  return process.env.NODE_ENV !== "production" && E !== "length" && isNaN(parseInt(E)) && die(14), objectTraps.set.call(this, o[0], E, A, o[0]);
};
function peek(o, E) {
  const A = o[DRAFT_STATE];
  return (A ? latest(A) : o)[E];
}
function readPropFromProto(o, E, A) {
  const g = getDescriptorFromProto(E, A);
  return g ? "value" in g ? g.value : (
    // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    g.get?.call(o.draft_)
  ) : void 0;
}
function getDescriptorFromProto(o, E) {
  if (!(E in o))
    return;
  let A = getPrototypeOf(o);
  for (; A; ) {
    const g = Object.getOwnPropertyDescriptor(A, E);
    if (g)
      return g;
    A = getPrototypeOf(A);
  }
}
function markChanged(o) {
  o.modified_ || (o.modified_ = !0, o.parent_ && markChanged(o.parent_));
}
function prepareCopy(o) {
  o.copy_ || (o.copy_ = shallowCopy(
    o.base_,
    o.scope_.immer_.useStrictShallowCopy_
  ));
}
var Immer2 = class {
  constructor(o) {
    this.autoFreeze_ = !0, this.useStrictShallowCopy_ = !1, this.useStrictIteration_ = !0, this.produce = (E, A, g) => {
      if (typeof E == "function" && typeof A != "function") {
        const t = A;
        A = E;
        const c = this;
        return function(h = t, ...d) {
          return c.produce(h, (k) => A.call(this, k, ...d));
        };
      }
      typeof A != "function" && die(6), g !== void 0 && typeof g != "function" && die(7);
      let e;
      if (isDraftable(E)) {
        const t = enterScope(this), c = createProxy(E, void 0);
        let n = !0;
        try {
          e = A(c), n = !1;
        } finally {
          n ? revokeScope(t) : leaveScope(t);
        }
        return usePatchesInScope(t, g), processResult(e, t);
      } else if (!E || typeof E != "object") {
        if (e = A(E), e === void 0 && (e = E), e === NOTHING && (e = void 0), this.autoFreeze_ && freeze(e, !0), g) {
          const t = [], c = [];
          getPlugin("Patches").generateReplacementPatches_(E, e, t, c), g(t, c);
        }
        return e;
      } else
        die(1, E);
    }, this.produceWithPatches = (E, A) => {
      if (typeof E == "function")
        return (c, ...n) => this.produceWithPatches(c, (h) => E(h, ...n));
      let g, e;
      return [this.produce(E, A, (c, n) => {
        g = c, e = n;
      }), g, e];
    }, typeof o?.autoFreeze == "boolean" && this.setAutoFreeze(o.autoFreeze), typeof o?.useStrictShallowCopy == "boolean" && this.setUseStrictShallowCopy(o.useStrictShallowCopy), typeof o?.useStrictIteration == "boolean" && this.setUseStrictIteration(o.useStrictIteration);
  }
  createDraft(o) {
    isDraftable(o) || die(8), isDraft(o) && (o = current(o));
    const E = enterScope(this), A = createProxy(o, void 0);
    return A[DRAFT_STATE].isManual_ = !0, leaveScope(E), A;
  }
  finishDraft(o, E) {
    const A = o && o[DRAFT_STATE];
    (!A || !A.isManual_) && die(9);
    const { scope_: g } = A;
    return usePatchesInScope(g, E), processResult(void 0, g);
  }
  /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */
  setAutoFreeze(o) {
    this.autoFreeze_ = o;
  }
  /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */
  setUseStrictShallowCopy(o) {
    this.useStrictShallowCopy_ = o;
  }
  /**
   * Pass false to use faster iteration that skips non-enumerable properties
   * but still handles symbols for compatibility.
   *
   * By default, strict iteration is enabled (includes all own properties).
   */
  setUseStrictIteration(o) {
    this.useStrictIteration_ = o;
  }
  shouldUseStrictIteration() {
    return this.useStrictIteration_;
  }
  applyPatches(o, E) {
    let A;
    for (A = E.length - 1; A >= 0; A--) {
      const e = E[A];
      if (e.path.length === 0 && e.op === "replace") {
        o = e.value;
        break;
      }
    }
    A > -1 && (E = E.slice(A + 1));
    const g = getPlugin("Patches").applyPatches_;
    return isDraft(o) ? g(o, E) : this.produce(
      o,
      (e) => g(e, E)
    );
  }
};
function createProxy(o, E) {
  const A = isMap(o) ? getPlugin("MapSet").proxyMap_(o, E) : isSet(o) ? getPlugin("MapSet").proxySet_(o, E) : createProxyProxy(o, E);
  return (E ? E.scope_ : getCurrentScope()).drafts_.push(A), A;
}
function current(o) {
  return isDraft(o) || die(10, o), currentImpl(o);
}
function currentImpl(o) {
  if (!isDraftable(o) || isFrozen(o))
    return o;
  const E = o[DRAFT_STATE];
  let A, g = !0;
  if (E) {
    if (!E.modified_)
      return E.base_;
    E.finalized_ = !0, A = shallowCopy(o, E.scope_.immer_.useStrictShallowCopy_), g = E.scope_.immer_.shouldUseStrictIteration();
  } else
    A = shallowCopy(o, !0);
  return each$1(
    A,
    (e, t) => {
      set(A, e, currentImpl(t));
    },
    g
  ), E && (E.finalized_ = !1), A;
}
function enablePatches() {
  process.env.NODE_ENV !== "production" && errors.push(
    'Sets cannot have "replace" patches.',
    function(M) {
      return "Unsupported patch operation: " + M;
    },
    function(M) {
      return "Cannot apply patch, path doesn't resolve: " + M;
    },
    "Patching reserved attributes like __proto__, prototype and constructor is not allowed"
  );
  const E = "replace", A = "add", g = "remove";
  function e(M, S, AA, H) {
    switch (M.type_) {
      case 0:
      case 2:
        return c(
          M,
          S,
          AA,
          H
        );
      case 1:
        return t(M, S, AA, H);
      case 3:
        return n(
          M,
          S,
          AA,
          H
        );
    }
  }
  function t(M, S, AA, H) {
    let { base_: gA, assigned_: CA } = M, IA = M.copy_;
    IA.length < gA.length && ([gA, IA] = [IA, gA], [AA, H] = [H, AA]);
    for (let BA = 0; BA < gA.length; BA++)
      if (CA[BA] && IA[BA] !== gA[BA]) {
        const QA = S.concat([BA]);
        AA.push({
          op: E,
          path: QA,
          // Need to maybe clone it, as it can in fact be the original value
          // due to the base/copy inversion at the start of this function
          value: p(IA[BA])
        }), H.push({
          op: E,
          path: QA,
          value: p(gA[BA])
        });
      }
    for (let BA = gA.length; BA < IA.length; BA++) {
      const QA = S.concat([BA]);
      AA.push({
        op: A,
        path: QA,
        // Need to maybe clone it, as it can in fact be the original value
        // due to the base/copy inversion at the start of this function
        value: p(IA[BA])
      });
    }
    for (let BA = IA.length - 1; gA.length <= BA; --BA) {
      const QA = S.concat([BA]);
      H.push({
        op: g,
        path: QA
      });
    }
  }
  function c(M, S, AA, H) {
    const { base_: gA, copy_: CA } = M;
    each$1(M.assigned_, (IA, BA) => {
      const QA = get(gA, IA), EA = get(CA, IA), oA = BA ? has$1(gA, IA) ? E : A : g;
      if (QA === EA && oA === E)
        return;
      const iA = S.concat(IA);
      AA.push(oA === g ? { op: oA, path: iA } : { op: oA, path: iA, value: EA }), H.push(
        oA === A ? { op: g, path: iA } : oA === g ? { op: A, path: iA, value: p(QA) } : { op: E, path: iA, value: p(QA) }
      );
    });
  }
  function n(M, S, AA, H) {
    let { base_: gA, copy_: CA } = M, IA = 0;
    gA.forEach((BA) => {
      if (!CA.has(BA)) {
        const QA = S.concat([IA]);
        AA.push({
          op: g,
          path: QA,
          value: BA
        }), H.unshift({
          op: A,
          path: QA,
          value: BA
        });
      }
      IA++;
    }), IA = 0, CA.forEach((BA) => {
      if (!gA.has(BA)) {
        const QA = S.concat([IA]);
        AA.push({
          op: A,
          path: QA,
          value: BA
        }), H.unshift({
          op: g,
          path: QA,
          value: BA
        });
      }
      IA++;
    });
  }
  function h(M, S, AA, H) {
    AA.push({
      op: E,
      path: [],
      value: S === NOTHING ? void 0 : S
    }), H.push({
      op: E,
      path: [],
      value: M
    });
  }
  function d(M, S) {
    return S.forEach((AA) => {
      const { path: H, op: gA } = AA;
      let CA = M;
      for (let EA = 0; EA < H.length - 1; EA++) {
        const oA = getArchtype(CA);
        let iA = H[EA];
        typeof iA != "string" && typeof iA != "number" && (iA = "" + iA), (oA === 0 || oA === 1) && (iA === "__proto__" || iA === "constructor") && die(19), typeof CA == "function" && iA === "prototype" && die(19), CA = get(CA, iA), typeof CA != "object" && die(18, H.join("/"));
      }
      const IA = getArchtype(CA), BA = k(AA.value), QA = H[H.length - 1];
      switch (gA) {
        case E:
          switch (IA) {
            case 2:
              return CA.set(QA, BA);
            case 3:
              die(16);
            default:
              return CA[QA] = BA;
          }
        case A:
          switch (IA) {
            case 1:
              return QA === "-" ? CA.push(BA) : CA.splice(QA, 0, BA);
            case 2:
              return CA.set(QA, BA);
            case 3:
              return CA.add(BA);
            default:
              return CA[QA] = BA;
          }
        case g:
          switch (IA) {
            case 1:
              return CA.splice(QA, 1);
            case 2:
              return CA.delete(QA);
            case 3:
              return CA.delete(AA.value);
            default:
              return delete CA[QA];
          }
        default:
          die(17, gA);
      }
    }), M;
  }
  function k(M) {
    if (!isDraftable(M))
      return M;
    if (Array.isArray(M))
      return M.map(k);
    if (isMap(M))
      return new Map(
        Array.from(M.entries()).map(([AA, H]) => [AA, k(H)])
      );
    if (isSet(M))
      return new Set(Array.from(M).map(k));
    const S = Object.create(getPrototypeOf(M));
    for (const AA in M)
      S[AA] = k(M[AA]);
    return has$1(M, DRAFTABLE) && (S[DRAFTABLE] = M[DRAFTABLE]), S;
  }
  function p(M) {
    return isDraft(M) ? k(M) : M;
  }
  loadPlugin("Patches", {
    applyPatches_: d,
    generatePatches_: e,
    generateReplacementPatches_: h
  });
}
function enableMapSet() {
  class o extends Map {
    constructor(h, d) {
      super(), this[DRAFT_STATE] = {
        type_: 2,
        parent_: d,
        scope_: d ? d.scope_ : getCurrentScope(),
        modified_: !1,
        finalized_: !1,
        copy_: void 0,
        assigned_: void 0,
        base_: h,
        draft_: this,
        isManual_: !1,
        revoked_: !1
      };
    }
    get size() {
      return latest(this[DRAFT_STATE]).size;
    }
    has(h) {
      return latest(this[DRAFT_STATE]).has(h);
    }
    set(h, d) {
      const k = this[DRAFT_STATE];
      return c(k), (!latest(k).has(h) || latest(k).get(h) !== d) && (A(k), markChanged(k), k.assigned_.set(h, !0), k.copy_.set(h, d), k.assigned_.set(h, !0)), this;
    }
    delete(h) {
      if (!this.has(h))
        return !1;
      const d = this[DRAFT_STATE];
      return c(d), A(d), markChanged(d), d.base_.has(h) ? d.assigned_.set(h, !1) : d.assigned_.delete(h), d.copy_.delete(h), !0;
    }
    clear() {
      const h = this[DRAFT_STATE];
      c(h), latest(h).size && (A(h), markChanged(h), h.assigned_ = /* @__PURE__ */ new Map(), each$1(h.base_, (d) => {
        h.assigned_.set(d, !1);
      }), h.copy_.clear());
    }
    forEach(h, d) {
      const k = this[DRAFT_STATE];
      latest(k).forEach((p, M, S) => {
        h.call(d, this.get(M), M, this);
      });
    }
    get(h) {
      const d = this[DRAFT_STATE];
      c(d);
      const k = latest(d).get(h);
      if (d.finalized_ || !isDraftable(k) || k !== d.base_.get(h))
        return k;
      const p = createProxy(k, d);
      return A(d), d.copy_.set(h, p), p;
    }
    keys() {
      return latest(this[DRAFT_STATE]).keys();
    }
    values() {
      const h = this.keys();
      return {
        [Symbol.iterator]: () => this.values(),
        next: () => {
          const d = h.next();
          return d.done ? d : {
            done: !1,
            value: this.get(d.value)
          };
        }
      };
    }
    entries() {
      const h = this.keys();
      return {
        [Symbol.iterator]: () => this.entries(),
        next: () => {
          const d = h.next();
          if (d.done)
            return d;
          const k = this.get(d.value);
          return {
            done: !1,
            value: [d.value, k]
          };
        }
      };
    }
    [Symbol.iterator]() {
      return this.entries();
    }
  }
  function E(n, h) {
    return new o(n, h);
  }
  function A(n) {
    n.copy_ || (n.assigned_ = /* @__PURE__ */ new Map(), n.copy_ = new Map(n.base_));
  }
  class g extends Set {
    constructor(h, d) {
      super(), this[DRAFT_STATE] = {
        type_: 3,
        parent_: d,
        scope_: d ? d.scope_ : getCurrentScope(),
        modified_: !1,
        finalized_: !1,
        copy_: void 0,
        base_: h,
        draft_: this,
        drafts_: /* @__PURE__ */ new Map(),
        revoked_: !1,
        isManual_: !1
      };
    }
    get size() {
      return latest(this[DRAFT_STATE]).size;
    }
    has(h) {
      const d = this[DRAFT_STATE];
      return c(d), d.copy_ ? !!(d.copy_.has(h) || d.drafts_.has(h) && d.copy_.has(d.drafts_.get(h))) : d.base_.has(h);
    }
    add(h) {
      const d = this[DRAFT_STATE];
      return c(d), this.has(h) || (t(d), markChanged(d), d.copy_.add(h)), this;
    }
    delete(h) {
      if (!this.has(h))
        return !1;
      const d = this[DRAFT_STATE];
      return c(d), t(d), markChanged(d), d.copy_.delete(h) || (d.drafts_.has(h) ? d.copy_.delete(d.drafts_.get(h)) : (
        /* istanbul ignore next */
        !1
      ));
    }
    clear() {
      const h = this[DRAFT_STATE];
      c(h), latest(h).size && (t(h), markChanged(h), h.copy_.clear());
    }
    values() {
      const h = this[DRAFT_STATE];
      return c(h), t(h), h.copy_.values();
    }
    entries() {
      const h = this[DRAFT_STATE];
      return c(h), t(h), h.copy_.entries();
    }
    keys() {
      return this.values();
    }
    [Symbol.iterator]() {
      return this.values();
    }
    forEach(h, d) {
      const k = this.values();
      let p = k.next();
      for (; !p.done; )
        h.call(d, p.value, p.value, this), p = k.next();
    }
  }
  function e(n, h) {
    return new g(n, h);
  }
  function t(n) {
    n.copy_ || (n.copy_ = /* @__PURE__ */ new Set(), n.base_.forEach((h) => {
      if (isDraftable(h)) {
        const d = createProxy(h, n);
        n.drafts_.set(h, d), n.copy_.add(d);
      } else
        n.copy_.add(h);
    }));
  }
  function c(n) {
    n.revoked_ && die(3, JSON.stringify(latest(n)));
  }
  loadPlugin("MapSet", { proxyMap_: E, proxySet_: e });
}
var immer = new Immer2(), produce = immer.produce, __assign$2 = function() {
  return __assign$2 = Object.assign || function(E) {
    for (var A, g = 1, e = arguments.length; g < e; g++) {
      A = arguments[g];
      for (var t in A) Object.prototype.hasOwnProperty.call(A, t) && (E[t] = A[t]);
    }
    return E;
  }, __assign$2.apply(this, arguments);
};
function __awaiter(o, E, A, g) {
  function e(t) {
    return t instanceof A ? t : new A(function(c) {
      c(t);
    });
  }
  return new (A || (A = Promise))(function(t, c) {
    function n(k) {
      try {
        d(g.next(k));
      } catch (p) {
        c(p);
      }
    }
    function h(k) {
      try {
        d(g.throw(k));
      } catch (p) {
        c(p);
      }
    }
    function d(k) {
      k.done ? t(k.value) : e(k.value).then(n, h);
    }
    d((g = g.apply(o, E || [])).next());
  });
}
function __values(o) {
  var E = typeof Symbol == "function" && Symbol.iterator, A = E && o[E], g = 0;
  if (A) return A.call(o);
  if (o && typeof o.length == "number") return {
    next: function() {
      return o && g >= o.length && (o = void 0), { value: o && o[g++], done: !o };
    }
  };
  throw new TypeError(E ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __await(o) {
  return this instanceof __await ? (this.v = o, this) : new __await(o);
}
function __asyncGenerator(o, E, A) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var g = A.apply(o, E || []), e, t = [];
  return e = Object.create((typeof AsyncIterator == "function" ? AsyncIterator : Object).prototype), n("next"), n("throw"), n("return", c), e[Symbol.asyncIterator] = function() {
    return this;
  }, e;
  function c(S) {
    return function(AA) {
      return Promise.resolve(AA).then(S, p);
    };
  }
  function n(S, AA) {
    g[S] && (e[S] = function(H) {
      return new Promise(function(gA, CA) {
        t.push([S, H, gA, CA]) > 1 || h(S, H);
      });
    }, AA && (e[S] = AA(e[S])));
  }
  function h(S, AA) {
    try {
      d(g[S](AA));
    } catch (H) {
      M(t[0][3], H);
    }
  }
  function d(S) {
    S.value instanceof __await ? Promise.resolve(S.value.v).then(k, p) : M(t[0][2], S);
  }
  function k(S) {
    h("next", S);
  }
  function p(S) {
    h("throw", S);
  }
  function M(S, AA) {
    S(AA), t.shift(), t.length && h(t[0][0], t[0][1]);
  }
}
function __asyncDelegator(o) {
  var E, A;
  return E = {}, g("next"), g("throw", function(e) {
    throw e;
  }), g("return"), E[Symbol.iterator] = function() {
    return this;
  }, E;
  function g(e, t) {
    E[e] = o[e] ? function(c) {
      return (A = !A) ? { value: __await(o[e](c)), done: !1 } : t ? t(c) : c;
    } : t;
  }
}
function __asyncValues(o) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var E = o[Symbol.asyncIterator], A;
  return E ? E.call(o) : (o = typeof __values == "function" ? __values(o) : o[Symbol.iterator](), A = {}, g("next"), g("throw"), g("return"), A[Symbol.asyncIterator] = function() {
    return this;
  }, A);
  function g(t) {
    A[t] = o[t] && function(c) {
      return new Promise(function(n, h) {
        c = o[t](c), e(n, h, c.done, c.value);
      });
    };
  }
  function e(t, c, n, h) {
    Promise.resolve(h).then(function(d) {
      t({ value: d, done: n });
    }, c);
  }
}
typeof SuppressedError == "function" && SuppressedError;
const decoder = new TextDecoder("utf-8"), decodeUtf8 = decoder.decode.bind(decoder), encoder = new TextEncoder(), encodeUtf8 = (o) => encoder.encode(o), isNumber = (o) => typeof o == "number", isBoolean = (o) => typeof o == "boolean", isFunction$2 = (o) => typeof o == "function", isObject$2 = (o) => o != null && Object(o) === o, isPromise = (o) => isObject$2(o) && isFunction$2(o.then), isIterable = (o) => isObject$2(o) && isFunction$2(o[Symbol.iterator]), isAsyncIterable$1 = (o) => isObject$2(o) && isFunction$2(o[Symbol.asyncIterator]), isArrowJSON = (o) => isObject$2(o) && isObject$2(o.schema), isIteratorResult = (o) => isObject$2(o) && "done" in o && "value" in o, isFileHandle = (o) => isObject$2(o) && isFunction$2(o.stat) && isNumber(o.fd), isFetchResponse = (o) => isObject$2(o) && isReadableDOMStream(o.body), isReadableInterop = (o) => "_getDOMStream" in o && "_getNodeStream" in o, isReadableDOMStream = (o) => isObject$2(o) && isFunction$2(o.cancel) && isFunction$2(o.getReader) && !isReadableInterop(o), isReadableNodeStream = (o) => isObject$2(o) && isFunction$2(o.read) && isFunction$2(o.pipe) && isBoolean(o.readable) && !isReadableInterop(o), isFlatbuffersByteBuffer = (o) => isObject$2(o) && isFunction$2(o.clear) && isFunction$2(o.bytes) && isFunction$2(o.position) && isFunction$2(o.setPosition) && isFunction$2(o.capacity) && isFunction$2(o.getBufferIdentifier) && isFunction$2(o.createLong), SharedArrayBuf = typeof SharedArrayBuffer < "u" ? SharedArrayBuffer : ArrayBuffer;
function collapseContiguousByteRanges(o) {
  const E = o[0] ? [o[0]] : [];
  let A, g, e, t;
  for (let c, n, h = 0, d = 0, k = o.length; ++h < k; ) {
    if (c = E[d], n = o[h], !c || !n || c.buffer !== n.buffer || n.byteOffset < c.byteOffset) {
      n && (E[++d] = n);
      continue;
    }
    if ({ byteOffset: A, byteLength: e } = c, { byteOffset: g, byteLength: t } = n, A + e < g || g + t < A) {
      n && (E[++d] = n);
      continue;
    }
    E[d] = new Uint8Array(c.buffer, A, g - A + t);
  }
  return E;
}
function memcpy(o, E, A = 0, g = E.byteLength) {
  const e = o.byteLength, t = new Uint8Array(o.buffer, o.byteOffset, e), c = new Uint8Array(E.buffer, E.byteOffset, Math.min(g, e));
  return t.set(c, A), o;
}
function joinUint8Arrays(o, E) {
  const A = collapseContiguousByteRanges(o), g = A.reduce((k, p) => k + p.byteLength, 0);
  let e, t, c, n = 0, h = -1;
  const d = Math.min(E || Number.POSITIVE_INFINITY, g);
  for (const k = A.length; ++h < k; ) {
    if (e = A[h], t = e.subarray(0, Math.min(e.length, d - n)), d <= n + t.length) {
      t.length < e.length ? A[h] = e.subarray(t.length) : t.length === e.length && h++, c ? memcpy(c, t, n) : c = t;
      break;
    }
    memcpy(c || (c = new Uint8Array(d)), t, n), n += t.length;
  }
  return [c || new Uint8Array(0), A.slice(h), g - (c ? c.byteLength : 0)];
}
function toArrayBufferView(o, E) {
  let A = isIteratorResult(E) ? E.value : E;
  return A instanceof o ? o === Uint8Array ? new o(A.buffer, A.byteOffset, A.byteLength) : A : A ? (typeof A == "string" && (A = encodeUtf8(A)), A instanceof ArrayBuffer ? new o(A) : A instanceof SharedArrayBuf ? new o(A) : isFlatbuffersByteBuffer(A) ? toArrayBufferView(o, A.bytes()) : ArrayBuffer.isView(A) ? A.byteLength <= 0 ? new o(0) : new o(A.buffer, A.byteOffset, A.byteLength / o.BYTES_PER_ELEMENT) : o.from(A)) : new o(0);
}
const toInt8Array = (o) => toArrayBufferView(Int8Array, o), toInt16Array = (o) => toArrayBufferView(Int16Array, o), toInt32Array = (o) => toArrayBufferView(Int32Array, o), toBigInt64Array = (o) => toArrayBufferView(BigInt64Array, o), toUint8Array = (o) => toArrayBufferView(Uint8Array, o), toUint16Array = (o) => toArrayBufferView(Uint16Array, o), toUint32Array = (o) => toArrayBufferView(Uint32Array, o), toBigUint64Array = (o) => toArrayBufferView(BigUint64Array, o), toFloat32Array = (o) => toArrayBufferView(Float32Array, o), toFloat64Array = (o) => toArrayBufferView(Float64Array, o), toUint8ClampedArray = (o) => toArrayBufferView(Uint8ClampedArray, o), pump$1 = (o) => (o.next(), o);
function* toArrayBufferViewIterator(o, E) {
  const A = function* (e) {
    yield e;
  }, g = typeof E == "string" || ArrayBuffer.isView(E) || E instanceof ArrayBuffer || E instanceof SharedArrayBuf ? A(E) : isIterable(E) ? E : A(E);
  return yield* pump$1((function* (e) {
    let t = null;
    do
      t = e.next(yield toArrayBufferView(o, t));
    while (!t.done);
  })(g[Symbol.iterator]())), new o();
}
const toInt8ArrayIterator = (o) => toArrayBufferViewIterator(Int8Array, o), toInt16ArrayIterator = (o) => toArrayBufferViewIterator(Int16Array, o), toInt32ArrayIterator = (o) => toArrayBufferViewIterator(Int32Array, o), toUint8ArrayIterator = (o) => toArrayBufferViewIterator(Uint8Array, o), toUint16ArrayIterator = (o) => toArrayBufferViewIterator(Uint16Array, o), toUint32ArrayIterator = (o) => toArrayBufferViewIterator(Uint32Array, o), toFloat32ArrayIterator = (o) => toArrayBufferViewIterator(Float32Array, o), toFloat64ArrayIterator = (o) => toArrayBufferViewIterator(Float64Array, o), toUint8ClampedArrayIterator = (o) => toArrayBufferViewIterator(Uint8ClampedArray, o);
function toArrayBufferViewAsyncIterator(o, E) {
  return __asyncGenerator(this, arguments, function* () {
    if (isPromise(E))
      return yield __await(yield __await(yield* __asyncDelegator(__asyncValues(toArrayBufferViewAsyncIterator(o, yield __await(E))))));
    const g = function(c) {
      return __asyncGenerator(this, arguments, function* () {
        yield yield __await(yield __await(c));
      });
    }, e = function(c) {
      return __asyncGenerator(this, arguments, function* () {
        yield __await(yield* __asyncDelegator(__asyncValues(pump$1((function* (n) {
          let h = null;
          do
            h = n.next(yield h?.value);
          while (!h.done);
        })(c[Symbol.iterator]())))));
      });
    }, t = typeof E == "string" || ArrayBuffer.isView(E) || E instanceof ArrayBuffer || E instanceof SharedArrayBuf ? g(E) : isIterable(E) ? e(E) : isAsyncIterable$1(E) ? E : g(E);
    return yield __await(
      // otherwise if AsyncIterable, use it
      yield* __asyncDelegator(__asyncValues(pump$1((function(c) {
        return __asyncGenerator(this, arguments, function* () {
          let n = null;
          do
            n = yield __await(c.next(yield yield __await(toArrayBufferView(o, n))));
          while (!n.done);
        });
      })(t[Symbol.asyncIterator]()))))
    ), yield __await(new o());
  });
}
const toInt8ArrayAsyncIterator = (o) => toArrayBufferViewAsyncIterator(Int8Array, o), toInt16ArrayAsyncIterator = (o) => toArrayBufferViewAsyncIterator(Int16Array, o), toInt32ArrayAsyncIterator = (o) => toArrayBufferViewAsyncIterator(Int32Array, o), toUint8ArrayAsyncIterator = (o) => toArrayBufferViewAsyncIterator(Uint8Array, o), toUint16ArrayAsyncIterator = (o) => toArrayBufferViewAsyncIterator(Uint16Array, o), toUint32ArrayAsyncIterator = (o) => toArrayBufferViewAsyncIterator(Uint32Array, o), toFloat32ArrayAsyncIterator = (o) => toArrayBufferViewAsyncIterator(Float32Array, o), toFloat64ArrayAsyncIterator = (o) => toArrayBufferViewAsyncIterator(Float64Array, o), toUint8ClampedArrayAsyncIterator = (o) => toArrayBufferViewAsyncIterator(Uint8ClampedArray, o);
function rebaseValueOffsets(o, E, A) {
  if (o !== 0) {
    A = A.slice(0, E);
    for (let g = -1, e = A.length; ++g < e; )
      A[g] += o;
  }
  return A.subarray(0, E);
}
function compareArrayLike(o, E) {
  let A = 0;
  const g = o.length;
  if (g !== E.length)
    return !1;
  if (g > 0)
    do
      if (o[A] !== E[A])
        return !1;
    while (++A < g);
  return !0;
}
const util_buffer_ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  compareArrayLike,
  joinUint8Arrays,
  memcpy,
  rebaseValueOffsets,
  toArrayBufferView,
  toArrayBufferViewAsyncIterator,
  toArrayBufferViewIterator,
  toBigInt64Array,
  toBigUint64Array,
  toFloat32Array,
  toFloat32ArrayAsyncIterator,
  toFloat32ArrayIterator,
  toFloat64Array,
  toFloat64ArrayAsyncIterator,
  toFloat64ArrayIterator,
  toInt16Array,
  toInt16ArrayAsyncIterator,
  toInt16ArrayIterator,
  toInt32Array,
  toInt32ArrayAsyncIterator,
  toInt32ArrayIterator,
  toInt8Array,
  toInt8ArrayAsyncIterator,
  toInt8ArrayIterator,
  toUint16Array,
  toUint16ArrayAsyncIterator,
  toUint16ArrayIterator,
  toUint32Array,
  toUint32ArrayAsyncIterator,
  toUint32ArrayIterator,
  toUint8Array,
  toUint8ArrayAsyncIterator,
  toUint8ArrayIterator,
  toUint8ClampedArray,
  toUint8ClampedArrayAsyncIterator,
  toUint8ClampedArrayIterator
}, Symbol.toStringTag, { value: "Module" })), streamAdapters = {
  fromIterable(o) {
    return pump(fromIterable(o));
  },
  fromAsyncIterable(o) {
    return pump(fromAsyncIterable(o));
  },
  fromDOMStream(o) {
    return pump(fromDOMStream(o));
  },
  fromNodeStream(o) {
    return pump(fromNodeStream(o));
  },
  // @ts-ignore
  toDOMStream(o, E) {
    throw new Error('"toDOMStream" not available in this environment');
  },
  // @ts-ignore
  toNodeStream(o, E) {
    throw new Error('"toNodeStream" not available in this environment');
  }
}, pump = (o) => (o.next(), o);
function* fromIterable(o) {
  let E, A = !1, g = [], e, t, c, n = 0;
  function h() {
    return t === "peek" ? joinUint8Arrays(g, c)[0] : ([e, g, n] = joinUint8Arrays(g, c), e);
  }
  ({ cmd: t, size: c } = (yield null) || { cmd: "read", size: 0 });
  const d = toUint8ArrayIterator(o)[Symbol.iterator]();
  try {
    do
      if ({ done: E, value: e } = Number.isNaN(c - n) ? d.next() : d.next(c - n), !E && e.byteLength > 0 && (g.push(e), n += e.byteLength), E || c <= n)
        do
          ({ cmd: t, size: c } = yield h());
        while (c < n);
    while (!E);
  } catch (k) {
    A = !0, typeof d.throw == "function" && d.throw(k);
  } finally {
    A === !1 && typeof d.return == "function" && d.return(null);
  }
  return null;
}
function fromAsyncIterable(o) {
  return __asyncGenerator(this, arguments, function* () {
    let A, g = !1, e = [], t, c, n, h = 0;
    function d() {
      return c === "peek" ? joinUint8Arrays(e, n)[0] : ([t, e, h] = joinUint8Arrays(e, n), t);
    }
    ({ cmd: c, size: n } = (yield yield __await(null)) || { cmd: "read", size: 0 });
    const k = toUint8ArrayAsyncIterator(o)[Symbol.asyncIterator]();
    try {
      do
        if ({ done: A, value: t } = Number.isNaN(n - h) ? yield __await(k.next()) : yield __await(k.next(n - h)), !A && t.byteLength > 0 && (e.push(t), h += t.byteLength), A || n <= h)
          do
            ({ cmd: c, size: n } = yield yield __await(d()));
          while (n < h);
      while (!A);
    } catch (p) {
      g = !0, typeof k.throw == "function" && (yield __await(k.throw(p)));
    } finally {
      g === !1 && typeof k.return == "function" && (yield __await(k.return(new Uint8Array(0))));
    }
    return yield __await(null);
  });
}
function fromDOMStream(o) {
  return __asyncGenerator(this, arguments, function* () {
    let A = !1, g = !1, e = [], t, c, n, h = 0;
    function d() {
      return c === "peek" ? joinUint8Arrays(e, n)[0] : ([t, e, h] = joinUint8Arrays(e, n), t);
    }
    ({ cmd: c, size: n } = (yield yield __await(null)) || { cmd: "read", size: 0 });
    const k = new AdaptiveByteReader(o);
    try {
      do
        if ({ done: A, value: t } = Number.isNaN(n - h) ? yield __await(k.read()) : yield __await(k.read(n - h)), !A && t.byteLength > 0 && (e.push(toUint8Array(t)), h += t.byteLength), A || n <= h)
          do
            ({ cmd: c, size: n } = yield yield __await(d()));
          while (n < h);
      while (!A);
    } catch (p) {
      g = !0, yield __await(k.cancel(p));
    } finally {
      g === !1 ? yield __await(k.cancel()) : o.locked && k.releaseLock();
    }
    return yield __await(null);
  });
}
class AdaptiveByteReader {
  constructor(E) {
    this.source = E, this.reader = null, this.reader = this.source.getReader(), this.reader.closed.catch(() => {
    });
  }
  get closed() {
    return this.reader ? this.reader.closed.catch(() => {
    }) : Promise.resolve();
  }
  releaseLock() {
    this.reader && this.reader.releaseLock(), this.reader = null;
  }
  cancel(E) {
    return __awaiter(this, void 0, void 0, function* () {
      const { reader: A, source: g } = this;
      A && (yield A.cancel(E).catch(() => {
      })), g && g.locked && this.releaseLock();
    });
  }
  read(E) {
    return __awaiter(this, void 0, void 0, function* () {
      if (E === 0)
        return { done: this.reader == null, value: new Uint8Array(0) };
      const A = yield this.reader.read();
      return !A.done && (A.value = toUint8Array(A)), A;
    });
  }
}
const onEvent = (o, E) => {
  const A = (e) => g([E, e]);
  let g;
  return [E, A, new Promise((e) => (g = e) && o.once(E, A))];
};
function fromNodeStream(o) {
  return __asyncGenerator(this, arguments, function* () {
    const A = [];
    let g = "error", e = !1, t = null, c, n, h = 0, d = [], k;
    function p() {
      return c === "peek" ? joinUint8Arrays(d, n)[0] : ([k, d, h] = joinUint8Arrays(d, n), k);
    }
    if ({ cmd: c, size: n } = (yield yield __await(null)) || { cmd: "read", size: 0 }, o.isTTY)
      return yield yield __await(new Uint8Array(0)), yield __await(null);
    try {
      A[0] = onEvent(o, "end"), A[1] = onEvent(o, "error");
      do {
        if (A[2] = onEvent(o, "readable"), [g, t] = yield __await(Promise.race(A.map((S) => S[2]))), g === "error")
          break;
        if ((e = g === "end") || (Number.isFinite(n - h) ? (k = toUint8Array(o.read(n - h)), k.byteLength < n - h && (k = toUint8Array(o.read()))) : k = toUint8Array(o.read()), k.byteLength > 0 && (d.push(k), h += k.byteLength)), e || n <= h)
          do
            ({ cmd: c, size: n } = yield yield __await(p()));
          while (n < h);
      } while (!e);
    } finally {
      yield __await(M(A, g === "error" ? t : null));
    }
    return yield __await(null);
    function M(S, AA) {
      return k = d = null, new Promise((H, gA) => {
        for (const [CA, IA] of S)
          o.off(CA, IA);
        try {
          const CA = o.destroy;
          CA && CA.call(o, AA), AA = void 0;
        } catch (CA) {
          AA = CA || AA;
        } finally {
          AA != null ? gA(AA) : H();
        }
      });
    }
  });
}
var MetadataVersion;
(function(o) {
  o[o.V1 = 0] = "V1", o[o.V2 = 1] = "V2", o[o.V3 = 2] = "V3", o[o.V4 = 3] = "V4", o[o.V5 = 4] = "V5";
})(MetadataVersion || (MetadataVersion = {}));
var UnionMode;
(function(o) {
  o[o.Sparse = 0] = "Sparse", o[o.Dense = 1] = "Dense";
})(UnionMode || (UnionMode = {}));
var Precision;
(function(o) {
  o[o.HALF = 0] = "HALF", o[o.SINGLE = 1] = "SINGLE", o[o.DOUBLE = 2] = "DOUBLE";
})(Precision || (Precision = {}));
var DateUnit;
(function(o) {
  o[o.DAY = 0] = "DAY", o[o.MILLISECOND = 1] = "MILLISECOND";
})(DateUnit || (DateUnit = {}));
var TimeUnit;
(function(o) {
  o[o.SECOND = 0] = "SECOND", o[o.MILLISECOND = 1] = "MILLISECOND", o[o.MICROSECOND = 2] = "MICROSECOND", o[o.NANOSECOND = 3] = "NANOSECOND";
})(TimeUnit || (TimeUnit = {}));
var IntervalUnit;
(function(o) {
  o[o.YEAR_MONTH = 0] = "YEAR_MONTH", o[o.DAY_TIME = 1] = "DAY_TIME", o[o.MONTH_DAY_NANO = 2] = "MONTH_DAY_NANO";
})(IntervalUnit || (IntervalUnit = {}));
const SIZEOF_SHORT = 2, SIZEOF_INT = 4, FILE_IDENTIFIER_LENGTH = 4, SIZE_PREFIX_LENGTH = 4, int32 = new Int32Array(2), float32 = new Float32Array(int32.buffer), float64 = new Float64Array(int32.buffer), isLittleEndian = new Uint16Array(new Uint8Array([1, 0]).buffer)[0] === 1;
var Encoding;
(function(o) {
  o[o.UTF8_BYTES = 1] = "UTF8_BYTES", o[o.UTF16_STRING = 2] = "UTF16_STRING";
})(Encoding || (Encoding = {}));
let ByteBuffer$2 = class GI {
  /**
   * Create a new ByteBuffer with a given array of bytes (`Uint8Array`)
   */
  constructor(E) {
    this.bytes_ = E, this.position_ = 0, this.text_decoder_ = new TextDecoder();
  }
  /**
   * Create and allocate a new ByteBuffer with a given size.
   */
  static allocate(E) {
    return new GI(new Uint8Array(E));
  }
  clear() {
    this.position_ = 0;
  }
  /**
   * Get the underlying `Uint8Array`.
   */
  bytes() {
    return this.bytes_;
  }
  /**
   * Get the buffer's position.
   */
  position() {
    return this.position_;
  }
  /**
   * Set the buffer's position.
   */
  setPosition(E) {
    this.position_ = E;
  }
  /**
   * Get the buffer's capacity.
   */
  capacity() {
    return this.bytes_.length;
  }
  readInt8(E) {
    return this.readUint8(E) << 24 >> 24;
  }
  readUint8(E) {
    return this.bytes_[E];
  }
  readInt16(E) {
    return this.readUint16(E) << 16 >> 16;
  }
  readUint16(E) {
    return this.bytes_[E] | this.bytes_[E + 1] << 8;
  }
  readInt32(E) {
    return this.bytes_[E] | this.bytes_[E + 1] << 8 | this.bytes_[E + 2] << 16 | this.bytes_[E + 3] << 24;
  }
  readUint32(E) {
    return this.readInt32(E) >>> 0;
  }
  readInt64(E) {
    return BigInt.asIntN(64, BigInt(this.readUint32(E)) + (BigInt(this.readUint32(E + 4)) << BigInt(32)));
  }
  readUint64(E) {
    return BigInt.asUintN(64, BigInt(this.readUint32(E)) + (BigInt(this.readUint32(E + 4)) << BigInt(32)));
  }
  readFloat32(E) {
    return int32[0] = this.readInt32(E), float32[0];
  }
  readFloat64(E) {
    return int32[isLittleEndian ? 0 : 1] = this.readInt32(E), int32[isLittleEndian ? 1 : 0] = this.readInt32(E + 4), float64[0];
  }
  writeInt8(E, A) {
    this.bytes_[E] = A;
  }
  writeUint8(E, A) {
    this.bytes_[E] = A;
  }
  writeInt16(E, A) {
    this.bytes_[E] = A, this.bytes_[E + 1] = A >> 8;
  }
  writeUint16(E, A) {
    this.bytes_[E] = A, this.bytes_[E + 1] = A >> 8;
  }
  writeInt32(E, A) {
    this.bytes_[E] = A, this.bytes_[E + 1] = A >> 8, this.bytes_[E + 2] = A >> 16, this.bytes_[E + 3] = A >> 24;
  }
  writeUint32(E, A) {
    this.bytes_[E] = A, this.bytes_[E + 1] = A >> 8, this.bytes_[E + 2] = A >> 16, this.bytes_[E + 3] = A >> 24;
  }
  writeInt64(E, A) {
    this.writeInt32(E, Number(BigInt.asIntN(32, A))), this.writeInt32(E + 4, Number(BigInt.asIntN(32, A >> BigInt(32))));
  }
  writeUint64(E, A) {
    this.writeUint32(E, Number(BigInt.asUintN(32, A))), this.writeUint32(E + 4, Number(BigInt.asUintN(32, A >> BigInt(32))));
  }
  writeFloat32(E, A) {
    float32[0] = A, this.writeInt32(E, int32[0]);
  }
  writeFloat64(E, A) {
    float64[0] = A, this.writeInt32(E, int32[isLittleEndian ? 0 : 1]), this.writeInt32(E + 4, int32[isLittleEndian ? 1 : 0]);
  }
  /**
   * Return the file identifier.   Behavior is undefined for FlatBuffers whose
   * schema does not include a file_identifier (likely points at padding or the
   * start of a the root vtable).
   */
  getBufferIdentifier() {
    if (this.bytes_.length < this.position_ + SIZEOF_INT + FILE_IDENTIFIER_LENGTH)
      throw new Error("FlatBuffers: ByteBuffer is too short to contain an identifier.");
    let E = "";
    for (let A = 0; A < FILE_IDENTIFIER_LENGTH; A++)
      E += String.fromCharCode(this.readInt8(this.position_ + SIZEOF_INT + A));
    return E;
  }
  /**
   * Look up a field in the vtable, return an offset into the object, or 0 if the
   * field is not present.
   */
  __offset(E, A) {
    const g = E - this.readInt32(E);
    return A < this.readInt16(g) ? this.readInt16(g + A) : 0;
  }
  /**
   * Initialize any Table-derived type to point to the union at the given offset.
   */
  __union(E, A) {
    return E.bb_pos = A + this.readInt32(A), E.bb = this, E;
  }
  /**
   * Create a JavaScript string from UTF-8 data stored inside the FlatBuffer.
   * This allocates a new string and converts to wide chars upon each access.
   *
   * To avoid the conversion to string, pass Encoding.UTF8_BYTES as the
   * "optionalEncoding" argument. This is useful for avoiding conversion when
   * the data will just be packaged back up in another FlatBuffer later on.
   *
   * @param offset
   * @param opt_encoding Defaults to UTF16_STRING
   */
  __string(E, A) {
    E += this.readInt32(E);
    const g = this.readInt32(E);
    E += SIZEOF_INT;
    const e = this.bytes_.subarray(E, E + g);
    return A === Encoding.UTF8_BYTES ? e : this.text_decoder_.decode(e);
  }
  /**
   * Handle unions that can contain string as its member, if a Table-derived type then initialize it,
   * if a string then return a new one
   *
   * WARNING: strings are immutable in JS so we can't change the string that the user gave us, this
   * makes the behaviour of __union_with_string different compared to __union
   */
  __union_with_string(E, A) {
    return typeof E == "string" ? this.__string(A) : this.__union(E, A);
  }
  /**
   * Retrieve the relative offset stored at "offset"
   */
  __indirect(E) {
    return E + this.readInt32(E);
  }
  /**
   * Get the start of data of a vector whose offset is stored at "offset" in this object.
   */
  __vector(E) {
    return E + this.readInt32(E) + SIZEOF_INT;
  }
  /**
   * Get the length of a vector whose offset is stored at "offset" in this object.
   */
  __vector_len(E) {
    return this.readInt32(E + this.readInt32(E));
  }
  __has_identifier(E) {
    if (E.length != FILE_IDENTIFIER_LENGTH)
      throw new Error("FlatBuffers: file identifier must be length " + FILE_IDENTIFIER_LENGTH);
    for (let A = 0; A < FILE_IDENTIFIER_LENGTH; A++)
      if (E.charCodeAt(A) != this.readInt8(this.position() + SIZEOF_INT + A))
        return !1;
    return !0;
  }
  /**
   * A helper function for generating list for obj api
   */
  createScalarList(E, A) {
    const g = [];
    for (let e = 0; e < A; ++e) {
      const t = E(e);
      t !== null && g.push(t);
    }
    return g;
  }
  /**
   * A helper function for generating list for obj api
   * @param listAccessor function that accepts an index and return data at that index
   * @param listLength listLength
   * @param res result list
   */
  createObjList(E, A) {
    const g = [];
    for (let e = 0; e < A; ++e) {
      const t = E(e);
      t !== null && g.push(t.unpack());
    }
    return g;
  }
}, Builder$2 = class lI {
  /**
   * Create a FlatBufferBuilder.
   */
  constructor(E) {
    this.minalign = 1, this.vtable = null, this.vtable_in_use = 0, this.isNested = !1, this.object_start = 0, this.vtables = [], this.vector_num_elems = 0, this.force_defaults = !1, this.string_maps = null, this.text_encoder = new TextEncoder();
    let A;
    E ? A = E : A = 1024, this.bb = ByteBuffer$2.allocate(A), this.space = A;
  }
  clear() {
    this.bb.clear(), this.space = this.bb.capacity(), this.minalign = 1, this.vtable = null, this.vtable_in_use = 0, this.isNested = !1, this.object_start = 0, this.vtables = [], this.vector_num_elems = 0, this.force_defaults = !1, this.string_maps = null;
  }
  /**
   * In order to save space, fields that are set to their default value
   * don't get serialized into the buffer. Forcing defaults provides a
   * way to manually disable this optimization.
   *
   * @param forceDefaults true always serializes default values
   */
  forceDefaults(E) {
    this.force_defaults = E;
  }
  /**
   * Get the ByteBuffer representing the FlatBuffer. Only call this after you've
   * called finish(). The actual data starts at the ByteBuffer's current position,
   * not necessarily at 0.
   */
  dataBuffer() {
    return this.bb;
  }
  /**
   * Get the bytes representing the FlatBuffer. Only call this after you've
   * called finish().
   */
  asUint8Array() {
    return this.bb.bytes().subarray(this.bb.position(), this.bb.position() + this.offset());
  }
  /**
   * Prepare to write an element of `size` after `additional_bytes` have been
   * written, e.g. if you write a string, you need to align such the int length
   * field is aligned to 4 bytes, and the string data follows it directly. If all
   * you need to do is alignment, `additional_bytes` will be 0.
   *
   * @param size This is the of the new element to write
   * @param additional_bytes The padding size
   */
  prep(E, A) {
    E > this.minalign && (this.minalign = E);
    const g = ~(this.bb.capacity() - this.space + A) + 1 & E - 1;
    for (; this.space < g + E + A; ) {
      const e = this.bb.capacity();
      this.bb = lI.growByteBuffer(this.bb), this.space += this.bb.capacity() - e;
    }
    this.pad(g);
  }
  pad(E) {
    for (let A = 0; A < E; A++)
      this.bb.writeInt8(--this.space, 0);
  }
  writeInt8(E) {
    this.bb.writeInt8(this.space -= 1, E);
  }
  writeInt16(E) {
    this.bb.writeInt16(this.space -= 2, E);
  }
  writeInt32(E) {
    this.bb.writeInt32(this.space -= 4, E);
  }
  writeInt64(E) {
    this.bb.writeInt64(this.space -= 8, E);
  }
  writeFloat32(E) {
    this.bb.writeFloat32(this.space -= 4, E);
  }
  writeFloat64(E) {
    this.bb.writeFloat64(this.space -= 8, E);
  }
  /**
   * Add an `int8` to the buffer, properly aligned, and grows the buffer (if necessary).
   * @param value The `int8` to add the buffer.
   */
  addInt8(E) {
    this.prep(1, 0), this.writeInt8(E);
  }
  /**
   * Add an `int16` to the buffer, properly aligned, and grows the buffer (if necessary).
   * @param value The `int16` to add the buffer.
   */
  addInt16(E) {
    this.prep(2, 0), this.writeInt16(E);
  }
  /**
   * Add an `int32` to the buffer, properly aligned, and grows the buffer (if necessary).
   * @param value The `int32` to add the buffer.
   */
  addInt32(E) {
    this.prep(4, 0), this.writeInt32(E);
  }
  /**
   * Add an `int64` to the buffer, properly aligned, and grows the buffer (if necessary).
   * @param value The `int64` to add the buffer.
   */
  addInt64(E) {
    this.prep(8, 0), this.writeInt64(E);
  }
  /**
   * Add a `float32` to the buffer, properly aligned, and grows the buffer (if necessary).
   * @param value The `float32` to add the buffer.
   */
  addFloat32(E) {
    this.prep(4, 0), this.writeFloat32(E);
  }
  /**
   * Add a `float64` to the buffer, properly aligned, and grows the buffer (if necessary).
   * @param value The `float64` to add the buffer.
   */
  addFloat64(E) {
    this.prep(8, 0), this.writeFloat64(E);
  }
  addFieldInt8(E, A, g) {
    (this.force_defaults || A != g) && (this.addInt8(A), this.slot(E));
  }
  addFieldInt16(E, A, g) {
    (this.force_defaults || A != g) && (this.addInt16(A), this.slot(E));
  }
  addFieldInt32(E, A, g) {
    (this.force_defaults || A != g) && (this.addInt32(A), this.slot(E));
  }
  addFieldInt64(E, A, g) {
    (this.force_defaults || A !== g) && (this.addInt64(A), this.slot(E));
  }
  addFieldFloat32(E, A, g) {
    (this.force_defaults || A != g) && (this.addFloat32(A), this.slot(E));
  }
  addFieldFloat64(E, A, g) {
    (this.force_defaults || A != g) && (this.addFloat64(A), this.slot(E));
  }
  addFieldOffset(E, A, g) {
    (this.force_defaults || A != g) && (this.addOffset(A), this.slot(E));
  }
  /**
   * Structs are stored inline, so nothing additional is being added. `d` is always 0.
   */
  addFieldStruct(E, A, g) {
    A != g && (this.nested(A), this.slot(E));
  }
  /**
   * Structures are always stored inline, they need to be created right
   * where they're used.  You'll get this assertion failure if you
   * created it elsewhere.
   */
  nested(E) {
    if (E != this.offset())
      throw new TypeError("FlatBuffers: struct must be serialized inline.");
  }
  /**
   * Should not be creating any other object, string or vector
   * while an object is being constructed
   */
  notNested() {
    if (this.isNested)
      throw new TypeError("FlatBuffers: object serialization must not be nested.");
  }
  /**
   * Set the current vtable at `voffset` to the current location in the buffer.
   */
  slot(E) {
    this.vtable !== null && (this.vtable[E] = this.offset());
  }
  /**
   * @returns Offset relative to the end of the buffer.
   */
  offset() {
    return this.bb.capacity() - this.space;
  }
  /**
   * Doubles the size of the backing ByteBuffer and copies the old data towards
   * the end of the new buffer (since we build the buffer backwards).
   *
   * @param bb The current buffer with the existing data
   * @returns A new byte buffer with the old data copied
   * to it. The data is located at the end of the buffer.
   *
   * uint8Array.set() formally takes {Array<number>|ArrayBufferView}, so to pass
   * it a uint8Array we need to suppress the type check:
   * @suppress {checkTypes}
   */
  static growByteBuffer(E) {
    const A = E.capacity();
    if (A & 3221225472)
      throw new Error("FlatBuffers: cannot grow buffer beyond 2 gigabytes.");
    const g = A << 1, e = ByteBuffer$2.allocate(g);
    return e.setPosition(g - A), e.bytes().set(E.bytes(), g - A), e;
  }
  /**
   * Adds on offset, relative to where it will be written.
   *
   * @param offset The offset to add.
   */
  addOffset(E) {
    this.prep(SIZEOF_INT, 0), this.writeInt32(this.offset() - E + SIZEOF_INT);
  }
  /**
   * Start encoding a new object in the buffer.  Users will not usually need to
   * call this directly. The FlatBuffers compiler will generate helper methods
   * that call this method internally.
   */
  startObject(E) {
    this.notNested(), this.vtable == null && (this.vtable = []), this.vtable_in_use = E;
    for (let A = 0; A < E; A++)
      this.vtable[A] = 0;
    this.isNested = !0, this.object_start = this.offset();
  }
  /**
   * Finish off writing the object that is under construction.
   *
   * @returns The offset to the object inside `dataBuffer`
   */
  endObject() {
    if (this.vtable == null || !this.isNested)
      throw new Error("FlatBuffers: endObject called without startObject");
    this.addInt32(0);
    const E = this.offset();
    let A = this.vtable_in_use - 1;
    for (; A >= 0 && this.vtable[A] == 0; A--)
      ;
    const g = A + 1;
    for (; A >= 0; A--)
      this.addInt16(this.vtable[A] != 0 ? E - this.vtable[A] : 0);
    const e = 2;
    this.addInt16(E - this.object_start);
    const t = (g + e) * SIZEOF_SHORT;
    this.addInt16(t);
    let c = 0;
    const n = this.space;
    A: for (A = 0; A < this.vtables.length; A++) {
      const h = this.bb.capacity() - this.vtables[A];
      if (t == this.bb.readInt16(h)) {
        for (let d = SIZEOF_SHORT; d < t; d += SIZEOF_SHORT)
          if (this.bb.readInt16(n + d) != this.bb.readInt16(h + d))
            continue A;
        c = this.vtables[A];
        break;
      }
    }
    return c ? (this.space = this.bb.capacity() - E, this.bb.writeInt32(this.space, c - E)) : (this.vtables.push(this.offset()), this.bb.writeInt32(this.bb.capacity() - E, this.offset() - E)), this.isNested = !1, E;
  }
  /**
   * Finalize a buffer, poiting to the given `root_table`.
   */
  finish(E, A, g) {
    const e = g ? SIZE_PREFIX_LENGTH : 0;
    if (A) {
      const t = A;
      if (this.prep(this.minalign, SIZEOF_INT + FILE_IDENTIFIER_LENGTH + e), t.length != FILE_IDENTIFIER_LENGTH)
        throw new TypeError("FlatBuffers: file identifier must be length " + FILE_IDENTIFIER_LENGTH);
      for (let c = FILE_IDENTIFIER_LENGTH - 1; c >= 0; c--)
        this.writeInt8(t.charCodeAt(c));
    }
    this.prep(this.minalign, SIZEOF_INT + e), this.addOffset(E), e && this.addInt32(this.bb.capacity() - this.space), this.bb.setPosition(this.space);
  }
  /**
   * Finalize a size prefixed buffer, pointing to the given `root_table`.
   */
  finishSizePrefixed(E, A) {
    this.finish(E, A, !0);
  }
  /**
   * This checks a required field has been set in a given table that has
   * just been constructed.
   */
  requiredField(E, A) {
    const g = this.bb.capacity() - E, e = g - this.bb.readInt32(g);
    if (!(A < this.bb.readInt16(e) && this.bb.readInt16(e + A) != 0))
      throw new TypeError("FlatBuffers: field " + A + " must be set");
  }
  /**
   * Start a new array/vector of objects.  Users usually will not call
   * this directly. The FlatBuffers compiler will create a start/end
   * method for vector types in generated code.
   *
   * @param elem_size The size of each element in the array
   * @param num_elems The number of elements in the array
   * @param alignment The alignment of the array
   */
  startVector(E, A, g) {
    this.notNested(), this.vector_num_elems = A, this.prep(SIZEOF_INT, E * A), this.prep(g, E * A);
  }
  /**
   * Finish off the creation of an array and all its elements. The array must be
   * created with `startVector`.
   *
   * @returns The offset at which the newly created array
   * starts.
   */
  endVector() {
    return this.writeInt32(this.vector_num_elems), this.offset();
  }
  /**
   * Encode the string `s` in the buffer using UTF-8. If the string passed has
   * already been seen, we return the offset of the already written string
   *
   * @param s The string to encode
   * @return The offset in the buffer where the encoded string starts
   */
  createSharedString(E) {
    if (!E)
      return 0;
    if (this.string_maps || (this.string_maps = /* @__PURE__ */ new Map()), this.string_maps.has(E))
      return this.string_maps.get(E);
    const A = this.createString(E);
    return this.string_maps.set(E, A), A;
  }
  /**
   * Encode the string `s` in the buffer using UTF-8. If a Uint8Array is passed
   * instead of a string, it is assumed to contain valid UTF-8 encoded data.
   *
   * @param s The string to encode
   * @return The offset in the buffer where the encoded string starts
   */
  createString(E) {
    if (E == null)
      return 0;
    let A;
    return E instanceof Uint8Array ? A = E : A = this.text_encoder.encode(E), this.addInt8(0), this.startVector(1, A.length, 1), this.bb.setPosition(this.space -= A.length), this.bb.bytes().set(A, this.space), this.endVector();
  }
  /**
   * Create a byte vector.
   *
   * @param v The bytes to add
   * @returns The offset in the buffer where the byte vector starts
   */
  createByteVector(E) {
    return E == null ? 0 : (this.startVector(1, E.length, 1), this.bb.setPosition(this.space -= E.length), this.bb.bytes().set(E, this.space), this.endVector());
  }
  /**
   * A helper function to pack an object
   *
   * @returns offset of obj
   */
  createObjectOffset(E) {
    return E === null ? 0 : typeof E == "string" ? this.createString(E) : E.pack(this);
  }
  /**
   * A helper function to pack a list of object
   *
   * @returns list of offsets of each non null object
   */
  createObjectOffsetList(E) {
    const A = [];
    for (let g = 0; g < E.length; ++g) {
      const e = E[g];
      if (e !== null)
        A.push(this.createObjectOffset(e));
      else
        throw new TypeError("FlatBuffers: Argument for createObjectOffsetList cannot contain null.");
    }
    return A;
  }
  createStructOffsetList(E, A) {
    return A(this, E.length), this.createObjectOffsetList(E.slice().reverse()), this.endVector();
  }
};
var BodyCompressionMethod;
(function(o) {
  o[o.BUFFER = 0] = "BUFFER";
})(BodyCompressionMethod || (BodyCompressionMethod = {}));
var CompressionType;
(function(o) {
  o[o.LZ4_FRAME = 0] = "LZ4_FRAME", o[o.ZSTD = 1] = "ZSTD";
})(CompressionType || (CompressionType = {}));
let BodyCompression$1 = class Hg {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(E, A) {
    return this.bb_pos = E, this.bb = A, this;
  }
  static getRootAsBodyCompression(E, A) {
    return (A || new Hg()).__init(E.readInt32(E.position()) + E.position(), E);
  }
  static getSizePrefixedRootAsBodyCompression(E, A) {
    return E.setPosition(E.position() + SIZE_PREFIX_LENGTH), (A || new Hg()).__init(E.readInt32(E.position()) + E.position(), E);
  }
  /**
   * Compressor library.
   * For LZ4_FRAME, each compressed buffer must consist of a single frame.
   */
  codec() {
    const E = this.bb.__offset(this.bb_pos, 4);
    return E ? this.bb.readInt8(this.bb_pos + E) : CompressionType.LZ4_FRAME;
  }
  /**
   * Indicates the way the record batch body was compressed
   */
  method() {
    const E = this.bb.__offset(this.bb_pos, 6);
    return E ? this.bb.readInt8(this.bb_pos + E) : BodyCompressionMethod.BUFFER;
  }
  static startBodyCompression(E) {
    E.startObject(2);
  }
  static addCodec(E, A) {
    E.addFieldInt8(0, A, CompressionType.LZ4_FRAME);
  }
  static addMethod(E, A) {
    E.addFieldInt8(1, A, BodyCompressionMethod.BUFFER);
  }
  static endBodyCompression(E) {
    return E.endObject();
  }
  static createBodyCompression(E, A, g) {
    return Hg.startBodyCompression(E), Hg.addCodec(E, A), Hg.addMethod(E, g), Hg.endBodyCompression(E);
  }
}, Buffer$1 = class {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(E, A) {
    return this.bb_pos = E, this.bb = A, this;
  }
  /**
   * The relative offset into the shared memory page where the bytes for this
   * buffer starts
   */
  offset() {
    return this.bb.readInt64(this.bb_pos);
  }
  /**
   * The absolute length (in bytes) of the memory buffer. The memory is found
   * from offset (inclusive) to offset + length (non-inclusive). When building
   * messages using the encapsulated IPC message, padding bytes may be written
   * after a buffer, but such padding bytes do not need to be accounted for in
   * the size here.
   */
  length() {
    return this.bb.readInt64(this.bb_pos + 8);
  }
  static sizeOf() {
    return 16;
  }
  static createBuffer(E, A, g) {
    return E.prep(8, 16), E.writeInt64(BigInt(g ?? 0)), E.writeInt64(BigInt(A ?? 0)), E.offset();
  }
}, FieldNode$1 = class {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(E, A) {
    return this.bb_pos = E, this.bb = A, this;
  }
  /**
   * The number of value slots in the Arrow array at this level of a nested
   * tree
   */
  length() {
    return this.bb.readInt64(this.bb_pos);
  }
  /**
   * The number of observed nulls. Fields with null_count == 0 may choose not
   * to write their physical validity bitmap out as a materialized buffer,
   * instead setting the length of the bitmap buffer to 0.
   */
  nullCount() {
    return this.bb.readInt64(this.bb_pos + 8);
  }
  static sizeOf() {
    return 16;
  }
  static createFieldNode(E, A, g) {
    return E.prep(8, 16), E.writeInt64(BigInt(g ?? 0)), E.writeInt64(BigInt(A ?? 0)), E.offset();
  }
}, RecordBatch$3 = class iI {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(E, A) {
    return this.bb_pos = E, this.bb = A, this;
  }
  static getRootAsRecordBatch(E, A) {
    return (A || new iI()).__init(E.readInt32(E.position()) + E.position(), E);
  }
  static getSizePrefixedRootAsRecordBatch(E, A) {
    return E.setPosition(E.position() + SIZE_PREFIX_LENGTH), (A || new iI()).__init(E.readInt32(E.position()) + E.position(), E);
  }
  /**
   * number of records / rows. The arrays in the batch should all have this
   * length
   */
  length() {
    const E = this.bb.__offset(this.bb_pos, 4);
    return E ? this.bb.readInt64(this.bb_pos + E) : BigInt("0");
  }
  /**
   * Nodes correspond to the pre-ordered flattened logical schema
   */
  nodes(E, A) {
    const g = this.bb.__offset(this.bb_pos, 6);
    return g ? (A || new FieldNode$1()).__init(this.bb.__vector(this.bb_pos + g) + E * 16, this.bb) : null;
  }
  nodesLength() {
    const E = this.bb.__offset(this.bb_pos, 6);
    return E ? this.bb.__vector_len(this.bb_pos + E) : 0;
  }
  /**
   * Buffers correspond to the pre-ordered flattened buffer tree
   *
   * The number of buffers appended to this list depends on the schema. For
   * example, most primitive arrays will have 2 buffers, 1 for the validity
   * bitmap and 1 for the values. For struct arrays, there will only be a
   * single buffer for the validity (nulls) bitmap
   */
  buffers(E, A) {
    const g = this.bb.__offset(this.bb_pos, 8);
    return g ? (A || new Buffer$1()).__init(this.bb.__vector(this.bb_pos + g) + E * 16, this.bb) : null;
  }
  buffersLength() {
    const E = this.bb.__offset(this.bb_pos, 8);
    return E ? this.bb.__vector_len(this.bb_pos + E) : 0;
  }
  /**
   * Optional compression of the message body
   */
  compression(E) {
    const A = this.bb.__offset(this.bb_pos, 10);
    return A ? (E || new BodyCompression$1()).__init(this.bb.__indirect(this.bb_pos + A), this.bb) : null;
  }
  static startRecordBatch(E) {
    E.startObject(4);
  }
  static addLength(E, A) {
    E.addFieldInt64(0, A, BigInt("0"));
  }
  static addNodes(E, A) {
    E.addFieldOffset(1, A, 0);
  }
  static startNodesVector(E, A) {
    E.startVector(16, A, 8);
  }
  static addBuffers(E, A) {
    E.addFieldOffset(2, A, 0);
  }
  static startBuffersVector(E, A) {
    E.startVector(16, A, 8);
  }
  static addCompression(E, A) {
    E.addFieldOffset(3, A, 0);
  }
  static endRecordBatch(E) {
    return E.endObject();
  }
}, DictionaryBatch$1 = class oI {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(E, A) {
    return this.bb_pos = E, this.bb = A, this;
  }
  static getRootAsDictionaryBatch(E, A) {
    return (A || new oI()).__init(E.readInt32(E.position()) + E.position(), E);
  }
  static getSizePrefixedRootAsDictionaryBatch(E, A) {
    return E.setPosition(E.position() + SIZE_PREFIX_LENGTH), (A || new oI()).__init(E.readInt32(E.position()) + E.position(), E);
  }
  id() {
    const E = this.bb.__offset(this.bb_pos, 4);
    return E ? this.bb.readInt64(this.bb_pos + E) : BigInt("0");
  }
  data(E) {
    const A = this.bb.__offset(this.bb_pos, 6);
    return A ? (E || new RecordBatch$3()).__init(this.bb.__indirect(this.bb_pos + A), this.bb) : null;
  }
  /**
   * If isDelta is true the values in the dictionary are to be appended to a
   * dictionary with the indicated id. If isDelta is false this dictionary
   * should replace the existing dictionary.
   */
  isDelta() {
    const E = this.bb.__offset(this.bb_pos, 8);
    return E ? !!this.bb.readInt8(this.bb_pos + E) : !1;
  }
  static startDictionaryBatch(E) {
    E.startObject(3);
  }
  static addId(E, A) {
    E.addFieldInt64(0, A, BigInt("0"));
  }
  static addData(E, A) {
    E.addFieldOffset(1, A, 0);
  }
  static addIsDelta(E, A) {
    E.addFieldInt8(2, +A, 0);
  }
  static endDictionaryBatch(E) {
    return E.endObject();
  }
};
var Endianness;
(function(o) {
  o[o.Little = 0] = "Little", o[o.Big = 1] = "Big";
})(Endianness || (Endianness = {}));
var DictionaryKind;
(function(o) {
  o[o.DenseArray = 0] = "DenseArray";
})(DictionaryKind || (DictionaryKind = {}));
class Int {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(E, A) {
    return this.bb_pos = E, this.bb = A, this;
  }
  static getRootAsInt(E, A) {
    return (A || new Int()).__init(E.readInt32(E.position()) + E.position(), E);
  }
  static getSizePrefixedRootAsInt(E, A) {
    return E.setPosition(E.position() + SIZE_PREFIX_LENGTH), (A || new Int()).__init(E.readInt32(E.position()) + E.position(), E);
  }
  bitWidth() {
    const E = this.bb.__offset(this.bb_pos, 4);
    return E ? this.bb.readInt32(this.bb_pos + E) : 0;
  }
  isSigned() {
    const E = this.bb.__offset(this.bb_pos, 6);
    return E ? !!this.bb.readInt8(this.bb_pos + E) : !1;
  }
  static startInt(E) {
    E.startObject(2);
  }
  static addBitWidth(E, A) {
    E.addFieldInt32(0, A, 0);
  }
  static addIsSigned(E, A) {
    E.addFieldInt8(1, +A, 0);
  }
  static endInt(E) {
    return E.endObject();
  }
  static createInt(E, A, g) {
    return Int.startInt(E), Int.addBitWidth(E, A), Int.addIsSigned(E, g), Int.endInt(E);
  }
}
class DictionaryEncoding {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(E, A) {
    return this.bb_pos = E, this.bb = A, this;
  }
  static getRootAsDictionaryEncoding(E, A) {
    return (A || new DictionaryEncoding()).__init(E.readInt32(E.position()) + E.position(), E);
  }
  static getSizePrefixedRootAsDictionaryEncoding(E, A) {
    return E.setPosition(E.position() + SIZE_PREFIX_LENGTH), (A || new DictionaryEncoding()).__init(E.readInt32(E.position()) + E.position(), E);
  }
  /**
   * The known dictionary id in the application where this data is used. In
   * the file or streaming formats, the dictionary ids are found in the
   * DictionaryBatch messages
   */
  id() {
    const E = this.bb.__offset(this.bb_pos, 4);
    return E ? this.bb.readInt64(this.bb_pos + E) : BigInt("0");
  }
  /**
   * The dictionary indices are constrained to be non-negative integers. If
   * this field is null, the indices must be signed int32. To maximize
   * cross-language compatibility and performance, implementations are
   * recommended to prefer signed integer types over unsigned integer types
   * and to avoid uint64 indices unless they are required by an application.
   */
  indexType(E) {
    const A = this.bb.__offset(this.bb_pos, 6);
    return A ? (E || new Int()).__init(this.bb.__indirect(this.bb_pos + A), this.bb) : null;
  }
  /**
   * By default, dictionaries are not ordered, or the order does not have
   * semantic meaning. In some statistical, applications, dictionary-encoding
   * is used to represent ordered categorical data, and we provide a way to
   * preserve that metadata here
   */
  isOrdered() {
    const E = this.bb.__offset(this.bb_pos, 8);
    return E ? !!this.bb.readInt8(this.bb_pos + E) : !1;
  }
  dictionaryKind() {
    const E = this.bb.__offset(this.bb_pos, 10);
    return E ? this.bb.readInt16(this.bb_pos + E) : DictionaryKind.DenseArray;
  }
  static startDictionaryEncoding(E) {
    E.startObject(4);
  }
  static addId(E, A) {
    E.addFieldInt64(0, A, BigInt("0"));
  }
  static addIndexType(E, A) {
    E.addFieldOffset(1, A, 0);
  }
  static addIsOrdered(E, A) {
    E.addFieldInt8(2, +A, 0);
  }
  static addDictionaryKind(E, A) {
    E.addFieldInt16(3, A, DictionaryKind.DenseArray);
  }
  static endDictionaryEncoding(E) {
    return E.endObject();
  }
}
class KeyValue {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(E, A) {
    return this.bb_pos = E, this.bb = A, this;
  }
  static getRootAsKeyValue(E, A) {
    return (A || new KeyValue()).__init(E.readInt32(E.position()) + E.position(), E);
  }
  static getSizePrefixedRootAsKeyValue(E, A) {
    return E.setPosition(E.position() + SIZE_PREFIX_LENGTH), (A || new KeyValue()).__init(E.readInt32(E.position()) + E.position(), E);
  }
  key(E) {
    const A = this.bb.__offset(this.bb_pos, 4);
    return A ? this.bb.__string(this.bb_pos + A, E) : null;
  }
  value(E) {
    const A = this.bb.__offset(this.bb_pos, 6);
    return A ? this.bb.__string(this.bb_pos + A, E) : null;
  }
  static startKeyValue(E) {
    E.startObject(2);
  }
  static addKey(E, A) {
    E.addFieldOffset(0, A, 0);
  }
  static addValue(E, A) {
    E.addFieldOffset(1, A, 0);
  }
  static endKeyValue(E) {
    return E.endObject();
  }
  static createKeyValue(E, A, g) {
    return KeyValue.startKeyValue(E), KeyValue.addKey(E, A), KeyValue.addValue(E, g), KeyValue.endKeyValue(E);
  }
}
let Binary$1 = class vg {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(E, A) {
    return this.bb_pos = E, this.bb = A, this;
  }
  static getRootAsBinary(E, A) {
    return (A || new vg()).__init(E.readInt32(E.position()) + E.position(), E);
  }
  static getSizePrefixedRootAsBinary(E, A) {
    return E.setPosition(E.position() + SIZE_PREFIX_LENGTH), (A || new vg()).__init(E.readInt32(E.position()) + E.position(), E);
  }
  static startBinary(E) {
    E.startObject(0);
  }
  static endBinary(E) {
    return E.endObject();
  }
  static createBinary(E) {
    return vg.startBinary(E), vg.endBinary(E);
  }
}, Bool$1 = class jg {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(E, A) {
    return this.bb_pos = E, this.bb = A, this;
  }
  static getRootAsBool(E, A) {
    return (A || new jg()).__init(E.readInt32(E.position()) + E.position(), E);
  }
  static getSizePrefixedRootAsBool(E, A) {
    return E.setPosition(E.position() + SIZE_PREFIX_LENGTH), (A || new jg()).__init(E.readInt32(E.position()) + E.position(), E);
  }
  static startBool(E) {
    E.startObject(0);
  }
  static endBool(E) {
    return E.endObject();
  }
  static createBool(E) {
    return jg.startBool(E), jg.endBool(E);
  }
}, Date$1 = class Kg {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(E, A) {
    return this.bb_pos = E, this.bb = A, this;
  }
  static getRootAsDate(E, A) {
    return (A || new Kg()).__init(E.readInt32(E.position()) + E.position(), E);
  }
  static getSizePrefixedRootAsDate(E, A) {
    return E.setPosition(E.position() + SIZE_PREFIX_LENGTH), (A || new Kg()).__init(E.readInt32(E.position()) + E.position(), E);
  }
  unit() {
    const E = this.bb.__offset(this.bb_pos, 4);
    return E ? this.bb.readInt16(this.bb_pos + E) : DateUnit.MILLISECOND;
  }
  static startDate(E) {
    E.startObject(1);
  }
  static addUnit(E, A) {
    E.addFieldInt16(0, A, DateUnit.MILLISECOND);
  }
  static endDate(E) {
    return E.endObject();
  }
  static createDate(E, A) {
    return Kg.startDate(E), Kg.addUnit(E, A), Kg.endDate(E);
  }
}, Decimal$1 = class Mg {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(E, A) {
    return this.bb_pos = E, this.bb = A, this;
  }
  static getRootAsDecimal(E, A) {
    return (A || new Mg()).__init(E.readInt32(E.position()) + E.position(), E);
  }
  static getSizePrefixedRootAsDecimal(E, A) {
    return E.setPosition(E.position() + SIZE_PREFIX_LENGTH), (A || new Mg()).__init(E.readInt32(E.position()) + E.position(), E);
  }
  /**
   * Total number of decimal digits
   */
  precision() {
    const E = this.bb.__offset(this.bb_pos, 4);
    return E ? this.bb.readInt32(this.bb_pos + E) : 0;
  }
  /**
   * Number of digits after the decimal point "."
   */
  scale() {
    const E = this.bb.__offset(this.bb_pos, 6);
    return E ? this.bb.readInt32(this.bb_pos + E) : 0;
  }
  /**
   * Number of bits per value. The only accepted widths are 128 and 256.
   * We use bitWidth for consistency with Int::bitWidth.
   */
  bitWidth() {
    const E = this.bb.__offset(this.bb_pos, 8);
    return E ? this.bb.readInt32(this.bb_pos + E) : 128;
  }
  static startDecimal(E) {
    E.startObject(3);
  }
  static addPrecision(E, A) {
    E.addFieldInt32(0, A, 0);
  }
  static addScale(E, A) {
    E.addFieldInt32(1, A, 0);
  }
  static addBitWidth(E, A) {
    E.addFieldInt32(2, A, 128);
  }
  static endDecimal(E) {
    return E.endObject();
  }
  static createDecimal(E, A, g, e) {
    return Mg.startDecimal(E), Mg.addPrecision(E, A), Mg.addScale(E, g), Mg.addBitWidth(E, e), Mg.endDecimal(E);
  }
}, Duration$1 = class Wg {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(E, A) {
    return this.bb_pos = E, this.bb = A, this;
  }
  static getRootAsDuration(E, A) {
    return (A || new Wg()).__init(E.readInt32(E.position()) + E.position(), E);
  }
  static getSizePrefixedRootAsDuration(E, A) {
    return E.setPosition(E.position() + SIZE_PREFIX_LENGTH), (A || new Wg()).__init(E.readInt32(E.position()) + E.position(), E);
  }
  unit() {
    const E = this.bb.__offset(this.bb_pos, 4);
    return E ? this.bb.readInt16(this.bb_pos + E) : TimeUnit.MILLISECOND;
  }
  static startDuration(E) {
    E.startObject(1);
  }
  static addUnit(E, A) {
    E.addFieldInt16(0, A, TimeUnit.MILLISECOND);
  }
  static endDuration(E) {
    return E.endObject();
  }
  static createDuration(E, A) {
    return Wg.startDuration(E), Wg.addUnit(E, A), Wg.endDuration(E);
  }
}, FixedSizeBinary$1 = class xg {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(E, A) {
    return this.bb_pos = E, this.bb = A, this;
  }
  static getRootAsFixedSizeBinary(E, A) {
    return (A || new xg()).__init(E.readInt32(E.position()) + E.position(), E);
  }
  static getSizePrefixedRootAsFixedSizeBinary(E, A) {
    return E.setPosition(E.position() + SIZE_PREFIX_LENGTH), (A || new xg()).__init(E.readInt32(E.position()) + E.position(), E);
  }
  /**
   * Number of bytes per value
   */
  byteWidth() {
    const E = this.bb.__offset(this.bb_pos, 4);
    return E ? this.bb.readInt32(this.bb_pos + E) : 0;
  }
  static startFixedSizeBinary(E) {
    E.startObject(1);
  }
  static addByteWidth(E, A) {
    E.addFieldInt32(0, A, 0);
  }
  static endFixedSizeBinary(E) {
    return E.endObject();
  }
  static createFixedSizeBinary(E, A) {
    return xg.startFixedSizeBinary(E), xg.addByteWidth(E, A), xg.endFixedSizeBinary(E);
  }
}, FixedSizeList$2 = class fg {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(E, A) {
    return this.bb_pos = E, this.bb = A, this;
  }
  static getRootAsFixedSizeList(E, A) {
    return (A || new fg()).__init(E.readInt32(E.position()) + E.position(), E);
  }
  static getSizePrefixedRootAsFixedSizeList(E, A) {
    return E.setPosition(E.position() + SIZE_PREFIX_LENGTH), (A || new fg()).__init(E.readInt32(E.position()) + E.position(), E);
  }
  /**
   * Number of list items per value
   */
  listSize() {
    const E = this.bb.__offset(this.bb_pos, 4);
    return E ? this.bb.readInt32(this.bb_pos + E) : 0;
  }
  static startFixedSizeList(E) {
    E.startObject(1);
  }
  static addListSize(E, A) {
    E.addFieldInt32(0, A, 0);
  }
  static endFixedSizeList(E) {
    return E.endObject();
  }
  static createFixedSizeList(E, A) {
    return fg.startFixedSizeList(E), fg.addListSize(E, A), fg.endFixedSizeList(E);
  }
};
class FloatingPoint {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(E, A) {
    return this.bb_pos = E, this.bb = A, this;
  }
  static getRootAsFloatingPoint(E, A) {
    return (A || new FloatingPoint()).__init(E.readInt32(E.position()) + E.position(), E);
  }
  static getSizePrefixedRootAsFloatingPoint(E, A) {
    return E.setPosition(E.position() + SIZE_PREFIX_LENGTH), (A || new FloatingPoint()).__init(E.readInt32(E.position()) + E.position(), E);
  }
  precision() {
    const E = this.bb.__offset(this.bb_pos, 4);
    return E ? this.bb.readInt16(this.bb_pos + E) : Precision.HALF;
  }
  static startFloatingPoint(E) {
    E.startObject(1);
  }
  static addPrecision(E, A) {
    E.addFieldInt16(0, A, Precision.HALF);
  }
  static endFloatingPoint(E) {
    return E.endObject();
  }
  static createFloatingPoint(E, A) {
    return FloatingPoint.startFloatingPoint(E), FloatingPoint.addPrecision(E, A), FloatingPoint.endFloatingPoint(E);
  }
}
class Interval {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(E, A) {
    return this.bb_pos = E, this.bb = A, this;
  }
  static getRootAsInterval(E, A) {
    return (A || new Interval()).__init(E.readInt32(E.position()) + E.position(), E);
  }
  static getSizePrefixedRootAsInterval(E, A) {
    return E.setPosition(E.position() + SIZE_PREFIX_LENGTH), (A || new Interval()).__init(E.readInt32(E.position()) + E.position(), E);
  }
  unit() {
    const E = this.bb.__offset(this.bb_pos, 4);
    return E ? this.bb.readInt16(this.bb_pos + E) : IntervalUnit.YEAR_MONTH;
  }
  static startInterval(E) {
    E.startObject(1);
  }
  static addUnit(E, A) {
    E.addFieldInt16(0, A, IntervalUnit.YEAR_MONTH);
  }
  static endInterval(E) {
    return E.endObject();
  }
  static createInterval(E, A) {
    return Interval.startInterval(E), Interval.addUnit(E, A), Interval.endInterval(E);
  }
}
let LargeBinary$1 = class Tg {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(E, A) {
    return this.bb_pos = E, this.bb = A, this;
  }
  static getRootAsLargeBinary(E, A) {
    return (A || new Tg()).__init(E.readInt32(E.position()) + E.position(), E);
  }
  static getSizePrefixedRootAsLargeBinary(E, A) {
    return E.setPosition(E.position() + SIZE_PREFIX_LENGTH), (A || new Tg()).__init(E.readInt32(E.position()) + E.position(), E);
  }
  static startLargeBinary(E) {
    E.startObject(0);
  }
  static endLargeBinary(E) {
    return E.endObject();
  }
  static createLargeBinary(E) {
    return Tg.startLargeBinary(E), Tg.endLargeBinary(E);
  }
}, LargeUtf8$1 = class Og {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(E, A) {
    return this.bb_pos = E, this.bb = A, this;
  }
  static getRootAsLargeUtf8(E, A) {
    return (A || new Og()).__init(E.readInt32(E.position()) + E.position(), E);
  }
  static getSizePrefixedRootAsLargeUtf8(E, A) {
    return E.setPosition(E.position() + SIZE_PREFIX_LENGTH), (A || new Og()).__init(E.readInt32(E.position()) + E.position(), E);
  }
  static startLargeUtf8(E) {
    E.startObject(0);
  }
  static endLargeUtf8(E) {
    return E.endObject();
  }
  static createLargeUtf8(E) {
    return Og.startLargeUtf8(E), Og.endLargeUtf8(E);
  }
}, List$1 = class zg {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(E, A) {
    return this.bb_pos = E, this.bb = A, this;
  }
  static getRootAsList(E, A) {
    return (A || new zg()).__init(E.readInt32(E.position()) + E.position(), E);
  }
  static getSizePrefixedRootAsList(E, A) {
    return E.setPosition(E.position() + SIZE_PREFIX_LENGTH), (A || new zg()).__init(E.readInt32(E.position()) + E.position(), E);
  }
  static startList(E) {
    E.startObject(0);
  }
  static endList(E) {
    return E.endObject();
  }
  static createList(E) {
    return zg.startList(E), zg.endList(E);
  }
}, Map$1 = class Vg {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(E, A) {
    return this.bb_pos = E, this.bb = A, this;
  }
  static getRootAsMap(E, A) {
    return (A || new Vg()).__init(E.readInt32(E.position()) + E.position(), E);
  }
  static getSizePrefixedRootAsMap(E, A) {
    return E.setPosition(E.position() + SIZE_PREFIX_LENGTH), (A || new Vg()).__init(E.readInt32(E.position()) + E.position(), E);
  }
  /**
   * Set to true if the keys within each value are sorted
   */
  keysSorted() {
    const E = this.bb.__offset(this.bb_pos, 4);
    return E ? !!this.bb.readInt8(this.bb_pos + E) : !1;
  }
  static startMap(E) {
    E.startObject(1);
  }
  static addKeysSorted(E, A) {
    E.addFieldInt8(0, +A, 0);
  }
  static endMap(E) {
    return E.endObject();
  }
  static createMap(E, A) {
    return Vg.startMap(E), Vg.addKeysSorted(E, A), Vg.endMap(E);
  }
}, Null$1 = class Pg {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(E, A) {
    return this.bb_pos = E, this.bb = A, this;
  }
  static getRootAsNull(E, A) {
    return (A || new Pg()).__init(E.readInt32(E.position()) + E.position(), E);
  }
  static getSizePrefixedRootAsNull(E, A) {
    return E.setPosition(E.position() + SIZE_PREFIX_LENGTH), (A || new Pg()).__init(E.readInt32(E.position()) + E.position(), E);
  }
  static startNull(E) {
    E.startObject(0);
  }
  static endNull(E) {
    return E.endObject();
  }
  static createNull(E) {
    return Pg.startNull(E), Pg.endNull(E);
  }
};
class Struct_ {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(E, A) {
    return this.bb_pos = E, this.bb = A, this;
  }
  static getRootAsStruct_(E, A) {
    return (A || new Struct_()).__init(E.readInt32(E.position()) + E.position(), E);
  }
  static getSizePrefixedRootAsStruct_(E, A) {
    return E.setPosition(E.position() + SIZE_PREFIX_LENGTH), (A || new Struct_()).__init(E.readInt32(E.position()) + E.position(), E);
  }
  static startStruct_(E) {
    E.startObject(0);
  }
  static endStruct_(E) {
    return E.endObject();
  }
  static createStruct_(E) {
    return Struct_.startStruct_(E), Struct_.endStruct_(E);
  }
}
class Time {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(E, A) {
    return this.bb_pos = E, this.bb = A, this;
  }
  static getRootAsTime(E, A) {
    return (A || new Time()).__init(E.readInt32(E.position()) + E.position(), E);
  }
  static getSizePrefixedRootAsTime(E, A) {
    return E.setPosition(E.position() + SIZE_PREFIX_LENGTH), (A || new Time()).__init(E.readInt32(E.position()) + E.position(), E);
  }
  unit() {
    const E = this.bb.__offset(this.bb_pos, 4);
    return E ? this.bb.readInt16(this.bb_pos + E) : TimeUnit.MILLISECOND;
  }
  bitWidth() {
    const E = this.bb.__offset(this.bb_pos, 6);
    return E ? this.bb.readInt32(this.bb_pos + E) : 32;
  }
  static startTime(E) {
    E.startObject(2);
  }
  static addUnit(E, A) {
    E.addFieldInt16(0, A, TimeUnit.MILLISECOND);
  }
  static addBitWidth(E, A) {
    E.addFieldInt32(1, A, 32);
  }
  static endTime(E) {
    return E.endObject();
  }
  static createTime(E, A, g) {
    return Time.startTime(E), Time.addUnit(E, A), Time.addBitWidth(E, g), Time.endTime(E);
  }
}
class Timestamp {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(E, A) {
    return this.bb_pos = E, this.bb = A, this;
  }
  static getRootAsTimestamp(E, A) {
    return (A || new Timestamp()).__init(E.readInt32(E.position()) + E.position(), E);
  }
  static getSizePrefixedRootAsTimestamp(E, A) {
    return E.setPosition(E.position() + SIZE_PREFIX_LENGTH), (A || new Timestamp()).__init(E.readInt32(E.position()) + E.position(), E);
  }
  unit() {
    const E = this.bb.__offset(this.bb_pos, 4);
    return E ? this.bb.readInt16(this.bb_pos + E) : TimeUnit.SECOND;
  }
  timezone(E) {
    const A = this.bb.__offset(this.bb_pos, 6);
    return A ? this.bb.__string(this.bb_pos + A, E) : null;
  }
  static startTimestamp(E) {
    E.startObject(2);
  }
  static addUnit(E, A) {
    E.addFieldInt16(0, A, TimeUnit.SECOND);
  }
  static addTimezone(E, A) {
    E.addFieldOffset(1, A, 0);
  }
  static endTimestamp(E) {
    return E.endObject();
  }
  static createTimestamp(E, A, g) {
    return Timestamp.startTimestamp(E), Timestamp.addUnit(E, A), Timestamp.addTimezone(E, g), Timestamp.endTimestamp(E);
  }
}
class Union {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(E, A) {
    return this.bb_pos = E, this.bb = A, this;
  }
  static getRootAsUnion(E, A) {
    return (A || new Union()).__init(E.readInt32(E.position()) + E.position(), E);
  }
  static getSizePrefixedRootAsUnion(E, A) {
    return E.setPosition(E.position() + SIZE_PREFIX_LENGTH), (A || new Union()).__init(E.readInt32(E.position()) + E.position(), E);
  }
  mode() {
    const E = this.bb.__offset(this.bb_pos, 4);
    return E ? this.bb.readInt16(this.bb_pos + E) : UnionMode.Sparse;
  }
  typeIds(E) {
    const A = this.bb.__offset(this.bb_pos, 6);
    return A ? this.bb.readInt32(this.bb.__vector(this.bb_pos + A) + E * 4) : 0;
  }
  typeIdsLength() {
    const E = this.bb.__offset(this.bb_pos, 6);
    return E ? this.bb.__vector_len(this.bb_pos + E) : 0;
  }
  typeIdsArray() {
    const E = this.bb.__offset(this.bb_pos, 6);
    return E ? new Int32Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + E), this.bb.__vector_len(this.bb_pos + E)) : null;
  }
  static startUnion(E) {
    E.startObject(2);
  }
  static addMode(E, A) {
    E.addFieldInt16(0, A, UnionMode.Sparse);
  }
  static addTypeIds(E, A) {
    E.addFieldOffset(1, A, 0);
  }
  static createTypeIdsVector(E, A) {
    E.startVector(4, A.length, 4);
    for (let g = A.length - 1; g >= 0; g--)
      E.addInt32(A[g]);
    return E.endVector();
  }
  static startTypeIdsVector(E, A) {
    E.startVector(4, A, 4);
  }
  static endUnion(E) {
    return E.endObject();
  }
  static createUnion(E, A, g) {
    return Union.startUnion(E), Union.addMode(E, A), Union.addTypeIds(E, g), Union.endUnion(E);
  }
}
let Utf8$1 = class $g {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(E, A) {
    return this.bb_pos = E, this.bb = A, this;
  }
  static getRootAsUtf8(E, A) {
    return (A || new $g()).__init(E.readInt32(E.position()) + E.position(), E);
  }
  static getSizePrefixedRootAsUtf8(E, A) {
    return E.setPosition(E.position() + SIZE_PREFIX_LENGTH), (A || new $g()).__init(E.readInt32(E.position()) + E.position(), E);
  }
  static startUtf8(E) {
    E.startObject(0);
  }
  static endUtf8(E) {
    return E.endObject();
  }
  static createUtf8(E) {
    return $g.startUtf8(E), $g.endUtf8(E);
  }
};
var Type$1;
(function(o) {
  o[o.NONE = 0] = "NONE", o[o.Null = 1] = "Null", o[o.Int = 2] = "Int", o[o.FloatingPoint = 3] = "FloatingPoint", o[o.Binary = 4] = "Binary", o[o.Utf8 = 5] = "Utf8", o[o.Bool = 6] = "Bool", o[o.Decimal = 7] = "Decimal", o[o.Date = 8] = "Date", o[o.Time = 9] = "Time", o[o.Timestamp = 10] = "Timestamp", o[o.Interval = 11] = "Interval", o[o.List = 12] = "List", o[o.Struct_ = 13] = "Struct_", o[o.Union = 14] = "Union", o[o.FixedSizeBinary = 15] = "FixedSizeBinary", o[o.FixedSizeList = 16] = "FixedSizeList", o[o.Map = 17] = "Map", o[o.Duration = 18] = "Duration", o[o.LargeBinary = 19] = "LargeBinary", o[o.LargeUtf8 = 20] = "LargeUtf8", o[o.LargeList = 21] = "LargeList", o[o.RunEndEncoded = 22] = "RunEndEncoded";
})(Type$1 || (Type$1 = {}));
let Field$1 = class QI {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(E, A) {
    return this.bb_pos = E, this.bb = A, this;
  }
  static getRootAsField(E, A) {
    return (A || new QI()).__init(E.readInt32(E.position()) + E.position(), E);
  }
  static getSizePrefixedRootAsField(E, A) {
    return E.setPosition(E.position() + SIZE_PREFIX_LENGTH), (A || new QI()).__init(E.readInt32(E.position()) + E.position(), E);
  }
  name(E) {
    const A = this.bb.__offset(this.bb_pos, 4);
    return A ? this.bb.__string(this.bb_pos + A, E) : null;
  }
  /**
   * Whether or not this field can contain nulls. Should be true in general.
   */
  nullable() {
    const E = this.bb.__offset(this.bb_pos, 6);
    return E ? !!this.bb.readInt8(this.bb_pos + E) : !1;
  }
  typeType() {
    const E = this.bb.__offset(this.bb_pos, 8);
    return E ? this.bb.readUint8(this.bb_pos + E) : Type$1.NONE;
  }
  /**
   * This is the type of the decoded value if the field is dictionary encoded.
   */
  type(E) {
    const A = this.bb.__offset(this.bb_pos, 10);
    return A ? this.bb.__union(E, this.bb_pos + A) : null;
  }
  /**
   * Present only if the field is dictionary encoded.
   */
  dictionary(E) {
    const A = this.bb.__offset(this.bb_pos, 12);
    return A ? (E || new DictionaryEncoding()).__init(this.bb.__indirect(this.bb_pos + A), this.bb) : null;
  }
  /**
   * children apply only to nested data types like Struct, List and Union. For
   * primitive types children will have length 0.
   */
  children(E, A) {
    const g = this.bb.__offset(this.bb_pos, 14);
    return g ? (A || new QI()).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + g) + E * 4), this.bb) : null;
  }
  childrenLength() {
    const E = this.bb.__offset(this.bb_pos, 14);
    return E ? this.bb.__vector_len(this.bb_pos + E) : 0;
  }
  /**
   * User-defined metadata
   */
  customMetadata(E, A) {
    const g = this.bb.__offset(this.bb_pos, 16);
    return g ? (A || new KeyValue()).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + g) + E * 4), this.bb) : null;
  }
  customMetadataLength() {
    const E = this.bb.__offset(this.bb_pos, 16);
    return E ? this.bb.__vector_len(this.bb_pos + E) : 0;
  }
  static startField(E) {
    E.startObject(7);
  }
  static addName(E, A) {
    E.addFieldOffset(0, A, 0);
  }
  static addNullable(E, A) {
    E.addFieldInt8(1, +A, 0);
  }
  static addTypeType(E, A) {
    E.addFieldInt8(2, A, Type$1.NONE);
  }
  static addType(E, A) {
    E.addFieldOffset(3, A, 0);
  }
  static addDictionary(E, A) {
    E.addFieldOffset(4, A, 0);
  }
  static addChildren(E, A) {
    E.addFieldOffset(5, A, 0);
  }
  static createChildrenVector(E, A) {
    E.startVector(4, A.length, 4);
    for (let g = A.length - 1; g >= 0; g--)
      E.addOffset(A[g]);
    return E.endVector();
  }
  static startChildrenVector(E, A) {
    E.startVector(4, A, 4);
  }
  static addCustomMetadata(E, A) {
    E.addFieldOffset(6, A, 0);
  }
  static createCustomMetadataVector(E, A) {
    E.startVector(4, A.length, 4);
    for (let g = A.length - 1; g >= 0; g--)
      E.addOffset(A[g]);
    return E.endVector();
  }
  static startCustomMetadataVector(E, A) {
    E.startVector(4, A, 4);
  }
  static endField(E) {
    return E.endObject();
  }
}, Schema$3 = class pg {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(E, A) {
    return this.bb_pos = E, this.bb = A, this;
  }
  static getRootAsSchema(E, A) {
    return (A || new pg()).__init(E.readInt32(E.position()) + E.position(), E);
  }
  static getSizePrefixedRootAsSchema(E, A) {
    return E.setPosition(E.position() + SIZE_PREFIX_LENGTH), (A || new pg()).__init(E.readInt32(E.position()) + E.position(), E);
  }
  /**
   * endianness of the buffer
   * it is Little Endian by default
   * if endianness doesn't match the underlying system then the vectors need to be converted
   */
  endianness() {
    const E = this.bb.__offset(this.bb_pos, 4);
    return E ? this.bb.readInt16(this.bb_pos + E) : Endianness.Little;
  }
  fields(E, A) {
    const g = this.bb.__offset(this.bb_pos, 6);
    return g ? (A || new Field$1()).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + g) + E * 4), this.bb) : null;
  }
  fieldsLength() {
    const E = this.bb.__offset(this.bb_pos, 6);
    return E ? this.bb.__vector_len(this.bb_pos + E) : 0;
  }
  customMetadata(E, A) {
    const g = this.bb.__offset(this.bb_pos, 8);
    return g ? (A || new KeyValue()).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + g) + E * 4), this.bb) : null;
  }
  customMetadataLength() {
    const E = this.bb.__offset(this.bb_pos, 8);
    return E ? this.bb.__vector_len(this.bb_pos + E) : 0;
  }
  /**
   * Features used in the stream/file.
   */
  features(E) {
    const A = this.bb.__offset(this.bb_pos, 10);
    return A ? this.bb.readInt64(this.bb.__vector(this.bb_pos + A) + E * 8) : BigInt(0);
  }
  featuresLength() {
    const E = this.bb.__offset(this.bb_pos, 10);
    return E ? this.bb.__vector_len(this.bb_pos + E) : 0;
  }
  static startSchema(E) {
    E.startObject(4);
  }
  static addEndianness(E, A) {
    E.addFieldInt16(0, A, Endianness.Little);
  }
  static addFields(E, A) {
    E.addFieldOffset(1, A, 0);
  }
  static createFieldsVector(E, A) {
    E.startVector(4, A.length, 4);
    for (let g = A.length - 1; g >= 0; g--)
      E.addOffset(A[g]);
    return E.endVector();
  }
  static startFieldsVector(E, A) {
    E.startVector(4, A, 4);
  }
  static addCustomMetadata(E, A) {
    E.addFieldOffset(2, A, 0);
  }
  static createCustomMetadataVector(E, A) {
    E.startVector(4, A.length, 4);
    for (let g = A.length - 1; g >= 0; g--)
      E.addOffset(A[g]);
    return E.endVector();
  }
  static startCustomMetadataVector(E, A) {
    E.startVector(4, A, 4);
  }
  static addFeatures(E, A) {
    E.addFieldOffset(3, A, 0);
  }
  static createFeaturesVector(E, A) {
    E.startVector(8, A.length, 8);
    for (let g = A.length - 1; g >= 0; g--)
      E.addInt64(A[g]);
    return E.endVector();
  }
  static startFeaturesVector(E, A) {
    E.startVector(8, A, 8);
  }
  static endSchema(E) {
    return E.endObject();
  }
  static finishSchemaBuffer(E, A) {
    E.finish(A);
  }
  static finishSizePrefixedSchemaBuffer(E, A) {
    E.finish(A, void 0, !0);
  }
  static createSchema(E, A, g, e, t) {
    return pg.startSchema(E), pg.addEndianness(E, A), pg.addFields(E, g), pg.addCustomMetadata(E, e), pg.addFeatures(E, t), pg.endSchema(E);
  }
};
var MessageHeader;
(function(o) {
  o[o.NONE = 0] = "NONE", o[o.Schema = 1] = "Schema", o[o.DictionaryBatch = 2] = "DictionaryBatch", o[o.RecordBatch = 3] = "RecordBatch", o[o.Tensor = 4] = "Tensor", o[o.SparseTensor = 5] = "SparseTensor";
})(MessageHeader || (MessageHeader = {}));
var Type;
(function(o) {
  o[o.NONE = 0] = "NONE", o[o.Null = 1] = "Null", o[o.Int = 2] = "Int", o[o.Float = 3] = "Float", o[o.Binary = 4] = "Binary", o[o.Utf8 = 5] = "Utf8", o[o.Bool = 6] = "Bool", o[o.Decimal = 7] = "Decimal", o[o.Date = 8] = "Date", o[o.Time = 9] = "Time", o[o.Timestamp = 10] = "Timestamp", o[o.Interval = 11] = "Interval", o[o.List = 12] = "List", o[o.Struct = 13] = "Struct", o[o.Union = 14] = "Union", o[o.FixedSizeBinary = 15] = "FixedSizeBinary", o[o.FixedSizeList = 16] = "FixedSizeList", o[o.Map = 17] = "Map", o[o.Duration = 18] = "Duration", o[o.LargeBinary = 19] = "LargeBinary", o[o.LargeUtf8 = 20] = "LargeUtf8", o[o.Dictionary = -1] = "Dictionary", o[o.Int8 = -2] = "Int8", o[o.Int16 = -3] = "Int16", o[o.Int32 = -4] = "Int32", o[o.Int64 = -5] = "Int64", o[o.Uint8 = -6] = "Uint8", o[o.Uint16 = -7] = "Uint16", o[o.Uint32 = -8] = "Uint32", o[o.Uint64 = -9] = "Uint64", o[o.Float16 = -10] = "Float16", o[o.Float32 = -11] = "Float32", o[o.Float64 = -12] = "Float64", o[o.DateDay = -13] = "DateDay", o[o.DateMillisecond = -14] = "DateMillisecond", o[o.TimestampSecond = -15] = "TimestampSecond", o[o.TimestampMillisecond = -16] = "TimestampMillisecond", o[o.TimestampMicrosecond = -17] = "TimestampMicrosecond", o[o.TimestampNanosecond = -18] = "TimestampNanosecond", o[o.TimeSecond = -19] = "TimeSecond", o[o.TimeMillisecond = -20] = "TimeMillisecond", o[o.TimeMicrosecond = -21] = "TimeMicrosecond", o[o.TimeNanosecond = -22] = "TimeNanosecond", o[o.DenseUnion = -23] = "DenseUnion", o[o.SparseUnion = -24] = "SparseUnion", o[o.IntervalDayTime = -25] = "IntervalDayTime", o[o.IntervalYearMonth = -26] = "IntervalYearMonth", o[o.DurationSecond = -27] = "DurationSecond", o[o.DurationMillisecond = -28] = "DurationMillisecond", o[o.DurationMicrosecond = -29] = "DurationMicrosecond", o[o.DurationNanosecond = -30] = "DurationNanosecond", o[o.IntervalMonthDayNano = -31] = "IntervalMonthDayNano";
})(Type || (Type = {}));
var BufferType;
(function(o) {
  o[o.OFFSET = 0] = "OFFSET", o[o.DATA = 1] = "DATA", o[o.VALIDITY = 2] = "VALIDITY", o[o.TYPE = 3] = "TYPE";
})(BufferType || (BufferType = {}));
const undf = void 0;
function valueToString(o) {
  if (o === null)
    return "null";
  if (o === undf)
    return "undefined";
  switch (typeof o) {
    case "number":
      return `${o}`;
    case "bigint":
      return `${o}`;
    case "string":
      return `"${o}"`;
  }
  return typeof o[Symbol.toPrimitive] == "function" ? o[Symbol.toPrimitive]("string") : ArrayBuffer.isView(o) ? o instanceof BigInt64Array || o instanceof BigUint64Array ? `[${[...o].map((E) => valueToString(E))}]` : `[${o}]` : ArrayBuffer.isView(o) ? `[${o}]` : JSON.stringify(o, (E, A) => typeof A == "bigint" ? `${A}` : A);
}
const util_pretty_ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  valueToString
}, Symbol.toStringTag, { value: "Module" }));
function bigIntToNumber(o) {
  if (typeof o == "bigint" && (o < Number.MIN_SAFE_INTEGER || o > Number.MAX_SAFE_INTEGER))
    throw new TypeError(`${o} is not safe to convert to a number.`);
  return Number(o);
}
function divideBigInts(o, E) {
  return bigIntToNumber(o / E) + bigIntToNumber(o % E) / bigIntToNumber(E);
}
const isArrowBigNumSymbol = Symbol.for("isArrowBigNum");
function BigNum(o, ...E) {
  return E.length === 0 ? Object.setPrototypeOf(toArrayBufferView(this.TypedArray, o), this.constructor.prototype) : Object.setPrototypeOf(new this.TypedArray(o, ...E), this.constructor.prototype);
}
BigNum.prototype[isArrowBigNumSymbol] = !0;
BigNum.prototype.toJSON = function() {
  return `"${bigNumToString(this)}"`;
};
BigNum.prototype.valueOf = function(o) {
  return bigNumToNumber(this, o);
};
BigNum.prototype.toString = function() {
  return bigNumToString(this);
};
BigNum.prototype[Symbol.toPrimitive] = function(o = "default") {
  switch (o) {
    case "number":
      return bigNumToNumber(this);
    case "string":
      return bigNumToString(this);
    case "default":
      return bigNumToBigInt(this);
  }
  return bigNumToString(this);
};
function SignedBigNum(...o) {
  return BigNum.apply(this, o);
}
function UnsignedBigNum(...o) {
  return BigNum.apply(this, o);
}
function DecimalBigNum(...o) {
  return BigNum.apply(this, o);
}
Object.setPrototypeOf(SignedBigNum.prototype, Object.create(Int32Array.prototype));
Object.setPrototypeOf(UnsignedBigNum.prototype, Object.create(Uint32Array.prototype));
Object.setPrototypeOf(DecimalBigNum.prototype, Object.create(Uint32Array.prototype));
Object.assign(SignedBigNum.prototype, BigNum.prototype, { constructor: SignedBigNum, signed: !0, TypedArray: Int32Array, BigIntArray: BigInt64Array });
Object.assign(UnsignedBigNum.prototype, BigNum.prototype, { constructor: UnsignedBigNum, signed: !1, TypedArray: Uint32Array, BigIntArray: BigUint64Array });
Object.assign(DecimalBigNum.prototype, BigNum.prototype, { constructor: DecimalBigNum, signed: !0, TypedArray: Uint32Array, BigIntArray: BigUint64Array });
const TWO_TO_THE_64 = BigInt(4294967296) * BigInt(4294967296), TWO_TO_THE_64_MINUS_1 = TWO_TO_THE_64 - BigInt(1);
function bigNumToNumber(o, E) {
  const { buffer: A, byteOffset: g, byteLength: e, signed: t } = o, c = new BigUint64Array(A, g, e / 8), n = t && c.at(-1) & BigInt(1) << BigInt(63);
  let h = BigInt(0), d = 0;
  if (n) {
    for (const k of c)
      h |= (k ^ TWO_TO_THE_64_MINUS_1) * (BigInt(1) << BigInt(64 * d++));
    h *= BigInt(-1), h -= BigInt(1);
  } else
    for (const k of c)
      h |= k * (BigInt(1) << BigInt(64 * d++));
  if (typeof E == "number" && E > 0) {
    const k = BigInt("1".padEnd(E + 1, "0")), p = h / k, M = n ? -(h % k) : h % k, S = bigIntToNumber(p), AA = `${M}`.padStart(E, "0");
    return +`${n && S === 0 ? "-" : ""}${S}.${AA}`;
  }
  return bigIntToNumber(h);
}
function bigNumToString(o) {
  if (o.byteLength === 8)
    return `${new o.BigIntArray(o.buffer, o.byteOffset, 1)[0]}`;
  if (!o.signed)
    return unsignedBigNumToString(o);
  let E = new Uint16Array(o.buffer, o.byteOffset, o.byteLength / 2);
  if (new Int16Array([E.at(-1)])[0] >= 0)
    return unsignedBigNumToString(o);
  E = E.slice();
  let g = 1;
  for (let t = 0; t < E.length; t++) {
    const c = E[t], n = ~c + g;
    E[t] = n, g &= c === 0 ? 1 : 0;
  }
  return `-${unsignedBigNumToString(E)}`;
}
function bigNumToBigInt(o) {
  return o.byteLength === 8 ? new o.BigIntArray(o.buffer, o.byteOffset, 1)[0] : bigNumToString(o);
}
function unsignedBigNumToString(o) {
  let E = "";
  const A = new Uint32Array(2);
  let g = new Uint16Array(o.buffer, o.byteOffset, o.byteLength / 2);
  const e = new Uint32Array((g = new Uint16Array(g).reverse()).buffer);
  let t = -1;
  const c = g.length - 1;
  do {
    for (A[0] = g[t = 0]; t < c; )
      g[t++] = A[1] = A[0] / 10, A[0] = (A[0] - A[1] * 10 << 16) + g[t];
    g[t] = A[1] = A[0] / 10, A[0] = A[0] - A[1] * 10, E = `${A[0]}${E}`;
  } while (e[0] || e[1] || e[2] || e[3]);
  return E ?? "0";
}
class BN {
  /** @nocollapse */
  static new(E, A) {
    switch (A) {
      case !0:
        return new SignedBigNum(E);
      case !1:
        return new UnsignedBigNum(E);
    }
    switch (E.constructor) {
      case Int8Array:
      case Int16Array:
      case Int32Array:
      case BigInt64Array:
        return new SignedBigNum(E);
    }
    return E.byteLength === 16 ? new DecimalBigNum(E) : new UnsignedBigNum(E);
  }
  /** @nocollapse */
  static signed(E) {
    return new SignedBigNum(E);
  }
  /** @nocollapse */
  static unsigned(E) {
    return new UnsignedBigNum(E);
  }
  /** @nocollapse */
  static decimal(E) {
    return new DecimalBigNum(E);
  }
  constructor(E, A) {
    return BN.new(E, A);
  }
}
const util_bn_ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BN,
  bigNumToBigInt,
  bigNumToNumber,
  bigNumToString,
  isArrowBigNumSymbol
}, Symbol.toStringTag, { value: "Module" }));
var _a$4, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o$1, _p, _q, _r, _s, _t$1, _u, _v, _w, _x;
class DataType {
  /** @nocollapse */
  static isNull(E) {
    return E?.typeId === Type.Null;
  }
  /** @nocollapse */
  static isInt(E) {
    return E?.typeId === Type.Int;
  }
  /** @nocollapse */
  static isFloat(E) {
    return E?.typeId === Type.Float;
  }
  /** @nocollapse */
  static isBinary(E) {
    return E?.typeId === Type.Binary;
  }
  /** @nocollapse */
  static isLargeBinary(E) {
    return E?.typeId === Type.LargeBinary;
  }
  /** @nocollapse */
  static isUtf8(E) {
    return E?.typeId === Type.Utf8;
  }
  /** @nocollapse */
  static isLargeUtf8(E) {
    return E?.typeId === Type.LargeUtf8;
  }
  /** @nocollapse */
  static isBool(E) {
    return E?.typeId === Type.Bool;
  }
  /** @nocollapse */
  static isDecimal(E) {
    return E?.typeId === Type.Decimal;
  }
  /** @nocollapse */
  static isDate(E) {
    return E?.typeId === Type.Date;
  }
  /** @nocollapse */
  static isTime(E) {
    return E?.typeId === Type.Time;
  }
  /** @nocollapse */
  static isTimestamp(E) {
    return E?.typeId === Type.Timestamp;
  }
  /** @nocollapse */
  static isInterval(E) {
    return E?.typeId === Type.Interval;
  }
  /** @nocollapse */
  static isDuration(E) {
    return E?.typeId === Type.Duration;
  }
  /** @nocollapse */
  static isList(E) {
    return E?.typeId === Type.List;
  }
  /** @nocollapse */
  static isStruct(E) {
    return E?.typeId === Type.Struct;
  }
  /** @nocollapse */
  static isUnion(E) {
    return E?.typeId === Type.Union;
  }
  /** @nocollapse */
  static isFixedSizeBinary(E) {
    return E?.typeId === Type.FixedSizeBinary;
  }
  /** @nocollapse */
  static isFixedSizeList(E) {
    return E?.typeId === Type.FixedSizeList;
  }
  /** @nocollapse */
  static isMap(E) {
    return E?.typeId === Type.Map;
  }
  /** @nocollapse */
  static isDictionary(E) {
    return E?.typeId === Type.Dictionary;
  }
  /** @nocollapse */
  static isDenseUnion(E) {
    return DataType.isUnion(E) && E.mode === UnionMode.Dense;
  }
  /** @nocollapse */
  static isSparseUnion(E) {
    return DataType.isUnion(E) && E.mode === UnionMode.Sparse;
  }
  constructor(E) {
    this.typeId = E;
  }
}
_a$4 = Symbol.toStringTag;
DataType[_a$4] = ((o) => (o.children = null, o.ArrayType = Array, o.OffsetArrayType = Int32Array, o[Symbol.toStringTag] = "DataType"))(DataType.prototype);
class Null extends DataType {
  constructor() {
    super(Type.Null);
  }
  toString() {
    return "Null";
  }
}
_b = Symbol.toStringTag;
Null[_b] = ((o) => o[Symbol.toStringTag] = "Null")(Null.prototype);
class Int_ extends DataType {
  constructor(E, A) {
    super(Type.Int), this.isSigned = E, this.bitWidth = A;
  }
  get ArrayType() {
    switch (this.bitWidth) {
      case 8:
        return this.isSigned ? Int8Array : Uint8Array;
      case 16:
        return this.isSigned ? Int16Array : Uint16Array;
      case 32:
        return this.isSigned ? Int32Array : Uint32Array;
      case 64:
        return this.isSigned ? BigInt64Array : BigUint64Array;
    }
    throw new Error(`Unrecognized ${this[Symbol.toStringTag]} type`);
  }
  toString() {
    return `${this.isSigned ? "I" : "Ui"}nt${this.bitWidth}`;
  }
}
_c = Symbol.toStringTag;
Int_[_c] = ((o) => (o.isSigned = null, o.bitWidth = null, o[Symbol.toStringTag] = "Int"))(Int_.prototype);
class Int32 extends Int_ {
  constructor() {
    super(!0, 32);
  }
  get ArrayType() {
    return Int32Array;
  }
}
Object.defineProperty(Int32.prototype, "ArrayType", { value: Int32Array });
class Float extends DataType {
  constructor(E) {
    super(Type.Float), this.precision = E;
  }
  get ArrayType() {
    switch (this.precision) {
      case Precision.HALF:
        return Uint16Array;
      case Precision.SINGLE:
        return Float32Array;
      case Precision.DOUBLE:
        return Float64Array;
    }
    throw new Error(`Unrecognized ${this[Symbol.toStringTag]} type`);
  }
  toString() {
    return `Float${this.precision << 5 || 16}`;
  }
}
_d = Symbol.toStringTag;
Float[_d] = ((o) => (o.precision = null, o[Symbol.toStringTag] = "Float"))(Float.prototype);
class Binary extends DataType {
  constructor() {
    super(Type.Binary);
  }
  toString() {
    return "Binary";
  }
}
_e = Symbol.toStringTag;
Binary[_e] = ((o) => (o.ArrayType = Uint8Array, o[Symbol.toStringTag] = "Binary"))(Binary.prototype);
class LargeBinary extends DataType {
  constructor() {
    super(Type.LargeBinary);
  }
  toString() {
    return "LargeBinary";
  }
}
_f = Symbol.toStringTag;
LargeBinary[_f] = ((o) => (o.ArrayType = Uint8Array, o.OffsetArrayType = BigInt64Array, o[Symbol.toStringTag] = "LargeBinary"))(LargeBinary.prototype);
class Utf8 extends DataType {
  constructor() {
    super(Type.Utf8);
  }
  toString() {
    return "Utf8";
  }
}
_g = Symbol.toStringTag;
Utf8[_g] = ((o) => (o.ArrayType = Uint8Array, o[Symbol.toStringTag] = "Utf8"))(Utf8.prototype);
class LargeUtf8 extends DataType {
  constructor() {
    super(Type.LargeUtf8);
  }
  toString() {
    return "LargeUtf8";
  }
}
_h = Symbol.toStringTag;
LargeUtf8[_h] = ((o) => (o.ArrayType = Uint8Array, o.OffsetArrayType = BigInt64Array, o[Symbol.toStringTag] = "LargeUtf8"))(LargeUtf8.prototype);
class Bool extends DataType {
  constructor() {
    super(Type.Bool);
  }
  toString() {
    return "Bool";
  }
}
_j = Symbol.toStringTag;
Bool[_j] = ((o) => (o.ArrayType = Uint8Array, o[Symbol.toStringTag] = "Bool"))(Bool.prototype);
class Decimal extends DataType {
  constructor(E, A, g = 128) {
    super(Type.Decimal), this.scale = E, this.precision = A, this.bitWidth = g;
  }
  toString() {
    return `Decimal[${this.precision}e${this.scale > 0 ? "+" : ""}${this.scale}]`;
  }
}
_k = Symbol.toStringTag;
Decimal[_k] = ((o) => (o.scale = null, o.precision = null, o.ArrayType = Uint32Array, o[Symbol.toStringTag] = "Decimal"))(Decimal.prototype);
class Date_ extends DataType {
  constructor(E) {
    super(Type.Date), this.unit = E;
  }
  toString() {
    return `Date${(this.unit + 1) * 32}<${DateUnit[this.unit]}>`;
  }
  get ArrayType() {
    return this.unit === DateUnit.DAY ? Int32Array : BigInt64Array;
  }
}
_l = Symbol.toStringTag;
Date_[_l] = ((o) => (o.unit = null, o[Symbol.toStringTag] = "Date"))(Date_.prototype);
class Time_ extends DataType {
  constructor(E, A) {
    super(Type.Time), this.unit = E, this.bitWidth = A;
  }
  toString() {
    return `Time${this.bitWidth}<${TimeUnit[this.unit]}>`;
  }
  get ArrayType() {
    switch (this.bitWidth) {
      case 32:
        return Int32Array;
      case 64:
        return BigInt64Array;
    }
    throw new Error(`Unrecognized ${this[Symbol.toStringTag]} type`);
  }
}
_m = Symbol.toStringTag;
Time_[_m] = ((o) => (o.unit = null, o.bitWidth = null, o[Symbol.toStringTag] = "Time"))(Time_.prototype);
class Timestamp_ extends DataType {
  constructor(E, A) {
    super(Type.Timestamp), this.unit = E, this.timezone = A;
  }
  toString() {
    return `Timestamp<${TimeUnit[this.unit]}${this.timezone ? `, ${this.timezone}` : ""}>`;
  }
}
_o$1 = Symbol.toStringTag;
Timestamp_[_o$1] = ((o) => (o.unit = null, o.timezone = null, o.ArrayType = BigInt64Array, o[Symbol.toStringTag] = "Timestamp"))(Timestamp_.prototype);
class Interval_ extends DataType {
  constructor(E) {
    super(Type.Interval), this.unit = E;
  }
  toString() {
    return `Interval<${IntervalUnit[this.unit]}>`;
  }
}
_p = Symbol.toStringTag;
Interval_[_p] = ((o) => (o.unit = null, o.ArrayType = Int32Array, o[Symbol.toStringTag] = "Interval"))(Interval_.prototype);
class Duration extends DataType {
  constructor(E) {
    super(Type.Duration), this.unit = E;
  }
  toString() {
    return `Duration<${TimeUnit[this.unit]}>`;
  }
}
_q = Symbol.toStringTag;
Duration[_q] = ((o) => (o.unit = null, o.ArrayType = BigInt64Array, o[Symbol.toStringTag] = "Duration"))(Duration.prototype);
class List extends DataType {
  constructor(E) {
    super(Type.List), this.children = [E];
  }
  toString() {
    return `List<${this.valueType}>`;
  }
  get valueType() {
    return this.children[0].type;
  }
  get valueField() {
    return this.children[0];
  }
  get ArrayType() {
    return this.valueType.ArrayType;
  }
}
_r = Symbol.toStringTag;
List[_r] = ((o) => (o.children = null, o[Symbol.toStringTag] = "List"))(List.prototype);
class Struct extends DataType {
  constructor(E) {
    super(Type.Struct), this.children = E;
  }
  toString() {
    return `Struct<{${this.children.map((E) => `${E.name}:${E.type}`).join(", ")}}>`;
  }
}
_s = Symbol.toStringTag;
Struct[_s] = ((o) => (o.children = null, o[Symbol.toStringTag] = "Struct"))(Struct.prototype);
class Union_ extends DataType {
  constructor(E, A, g) {
    super(Type.Union), this.mode = E, this.children = g, this.typeIds = A = Int32Array.from(A), this.typeIdToChildIndex = A.reduce((e, t, c) => (e[t] = c) && e || e, /* @__PURE__ */ Object.create(null));
  }
  toString() {
    return `${this[Symbol.toStringTag]}<${this.children.map((E) => `${E.type}`).join(" | ")}>`;
  }
}
_t$1 = Symbol.toStringTag;
Union_[_t$1] = ((o) => (o.mode = null, o.typeIds = null, o.children = null, o.typeIdToChildIndex = null, o.ArrayType = Int8Array, o[Symbol.toStringTag] = "Union"))(Union_.prototype);
class FixedSizeBinary extends DataType {
  constructor(E) {
    super(Type.FixedSizeBinary), this.byteWidth = E;
  }
  toString() {
    return `FixedSizeBinary[${this.byteWidth}]`;
  }
}
_u = Symbol.toStringTag;
FixedSizeBinary[_u] = ((o) => (o.byteWidth = null, o.ArrayType = Uint8Array, o[Symbol.toStringTag] = "FixedSizeBinary"))(FixedSizeBinary.prototype);
let FixedSizeList$1 = class extends DataType {
  constructor(E, A) {
    super(Type.FixedSizeList), this.listSize = E, this.children = [A];
  }
  get valueType() {
    return this.children[0].type;
  }
  get valueField() {
    return this.children[0];
  }
  get ArrayType() {
    return this.valueType.ArrayType;
  }
  toString() {
    return `FixedSizeList[${this.listSize}]<${this.valueType}>`;
  }
};
_v = Symbol.toStringTag;
FixedSizeList$1[_v] = ((o) => (o.children = null, o.listSize = null, o[Symbol.toStringTag] = "FixedSizeList"))(FixedSizeList$1.prototype);
class Map_ extends DataType {
  constructor(E, A = !1) {
    var g, e, t;
    if (super(Type.Map), this.children = [E], this.keysSorted = A, E && (E.name = "entries", !((g = E?.type) === null || g === void 0) && g.children)) {
      const c = (e = E?.type) === null || e === void 0 ? void 0 : e.children[0];
      c && (c.name = "key");
      const n = (t = E?.type) === null || t === void 0 ? void 0 : t.children[1];
      n && (n.name = "value");
    }
  }
  get keyType() {
    return this.children[0].type.children[0].type;
  }
  get valueType() {
    return this.children[0].type.children[1].type;
  }
  get childType() {
    return this.children[0].type;
  }
  toString() {
    return `Map<{${this.children[0].type.children.map((E) => `${E.name}:${E.type}`).join(", ")}}>`;
  }
}
_w = Symbol.toStringTag;
Map_[_w] = ((o) => (o.children = null, o.keysSorted = null, o[Symbol.toStringTag] = "Map_"))(Map_.prototype);
const getId$1 = /* @__PURE__ */ ((o) => () => ++o)(-1);
class Dictionary extends DataType {
  constructor(E, A, g, e) {
    super(Type.Dictionary), this.indices = A, this.dictionary = E, this.isOrdered = e || !1, this.id = g == null ? getId$1() : bigIntToNumber(g);
  }
  get children() {
    return this.dictionary.children;
  }
  get valueType() {
    return this.dictionary;
  }
  get ArrayType() {
    return this.dictionary.ArrayType;
  }
  toString() {
    return `Dictionary<${this.indices}, ${this.dictionary}>`;
  }
}
_x = Symbol.toStringTag;
Dictionary[_x] = ((o) => (o.id = null, o.indices = null, o.isOrdered = null, o.dictionary = null, o[Symbol.toStringTag] = "Dictionary"))(Dictionary.prototype);
function strideForType(o) {
  const E = o;
  switch (o.typeId) {
    case Type.Decimal:
      return o.bitWidth / 32;
    case Type.Interval:
      return E.unit === IntervalUnit.MONTH_DAY_NANO ? 4 : 1 + E.unit;
    // case Type.Int: return 1 + +((t as Int_).bitWidth > 32);
    // case Type.Time: return 1 + +((t as Time_).bitWidth > 32);
    case Type.FixedSizeList:
      return E.listSize;
    case Type.FixedSizeBinary:
      return E.byteWidth;
    default:
      return 1;
  }
}
class Visitor {
  visitMany(E, ...A) {
    return E.map((g, e) => this.visit(g, ...A.map((t) => t[e])));
  }
  visit(...E) {
    return this.getVisitFn(E[0], !1).apply(this, E);
  }
  getVisitFn(E, A = !0) {
    return getVisitFn(this, E, A);
  }
  getVisitFnByTypeId(E, A = !0) {
    return getVisitFnByTypeId(this, E, A);
  }
  visitNull(E, ...A) {
    return null;
  }
  visitBool(E, ...A) {
    return null;
  }
  visitInt(E, ...A) {
    return null;
  }
  visitFloat(E, ...A) {
    return null;
  }
  visitUtf8(E, ...A) {
    return null;
  }
  visitLargeUtf8(E, ...A) {
    return null;
  }
  visitBinary(E, ...A) {
    return null;
  }
  visitLargeBinary(E, ...A) {
    return null;
  }
  visitFixedSizeBinary(E, ...A) {
    return null;
  }
  visitDate(E, ...A) {
    return null;
  }
  visitTimestamp(E, ...A) {
    return null;
  }
  visitTime(E, ...A) {
    return null;
  }
  visitDecimal(E, ...A) {
    return null;
  }
  visitList(E, ...A) {
    return null;
  }
  visitStruct(E, ...A) {
    return null;
  }
  visitUnion(E, ...A) {
    return null;
  }
  visitDictionary(E, ...A) {
    return null;
  }
  visitInterval(E, ...A) {
    return null;
  }
  visitDuration(E, ...A) {
    return null;
  }
  visitFixedSizeList(E, ...A) {
    return null;
  }
  visitMap(E, ...A) {
    return null;
  }
}
function getVisitFn(o, E, A = !0) {
  return typeof E == "number" ? getVisitFnByTypeId(o, E, A) : typeof E == "string" && E in Type ? getVisitFnByTypeId(o, Type[E], A) : E && E instanceof DataType ? getVisitFnByTypeId(o, inferDType(E), A) : E?.type && E.type instanceof DataType ? getVisitFnByTypeId(o, inferDType(E.type), A) : getVisitFnByTypeId(o, Type.NONE, A);
}
function getVisitFnByTypeId(o, E, A = !0) {
  let g = null;
  switch (E) {
    case Type.Null:
      g = o.visitNull;
      break;
    case Type.Bool:
      g = o.visitBool;
      break;
    case Type.Int:
      g = o.visitInt;
      break;
    case Type.Int8:
      g = o.visitInt8 || o.visitInt;
      break;
    case Type.Int16:
      g = o.visitInt16 || o.visitInt;
      break;
    case Type.Int32:
      g = o.visitInt32 || o.visitInt;
      break;
    case Type.Int64:
      g = o.visitInt64 || o.visitInt;
      break;
    case Type.Uint8:
      g = o.visitUint8 || o.visitInt;
      break;
    case Type.Uint16:
      g = o.visitUint16 || o.visitInt;
      break;
    case Type.Uint32:
      g = o.visitUint32 || o.visitInt;
      break;
    case Type.Uint64:
      g = o.visitUint64 || o.visitInt;
      break;
    case Type.Float:
      g = o.visitFloat;
      break;
    case Type.Float16:
      g = o.visitFloat16 || o.visitFloat;
      break;
    case Type.Float32:
      g = o.visitFloat32 || o.visitFloat;
      break;
    case Type.Float64:
      g = o.visitFloat64 || o.visitFloat;
      break;
    case Type.Utf8:
      g = o.visitUtf8;
      break;
    case Type.LargeUtf8:
      g = o.visitLargeUtf8;
      break;
    case Type.Binary:
      g = o.visitBinary;
      break;
    case Type.LargeBinary:
      g = o.visitLargeBinary;
      break;
    case Type.FixedSizeBinary:
      g = o.visitFixedSizeBinary;
      break;
    case Type.Date:
      g = o.visitDate;
      break;
    case Type.DateDay:
      g = o.visitDateDay || o.visitDate;
      break;
    case Type.DateMillisecond:
      g = o.visitDateMillisecond || o.visitDate;
      break;
    case Type.Timestamp:
      g = o.visitTimestamp;
      break;
    case Type.TimestampSecond:
      g = o.visitTimestampSecond || o.visitTimestamp;
      break;
    case Type.TimestampMillisecond:
      g = o.visitTimestampMillisecond || o.visitTimestamp;
      break;
    case Type.TimestampMicrosecond:
      g = o.visitTimestampMicrosecond || o.visitTimestamp;
      break;
    case Type.TimestampNanosecond:
      g = o.visitTimestampNanosecond || o.visitTimestamp;
      break;
    case Type.Time:
      g = o.visitTime;
      break;
    case Type.TimeSecond:
      g = o.visitTimeSecond || o.visitTime;
      break;
    case Type.TimeMillisecond:
      g = o.visitTimeMillisecond || o.visitTime;
      break;
    case Type.TimeMicrosecond:
      g = o.visitTimeMicrosecond || o.visitTime;
      break;
    case Type.TimeNanosecond:
      g = o.visitTimeNanosecond || o.visitTime;
      break;
    case Type.Decimal:
      g = o.visitDecimal;
      break;
    case Type.List:
      g = o.visitList;
      break;
    case Type.Struct:
      g = o.visitStruct;
      break;
    case Type.Union:
      g = o.visitUnion;
      break;
    case Type.DenseUnion:
      g = o.visitDenseUnion || o.visitUnion;
      break;
    case Type.SparseUnion:
      g = o.visitSparseUnion || o.visitUnion;
      break;
    case Type.Dictionary:
      g = o.visitDictionary;
      break;
    case Type.Interval:
      g = o.visitInterval;
      break;
    case Type.IntervalDayTime:
      g = o.visitIntervalDayTime || o.visitInterval;
      break;
    case Type.IntervalYearMonth:
      g = o.visitIntervalYearMonth || o.visitInterval;
      break;
    case Type.IntervalMonthDayNano:
      g = o.visitIntervalMonthDayNano || o.visitInterval;
      break;
    case Type.Duration:
      g = o.visitDuration;
      break;
    case Type.DurationSecond:
      g = o.visitDurationSecond || o.visitDuration;
      break;
    case Type.DurationMillisecond:
      g = o.visitDurationMillisecond || o.visitDuration;
      break;
    case Type.DurationMicrosecond:
      g = o.visitDurationMicrosecond || o.visitDuration;
      break;
    case Type.DurationNanosecond:
      g = o.visitDurationNanosecond || o.visitDuration;
      break;
    case Type.FixedSizeList:
      g = o.visitFixedSizeList;
      break;
    case Type.Map:
      g = o.visitMap;
      break;
  }
  if (typeof g == "function")
    return g;
  if (!A)
    return () => null;
  throw new Error(`Unrecognized type '${Type[E]}'`);
}
function inferDType(o) {
  switch (o.typeId) {
    case Type.Null:
      return Type.Null;
    case Type.Int: {
      const { bitWidth: E, isSigned: A } = o;
      switch (E) {
        case 8:
          return A ? Type.Int8 : Type.Uint8;
        case 16:
          return A ? Type.Int16 : Type.Uint16;
        case 32:
          return A ? Type.Int32 : Type.Uint32;
        case 64:
          return A ? Type.Int64 : Type.Uint64;
      }
      return Type.Int;
    }
    case Type.Float:
      switch (o.precision) {
        case Precision.HALF:
          return Type.Float16;
        case Precision.SINGLE:
          return Type.Float32;
        case Precision.DOUBLE:
          return Type.Float64;
      }
      return Type.Float;
    case Type.Binary:
      return Type.Binary;
    case Type.LargeBinary:
      return Type.LargeBinary;
    case Type.Utf8:
      return Type.Utf8;
    case Type.LargeUtf8:
      return Type.LargeUtf8;
    case Type.Bool:
      return Type.Bool;
    case Type.Decimal:
      return Type.Decimal;
    case Type.Time:
      switch (o.unit) {
        case TimeUnit.SECOND:
          return Type.TimeSecond;
        case TimeUnit.MILLISECOND:
          return Type.TimeMillisecond;
        case TimeUnit.MICROSECOND:
          return Type.TimeMicrosecond;
        case TimeUnit.NANOSECOND:
          return Type.TimeNanosecond;
      }
      return Type.Time;
    case Type.Timestamp:
      switch (o.unit) {
        case TimeUnit.SECOND:
          return Type.TimestampSecond;
        case TimeUnit.MILLISECOND:
          return Type.TimestampMillisecond;
        case TimeUnit.MICROSECOND:
          return Type.TimestampMicrosecond;
        case TimeUnit.NANOSECOND:
          return Type.TimestampNanosecond;
      }
      return Type.Timestamp;
    case Type.Date:
      switch (o.unit) {
        case DateUnit.DAY:
          return Type.DateDay;
        case DateUnit.MILLISECOND:
          return Type.DateMillisecond;
      }
      return Type.Date;
    case Type.Interval:
      switch (o.unit) {
        case IntervalUnit.DAY_TIME:
          return Type.IntervalDayTime;
        case IntervalUnit.YEAR_MONTH:
          return Type.IntervalYearMonth;
        case IntervalUnit.MONTH_DAY_NANO:
          return Type.IntervalMonthDayNano;
      }
      return Type.Interval;
    case Type.Duration:
      switch (o.unit) {
        case TimeUnit.SECOND:
          return Type.DurationSecond;
        case TimeUnit.MILLISECOND:
          return Type.DurationMillisecond;
        case TimeUnit.MICROSECOND:
          return Type.DurationMicrosecond;
        case TimeUnit.NANOSECOND:
          return Type.DurationNanosecond;
      }
      return Type.Duration;
    case Type.Map:
      return Type.Map;
    case Type.List:
      return Type.List;
    case Type.Struct:
      return Type.Struct;
    case Type.Union:
      switch (o.mode) {
        case UnionMode.Dense:
          return Type.DenseUnion;
        case UnionMode.Sparse:
          return Type.SparseUnion;
      }
      return Type.Union;
    case Type.FixedSizeBinary:
      return Type.FixedSizeBinary;
    case Type.FixedSizeList:
      return Type.FixedSizeList;
    case Type.Dictionary:
      return Type.Dictionary;
  }
  throw new Error(`Unrecognized type '${Type[o.typeId]}'`);
}
Visitor.prototype.visitInt8 = null;
Visitor.prototype.visitInt16 = null;
Visitor.prototype.visitInt32 = null;
Visitor.prototype.visitInt64 = null;
Visitor.prototype.visitUint8 = null;
Visitor.prototype.visitUint16 = null;
Visitor.prototype.visitUint32 = null;
Visitor.prototype.visitUint64 = null;
Visitor.prototype.visitFloat16 = null;
Visitor.prototype.visitFloat32 = null;
Visitor.prototype.visitFloat64 = null;
Visitor.prototype.visitDateDay = null;
Visitor.prototype.visitDateMillisecond = null;
Visitor.prototype.visitTimestampSecond = null;
Visitor.prototype.visitTimestampMillisecond = null;
Visitor.prototype.visitTimestampMicrosecond = null;
Visitor.prototype.visitTimestampNanosecond = null;
Visitor.prototype.visitTimeSecond = null;
Visitor.prototype.visitTimeMillisecond = null;
Visitor.prototype.visitTimeMicrosecond = null;
Visitor.prototype.visitTimeNanosecond = null;
Visitor.prototype.visitDenseUnion = null;
Visitor.prototype.visitSparseUnion = null;
Visitor.prototype.visitIntervalDayTime = null;
Visitor.prototype.visitIntervalYearMonth = null;
Visitor.prototype.visitIntervalMonthDayNano = null;
Visitor.prototype.visitDuration = null;
Visitor.prototype.visitDurationSecond = null;
Visitor.prototype.visitDurationMillisecond = null;
Visitor.prototype.visitDurationMicrosecond = null;
Visitor.prototype.visitDurationNanosecond = null;
const f64 = new Float64Array(1), u32 = new Uint32Array(f64.buffer);
function uint16ToFloat64(o) {
  const E = (o & 31744) >> 10, A = (o & 1023) / 1024, g = Math.pow(-1, (o & 32768) >> 15);
  switch (E) {
    case 31:
      return g * (A ? Number.NaN : 1 / 0);
    case 0:
      return g * (A ? 6103515625e-14 * A : 0);
  }
  return g * Math.pow(2, E - 15) * (1 + A);
}
function float64ToUint16(o) {
  if (o !== o)
    return 32256;
  f64[0] = o;
  const E = (u32[1] & 2147483648) >> 16 & 65535;
  let A = u32[1] & 2146435072, g = 0;
  return A >= 1089470464 ? u32[0] > 0 ? A = 31744 : (A = (A & 2080374784) >> 16, g = (u32[1] & 1048575) >> 10) : A <= 1056964608 ? (g = 1048576 + (u32[1] & 1048575), g = 1048576 + (g << (A >> 20) - 998) >> 21, A = 0) : (A = A - 1056964608 >> 10, g = (u32[1] & 1048575) + 512 >> 10), E | A | g & 65535;
}
const util_math_ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  float64ToUint16,
  uint16ToFloat64
}, Symbol.toStringTag, { value: "Module" }));
class SetVisitor extends Visitor {
}
function wrapSet(o) {
  return (E, A, g) => {
    if (E.setValid(A, g != null))
      return o(E, A, g);
  };
}
const setEpochMsToDays = (o, E, A) => {
  o[E] = Math.floor(A / 864e5);
}, setVariableWidthBytes = (o, E, A, g) => {
  if (A + 1 < E.length) {
    const e = bigIntToNumber(E[A]), t = bigIntToNumber(E[A + 1]);
    o.set(g.subarray(0, t - e), e);
  }
}, setBool$1 = ({ offset: o, values: E }, A, g) => {
  const e = o + A;
  g ? E[e >> 3] |= 1 << e % 8 : E[e >> 3] &= ~(1 << e % 8);
}, setInt = ({ values: o }, E, A) => {
  o[E] = A;
}, setFloat = ({ values: o }, E, A) => {
  o[E] = A;
}, setFloat16 = ({ values: o }, E, A) => {
  o[E] = float64ToUint16(A);
}, setAnyFloat = (o, E, A) => {
  switch (o.type.precision) {
    case Precision.HALF:
      return setFloat16(o, E, A);
    case Precision.SINGLE:
    case Precision.DOUBLE:
      return setFloat(o, E, A);
  }
}, setDateDay = ({ values: o }, E, A) => {
  setEpochMsToDays(o, E, A.valueOf());
}, setDateMillisecond = ({ values: o }, E, A) => {
  o[E] = BigInt(A);
}, setFixedSizeBinary = ({ stride: o, values: E }, A, g) => {
  E.set(g.subarray(0, o), o * A);
}, setBinary = ({ values: o, valueOffsets: E }, A, g) => setVariableWidthBytes(o, E, A, g), setUtf8 = ({ values: o, valueOffsets: E }, A, g) => setVariableWidthBytes(o, E, A, encodeUtf8(g)), setDate = (o, E, A) => {
  o.type.unit === DateUnit.DAY ? setDateDay(o, E, A) : setDateMillisecond(o, E, A);
}, setTimestampSecond = ({ values: o }, E, A) => {
  o[E] = BigInt(A / 1e3);
}, setTimestampMillisecond = ({ values: o }, E, A) => {
  o[E] = BigInt(A);
}, setTimestampMicrosecond = ({ values: o }, E, A) => {
  o[E] = BigInt(A * 1e3);
}, setTimestampNanosecond = ({ values: o }, E, A) => {
  o[E] = BigInt(A * 1e6);
}, setTimestamp = (o, E, A) => {
  switch (o.type.unit) {
    case TimeUnit.SECOND:
      return setTimestampSecond(o, E, A);
    case TimeUnit.MILLISECOND:
      return setTimestampMillisecond(o, E, A);
    case TimeUnit.MICROSECOND:
      return setTimestampMicrosecond(o, E, A);
    case TimeUnit.NANOSECOND:
      return setTimestampNanosecond(o, E, A);
  }
}, setTimeSecond = ({ values: o }, E, A) => {
  o[E] = A;
}, setTimeMillisecond = ({ values: o }, E, A) => {
  o[E] = A;
}, setTimeMicrosecond = ({ values: o }, E, A) => {
  o[E] = A;
}, setTimeNanosecond = ({ values: o }, E, A) => {
  o[E] = A;
}, setTime = (o, E, A) => {
  switch (o.type.unit) {
    case TimeUnit.SECOND:
      return setTimeSecond(o, E, A);
    case TimeUnit.MILLISECOND:
      return setTimeMillisecond(o, E, A);
    case TimeUnit.MICROSECOND:
      return setTimeMicrosecond(o, E, A);
    case TimeUnit.NANOSECOND:
      return setTimeNanosecond(o, E, A);
  }
}, setDecimal = ({ values: o, stride: E }, A, g) => {
  o.set(g.subarray(0, E), E * A);
}, setList = (o, E, A) => {
  const g = o.children[0], e = o.valueOffsets, t = instance$5.getVisitFn(g);
  if (Array.isArray(A))
    for (let c = -1, n = e[E], h = e[E + 1]; n < h; )
      t(g, n++, A[++c]);
  else
    for (let c = -1, n = e[E], h = e[E + 1]; n < h; )
      t(g, n++, A.get(++c));
}, setMap = (o, E, A) => {
  const g = o.children[0], { valueOffsets: e } = o, t = instance$5.getVisitFn(g);
  let { [E]: c, [E + 1]: n } = e;
  const h = A instanceof Map ? A.entries() : Object.entries(A);
  for (const d of h)
    if (t(g, c, d), ++c >= n)
      break;
}, _setStructArrayValue = (o, E) => (A, g, e, t) => g && A(g, o, E[t]), _setStructVectorValue = (o, E) => (A, g, e, t) => g && A(g, o, E.get(t)), _setStructMapValue = (o, E) => (A, g, e, t) => g && A(g, o, E.get(e.name)), _setStructObjectValue = (o, E) => (A, g, e, t) => g && A(g, o, E[e.name]), setStruct = (o, E, A) => {
  const g = o.type.children.map((t) => instance$5.getVisitFn(t.type)), e = A instanceof Map ? _setStructMapValue(E, A) : A instanceof Vector ? _setStructVectorValue(E, A) : Array.isArray(A) ? _setStructArrayValue(E, A) : _setStructObjectValue(E, A);
  o.type.children.forEach((t, c) => e(g[c], o.children[c], t, c));
}, setUnion = (o, E, A) => {
  o.type.mode === UnionMode.Dense ? setDenseUnion(o, E, A) : setSparseUnion(o, E, A);
}, setDenseUnion = (o, E, A) => {
  const g = o.type.typeIdToChildIndex[o.typeIds[E]], e = o.children[g];
  instance$5.visit(e, o.valueOffsets[E], A);
}, setSparseUnion = (o, E, A) => {
  const g = o.type.typeIdToChildIndex[o.typeIds[E]], e = o.children[g];
  instance$5.visit(e, E, A);
}, setDictionary = (o, E, A) => {
  var g;
  (g = o.dictionary) === null || g === void 0 || g.set(o.values[E], A);
}, setIntervalValue = (o, E, A) => {
  switch (o.type.unit) {
    case IntervalUnit.YEAR_MONTH:
      return setIntervalYearMonth(o, E, A);
    case IntervalUnit.DAY_TIME:
      return setIntervalDayTime(o, E, A);
    case IntervalUnit.MONTH_DAY_NANO:
      return setIntervalMonthDayNano(o, E, A);
  }
}, setIntervalDayTime = ({ values: o }, E, A) => {
  o.set(A.subarray(0, 2), 2 * E);
}, setIntervalYearMonth = ({ values: o }, E, A) => {
  o[E] = A[0] * 12 + A[1] % 12;
}, setIntervalMonthDayNano = ({ values: o, stride: E }, A, g) => {
  o.set(g.subarray(0, E), E * A);
}, setDurationSecond = ({ values: o }, E, A) => {
  o[E] = A;
}, setDurationMillisecond = ({ values: o }, E, A) => {
  o[E] = A;
}, setDurationMicrosecond = ({ values: o }, E, A) => {
  o[E] = A;
}, setDurationNanosecond = ({ values: o }, E, A) => {
  o[E] = A;
}, setDuration = (o, E, A) => {
  switch (o.type.unit) {
    case TimeUnit.SECOND:
      return setDurationSecond(o, E, A);
    case TimeUnit.MILLISECOND:
      return setDurationMillisecond(o, E, A);
    case TimeUnit.MICROSECOND:
      return setDurationMicrosecond(o, E, A);
    case TimeUnit.NANOSECOND:
      return setDurationNanosecond(o, E, A);
  }
}, setFixedSizeList = (o, E, A) => {
  const { stride: g } = o, e = o.children[0], t = instance$5.getVisitFn(e);
  if (Array.isArray(A))
    for (let c = -1, n = E * g; ++c < g; )
      t(e, n + c, A[c]);
  else
    for (let c = -1, n = E * g; ++c < g; )
      t(e, n + c, A.get(c));
};
SetVisitor.prototype.visitBool = wrapSet(setBool$1);
SetVisitor.prototype.visitInt = wrapSet(setInt);
SetVisitor.prototype.visitInt8 = wrapSet(setInt);
SetVisitor.prototype.visitInt16 = wrapSet(setInt);
SetVisitor.prototype.visitInt32 = wrapSet(setInt);
SetVisitor.prototype.visitInt64 = wrapSet(setInt);
SetVisitor.prototype.visitUint8 = wrapSet(setInt);
SetVisitor.prototype.visitUint16 = wrapSet(setInt);
SetVisitor.prototype.visitUint32 = wrapSet(setInt);
SetVisitor.prototype.visitUint64 = wrapSet(setInt);
SetVisitor.prototype.visitFloat = wrapSet(setAnyFloat);
SetVisitor.prototype.visitFloat16 = wrapSet(setFloat16);
SetVisitor.prototype.visitFloat32 = wrapSet(setFloat);
SetVisitor.prototype.visitFloat64 = wrapSet(setFloat);
SetVisitor.prototype.visitUtf8 = wrapSet(setUtf8);
SetVisitor.prototype.visitLargeUtf8 = wrapSet(setUtf8);
SetVisitor.prototype.visitBinary = wrapSet(setBinary);
SetVisitor.prototype.visitLargeBinary = wrapSet(setBinary);
SetVisitor.prototype.visitFixedSizeBinary = wrapSet(setFixedSizeBinary);
SetVisitor.prototype.visitDate = wrapSet(setDate);
SetVisitor.prototype.visitDateDay = wrapSet(setDateDay);
SetVisitor.prototype.visitDateMillisecond = wrapSet(setDateMillisecond);
SetVisitor.prototype.visitTimestamp = wrapSet(setTimestamp);
SetVisitor.prototype.visitTimestampSecond = wrapSet(setTimestampSecond);
SetVisitor.prototype.visitTimestampMillisecond = wrapSet(setTimestampMillisecond);
SetVisitor.prototype.visitTimestampMicrosecond = wrapSet(setTimestampMicrosecond);
SetVisitor.prototype.visitTimestampNanosecond = wrapSet(setTimestampNanosecond);
SetVisitor.prototype.visitTime = wrapSet(setTime);
SetVisitor.prototype.visitTimeSecond = wrapSet(setTimeSecond);
SetVisitor.prototype.visitTimeMillisecond = wrapSet(setTimeMillisecond);
SetVisitor.prototype.visitTimeMicrosecond = wrapSet(setTimeMicrosecond);
SetVisitor.prototype.visitTimeNanosecond = wrapSet(setTimeNanosecond);
SetVisitor.prototype.visitDecimal = wrapSet(setDecimal);
SetVisitor.prototype.visitList = wrapSet(setList);
SetVisitor.prototype.visitStruct = wrapSet(setStruct);
SetVisitor.prototype.visitUnion = wrapSet(setUnion);
SetVisitor.prototype.visitDenseUnion = wrapSet(setDenseUnion);
SetVisitor.prototype.visitSparseUnion = wrapSet(setSparseUnion);
SetVisitor.prototype.visitDictionary = wrapSet(setDictionary);
SetVisitor.prototype.visitInterval = wrapSet(setIntervalValue);
SetVisitor.prototype.visitIntervalDayTime = wrapSet(setIntervalDayTime);
SetVisitor.prototype.visitIntervalYearMonth = wrapSet(setIntervalYearMonth);
SetVisitor.prototype.visitIntervalMonthDayNano = wrapSet(setIntervalMonthDayNano);
SetVisitor.prototype.visitDuration = wrapSet(setDuration);
SetVisitor.prototype.visitDurationSecond = wrapSet(setDurationSecond);
SetVisitor.prototype.visitDurationMillisecond = wrapSet(setDurationMillisecond);
SetVisitor.prototype.visitDurationMicrosecond = wrapSet(setDurationMicrosecond);
SetVisitor.prototype.visitDurationNanosecond = wrapSet(setDurationNanosecond);
SetVisitor.prototype.visitFixedSizeList = wrapSet(setFixedSizeList);
SetVisitor.prototype.visitMap = wrapSet(setMap);
const instance$5 = new SetVisitor(), kParent = Symbol.for("parent"), kRowIndex = Symbol.for("rowIndex");
class StructRow {
  constructor(E, A) {
    return this[kParent] = E, this[kRowIndex] = A, new Proxy(this, structRowProxyHandler);
  }
  toArray() {
    return Object.values(this.toJSON());
  }
  toJSON() {
    const E = this[kRowIndex], A = this[kParent], g = A.type.children, e = {};
    for (let t = -1, c = g.length; ++t < c; )
      e[g[t].name] = instance$4.visit(A.children[t], E);
    return e;
  }
  toString() {
    return `{${[...this].map(([E, A]) => `${valueToString(E)}: ${valueToString(A)}`).join(", ")}}`;
  }
  [Symbol.for("nodejs.util.inspect.custom")]() {
    return this.toString();
  }
  [Symbol.iterator]() {
    return new StructRowIterator(this[kParent], this[kRowIndex]);
  }
}
class StructRowIterator {
  constructor(E, A) {
    this.childIndex = 0, this.children = E.children, this.rowIndex = A, this.childFields = E.type.children, this.numChildren = this.childFields.length;
  }
  [Symbol.iterator]() {
    return this;
  }
  next() {
    const E = this.childIndex;
    return E < this.numChildren ? (this.childIndex = E + 1, {
      done: !1,
      value: [
        this.childFields[E].name,
        instance$4.visit(this.children[E], this.rowIndex)
      ]
    }) : { done: !0, value: null };
  }
}
Object.defineProperties(StructRow.prototype, {
  [Symbol.toStringTag]: { enumerable: !1, configurable: !1, value: "Row" },
  [kParent]: { writable: !0, enumerable: !1, configurable: !1, value: null },
  [kRowIndex]: { writable: !0, enumerable: !1, configurable: !1, value: -1 }
});
class StructRowProxyHandler {
  isExtensible() {
    return !1;
  }
  deleteProperty() {
    return !1;
  }
  preventExtensions() {
    return !0;
  }
  ownKeys(E) {
    return E[kParent].type.children.map((A) => A.name);
  }
  has(E, A) {
    return E[kParent].type.children.some((g) => g.name === A);
  }
  getOwnPropertyDescriptor(E, A) {
    if (E[kParent].type.children.some((g) => g.name === A))
      return { writable: !0, enumerable: !0, configurable: !0 };
  }
  get(E, A) {
    if (Reflect.has(E, A))
      return E[A];
    const g = E[kParent].type.children.findIndex((e) => e.name === A);
    if (g !== -1) {
      const e = instance$4.visit(E[kParent].children[g], E[kRowIndex]);
      return Reflect.set(E, A, e), e;
    }
  }
  set(E, A, g) {
    const e = E[kParent].type.children.findIndex((t) => t.name === A);
    return e !== -1 ? (instance$5.visit(E[kParent].children[e], E[kRowIndex], g), Reflect.set(E, A, g)) : Reflect.has(E, A) || typeof A == "symbol" ? Reflect.set(E, A, g) : !1;
  }
}
const structRowProxyHandler = new StructRowProxyHandler();
class GetVisitor extends Visitor {
}
function wrapGet(o) {
  return (E, A) => E.getValid(A) ? o(E, A) : null;
}
const epochDaysToMs = (o, E) => 864e5 * o[E], getNull = (o, E) => null, getVariableWidthBytes = (o, E, A) => {
  if (A + 1 >= E.length)
    return null;
  const g = bigIntToNumber(E[A]), e = bigIntToNumber(E[A + 1]);
  return o.subarray(g, e);
}, getBool$1 = ({ offset: o, values: E }, A) => {
  const g = o + A;
  return (E[g >> 3] & 1 << g % 8) !== 0;
}, getDateDay = ({ values: o }, E) => epochDaysToMs(o, E), getDateMillisecond = ({ values: o }, E) => bigIntToNumber(o[E]), getNumeric = ({ stride: o, values: E }, A) => E[o * A], getFloat16 = ({ stride: o, values: E }, A) => uint16ToFloat64(E[o * A]), getBigInts = ({ values: o }, E) => o[E], getFixedSizeBinary = ({ stride: o, values: E }, A) => E.subarray(o * A, o * (A + 1)), getBinary = ({ values: o, valueOffsets: E }, A) => getVariableWidthBytes(o, E, A), getUtf8 = ({ values: o, valueOffsets: E }, A) => {
  const g = getVariableWidthBytes(o, E, A);
  return g !== null ? decodeUtf8(g) : null;
}, getInt = ({ values: o }, E) => o[E], getFloat = ({ type: o, values: E }, A) => o.precision !== Precision.HALF ? E[A] : uint16ToFloat64(E[A]), getDate = (o, E) => o.type.unit === DateUnit.DAY ? getDateDay(o, E) : getDateMillisecond(o, E), getTimestampSecond = ({ values: o }, E) => 1e3 * bigIntToNumber(o[E]), getTimestampMillisecond = ({ values: o }, E) => bigIntToNumber(o[E]), getTimestampMicrosecond = ({ values: o }, E) => divideBigInts(o[E], BigInt(1e3)), getTimestampNanosecond = ({ values: o }, E) => divideBigInts(o[E], BigInt(1e6)), getTimestamp = (o, E) => {
  switch (o.type.unit) {
    case TimeUnit.SECOND:
      return getTimestampSecond(o, E);
    case TimeUnit.MILLISECOND:
      return getTimestampMillisecond(o, E);
    case TimeUnit.MICROSECOND:
      return getTimestampMicrosecond(o, E);
    case TimeUnit.NANOSECOND:
      return getTimestampNanosecond(o, E);
  }
}, getTimeSecond = ({ values: o }, E) => o[E], getTimeMillisecond = ({ values: o }, E) => o[E], getTimeMicrosecond = ({ values: o }, E) => o[E], getTimeNanosecond = ({ values: o }, E) => o[E], getTime = (o, E) => {
  switch (o.type.unit) {
    case TimeUnit.SECOND:
      return getTimeSecond(o, E);
    case TimeUnit.MILLISECOND:
      return getTimeMillisecond(o, E);
    case TimeUnit.MICROSECOND:
      return getTimeMicrosecond(o, E);
    case TimeUnit.NANOSECOND:
      return getTimeNanosecond(o, E);
  }
}, getDecimal = ({ values: o, stride: E }, A) => BN.decimal(o.subarray(E * A, E * (A + 1))), getList = (o, E) => {
  const { valueOffsets: A, stride: g, children: e } = o, { [E * g]: t, [E * g + 1]: c } = A, h = e[0].slice(t, c - t);
  return new Vector([h]);
}, getMap = (o, E) => {
  const { valueOffsets: A, children: g } = o, { [E]: e, [E + 1]: t } = A, c = g[0];
  return new MapRow(c.slice(e, t - e));
}, getStruct = (o, E) => new StructRow(o, E), getUnion = (o, E) => o.type.mode === UnionMode.Dense ? getDenseUnion(o, E) : getSparseUnion(o, E), getDenseUnion = (o, E) => {
  const A = o.type.typeIdToChildIndex[o.typeIds[E]], g = o.children[A];
  return instance$4.visit(g, o.valueOffsets[E]);
}, getSparseUnion = (o, E) => {
  const A = o.type.typeIdToChildIndex[o.typeIds[E]], g = o.children[A];
  return instance$4.visit(g, E);
}, getDictionary = (o, E) => {
  var A;
  return (A = o.dictionary) === null || A === void 0 ? void 0 : A.get(o.values[E]);
}, getInterval = (o, E) => o.type.unit === IntervalUnit.MONTH_DAY_NANO ? getIntervalMonthDayNano(o, E) : o.type.unit === IntervalUnit.DAY_TIME ? getIntervalDayTime(o, E) : getIntervalYearMonth(o, E), getIntervalDayTime = ({ values: o }, E) => o.subarray(2 * E, 2 * (E + 1)), getIntervalYearMonth = ({ values: o }, E) => {
  const A = o[E], g = new Int32Array(2);
  return g[0] = Math.trunc(A / 12), g[1] = Math.trunc(A % 12), g;
}, getIntervalMonthDayNano = ({ values: o }, E) => o.subarray(4 * E, 4 * (E + 1)), getDurationSecond = ({ values: o }, E) => o[E], getDurationMillisecond = ({ values: o }, E) => o[E], getDurationMicrosecond = ({ values: o }, E) => o[E], getDurationNanosecond = ({ values: o }, E) => o[E], getDuration = (o, E) => {
  switch (o.type.unit) {
    case TimeUnit.SECOND:
      return getDurationSecond(o, E);
    case TimeUnit.MILLISECOND:
      return getDurationMillisecond(o, E);
    case TimeUnit.MICROSECOND:
      return getDurationMicrosecond(o, E);
    case TimeUnit.NANOSECOND:
      return getDurationNanosecond(o, E);
  }
}, getFixedSizeList = (o, E) => {
  const { stride: A, children: g } = o, t = g[0].slice(E * A, A);
  return new Vector([t]);
};
GetVisitor.prototype.visitNull = wrapGet(getNull);
GetVisitor.prototype.visitBool = wrapGet(getBool$1);
GetVisitor.prototype.visitInt = wrapGet(getInt);
GetVisitor.prototype.visitInt8 = wrapGet(getNumeric);
GetVisitor.prototype.visitInt16 = wrapGet(getNumeric);
GetVisitor.prototype.visitInt32 = wrapGet(getNumeric);
GetVisitor.prototype.visitInt64 = wrapGet(getBigInts);
GetVisitor.prototype.visitUint8 = wrapGet(getNumeric);
GetVisitor.prototype.visitUint16 = wrapGet(getNumeric);
GetVisitor.prototype.visitUint32 = wrapGet(getNumeric);
GetVisitor.prototype.visitUint64 = wrapGet(getBigInts);
GetVisitor.prototype.visitFloat = wrapGet(getFloat);
GetVisitor.prototype.visitFloat16 = wrapGet(getFloat16);
GetVisitor.prototype.visitFloat32 = wrapGet(getNumeric);
GetVisitor.prototype.visitFloat64 = wrapGet(getNumeric);
GetVisitor.prototype.visitUtf8 = wrapGet(getUtf8);
GetVisitor.prototype.visitLargeUtf8 = wrapGet(getUtf8);
GetVisitor.prototype.visitBinary = wrapGet(getBinary);
GetVisitor.prototype.visitLargeBinary = wrapGet(getBinary);
GetVisitor.prototype.visitFixedSizeBinary = wrapGet(getFixedSizeBinary);
GetVisitor.prototype.visitDate = wrapGet(getDate);
GetVisitor.prototype.visitDateDay = wrapGet(getDateDay);
GetVisitor.prototype.visitDateMillisecond = wrapGet(getDateMillisecond);
GetVisitor.prototype.visitTimestamp = wrapGet(getTimestamp);
GetVisitor.prototype.visitTimestampSecond = wrapGet(getTimestampSecond);
GetVisitor.prototype.visitTimestampMillisecond = wrapGet(getTimestampMillisecond);
GetVisitor.prototype.visitTimestampMicrosecond = wrapGet(getTimestampMicrosecond);
GetVisitor.prototype.visitTimestampNanosecond = wrapGet(getTimestampNanosecond);
GetVisitor.prototype.visitTime = wrapGet(getTime);
GetVisitor.prototype.visitTimeSecond = wrapGet(getTimeSecond);
GetVisitor.prototype.visitTimeMillisecond = wrapGet(getTimeMillisecond);
GetVisitor.prototype.visitTimeMicrosecond = wrapGet(getTimeMicrosecond);
GetVisitor.prototype.visitTimeNanosecond = wrapGet(getTimeNanosecond);
GetVisitor.prototype.visitDecimal = wrapGet(getDecimal);
GetVisitor.prototype.visitList = wrapGet(getList);
GetVisitor.prototype.visitStruct = wrapGet(getStruct);
GetVisitor.prototype.visitUnion = wrapGet(getUnion);
GetVisitor.prototype.visitDenseUnion = wrapGet(getDenseUnion);
GetVisitor.prototype.visitSparseUnion = wrapGet(getSparseUnion);
GetVisitor.prototype.visitDictionary = wrapGet(getDictionary);
GetVisitor.prototype.visitInterval = wrapGet(getInterval);
GetVisitor.prototype.visitIntervalDayTime = wrapGet(getIntervalDayTime);
GetVisitor.prototype.visitIntervalYearMonth = wrapGet(getIntervalYearMonth);
GetVisitor.prototype.visitIntervalMonthDayNano = wrapGet(getIntervalMonthDayNano);
GetVisitor.prototype.visitDuration = wrapGet(getDuration);
GetVisitor.prototype.visitDurationSecond = wrapGet(getDurationSecond);
GetVisitor.prototype.visitDurationMillisecond = wrapGet(getDurationMillisecond);
GetVisitor.prototype.visitDurationMicrosecond = wrapGet(getDurationMicrosecond);
GetVisitor.prototype.visitDurationNanosecond = wrapGet(getDurationNanosecond);
GetVisitor.prototype.visitFixedSizeList = wrapGet(getFixedSizeList);
GetVisitor.prototype.visitMap = wrapGet(getMap);
const instance$4 = new GetVisitor(), kKeys = Symbol.for("keys"), kVals = Symbol.for("vals"), kKeysAsStrings = Symbol.for("kKeysAsStrings"), _kKeysAsStrings = Symbol.for("_kKeysAsStrings");
class MapRow {
  constructor(E) {
    return this[kKeys] = new Vector([E.children[0]]).memoize(), this[kVals] = E.children[1], new Proxy(this, new MapRowProxyHandler());
  }
  /** @ignore */
  get [kKeysAsStrings]() {
    return this[_kKeysAsStrings] || (this[_kKeysAsStrings] = Array.from(this[kKeys].toArray(), String));
  }
  [Symbol.iterator]() {
    return new MapRowIterator(this[kKeys], this[kVals]);
  }
  get size() {
    return this[kKeys].length;
  }
  toArray() {
    return Object.values(this.toJSON());
  }
  toJSON() {
    const E = this[kKeys], A = this[kVals], g = {};
    for (let e = -1, t = E.length; ++e < t; )
      g[E.get(e)] = instance$4.visit(A, e);
    return g;
  }
  toString() {
    return `{${[...this].map(([E, A]) => `${valueToString(E)}: ${valueToString(A)}`).join(", ")}}`;
  }
  [Symbol.for("nodejs.util.inspect.custom")]() {
    return this.toString();
  }
}
class MapRowIterator {
  constructor(E, A) {
    this.keys = E, this.vals = A, this.keyIndex = 0, this.numKeys = E.length;
  }
  [Symbol.iterator]() {
    return this;
  }
  next() {
    const E = this.keyIndex;
    return E === this.numKeys ? { done: !0, value: null } : (this.keyIndex++, {
      done: !1,
      value: [
        this.keys.get(E),
        instance$4.visit(this.vals, E)
      ]
    });
  }
}
class MapRowProxyHandler {
  isExtensible() {
    return !1;
  }
  deleteProperty() {
    return !1;
  }
  preventExtensions() {
    return !0;
  }
  ownKeys(E) {
    return E[kKeysAsStrings];
  }
  has(E, A) {
    return E[kKeysAsStrings].includes(A);
  }
  getOwnPropertyDescriptor(E, A) {
    if (E[kKeysAsStrings].indexOf(A) !== -1)
      return { writable: !0, enumerable: !0, configurable: !0 };
  }
  get(E, A) {
    if (Reflect.has(E, A))
      return E[A];
    const g = E[kKeysAsStrings].indexOf(A);
    if (g !== -1) {
      const e = instance$4.visit(Reflect.get(E, kVals), g);
      return Reflect.set(E, A, e), e;
    }
  }
  set(E, A, g) {
    const e = E[kKeysAsStrings].indexOf(A);
    return e !== -1 ? (instance$5.visit(Reflect.get(E, kVals), e, g), Reflect.set(E, A, g)) : Reflect.has(E, A) ? Reflect.set(E, A, g) : !1;
  }
}
Object.defineProperties(MapRow.prototype, {
  [Symbol.toStringTag]: { enumerable: !1, configurable: !1, value: "Row" },
  [kKeys]: { writable: !0, enumerable: !1, configurable: !1, value: null },
  [kVals]: { writable: !0, enumerable: !1, configurable: !1, value: null },
  [_kKeysAsStrings]: { writable: !0, enumerable: !1, configurable: !1, value: null }
});
let tmp;
function clampRange(o, E, A, g) {
  const { length: e = 0 } = o;
  let t = typeof E != "number" ? 0 : E, c = typeof A != "number" ? e : A;
  return t < 0 && (t = (t % e + e) % e), c < 0 && (c = (c % e + e) % e), c < t && (tmp = t, t = c, c = tmp), c > e && (c = e), g ? g(o, t, c) : [t, c];
}
const wrapIndex = (o, E) => o < 0 ? E + o : o, isNaNFast = (o) => o !== o;
function createElementComparator(o) {
  if (typeof o !== "object" || o === null)
    return isNaNFast(o) ? isNaNFast : (A) => A === o;
  if (o instanceof Date) {
    const A = o.valueOf();
    return (g) => g instanceof Date ? g.valueOf() === A : !1;
  }
  return ArrayBuffer.isView(o) ? (A) => A ? compareArrayLike(o, A) : !1 : o instanceof Map ? createMapComparator(o) : Array.isArray(o) ? createArrayLikeComparator(o) : o instanceof Vector ? createVectorComparator(o) : createObjectComparator(o, !0);
}
function createArrayLikeComparator(o) {
  const E = [];
  for (let A = -1, g = o.length; ++A < g; )
    E[A] = createElementComparator(o[A]);
  return createSubElementsComparator(E);
}
function createMapComparator(o) {
  let E = -1;
  const A = [];
  for (const g of o.values())
    A[++E] = createElementComparator(g);
  return createSubElementsComparator(A);
}
function createVectorComparator(o) {
  const E = [];
  for (let A = -1, g = o.length; ++A < g; )
    E[A] = createElementComparator(o.get(A));
  return createSubElementsComparator(E);
}
function createObjectComparator(o, E = !1) {
  const A = Object.keys(o);
  if (!E && A.length === 0)
    return () => !1;
  const g = [];
  for (let e = -1, t = A.length; ++e < t; )
    g[e] = createElementComparator(o[A[e]]);
  return createSubElementsComparator(g, A);
}
function createSubElementsComparator(o, E) {
  return (A) => {
    if (!A || typeof A != "object")
      return !1;
    switch (A.constructor) {
      case Array:
        return compareArray$1(o, A);
      case Map:
        return compareObject(o, A, A.keys());
      case MapRow:
      case StructRow:
      case Object:
      case void 0:
        return compareObject(o, A, E || Object.keys(A));
    }
    return A instanceof Vector ? compareVector(o, A) : !1;
  };
}
function compareArray$1(o, E) {
  const A = o.length;
  if (E.length !== A)
    return !1;
  for (let g = -1; ++g < A; )
    if (!o[g](E[g]))
      return !1;
  return !0;
}
function compareVector(o, E) {
  const A = o.length;
  if (E.length !== A)
    return !1;
  for (let g = -1; ++g < A; )
    if (!o[g](E.get(g)))
      return !1;
  return !0;
}
function compareObject(o, E, A) {
  const g = A[Symbol.iterator](), e = E instanceof Map ? E.keys() : Object.keys(E)[Symbol.iterator](), t = E instanceof Map ? E.values() : Object.values(E)[Symbol.iterator]();
  let c = 0;
  const n = o.length;
  let h = t.next(), d = g.next(), k = e.next();
  for (; c < n && !d.done && !k.done && !h.done && !(d.value !== k.value || !o[c](h.value)); ++c, d = g.next(), k = e.next(), h = t.next())
    ;
  return c === n && d.done && k.done && h.done ? !0 : (g.return && g.return(), e.return && e.return(), t.return && t.return(), !1);
}
const util_vector_ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  clampRange,
  createElementComparator,
  wrapIndex
}, Symbol.toStringTag, { value: "Module" }));
function getBool(o, E, A, g) {
  return (A & 1 << g) !== 0;
}
function getBit(o, E, A, g) {
  return (A & 1 << g) >> g;
}
function setBool(o, E, A) {
  return A ? !!(o[E >> 3] |= 1 << E % 8) || !0 : !(o[E >> 3] &= ~(1 << E % 8)) && !1;
}
function truncateBitmap(o, E, A) {
  const g = A.byteLength + 7 & -8;
  if (o > 0 || A.byteLength < g) {
    const e = new Uint8Array(g);
    return e.set(o % 8 === 0 ? A.subarray(o >> 3) : (
      // Otherwise iterate each bit from the offset and return a new one
      packBools(new BitIterator(A, o, E, null, getBool)).subarray(0, g)
    )), e;
  }
  return A;
}
function packBools(o) {
  const E = [];
  let A = 0, g = 0, e = 0;
  for (const c of o)
    c && (e |= 1 << g), ++g === 8 && (E[A++] = e, e = g = 0);
  (A === 0 || g > 0) && (E[A++] = e);
  const t = new Uint8Array(E.length + 7 & -8);
  return t.set(E), t;
}
class BitIterator {
  constructor(E, A, g, e, t) {
    this.bytes = E, this.length = g, this.context = e, this.get = t, this.bit = A % 8, this.byteIndex = A >> 3, this.byte = E[this.byteIndex++], this.index = 0;
  }
  next() {
    return this.index < this.length ? (this.bit === 8 && (this.bit = 0, this.byte = this.bytes[this.byteIndex++]), {
      value: this.get(this.context, this.index++, this.byte, this.bit++)
    }) : { done: !0, value: null };
  }
  [Symbol.iterator]() {
    return this;
  }
}
function popcnt_bit_range(o, E, A) {
  if (A - E <= 0)
    return 0;
  if (A - E < 8) {
    let t = 0;
    for (const c of new BitIterator(o, E, A - E, o, getBit))
      t += c;
    return t;
  }
  const g = A >> 3 << 3, e = E + (E % 8 === 0 ? 0 : 8 - E % 8);
  return (
    // Get the popcnt of bits between the left hand side, and the next highest multiple of 8
    popcnt_bit_range(o, E, e) + // Get the popcnt of bits between the right hand side, and the next lowest multiple of 8
    popcnt_bit_range(o, g, A) + // Get the popcnt of all bits between the left and right hand sides' multiples of 8
    popcnt_array(o, e >> 3, g - e >> 3)
  );
}
function popcnt_array(o, E, A) {
  let g = 0, e = Math.trunc(E);
  const t = new DataView(o.buffer, o.byteOffset, o.byteLength), c = A === void 0 ? o.byteLength : e + A;
  for (; c - e >= 4; )
    g += popcnt_uint32(t.getUint32(e)), e += 4;
  for (; c - e >= 2; )
    g += popcnt_uint32(t.getUint16(e)), e += 2;
  for (; c - e >= 1; )
    g += popcnt_uint32(t.getUint8(e)), e += 1;
  return g;
}
function popcnt_uint32(o) {
  let E = Math.trunc(o);
  return E = E - (E >>> 1 & 1431655765), E = (E & 858993459) + (E >>> 2 & 858993459), (E + (E >>> 4) & 252645135) * 16843009 >>> 24;
}
const util_bit_ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BitIterator,
  getBit,
  getBool,
  packBools,
  popcnt_array,
  popcnt_bit_range,
  popcnt_uint32,
  setBool,
  truncateBitmap
}, Symbol.toStringTag, { value: "Module" })), kUnknownNullCount = -1;
class Data {
  get typeId() {
    return this.type.typeId;
  }
  get ArrayType() {
    return this.type.ArrayType;
  }
  get buffers() {
    return [this.valueOffsets, this.values, this.nullBitmap, this.typeIds];
  }
  get nullable() {
    if (this._nullCount !== 0) {
      const { type: E } = this;
      return DataType.isSparseUnion(E) ? this.children.some((A) => A.nullable) : DataType.isDenseUnion(E) ? this.children.some((A) => A.nullable) : this.nullBitmap && this.nullBitmap.byteLength > 0;
    }
    return !0;
  }
  get byteLength() {
    let E = 0;
    const { valueOffsets: A, values: g, nullBitmap: e, typeIds: t } = this;
    return A && (E += A.byteLength), g && (E += g.byteLength), e && (E += e.byteLength), t && (E += t.byteLength), this.children.reduce((c, n) => c + n.byteLength, E);
  }
  get nullCount() {
    if (DataType.isUnion(this.type))
      return this.children.reduce((g, e) => g + e.nullCount, 0);
    let E = this._nullCount, A;
    return E <= kUnknownNullCount && (A = this.nullBitmap) && (this._nullCount = E = A.length === 0 ? (
      // no null bitmap, so all values are valid
      0
    ) : this.length - popcnt_bit_range(A, this.offset, this.offset + this.length)), E;
  }
  constructor(E, A, g, e, t, c = [], n) {
    this.type = E, this.children = c, this.dictionary = n, this.offset = Math.floor(Math.max(A || 0, 0)), this.length = Math.floor(Math.max(g || 0, 0)), this._nullCount = Math.floor(Math.max(e || 0, -1));
    let h;
    t instanceof Data ? (this.stride = t.stride, this.values = t.values, this.typeIds = t.typeIds, this.nullBitmap = t.nullBitmap, this.valueOffsets = t.valueOffsets) : (this.stride = strideForType(E), t && ((h = t[0]) && (this.valueOffsets = h), (h = t[1]) && (this.values = h), (h = t[2]) && (this.nullBitmap = h), (h = t[3]) && (this.typeIds = h)));
  }
  getValid(E) {
    const { type: A } = this;
    if (DataType.isUnion(A)) {
      const g = A, e = this.children[g.typeIdToChildIndex[this.typeIds[E]]], t = g.mode === UnionMode.Dense ? this.valueOffsets[E] : E;
      return e.getValid(t);
    }
    if (this.nullable && this.nullCount > 0) {
      const g = this.offset + E;
      return (this.nullBitmap[g >> 3] & 1 << g % 8) !== 0;
    }
    return !0;
  }
  setValid(E, A) {
    let g;
    const { type: e } = this;
    if (DataType.isUnion(e)) {
      const t = e, c = this.children[t.typeIdToChildIndex[this.typeIds[E]]], n = t.mode === UnionMode.Dense ? this.valueOffsets[E] : E;
      g = c.getValid(n), c.setValid(n, A);
    } else {
      let { nullBitmap: t } = this;
      const { offset: c, length: n } = this, h = c + E, d = 1 << h % 8, k = h >> 3;
      (!t || t.byteLength <= k) && (t = new Uint8Array((c + n + 63 & -64) >> 3).fill(255), this.nullCount > 0 ? (t.set(truncateBitmap(c, n, this.nullBitmap), 0), Object.assign(this, { nullBitmap: t })) : Object.assign(this, { nullBitmap: t, _nullCount: 0 }));
      const p = t[k];
      g = (p & d) !== 0, t[k] = A ? p | d : p & ~d;
    }
    return g !== !!A && (this._nullCount = this.nullCount + (A ? -1 : 1)), A;
  }
  clone(E = this.type, A = this.offset, g = this.length, e = this._nullCount, t = this, c = this.children) {
    return new Data(E, A, g, e, t, c, this.dictionary);
  }
  slice(E, A) {
    const { stride: g, typeId: e, children: t } = this, c = +(this._nullCount === 0) - 1, n = e === 16 ? g : 1, h = this._sliceBuffers(E, A, g, e);
    return this.clone(
      this.type,
      this.offset + E,
      A,
      c,
      h,
      // Don't slice children if we have value offsets (the variable-width types)
      t.length === 0 || this.valueOffsets ? t : this._sliceChildren(t, n * E, n * A)
    );
  }
  _changeLengthAndBackfillNullBitmap(E) {
    if (this.typeId === Type.Null)
      return this.clone(this.type, 0, E, 0);
    const { length: A, nullCount: g } = this, e = new Uint8Array((E + 63 & -64) >> 3).fill(255, 0, A >> 3);
    e[A >> 3] = (1 << A - (A & -8)) - 1, g > 0 && e.set(truncateBitmap(this.offset, A, this.nullBitmap), 0);
    const t = this.buffers;
    return t[BufferType.VALIDITY] = e, this.clone(this.type, 0, E, g + (E - A), t);
  }
  _sliceBuffers(E, A, g, e) {
    let t;
    const { buffers: c } = this;
    return (t = c[BufferType.TYPE]) && (c[BufferType.TYPE] = t.subarray(E, E + A)), (t = c[BufferType.OFFSET]) && (c[BufferType.OFFSET] = t.subarray(E, E + A + 1)) || // Otherwise if no offsets, slice the data buffer. Don't slice the data vector for Booleans, since the offset goes by bits not bytes
    (t = c[BufferType.DATA]) && (c[BufferType.DATA] = e === 6 ? t : t.subarray(g * E, g * (E + A))), c;
  }
  _sliceChildren(E, A, g) {
    return E.map((e) => e.slice(A, g));
  }
}
Data.prototype.children = Object.freeze([]);
class MakeDataVisitor extends Visitor {
  visit(E) {
    return this.getVisitFn(E.type).call(this, E);
  }
  visitNull(E) {
    const { ["type"]: A, ["offset"]: g = 0, ["length"]: e = 0 } = E;
    return new Data(A, g, e, e);
  }
  visitBool(E) {
    const { ["type"]: A, ["offset"]: g = 0 } = E, e = toUint8Array(E.nullBitmap), t = toArrayBufferView(A.ArrayType, E.data), { ["length"]: c = t.length >> 3, ["nullCount"]: n = E.nullBitmap ? -1 : 0 } = E;
    return new Data(A, g, c, n, [void 0, t, e]);
  }
  visitInt(E) {
    const { ["type"]: A, ["offset"]: g = 0 } = E, e = toUint8Array(E.nullBitmap), t = toArrayBufferView(A.ArrayType, E.data), { ["length"]: c = t.length, ["nullCount"]: n = E.nullBitmap ? -1 : 0 } = E;
    return new Data(A, g, c, n, [void 0, t, e]);
  }
  visitFloat(E) {
    const { ["type"]: A, ["offset"]: g = 0 } = E, e = toUint8Array(E.nullBitmap), t = toArrayBufferView(A.ArrayType, E.data), { ["length"]: c = t.length, ["nullCount"]: n = E.nullBitmap ? -1 : 0 } = E;
    return new Data(A, g, c, n, [void 0, t, e]);
  }
  visitUtf8(E) {
    const { ["type"]: A, ["offset"]: g = 0 } = E, e = toUint8Array(E.data), t = toUint8Array(E.nullBitmap), c = toInt32Array(E.valueOffsets), { ["length"]: n = c.length - 1, ["nullCount"]: h = E.nullBitmap ? -1 : 0 } = E;
    return new Data(A, g, n, h, [c, e, t]);
  }
  visitLargeUtf8(E) {
    const { ["type"]: A, ["offset"]: g = 0 } = E, e = toUint8Array(E.data), t = toUint8Array(E.nullBitmap), c = toBigInt64Array(E.valueOffsets), { ["length"]: n = c.length - 1, ["nullCount"]: h = E.nullBitmap ? -1 : 0 } = E;
    return new Data(A, g, n, h, [c, e, t]);
  }
  visitBinary(E) {
    const { ["type"]: A, ["offset"]: g = 0 } = E, e = toUint8Array(E.data), t = toUint8Array(E.nullBitmap), c = toInt32Array(E.valueOffsets), { ["length"]: n = c.length - 1, ["nullCount"]: h = E.nullBitmap ? -1 : 0 } = E;
    return new Data(A, g, n, h, [c, e, t]);
  }
  visitLargeBinary(E) {
    const { ["type"]: A, ["offset"]: g = 0 } = E, e = toUint8Array(E.data), t = toUint8Array(E.nullBitmap), c = toBigInt64Array(E.valueOffsets), { ["length"]: n = c.length - 1, ["nullCount"]: h = E.nullBitmap ? -1 : 0 } = E;
    return new Data(A, g, n, h, [c, e, t]);
  }
  visitFixedSizeBinary(E) {
    const { ["type"]: A, ["offset"]: g = 0 } = E, e = toUint8Array(E.nullBitmap), t = toArrayBufferView(A.ArrayType, E.data), { ["length"]: c = t.length / strideForType(A), ["nullCount"]: n = E.nullBitmap ? -1 : 0 } = E;
    return new Data(A, g, c, n, [void 0, t, e]);
  }
  visitDate(E) {
    const { ["type"]: A, ["offset"]: g = 0 } = E, e = toUint8Array(E.nullBitmap), t = toArrayBufferView(A.ArrayType, E.data), { ["length"]: c = t.length / strideForType(A), ["nullCount"]: n = E.nullBitmap ? -1 : 0 } = E;
    return new Data(A, g, c, n, [void 0, t, e]);
  }
  visitTimestamp(E) {
    const { ["type"]: A, ["offset"]: g = 0 } = E, e = toUint8Array(E.nullBitmap), t = toArrayBufferView(A.ArrayType, E.data), { ["length"]: c = t.length / strideForType(A), ["nullCount"]: n = E.nullBitmap ? -1 : 0 } = E;
    return new Data(A, g, c, n, [void 0, t, e]);
  }
  visitTime(E) {
    const { ["type"]: A, ["offset"]: g = 0 } = E, e = toUint8Array(E.nullBitmap), t = toArrayBufferView(A.ArrayType, E.data), { ["length"]: c = t.length / strideForType(A), ["nullCount"]: n = E.nullBitmap ? -1 : 0 } = E;
    return new Data(A, g, c, n, [void 0, t, e]);
  }
  visitDecimal(E) {
    const { ["type"]: A, ["offset"]: g = 0 } = E, e = toUint8Array(E.nullBitmap), t = toArrayBufferView(A.ArrayType, E.data), { ["length"]: c = t.length / strideForType(A), ["nullCount"]: n = E.nullBitmap ? -1 : 0 } = E;
    return new Data(A, g, c, n, [void 0, t, e]);
  }
  visitList(E) {
    const { ["type"]: A, ["offset"]: g = 0, ["child"]: e } = E, t = toUint8Array(E.nullBitmap), c = toInt32Array(E.valueOffsets), { ["length"]: n = c.length - 1, ["nullCount"]: h = E.nullBitmap ? -1 : 0 } = E;
    return new Data(A, g, n, h, [c, void 0, t], [e]);
  }
  visitStruct(E) {
    const { ["type"]: A, ["offset"]: g = 0, ["children"]: e = [] } = E, t = toUint8Array(E.nullBitmap), { length: c = e.reduce((h, { length: d }) => Math.max(h, d), 0), nullCount: n = E.nullBitmap ? -1 : 0 } = E;
    return new Data(A, g, c, n, [void 0, void 0, t], e);
  }
  visitUnion(E) {
    const { ["type"]: A, ["offset"]: g = 0, ["children"]: e = [] } = E, t = toArrayBufferView(A.ArrayType, E.typeIds), { ["length"]: c = t.length, ["nullCount"]: n = -1 } = E;
    if (DataType.isSparseUnion(A))
      return new Data(A, g, c, n, [void 0, void 0, void 0, t], e);
    const h = toInt32Array(E.valueOffsets);
    return new Data(A, g, c, n, [h, void 0, void 0, t], e);
  }
  visitDictionary(E) {
    const { ["type"]: A, ["offset"]: g = 0 } = E, e = toUint8Array(E.nullBitmap), t = toArrayBufferView(A.indices.ArrayType, E.data), { ["dictionary"]: c = new Vector([new MakeDataVisitor().visit({ type: A.dictionary })]) } = E, { ["length"]: n = t.length, ["nullCount"]: h = E.nullBitmap ? -1 : 0 } = E;
    return new Data(A, g, n, h, [void 0, t, e], [], c);
  }
  visitInterval(E) {
    const { ["type"]: A, ["offset"]: g = 0 } = E, e = toUint8Array(E.nullBitmap), t = toArrayBufferView(A.ArrayType, E.data), { ["length"]: c = t.length / strideForType(A), ["nullCount"]: n = E.nullBitmap ? -1 : 0 } = E;
    return new Data(A, g, c, n, [void 0, t, e]);
  }
  visitDuration(E) {
    const { ["type"]: A, ["offset"]: g = 0 } = E, e = toUint8Array(E.nullBitmap), t = toArrayBufferView(A.ArrayType, E.data), { ["length"]: c = t.length, ["nullCount"]: n = E.nullBitmap ? -1 : 0 } = E;
    return new Data(A, g, c, n, [void 0, t, e]);
  }
  visitFixedSizeList(E) {
    const { ["type"]: A, ["offset"]: g = 0, ["child"]: e = new MakeDataVisitor().visit({ type: A.valueType }) } = E, t = toUint8Array(E.nullBitmap), { ["length"]: c = e.length / strideForType(A), ["nullCount"]: n = E.nullBitmap ? -1 : 0 } = E;
    return new Data(A, g, c, n, [void 0, void 0, t], [e]);
  }
  visitMap(E) {
    const { ["type"]: A, ["offset"]: g = 0, ["child"]: e = new MakeDataVisitor().visit({ type: A.childType }) } = E, t = toUint8Array(E.nullBitmap), c = toInt32Array(E.valueOffsets), { ["length"]: n = c.length - 1, ["nullCount"]: h = E.nullBitmap ? -1 : 0 } = E;
    return new Data(A, g, n, h, [c, void 0, t], [e]);
  }
}
const makeDataVisitor = new MakeDataVisitor();
function makeData(o) {
  return makeDataVisitor.visit(o);
}
class ChunkedIterator {
  constructor(E = 0, A) {
    this.numChunks = E, this.getChunkIterator = A, this.chunkIndex = 0, this.chunkIterator = this.getChunkIterator(0);
  }
  next() {
    for (; this.chunkIndex < this.numChunks; ) {
      const E = this.chunkIterator.next();
      if (!E.done)
        return E;
      ++this.chunkIndex < this.numChunks && (this.chunkIterator = this.getChunkIterator(this.chunkIndex));
    }
    return { done: !0, value: null };
  }
  [Symbol.iterator]() {
    return this;
  }
}
function computeChunkNullable(o) {
  return o.some((E) => E.nullable);
}
function computeChunkNullCounts(o) {
  return o.reduce((E, A) => E + A.nullCount, 0);
}
function computeChunkOffsets(o) {
  return o.reduce((E, A, g) => (E[g + 1] = E[g] + A.length, E), new Uint32Array(o.length + 1));
}
function sliceChunks$1(o, E, A, g) {
  const e = [];
  for (let t = -1, c = o.length; ++t < c; ) {
    const n = o[t], h = E[t], { length: d } = n;
    if (h >= g)
      break;
    if (A >= h + d)
      continue;
    if (h >= A && h + d <= g) {
      e.push(n);
      continue;
    }
    const k = Math.max(0, A - h), p = Math.min(g - h, d);
    e.push(n.slice(k, p - k));
  }
  return e.length === 0 && e.push(o[0].slice(0, 0)), e;
}
function binarySearch(o, E, A, g) {
  let e = 0, t = 0, c = E.length - 1;
  do {
    if (e >= c - 1)
      return A < E[c] ? g(o, e, A - E[e]) : null;
    t = e + Math.trunc((c - e) * 0.5), A < E[t] ? c = t : e = t;
  } while (e < c);
}
function isChunkedValid(o, E) {
  return o.getValid(E);
}
function wrapChunkedCall1(o) {
  function E(A, g, e) {
    return o(A[g], e);
  }
  return function(A) {
    const g = this.data;
    return binarySearch(g, this._offsets, A, E);
  };
}
function wrapChunkedCall2(o) {
  let E;
  function A(g, e, t) {
    return o(g[e], t, E);
  }
  return function(g, e) {
    const t = this.data;
    E = e;
    const c = binarySearch(t, this._offsets, g, A);
    return E = void 0, c;
  };
}
function wrapChunkedIndexOf(o) {
  let E;
  function A(g, e, t) {
    let c = t, n = 0, h = 0;
    for (let d = e - 1, k = g.length; ++d < k; ) {
      const p = g[d];
      if (~(n = o(p, E, c)))
        return h + n;
      c = 0, h += p.length;
    }
    return -1;
  }
  return function(g, e) {
    E = g;
    const t = this.data, c = typeof e != "number" ? A(t, 0, 0) : binarySearch(t, this._offsets, e, A);
    return E = void 0, c;
  };
}
class IndexOfVisitor extends Visitor {
}
function nullIndexOf(o, E) {
  return E === null && o.length > 0 ? 0 : -1;
}
function indexOfNull(o, E) {
  const { nullBitmap: A } = o;
  if (!A || o.nullCount <= 0)
    return -1;
  let g = 0;
  for (const e of new BitIterator(A, o.offset + (E || 0), o.length, A, getBool)) {
    if (!e)
      return g;
    ++g;
  }
  return -1;
}
function indexOfValue(o, E, A) {
  if (E === void 0)
    return -1;
  if (E === null)
    switch (o.typeId) {
      // Unions don't have a nullBitmap of its own, so compare the `searchElement` to `get()`.
      case Type.Union:
        break;
      // Dictionaries do have a nullBitmap, but their dictionary could also have null elements.
      case Type.Dictionary:
        break;
      // All other types can iterate the null bitmap
      default:
        return indexOfNull(o, A);
    }
  const g = instance$4.getVisitFn(o), e = createElementComparator(E);
  for (let t = (A || 0) - 1, c = o.length; ++t < c; )
    if (e(g(o, t)))
      return t;
  return -1;
}
function indexOfUnion(o, E, A) {
  const g = instance$4.getVisitFn(o), e = createElementComparator(E);
  for (let t = (A || 0) - 1, c = o.length; ++t < c; )
    if (e(g(o, t)))
      return t;
  return -1;
}
IndexOfVisitor.prototype.visitNull = nullIndexOf;
IndexOfVisitor.prototype.visitBool = indexOfValue;
IndexOfVisitor.prototype.visitInt = indexOfValue;
IndexOfVisitor.prototype.visitInt8 = indexOfValue;
IndexOfVisitor.prototype.visitInt16 = indexOfValue;
IndexOfVisitor.prototype.visitInt32 = indexOfValue;
IndexOfVisitor.prototype.visitInt64 = indexOfValue;
IndexOfVisitor.prototype.visitUint8 = indexOfValue;
IndexOfVisitor.prototype.visitUint16 = indexOfValue;
IndexOfVisitor.prototype.visitUint32 = indexOfValue;
IndexOfVisitor.prototype.visitUint64 = indexOfValue;
IndexOfVisitor.prototype.visitFloat = indexOfValue;
IndexOfVisitor.prototype.visitFloat16 = indexOfValue;
IndexOfVisitor.prototype.visitFloat32 = indexOfValue;
IndexOfVisitor.prototype.visitFloat64 = indexOfValue;
IndexOfVisitor.prototype.visitUtf8 = indexOfValue;
IndexOfVisitor.prototype.visitLargeUtf8 = indexOfValue;
IndexOfVisitor.prototype.visitBinary = indexOfValue;
IndexOfVisitor.prototype.visitLargeBinary = indexOfValue;
IndexOfVisitor.prototype.visitFixedSizeBinary = indexOfValue;
IndexOfVisitor.prototype.visitDate = indexOfValue;
IndexOfVisitor.prototype.visitDateDay = indexOfValue;
IndexOfVisitor.prototype.visitDateMillisecond = indexOfValue;
IndexOfVisitor.prototype.visitTimestamp = indexOfValue;
IndexOfVisitor.prototype.visitTimestampSecond = indexOfValue;
IndexOfVisitor.prototype.visitTimestampMillisecond = indexOfValue;
IndexOfVisitor.prototype.visitTimestampMicrosecond = indexOfValue;
IndexOfVisitor.prototype.visitTimestampNanosecond = indexOfValue;
IndexOfVisitor.prototype.visitTime = indexOfValue;
IndexOfVisitor.prototype.visitTimeSecond = indexOfValue;
IndexOfVisitor.prototype.visitTimeMillisecond = indexOfValue;
IndexOfVisitor.prototype.visitTimeMicrosecond = indexOfValue;
IndexOfVisitor.prototype.visitTimeNanosecond = indexOfValue;
IndexOfVisitor.prototype.visitDecimal = indexOfValue;
IndexOfVisitor.prototype.visitList = indexOfValue;
IndexOfVisitor.prototype.visitStruct = indexOfValue;
IndexOfVisitor.prototype.visitUnion = indexOfValue;
IndexOfVisitor.prototype.visitDenseUnion = indexOfUnion;
IndexOfVisitor.prototype.visitSparseUnion = indexOfUnion;
IndexOfVisitor.prototype.visitDictionary = indexOfValue;
IndexOfVisitor.prototype.visitInterval = indexOfValue;
IndexOfVisitor.prototype.visitIntervalDayTime = indexOfValue;
IndexOfVisitor.prototype.visitIntervalYearMonth = indexOfValue;
IndexOfVisitor.prototype.visitIntervalMonthDayNano = indexOfValue;
IndexOfVisitor.prototype.visitDuration = indexOfValue;
IndexOfVisitor.prototype.visitDurationSecond = indexOfValue;
IndexOfVisitor.prototype.visitDurationMillisecond = indexOfValue;
IndexOfVisitor.prototype.visitDurationMicrosecond = indexOfValue;
IndexOfVisitor.prototype.visitDurationNanosecond = indexOfValue;
IndexOfVisitor.prototype.visitFixedSizeList = indexOfValue;
IndexOfVisitor.prototype.visitMap = indexOfValue;
const instance$3 = new IndexOfVisitor();
class IteratorVisitor extends Visitor {
}
function vectorIterator(o) {
  const { type: E } = o;
  if (o.nullCount === 0 && o.stride === 1 && // Don't defer to native iterator for timestamps since Numbers are expected
  // (DataType.isTimestamp(type)) && type.unit === TimeUnit.MILLISECOND ||
  (DataType.isInt(E) && E.bitWidth !== 64 || DataType.isTime(E) && E.bitWidth !== 64 || DataType.isFloat(E) && E.precision !== Precision.HALF))
    return new ChunkedIterator(o.data.length, (g) => {
      const e = o.data[g];
      return e.values.subarray(0, e.length)[Symbol.iterator]();
    });
  let A = 0;
  return new ChunkedIterator(o.data.length, (g) => {
    const t = o.data[g].length, c = o.slice(A, A + t);
    return A += t, new VectorIterator(c);
  });
}
class VectorIterator {
  constructor(E) {
    this.vector = E, this.index = 0;
  }
  next() {
    return this.index < this.vector.length ? {
      value: this.vector.get(this.index++)
    } : { done: !0, value: null };
  }
  [Symbol.iterator]() {
    return this;
  }
}
IteratorVisitor.prototype.visitNull = vectorIterator;
IteratorVisitor.prototype.visitBool = vectorIterator;
IteratorVisitor.prototype.visitInt = vectorIterator;
IteratorVisitor.prototype.visitInt8 = vectorIterator;
IteratorVisitor.prototype.visitInt16 = vectorIterator;
IteratorVisitor.prototype.visitInt32 = vectorIterator;
IteratorVisitor.prototype.visitInt64 = vectorIterator;
IteratorVisitor.prototype.visitUint8 = vectorIterator;
IteratorVisitor.prototype.visitUint16 = vectorIterator;
IteratorVisitor.prototype.visitUint32 = vectorIterator;
IteratorVisitor.prototype.visitUint64 = vectorIterator;
IteratorVisitor.prototype.visitFloat = vectorIterator;
IteratorVisitor.prototype.visitFloat16 = vectorIterator;
IteratorVisitor.prototype.visitFloat32 = vectorIterator;
IteratorVisitor.prototype.visitFloat64 = vectorIterator;
IteratorVisitor.prototype.visitUtf8 = vectorIterator;
IteratorVisitor.prototype.visitLargeUtf8 = vectorIterator;
IteratorVisitor.prototype.visitBinary = vectorIterator;
IteratorVisitor.prototype.visitLargeBinary = vectorIterator;
IteratorVisitor.prototype.visitFixedSizeBinary = vectorIterator;
IteratorVisitor.prototype.visitDate = vectorIterator;
IteratorVisitor.prototype.visitDateDay = vectorIterator;
IteratorVisitor.prototype.visitDateMillisecond = vectorIterator;
IteratorVisitor.prototype.visitTimestamp = vectorIterator;
IteratorVisitor.prototype.visitTimestampSecond = vectorIterator;
IteratorVisitor.prototype.visitTimestampMillisecond = vectorIterator;
IteratorVisitor.prototype.visitTimestampMicrosecond = vectorIterator;
IteratorVisitor.prototype.visitTimestampNanosecond = vectorIterator;
IteratorVisitor.prototype.visitTime = vectorIterator;
IteratorVisitor.prototype.visitTimeSecond = vectorIterator;
IteratorVisitor.prototype.visitTimeMillisecond = vectorIterator;
IteratorVisitor.prototype.visitTimeMicrosecond = vectorIterator;
IteratorVisitor.prototype.visitTimeNanosecond = vectorIterator;
IteratorVisitor.prototype.visitDecimal = vectorIterator;
IteratorVisitor.prototype.visitList = vectorIterator;
IteratorVisitor.prototype.visitStruct = vectorIterator;
IteratorVisitor.prototype.visitUnion = vectorIterator;
IteratorVisitor.prototype.visitDenseUnion = vectorIterator;
IteratorVisitor.prototype.visitSparseUnion = vectorIterator;
IteratorVisitor.prototype.visitDictionary = vectorIterator;
IteratorVisitor.prototype.visitInterval = vectorIterator;
IteratorVisitor.prototype.visitIntervalDayTime = vectorIterator;
IteratorVisitor.prototype.visitIntervalYearMonth = vectorIterator;
IteratorVisitor.prototype.visitIntervalMonthDayNano = vectorIterator;
IteratorVisitor.prototype.visitDuration = vectorIterator;
IteratorVisitor.prototype.visitDurationSecond = vectorIterator;
IteratorVisitor.prototype.visitDurationMillisecond = vectorIterator;
IteratorVisitor.prototype.visitDurationMicrosecond = vectorIterator;
IteratorVisitor.prototype.visitDurationNanosecond = vectorIterator;
IteratorVisitor.prototype.visitFixedSizeList = vectorIterator;
IteratorVisitor.prototype.visitMap = vectorIterator;
const instance$2 = new IteratorVisitor();
var _a$3;
const visitorsByTypeId = {}, vectorPrototypesByTypeId = {};
class Vector {
  constructor(E) {
    var A, g, e;
    const t = E[0] instanceof Vector ? E.flatMap((n) => n.data) : E;
    if (t.length === 0 || t.some((n) => !(n instanceof Data)))
      throw new TypeError("Vector constructor expects an Array of Data instances.");
    const c = (A = t[0]) === null || A === void 0 ? void 0 : A.type;
    switch (t.length) {
      case 0:
        this._offsets = [0];
        break;
      case 1: {
        const { get: n, set: h, indexOf: d } = visitorsByTypeId[c.typeId], k = t[0];
        this.isValid = (p) => isChunkedValid(k, p), this.get = (p) => n(k, p), this.set = (p, M) => h(k, p, M), this.indexOf = (p) => d(k, p), this._offsets = [0, k.length];
        break;
      }
      default:
        Object.setPrototypeOf(this, vectorPrototypesByTypeId[c.typeId]), this._offsets = computeChunkOffsets(t);
        break;
    }
    this.data = t, this.type = c, this.stride = strideForType(c), this.numChildren = (e = (g = c.children) === null || g === void 0 ? void 0 : g.length) !== null && e !== void 0 ? e : 0, this.length = this._offsets.at(-1);
  }
  /**
   * The aggregate size (in bytes) of this Vector's buffers and/or child Vectors.
   */
  get byteLength() {
    return this.data.reduce((E, A) => E + A.byteLength, 0);
  }
  /**
   * Whether this Vector's elements can contain null values.
   */
  get nullable() {
    return computeChunkNullable(this.data);
  }
  /**
   * The number of null elements in this Vector.
   */
  get nullCount() {
    return computeChunkNullCounts(this.data);
  }
  /**
   * The Array or TypedArray constructor used for the JS representation
   *  of the element's values in {@link Vector.prototype.toArray `toArray()`}.
   */
  get ArrayType() {
    return this.type.ArrayType;
  }
  /**
   * The name that should be printed when the Vector is logged in a message.
   */
  get [Symbol.toStringTag]() {
    return `${this.VectorName}<${this.type[Symbol.toStringTag]}>`;
  }
  /**
   * The name of this Vector.
   */
  get VectorName() {
    return `${Type[this.type.typeId]}Vector`;
  }
  /**
   * Check whether an element is null.
   * @param index The index at which to read the validity bitmap.
   */
  // @ts-ignore
  isValid(E) {
    return !1;
  }
  /**
   * Get an element value by position.
   * @param index The index of the element to read.
   */
  // @ts-ignore
  get(E) {
    return null;
  }
  /**
   * Get an element value by position.
   * @param index The index of the element to read. A negative index will count back from the last element.
   */
  at(E) {
    return this.get(wrapIndex(E, this.length));
  }
  /**
   * Set an element value by position.
   * @param index The index of the element to write.
   * @param value The value to set.
   */
  // @ts-ignore
  set(E, A) {
  }
  /**
   * Retrieve the index of the first occurrence of a value in an Vector.
   * @param element The value to locate in the Vector.
   * @param offset The index at which to begin the search. If offset is omitted, the search starts at index 0.
   */
  // @ts-ignore
  indexOf(E, A) {
    return -1;
  }
  includes(E, A) {
    return this.indexOf(E, A) > -1;
  }
  /**
   * Iterator for the Vector's elements.
   */
  [Symbol.iterator]() {
    return instance$2.visit(this);
  }
  /**
   * Combines two or more Vectors of the same type.
   * @param others Additional Vectors to add to the end of this Vector.
   */
  concat(...E) {
    return new Vector(this.data.concat(E.flatMap((A) => A.data).flat(Number.POSITIVE_INFINITY)));
  }
  /**
   * Return a zero-copy sub-section of this Vector.
   * @param start The beginning of the specified portion of the Vector.
   * @param end The end of the specified portion of the Vector. This is exclusive of the element at the index 'end'.
   */
  slice(E, A) {
    return new Vector(clampRange(this, E, A, ({ data: g, _offsets: e }, t, c) => sliceChunks$1(g, e, t, c)));
  }
  toJSON() {
    return [...this];
  }
  /**
   * Return a JavaScript Array or TypedArray of the Vector's elements.
   *
   * @note If this Vector contains a single Data chunk and the Vector's type is a
   *  primitive numeric type corresponding to one of the JavaScript TypedArrays, this
   *  method returns a zero-copy slice of the underlying TypedArray values. If there's
   *  more than one chunk, the resulting TypedArray will be a copy of the data from each
   *  chunk's underlying TypedArray values.
   *
   * @returns An Array or TypedArray of the Vector's elements, based on the Vector's DataType.
   */
  toArray() {
    const { type: E, data: A, length: g, stride: e, ArrayType: t } = this;
    switch (E.typeId) {
      case Type.Int:
      case Type.Float:
      case Type.Decimal:
      case Type.Time:
      case Type.Timestamp:
        switch (A.length) {
          case 0:
            return new t();
          case 1:
            return A[0].values.subarray(0, g * e);
          default:
            return A.reduce((c, { values: n, length: h }) => (c.array.set(n.subarray(0, h * e), c.offset), c.offset += h * e, c), { array: new t(g * e), offset: 0 }).array;
        }
    }
    return [...this];
  }
  /**
   * Returns a string representation of the Vector.
   *
   * @returns A string representation of the Vector.
   */
  toString() {
    return `[${[...this].join(",")}]`;
  }
  /**
   * Returns a child Vector by name, or null if this Vector has no child with the given name.
   * @param name The name of the child to retrieve.
   */
  getChild(E) {
    var A;
    return this.getChildAt((A = this.type.children) === null || A === void 0 ? void 0 : A.findIndex((g) => g.name === E));
  }
  /**
   * Returns a child Vector by index, or null if this Vector has no child at the supplied index.
   * @param index The index of the child to retrieve.
   */
  getChildAt(E) {
    return E > -1 && E < this.numChildren ? new Vector(this.data.map(({ children: A }) => A[E])) : null;
  }
  get isMemoized() {
    return DataType.isDictionary(this.type) ? this.data[0].dictionary.isMemoized : !1;
  }
  /**
   * Adds memoization to the Vector's {@link get} method. For dictionary
   * vectors, this method return a vector that memoizes only the dictionary
   * values.
   *
   * Memoization is very useful when decoding a value is expensive such as
   * Utf8. The memoization creates a cache of the size of the Vector and
   * therefore increases memory usage.
   *
   * @returns A new vector that memoizes calls to {@link get}.
   */
  memoize() {
    if (DataType.isDictionary(this.type)) {
      const E = new MemoizedVector(this.data[0].dictionary), A = this.data.map((g) => {
        const e = g.clone();
        return e.dictionary = E, e;
      });
      return new Vector(A);
    }
    return new MemoizedVector(this);
  }
  /**
   * Returns a vector without memoization of the {@link get} method. If this
   * vector is not memoized, this method returns this vector.
   *
   * @returns A new vector without memoization.
   */
  unmemoize() {
    if (DataType.isDictionary(this.type) && this.isMemoized) {
      const E = this.data[0].dictionary.unmemoize(), A = this.data.map((g) => {
        const e = g.clone();
        return e.dictionary = E, e;
      });
      return new Vector(A);
    }
    return this;
  }
}
_a$3 = Symbol.toStringTag;
Vector[_a$3] = ((o) => {
  o.type = DataType.prototype, o.data = [], o.length = 0, o.stride = 1, o.numChildren = 0, o._offsets = new Uint32Array([0]), o[Symbol.isConcatSpreadable] = !0;
  const E = Object.keys(Type).map((A) => Type[A]).filter((A) => typeof A == "number" && A !== Type.NONE);
  for (const A of E) {
    const g = instance$4.getVisitFnByTypeId(A), e = instance$5.getVisitFnByTypeId(A), t = instance$3.getVisitFnByTypeId(A);
    visitorsByTypeId[A] = { get: g, set: e, indexOf: t }, vectorPrototypesByTypeId[A] = Object.create(o, {
      isValid: { value: wrapChunkedCall1(isChunkedValid) },
      get: { value: wrapChunkedCall1(instance$4.getVisitFnByTypeId(A)) },
      set: { value: wrapChunkedCall2(instance$5.getVisitFnByTypeId(A)) },
      indexOf: { value: wrapChunkedIndexOf(instance$3.getVisitFnByTypeId(A)) }
    });
  }
  return "Vector";
})(Vector.prototype);
class MemoizedVector extends Vector {
  constructor(E) {
    super(E.data);
    const A = this.get, g = this.set, e = this.slice, t = new Array(this.length);
    Object.defineProperty(this, "get", {
      value(c) {
        const n = t[c];
        if (n !== void 0)
          return n;
        const h = A.call(this, c);
        return t[c] = h, h;
      }
    }), Object.defineProperty(this, "set", {
      value(c, n) {
        g.call(this, c, n), t[c] = n;
      }
    }), Object.defineProperty(this, "slice", {
      value: (c, n) => new MemoizedVector(e.call(this, c, n))
    }), Object.defineProperty(this, "isMemoized", { value: !0 }), Object.defineProperty(this, "unmemoize", {
      value: () => new Vector(this.data)
    }), Object.defineProperty(this, "memoize", {
      value: () => this
    });
  }
}
class Block {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(E, A) {
    return this.bb_pos = E, this.bb = A, this;
  }
  /**
   * Index to the start of the RecordBlock (note this is past the Message header)
   */
  offset() {
    return this.bb.readInt64(this.bb_pos);
  }
  /**
   * Length of the metadata
   */
  metaDataLength() {
    return this.bb.readInt32(this.bb_pos + 8);
  }
  /**
   * Length of the data (this is aligned so there can be a gap between this and
   * the metadata).
   */
  bodyLength() {
    return this.bb.readInt64(this.bb_pos + 16);
  }
  static sizeOf() {
    return 24;
  }
  static createBlock(E, A, g, e) {
    return E.prep(8, 24), E.writeInt64(BigInt(e ?? 0)), E.pad(4), E.writeInt32(g), E.writeInt64(BigInt(A ?? 0)), E.offset();
  }
}
class Footer {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(E, A) {
    return this.bb_pos = E, this.bb = A, this;
  }
  static getRootAsFooter(E, A) {
    return (A || new Footer()).__init(E.readInt32(E.position()) + E.position(), E);
  }
  static getSizePrefixedRootAsFooter(E, A) {
    return E.setPosition(E.position() + SIZE_PREFIX_LENGTH), (A || new Footer()).__init(E.readInt32(E.position()) + E.position(), E);
  }
  version() {
    const E = this.bb.__offset(this.bb_pos, 4);
    return E ? this.bb.readInt16(this.bb_pos + E) : MetadataVersion.V1;
  }
  schema(E) {
    const A = this.bb.__offset(this.bb_pos, 6);
    return A ? (E || new Schema$3()).__init(this.bb.__indirect(this.bb_pos + A), this.bb) : null;
  }
  dictionaries(E, A) {
    const g = this.bb.__offset(this.bb_pos, 8);
    return g ? (A || new Block()).__init(this.bb.__vector(this.bb_pos + g) + E * 24, this.bb) : null;
  }
  dictionariesLength() {
    const E = this.bb.__offset(this.bb_pos, 8);
    return E ? this.bb.__vector_len(this.bb_pos + E) : 0;
  }
  recordBatches(E, A) {
    const g = this.bb.__offset(this.bb_pos, 10);
    return g ? (A || new Block()).__init(this.bb.__vector(this.bb_pos + g) + E * 24, this.bb) : null;
  }
  recordBatchesLength() {
    const E = this.bb.__offset(this.bb_pos, 10);
    return E ? this.bb.__vector_len(this.bb_pos + E) : 0;
  }
  /**
   * User-defined metadata
   */
  customMetadata(E, A) {
    const g = this.bb.__offset(this.bb_pos, 12);
    return g ? (A || new KeyValue()).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + g) + E * 4), this.bb) : null;
  }
  customMetadataLength() {
    const E = this.bb.__offset(this.bb_pos, 12);
    return E ? this.bb.__vector_len(this.bb_pos + E) : 0;
  }
  static startFooter(E) {
    E.startObject(5);
  }
  static addVersion(E, A) {
    E.addFieldInt16(0, A, MetadataVersion.V1);
  }
  static addSchema(E, A) {
    E.addFieldOffset(1, A, 0);
  }
  static addDictionaries(E, A) {
    E.addFieldOffset(2, A, 0);
  }
  static startDictionariesVector(E, A) {
    E.startVector(24, A, 8);
  }
  static addRecordBatches(E, A) {
    E.addFieldOffset(3, A, 0);
  }
  static startRecordBatchesVector(E, A) {
    E.startVector(24, A, 8);
  }
  static addCustomMetadata(E, A) {
    E.addFieldOffset(4, A, 0);
  }
  static createCustomMetadataVector(E, A) {
    E.startVector(4, A.length, 4);
    for (let g = A.length - 1; g >= 0; g--)
      E.addOffset(A[g]);
    return E.endVector();
  }
  static startCustomMetadataVector(E, A) {
    E.startVector(4, A, 4);
  }
  static endFooter(E) {
    return E.endObject();
  }
  static finishFooterBuffer(E, A) {
    E.finish(A);
  }
  static finishSizePrefixedFooterBuffer(E, A) {
    E.finish(A, void 0, !0);
  }
}
let Schema$2 = class Zg {
  constructor(E = [], A, g, e = MetadataVersion.V5) {
    this.fields = E || [], this.metadata = A || /* @__PURE__ */ new Map(), g || (g = generateDictionaryMap(this.fields)), this.dictionaries = g, this.metadataVersion = e;
  }
  get [Symbol.toStringTag]() {
    return "Schema";
  }
  get names() {
    return this.fields.map((E) => E.name);
  }
  toString() {
    return `Schema<{ ${this.fields.map((E, A) => `${A}: ${E}`).join(", ")} }>`;
  }
  /**
   * Construct a new Schema containing only specified fields.
   *
   * @param fieldNames Names of fields to keep.
   * @returns A new Schema of fields matching the specified names.
   */
  select(E) {
    const A = new Set(E), g = this.fields.filter((e) => A.has(e.name));
    return new Zg(g, this.metadata);
  }
  /**
   * Construct a new Schema containing only fields at the specified indices.
   *
   * @param fieldIndices Indices of fields to keep.
   * @returns A new Schema of fields at the specified indices.
   */
  selectAt(E) {
    const A = E.map((g) => this.fields[g]).filter(Boolean);
    return new Zg(A, this.metadata);
  }
  assign(...E) {
    const A = E[0] instanceof Zg ? E[0] : Array.isArray(E[0]) ? new Zg(E[0]) : new Zg(E), g = [...this.fields], e = mergeMaps(mergeMaps(/* @__PURE__ */ new Map(), this.metadata), A.metadata), t = A.fields.filter((n) => {
      const h = g.findIndex((d) => d.name === n.name);
      return ~h ? (g[h] = n.clone({
        metadata: mergeMaps(mergeMaps(/* @__PURE__ */ new Map(), g[h].metadata), n.metadata)
      })) && !1 : !0;
    }), c = generateDictionaryMap(t, /* @__PURE__ */ new Map());
    return new Zg([...g, ...t], e, new Map([...this.dictionaries, ...c]));
  }
};
Schema$2.prototype.fields = null;
Schema$2.prototype.metadata = null;
Schema$2.prototype.dictionaries = null;
class Field {
  /** @nocollapse */
  static new(...E) {
    let [A, g, e, t] = E;
    return E[0] && typeof E[0] == "object" && ({ name: A } = E[0], g === void 0 && (g = E[0].type), e === void 0 && (e = E[0].nullable), t === void 0 && (t = E[0].metadata)), new Field(`${A}`, g, e, t);
  }
  constructor(E, A, g = !1, e) {
    this.name = E, this.type = A, this.nullable = g, this.metadata = e || /* @__PURE__ */ new Map();
  }
  get typeId() {
    return this.type.typeId;
  }
  get [Symbol.toStringTag]() {
    return "Field";
  }
  toString() {
    return `${this.name}: ${this.type}`;
  }
  clone(...E) {
    let [A, g, e, t] = E;
    return !E[0] || typeof E[0] != "object" ? [A = this.name, g = this.type, e = this.nullable, t = this.metadata] = E : { name: A = this.name, type: g = this.type, nullable: e = this.nullable, metadata: t = this.metadata } = E[0], Field.new(A, g, e, t);
  }
}
Field.prototype.type = null;
Field.prototype.name = null;
Field.prototype.nullable = null;
Field.prototype.metadata = null;
function mergeMaps(o, E) {
  return new Map([...o || /* @__PURE__ */ new Map(), ...E || /* @__PURE__ */ new Map()]);
}
function generateDictionaryMap(o, E = /* @__PURE__ */ new Map()) {
  for (let A = -1, g = o.length; ++A < g; ) {
    const t = o[A].type;
    if (DataType.isDictionary(t)) {
      if (!E.has(t.id))
        E.set(t.id, t.dictionary);
      else if (E.get(t.id) !== t.dictionary)
        throw new Error("Cannot create Schema containing two different dictionaries with the same Id");
    }
    t.children && t.children.length > 0 && generateDictionaryMap(t.children, E);
  }
  return E;
}
var Builder$1 = Builder$2, ByteBuffer$1 = ByteBuffer$2;
class Footer_ {
  /** @nocollapse */
  static decode(E) {
    E = new ByteBuffer$1(toUint8Array(E));
    const A = Footer.getRootAsFooter(E), g = Schema$2.decode(A.schema(), /* @__PURE__ */ new Map(), A.version());
    return new OffHeapFooter(g, A);
  }
  /** @nocollapse */
  static encode(E) {
    const A = new Builder$1(), g = Schema$2.encode(A, E.schema);
    Footer.startRecordBatchesVector(A, E.numRecordBatches);
    for (const c of [...E.recordBatches()].slice().reverse())
      FileBlock.encode(A, c);
    const e = A.endVector();
    Footer.startDictionariesVector(A, E.numDictionaries);
    for (const c of [...E.dictionaryBatches()].slice().reverse())
      FileBlock.encode(A, c);
    const t = A.endVector();
    return Footer.startFooter(A), Footer.addSchema(A, g), Footer.addVersion(A, MetadataVersion.V5), Footer.addRecordBatches(A, e), Footer.addDictionaries(A, t), Footer.finishFooterBuffer(A, Footer.endFooter(A)), A.asUint8Array();
  }
  get numRecordBatches() {
    return this._recordBatches.length;
  }
  get numDictionaries() {
    return this._dictionaryBatches.length;
  }
  constructor(E, A = MetadataVersion.V5, g, e) {
    this.schema = E, this.version = A, g && (this._recordBatches = g), e && (this._dictionaryBatches = e);
  }
  *recordBatches() {
    for (let E, A = -1, g = this.numRecordBatches; ++A < g; )
      (E = this.getRecordBatch(A)) && (yield E);
  }
  *dictionaryBatches() {
    for (let E, A = -1, g = this.numDictionaries; ++A < g; )
      (E = this.getDictionaryBatch(A)) && (yield E);
  }
  getRecordBatch(E) {
    return E >= 0 && E < this.numRecordBatches && this._recordBatches[E] || null;
  }
  getDictionaryBatch(E) {
    return E >= 0 && E < this.numDictionaries && this._dictionaryBatches[E] || null;
  }
}
class OffHeapFooter extends Footer_ {
  get numRecordBatches() {
    return this._footer.recordBatchesLength();
  }
  get numDictionaries() {
    return this._footer.dictionariesLength();
  }
  constructor(E, A) {
    super(E, A.version()), this._footer = A;
  }
  getRecordBatch(E) {
    if (E >= 0 && E < this.numRecordBatches) {
      const A = this._footer.recordBatches(E);
      if (A)
        return FileBlock.decode(A);
    }
    return null;
  }
  getDictionaryBatch(E) {
    if (E >= 0 && E < this.numDictionaries) {
      const A = this._footer.dictionaries(E);
      if (A)
        return FileBlock.decode(A);
    }
    return null;
  }
}
class FileBlock {
  /** @nocollapse */
  static decode(E) {
    return new FileBlock(E.metaDataLength(), E.bodyLength(), E.offset());
  }
  /** @nocollapse */
  static encode(E, A) {
    const { metaDataLength: g } = A, e = BigInt(A.offset), t = BigInt(A.bodyLength);
    return Block.createBlock(E, e, g, t);
  }
  constructor(E, A, g) {
    this.metaDataLength = E, this.offset = bigIntToNumber(g), this.bodyLength = bigIntToNumber(A);
  }
}
let Message$1 = class ug {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(E, A) {
    return this.bb_pos = E, this.bb = A, this;
  }
  static getRootAsMessage(E, A) {
    return (A || new ug()).__init(E.readInt32(E.position()) + E.position(), E);
  }
  static getSizePrefixedRootAsMessage(E, A) {
    return E.setPosition(E.position() + SIZE_PREFIX_LENGTH), (A || new ug()).__init(E.readInt32(E.position()) + E.position(), E);
  }
  version() {
    const E = this.bb.__offset(this.bb_pos, 4);
    return E ? this.bb.readInt16(this.bb_pos + E) : MetadataVersion.V1;
  }
  headerType() {
    const E = this.bb.__offset(this.bb_pos, 6);
    return E ? this.bb.readUint8(this.bb_pos + E) : MessageHeader.NONE;
  }
  header(E) {
    const A = this.bb.__offset(this.bb_pos, 8);
    return A ? this.bb.__union(E, this.bb_pos + A) : null;
  }
  bodyLength() {
    const E = this.bb.__offset(this.bb_pos, 10);
    return E ? this.bb.readInt64(this.bb_pos + E) : BigInt("0");
  }
  customMetadata(E, A) {
    const g = this.bb.__offset(this.bb_pos, 12);
    return g ? (A || new KeyValue()).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + g) + E * 4), this.bb) : null;
  }
  customMetadataLength() {
    const E = this.bb.__offset(this.bb_pos, 12);
    return E ? this.bb.__vector_len(this.bb_pos + E) : 0;
  }
  static startMessage(E) {
    E.startObject(5);
  }
  static addVersion(E, A) {
    E.addFieldInt16(0, A, MetadataVersion.V1);
  }
  static addHeaderType(E, A) {
    E.addFieldInt8(1, A, MessageHeader.NONE);
  }
  static addHeader(E, A) {
    E.addFieldOffset(2, A, 0);
  }
  static addBodyLength(E, A) {
    E.addFieldInt64(3, A, BigInt("0"));
  }
  static addCustomMetadata(E, A) {
    E.addFieldOffset(4, A, 0);
  }
  static createCustomMetadataVector(E, A) {
    E.startVector(4, A.length, 4);
    for (let g = A.length - 1; g >= 0; g--)
      E.addOffset(A[g]);
    return E.endVector();
  }
  static startCustomMetadataVector(E, A) {
    E.startVector(4, A, 4);
  }
  static endMessage(E) {
    return E.endObject();
  }
  static finishMessageBuffer(E, A) {
    E.finish(A);
  }
  static finishSizePrefixedMessageBuffer(E, A) {
    E.finish(A, void 0, !0);
  }
  static createMessage(E, A, g, e, t, c) {
    return ug.startMessage(E), ug.addVersion(E, A), ug.addHeaderType(E, g), ug.addHeader(E, e), ug.addBodyLength(E, t), ug.addCustomMetadata(E, c), ug.endMessage(E);
  }
};
class TypeAssembler extends Visitor {
  visit(E, A) {
    return E == null || A == null ? void 0 : super.visit(E, A);
  }
  visitNull(E, A) {
    return Null$1.startNull(A), Null$1.endNull(A);
  }
  visitInt(E, A) {
    return Int.startInt(A), Int.addBitWidth(A, E.bitWidth), Int.addIsSigned(A, E.isSigned), Int.endInt(A);
  }
  visitFloat(E, A) {
    return FloatingPoint.startFloatingPoint(A), FloatingPoint.addPrecision(A, E.precision), FloatingPoint.endFloatingPoint(A);
  }
  visitBinary(E, A) {
    return Binary$1.startBinary(A), Binary$1.endBinary(A);
  }
  visitLargeBinary(E, A) {
    return LargeBinary$1.startLargeBinary(A), LargeBinary$1.endLargeBinary(A);
  }
  visitBool(E, A) {
    return Bool$1.startBool(A), Bool$1.endBool(A);
  }
  visitUtf8(E, A) {
    return Utf8$1.startUtf8(A), Utf8$1.endUtf8(A);
  }
  visitLargeUtf8(E, A) {
    return LargeUtf8$1.startLargeUtf8(A), LargeUtf8$1.endLargeUtf8(A);
  }
  visitDecimal(E, A) {
    return Decimal$1.startDecimal(A), Decimal$1.addScale(A, E.scale), Decimal$1.addPrecision(A, E.precision), Decimal$1.addBitWidth(A, E.bitWidth), Decimal$1.endDecimal(A);
  }
  visitDate(E, A) {
    return Date$1.startDate(A), Date$1.addUnit(A, E.unit), Date$1.endDate(A);
  }
  visitTime(E, A) {
    return Time.startTime(A), Time.addUnit(A, E.unit), Time.addBitWidth(A, E.bitWidth), Time.endTime(A);
  }
  visitTimestamp(E, A) {
    const g = E.timezone && A.createString(E.timezone) || void 0;
    return Timestamp.startTimestamp(A), Timestamp.addUnit(A, E.unit), g !== void 0 && Timestamp.addTimezone(A, g), Timestamp.endTimestamp(A);
  }
  visitInterval(E, A) {
    return Interval.startInterval(A), Interval.addUnit(A, E.unit), Interval.endInterval(A);
  }
  visitDuration(E, A) {
    return Duration$1.startDuration(A), Duration$1.addUnit(A, E.unit), Duration$1.endDuration(A);
  }
  visitList(E, A) {
    return List$1.startList(A), List$1.endList(A);
  }
  visitStruct(E, A) {
    return Struct_.startStruct_(A), Struct_.endStruct_(A);
  }
  visitUnion(E, A) {
    Union.startTypeIdsVector(A, E.typeIds.length);
    const g = Union.createTypeIdsVector(A, E.typeIds);
    return Union.startUnion(A), Union.addMode(A, E.mode), Union.addTypeIds(A, g), Union.endUnion(A);
  }
  visitDictionary(E, A) {
    const g = this.visit(E.indices, A);
    return DictionaryEncoding.startDictionaryEncoding(A), DictionaryEncoding.addId(A, BigInt(E.id)), DictionaryEncoding.addIsOrdered(A, E.isOrdered), g !== void 0 && DictionaryEncoding.addIndexType(A, g), DictionaryEncoding.endDictionaryEncoding(A);
  }
  visitFixedSizeBinary(E, A) {
    return FixedSizeBinary$1.startFixedSizeBinary(A), FixedSizeBinary$1.addByteWidth(A, E.byteWidth), FixedSizeBinary$1.endFixedSizeBinary(A);
  }
  visitFixedSizeList(E, A) {
    return FixedSizeList$2.startFixedSizeList(A), FixedSizeList$2.addListSize(A, E.listSize), FixedSizeList$2.endFixedSizeList(A);
  }
  visitMap(E, A) {
    return Map$1.startMap(A), Map$1.addKeysSorted(A, E.keysSorted), Map$1.endMap(A);
  }
}
const instance$1 = new TypeAssembler();
function schemaFromJSON(o, E = /* @__PURE__ */ new Map()) {
  return new Schema$2(schemaFieldsFromJSON(o, E), customMetadataFromJSON(o.metadata), E);
}
function recordBatchFromJSON(o) {
  return new RecordBatch$2(o.count, fieldNodesFromJSON(o.columns), buffersFromJSON(o.columns), null);
}
function dictionaryBatchFromJSON(o) {
  return new DictionaryBatch(recordBatchFromJSON(o.data), o.id, o.isDelta);
}
function schemaFieldsFromJSON(o, E) {
  return (o.fields || []).filter(Boolean).map((A) => Field.fromJSON(A, E));
}
function fieldChildrenFromJSON(o, E) {
  return (o.children || []).filter(Boolean).map((A) => Field.fromJSON(A, E));
}
function fieldNodesFromJSON(o) {
  return (o || []).reduce((E, A) => [
    ...E,
    new FieldNode(A.count, nullCountFromJSON(A.VALIDITY)),
    ...fieldNodesFromJSON(A.children)
  ], []);
}
function buffersFromJSON(o, E = []) {
  for (let A = -1, g = (o || []).length; ++A < g; ) {
    const e = o[A];
    e.VALIDITY && E.push(new BufferRegion(E.length, e.VALIDITY.length)), e.TYPE_ID && E.push(new BufferRegion(E.length, e.TYPE_ID.length)), e.OFFSET && E.push(new BufferRegion(E.length, e.OFFSET.length)), e.DATA && E.push(new BufferRegion(E.length, e.DATA.length)), E = buffersFromJSON(e.children, E);
  }
  return E;
}
function nullCountFromJSON(o) {
  return (o || []).reduce((E, A) => E + +(A === 0), 0);
}
function fieldFromJSON(o, E) {
  let A, g, e, t, c, n;
  return !E || !(t = o.dictionary) ? (c = typeFromJSON(o, fieldChildrenFromJSON(o, E)), e = new Field(o.name, c, o.nullable, customMetadataFromJSON(o.metadata))) : E.has(A = t.id) ? (g = (g = t.indexType) ? indexTypeFromJSON(g) : new Int32(), n = new Dictionary(E.get(A), g, A, t.isOrdered), e = new Field(o.name, n, o.nullable, customMetadataFromJSON(o.metadata))) : (g = (g = t.indexType) ? indexTypeFromJSON(g) : new Int32(), E.set(A, c = typeFromJSON(o, fieldChildrenFromJSON(o, E))), n = new Dictionary(c, g, A, t.isOrdered), e = new Field(o.name, n, o.nullable, customMetadataFromJSON(o.metadata))), e || null;
}
function customMetadataFromJSON(o = []) {
  return new Map(o.map(({ key: E, value: A }) => [E, A]));
}
function indexTypeFromJSON(o) {
  return new Int_(o.isSigned, o.bitWidth);
}
function typeFromJSON(o, E) {
  const A = o.type.name;
  switch (A) {
    case "NONE":
      return new Null();
    case "null":
      return new Null();
    case "binary":
      return new Binary();
    case "largebinary":
      return new LargeBinary();
    case "utf8":
      return new Utf8();
    case "largeutf8":
      return new LargeUtf8();
    case "bool":
      return new Bool();
    case "list":
      return new List((E || [])[0]);
    case "struct":
      return new Struct(E || []);
    case "struct_":
      return new Struct(E || []);
  }
  switch (A) {
    case "int": {
      const g = o.type;
      return new Int_(g.isSigned, g.bitWidth);
    }
    case "floatingpoint": {
      const g = o.type;
      return new Float(Precision[g.precision]);
    }
    case "decimal": {
      const g = o.type;
      return new Decimal(g.scale, g.precision, g.bitWidth);
    }
    case "date": {
      const g = o.type;
      return new Date_(DateUnit[g.unit]);
    }
    case "time": {
      const g = o.type;
      return new Time_(TimeUnit[g.unit], g.bitWidth);
    }
    case "timestamp": {
      const g = o.type;
      return new Timestamp_(TimeUnit[g.unit], g.timezone);
    }
    case "interval": {
      const g = o.type;
      return new Interval_(IntervalUnit[g.unit]);
    }
    case "duration": {
      const g = o.type;
      return new Duration(TimeUnit[g.unit]);
    }
    case "union": {
      const g = o.type, [e, ...t] = (g.mode + "").toLowerCase(), c = e.toUpperCase() + t.join("");
      return new Union_(UnionMode[c], g.typeIds || [], E || []);
    }
    case "fixedsizebinary": {
      const g = o.type;
      return new FixedSizeBinary(g.byteWidth);
    }
    case "fixedsizelist": {
      const g = o.type;
      return new FixedSizeList$1(g.listSize, (E || [])[0]);
    }
    case "map": {
      const g = o.type;
      return new Map_((E || [])[0], g.keysSorted);
    }
  }
  throw new Error(`Unrecognized type: "${A}"`);
}
var Builder = Builder$2, ByteBuffer = ByteBuffer$2;
class Message {
  /** @nocollapse */
  static fromJSON(E, A) {
    const g = new Message(0, MetadataVersion.V5, A);
    return g._createHeader = messageHeaderFromJSON(E, A), g;
  }
  /** @nocollapse */
  static decode(E) {
    E = new ByteBuffer(toUint8Array(E));
    const A = Message$1.getRootAsMessage(E), g = A.bodyLength(), e = A.version(), t = A.headerType(), c = new Message(g, e, t);
    return c._createHeader = decodeMessageHeader(A, t), c;
  }
  /** @nocollapse */
  static encode(E) {
    const A = new Builder();
    let g = -1;
    return E.isSchema() ? g = Schema$2.encode(A, E.header()) : E.isRecordBatch() ? g = RecordBatch$2.encode(A, E.header()) : E.isDictionaryBatch() && (g = DictionaryBatch.encode(A, E.header())), Message$1.startMessage(A), Message$1.addVersion(A, MetadataVersion.V5), Message$1.addHeader(A, g), Message$1.addHeaderType(A, E.headerType), Message$1.addBodyLength(A, BigInt(E.bodyLength)), Message$1.finishMessageBuffer(A, Message$1.endMessage(A)), A.asUint8Array();
  }
  /** @nocollapse */
  static from(E, A = 0) {
    if (E instanceof Schema$2)
      return new Message(0, MetadataVersion.V5, MessageHeader.Schema, E);
    if (E instanceof RecordBatch$2)
      return new Message(A, MetadataVersion.V5, MessageHeader.RecordBatch, E);
    if (E instanceof DictionaryBatch)
      return new Message(A, MetadataVersion.V5, MessageHeader.DictionaryBatch, E);
    throw new Error(`Unrecognized Message header: ${E}`);
  }
  get type() {
    return this.headerType;
  }
  get version() {
    return this._version;
  }
  get headerType() {
    return this._headerType;
  }
  get compression() {
    return this._compression;
  }
  get bodyLength() {
    return this._bodyLength;
  }
  header() {
    return this._createHeader();
  }
  isSchema() {
    return this.headerType === MessageHeader.Schema;
  }
  isRecordBatch() {
    return this.headerType === MessageHeader.RecordBatch;
  }
  isDictionaryBatch() {
    return this.headerType === MessageHeader.DictionaryBatch;
  }
  constructor(E, A, g, e) {
    this._version = A, this._headerType = g, this.body = new Uint8Array(0), this._compression = e?.compression, e && (this._createHeader = () => e), this._bodyLength = bigIntToNumber(E);
  }
}
let RecordBatch$2 = class {
  get nodes() {
    return this._nodes;
  }
  get length() {
    return this._length;
  }
  get buffers() {
    return this._buffers;
  }
  get compression() {
    return this._compression;
  }
  constructor(E, A, g, e) {
    this._nodes = A, this._buffers = g, this._length = bigIntToNumber(E), this._compression = e;
  }
};
class DictionaryBatch {
  get id() {
    return this._id;
  }
  get data() {
    return this._data;
  }
  get isDelta() {
    return this._isDelta;
  }
  get length() {
    return this.data.length;
  }
  get nodes() {
    return this.data.nodes;
  }
  get buffers() {
    return this.data.buffers;
  }
  constructor(E, A, g = !1) {
    this._data = E, this._isDelta = g, this._id = bigIntToNumber(A);
  }
}
class BufferRegion {
  constructor(E, A) {
    this.offset = bigIntToNumber(E), this.length = bigIntToNumber(A);
  }
}
class FieldNode {
  constructor(E, A) {
    this.length = bigIntToNumber(E), this.nullCount = bigIntToNumber(A);
  }
}
class BodyCompression {
  constructor(E, A = BodyCompressionMethod.BUFFER) {
    this.type = E, this.method = A;
  }
}
function messageHeaderFromJSON(o, E) {
  return (() => {
    switch (E) {
      case MessageHeader.Schema:
        return Schema$2.fromJSON(o);
      case MessageHeader.RecordBatch:
        return RecordBatch$2.fromJSON(o);
      case MessageHeader.DictionaryBatch:
        return DictionaryBatch.fromJSON(o);
    }
    throw new Error(`Unrecognized Message type: { name: ${MessageHeader[E]}, type: ${E} }`);
  });
}
function decodeMessageHeader(o, E) {
  return (() => {
    switch (E) {
      case MessageHeader.Schema:
        return Schema$2.decode(o.header(new Schema$3()), /* @__PURE__ */ new Map(), o.version());
      case MessageHeader.RecordBatch:
        return RecordBatch$2.decode(o.header(new RecordBatch$3()), o.version());
      case MessageHeader.DictionaryBatch:
        return DictionaryBatch.decode(o.header(new DictionaryBatch$1()), o.version());
    }
    throw new Error(`Unrecognized Message type: { name: ${MessageHeader[E]}, type: ${E} }`);
  });
}
Field.encode = encodeField;
Field.decode = decodeField;
Field.fromJSON = fieldFromJSON;
Schema$2.encode = encodeSchema;
Schema$2.decode = decodeSchema;
Schema$2.fromJSON = schemaFromJSON;
RecordBatch$2.encode = encodeRecordBatch;
RecordBatch$2.decode = decodeRecordBatch;
RecordBatch$2.fromJSON = recordBatchFromJSON;
DictionaryBatch.encode = encodeDictionaryBatch;
DictionaryBatch.decode = decodeDictionaryBatch;
DictionaryBatch.fromJSON = dictionaryBatchFromJSON;
FieldNode.encode = encodeFieldNode;
FieldNode.decode = decodeFieldNode;
BufferRegion.encode = encodeBufferRegion;
BufferRegion.decode = decodeBufferRegion;
BodyCompression.encode = encodeBodyCompression;
BodyCompression.decode = decodeBodyCompression;
function decodeSchema(o, E = /* @__PURE__ */ new Map(), A = MetadataVersion.V5) {
  const g = decodeSchemaFields(o, E);
  return new Schema$2(g, decodeCustomMetadata(o), E, A);
}
function decodeRecordBatch(o, E = MetadataVersion.V5) {
  return new RecordBatch$2(o.length(), decodeFieldNodes(o), decodeBuffers(o, E), decodeBodyCompression(o.compression()));
}
function decodeDictionaryBatch(o, E = MetadataVersion.V5) {
  return new DictionaryBatch(RecordBatch$2.decode(o.data(), E), o.id(), o.isDelta());
}
function decodeBufferRegion(o) {
  return new BufferRegion(o.offset(), o.length());
}
function decodeFieldNode(o) {
  return new FieldNode(o.length(), o.nullCount());
}
function decodeFieldNodes(o) {
  const E = [];
  for (let A, g = -1, e = -1, t = o.nodesLength(); ++g < t; )
    (A = o.nodes(g)) && (E[++e] = FieldNode.decode(A));
  return E;
}
function decodeBuffers(o, E) {
  const A = [];
  for (let g, e = -1, t = -1, c = o.buffersLength(); ++e < c; )
    (g = o.buffers(e)) && (E < MetadataVersion.V4 && (g.bb_pos += 8 * (e + 1)), A[++t] = BufferRegion.decode(g));
  return A;
}
function decodeSchemaFields(o, E) {
  const A = [];
  for (let g, e = -1, t = -1, c = o.fieldsLength(); ++e < c; )
    (g = o.fields(e)) && (A[++t] = Field.decode(g, E));
  return A;
}
function decodeFieldChildren(o, E) {
  const A = [];
  for (let g, e = -1, t = -1, c = o.childrenLength(); ++e < c; )
    (g = o.children(e)) && (A[++t] = Field.decode(g, E));
  return A;
}
function decodeField(o, E) {
  let A, g, e, t, c, n;
  return !E || !(n = o.dictionary()) ? (e = decodeFieldType(o, decodeFieldChildren(o, E)), g = new Field(o.name(), e, o.nullable(), decodeCustomMetadata(o))) : E.has(A = bigIntToNumber(n.id())) ? (t = (t = n.indexType()) ? decodeIndexType(t) : new Int32(), c = new Dictionary(E.get(A), t, A, n.isOrdered()), g = new Field(o.name(), c, o.nullable(), decodeCustomMetadata(o))) : (t = (t = n.indexType()) ? decodeIndexType(t) : new Int32(), E.set(A, e = decodeFieldType(o, decodeFieldChildren(o, E))), c = new Dictionary(e, t, A, n.isOrdered()), g = new Field(o.name(), c, o.nullable(), decodeCustomMetadata(o))), g || null;
}
function decodeCustomMetadata(o) {
  const E = /* @__PURE__ */ new Map();
  if (o)
    for (let A, g, e = -1, t = Math.trunc(o.customMetadataLength()); ++e < t; )
      (A = o.customMetadata(e)) && (g = A.key()) != null && E.set(g, A.value());
  return E;
}
function decodeIndexType(o) {
  return new Int_(o.isSigned(), o.bitWidth());
}
function decodeFieldType(o, E) {
  const A = o.typeType();
  switch (A) {
    case Type$1.NONE:
      return new Null();
    case Type$1.Null:
      return new Null();
    case Type$1.Binary:
      return new Binary();
    case Type$1.LargeBinary:
      return new LargeBinary();
    case Type$1.Utf8:
      return new Utf8();
    case Type$1.LargeUtf8:
      return new LargeUtf8();
    case Type$1.Bool:
      return new Bool();
    case Type$1.List:
      return new List((E || [])[0]);
    case Type$1.Struct_:
      return new Struct(E || []);
  }
  switch (A) {
    case Type$1.Int: {
      const g = o.type(new Int());
      return new Int_(g.isSigned(), g.bitWidth());
    }
    case Type$1.FloatingPoint: {
      const g = o.type(new FloatingPoint());
      return new Float(g.precision());
    }
    case Type$1.Decimal: {
      const g = o.type(new Decimal$1());
      return new Decimal(g.scale(), g.precision(), g.bitWidth());
    }
    case Type$1.Date: {
      const g = o.type(new Date$1());
      return new Date_(g.unit());
    }
    case Type$1.Time: {
      const g = o.type(new Time());
      return new Time_(g.unit(), g.bitWidth());
    }
    case Type$1.Timestamp: {
      const g = o.type(new Timestamp());
      return new Timestamp_(g.unit(), g.timezone());
    }
    case Type$1.Interval: {
      const g = o.type(new Interval());
      return new Interval_(g.unit());
    }
    case Type$1.Duration: {
      const g = o.type(new Duration$1());
      return new Duration(g.unit());
    }
    case Type$1.Union: {
      const g = o.type(new Union());
      return new Union_(g.mode(), g.typeIdsArray() || [], E || []);
    }
    case Type$1.FixedSizeBinary: {
      const g = o.type(new FixedSizeBinary$1());
      return new FixedSizeBinary(g.byteWidth());
    }
    case Type$1.FixedSizeList: {
      const g = o.type(new FixedSizeList$2());
      return new FixedSizeList$1(g.listSize(), (E || [])[0]);
    }
    case Type$1.Map: {
      const g = o.type(new Map$1());
      return new Map_((E || [])[0], g.keysSorted());
    }
  }
  throw new Error(`Unrecognized type: "${Type$1[A]}" (${A})`);
}
function decodeBodyCompression(o) {
  return o ? new BodyCompression(o.codec(), o.method()) : null;
}
function encodeSchema(o, E) {
  const A = E.fields.map((t) => Field.encode(o, t));
  Schema$3.startFieldsVector(o, A.length);
  const g = Schema$3.createFieldsVector(o, A), e = E.metadata && E.metadata.size > 0 ? Schema$3.createCustomMetadataVector(o, [...E.metadata].map(([t, c]) => {
    const n = o.createString(`${t}`), h = o.createString(`${c}`);
    return KeyValue.startKeyValue(o), KeyValue.addKey(o, n), KeyValue.addValue(o, h), KeyValue.endKeyValue(o);
  })) : -1;
  return Schema$3.startSchema(o), Schema$3.addFields(o, g), Schema$3.addEndianness(o, platformIsLittleEndian ? Endianness.Little : Endianness.Big), e !== -1 && Schema$3.addCustomMetadata(o, e), Schema$3.endSchema(o);
}
function encodeField(o, E) {
  let A = -1, g = -1, e = -1;
  const t = E.type;
  let c = E.typeId;
  DataType.isDictionary(t) ? (c = t.dictionary.typeId, e = instance$1.visit(t, o), g = instance$1.visit(t.dictionary, o)) : g = instance$1.visit(t, o);
  const n = (t.children || []).map((k) => Field.encode(o, k)), h = Field$1.createChildrenVector(o, n), d = E.metadata && E.metadata.size > 0 ? Field$1.createCustomMetadataVector(o, [...E.metadata].map(([k, p]) => {
    const M = o.createString(`${k}`), S = o.createString(`${p}`);
    return KeyValue.startKeyValue(o), KeyValue.addKey(o, M), KeyValue.addValue(o, S), KeyValue.endKeyValue(o);
  })) : -1;
  return E.name && (A = o.createString(E.name)), Field$1.startField(o), Field$1.addType(o, g), Field$1.addTypeType(o, c), Field$1.addChildren(o, h), Field$1.addNullable(o, !!E.nullable), A !== -1 && Field$1.addName(o, A), e !== -1 && Field$1.addDictionary(o, e), d !== -1 && Field$1.addCustomMetadata(o, d), Field$1.endField(o);
}
function encodeRecordBatch(o, E) {
  const A = E.nodes || [], g = E.buffers || [];
  RecordBatch$3.startNodesVector(o, A.length);
  for (const n of A.slice().reverse())
    FieldNode.encode(o, n);
  const e = o.endVector();
  RecordBatch$3.startBuffersVector(o, g.length);
  for (const n of g.slice().reverse())
    BufferRegion.encode(o, n);
  const t = o.endVector();
  let c = null;
  return E.compression !== null && (c = encodeBodyCompression(o, E.compression)), RecordBatch$3.startRecordBatch(o), RecordBatch$3.addLength(o, BigInt(E.length)), RecordBatch$3.addNodes(o, e), RecordBatch$3.addBuffers(o, t), E.compression !== null && c && RecordBatch$3.addCompression(o, c), RecordBatch$3.endRecordBatch(o);
}
function encodeBodyCompression(o, E) {
  return BodyCompression$1.startBodyCompression(o), BodyCompression$1.addCodec(o, E.type), BodyCompression$1.addMethod(o, E.method), BodyCompression$1.endBodyCompression(o);
}
function encodeDictionaryBatch(o, E) {
  const A = RecordBatch$2.encode(o, E.data);
  return DictionaryBatch$1.startDictionaryBatch(o), DictionaryBatch$1.addId(o, BigInt(E.id)), DictionaryBatch$1.addIsDelta(o, E.isDelta), DictionaryBatch$1.addData(o, A), DictionaryBatch$1.endDictionaryBatch(o);
}
function encodeFieldNode(o, E) {
  return FieldNode$1.createFieldNode(o, BigInt(E.length), BigInt(E.nullCount));
}
function encodeBufferRegion(o, E) {
  return Buffer$1.createBuffer(o, BigInt(E.offset), BigInt(E.length));
}
const platformIsLittleEndian = (() => {
  const o = new ArrayBuffer(2);
  return new DataView(o).setInt16(
    0,
    256,
    !0
    /* littleEndian */
  ), new Int16Array(o)[0] === 256;
})(), ITERATOR_DONE = Object.freeze({ done: !0, value: void 0 });
class ArrowJSON {
  constructor(E) {
    this._json = E;
  }
  get schema() {
    return this._json.schema;
  }
  get batches() {
    return this._json.batches || [];
  }
  get dictionaries() {
    return this._json.dictionaries || [];
  }
}
class ReadableInterop {
  tee() {
    return this._getDOMStream().tee();
  }
  pipe(E, A) {
    return this._getNodeStream().pipe(E, A);
  }
  pipeTo(E, A) {
    return this._getDOMStream().pipeTo(E, A);
  }
  pipeThrough(E, A) {
    return this._getDOMStream().pipeThrough(E, A);
  }
  _getDOMStream() {
    return this._DOMStream || (this._DOMStream = this.toDOMStream());
  }
  _getNodeStream() {
    return this._nodeStream || (this._nodeStream = this.toNodeStream());
  }
}
class AsyncQueue extends ReadableInterop {
  constructor() {
    super(), this._values = [], this.resolvers = [], this._closedPromise = new Promise((E) => this._closedPromiseResolve = E);
  }
  get closed() {
    return this._closedPromise;
  }
  cancel(E) {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.return(E);
    });
  }
  write(E) {
    this._ensureOpen() && (this.resolvers.length <= 0 ? this._values.push(E) : this.resolvers.shift().resolve({ done: !1, value: E }));
  }
  abort(E) {
    this._closedPromiseResolve && (this.resolvers.length <= 0 ? this._error = { error: E } : this.resolvers.shift().reject({ done: !0, value: E }));
  }
  close() {
    if (this._closedPromiseResolve) {
      const { resolvers: E } = this;
      for (; E.length > 0; )
        E.shift().resolve(ITERATOR_DONE);
      this._closedPromiseResolve(), this._closedPromiseResolve = void 0;
    }
  }
  [Symbol.asyncIterator]() {
    return this;
  }
  toDOMStream(E) {
    return streamAdapters.toDOMStream(this._closedPromiseResolve || this._error ? this : this._values, E);
  }
  toNodeStream(E) {
    return streamAdapters.toNodeStream(this._closedPromiseResolve || this._error ? this : this._values, E);
  }
  throw(E) {
    return __awaiter(this, void 0, void 0, function* () {
      return yield this.abort(E), ITERATOR_DONE;
    });
  }
  return(E) {
    return __awaiter(this, void 0, void 0, function* () {
      return yield this.close(), ITERATOR_DONE;
    });
  }
  read(E) {
    return __awaiter(this, void 0, void 0, function* () {
      return (yield this.next(E, "read")).value;
    });
  }
  peek(E) {
    return __awaiter(this, void 0, void 0, function* () {
      return (yield this.next(E, "peek")).value;
    });
  }
  next(...E) {
    return this._values.length > 0 ? Promise.resolve({ done: !1, value: this._values.shift() }) : this._error ? Promise.reject({ done: !0, value: this._error.error }) : this._closedPromiseResolve ? new Promise((A, g) => {
      this.resolvers.push({ resolve: A, reject: g });
    }) : Promise.resolve(ITERATOR_DONE);
  }
  _ensureOpen() {
    if (this._closedPromiseResolve)
      return !0;
    throw new Error("AsyncQueue is closed");
  }
}
class AsyncByteQueue extends AsyncQueue {
  write(E) {
    if ((E = toUint8Array(E)).byteLength > 0)
      return super.write(E);
  }
  toString(E = !1) {
    return E ? decodeUtf8(this.toUint8Array(!0)) : this.toUint8Array(!1).then(decodeUtf8);
  }
  toUint8Array(E = !1) {
    return E ? joinUint8Arrays(this._values)[0] : __awaiter(this, void 0, void 0, function* () {
      var A, g, e, t;
      const c = [];
      let n = 0;
      try {
        for (var h = !0, d = __asyncValues(this), k; k = yield d.next(), A = k.done, !A; h = !0) {
          t = k.value, h = !1;
          const p = t;
          c.push(p), n += p.byteLength;
        }
      } catch (p) {
        g = { error: p };
      } finally {
        try {
          !h && !A && (e = d.return) && (yield e.call(d));
        } finally {
          if (g) throw g.error;
        }
      }
      return joinUint8Arrays(c, n)[0];
    });
  }
}
class ByteStream {
  constructor(E) {
    E && (this.source = new ByteStreamSource(streamAdapters.fromIterable(E)));
  }
  [Symbol.iterator]() {
    return this;
  }
  next(E) {
    return this.source.next(E);
  }
  throw(E) {
    return this.source.throw(E);
  }
  return(E) {
    return this.source.return(E);
  }
  peek(E) {
    return this.source.peek(E);
  }
  read(E) {
    return this.source.read(E);
  }
}
class AsyncByteStream {
  constructor(E) {
    E instanceof AsyncByteStream ? this.source = E.source : E instanceof AsyncByteQueue ? this.source = new AsyncByteStreamSource(streamAdapters.fromAsyncIterable(E)) : isReadableNodeStream(E) ? this.source = new AsyncByteStreamSource(streamAdapters.fromNodeStream(E)) : isReadableDOMStream(E) ? this.source = new AsyncByteStreamSource(streamAdapters.fromDOMStream(E)) : isFetchResponse(E) ? this.source = new AsyncByteStreamSource(streamAdapters.fromDOMStream(E.body)) : isIterable(E) ? this.source = new AsyncByteStreamSource(streamAdapters.fromIterable(E)) : isPromise(E) ? this.source = new AsyncByteStreamSource(streamAdapters.fromAsyncIterable(E)) : isAsyncIterable$1(E) && (this.source = new AsyncByteStreamSource(streamAdapters.fromAsyncIterable(E)));
  }
  [Symbol.asyncIterator]() {
    return this;
  }
  next(E) {
    return this.source.next(E);
  }
  throw(E) {
    return this.source.throw(E);
  }
  return(E) {
    return this.source.return(E);
  }
  get closed() {
    return this.source.closed;
  }
  cancel(E) {
    return this.source.cancel(E);
  }
  peek(E) {
    return this.source.peek(E);
  }
  read(E) {
    return this.source.read(E);
  }
}
class ByteStreamSource {
  constructor(E) {
    this.source = E;
  }
  cancel(E) {
    this.return(E);
  }
  peek(E) {
    return this.next(E, "peek").value;
  }
  read(E) {
    return this.next(E, "read").value;
  }
  next(E, A = "read") {
    return this.source.next({ cmd: A, size: E });
  }
  throw(E) {
    return Object.create(this.source.throw && this.source.throw(E) || ITERATOR_DONE);
  }
  return(E) {
    return Object.create(this.source.return && this.source.return(E) || ITERATOR_DONE);
  }
}
class AsyncByteStreamSource {
  constructor(E) {
    this.source = E, this._closedPromise = new Promise((A) => this._closedPromiseResolve = A);
  }
  cancel(E) {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.return(E);
    });
  }
  get closed() {
    return this._closedPromise;
  }
  read(E) {
    return __awaiter(this, void 0, void 0, function* () {
      return (yield this.next(E, "read")).value;
    });
  }
  peek(E) {
    return __awaiter(this, void 0, void 0, function* () {
      return (yield this.next(E, "peek")).value;
    });
  }
  next(E) {
    return __awaiter(this, arguments, void 0, function* (A, g = "read") {
      return yield this.source.next({ cmd: g, size: A });
    });
  }
  throw(E) {
    return __awaiter(this, void 0, void 0, function* () {
      const A = this.source.throw && (yield this.source.throw(E)) || ITERATOR_DONE;
      return this._closedPromiseResolve && this._closedPromiseResolve(), this._closedPromiseResolve = void 0, Object.create(A);
    });
  }
  return(E) {
    return __awaiter(this, void 0, void 0, function* () {
      const A = this.source.return && (yield this.source.return(E)) || ITERATOR_DONE;
      return this._closedPromiseResolve && this._closedPromiseResolve(), this._closedPromiseResolve = void 0, Object.create(A);
    });
  }
}
class RandomAccessFile extends ByteStream {
  constructor(E, A) {
    super(), this.position = 0, this.buffer = toUint8Array(E), this.size = A === void 0 ? this.buffer.byteLength : A;
  }
  readInt32(E) {
    const { buffer: A, byteOffset: g } = this.readAt(E, 4);
    return new DataView(A, g).getInt32(0, !0);
  }
  seek(E) {
    return this.position = Math.min(E, this.size), E < this.size;
  }
  read(E) {
    const { buffer: A, size: g, position: e } = this;
    return A && e < g ? (typeof E != "number" && (E = Number.POSITIVE_INFINITY), this.position = Math.min(g, e + Math.min(g - e, E)), A.subarray(e, this.position)) : null;
  }
  readAt(E, A) {
    const g = this.buffer, e = Math.min(this.size, E + A);
    return g ? g.subarray(E, e) : new Uint8Array(A);
  }
  close() {
    this.buffer && (this.buffer = null);
  }
  throw(E) {
    return this.close(), { done: !0, value: E };
  }
  return(E) {
    return this.close(), { done: !0, value: E };
  }
}
class AsyncRandomAccessFile extends AsyncByteStream {
  constructor(E, A) {
    super(), this.position = 0, this._handle = E, typeof A == "number" ? this.size = A : this._pending = __awaiter(this, void 0, void 0, function* () {
      this.size = (yield E.stat()).size, delete this._pending;
    });
  }
  readInt32(E) {
    return __awaiter(this, void 0, void 0, function* () {
      const { buffer: A, byteOffset: g } = yield this.readAt(E, 4);
      return new DataView(A, g).getInt32(0, !0);
    });
  }
  seek(E) {
    return __awaiter(this, void 0, void 0, function* () {
      return this._pending && (yield this._pending), this.position = Math.min(E, this.size), E < this.size;
    });
  }
  read(E) {
    return __awaiter(this, void 0, void 0, function* () {
      this._pending && (yield this._pending);
      const { _handle: A, size: g, position: e } = this;
      if (A && e < g) {
        typeof E != "number" && (E = Number.POSITIVE_INFINITY);
        let t = e, c = 0, n = 0;
        const h = Math.min(g, t + Math.min(g - t, E)), d = new Uint8Array(Math.max(0, (this.position = h) - t));
        for (; (t += n) < h && (c += n) < d.byteLength; )
          ({ bytesRead: n } = yield A.read(d, c, d.byteLength - c, t));
        return d;
      }
      return null;
    });
  }
  readAt(E, A) {
    return __awaiter(this, void 0, void 0, function* () {
      this._pending && (yield this._pending);
      const { _handle: g, size: e } = this;
      if (g && E + A < e) {
        const t = Math.min(e, E + A), c = new Uint8Array(t - E);
        return (yield g.read(c, 0, A, E)).buffer;
      }
      return new Uint8Array(A);
    });
  }
  close() {
    return __awaiter(this, void 0, void 0, function* () {
      const E = this._handle;
      this._handle = null, E && (yield E.close());
    });
  }
  throw(E) {
    return __awaiter(this, void 0, void 0, function* () {
      return yield this.close(), { done: !0, value: E };
    });
  }
  return(E) {
    return __awaiter(this, void 0, void 0, function* () {
      return yield this.close(), { done: !0, value: E };
    });
  }
}
const carryBit16 = 65536;
function intAsHex(o) {
  return o < 0 && (o = 4294967295 + o + 1), `0x${o.toString(16)}`;
}
const kInt32DecimalDigits = 8, kPowersOfTen = [
  1,
  10,
  100,
  1e3,
  1e4,
  1e5,
  1e6,
  1e7,
  1e8
];
class BaseInt64 {
  constructor(E) {
    this.buffer = E;
  }
  high() {
    return this.buffer[1];
  }
  low() {
    return this.buffer[0];
  }
  _times(E) {
    const A = new Uint32Array([
      this.buffer[1] >>> 16,
      this.buffer[1] & 65535,
      this.buffer[0] >>> 16,
      this.buffer[0] & 65535
    ]), g = new Uint32Array([
      E.buffer[1] >>> 16,
      E.buffer[1] & 65535,
      E.buffer[0] >>> 16,
      E.buffer[0] & 65535
    ]);
    let e = A[3] * g[3];
    this.buffer[0] = e & 65535;
    let t = e >>> 16;
    return e = A[2] * g[3], t += e, e = A[3] * g[2] >>> 0, t += e, this.buffer[0] += t << 16, this.buffer[1] = t >>> 0 < e ? carryBit16 : 0, this.buffer[1] += t >>> 16, this.buffer[1] += A[1] * g[3] + A[2] * g[2] + A[3] * g[1], this.buffer[1] += A[0] * g[3] + A[1] * g[2] + A[2] * g[1] + A[3] * g[0] << 16, this;
  }
  _plus(E) {
    const A = this.buffer[0] + E.buffer[0] >>> 0;
    this.buffer[1] += E.buffer[1], A < this.buffer[0] >>> 0 && ++this.buffer[1], this.buffer[0] = A;
  }
  lessThan(E) {
    return this.buffer[1] < E.buffer[1] || this.buffer[1] === E.buffer[1] && this.buffer[0] < E.buffer[0];
  }
  equals(E) {
    return this.buffer[1] === E.buffer[1] && this.buffer[0] == E.buffer[0];
  }
  greaterThan(E) {
    return E.lessThan(this);
  }
  hex() {
    return `${intAsHex(this.buffer[1])} ${intAsHex(this.buffer[0])}`;
  }
}
class Uint64 extends BaseInt64 {
  times(E) {
    return this._times(E), this;
  }
  plus(E) {
    return this._plus(E), this;
  }
  /** @nocollapse */
  static from(E, A = new Uint32Array(2)) {
    return Uint64.fromString(typeof E == "string" ? E : E.toString(), A);
  }
  /** @nocollapse */
  static fromNumber(E, A = new Uint32Array(2)) {
    return Uint64.fromString(E.toString(), A);
  }
  /** @nocollapse */
  static fromString(E, A = new Uint32Array(2)) {
    const g = E.length, e = new Uint64(A);
    for (let t = 0; t < g; ) {
      const c = kInt32DecimalDigits < g - t ? kInt32DecimalDigits : g - t, n = new Uint64(new Uint32Array([Number.parseInt(E.slice(t, t + c), 10), 0])), h = new Uint64(new Uint32Array([kPowersOfTen[c], 0]));
      e.times(h), e.plus(n), t += c;
    }
    return e;
  }
  /** @nocollapse */
  static convertArray(E) {
    const A = new Uint32Array(E.length * 2);
    for (let g = -1, e = E.length; ++g < e; )
      Uint64.from(E[g], new Uint32Array(A.buffer, A.byteOffset + 2 * g * 4, 2));
    return A;
  }
  /** @nocollapse */
  static multiply(E, A) {
    return new Uint64(new Uint32Array(E.buffer)).times(A);
  }
  /** @nocollapse */
  static add(E, A) {
    return new Uint64(new Uint32Array(E.buffer)).plus(A);
  }
}
class Int64 extends BaseInt64 {
  negate() {
    return this.buffer[0] = ~this.buffer[0] + 1, this.buffer[1] = ~this.buffer[1], this.buffer[0] == 0 && ++this.buffer[1], this;
  }
  times(E) {
    return this._times(E), this;
  }
  plus(E) {
    return this._plus(E), this;
  }
  lessThan(E) {
    const A = this.buffer[1] << 0, g = E.buffer[1] << 0;
    return A < g || A === g && this.buffer[0] < E.buffer[0];
  }
  /** @nocollapse */
  static from(E, A = new Uint32Array(2)) {
    return Int64.fromString(typeof E == "string" ? E : E.toString(), A);
  }
  /** @nocollapse */
  static fromNumber(E, A = new Uint32Array(2)) {
    return Int64.fromString(E.toString(), A);
  }
  /** @nocollapse */
  static fromString(E, A = new Uint32Array(2)) {
    const g = E.startsWith("-"), e = E.length, t = new Int64(A);
    for (let c = g ? 1 : 0; c < e; ) {
      const n = kInt32DecimalDigits < e - c ? kInt32DecimalDigits : e - c, h = new Int64(new Uint32Array([Number.parseInt(E.slice(c, c + n), 10), 0])), d = new Int64(new Uint32Array([kPowersOfTen[n], 0]));
      t.times(d), t.plus(h), c += n;
    }
    return g ? t.negate() : t;
  }
  /** @nocollapse */
  static convertArray(E) {
    const A = new Uint32Array(E.length * 2);
    for (let g = -1, e = E.length; ++g < e; )
      Int64.from(E[g], new Uint32Array(A.buffer, A.byteOffset + 2 * g * 4, 2));
    return A;
  }
  /** @nocollapse */
  static multiply(E, A) {
    return new Int64(new Uint32Array(E.buffer)).times(A);
  }
  /** @nocollapse */
  static add(E, A) {
    return new Int64(new Uint32Array(E.buffer)).plus(A);
  }
}
class Int128 {
  constructor(E) {
    this.buffer = E;
  }
  high() {
    return new Int64(new Uint32Array(this.buffer.buffer, this.buffer.byteOffset + 8, 2));
  }
  low() {
    return new Int64(new Uint32Array(this.buffer.buffer, this.buffer.byteOffset, 2));
  }
  negate() {
    return this.buffer[0] = ~this.buffer[0] + 1, this.buffer[1] = ~this.buffer[1], this.buffer[2] = ~this.buffer[2], this.buffer[3] = ~this.buffer[3], this.buffer[0] == 0 && ++this.buffer[1], this.buffer[1] == 0 && ++this.buffer[2], this.buffer[2] == 0 && ++this.buffer[3], this;
  }
  times(E) {
    const A = new Uint64(new Uint32Array([this.buffer[3], 0])), g = new Uint64(new Uint32Array([this.buffer[2], 0])), e = new Uint64(new Uint32Array([this.buffer[1], 0])), t = new Uint64(new Uint32Array([this.buffer[0], 0])), c = new Uint64(new Uint32Array([E.buffer[3], 0])), n = new Uint64(new Uint32Array([E.buffer[2], 0])), h = new Uint64(new Uint32Array([E.buffer[1], 0])), d = new Uint64(new Uint32Array([E.buffer[0], 0]));
    let k = Uint64.multiply(t, d);
    this.buffer[0] = k.low();
    const p = new Uint64(new Uint32Array([k.high(), 0]));
    return k = Uint64.multiply(e, d), p.plus(k), k = Uint64.multiply(t, h), p.plus(k), this.buffer[1] = p.low(), this.buffer[3] = p.lessThan(k) ? 1 : 0, this.buffer[2] = p.high(), new Uint64(new Uint32Array(this.buffer.buffer, this.buffer.byteOffset + 8, 2)).plus(Uint64.multiply(g, d)).plus(Uint64.multiply(e, h)).plus(Uint64.multiply(t, n)), this.buffer[3] += Uint64.multiply(A, d).plus(Uint64.multiply(g, h)).plus(Uint64.multiply(e, n)).plus(Uint64.multiply(t, c)).low(), this;
  }
  plus(E) {
    const A = new Uint32Array(4);
    return A[3] = this.buffer[3] + E.buffer[3] >>> 0, A[2] = this.buffer[2] + E.buffer[2] >>> 0, A[1] = this.buffer[1] + E.buffer[1] >>> 0, A[0] = this.buffer[0] + E.buffer[0] >>> 0, A[0] < this.buffer[0] >>> 0 && ++A[1], A[1] < this.buffer[1] >>> 0 && ++A[2], A[2] < this.buffer[2] >>> 0 && ++A[3], this.buffer[3] = A[3], this.buffer[2] = A[2], this.buffer[1] = A[1], this.buffer[0] = A[0], this;
  }
  hex() {
    return `${intAsHex(this.buffer[3])} ${intAsHex(this.buffer[2])} ${intAsHex(this.buffer[1])} ${intAsHex(this.buffer[0])}`;
  }
  /** @nocollapse */
  static multiply(E, A) {
    return new Int128(new Uint32Array(E.buffer)).times(A);
  }
  /** @nocollapse */
  static add(E, A) {
    return new Int128(new Uint32Array(E.buffer)).plus(A);
  }
  /** @nocollapse */
  static from(E, A = new Uint32Array(4)) {
    return Int128.fromString(typeof E == "string" ? E : E.toString(), A);
  }
  /** @nocollapse */
  static fromNumber(E, A = new Uint32Array(4)) {
    return Int128.fromString(E.toString(), A);
  }
  /** @nocollapse */
  static fromString(E, A = new Uint32Array(4)) {
    const g = E.startsWith("-"), e = E.length, t = new Int128(A);
    for (let c = g ? 1 : 0; c < e; ) {
      const n = kInt32DecimalDigits < e - c ? kInt32DecimalDigits : e - c, h = new Int128(new Uint32Array([Number.parseInt(E.slice(c, c + n), 10), 0, 0, 0])), d = new Int128(new Uint32Array([kPowersOfTen[n], 0, 0, 0]));
      t.times(d), t.plus(h), c += n;
    }
    return g ? t.negate() : t;
  }
  /** @nocollapse */
  static convertArray(E) {
    const A = new Uint32Array(E.length * 4);
    for (let g = -1, e = E.length; ++g < e; )
      Int128.from(E[g], new Uint32Array(A.buffer, A.byteOffset + 16 * g, 4));
    return A;
  }
}
const util_int_ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BaseInt64,
  Int128,
  Int64,
  Uint64
}, Symbol.toStringTag, { value: "Module" }));
function toIntervalDayTimeInt32Array(o) {
  var E, A;
  const g = o.length, e = new Int32Array(g * 2);
  for (let t = 0, c = 0; t < g; t++) {
    const n = o[t];
    e[c++] = (E = n.days) !== null && E !== void 0 ? E : 0, e[c++] = (A = n.milliseconds) !== null && A !== void 0 ? A : 0;
  }
  return e;
}
function toIntervalMonthDayNanoInt32Array(o) {
  var E, A;
  const g = o.length, e = new Int32Array(g * 4);
  for (let t = 0, c = 0; t < g; t++) {
    const n = o[t];
    e[c++] = (E = n.months) !== null && E !== void 0 ? E : 0, e[c++] = (A = n.days) !== null && A !== void 0 ? A : 0;
    const h = n.nanoseconds;
    h ? (e[c++] = Number(BigInt(h) & BigInt(4294967295)), e[c++] = Number(BigInt(h) >> BigInt(32))) : c += 2;
  }
  return e;
}
function toIntervalDayTimeObjects(o) {
  const E = o.length, A = new Array(E / 2);
  for (let g = 0, e = 0; g < E; g += 2)
    A[e++] = {
      days: o[g],
      milliseconds: o[g + 1]
    };
  return A;
}
function toIntervalMonthDayNanoObjects(o, E) {
  const A = o.length, g = new Array(A / 4);
  for (let e = 0, t = 0; e < A; e += 4) {
    const c = BigInt(o[e + 3]) << BigInt(32) | BigInt(o[e + 2] >>> 0);
    g[t++] = {
      months: o[e],
      days: o[e + 1],
      nanoseconds: E ? `${c}` : c
    };
  }
  return g;
}
const util_interval_ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  toIntervalDayTimeInt32Array,
  toIntervalDayTimeObjects,
  toIntervalMonthDayNanoInt32Array,
  toIntervalMonthDayNanoObjects
}, Symbol.toStringTag, { value: "Module" }));
class VectorLoader extends Visitor {
  constructor(E, A, g, e, t = MetadataVersion.V5) {
    super(), this.nodesIndex = -1, this.buffersIndex = -1, this.bytes = E, this.nodes = A, this.buffers = g, this.dictionaries = e, this.metadataVersion = t;
  }
  visit(E) {
    return super.visit(E instanceof Field ? E.type : E);
  }
  visitNull(E, { length: A } = this.nextFieldNode()) {
    return makeData({ type: E, length: A });
  }
  visitBool(E, { length: A, nullCount: g } = this.nextFieldNode()) {
    return makeData({ type: E, length: A, nullCount: g, nullBitmap: this.readNullBitmap(E, g), data: this.readData(E) });
  }
  visitInt(E, { length: A, nullCount: g } = this.nextFieldNode()) {
    return makeData({ type: E, length: A, nullCount: g, nullBitmap: this.readNullBitmap(E, g), data: this.readData(E) });
  }
  visitFloat(E, { length: A, nullCount: g } = this.nextFieldNode()) {
    return makeData({ type: E, length: A, nullCount: g, nullBitmap: this.readNullBitmap(E, g), data: this.readData(E) });
  }
  visitUtf8(E, { length: A, nullCount: g } = this.nextFieldNode()) {
    return makeData({ type: E, length: A, nullCount: g, nullBitmap: this.readNullBitmap(E, g), valueOffsets: this.readOffsets(E), data: this.readData(E) });
  }
  visitLargeUtf8(E, { length: A, nullCount: g } = this.nextFieldNode()) {
    return makeData({ type: E, length: A, nullCount: g, nullBitmap: this.readNullBitmap(E, g), valueOffsets: this.readOffsets(E), data: this.readData(E) });
  }
  visitBinary(E, { length: A, nullCount: g } = this.nextFieldNode()) {
    return makeData({ type: E, length: A, nullCount: g, nullBitmap: this.readNullBitmap(E, g), valueOffsets: this.readOffsets(E), data: this.readData(E) });
  }
  visitLargeBinary(E, { length: A, nullCount: g } = this.nextFieldNode()) {
    return makeData({ type: E, length: A, nullCount: g, nullBitmap: this.readNullBitmap(E, g), valueOffsets: this.readOffsets(E), data: this.readData(E) });
  }
  visitFixedSizeBinary(E, { length: A, nullCount: g } = this.nextFieldNode()) {
    return makeData({ type: E, length: A, nullCount: g, nullBitmap: this.readNullBitmap(E, g), data: this.readData(E) });
  }
  visitDate(E, { length: A, nullCount: g } = this.nextFieldNode()) {
    return makeData({ type: E, length: A, nullCount: g, nullBitmap: this.readNullBitmap(E, g), data: this.readData(E) });
  }
  visitTimestamp(E, { length: A, nullCount: g } = this.nextFieldNode()) {
    return makeData({ type: E, length: A, nullCount: g, nullBitmap: this.readNullBitmap(E, g), data: this.readData(E) });
  }
  visitTime(E, { length: A, nullCount: g } = this.nextFieldNode()) {
    return makeData({ type: E, length: A, nullCount: g, nullBitmap: this.readNullBitmap(E, g), data: this.readData(E) });
  }
  visitDecimal(E, { length: A, nullCount: g } = this.nextFieldNode()) {
    return makeData({ type: E, length: A, nullCount: g, nullBitmap: this.readNullBitmap(E, g), data: this.readData(E) });
  }
  visitList(E, { length: A, nullCount: g } = this.nextFieldNode()) {
    return makeData({ type: E, length: A, nullCount: g, nullBitmap: this.readNullBitmap(E, g), valueOffsets: this.readOffsets(E), child: this.visit(E.children[0]) });
  }
  visitStruct(E, { length: A, nullCount: g } = this.nextFieldNode()) {
    return makeData({ type: E, length: A, nullCount: g, nullBitmap: this.readNullBitmap(E, g), children: this.visitMany(E.children) });
  }
  visitUnion(E, { length: A, nullCount: g } = this.nextFieldNode()) {
    return this.metadataVersion < MetadataVersion.V5 && this.readNullBitmap(E, g), E.mode === UnionMode.Sparse ? this.visitSparseUnion(E, { length: A, nullCount: g }) : this.visitDenseUnion(E, { length: A, nullCount: g });
  }
  visitDenseUnion(E, { length: A, nullCount: g } = this.nextFieldNode()) {
    return makeData({ type: E, length: A, nullCount: g, typeIds: this.readTypeIds(E), valueOffsets: this.readOffsets(E), children: this.visitMany(E.children) });
  }
  visitSparseUnion(E, { length: A, nullCount: g } = this.nextFieldNode()) {
    return makeData({ type: E, length: A, nullCount: g, typeIds: this.readTypeIds(E), children: this.visitMany(E.children) });
  }
  visitDictionary(E, { length: A, nullCount: g } = this.nextFieldNode()) {
    return makeData({ type: E, length: A, nullCount: g, nullBitmap: this.readNullBitmap(E, g), data: this.readData(E.indices), dictionary: this.readDictionary(E) });
  }
  visitInterval(E, { length: A, nullCount: g } = this.nextFieldNode()) {
    return makeData({ type: E, length: A, nullCount: g, nullBitmap: this.readNullBitmap(E, g), data: this.readData(E) });
  }
  visitDuration(E, { length: A, nullCount: g } = this.nextFieldNode()) {
    return makeData({ type: E, length: A, nullCount: g, nullBitmap: this.readNullBitmap(E, g), data: this.readData(E) });
  }
  visitFixedSizeList(E, { length: A, nullCount: g } = this.nextFieldNode()) {
    return makeData({ type: E, length: A, nullCount: g, nullBitmap: this.readNullBitmap(E, g), child: this.visit(E.children[0]) });
  }
  visitMap(E, { length: A, nullCount: g } = this.nextFieldNode()) {
    return makeData({ type: E, length: A, nullCount: g, nullBitmap: this.readNullBitmap(E, g), valueOffsets: this.readOffsets(E), child: this.visit(E.children[0]) });
  }
  nextFieldNode() {
    return this.nodes[++this.nodesIndex];
  }
  nextBufferRange() {
    return this.buffers[++this.buffersIndex];
  }
  readNullBitmap(E, A, g = this.nextBufferRange()) {
    return A > 0 && this.readData(E, g) || new Uint8Array(0);
  }
  readOffsets(E, A) {
    return this.readData(E, A);
  }
  readTypeIds(E, A) {
    return this.readData(E, A);
  }
  readData(E, { length: A, offset: g } = this.nextBufferRange()) {
    return this.bytes.subarray(g, g + A);
  }
  readDictionary(E) {
    return this.dictionaries.get(E.id);
  }
}
class JSONVectorLoader extends VectorLoader {
  constructor(E, A, g, e, t) {
    super(new Uint8Array(0), A, g, e, t), this.sources = E;
  }
  readNullBitmap(E, A, { offset: g } = this.nextBufferRange()) {
    return A <= 0 ? new Uint8Array(0) : packBools(this.sources[g]);
  }
  readOffsets(E, { offset: A } = this.nextBufferRange()) {
    return toArrayBufferView(Uint8Array, toArrayBufferView(E.OffsetArrayType, this.sources[A]));
  }
  readTypeIds(E, { offset: A } = this.nextBufferRange()) {
    return toArrayBufferView(Uint8Array, toArrayBufferView(E.ArrayType, this.sources[A]));
  }
  readData(E, { offset: A } = this.nextBufferRange()) {
    const { sources: g } = this;
    if (DataType.isTimestamp(E))
      return toArrayBufferView(Uint8Array, Int64.convertArray(g[A]));
    if ((DataType.isInt(E) || DataType.isTime(E)) && E.bitWidth === 64 || DataType.isDuration(E))
      return toArrayBufferView(Uint8Array, Int64.convertArray(g[A]));
    if (DataType.isDate(E) && E.unit === DateUnit.MILLISECOND)
      return toArrayBufferView(Uint8Array, Int64.convertArray(g[A]));
    if (DataType.isDecimal(E))
      return toArrayBufferView(Uint8Array, Int128.convertArray(g[A]));
    if (DataType.isBinary(E) || DataType.isLargeBinary(E) || DataType.isFixedSizeBinary(E))
      return binaryDataFromJSON(g[A]);
    if (DataType.isBool(E))
      return packBools(g[A]);
    if (DataType.isUtf8(E) || DataType.isLargeUtf8(E))
      return encodeUtf8(g[A].join(""));
    if (DataType.isInterval(E))
      switch (E.unit) {
        case IntervalUnit.DAY_TIME:
          return toIntervalDayTimeInt32Array(g[A]);
        case IntervalUnit.MONTH_DAY_NANO:
          return toIntervalMonthDayNanoInt32Array(g[A]);
      }
    return toArrayBufferView(Uint8Array, toArrayBufferView(E.ArrayType, g[A].map((e) => +e)));
  }
}
function binaryDataFromJSON(o) {
  const E = o.join(""), A = new Uint8Array(E.length / 2);
  for (let g = 0; g < E.length; g += 2)
    A[g >> 1] = Number.parseInt(E.slice(g, g + 2), 16);
  return A;
}
class CompressedVectorLoader extends VectorLoader {
  constructor(E, A, g, e, t) {
    super(new Uint8Array(0), A, g, e, t), this.bodyChunks = E;
  }
  readData(E, A = this.nextBufferRange()) {
    return this.bodyChunks[this.buffersIndex];
  }
}
class TypeComparator extends Visitor {
  compareSchemas(E, A) {
    return E === A || A instanceof E.constructor && this.compareManyFields(E.fields, A.fields);
  }
  compareManyFields(E, A) {
    return E === A || Array.isArray(E) && Array.isArray(A) && E.length === A.length && E.every((g, e) => this.compareFields(g, A[e]));
  }
  compareFields(E, A) {
    return E === A || A instanceof E.constructor && E.name === A.name && E.nullable === A.nullable && this.visit(E.type, A.type);
  }
}
function compareConstructor(o, E) {
  return E instanceof o.constructor;
}
function compareAny(o, E) {
  return o === E || compareConstructor(o, E);
}
function compareInt(o, E) {
  return o === E || compareConstructor(o, E) && o.bitWidth === E.bitWidth && o.isSigned === E.isSigned;
}
function compareFloat(o, E) {
  return o === E || compareConstructor(o, E) && o.precision === E.precision;
}
function compareFixedSizeBinary(o, E) {
  return o === E || compareConstructor(o, E) && o.byteWidth === E.byteWidth;
}
function compareDate(o, E) {
  return o === E || compareConstructor(o, E) && o.unit === E.unit;
}
function compareTimestamp(o, E) {
  return o === E || compareConstructor(o, E) && o.unit === E.unit && o.timezone === E.timezone;
}
function compareTime(o, E) {
  return o === E || compareConstructor(o, E) && o.unit === E.unit && o.bitWidth === E.bitWidth;
}
function compareList(o, E) {
  return o === E || compareConstructor(o, E) && o.children.length === E.children.length && instance.compareManyFields(o.children, E.children);
}
function compareStruct(o, E) {
  return o === E || compareConstructor(o, E) && o.children.length === E.children.length && instance.compareManyFields(o.children, E.children);
}
function compareUnion(o, E) {
  return o === E || compareConstructor(o, E) && o.mode === E.mode && o.typeIds.every((A, g) => A === E.typeIds[g]) && instance.compareManyFields(o.children, E.children);
}
function compareDictionary(o, E) {
  return o === E || compareConstructor(o, E) && o.id === E.id && o.isOrdered === E.isOrdered && instance.visit(o.indices, E.indices) && instance.visit(o.dictionary, E.dictionary);
}
function compareInterval(o, E) {
  return o === E || compareConstructor(o, E) && o.unit === E.unit;
}
function compareDuration(o, E) {
  return o === E || compareConstructor(o, E) && o.unit === E.unit;
}
function compareFixedSizeList(o, E) {
  return o === E || compareConstructor(o, E) && o.listSize === E.listSize && o.children.length === E.children.length && instance.compareManyFields(o.children, E.children);
}
function compareMap(o, E) {
  return o === E || compareConstructor(o, E) && o.keysSorted === E.keysSorted && o.children.length === E.children.length && instance.compareManyFields(o.children, E.children);
}
TypeComparator.prototype.visitNull = compareAny;
TypeComparator.prototype.visitBool = compareAny;
TypeComparator.prototype.visitInt = compareInt;
TypeComparator.prototype.visitInt8 = compareInt;
TypeComparator.prototype.visitInt16 = compareInt;
TypeComparator.prototype.visitInt32 = compareInt;
TypeComparator.prototype.visitInt64 = compareInt;
TypeComparator.prototype.visitUint8 = compareInt;
TypeComparator.prototype.visitUint16 = compareInt;
TypeComparator.prototype.visitUint32 = compareInt;
TypeComparator.prototype.visitUint64 = compareInt;
TypeComparator.prototype.visitFloat = compareFloat;
TypeComparator.prototype.visitFloat16 = compareFloat;
TypeComparator.prototype.visitFloat32 = compareFloat;
TypeComparator.prototype.visitFloat64 = compareFloat;
TypeComparator.prototype.visitUtf8 = compareAny;
TypeComparator.prototype.visitLargeUtf8 = compareAny;
TypeComparator.prototype.visitBinary = compareAny;
TypeComparator.prototype.visitLargeBinary = compareAny;
TypeComparator.prototype.visitFixedSizeBinary = compareFixedSizeBinary;
TypeComparator.prototype.visitDate = compareDate;
TypeComparator.prototype.visitDateDay = compareDate;
TypeComparator.prototype.visitDateMillisecond = compareDate;
TypeComparator.prototype.visitTimestamp = compareTimestamp;
TypeComparator.prototype.visitTimestampSecond = compareTimestamp;
TypeComparator.prototype.visitTimestampMillisecond = compareTimestamp;
TypeComparator.prototype.visitTimestampMicrosecond = compareTimestamp;
TypeComparator.prototype.visitTimestampNanosecond = compareTimestamp;
TypeComparator.prototype.visitTime = compareTime;
TypeComparator.prototype.visitTimeSecond = compareTime;
TypeComparator.prototype.visitTimeMillisecond = compareTime;
TypeComparator.prototype.visitTimeMicrosecond = compareTime;
TypeComparator.prototype.visitTimeNanosecond = compareTime;
TypeComparator.prototype.visitDecimal = compareAny;
TypeComparator.prototype.visitList = compareList;
TypeComparator.prototype.visitStruct = compareStruct;
TypeComparator.prototype.visitUnion = compareUnion;
TypeComparator.prototype.visitDenseUnion = compareUnion;
TypeComparator.prototype.visitSparseUnion = compareUnion;
TypeComparator.prototype.visitDictionary = compareDictionary;
TypeComparator.prototype.visitInterval = compareInterval;
TypeComparator.prototype.visitIntervalDayTime = compareInterval;
TypeComparator.prototype.visitIntervalYearMonth = compareInterval;
TypeComparator.prototype.visitIntervalMonthDayNano = compareInterval;
TypeComparator.prototype.visitDuration = compareDuration;
TypeComparator.prototype.visitDurationSecond = compareDuration;
TypeComparator.prototype.visitDurationMillisecond = compareDuration;
TypeComparator.prototype.visitDurationMicrosecond = compareDuration;
TypeComparator.prototype.visitDurationNanosecond = compareDuration;
TypeComparator.prototype.visitFixedSizeList = compareFixedSizeList;
TypeComparator.prototype.visitMap = compareMap;
const instance = new TypeComparator();
function compareSchemas(o, E) {
  return instance.compareSchemas(o, E);
}
function compareFields(o, E) {
  return instance.compareFields(o, E);
}
function compareTypes(o, E) {
  return instance.visit(o, E);
}
function distributeVectorsIntoRecordBatches(o, E) {
  return uniformlyDistributeChunksAcrossRecordBatches(o, E.map((A) => A.data.concat()));
}
function uniformlyDistributeChunksAcrossRecordBatches(o, E) {
  const A = [...o.fields], g = [], e = { numBatches: E.reduce((p, M) => Math.max(p, M.length), 0) };
  let t = 0, c = 0, n = -1;
  const h = E.length;
  let d, k = [];
  for (; e.numBatches-- > 0; ) {
    for (c = Number.POSITIVE_INFINITY, n = -1; ++n < h; )
      k[n] = d = E[n].shift(), c = Math.min(c, d ? d.length : c);
    Number.isFinite(c) && (k = distributeChildren(A, c, k, E, e), c > 0 && (g[t++] = makeData({
      type: new Struct(A),
      length: c,
      nullCount: 0,
      children: k.slice()
    })));
  }
  return [
    o = o.assign(A),
    g.map((p) => new RecordBatch$1(o, p))
  ];
}
function distributeChildren(o, E, A, g, e) {
  var t;
  const c = (E + 63 & -64) >> 3;
  for (let n = -1, h = g.length; ++n < h; ) {
    const d = A[n], k = d?.length;
    if (k >= E)
      k === E ? A[n] = d : (A[n] = d.slice(0, E), e.numBatches = Math.max(e.numBatches, g[n].unshift(d.slice(E, k - E))));
    else {
      const p = o[n];
      o[n] = p.clone({ nullable: !0 }), A[n] = (t = d?._changeLengthAndBackfillNullBitmap(E)) !== null && t !== void 0 ? t : makeData({
        type: p.type,
        length: E,
        nullCount: E,
        nullBitmap: new Uint8Array(c)
      });
    }
  }
  return A;
}
var _a$2;
let Table$1 = class Ug {
  constructor(...E) {
    var A, g;
    if (E.length === 0)
      return this.batches = [], this.schema = new Schema$2([]), this._offsets = [0], this;
    let e, t;
    E[0] instanceof Schema$2 && (e = E.shift()), E.at(-1) instanceof Uint32Array && (t = E.pop());
    const c = (h) => {
      if (h) {
        if (h instanceof RecordBatch$1)
          return [h];
        if (h instanceof Ug)
          return h.batches;
        if (h instanceof Data) {
          if (h.type instanceof Struct)
            return [new RecordBatch$1(new Schema$2(h.type.children), h)];
        } else {
          if (Array.isArray(h))
            return h.flatMap((d) => c(d));
          if (typeof h[Symbol.iterator] == "function")
            return [...h].flatMap((d) => c(d));
          if (typeof h == "object") {
            const d = Object.keys(h), k = d.map((S) => new Vector([h[S]])), p = e ?? new Schema$2(d.map((S, AA) => new Field(String(S), k[AA].type, k[AA].nullable))), [, M] = distributeVectorsIntoRecordBatches(p, k);
            return M.length === 0 ? [new RecordBatch$1(h)] : M;
          }
        }
      }
      return [];
    }, n = E.flatMap((h) => c(h));
    if (e = (g = e ?? ((A = n[0]) === null || A === void 0 ? void 0 : A.schema)) !== null && g !== void 0 ? g : new Schema$2([]), !(e instanceof Schema$2))
      throw new TypeError("Table constructor expects a [Schema, RecordBatch[]] pair.");
    for (const h of n) {
      if (!(h instanceof RecordBatch$1))
        throw new TypeError("Table constructor expects a [Schema, RecordBatch[]] pair.");
      if (!compareSchemas(e, h.schema))
        throw new TypeError("Table and inner RecordBatch schemas must be equivalent.");
    }
    this.schema = e, this.batches = n, this._offsets = t ?? computeChunkOffsets(this.data);
  }
  /**
   * The contiguous {@link RecordBatch `RecordBatch`} chunks of the Table rows.
   */
  get data() {
    return this.batches.map(({ data: E }) => E);
  }
  /**
   * The number of columns in this Table.
   */
  get numCols() {
    return this.schema.fields.length;
  }
  /**
   * The number of rows in this Table.
   */
  get numRows() {
    return this.data.reduce((E, A) => E + A.length, 0);
  }
  /**
   * The number of null rows in this Table.
   */
  get nullCount() {
    return this._nullCount === -1 && (this._nullCount = computeChunkNullCounts(this.data)), this._nullCount;
  }
  /**
   * Check whether an element is null.
   *
   * @param index The index at which to read the validity bitmap.
   */
  // @ts-ignore
  isValid(E) {
    return !1;
  }
  /**
   * Get an element value by position.
   *
   * @param index The index of the element to read.
   */
  // @ts-ignore
  get(E) {
    return null;
  }
  /**
    * Get an element value by position.
    * @param index The index of the element to read. A negative index will count back from the last element.
    */
  // @ts-ignore
  at(E) {
    return this.get(wrapIndex(E, this.numRows));
  }
  /**
   * Set an element value by position.
   *
   * @param index The index of the element to write.
   * @param value The value to set.
   */
  // @ts-ignore
  set(E, A) {
  }
  /**
   * Retrieve the index of the first occurrence of a value in an Vector.
   *
   * @param element The value to locate in the Vector.
   * @param offset The index at which to begin the search. If offset is omitted, the search starts at index 0.
   */
  // @ts-ignore
  indexOf(E, A) {
    return -1;
  }
  /**
   * Iterator for rows in this Table.
   */
  [Symbol.iterator]() {
    return this.batches.length > 0 ? instance$2.visit(new Vector(this.data)) : new Array(0)[Symbol.iterator]();
  }
  /**
   * Return a JavaScript Array of the Table rows.
   *
   * @returns An Array of Table rows.
   */
  toArray() {
    return [...this];
  }
  /**
   * Returns a string representation of the Table rows.
   *
   * @returns A string representation of the Table rows.
   */
  toString() {
    return `[
  ${this.toArray().join(`,
  `)}
]`;
  }
  /**
   * Combines two or more Tables of the same schema.
   *
   * @param others Additional Tables to add to the end of this Tables.
   */
  concat(...E) {
    const A = this.schema, g = this.data.concat(E.flatMap(({ data: e }) => e));
    return new Ug(A, g.map((e) => new RecordBatch$1(A, e)));
  }
  /**
   * Return a zero-copy sub-section of this Table.
   *
   * @param begin The beginning of the specified portion of the Table.
   * @param end The end of the specified portion of the Table. This is exclusive of the element at the index 'end'.
   */
  slice(E, A) {
    const g = this.schema;
    [E, A] = clampRange({ length: this.numRows }, E, A);
    const e = sliceChunks$1(this.data, this._offsets, E, A);
    return new Ug(g, e.map((t) => new RecordBatch$1(g, t)));
  }
  /**
   * Returns a child Vector by name, or null if this Vector has no child with the given name.
   *
   * @param name The name of the child to retrieve.
   */
  getChild(E) {
    return this.getChildAt(this.schema.fields.findIndex((A) => A.name === E));
  }
  /**
   * Returns a child Vector by index, or null if this Vector has no child at the supplied index.
   *
   * @param index The index of the child to retrieve.
   */
  getChildAt(E) {
    if (E > -1 && E < this.schema.fields.length) {
      const A = this.data.map((g) => g.children[E]);
      if (A.length === 0) {
        const { type: g } = this.schema.fields[E], e = makeData({ type: g, length: 0, nullCount: 0 });
        A.push(e._changeLengthAndBackfillNullBitmap(this.numRows));
      }
      return new Vector(A);
    }
    return null;
  }
  /**
   * Sets a child Vector by name.
   *
   * @param name The name of the child to overwrite.
   * @returns A new Table with the supplied child for the specified name.
   */
  setChild(E, A) {
    var g;
    return this.setChildAt((g = this.schema.fields) === null || g === void 0 ? void 0 : g.findIndex((e) => e.name === E), A);
  }
  setChildAt(E, A) {
    let g = this.schema, e = [...this.batches];
    if (E > -1 && E < this.numCols) {
      A || (A = new Vector([makeData({ type: new Null(), length: this.numRows })]));
      const t = g.fields.slice(), c = t[E].clone({ type: A.type }), n = this.schema.fields.map((h, d) => this.getChildAt(d));
      [t[E], n[E]] = [c, A], [g, e] = distributeVectorsIntoRecordBatches(g, n);
    }
    return new Ug(g, e);
  }
  /**
   * Construct a new Table containing only specified columns.
   *
   * @param columnNames Names of columns to keep.
   * @returns A new Table of columns matching the specified names.
   */
  select(E) {
    const A = this.schema.fields.reduce((g, e, t) => g.set(e.name, t), /* @__PURE__ */ new Map());
    return this.selectAt(E.map((g) => A.get(g)).filter((g) => g > -1));
  }
  /**
   * Construct a new Table containing only columns at the specified indices.
   *
   * @param columnIndices Indices of columns to keep.
   * @returns A new Table of columns at the specified indices.
   */
  selectAt(E) {
    const A = this.schema.selectAt(E), g = this.batches.map((e) => e.selectAt(E));
    return new Ug(A, g);
  }
  assign(E) {
    const A = this.schema.fields, [g, e] = E.schema.fields.reduce((n, h, d) => {
      const [k, p] = n, M = A.findIndex((S) => S.name === h.name);
      return ~M ? p[M] = d : k.push(d), n;
    }, [[], []]), t = this.schema.assign(E.schema), c = [
      ...A.map((n, h) => [h, e[h]]).map(([n, h]) => h === void 0 ? this.getChildAt(n) : E.getChildAt(h)),
      ...g.map((n) => E.getChildAt(n))
    ].filter(Boolean);
    return new Ug(...distributeVectorsIntoRecordBatches(t, c));
  }
};
_a$2 = Symbol.toStringTag;
Table$1[_a$2] = ((o) => (o.schema = null, o.batches = [], o._offsets = new Uint32Array([0]), o._nullCount = -1, o[Symbol.isConcatSpreadable] = !0, o.isValid = wrapChunkedCall1(isChunkedValid), o.get = wrapChunkedCall1(instance$4.getVisitFn(Type.Struct)), o.set = wrapChunkedCall2(instance$5.getVisitFn(Type.Struct)), o.indexOf = wrapChunkedIndexOf(instance$3.getVisitFn(Type.Struct)), "Table"))(Table$1.prototype);
var _a$1;
let RecordBatch$1 = class AI {
  constructor(...E) {
    switch (E.length) {
      case 2: {
        if ([this.schema] = E, !(this.schema instanceof Schema$2))
          throw new TypeError("RecordBatch constructor expects a [Schema, Data] pair.");
        if ([
          ,
          this.data = makeData({
            nullCount: 0,
            type: new Struct(this.schema.fields),
            children: this.schema.fields.map((A) => makeData({ type: A.type, nullCount: 0 }))
          })
        ] = E, !(this.data instanceof Data))
          throw new TypeError("RecordBatch constructor expects a [Schema, Data] pair.");
        [this.schema, this.data] = ensureSameLengthData(this.schema, this.data.children);
        break;
      }
      case 1: {
        const [A] = E, { fields: g, children: e, length: t } = Object.keys(A).reduce((h, d, k) => (h.children[k] = A[d], h.length = Math.max(h.length, A[d].length), h.fields[k] = Field.new({ name: d, type: A[d].type, nullable: !0 }), h), {
          length: 0,
          fields: new Array(),
          children: new Array()
        }), c = new Schema$2(g), n = makeData({ type: new Struct(g), length: t, children: e, nullCount: 0 });
        [this.schema, this.data] = ensureSameLengthData(c, n.children, t);
        break;
      }
      default:
        throw new TypeError("RecordBatch constructor expects an Object mapping names to child Data, or a [Schema, Data] pair.");
    }
  }
  get dictionaries() {
    return this._dictionaries || (this._dictionaries = collectDictionaries(this.schema.fields, this.data.children));
  }
  /**
   * The number of columns in this RecordBatch.
   */
  get numCols() {
    return this.schema.fields.length;
  }
  /**
   * The number of rows in this RecordBatch.
   */
  get numRows() {
    return this.data.length;
  }
  /**
   * The number of null rows in this RecordBatch.
   */
  get nullCount() {
    return this.data.nullCount;
  }
  /**
   * Check whether an row is null.
   * @param index The index at which to read the validity bitmap.
   */
  isValid(E) {
    return this.data.getValid(E);
  }
  /**
   * Get a row by position.
   * @param index The index of the row to read.
   */
  get(E) {
    return instance$4.visit(this.data, E);
  }
  /**
    * Get a row value by position.
    * @param index The index of the row to read. A negative index will count back from the last row.
    */
  at(E) {
    return this.get(wrapIndex(E, this.numRows));
  }
  /**
   * Set a row by position.
   * @param index The index of the row to write.
   * @param value The value to set.
   */
  set(E, A) {
    return instance$5.visit(this.data, E, A);
  }
  /**
   * Retrieve the index of the first occurrence of a row in an RecordBatch.
   * @param element The row to locate in the RecordBatch.
   * @param offset The index at which to begin the search. If offset is omitted, the search starts at index 0.
   */
  indexOf(E, A) {
    return instance$3.visit(this.data, E, A);
  }
  /**
   * Iterator for rows in this RecordBatch.
   */
  [Symbol.iterator]() {
    return instance$2.visit(new Vector([this.data]));
  }
  /**
   * Return a JavaScript Array of the RecordBatch rows.
   * @returns An Array of RecordBatch rows.
   */
  toArray() {
    return [...this];
  }
  /**
   * Combines two or more RecordBatch of the same schema.
   * @param others Additional RecordBatch to add to the end of this RecordBatch.
   */
  concat(...E) {
    return new Table$1(this.schema, [this, ...E]);
  }
  /**
   * Return a zero-copy sub-section of this RecordBatch.
   * @param start The beginning of the specified portion of the RecordBatch.
   * @param end The end of the specified portion of the RecordBatch. This is exclusive of the row at the index 'end'.
   */
  slice(E, A) {
    const [g] = new Vector([this.data]).slice(E, A).data;
    return new AI(this.schema, g);
  }
  /**
   * Returns a child Vector by name, or null if this Vector has no child with the given name.
   * @param name The name of the child to retrieve.
   */
  getChild(E) {
    var A;
    return this.getChildAt((A = this.schema.fields) === null || A === void 0 ? void 0 : A.findIndex((g) => g.name === E));
  }
  /**
   * Returns a child Vector by index, or null if this Vector has no child at the supplied index.
   * @param index The index of the child to retrieve.
   */
  getChildAt(E) {
    return E > -1 && E < this.schema.fields.length ? new Vector([this.data.children[E]]) : null;
  }
  /**
   * Sets a child Vector by name.
   * @param name The name of the child to overwrite.
   * @returns A new RecordBatch with the new child for the specified name.
   */
  setChild(E, A) {
    var g;
    return this.setChildAt((g = this.schema.fields) === null || g === void 0 ? void 0 : g.findIndex((e) => e.name === E), A);
  }
  setChildAt(E, A) {
    let g = this.schema, e = this.data;
    if (E > -1 && E < this.numCols) {
      A || (A = new Vector([makeData({ type: new Null(), length: this.numRows })]));
      const t = g.fields.slice(), c = e.children.slice(), n = t[E].clone({ type: A.type });
      [t[E], c[E]] = [n, A.data[0]], g = new Schema$2(t, new Map(this.schema.metadata)), e = makeData({ type: new Struct(t), children: c });
    }
    return new AI(g, e);
  }
  /**
   * Construct a new RecordBatch containing only specified columns.
   *
   * @param columnNames Names of columns to keep.
   * @returns A new RecordBatch of columns matching the specified names.
   */
  select(E) {
    const A = this.schema.select(E), g = new Struct(A.fields), e = [];
    for (const t of E) {
      const c = this.schema.fields.findIndex((n) => n.name === t);
      ~c && (e[c] = this.data.children[c]);
    }
    return new AI(A, makeData({ type: g, length: this.numRows, children: e }));
  }
  /**
   * Construct a new RecordBatch containing only columns at the specified indices.
   *
   * @param columnIndices Indices of columns to keep.
   * @returns A new RecordBatch of columns matching at the specified indices.
   */
  selectAt(E) {
    const A = this.schema.selectAt(E), g = E.map((t) => this.data.children[t]).filter(Boolean), e = makeData({ type: new Struct(A.fields), length: this.numRows, children: g });
    return new AI(A, e);
  }
};
_a$1 = Symbol.toStringTag;
RecordBatch$1[_a$1] = ((o) => (o._nullCount = -1, o[Symbol.isConcatSpreadable] = !0, "RecordBatch"))(RecordBatch$1.prototype);
function ensureSameLengthData(o, E, A = E.reduce((g, e) => Math.max(g, e.length), 0)) {
  var g;
  const e = [...o.fields], t = [...E], c = (A + 63 & -64) >> 3;
  for (const [n, h] of o.fields.entries()) {
    const d = E[n];
    (!d || d.length !== A) && (e[n] = h.clone({ nullable: !0 }), t[n] = (g = d?._changeLengthAndBackfillNullBitmap(A)) !== null && g !== void 0 ? g : makeData({
      type: h.type,
      length: A,
      nullCount: A,
      nullBitmap: new Uint8Array(c)
    }));
  }
  return [
    o.assign(e),
    makeData({ type: new Struct(e), length: A, children: t })
  ];
}
function collectDictionaries(o, E, A = /* @__PURE__ */ new Map()) {
  var g, e;
  if (((g = o?.length) !== null && g !== void 0 ? g : 0) > 0 && o?.length === E?.length)
    for (let t = -1, c = o.length; ++t < c; ) {
      const { type: n } = o[t], h = E[t];
      for (const d of [h, ...((e = h?.dictionary) === null || e === void 0 ? void 0 : e.data) || []])
        collectDictionaries(n.children, d?.children, A);
      if (DataType.isDictionary(n)) {
        const { id: d } = n;
        if (!A.has(d))
          h?.dictionary && A.set(d, h.dictionary);
        else if (A.get(d) !== h.dictionary)
          throw new Error("Cannot create Schema containing two different dictionaries with the same Id");
      }
    }
  return A;
}
class _InternalEmptyPlaceholderRecordBatch extends RecordBatch$1 {
  constructor(E) {
    const A = E.fields.map((e) => makeData({ type: e.type })), g = makeData({ type: new Struct(E.fields), nullCount: 0, children: A });
    super(E, g);
  }
}
const invalidMessageType = (o) => `Expected ${MessageHeader[o]} Message in stream, but was null or length 0.`, nullMessage = (o) => `Header pointer of flatbuffer-encoded ${MessageHeader[o]} Message is null or length 0.`, invalidMessageMetadata = (o, E) => `Expected to read ${o} metadata bytes, but only read ${E}.`, invalidMessageBodyLength = (o, E) => `Expected to read ${o} bytes for message body, but only read ${E}.`;
class MessageReader {
  constructor(E) {
    this.source = E instanceof ByteStream ? E : new ByteStream(E);
  }
  [Symbol.iterator]() {
    return this;
  }
  next() {
    let E;
    return (E = this.readMetadataLength()).done || E.value === -1 && (E = this.readMetadataLength()).done || (E = this.readMetadata(E.value)).done ? ITERATOR_DONE : E;
  }
  throw(E) {
    return this.source.throw(E);
  }
  return(E) {
    return this.source.return(E);
  }
  readMessage(E) {
    let A;
    if ((A = this.next()).done)
      return null;
    if (E != null && A.value.headerType !== E)
      throw new Error(invalidMessageType(E));
    return A.value;
  }
  readMessageBody(E) {
    if (E <= 0)
      return new Uint8Array(0);
    const A = toUint8Array(this.source.read(E));
    if (A.byteLength < E)
      throw new Error(invalidMessageBodyLength(E, A.byteLength));
    return (
      /* 1. */
      A.byteOffset % 8 === 0 && /* 2. */
      A.byteOffset + A.byteLength <= A.buffer.byteLength ? A : A.slice()
    );
  }
  readSchema(E = !1) {
    const A = MessageHeader.Schema, g = this.readMessage(A), e = g?.header();
    if (E && !e)
      throw new Error(nullMessage(A));
    return e;
  }
  readMetadataLength() {
    const E = this.source.read(PADDING), A = E && new ByteBuffer$2(E), g = A?.readInt32(0) || 0;
    return { done: g === 0, value: g };
  }
  readMetadata(E) {
    const A = this.source.read(E);
    if (!A)
      return ITERATOR_DONE;
    if (A.byteLength < E)
      throw new Error(invalidMessageMetadata(E, A.byteLength));
    return { done: !1, value: Message.decode(A) };
  }
}
class AsyncMessageReader {
  constructor(E, A) {
    this.source = E instanceof AsyncByteStream ? E : isFileHandle(E) ? new AsyncRandomAccessFile(E, A) : new AsyncByteStream(E);
  }
  [Symbol.asyncIterator]() {
    return this;
  }
  next() {
    return __awaiter(this, void 0, void 0, function* () {
      let E;
      return (E = yield this.readMetadataLength()).done || E.value === -1 && (E = yield this.readMetadataLength()).done || (E = yield this.readMetadata(E.value)).done ? ITERATOR_DONE : E;
    });
  }
  throw(E) {
    return __awaiter(this, void 0, void 0, function* () {
      return yield this.source.throw(E);
    });
  }
  return(E) {
    return __awaiter(this, void 0, void 0, function* () {
      return yield this.source.return(E);
    });
  }
  readMessage(E) {
    return __awaiter(this, void 0, void 0, function* () {
      let A;
      if ((A = yield this.next()).done)
        return null;
      if (E != null && A.value.headerType !== E)
        throw new Error(invalidMessageType(E));
      return A.value;
    });
  }
  readMessageBody(E) {
    return __awaiter(this, void 0, void 0, function* () {
      if (E <= 0)
        return new Uint8Array(0);
      const A = toUint8Array(yield this.source.read(E));
      if (A.byteLength < E)
        throw new Error(invalidMessageBodyLength(E, A.byteLength));
      return (
        /* 1. */
        A.byteOffset % 8 === 0 && /* 2. */
        A.byteOffset + A.byteLength <= A.buffer.byteLength ? A : A.slice()
      );
    });
  }
  readSchema() {
    return __awaiter(this, arguments, void 0, function* (E = !1) {
      const A = MessageHeader.Schema, g = yield this.readMessage(A), e = g?.header();
      if (E && !e)
        throw new Error(nullMessage(A));
      return e;
    });
  }
  readMetadataLength() {
    return __awaiter(this, void 0, void 0, function* () {
      const E = yield this.source.read(PADDING), A = E && new ByteBuffer$2(E), g = A?.readInt32(0) || 0;
      return { done: g === 0, value: g };
    });
  }
  readMetadata(E) {
    return __awaiter(this, void 0, void 0, function* () {
      const A = yield this.source.read(E);
      if (!A)
        return ITERATOR_DONE;
      if (A.byteLength < E)
        throw new Error(invalidMessageMetadata(E, A.byteLength));
      return { done: !1, value: Message.decode(A) };
    });
  }
}
class JSONMessageReader extends MessageReader {
  constructor(E) {
    super(new Uint8Array(0)), this._schema = !1, this._body = [], this._batchIndex = 0, this._dictionaryIndex = 0, this._json = E instanceof ArrowJSON ? E : new ArrowJSON(E);
  }
  next() {
    const { _json: E } = this;
    if (!this._schema)
      return this._schema = !0, { done: !1, value: Message.fromJSON(E.schema, MessageHeader.Schema) };
    if (this._dictionaryIndex < E.dictionaries.length) {
      const A = E.dictionaries[this._dictionaryIndex++];
      return this._body = A.data.columns, { done: !1, value: Message.fromJSON(A, MessageHeader.DictionaryBatch) };
    }
    if (this._batchIndex < E.batches.length) {
      const A = E.batches[this._batchIndex++];
      return this._body = A.columns, { done: !1, value: Message.fromJSON(A, MessageHeader.RecordBatch) };
    }
    return this._body = [], ITERATOR_DONE;
  }
  readMessageBody(E) {
    return A(this._body);
    function A(g) {
      return (g || []).reduce((e, t) => [
        ...e,
        ...t.VALIDITY && [t.VALIDITY] || [],
        ...t.TYPE_ID && [t.TYPE_ID] || [],
        ...t.OFFSET && [t.OFFSET] || [],
        ...t.DATA && [t.DATA] || [],
        ...A(t.children)
      ], []);
    }
  }
  readMessage(E) {
    let A;
    if ((A = this.next()).done)
      return null;
    if (E != null && A.value.headerType !== E)
      throw new Error(invalidMessageType(E));
    return A.value;
  }
  readSchema() {
    const E = MessageHeader.Schema, A = this.readMessage(E), g = A?.header();
    if (!A || !g)
      throw new Error(nullMessage(E));
    return g;
  }
}
const PADDING = 4, MAGIC_STR = "ARROW1", MAGIC = new Uint8Array(MAGIC_STR.length);
for (let o = 0; o < MAGIC_STR.length; o += 1)
  MAGIC[o] = MAGIC_STR.codePointAt(o);
function checkForMagicArrowString(o, E = 0) {
  for (let A = -1, g = MAGIC.length; ++A < g; )
    if (MAGIC[A] !== o[E + A])
      return !1;
  return !0;
}
const magicLength = MAGIC.length, magicAndPadding = magicLength + PADDING, magicX2AndPadding = magicLength * 2 + PADDING;
class Lz4FrameValidator {
  constructor() {
    this.LZ4_FRAME_MAGIC = new Uint8Array([4, 34, 77, 24]), this.MIN_HEADER_LENGTH = 7;
  }
  isValidCodecEncode(E) {
    const A = new Uint8Array([1, 2, 3, 4, 5, 6, 7, 8]), g = E.encode(A);
    return this._isValidCompressed(g);
  }
  _isValidCompressed(E) {
    return this._hasMinimumLength(E) && this._hasValidMagicNumber(E) && this._hasValidVersion(E);
  }
  _hasMinimumLength(E) {
    return E.length >= this.MIN_HEADER_LENGTH;
  }
  _hasValidMagicNumber(E) {
    return this.LZ4_FRAME_MAGIC.every((A, g) => E[g] === A);
  }
  _hasValidVersion(E) {
    return (E[4] & 192) >> 6 === 1;
  }
}
class ZstdValidator {
  constructor() {
    this.ZSTD_MAGIC = new Uint8Array([40, 181, 47, 253]), this.MIN_HEADER_LENGTH = 6;
  }
  isValidCodecEncode(E) {
    const A = new Uint8Array([1, 2, 3, 4, 5, 6, 7, 8]), g = E.encode(A);
    return this._isValidCompressed(g);
  }
  _isValidCompressed(E) {
    return this._hasMinimumLength(E) && this._hasValidMagicNumber(E);
  }
  _hasMinimumLength(E) {
    return E.length >= this.MIN_HEADER_LENGTH;
  }
  _hasValidMagicNumber(E) {
    return this.ZSTD_MAGIC.every((A, g) => E[g] === A);
  }
}
const compressionValidators = {
  [CompressionType.LZ4_FRAME]: new Lz4FrameValidator(),
  [CompressionType.ZSTD]: new ZstdValidator()
};
class _CompressionRegistry {
  constructor() {
    this.registry = {};
  }
  set(E, A) {
    if (A?.encode && typeof A.encode == "function" && !compressionValidators[E].isValidCodecEncode(A))
      throw new Error(`Encoder for ${CompressionType[E]} is not valid.`);
    this.registry[E] = A;
  }
  get(E) {
    var A;
    return ((A = this.registry) === null || A === void 0 ? void 0 : A[E]) || null;
  }
}
const compressionRegistry = new _CompressionRegistry(), LENGTH_NO_COMPRESSED_DATA = -1, COMPRESS_LENGTH_PREFIX = 8;
class RecordBatchReader extends ReadableInterop {
  constructor(E) {
    super(), this._impl = E;
  }
  get closed() {
    return this._impl.closed;
  }
  get schema() {
    return this._impl.schema;
  }
  get autoDestroy() {
    return this._impl.autoDestroy;
  }
  get dictionaries() {
    return this._impl.dictionaries;
  }
  get numDictionaries() {
    return this._impl.numDictionaries;
  }
  get numRecordBatches() {
    return this._impl.numRecordBatches;
  }
  get footer() {
    return this._impl.isFile() ? this._impl.footer : null;
  }
  isSync() {
    return this._impl.isSync();
  }
  isAsync() {
    return this._impl.isAsync();
  }
  isFile() {
    return this._impl.isFile();
  }
  isStream() {
    return this._impl.isStream();
  }
  next() {
    return this._impl.next();
  }
  throw(E) {
    return this._impl.throw(E);
  }
  return(E) {
    return this._impl.return(E);
  }
  cancel() {
    return this._impl.cancel();
  }
  reset(E) {
    return this._impl.reset(E), this._DOMStream = void 0, this._nodeStream = void 0, this;
  }
  open(E) {
    const A = this._impl.open(E);
    return isPromise(A) ? A.then(() => this) : this;
  }
  readRecordBatch(E) {
    return this._impl.isFile() ? this._impl.readRecordBatch(E) : null;
  }
  [Symbol.iterator]() {
    return this._impl[Symbol.iterator]();
  }
  [Symbol.asyncIterator]() {
    return this._impl[Symbol.asyncIterator]();
  }
  toDOMStream() {
    return streamAdapters.toDOMStream(this.isSync() ? { [Symbol.iterator]: () => this } : { [Symbol.asyncIterator]: () => this });
  }
  toNodeStream() {
    return streamAdapters.toNodeStream(this.isSync() ? { [Symbol.iterator]: () => this } : { [Symbol.asyncIterator]: () => this }, { objectMode: !0 });
  }
  /** @nocollapse */
  // @ts-ignore
  static throughNode(E) {
    throw new Error('"throughNode" not available in this environment');
  }
  /** @nocollapse */
  static throughDOM(E, A) {
    throw new Error('"throughDOM" not available in this environment');
  }
  /** @nocollapse */
  static from(E) {
    return E instanceof RecordBatchReader ? E : isArrowJSON(E) ? fromArrowJSON(E) : isFileHandle(E) ? fromFileHandle(E) : isPromise(E) ? __awaiter(this, void 0, void 0, function* () {
      return yield RecordBatchReader.from(yield E);
    }) : isFetchResponse(E) || isReadableDOMStream(E) || isReadableNodeStream(E) || isAsyncIterable$1(E) ? fromAsyncByteStream(new AsyncByteStream(E)) : fromByteStream(new ByteStream(E));
  }
  /** @nocollapse */
  static readAll(E) {
    return E instanceof RecordBatchReader ? E.isSync() ? readAllSync(E) : readAllAsync(E) : isArrowJSON(E) || ArrayBuffer.isView(E) || isIterable(E) || isIteratorResult(E) ? readAllSync(E) : readAllAsync(E);
  }
}
class RecordBatchStreamReader extends RecordBatchReader {
  constructor(E) {
    super(E), this._impl = E;
  }
  readAll() {
    return [...this];
  }
  [Symbol.iterator]() {
    return this._impl[Symbol.iterator]();
  }
  [Symbol.asyncIterator]() {
    return __asyncGenerator(this, arguments, function* () {
      yield __await(yield* __asyncDelegator(__asyncValues(this[Symbol.iterator]())));
    });
  }
}
class AsyncRecordBatchStreamReader extends RecordBatchReader {
  constructor(E) {
    super(E), this._impl = E;
  }
  readAll() {
    return __awaiter(this, void 0, void 0, function* () {
      var E, A, g, e;
      const t = new Array();
      try {
        for (var c = !0, n = __asyncValues(this), h; h = yield n.next(), E = h.done, !E; c = !0) {
          e = h.value, c = !1;
          const d = e;
          t.push(d);
        }
      } catch (d) {
        A = { error: d };
      } finally {
        try {
          !c && !E && (g = n.return) && (yield g.call(n));
        } finally {
          if (A) throw A.error;
        }
      }
      return t;
    });
  }
  [Symbol.iterator]() {
    throw new Error("AsyncRecordBatchStreamReader is not Iterable");
  }
  [Symbol.asyncIterator]() {
    return this._impl[Symbol.asyncIterator]();
  }
}
class RecordBatchFileReader extends RecordBatchStreamReader {
  constructor(E) {
    super(E), this._impl = E;
  }
}
class AsyncRecordBatchFileReader extends AsyncRecordBatchStreamReader {
  constructor(E) {
    super(E), this._impl = E;
  }
}
class RecordBatchReaderImpl {
  get numDictionaries() {
    return this._dictionaryIndex;
  }
  get numRecordBatches() {
    return this._recordBatchIndex;
  }
  constructor(E = /* @__PURE__ */ new Map()) {
    this.closed = !1, this.autoDestroy = !0, this._dictionaryIndex = 0, this._recordBatchIndex = 0, this.dictionaries = E;
  }
  isSync() {
    return !1;
  }
  isAsync() {
    return !1;
  }
  isFile() {
    return !1;
  }
  isStream() {
    return !1;
  }
  reset(E) {
    return this._dictionaryIndex = 0, this._recordBatchIndex = 0, this.schema = E, this.dictionaries = /* @__PURE__ */ new Map(), this;
  }
  _loadRecordBatch(E, A) {
    let g;
    if (E.compression != null) {
      const t = compressionRegistry.get(E.compression.type);
      if (t?.decode && typeof t.decode == "function") {
        const { decommpressedBody: c, buffers: n } = this._decompressBuffers(E, A, t);
        g = this._loadCompressedVectors(E, c, this.schema.fields), E = new RecordBatch$2(E.length, E.nodes, n, null);
      } else
        throw new Error("Record batch is compressed but codec not found");
    } else
      g = this._loadVectors(E, A, this.schema.fields);
    const e = makeData({ type: new Struct(this.schema.fields), length: E.length, children: g });
    return new RecordBatch$1(this.schema, e);
  }
  _loadDictionaryBatch(E, A) {
    const { id: g, isDelta: e } = E, { dictionaries: t, schema: c } = this, n = t.get(g), h = c.dictionaries.get(g);
    let d;
    if (E.data.compression != null) {
      const k = compressionRegistry.get(E.data.compression.type);
      if (k?.decode && typeof k.decode == "function") {
        const { decommpressedBody: p, buffers: M } = this._decompressBuffers(E.data, A, k);
        d = this._loadCompressedVectors(E.data, p, [h]), E = new DictionaryBatch(new RecordBatch$2(E.data.length, E.data.nodes, M, null), g, e);
      } else
        throw new Error("Dictionary batch is compressed but codec not found");
    } else
      d = this._loadVectors(E.data, A, [h]);
    return (n && e ? n.concat(new Vector(d)) : new Vector(d)).memoize();
  }
  _loadVectors(E, A, g) {
    return new VectorLoader(A, E.nodes, E.buffers, this.dictionaries, this.schema.metadataVersion).visitMany(g);
  }
  _loadCompressedVectors(E, A, g) {
    return new CompressedVectorLoader(A, E.nodes, E.buffers, this.dictionaries, this.schema.metadataVersion).visitMany(g);
  }
  _decompressBuffers(E, A, g) {
    const e = [], t = [];
    let c = 0;
    for (const { offset: n, length: h } of E.buffers) {
      if (h === 0) {
        e.push(new Uint8Array(0)), t.push(new BufferRegion(c, 0));
        continue;
      }
      const d = new ByteBuffer$2(A.subarray(n, n + h)), k = bigIntToNumber(d.readInt64(0)), p = d.bytes().subarray(COMPRESS_LENGTH_PREFIX), M = k === LENGTH_NO_COMPRESSED_DATA ? p : g.decode(p);
      e.push(M);
      const S = (c + 7 & -8) - c;
      c += S, t.push(new BufferRegion(c, M.length)), c += M.length;
    }
    return {
      decommpressedBody: e,
      buffers: t
    };
  }
}
class RecordBatchStreamReaderImpl extends RecordBatchReaderImpl {
  constructor(E, A) {
    super(A), this._reader = isArrowJSON(E) ? new JSONMessageReader(this._handle = E) : new MessageReader(this._handle = E);
  }
  isSync() {
    return !0;
  }
  isStream() {
    return !0;
  }
  [Symbol.iterator]() {
    return this;
  }
  cancel() {
    !this.closed && (this.closed = !0) && (this.reset()._reader.return(), this._reader = null, this.dictionaries = null);
  }
  open(E) {
    return this.closed || (this.autoDestroy = shouldAutoDestroy(this, E), this.schema || (this.schema = this._reader.readSchema()) || this.cancel()), this;
  }
  throw(E) {
    return !this.closed && this.autoDestroy && (this.closed = !0) ? this.reset()._reader.throw(E) : ITERATOR_DONE;
  }
  return(E) {
    return !this.closed && this.autoDestroy && (this.closed = !0) ? this.reset()._reader.return(E) : ITERATOR_DONE;
  }
  next() {
    if (this.closed)
      return ITERATOR_DONE;
    let E;
    const { _reader: A } = this;
    for (; E = this._readNextMessageAndValidate(); )
      if (E.isSchema())
        this.reset(E.header());
      else if (E.isRecordBatch()) {
        this._recordBatchIndex++;
        const g = E.header(), e = A.readMessageBody(E.bodyLength);
        return { done: !1, value: this._loadRecordBatch(g, e) };
      } else if (E.isDictionaryBatch()) {
        this._dictionaryIndex++;
        const g = E.header(), e = A.readMessageBody(E.bodyLength), t = this._loadDictionaryBatch(g, e);
        this.dictionaries.set(g.id, t);
      }
    return this.schema && this._recordBatchIndex === 0 ? (this._recordBatchIndex++, { done: !1, value: new _InternalEmptyPlaceholderRecordBatch(this.schema) }) : this.return();
  }
  _readNextMessageAndValidate(E) {
    return this._reader.readMessage(E);
  }
}
class AsyncRecordBatchStreamReaderImpl extends RecordBatchReaderImpl {
  constructor(E, A) {
    super(A), this._reader = new AsyncMessageReader(this._handle = E);
  }
  isAsync() {
    return !0;
  }
  isStream() {
    return !0;
  }
  [Symbol.asyncIterator]() {
    return this;
  }
  cancel() {
    return __awaiter(this, void 0, void 0, function* () {
      !this.closed && (this.closed = !0) && (yield this.reset()._reader.return(), this._reader = null, this.dictionaries = null);
    });
  }
  open(E) {
    return __awaiter(this, void 0, void 0, function* () {
      return this.closed || (this.autoDestroy = shouldAutoDestroy(this, E), this.schema || (this.schema = yield this._reader.readSchema()) || (yield this.cancel())), this;
    });
  }
  throw(E) {
    return __awaiter(this, void 0, void 0, function* () {
      return !this.closed && this.autoDestroy && (this.closed = !0) ? yield this.reset()._reader.throw(E) : ITERATOR_DONE;
    });
  }
  return(E) {
    return __awaiter(this, void 0, void 0, function* () {
      return !this.closed && this.autoDestroy && (this.closed = !0) ? yield this.reset()._reader.return(E) : ITERATOR_DONE;
    });
  }
  next() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.closed)
        return ITERATOR_DONE;
      let E;
      const { _reader: A } = this;
      for (; E = yield this._readNextMessageAndValidate(); )
        if (E.isSchema())
          yield this.reset(E.header());
        else if (E.isRecordBatch()) {
          this._recordBatchIndex++;
          const g = E.header(), e = yield A.readMessageBody(E.bodyLength);
          return { done: !1, value: this._loadRecordBatch(g, e) };
        } else if (E.isDictionaryBatch()) {
          this._dictionaryIndex++;
          const g = E.header(), e = yield A.readMessageBody(E.bodyLength), t = this._loadDictionaryBatch(g, e);
          this.dictionaries.set(g.id, t);
        }
      return this.schema && this._recordBatchIndex === 0 ? (this._recordBatchIndex++, { done: !1, value: new _InternalEmptyPlaceholderRecordBatch(this.schema) }) : yield this.return();
    });
  }
  _readNextMessageAndValidate(E) {
    return __awaiter(this, void 0, void 0, function* () {
      return yield this._reader.readMessage(E);
    });
  }
}
class RecordBatchFileReaderImpl extends RecordBatchStreamReaderImpl {
  get footer() {
    return this._footer;
  }
  get numDictionaries() {
    return this._footer ? this._footer.numDictionaries : 0;
  }
  get numRecordBatches() {
    return this._footer ? this._footer.numRecordBatches : 0;
  }
  constructor(E, A) {
    super(E instanceof RandomAccessFile ? E : new RandomAccessFile(E), A);
  }
  isSync() {
    return !0;
  }
  isFile() {
    return !0;
  }
  open(E) {
    if (!this.closed && !this._footer) {
      this.schema = (this._footer = this._readFooter()).schema;
      for (const A of this._footer.dictionaryBatches())
        A && this._readDictionaryBatch(this._dictionaryIndex++);
    }
    return super.open(E);
  }
  readRecordBatch(E) {
    var A;
    if (this.closed)
      return null;
    this._footer || this.open();
    const g = (A = this._footer) === null || A === void 0 ? void 0 : A.getRecordBatch(E);
    if (g && this._handle.seek(g.offset)) {
      const e = this._reader.readMessage(MessageHeader.RecordBatch);
      if (e?.isRecordBatch()) {
        const t = e.header(), c = this._reader.readMessageBody(e.bodyLength);
        return this._loadRecordBatch(t, c);
      }
    }
    return null;
  }
  _readDictionaryBatch(E) {
    var A;
    const g = (A = this._footer) === null || A === void 0 ? void 0 : A.getDictionaryBatch(E);
    if (g && this._handle.seek(g.offset)) {
      const e = this._reader.readMessage(MessageHeader.DictionaryBatch);
      if (e?.isDictionaryBatch()) {
        const t = e.header(), c = this._reader.readMessageBody(e.bodyLength), n = this._loadDictionaryBatch(t, c);
        this.dictionaries.set(t.id, n);
      }
    }
  }
  _readFooter() {
    const { _handle: E } = this, A = E.size - magicAndPadding, g = E.readInt32(A), e = E.readAt(A - g, g);
    return Footer_.decode(e);
  }
  _readNextMessageAndValidate(E) {
    var A;
    if (this._footer || this.open(), this._footer && this._recordBatchIndex < this.numRecordBatches) {
      const g = (A = this._footer) === null || A === void 0 ? void 0 : A.getRecordBatch(this._recordBatchIndex);
      if (g && this._handle.seek(g.offset))
        return this._reader.readMessage(E);
    }
    return null;
  }
}
class AsyncRecordBatchFileReaderImpl extends AsyncRecordBatchStreamReaderImpl {
  get footer() {
    return this._footer;
  }
  get numDictionaries() {
    return this._footer ? this._footer.numDictionaries : 0;
  }
  get numRecordBatches() {
    return this._footer ? this._footer.numRecordBatches : 0;
  }
  constructor(E, ...A) {
    const g = typeof A[0] != "number" ? A.shift() : void 0, e = A[0] instanceof Map ? A.shift() : void 0;
    super(E instanceof AsyncRandomAccessFile ? E : new AsyncRandomAccessFile(E, g), e);
  }
  isFile() {
    return !0;
  }
  isAsync() {
    return !0;
  }
  open(E) {
    const A = Object.create(null, {
      open: { get: () => super.open }
    });
    return __awaiter(this, void 0, void 0, function* () {
      if (!this.closed && !this._footer) {
        this.schema = (this._footer = yield this._readFooter()).schema;
        for (const g of this._footer.dictionaryBatches())
          g && (yield this._readDictionaryBatch(this._dictionaryIndex++));
      }
      return yield A.open.call(this, E);
    });
  }
  readRecordBatch(E) {
    return __awaiter(this, void 0, void 0, function* () {
      var A;
      if (this.closed)
        return null;
      this._footer || (yield this.open());
      const g = (A = this._footer) === null || A === void 0 ? void 0 : A.getRecordBatch(E);
      if (g && (yield this._handle.seek(g.offset))) {
        const e = yield this._reader.readMessage(MessageHeader.RecordBatch);
        if (e?.isRecordBatch()) {
          const t = e.header(), c = yield this._reader.readMessageBody(e.bodyLength);
          return this._loadRecordBatch(t, c);
        }
      }
      return null;
    });
  }
  _readDictionaryBatch(E) {
    return __awaiter(this, void 0, void 0, function* () {
      var A;
      const g = (A = this._footer) === null || A === void 0 ? void 0 : A.getDictionaryBatch(E);
      if (g && (yield this._handle.seek(g.offset))) {
        const e = yield this._reader.readMessage(MessageHeader.DictionaryBatch);
        if (e?.isDictionaryBatch()) {
          const t = e.header(), c = yield this._reader.readMessageBody(e.bodyLength), n = this._loadDictionaryBatch(t, c);
          this.dictionaries.set(t.id, n);
        }
      }
    });
  }
  _readFooter() {
    return __awaiter(this, void 0, void 0, function* () {
      const { _handle: E } = this;
      E._pending && (yield E._pending);
      const A = E.size - magicAndPadding, g = yield E.readInt32(A), e = yield E.readAt(A - g, g);
      return Footer_.decode(e);
    });
  }
  _readNextMessageAndValidate(E) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this._footer || (yield this.open()), this._footer && this._recordBatchIndex < this.numRecordBatches) {
        const A = this._footer.getRecordBatch(this._recordBatchIndex);
        if (A && (yield this._handle.seek(A.offset)))
          return yield this._reader.readMessage(E);
      }
      return null;
    });
  }
}
class RecordBatchJSONReaderImpl extends RecordBatchStreamReaderImpl {
  constructor(E, A) {
    super(E, A);
  }
  _loadVectors(E, A, g) {
    return new JSONVectorLoader(A, E.nodes, E.buffers, this.dictionaries, this.schema.metadataVersion).visitMany(g);
  }
}
function shouldAutoDestroy(o, E) {
  return E && typeof E.autoDestroy == "boolean" ? E.autoDestroy : o.autoDestroy;
}
function* readAllSync(o) {
  const E = RecordBatchReader.from(o);
  try {
    if (!E.open({ autoDestroy: !1 }).closed)
      do
        yield E;
      while (!E.reset().open().closed);
  } finally {
    E.cancel();
  }
}
function readAllAsync(o) {
  return __asyncGenerator(this, arguments, function* () {
    const A = yield __await(RecordBatchReader.from(o));
    try {
      if (!(yield __await(A.open({ autoDestroy: !1 }))).closed)
        do
          yield yield __await(A);
        while (!(yield __await(A.reset().open())).closed);
    } finally {
      yield __await(A.cancel());
    }
  });
}
function fromArrowJSON(o) {
  return new RecordBatchStreamReader(new RecordBatchJSONReaderImpl(o));
}
function fromByteStream(o) {
  const E = o.peek(magicLength + 7 & -8);
  return E && E.byteLength >= 4 ? checkForMagicArrowString(E) ? new RecordBatchFileReader(new RecordBatchFileReaderImpl(o.read())) : new RecordBatchStreamReader(new RecordBatchStreamReaderImpl(o)) : new RecordBatchStreamReader(new RecordBatchStreamReaderImpl((function* () {
  })()));
}
function fromAsyncByteStream(o) {
  return __awaiter(this, void 0, void 0, function* () {
    const E = yield o.peek(magicLength + 7 & -8);
    return E && E.byteLength >= 4 ? checkForMagicArrowString(E) ? new RecordBatchFileReader(new RecordBatchFileReaderImpl(yield o.read())) : new AsyncRecordBatchStreamReader(new AsyncRecordBatchStreamReaderImpl(o)) : new AsyncRecordBatchStreamReader(new AsyncRecordBatchStreamReaderImpl((function() {
      return __asyncGenerator(this, arguments, function* () {
      });
    })()));
  });
}
function fromFileHandle(o) {
  return __awaiter(this, void 0, void 0, function* () {
    const { size: E } = yield o.stat(), A = new AsyncRandomAccessFile(o, E);
    return E >= magicX2AndPadding && checkForMagicArrowString(yield A.readAt(0, magicLength + 7 & -8)) ? new AsyncRecordBatchFileReader(new AsyncRecordBatchFileReaderImpl(A)) : new AsyncRecordBatchStreamReader(new AsyncRecordBatchStreamReaderImpl(A));
  });
}
function tableFromIPC(o) {
  const E = RecordBatchReader.from(o);
  return isPromise(E) ? E.then((A) => tableFromIPC(A)) : E.isAsync() ? E.readAll().then((A) => new Table$1(A)) : new Table$1(E.readAll());
}
const PandasRangeIndexType = "range";
var DataFrameCellType = /* @__PURE__ */ ((o) => (o.INDEX = "index", o.DATA = "data", o))(DataFrameCellType || {});
function convertVectorToList(o) {
  const E = [];
  for (let A = 0; A < o.length; A++)
    E.push(o.get(A));
  return E;
}
function getPandasTypeName(o) {
  return isNullOrUndefined(o.pandasType) ? void 0 : (o.pandasType.pandas_type === "object" ? o.pandasType.numpy_type : o.pandasType.pandas_type).toLowerCase().trim();
}
function getTimezone(o) {
  return o.arrowField?.type?.timezone ?? o.pandasType?.metadata?.timezone;
}
function isIntegerType(o) {
  if (isNullOrUndefined(o))
    return !1;
  const E = getPandasTypeName(o) ?? "";
  return (
    // Period types are integers with an extra extension name
    DataType.isInt(o.arrowField.type) && !isPeriodType(o) || E.startsWith("int") && !isIntervalType(o) || isRangeIndexType(o) || isUnsignedIntegerType(o)
  );
}
function isUnsignedIntegerType(o) {
  return isNullOrUndefined(o) ? !1 : DataType.isInt(o.arrowField.type) && o.arrowField.type.isSigned === !1 || (getPandasTypeName(o)?.startsWith("uint") ?? !1);
}
function isFloatType(o) {
  return isNullOrUndefined(o) ? !1 : (DataType.isFloat(o.arrowField.type) || getPandasTypeName(o)?.startsWith("float")) ?? !1;
}
function isDecimalType(o) {
  return isNullOrUndefined(o) ? !1 : DataType.isDecimal(o.arrowField.type) || getPandasTypeName(o) === "decimal";
}
function isNumericType(o) {
  return isNullOrUndefined(o) ? !1 : isIntegerType(o) || isFloatType(o) || isDecimalType(o);
}
function isBooleanType(o) {
  return isNullOrUndefined(o) ? !1 : DataType.isBool(o.arrowField.type) || getPandasTypeName(o) === "bool";
}
function isDurationType(o) {
  return isNullOrUndefined(o) ? !1 : DataType.isDuration(o.arrowField.type) || (getPandasTypeName(o)?.startsWith("timedelta") ?? !1);
}
function isPeriodType(o) {
  return isNullOrUndefined(o) ? !1 : DataType.isInt(o.arrowField.type) && o.arrowField.metadata.get("ARROW:extension:name") === "period" || (getPandasTypeName(o)?.startsWith("period") ?? !1);
}
function isDatetimeType(o) {
  return isNullOrUndefined(o) ? !1 : DataType.isTimestamp(o.arrowField.type) || (getPandasTypeName(o)?.startsWith("datetime") ?? !1);
}
function isDateType(o) {
  return isNullOrUndefined(o) ? !1 : DataType.isDate(o.arrowField.type) || getPandasTypeName(o) === "date";
}
function isTimeType(o) {
  return isNullOrUndefined(o) ? !1 : DataType.isTime(o.arrowField.type) || getPandasTypeName(o) === "time";
}
function isCategoricalType(o) {
  return isNullOrUndefined(o) ? !1 : DataType.isDictionary(o.arrowField.type) || getPandasTypeName(o) === "categorical";
}
function isListType(o) {
  return isNullOrUndefined(o) ? !1 : DataType.isList(o.arrowField.type) || DataType.isFixedSizeList(o.arrowField.type) || (getPandasTypeName(o)?.startsWith("list") ?? !1);
}
function isObjectType(o) {
  return isNullOrUndefined(o) ? !1 : DataType.isStruct(o.arrowField.type) || DataType.isMap(o.arrowField.type) || getPandasTypeName(o) === "object";
}
function isBytesType(o) {
  return isNullOrUndefined(o) ? !1 : DataType.isBinary(o.arrowField.type) || DataType.isLargeBinary(o.arrowField.type) || getPandasTypeName(o) === "bytes";
}
function isStringType(o) {
  return isNullOrUndefined(o) ? !1 : DataType.isUtf8(o.arrowField.type) || DataType.isLargeUtf8(o.arrowField.type) || ["unicode", "large_string[pyarrow]"].includes(getPandasTypeName(o) ?? "");
}
function isEmptyType(o) {
  return isNullOrUndefined(o) ? !1 : DataType.isNull(o.arrowField.type) || getPandasTypeName(o) === "empty";
}
function isIntervalType(o) {
  return isNullOrUndefined(o) ? !1 : DataType.isStruct(o.arrowField.type) && o.arrowField.metadata.get("ARROW:extension:name") === "interval" || (getPandasTypeName(o)?.startsWith("interval") ?? !1);
}
function isRangeIndexType(o) {
  return isNullOrUndefined(o) ? !1 : getPandasTypeName(o) === PandasRangeIndexType;
}
function sameDataTypes(o, E) {
  return o.every((A, g) => A.pandasType?.pandas_type === E[g]?.pandasType?.pandas_type);
}
function sameIndexTypes(o, E) {
  return o.length !== E.length ? !1 : o.every((A, g) => g < E.length && getPandasTypeName(A) === getPandasTypeName(E[g]));
}
function concatIndexes(o, E, A, g) {
  if (A.length === 0)
    return o;
  if (o.length === 0)
    return A;
  if (!sameIndexTypes(E, g)) {
    const t = g.map((n) => getPandasTypeName(n)), c = E.map((n) => getPandasTypeName(n));
    throw new Error(`
Unsupported operation. The data passed into \`add_rows()\` must have the same
index signature as the original data.

In this case, \`add_rows()\` received \`${JSON.stringify(t)}\`
but was expecting \`${JSON.stringify(c)}\`.
`);
  }
  if (E.length === 0)
    throw new Error("There was an error while parsing index types.");
  if (isRangeIndexType(E[0])) {
    const {
      step: t,
      stop: c
    } = E[0].pandasType?.metadata;
    A = [range$1(
      c,
      // End is not inclusive
      c + A[0].length * t,
      t
    )];
  }
  return zip$1(o, A).map((t) => t[0].concat(t[1]));
}
function concatData(o, E, A, g) {
  if (A.numCols === 0)
    return o;
  if (o.numCols === 0)
    return A;
  if (!sameDataTypes(E, g)) {
    const t = g.map((n) => n.pandasType?.pandas_type), c = E.map((n) => n.pandasType?.pandas_type);
    throw new Error(`
Unsupported operation. The data passed into \`add_rows()\` must have the same
data signature as the original data.

In this case, \`add_rows()\` received \`${JSON.stringify(t)}\`
but was expecting \`${JSON.stringify(c)}\`.
`);
  }
  const e = A.selectAt(range$1(0, o.numCols));
  return o.concat(e);
}
function concatTypes(o, E, A, g) {
  const e = concatIndexTypes(o, A), t = concatDataTypes(E, g);
  return {
    indexTypes: e,
    dataTypes: t
  };
}
function concatIndexTypes(o, E) {
  if (E.length === 0)
    return o;
  if (o.length === 0)
    return E;
  if (!sameIndexTypes(o, E)) {
    const A = E.map((e) => getPandasTypeName(e)), g = o.map((e) => getPandasTypeName(e));
    throw new Error(`
Unsupported operation. The data passed into \`add_rows()\` must have the same
index signature as the original data.

In this case, \`add_rows()\` received \`${JSON.stringify(A)}\`
but was expecting \`${JSON.stringify(g)}\`.
`);
  }
  return o.map((A) => {
    if (isRangeIndexType(A) && A.pandasType) {
      const {
        stop: g,
        step: e
      } = A.pandasType.metadata, {
        start: t,
        stop: c,
        step: n
      } = E[0].pandasType?.metadata, h = (c - t) / n, d = g + h * e;
      return {
        ...A,
        pandasType: {
          ...A.pandasType,
          metadata: {
            ...A.pandasType.metadata,
            stop: d
          }
        }
      };
    }
    return A;
  });
}
function concatDataTypes(o, E) {
  return o.length === 0 ? E : o;
}
function concat(o, E, A, g, e, t, c, n) {
  const h = concatIndexes(A, E, c, t), d = concatData(g, o, n, e), {
    indexTypes: k,
    dataTypes: p
  } = concatTypes(E, o, t, e);
  return {
    index: h,
    data: d,
    indexTypes: k,
    dataTypes: p
  };
}
let wasm;
const heap = new Array(128).fill(void 0);
heap.push(void 0, null, !0, !1);
let heap_next = heap.length;
function addHeapObject(o) {
  heap_next === heap.length && heap.push(heap.length + 1);
  const E = heap_next;
  return heap_next = heap[E], heap[E] = o, E;
}
function getObject(o) {
  return heap[o];
}
function dropObject(o) {
  o < 132 || (heap[o] = heap_next, heap_next = o);
}
function takeObject(o) {
  const E = getObject(o);
  return dropObject(o), E;
}
const cachedTextDecoder = typeof TextDecoder < "u" ? new TextDecoder("utf-8", { ignoreBOM: !0, fatal: !0 }) : { decode: () => {
  throw Error("TextDecoder not available");
} };
typeof TextDecoder < "u" && cachedTextDecoder.decode();
let cachedUint8Memory0 = null;
function getUint8Memory0() {
  return (cachedUint8Memory0 === null || cachedUint8Memory0.byteLength === 0) && (cachedUint8Memory0 = new Uint8Array(wasm.memory.buffer)), cachedUint8Memory0;
}
function getStringFromWasm0(o, E) {
  return o = o >>> 0, cachedTextDecoder.decode(getUint8Memory0().subarray(o, o + E));
}
function isLikeNone(o) {
  return o == null;
}
let cachedFloat64Memory0 = null;
function getFloat64Memory0() {
  return (cachedFloat64Memory0 === null || cachedFloat64Memory0.byteLength === 0) && (cachedFloat64Memory0 = new Float64Array(wasm.memory.buffer)), cachedFloat64Memory0;
}
let cachedInt32Memory0 = null;
function getInt32Memory0() {
  return (cachedInt32Memory0 === null || cachedInt32Memory0.byteLength === 0) && (cachedInt32Memory0 = new Int32Array(wasm.memory.buffer)), cachedInt32Memory0;
}
let WASM_VECTOR_LEN = 0;
const cachedTextEncoder = typeof TextEncoder < "u" ? new TextEncoder("utf-8") : { encode: () => {
  throw Error("TextEncoder not available");
} }, encodeString = typeof cachedTextEncoder.encodeInto == "function" ? function(o, E) {
  return cachedTextEncoder.encodeInto(o, E);
} : function(o, E) {
  const A = cachedTextEncoder.encode(o);
  return E.set(A), {
    read: o.length,
    written: A.length
  };
};
function passStringToWasm0(o, E, A) {
  if (A === void 0) {
    const n = cachedTextEncoder.encode(o), h = E(n.length, 1) >>> 0;
    return getUint8Memory0().subarray(h, h + n.length).set(n), WASM_VECTOR_LEN = n.length, h;
  }
  let g = o.length, e = E(g, 1) >>> 0;
  const t = getUint8Memory0();
  let c = 0;
  for (; c < g; c++) {
    const n = o.charCodeAt(c);
    if (n > 127) break;
    t[e + c] = n;
  }
  if (c !== g) {
    c !== 0 && (o = o.slice(c)), e = A(e, g, g = c + o.length * 3, 1) >>> 0;
    const n = getUint8Memory0().subarray(e + c, e + g), h = encodeString(o, n);
    c += h.written, e = A(e, g, c, 1) >>> 0;
  }
  return WASM_VECTOR_LEN = c, e;
}
let cachedBigInt64Memory0 = null;
function getBigInt64Memory0() {
  return (cachedBigInt64Memory0 === null || cachedBigInt64Memory0.byteLength === 0) && (cachedBigInt64Memory0 = new BigInt64Array(wasm.memory.buffer)), cachedBigInt64Memory0;
}
function debugString(o) {
  const E = typeof o;
  if (E == "number" || E == "boolean" || o == null)
    return `${o}`;
  if (E == "string")
    return `"${o}"`;
  if (E == "symbol") {
    const e = o.description;
    return e == null ? "Symbol" : `Symbol(${e})`;
  }
  if (E == "function") {
    const e = o.name;
    return typeof e == "string" && e.length > 0 ? `Function(${e})` : "Function";
  }
  if (Array.isArray(o)) {
    const e = o.length;
    let t = "[";
    e > 0 && (t += debugString(o[0]));
    for (let c = 1; c < e; c++)
      t += ", " + debugString(o[c]);
    return t += "]", t;
  }
  const A = /\[object ([^\]]+)\]/.exec(toString.call(o));
  let g;
  if (A.length > 1)
    g = A[1];
  else
    return toString.call(o);
  if (g == "Object")
    try {
      return "Object(" + JSON.stringify(o) + ")";
    } catch {
      return "Object";
    }
  return o instanceof Error ? `${o.name}: ${o.message}
${o.stack}` : g;
}
const CLOSURE_DTORS = typeof FinalizationRegistry > "u" ? { register: () => {
}, unregister: () => {
} } : new FinalizationRegistry((o) => {
  wasm.__wbindgen_export_2.get(o.dtor)(o.a, o.b);
});
function makeMutClosure(o, E, A, g) {
  const e = { a: o, b: E, cnt: 1, dtor: A }, t = (...c) => {
    e.cnt++;
    const n = e.a;
    e.a = 0;
    try {
      return g(n, e.b, ...c);
    } finally {
      --e.cnt === 0 ? (wasm.__wbindgen_export_2.get(e.dtor)(n, e.b), CLOSURE_DTORS.unregister(e)) : e.a = n;
    }
  };
  return t.original = e, CLOSURE_DTORS.register(t, e, e), t;
}
function __wbg_adapter_50(o, E, A) {
  wasm._dyn_core__ops__function__FnMut__A____Output___R_as_wasm_bindgen__closure__WasmClosure___describe__invoke__h1de40baa0df51db0(o, E, addHeapObject(A));
}
function passArray8ToWasm0(o, E) {
  const A = E(o.length * 1, 1) >>> 0;
  return getUint8Memory0().set(o, A / 1), WASM_VECTOR_LEN = o.length, A;
}
function readParquet(o, E) {
  try {
    const t = wasm.__wbindgen_add_to_stack_pointer(-16), c = passArray8ToWasm0(o, wasm.__wbindgen_malloc), n = WASM_VECTOR_LEN;
    wasm.readParquet(t, c, n, isLikeNone(E) ? 0 : addHeapObject(E));
    var A = getInt32Memory0()[t / 4 + 0], g = getInt32Memory0()[t / 4 + 1], e = getInt32Memory0()[t / 4 + 2];
    if (e)
      throw takeObject(g);
    return Table.__wrap(A);
  } finally {
    wasm.__wbindgen_add_to_stack_pointer(16);
  }
}
function _assertClass(o, E) {
  if (!(o instanceof E))
    throw new Error(`expected instance of ${E.name}`);
  return o.ptr;
}
function getArrayU8FromWasm0(o, E) {
  return o = o >>> 0, getUint8Memory0().subarray(o / 1, o / 1 + E);
}
let cachedUint32Memory0 = null;
function getUint32Memory0() {
  return (cachedUint32Memory0 === null || cachedUint32Memory0.byteLength === 0) && (cachedUint32Memory0 = new Uint32Array(wasm.memory.buffer)), cachedUint32Memory0;
}
function getArrayJsValueFromWasm0(o, E) {
  o = o >>> 0;
  const g = getUint32Memory0().subarray(o / 4, o / 4 + E), e = [];
  for (let t = 0; t < g.length; t++)
    e.push(takeObject(g[t]));
  return e;
}
function handleError(o, E) {
  try {
    return o.apply(this, E);
  } catch (A) {
    wasm.__wbindgen_exn_store(addHeapObject(A));
  }
}
function getArrayU32FromWasm0(o, E) {
  return o = o >>> 0, getUint32Memory0().subarray(o / 4, o / 4 + E);
}
function __wbg_adapter_285(o, E, A, g) {
  wasm.wasm_bindgen__convert__closures__invoke2_mut__h26b6dc7d05b06fdf(o, E, addHeapObject(A), addHeapObject(g));
}
const ColumnChunkMetaDataFinalization = typeof FinalizationRegistry > "u" ? { register: () => {
}, unregister: () => {
} } : new FinalizationRegistry((o) => wasm.__wbg_columnchunkmetadata_free(o >>> 0));
class ColumnChunkMetaData {
  static __wrap(E) {
    E = E >>> 0;
    const A = Object.create(ColumnChunkMetaData.prototype);
    return A.__wbg_ptr = E, ColumnChunkMetaDataFinalization.register(A, A.__wbg_ptr, A), A;
  }
  __destroy_into_raw() {
    const E = this.__wbg_ptr;
    return this.__wbg_ptr = 0, ColumnChunkMetaDataFinalization.unregister(this), E;
  }
  free() {
    const E = this.__destroy_into_raw();
    wasm.__wbg_columnchunkmetadata_free(E);
  }
  /**
  * File where the column chunk is stored.
  *
  * If not set, assumed to belong to the same file as the metadata.
  * This path is relative to the current file.
  * @returns {string | undefined}
  */
  filePath() {
    try {
      const g = wasm.__wbindgen_add_to_stack_pointer(-16);
      wasm.columnchunkmetadata_filePath(g, this.__wbg_ptr);
      var E = getInt32Memory0()[g / 4 + 0], A = getInt32Memory0()[g / 4 + 1];
      let e;
      return E !== 0 && (e = getStringFromWasm0(E, A).slice(), wasm.__wbindgen_free(E, A * 1, 1)), e;
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
  /**
  * Byte offset in `file_path()`.
  * @returns {bigint}
  */
  fileOffset() {
    return wasm.columnchunkmetadata_fileOffset(this.__wbg_ptr);
  }
  /**
  * Path (or identifier) of this column.
  * @returns {(string)[]}
  */
  columnPath() {
    try {
      const e = wasm.__wbindgen_add_to_stack_pointer(-16);
      wasm.columnchunkmetadata_columnPath(e, this.__wbg_ptr);
      var E = getInt32Memory0()[e / 4 + 0], A = getInt32Memory0()[e / 4 + 1], g = getArrayJsValueFromWasm0(E, A).slice();
      return wasm.__wbindgen_free(E, A * 4, 4), g;
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
  /**
  * All encodings used for this column.
  * @returns {any[]}
  */
  encodings() {
    try {
      const e = wasm.__wbindgen_add_to_stack_pointer(-16);
      wasm.columnchunkmetadata_encodings(e, this.__wbg_ptr);
      var E = getInt32Memory0()[e / 4 + 0], A = getInt32Memory0()[e / 4 + 1], g = getArrayJsValueFromWasm0(E, A).slice();
      return wasm.__wbindgen_free(E, A * 4, 4), g;
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
  /**
  * Total number of values in this column chunk.
  * @returns {number}
  */
  numValues() {
    return wasm.columnchunkmetadata_numValues(this.__wbg_ptr);
  }
  /**
  * Compression for this column.
  * @returns {Compression}
  */
  compression() {
    return wasm.columnchunkmetadata_compression(this.__wbg_ptr);
  }
  /**
  * Returns the total compressed data size of this column chunk.
  * @returns {number}
  */
  compressedSize() {
    return wasm.columnchunkmetadata_compressedSize(this.__wbg_ptr);
  }
  /**
  * Returns the total uncompressed data size of this column chunk.
  * @returns {number}
  */
  uncompressedSize() {
    return wasm.columnchunkmetadata_uncompressedSize(this.__wbg_ptr);
  }
}
typeof FinalizationRegistry > "u" || new FinalizationRegistry((o) => wasm.__wbg_ffiarrowarray_free(o >>> 0));
const FFIArrowSchemaFinalization = typeof FinalizationRegistry > "u" ? { register: () => {
}, unregister: () => {
} } : new FinalizationRegistry((o) => wasm.__wbg_ffiarrowschema_free(o >>> 0));
class FFIArrowSchema {
  static __wrap(E) {
    E = E >>> 0;
    const A = Object.create(FFIArrowSchema.prototype);
    return A.__wbg_ptr = E, FFIArrowSchemaFinalization.register(A, A.__wbg_ptr, A), A;
  }
  __destroy_into_raw() {
    const E = this.__wbg_ptr;
    return this.__wbg_ptr = 0, FFIArrowSchemaFinalization.unregister(this), E;
  }
  free() {
    const E = this.__destroy_into_raw();
    wasm.__wbg_ffiarrowschema_free(E);
  }
  /**
  * Access the pointer to the
  * [`ArrowSchema`](https://arrow.apache.org/docs/format/CDataInterface.html#structure-definitions)
  * struct. This can be viewed or copied (without serialization) to an Arrow JS `Field` by
  * using [`arrow-js-ffi`](https://github.com/kylebarron/arrow-js-ffi). You can access the
  * [`WebAssembly.Memory`](https://developer.mozilla.org/en-US/docs/WebAssembly/JavaScript_interface/Memory)
  * instance by using {@linkcode wasmMemory}.
  *
  * **Example**:
  *
  * ```ts
  * import { parseRecordBatch } from "arrow-js-ffi";
  *
  * const wasmRecordBatch: FFIRecordBatch = ...
  * const wasmMemory: WebAssembly.Memory = wasmMemory();
  *
  * // Pass `true` to copy arrays across the boundary instead of creating views.
  * const jsRecordBatch = parseRecordBatch(
  *   wasmMemory.buffer,
  *   wasmRecordBatch.arrayAddr(),
  *   wasmRecordBatch.schemaAddr(),
  *   true
  * );
  * ```
  * @returns {number}
  */
  addr() {
    return wasm.ffiarrowschema_addr(this.__wbg_ptr) >>> 0;
  }
}
typeof FinalizationRegistry > "u" || new FinalizationRegistry((o) => wasm.__wbg_ffidata_free(o >>> 0));
const FFIRecordBatchFinalization = typeof FinalizationRegistry > "u" ? { register: () => {
}, unregister: () => {
} } : new FinalizationRegistry((o) => wasm.__wbg_ffirecordbatch_free(o >>> 0));
class FFIRecordBatch {
  static __wrap(E) {
    E = E >>> 0;
    const A = Object.create(FFIRecordBatch.prototype);
    return A.__wbg_ptr = E, FFIRecordBatchFinalization.register(A, A.__wbg_ptr, A), A;
  }
  __destroy_into_raw() {
    const E = this.__wbg_ptr;
    return this.__wbg_ptr = 0, FFIRecordBatchFinalization.unregister(this), E;
  }
  free() {
    const E = this.__destroy_into_raw();
    wasm.__wbg_ffirecordbatch_free(E);
  }
  /**
  * Access the pointer to the
  * [`ArrowArray`](https://arrow.apache.org/docs/format/CDataInterface.html#structure-definitions)
  * struct. This can be viewed or copied (without serialization) to an Arrow JS `RecordBatch` by
  * using [`arrow-js-ffi`](https://github.com/kylebarron/arrow-js-ffi). You can access the
  * [`WebAssembly.Memory`](https://developer.mozilla.org/en-US/docs/WebAssembly/JavaScript_interface/Memory)
  * instance by using {@linkcode wasmMemory}.
  *
  * **Example**:
  *
  * ```ts
  * import { parseRecordBatch } from "arrow-js-ffi";
  *
  * const wasmRecordBatch: FFIRecordBatch = ...
  * const wasmMemory: WebAssembly.Memory = wasmMemory();
  *
  * // Pass `true` to copy arrays across the boundary instead of creating views.
  * const jsRecordBatch = parseRecordBatch(
  *   wasmMemory.buffer,
  *   wasmRecordBatch.arrayAddr(),
  *   wasmRecordBatch.schemaAddr(),
  *   true
  * );
  * ```
  * @returns {number}
  */
  arrayAddr() {
    return wasm.ffirecordbatch_arrayAddr(this.__wbg_ptr) >>> 0;
  }
  /**
  * Access the pointer to the
  * [`ArrowSchema`](https://arrow.apache.org/docs/format/CDataInterface.html#structure-definitions)
  * struct. This can be viewed or copied (without serialization) to an Arrow JS `Field` by
  * using [`arrow-js-ffi`](https://github.com/kylebarron/arrow-js-ffi). You can access the
  * [`WebAssembly.Memory`](https://developer.mozilla.org/en-US/docs/WebAssembly/JavaScript_interface/Memory)
  * instance by using {@linkcode wasmMemory}.
  *
  * **Example**:
  *
  * ```ts
  * import { parseRecordBatch } from "arrow-js-ffi";
  *
  * const wasmRecordBatch: FFIRecordBatch = ...
  * const wasmMemory: WebAssembly.Memory = wasmMemory();
  *
  * // Pass `true` to copy arrays across the boundary instead of creating views.
  * const jsRecordBatch = parseRecordBatch(
  *   wasmMemory.buffer,
  *   wasmRecordBatch.arrayAddr(),
  *   wasmRecordBatch.schemaAddr(),
  *   true
  * );
  * ```
  * @returns {number}
  */
  schemaAddr() {
    return wasm.ffirecordbatch_schemaAddr(this.__wbg_ptr) >>> 0;
  }
}
const FFITableFinalization = typeof FinalizationRegistry > "u" ? { register: () => {
}, unregister: () => {
} } : new FinalizationRegistry((o) => wasm.__wbg_ffitable_free(o >>> 0));
class FFITable {
  static __wrap(E) {
    E = E >>> 0;
    const A = Object.create(FFITable.prototype);
    return A.__wbg_ptr = E, FFITableFinalization.register(A, A.__wbg_ptr, A), A;
  }
  __destroy_into_raw() {
    const E = this.__wbg_ptr;
    return this.__wbg_ptr = 0, FFITableFinalization.unregister(this), E;
  }
  free() {
    const E = this.__destroy_into_raw();
    wasm.__wbg_ffitable_free(E);
  }
  /**
  * Get the total number of record batches in the table
  * @returns {number}
  */
  numBatches() {
    return wasm.ffitable_numBatches(this.__wbg_ptr) >>> 0;
  }
  /**
  * Get the pointer to one ArrowSchema FFI struct
  * @returns {number}
  */
  schemaAddr() {
    return wasm.ffitable_schemaAddr(this.__wbg_ptr) >>> 0;
  }
  /**
  * Get the pointer to one ArrowArray FFI struct for a given chunk index and column index
  *
  * Access the pointer to one
  * [`ArrowArray`](https://arrow.apache.org/docs/format/CDataInterface.html#structure-definitions)
  * struct representing one of the internal `RecordBatch`es. This can be viewed or copied (without serialization) to an Arrow JS `RecordBatch` by
  * using [`arrow-js-ffi`](https://github.com/kylebarron/arrow-js-ffi). You can access the
  * [`WebAssembly.Memory`](https://developer.mozilla.org/en-US/docs/WebAssembly/JavaScript_interface/Memory)
  * instance by using {@linkcode wasmMemory}.
  *
  * **Example**:
  *
  * ```ts
  * import * as arrow from "apache-arrow";
  * import { parseRecordBatch } from "arrow-js-ffi";
  *
  * const wasmTable: FFITable = ...
  * const wasmMemory: WebAssembly.Memory = wasmMemory();
  *
  * const jsBatches: arrow.RecordBatch[] = []
  * for (let i = 0; i < wasmTable.numBatches(); i++) {
  *   // Pass `true` to copy arrays across the boundary instead of creating views.
  *   const jsRecordBatch = parseRecordBatch(
  *     wasmMemory.buffer,
  *     wasmTable.arrayAddr(i),
  *     wasmTable.schemaAddr(),
  *     true
  *   );
  *   jsBatches.push(jsRecordBatch);
  * }
  * const jsTable = new arrow.Table(jsBatches);
  * ```
  *
  * @param chunk number The chunk index to use
  * @returns number pointer to an ArrowArray FFI struct in Wasm memory
  * @param {number} chunk
  * @returns {number}
  */
  arrayAddr(E) {
    return wasm.ffitable_arrayAddr(this.__wbg_ptr, E) >>> 0;
  }
  /**
  * @returns {Uint32Array}
  */
  arrayAddrs() {
    try {
      const e = wasm.__wbindgen_add_to_stack_pointer(-16);
      wasm.ffitable_arrayAddrs(e, this.__wbg_ptr);
      var E = getInt32Memory0()[e / 4 + 0], A = getInt32Memory0()[e / 4 + 1], g = getArrayU32FromWasm0(E, A).slice();
      return wasm.__wbindgen_free(E, A * 4, 4), g;
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
  /**
  */
  drop() {
    const E = this.__destroy_into_raw();
    wasm.ffitable_drop(E);
  }
}
typeof FinalizationRegistry > "u" || new FinalizationRegistry((o) => wasm.__wbg_ffivector_free(o >>> 0));
const FileMetaDataFinalization = typeof FinalizationRegistry > "u" ? { register: () => {
}, unregister: () => {
} } : new FinalizationRegistry((o) => wasm.__wbg_filemetadata_free(o >>> 0));
class FileMetaData {
  static __wrap(E) {
    E = E >>> 0;
    const A = Object.create(FileMetaData.prototype);
    return A.__wbg_ptr = E, FileMetaDataFinalization.register(A, A.__wbg_ptr, A), A;
  }
  __destroy_into_raw() {
    const E = this.__wbg_ptr;
    return this.__wbg_ptr = 0, FileMetaDataFinalization.unregister(this), E;
  }
  free() {
    const E = this.__destroy_into_raw();
    wasm.__wbg_filemetadata_free(E);
  }
  /**
  * Returns version of this file.
  * @returns {number}
  */
  version() {
    return wasm.filemetadata_version(this.__wbg_ptr);
  }
  /**
  * Returns number of rows in the file.
  * @returns {number}
  */
  numRows() {
    return wasm.filemetadata_numRows(this.__wbg_ptr);
  }
  /**
  * String message for application that wrote this file.
  *
  * This should have the following format:
  * `<application> version <application version> (build <application build hash>)`.
  *
  * ```shell
  * parquet-mr version 1.8.0 (build 0fda28af84b9746396014ad6a415b90592a98b3b)
  * ```
  * @returns {string | undefined}
  */
  createdBy() {
    try {
      const g = wasm.__wbindgen_add_to_stack_pointer(-16);
      wasm.filemetadata_createdBy(g, this.__wbg_ptr);
      var E = getInt32Memory0()[g / 4 + 0], A = getInt32Memory0()[g / 4 + 1];
      let e;
      return E !== 0 && (e = getStringFromWasm0(E, A).slice(), wasm.__wbindgen_free(E, A * 1, 1)), e;
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
  /**
  * Returns key_value_metadata of this file.
  * @returns {Map<any, any>}
  */
  keyValueMetadata() {
    try {
      const e = wasm.__wbindgen_add_to_stack_pointer(-16);
      wasm.filemetadata_keyValueMetadata(e, this.__wbg_ptr);
      var E = getInt32Memory0()[e / 4 + 0], A = getInt32Memory0()[e / 4 + 1], g = getInt32Memory0()[e / 4 + 2];
      if (g)
        throw takeObject(A);
      return takeObject(E);
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
}
typeof FinalizationRegistry > "u" || new FinalizationRegistry((o) => wasm.__wbg_intounderlyingbytesource_free(o >>> 0));
typeof FinalizationRegistry > "u" || new FinalizationRegistry((o) => wasm.__wbg_intounderlyingsink_free(o >>> 0));
const IntoUnderlyingSourceFinalization = typeof FinalizationRegistry > "u" ? { register: () => {
}, unregister: () => {
} } : new FinalizationRegistry((o) => wasm.__wbg_intounderlyingsource_free(o >>> 0));
class IntoUnderlyingSource {
  static __wrap(E) {
    E = E >>> 0;
    const A = Object.create(IntoUnderlyingSource.prototype);
    return A.__wbg_ptr = E, IntoUnderlyingSourceFinalization.register(A, A.__wbg_ptr, A), A;
  }
  __destroy_into_raw() {
    const E = this.__wbg_ptr;
    return this.__wbg_ptr = 0, IntoUnderlyingSourceFinalization.unregister(this), E;
  }
  free() {
    const E = this.__destroy_into_raw();
    wasm.__wbg_intounderlyingsource_free(E);
  }
  /**
  * @param {ReadableStreamDefaultController} controller
  * @returns {Promise<any>}
  */
  pull(E) {
    const A = wasm.intounderlyingsource_pull(this.__wbg_ptr, addHeapObject(E));
    return takeObject(A);
  }
  /**
  */
  cancel() {
    const E = this.__destroy_into_raw();
    wasm.intounderlyingsource_cancel(E);
  }
}
const ParquetFileFinalization = typeof FinalizationRegistry > "u" ? { register: () => {
}, unregister: () => {
} } : new FinalizationRegistry((o) => wasm.__wbg_parquetfile_free(o >>> 0));
class ParquetFile {
  static __wrap(E) {
    E = E >>> 0;
    const A = Object.create(ParquetFile.prototype);
    return A.__wbg_ptr = E, ParquetFileFinalization.register(A, A.__wbg_ptr, A), A;
  }
  __destroy_into_raw() {
    const E = this.__wbg_ptr;
    return this.__wbg_ptr = 0, ParquetFileFinalization.unregister(this), E;
  }
  free() {
    const E = this.__destroy_into_raw();
    wasm.__wbg_parquetfile_free(E);
  }
  /**
  * Construct a ParquetFile from a new URL.
  *
  * @param options The options to pass into `object-store`'s [`parse_url_opts`][parse_url_opts]
  *
  * [parse_url_opts]: https://docs.rs/object_store/latest/object_store/fn.parse_url_opts.html
  * @param {string} url
  * @param {Map<any, any> | undefined} [options]
  * @returns {Promise<ParquetFile>}
  */
  static fromUrl(E, A) {
    const g = passStringToWasm0(E, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc), e = WASM_VECTOR_LEN, t = wasm.parquetfile_fromUrl(g, e, isLikeNone(A) ? 0 : addHeapObject(A));
    return takeObject(t);
  }
  /**
  * Construct a ParquetFile from a new [Blob] or [File] handle.
  *
  * [Blob]: https://developer.mozilla.org/en-US/docs/Web/API/Blob
  * [File]: https://developer.mozilla.org/en-US/docs/Web/API/File
  *
  * Safety: Do not use this in a multi-threaded environment,
  * (transitively depends on `!Send` `web_sys::Blob`)
  * @param {Blob} handle
  * @returns {Promise<ParquetFile>}
  */
  static fromFile(E) {
    const A = wasm.parquetfile_fromFile(addHeapObject(E));
    return takeObject(A);
  }
  /**
  * @returns {ParquetMetaData}
  */
  metadata() {
    try {
      const e = wasm.__wbindgen_add_to_stack_pointer(-16);
      wasm.parquetfile_metadata(e, this.__wbg_ptr);
      var E = getInt32Memory0()[e / 4 + 0], A = getInt32Memory0()[e / 4 + 1], g = getInt32Memory0()[e / 4 + 2];
      if (g)
        throw takeObject(A);
      return ParquetMetaData.__wrap(E);
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
  /**
  * Read from the Parquet file in an async fashion.
  *
  * @param options
  *
  *    Options for reading Parquet data. Optional keys include:
  *
  *    - `batchSize`: The number of rows in each batch. If not provided, the upstream parquet
  *           default is 1024.
  *    - `rowGroups`: Only read data from the provided row group indexes.
  *    - `limit`: Provide a limit to the number of rows to be read.
  *    - `offset`: Provide an offset to skip over the given number of rows.
  *    - `columns`: The column names from the file to read.
  * @param {ReaderOptions | undefined} [options]
  * @returns {Promise<Table>}
  */
  read(E) {
    const A = wasm.parquetfile_read(this.__wbg_ptr, isLikeNone(E) ? 0 : addHeapObject(E));
    return takeObject(A);
  }
  /**
  * Create a readable stream of record batches.
  *
  * Each item in the stream will be a {@linkcode RecordBatch}.
  *
  * @param options
  *
  *    Options for reading Parquet data. Optional keys include:
  *
  *    - `batchSize`: The number of rows in each batch. If not provided, the upstream parquet
  *           default is 1024.
  *    - `rowGroups`: Only read data from the provided row group indexes.
  *    - `limit`: Provide a limit to the number of rows to be read.
  *    - `offset`: Provide an offset to skip over the given number of rows.
  *    - `columns`: The column names from the file to read.
  *    - `concurrency`: The number of concurrent requests to make
  * @param {ReaderOptions | undefined} [options]
  * @returns {Promise<ReadableStream>}
  */
  stream(E) {
    const A = wasm.parquetfile_stream(this.__wbg_ptr, isLikeNone(E) ? 0 : addHeapObject(E));
    return takeObject(A);
  }
}
const ParquetMetaDataFinalization = typeof FinalizationRegistry > "u" ? { register: () => {
}, unregister: () => {
} } : new FinalizationRegistry((o) => wasm.__wbg_parquetmetadata_free(o >>> 0));
class ParquetMetaData {
  static __wrap(E) {
    E = E >>> 0;
    const A = Object.create(ParquetMetaData.prototype);
    return A.__wbg_ptr = E, ParquetMetaDataFinalization.register(A, A.__wbg_ptr, A), A;
  }
  __destroy_into_raw() {
    const E = this.__wbg_ptr;
    return this.__wbg_ptr = 0, ParquetMetaDataFinalization.unregister(this), E;
  }
  free() {
    const E = this.__destroy_into_raw();
    wasm.__wbg_parquetmetadata_free(E);
  }
  /**
  * Returns file metadata as reference.
  * @returns {FileMetaData}
  */
  fileMetadata() {
    const E = wasm.parquetmetadata_fileMetadata(this.__wbg_ptr);
    return FileMetaData.__wrap(E);
  }
  /**
  * Returns number of row groups in this file.
  * @returns {number}
  */
  numRowGroups() {
    return wasm.parquetmetadata_numRowGroups(this.__wbg_ptr) >>> 0;
  }
  /**
  * Returns row group metadata for `i`th position.
  * Position should be less than number of row groups `num_row_groups`.
  * @param {number} i
  * @returns {RowGroupMetaData}
  */
  rowGroup(E) {
    const A = wasm.parquetmetadata_rowGroup(this.__wbg_ptr, E);
    return RowGroupMetaData.__wrap(A);
  }
  /**
  * Returns row group metadata for all row groups
  * @returns {(RowGroupMetaData)[]}
  */
  rowGroups() {
    try {
      const e = wasm.__wbindgen_add_to_stack_pointer(-16);
      wasm.parquetmetadata_rowGroups(e, this.__wbg_ptr);
      var E = getInt32Memory0()[e / 4 + 0], A = getInt32Memory0()[e / 4 + 1], g = getArrayJsValueFromWasm0(E, A).slice();
      return wasm.__wbindgen_free(E, A * 4, 4), g;
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
}
const RecordBatchFinalization = typeof FinalizationRegistry > "u" ? { register: () => {
}, unregister: () => {
} } : new FinalizationRegistry((o) => wasm.__wbg_recordbatch_free(o >>> 0));
class RecordBatch {
  static __wrap(E) {
    E = E >>> 0;
    const A = Object.create(RecordBatch.prototype);
    return A.__wbg_ptr = E, RecordBatchFinalization.register(A, A.__wbg_ptr, A), A;
  }
  __destroy_into_raw() {
    const E = this.__wbg_ptr;
    return this.__wbg_ptr = 0, RecordBatchFinalization.unregister(this), E;
  }
  free() {
    const E = this.__destroy_into_raw();
    wasm.__wbg_recordbatch_free(E);
  }
  /**
  * The number of rows in this RecordBatch.
  * @returns {number}
  */
  get numRows() {
    return wasm.recordbatch_numRows(this.__wbg_ptr) >>> 0;
  }
  /**
  * The number of columns in this RecordBatch.
  * @returns {number}
  */
  get numColumns() {
    return wasm.recordbatch_numColumns(this.__wbg_ptr) >>> 0;
  }
  /**
  * The {@linkcode Schema} of this RecordBatch.
  * @returns {Schema}
  */
  get schema() {
    const E = wasm.recordbatch_schema(this.__wbg_ptr);
    return Schema$1.__wrap(E);
  }
  /**
  * Export this RecordBatch to FFI structs according to the Arrow C Data Interface.
  *
  * This method **does not consume** the RecordBatch, so you must remember to call {@linkcode
  * RecordBatch.free} to release the resources. The underlying arrays are reference counted, so
  * this method does not copy data, it only prevents the data from being released.
  * @returns {FFIRecordBatch}
  */
  toFFI() {
    try {
      const e = wasm.__wbindgen_add_to_stack_pointer(-16);
      wasm.recordbatch_toFFI(e, this.__wbg_ptr);
      var E = getInt32Memory0()[e / 4 + 0], A = getInt32Memory0()[e / 4 + 1], g = getInt32Memory0()[e / 4 + 2];
      if (g)
        throw takeObject(A);
      return FFIRecordBatch.__wrap(E);
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
  /**
  * Export this RecordBatch to FFI structs according to the Arrow C Data Interface.
  *
  * This method **does consume** the RecordBatch, so the original RecordBatch will be
  * inaccessible after this call. You must still call {@linkcode FFIRecordBatch.free} after
  * you've finished using the FFIRecordBatch.
  * @returns {FFIRecordBatch}
  */
  intoFFI() {
    try {
      const e = this.__destroy_into_raw(), t = wasm.__wbindgen_add_to_stack_pointer(-16);
      wasm.recordbatch_intoFFI(t, e);
      var E = getInt32Memory0()[t / 4 + 0], A = getInt32Memory0()[t / 4 + 1], g = getInt32Memory0()[t / 4 + 2];
      if (g)
        throw takeObject(A);
      return FFIRecordBatch.__wrap(E);
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
  /**
  * Consume this RecordBatch and convert to an Arrow IPC Stream buffer
  * @returns {Uint8Array}
  */
  intoIPCStream() {
    try {
      const c = this.__destroy_into_raw(), n = wasm.__wbindgen_add_to_stack_pointer(-16);
      wasm.recordbatch_intoIPCStream(n, c);
      var E = getInt32Memory0()[n / 4 + 0], A = getInt32Memory0()[n / 4 + 1], g = getInt32Memory0()[n / 4 + 2], e = getInt32Memory0()[n / 4 + 3];
      if (e)
        throw takeObject(g);
      var t = getArrayU8FromWasm0(E, A).slice();
      return wasm.__wbindgen_free(E, A * 1, 1), t;
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
  /**
  * Override the schema of this [`RecordBatch`]
  *
  * Returns an error if `schema` is not a superset of the current schema
  * as determined by [`Schema::contains`]
  * @param {Schema} schema
  * @returns {RecordBatch}
  */
  withSchema(E) {
    try {
      const c = wasm.__wbindgen_add_to_stack_pointer(-16);
      _assertClass(E, Schema$1);
      var A = E.__destroy_into_raw();
      wasm.recordbatch_withSchema(c, this.__wbg_ptr, A);
      var g = getInt32Memory0()[c / 4 + 0], e = getInt32Memory0()[c / 4 + 1], t = getInt32Memory0()[c / 4 + 2];
      if (t)
        throw takeObject(e);
      return RecordBatch.__wrap(g);
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
  /**
  * Return a new RecordBatch where each column is sliced
  * according to `offset` and `length`
  * @param {number} offset
  * @param {number} length
  * @returns {RecordBatch}
  */
  slice(E, A) {
    const g = wasm.recordbatch_slice(this.__wbg_ptr, E, A);
    return RecordBatch.__wrap(g);
  }
  /**
  * Returns the total number of bytes of memory occupied physically by this batch.
  * @returns {number}
  */
  getArrayMemorySize() {
    return wasm.recordbatch_getArrayMemorySize(this.__wbg_ptr) >>> 0;
  }
}
const RowGroupMetaDataFinalization = typeof FinalizationRegistry > "u" ? { register: () => {
}, unregister: () => {
} } : new FinalizationRegistry((o) => wasm.__wbg_rowgroupmetadata_free(o >>> 0));
class RowGroupMetaData {
  static __wrap(E) {
    E = E >>> 0;
    const A = Object.create(RowGroupMetaData.prototype);
    return A.__wbg_ptr = E, RowGroupMetaDataFinalization.register(A, A.__wbg_ptr, A), A;
  }
  __destroy_into_raw() {
    const E = this.__wbg_ptr;
    return this.__wbg_ptr = 0, RowGroupMetaDataFinalization.unregister(this), E;
  }
  free() {
    const E = this.__destroy_into_raw();
    wasm.__wbg_rowgroupmetadata_free(E);
  }
  /**
  * Number of columns in this row group.
  * @returns {number}
  */
  numColumns() {
    return wasm.rowgroupmetadata_numColumns(this.__wbg_ptr) >>> 0;
  }
  /**
  * Returns column chunk metadata for `i`th column.
  * @param {number} i
  * @returns {ColumnChunkMetaData}
  */
  column(E) {
    const A = wasm.rowgroupmetadata_column(this.__wbg_ptr, E);
    return ColumnChunkMetaData.__wrap(A);
  }
  /**
  * Returns column chunk metadata for all columns
  * @returns {(ColumnChunkMetaData)[]}
  */
  columns() {
    try {
      const e = wasm.__wbindgen_add_to_stack_pointer(-16);
      wasm.rowgroupmetadata_columns(e, this.__wbg_ptr);
      var E = getInt32Memory0()[e / 4 + 0], A = getInt32Memory0()[e / 4 + 1], g = getArrayJsValueFromWasm0(E, A).slice();
      return wasm.__wbindgen_free(E, A * 4, 4), g;
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
  /**
  * Number of rows in this row group.
  * @returns {number}
  */
  numRows() {
    return wasm.rowgroupmetadata_numRows(this.__wbg_ptr);
  }
  /**
  * Total byte size of all uncompressed column data in this row group.
  * @returns {number}
  */
  totalByteSize() {
    return wasm.rowgroupmetadata_totalByteSize(this.__wbg_ptr);
  }
  /**
  * Total size of all compressed column data in this row group.
  * @returns {number}
  */
  compressedSize() {
    return wasm.rowgroupmetadata_compressedSize(this.__wbg_ptr);
  }
}
const SchemaFinalization = typeof FinalizationRegistry > "u" ? { register: () => {
}, unregister: () => {
} } : new FinalizationRegistry((o) => wasm.__wbg_schema_free(o >>> 0));
let Schema$1 = class eI {
  static __wrap(E) {
    E = E >>> 0;
    const A = Object.create(eI.prototype);
    return A.__wbg_ptr = E, SchemaFinalization.register(A, A.__wbg_ptr, A), A;
  }
  __destroy_into_raw() {
    const E = this.__wbg_ptr;
    return this.__wbg_ptr = 0, SchemaFinalization.unregister(this), E;
  }
  free() {
    const E = this.__destroy_into_raw();
    wasm.__wbg_schema_free(E);
  }
  /**
  * Export this schema to an FFIArrowSchema object, which can be read with arrow-js-ffi.
  *
  * This method **does not consume** the Schema, so you must remember to call {@linkcode
  * Schema.free} to release the resources. The underlying arrays are reference counted, so
  * this method does not copy data, it only prevents the data from being released.
  * @returns {FFIArrowSchema}
  */
  toFFI() {
    try {
      const e = wasm.__wbindgen_add_to_stack_pointer(-16);
      wasm.schema_toFFI(e, this.__wbg_ptr);
      var E = getInt32Memory0()[e / 4 + 0], A = getInt32Memory0()[e / 4 + 1], g = getInt32Memory0()[e / 4 + 2];
      if (g)
        throw takeObject(A);
      return FFIArrowSchema.__wrap(E);
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
  /**
  * Export this Table to FFI structs according to the Arrow C Data Interface.
  *
  * This method **does consume** the Table, so the original Table will be
  * inaccessible after this call. You must still call {@linkcode FFITable.free} after
  * you've finished using the FFITable.
  * @returns {FFIArrowSchema}
  */
  intoFFI() {
    try {
      const e = this.__destroy_into_raw(), t = wasm.__wbindgen_add_to_stack_pointer(-16);
      wasm.schema_intoFFI(t, e);
      var E = getInt32Memory0()[t / 4 + 0], A = getInt32Memory0()[t / 4 + 1], g = getInt32Memory0()[t / 4 + 2];
      if (g)
        throw takeObject(A);
      return FFIArrowSchema.__wrap(E);
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
  /**
  * Consume this schema and convert to an Arrow IPC Stream buffer
  * @returns {Uint8Array}
  */
  intoIPCStream() {
    try {
      const c = this.__destroy_into_raw(), n = wasm.__wbindgen_add_to_stack_pointer(-16);
      wasm.schema_intoIPCStream(n, c);
      var E = getInt32Memory0()[n / 4 + 0], A = getInt32Memory0()[n / 4 + 1], g = getInt32Memory0()[n / 4 + 2], e = getInt32Memory0()[n / 4 + 3];
      if (e)
        throw takeObject(g);
      var t = getArrayU8FromWasm0(E, A).slice();
      return wasm.__wbindgen_free(E, A * 1, 1), t;
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
  /**
  * Sets the metadata of this `Schema` to be `metadata` and returns a new object
  * @param {SchemaMetadata} metadata
  * @returns {Schema}
  */
  withMetadata(E) {
    try {
      const t = wasm.__wbindgen_add_to_stack_pointer(-16);
      wasm.schema_withMetadata(t, this.__wbg_ptr, addHeapObject(E));
      var A = getInt32Memory0()[t / 4 + 0], g = getInt32Memory0()[t / 4 + 1], e = getInt32Memory0()[t / 4 + 2];
      if (e)
        throw takeObject(g);
      return eI.__wrap(A);
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
  /**
  * Find the index of the column with the given name.
  * @param {string} name
  * @returns {number}
  */
  indexOf(E) {
    try {
      const t = wasm.__wbindgen_add_to_stack_pointer(-16), c = passStringToWasm0(E, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc), n = WASM_VECTOR_LEN;
      wasm.schema_indexOf(t, this.__wbg_ptr, c, n);
      var A = getInt32Memory0()[t / 4 + 0], g = getInt32Memory0()[t / 4 + 1], e = getInt32Memory0()[t / 4 + 2];
      if (e)
        throw takeObject(g);
      return A >>> 0;
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
  /**
  * Returns an immutable reference to the Map of custom metadata key-value pairs.
  * @returns {SchemaMetadata}
  */
  metadata() {
    try {
      const e = wasm.__wbindgen_add_to_stack_pointer(-16);
      wasm.schema_metadata(e, this.__wbg_ptr);
      var E = getInt32Memory0()[e / 4 + 0], A = getInt32Memory0()[e / 4 + 1], g = getInt32Memory0()[e / 4 + 2];
      if (g)
        throw takeObject(A);
      return takeObject(E);
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
};
const TableFinalization = typeof FinalizationRegistry > "u" ? { register: () => {
}, unregister: () => {
} } : new FinalizationRegistry((o) => wasm.__wbg_table_free(o >>> 0));
class Table {
  static __wrap(E) {
    E = E >>> 0;
    const A = Object.create(Table.prototype);
    return A.__wbg_ptr = E, TableFinalization.register(A, A.__wbg_ptr, A), A;
  }
  __destroy_into_raw() {
    const E = this.__wbg_ptr;
    return this.__wbg_ptr = 0, TableFinalization.unregister(this), E;
  }
  free() {
    const E = this.__destroy_into_raw();
    wasm.__wbg_table_free(E);
  }
  /**
  * Access the Table's {@linkcode Schema}.
  * @returns {Schema}
  */
  get schema() {
    const E = wasm.table_schema(this.__wbg_ptr);
    return Schema$1.__wrap(E);
  }
  /**
  * The number of batches in the Table
  * @returns {number}
  */
  get numBatches() {
    return wasm.table_numBatches(this.__wbg_ptr) >>> 0;
  }
  /**
  * Export this Table to FFI structs according to the Arrow C Data Interface.
  *
  * This method **does not consume** the Table, so you must remember to call {@linkcode
  * Table.free} to release the resources. The underlying arrays are reference counted, so
  * this method does not copy data, it only prevents the data from being released.
  * @returns {FFITable}
  */
  toFFI() {
    try {
      const e = wasm.__wbindgen_add_to_stack_pointer(-16);
      wasm.table_toFFI(e, this.__wbg_ptr);
      var E = getInt32Memory0()[e / 4 + 0], A = getInt32Memory0()[e / 4 + 1], g = getInt32Memory0()[e / 4 + 2];
      if (g)
        throw takeObject(A);
      return FFITable.__wrap(E);
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
  /**
  * Export this Table to FFI structs according to the Arrow C Data Interface.
  *
  * This method **does consume** the Table, so the original Table will be
  * inaccessible after this call. You must still call {@linkcode FFITable.free} after
  * you've finished using the FFITable.
  * @returns {FFITable}
  */
  intoFFI() {
    try {
      const e = this.__destroy_into_raw(), t = wasm.__wbindgen_add_to_stack_pointer(-16);
      wasm.table_intoFFI(t, e);
      var E = getInt32Memory0()[t / 4 + 0], A = getInt32Memory0()[t / 4 + 1], g = getInt32Memory0()[t / 4 + 2];
      if (g)
        throw takeObject(A);
      return FFITable.__wrap(E);
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
  /**
  * Consume this table and convert to an Arrow IPC Stream buffer
  * @returns {Uint8Array}
  */
  intoIPCStream() {
    try {
      const c = this.__destroy_into_raw(), n = wasm.__wbindgen_add_to_stack_pointer(-16);
      wasm.table_intoIPCStream(n, c);
      var E = getInt32Memory0()[n / 4 + 0], A = getInt32Memory0()[n / 4 + 1], g = getInt32Memory0()[n / 4 + 2], e = getInt32Memory0()[n / 4 + 3];
      if (e)
        throw takeObject(g);
      var t = getArrayU8FromWasm0(E, A).slice();
      return wasm.__wbindgen_free(E, A * 1, 1), t;
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
  /**
  * Create a table from an Arrow IPC Stream buffer
  * @param {Uint8Array} buf
  * @returns {Table}
  */
  static fromIPCStream(E) {
    try {
      const t = wasm.__wbindgen_add_to_stack_pointer(-16), c = passArray8ToWasm0(E, wasm.__wbindgen_malloc), n = WASM_VECTOR_LEN;
      wasm.table_fromIPCStream(t, c, n);
      var A = getInt32Memory0()[t / 4 + 0], g = getInt32Memory0()[t / 4 + 1], e = getInt32Memory0()[t / 4 + 2];
      if (e)
        throw takeObject(g);
      return Table.__wrap(A);
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
  /**
  * Returns the total number of bytes of memory occupied physically by all batches in this
  * table.
  * @returns {number}
  */
  getArrayMemorySize() {
    return wasm.table_getArrayMemorySize(this.__wbg_ptr) >>> 0;
  }
}
typeof FinalizationRegistry > "u" || new FinalizationRegistry((o) => wasm.__wbg_wasmgetoptions_free(o >>> 0));
const WasmObjectMetaFinalization = typeof FinalizationRegistry > "u" ? { register: () => {
}, unregister: () => {
} } : new FinalizationRegistry((o) => wasm.__wbg_wasmobjectmeta_free(o >>> 0));
class WasmObjectMeta {
  static __wrap(E) {
    E = E >>> 0;
    const A = Object.create(WasmObjectMeta.prototype);
    return A.__wbg_ptr = E, WasmObjectMetaFinalization.register(A, A.__wbg_ptr, A), A;
  }
  toJSON() {
    return {
      location: this.location,
      last_modified: this.last_modified,
      size: this.size,
      e_tag: this.e_tag,
      version: this.version
    };
  }
  toString() {
    return JSON.stringify(this);
  }
  __destroy_into_raw() {
    const E = this.__wbg_ptr;
    return this.__wbg_ptr = 0, WasmObjectMetaFinalization.unregister(this), E;
  }
  free() {
    const E = this.__destroy_into_raw();
    wasm.__wbg_wasmobjectmeta_free(E);
  }
  /**
  * The full path to the object
  * @returns {string}
  */
  get location() {
    let E, A;
    try {
      const t = wasm.__wbindgen_add_to_stack_pointer(-16);
      wasm.__wbg_get_wasmobjectmeta_location(t, this.__wbg_ptr);
      var g = getInt32Memory0()[t / 4 + 0], e = getInt32Memory0()[t / 4 + 1];
      return E = g, A = e, getStringFromWasm0(g, e);
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16), wasm.__wbindgen_free(E, A, 1);
    }
  }
  /**
  * The full path to the object
  * @param {string} arg0
  */
  set location(E) {
    const A = passStringToWasm0(E, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc), g = WASM_VECTOR_LEN;
    wasm.__wbg_set_wasmobjectmeta_location(this.__wbg_ptr, A, g);
  }
  /**
  * The last modified time
  * @returns {Date}
  */
  get last_modified() {
    const E = wasm.__wbg_get_wasmobjectmeta_last_modified(this.__wbg_ptr);
    return takeObject(E);
  }
  /**
  * The last modified time
  * @param {Date} arg0
  */
  set last_modified(E) {
    wasm.__wbg_set_wasmobjectmeta_last_modified(this.__wbg_ptr, addHeapObject(E));
  }
  /**
  * The size in bytes of the object
  * @returns {number}
  */
  get size() {
    return wasm.__wbg_get_wasmobjectmeta_size(this.__wbg_ptr) >>> 0;
  }
  /**
  * The size in bytes of the object
  * @param {number} arg0
  */
  set size(E) {
    wasm.__wbg_set_wasmobjectmeta_size(this.__wbg_ptr, E);
  }
  /**
  * The unique identifier for the object
  *
  * <https://datatracker.ietf.org/doc/html/rfc9110#name-etag>
  * @returns {string | undefined}
  */
  get e_tag() {
    try {
      const g = wasm.__wbindgen_add_to_stack_pointer(-16);
      wasm.__wbg_get_wasmobjectmeta_e_tag(g, this.__wbg_ptr);
      var E = getInt32Memory0()[g / 4 + 0], A = getInt32Memory0()[g / 4 + 1];
      let e;
      return E !== 0 && (e = getStringFromWasm0(E, A).slice(), wasm.__wbindgen_free(E, A * 1, 1)), e;
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
  /**
  * The unique identifier for the object
  *
  * <https://datatracker.ietf.org/doc/html/rfc9110#name-etag>
  * @param {string | undefined} [arg0]
  */
  set e_tag(E) {
    var A = isLikeNone(E) ? 0 : passStringToWasm0(E, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc), g = WASM_VECTOR_LEN;
    wasm.__wbg_set_wasmobjectmeta_e_tag(this.__wbg_ptr, A, g);
  }
  /**
  * A version indicator for this object
  * @returns {string | undefined}
  */
  get version() {
    try {
      const g = wasm.__wbindgen_add_to_stack_pointer(-16);
      wasm.__wbg_get_wasmobjectmeta_version(g, this.__wbg_ptr);
      var E = getInt32Memory0()[g / 4 + 0], A = getInt32Memory0()[g / 4 + 1];
      let e;
      return E !== 0 && (e = getStringFromWasm0(E, A).slice(), wasm.__wbindgen_free(E, A * 1, 1)), e;
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
  /**
  * A version indicator for this object
  * @param {string | undefined} [arg0]
  */
  set version(E) {
    var A = isLikeNone(E) ? 0 : passStringToWasm0(E, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc), g = WASM_VECTOR_LEN;
    wasm.__wbg_set_wasmobjectmeta_version(this.__wbg_ptr, A, g);
  }
}
typeof FinalizationRegistry > "u" || new FinalizationRegistry((o) => wasm.__wbg_wasmobjectstore_free(o >>> 0));
typeof FinalizationRegistry > "u" || new FinalizationRegistry((o) => wasm.__wbg_writerproperties_free(o >>> 0));
typeof FinalizationRegistry > "u" || new FinalizationRegistry((o) => wasm.__wbg_writerpropertiesbuilder_free(o >>> 0));
async function __wbg_load(o, E) {
  if (typeof Response == "function" && o instanceof Response) {
    if (typeof WebAssembly.instantiateStreaming == "function")
      try {
        return await WebAssembly.instantiateStreaming(o, E);
      } catch (g) {
        if (o.headers.get("Content-Type") != "application/wasm")
          console.warn("`WebAssembly.instantiateStreaming` failed because your server does not serve wasm with `application/wasm` MIME type. Falling back to `WebAssembly.instantiate` which is slower. Original error:\n", g);
        else
          throw g;
      }
    const A = await o.arrayBuffer();
    return await WebAssembly.instantiate(A, E);
  } else {
    const A = await WebAssembly.instantiate(o, E);
    return A instanceof WebAssembly.Instance ? { instance: A, module: o } : A;
  }
}
function __wbg_get_imports() {
  const o = {};
  return o.wbg = {}, o.wbg.__wbindgen_number_new = function(E) {
    return addHeapObject(E);
  }, o.wbg.__wbg_columnchunkmetadata_new = function(E) {
    const A = ColumnChunkMetaData.__wrap(E);
    return addHeapObject(A);
  }, o.wbg.__wbg_rowgroupmetadata_new = function(E) {
    const A = RowGroupMetaData.__wrap(E);
    return addHeapObject(A);
  }, o.wbg.__wbg_parquetfile_new = function(E) {
    const A = ParquetFile.__wrap(E);
    return addHeapObject(A);
  }, o.wbg.__wbindgen_object_drop_ref = function(E) {
    takeObject(E);
  }, o.wbg.__wbindgen_object_clone_ref = function(E) {
    const A = getObject(E);
    return addHeapObject(A);
  }, o.wbg.__wbindgen_error_new = function(E, A) {
    const g = new Error(getStringFromWasm0(E, A));
    return addHeapObject(g);
  }, o.wbg.__wbindgen_is_undefined = function(E) {
    return getObject(E) === void 0;
  }, o.wbg.__wbindgen_in = function(E, A) {
    return getObject(E) in getObject(A);
  }, o.wbg.__wbindgen_is_bigint = function(E) {
    return typeof getObject(E) == "bigint";
  }, o.wbg.__wbindgen_bigint_from_u64 = function(E) {
    const A = BigInt.asUintN(64, E);
    return addHeapObject(A);
  }, o.wbg.__wbindgen_jsval_eq = function(E, A) {
    return getObject(E) === getObject(A);
  }, o.wbg.__wbindgen_is_object = function(E) {
    const A = getObject(E);
    return typeof A == "object" && A !== null;
  }, o.wbg.__wbindgen_string_new = function(E, A) {
    const g = getStringFromWasm0(E, A);
    return addHeapObject(g);
  }, o.wbg.__wbindgen_number_get = function(E, A) {
    const g = getObject(A), e = typeof g == "number" ? g : void 0;
    getFloat64Memory0()[E / 8 + 1] = isLikeNone(e) ? 0 : e, getInt32Memory0()[E / 4 + 0] = !isLikeNone(e);
  }, o.wbg.__wbg_fetch_1db5b0ae726d68b5 = function(E) {
    const A = fetch(getObject(E));
    return addHeapObject(A);
  }, o.wbg.__wbg_wasmobjectmeta_new = function(E) {
    const A = WasmObjectMeta.__wrap(E);
    return addHeapObject(A);
  }, o.wbg.__wbindgen_string_get = function(E, A) {
    const g = getObject(A), e = typeof g == "string" ? g : void 0;
    var t = isLikeNone(e) ? 0 : passStringToWasm0(e, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc), c = WASM_VECTOR_LEN;
    getInt32Memory0()[E / 4 + 1] = c, getInt32Memory0()[E / 4 + 0] = t;
  }, o.wbg.__wbg_fetch_bc7c8e27076a5c84 = function(E) {
    const A = fetch(getObject(E));
    return addHeapObject(A);
  }, o.wbg.__wbg_done_2ffa852272310e47 = function(E) {
    return getObject(E).done;
  }, o.wbg.__wbg_value_9f6eeb1e2aab8d96 = function(E) {
    const A = getObject(E).value;
    return addHeapObject(A);
  }, o.wbg.__wbg_newwithintounderlyingsource_a03a82aa1bbbb292 = function(E, A) {
    const g = new ReadableStream(IntoUnderlyingSource.__wrap(E), takeObject(A));
    return addHeapObject(g);
  }, o.wbg.__wbg_getReader_ab94afcb5cb7689a = function() {
    return handleError(function(E) {
      const A = getObject(E).getReader();
      return addHeapObject(A);
    }, arguments);
  }, o.wbg.__wbg_sethighWaterMark_ea50ed3ec2143088 = function(E, A) {
    getObject(E).highWaterMark = A;
  }, o.wbg.__wbg_recordbatch_new = function(E) {
    const A = RecordBatch.__wrap(E);
    return addHeapObject(A);
  }, o.wbg.__wbg_table_new = function(E) {
    const A = Table.__wrap(E);
    return addHeapObject(A);
  }, o.wbg.__wbindgen_jsval_loose_eq = function(E, A) {
    return getObject(E) == getObject(A);
  }, o.wbg.__wbindgen_boolean_get = function(E) {
    const A = getObject(E);
    return typeof A == "boolean" ? A ? 1 : 0 : 2;
  }, o.wbg.__wbindgen_as_number = function(E) {
    return +getObject(E);
  }, o.wbg.__wbg_String_b9412f8799faab3e = function(E, A) {
    const g = String(getObject(A)), e = passStringToWasm0(g, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc), t = WASM_VECTOR_LEN;
    getInt32Memory0()[E / 4 + 1] = t, getInt32Memory0()[E / 4 + 0] = e;
  }, o.wbg.__wbg_getwithrefkey_edc2c8960f0f1191 = function(E, A) {
    const g = getObject(E)[getObject(A)];
    return addHeapObject(g);
  }, o.wbg.__wbg_set_f975102236d3c502 = function(E, A, g) {
    getObject(E)[takeObject(A)] = takeObject(g);
  }, o.wbg.__wbindgen_cb_drop = function(E) {
    const A = takeObject(E).original;
    return A.cnt-- == 1 ? (A.a = 0, !0) : !1;
  }, o.wbg.__wbg_queueMicrotask_481971b0d87f3dd4 = function(E) {
    queueMicrotask(getObject(E));
  }, o.wbg.__wbg_queueMicrotask_3cbae2ec6b6cd3d6 = function(E) {
    const A = getObject(E).queueMicrotask;
    return addHeapObject(A);
  }, o.wbg.__wbindgen_is_function = function(E) {
    return typeof getObject(E) == "function";
  }, o.wbg.__wbg_fetch_921fad6ef9e883dd = function(E, A) {
    const g = getObject(E).fetch(getObject(A));
    return addHeapObject(g);
  }, o.wbg.__wbg_new_ab6fd82b10560829 = function() {
    return handleError(function() {
      const E = new Headers();
      return addHeapObject(E);
    }, arguments);
  }, o.wbg.__wbg_append_7bfcb4937d1d5e29 = function() {
    return handleError(function(E, A, g, e, t) {
      getObject(E).append(getStringFromWasm0(A, g), getStringFromWasm0(e, t));
    }, arguments);
  }, o.wbg.__wbg_close_a994f9425dab445c = function() {
    return handleError(function(E) {
      getObject(E).close();
    }, arguments);
  }, o.wbg.__wbg_enqueue_ea194723156c0cc2 = function() {
    return handleError(function(E, A) {
      getObject(E).enqueue(getObject(A));
    }, arguments);
  }, o.wbg.__wbg_size_9c7e57fbd4f0f4b5 = function(E) {
    return getObject(E).size;
  }, o.wbg.__wbg_arrayBuffer_307ddd1bd1d04e23 = function(E) {
    const A = getObject(E).arrayBuffer();
    return addHeapObject(A);
  }, o.wbg.__wbg_slice_1991e6e71a6587f3 = function() {
    return handleError(function(E, A, g) {
      const e = getObject(E).slice(A, g);
      return addHeapObject(e);
    }, arguments);
  }, o.wbg.__wbg_read_e7d0f8a49be01d86 = function(E) {
    const A = getObject(E).read();
    return addHeapObject(A);
  }, o.wbg.__wbg_releaseLock_5c49db976c08b864 = function(E) {
    getObject(E).releaseLock();
  }, o.wbg.__wbg_cancel_6ee33d4006737aef = function(E) {
    const A = getObject(E).cancel();
    return addHeapObject(A);
  }, o.wbg.__wbg_byobRequest_72fca99f9c32c193 = function(E) {
    const A = getObject(E).byobRequest;
    return isLikeNone(A) ? 0 : addHeapObject(A);
  }, o.wbg.__wbg_close_184931724d961ccc = function() {
    return handleError(function(E) {
      getObject(E).close();
    }, arguments);
  }, o.wbg.__wbg_instanceof_Response_849eb93e75734b6e = function(E) {
    let A;
    try {
      A = getObject(E) instanceof Response;
    } catch {
      A = !1;
    }
    return A;
  }, o.wbg.__wbg_url_5f6dc4009ac5f99d = function(E, A) {
    const g = getObject(A).url, e = passStringToWasm0(g, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc), t = WASM_VECTOR_LEN;
    getInt32Memory0()[E / 4 + 1] = t, getInt32Memory0()[E / 4 + 0] = e;
  }, o.wbg.__wbg_status_61a01141acd3cf74 = function(E) {
    return getObject(E).status;
  }, o.wbg.__wbg_headers_9620bfada380764a = function(E) {
    const A = getObject(E).headers;
    return addHeapObject(A);
  }, o.wbg.__wbg_body_9545a94f397829db = function(E) {
    const A = getObject(E).body;
    return isLikeNone(A) ? 0 : addHeapObject(A);
  }, o.wbg.__wbg_arrayBuffer_29931d52c7206b02 = function() {
    return handleError(function(E) {
      const A = getObject(E).arrayBuffer();
      return addHeapObject(A);
    }, arguments);
  }, o.wbg.__wbg_signal_a61f78a3478fd9bc = function(E) {
    const A = getObject(E).signal;
    return addHeapObject(A);
  }, o.wbg.__wbg_new_0d76b0581eca6298 = function() {
    return handleError(function() {
      const E = new AbortController();
      return addHeapObject(E);
    }, arguments);
  }, o.wbg.__wbg_abort_2aa7521d5690750e = function(E) {
    getObject(E).abort();
  }, o.wbg.__wbg_view_7f0ce470793a340f = function(E) {
    const A = getObject(E).view;
    return isLikeNone(A) ? 0 : addHeapObject(A);
  }, o.wbg.__wbg_respond_b1a43b2e3a06d525 = function() {
    return handleError(function(E, A) {
      getObject(E).respond(A >>> 0);
    }, arguments);
  }, o.wbg.__wbg_newwithstrandinit_3fd6fba4083ff2d0 = function() {
    return handleError(function(E, A, g) {
      const e = new Request(getStringFromWasm0(E, A), getObject(g));
      return addHeapObject(e);
    }, arguments);
  }, o.wbg.__wbg_get_bd8e338fbd5f5cc8 = function(E, A) {
    const g = getObject(E)[A >>> 0];
    return addHeapObject(g);
  }, o.wbg.__wbg_length_cd7af8117672b8b8 = function(E) {
    return getObject(E).length;
  }, o.wbg.__wbg_newnoargs_e258087cd0daa0ea = function(E, A) {
    const g = new Function(getStringFromWasm0(E, A));
    return addHeapObject(g);
  }, o.wbg.__wbg_new_d9bc3a0147634640 = function() {
    return addHeapObject(/* @__PURE__ */ new Map());
  }, o.wbg.__wbg_next_40fc327bfc8770e6 = function(E) {
    const A = getObject(E).next;
    return addHeapObject(A);
  }, o.wbg.__wbg_next_196c84450b364254 = function() {
    return handleError(function(E) {
      const A = getObject(E).next();
      return addHeapObject(A);
    }, arguments);
  }, o.wbg.__wbg_done_298b57d23c0fc80c = function(E) {
    return getObject(E).done;
  }, o.wbg.__wbg_value_d93c65011f51a456 = function(E) {
    const A = getObject(E).value;
    return addHeapObject(A);
  }, o.wbg.__wbg_iterator_2cee6dadfd956dfa = function() {
    return addHeapObject(Symbol.iterator);
  }, o.wbg.__wbg_get_e3c254076557e348 = function() {
    return handleError(function(E, A) {
      const g = Reflect.get(getObject(E), getObject(A));
      return addHeapObject(g);
    }, arguments);
  }, o.wbg.__wbg_call_27c0f87801dedf93 = function() {
    return handleError(function(E, A) {
      const g = getObject(E).call(getObject(A));
      return addHeapObject(g);
    }, arguments);
  }, o.wbg.__wbg_new_72fb9a18b5ae2624 = function() {
    const E = new Object();
    return addHeapObject(E);
  }, o.wbg.__wbindgen_is_string = function(E) {
    return typeof getObject(E) == "string";
  }, o.wbg.__wbg_self_ce0dbfc45cf2f5be = function() {
    return handleError(function() {
      const E = self.self;
      return addHeapObject(E);
    }, arguments);
  }, o.wbg.__wbg_window_c6fb939a7f436783 = function() {
    return handleError(function() {
      const E = window.window;
      return addHeapObject(E);
    }, arguments);
  }, o.wbg.__wbg_globalThis_d1e6af4856ba331b = function() {
    return handleError(function() {
      const E = globalThis.globalThis;
      return addHeapObject(E);
    }, arguments);
  }, o.wbg.__wbg_global_207b558942527489 = function() {
    return handleError(function() {
      const E = global.global;
      return addHeapObject(E);
    }, arguments);
  }, o.wbg.__wbg_isArray_2ab64d95e09ea0ae = function(E) {
    return Array.isArray(getObject(E));
  }, o.wbg.__wbg_instanceof_ArrayBuffer_836825be07d4c9d2 = function(E) {
    let A;
    try {
      A = getObject(E) instanceof ArrayBuffer;
    } catch {
      A = !1;
    }
    return A;
  }, o.wbg.__wbg_new_28c511d9baebfa89 = function(E, A) {
    const g = new Error(getStringFromWasm0(E, A));
    return addHeapObject(g);
  }, o.wbg.__wbg_call_b3ca7c6051f9bec1 = function() {
    return handleError(function(E, A, g) {
      const e = getObject(E).call(getObject(A), getObject(g));
      return addHeapObject(e);
    }, arguments);
  }, o.wbg.__wbg_set_8417257aaedc936b = function(E, A, g) {
    const e = getObject(E).set(getObject(A), getObject(g));
    return addHeapObject(e);
  }, o.wbg.__wbg_isSafeInteger_f7b04ef02296c4d2 = function(E) {
    return Number.isSafeInteger(getObject(E));
  }, o.wbg.__wbg_new_cf3ec55744a78578 = function(E) {
    const A = new Date(getObject(E));
    return addHeapObject(A);
  }, o.wbg.__wbg_entries_95cc2c823b285a09 = function(E) {
    const A = Object.entries(getObject(E));
    return addHeapObject(A);
  }, o.wbg.__wbg_new_81740750da40724f = function(E, A) {
    try {
      var g = { a: E, b: A }, e = (c, n) => {
        const h = g.a;
        g.a = 0;
        try {
          return __wbg_adapter_285(h, g.b, c, n);
        } finally {
          g.a = h;
        }
      };
      const t = new Promise(e);
      return addHeapObject(t);
    } finally {
      g.a = g.b = 0;
    }
  }, o.wbg.__wbg_resolve_b0083a7967828ec8 = function(E) {
    const A = Promise.resolve(getObject(E));
    return addHeapObject(A);
  }, o.wbg.__wbg_catch_0260e338d10f79ae = function(E, A) {
    const g = getObject(E).catch(getObject(A));
    return addHeapObject(g);
  }, o.wbg.__wbg_then_0c86a60e8fcfe9f6 = function(E, A) {
    const g = getObject(E).then(getObject(A));
    return addHeapObject(g);
  }, o.wbg.__wbg_then_a73caa9a87991566 = function(E, A, g) {
    const e = getObject(E).then(getObject(A), getObject(g));
    return addHeapObject(e);
  }, o.wbg.__wbg_buffer_12d079cc21e14bdb = function(E) {
    const A = getObject(E).buffer;
    return addHeapObject(A);
  }, o.wbg.__wbg_newwithbyteoffsetandlength_aa4a17c33a06e5cb = function(E, A, g) {
    const e = new Uint8Array(getObject(E), A >>> 0, g >>> 0);
    return addHeapObject(e);
  }, o.wbg.__wbg_new_63b92bc8671ed464 = function(E) {
    const A = new Uint8Array(getObject(E));
    return addHeapObject(A);
  }, o.wbg.__wbg_set_a47bac70306a19a7 = function(E, A, g) {
    getObject(E).set(getObject(A), g >>> 0);
  }, o.wbg.__wbg_length_c20a40f15020d68a = function(E) {
    return getObject(E).length;
  }, o.wbg.__wbg_instanceof_Uint8Array_2b3bbecd033d19f6 = function(E) {
    let A;
    try {
      A = getObject(E) instanceof Uint8Array;
    } catch {
      A = !1;
    }
    return A;
  }, o.wbg.__wbg_newwithlength_e9b4878cebadb3d3 = function(E) {
    const A = new Uint8Array(E >>> 0);
    return addHeapObject(A);
  }, o.wbg.__wbg_newwithbyteoffset_27c6424791adc775 = function(E, A) {
    const g = new Uint8Array(getObject(E), A >>> 0);
    return addHeapObject(g);
  }, o.wbg.__wbg_buffer_dd7f74bc60f1faab = function(E) {
    const A = getObject(E).buffer;
    return addHeapObject(A);
  }, o.wbg.__wbg_byteLength_58f7b4fab1919d44 = function(E) {
    return getObject(E).byteLength;
  }, o.wbg.__wbg_byteOffset_81d60f7392524f62 = function(E) {
    return getObject(E).byteOffset;
  }, o.wbg.__wbg_stringify_8887fe74e1c50d81 = function() {
    return handleError(function(E) {
      const A = JSON.stringify(getObject(E));
      return addHeapObject(A);
    }, arguments);
  }, o.wbg.__wbg_has_0af94d20077affa2 = function() {
    return handleError(function(E, A) {
      return Reflect.has(getObject(E), getObject(A));
    }, arguments);
  }, o.wbg.__wbg_set_1f9b04f170055d33 = function() {
    return handleError(function(E, A, g) {
      return Reflect.set(getObject(E), getObject(A), getObject(g));
    }, arguments);
  }, o.wbg.__wbindgen_bigint_get_as_i64 = function(E, A) {
    const g = getObject(A), e = typeof g == "bigint" ? g : void 0;
    getBigInt64Memory0()[E / 8 + 1] = isLikeNone(e) ? BigInt(0) : e, getInt32Memory0()[E / 4 + 0] = !isLikeNone(e);
  }, o.wbg.__wbindgen_debug_string = function(E, A) {
    const g = debugString(getObject(A)), e = passStringToWasm0(g, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc), t = WASM_VECTOR_LEN;
    getInt32Memory0()[E / 4 + 1] = t, getInt32Memory0()[E / 4 + 0] = e;
  }, o.wbg.__wbindgen_throw = function(E, A) {
    throw new Error(getStringFromWasm0(E, A));
  }, o.wbg.__wbindgen_memory = function() {
    const E = wasm.memory;
    return addHeapObject(E);
  }, o.wbg.__wbindgen_function_table = function() {
    const E = wasm.__wbindgen_export_2;
    return addHeapObject(E);
  }, o.wbg.__wbindgen_closure_wrapper13295 = function(E, A, g) {
    const e = makeMutClosure(E, A, 3248, __wbg_adapter_50);
    return addHeapObject(e);
  }, o;
}
function __wbg_finalize_init(o, E) {
  return wasm = o.exports, __wbg_init.__wbindgen_wasm_module = E, cachedBigInt64Memory0 = null, cachedFloat64Memory0 = null, cachedInt32Memory0 = null, cachedUint32Memory0 = null, cachedUint8Memory0 = null, wasm;
}
async function __wbg_init(o) {
  if (wasm !== void 0) return wasm;
  typeof o > "u" && (o = new URL("./assets/1b1a876c211e4f13.wasm", import.meta.url));
  const E = __wbg_get_imports();
  (typeof o == "string" || typeof Request == "function" && o instanceof Request || typeof URL == "function" && o instanceof URL) && (o = fetch(o));
  const { instance: A, module: g } = await __wbg_load(await o, E);
  return __wbg_finalize_init(A, g);
}
__wbg_init();
function isPandasRangeIndex(o) {
  return typeof o == "object" && o.kind === "range";
}
function parsePandasSchema(o) {
  const E = o.schema.metadata.get("pandas");
  if (!isNullOrUndefined(E))
    return JSON.parse(E);
}
function parsePandasIndexData(o, E) {
  return E ? E.index_columns.map((A) => {
    if (isPandasRangeIndex(A)) {
      const {
        start: e,
        stop: t,
        step: c
      } = A;
      return range$1(e, t, c);
    }
    const g = o.getChild(A);
    return g instanceof Vector && g.type instanceof Null ? null : g;
  }).filter((A) => A !== null) : [];
}
function parseHeaderName(o, E) {
  if (E === 1)
    return [o];
  try {
    return JSON.parse(o.trim().replace(/^\(/, "[").replace(/\)$/, "]").replace(/'/g, '"'));
  } catch {
    return [...Array(E - 1).fill(""), o];
  }
}
function parseColumnNames(o, E, A) {
  const g = E.concat(o);
  return unzip(g.map((e) => e.arrowField.name.startsWith("__index_level_") ? "" : e.arrowField.name).map((e) => (
    // If DataFrame `columns` has multi-level indexing, the length of
    // `column_indexes` will show how many levels there are.
    parseHeaderName(e, A?.column_indexes.length ?? 1)
  )));
}
function parseData(o, E) {
  const A = o.numRows, g = E.length;
  if (A === 0 || g === 0)
    return o.select([]);
  const e = E.map((t) => t.arrowField.name);
  return o.select(e);
}
function parsePandasIndexColumnTypes(o, E, A) {
  return E ? E.index_columns.map((e) => {
    if (isPandasRangeIndex(e)) {
      const c = e.name || "";
      return {
        type: DataFrameCellType.INDEX,
        arrowField: new Field(c, new Int_(!0, 64), !0),
        pandasType: {
          field_name: c,
          name: c,
          pandas_type: PandasRangeIndexType,
          numpy_type: PandasRangeIndexType,
          metadata: e
        }
      };
    }
    const t = o.fields.find((c) => c.name === e);
    if (!t)
      throw new Error(`Index field ${e} not found in arrow schema`);
    return {
      type: DataFrameCellType.INDEX,
      arrowField: t,
      pandasType: E.columns.find((c) => c.field_name === e),
      categoricalOptions: A[t.name]
    };
  }) : [];
}
function parseDataColumnTypes(o, E, A) {
  return o.fields.filter((t) => E ? !E.index_columns.includes(t.name) : !0).map((t) => ({
    type: DataFrameCellType.DATA,
    arrowField: t,
    pandasType: E?.columns.find((c) => c.field_name === t.name),
    categoricalOptions: A[t.name]
  }));
}
function parseCategoricalOptionsForColumns(o) {
  const E = {};
  return o.schema.fields.forEach((A, g) => {
    if (A.type instanceof Dictionary) {
      const e = o.getChildAt(g)?.data[0]?.dictionary;
      notNullOrUndefined(e) && (E[A.name] = convertVectorToList(e));
    }
  }), E;
}
function parseArrowIpcBytes(o) {
  const E = tableFromIPC(o && readParquet(o).intoIPCStream()), A = E.schema, g = parsePandasSchema(E), e = parseCategoricalOptionsForColumns(E), t = parsePandasIndexColumnTypes(A, g, e), c = parseDataColumnTypes(A, g, e), n = parseData(E, c), h = parsePandasIndexData(E, g), d = parseColumnNames(c, t, g);
  return {
    pandasIndexData: h,
    data: n,
    columnNames: d,
    pandasIndexColumnTypes: t,
    dataColumnTypes: c
  };
}
var _a;
_a = DRAFTABLE;
class Quiver {
  constructor(E) {
    this[_a] = !0;
    const {
      pandasIndexData: A,
      columnNames: g,
      data: e,
      dataColumnTypes: t,
      pandasIndexColumnTypes: c
    } = parseArrowIpcBytes(E.data), n = E.styler ? parseStyler(E.styler) : void 0;
    this._pandasIndexData = A, this._columnNames = g, this._data = e, this._dataColumnTypes = t, this._pandasIndexColumnTypes = c, this._styler = n, this._num_bytes = E.data?.length ?? 0, this._columnTypes = this._pandasIndexColumnTypes.concat(this._dataColumnTypes);
  }
  /** Matrix of column names of the index- & data-columns.
   *
   * This is a matrix to support multi-level headers.
   * Index columns only exist if the DataFrame was created based on a Pandas DataFrame.
   */
  get columnNames() {
    return this._columnNames;
  }
  /** List of column types for every index- & data-column. */
  get columnTypes() {
    return this._columnTypes;
  }
  /** Pandas Styler data. This will only be defined if the user styled the dataframe
   * via Pandas Styler.
   */
  get styler() {
    return this._styler;
  }
  /** Dimensions of the DataFrame. */
  get dimensions() {
    const E = this._pandasIndexColumnTypes.length || 0, A = this._columnNames.length || 1, g = this._data.numRows || 0, e = this._dataColumnTypes.length || 0, t = A + g, c = E + e;
    return {
      numHeaderRows: A,
      numIndexColumns: E,
      numDataRows: g,
      numDataColumns: e,
      numRows: t,
      numColumns: c
    };
  }
  /**
   * A hash that identifies the underlying data.
   *
   * This hash is based on various descriptive information
   * but is not 100% guaranteed to be unique.
   */
  get hash() {
    const E = [this.dimensions.numColumns, this.dimensions.numDataColumns, this.dimensions.numDataRows, this.dimensions.numIndexColumns, this.dimensions.numHeaderRows, this.dimensions.numRows, this._num_bytes, this._columnNames];
    return hashString(E.join("-"));
  }
  /** Return a single cell from an (Pandas) index- or data-column of the DataFrame.
   *
   * @param rowIndex - The row index of the cell (0 is the first data or index row excluding header rows)
   * @param columnIndex - The column index of the cell (0 is the first data or index column)
   * @returns The cell's content, type, and field.
   */
  getCell(E, A) {
    const {
      numIndexColumns: g,
      numDataRows: e,
      numColumns: t
    } = this.dimensions;
    if (E < 0 || E >= e)
      throw new Error(`Row index is out of range: ${E}`);
    if (A < 0 || A >= t)
      throw new Error(`Column index is out of range: ${A}`);
    if (A < g) {
      const k = this._pandasIndexColumnTypes[A], p = this.getIndexValue(E, A);
      return {
        type: DataFrameCellType.INDEX,
        content: p,
        contentType: k,
        field: k.arrowField
      };
    }
    const n = A - g, h = this._dataColumnTypes[n], d = this.getDataValue(E, n);
    return {
      type: DataFrameCellType.DATA,
      content: d,
      contentType: h,
      field: h.arrowField
    };
  }
  /** Get the raw value of an index cell.
   *
   * Index columns only exist if the DataFrame was created based on a Pandas DataFrame.
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace 'any' with a more specific type.
  getIndexValue(E, A) {
    const g = this._pandasIndexData[A];
    return g instanceof Vector ? g.get(E) : g[E];
  }
  /** Get the raw value of a data cell. */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace 'any' with a more specific type.
  getDataValue(E, A) {
    return this._data.getChildAt(A)?.get(E);
  }
  /**
   * Add the contents of another table (data + indexes) to this table.
   * Extra columns will not be created.
   */
  addRows(E) {
    if (this.styler || E.styler)
      throw new Error("\nUnsupported operation. `add_rows()` does not support Pandas Styler objects.\n\nIf you do not need the Styler's styles, try passing the `.data` attribute of\nthe Styler object instead to concatenate just the underlying dataframe.\n\nFor example:\n```\nst.add_rows(my_styler.data)\n```\n");
    if (E.dimensions.numDataRows === 0)
      return produce(this, (c) => c);
    if (this.dimensions.numDataRows === 0)
      return produce(E, (c) => c);
    const {
      index: A,
      data: g,
      indexTypes: e,
      dataTypes: t
    } = concat(this._dataColumnTypes, this._pandasIndexColumnTypes, this._pandasIndexData, this._data, E._dataColumnTypes, E._pandasIndexColumnTypes, E._pandasIndexData, E._data);
    return produce(this, (c) => {
      c._pandasIndexData = A, c._data = g, c._pandasIndexColumnTypes = e, c._dataColumnTypes = t, c._columnTypes = e.concat(t);
    });
  }
}
function parseStyler(o) {
  return {
    uuid: o.uuid,
    caption: o.caption,
    cssStyles: o.styles,
    cssId: o.uuid ? `T_${o.uuid}` : void 0,
    // Recursively create a new Quiver instance for Styler's display values.
    // This values will be used for rendering the DataFrame, while the original values
    // will be used for sorting, etc.
    displayValues: new Quiver({
      data: o.displayValues
    })
  };
}
class ElementNode {
  /** Create a new ElementNode. */
  constructor(E, A, g, e, t) {
    this.element = E, this.metadata = A, this.scriptRunId = g, this.activeScriptHash = e, this.fragmentId = t;
  }
  get quiverElement() {
    if (this.lazyQuiverElement !== void 0)
      return this.lazyQuiverElement;
    if (this.element.type !== "arrowTable" && this.element.type !== "arrowDataFrame")
      throw new Error(`elementType '${this.element.type}' is not a valid Quiver element!`);
    const E = new Quiver(this.element[this.element.type]);
    return this.lazyQuiverElement = E, E;
  }
  get vegaLiteChartElement() {
    if (this.lazyVegaLiteChartElement !== void 0)
      return this.lazyVegaLiteChartElement;
    if (this.element.type !== "arrowVegaLiteChart")
      throw new Error(`elementType '${this.element.type}' is not a valid VegaLiteChartElement!`);
    const E = this.element.arrowVegaLiteChart, A = E.data ? new Quiver(E.data) : null, g = E.datasets.length > 0 ? wrapDatasets(E.datasets) : [], e = {
      data: A,
      spec: E.spec,
      datasets: g,
      useContainerWidth: E.useContainerWidth,
      vegaLiteTheme: E.theme,
      id: E.id,
      selectionMode: E.selectionMode,
      formId: E.formId
    };
    return this.lazyVegaLiteChartElement = e, e;
  }
  arrowAddRows(E, A) {
    const g = this.element.type, e = new ElementNode(this.element, this.metadata, A, this.activeScriptHash, this.fragmentId);
    switch (g) {
      case "arrowTable":
      case "arrowDataFrame": {
        e.lazyQuiverElement = ElementNode.quiverAddRowsHelper(this.quiverElement, E);
        break;
      }
      case "arrowVegaLiteChart": {
        e.lazyVegaLiteChartElement = ElementNode.vegaLiteChartAddRowsHelper(this.vegaLiteChartElement, E);
        break;
      }
      default:
        throw new Error(`elementType '${this.element.type}' is not a valid arrowAddRows target!`);
    }
    return e;
  }
  static quiverAddRowsHelper(E, A) {
    if (A.hasName)
      throw new Error("Add rows cannot be used with a named dataset for this element.");
    const g = new Quiver(A.data);
    return E.addRows(g);
  }
  static vegaLiteChartAddRowsHelper(E, A) {
    const g = A.hasName ? A.name : null, e = new Quiver(A.data);
    return produce(E, (t) => {
      const c = getNamedDataSet(t.datasets, g);
      c ? c.data = c.data.addRows(e) : t.data = t.data ? t.data.addRows(e) : e;
    });
  }
  /**
   * Accept a visitor.
   * @param visitor - The visitor to accept.
   * @returns The result of the visitor's visitElementNode method.
   * @example
   * const visitor = new DebugVisitor()
   * const result = elementNode.accept(visitor)
   * console.log(result)
   */
  accept(E) {
    return E.visitElementNode(this);
  }
  /**
   * Returns a string representation of this ElementNode for debugging purposes.
   * This method can be used to log or inspect the state of the node.
   *
   * @returns {string} A debug string describing this node.
   */
  debug() {
    return this.accept(new DebugVisitor());
  }
}
function getNamedDataSet(o, E) {
  return o.length === 1 ? o[0] : o.find((A) => A.hasName && A.name === E);
}
function wrapDatasets(o) {
  return o.map((E) => ({
    hasName: E.hasName,
    name: E.name,
    data: new Quiver(E.data)
  }));
}
class ClearStaleNodeVisitor {
  constructor(E, A, g) {
    this.currentScriptRunId = E, this.fragmentIdsThisRun = A ?? [], this.fragmentIdOfBlock = g;
  }
  get isFragmentRun() {
    return this.fragmentIdsThisRun.length > 0;
  }
  visitBlockNode(E) {
    let A = null;
    if (this.isFragmentRun) {
      if (this.fragmentIdOfBlock && E.scriptRunId !== this.currentScriptRunId)
        return;
      E.fragmentId && this.fragmentIdsThisRun.includes(E.fragmentId) && E.scriptRunId === this.currentScriptRunId && (A = new ClearStaleNodeVisitor(this.currentScriptRunId, this.fragmentIdsThisRun, E.fragmentId));
    } else if (E.scriptRunId !== this.currentScriptRunId)
      return;
    const g = [];
    let e = !1;
    return E.children.forEach((t) => {
      const c = t.accept(A ?? this);
      c !== t && (e = !0), c !== void 0 && g.push(c);
    }), e ? new BlockNode(E.activeScriptHash, g, E.deltaBlock, this.currentScriptRunId, E.fragmentId, E.deltaMsgReceivedAt) : E;
  }
  visitElementNode(E) {
    return this.isFragmentRun && (!E.fragmentId || !this.fragmentIdOfBlock || E.scriptRunId === this.currentScriptRunId) || E.scriptRunId === this.currentScriptRunId ? E : void 0;
  }
}
class ElementsSetVisitor {
  constructor() {
    this.elements = /* @__PURE__ */ new Set();
  }
  visitElementNode(E) {
    return this.elements.add(E.element), this.elements;
  }
  visitBlockNode(E) {
    for (const A of E.children)
      A.accept(this);
    return this.elements;
  }
  /**
   * Static convenience method to collect all elements from a node tree.
   */
  static collectElements(E) {
    const A = new ElementsSetVisitor();
    return E.accept(A), A.elements;
  }
}
class FilterMainScriptElementsVisitor {
  constructor(E) {
    this.mainScriptHash = E;
  }
  visitElementNode(E) {
    if (E.activeScriptHash === this.mainScriptHash)
      return E;
  }
  visitBlockNode(E) {
    if (E.activeScriptHash !== this.mainScriptHash)
      return;
    let A = !1;
    const g = [];
    for (const e of E.children) {
      const t = e.accept(this);
      t !== e && (A = !0), t !== void 0 && g.push(t);
    }
    return A ? new BlockNode(E.activeScriptHash, g, E.deltaBlock, E.scriptRunId, E.fragmentId, E.deltaMsgReceivedAt) : E;
  }
  /**
   * Static convenience method to filter a node tree based on mainScriptHash.
   */
  static filterNode(E, A) {
    const g = new FilterMainScriptElementsVisitor(A);
    return E.accept(g);
  }
}
class GetNodeByDeltaPathVisitor {
  constructor(E) {
    this.deltaPath = E;
  }
  visitElementNode(E) {
  }
  visitBlockNode(E) {
    if (this.deltaPath.length === 0)
      return;
    const [A, ...g] = this.deltaPath;
    if (A < 0 || A >= E.children.length)
      return;
    if (g.length === 0)
      return E.children[A];
    const e = new GetNodeByDeltaPathVisitor(g);
    return E.children[A].accept(e);
  }
  /**
   * Static convenience method to get a node at a delta path.
   */
  static getNodeAtPath(E, A) {
    const g = new GetNodeByDeltaPathVisitor(A);
    return E.accept(g);
  }
}
class SetNodeByDeltaPathVisitor {
  constructor(E, A, g) {
    if (E.length === 0)
      throw new Error("deltaPath cannot be empty");
    this.deltaPath = E, this.nodeToSet = A, this.scriptRunId = g;
  }
  visitElementNode(E) {
    throw new Error("'SetNodeByDeltaPathVisitor' cannot visit an ElementNode");
  }
  visitBlockNode(E) {
    const [A, ...g] = this.deltaPath;
    if (A < 0 || A > E.children.length)
      throw new Error(`Bad delta path index ${A} (should be between [0, ${E.children.length}])`);
    const e = E.children.slice();
    if (g.length === 0)
      e[A] = this.nodeToSet;
    else {
      const t = new SetNodeByDeltaPathVisitor(g, this.nodeToSet, this.scriptRunId);
      e[A] = e[A].accept(t);
    }
    return new BlockNode(E.activeScriptHash, e, E.deltaBlock, this.scriptRunId, E.fragmentId, E.deltaMsgReceivedAt);
  }
  /**
   * Static convenience method to set a node at a delta path.
   */
  static setNodeAtPath(E, A, g, e) {
    const t = new SetNodeByDeltaPathVisitor(A, g, e);
    return E.accept(t);
  }
}
class AppRoot {
  /**
   * Create an empty AppRoot with a placeholder "skeleton" element.
   * @param mainScriptHash - The hash of the main script that creates this AppRoot.
   * @param isInitialRender - Whether this is the initial render.
   * @param sidebarElements - The elements to add to the sidebar (this was a relic
   * of MPA V1 to maintain the sidebar from flickering, we don't use it anymore).
   * @param logo - The logo to add to the app.
   * @returns A new AppRoot with the given parameters.
   */
  static empty(E = "", A = !0, g, e) {
    const t = [];
    let c;
    switch (getLoadingScreenType()) {
      case LoadingScreenType.NONE:
        break;
      case LoadingScreenType.V1:
        A && (c = makeElementWithInfoText("Please wait..."));
        break;
      default:
        c = makeAppSkeletonElement();
    }
    c && t.push(new ElementNode(c, ForwardMsgMetadata.create({}), NO_SCRIPT_RUN_ID, E));
    const n = new BlockNode(E, t, new Block$1({
      allowEmpty: !0
    }), NO_SCRIPT_RUN_ID), h = g || new BlockNode(E, [], new Block$1({
      allowEmpty: !0
    }), NO_SCRIPT_RUN_ID), d = new BlockNode(E, [], new Block$1({
      allowEmpty: !0
    }), NO_SCRIPT_RUN_ID), k = new BlockNode(E, [], new Block$1({
      allowEmpty: !0
    }), NO_SCRIPT_RUN_ID), p = e ? {
      logo: e,
      activeScriptHash: E,
      scriptRunId: NO_SCRIPT_RUN_ID
    } : null;
    return new AppRoot(E, new BlockNode(E, [n, h, d, k]), p);
  }
  constructor(E, A, g = null) {
    if (this.mainScriptHash = E, this.root = A, this.appLogo = g, this.root.children.length !== 4 || isNullOrUndefined(this.main) || isNullOrUndefined(this.sidebar) || isNullOrUndefined(this.event) || isNullOrUndefined(this.bottom))
      throw new Error(`Invalid root node children! ${A}`);
  }
  get main() {
    const [E] = this.root.children;
    return E;
  }
  get sidebar() {
    const [, E] = this.root.children;
    return E;
  }
  get event() {
    const [, , E] = this.root.children;
    return E;
  }
  get bottom() {
    const [, , , E] = this.root.children;
    return E;
  }
  get logo() {
    return this.appLogo?.logo ?? null;
  }
  appRootWithLogo(E, A) {
    return new AppRoot(this.mainScriptHash, this.root, {
      logo: E,
      ...A
    });
  }
  applyDelta(E, A, g) {
    const {
      deltaPath: e,
      activeScriptHash: t
    } = g;
    switch (A.type) {
      case "newElement": {
        const c = A.newElement;
        return this.addElement(e, E, c, g, t, A.fragmentId);
      }
      case "addBlock": {
        const c = Date.now();
        return this.addBlock(e, A.addBlock, E, t, A.fragmentId, c);
      }
      case "arrowAddRows":
        try {
          return this.arrowAddRows(e, A.arrowAddRows, E);
        } catch (c) {
          const n = makeElementWithErrorText(ensureError(c).message);
          return this.addElement(e, E, n, g, t);
        }
      default:
        throw new Error(`Unrecognized deltaType: '${A.type}'`);
    }
  }
  ensureBlockNode(E, A = this.mainScriptHash) {
    return E ?? new BlockNode(A);
  }
  /**
   * Clears all nodes that are not associated with the mainScriptHash.
   * @param mainScriptHash - The hash of the main script.
   * @returns A new AppRoot with the filtered nodes.
   */
  filterMainScriptElements(E) {
    const A = this.main.scriptRunId, g = new FilterMainScriptElementsVisitor(E), e = this.root.children.map((c) => this.ensureBlockNode(c.accept(g), E)), t = this.appLogo?.activeScriptHash === E ? this.appLogo : null;
    return new AppRoot(E, new BlockNode(E, e, new Block$1({
      allowEmpty: !0
    }), A), t);
  }
  clearStaleNodes(E, A) {
    const g = new ClearStaleNodeVisitor(E, A), e = this.root.children.map((n) => this.ensureBlockNode(n.accept(g))), c = A && A.length > 0 || this.appLogo?.scriptRunId === E ? this.appLogo : null;
    return new AppRoot(this.mainScriptHash, new BlockNode(this.mainScriptHash, e, new Block$1({
      allowEmpty: !0
    }), E), c);
  }
  /** Return a Set containing all Elements in the tree. */
  getElements() {
    const E = new ElementsSetVisitor();
    return this.main.accept(E), this.sidebar.accept(E), this.event.accept(E), this.bottom.accept(E), E.elements;
  }
  addElement(E, A, g, e, t, c) {
    const n = new ElementNode(g, e, A, t, c);
    return new AppRoot(this.mainScriptHash, SetNodeByDeltaPathVisitor.setNodeAtPath(this.root, E, n, A), this.appLogo);
  }
  addBlock(E, A, g, e, t, c) {
    const n = GetNodeByDeltaPathVisitor.getNodeAtPath(this.root, E);
    let h = [];
    n instanceof BlockNode && n.deltaBlock.type === A.type && (h = n.children);
    const d = new BlockNode(e, h, A, g, t, c);
    return new AppRoot(this.mainScriptHash, SetNodeByDeltaPathVisitor.setNodeAtPath(this.root, E, d, g), this.appLogo);
  }
  arrowAddRows(E, A, g) {
    const e = GetNodeByDeltaPathVisitor.getNodeAtPath(this.root, E);
    if (isNullOrUndefined(e) || !(e instanceof ElementNode))
      throw new Error(`Can't arrowAddRows: invalid deltaPath: ${E}`);
    const t = e.arrowAddRows(A, g);
    return new AppRoot(this.mainScriptHash, SetNodeByDeltaPathVisitor.setNodeAtPath(this.root, E, t, g), this.appLogo);
  }
  getChildName(E) {
    switch (E) {
      case this.main:
        return "main";
      case this.sidebar:
        return "sidebar";
      case this.event:
        return "event";
      case this.bottom:
        return "bottom";
      default:
        return "unknown";
    }
  }
  /**
   * Returns a string representation of the AppRoot structure for debugging purposes.
   * This method traverses the AppRoot tree and outputs a formatted string
   * showing the hierarchy of its child nodes.
   *
   * @returns {string} A formatted string representing the AppRoot structure.
   */
  debug() {
    let E = `AppRoot
`;
    return this.root.children.forEach((A, g) => {
      const e = g === this.root.children.length - 1, t = this.getChildName(A), c = e ? "└── " : "├── ", n = e ? "    " : "│   ";
      E += `${c}${t}:
`;
      const h = new DebugVisitor(n, !0);
      E += A.accept(h);
    }), E;
  }
}
var classnames = { exports: {} };
var hasRequiredClassnames;
function requireClassnames() {
  return hasRequiredClassnames || (hasRequiredClassnames = 1, (function(o) {
    (function() {
      var E = {}.hasOwnProperty;
      function A() {
        for (var t = "", c = 0; c < arguments.length; c++) {
          var n = arguments[c];
          n && (t = e(t, g(n)));
        }
        return t;
      }
      function g(t) {
        if (typeof t == "string" || typeof t == "number")
          return t;
        if (typeof t != "object")
          return "";
        if (Array.isArray(t))
          return A.apply(null, t);
        if (t.toString !== Object.prototype.toString && !t.toString.toString().includes("[native code]"))
          return t.toString();
        var c = "";
        for (var n in t)
          E.call(t, n) && t[n] && (c = e(c, n));
        return c;
      }
      function e(t, c) {
        return c ? t ? t + " " + c : t + c : t;
      }
      o.exports ? (A.default = A, o.exports = A) : window.classNames = A;
    })();
  })(classnames)), classnames.exports;
}
var classnamesExports = requireClassnames();
const classNames = /* @__PURE__ */ getDefaultExportFromCjs(classnamesExports);
var Direction = /* @__PURE__ */ ((o) => (o.HORIZONTAL = "row", o.VERTICAL = "column", o))(Direction || {});
function getDirectionOfBlock(o) {
  return o.flexContainer ? o.flexContainer.direction == Block$1.FlexContainer.Direction.HORIZONTAL ? "row" : "column" : o.vertical ? "column" : o.horizontal ? "row" : "column";
}
function shouldWidthStretch(o) {
  return !!(o?.useStretch || o?.pixelWidth);
}
function shouldHeightStretch(o) {
  return !!(o?.useStretch || o?.pixelHeight);
}
const alignmentMap = {
  [streamlit.TextAlignmentConfig.Alignment.LEFT]: "left",
  [streamlit.TextAlignmentConfig.Alignment.CENTER]: "center",
  [streamlit.TextAlignmentConfig.Alignment.RIGHT]: "right",
  [streamlit.TextAlignmentConfig.Alignment.JUSTIFY]: "justify",
  [streamlit.TextAlignmentConfig.Alignment.UNSPECIFIED]: "left"
};
function getTextAlignmentStyle(o) {
  if (o?.alignment)
    return alignmentMap[o.alignment] || "left";
}
const FlexContext = createContext(null);
FlexContext.displayName = "FlexContext";
const FlexContextProvider = ({
  children: o,
  direction: E,
  isRoot: A,
  parentWidth: g,
  hasContentWidth: e = !1,
  hasFixedWidth: t = !1,
  parentContext: c = null
}) => {
  const n = useMemo$1(() => {
    const h = E === Direction.HORIZONTAL;
    let d;
    return e ? d = !0 : t ? d = !1 : d = c?.isInContentWidthContainer ?? !1, {
      direction: E,
      isInHorizontalLayout: h,
      isInRoot: A ?? !1,
      parentWidth: g,
      isInContentWidthContainer: d
    };
  }, [E, A, g, e, t, c]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(FlexContext.Provider, { value: n, children: o });
};
function guard(o, E, A) {
  return Math.min(Math.max(o, A), E);
}
class ColorError extends Error {
  constructor(E) {
    super(`Failed to parse color: "${E}"`);
  }
}
var ColorError$1 = ColorError;
function parseToRgba(o) {
  if (typeof o != "string") throw new ColorError$1(o);
  if (o.trim().toLowerCase() === "transparent") return [0, 0, 0, 0];
  let E = o.trim();
  E = namedColorRegex.test(o) ? nameToHex(o) : o;
  const A = reducedHexRegex.exec(E);
  if (A) {
    const c = Array.from(A).slice(1);
    return [...c.slice(0, 3).map((n) => parseInt(r$1(n, 2), 16)), parseInt(r$1(c[3] || "f", 2), 16) / 255];
  }
  const g = hexRegex.exec(E);
  if (g) {
    const c = Array.from(g).slice(1);
    return [...c.slice(0, 3).map((n) => parseInt(n, 16)), parseInt(c[3] || "ff", 16) / 255];
  }
  const e = rgbaRegex.exec(E);
  if (e) {
    const c = Array.from(e).slice(1);
    return [...c.slice(0, 3).map((n) => parseInt(n, 10)), parseFloat(c[3] || "1")];
  }
  const t = hslaRegex.exec(E);
  if (t) {
    const [c, n, h, d] = Array.from(t).slice(1).map(parseFloat);
    if (guard(0, 100, n) !== n) throw new ColorError$1(o);
    if (guard(0, 100, h) !== h) throw new ColorError$1(o);
    return [...hslToRgb(c, n, h), Number.isNaN(d) ? 1 : d];
  }
  throw new ColorError$1(o);
}
function hash(o) {
  let E = 5381, A = o.length;
  for (; A; )
    E = E * 33 ^ o.charCodeAt(--A);
  return (E >>> 0) % 2341;
}
const colorToInt = (o) => parseInt(o.replace(/_/g, ""), 36), compressedColorMap = "1q29ehhb 1n09sgk7 1kl1ekf_ _yl4zsno 16z9eiv3 1p29lhp8 _bd9zg04 17u0____ _iw9zhe5 _to73___ _r45e31e _7l6g016 _jh8ouiv _zn3qba8 1jy4zshs 11u87k0u 1ro9yvyo 1aj3xael 1gz9zjz0 _3w8l4xo 1bf1ekf_ _ke3v___ _4rrkb__ 13j776yz _646mbhl _nrjr4__ _le6mbhl 1n37ehkb _m75f91n _qj3bzfz 1939yygw 11i5z6x8 _1k5f8xs 1509441m 15t5lwgf _ae2th1n _tg1ugcv 1lp1ugcv 16e14up_ _h55rw7n _ny9yavn _7a11xb_ 1ih442g9 _pv442g9 1mv16xof 14e6y7tu 1oo9zkds 17d1cisi _4v9y70f _y98m8kc 1019pq0v 12o9zda8 _348j4f4 1et50i2o _8epa8__ _ts6senj 1o350i2o 1mi9eiuo 1259yrp0 1ln80gnw _632xcoy 1cn9zldc _f29edu4 1n490c8q _9f9ziet 1b94vk74 _m49zkct 1kz6s73a 1eu9dtog _q58s1rz 1dy9sjiq __u89jo3 _aj5nkwg _ld89jo3 13h9z6wx _qa9z2ii _l119xgq _bs5arju 1hj4nwk9 1qt4nwk9 1ge6wau6 14j9zlcw 11p1edc_ _ms1zcxe _439shk6 _jt9y70f _754zsow 1la40eju _oq5p___ _x279qkz 1fa5r3rv _yd2d9ip _424tcku _8y1di2_ _zi2uabw _yy7rn9h 12yz980_ __39ljp6 1b59zg0x _n39zfzp 1fy9zest _b33k___ _hp9wq92 1il50hz4 _io472ub _lj9z3eo 19z9ykg0 _8t8iu3a 12b9bl4a 1ak5yw0o _896v4ku _tb8k8lv _s59zi6t _c09ze0p 1lg80oqn 1id9z8wb _238nba5 1kq6wgdi _154zssg _tn3zk49 _da9y6tc 1sg7cv4f _r12jvtt 1gq5fmkz 1cs9rvci _lp9jn1c _xw1tdnb 13f9zje6 16f6973h _vo7ir40 _bt5arjf _rc45e4t _hr4e100 10v4e100 _hc9zke2 _w91egv_ _sj2r1kk 13c87yx8 _vqpds__ _ni8ggk8 _tj9yqfb 1ia2j4r4 _7x9b10u 1fc9ld4j 1eq9zldr _5j9lhpx _ez9zl6o _md61fzm".split(" ").reduce((o, E) => {
  const A = colorToInt(E.substring(0, 3)), g = colorToInt(E.substring(3)).toString(16);
  let e = "";
  for (let t = 0; t < 6 - g.length; t++)
    e += "0";
  return o[A] = `${e}${g}`, o;
}, {});
function nameToHex(o) {
  const E = o.toLowerCase().trim(), A = compressedColorMap[hash(E)];
  if (!A) throw new ColorError$1(o);
  return `#${A}`;
}
const r$1 = (o, E) => Array.from(Array(E)).map(() => o).join(""), reducedHexRegex = new RegExp(`^#${r$1("([a-f0-9])", 3)}([a-f0-9])?$`, "i"), hexRegex = new RegExp(`^#${r$1("([a-f0-9]{2})", 3)}([a-f0-9]{2})?$`, "i"), rgbaRegex = new RegExp(`^rgba?\\(\\s*(\\d+)\\s*${r$1(",\\s*(\\d+)\\s*", 2)}(?:,\\s*([\\d.]+))?\\s*\\)$`, "i"), hslaRegex = /^hsla?\(\s*([\d.]+)\s*,\s*([\d.]+)%\s*,\s*([\d.]+)%(?:\s*,\s*([\d.]+))?\s*\)$/i, namedColorRegex = /^[a-z]+$/i, roundColor = (o) => Math.round(o * 255), hslToRgb = (o, E, A) => {
  let g = A / 100;
  if (E === 0)
    return [g, g, g].map(roundColor);
  const e = (o % 360 + 360) % 360 / 60, t = (1 - Math.abs(2 * g - 1)) * (E / 100), c = t * (1 - Math.abs(e % 2 - 1));
  let n = 0, h = 0, d = 0;
  e >= 0 && e < 1 ? (n = t, h = c) : e >= 1 && e < 2 ? (n = c, h = t) : e >= 2 && e < 3 ? (h = t, d = c) : e >= 3 && e < 4 ? (h = c, d = t) : e >= 4 && e < 5 ? (n = c, d = t) : e >= 5 && e < 6 && (n = t, d = c);
  const k = g - t / 2, p = n + k, M = h + k, S = d + k;
  return [p, M, S].map(roundColor);
};
function parseToHsla(o) {
  const [E, A, g, e] = parseToRgba(o).map((p, M) => (
    // 3rd index is alpha channel which is already normalized
    M === 3 ? p : p / 255
  )), t = Math.max(E, A, g), c = Math.min(E, A, g), n = (t + c) / 2;
  if (t === c) return [0, 0, n, e];
  const h = t - c, d = n > 0.5 ? h / (2 - t - c) : h / (t + c);
  return [60 * (E === t ? (A - g) / h + (A < g ? 6 : 0) : A === t ? (g - E) / h + 2 : (E - A) / h + 4), d, n, e];
}
function hsla(o, E, A, g) {
  return `hsla(${(o % 360).toFixed()}, ${guard(0, 100, E * 100).toFixed()}%, ${guard(0, 100, A * 100).toFixed()}%, ${parseFloat(guard(0, 1, g).toFixed(3))})`;
}
function darken(o, E) {
  const [A, g, e, t] = parseToHsla(o);
  return hsla(A, g, e - E, t);
}
function getLuminance(o) {
  if (o === "transparent") return 0;
  function E(t) {
    const c = t / 255;
    return c <= 0.04045 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
  }
  const [A, g, e] = parseToRgba(o);
  return 0.2126 * E(A) + 0.7152 * E(g) + 0.0722 * E(e);
}
function rgba$1(o, E, A, g) {
  return `rgba(${guard(0, 255, o).toFixed()}, ${guard(0, 255, E).toFixed()}, ${guard(0, 255, A).toFixed()}, ${parseFloat(guard(0, 1, g).toFixed(3))})`;
}
function mix$1(o, E, A) {
  const g = (EA, oA) => (
    // 3rd index is alpha channel which is already normalized
    oA === 3 ? EA : EA / 255
  ), [e, t, c, n] = parseToRgba(o).map(g), [h, d, k, p] = parseToRgba(E).map(g), M = p - n, S = A * 2 - 1, H = ((S * M === -1 ? S : S + M / (1 + S * M)) + 1) / 2, gA = 1 - H, CA = (e * gA + h * H) * 255, IA = (t * gA + d * H) * 255, BA = (c * gA + k * H) * 255, QA = p * A + n * (1 - A);
  return rgba$1(CA, IA, BA, QA);
}
function lighten(o, E) {
  return darken(o, -E);
}
function transparentize(o, E) {
  const [A, g, e, t] = parseToRgba(o);
  return rgba$1(A, g, e, t - E);
}
function toHex(o) {
  const [E, A, g, e] = parseToRgba(o);
  let t = (c) => {
    const n = guard(0, 255, c).toString(16);
    return n.length === 1 ? `0${n}` : n;
  };
  return `#${t(E)}${t(A)}${t(g)}${e < 1 ? t(Math.round(e * 255)) : ""}`;
}
var colors$1 = {
  white: "#FFFFFF",
  gray50: "#F6F6F6",
  gray100: "#EEEEEE",
  gray200: "#E2E2E2",
  gray300: "#CBCBCB",
  gray400: "#AFAFAF",
  gray500: "#6B6B6B",
  gray600: "#545454",
  gray700: "#333333",
  gray800: "#1F1F1F",
  gray900: "#141414",
  black: "#000000",
  platinum400: "#8EA3AD",
  red50: "#FFEFED",
  red100: "#FED7D2",
  red200: "#F1998E",
  red300: "#E85C4A",
  red400: "#E11900",
  red500: "#AB1300",
  red600: "#870F00",
  red700: "#5A0A00",
  orange200: "#FABDA5",
  orange300: "#FA9269",
  orange400: "#FF6937",
  orange500: "#C14F29",
  orange600: "#9A3F21",
  orange700: "#672A16",
  yellow50: "#FFFAF0",
  yellow100: "#FFF2D9",
  yellow200: "#FFE3AC",
  yellow300: "#FFCF70",
  yellow400: "#FFC043",
  yellow500: "#BC8B2C",
  yellow600: "#996F00",
  yellow700: "#674D1B",
  green50: "#E6F2ED",
  green100: "#ADDEC9",
  green200: "#66D19E",
  green300: "#06C167",
  green400: "#048848",
  green500: "#03703C",
  green600: "#03582F",
  green700: "#10462D",
  blue50: "#EFF3FE",
  blue100: "#D4E2FC",
  blue200: "#A0BFF8",
  blue300: "#5B91F5",
  blue400: "#276EF1",
  blue500: "#1E54B7",
  blue600: "#174291",
  blue700: "#102C60",
  cobalt400: "#0E1FC1",
  purple200: "#C1B4E2",
  purple300: "#957FCE",
  purple400: "#7356BF",
  purple500: "#574191",
  purple600: "#453473",
  purple700: "#2E224C",
  brown200: "#D2BBB0",
  brown300: "#B18977",
  brown400: "#99644C",
  brown500: "#744C3A",
  brown600: "#5C3C2E",
  brown700: "#3D281E"
}, lightColorTokens = {
  // Primary Palette
  primaryA: colors$1.black,
  primaryB: colors$1.white,
  primary: colors$1.black,
  primary50: colors$1.gray50,
  primary100: colors$1.gray100,
  primary200: colors$1.gray200,
  primary300: colors$1.gray300,
  primary400: colors$1.gray400,
  primary500: colors$1.gray500,
  primary600: colors$1.gray600,
  primary700: colors$1.gray700,
  // Accent Palette
  accent: colors$1.blue400,
  accent50: colors$1.blue50,
  accent100: colors$1.blue100,
  accent200: colors$1.blue200,
  accent300: colors$1.blue300,
  accent400: colors$1.blue400,
  accent500: colors$1.blue500,
  accent600: colors$1.blue600,
  accent700: colors$1.blue700,
  // Negative Palette
  negative: colors$1.red400,
  negative50: colors$1.red50,
  negative100: colors$1.red100,
  negative200: colors$1.red200,
  negative300: colors$1.red300,
  negative400: colors$1.red400,
  negative500: colors$1.red500,
  negative600: colors$1.red600,
  negative700: colors$1.red700,
  // Warning Palette
  warning: colors$1.yellow400,
  warning50: colors$1.yellow50,
  warning100: colors$1.yellow100,
  warning200: colors$1.yellow200,
  warning300: colors$1.yellow300,
  warning400: colors$1.yellow400,
  warning500: colors$1.yellow500,
  warning600: colors$1.yellow600,
  warning700: colors$1.yellow700,
  // Positive Palette
  positive: colors$1.green500,
  positive50: colors$1.green50,
  positive100: colors$1.green100,
  positive200: colors$1.green200,
  positive300: colors$1.green300,
  positive400: colors$1.green400,
  positive500: colors$1.green500,
  positive600: colors$1.green600,
  positive700: colors$1.green700,
  // Monochrome Palette
  white: colors$1.white,
  black: colors$1.black,
  mono100: colors$1.white,
  mono200: colors$1.gray50,
  mono300: colors$1.gray100,
  mono400: colors$1.gray200,
  mono500: colors$1.gray300,
  mono600: colors$1.gray400,
  mono700: colors$1.gray500,
  mono800: colors$1.gray600,
  mono900: colors$1.gray700,
  mono1000: colors$1.black,
  // Rating Palette,
  ratingInactiveFill: colors$1.gray100,
  ratingStroke: colors$1.gray300
};
function hexToRgb() {
  var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", E = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "1", A = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
  o = o.replace(A, function(e, t, c, n) {
    return t + t + c + c + n + n;
  });
  var g = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(o);
  return g ? "rgba(".concat(parseInt(g[1], 16), ", ").concat(parseInt(g[2], 16), ", ").concat(parseInt(g[3], 16), ", ").concat(E, ")") : null;
}
var ellipsisText = {
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  wordWrap: "normal"
};
function expandBorderStyles(o) {
  return {
    borderTopWidth: o.borderWidth,
    borderTopStyle: o.borderStyle,
    borderTopColor: o.borderColor,
    borderBottomWidth: o.borderWidth,
    borderBottomStyle: o.borderStyle,
    borderBottomColor: o.borderColor,
    borderLeftWidth: o.borderWidth,
    borderLeftStyle: o.borderStyle,
    borderLeftColor: o.borderColor,
    borderRightWidth: o.borderWidth,
    borderRightStyle: o.borderStyle,
    borderRightColor: o.borderColor
  };
}
function ownKeys$y(o, E) {
  var A = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var g = Object.getOwnPropertySymbols(o);
    E && (g = g.filter(function(e) {
      return Object.getOwnPropertyDescriptor(o, e).enumerable;
    })), A.push.apply(A, g);
  }
  return A;
}
function _objectSpread$w(o) {
  for (var E = 1; E < arguments.length; E++) {
    var A = arguments[E] != null ? arguments[E] : {};
    E % 2 ? ownKeys$y(Object(A), !0).forEach(function(g) {
      _defineProperty$F(o, g, A[g]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(A)) : ownKeys$y(Object(A)).forEach(function(g) {
      Object.defineProperty(o, g, Object.getOwnPropertyDescriptor(A, g));
    });
  }
  return o;
}
function _defineProperty$F(o, E, A) {
  return E in o ? Object.defineProperty(o, E, { value: A, enumerable: !0, configurable: !0, writable: !0 }) : o[E] = A, o;
}
const getSemanticColorTokens = (function() {
  var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : lightColorTokens, E = {
    // Background
    backgroundPrimary: o.primaryB,
    backgroundSecondary: colors$1.gray50,
    backgroundTertiary: colors$1.gray100,
    backgroundInversePrimary: o.primaryA,
    backgroundInverseSecondary: colors$1.gray800,
    // Content
    contentPrimary: o.primaryA,
    contentSecondary: colors$1.gray600,
    contentTertiary: colors$1.gray500,
    contentInversePrimary: o.primaryB,
    contentInverseSecondary: colors$1.gray300,
    contentInverseTertiary: colors$1.gray400,
    // Border
    borderOpaque: colors$1.gray200,
    borderTransparent: hexToRgb(o.primaryA, "0.08"),
    borderSelected: o.primaryA,
    borderInverseOpaque: colors$1.gray700,
    borderInverseTransparent: hexToRgb(o.primaryB, "0.2"),
    borderInverseSelected: o.primaryB
  }, A = {
    // Backgrounds
    backgroundStateDisabled: colors$1.gray50,
    backgroundOverlayDark: hexToRgb(colors$1.black, "0.3"),
    backgroundOverlayLight: hexToRgb(colors$1.black, "0.08"),
    backgroundOverlayArt: hexToRgb(colors$1.black, "0.00"),
    backgroundAccent: o.accent,
    backgroundNegative: o.negative,
    backgroundWarning: o.warning,
    backgroundPositive: colors$1.green400,
    backgroundLightAccent: colors$1.blue50,
    backgroundLightNegative: colors$1.red50,
    backgroundLightWarning: colors$1.yellow50,
    backgroundLightPositive: colors$1.green50,
    backgroundAlwaysDark: colors$1.black,
    backgroundAlwaysLight: colors$1.white,
    // Content
    contentStateDisabled: colors$1.gray400,
    contentAccent: o.accent,
    contentOnColor: colors$1.white,
    contentOnColorInverse: colors$1.black,
    contentNegative: o.negative,
    contentWarning: colors$1.yellow600,
    contentPositive: colors$1.green400,
    // Border
    borderStateDisabled: colors$1.gray50,
    borderAccent: colors$1.blue400,
    borderAccentLight: colors$1.blue200,
    borderNegative: colors$1.red200,
    borderWarning: colors$1.yellow200,
    borderPositive: colors$1.green200,
    // Programs
    safety: colors$1.blue400,
    eatsGreen400: colors$1.green400,
    freightBlue400: colors$1.cobalt400,
    jumpRed400: colors$1.red400,
    rewardsTier1: colors$1.blue400,
    rewardsTier2: colors$1.yellow400,
    rewardsTier3: colors$1.platinum400,
    rewardsTier4: colors$1.black,
    membership: colors$1.yellow600
  };
  return _objectSpread$w(_objectSpread$w({}, E), A);
});
var tagHoverBackground = "rgba(0, 0, 0, 0.08)";
const getComponentColorTokens = (function() {
  var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : lightColorTokens;
  return {
    bannerActionLowInfo: o.accent100,
    bannerActionLowNegative: o.negative100,
    bannerActionLowPositive: o.positive100,
    bannerActionLowWarning: o.warning200,
    bannerActionHighInfo: o.accent500,
    bannerActionHighNegative: o.negative500,
    bannerActionHighPositive: o.positive500,
    bannerActionHighWarning: o.warning200,
    // Buttons
    buttonPrimaryFill: o.primary,
    buttonPrimaryText: o.white,
    buttonPrimaryHover: o.primary700,
    buttonPrimaryActive: o.primary600,
    buttonPrimarySelectedFill: o.primary600,
    buttonPrimarySelectedText: o.white,
    buttonPrimarySpinnerForeground: o.accent,
    buttonPrimarySpinnerBackground: o.primaryB,
    buttonSecondaryFill: o.primary100,
    buttonSecondaryText: o.primary,
    buttonSecondaryHover: o.primary200,
    buttonSecondaryActive: o.primary300,
    buttonSecondarySelectedFill: o.primary300,
    buttonSecondarySelectedText: o.primary,
    buttonSecondarySpinnerForeground: o.accent,
    buttonSecondarySpinnerBackground: o.primaryB,
    buttonTertiaryFill: "transparent",
    buttonTertiaryText: o.primary,
    buttonTertiaryHover: o.primary50,
    buttonTertiaryActive: o.primary100,
    buttonTertiarySelectedFill: o.primary100,
    buttonTertiarySelectedText: o.primary,
    buttonTertiaryDisabledActiveFill: o.primary50,
    buttonTertiaryDisabledActiveText: o.mono600,
    buttonTertiarySpinnerForeground: o.accent,
    buttonTertiarySpinnerBackground: o.primary100,
    buttonDisabledFill: o.mono200,
    buttonDisabledText: o.mono600,
    buttonDisabledActiveFill: o.mono700,
    buttonDisabledActiveText: o.mono100,
    buttonDisabledSpinnerForeground: o.mono600,
    buttonDisabledSpinnerBackground: o.mono400,
    // Breadcrumbs
    breadcrumbsText: o.black,
    breadcrumbsSeparatorFill: o.mono700,
    // Datepicker
    calendarBackground: o.mono100,
    calendarForeground: o.mono1000,
    calendarForegroundDisabled: o.mono500,
    calendarHeaderBackground: o.white,
    calendarHeaderForeground: o.primary,
    calendarHeaderBackgroundActive: o.primary700,
    calendarHeaderForegroundDisabled: o.primary500,
    calendarDayForegroundPseudoSelected: o.mono1000,
    calendarDayBackgroundPseudoSelectedHighlighted: o.primary200,
    calendarDayForegroundPseudoSelectedHighlighted: o.mono1000,
    calendarDayBackgroundSelected: o.primary,
    calendarDayForegroundSelected: o.white,
    calendarDayBackgroundSelectedHighlighted: o.primary,
    calendarDayForegroundSelectedHighlighted: o.white,
    // Combobox
    comboboxListItemFocus: o.mono200,
    comboboxListItemHover: o.mono300,
    // FileUploader
    fileUploaderBackgroundColor: o.mono200,
    fileUploaderBackgroundColorActive: o.primary50,
    fileUploaderBorderColorActive: o.primary,
    fileUploaderBorderColorDefault: o.mono500,
    fileUploaderMessageColor: o.mono800,
    // Links
    linkText: o.primary,
    linkVisited: o.primary700,
    linkHover: o.primary600,
    linkActive: o.primary500,
    // List
    listHeaderFill: o.white,
    listBodyFill: o.white,
    // ProgressSteps
    progressStepsCompletedText: o.white,
    progressStepsCompletedFill: o.primary,
    progressStepsActiveText: o.white,
    progressStepsActiveFill: o.primary,
    // Toggle
    toggleFill: o.white,
    toggleFillChecked: o.primary,
    toggleFillDisabled: o.mono600,
    toggleTrackFill: o.mono400,
    toggleTrackFillDisabled: o.mono300,
    // Tick
    tickFill: o.mono100,
    tickFillHover: o.mono200,
    tickFillActive: o.mono300,
    tickFillSelected: o.primary,
    tickFillSelectedHover: o.primary700,
    tickFillSelectedHoverActive: o.primary600,
    tickFillError: o.negative50,
    tickFillErrorHover: o.negative100,
    tickFillErrorHoverActive: o.negative200,
    tickFillErrorSelected: o.negative400,
    tickFillErrorSelectedHover: o.negative500,
    tickFillErrorSelectedHoverActive: o.negative600,
    tickFillDisabled: o.mono600,
    tickBorder: o.mono700,
    tickBorderError: o.negative400,
    tickMarkFill: o.white,
    tickMarkFillError: o.white,
    tickMarkFillDisabled: o.mono100,
    // Slider/Toggle
    sliderTrackFill: "transparent",
    sliderHandleFill: o.primaryA,
    sliderHandleFillDisabled: o.primary400,
    sliderHandleInnerFill: o.primaryA,
    sliderTrackFillHover: o.mono500,
    sliderTrackFillActive: o.mono600,
    sliderTrackFillDisabled: o.mono300,
    sliderHandleInnerFillDisabled: o.mono400,
    sliderHandleInnerFillSelectedHover: o.primary,
    sliderHandleInnerFillSelectedActive: o.primary500,
    // Inputs
    inputBorder: o.mono300,
    inputFill: o.mono300,
    inputFillError: o.negative50,
    inputFillDisabled: o.mono200,
    inputFillActive: o.mono200,
    inputFillPositive: o.positive50,
    inputTextDisabled: o.mono600,
    inputBorderError: o.negative200,
    inputBorderPositive: o.positive200,
    inputEnhancerFill: o.mono300,
    inputEnhancerFillDisabled: o.mono300,
    inputEnhancerTextDisabled: o.mono600,
    inputPlaceholder: o.mono700,
    inputPlaceholderDisabled: o.mono600,
    // Menu
    menuFill: o.mono100,
    menuFillHover: o.mono200,
    menuFontDefault: o.mono800,
    menuFontDisabled: o.mono500,
    menuFontHighlighted: o.mono1000,
    menuFontSelected: o.mono1000,
    // Modal
    modalCloseColor: o.mono1000,
    modalCloseColorHover: o.mono800,
    modalCloseColorFocus: o.mono800,
    // Tab
    tabBarFill: o.mono200,
    tabColor: o.mono800,
    // Notification
    notificationInfoBackground: o.accent50,
    notificationInfoText: o.primaryA,
    notificationPositiveBackground: o.positive50,
    notificationPositiveText: o.primaryA,
    notificationWarningBackground: o.warning50,
    notificationWarningText: o.primaryA,
    notificationNegativeBackground: o.negative50,
    notificationNegativeText: o.primaryA,
    // Tag
    // Custom ramps
    tagFontDisabledRampUnit: "100",
    tagSolidFontRampUnit: "0",
    tagSolidRampUnit: "400",
    tagOutlinedFontRampUnit: "400",
    tagOutlinedRampUnit: "200",
    // Deprecated
    tagSolidHoverRampUnit: "50",
    tagSolidActiveRampUnit: "100",
    tagSolidDisabledRampUnit: "50",
    tagSolidFontHoverRampUnit: "500",
    tagLightRampUnit: "50",
    tagLightHoverRampUnit: "100",
    tagLightActiveRampUnit: "100",
    tagLightFontRampUnit: "500",
    tagLightFontHoverRampUnit: "500",
    tagOutlinedHoverRampUnit: "50",
    tagOutlinedActiveRampUnit: "0",
    tagOutlinedFontHoverRampUnit: "400",
    // Neutral
    tagNeutralFontDisabled: o.mono600,
    tagNeutralOutlinedDisabled: o.mono400,
    tagNeutralSolidFont: o.white,
    tagNeutralSolidBackground: o.black,
    tagNeutralOutlinedBackground: o.mono600,
    tagNeutralOutlinedFont: o.black,
    // Deprecated
    tagNeutralSolidHover: o.mono300,
    tagNeutralSolidActive: o.mono400,
    tagNeutralSolidDisabled: o.mono200,
    tagNeutralSolidFontHover: o.mono900,
    tagNeutralLightBackground: o.mono300,
    tagNeutralLightHover: o.mono300,
    tagNeutralLightActive: o.mono400,
    tagNeutralLightDisabled: o.mono200,
    tagNeutralLightFont: o.mono900,
    tagNeutralLightFontHover: o.mono900,
    tagNeutralOutlinedActive: o.mono900,
    tagNeutralOutlinedFontHover: o.mono800,
    tagNeutralOutlinedHover: tagHoverBackground,
    // Primary
    tagPrimaryFontDisabled: o.primary400,
    tagPrimaryOutlinedDisabled: o.primary200,
    tagPrimarySolidFont: o.white,
    tagPrimarySolidBackground: o.primary,
    tagPrimaryOutlinedFontHover: o.primary,
    tagPrimaryOutlinedFont: o.primary,
    // Deprecated
    tagPrimarySolidHover: o.primary100,
    tagPrimarySolidActive: o.primary200,
    tagPrimarySolidDisabled: o.primary50,
    tagPrimarySolidFontHover: o.primary700,
    tagPrimaryLightBackground: o.primary50,
    tagPrimaryLightHover: o.primary100,
    tagPrimaryLightActive: o.primary100,
    tagPrimaryLightDisabled: o.primary50,
    tagPrimaryLightFont: o.primary500,
    tagPrimaryLightFontHover: o.primary500,
    tagPrimaryOutlinedActive: o.primary600,
    tagPrimaryOutlinedHover: tagHoverBackground,
    tagPrimaryOutlinedBackground: o.primary400,
    // Accent
    tagAccentFontDisabled: o.accent200,
    tagAccentOutlinedDisabled: o.accent200,
    tagAccentSolidFont: o.white,
    tagAccentSolidBackground: o.accent400,
    tagAccentOutlinedBackground: o.accent200,
    tagAccentOutlinedFont: o.accent400,
    // Deprecated
    tagAccentSolidHover: o.accent50,
    tagAccentSolidActive: o.accent100,
    tagAccentSolidDisabled: o.accent50,
    tagAccentSolidFontHover: o.accent500,
    tagAccentLightBackground: o.accent50,
    tagAccentLightHover: o.accent100,
    tagAccentLightActive: o.accent100,
    tagAccentLightDisabled: o.accent50,
    tagAccentLightFont: o.accent500,
    tagAccentLightFontHover: o.accent500,
    tagAccentOutlinedActive: o.accent600,
    tagAccentOutlinedFontHover: o.accent400,
    tagAccentOutlinedHover: tagHoverBackground,
    // Positive
    tagPositiveFontDisabled: o.positive200,
    tagPositiveOutlinedDisabled: o.positive200,
    tagPositiveSolidFont: o.white,
    tagPositiveSolidBackground: o.positive400,
    tagPositiveOutlinedBackground: o.positive200,
    tagPositiveOutlinedFont: o.positive400,
    // Deprecated
    tagPositiveSolidHover: o.positive50,
    tagPositiveSolidActive: o.positive100,
    tagPositiveSolidDisabled: o.positive50,
    tagPositiveSolidFontHover: o.positive500,
    tagPositiveLightBackground: o.positive50,
    tagPositiveLightHover: o.positive100,
    tagPositiveLightActive: o.positive100,
    tagPositiveLightDisabled: o.positive50,
    tagPositiveLightFont: o.positive500,
    tagPositiveLightFontHover: o.positive500,
    tagPositiveOutlinedActive: o.positive600,
    tagPositiveOutlinedFontHover: o.positive400,
    tagPositiveOutlinedHover: tagHoverBackground,
    // Warning
    tagWarningFontDisabled: o.warning300,
    tagWarningOutlinedDisabled: o.warning300,
    tagWarningSolidFont: o.warning700,
    tagWarningSolidBackground: o.warning400,
    tagWarningOutlinedBackground: o.warning300,
    tagWarningOutlinedFont: o.warning600,
    // Deprecated
    tagWarningSolidHover: o.warning50,
    tagWarningSolidActive: o.warning100,
    tagWarningSolidDisabled: o.warning50,
    tagWarningSolidFontHover: o.warning500,
    tagWarningLightBackground: o.warning50,
    tagWarningLightHover: o.warning100,
    tagWarningLightActive: o.warning100,
    tagWarningLightDisabled: o.warning50,
    tagWarningLightFont: o.warning500,
    tagWarningLightFontHover: o.warning500,
    tagWarningOutlinedActive: o.warning600,
    tagWarningOutlinedFontHover: o.warning600,
    tagWarningOutlinedHover: tagHoverBackground,
    // Negative
    tagNegativeFontDisabled: o.negative200,
    tagNegativeOutlinedDisabled: o.negative200,
    tagNegativeSolidFont: o.white,
    tagNegativeSolidBackground: o.negative400,
    tagNegativeOutlinedBackground: o.negative200,
    tagNegativeOutlinedFont: o.negative400,
    // Deprecated
    tagNegativeSolidHover: o.negative50,
    tagNegativeSolidActive: o.negative100,
    tagNegativeSolidDisabled: o.negative50,
    tagNegativeSolidFontHover: o.negative500,
    tagNegativeLightBackground: o.negative50,
    tagNegativeLightHover: o.negative100,
    tagNegativeLightActive: o.negative100,
    tagNegativeLightDisabled: o.negative50,
    tagNegativeLightFont: o.negative500,
    tagNegativeLightFontHover: o.negative500,
    tagNegativeOutlinedActive: o.negative600,
    tagNegativeOutlinedFontHover: o.negative400,
    tagNegativeOutlinedHover: tagHoverBackground,
    // Table
    tableHeadBackgroundColor: o.mono100,
    tableBackground: o.mono100,
    tableStripedBackground: o.mono200,
    tableFilter: o.mono600,
    tableFilterHeading: o.mono700,
    tableFilterBackground: o.mono100,
    tableFilterFooterBackground: o.mono200,
    // Toast
    toastText: o.white,
    toastPrimaryText: o.white,
    toastInfoBackground: o.accent400,
    toastInfoText: o.white,
    toastPositiveBackground: o.positive400,
    toastPositiveText: o.white,
    toastWarningBackground: o.warning400,
    toastWarningText: o.black,
    toastNegativeBackground: o.negative400,
    toastNegativeText: o.white,
    // Spinner
    spinnerTrackFill: o.mono900,
    // Progress bar
    progressbarTrackFill: o.mono900,
    // Tooltip
    tooltipBackground: o.mono900,
    tooltipText: o.mono100
  };
});
var borders = {
  border100: {
    borderColor: "hsla(0, 0%, 0%, 0.04)",
    borderStyle: "solid",
    borderWidth: "1px"
  },
  border200: {
    borderColor: "hsla(0, 0%, 0%, 0.08)",
    borderStyle: "solid",
    borderWidth: "1px"
  },
  border300: {
    borderColor: "hsla(0, 0%, 0%, 0.12)",
    borderStyle: "solid",
    borderWidth: "1px"
  },
  border400: {
    borderColor: "hsla(0, 0%, 0%, 0.16)",
    borderStyle: "solid",
    borderWidth: "1px"
  },
  border500: {
    borderColor: "hsla(0, 0%, 0%, 0.2)",
    borderStyle: "solid",
    borderWidth: "1px"
  },
  border600: {
    borderColor: "hsla(0, 0%, 0%, 0.24)",
    borderStyle: "solid",
    borderWidth: "1px"
  },
  radius100: "2px",
  radius200: "4px",
  radius300: "8px",
  radius400: "12px",
  radius500: "16px",
  /** Datepicker (Range), Progress Bar, Slider, Tag */
  useRoundedCorners: !0,
  /** Button, ButtonGroup */
  buttonBorderRadiusMini: "4px",
  buttonBorderRadius: "8px",
  /** Checkbox */
  checkboxBorderRadius: "0px",
  /** Input, Select, Textarea */
  inputBorderRadiusMini: "4px",
  inputBorderRadius: "8px",
  /** Popover, Menu, Tooltip */
  popoverBorderRadius: "8px",
  /** Card, Datepicker, Modal, Toast, Notification */
  surfaceBorderRadius: "0px",
  /** Tag */
  tagBorderRadius: "24px"
}, lighting = {
  shadow400: "0 1px 4px hsla(0, 0%, 0%, 0.16)",
  shadow500: "0 2px 8px hsla(0, 0%, 0%, 0.16)",
  shadow600: "0 4px 16px hsla(0, 0%, 0%, 0.16)",
  shadow700: "0 8px 24px hsla(0, 0%, 0%, 0.16)",
  overlay0: "inset 0 0 0 1000px hsla(0, 0%, 0%, 0)",
  overlay100: "inset 0 0 0 1000px hsla(0, 0%, 0%, 0.04)",
  overlay200: "inset 0 0 0 1000px hsla(0, 0%, 0%, 0.08)",
  overlay300: "inset 0 0 0 1000px hsla(0, 0%, 0%, 0.12)",
  overlay400: "inset 0 0 0 1000px hsla(0, 0%, 0%, 0.16)",
  overlay500: "inset 0 0 0 1000px hsla(0, 0%, 0%, 0.2)",
  overlay600: "inset 0 0 0 1000px hsla(0, 0%, 0%, 0.24)",
  shallowAbove: "0px -4px 16px rgba(0, 0, 0, 0.12)",
  shallowBelow: "0px 4px 16px rgba(0, 0, 0, 0.12)",
  deepAbove: "0px -16px 48px rgba(0, 0, 0, 0.22)",
  deepBelow: "0px 16px 48px rgba(0, 0, 0, 0.22)"
};
function ownKeys$x(o, E) {
  var A = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var g = Object.getOwnPropertySymbols(o);
    E && (g = g.filter(function(e) {
      return Object.getOwnPropertyDescriptor(o, e).enumerable;
    })), A.push.apply(A, g);
  }
  return A;
}
function _objectSpread$v(o) {
  for (var E = 1; E < arguments.length; E++) {
    var A = arguments[E] != null ? arguments[E] : {};
    E % 2 ? ownKeys$x(Object(A), !0).forEach(function(g) {
      _defineProperty$E(o, g, A[g]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(A)) : ownKeys$x(Object(A)).forEach(function(g) {
      Object.defineProperty(o, g, Object.getOwnPropertyDescriptor(A, g));
    });
  }
  return o;
}
function _defineProperty$E(o, E, A) {
  return E in o ? Object.defineProperty(o, E, { value: A, enumerable: !0, configurable: !0, writable: !0 }) : o[E] = A, o;
}
var defaultFontTokens = {
  primaryFontFamily: 'system-ui, "Helvetica Neue", Helvetica, Arial, sans-serif'
}, monoFontFamily = '"Lucida Console", Monaco, monospace';
const getTypography = (function() {
  var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultFontTokens, E = {
    fontFamily: o.primaryFontFamily,
    fontSize: "12px",
    fontWeight: "normal",
    lineHeight: "20px"
  }, A = {
    fontFamily: o.primaryFontFamily,
    fontSize: "12px",
    fontWeight: 500,
    lineHeight: "16px"
  }, g = {
    fontFamily: o.primaryFontFamily,
    fontSize: "14px",
    fontWeight: "normal",
    lineHeight: "20px"
  }, e = {
    fontFamily: o.primaryFontFamily,
    fontSize: "14px",
    fontWeight: 500,
    lineHeight: "16px"
  }, t = {
    fontFamily: o.primaryFontFamily,
    fontSize: "16px",
    fontWeight: "normal",
    lineHeight: "24px"
  }, c = {
    fontFamily: o.primaryFontFamily,
    fontSize: "16px",
    fontWeight: 500,
    lineHeight: "20px"
  }, n = {
    fontFamily: o.primaryFontFamily,
    fontSize: "18px",
    fontWeight: "normal",
    lineHeight: "28px"
  }, h = {
    fontFamily: o.primaryFontFamily,
    fontSize: "18px",
    fontWeight: 500,
    lineHeight: "24px"
  }, d = {
    fontFamily: o.primaryFontFamily,
    fontSize: "20px",
    fontWeight: 700,
    lineHeight: "28px"
  }, k = {
    fontFamily: o.primaryFontFamily,
    fontSize: "24px",
    fontWeight: 700,
    lineHeight: "32px"
  }, p = {
    fontFamily: o.primaryFontFamily,
    fontSize: "28px",
    fontWeight: 700,
    lineHeight: "36px"
  }, M = {
    fontFamily: o.primaryFontFamily,
    fontSize: "32px",
    fontWeight: 700,
    lineHeight: "40px"
  }, S = {
    fontFamily: o.primaryFontFamily,
    fontSize: "36px",
    fontWeight: 700,
    lineHeight: "44px"
  }, AA = {
    fontFamily: o.primaryFontFamily,
    fontSize: "40px",
    fontWeight: 700,
    lineHeight: "52px"
  }, H = {
    fontFamily: o.primaryFontFamily,
    fontSize: "36px",
    fontWeight: 700,
    lineHeight: "44px"
  }, gA = {
    fontFamily: o.primaryFontFamily,
    fontSize: "44px",
    fontWeight: 700,
    lineHeight: "52px"
  }, CA = {
    fontFamily: o.primaryFontFamily,
    fontSize: "52px",
    fontWeight: 700,
    lineHeight: "64px"
  }, IA = {
    fontFamily: o.primaryFontFamily,
    fontSize: "96px",
    fontWeight: 700,
    lineHeight: "112px"
  };
  return {
    font100: E,
    font150: A,
    font200: g,
    font250: e,
    font300: t,
    font350: c,
    font400: n,
    font450: h,
    font550: d,
    font650: k,
    font750: p,
    font850: M,
    font950: S,
    font1050: AA,
    font1150: H,
    font1250: gA,
    font1350: CA,
    font1450: IA,
    ParagraphXSmall: E,
    ParagraphSmall: g,
    ParagraphMedium: t,
    ParagraphLarge: n,
    LabelXSmall: A,
    LabelSmall: e,
    LabelMedium: c,
    LabelLarge: h,
    HeadingXSmall: d,
    HeadingSmall: k,
    HeadingMedium: p,
    HeadingLarge: M,
    HeadingXLarge: S,
    HeadingXXLarge: AA,
    DisplayXSmall: H,
    DisplaySmall: gA,
    DisplayMedium: CA,
    DisplayLarge: IA,
    MonoParagraphXSmall: _objectSpread$v(_objectSpread$v({}, E), {}, {
      fontFamily: monoFontFamily
    }),
    MonoParagraphSmall: _objectSpread$v(_objectSpread$v({}, g), {}, {
      fontFamily: monoFontFamily
    }),
    MonoParagraphMedium: _objectSpread$v(_objectSpread$v({}, t), {}, {
      fontFamily: monoFontFamily
    }),
    MonoParagraphLarge: _objectSpread$v(_objectSpread$v({}, n), {}, {
      fontFamily: monoFontFamily
    }),
    MonoLabelXSmall: _objectSpread$v(_objectSpread$v({}, A), {}, {
      fontFamily: monoFontFamily
    }),
    MonoLabelSmall: _objectSpread$v(_objectSpread$v({}, e), {}, {
      fontFamily: monoFontFamily
    }),
    MonoLabelMedium: _objectSpread$v(_objectSpread$v({}, c), {}, {
      fontFamily: monoFontFamily
    }),
    MonoLabelLarge: _objectSpread$v(_objectSpread$v({}, h), {}, {
      fontFamily: monoFontFamily
    }),
    MonoHeadingXSmall: _objectSpread$v(_objectSpread$v({}, d), {}, {
      fontFamily: monoFontFamily
    }),
    MonoHeadingSmall: _objectSpread$v(_objectSpread$v({}, k), {}, {
      fontFamily: monoFontFamily
    }),
    MonoHeadingMedium: _objectSpread$v(_objectSpread$v({}, p), {}, {
      fontFamily: monoFontFamily
    }),
    MonoHeadingLarge: _objectSpread$v(_objectSpread$v({}, M), {}, {
      fontFamily: monoFontFamily
    }),
    MonoHeadingXLarge: _objectSpread$v(_objectSpread$v({}, S), {}, {
      fontFamily: monoFontFamily
    }),
    MonoHeadingXXLarge: _objectSpread$v(_objectSpread$v({}, AA), {}, {
      fontFamily: monoFontFamily
    }),
    MonoDisplayXSmall: _objectSpread$v(_objectSpread$v({}, H), {}, {
      fontFamily: monoFontFamily
    }),
    MonoDisplaySmall: _objectSpread$v(_objectSpread$v({}, gA), {}, {
      fontFamily: monoFontFamily
    }),
    MonoDisplayMedium: _objectSpread$v(_objectSpread$v({}, CA), {}, {
      fontFamily: monoFontFamily
    }),
    MonoDisplayLarge: _objectSpread$v(_objectSpread$v({}, IA), {}, {
      fontFamily: monoFontFamily
    })
  };
});
var animation = {
  timing100: "100ms",
  timing200: "200ms",
  timing300: "300ms",
  timing400: "400ms",
  timing500: "500ms",
  timing600: "600ms",
  timing700: "700ms",
  timing800: "800ms",
  timing900: "900ms",
  timing1000: "1000ms",
  easeInCurve: "cubic-bezier(.8, .2, .6, 1)",
  easeOutCurve: "cubic-bezier(.2, .8, .4, 1)",
  easeInOutCurve: "cubic-bezier(0.4, 0, 0.2, 1)",
  easeInQuinticCurve: "cubic-bezier(0.755, 0.05, 0.855, 0.06)",
  easeOutQuinticCurve: "cubic-bezier(0.23, 1, 0.32, 1)",
  easeInOutQuinticCurve: "cubic-bezier(0.86, 0, 0.07, 1)",
  linearCurve: "cubic-bezier(0, 0, 1, 1)"
}, breakpoints$1 = {
  small: 320,
  medium: 600,
  large: 1136
}, grid$1 = {
  columns: [4, 8, 12],
  gutters: [16, 36, 36],
  margins: [16, 36, 64],
  gaps: 0,
  unit: "px",
  maxWidth: 1280
}, getMediaQuery = function o(E) {
  return "@media screen and (min-width: ".concat(E, "px)");
}, mediaQuery = {
  small: getMediaQuery(breakpoints$1.small),
  medium: getMediaQuery(breakpoints$1.medium),
  large: getMediaQuery(breakpoints$1.large)
}, sizing$1 = {
  scale0: "2px",
  scale100: "4px",
  scale200: "6px",
  scale300: "8px",
  scale400: "10px",
  scale500: "12px",
  scale550: "14px",
  scale600: "16px",
  scale650: "18px",
  scale700: "20px",
  scale750: "22px",
  scale800: "24px",
  scale850: "28px",
  scale900: "32px",
  scale950: "36px",
  scale1000: "40px",
  scale1200: "48px",
  scale1400: "56px",
  scale1600: "64px",
  scale2400: "96px",
  scale3200: "128px",
  scale4800: "192px"
};
function ownKeys$w(o, E) {
  var A = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var g = Object.getOwnPropertySymbols(o);
    E && (g = g.filter(function(e) {
      return Object.getOwnPropertyDescriptor(o, e).enumerable;
    })), A.push.apply(A, g);
  }
  return A;
}
function _objectSpread$u(o) {
  for (var E = 1; E < arguments.length; E++) {
    var A = arguments[E] != null ? arguments[E] : {};
    E % 2 ? ownKeys$w(Object(A), !0).forEach(function(g) {
      _defineProperty$D(o, g, A[g]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(A)) : ownKeys$w(Object(A)).forEach(function(g) {
      Object.defineProperty(o, g, Object.getOwnPropertyDescriptor(A, g));
    });
  }
  return o;
}
function _defineProperty$D(o, E, A) {
  return E in o ? Object.defineProperty(o, E, { value: A, enumerable: !0, configurable: !0, writable: !0 }) : o[E] = A, o;
}
var LightTheme = {
  name: "light-theme",
  colors: _objectSpread$u(_objectSpread$u(_objectSpread$u({}, lightColorTokens), getComponentColorTokens()), getSemanticColorTokens()),
  animation,
  breakpoints: breakpoints$1,
  borders,
  direction: "auto",
  grid: grid$1,
  lighting,
  mediaQuery,
  sizing: sizing$1,
  typography: getTypography(),
  // TODO(#2318) Remove it in the next v11 major version.
  // Do not use.
  zIndex: {
    modal: 2e3
  }
};
function _typeof$l(o) {
  "@babel/helpers - typeof";
  return _typeof$l = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(E) {
    return typeof E;
  } : function(E) {
    return E && typeof Symbol == "function" && E.constructor === Symbol && E !== Symbol.prototype ? "symbol" : typeof E;
  }, _typeof$l(o);
}
function deepMerge$1(o) {
  o = o || {};
  for (var E = arguments.length <= 1 ? 0 : arguments.length - 1, A, g, e = 0; e < E; e++) {
    A = (e + 1 < 1 || arguments.length <= e + 1 ? void 0 : arguments[e + 1]) || {};
    for (var t in A)
      _typeof$l(A[t]) !== void 0 && (g = A[t], isCloneable(g) ? o[t] = deepMerge$1(
        /* eslint-disable-next-line no-mixed-operators */
        o[t] || Array.isArray(g) && [] || {},
        g
      ) : o[t] = g);
  }
  return o;
}
function isCloneable(o) {
  return Array.isArray(o) || {}.toString.call(o) == "[object Object]";
}
var darkColorTokens = {
  // Primary Palette
  primaryA: colors$1.gray200,
  primaryB: colors$1.gray900,
  primary: colors$1.white,
  primary50: colors$1.gray50,
  primary100: colors$1.gray100,
  primary200: colors$1.gray200,
  primary300: colors$1.gray300,
  primary400: colors$1.gray400,
  primary500: colors$1.gray500,
  primary600: colors$1.gray600,
  primary700: colors$1.gray700,
  // Accent Palette
  accent: colors$1.blue400,
  accent50: colors$1.blue50,
  accent100: colors$1.blue100,
  accent200: colors$1.blue200,
  accent300: colors$1.blue300,
  accent400: colors$1.blue400,
  accent500: colors$1.blue500,
  accent600: colors$1.blue600,
  accent700: colors$1.blue700,
  // Negative Palette
  negative: colors$1.red500,
  negative50: colors$1.red50,
  negative100: colors$1.red100,
  negative200: colors$1.red200,
  negative300: colors$1.red300,
  negative400: colors$1.red400,
  negative500: colors$1.red500,
  negative600: colors$1.red600,
  negative700: colors$1.red700,
  // Warning Palette
  warning: colors$1.yellow500,
  warning50: colors$1.yellow50,
  warning100: colors$1.yellow100,
  warning200: colors$1.yellow200,
  warning300: colors$1.yellow300,
  warning400: colors$1.yellow400,
  warning500: colors$1.yellow500,
  warning600: colors$1.yellow600,
  warning700: colors$1.yellow700,
  // Positive Palette
  positive: colors$1.green400,
  positive50: colors$1.green50,
  positive100: colors$1.green100,
  positive200: colors$1.green200,
  positive300: colors$1.green300,
  positive400: colors$1.green400,
  positive500: colors$1.green500,
  positive600: colors$1.green600,
  positive700: colors$1.green700,
  // Monochrome Palette
  white: colors$1.white,
  black: colors$1.black,
  mono100: colors$1.gray300,
  mono200: colors$1.gray400,
  mono300: colors$1.gray500,
  mono400: colors$1.gray600,
  mono500: colors$1.gray700,
  // mono600 and mono900 are not in official brand tokens atm
  mono600: "#292929",
  mono700: "#1F1F1F",
  mono800: "#141414",
  mono900: "#111111",
  mono1000: colors$1.black,
  // Rating Palette,
  ratingInactiveFill: colors$1.gray500,
  ratingStroke: colors$1.gray700
}, _excluded$q = ["primaryFontFamily"];
function ownKeys$v(o, E) {
  var A = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var g = Object.getOwnPropertySymbols(o);
    E && (g = g.filter(function(e) {
      return Object.getOwnPropertyDescriptor(o, e).enumerable;
    })), A.push.apply(A, g);
  }
  return A;
}
function _objectSpread$t(o) {
  for (var E = 1; E < arguments.length; E++) {
    var A = arguments[E] != null ? arguments[E] : {};
    E % 2 ? ownKeys$v(Object(A), !0).forEach(function(g) {
      _defineProperty$C(o, g, A[g]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(A)) : ownKeys$v(Object(A)).forEach(function(g) {
      Object.defineProperty(o, g, Object.getOwnPropertyDescriptor(A, g));
    });
  }
  return o;
}
function _defineProperty$C(o, E, A) {
  return E in o ? Object.defineProperty(o, E, { value: A, enumerable: !0, configurable: !0, writable: !0 }) : o[E] = A, o;
}
function _objectWithoutProperties$s(o, E) {
  if (o == null) return {};
  var A = _objectWithoutPropertiesLoose$s(o, E), g, e;
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    for (e = 0; e < t.length; e++)
      g = t[e], !(E.indexOf(g) >= 0) && Object.prototype.propertyIsEnumerable.call(o, g) && (A[g] = o[g]);
  }
  return A;
}
function _objectWithoutPropertiesLoose$s(o, E) {
  if (o == null) return {};
  var A = {}, g = Object.keys(o), e, t;
  for (t = 0; t < g.length; t++)
    e = g[t], !(E.indexOf(e) >= 0) && (A[e] = o[e]);
  return A;
}
function createLightTheme() {
  var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, E = arguments.length > 1 ? arguments[1] : void 0, A = o.primaryFontFamily, g = _objectWithoutProperties$s(o, _excluded$q), e = _objectSpread$t(_objectSpread$t({}, lightColorTokens), g), t = {
    animation,
    borders,
    breakpoints: breakpoints$1,
    colors: _objectSpread$t(_objectSpread$t(_objectSpread$t({}, e), getComponentColorTokens(e)), getSemanticColorTokens(e)),
    direction: "auto",
    grid: grid$1,
    lighting,
    mediaQuery,
    sizing: sizing$1,
    // If primaryFontFamily is not provided, we use our default font tokens
    typography: A ? getTypography({
      primaryFontFamily: A
    }) : getTypography(),
    // TODO(#2318) Remove in v11, the next major version.
    // Do not use.
    zIndex: {
      modal: 2e3
    }
  };
  return deepMerge$1(t, E);
}
function ownKeys$u(o, E) {
  var A = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var g = Object.getOwnPropertySymbols(o);
    E && (g = g.filter(function(e) {
      return Object.getOwnPropertyDescriptor(o, e).enumerable;
    })), A.push.apply(A, g);
  }
  return A;
}
function _objectSpread$s(o) {
  for (var E = 1; E < arguments.length; E++) {
    var A = arguments[E] != null ? arguments[E] : {};
    E % 2 ? ownKeys$u(Object(A), !0).forEach(function(g) {
      _defineProperty$B(o, g, A[g]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(A)) : ownKeys$u(Object(A)).forEach(function(g) {
      Object.defineProperty(o, g, Object.getOwnPropertyDescriptor(A, g));
    });
  }
  return o;
}
function _defineProperty$B(o, E, A) {
  return E in o ? Object.defineProperty(o, E, { value: A, enumerable: !0, configurable: !0, writable: !0 }) : o[E] = A, o;
}
var primitives$1 = _objectSpread$s(_objectSpread$s({}, darkColorTokens), defaultFontTokens);
function ownKeys$t(o, E) {
  var A = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var g = Object.getOwnPropertySymbols(o);
    E && (g = g.filter(function(e) {
      return Object.getOwnPropertyDescriptor(o, e).enumerable;
    })), A.push.apply(A, g);
  }
  return A;
}
function _objectSpread$r(o) {
  for (var E = 1; E < arguments.length; E++) {
    var A = arguments[E] != null ? arguments[E] : {};
    E % 2 ? ownKeys$t(Object(A), !0).forEach(function(g) {
      _defineProperty$A(o, g, A[g]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(A)) : ownKeys$t(Object(A)).forEach(function(g) {
      Object.defineProperty(o, g, Object.getOwnPropertyDescriptor(A, g));
    });
  }
  return o;
}
function _defineProperty$A(o, E, A) {
  return E in o ? Object.defineProperty(o, E, { value: A, enumerable: !0, configurable: !0, writable: !0 }) : o[E] = A, o;
}
var primitives = _objectSpread$r(_objectSpread$r({}, lightColorTokens), defaultFontTokens), ThemeContext$1 = /* @__PURE__ */ React.createContext(LightTheme), ThemeProvider$1 = function o(E) {
  var A = E.theme, g = E.children;
  return /* @__PURE__ */ React.createElement(ThemeContext$1.Provider, {
    value: A
  }, g);
};
function driver(o, E) {
  const A = renderDeclarativeRules(o, E);
  return E.renderStyle(A);
}
function getInitialStyle() {
  return {};
}
function renderDeclarativeRules(o, E) {
  for (const A in o) {
    const g = o[A];
    if (A === "animationName" && typeof g != "string") {
      o.animationName = E.renderKeyframes(g);
      continue;
    }
    if (A === "fontFamily" && typeof g != "string")
      if (Array.isArray(g)) {
        let e = "";
        for (const t of g)
          typeof t == "object" ? e += `${E.renderFontFace(t)},` : typeof t == "string" && (e += `${t},`);
        o.fontFamily = e.slice(0, -1);
        continue;
      } else {
        if (g === void 0)
          continue;
        o.fontFamily = E.renderFontFace(g);
        continue;
      }
    typeof g == "object" && g !== null && renderDeclarativeRules(g, E);
  }
  return o;
}
function addDebugMetadata(o, E) {
  const {
    stack: A,
    stacktrace: g,
    message: e
  } = new Error("stacktrace source");
  o.debug = {
    stackInfo: {
      stack: A,
      stacktrace: g,
      message: e
    },
    stackIndex: E
  };
}
const setupDevtoolsExtension = () => {
  const o = {}, E = /* @__PURE__ */ new Map(), A = /* @__PURE__ */ new Map(), g = (e) => {
    const t = {};
    if (typeof e != "string")
      return t;
    if (A.has(e)) {
      t.styles = A.get(e);
      const c = e.split(" ");
      if (c.length) {
        const n = {};
        c.forEach((h) => {
          n[h] = o[h];
        }), t.classes = n;
      }
      if (E.has(e)) {
        const n = E.get(e);
        t.extends = n;
      }
      return t;
    }
  };
  window.__STYLETRON_DEVTOOLS__ = {
    atomicMap: o,
    extensionsMap: E,
    stylesMap: A,
    getStyles: g
  };
};
function _extends$B() {
  return _extends$B = Object.assign ? Object.assign.bind() : function(o) {
    for (var E = 1; E < arguments.length; E++) {
      var A = arguments[E];
      for (var g in A)
        Object.prototype.hasOwnProperty.call(A, g) && (o[g] = A[g]);
    }
    return o;
  }, _extends$B.apply(this, arguments);
}
const noopEngine = {
  renderStyle: () => "",
  renderKeyframes: () => "",
  renderFontFace: () => ""
}, StyletronContext = /* @__PURE__ */ React.createContext(noopEngine), HydrationContext = /* @__PURE__ */ React.createContext(!1), DebugEngineContext = /* @__PURE__ */ React.createContext(void 0);
class DevProvider extends React.Component {
  constructor(E) {
    super(E), this.state = {
      hydrating: !!E.debugAfterHydration
    };
  }
  componentDidMount() {
    this.state.hydrating === !0 && this.setState({
      hydrating: !1
    });
  }
  render() {
    return /* @__PURE__ */ React.createElement(StyletronContext.Provider, {
      value: this.props.value
    }, /* @__PURE__ */ React.createElement(DebugEngineContext.Provider, {
      value: this.props.debug
    }, /* @__PURE__ */ React.createElement(HydrationContext.Provider, {
      value: this.state.hydrating
    }, this.props.children)));
  }
}
const Provider$1 = process.env.NODE_ENV !== "production" ? DevProvider : StyletronContext.Provider;
process.env.NODE_ENV !== "production" && !window.__STYLETRON_DEVTOOLS__ && setupDevtoolsExtension();
function checkNoopEngine(o) {
  process.env.NODE_ENV !== "test" && o === noopEngine && // eslint-disable-next-line no-console
  console.warn(process.env.NODE_ENV !== "production" ? `
Styletron has been switched to a no-op (test) mode.

A Styletron styled component was rendered, but no Styletron engine instance was provided in React context.

Did you forget to provide a Styletron engine instance to React context via using the Styletron provider component?

Note: Providers and Consumers must come from the exact same React.createContext call to work.
If your app has multiple instances of the "styletron-react" package in your node_module tree,
your Provider may be coming from a different React.createContext call, which means the styled components
will not recieve the provided engine instance. This scenario can arise, for example, when using "npm link".
` : "Styletron Provider is not set up. Defaulting to no-op.");
}
function useStyletron$1() {
  const o = React.useContext(StyletronContext), E = React.useContext(DebugEngineContext), A = React.useContext(HydrationContext);
  checkNoopEngine(o);
  const g = React.useRef(""), e = React.useRef([]);
  return [function(c) {
    const n = driver(c, o);
    if (process.env.NODE_ENV === "production")
      return n;
    const {
      stack: h,
      message: d
    } = new Error("stacktrace source"), k = [E, A];
    return (e.current[0] !== k[0] || e.current[1] !== k[1]) && (E && !A && (g.current = E.debug({
      stackInfo: {
        stack: h,
        message: d
      },
      stackIndex: 1
    })), e.current = k), g.current ? `${g.current} ${n}` : n;
  }];
}
function createStyled$1({
  getInitialStyle: o,
  driver: E,
  wrapper: A
}) {
  function g(e, t) {
    process.env.NODE_ENV !== "production" && e.__STYLETRON__ && (console.warn("It appears you are passing a styled component into `styled`."), console.warn("For composition with existing styled components, use `withStyle` or `withTransform` instead."));
    const c = {
      reducers: [],
      base: e,
      driver: E,
      getInitialStyle: o,
      wrapper: A
    };
    return process.env.NODE_ENV !== "production" && addDebugMetadata(c, 2), createStyledElementComponent(autoComposeShallow(c, t));
  }
  return g;
}
const withStyleDeep = (o, E) => {
  const A = o.__STYLETRON__;
  return process.env.NODE_ENV !== "production" && (A || console.warn("The first parameter to `withStyle` must be a styled component (without extra wrappers).")), process.env.NODE_ENV !== "production" ? (addDebugMetadata(A, 2), createStyledElementComponent(addExtension(autoComposeDeep(A, E), o, E))) : createStyledElementComponent(autoComposeDeep(A, E));
}, withStyle$1 = withStyleDeep, withWrapper$1 = (o, E) => {
  const A = o.__STYLETRON__;
  process.env.NODE_ENV !== "production" && (A || console.warn("The first parameter to `withWrapper` must be a styled component (without extra wrappers)."));
  const g = {
    getInitialStyle: A.getInitialStyle,
    base: A.base,
    driver: A.driver,
    wrapper: E,
    reducers: A.reducers
  };
  return process.env.NODE_ENV !== "production" && addDebugMetadata(g, 2), createStyledElementComponent(g);
};
function autoComposeShallow(o, E) {
  return typeof E == "function" ? dynamicComposeShallow(o, E) : staticComposeShallow(o, E);
}
function addExtension(o, E, A) {
  return {
    ...o,
    ext: {
      with: A,
      name: E.displayName,
      base: E.__STYLETRON__.base,
      getInitialStyle: E.__STYLETRON__.reducers.length ? E.__STYLETRON__.reducers[0].reducer : E.__STYLETRON__.getInitialStyle
    }
  };
}
function autoComposeDeep(o, E) {
  return typeof E == "function" ? dynamicComposeDeep(o, E) : staticComposeDeep(o, E);
}
function staticComposeShallow(o, E) {
  return composeStatic(o, createShallowMergeReducer(E));
}
function staticComposeDeep(o, E) {
  return composeStatic(o, createDeepMergeReducer(E));
}
function dynamicComposeShallow(o, E) {
  return composeDynamic(o, (A, g) => shallowMerge(A, E(g)));
}
function dynamicComposeDeep(o, E) {
  return composeDynamic(o, (A, g) => deepMerge(A, E(g)));
}
function createShallowMergeReducer(o) {
  return {
    reducer: (E) => shallowMerge(E, o),
    assignmentCommutative: !0,
    factory: createShallowMergeReducer,
    style: o
  };
}
function createDeepMergeReducer(o) {
  return {
    reducer: (E) => deepMerge(E, o),
    assignmentCommutative: !0,
    factory: createDeepMergeReducer,
    style: o
  };
}
function composeStatic(o, E) {
  if (o.reducers.length === 0) {
    const A = E.reducer(o.getInitialStyle()), g = {
      reducers: o.reducers,
      base: o.base,
      driver: o.driver,
      wrapper: o.wrapper,
      getInitialStyle: () => A
    };
    return process.env.NODE_ENV !== "production" && (g.debug = o.debug), g;
  } else {
    const A = o.reducers[0];
    if (A.assignmentCommutative === !0 && E.assignmentCommutative === !0) {
      const g = E.reducer(A.style), e = {
        getInitialStyle: o.getInitialStyle,
        base: o.base,
        driver: o.driver,
        wrapper: o.wrapper,
        reducers: [A.factory(g)].concat(o.reducers.slice(1))
      };
      return process.env.NODE_ENV !== "production" && (e.debug = o.debug), e;
    }
    return composeDynamic(o, E.reducer);
  }
}
function composeDynamic(o, E) {
  const A = {
    getInitialStyle: o.getInitialStyle,
    base: o.base,
    driver: o.driver,
    wrapper: o.wrapper,
    // @ts-ignore
    reducers: [{
      assignmentCommutative: !1,
      reducer: E
    }].concat(o.reducers)
  };
  return process.env.NODE_ENV !== "production" && (A.debug = o.debug), A;
}
function createStyledElementComponent(o) {
  const {
    reducers: E,
    base: A,
    driver: g,
    wrapper: e,
    getInitialStyle: t,
    ext: c
  } = o;
  if (process.env.NODE_ENV !== "production") {
    var n, h;
    o.debug && (n = o.debug.stackInfo, h = o.debug.stackIndex);
  }
  if (process.env.NODE_ENV !== "production")
    var d;
  const p = e(/* @__PURE__ */ React.forwardRef((M, S) => {
    const AA = React.useContext(StyletronContext), H = React.useContext(DebugEngineContext), gA = React.useContext(HydrationContext);
    checkNoopEngine(AA);
    const CA = omitPrefixedKeys(M);
    let IA = resolveStyle(t, E, M);
    M.$style && (typeof M.$style == "function" ? IA = deepMerge(IA, M.$style(M)) : IA = deepMerge(IA, M.$style));
    const BA = g(IA, AA), QA = M.$as ? M.$as : A;
    if (CA.className = M.className ? `${M.className} ${BA}` : BA, process.env.NODE_ENV !== "production" && H && !gA) {
      d || (d = H.debug({
        stackInfo: n,
        stackIndex: h
      }));
      const EA = `${d} ${CA.className}`;
      CA.className = EA;
    }
    return process.env.NODE_ENV !== "production" && window.__STYLETRON_DEVTOOLS__ && (window.__STYLETRON_DEVTOOLS__.stylesMap.set(CA.className, IA), c && window.__STYLETRON_DEVTOOLS__.extensionsMap.set(CA.className, {
      base: c.base,
      displayName: c.name,
      initialStyles: c.getInitialStyle({}, M),
      styleOverrides: typeof c.with == "function" ? c.with(M) : c.with
    })), M.$ref && console.warn("The prop `$ref` has been deprecated. Use `ref` instead. Refs are now forwarded with React.forwardRef."), /* @__PURE__ */ React.createElement(QA, _extends$B({}, CA, {
      ref: S || M.$ref
    }));
  }));
  if (p.__STYLETRON__ = {
    base: A,
    reducers: E,
    driver: g,
    wrapper: e,
    getInitialStyle: t
  }, process.env.NODE_ENV !== "production") {
    let M;
    typeof A == "string" ? M = A : A.displayName ? M = A.displayName : A.name ? M = A.name : M = "Unknown", p.displayName = `Styled(${M})`;
  }
  return p;
}
function resolveStyle(o, E, A) {
  let g = o(), e = E.length;
  for (; e--; ) {
    const t = E[e].reducer;
    g = t(g, A);
  }
  return g;
}
function isObject$1(o) {
  return typeof o == "object" && o !== null;
}
function omitPrefixedKeys(o) {
  const E = {};
  for (const A in o)
    A[0] !== "$" && (E[A] = o[A]);
  return E;
}
function deepMerge(o, E) {
  const A = assign({}, o);
  for (const g in E) {
    const e = E[g];
    isObject$1(e) && isObject$1(o[g]) ? A[g] = deepMerge(o[g], e) : A[g] = e;
  }
  return A;
}
function shallowMerge(o, E) {
  return assign(assign({}, o), E);
}
function assign(o, E) {
  for (const A in E)
    o[A] = E[A];
  return o;
}
function ownKeys$s(o, E) {
  var A = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var g = Object.getOwnPropertySymbols(o);
    E && (g = g.filter(function(e) {
      return Object.getOwnPropertyDescriptor(o, e).enumerable;
    })), A.push.apply(A, g);
  }
  return A;
}
function _objectSpread$q(o) {
  for (var E = 1; E < arguments.length; E++) {
    var A = arguments[E] != null ? arguments[E] : {};
    E % 2 ? ownKeys$s(Object(A), !0).forEach(function(g) {
      _defineProperty$z(o, g, A[g]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(A)) : ownKeys$s(Object(A)).forEach(function(g) {
      Object.defineProperty(o, g, Object.getOwnPropertyDescriptor(A, g));
    });
  }
  return o;
}
function _defineProperty$z(o, E, A) {
  return E in o ? Object.defineProperty(o, E, { value: A, enumerable: !0, configurable: !0, writable: !0 }) : o[E] = A, o;
}
function _slicedToArray$n(o, E) {
  return _arrayWithHoles$m(o) || _iterableToArrayLimit$m(o, E) || _unsupportedIterableToArray$m(o, E) || _nonIterableRest$m();
}
function _nonIterableRest$m() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$m(o, E) {
  if (o) {
    if (typeof o == "string") return _arrayLikeToArray$m(o, E);
    var A = Object.prototype.toString.call(o).slice(8, -1);
    if (A === "Object" && o.constructor && (A = o.constructor.name), A === "Map" || A === "Set") return Array.from(o);
    if (A === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(A)) return _arrayLikeToArray$m(o, E);
  }
}
function _arrayLikeToArray$m(o, E) {
  (E == null || E > o.length) && (E = o.length);
  for (var A = 0, g = new Array(E); A < E; A++)
    g[A] = o[A];
  return g;
}
function _iterableToArrayLimit$m(o, E) {
  var A = o == null ? null : typeof Symbol < "u" && o[Symbol.iterator] || o["@@iterator"];
  if (A != null) {
    var g = [], e = !0, t = !1, c, n;
    try {
      for (A = A.call(o); !(e = (c = A.next()).done) && (g.push(c.value), !(E && g.length === E)); e = !0)
        ;
    } catch (h) {
      t = !0, n = h;
    } finally {
      try {
        !e && A.return != null && A.return();
      } finally {
        if (t) throw n;
      }
    }
    return g;
  }
}
function _arrayWithHoles$m(o) {
  if (Array.isArray(o)) return o;
}
function _extends$A() {
  return _extends$A = Object.assign ? Object.assign.bind() : function(o) {
    for (var E = 1; E < arguments.length; E++) {
      var A = arguments[E];
      for (var g in A)
        Object.prototype.hasOwnProperty.call(A, g) && (o[g] = A[g]);
    }
    return o;
  }, _extends$A.apply(this, arguments);
}
var wrapper = function o(E) {
  return /* @__PURE__ */ React.forwardRef(function(A, g) {
    return /* @__PURE__ */ React.createElement(ThemeContext$1.Consumer, null, function(e) {
      return /* @__PURE__ */ React.createElement(E, _extends$A({
        ref: g
      }, A, {
        $theme: e
      }));
    });
  });
};
function createThemedStyled() {
  return createStyled$1({
    wrapper,
    getInitialStyle,
    driver
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  });
}
var styled = createThemedStyled();
function createThemedWithStyle() {
  return withStyle$1;
}
var withStyle = createThemedWithStyle();
function createThemedUseStyletron() {
  return function() {
    var o = React.useContext(ThemeContext$1), E = useStyletron$1(), A = _slicedToArray$n(E, 1), g = A[0];
    return [g, o];
  };
}
var useStyletron = createThemedUseStyletron();
function withWrapper(o, E) {
  return withWrapper$1(o, function(A) {
    return /* @__PURE__ */ React.forwardRef(function(g, e) {
      return /* @__PURE__ */ React.createElement(ThemeContext$1.Consumer, null, function(t) {
        return (
          // @ts-ignore
          E(A)(_objectSpread$q(_objectSpread$q({
            ref: e
          }, g), {}, {
            $theme: t
          }))
        );
      });
    });
  });
}
var locale$b = {
  collapse: "Collapse",
  expand: "Expand"
}, locale$a = {
  ariaLabel: "Breadcrumbs navigation"
}, locale$9 = {
  ariaLabel: "Select a date.",
  ariaLabelRange: "Select a date range.",
  ariaLabelCalendar: "Calendar.",
  ariaRoleDescriptionCalendarMonth: "Calendar month",
  previousMonth: "Previous month.",
  nextMonth: "Next month.",
  pastWeek: "Past Week",
  pastMonth: "Past Month",
  pastThreeMonths: "Past 3 Months",
  pastSixMonths: "Past 6 Months",
  pastYear: "Past Year",
  pastTwoYears: "Past 2 Years",
  screenReaderMessageInput: "Press the down arrow key to interact with the calendar and select a date. Press the escape button to close the calendar.",
  selectedDate: "Selected date is ${date}.",
  selectedDateRange: "Selected date range is from ${startDate} to ${endDate}.",
  selectSecondDatePrompt: "Select the second date.",
  quickSelectLabel: "Choose a date range",
  quickSelectAriaLabel: "Choose a date range",
  quickSelectPlaceholder: "None",
  timeSelectEndLabel: "End time",
  timeSelectStartLabel: "Start time",
  timePickerAriaLabel12Hour: "Select a time, 12-hour format.",
  timePickerAriaLabel24Hour: "Select a time, 24-hour format.",
  timezonePickerAriaLabel: "Select a timezone.",
  selectedStartDateLabel: "Selected start date.",
  selectedEndDateLabel: "Selected end date.",
  dateNotAvailableLabel: "Not available.",
  dateAvailableLabel: "It's available.",
  selectedLabel: "Selected.",
  chooseLabel: "Choose"
}, locale$8 = {
  emptyState: "No rows match the filter criteria defined. Please remove one or more filters to view more data.",
  loadingState: "Loading rows.",
  searchAriaLabel: "Search by text",
  filterAdd: "Add Filter",
  filterExclude: "Exclude",
  filterApply: "Apply",
  filterExcludeRange: "Exclude range",
  filterExcludeValue: "Exclude value",
  filterAppliedTo: "filter applied to",
  optionsLabel: "Select column to filter by",
  optionsSearch: "Search for a column to filter by...",
  optionsEmpty: "No columns available.",
  categoricalFilterSelectAll: "Select All",
  categoricalFilterSelectClear: "Clear",
  categoricalFilterEmpty: "No categories found",
  datetimeFilterRange: "Range",
  datetimeFilterRangeDatetime: "Date, Time",
  datetimeFilterRangeDate: "Date",
  datetimeFilterRangeTime: "Time",
  datetimeFilterCategorical: "Categorical",
  datetimeFilterCategoricalWeekday: "Weekday",
  datetimeFilterCategoricalMonth: "Month",
  datetimeFilterCategoricalQuarter: "Quarter",
  datetimeFilterCategoricalHalf: "Half",
  datetimeFilterCategoricalFirstHalf: "H1",
  datetimeFilterCategoricalSecondHalf: "H2",
  datetimeFilterCategoricalYear: "Year",
  numericalFilterRange: "Range",
  numericalFilterSingleValue: "Single Value",
  booleanFilterTrue: "true",
  booleanFilterFalse: "false",
  booleanColumnTrueShort: "T",
  booleanColumnFalseShort: "F",
  selectRow: "Select row",
  selectAllRows: "Select all rows"
}, locale$7 = {
  ariaLabel: "button group"
}, locale$6 = {
  dropFilesToUpload: "Drop files here to upload...",
  or: "",
  browseFiles: "Browse files",
  retry: "Retry Upload",
  cancel: "Cancel"
}, locale$5 = {
  noResultsMsg: "No results",
  parentMenuItemAriaLabel: "You are currently at an item that opens a nested listbox. Press right arrow to enter that element and left arrow to return."
}, locale$4 = {
  close: "Close"
}, locale$3 = {
  close: "Close"
}, locale$2 = {
  prev: "Prev",
  next: "Next",
  preposition: "of"
}, locale$1 = {
  // Remove noResultsMsg prop in the next major version
  noResultsMsg: "No results found",
  placeholder: "Select...",
  create: "Create"
}, locale = {
  close: "Close"
}, en_US = {
  accordion: locale$b,
  breadcrumbs: locale$a,
  datepicker: locale$9,
  datatable: locale$8,
  buttongroup: locale$7,
  fileuploader: locale$6,
  menu: locale$5,
  modal: locale$4,
  drawer: locale$3,
  pagination: locale$2,
  select: locale$1,
  toast: locale
}, LocaleContext = /* @__PURE__ */ React.createContext(en_US), generateUID$1 = function() {
  var o = 1, E = /* @__PURE__ */ new WeakMap(), A = function(g, e) {
    return typeof g == "number" || typeof g == "string" ? e ? "idx-".concat(e) : "val-".concat(g) : E.has(g) ? "uid" + E.get(g) : (E.set(g, o++), A(g));
  };
  return A;
}, createSource = function(o) {
  return o === void 0 && (o = ""), {
    value: 1,
    prefix: o,
    uid: generateUID$1()
  };
}, counter = createSource(), source = React.createContext(createSource()), getId = function(o) {
  return o.value++;
}, getPrefix = function(o) {
  return o ? o.prefix : "";
}, __extends$1 = /* @__PURE__ */ (function() {
  var o = function(E, A) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(g, e) {
      g.__proto__ = e;
    } || function(g, e) {
      for (var t in e) Object.prototype.hasOwnProperty.call(e, t) && (g[t] = e[t]);
    }, o(E, A);
  };
  return function(E, A) {
    if (typeof A != "function" && A !== null)
      throw new TypeError("Class extends value " + String(A) + " is not a constructor or null");
    o(E, A);
    function g() {
      this.constructor = E;
    }
    E.prototype = A === null ? Object.create(A) : (g.prototype = A.prototype, new g());
  };
})(), prefixId = function(o, E, A) {
  var g = E + o;
  return String(A ? A(g) : g);
}, UID = (
  /** @class */
  (function(o) {
    __extends$1(E, o);
    function E() {
      var A = o !== null && o.apply(this, arguments) || this;
      return A.state = {
        quartz: A.props.idSource || counter,
        prefix: getPrefix(A.props.idSource),
        id: getId(A.props.idSource || counter)
      }, A.uid = function(g) {
        return prefixId(A.state.id + "-" + A.state.quartz.uid(g), A.state.prefix, A.props.name);
      }, A;
    }
    return E.prototype.render = function() {
      var A = this.props, g = A.children, e = A.name, t = this.state, c = t.id, n = t.prefix;
      return g(prefixId(c, n, e), this.uid);
    }, E;
  })(React.Component)
), generateUID = function(o) {
  var E = o || counter, A = getPrefix(E), g = getId(E), e = A + g, t = function(c) {
    return e + E.uid(c);
  };
  return { uid: e, gen: t };
}, useUIDState = function() {
  if (process.env.NODE_ENV !== "production" && !("useContext" in React))
    throw new Error("Hooks API requires React 16.8+");
  var o = useContext(source), E = useState(function() {
    return generateUID(o);
  })[0];
  return E;
}, useUID = function() {
  var o = useUIDState().uid;
  return o;
}, useUIDSeed = function() {
  var o = useUIDState().gen;
  return o;
}, UIDReset = function(o) {
  var E = o.children, A = o.prefix, g = A === void 0 ? "" : A, e = useState(function() {
    return createSource(g);
  })[0];
  return React.createElement(source.Provider, { value: e }, E);
}, UIDConsumer = function(o) {
  var E = o.name, A = o.children;
  return React.createElement(source.Consumer, null, function(g) {
    return React.createElement(UID, { name: E, idSource: g, children: A });
  });
}, reactIsExports$1 = requireReactIs$1();
function _extends$z() {
  return _extends$z = Object.assign ? Object.assign.bind() : function(o) {
    for (var E = 1; E < arguments.length; E++) {
      var A = arguments[E];
      for (var g in A)
        Object.prototype.hasOwnProperty.call(A, g) && (o[g] = A[g]);
    }
    return o;
  }, _extends$z.apply(this, arguments);
}
function ownKeys$r(o, E) {
  var A = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var g = Object.getOwnPropertySymbols(o);
    E && (g = g.filter(function(e) {
      return Object.getOwnPropertyDescriptor(o, e).enumerable;
    })), A.push.apply(A, g);
  }
  return A;
}
function _objectSpread$p(o) {
  for (var E = 1; E < arguments.length; E++) {
    var A = arguments[E] != null ? arguments[E] : {};
    E % 2 ? ownKeys$r(Object(A), !0).forEach(function(g) {
      _defineProperty$y(o, g, A[g]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(A)) : ownKeys$r(Object(A)).forEach(function(g) {
      Object.defineProperty(o, g, Object.getOwnPropertyDescriptor(A, g));
    });
  }
  return o;
}
function _defineProperty$y(o, E, A) {
  return E in o ? Object.defineProperty(o, E, { value: A, enumerable: !0, configurable: !0, writable: !0 }) : o[E] = A, o;
}
function _typeof$k(o) {
  "@babel/helpers - typeof";
  return _typeof$k = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(E) {
    return typeof E;
  } : function(E) {
    return E && typeof Symbol == "function" && E.constructor === Symbol && E !== Symbol.prototype ? "symbol" : typeof E;
  }, _typeof$k(o);
}
function getOverride(o) {
  return reactIsExports$1.isValidElementType(o) ? o : o && _typeof$k(o) === "object" ? o.component : o;
}
function getOverrideProps(o) {
  return o && _typeof$k(o) === "object" ? _typeof$k(o.props) === "object" ? _objectSpread$p(_objectSpread$p({}, o.props), {}, {
    $style: o.style
  }) : {
    $style: o.style
  } : {};
}
function toObjectOverride(o) {
  return reactIsExports$1.isValidElementType(o) ? {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    component: o
  } : o || {};
}
function getOverrides(o, E) {
  var A = getOverride(o) || E;
  if (o && _typeof$k(o) === "object" && typeof o.props == "function") {
    process.env.NODE_ENV !== "production" && console.warn("baseui:Overrides Props as a function will be removed in the next major version. Override the whole component instead. See https://baseweb.design/guides/understanding-overrides/#override-the-entire-subcomponent");
    var g = /* @__PURE__ */ React.forwardRef(function(t, c) {
      var n = o.props(t), h = getOverrideProps(_objectSpread$p(_objectSpread$p({}, o), {}, {
        props: n
      }));
      return /* @__PURE__ */ React.createElement(A, _extends$z({
        ref: c
      }, h));
    });
    return g.displayName = A.displayName, [g, {}];
  }
  var e = getOverrideProps(o);
  return [A, e];
}
function mergeOverrides() {
  var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, E = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, A = Object.assign({}, o, E), g = Object.keys(A);
  return g.reduce(function(e, t) {
    return e[t] = mergeOverride(toObjectOverride(o[t]), toObjectOverride(E[t])), e;
  }, {});
}
function mergeOverride(o, E) {
  var A = _objectSpread$p(_objectSpread$p({}, o), E);
  return o.props && E.props && (A.props = mergeConfigurationOverrides(o.props, E.props)), o.style && E.style && (A.style = mergeConfigurationOverrides(o.style, E.style)), A;
}
function mergeConfigurationOverrides(o, E) {
  return _typeof$k(o) === "object" && _typeof$k(E) === "object" ? deepMerge$1({}, o, E) : function() {
    return deepMerge$1({}, typeof o == "function" ? o.apply(void 0, arguments) : o, typeof E == "function" ? E.apply(void 0, arguments) : E);
  };
}
var initialized = !1, hadKeyboardEvent = !0, inputTypesWhitelist = {
  text: !0,
  search: !0,
  url: !0,
  tel: !0,
  email: !0,
  password: !0,
  number: !0,
  date: !0,
  month: !0,
  week: !0,
  time: !0,
  datetime: !0,
  "datetime-local": !0
};
function focusTriggersKeyboardModality(o) {
  var E = o.type, A = o.tagName;
  return !!(A === "INPUT" && inputTypesWhitelist[E] && !o.readOnly || A === "TEXTAREA" && !o.readOnly || o.isContentEditable);
}
function handleKeyDown(o) {
  o.metaKey || o.altKey || o.ctrlKey || (hadKeyboardEvent = !0);
}
function handlePointerDown() {
  hadKeyboardEvent = !1;
}
function handleVisibilityChange() {
  this.visibilityState;
}
function prepare(o) {
  o.addEventListener("keydown", handleKeyDown, !0), o.addEventListener("mousedown", handlePointerDown, !0), o.addEventListener("pointerdown", handlePointerDown, !0), o.addEventListener("touchstart", handlePointerDown, !0), o.addEventListener("visibilitychange", handleVisibilityChange, !0);
}
function isFocusVisible(o) {
  try {
    return o.target.matches(":focus-visible");
  } catch {
  }
  return hadKeyboardEvent || focusTriggersKeyboardModality(o.target);
}
function initFocusVisible(o) {
  !initialized && o != null && (initialized = !0, prepare(o.ownerDocument));
}
var forkFocus = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  function o(E, A) {
    return function(g) {
      typeof E.onFocus == "function" && E.onFocus(g), A(g);
    };
  }
), forkBlur = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  function o(E, A) {
    return function(g) {
      typeof E.onBlur == "function" && E.onBlur(g), A(g);
    };
  }
);
function _typeof$j(o) {
  "@babel/helpers - typeof";
  return _typeof$j = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(E) {
    return typeof E;
  } : function(E) {
    return E && typeof Symbol == "function" && E.constructor === Symbol && E !== Symbol.prototype ? "symbol" : typeof E;
  }, _typeof$j(o);
}
function _extends$y() {
  return _extends$y = Object.assign ? Object.assign.bind() : function(o) {
    for (var E = 1; E < arguments.length; E++) {
      var A = arguments[E];
      for (var g in A)
        Object.prototype.hasOwnProperty.call(A, g) && (o[g] = A[g]);
    }
    return o;
  }, _extends$y.apply(this, arguments);
}
function _slicedToArray$m(o, E) {
  return _arrayWithHoles$l(o) || _iterableToArrayLimit$l(o, E) || _unsupportedIterableToArray$l(o, E) || _nonIterableRest$l();
}
function _nonIterableRest$l() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _iterableToArrayLimit$l(o, E) {
  var A = o == null ? null : typeof Symbol < "u" && o[Symbol.iterator] || o["@@iterator"];
  if (A != null) {
    var g = [], e = !0, t = !1, c, n;
    try {
      for (A = A.call(o); !(e = (c = A.next()).done) && (g.push(c.value), !(E && g.length === E)); e = !0)
        ;
    } catch (h) {
      t = !0, n = h;
    } finally {
      try {
        !e && A.return != null && A.return();
      } finally {
        if (t) throw n;
      }
    }
    return g;
  }
}
function _arrayWithHoles$l(o) {
  if (Array.isArray(o)) return o;
}
function _toConsumableArray$3(o) {
  return _arrayWithoutHoles$3(o) || _iterableToArray$3(o) || _unsupportedIterableToArray$l(o) || _nonIterableSpread$3();
}
function _nonIterableSpread$3() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$l(o, E) {
  if (o) {
    if (typeof o == "string") return _arrayLikeToArray$l(o, E);
    var A = Object.prototype.toString.call(o).slice(8, -1);
    if (A === "Object" && o.constructor && (A = o.constructor.name), A === "Map" || A === "Set") return Array.from(o);
    if (A === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(A)) return _arrayLikeToArray$l(o, E);
  }
}
function _iterableToArray$3(o) {
  if (typeof Symbol < "u" && o[Symbol.iterator] != null || o["@@iterator"] != null) return Array.from(o);
}
function _arrayWithoutHoles$3(o) {
  if (Array.isArray(o)) return _arrayLikeToArray$l(o);
}
function _arrayLikeToArray$l(o, E) {
  (E == null || E > o.length) && (E = o.length);
  for (var A = 0, g = new Array(E); A < E; A++)
    g[A] = o[A];
  return g;
}
function _classCallCheck$g(o, E) {
  if (!(o instanceof E))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$g(o, E) {
  for (var A = 0; A < E.length; A++) {
    var g = E[A];
    g.enumerable = g.enumerable || !1, g.configurable = !0, "value" in g && (g.writable = !0), Object.defineProperty(o, g.key, g);
  }
}
function _createClass$g(o, E, A) {
  return E && _defineProperties$g(o.prototype, E), Object.defineProperty(o, "prototype", { writable: !1 }), o;
}
function _inherits$g(o, E) {
  if (typeof E != "function" && E !== null)
    throw new TypeError("Super expression must either be null or a function");
  o.prototype = Object.create(E && E.prototype, { constructor: { value: o, writable: !0, configurable: !0 } }), Object.defineProperty(o, "prototype", { writable: !1 }), E && _setPrototypeOf$h(o, E);
}
function _setPrototypeOf$h(o, E) {
  return _setPrototypeOf$h = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(g, e) {
    return g.__proto__ = e, g;
  }, _setPrototypeOf$h(o, E);
}
function _createSuper$g(o) {
  var E = _isNativeReflectConstruct$g();
  return function() {
    var g = _getPrototypeOf$g(o), e;
    if (E) {
      var t = _getPrototypeOf$g(this).constructor;
      e = Reflect.construct(g, arguments, t);
    } else
      e = g.apply(this, arguments);
    return _possibleConstructorReturn$g(this, e);
  };
}
function _possibleConstructorReturn$g(o, E) {
  if (E && (_typeof$j(E) === "object" || typeof E == "function"))
    return E;
  if (E !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$h(o);
}
function _assertThisInitialized$h(o) {
  if (o === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return o;
}
function _isNativeReflectConstruct$g() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function _getPrototypeOf$g(o) {
  return _getPrototypeOf$g = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(A) {
    return A.__proto__ || Object.getPrototypeOf(A);
  }, _getPrototypeOf$g(o);
}
function _defineProperty$x(o, E, A) {
  return E in o ? Object.defineProperty(o, E, { value: A, enumerable: !0, configurable: !0, writable: !0 }) : o[E] = A, o;
}
var StyledAppContainer = styled("div", {});
StyledAppContainer.displayName = "StyledAppContainer";
var StyledLayersContainer = styled("div", {});
StyledLayersContainer.displayName = "StyledLayersContainer";
function defaultEventHandlerFn() {
  process.env.NODE_ENV !== "production" && console.warn("`LayersManager` was not found. This occurs if you are attempting to use a component requiring `Layer` without using the `BaseProvider` at the root of your app. Please visit https://baseweb.design/components/base-provider/ for more information");
}
var LayersContext = /* @__PURE__ */ React.createContext({
  addEscapeHandler: defaultEventHandlerFn,
  removeEscapeHandler: defaultEventHandlerFn,
  addKeyDownHandler: defaultEventHandlerFn,
  removeKeyDownHandler: defaultEventHandlerFn,
  addKeyUpHandler: defaultEventHandlerFn,
  removeKeyUpHandler: defaultEventHandlerFn,
  addKeyPressHandler: defaultEventHandlerFn,
  removeKeyPressHandler: defaultEventHandlerFn,
  addDocClickHandler: defaultEventHandlerFn,
  removeDocClickHandler: defaultEventHandlerFn,
  host: void 0,
  zIndex: void 0
}), Provider = LayersContext.Provider, Consumer = LayersContext.Consumer, LayersManager = /* @__PURE__ */ (function(o) {
  _inherits$g(A, o);
  var E = _createSuper$g(A);
  function A(g) {
    var e;
    return _classCallCheck$g(this, A), e = E.call(this, g), _defineProperty$x(_assertThisInitialized$h(e), "host", /* @__PURE__ */ React.createRef()), _defineProperty$x(_assertThisInitialized$h(e), "containerRef", /* @__PURE__ */ React.createRef()), _defineProperty$x(_assertThisInitialized$h(e), "onDocumentClick", function(t) {
      var c = e.state.docClickHandlers[e.state.docClickHandlers.length - 1];
      c && c(t);
    }), _defineProperty$x(_assertThisInitialized$h(e), "onKeyDown", function(t) {
      var c = e.state.keyDownHandlers[e.state.keyDownHandlers.length - 1];
      c && c(t);
    }), _defineProperty$x(_assertThisInitialized$h(e), "onKeyUp", function(t) {
      if (t.key === "Escape") {
        var c = e.state.escapeKeyHandlers[e.state.escapeKeyHandlers.length - 1];
        c && c();
      }
      var n = e.state.keyUpHandlers[e.state.keyUpHandlers.length - 1];
      n && n(t);
    }), _defineProperty$x(_assertThisInitialized$h(e), "onKeyPress", function(t) {
      var c = e.state.keyPressHandlers[e.state.keyPressHandlers.length - 1];
      c && c(t);
    }), _defineProperty$x(_assertThisInitialized$h(e), "onAddEscapeHandler", function(t) {
      e.setState(function(c) {
        return {
          escapeKeyHandlers: [].concat(_toConsumableArray$3(c.escapeKeyHandlers), [t])
        };
      });
    }), _defineProperty$x(_assertThisInitialized$h(e), "onRemoveEscapeHandler", function(t) {
      e.setState(function(c) {
        return {
          escapeKeyHandlers: c.escapeKeyHandlers.filter(function(n) {
            return n !== t;
          })
        };
      });
    }), _defineProperty$x(_assertThisInitialized$h(e), "onAddKeyDownHandler", function(t) {
      e.setState(function(c) {
        return {
          keyDownHandlers: [].concat(_toConsumableArray$3(c.keyDownHandlers), [t])
        };
      });
    }), _defineProperty$x(_assertThisInitialized$h(e), "onRemoveKeyDownHandler", function(t) {
      e.setState(function(c) {
        return {
          keyDownHandlers: c.keyDownHandlers.filter(function(n) {
            return n !== t;
          })
        };
      });
    }), _defineProperty$x(_assertThisInitialized$h(e), "onAddKeyUpHandler", function(t) {
      e.setState(function(c) {
        return {
          keyUpHandlers: [].concat(_toConsumableArray$3(c.keyUpHandlers), [t])
        };
      });
    }), _defineProperty$x(_assertThisInitialized$h(e), "onRemoveKeyUpHandler", function(t) {
      e.setState(function(c) {
        return {
          keyUpHandlers: c.keyUpHandlers.filter(function(n) {
            return n !== t;
          })
        };
      });
    }), _defineProperty$x(_assertThisInitialized$h(e), "onAddKeyPressHandler", function(t) {
      e.setState(function(c) {
        return {
          keyPressHandlers: [].concat(_toConsumableArray$3(c.keyPressHandlers), [t])
        };
      });
    }), _defineProperty$x(_assertThisInitialized$h(e), "onRemoveKeyPressHandler", function(t) {
      e.setState(function(c) {
        return {
          keyPressHandlers: c.keyPressHandlers.filter(function(n) {
            return n !== t;
          })
        };
      });
    }), _defineProperty$x(_assertThisInitialized$h(e), "onAddDocClickHandler", function(t) {
      e.setState(function(c) {
        return {
          docClickHandlers: [].concat(_toConsumableArray$3(c.docClickHandlers), [t])
        };
      });
    }), _defineProperty$x(_assertThisInitialized$h(e), "onRemoveDocClickHandler", function(t) {
      e.setState(function(c) {
        return {
          docClickHandlers: c.docClickHandlers.filter(function(n) {
            return n !== t;
          })
        };
      });
    }), e.state = {
      escapeKeyHandlers: [],
      keyDownHandlers: [],
      keyUpHandlers: [],
      keyPressHandlers: [],
      docClickHandlers: []
    }, e;
  }
  return _createClass$g(A, [{
    key: "componentDidMount",
    value: function() {
      this.forceUpdate(), initFocusVisible(this.containerRef.current), typeof document < "u" && (document.addEventListener("keydown", this.onKeyDown), document.addEventListener("keyup", this.onKeyUp), document.addEventListener("keypress", this.onKeyPress), document.addEventListener("mousedown", this.onDocumentClick));
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      typeof document < "u" && (document.removeEventListener("keydown", this.onKeyDown), document.removeEventListener("keyup", this.onKeyUp), document.removeEventListener("keypress", this.onKeyPress), document.removeEventListener("mousedown", this.onDocumentClick));
    }
  }, {
    key: "render",
    value: function() {
      var e = this, t = this.props.overrides, c = t === void 0 ? {} : t, n = getOverrides(c.AppContainer, StyledAppContainer), h = _slicedToArray$m(n, 2), d = h[0], k = h[1], p = getOverrides(c.LayersContainer, StyledLayersContainer), M = _slicedToArray$m(p, 2), S = M[0], AA = M[1];
      return /* @__PURE__ */ React.createElement(Consumer, null, function(H) {
        var gA = H.host;
        return process.env.NODE_ENV !== "production" && gA !== void 0 && console.warn("There is a LayersManager already exists in your application. It is not recommended to have more than one LayersManager in an application."), /* @__PURE__ */ React.createElement(Provider, {
          value: {
            host: gA || e.host.current,
            zIndex: e.props.zIndex,
            addEscapeHandler: e.onAddEscapeHandler,
            removeEscapeHandler: e.onRemoveEscapeHandler,
            addKeyDownHandler: e.onAddKeyDownHandler,
            removeKeyDownHandler: e.onRemoveKeyDownHandler,
            addKeyUpHandler: e.onAddKeyUpHandler,
            removeKeyUpHandler: e.onRemoveKeyUpHandler,
            addKeyPressHandler: e.onAddKeyPressHandler,
            removeKeyPressHandler: e.onRemoveKeyPressHandler,
            addDocClickHandler: e.onAddDocClickHandler,
            removeDocClickHandler: e.onRemoveDocClickHandler
          }
        }, /* @__PURE__ */ React.createElement(d, _extends$y({}, k, {
          ref: e.containerRef
        }), e.props.children), /* @__PURE__ */ React.createElement(S, _extends$y({}, AA, {
          ref: e.host
        })));
      });
    }
  }]), A;
})(React.Component);
function _typeof$i(o) {
  "@babel/helpers - typeof";
  return _typeof$i = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(E) {
    return typeof E;
  } : function(E) {
    return E && typeof Symbol == "function" && E.constructor === Symbol && E !== Symbol.prototype ? "symbol" : typeof E;
  }, _typeof$i(o);
}
function _extends$x() {
  return _extends$x = Object.assign ? Object.assign.bind() : function(o) {
    for (var E = 1; E < arguments.length; E++) {
      var A = arguments[E];
      for (var g in A)
        Object.prototype.hasOwnProperty.call(A, g) && (o[g] = A[g]);
    }
    return o;
  }, _extends$x.apply(this, arguments);
}
function _classCallCheck$f(o, E) {
  if (!(o instanceof E))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$f(o, E) {
  for (var A = 0; A < E.length; A++) {
    var g = E[A];
    g.enumerable = g.enumerable || !1, g.configurable = !0, "value" in g && (g.writable = !0), Object.defineProperty(o, g.key, g);
  }
}
function _createClass$f(o, E, A) {
  return E && _defineProperties$f(o.prototype, E), Object.defineProperty(o, "prototype", { writable: !1 }), o;
}
function _inherits$f(o, E) {
  if (typeof E != "function" && E !== null)
    throw new TypeError("Super expression must either be null or a function");
  o.prototype = Object.create(E && E.prototype, { constructor: { value: o, writable: !0, configurable: !0 } }), Object.defineProperty(o, "prototype", { writable: !1 }), E && _setPrototypeOf$g(o, E);
}
function _setPrototypeOf$g(o, E) {
  return _setPrototypeOf$g = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(g, e) {
    return g.__proto__ = e, g;
  }, _setPrototypeOf$g(o, E);
}
function _createSuper$f(o) {
  var E = _isNativeReflectConstruct$f();
  return function() {
    var g = _getPrototypeOf$f(o), e;
    if (E) {
      var t = _getPrototypeOf$f(this).constructor;
      e = Reflect.construct(g, arguments, t);
    } else
      e = g.apply(this, arguments);
    return _possibleConstructorReturn$f(this, e);
  };
}
function _possibleConstructorReturn$f(o, E) {
  if (E && (_typeof$i(E) === "object" || typeof E == "function"))
    return E;
  if (E !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$g(o);
}
function _assertThisInitialized$g(o) {
  if (o === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return o;
}
function _isNativeReflectConstruct$f() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function _getPrototypeOf$f(o) {
  return _getPrototypeOf$f = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(A) {
    return A.__proto__ || Object.getPrototypeOf(A);
  }, _getPrototypeOf$f(o);
}
function _defineProperty$w(o, E, A) {
  return E in o ? Object.defineProperty(o, E, { value: A, enumerable: !0, configurable: !0, writable: !0 }) : o[E] = A, o;
}
var Container = styled("div", function(o) {
  var E = o.$zIndex;
  return {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    zIndex: E || null
  };
});
Container.displayName = "Container";
var LayerComponent = /* @__PURE__ */ (function(o) {
  _inherits$f(A, o);
  var E = _createSuper$f(A);
  function A() {
    var g;
    _classCallCheck$f(this, A);
    for (var e = arguments.length, t = new Array(e), c = 0; c < e; c++)
      t[c] = arguments[c];
    return g = E.call.apply(E, [this].concat(t)), _defineProperty$w(_assertThisInitialized$g(g), "state", {
      container: null
    }), _defineProperty$w(_assertThisInitialized$g(g), "onEscape", function() {
      g.props.onEscape && g.props.onEscape();
    }), _defineProperty$w(_assertThisInitialized$g(g), "onKeyDown", function(n) {
      g.props.onKeyDown && g.props.onKeyDown(n);
    }), _defineProperty$w(_assertThisInitialized$g(g), "onKeyUp", function(n) {
      g.props.onKeyUp && g.props.onKeyUp(n);
    }), _defineProperty$w(_assertThisInitialized$g(g), "onKeyPress", function(n) {
      g.props.onKeyPress && g.props.onKeyPress(n);
    }), _defineProperty$w(_assertThisInitialized$g(g), "onDocumentClick", function(n) {
      g.props.onDocumentClick && g.props.onDocumentClick(n);
    }), g;
  }
  return _createClass$f(A, [{
    key: "componentDidMount",
    value: function() {
      this.context.addEscapeHandler(this.onEscape), this.context.addKeyDownHandler(this.onKeyDown), this.context.addKeyUpHandler(this.onKeyUp), this.context.addKeyPressHandler(this.onKeyPress), this.props.isHoverLayer || this.context.addDocClickHandler(this.onDocumentClick);
      var e = this.props, t = e.onMount, c = e.mountNode, n = e.host;
      if (c) {
        t && t();
        return;
      }
      var h = n !== void 0;
      process.env.NODE_ENV !== "production" && (h || console.warn("`LayersManager` was not found. This occurs if you are attempting to use a component requiring `Layer` without using the `BaseProvider` at the root of your app. Please visit https://baseweb.design/components/base-provider/ for more information"));
      var d = h ? n : document.body;
      d && this.addContainer(d);
    }
  }, {
    key: "componentDidUpdate",
    value: function(e) {
      var t = this.props, c = t.host, n = t.mountNode;
      n || (c && c !== e.host && e.host === null && this.addContainer(c), e.isHoverLayer != this.props.isHoverLayer && (this.props.isHoverLayer ? this.context.removeDocClickHandler(this.onDocumentClick) : this.context.addDocClickHandler(this.onDocumentClick)));
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.context.removeEscapeHandler(this.onEscape), this.context.removeKeyDownHandler(this.onKeyDown), this.context.removeKeyUpHandler(this.onKeyUp), this.context.removeKeyPressHandler(this.onKeyPress), this.context.removeDocClickHandler(this.onDocumentClick), this.props.onUnmount && this.props.onUnmount();
      var e = this.props.host, t = this.state.container;
      e && t && e.contains(t) && e.removeChild(t);
    }
  }, {
    key: "addContainer",
    value: function(e) {
      var t = this.props, c = t.index, n = t.mountNode, h = t.onMount;
      if (!n && e) {
        var d = e.ownerDocument.createElement("div"), k = typeof c == "number" ? e.children[c] : null;
        k ? e.insertBefore(d, k) : e.appendChild(d), this.setState({
          container: d
        }, function() {
          h && h();
        });
      }
    }
  }, {
    key: "render",
    value: function() {
      var e = this.state.container, t = this.props, c = t.children, n = t.mountNode, h = t.zIndex, d = h ? /* @__PURE__ */ React.createElement(Container, {
        $zIndex: h
      }, c) : c;
      return typeof document < "u" ? n ? /* @__PURE__ */ ReactDOM.createPortal(d, n) : e ? /* @__PURE__ */ ReactDOM.createPortal(d, e) : null : null;
    }
  }]), A;
})(React.Component);
_defineProperty$w(LayerComponent, "contextType", LayersContext);
function Layer(o) {
  return /* @__PURE__ */ React.createElement(Consumer, null, function(E) {
    var A = E.host, g = E.zIndex;
    return /* @__PURE__ */ React.createElement(LayerComponent, _extends$x({}, o, {
      host: A,
      zIndex: g
    }));
  });
}
var isBrowser$1 = typeof window < "u" && typeof document < "u" && typeof navigator < "u", timeoutDuration = (function() {
  for (var o = ["Edge", "Trident", "Firefox"], E = 0; E < o.length; E += 1)
    if (isBrowser$1 && navigator.userAgent.indexOf(o[E]) >= 0)
      return 1;
  return 0;
})();
function microtaskDebounce(o) {
  var E = !1;
  return function() {
    E || (E = !0, window.Promise.resolve().then(function() {
      E = !1, o();
    }));
  };
}
function taskDebounce(o) {
  var E = !1;
  return function() {
    E || (E = !0, setTimeout(function() {
      E = !1, o();
    }, timeoutDuration));
  };
}
var supportsMicroTasks = isBrowser$1 && window.Promise, debounce$1 = supportsMicroTasks ? microtaskDebounce : taskDebounce;
function isFunction$1(o) {
  var E = {};
  return o && E.toString.call(o) === "[object Function]";
}
function getStyleComputedProperty(o, E) {
  if (o.nodeType !== 1)
    return [];
  var A = o.ownerDocument.defaultView, g = A.getComputedStyle(o, null);
  return E ? g[E] : g;
}
function getParentNode$1(o) {
  return o.nodeName === "HTML" ? o : o.parentNode || o.host;
}
function getScrollParent(o) {
  if (!o)
    return document.body;
  switch (o.nodeName) {
    case "HTML":
    case "BODY":
      return o.ownerDocument.body;
    case "#document":
      return o.body;
  }
  var E = getStyleComputedProperty(o), A = E.overflow, g = E.overflowX, e = E.overflowY;
  return /(auto|scroll|overlay)/.test(A + e + g) ? o : getScrollParent(getParentNode$1(o));
}
function getReferenceNode(o) {
  return o && o.referenceNode ? o.referenceNode : o;
}
var isIE11 = isBrowser$1 && !!(window.MSInputMethodContext && document.documentMode), isIE10 = isBrowser$1 && /MSIE 10/.test(navigator.userAgent);
function isIE(o) {
  return o === 11 ? isIE11 : o === 10 ? isIE10 : isIE11 || isIE10;
}
function getOffsetParent(o) {
  if (!o)
    return document.documentElement;
  for (var E = isIE(10) ? document.body : null, A = o.offsetParent || null; A === E && o.nextElementSibling; )
    A = (o = o.nextElementSibling).offsetParent;
  var g = A && A.nodeName;
  return !g || g === "BODY" || g === "HTML" ? o ? o.ownerDocument.documentElement : document.documentElement : ["TH", "TD", "TABLE"].indexOf(A.nodeName) !== -1 && getStyleComputedProperty(A, "position") === "static" ? getOffsetParent(A) : A;
}
function isOffsetContainer(o) {
  var E = o.nodeName;
  return E === "BODY" ? !1 : E === "HTML" || getOffsetParent(o.firstElementChild) === o;
}
function getRoot(o) {
  return o.parentNode !== null ? getRoot(o.parentNode) : o;
}
function findCommonOffsetParent(o, E) {
  if (!o || !o.nodeType || !E || !E.nodeType)
    return document.documentElement;
  var A = o.compareDocumentPosition(E) & Node.DOCUMENT_POSITION_FOLLOWING, g = A ? o : E, e = A ? E : o, t = document.createRange();
  t.setStart(g, 0), t.setEnd(e, 0);
  var c = t.commonAncestorContainer;
  if (o !== c && E !== c || g.contains(e))
    return isOffsetContainer(c) ? c : getOffsetParent(c);
  var n = getRoot(o);
  return n.host ? findCommonOffsetParent(n.host, E) : findCommonOffsetParent(o, getRoot(E).host);
}
function getScroll(o) {
  var E = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "top", A = E === "top" ? "scrollTop" : "scrollLeft", g = o.nodeName;
  if (g === "BODY" || g === "HTML") {
    var e = o.ownerDocument.documentElement, t = o.ownerDocument.scrollingElement || e;
    return t[A];
  }
  return o[A];
}
function includeScroll(o, E) {
  var A = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, g = getScroll(E, "top"), e = getScroll(E, "left"), t = A ? -1 : 1;
  return o.top += g * t, o.bottom += g * t, o.left += e * t, o.right += e * t, o;
}
function getBordersSize$1(o, E) {
  var A = E === "x" ? "Left" : "Top", g = A === "Left" ? "Right" : "Bottom";
  return parseFloat(o["border" + A + "Width"]) + parseFloat(o["border" + g + "Width"]);
}
function getSize(o, E, A, g) {
  return Math.max(E["offset" + o], E["scroll" + o], A["client" + o], A["offset" + o], A["scroll" + o], isIE(10) ? parseInt(A["offset" + o]) + parseInt(g["margin" + (o === "Height" ? "Top" : "Left")]) + parseInt(g["margin" + (o === "Height" ? "Bottom" : "Right")]) : 0);
}
function getWindowSizes(o) {
  var E = o.body, A = o.documentElement, g = isIE(10) && getComputedStyle(A);
  return {
    height: getSize("Height", E, A, g),
    width: getSize("Width", E, A, g)
  };
}
var classCallCheck = function(o, E) {
  if (!(o instanceof E))
    throw new TypeError("Cannot call a class as a function");
}, createClass = /* @__PURE__ */ (function() {
  function o(E, A) {
    for (var g = 0; g < A.length; g++) {
      var e = A[g];
      e.enumerable = e.enumerable || !1, e.configurable = !0, "value" in e && (e.writable = !0), Object.defineProperty(E, e.key, e);
    }
  }
  return function(E, A, g) {
    return A && o(E.prototype, A), g && o(E, g), E;
  };
})(), defineProperty = function(o, E, A) {
  return E in o ? Object.defineProperty(o, E, {
    value: A,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : o[E] = A, o;
}, _extends$w = Object.assign || function(o) {
  for (var E = 1; E < arguments.length; E++) {
    var A = arguments[E];
    for (var g in A)
      Object.prototype.hasOwnProperty.call(A, g) && (o[g] = A[g]);
  }
  return o;
};
function getClientRect(o) {
  return _extends$w({}, o, {
    right: o.left + o.width,
    bottom: o.top + o.height
  });
}
function getBoundingClientRect(o) {
  var E = {};
  try {
    if (isIE(10)) {
      E = o.getBoundingClientRect();
      var A = getScroll(o, "top"), g = getScroll(o, "left");
      E.top += A, E.left += g, E.bottom += A, E.right += g;
    } else
      E = o.getBoundingClientRect();
  } catch {
  }
  var e = {
    left: E.left,
    top: E.top,
    width: E.right - E.left,
    height: E.bottom - E.top
  }, t = o.nodeName === "HTML" ? getWindowSizes(o.ownerDocument) : {}, c = t.width || o.clientWidth || e.width, n = t.height || o.clientHeight || e.height, h = o.offsetWidth - c, d = o.offsetHeight - n;
  if (h || d) {
    var k = getStyleComputedProperty(o);
    h -= getBordersSize$1(k, "x"), d -= getBordersSize$1(k, "y"), e.width -= h, e.height -= d;
  }
  return getClientRect(e);
}
function getOffsetRectRelativeToArbitraryNode(o, E) {
  var A = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, g = isIE(10), e = E.nodeName === "HTML", t = getBoundingClientRect(o), c = getBoundingClientRect(E), n = getScrollParent(o), h = getStyleComputedProperty(E), d = parseFloat(h.borderTopWidth), k = parseFloat(h.borderLeftWidth);
  A && e && (c.top = Math.max(c.top, 0), c.left = Math.max(c.left, 0));
  var p = getClientRect({
    top: t.top - c.top - d,
    left: t.left - c.left - k,
    width: t.width,
    height: t.height
  });
  if (p.marginTop = 0, p.marginLeft = 0, !g && e) {
    var M = parseFloat(h.marginTop), S = parseFloat(h.marginLeft);
    p.top -= d - M, p.bottom -= d - M, p.left -= k - S, p.right -= k - S, p.marginTop = M, p.marginLeft = S;
  }
  return (g && !A ? E.contains(n) : E === n && n.nodeName !== "BODY") && (p = includeScroll(p, E)), p;
}
function getViewportOffsetRectRelativeToArtbitraryNode(o) {
  var E = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, A = o.ownerDocument.documentElement, g = getOffsetRectRelativeToArbitraryNode(o, A), e = Math.max(A.clientWidth, window.innerWidth || 0), t = Math.max(A.clientHeight, window.innerHeight || 0), c = E ? 0 : getScroll(A), n = E ? 0 : getScroll(A, "left"), h = {
    top: c - g.top + g.marginTop,
    left: n - g.left + g.marginLeft,
    width: e,
    height: t
  };
  return getClientRect(h);
}
function isFixed$1(o) {
  var E = o.nodeName;
  if (E === "BODY" || E === "HTML")
    return !1;
  if (getStyleComputedProperty(o, "position") === "fixed")
    return !0;
  var A = getParentNode$1(o);
  return A ? isFixed$1(A) : !1;
}
function getFixedPositionOffsetParent(o) {
  if (!o || !o.parentElement || isIE())
    return document.documentElement;
  for (var E = o.parentElement; E && getStyleComputedProperty(E, "transform") === "none"; )
    E = E.parentElement;
  return E || document.documentElement;
}
function getBoundaries(o, E, A, g) {
  var e = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !1, t = { top: 0, left: 0 }, c = e ? getFixedPositionOffsetParent(o) : findCommonOffsetParent(o, getReferenceNode(E));
  if (g === "viewport")
    t = getViewportOffsetRectRelativeToArtbitraryNode(c, e);
  else {
    var n = void 0;
    g === "scrollParent" ? (n = getScrollParent(getParentNode$1(E)), n.nodeName === "BODY" && (n = o.ownerDocument.documentElement)) : g === "window" ? n = o.ownerDocument.documentElement : n = g;
    var h = getOffsetRectRelativeToArbitraryNode(n, c, e);
    if (n.nodeName === "HTML" && !isFixed$1(c)) {
      var d = getWindowSizes(o.ownerDocument), k = d.height, p = d.width;
      t.top += h.top - h.marginTop, t.bottom = k + h.top, t.left += h.left - h.marginLeft, t.right = p + h.left;
    } else
      t = h;
  }
  A = A || 0;
  var M = typeof A == "number";
  return t.left += M ? A : A.left || 0, t.top += M ? A : A.top || 0, t.right -= M ? A : A.right || 0, t.bottom -= M ? A : A.bottom || 0, t;
}
function getArea(o) {
  var E = o.width, A = o.height;
  return E * A;
}
function computeAutoPlacement(o, E, A, g, e) {
  var t = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : 0;
  if (o.indexOf("auto") === -1)
    return o;
  var c = getBoundaries(A, g, t, e), n = {
    top: {
      width: c.width,
      height: E.top - c.top
    },
    right: {
      width: c.right - E.right,
      height: c.height
    },
    bottom: {
      width: c.width,
      height: c.bottom - E.bottom
    },
    left: {
      width: E.left - c.left,
      height: c.height
    }
  }, h = Object.keys(n).map(function(M) {
    return _extends$w({
      key: M
    }, n[M], {
      area: getArea(n[M])
    });
  }).sort(function(M, S) {
    return S.area - M.area;
  }), d = h.filter(function(M) {
    var S = M.width, AA = M.height;
    return S >= A.clientWidth && AA >= A.clientHeight;
  }), k = d.length > 0 ? d[0].key : h[0].key, p = o.split("-")[1];
  return k + (p ? "-" + p : "");
}
function getReferenceOffsets(o, E, A) {
  var g = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null, e = g ? getFixedPositionOffsetParent(E) : findCommonOffsetParent(E, getReferenceNode(A));
  return getOffsetRectRelativeToArbitraryNode(A, e, g);
}
function getOuterSizes(o) {
  var E = o.ownerDocument.defaultView, A = E.getComputedStyle(o), g = parseFloat(A.marginTop || 0) + parseFloat(A.marginBottom || 0), e = parseFloat(A.marginLeft || 0) + parseFloat(A.marginRight || 0), t = {
    width: o.offsetWidth + e,
    height: o.offsetHeight + g
  };
  return t;
}
function getOppositePlacement(o) {
  var E = { left: "right", right: "left", bottom: "top", top: "bottom" };
  return o.replace(/left|right|bottom|top/g, function(A) {
    return E[A];
  });
}
function getPopperOffsets(o, E, A) {
  A = A.split("-")[0];
  var g = getOuterSizes(o), e = {
    width: g.width,
    height: g.height
  }, t = ["right", "left"].indexOf(A) !== -1, c = t ? "top" : "left", n = t ? "left" : "top", h = t ? "height" : "width", d = t ? "width" : "height";
  return e[c] = E[c] + E[h] / 2 - g[h] / 2, A === n ? e[n] = E[n] - g[d] : e[n] = E[getOppositePlacement(n)], e;
}
function find$2(o, E) {
  return Array.prototype.find ? o.find(E) : o.filter(E)[0];
}
function findIndex$1(o, E, A) {
  if (Array.prototype.findIndex)
    return o.findIndex(function(e) {
      return e[E] === A;
    });
  var g = find$2(o, function(e) {
    return e[E] === A;
  });
  return o.indexOf(g);
}
function runModifiers(o, E, A) {
  var g = A === void 0 ? o : o.slice(0, findIndex$1(o, "name", A));
  return g.forEach(function(e) {
    e.function && console.warn("`modifier.function` is deprecated, use `modifier.fn`!");
    var t = e.function || e.fn;
    e.enabled && isFunction$1(t) && (E.offsets.popper = getClientRect(E.offsets.popper), E.offsets.reference = getClientRect(E.offsets.reference), E = t(E, e));
  }), E;
}
function update() {
  if (!this.state.isDestroyed) {
    var o = {
      instance: this,
      styles: {},
      arrowStyles: {},
      attributes: {},
      flipped: !1,
      offsets: {}
    };
    o.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed), o.placement = computeAutoPlacement(this.options.placement, o.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding), o.originalPlacement = o.placement, o.positionFixed = this.options.positionFixed, o.offsets.popper = getPopperOffsets(this.popper, o.offsets.reference, o.placement), o.offsets.popper.position = this.options.positionFixed ? "fixed" : "absolute", o = runModifiers(this.modifiers, o), this.state.isCreated ? this.options.onUpdate(o) : (this.state.isCreated = !0, this.options.onCreate(o));
  }
}
function isModifierEnabled(o, E) {
  return o.some(function(A) {
    var g = A.name, e = A.enabled;
    return e && g === E;
  });
}
function getSupportedPropertyName(o) {
  for (var E = [!1, "ms", "Webkit", "Moz", "O"], A = o.charAt(0).toUpperCase() + o.slice(1), g = 0; g < E.length; g++) {
    var e = E[g], t = e ? "" + e + A : o;
    if (typeof document.body.style[t] < "u")
      return t;
  }
  return null;
}
function destroy() {
  return this.state.isDestroyed = !0, isModifierEnabled(this.modifiers, "applyStyle") && (this.popper.removeAttribute("x-placement"), this.popper.style.position = "", this.popper.style.top = "", this.popper.style.left = "", this.popper.style.right = "", this.popper.style.bottom = "", this.popper.style.willChange = "", this.popper.style[getSupportedPropertyName("transform")] = ""), this.disableEventListeners(), this.options.removeOnDestroy && this.popper.parentNode.removeChild(this.popper), this;
}
function getWindow(o) {
  var E = o.ownerDocument;
  return E ? E.defaultView : window;
}
function attachToScrollParents(o, E, A, g) {
  var e = o.nodeName === "BODY", t = e ? o.ownerDocument.defaultView : o;
  t.addEventListener(E, A, { passive: !0 }), e || attachToScrollParents(getScrollParent(t.parentNode), E, A, g), g.push(t);
}
function setupEventListeners(o, E, A, g) {
  A.updateBound = g, getWindow(o).addEventListener("resize", A.updateBound, { passive: !0 });
  var e = getScrollParent(o);
  return attachToScrollParents(e, "scroll", A.updateBound, A.scrollParents), A.scrollElement = e, A.eventsEnabled = !0, A;
}
function enableEventListeners() {
  this.state.eventsEnabled || (this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate));
}
function removeEventListeners(o, E) {
  return getWindow(o).removeEventListener("resize", E.updateBound), E.scrollParents.forEach(function(A) {
    A.removeEventListener("scroll", E.updateBound);
  }), E.updateBound = null, E.scrollParents = [], E.scrollElement = null, E.eventsEnabled = !1, E;
}
function disableEventListeners() {
  this.state.eventsEnabled && (cancelAnimationFrame(this.scheduleUpdate), this.state = removeEventListeners(this.reference, this.state));
}
function isNumeric(o) {
  return o !== "" && !isNaN(parseFloat(o)) && isFinite(o);
}
function setStyles(o, E) {
  Object.keys(E).forEach(function(A) {
    var g = "";
    ["width", "height", "top", "right", "bottom", "left"].indexOf(A) !== -1 && isNumeric(E[A]) && (g = "px"), o.style[A] = E[A] + g;
  });
}
function setAttributes(o, E) {
  Object.keys(E).forEach(function(A) {
    var g = E[A];
    g !== !1 ? o.setAttribute(A, E[A]) : o.removeAttribute(A);
  });
}
function applyStyle(o) {
  return setStyles(o.instance.popper, o.styles), setAttributes(o.instance.popper, o.attributes), o.arrowElement && Object.keys(o.arrowStyles).length && setStyles(o.arrowElement, o.arrowStyles), o;
}
function applyStyleOnLoad(o, E, A, g, e) {
  var t = getReferenceOffsets(e, E, o, A.positionFixed), c = computeAutoPlacement(A.placement, t, E, o, A.modifiers.flip.boundariesElement, A.modifiers.flip.padding);
  return E.setAttribute("x-placement", c), setStyles(E, { position: A.positionFixed ? "fixed" : "absolute" }), A;
}
function getRoundedOffsets(o, E) {
  var A = o.offsets, g = A.popper, e = A.reference, t = Math.round, c = Math.floor, n = function(CA) {
    return CA;
  }, h = t(e.width), d = t(g.width), k = ["left", "right"].indexOf(o.placement) !== -1, p = o.placement.indexOf("-") !== -1, M = h % 2 === d % 2, S = h % 2 === 1 && d % 2 === 1, AA = E ? k || p || M ? t : c : n, H = E ? t : n;
  return {
    left: AA(S && !p && E ? g.left - 1 : g.left),
    top: H(g.top),
    bottom: H(g.bottom),
    right: AA(g.right)
  };
}
var isFirefox = isBrowser$1 && /Firefox/i.test(navigator.userAgent);
function computeStyle(o, E) {
  var A = E.x, g = E.y, e = o.offsets.popper, t = find$2(o.instance.modifiers, function(BA) {
    return BA.name === "applyStyle";
  }).gpuAcceleration;
  t !== void 0 && console.warn("WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!");
  var c = t !== void 0 ? t : E.gpuAcceleration, n = getOffsetParent(o.instance.popper), h = getBoundingClientRect(n), d = {
    position: e.position
  }, k = getRoundedOffsets(o, window.devicePixelRatio < 2 || !isFirefox), p = A === "bottom" ? "top" : "bottom", M = g === "right" ? "left" : "right", S = getSupportedPropertyName("transform"), AA = void 0, H = void 0;
  if (p === "bottom" ? n.nodeName === "HTML" ? H = -n.clientHeight + k.bottom : H = -h.height + k.bottom : H = k.top, M === "right" ? n.nodeName === "HTML" ? AA = -n.clientWidth + k.right : AA = -h.width + k.right : AA = k.left, c && S)
    d[S] = "translate3d(" + AA + "px, " + H + "px, 0)", d[p] = 0, d[M] = 0, d.willChange = "transform";
  else {
    var gA = p === "bottom" ? -1 : 1, CA = M === "right" ? -1 : 1;
    d[p] = H * gA, d[M] = AA * CA, d.willChange = p + ", " + M;
  }
  var IA = {
    "x-placement": o.placement
  };
  return o.attributes = _extends$w({}, IA, o.attributes), o.styles = _extends$w({}, d, o.styles), o.arrowStyles = _extends$w({}, o.offsets.arrow, o.arrowStyles), o;
}
function isModifierRequired(o, E, A) {
  var g = find$2(o, function(n) {
    var h = n.name;
    return h === E;
  }), e = !!g && o.some(function(n) {
    return n.name === A && n.enabled && n.order < g.order;
  });
  if (!e) {
    var t = "`" + E + "`", c = "`" + A + "`";
    console.warn(c + " modifier is required by " + t + " modifier in order to work, be sure to include it before " + t + "!");
  }
  return e;
}
function arrow(o, E) {
  var A;
  if (!isModifierRequired(o.instance.modifiers, "arrow", "keepTogether"))
    return o;
  var g = E.element;
  if (typeof g == "string") {
    if (g = o.instance.popper.querySelector(g), !g)
      return o;
  } else if (!o.instance.popper.contains(g))
    return console.warn("WARNING: `arrow.element` must be child of its popper element!"), o;
  var e = o.placement.split("-")[0], t = o.offsets, c = t.popper, n = t.reference, h = ["left", "right"].indexOf(e) !== -1, d = h ? "height" : "width", k = h ? "Top" : "Left", p = k.toLowerCase(), M = h ? "left" : "top", S = h ? "bottom" : "right", AA = getOuterSizes(g)[d];
  n[S] - AA < c[p] && (o.offsets.popper[p] -= c[p] - (n[S] - AA)), n[p] + AA > c[S] && (o.offsets.popper[p] += n[p] + AA - c[S]), o.offsets.popper = getClientRect(o.offsets.popper);
  var H = n[p] + n[d] / 2 - AA / 2, gA = getStyleComputedProperty(o.instance.popper), CA = parseFloat(gA["margin" + k]), IA = parseFloat(gA["border" + k + "Width"]), BA = H - o.offsets.popper[p] - CA - IA;
  return BA = Math.max(Math.min(c[d] - AA, BA), 0), o.arrowElement = g, o.offsets.arrow = (A = {}, defineProperty(A, p, Math.round(BA)), defineProperty(A, M, ""), A), o;
}
function getOppositeVariation(o) {
  return o === "end" ? "start" : o === "start" ? "end" : o;
}
var placements = ["auto-start", "auto", "auto-end", "top-start", "top", "top-end", "right-start", "right", "right-end", "bottom-end", "bottom", "bottom-start", "left-end", "left", "left-start"], validPlacements = placements.slice(3);
function clockwise(o) {
  var E = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, A = validPlacements.indexOf(o), g = validPlacements.slice(A + 1).concat(validPlacements.slice(0, A));
  return E ? g.reverse() : g;
}
var BEHAVIORS = {
  FLIP: "flip",
  CLOCKWISE: "clockwise",
  COUNTERCLOCKWISE: "counterclockwise"
};
function flip(o, E) {
  if (isModifierEnabled(o.instance.modifiers, "inner") || o.flipped && o.placement === o.originalPlacement)
    return o;
  var A = getBoundaries(o.instance.popper, o.instance.reference, E.padding, E.boundariesElement, o.positionFixed), g = o.placement.split("-")[0], e = getOppositePlacement(g), t = o.placement.split("-")[1] || "", c = [];
  switch (E.behavior) {
    case BEHAVIORS.FLIP:
      c = [g, e];
      break;
    case BEHAVIORS.CLOCKWISE:
      c = clockwise(g);
      break;
    case BEHAVIORS.COUNTERCLOCKWISE:
      c = clockwise(g, !0);
      break;
    default:
      c = E.behavior;
  }
  return c.forEach(function(n, h) {
    if (g !== n || c.length === h + 1)
      return o;
    g = o.placement.split("-")[0], e = getOppositePlacement(g);
    var d = o.offsets.popper, k = o.offsets.reference, p = Math.floor, M = g === "left" && p(d.right) > p(k.left) || g === "right" && p(d.left) < p(k.right) || g === "top" && p(d.bottom) > p(k.top) || g === "bottom" && p(d.top) < p(k.bottom), S = p(d.left) < p(A.left), AA = p(d.right) > p(A.right), H = p(d.top) < p(A.top), gA = p(d.bottom) > p(A.bottom), CA = g === "left" && S || g === "right" && AA || g === "top" && H || g === "bottom" && gA, IA = ["top", "bottom"].indexOf(g) !== -1, BA = !!E.flipVariations && (IA && t === "start" && S || IA && t === "end" && AA || !IA && t === "start" && H || !IA && t === "end" && gA), QA = !!E.flipVariationsByContent && (IA && t === "start" && AA || IA && t === "end" && S || !IA && t === "start" && gA || !IA && t === "end" && H), EA = BA || QA;
    (M || CA || EA) && (o.flipped = !0, (M || CA) && (g = c[h + 1]), EA && (t = getOppositeVariation(t)), o.placement = g + (t ? "-" + t : ""), o.offsets.popper = _extends$w({}, o.offsets.popper, getPopperOffsets(o.instance.popper, o.offsets.reference, o.placement)), o = runModifiers(o.instance.modifiers, o, "flip"));
  }), o;
}
function keepTogether(o) {
  var E = o.offsets, A = E.popper, g = E.reference, e = o.placement.split("-")[0], t = Math.floor, c = ["top", "bottom"].indexOf(e) !== -1, n = c ? "right" : "bottom", h = c ? "left" : "top", d = c ? "width" : "height";
  return A[n] < t(g[h]) && (o.offsets.popper[h] = t(g[h]) - A[d]), A[h] > t(g[n]) && (o.offsets.popper[h] = t(g[n])), o;
}
function toValue(o, E, A, g) {
  var e = o.match(/((?:\-|\+)?\d*\.?\d*)(.*)/), t = +e[1], c = e[2];
  if (!t)
    return o;
  if (c.indexOf("%") === 0) {
    var n = void 0;
    switch (c) {
      case "%p":
        n = A;
        break;
      case "%":
      case "%r":
      default:
        n = g;
    }
    var h = getClientRect(n);
    return h[E] / 100 * t;
  } else if (c === "vh" || c === "vw") {
    var d = void 0;
    return c === "vh" ? d = Math.max(document.documentElement.clientHeight, window.innerHeight || 0) : d = Math.max(document.documentElement.clientWidth, window.innerWidth || 0), d / 100 * t;
  } else
    return t;
}
function parseOffset(o, E, A, g) {
  var e = [0, 0], t = ["right", "left"].indexOf(g) !== -1, c = o.split(/(\+|\-)/).map(function(k) {
    return k.trim();
  }), n = c.indexOf(find$2(c, function(k) {
    return k.search(/,|\s/) !== -1;
  }));
  c[n] && c[n].indexOf(",") === -1 && console.warn("Offsets separated by white space(s) are deprecated, use a comma (,) instead.");
  var h = /\s*,\s*|\s+/, d = n !== -1 ? [c.slice(0, n).concat([c[n].split(h)[0]]), [c[n].split(h)[1]].concat(c.slice(n + 1))] : [c];
  return d = d.map(function(k, p) {
    var M = (p === 1 ? !t : t) ? "height" : "width", S = !1;
    return k.reduce(function(AA, H) {
      return AA[AA.length - 1] === "" && ["+", "-"].indexOf(H) !== -1 ? (AA[AA.length - 1] = H, S = !0, AA) : S ? (AA[AA.length - 1] += H, S = !1, AA) : AA.concat(H);
    }, []).map(function(AA) {
      return toValue(AA, M, E, A);
    });
  }), d.forEach(function(k, p) {
    k.forEach(function(M, S) {
      isNumeric(M) && (e[p] += M * (k[S - 1] === "-" ? -1 : 1));
    });
  }), e;
}
function offset(o, E) {
  var A = E.offset, g = o.placement, e = o.offsets, t = e.popper, c = e.reference, n = g.split("-")[0], h = void 0;
  return isNumeric(+A) ? h = [+A, 0] : h = parseOffset(A, t, c, n), n === "left" ? (t.top += h[0], t.left -= h[1]) : n === "right" ? (t.top += h[0], t.left += h[1]) : n === "top" ? (t.left += h[0], t.top -= h[1]) : n === "bottom" && (t.left += h[0], t.top += h[1]), o.popper = t, o;
}
function preventOverflow(o, E) {
  var A = E.boundariesElement || getOffsetParent(o.instance.popper);
  o.instance.reference === A && (A = getOffsetParent(A));
  var g = getSupportedPropertyName("transform"), e = o.instance.popper.style, t = e.top, c = e.left, n = e[g];
  e.top = "", e.left = "", e[g] = "";
  var h = getBoundaries(o.instance.popper, o.instance.reference, E.padding, A, o.positionFixed);
  e.top = t, e.left = c, e[g] = n, E.boundaries = h;
  var d = E.priority, k = o.offsets.popper, p = {
    primary: function(S) {
      var AA = k[S];
      return k[S] < h[S] && !E.escapeWithReference && (AA = Math.max(k[S], h[S])), defineProperty({}, S, AA);
    },
    secondary: function(S) {
      var AA = S === "right" ? "left" : "top", H = k[AA];
      return k[S] > h[S] && !E.escapeWithReference && (H = Math.min(k[AA], h[S] - (S === "right" ? k.width : k.height))), defineProperty({}, AA, H);
    }
  };
  return d.forEach(function(M) {
    var S = ["left", "top"].indexOf(M) !== -1 ? "primary" : "secondary";
    k = _extends$w({}, k, p[S](M));
  }), o.offsets.popper = k, o;
}
function shift(o) {
  var E = o.placement, A = E.split("-")[0], g = E.split("-")[1];
  if (g) {
    var e = o.offsets, t = e.reference, c = e.popper, n = ["bottom", "top"].indexOf(A) !== -1, h = n ? "left" : "top", d = n ? "width" : "height", k = {
      start: defineProperty({}, h, t[h]),
      end: defineProperty({}, h, t[h] + t[d] - c[d])
    };
    o.offsets.popper = _extends$w({}, c, k[g]);
  }
  return o;
}
function hide(o) {
  if (!isModifierRequired(o.instance.modifiers, "hide", "preventOverflow"))
    return o;
  var E = o.offsets.reference, A = find$2(o.instance.modifiers, function(g) {
    return g.name === "preventOverflow";
  }).boundaries;
  if (E.bottom < A.top || E.left > A.right || E.top > A.bottom || E.right < A.left) {
    if (o.hide === !0)
      return o;
    o.hide = !0, o.attributes["x-out-of-boundaries"] = "";
  } else {
    if (o.hide === !1)
      return o;
    o.hide = !1, o.attributes["x-out-of-boundaries"] = !1;
  }
  return o;
}
function inner(o) {
  var E = o.placement, A = E.split("-")[0], g = o.offsets, e = g.popper, t = g.reference, c = ["left", "right"].indexOf(A) !== -1, n = ["top", "left"].indexOf(A) === -1;
  return e[c ? "left" : "top"] = t[A] - (n ? e[c ? "width" : "height"] : 0), o.placement = getOppositePlacement(E), o.offsets.popper = getClientRect(e), o;
}
var modifiers = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: !0,
    /** @prop {ModifierFn} */
    fn: shift
  },
  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: !0,
    /** @prop {ModifierFn} */
    fn: offset,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },
  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: !0,
    /** @prop {ModifierFn} */
    fn: preventOverflow,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ["left", "right", "top", "bottom"],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: "scrollParent"
  },
  /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: !0,
    /** @prop {ModifierFn} */
    fn: keepTogether
  },
  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: !0,
    /** @prop {ModifierFn} */
    fn: arrow,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: "[x-arrow]"
  },
  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: !0,
    /** @prop {ModifierFn} */
    fn: flip,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */
    behavior: "flip",
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */
    boundariesElement: "viewport",
    /**
     * @prop {Boolean} flipVariations=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the reference element overlaps its boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariations: !1,
    /**
     * @prop {Boolean} flipVariationsByContent=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the popper element overlaps its reference boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariationsByContent: !1
  },
  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: !1,
    /** @prop {ModifierFn} */
    fn: inner
  },
  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: !0,
    /** @prop {ModifierFn} */
    fn: hide
  },
  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: !0,
    /** @prop {ModifierFn} */
    fn: computeStyle,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: !0,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: "bottom",
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: "right"
  },
  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: !0,
    /** @prop {ModifierFn} */
    fn: applyStyle,
    /** @prop {Function} */
    onLoad: applyStyleOnLoad,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: void 0
  }
}, Defaults = {
  /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */
  placement: "bottom",
  /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */
  positionFixed: !1,
  /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: !0,
  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: !1,
  /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function o() {
  },
  /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function o() {
  },
  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */
  modifiers
}, Popper = (function() {
  function o(E, A) {
    var g = this, e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    classCallCheck(this, o), this.scheduleUpdate = function() {
      return requestAnimationFrame(g.update);
    }, this.update = debounce$1(this.update.bind(this)), this.options = _extends$w({}, o.Defaults, e), this.state = {
      isDestroyed: !1,
      isCreated: !1,
      scrollParents: []
    }, this.reference = E && E.jquery ? E[0] : E, this.popper = A && A.jquery ? A[0] : A, this.options.modifiers = {}, Object.keys(_extends$w({}, o.Defaults.modifiers, e.modifiers)).forEach(function(c) {
      g.options.modifiers[c] = _extends$w({}, o.Defaults.modifiers[c] || {}, e.modifiers ? e.modifiers[c] : {});
    }), this.modifiers = Object.keys(this.options.modifiers).map(function(c) {
      return _extends$w({
        name: c
      }, g.options.modifiers[c]);
    }).sort(function(c, n) {
      return c.order - n.order;
    }), this.modifiers.forEach(function(c) {
      c.enabled && isFunction$1(c.onLoad) && c.onLoad(g.reference, g.popper, g.options, c, g.state);
    }), this.update();
    var t = this.options.eventsEnabled;
    t && this.enableEventListeners(), this.state.eventsEnabled = t;
  }
  return createClass(o, [{
    key: "update",
    value: function() {
      return update.call(this);
    }
  }, {
    key: "destroy",
    value: function() {
      return destroy.call(this);
    }
  }, {
    key: "enableEventListeners",
    value: function() {
      return enableEventListeners.call(this);
    }
  }, {
    key: "disableEventListeners",
    value: function() {
      return disableEventListeners.call(this);
    }
    /**
     * Schedules an update. It will run on the next UI update available.
     * @method scheduleUpdate
     * @memberof Popper
     */
    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */
  }]), o;
})();
Popper.Utils = (typeof window < "u" ? window : global).PopperUtils;
Popper.placements = placements;
Popper.Defaults = Defaults;
function toPopperPlacement(o) {
  return o.replace(/(Top|Left)$/, "-start").replace(/(Right|Bottom)$/, "-end");
}
function parsePopperOffset(o) {
  return {
    top: Math.floor(o.top || 0),
    left: Math.floor(o.left || 0)
  };
}
var TETHER_PLACEMENT = {
  auto: "auto"
};
function _typeof$h(o) {
  "@babel/helpers - typeof";
  return _typeof$h = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(E) {
    return typeof E;
  } : function(E) {
    return E && typeof Symbol == "function" && E.constructor === Symbol && E !== Symbol.prototype ? "symbol" : typeof E;
  }, _typeof$h(o);
}
var _excluded$p = ["modifiers"];
function ownKeys$q(o, E) {
  var A = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var g = Object.getOwnPropertySymbols(o);
    E && (g = g.filter(function(e) {
      return Object.getOwnPropertyDescriptor(o, e).enumerable;
    })), A.push.apply(A, g);
  }
  return A;
}
function _objectSpread$o(o) {
  for (var E = 1; E < arguments.length; E++) {
    var A = arguments[E] != null ? arguments[E] : {};
    E % 2 ? ownKeys$q(Object(A), !0).forEach(function(g) {
      _defineProperty$v(o, g, A[g]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(A)) : ownKeys$q(Object(A)).forEach(function(g) {
      Object.defineProperty(o, g, Object.getOwnPropertyDescriptor(A, g));
    });
  }
  return o;
}
function _objectWithoutProperties$r(o, E) {
  if (o == null) return {};
  var A = _objectWithoutPropertiesLoose$r(o, E), g, e;
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    for (e = 0; e < t.length; e++)
      g = t[e], !(E.indexOf(g) >= 0) && Object.prototype.propertyIsEnumerable.call(o, g) && (A[g] = o[g]);
  }
  return A;
}
function _objectWithoutPropertiesLoose$r(o, E) {
  if (o == null) return {};
  var A = {}, g = Object.keys(o), e, t;
  for (t = 0; t < g.length; t++)
    e = g[t], !(E.indexOf(e) >= 0) && (A[e] = o[e]);
  return A;
}
function _classCallCheck$e(o, E) {
  if (!(o instanceof E))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$e(o, E) {
  for (var A = 0; A < E.length; A++) {
    var g = E[A];
    g.enumerable = g.enumerable || !1, g.configurable = !0, "value" in g && (g.writable = !0), Object.defineProperty(o, g.key, g);
  }
}
function _createClass$e(o, E, A) {
  return E && _defineProperties$e(o.prototype, E), Object.defineProperty(o, "prototype", { writable: !1 }), o;
}
function _inherits$e(o, E) {
  if (typeof E != "function" && E !== null)
    throw new TypeError("Super expression must either be null or a function");
  o.prototype = Object.create(E && E.prototype, { constructor: { value: o, writable: !0, configurable: !0 } }), Object.defineProperty(o, "prototype", { writable: !1 }), E && _setPrototypeOf$f(o, E);
}
function _setPrototypeOf$f(o, E) {
  return _setPrototypeOf$f = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(g, e) {
    return g.__proto__ = e, g;
  }, _setPrototypeOf$f(o, E);
}
function _createSuper$e(o) {
  var E = _isNativeReflectConstruct$e();
  return function() {
    var g = _getPrototypeOf$e(o), e;
    if (E) {
      var t = _getPrototypeOf$e(this).constructor;
      e = Reflect.construct(g, arguments, t);
    } else
      e = g.apply(this, arguments);
    return _possibleConstructorReturn$e(this, e);
  };
}
function _possibleConstructorReturn$e(o, E) {
  if (E && (_typeof$h(E) === "object" || typeof E == "function"))
    return E;
  if (E !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$f(o);
}
function _assertThisInitialized$f(o) {
  if (o === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return o;
}
function _isNativeReflectConstruct$e() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function _getPrototypeOf$e(o) {
  return _getPrototypeOf$e = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(A) {
    return A.__proto__ || Object.getPrototypeOf(A);
  }, _getPrototypeOf$e(o);
}
function _defineProperty$v(o, E, A) {
  return E in o ? Object.defineProperty(o, E, { value: A, enumerable: !0, configurable: !0, writable: !0 }) : o[E] = A, o;
}
var Tether = /* @__PURE__ */ (function(o) {
  _inherits$e(A, o);
  var E = _createSuper$e(A);
  function A() {
    var g;
    _classCallCheck$e(this, A);
    for (var e = arguments.length, t = new Array(e), c = 0; c < e; c++)
      t[c] = arguments[c];
    return g = E.call.apply(E, [this].concat(t)), _defineProperty$v(_assertThisInitialized$f(g), "popper", void 0), _defineProperty$v(_assertThisInitialized$f(g), "popperHeight", 0), _defineProperty$v(_assertThisInitialized$f(g), "popperWidth", 0), _defineProperty$v(_assertThisInitialized$f(g), "anchorHeight", 0), _defineProperty$v(_assertThisInitialized$f(g), "anchorWidth", 0), _defineProperty$v(_assertThisInitialized$f(g), "state", {
      isMounted: !1
    }), _defineProperty$v(_assertThisInitialized$f(g), "onPopperUpdate", function(n) {
      var h = {
        popper: parsePopperOffset(n.offsets.popper),
        arrow: n.offsets.arrow ? parsePopperOffset(n.offsets.arrow) : {
          top: 0,
          left: 0
        }
      };
      g.props.onPopperUpdate(h, n);
    }), g;
  }
  return _createClass$e(A, [{
    key: "componentDidMount",
    value: function() {
      this.setState({
        isMounted: !0
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function(e, t) {
      if (this.props.anchorRef) {
        var c = this.props.anchorRef.getBoundingClientRect(), n = c.height, h = c.width;
        (this.anchorHeight !== n || this.anchorWidth !== h) && (this.anchorHeight = n, this.anchorWidth = h, this.popper && this.popper.scheduleUpdate());
      }
      if (this.props.popperRef) {
        var d = this.props.popperRef.getBoundingClientRect(), k = d.height, p = d.width;
        (this.popperHeight !== k || this.popperWidth !== p) && (this.popperHeight = k, this.popperWidth = p, this.popper && this.popper.scheduleUpdate()), this.state.isMounted !== t.isMounted && (this.props.anchorRef ? this.initializePopper() : process.env.NODE_ENV !== "production" && console.warn(`[baseui][TetherBehavior] ref has not been passed to the Popper's anchor element.
              See how to pass the ref to an anchor element in the Popover example
              https://baseweb.design/components/popover/#anchor-ref-handling-example`));
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.destroyPopover();
    }
  }, {
    key: "initializePopper",
    value: function() {
      var e = this.props, t = e.placement, c = e.popperOptions, n = c.modifiers, h = _objectWithoutProperties$r(c, _excluded$p);
      !this.props.anchorRef || !this.props.popperRef || (this.popper = new Popper(this.props.anchorRef, this.props.popperRef, _objectSpread$o({
        // Recommended placement (popper may ignore if it causes a viewport overflow, etc)
        placement: toPopperPlacement(t),
        modifiers: _objectSpread$o({
          // Passing the arrow ref will measure the arrow when calculating styles
          arrow: {
            element: this.props.arrowRef,
            enabled: !!this.props.arrowRef
          },
          computeStyle: {
            // Make popper use top/left instead of transform translate, this is because
            // we use transform for animations and we dont want them to conflict
            gpuAcceleration: !1
          },
          applyStyle: {
            // Disable default styling modifier, we'll apply styles on our own
            enabled: !1
          },
          applyReactStyle: {
            enabled: !0,
            fn: this.onPopperUpdate,
            order: 900
          },
          preventOverflow: {
            enabled: !0
          }
        }, n)
      }, h)));
    }
  }, {
    key: "destroyPopover",
    value: function() {
      this.popper && (this.popper.destroy(), delete this.popper);
    }
  }, {
    key: "render",
    value: function() {
      return this.props.children || null;
    }
  }]), A;
})(React.Component);
_defineProperty$v(Tether, "defaultProps", {
  anchorRef: null,
  onPopperUpdate: function o() {
    return null;
  },
  placement: TETHER_PLACEMENT.auto,
  popperRef: null,
  popperOptions: {}
});
var BaseProvider = function o(E) {
  var A = E.children, g = E.overrides, e = E.theme, t = E.zIndex;
  return /* @__PURE__ */ React.createElement(LayersManager, {
    zIndex: t,
    overrides: g
  }, /* @__PURE__ */ React.createElement(UIDReset, {
    prefix: "bui"
  }, /* @__PURE__ */ React.createElement(ThemeProvider$1, {
    theme: e
  }, A)));
};
const createBaseUiThemePrimitives = (o, E) => {
  const {
    colors: A,
    genericFonts: g
  } = E;
  return {
    ...o,
    primaryFontFamily: g.bodyFont,
    primary100: A.primary,
    primary200: A.primary,
    primary300: A.primary,
    primary400: A.primary,
    primary500: A.primary,
    primary600: A.primary,
    primary700: A.primary,
    // Override gray values based on what is actually used in BaseWeb, and the
    // way we want it to match our theme originating from Bootstrap.
    mono100: A.bgColor,
    // Popup menu
    mono200: A.secondaryBg,
    // Text input, text area, selectbox
    mono300: A.gray30,
    // Disabled widget background
    mono400: A.gray30,
    // Slider track
    mono500: A.gray60,
    // Clicked checkbox and radio
    mono600: A.fadedText40,
    // Disabled widget text
    mono700: A.gray60,
    // Unselected checkbox and radio
    mono800: A.bodyText,
    // Selectbox text
    mono900: A.bodyText,
    // Not used, but just in case.
    mono1000: A.black
  };
}, createBaseUiThemeOverrides = (o) => {
  const {
    inSidebar: E,
    colors: A,
    genericFonts: g,
    fontSizes: e,
    lineHeights: t,
    radii: c
  } = o, n = {
    fontFamily: g.bodyFont,
    fontSize: e.md,
    fontSizeSm: e.sm,
    fontWeight: "normal",
    lineHeight: t.base,
    lineHeightTight: t.tight
  }, h = A.secondaryBg, d = E ? A.secondaryBg : A.bgColor, k = E ? A.bgColor : A.secondaryBg;
  return {
    borders: {
      // Override borders that are declared from literals in
      // https://github.com/uber/baseweb/blob/master/src/themes/shared/borders.ts
      radius100: c.default,
      radius200: c.default,
      radius300: c.default,
      radius400: c.default,
      radius500: c.default,
      /** Datepicker (Range), Progress Bar, Slider, Tag */
      useRoundedCorners: !0,
      /** Button, ButtonGroup */
      buttonBorderRadiusMini: c.md,
      // Unused today.
      buttonBorderRadius: c.default,
      /** Checkbox */
      checkboxBorderRadius: `min(${c.md}, ${c.maxCheckbox})`,
      /** Input, Select, Textarea */
      inputBorderRadiusMini: c.md,
      // Unused today.
      inputBorderRadius: c.default,
      /** Popover, Menu, Tooltip */
      popoverBorderRadius: c.default,
      /** Card, Datepicker, Modal, Toast, Notification */
      surfaceBorderRadius: c.default,
      /** Tag */
      tagBorderRadius: c.md
    },
    typography: {
      // Here we override some fonts that are used in widgets. We don't care
      // about the ones that are not used.
      font100: {},
      font150: {
        ...n
      },
      // Popup menus
      font200: {},
      font250: {},
      font300: {
        ...n
      },
      // Popup menus
      font350: {
        ...n
      },
      // Checkbox
      font400: {
        ...n
      },
      // Textinput, textarea, selectboxes
      font450: {
        ...n
      },
      // Radio
      font460: {
        ...n
      },
      // Calendar header buttons
      font470: {
        ...n
      },
      // Button
      font500: {
        ...n
      },
      // Selected items in selectbox
      font600: {},
      LabelXSmall: {
        ...n
      },
      LabelSmall: {
        ...n
      },
      LabelMedium: {
        ...n
      },
      LabelLarge: {
        ...n
      },
      ParagraphSmall: {
        ...n
      }
    },
    colors: {
      white: A.white,
      black: A.black,
      primary: A.primary,
      primaryA: A.primary,
      backgroundPrimary: A.bgColor,
      backgroundSecondary: h,
      backgroundTertiary: A.bgColor,
      borderOpaque: A.darkenedBgMix25,
      accent: transparentize(A.primary, 0.5),
      tagPrimarySolidBackground: A.primary,
      tagPrimaryFontDisabled: A.fadedText40,
      tagPrimaryOutlinedDisabled: A.transparent,
      borderSelected: A.primary,
      contentPrimary: A.bodyText,
      inputPlaceholder: A.fadedText60,
      tickFillDisabled: A.fadedText40,
      tickMarkFill: A.gray20,
      tickFillSelected: A.primary,
      datepickerBackground: d,
      calendarBackground: d,
      calendarForeground: A.bodyText,
      calendarDayForegroundPseudoSelected: A.bodyText,
      calendarHeaderBackground: k,
      calendarHeaderBackgroundActive: k,
      calendarHeaderForeground: A.bodyText,
      calendarHeaderForegroundDisabled: A.gray40,
      calendarDayBackgroundSelected: A.primary,
      calendarDayBackgroundSelectedHighlighted: A.primary,
      calendarDayForegroundSelected: A.white,
      calendarDayForegroundSelectedHighlighted: A.white,
      calendarDayForegroundPseudoSelectedHighlighted: A.bodyText,
      menuFontHighlighted: A.bodyText,
      menuFontSelected: A.bodyText,
      modalCloseColor: A.bodyText,
      notificationInfoBackground: A.blueBackgroundColor,
      notificationInfoText: A.blueTextColor,
      notificationPositiveBackground: A.greenBackgroundColor,
      notificationPositiveText: A.greenTextColor,
      notificationWarningBackground: A.yellowBackgroundColor,
      notificationWarningText: A.yellowTextColor,
      notificationNegativeBackground: A.redBackgroundColor,
      notificationNegativeText: A.redTextColor,
      progressbarTrackFill: h,
      // mono100 overrides
      tickFill: A.lightenedBg05,
      // Checkbox and Radio
      tickMarkFillDisabled: A.lightenedBg05,
      // We want menuFill to always use bgColor. But when in sidebar, bgColor and secondaryBg are
      // swapped! So here we unswap them.
      menuFill: d,
      // mono200 overrides
      buttonDisabledFill: A.lightenedBg05,
      tickFillHover: h,
      inputFillDisabled: h,
      inputFillActive: h,
      // mono300 overrides
      toggleTrackFillDisabled: h,
      tickFillActive: h,
      sliderTrackFillDisabled: h,
      inputBorder: A.widgetBorderColor || h,
      inputFill: h,
      inputEnhanceFill: h,
      inputEnhancerFillDisabled: h,
      // mono400 overrides
      buttonDisabledSpinnerBackground: A.gray40,
      toggleTrackFill: A.gray40,
      sliderTrackFill: A.gray40,
      sliderHandleInnerFill: A.gray40,
      sliderHandleInnerFillDisabled: A.gray40
    }
  };
}, createBaseUiTheme = (o, E = primitives) => createLightTheme(createBaseUiThemePrimitives(E, o), createBaseUiThemeOverrides(o)), computeDerivedColors = (o) => {
  const {
    bodyText: E,
    secondaryBg: A,
    bgColor: g
  } = o, e = getLuminance(g) > 0.5, t = transparentize(E, 0.9), c = transparentize(E, 0.8), n = transparentize(E, 0.7), h = transparentize(E, 0.6), d = transparentize(E, 0.4), k = mix$1(g, A, 0.5), p = e ? darken(k, 0.3) : lighten(k, 0.6), M = transparentize(p, 0.75), S = transparentize(p, 0.85), AA = lighten(g, 0.025);
  return {
    fadedText05: t,
    fadedText10: c,
    fadedText20: n,
    fadedText40: h,
    fadedText60: d,
    bgMix: k,
    darkenedBgMix100: p,
    darkenedBgMix25: M,
    darkenedBgMix15: S,
    lightenedBg05: AA
  };
};
function _isLightBackground(o) {
  return getLuminance(o) > 0.5;
}
function hasLightBackgroundColor(o) {
  return _isLightBackground(o.colors.bgColor);
}
const createEmotionColors = (o) => {
  const E = computeDerivedColors(o), A = defaultCategoricalColorsArray(o), g = defaultSequentialColorsArray(o);
  return {
    ...o,
    ...E,
    link: o.blueTextColor,
    codeTextColor: o.greenTextColor,
    codeBackgroundColor: E.bgMix,
    borderColor: E.fadedText10,
    borderColorLight: E.fadedText05,
    dataframeBorderColor: E.fadedText05,
    dataframeHeaderBackgroundColor: E.bgMix,
    headingColor: o.bodyText,
    chartCategoricalColors: A,
    chartSequentialColors: g
  };
};
function getDividerColors(o) {
  const {
    redColor: E,
    orangeColor: A,
    yellowColor: g,
    blueColor: e,
    greenColor: t,
    violetColor: c,
    grayColor: n
  } = o.colors;
  return {
    red: E,
    orange: A,
    yellow: g,
    blue: e,
    green: t,
    violet: c,
    gray: n,
    grey: n,
    rainbow: `linear-gradient(to right, ${E}, ${A}, ${g}, ${t}, ${e}, ${c})`
  };
}
function getMetricColor(o, E) {
  switch (E) {
    case Metric$1.MetricColor.RED:
      return o.colors.redColor;
    case Metric$1.MetricColor.GREEN:
      return o.colors.greenColor;
    // this must be grey
    default:
      return o.colors.grayColor;
  }
}
function getMarkdownBgColors(o) {
  const E = hasLightBackgroundColor(o), A = o.colors;
  return {
    redbg: A.redBackgroundColor,
    orangebg: A.orangeBackgroundColor,
    yellowbg: A.yellowBackgroundColor,
    bluebg: A.blueBackgroundColor,
    greenbg: A.greenBackgroundColor,
    violetbg: A.violetBackgroundColor,
    purplebg: transparentize(A[E ? "purple90" : "purple80"], E ? 0.9 : 0.7),
    graybg: A.grayBackgroundColor,
    primarybg: transparentize(A.primary, E ? 0.9 : 0.7)
  };
}
function getMetricBackgroundColor(o, E) {
  switch (E) {
    case Metric$1.MetricColor.RED:
      return o.colors.redBackgroundColor;
    case Metric$1.MetricColor.GREEN:
      return o.colors.greenBackgroundColor;
    // this must be grey
    default:
      return o.colors.grayBackgroundColor;
  }
}
function getMarkdownTextColors(o) {
  const E = hasLightBackgroundColor(o), A = o.colors, g = A.primary, e = A.redTextColor, t = A.orangeTextColor, c = A.yellowTextColor, n = A.blueTextColor, h = A.greenTextColor, d = A.violetTextColor, k = E ? A.purple100 : A.purple80, p = A.grayTextColor;
  return {
    red: e,
    orange: t,
    yellow: c,
    green: h,
    blue: n,
    violet: d,
    purple: k,
    gray: p,
    primary: g
  };
}
function getMetricTextColor(o, E) {
  switch (E) {
    case Metric$1.MetricColor.RED:
      return o.colors.redTextColor;
    case Metric$1.MetricColor.GREEN:
      return o.colors.greenTextColor;
    // this must be grey
    default:
      return o.colors.grayTextColor;
  }
}
function getGray70(o) {
  return hasLightBackgroundColor(o) ? o.colors.gray70 : o.colors.gray30;
}
function getGray30(o) {
  return hasLightBackgroundColor(o) ? o.colors.gray30 : o.colors.gray85;
}
function getGray90(o) {
  return hasLightBackgroundColor(o) ? o.colors.gray90 : o.colors.gray10;
}
function getBlue80(o) {
  return hasLightBackgroundColor(o) ? o.colors.blue80 : o.colors.blue40;
}
function getBlueArrayAsc(o) {
  return [o.blue10, o.blue20, o.blue30, o.blue40, o.blue50, o.blue60, o.blue70, o.blue80, o.blue90, o.blue100];
}
function getBlueArrayDesc(o) {
  return [o.blue100, o.blue90, o.blue80, o.blue70, o.blue60, o.blue50, o.blue40, o.blue30, o.blue20, o.blue10];
}
function getDivergingColorsArray(o) {
  const {
    colors: E
  } = o;
  return [E.red100, E.red90, E.red70, E.red50, E.red30, E.blue30, E.blue50, E.blue70, E.blue90, E.blue100];
}
function defaultSequentialColorsArray(o) {
  return _isLightBackground(o.bgColor) ? getBlueArrayAsc(o) : getBlueArrayDesc(o);
}
function defaultCategoricalColorsArray(o) {
  return _isLightBackground(o.bgColor) ? [o.blue80, o.blue40, o.red80, o.red40, o.blueGreen80, o.green40, o.orange80, o.orange50, o.purple80, o.gray40] : [o.blue40, o.blue80, o.red40, o.red80, o.green40, o.blueGreen80, o.orange50, o.orange80, o.purple80, o.gray40];
}
function getDecreasingRed(o) {
  return hasLightBackgroundColor(o) ? o.colors.red80 : o.colors.red40;
}
function getIncreasingGreen(o) {
  return hasLightBackgroundColor(o) ? o.colors.blueGreen80 : o.colors.green40;
}
const breakpoints = {
  // This value is used to determine whether we should hide/show the "Please enter to apply" in all widgets.
  hideWidgetDetails: 180,
  // This value is used to determine whether we should hide/show the - and + buttons in st.number_input.
  hideNumberInputControls: 120,
  sm: "576px",
  columns: "640px",
  md: "768px"
}, colors = {
  transparent: "transparent",
  black: "#000000",
  white: "#ffffff",
  gray10: "#fafafa",
  gray20: "#f0f2f6",
  gray30: "#e6eaf1",
  gray40: "#d5dae5",
  gray50: "#bfc5d3",
  gray60: "#a3a8b8",
  gray70: "#808495",
  gray80: "#555867",
  gray85: "#31333F",
  gray90: "#262730",
  gray100: "#0e1117",
  red10: "#fff0f0",
  red20: "#ffdede",
  red30: "#ffc7c7",
  red40: "#ffabab",
  red50: "#ff8c8c",
  red60: "#ff6c6c",
  red70: "#ff4b4b",
  red80: "#ff2b2b",
  red90: "#bd4043",
  red100: "#7d353b",
  orange10: "#fffae8",
  orange20: "#fff6d0",
  orange30: "#ffecb0",
  orange40: "#ffe08e",
  orange50: "#ffd16a",
  orange60: "#ffbd45",
  orange70: "#ffa421",
  orange80: "#ff8700",
  orange90: "#ed6f13",
  orange95: "#e2660c",
  orange100: "#d95a00",
  yellow10: "#ffffe1",
  yellow20: "#ffffc2",
  yellow30: "#ffffa0",
  yellow40: "#ffff7d",
  yellow50: "#ffff59",
  yellow60: "#fff835",
  yellow65: "#ffff12",
  yellow70: "#ffe312",
  yellow80: "#faca2b",
  yellow90: "#edbb16",
  yellow100: "#dea816",
  yellow110: "#916e10",
  yellow115: "#926c05",
  green10: "#dffde9",
  green20: "#c0fcd3",
  green30: "#9ef6bb",
  green40: "#7defa1",
  green50: "#5ce488",
  green60: "#3dd56d",
  green70: "#21c354",
  green80: "#09ab3b",
  green90: "#158237",
  green100: "#177233",
  blueGreen10: "#dcfffb",
  blueGreen20: "#bafff7",
  blueGreen30: "#93ffee",
  blueGreen40: "#6bfde3",
  blueGreen50: "#45f4d5",
  blueGreen60: "#20e7c5",
  blueGreen70: "#00d4b1",
  blueGreen80: "#29b09d",
  blueGreen90: "#2c867c",
  blueGreen100: "#246e69",
  lightBlue10: "#e0feff",
  lightBlue20: "#bffdff",
  lightBlue30: "#9af8ff",
  lightBlue40: "#73efff",
  lightBlue50: "#4be4ff",
  lightBlue60: "#24d4ff",
  lightBlue70: "#00c0f2",
  lightBlue80: "#00a4d4",
  lightBlue90: "#0d8cb5",
  lightBlue100: "#15799e",
  blue10: "#e4f5ff",
  blue20: "#c7ebff",
  blue30: "#a6dcff",
  blue40: "#83c9ff",
  blue50: "#60b4ff",
  blue60: "#3d9df3",
  blue65: "#1c83ff",
  blue70: "#1c83e1",
  blue80: "#0068c9",
  blue90: "#0054a3",
  blue100: "#004280",
  purple10: "#f5ebff",
  purple20: "#ebd6ff",
  purple30: "#dbbbff",
  purple40: "#c89dff",
  purple50: "#b27eff",
  purple60: "#9a5dff",
  purple70: "#803df5",
  purple80: "#6d3fc0",
  purple90: "#583f84",
  purple100: "#3f3163"
}, iconSizes = {
  xs: "0.5rem",
  sm: "0.75rem",
  md: "0.9rem",
  base: "1rem",
  lg: "1.25rem",
  xl: "1.5rem",
  twoXL: "1.8rem",
  threeXL: "2.3rem"
}, radii = {
  md: "0.25rem",
  // This is the default radius used in most elements:
  default: "0.5rem",
  xl: "0.75rem",
  xxl: "1rem",
  // Radius specific to buttons (enables buttonRadius config):
  button: "0.5rem",
  // Chat input enforces a more rounded look:
  chatInput: "1.25rem",
  // Ensures that the element is fully rounded:
  full: "9999px",
  // The maximum radius for checkboxes to still be recognizable as a checkbox:
  maxCheckbox: "0.35rem"
}, sizes = {
  full: "100%",
  headerHeight: "3.75rem",
  // Old header height to avoid addtl cascading visual/snapshot changes
  fullScreenHeaderHeight: "2.875rem",
  sidebarTopSpace: "6rem",
  toastWidth: "21rem",
  // Use px here since we want to keep the width the same
  // regardless of the root font size.
  contentMaxWidth: "736px",
  maxChartTooltipWidth: "30rem",
  // Used for checkboxes, radio, and toggles:
  checkbox: "1rem",
  borderWidth: "1px",
  // Used for checkboxes/toggle
  smallElementHeight: "1.5rem",
  // min height used for most input widgets
  minElementHeight: "2.5rem",
  // min height for larger input widgets like text area and audio input
  largestElementHeight: "4.25rem",
  smallLogoHeight: "1.25rem",
  defaultLogoHeight: "1.5rem",
  largeLogoHeight: "2rem",
  sliderThumb: "0.75rem",
  wideSidePadding: "5rem",
  headerDecorationHeight: "0.125rem",
  appRunningMen: "1.6rem",
  appStatusMaxWidth: "20rem",
  spinnerSize: "1.375rem",
  spinnerThickness: "0.125rem",
  tabHeight: "2.5rem",
  // Min width used for popover and dialog:
  minPopupWidth: "20rem",
  maxTooltipHeight: "18.75rem",
  chatAvatarSize: "2rem",
  // Used for the clear icon used by some Input elements
  clearIconSize: "1.5em",
  numberInputControlsWidth: "2rem",
  emptyDropdownHeight: "5.625rem",
  dropdownItemHeight: "2.5rem",
  maxDropdownHeight: "18.75rem",
  appDefaultBottomPadding: "3.5rem",
  defaultMapHeight: "31.25rem",
  defaultChartHeight: "21.875rem",
  defaultChartWidth: "25rem",
  // The minimum width of the menu (used for the dataframe column menu)
  minMenuWidth: "8rem",
  minChatInputFileListHeight: "3rem",
  headerItemHeight: "1.75rem",
  headerRightContentMaxWidth: "12.5rem"
}, spacing = {
  px: "1px",
  none: "0",
  threeXS: "0.125rem",
  // 2px
  twoXS: "0.25rem",
  // 4px
  xs: "0.375rem",
  // 6px
  sm: "0.5rem",
  // 8px
  md: "0.75rem",
  // 12px
  lg: "1rem",
  // 16px
  xl: "1.25rem",
  // 20px
  twoXL: "1.5rem",
  // 24px
  threeXL: "2rem",
  // 32px
  fourXL: "4rem"
  // 64px
}, fonts = {
  sansSerif: '"Source Sans", sans-serif',
  monospace: '"Source Code Pro", monospace',
  serif: '"Source Serif", serif',
  materialIcons: "Material Symbols Rounded"
}, genericFonts = {
  bodyFont: fonts.sansSerif,
  codeFont: fonts.monospace,
  headingFont: fonts.sansSerif,
  iconFont: fonts.materialIcons
}, fontSizes = {
  // baseFontSize equals to md, but in pixels (this value can also be configured by the user)
  // The baseFontSize should only be used in global styles.
  baseFontSize: 16,
  twoSm: "0.75rem",
  sm: "0.875rem",
  md: "1rem",
  mdLg: "1.125rem",
  lg: "1.25rem",
  xl: "1.5rem",
  twoXL: "1.75rem",
  threeXL: "2.25rem",
  fourXL: "2.75rem",
  codeFontSize: "0.875rem",
  // Inline code font size as em value for proper scaling w/ headers, captions,
  // sidebar, etc.
  inlineCodeFontSize: "0.75em",
  // Header font sizes - unaffected by baseFontSize, configured via headingFontSizes
  h1FontSize: "2.75rem",
  h2FontSize: "2.25rem",
  h3FontSize: "1.75rem",
  h4FontSize: "1.5rem",
  h5FontSize: "1.25rem",
  h6FontSize: "1rem"
}, fontWeights = {
  normal: 400,
  semiBold: 500,
  bold: 600,
  extrabold: 700,
  // codeFontWeight separately configurable
  code: 400,
  codeBold: 600,
  codeExtraBold: 700,
  // baseFontWeight config does not affect headers
  // defaults set here for h1-h6
  h1FontWeight: 700,
  h2FontWeight: 600,
  h3FontWeight: 600,
  h4FontWeight: 600,
  h5FontWeight: 600,
  h6FontWeight: 600
}, lineHeights = {
  none: 1,
  headings: 1.2,
  tight: 1.25,
  inputWidget: 1.4,
  small: 1.5,
  base: 1.6,
  menuItem: 2
}, sidebar = 100, menuButton = sidebar + 10, balloons = 1e6, header = balloons - 10, bottom = sidebar - 1, sidebarMobile = balloons - 5, fullscreenWrapper = balloons + 50, headerDecoration = balloons - 1, popup = fullscreenWrapper + 10, tablePortal = fullscreenWrapper + 60, cacheSpinner = sidebar + 1, toast = popup + 1, zIndices = {
  hide: -1,
  auto: "auto",
  base: 0,
  // this is used if we want to ensure that an element
  // is shown above the parent elements.
  priority: 1,
  sidebar,
  menuButton,
  balloons,
  header,
  sidebarMobile,
  popup,
  fullscreenWrapper,
  tablePortal,
  bottom,
  cacheSpinner,
  toast,
  headerDecoration
}, requiredThemeColors = {
  bgColor: colors.white,
  secondaryBg: colors.gray20,
  bodyText: colors.gray85,
  primary: colors.red70,
  secondary: colors.blue70,
  // Used in progress bar
  // Default main theme colors (light theme)
  redColor: colors.red70,
  orangeColor: colors.orange70,
  yellowColor: colors.yellow80,
  blueColor: colors.blue70,
  greenColor: colors.green70,
  violetColor: colors.purple70,
  grayColor: colors.gray60,
  // Default background theme colors (light theme)
  redBackgroundColor: transparentize(colors.red80, 0.9),
  orangeBackgroundColor: transparentize(colors.orange70, 0.9),
  yellowBackgroundColor: transparentize(colors.yellow65, 0.9),
  blueBackgroundColor: transparentize(colors.blue65, 0.9),
  greenBackgroundColor: transparentize(colors.green70, 0.9),
  violetBackgroundColor: transparentize(colors.purple60, 0.9),
  grayBackgroundColor: transparentize(colors.gray85, 0.9),
  // Default text theme colors (light theme)
  redTextColor: colors.red90,
  orangeTextColor: colors.orange95,
  yellowTextColor: colors.yellow115,
  blueTextColor: colors.blue90,
  greenTextColor: colors.green90,
  violetTextColor: colors.purple90,
  grayTextColor: transparentize(colors.gray85, 0.4)
}, optionalThemeColors = {}, themeColors = {
  ...colors,
  ...requiredThemeColors,
  ...optionalThemeColors
}, emotionBaseTheme = {
  inSidebar: !1,
  showSidebarBorder: !1,
  linkUnderline: !0,
  breakpoints,
  colors: createEmotionColors(themeColors),
  fonts,
  fontSizes,
  fontWeights,
  genericFonts,
  iconSizes,
  lineHeights,
  radii,
  sizes,
  spacing,
  zIndices
}, genericColors$1 = {
  ...colors,
  bgColor: colors.gray100,
  bodyText: colors.gray10,
  primary: colors.red70,
  secondaryBg: colors.gray90,
  // Default main theme colors (dark theme)
  redColor: colors.red80,
  orangeColor: colors.orange80,
  yellowColor: colors.yellow70,
  blueColor: colors.blue80,
  greenColor: colors.green80,
  violetColor: colors.purple70,
  grayColor: colors.gray80,
  // Default background theme colors (dark theme)
  redBackgroundColor: transparentize(colors.red60, 0.8),
  orangeBackgroundColor: transparentize(colors.orange80, 0.8),
  yellowBackgroundColor: transparentize(colors.yellow65, 0.8),
  blueBackgroundColor: transparentize(colors.blue60, 0.8),
  greenBackgroundColor: transparentize(colors.green60, 0.8),
  violetBackgroundColor: transparentize(colors.purple60, 0.8),
  grayBackgroundColor: transparentize(colors.gray70, 0.8),
  // Default text theme colors (dark theme)
  redTextColor: colors.red60,
  orangeTextColor: colors.orange60,
  yellowTextColor: colors.yellow20,
  blueTextColor: colors.blue60,
  greenTextColor: colors.green50,
  violetTextColor: colors.purple50,
  grayTextColor: transparentize(colors.gray10, 0.4)
}, emotionDarkTheme = {
  ...emotionBaseTheme,
  inSidebar: !1,
  colors: createEmotionColors({
    ...emotionBaseTheme.colors,
    ...genericColors$1
  })
}, genericColors = {
  ...colors
}, emotionLightTheme = {
  ...emotionBaseTheme,
  inSidebar: !1,
  colors: createEmotionColors({
    ...emotionBaseTheme.colors,
    ...genericColors
  })
}, baseuiLightTheme = createBaseUiTheme(emotionLightTheme, primitives), baseuiDarkTheme = createBaseUiTheme(emotionDarkTheme, primitives$1), baseTheme = {
  name: "base",
  emotion: emotionBaseTheme,
  basewebTheme: baseuiLightTheme,
  primitives
}, darkTheme = {
  name: "Dark",
  emotion: emotionDarkTheme,
  basewebTheme: baseuiDarkTheme,
  primitives: primitives$1
}, lightTheme = {
  name: "Light",
  emotion: emotionLightTheme,
  basewebTheme: baseuiLightTheme,
  primitives
}, STALE_TRANSITION_PARAMS = "1s ease-in 0.5s", STALE_STYLES = {
  opacity: 0.33,
  transition: `opacity ${STALE_TRANSITION_PARAMS}`
}, CACHED_THEME_VERSION = 1, CACHED_THEME_BASE_KEY = `stActiveTheme-${window.location.pathname}`, LocalStore = {
  CACHED_THEME_VERSION,
  CACHED_THEME_BASE_KEY,
  ACTIVE_THEME: `${CACHED_THEME_BASE_KEY}-v${CACHED_THEME_VERSION}`
}, AUTO_THEME_NAME = "Use system setting", CUSTOM_THEME_NAME = "Custom Theme", CUSTOM_THEME_LIGHT_NAME = "Custom Theme Light", CUSTOM_THEME_DARK_NAME = "Custom Theme Dark", CUSTOM_THEME_AUTO_NAME = "Custom Theme Auto", LOG$d = loglevelExports$1.getLogger("theme:utils");
function sortThemeInputKeys(o) {
  if (o == null)
    return o;
  if (Array.isArray(o))
    return o.map((E) => sortThemeInputKeys(E));
  if (typeof o == "object") {
    const E = {};
    return Object.keys(o).sort().forEach((A) => {
      E[A] = sortThemeInputKeys(o[A]);
    }), E;
  }
  return o;
}
function mergeTheme(o, E) {
  if (E && isObject$3(E)) {
    const A = new CustomThemeConfig(E);
    return createTheme(o.name, A, o);
  }
  return o;
}
const getMergedLightTheme = once$1(() => mergeTheme(lightTheme, window.__streamlit?.LIGHT_THEME)), getMergedDarkTheme = once$1(() => mergeTheme(darkTheme, window.__streamlit?.DARK_THEME)), getSystemThemePreference = () => window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light", getSystemTheme = () => getSystemThemePreference() === "dark" ? getMergedDarkTheme() : getMergedLightTheme(), createAutoTheme = () => ({
  ...getSystemTheme(),
  name: AUTO_THEME_NAME
}), createPresetThemes = () => [createAutoTheme(), getMergedLightTheme(), getMergedDarkTheme()], isPresetTheme = (o) => createPresetThemes().map((A) => A.name).includes(o.name), bgColorToBaseString = (o) => o === void 0 || getLuminance(o) > 0.5 ? "light" : "dark", isColor = (o) => {
  const E = new Option().style;
  return E.color = o, E.color !== "";
}, roundFontSizeToNearestEighth = (o) => Math.round(o * 8) / 8, parseFont = (o, E = fonts.sansSerif) => {
  const A = o.trim();
  if (!A)
    return E;
  const g = {
    "sans-serif": fonts.sansSerif,
    serif: fonts.serif,
    monospace: fonts.monospace
  }, e = A.toLowerCase().replaceAll(" ", "-");
  return e in g ? g[e] : `${A}, ${E}`;
}, parseColor = (o, E, A = !1) => {
  if (isColor(o))
    return o;
  if (isColor(`#${o}`))
    return `#${o}`;
  if (E.toLowerCase().includes("color")) {
    const e = A ? "theme.sidebar" : "theme";
    LOG$d.warn(`Invalid color passed for ${E} in ${e}: "${o}"`);
  }
}, resolveBgColor = (o, E, A, g) => o || (E ? transparentize(E, g ? 0.9 : 0.8) : A), resolveTextColor = (o, E, A, g) => o || (E ? g ? darken(E, 0.15) : lighten(E, 0.15) : A), setBackgroundColors = (o, E) => {
  const A = {
    ...o
  }, g = {
    redBackgroundColor: {
      main: E.redColor,
      background: E.redBackgroundColor
    },
    orangeBackgroundColor: {
      main: E.orangeColor,
      background: E.orangeBackgroundColor
    },
    yellowBackgroundColor: {
      main: E.yellowColor,
      background: E.yellowBackgroundColor
    },
    blueBackgroundColor: {
      main: E.blueColor,
      background: E.blueBackgroundColor
    },
    greenBackgroundColor: {
      main: E.greenColor,
      background: E.greenBackgroundColor
    },
    violetBackgroundColor: {
      main: E.violetColor,
      background: E.violetBackgroundColor
    },
    grayBackgroundColor: {
      main: E.grayColor,
      background: E.grayBackgroundColor
    }
  }, e = getLuminance(A.bgColor) > 0.5;
  return Object.entries(g).forEach(([t, {
    main: c,
    background: n
  }]) => {
    const h = t;
    A[h] = resolveBgColor(n, c, o[h], e);
  }), A;
}, setTextColors = (o, E) => {
  const A = {
    ...o
  }, g = {
    redTextColor: {
      main: E.redColor,
      text: E.redTextColor
    },
    orangeTextColor: {
      main: E.orangeColor,
      text: E.orangeTextColor
    },
    yellowTextColor: {
      main: E.yellowColor,
      text: E.yellowTextColor
    },
    blueTextColor: {
      main: E.blueColor,
      text: E.blueTextColor
    },
    greenTextColor: {
      main: E.greenColor,
      text: E.greenTextColor
    },
    violetTextColor: {
      main: E.violetColor,
      text: E.violetTextColor
    },
    grayTextColor: {
      main: E.grayColor,
      text: E.grayTextColor
    }
  }, e = getLuminance(A.bgColor) > 0.5;
  return Object.entries(g).forEach(([t, {
    main: c,
    text: n
  }]) => {
    const h = t;
    A[h] = resolveTextColor(n, c, o[h], e);
  }), A;
}, parseRadius = (o) => {
  let E = "rem", A;
  const g = o.trim().toLowerCase();
  return g === "none" ? A = 0 : g === "small" ? A = 0.35 : g === "medium" ? A = 0.5 : g === "large" ? A = 1 : g === "full" ? A = 1.4 : g.endsWith("rem") ? A = parseFloat(g) : g.endsWith("px") ? (A = parseFloat(g), E = "px") : isNaN(parseFloat(g)) || (A = parseFloat(g), E = "px"), [A, E];
}, parseFontSize = (o, E, A) => {
  const g = A ? "theme.sidebar" : "theme";
  if (typeof E == "string") {
    const e = E.trim().toLowerCase(), t = parseFloat(e);
    if (t && (e.endsWith("rem") || e.endsWith("px")))
      return e;
    if (t.toString() === e)
      return `${e}px`;
  }
  LOG$d.warn(`Invalid size passed for ${o} in ${g}: ${E}. Falling back to default ${o}.`);
}, isValidFontWeight = (o, E, A, g, e) => {
  const t = e ? "theme.sidebar" : "theme";
  if (notNullOrUndefined(E)) {
    const c = Number.isInteger(E), n = E % 100 === 0, h = E >= A && E <= g;
    return !c || !n || !h ? (LOG$d.warn(`Invalid ${o}: ${E} in ${t}. The ${o} must be an integer ${A}-${g}, and an increment of 100. Falling back to default font weight.`), !1) : !0;
  }
  return !1;
}, convertHeadingFontSizeToRem = (o, E, A, g) => {
  const e = parseFontSize(o, E, g);
  if (e?.endsWith("rem"))
    return e;
  if (e?.endsWith("px"))
    return `${parseFloat(e) / A}rem`;
}, setHeadingFontSizes = (o, E, A, g) => {
  const e = {
    ...o
  };
  return g && g.forEach((t, c) => {
    const n = `h${c + 1}FontSize`, h = convertHeadingFontSizeToRem(`${n} in headingFontSizes`, t, A, E);
    h && (e[n] = h);
  }), e;
}, setFontWeights = (o, E, A, g, e) => {
  const t = {
    ...o,
    // Override default h1FontWeight for sidebar to 600
    // Default for main theme set in typography (700)
    h1FontWeight: E ? 600 : o.h1FontWeight
  };
  return A && isValidFontWeight("baseFontWeight", A, 100, 600) && (t.normal = A, t.semiBold = A + 100, t.bold = A + 200, t.extrabold = A + 300, t.code = A, t.codeBold = A + 200, t.codeExtraBold = A + 300), g && isValidFontWeight("codeFontWeight", g, 100, 600) && (t.code = g, t.codeBold = g + 200, t.codeExtraBold = g + 300), e && e.forEach((c, n) => {
    const h = `h${n + 1}FontWeight`;
    isValidFontWeight(`${h} in headingFontWeights`, c, 100, 900, E) && (t[h] = c);
  }), t;
}, validateChartColors = (o, E) => E.map((A) => parseColor(A, o)).filter((A) => A !== void 0), createEmotionTheme = (o, E = baseTheme) => {
  const {
    colors: A,
    genericFonts: g,
    inSidebar: e
  } = E.emotion, {
    baseFontSize: t,
    baseFontWeight: c,
    baseRadius: n,
    buttonRadius: h,
    codeFontSize: d,
    codeFontWeight: k,
    showWidgetBorder: p,
    headingFont: M,
    headingFontSizes: S,
    headingFontWeights: AA,
    bodyFont: H,
    codeFont: gA,
    showSidebarBorder: CA,
    linkUnderline: IA,
    // Since chart color configs passed as array, handle separate from parsedColors
    chartCategoricalColors: BA,
    chartSequentialColors: QA,
    ...EA
  } = o, oA = Object.entries(EA).reduce((YA, [LA, WA]) => {
    const zA = parseColor(WA, LA, e);
    return zA && (YA[LA] = zA), YA;
  }, {}), {
    secondaryBackgroundColor: iA,
    backgroundColor: aA,
    primaryColor: tA,
    textColor: eA,
    dataframeBorderColor: cA,
    dataframeHeaderBackgroundColor: DA,
    widgetBorderColor: nA,
    borderColor: wA,
    linkColor: lA,
    codeTextColor: NA,
    codeBackgroundColor: RA,
    redColor: KA,
    orangeColor: vA,
    yellowColor: GA,
    blueColor: FA,
    greenColor: HA,
    violetColor: sA,
    grayColor: mA
  } = oA, xA = {
    ...A,
    primary: tA ?? A.primary,
    bodyText: eA ?? A.bodyText,
    secondaryBg: iA ?? A.secondaryBg,
    bgColor: aA ?? A.bgColor,
    // Main theme colors
    redColor: KA ?? A.redColor,
    orangeColor: vA ?? A.orangeColor,
    yellowColor: GA ?? A.yellowColor,
    blueColor: FA ?? A.blueColor,
    greenColor: HA ?? A.greenColor,
    violetColor: sA ?? A.violetColor,
    grayColor: mA ?? A.grayColor,
    // Secondary color is not yet configurable. Set secondary color to primary color
    // by default for all custom themes.
    secondary: tA ?? A.primary
  }, hA = {
    colors: {
      ...createEmotionColors(xA)
    },
    showSidebarBorder: CA ?? E.emotion.showSidebarBorder,
    linkUnderline: IA ?? E.emotion.linkUnderline,
    // Copy over the default values for the other configurable theme properties
    radii: {
      ...E.emotion.radii
    },
    fontSizes: {
      ...E.emotion.fontSizes
    },
    fontWeights: {
      ...E.emotion.fontWeights
    }
  };
  if (hA.colors.codeBackgroundColor = RA ?? A.codeBackgroundColor, hA.colors.dataframeHeaderBackgroundColor = DA ?? A.dataframeHeaderBackgroundColor, notNullOrUndefined(wA)) {
    hA.colors.borderColor = wA;
    const YA = transparentize(wA, 0.55);
    hA.colors.borderColorLight = YA, hA.colors.dataframeBorderColor = YA;
  }
  if (notNullOrUndefined(cA) && (hA.colors.dataframeBorderColor = cA), (p || nA) && (hA.colors.widgetBorderColor = nA || hA.colors.borderColor), hA.colors = setBackgroundColors(hA.colors, oA), hA.colors = setTextColors(hA.colors, oA), hA.colors.link = lA ?? hA.colors.blueTextColor, hA.colors.codeTextColor = NA ?? hA.colors.greenTextColor, notNullOrUndefined(BA) && BA.length > 0) {
    const YA = validateChartColors("chartCategoricalColors", BA);
    YA.length > 0 && (hA.colors.chartCategoricalColors = YA);
  }
  if (notNullOrUndefined(QA) && QA.length > 0) {
    const YA = validateChartColors("chartSequentialColors", QA);
    YA.length === 10 ? hA.colors.chartSequentialColors = YA : LOG$d.warn(`Invalid chartSequentialColors: ${QA.toString()}. Falling back to default chartSequentialColors.`);
  }
  if (notNullOrUndefined(n)) {
    const [YA, LA] = parseRadius(n);
    if (notNullOrUndefined(YA) && !isNaN(YA)) {
      const WA = addCssUnit(YA, LA);
      hA.radii.default = WA, hA.radii.button = WA, hA.radii.md = addCssUnit(roundToTwoDecimals(YA * 0.5), LA), hA.radii.xl = addCssUnit(roundToTwoDecimals(YA * 1.5), LA), hA.radii.xxl = addCssUnit(roundToTwoDecimals(YA * 2), LA);
    } else
      LOG$d.warn(`Invalid base radius: ${n}. Falling back to default base radius.`);
  }
  if (notNullOrUndefined(h)) {
    const [YA, LA] = parseRadius(h);
    notNullOrUndefined(YA) && !isNaN(YA) ? hA.radii.button = addCssUnit(YA, LA) : LOG$d.warn(`Invalid button radius: ${h}. Falling back to default button radius.`);
  }
  if (t && t > 0 && (hA.fontSizes.baseFontSize = t), d) {
    const YA = parseFontSize("codeFontSize", d, e);
    YA && (hA.fontSizes.codeFontSize = YA);
  }
  hA.fontSizes = setHeadingFontSizes(hA.fontSizes, e, hA.fontSizes.baseFontSize, S), hA.fontWeights = setFontWeights(E.emotion.fontWeights, e, c, k, AA);
  const MA = {
    // Default values for the generic fonts
    ...g,
    // Override properties if configured
    bodyFont: H ? parseFont(H, fonts.sansSerif) : g.bodyFont,
    codeFont: gA ? parseFont(gA, fonts.monospace) : g.codeFont,
    headingFont: M ? parseFont(M, fonts.sansSerif) : g.headingFont
  };
  return H && !M && (MA.headingFont = parseFont(H, fonts.sansSerif)), {
    ...E.emotion,
    genericFonts: MA,
    ...hA
  };
}, toThemeInput = (o) => {
  const {
    colors: E
  } = o;
  return {
    primaryColor: E.primary,
    backgroundColor: E.bgColor,
    secondaryBackgroundColor: E.secondaryBg,
    textColor: E.bodyText,
    bodyFont: o.genericFonts.bodyFont
  };
}, toExportedTheme = (o) => {
  const {
    colors: E
  } = o, A = toThemeInput(o);
  return {
    primaryColor: A.primaryColor,
    backgroundColor: A.backgroundColor,
    secondaryBackgroundColor: A.secondaryBackgroundColor,
    textColor: A.textColor,
    bodyFont: A.bodyFont,
    base: bgColorToBaseString(A.backgroundColor),
    ...computeDerivedColors(E)
  };
}, completeThemeInput = (o, E) => new CustomThemeConfig({
  ...toThemeInput(E.emotion),
  ...o
}), createTheme = (o, E, A, g = !1) => {
  let e;
  A ? e = completeThemeInput(E, A) : E.base === CustomThemeConfig.BaseTheme.DARK ? e = completeThemeInput(E, darkTheme) : e = completeThemeInput(E, lightTheme);
  const t = e.backgroundColor, c = merge$1(cloneDeep(A || (getLuminance(t) > 0.5 ? lightTheme : darkTheme)), {
    emotion: {
      inSidebar: g
    }
  }), n = createEmotionTheme(e, c), h = cloneDeep(createBaseUiTheme(n, c.primitives));
  return {
    ...c,
    name: o,
    emotion: n,
    basewebTheme: h,
    themeInput: E
  };
}, getCachedTheme = () => {
  if (!localStorageAvailable())
    return null;
  const o = window.localStorage.getItem(LocalStore.ACTIVE_THEME);
  if (!o)
    return null;
  const {
    name: E,
    themeInput: A
  } = JSON.parse(o);
  switch (E) {
    case lightTheme.name:
      return getMergedLightTheme();
    case darkTheme.name:
      return getMergedDarkTheme();
    case CUSTOM_THEME_LIGHT_NAME:
      return {
        ...createTheme(E, A),
        displayName: "Light"
      };
    case CUSTOM_THEME_DARK_NAME:
      return {
        ...createTheme(E, A),
        displayName: "Dark"
      };
    default:
      return createTheme(E, A);
  }
}, deleteOldCachedThemes = () => {
  const {
    CACHED_THEME_VERSION: o,
    CACHED_THEME_BASE_KEY: E
  } = LocalStore, {
    localStorage: A
  } = window;
  A.removeItem("stActiveTheme"), A.removeItem(E);
  for (let g = 1; g <= o; g++)
    A.removeItem(`${E}-v${g}`);
}, setCachedTheme = (o) => {
  if (!localStorageAvailable() || (deleteOldCachedThemes(), isLightThemeInQueryParams() || isDarkThemeInQueryParams()))
    return;
  const E = {
    name: o.name,
    ...!isPresetTheme(o) && {
      themeInput: toThemeInput(o.emotion)
    }
  };
  window.localStorage.setItem(LocalStore.ACTIVE_THEME, JSON.stringify(E));
}, removeCachedTheme = () => {
  localStorageAvailable() && window.localStorage.removeItem(LocalStore.ACTIVE_THEME);
}, getHostSpecifiedTheme = () => isLightThemeInQueryParams() ? getMergedLightTheme() : isDarkThemeInQueryParams() ? getMergedDarkTheme() : createAutoTheme(), getDefaultTheme = () => {
  const o = getCachedTheme();
  return o && o.name !== AUTO_THEME_NAME ? o : getHostSpecifiedTheme();
}, whiteSpace = /\s+/;
function computeSpacingStyle(o, E) {
  return o === "" ? "" : o.split(whiteSpace).map((A) => A === "0" ? E.spacing.none : A in E.spacing ? E.spacing[A] : (LOG$d.error(`Invalid spacing value: ${A}`), E.spacing.none)).join(" ");
}
function addCssUnit(o, E) {
  return `${o}${E}`;
}
function roundToTwoDecimals(o) {
  return parseFloat(o.toFixed(2));
}
function blend(o, E) {
  if (E === void 0) return o;
  const [A, g, e, t] = parseToRgba(o);
  if (t === 1) return o;
  const [c, n, h, d] = parseToRgba(E), k = t + d * (1 - t), p = Math.round((t * A + d * c * (1 - t)) / k), M = Math.round((t * g + d * n * (1 - t)) / k), S = Math.round((t * e + d * h * (1 - t)) / k);
  return toHex(`rgba(${p}, ${M}, ${S}, ${k})`);
}
const convertRemToPx = (o) => (
  // TODO(lukasmasuch): We might want to somehow cache this value at some point.
  // However, I did experimented with the performance of calling this, and
  // it seems not like a big deal to call it many times.
  parseFloat(o.replace(/rem$/, "")) * // We fallback to 16px if the fontSize is not defined (should only happen in tests)
  (parseFloat(getComputedStyle(document.documentElement).fontSize) || 16)
), skipProtobufDefaults = (o, E) => {
  if (E === "" || E === null || Array.isArray(E) && E.length === 0)
    return o;
}, handleSectionInheritance = (o, E) => {
  const A = E === "light", g = A ? CustomThemeConfig.BaseTheme.LIGHT : CustomThemeConfig.BaseTheme.DARK, {
    light: e,
    dark: t,
    sidebar: c,
    ...n
  } = o, h = A ? e : t, {
    sidebar: d,
    ...k
  } = h || {}, p = mergeWith(
    {},
    n,
    // Common theme properties from themeInput
    k,
    // Variant-specific theme overrides (without sidebar)
    {
      base: g
    },
    // Set base last to override any base from commonTheme/variantTheme
    skipProtobufDefaults
  );
  return (c || d) && (p.sidebar = mergeWith({}, c, d, skipProtobufDefaults)), p;
}, hasThemeSectionConfigs = (o) => {
  if (!o)
    return !1;
  const E = (A) => A == null ? !1 : Array.isArray(A) ? A.length > 0 : typeof A == "object" ? Object.values(A).some(E) : !0;
  return Object.values(o).some(E);
}, createCustomThemes = (o) => {
  const E = hasThemeSectionConfigs(o.light), A = hasThemeSectionConfigs(o.dark), g = [];
  if (E || A) {
    const e = handleSectionInheritance(o, "light"), t = {
      ...createTheme(CUSTOM_THEME_LIGHT_NAME, e),
      displayName: "Light"
    }, c = handleSectionInheritance(o, "dark"), n = {
      ...createTheme(CUSTOM_THEME_DARK_NAME, c),
      displayName: "Dark"
    }, d = {
      ...getSystemThemePreference() === "dark" ? n : t,
      displayName: AUTO_THEME_NAME,
      name: CUSTOM_THEME_AUTO_NAME
    };
    g.push(t, n, d);
  } else {
    const e = createTheme(CUSTOM_THEME_NAME, o);
    g.push(e);
  }
  return g;
}, setSidebarHeadingFontSizes = (o) => merge$1([], ["1.5rem", "1.25rem", "1.125rem", "1rem", "0.875rem", "0.75rem"], o || []), createSidebarTheme = (o) => {
  const E = o.themeInput?.sidebar, {
    bgColor: A,
    secondaryBg: g
  } = o.emotion.colors, e = E?.backgroundColor || g, t = E?.secondaryBackgroundColor || A, c = setSidebarHeadingFontSizes(E?.headingFontSizes);
  let n = getLuminance(e) > 0.5 ? CustomThemeConfig.BaseTheme.LIGHT : CustomThemeConfig.BaseTheme.DARK;
  o.name === CUSTOM_THEME_LIGHT_NAME ? n = CustomThemeConfig.BaseTheme.LIGHT : o.name === CUSTOM_THEME_DARK_NAME && (n = CustomThemeConfig.BaseTheme.DARK);
  const h = mergeWith(
    {},
    o.themeInput,
    // Use the theme props from the main theme as basis
    E,
    // Merge sidebar configs
    {
      // Explicit overrides that should always be applied
      base: n,
      backgroundColor: e,
      secondaryBackgroundColor: t,
      headingFontSizes: c
    },
    skipProtobufDefaults
  );
  return createTheme(
    "Sidebar",
    h,
    void 0,
    // Creating a new theme from scratch
    !0
    // inSidebar
  );
}, THEME_MAPPING = {
  [lightTheme.name]: CUSTOM_THEME_LIGHT_NAME,
  [darkTheme.name]: CUSTOM_THEME_DARK_NAME,
  [CUSTOM_THEME_LIGHT_NAME]: lightTheme.name,
  [CUSTOM_THEME_DARK_NAME]: darkTheme.name
}, mapCachedThemeToAvailableTheme = (o, E) => {
  if (!o)
    return null;
  const A = E.find((e) => e.name === o.name);
  if (A)
    return A;
  const g = THEME_MAPPING[o.name];
  return g ? E.find((e) => e.name === g) ?? null : null;
}, isPositiveNumber = (o) => typeof o == "number" && o >= 0 && !isNaN(o), isNonZeroPositiveNumber = (o) => typeof o == "number" && o > 0 && !isNaN(o), getWidth = (o, E) => {
  if (E?.useContainerWidth)
    return {
      type: "stretch"
      /* STRETCH */
    };
  const A = o.widthConfig?.useStretch || E?.widthConfig?.useStretch, g = o?.widthConfig?.useContent || E?.widthConfig?.useContent, e = o?.widthConfig?.pixelWidth || E?.widthConfig?.pixelWidth || o.widthConfig?.pixelWidth === 0, t = o.widthConfig?.remWidth;
  return A ? {
    type: "stretch"
    /* STRETCH */
  } : g ? {
    type: "content"
    /* CONTENT */
  } : t && isPositiveNumber(o.widthConfig?.remWidth) ? {
    type: "rem",
    rem: o.widthConfig.remWidth
  } : e && isPositiveNumber(o.widthConfig?.pixelWidth) ? {
    type: "pixel",
    pixels: o.widthConfig.pixelWidth
  } : e && isPositiveNumber(E?.widthConfig?.pixelWidth) ? {
    type: "pixel",
    pixels: E.widthConfig.pixelWidth
  } : isNonZeroPositiveNumber(E?.width) && !o.widthConfig ? {
    type: "pixel",
    pixels: E.width
  } : {
    type: "auto"
    /* AUTO */
  };
}, getHeight = (o, E) => {
  const A = !!o.heightConfig?.useStretch, g = !!o.heightConfig?.useContent, e = !!o.heightConfig?.pixelHeight || o.heightConfig?.pixelHeight === 0, t = o.heightConfig?.remHeight;
  return A ? {
    type: "stretch"
    /* STRETCH */
  } : g ? {
    type: "content"
    /* CONTENT */
  } : t && isPositiveNumber(o.heightConfig?.remHeight) ? {
    type: "rem",
    rem: o.heightConfig.remHeight
  } : e && isPositiveNumber(o.heightConfig?.pixelHeight) ? {
    type: "pixel",
    pixels: o.heightConfig.pixelHeight
  } : isNonZeroPositiveNumber(E?.height) && !o.heightConfig ? {
    type: "pixel",
    pixels: E.height
  } : {
    type: "auto"
    /* AUTO */
  };
}, getFlex = (o, E, A, g) => {
  if (A === Direction.HORIZONTAL)
    switch (o.type) {
      case "pixel":
        return `0 0 ${o.pixels}px`;
      case "rem":
        return `0 0 ${o.rem}rem`;
      case "content":
        return "0 0 fit-content";
      case "stretch":
        return `1 1 ${g ?? "fit-content"}`;
      case "auto":
        return;
      default:
        assertNever(o);
    }
  else if (A === Direction.VERTICAL)
    switch (E.type) {
      case "pixel":
        return `0 0 ${E.pixels}px`;
      case "rem":
        return `0 0 ${E.rem}rem`;
      case "content":
      case "stretch":
      case "auto":
        return;
      default:
        assertNever(E);
    }
}, getDirection = (o) => o?.direction, calculateMinWidthWithParentConstraint = (o, E, A = 32) => {
  if (E === void 0 || o === void 0 || o === "fit-content")
    return o;
  const g = convertRemToPx(o);
  return E < g && E > A ? `${E - A}px` : o;
}, useLayoutStyles = ({
  element: o,
  subElement: E,
  styleOverrides: A,
  minStretchBehavior: g
}) => {
  const e = useContext(FlexContext);
  return useMemo$1(() => {
    if (!o)
      return {
        width: "auto",
        height: "auto",
        overflow: "visible"
      };
    const c = getWidth(o, E);
    let n, h;
    switch (c.type) {
      case "stretch":
        n = "100%";
        break;
      case "rem":
        n = `${c.rem}rem`;
        break;
      case "pixel":
        n = `${c.pixels}px`;
        break;
      case "content":
        n = "fit-content";
        break;
      case "auto":
        n = "auto";
        break;
      default:
        assertNever(c);
    }
    const d = getDirection(e);
    e?.isInContentWidthContainer && c.type === "stretch" && g !== void 0 && (h = calculateMinWidthWithParentConstraint(g, e?.parentWidth));
    const k = getHeight(o, E);
    let p, M = "visible";
    switch (k.type) {
      case "stretch":
        p = "100%";
        break;
      case "content":
        p = "auto";
        break;
      case "rem":
        p = `${k.rem}rem`;
        break;
      case "pixel":
        p = `${k.pixels}px`, M = "auto";
        break;
      case "auto":
        p = "auto";
        break;
      default:
        assertNever(k);
    }
    const S = getFlex(c, k, d, g), AA = getTextAlignmentStyle("textAlignmentConfig" in o ? o.textAlignmentConfig : void 0);
    return {
      ...{
        width: n,
        height: p,
        overflow: M,
        flex: S,
        minWidth: h,
        textAlign: AA
      },
      ...A
    };
  }, [o, E, A, e, g]);
};
var ScriptRunState = /* @__PURE__ */ ((o) => (o.NOT_RUNNING = "notRunning", o.RUNNING = "running", o.RERUN_REQUESTED = "rerunRequested", o.STOP_REQUESTED = "stopRequested", o.COMPILATION_ERROR = "compilationError", o))(ScriptRunState || {});
const ScriptRunContext = createContext({
  scriptRunState: ScriptRunState.NOT_RUNNING,
  scriptRunId: "<null>",
  fragmentIdsThisRun: []
});
ScriptRunContext.displayName = "ScriptRunContext";
var reactPropsRegex$1 = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, isPropValid$1 = /* @__PURE__ */ memoize$1(
  function(o) {
    return reactPropsRegex$1.test(o) || o.charCodeAt(0) === 111 && o.charCodeAt(1) === 110 && o.charCodeAt(2) < 91;
  }
  /* Z+1 */
), testOmitPropsOnStringTag = isPropValid$1, testOmitPropsOnComponent = function o(E) {
  return E !== "theme";
}, getDefaultShouldForwardProp = function o(E) {
  return typeof E == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  E.charCodeAt(0) > 96 ? testOmitPropsOnStringTag : testOmitPropsOnComponent;
}, composeShouldForwardProps = function o(E, A, g) {
  var e;
  if (A) {
    var t = A.shouldForwardProp;
    e = E.__emotion_forwardProp && t ? function(c) {
      return E.__emotion_forwardProp(c) && t(c);
    } : t;
  }
  return typeof e != "function" && g && (e = E.__emotion_forwardProp), e;
}, Insertion = function o(E) {
  var A = E.cache, g = E.serialized, e = E.isStringTag;
  return registerStyles(A, g, e), useInsertionEffectAlwaysWithSyncFallback(function() {
    return insertStyles(A, g, e);
  }), null;
}, createStyled = function o(E, A) {
  var g = E.__emotion_real === E, e = g && E.__emotion_base || E, t, c;
  A !== void 0 && (t = A.label, c = A.target);
  var n = composeShouldForwardProps(E, A, g), h = n || getDefaultShouldForwardProp(e), d = !h("as");
  return function() {
    var k = arguments, p = g && E.__emotion_styles !== void 0 ? E.__emotion_styles.slice(0) : [];
    if (t !== void 0 && p.push("label:" + t + ";"), k[0] == null || k[0].raw === void 0)
      p.push.apply(p, k);
    else {
      var M = k[0];
      p.push(M[0]);
      for (var S = k.length, AA = 1; AA < S; AA++)
        p.push(k[AA], M[AA]);
    }
    var H = withEmotionCache(function(gA, CA, IA) {
      var BA = d && gA.as || e, QA = "", EA = [], oA = gA;
      if (gA.theme == null) {
        oA = {};
        for (var iA in gA)
          oA[iA] = gA[iA];
        oA.theme = React.useContext(ThemeContext$2);
      }
      typeof gA.className == "string" ? QA = getRegisteredStyles(CA.registered, EA, gA.className) : gA.className != null && (QA = gA.className + " ");
      var aA = serializeStyles(p.concat(EA), CA.registered, oA);
      QA += CA.key + "-" + aA.name, c !== void 0 && (QA += " " + c);
      var tA = d && n === void 0 ? getDefaultShouldForwardProp(BA) : h, eA = {};
      for (var cA in gA)
        d && cA === "as" || tA(cA) && (eA[cA] = gA[cA]);
      return eA.className = QA, IA && (eA.ref = IA), /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Insertion, {
        cache: CA,
        serialized: aA,
        isStringTag: typeof BA == "string"
      }), /* @__PURE__ */ React.createElement(BA, eA));
    });
    return H.displayName = t !== void 0 ? t : "Styled(" + (typeof e == "string" ? e : e.displayName || e.name || "Component") + ")", H.defaultProps = E.defaultProps, H.__emotion_real = H, H.__emotion_base = e, H.__emotion_styles = p, H.__emotion_forwardProp = n, Object.defineProperty(H, "toString", {
      value: function() {
        return "." + c;
      }
    }), H.withComponent = function(gA, CA) {
      var IA = o(gA, _extends$C({}, A, CA, {
        shouldForwardProp: composeShouldForwardProps(H, CA, !0)
      }));
      return IA.apply(void 0, p);
    }, H;
  };
}, reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|popover|popoverTarget|popoverTargetAction|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, isPropValid = /* @__PURE__ */ memoize$1(
  function(o) {
    return reactPropsRegex.test(o) || o.charCodeAt(0) === 111 && o.charCodeAt(1) === 110 && o.charCodeAt(2) < 91;
  }
  /* Z+1 */
), SIZE$3 = {
  medium: "medium"
}, spin = {
  from: {
    transform: "rotate(0deg)"
  },
  to: {
    transform: "rotate(360deg)"
  }
}, StyledSpinner = styled("i", function(o) {
  var E = o.$theme, A = o.$color, g = A === void 0 ? E.colors.contentAccent : A, e = o.$borderWidth, t = o.$size, c = t === void 0 ? SIZE$3.medium : t, n = {
    large: E.sizing.scale300,
    medium: E.sizing.scale100,
    small: E.sizing.scale0
  }[e || c], h = {
    large: E.sizing.scale1000,
    medium: E.sizing.scale900,
    small: E.sizing.scale800
  }[c];
  return n || (n = E.sizing[e], n || (n = "".concat(parseInt(e), "px"))), h || (h = E.sizing[c], h || (h = "".concat(parseInt(c), "px"))), {
    display: "block",
    animationName: spin,
    animationDuration: E.animation.timing1000,
    animationIterationCount: "infinite",
    animationTimingFunction: "linear",
    borderLeftStyle: "solid",
    borderRightStyle: "solid",
    borderTopStyle: "solid",
    borderBottomStyle: "solid",
    borderRadius: "50%",
    borderTopColor: g,
    borderRightColor: E.colors.backgroundTertiary,
    borderBottomColor: E.colors.backgroundTertiary,
    borderLeftColor: E.colors.backgroundTertiary,
    borderLeftWidth: n,
    borderRightWidth: n,
    borderTopWidth: n,
    borderBottomWidth: n,
    width: h,
    height: h,
    cursor: "wait"
  };
});
StyledSpinner.displayName = "StyledSpinner";
StyledSpinner.displayName = "StyledSpinner";
function _EMOTION_STRINGIFIED_CSS_ERROR__$g() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const StyledSpinnerIcon = /* @__PURE__ */ createStyled(StyledSpinner, process.env.NODE_ENV === "production" ? {
  shouldForwardProp: (o) => isPropValid(o) && !["size"].includes(o),
  target: "eyeqlp54"
} : {
  shouldForwardProp: (o) => isPropValid(o) && !["size"].includes(o),
  target: "eyeqlp54",
  label: "StyledSpinnerIcon"
})(({
  size: o = "lg",
  margin: E = "",
  padding: A = "",
  theme: g
}) => {
  const e = `calc(${g.iconSizes[o]} * 0.80)`;
  return {
    width: e,
    height: e,
    fontSize: e,
    justifyContents: "center",
    margin: computeSpacingStyle(E, g),
    padding: computeSpacingStyle(A, g),
    borderColor: g.colors.fadedText10,
    borderTopColor: g.colors.bodyText,
    borderWidth: g.sizes.spinnerThickness,
    flexGrow: 0,
    flexShrink: 0
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledIcon = /* @__PURE__ */ createStyled("span", process.env.NODE_ENV === "production" ? {
  shouldForwardProp: (o) => isPropValid(o) && !["size", "as"].includes(o),
  target: "eyeqlp53"
} : {
  shouldForwardProp: (o) => isPropValid(o) && !["size", "as"].includes(o),
  target: "eyeqlp53",
  label: "StyledIcon"
})(({
  color: o,
  size: E,
  margin: A,
  padding: g,
  theme: e
}) => ({
  color: o || "inherit",
  fill: "currentColor",
  display: "inline-flex",
  alignItems: "center",
  justifyContents: "center",
  fontSize: e.iconSizes[E],
  width: e.iconSizes[E],
  height: e.iconSizes[E],
  margin: computeSpacingStyle(A, e),
  padding: computeSpacingStyle(g, e),
  flexShrink: 0
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledDynamicIcon = /* @__PURE__ */ createStyled("span", process.env.NODE_ENV === "production" ? {
  target: "eyeqlp52"
} : {
  target: "eyeqlp52",
  label: "StyledDynamicIcon"
})(({
  size: o = "lg",
  margin: E = "",
  padding: A = "",
  theme: g
}) => ({
  fill: "currentColor",
  display: "inline-flex",
  alignItems: "center",
  justifyContents: "center",
  fontSize: g.iconSizes[o],
  width: g.iconSizes[o],
  height: g.iconSizes[o],
  margin: computeSpacingStyle(E, g),
  padding: computeSpacingStyle(A, g),
  flexShrink: 0
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledImageIcon = /* @__PURE__ */ createStyled("img", process.env.NODE_ENV === "production" ? {
  target: "eyeqlp51"
} : {
  target: "eyeqlp51",
  label: "StyledImageIcon"
})(process.env.NODE_ENV === "production" ? {
  name: "w1atjl",
  styles: "width:100%;height:100%"
} : {
  name: "w1atjl",
  styles: "width:100%;height:100%/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$g
}), StyledEmojiIcon = /* @__PURE__ */ createStyled("span", process.env.NODE_ENV === "production" ? {
  target: "eyeqlp50"
} : {
  target: "eyeqlp50",
  label: "StyledEmojiIcon"
})(({
  size: o,
  margin: E,
  padding: A,
  theme: g,
  color: e
}) => {
  const t = `calc(${g.iconSizes[o]} * 0.90)`;
  return {
    display: "inline-flex",
    alignItems: "center",
    justifyContents: "center",
    fontSize: t,
    width: t,
    height: t,
    margin: computeSpacingStyle(E, g),
    padding: computeSpacingStyle(A, g),
    color: e
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), getDefaultProps$1 = ({
  size: o,
  margin: E,
  padding: A,
  color: g
}) => ({
  size: o || "md",
  margin: E || "",
  padding: A || "",
  color: g || void 0
}), Icon$2 = ({
  content: o,
  color: E,
  size: A,
  margin: g,
  padding: e,
  testid: t
}) => /* @__PURE__ */ jsxRuntimeExports.jsx(StyledIcon, { as: o, "aria-hidden": "true", "data-testid": t, ...getDefaultProps$1({
  size: A,
  margin: g,
  padding: e,
  color: E
}) }), EmojiIcon = ({
  size: o,
  margin: E,
  padding: A,
  children: g,
  color: e,
  testid: t
}) => (typeof g == "string" && (g = g.replace(/^emoji:/, "")), /* @__PURE__ */ jsxRuntimeExports.jsx(StyledEmojiIcon, { "data-testid": t || "stIconEmoji", "aria-hidden": "true", ...getDefaultProps$1({
  size: o,
  margin: E,
  padding: A,
  color: e
}), children: g })), StyledMaterialIcon = /* @__PURE__ */ createStyled("span", process.env.NODE_ENV === "production" ? {
  target: "e16edly10"
} : {
  target: "e16edly10",
  label: "StyledMaterialIcon"
})(({
  size: o,
  margin: E,
  padding: A,
  theme: g,
  color: e
}) => ({
  display: "inline-flex",
  alignItems: "center",
  justifyContents: "center",
  color: e,
  fontSize: g.iconSizes[o],
  width: g.iconSizes[o],
  height: g.iconSizes[o],
  margin: computeSpacingStyle(E, g),
  padding: computeSpacingStyle(A, g),
  userSelect: "none",
  fontFamily: g.genericFonts.iconFont,
  fontWeight: g.fontWeights.normal,
  fontStyle: "normal",
  lineHeight: g.lineHeights.none,
  letterSpacing: "normal",
  textTransform: "none",
  whiteSpace: "nowrap",
  wordWrap: "normal",
  direction: "ltr",
  fontFeatureSettings: "liga",
  MozFontFeatureSettings: "liga",
  WebkitFontFeatureSettings: "liga",
  WebkitFontSmoothing: "antialiased"
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), getDefaultProps = ({
  size: o,
  margin: E,
  padding: A,
  color: g
}) => ({
  size: o || "md",
  margin: E || "",
  padding: A || "",
  color: g || "inherit"
}), MaterialFontIcon = ({
  iconName: o,
  ...E
}) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  StyledMaterialIcon,
  {
    ...getDefaultProps(E),
    "data-testid": E.testid || "stIconMaterial",
    translate: "no",
    children: o
  }
);
function parseIconPackEntry(o) {
  const E = o.match(/^:(.+)\/(.+):$/);
  if (E === null)
    return {
      pack: "emoji",
      icon: o
    };
  const A = E[1], g = E[2];
  return {
    pack: A,
    icon: g
  };
}
function isMaterialIcon(o) {
  if (!o)
    return !1;
  const E = parseIconPackEntry(o);
  return E.pack === "material" && E.icon !== "";
}
function getFilledStarIconSrc() {
  return "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBjbGlwLXBhdGg9InVybCgjY2xpcDBfMTg2MF84NDMpIj48cGF0aCBkPSJNOS45OTk5NCAxNC4zOTE2TDEzLjQ1ODMgMTYuNDgzM0MxNC4wOTE2IDE2Ljg2NjYgMTQuODY2NiAxNi4zIDE0LjY5OTkgMTUuNTgzM0wxMy43ODMzIDExLjY1TDE2Ljg0MTYgOC45OTk5N0MxNy4zOTk5IDguNTE2NjMgMTcuMDk5OSA3LjU5OTk3IDE2LjM2NjYgNy41NDE2M0wxMi4zNDE2IDcuMTk5OTdMMTAuNzY2NiAzLjQ4MzNDMTAuNDgzMyAyLjgwODMgOS41MTY2MSAyLjgwODMgOS4yMzMyNyAzLjQ4MzNMNy42NTgyNyA3LjE5MTYzTDMuNjMzMjcgNy41MzMzQzIuODk5OTQgNy41OTE2MyAyLjU5OTk0IDguNTA4MyAzLjE1ODI3IDguOTkxNjNMNi4yMTY2MSAxMS42NDE2TDUuMjk5OTQgMTUuNTc1QzUuMTMzMjcgMTYuMjkxNiA1LjkwODI3IDE2Ljg1ODMgNi41NDE2MSAxNi40NzVMOS45OTk5NCAxNC4zOTE2WiIgZmlsbD0iI0ZBQ0EyQiIvPjwvZz48ZGVmcz48Y2xpcFBhdGggaWQ9ImNsaXAwXzE4NjBfODQzIj48cmVjdCB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIGZpbGw9IndoaXRlIi8+PC9jbGlwUGF0aD48L2RlZnM+PC9zdmc+";
}
const DynamicIconDispatcher = ({
  iconValue: o,
  ...E
}) => {
  if (o === "spinner")
    return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledDynamicIcon, { ...E, children: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledSpinnerIcon, { "data-testid": E.testid || "stSpinnerIcon", ...E }) });
  const {
    pack: A,
    icon: g
  } = parseIconPackEntry(o);
  switch (A) {
    case "material":
      switch (g) {
        case "star_filled":
          return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledDynamicIcon, { ...E, children: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledImageIcon, { src: getFilledStarIconSrc(), "data-testid": E.testid || "stImageIcon" }) });
        default:
          return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledDynamicIcon, { ...E, children: /* @__PURE__ */ jsxRuntimeExports.jsx(MaterialFontIcon, { pack: A, iconName: g, ...E }) });
      }
    case "emoji":
    default:
      return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledDynamicIcon, { ...E, children: /* @__PURE__ */ jsxRuntimeExports.jsx(EmojiIcon, { ...E, children: g }) });
  }
}, DynamicIcon = (o) => /* @__PURE__ */ jsxRuntimeExports.jsx(Suspense, { fallback: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledDynamicIcon, { ...o, children: /* @__PURE__ */ jsxRuntimeExports.jsx(EmojiIcon, { ...o, children: " " }) }), children: /* @__PURE__ */ jsxRuntimeExports.jsx(DynamicIconDispatcher, { ...o }) }, o.iconValue), LibConfigContext = createContext({
  locale: window.navigator.language,
  // Selected libConfig properties:
  mapboxToken: void 0,
  enforceDownloadInNewTab: void 0,
  resourceCrossOriginMode: void 0
});
LibConfigContext.displayName = "LibConfigContext";
var Pe = Object.defineProperty, a = (o, E) => Pe(o, "name", { value: E, configurable: !0 }), P$1 = class {
  type = 3;
  name = "";
  prefix = "";
  value = "";
  suffix = "";
  modifier = 3;
  constructor(E, A, g, e, t, c) {
    this.type = E, this.name = A, this.prefix = g, this.value = e, this.suffix = t, this.modifier = c;
  }
  hasCustomName() {
    return this.name !== "" && typeof this.name != "number";
  }
};
a(P$1, "Part");
var Re = /[$_\p{ID_Start}]/u, Ee = /[$_\u200C\u200D\p{ID_Continue}]/u, v = ".*";
function Oe(o, E) {
  return (E ? /^[\x00-\xFF]*$/ : /^[\x00-\x7F]*$/).test(o);
}
a(Oe, "isASCII");
function D(o, E = !1) {
  let A = [], g = 0;
  for (; g < o.length; ) {
    let e = o[g], t = a(function(c) {
      if (!E) throw new TypeError(c);
      A.push({ type: "INVALID_CHAR", index: g, value: o[g++] });
    }, "ErrorOrInvalid");
    if (e === "*") {
      A.push({ type: "ASTERISK", index: g, value: o[g++] });
      continue;
    }
    if (e === "+" || e === "?") {
      A.push({ type: "OTHER_MODIFIER", index: g, value: o[g++] });
      continue;
    }
    if (e === "\\") {
      A.push({ type: "ESCAPED_CHAR", index: g++, value: o[g++] });
      continue;
    }
    if (e === "{") {
      A.push({ type: "OPEN", index: g, value: o[g++] });
      continue;
    }
    if (e === "}") {
      A.push({ type: "CLOSE", index: g, value: o[g++] });
      continue;
    }
    if (e === ":") {
      let c = "", n = g + 1;
      for (; n < o.length; ) {
        let h = o.substr(n, 1);
        if (n === g + 1 && Re.test(h) || n !== g + 1 && Ee.test(h)) {
          c += o[n++];
          continue;
        }
        break;
      }
      if (!c) {
        t(`Missing parameter name at ${g}`);
        continue;
      }
      A.push({ type: "NAME", index: g, value: c }), g = n;
      continue;
    }
    if (e === "(") {
      let c = 1, n = "", h = g + 1, d = !1;
      if (o[h] === "?") {
        t(`Pattern cannot start with "?" at ${h}`);
        continue;
      }
      for (; h < o.length; ) {
        if (!Oe(o[h], !1)) {
          t(`Invalid character '${o[h]}' at ${h}.`), d = !0;
          break;
        }
        if (o[h] === "\\") {
          n += o[h++] + o[h++];
          continue;
        }
        if (o[h] === ")") {
          if (c--, c === 0) {
            h++;
            break;
          }
        } else if (o[h] === "(" && (c++, o[h + 1] !== "?")) {
          t(`Capturing groups are not allowed at ${h}`), d = !0;
          break;
        }
        n += o[h++];
      }
      if (d) continue;
      if (c) {
        t(`Unbalanced pattern at ${g}`);
        continue;
      }
      if (!n) {
        t(`Missing pattern at ${g}`);
        continue;
      }
      A.push({ type: "REGEX", index: g, value: n }), g = h;
      continue;
    }
    A.push({ type: "CHAR", index: g, value: o[g++] });
  }
  return A.push({ type: "END", index: g, value: "" }), A;
}
a(D, "lexer");
function F$1(o, E = {}) {
  let A = D(o);
  E.delimiter ??= "/#?", E.prefixes ??= "./";
  let g = `[^${x(E.delimiter)}]+?`, e = [], t = 0, c = 0, n = /* @__PURE__ */ new Set(), h = a((IA) => {
    if (c < A.length && A[c].type === IA) return A[c++].value;
  }, "tryConsume"), d = a(() => h("OTHER_MODIFIER") ?? h("ASTERISK"), "tryConsumeModifier"), k = a((IA) => {
    let BA = h(IA);
    if (BA !== void 0) return BA;
    let { type: QA, index: EA } = A[c];
    throw new TypeError(`Unexpected ${QA} at ${EA}, expected ${IA}`);
  }, "mustConsume"), p = a(() => {
    let IA = "", BA;
    for (; BA = h("CHAR") ?? h("ESCAPED_CHAR"); ) IA += BA;
    return IA;
  }, "consumeText"), M = a((IA) => IA, "DefaultEncodePart"), S = E.encodePart || M, AA = "", H = a((IA) => {
    AA += IA;
  }, "appendToPendingFixedValue"), gA = a(() => {
    AA.length && (e.push(new P$1(3, "", "", S(AA), "", 3)), AA = "");
  }, "maybeAddPartFromPendingFixedValue"), CA = a((IA, BA, QA, EA, oA) => {
    let iA = 3;
    switch (oA) {
      case "?":
        iA = 1;
        break;
      case "*":
        iA = 0;
        break;
      case "+":
        iA = 2;
        break;
    }
    if (!BA && !QA && iA === 3) {
      H(IA);
      return;
    }
    if (gA(), !BA && !QA) {
      if (!IA) return;
      e.push(new P$1(3, "", "", S(IA), "", iA));
      return;
    }
    let aA;
    QA ? QA === "*" ? aA = v : aA = QA : aA = g;
    let tA = 2;
    aA === g ? (tA = 1, aA = "") : aA === v && (tA = 0, aA = "");
    let eA;
    if (BA ? eA = BA : QA && (eA = t++), n.has(eA)) throw new TypeError(`Duplicate name '${eA}'.`);
    n.add(eA), e.push(new P$1(tA, eA, S(IA), aA, S(EA), iA));
  }, "addPart");
  for (; c < A.length; ) {
    let IA = h("CHAR"), BA = h("NAME"), QA = h("REGEX");
    if (!BA && !QA && (QA = h("ASTERISK")), BA || QA) {
      let oA = IA ?? "";
      E.prefixes.indexOf(oA) === -1 && (H(oA), oA = ""), gA();
      let iA = d();
      CA(oA, BA, QA, "", iA);
      continue;
    }
    let EA = IA ?? h("ESCAPED_CHAR");
    if (EA) {
      H(EA);
      continue;
    }
    if (h("OPEN")) {
      let oA = p(), iA = h("NAME"), aA = h("REGEX");
      !iA && !aA && (aA = h("ASTERISK"));
      let tA = p();
      k("CLOSE");
      let eA = d();
      CA(oA, iA, aA, tA, eA);
      continue;
    }
    gA(), k("END");
  }
  return e;
}
a(F$1, "parse");
function x(o) {
  return o.replace(/([.+*?^${}()[\]|/\\])/g, "\\$1");
}
a(x, "escapeString");
function B$1(o) {
  return o && o.ignoreCase ? "ui" : "u";
}
a(B$1, "flags");
function q(o, E, A) {
  return W$1(F$1(o, A), E, A);
}
a(q, "stringToRegexp");
function T(o) {
  switch (o) {
    case 0:
      return "*";
    case 1:
      return "?";
    case 2:
      return "+";
    case 3:
      return "";
  }
}
a(T, "modifierToString");
function W$1(o, E, A = {}) {
  A.delimiter ??= "/#?", A.prefixes ??= "./", A.sensitive ??= !1, A.strict ??= !1, A.end ??= !0, A.start ??= !0, A.endsWith = "";
  let g = A.start ? "^" : "";
  for (let n of o) {
    if (n.type === 3) {
      n.modifier === 3 ? g += x(n.value) : g += `(?:${x(n.value)})${T(n.modifier)}`;
      continue;
    }
    E && E.push(n.name);
    let h = `[^${x(A.delimiter)}]+?`, d = n.value;
    if (n.type === 1 ? d = h : n.type === 0 && (d = v), !n.prefix.length && !n.suffix.length) {
      n.modifier === 3 || n.modifier === 1 ? g += `(${d})${T(n.modifier)}` : g += `((?:${d})${T(n.modifier)})`;
      continue;
    }
    if (n.modifier === 3 || n.modifier === 1) {
      g += `(?:${x(n.prefix)}(${d})${x(n.suffix)})`, g += T(n.modifier);
      continue;
    }
    g += `(?:${x(n.prefix)}`, g += `((?:${d})(?:`, g += x(n.suffix), g += x(n.prefix), g += `(?:${d}))*)${x(n.suffix)})`, n.modifier === 0 && (g += "?");
  }
  let e = `[${x(A.endsWith)}]|$`, t = `[${x(A.delimiter)}]`;
  if (A.end) return A.strict || (g += `${t}?`), A.endsWith.length ? g += `(?=${e})` : g += "$", new RegExp(g, B$1(A));
  A.strict || (g += `(?:${t}(?=${e}))?`);
  let c = !1;
  if (o.length) {
    let n = o[o.length - 1];
    n.type === 3 && n.modifier === 3 && (c = A.delimiter.indexOf(n) > -1);
  }
  return c || (g += `(?=${t}|${e})`), new RegExp(g, B$1(A));
}
a(W$1, "partsToRegexp");
var b = { delimiter: "", prefixes: "", sensitive: !0, strict: !0 }, J$1 = { delimiter: ".", prefixes: "", sensitive: !0, strict: !0 }, Q$1 = { delimiter: "/", prefixes: "/", sensitive: !0, strict: !0 };
function ee(o, E) {
  return o.length ? o[0] === "/" ? !0 : !E || o.length < 2 ? !1 : (o[0] == "\\" || o[0] == "{") && o[1] == "/" : !1;
}
a(ee, "isAbsolutePathname");
function te(o, E) {
  return o.startsWith(E) ? o.substring(E.length, o.length) : o;
}
a(te, "maybeStripPrefix");
function ke(o, E) {
  return o.endsWith(E) ? o.substr(0, o.length - E.length) : o;
}
a(ke, "maybeStripSuffix");
function _(o) {
  return !o || o.length < 2 ? !1 : o[0] === "[" || (o[0] === "\\" || o[0] === "{") && o[1] === "[";
}
a(_, "treatAsIPv6Hostname");
var re$1 = ["ftp", "file", "http", "https", "ws", "wss"];
function U$1(o) {
  if (!o) return !0;
  for (let E of re$1) if (o.test(E)) return !0;
  return !1;
}
a(U$1, "isSpecialScheme");
function ne(o, E) {
  if (o = te(o, "#"), E || o === "") return o;
  let A = new URL("https://example.com");
  return A.hash = o, A.hash ? A.hash.substring(1, A.hash.length) : "";
}
a(ne, "canonicalizeHash");
function se(o, E) {
  if (o = te(o, "?"), E || o === "") return o;
  let A = new URL("https://example.com");
  return A.search = o, A.search ? A.search.substring(1, A.search.length) : "";
}
a(se, "canonicalizeSearch");
function ie(o, E) {
  return E || o === "" ? o : _(o) ? K$1(o) : j(o);
}
a(ie, "canonicalizeHostname");
function ae(o, E) {
  if (E || o === "") return o;
  let A = new URL("https://example.com");
  return A.password = o, A.password;
}
a(ae, "canonicalizePassword");
function oe(o, E) {
  if (E || o === "") return o;
  let A = new URL("https://example.com");
  return A.username = o, A.username;
}
a(oe, "canonicalizeUsername");
function ce(o, E, A) {
  if (A || o === "") return o;
  if (E && !re$1.includes(E)) return new URL(`${E}:${o}`).pathname;
  let g = o[0] == "/";
  return o = new URL(g ? o : "/-" + o, "https://example.com").pathname, g || (o = o.substring(2, o.length)), o;
}
a(ce, "canonicalizePathname");
function le(o, E, A) {
  return z$1(E) === o && (o = ""), A || o === "" ? o : G$1(o);
}
a(le, "canonicalizePort");
function fe(o, E) {
  return o = ke(o, ":"), E || o === "" ? o : w$1(o);
}
a(fe, "canonicalizeProtocol");
function z$1(o) {
  switch (o) {
    case "ws":
    case "http":
      return "80";
    case "wws":
    case "https":
      return "443";
    case "ftp":
      return "21";
    default:
      return "";
  }
}
a(z$1, "defaultPortForProtocol");
function w$1(o) {
  if (o === "") return o;
  if (/^[-+.A-Za-z0-9]*$/.test(o)) return o.toLowerCase();
  throw new TypeError(`Invalid protocol '${o}'.`);
}
a(w$1, "protocolEncodeCallback");
function he(o) {
  if (o === "") return o;
  let E = new URL("https://example.com");
  return E.username = o, E.username;
}
a(he, "usernameEncodeCallback");
function ue(o) {
  if (o === "") return o;
  let E = new URL("https://example.com");
  return E.password = o, E.password;
}
a(ue, "passwordEncodeCallback");
function j(o) {
  if (o === "") return o;
  if (/[\t\n\r #%/:<>?@[\]^\\|]/g.test(o)) throw new TypeError(`Invalid hostname '${o}'`);
  let E = new URL("https://example.com");
  return E.hostname = o, E.hostname;
}
a(j, "hostnameEncodeCallback");
function K$1(o) {
  if (o === "") return o;
  if (/[^0-9a-fA-F[\]:]/g.test(o)) throw new TypeError(`Invalid IPv6 hostname '${o}'`);
  return o.toLowerCase();
}
a(K$1, "ipv6HostnameEncodeCallback");
function G$1(o) {
  if (o === "" || /^[0-9]*$/.test(o) && parseInt(o) <= 65535) return o;
  throw new TypeError(`Invalid port '${o}'.`);
}
a(G$1, "portEncodeCallback");
function de(o) {
  if (o === "") return o;
  let E = new URL("https://example.com");
  return E.pathname = o[0] !== "/" ? "/-" + o : o, o[0] !== "/" ? E.pathname.substring(2, E.pathname.length) : E.pathname;
}
a(de, "standardURLPathnameEncodeCallback");
function pe(o) {
  return o === "" ? o : new URL(`data:${o}`).pathname;
}
a(pe, "pathURLPathnameEncodeCallback");
function ge(o) {
  if (o === "") return o;
  let E = new URL("https://example.com");
  return E.search = o, E.search.substring(1, E.search.length);
}
a(ge, "searchEncodeCallback");
function me(o) {
  if (o === "") return o;
  let E = new URL("https://example.com");
  return E.hash = o, E.hash.substring(1, E.hash.length);
}
a(me, "hashEncodeCallback");
var C = class {
  #Q;
  #C = [];
  #g = {};
  #A = 0;
  #B = 1;
  #e = 0;
  #i = 0;
  #G = 0;
  #l = 0;
  #n = !1;
  constructor(o) {
    this.#Q = o;
  }
  get result() {
    return this.#g;
  }
  parse() {
    for (this.#C = D(this.#Q, !0); this.#A < this.#C.length; this.#A += this.#B) {
      if (this.#B = 1, this.#C[this.#A].type === "END") {
        if (this.#i === 0) {
          this.#r(), this.#t() ? this.#I(9, 1) : this.#c() ? this.#I(8, 1) : this.#I(7, 0);
          continue;
        } else if (this.#i === 2) {
          this.#a(5);
          continue;
        }
        this.#I(10, 0);
        break;
      }
      if (this.#G > 0) if (this.#k()) this.#G -= 1;
      else continue;
      if (this.#b()) {
        this.#G += 1;
        continue;
      }
      switch (this.#i) {
        case 0:
          this.#h() && this.#a(1);
          break;
        case 1:
          if (this.#h()) {
            this.#Y();
            let o = 7, E = 1;
            this.#y() ? (o = 2, E = 3) : this.#n && (o = 2), this.#I(o, E);
          }
          break;
        case 2:
          this.#s() ? this.#a(3) : (this.#w() || this.#c() || this.#t()) && this.#a(5);
          break;
        case 3:
          this.#d() ? this.#I(4, 1) : this.#s() && this.#I(5, 1);
          break;
        case 4:
          this.#s() && this.#I(5, 1);
          break;
        case 5:
          this.#u() ? this.#l += 1 : this.#R() && (this.#l -= 1), this.#F() && !this.#l ? this.#I(6, 1) : this.#w() ? this.#I(7, 0) : this.#c() ? this.#I(8, 1) : this.#t() && this.#I(9, 1);
          break;
        case 6:
          this.#w() ? this.#I(7, 0) : this.#c() ? this.#I(8, 1) : this.#t() && this.#I(9, 1);
          break;
        case 7:
          this.#c() ? this.#I(8, 1) : this.#t() && this.#I(9, 1);
          break;
        case 8:
          this.#t() && this.#I(9, 1);
          break;
      }
    }
    this.#g.hostname !== void 0 && this.#g.port === void 0 && (this.#g.port = "");
  }
  #I(o, E) {
    switch (this.#i) {
      case 0:
        break;
      case 1:
        this.#g.protocol = this.#o();
        break;
      case 2:
        break;
      case 3:
        this.#g.username = this.#o();
        break;
      case 4:
        this.#g.password = this.#o();
        break;
      case 5:
        this.#g.hostname = this.#o();
        break;
      case 6:
        this.#g.port = this.#o();
        break;
      case 7:
        this.#g.pathname = this.#o();
        break;
      case 8:
        this.#g.search = this.#o();
        break;
      case 9:
        this.#g.hash = this.#o();
        break;
    }
    this.#i !== 0 && o !== 10 && ([1, 2, 3, 4].includes(this.#i) && [6, 7, 8, 9].includes(o) && (this.#g.hostname ??= ""), [1, 2, 3, 4, 5, 6].includes(this.#i) && [8, 9].includes(o) && (this.#g.pathname ??= this.#n ? "/" : ""), [1, 2, 3, 4, 5, 6, 7].includes(this.#i) && o === 9 && (this.#g.search ??= "")), this.#N(o, E);
  }
  #N(o, E) {
    this.#i = o, this.#e = this.#A + E, this.#A += E, this.#B = 0;
  }
  #r() {
    this.#A = this.#e, this.#B = 0;
  }
  #a(o) {
    this.#r(), this.#i = o;
  }
  #D(o) {
    return o < 0 && (o = this.#C.length - o), o < this.#C.length ? this.#C[o] : this.#C[this.#C.length - 1];
  }
  #E(o, E) {
    let A = this.#D(o);
    return A.value === E && (A.type === "CHAR" || A.type === "ESCAPED_CHAR" || A.type === "INVALID_CHAR");
  }
  #h() {
    return this.#E(this.#A, ":");
  }
  #y() {
    return this.#E(this.#A + 1, "/") && this.#E(this.#A + 2, "/");
  }
  #s() {
    return this.#E(this.#A, "@");
  }
  #d() {
    return this.#E(this.#A, ":");
  }
  #F() {
    return this.#E(this.#A, ":");
  }
  #w() {
    return this.#E(this.#A, "/");
  }
  #c() {
    if (this.#E(this.#A, "?")) return !0;
    if (this.#C[this.#A].value !== "?") return !1;
    let o = this.#D(this.#A - 1);
    return o.type !== "NAME" && o.type !== "REGEX" && o.type !== "CLOSE" && o.type !== "ASTERISK";
  }
  #t() {
    return this.#E(this.#A, "#");
  }
  #b() {
    return this.#C[this.#A].type == "OPEN";
  }
  #k() {
    return this.#C[this.#A].type == "CLOSE";
  }
  #u() {
    return this.#E(this.#A, "[");
  }
  #R() {
    return this.#E(this.#A, "]");
  }
  #o() {
    let o = this.#C[this.#A], E = this.#D(this.#e).index;
    return this.#Q.substring(E, o.index);
  }
  #Y() {
    let o = {};
    Object.assign(o, b), o.encodePart = w$1;
    let E = q(this.#o(), void 0, o);
    this.#n = U$1(E);
  }
};
a(C, "Parser");
var V$1 = ["protocol", "username", "password", "hostname", "port", "pathname", "search", "hash"], O = "*";
function Se(o, E) {
  if (typeof o != "string") throw new TypeError("parameter 1 is not of type 'string'.");
  let A = new URL(o, E);
  return { protocol: A.protocol.substring(0, A.protocol.length - 1), username: A.username, password: A.password, hostname: A.hostname, port: A.port, pathname: A.pathname, search: A.search !== "" ? A.search.substring(1, A.search.length) : void 0, hash: A.hash !== "" ? A.hash.substring(1, A.hash.length) : void 0 };
}
a(Se, "extractValues");
function R(o, E) {
  return E ? I$1(o) : o;
}
a(R, "processBaseURLString");
function L$1(o, E, A) {
  let g;
  if (typeof E.baseURL == "string") try {
    g = new URL(E.baseURL), E.protocol === void 0 && (o.protocol = R(g.protocol.substring(0, g.protocol.length - 1), A)), !A && E.protocol === void 0 && E.hostname === void 0 && E.port === void 0 && E.username === void 0 && (o.username = R(g.username, A)), !A && E.protocol === void 0 && E.hostname === void 0 && E.port === void 0 && E.username === void 0 && E.password === void 0 && (o.password = R(g.password, A)), E.protocol === void 0 && E.hostname === void 0 && (o.hostname = R(g.hostname, A)), E.protocol === void 0 && E.hostname === void 0 && E.port === void 0 && (o.port = R(g.port, A)), E.protocol === void 0 && E.hostname === void 0 && E.port === void 0 && E.pathname === void 0 && (o.pathname = R(g.pathname, A)), E.protocol === void 0 && E.hostname === void 0 && E.port === void 0 && E.pathname === void 0 && E.search === void 0 && (o.search = R(g.search.substring(1, g.search.length), A)), E.protocol === void 0 && E.hostname === void 0 && E.port === void 0 && E.pathname === void 0 && E.search === void 0 && E.hash === void 0 && (o.hash = R(g.hash.substring(1, g.hash.length), A));
  } catch {
    throw new TypeError(`invalid baseURL '${E.baseURL}'.`);
  }
  if (typeof E.protocol == "string" && (o.protocol = fe(E.protocol, A)), typeof E.username == "string" && (o.username = oe(E.username, A)), typeof E.password == "string" && (o.password = ae(E.password, A)), typeof E.hostname == "string" && (o.hostname = ie(E.hostname, A)), typeof E.port == "string" && (o.port = le(E.port, o.protocol, A)), typeof E.pathname == "string") {
    if (o.pathname = E.pathname, g && !ee(o.pathname, A)) {
      let e = g.pathname.lastIndexOf("/");
      e >= 0 && (o.pathname = R(g.pathname.substring(0, e + 1), A) + o.pathname);
    }
    o.pathname = ce(o.pathname, o.protocol, A);
  }
  return typeof E.search == "string" && (o.search = se(E.search, A)), typeof E.hash == "string" && (o.hash = ne(E.hash, A)), o;
}
a(L$1, "applyInit");
function I$1(o) {
  return o.replace(/([+*?:{}()\\])/g, "\\$1");
}
a(I$1, "escapePatternString");
function Te(o) {
  return o.replace(/([.+*?^${}()[\]|/\\])/g, "\\$1");
}
a(Te, "escapeRegexpString");
function Ae(o, E) {
  E.delimiter ??= "/#?", E.prefixes ??= "./", E.sensitive ??= !1, E.strict ??= !1, E.end ??= !0, E.start ??= !0, E.endsWith = "";
  let A = ".*", g = `[^${Te(E.delimiter)}]+?`, e = /[$_\u200C\u200D\p{ID_Continue}]/u, t = "";
  for (let c = 0; c < o.length; ++c) {
    let n = o[c];
    if (n.type === 3) {
      if (n.modifier === 3) {
        t += I$1(n.value);
        continue;
      }
      t += `{${I$1(n.value)}}${T(n.modifier)}`;
      continue;
    }
    let h = n.hasCustomName(), d = !!n.suffix.length || !!n.prefix.length && (n.prefix.length !== 1 || !E.prefixes.includes(n.prefix)), k = c > 0 ? o[c - 1] : null, p = c < o.length - 1 ? o[c + 1] : null;
    if (!d && h && n.type === 1 && n.modifier === 3 && p && !p.prefix.length && !p.suffix.length) if (p.type === 3) {
      let M = p.value.length > 0 ? p.value[0] : "";
      d = e.test(M);
    } else d = !p.hasCustomName();
    if (!d && !n.prefix.length && k && k.type === 3) {
      let M = k.value[k.value.length - 1];
      d = E.prefixes.includes(M);
    }
    d && (t += "{"), t += I$1(n.prefix), h && (t += `:${n.name}`), n.type === 2 ? t += `(${n.value})` : n.type === 1 ? h || (t += `(${g})`) : n.type === 0 && (!h && (!k || k.type === 3 || k.modifier !== 3 || d || n.prefix !== "") ? t += "*" : t += `(${A})`), n.type === 1 && h && n.suffix.length && e.test(n.suffix[0]) && (t += "\\"), t += I$1(n.suffix), d && (t += "}"), n.modifier !== 3 && (t += T(n.modifier));
  }
  return t;
}
a(Ae, "partsToPattern");
var Y = class {
  #Q;
  #C = {};
  #g = {};
  #A = {};
  #B = {};
  #e = !1;
  constructor(o = {}, E, A) {
    try {
      let g;
      if (typeof E == "string" ? g = E : A = E, typeof o == "string") {
        let n = new C(o);
        if (n.parse(), o = n.result, g === void 0 && typeof o.protocol != "string") throw new TypeError("A base URL must be provided for a relative constructor string.");
        o.baseURL = g;
      } else {
        if (!o || typeof o != "object") throw new TypeError("parameter 1 is not of type 'string' and cannot convert to dictionary.");
        if (g) throw new TypeError("parameter 1 is not of type 'string'.");
      }
      typeof A > "u" && (A = { ignoreCase: !1 });
      let e = { ignoreCase: A.ignoreCase === !0 }, t = { pathname: O, protocol: O, username: O, password: O, hostname: O, port: O, search: O, hash: O };
      this.#Q = L$1(t, o, !0), z$1(this.#Q.protocol) === this.#Q.port && (this.#Q.port = "");
      let c;
      for (c of V$1) {
        if (!(c in this.#Q)) continue;
        let n = {}, h = this.#Q[c];
        switch (this.#g[c] = [], c) {
          case "protocol":
            Object.assign(n, b), n.encodePart = w$1;
            break;
          case "username":
            Object.assign(n, b), n.encodePart = he;
            break;
          case "password":
            Object.assign(n, b), n.encodePart = ue;
            break;
          case "hostname":
            Object.assign(n, J$1), _(h) ? n.encodePart = K$1 : n.encodePart = j;
            break;
          case "port":
            Object.assign(n, b), n.encodePart = G$1;
            break;
          case "pathname":
            U$1(this.#C.protocol) ? (Object.assign(n, Q$1, e), n.encodePart = de) : (Object.assign(n, b, e), n.encodePart = pe);
            break;
          case "search":
            Object.assign(n, b, e), n.encodePart = ge;
            break;
          case "hash":
            Object.assign(n, b, e), n.encodePart = me;
            break;
        }
        try {
          this.#B[c] = F$1(h, n), this.#C[c] = W$1(this.#B[c], this.#g[c], n), this.#A[c] = Ae(this.#B[c], n), this.#e = this.#e || this.#B[c].some((d) => d.type === 2);
        } catch {
          throw new TypeError(`invalid ${c} pattern '${this.#Q[c]}'.`);
        }
      }
    } catch (g) {
      throw new TypeError(`Failed to construct 'URLPattern': ${g.message}`);
    }
  }
  get [Symbol.toStringTag]() {
    return "URLPattern";
  }
  test(o = {}, E) {
    let A = { pathname: "", protocol: "", username: "", password: "", hostname: "", port: "", search: "", hash: "" };
    if (typeof o != "string" && E) throw new TypeError("parameter 1 is not of type 'string'.");
    if (typeof o > "u") return !1;
    try {
      typeof o == "object" ? A = L$1(A, o, !1) : A = L$1(A, Se(o, E), !1);
    } catch {
      return !1;
    }
    let g;
    for (g of V$1) if (!this.#C[g].exec(A[g])) return !1;
    return !0;
  }
  exec(o = {}, E) {
    let A = { pathname: "", protocol: "", username: "", password: "", hostname: "", port: "", search: "", hash: "" };
    if (typeof o != "string" && E) throw new TypeError("parameter 1 is not of type 'string'.");
    if (typeof o > "u") return;
    try {
      typeof o == "object" ? A = L$1(A, o, !1) : A = L$1(A, Se(o, E), !1);
    } catch {
      return null;
    }
    let g = {};
    E ? g.inputs = [o, E] : g.inputs = [o];
    let e;
    for (e of V$1) {
      let t = this.#C[e].exec(A[e]);
      if (!t) return null;
      let c = {};
      for (let [n, h] of this.#g[e].entries()) if (typeof h == "string" || typeof h == "number") {
        let d = t[n + 1];
        c[h] = d;
      }
      g[e] = { input: A[e] ?? "", groups: c };
    }
    return g;
  }
  static compareComponent(o, E, A) {
    let g = a((n, h) => {
      for (let d of ["type", "modifier", "prefix", "value", "suffix"]) {
        if (n[d] < h[d]) return -1;
        if (n[d] !== h[d])
          return 1;
      }
      return 0;
    }, "comparePart"), e = new P$1(3, "", "", "", "", 3), t = new P$1(0, "", "", "", "", 3), c = a((n, h) => {
      let d = 0;
      for (; d < Math.min(n.length, h.length); ++d) {
        let k = g(n[d], h[d]);
        if (k) return k;
      }
      return n.length === h.length ? 0 : g(n[d] ?? e, h[d] ?? e);
    }, "comparePartList");
    return !E.#A[o] && !A.#A[o] ? 0 : E.#A[o] && !A.#A[o] ? c(E.#B[o], [t]) : !E.#A[o] && A.#A[o] ? c([t], A.#B[o]) : c(E.#B[o], A.#B[o]);
  }
  get protocol() {
    return this.#A.protocol;
  }
  get username() {
    return this.#A.username;
  }
  get password() {
    return this.#A.password;
  }
  get hostname() {
    return this.#A.hostname;
  }
  get port() {
    return this.#A.port;
  }
  get pathname() {
    return this.#A.pathname;
  }
  get search() {
    return this.#A.search;
  }
  get hash() {
    return this.#A.hash;
  }
  get hasRegExpGroups() {
    return this.#e;
  }
};
a(Y, "URLPattern");
globalThis.URLPattern || (globalThis.URLPattern = Y);
function isValidOrigin(o, E) {
  let A, g, e;
  try {
    A = new URLPattern(o), g = new URLPattern({
      protocol: A.protocol,
      hostname: A.hostname
    }), e = new URL(E);
  } catch {
    return !1;
  }
  return e.hostname === "localhost" && g.test(e) ? !0 : A.test(e);
}
function getCrossOriginAttribute(o, E) {
  if (E)
    try {
      const A = new URL(E);
      return window.__streamlit?.BACKEND_BASE_URL && A.origin === new URL(window.__streamlit?.BACKEND_BASE_URL).origin ? o : void 0;
    } catch {
      return window.__streamlit?.BACKEND_BASE_URL ? o : void 0;
    }
}
const useCrossOriginAttribute = (o) => {
  const {
    resourceCrossOriginMode: E
  } = useContext(LibConfigContext);
  if (o)
    return getCrossOriginAttribute(E, o);
}, useEmotionTheme = () => useTheme(), StyledChatMessageContainer = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "eeusbqq4"
} : {
  target: "eeusbqq4",
  label: "StyledChatMessageContainer"
})(({
  theme: o,
  background: E
}) => {
  const A = hasLightBackgroundColor(o);
  return {
    width: "100%",
    display: "flex",
    alignItems: "flex-start",
    gap: o.spacing.sm,
    padding: o.spacing.lg,
    paddingRight: E ? o.spacing.lg : 0,
    borderRadius: o.radii.default,
    ...E ? {
      backgroundColor: transparentize(A ? o.colors.gray20 : o.colors.gray90, 0.5)
    } : {}
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledMessageContent = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "eeusbqq3"
} : {
  target: "eeusbqq3",
  label: "StyledMessageContent"
})(({
  theme: o
}) => ({
  color: o.colors.bodyText,
  margin: "auto",
  flexGrow: 1,
  // Ensure the size of the message has an interpreted width as
  // the amount defined by flex layout and disregard its contents
  // they will handle their overflow.
  //
  // Unintuitively, setting the min width to 0 tells the browser
  // that it can shrink past the content's width to the desired size.
  // https://makandracards.com/makandra/66994-css-flex-and-min-width
  minWidth: 0
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledAvatarBackground = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "eeusbqq2"
} : {
  target: "eeusbqq2",
  label: "StyledAvatarBackground"
})(({
  theme: o
}) => {
  const E = hasLightBackgroundColor(o);
  return {
    display: "flex",
    border: `${o.sizes.borderWidth} solid ${E ? o.colors.gray40 : o.colors.gray85}`,
    backgroundColor: E ? o.colors.white : o.colors.gray100,
    color: E ? o.colors.gray90 : o.colors.white,
    lineHeight: o.lineHeights.none,
    fontSize: o.fontSizes.md,
    // Ensure the avatar always respects the width/height
    flexShrink: 0,
    width: o.sizes.chatAvatarSize,
    height: o.sizes.chatAvatarSize,
    borderRadius: o.radii.default,
    alignItems: "center",
    justifyContent: "center"
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledAvatarIcon = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "eeusbqq1"
} : {
  target: "eeusbqq1",
  label: "StyledAvatarIcon"
})(({
  theme: o,
  background: E
}) => {
  const A = hasLightBackgroundColor(o);
  return {
    display: "flex",
    width: o.sizes.chatAvatarSize,
    height: o.sizes.chatAvatarSize,
    // Ensure the avatar always respects the width/height
    flexShrink: 0,
    borderRadius: o.radii.default,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: E,
    color: A ? o.colors.white : o.colors.gray100
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledAvatarImage = /* @__PURE__ */ createStyled("img", process.env.NODE_ENV === "production" ? {
  target: "eeusbqq0"
} : {
  target: "eeusbqq0",
  label: "StyledAvatarImage"
})(({
  theme: o
}) => ({
  width: o.sizes.chatAvatarSize,
  height: o.sizes.chatAvatarSize,
  // Ensure the avatar always respects the width/height
  flexShrink: 0,
  borderRadius: o.radii.default,
  objectFit: "cover",
  display: "flex"
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
function ChatMessageAvatar(o) {
  const {
    avatar: E,
    avatarType: A,
    name: g,
    endpoints: e
  } = o, t = useEmotionTheme(), c = useCrossOriginAttribute(E);
  if (E)
    switch (A) {
      case Block$1.ChatMessage.AvatarType.IMAGE:
        return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledAvatarImage, { src: e.buildMediaURL(E), alt: `${g} avatar`, crossOrigin: c });
      case Block$1.ChatMessage.AvatarType.EMOJI:
        return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledAvatarBackground, { children: E });
      case Block$1.ChatMessage.AvatarType.ICON:
        if (E === "user")
          return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledAvatarIcon, { "data-testid": "stChatMessageAvatarUser", background: t.colors.redColor, children: /* @__PURE__ */ jsxRuntimeExports.jsx(DynamicIcon, { size: "lg", iconValue: ":material/face:" }) });
        if (E === "assistant")
          return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledAvatarIcon, { "data-testid": "stChatMessageAvatarAssistant", background: t.colors.orangeColor, children: /* @__PURE__ */ jsxRuntimeExports.jsx(DynamicIcon, { size: "lg", iconValue: ":material/smart_toy:" }) });
        if (E.startsWith(":material"))
          return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledAvatarBackground, { "data-testid": "stChatMessageAvatarCustom", children: /* @__PURE__ */ jsxRuntimeExports.jsx(DynamicIcon, { size: "lg", iconValue: E, color: t.colors.bodyText }) });
    }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledAvatarBackground, { children: g ? g.charAt(0).toUpperCase() : "🧑‍💻" });
}
const ChatMessage = ({
  endpoints: o,
  element: E,
  children: A
}) => {
  const {
    avatar: g,
    avatarType: e,
    name: t
  } = E;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledChatMessageContainer, { className: "stChatMessage", "data-testid": "stChatMessage", background: ["user", "human"].includes(t.toLowerCase()), children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(ChatMessageAvatar, { name: t, avatar: g, avatarType: e, endpoints: o }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(StyledMessageContent, { "data-testid": "stChatMessageContent", "aria-label": `Chat message from ${t}`, children: A })
  ] });
}, ChatMessage$1 = memo(ChatMessage), IsDialogContext = createContext(!1);
IsDialogContext.displayName = "IsDialogContext";
function _objectWithoutPropertiesLoose$q(o, E) {
  if (o == null) return {};
  var A = {};
  for (var g in o) if ({}.hasOwnProperty.call(o, g)) {
    if (E.indexOf(g) !== -1) continue;
    A[g] = o[g];
  }
  return A;
}
var propTypes$1 = { exports: {} };
var objectAssign, hasRequiredObjectAssign;
function requireObjectAssign() {
  if (hasRequiredObjectAssign) return objectAssign;
  hasRequiredObjectAssign = 1;
  var o = Object.getOwnPropertySymbols, E = Object.prototype.hasOwnProperty, A = Object.prototype.propertyIsEnumerable;
  function g(t) {
    if (t == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(t);
  }
  function e() {
    try {
      if (!Object.assign)
        return !1;
      var t = new String("abc");
      if (t[5] = "de", Object.getOwnPropertyNames(t)[0] === "5")
        return !1;
      for (var c = {}, n = 0; n < 10; n++)
        c["_" + String.fromCharCode(n)] = n;
      var h = Object.getOwnPropertyNames(c).map(function(k) {
        return c[k];
      });
      if (h.join("") !== "0123456789")
        return !1;
      var d = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(k) {
        d[k] = k;
      }), Object.keys(Object.assign({}, d)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return objectAssign = e() ? Object.assign : function(t, c) {
    for (var n, h = g(t), d, k = 1; k < arguments.length; k++) {
      n = Object(arguments[k]);
      for (var p in n)
        E.call(n, p) && (h[p] = n[p]);
      if (o) {
        d = o(n);
        for (var M = 0; M < d.length; M++)
          A.call(n, d[M]) && (h[d[M]] = n[d[M]]);
      }
    }
    return h;
  }, objectAssign;
}
var ReactPropTypesSecret_1, hasRequiredReactPropTypesSecret;
function requireReactPropTypesSecret() {
  if (hasRequiredReactPropTypesSecret) return ReactPropTypesSecret_1;
  hasRequiredReactPropTypesSecret = 1;
  var o = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return ReactPropTypesSecret_1 = o, ReactPropTypesSecret_1;
}
var has, hasRequiredHas;
function requireHas() {
  return hasRequiredHas || (hasRequiredHas = 1, has = Function.call.bind(Object.prototype.hasOwnProperty)), has;
}
var checkPropTypes_1, hasRequiredCheckPropTypes;
function requireCheckPropTypes() {
  if (hasRequiredCheckPropTypes) return checkPropTypes_1;
  hasRequiredCheckPropTypes = 1;
  var o = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var E = /* @__PURE__ */ requireReactPropTypesSecret(), A = {}, g = /* @__PURE__ */ requireHas();
    o = function(t) {
      var c = "Warning: " + t;
      typeof console < "u" && console.error(c);
      try {
        throw new Error(c);
      } catch {
      }
    };
  }
  function e(t, c, n, h, d) {
    if (process.env.NODE_ENV !== "production") {
      for (var k in t)
        if (g(t, k)) {
          var p;
          try {
            if (typeof t[k] != "function") {
              var M = Error(
                (h || "React class") + ": " + n + " type `" + k + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[k] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw M.name = "Invariant Violation", M;
            }
            p = t[k](c, k, h, n, null, E);
          } catch (AA) {
            p = AA;
          }
          if (p && !(p instanceof Error) && o(
            (h || "React class") + ": type specification of " + n + " `" + k + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof p + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), p instanceof Error && !(p.message in A)) {
            A[p.message] = !0;
            var S = d ? d() : "";
            o(
              "Failed " + n + " type: " + p.message + (S ?? "")
            );
          }
        }
    }
  }
  return e.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (A = {});
  }, checkPropTypes_1 = e, checkPropTypes_1;
}
var factoryWithTypeCheckers, hasRequiredFactoryWithTypeCheckers;
function requireFactoryWithTypeCheckers() {
  if (hasRequiredFactoryWithTypeCheckers) return factoryWithTypeCheckers;
  hasRequiredFactoryWithTypeCheckers = 1;
  var o = requireReactIs$1(), E = requireObjectAssign(), A = /* @__PURE__ */ requireReactPropTypesSecret(), g = /* @__PURE__ */ requireHas(), e = /* @__PURE__ */ requireCheckPropTypes(), t = function() {
  };
  process.env.NODE_ENV !== "production" && (t = function(n) {
    var h = "Warning: " + n;
    typeof console < "u" && console.error(h);
    try {
      throw new Error(h);
    } catch {
    }
  });
  function c() {
    return null;
  }
  return factoryWithTypeCheckers = function(n, h) {
    var d = typeof Symbol == "function" && Symbol.iterator, k = "@@iterator";
    function p(GA) {
      var FA = GA && (d && GA[d] || GA[k]);
      if (typeof FA == "function")
        return FA;
    }
    var M = "<<anonymous>>", S = {
      array: CA("array"),
      bigint: CA("bigint"),
      bool: CA("boolean"),
      func: CA("function"),
      number: CA("number"),
      object: CA("object"),
      string: CA("string"),
      symbol: CA("symbol"),
      any: IA(),
      arrayOf: BA,
      element: QA(),
      elementType: EA(),
      instanceOf: oA,
      node: eA(),
      objectOf: aA,
      oneOf: iA,
      oneOfType: tA,
      shape: DA,
      exact: nA
    };
    function AA(GA, FA) {
      return GA === FA ? GA !== 0 || 1 / GA === 1 / FA : GA !== GA && FA !== FA;
    }
    function H(GA, FA) {
      this.message = GA, this.data = FA && typeof FA == "object" ? FA : {}, this.stack = "";
    }
    H.prototype = Error.prototype;
    function gA(GA) {
      if (process.env.NODE_ENV !== "production")
        var FA = {}, HA = 0;
      function sA(xA, hA, MA, YA, LA, WA, zA) {
        if (YA = YA || M, WA = WA || MA, zA !== A) {
          if (h) {
            var ZA = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw ZA.name = "Invariant Violation", ZA;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var Ag = YA + ":" + MA;
            !FA[Ag] && // Avoid spamming the console because they are often not actionable except for lib authors
            HA < 3 && (t(
              "You are manually calling a React.PropTypes validation function for the `" + WA + "` prop on `" + YA + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), FA[Ag] = !0, HA++);
          }
        }
        return hA[MA] == null ? xA ? hA[MA] === null ? new H("The " + LA + " `" + WA + "` is marked as required " + ("in `" + YA + "`, but its value is `null`.")) : new H("The " + LA + " `" + WA + "` is marked as required in " + ("`" + YA + "`, but its value is `undefined`.")) : null : GA(hA, MA, YA, LA, WA);
      }
      var mA = sA.bind(null, !1);
      return mA.isRequired = sA.bind(null, !0), mA;
    }
    function CA(GA) {
      function FA(HA, sA, mA, xA, hA, MA) {
        var YA = HA[sA], LA = NA(YA);
        if (LA !== GA) {
          var WA = RA(YA);
          return new H(
            "Invalid " + xA + " `" + hA + "` of type " + ("`" + WA + "` supplied to `" + mA + "`, expected ") + ("`" + GA + "`."),
            { expectedType: GA }
          );
        }
        return null;
      }
      return gA(FA);
    }
    function IA() {
      return gA(c);
    }
    function BA(GA) {
      function FA(HA, sA, mA, xA, hA) {
        if (typeof GA != "function")
          return new H("Property `" + hA + "` of component `" + mA + "` has invalid PropType notation inside arrayOf.");
        var MA = HA[sA];
        if (!Array.isArray(MA)) {
          var YA = NA(MA);
          return new H("Invalid " + xA + " `" + hA + "` of type " + ("`" + YA + "` supplied to `" + mA + "`, expected an array."));
        }
        for (var LA = 0; LA < MA.length; LA++) {
          var WA = GA(MA, LA, mA, xA, hA + "[" + LA + "]", A);
          if (WA instanceof Error)
            return WA;
        }
        return null;
      }
      return gA(FA);
    }
    function QA() {
      function GA(FA, HA, sA, mA, xA) {
        var hA = FA[HA];
        if (!n(hA)) {
          var MA = NA(hA);
          return new H("Invalid " + mA + " `" + xA + "` of type " + ("`" + MA + "` supplied to `" + sA + "`, expected a single ReactElement."));
        }
        return null;
      }
      return gA(GA);
    }
    function EA() {
      function GA(FA, HA, sA, mA, xA) {
        var hA = FA[HA];
        if (!o.isValidElementType(hA)) {
          var MA = NA(hA);
          return new H("Invalid " + mA + " `" + xA + "` of type " + ("`" + MA + "` supplied to `" + sA + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return gA(GA);
    }
    function oA(GA) {
      function FA(HA, sA, mA, xA, hA) {
        if (!(HA[sA] instanceof GA)) {
          var MA = GA.name || M, YA = vA(HA[sA]);
          return new H("Invalid " + xA + " `" + hA + "` of type " + ("`" + YA + "` supplied to `" + mA + "`, expected ") + ("instance of `" + MA + "`."));
        }
        return null;
      }
      return gA(FA);
    }
    function iA(GA) {
      if (!Array.isArray(GA))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? t(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : t("Invalid argument supplied to oneOf, expected an array.")), c;
      function FA(HA, sA, mA, xA, hA) {
        for (var MA = HA[sA], YA = 0; YA < GA.length; YA++)
          if (AA(MA, GA[YA]))
            return null;
        var LA = JSON.stringify(GA, function(zA, ZA) {
          var Ag = RA(ZA);
          return Ag === "symbol" ? String(ZA) : ZA;
        });
        return new H("Invalid " + xA + " `" + hA + "` of value `" + String(MA) + "` " + ("supplied to `" + mA + "`, expected one of " + LA + "."));
      }
      return gA(FA);
    }
    function aA(GA) {
      function FA(HA, sA, mA, xA, hA) {
        if (typeof GA != "function")
          return new H("Property `" + hA + "` of component `" + mA + "` has invalid PropType notation inside objectOf.");
        var MA = HA[sA], YA = NA(MA);
        if (YA !== "object")
          return new H("Invalid " + xA + " `" + hA + "` of type " + ("`" + YA + "` supplied to `" + mA + "`, expected an object."));
        for (var LA in MA)
          if (g(MA, LA)) {
            var WA = GA(MA, LA, mA, xA, hA + "." + LA, A);
            if (WA instanceof Error)
              return WA;
          }
        return null;
      }
      return gA(FA);
    }
    function tA(GA) {
      if (!Array.isArray(GA))
        return process.env.NODE_ENV !== "production" && t("Invalid argument supplied to oneOfType, expected an instance of array."), c;
      for (var FA = 0; FA < GA.length; FA++) {
        var HA = GA[FA];
        if (typeof HA != "function")
          return t(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + KA(HA) + " at index " + FA + "."
          ), c;
      }
      function sA(mA, xA, hA, MA, YA) {
        for (var LA = [], WA = 0; WA < GA.length; WA++) {
          var zA = GA[WA], ZA = zA(mA, xA, hA, MA, YA, A);
          if (ZA == null)
            return null;
          ZA.data && g(ZA.data, "expectedType") && LA.push(ZA.data.expectedType);
        }
        var Ag = LA.length > 0 ? ", expected one of type [" + LA.join(", ") + "]" : "";
        return new H("Invalid " + MA + " `" + YA + "` supplied to " + ("`" + hA + "`" + Ag + "."));
      }
      return gA(sA);
    }
    function eA() {
      function GA(FA, HA, sA, mA, xA) {
        return wA(FA[HA]) ? null : new H("Invalid " + mA + " `" + xA + "` supplied to " + ("`" + sA + "`, expected a ReactNode."));
      }
      return gA(GA);
    }
    function cA(GA, FA, HA, sA, mA) {
      return new H(
        (GA || "React class") + ": " + FA + " type `" + HA + "." + sA + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + mA + "`."
      );
    }
    function DA(GA) {
      function FA(HA, sA, mA, xA, hA) {
        var MA = HA[sA], YA = NA(MA);
        if (YA !== "object")
          return new H("Invalid " + xA + " `" + hA + "` of type `" + YA + "` " + ("supplied to `" + mA + "`, expected `object`."));
        for (var LA in GA) {
          var WA = GA[LA];
          if (typeof WA != "function")
            return cA(mA, xA, hA, LA, RA(WA));
          var zA = WA(MA, LA, mA, xA, hA + "." + LA, A);
          if (zA)
            return zA;
        }
        return null;
      }
      return gA(FA);
    }
    function nA(GA) {
      function FA(HA, sA, mA, xA, hA) {
        var MA = HA[sA], YA = NA(MA);
        if (YA !== "object")
          return new H("Invalid " + xA + " `" + hA + "` of type `" + YA + "` " + ("supplied to `" + mA + "`, expected `object`."));
        var LA = E({}, HA[sA], GA);
        for (var WA in LA) {
          var zA = GA[WA];
          if (g(GA, WA) && typeof zA != "function")
            return cA(mA, xA, hA, WA, RA(zA));
          if (!zA)
            return new H(
              "Invalid " + xA + " `" + hA + "` key `" + WA + "` supplied to `" + mA + "`.\nBad object: " + JSON.stringify(HA[sA], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(GA), null, "  ")
            );
          var ZA = zA(MA, WA, mA, xA, hA + "." + WA, A);
          if (ZA)
            return ZA;
        }
        return null;
      }
      return gA(FA);
    }
    function wA(GA) {
      switch (typeof GA) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !GA;
        case "object":
          if (Array.isArray(GA))
            return GA.every(wA);
          if (GA === null || n(GA))
            return !0;
          var FA = p(GA);
          if (FA) {
            var HA = FA.call(GA), sA;
            if (FA !== GA.entries) {
              for (; !(sA = HA.next()).done; )
                if (!wA(sA.value))
                  return !1;
            } else
              for (; !(sA = HA.next()).done; ) {
                var mA = sA.value;
                if (mA && !wA(mA[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function lA(GA, FA) {
      return GA === "symbol" ? !0 : FA ? FA["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && FA instanceof Symbol : !1;
    }
    function NA(GA) {
      var FA = typeof GA;
      return Array.isArray(GA) ? "array" : GA instanceof RegExp ? "object" : lA(FA, GA) ? "symbol" : FA;
    }
    function RA(GA) {
      if (typeof GA > "u" || GA === null)
        return "" + GA;
      var FA = NA(GA);
      if (FA === "object") {
        if (GA instanceof Date)
          return "date";
        if (GA instanceof RegExp)
          return "regexp";
      }
      return FA;
    }
    function KA(GA) {
      var FA = RA(GA);
      switch (FA) {
        case "array":
        case "object":
          return "an " + FA;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + FA;
        default:
          return FA;
      }
    }
    function vA(GA) {
      return !GA.constructor || !GA.constructor.name ? M : GA.constructor.name;
    }
    return S.checkPropTypes = e, S.resetWarningCache = e.resetWarningCache, S.PropTypes = S, S;
  }, factoryWithTypeCheckers;
}
var factoryWithThrowingShims, hasRequiredFactoryWithThrowingShims;
function requireFactoryWithThrowingShims() {
  if (hasRequiredFactoryWithThrowingShims) return factoryWithThrowingShims;
  hasRequiredFactoryWithThrowingShims = 1;
  var o = /* @__PURE__ */ requireReactPropTypesSecret();
  function E() {
  }
  function A() {
  }
  return A.resetWarningCache = E, factoryWithThrowingShims = function() {
    function g(c, n, h, d, k, p) {
      if (p !== o) {
        var M = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw M.name = "Invariant Violation", M;
      }
    }
    g.isRequired = g;
    function e() {
      return g;
    }
    var t = {
      array: g,
      bigint: g,
      bool: g,
      func: g,
      number: g,
      object: g,
      string: g,
      symbol: g,
      any: g,
      arrayOf: e,
      element: g,
      elementType: g,
      instanceOf: e,
      node: g,
      objectOf: e,
      oneOf: e,
      oneOfType: e,
      shape: e,
      exact: e,
      checkPropTypes: A,
      resetWarningCache: E
    };
    return t.PropTypes = t, t;
  }, factoryWithThrowingShims;
}
var hasRequiredPropTypes;
function requirePropTypes() {
  if (hasRequiredPropTypes) return propTypes$1.exports;
  if (hasRequiredPropTypes = 1, process.env.NODE_ENV !== "production") {
    var o = requireReactIs$1(), E = !0;
    propTypes$1.exports = /* @__PURE__ */ requireFactoryWithTypeCheckers()(o.isElement, E);
  } else
    propTypes$1.exports = /* @__PURE__ */ requireFactoryWithThrowingShims()();
  return propTypes$1.exports;
}
var propTypesExports = /* @__PURE__ */ requirePropTypes();
const PropTypes = /* @__PURE__ */ getDefaultExportFromCjs(propTypesExports);
var FOCUS_GROUP = "data-focus-lock", FOCUS_DISABLED = "data-focus-lock-disabled", FOCUS_ALLOW = "data-no-focus-lock", FOCUS_AUTO = "data-autofocus-inside", FOCUS_NO_AUTOFOCUS = "data-no-autofocus";
function assignRef(o, E) {
  return typeof o == "function" ? o(E) : o && (o.current = E), o;
}
function useCallbackRef(o, E) {
  var A = useState(function() {
    return {
      // value
      value: o,
      // last callback
      callback: E,
      // "memoized" public interface
      facade: {
        get current() {
          return A.value;
        },
        set current(g) {
          var e = A.value;
          e !== g && (A.value = g, A.callback(g, e));
        }
      }
    };
  })[0];
  return A.callback = E, A.facade;
}
var useIsomorphicLayoutEffect = typeof window < "u" ? React.useLayoutEffect : React.useEffect, currentValues = /* @__PURE__ */ new WeakMap();
function useMergeRefs(o, E) {
  var A = useCallbackRef(null, function(g) {
    return o.forEach(function(e) {
      return assignRef(e, g);
    });
  });
  return useIsomorphicLayoutEffect(function() {
    var g = currentValues.get(A);
    if (g) {
      var e = new Set(g), t = new Set(o), c = A.current;
      e.forEach(function(n) {
        t.has(n) || assignRef(n, null);
      }), t.forEach(function(n) {
        e.has(n) || assignRef(n, c);
      });
    }
    currentValues.set(A, o);
  }, [o]), A;
}
var hiddenGuard = {
  width: "1px",
  height: "0px",
  padding: 0,
  overflow: "hidden",
  position: "fixed",
  top: "1px",
  left: "1px"
};
process.env.NODE_ENV !== "production" && PropTypes.node;
function ItoI(o) {
  return o;
}
function innerCreateMedium(o, E) {
  E === void 0 && (E = ItoI);
  var A = [], g = !1, e = {
    read: function() {
      if (g)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return A.length ? A[A.length - 1] : o;
    },
    useMedium: function(t) {
      var c = E(t, g);
      return A.push(c), function() {
        A = A.filter(function(n) {
          return n !== c;
        });
      };
    },
    assignSyncMedium: function(t) {
      for (g = !0; A.length; ) {
        var c = A;
        A = [], c.forEach(t);
      }
      A = {
        push: function(n) {
          return t(n);
        },
        filter: function() {
          return A;
        }
      };
    },
    assignMedium: function(t) {
      g = !0;
      var c = [];
      if (A.length) {
        var n = A;
        A = [], n.forEach(t), c = A;
      }
      var h = function() {
        var k = c;
        c = [], k.forEach(t);
      }, d = function() {
        return Promise.resolve().then(h);
      };
      d(), A = {
        push: function(k) {
          c.push(k), d();
        },
        filter: function(k) {
          return c = c.filter(k), A;
        }
      };
    }
  };
  return e;
}
function createMedium(o, E) {
  return E === void 0 && (E = ItoI), innerCreateMedium(o, E);
}
function createSidecarMedium(o) {
  o === void 0 && (o = {});
  var E = innerCreateMedium(null);
  return E.options = __assign$2({ async: !0, ssr: !1 }, o), E;
}
var mediumFocus = createMedium({}, function(o) {
  var E = o.target, A = o.currentTarget;
  return {
    target: E,
    currentTarget: A
  };
}), mediumBlur = createMedium(), mediumEffect = createMedium(), mediumSidecar = createSidecarMedium({
  async: !0,
  ssr: typeof document < "u"
}), focusScope = /* @__PURE__ */ createContext(void 0), emptyArray = [], FocusLock = /* @__PURE__ */ forwardRef(function o(E, A) {
  var g, e = useState(), t = e[0], c = e[1], n = useRef(), h = useRef(!1), d = useRef(null), k = useState({}), p = k[1], M = E.children, S = E.disabled, AA = S === void 0 ? !1 : S, H = E.noFocusGuards, gA = H === void 0 ? !1 : H, CA = E.persistentFocus, IA = CA === void 0 ? !1 : CA, BA = E.crossFrame, QA = BA === void 0 ? !0 : BA, EA = E.autoFocus, oA = EA === void 0 ? !0 : EA, iA = E.allowTextSelection, aA = E.group, tA = E.className, eA = E.whiteList, cA = E.hasPositiveIndices, DA = E.shards, nA = DA === void 0 ? emptyArray : DA, wA = E.as, lA = wA === void 0 ? "div" : wA, NA = E.lockProps, RA = NA === void 0 ? {} : NA, KA = E.sideCar, vA = E.returnFocus, GA = vA === void 0 ? !1 : vA, FA = E.focusOptions, HA = E.onActivation, sA = E.onDeactivation, mA = useState({}), xA = mA[0], hA = useCallback(function(PA) {
    var Gg = PA.captureFocusRestore;
    if (!d.current) {
      var gg, eg = (gg = document) == null ? void 0 : gg.activeElement;
      d.current = eg, eg !== document.body && (d.current = Gg(eg));
    }
    n.current && HA && HA(n.current), h.current = !0, p();
  }, [HA]), MA = useCallback(function() {
    h.current = !1, sA && sA(n.current), p();
  }, [sA]), YA = useCallback(function(PA) {
    var Gg = d.current;
    if (Gg) {
      var gg = (typeof Gg == "function" ? Gg() : Gg) || document.body, eg = typeof GA == "function" ? GA(gg) : GA;
      if (eg) {
        var Dg = typeof eg == "object" ? eg : void 0;
        d.current = null, PA ? Promise.resolve().then(function() {
          return gg.focus(Dg);
        }) : gg.focus(Dg);
      }
    }
  }, [GA]), LA = useCallback(function(PA) {
    h.current && mediumFocus.useMedium(PA);
  }, []), WA = mediumBlur.useMedium, zA = useCallback(function(PA) {
    n.current !== PA && (n.current = PA, c(PA));
  }, []);
  process.env.NODE_ENV !== "production" && (typeof iA < "u" && console.warn("React-Focus-Lock: allowTextSelection is deprecated and enabled by default"), useEffect(function() {
    !n.current && typeof lA != "string" && console.error("FocusLock: could not obtain ref to internal node");
  }, []));
  var ZA = _extends$C((g = {}, g[FOCUS_DISABLED] = AA && "disabled", g[FOCUS_GROUP] = aA, g), RA), Ag = gA !== !0, UA = Ag && gA !== "tail", ig = useMergeRefs([A, zA]), og = useMemo$1(function() {
    return {
      observed: n,
      shards: nA,
      enabled: !AA,
      active: h.current
    };
  }, [AA, h.current, nA, t]);
  return /* @__PURE__ */ React__default.createElement(Fragment, null, Ag && [
    /* @__PURE__ */ React__default.createElement("div", {
      key: "guard-first",
      "data-focus-guard": !0,
      tabIndex: AA ? -1 : 0,
      style: hiddenGuard
    }),
    cA ? /* @__PURE__ */ React__default.createElement("div", {
      key: "guard-nearest",
      "data-focus-guard": !0,
      tabIndex: AA ? -1 : 1,
      style: hiddenGuard
    }) : null
  ], !AA && /* @__PURE__ */ React__default.createElement(KA, {
    id: xA,
    sideCar: mediumSidecar,
    observed: t,
    disabled: AA,
    persistentFocus: IA,
    crossFrame: QA,
    autoFocus: oA,
    whiteList: eA,
    shards: nA,
    onActivation: hA,
    onDeactivation: MA,
    returnFocus: YA,
    focusOptions: FA,
    noFocusGuards: gA
  }), /* @__PURE__ */ React__default.createElement(lA, _extends$C({
    ref: ig
  }, ZA, {
    className: tA,
    onBlur: WA,
    onFocus: LA
  }), /* @__PURE__ */ React__default.createElement(focusScope.Provider, {
    value: og
  }, M)), UA && /* @__PURE__ */ React__default.createElement("div", {
    "data-focus-guard": !0,
    tabIndex: AA ? -1 : 0,
    style: hiddenGuard
  }));
});
FocusLock.propTypes = process.env.NODE_ENV !== "production" ? {
  children: propTypesExports.node,
  disabled: propTypesExports.bool,
  returnFocus: propTypesExports.oneOfType([propTypesExports.bool, propTypesExports.object, propTypesExports.func]),
  focusOptions: propTypesExports.object,
  noFocusGuards: propTypesExports.bool,
  hasPositiveIndices: propTypesExports.bool,
  allowTextSelection: propTypesExports.bool,
  autoFocus: propTypesExports.bool,
  persistentFocus: propTypesExports.bool,
  crossFrame: propTypesExports.bool,
  group: propTypesExports.string,
  className: propTypesExports.string,
  whiteList: propTypesExports.func,
  shards: propTypesExports.arrayOf(propTypesExports.any),
  as: propTypesExports.oneOfType([propTypesExports.string, propTypesExports.func, propTypesExports.object]),
  lockProps: propTypesExports.object,
  onActivation: propTypesExports.func,
  onDeactivation: propTypesExports.func,
  sideCar: propTypesExports.any.isRequired
} : {};
function _setPrototypeOf$e(o, E) {
  return _setPrototypeOf$e = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(A, g) {
    return A.__proto__ = g, A;
  }, _setPrototypeOf$e(o, E);
}
function _inheritsLoose(o, E) {
  o.prototype = Object.create(E.prototype), o.prototype.constructor = o, _setPrototypeOf$e(o, E);
}
function _typeof$g(o) {
  "@babel/helpers - typeof";
  return _typeof$g = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(E) {
    return typeof E;
  } : function(E) {
    return E && typeof Symbol == "function" && E.constructor === Symbol && E !== Symbol.prototype ? "symbol" : typeof E;
  }, _typeof$g(o);
}
function toPrimitive$2(o, E) {
  if (_typeof$g(o) != "object" || !o) return o;
  var A = o[Symbol.toPrimitive];
  if (A !== void 0) {
    var g = A.call(o, E);
    if (_typeof$g(g) != "object") return g;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (E === "string" ? String : Number)(o);
}
function toPropertyKey$2(o) {
  var E = toPrimitive$2(o, "string");
  return _typeof$g(E) == "symbol" ? E : E + "";
}
function _defineProperty$u(o, E, A) {
  return (E = toPropertyKey$2(E)) in o ? Object.defineProperty(o, E, {
    value: A,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : o[E] = A, o;
}
function withSideEffect(o, E) {
  if (process.env.NODE_ENV !== "production") {
    if (typeof o != "function")
      throw new Error("Expected reducePropsToState to be a function.");
    if (typeof E != "function")
      throw new Error("Expected handleStateChangeOnClient to be a function.");
  }
  function A(g) {
    return g.displayName || g.name || "Component";
  }
  return function(e) {
    if (process.env.NODE_ENV !== "production" && typeof e != "function")
      throw new Error("Expected WrappedComponent to be a React component.");
    var t = [], c;
    function n() {
      c = o(t.map(function(d) {
        return d.props;
      })), E(c);
    }
    var h = /* @__PURE__ */ (function(d) {
      _inheritsLoose(k, d);
      function k() {
        return d.apply(this, arguments) || this;
      }
      k.peek = function() {
        return c;
      };
      var p = k.prototype;
      return p.componentDidMount = function() {
        t.push(this), n();
      }, p.componentDidUpdate = function() {
        n();
      }, p.componentWillUnmount = function() {
        var S = t.indexOf(this);
        t.splice(S, 1), n();
      }, p.render = function() {
        return /* @__PURE__ */ React__default.createElement(e, this.props);
      }, k;
    })(PureComponent);
    return _defineProperty$u(h, "displayName", "SideEffect(" + A(e) + ")"), h;
  };
}
var toArray$2 = function(o) {
  for (var E = Array(o.length), A = 0; A < o.length; ++A)
    E[A] = o[A];
  return E;
}, asArray = function(o) {
  return Array.isArray(o) ? o : [o];
}, getFirst = function(o) {
  return Array.isArray(o) ? o[0] : o;
}, isElementHidden = function(o) {
  if (o.nodeType !== Node.ELEMENT_NODE)
    return !1;
  var E = window.getComputedStyle(o, null);
  return !E || !E.getPropertyValue ? !1 : E.getPropertyValue("display") === "none" || E.getPropertyValue("visibility") === "hidden";
}, getParentNode = function(o) {
  return o.parentNode && o.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    o.parentNode.host
  ) : o.parentNode;
}, isTopNode = function(o) {
  return o === document || o && o.nodeType === Node.DOCUMENT_NODE;
}, isInert = function(o) {
  return o.hasAttribute("inert");
}, isVisibleUncached = function(o, E) {
  return !o || isTopNode(o) || !isElementHidden(o) && !isInert(o) && E(getParentNode(o));
}, isVisibleCached = function(o, E) {
  var A = o.get(E);
  if (A !== void 0)
    return A;
  var g = isVisibleUncached(E, isVisibleCached.bind(void 0, o));
  return o.set(E, g), g;
}, isAutoFocusAllowedUncached = function(o, E) {
  return o && !isTopNode(o) ? isAutoFocusAllowed(o) ? E(getParentNode(o)) : !1 : !0;
}, isAutoFocusAllowedCached = function(o, E) {
  var A = o.get(E);
  if (A !== void 0)
    return A;
  var g = isAutoFocusAllowedUncached(E, isAutoFocusAllowedCached.bind(void 0, o));
  return o.set(E, g), g;
}, getDataset = function(o) {
  return o.dataset;
}, isHTMLButtonElement = function(o) {
  return o.tagName === "BUTTON";
}, isHTMLInputElement = function(o) {
  return o.tagName === "INPUT";
}, isRadioElement = function(o) {
  return isHTMLInputElement(o) && o.type === "radio";
}, notHiddenInput = function(o) {
  return !((isHTMLInputElement(o) || isHTMLButtonElement(o)) && (o.type === "hidden" || o.disabled));
}, isAutoFocusAllowed = function(o) {
  var E = o.getAttribute(FOCUS_NO_AUTOFOCUS);
  return ![!0, "true", ""].includes(E);
}, isGuard = function(o) {
  var E;
  return !!(o && (!((E = getDataset(o)) === null || E === void 0) && E.focusGuard));
}, isNotAGuard = function(o) {
  return !isGuard(o);
}, isDefined = function(o) {
  return !!o;
}, tabSort = function(o, E) {
  var A = Math.max(0, o.tabIndex), g = Math.max(0, E.tabIndex), e = A - g, t = o.index - E.index;
  if (e) {
    if (!A)
      return 1;
    if (!g)
      return -1;
  }
  return e || t;
}, getTabIndex = function(o) {
  return o.tabIndex < 0 && !o.hasAttribute("tabindex") ? 0 : o.tabIndex;
}, orderByTabIndex = function(o, E, A) {
  return toArray$2(o).map(function(g, e) {
    var t = getTabIndex(g);
    return {
      node: g,
      index: e,
      tabIndex: A && t === -1 ? (g.dataset || {}).focusGuard ? 0 : -1 : t
    };
  }).filter(function(g) {
    return !E || g.tabIndex >= 0;
  }).sort(tabSort);
}, tabbables = [
  "button:enabled",
  "select:enabled",
  "textarea:enabled",
  "input:enabled",
  // elements with explicit roles will also use explicit tabindex
  // '[role="button"]',
  "a[href]",
  "area[href]",
  "summary",
  "iframe",
  "object",
  "embed",
  "audio[controls]",
  "video[controls]",
  "[tabindex]",
  "[contenteditable]",
  "[autofocus]"
], queryTabbables = tabbables.join(","), queryGuardTabbables = "".concat(queryTabbables, ", [data-focus-guard]"), getFocusablesWithShadowDom = function(o, E) {
  return toArray$2((o.shadowRoot || o).children).reduce(function(A, g) {
    return A.concat(g.matches(E ? queryGuardTabbables : queryTabbables) ? [g] : [], getFocusablesWithShadowDom(g));
  }, []);
}, getFocusablesWithIFrame = function(o, E) {
  var A;
  return o instanceof HTMLIFrameElement && (!((A = o.contentDocument) === null || A === void 0) && A.body) ? getFocusables([o.contentDocument.body], E) : [o];
}, getFocusables = function(o, E) {
  return o.reduce(function(A, g) {
    var e, t = getFocusablesWithShadowDom(g, E), c = (e = []).concat.apply(e, t.map(function(n) {
      return getFocusablesWithIFrame(n, E);
    }));
    return A.concat(
      // add all tabbables inside and within shadow DOMs in DOM order
      c,
      // add if node is tabbable itself
      g.parentNode ? toArray$2(g.parentNode.querySelectorAll(queryTabbables)).filter(function(n) {
        return n === g;
      }) : []
    );
  }, []);
}, getParentAutofocusables = function(o) {
  var E = o.querySelectorAll("[".concat(FOCUS_AUTO, "]"));
  return toArray$2(E).map(function(A) {
    return getFocusables([A]);
  }).reduce(function(A, g) {
    return A.concat(g);
  }, []);
}, filterFocusable = function(o, E) {
  return toArray$2(o).filter(function(A) {
    return isVisibleCached(E, A);
  }).filter(function(A) {
    return notHiddenInput(A);
  });
}, filterAutoFocusable = function(o, E) {
  return E === void 0 && (E = /* @__PURE__ */ new Map()), toArray$2(o).filter(function(A) {
    return isAutoFocusAllowedCached(E, A);
  });
}, getTabbableNodes = function(o, E, A) {
  return orderByTabIndex(filterFocusable(getFocusables(o, A), E), !0, A);
}, getFocusableNodes = function(o, E) {
  return orderByTabIndex(filterFocusable(getFocusables(o), E), !1);
}, parentAutofocusables = function(o, E) {
  return filterFocusable(getParentAutofocusables(o), E);
}, contains = function(o, E) {
  return o.shadowRoot ? contains(o.shadowRoot, E) : Object.getPrototypeOf(o).contains !== void 0 && Object.getPrototypeOf(o).contains.call(o, E) ? !0 : toArray$2(o.children).some(function(A) {
    var g;
    if (A instanceof HTMLIFrameElement) {
      var e = (g = A.contentDocument) === null || g === void 0 ? void 0 : g.body;
      return e ? contains(e, E) : !1;
    }
    return contains(A, E);
  });
}, filterNested = function(o) {
  for (var E = /* @__PURE__ */ new Set(), A = o.length, g = 0; g < A; g += 1)
    for (var e = g + 1; e < A; e += 1) {
      var t = o[g].compareDocumentPosition(o[e]);
      (t & Node.DOCUMENT_POSITION_CONTAINED_BY) > 0 && E.add(e), (t & Node.DOCUMENT_POSITION_CONTAINS) > 0 && E.add(g);
    }
  return o.filter(function(c, n) {
    return !E.has(n);
  });
}, getTopParent = function(o) {
  return o.parentNode ? getTopParent(o.parentNode) : o;
}, getAllAffectedNodes = function(o) {
  var E = asArray(o);
  return E.filter(Boolean).reduce(function(A, g) {
    var e = g.getAttribute(FOCUS_GROUP);
    return A.push.apply(A, e ? filterNested(toArray$2(getTopParent(g).querySelectorAll("[".concat(FOCUS_GROUP, '="').concat(e, '"]:not([').concat(FOCUS_DISABLED, '="disabled"])')))) : [g]), A;
  }, []);
}, safeProbe = function(o) {
  try {
    return o();
  } catch {
    return;
  }
}, getActiveElement = function(o) {
  if (o === void 0 && (o = document), !(!o || !o.activeElement)) {
    var E = o.activeElement;
    return E.shadowRoot ? getActiveElement(E.shadowRoot) : E instanceof HTMLIFrameElement && safeProbe(function() {
      return E.contentWindow.document;
    }) ? getActiveElement(E.contentWindow.document) : E;
  }
}, focusInFrame = function(o, E) {
  return o === E;
}, focusInsideIframe = function(o, E) {
  return !!toArray$2(o.querySelectorAll("iframe")).some(function(A) {
    return focusInFrame(A, E);
  });
}, focusInside = function(o, E) {
  return E === void 0 && (E = getActiveElement(getFirst(o).ownerDocument)), !E || E.dataset && E.dataset.focusGuard ? !1 : getAllAffectedNodes(o).some(function(A) {
    return contains(A, E) || focusInsideIframe(A, E);
  });
}, focusIsHidden = function(o) {
  o === void 0 && (o = document);
  var E = getActiveElement(o);
  return E ? toArray$2(o.querySelectorAll("[".concat(FOCUS_ALLOW, "]"))).some(function(A) {
    return contains(A, E);
  }) : !1;
}, findSelectedRadio = function(o, E) {
  return E.filter(isRadioElement).filter(function(A) {
    return A.name === o.name;
  }).filter(function(A) {
    return A.checked;
  })[0] || o;
}, correctNode = function(o, E) {
  return isRadioElement(o) && o.name ? findSelectedRadio(o, E) : o;
}, correctNodes = function(o) {
  var E = /* @__PURE__ */ new Set();
  return o.forEach(function(A) {
    return E.add(correctNode(A, o));
  }), o.filter(function(A) {
    return E.has(A);
  });
}, pickFirstFocus = function(o) {
  return o[0] && o.length > 1 ? correctNode(o[0], o) : o[0];
}, pickFocusable = function(o, E) {
  return o.indexOf(correctNode(E, o));
}, NEW_FOCUS = "NEW_FOCUS", newFocus = function(o, E, A, g, e) {
  var t = o.length, c = o[0], n = o[t - 1], h = isGuard(g);
  if (!(g && o.indexOf(g) >= 0)) {
    var d = g !== void 0 ? A.indexOf(g) : -1, k = e ? A.indexOf(e) : d, p = e ? o.indexOf(e) : -1;
    if (d === -1)
      return p !== -1 ? p : NEW_FOCUS;
    if (p === -1)
      return NEW_FOCUS;
    var M = d - k, S = A.indexOf(c), AA = A.indexOf(n), H = correctNodes(A), gA = g !== void 0 ? H.indexOf(g) : -1, CA = e ? H.indexOf(e) : gA, IA = H.filter(function(aA) {
      return aA.tabIndex >= 0;
    }), BA = g !== void 0 ? IA.indexOf(g) : -1, QA = e ? IA.indexOf(e) : BA, EA = BA >= 0 && QA >= 0 ? (
      // old/new are tabbables, measure distance in tabbable space
      QA - BA
    ) : (
      // or else measure in focusable space
      CA - gA
    );
    if (!M && p >= 0 || E.length === 0)
      return p;
    var oA = pickFocusable(o, E[0]), iA = pickFocusable(o, E[E.length - 1]);
    if (d <= S && h && Math.abs(M) > 1)
      return iA;
    if (d >= AA && h && Math.abs(M) > 1)
      return oA;
    if (M && Math.abs(EA) > 1)
      return p;
    if (d <= S)
      return iA;
    if (d > AA)
      return oA;
    if (M)
      return Math.abs(M) > 1 ? p : (t + p + M) % t;
  }
}, findAutoFocused = function(o) {
  return function(E) {
    var A, g = (A = getDataset(E)) === null || A === void 0 ? void 0 : A.autofocus;
    return (
      // @ts-expect-error
      E.autofocus || //
      g !== void 0 && g !== "false" || //
      o.indexOf(E) >= 0
    );
  };
}, pickAutofocus = function(o, E, A) {
  var g = o.map(function(t) {
    var c = t.node;
    return c;
  }), e = filterAutoFocusable(g.filter(findAutoFocused(A)));
  return e && e.length ? pickFirstFocus(e) : pickFirstFocus(filterAutoFocusable(E));
}, getParents = function(o, E) {
  return E === void 0 && (E = []), E.push(o), o.parentNode && getParents(o.parentNode.host || o.parentNode, E), E;
}, getCommonParent = function(o, E) {
  for (var A = getParents(o), g = getParents(E), e = 0; e < A.length; e += 1) {
    var t = A[e];
    if (g.indexOf(t) >= 0)
      return t;
  }
  return !1;
}, getTopCommonParent = function(o, E, A) {
  var g = asArray(o), e = asArray(E), t = g[0], c = !1;
  return e.filter(Boolean).forEach(function(n) {
    c = getCommonParent(c || n, n) || c, A.filter(Boolean).forEach(function(h) {
      var d = getCommonParent(t, h);
      d && (!c || contains(d, c) ? c = d : c = getCommonParent(d, c));
    });
  }), c;
}, allParentAutofocusables = function(o, E) {
  return o.reduce(function(A, g) {
    return A.concat(parentAutofocusables(g, E));
  }, []);
}, reorderNodes = function(o, E) {
  var A = /* @__PURE__ */ new Map();
  return E.forEach(function(g) {
    return A.set(g.node, g);
  }), o.map(function(g) {
    return A.get(g);
  }).filter(isDefined);
}, focusSolver = function(o, E) {
  var A = getActiveElement(asArray(o).length > 0 ? document : getFirst(o).ownerDocument), g = getAllAffectedNodes(o).filter(isNotAGuard), e = getTopCommonParent(A || o, o, g), t = /* @__PURE__ */ new Map(), c = getFocusableNodes(g, t), n = c.filter(function(AA) {
    var H = AA.node;
    return isNotAGuard(H);
  });
  if (n[0]) {
    var h = getFocusableNodes([e], t).map(function(AA) {
      var H = AA.node;
      return H;
    }), d = reorderNodes(h, n), k = d.map(function(AA) {
      var H = AA.node;
      return H;
    }), p = d.filter(function(AA) {
      var H = AA.tabIndex;
      return H >= 0;
    }).map(function(AA) {
      var H = AA.node;
      return H;
    }), M = newFocus(k, p, h, A, E);
    if (M === NEW_FOCUS) {
      var S = (
        // first try only tabbable, and the fallback to all focusable, as long as at least one element should be picked for focus
        pickAutofocus(c, p, allParentAutofocusables(g, t)) || pickAutofocus(c, k, allParentAutofocusables(g, t))
      );
      if (S)
        return { node: S };
      console.warn("focus-lock: cannot find any node to move focus into");
      return;
    }
    return M === void 0 ? M : d[M];
  }
}, expandFocusableNodes = function(o) {
  var E = getAllAffectedNodes(o).filter(isNotAGuard), A = getTopCommonParent(o, o, E), g = orderByTabIndex(getFocusables([A], !0), !0, !0), e = getFocusables(E, !1);
  return g.map(function(t) {
    var c = t.node, n = t.index;
    return {
      node: c,
      index: n,
      lockItem: e.indexOf(c) >= 0,
      guard: isGuard(c)
    };
  });
}, focusOn = function(o, E) {
  o && ("focus" in o && o.focus(E), "contentWindow" in o && o.contentWindow && o.contentWindow.focus());
}, guardCount = 0, lockDisabled = !1, moveFocusInside = function(o, E, A) {
  A === void 0 && (A = {});
  var g = focusSolver(o, E);
  if (!lockDisabled && g) {
    if (guardCount > 2) {
      console.error("FocusLock: focus-fighting detected. Only one focus management system could be active. See https://github.com/theKashey/focus-lock/#focus-fighting"), lockDisabled = !0, setTimeout(function() {
        lockDisabled = !1;
      }, 1);
      return;
    }
    guardCount++, focusOn(g.node, A.focusOptions), guardCount--;
  }
};
function weakRef(o) {
  if (!o)
    return null;
  if (typeof WeakRef > "u")
    return function() {
      return o || null;
    };
  var E = o ? new WeakRef(o) : null;
  return function() {
    return E?.deref() || null;
  };
}
var recordElementLocation = function(o) {
  if (!o)
    return null;
  for (var E = [], A = o; A && A !== document.body; )
    E.push({
      current: weakRef(A),
      parent: weakRef(A.parentElement),
      left: weakRef(A.previousElementSibling),
      right: weakRef(A.nextElementSibling)
    }), A = A.parentElement;
  return {
    element: weakRef(o),
    stack: E,
    ownerDocument: o.ownerDocument
  };
}, restoreFocusTo = function(o) {
  var E, A, g, e, t;
  if (o)
    for (var c = o.stack, n = o.ownerDocument, h = /* @__PURE__ */ new Map(), d = 0, k = c; d < k.length; d++) {
      var p = k[d], M = (E = p.parent) === null || E === void 0 ? void 0 : E.call(p);
      if (M && n.contains(M)) {
        for (var S = (A = p.left) === null || A === void 0 ? void 0 : A.call(p), AA = p.current(), H = M.contains(AA) ? AA : void 0, gA = (g = p.right) === null || g === void 0 ? void 0 : g.call(p), CA = getTabbableNodes([M], h), IA = (
          // that is element itself
          (t = (e = H ?? S?.nextElementSibling) !== null && e !== void 0 ? e : (
            // or somebody to the right, still close enough
            gA
          )) !== null && t !== void 0 ? t : (
            // or somebody to the left, something?
            S
          )
        ); IA; ) {
          for (var BA = 0, QA = CA; BA < QA.length; BA++) {
            var EA = QA[BA];
            if (IA?.contains(EA.node))
              return EA.node;
          }
          IA = IA.nextElementSibling;
        }
        if (CA.length)
          return CA[0].node;
      }
    }
}, captureFocusRestore = function(o) {
  var E = recordElementLocation(o);
  return function() {
    return restoreFocusTo(E);
  };
}, getRelativeFocusable = function(o, E, A) {
  if (!o || !E)
    return console.error("no element or scope given"), {};
  var g = asArray(E);
  if (g.every(function(c) {
    return !contains(c, o);
  }))
    return console.error("Active element is not contained in the scope"), {};
  var e = A ? getTabbableNodes(g, /* @__PURE__ */ new Map()) : getFocusableNodes(g, /* @__PURE__ */ new Map()), t = e.findIndex(function(c) {
    var n = c.node;
    return n === o;
  });
  if (t !== -1)
    return {
      prev: e[t - 1],
      next: e[t + 1],
      first: e[0],
      last: e[e.length - 1]
    };
}, getBoundary = function(o, E) {
  var A = E ? getTabbableNodes(asArray(o), /* @__PURE__ */ new Map()) : getFocusableNodes(asArray(o), /* @__PURE__ */ new Map());
  return {
    first: A[0],
    last: A[A.length - 1]
  };
}, defaultOptions$1 = function(o) {
  return Object.assign({
    scope: document.body,
    cycle: !0,
    onlyTabbable: !0
  }, o);
}, moveFocus = function(o, E, A) {
  E === void 0 && (E = {});
  var g = defaultOptions$1(E), e = getRelativeFocusable(o, g.scope, g.onlyTabbable);
  if (e) {
    var t = A(e, g.cycle);
    t && focusOn(t.node, g.focusOptions);
  }
}, focusNextElement = function(o, E) {
  E === void 0 && (E = {}), moveFocus(o, E, function(A, g) {
    var e = A.next, t = A.first;
    return e || g && t;
  });
}, focusPrevElement = function(o, E) {
  E === void 0 && (E = {}), moveFocus(o, E, function(A, g) {
    var e = A.prev, t = A.last;
    return e || g && t;
  });
}, pickBoundary = function(o, E, A) {
  var g, e = getBoundary(o, (g = E.onlyTabbable) !== null && g !== void 0 ? g : !0), t = e[A];
  t && focusOn(t.node, E.focusOptions);
}, focusFirstElement = function(o, E) {
  E === void 0 && (E = {}), pickBoundary(o, E, "first");
}, focusLastElement = function(o, E) {
  E === void 0 && (E = {}), pickBoundary(o, E, "last");
};
function deferAction(o) {
  setTimeout(o, 1);
}
var inlineProp = function o(E, A) {
  var g = {};
  return g[E] = A, g;
}, extractRef = function o(E) {
  return E && "current" in E ? E.current : E;
}, focusOnBody = function o() {
  return document && document.activeElement === document.body;
}, isFreeFocus = function o() {
  return focusOnBody() || focusIsHidden();
}, lastActiveTrap = null, lastActiveFocus = null, tryRestoreFocus = function o() {
  return null;
}, lastPortaledElement = null, focusWasOutsideWindow = !1, windowFocused = !1, defaultWhitelist = function o() {
  return !0;
}, focusWhitelisted = function o(E) {
  return (lastActiveTrap.whiteList || defaultWhitelist)(E);
}, recordPortal = function o(E, A) {
  lastPortaledElement = {
    observerNode: E,
    portaledElement: A
  };
}, focusIsPortaledPair = function o(E) {
  return lastPortaledElement && lastPortaledElement.portaledElement === E;
};
function autoGuard(o, E, A, g) {
  var e = null, t = o;
  do {
    var c = g[t];
    if (c.guard)
      c.node.dataset.focusAutoGuard && (e = c);
    else if (c.lockItem) {
      if (t !== o)
        return;
      e = null;
    } else
      break;
  } while ((t += A) !== E);
  e && (e.node.tabIndex = 0);
}
var focusWasOutside = function o(E) {
  return E ? !!focusWasOutsideWindow : focusWasOutsideWindow === "meanwhile";
}, checkInHost = function o(E, A, g) {
  return A && (A.host === E && (!A.activeElement || g.contains(A.activeElement)) || A.parentNode && o(E, A.parentNode, g));
}, withinHost = function o(E, A) {
  return A.some(function(g) {
    return checkInHost(E, g, g);
  });
}, getNodeFocusables = function o(E) {
  return getFocusableNodes(E, /* @__PURE__ */ new Map());
}, isNotFocusable = function o(E) {
  return !getNodeFocusables([E.parentNode]).some(function(A) {
    return A.node === E;
  });
}, activateTrap = function o() {
  var E = !1;
  if (lastActiveTrap) {
    var A = lastActiveTrap, g = A.observed, e = A.persistentFocus, t = A.autoFocus, c = A.shards, n = A.crossFrame, h = A.focusOptions, d = A.noFocusGuards, k = g || lastPortaledElement && lastPortaledElement.portaledElement;
    if (focusOnBody() && lastActiveFocus && lastActiveFocus !== document.body && (!document.body.contains(lastActiveFocus) || isNotFocusable(lastActiveFocus))) {
      var p = tryRestoreFocus();
      p && p.focus();
    }
    var M = document && document.activeElement;
    if (k) {
      var S = [k].concat(c.map(extractRef).filter(Boolean)), AA = function() {
        if (!focusWasOutside(n) || !d || !lastActiveFocus || windowFocused)
          return !1;
        var BA = getNodeFocusables(S), QA = BA.findIndex(function(EA) {
          var oA = EA.node;
          return oA === lastActiveFocus;
        });
        return QA === 0 || QA === BA.length - 1;
      };
      if ((!M || focusWhitelisted(M)) && (e || AA() || !isFreeFocus() || !lastActiveFocus && t) && (k && !(focusInside(S) || M && withinHost(M, S) || focusIsPortaledPair(M)) && (document && !lastActiveFocus && M && !t ? (M.blur && M.blur(), document.body.focus()) : (E = moveFocusInside(S, lastActiveFocus, {
        focusOptions: h
      }), lastPortaledElement = {})), lastActiveFocus = document && document.activeElement, lastActiveFocus !== document.body && (tryRestoreFocus = captureFocusRestore(lastActiveFocus)), focusWasOutsideWindow = !1), document && M !== document.activeElement && document.querySelector("[data-focus-auto-guard]")) {
        var H = document && document.activeElement, gA = expandFocusableNodes(S), CA = gA.map(function(IA) {
          var BA = IA.node;
          return BA;
        }).indexOf(H);
        CA > -1 && (gA.filter(function(IA) {
          var BA = IA.guard, QA = IA.node;
          return BA && QA.dataset.focusAutoGuard;
        }).forEach(function(IA) {
          var BA = IA.node;
          return BA.removeAttribute("tabIndex");
        }), autoGuard(CA, gA.length, 1, gA), autoGuard(CA, -1, -1, gA));
      }
    }
  }
  return E;
}, onTrap = function o(E) {
  activateTrap() && E && (E.stopPropagation(), E.preventDefault());
}, onBlur = function o() {
  return deferAction(activateTrap);
}, onFocus = function o(E) {
  var A = E.target, g = E.currentTarget;
  g.contains(A) || recordPortal(g, A);
}, FocusWatcher = function o() {
  return null;
};
process.env.NODE_ENV !== "production" && PropTypes.node.isRequired;
var onWindowFocus = function o() {
  windowFocused = !0;
}, onWindowBlur = function o() {
  windowFocused = !1, focusWasOutsideWindow = "just", deferAction(function() {
    focusWasOutsideWindow = "meanwhile";
  });
}, attachHandler = function o() {
  document.addEventListener("focusin", onTrap), document.addEventListener("focusout", onBlur), window.addEventListener("focus", onWindowFocus), window.addEventListener("blur", onWindowBlur);
}, detachHandler = function o() {
  document.removeEventListener("focusin", onTrap), document.removeEventListener("focusout", onBlur), window.removeEventListener("focus", onWindowFocus), window.removeEventListener("blur", onWindowBlur);
};
function reducePropsToState(o) {
  return o.filter(function(E) {
    var A = E.disabled;
    return !A;
  });
}
var focusLockAPI = {
  moveFocusInside,
  focusInside,
  focusNextElement,
  focusPrevElement,
  focusFirstElement,
  focusLastElement,
  captureFocusRestore
};
function handleStateChangeOnClient(o) {
  var E = o.slice(-1)[0];
  E && !lastActiveTrap && attachHandler();
  var A = lastActiveTrap, g = A && E && E.id === A.id;
  lastActiveTrap = E, A && !g && (A.onDeactivation(), o.filter(function(e) {
    var t = e.id;
    return t === A.id;
  }).length || A.returnFocus(!E)), E ? (lastActiveFocus = null, (!g || A.observed !== E.observed) && E.onActivation(focusLockAPI), activateTrap(), deferAction(activateTrap)) : (detachHandler(), lastActiveFocus = null);
}
mediumFocus.assignSyncMedium(onFocus);
mediumBlur.assignMedium(onBlur);
mediumEffect.assignMedium(function(o) {
  return o(focusLockAPI);
});
const FocusTrap = withSideEffect(reducePropsToState, handleStateChangeOnClient)(FocusWatcher);
var FocusLockCombination = /* @__PURE__ */ forwardRef(function o(E, A) {
  return /* @__PURE__ */ React__default.createElement(FocusLock, _extends$C({
    sideCar: FocusTrap,
    ref: A
  }, E));
}), _ref = FocusLock.propTypes || {};
_ref.sideCar;
var propTypes = _objectWithoutPropertiesLoose$q(_ref, ["sideCar"]);
FocusLockCombination.propTypes = process.env.NODE_ENV !== "production" ? propTypes : {};
var useFocusInside = function o(E) {
  useEffect(function() {
    var A = !0;
    return mediumEffect.useMedium(function(g) {
      var e = E && E.current;
      A && e && (g.focusInside(e) || g.moveFocusInside(e, null));
    }), function() {
      A = !1;
    };
  }, [E]);
};
function MoveFocusInside(o) {
  var E = o.disabled, A = E === void 0 ? !1 : E, g = o.className, e = o.children, t = useRef(null);
  return useFocusInside(A ? void 0 : t), /* @__PURE__ */ React__default.createElement("div", _extends$C({}, inlineProp(FOCUS_AUTO, !A), {
    ref: t,
    className: g
  }), e);
}
MoveFocusInside.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
  className: PropTypes.string
} : {};
var SIZE$2 = {
  default: "default",
  full: "full",
  auto: "auto"
}, SIZE_WIDTHS = {
  default: "500px",
  full: "100%",
  auto: "auto"
}, ROLE = {
  dialog: "dialog"
}, CLOSE_SOURCE = {
  closeButton: "closeButton",
  backdrop: "backdrop",
  escape: "escape"
};
function ownKeys$p(o, E) {
  var A = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var g = Object.getOwnPropertySymbols(o);
    E && (g = g.filter(function(e) {
      return Object.getOwnPropertyDescriptor(o, e).enumerable;
    })), A.push.apply(A, g);
  }
  return A;
}
function _objectSpread$n(o) {
  for (var E = 1; E < arguments.length; E++) {
    var A = arguments[E] != null ? arguments[E] : {};
    E % 2 ? ownKeys$p(Object(A), !0).forEach(function(g) {
      _defineProperty$t(o, g, A[g]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(A)) : ownKeys$p(Object(A)).forEach(function(g) {
      Object.defineProperty(o, g, Object.getOwnPropertyDescriptor(A, g));
    });
  }
  return o;
}
function _defineProperty$t(o, E, A) {
  return E in o ? Object.defineProperty(o, E, { value: A, enumerable: !0, configurable: !0, writable: !0 }) : o[E] = A, o;
}
function getSizeStyles(o) {
  var E = {
    maxWidth: "100%",
    width: null
  };
  return typeof o == "number" ? E.width = "".concat(o, "px") : SIZE$2[o] ? E.width = SIZE_WIDTHS[o] : typeof o == "string" && (E.width = o), o === SIZE$2.full && (E.alignSelf = "stretch"), E;
}
var Root$3 = styled("div", function(o) {
  var E = o.$isOpen;
  return {
    position: "fixed",
    overflow: "auto",
    right: 0,
    bottom: 0,
    top: 0,
    left: 0,
    pointerEvents: E ? "auto" : "none"
  };
});
Root$3.displayName = "Root";
Root$3.displayName = "Root";
var DialogContainer = styled("div", function(o) {
  var E = o.$animate, A = o.$isOpen, g = o.$isVisible, e = o.$theme, t = {
    transitionProperty: "opacity",
    transitionDuration: e.animation.timing400,
    transitionTimingFunction: e.animation.easeOutCurve
  };
  return _objectSpread$n({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    minHeight: "100%",
    userSelect: "none",
    pointerEvents: "auto",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    // Remove grey highlight
    WebkitTapHighlightColor: "transparent",
    opacity: g && A ? 1 : 0
  }, E ? t : null);
});
DialogContainer.displayName = "DialogContainer";
DialogContainer.displayName = "DialogContainer";
var Dialog$2 = styled("div", function(o) {
  var E = o.$animate, A = o.$isOpen, g = o.$isVisible, e = o.$size, t = o.$theme;
  return _objectSpread$n(_objectSpread$n(_objectSpread$n({
    position: "relative",
    backgroundColor: t.colors.backgroundPrimary,
    borderTopLeftRadius: t.borders.radius500,
    borderTopRightRadius: t.borders.radius500,
    borderBottomRightRadius: t.borders.radius500,
    borderBottomLeftRadius: t.borders.radius500,
    marginLeft: t.sizing.scale600,
    marginTop: t.sizing.scale600,
    marginRight: t.sizing.scale600,
    marginBottom: t.sizing.scale600
  }, getSizeStyles(e)), {}, {
    // Animation
    opacity: g && A ? 1 : 0,
    transform: g ? "translateY(0)" : "translateY(20px)"
  }, E ? {
    transitionProperty: "opacity, transform",
    transitionDuration: t.animation.timing400,
    transitionTimingFunction: t.animation.easeOutCurve
  } : null), {}, {
    // Reset interactivity properties set by container
    userSelect: "text",
    pointerEvents: A ? "all" : "none",
    // We move focus to the modal, but we don't want the blue outline style
    ":focus": {
      outline: "none"
    }
  });
});
Dialog$2.displayName = "Dialog";
Dialog$2.displayName = "Dialog";
var Close = styled("button", function(o) {
  var E, A = o.$theme, g = o.$isFocusVisible, e = A.direction === "rtl" ? "left" : "right";
  return E = {
    // Reset button styles
    background: "transparent",
    outline: 0,
    paddingLeft: 0,
    paddingTop: 0,
    paddingRight: 0,
    paddingBottom: 0,
    // colors
    color: A.colors.modalCloseColor,
    transitionProperty: "color, border-color",
    transitionDuration: A.animation.timing200,
    borderLeftWidth: "1px",
    borderRightWidth: "1px",
    borderTopWidth: "1px",
    borderBottomWidth: "1px",
    borderLeftStyle: "solid",
    borderRightStyle: "solid",
    borderTopStyle: "solid",
    borderBottomStyle: "solid",
    borderLeftColor: "transparent",
    borderRightColor: "transparent",
    borderTopColor: "transparent",
    borderBottomColor: "transparent",
    ":hover": {
      color: A.colors.modalCloseColorHover
    },
    ":focus": {
      outline: g ? "3px solid ".concat(A.colors.accent) : "none"
    },
    // Positioning
    position: "absolute",
    top: A.sizing.scale500
  }, _defineProperty$t(E, e, A.sizing.scale500), _defineProperty$t(E, "width", A.sizing.scale800), _defineProperty$t(E, "height", A.sizing.scale800), _defineProperty$t(E, "display", "flex"), _defineProperty$t(E, "justifyContent", "center"), _defineProperty$t(E, "alignItems", "center"), _defineProperty$t(E, "cursor", "pointer"), E;
});
Close.displayName = "Close";
Close.displayName = "Close";
var ModalHeader$1 = styled("div", function(o) {
  var E, A = o.$theme, g = A.direction === "rtl" ? "marginRight" : "marginLeft", e = A.direction === "rtl" ? "marginLeft" : "marginRight";
  return _objectSpread$n(_objectSpread$n({}, A.typography.font550), {}, (E = {
    color: A.colors.contentPrimary,
    marginTop: A.sizing.scale900,
    marginBottom: A.sizing.scale600
  }, _defineProperty$t(E, g, A.sizing.scale800), _defineProperty$t(E, e, A.sizing.scale900), E));
});
ModalHeader$1.displayName = "ModalHeader";
ModalHeader$1.displayName = "ModalHeader";
var ModalBody$2 = styled("div", function(o) {
  var E = o.$theme;
  return _objectSpread$n(_objectSpread$n({}, E.typography.font200), {}, {
    color: E.colors.contentSecondary,
    marginTop: E.sizing.scale600,
    marginLeft: E.sizing.scale800,
    marginRight: E.sizing.scale800,
    marginBottom: E.sizing.scale700
  });
});
ModalBody$2.displayName = "ModalBody";
ModalBody$2.displayName = "ModalBody";
var ModalFooter$1 = styled("div", function(o) {
  var E = o.$theme;
  return _objectSpread$n(_objectSpread$n({}, E.typography.font200), {}, {
    marginTop: E.sizing.scale700,
    marginLeft: E.sizing.scale800,
    marginRight: E.sizing.scale800,
    paddingTop: E.sizing.scale500,
    paddingBottom: E.sizing.scale500,
    textAlign: E.direction === "rtl" ? "left" : "right"
  });
});
ModalFooter$1.displayName = "ModalFooter";
ModalFooter$1.displayName = "ModalFooter";
function CloseIcon() {
  return /* @__PURE__ */ React.createElement("svg", {
    width: "10",
    height: "10",
    viewBox: "0 0 10 10",
    style: {
      stroke: "currentColor"
    },
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M9 1L5 5M1 9L5 5M5 5L1 1M5 5L9 9",
    strokeWidth: "2",
    strokeLinecap: "round"
  }));
}
function _typeof$f(o) {
  "@babel/helpers - typeof";
  return _typeof$f = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(E) {
    return typeof E;
  } : function(E) {
    return E && typeof Symbol == "function" && E.constructor === Symbol && E !== Symbol.prototype ? "symbol" : typeof E;
  }, _typeof$f(o);
}
function _extends$v() {
  return _extends$v = Object.assign ? Object.assign.bind() : function(o) {
    for (var E = 1; E < arguments.length; E++) {
      var A = arguments[E];
      for (var g in A)
        Object.prototype.hasOwnProperty.call(A, g) && (o[g] = A[g]);
    }
    return o;
  }, _extends$v.apply(this, arguments);
}
function _slicedToArray$l(o, E) {
  return _arrayWithHoles$k(o) || _iterableToArrayLimit$k(o, E) || _unsupportedIterableToArray$k(o, E) || _nonIterableRest$k();
}
function _nonIterableRest$k() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$k(o, E) {
  if (o) {
    if (typeof o == "string") return _arrayLikeToArray$k(o, E);
    var A = Object.prototype.toString.call(o).slice(8, -1);
    if (A === "Object" && o.constructor && (A = o.constructor.name), A === "Map" || A === "Set") return Array.from(o);
    if (A === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(A)) return _arrayLikeToArray$k(o, E);
  }
}
function _arrayLikeToArray$k(o, E) {
  (E == null || E > o.length) && (E = o.length);
  for (var A = 0, g = new Array(E); A < E; A++)
    g[A] = o[A];
  return g;
}
function _iterableToArrayLimit$k(o, E) {
  var A = o == null ? null : typeof Symbol < "u" && o[Symbol.iterator] || o["@@iterator"];
  if (A != null) {
    var g = [], e = !0, t = !1, c, n;
    try {
      for (A = A.call(o); !(e = (c = A.next()).done) && (g.push(c.value), !(E && g.length === E)); e = !0)
        ;
    } catch (h) {
      t = !0, n = h;
    } finally {
      try {
        !e && A.return != null && A.return();
      } finally {
        if (t) throw n;
      }
    }
    return g;
  }
}
function _arrayWithHoles$k(o) {
  if (Array.isArray(o)) return o;
}
function _classCallCheck$d(o, E) {
  if (!(o instanceof E))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$d(o, E) {
  for (var A = 0; A < E.length; A++) {
    var g = E[A];
    g.enumerable = g.enumerable || !1, g.configurable = !0, "value" in g && (g.writable = !0), Object.defineProperty(o, g.key, g);
  }
}
function _createClass$d(o, E, A) {
  return E && _defineProperties$d(o.prototype, E), Object.defineProperty(o, "prototype", { writable: !1 }), o;
}
function _inherits$d(o, E) {
  if (typeof E != "function" && E !== null)
    throw new TypeError("Super expression must either be null or a function");
  o.prototype = Object.create(E && E.prototype, { constructor: { value: o, writable: !0, configurable: !0 } }), Object.defineProperty(o, "prototype", { writable: !1 }), E && _setPrototypeOf$d(o, E);
}
function _setPrototypeOf$d(o, E) {
  return _setPrototypeOf$d = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(g, e) {
    return g.__proto__ = e, g;
  }, _setPrototypeOf$d(o, E);
}
function _createSuper$d(o) {
  var E = _isNativeReflectConstruct$d();
  return function() {
    var g = _getPrototypeOf$d(o), e;
    if (E) {
      var t = _getPrototypeOf$d(this).constructor;
      e = Reflect.construct(g, arguments, t);
    } else
      e = g.apply(this, arguments);
    return _possibleConstructorReturn$d(this, e);
  };
}
function _possibleConstructorReturn$d(o, E) {
  if (E && (_typeof$f(E) === "object" || typeof E == "function"))
    return E;
  if (E !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$e(o);
}
function _assertThisInitialized$e(o) {
  if (o === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return o;
}
function _isNativeReflectConstruct$d() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function _getPrototypeOf$d(o) {
  return _getPrototypeOf$d = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(A) {
    return A.__proto__ || Object.getPrototypeOf(A);
  }, _getPrototypeOf$d(o);
}
function _defineProperty$s(o, E, A) {
  return E in o ? Object.defineProperty(o, E, { value: A, enumerable: !0, configurable: !0, writable: !0 }) : o[E] = A, o;
}
var Modal$1 = /* @__PURE__ */ (function(o) {
  _inherits$d(A, o);
  var E = _createSuper$d(A);
  function A() {
    var g;
    _classCallCheck$d(this, A);
    for (var e = arguments.length, t = new Array(e), c = 0; c < e; c++)
      t[c] = arguments[c];
    return g = E.call.apply(E, [this].concat(t)), _defineProperty$s(_assertThisInitialized$e(g), "animateOutTimer", void 0), _defineProperty$s(_assertThisInitialized$e(g), "animateStartTimer", void 0), _defineProperty$s(_assertThisInitialized$e(g), "dialogContainerRef", /* @__PURE__ */ React.createRef()), _defineProperty$s(_assertThisInitialized$e(g), "lastFocus", null), _defineProperty$s(_assertThisInitialized$e(g), "lastMountNodeOverflowStyle", null), _defineProperty$s(_assertThisInitialized$e(g), "rootRef", /* @__PURE__ */ React.createRef()), _defineProperty$s(_assertThisInitialized$e(g), "state", {
      isVisible: !1,
      mounted: !1,
      isFocusVisible: !1
    }), _defineProperty$s(_assertThisInitialized$e(g), "handleFocus", function(n) {
      isFocusVisible(n) && g.setState({
        isFocusVisible: !0
      });
    }), _defineProperty$s(_assertThisInitialized$e(g), "handleBlur", function(n) {
      g.state.isFocusVisible !== !1 && g.setState({
        isFocusVisible: !1
      });
    }), _defineProperty$s(_assertThisInitialized$e(g), "onEscape", function() {
      g.props.closeable && g.triggerClose(CLOSE_SOURCE.escape);
    }), _defineProperty$s(_assertThisInitialized$e(g), "onDocumentClick", function(n) {
      n.target && n.target instanceof HTMLElement && n.target.contains(g.dialogContainerRef.current) && g.onBackdropClick();
    }), _defineProperty$s(_assertThisInitialized$e(g), "onBackdropClick", function() {
      g.props.closeable && g.triggerClose(CLOSE_SOURCE.backdrop);
    }), _defineProperty$s(_assertThisInitialized$e(g), "onCloseClick", function() {
      g.triggerClose(CLOSE_SOURCE.closeButton);
    }), _defineProperty$s(_assertThisInitialized$e(g), "animateOutComplete", function() {
      g.setState({
        isVisible: !1
      });
    }), g;
  }
  return _createClass$d(A, [{
    key: "componentDidMount",
    value: function() {
      this.setState({
        mounted: !0
      }), process.env.NODE_ENV !== "production" && this.props.closable && console.warn("The property `closable` is not supported on the Modal. Did you mean `closeable`?");
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.resetMountNodeScroll(), this.clearTimers();
    }
  }, {
    key: "componentDidUpdate",
    value: function(e, t) {
      var c = this.props.isOpen;
      // If isOpen is changing *or* we just mounted and modal should be open
      (c !== e.isOpen || c && this.state.mounted && !t.mounted) && (c ? this.didOpen() : this.didClose());
    }
  }, {
    key: "disableMountNodeScroll",
    value: function() {
      var e = this.getMountNode();
      this.lastMountNodeOverflowStyle = e.style.overflow || "", e.style.overflow = "hidden";
    }
  }, {
    key: "resetMountNodeScroll",
    value: function() {
      var e = this.getMountNode(), t = this.lastMountNodeOverflowStyle;
      e && t !== null && (e.style.overflow === "hidden" && (e.style.overflow = t || ""), this.lastMountNodeOverflowStyle = null);
    }
  }, {
    key: "clearTimers",
    value: function() {
      this.animateOutTimer && clearTimeout(this.animateOutTimer), this.animateStartTimer && cancelAnimationFrame(this.animateStartTimer);
    }
  }, {
    key: "didOpen",
    value: function() {
      var e = this, t = this.rootRef.current;
      t && (t.scrollTop = 0), this.clearTimers(), this.disableMountNodeScroll(), this.animateStartTimer = requestAnimationFrame(function() {
        e.setState({
          isVisible: !0
        });
      });
    }
  }, {
    key: "didClose",
    value: function() {
      this.resetMountNodeScroll(), this.animateOutTimer = setTimeout(this.animateOutComplete, 500);
    }
  }, {
    key: "triggerClose",
    value: function(e) {
      this.props.onClose && e && this.props.onClose({
        closeSource: e
      });
    }
  }, {
    key: "getSharedProps",
    value: function() {
      var e = this.props, t = e.animate, c = e.isOpen, n = e.size, h = e.role, d = e.closeable;
      return {
        $animate: t,
        $isVisible: this.state.isVisible,
        $isOpen: !!c,
        $size: n,
        $role: h,
        $closeable: !!d,
        $isFocusVisible: this.state.isFocusVisible
      };
    }
  }, {
    key: "getMountNode",
    value: function() {
      var e = this.props.mountNode;
      return e || document.body;
    }
  }, {
    key: "getChildren",
    value: function() {
      var e = this.props.children;
      return typeof e == "function" ? e() : e;
    }
  }, {
    key: "renderModal",
    value: function() {
      var e = this, t = this.props, c = t.overrides, n = c === void 0 ? {} : c, h = t.closeable, d = t.role, k = t.autoFocus, p = t.focusLock, M = t.returnFocus, S = n.Root, AA = n.Dialog, H = n.DialogContainer, gA = n.Close, CA = getOverrides(S, Root$3), IA = _slicedToArray$l(CA, 2), BA = IA[0], QA = IA[1], EA = getOverrides(H, DialogContainer), oA = _slicedToArray$l(EA, 2), iA = oA[0], aA = oA[1], tA = getOverrides(AA, Dialog$2), eA = _slicedToArray$l(tA, 2), cA = eA[0], DA = eA[1], nA = getOverrides(gA, Close), wA = _slicedToArray$l(nA, 2), lA = wA[0], NA = wA[1], RA = this.getSharedProps(), KA = this.getChildren();
      return /* @__PURE__ */ React.createElement(LocaleContext.Consumer, null, function(vA) {
        return /* @__PURE__ */ React.createElement(FocusLockCombination, {
          disabled: !p,
          crossFrame: !1,
          returnFocus: M,
          autoFocus: k
        }, /* @__PURE__ */ React.createElement(BA, _extends$v({
          "data-baseweb": "modal",
          ref: e.rootRef
        }, RA, QA), /* @__PURE__ */ React.createElement(
          iA,
          _extends$v({
            ref: e.dialogContainerRef
          }, RA, aA),
          /* @__PURE__ */ React.createElement(cA, _extends$v({
            tabIndex: -1,
            "aria-modal": !0,
            "aria-label": "dialog",
            role: d
          }, RA, DA), KA, h ? /* @__PURE__ */ React.createElement(lA, _extends$v({
            "aria-label": vA.modal.close,
            onClick: e.onCloseClick
          }, RA, NA, {
            onFocus: forkFocus(NA, e.handleFocus),
            onBlur: forkBlur(NA, e.handleBlur)
          }), /* @__PURE__ */ React.createElement(CloseIcon, null)) : null)
        )));
      });
    }
  }, {
    key: "render",
    value: function() {
      return !this.state.mounted || !this.props.isOpen && !this.state.isVisible ? null : /* @__PURE__ */ React.createElement(Layer, {
        onEscape: this.onEscape,
        onDocumentClick: this.onDocumentClick,
        mountNode: this.props.mountNode
      }, this.renderModal());
    }
  }]), A;
})(React.Component);
_defineProperty$s(Modal$1, "defaultProps", {
  animate: !0,
  autoFocus: !0,
  focusLock: !0,
  returnFocus: !0,
  closeable: !0,
  name: "dialog",
  isOpen: !1,
  overrides: {},
  role: ROLE.dialog,
  size: SIZE$2.default
});
function escapeStringRegexp$1(o) {
  if (typeof o != "string")
    throw new TypeError("Expected a string");
  return o.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
}
const replacements = [
  // German umlauts
  ["ß", "ss"],
  ["ẞ", "Ss"],
  ["ä", "ae"],
  ["Ä", "Ae"],
  ["ö", "oe"],
  ["Ö", "Oe"],
  ["ü", "ue"],
  ["Ü", "Ue"],
  // Latin
  ["À", "A"],
  ["Á", "A"],
  ["Â", "A"],
  ["Ã", "A"],
  ["Ä", "Ae"],
  ["Å", "A"],
  ["Æ", "AE"],
  ["Ç", "C"],
  ["È", "E"],
  ["É", "E"],
  ["Ê", "E"],
  ["Ë", "E"],
  ["Ə", "A"],
  // Azerbaijani schwa
  ["Ì", "I"],
  ["Í", "I"],
  ["Î", "I"],
  ["Ï", "I"],
  ["Ð", "D"],
  ["Ñ", "N"],
  ["Ò", "O"],
  ["Ó", "O"],
  ["Ô", "O"],
  ["Õ", "O"],
  ["Ö", "Oe"],
  ["Ō", "O"],
  ["Ő", "O"],
  ["Ø", "O"],
  ["Œ", "OE"],
  // French ligature
  ["Ù", "U"],
  ["Ú", "U"],
  ["Û", "U"],
  ["Ü", "Ue"],
  ["Ű", "U"],
  ["Ý", "Y"],
  ["Þ", "TH"],
  ["ß", "ss"],
  ["à", "a"],
  ["á", "a"],
  ["â", "a"],
  ["ã", "a"],
  ["ä", "ae"],
  ["å", "a"],
  ["æ", "ae"],
  ["ç", "c"],
  ["è", "e"],
  ["é", "e"],
  ["ê", "e"],
  ["ë", "e"],
  ["ə", "a"],
  // Azerbaijani schwa
  ["ì", "i"],
  ["í", "i"],
  ["î", "i"],
  ["ï", "i"],
  ["ð", "d"],
  ["ñ", "n"],
  ["ò", "o"],
  ["ó", "o"],
  ["ô", "o"],
  ["õ", "o"],
  ["ö", "oe"],
  ["ō", "o"],
  ["ő", "o"],
  ["ø", "o"],
  ["œ", "oe"],
  // French ligature
  ["ù", "u"],
  ["ú", "u"],
  ["û", "u"],
  ["ü", "ue"],
  ["ű", "u"],
  ["ý", "y"],
  ["þ", "th"],
  ["ÿ", "y"],
  // Vietnamese
  ["à", "a"],
  ["À", "A"],
  ["á", "a"],
  ["Á", "A"],
  ["â", "a"],
  ["Â", "A"],
  ["ã", "a"],
  ["Ã", "A"],
  ["è", "e"],
  ["È", "E"],
  ["é", "e"],
  ["É", "E"],
  ["ê", "e"],
  ["Ê", "E"],
  ["ì", "i"],
  ["Ì", "I"],
  ["í", "i"],
  ["Í", "I"],
  ["ò", "o"],
  ["Ò", "O"],
  ["ó", "o"],
  ["Ó", "O"],
  ["ô", "o"],
  ["Ô", "O"],
  ["õ", "o"],
  ["Õ", "O"],
  ["ù", "u"],
  ["Ù", "U"],
  ["ú", "u"],
  ["Ú", "U"],
  ["ý", "y"],
  ["Ý", "Y"],
  ["ă", "a"],
  ["Ă", "A"],
  ["Đ", "D"],
  ["đ", "d"],
  ["ĩ", "i"],
  ["Ĩ", "I"],
  ["ũ", "u"],
  ["Ũ", "U"],
  ["ơ", "o"],
  ["Ơ", "O"],
  ["ư", "u"],
  ["Ư", "U"],
  ["ạ", "a"],
  ["Ạ", "A"],
  ["ả", "a"],
  ["Ả", "A"],
  ["ấ", "a"],
  ["Ấ", "A"],
  ["ầ", "a"],
  ["Ầ", "A"],
  ["ẩ", "a"],
  ["Ẩ", "A"],
  ["ẫ", "a"],
  ["Ẫ", "A"],
  ["ậ", "a"],
  ["Ậ", "A"],
  ["ắ", "a"],
  ["Ắ", "A"],
  ["ằ", "a"],
  ["Ằ", "A"],
  ["ẳ", "a"],
  ["Ẳ", "A"],
  ["ẵ", "a"],
  ["Ẵ", "A"],
  ["ặ", "a"],
  ["Ặ", "A"],
  ["ẹ", "e"],
  ["Ẹ", "E"],
  ["ẻ", "e"],
  ["Ẻ", "E"],
  ["ẽ", "e"],
  ["Ẽ", "E"],
  ["ế", "e"],
  ["Ế", "E"],
  ["ề", "e"],
  ["Ề", "E"],
  ["ể", "e"],
  ["Ể", "E"],
  ["ễ", "e"],
  ["Ễ", "E"],
  ["ệ", "e"],
  ["Ệ", "E"],
  ["ỉ", "i"],
  ["Ỉ", "I"],
  ["ị", "i"],
  ["Ị", "I"],
  ["ọ", "o"],
  ["Ọ", "O"],
  ["ỏ", "o"],
  ["Ỏ", "O"],
  ["ố", "o"],
  ["Ố", "O"],
  ["ồ", "o"],
  ["Ồ", "O"],
  ["ổ", "o"],
  ["Ổ", "O"],
  ["ỗ", "o"],
  ["Ỗ", "O"],
  ["ộ", "o"],
  ["Ộ", "O"],
  ["ớ", "o"],
  ["Ớ", "O"],
  ["ờ", "o"],
  ["Ờ", "O"],
  ["ở", "o"],
  ["Ở", "O"],
  ["ỡ", "o"],
  ["Ỡ", "O"],
  ["ợ", "o"],
  ["Ợ", "O"],
  ["ụ", "u"],
  ["Ụ", "U"],
  ["ủ", "u"],
  ["Ủ", "U"],
  ["ứ", "u"],
  ["Ứ", "U"],
  ["ừ", "u"],
  ["Ừ", "U"],
  ["ử", "u"],
  ["Ử", "U"],
  ["ữ", "u"],
  ["Ữ", "U"],
  ["ự", "u"],
  ["Ự", "U"],
  ["ỳ", "y"],
  ["Ỳ", "Y"],
  ["ỵ", "y"],
  ["Ỵ", "Y"],
  ["ỷ", "y"],
  ["Ỷ", "Y"],
  ["ỹ", "y"],
  ["Ỹ", "Y"],
  // Arabic
  ["ء", "e"],
  ["آ", "a"],
  ["أ", "a"],
  ["ؤ", "w"],
  ["إ", "a"],
  ["ئ", "y"],
  ["ا", "a"],
  ["ب", "b"],
  ["ة", "t"],
  ["ت", "t"],
  ["ث", "th"],
  ["ج", "j"],
  ["ح", "h"],
  ["خ", "kh"],
  ["د", "d"],
  ["ذ", "dh"],
  ["ر", "r"],
  ["ز", "z"],
  ["س", "s"],
  ["ش", "sh"],
  ["ص", "s"],
  ["ض", "d"],
  ["ط", "t"],
  ["ظ", "z"],
  ["ع", "e"],
  ["غ", "gh"],
  ["ـ", "_"],
  ["ف", "f"],
  ["ق", "q"],
  ["ك", "k"],
  ["ل", "l"],
  ["م", "m"],
  ["ن", "n"],
  ["ه", "h"],
  ["و", "w"],
  ["ى", "a"],
  ["ي", "y"],
  ["َ‎", "a"],
  ["ُ", "u"],
  ["ِ‎", "i"],
  ["٠", "0"],
  ["١", "1"],
  ["٢", "2"],
  ["٣", "3"],
  ["٤", "4"],
  ["٥", "5"],
  ["٦", "6"],
  ["٧", "7"],
  ["٨", "8"],
  ["٩", "9"],
  // Persian / Farsi
  ["چ", "ch"],
  ["ک", "k"],
  ["گ", "g"],
  ["پ", "p"],
  ["ژ", "zh"],
  ["ی", "y"],
  ["۰", "0"],
  ["۱", "1"],
  ["۲", "2"],
  ["۳", "3"],
  ["۴", "4"],
  ["۵", "5"],
  ["۶", "6"],
  ["۷", "7"],
  ["۸", "8"],
  ["۹", "9"],
  // Pashto
  ["ټ", "p"],
  ["ځ", "z"],
  ["څ", "c"],
  ["ډ", "d"],
  ["ﺫ", "d"],
  ["ﺭ", "r"],
  ["ړ", "r"],
  ["ﺯ", "z"],
  ["ږ", "g"],
  ["ښ", "x"],
  ["ګ", "g"],
  ["ڼ", "n"],
  ["ۀ", "e"],
  ["ې", "e"],
  ["ۍ", "ai"],
  // Urdu
  ["ٹ", "t"],
  ["ڈ", "d"],
  ["ڑ", "r"],
  ["ں", "n"],
  ["ہ", "h"],
  ["ھ", "h"],
  ["ے", "e"],
  // Russian
  ["А", "A"],
  ["а", "a"],
  ["Б", "B"],
  ["б", "b"],
  ["В", "V"],
  ["в", "v"],
  ["Г", "G"],
  ["г", "g"],
  ["Д", "D"],
  ["д", "d"],
  ["ъе", "ye"],
  ["Ъе", "Ye"],
  ["ъЕ", "yE"],
  ["ЪЕ", "YE"],
  ["Е", "E"],
  ["е", "e"],
  ["Ё", "Yo"],
  ["ё", "yo"],
  ["Ж", "Zh"],
  ["ж", "zh"],
  ["З", "Z"],
  ["з", "z"],
  ["И", "I"],
  ["и", "i"],
  ["ый", "iy"],
  ["Ый", "Iy"],
  ["ЫЙ", "IY"],
  ["ыЙ", "iY"],
  ["Й", "Y"],
  ["й", "y"],
  ["К", "K"],
  ["к", "k"],
  ["Л", "L"],
  ["л", "l"],
  ["М", "M"],
  ["м", "m"],
  ["Н", "N"],
  ["н", "n"],
  ["О", "O"],
  ["о", "o"],
  ["П", "P"],
  ["п", "p"],
  ["Р", "R"],
  ["р", "r"],
  ["С", "S"],
  ["с", "s"],
  ["Т", "T"],
  ["т", "t"],
  ["У", "U"],
  ["у", "u"],
  ["Ф", "F"],
  ["ф", "f"],
  ["Х", "Kh"],
  ["х", "kh"],
  ["Ц", "Ts"],
  ["ц", "ts"],
  ["Ч", "Ch"],
  ["ч", "ch"],
  ["Ш", "Sh"],
  ["ш", "sh"],
  ["Щ", "Sch"],
  ["щ", "sch"],
  ["Ъ", ""],
  ["ъ", ""],
  ["Ы", "Y"],
  ["ы", "y"],
  ["Ь", ""],
  ["ь", ""],
  ["Э", "E"],
  ["э", "e"],
  ["Ю", "Yu"],
  ["ю", "yu"],
  ["Я", "Ya"],
  ["я", "ya"],
  // Romanian
  ["ă", "a"],
  ["Ă", "A"],
  ["ș", "s"],
  ["Ș", "S"],
  ["ț", "t"],
  ["Ț", "T"],
  ["ţ", "t"],
  ["Ţ", "T"],
  // Turkish
  ["ş", "s"],
  ["Ş", "S"],
  ["ç", "c"],
  ["Ç", "C"],
  ["ğ", "g"],
  ["Ğ", "G"],
  ["ı", "i"],
  ["İ", "I"],
  // Armenian
  ["ա", "a"],
  ["Ա", "A"],
  ["բ", "b"],
  ["Բ", "B"],
  ["գ", "g"],
  ["Գ", "G"],
  ["դ", "d"],
  ["Դ", "D"],
  ["ե", "ye"],
  ["Ե", "Ye"],
  ["զ", "z"],
  ["Զ", "Z"],
  ["է", "e"],
  ["Է", "E"],
  ["ը", "y"],
  ["Ը", "Y"],
  ["թ", "t"],
  ["Թ", "T"],
  ["ժ", "zh"],
  ["Ժ", "Zh"],
  ["ի", "i"],
  ["Ի", "I"],
  ["լ", "l"],
  ["Լ", "L"],
  ["խ", "kh"],
  ["Խ", "Kh"],
  ["ծ", "ts"],
  ["Ծ", "Ts"],
  ["կ", "k"],
  ["Կ", "K"],
  ["հ", "h"],
  ["Հ", "H"],
  ["ձ", "dz"],
  ["Ձ", "Dz"],
  ["ղ", "gh"],
  ["Ղ", "Gh"],
  ["ճ", "tch"],
  ["Ճ", "Tch"],
  ["մ", "m"],
  ["Մ", "M"],
  ["յ", "y"],
  ["Յ", "Y"],
  ["ն", "n"],
  ["Ն", "N"],
  ["շ", "sh"],
  ["Շ", "Sh"],
  // NOTE: Longer Armenian sequences must come before shorter ones
  ["ու", "u"],
  ["ՈՒ", "U"],
  ["Ու", "U"],
  ["ո", "vo"],
  ["Ո", "Vo"],
  ["չ", "ch"],
  ["Չ", "Ch"],
  ["պ", "p"],
  ["Պ", "P"],
  ["ջ", "j"],
  ["Ջ", "J"],
  ["ռ", "r"],
  ["Ռ", "R"],
  ["ս", "s"],
  ["Ս", "S"],
  ["վ", "v"],
  ["Վ", "V"],
  ["տ", "t"],
  ["Տ", "T"],
  ["ր", "r"],
  ["Ր", "R"],
  ["ց", "c"],
  ["Ց", "C"],
  ["փ", "p"],
  ["Փ", "P"],
  ["ք", "q"],
  ["Ք", "Q"],
  ["օ", "o"],
  ["Օ", "O"],
  ["ֆ", "f"],
  ["Ֆ", "F"],
  ["և", "yev"],
  // Georgian
  ["ა", "a"],
  ["ბ", "b"],
  ["გ", "g"],
  ["დ", "d"],
  ["ე", "e"],
  ["ვ", "v"],
  ["ზ", "z"],
  ["თ", "t"],
  ["ი", "i"],
  ["კ", "k"],
  ["ლ", "l"],
  ["მ", "m"],
  ["ნ", "n"],
  ["ო", "o"],
  ["პ", "p"],
  ["ჟ", "zh"],
  ["რ", "r"],
  ["ს", "s"],
  ["ტ", "t"],
  ["უ", "u"],
  ["ფ", "ph"],
  ["ქ", "q"],
  ["ღ", "gh"],
  ["ყ", "k"],
  ["შ", "sh"],
  ["ჩ", "ch"],
  ["ც", "ts"],
  ["ძ", "dz"],
  ["წ", "ts"],
  ["ჭ", "tch"],
  ["ხ", "kh"],
  ["ჯ", "j"],
  ["ჰ", "h"],
  // Czech
  ["č", "c"],
  ["ď", "d"],
  ["ě", "e"],
  ["ň", "n"],
  ["ř", "r"],
  ["š", "s"],
  ["ť", "t"],
  ["ů", "u"],
  ["ž", "z"],
  ["Č", "C"],
  ["Ď", "D"],
  ["Ě", "E"],
  ["Ň", "N"],
  ["Ř", "R"],
  ["Š", "S"],
  ["Ť", "T"],
  ["Ů", "U"],
  ["Ž", "Z"],
  // Dhivehi
  ["ހ", "h"],
  ["ށ", "sh"],
  ["ނ", "n"],
  ["ރ", "r"],
  ["ބ", "b"],
  ["ޅ", "lh"],
  ["ކ", "k"],
  ["އ", "a"],
  ["ވ", "v"],
  ["މ", "m"],
  ["ފ", "f"],
  ["ދ", "dh"],
  ["ތ", "th"],
  ["ލ", "l"],
  ["ގ", "g"],
  ["ޏ", "gn"],
  ["ސ", "s"],
  ["ޑ", "d"],
  ["ޒ", "z"],
  ["ޓ", "t"],
  ["ޔ", "y"],
  ["ޕ", "p"],
  ["ޖ", "j"],
  ["ޗ", "ch"],
  ["ޘ", "tt"],
  ["ޙ", "hh"],
  ["ޚ", "kh"],
  ["ޛ", "th"],
  ["ޜ", "z"],
  ["ޝ", "sh"],
  ["ޞ", "s"],
  ["ޟ", "d"],
  ["ޠ", "t"],
  ["ޡ", "z"],
  ["ޢ", "a"],
  ["ޣ", "gh"],
  ["ޤ", "q"],
  ["ޥ", "w"],
  ["ަ", "a"],
  ["ާ", "aa"],
  ["ި", "i"],
  ["ީ", "ee"],
  ["ު", "u"],
  ["ޫ", "oo"],
  ["ެ", "e"],
  ["ޭ", "ey"],
  ["ޮ", "o"],
  ["ޯ", "oa"],
  ["ް", ""],
  // Greek
  ["α", "a"],
  ["β", "v"],
  ["γ", "g"],
  ["δ", "d"],
  ["ε", "e"],
  ["ζ", "z"],
  ["η", "i"],
  ["θ", "th"],
  ["ι", "i"],
  ["κ", "k"],
  ["λ", "l"],
  ["μ", "m"],
  ["ν", "n"],
  ["ξ", "ks"],
  ["ο", "o"],
  ["π", "p"],
  ["ρ", "r"],
  ["σ", "s"],
  ["τ", "t"],
  ["υ", "y"],
  ["φ", "f"],
  ["χ", "x"],
  ["ψ", "ps"],
  ["ω", "o"],
  ["ά", "a"],
  ["έ", "e"],
  ["ί", "i"],
  ["ό", "o"],
  ["ύ", "y"],
  ["ή", "i"],
  ["ώ", "o"],
  ["ς", "s"],
  ["ϊ", "i"],
  ["ΰ", "y"],
  ["ϋ", "y"],
  ["ΐ", "i"],
  ["Α", "A"],
  ["Β", "B"],
  ["Γ", "G"],
  ["Δ", "D"],
  ["Ε", "E"],
  ["Ζ", "Z"],
  ["Η", "I"],
  ["Θ", "TH"],
  ["Ι", "I"],
  ["Κ", "K"],
  ["Λ", "L"],
  ["Μ", "M"],
  ["Ν", "N"],
  ["Ξ", "KS"],
  ["Ο", "O"],
  ["Π", "P"],
  ["Ρ", "R"],
  ["Σ", "S"],
  ["Τ", "T"],
  ["Υ", "Y"],
  ["Φ", "F"],
  ["Χ", "X"],
  ["Ψ", "PS"],
  ["Ω", "O"],
  ["Ά", "A"],
  ["Έ", "E"],
  ["Ί", "I"],
  ["Ό", "O"],
  ["Ύ", "Y"],
  ["Ή", "I"],
  ["Ώ", "O"],
  ["Ϊ", "I"],
  ["Ϋ", "Y"],
  // Disabled as it conflicts with German and Latin.
  // Hungarian
  // ['ä', 'a'],
  // ['Ä', 'A'],
  // ['ö', 'o'],
  // ['Ö', 'O'],
  // ['ü', 'u'],
  // ['Ü', 'U'],
  // ['ű', 'u'],
  // ['Ű', 'U'],
  // Latvian
  ["ā", "a"],
  ["ē", "e"],
  ["ģ", "g"],
  ["ī", "i"],
  ["ķ", "k"],
  ["ļ", "l"],
  ["ņ", "n"],
  ["ū", "u"],
  ["Ā", "A"],
  ["Ē", "E"],
  ["Ģ", "G"],
  ["Ī", "I"],
  ["Ķ", "K"],
  ["Ļ", "L"],
  ["Ņ", "N"],
  ["Ū", "U"],
  ["č", "c"],
  ["š", "s"],
  ["ž", "z"],
  ["Č", "C"],
  ["Š", "S"],
  ["Ž", "Z"],
  // Lithuanian
  ["ą", "a"],
  ["č", "c"],
  ["ę", "e"],
  ["ė", "e"],
  ["į", "i"],
  ["š", "s"],
  ["ų", "u"],
  ["ū", "u"],
  ["ž", "z"],
  ["Ą", "A"],
  ["Č", "C"],
  ["Ę", "E"],
  ["Ė", "E"],
  ["Į", "I"],
  ["Š", "S"],
  ["Ų", "U"],
  ["Ū", "U"],
  // Macedonian
  ["Ќ", "Kj"],
  ["ќ", "kj"],
  ["Љ", "Lj"],
  ["љ", "lj"],
  ["Њ", "Nj"],
  ["њ", "nj"],
  ["Тс", "Ts"],
  ["тс", "ts"],
  // Polish
  ["ą", "a"],
  ["ć", "c"],
  ["ę", "e"],
  ["ł", "l"],
  ["ń", "n"],
  ["ś", "s"],
  ["ź", "z"],
  ["ż", "z"],
  ["Ą", "A"],
  ["Ć", "C"],
  ["Ę", "E"],
  ["Ł", "L"],
  ["Ń", "N"],
  ["Ś", "S"],
  ["Ź", "Z"],
  ["Ż", "Z"],
  // Disabled as it conflicts with Vietnamese.
  // Serbian
  // ['љ', 'lj'],
  // ['њ', 'nj'],
  // ['Љ', 'Lj'],
  // ['Њ', 'Nj'],
  // ['đ', 'dj'],
  // ['Đ', 'Dj'],
  // ['ђ', 'dj'],
  // ['ј', 'j'],
  // ['ћ', 'c'],
  // ['џ', 'dz'],
  // ['Ђ', 'Dj'],
  // ['Ј', 'j'],
  // ['Ћ', 'C'],
  // ['Џ', 'Dz'],
  // Disabled as it conflicts with German and Latin.
  // Slovak
  // ['ä', 'a'],
  // ['Ä', 'A'],
  // ['ľ', 'l'],
  // ['ĺ', 'l'],
  // ['ŕ', 'r'],
  // ['Ľ', 'L'],
  // ['Ĺ', 'L'],
  // ['Ŕ', 'R'],
  // Disabled as it conflicts with German and Latin.
  // Swedish
  // ['å', 'o'],
  // ['Å', 'o'],
  // ['ä', 'a'],
  // ['Ä', 'A'],
  // ['ë', 'e'],
  // ['Ë', 'E'],
  // ['ö', 'o'],
  // ['Ö', 'O'],
  // Ukrainian
  ["Є", "Ye"],
  ["І", "I"],
  ["Ї", "Yi"],
  ["Ґ", "G"],
  ["є", "ye"],
  ["і", "i"],
  ["ї", "yi"],
  ["ґ", "g"],
  // Dutch
  ["Ĳ", "IJ"],
  ["ĳ", "ij"],
  // Danish
  // ['Æ', 'Ae'],
  // ['Ø', 'Oe'],
  // ['Å', 'Aa'],
  // ['æ', 'ae'],
  // ['ø', 'oe'],
  // ['å', 'aa']
  // Currencies
  ["¢", "c"],
  ["¥", "Y"],
  ["߿", "b"],
  ["৳", "t"],
  ["૱", "Bo"],
  ["฿", "B"],
  ["₠", "CE"],
  ["₡", "C"],
  ["₢", "Cr"],
  ["₣", "F"],
  ["₥", "m"],
  ["₦", "N"],
  ["₧", "Pt"],
  ["₨", "Rs"],
  ["₩", "W"],
  ["₫", "s"],
  ["€", "E"],
  ["₭", "K"],
  ["₮", "T"],
  ["₯", "Dp"],
  ["₰", "S"],
  ["₱", "P"],
  ["₲", "G"],
  ["₳", "A"],
  ["₴", "S"],
  ["₵", "C"],
  ["₶", "tt"],
  ["₷", "S"],
  ["₸", "T"],
  ["₹", "R"],
  ["₺", "L"],
  ["₽", "P"],
  ["₿", "B"],
  ["﹩", "$"],
  ["￠", "c"],
  ["￥", "Y"],
  ["￦", "W"],
  // Latin
  ["𝐀", "A"],
  ["𝐁", "B"],
  ["𝐂", "C"],
  ["𝐃", "D"],
  ["𝐄", "E"],
  ["𝐅", "F"],
  ["𝐆", "G"],
  ["𝐇", "H"],
  ["𝐈", "I"],
  ["𝐉", "J"],
  ["𝐊", "K"],
  ["𝐋", "L"],
  ["𝐌", "M"],
  ["𝐍", "N"],
  ["𝐎", "O"],
  ["𝐏", "P"],
  ["𝐐", "Q"],
  ["𝐑", "R"],
  ["𝐒", "S"],
  ["𝐓", "T"],
  ["𝐔", "U"],
  ["𝐕", "V"],
  ["𝐖", "W"],
  ["𝐗", "X"],
  ["𝐘", "Y"],
  ["𝐙", "Z"],
  ["𝐚", "a"],
  ["𝐛", "b"],
  ["𝐜", "c"],
  ["𝐝", "d"],
  ["𝐞", "e"],
  ["𝐟", "f"],
  ["𝐠", "g"],
  ["𝐡", "h"],
  ["𝐢", "i"],
  ["𝐣", "j"],
  ["𝐤", "k"],
  ["𝐥", "l"],
  ["𝐦", "m"],
  ["𝐧", "n"],
  ["𝐨", "o"],
  ["𝐩", "p"],
  ["𝐪", "q"],
  ["𝐫", "r"],
  ["𝐬", "s"],
  ["𝐭", "t"],
  ["𝐮", "u"],
  ["𝐯", "v"],
  ["𝐰", "w"],
  ["𝐱", "x"],
  ["𝐲", "y"],
  ["𝐳", "z"],
  ["𝐴", "A"],
  ["𝐵", "B"],
  ["𝐶", "C"],
  ["𝐷", "D"],
  ["𝐸", "E"],
  ["𝐹", "F"],
  ["𝐺", "G"],
  ["𝐻", "H"],
  ["𝐼", "I"],
  ["𝐽", "J"],
  ["𝐾", "K"],
  ["𝐿", "L"],
  ["𝑀", "M"],
  ["𝑁", "N"],
  ["𝑂", "O"],
  ["𝑃", "P"],
  ["𝑄", "Q"],
  ["𝑅", "R"],
  ["𝑆", "S"],
  ["𝑇", "T"],
  ["𝑈", "U"],
  ["𝑉", "V"],
  ["𝑊", "W"],
  ["𝑋", "X"],
  ["𝑌", "Y"],
  ["𝑍", "Z"],
  ["𝑎", "a"],
  ["𝑏", "b"],
  ["𝑐", "c"],
  ["𝑑", "d"],
  ["𝑒", "e"],
  ["𝑓", "f"],
  ["𝑔", "g"],
  ["𝑖", "i"],
  ["𝑗", "j"],
  ["𝑘", "k"],
  ["𝑙", "l"],
  ["𝑚", "m"],
  ["𝑛", "n"],
  ["𝑜", "o"],
  ["𝑝", "p"],
  ["𝑞", "q"],
  ["𝑟", "r"],
  ["𝑠", "s"],
  ["𝑡", "t"],
  ["𝑢", "u"],
  ["𝑣", "v"],
  ["𝑤", "w"],
  ["𝑥", "x"],
  ["𝑦", "y"],
  ["𝑧", "z"],
  ["𝑨", "A"],
  ["𝑩", "B"],
  ["𝑪", "C"],
  ["𝑫", "D"],
  ["𝑬", "E"],
  ["𝑭", "F"],
  ["𝑮", "G"],
  ["𝑯", "H"],
  ["𝑰", "I"],
  ["𝑱", "J"],
  ["𝑲", "K"],
  ["𝑳", "L"],
  ["𝑴", "M"],
  ["𝑵", "N"],
  ["𝑶", "O"],
  ["𝑷", "P"],
  ["𝑸", "Q"],
  ["𝑹", "R"],
  ["𝑺", "S"],
  ["𝑻", "T"],
  ["𝑼", "U"],
  ["𝑽", "V"],
  ["𝑾", "W"],
  ["𝑿", "X"],
  ["𝒀", "Y"],
  ["𝒁", "Z"],
  ["𝒂", "a"],
  ["𝒃", "b"],
  ["𝒄", "c"],
  ["𝒅", "d"],
  ["𝒆", "e"],
  ["𝒇", "f"],
  ["𝒈", "g"],
  ["𝒉", "h"],
  ["𝒊", "i"],
  ["𝒋", "j"],
  ["𝒌", "k"],
  ["𝒍", "l"],
  ["𝒎", "m"],
  ["𝒏", "n"],
  ["𝒐", "o"],
  ["𝒑", "p"],
  ["𝒒", "q"],
  ["𝒓", "r"],
  ["𝒔", "s"],
  ["𝒕", "t"],
  ["𝒖", "u"],
  ["𝒗", "v"],
  ["𝒘", "w"],
  ["𝒙", "x"],
  ["𝒚", "y"],
  ["𝒛", "z"],
  ["𝒜", "A"],
  ["𝒞", "C"],
  ["𝒟", "D"],
  ["𝒢", "g"],
  ["𝒥", "J"],
  ["𝒦", "K"],
  ["𝒩", "N"],
  ["𝒪", "O"],
  ["𝒫", "P"],
  ["𝒬", "Q"],
  ["𝒮", "S"],
  ["𝒯", "T"],
  ["𝒰", "U"],
  ["𝒱", "V"],
  ["𝒲", "W"],
  ["𝒳", "X"],
  ["𝒴", "Y"],
  ["𝒵", "Z"],
  ["𝒶", "a"],
  ["𝒷", "b"],
  ["𝒸", "c"],
  ["𝒹", "d"],
  ["𝒻", "f"],
  ["𝒽", "h"],
  ["𝒾", "i"],
  ["𝒿", "j"],
  ["𝓀", "k"],
  ["𝓁", "l"],
  ["𝓂", "m"],
  ["𝓃", "n"],
  ["𝓅", "p"],
  ["𝓆", "q"],
  ["𝓇", "r"],
  ["𝓈", "s"],
  ["𝓉", "t"],
  ["𝓊", "u"],
  ["𝓋", "v"],
  ["𝓌", "w"],
  ["𝓍", "x"],
  ["𝓎", "y"],
  ["𝓏", "z"],
  ["𝓐", "A"],
  ["𝓑", "B"],
  ["𝓒", "C"],
  ["𝓓", "D"],
  ["𝓔", "E"],
  ["𝓕", "F"],
  ["𝓖", "G"],
  ["𝓗", "H"],
  ["𝓘", "I"],
  ["𝓙", "J"],
  ["𝓚", "K"],
  ["𝓛", "L"],
  ["𝓜", "M"],
  ["𝓝", "N"],
  ["𝓞", "O"],
  ["𝓟", "P"],
  ["𝓠", "Q"],
  ["𝓡", "R"],
  ["𝓢", "S"],
  ["𝓣", "T"],
  ["𝓤", "U"],
  ["𝓥", "V"],
  ["𝓦", "W"],
  ["𝓧", "X"],
  ["𝓨", "Y"],
  ["𝓩", "Z"],
  ["𝓪", "a"],
  ["𝓫", "b"],
  ["𝓬", "c"],
  ["𝓭", "d"],
  ["𝓮", "e"],
  ["𝓯", "f"],
  ["𝓰", "g"],
  ["𝓱", "h"],
  ["𝓲", "i"],
  ["𝓳", "j"],
  ["𝓴", "k"],
  ["𝓵", "l"],
  ["𝓶", "m"],
  ["𝓷", "n"],
  ["𝓸", "o"],
  ["𝓹", "p"],
  ["𝓺", "q"],
  ["𝓻", "r"],
  ["𝓼", "s"],
  ["𝓽", "t"],
  ["𝓾", "u"],
  ["𝓿", "v"],
  ["𝔀", "w"],
  ["𝔁", "x"],
  ["𝔂", "y"],
  ["𝔃", "z"],
  ["𝔄", "A"],
  ["𝔅", "B"],
  ["𝔇", "D"],
  ["𝔈", "E"],
  ["𝔉", "F"],
  ["𝔊", "G"],
  ["𝔍", "J"],
  ["𝔎", "K"],
  ["𝔏", "L"],
  ["𝔐", "M"],
  ["𝔑", "N"],
  ["𝔒", "O"],
  ["𝔓", "P"],
  ["𝔔", "Q"],
  ["𝔖", "S"],
  ["𝔗", "T"],
  ["𝔘", "U"],
  ["𝔙", "V"],
  ["𝔚", "W"],
  ["𝔛", "X"],
  ["𝔜", "Y"],
  ["𝔞", "a"],
  ["𝔟", "b"],
  ["𝔠", "c"],
  ["𝔡", "d"],
  ["𝔢", "e"],
  ["𝔣", "f"],
  ["𝔤", "g"],
  ["𝔥", "h"],
  ["𝔦", "i"],
  ["𝔧", "j"],
  ["𝔨", "k"],
  ["𝔩", "l"],
  ["𝔪", "m"],
  ["𝔫", "n"],
  ["𝔬", "o"],
  ["𝔭", "p"],
  ["𝔮", "q"],
  ["𝔯", "r"],
  ["𝔰", "s"],
  ["𝔱", "t"],
  ["𝔲", "u"],
  ["𝔳", "v"],
  ["𝔴", "w"],
  ["𝔵", "x"],
  ["𝔶", "y"],
  ["𝔷", "z"],
  ["𝔸", "A"],
  ["𝔹", "B"],
  ["𝔻", "D"],
  ["𝔼", "E"],
  ["𝔽", "F"],
  ["𝔾", "G"],
  ["𝕀", "I"],
  ["𝕁", "J"],
  ["𝕂", "K"],
  ["𝕃", "L"],
  ["𝕄", "M"],
  ["𝕆", "O"],
  ["𝕊", "S"],
  ["𝕋", "T"],
  ["𝕌", "U"],
  ["𝕍", "V"],
  ["𝕎", "W"],
  ["𝕏", "X"],
  ["𝕐", "Y"],
  ["𝕒", "a"],
  ["𝕓", "b"],
  ["𝕔", "c"],
  ["𝕕", "d"],
  ["𝕖", "e"],
  ["𝕗", "f"],
  ["𝕘", "g"],
  ["𝕙", "h"],
  ["𝕚", "i"],
  ["𝕛", "j"],
  ["𝕜", "k"],
  ["𝕝", "l"],
  ["𝕞", "m"],
  ["𝕟", "n"],
  ["𝕠", "o"],
  ["𝕡", "p"],
  ["𝕢", "q"],
  ["𝕣", "r"],
  ["𝕤", "s"],
  ["𝕥", "t"],
  ["𝕦", "u"],
  ["𝕧", "v"],
  ["𝕨", "w"],
  ["𝕩", "x"],
  ["𝕪", "y"],
  ["𝕫", "z"],
  ["𝕬", "A"],
  ["𝕭", "B"],
  ["𝕮", "C"],
  ["𝕯", "D"],
  ["𝕰", "E"],
  ["𝕱", "F"],
  ["𝕲", "G"],
  ["𝕳", "H"],
  ["𝕴", "I"],
  ["𝕵", "J"],
  ["𝕶", "K"],
  ["𝕷", "L"],
  ["𝕸", "M"],
  ["𝕹", "N"],
  ["𝕺", "O"],
  ["𝕻", "P"],
  ["𝕼", "Q"],
  ["𝕽", "R"],
  ["𝕾", "S"],
  ["𝕿", "T"],
  ["𝖀", "U"],
  ["𝖁", "V"],
  ["𝖂", "W"],
  ["𝖃", "X"],
  ["𝖄", "Y"],
  ["𝖅", "Z"],
  ["𝖆", "a"],
  ["𝖇", "b"],
  ["𝖈", "c"],
  ["𝖉", "d"],
  ["𝖊", "e"],
  ["𝖋", "f"],
  ["𝖌", "g"],
  ["𝖍", "h"],
  ["𝖎", "i"],
  ["𝖏", "j"],
  ["𝖐", "k"],
  ["𝖑", "l"],
  ["𝖒", "m"],
  ["𝖓", "n"],
  ["𝖔", "o"],
  ["𝖕", "p"],
  ["𝖖", "q"],
  ["𝖗", "r"],
  ["𝖘", "s"],
  ["𝖙", "t"],
  ["𝖚", "u"],
  ["𝖛", "v"],
  ["𝖜", "w"],
  ["𝖝", "x"],
  ["𝖞", "y"],
  ["𝖟", "z"],
  ["𝖠", "A"],
  ["𝖡", "B"],
  ["𝖢", "C"],
  ["𝖣", "D"],
  ["𝖤", "E"],
  ["𝖥", "F"],
  ["𝖦", "G"],
  ["𝖧", "H"],
  ["𝖨", "I"],
  ["𝖩", "J"],
  ["𝖪", "K"],
  ["𝖫", "L"],
  ["𝖬", "M"],
  ["𝖭", "N"],
  ["𝖮", "O"],
  ["𝖯", "P"],
  ["𝖰", "Q"],
  ["𝖱", "R"],
  ["𝖲", "S"],
  ["𝖳", "T"],
  ["𝖴", "U"],
  ["𝖵", "V"],
  ["𝖶", "W"],
  ["𝖷", "X"],
  ["𝖸", "Y"],
  ["𝖹", "Z"],
  ["𝖺", "a"],
  ["𝖻", "b"],
  ["𝖼", "c"],
  ["𝖽", "d"],
  ["𝖾", "e"],
  ["𝖿", "f"],
  ["𝗀", "g"],
  ["𝗁", "h"],
  ["𝗂", "i"],
  ["𝗃", "j"],
  ["𝗄", "k"],
  ["𝗅", "l"],
  ["𝗆", "m"],
  ["𝗇", "n"],
  ["𝗈", "o"],
  ["𝗉", "p"],
  ["𝗊", "q"],
  ["𝗋", "r"],
  ["𝗌", "s"],
  ["𝗍", "t"],
  ["𝗎", "u"],
  ["𝗏", "v"],
  ["𝗐", "w"],
  ["𝗑", "x"],
  ["𝗒", "y"],
  ["𝗓", "z"],
  ["𝗔", "A"],
  ["𝗕", "B"],
  ["𝗖", "C"],
  ["𝗗", "D"],
  ["𝗘", "E"],
  ["𝗙", "F"],
  ["𝗚", "G"],
  ["𝗛", "H"],
  ["𝗜", "I"],
  ["𝗝", "J"],
  ["𝗞", "K"],
  ["𝗟", "L"],
  ["𝗠", "M"],
  ["𝗡", "N"],
  ["𝗢", "O"],
  ["𝗣", "P"],
  ["𝗤", "Q"],
  ["𝗥", "R"],
  ["𝗦", "S"],
  ["𝗧", "T"],
  ["𝗨", "U"],
  ["𝗩", "V"],
  ["𝗪", "W"],
  ["𝗫", "X"],
  ["𝗬", "Y"],
  ["𝗭", "Z"],
  ["𝗮", "a"],
  ["𝗯", "b"],
  ["𝗰", "c"],
  ["𝗱", "d"],
  ["𝗲", "e"],
  ["𝗳", "f"],
  ["𝗴", "g"],
  ["𝗵", "h"],
  ["𝗶", "i"],
  ["𝗷", "j"],
  ["𝗸", "k"],
  ["𝗹", "l"],
  ["𝗺", "m"],
  ["𝗻", "n"],
  ["𝗼", "o"],
  ["𝗽", "p"],
  ["𝗾", "q"],
  ["𝗿", "r"],
  ["𝘀", "s"],
  ["𝘁", "t"],
  ["𝘂", "u"],
  ["𝘃", "v"],
  ["𝘄", "w"],
  ["𝘅", "x"],
  ["𝘆", "y"],
  ["𝘇", "z"],
  ["𝘈", "A"],
  ["𝘉", "B"],
  ["𝘊", "C"],
  ["𝘋", "D"],
  ["𝘌", "E"],
  ["𝘍", "F"],
  ["𝘎", "G"],
  ["𝘏", "H"],
  ["𝘐", "I"],
  ["𝘑", "J"],
  ["𝘒", "K"],
  ["𝘓", "L"],
  ["𝘔", "M"],
  ["𝘕", "N"],
  ["𝘖", "O"],
  ["𝘗", "P"],
  ["𝘘", "Q"],
  ["𝘙", "R"],
  ["𝘚", "S"],
  ["𝘛", "T"],
  ["𝘜", "U"],
  ["𝘝", "V"],
  ["𝘞", "W"],
  ["𝘟", "X"],
  ["𝘠", "Y"],
  ["𝘡", "Z"],
  ["𝘢", "a"],
  ["𝘣", "b"],
  ["𝘤", "c"],
  ["𝘥", "d"],
  ["𝘦", "e"],
  ["𝘧", "f"],
  ["𝘨", "g"],
  ["𝘩", "h"],
  ["𝘪", "i"],
  ["𝘫", "j"],
  ["𝘬", "k"],
  ["𝘭", "l"],
  ["𝘮", "m"],
  ["𝘯", "n"],
  ["𝘰", "o"],
  ["𝘱", "p"],
  ["𝘲", "q"],
  ["𝘳", "r"],
  ["𝘴", "s"],
  ["𝘵", "t"],
  ["𝘶", "u"],
  ["𝘷", "v"],
  ["𝘸", "w"],
  ["𝘹", "x"],
  ["𝘺", "y"],
  ["𝘻", "z"],
  ["𝘼", "A"],
  ["𝘽", "B"],
  ["𝘾", "C"],
  ["𝘿", "D"],
  ["𝙀", "E"],
  ["𝙁", "F"],
  ["𝙂", "G"],
  ["𝙃", "H"],
  ["𝙄", "I"],
  ["𝙅", "J"],
  ["𝙆", "K"],
  ["𝙇", "L"],
  ["𝙈", "M"],
  ["𝙉", "N"],
  ["𝙊", "O"],
  ["𝙋", "P"],
  ["𝙌", "Q"],
  ["𝙍", "R"],
  ["𝙎", "S"],
  ["𝙏", "T"],
  ["𝙐", "U"],
  ["𝙑", "V"],
  ["𝙒", "W"],
  ["𝙓", "X"],
  ["𝙔", "Y"],
  ["𝙕", "Z"],
  ["𝙖", "a"],
  ["𝙗", "b"],
  ["𝙘", "c"],
  ["𝙙", "d"],
  ["𝙚", "e"],
  ["𝙛", "f"],
  ["𝙜", "g"],
  ["𝙝", "h"],
  ["𝙞", "i"],
  ["𝙟", "j"],
  ["𝙠", "k"],
  ["𝙡", "l"],
  ["𝙢", "m"],
  ["𝙣", "n"],
  ["𝙤", "o"],
  ["𝙥", "p"],
  ["𝙦", "q"],
  ["𝙧", "r"],
  ["𝙨", "s"],
  ["𝙩", "t"],
  ["𝙪", "u"],
  ["𝙫", "v"],
  ["𝙬", "w"],
  ["𝙭", "x"],
  ["𝙮", "y"],
  ["𝙯", "z"],
  ["𝙰", "A"],
  ["𝙱", "B"],
  ["𝙲", "C"],
  ["𝙳", "D"],
  ["𝙴", "E"],
  ["𝙵", "F"],
  ["𝙶", "G"],
  ["𝙷", "H"],
  ["𝙸", "I"],
  ["𝙹", "J"],
  ["𝙺", "K"],
  ["𝙻", "L"],
  ["𝙼", "M"],
  ["𝙽", "N"],
  ["𝙾", "O"],
  ["𝙿", "P"],
  ["𝚀", "Q"],
  ["𝚁", "R"],
  ["𝚂", "S"],
  ["𝚃", "T"],
  ["𝚄", "U"],
  ["𝚅", "V"],
  ["𝚆", "W"],
  ["𝚇", "X"],
  ["𝚈", "Y"],
  ["𝚉", "Z"],
  ["𝚊", "a"],
  ["𝚋", "b"],
  ["𝚌", "c"],
  ["𝚍", "d"],
  ["𝚎", "e"],
  ["𝚏", "f"],
  ["𝚐", "g"],
  ["𝚑", "h"],
  ["𝚒", "i"],
  ["𝚓", "j"],
  ["𝚔", "k"],
  ["𝚕", "l"],
  ["𝚖", "m"],
  ["𝚗", "n"],
  ["𝚘", "o"],
  ["𝚙", "p"],
  ["𝚚", "q"],
  ["𝚛", "r"],
  ["𝚜", "s"],
  ["𝚝", "t"],
  ["𝚞", "u"],
  ["𝚟", "v"],
  ["𝚠", "w"],
  ["𝚡", "x"],
  ["𝚢", "y"],
  ["𝚣", "z"],
  // Dotless letters
  ["𝚤", "l"],
  ["𝚥", "j"],
  // Greek
  ["𝛢", "A"],
  ["𝛣", "B"],
  ["𝛤", "G"],
  ["𝛥", "D"],
  ["𝛦", "E"],
  ["𝛧", "Z"],
  ["𝛨", "I"],
  ["𝛩", "TH"],
  ["𝛪", "I"],
  ["𝛫", "K"],
  ["𝛬", "L"],
  ["𝛭", "M"],
  ["𝛮", "N"],
  ["𝛯", "KS"],
  ["𝛰", "O"],
  ["𝛱", "P"],
  ["𝛲", "R"],
  ["𝛳", "TH"],
  ["𝛴", "S"],
  ["𝛵", "T"],
  ["𝛶", "Y"],
  ["𝛷", "F"],
  ["𝛸", "x"],
  ["𝛹", "PS"],
  ["𝛺", "O"],
  ["𝛻", "D"],
  ["𝛼", "a"],
  ["𝛽", "b"],
  ["𝛾", "g"],
  ["𝛿", "d"],
  ["𝜀", "e"],
  ["𝜁", "z"],
  ["𝜂", "i"],
  ["𝜃", "th"],
  ["𝜄", "i"],
  ["𝜅", "k"],
  ["𝜆", "l"],
  ["𝜇", "m"],
  ["𝜈", "n"],
  ["𝜉", "ks"],
  ["𝜊", "o"],
  ["𝜋", "p"],
  ["𝜌", "r"],
  ["𝜍", "s"],
  ["𝜎", "s"],
  ["𝜏", "t"],
  ["𝜐", "y"],
  ["𝜑", "f"],
  ["𝜒", "x"],
  ["𝜓", "ps"],
  ["𝜔", "o"],
  ["𝜕", "d"],
  ["𝜖", "E"],
  ["𝜗", "TH"],
  ["𝜘", "K"],
  ["𝜙", "f"],
  ["𝜚", "r"],
  ["𝜛", "p"],
  ["𝜜", "A"],
  ["𝜝", "V"],
  ["𝜞", "G"],
  ["𝜟", "D"],
  ["𝜠", "E"],
  ["𝜡", "Z"],
  ["𝜢", "I"],
  ["𝜣", "TH"],
  ["𝜤", "I"],
  ["𝜥", "K"],
  ["𝜦", "L"],
  ["𝜧", "M"],
  ["𝜨", "N"],
  ["𝜩", "KS"],
  ["𝜪", "O"],
  ["𝜫", "P"],
  ["𝜬", "S"],
  ["𝜭", "TH"],
  ["𝜮", "S"],
  ["𝜯", "T"],
  ["𝜰", "Y"],
  ["𝜱", "F"],
  ["𝜲", "X"],
  ["𝜳", "PS"],
  ["𝜴", "O"],
  ["𝜵", "D"],
  ["𝜶", "a"],
  ["𝜷", "v"],
  ["𝜸", "g"],
  ["𝜹", "d"],
  ["𝜺", "e"],
  ["𝜻", "z"],
  ["𝜼", "i"],
  ["𝜽", "th"],
  ["𝜾", "i"],
  ["𝜿", "k"],
  ["𝝀", "l"],
  ["𝝁", "m"],
  ["𝝂", "n"],
  ["𝝃", "ks"],
  ["𝝄", "o"],
  ["𝝅", "p"],
  ["𝝆", "r"],
  ["𝝇", "s"],
  ["𝝈", "s"],
  ["𝝉", "t"],
  ["𝝊", "y"],
  ["𝝋", "f"],
  ["𝝌", "x"],
  ["𝝍", "ps"],
  ["𝝎", "o"],
  ["𝝏", "a"],
  ["𝝐", "e"],
  ["𝝑", "i"],
  ["𝝒", "k"],
  ["𝝓", "f"],
  ["𝝔", "r"],
  ["𝝕", "p"],
  ["𝝖", "A"],
  ["𝝗", "B"],
  ["𝝘", "G"],
  ["𝝙", "D"],
  ["𝝚", "E"],
  ["𝝛", "Z"],
  ["𝝜", "I"],
  ["𝝝", "TH"],
  ["𝝞", "I"],
  ["𝝟", "K"],
  ["𝝠", "L"],
  ["𝝡", "M"],
  ["𝝢", "N"],
  ["𝝣", "KS"],
  ["𝝤", "O"],
  ["𝝥", "P"],
  ["𝝦", "R"],
  ["𝝧", "TH"],
  ["𝝨", "S"],
  ["𝝩", "T"],
  ["𝝪", "Y"],
  ["𝝫", "F"],
  ["𝝬", "X"],
  ["𝝭", "PS"],
  ["𝝮", "O"],
  ["𝝯", "D"],
  ["𝝰", "a"],
  ["𝝱", "v"],
  ["𝝲", "g"],
  ["𝝳", "d"],
  ["𝝴", "e"],
  ["𝝵", "z"],
  ["𝝶", "i"],
  ["𝝷", "th"],
  ["𝝸", "i"],
  ["𝝹", "k"],
  ["𝝺", "l"],
  ["𝝻", "m"],
  ["𝝼", "n"],
  ["𝝽", "ks"],
  ["𝝾", "o"],
  ["𝝿", "p"],
  ["𝞀", "r"],
  ["𝞁", "s"],
  ["𝞂", "s"],
  ["𝞃", "t"],
  ["𝞄", "y"],
  ["𝞅", "f"],
  ["𝞆", "x"],
  ["𝞇", "ps"],
  ["𝞈", "o"],
  ["𝞉", "a"],
  ["𝞊", "e"],
  ["𝞋", "i"],
  ["𝞌", "k"],
  ["𝞍", "f"],
  ["𝞎", "r"],
  ["𝞏", "p"],
  ["𝞐", "A"],
  ["𝞑", "V"],
  ["𝞒", "G"],
  ["𝞓", "D"],
  ["𝞔", "E"],
  ["𝞕", "Z"],
  ["𝞖", "I"],
  ["𝞗", "TH"],
  ["𝞘", "I"],
  ["𝞙", "K"],
  ["𝞚", "L"],
  ["𝞛", "M"],
  ["𝞜", "N"],
  ["𝞝", "KS"],
  ["𝞞", "O"],
  ["𝞟", "P"],
  ["𝞠", "S"],
  ["𝞡", "TH"],
  ["𝞢", "S"],
  ["𝞣", "T"],
  ["𝞤", "Y"],
  ["𝞥", "F"],
  ["𝞦", "X"],
  ["𝞧", "PS"],
  ["𝞨", "O"],
  ["𝞩", "D"],
  ["𝞪", "av"],
  ["𝞫", "g"],
  ["𝞬", "d"],
  ["𝞭", "e"],
  ["𝞮", "z"],
  ["𝞯", "i"],
  ["𝞰", "i"],
  ["𝞱", "th"],
  ["𝞲", "i"],
  ["𝞳", "k"],
  ["𝞴", "l"],
  ["𝞵", "m"],
  ["𝞶", "n"],
  ["𝞷", "ks"],
  ["𝞸", "o"],
  ["𝞹", "p"],
  ["𝞺", "r"],
  ["𝞻", "s"],
  ["𝞼", "s"],
  ["𝞽", "t"],
  ["𝞾", "y"],
  ["𝞿", "f"],
  ["𝟀", "x"],
  ["𝟁", "ps"],
  ["𝟂", "o"],
  ["𝟃", "a"],
  ["𝟄", "e"],
  ["𝟅", "i"],
  ["𝟆", "k"],
  ["𝟇", "f"],
  ["𝟈", "r"],
  ["𝟉", "p"],
  ["𝟊", "F"],
  ["𝟋", "f"],
  ["⒜", "(a)"],
  ["⒝", "(b)"],
  ["⒞", "(c)"],
  ["⒟", "(d)"],
  ["⒠", "(e)"],
  ["⒡", "(f)"],
  ["⒢", "(g)"],
  ["⒣", "(h)"],
  ["⒤", "(i)"],
  ["⒥", "(j)"],
  ["⒦", "(k)"],
  ["⒧", "(l)"],
  ["⒨", "(m)"],
  ["⒩", "(n)"],
  ["⒪", "(o)"],
  ["⒫", "(p)"],
  ["⒬", "(q)"],
  ["⒭", "(r)"],
  ["⒮", "(s)"],
  ["⒯", "(t)"],
  ["⒰", "(u)"],
  ["⒱", "(v)"],
  ["⒲", "(w)"],
  ["⒳", "(x)"],
  ["⒴", "(y)"],
  ["⒵", "(z)"],
  ["Ⓐ", "(A)"],
  ["Ⓑ", "(B)"],
  ["Ⓒ", "(C)"],
  ["Ⓓ", "(D)"],
  ["Ⓔ", "(E)"],
  ["Ⓕ", "(F)"],
  ["Ⓖ", "(G)"],
  ["Ⓗ", "(H)"],
  ["Ⓘ", "(I)"],
  ["Ⓙ", "(J)"],
  ["Ⓚ", "(K)"],
  ["Ⓛ", "(L)"],
  ["Ⓝ", "(N)"],
  ["Ⓞ", "(O)"],
  ["Ⓟ", "(P)"],
  ["Ⓠ", "(Q)"],
  ["Ⓡ", "(R)"],
  ["Ⓢ", "(S)"],
  ["Ⓣ", "(T)"],
  ["Ⓤ", "(U)"],
  ["Ⓥ", "(V)"],
  ["Ⓦ", "(W)"],
  ["Ⓧ", "(X)"],
  ["Ⓨ", "(Y)"],
  ["Ⓩ", "(Z)"],
  ["ⓐ", "(a)"],
  ["ⓑ", "(b)"],
  ["ⓒ", "(c)"],
  ["ⓓ", "(d)"],
  ["ⓔ", "(e)"],
  ["ⓕ", "(f)"],
  ["ⓖ", "(g)"],
  ["ⓗ", "(h)"],
  ["ⓘ", "(i)"],
  ["ⓙ", "(j)"],
  ["ⓚ", "(k)"],
  ["ⓛ", "(l)"],
  ["ⓜ", "(m)"],
  ["ⓝ", "(n)"],
  ["ⓞ", "(o)"],
  ["ⓟ", "(p)"],
  ["ⓠ", "(q)"],
  ["ⓡ", "(r)"],
  ["ⓢ", "(s)"],
  ["ⓣ", "(t)"],
  ["ⓤ", "(u)"],
  ["ⓥ", "(v)"],
  ["ⓦ", "(w)"],
  ["ⓧ", "(x)"],
  ["ⓨ", "(y)"],
  ["ⓩ", "(z)"],
  // Maltese
  ["Ċ", "C"],
  ["ċ", "c"],
  ["Ġ", "G"],
  ["ġ", "g"],
  ["Ħ", "H"],
  ["ħ", "h"],
  ["Ż", "Z"],
  ["ż", "z"],
  // Numbers
  ["𝟎", "0"],
  ["𝟏", "1"],
  ["𝟐", "2"],
  ["𝟑", "3"],
  ["𝟒", "4"],
  ["𝟓", "5"],
  ["𝟔", "6"],
  ["𝟕", "7"],
  ["𝟖", "8"],
  ["𝟗", "9"],
  ["𝟘", "0"],
  ["𝟙", "1"],
  ["𝟚", "2"],
  ["𝟛", "3"],
  ["𝟜", "4"],
  ["𝟝", "5"],
  ["𝟞", "6"],
  ["𝟟", "7"],
  ["𝟠", "8"],
  ["𝟡", "9"],
  ["𝟢", "0"],
  ["𝟣", "1"],
  ["𝟤", "2"],
  ["𝟥", "3"],
  ["𝟦", "4"],
  ["𝟧", "5"],
  ["𝟨", "6"],
  ["𝟩", "7"],
  ["𝟪", "8"],
  ["𝟫", "9"],
  ["𝟬", "0"],
  ["𝟭", "1"],
  ["𝟮", "2"],
  ["𝟯", "3"],
  ["𝟰", "4"],
  ["𝟱", "5"],
  ["𝟲", "6"],
  ["𝟳", "7"],
  ["𝟴", "8"],
  ["𝟵", "9"],
  ["𝟶", "0"],
  ["𝟷", "1"],
  ["𝟸", "2"],
  ["𝟹", "3"],
  ["𝟺", "4"],
  ["𝟻", "5"],
  ["𝟼", "6"],
  ["𝟽", "7"],
  ["𝟾", "8"],
  ["𝟿", "9"],
  ["①", "1"],
  ["②", "2"],
  ["③", "3"],
  ["④", "4"],
  ["⑤", "5"],
  ["⑥", "6"],
  ["⑦", "7"],
  ["⑧", "8"],
  ["⑨", "9"],
  ["⑩", "10"],
  ["⑪", "11"],
  ["⑫", "12"],
  ["⑬", "13"],
  ["⑭", "14"],
  ["⑮", "15"],
  ["⑯", "16"],
  ["⑰", "17"],
  ["⑱", "18"],
  ["⑲", "19"],
  ["⑳", "20"],
  ["⑴", "1"],
  ["⑵", "2"],
  ["⑶", "3"],
  ["⑷", "4"],
  ["⑸", "5"],
  ["⑹", "6"],
  ["⑺", "7"],
  ["⑻", "8"],
  ["⑼", "9"],
  ["⑽", "10"],
  ["⑾", "11"],
  ["⑿", "12"],
  ["⒀", "13"],
  ["⒁", "14"],
  ["⒂", "15"],
  ["⒃", "16"],
  ["⒄", "17"],
  ["⒅", "18"],
  ["⒆", "19"],
  ["⒇", "20"],
  ["⒈", "1."],
  ["⒉", "2."],
  ["⒊", "3."],
  ["⒋", "4."],
  ["⒌", "5."],
  ["⒍", "6."],
  ["⒎", "7."],
  ["⒏", "8."],
  ["⒐", "9."],
  ["⒑", "10."],
  ["⒒", "11."],
  ["⒓", "12."],
  ["⒔", "13."],
  ["⒕", "14."],
  ["⒖", "15."],
  ["⒗", "16."],
  ["⒘", "17."],
  ["⒙", "18."],
  ["⒚", "19."],
  ["⒛", "20."],
  ["⓪", "0"],
  ["⓫", "11"],
  ["⓬", "12"],
  ["⓭", "13"],
  ["⓮", "14"],
  ["⓯", "15"],
  ["⓰", "16"],
  ["⓱", "17"],
  ["⓲", "18"],
  ["⓳", "19"],
  ["⓴", "20"],
  ["⓵", "1"],
  ["⓶", "2"],
  ["⓷", "3"],
  ["⓸", "4"],
  ["⓹", "5"],
  ["⓺", "6"],
  ["⓻", "7"],
  ["⓼", "8"],
  ["⓽", "9"],
  ["⓾", "10"],
  ["⓿", "0"],
  // Punctuation
  ["🙰", "&"],
  ["🙱", "&"],
  ["🙲", "&"],
  ["🙳", "&"],
  ["🙴", "&"],
  ["🙵", "&"],
  ["🙶", '"'],
  ["🙷", '"'],
  ["🙸", '"'],
  ["‽", "?!"],
  ["🙹", "?!"],
  ["🙺", "?!"],
  ["🙻", "?!"],
  ["🙼", "/"],
  ["🙽", "\\"],
  // Alchemy
  ["🜇", "AR"],
  ["🜈", "V"],
  ["🜉", "V"],
  ["🜆", "VR"],
  ["🜅", "VF"],
  ["🜩", "2"],
  ["🜪", "5"],
  ["🝡", "f"],
  ["🝢", "W"],
  ["🝣", "U"],
  ["🝧", "V"],
  ["🝨", "T"],
  ["🝪", "V"],
  ["🝫", "MB"],
  ["🝬", "VB"],
  ["🝲", "3B"],
  ["🝳", "3B"],
  // Emojis
  ["💯", "100"],
  ["🔙", "BACK"],
  ["🔚", "END"],
  ["🔛", "ON!"],
  ["🔜", "SOON"],
  ["🔝", "TOP"],
  ["🔞", "18"],
  ["🔤", "abc"],
  ["🔠", "ABCD"],
  ["🔡", "abcd"],
  ["🔢", "1234"],
  ["🔣", "T&@%"],
  ["#️⃣", "#"],
  ["*️⃣", "*"],
  ["0️⃣", "0"],
  ["1️⃣", "1"],
  ["2️⃣", "2"],
  ["3️⃣", "3"],
  ["4️⃣", "4"],
  ["5️⃣", "5"],
  ["6️⃣", "6"],
  ["7️⃣", "7"],
  ["8️⃣", "8"],
  ["9️⃣", "9"],
  ["🔟", "10"],
  ["🅰️", "A"],
  ["🅱️", "B"],
  ["🆎", "AB"],
  ["🆑", "CL"],
  ["🅾️", "O"],
  ["🅿", "P"],
  ["🆘", "SOS"],
  ["🅲", "C"],
  ["🅳", "D"],
  ["🅴", "E"],
  ["🅵", "F"],
  ["🅶", "G"],
  ["🅷", "H"],
  ["🅸", "I"],
  ["🅹", "J"],
  ["🅺", "K"],
  ["🅻", "L"],
  ["🅼", "M"],
  ["🅽", "N"],
  ["🆀", "Q"],
  ["🆁", "R"],
  ["🆂", "S"],
  ["🆃", "T"],
  ["🆄", "U"],
  ["🆅", "V"],
  ["🆆", "W"],
  ["🆇", "X"],
  ["🆈", "Y"],
  ["🆉", "Z"],
  // Dashes not covered by Dash_Punctuation category
  ["−", "-"],
  // U+2212 Minus Sign (Mathematical Operators category)
  ["⁓", "-"]
  // U+2053 Swung Dash (Other_Punctuation category)
], builtinReplacements = new Map(replacements), danishNorwegianReplacements = [
  ["æ", "ae"],
  ["Æ", "Ae"],
  ["ø", "oe"],
  ["Ø", "Oe"],
  ["å", "aa"],
  ["Å", "Aa"]
], localeReplacements = {
  // Swedish
  sv: [
    ["ä", "a"],
    ["Ä", "A"],
    ["ö", "o"],
    ["Ö", "O"],
    ["å", "a"],
    ["Å", "A"]
  ],
  // Danish
  da: danishNorwegianReplacements,
  // Norwegian Bokmål
  nb: danishNorwegianReplacements,
  // German
  de: [
    ["ä", "ae"],
    ["Ä", "Ae"],
    ["ö", "oe"],
    ["Ö", "Oe"],
    ["ü", "ue"],
    ["Ü", "Ue"],
    ["ß", "ss"],
    ["ẞ", "Ss"]
  ],
  // Turkish
  tr: [
    ["â", "a"],
    ["Â", "A"],
    ["ö", "o"],
    ["Ö", "O"],
    ["ü", "u"],
    ["Ü", "U"]
  ],
  // Hungarian
  hu: [
    ["ű", "u"],
    ["Ű", "U"],
    ["ö", "o"],
    ["Ö", "O"],
    ["ü", "u"],
    ["Ü", "U"],
    ["á", "a"],
    ["Á", "A"],
    ["é", "e"],
    ["É", "E"],
    ["í", "i"],
    ["Í", "I"],
    ["ó", "o"],
    ["Ó", "O"],
    ["ú", "u"],
    ["Ú", "U"]
  ],
  // Serbian
  sr: [
    ["ђ", "dj"],
    ["Ђ", "Dj"],
    ["џ", "dz"],
    ["Џ", "Dz"],
    ["љ", "lj"],
    ["Љ", "Lj"],
    ["њ", "nj"],
    ["Њ", "Nj"],
    ["ћ", "c"],
    ["Ћ", "C"],
    ["ч", "ch"],
    ["Ч", "Ch"],
    ["ш", "sh"],
    ["Ш", "Sh"],
    ["ж", "zh"],
    ["Ж", "Zh"]
  ]
};
for (const o of Object.keys(localeReplacements))
  localeReplacements[o] = new Map(localeReplacements[o]);
const doCustomReplacements = (o, E) => {
  for (const [A, g] of E)
    o = o.replaceAll(A, g);
  return o;
}, getLocaleReplacements = (o) => {
  if (!o)
    return;
  const E = o.toLowerCase().replace(/^no(-|$)/, "nb$1");
  return localeReplacements[E] || localeReplacements[E.split("-")[0]] || void 0;
};
function transliterate(o, E) {
  if (typeof o != "string")
    throw new TypeError(`Expected a string, got \`${typeof o}\``);
  E = {
    customReplacements: [],
    ...E
  };
  const A = getLocaleReplacements(E.locale);
  let g = builtinReplacements;
  const e = E.customReplacements.length > 0 || E.customReplacements.size > 0;
  if (A || e) {
    if (g = new Map(builtinReplacements), A)
      for (const [t, c] of A)
        g.set(t, c);
    for (const [t, c] of E.customReplacements)
      g.set(t, c);
  }
  return o = o.normalize(), o = doCustomReplacements(o, g), o = o.normalize("NFD").replaceAll(new RegExp("\\p{Diacritic}", "gu"), "").normalize(), o = o.replaceAll(new RegExp("\\p{Dash_Punctuation}", "gu"), "-"), o;
}
const overridableReplacements = [
  ["&", " and "],
  ["🦄", " unicorn "],
  ["♥", " love "]
], decamelize = (o) => o.replaceAll(/([A-Z]{2,})(\d+)/g, "$1 $2").replaceAll(/([a-z\d]+)([A-Z]{2,})/g, "$1 $2").replaceAll(/([a-z\d])([A-Z])/g, "$1 $2").replaceAll(/([A-Z]+)([A-Z][a-rt-z\d]+)/g, "$1 $2"), removeMootSeparators = (o, E) => {
  const A = escapeStringRegexp$1(E);
  return o.replaceAll(new RegExp(`(?:${A}){2,}`, "g"), E).replaceAll(new RegExp(`^(?:${A})|(?:${A})$`, "g"), "");
}, buildPatternSlug = (o) => {
  let E = String.raw`a-z\d`;
  if (E += o.lowercase ? "" : "A-Z", o.transliterate === !1 && (E += String.raw`\p{L}\p{N}`), o.preserveCharacters.length > 0)
    for (const g of o.preserveCharacters) {
      if (g === o.separator)
        throw new Error(`The separator character \`${o.separator}\` cannot be included in preserved characters: ${o.preserveCharacters}`);
      E += escapeStringRegexp$1(g);
    }
  const A = o.transliterate ? "g" : "gu";
  return new RegExp(`[^${E}]+`, A);
};
function slugify(o, E) {
  if (typeof o != "string")
    throw new TypeError(`Expected a string, got \`${typeof o}\``);
  E = {
    separator: "-",
    lowercase: !0,
    decamelize: !0,
    customReplacements: [],
    preserveLeadingUnderscore: !1,
    preserveTrailingDash: !1,
    preserveCharacters: [],
    transliterate: !0,
    ...E
  };
  const A = E.preserveLeadingUnderscore && o.startsWith("_"), g = E.preserveTrailingDash && o.endsWith("-");
  if (E.transliterate) {
    const t = new Map([
      ...overridableReplacements,
      ...E.customReplacements
    ]);
    o = transliterate(o, { customReplacements: t, locale: E.locale });
  } else if (E.customReplacements.length > 0)
    for (const [t, c] of E.customReplacements)
      o = o.replaceAll(t, c);
  E.decamelize && (o = decamelize(o));
  const e = buildPatternSlug(E);
  return E.lowercase && (o = E.locale ? o.toLocaleLowerCase(E.locale) : o.toLowerCase()), o = o.replaceAll(/([a-zA-Z\d]+)['\u2019]([ts])(\s|$)/g, "$1$2$3"), o = o.replace(e, E.separator), o = o.replaceAll("\\", ""), E.separator && (o = removeMootSeparators(o, E.separator)), A && (o = `_${o}`), g && (o = `${o}-`), o;
}
function escapeStringRegexp(o) {
  if (typeof o != "string")
    throw new TypeError("Expected a string");
  return o.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
}
const convert = (
  // Note: overloads in JSDoc can’t yet use different `@template`s.
  /**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */
  /**
   * @param {Test} [test]
   * @returns {Check}
   */
  (function(o) {
    if (o == null)
      return ok$1;
    if (typeof o == "function")
      return castFactory(o);
    if (typeof o == "object")
      return Array.isArray(o) ? anyFactory(o) : (
        // Cast because `ReadonlyArray` goes into the above but `isArray`
        // narrows to `Array`.
        propertiesFactory(
          /** @type {Props} */
          o
        )
      );
    if (typeof o == "string")
      return typeFactory(o);
    throw new Error("Expected function, string, or object as test");
  })
);
function anyFactory(o) {
  const E = [];
  let A = -1;
  for (; ++A < o.length; )
    E[A] = convert(o[A]);
  return castFactory(g);
  function g(...e) {
    let t = -1;
    for (; ++t < E.length; )
      if (E[t].apply(this, e)) return !0;
    return !1;
  }
}
function propertiesFactory(o) {
  const E = (
    /** @type {Record<string, unknown>} */
    o
  );
  return castFactory(A);
  function A(g) {
    const e = (
      /** @type {Record<string, unknown>} */
      /** @type {unknown} */
      g
    );
    let t;
    for (t in o)
      if (e[t] !== E[t]) return !1;
    return !0;
  }
}
function typeFactory(o) {
  return castFactory(E);
  function E(A) {
    return A && A.type === o;
  }
}
function castFactory(o) {
  return E;
  function E(A, g, e) {
    return !!(looksLikeANode(A) && o.call(
      this,
      A,
      typeof g == "number" ? g : void 0,
      e || void 0
    ));
  }
}
function ok$1() {
  return !0;
}
function looksLikeANode(o) {
  return o !== null && typeof o == "object" && "type" in o;
}
function color(o) {
  return o;
}
const empty$2 = [], CONTINUE = !0, EXIT = !1, SKIP = "skip";
function visitParents(o, E, A, g) {
  let e;
  typeof E == "function" && typeof A != "function" ? (g = A, A = E) : e = E;
  const t = convert(e), c = g ? -1 : 1;
  n(o, void 0, [])();
  function n(h, d, k) {
    const p = (
      /** @type {Record<string, unknown>} */
      h && typeof h == "object" ? h : {}
    );
    if (typeof p.type == "string") {
      const S = (
        // `hast`
        typeof p.tagName == "string" ? p.tagName : (
          // `xast`
          typeof p.name == "string" ? p.name : void 0
        )
      );
      Object.defineProperty(M, "name", {
        value: "node (" + (h.type + (S ? "<" + S + ">" : "")) + ")"
      });
    }
    return M;
    function M() {
      let S = empty$2, AA, H, gA;
      if ((!E || t(h, d, k[k.length - 1] || void 0)) && (S = toResult(A(h, k)), S[0] === EXIT))
        return S;
      if ("children" in h && h.children) {
        const CA = (
          /** @type {UnistParent} */
          h
        );
        if (CA.children && S[0] !== SKIP)
          for (H = (g ? CA.children.length : -1) + c, gA = k.concat(CA); H > -1 && H < CA.children.length; ) {
            const IA = CA.children[H];
            if (AA = n(IA, H, gA)(), AA[0] === EXIT)
              return AA;
            H = typeof AA[1] == "number" ? AA[1] : H + c;
          }
      }
      return S;
    }
  }
}
function toResult(o) {
  return Array.isArray(o) ? o : typeof o == "number" ? [CONTINUE, o] : o == null ? empty$2 : [o];
}
function findAndReplace(o, E, A) {
  const e = convert((A || {}).ignore || []), t = toPairs(E);
  let c = -1;
  for (; ++c < t.length; )
    visitParents(o, "text", n);
  function n(d, k) {
    let p = -1, M;
    for (; ++p < k.length; ) {
      const S = k[p], AA = M ? M.children : void 0;
      if (e(
        S,
        AA ? AA.indexOf(S) : void 0,
        M
      ))
        return;
      M = S;
    }
    if (M)
      return h(d, k);
  }
  function h(d, k) {
    const p = k[k.length - 1], M = t[c][0], S = t[c][1];
    let AA = 0;
    const gA = p.children.indexOf(d);
    let CA = !1, IA = [];
    M.lastIndex = 0;
    let BA = M.exec(d.value);
    for (; BA; ) {
      const QA = BA.index, EA = {
        index: BA.index,
        input: BA.input,
        stack: [...k, d]
      };
      let oA = S(...BA, EA);
      if (typeof oA == "string" && (oA = oA.length > 0 ? { type: "text", value: oA } : void 0), oA === !1 ? M.lastIndex = QA + 1 : (AA !== QA && IA.push({
        type: "text",
        value: d.value.slice(AA, QA)
      }), Array.isArray(oA) ? IA.push(...oA) : oA && IA.push(oA), AA = QA + BA[0].length, CA = !0), !M.global)
        break;
      BA = M.exec(d.value);
    }
    return CA ? (AA < d.value.length && IA.push({ type: "text", value: d.value.slice(AA) }), p.children.splice(gA, 1, ...IA)) : IA = [d], gA + IA.length;
  }
}
function toPairs(o) {
  const E = [];
  if (!Array.isArray(o))
    throw new TypeError("Expected find and replace tuple or list of tuples");
  const A = !o[0] || Array.isArray(o[0]) ? o : [o];
  let g = -1;
  for (; ++g < A.length; ) {
    const e = A[g];
    E.push([toExpression(e[0]), toFunction(e[1])]);
  }
  return E;
}
function toExpression(o) {
  return typeof o == "string" ? new RegExp(escapeStringRegexp(o), "g") : o;
}
function toFunction(o) {
  return typeof o == "function" ? o : function() {
    return o;
  };
}
function _extends$u() {
  return _extends$u = Object.assign || function(o) {
    for (var E = 1; E < arguments.length; E++) {
      var A = arguments[E];
      for (var g in A)
        Object.prototype.hasOwnProperty.call(A, g) && (o[g] = A[g]);
    }
    return o;
  }, _extends$u.apply(this, arguments);
}
function _objectWithoutProperties$q(o, E) {
  if (o == null) return {};
  var A = _objectWithoutPropertiesLoose$p(o, E), g, e;
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    for (e = 0; e < t.length; e++)
      g = t[e], !(E.indexOf(g) >= 0) && Object.prototype.propertyIsEnumerable.call(o, g) && (A[g] = o[g]);
  }
  return A;
}
function _objectWithoutPropertiesLoose$p(o, E) {
  if (o == null) return {};
  var A = {}, g = Object.keys(o), e, t;
  for (t = 0; t < g.length; t++)
    e = g[t], !(E.indexOf(e) >= 0) && (A[e] = o[e]);
  return A;
}
var Check = forwardRef(function(o, E) {
  var A = o.color, g = A === void 0 ? "currentColor" : A, e = o.size, t = e === void 0 ? 24 : e, c = _objectWithoutProperties$q(o, ["color", "size"]);
  return /* @__PURE__ */ React__default.createElement("svg", _extends$u({
    ref: E,
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: t,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: g,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, c), /* @__PURE__ */ React__default.createElement("polyline", {
    points: "20 6 9 17 4 12"
  }));
});
Check.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Check.displayName = "Check";
function _extends$t() {
  return _extends$t = Object.assign || function(o) {
    for (var E = 1; E < arguments.length; E++) {
      var A = arguments[E];
      for (var g in A)
        Object.prototype.hasOwnProperty.call(A, g) && (o[g] = A[g]);
    }
    return o;
  }, _extends$t.apply(this, arguments);
}
function _objectWithoutProperties$p(o, E) {
  if (o == null) return {};
  var A = _objectWithoutPropertiesLoose$o(o, E), g, e;
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    for (e = 0; e < t.length; e++)
      g = t[e], !(E.indexOf(g) >= 0) && Object.prototype.propertyIsEnumerable.call(o, g) && (A[g] = o[g]);
  }
  return A;
}
function _objectWithoutPropertiesLoose$o(o, E) {
  if (o == null) return {};
  var A = {}, g = Object.keys(o), e, t;
  for (t = 0; t < g.length; t++)
    e = g[t], !(E.indexOf(e) >= 0) && (A[e] = o[e]);
  return A;
}
var Copy = forwardRef(function(o, E) {
  var A = o.color, g = A === void 0 ? "currentColor" : A, e = o.size, t = e === void 0 ? 24 : e, c = _objectWithoutProperties$p(o, ["color", "size"]);
  return /* @__PURE__ */ React__default.createElement("svg", _extends$t({
    ref: E,
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: t,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: g,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, c), /* @__PURE__ */ React__default.createElement("rect", {
    x: "9",
    y: "9",
    width: "13",
    height: "13",
    rx: "2",
    ry: "2"
  }), /* @__PURE__ */ React__default.createElement("path", {
    d: "M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"
  }));
});
Copy.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Copy.displayName = "Copy";
function _extends$s() {
  return _extends$s = Object.assign || function(o) {
    for (var E = 1; E < arguments.length; E++) {
      var A = arguments[E];
      for (var g in A)
        Object.prototype.hasOwnProperty.call(A, g) && (o[g] = A[g]);
    }
    return o;
  }, _extends$s.apply(this, arguments);
}
function _objectWithoutProperties$o(o, E) {
  if (o == null) return {};
  var A = _objectWithoutPropertiesLoose$n(o, E), g, e;
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    for (e = 0; e < t.length; e++)
      g = t[e], !(E.indexOf(g) >= 0) && Object.prototype.propertyIsEnumerable.call(o, g) && (A[g] = o[g]);
  }
  return A;
}
function _objectWithoutPropertiesLoose$n(o, E) {
  if (o == null) return {};
  var A = {}, g = Object.keys(o), e, t;
  for (t = 0; t < g.length; t++)
    e = g[t], !(E.indexOf(e) >= 0) && (A[e] = o[e]);
  return A;
}
var HelpCircle = forwardRef(function(o, E) {
  var A = o.color, g = A === void 0 ? "currentColor" : A, e = o.size, t = e === void 0 ? 24 : e, c = _objectWithoutProperties$o(o, ["color", "size"]);
  return /* @__PURE__ */ React__default.createElement("svg", _extends$s({
    ref: E,
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: t,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: g,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, c), /* @__PURE__ */ React__default.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }), /* @__PURE__ */ React__default.createElement("path", {
    d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"
  }), /* @__PURE__ */ React__default.createElement("line", {
    x1: "12",
    y1: "17",
    x2: "12.01",
    y2: "17"
  }));
});
HelpCircle.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
HelpCircle.displayName = "HelpCircle";
function _extends$r() {
  return _extends$r = Object.assign || function(o) {
    for (var E = 1; E < arguments.length; E++) {
      var A = arguments[E];
      for (var g in A)
        Object.prototype.hasOwnProperty.call(A, g) && (o[g] = A[g]);
    }
    return o;
  }, _extends$r.apply(this, arguments);
}
function _objectWithoutProperties$n(o, E) {
  if (o == null) return {};
  var A = _objectWithoutPropertiesLoose$m(o, E), g, e;
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    for (e = 0; e < t.length; e++)
      g = t[e], !(E.indexOf(g) >= 0) && Object.prototype.propertyIsEnumerable.call(o, g) && (A[g] = o[g]);
  }
  return A;
}
function _objectWithoutPropertiesLoose$m(o, E) {
  if (o == null) return {};
  var A = {}, g = Object.keys(o), e, t;
  for (t = 0; t < g.length; t++)
    e = g[t], !(E.indexOf(e) >= 0) && (A[e] = o[e]);
  return A;
}
var Link2 = forwardRef(function(o, E) {
  var A = o.color, g = A === void 0 ? "currentColor" : A, e = o.size, t = e === void 0 ? 24 : e, c = _objectWithoutProperties$n(o, ["color", "size"]);
  return /* @__PURE__ */ React__default.createElement("svg", _extends$r({
    ref: E,
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: t,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: g,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, c), /* @__PURE__ */ React__default.createElement("path", {
    d: "M15 7h3a5 5 0 0 1 5 5 5 5 0 0 1-5 5h-3m-6 0H6a5 5 0 0 1-5-5 5 5 0 0 1 5-5h3"
  }), /* @__PURE__ */ React__default.createElement("line", {
    x1: "8",
    y1: "12",
    x2: "16",
    y2: "12"
  }));
});
Link2.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Link2.displayName = "Link2";
function ok() {
}
function unreachable() {
}
function parse$2(o) {
  const E = [], A = String(o || "");
  let g = A.indexOf(","), e = 0, t = !1;
  for (; !t; ) {
    g === -1 && (g = A.length, t = !0);
    const c = A.slice(e, g).trim();
    (c || !t) && E.push(c), e = g + 1, g = A.indexOf(",", e);
  }
  return E;
}
function stringify$1(o, E) {
  const A = {};
  return (o[o.length - 1] === "" ? [...o, ""] : o).join(
    (A.padRight ? " " : "") + "," + (A.padLeft === !1 ? "" : " ")
  ).trim();
}
const nameRe = /^[$_\p{ID_Start}][$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, nameReJsx = /^[$_\p{ID_Start}][-$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, emptyOptions$5 = {};
function name(o, E) {
  return (emptyOptions$5.jsx ? nameReJsx : nameRe).test(o);
}
const re = /[ \t\n\f\r]/g;
function whitespace(o) {
  return typeof o == "object" ? o.type === "text" ? empty$1(o.value) : !1 : empty$1(o);
}
function empty$1(o) {
  return o.replace(re, "") === "";
}
class Schema {
  /**
   * @param {SchemaType['property']} property
   *   Property.
   * @param {SchemaType['normal']} normal
   *   Normal.
   * @param {Space | undefined} [space]
   *   Space.
   * @returns
   *   Schema.
   */
  constructor(E, A, g) {
    this.normal = A, this.property = E, g && (this.space = g);
  }
}
Schema.prototype.normal = {};
Schema.prototype.property = {};
Schema.prototype.space = void 0;
function merge(o, E) {
  const A = {}, g = {};
  for (const e of o)
    Object.assign(A, e.property), Object.assign(g, e.normal);
  return new Schema(A, g, E);
}
function normalize$1(o) {
  return o.toLowerCase();
}
class Info {
  /**
   * @param {string} property
   *   Property.
   * @param {string} attribute
   *   Attribute.
   * @returns
   *   Info.
   */
  constructor(E, A) {
    this.attribute = A, this.property = E;
  }
}
Info.prototype.attribute = "";
Info.prototype.booleanish = !1;
Info.prototype.boolean = !1;
Info.prototype.commaOrSpaceSeparated = !1;
Info.prototype.commaSeparated = !1;
Info.prototype.defined = !1;
Info.prototype.mustUseProperty = !1;
Info.prototype.number = !1;
Info.prototype.overloadedBoolean = !1;
Info.prototype.property = "";
Info.prototype.spaceSeparated = !1;
Info.prototype.space = void 0;
let powers = 0;
const boolean = increment(), booleanish = increment(), overloadedBoolean = increment(), number = increment(), spaceSeparated = increment(), commaSeparated = increment(), commaOrSpaceSeparated = increment();
function increment() {
  return 2 ** ++powers;
}
const types$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  boolean,
  booleanish,
  commaOrSpaceSeparated,
  commaSeparated,
  number,
  overloadedBoolean,
  spaceSeparated
}, Symbol.toStringTag, { value: "Module" })), checks = (
  /** @type {ReadonlyArray<keyof typeof types>} */
  Object.keys(types$1)
);
class DefinedInfo extends Info {
  /**
   * @constructor
   * @param {string} property
   *   Property.
   * @param {string} attribute
   *   Attribute.
   * @param {number | null | undefined} [mask]
   *   Mask.
   * @param {Space | undefined} [space]
   *   Space.
   * @returns
   *   Info.
   */
  constructor(E, A, g, e) {
    let t = -1;
    if (super(E, A), mark$1(this, "space", e), typeof g == "number")
      for (; ++t < checks.length; ) {
        const c = checks[t];
        mark$1(this, checks[t], (g & types$1[c]) === types$1[c]);
      }
  }
}
DefinedInfo.prototype.defined = !0;
function mark$1(o, E, A) {
  A && (o[E] = A);
}
function create(o) {
  const E = {}, A = {};
  for (const [g, e] of Object.entries(o.properties)) {
    const t = new DefinedInfo(
      g,
      o.transform(o.attributes || {}, g),
      e,
      o.space
    );
    o.mustUseProperty && o.mustUseProperty.includes(g) && (t.mustUseProperty = !0), E[g] = t, A[normalize$1(g)] = g, A[normalize$1(t.attribute)] = g;
  }
  return new Schema(E, A, o.space);
}
const aria = create({
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: booleanish,
    ariaAutoComplete: null,
    ariaBusy: booleanish,
    ariaChecked: booleanish,
    ariaColCount: number,
    ariaColIndex: number,
    ariaColSpan: number,
    ariaControls: spaceSeparated,
    ariaCurrent: null,
    ariaDescribedBy: spaceSeparated,
    ariaDetails: null,
    ariaDisabled: booleanish,
    ariaDropEffect: spaceSeparated,
    ariaErrorMessage: null,
    ariaExpanded: booleanish,
    ariaFlowTo: spaceSeparated,
    ariaGrabbed: booleanish,
    ariaHasPopup: null,
    ariaHidden: booleanish,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: spaceSeparated,
    ariaLevel: number,
    ariaLive: null,
    ariaModal: booleanish,
    ariaMultiLine: booleanish,
    ariaMultiSelectable: booleanish,
    ariaOrientation: null,
    ariaOwns: spaceSeparated,
    ariaPlaceholder: null,
    ariaPosInSet: number,
    ariaPressed: booleanish,
    ariaReadOnly: booleanish,
    ariaRelevant: null,
    ariaRequired: booleanish,
    ariaRoleDescription: spaceSeparated,
    ariaRowCount: number,
    ariaRowIndex: number,
    ariaRowSpan: number,
    ariaSelected: booleanish,
    ariaSetSize: number,
    ariaSort: null,
    ariaValueMax: number,
    ariaValueMin: number,
    ariaValueNow: number,
    ariaValueText: null,
    role: null
  },
  transform(o, E) {
    return E === "role" ? E : "aria-" + E.slice(4).toLowerCase();
  }
});
function caseSensitiveTransform(o, E) {
  return E in o ? o[E] : E;
}
function caseInsensitiveTransform(o, E) {
  return caseSensitiveTransform(o, E.toLowerCase());
}
const html$3 = create({
  attributes: {
    acceptcharset: "accept-charset",
    classname: "class",
    htmlfor: "for",
    httpequiv: "http-equiv"
  },
  mustUseProperty: ["checked", "multiple", "muted", "selected"],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: commaSeparated,
    acceptCharset: spaceSeparated,
    accessKey: spaceSeparated,
    action: null,
    allow: null,
    allowFullScreen: boolean,
    allowPaymentRequest: boolean,
    allowUserMedia: boolean,
    alt: null,
    as: null,
    async: boolean,
    autoCapitalize: null,
    autoComplete: spaceSeparated,
    autoFocus: boolean,
    autoPlay: boolean,
    blocking: spaceSeparated,
    capture: null,
    charSet: null,
    checked: boolean,
    cite: null,
    className: spaceSeparated,
    cols: number,
    colSpan: null,
    content: null,
    contentEditable: booleanish,
    controls: boolean,
    controlsList: spaceSeparated,
    coords: number | commaSeparated,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: boolean,
    defer: boolean,
    dir: null,
    dirName: null,
    disabled: boolean,
    download: overloadedBoolean,
    draggable: booleanish,
    encType: null,
    enterKeyHint: null,
    fetchPriority: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: boolean,
    formTarget: null,
    headers: spaceSeparated,
    height: number,
    hidden: overloadedBoolean,
    high: number,
    href: null,
    hrefLang: null,
    htmlFor: spaceSeparated,
    httpEquiv: spaceSeparated,
    id: null,
    imageSizes: null,
    imageSrcSet: null,
    inert: boolean,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: boolean,
    itemId: null,
    itemProp: spaceSeparated,
    itemRef: spaceSeparated,
    itemScope: boolean,
    itemType: spaceSeparated,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: boolean,
    low: number,
    manifest: null,
    max: null,
    maxLength: number,
    media: null,
    method: null,
    min: null,
    minLength: number,
    multiple: boolean,
    muted: boolean,
    name: null,
    nonce: null,
    noModule: boolean,
    noValidate: boolean,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforeMatch: null,
    onBeforePrint: null,
    onBeforeToggle: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextLost: null,
    onContextMenu: null,
    onContextRestored: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onScrollEnd: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: boolean,
    optimum: number,
    pattern: null,
    ping: spaceSeparated,
    placeholder: null,
    playsInline: boolean,
    popover: null,
    popoverTarget: null,
    popoverTargetAction: null,
    poster: null,
    preload: null,
    readOnly: boolean,
    referrerPolicy: null,
    rel: spaceSeparated,
    required: boolean,
    reversed: boolean,
    rows: number,
    rowSpan: number,
    sandbox: spaceSeparated,
    scope: null,
    scoped: boolean,
    seamless: boolean,
    selected: boolean,
    shadowRootClonable: boolean,
    shadowRootDelegatesFocus: boolean,
    shadowRootMode: null,
    shape: null,
    size: number,
    sizes: null,
    slot: null,
    span: number,
    spellCheck: booleanish,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: null,
    start: number,
    step: null,
    style: null,
    tabIndex: number,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: boolean,
    useMap: null,
    value: booleanish,
    width: number,
    wrap: null,
    writingSuggestions: null,
    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null,
    // Several. Use CSS `text-align` instead,
    aLink: null,
    // `<body>`. Use CSS `a:active {color}` instead
    archive: spaceSeparated,
    // `<object>`. List of URIs to archives
    axis: null,
    // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null,
    // `<body>`. Use CSS `background-image` instead
    bgColor: null,
    // `<body>` and table elements. Use CSS `background-color` instead
    border: number,
    // `<table>`. Use CSS `border-width` instead,
    borderColor: null,
    // `<table>`. Use CSS `border-color` instead,
    bottomMargin: number,
    // `<body>`
    cellPadding: null,
    // `<table>`
    cellSpacing: null,
    // `<table>`
    char: null,
    // Several table elements. When `align=char`, sets the character to align on
    charOff: null,
    // Several table elements. When `char`, offsets the alignment
    classId: null,
    // `<object>`
    clear: null,
    // `<br>`. Use CSS `clear` instead
    code: null,
    // `<object>`
    codeBase: null,
    // `<object>`
    codeType: null,
    // `<object>`
    color: null,
    // `<font>` and `<hr>`. Use CSS instead
    compact: boolean,
    // Lists. Use CSS to reduce space between items instead
    declare: boolean,
    // `<object>`
    event: null,
    // `<script>`
    face: null,
    // `<font>`. Use CSS instead
    frame: null,
    // `<table>`
    frameBorder: null,
    // `<iframe>`. Use CSS `border` instead
    hSpace: number,
    // `<img>` and `<object>`
    leftMargin: number,
    // `<body>`
    link: null,
    // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null,
    // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null,
    // `<img>`. Use a `<picture>`
    marginHeight: number,
    // `<body>`
    marginWidth: number,
    // `<body>`
    noResize: boolean,
    // `<frame>`
    noHref: boolean,
    // `<area>`. Use no href instead of an explicit `nohref`
    noShade: boolean,
    // `<hr>`. Use background-color and height instead of borders
    noWrap: boolean,
    // `<td>` and `<th>`
    object: null,
    // `<applet>`
    profile: null,
    // `<head>`
    prompt: null,
    // `<isindex>`
    rev: null,
    // `<link>`
    rightMargin: number,
    // `<body>`
    rules: null,
    // `<table>`
    scheme: null,
    // `<meta>`
    scrolling: booleanish,
    // `<frame>`. Use overflow in the child context
    standby: null,
    // `<object>`
    summary: null,
    // `<table>`
    text: null,
    // `<body>`. Use CSS `color` instead
    topMargin: number,
    // `<body>`
    valueType: null,
    // `<param>`
    version: null,
    // `<html>`. Use a doctype.
    vAlign: null,
    // Several. Use CSS `vertical-align` instead
    vLink: null,
    // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: number,
    // `<img>` and `<object>`
    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: boolean,
    disableRemotePlayback: boolean,
    prefix: null,
    property: null,
    results: number,
    security: null,
    unselectable: null
  },
  space: "html",
  transform: caseInsensitiveTransform
}), svg$1 = create({
  attributes: {
    accentHeight: "accent-height",
    alignmentBaseline: "alignment-baseline",
    arabicForm: "arabic-form",
    baselineShift: "baseline-shift",
    capHeight: "cap-height",
    className: "class",
    clipPath: "clip-path",
    clipRule: "clip-rule",
    colorInterpolation: "color-interpolation",
    colorInterpolationFilters: "color-interpolation-filters",
    colorProfile: "color-profile",
    colorRendering: "color-rendering",
    crossOrigin: "crossorigin",
    dataType: "datatype",
    dominantBaseline: "dominant-baseline",
    enableBackground: "enable-background",
    fillOpacity: "fill-opacity",
    fillRule: "fill-rule",
    floodColor: "flood-color",
    floodOpacity: "flood-opacity",
    fontFamily: "font-family",
    fontSize: "font-size",
    fontSizeAdjust: "font-size-adjust",
    fontStretch: "font-stretch",
    fontStyle: "font-style",
    fontVariant: "font-variant",
    fontWeight: "font-weight",
    glyphName: "glyph-name",
    glyphOrientationHorizontal: "glyph-orientation-horizontal",
    glyphOrientationVertical: "glyph-orientation-vertical",
    hrefLang: "hreflang",
    horizAdvX: "horiz-adv-x",
    horizOriginX: "horiz-origin-x",
    horizOriginY: "horiz-origin-y",
    imageRendering: "image-rendering",
    letterSpacing: "letter-spacing",
    lightingColor: "lighting-color",
    markerEnd: "marker-end",
    markerMid: "marker-mid",
    markerStart: "marker-start",
    navDown: "nav-down",
    navDownLeft: "nav-down-left",
    navDownRight: "nav-down-right",
    navLeft: "nav-left",
    navNext: "nav-next",
    navPrev: "nav-prev",
    navRight: "nav-right",
    navUp: "nav-up",
    navUpLeft: "nav-up-left",
    navUpRight: "nav-up-right",
    onAbort: "onabort",
    onActivate: "onactivate",
    onAfterPrint: "onafterprint",
    onBeforePrint: "onbeforeprint",
    onBegin: "onbegin",
    onCancel: "oncancel",
    onCanPlay: "oncanplay",
    onCanPlayThrough: "oncanplaythrough",
    onChange: "onchange",
    onClick: "onclick",
    onClose: "onclose",
    onCopy: "oncopy",
    onCueChange: "oncuechange",
    onCut: "oncut",
    onDblClick: "ondblclick",
    onDrag: "ondrag",
    onDragEnd: "ondragend",
    onDragEnter: "ondragenter",
    onDragExit: "ondragexit",
    onDragLeave: "ondragleave",
    onDragOver: "ondragover",
    onDragStart: "ondragstart",
    onDrop: "ondrop",
    onDurationChange: "ondurationchange",
    onEmptied: "onemptied",
    onEnd: "onend",
    onEnded: "onended",
    onError: "onerror",
    onFocus: "onfocus",
    onFocusIn: "onfocusin",
    onFocusOut: "onfocusout",
    onHashChange: "onhashchange",
    onInput: "oninput",
    onInvalid: "oninvalid",
    onKeyDown: "onkeydown",
    onKeyPress: "onkeypress",
    onKeyUp: "onkeyup",
    onLoad: "onload",
    onLoadedData: "onloadeddata",
    onLoadedMetadata: "onloadedmetadata",
    onLoadStart: "onloadstart",
    onMessage: "onmessage",
    onMouseDown: "onmousedown",
    onMouseEnter: "onmouseenter",
    onMouseLeave: "onmouseleave",
    onMouseMove: "onmousemove",
    onMouseOut: "onmouseout",
    onMouseOver: "onmouseover",
    onMouseUp: "onmouseup",
    onMouseWheel: "onmousewheel",
    onOffline: "onoffline",
    onOnline: "ononline",
    onPageHide: "onpagehide",
    onPageShow: "onpageshow",
    onPaste: "onpaste",
    onPause: "onpause",
    onPlay: "onplay",
    onPlaying: "onplaying",
    onPopState: "onpopstate",
    onProgress: "onprogress",
    onRateChange: "onratechange",
    onRepeat: "onrepeat",
    onReset: "onreset",
    onResize: "onresize",
    onScroll: "onscroll",
    onSeeked: "onseeked",
    onSeeking: "onseeking",
    onSelect: "onselect",
    onShow: "onshow",
    onStalled: "onstalled",
    onStorage: "onstorage",
    onSubmit: "onsubmit",
    onSuspend: "onsuspend",
    onTimeUpdate: "ontimeupdate",
    onToggle: "ontoggle",
    onUnload: "onunload",
    onVolumeChange: "onvolumechange",
    onWaiting: "onwaiting",
    onZoom: "onzoom",
    overlinePosition: "overline-position",
    overlineThickness: "overline-thickness",
    paintOrder: "paint-order",
    panose1: "panose-1",
    pointerEvents: "pointer-events",
    referrerPolicy: "referrerpolicy",
    renderingIntent: "rendering-intent",
    shapeRendering: "shape-rendering",
    stopColor: "stop-color",
    stopOpacity: "stop-opacity",
    strikethroughPosition: "strikethrough-position",
    strikethroughThickness: "strikethrough-thickness",
    strokeDashArray: "stroke-dasharray",
    strokeDashOffset: "stroke-dashoffset",
    strokeLineCap: "stroke-linecap",
    strokeLineJoin: "stroke-linejoin",
    strokeMiterLimit: "stroke-miterlimit",
    strokeOpacity: "stroke-opacity",
    strokeWidth: "stroke-width",
    tabIndex: "tabindex",
    textAnchor: "text-anchor",
    textDecoration: "text-decoration",
    textRendering: "text-rendering",
    transformOrigin: "transform-origin",
    typeOf: "typeof",
    underlinePosition: "underline-position",
    underlineThickness: "underline-thickness",
    unicodeBidi: "unicode-bidi",
    unicodeRange: "unicode-range",
    unitsPerEm: "units-per-em",
    vAlphabetic: "v-alphabetic",
    vHanging: "v-hanging",
    vIdeographic: "v-ideographic",
    vMathematical: "v-mathematical",
    vectorEffect: "vector-effect",
    vertAdvY: "vert-adv-y",
    vertOriginX: "vert-origin-x",
    vertOriginY: "vert-origin-y",
    wordSpacing: "word-spacing",
    writingMode: "writing-mode",
    xHeight: "x-height",
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: "playbackorder",
    timelineBegin: "timelinebegin"
  },
  properties: {
    about: commaOrSpaceSeparated,
    accentHeight: number,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: number,
    amplitude: number,
    arabicForm: null,
    ascent: number,
    attributeName: null,
    attributeType: null,
    azimuth: number,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: number,
    by: null,
    calcMode: null,
    capHeight: number,
    className: spaceSeparated,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: number,
    diffuseConstant: number,
    direction: null,
    display: null,
    dur: null,
    divisor: number,
    dominantBaseline: null,
    download: boolean,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: number,
    enableBackground: null,
    end: null,
    event: null,
    exponent: number,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: number,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: commaSeparated,
    g2: commaSeparated,
    glyphName: commaSeparated,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: number,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: number,
    horizOriginX: number,
    horizOriginY: number,
    id: null,
    ideographic: number,
    imageRendering: null,
    initialVisibility: null,
    in: null,
    in2: null,
    intercept: number,
    k: number,
    k1: number,
    k2: number,
    k3: number,
    k4: number,
    kernelMatrix: commaOrSpaceSeparated,
    kernelUnitLength: null,
    keyPoints: null,
    // SEMI_COLON_SEPARATED
    keySplines: null,
    // SEMI_COLON_SEPARATED
    keyTimes: null,
    // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: number,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: number,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: number,
    overlineThickness: number,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: number,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: spaceSeparated,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: number,
    pointsAtY: number,
    pointsAtZ: number,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: commaOrSpaceSeparated,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: commaOrSpaceSeparated,
    rev: commaOrSpaceSeparated,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: commaOrSpaceSeparated,
    requiredFeatures: commaOrSpaceSeparated,
    requiredFonts: commaOrSpaceSeparated,
    requiredFormats: commaOrSpaceSeparated,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: number,
    specularExponent: number,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: number,
    strikethroughThickness: number,
    string: null,
    stroke: null,
    strokeDashArray: commaOrSpaceSeparated,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: number,
    strokeOpacity: number,
    strokeWidth: null,
    style: null,
    surfaceScale: number,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: commaOrSpaceSeparated,
    tabIndex: number,
    tableValues: null,
    target: null,
    targetX: number,
    targetY: number,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: commaOrSpaceSeparated,
    to: null,
    transform: null,
    transformOrigin: null,
    u1: null,
    u2: null,
    underlinePosition: number,
    underlineThickness: number,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: number,
    values: null,
    vAlphabetic: number,
    vMathematical: number,
    vectorEffect: null,
    vHanging: number,
    vIdeographic: number,
    version: null,
    vertAdvY: number,
    vertOriginX: number,
    vertOriginY: number,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: number,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  },
  space: "svg",
  transform: caseSensitiveTransform
}), xlink = create({
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  },
  space: "xlink",
  transform(o, E) {
    return "xlink:" + E.slice(5).toLowerCase();
  }
}), xmlns = create({
  attributes: { xmlnsxlink: "xmlns:xlink" },
  properties: { xmlnsXLink: null, xmlns: null },
  space: "xmlns",
  transform: caseInsensitiveTransform
}), xml = create({
  properties: { xmlBase: null, xmlLang: null, xmlSpace: null },
  space: "xml",
  transform(o, E) {
    return "xml:" + E.slice(3).toLowerCase();
  }
}), hastToReact = {
  classId: "classID",
  dataType: "datatype",
  itemId: "itemID",
  strokeDashArray: "strokeDasharray",
  strokeDashOffset: "strokeDashoffset",
  strokeLineCap: "strokeLinecap",
  strokeLineJoin: "strokeLinejoin",
  strokeMiterLimit: "strokeMiterlimit",
  typeOf: "typeof",
  xLinkActuate: "xlinkActuate",
  xLinkArcRole: "xlinkArcrole",
  xLinkHref: "xlinkHref",
  xLinkRole: "xlinkRole",
  xLinkShow: "xlinkShow",
  xLinkTitle: "xlinkTitle",
  xLinkType: "xlinkType",
  xmlnsXLink: "xmlnsXlink"
}, cap$1 = /[A-Z]/g, dash = /-[a-z]/g, valid = /^data[-\w.:]+$/i;
function find$1(o, E) {
  const A = normalize$1(E);
  let g = E, e = Info;
  if (A in o.normal)
    return o.property[o.normal[A]];
  if (A.length > 4 && A.slice(0, 4) === "data" && valid.test(E)) {
    if (E.charAt(4) === "-") {
      const t = E.slice(5).replace(dash, camelcase);
      g = "data" + t.charAt(0).toUpperCase() + t.slice(1);
    } else {
      const t = E.slice(4);
      if (!dash.test(t)) {
        let c = t.replace(cap$1, kebab);
        c.charAt(0) !== "-" && (c = "-" + c), E = "data" + c;
      }
    }
    e = DefinedInfo;
  }
  return new e(g, E);
}
function kebab(o) {
  return "-" + o.toLowerCase();
}
function camelcase(o) {
  return o.charAt(1).toUpperCase();
}
const html$2 = merge([aria, html$3, xlink, xmlns, xml], "html"), svg = merge([aria, svg$1, xlink, xmlns, xml], "svg");
function parse$1(o) {
  const E = String(o || "").trim();
  return E ? E.split(/[ \t\n\r\f]+/g) : [];
}
function stringify(o) {
  return o.join(" ").trim();
}
var cjs$2 = {}, cjs$1, hasRequiredCjs$2;
function requireCjs$2() {
  if (hasRequiredCjs$2) return cjs$1;
  hasRequiredCjs$2 = 1;
  var o = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g, E = /\n/g, A = /^\s*/, g = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/, e = /^:\s*/, t = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/, c = /^[;\s]*/, n = /^\s+|\s+$/g, h = `
`, d = "/", k = "*", p = "", M = "comment", S = "declaration";
  function AA(gA, CA) {
    if (typeof gA != "string")
      throw new TypeError("First argument must be a string");
    if (!gA) return [];
    CA = CA || {};
    var IA = 1, BA = 1;
    function QA(wA) {
      var lA = wA.match(E);
      lA && (IA += lA.length);
      var NA = wA.lastIndexOf(h);
      BA = ~NA ? wA.length - NA : BA + wA.length;
    }
    function EA() {
      var wA = { line: IA, column: BA };
      return function(lA) {
        return lA.position = new oA(wA), tA(), lA;
      };
    }
    function oA(wA) {
      this.start = wA, this.end = { line: IA, column: BA }, this.source = CA.source;
    }
    oA.prototype.content = gA;
    function iA(wA) {
      var lA = new Error(
        CA.source + ":" + IA + ":" + BA + ": " + wA
      );
      if (lA.reason = wA, lA.filename = CA.source, lA.line = IA, lA.column = BA, lA.source = gA, !CA.silent) throw lA;
    }
    function aA(wA) {
      var lA = wA.exec(gA);
      if (lA) {
        var NA = lA[0];
        return QA(NA), gA = gA.slice(NA.length), lA;
      }
    }
    function tA() {
      aA(A);
    }
    function eA(wA) {
      var lA;
      for (wA = wA || []; lA = cA(); )
        lA !== !1 && wA.push(lA);
      return wA;
    }
    function cA() {
      var wA = EA();
      if (!(d != gA.charAt(0) || k != gA.charAt(1))) {
        for (var lA = 2; p != gA.charAt(lA) && (k != gA.charAt(lA) || d != gA.charAt(lA + 1)); )
          ++lA;
        if (lA += 2, p === gA.charAt(lA - 1))
          return iA("End of comment missing");
        var NA = gA.slice(2, lA - 2);
        return BA += 2, QA(NA), gA = gA.slice(lA), BA += 2, wA({
          type: M,
          comment: NA
        });
      }
    }
    function DA() {
      var wA = EA(), lA = aA(g);
      if (lA) {
        if (cA(), !aA(e)) return iA("property missing ':'");
        var NA = aA(t), RA = wA({
          type: S,
          property: H(lA[0].replace(o, p)),
          value: NA ? H(NA[0].replace(o, p)) : p
        });
        return aA(c), RA;
      }
    }
    function nA() {
      var wA = [];
      eA(wA);
      for (var lA; lA = DA(); )
        lA !== !1 && (wA.push(lA), eA(wA));
      return wA;
    }
    return tA(), nA();
  }
  function H(gA) {
    return gA ? gA.replace(n, p) : p;
  }
  return cjs$1 = AA, cjs$1;
}
var hasRequiredCjs$1;
function requireCjs$1() {
  if (hasRequiredCjs$1) return cjs$2;
  hasRequiredCjs$1 = 1;
  var o = cjs$2 && cjs$2.__importDefault || function(g) {
    return g && g.__esModule ? g : { default: g };
  };
  Object.defineProperty(cjs$2, "__esModule", { value: !0 }), cjs$2.default = A;
  const E = o(requireCjs$2());
  function A(g, e) {
    let t = null;
    if (!g || typeof g != "string")
      return t;
    const c = (0, E.default)(g), n = typeof e == "function";
    return c.forEach((h) => {
      if (h.type !== "declaration")
        return;
      const { property: d, value: k } = h;
      n ? e(d, k, h) : k && (t = t || {}, t[d] = k);
    }), t;
  }
  return cjs$2;
}
var utilities = {}, hasRequiredUtilities;
function requireUtilities() {
  if (hasRequiredUtilities) return utilities;
  hasRequiredUtilities = 1, Object.defineProperty(utilities, "__esModule", { value: !0 }), utilities.camelCase = void 0;
  var o = /^--[a-zA-Z0-9_-]+$/, E = /-([a-z])/g, A = /^[^-]+$/, g = /^-(webkit|moz|ms|o|khtml)-/, e = /^-(ms)-/, t = function(d) {
    return !d || A.test(d) || o.test(d);
  }, c = function(d, k) {
    return k.toUpperCase();
  }, n = function(d, k) {
    return "".concat(k, "-");
  }, h = function(d, k) {
    return k === void 0 && (k = {}), t(d) ? d : (d = d.toLowerCase(), k.reactCompat ? d = d.replace(e, n) : d = d.replace(g, n), d.replace(E, c));
  };
  return utilities.camelCase = h, utilities;
}
var cjs, hasRequiredCjs;
function requireCjs() {
  if (hasRequiredCjs) return cjs;
  hasRequiredCjs = 1;
  var o = cjs && cjs.__importDefault || function(e) {
    return e && e.__esModule ? e : { default: e };
  }, E = o(requireCjs$1()), A = requireUtilities();
  function g(e, t) {
    var c = {};
    return !e || typeof e != "string" || (0, E.default)(e, function(n, h) {
      n && h && (c[(0, A.camelCase)(n, t)] = h);
    }), c;
  }
  return g.default = g, cjs = g, cjs;
}
var cjsExports = requireCjs();
const styleToJs = /* @__PURE__ */ getDefaultExportFromCjs(cjsExports), pointEnd = point$2("end"), pointStart = point$2("start");
function point$2(o) {
  return E;
  function E(A) {
    const g = A && A.position && A.position[o] || {};
    if (typeof g.line == "number" && g.line > 0 && typeof g.column == "number" && g.column > 0)
      return {
        line: g.line,
        column: g.column,
        offset: typeof g.offset == "number" && g.offset > -1 ? g.offset : void 0
      };
  }
}
function position$2(o) {
  const E = pointStart(o), A = pointEnd(o);
  if (E && A)
    return { start: E, end: A };
}
function stringifyPosition(o) {
  return !o || typeof o != "object" ? "" : "position" in o || "type" in o ? position$1(o.position) : "start" in o || "end" in o ? position$1(o) : "line" in o || "column" in o ? point$1(o) : "";
}
function point$1(o) {
  return index$1(o && o.line) + ":" + index$1(o && o.column);
}
function position$1(o) {
  return point$1(o && o.start) + "-" + point$1(o && o.end);
}
function index$1(o) {
  return o && typeof o == "number" ? o : 1;
}
class VFileMessage extends Error {
  /**
   * Create a message for `reason`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {Options | null | undefined} [options]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | Options | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */
  // eslint-disable-next-line complexity
  constructor(E, A, g) {
    super(), typeof A == "string" && (g = A, A = void 0);
    let e = "", t = {}, c = !1;
    if (A && ("line" in A && "column" in A ? t = { place: A } : "start" in A && "end" in A ? t = { place: A } : "type" in A ? t = {
      ancestors: [A],
      place: A.position
    } : t = { ...A }), typeof E == "string" ? e = E : !t.cause && E && (c = !0, e = E.message, t.cause = E), !t.ruleId && !t.source && typeof g == "string") {
      const h = g.indexOf(":");
      h === -1 ? t.ruleId = g : (t.source = g.slice(0, h), t.ruleId = g.slice(h + 1));
    }
    if (!t.place && t.ancestors && t.ancestors) {
      const h = t.ancestors[t.ancestors.length - 1];
      h && (t.place = h.position);
    }
    const n = t.place && "start" in t.place ? t.place.start : t.place;
    this.ancestors = t.ancestors || void 0, this.cause = t.cause || void 0, this.column = n ? n.column : void 0, this.fatal = void 0, this.file = "", this.message = e, this.line = n ? n.line : void 0, this.name = stringifyPosition(t.place) || "1:1", this.place = t.place || void 0, this.reason = this.message, this.ruleId = t.ruleId || void 0, this.source = t.source || void 0, this.stack = c && t.cause && typeof t.cause.stack == "string" ? t.cause.stack : "", this.actual = void 0, this.expected = void 0, this.note = void 0, this.url = void 0;
  }
}
VFileMessage.prototype.file = "";
VFileMessage.prototype.name = "";
VFileMessage.prototype.reason = "";
VFileMessage.prototype.message = "";
VFileMessage.prototype.stack = "";
VFileMessage.prototype.column = void 0;
VFileMessage.prototype.line = void 0;
VFileMessage.prototype.ancestors = void 0;
VFileMessage.prototype.cause = void 0;
VFileMessage.prototype.fatal = void 0;
VFileMessage.prototype.place = void 0;
VFileMessage.prototype.ruleId = void 0;
VFileMessage.prototype.source = void 0;
const own$4 = {}.hasOwnProperty, emptyMap = /* @__PURE__ */ new Map(), cap = /[A-Z]/g, tableElements = /* @__PURE__ */ new Set(["table", "tbody", "thead", "tfoot", "tr"]), tableCellElement = /* @__PURE__ */ new Set(["td", "th"]), docs = "https://github.com/syntax-tree/hast-util-to-jsx-runtime";
function toJsxRuntime(o, E) {
  if (!E || E.Fragment === void 0)
    throw new TypeError("Expected `Fragment` in options");
  const A = E.filePath || void 0;
  let g;
  if (E.development) {
    if (typeof E.jsxDEV != "function")
      throw new TypeError(
        "Expected `jsxDEV` in options when `development: true`"
      );
    g = developmentCreate(A, E.jsxDEV);
  } else {
    if (typeof E.jsx != "function")
      throw new TypeError("Expected `jsx` in production options");
    if (typeof E.jsxs != "function")
      throw new TypeError("Expected `jsxs` in production options");
    g = productionCreate(A, E.jsx, E.jsxs);
  }
  const e = {
    Fragment: E.Fragment,
    ancestors: [],
    components: E.components || {},
    create: g,
    elementAttributeNameCase: E.elementAttributeNameCase || "react",
    evaluater: E.createEvaluater ? E.createEvaluater() : void 0,
    filePath: A,
    ignoreInvalidStyle: E.ignoreInvalidStyle || !1,
    passKeys: E.passKeys !== !1,
    passNode: E.passNode || !1,
    schema: E.space === "svg" ? svg : html$2,
    stylePropertyNameCase: E.stylePropertyNameCase || "dom",
    tableCellAlignToStyle: E.tableCellAlignToStyle !== !1
  }, t = one$1(e, o, void 0);
  return t && typeof t != "string" ? t : e.create(
    o,
    e.Fragment,
    { children: t || void 0 },
    void 0
  );
}
function one$1(o, E, A) {
  if (E.type === "element")
    return element$1(o, E, A);
  if (E.type === "mdxFlowExpression" || E.type === "mdxTextExpression")
    return mdxExpression(o, E);
  if (E.type === "mdxJsxFlowElement" || E.type === "mdxJsxTextElement")
    return mdxJsxElement(o, E, A);
  if (E.type === "mdxjsEsm")
    return mdxEsm(o, E);
  if (E.type === "root")
    return root$3(o, E, A);
  if (E.type === "text")
    return text$6(o, E);
}
function element$1(o, E, A) {
  const g = o.schema;
  let e = g;
  E.tagName.toLowerCase() === "svg" && g.space === "html" && (e = svg, o.schema = e), o.ancestors.push(E);
  const t = findComponentFromName(o, E.tagName, !1), c = createElementProps(o, E);
  let n = createChildren(o, E);
  return tableElements.has(E.tagName) && (n = n.filter(function(h) {
    return typeof h == "string" ? !whitespace(h) : !0;
  })), addNode(o, c, t, E), addChildren(c, n), o.ancestors.pop(), o.schema = g, o.create(E, t, c, A);
}
function mdxExpression(o, E) {
  if (E.data && E.data.estree && o.evaluater) {
    const g = E.data.estree.body[0];
    return g.type, /** @type {Child | undefined} */
    o.evaluater.evaluateExpression(g.expression);
  }
  crashEstree(o, E.position);
}
function mdxEsm(o, E) {
  if (E.data && E.data.estree && o.evaluater)
    return (
      /** @type {Child | undefined} */
      o.evaluater.evaluateProgram(E.data.estree)
    );
  crashEstree(o, E.position);
}
function mdxJsxElement(o, E, A) {
  const g = o.schema;
  let e = g;
  E.name === "svg" && g.space === "html" && (e = svg, o.schema = e), o.ancestors.push(E);
  const t = E.name === null ? o.Fragment : findComponentFromName(o, E.name, !0), c = createJsxElementProps(o, E), n = createChildren(o, E);
  return addNode(o, c, t, E), addChildren(c, n), o.ancestors.pop(), o.schema = g, o.create(E, t, c, A);
}
function root$3(o, E, A) {
  const g = {};
  return addChildren(g, createChildren(o, E)), o.create(E, o.Fragment, g, A);
}
function text$6(o, E) {
  return E.value;
}
function addNode(o, E, A, g) {
  typeof A != "string" && A !== o.Fragment && o.passNode && (E.node = g);
}
function addChildren(o, E) {
  if (E.length > 0) {
    const A = E.length > 1 ? E : E[0];
    A && (o.children = A);
  }
}
function productionCreate(o, E, A) {
  return g;
  function g(e, t, c, n) {
    const d = Array.isArray(c.children) ? A : E;
    return n ? d(t, c, n) : d(t, c);
  }
}
function developmentCreate(o, E) {
  return A;
  function A(g, e, t, c) {
    const n = Array.isArray(t.children), h = pointStart(g);
    return E(
      e,
      t,
      c,
      n,
      {
        columnNumber: h ? h.column - 1 : void 0,
        fileName: o,
        lineNumber: h ? h.line : void 0
      },
      void 0
    );
  }
}
function createElementProps(o, E) {
  const A = {};
  let g, e;
  for (e in E.properties)
    if (e !== "children" && own$4.call(E.properties, e)) {
      const t = createProperty(o, e, E.properties[e]);
      if (t) {
        const [c, n] = t;
        o.tableCellAlignToStyle && c === "align" && typeof n == "string" && tableCellElement.has(E.tagName) ? g = n : A[c] = n;
      }
    }
  if (g) {
    const t = (
      /** @type {Style} */
      A.style || (A.style = {})
    );
    t[o.stylePropertyNameCase === "css" ? "text-align" : "textAlign"] = g;
  }
  return A;
}
function createJsxElementProps(o, E) {
  const A = {};
  for (const g of E.attributes)
    if (g.type === "mdxJsxExpressionAttribute")
      if (g.data && g.data.estree && o.evaluater) {
        const t = g.data.estree.body[0];
        t.type;
        const c = t.expression;
        c.type;
        const n = c.properties[0];
        n.type, Object.assign(
          A,
          o.evaluater.evaluateExpression(n.argument)
        );
      } else
        crashEstree(o, E.position);
    else {
      const e = g.name;
      let t;
      if (g.value && typeof g.value == "object")
        if (g.value.data && g.value.data.estree && o.evaluater) {
          const n = g.value.data.estree.body[0];
          n.type, t = o.evaluater.evaluateExpression(n.expression);
        } else
          crashEstree(o, E.position);
      else
        t = g.value === null ? !0 : g.value;
      A[e] = /** @type {Props[keyof Props]} */
      t;
    }
  return A;
}
function createChildren(o, E) {
  const A = [];
  let g = -1;
  const e = o.passKeys ? /* @__PURE__ */ new Map() : emptyMap;
  for (; ++g < E.children.length; ) {
    const t = E.children[g];
    let c;
    if (o.passKeys) {
      const h = t.type === "element" ? t.tagName : t.type === "mdxJsxFlowElement" || t.type === "mdxJsxTextElement" ? t.name : void 0;
      if (h) {
        const d = e.get(h) || 0;
        c = h + "-" + d, e.set(h, d + 1);
      }
    }
    const n = one$1(o, t, c);
    n !== void 0 && A.push(n);
  }
  return A;
}
function createProperty(o, E, A) {
  const g = find$1(o.schema, E);
  if (!(A == null || typeof A == "number" && Number.isNaN(A))) {
    if (Array.isArray(A) && (A = g.commaSeparated ? stringify$1(A) : stringify(A)), g.property === "style") {
      let e = typeof A == "object" ? A : parseStyle(o, String(A));
      return o.stylePropertyNameCase === "css" && (e = transformStylesToCssCasing(e)), ["style", e];
    }
    return [
      o.elementAttributeNameCase === "react" && g.space ? hastToReact[g.property] || g.property : g.attribute,
      A
    ];
  }
}
function parseStyle(o, E) {
  try {
    return styleToJs(E, { reactCompat: !0 });
  } catch (A) {
    if (o.ignoreInvalidStyle)
      return {};
    const g = (
      /** @type {Error} */
      A
    ), e = new VFileMessage("Cannot parse `style` attribute", {
      ancestors: o.ancestors,
      cause: g,
      ruleId: "style",
      source: "hast-util-to-jsx-runtime"
    });
    throw e.file = o.filePath || void 0, e.url = docs + "#cannot-parse-style-attribute", e;
  }
}
function findComponentFromName(o, E, A) {
  let g;
  if (!A)
    g = { type: "Literal", value: E };
  else if (E.includes(".")) {
    const e = E.split(".");
    let t = -1, c;
    for (; ++t < e.length; ) {
      const n = name(e[t]) ? { type: "Identifier", name: e[t] } : { type: "Literal", value: e[t] };
      c = c ? {
        type: "MemberExpression",
        object: c,
        property: n,
        computed: !!(t && n.type === "Literal"),
        optional: !1
      } : n;
    }
    g = c;
  } else
    g = name(E) && !/^[a-z]/.test(E) ? { type: "Identifier", name: E } : { type: "Literal", value: E };
  if (g.type === "Literal") {
    const e = (
      /** @type {string | number} */
      g.value
    );
    return own$4.call(o.components, e) ? o.components[e] : e;
  }
  if (o.evaluater)
    return o.evaluater.evaluateExpression(g);
  crashEstree(o);
}
function crashEstree(o, E) {
  const A = new VFileMessage(
    "Cannot handle MDX estrees without `createEvaluater`",
    {
      ancestors: o.ancestors,
      place: E,
      ruleId: "mdx-estree",
      source: "hast-util-to-jsx-runtime"
    }
  );
  throw A.file = o.filePath || void 0, A.url = docs + "#cannot-handle-mdx-estrees-without-createevaluater", A;
}
function transformStylesToCssCasing(o) {
  const E = {};
  let A;
  for (A in o)
    own$4.call(o, A) && (E[transformStyleToCssCasing(A)] = o[A]);
  return E;
}
function transformStyleToCssCasing(o) {
  let E = o.replace(cap, toDash);
  return E.slice(0, 3) === "ms-" && (E = "-" + E), E;
}
function toDash(o) {
  return "-" + o.toLowerCase();
}
const urlAttributes = {
  action: ["form"],
  cite: ["blockquote", "del", "ins", "q"],
  data: ["object"],
  formAction: ["button", "input"],
  href: ["a", "area", "base", "link"],
  icon: ["menuitem"],
  itemId: null,
  manifest: ["html"],
  ping: ["a", "area"],
  poster: ["video"],
  src: [
    "audio",
    "embed",
    "iframe",
    "img",
    "input",
    "script",
    "source",
    "track",
    "video"
  ]
}, emptyOptions$4 = {};
function toString$2(o, E) {
  const A = emptyOptions$4, g = typeof A.includeImageAlt == "boolean" ? A.includeImageAlt : !0, e = typeof A.includeHtml == "boolean" ? A.includeHtml : !0;
  return one(o, g, e);
}
function one(o, E, A) {
  if (node(o)) {
    if ("value" in o)
      return o.type === "html" && !A ? "" : o.value;
    if (E && "alt" in o && o.alt)
      return o.alt;
    if ("children" in o)
      return all(o.children, E, A);
  }
  return Array.isArray(o) ? all(o, E, A) : "";
}
function all(o, E, A) {
  const g = [];
  let e = -1;
  for (; ++e < o.length; )
    g[e] = one(o[e], E, A);
  return g.join("");
}
function node(o) {
  return !!(o && typeof o == "object");
}
const element = document.createElement("i");
function decodeNamedCharacterReference(o) {
  const E = "&" + o + ";";
  element.innerHTML = E;
  const A = element.textContent;
  return (
    // @ts-expect-error: TypeScript is wrong that `textContent` on elements can
    // yield `null`.
    A.charCodeAt(A.length - 1) === 59 && o !== "semi" || A === E ? !1 : A
  );
}
function splice(o, E, A, g) {
  const e = o.length;
  let t = 0, c;
  if (E < 0 ? E = -E > e ? 0 : e + E : E = E > e ? e : E, A = A > 0 ? A : 0, g.length < 1e4)
    c = Array.from(g), c.unshift(E, A), o.splice(...c);
  else
    for (A && o.splice(E, A); t < g.length; )
      c = g.slice(t, t + 1e4), c.unshift(E, 0), o.splice(...c), t += 1e4, E += 1e4;
}
function push(o, E) {
  return o.length > 0 ? (splice(o, o.length, 0, E), o) : E;
}
const hasOwnProperty = {}.hasOwnProperty;
function combineExtensions(o) {
  const E = {};
  let A = -1;
  for (; ++A < o.length; )
    syntaxExtension(E, o[A]);
  return E;
}
function syntaxExtension(o, E) {
  let A;
  for (A in E) {
    const e = (hasOwnProperty.call(o, A) ? o[A] : void 0) || (o[A] = {}), t = E[A];
    let c;
    if (t)
      for (c in t) {
        hasOwnProperty.call(e, c) || (e[c] = []);
        const n = t[c];
        constructs(
          // @ts-expect-error Looks like a list.
          e[c],
          Array.isArray(n) ? n : n ? [n] : []
        );
      }
  }
}
function constructs(o, E) {
  let A = -1;
  const g = [];
  for (; ++A < E.length; )
    (E[A].add === "after" ? o : g).push(E[A]);
  splice(o, 0, 0, g);
}
function decodeNumericCharacterReference(o, E) {
  const A = Number.parseInt(o, E);
  return (
    // C0 except for HT, LF, FF, CR, space.
    A < 9 || A === 11 || A > 13 && A < 32 || // Control character (DEL) of C0, and C1 controls.
    A > 126 && A < 160 || // Lone high surrogates and low surrogates.
    A > 55295 && A < 57344 || // Noncharacters.
    A > 64975 && A < 65008 || /* eslint-disable no-bitwise */
    (A & 65535) === 65535 || (A & 65535) === 65534 || /* eslint-enable no-bitwise */
    // Out of range
    A > 1114111 ? "�" : String.fromCodePoint(A)
  );
}
function normalizeIdentifier(o) {
  return o.replace(/[\t\n\r ]+/g, " ").replace(/^ | $/g, "").toLowerCase().toUpperCase();
}
const asciiAlpha = regexCheck(/[A-Za-z]/), asciiAlphanumeric = regexCheck(/[\dA-Za-z]/), asciiAtext = regexCheck(/[#-'*+\--9=?A-Z^-~]/);
function asciiControl(o) {
  return (
    // Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    o !== null && (o < 32 || o === 127)
  );
}
const asciiDigit = regexCheck(/\d/), asciiHexDigit = regexCheck(/[\dA-Fa-f]/), asciiPunctuation = regexCheck(/[!-/:-@[-`{-~]/);
function markdownLineEnding(o) {
  return o !== null && o < -2;
}
function markdownLineEndingOrSpace(o) {
  return o !== null && (o < 0 || o === 32);
}
function markdownSpace(o) {
  return o === -2 || o === -1 || o === 32;
}
const unicodePunctuation = regexCheck(new RegExp("\\p{P}|\\p{S}", "u")), unicodeWhitespace = regexCheck(/\s/);
function regexCheck(o) {
  return E;
  function E(A) {
    return A !== null && A > -1 && o.test(String.fromCharCode(A));
  }
}
function normalizeUri(o) {
  const E = [];
  let A = -1, g = 0, e = 0;
  for (; ++A < o.length; ) {
    const t = o.charCodeAt(A);
    let c = "";
    if (t === 37 && asciiAlphanumeric(o.charCodeAt(A + 1)) && asciiAlphanumeric(o.charCodeAt(A + 2)))
      e = 2;
    else if (t < 128)
      /[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(t)) || (c = String.fromCharCode(t));
    else if (t > 55295 && t < 57344) {
      const n = o.charCodeAt(A + 1);
      t < 56320 && n > 56319 && n < 57344 ? (c = String.fromCharCode(t, n), e = 1) : c = "�";
    } else
      c = String.fromCharCode(t);
    c && (E.push(o.slice(g, A), encodeURIComponent(c)), g = A + e + 1, c = ""), e && (A += e, e = 0);
  }
  return E.join("") + o.slice(g);
}
function factorySpace(o, E, A, g) {
  const e = g ? g - 1 : Number.POSITIVE_INFINITY;
  let t = 0;
  return c;
  function c(h) {
    return markdownSpace(h) ? (o.enter(A), n(h)) : E(h);
  }
  function n(h) {
    return markdownSpace(h) && t++ < e ? (o.consume(h), n) : (o.exit(A), E(h));
  }
}
const content$1 = {
  tokenize: initializeContent
};
function initializeContent(o) {
  const E = o.attempt(this.parser.constructs.contentInitial, g, e);
  let A;
  return E;
  function g(n) {
    if (n === null) {
      o.consume(n);
      return;
    }
    return o.enter("lineEnding"), o.consume(n), o.exit("lineEnding"), factorySpace(o, E, "linePrefix");
  }
  function e(n) {
    return o.enter("paragraph"), t(n);
  }
  function t(n) {
    const h = o.enter("chunkText", {
      contentType: "text",
      previous: A
    });
    return A && (A.next = h), A = h, c(n);
  }
  function c(n) {
    if (n === null) {
      o.exit("chunkText"), o.exit("paragraph"), o.consume(n);
      return;
    }
    return markdownLineEnding(n) ? (o.consume(n), o.exit("chunkText"), t) : (o.consume(n), c);
  }
}
const document$2 = {
  tokenize: initializeDocument
}, containerConstruct = {
  tokenize: tokenizeContainer
};
function initializeDocument(o) {
  const E = this, A = [];
  let g = 0, e, t, c;
  return n;
  function n(BA) {
    if (g < A.length) {
      const QA = A[g];
      return E.containerState = QA[1], o.attempt(QA[0].continuation, h, d)(BA);
    }
    return d(BA);
  }
  function h(BA) {
    if (g++, E.containerState._closeFlow) {
      E.containerState._closeFlow = void 0, e && IA();
      const QA = E.events.length;
      let EA = QA, oA;
      for (; EA--; )
        if (E.events[EA][0] === "exit" && E.events[EA][1].type === "chunkFlow") {
          oA = E.events[EA][1].end;
          break;
        }
      CA(g);
      let iA = QA;
      for (; iA < E.events.length; )
        E.events[iA][1].end = {
          ...oA
        }, iA++;
      return splice(E.events, EA + 1, 0, E.events.slice(QA)), E.events.length = iA, d(BA);
    }
    return n(BA);
  }
  function d(BA) {
    if (g === A.length) {
      if (!e)
        return M(BA);
      if (e.currentConstruct && e.currentConstruct.concrete)
        return AA(BA);
      E.interrupt = !!(e.currentConstruct && !e._gfmTableDynamicInterruptHack);
    }
    return E.containerState = {}, o.check(containerConstruct, k, p)(BA);
  }
  function k(BA) {
    return e && IA(), CA(g), M(BA);
  }
  function p(BA) {
    return E.parser.lazy[E.now().line] = g !== A.length, c = E.now().offset, AA(BA);
  }
  function M(BA) {
    return E.containerState = {}, o.attempt(containerConstruct, S, AA)(BA);
  }
  function S(BA) {
    return g++, A.push([E.currentConstruct, E.containerState]), M(BA);
  }
  function AA(BA) {
    if (BA === null) {
      e && IA(), CA(0), o.consume(BA);
      return;
    }
    return e = e || E.parser.flow(E.now()), o.enter("chunkFlow", {
      _tokenizer: e,
      contentType: "flow",
      previous: t
    }), H(BA);
  }
  function H(BA) {
    if (BA === null) {
      gA(o.exit("chunkFlow"), !0), CA(0), o.consume(BA);
      return;
    }
    return markdownLineEnding(BA) ? (o.consume(BA), gA(o.exit("chunkFlow")), g = 0, E.interrupt = void 0, n) : (o.consume(BA), H);
  }
  function gA(BA, QA) {
    const EA = E.sliceStream(BA);
    if (QA && EA.push(null), BA.previous = t, t && (t.next = BA), t = BA, e.defineSkip(BA.start), e.write(EA), E.parser.lazy[BA.start.line]) {
      let oA = e.events.length;
      for (; oA--; )
        if (
          // The token starts before the line ending…
          e.events[oA][1].start.offset < c && // …and either is not ended yet…
          (!e.events[oA][1].end || // …or ends after it.
          e.events[oA][1].end.offset > c)
        )
          return;
      const iA = E.events.length;
      let aA = iA, tA, eA;
      for (; aA--; )
        if (E.events[aA][0] === "exit" && E.events[aA][1].type === "chunkFlow") {
          if (tA) {
            eA = E.events[aA][1].end;
            break;
          }
          tA = !0;
        }
      for (CA(g), oA = iA; oA < E.events.length; )
        E.events[oA][1].end = {
          ...eA
        }, oA++;
      splice(E.events, aA + 1, 0, E.events.slice(iA)), E.events.length = oA;
    }
  }
  function CA(BA) {
    let QA = A.length;
    for (; QA-- > BA; ) {
      const EA = A[QA];
      E.containerState = EA[1], EA[0].exit.call(E, o);
    }
    A.length = BA;
  }
  function IA() {
    e.write([null]), t = void 0, e = void 0, E.containerState._closeFlow = void 0;
  }
}
function tokenizeContainer(o, E, A) {
  return factorySpace(o, o.attempt(this.parser.constructs.document, E, A), "linePrefix", this.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4);
}
function classifyCharacter(o) {
  if (o === null || markdownLineEndingOrSpace(o) || unicodeWhitespace(o))
    return 1;
  if (unicodePunctuation(o))
    return 2;
}
function resolveAll(o, E, A) {
  const g = [];
  let e = -1;
  for (; ++e < o.length; ) {
    const t = o[e].resolveAll;
    t && !g.includes(t) && (E = t(E, A), g.push(t));
  }
  return E;
}
const attention = {
  name: "attention",
  resolveAll: resolveAllAttention,
  tokenize: tokenizeAttention
};
function resolveAllAttention(o, E) {
  let A = -1, g, e, t, c, n, h, d, k;
  for (; ++A < o.length; )
    if (o[A][0] === "enter" && o[A][1].type === "attentionSequence" && o[A][1]._close) {
      for (g = A; g--; )
        if (o[g][0] === "exit" && o[g][1].type === "attentionSequence" && o[g][1]._open && // If the markers are the same:
        E.sliceSerialize(o[g][1]).charCodeAt(0) === E.sliceSerialize(o[A][1]).charCodeAt(0)) {
          if ((o[g][1]._close || o[A][1]._open) && (o[A][1].end.offset - o[A][1].start.offset) % 3 && !((o[g][1].end.offset - o[g][1].start.offset + o[A][1].end.offset - o[A][1].start.offset) % 3))
            continue;
          h = o[g][1].end.offset - o[g][1].start.offset > 1 && o[A][1].end.offset - o[A][1].start.offset > 1 ? 2 : 1;
          const p = {
            ...o[g][1].end
          }, M = {
            ...o[A][1].start
          };
          movePoint(p, -h), movePoint(M, h), c = {
            type: h > 1 ? "strongSequence" : "emphasisSequence",
            start: p,
            end: {
              ...o[g][1].end
            }
          }, n = {
            type: h > 1 ? "strongSequence" : "emphasisSequence",
            start: {
              ...o[A][1].start
            },
            end: M
          }, t = {
            type: h > 1 ? "strongText" : "emphasisText",
            start: {
              ...o[g][1].end
            },
            end: {
              ...o[A][1].start
            }
          }, e = {
            type: h > 1 ? "strong" : "emphasis",
            start: {
              ...c.start
            },
            end: {
              ...n.end
            }
          }, o[g][1].end = {
            ...c.start
          }, o[A][1].start = {
            ...n.end
          }, d = [], o[g][1].end.offset - o[g][1].start.offset && (d = push(d, [["enter", o[g][1], E], ["exit", o[g][1], E]])), d = push(d, [["enter", e, E], ["enter", c, E], ["exit", c, E], ["enter", t, E]]), d = push(d, resolveAll(E.parser.constructs.insideSpan.null, o.slice(g + 1, A), E)), d = push(d, [["exit", t, E], ["enter", n, E], ["exit", n, E], ["exit", e, E]]), o[A][1].end.offset - o[A][1].start.offset ? (k = 2, d = push(d, [["enter", o[A][1], E], ["exit", o[A][1], E]])) : k = 0, splice(o, g - 1, A - g + 3, d), A = g + d.length - k - 2;
          break;
        }
    }
  for (A = -1; ++A < o.length; )
    o[A][1].type === "attentionSequence" && (o[A][1].type = "data");
  return o;
}
function tokenizeAttention(o, E) {
  const A = this.parser.constructs.attentionMarkers.null, g = this.previous, e = classifyCharacter(g);
  let t;
  return c;
  function c(h) {
    return t = h, o.enter("attentionSequence"), n(h);
  }
  function n(h) {
    if (h === t)
      return o.consume(h), n;
    const d = o.exit("attentionSequence"), k = classifyCharacter(h), p = !k || k === 2 && e || A.includes(h), M = !e || e === 2 && k || A.includes(g);
    return d._open = !!(t === 42 ? p : p && (e || !M)), d._close = !!(t === 42 ? M : M && (k || !p)), E(h);
  }
}
function movePoint(o, E) {
  o.column += E, o.offset += E, o._bufferIndex += E;
}
const autolink = {
  name: "autolink",
  tokenize: tokenizeAutolink
};
function tokenizeAutolink(o, E, A) {
  let g = 0;
  return e;
  function e(S) {
    return o.enter("autolink"), o.enter("autolinkMarker"), o.consume(S), o.exit("autolinkMarker"), o.enter("autolinkProtocol"), t;
  }
  function t(S) {
    return asciiAlpha(S) ? (o.consume(S), c) : S === 64 ? A(S) : d(S);
  }
  function c(S) {
    return S === 43 || S === 45 || S === 46 || asciiAlphanumeric(S) ? (g = 1, n(S)) : d(S);
  }
  function n(S) {
    return S === 58 ? (o.consume(S), g = 0, h) : (S === 43 || S === 45 || S === 46 || asciiAlphanumeric(S)) && g++ < 32 ? (o.consume(S), n) : (g = 0, d(S));
  }
  function h(S) {
    return S === 62 ? (o.exit("autolinkProtocol"), o.enter("autolinkMarker"), o.consume(S), o.exit("autolinkMarker"), o.exit("autolink"), E) : S === null || S === 32 || S === 60 || asciiControl(S) ? A(S) : (o.consume(S), h);
  }
  function d(S) {
    return S === 64 ? (o.consume(S), k) : asciiAtext(S) ? (o.consume(S), d) : A(S);
  }
  function k(S) {
    return asciiAlphanumeric(S) ? p(S) : A(S);
  }
  function p(S) {
    return S === 46 ? (o.consume(S), g = 0, k) : S === 62 ? (o.exit("autolinkProtocol").type = "autolinkEmail", o.enter("autolinkMarker"), o.consume(S), o.exit("autolinkMarker"), o.exit("autolink"), E) : M(S);
  }
  function M(S) {
    if ((S === 45 || asciiAlphanumeric(S)) && g++ < 63) {
      const AA = S === 45 ? M : p;
      return o.consume(S), AA;
    }
    return A(S);
  }
}
const blankLine = {
  partial: !0,
  tokenize: tokenizeBlankLine
};
function tokenizeBlankLine(o, E, A) {
  return g;
  function g(t) {
    return markdownSpace(t) ? factorySpace(o, e, "linePrefix")(t) : e(t);
  }
  function e(t) {
    return t === null || markdownLineEnding(t) ? E(t) : A(t);
  }
}
const blockQuote = {
  continuation: {
    tokenize: tokenizeBlockQuoteContinuation
  },
  exit: exit$2,
  name: "blockQuote",
  tokenize: tokenizeBlockQuoteStart
};
function tokenizeBlockQuoteStart(o, E, A) {
  const g = this;
  return e;
  function e(c) {
    if (c === 62) {
      const n = g.containerState;
      return n.open || (o.enter("blockQuote", {
        _container: !0
      }), n.open = !0), o.enter("blockQuotePrefix"), o.enter("blockQuoteMarker"), o.consume(c), o.exit("blockQuoteMarker"), t;
    }
    return A(c);
  }
  function t(c) {
    return markdownSpace(c) ? (o.enter("blockQuotePrefixWhitespace"), o.consume(c), o.exit("blockQuotePrefixWhitespace"), o.exit("blockQuotePrefix"), E) : (o.exit("blockQuotePrefix"), E(c));
  }
}
function tokenizeBlockQuoteContinuation(o, E, A) {
  const g = this;
  return e;
  function e(c) {
    return markdownSpace(c) ? factorySpace(o, t, "linePrefix", g.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(c) : t(c);
  }
  function t(c) {
    return o.attempt(blockQuote, E, A)(c);
  }
}
function exit$2(o) {
  o.exit("blockQuote");
}
const characterEscape = {
  name: "characterEscape",
  tokenize: tokenizeCharacterEscape
};
function tokenizeCharacterEscape(o, E, A) {
  return g;
  function g(t) {
    return o.enter("characterEscape"), o.enter("escapeMarker"), o.consume(t), o.exit("escapeMarker"), e;
  }
  function e(t) {
    return asciiPunctuation(t) ? (o.enter("characterEscapeValue"), o.consume(t), o.exit("characterEscapeValue"), o.exit("characterEscape"), E) : A(t);
  }
}
const characterReference = {
  name: "characterReference",
  tokenize: tokenizeCharacterReference
};
function tokenizeCharacterReference(o, E, A) {
  const g = this;
  let e = 0, t, c;
  return n;
  function n(p) {
    return o.enter("characterReference"), o.enter("characterReferenceMarker"), o.consume(p), o.exit("characterReferenceMarker"), h;
  }
  function h(p) {
    return p === 35 ? (o.enter("characterReferenceMarkerNumeric"), o.consume(p), o.exit("characterReferenceMarkerNumeric"), d) : (o.enter("characterReferenceValue"), t = 31, c = asciiAlphanumeric, k(p));
  }
  function d(p) {
    return p === 88 || p === 120 ? (o.enter("characterReferenceMarkerHexadecimal"), o.consume(p), o.exit("characterReferenceMarkerHexadecimal"), o.enter("characterReferenceValue"), t = 6, c = asciiHexDigit, k) : (o.enter("characterReferenceValue"), t = 7, c = asciiDigit, k(p));
  }
  function k(p) {
    if (p === 59 && e) {
      const M = o.exit("characterReferenceValue");
      return c === asciiAlphanumeric && !decodeNamedCharacterReference(g.sliceSerialize(M)) ? A(p) : (o.enter("characterReferenceMarker"), o.consume(p), o.exit("characterReferenceMarker"), o.exit("characterReference"), E);
    }
    return c(p) && e++ < t ? (o.consume(p), k) : A(p);
  }
}
const nonLazyContinuation$1 = {
  partial: !0,
  tokenize: tokenizeNonLazyContinuation$1
}, codeFenced = {
  concrete: !0,
  name: "codeFenced",
  tokenize: tokenizeCodeFenced
};
function tokenizeCodeFenced(o, E, A) {
  const g = this, e = {
    partial: !0,
    tokenize: EA
  };
  let t = 0, c = 0, n;
  return h;
  function h(oA) {
    return d(oA);
  }
  function d(oA) {
    const iA = g.events[g.events.length - 1];
    return t = iA && iA[1].type === "linePrefix" ? iA[2].sliceSerialize(iA[1], !0).length : 0, n = oA, o.enter("codeFenced"), o.enter("codeFencedFence"), o.enter("codeFencedFenceSequence"), k(oA);
  }
  function k(oA) {
    return oA === n ? (c++, o.consume(oA), k) : c < 3 ? A(oA) : (o.exit("codeFencedFenceSequence"), markdownSpace(oA) ? factorySpace(o, p, "whitespace")(oA) : p(oA));
  }
  function p(oA) {
    return oA === null || markdownLineEnding(oA) ? (o.exit("codeFencedFence"), g.interrupt ? E(oA) : o.check(nonLazyContinuation$1, H, QA)(oA)) : (o.enter("codeFencedFenceInfo"), o.enter("chunkString", {
      contentType: "string"
    }), M(oA));
  }
  function M(oA) {
    return oA === null || markdownLineEnding(oA) ? (o.exit("chunkString"), o.exit("codeFencedFenceInfo"), p(oA)) : markdownSpace(oA) ? (o.exit("chunkString"), o.exit("codeFencedFenceInfo"), factorySpace(o, S, "whitespace")(oA)) : oA === 96 && oA === n ? A(oA) : (o.consume(oA), M);
  }
  function S(oA) {
    return oA === null || markdownLineEnding(oA) ? p(oA) : (o.enter("codeFencedFenceMeta"), o.enter("chunkString", {
      contentType: "string"
    }), AA(oA));
  }
  function AA(oA) {
    return oA === null || markdownLineEnding(oA) ? (o.exit("chunkString"), o.exit("codeFencedFenceMeta"), p(oA)) : oA === 96 && oA === n ? A(oA) : (o.consume(oA), AA);
  }
  function H(oA) {
    return o.attempt(e, QA, gA)(oA);
  }
  function gA(oA) {
    return o.enter("lineEnding"), o.consume(oA), o.exit("lineEnding"), CA;
  }
  function CA(oA) {
    return t > 0 && markdownSpace(oA) ? factorySpace(o, IA, "linePrefix", t + 1)(oA) : IA(oA);
  }
  function IA(oA) {
    return oA === null || markdownLineEnding(oA) ? o.check(nonLazyContinuation$1, H, QA)(oA) : (o.enter("codeFlowValue"), BA(oA));
  }
  function BA(oA) {
    return oA === null || markdownLineEnding(oA) ? (o.exit("codeFlowValue"), IA(oA)) : (o.consume(oA), BA);
  }
  function QA(oA) {
    return o.exit("codeFenced"), E(oA);
  }
  function EA(oA, iA, aA) {
    let tA = 0;
    return eA;
    function eA(lA) {
      return oA.enter("lineEnding"), oA.consume(lA), oA.exit("lineEnding"), cA;
    }
    function cA(lA) {
      return oA.enter("codeFencedFence"), markdownSpace(lA) ? factorySpace(oA, DA, "linePrefix", g.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(lA) : DA(lA);
    }
    function DA(lA) {
      return lA === n ? (oA.enter("codeFencedFenceSequence"), nA(lA)) : aA(lA);
    }
    function nA(lA) {
      return lA === n ? (tA++, oA.consume(lA), nA) : tA >= c ? (oA.exit("codeFencedFenceSequence"), markdownSpace(lA) ? factorySpace(oA, wA, "whitespace")(lA) : wA(lA)) : aA(lA);
    }
    function wA(lA) {
      return lA === null || markdownLineEnding(lA) ? (oA.exit("codeFencedFence"), iA(lA)) : aA(lA);
    }
  }
}
function tokenizeNonLazyContinuation$1(o, E, A) {
  const g = this;
  return e;
  function e(c) {
    return c === null ? A(c) : (o.enter("lineEnding"), o.consume(c), o.exit("lineEnding"), t);
  }
  function t(c) {
    return g.parser.lazy[g.now().line] ? A(c) : E(c);
  }
}
const codeIndented = {
  name: "codeIndented",
  tokenize: tokenizeCodeIndented
}, furtherStart = {
  partial: !0,
  tokenize: tokenizeFurtherStart
};
function tokenizeCodeIndented(o, E, A) {
  const g = this;
  return e;
  function e(d) {
    return o.enter("codeIndented"), factorySpace(o, t, "linePrefix", 5)(d);
  }
  function t(d) {
    const k = g.events[g.events.length - 1];
    return k && k[1].type === "linePrefix" && k[2].sliceSerialize(k[1], !0).length >= 4 ? c(d) : A(d);
  }
  function c(d) {
    return d === null ? h(d) : markdownLineEnding(d) ? o.attempt(furtherStart, c, h)(d) : (o.enter("codeFlowValue"), n(d));
  }
  function n(d) {
    return d === null || markdownLineEnding(d) ? (o.exit("codeFlowValue"), c(d)) : (o.consume(d), n);
  }
  function h(d) {
    return o.exit("codeIndented"), E(d);
  }
}
function tokenizeFurtherStart(o, E, A) {
  const g = this;
  return e;
  function e(c) {
    return g.parser.lazy[g.now().line] ? A(c) : markdownLineEnding(c) ? (o.enter("lineEnding"), o.consume(c), o.exit("lineEnding"), e) : factorySpace(o, t, "linePrefix", 5)(c);
  }
  function t(c) {
    const n = g.events[g.events.length - 1];
    return n && n[1].type === "linePrefix" && n[2].sliceSerialize(n[1], !0).length >= 4 ? E(c) : markdownLineEnding(c) ? e(c) : A(c);
  }
}
const codeText = {
  name: "codeText",
  previous: previous$3,
  resolve: resolveCodeText,
  tokenize: tokenizeCodeText
};
function resolveCodeText(o) {
  let E = o.length - 4, A = 3, g, e;
  if ((o[A][1].type === "lineEnding" || o[A][1].type === "space") && (o[E][1].type === "lineEnding" || o[E][1].type === "space")) {
    for (g = A; ++g < E; )
      if (o[g][1].type === "codeTextData") {
        o[A][1].type = "codeTextPadding", o[E][1].type = "codeTextPadding", A += 2, E -= 2;
        break;
      }
  }
  for (g = A - 1, E++; ++g <= E; )
    e === void 0 ? g !== E && o[g][1].type !== "lineEnding" && (e = g) : (g === E || o[g][1].type === "lineEnding") && (o[e][1].type = "codeTextData", g !== e + 2 && (o[e][1].end = o[g - 1][1].end, o.splice(e + 2, g - e - 2), E -= g - e - 2, g = e + 2), e = void 0);
  return o;
}
function previous$3(o) {
  return o !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
function tokenizeCodeText(o, E, A) {
  let g = 0, e, t;
  return c;
  function c(p) {
    return o.enter("codeText"), o.enter("codeTextSequence"), n(p);
  }
  function n(p) {
    return p === 96 ? (o.consume(p), g++, n) : (o.exit("codeTextSequence"), h(p));
  }
  function h(p) {
    return p === null ? A(p) : p === 32 ? (o.enter("space"), o.consume(p), o.exit("space"), h) : p === 96 ? (t = o.enter("codeTextSequence"), e = 0, k(p)) : markdownLineEnding(p) ? (o.enter("lineEnding"), o.consume(p), o.exit("lineEnding"), h) : (o.enter("codeTextData"), d(p));
  }
  function d(p) {
    return p === null || p === 32 || p === 96 || markdownLineEnding(p) ? (o.exit("codeTextData"), h(p)) : (o.consume(p), d);
  }
  function k(p) {
    return p === 96 ? (o.consume(p), e++, k) : e === g ? (o.exit("codeTextSequence"), o.exit("codeText"), E(p)) : (t.type = "codeTextData", d(p));
  }
}
class SpliceBuffer {
  /**
   * @param {ReadonlyArray<T> | null | undefined} [initial]
   *   Initial items (optional).
   * @returns
   *   Splice buffer.
   */
  constructor(E) {
    this.left = E ? [...E] : [], this.right = [];
  }
  /**
   * Array access;
   * does not move the cursor.
   *
   * @param {number} index
   *   Index.
   * @return {T}
   *   Item.
   */
  get(E) {
    if (E < 0 || E >= this.left.length + this.right.length)
      throw new RangeError("Cannot access index `" + E + "` in a splice buffer of size `" + (this.left.length + this.right.length) + "`");
    return E < this.left.length ? this.left[E] : this.right[this.right.length - E + this.left.length - 1];
  }
  /**
   * The length of the splice buffer, one greater than the largest index in the
   * array.
   */
  get length() {
    return this.left.length + this.right.length;
  }
  /**
   * Remove and return `list[0]`;
   * moves the cursor to `0`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  shift() {
    return this.setCursor(0), this.right.pop();
  }
  /**
   * Slice the buffer to get an array;
   * does not move the cursor.
   *
   * @param {number} start
   *   Start.
   * @param {number | null | undefined} [end]
   *   End (optional).
   * @returns {Array<T>}
   *   Array of items.
   */
  slice(E, A) {
    const g = A ?? Number.POSITIVE_INFINITY;
    return g < this.left.length ? this.left.slice(E, g) : E > this.left.length ? this.right.slice(this.right.length - g + this.left.length, this.right.length - E + this.left.length).reverse() : this.left.slice(E).concat(this.right.slice(this.right.length - g + this.left.length).reverse());
  }
  /**
   * Mimics the behavior of Array.prototype.splice() except for the change of
   * interface necessary to avoid segfaults when patching in very large arrays.
   *
   * This operation moves cursor is moved to `start` and results in the cursor
   * placed after any inserted items.
   *
   * @param {number} start
   *   Start;
   *   zero-based index at which to start changing the array;
   *   negative numbers count backwards from the end of the array and values
   *   that are out-of bounds are clamped to the appropriate end of the array.
   * @param {number | null | undefined} [deleteCount=0]
   *   Delete count (default: `0`);
   *   maximum number of elements to delete, starting from start.
   * @param {Array<T> | null | undefined} [items=[]]
   *   Items to include in place of the deleted items (default: `[]`).
   * @return {Array<T>}
   *   Any removed items.
   */
  splice(E, A, g) {
    const e = A || 0;
    this.setCursor(Math.trunc(E));
    const t = this.right.splice(this.right.length - e, Number.POSITIVE_INFINITY);
    return g && chunkedPush(this.left, g), t.reverse();
  }
  /**
   * Remove and return the highest-numbered item in the array, so
   * `list[list.length - 1]`;
   * Moves the cursor to `length`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  pop() {
    return this.setCursor(Number.POSITIVE_INFINITY), this.left.pop();
  }
  /**
   * Inserts a single item to the high-numbered side of the array;
   * moves the cursor to `length`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  push(E) {
    this.setCursor(Number.POSITIVE_INFINITY), this.left.push(E);
  }
  /**
   * Inserts many items to the high-numbered side of the array.
   * Moves the cursor to `length`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  pushMany(E) {
    this.setCursor(Number.POSITIVE_INFINITY), chunkedPush(this.left, E);
  }
  /**
   * Inserts a single item to the low-numbered side of the array;
   * Moves the cursor to `0`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  unshift(E) {
    this.setCursor(0), this.right.push(E);
  }
  /**
   * Inserts many items to the low-numbered side of the array;
   * moves the cursor to `0`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  unshiftMany(E) {
    this.setCursor(0), chunkedPush(this.right, E.reverse());
  }
  /**
   * Move the cursor to a specific position in the array. Requires
   * time proportional to the distance moved.
   *
   * If `n < 0`, the cursor will end up at the beginning.
   * If `n > length`, the cursor will end up at the end.
   *
   * @param {number} n
   *   Position.
   * @return {undefined}
   *   Nothing.
   */
  setCursor(E) {
    if (!(E === this.left.length || E > this.left.length && this.right.length === 0 || E < 0 && this.left.length === 0))
      if (E < this.left.length) {
        const A = this.left.splice(E, Number.POSITIVE_INFINITY);
        chunkedPush(this.right, A.reverse());
      } else {
        const A = this.right.splice(this.left.length + this.right.length - E, Number.POSITIVE_INFINITY);
        chunkedPush(this.left, A.reverse());
      }
  }
}
function chunkedPush(o, E) {
  let A = 0;
  if (E.length < 1e4)
    o.push(...E);
  else
    for (; A < E.length; )
      o.push(...E.slice(A, A + 1e4)), A += 1e4;
}
function subtokenize(o) {
  const E = {};
  let A = -1, g, e, t, c, n, h, d;
  const k = new SpliceBuffer(o);
  for (; ++A < k.length; ) {
    for (; A in E; )
      A = E[A];
    if (g = k.get(A), A && g[1].type === "chunkFlow" && k.get(A - 1)[1].type === "listItemPrefix" && (h = g[1]._tokenizer.events, t = 0, t < h.length && h[t][1].type === "lineEndingBlank" && (t += 2), t < h.length && h[t][1].type === "content"))
      for (; ++t < h.length && h[t][1].type !== "content"; )
        h[t][1].type === "chunkText" && (h[t][1]._isInFirstContentOfListItem = !0, t++);
    if (g[0] === "enter")
      g[1].contentType && (Object.assign(E, subcontent(k, A)), A = E[A], d = !0);
    else if (g[1]._container) {
      for (t = A, e = void 0; t--; )
        if (c = k.get(t), c[1].type === "lineEnding" || c[1].type === "lineEndingBlank")
          c[0] === "enter" && (e && (k.get(e)[1].type = "lineEndingBlank"), c[1].type = "lineEnding", e = t);
        else if (!(c[1].type === "linePrefix" || c[1].type === "listItemIndent")) break;
      e && (g[1].end = {
        ...k.get(e)[1].start
      }, n = k.slice(e, A), n.unshift(g), k.splice(e, A - e + 1, n));
    }
  }
  return splice(o, 0, Number.POSITIVE_INFINITY, k.slice(0)), !d;
}
function subcontent(o, E) {
  const A = o.get(E)[1], g = o.get(E)[2];
  let e = E - 1;
  const t = [];
  let c = A._tokenizer;
  c || (c = g.parser[A.contentType](A.start), A._contentTypeTextTrailing && (c._contentTypeTextTrailing = !0));
  const n = c.events, h = [], d = {};
  let k, p, M = -1, S = A, AA = 0, H = 0;
  const gA = [H];
  for (; S; ) {
    for (; o.get(++e)[1] !== S; )
      ;
    t.push(e), S._tokenizer || (k = g.sliceStream(S), S.next || k.push(null), p && c.defineSkip(S.start), S._isInFirstContentOfListItem && (c._gfmTasklistFirstContentOfListItem = !0), c.write(k), S._isInFirstContentOfListItem && (c._gfmTasklistFirstContentOfListItem = void 0)), p = S, S = S.next;
  }
  for (S = A; ++M < n.length; )
    // Find a void token that includes a break.
    n[M][0] === "exit" && n[M - 1][0] === "enter" && n[M][1].type === n[M - 1][1].type && n[M][1].start.line !== n[M][1].end.line && (H = M + 1, gA.push(H), S._tokenizer = void 0, S.previous = void 0, S = S.next);
  for (c.events = [], S ? (S._tokenizer = void 0, S.previous = void 0) : gA.pop(), M = gA.length; M--; ) {
    const CA = n.slice(gA[M], gA[M + 1]), IA = t.pop();
    h.push([IA, IA + CA.length - 1]), o.splice(IA, 2, CA);
  }
  for (h.reverse(), M = -1; ++M < h.length; )
    d[AA + h[M][0]] = AA + h[M][1], AA += h[M][1] - h[M][0] - 1;
  return d;
}
const content = {
  resolve: resolveContent,
  tokenize: tokenizeContent
}, continuationConstruct = {
  partial: !0,
  tokenize: tokenizeContinuation
};
function resolveContent(o) {
  return subtokenize(o), o;
}
function tokenizeContent(o, E) {
  let A;
  return g;
  function g(n) {
    return o.enter("content"), A = o.enter("chunkContent", {
      contentType: "content"
    }), e(n);
  }
  function e(n) {
    return n === null ? t(n) : markdownLineEnding(n) ? o.check(continuationConstruct, c, t)(n) : (o.consume(n), e);
  }
  function t(n) {
    return o.exit("chunkContent"), o.exit("content"), E(n);
  }
  function c(n) {
    return o.consume(n), o.exit("chunkContent"), A.next = o.enter("chunkContent", {
      contentType: "content",
      previous: A
    }), A = A.next, e;
  }
}
function tokenizeContinuation(o, E, A) {
  const g = this;
  return e;
  function e(c) {
    return o.exit("chunkContent"), o.enter("lineEnding"), o.consume(c), o.exit("lineEnding"), factorySpace(o, t, "linePrefix");
  }
  function t(c) {
    if (c === null || markdownLineEnding(c))
      return A(c);
    const n = g.events[g.events.length - 1];
    return !g.parser.constructs.disable.null.includes("codeIndented") && n && n[1].type === "linePrefix" && n[2].sliceSerialize(n[1], !0).length >= 4 ? E(c) : o.interrupt(g.parser.constructs.flow, A, E)(c);
  }
}
function factoryDestination(o, E, A, g, e, t, c, n, h) {
  const d = h || Number.POSITIVE_INFINITY;
  let k = 0;
  return p;
  function p(CA) {
    return CA === 60 ? (o.enter(g), o.enter(e), o.enter(t), o.consume(CA), o.exit(t), M) : CA === null || CA === 32 || CA === 41 || asciiControl(CA) ? A(CA) : (o.enter(g), o.enter(c), o.enter(n), o.enter("chunkString", {
      contentType: "string"
    }), H(CA));
  }
  function M(CA) {
    return CA === 62 ? (o.enter(t), o.consume(CA), o.exit(t), o.exit(e), o.exit(g), E) : (o.enter(n), o.enter("chunkString", {
      contentType: "string"
    }), S(CA));
  }
  function S(CA) {
    return CA === 62 ? (o.exit("chunkString"), o.exit(n), M(CA)) : CA === null || CA === 60 || markdownLineEnding(CA) ? A(CA) : (o.consume(CA), CA === 92 ? AA : S);
  }
  function AA(CA) {
    return CA === 60 || CA === 62 || CA === 92 ? (o.consume(CA), S) : S(CA);
  }
  function H(CA) {
    return !k && (CA === null || CA === 41 || markdownLineEndingOrSpace(CA)) ? (o.exit("chunkString"), o.exit(n), o.exit(c), o.exit(g), E(CA)) : k < d && CA === 40 ? (o.consume(CA), k++, H) : CA === 41 ? (o.consume(CA), k--, H) : CA === null || CA === 32 || CA === 40 || asciiControl(CA) ? A(CA) : (o.consume(CA), CA === 92 ? gA : H);
  }
  function gA(CA) {
    return CA === 40 || CA === 41 || CA === 92 ? (o.consume(CA), H) : H(CA);
  }
}
function factoryLabel$1(o, E, A, g, e, t) {
  const c = this;
  let n = 0, h;
  return d;
  function d(S) {
    return o.enter(g), o.enter(e), o.consume(S), o.exit(e), o.enter(t), k;
  }
  function k(S) {
    return n > 999 || S === null || S === 91 || S === 93 && !h || // To do: remove in the future once we’ve switched from
    // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
    // which doesn’t need this.
    // Hidden footnotes hook.
    /* c8 ignore next 3 */
    S === 94 && !n && "_hiddenFootnoteSupport" in c.parser.constructs ? A(S) : S === 93 ? (o.exit(t), o.enter(e), o.consume(S), o.exit(e), o.exit(g), E) : markdownLineEnding(S) ? (o.enter("lineEnding"), o.consume(S), o.exit("lineEnding"), k) : (o.enter("chunkString", {
      contentType: "string"
    }), p(S));
  }
  function p(S) {
    return S === null || S === 91 || S === 93 || markdownLineEnding(S) || n++ > 999 ? (o.exit("chunkString"), k(S)) : (o.consume(S), h || (h = !markdownSpace(S)), S === 92 ? M : p);
  }
  function M(S) {
    return S === 91 || S === 92 || S === 93 ? (o.consume(S), n++, p) : p(S);
  }
}
function factoryTitle(o, E, A, g, e, t) {
  let c;
  return n;
  function n(M) {
    return M === 34 || M === 39 || M === 40 ? (o.enter(g), o.enter(e), o.consume(M), o.exit(e), c = M === 40 ? 41 : M, h) : A(M);
  }
  function h(M) {
    return M === c ? (o.enter(e), o.consume(M), o.exit(e), o.exit(g), E) : (o.enter(t), d(M));
  }
  function d(M) {
    return M === c ? (o.exit(t), h(c)) : M === null ? A(M) : markdownLineEnding(M) ? (o.enter("lineEnding"), o.consume(M), o.exit("lineEnding"), factorySpace(o, d, "linePrefix")) : (o.enter("chunkString", {
      contentType: "string"
    }), k(M));
  }
  function k(M) {
    return M === c || M === null || markdownLineEnding(M) ? (o.exit("chunkString"), d(M)) : (o.consume(M), M === 92 ? p : k);
  }
  function p(M) {
    return M === c || M === 92 ? (o.consume(M), k) : k(M);
  }
}
function factoryWhitespace(o, E) {
  let A;
  return g;
  function g(e) {
    return markdownLineEnding(e) ? (o.enter("lineEnding"), o.consume(e), o.exit("lineEnding"), A = !0, g) : markdownSpace(e) ? factorySpace(o, g, A ? "linePrefix" : "lineSuffix")(e) : E(e);
  }
}
const definition$1 = {
  name: "definition",
  tokenize: tokenizeDefinition
}, titleBefore = {
  partial: !0,
  tokenize: tokenizeTitleBefore
};
function tokenizeDefinition(o, E, A) {
  const g = this;
  let e;
  return t;
  function t(S) {
    return o.enter("definition"), c(S);
  }
  function c(S) {
    return factoryLabel$1.call(
      g,
      o,
      n,
      // Note: we don’t need to reset the way `markdown-rs` does.
      A,
      "definitionLabel",
      "definitionLabelMarker",
      "definitionLabelString"
    )(S);
  }
  function n(S) {
    return e = normalizeIdentifier(g.sliceSerialize(g.events[g.events.length - 1][1]).slice(1, -1)), S === 58 ? (o.enter("definitionMarker"), o.consume(S), o.exit("definitionMarker"), h) : A(S);
  }
  function h(S) {
    return markdownLineEndingOrSpace(S) ? factoryWhitespace(o, d)(S) : d(S);
  }
  function d(S) {
    return factoryDestination(
      o,
      k,
      // Note: we don’t need to reset the way `markdown-rs` does.
      A,
      "definitionDestination",
      "definitionDestinationLiteral",
      "definitionDestinationLiteralMarker",
      "definitionDestinationRaw",
      "definitionDestinationString"
    )(S);
  }
  function k(S) {
    return o.attempt(titleBefore, p, p)(S);
  }
  function p(S) {
    return markdownSpace(S) ? factorySpace(o, M, "whitespace")(S) : M(S);
  }
  function M(S) {
    return S === null || markdownLineEnding(S) ? (o.exit("definition"), g.parser.defined.push(e), E(S)) : A(S);
  }
}
function tokenizeTitleBefore(o, E, A) {
  return g;
  function g(n) {
    return markdownLineEndingOrSpace(n) ? factoryWhitespace(o, e)(n) : A(n);
  }
  function e(n) {
    return factoryTitle(o, t, A, "definitionTitle", "definitionTitleMarker", "definitionTitleString")(n);
  }
  function t(n) {
    return markdownSpace(n) ? factorySpace(o, c, "whitespace")(n) : c(n);
  }
  function c(n) {
    return n === null || markdownLineEnding(n) ? E(n) : A(n);
  }
}
const hardBreakEscape = {
  name: "hardBreakEscape",
  tokenize: tokenizeHardBreakEscape
};
function tokenizeHardBreakEscape(o, E, A) {
  return g;
  function g(t) {
    return o.enter("hardBreakEscape"), o.consume(t), e;
  }
  function e(t) {
    return markdownLineEnding(t) ? (o.exit("hardBreakEscape"), E(t)) : A(t);
  }
}
const headingAtx = {
  name: "headingAtx",
  resolve: resolveHeadingAtx,
  tokenize: tokenizeHeadingAtx
};
function resolveHeadingAtx(o, E) {
  let A = o.length - 2, g = 3, e, t;
  return o[g][1].type === "whitespace" && (g += 2), A - 2 > g && o[A][1].type === "whitespace" && (A -= 2), o[A][1].type === "atxHeadingSequence" && (g === A - 1 || A - 4 > g && o[A - 2][1].type === "whitespace") && (A -= g + 1 === A ? 2 : 4), A > g && (e = {
    type: "atxHeadingText",
    start: o[g][1].start,
    end: o[A][1].end
  }, t = {
    type: "chunkText",
    start: o[g][1].start,
    end: o[A][1].end,
    contentType: "text"
  }, splice(o, g, A - g + 1, [["enter", e, E], ["enter", t, E], ["exit", t, E], ["exit", e, E]])), o;
}
function tokenizeHeadingAtx(o, E, A) {
  let g = 0;
  return e;
  function e(k) {
    return o.enter("atxHeading"), t(k);
  }
  function t(k) {
    return o.enter("atxHeadingSequence"), c(k);
  }
  function c(k) {
    return k === 35 && g++ < 6 ? (o.consume(k), c) : k === null || markdownLineEndingOrSpace(k) ? (o.exit("atxHeadingSequence"), n(k)) : A(k);
  }
  function n(k) {
    return k === 35 ? (o.enter("atxHeadingSequence"), h(k)) : k === null || markdownLineEnding(k) ? (o.exit("atxHeading"), E(k)) : markdownSpace(k) ? factorySpace(o, n, "whitespace")(k) : (o.enter("atxHeadingText"), d(k));
  }
  function h(k) {
    return k === 35 ? (o.consume(k), h) : (o.exit("atxHeadingSequence"), n(k));
  }
  function d(k) {
    return k === null || k === 35 || markdownLineEndingOrSpace(k) ? (o.exit("atxHeadingText"), n(k)) : (o.consume(k), d);
  }
}
const htmlBlockNames = [
  "address",
  "article",
  "aside",
  "base",
  "basefont",
  "blockquote",
  "body",
  "caption",
  "center",
  "col",
  "colgroup",
  "dd",
  "details",
  "dialog",
  "dir",
  "div",
  "dl",
  "dt",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "frame",
  "frameset",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hr",
  "html",
  "iframe",
  "legend",
  "li",
  "link",
  "main",
  "menu",
  "menuitem",
  "nav",
  "noframes",
  "ol",
  "optgroup",
  "option",
  "p",
  "param",
  "search",
  "section",
  "summary",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "title",
  "tr",
  "track",
  "ul"
], htmlRawNames = ["pre", "script", "style", "textarea"], htmlFlow = {
  concrete: !0,
  name: "htmlFlow",
  resolveTo: resolveToHtmlFlow,
  tokenize: tokenizeHtmlFlow
}, blankLineBefore = {
  partial: !0,
  tokenize: tokenizeBlankLineBefore
}, nonLazyContinuationStart = {
  partial: !0,
  tokenize: tokenizeNonLazyContinuationStart
};
function resolveToHtmlFlow(o) {
  let E = o.length;
  for (; E-- && !(o[E][0] === "enter" && o[E][1].type === "htmlFlow"); )
    ;
  return E > 1 && o[E - 2][1].type === "linePrefix" && (o[E][1].start = o[E - 2][1].start, o[E + 1][1].start = o[E - 2][1].start, o.splice(E - 2, 2)), o;
}
function tokenizeHtmlFlow(o, E, A) {
  const g = this;
  let e, t, c, n, h;
  return d;
  function d(sA) {
    return k(sA);
  }
  function k(sA) {
    return o.enter("htmlFlow"), o.enter("htmlFlowData"), o.consume(sA), p;
  }
  function p(sA) {
    return sA === 33 ? (o.consume(sA), M) : sA === 47 ? (o.consume(sA), t = !0, H) : sA === 63 ? (o.consume(sA), e = 3, g.interrupt ? E : GA) : asciiAlpha(sA) ? (o.consume(sA), c = String.fromCharCode(sA), gA) : A(sA);
  }
  function M(sA) {
    return sA === 45 ? (o.consume(sA), e = 2, S) : sA === 91 ? (o.consume(sA), e = 5, n = 0, AA) : asciiAlpha(sA) ? (o.consume(sA), e = 4, g.interrupt ? E : GA) : A(sA);
  }
  function S(sA) {
    return sA === 45 ? (o.consume(sA), g.interrupt ? E : GA) : A(sA);
  }
  function AA(sA) {
    const mA = "CDATA[";
    return sA === mA.charCodeAt(n++) ? (o.consume(sA), n === mA.length ? g.interrupt ? E : DA : AA) : A(sA);
  }
  function H(sA) {
    return asciiAlpha(sA) ? (o.consume(sA), c = String.fromCharCode(sA), gA) : A(sA);
  }
  function gA(sA) {
    if (sA === null || sA === 47 || sA === 62 || markdownLineEndingOrSpace(sA)) {
      const mA = sA === 47, xA = c.toLowerCase();
      return !mA && !t && htmlRawNames.includes(xA) ? (e = 1, g.interrupt ? E(sA) : DA(sA)) : htmlBlockNames.includes(c.toLowerCase()) ? (e = 6, mA ? (o.consume(sA), CA) : g.interrupt ? E(sA) : DA(sA)) : (e = 7, g.interrupt && !g.parser.lazy[g.now().line] ? A(sA) : t ? IA(sA) : BA(sA));
    }
    return sA === 45 || asciiAlphanumeric(sA) ? (o.consume(sA), c += String.fromCharCode(sA), gA) : A(sA);
  }
  function CA(sA) {
    return sA === 62 ? (o.consume(sA), g.interrupt ? E : DA) : A(sA);
  }
  function IA(sA) {
    return markdownSpace(sA) ? (o.consume(sA), IA) : eA(sA);
  }
  function BA(sA) {
    return sA === 47 ? (o.consume(sA), eA) : sA === 58 || sA === 95 || asciiAlpha(sA) ? (o.consume(sA), QA) : markdownSpace(sA) ? (o.consume(sA), BA) : eA(sA);
  }
  function QA(sA) {
    return sA === 45 || sA === 46 || sA === 58 || sA === 95 || asciiAlphanumeric(sA) ? (o.consume(sA), QA) : EA(sA);
  }
  function EA(sA) {
    return sA === 61 ? (o.consume(sA), oA) : markdownSpace(sA) ? (o.consume(sA), EA) : BA(sA);
  }
  function oA(sA) {
    return sA === null || sA === 60 || sA === 61 || sA === 62 || sA === 96 ? A(sA) : sA === 34 || sA === 39 ? (o.consume(sA), h = sA, iA) : markdownSpace(sA) ? (o.consume(sA), oA) : aA(sA);
  }
  function iA(sA) {
    return sA === h ? (o.consume(sA), h = null, tA) : sA === null || markdownLineEnding(sA) ? A(sA) : (o.consume(sA), iA);
  }
  function aA(sA) {
    return sA === null || sA === 34 || sA === 39 || sA === 47 || sA === 60 || sA === 61 || sA === 62 || sA === 96 || markdownLineEndingOrSpace(sA) ? EA(sA) : (o.consume(sA), aA);
  }
  function tA(sA) {
    return sA === 47 || sA === 62 || markdownSpace(sA) ? BA(sA) : A(sA);
  }
  function eA(sA) {
    return sA === 62 ? (o.consume(sA), cA) : A(sA);
  }
  function cA(sA) {
    return sA === null || markdownLineEnding(sA) ? DA(sA) : markdownSpace(sA) ? (o.consume(sA), cA) : A(sA);
  }
  function DA(sA) {
    return sA === 45 && e === 2 ? (o.consume(sA), NA) : sA === 60 && e === 1 ? (o.consume(sA), RA) : sA === 62 && e === 4 ? (o.consume(sA), FA) : sA === 63 && e === 3 ? (o.consume(sA), GA) : sA === 93 && e === 5 ? (o.consume(sA), vA) : markdownLineEnding(sA) && (e === 6 || e === 7) ? (o.exit("htmlFlowData"), o.check(blankLineBefore, HA, nA)(sA)) : sA === null || markdownLineEnding(sA) ? (o.exit("htmlFlowData"), nA(sA)) : (o.consume(sA), DA);
  }
  function nA(sA) {
    return o.check(nonLazyContinuationStart, wA, HA)(sA);
  }
  function wA(sA) {
    return o.enter("lineEnding"), o.consume(sA), o.exit("lineEnding"), lA;
  }
  function lA(sA) {
    return sA === null || markdownLineEnding(sA) ? nA(sA) : (o.enter("htmlFlowData"), DA(sA));
  }
  function NA(sA) {
    return sA === 45 ? (o.consume(sA), GA) : DA(sA);
  }
  function RA(sA) {
    return sA === 47 ? (o.consume(sA), c = "", KA) : DA(sA);
  }
  function KA(sA) {
    if (sA === 62) {
      const mA = c.toLowerCase();
      return htmlRawNames.includes(mA) ? (o.consume(sA), FA) : DA(sA);
    }
    return asciiAlpha(sA) && c.length < 8 ? (o.consume(sA), c += String.fromCharCode(sA), KA) : DA(sA);
  }
  function vA(sA) {
    return sA === 93 ? (o.consume(sA), GA) : DA(sA);
  }
  function GA(sA) {
    return sA === 62 ? (o.consume(sA), FA) : sA === 45 && e === 2 ? (o.consume(sA), GA) : DA(sA);
  }
  function FA(sA) {
    return sA === null || markdownLineEnding(sA) ? (o.exit("htmlFlowData"), HA(sA)) : (o.consume(sA), FA);
  }
  function HA(sA) {
    return o.exit("htmlFlow"), E(sA);
  }
}
function tokenizeNonLazyContinuationStart(o, E, A) {
  const g = this;
  return e;
  function e(c) {
    return markdownLineEnding(c) ? (o.enter("lineEnding"), o.consume(c), o.exit("lineEnding"), t) : A(c);
  }
  function t(c) {
    return g.parser.lazy[g.now().line] ? A(c) : E(c);
  }
}
function tokenizeBlankLineBefore(o, E, A) {
  return g;
  function g(e) {
    return o.enter("lineEnding"), o.consume(e), o.exit("lineEnding"), o.attempt(blankLine, E, A);
  }
}
const htmlText = {
  name: "htmlText",
  tokenize: tokenizeHtmlText
};
function tokenizeHtmlText(o, E, A) {
  const g = this;
  let e, t, c;
  return n;
  function n(GA) {
    return o.enter("htmlText"), o.enter("htmlTextData"), o.consume(GA), h;
  }
  function h(GA) {
    return GA === 33 ? (o.consume(GA), d) : GA === 47 ? (o.consume(GA), EA) : GA === 63 ? (o.consume(GA), BA) : asciiAlpha(GA) ? (o.consume(GA), aA) : A(GA);
  }
  function d(GA) {
    return GA === 45 ? (o.consume(GA), k) : GA === 91 ? (o.consume(GA), t = 0, AA) : asciiAlpha(GA) ? (o.consume(GA), IA) : A(GA);
  }
  function k(GA) {
    return GA === 45 ? (o.consume(GA), S) : A(GA);
  }
  function p(GA) {
    return GA === null ? A(GA) : GA === 45 ? (o.consume(GA), M) : markdownLineEnding(GA) ? (c = p, RA(GA)) : (o.consume(GA), p);
  }
  function M(GA) {
    return GA === 45 ? (o.consume(GA), S) : p(GA);
  }
  function S(GA) {
    return GA === 62 ? NA(GA) : GA === 45 ? M(GA) : p(GA);
  }
  function AA(GA) {
    const FA = "CDATA[";
    return GA === FA.charCodeAt(t++) ? (o.consume(GA), t === FA.length ? H : AA) : A(GA);
  }
  function H(GA) {
    return GA === null ? A(GA) : GA === 93 ? (o.consume(GA), gA) : markdownLineEnding(GA) ? (c = H, RA(GA)) : (o.consume(GA), H);
  }
  function gA(GA) {
    return GA === 93 ? (o.consume(GA), CA) : H(GA);
  }
  function CA(GA) {
    return GA === 62 ? NA(GA) : GA === 93 ? (o.consume(GA), CA) : H(GA);
  }
  function IA(GA) {
    return GA === null || GA === 62 ? NA(GA) : markdownLineEnding(GA) ? (c = IA, RA(GA)) : (o.consume(GA), IA);
  }
  function BA(GA) {
    return GA === null ? A(GA) : GA === 63 ? (o.consume(GA), QA) : markdownLineEnding(GA) ? (c = BA, RA(GA)) : (o.consume(GA), BA);
  }
  function QA(GA) {
    return GA === 62 ? NA(GA) : BA(GA);
  }
  function EA(GA) {
    return asciiAlpha(GA) ? (o.consume(GA), oA) : A(GA);
  }
  function oA(GA) {
    return GA === 45 || asciiAlphanumeric(GA) ? (o.consume(GA), oA) : iA(GA);
  }
  function iA(GA) {
    return markdownLineEnding(GA) ? (c = iA, RA(GA)) : markdownSpace(GA) ? (o.consume(GA), iA) : NA(GA);
  }
  function aA(GA) {
    return GA === 45 || asciiAlphanumeric(GA) ? (o.consume(GA), aA) : GA === 47 || GA === 62 || markdownLineEndingOrSpace(GA) ? tA(GA) : A(GA);
  }
  function tA(GA) {
    return GA === 47 ? (o.consume(GA), NA) : GA === 58 || GA === 95 || asciiAlpha(GA) ? (o.consume(GA), eA) : markdownLineEnding(GA) ? (c = tA, RA(GA)) : markdownSpace(GA) ? (o.consume(GA), tA) : NA(GA);
  }
  function eA(GA) {
    return GA === 45 || GA === 46 || GA === 58 || GA === 95 || asciiAlphanumeric(GA) ? (o.consume(GA), eA) : cA(GA);
  }
  function cA(GA) {
    return GA === 61 ? (o.consume(GA), DA) : markdownLineEnding(GA) ? (c = cA, RA(GA)) : markdownSpace(GA) ? (o.consume(GA), cA) : tA(GA);
  }
  function DA(GA) {
    return GA === null || GA === 60 || GA === 61 || GA === 62 || GA === 96 ? A(GA) : GA === 34 || GA === 39 ? (o.consume(GA), e = GA, nA) : markdownLineEnding(GA) ? (c = DA, RA(GA)) : markdownSpace(GA) ? (o.consume(GA), DA) : (o.consume(GA), wA);
  }
  function nA(GA) {
    return GA === e ? (o.consume(GA), e = void 0, lA) : GA === null ? A(GA) : markdownLineEnding(GA) ? (c = nA, RA(GA)) : (o.consume(GA), nA);
  }
  function wA(GA) {
    return GA === null || GA === 34 || GA === 39 || GA === 60 || GA === 61 || GA === 96 ? A(GA) : GA === 47 || GA === 62 || markdownLineEndingOrSpace(GA) ? tA(GA) : (o.consume(GA), wA);
  }
  function lA(GA) {
    return GA === 47 || GA === 62 || markdownLineEndingOrSpace(GA) ? tA(GA) : A(GA);
  }
  function NA(GA) {
    return GA === 62 ? (o.consume(GA), o.exit("htmlTextData"), o.exit("htmlText"), E) : A(GA);
  }
  function RA(GA) {
    return o.exit("htmlTextData"), o.enter("lineEnding"), o.consume(GA), o.exit("lineEnding"), KA;
  }
  function KA(GA) {
    return markdownSpace(GA) ? factorySpace(o, vA, "linePrefix", g.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(GA) : vA(GA);
  }
  function vA(GA) {
    return o.enter("htmlTextData"), c(GA);
  }
}
const labelEnd = {
  name: "labelEnd",
  resolveAll: resolveAllLabelEnd,
  resolveTo: resolveToLabelEnd,
  tokenize: tokenizeLabelEnd
}, resourceConstruct = {
  tokenize: tokenizeResource
}, referenceFullConstruct = {
  tokenize: tokenizeReferenceFull
}, referenceCollapsedConstruct = {
  tokenize: tokenizeReferenceCollapsed
};
function resolveAllLabelEnd(o) {
  let E = -1;
  const A = [];
  for (; ++E < o.length; ) {
    const g = o[E][1];
    if (A.push(o[E]), g.type === "labelImage" || g.type === "labelLink" || g.type === "labelEnd") {
      const e = g.type === "labelImage" ? 4 : 2;
      g.type = "data", E += e;
    }
  }
  return o.length !== A.length && splice(o, 0, o.length, A), o;
}
function resolveToLabelEnd(o, E) {
  let A = o.length, g = 0, e, t, c, n;
  for (; A--; )
    if (e = o[A][1], t) {
      if (e.type === "link" || e.type === "labelLink" && e._inactive)
        break;
      o[A][0] === "enter" && e.type === "labelLink" && (e._inactive = !0);
    } else if (c) {
      if (o[A][0] === "enter" && (e.type === "labelImage" || e.type === "labelLink") && !e._balanced && (t = A, e.type !== "labelLink")) {
        g = 2;
        break;
      }
    } else e.type === "labelEnd" && (c = A);
  const h = {
    type: o[t][1].type === "labelLink" ? "link" : "image",
    start: {
      ...o[t][1].start
    },
    end: {
      ...o[o.length - 1][1].end
    }
  }, d = {
    type: "label",
    start: {
      ...o[t][1].start
    },
    end: {
      ...o[c][1].end
    }
  }, k = {
    type: "labelText",
    start: {
      ...o[t + g + 2][1].end
    },
    end: {
      ...o[c - 2][1].start
    }
  };
  return n = [["enter", h, E], ["enter", d, E]], n = push(n, o.slice(t + 1, t + g + 3)), n = push(n, [["enter", k, E]]), n = push(n, resolveAll(E.parser.constructs.insideSpan.null, o.slice(t + g + 4, c - 3), E)), n = push(n, [["exit", k, E], o[c - 2], o[c - 1], ["exit", d, E]]), n = push(n, o.slice(c + 1)), n = push(n, [["exit", h, E]]), splice(o, t, o.length, n), o;
}
function tokenizeLabelEnd(o, E, A) {
  const g = this;
  let e = g.events.length, t, c;
  for (; e--; )
    if ((g.events[e][1].type === "labelImage" || g.events[e][1].type === "labelLink") && !g.events[e][1]._balanced) {
      t = g.events[e][1];
      break;
    }
  return n;
  function n(M) {
    return t ? t._inactive ? p(M) : (c = g.parser.defined.includes(normalizeIdentifier(g.sliceSerialize({
      start: t.end,
      end: g.now()
    }))), o.enter("labelEnd"), o.enter("labelMarker"), o.consume(M), o.exit("labelMarker"), o.exit("labelEnd"), h) : A(M);
  }
  function h(M) {
    return M === 40 ? o.attempt(resourceConstruct, k, c ? k : p)(M) : M === 91 ? o.attempt(referenceFullConstruct, k, c ? d : p)(M) : c ? k(M) : p(M);
  }
  function d(M) {
    return o.attempt(referenceCollapsedConstruct, k, p)(M);
  }
  function k(M) {
    return E(M);
  }
  function p(M) {
    return t._balanced = !0, A(M);
  }
}
function tokenizeResource(o, E, A) {
  return g;
  function g(p) {
    return o.enter("resource"), o.enter("resourceMarker"), o.consume(p), o.exit("resourceMarker"), e;
  }
  function e(p) {
    return markdownLineEndingOrSpace(p) ? factoryWhitespace(o, t)(p) : t(p);
  }
  function t(p) {
    return p === 41 ? k(p) : factoryDestination(o, c, n, "resourceDestination", "resourceDestinationLiteral", "resourceDestinationLiteralMarker", "resourceDestinationRaw", "resourceDestinationString", 32)(p);
  }
  function c(p) {
    return markdownLineEndingOrSpace(p) ? factoryWhitespace(o, h)(p) : k(p);
  }
  function n(p) {
    return A(p);
  }
  function h(p) {
    return p === 34 || p === 39 || p === 40 ? factoryTitle(o, d, A, "resourceTitle", "resourceTitleMarker", "resourceTitleString")(p) : k(p);
  }
  function d(p) {
    return markdownLineEndingOrSpace(p) ? factoryWhitespace(o, k)(p) : k(p);
  }
  function k(p) {
    return p === 41 ? (o.enter("resourceMarker"), o.consume(p), o.exit("resourceMarker"), o.exit("resource"), E) : A(p);
  }
}
function tokenizeReferenceFull(o, E, A) {
  const g = this;
  return e;
  function e(n) {
    return factoryLabel$1.call(g, o, t, c, "reference", "referenceMarker", "referenceString")(n);
  }
  function t(n) {
    return g.parser.defined.includes(normalizeIdentifier(g.sliceSerialize(g.events[g.events.length - 1][1]).slice(1, -1))) ? E(n) : A(n);
  }
  function c(n) {
    return A(n);
  }
}
function tokenizeReferenceCollapsed(o, E, A) {
  return g;
  function g(t) {
    return o.enter("reference"), o.enter("referenceMarker"), o.consume(t), o.exit("referenceMarker"), e;
  }
  function e(t) {
    return t === 93 ? (o.enter("referenceMarker"), o.consume(t), o.exit("referenceMarker"), o.exit("reference"), E) : A(t);
  }
}
const labelStartImage = {
  name: "labelStartImage",
  resolveAll: labelEnd.resolveAll,
  tokenize: tokenizeLabelStartImage
};
function tokenizeLabelStartImage(o, E, A) {
  const g = this;
  return e;
  function e(n) {
    return o.enter("labelImage"), o.enter("labelImageMarker"), o.consume(n), o.exit("labelImageMarker"), t;
  }
  function t(n) {
    return n === 91 ? (o.enter("labelMarker"), o.consume(n), o.exit("labelMarker"), o.exit("labelImage"), c) : A(n);
  }
  function c(n) {
    return n === 94 && "_hiddenFootnoteSupport" in g.parser.constructs ? A(n) : E(n);
  }
}
const labelStartLink = {
  name: "labelStartLink",
  resolveAll: labelEnd.resolveAll,
  tokenize: tokenizeLabelStartLink
};
function tokenizeLabelStartLink(o, E, A) {
  const g = this;
  return e;
  function e(c) {
    return o.enter("labelLink"), o.enter("labelMarker"), o.consume(c), o.exit("labelMarker"), o.exit("labelLink"), t;
  }
  function t(c) {
    return c === 94 && "_hiddenFootnoteSupport" in g.parser.constructs ? A(c) : E(c);
  }
}
const lineEnding = {
  name: "lineEnding",
  tokenize: tokenizeLineEnding
};
function tokenizeLineEnding(o, E) {
  return A;
  function A(g) {
    return o.enter("lineEnding"), o.consume(g), o.exit("lineEnding"), factorySpace(o, E, "linePrefix");
  }
}
const thematicBreak$2 = {
  name: "thematicBreak",
  tokenize: tokenizeThematicBreak
};
function tokenizeThematicBreak(o, E, A) {
  let g = 0, e;
  return t;
  function t(d) {
    return o.enter("thematicBreak"), c(d);
  }
  function c(d) {
    return e = d, n(d);
  }
  function n(d) {
    return d === e ? (o.enter("thematicBreakSequence"), h(d)) : g >= 3 && (d === null || markdownLineEnding(d)) ? (o.exit("thematicBreak"), E(d)) : A(d);
  }
  function h(d) {
    return d === e ? (o.consume(d), g++, h) : (o.exit("thematicBreakSequence"), markdownSpace(d) ? factorySpace(o, n, "whitespace")(d) : n(d));
  }
}
const list$2 = {
  continuation: {
    tokenize: tokenizeListContinuation
  },
  exit: tokenizeListEnd,
  name: "list",
  tokenize: tokenizeListStart
}, listItemPrefixWhitespaceConstruct = {
  partial: !0,
  tokenize: tokenizeListItemPrefixWhitespace
}, indentConstruct = {
  partial: !0,
  tokenize: tokenizeIndent$1
};
function tokenizeListStart(o, E, A) {
  const g = this, e = g.events[g.events.length - 1];
  let t = e && e[1].type === "linePrefix" ? e[2].sliceSerialize(e[1], !0).length : 0, c = 0;
  return n;
  function n(S) {
    const AA = g.containerState.type || (S === 42 || S === 43 || S === 45 ? "listUnordered" : "listOrdered");
    if (AA === "listUnordered" ? !g.containerState.marker || S === g.containerState.marker : asciiDigit(S)) {
      if (g.containerState.type || (g.containerState.type = AA, o.enter(AA, {
        _container: !0
      })), AA === "listUnordered")
        return o.enter("listItemPrefix"), S === 42 || S === 45 ? o.check(thematicBreak$2, A, d)(S) : d(S);
      if (!g.interrupt || S === 49)
        return o.enter("listItemPrefix"), o.enter("listItemValue"), h(S);
    }
    return A(S);
  }
  function h(S) {
    return asciiDigit(S) && ++c < 10 ? (o.consume(S), h) : (!g.interrupt || c < 2) && (g.containerState.marker ? S === g.containerState.marker : S === 41 || S === 46) ? (o.exit("listItemValue"), d(S)) : A(S);
  }
  function d(S) {
    return o.enter("listItemMarker"), o.consume(S), o.exit("listItemMarker"), g.containerState.marker = g.containerState.marker || S, o.check(
      blankLine,
      // Can’t be empty when interrupting.
      g.interrupt ? A : k,
      o.attempt(listItemPrefixWhitespaceConstruct, M, p)
    );
  }
  function k(S) {
    return g.containerState.initialBlankLine = !0, t++, M(S);
  }
  function p(S) {
    return markdownSpace(S) ? (o.enter("listItemPrefixWhitespace"), o.consume(S), o.exit("listItemPrefixWhitespace"), M) : A(S);
  }
  function M(S) {
    return g.containerState.size = t + g.sliceSerialize(o.exit("listItemPrefix"), !0).length, E(S);
  }
}
function tokenizeListContinuation(o, E, A) {
  const g = this;
  return g.containerState._closeFlow = void 0, o.check(blankLine, e, t);
  function e(n) {
    return g.containerState.furtherBlankLines = g.containerState.furtherBlankLines || g.containerState.initialBlankLine, factorySpace(o, E, "listItemIndent", g.containerState.size + 1)(n);
  }
  function t(n) {
    return g.containerState.furtherBlankLines || !markdownSpace(n) ? (g.containerState.furtherBlankLines = void 0, g.containerState.initialBlankLine = void 0, c(n)) : (g.containerState.furtherBlankLines = void 0, g.containerState.initialBlankLine = void 0, o.attempt(indentConstruct, E, c)(n));
  }
  function c(n) {
    return g.containerState._closeFlow = !0, g.interrupt = void 0, factorySpace(o, o.attempt(list$2, E, A), "linePrefix", g.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(n);
  }
}
function tokenizeIndent$1(o, E, A) {
  const g = this;
  return factorySpace(o, e, "listItemIndent", g.containerState.size + 1);
  function e(t) {
    const c = g.events[g.events.length - 1];
    return c && c[1].type === "listItemIndent" && c[2].sliceSerialize(c[1], !0).length === g.containerState.size ? E(t) : A(t);
  }
}
function tokenizeListEnd(o) {
  o.exit(this.containerState.type);
}
function tokenizeListItemPrefixWhitespace(o, E, A) {
  const g = this;
  return factorySpace(o, e, "listItemPrefixWhitespace", g.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 5);
  function e(t) {
    const c = g.events[g.events.length - 1];
    return !markdownSpace(t) && c && c[1].type === "listItemPrefixWhitespace" ? E(t) : A(t);
  }
}
const setextUnderline = {
  name: "setextUnderline",
  resolveTo: resolveToSetextUnderline,
  tokenize: tokenizeSetextUnderline
};
function resolveToSetextUnderline(o, E) {
  let A = o.length, g, e, t;
  for (; A--; )
    if (o[A][0] === "enter") {
      if (o[A][1].type === "content") {
        g = A;
        break;
      }
      o[A][1].type === "paragraph" && (e = A);
    } else
      o[A][1].type === "content" && o.splice(A, 1), !t && o[A][1].type === "definition" && (t = A);
  const c = {
    type: "setextHeading",
    start: {
      ...o[g][1].start
    },
    end: {
      ...o[o.length - 1][1].end
    }
  };
  return o[e][1].type = "setextHeadingText", t ? (o.splice(e, 0, ["enter", c, E]), o.splice(t + 1, 0, ["exit", o[g][1], E]), o[g][1].end = {
    ...o[t][1].end
  }) : o[g][1] = c, o.push(["exit", c, E]), o;
}
function tokenizeSetextUnderline(o, E, A) {
  const g = this;
  let e;
  return t;
  function t(d) {
    let k = g.events.length, p;
    for (; k--; )
      if (g.events[k][1].type !== "lineEnding" && g.events[k][1].type !== "linePrefix" && g.events[k][1].type !== "content") {
        p = g.events[k][1].type === "paragraph";
        break;
      }
    return !g.parser.lazy[g.now().line] && (g.interrupt || p) ? (o.enter("setextHeadingLine"), e = d, c(d)) : A(d);
  }
  function c(d) {
    return o.enter("setextHeadingLineSequence"), n(d);
  }
  function n(d) {
    return d === e ? (o.consume(d), n) : (o.exit("setextHeadingLineSequence"), markdownSpace(d) ? factorySpace(o, h, "lineSuffix")(d) : h(d));
  }
  function h(d) {
    return d === null || markdownLineEnding(d) ? (o.exit("setextHeadingLine"), E(d)) : A(d);
  }
}
const flow$1 = {
  tokenize: initializeFlow
};
function initializeFlow(o) {
  const E = this, A = o.attempt(
    // Try to parse a blank line.
    blankLine,
    g,
    // Try to parse initial flow (essentially, only code).
    o.attempt(this.parser.constructs.flowInitial, e, factorySpace(o, o.attempt(this.parser.constructs.flow, e, o.attempt(content, e)), "linePrefix"))
  );
  return A;
  function g(t) {
    if (t === null) {
      o.consume(t);
      return;
    }
    return o.enter("lineEndingBlank"), o.consume(t), o.exit("lineEndingBlank"), E.currentConstruct = void 0, A;
  }
  function e(t) {
    if (t === null) {
      o.consume(t);
      return;
    }
    return o.enter("lineEnding"), o.consume(t), o.exit("lineEnding"), E.currentConstruct = void 0, A;
  }
}
const resolver = {
  resolveAll: createResolver()
}, string$1 = initializeFactory("string"), text$5 = initializeFactory("text");
function initializeFactory(o) {
  return {
    resolveAll: createResolver(o === "text" ? resolveAllLineSuffixes : void 0),
    tokenize: E
  };
  function E(A) {
    const g = this, e = this.parser.constructs[o], t = A.attempt(e, c, n);
    return c;
    function c(k) {
      return d(k) ? t(k) : n(k);
    }
    function n(k) {
      if (k === null) {
        A.consume(k);
        return;
      }
      return A.enter("data"), A.consume(k), h;
    }
    function h(k) {
      return d(k) ? (A.exit("data"), t(k)) : (A.consume(k), h);
    }
    function d(k) {
      if (k === null)
        return !0;
      const p = e[k];
      let M = -1;
      if (p)
        for (; ++M < p.length; ) {
          const S = p[M];
          if (!S.previous || S.previous.call(g, g.previous))
            return !0;
        }
      return !1;
    }
  }
}
function createResolver(o) {
  return E;
  function E(A, g) {
    let e = -1, t;
    for (; ++e <= A.length; )
      t === void 0 ? A[e] && A[e][1].type === "data" && (t = e, e++) : (!A[e] || A[e][1].type !== "data") && (e !== t + 2 && (A[t][1].end = A[e - 1][1].end, A.splice(t + 2, e - t - 2), e = t + 2), t = void 0);
    return o ? o(A, g) : A;
  }
}
function resolveAllLineSuffixes(o, E) {
  let A = 0;
  for (; ++A <= o.length; )
    if ((A === o.length || o[A][1].type === "lineEnding") && o[A - 1][1].type === "data") {
      const g = o[A - 1][1], e = E.sliceStream(g);
      let t = e.length, c = -1, n = 0, h;
      for (; t--; ) {
        const d = e[t];
        if (typeof d == "string") {
          for (c = d.length; d.charCodeAt(c - 1) === 32; )
            n++, c--;
          if (c) break;
          c = -1;
        } else if (d === -2)
          h = !0, n++;
        else if (d !== -1) {
          t++;
          break;
        }
      }
      if (E._contentTypeTextTrailing && A === o.length && (n = 0), n) {
        const d = {
          type: A === o.length || h || n < 2 ? "lineSuffix" : "hardBreakTrailing",
          start: {
            _bufferIndex: t ? c : g.start._bufferIndex + c,
            _index: g.start._index + t,
            line: g.end.line,
            column: g.end.column - n,
            offset: g.end.offset - n
          },
          end: {
            ...g.end
          }
        };
        g.end = {
          ...d.start
        }, g.start.offset === g.end.offset ? Object.assign(g, d) : (o.splice(A, 0, ["enter", d, E], ["exit", d, E]), A += 2);
      }
      A++;
    }
  return o;
}
const document$1 = {
  42: list$2,
  43: list$2,
  45: list$2,
  48: list$2,
  49: list$2,
  50: list$2,
  51: list$2,
  52: list$2,
  53: list$2,
  54: list$2,
  55: list$2,
  56: list$2,
  57: list$2,
  62: blockQuote
}, contentInitial = {
  91: definition$1
}, flowInitial = {
  [-2]: codeIndented,
  [-1]: codeIndented,
  32: codeIndented
}, flow = {
  35: headingAtx,
  42: thematicBreak$2,
  45: [setextUnderline, thematicBreak$2],
  60: htmlFlow,
  61: setextUnderline,
  95: thematicBreak$2,
  96: codeFenced,
  126: codeFenced
}, string = {
  38: characterReference,
  92: characterEscape
}, text$4 = {
  [-5]: lineEnding,
  [-4]: lineEnding,
  [-3]: lineEnding,
  33: labelStartImage,
  38: characterReference,
  42: attention,
  60: [autolink, htmlText],
  91: labelStartLink,
  92: [hardBreakEscape, characterEscape],
  93: labelEnd,
  95: attention,
  96: codeText
}, insideSpan = {
  null: [attention, resolver]
}, attentionMarkers = {
  null: [42, 95]
}, disable = {
  null: []
}, defaultConstructs = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  attentionMarkers,
  contentInitial,
  disable,
  document: document$1,
  flow,
  flowInitial,
  insideSpan,
  string,
  text: text$4
}, Symbol.toStringTag, { value: "Module" }));
function createTokenizer(o, E, A) {
  let g = {
    _bufferIndex: -1,
    _index: 0,
    line: A && A.line || 1,
    column: A && A.column || 1,
    offset: A && A.offset || 0
  };
  const e = {}, t = [];
  let c = [], n = [];
  const h = {
    attempt: iA(EA),
    check: iA(oA),
    consume: IA,
    enter: BA,
    exit: QA,
    interrupt: iA(oA, {
      interrupt: !0
    })
  }, d = {
    code: null,
    containerState: {},
    defineSkip: H,
    events: [],
    now: AA,
    parser: o,
    previous: null,
    sliceSerialize: M,
    sliceStream: S,
    write: p
  };
  let k = E.tokenize.call(d, h);
  return E.resolveAll && t.push(E), d;
  function p(cA) {
    return c = push(c, cA), gA(), c[c.length - 1] !== null ? [] : (aA(E, 0), d.events = resolveAll(t, d.events, d), d.events);
  }
  function M(cA, DA) {
    return serializeChunks(S(cA), DA);
  }
  function S(cA) {
    return sliceChunks(c, cA);
  }
  function AA() {
    const {
      _bufferIndex: cA,
      _index: DA,
      line: nA,
      column: wA,
      offset: lA
    } = g;
    return {
      _bufferIndex: cA,
      _index: DA,
      line: nA,
      column: wA,
      offset: lA
    };
  }
  function H(cA) {
    e[cA.line] = cA.column, eA();
  }
  function gA() {
    let cA;
    for (; g._index < c.length; ) {
      const DA = c[g._index];
      if (typeof DA == "string")
        for (cA = g._index, g._bufferIndex < 0 && (g._bufferIndex = 0); g._index === cA && g._bufferIndex < DA.length; )
          CA(DA.charCodeAt(g._bufferIndex));
      else
        CA(DA);
    }
  }
  function CA(cA) {
    k = k(cA);
  }
  function IA(cA) {
    markdownLineEnding(cA) ? (g.line++, g.column = 1, g.offset += cA === -3 ? 2 : 1, eA()) : cA !== -1 && (g.column++, g.offset++), g._bufferIndex < 0 ? g._index++ : (g._bufferIndex++, g._bufferIndex === // Points w/ non-negative `_bufferIndex` reference
    // strings.
    /** @type {string} */
    c[g._index].length && (g._bufferIndex = -1, g._index++)), d.previous = cA;
  }
  function BA(cA, DA) {
    const nA = DA || {};
    return nA.type = cA, nA.start = AA(), d.events.push(["enter", nA, d]), n.push(nA), nA;
  }
  function QA(cA) {
    const DA = n.pop();
    return DA.end = AA(), d.events.push(["exit", DA, d]), DA;
  }
  function EA(cA, DA) {
    aA(cA, DA.from);
  }
  function oA(cA, DA) {
    DA.restore();
  }
  function iA(cA, DA) {
    return nA;
    function nA(wA, lA, NA) {
      let RA, KA, vA, GA;
      return Array.isArray(wA) ? (
        /* c8 ignore next 1 */
        HA(wA)
      ) : "tokenize" in wA ? (
        // Looks like a construct.
        HA([
          /** @type {Construct} */
          wA
        ])
      ) : FA(wA);
      function FA(hA) {
        return MA;
        function MA(YA) {
          const LA = YA !== null && hA[YA], WA = YA !== null && hA.null, zA = [
            // To do: add more extension tests.
            /* c8 ignore next 2 */
            ...Array.isArray(LA) ? LA : LA ? [LA] : [],
            ...Array.isArray(WA) ? WA : WA ? [WA] : []
          ];
          return HA(zA)(YA);
        }
      }
      function HA(hA) {
        return RA = hA, KA = 0, hA.length === 0 ? NA : sA(hA[KA]);
      }
      function sA(hA) {
        return MA;
        function MA(YA) {
          return GA = tA(), vA = hA, hA.partial || (d.currentConstruct = hA), hA.name && d.parser.constructs.disable.null.includes(hA.name) ? xA() : hA.tokenize.call(
            // If we do have fields, create an object w/ `context` as its
            // prototype.
            // This allows a “live binding”, which is needed for `interrupt`.
            DA ? Object.assign(Object.create(d), DA) : d,
            h,
            mA,
            xA
          )(YA);
        }
      }
      function mA(hA) {
        return cA(vA, GA), lA;
      }
      function xA(hA) {
        return GA.restore(), ++KA < RA.length ? sA(RA[KA]) : NA;
      }
    }
  }
  function aA(cA, DA) {
    cA.resolveAll && !t.includes(cA) && t.push(cA), cA.resolve && splice(d.events, DA, d.events.length - DA, cA.resolve(d.events.slice(DA), d)), cA.resolveTo && (d.events = cA.resolveTo(d.events, d));
  }
  function tA() {
    const cA = AA(), DA = d.previous, nA = d.currentConstruct, wA = d.events.length, lA = Array.from(n);
    return {
      from: wA,
      restore: NA
    };
    function NA() {
      g = cA, d.previous = DA, d.currentConstruct = nA, d.events.length = wA, n = lA, eA();
    }
  }
  function eA() {
    g.line in e && g.column < 2 && (g.column = e[g.line], g.offset += e[g.line] - 1);
  }
}
function sliceChunks(o, E) {
  const A = E.start._index, g = E.start._bufferIndex, e = E.end._index, t = E.end._bufferIndex;
  let c;
  if (A === e)
    c = [o[A].slice(g, t)];
  else {
    if (c = o.slice(A, e), g > -1) {
      const n = c[0];
      typeof n == "string" ? c[0] = n.slice(g) : c.shift();
    }
    t > 0 && c.push(o[e].slice(0, t));
  }
  return c;
}
function serializeChunks(o, E) {
  let A = -1;
  const g = [];
  let e;
  for (; ++A < o.length; ) {
    const t = o[A];
    let c;
    if (typeof t == "string")
      c = t;
    else switch (t) {
      case -5: {
        c = "\r";
        break;
      }
      case -4: {
        c = `
`;
        break;
      }
      case -3: {
        c = `\r
`;
        break;
      }
      case -2: {
        c = E ? " " : "	";
        break;
      }
      case -1: {
        if (!E && e) continue;
        c = " ";
        break;
      }
      default:
        c = String.fromCharCode(t);
    }
    e = t === -2, g.push(c);
  }
  return g.join("");
}
function parse(o) {
  const g = {
    constructs: (
      /** @type {FullNormalizedExtension} */
      combineExtensions([defaultConstructs, ...(o || {}).extensions || []])
    ),
    content: e(content$1),
    defined: [],
    document: e(document$2),
    flow: e(flow$1),
    lazy: {},
    string: e(string$1),
    text: e(text$5)
  };
  return g;
  function e(t) {
    return c;
    function c(n) {
      return createTokenizer(g, t, n);
    }
  }
}
function postprocess(o) {
  for (; !subtokenize(o); )
    ;
  return o;
}
const search = /[\0\t\n\r]/g;
function preprocess() {
  let o = 1, E = "", A = !0, g;
  return e;
  function e(t, c, n) {
    const h = [];
    let d, k, p, M, S;
    for (t = E + (typeof t == "string" ? t.toString() : new TextDecoder(c || void 0).decode(t)), p = 0, E = "", A && (t.charCodeAt(0) === 65279 && p++, A = void 0); p < t.length; ) {
      if (search.lastIndex = p, d = search.exec(t), M = d && d.index !== void 0 ? d.index : t.length, S = t.charCodeAt(M), !d) {
        E = t.slice(p);
        break;
      }
      if (S === 10 && p === M && g)
        h.push(-3), g = void 0;
      else
        switch (g && (h.push(-5), g = void 0), p < M && (h.push(t.slice(p, M)), o += M - p), S) {
          case 0: {
            h.push(65533), o++;
            break;
          }
          case 9: {
            for (k = Math.ceil(o / 4) * 4, h.push(-2); o++ < k; ) h.push(-1);
            break;
          }
          case 10: {
            h.push(-4), o = 1;
            break;
          }
          default:
            g = !0, o = 1;
        }
      p = M + 1;
    }
    return n && (g && h.push(-5), E && h.push(E), h.push(null)), h;
  }
}
const characterEscapeOrReference = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function decodeString(o) {
  return o.replace(characterEscapeOrReference, decode);
}
function decode(o, E, A) {
  if (E)
    return E;
  if (A.charCodeAt(0) === 35) {
    const e = A.charCodeAt(1), t = e === 120 || e === 88;
    return decodeNumericCharacterReference(A.slice(t ? 2 : 1), t ? 16 : 10);
  }
  return decodeNamedCharacterReference(A) || o;
}
const own$3 = {}.hasOwnProperty;
function fromMarkdown(o, E, A) {
  return typeof E != "string" && (A = E, E = void 0), compiler(A)(postprocess(parse(A).document().write(preprocess()(o, E, !0))));
}
function compiler(o) {
  const E = {
    transforms: [],
    canContainEols: ["emphasis", "fragment", "heading", "paragraph", "strong"],
    enter: {
      autolink: t(gg),
      autolinkProtocol: tA,
      autolinkEmail: tA,
      atxHeading: t(ig),
      blockQuote: t(WA),
      characterEscape: tA,
      characterReference: tA,
      codeFenced: t(zA),
      codeFencedFenceInfo: c,
      codeFencedFenceMeta: c,
      codeIndented: t(zA, c),
      codeText: t(ZA, c),
      codeTextData: tA,
      data: tA,
      codeFlowValue: tA,
      definition: t(Ag),
      definitionDestinationString: c,
      definitionLabelString: c,
      definitionTitleString: c,
      emphasis: t(UA),
      hardBreakEscape: t(og),
      hardBreakTrailing: t(og),
      htmlFlow: t(PA, c),
      htmlFlowData: tA,
      htmlText: t(PA, c),
      htmlTextData: tA,
      image: t(Gg),
      label: c,
      link: t(gg),
      listItem: t(Dg),
      listItemValue: M,
      listOrdered: t(eg, p),
      listUnordered: t(eg),
      paragraph: t(rg),
      reference: sA,
      referenceString: c,
      resourceDestinationString: c,
      resourceTitleString: c,
      setextHeading: t(ig),
      strong: t(cg),
      thematicBreak: t(Cg)
    },
    exit: {
      atxHeading: h(),
      atxHeadingSequence: EA,
      autolink: h(),
      autolinkEmail: LA,
      autolinkProtocol: YA,
      blockQuote: h(),
      characterEscapeValue: eA,
      characterReferenceMarkerHexadecimal: xA,
      characterReferenceMarkerNumeric: xA,
      characterReferenceValue: hA,
      characterReference: MA,
      codeFenced: h(gA),
      codeFencedFence: H,
      codeFencedFenceInfo: S,
      codeFencedFenceMeta: AA,
      codeFlowValue: eA,
      codeIndented: h(CA),
      codeText: h(lA),
      codeTextData: eA,
      data: eA,
      definition: h(),
      definitionDestinationString: QA,
      definitionLabelString: IA,
      definitionTitleString: BA,
      emphasis: h(),
      hardBreakEscape: h(DA),
      hardBreakTrailing: h(DA),
      htmlFlow: h(nA),
      htmlFlowData: eA,
      htmlText: h(wA),
      htmlTextData: eA,
      image: h(RA),
      label: vA,
      labelText: KA,
      lineEnding: cA,
      link: h(NA),
      listItem: h(),
      listOrdered: h(),
      listUnordered: h(),
      paragraph: h(),
      referenceString: mA,
      resourceDestinationString: GA,
      resourceTitleString: FA,
      resource: HA,
      setextHeading: h(aA),
      setextHeadingLineSequence: iA,
      setextHeadingText: oA,
      strong: h(),
      thematicBreak: h()
    }
  };
  configure(E, (o || {}).mdastExtensions || []);
  const A = {};
  return g;
  function g(dA) {
    let pA = {
      type: "root",
      children: []
    };
    const XA = {
      stack: [pA],
      tokenStack: [],
      config: E,
      enter: n,
      exit: d,
      buffer: c,
      resume: k,
      data: A
    }, jA = [];
    let OA = -1;
    for (; ++OA < dA.length; )
      if (dA[OA][1].type === "listOrdered" || dA[OA][1].type === "listUnordered")
        if (dA[OA][0] === "enter")
          jA.push(OA);
        else {
          const VA = jA.pop();
          OA = e(dA, VA, OA);
        }
    for (OA = -1; ++OA < dA.length; ) {
      const VA = E[dA[OA][0]];
      own$3.call(VA, dA[OA][1].type) && VA[dA[OA][1].type].call(Object.assign({
        sliceSerialize: dA[OA][2].sliceSerialize
      }, XA), dA[OA][1]);
    }
    if (XA.tokenStack.length > 0) {
      const VA = XA.tokenStack[XA.tokenStack.length - 1];
      (VA[1] || defaultOnError).call(XA, void 0, VA[0]);
    }
    for (pA.position = {
      start: point(dA.length > 0 ? dA[0][1].start : {
        line: 1,
        column: 1,
        offset: 0
      }),
      end: point(dA.length > 0 ? dA[dA.length - 2][1].end : {
        line: 1,
        column: 1,
        offset: 0
      })
    }, OA = -1; ++OA < E.transforms.length; )
      pA = E.transforms[OA](pA) || pA;
    return pA;
  }
  function e(dA, pA, XA) {
    let jA = pA - 1, OA = -1, VA = !1, $A, fA, yA, bA;
    for (; ++jA <= XA; ) {
      const kA = dA[jA];
      switch (kA[1].type) {
        case "listUnordered":
        case "listOrdered":
        case "blockQuote": {
          kA[0] === "enter" ? OA++ : OA--, bA = void 0;
          break;
        }
        case "lineEndingBlank": {
          kA[0] === "enter" && ($A && !bA && !OA && !yA && (yA = jA), bA = void 0);
          break;
        }
        case "linePrefix":
        case "listItemValue":
        case "listItemMarker":
        case "listItemPrefix":
        case "listItemPrefixWhitespace":
          break;
        default:
          bA = void 0;
      }
      if (!OA && kA[0] === "enter" && kA[1].type === "listItemPrefix" || OA === -1 && kA[0] === "exit" && (kA[1].type === "listUnordered" || kA[1].type === "listOrdered")) {
        if ($A) {
          let JA = jA;
          for (fA = void 0; JA--; ) {
            const uA = dA[JA];
            if (uA[1].type === "lineEnding" || uA[1].type === "lineEndingBlank") {
              if (uA[0] === "exit") continue;
              fA && (dA[fA][1].type = "lineEndingBlank", VA = !0), uA[1].type = "lineEnding", fA = JA;
            } else if (!(uA[1].type === "linePrefix" || uA[1].type === "blockQuotePrefix" || uA[1].type === "blockQuotePrefixWhitespace" || uA[1].type === "blockQuoteMarker" || uA[1].type === "listItemIndent")) break;
          }
          yA && (!fA || yA < fA) && ($A._spread = !0), $A.end = Object.assign({}, fA ? dA[fA][1].start : kA[1].end), dA.splice(fA || jA, 0, ["exit", $A, kA[2]]), jA++, XA++;
        }
        if (kA[1].type === "listItemPrefix") {
          const JA = {
            type: "listItem",
            _spread: !1,
            start: Object.assign({}, kA[1].start),
            // @ts-expect-error: we’ll add `end` in a second.
            end: void 0
          };
          $A = JA, dA.splice(jA, 0, ["enter", JA, kA[2]]), jA++, XA++, yA = void 0, bA = !0;
        }
      }
    }
    return dA[pA][1]._spread = VA, XA;
  }
  function t(dA, pA) {
    return XA;
    function XA(jA) {
      n.call(this, dA(jA), jA), pA && pA.call(this, jA);
    }
  }
  function c() {
    this.stack.push({
      type: "fragment",
      children: []
    });
  }
  function n(dA, pA, XA) {
    this.stack[this.stack.length - 1].children.push(dA), this.stack.push(dA), this.tokenStack.push([pA, XA || void 0]), dA.position = {
      start: point(pA.start),
      // @ts-expect-error: `end` will be patched later.
      end: void 0
    };
  }
  function h(dA) {
    return pA;
    function pA(XA) {
      dA && dA.call(this, XA), d.call(this, XA);
    }
  }
  function d(dA, pA) {
    const XA = this.stack.pop(), jA = this.tokenStack.pop();
    if (jA)
      jA[0].type !== dA.type && (pA ? pA.call(this, dA, jA[0]) : (jA[1] || defaultOnError).call(this, dA, jA[0]));
    else throw new Error("Cannot close `" + dA.type + "` (" + stringifyPosition({
      start: dA.start,
      end: dA.end
    }) + "): it’s not open");
    XA.position.end = point(dA.end);
  }
  function k() {
    return toString$2(this.stack.pop());
  }
  function p() {
    this.data.expectingFirstListItemValue = !0;
  }
  function M(dA) {
    if (this.data.expectingFirstListItemValue) {
      const pA = this.stack[this.stack.length - 2];
      pA.start = Number.parseInt(this.sliceSerialize(dA), 10), this.data.expectingFirstListItemValue = void 0;
    }
  }
  function S() {
    const dA = this.resume(), pA = this.stack[this.stack.length - 1];
    pA.lang = dA;
  }
  function AA() {
    const dA = this.resume(), pA = this.stack[this.stack.length - 1];
    pA.meta = dA;
  }
  function H() {
    this.data.flowCodeInside || (this.buffer(), this.data.flowCodeInside = !0);
  }
  function gA() {
    const dA = this.resume(), pA = this.stack[this.stack.length - 1];
    pA.value = dA.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, ""), this.data.flowCodeInside = void 0;
  }
  function CA() {
    const dA = this.resume(), pA = this.stack[this.stack.length - 1];
    pA.value = dA.replace(/(\r?\n|\r)$/g, "");
  }
  function IA(dA) {
    const pA = this.resume(), XA = this.stack[this.stack.length - 1];
    XA.label = pA, XA.identifier = normalizeIdentifier(this.sliceSerialize(dA)).toLowerCase();
  }
  function BA() {
    const dA = this.resume(), pA = this.stack[this.stack.length - 1];
    pA.title = dA;
  }
  function QA() {
    const dA = this.resume(), pA = this.stack[this.stack.length - 1];
    pA.url = dA;
  }
  function EA(dA) {
    const pA = this.stack[this.stack.length - 1];
    if (!pA.depth) {
      const XA = this.sliceSerialize(dA).length;
      pA.depth = XA;
    }
  }
  function oA() {
    this.data.setextHeadingSlurpLineEnding = !0;
  }
  function iA(dA) {
    const pA = this.stack[this.stack.length - 1];
    pA.depth = this.sliceSerialize(dA).codePointAt(0) === 61 ? 1 : 2;
  }
  function aA() {
    this.data.setextHeadingSlurpLineEnding = void 0;
  }
  function tA(dA) {
    const XA = this.stack[this.stack.length - 1].children;
    let jA = XA[XA.length - 1];
    (!jA || jA.type !== "text") && (jA = hg(), jA.position = {
      start: point(dA.start),
      // @ts-expect-error: we’ll add `end` later.
      end: void 0
    }, XA.push(jA)), this.stack.push(jA);
  }
  function eA(dA) {
    const pA = this.stack.pop();
    pA.value += this.sliceSerialize(dA), pA.position.end = point(dA.end);
  }
  function cA(dA) {
    const pA = this.stack[this.stack.length - 1];
    if (this.data.atHardBreak) {
      const XA = pA.children[pA.children.length - 1];
      XA.position.end = point(dA.end), this.data.atHardBreak = void 0;
      return;
    }
    !this.data.setextHeadingSlurpLineEnding && E.canContainEols.includes(pA.type) && (tA.call(this, dA), eA.call(this, dA));
  }
  function DA() {
    this.data.atHardBreak = !0;
  }
  function nA() {
    const dA = this.resume(), pA = this.stack[this.stack.length - 1];
    pA.value = dA;
  }
  function wA() {
    const dA = this.resume(), pA = this.stack[this.stack.length - 1];
    pA.value = dA;
  }
  function lA() {
    const dA = this.resume(), pA = this.stack[this.stack.length - 1];
    pA.value = dA;
  }
  function NA() {
    const dA = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const pA = this.data.referenceType || "shortcut";
      dA.type += "Reference", dA.referenceType = pA, delete dA.url, delete dA.title;
    } else
      delete dA.identifier, delete dA.label;
    this.data.referenceType = void 0;
  }
  function RA() {
    const dA = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const pA = this.data.referenceType || "shortcut";
      dA.type += "Reference", dA.referenceType = pA, delete dA.url, delete dA.title;
    } else
      delete dA.identifier, delete dA.label;
    this.data.referenceType = void 0;
  }
  function KA(dA) {
    const pA = this.sliceSerialize(dA), XA = this.stack[this.stack.length - 2];
    XA.label = decodeString(pA), XA.identifier = normalizeIdentifier(pA).toLowerCase();
  }
  function vA() {
    const dA = this.stack[this.stack.length - 1], pA = this.resume(), XA = this.stack[this.stack.length - 1];
    if (this.data.inReference = !0, XA.type === "link") {
      const jA = dA.children;
      XA.children = jA;
    } else
      XA.alt = pA;
  }
  function GA() {
    const dA = this.resume(), pA = this.stack[this.stack.length - 1];
    pA.url = dA;
  }
  function FA() {
    const dA = this.resume(), pA = this.stack[this.stack.length - 1];
    pA.title = dA;
  }
  function HA() {
    this.data.inReference = void 0;
  }
  function sA() {
    this.data.referenceType = "collapsed";
  }
  function mA(dA) {
    const pA = this.resume(), XA = this.stack[this.stack.length - 1];
    XA.label = pA, XA.identifier = normalizeIdentifier(this.sliceSerialize(dA)).toLowerCase(), this.data.referenceType = "full";
  }
  function xA(dA) {
    this.data.characterReferenceType = dA.type;
  }
  function hA(dA) {
    const pA = this.sliceSerialize(dA), XA = this.data.characterReferenceType;
    let jA;
    XA ? (jA = decodeNumericCharacterReference(pA, XA === "characterReferenceMarkerNumeric" ? 10 : 16), this.data.characterReferenceType = void 0) : jA = decodeNamedCharacterReference(pA);
    const OA = this.stack[this.stack.length - 1];
    OA.value += jA;
  }
  function MA(dA) {
    const pA = this.stack.pop();
    pA.position.end = point(dA.end);
  }
  function YA(dA) {
    eA.call(this, dA);
    const pA = this.stack[this.stack.length - 1];
    pA.url = this.sliceSerialize(dA);
  }
  function LA(dA) {
    eA.call(this, dA);
    const pA = this.stack[this.stack.length - 1];
    pA.url = "mailto:" + this.sliceSerialize(dA);
  }
  function WA() {
    return {
      type: "blockquote",
      children: []
    };
  }
  function zA() {
    return {
      type: "code",
      lang: null,
      meta: null,
      value: ""
    };
  }
  function ZA() {
    return {
      type: "inlineCode",
      value: ""
    };
  }
  function Ag() {
    return {
      type: "definition",
      identifier: "",
      label: null,
      title: null,
      url: ""
    };
  }
  function UA() {
    return {
      type: "emphasis",
      children: []
    };
  }
  function ig() {
    return {
      type: "heading",
      // @ts-expect-error `depth` will be set later.
      depth: 0,
      children: []
    };
  }
  function og() {
    return {
      type: "break"
    };
  }
  function PA() {
    return {
      type: "html",
      value: ""
    };
  }
  function Gg() {
    return {
      type: "image",
      title: null,
      url: "",
      alt: null
    };
  }
  function gg() {
    return {
      type: "link",
      title: null,
      url: "",
      children: []
    };
  }
  function eg(dA) {
    return {
      type: "list",
      ordered: dA.type === "listOrdered",
      start: null,
      spread: dA._spread,
      children: []
    };
  }
  function Dg(dA) {
    return {
      type: "listItem",
      spread: dA._spread,
      checked: null,
      children: []
    };
  }
  function rg() {
    return {
      type: "paragraph",
      children: []
    };
  }
  function cg() {
    return {
      type: "strong",
      children: []
    };
  }
  function hg() {
    return {
      type: "text",
      value: ""
    };
  }
  function Cg() {
    return {
      type: "thematicBreak"
    };
  }
}
function point(o) {
  return {
    line: o.line,
    column: o.column,
    offset: o.offset
  };
}
function configure(o, E) {
  let A = -1;
  for (; ++A < E.length; ) {
    const g = E[A];
    Array.isArray(g) ? configure(o, g) : extension(o, g);
  }
}
function extension(o, E) {
  let A;
  for (A in E)
    if (own$3.call(E, A))
      switch (A) {
        case "canContainEols": {
          const g = E[A];
          g && o[A].push(...g);
          break;
        }
        case "transforms": {
          const g = E[A];
          g && o[A].push(...g);
          break;
        }
        case "enter":
        case "exit": {
          const g = E[A];
          g && Object.assign(o[A], g);
          break;
        }
      }
}
function defaultOnError(o, E) {
  throw o ? new Error("Cannot close `" + o.type + "` (" + stringifyPosition({
    start: o.start,
    end: o.end
  }) + "): a different token (`" + E.type + "`, " + stringifyPosition({
    start: E.start,
    end: E.end
  }) + ") is open") : new Error("Cannot close document, a token (`" + E.type + "`, " + stringifyPosition({
    start: E.start,
    end: E.end
  }) + ") is still open");
}
function remarkParse(o) {
  const E = this;
  E.parser = A;
  function A(g) {
    return fromMarkdown(g, {
      ...E.data("settings"),
      ...o,
      // Note: these options are not in the readme.
      // The goal is for them to be set by plugins on `data` instead of being
      // passed by users.
      extensions: E.data("micromarkExtensions") || [],
      mdastExtensions: E.data("fromMarkdownExtensions") || []
    });
  }
}
function blockquote$1(o, E) {
  const A = {
    type: "element",
    tagName: "blockquote",
    properties: {},
    children: o.wrap(o.all(E), !0)
  };
  return o.patch(E, A), o.applyData(E, A);
}
function hardBreak$1(o, E) {
  const A = { type: "element", tagName: "br", properties: {}, children: [] };
  return o.patch(E, A), [o.applyData(E, A), { type: "text", value: `
` }];
}
function code$3(o, E) {
  const A = E.value ? E.value + `
` : "", g = {};
  E.lang && (g.className = ["language-" + E.lang]);
  let e = {
    type: "element",
    tagName: "code",
    properties: g,
    children: [{ type: "text", value: A }]
  };
  return E.meta && (e.data = { meta: E.meta }), o.patch(E, e), e = o.applyData(E, e), e = { type: "element", tagName: "pre", properties: {}, children: [e] }, o.patch(E, e), e;
}
function strikethrough(o, E) {
  const A = {
    type: "element",
    tagName: "del",
    properties: {},
    children: o.all(E)
  };
  return o.patch(E, A), o.applyData(E, A);
}
function emphasis$1(o, E) {
  const A = {
    type: "element",
    tagName: "em",
    properties: {},
    children: o.all(E)
  };
  return o.patch(E, A), o.applyData(E, A);
}
function footnoteReference$1(o, E) {
  const A = typeof o.options.clobberPrefix == "string" ? o.options.clobberPrefix : "user-content-", g = String(E.identifier).toUpperCase(), e = normalizeUri(g.toLowerCase()), t = o.footnoteOrder.indexOf(g);
  let c, n = o.footnoteCounts.get(g);
  n === void 0 ? (n = 0, o.footnoteOrder.push(g), c = o.footnoteOrder.length) : c = t + 1, n += 1, o.footnoteCounts.set(g, n);
  const h = {
    type: "element",
    tagName: "a",
    properties: {
      href: "#" + A + "fn-" + e,
      id: A + "fnref-" + e + (n > 1 ? "-" + n : ""),
      dataFootnoteRef: !0,
      ariaDescribedBy: ["footnote-label"]
    },
    children: [{ type: "text", value: String(c) }]
  };
  o.patch(E, h);
  const d = {
    type: "element",
    tagName: "sup",
    properties: {},
    children: [h]
  };
  return o.patch(E, d), o.applyData(E, d);
}
function heading$1(o, E) {
  const A = {
    type: "element",
    tagName: "h" + E.depth,
    properties: {},
    children: o.all(E)
  };
  return o.patch(E, A), o.applyData(E, A);
}
function html$1(o, E) {
  if (o.options.allowDangerousHtml) {
    const A = { type: "raw", value: E.value };
    return o.patch(E, A), o.applyData(E, A);
  }
}
function revert(o, E) {
  const A = E.referenceType;
  let g = "]";
  if (A === "collapsed" ? g += "[]" : A === "full" && (g += "[" + (E.label || E.identifier) + "]"), E.type === "imageReference")
    return [{ type: "text", value: "![" + E.alt + g }];
  const e = o.all(E), t = e[0];
  t && t.type === "text" ? t.value = "[" + t.value : e.unshift({ type: "text", value: "[" });
  const c = e[e.length - 1];
  return c && c.type === "text" ? c.value += g : e.push({ type: "text", value: g }), e;
}
function imageReference$1(o, E) {
  const A = String(E.identifier).toUpperCase(), g = o.definitionById.get(A);
  if (!g)
    return revert(o, E);
  const e = { src: normalizeUri(g.url || ""), alt: E.alt };
  g.title !== null && g.title !== void 0 && (e.title = g.title);
  const t = { type: "element", tagName: "img", properties: e, children: [] };
  return o.patch(E, t), o.applyData(E, t);
}
function image$1(o, E) {
  const A = { src: normalizeUri(E.url) };
  E.alt !== null && E.alt !== void 0 && (A.alt = E.alt), E.title !== null && E.title !== void 0 && (A.title = E.title);
  const g = { type: "element", tagName: "img", properties: A, children: [] };
  return o.patch(E, g), o.applyData(E, g);
}
function inlineCode$1(o, E) {
  const A = { type: "text", value: E.value.replace(/\r?\n|\r/g, " ") };
  o.patch(E, A);
  const g = {
    type: "element",
    tagName: "code",
    properties: {},
    children: [A]
  };
  return o.patch(E, g), o.applyData(E, g);
}
function linkReference$1(o, E) {
  const A = String(E.identifier).toUpperCase(), g = o.definitionById.get(A);
  if (!g)
    return revert(o, E);
  const e = { href: normalizeUri(g.url || "") };
  g.title !== null && g.title !== void 0 && (e.title = g.title);
  const t = {
    type: "element",
    tagName: "a",
    properties: e,
    children: o.all(E)
  };
  return o.patch(E, t), o.applyData(E, t);
}
function link$1(o, E) {
  const A = { href: normalizeUri(E.url) };
  E.title !== null && E.title !== void 0 && (A.title = E.title);
  const g = {
    type: "element",
    tagName: "a",
    properties: A,
    children: o.all(E)
  };
  return o.patch(E, g), o.applyData(E, g);
}
function listItem$1(o, E, A) {
  const g = o.all(E), e = A ? listLoose(A) : listItemLoose(E), t = {}, c = [];
  if (typeof E.checked == "boolean") {
    const k = g[0];
    let p;
    k && k.type === "element" && k.tagName === "p" ? p = k : (p = { type: "element", tagName: "p", properties: {}, children: [] }, g.unshift(p)), p.children.length > 0 && p.children.unshift({ type: "text", value: " " }), p.children.unshift({
      type: "element",
      tagName: "input",
      properties: { type: "checkbox", checked: E.checked, disabled: !0 },
      children: []
    }), t.className = ["task-list-item"];
  }
  let n = -1;
  for (; ++n < g.length; ) {
    const k = g[n];
    (e || n !== 0 || k.type !== "element" || k.tagName !== "p") && c.push({ type: "text", value: `
` }), k.type === "element" && k.tagName === "p" && !e ? c.push(...k.children) : c.push(k);
  }
  const h = g[g.length - 1];
  h && (e || h.type !== "element" || h.tagName !== "p") && c.push({ type: "text", value: `
` });
  const d = { type: "element", tagName: "li", properties: t, children: c };
  return o.patch(E, d), o.applyData(E, d);
}
function listLoose(o) {
  let E = !1;
  if (o.type === "list") {
    E = o.spread || !1;
    const A = o.children;
    let g = -1;
    for (; !E && ++g < A.length; )
      E = listItemLoose(A[g]);
  }
  return E;
}
function listItemLoose(o) {
  const E = o.spread;
  return E ?? o.children.length > 1;
}
function list$1(o, E) {
  const A = {}, g = o.all(E);
  let e = -1;
  for (typeof E.start == "number" && E.start !== 1 && (A.start = E.start); ++e < g.length; ) {
    const c = g[e];
    if (c.type === "element" && c.tagName === "li" && c.properties && Array.isArray(c.properties.className) && c.properties.className.includes("task-list-item")) {
      A.className = ["contains-task-list"];
      break;
    }
  }
  const t = {
    type: "element",
    tagName: E.ordered ? "ol" : "ul",
    properties: A,
    children: o.wrap(g, !0)
  };
  return o.patch(E, t), o.applyData(E, t);
}
function paragraph$1(o, E) {
  const A = {
    type: "element",
    tagName: "p",
    properties: {},
    children: o.all(E)
  };
  return o.patch(E, A), o.applyData(E, A);
}
function root$2(o, E) {
  const A = { type: "root", children: o.wrap(o.all(E)) };
  return o.patch(E, A), o.applyData(E, A);
}
function strong$1(o, E) {
  const A = {
    type: "element",
    tagName: "strong",
    properties: {},
    children: o.all(E)
  };
  return o.patch(E, A), o.applyData(E, A);
}
function table(o, E) {
  const A = o.all(E), g = A.shift(), e = [];
  if (g) {
    const c = {
      type: "element",
      tagName: "thead",
      properties: {},
      children: o.wrap([g], !0)
    };
    o.patch(E.children[0], c), e.push(c);
  }
  if (A.length > 0) {
    const c = {
      type: "element",
      tagName: "tbody",
      properties: {},
      children: o.wrap(A, !0)
    }, n = pointStart(E.children[1]), h = pointEnd(E.children[E.children.length - 1]);
    n && h && (c.position = { start: n, end: h }), e.push(c);
  }
  const t = {
    type: "element",
    tagName: "table",
    properties: {},
    children: o.wrap(e, !0)
  };
  return o.patch(E, t), o.applyData(E, t);
}
function tableRow(o, E, A) {
  const g = A ? A.children : void 0, t = (g ? g.indexOf(E) : 1) === 0 ? "th" : "td", c = A && A.type === "table" ? A.align : void 0, n = c ? c.length : E.children.length;
  let h = -1;
  const d = [];
  for (; ++h < n; ) {
    const p = E.children[h], M = {}, S = c ? c[h] : void 0;
    S && (M.align = S);
    let AA = { type: "element", tagName: t, properties: M, children: [] };
    p && (AA.children = o.all(p), o.patch(p, AA), AA = o.applyData(p, AA)), d.push(AA);
  }
  const k = {
    type: "element",
    tagName: "tr",
    properties: {},
    children: o.wrap(d, !0)
  };
  return o.patch(E, k), o.applyData(E, k);
}
function tableCell(o, E) {
  const A = {
    type: "element",
    tagName: "td",
    // Assume body cell.
    properties: {},
    children: o.all(E)
  };
  return o.patch(E, A), o.applyData(E, A);
}
const tab = 9, space = 32;
function trimLines(o) {
  const E = String(o), A = /\r?\n|\r/g;
  let g = A.exec(E), e = 0;
  const t = [];
  for (; g; )
    t.push(
      trimLine(E.slice(e, g.index), e > 0, !0),
      g[0]
    ), e = g.index + g[0].length, g = A.exec(E);
  return t.push(trimLine(E.slice(e), e > 0, !1)), t.join("");
}
function trimLine(o, E, A) {
  let g = 0, e = o.length;
  if (E) {
    let t = o.codePointAt(g);
    for (; t === tab || t === space; )
      g++, t = o.codePointAt(g);
  }
  if (A) {
    let t = o.codePointAt(e - 1);
    for (; t === tab || t === space; )
      e--, t = o.codePointAt(e - 1);
  }
  return e > g ? o.slice(g, e) : "";
}
function text$3(o, E) {
  const A = { type: "text", value: trimLines(String(E.value)) };
  return o.patch(E, A), o.applyData(E, A);
}
function thematicBreak$1(o, E) {
  const A = {
    type: "element",
    tagName: "hr",
    properties: {},
    children: []
  };
  return o.patch(E, A), o.applyData(E, A);
}
const handlers = {
  blockquote: blockquote$1,
  break: hardBreak$1,
  code: code$3,
  delete: strikethrough,
  emphasis: emphasis$1,
  footnoteReference: footnoteReference$1,
  heading: heading$1,
  html: html$1,
  imageReference: imageReference$1,
  image: image$1,
  inlineCode: inlineCode$1,
  linkReference: linkReference$1,
  link: link$1,
  listItem: listItem$1,
  list: list$1,
  paragraph: paragraph$1,
  // @ts-expect-error: root is different, but hard to type.
  root: root$2,
  strong: strong$1,
  table,
  tableCell,
  tableRow,
  text: text$3,
  thematicBreak: thematicBreak$1,
  toml: ignore,
  yaml: ignore,
  definition: ignore,
  footnoteDefinition: ignore
};
function ignore() {
}
const VOID = -1, PRIMITIVE = 0, ARRAY = 1, OBJECT = 2, DATE = 3, REGEXP = 4, MAP = 5, SET = 6, ERROR = 7, BIGINT = 8, env = typeof self == "object" ? self : globalThis, deserializer = (o, E) => {
  const A = (e, t) => (o.set(t, e), e), g = (e) => {
    if (o.has(e))
      return o.get(e);
    const [t, c] = E[e];
    switch (t) {
      case PRIMITIVE:
      case VOID:
        return A(c, e);
      case ARRAY: {
        const n = A([], e);
        for (const h of c)
          n.push(g(h));
        return n;
      }
      case OBJECT: {
        const n = A({}, e);
        for (const [h, d] of c)
          n[g(h)] = g(d);
        return n;
      }
      case DATE:
        return A(new Date(c), e);
      case REGEXP: {
        const { source: n, flags: h } = c;
        return A(new RegExp(n, h), e);
      }
      case MAP: {
        const n = A(/* @__PURE__ */ new Map(), e);
        for (const [h, d] of c)
          n.set(g(h), g(d));
        return n;
      }
      case SET: {
        const n = A(/* @__PURE__ */ new Set(), e);
        for (const h of c)
          n.add(g(h));
        return n;
      }
      case ERROR: {
        const { name: n, message: h } = c;
        return A(new env[n](h), e);
      }
      case BIGINT:
        return A(BigInt(c), e);
      case "BigInt":
        return A(Object(BigInt(c)), e);
      case "ArrayBuffer":
        return A(new Uint8Array(c).buffer, c);
      case "DataView": {
        const { buffer: n } = new Uint8Array(c);
        return A(new DataView(n), c);
      }
    }
    return A(new env[t](c), e);
  };
  return g;
}, deserialize = (o) => deserializer(/* @__PURE__ */ new Map(), o)(0), EMPTY = "", { toString: toString$1 } = {}, { keys } = Object, typeOf = (o) => {
  const E = typeof o;
  if (E !== "object" || !o)
    return [PRIMITIVE, E];
  const A = toString$1.call(o).slice(8, -1);
  switch (A) {
    case "Array":
      return [ARRAY, EMPTY];
    case "Object":
      return [OBJECT, EMPTY];
    case "Date":
      return [DATE, EMPTY];
    case "RegExp":
      return [REGEXP, EMPTY];
    case "Map":
      return [MAP, EMPTY];
    case "Set":
      return [SET, EMPTY];
    case "DataView":
      return [ARRAY, A];
  }
  return A.includes("Array") ? [ARRAY, A] : A.includes("Error") ? [ERROR, A] : [OBJECT, A];
}, shouldSkip = ([o, E]) => o === PRIMITIVE && (E === "function" || E === "symbol"), serializer = (o, E, A, g) => {
  const e = (c, n) => {
    const h = g.push(c) - 1;
    return A.set(n, h), h;
  }, t = (c) => {
    if (A.has(c))
      return A.get(c);
    let [n, h] = typeOf(c);
    switch (n) {
      case PRIMITIVE: {
        let k = c;
        switch (h) {
          case "bigint":
            n = BIGINT, k = c.toString();
            break;
          case "function":
          case "symbol":
            if (o)
              throw new TypeError("unable to serialize " + h);
            k = null;
            break;
          case "undefined":
            return e([VOID], c);
        }
        return e([n, k], c);
      }
      case ARRAY: {
        if (h) {
          let M = c;
          return h === "DataView" ? M = new Uint8Array(c.buffer) : h === "ArrayBuffer" && (M = new Uint8Array(c)), e([h, [...M]], c);
        }
        const k = [], p = e([n, k], c);
        for (const M of c)
          k.push(t(M));
        return p;
      }
      case OBJECT: {
        if (h)
          switch (h) {
            case "BigInt":
              return e([h, c.toString()], c);
            case "Boolean":
            case "Number":
            case "String":
              return e([h, c.valueOf()], c);
          }
        if (E && "toJSON" in c)
          return t(c.toJSON());
        const k = [], p = e([n, k], c);
        for (const M of keys(c))
          (o || !shouldSkip(typeOf(c[M]))) && k.push([t(M), t(c[M])]);
        return p;
      }
      case DATE:
        return e([n, c.toISOString()], c);
      case REGEXP: {
        const { source: k, flags: p } = c;
        return e([n, { source: k, flags: p }], c);
      }
      case MAP: {
        const k = [], p = e([n, k], c);
        for (const [M, S] of c)
          (o || !(shouldSkip(typeOf(M)) || shouldSkip(typeOf(S)))) && k.push([t(M), t(S)]);
        return p;
      }
      case SET: {
        const k = [], p = e([n, k], c);
        for (const M of c)
          (o || !shouldSkip(typeOf(M))) && k.push(t(M));
        return p;
      }
    }
    const { message: d } = c;
    return e([n, { name: h, message: d }], c);
  };
  return t;
}, serialize$1 = (o, { json: E, lossy: A } = {}) => {
  const g = [];
  return serializer(!(E || A), !!E, /* @__PURE__ */ new Map(), g)(o), g;
}, structuredClone$1 = typeof structuredClone == "function" ? (
  /* c8 ignore start */
  (o, E) => E && ("json" in E || "lossy" in E) ? deserialize(serialize$1(o, E)) : structuredClone(o)
) : (o, E) => deserialize(serialize$1(o, E));
function defaultFootnoteBackContent(o, E) {
  const A = [{ type: "text", value: "↩" }];
  return E > 1 && A.push({
    type: "element",
    tagName: "sup",
    properties: {},
    children: [{ type: "text", value: String(E) }]
  }), A;
}
function defaultFootnoteBackLabel(o, E) {
  return "Back to reference " + (o + 1) + (E > 1 ? "-" + E : "");
}
function footer(o) {
  const E = typeof o.options.clobberPrefix == "string" ? o.options.clobberPrefix : "user-content-", A = o.options.footnoteBackContent || defaultFootnoteBackContent, g = o.options.footnoteBackLabel || defaultFootnoteBackLabel, e = o.options.footnoteLabel || "Footnotes", t = o.options.footnoteLabelTagName || "h2", c = o.options.footnoteLabelProperties || {
    className: ["sr-only"]
  }, n = [];
  let h = -1;
  for (; ++h < o.footnoteOrder.length; ) {
    const d = o.footnoteById.get(
      o.footnoteOrder[h]
    );
    if (!d)
      continue;
    const k = o.all(d), p = String(d.identifier).toUpperCase(), M = normalizeUri(p.toLowerCase());
    let S = 0;
    const AA = [], H = o.footnoteCounts.get(p);
    for (; H !== void 0 && ++S <= H; ) {
      AA.length > 0 && AA.push({ type: "text", value: " " });
      let IA = typeof A == "string" ? A : A(h, S);
      typeof IA == "string" && (IA = { type: "text", value: IA }), AA.push({
        type: "element",
        tagName: "a",
        properties: {
          href: "#" + E + "fnref-" + M + (S > 1 ? "-" + S : ""),
          dataFootnoteBackref: "",
          ariaLabel: typeof g == "string" ? g : g(h, S),
          className: ["data-footnote-backref"]
        },
        children: Array.isArray(IA) ? IA : [IA]
      });
    }
    const gA = k[k.length - 1];
    if (gA && gA.type === "element" && gA.tagName === "p") {
      const IA = gA.children[gA.children.length - 1];
      IA && IA.type === "text" ? IA.value += " " : gA.children.push({ type: "text", value: " " }), gA.children.push(...AA);
    } else
      k.push(...AA);
    const CA = {
      type: "element",
      tagName: "li",
      properties: { id: E + "fn-" + M },
      children: o.wrap(k, !0)
    };
    o.patch(d, CA), n.push(CA);
  }
  if (n.length !== 0)
    return {
      type: "element",
      tagName: "section",
      properties: { dataFootnotes: !0, className: ["footnotes"] },
      children: [
        {
          type: "element",
          tagName: t,
          properties: {
            ...structuredClone$1(c),
            id: "footnote-label"
          },
          children: [{ type: "text", value: e }]
        },
        { type: "text", value: `
` },
        {
          type: "element",
          tagName: "ol",
          properties: {},
          children: o.wrap(n, !0)
        },
        { type: "text", value: `
` }
      ]
    };
}
function visit(o, E, A, g) {
  let e, t, c;
  typeof E == "function" && typeof A != "function" ? (t = void 0, c = E, e = A) : (t = E, c = A, e = g), visitParents(o, t, n, e);
  function n(h, d) {
    const k = d[d.length - 1], p = k ? k.children.indexOf(h) : void 0;
    return c(h, p, k);
  }
}
const own$2 = {}.hasOwnProperty, emptyOptions$3 = {};
function createState(o, E) {
  const A = E || emptyOptions$3, g = /* @__PURE__ */ new Map(), e = /* @__PURE__ */ new Map(), t = /* @__PURE__ */ new Map(), c = { ...handlers, ...A.handlers }, n = {
    all: d,
    applyData,
    definitionById: g,
    footnoteById: e,
    footnoteCounts: t,
    footnoteOrder: [],
    handlers: c,
    one: h,
    options: A,
    patch,
    wrap: wrap$1
  };
  return visit(o, function(k) {
    if (k.type === "definition" || k.type === "footnoteDefinition") {
      const p = k.type === "definition" ? g : e, M = String(k.identifier).toUpperCase();
      p.has(M) || p.set(M, k);
    }
  }), n;
  function h(k, p) {
    const M = k.type, S = n.handlers[M];
    if (own$2.call(n.handlers, M) && S)
      return S(n, k, p);
    if (n.options.passThrough && n.options.passThrough.includes(M)) {
      if ("children" in k) {
        const { children: H, ...gA } = k, CA = structuredClone$1(gA);
        return CA.children = n.all(k), CA;
      }
      return structuredClone$1(k);
    }
    return (n.options.unknownHandler || defaultUnknownHandler)(n, k, p);
  }
  function d(k) {
    const p = [];
    if ("children" in k) {
      const M = k.children;
      let S = -1;
      for (; ++S < M.length; ) {
        const AA = n.one(M[S], k);
        if (AA) {
          if (S && M[S - 1].type === "break" && (!Array.isArray(AA) && AA.type === "text" && (AA.value = trimMarkdownSpaceStart(AA.value)), !Array.isArray(AA) && AA.type === "element")) {
            const H = AA.children[0];
            H && H.type === "text" && (H.value = trimMarkdownSpaceStart(H.value));
          }
          Array.isArray(AA) ? p.push(...AA) : p.push(AA);
        }
      }
    }
    return p;
  }
}
function patch(o, E) {
  o.position && (E.position = position$2(o));
}
function applyData(o, E) {
  let A = E;
  if (o && o.data) {
    const g = o.data.hName, e = o.data.hChildren, t = o.data.hProperties;
    if (typeof g == "string")
      if (A.type === "element")
        A.tagName = g;
      else {
        const c = "children" in A ? A.children : [A];
        A = { type: "element", tagName: g, properties: {}, children: c };
      }
    A.type === "element" && t && Object.assign(A.properties, structuredClone$1(t)), "children" in A && A.children && e !== null && e !== void 0 && (A.children = e);
  }
  return A;
}
function defaultUnknownHandler(o, E) {
  const A = E.data || {}, g = "value" in E && !(own$2.call(A, "hProperties") || own$2.call(A, "hChildren")) ? { type: "text", value: E.value } : {
    type: "element",
    tagName: "div",
    properties: {},
    children: o.all(E)
  };
  return o.patch(E, g), o.applyData(E, g);
}
function wrap$1(o, E) {
  const A = [];
  let g = -1;
  for (E && A.push({ type: "text", value: `
` }); ++g < o.length; )
    g && A.push({ type: "text", value: `
` }), A.push(o[g]);
  return E && o.length > 0 && A.push({ type: "text", value: `
` }), A;
}
function trimMarkdownSpaceStart(o) {
  let E = 0, A = o.charCodeAt(E);
  for (; A === 9 || A === 32; )
    E++, A = o.charCodeAt(E);
  return o.slice(E);
}
function toHast(o, E) {
  const A = createState(o, E), g = A.one(o, void 0), e = footer(A), t = Array.isArray(g) ? { type: "root", children: g } : g || { type: "root", children: [] };
  return e && t.children.push({ type: "text", value: `
` }, e), t;
}
function remarkRehype(o, E) {
  return o && "run" in o ? async function(A, g) {
    const e = (
      /** @type {HastRoot} */
      toHast(A, { file: g, ...E })
    );
    await o.run(e, g);
  } : function(A, g) {
    return (
      /** @type {HastRoot} */
      toHast(A, { file: g, ...o || E })
    );
  };
}
function bail(o) {
  if (o)
    throw o;
}
var extend$1, hasRequiredExtend;
function requireExtend() {
  if (hasRequiredExtend) return extend$1;
  hasRequiredExtend = 1;
  var o = Object.prototype.hasOwnProperty, E = Object.prototype.toString, A = Object.defineProperty, g = Object.getOwnPropertyDescriptor, e = function(d) {
    return typeof Array.isArray == "function" ? Array.isArray(d) : E.call(d) === "[object Array]";
  }, t = function(d) {
    if (!d || E.call(d) !== "[object Object]")
      return !1;
    var k = o.call(d, "constructor"), p = d.constructor && d.constructor.prototype && o.call(d.constructor.prototype, "isPrototypeOf");
    if (d.constructor && !k && !p)
      return !1;
    var M;
    for (M in d)
      ;
    return typeof M > "u" || o.call(d, M);
  }, c = function(d, k) {
    A && k.name === "__proto__" ? A(d, k.name, {
      enumerable: !0,
      configurable: !0,
      value: k.newValue,
      writable: !0
    }) : d[k.name] = k.newValue;
  }, n = function(d, k) {
    if (k === "__proto__")
      if (o.call(d, k)) {
        if (g)
          return g(d, k).value;
      } else return;
    return d[k];
  };
  return extend$1 = function h() {
    var d, k, p, M, S, AA, H = arguments[0], gA = 1, CA = arguments.length, IA = !1;
    for (typeof H == "boolean" && (IA = H, H = arguments[1] || {}, gA = 2), (H == null || typeof H != "object" && typeof H != "function") && (H = {}); gA < CA; ++gA)
      if (d = arguments[gA], d != null)
        for (k in d)
          p = n(H, k), M = n(d, k), H !== M && (IA && M && (t(M) || (S = e(M))) ? (S ? (S = !1, AA = p && e(p) ? p : []) : AA = p && t(p) ? p : {}, c(H, { name: k, newValue: h(IA, AA, M) })) : typeof M < "u" && c(H, { name: k, newValue: M }));
    return H;
  }, extend$1;
}
var extendExports = requireExtend();
const extend = /* @__PURE__ */ getDefaultExportFromCjs(extendExports);
function isPlainObject$1(o) {
  if (typeof o != "object" || o === null)
    return !1;
  const E = Object.getPrototypeOf(o);
  return (E === null || E === Object.prototype || Object.getPrototypeOf(E) === null) && !(Symbol.toStringTag in o) && !(Symbol.iterator in o);
}
function trough() {
  const o = [], E = { run: A, use: g };
  return E;
  function A(...e) {
    let t = -1;
    const c = e.pop();
    if (typeof c != "function")
      throw new TypeError("Expected function as last argument, not " + c);
    n(null, ...e);
    function n(h, ...d) {
      const k = o[++t];
      let p = -1;
      if (h) {
        c(h);
        return;
      }
      for (; ++p < e.length; )
        (d[p] === null || d[p] === void 0) && (d[p] = e[p]);
      e = d, k ? wrap(k, n)(...d) : c(null, ...d);
    }
  }
  function g(e) {
    if (typeof e != "function")
      throw new TypeError(
        "Expected `middelware` to be a function, not " + e
      );
    return o.push(e), E;
  }
}
function wrap(o, E) {
  let A;
  return g;
  function g(...c) {
    const n = o.length > c.length;
    let h;
    n && c.push(e);
    try {
      h = o.apply(this, c);
    } catch (d) {
      const k = (
        /** @type {Error} */
        d
      );
      if (n && A)
        throw k;
      return e(k);
    }
    n || (h && h.then && typeof h.then == "function" ? h.then(t, e) : h instanceof Error ? e(h) : t(h));
  }
  function e(c, ...n) {
    A || (A = !0, E(c, ...n));
  }
  function t(c) {
    e(null, c);
  }
}
const minpath = { basename, dirname, extname, join, sep: "/" };
function basename(o, E) {
  if (E !== void 0 && typeof E != "string")
    throw new TypeError('"ext" argument must be a string');
  assertPath$1(o);
  let A = 0, g = -1, e = o.length, t;
  if (E === void 0 || E.length === 0 || E.length > o.length) {
    for (; e--; )
      if (o.codePointAt(e) === 47) {
        if (t) {
          A = e + 1;
          break;
        }
      } else g < 0 && (t = !0, g = e + 1);
    return g < 0 ? "" : o.slice(A, g);
  }
  if (E === o)
    return "";
  let c = -1, n = E.length - 1;
  for (; e--; )
    if (o.codePointAt(e) === 47) {
      if (t) {
        A = e + 1;
        break;
      }
    } else
      c < 0 && (t = !0, c = e + 1), n > -1 && (o.codePointAt(e) === E.codePointAt(n--) ? n < 0 && (g = e) : (n = -1, g = c));
  return A === g ? g = c : g < 0 && (g = o.length), o.slice(A, g);
}
function dirname(o) {
  if (assertPath$1(o), o.length === 0)
    return ".";
  let E = -1, A = o.length, g;
  for (; --A; )
    if (o.codePointAt(A) === 47) {
      if (g) {
        E = A;
        break;
      }
    } else g || (g = !0);
  return E < 0 ? o.codePointAt(0) === 47 ? "/" : "." : E === 1 && o.codePointAt(0) === 47 ? "//" : o.slice(0, E);
}
function extname(o) {
  assertPath$1(o);
  let E = o.length, A = -1, g = 0, e = -1, t = 0, c;
  for (; E--; ) {
    const n = o.codePointAt(E);
    if (n === 47) {
      if (c) {
        g = E + 1;
        break;
      }
      continue;
    }
    A < 0 && (c = !0, A = E + 1), n === 46 ? e < 0 ? e = E : t !== 1 && (t = 1) : e > -1 && (t = -1);
  }
  return e < 0 || A < 0 || // We saw a non-dot character immediately before the dot.
  t === 0 || // The (right-most) trimmed path component is exactly `..`.
  t === 1 && e === A - 1 && e === g + 1 ? "" : o.slice(e, A);
}
function join(...o) {
  let E = -1, A;
  for (; ++E < o.length; )
    assertPath$1(o[E]), o[E] && (A = A === void 0 ? o[E] : A + "/" + o[E]);
  return A === void 0 ? "." : normalize(A);
}
function normalize(o) {
  assertPath$1(o);
  const E = o.codePointAt(0) === 47;
  let A = normalizeString(o, !E);
  return A.length === 0 && !E && (A = "."), A.length > 0 && o.codePointAt(o.length - 1) === 47 && (A += "/"), E ? "/" + A : A;
}
function normalizeString(o, E) {
  let A = "", g = 0, e = -1, t = 0, c = -1, n, h;
  for (; ++c <= o.length; ) {
    if (c < o.length)
      n = o.codePointAt(c);
    else {
      if (n === 47)
        break;
      n = 47;
    }
    if (n === 47) {
      if (!(e === c - 1 || t === 1)) if (e !== c - 1 && t === 2) {
        if (A.length < 2 || g !== 2 || A.codePointAt(A.length - 1) !== 46 || A.codePointAt(A.length - 2) !== 46) {
          if (A.length > 2) {
            if (h = A.lastIndexOf("/"), h !== A.length - 1) {
              h < 0 ? (A = "", g = 0) : (A = A.slice(0, h), g = A.length - 1 - A.lastIndexOf("/")), e = c, t = 0;
              continue;
            }
          } else if (A.length > 0) {
            A = "", g = 0, e = c, t = 0;
            continue;
          }
        }
        E && (A = A.length > 0 ? A + "/.." : "..", g = 2);
      } else
        A.length > 0 ? A += "/" + o.slice(e + 1, c) : A = o.slice(e + 1, c), g = c - e - 1;
      e = c, t = 0;
    } else n === 46 && t > -1 ? t++ : t = -1;
  }
  return A;
}
function assertPath$1(o) {
  if (typeof o != "string")
    throw new TypeError(
      "Path must be a string. Received " + JSON.stringify(o)
    );
}
const minproc = { cwd };
function cwd() {
  return "/";
}
function isUrl(o) {
  return !!(o !== null && typeof o == "object" && "href" in o && o.href && "protocol" in o && o.protocol && // @ts-expect-error: indexing is fine.
  o.auth === void 0);
}
function urlToPath(o) {
  if (typeof o == "string")
    o = new URL(o);
  else if (!isUrl(o)) {
    const E = new TypeError(
      'The "path" argument must be of type string or an instance of URL. Received `' + o + "`"
    );
    throw E.code = "ERR_INVALID_ARG_TYPE", E;
  }
  if (o.protocol !== "file:") {
    const E = new TypeError("The URL must be of scheme file");
    throw E.code = "ERR_INVALID_URL_SCHEME", E;
  }
  return getPathFromURLPosix(o);
}
function getPathFromURLPosix(o) {
  if (o.hostname !== "") {
    const g = new TypeError(
      'File URL host must be "localhost" or empty on darwin'
    );
    throw g.code = "ERR_INVALID_FILE_URL_HOST", g;
  }
  const E = o.pathname;
  let A = -1;
  for (; ++A < E.length; )
    if (E.codePointAt(A) === 37 && E.codePointAt(A + 1) === 50) {
      const g = E.codePointAt(A + 2);
      if (g === 70 || g === 102) {
        const e = new TypeError(
          "File URL path must not include encoded / characters"
        );
        throw e.code = "ERR_INVALID_FILE_URL_PATH", e;
      }
    }
  return decodeURIComponent(E);
}
const order = (
  /** @type {const} */
  [
    "history",
    "path",
    "basename",
    "stem",
    "extname",
    "dirname"
  ]
);
class VFile {
  /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Uint8Array` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */
  constructor(E) {
    let A;
    E ? isUrl(E) ? A = { path: E } : typeof E == "string" || isUint8Array$1(E) ? A = { value: E } : A = E : A = {}, this.cwd = "cwd" in A ? "" : minproc.cwd(), this.data = {}, this.history = [], this.messages = [], this.value, this.map, this.result, this.stored;
    let g = -1;
    for (; ++g < order.length; ) {
      const t = order[g];
      t in A && A[t] !== void 0 && A[t] !== null && (this[t] = t === "history" ? [...A[t]] : A[t]);
    }
    let e;
    for (e in A)
      order.includes(e) || (this[e] = A[e]);
  }
  /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   *
   * @returns {string | undefined}
   *   Basename.
   */
  get basename() {
    return typeof this.path == "string" ? minpath.basename(this.path) : void 0;
  }
  /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} basename
   *   Basename.
   * @returns {undefined}
   *   Nothing.
   */
  set basename(E) {
    assertNonEmpty(E, "basename"), assertPart(E, "basename"), this.path = minpath.join(this.dirname || "", E);
  }
  /**
   * Get the parent path (example: `'~'`).
   *
   * @returns {string | undefined}
   *   Dirname.
   */
  get dirname() {
    return typeof this.path == "string" ? minpath.dirname(this.path) : void 0;
  }
  /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} dirname
   *   Dirname.
   * @returns {undefined}
   *   Nothing.
   */
  set dirname(E) {
    assertPath(this.basename, "dirname"), this.path = minpath.join(E || "", this.basename);
  }
  /**
   * Get the extname (including dot) (example: `'.js'`).
   *
   * @returns {string | undefined}
   *   Extname.
   */
  get extname() {
    return typeof this.path == "string" ? minpath.extname(this.path) : void 0;
  }
  /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} extname
   *   Extname.
   * @returns {undefined}
   *   Nothing.
   */
  set extname(E) {
    if (assertPart(E, "extname"), assertPath(this.dirname, "extname"), E) {
      if (E.codePointAt(0) !== 46)
        throw new Error("`extname` must start with `.`");
      if (E.includes(".", 1))
        throw new Error("`extname` cannot contain multiple dots");
    }
    this.path = minpath.join(this.dirname, this.stem + (E || ""));
  }
  /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   *   Path.
   */
  get path() {
    return this.history[this.history.length - 1];
  }
  /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {URL | string} path
   *   Path.
   * @returns {undefined}
   *   Nothing.
   */
  set path(E) {
    isUrl(E) && (E = urlToPath(E)), assertNonEmpty(E, "path"), this.path !== E && this.history.push(E);
  }
  /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   *
   * @returns {string | undefined}
   *   Stem.
   */
  get stem() {
    return typeof this.path == "string" ? minpath.basename(this.path, this.extname) : void 0;
  }
  /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} stem
   *   Stem.
   * @returns {undefined}
   *   Nothing.
   */
  set stem(E) {
    assertNonEmpty(E, "stem"), assertPart(E, "stem"), this.path = minpath.join(this.dirname || "", E + (this.extname || ""));
  }
  // Normal prototypal methods.
  /**
   * Create a fatal message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `true` (error; file not usable)
   * and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Never.
   * @throws {VFileMessage}
   *   Message.
   */
  fail(E, A, g) {
    const e = this.message(E, A, g);
    throw e.fatal = !0, e;
  }
  /**
   * Create an info message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `undefined` (info; change
   * likely not needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  info(E, A, g) {
    const e = this.message(E, A, g);
    return e.fatal = void 0, e;
  }
  /**
   * Create a message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `false` (warning; change may be
   * needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  message(E, A, g) {
    const e = new VFileMessage(
      // @ts-expect-error: the overloads are fine.
      E,
      A,
      g
    );
    return this.path && (e.name = this.path + ":" + e.name, e.file = this.path), e.fatal = !1, this.messages.push(e), e;
  }
  /**
   * Serialize the file.
   *
   * > **Note**: which encodings are supported depends on the engine.
   * > For info on Node.js, see:
   * > <https://nodejs.org/api/util.html#whatwg-supported-encodings>.
   *
   * @param {string | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Uint8Array`
   *   (default: `'utf-8'`).
   * @returns {string}
   *   Serialized file.
   */
  toString(E) {
    return this.value === void 0 ? "" : typeof this.value == "string" ? this.value : new TextDecoder(E || void 0).decode(this.value);
  }
}
function assertPart(o, E) {
  if (o && o.includes(minpath.sep))
    throw new Error(
      "`" + E + "` cannot be a path: did not expect `" + minpath.sep + "`"
    );
}
function assertNonEmpty(o, E) {
  if (!o)
    throw new Error("`" + E + "` cannot be empty");
}
function assertPath(o, E) {
  if (!o)
    throw new Error("Setting `" + E + "` requires `path` to be set too");
}
function isUint8Array$1(o) {
  return !!(o && typeof o == "object" && "byteLength" in o && "byteOffset" in o);
}
const CallableInstance = (
  /**
   * @type {new <Parameters extends Array<unknown>, Result>(property: string | symbol) => (...parameters: Parameters) => Result}
   */
  /** @type {unknown} */
  /**
   * @this {Function}
   * @param {string | symbol} property
   * @returns {(...parameters: Array<unknown>) => unknown}
   */
  (function(o) {
    const g = (
      /** @type {Record<string | symbol, Function>} */
      // Prototypes do exist.
      // type-coverage:ignore-next-line
      this.constructor.prototype
    ), e = g[o], t = function() {
      return e.apply(t, arguments);
    };
    return Object.setPrototypeOf(t, g), t;
  })
), own$1 = {}.hasOwnProperty;
class Processor extends CallableInstance {
  /**
   * Create a processor.
   */
  constructor() {
    super("copy"), this.Compiler = void 0, this.Parser = void 0, this.attachers = [], this.compiler = void 0, this.freezeIndex = -1, this.frozen = void 0, this.namespace = {}, this.parser = void 0, this.transformers = trough();
  }
  /**
   * Copy a processor.
   *
   * @deprecated
   *   This is a private internal method and should not be used.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   New *unfrozen* processor ({@linkcode Processor}) that is
   *   configured to work the same as its ancestor.
   *   When the descendant processor is configured in the future it does not
   *   affect the ancestral processor.
   */
  copy() {
    const E = (
      /** @type {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>} */
      new Processor()
    );
    let A = -1;
    for (; ++A < this.attachers.length; ) {
      const g = this.attachers[A];
      E.use(...g);
    }
    return E.data(extend(!0, {}, this.namespace)), E;
  }
  /**
   * Configure the processor with info available to all plugins.
   * Information is stored in an object.
   *
   * Typically, options can be given to a specific plugin, but sometimes it
   * makes sense to have information shared with several plugins.
   * For example, a list of HTML elements that are self-closing, which is
   * needed during all phases.
   *
   * > **Note**: setting information cannot occur on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * > **Note**: to register custom data in TypeScript, augment the
   * > {@linkcode Data} interface.
   *
   * @example
   *   This example show how to get and set info:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   const processor = unified().data('alpha', 'bravo')
   *
   *   processor.data('alpha') // => 'bravo'
   *
   *   processor.data() // => {alpha: 'bravo'}
   *
   *   processor.data({charlie: 'delta'})
   *
   *   processor.data() // => {charlie: 'delta'}
   *   ```
   *
   * @template {keyof Data} Key
   *
   * @overload
   * @returns {Data}
   *
   * @overload
   * @param {Data} dataset
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Key} key
   * @returns {Data[Key]}
   *
   * @overload
   * @param {Key} key
   * @param {Data[Key]} value
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @param {Data | Key} [key]
   *   Key to get or set, or entire dataset to set, or nothing to get the
   *   entire dataset (optional).
   * @param {Data[Key]} [value]
   *   Value to set (optional).
   * @returns {unknown}
   *   The current processor when setting, the value at `key` when getting, or
   *   the entire dataset when getting without key.
   */
  data(E, A) {
    return typeof E == "string" ? arguments.length === 2 ? (assertUnfrozen("data", this.frozen), this.namespace[E] = A, this) : own$1.call(this.namespace, E) && this.namespace[E] || void 0 : E ? (assertUnfrozen("data", this.frozen), this.namespace = E, this) : this.namespace;
  }
  /**
   * Freeze a processor.
   *
   * Frozen processors are meant to be extended and not to be configured
   * directly.
   *
   * When a processor is frozen it cannot be unfrozen.
   * New processors working the same way can be created by calling the
   * processor.
   *
   * It’s possible to freeze processors explicitly by calling `.freeze()`.
   * Processors freeze automatically when `.parse()`, `.run()`, `.runSync()`,
   * `.stringify()`, `.process()`, or `.processSync()` are called.
   *
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   The current processor.
   */
  freeze() {
    if (this.frozen)
      return this;
    const E = (
      /** @type {Processor} */
      /** @type {unknown} */
      this
    );
    for (; ++this.freezeIndex < this.attachers.length; ) {
      const [A, ...g] = this.attachers[this.freezeIndex];
      if (g[0] === !1)
        continue;
      g[0] === !0 && (g[0] = void 0);
      const e = A.call(E, ...g);
      typeof e == "function" && this.transformers.use(e);
    }
    return this.frozen = !0, this.freezeIndex = Number.POSITIVE_INFINITY, this;
  }
  /**
   * Parse text to a syntax tree.
   *
   * > **Note**: `parse` freezes the processor if not already *frozen*.
   *
   * > **Note**: `parse` performs the parse phase, not the run phase or other
   * > phases.
   *
   * @param {Compatible | undefined} [file]
   *   file to parse (optional); typically `string` or `VFile`; any value
   *   accepted as `x` in `new VFile(x)`.
   * @returns {ParseTree extends undefined ? Node : ParseTree}
   *   Syntax tree representing `file`.
   */
  parse(E) {
    this.freeze();
    const A = vfile(E), g = this.parser || this.Parser;
    return assertParser("parse", g), g(String(A), A);
  }
  /**
   * Process the given file as configured on the processor.
   *
   * > **Note**: `process` freezes the processor if not already *frozen*.
   *
   * > **Note**: `process` performs the parse, run, and stringify phases.
   *
   * @overload
   * @param {Compatible | undefined} file
   * @param {ProcessCallback<VFileWithOutput<CompileResult>>} done
   * @returns {undefined}
   *
   * @overload
   * @param {Compatible | undefined} [file]
   * @returns {Promise<VFileWithOutput<CompileResult>>}
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`]; any value accepted as
   *   `x` in `new VFile(x)`.
   * @param {ProcessCallback<VFileWithOutput<CompileResult>> | undefined} [done]
   *   Callback (optional).
   * @returns {Promise<VFile> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise a promise, rejected with a fatal error or resolved with the
   *   processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  process(E, A) {
    const g = this;
    return this.freeze(), assertParser("process", this.parser || this.Parser), assertCompiler("process", this.compiler || this.Compiler), A ? e(void 0, A) : new Promise(e);
    function e(t, c) {
      const n = vfile(E), h = (
        /** @type {HeadTree extends undefined ? Node : HeadTree} */
        /** @type {unknown} */
        g.parse(n)
      );
      g.run(h, n, function(k, p, M) {
        if (k || !p || !M)
          return d(k);
        const S = (
          /** @type {CompileTree extends undefined ? Node : CompileTree} */
          /** @type {unknown} */
          p
        ), AA = g.stringify(S, M);
        looksLikeAValue(AA) ? M.value = AA : M.result = AA, d(
          k,
          /** @type {VFileWithOutput<CompileResult>} */
          M
        );
      });
      function d(k, p) {
        k || !p ? c(k) : t ? t(p) : A(void 0, p);
      }
    }
  }
  /**
   * Process the given file as configured on the processor.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `processSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `processSync` performs the parse, run, and stringify phases.
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`; any value accepted as
   *   `x` in `new VFile(x)`.
   * @returns {VFileWithOutput<CompileResult>}
   *   The processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  processSync(E) {
    let A = !1, g;
    return this.freeze(), assertParser("processSync", this.parser || this.Parser), assertCompiler("processSync", this.compiler || this.Compiler), this.process(E, e), assertDone("processSync", "process", A), g;
    function e(t, c) {
      A = !0, bail(t), g = c;
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * > **Note**: `run` freezes the processor if not already *frozen*.
   *
   * > **Note**: `run` performs the run phase, not other phases.
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} file
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} [file]
   * @returns {Promise<TailTree extends undefined ? Node : TailTree>}
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {(
   *   RunCallback<TailTree extends undefined ? Node : TailTree> |
   *   Compatible
   * )} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} [done]
   *   Callback (optional).
   * @returns {Promise<TailTree extends undefined ? Node : TailTree> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise, a promise rejected with a fatal error or resolved with the
   *   transformed tree.
   */
  run(E, A, g) {
    assertNode(E), this.freeze();
    const e = this.transformers;
    return !g && typeof A == "function" && (g = A, A = void 0), g ? t(void 0, g) : new Promise(t);
    function t(c, n) {
      const h = vfile(A);
      e.run(E, h, d);
      function d(k, p, M) {
        const S = (
          /** @type {TailTree extends undefined ? Node : TailTree} */
          p || E
        );
        k ? n(k) : c ? c(S) : g(void 0, S, M);
      }
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `runSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `runSync` performs the run phase, not other phases.
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {TailTree extends undefined ? Node : TailTree}
   *   Transformed tree.
   */
  runSync(E, A) {
    let g = !1, e;
    return this.run(E, A, t), assertDone("runSync", "run", g), e;
    function t(c, n) {
      bail(c), e = n, g = !0;
    }
  }
  /**
   * Compile a syntax tree.
   *
   * > **Note**: `stringify` freezes the processor if not already *frozen*.
   *
   * > **Note**: `stringify` performs the stringify phase, not the run phase
   * > or other phases.
   *
   * @param {CompileTree extends undefined ? Node : CompileTree} tree
   *   Tree to compile.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {CompileResult extends undefined ? Value : CompileResult}
   *   Textual representation of the tree (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most compilers
   *   > return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  stringify(E, A) {
    this.freeze();
    const g = vfile(A), e = this.compiler || this.Compiler;
    return assertCompiler("stringify", e), assertNode(E), e(E, g);
  }
  /**
   * Configure the processor to use a plugin, a list of usable values, or a
   * preset.
   *
   * If the processor is already using a plugin, the previous plugin
   * configuration is changed based on the options that are passed in.
   * In other words, the plugin is not added a second time.
   *
   * > **Note**: `use` cannot be called on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * @example
   *   There are many ways to pass plugins to `.use()`.
   *   This example gives an overview:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   unified()
   *     // Plugin with options:
   *     .use(pluginA, {x: true, y: true})
   *     // Passing the same plugin again merges configuration (to `{x: true, y: false, z: true}`):
   *     .use(pluginA, {y: false, z: true})
   *     // Plugins:
   *     .use([pluginB, pluginC])
   *     // Two plugins, the second with options:
   *     .use([pluginD, [pluginE, {}]])
   *     // Preset with plugins and settings:
   *     .use({plugins: [pluginF, [pluginG, {}]], settings: {position: false}})
   *     // Settings only:
   *     .use({settings: {position: false}})
   *   ```
   *
   * @template {Array<unknown>} [Parameters=[]]
   * @template {Node | string | undefined} [Input=undefined]
   * @template [Output=Input]
   *
   * @overload
   * @param {Preset | null | undefined} [preset]
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {PluggableList} list
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Plugin<Parameters, Input, Output>} plugin
   * @param {...(Parameters | [boolean])} parameters
   * @returns {UsePlugin<ParseTree, HeadTree, TailTree, CompileTree, CompileResult, Input, Output>}
   *
   * @param {PluggableList | Plugin | Preset | null | undefined} value
   *   Usable value.
   * @param {...unknown} parameters
   *   Parameters, when a plugin is given as a usable value.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   Current processor.
   */
  use(E, ...A) {
    const g = this.attachers, e = this.namespace;
    if (assertUnfrozen("use", this.frozen), E != null) if (typeof E == "function")
      h(E, A);
    else if (typeof E == "object")
      Array.isArray(E) ? n(E) : c(E);
    else
      throw new TypeError("Expected usable value, not `" + E + "`");
    return this;
    function t(d) {
      if (typeof d == "function")
        h(d, []);
      else if (typeof d == "object")
        if (Array.isArray(d)) {
          const [k, ...p] = (
            /** @type {PluginTuple<Array<unknown>>} */
            d
          );
          h(k, p);
        } else
          c(d);
      else
        throw new TypeError("Expected usable value, not `" + d + "`");
    }
    function c(d) {
      if (!("plugins" in d) && !("settings" in d))
        throw new Error(
          "Expected usable value but received an empty preset, which is probably a mistake: presets typically come with `plugins` and sometimes with `settings`, but this has neither"
        );
      n(d.plugins), d.settings && (e.settings = extend(!0, e.settings, d.settings));
    }
    function n(d) {
      let k = -1;
      if (d != null) if (Array.isArray(d))
        for (; ++k < d.length; ) {
          const p = d[k];
          t(p);
        }
      else
        throw new TypeError("Expected a list of plugins, not `" + d + "`");
    }
    function h(d, k) {
      let p = -1, M = -1;
      for (; ++p < g.length; )
        if (g[p][0] === d) {
          M = p;
          break;
        }
      if (M === -1)
        g.push([d, ...k]);
      else if (k.length > 0) {
        let [S, ...AA] = k;
        const H = g[M][1];
        isPlainObject$1(H) && isPlainObject$1(S) && (S = extend(!0, H, S)), g[M] = [d, S, ...AA];
      }
    }
  }
}
const unified = new Processor().freeze();
function assertParser(o, E) {
  if (typeof E != "function")
    throw new TypeError("Cannot `" + o + "` without `parser`");
}
function assertCompiler(o, E) {
  if (typeof E != "function")
    throw new TypeError("Cannot `" + o + "` without `compiler`");
}
function assertUnfrozen(o, E) {
  if (E)
    throw new Error(
      "Cannot call `" + o + "` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`."
    );
}
function assertNode(o) {
  if (!isPlainObject$1(o) || typeof o.type != "string")
    throw new TypeError("Expected node, got `" + o + "`");
}
function assertDone(o, E, A) {
  if (!A)
    throw new Error(
      "`" + o + "` finished async. Use `" + E + "` instead"
    );
}
function vfile(o) {
  return looksLikeAVFile(o) ? o : new VFile(o);
}
function looksLikeAVFile(o) {
  return !!(o && typeof o == "object" && "message" in o && "messages" in o);
}
function looksLikeAValue(o) {
  return typeof o == "string" || isUint8Array(o);
}
function isUint8Array(o) {
  return !!(o && typeof o == "object" && "byteLength" in o && "byteOffset" in o);
}
const changelog = "https://github.com/remarkjs/react-markdown/blob/main/changelog.md", emptyPlugins = [], emptyRemarkRehypeOptions = { allowDangerousHtml: !0 }, safeProtocol = /^(https?|ircs?|mailto|xmpp)$/i, deprecations = [
  { from: "astPlugins", id: "remove-buggy-html-in-markdown-parser" },
  { from: "allowDangerousHtml", id: "remove-buggy-html-in-markdown-parser" },
  {
    from: "allowNode",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowElement"
  },
  {
    from: "allowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowedElements"
  },
  { from: "className", id: "remove-classname" },
  {
    from: "disallowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "disallowedElements"
  },
  { from: "escapeHtml", id: "remove-buggy-html-in-markdown-parser" },
  { from: "includeElementIndex", id: "#remove-includeelementindex" },
  {
    from: "includeNodeIndex",
    id: "change-includenodeindex-to-includeelementindex"
  },
  { from: "linkTarget", id: "remove-linktarget" },
  { from: "plugins", id: "change-plugins-to-remarkplugins", to: "remarkPlugins" },
  { from: "rawSourcePos", id: "#remove-rawsourcepos" },
  { from: "renderers", id: "change-renderers-to-components", to: "components" },
  { from: "source", id: "change-source-to-children", to: "children" },
  { from: "sourcePos", id: "#remove-sourcepos" },
  { from: "transformImageUri", id: "#add-urltransform", to: "urlTransform" },
  { from: "transformLinkUri", id: "#add-urltransform", to: "urlTransform" }
];
function Markdown$2(o) {
  const E = createProcessor(o), A = createFile(o);
  return post(E.runSync(E.parse(A), A), o);
}
function createProcessor(o) {
  const E = o.rehypePlugins || emptyPlugins, A = o.remarkPlugins || emptyPlugins, g = o.remarkRehypeOptions ? { ...o.remarkRehypeOptions, ...emptyRemarkRehypeOptions } : emptyRemarkRehypeOptions;
  return unified().use(remarkParse).use(A).use(remarkRehype, g).use(E);
}
function createFile(o) {
  const E = o.children || "", A = new VFile();
  return typeof E == "string" && (A.value = E), A;
}
function post(o, E) {
  const A = E.allowedElements, g = E.allowElement, e = E.components, t = E.disallowedElements, c = E.skipHtml, n = E.unwrapDisallowed, h = E.urlTransform || defaultUrlTransform;
  for (const k of deprecations)
    Object.hasOwn(E, k.from) && ("" + k.from + (k.to ? "use `" + k.to + "` instead" : "remove it") + changelog + k.id, void 0);
  return visit(o, d), toJsxRuntime(o, {
    Fragment: jsxRuntimeExports.Fragment,
    components: e,
    ignoreInvalidStyle: !0,
    jsx: jsxRuntimeExports.jsx,
    jsxs: jsxRuntimeExports.jsxs,
    passKeys: !0,
    passNode: !0
  });
  function d(k, p, M) {
    if (k.type === "raw" && M && typeof p == "number")
      return c ? M.children.splice(p, 1) : M.children[p] = { type: "text", value: k.value }, p;
    if (k.type === "element") {
      let S;
      for (S in urlAttributes)
        if (Object.hasOwn(urlAttributes, S) && Object.hasOwn(k.properties, S)) {
          const AA = k.properties[S], H = urlAttributes[S];
          (H === null || H.includes(k.tagName)) && (k.properties[S] = h(String(AA || ""), S, k));
        }
    }
    if (k.type === "element") {
      let S = A ? !A.includes(k.tagName) : t ? t.includes(k.tagName) : !1;
      if (!S && g && typeof p == "number" && (S = !g(k, p, M)), S && M && typeof p == "number")
        return n && k.children ? M.children.splice(p, 1, ...k.children) : M.children.splice(p, 1), p;
    }
  }
}
function defaultUrlTransform(o) {
  const E = o.indexOf(":"), A = o.indexOf("?"), g = o.indexOf("#"), e = o.indexOf("/");
  return (
    // If there is no protocol, it’s relative.
    E === -1 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    e !== -1 && E > e || A !== -1 && E > A || g !== -1 && E > g || // It is a protocol, it should be allowed.
    safeProtocol.test(o.slice(0, E)) ? o : ""
  );
}
function ccount(o, E) {
  const A = String(o);
  if (typeof E != "string")
    throw new TypeError("Expected character");
  let g = 0, e = A.indexOf(E);
  for (; e !== -1; )
    g++, e = A.indexOf(E, e + E.length);
  return g;
}
const characterEntitiesLegacy = [
  "AElig",
  "AMP",
  "Aacute",
  "Acirc",
  "Agrave",
  "Aring",
  "Atilde",
  "Auml",
  "COPY",
  "Ccedil",
  "ETH",
  "Eacute",
  "Ecirc",
  "Egrave",
  "Euml",
  "GT",
  "Iacute",
  "Icirc",
  "Igrave",
  "Iuml",
  "LT",
  "Ntilde",
  "Oacute",
  "Ocirc",
  "Ograve",
  "Oslash",
  "Otilde",
  "Ouml",
  "QUOT",
  "REG",
  "THORN",
  "Uacute",
  "Ucirc",
  "Ugrave",
  "Uuml",
  "Yacute",
  "aacute",
  "acirc",
  "acute",
  "aelig",
  "agrave",
  "amp",
  "aring",
  "atilde",
  "auml",
  "brvbar",
  "ccedil",
  "cedil",
  "cent",
  "copy",
  "curren",
  "deg",
  "divide",
  "eacute",
  "ecirc",
  "egrave",
  "eth",
  "euml",
  "frac12",
  "frac14",
  "frac34",
  "gt",
  "iacute",
  "icirc",
  "iexcl",
  "igrave",
  "iquest",
  "iuml",
  "laquo",
  "lt",
  "macr",
  "micro",
  "middot",
  "nbsp",
  "not",
  "ntilde",
  "oacute",
  "ocirc",
  "ograve",
  "ordf",
  "ordm",
  "oslash",
  "otilde",
  "ouml",
  "para",
  "plusmn",
  "pound",
  "quot",
  "raquo",
  "reg",
  "sect",
  "shy",
  "sup1",
  "sup2",
  "sup3",
  "szlig",
  "thorn",
  "times",
  "uacute",
  "ucirc",
  "ugrave",
  "uml",
  "uuml",
  "yacute",
  "yen",
  "yuml"
], characterReferenceInvalid = {
  0: "�",
  128: "€",
  130: "‚",
  131: "ƒ",
  132: "„",
  133: "…",
  134: "†",
  135: "‡",
  136: "ˆ",
  137: "‰",
  138: "Š",
  139: "‹",
  140: "Œ",
  142: "Ž",
  145: "‘",
  146: "’",
  147: "“",
  148: "”",
  149: "•",
  150: "–",
  151: "—",
  152: "˜",
  153: "™",
  154: "š",
  155: "›",
  156: "œ",
  158: "ž",
  159: "Ÿ"
};
function isDecimal(o) {
  const E = typeof o == "string" ? o.charCodeAt(0) : o;
  return E >= 48 && E <= 57;
}
function isHexadecimal(o) {
  const E = typeof o == "string" ? o.charCodeAt(0) : o;
  return E >= 97 && E <= 102 || E >= 65 && E <= 70 || E >= 48 && E <= 57;
}
function isAlphabetical(o) {
  const E = typeof o == "string" ? o.charCodeAt(0) : o;
  return E >= 97 && E <= 122 || E >= 65 && E <= 90;
}
function isAlphanumerical(o) {
  return isAlphabetical(o) || isDecimal(o);
}
const messages = [
  "",
  /* 1: Non terminated (named) */
  "Named character references must be terminated by a semicolon",
  /* 2: Non terminated (numeric) */
  "Numeric character references must be terminated by a semicolon",
  /* 3: Empty (named) */
  "Named character references cannot be empty",
  /* 4: Empty (numeric) */
  "Numeric character references cannot be empty",
  /* 5: Unknown (named) */
  "Named character references must be known",
  /* 6: Disallowed (numeric) */
  "Numeric character references cannot be disallowed",
  /* 7: Prohibited (numeric) */
  "Numeric character references cannot be outside the permissible Unicode range"
];
function parseEntities(o, E) {
  const A = E || {}, g = typeof A.additional == "string" ? A.additional.charCodeAt(0) : A.additional, e = [];
  let t = 0, c = -1, n = "", h, d;
  A.position && ("start" in A.position || "indent" in A.position ? (d = A.position.indent, h = A.position.start) : h = A.position);
  let k = (h ? h.line : 0) || 1, p = (h ? h.column : 0) || 1, M = AA(), S;
  for (t--; ++t <= o.length; )
    if (S === 10 && (p = (d ? d[c] : 0) || 1), S = o.charCodeAt(t), S === 38) {
      const CA = o.charCodeAt(t + 1);
      if (CA === 9 || CA === 10 || CA === 12 || CA === 32 || CA === 38 || CA === 60 || Number.isNaN(CA) || g && CA === g) {
        n += String.fromCharCode(S), p++;
        continue;
      }
      const IA = t + 1;
      let BA = IA, QA = IA, EA;
      if (CA === 35) {
        QA = ++BA;
        const nA = o.charCodeAt(QA);
        nA === 88 || nA === 120 ? (EA = "hexadecimal", QA = ++BA) : EA = "decimal";
      } else
        EA = "named";
      let oA = "", iA = "", aA = "";
      const tA = EA === "named" ? isAlphanumerical : EA === "decimal" ? isDecimal : isHexadecimal;
      for (QA--; ++QA <= o.length; ) {
        const nA = o.charCodeAt(QA);
        if (!tA(nA))
          break;
        aA += String.fromCharCode(nA), EA === "named" && characterEntitiesLegacy.includes(aA) && (oA = aA, iA = decodeNamedCharacterReference(aA));
      }
      let eA = o.charCodeAt(QA) === 59;
      if (eA) {
        QA++;
        const nA = EA === "named" ? decodeNamedCharacterReference(aA) : !1;
        nA && (oA = aA, iA = nA);
      }
      let cA = 1 + QA - IA, DA = "";
      if (!(!eA && A.nonTerminated === !1)) if (!aA)
        EA !== "named" && H(4, cA);
      else if (EA === "named") {
        if (eA && !iA)
          H(5, 1);
        else if (oA !== aA && (QA = BA + oA.length, cA = 1 + QA - BA, eA = !1), !eA) {
          const nA = oA ? 1 : 3;
          if (A.attribute) {
            const wA = o.charCodeAt(QA);
            wA === 61 ? (H(nA, cA), iA = "") : isAlphanumerical(wA) ? iA = "" : H(nA, cA);
          } else
            H(nA, cA);
        }
        DA = iA;
      } else {
        eA || H(2, cA);
        let nA = Number.parseInt(
          aA,
          EA === "hexadecimal" ? 16 : 10
        );
        if (prohibited(nA))
          H(7, cA), DA = "�";
        else if (nA in characterReferenceInvalid)
          H(6, cA), DA = characterReferenceInvalid[nA];
        else {
          let wA = "";
          disallowed(nA) && H(6, cA), nA > 65535 && (nA -= 65536, wA += String.fromCharCode(
            nA >>> 10 | 55296
          ), nA = 56320 | nA & 1023), DA = wA + String.fromCharCode(nA);
        }
      }
      if (DA) {
        gA(), M = AA(), t = QA - 1, p += QA - IA + 1, e.push(DA);
        const nA = AA();
        nA.offset++, A.reference && A.reference.call(
          A.referenceContext || void 0,
          DA,
          { start: M, end: nA },
          o.slice(IA - 1, QA)
        ), M = nA;
      } else
        aA = o.slice(IA - 1, QA), n += aA, p += aA.length, t = QA - 1;
    } else
      S === 10 && (k++, c++, p = 0), Number.isNaN(S) ? gA() : (n += String.fromCharCode(S), p++);
  return e.join("");
  function AA() {
    return {
      line: k,
      column: p,
      offset: t + ((h ? h.offset : 0) || 0)
    };
  }
  function H(CA, IA) {
    let BA;
    A.warning && (BA = AA(), BA.column += IA, BA.offset += IA, A.warning.call(
      A.warningContext || void 0,
      messages[CA],
      BA,
      CA
    ));
  }
  function gA() {
    n && (e.push(n), A.text && A.text.call(A.textContext || void 0, n, {
      start: M,
      end: AA()
    }), n = "");
  }
}
function prohibited(o) {
  return o >= 55296 && o <= 57343 || o > 1114111;
}
function disallowed(o) {
  return o >= 1 && o <= 8 || o === 11 || o >= 13 && o <= 31 || o >= 127 && o <= 159 || o >= 64976 && o <= 65007 || (o & 65535) === 65535 || (o & 65535) === 65534;
}
const defaultSubsetRegex = /["&'<>`]/g, surrogatePairsRegex = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g, controlCharactersRegex = (
  // eslint-disable-next-line no-control-regex, unicorn/no-hex-escape
  /[\x01-\t\v\f\x0E-\x1F\x7F\x81\x8D\x8F\x90\x9D\xA0-\uFFFF]/g
), regexEscapeRegex = /[|\\{}()[\]^$+*?.]/g, subsetToRegexCache = /* @__PURE__ */ new WeakMap();
function core(o, E) {
  if (o = o.replace(
    E.subset ? charactersToExpressionCached(E.subset) : defaultSubsetRegex,
    g
  ), E.subset || E.escapeOnly)
    return o;
  return o.replace(surrogatePairsRegex, A).replace(controlCharactersRegex, g);
  function A(e, t, c) {
    return E.format(
      (e.charCodeAt(0) - 55296) * 1024 + e.charCodeAt(1) - 56320 + 65536,
      c.charCodeAt(t + 2),
      E
    );
  }
  function g(e, t, c) {
    return E.format(
      e.charCodeAt(0),
      c.charCodeAt(t + 1),
      E
    );
  }
}
function charactersToExpressionCached(o) {
  let E = subsetToRegexCache.get(o);
  return E || (E = charactersToExpression(o), subsetToRegexCache.set(o, E)), E;
}
function charactersToExpression(o) {
  const E = [];
  let A = -1;
  for (; ++A < o.length; )
    E.push(o[A].replace(regexEscapeRegex, "\\$&"));
  return new RegExp("(?:" + E.join("|") + ")", "g");
}
function formatBasic(o) {
  return "&#x" + o.toString(16).toUpperCase() + ";";
}
function stringifyEntitiesLight(o, E) {
  return core(o, Object.assign({ format: formatBasic }, E));
}
const own = {}.hasOwnProperty, emptyOptions$2 = {}, shortcut = /^[^\t\n\r "#'.<=>`}]+$/, unquoted = /^[^\t\n\r "'<=>`}]+$/;
function directiveFromMarkdown() {
  return {
    canContainEols: ["textDirective"],
    enter: {
      directiveContainer: enterContainer,
      directiveContainerAttributes: enterAttributes,
      directiveContainerLabel: enterContainerLabel,
      directiveLeaf: enterLeaf,
      directiveLeafAttributes: enterAttributes,
      directiveText: enterText,
      directiveTextAttributes: enterAttributes
    },
    exit: {
      directiveContainer: exit$1,
      directiveContainerAttributeClassValue: exitAttributeClassValue,
      directiveContainerAttributeIdValue: exitAttributeIdValue,
      directiveContainerAttributeName: exitAttributeName,
      directiveContainerAttributeValue: exitAttributeValue,
      directiveContainerAttributes: exitAttributes,
      directiveContainerLabel: exitContainerLabel,
      directiveContainerName: exitName,
      directiveLeaf: exit$1,
      directiveLeafAttributeClassValue: exitAttributeClassValue,
      directiveLeafAttributeIdValue: exitAttributeIdValue,
      directiveLeafAttributeName: exitAttributeName,
      directiveLeafAttributeValue: exitAttributeValue,
      directiveLeafAttributes: exitAttributes,
      directiveLeafName: exitName,
      directiveText: exit$1,
      directiveTextAttributeClassValue: exitAttributeClassValue,
      directiveTextAttributeIdValue: exitAttributeIdValue,
      directiveTextAttributeName: exitAttributeName,
      directiveTextAttributeValue: exitAttributeValue,
      directiveTextAttributes: exitAttributes,
      directiveTextName: exitName
    }
  };
}
function directiveToMarkdown(o) {
  const E = emptyOptions$2;
  if (E.quote !== '"' && E.quote !== "'" && E.quote !== null && E.quote !== void 0)
    throw new Error(
      "Invalid quote `" + E.quote + "`, expected `'` or `\"`"
    );
  return A.peek = peekDirective, {
    handlers: {
      containerDirective: A,
      leafDirective: A,
      textDirective: A
    },
    unsafe: [
      {
        character: "\r",
        inConstruct: ["leafDirectiveLabel", "containerDirectiveLabel"]
      },
      {
        character: `
`,
        inConstruct: ["leafDirectiveLabel", "containerDirectiveLabel"]
      },
      {
        before: "[^:]",
        character: ":",
        after: "[A-Za-z]",
        inConstruct: ["phrasing"]
      },
      { atBreak: !0, character: ":", after: ":" }
    ]
  };
  function A(t, c, n, h) {
    const d = n.createTracker(h), k = fence(t), p = n.enter(t.type);
    let M = d.move(k + (t.name || "")), S;
    if (t.type === "containerDirective") {
      const AA = (t.children || [])[0];
      S = inlineDirectiveLabel(AA) ? AA : void 0;
    } else
      S = t;
    if (S && S.children && S.children.length > 0) {
      const AA = n.enter("label"), H = `${t.type}Label`, gA = n.enter(H);
      M += d.move("["), M += d.move(
        n.containerPhrasing(S, {
          ...d.current(),
          before: M,
          after: "]"
        })
      ), M += d.move("]"), gA(), AA();
    }
    if (M += d.move(g(t, n)), t.type === "containerDirective") {
      const AA = (t.children || [])[0];
      let H = t;
      inlineDirectiveLabel(AA) && (H = Object.assign({}, t, { children: t.children.slice(1) })), H && H.children && H.children.length > 0 && (M += d.move(`
`), M += d.move(n.containerFlow(H, d.current()))), M += d.move(`
` + k);
    }
    return p(), M;
  }
  function g(t, c) {
    const n = t.attributes || {}, h = [];
    let d, k, p, M;
    for (M in n)
      if (own.call(n, M) && n[M] !== void 0 && n[M] !== null) {
        const S = String(n[M]);
        if (M === "id")
          p = E.preferShortcut !== !1 && shortcut.test(S) ? "#" + S : e("id", S, t, c);
        else if (M === "class") {
          const AA = S.split(/[\t\n\r ]+/g), H = [], gA = [];
          let CA = -1;
          for (; ++CA < AA.length; )
            (E.preferShortcut !== !1 && shortcut.test(AA[CA]) ? gA : H).push(AA[CA]);
          d = H.length > 0 ? e("class", H.join(" "), t, c) : "", k = gA.length > 0 ? "." + gA.join(".") : "";
        } else
          h.push(e(M, S, t, c));
      }
    return d && h.unshift(d), k && h.unshift(k), p && h.unshift(p), h.length > 0 ? "{" + h.join(" ") + "}" : "";
  }
  function e(t, c, n, h) {
    if (E.collapseEmptyAttributes !== !1 && !c) return t;
    if (E.preferUnquoted && unquoted.test(c))
      return t + "=" + c;
    const d = E.quote || h.options.quote || '"', k = d === '"' ? "'" : '"', p = E.quoteSmart && ccount(c, d) > ccount(c, k) ? k : d, M = n.type === "textDirective" ? [p] : [p, `
`, "\r"];
    return t + "=" + p + stringifyEntitiesLight(c, { subset: M }) + p;
  }
}
function enterContainer(o) {
  enter.call(this, "containerDirective", o);
}
function enterLeaf(o) {
  enter.call(this, "leafDirective", o);
}
function enterText(o) {
  enter.call(this, "textDirective", o);
}
function enter(o, E) {
  this.enter({ type: o, name: "", attributes: {}, children: [] }, E);
}
function exitName(o) {
  const E = this.stack[this.stack.length - 1];
  E.type === "containerDirective" || E.type === "leafDirective" || E.type, E.name = this.sliceSerialize(o);
}
function enterContainerLabel(o) {
  this.enter(
    { type: "paragraph", data: { directiveLabel: !0 }, children: [] },
    o
  );
}
function exitContainerLabel(o) {
  this.exit(o);
}
function enterAttributes() {
  this.data.directiveAttributes = [], this.buffer();
}
function exitAttributeIdValue(o) {
  this.data.directiveAttributes.push([
    "id",
    parseEntities(this.sliceSerialize(o), { attribute: !0 })
  ]);
}
function exitAttributeClassValue(o) {
  this.data.directiveAttributes.push([
    "class",
    parseEntities(this.sliceSerialize(o), { attribute: !0 })
  ]);
}
function exitAttributeValue(o) {
  const E = this.data.directiveAttributes;
  E[E.length - 1][1] = parseEntities(this.sliceSerialize(o), {
    attribute: !0
  });
}
function exitAttributeName(o) {
  this.data.directiveAttributes.push([this.sliceSerialize(o), ""]);
}
function exitAttributes() {
  const o = this.data.directiveAttributes, E = {};
  let A = -1;
  for (; ++A < o.length; ) {
    const e = o[A];
    e[0] === "class" && E.class ? E.class += " " + e[1] : E[e[0]] = e[1];
  }
  this.data.directiveAttributes = void 0, this.resume();
  const g = this.stack[this.stack.length - 1];
  g.type === "containerDirective" || g.type === "leafDirective" || g.type, g.attributes = E;
}
function exit$1(o) {
  this.exit(o);
}
function peekDirective() {
  return ":";
}
function inlineDirectiveLabel(o) {
  return !!(o && o.type === "paragraph" && o.data && o.data.directiveLabel);
}
function fence(o) {
  let E = 0;
  return o.type === "containerDirective" ? (visitParents(o, function(A, g) {
    if (A.type === "containerDirective") {
      let e = g.length, t = 0;
      for (; e--; )
        g[e].type === "containerDirective" && t++;
      t > E && (E = t);
    }
  }), E += 3) : o.type === "leafDirective" ? E = 2 : E = 1, ":".repeat(E);
}
function factoryAttributes(o, E, A, g, e, t, c, n, h, d, k, p, M, S, AA) {
  let H, gA;
  return CA;
  function CA(lA) {
    return o.enter(g), o.enter(e), o.consume(lA), o.exit(e), IA;
  }
  function IA(lA) {
    return lA === 35 ? (H = c, BA(lA)) : lA === 46 ? (H = n, BA(lA)) : AA && markdownSpace(lA) ? factorySpace(o, IA, "whitespace")(lA) : !AA && markdownLineEndingOrSpace(lA) ? factoryWhitespace(o, IA)(lA) : lA === null || markdownLineEnding(lA) || unicodeWhitespace(lA) || unicodePunctuation(lA) && lA !== 45 && lA !== 95 ? wA(lA) : (o.enter(t), o.enter(h), o.consume(lA), oA);
  }
  function BA(lA) {
    const NA = (
      /** @type {TokenType} */
      H + "Marker"
    );
    return o.enter(t), o.enter(H), o.enter(NA), o.consume(lA), o.exit(NA), QA;
  }
  function QA(lA) {
    if (lA === null || lA === 34 || lA === 35 || lA === 39 || lA === 46 || lA === 60 || lA === 61 || lA === 62 || lA === 96 || lA === 125 || markdownLineEndingOrSpace(lA))
      return A(lA);
    const NA = (
      /** @type {TokenType} */
      H + "Value"
    );
    return o.enter(NA), o.consume(lA), EA;
  }
  function EA(lA) {
    if (lA === null || lA === 34 || lA === 39 || lA === 60 || lA === 61 || lA === 62 || lA === 96)
      return A(lA);
    if (lA === 35 || lA === 46 || lA === 125 || markdownLineEndingOrSpace(lA)) {
      const NA = (
        /** @type {TokenType} */
        H + "Value"
      );
      return o.exit(NA), o.exit(H), o.exit(t), IA(lA);
    }
    return o.consume(lA), EA;
  }
  function oA(lA) {
    return lA === null || markdownLineEnding(lA) || unicodeWhitespace(lA) || unicodePunctuation(lA) && lA !== 45 && lA !== 46 && lA !== 58 && lA !== 95 ? (o.exit(h), AA && markdownSpace(lA) ? factorySpace(o, iA, "whitespace")(lA) : !AA && markdownLineEndingOrSpace(lA) ? factoryWhitespace(o, iA)(lA) : iA(lA)) : (o.consume(lA), oA);
  }
  function iA(lA) {
    return lA === 61 ? (o.enter(d), o.consume(lA), o.exit(d), aA) : (o.exit(t), IA(lA));
  }
  function aA(lA) {
    return lA === null || lA === 60 || lA === 61 || lA === 62 || lA === 96 || lA === 125 || AA && markdownLineEnding(lA) ? A(lA) : lA === 34 || lA === 39 ? (o.enter(k), o.enter(M), o.consume(lA), o.exit(M), gA = lA, eA) : AA && markdownSpace(lA) ? factorySpace(o, aA, "whitespace")(lA) : !AA && markdownLineEndingOrSpace(lA) ? factoryWhitespace(o, aA)(lA) : (o.enter(p), o.enter(S), o.consume(lA), gA = void 0, tA);
  }
  function tA(lA) {
    return lA === null || lA === 34 || lA === 39 || lA === 60 || lA === 61 || lA === 62 || lA === 96 ? A(lA) : lA === 125 || markdownLineEndingOrSpace(lA) ? (o.exit(S), o.exit(p), o.exit(t), IA(lA)) : (o.consume(lA), tA);
  }
  function eA(lA) {
    return lA === gA ? (o.enter(M), o.consume(lA), o.exit(M), o.exit(k), o.exit(t), nA) : (o.enter(p), cA(lA));
  }
  function cA(lA) {
    return lA === gA ? (o.exit(p), eA(lA)) : lA === null ? A(lA) : markdownLineEnding(lA) ? AA ? A(lA) : factoryWhitespace(o, cA)(lA) : (o.enter(S), o.consume(lA), DA);
  }
  function DA(lA) {
    return lA === gA || lA === null || markdownLineEnding(lA) ? (o.exit(S), cA(lA)) : (o.consume(lA), DA);
  }
  function nA(lA) {
    return lA === 125 || markdownLineEndingOrSpace(lA) ? IA(lA) : wA(lA);
  }
  function wA(lA) {
    return lA === 125 ? (o.enter(e), o.consume(lA), o.exit(e), o.exit(g), E) : A(lA);
  }
}
function factoryLabel(o, E, A, g, e, t, c) {
  let n = 0, h = 0, d;
  return k;
  function k(gA) {
    return o.enter(g), o.enter(e), o.consume(gA), o.exit(e), p;
  }
  function p(gA) {
    return gA === 93 ? (o.enter(e), o.consume(gA), o.exit(e), o.exit(g), E) : (o.enter(t), M(gA));
  }
  function M(gA) {
    if (gA === 93 && !h)
      return H(gA);
    const CA = o.enter("chunkText", {
      _contentTypeTextTrailing: !0,
      contentType: "text",
      previous: d
    });
    return d && (d.next = CA), d = CA, S(gA);
  }
  function S(gA) {
    return gA === null || n > 999 || gA === 91 && ++h > 32 ? A(gA) : gA === 93 && !h-- ? (o.exit("chunkText"), H(gA)) : markdownLineEnding(gA) ? c ? A(gA) : (o.consume(gA), o.exit("chunkText"), M) : (o.consume(gA), gA === 92 ? AA : S);
  }
  function AA(gA) {
    return gA === 91 || gA === 92 || gA === 93 ? (o.consume(gA), n++, S) : S(gA);
  }
  function H(gA) {
    return o.exit(t), o.enter(e), o.consume(gA), o.exit(e), o.exit(g), E;
  }
}
function factoryName(o, E, A, g) {
  const e = this;
  return t;
  function t(n) {
    return n === null || markdownLineEnding(n) || unicodePunctuation(n) || unicodeWhitespace(n) ? A(n) : (o.enter(g), o.consume(n), c);
  }
  function c(n) {
    return n === null || markdownLineEnding(n) || unicodeWhitespace(n) || unicodePunctuation(n) && n !== 45 && n !== 95 ? (o.exit(g), e.previous === 45 || e.previous === 95 ? A(n) : E(n)) : (o.consume(n), c);
  }
}
const directiveContainer = {
  tokenize: tokenizeDirectiveContainer,
  concrete: !0
}, label$2 = {
  tokenize: tokenizeLabel$2,
  partial: !0
}, attributes$2 = {
  tokenize: tokenizeAttributes$2,
  partial: !0
}, nonLazyLine = {
  tokenize: tokenizeNonLazyLine,
  partial: !0
};
function tokenizeDirectiveContainer(o, E, A) {
  const g = this, e = g.events[g.events.length - 1], t = e && e[1].type === "linePrefix" ? e[2].sliceSerialize(e[1], !0).length : 0;
  let c = 0, n;
  return h;
  function h(tA) {
    return o.enter("directiveContainer"), o.enter("directiveContainerFence"), o.enter("directiveContainerSequence"), d(tA);
  }
  function d(tA) {
    return tA === 58 ? (o.consume(tA), c++, d) : c < 3 ? A(tA) : (o.exit("directiveContainerSequence"), factoryName.call(g, o, k, A, "directiveContainerName")(tA));
  }
  function k(tA) {
    return tA === 91 ? o.attempt(label$2, p, p)(tA) : p(tA);
  }
  function p(tA) {
    return tA === 123 ? o.attempt(attributes$2, M, M)(tA) : M(tA);
  }
  function M(tA) {
    return factorySpace(o, S, "whitespace")(tA);
  }
  function S(tA) {
    return o.exit("directiveContainerFence"), tA === null ? iA(tA) : markdownLineEnding(tA) ? g.interrupt ? E(tA) : o.attempt(nonLazyLine, AA, iA)(tA) : A(tA);
  }
  function AA(tA) {
    return tA === null ? iA(tA) : markdownLineEnding(tA) ? o.check(nonLazyLine, BA, iA)(tA) : (o.enter("directiveContainerContent"), H(tA));
  }
  function H(tA) {
    return o.attempt({
      tokenize: aA,
      partial: !0
    }, oA, t ? factorySpace(o, gA, "linePrefix", t + 1) : gA)(tA);
  }
  function gA(tA) {
    return tA === null ? oA(tA) : markdownLineEnding(tA) ? o.check(nonLazyLine, IA, oA)(tA) : IA(tA);
  }
  function CA(tA) {
    if (tA === null) {
      const eA = o.exit("chunkDocument");
      return g.parser.lazy[eA.start.line] = !1, oA(tA);
    }
    return markdownLineEnding(tA) ? o.check(nonLazyLine, QA, EA)(tA) : (o.consume(tA), CA);
  }
  function IA(tA) {
    const eA = o.enter("chunkDocument", {
      contentType: "document",
      previous: n
    });
    return n && (n.next = eA), n = eA, CA(tA);
  }
  function BA(tA) {
    return o.enter("directiveContainerContent"), H(tA);
  }
  function QA(tA) {
    o.consume(tA);
    const eA = o.exit("chunkDocument");
    return g.parser.lazy[eA.start.line] = !1, H;
  }
  function EA(tA) {
    const eA = o.exit("chunkDocument");
    return g.parser.lazy[eA.start.line] = !1, oA(tA);
  }
  function oA(tA) {
    return o.exit("directiveContainerContent"), iA(tA);
  }
  function iA(tA) {
    return o.exit("directiveContainer"), E(tA);
  }
  function aA(tA, eA, cA) {
    let DA = 0;
    return factorySpace(tA, nA, "linePrefix", g.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4);
    function nA(NA) {
      return tA.enter("directiveContainerFence"), tA.enter("directiveContainerSequence"), wA(NA);
    }
    function wA(NA) {
      return NA === 58 ? (tA.consume(NA), DA++, wA) : DA < c ? cA(NA) : (tA.exit("directiveContainerSequence"), factorySpace(tA, lA, "whitespace")(NA));
    }
    function lA(NA) {
      return NA === null || markdownLineEnding(NA) ? (tA.exit("directiveContainerFence"), eA(NA)) : cA(NA);
    }
  }
}
function tokenizeLabel$2(o, E, A) {
  return factoryLabel(o, E, A, "directiveContainerLabel", "directiveContainerLabelMarker", "directiveContainerLabelString", !0);
}
function tokenizeAttributes$2(o, E, A) {
  return factoryAttributes(o, E, A, "directiveContainerAttributes", "directiveContainerAttributesMarker", "directiveContainerAttribute", "directiveContainerAttributeId", "directiveContainerAttributeClass", "directiveContainerAttributeName", "directiveContainerAttributeInitializerMarker", "directiveContainerAttributeValueLiteral", "directiveContainerAttributeValue", "directiveContainerAttributeValueMarker", "directiveContainerAttributeValueData", !0);
}
function tokenizeNonLazyLine(o, E, A) {
  const g = this;
  return e;
  function e(c) {
    return o.enter("lineEnding"), o.consume(c), o.exit("lineEnding"), t;
  }
  function t(c) {
    return g.parser.lazy[g.now().line] ? A(c) : E(c);
  }
}
const directiveLeaf = {
  tokenize: tokenizeDirectiveLeaf
}, label$1 = {
  tokenize: tokenizeLabel$1,
  partial: !0
}, attributes$1 = {
  tokenize: tokenizeAttributes$1,
  partial: !0
};
function tokenizeDirectiveLeaf(o, E, A) {
  const g = this;
  return e;
  function e(k) {
    return o.enter("directiveLeaf"), o.enter("directiveLeafSequence"), o.consume(k), t;
  }
  function t(k) {
    return k === 58 ? (o.consume(k), o.exit("directiveLeafSequence"), factoryName.call(g, o, c, A, "directiveLeafName")) : A(k);
  }
  function c(k) {
    return k === 91 ? o.attempt(label$1, n, n)(k) : n(k);
  }
  function n(k) {
    return k === 123 ? o.attempt(attributes$1, h, h)(k) : h(k);
  }
  function h(k) {
    return factorySpace(o, d, "whitespace")(k);
  }
  function d(k) {
    return k === null || markdownLineEnding(k) ? (o.exit("directiveLeaf"), E(k)) : A(k);
  }
}
function tokenizeLabel$1(o, E, A) {
  return factoryLabel(o, E, A, "directiveLeafLabel", "directiveLeafLabelMarker", "directiveLeafLabelString", !0);
}
function tokenizeAttributes$1(o, E, A) {
  return factoryAttributes(o, E, A, "directiveLeafAttributes", "directiveLeafAttributesMarker", "directiveLeafAttribute", "directiveLeafAttributeId", "directiveLeafAttributeClass", "directiveLeafAttributeName", "directiveLeafAttributeInitializerMarker", "directiveLeafAttributeValueLiteral", "directiveLeafAttributeValue", "directiveLeafAttributeValueMarker", "directiveLeafAttributeValueData", !0);
}
const directiveText = {
  tokenize: tokenizeDirectiveText,
  previous: previous$2
}, label = {
  tokenize: tokenizeLabel,
  partial: !0
}, attributes = {
  tokenize: tokenizeAttributes,
  partial: !0
};
function previous$2(o) {
  return o !== 58 || this.events[this.events.length - 1][1].type === "characterEscape";
}
function tokenizeDirectiveText(o, E, A) {
  const g = this;
  return e;
  function e(h) {
    return o.enter("directiveText"), o.enter("directiveTextMarker"), o.consume(h), o.exit("directiveTextMarker"), factoryName.call(g, o, t, A, "directiveTextName");
  }
  function t(h) {
    return h === 58 ? A(h) : h === 91 ? o.attempt(label, c, c)(h) : c(h);
  }
  function c(h) {
    return h === 123 ? o.attempt(attributes, n, n)(h) : n(h);
  }
  function n(h) {
    return o.exit("directiveText"), E(h);
  }
}
function tokenizeLabel(o, E, A) {
  return factoryLabel(o, E, A, "directiveTextLabel", "directiveTextLabelMarker", "directiveTextLabelString");
}
function tokenizeAttributes(o, E, A) {
  return factoryAttributes(o, E, A, "directiveTextAttributes", "directiveTextAttributesMarker", "directiveTextAttribute", "directiveTextAttributeId", "directiveTextAttributeClass", "directiveTextAttributeName", "directiveTextAttributeInitializerMarker", "directiveTextAttributeValueLiteral", "directiveTextAttributeValue", "directiveTextAttributeValueMarker", "directiveTextAttributeValueData");
}
function directive() {
  return {
    text: {
      58: directiveText
    },
    flow: {
      58: [directiveContainer, directiveLeaf]
    }
  };
}
function remarkDirective() {
  const E = /** @type {Processor<Root>} */ this.data(), A = E.micromarkExtensions || (E.micromarkExtensions = []), g = E.fromMarkdownExtensions || (E.fromMarkdownExtensions = []), e = E.toMarkdownExtensions || (E.toMarkdownExtensions = []);
  A.push(directive()), g.push(directiveFromMarkdown()), e.push(directiveToMarkdown());
}
const inConstruct = "phrasing", notInConstruct = ["autolink", "link", "image", "label"];
function gfmAutolinkLiteralFromMarkdown() {
  return {
    transforms: [transformGfmAutolinkLiterals],
    enter: {
      literalAutolink: enterLiteralAutolink,
      literalAutolinkEmail: enterLiteralAutolinkValue,
      literalAutolinkHttp: enterLiteralAutolinkValue,
      literalAutolinkWww: enterLiteralAutolinkValue
    },
    exit: {
      literalAutolink: exitLiteralAutolink,
      literalAutolinkEmail: exitLiteralAutolinkEmail,
      literalAutolinkHttp: exitLiteralAutolinkHttp,
      literalAutolinkWww: exitLiteralAutolinkWww
    }
  };
}
function gfmAutolinkLiteralToMarkdown() {
  return {
    unsafe: [
      {
        character: "@",
        before: "[+\\-.\\w]",
        after: "[\\-.\\w]",
        inConstruct,
        notInConstruct
      },
      {
        character: ".",
        before: "[Ww]",
        after: "[\\-.\\w]",
        inConstruct,
        notInConstruct
      },
      {
        character: ":",
        before: "[ps]",
        after: "\\/",
        inConstruct,
        notInConstruct
      }
    ]
  };
}
function enterLiteralAutolink(o) {
  this.enter({ type: "link", title: null, url: "", children: [] }, o);
}
function enterLiteralAutolinkValue(o) {
  this.config.enter.autolinkProtocol.call(this, o);
}
function exitLiteralAutolinkHttp(o) {
  this.config.exit.autolinkProtocol.call(this, o);
}
function exitLiteralAutolinkWww(o) {
  this.config.exit.data.call(this, o);
  const E = this.stack[this.stack.length - 1];
  E.type, E.url = "http://" + this.sliceSerialize(o);
}
function exitLiteralAutolinkEmail(o) {
  this.config.exit.autolinkEmail.call(this, o);
}
function exitLiteralAutolink(o) {
  this.exit(o);
}
function transformGfmAutolinkLiterals(o) {
  findAndReplace(
    o,
    [
      [/(https?:\/\/|www(?=\.))([-.\w]+)([^ \t\r\n]*)/gi, findUrl],
      [new RegExp("(?<=^|\\s|\\p{P}|\\p{S})([-.\\w+]+)@([-\\w]+(?:\\.[-\\w]+)+)", "gu"), findEmail]
    ],
    { ignore: ["link", "linkReference"] }
  );
}
function findUrl(o, E, A, g, e) {
  let t = "";
  if (!previous$1(e) || (/^w/i.test(E) && (A = E + A, E = "", t = "http://"), !isCorrectDomain(A)))
    return !1;
  const c = splitUrl(A + g);
  if (!c[0]) return !1;
  const n = {
    type: "link",
    title: null,
    url: t + E + c[0],
    children: [{ type: "text", value: E + c[0] }]
  };
  return c[1] ? [n, { type: "text", value: c[1] }] : n;
}
function findEmail(o, E, A, g) {
  return (
    // Not an expected previous character.
    !previous$1(g, !0) || // Label ends in not allowed character.
    /[-\d_]$/.test(A) ? !1 : {
      type: "link",
      title: null,
      url: "mailto:" + E + "@" + A,
      children: [{ type: "text", value: E + "@" + A }]
    }
  );
}
function isCorrectDomain(o) {
  const E = o.split(".");
  return !(E.length < 2 || E[E.length - 1] && (/_/.test(E[E.length - 1]) || !/[a-zA-Z\d]/.test(E[E.length - 1])) || E[E.length - 2] && (/_/.test(E[E.length - 2]) || !/[a-zA-Z\d]/.test(E[E.length - 2])));
}
function splitUrl(o) {
  const E = /[!"&'),.:;<>?\]}]+$/.exec(o);
  if (!E)
    return [o, void 0];
  o = o.slice(0, E.index);
  let A = E[0], g = A.indexOf(")");
  const e = ccount(o, "(");
  let t = ccount(o, ")");
  for (; g !== -1 && e > t; )
    o += A.slice(0, g + 1), A = A.slice(g + 1), g = A.indexOf(")"), t++;
  return [o, A];
}
function previous$1(o, E) {
  const A = o.input.charCodeAt(o.index - 1);
  return (o.index === 0 || unicodeWhitespace(A) || unicodePunctuation(A)) && // If it’s an email, the previous character should not be a slash.
  (!E || A !== 47);
}
footnoteReference.peek = footnoteReferencePeek;
function enterFootnoteCallString() {
  this.buffer();
}
function enterFootnoteCall(o) {
  this.enter({ type: "footnoteReference", identifier: "", label: "" }, o);
}
function enterFootnoteDefinitionLabelString() {
  this.buffer();
}
function enterFootnoteDefinition(o) {
  this.enter(
    { type: "footnoteDefinition", identifier: "", label: "", children: [] },
    o
  );
}
function exitFootnoteCallString(o) {
  const E = this.resume(), A = this.stack[this.stack.length - 1];
  A.type, A.identifier = normalizeIdentifier(
    this.sliceSerialize(o)
  ).toLowerCase(), A.label = E;
}
function exitFootnoteCall(o) {
  this.exit(o);
}
function exitFootnoteDefinitionLabelString(o) {
  const E = this.resume(), A = this.stack[this.stack.length - 1];
  A.type, A.identifier = normalizeIdentifier(
    this.sliceSerialize(o)
  ).toLowerCase(), A.label = E;
}
function exitFootnoteDefinition(o) {
  this.exit(o);
}
function footnoteReferencePeek() {
  return "[";
}
function footnoteReference(o, E, A, g) {
  const e = A.createTracker(g);
  let t = e.move("[^");
  const c = A.enter("footnoteReference"), n = A.enter("reference");
  return t += e.move(
    A.safe(A.associationId(o), { after: "]", before: t })
  ), n(), c(), t += e.move("]"), t;
}
function gfmFootnoteFromMarkdown() {
  return {
    enter: {
      gfmFootnoteCallString: enterFootnoteCallString,
      gfmFootnoteCall: enterFootnoteCall,
      gfmFootnoteDefinitionLabelString: enterFootnoteDefinitionLabelString,
      gfmFootnoteDefinition: enterFootnoteDefinition
    },
    exit: {
      gfmFootnoteCallString: exitFootnoteCallString,
      gfmFootnoteCall: exitFootnoteCall,
      gfmFootnoteDefinitionLabelString: exitFootnoteDefinitionLabelString,
      gfmFootnoteDefinition: exitFootnoteDefinition
    }
  };
}
function gfmFootnoteToMarkdown(o) {
  let E = !1;
  return o && o.firstLineBlank && (E = !0), {
    handlers: { footnoteDefinition: A, footnoteReference },
    // This is on by default already.
    unsafe: [{ character: "[", inConstruct: ["label", "phrasing", "reference"] }]
  };
  function A(g, e, t, c) {
    const n = t.createTracker(c);
    let h = n.move("[^");
    const d = t.enter("footnoteDefinition"), k = t.enter("label");
    return h += n.move(
      t.safe(t.associationId(g), { before: h, after: "]" })
    ), k(), h += n.move("]:"), g.children && g.children.length > 0 && (n.shift(4), h += n.move(
      (E ? `
` : " ") + t.indentLines(
        t.containerFlow(g, n.current()),
        E ? mapAll : mapExceptFirst
      )
    )), d(), h;
  }
}
function mapExceptFirst(o, E, A) {
  return E === 0 ? o : mapAll(o, E, A);
}
function mapAll(o, E, A) {
  return (A ? "" : "    ") + o;
}
const constructsWithoutStrikethrough = [
  "autolink",
  "destinationLiteral",
  "destinationRaw",
  "reference",
  "titleQuote",
  "titleApostrophe"
];
handleDelete.peek = peekDelete;
function gfmStrikethroughFromMarkdown() {
  return {
    canContainEols: ["delete"],
    enter: { strikethrough: enterStrikethrough },
    exit: { strikethrough: exitStrikethrough }
  };
}
function gfmStrikethroughToMarkdown() {
  return {
    unsafe: [
      {
        character: "~",
        inConstruct: "phrasing",
        notInConstruct: constructsWithoutStrikethrough
      }
    ],
    handlers: { delete: handleDelete }
  };
}
function enterStrikethrough(o) {
  this.enter({ type: "delete", children: [] }, o);
}
function exitStrikethrough(o) {
  this.exit(o);
}
function handleDelete(o, E, A, g) {
  const e = A.createTracker(g), t = A.enter("strikethrough");
  let c = e.move("~~");
  return c += A.containerPhrasing(o, {
    ...e.current(),
    before: c,
    after: "~"
  }), c += e.move("~~"), t(), c;
}
function peekDelete() {
  return "~";
}
function defaultStringLength(o) {
  return o.length;
}
function markdownTable(o, E) {
  const A = E || {}, g = (A.align || []).concat(), e = A.stringLength || defaultStringLength, t = [], c = [], n = [], h = [];
  let d = 0, k = -1;
  for (; ++k < o.length; ) {
    const H = [], gA = [];
    let CA = -1;
    for (o[k].length > d && (d = o[k].length); ++CA < o[k].length; ) {
      const IA = serialize(o[k][CA]);
      if (A.alignDelimiters !== !1) {
        const BA = e(IA);
        gA[CA] = BA, (h[CA] === void 0 || BA > h[CA]) && (h[CA] = BA);
      }
      H.push(IA);
    }
    c[k] = H, n[k] = gA;
  }
  let p = -1;
  if (typeof g == "object" && "length" in g)
    for (; ++p < d; )
      t[p] = toAlignment(g[p]);
  else {
    const H = toAlignment(g);
    for (; ++p < d; )
      t[p] = H;
  }
  p = -1;
  const M = [], S = [];
  for (; ++p < d; ) {
    const H = t[p];
    let gA = "", CA = "";
    H === 99 ? (gA = ":", CA = ":") : H === 108 ? gA = ":" : H === 114 && (CA = ":");
    let IA = A.alignDelimiters === !1 ? 1 : Math.max(
      1,
      h[p] - gA.length - CA.length
    );
    const BA = gA + "-".repeat(IA) + CA;
    A.alignDelimiters !== !1 && (IA = gA.length + IA + CA.length, IA > h[p] && (h[p] = IA), S[p] = IA), M[p] = BA;
  }
  c.splice(1, 0, M), n.splice(1, 0, S), k = -1;
  const AA = [];
  for (; ++k < c.length; ) {
    const H = c[k], gA = n[k];
    p = -1;
    const CA = [];
    for (; ++p < d; ) {
      const IA = H[p] || "";
      let BA = "", QA = "";
      if (A.alignDelimiters !== !1) {
        const EA = h[p] - (gA[p] || 0), oA = t[p];
        oA === 114 ? BA = " ".repeat(EA) : oA === 99 ? EA % 2 ? (BA = " ".repeat(EA / 2 + 0.5), QA = " ".repeat(EA / 2 - 0.5)) : (BA = " ".repeat(EA / 2), QA = BA) : QA = " ".repeat(EA);
      }
      A.delimiterStart !== !1 && !p && CA.push("|"), A.padding !== !1 && // Don’t add the opening space if we’re not aligning and the cell is
      // empty: there will be a closing space.
      !(A.alignDelimiters === !1 && IA === "") && (A.delimiterStart !== !1 || p) && CA.push(" "), A.alignDelimiters !== !1 && CA.push(BA), CA.push(IA), A.alignDelimiters !== !1 && CA.push(QA), A.padding !== !1 && CA.push(" "), (A.delimiterEnd !== !1 || p !== d - 1) && CA.push("|");
    }
    AA.push(
      A.delimiterEnd === !1 ? CA.join("").replace(/ +$/, "") : CA.join("")
    );
  }
  return AA.join(`
`);
}
function serialize(o) {
  return o == null ? "" : String(o);
}
function toAlignment(o) {
  const E = typeof o == "string" ? o.codePointAt(0) : 0;
  return E === 67 || E === 99 ? 99 : E === 76 || E === 108 ? 108 : E === 82 || E === 114 ? 114 : 0;
}
function blockquote(o, E, A, g) {
  const e = A.enter("blockquote"), t = A.createTracker(g);
  t.move("> "), t.shift(2);
  const c = A.indentLines(
    A.containerFlow(o, t.current()),
    map$2
  );
  return e(), c;
}
function map$2(o, E, A) {
  return ">" + (A ? "" : " ") + o;
}
function patternInScope(o, E) {
  return listInScope(o, E.inConstruct, !0) && !listInScope(o, E.notInConstruct, !1);
}
function listInScope(o, E, A) {
  if (typeof E == "string" && (E = [E]), !E || E.length === 0)
    return A;
  let g = -1;
  for (; ++g < E.length; )
    if (o.includes(E[g]))
      return !0;
  return !1;
}
function hardBreak(o, E, A, g) {
  let e = -1;
  for (; ++e < A.unsafe.length; )
    if (A.unsafe[e].character === `
` && patternInScope(A.stack, A.unsafe[e]))
      return /[ \t]/.test(g.before) ? "" : " ";
  return `\\
`;
}
function longestStreak(o, E) {
  const A = String(o);
  let g = A.indexOf(E), e = g, t = 0, c = 0;
  if (typeof E != "string")
    throw new TypeError("Expected substring");
  for (; g !== -1; )
    g === e ? ++t > c && (c = t) : t = 1, e = g + E.length, g = A.indexOf(E, e);
  return c;
}
function formatCodeAsIndented(o, E) {
  return !!(E.options.fences === !1 && o.value && // If there’s no info…
  !o.lang && // And there’s a non-whitespace character…
  /[^ \r\n]/.test(o.value) && // And the value doesn’t start or end in a blank…
  !/^[\t ]*(?:[\r\n]|$)|(?:^|[\r\n])[\t ]*$/.test(o.value));
}
function checkFence(o) {
  const E = o.options.fence || "`";
  if (E !== "`" && E !== "~")
    throw new Error(
      "Cannot serialize code with `" + E + "` for `options.fence`, expected `` ` `` or `~`"
    );
  return E;
}
function code$2(o, E, A, g) {
  const e = checkFence(A), t = o.value || "", c = e === "`" ? "GraveAccent" : "Tilde";
  if (formatCodeAsIndented(o, A)) {
    const p = A.enter("codeIndented"), M = A.indentLines(t, map$1);
    return p(), M;
  }
  const n = A.createTracker(g), h = e.repeat(Math.max(longestStreak(t, e) + 1, 3)), d = A.enter("codeFenced");
  let k = n.move(h);
  if (o.lang) {
    const p = A.enter(`codeFencedLang${c}`);
    k += n.move(
      A.safe(o.lang, {
        before: k,
        after: " ",
        encode: ["`"],
        ...n.current()
      })
    ), p();
  }
  if (o.lang && o.meta) {
    const p = A.enter(`codeFencedMeta${c}`);
    k += n.move(" "), k += n.move(
      A.safe(o.meta, {
        before: k,
        after: `
`,
        encode: ["`"],
        ...n.current()
      })
    ), p();
  }
  return k += n.move(`
`), t && (k += n.move(t + `
`)), k += n.move(h), d(), k;
}
function map$1(o, E, A) {
  return (A ? "" : "    ") + o;
}
function checkQuote(o) {
  const E = o.options.quote || '"';
  if (E !== '"' && E !== "'")
    throw new Error(
      "Cannot serialize title with `" + E + "` for `options.quote`, expected `\"`, or `'`"
    );
  return E;
}
function definition(o, E, A, g) {
  const e = checkQuote(A), t = e === '"' ? "Quote" : "Apostrophe", c = A.enter("definition");
  let n = A.enter("label");
  const h = A.createTracker(g);
  let d = h.move("[");
  return d += h.move(
    A.safe(A.associationId(o), {
      before: d,
      after: "]",
      ...h.current()
    })
  ), d += h.move("]: "), n(), // If there’s no url, or…
  !o.url || // If there are control characters or whitespace.
  /[\0- \u007F]/.test(o.url) ? (n = A.enter("destinationLiteral"), d += h.move("<"), d += h.move(
    A.safe(o.url, { before: d, after: ">", ...h.current() })
  ), d += h.move(">")) : (n = A.enter("destinationRaw"), d += h.move(
    A.safe(o.url, {
      before: d,
      after: o.title ? " " : `
`,
      ...h.current()
    })
  )), n(), o.title && (n = A.enter(`title${t}`), d += h.move(" " + e), d += h.move(
    A.safe(o.title, {
      before: d,
      after: e,
      ...h.current()
    })
  ), d += h.move(e), n()), c(), d;
}
function checkEmphasis(o) {
  const E = o.options.emphasis || "*";
  if (E !== "*" && E !== "_")
    throw new Error(
      "Cannot serialize emphasis with `" + E + "` for `options.emphasis`, expected `*`, or `_`"
    );
  return E;
}
function encodeCharacterReference(o) {
  return "&#x" + o.toString(16).toUpperCase() + ";";
}
function encodeInfo(o, E, A) {
  const g = classifyCharacter(o), e = classifyCharacter(E);
  return g === void 0 ? e === void 0 ? (
    // Letter inside:
    // we have to encode *both* letters for `_` as it is looser.
    // it already forms for `*` (and GFMs `~`).
    A === "_" ? { inside: !0, outside: !0 } : { inside: !1, outside: !1 }
  ) : e === 1 ? (
    // Whitespace inside: encode both (letter, whitespace).
    { inside: !0, outside: !0 }
  ) : (
    // Punctuation inside: encode outer (letter)
    { inside: !1, outside: !0 }
  ) : g === 1 ? e === void 0 ? (
    // Letter inside: already forms.
    { inside: !1, outside: !1 }
  ) : e === 1 ? (
    // Whitespace inside: encode both (whitespace).
    { inside: !0, outside: !0 }
  ) : (
    // Punctuation inside: already forms.
    { inside: !1, outside: !1 }
  ) : e === void 0 ? (
    // Letter inside: already forms.
    { inside: !1, outside: !1 }
  ) : e === 1 ? (
    // Whitespace inside: encode inner (whitespace).
    { inside: !0, outside: !1 }
  ) : (
    // Punctuation inside: already forms.
    { inside: !1, outside: !1 }
  );
}
emphasis.peek = emphasisPeek;
function emphasis(o, E, A, g) {
  const e = checkEmphasis(A), t = A.enter("emphasis"), c = A.createTracker(g), n = c.move(e);
  let h = c.move(
    A.containerPhrasing(o, {
      after: e,
      before: n,
      ...c.current()
    })
  );
  const d = h.charCodeAt(0), k = encodeInfo(
    g.before.charCodeAt(g.before.length - 1),
    d,
    e
  );
  k.inside && (h = encodeCharacterReference(d) + h.slice(1));
  const p = h.charCodeAt(h.length - 1), M = encodeInfo(g.after.charCodeAt(0), p, e);
  M.inside && (h = h.slice(0, -1) + encodeCharacterReference(p));
  const S = c.move(e);
  return t(), A.attentionEncodeSurroundingInfo = {
    after: M.outside,
    before: k.outside
  }, n + h + S;
}
function emphasisPeek(o, E, A) {
  return A.options.emphasis || "*";
}
function formatHeadingAsSetext(o, E) {
  let A = !1;
  return visit(o, function(g) {
    if ("value" in g && /\r?\n|\r/.test(g.value) || g.type === "break")
      return A = !0, EXIT;
  }), !!((!o.depth || o.depth < 3) && toString$2(o) && (E.options.setext || A));
}
function heading(o, E, A, g) {
  const e = Math.max(Math.min(6, o.depth || 1), 1), t = A.createTracker(g);
  if (formatHeadingAsSetext(o, A)) {
    const k = A.enter("headingSetext"), p = A.enter("phrasing"), M = A.containerPhrasing(o, {
      ...t.current(),
      before: `
`,
      after: `
`
    });
    return p(), k(), M + `
` + (e === 1 ? "=" : "-").repeat(
      // The whole size…
      M.length - // Minus the position of the character after the last EOL (or
      // 0 if there is none)…
      (Math.max(M.lastIndexOf("\r"), M.lastIndexOf(`
`)) + 1)
    );
  }
  const c = "#".repeat(e), n = A.enter("headingAtx"), h = A.enter("phrasing");
  t.move(c + " ");
  let d = A.containerPhrasing(o, {
    before: "# ",
    after: `
`,
    ...t.current()
  });
  return /^[\t ]/.test(d) && (d = encodeCharacterReference(d.charCodeAt(0)) + d.slice(1)), d = d ? c + " " + d : c, A.options.closeAtx && (d += " " + c), h(), n(), d;
}
html.peek = htmlPeek;
function html(o) {
  return o.value || "";
}
function htmlPeek() {
  return "<";
}
image.peek = imagePeek;
function image(o, E, A, g) {
  const e = checkQuote(A), t = e === '"' ? "Quote" : "Apostrophe", c = A.enter("image");
  let n = A.enter("label");
  const h = A.createTracker(g);
  let d = h.move("![");
  return d += h.move(
    A.safe(o.alt, { before: d, after: "]", ...h.current() })
  ), d += h.move("]("), n(), // If there’s no url but there is a title…
  !o.url && o.title || // If there are control characters or whitespace.
  /[\0- \u007F]/.test(o.url) ? (n = A.enter("destinationLiteral"), d += h.move("<"), d += h.move(
    A.safe(o.url, { before: d, after: ">", ...h.current() })
  ), d += h.move(">")) : (n = A.enter("destinationRaw"), d += h.move(
    A.safe(o.url, {
      before: d,
      after: o.title ? " " : ")",
      ...h.current()
    })
  )), n(), o.title && (n = A.enter(`title${t}`), d += h.move(" " + e), d += h.move(
    A.safe(o.title, {
      before: d,
      after: e,
      ...h.current()
    })
  ), d += h.move(e), n()), d += h.move(")"), c(), d;
}
function imagePeek() {
  return "!";
}
imageReference.peek = imageReferencePeek;
function imageReference(o, E, A, g) {
  const e = o.referenceType, t = A.enter("imageReference");
  let c = A.enter("label");
  const n = A.createTracker(g);
  let h = n.move("![");
  const d = A.safe(o.alt, {
    before: h,
    after: "]",
    ...n.current()
  });
  h += n.move(d + "]["), c();
  const k = A.stack;
  A.stack = [], c = A.enter("reference");
  const p = A.safe(A.associationId(o), {
    before: h,
    after: "]",
    ...n.current()
  });
  return c(), A.stack = k, t(), e === "full" || !d || d !== p ? h += n.move(p + "]") : e === "shortcut" ? h = h.slice(0, -1) : h += n.move("]"), h;
}
function imageReferencePeek() {
  return "!";
}
inlineCode.peek = inlineCodePeek;
function inlineCode(o, E, A) {
  let g = o.value || "", e = "`", t = -1;
  for (; new RegExp("(^|[^`])" + e + "([^`]|$)").test(g); )
    e += "`";
  for (/[^ \r\n]/.test(g) && (/^[ \r\n]/.test(g) && /[ \r\n]$/.test(g) || /^`|`$/.test(g)) && (g = " " + g + " "); ++t < A.unsafe.length; ) {
    const c = A.unsafe[t], n = A.compilePattern(c);
    let h;
    if (c.atBreak)
      for (; h = n.exec(g); ) {
        let d = h.index;
        g.charCodeAt(d) === 10 && g.charCodeAt(d - 1) === 13 && d--, g = g.slice(0, d) + " " + g.slice(h.index + 1);
      }
  }
  return e + g + e;
}
function inlineCodePeek() {
  return "`";
}
function formatLinkAsAutolink(o, E) {
  const A = toString$2(o);
  return !!(!E.options.resourceLink && // If there’s a url…
  o.url && // And there’s a no title…
  !o.title && // And the content of `node` is a single text node…
  o.children && o.children.length === 1 && o.children[0].type === "text" && // And if the url is the same as the content…
  (A === o.url || "mailto:" + A === o.url) && // And that starts w/ a protocol…
  /^[a-z][a-z+.-]+:/i.test(o.url) && // And that doesn’t contain ASCII control codes (character escapes and
  // references don’t work), space, or angle brackets…
  !/[\0- <>\u007F]/.test(o.url));
}
link.peek = linkPeek;
function link(o, E, A, g) {
  const e = checkQuote(A), t = e === '"' ? "Quote" : "Apostrophe", c = A.createTracker(g);
  let n, h;
  if (formatLinkAsAutolink(o, A)) {
    const k = A.stack;
    A.stack = [], n = A.enter("autolink");
    let p = c.move("<");
    return p += c.move(
      A.containerPhrasing(o, {
        before: p,
        after: ">",
        ...c.current()
      })
    ), p += c.move(">"), n(), A.stack = k, p;
  }
  n = A.enter("link"), h = A.enter("label");
  let d = c.move("[");
  return d += c.move(
    A.containerPhrasing(o, {
      before: d,
      after: "](",
      ...c.current()
    })
  ), d += c.move("]("), h(), // If there’s no url but there is a title…
  !o.url && o.title || // If there are control characters or whitespace.
  /[\0- \u007F]/.test(o.url) ? (h = A.enter("destinationLiteral"), d += c.move("<"), d += c.move(
    A.safe(o.url, { before: d, after: ">", ...c.current() })
  ), d += c.move(">")) : (h = A.enter("destinationRaw"), d += c.move(
    A.safe(o.url, {
      before: d,
      after: o.title ? " " : ")",
      ...c.current()
    })
  )), h(), o.title && (h = A.enter(`title${t}`), d += c.move(" " + e), d += c.move(
    A.safe(o.title, {
      before: d,
      after: e,
      ...c.current()
    })
  ), d += c.move(e), h()), d += c.move(")"), n(), d;
}
function linkPeek(o, E, A) {
  return formatLinkAsAutolink(o, A) ? "<" : "[";
}
linkReference.peek = linkReferencePeek;
function linkReference(o, E, A, g) {
  const e = o.referenceType, t = A.enter("linkReference");
  let c = A.enter("label");
  const n = A.createTracker(g);
  let h = n.move("[");
  const d = A.containerPhrasing(o, {
    before: h,
    after: "]",
    ...n.current()
  });
  h += n.move(d + "]["), c();
  const k = A.stack;
  A.stack = [], c = A.enter("reference");
  const p = A.safe(A.associationId(o), {
    before: h,
    after: "]",
    ...n.current()
  });
  return c(), A.stack = k, t(), e === "full" || !d || d !== p ? h += n.move(p + "]") : e === "shortcut" ? h = h.slice(0, -1) : h += n.move("]"), h;
}
function linkReferencePeek() {
  return "[";
}
function checkBullet(o) {
  const E = o.options.bullet || "*";
  if (E !== "*" && E !== "+" && E !== "-")
    throw new Error(
      "Cannot serialize items with `" + E + "` for `options.bullet`, expected `*`, `+`, or `-`"
    );
  return E;
}
function checkBulletOther(o) {
  const E = checkBullet(o), A = o.options.bulletOther;
  if (!A)
    return E === "*" ? "-" : "*";
  if (A !== "*" && A !== "+" && A !== "-")
    throw new Error(
      "Cannot serialize items with `" + A + "` for `options.bulletOther`, expected `*`, `+`, or `-`"
    );
  if (A === E)
    throw new Error(
      "Expected `bullet` (`" + E + "`) and `bulletOther` (`" + A + "`) to be different"
    );
  return A;
}
function checkBulletOrdered(o) {
  const E = o.options.bulletOrdered || ".";
  if (E !== "." && E !== ")")
    throw new Error(
      "Cannot serialize items with `" + E + "` for `options.bulletOrdered`, expected `.` or `)`"
    );
  return E;
}
function checkRule(o) {
  const E = o.options.rule || "*";
  if (E !== "*" && E !== "-" && E !== "_")
    throw new Error(
      "Cannot serialize rules with `" + E + "` for `options.rule`, expected `*`, `-`, or `_`"
    );
  return E;
}
function list(o, E, A, g) {
  const e = A.enter("list"), t = A.bulletCurrent;
  let c = o.ordered ? checkBulletOrdered(A) : checkBullet(A);
  const n = o.ordered ? c === "." ? ")" : "." : checkBulletOther(A);
  let h = E && A.bulletLastUsed ? c === A.bulletLastUsed : !1;
  if (!o.ordered) {
    const k = o.children ? o.children[0] : void 0;
    if (
      // Bullet could be used as a thematic break marker:
      (c === "*" || c === "-") && // Empty first list item:
      k && (!k.children || !k.children[0]) && // Directly in two other list items:
      A.stack[A.stack.length - 1] === "list" && A.stack[A.stack.length - 2] === "listItem" && A.stack[A.stack.length - 3] === "list" && A.stack[A.stack.length - 4] === "listItem" && // That are each the first child.
      A.indexStack[A.indexStack.length - 1] === 0 && A.indexStack[A.indexStack.length - 2] === 0 && A.indexStack[A.indexStack.length - 3] === 0 && (h = !0), checkRule(A) === c && k
    ) {
      let p = -1;
      for (; ++p < o.children.length; ) {
        const M = o.children[p];
        if (M && M.type === "listItem" && M.children && M.children[0] && M.children[0].type === "thematicBreak") {
          h = !0;
          break;
        }
      }
    }
  }
  h && (c = n), A.bulletCurrent = c;
  const d = A.containerFlow(o, g);
  return A.bulletLastUsed = c, A.bulletCurrent = t, e(), d;
}
function checkListItemIndent(o) {
  const E = o.options.listItemIndent || "one";
  if (E !== "tab" && E !== "one" && E !== "mixed")
    throw new Error(
      "Cannot serialize items with `" + E + "` for `options.listItemIndent`, expected `tab`, `one`, or `mixed`"
    );
  return E;
}
function listItem(o, E, A, g) {
  const e = checkListItemIndent(A);
  let t = A.bulletCurrent || checkBullet(A);
  E && E.type === "list" && E.ordered && (t = (typeof E.start == "number" && E.start > -1 ? E.start : 1) + (A.options.incrementListMarker === !1 ? 0 : E.children.indexOf(o)) + t);
  let c = t.length + 1;
  (e === "tab" || e === "mixed" && (E && E.type === "list" && E.spread || o.spread)) && (c = Math.ceil(c / 4) * 4);
  const n = A.createTracker(g);
  n.move(t + " ".repeat(c - t.length)), n.shift(c);
  const h = A.enter("listItem"), d = A.indentLines(
    A.containerFlow(o, n.current()),
    k
  );
  return h(), d;
  function k(p, M, S) {
    return M ? (S ? "" : " ".repeat(c)) + p : (S ? t : t + " ".repeat(c - t.length)) + p;
  }
}
function paragraph(o, E, A, g) {
  const e = A.enter("paragraph"), t = A.enter("phrasing"), c = A.containerPhrasing(o, g);
  return t(), e(), c;
}
const phrasing = (
  /** @type {(node?: unknown) => node is Exclude<PhrasingContent, Html>} */
  convert([
    "break",
    "delete",
    "emphasis",
    // To do: next major: removed since footnotes were added to GFM.
    "footnote",
    "footnoteReference",
    "image",
    "imageReference",
    "inlineCode",
    // Enabled by `mdast-util-math`:
    "inlineMath",
    "link",
    "linkReference",
    // Enabled by `mdast-util-mdx`:
    "mdxJsxTextElement",
    // Enabled by `mdast-util-mdx`:
    "mdxTextExpression",
    "strong",
    "text",
    // Enabled by `mdast-util-directive`:
    "textDirective"
  ])
);
function root$1(o, E, A, g) {
  return (o.children.some(function(c) {
    return phrasing(c);
  }) ? A.containerPhrasing : A.containerFlow).call(A, o, g);
}
function checkStrong(o) {
  const E = o.options.strong || "*";
  if (E !== "*" && E !== "_")
    throw new Error(
      "Cannot serialize strong with `" + E + "` for `options.strong`, expected `*`, or `_`"
    );
  return E;
}
strong.peek = strongPeek;
function strong(o, E, A, g) {
  const e = checkStrong(A), t = A.enter("strong"), c = A.createTracker(g), n = c.move(e + e);
  let h = c.move(
    A.containerPhrasing(o, {
      after: e,
      before: n,
      ...c.current()
    })
  );
  const d = h.charCodeAt(0), k = encodeInfo(
    g.before.charCodeAt(g.before.length - 1),
    d,
    e
  );
  k.inside && (h = encodeCharacterReference(d) + h.slice(1));
  const p = h.charCodeAt(h.length - 1), M = encodeInfo(g.after.charCodeAt(0), p, e);
  M.inside && (h = h.slice(0, -1) + encodeCharacterReference(p));
  const S = c.move(e + e);
  return t(), A.attentionEncodeSurroundingInfo = {
    after: M.outside,
    before: k.outside
  }, n + h + S;
}
function strongPeek(o, E, A) {
  return A.options.strong || "*";
}
function text$2(o, E, A, g) {
  return A.safe(o.value, g);
}
function checkRuleRepetition(o) {
  const E = o.options.ruleRepetition || 3;
  if (E < 3)
    throw new Error(
      "Cannot serialize rules with repetition `" + E + "` for `options.ruleRepetition`, expected `3` or more"
    );
  return E;
}
function thematicBreak(o, E, A) {
  const g = (checkRule(A) + (A.options.ruleSpaces ? " " : "")).repeat(checkRuleRepetition(A));
  return A.options.ruleSpaces ? g.slice(0, -1) : g;
}
const handle = {
  blockquote,
  break: hardBreak,
  code: code$2,
  definition,
  emphasis,
  hardBreak,
  heading,
  html,
  image,
  imageReference,
  inlineCode,
  link,
  linkReference,
  list,
  listItem,
  paragraph,
  root: root$1,
  strong,
  text: text$2,
  thematicBreak
};
function gfmTableFromMarkdown() {
  return {
    enter: {
      table: enterTable,
      tableData: enterCell,
      tableHeader: enterCell,
      tableRow: enterRow
    },
    exit: {
      codeText: exitCodeText,
      table: exitTable,
      tableData: exit,
      tableHeader: exit,
      tableRow: exit
    }
  };
}
function enterTable(o) {
  const E = o._align;
  this.enter(
    {
      type: "table",
      align: E.map(function(A) {
        return A === "none" ? null : A;
      }),
      children: []
    },
    o
  ), this.data.inTable = !0;
}
function exitTable(o) {
  this.exit(o), this.data.inTable = void 0;
}
function enterRow(o) {
  this.enter({ type: "tableRow", children: [] }, o);
}
function exit(o) {
  this.exit(o);
}
function enterCell(o) {
  this.enter({ type: "tableCell", children: [] }, o);
}
function exitCodeText(o) {
  let E = this.resume();
  this.data.inTable && (E = E.replace(/\\([\\|])/g, replace));
  const A = this.stack[this.stack.length - 1];
  A.type, A.value = E, this.exit(o);
}
function replace(o, E) {
  return E === "|" ? E : o;
}
function gfmTableToMarkdown(o) {
  const E = o || {}, A = E.tableCellPadding, g = E.tablePipeAlign, e = E.stringLength, t = A ? " " : "|";
  return {
    unsafe: [
      { character: "\r", inConstruct: "tableCell" },
      { character: `
`, inConstruct: "tableCell" },
      // A pipe, when followed by a tab or space (padding), or a dash or colon
      // (unpadded delimiter row), could result in a table.
      { atBreak: !0, character: "|", after: "[	 :-]" },
      // A pipe in a cell must be encoded.
      { character: "|", inConstruct: "tableCell" },
      // A colon must be followed by a dash, in which case it could start a
      // delimiter row.
      { atBreak: !0, character: ":", after: "-" },
      // A delimiter row can also start with a dash, when followed by more
      // dashes, a colon, or a pipe.
      // This is a stricter version than the built in check for lists, thematic
      // breaks, and setex heading underlines though:
      // <https://github.com/syntax-tree/mdast-util-to-markdown/blob/51a2038/lib/unsafe.js#L57>
      { atBreak: !0, character: "-", after: "[:|-]" }
    ],
    handlers: {
      inlineCode: M,
      table: c,
      tableCell: h,
      tableRow: n
    }
  };
  function c(S, AA, H, gA) {
    return d(k(S, H, gA), S.align);
  }
  function n(S, AA, H, gA) {
    const CA = p(S, H, gA), IA = d([CA]);
    return IA.slice(0, IA.indexOf(`
`));
  }
  function h(S, AA, H, gA) {
    const CA = H.enter("tableCell"), IA = H.enter("phrasing"), BA = H.containerPhrasing(S, {
      ...gA,
      before: t,
      after: t
    });
    return IA(), CA(), BA;
  }
  function d(S, AA) {
    return markdownTable(S, {
      align: AA,
      // @ts-expect-error: `markdown-table` types should support `null`.
      alignDelimiters: g,
      // @ts-expect-error: `markdown-table` types should support `null`.
      padding: A,
      // @ts-expect-error: `markdown-table` types should support `null`.
      stringLength: e
    });
  }
  function k(S, AA, H) {
    const gA = S.children;
    let CA = -1;
    const IA = [], BA = AA.enter("table");
    for (; ++CA < gA.length; )
      IA[CA] = p(gA[CA], AA, H);
    return BA(), IA;
  }
  function p(S, AA, H) {
    const gA = S.children;
    let CA = -1;
    const IA = [], BA = AA.enter("tableRow");
    for (; ++CA < gA.length; )
      IA[CA] = h(gA[CA], S, AA, H);
    return BA(), IA;
  }
  function M(S, AA, H) {
    let gA = handle.inlineCode(S, AA, H);
    return H.stack.includes("tableCell") && (gA = gA.replace(/\|/g, "\\$&")), gA;
  }
}
function gfmTaskListItemFromMarkdown() {
  return {
    exit: {
      taskListCheckValueChecked: exitCheck,
      taskListCheckValueUnchecked: exitCheck,
      paragraph: exitParagraphWithTaskListItem
    }
  };
}
function gfmTaskListItemToMarkdown() {
  return {
    unsafe: [{ atBreak: !0, character: "-", after: "[:|-]" }],
    handlers: { listItem: listItemWithTaskListItem }
  };
}
function exitCheck(o) {
  const E = this.stack[this.stack.length - 2];
  E.type, E.checked = o.type === "taskListCheckValueChecked";
}
function exitParagraphWithTaskListItem(o) {
  const E = this.stack[this.stack.length - 2];
  if (E && E.type === "listItem" && typeof E.checked == "boolean") {
    const A = this.stack[this.stack.length - 1];
    A.type;
    const g = A.children[0];
    if (g && g.type === "text") {
      const e = E.children;
      let t = -1, c;
      for (; ++t < e.length; ) {
        const n = e[t];
        if (n.type === "paragraph") {
          c = n;
          break;
        }
      }
      c === A && (g.value = g.value.slice(1), g.value.length === 0 ? A.children.shift() : A.position && g.position && typeof g.position.start.offset == "number" && (g.position.start.column++, g.position.start.offset++, A.position.start = Object.assign({}, g.position.start)));
    }
  }
  this.exit(o);
}
function listItemWithTaskListItem(o, E, A, g) {
  const e = o.children[0], t = typeof o.checked == "boolean" && e && e.type === "paragraph", c = "[" + (o.checked ? "x" : " ") + "] ", n = A.createTracker(g);
  t && n.move(c);
  let h = handle.listItem(o, E, A, {
    ...g,
    ...n.current()
  });
  return t && (h = h.replace(/^(?:[*+-]|\d+\.)([\r\n]| {1,3})/, d)), h;
  function d(k) {
    return k + c;
  }
}
function gfmFromMarkdown() {
  return [
    gfmAutolinkLiteralFromMarkdown(),
    gfmFootnoteFromMarkdown(),
    gfmStrikethroughFromMarkdown(),
    gfmTableFromMarkdown(),
    gfmTaskListItemFromMarkdown()
  ];
}
function gfmToMarkdown(o) {
  return {
    extensions: [
      gfmAutolinkLiteralToMarkdown(),
      gfmFootnoteToMarkdown(o),
      gfmStrikethroughToMarkdown(),
      gfmTableToMarkdown(o),
      gfmTaskListItemToMarkdown()
    ]
  };
}
const wwwPrefix = {
  tokenize: tokenizeWwwPrefix,
  partial: !0
}, domain = {
  tokenize: tokenizeDomain,
  partial: !0
}, path$2 = {
  tokenize: tokenizePath,
  partial: !0
}, trail = {
  tokenize: tokenizeTrail,
  partial: !0
}, emailDomainDotTrail = {
  tokenize: tokenizeEmailDomainDotTrail,
  partial: !0
}, wwwAutolink = {
  name: "wwwAutolink",
  tokenize: tokenizeWwwAutolink,
  previous: previousWww
}, protocolAutolink = {
  name: "protocolAutolink",
  tokenize: tokenizeProtocolAutolink,
  previous: previousProtocol
}, emailAutolink = {
  name: "emailAutolink",
  tokenize: tokenizeEmailAutolink,
  previous: previousEmail
}, text$1 = {};
function gfmAutolinkLiteral() {
  return {
    text: text$1
  };
}
let code$1 = 48;
for (; code$1 < 123; )
  text$1[code$1] = emailAutolink, code$1++, code$1 === 58 ? code$1 = 65 : code$1 === 91 && (code$1 = 97);
text$1[43] = emailAutolink;
text$1[45] = emailAutolink;
text$1[46] = emailAutolink;
text$1[95] = emailAutolink;
text$1[72] = [emailAutolink, protocolAutolink];
text$1[104] = [emailAutolink, protocolAutolink];
text$1[87] = [emailAutolink, wwwAutolink];
text$1[119] = [emailAutolink, wwwAutolink];
function tokenizeEmailAutolink(o, E, A) {
  const g = this;
  let e, t;
  return c;
  function c(p) {
    return !gfmAtext(p) || !previousEmail.call(g, g.previous) || previousUnbalanced(g.events) ? A(p) : (o.enter("literalAutolink"), o.enter("literalAutolinkEmail"), n(p));
  }
  function n(p) {
    return gfmAtext(p) ? (o.consume(p), n) : p === 64 ? (o.consume(p), h) : A(p);
  }
  function h(p) {
    return p === 46 ? o.check(emailDomainDotTrail, k, d)(p) : p === 45 || p === 95 || asciiAlphanumeric(p) ? (t = !0, o.consume(p), h) : k(p);
  }
  function d(p) {
    return o.consume(p), e = !0, h;
  }
  function k(p) {
    return t && e && asciiAlpha(g.previous) ? (o.exit("literalAutolinkEmail"), o.exit("literalAutolink"), E(p)) : A(p);
  }
}
function tokenizeWwwAutolink(o, E, A) {
  const g = this;
  return e;
  function e(c) {
    return c !== 87 && c !== 119 || !previousWww.call(g, g.previous) || previousUnbalanced(g.events) ? A(c) : (o.enter("literalAutolink"), o.enter("literalAutolinkWww"), o.check(wwwPrefix, o.attempt(domain, o.attempt(path$2, t), A), A)(c));
  }
  function t(c) {
    return o.exit("literalAutolinkWww"), o.exit("literalAutolink"), E(c);
  }
}
function tokenizeProtocolAutolink(o, E, A) {
  const g = this;
  let e = "", t = !1;
  return c;
  function c(p) {
    return (p === 72 || p === 104) && previousProtocol.call(g, g.previous) && !previousUnbalanced(g.events) ? (o.enter("literalAutolink"), o.enter("literalAutolinkHttp"), e += String.fromCodePoint(p), o.consume(p), n) : A(p);
  }
  function n(p) {
    if (asciiAlpha(p) && e.length < 5)
      return e += String.fromCodePoint(p), o.consume(p), n;
    if (p === 58) {
      const M = e.toLowerCase();
      if (M === "http" || M === "https")
        return o.consume(p), h;
    }
    return A(p);
  }
  function h(p) {
    return p === 47 ? (o.consume(p), t ? d : (t = !0, h)) : A(p);
  }
  function d(p) {
    return p === null || asciiControl(p) || markdownLineEndingOrSpace(p) || unicodeWhitespace(p) || unicodePunctuation(p) ? A(p) : o.attempt(domain, o.attempt(path$2, k), A)(p);
  }
  function k(p) {
    return o.exit("literalAutolinkHttp"), o.exit("literalAutolink"), E(p);
  }
}
function tokenizeWwwPrefix(o, E, A) {
  let g = 0;
  return e;
  function e(c) {
    return (c === 87 || c === 119) && g < 3 ? (g++, o.consume(c), e) : c === 46 && g === 3 ? (o.consume(c), t) : A(c);
  }
  function t(c) {
    return c === null ? A(c) : E(c);
  }
}
function tokenizeDomain(o, E, A) {
  let g, e, t;
  return c;
  function c(d) {
    return d === 46 || d === 95 ? o.check(trail, h, n)(d) : d === null || markdownLineEndingOrSpace(d) || unicodeWhitespace(d) || d !== 45 && unicodePunctuation(d) ? h(d) : (t = !0, o.consume(d), c);
  }
  function n(d) {
    return d === 95 ? g = !0 : (e = g, g = void 0), o.consume(d), c;
  }
  function h(d) {
    return e || g || !t ? A(d) : E(d);
  }
}
function tokenizePath(o, E) {
  let A = 0, g = 0;
  return e;
  function e(c) {
    return c === 40 ? (A++, o.consume(c), e) : c === 41 && g < A ? t(c) : c === 33 || c === 34 || c === 38 || c === 39 || c === 41 || c === 42 || c === 44 || c === 46 || c === 58 || c === 59 || c === 60 || c === 63 || c === 93 || c === 95 || c === 126 ? o.check(trail, E, t)(c) : c === null || markdownLineEndingOrSpace(c) || unicodeWhitespace(c) ? E(c) : (o.consume(c), e);
  }
  function t(c) {
    return c === 41 && g++, o.consume(c), e;
  }
}
function tokenizeTrail(o, E, A) {
  return g;
  function g(n) {
    return n === 33 || n === 34 || n === 39 || n === 41 || n === 42 || n === 44 || n === 46 || n === 58 || n === 59 || n === 63 || n === 95 || n === 126 ? (o.consume(n), g) : n === 38 ? (o.consume(n), t) : n === 93 ? (o.consume(n), e) : (
      // `<` is an end.
      n === 60 || // So is whitespace.
      n === null || markdownLineEndingOrSpace(n) || unicodeWhitespace(n) ? E(n) : A(n)
    );
  }
  function e(n) {
    return n === null || n === 40 || n === 91 || markdownLineEndingOrSpace(n) || unicodeWhitespace(n) ? E(n) : g(n);
  }
  function t(n) {
    return asciiAlpha(n) ? c(n) : A(n);
  }
  function c(n) {
    return n === 59 ? (o.consume(n), g) : asciiAlpha(n) ? (o.consume(n), c) : A(n);
  }
}
function tokenizeEmailDomainDotTrail(o, E, A) {
  return g;
  function g(t) {
    return o.consume(t), e;
  }
  function e(t) {
    return asciiAlphanumeric(t) ? A(t) : E(t);
  }
}
function previousWww(o) {
  return o === null || o === 40 || o === 42 || o === 95 || o === 91 || o === 93 || o === 126 || markdownLineEndingOrSpace(o);
}
function previousProtocol(o) {
  return !asciiAlpha(o);
}
function previousEmail(o) {
  return !(o === 47 || gfmAtext(o));
}
function gfmAtext(o) {
  return o === 43 || o === 45 || o === 46 || o === 95 || asciiAlphanumeric(o);
}
function previousUnbalanced(o) {
  let E = o.length, A = !1;
  for (; E--; ) {
    const g = o[E][1];
    if ((g.type === "labelLink" || g.type === "labelImage") && !g._balanced) {
      A = !0;
      break;
    }
    if (g._gfmAutolinkLiteralWalkedInto) {
      A = !1;
      break;
    }
  }
  return o.length > 0 && !A && (o[o.length - 1][1]._gfmAutolinkLiteralWalkedInto = !0), A;
}
const indent = {
  tokenize: tokenizeIndent,
  partial: !0
};
function gfmFootnote() {
  return {
    document: {
      91: {
        name: "gfmFootnoteDefinition",
        tokenize: tokenizeDefinitionStart,
        continuation: {
          tokenize: tokenizeDefinitionContinuation
        },
        exit: gfmFootnoteDefinitionEnd
      }
    },
    text: {
      91: {
        name: "gfmFootnoteCall",
        tokenize: tokenizeGfmFootnoteCall
      },
      93: {
        name: "gfmPotentialFootnoteCall",
        add: "after",
        tokenize: tokenizePotentialGfmFootnoteCall,
        resolveTo: resolveToPotentialGfmFootnoteCall
      }
    }
  };
}
function tokenizePotentialGfmFootnoteCall(o, E, A) {
  const g = this;
  let e = g.events.length;
  const t = g.parser.gfmFootnotes || (g.parser.gfmFootnotes = []);
  let c;
  for (; e--; ) {
    const h = g.events[e][1];
    if (h.type === "labelImage") {
      c = h;
      break;
    }
    if (h.type === "gfmFootnoteCall" || h.type === "labelLink" || h.type === "label" || h.type === "image" || h.type === "link")
      break;
  }
  return n;
  function n(h) {
    if (!c || !c._balanced)
      return A(h);
    const d = normalizeIdentifier(g.sliceSerialize({
      start: c.end,
      end: g.now()
    }));
    return d.codePointAt(0) !== 94 || !t.includes(d.slice(1)) ? A(h) : (o.enter("gfmFootnoteCallLabelMarker"), o.consume(h), o.exit("gfmFootnoteCallLabelMarker"), E(h));
  }
}
function resolveToPotentialGfmFootnoteCall(o, E) {
  let A = o.length;
  for (; A--; )
    if (o[A][1].type === "labelImage" && o[A][0] === "enter") {
      o[A][1];
      break;
    }
  o[A + 1][1].type = "data", o[A + 3][1].type = "gfmFootnoteCallLabelMarker";
  const g = {
    type: "gfmFootnoteCall",
    start: Object.assign({}, o[A + 3][1].start),
    end: Object.assign({}, o[o.length - 1][1].end)
  }, e = {
    type: "gfmFootnoteCallMarker",
    start: Object.assign({}, o[A + 3][1].end),
    end: Object.assign({}, o[A + 3][1].end)
  };
  e.end.column++, e.end.offset++, e.end._bufferIndex++;
  const t = {
    type: "gfmFootnoteCallString",
    start: Object.assign({}, e.end),
    end: Object.assign({}, o[o.length - 1][1].start)
  }, c = {
    type: "chunkString",
    contentType: "string",
    start: Object.assign({}, t.start),
    end: Object.assign({}, t.end)
  }, n = [
    // Take the `labelImageMarker` (now `data`, the `!`)
    o[A + 1],
    o[A + 2],
    ["enter", g, E],
    // The `[`
    o[A + 3],
    o[A + 4],
    // The `^`.
    ["enter", e, E],
    ["exit", e, E],
    // Everything in between.
    ["enter", t, E],
    ["enter", c, E],
    ["exit", c, E],
    ["exit", t, E],
    // The ending (`]`, properly parsed and labelled).
    o[o.length - 2],
    o[o.length - 1],
    ["exit", g, E]
  ];
  return o.splice(A, o.length - A + 1, ...n), o;
}
function tokenizeGfmFootnoteCall(o, E, A) {
  const g = this, e = g.parser.gfmFootnotes || (g.parser.gfmFootnotes = []);
  let t = 0, c;
  return n;
  function n(p) {
    return o.enter("gfmFootnoteCall"), o.enter("gfmFootnoteCallLabelMarker"), o.consume(p), o.exit("gfmFootnoteCallLabelMarker"), h;
  }
  function h(p) {
    return p !== 94 ? A(p) : (o.enter("gfmFootnoteCallMarker"), o.consume(p), o.exit("gfmFootnoteCallMarker"), o.enter("gfmFootnoteCallString"), o.enter("chunkString").contentType = "string", d);
  }
  function d(p) {
    if (
      // Too long.
      t > 999 || // Closing brace with nothing.
      p === 93 && !c || // Space or tab is not supported by GFM for some reason.
      // `\n` and `[` not being supported makes sense.
      p === null || p === 91 || markdownLineEndingOrSpace(p)
    )
      return A(p);
    if (p === 93) {
      o.exit("chunkString");
      const M = o.exit("gfmFootnoteCallString");
      return e.includes(normalizeIdentifier(g.sliceSerialize(M))) ? (o.enter("gfmFootnoteCallLabelMarker"), o.consume(p), o.exit("gfmFootnoteCallLabelMarker"), o.exit("gfmFootnoteCall"), E) : A(p);
    }
    return markdownLineEndingOrSpace(p) || (c = !0), t++, o.consume(p), p === 92 ? k : d;
  }
  function k(p) {
    return p === 91 || p === 92 || p === 93 ? (o.consume(p), t++, d) : d(p);
  }
}
function tokenizeDefinitionStart(o, E, A) {
  const g = this, e = g.parser.gfmFootnotes || (g.parser.gfmFootnotes = []);
  let t, c = 0, n;
  return h;
  function h(AA) {
    return o.enter("gfmFootnoteDefinition")._container = !0, o.enter("gfmFootnoteDefinitionLabel"), o.enter("gfmFootnoteDefinitionLabelMarker"), o.consume(AA), o.exit("gfmFootnoteDefinitionLabelMarker"), d;
  }
  function d(AA) {
    return AA === 94 ? (o.enter("gfmFootnoteDefinitionMarker"), o.consume(AA), o.exit("gfmFootnoteDefinitionMarker"), o.enter("gfmFootnoteDefinitionLabelString"), o.enter("chunkString").contentType = "string", k) : A(AA);
  }
  function k(AA) {
    if (
      // Too long.
      c > 999 || // Closing brace with nothing.
      AA === 93 && !n || // Space or tab is not supported by GFM for some reason.
      // `\n` and `[` not being supported makes sense.
      AA === null || AA === 91 || markdownLineEndingOrSpace(AA)
    )
      return A(AA);
    if (AA === 93) {
      o.exit("chunkString");
      const H = o.exit("gfmFootnoteDefinitionLabelString");
      return t = normalizeIdentifier(g.sliceSerialize(H)), o.enter("gfmFootnoteDefinitionLabelMarker"), o.consume(AA), o.exit("gfmFootnoteDefinitionLabelMarker"), o.exit("gfmFootnoteDefinitionLabel"), M;
    }
    return markdownLineEndingOrSpace(AA) || (n = !0), c++, o.consume(AA), AA === 92 ? p : k;
  }
  function p(AA) {
    return AA === 91 || AA === 92 || AA === 93 ? (o.consume(AA), c++, k) : k(AA);
  }
  function M(AA) {
    return AA === 58 ? (o.enter("definitionMarker"), o.consume(AA), o.exit("definitionMarker"), e.includes(t) || e.push(t), factorySpace(o, S, "gfmFootnoteDefinitionWhitespace")) : A(AA);
  }
  function S(AA) {
    return E(AA);
  }
}
function tokenizeDefinitionContinuation(o, E, A) {
  return o.check(blankLine, E, o.attempt(indent, E, A));
}
function gfmFootnoteDefinitionEnd(o) {
  o.exit("gfmFootnoteDefinition");
}
function tokenizeIndent(o, E, A) {
  const g = this;
  return factorySpace(o, e, "gfmFootnoteDefinitionIndent", 5);
  function e(t) {
    const c = g.events[g.events.length - 1];
    return c && c[1].type === "gfmFootnoteDefinitionIndent" && c[2].sliceSerialize(c[1], !0).length === 4 ? E(t) : A(t);
  }
}
function gfmStrikethrough(o) {
  let A = (o || {}).singleTilde;
  const g = {
    name: "strikethrough",
    tokenize: t,
    resolveAll: e
  };
  return A == null && (A = !0), {
    text: {
      126: g
    },
    insideSpan: {
      null: [g]
    },
    attentionMarkers: {
      null: [126]
    }
  };
  function e(c, n) {
    let h = -1;
    for (; ++h < c.length; )
      if (c[h][0] === "enter" && c[h][1].type === "strikethroughSequenceTemporary" && c[h][1]._close) {
        let d = h;
        for (; d--; )
          if (c[d][0] === "exit" && c[d][1].type === "strikethroughSequenceTemporary" && c[d][1]._open && // If the sizes are the same:
          c[h][1].end.offset - c[h][1].start.offset === c[d][1].end.offset - c[d][1].start.offset) {
            c[h][1].type = "strikethroughSequence", c[d][1].type = "strikethroughSequence";
            const k = {
              type: "strikethrough",
              start: Object.assign({}, c[d][1].start),
              end: Object.assign({}, c[h][1].end)
            }, p = {
              type: "strikethroughText",
              start: Object.assign({}, c[d][1].end),
              end: Object.assign({}, c[h][1].start)
            }, M = [["enter", k, n], ["enter", c[d][1], n], ["exit", c[d][1], n], ["enter", p, n]], S = n.parser.constructs.insideSpan.null;
            S && splice(M, M.length, 0, resolveAll(S, c.slice(d + 1, h), n)), splice(M, M.length, 0, [["exit", p, n], ["enter", c[h][1], n], ["exit", c[h][1], n], ["exit", k, n]]), splice(c, d - 1, h - d + 3, M), h = d + M.length - 2;
            break;
          }
      }
    for (h = -1; ++h < c.length; )
      c[h][1].type === "strikethroughSequenceTemporary" && (c[h][1].type = "data");
    return c;
  }
  function t(c, n, h) {
    const d = this.previous, k = this.events;
    let p = 0;
    return M;
    function M(AA) {
      return d === 126 && k[k.length - 1][1].type !== "characterEscape" ? h(AA) : (c.enter("strikethroughSequenceTemporary"), S(AA));
    }
    function S(AA) {
      const H = classifyCharacter(d);
      if (AA === 126)
        return p > 1 ? h(AA) : (c.consume(AA), p++, S);
      if (p < 2 && !A) return h(AA);
      const gA = c.exit("strikethroughSequenceTemporary"), CA = classifyCharacter(AA);
      return gA._open = !CA || CA === 2 && !!H, gA._close = !H || H === 2 && !!CA, n(AA);
    }
  }
}
class EditMap {
  /**
   * Create a new edit map.
   */
  constructor() {
    this.map = [];
  }
  /**
   * Create an edit: a remove and/or add at a certain place.
   *
   * @param {number} index
   * @param {number} remove
   * @param {Array<Event>} add
   * @returns {undefined}
   */
  add(E, A, g) {
    addImplementation(this, E, A, g);
  }
  // To do: add this when moving to `micromark`.
  // /**
  //  * Create an edit: but insert `add` before existing additions.
  //  *
  //  * @param {number} index
  //  * @param {number} remove
  //  * @param {Array<Event>} add
  //  * @returns {undefined}
  //  */
  // addBefore(index, remove, add) {
  //   addImplementation(this, index, remove, add, true)
  // }
  /**
   * Done, change the events.
   *
   * @param {Array<Event>} events
   * @returns {undefined}
   */
  consume(E) {
    if (this.map.sort(function(t, c) {
      return t[0] - c[0];
    }), this.map.length === 0)
      return;
    let A = this.map.length;
    const g = [];
    for (; A > 0; )
      A -= 1, g.push(E.slice(this.map[A][0] + this.map[A][1]), this.map[A][2]), E.length = this.map[A][0];
    g.push(E.slice()), E.length = 0;
    let e = g.pop();
    for (; e; ) {
      for (const t of e)
        E.push(t);
      e = g.pop();
    }
    this.map.length = 0;
  }
}
function addImplementation(o, E, A, g) {
  let e = 0;
  if (!(A === 0 && g.length === 0)) {
    for (; e < o.map.length; ) {
      if (o.map[e][0] === E) {
        o.map[e][1] += A, o.map[e][2].push(...g);
        return;
      }
      e += 1;
    }
    o.map.push([E, A, g]);
  }
}
function gfmTableAlign(o, E) {
  let A = !1;
  const g = [];
  for (; E < o.length; ) {
    const e = o[E];
    if (A) {
      if (e[0] === "enter")
        e[1].type === "tableContent" && g.push(o[E + 1][1].type === "tableDelimiterMarker" ? "left" : "none");
      else if (e[1].type === "tableContent") {
        if (o[E - 1][1].type === "tableDelimiterMarker") {
          const t = g.length - 1;
          g[t] = g[t] === "left" ? "center" : "right";
        }
      } else if (e[1].type === "tableDelimiterRow")
        break;
    } else e[0] === "enter" && e[1].type === "tableDelimiterRow" && (A = !0);
    E += 1;
  }
  return g;
}
function gfmTable() {
  return {
    flow: {
      null: {
        name: "table",
        tokenize: tokenizeTable,
        resolveAll: resolveTable
      }
    }
  };
}
function tokenizeTable(o, E, A) {
  const g = this;
  let e = 0, t = 0, c;
  return n;
  function n(eA) {
    let cA = g.events.length - 1;
    for (; cA > -1; ) {
      const wA = g.events[cA][1].type;
      if (wA === "lineEnding" || // Note: markdown-rs uses `whitespace` instead of `linePrefix`
      wA === "linePrefix") cA--;
      else break;
    }
    const DA = cA > -1 ? g.events[cA][1].type : null, nA = DA === "tableHead" || DA === "tableRow" ? oA : h;
    return nA === oA && g.parser.lazy[g.now().line] ? A(eA) : nA(eA);
  }
  function h(eA) {
    return o.enter("tableHead"), o.enter("tableRow"), d(eA);
  }
  function d(eA) {
    return eA === 124 || (c = !0, t += 1), k(eA);
  }
  function k(eA) {
    return eA === null ? A(eA) : markdownLineEnding(eA) ? t > 1 ? (t = 0, g.interrupt = !0, o.exit("tableRow"), o.enter("lineEnding"), o.consume(eA), o.exit("lineEnding"), S) : A(eA) : markdownSpace(eA) ? factorySpace(o, k, "whitespace")(eA) : (t += 1, c && (c = !1, e += 1), eA === 124 ? (o.enter("tableCellDivider"), o.consume(eA), o.exit("tableCellDivider"), c = !0, k) : (o.enter("data"), p(eA)));
  }
  function p(eA) {
    return eA === null || eA === 124 || markdownLineEndingOrSpace(eA) ? (o.exit("data"), k(eA)) : (o.consume(eA), eA === 92 ? M : p);
  }
  function M(eA) {
    return eA === 92 || eA === 124 ? (o.consume(eA), p) : p(eA);
  }
  function S(eA) {
    return g.interrupt = !1, g.parser.lazy[g.now().line] ? A(eA) : (o.enter("tableDelimiterRow"), c = !1, markdownSpace(eA) ? factorySpace(o, AA, "linePrefix", g.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(eA) : AA(eA));
  }
  function AA(eA) {
    return eA === 45 || eA === 58 ? gA(eA) : eA === 124 ? (c = !0, o.enter("tableCellDivider"), o.consume(eA), o.exit("tableCellDivider"), H) : EA(eA);
  }
  function H(eA) {
    return markdownSpace(eA) ? factorySpace(o, gA, "whitespace")(eA) : gA(eA);
  }
  function gA(eA) {
    return eA === 58 ? (t += 1, c = !0, o.enter("tableDelimiterMarker"), o.consume(eA), o.exit("tableDelimiterMarker"), CA) : eA === 45 ? (t += 1, CA(eA)) : eA === null || markdownLineEnding(eA) ? QA(eA) : EA(eA);
  }
  function CA(eA) {
    return eA === 45 ? (o.enter("tableDelimiterFiller"), IA(eA)) : EA(eA);
  }
  function IA(eA) {
    return eA === 45 ? (o.consume(eA), IA) : eA === 58 ? (c = !0, o.exit("tableDelimiterFiller"), o.enter("tableDelimiterMarker"), o.consume(eA), o.exit("tableDelimiterMarker"), BA) : (o.exit("tableDelimiterFiller"), BA(eA));
  }
  function BA(eA) {
    return markdownSpace(eA) ? factorySpace(o, QA, "whitespace")(eA) : QA(eA);
  }
  function QA(eA) {
    return eA === 124 ? AA(eA) : eA === null || markdownLineEnding(eA) ? !c || e !== t ? EA(eA) : (o.exit("tableDelimiterRow"), o.exit("tableHead"), E(eA)) : EA(eA);
  }
  function EA(eA) {
    return A(eA);
  }
  function oA(eA) {
    return o.enter("tableRow"), iA(eA);
  }
  function iA(eA) {
    return eA === 124 ? (o.enter("tableCellDivider"), o.consume(eA), o.exit("tableCellDivider"), iA) : eA === null || markdownLineEnding(eA) ? (o.exit("tableRow"), E(eA)) : markdownSpace(eA) ? factorySpace(o, iA, "whitespace")(eA) : (o.enter("data"), aA(eA));
  }
  function aA(eA) {
    return eA === null || eA === 124 || markdownLineEndingOrSpace(eA) ? (o.exit("data"), iA(eA)) : (o.consume(eA), eA === 92 ? tA : aA);
  }
  function tA(eA) {
    return eA === 92 || eA === 124 ? (o.consume(eA), aA) : aA(eA);
  }
}
function resolveTable(o, E) {
  let A = -1, g = !0, e = 0, t = [0, 0, 0, 0], c = [0, 0, 0, 0], n = !1, h = 0, d, k, p;
  const M = new EditMap();
  for (; ++A < o.length; ) {
    const S = o[A], AA = S[1];
    S[0] === "enter" ? AA.type === "tableHead" ? (n = !1, h !== 0 && (flushTableEnd(M, E, h, d, k), k = void 0, h = 0), d = {
      type: "table",
      start: Object.assign({}, AA.start),
      // Note: correct end is set later.
      end: Object.assign({}, AA.end)
    }, M.add(A, 0, [["enter", d, E]])) : AA.type === "tableRow" || AA.type === "tableDelimiterRow" ? (g = !0, p = void 0, t = [0, 0, 0, 0], c = [0, A + 1, 0, 0], n && (n = !1, k = {
      type: "tableBody",
      start: Object.assign({}, AA.start),
      // Note: correct end is set later.
      end: Object.assign({}, AA.end)
    }, M.add(A, 0, [["enter", k, E]])), e = AA.type === "tableDelimiterRow" ? 2 : k ? 3 : 1) : e && (AA.type === "data" || AA.type === "tableDelimiterMarker" || AA.type === "tableDelimiterFiller") ? (g = !1, c[2] === 0 && (t[1] !== 0 && (c[0] = c[1], p = flushCell(M, E, t, e, void 0, p), t = [0, 0, 0, 0]), c[2] = A)) : AA.type === "tableCellDivider" && (g ? g = !1 : (t[1] !== 0 && (c[0] = c[1], p = flushCell(M, E, t, e, void 0, p)), t = c, c = [t[1], A, 0, 0])) : AA.type === "tableHead" ? (n = !0, h = A) : AA.type === "tableRow" || AA.type === "tableDelimiterRow" ? (h = A, t[1] !== 0 ? (c[0] = c[1], p = flushCell(M, E, t, e, A, p)) : c[1] !== 0 && (p = flushCell(M, E, c, e, A, p)), e = 0) : e && (AA.type === "data" || AA.type === "tableDelimiterMarker" || AA.type === "tableDelimiterFiller") && (c[3] = A);
  }
  for (h !== 0 && flushTableEnd(M, E, h, d, k), M.consume(E.events), A = -1; ++A < E.events.length; ) {
    const S = E.events[A];
    S[0] === "enter" && S[1].type === "table" && (S[1]._align = gfmTableAlign(E.events, A));
  }
  return o;
}
function flushCell(o, E, A, g, e, t) {
  const c = g === 1 ? "tableHeader" : g === 2 ? "tableDelimiter" : "tableData", n = "tableContent";
  A[0] !== 0 && (t.end = Object.assign({}, getPoint(E.events, A[0])), o.add(A[0], 0, [["exit", t, E]]));
  const h = getPoint(E.events, A[1]);
  if (t = {
    type: c,
    start: Object.assign({}, h),
    // Note: correct end is set later.
    end: Object.assign({}, h)
  }, o.add(A[1], 0, [["enter", t, E]]), A[2] !== 0) {
    const d = getPoint(E.events, A[2]), k = getPoint(E.events, A[3]), p = {
      type: n,
      start: Object.assign({}, d),
      end: Object.assign({}, k)
    };
    if (o.add(A[2], 0, [["enter", p, E]]), g !== 2) {
      const M = E.events[A[2]], S = E.events[A[3]];
      if (M[1].end = Object.assign({}, S[1].end), M[1].type = "chunkText", M[1].contentType = "text", A[3] > A[2] + 1) {
        const AA = A[2] + 1, H = A[3] - A[2] - 1;
        o.add(AA, H, []);
      }
    }
    o.add(A[3] + 1, 0, [["exit", p, E]]);
  }
  return e !== void 0 && (t.end = Object.assign({}, getPoint(E.events, e)), o.add(e, 0, [["exit", t, E]]), t = void 0), t;
}
function flushTableEnd(o, E, A, g, e) {
  const t = [], c = getPoint(E.events, A);
  e && (e.end = Object.assign({}, c), t.push(["exit", e, E])), g.end = Object.assign({}, c), t.push(["exit", g, E]), o.add(A + 1, 0, t);
}
function getPoint(o, E) {
  const A = o[E], g = A[0] === "enter" ? "start" : "end";
  return A[1][g];
}
const tasklistCheck = {
  name: "tasklistCheck",
  tokenize: tokenizeTasklistCheck
};
function gfmTaskListItem() {
  return {
    text: {
      91: tasklistCheck
    }
  };
}
function tokenizeTasklistCheck(o, E, A) {
  const g = this;
  return e;
  function e(h) {
    return (
      // Exit if there’s stuff before.
      g.previous !== null || // Exit if not in the first content that is the first child of a list
      // item.
      !g._gfmTasklistFirstContentOfListItem ? A(h) : (o.enter("taskListCheck"), o.enter("taskListCheckMarker"), o.consume(h), o.exit("taskListCheckMarker"), t)
    );
  }
  function t(h) {
    return markdownLineEndingOrSpace(h) ? (o.enter("taskListCheckValueUnchecked"), o.consume(h), o.exit("taskListCheckValueUnchecked"), c) : h === 88 || h === 120 ? (o.enter("taskListCheckValueChecked"), o.consume(h), o.exit("taskListCheckValueChecked"), c) : A(h);
  }
  function c(h) {
    return h === 93 ? (o.enter("taskListCheckMarker"), o.consume(h), o.exit("taskListCheckMarker"), o.exit("taskListCheck"), n) : A(h);
  }
  function n(h) {
    return markdownLineEnding(h) ? E(h) : markdownSpace(h) ? o.check({
      tokenize: spaceThenNonSpace
    }, E, A)(h) : A(h);
  }
}
function spaceThenNonSpace(o, E, A) {
  return factorySpace(o, g, "whitespace");
  function g(e) {
    return e === null ? A(e) : E(e);
  }
}
function gfm(o) {
  return combineExtensions([
    gfmAutolinkLiteral(),
    gfmFootnote(),
    gfmStrikethrough(o),
    gfmTable(),
    gfmTaskListItem()
  ]);
}
const emptyOptions$1 = {};
function remarkGfm(o) {
  const E = (
    /** @type {Processor<Root>} */
    this
  ), A = o || emptyOptions$1, g = E.data(), e = g.micromarkExtensions || (g.micromarkExtensions = []), t = g.fromMarkdownExtensions || (g.fromMarkdownExtensions = []), c = g.toMarkdownExtensions || (g.toMarkdownExtensions = []);
  e.push(gfm(A)), t.push(gfmFromMarkdown()), c.push(gfmToMarkdown(A));
}
function mathFromMarkdown() {
  return {
    enter: {
      mathFlow: o,
      mathFlowFenceMeta: E,
      mathText: t
    },
    exit: {
      mathFlow: e,
      mathFlowFence: g,
      mathFlowFenceMeta: A,
      mathFlowValue: n,
      mathText: c,
      mathTextData: n
    }
  };
  function o(h) {
    const d = {
      type: "element",
      tagName: "code",
      properties: { className: ["language-math", "math-display"] },
      children: []
    };
    this.enter(
      {
        type: "math",
        meta: null,
        value: "",
        data: { hName: "pre", hChildren: [d] }
      },
      h
    );
  }
  function E() {
    this.buffer();
  }
  function A() {
    const h = this.resume(), d = this.stack[this.stack.length - 1];
    d.type, d.meta = h;
  }
  function g() {
    this.data.mathFlowInside || (this.buffer(), this.data.mathFlowInside = !0);
  }
  function e(h) {
    const d = this.resume().replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, ""), k = this.stack[this.stack.length - 1];
    k.type, this.exit(h), k.value = d;
    const p = (
      /** @type {HastElement} */
      k.data.hChildren[0]
    );
    p.type, p.tagName, p.children.push({ type: "text", value: d }), this.data.mathFlowInside = void 0;
  }
  function t(h) {
    this.enter(
      {
        type: "inlineMath",
        value: "",
        data: {
          hName: "code",
          hProperties: { className: ["language-math", "math-inline"] },
          hChildren: []
        }
      },
      h
    ), this.buffer();
  }
  function c(h) {
    const d = this.resume(), k = this.stack[this.stack.length - 1];
    k.type, this.exit(h), k.value = d, /** @type {Array<HastElementContent>} */
    // @ts-expect-error: we defined it in `enterMathFlow`.
    k.data.hChildren.push({ type: "text", value: d });
  }
  function n(h) {
    this.config.enter.data.call(this, h), this.config.exit.data.call(this, h);
  }
}
function mathToMarkdown(o) {
  let E = (o || {}).singleDollarTextMath;
  return E == null && (E = !0), g.peek = e, {
    unsafe: [
      { character: "\r", inConstruct: "mathFlowMeta" },
      { character: `
`, inConstruct: "mathFlowMeta" },
      {
        character: "$",
        after: E ? void 0 : "\\$",
        inConstruct: "phrasing"
      },
      { character: "$", inConstruct: "mathFlowMeta" },
      { atBreak: !0, character: "$", after: "\\$" }
    ],
    handlers: { math: A, inlineMath: g }
  };
  function A(t, c, n, h) {
    const d = t.value || "", k = n.createTracker(h), p = "$".repeat(Math.max(longestStreak(d, "$") + 1, 2)), M = n.enter("mathFlow");
    let S = k.move(p);
    if (t.meta) {
      const AA = n.enter("mathFlowMeta");
      S += k.move(
        n.safe(t.meta, {
          after: `
`,
          before: S,
          encode: ["$"],
          ...k.current()
        })
      ), AA();
    }
    return S += k.move(`
`), d && (S += k.move(d + `
`)), S += k.move(p), M(), S;
  }
  function g(t, c, n) {
    let h = t.value || "", d = 1;
    for (E || d++; new RegExp("(^|[^$])" + "\\$".repeat(d) + "([^$]|$)").test(h); )
      d++;
    const k = "$".repeat(d);
    // Contains non-space.
    /[^ \r\n]/.test(h) && // Starts with space and ends with space.
    (/^[ \r\n]/.test(h) && /[ \r\n]$/.test(h) || // Starts or ends with dollar.
    /^\$|\$$/.test(h)) && (h = " " + h + " ");
    let p = -1;
    for (; ++p < n.unsafe.length; ) {
      const M = n.unsafe[p];
      if (!M.atBreak) continue;
      const S = n.compilePattern(M);
      let AA;
      for (; AA = S.exec(h); ) {
        let H = AA.index;
        h.codePointAt(H) === 10 && h.codePointAt(H - 1) === 13 && H--, h = h.slice(0, H) + " " + h.slice(AA.index + 1);
      }
    }
    return k + h + k;
  }
  function e() {
    return "$";
  }
}
const mathFlow = {
  tokenize: tokenizeMathFenced,
  concrete: !0,
  name: "mathFlow"
}, nonLazyContinuation = {
  tokenize: tokenizeNonLazyContinuation,
  partial: !0
};
function tokenizeMathFenced(o, E, A) {
  const g = this, e = g.events[g.events.length - 1], t = e && e[1].type === "linePrefix" ? e[2].sliceSerialize(e[1], !0).length : 0;
  let c = 0;
  return n;
  function n(IA) {
    return o.enter("mathFlow"), o.enter("mathFlowFence"), o.enter("mathFlowFenceSequence"), h(IA);
  }
  function h(IA) {
    return IA === 36 ? (o.consume(IA), c++, h) : c < 2 ? A(IA) : (o.exit("mathFlowFenceSequence"), factorySpace(o, d, "whitespace")(IA));
  }
  function d(IA) {
    return IA === null || markdownLineEnding(IA) ? p(IA) : (o.enter("mathFlowFenceMeta"), o.enter("chunkString", {
      contentType: "string"
    }), k(IA));
  }
  function k(IA) {
    return IA === null || markdownLineEnding(IA) ? (o.exit("chunkString"), o.exit("mathFlowFenceMeta"), p(IA)) : IA === 36 ? A(IA) : (o.consume(IA), k);
  }
  function p(IA) {
    return o.exit("mathFlowFence"), g.interrupt ? E(IA) : o.attempt(nonLazyContinuation, M, gA)(IA);
  }
  function M(IA) {
    return o.attempt({
      tokenize: CA,
      partial: !0
    }, gA, S)(IA);
  }
  function S(IA) {
    return (t ? factorySpace(o, AA, "linePrefix", t + 1) : AA)(IA);
  }
  function AA(IA) {
    return IA === null ? gA(IA) : markdownLineEnding(IA) ? o.attempt(nonLazyContinuation, M, gA)(IA) : (o.enter("mathFlowValue"), H(IA));
  }
  function H(IA) {
    return IA === null || markdownLineEnding(IA) ? (o.exit("mathFlowValue"), AA(IA)) : (o.consume(IA), H);
  }
  function gA(IA) {
    return o.exit("mathFlow"), E(IA);
  }
  function CA(IA, BA, QA) {
    let EA = 0;
    return factorySpace(IA, oA, "linePrefix", g.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4);
    function oA(tA) {
      return IA.enter("mathFlowFence"), IA.enter("mathFlowFenceSequence"), iA(tA);
    }
    function iA(tA) {
      return tA === 36 ? (EA++, IA.consume(tA), iA) : EA < c ? QA(tA) : (IA.exit("mathFlowFenceSequence"), factorySpace(IA, aA, "whitespace")(tA));
    }
    function aA(tA) {
      return tA === null || markdownLineEnding(tA) ? (IA.exit("mathFlowFence"), BA(tA)) : QA(tA);
    }
  }
}
function tokenizeNonLazyContinuation(o, E, A) {
  const g = this;
  return e;
  function e(c) {
    return c === null ? E(c) : (o.enter("lineEnding"), o.consume(c), o.exit("lineEnding"), t);
  }
  function t(c) {
    return g.parser.lazy[g.now().line] ? A(c) : E(c);
  }
}
function mathText(o) {
  let A = (o || {}).singleDollarTextMath;
  return A == null && (A = !0), {
    tokenize: g,
    resolve: resolveMathText,
    previous,
    name: "mathText"
  };
  function g(e, t, c) {
    let n = 0, h, d;
    return k;
    function k(H) {
      return e.enter("mathText"), e.enter("mathTextSequence"), p(H);
    }
    function p(H) {
      return H === 36 ? (e.consume(H), n++, p) : n < 2 && !A ? c(H) : (e.exit("mathTextSequence"), M(H));
    }
    function M(H) {
      return H === null ? c(H) : H === 36 ? (d = e.enter("mathTextSequence"), h = 0, AA(H)) : H === 32 ? (e.enter("space"), e.consume(H), e.exit("space"), M) : markdownLineEnding(H) ? (e.enter("lineEnding"), e.consume(H), e.exit("lineEnding"), M) : (e.enter("mathTextData"), S(H));
    }
    function S(H) {
      return H === null || H === 32 || H === 36 || markdownLineEnding(H) ? (e.exit("mathTextData"), M(H)) : (e.consume(H), S);
    }
    function AA(H) {
      return H === 36 ? (e.consume(H), h++, AA) : h === n ? (e.exit("mathTextSequence"), e.exit("mathText"), t(H)) : (d.type = "mathTextData", S(H));
    }
  }
}
function resolveMathText(o) {
  let E = o.length - 4, A = 3, g, e;
  if ((o[A][1].type === "lineEnding" || o[A][1].type === "space") && (o[E][1].type === "lineEnding" || o[E][1].type === "space")) {
    for (g = A; ++g < E; )
      if (o[g][1].type === "mathTextData") {
        o[E][1].type = "mathTextPadding", o[A][1].type = "mathTextPadding", A += 2, E -= 2;
        break;
      }
  }
  for (g = A - 1, E++; ++g <= E; )
    e === void 0 ? g !== E && o[g][1].type !== "lineEnding" && (e = g) : (g === E || o[g][1].type === "lineEnding") && (o[e][1].type = "mathTextData", g !== e + 2 && (o[e][1].end = o[g - 1][1].end, o.splice(e + 2, g - e - 2), E -= g - e - 2, g = e + 2), e = void 0);
  return o;
}
function previous(o) {
  return o !== 36 || this.events[this.events.length - 1][1].type === "characterEscape";
}
function math(o) {
  return {
    flow: {
      36: mathFlow
    },
    text: {
      36: mathText(o)
    }
  };
}
const emptyOptions = {};
function remarkMath(o) {
  const E = (
    /** @type {Processor} */
    this
  ), A = o || emptyOptions, g = E.data(), e = g.micromarkExtensions || (g.micromarkExtensions = []), t = g.fromMarkdownExtensions || (g.fromMarkdownExtensions = []), c = g.toMarkdownExtensions || (g.toMarkdownExtensions = []);
  e.push(math(A)), t.push(mathFromMarkdown()), c.push(mathToMarkdown(A));
}
const streamlitLogo = "data:image/svg+xml,%3csvg%20width='301'%20height='165'%20viewBox='0%200%20301%20165'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M150.731%20101.547L98.1387%2073.7471L6.84674%2025.4969C6.7634%2025.4136%206.59674%2025.4136%206.51341%2025.4136C3.18007%2023.8303%20-0.236608%2027.1636%201.0134%2030.497L47.5302%20149.139L47.5385%20149.164C47.5885%20149.281%2047.6302%20149.397%2047.6802%20149.514C49.5885%20153.939%2053.7552%20156.672%2058.2886%20157.747C58.6719%20157.831%2058.9461%20157.906%2059.4064%20157.998C59.8645%20158.1%2060.5052%20158.239%2061.0552%20158.281C61.1469%20158.289%2061.2302%20158.289%2061.3219%20158.297H61.3886C61.4552%20158.306%2061.5219%20158.306%2061.5886%20158.314H61.6802C61.7386%20158.322%2061.8052%20158.322%2061.8636%20158.322H61.9719C62.0386%20158.331%2062.1052%20158.331%2062.1719%20158.331V158.331C121.084%20164.754%20180.519%20164.754%20239.431%20158.331V158.331C240.139%20158.331%20240.831%20158.297%20241.497%20158.231C241.714%20158.206%20241.922%20158.181%20242.131%20158.156C242.156%20158.147%20242.189%20158.147%20242.214%20158.139C242.356%20158.122%20242.497%20158.097%20242.639%20158.072C242.847%20158.047%20243.056%20158.006%20243.264%20157.964C243.681%20157.872%20243.87%20157.806%20244.436%20157.611C245.001%20157.417%20245.94%20157.077%20246.527%20156.794C247.115%20156.511%20247.522%20156.239%20248.014%20155.931C248.622%20155.547%20249.201%20155.155%20249.788%20154.715C250.041%20154.521%20250.214%20154.397%20250.397%20154.222L250.297%20154.164L150.731%20101.547Z'%20fill='%23FF4B4B'/%3e%3cpath%20d='M294.766%2025.4981H294.683L203.357%2073.7483L254.124%20149.357L300.524%2030.4981V30.3315C301.691%2026.8314%20298.108%2023.6648%20294.766%2025.4981'%20fill='%237D353B'/%3e%3cpath%20d='M155.598%202.55572C153.264%20-0.852624%20148.181%20-0.852624%20145.931%202.55572L98.1389%2073.7477L150.731%20101.548L250.398%20154.222C251.024%20153.609%20251.526%20153.012%20252.056%20152.381C252.806%20151.456%20253.506%20150.465%20254.123%20149.356L203.356%2073.7477L155.598%202.55572Z'%20fill='%23BD4043'/%3e%3c/svg%3e", IsSidebarContext = createContext(!1);
IsSidebarContext.displayName = "IsSidebarContext";
const codeLink = {
  // Streamline the style when inside anchors to avoid broken underline and more
  "a > &": {
    color: "inherit"
  }
}, StyledInlineCode = /* @__PURE__ */ createStyled("code", process.env.NODE_ENV === "production" ? {
  target: "e1ycw9pz5"
} : {
  target: "e1ycw9pz5",
  label: "StyledInlineCode"
})(({
  theme: o
}) => ({
  padding: "0.2em 0.4em",
  overflowWrap: "break-word",
  whiteSpace: "pre-wrap",
  margin: 0,
  borderRadius: o.radii.md,
  background: o.colors.codeBackgroundColor,
  color: o.colors.codeTextColor,
  fontFamily: o.genericFonts.codeFont,
  // Use em here so that it works correctly within headers, captions,
  // sidebar, etc.
  fontSize: o.fontSizes.inlineCodeFontSize,
  fontWeight: o.fontWeights.code,
  ...codeLink
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), codeBlockStyle = (o, E) => ({
  background: "transparent",
  border: 0,
  color: "inherit",
  display: "inline",
  fontFamily: o.genericFonts.codeFont,
  fontSize: o.fontSizes.codeFontSize,
  fontWeight: o.fontWeights.code,
  lineHeight: "inherit",
  margin: 0,
  overflowX: "auto",
  padding: 0,
  whiteSpace: E ? "pre-wrap" : "pre",
  overflowWrap: E ? "break-word" : "normal",
  ...codeLink
}), StyledCode = /* @__PURE__ */ createStyled("code", process.env.NODE_ENV === "production" ? {
  target: "e1ycw9pz4"
} : {
  target: "e1ycw9pz4",
  label: "StyledCode"
})(({
  theme: o,
  wrapLines: E
}) => ({
  ...codeBlockStyle(o, E)
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledPre = /* @__PURE__ */ createStyled("pre", process.env.NODE_ENV === "production" ? {
  target: "e1ycw9pz3"
} : {
  target: "e1ycw9pz3",
  label: "StyledPre"
})(({
  theme: o,
  wrapLines: E
}) => ({
  height: "100%",
  background: o.colors.codeBackgroundColor,
  borderRadius: o.radii.default,
  color: o.colors.bodyText,
  fontSize: o.fontSizes.twoSm,
  fontFamily: o.genericFonts.codeFont,
  display: "block",
  // Remove browser default top margin
  margin: 0,
  // Disable auto-hiding scrollbar in legacy Edge to avoid overlap,
  // making it impossible to interact with the content
  msOverflowStyle: "scrollbar",
  // Don't allow content to break outside
  overflow: "auto",
  // Add padding around the code
  padding: o.spacing.lg,
  // Add padding to the right to account for the copy button
  paddingRight: o.iconSizes.threeXL,
  code: {
    ...codeBlockStyle(o, E)
  },
  // The token can consist of many lines, e.g. a triple-quote string, so
  // we need to make sure that the color is not overwritten.
  ".comment.linenumber": {
    color: o.colors.fadedText40,
    fontSize: o.fontSizes.twoSm,
    // Center-align number vertically, or they'll be positioned differently when
    // wrapLines=true. Even with this change, though, the position is still ~2px
    // off.
    // NOTE: The alignSelf below only apply applies when wrapLines=true, because
    // that option wraps this element in a flex container.
    alignSelf: "center",
    // Override the default token's min-width, to ensure it fits 3-digit lines
    minWidth: `${o.spacing.threeXL} !important`
  },
  ".token.comment, .token.prolog, .token.doctype, .token.cdata": {
    color: o.colors.gray70
  },
  ".token.punctuation": {
    color: o.colors.gray70
  },
  ".namespace": {
    opacity: 0.7
  },
  ".token.attr-name, .token.property, .token.variable": {
    color: o.colors.lightBlue80
  },
  ".token.boolean, .token.constant, .token.symbol": {
    color: o.colors.green70
  },
  ".token.number, .token.regex": {
    color: o.colors.blueGreen80
  },
  ".token.string, .token.char, .token.attr-value": {
    color: o.colors.green80
  },
  ".token.operator, .token.entity": {
    color: o.colors.orange90
  },
  ".token.url": {
    color: o.colors.purple80
  },
  ".token.decorator, .token.atrule": {
    color: o.colors.orange90
  },
  ".token.keyword, .token.tag": {
    color: o.colors.blue70
  },
  ".token.function, .token.class-name, .token.selector": {
    color: o.colors.blue70,
    fontWeight: o.fontWeights.codeExtraBold
  },
  ".token.important": {
    color: o.colors.red70,
    fontWeight: o.fontWeights.codeExtraBold
  },
  ".token.comment": {
    color: o.colors.gray70,
    fontStyle: "italic"
  },
  ".token.italic": {
    fontStyle: "italic"
  },
  ".token.entity": {
    cursor: "help"
  },
  /**
   * Diff syntax highlighting
   */
  ".token.deleted.line, .token.deleted.prefix": {
    color: o.colors.red70
  },
  ".token.inserted.line, .token.inserted.prefix": {
    color: o.colors.green70
  },
  ".token.unchanged.line": {
    color: o.colors.gray70
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2xpYi9zcmMvY29tcG9uZW50cy9lbGVtZW50cy9Db2RlQmxvY2svc3R5bGVkLWNvbXBvbmVudHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBK0V5QiIsImZpbGUiOiIvaG9tZS9ydW5uZXIvd29yay9zdGxpdGUvc3RsaXRlL3N0cmVhbWxpdC9mcm9udGVuZC9saWIvc3JjL2NvbXBvbmVudHMvZWxlbWVudHMvQ29kZUJsb2NrL3N0eWxlZC1jb21wb25lbnRzLnRzIiwic291cmNlc0NvbnRlbnQiOlsiLyoqXG4gKiBDb3B5cmlnaHQgKGMpIFN0cmVhbWxpdCBJbmMuICgyMDE4LTIwMjIpIFNub3dmbGFrZSBJbmMuICgyMDIyLTIwMjUpXG4gKlxuICogTGljZW5zZWQgdW5kZXIgdGhlIEFwYWNoZSBMaWNlbnNlLCBWZXJzaW9uIDIuMCAodGhlIFwiTGljZW5zZVwiKTtcbiAqIHlvdSBtYXkgbm90IHVzZSB0aGlzIGZpbGUgZXhjZXB0IGluIGNvbXBsaWFuY2Ugd2l0aCB0aGUgTGljZW5zZS5cbiAqIFlvdSBtYXkgb2J0YWluIGEgY29weSBvZiB0aGUgTGljZW5zZSBhdFxuICpcbiAqICAgICBodHRwOi8vd3d3LmFwYWNoZS5vcmcvbGljZW5zZXMvTElDRU5TRS0yLjBcbiAqXG4gKiBVbmxlc3MgcmVxdWlyZWQgYnkgYXBwbGljYWJsZSBsYXcgb3IgYWdyZWVkIHRvIGluIHdyaXRpbmcsIHNvZnR3YXJlXG4gKiBkaXN0cmlidXRlZCB1bmRlciB0aGUgTGljZW5zZSBpcyBkaXN0cmlidXRlZCBvbiBhbiBcIkFTIElTXCIgQkFTSVMsXG4gKiBXSVRIT1VUIFdBUlJBTlRJRVMgT1IgQ09ORElUSU9OUyBPRiBBTlkgS0lORCwgZWl0aGVyIGV4cHJlc3Mgb3IgaW1wbGllZC5cbiAqIFNlZSB0aGUgTGljZW5zZSBmb3IgdGhlIHNwZWNpZmljIGxhbmd1YWdlIGdvdmVybmluZyBwZXJtaXNzaW9ucyBhbmRcbiAqIGxpbWl0YXRpb25zIHVuZGVyIHRoZSBMaWNlbnNlLlxuICovXG5cbmltcG9ydCB7IENTU09iamVjdCwgVGhlbWUgfSBmcm9tIFwiQGVtb3Rpb24vcmVhY3RcIlxuaW1wb3J0IHN0eWxlZCBmcm9tIFwiQGVtb3Rpb24vc3R5bGVkXCJcblxuY29uc3QgY29kZUxpbms6IENTU09iamVjdCA9IHtcbiAgLy8gU3RyZWFtbGluZSB0aGUgc3R5bGUgd2hlbiBpbnNpZGUgYW5jaG9ycyB0byBhdm9pZCBicm9rZW4gdW5kZXJsaW5lIGFuZCBtb3JlXG4gIFwiYSA+ICZcIjoge1xuICAgIGNvbG9yOiBcImluaGVyaXRcIixcbiAgfSxcbn1cblxuZXhwb3J0IGNvbnN0IFN0eWxlZElubGluZUNvZGUgPSBzdHlsZWQuY29kZSgoeyB0aGVtZSB9KSA9PiAoe1xuICBwYWRkaW5nOiBcIjAuMmVtIDAuNGVtXCIsXG4gIG92ZXJmbG93V3JhcDogXCJicmVhay13b3JkXCIsXG4gIHdoaXRlU3BhY2U6IFwicHJlLXdyYXBcIixcbiAgbWFyZ2luOiAwLFxuICBib3JkZXJSYWRpdXM6IHRoZW1lLnJhZGlpLm1kLFxuICBiYWNrZ3JvdW5kOiB0aGVtZS5jb2xvcnMuY29kZUJhY2tncm91bmRDb2xvcixcbiAgY29sb3I6IHRoZW1lLmNvbG9ycy5jb2RlVGV4dENvbG9yLFxuICBmb250RmFtaWx5OiB0aGVtZS5nZW5lcmljRm9udHMuY29kZUZvbnQsXG4gIC8vIFVzZSBlbSBoZXJlIHNvIHRoYXQgaXQgd29ya3MgY29ycmVjdGx5IHdpdGhpbiBoZWFkZXJzLCBjYXB0aW9ucyxcbiAgLy8gc2lkZWJhciwgZXRjLlxuICBmb250U2l6ZTogdGhlbWUuZm9udFNpemVzLmlubGluZUNvZGVGb250U2l6ZSxcbiAgZm9udFdlaWdodDogdGhlbWUuZm9udFdlaWdodHMuY29kZSxcblxuICAuLi5jb2RlTGluayxcbn0pKVxuXG50eXBlIFN0eWxlZENvZGVQcm9wcyA9IHtcbiAgd3JhcExpbmVzOiBib29sZWFuXG59XG5cbmNvbnN0IGNvZGVCbG9ja1N0eWxlID0gKFxuICB0aGVtZTogVGhlbWUsXG4gIHdyYXBMaW5lczogU3R5bGVkQ29kZVByb3BzW1wid3JhcExpbmVzXCJdXG4pOiBDU1NPYmplY3QgPT4gKHtcbiAgYmFja2dyb3VuZDogXCJ0cmFuc3BhcmVudFwiLFxuICBib3JkZXI6IDAsXG4gIGNvbG9yOiBcImluaGVyaXRcIixcbiAgZGlzcGxheTogXCJpbmxpbmVcIixcbiAgZm9udEZhbWlseTogdGhlbWUuZ2VuZXJpY0ZvbnRzLmNvZGVGb250LFxuICBmb250U2l6ZTogdGhlbWUuZm9udFNpemVzLmNvZGVGb250U2l6ZSxcbiAgZm9udFdlaWdodDogdGhlbWUuZm9udFdlaWdodHMuY29kZSxcbiAgbGluZUhlaWdodDogXCJpbmhlcml0XCIsXG4gIG1hcmdpbjogMCxcbiAgb3ZlcmZsb3dYOiBcImF1dG9cIixcbiAgcGFkZGluZzogMCxcbiAgd2hpdGVTcGFjZTogd3JhcExpbmVzID8gXCJwcmUtd3JhcFwiIDogXCJwcmVcIixcbiAgb3ZlcmZsb3dXcmFwOiB3cmFwTGluZXMgPyBcImJyZWFrLXdvcmRcIiA6IFwibm9ybWFsXCIsXG4gIC4uLmNvZGVMaW5rLFxufSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZENvZGUgPSBzdHlsZWQuY29kZTxTdHlsZWRDb2RlUHJvcHM+KFxuICAoeyB0aGVtZSwgd3JhcExpbmVzIH0pID0+ICh7XG4gICAgLi4uY29kZUJsb2NrU3R5bGUodGhlbWUsIHdyYXBMaW5lcyksXG4gIH0pXG4pXG5cbi8qXG4gIFRoaXMgaXMgdGhlIGRlZmF1bHQgcHJpc20uanMgdGhlbWUgZm9yIEphdmFTY3JpcHQsIENTUyBhbmQgSFRNTCwgYnV0XG4gIHN0cmlwcGVkIG9mIGV2ZXJ5dGhpbmcgZXhjZXB0IGZvciB0b2tlbiBzdHlsaW5nLlxuXG4gIFNlZSBodHRwczovL3ByaXNtanMuY29tL2Rvd25sb2FkLmh0bWwjdGhlbWVzPXByaXNtJmxhbmd1YWdlcz1tYXJrdXArY3NzK2NsaWtlK2phdmFzY3JpcHRcbiovXG5leHBvcnQgY29uc3QgU3R5bGVkUHJlID0gc3R5bGVkLnByZTxTdHlsZWRDb2RlUHJvcHM+KFxuICAoeyB0aGVtZSwgd3JhcExpbmVzIH0pID0+ICh7XG4gICAgaGVpZ2h0OiBcIjEwMCVcIixcbiAgICBiYWNrZ3JvdW5kOiB0aGVtZS5jb2xvcnMuY29kZUJhY2tncm91bmRDb2xvcixcbiAgICBib3JkZXJSYWRpdXM6IHRoZW1lLnJhZGlpLmRlZmF1bHQsXG4gICAgY29sb3I6IHRoZW1lLmNvbG9ycy5ib2R5VGV4dCxcbiAgICBmb250U2l6ZTogdGhlbWUuZm9udFNpemVzLnR3b1NtLFxuICAgIGZvbnRGYW1pbHk6IHRoZW1lLmdlbmVyaWNGb250cy5jb2RlRm9udCxcbiAgICBkaXNwbGF5OiBcImJsb2NrXCIsXG4gICAgLy8gUmVtb3ZlIGJyb3dzZXIgZGVmYXVsdCB0b3AgbWFyZ2luXG4gICAgbWFyZ2luOiAwLFxuICAgIC8vIERpc2FibGUgYXV0by1oaWRpbmcgc2Nyb2xsYmFyIGluIGxlZ2FjeSBFZGdlIHRvIGF2b2lkIG92ZXJsYXAsXG4gICAgLy8gbWFraW5nIGl0IGltcG9zc2libGUgdG8gaW50ZXJhY3Qgd2l0aCB0aGUgY29udGVudFxuICAgIG1zT3ZlcmZsb3dTdHlsZTogXCJzY3JvbGxiYXJcIixcblxuICAgIC8vIERvbid0IGFsbG93IGNvbnRlbnQgdG8gYnJlYWsgb3V0c2lkZVxuICAgIG92ZXJmbG93OiBcImF1dG9cIixcblxuICAgIC8vIEFkZCBwYWRkaW5nIGFyb3VuZCB0aGUgY29kZVxuICAgIHBhZGRpbmc6IHRoZW1lLnNwYWNpbmcubGcsXG4gICAgLy8gQWRkIHBhZGRpbmcgdG8gdGhlIHJpZ2h0IHRvIGFjY291bnQgZm9yIHRoZSBjb3B5IGJ1dHRvblxuICAgIHBhZGRpbmdSaWdodDogdGhlbWUuaWNvblNpemVzLnRocmVlWEwsXG5cbiAgICBjb2RlOiB7IC4uLmNvZGVCbG9ja1N0eWxlKHRoZW1lLCB3cmFwTGluZXMpIH0sXG5cbiAgICAvLyBUaGUgdG9rZW4gY2FuIGNvbnNpc3Qgb2YgbWFueSBsaW5lcywgZS5nLiBhIHRyaXBsZS1xdW90ZSBzdHJpbmcsIHNvXG4gICAgLy8gd2UgbmVlZCB0byBtYWtlIHN1cmUgdGhhdCB0aGUgY29sb3IgaXMgbm90IG92ZXJ3cml0dGVuLlxuICAgIFwiLmNvbW1lbnQubGluZW51bWJlclwiOiB7XG4gICAgICBjb2xvcjogdGhlbWUuY29sb3JzLmZhZGVkVGV4dDQwLFxuICAgICAgZm9udFNpemU6IHRoZW1lLmZvbnRTaXplcy50d29TbSxcblxuICAgICAgLy8gQ2VudGVyLWFsaWduIG51bWJlciB2ZXJ0aWNhbGx5LCBvciB0aGV5J2xsIGJlIHBvc2l0aW9uZWQgZGlmZmVyZW50bHkgd2hlblxuICAgICAgLy8gd3JhcExpbmVzPXRydWUuIEV2ZW4gd2l0aCB0aGlzIGNoYW5nZSwgdGhvdWdoLCB0aGUgcG9zaXRpb24gaXMgc3RpbGwgfjJweFxuICAgICAgLy8gb2ZmLlxuICAgICAgLy8gTk9URTogVGhlIGFsaWduU2VsZiBiZWxvdyBvbmx5IGFwcGx5IGFwcGxpZXMgd2hlbiB3cmFwTGluZXM9dHJ1ZSwgYmVjYXVzZVxuICAgICAgLy8gdGhhdCBvcHRpb24gd3JhcHMgdGhpcyBlbGVtZW50IGluIGEgZmxleCBjb250YWluZXIuXG4gICAgICBhbGlnblNlbGY6IFwiY2VudGVyXCIsXG5cbiAgICAgIC8vIE92ZXJyaWRlIHRoZSBkZWZhdWx0IHRva2VuJ3MgbWluLXdpZHRoLCB0byBlbnN1cmUgaXQgZml0cyAzLWRpZ2l0IGxpbmVzXG4gICAgICBtaW5XaWR0aDogYCR7dGhlbWUuc3BhY2luZy50aHJlZVhMfSAhaW1wb3J0YW50YCxcbiAgICB9LFxuXG4gICAgXCIudG9rZW4uY29tbWVudCwgLnRva2VuLnByb2xvZywgLnRva2VuLmRvY3R5cGUsIC50b2tlbi5jZGF0YVwiOiB7XG4gICAgICBjb2xvcjogdGhlbWUuY29sb3JzLmdyYXk3MCxcbiAgICB9LFxuXG4gICAgXCIudG9rZW4ucHVuY3R1YXRpb25cIjoge1xuICAgICAgY29sb3I6IHRoZW1lLmNvbG9ycy5ncmF5NzAsXG4gICAgfSxcblxuICAgIFwiLm5hbWVzcGFjZVwiOiB7XG4gICAgICBvcGFjaXR5OiAwLjcsXG4gICAgfSxcblxuICAgIFwiLnRva2VuLmF0dHItbmFtZSwgLnRva2VuLnByb3BlcnR5LCAudG9rZW4udmFyaWFibGVcIjoge1xuICAgICAgY29sb3I6IHRoZW1lLmNvbG9ycy5saWdodEJsdWU4MCxcbiAgICB9LFxuXG4gICAgXCIudG9rZW4uYm9vbGVhbiwgLnRva2VuLmNvbnN0YW50LCAudG9rZW4uc3ltYm9sXCI6IHtcbiAgICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMuZ3JlZW43MCxcbiAgICB9LFxuXG4gICAgXCIudG9rZW4ubnVtYmVyLCAudG9rZW4ucmVnZXhcIjoge1xuICAgICAgY29sb3I6IHRoZW1lLmNvbG9ycy5ibHVlR3JlZW44MCxcbiAgICB9LFxuXG4gICAgXCIudG9rZW4uc3RyaW5nLCAudG9rZW4uY2hhciwgLnRva2VuLmF0dHItdmFsdWVcIjoge1xuICAgICAgY29sb3I6IHRoZW1lLmNvbG9ycy5ncmVlbjgwLFxuICAgIH0sXG5cbiAgICBcIi50b2tlbi5vcGVyYXRvciwgLnRva2VuLmVudGl0eVwiOiB7XG4gICAgICBjb2xvcjogdGhlbWUuY29sb3JzLm9yYW5nZTkwLFxuICAgIH0sXG5cbiAgICBcIi50b2tlbi51cmxcIjoge1xuICAgICAgY29sb3I6IHRoZW1lLmNvbG9ycy5wdXJwbGU4MCxcbiAgICB9LFxuXG4gICAgXCIudG9rZW4uZGVjb3JhdG9yLCAudG9rZW4uYXRydWxlXCI6IHtcbiAgICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMub3JhbmdlOTAsXG4gICAgfSxcblxuICAgIFwiLnRva2VuLmtleXdvcmQsIC50b2tlbi50YWdcIjoge1xuICAgICAgY29sb3I6IHRoZW1lLmNvbG9ycy5ibHVlNzAsXG4gICAgfSxcblxuICAgIFwiLnRva2VuLmZ1bmN0aW9uLCAudG9rZW4uY2xhc3MtbmFtZSwgLnRva2VuLnNlbGVjdG9yXCI6IHtcbiAgICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMuYmx1ZTcwLFxuICAgICAgZm9udFdlaWdodDogdGhlbWUuZm9udFdlaWdodHMuY29kZUV4dHJhQm9sZCxcbiAgICB9LFxuXG4gICAgXCIudG9rZW4uaW1wb3J0YW50XCI6IHtcbiAgICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMucmVkNzAsXG4gICAgICBmb250V2VpZ2h0OiB0aGVtZS5mb250V2VpZ2h0cy5jb2RlRXh0cmFCb2xkLFxuICAgIH0sXG5cbiAgICBcIi50b2tlbi5jb21tZW50XCI6IHtcbiAgICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMuZ3JheTcwLFxuICAgICAgZm9udFN0eWxlOiBcIml0YWxpY1wiLFxuICAgIH0sXG5cbiAgICBcIi50b2tlbi5pdGFsaWNcIjoge1xuICAgICAgZm9udFN0eWxlOiBcIml0YWxpY1wiLFxuICAgIH0sXG5cbiAgICBcIi50b2tlbi5lbnRpdHlcIjoge1xuICAgICAgY3Vyc29yOiBcImhlbHBcIixcbiAgICB9LFxuXG4gICAgLyoqXG4gICAgICogRGlmZiBzeW50YXggaGlnaGxpZ2h0aW5nXG4gICAgICovXG4gICAgXCIudG9rZW4uZGVsZXRlZC5saW5lLCAudG9rZW4uZGVsZXRlZC5wcmVmaXhcIjoge1xuICAgICAgY29sb3I6IHRoZW1lLmNvbG9ycy5yZWQ3MCxcbiAgICB9LFxuICAgIFwiLnRva2VuLmluc2VydGVkLmxpbmUsIC50b2tlbi5pbnNlcnRlZC5wcmVmaXhcIjoge1xuICAgICAgY29sb3I6IHRoZW1lLmNvbG9ycy5ncmVlbjcwLFxuICAgIH0sXG4gICAgXCIudG9rZW4udW5jaGFuZ2VkLmxpbmVcIjoge1xuICAgICAgY29sb3I6IHRoZW1lLmNvbG9ycy5ncmF5NzAsXG4gICAgfSxcbiAgfSlcbilcblxuZXhwb3J0IGNvbnN0IFN0eWxlZENvcHlCdXR0b25Db250YWluZXIgPSBzdHlsZWQuZGl2KCh7IHRoZW1lIH0pID0+ICh7XG4gIG9wYWNpdHk6IDAsXG4gIHBhZGRpbmc6IGAke3RoZW1lLnNwYWNpbmcuc219ICR7dGhlbWUuc3BhY2luZy5zbX0gMCAwYCxcbiAgdG9wOiAwLFxuICByaWdodDogMCxcbiAgcG9zaXRpb246IFwiYWJzb2x1dGVcIixcbiAgd2lkdGg6IFwiMTAwJVwiLFxuICBoZWlnaHQ6IFwiMTAwJVwiLFxuICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy50cmFuc3BhcmVudCxcbiAgekluZGV4OiB0aGVtZS56SW5kaWNlcy5zaWRlYmFyICsgMSxcbiAgZGlzcGxheTogXCJmbGV4XCIsXG4gIGp1c3RpZnlDb250ZW50OiBcImZsZXgtZW5kXCIsXG4gIGFsaWduSXRlbXM6IFwiZmxleC1zdGFydFwiLFxuICB0cmFuc2l0aW9uOiBcIm9wYWNpdHkgMzAwbXMgMTUwbXNcIixcbiAgcG9pbnRlckV2ZW50czogXCJub25lXCIsXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZENvZGVCbG9jayA9IHN0eWxlZC5kaXYoKHsgdGhlbWUgfSkgPT4gKHtcbiAgaGVpZ2h0OiBcIjEwMCVcIixcbiAgcG9zaXRpb246IFwicmVsYXRpdmVcIixcbiAgbWFyZ2luTGVmdDogdGhlbWUuc3BhY2luZy5ub25lLFxuICBtYXJnaW5SaWdodDogdGhlbWUuc3BhY2luZy5ub25lLFxuICBtYXJnaW5Ub3A6IHRoZW1lLnNwYWNpbmcubm9uZSxcbiAgbWFyZ2luQm90dG9tOiB1bmRlZmluZWQsXG5cbiAgXCImOmhvdmVyXCI6IHtcbiAgICBbYCR7U3R5bGVkQ29weUJ1dHRvbkNvbnRhaW5lcn1gXToge1xuICAgICAgb3BhY2l0eTogMSxcbiAgICB9LFxuICB9LFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRDb3B5QnV0dG9uID0gc3R5bGVkLmJ1dHRvbigoeyB0aGVtZSB9KSA9PiAoe1xuICBwb2ludGVyRXZlbnRzOiBcImF1dG9cIixcbiAgaGVpZ2h0OiB0aGVtZS5pY29uU2l6ZXMudGhyZWVYTCxcbiAgd2lkdGg6IHRoZW1lLmljb25TaXplcy50aHJlZVhMLFxuICBwYWRkaW5nOiB0aGVtZS5zcGFjaW5nLm5vbmUsXG4gIGJvcmRlcjogXCJub25lXCIsXG4gIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLnRyYW5zcGFyZW50LFxuICBjb2xvcjogdGhlbWUuY29sb3JzLmZhZGVkVGV4dDYwLFxuICB0cmFuc2Zvcm06IFwic2NhbGUoMClcIixcbiAgdG9wOiAwLFxuICByaWdodDogMCxcblxuICAvLyBTaG93IGJ1dHRvbiBvbiBjb250YWluZXIgaG92ZXJcbiAgW2Ake1N0eWxlZENvZGVCbG9ja306aG92ZXIgJmBdOiB7XG4gICAgb3BhY2l0eTogMSxcbiAgICB0cmFuc2Zvcm06IFwic2NhbGUoMSlcIixcbiAgICBvdXRsaW5lOiBcIm5vbmVcIixcbiAgICB0cmFuc2l0aW9uOiBcIm5vbmVcIixcbiAgfSxcblxuICAvLyBTaG93IGJ1dHRvbiBvbiBpdHMgb3duIGhvdmVyL2ZvY3VzIHN0YXRlc1xuICBcIiY6aG92ZXIsICY6Zm9jdXMsICY6YWN0aXZlLCAmOmZvY3VzLXZpc2libGVcIjoge1xuICAgIG9wYWNpdHk6IDEsXG4gICAgdHJhbnNmb3JtOiBcInNjYWxlKDEpXCIsXG4gICAgb3V0bGluZTogXCJub25lXCIsXG4gICAgdHJhbnNpdGlvbjogXCJub25lXCIsXG4gICAgYm9yZGVyUmFkaXVzOiB0aGVtZS5yYWRpaS5tZCxcbiAgfSxcblxuICBcIiY6aG92ZXJcIjoge1xuICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMuYm9keVRleHQsXG4gICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMuZGFya2VuZWRCZ01peDE1LFxuICB9LFxuXG4gIFwiJjphY3RpdmVcIjoge1xuICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMuYm9keVRleHQsXG4gICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMuZGFya2VuZWRCZ01peDI1LFxuICB9LFxuXG4gIC8vIEFjY2Vzc2libGUgZm9jdXMgcmluZyB3aGVuIGtleWJvYXJkIGZvY3VzaW5nIHRoZSBidXR0b25cbiAgXCImOmZvY3VzLXZpc2libGVcIjoge1xuICAgIGJveFNoYWRvdzogYDAgMCAwIDAuMnJlbSAke3RoZW1lLmNvbG9ycy5kYXJrZW5lZEJnTWl4MjV9YCxcbiAgfSxcbn0pKVxuIl19 */"), StyledCopyButtonContainer = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e1ycw9pz2"
} : {
  target: "e1ycw9pz2",
  label: "StyledCopyButtonContainer"
})(({
  theme: o
}) => ({
  opacity: 0,
  padding: `${o.spacing.sm} ${o.spacing.sm} 0 0`,
  top: 0,
  right: 0,
  position: "absolute",
  width: "100%",
  height: "100%",
  backgroundColor: o.colors.transparent,
  zIndex: o.zIndices.sidebar + 1,
  display: "flex",
  justifyContent: "flex-end",
  alignItems: "flex-start",
  transition: "opacity 300ms 150ms",
  pointerEvents: "none"
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledCodeBlock = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e1ycw9pz1"
} : {
  target: "e1ycw9pz1",
  label: "StyledCodeBlock"
})(({
  theme: o
}) => ({
  height: "100%",
  position: "relative",
  marginLeft: o.spacing.none,
  marginRight: o.spacing.none,
  marginTop: o.spacing.none,
  marginBottom: void 0,
  "&:hover": {
    [`${StyledCopyButtonContainer}`]: {
      opacity: 1
    }
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledCopyButton = /* @__PURE__ */ createStyled("button", process.env.NODE_ENV === "production" ? {
  target: "e1ycw9pz0"
} : {
  target: "e1ycw9pz0",
  label: "StyledCopyButton"
})(({
  theme: o
}) => ({
  pointerEvents: "auto",
  height: o.iconSizes.threeXL,
  width: o.iconSizes.threeXL,
  padding: o.spacing.none,
  border: "none",
  backgroundColor: o.colors.transparent,
  color: o.colors.fadedText60,
  transform: "scale(0)",
  top: 0,
  right: 0,
  // Show button on container hover
  [`${StyledCodeBlock}:hover &`]: {
    opacity: 1,
    transform: "scale(1)",
    outline: "none",
    transition: "none"
  },
  // Show button on its own hover/focus states
  "&:hover, &:focus, &:active, &:focus-visible": {
    opacity: 1,
    transform: "scale(1)",
    outline: "none",
    transition: "none",
    borderRadius: o.radii.md
  },
  "&:hover": {
    color: o.colors.bodyText,
    backgroundColor: o.colors.darkenedBgMix15
  },
  "&:active": {
    color: o.colors.bodyText,
    backgroundColor: o.colors.darkenedBgMix25
  },
  // Accessible focus ring when keyboard focusing the button
  "&:focus-visible": {
    boxShadow: `0 0 0 0.2rem ${o.colors.darkenedBgMix25}`
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), pulseAnimation = keyframes`
  0%, 100% {
    opacity: 0.5;
  }

  50% {
    opacity: 1;
  }
`, ANIMATION_STYLES = {
  animationDuration: "750ms",
  animationName: pulseAnimation,
  animationTimingFunction: "ease-in",
  animationDirection: "normal",
  animationIterationCount: "infinite"
}, StyledSkeleton = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e1lmee1o4"
} : {
  target: "e1lmee1o4",
  label: "StyledSkeleton"
})(({
  theme: o
}) => ({
  display: "flex",
  flexDirection: "column",
  gap: o.spacing.lg
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), TitleSkeleton = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e1lmee1o3"
} : {
  target: "e1lmee1o3",
  label: "TitleSkeleton"
})(({
  theme: o
}) => ({
  height: o.fontSizes.fourXL,
  width: `calc(${o.sizes.contentMaxWidth} * 0.37)`,
  // Picked because it looks good.
  maxWidth: "75%",
  // Picked because it looks good.
  background: o.colors.darkenedBgMix15,
  borderRadius: o.radii.default,
  ...ANIMATION_STYLES
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), ParagraphSkeleton = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e1lmee1o2"
} : {
  target: "e1lmee1o2",
  label: "ParagraphSkeleton"
})(({
  theme: o
}) => ({
  display: "flex",
  flexDirection: "column",
  gap: o.spacing.sm
  // Picked because it looks good.
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), TextLineSkeleton = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e1lmee1o1"
} : {
  target: "e1lmee1o1",
  label: "TextLineSkeleton"
})(({
  theme: o,
  width: E
}) => ({
  height: o.fontSizes.md,
  width: E,
  background: o.colors.darkenedBgMix15,
  borderRadius: o.radii.default,
  ...ANIMATION_STYLES
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), SquareSkeleton = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e1lmee1o0"
} : {
  target: "e1lmee1o0",
  label: "SquareSkeleton"
})(({
  theme: o,
  height: E,
  width: A
}) => ({
  height: E ?? o.fontSizes.fourXL,
  width: A ?? "100%",
  background: o.colors.darkenedBgMix15,
  borderRadius: o.radii.default,
  ...ANIMATION_STYLES
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), SHOW_DELAY_MS = 500, RawAppSkeleton = () => {
  const [o, E] = useState(!1);
  return useEffect(() => {
    const A = setTimeout(() => {
      E(!0);
    }, SHOW_DELAY_MS);
    return () => {
      clearTimeout(A);
    };
  }, []), o ? /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledSkeleton, { className: "stAppSkeleton", "data-testid": "stAppSkeleton", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(TitleSkeleton, {}),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(ParagraphSkeleton, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(TextLineSkeleton, { width: "98%" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(TextLineSkeleton, { width: "100%" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(TextLineSkeleton, { width: "96%" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(TextLineSkeleton, { width: "65%" })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(SquareSkeleton, { width: "75%", height: "9rem" })
  ] }) : /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {});
}, AppSkeleton = memo(RawAppSkeleton), RawSkeleton = ({
  element: o
}) => o.style == Skeleton$1.SkeletonStyle.APP ? /* @__PURE__ */ jsxRuntimeExports.jsx(AppSkeleton, {}) : /* @__PURE__ */ jsxRuntimeExports.jsx(SquareSkeleton, { className: "stSkeleton", "data-testid": "stSkeleton", height: o?.height ? o.height + "px" : void 0 }), Skeleton = memo(RawSkeleton);
var KIND$1 = Object.freeze({
  info: "info",
  positive: "positive",
  warning: "warning",
  negative: "negative"
}), TYPE$1 = Object.freeze({
  inline: "inline",
  toast: "toast"
}), PLACEMENT$1 = Object.freeze({
  topLeft: "topLeft",
  top: "top",
  topRight: "topRight",
  bottomRight: "bottomRight",
  bottom: "bottom",
  bottomLeft: "bottomLeft"
});
function getSvgStyles$1(o) {
  var E = o.$theme, A = o.$size, g = o.$color, e = E.sizing.scale600;
  A && (E.sizing[A] ? e = E.sizing[A] : typeof A == "number" ? e = "".concat(A, "px") : e = A);
  var t = "currentColor";
  return g && (E.colors[g] ? t = E.colors[g] : t = g), {
    display: "inline-block",
    fill: t,
    color: t,
    height: e,
    width: e
  };
}
var Svg = styled("svg", getSvgStyles$1);
Svg.displayName = "Svg";
Svg.displayName = "Svg";
function _objectDestructuringEmpty(o) {
  if (o == null) throw new TypeError("Cannot destructure undefined");
}
function ownKeys$o(o, E) {
  var A = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var g = Object.getOwnPropertySymbols(o);
    E && (g = g.filter(function(e) {
      return Object.getOwnPropertyDescriptor(o, e).enumerable;
    })), A.push.apply(A, g);
  }
  return A;
}
function _objectSpread$m(o) {
  for (var E = 1; E < arguments.length; E++) {
    var A = arguments[E] != null ? arguments[E] : {};
    E % 2 ? ownKeys$o(Object(A), !0).forEach(function(g) {
      _defineProperty$r(o, g, A[g]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(A)) : ownKeys$o(Object(A)).forEach(function(g) {
      Object.defineProperty(o, g, Object.getOwnPropertyDescriptor(A, g));
    });
  }
  return o;
}
function _defineProperty$r(o, E, A) {
  return E in o ? Object.defineProperty(o, E, { value: A, enumerable: !0, configurable: !0, writable: !0 }) : o[E] = A, o;
}
function getBackgroundColor$1(o, E, A) {
  var g, e = E === TYPE$1.inline;
  return (g = {}, _defineProperty$r(g, KIND$1.info, e ? A.colors.notificationInfoBackground : A.colors.toastInfoBackground), _defineProperty$r(g, KIND$1.positive, e ? A.colors.notificationPositiveBackground : A.colors.toastPositiveBackground), _defineProperty$r(g, KIND$1.warning, e ? A.colors.notificationWarningBackground : A.colors.toastWarningBackground), _defineProperty$r(g, KIND$1.negative, e ? A.colors.notificationNegativeBackground : A.colors.toastNegativeBackground), g)[o];
}
function getFontColor$1(o, E, A) {
  var g, e = E === TYPE$1.inline;
  if (e) {
    var t;
    return (t = {}, _defineProperty$r(t, KIND$1.info, A.colors.notificationInfoText), _defineProperty$r(t, KIND$1.positive, A.colors.notificationPositiveText), _defineProperty$r(t, KIND$1.warning, A.colors.notificationWarningText), _defineProperty$r(t, KIND$1.negative, A.colors.notificationNegativeText), t)[o];
  }
  return (g = {}, _defineProperty$r(g, KIND$1.info, A.colors.toastInfoText), _defineProperty$r(g, KIND$1.positive, A.colors.toastPositiveText), _defineProperty$r(g, KIND$1.warning, A.colors.toastWarningText), _defineProperty$r(g, KIND$1.negative, A.colors.toastNegativeText), g)[o];
}
function getPlacement(o) {
  switch (o) {
    case PLACEMENT$1.topLeft:
      return {
        top: 0,
        alignItems: "flex-start",
        justifyContent: "flex-start",
        flexDirection: "column"
      };
    case PLACEMENT$1.top:
      return {
        top: 0,
        alignItems: "center",
        justifyContent: "flex-start",
        flexDirection: "column"
      };
    case PLACEMENT$1.topRight:
      return {
        top: 0,
        alignItems: "flex-end",
        justifyContent: "flex-start",
        flexDirection: "column"
      };
    case PLACEMENT$1.bottomRight:
      return {
        bottom: 0,
        alignItems: "flex-end",
        justifyContent: "flex-end",
        flexDirection: "column-reverse"
      };
    case PLACEMENT$1.bottom:
      return {
        bottom: 0,
        alignItems: "center",
        justifyContent: "flex-end",
        flexDirection: "column-reverse"
      };
    case PLACEMENT$1.bottomLeft:
      return {
        bottom: 0,
        alignItems: "flex-start",
        justifyContent: "flex-end",
        flexDirection: "column-reverse"
      };
  }
}
var Root$2 = styled("div", function(o) {
  var E = o.$placement, A = o.$theme;
  return _objectSpread$m({
    pointerEvents: "none",
    position: "fixed",
    right: 0,
    left: 0,
    display: "flex",
    marginTop: A.sizing.scale300,
    marginBottom: A.sizing.scale300,
    marginLeft: A.sizing.scale600,
    marginRight: A.sizing.scale600
  }, getPlacement(E));
});
Root$2.displayName = "Root";
Root$2.displayName = "Root";
var InnerContainer = styled(
  "div",
  // eslint-disable-next-line no-empty-pattern
  function(o) {
    return _objectDestructuringEmpty(o), {};
  }
);
InnerContainer.displayName = "InnerContainer";
InnerContainer.displayName = "InnerContainer";
var Body$3 = styled("div", function(o) {
  var E = o.$isVisible, A = o.$kind, g = o.$type, e = o.$theme, t = g === TYPE$1.inline;
  return _objectSpread$m(_objectSpread$m({}, e.typography.font300), {}, {
    pointerEvents: "auto",
    color: getFontColor$1(A, g, e),
    height: "auto",
    width: "288px",
    paddingTop: e.sizing.scale600,
    paddingRight: e.sizing.scale600,
    paddingBottom: e.sizing.scale600,
    paddingLeft: e.sizing.scale600,
    marginTop: e.sizing.scale300,
    marginBottom: e.sizing.scale300,
    backgroundColor: getBackgroundColor$1(A, g, e) || e.colors.accent,
    borderTopLeftRadius: e.borders.radius400,
    borderTopRightRadius: e.borders.radius400,
    borderBottomRightRadius: e.borders.radius400,
    borderBottomLeftRadius: e.borders.radius400,
    boxShadow: t ? "none" : e.lighting.shadow600,
    opacity: E ? 1 : 0,
    transitionProperty: "all",
    transitionDuration: e.animation.timing200,
    transitionTimingFunction: e.animation.easeInOutCurve,
    display: "flex",
    justifyContent: "space-between"
  });
});
Body$3.displayName = "Body";
Body$3.displayName = "Body";
var CloseIconSvg = styled("svg", function(o) {
  var E = o.$theme, A = o.$size, g = o.$color, e = o.$isFocusVisible;
  return _objectSpread$m(_objectSpread$m({}, getSvgStyles$1({
    $theme: E,
    $size: A,
    $color: g
  })), {}, {
    cursor: "pointer",
    width: A || "16px",
    flexShrink: 0,
    outline: e ? "3px solid ".concat(E.colors.accent) : "none"
  });
});
CloseIconSvg.displayName = "CloseIconSvg";
CloseIconSvg.displayName = "CloseIconSvg";
function omitDollarPrefixedKeys(o) {
  var E = {};
  for (var A in o)
    A[0] !== "$" && (E[A] = o[A]);
  return E;
}
var _excluded$o = ["children", "title", "size", "color", "overrides"];
function _extends$q() {
  return _extends$q = Object.assign ? Object.assign.bind() : function(o) {
    for (var E = 1; E < arguments.length; E++) {
      var A = arguments[E];
      for (var g in A)
        Object.prototype.hasOwnProperty.call(A, g) && (o[g] = A[g]);
    }
    return o;
  }, _extends$q.apply(this, arguments);
}
function ownKeys$n(o, E) {
  var A = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var g = Object.getOwnPropertySymbols(o);
    E && (g = g.filter(function(e) {
      return Object.getOwnPropertyDescriptor(o, e).enumerable;
    })), A.push.apply(A, g);
  }
  return A;
}
function _objectSpread$l(o) {
  for (var E = 1; E < arguments.length; E++) {
    var A = arguments[E] != null ? arguments[E] : {};
    E % 2 ? ownKeys$n(Object(A), !0).forEach(function(g) {
      _defineProperty$q(o, g, A[g]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(A)) : ownKeys$n(Object(A)).forEach(function(g) {
      Object.defineProperty(o, g, Object.getOwnPropertyDescriptor(A, g));
    });
  }
  return o;
}
function _defineProperty$q(o, E, A) {
  return E in o ? Object.defineProperty(o, E, { value: A, enumerable: !0, configurable: !0, writable: !0 }) : o[E] = A, o;
}
function _slicedToArray$k(o, E) {
  return _arrayWithHoles$j(o) || _iterableToArrayLimit$j(o, E) || _unsupportedIterableToArray$j(o, E) || _nonIterableRest$j();
}
function _nonIterableRest$j() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$j(o, E) {
  if (o) {
    if (typeof o == "string") return _arrayLikeToArray$j(o, E);
    var A = Object.prototype.toString.call(o).slice(8, -1);
    if (A === "Object" && o.constructor && (A = o.constructor.name), A === "Map" || A === "Set") return Array.from(o);
    if (A === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(A)) return _arrayLikeToArray$j(o, E);
  }
}
function _arrayLikeToArray$j(o, E) {
  (E == null || E > o.length) && (E = o.length);
  for (var A = 0, g = new Array(E); A < E; A++)
    g[A] = o[A];
  return g;
}
function _iterableToArrayLimit$j(o, E) {
  var A = o == null ? null : typeof Symbol < "u" && o[Symbol.iterator] || o["@@iterator"];
  if (A != null) {
    var g = [], e = !0, t = !1, c, n;
    try {
      for (A = A.call(o); !(e = (c = A.next()).done) && (g.push(c.value), !(E && g.length === E)); e = !0)
        ;
    } catch (h) {
      t = !0, n = h;
    } finally {
      try {
        !e && A.return != null && A.return();
      } finally {
        if (t) throw n;
      }
    }
    return g;
  }
}
function _arrayWithHoles$j(o) {
  if (Array.isArray(o)) return o;
}
function _objectWithoutProperties$m(o, E) {
  if (o == null) return {};
  var A = _objectWithoutPropertiesLoose$l(o, E), g, e;
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    for (e = 0; e < t.length; e++)
      g = t[e], !(E.indexOf(g) >= 0) && Object.prototype.propertyIsEnumerable.call(o, g) && (A[g] = o[g]);
  }
  return A;
}
function _objectWithoutPropertiesLoose$l(o, E) {
  if (o == null) return {};
  var A = {}, g = Object.keys(o), e, t;
  for (t = 0; t < g.length; t++)
    e = g[t], !(E.indexOf(e) >= 0) && (A[e] = o[e]);
  return A;
}
var Icon = function o(E, A) {
  var g = E.children, e = E.title, t = E.size, c = E.color, n = E.overrides, h = n === void 0 ? {} : n, d = _objectWithoutProperties$m(E, _excluded$o), k = getOverrides(h.Svg, Svg), p = _slicedToArray$k(k, 2), M = p[0], S = p[1], AA = M.__STYLETRON__ ? _objectSpread$l(_objectSpread$l({
    title: e,
    $color: c,
    $size: t
  }, d), S) : _objectSpread$l(_objectSpread$l({
    title: e,
    color: c,
    size: t
  }, omitDollarPrefixedKeys(d)), omitDollarPrefixedKeys(S));
  return /* @__PURE__ */ React.createElement(M, _extends$q({
    "data-baseweb": "icon",
    ref: A
  }, AA), e ? /* @__PURE__ */ React.createElement("title", null, e) : null, g);
};
const Icon$1 = /* @__PURE__ */ React.forwardRef(Icon);
var _excluded$n = ["title", "size", "color", "overrides"];
function _extends$p() {
  return _extends$p = Object.assign ? Object.assign.bind() : function(o) {
    for (var E = 1; E < arguments.length; E++) {
      var A = arguments[E];
      for (var g in A)
        Object.prototype.hasOwnProperty.call(A, g) && (o[g] = A[g]);
    }
    return o;
  }, _extends$p.apply(this, arguments);
}
function _objectWithoutProperties$l(o, E) {
  if (o == null) return {};
  var A = _objectWithoutPropertiesLoose$k(o, E), g, e;
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    for (e = 0; e < t.length; e++)
      g = t[e], !(E.indexOf(g) >= 0) && Object.prototype.propertyIsEnumerable.call(o, g) && (A[g] = o[g]);
  }
  return A;
}
function _objectWithoutPropertiesLoose$k(o, E) {
  if (o == null) return {};
  var A = {}, g = Object.keys(o), e, t;
  for (t = 0; t < g.length; t++)
    e = g[t], !(E.indexOf(e) >= 0) && (A[e] = o[e]);
  return A;
}
function _slicedToArray$j(o, E) {
  return _arrayWithHoles$i(o) || _iterableToArrayLimit$i(o, E) || _unsupportedIterableToArray$i(o, E) || _nonIterableRest$i();
}
function _nonIterableRest$i() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$i(o, E) {
  if (o) {
    if (typeof o == "string") return _arrayLikeToArray$i(o, E);
    var A = Object.prototype.toString.call(o).slice(8, -1);
    if (A === "Object" && o.constructor && (A = o.constructor.name), A === "Map" || A === "Set") return Array.from(o);
    if (A === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(A)) return _arrayLikeToArray$i(o, E);
  }
}
function _arrayLikeToArray$i(o, E) {
  (E == null || E > o.length) && (E = o.length);
  for (var A = 0, g = new Array(E); A < E; A++)
    g[A] = o[A];
  return g;
}
function _iterableToArrayLimit$i(o, E) {
  var A = o == null ? null : typeof Symbol < "u" && o[Symbol.iterator] || o["@@iterator"];
  if (A != null) {
    var g = [], e = !0, t = !1, c, n;
    try {
      for (A = A.call(o); !(e = (c = A.next()).done) && (g.push(c.value), !(E && g.length === E)); e = !0)
        ;
    } catch (h) {
      t = !0, n = h;
    } finally {
      try {
        !e && A.return != null && A.return();
      } finally {
        if (t) throw n;
      }
    }
    return g;
  }
}
function _arrayWithHoles$i(o) {
  if (Array.isArray(o)) return o;
}
function Delete(o, E) {
  var A = useStyletron(), g = _slicedToArray$j(A, 2), e = g[1], t = o.title, c = t === void 0 ? "Delete" : t, n = o.size, h = o.color, d = o.overrides, k = d === void 0 ? {} : d, p = _objectWithoutProperties$l(o, _excluded$n), M = mergeOverride(
    // Icons from the theme target the SVG override in the underlying Icon component
    {
      component: e.icons && e.icons.Delete ? e.icons.Delete : null
    },
    k && k.Svg ? toObjectOverride(k.Svg) : {}
  );
  return /* @__PURE__ */ React.createElement(Icon$1, _extends$p({
    viewBox: "0 0 24 24",
    ref: E,
    title: c,
    size: n,
    color: h,
    overrides: {
      Svg: M
    }
  }, p), /* @__PURE__ */ React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.29289 7.29289C7.68342 6.90237 8.31658 6.90237 8.70711 7.29289L12 10.5858L15.2929 7.29289C15.6834 6.90237 16.3166 6.90237 16.7071 7.29289C17.0976 7.68342 17.0976 8.31658 16.7071 8.70711L13.4142 12L16.7071 15.2929C17.0976 15.6834 17.0976 16.3166 16.7071 16.7071C16.3166 17.0976 15.6834 17.0976 15.2929 16.7071L12 13.4142L8.70711 16.7071C8.31658 17.0976 7.68342 17.0976 7.29289 16.7071C6.90237 16.3166 6.90237 15.6834 7.29289 15.2929L10.5858 12L7.29289 8.70711C6.90237 8.31658 6.90237 7.68342 7.29289 7.29289Z"
  }));
}
const DeleteIcon = /* @__PURE__ */ React.forwardRef(Delete);
function _typeof$e(o) {
  "@babel/helpers - typeof";
  return _typeof$e = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(E) {
    return typeof E;
  } : function(E) {
    return E && typeof Symbol == "function" && E.constructor === Symbol && E !== Symbol.prototype ? "symbol" : typeof E;
  }, _typeof$e(o);
}
function _extends$o() {
  return _extends$o = Object.assign ? Object.assign.bind() : function(o) {
    for (var E = 1; E < arguments.length; E++) {
      var A = arguments[E];
      for (var g in A)
        Object.prototype.hasOwnProperty.call(A, g) && (o[g] = A[g]);
    }
    return o;
  }, _extends$o.apply(this, arguments);
}
function _slicedToArray$i(o, E) {
  return _arrayWithHoles$h(o) || _iterableToArrayLimit$h(o, E) || _unsupportedIterableToArray$h(o, E) || _nonIterableRest$h();
}
function _nonIterableRest$h() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$h(o, E) {
  if (o) {
    if (typeof o == "string") return _arrayLikeToArray$h(o, E);
    var A = Object.prototype.toString.call(o).slice(8, -1);
    if (A === "Object" && o.constructor && (A = o.constructor.name), A === "Map" || A === "Set") return Array.from(o);
    if (A === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(A)) return _arrayLikeToArray$h(o, E);
  }
}
function _arrayLikeToArray$h(o, E) {
  (E == null || E > o.length) && (E = o.length);
  for (var A = 0, g = new Array(E); A < E; A++)
    g[A] = o[A];
  return g;
}
function _iterableToArrayLimit$h(o, E) {
  var A = o == null ? null : typeof Symbol < "u" && o[Symbol.iterator] || o["@@iterator"];
  if (A != null) {
    var g = [], e = !0, t = !1, c, n;
    try {
      for (A = A.call(o); !(e = (c = A.next()).done) && (g.push(c.value), !(E && g.length === E)); e = !0)
        ;
    } catch (h) {
      t = !0, n = h;
    } finally {
      try {
        !e && A.return != null && A.return();
      } finally {
        if (t) throw n;
      }
    }
    return g;
  }
}
function _arrayWithHoles$h(o) {
  if (Array.isArray(o)) return o;
}
function _classCallCheck$c(o, E) {
  if (!(o instanceof E))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$c(o, E) {
  for (var A = 0; A < E.length; A++) {
    var g = E[A];
    g.enumerable = g.enumerable || !1, g.configurable = !0, "value" in g && (g.writable = !0), Object.defineProperty(o, g.key, g);
  }
}
function _createClass$c(o, E, A) {
  return E && _defineProperties$c(o.prototype, E), Object.defineProperty(o, "prototype", { writable: !1 }), o;
}
function _inherits$c(o, E) {
  if (typeof E != "function" && E !== null)
    throw new TypeError("Super expression must either be null or a function");
  o.prototype = Object.create(E && E.prototype, { constructor: { value: o, writable: !0, configurable: !0 } }), Object.defineProperty(o, "prototype", { writable: !1 }), E && _setPrototypeOf$c(o, E);
}
function _setPrototypeOf$c(o, E) {
  return _setPrototypeOf$c = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(g, e) {
    return g.__proto__ = e, g;
  }, _setPrototypeOf$c(o, E);
}
function _createSuper$c(o) {
  var E = _isNativeReflectConstruct$c();
  return function() {
    var g = _getPrototypeOf$c(o), e;
    if (E) {
      var t = _getPrototypeOf$c(this).constructor;
      e = Reflect.construct(g, arguments, t);
    } else
      e = g.apply(this, arguments);
    return _possibleConstructorReturn$c(this, e);
  };
}
function _possibleConstructorReturn$c(o, E) {
  if (E && (_typeof$e(E) === "object" || typeof E == "function"))
    return E;
  if (E !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$d(o);
}
function _assertThisInitialized$d(o) {
  if (o === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return o;
}
function _isNativeReflectConstruct$c() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function _getPrototypeOf$c(o) {
  return _getPrototypeOf$c = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(A) {
    return A.__proto__ || Object.getPrototypeOf(A);
  }, _getPrototypeOf$c(o);
}
function _defineProperty$p(o, E, A) {
  return E in o ? Object.defineProperty(o, E, { value: A, enumerable: !0, configurable: !0, writable: !0 }) : o[E] = A, o;
}
var Toast$1 = /* @__PURE__ */ (function(o) {
  _inherits$c(A, o);
  var E = _createSuper$c(A);
  function A(g) {
    var e;
    return _classCallCheck$c(this, A), e = E.call(this, g), _defineProperty$p(_assertThisInitialized$d(e), "autoHideTimeout", void 0), _defineProperty$p(_assertThisInitialized$d(e), "animateInTimer", void 0), _defineProperty$p(_assertThisInitialized$d(e), "animateOutCompleteTimer", void 0), _defineProperty$p(_assertThisInitialized$d(e), "closeRef", void 0), _defineProperty$p(_assertThisInitialized$d(e), "previouslyFocusedElement", void 0), _defineProperty$p(_assertThisInitialized$d(e), "state", {
      isVisible: !1,
      isRendered: !0,
      isFocusVisible: !1
    }), _defineProperty$p(_assertThisInitialized$d(e), "handleFocus", function(t) {
      isFocusVisible(t) && e.setState({
        isFocusVisible: !0
      });
    }), _defineProperty$p(_assertThisInitialized$d(e), "handleBlur", function(t) {
      e.state.isFocusVisible !== !1 && e.setState({
        isFocusVisible: !1
      });
    }), _defineProperty$p(_assertThisInitialized$d(e), "animateIn", function() {
      e.animateInTimer = setTimeout(function() {
        e.setState({
          isVisible: !0
        });
      }, 0);
    }), _defineProperty$p(_assertThisInitialized$d(e), "animateOut", function() {
      var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : function() {
      };
      e.setState({
        isVisible: !1
      }), e.animateOutCompleteTimer = setTimeout(function() {
        e.setState({
          isRendered: !1
        }), t();
      }, 600);
    }), _defineProperty$p(_assertThisInitialized$d(e), "dismiss", function() {
      e.animateOut(e.props.onClose), e.props.autoFocus && e.previouslyFocusedElement && e.previouslyFocusedElement.focus();
    }), _defineProperty$p(_assertThisInitialized$d(e), "onFocus", function(t) {
      e.state.isVisible && (clearTimeout(e.autoHideTimeout), clearTimeout(e.animateOutCompleteTimer), typeof e.props.onFocus == "function" && e.props.onFocus(t));
    }), _defineProperty$p(_assertThisInitialized$d(e), "onMouseEnter", function(t) {
      e.state.isVisible && (clearTimeout(e.autoHideTimeout), clearTimeout(e.animateOutCompleteTimer), typeof e.props.onMouseEnter == "function" && e.props.onMouseEnter(t));
    }), _defineProperty$p(_assertThisInitialized$d(e), "onBlur", function(t) {
      e.startTimeout(), typeof e.props.onBlur == "function" && e.props.onBlur(t);
    }), _defineProperty$p(_assertThisInitialized$d(e), "onMouseLeave", function(t) {
      e.startTimeout(), typeof e.props.onMouseLeave == "function" && e.props.onMouseLeave(t);
    }), e.closeRef = /* @__PURE__ */ React.createRef(), e.previouslyFocusedElement = null, e;
  }
  return _createClass$c(A, [{
    key: "componentDidMount",
    value: function() {
      this.animateIn(), this.startTimeout(), typeof document < "u" && this.props.autoFocus && this.closeRef && this.closeRef.current && this.closeRef.current.focus && typeof this.closeRef.current.focus == "function" && (this.previouslyFocusedElement = document.activeElement, this.closeRef.current.focus(), this.setState({
        isFocusVisible: !0
      }));
    }
  }, {
    key: "componentDidUpdate",
    value: function(e) {
      (this.props.autoHideDuration !== e.autoHideDuration || this.props.__updated !== e.__updated) && this.startTimeout();
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.clearTimeout();
    }
  }, {
    key: "startTimeout",
    value: function() {
      this.props.autoHideDuration && (this.autoHideTimeout && clearTimeout(this.autoHideTimeout), this.autoHideTimeout = setTimeout(this.dismiss, this.props.autoHideDuration));
    }
  }, {
    key: "clearTimeout",
    value: (function(g) {
      function e() {
        return g.apply(this, arguments);
      }
      return e.toString = function() {
        return g.toString();
      }, e;
    })(function() {
      [this.autoHideTimeout, this.animateInTimer, this.animateOutCompleteTimer].forEach(function(g) {
        g && clearTimeout(g);
      });
    })
  }, {
    key: "getSharedProps",
    value: function() {
      var e = this.props, t = e.kind, c = e.notificationType, n = e.closeable, h = this.state, d = h.isRendered, k = h.isVisible;
      return {
        $kind: t,
        $type: c,
        $closeable: n,
        $isRendered: d,
        $isVisible: k
      };
    }
  }, {
    key: "render",
    value: function() {
      var e = this, t = this.props, c = t.children, n = t.closeable, h = this.state.isRendered, d = this.props.overrides, k = d.Body, p = d.CloseIcon, M = d.InnerContainer, S = getOverrides(k, Body$3), AA = _slicedToArray$i(S, 2), H = AA[0], gA = AA[1], CA = getOverrides(M, InnerContainer), IA = _slicedToArray$i(CA, 2), BA = IA[0], QA = IA[1], EA = getOverrides(p, CloseIconSvg), oA = _slicedToArray$i(EA, 2), iA = oA[0], aA = oA[1], tA = mergeOverrides({
        Svg: {
          component: iA
        }
      }, {
        Svg: p
      }), eA = this.getSharedProps();
      return h ? /* @__PURE__ */ React.createElement(LocaleContext.Consumer, null, function(cA) {
        return /* @__PURE__ */ React.createElement(H, _extends$o({
          role: "alert",
          "data-baseweb": e.props["data-baseweb"] || "toast"
        }, eA, gA, {
          // the properties below have to go after overrides
          onBlur: e.onBlur,
          onFocus: e.onFocus,
          onMouseEnter: e.onMouseEnter,
          onMouseLeave: e.onMouseLeave
        }), /* @__PURE__ */ React.createElement(BA, _extends$o({}, eA, QA), typeof c == "function" ? c({
          dismiss: e.dismiss
        }) : c), n ? /* @__PURE__ */ React.createElement(DeleteIcon, _extends$o({
          ref: e.closeRef,
          role: "button",
          tabIndex: 0,
          $isFocusVisible: e.state.isFocusVisible,
          onClick: e.dismiss,
          onKeyPress: function(nA) {
            nA.key === "Enter" && e.dismiss();
          },
          title: cA.toast.close
        }, eA, aA, {
          onFocus: forkFocus(aA, e.handleFocus),
          onBlur: forkBlur(aA, e.handleBlur),
          overrides: tA
        })) : null);
      }) : null;
    }
  }]), A;
})(React.Component);
_defineProperty$p(Toast$1, "defaultProps", {
  autoFocus: !1,
  autoHideDuration: 0,
  closeable: !0,
  kind: KIND$1.info,
  notificationType: TYPE$1.toast,
  // Do we need a separate handler for
  // when a notification dismisses automatically
  onClose: function o() {
  },
  onBlur: function o() {
  },
  onFocus: function o() {
  },
  onMouseEnter: function o() {
  },
  onMouseLeave: function o() {
  },
  overrides: {}
});
function _typeof$d(o) {
  "@babel/helpers - typeof";
  return _typeof$d = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(E) {
    return typeof E;
  } : function(E) {
    return E && typeof Symbol == "function" && E.constructor === Symbol && E !== Symbol.prototype ? "symbol" : typeof E;
  }, _typeof$d(o);
}
var _excluded$m = ["onClose", "children", "key"];
function _slicedToArray$h(o, E) {
  return _arrayWithHoles$g(o) || _iterableToArrayLimit$g(o, E) || _unsupportedIterableToArray$g(o, E) || _nonIterableRest$g();
}
function _nonIterableRest$g() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _iterableToArrayLimit$g(o, E) {
  var A = o == null ? null : typeof Symbol < "u" && o[Symbol.iterator] || o["@@iterator"];
  if (A != null) {
    var g = [], e = !0, t = !1, c, n;
    try {
      for (A = A.call(o); !(e = (c = A.next()).done) && (g.push(c.value), !(E && g.length === E)); e = !0)
        ;
    } catch (h) {
      t = !0, n = h;
    } finally {
      try {
        !e && A.return != null && A.return();
      } finally {
        if (t) throw n;
      }
    }
    return g;
  }
}
function _arrayWithHoles$g(o) {
  if (Array.isArray(o)) return o;
}
function _extends$n() {
  return _extends$n = Object.assign ? Object.assign.bind() : function(o) {
    for (var E = 1; E < arguments.length; E++) {
      var A = arguments[E];
      for (var g in A)
        Object.prototype.hasOwnProperty.call(A, g) && (o[g] = A[g]);
    }
    return o;
  }, _extends$n.apply(this, arguments);
}
function _objectWithoutProperties$k(o, E) {
  if (o == null) return {};
  var A = _objectWithoutPropertiesLoose$j(o, E), g, e;
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    for (e = 0; e < t.length; e++)
      g = t[e], !(E.indexOf(g) >= 0) && Object.prototype.propertyIsEnumerable.call(o, g) && (A[g] = o[g]);
  }
  return A;
}
function _objectWithoutPropertiesLoose$j(o, E) {
  if (o == null) return {};
  var A = {}, g = Object.keys(o), e, t;
  for (t = 0; t < g.length; t++)
    e = g[t], !(E.indexOf(e) >= 0) && (A[e] = o[e]);
  return A;
}
function _toConsumableArray$2(o) {
  return _arrayWithoutHoles$2(o) || _iterableToArray$2(o) || _unsupportedIterableToArray$g(o) || _nonIterableSpread$2();
}
function _nonIterableSpread$2() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$g(o, E) {
  if (o) {
    if (typeof o == "string") return _arrayLikeToArray$g(o, E);
    var A = Object.prototype.toString.call(o).slice(8, -1);
    if (A === "Object" && o.constructor && (A = o.constructor.name), A === "Map" || A === "Set") return Array.from(o);
    if (A === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(A)) return _arrayLikeToArray$g(o, E);
  }
}
function _iterableToArray$2(o) {
  if (typeof Symbol < "u" && o[Symbol.iterator] != null || o["@@iterator"] != null) return Array.from(o);
}
function _arrayWithoutHoles$2(o) {
  if (Array.isArray(o)) return _arrayLikeToArray$g(o);
}
function _arrayLikeToArray$g(o, E) {
  (E == null || E > o.length) && (E = o.length);
  for (var A = 0, g = new Array(E); A < E; A++)
    g[A] = o[A];
  return g;
}
function ownKeys$m(o, E) {
  var A = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var g = Object.getOwnPropertySymbols(o);
    E && (g = g.filter(function(e) {
      return Object.getOwnPropertyDescriptor(o, e).enumerable;
    })), A.push.apply(A, g);
  }
  return A;
}
function _objectSpread$k(o) {
  for (var E = 1; E < arguments.length; E++) {
    var A = arguments[E] != null ? arguments[E] : {};
    E % 2 ? ownKeys$m(Object(A), !0).forEach(function(g) {
      _defineProperty$o(o, g, A[g]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(A)) : ownKeys$m(Object(A)).forEach(function(g) {
      Object.defineProperty(o, g, Object.getOwnPropertyDescriptor(A, g));
    });
  }
  return o;
}
function _classCallCheck$b(o, E) {
  if (!(o instanceof E))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$b(o, E) {
  for (var A = 0; A < E.length; A++) {
    var g = E[A];
    g.enumerable = g.enumerable || !1, g.configurable = !0, "value" in g && (g.writable = !0), Object.defineProperty(o, g.key, g);
  }
}
function _createClass$b(o, E, A) {
  return E && _defineProperties$b(o.prototype, E), Object.defineProperty(o, "prototype", { writable: !1 }), o;
}
function _inherits$b(o, E) {
  if (typeof E != "function" && E !== null)
    throw new TypeError("Super expression must either be null or a function");
  o.prototype = Object.create(E && E.prototype, { constructor: { value: o, writable: !0, configurable: !0 } }), Object.defineProperty(o, "prototype", { writable: !1 }), E && _setPrototypeOf$b(o, E);
}
function _setPrototypeOf$b(o, E) {
  return _setPrototypeOf$b = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(g, e) {
    return g.__proto__ = e, g;
  }, _setPrototypeOf$b(o, E);
}
function _createSuper$b(o) {
  var E = _isNativeReflectConstruct$b();
  return function() {
    var g = _getPrototypeOf$b(o), e;
    if (E) {
      var t = _getPrototypeOf$b(this).constructor;
      e = Reflect.construct(g, arguments, t);
    } else
      e = g.apply(this, arguments);
    return _possibleConstructorReturn$b(this, e);
  };
}
function _possibleConstructorReturn$b(o, E) {
  if (E && (_typeof$d(E) === "object" || typeof E == "function"))
    return E;
  if (E !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$c(o);
}
function _assertThisInitialized$c(o) {
  if (o === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return o;
}
function _isNativeReflectConstruct$b() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function _getPrototypeOf$b(o) {
  return _getPrototypeOf$b = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(A) {
    return A.__proto__ || Object.getPrototypeOf(A);
  }, _getPrototypeOf$b(o);
}
function _defineProperty$o(o, E, A) {
  return E in o ? Object.defineProperty(o, E, { value: A, enumerable: !0, configurable: !0, writable: !0 }) : o[E] = A, o;
}
var toasterRef, ToasterContainer = /* @__PURE__ */ (function(o) {
  _inherits$b(A, o);
  var E = _createSuper$b(A);
  function A(g) {
    var e;
    return _classCallCheck$b(this, A), e = E.call(this, g), _defineProperty$o(_assertThisInitialized$c(e), "state", {
      isMounted: !1,
      toasts: []
    }), _defineProperty$o(_assertThisInitialized$c(e), "dismissHandlers", {}), _defineProperty$o(_assertThisInitialized$c(e), "toastId", 0), _defineProperty$o(_assertThisInitialized$c(e), "getToastProps", function(t) {
      var c = e.props, n = c.autoFocus, h = c.autoHideDuration, d = c.closeable, k = t.key || "toast-".concat(e.toastId++);
      return _objectSpread$k(_objectSpread$k({
        autoFocus: n,
        autoHideDuration: h,
        closeable: d
      }, t), {}, {
        key: k
      });
    }), _defineProperty$o(_assertThisInitialized$c(e), "show", function() {
      var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      if (e.state.toasts.map(function(n) {
        return n.key;
      }).includes(t.key))
        return e.update(t.key, t), t.key;
      var c = e.getToastProps(t);
      return e.setState(function(n) {
        var h = n.toasts;
        return {
          toasts: [].concat(_toConsumableArray$2(h), [c])
        };
      }), c.key;
    }), _defineProperty$o(_assertThisInitialized$c(e), "update", function(t, c) {
      e.setState(function(n) {
        var h = n.toasts, d = h.map(function(k) {
          if (k.key === t) {
            var p = _objectSpread$k(_objectSpread$k(_objectSpread$k({}, k), e.getToastProps(_objectSpread$k({
              autoHideDuration: k.autoHideDuration
            }, c))), {}, {
              key: t
            }, e.props.resetAutoHideTimerOnUpdate ? {
              __updated: (+k.__updated || 0) + 1
            } : {});
            return p;
          }
          return k;
        });
        return {
          toasts: d
        };
      });
    }), _defineProperty$o(_assertThisInitialized$c(e), "dismiss", function(t) {
      e.dismissHandlers[t] && e.dismissHandlers[t]();
    }), _defineProperty$o(_assertThisInitialized$c(e), "clearAll", function() {
      Object.keys(e.dismissHandlers).forEach(function(t) {
        e.dismissHandlers[t]();
      });
    }), _defineProperty$o(_assertThisInitialized$c(e), "clear", function(t) {
      t === void 0 ? e.clearAll() : e.dismiss(t);
    }), _defineProperty$o(_assertThisInitialized$c(e), "internalOnClose", function(t) {
      delete e.dismissHandlers[t], e.setState(function(c) {
        var n = c.toasts;
        return {
          toasts: n.filter(function(h) {
            return h.key !== t;
          })
        };
      });
    }), _defineProperty$o(_assertThisInitialized$c(e), "getOnCloseHandler", function(t, c) {
      return function() {
        e.internalOnClose(t), typeof c == "function" && c();
      };
    }), _defineProperty$o(_assertThisInitialized$c(e), "renderToast", function(t) {
      var c = t.onClose, n = t.children, h = t.key, d = _objectWithoutProperties$k(t, _excluded$m), k = e.props.overrides, p = k.ToastBody, M = k.ToastCloseIcon, S = k.ToastInnerContainer, AA = mergeOverrides({
        Body: Body$3,
        CloseIcon: CloseIconSvg,
        InnerContainer
      }, {
        Body: p || {},
        CloseIcon: M || {},
        InnerContainer: S || {}
      }), H = mergeOverrides(AA, t.overrides);
      return /* @__PURE__ */ React.createElement(Toast$1, _extends$n({}, d, {
        overrides: H,
        key: h,
        onClose: e.getOnCloseHandler(h, c)
      }), function(gA) {
        var CA = gA.dismiss;
        return e.dismissHandlers[h] = CA, n;
      });
    }), _defineProperty$o(_assertThisInitialized$c(e), "getSharedProps", function() {
      var t = e.props.placement;
      return {
        $placement: t
      };
    }), toasterRef = _assertThisInitialized$c(e), e;
  }
  return _createClass$b(A, [{
    key: "componentDidMount",
    value: function() {
      this.setState({
        isMounted: !0
      });
    }
  }, {
    key: "render",
    value: function() {
      for (var e = this.getSharedProps(), t = this.props.overrides.Root, c = getOverrides(t, Root$2), n = _slicedToArray$h(c, 2), h = n[0], d = n[1], k = this.state.toasts.length, p = [], M = k - 1; M >= 0; M--)
        p.push(this.renderToast(this.state.toasts[M]));
      var S = /* @__PURE__ */ React.createElement(h, _extends$n({
        "data-baseweb": "toaster"
      }, e, d), p);
      return this.state.isMounted ? /* @__PURE__ */ React.createElement(React.Fragment, null, this.props.usePortal && typeof document < "u" && document.body ? /* @__PURE__ */ ReactDOM.createPortal(S, document.body) : S, this.props.children) : /* @__PURE__ */ React.createElement(React.Fragment, null, this.props.children);
    }
  }]), A;
})(React.Component);
_defineProperty$o(ToasterContainer, "defaultProps", {
  autoFocus: !1,
  autoHideDuration: 0,
  children: null,
  closeable: !0,
  overrides: {},
  placement: PLACEMENT$1.top,
  resetAutoHideTimerOnUpdate: !0,
  usePortal: !0
});
var toaster = {
  getRef: function o() {
    return toasterRef;
  },
  show: function o(E) {
    var A = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, g = this.getRef();
    if (g)
      return g.show(_objectSpread$k(_objectSpread$k({}, A), {}, {
        children: E
      }));
    if (process.env.NODE_ENV !== "production")
      throw new Error("Please make sure to add the ToasterContainer to your application, and it is mounted, before adding toasts! You can find more information here: https://baseweb.design/components/toast");
  },
  info: function o(E) {
    var A = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return this.show(E, _objectSpread$k(_objectSpread$k({}, A), {}, {
      kind: KIND$1.info
    }));
  },
  positive: function o(E) {
    var A = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return this.show(E, _objectSpread$k(_objectSpread$k({}, A), {}, {
      kind: KIND$1.positive
    }));
  },
  warning: function o(E) {
    var A = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return this.show(E, _objectSpread$k(_objectSpread$k({}, A), {}, {
      kind: KIND$1.warning
    }));
  },
  negative: function o(E) {
    var A = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return this.show(E, _objectSpread$k(_objectSpread$k({}, A), {}, {
      kind: KIND$1.negative
    }));
  },
  update: function o(E, A) {
    var g = this.getRef();
    g ? g.update(E, A) : process.env.NODE_ENV !== "production" && console.error("No ToasterContainer is mounted yet.");
  },
  clear: function o(E) {
    var A = this.getRef();
    A ? A.clear(E) : process.env.NODE_ENV !== "production" && console.error("No ToasterContainer is mounted yet.");
  }
};
function _typeof$c(o) {
  "@babel/helpers - typeof";
  return _typeof$c = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(E) {
    return typeof E;
  } : function(E) {
    return E && typeof Symbol == "function" && E.constructor === Symbol && E !== Symbol.prototype ? "symbol" : typeof E;
  }, _typeof$c(o);
}
function _extends$m() {
  return _extends$m = Object.assign ? Object.assign.bind() : function(o) {
    for (var E = 1; E < arguments.length; E++) {
      var A = arguments[E];
      for (var g in A)
        Object.prototype.hasOwnProperty.call(A, g) && (o[g] = A[g]);
    }
    return o;
  }, _extends$m.apply(this, arguments);
}
function _classCallCheck$a(o, E) {
  if (!(o instanceof E))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$a(o, E) {
  for (var A = 0; A < E.length; A++) {
    var g = E[A];
    g.enumerable = g.enumerable || !1, g.configurable = !0, "value" in g && (g.writable = !0), Object.defineProperty(o, g.key, g);
  }
}
function _createClass$a(o, E, A) {
  return E && _defineProperties$a(o.prototype, E), Object.defineProperty(o, "prototype", { writable: !1 }), o;
}
function _inherits$a(o, E) {
  if (typeof E != "function" && E !== null)
    throw new TypeError("Super expression must either be null or a function");
  o.prototype = Object.create(E && E.prototype, { constructor: { value: o, writable: !0, configurable: !0 } }), Object.defineProperty(o, "prototype", { writable: !1 }), E && _setPrototypeOf$a(o, E);
}
function _setPrototypeOf$a(o, E) {
  return _setPrototypeOf$a = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(g, e) {
    return g.__proto__ = e, g;
  }, _setPrototypeOf$a(o, E);
}
function _createSuper$a(o) {
  var E = _isNativeReflectConstruct$a();
  return function() {
    var g = _getPrototypeOf$a(o), e;
    if (E) {
      var t = _getPrototypeOf$a(this).constructor;
      e = Reflect.construct(g, arguments, t);
    } else
      e = g.apply(this, arguments);
    return _possibleConstructorReturn$a(this, e);
  };
}
function _possibleConstructorReturn$a(o, E) {
  if (E && (_typeof$c(E) === "object" || typeof E == "function"))
    return E;
  if (E !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$b(o);
}
function _assertThisInitialized$b(o) {
  if (o === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return o;
}
function _isNativeReflectConstruct$a() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function _getPrototypeOf$a(o) {
  return _getPrototypeOf$a = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(A) {
    return A.__proto__ || Object.getPrototypeOf(A);
  }, _getPrototypeOf$a(o);
}
function _defineProperty$n(o, E, A) {
  return E in o ? Object.defineProperty(o, E, { value: A, enumerable: !0, configurable: !0, writable: !0 }) : o[E] = A, o;
}
var Notification = /* @__PURE__ */ (function(o) {
  _inherits$a(A, o);
  var E = _createSuper$a(A);
  function A() {
    return _classCallCheck$a(this, A), E.apply(this, arguments);
  }
  return _createClass$a(A, [{
    key: "render",
    value: function() {
      var e = mergeOverrides({
        Body: {
          style: function(c) {
            var n = c.$theme;
            return {
              marginTop: n.sizing.scale600,
              marginRight: n.sizing.scale600,
              marginBottom: n.sizing.scale600,
              marginLeft: n.sizing.scale600
            };
          }
        }
      }, this.props.overrides);
      return /* @__PURE__ */ React.createElement(Toast$1, _extends$m({
        "data-baseweb": "notification"
      }, this.props, {
        overrides: e
      }));
    }
  }]), A;
})(React.Component);
_defineProperty$n(Notification, "defaultProps", {
  notificationType: TYPE$1.inline,
  closeable: !1
});
const StyledAlertContent$1 = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e1e4pi9i0"
} : {
  target: "e1e4pi9i0",
  label: "StyledAlertContent"
})(({
  theme: o
}) => ({
  pre: {
    backgroundColor: o.colors.transparent,
    paddingTop: o.spacing.lg,
    paddingBottom: o.spacing.lg,
    paddingRight: o.spacing.lg,
    paddingLeft: o.spacing.lg,
    border: `${o.sizes.borderWidth} solid ${o.colors.borderColor}`,
    "pre, code": {
      backgroundColor: o.colors.transparent,
      color: "inherit"
    }
  },
  code: {
    backgroundColor: o.colors.transparent,
    padding: o.spacing.none
  },
  "pre, code": {
    color: "inherit"
  },
  a: {
    color: "inherit",
    textDecoration: "underline"
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
var Kind = /* @__PURE__ */ ((o) => (o.ERROR = "error", o.INFO = "info", o.SUCCESS = "success", o.WARNING = "warning", o))(Kind || {});
function getNotificationKind(o) {
  switch (o) {
    case "error":
      return KIND$1.negative;
    case "info":
      return KIND$1.info;
    case "success":
      return KIND$1.positive;
    case "warning":
      return KIND$1.warning;
    default:
      throw new Error(`Unexpected alert type: ${o}`);
  }
}
function AlertContainer({
  kind: o,
  width: E,
  children: A
}) {
  const g = useEmotionTheme(), e = o.charAt(0).toUpperCase() + o.slice(1);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Notification, { kind: getNotificationKind(o), overrides: {
    Body: {
      style: {
        fontWeight: g.fontWeights.normal,
        marginTop: g.spacing.none,
        marginBottom: g.spacing.none,
        marginLeft: g.spacing.none,
        marginRight: g.spacing.none,
        width: E ? E.toString() : void 0,
        border: 0,
        borderTopRightRadius: g.radii.default,
        borderBottomRightRadius: g.radii.default,
        borderTopLeftRadius: g.radii.default,
        borderBottomLeftRadius: g.radii.default,
        paddingTop: g.spacing.lg,
        paddingBottom: g.spacing.lg,
        paddingRight: g.spacing.lg,
        paddingLeft: g.spacing.lg
      },
      props: {
        "data-testid": "stAlertContainer",
        className: "stAlertContainer"
      }
    },
    InnerContainer: {
      style: {
        width: "100%",
        lineHeight: g.lineHeights.small
      }
    }
  }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledAlertContent$1, { "data-testid": `stAlertContent${e}`, children: A }) });
}
const StyledStackTrace = /* @__PURE__ */ createStyled("pre", process.env.NODE_ENV === "production" ? {
  target: "e1ixn3a01"
} : {
  target: "e1ixn3a01",
  label: "StyledStackTrace"
})(({
  theme: o
}) => ({
  whiteSpace: "pre-wrap",
  wordWrap: "break-word",
  color: "inherit",
  fontSize: o.fontSizes.codeFontSize,
  fontFamily: o.genericFonts.codeFont,
  fontWeight: o.fontWeights.code,
  backgroundColor: o.colors.transparent,
  overflowX: "auto",
  margin: 0,
  borderRadius: o.radii.default,
  padding: o.spacing.lg,
  border: `${o.sizes.borderWidth} solid ${o.colors.borderColor}`
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledErrorName = /* @__PURE__ */ createStyled("strong", process.env.NODE_ENV === "production" ? {
  target: "e1ixn3a00"
} : {
  target: "e1ixn3a00",
  label: "StyledErrorName"
})(({
  theme: o
}) => ({
  fontWeight: o.fontWeights.codeBold
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2xpYi9zcmMvY29tcG9uZW50cy9zaGFyZWQvRXJyb3JFbGVtZW50L3N0eWxlZC1jb21wb25lbnRzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWlDK0IiLCJmaWxlIjoiL2hvbWUvcnVubmVyL3dvcmsvc3RsaXRlL3N0bGl0ZS9zdHJlYW1saXQvZnJvbnRlbmQvbGliL3NyYy9jb21wb25lbnRzL3NoYXJlZC9FcnJvckVsZW1lbnQvc3R5bGVkLWNvbXBvbmVudHMudHMiLCJzb3VyY2VzQ29udGVudCI6WyIvKipcbiAqIENvcHlyaWdodCAoYykgU3RyZWFtbGl0IEluYy4gKDIwMTgtMjAyMikgU25vd2ZsYWtlIEluYy4gKDIwMjItMjAyNSlcbiAqXG4gKiBMaWNlbnNlZCB1bmRlciB0aGUgQXBhY2hlIExpY2Vuc2UsIFZlcnNpb24gMi4wICh0aGUgXCJMaWNlbnNlXCIpO1xuICogeW91IG1heSBub3QgdXNlIHRoaXMgZmlsZSBleGNlcHQgaW4gY29tcGxpYW5jZSB3aXRoIHRoZSBMaWNlbnNlLlxuICogWW91IG1heSBvYnRhaW4gYSBjb3B5IG9mIHRoZSBMaWNlbnNlIGF0XG4gKlxuICogICAgIGh0dHA6Ly93d3cuYXBhY2hlLm9yZy9saWNlbnNlcy9MSUNFTlNFLTIuMFxuICpcbiAqIFVubGVzcyByZXF1aXJlZCBieSBhcHBsaWNhYmxlIGxhdyBvciBhZ3JlZWQgdG8gaW4gd3JpdGluZywgc29mdHdhcmVcbiAqIGRpc3RyaWJ1dGVkIHVuZGVyIHRoZSBMaWNlbnNlIGlzIGRpc3RyaWJ1dGVkIG9uIGFuIFwiQVMgSVNcIiBCQVNJUyxcbiAqIFdJVEhPVVQgV0FSUkFOVElFUyBPUiBDT05ESVRJT05TIE9GIEFOWSBLSU5ELCBlaXRoZXIgZXhwcmVzcyBvciBpbXBsaWVkLlxuICogU2VlIHRoZSBMaWNlbnNlIGZvciB0aGUgc3BlY2lmaWMgbGFuZ3VhZ2UgZ292ZXJuaW5nIHBlcm1pc3Npb25zIGFuZFxuICogbGltaXRhdGlvbnMgdW5kZXIgdGhlIExpY2Vuc2UuXG4gKi9cblxuaW1wb3J0IHN0eWxlZCBmcm9tIFwiQGVtb3Rpb24vc3R5bGVkXCJcblxuZXhwb3J0IGNvbnN0IFN0eWxlZFN0YWNrVHJhY2UgPSBzdHlsZWQucHJlKCh7IHRoZW1lIH0pID0+ICh7XG4gIHdoaXRlU3BhY2U6IFwicHJlLXdyYXBcIixcbiAgd29yZFdyYXA6IFwiYnJlYWstd29yZFwiLFxuICBjb2xvcjogXCJpbmhlcml0XCIsXG4gIGZvbnRTaXplOiB0aGVtZS5mb250U2l6ZXMuY29kZUZvbnRTaXplLFxuICBmb250RmFtaWx5OiB0aGVtZS5nZW5lcmljRm9udHMuY29kZUZvbnQsXG4gIGZvbnRXZWlnaHQ6IHRoZW1lLmZvbnRXZWlnaHRzLmNvZGUsXG4gIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLnRyYW5zcGFyZW50LFxuICBvdmVyZmxvd1g6IFwiYXV0b1wiLFxuICBtYXJnaW46IDAsXG4gIGJvcmRlclJhZGl1czogdGhlbWUucmFkaWkuZGVmYXVsdCxcbiAgcGFkZGluZzogdGhlbWUuc3BhY2luZy5sZyxcbiAgYm9yZGVyOiBgJHt0aGVtZS5zaXplcy5ib3JkZXJXaWR0aH0gc29saWQgJHt0aGVtZS5jb2xvcnMuYm9yZGVyQ29sb3J9YCxcbn0pKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkRXJyb3JOYW1lID0gc3R5bGVkLnN0cm9uZygoeyB0aGVtZSB9KSA9PiAoe1xuICBmb250V2VpZ2h0OiB0aGVtZS5mb250V2VpZ2h0cy5jb2RlQm9sZCxcbn0pKVxuIl19 */");
function ErrorElement(o) {
  const {
    name: E,
    message: A,
    stack: g,
    width: e
  } = o, t = g ? g.split(`
`) : [];
  t.shift();
  const c = t.map((n) => n.trim()).join(`
`);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(AlertContainer, { kind: Kind.ERROR, width: e, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledErrorName, { children: [
      E,
      ": "
    ] }),
    A,
    g ? /* @__PURE__ */ jsxRuntimeExports.jsx(StyledStackTrace, { "data-testid": "stErrorElementStack", children: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledCode, { wrapLines: !1, children: c }) }) : null
  ] });
}
const LOG$c = loglevelExports$1.getLogger("ErrorBoundary"), tI = class tI extends PureComponent {
  constructor() {
    super(...arguments), this.state = {
      error: null
    }, this.componentDidCatch = (E) => {
      LOG$c.error(`${E.name}: ${E.message}
${E.stack}`);
    };
  }
  render() {
    const {
      error: E
    } = this.state;
    return E ? E.name === "ChunkLoadError" ? /* @__PURE__ */ jsxRuntimeExports.jsx(ErrorElement, { width: this.props.width, name: "Network issue", message: /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { children: [
      "Cannot load Streamlit frontend code. This can happen when you update Streamlit while a Streamlit app is running.",
      /* @__PURE__ */ jsxRuntimeExports.jsx("br", {}),
      "To fix this, simply reload this app by pressing",
      " ",
      /* @__PURE__ */ jsxRuntimeExports.jsx(StyledInlineCode, { children: "F5" }),
      ",",
      " ",
      /* @__PURE__ */ jsxRuntimeExports.jsx(StyledInlineCode, { children: "Ctrl+R" }),
      ", or",
      " ",
      /* @__PURE__ */ jsxRuntimeExports.jsx(StyledInlineCode, { children: "Cmd+R" }),
      ".",
      /* @__PURE__ */ jsxRuntimeExports.jsx("br", {}),
      "If the error persists, try force-clearing your browser's cache as described",
      " ",
      /* @__PURE__ */ jsxRuntimeExports.jsx("a", { href: "https://en.wikipedia.org/wiki/Wikipedia:Bypass_your_cache#Cache_clearing_and_disabling", rel: "noopener noreferrer", target: "_blank", children: "here" })
    ] }) }) : /* @__PURE__ */ jsxRuntimeExports.jsx(ErrorElement, { width: this.props.width, name: E.name, message: E.message, stack: E.stack }) : this.props.children;
  }
};
tI.getDerivedStateFromError = (E) => ({
  error: E
});
let ErrorBoundary = tI;
const StyledTooltipIconWrapper = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "ewgb6652"
} : {
  target: "ewgb6652",
  label: "StyledTooltipIconWrapper"
})(({
  isLatex: o,
  theme: E
}) => ({
  display: "flex",
  alignItems: "center",
  marginTop: o ? E.spacing.md : "0",
  "& .stTooltipHoverTarget > svg": {
    stroke: E.colors.fadedText60,
    strokeWidth: 2.25
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledLabelHelpWrapper = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "ewgb6651"
} : {
  target: "ewgb6651",
  label: "StyledLabelHelpWrapper"
})(({
  isLatex: o
}) => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  visibility: "visible",
  // For LaTeX, use fit-content to keep icon close, but constrain with maxWidth
  // so long formulas can scroll. Center using margin-inline: auto
  width: o ? "fit-content" : "100%",
  ...o ? {
    maxWidth: "100%",
    marginInline: "auto"
  } : {}
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledLabelHelpInline = /* @__PURE__ */ createStyled("label", process.env.NODE_ENV === "production" ? {
  target: "ewgb6650"
} : {
  target: "ewgb6650",
  label: "StyledLabelHelpInline"
})(({
  theme: o
}) => ({
  marginLeft: o.spacing.xs,
  position: "relative",
  display: "flex",
  flexDirection: "row"
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
var PLACEMENT = {
  auto: "auto",
  topLeft: "topLeft",
  top: "top",
  topRight: "topRight",
  rightTop: "rightTop",
  right: "right",
  rightBottom: "rightBottom",
  bottomRight: "bottomRight",
  bottom: "bottom",
  bottomLeft: "bottomLeft",
  leftBottom: "leftBottom",
  left: "left",
  leftTop: "leftTop"
}, TRIGGER_TYPE = {
  click: "click",
  hover: "hover"
}, STATE_CHANGE_TYPE$1 = {
  open: "open",
  close: "close"
}, ACCESSIBILITY_TYPE = {
  none: "none",
  menu: "menu",
  tooltip: "tooltip"
}, POPOVER_MARGIN = 8, ARROW_SIZE = 6, ANIMATE_OUT_TIME = 0, ANIMATE_IN_TIME = 20, ARROW_WIDTH = Math.ceil(Math.sqrt(Math.pow(ARROW_SIZE * 2, 2) / 2));
function _typeof$b(o) {
  "@babel/helpers - typeof";
  return _typeof$b = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(E) {
    return typeof E;
  } : function(E) {
    return E && typeof Symbol == "function" && E.constructor === Symbol && E !== Symbol.prototype ? "symbol" : typeof E;
  }, _typeof$b(o);
}
function ownKeys$l(o, E) {
  var A = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var g = Object.getOwnPropertySymbols(o);
    E && (g = g.filter(function(e) {
      return Object.getOwnPropertyDescriptor(o, e).enumerable;
    })), A.push.apply(A, g);
  }
  return A;
}
function _objectSpread$j(o) {
  for (var E = 1; E < arguments.length; E++) {
    var A = arguments[E] != null ? arguments[E] : {};
    E % 2 ? ownKeys$l(Object(A), !0).forEach(function(g) {
      _defineProperty$m(o, g, A[g]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(A)) : ownKeys$l(Object(A)).forEach(function(g) {
      Object.defineProperty(o, g, Object.getOwnPropertyDescriptor(A, g));
    });
  }
  return o;
}
function _classCallCheck$9(o, E) {
  if (!(o instanceof E))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$9(o, E) {
  for (var A = 0; A < E.length; A++) {
    var g = E[A];
    g.enumerable = g.enumerable || !1, g.configurable = !0, "value" in g && (g.writable = !0), Object.defineProperty(o, g.key, g);
  }
}
function _createClass$9(o, E, A) {
  return E && _defineProperties$9(o.prototype, E), Object.defineProperty(o, "prototype", { writable: !1 }), o;
}
function _inherits$9(o, E) {
  if (typeof E != "function" && E !== null)
    throw new TypeError("Super expression must either be null or a function");
  o.prototype = Object.create(E && E.prototype, { constructor: { value: o, writable: !0, configurable: !0 } }), Object.defineProperty(o, "prototype", { writable: !1 }), E && _setPrototypeOf$9(o, E);
}
function _setPrototypeOf$9(o, E) {
  return _setPrototypeOf$9 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(g, e) {
    return g.__proto__ = e, g;
  }, _setPrototypeOf$9(o, E);
}
function _createSuper$9(o) {
  var E = _isNativeReflectConstruct$9();
  return function() {
    var g = _getPrototypeOf$9(o), e;
    if (E) {
      var t = _getPrototypeOf$9(this).constructor;
      e = Reflect.construct(g, arguments, t);
    } else
      e = g.apply(this, arguments);
    return _possibleConstructorReturn$9(this, e);
  };
}
function _possibleConstructorReturn$9(o, E) {
  if (E && (_typeof$b(E) === "object" || typeof E == "function"))
    return E;
  if (E !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$a(o);
}
function _assertThisInitialized$a(o) {
  if (o === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return o;
}
function _isNativeReflectConstruct$9() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function _getPrototypeOf$9(o) {
  return _getPrototypeOf$9 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(A) {
    return A.__proto__ || Object.getPrototypeOf(A);
  }, _getPrototypeOf$9(o);
}
function _defineProperty$m(o, E, A) {
  return E in o ? Object.defineProperty(o, E, { value: A, enumerable: !0, configurable: !0, writable: !0 }) : o[E] = A, o;
}
var defaultStateReducer = function o(E, A) {
  return A;
}, StatefulContainer$1 = /* @__PURE__ */ (function(o) {
  _inherits$9(A, o);
  var E = _createSuper$9(A);
  function A() {
    var g;
    _classCallCheck$9(this, A);
    for (var e = arguments.length, t = new Array(e), c = 0; c < e; c++)
      t[c] = arguments[c];
    return g = E.call.apply(E, [this].concat(t)), _defineProperty$m(_assertThisInitialized$a(g), "state", _objectSpread$j({
      isOpen: !1
    }, g.props.initialState)), _defineProperty$m(_assertThisInitialized$a(g), "onBlur", function(n) {
      g.props.onBlur && g.props.onBlur(n), !(g.props.focusLock || g.props.autoFocus) && g.close();
    }), _defineProperty$m(_assertThisInitialized$a(g), "onClick", function(n) {
      g.props.onClick && g.props.onClick(n), g.state.isOpen ? g.close() : g.open();
    }), _defineProperty$m(_assertThisInitialized$a(g), "onClickOutside", function() {
      g.close();
    }), _defineProperty$m(_assertThisInitialized$a(g), "onEsc", function() {
      g.close();
    }), _defineProperty$m(_assertThisInitialized$a(g), "onFocus", function(n) {
      g.props.onFocus && g.props.onFocus(n), isFocusVisible(n) && g.open();
    }), _defineProperty$m(_assertThisInitialized$a(g), "onMouseEnter", function(n) {
      g.props.onMouseEnter && g.props.onMouseEnter(n), g.open();
    }), _defineProperty$m(_assertThisInitialized$a(g), "onMouseLeave", function(n) {
      g.props.onMouseLeave && g.props.onMouseLeave(n), g.close();
    }), _defineProperty$m(_assertThisInitialized$a(g), "onContentClose", function() {
      g.close();
    }), _defineProperty$m(_assertThisInitialized$a(g), "renderContent", function() {
      var n = g.props.content;
      return typeof n == "function" ? n({
        close: g.onContentClose
      }) : n;
    }), g;
  }
  return _createClass$9(A, [{
    key: "open",
    value: function() {
      this.internalSetState(STATE_CHANGE_TYPE$1.open, {
        isOpen: !0
      }), this.props.onOpen && this.props.onOpen();
    }
  }, {
    key: "close",
    value: function() {
      this.internalSetState(STATE_CHANGE_TYPE$1.close, {
        isOpen: !1
      }), this.props.onClose && this.props.onClose();
    }
  }, {
    key: "internalSetState",
    value: function(e, t) {
      var c = this.props.stateReducer;
      if (typeof c != "function") {
        this.setState(t);
        return;
      }
      this.setState(function(n) {
        return c(e, t, n);
      });
    }
    /**
     * If user passed a content render prop, we want to give them a
     * callback to close the Popover. This is useful in any case where
     * a dev wants to manually close the popover based on some action.
     *
     * One simple example is a Popover with a "Dismiss" button in it:
     * <StatefulPopover content={({close}) => <button onClick={close}>Dismiss</button>}>
     *  Click me
     * </StatefulPopover>
     */
  }, {
    key: "render",
    value: function() {
      var e = this.props, t = e.accessibilityType, c = e.autoFocus, n = e.animateOutTime, h = e.dismissOnClickOutside, d = e.dismissOnEsc, k = e.focusLock, p = e.ignoreBoundary, M = e.mountNode, S = e.onBlur, AA = e.onClick, H = e.onFocus, gA = e.onMouseEnter, CA = e.onMouseLeave, IA = e.onMouseEnterDelay, BA = e.onMouseLeaveDelay, QA = e.overrides, EA = e.placement, oA = e.popperOptions, iA = e.renderAll, aA = e.returnFocus, tA = e.showArrow, eA = e.triggerType, cA = e.popoverMargin, DA = e.focusOptions, nA = {
        accessibilityType: t,
        animateOutTime: n,
        autoFocus: c,
        content: this.renderContent,
        focusLock: k,
        ignoreBoundary: p,
        isOpen: this.state.isOpen,
        mountNode: M,
        onBlur: S,
        onClick: AA,
        onFocus: H,
        onMouseEnter: gA,
        onMouseLeave: CA,
        onMouseEnterDelay: IA,
        onMouseLeaveDelay: BA,
        overrides: QA,
        placement: EA,
        popperOptions: oA,
        renderAll: iA,
        returnFocus: aA,
        showArrow: tA,
        triggerType: eA,
        popoverMargin: cA,
        focusOptions: DA
      };
      return h && (nA.onClickOutside = this.onClickOutside), d && (nA.onEsc = this.onEsc), eA === TRIGGER_TYPE.hover ? (nA.onBlur = this.onBlur, nA.onFocus = this.onFocus, nA.onMouseEnter = this.onMouseEnter, nA.onMouseLeave = this.onMouseLeave) : nA.onClick = this.onClick, this.props.children(nA);
    }
  }]), A;
})(React.Component);
_defineProperty$m(StatefulContainer$1, "defaultProps", {
  accessibilityType: ACCESSIBILITY_TYPE.menu,
  ignoreBoundary: !1,
  overrides: {},
  onMouseEnterDelay: 200,
  onMouseLeaveDelay: 200,
  placement: PLACEMENT.auto,
  popperOptions: {},
  showArrow: !1,
  triggerType: TRIGGER_TYPE.click,
  dismissOnClickOutside: !0,
  dismissOnEsc: !0,
  stateReducer: defaultStateReducer,
  popoverMargin: POPOVER_MARGIN
});
function ownKeys$k(o, E) {
  var A = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var g = Object.getOwnPropertySymbols(o);
    E && (g = g.filter(function(e) {
      return Object.getOwnPropertyDescriptor(o, e).enumerable;
    })), A.push.apply(A, g);
  }
  return A;
}
function _objectSpread$i(o) {
  for (var E = 1; E < arguments.length; E++) {
    var A = arguments[E] != null ? arguments[E] : {};
    E % 2 ? ownKeys$k(Object(A), !0).forEach(function(g) {
      _defineProperty$l(o, g, A[g]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(A)) : ownKeys$k(Object(A)).forEach(function(g) {
      Object.defineProperty(o, g, Object.getOwnPropertyDescriptor(A, g));
    });
  }
  return o;
}
function _defineProperty$l(o, E, A) {
  return E in o ? Object.defineProperty(o, E, { value: A, enumerable: !0, configurable: !0, writable: !0 }) : o[E] = A, o;
}
function _slicedToArray$g(o, E) {
  return _arrayWithHoles$f(o) || _iterableToArrayLimit$f(o, E) || _unsupportedIterableToArray$f(o, E) || _nonIterableRest$f();
}
function _nonIterableRest$f() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$f(o, E) {
  if (o) {
    if (typeof o == "string") return _arrayLikeToArray$f(o, E);
    var A = Object.prototype.toString.call(o).slice(8, -1);
    if (A === "Object" && o.constructor && (A = o.constructor.name), A === "Map" || A === "Set") return Array.from(o);
    if (A === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(A)) return _arrayLikeToArray$f(o, E);
  }
}
function _arrayLikeToArray$f(o, E) {
  (E == null || E > o.length) && (E = o.length);
  for (var A = 0, g = new Array(E); A < E; A++)
    g[A] = o[A];
  return g;
}
function _iterableToArrayLimit$f(o, E) {
  var A = o == null ? null : typeof Symbol < "u" && o[Symbol.iterator] || o["@@iterator"];
  if (A != null) {
    var g = [], e = !0, t = !1, c, n;
    try {
      for (A = A.call(o); !(e = (c = A.next()).done) && (g.push(c.value), !(E && g.length === E)); e = !0)
        ;
    } catch (h) {
      t = !0, n = h;
    } finally {
      try {
        !e && A.return != null && A.return();
      } finally {
        if (t) throw n;
      }
    }
    return g;
  }
}
function _arrayWithHoles$f(o) {
  if (Array.isArray(o)) return o;
}
var OPPOSITE_POSITIONS = {
  top: "bottom",
  bottom: "top",
  right: "left",
  left: "right"
};
function getOppositePosition(o) {
  return OPPOSITE_POSITIONS[o];
}
function isVerticalPosition(o) {
  return o === "top" || o === "bottom";
}
function capitalize(o) {
  return o.charAt(0).toUpperCase() + o.slice(1);
}
function fromPopperPlacement(o) {
  var E = o.replace(/(top|bottom)-start$/, "$1Left").replace(/(top|bottom)-end$/, "$1Right").replace(/(left|right)-start$/, "$1Top").replace(/(left|right)-end$/, "$1Bottom");
  return PLACEMENT[E] || null;
}
function splitPlacement(o) {
  var E = o.match(/^([a-z]+)([A-Z][a-z]+)?/) || [];
  return E.slice(1, 3).filter(Boolean).map(function(A) {
    return A.toLowerCase();
  });
}
function getPopoverMarginStyles(o, E, A) {
  var g = splitPlacement(E), e = _slicedToArray$g(g, 1), t = e[0], c = getOppositePosition(t);
  if (!c)
    return null;
  var n = "margin".concat(capitalize(c));
  return _defineProperty$l({}, n, "".concat(o + A, "px"));
}
function getStartPosition(o, E, A, g) {
  o = _objectSpread$i({}, o);
  var e = splitPlacement(E), t = _slicedToArray$g(e, 1), c = t[0], n = (A > 0 ? A : g) * 2;
  return isVerticalPosition(c) ? o.top += c === "top" ? n : -n : o.left += c === "left" ? n : -n, "translate3d(".concat(o.left, "px, ").concat(o.top, "px, 0)");
}
function getEndPosition(o) {
  return "translate3d(".concat(o.left, "px, ").concat(o.top, "px, 0)");
}
function getArrowPositionStyles(o, E) {
  var A, g = splitPlacement(E), e = _slicedToArray$g(g, 1), t = e[0], c = getOppositePosition(t);
  if (!c)
    return null;
  var n = isVerticalPosition(t) ? "left" : "top";
  return A = {}, _defineProperty$l(A, n, "".concat(o[n], "px")), _defineProperty$l(A, c, "-".concat(ARROW_SIZE - 2, "px")), A;
}
function ownKeys$j(o, E) {
  var A = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var g = Object.getOwnPropertySymbols(o);
    E && (g = g.filter(function(e) {
      return Object.getOwnPropertyDescriptor(o, e).enumerable;
    })), A.push.apply(A, g);
  }
  return A;
}
function _objectSpread$h(o) {
  for (var E = 1; E < arguments.length; E++) {
    var A = arguments[E] != null ? arguments[E] : {};
    E % 2 ? ownKeys$j(Object(A), !0).forEach(function(g) {
      _defineProperty$k(o, g, A[g]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(A)) : ownKeys$j(Object(A)).forEach(function(g) {
      Object.defineProperty(o, g, Object.getOwnPropertyDescriptor(A, g));
    });
  }
  return o;
}
function _defineProperty$k(o, E, A) {
  return E in o ? Object.defineProperty(o, E, { value: A, enumerable: !0, configurable: !0, writable: !0 }) : o[E] = A, o;
}
function getBodyStyles(o) {
  var E = o.$animationDuration, A = o.$isOpen, g = o.$isAnimating, e = o.$placement, t = o.$popoverOffset, c = o.$showArrow, n = o.$theme, h = o.$popoverMargin, d = o.$isHoverTrigger;
  return _objectSpread$h(_objectSpread$h({
    position: "absolute",
    top: 0,
    left: 0,
    backgroundColor: n.colors.backgroundTertiary,
    borderTopLeftRadius: n.borders.popoverBorderRadius,
    borderTopRightRadius: n.borders.popoverBorderRadius,
    borderBottomRightRadius: n.borders.popoverBorderRadius,
    borderBottomLeftRadius: n.borders.popoverBorderRadius,
    boxShadow: n.lighting.shadow600,
    transitionProperty: "opacity,transform",
    transitionDuration: g ? A ? "0.1s" : "".concat(E, "ms") : "0s",
    transitionTimingFunction: A ? n.animation.easeOutCurve : n.animation.easeInCurve,
    opacity: g && A ? 1 : 0,
    transform: g && A ? getEndPosition(t) : getStartPosition(t, e, c ? ARROW_SIZE : 0, h)
  }, getPopoverMarginStyles(c ? ARROW_SIZE : 0, e, h)), d ? {
    animationDuration: ".1s",
    animationName: {
      "0%": {
        pointerEvents: "none"
      },
      "99%": {
        pointerEvents: "none"
      },
      "100%": {
        pointerEvents: "auto"
      }
    }
  } : {});
}
var Body$2 = styled("div", getBodyStyles);
Body$2.displayName = "Body";
Body$2.displayName = "Body";
function getArrowStyles(o) {
  var E = o.$arrowOffset, A = o.$placement, g = o.$theme;
  return _objectSpread$h({
    backgroundColor: g.colors.backgroundTertiary,
    boxShadow: g.lighting.shadow600,
    width: "".concat(ARROW_WIDTH, "px"),
    height: "".concat(ARROW_WIDTH, "px"),
    transform: "rotate(45deg)",
    position: "absolute"
  }, getArrowPositionStyles(E, A));
}
var Arrow$1 = styled("div", getArrowStyles);
Arrow$1.displayName = "Arrow";
Arrow$1.displayName = "Arrow";
function getInnerStyles(o) {
  var E = o.$theme;
  return {
    backgroundColor: E.colors.backgroundTertiary,
    borderTopLeftRadius: E.borders.popoverBorderRadius,
    borderTopRightRadius: E.borders.popoverBorderRadius,
    borderBottomRightRadius: E.borders.popoverBorderRadius,
    borderBottomLeftRadius: E.borders.popoverBorderRadius,
    color: E.colors.contentPrimary,
    position: "relative"
  };
}
var Inner$1 = styled("div", getInnerStyles);
Inner$1.displayName = "Inner";
Inner$1.displayName = "Inner";
var Padding = styled("div", {
  paddingLeft: "12px",
  paddingTop: "12px",
  paddingRight: "12px",
  paddingBottom: "12px"
});
Padding.displayName = "Padding";
Padding.displayName = "Padding";
var Hidden = styled("div", {
  display: "none"
});
Hidden.displayName = "Hidden";
Hidden.displayName = "Hidden";
var baseDefaultProps$1 = {
  accessibilityType: ACCESSIBILITY_TYPE.menu,
  focusLock: !1,
  autoFocus: !0,
  returnFocus: !0,
  // Remove the `ignoreBoundary` prop in the next major version
  // and have it replaced with the TetherBehavior props overrides
  ignoreBoundary: !1,
  overrides: {},
  onMouseEnterDelay: 200,
  onMouseLeaveDelay: 200,
  placement: PLACEMENT.auto,
  showArrow: !1,
  triggerType: TRIGGER_TYPE.click,
  renderAll: !1
};
function ownKeys$i(o, E) {
  var A = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var g = Object.getOwnPropertySymbols(o);
    E && (g = g.filter(function(e) {
      return Object.getOwnPropertyDescriptor(o, e).enumerable;
    })), A.push.apply(A, g);
  }
  return A;
}
function _objectSpread$g(o) {
  for (var E = 1; E < arguments.length; E++) {
    var A = arguments[E] != null ? arguments[E] : {};
    E % 2 ? ownKeys$i(Object(A), !0).forEach(function(g) {
      _defineProperty$j(o, g, A[g]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(A)) : ownKeys$i(Object(A)).forEach(function(g) {
      Object.defineProperty(o, g, Object.getOwnPropertyDescriptor(A, g));
    });
  }
  return o;
}
function _extends$l() {
  return _extends$l = Object.assign ? Object.assign.bind() : function(o) {
    for (var E = 1; E < arguments.length; E++) {
      var A = arguments[E];
      for (var g in A)
        Object.prototype.hasOwnProperty.call(A, g) && (o[g] = A[g]);
    }
    return o;
  }, _extends$l.apply(this, arguments);
}
function _typeof$a(o) {
  "@babel/helpers - typeof";
  return _typeof$a = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(E) {
    return typeof E;
  } : function(E) {
    return E && typeof Symbol == "function" && E.constructor === Symbol && E !== Symbol.prototype ? "symbol" : typeof E;
  }, _typeof$a(o);
}
function _classCallCheck$8(o, E) {
  if (!(o instanceof E))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$8(o, E) {
  for (var A = 0; A < E.length; A++) {
    var g = E[A];
    g.enumerable = g.enumerable || !1, g.configurable = !0, "value" in g && (g.writable = !0), Object.defineProperty(o, g.key, g);
  }
}
function _createClass$8(o, E, A) {
  return E && _defineProperties$8(o.prototype, E), Object.defineProperty(o, "prototype", { writable: !1 }), o;
}
function _inherits$8(o, E) {
  if (typeof E != "function" && E !== null)
    throw new TypeError("Super expression must either be null or a function");
  o.prototype = Object.create(E && E.prototype, { constructor: { value: o, writable: !0, configurable: !0 } }), Object.defineProperty(o, "prototype", { writable: !1 }), E && _setPrototypeOf$8(o, E);
}
function _setPrototypeOf$8(o, E) {
  return _setPrototypeOf$8 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(g, e) {
    return g.__proto__ = e, g;
  }, _setPrototypeOf$8(o, E);
}
function _createSuper$8(o) {
  var E = _isNativeReflectConstruct$8();
  return function() {
    var g = _getPrototypeOf$8(o), e;
    if (E) {
      var t = _getPrototypeOf$8(this).constructor;
      e = Reflect.construct(g, arguments, t);
    } else
      e = g.apply(this, arguments);
    return _possibleConstructorReturn$8(this, e);
  };
}
function _possibleConstructorReturn$8(o, E) {
  if (E && (_typeof$a(E) === "object" || typeof E == "function"))
    return E;
  if (E !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$9(o);
}
function _assertThisInitialized$9(o) {
  if (o === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return o;
}
function _isNativeReflectConstruct$8() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function _getPrototypeOf$8(o) {
  return _getPrototypeOf$8 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(A) {
    return A.__proto__ || Object.getPrototypeOf(A);
  }, _getPrototypeOf$8(o);
}
function _defineProperty$j(o, E, A) {
  return E in o ? Object.defineProperty(o, E, { value: A, enumerable: !0, configurable: !0, writable: !0 }) : o[E] = A, o;
}
var PopoverInner = /* @__PURE__ */ (function(o) {
  _inherits$8(A, o);
  var E = _createSuper$8(A);
  function A() {
    var g;
    _classCallCheck$8(this, A);
    for (var e = arguments.length, t = new Array(e), c = 0; c < e; c++)
      t[c] = arguments[c];
    return g = E.call.apply(E, [this].concat(t)), _defineProperty$j(_assertThisInitialized$9(g), "animateInTimer", void 0), _defineProperty$j(_assertThisInitialized$9(g), "animateOutTimer", void 0), _defineProperty$j(_assertThisInitialized$9(g), "animateOutCompleteTimer", void 0), _defineProperty$j(_assertThisInitialized$9(g), "onMouseEnterTimer", void 0), _defineProperty$j(_assertThisInitialized$9(g), "onMouseLeaveTimer", void 0), _defineProperty$j(_assertThisInitialized$9(g), "anchorRef", /* @__PURE__ */ React.createRef()), _defineProperty$j(_assertThisInitialized$9(g), "popperRef", /* @__PURE__ */ React.createRef()), _defineProperty$j(_assertThisInitialized$9(g), "arrowRef", /* @__PURE__ */ React.createRef()), _defineProperty$j(_assertThisInitialized$9(g), "state", g.getDefaultState(g.props)), _defineProperty$j(_assertThisInitialized$9(g), "animateIn", function() {
      g.props.isOpen && g.setState({
        isAnimating: !0
      });
    }), _defineProperty$j(_assertThisInitialized$9(g), "animateOut", function() {
      g.props.isOpen || (g.setState({
        isAnimating: !0
      }), g.animateOutCompleteTimer = setTimeout(function() {
        g.setState({
          isAnimating: !1,
          // Reset to ideal placement specified in props
          placement: g.props.placement
        });
      }, g.props.animateOutTime || ANIMATE_OUT_TIME));
    }), _defineProperty$j(_assertThisInitialized$9(g), "onAnchorClick", function(n) {
      g.props.onClick && g.props.onClick(n);
    }), _defineProperty$j(_assertThisInitialized$9(g), "onAnchorMouseEnter", function(n) {
      g.onMouseLeaveTimer && clearTimeout(g.onMouseLeaveTimer), g.triggerOnMouseEnterWithDelay(n);
    }), _defineProperty$j(_assertThisInitialized$9(g), "onAnchorMouseLeave", function(n) {
      g.onMouseEnterTimer && clearTimeout(g.onMouseEnterTimer), g.triggerOnMouseLeaveWithDelay(n);
    }), _defineProperty$j(_assertThisInitialized$9(g), "onPopoverMouseEnter", function() {
      g.onMouseLeaveTimer && clearTimeout(g.onMouseLeaveTimer);
    }), _defineProperty$j(_assertThisInitialized$9(g), "onPopoverMouseLeave", function(n) {
      g.triggerOnMouseLeaveWithDelay(n);
    }), _defineProperty$j(_assertThisInitialized$9(g), "onPopperUpdate", function(n, h) {
      var d = fromPopperPlacement(h.placement) || PLACEMENT.top;
      return g.setState({
        arrowOffset: n.arrow,
        popoverOffset: n.popper,
        placement: d
      }), g.animateInTimer = setTimeout(g.animateIn, ANIMATE_IN_TIME), h;
    }), _defineProperty$j(_assertThisInitialized$9(g), "triggerOnMouseLeave", function(n) {
      g.props.onMouseLeave && g.props.onMouseLeave(n);
    }), _defineProperty$j(_assertThisInitialized$9(g), "triggerOnMouseEnter", function(n) {
      g.props.onMouseEnter && g.props.onMouseEnter(n);
    }), _defineProperty$j(_assertThisInitialized$9(g), "onDocumentClick", function(n) {
      var h = n.composedPath ? n.composedPath()[0] : n.target, d = g.popperRef.current, k = g.anchorRef.current;
      !d || d === h || h instanceof Node && d.contains(h) || !k || k === h || h instanceof Node && k.contains(h) || g.props.onClickOutside && g.props.onClickOutside(n);
    }), g;
  }
  return _createClass$8(A, [{
    key: "componentDidMount",
    value: function() {
      this.setState({
        isMounted: !0
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function(e, t) {
      this.init(e, t), this.props.accessibilityType !== ACCESSIBILITY_TYPE.tooltip && this.props.autoFocus && !this.state.autoFocusAfterPositioning && this.popperRef.current !== null && this.popperRef.current.getBoundingClientRect().top > 0 && this.setState({
        autoFocusAfterPositioning: !0
      }), process.env.NODE_ENV !== "production" && (this.anchorRef.current || console.warn(`[baseui][Popover] ref has not been passed to the Popper's anchor element.
              See how to pass the ref to an anchor element in the Popover example
              https://baseweb.design/components/popover/#anchor-ref-handling-example`));
    }
  }, {
    key: "init",
    value: function(e, t) {
      if (this.props.isOpen !== e.isOpen || this.state.isMounted !== t.isMounted || this.state.isLayerMounted !== t.isLayerMounted) {
        if (this.props.isOpen && this.state.isLayerMounted) {
          this.clearTimers();
          return;
        }
        if (!this.props.isOpen && e.isOpen) {
          this.animateOutTimer = setTimeout(this.animateOut, 20);
          return;
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.clearTimers();
    }
  }, {
    key: "getDefaultState",
    value: function(e) {
      return {
        isAnimating: !1,
        arrowOffset: {
          left: 0,
          top: 0
        },
        popoverOffset: {
          left: 0,
          top: 0
        },
        placement: e.placement,
        isMounted: !1,
        isLayerMounted: !1,
        autoFocusAfterPositioning: !1
      };
    }
  }, {
    key: "clearTimers",
    value: function() {
      [this.animateInTimer, this.animateOutTimer, this.animateOutCompleteTimer, this.onMouseEnterTimer, this.onMouseLeaveTimer].forEach(function(e) {
        e && clearTimeout(e);
      });
    }
  }, {
    key: "triggerOnMouseLeaveWithDelay",
    value: function(e) {
      var t = this, c = this.props.onMouseLeaveDelay;
      if (c) {
        this.onMouseLeaveTimer = setTimeout(function() {
          return t.triggerOnMouseLeave(e);
        }, c);
        return;
      }
      this.triggerOnMouseLeave(e);
    }
  }, {
    key: "triggerOnMouseEnterWithDelay",
    value: function(e) {
      var t = this, c = this.props.onMouseEnterDelay;
      if (c) {
        this.onMouseEnterTimer = setTimeout(function() {
          return t.triggerOnMouseEnter(e);
        }, c);
        return;
      }
      this.triggerOnMouseEnter(e);
    }
  }, {
    key: "isClickTrigger",
    value: function() {
      return this.props.triggerType === TRIGGER_TYPE.click;
    }
  }, {
    key: "isHoverTrigger",
    value: function() {
      return this.props.triggerType === TRIGGER_TYPE.hover;
    }
  }, {
    key: "isAccessibilityTypeMenu",
    value: function() {
      return this.props.accessibilityType === ACCESSIBILITY_TYPE.menu;
    }
  }, {
    key: "isAccessibilityTypeTooltip",
    value: function() {
      return this.props.accessibilityType === ACCESSIBILITY_TYPE.tooltip;
    }
  }, {
    key: "getAnchorIdAttr",
    value: function() {
      var e = this.getPopoverIdAttr();
      return e ? "".concat(e, "__anchor") : null;
    }
  }, {
    key: "getPopoverIdAttr",
    value: function() {
      return this.props.id || null;
    }
  }, {
    key: "getAnchorProps",
    value: function() {
      var e = this.props.isOpen, t = {
        ref: this.anchorRef
      }, c = this.getPopoverIdAttr();
      if (this.isAccessibilityTypeMenu()) {
        var n = this.isClickTrigger() ? "aria-controls" : "aria-owns";
        t[n] = e ? c : null, t["aria-haspopup"] = !0, t["aria-expanded"] = !!e;
      } else this.isAccessibilityTypeTooltip() && (t.id = this.getAnchorIdAttr(), t["aria-describedby"] = e ? c : null);
      return this.isHoverTrigger() ? (t.onMouseEnter = this.onAnchorMouseEnter, t.onMouseLeave = this.onAnchorMouseLeave, t.onBlur = this.props.onBlur, t.onFocus = this.props.onFocus) : t.onClick = this.onAnchorClick, t;
    }
  }, {
    key: "getPopoverBodyProps",
    value: function() {
      var e = {}, t = this.getPopoverIdAttr();
      return this.isAccessibilityTypeMenu() ? e.id = t : this.isAccessibilityTypeTooltip() && (e.id = t, e.role = "tooltip"), this.isHoverTrigger() && (e.onMouseEnter = this.onPopoverMouseEnter, e.onMouseLeave = this.onPopoverMouseLeave), e;
    }
  }, {
    key: "getSharedProps",
    value: function() {
      var e = this.props, t = e.isOpen, c = e.showArrow, n = e.popoverMargin, h = n === void 0 ? POPOVER_MARGIN : n, d = this.state, k = d.isAnimating, p = d.arrowOffset, M = d.popoverOffset, S = d.placement;
      return {
        $showArrow: !!c,
        $arrowOffset: p,
        $popoverOffset: M,
        $placement: S,
        $isAnimating: k,
        $animationDuration: this.props.animateOutTime || ANIMATE_OUT_TIME,
        $isOpen: t,
        $popoverMargin: h,
        $isHoverTrigger: this.isHoverTrigger()
      };
    }
  }, {
    key: "getAnchorFromChildren",
    value: function() {
      var e = this.props.children, t = React.Children.toArray(e);
      return t.length !== 1 && console.error("[baseui] Exactly 1 child must be passed to Popover/Tooltip, found ".concat(t.length, " children")), t[0];
    }
  }, {
    key: "renderAnchor",
    value: function() {
      var e = this.getAnchorFromChildren();
      if (!e)
        return null;
      var t = /* @__PURE__ */ React.isValidElement(e), c = this.getAnchorProps();
      return _typeof$a(e) === "object" && t ? /* @__PURE__ */ React.cloneElement(e, c) : /* @__PURE__ */ React.createElement("span", _extends$l({
        key: "popover-anchor"
      }, c), e);
    }
  }, {
    key: "renderPopover",
    value: function(e) {
      var t = this.props, c = t.showArrow, n = t.overrides, h = n === void 0 ? {} : n, d = h.Arrow, k = h.Body, p = h.Inner, M = getOverride(d) || Arrow$1, S = getOverride(k) || Body$2, AA = getOverride(p) || Inner$1, H = this.getSharedProps(), gA = this.getPopoverBodyProps();
      return /* @__PURE__ */ React.createElement(S, _extends$l({
        key: "popover-body",
        ref: this.popperRef,
        "data-baseweb": this.props["data-baseweb"] || "popover"
      }, gA, H, getOverrideProps(k)), c ? /* @__PURE__ */ React.createElement(M, _extends$l({
        key: "popover-arrow",
        ref: this.arrowRef
      }, H, getOverrideProps(d))) : null, /* @__PURE__ */ React.createElement(AA, _extends$l({}, H, getOverrideProps(p)), e));
    }
  }, {
    key: "renderContent",
    value: function() {
      var e = this.props.content;
      return typeof e == "function" ? e() : e;
    }
  }, {
    key: "render",
    value: function() {
      var e = this, t = this.state.isMounted && (this.props.isOpen || this.state.isAnimating), c = [this.renderAnchor()], n = t || this.props.renderAll ? this.renderContent() : null, h = {
        modifiers: {
          preventOverflow: {
            enabled: !this.props.ignoreBoundary,
            padding: 0
          }
        }
      };
      return n && (t ? c.push(/* @__PURE__ */ React.createElement(Layer, {
        key: "new-layer",
        mountNode: this.props.mountNode,
        onEscape: this.props.onEsc,
        onDocumentClick: this.isHoverTrigger() ? void 0 : this.onDocumentClick,
        isHoverLayer: this.isHoverTrigger(),
        onMount: function() {
          return e.setState({
            isLayerMounted: !0
          });
        },
        onUnmount: function() {
          return e.setState({
            isLayerMounted: !1
          });
        }
      }, /* @__PURE__ */ React.createElement(Tether, {
        anchorRef: this.anchorRef.current,
        arrowRef: this.arrowRef.current,
        popperRef: this.popperRef.current,
        popperOptions: _objectSpread$g(_objectSpread$g({}, h), this.props.popperOptions),
        onPopperUpdate: this.onPopperUpdate,
        placement: this.state.placement
      }, this.props.focusLock && this.props.accessibilityType !== ACCESSIBILITY_TYPE.tooltip ? /* @__PURE__ */ React.createElement(FocusLockCombination, {
        disabled: !this.props.focusLock,
        noFocusGuards: !1,
        returnFocus: !this.isHoverTrigger() && this.props.returnFocus,
        autoFocus: this.state.autoFocusAfterPositioning,
        crossFrame: !1,
        focusOptions: this.props.focusOptions
      }, this.renderPopover(n)) : /* @__PURE__ */ React.createElement(MoveFocusInside, {
        disabled: !this.props.autoFocus || !this.state.autoFocusAfterPositioning
      }, this.renderPopover(n))))) : c.push(/* @__PURE__ */ React.createElement(Hidden, {
        key: "hidden-layer"
      }, n))), c;
    }
  }]), A;
})(React.Component);
_defineProperty$j(PopoverInner, "defaultProps", baseDefaultProps$1);
var Popover$2 = function o(E) {
  var A = E.innerRef, g = useUID();
  return /* @__PURE__ */ React.createElement(PopoverInner, _extends$l({
    id: E.id || g,
    ref: A
  }, E));
};
Popover$2.defaultProps = baseDefaultProps$1;
var _excluded$l = ["children"];
function _objectWithoutProperties$j(o, E) {
  if (o == null) return {};
  var A = _objectWithoutPropertiesLoose$i(o, E), g, e;
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    for (e = 0; e < t.length; e++)
      g = t[e], !(E.indexOf(g) >= 0) && Object.prototype.propertyIsEnumerable.call(o, g) && (A[g] = o[g]);
  }
  return A;
}
function _objectWithoutPropertiesLoose$i(o, E) {
  if (o == null) return {};
  var A = {}, g = Object.keys(o), e, t;
  for (t = 0; t < g.length; t++)
    e = g[t], !(E.indexOf(e) >= 0) && (A[e] = o[e]);
  return A;
}
function StatefulPopover(o) {
  var E = o.children, A = _objectWithoutProperties$j(o, _excluded$l);
  return /* @__PURE__ */ React.createElement(StatefulContainer$1, A, function(g) {
    return /* @__PURE__ */ React.createElement(Popover$2, g, E);
  });
}
StatefulPopover.defaultProps = {
  accessibilityType: ACCESSIBILITY_TYPE.menu,
  ignoreBoundary: !1,
  overrides: {},
  onMouseEnterDelay: 200,
  onMouseLeaveDelay: 200,
  placement: PLACEMENT.auto,
  showArrow: !1,
  triggerType: TRIGGER_TYPE.click,
  dismissOnClickOutside: !0,
  dismissOnEsc: !0,
  stateReducer: function o(E, A) {
    return A;
  },
  popoverMargin: POPOVER_MARGIN
};
var baseDefaultProps = {
  accessibilityType: ACCESSIBILITY_TYPE.tooltip,
  focusLock: !1,
  autoFocus: !1,
  returnFocus: !1,
  onMouseEnterDelay: 200,
  onMouseLeaveDelay: 200,
  overrides: {},
  placement: PLACEMENT.auto,
  popoverMargin: 0,
  showArrow: !1,
  triggerType: TRIGGER_TYPE.hover,
  renderAll: !1
};
function _typeof$9(o) {
  "@babel/helpers - typeof";
  return _typeof$9 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(E) {
    return typeof E;
  } : function(E) {
    return E && typeof Symbol == "function" && E.constructor === Symbol && E !== Symbol.prototype ? "symbol" : typeof E;
  }, _typeof$9(o);
}
function ownKeys$h(o, E) {
  var A = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var g = Object.getOwnPropertySymbols(o);
    E && (g = g.filter(function(e) {
      return Object.getOwnPropertyDescriptor(o, e).enumerable;
    })), A.push.apply(A, g);
  }
  return A;
}
function _objectSpread$f(o) {
  for (var E = 1; E < arguments.length; E++) {
    var A = arguments[E] != null ? arguments[E] : {};
    E % 2 ? ownKeys$h(Object(A), !0).forEach(function(g) {
      _defineProperty$i(o, g, A[g]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(A)) : ownKeys$h(Object(A)).forEach(function(g) {
      Object.defineProperty(o, g, Object.getOwnPropertyDescriptor(A, g));
    });
  }
  return o;
}
function _classCallCheck$7(o, E) {
  if (!(o instanceof E))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$7(o, E) {
  for (var A = 0; A < E.length; A++) {
    var g = E[A];
    g.enumerable = g.enumerable || !1, g.configurable = !0, "value" in g && (g.writable = !0), Object.defineProperty(o, g.key, g);
  }
}
function _createClass$7(o, E, A) {
  return E && _defineProperties$7(o.prototype, E), Object.defineProperty(o, "prototype", { writable: !1 }), o;
}
function _inherits$7(o, E) {
  if (typeof E != "function" && E !== null)
    throw new TypeError("Super expression must either be null or a function");
  o.prototype = Object.create(E && E.prototype, { constructor: { value: o, writable: !0, configurable: !0 } }), Object.defineProperty(o, "prototype", { writable: !1 }), E && _setPrototypeOf$7(o, E);
}
function _setPrototypeOf$7(o, E) {
  return _setPrototypeOf$7 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(g, e) {
    return g.__proto__ = e, g;
  }, _setPrototypeOf$7(o, E);
}
function _createSuper$7(o) {
  var E = _isNativeReflectConstruct$7();
  return function() {
    var g = _getPrototypeOf$7(o), e;
    if (E) {
      var t = _getPrototypeOf$7(this).constructor;
      e = Reflect.construct(g, arguments, t);
    } else
      e = g.apply(this, arguments);
    return _possibleConstructorReturn$7(this, e);
  };
}
function _possibleConstructorReturn$7(o, E) {
  if (E && (_typeof$9(E) === "object" || typeof E == "function"))
    return E;
  if (E !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$8(o);
}
function _assertThisInitialized$8(o) {
  if (o === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return o;
}
function _isNativeReflectConstruct$7() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function _getPrototypeOf$7(o) {
  return _getPrototypeOf$7 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(A) {
    return A.__proto__ || Object.getPrototypeOf(A);
  }, _getPrototypeOf$7(o);
}
function _defineProperty$i(o, E, A) {
  return E in o ? Object.defineProperty(o, E, { value: A, enumerable: !0, configurable: !0, writable: !0 }) : o[E] = A, o;
}
var StatefulContainer = /* @__PURE__ */ (function(o) {
  _inherits$7(A, o);
  var E = _createSuper$7(A);
  function A() {
    return _classCallCheck$7(this, A), E.apply(this, arguments);
  }
  return _createClass$7(A, [{
    key: "render",
    value: function() {
      return /* @__PURE__ */ React.createElement(StatefulContainer$1, this.props);
    }
  }]), A;
})(React.Component);
_defineProperty$i(StatefulContainer, "defaultProps", _objectSpread$f({}, baseDefaultProps));
function ownKeys$g(o, E) {
  var A = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var g = Object.getOwnPropertySymbols(o);
    E && (g = g.filter(function(e) {
      return Object.getOwnPropertyDescriptor(o, e).enumerable;
    })), A.push.apply(A, g);
  }
  return A;
}
function _objectSpread$e(o) {
  for (var E = 1; E < arguments.length; E++) {
    var A = arguments[E] != null ? arguments[E] : {};
    E % 2 ? ownKeys$g(Object(A), !0).forEach(function(g) {
      _defineProperty$h(o, g, A[g]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(A)) : ownKeys$g(Object(A)).forEach(function(g) {
      Object.defineProperty(o, g, Object.getOwnPropertyDescriptor(A, g));
    });
  }
  return o;
}
function _defineProperty$h(o, E, A) {
  return E in o ? Object.defineProperty(o, E, { value: A, enumerable: !0, configurable: !0, writable: !0 }) : o[E] = A, o;
}
var Body$1 = styled("div", function(o) {
  return _objectSpread$e(_objectSpread$e({}, getBodyStyles(o)), {}, {
    backgroundColor: o.$theme.colors.tooltipBackground,
    borderTopLeftRadius: o.$theme.borders.radius300,
    borderTopRightRadius: o.$theme.borders.radius300,
    borderBottomRightRadius: o.$theme.borders.radius300,
    borderBottomLeftRadius: o.$theme.borders.radius300,
    boxShadow: o.$theme.lighting.shadow400,
    color: o.$theme.colors.tooltipText,
    // Reset transition property to opacity only, and static transform
    transitionProperty: "opacity",
    transform: getEndPosition(o.$popoverOffset)
  });
});
Body$1.displayName = "Body";
Body$1.displayName = "Body";
var Inner = styled("div", function(o) {
  return _objectSpread$e(_objectSpread$e(_objectSpread$e({}, getInnerStyles(o)), {}, {
    backgroundColor: o.$theme.colors.tooltipBackground,
    borderTopLeftRadius: o.$theme.borders.radius300,
    borderTopRightRadius: o.$theme.borders.radius300,
    borderBottomRightRadius: o.$theme.borders.radius300,
    borderBottomLeftRadius: o.$theme.borders.radius300,
    paddingTop: o.$theme.sizing.scale300,
    paddingBottom: o.$theme.sizing.scale300,
    paddingLeft: o.$theme.sizing.scale600,
    paddingRight: o.$theme.sizing.scale600
  }, o.$theme.typography.font150), {}, {
    color: o.$theme.colors.tooltipText
  });
});
Inner.displayName = "Inner";
Inner.displayName = "Inner";
var Arrow = styled("div", function(o) {
  return _objectSpread$e(_objectSpread$e({}, getArrowStyles(o)), {}, {
    backgroundColor: o.$theme.colors.tooltipBackground
  });
});
Arrow.displayName = "Arrow";
Arrow.displayName = "Arrow";
function _typeof$8(o) {
  "@babel/helpers - typeof";
  return _typeof$8 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(E) {
    return typeof E;
  } : function(E) {
    return E && typeof Symbol == "function" && E.constructor === Symbol && E !== Symbol.prototype ? "symbol" : typeof E;
  }, _typeof$8(o);
}
function ownKeys$f(o, E) {
  var A = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var g = Object.getOwnPropertySymbols(o);
    E && (g = g.filter(function(e) {
      return Object.getOwnPropertyDescriptor(o, e).enumerable;
    })), A.push.apply(A, g);
  }
  return A;
}
function _objectSpread$d(o) {
  for (var E = 1; E < arguments.length; E++) {
    var A = arguments[E] != null ? arguments[E] : {};
    E % 2 ? ownKeys$f(Object(A), !0).forEach(function(g) {
      _defineProperty$g(o, g, A[g]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(A)) : ownKeys$f(Object(A)).forEach(function(g) {
      Object.defineProperty(o, g, Object.getOwnPropertyDescriptor(A, g));
    });
  }
  return o;
}
function _extends$k() {
  return _extends$k = Object.assign ? Object.assign.bind() : function(o) {
    for (var E = 1; E < arguments.length; E++) {
      var A = arguments[E];
      for (var g in A)
        Object.prototype.hasOwnProperty.call(A, g) && (o[g] = A[g]);
    }
    return o;
  }, _extends$k.apply(this, arguments);
}
function _classCallCheck$6(o, E) {
  if (!(o instanceof E))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$6(o, E) {
  for (var A = 0; A < E.length; A++) {
    var g = E[A];
    g.enumerable = g.enumerable || !1, g.configurable = !0, "value" in g && (g.writable = !0), Object.defineProperty(o, g.key, g);
  }
}
function _createClass$6(o, E, A) {
  return E && _defineProperties$6(o.prototype, E), Object.defineProperty(o, "prototype", { writable: !1 }), o;
}
function _inherits$6(o, E) {
  if (typeof E != "function" && E !== null)
    throw new TypeError("Super expression must either be null or a function");
  o.prototype = Object.create(E && E.prototype, { constructor: { value: o, writable: !0, configurable: !0 } }), Object.defineProperty(o, "prototype", { writable: !1 }), E && _setPrototypeOf$6(o, E);
}
function _setPrototypeOf$6(o, E) {
  return _setPrototypeOf$6 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(g, e) {
    return g.__proto__ = e, g;
  }, _setPrototypeOf$6(o, E);
}
function _createSuper$6(o) {
  var E = _isNativeReflectConstruct$6();
  return function() {
    var g = _getPrototypeOf$6(o), e;
    if (E) {
      var t = _getPrototypeOf$6(this).constructor;
      e = Reflect.construct(g, arguments, t);
    } else
      e = g.apply(this, arguments);
    return _possibleConstructorReturn$6(this, e);
  };
}
function _possibleConstructorReturn$6(o, E) {
  if (E && (_typeof$8(E) === "object" || typeof E == "function"))
    return E;
  if (E !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$7(o);
}
function _assertThisInitialized$7(o) {
  if (o === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return o;
}
function _isNativeReflectConstruct$6() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function _getPrototypeOf$6(o) {
  return _getPrototypeOf$6 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(A) {
    return A.__proto__ || Object.getPrototypeOf(A);
  }, _getPrototypeOf$6(o);
}
function _defineProperty$g(o, E, A) {
  return E in o ? Object.defineProperty(o, E, { value: A, enumerable: !0, configurable: !0, writable: !0 }) : o[E] = A, o;
}
var Tooltip$2 = /* @__PURE__ */ (function(o) {
  _inherits$6(A, o);
  var E = _createSuper$6(A);
  function A() {
    return _classCallCheck$6(this, A), E.apply(this, arguments);
  }
  return _createClass$6(A, [{
    key: "render",
    value: function() {
      var e = mergeOverrides({
        Arrow,
        Body: Body$1,
        Inner
      }, this.props.overrides);
      return /* @__PURE__ */ React.createElement(Popover$2, _extends$k({
        autoFocus: !1,
        "data-baseweb": "tooltip"
      }, this.props, {
        overrides: e
      }));
    }
  }]), A;
})(React.Component);
_defineProperty$g(Tooltip$2, "defaultProps", _objectSpread$d({}, baseDefaultProps));
var _excluded$k = ["children"];
function _objectWithoutProperties$i(o, E) {
  if (o == null) return {};
  var A = _objectWithoutPropertiesLoose$h(o, E), g, e;
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    for (e = 0; e < t.length; e++)
      g = t[e], !(E.indexOf(g) >= 0) && Object.prototype.propertyIsEnumerable.call(o, g) && (A[g] = o[g]);
  }
  return A;
}
function _objectWithoutPropertiesLoose$h(o, E) {
  if (o == null) return {};
  var A = {}, g = Object.keys(o), e, t;
  for (t = 0; t < g.length; t++)
    e = g[t], !(E.indexOf(e) >= 0) && (A[e] = o[e]);
  return A;
}
function StatefulTooltip(o) {
  var E = o.children, A = _objectWithoutProperties$i(o, _excluded$k);
  return /* @__PURE__ */ React.createElement(StatefulContainer, A, function(g) {
    return /* @__PURE__ */ React.createElement(Tooltip$2, g, E);
  });
}
StatefulTooltip.defaultProps = StatefulContainer.defaultProps;
function _EMOTION_STRINGIFIED_CSS_ERROR__$f() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const StyledWrapper = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e1gc5fo22"
} : {
  target: "e1gc5fo22",
  label: "StyledWrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "87mhkc",
  styles: "display:table;table-layout:fixed;width:100%"
} : {
  name: "87mhkc",
  styles: "display:table;table-layout:fixed;width:100%/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$f
}), StyledEllipsizedDiv = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e1gc5fo21"
} : {
  target: "e1gc5fo21",
  label: "StyledEllipsizedDiv"
})(process.env.NODE_ENV === "production" ? {
  name: "sy3zga",
  styles: "overflow:hidden;white-space:nowrap;text-overflow:ellipsis;display:table-cell"
} : {
  name: "sy3zga",
  styles: "overflow:hidden;white-space:nowrap;text-overflow:ellipsis;display:table-cell/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$f
}), StyledTooltipContentWrapper = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e1gc5fo20"
} : {
  target: "e1gc5fo20",
  label: "StyledTooltipContentWrapper"
})(({
  theme: o
}) => ({
  boxSizing: "border-box",
  fontSize: `${o.fontSizes.sm}`,
  maxWidth: `calc(${o.sizes.contentMaxWidth} - 2 * ${o.spacing.threeXL})`,
  maxHeight: o.sizes.maxTooltipHeight,
  overflow: "auto",
  padding: `${o.spacing.xs} ${o.spacing.md}`,
  [`@media (max-width: ${o.breakpoints.sm})`]: {
    maxWidth: `calc(100% - ${o.spacing.threeXL})`
  },
  img: {
    maxWidth: "100%"
  },
  "*": {
    fontSize: o.fontSizes.sm
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
function useTooltipMeasurementSideEffect(o, E) {
  const {
    innerWidth: A
  } = useWindowDimensionsContext();
  useEffect(() => {
    const g = o?.parentElement;
    if (!g)
      return;
    (async () => {
      const t = () => {
        const M = g.getBoundingClientRect();
        return M.x !== 0 || M.y !== 0 ? M : null;
      };
      let c = null, n = 0;
      const h = 5;
      for (; !c && n < h; )
        c = t(), c || (n++, await new Promise((M) => requestAnimationFrame(M)));
      c || (c = g.getBoundingClientRect());
      const d = c.x, k = d + c.width - A, p = g.parentElement;
      if (k > 0 && p) {
        const M = new DOMMatrix(
          // eslint-disable-next-line streamlit-custom/no-force-reflow-access -- Existing usage
          window.getComputedStyle(p)?.transform
        );
        p.style.transform = `translate3d(${M.e - k}px, ${M.f}px, 0px)`;
      }
      d < 0 && (g.style.left = `${-d}px`);
    })();
  }, [o, E, A]);
}
var Placement = /* @__PURE__ */ ((o) => (o.AUTO = "auto", o.TOP_LEFT = "topLeft", o.TOP = "top", o.TOP_RIGHT = "topRight", o.RIGHT_TOP = "rightTop", o.RIGHT = "right", o.RIGHT_BOTTOM = "rightBottom", o.BOTTOM_RIGHT = "bottomRight", o.BOTTOM = "bottom", o.BOTTOM_LEFT = "bottomLeft", o.LEFT_BOTTOM = "leftBottom", o.LEFT = "left", o.LEFT_TOP = "leftTop", o))(Placement || {});
const generateDefaultTooltipOverrides = (o, E) => {
  const {
    colors: A,
    fontSizes: g,
    radii: e,
    fontWeights: t
  } = o;
  return {
    Body: {
      style: {
        // This is annoying, but a bunch of warnings get logged when the
        // shorthand version `borderRadius` is used here since the long
        // names are used by BaseWeb and mixing the two is apparently
        // bad :(
        borderTopLeftRadius: e.default,
        borderTopRightRadius: e.default,
        borderBottomLeftRadius: e.default,
        borderBottomRightRadius: e.default,
        paddingTop: "0 !important",
        paddingBottom: "0 !important",
        paddingLeft: "0 !important",
        paddingRight: "0 !important",
        backgroundColor: "transparent"
      }
    },
    Inner: {
      style: {
        backgroundColor: hasLightBackgroundColor(o) ? A.bgColor : A.secondaryBg,
        color: A.bodyText,
        fontSize: g.sm,
        fontWeight: t.normal,
        // See the long comment about `borderRadius`. The same applies here
        // to `padding`.
        paddingTop: "0 !important",
        paddingBottom: "0 !important",
        paddingLeft: "0 !important",
        paddingRight: "0 !important"
      },
      // overrides prop replaces tooltip subcomponent overrides
      ...E
    }
  };
};
function Tooltip({
  content: o,
  placement: E,
  children: A,
  inline: g,
  style: e,
  onMouseEnterDelay: t,
  overrides: c,
  containerWidth: n,
  error: h
}) {
  const d = useEmotionTheme(), [k, p] = useState(null), [M, S] = useState(!1), AA = useCallback(() => {
    S(!0);
  }, []), H = useCallback(() => {
    S(!1);
  }, []);
  useTooltipMeasurementSideEffect(k, M);
  const gA = generateDefaultTooltipOverrides(d, c);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StatefulTooltip, { onOpen: AA, onClose: H, content: o ? /* @__PURE__ */ jsxRuntimeExports.jsx(StyledTooltipContentWrapper, { className: h ? "stTooltipErrorContent" : "stTooltipContent", "data-testid": h ? "stTooltipErrorContent" : "stTooltipContent", ref: p, children: o }) : null, placement: PLACEMENT[E], accessibilityType: ACCESSIBILITY_TYPE.tooltip, showArrow: !1, popoverMargin: 10, onMouseEnterDelay: t, overrides: gA, children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: {
    display: "flex",
    flexDirection: "row",
    justifyContent: g ? "flex-end" : "",
    width: n ? "100%" : "auto",
    ...e
  }, "data-testid": h ? "stTooltipErrorHoverTarget" : "stTooltipHoverTarget", className: h ? "stTooltipErrorHoverTarget" : "stTooltipHoverTarget", children: A }) });
}
const Tooltip$1 = memo(Tooltip);
function OverflowTooltip({
  content: o,
  placement: E,
  children: A,
  inline: g,
  style: e
}) {
  const t = React__default.useRef(null), [c, n] = useState(!1);
  return React__default.useEffect(() => {
    const h = t?.current ? (
      // eslint-disable-next-line streamlit-custom/no-force-reflow-access -- Existing usage
      t.current.offsetWidth < t.current.scrollWidth
    ) : !1;
    h !== c && n(h);
  }, [A, c]), /* @__PURE__ */ jsxRuntimeExports.jsx(Tooltip$1, { content: c ? o : "", placement: E, inline: g, children: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledWrapper, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledEllipsizedDiv, { ref: t, style: e, children: A }) }) });
}
function TooltipIcon({
  placement: o = Placement.AUTO,
  isLatex: E = !1,
  content: A,
  children: g,
  markdownProps: e,
  onMouseEnterDelay: t,
  containerWidth: c = !1
}) {
  const n = useEmotionTheme();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledTooltipIconWrapper, { className: "stTooltipIcon", "data-testid": "stTooltipIcon", isLatex: E, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Tooltip$1, { content: /* @__PURE__ */ jsxRuntimeExports.jsx(StreamlitMarkdown$1, { style: {
    fontSize: n.fontSizes.sm
  }, source: A, allowHTML: !1, ...e || {} }), placement: o, onMouseEnterDelay: t, inline: !0, containerWidth: c, children: g || /* @__PURE__ */ jsxRuntimeExports.jsx(
    HelpCircle,
    {
      className: "icon",
      size: convertRemToPx(n.iconSizes.base)
    }
  ) }) });
}
const InlineTooltipIcon = ({
  placement: o = Placement.TOP_RIGHT,
  isLatex: E = !1,
  content: A,
  children: g,
  markdownProps: e
}) => /* @__PURE__ */ jsxRuntimeExports.jsx(StyledLabelHelpInline, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(TooltipIcon, { placement: o, isLatex: E, content: A, markdownProps: e, children: g }) });
function _EMOTION_STRINGIFIED_CSS_ERROR__$e() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
function convertRemToEm(o) {
  return o.replace(/rem$/, "em");
}
function sharedMarkdownStyle(o) {
  return {
    a: {
      color: o.colors.link,
      textDecoration: o.linkUnderline ? "underline" : "none"
    }
  };
}
function convertFontSizes(o, E, A) {
  if (E) {
    const g = roundFontSizeToNearestEighth(parseFloat(o) * 0.65), e = `${Math.max(g, 0.75)}rem`;
    return A ? convertRemToEm(e) : e;
  }
  return A ? convertRemToEm(o) : o;
}
function getMarkdownHeadingDefinitions(o, E, A) {
  return {
    "h1, h2, h3, h4, h5, h6": {
      fontFamily: o.genericFonts.headingFont,
      lineHeight: o.lineHeights.headings,
      margin: 0,
      color: "inherit"
    },
    h1: {
      fontSize: convertFontSizes(o.fontSizes.h1FontSize, E, A),
      fontWeight: o.fontWeights.h1FontWeight,
      padding: `${o.spacing.xl} 0 ${o.spacing.lg} 0`
    },
    "h1 b, h1 strong": {
      // Per Pull Request #9395, setting text to bold in headers
      // should NOT change its font-weight
      fontWeight: o.fontWeights.h1FontWeight
    },
    "h2, h3": {
      letterSpacing: "-0.005em"
    },
    h2: {
      fontSize: convertFontSizes(o.fontSizes.h2FontSize, E, A),
      fontWeight: o.fontWeights.h2FontWeight,
      padding: `${o.spacing.lg} 0 ${o.spacing.lg} 0`
    },
    h3: {
      fontSize: convertFontSizes(o.fontSizes.h3FontSize, E, A),
      fontWeight: o.fontWeights.h3FontWeight,
      padding: `${o.spacing.md} 0 ${o.spacing.lg} 0`
    },
    h4: {
      fontSize: convertFontSizes(o.fontSizes.h4FontSize, E, A),
      fontWeight: o.fontWeights.h4FontWeight,
      padding: `${o.spacing.sm} 0 ${o.spacing.lg} 0`
    },
    h5: {
      fontSize: convertFontSizes(o.fontSizes.h5FontSize, E, A),
      fontWeight: o.fontWeights.h5FontWeight,
      padding: `${o.spacing.xs} 0 ${o.spacing.lg} 0`
    },
    h6: {
      fontSize: convertFontSizes(o.fontSizes.h6FontSize, E, A),
      fontWeight: o.fontWeights.h6FontWeight,
      padding: `${o.spacing.twoXS} 0 ${o.spacing.lg} 0`
    }
  };
}
const StyledStreamlitMarkdown = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e1nzilvr6"
} : {
  target: "e1nzilvr6",
  label: "StyledStreamlitMarkdown"
})(({
  theme: o,
  isCaption: E,
  isInDialog: A,
  isLabel: g,
  inheritFont: e,
  boldLabel: t,
  largerLabel: c,
  isToast: n
}) => {
  const h = g && !c || n || E;
  return {
    fontFamily: e ? "inherit" : o.genericFonts.bodyFont,
    fontSize: e ? "inherit" : h ? o.fontSizes.sm : o.fontSizes.md,
    marginBottom: g ? "" : `-${o.spacing.lg}`,
    opacity: E ? 0.6 : void 0,
    color: "inherit",
    // Always respect the width of the parent container:
    maxWidth: "100%",
    width: g ? "" : "100%",
    // Break long words to prevent them from overflowing the container:
    overflowWrap: "break-word",
    ...sharedMarkdownStyle(o),
    ...getMarkdownHeadingDefinitions(o, A, E),
    // This is required so that long Latex formulas in `st.latex` are scrollable
    // when `help` is set (see below).
    "&:has(.katex-display)": {
      overflowX: "hidden"
    },
    p: {
      wordBreak: "break-word",
      marginBottom: g ? o.spacing.none : "",
      fontWeight: e ? "inherit" : t ? o.fontWeights.bold : "",
      marginTop: o.spacing.none,
      marginLeft: o.spacing.none,
      marginRight: o.spacing.none
    },
    img: {
      // Images in markdown should never be wider
      // than the content area.
      maxWidth: "100%",
      // In labels, widgets should never be taller than the text.
      maxHeight: g ? "1em" : void 0,
      verticalAlign: "middle",
      // Ensure that images are not distorted:
      objectFit: "scale-down"
    },
    li: {
      margin: "0.2em 0 0.2em 1.15em",
      padding: "0 0 0 0.3em"
    },
    "li.task-list-item": {
      listStyleType: "none",
      padding: "0",
      marginLeft: "0",
      "input[type='checkbox']": {
        verticalAlign: "middle",
        margin: "0 0.35em 0.1em 0"
      }
    },
    // Handles quotes:
    blockquote: {
      margin: "1em 0 1em 0",
      padding: "0 0 0 0.75em",
      borderLeft: `0.15em solid ${o.colors.borderColor}`,
      opacity: 0.6
    },
    "b, strong": {
      fontWeight: o.fontWeights.bold
    },
    // Issue #11976: Handle bolded inline code
    "b code, strong code": {
      fontWeight: o.fontWeights.codeBold
    },
    // Handles the horizontal divider:
    hr: {
      margin: "2em 0",
      padding: 0,
      // Reset Firefox's gray color:
      color: "inherit",
      backgroundColor: "transparent",
      border: "none",
      borderBottom: `${o.sizes.borderWidth} solid ${o.colors.borderColor}`,
      // Set correct height and prevent the size attribute
      // to make the hr look like an input field:
      "&:not([size])": {
        height: o.sizes.borderWidth
      }
    },
    table: {
      display: "table",
      // Prevent double borders
      borderCollapse: "collapse",
      marginBottom: o.spacing.lg
    },
    tr: {
      borderTop: `${o.sizes.borderWidth} solid ${o.colors.dataframeBorderColor}`
    },
    th: {
      // TODO: check whether this should be adjusted
      // defaults to font-weight: "bold" (700)
      textAlign: "inherit"
    },
    "th, td": {
      padding: `${o.spacing.xs} ${o.spacing.md}`,
      border: `${o.sizes.borderWidth} solid ${o.colors.dataframeBorderColor}`
    },
    "span.stMarkdownColoredBackground": {
      borderRadius: o.radii.md,
      padding: `${o.spacing.threeXS} ${o.spacing.twoXS}`,
      margin: o.spacing.none,
      boxDecorationBreak: "clone"
    },
    "span.stMarkdownBadge": {
      borderRadius: o.radii.md,
      // Since we're using inline-block below, we're not using vertical padding here,
      // because inline-block already makes the element look a bit taller.
      padding: `0 ${o.spacing.twoXS}`,
      // Add a small margin to separate it a bit from other text.
      margin: `0 ${o.spacing.px}`,
      // Make badges not wrap and ellipsize them if they are too long for the
      // parent container.
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      maxWidth: "100%",
      display: "inline-block",
      verticalAlign: "middle"
    },
    "p, ol, ul, dl, li": {
      fontSize: "inherit"
    },
    "& > ul, & > ol": {
      display: "block",
      width: "fit-content",
      textAlign: "left"
    },
    // Ensure nested lists stay as block elements
    "li > ul, li > ol": {
      display: "block"
    },
    // Allow long Latex formulas that are not inline (i.e. either from `st.latex`
    // or in their own paragraph inside `st.markdown`) to scroll horizontally.
    ".katex-display": {
      overflowX: "auto",
      overflowY: "hidden"
    },
    ".katex": {
      fontWeight: o.fontWeights.normal
    }
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledLinkIcon = /* @__PURE__ */ createStyled("a", process.env.NODE_ENV === "production" ? {
  target: "e1nzilvr5"
} : {
  target: "e1nzilvr5",
  label: "StyledLinkIcon"
})(({
  theme: o
}) => ({
  // center icon
  lineHeight: 0,
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  svg: {
    // same color as the tooltip-icon
    stroke: o.colors.fadedText60,
    strokeWidth: 2.25
  },
  "&:hover svg": {
    stroke: o.colors.bodyText
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledHeadingWithActionElements = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e1nzilvr4"
} : {
  target: "e1nzilvr4",
  label: "StyledHeadingWithActionElements"
})(({
  theme: o
}) => ({
  "h1, h2, h3, h4, h5, h6, span": {
    scrollMarginTop: o.sizes.headerHeight
  },
  ...sharedMarkdownStyle(o),
  // break-word & pretty makes most headings break in a nicer way than break-all while still
  // preventing overflowing of the container to the side. Long headings without whitespaces or hyphens might still look weird
  wordBreak: "break-word",
  textWrap: "pretty",
  // show link-icon when hovering somewhere over the heading
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace 'any' with a more specific type.
  [StyledLinkIcon]: {
    visibility: "hidden"
  },
  // we have to set the hover here so that the link icon becomes visible when hovering anywhere over the heading
  "&:hover": {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace 'any' with a more specific type.
    [StyledLinkIcon]: {
      visibility: "visible"
    }
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledHeadingActionElements = /* @__PURE__ */ createStyled("span", process.env.NODE_ENV === "production" ? {
  target: "e1nzilvr3"
} : {
  target: "e1nzilvr3",
  label: "StyledHeadingActionElements"
})(({
  theme: o
}) => ({
  marginLeft: o.spacing.sm,
  display: "inline-flex",
  gap: o.spacing.sm,
  verticalAlign: "middle",
  "& > *": {
    // remove margins of inner elements as they are wrapped in a container that applies the margin
    marginLeft: "0 !important"
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2xpYi9zcmMvY29tcG9uZW50cy9zaGFyZWQvU3RyZWFtbGl0TWFya2Rvd24vc3R5bGVkLWNvbXBvbmVudHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBbVkyQyIsImZpbGUiOiIvaG9tZS9ydW5uZXIvd29yay9zdGxpdGUvc3RsaXRlL3N0cmVhbWxpdC9mcm9udGVuZC9saWIvc3JjL2NvbXBvbmVudHMvc2hhcmVkL1N0cmVhbWxpdE1hcmtkb3duL3N0eWxlZC1jb21wb25lbnRzLnRzIiwic291cmNlc0NvbnRlbnQiOlsiLyoqXG4gKiBDb3B5cmlnaHQgKGMpIFN0cmVhbWxpdCBJbmMuICgyMDE4LTIwMjIpIFNub3dmbGFrZSBJbmMuICgyMDIyLTIwMjUpXG4gKlxuICogTGljZW5zZWQgdW5kZXIgdGhlIEFwYWNoZSBMaWNlbnNlLCBWZXJzaW9uIDIuMCAodGhlIFwiTGljZW5zZVwiKTtcbiAqIHlvdSBtYXkgbm90IHVzZSB0aGlzIGZpbGUgZXhjZXB0IGluIGNvbXBsaWFuY2Ugd2l0aCB0aGUgTGljZW5zZS5cbiAqIFlvdSBtYXkgb2J0YWluIGEgY29weSBvZiB0aGUgTGljZW5zZSBhdFxuICpcbiAqICAgICBodHRwOi8vd3d3LmFwYWNoZS5vcmcvbGljZW5zZXMvTElDRU5TRS0yLjBcbiAqXG4gKiBVbmxlc3MgcmVxdWlyZWQgYnkgYXBwbGljYWJsZSBsYXcgb3IgYWdyZWVkIHRvIGluIHdyaXRpbmcsIHNvZnR3YXJlXG4gKiBkaXN0cmlidXRlZCB1bmRlciB0aGUgTGljZW5zZSBpcyBkaXN0cmlidXRlZCBvbiBhbiBcIkFTIElTXCIgQkFTSVMsXG4gKiBXSVRIT1VUIFdBUlJBTlRJRVMgT1IgQ09ORElUSU9OUyBPRiBBTlkgS0lORCwgZWl0aGVyIGV4cHJlc3Mgb3IgaW1wbGllZC5cbiAqIFNlZSB0aGUgTGljZW5zZSBmb3IgdGhlIHNwZWNpZmljIGxhbmd1YWdlIGdvdmVybmluZyBwZXJtaXNzaW9ucyBhbmRcbiAqIGxpbWl0YXRpb25zIHVuZGVyIHRoZSBMaWNlbnNlLlxuICovXG5cbmltcG9ydCB7IFRoZW1lIH0gZnJvbSBcIkBlbW90aW9uL3JlYWN0XCJcbmltcG9ydCBzdHlsZWQgZnJvbSBcIkBlbW90aW9uL3N0eWxlZFwiXG5cbmltcG9ydCB7IHJvdW5kRm9udFNpemVUb05lYXJlc3RFaWdodGggfSBmcm9tIFwifmxpYi90aGVtZS91dGlsc1wiXG5cbmV4cG9ydCBpbnRlcmZhY2UgU3R5bGVkU3RyZWFtbGl0TWFya2Rvd25Qcm9wcyB7XG4gIGlzQ2FwdGlvbjogYm9vbGVhblxuICBpc0luRGlhbG9nOiBib29sZWFuXG4gIGlzTGFiZWw/OiBib29sZWFuXG4gIGluaGVyaXRGb250PzogYm9vbGVhblxuICBib2xkTGFiZWw/OiBib29sZWFuXG4gIGxhcmdlckxhYmVsPzogYm9vbGVhblxuICBpc1RvYXN0PzogYm9vbGVhblxufVxuXG5mdW5jdGlvbiBjb252ZXJ0UmVtVG9FbShzOiBzdHJpbmcpOiBzdHJpbmcge1xuICByZXR1cm4gcy5yZXBsYWNlKC9yZW0kLywgXCJlbVwiKVxufVxuXG4vLyBlc2xpbnQtZGlzYWJsZS1uZXh0LWxpbmUgQHR5cGVzY3JpcHQtZXNsaW50L25vLWV4cGxpY2l0LWFueSAtLSBUT0RPOiBSZXBsYWNlICdhbnknIHdpdGggYSBtb3JlIHNwZWNpZmljIHR5cGUuXG5mdW5jdGlvbiBzaGFyZWRNYXJrZG93blN0eWxlKHRoZW1lOiBUaGVtZSk6IGFueSB7XG4gIHJldHVybiB7XG4gICAgYToge1xuICAgICAgY29sb3I6IHRoZW1lLmNvbG9ycy5saW5rLFxuICAgICAgdGV4dERlY29yYXRpb246IHRoZW1lLmxpbmtVbmRlcmxpbmUgPyBcInVuZGVybGluZVwiIDogXCJub25lXCIsXG4gICAgfSxcbiAgfVxufVxuXG4vKipcbiAqIENhcHRpb24gc2l6ZXMgdGFrZW4gZnJvbSBkZWZhdWx0IHN0eWxlcywgYnV0IHVzaW5nIGVtIGluc3RlYWQgb2YgcmVtLCBzbyBpdFxuICogaW5oZXJpdHMgdGhlIDxzbWFsbD4ncyBzaHJ1bmsgc2l6ZS4gQWxzbyBoYW5kbGVzIHJlZHVjZWQgaGVhZGluZyBmb250IHNpemVzXG4gKiBpbiBkaWFsb2dzLlxuICovXG5mdW5jdGlvbiBjb252ZXJ0Rm9udFNpemVzKFxuICBmb250U2l6ZTogc3RyaW5nLFxuICBpc0luRGlhbG9nOiBib29sZWFuLFxuICBpc0NhcHRpb246IGJvb2xlYW5cbik6IHN0cmluZyB7XG4gIC8vIEZvciBoZWFkZXJzIGluIGBzdC5jYXB0aW9uYCwgd2UgdXNlIGBlbWAgdmFsdWVzLCBzbyB0aGUgaGVhZGVycyBhdXRvbWF0aWNhbGx5XG4gIC8vIGJlY29tZSBhIGJpdCBzbWFsbGVyIGJ5IGFkYXB0aW5nIHRvIHRoZSBmb250IHNpemUgb2YgdGhlIGNhcHRpb24uXG5cbiAgaWYgKGlzSW5EaWFsb2cpIHtcbiAgICAvLyBEaWFsb2dzIGFsc28gcmVkdWNlIHRoZSBmb250IHNpemUgb2YgdGhlIGhlYWRpbmdzIHRvIDY1JSBvZiB0aGUgYmFzZSBmb250IHNpemVcbiAgICAvLyBSb3VuZCB0aGUgZm9udCBzaXplIHRvIHRoZSBuZWFyZXN0IGVpZ2h0aCBvZiBhIHJlbSB0byB0cnkgdG8ga2VlcCB0byByb3VuZCBweCB2YWx1ZXNcbiAgICBjb25zdCByb3VuZGVkRm9udFNpemUgPSByb3VuZEZvbnRTaXplVG9OZWFyZXN0RWlnaHRoKFxuICAgICAgcGFyc2VGbG9hdChmb250U2l6ZSkgKiAwLjY1XG4gICAgKVxuXG4gICAgLy8gRW5zdXJlIHRoZSBmb250IHNpemUgaXMgYXQgbGVhc3QgMC43NXJlbVxuICAgIGNvbnN0IGRpYWxvZ0ZvbnRTaXplID0gYCR7TWF0aC5tYXgocm91bmRlZEZvbnRTaXplLCAwLjc1KX1yZW1gXG4gICAgcmV0dXJuIGlzQ2FwdGlvbiA/IGNvbnZlcnRSZW1Ub0VtKGRpYWxvZ0ZvbnRTaXplKSA6IGRpYWxvZ0ZvbnRTaXplXG4gIH1cblxuICByZXR1cm4gaXNDYXB0aW9uID8gY29udmVydFJlbVRvRW0oZm9udFNpemUpIDogZm9udFNpemVcbn1cblxuZnVuY3Rpb24gZ2V0TWFya2Rvd25IZWFkaW5nRGVmaW5pdGlvbnMoXG4gIHRoZW1lOiBUaGVtZSxcbiAgaXNJbkRpYWxvZzogYm9vbGVhbixcbiAgaXNDYXB0aW9uOiBib29sZWFuXG4gIC8vIGVzbGludC1kaXNhYmxlLW5leHQtbGluZSBAdHlwZXNjcmlwdC1lc2xpbnQvbm8tZXhwbGljaXQtYW55IC0tIFRPRE86IFJlcGxhY2UgJ2FueScgd2l0aCBhIG1vcmUgc3BlY2lmaWMgdHlwZS5cbik6IGFueSB7XG4gIHJldHVybiB7XG4gICAgXCJoMSwgaDIsIGgzLCBoNCwgaDUsIGg2XCI6IHtcbiAgICAgIGZvbnRGYW1pbHk6IHRoZW1lLmdlbmVyaWNGb250cy5oZWFkaW5nRm9udCxcbiAgICAgIGxpbmVIZWlnaHQ6IHRoZW1lLmxpbmVIZWlnaHRzLmhlYWRpbmdzLFxuICAgICAgbWFyZ2luOiAwLFxuICAgICAgY29sb3I6IFwiaW5oZXJpdFwiLFxuICAgIH0sXG4gICAgaDE6IHtcbiAgICAgIGZvbnRTaXplOiBjb252ZXJ0Rm9udFNpemVzKFxuICAgICAgICB0aGVtZS5mb250U2l6ZXMuaDFGb250U2l6ZSxcbiAgICAgICAgaXNJbkRpYWxvZyxcbiAgICAgICAgaXNDYXB0aW9uXG4gICAgICApLFxuXG4gICAgICBmb250V2VpZ2h0OiB0aGVtZS5mb250V2VpZ2h0cy5oMUZvbnRXZWlnaHQsXG4gICAgICBwYWRkaW5nOiBgJHt0aGVtZS5zcGFjaW5nLnhsfSAwICR7dGhlbWUuc3BhY2luZy5sZ30gMGAsXG4gICAgfSxcbiAgICBcImgxIGIsIGgxIHN0cm9uZ1wiOiB7XG4gICAgICAvLyBQZXIgUHVsbCBSZXF1ZXN0ICM5Mzk1LCBzZXR0aW5nIHRleHQgdG8gYm9sZCBpbiBoZWFkZXJzXG4gICAgICAvLyBzaG91bGQgTk9UIGNoYW5nZSBpdHMgZm9udC13ZWlnaHRcbiAgICAgIGZvbnRXZWlnaHQ6IHRoZW1lLmZvbnRXZWlnaHRzLmgxRm9udFdlaWdodCxcbiAgICB9LFxuICAgIFwiaDIsIGgzXCI6IHtcbiAgICAgIGxldHRlclNwYWNpbmc6IFwiLTAuMDA1ZW1cIixcbiAgICB9LFxuICAgIGgyOiB7XG4gICAgICBmb250U2l6ZTogY29udmVydEZvbnRTaXplcyhcbiAgICAgICAgdGhlbWUuZm9udFNpemVzLmgyRm9udFNpemUsXG4gICAgICAgIGlzSW5EaWFsb2csXG4gICAgICAgIGlzQ2FwdGlvblxuICAgICAgKSxcbiAgICAgIGZvbnRXZWlnaHQ6IHRoZW1lLmZvbnRXZWlnaHRzLmgyRm9udFdlaWdodCxcbiAgICAgIHBhZGRpbmc6IGAke3RoZW1lLnNwYWNpbmcubGd9IDAgJHt0aGVtZS5zcGFjaW5nLmxnfSAwYCxcbiAgICB9LFxuICAgIGgzOiB7XG4gICAgICBmb250U2l6ZTogY29udmVydEZvbnRTaXplcyhcbiAgICAgICAgdGhlbWUuZm9udFNpemVzLmgzRm9udFNpemUsXG4gICAgICAgIGlzSW5EaWFsb2csXG4gICAgICAgIGlzQ2FwdGlvblxuICAgICAgKSxcblxuICAgICAgZm9udFdlaWdodDogdGhlbWUuZm9udFdlaWdodHMuaDNGb250V2VpZ2h0LFxuICAgICAgcGFkZGluZzogYCR7dGhlbWUuc3BhY2luZy5tZH0gMCAke3RoZW1lLnNwYWNpbmcubGd9IDBgLFxuICAgIH0sXG4gICAgaDQ6IHtcbiAgICAgIGZvbnRTaXplOiBjb252ZXJ0Rm9udFNpemVzKFxuICAgICAgICB0aGVtZS5mb250U2l6ZXMuaDRGb250U2l6ZSxcbiAgICAgICAgaXNJbkRpYWxvZyxcbiAgICAgICAgaXNDYXB0aW9uXG4gICAgICApLFxuICAgICAgZm9udFdlaWdodDogdGhlbWUuZm9udFdlaWdodHMuaDRGb250V2VpZ2h0LFxuICAgICAgcGFkZGluZzogYCR7dGhlbWUuc3BhY2luZy5zbX0gMCAke3RoZW1lLnNwYWNpbmcubGd9IDBgLFxuICAgIH0sXG4gICAgaDU6IHtcbiAgICAgIGZvbnRTaXplOiBjb252ZXJ0Rm9udFNpemVzKFxuICAgICAgICB0aGVtZS5mb250U2l6ZXMuaDVGb250U2l6ZSxcbiAgICAgICAgaXNJbkRpYWxvZyxcbiAgICAgICAgaXNDYXB0aW9uXG4gICAgICApLFxuICAgICAgZm9udFdlaWdodDogdGhlbWUuZm9udFdlaWdodHMuaDVGb250V2VpZ2h0LFxuICAgICAgcGFkZGluZzogYCR7dGhlbWUuc3BhY2luZy54c30gMCAke3RoZW1lLnNwYWNpbmcubGd9IDBgLFxuICAgIH0sXG4gICAgaDY6IHtcbiAgICAgIGZvbnRTaXplOiBjb252ZXJ0Rm9udFNpemVzKFxuICAgICAgICB0aGVtZS5mb250U2l6ZXMuaDZGb250U2l6ZSxcbiAgICAgICAgaXNJbkRpYWxvZyxcbiAgICAgICAgaXNDYXB0aW9uXG4gICAgICApLFxuXG4gICAgICBmb250V2VpZ2h0OiB0aGVtZS5mb250V2VpZ2h0cy5oNkZvbnRXZWlnaHQsXG4gICAgICBwYWRkaW5nOiBgJHt0aGVtZS5zcGFjaW5nLnR3b1hTfSAwICR7dGhlbWUuc3BhY2luZy5sZ30gMGAsXG4gICAgfSxcbiAgfVxufVxuXG5leHBvcnQgY29uc3QgU3R5bGVkU3RyZWFtbGl0TWFya2Rvd24gPVxuICBzdHlsZWQuZGl2PFN0eWxlZFN0cmVhbWxpdE1hcmtkb3duUHJvcHM+KFxuICAgICh7XG4gICAgICB0aGVtZSxcbiAgICAgIGlzQ2FwdGlvbixcbiAgICAgIGlzSW5EaWFsb2csXG4gICAgICBpc0xhYmVsLFxuICAgICAgaW5oZXJpdEZvbnQsXG4gICAgICBib2xkTGFiZWwsXG4gICAgICBsYXJnZXJMYWJlbCxcbiAgICAgIGlzVG9hc3QsXG4gICAgfSkgPT4ge1xuICAgICAgLy8gV2lkZ2V0IExhYmVscyBoYXZlIHNtYWxsZXIgZm9udCBzaXplIHdpdGggZXhjZXB0aW9uIG9mIEJ1dHRvbi9DaGVja2JveC9SYWRpbyBCdXR0b24gbGFiZWxzXG4gICAgICAvLyBUb2FzdHMgYWxzbyBoYXZlIHNtYWxsZXIgZm9udCBzaXplIGFzIHdlbGwgYXMgcGlsbHMgYW5kIHNlZ21lbnRlZCBjb250cm9scy5cbiAgICAgIGNvbnN0IHVzZVNtYWxsZXJGb250U2l6ZSA9XG4gICAgICAgIChpc0xhYmVsICYmICFsYXJnZXJMYWJlbCkgfHwgaXNUb2FzdCB8fCBpc0NhcHRpb25cblxuICAgICAgcmV0dXJuIHtcbiAgICAgICAgZm9udEZhbWlseTogaW5oZXJpdEZvbnQgPyBcImluaGVyaXRcIiA6IHRoZW1lLmdlbmVyaWNGb250cy5ib2R5Rm9udCxcbiAgICAgICAgZm9udFNpemU6IGluaGVyaXRGb250XG4gICAgICAgICAgPyBcImluaGVyaXRcIlxuICAgICAgICAgIDogdXNlU21hbGxlckZvbnRTaXplXG4gICAgICAgICAgICA/IHRoZW1lLmZvbnRTaXplcy5zbVxuICAgICAgICAgICAgOiB0aGVtZS5mb250U2l6ZXMubWQsXG4gICAgICAgIG1hcmdpbkJvdHRvbTogaXNMYWJlbCA/IFwiXCIgOiBgLSR7dGhlbWUuc3BhY2luZy5sZ31gLFxuICAgICAgICBvcGFjaXR5OiBpc0NhcHRpb24gPyAwLjYgOiB1bmRlZmluZWQsXG4gICAgICAgIGNvbG9yOiBcImluaGVyaXRcIixcbiAgICAgICAgLy8gQWx3YXlzIHJlc3BlY3QgdGhlIHdpZHRoIG9mIHRoZSBwYXJlbnQgY29udGFpbmVyOlxuICAgICAgICBtYXhXaWR0aDogXCIxMDAlXCIsXG4gICAgICAgIHdpZHRoOiBpc0xhYmVsID8gXCJcIiA6IFwiMTAwJVwiLFxuICAgICAgICAvLyBCcmVhayBsb25nIHdvcmRzIHRvIHByZXZlbnQgdGhlbSBmcm9tIG92ZXJmbG93aW5nIHRoZSBjb250YWluZXI6XG4gICAgICAgIG92ZXJmbG93V3JhcDogXCJicmVhay13b3JkXCIsXG4gICAgICAgIC4uLnNoYXJlZE1hcmtkb3duU3R5bGUodGhlbWUpLFxuICAgICAgICAuLi5nZXRNYXJrZG93bkhlYWRpbmdEZWZpbml0aW9ucyh0aGVtZSwgaXNJbkRpYWxvZywgaXNDYXB0aW9uKSxcblxuICAgICAgICAvLyBUaGlzIGlzIHJlcXVpcmVkIHNvIHRoYXQgbG9uZyBMYXRleCBmb3JtdWxhcyBpbiBgc3QubGF0ZXhgIGFyZSBzY3JvbGxhYmxlXG4gICAgICAgIC8vIHdoZW4gYGhlbHBgIGlzIHNldCAoc2VlIGJlbG93KS5cbiAgICAgICAgXCImOmhhcygua2F0ZXgtZGlzcGxheSlcIjoge1xuICAgICAgICAgIG92ZXJmbG93WDogXCJoaWRkZW5cIixcbiAgICAgICAgfSxcblxuICAgICAgICBwOiB7XG4gICAgICAgICAgd29yZEJyZWFrOiBcImJyZWFrLXdvcmRcIixcbiAgICAgICAgICBtYXJnaW5Cb3R0b206IGlzTGFiZWwgPyB0aGVtZS5zcGFjaW5nLm5vbmUgOiBcIlwiLFxuICAgICAgICAgIGZvbnRXZWlnaHQ6IGluaGVyaXRGb250XG4gICAgICAgICAgICA/IFwiaW5oZXJpdFwiXG4gICAgICAgICAgICA6IGJvbGRMYWJlbFxuICAgICAgICAgICAgICA/IHRoZW1lLmZvbnRXZWlnaHRzLmJvbGRcbiAgICAgICAgICAgICAgOiBcIlwiLFxuICAgICAgICAgIG1hcmdpblRvcDogdGhlbWUuc3BhY2luZy5ub25lLFxuICAgICAgICAgIG1hcmdpbkxlZnQ6IHRoZW1lLnNwYWNpbmcubm9uZSxcbiAgICAgICAgICBtYXJnaW5SaWdodDogdGhlbWUuc3BhY2luZy5ub25lLFxuICAgICAgICB9LFxuXG4gICAgICAgIGltZzoge1xuICAgICAgICAgIC8vIEltYWdlcyBpbiBtYXJrZG93biBzaG91bGQgbmV2ZXIgYmUgd2lkZXJcbiAgICAgICAgICAvLyB0aGFuIHRoZSBjb250ZW50IGFyZWEuXG4gICAgICAgICAgbWF4V2lkdGg6IFwiMTAwJVwiLFxuICAgICAgICAgIC8vIEluIGxhYmVscywgd2lkZ2V0cyBzaG91bGQgbmV2ZXIgYmUgdGFsbGVyIHRoYW4gdGhlIHRleHQuXG4gICAgICAgICAgbWF4SGVpZ2h0OiBpc0xhYmVsID8gXCIxZW1cIiA6IHVuZGVmaW5lZCxcbiAgICAgICAgICB2ZXJ0aWNhbEFsaWduOiBcIm1pZGRsZVwiLFxuICAgICAgICAgIC8vIEVuc3VyZSB0aGF0IGltYWdlcyBhcmUgbm90IGRpc3RvcnRlZDpcbiAgICAgICAgICBvYmplY3RGaXQ6IFwic2NhbGUtZG93blwiLFxuICAgICAgICB9LFxuXG4gICAgICAgIGxpOiB7XG4gICAgICAgICAgbWFyZ2luOiBcIjAuMmVtIDAgMC4yZW0gMS4xNWVtXCIsXG4gICAgICAgICAgcGFkZGluZzogXCIwIDAgMCAwLjNlbVwiLFxuICAgICAgICB9LFxuXG4gICAgICAgIFwibGkudGFzay1saXN0LWl0ZW1cIjoge1xuICAgICAgICAgIGxpc3RTdHlsZVR5cGU6IFwibm9uZVwiLFxuICAgICAgICAgIHBhZGRpbmc6IFwiMFwiLFxuICAgICAgICAgIG1hcmdpbkxlZnQ6IFwiMFwiLFxuICAgICAgICAgIFwiaW5wdXRbdHlwZT0nY2hlY2tib3gnXVwiOiB7XG4gICAgICAgICAgICB2ZXJ0aWNhbEFsaWduOiBcIm1pZGRsZVwiLFxuICAgICAgICAgICAgbWFyZ2luOiBcIjAgMC4zNWVtIDAuMWVtIDBcIixcbiAgICAgICAgICB9LFxuICAgICAgICB9LFxuXG4gICAgICAgIC8vIEhhbmRsZXMgcXVvdGVzOlxuICAgICAgICBibG9ja3F1b3RlOiB7XG4gICAgICAgICAgbWFyZ2luOiBcIjFlbSAwIDFlbSAwXCIsXG4gICAgICAgICAgcGFkZGluZzogYDAgMCAwIDAuNzVlbWAsXG4gICAgICAgICAgYm9yZGVyTGVmdDogYDAuMTVlbSBzb2xpZCAke3RoZW1lLmNvbG9ycy5ib3JkZXJDb2xvcn1gLFxuICAgICAgICAgIG9wYWNpdHk6IDAuNixcbiAgICAgICAgfSxcblxuICAgICAgICBcImIsIHN0cm9uZ1wiOiB7XG4gICAgICAgICAgZm9udFdlaWdodDogdGhlbWUuZm9udFdlaWdodHMuYm9sZCxcbiAgICAgICAgfSxcblxuICAgICAgICAvLyBJc3N1ZSAjMTE5NzY6IEhhbmRsZSBib2xkZWQgaW5saW5lIGNvZGVcbiAgICAgICAgXCJiIGNvZGUsIHN0cm9uZyBjb2RlXCI6IHtcbiAgICAgICAgICBmb250V2VpZ2h0OiB0aGVtZS5mb250V2VpZ2h0cy5jb2RlQm9sZCxcbiAgICAgICAgfSxcblxuICAgICAgICAvLyBIYW5kbGVzIHRoZSBob3Jpem9udGFsIGRpdmlkZXI6XG4gICAgICAgIGhyOiB7XG4gICAgICAgICAgbWFyZ2luOiBcIjJlbSAwXCIsXG4gICAgICAgICAgcGFkZGluZzogMCxcbiAgICAgICAgICAvLyBSZXNldCBGaXJlZm94J3MgZ3JheSBjb2xvcjpcbiAgICAgICAgICBjb2xvcjogXCJpbmhlcml0XCIsXG4gICAgICAgICAgYmFja2dyb3VuZENvbG9yOiBcInRyYW5zcGFyZW50XCIsXG4gICAgICAgICAgYm9yZGVyOiBcIm5vbmVcIixcbiAgICAgICAgICBib3JkZXJCb3R0b206IGAke3RoZW1lLnNpemVzLmJvcmRlcldpZHRofSBzb2xpZCAke3RoZW1lLmNvbG9ycy5ib3JkZXJDb2xvcn1gLFxuICAgICAgICAgIC8vIFNldCBjb3JyZWN0IGhlaWdodCBhbmQgcHJldmVudCB0aGUgc2l6ZSBhdHRyaWJ1dGVcbiAgICAgICAgICAvLyB0byBtYWtlIHRoZSBociBsb29rIGxpa2UgYW4gaW5wdXQgZmllbGQ6XG4gICAgICAgICAgXCImOm5vdChbc2l6ZV0pXCI6IHtcbiAgICAgICAgICAgIGhlaWdodDogdGhlbWUuc2l6ZXMuYm9yZGVyV2lkdGgsXG4gICAgICAgICAgfSxcbiAgICAgICAgfSxcblxuICAgICAgICB0YWJsZToge1xuICAgICAgICAgIGRpc3BsYXk6IFwidGFibGVcIixcbiAgICAgICAgICAvLyBQcmV2ZW50IGRvdWJsZSBib3JkZXJzXG4gICAgICAgICAgYm9yZGVyQ29sbGFwc2U6IFwiY29sbGFwc2VcIixcbiAgICAgICAgICBtYXJnaW5Cb3R0b206IHRoZW1lLnNwYWNpbmcubGcsXG4gICAgICAgIH0sXG5cbiAgICAgICAgdHI6IHtcbiAgICAgICAgICBib3JkZXJUb3A6IGAke3RoZW1lLnNpemVzLmJvcmRlcldpZHRofSBzb2xpZCAke3RoZW1lLmNvbG9ycy5kYXRhZnJhbWVCb3JkZXJDb2xvcn1gLFxuICAgICAgICB9LFxuXG4gICAgICAgIHRoOiB7XG4gICAgICAgICAgLy8gVE9ETzogY2hlY2sgd2hldGhlciB0aGlzIHNob3VsZCBiZSBhZGp1c3RlZFxuICAgICAgICAgIC8vIGRlZmF1bHRzIHRvIGZvbnQtd2VpZ2h0OiBcImJvbGRcIiAoNzAwKVxuICAgICAgICAgIHRleHRBbGlnbjogXCJpbmhlcml0XCIsXG4gICAgICAgIH0sXG5cbiAgICAgICAgXCJ0aCwgdGRcIjoge1xuICAgICAgICAgIHBhZGRpbmc6IGAke3RoZW1lLnNwYWNpbmcueHN9ICR7dGhlbWUuc3BhY2luZy5tZH1gLFxuICAgICAgICAgIGJvcmRlcjogYCR7dGhlbWUuc2l6ZXMuYm9yZGVyV2lkdGh9IHNvbGlkICR7dGhlbWUuY29sb3JzLmRhdGFmcmFtZUJvcmRlckNvbG9yfWAsXG4gICAgICAgIH0sXG5cbiAgICAgICAgXCJzcGFuLnN0TWFya2Rvd25Db2xvcmVkQmFja2dyb3VuZFwiOiB7XG4gICAgICAgICAgYm9yZGVyUmFkaXVzOiB0aGVtZS5yYWRpaS5tZCxcbiAgICAgICAgICBwYWRkaW5nOiBgJHt0aGVtZS5zcGFjaW5nLnRocmVlWFN9ICR7dGhlbWUuc3BhY2luZy50d29YU31gLFxuICAgICAgICAgIG1hcmdpbjogdGhlbWUuc3BhY2luZy5ub25lLFxuICAgICAgICAgIGJveERlY29yYXRpb25CcmVhazogXCJjbG9uZVwiLFxuICAgICAgICB9LFxuXG4gICAgICAgIFwic3Bhbi5zdE1hcmtkb3duQmFkZ2VcIjoge1xuICAgICAgICAgIGJvcmRlclJhZGl1czogdGhlbWUucmFkaWkubWQsXG4gICAgICAgICAgLy8gU2luY2Ugd2UncmUgdXNpbmcgaW5saW5lLWJsb2NrIGJlbG93LCB3ZSdyZSBub3QgdXNpbmcgdmVydGljYWwgcGFkZGluZyBoZXJlLFxuICAgICAgICAgIC8vIGJlY2F1c2UgaW5saW5lLWJsb2NrIGFscmVhZHkgbWFrZXMgdGhlIGVsZW1lbnQgbG9vayBhIGJpdCB0YWxsZXIuXG4gICAgICAgICAgcGFkZGluZzogYDAgJHt0aGVtZS5zcGFjaW5nLnR3b1hTfWAsXG4gICAgICAgICAgLy8gQWRkIGEgc21hbGwgbWFyZ2luIHRvIHNlcGFyYXRlIGl0IGEgYml0IGZyb20gb3RoZXIgdGV4dC5cbiAgICAgICAgICBtYXJnaW46IGAwICR7dGhlbWUuc3BhY2luZy5weH1gLFxuXG4gICAgICAgICAgLy8gTWFrZSBiYWRnZXMgbm90IHdyYXAgYW5kIGVsbGlwc2l6ZSB0aGVtIGlmIHRoZXkgYXJlIHRvbyBsb25nIGZvciB0aGVcbiAgICAgICAgICAvLyBwYXJlbnQgY29udGFpbmVyLlxuICAgICAgICAgIHdoaXRlU3BhY2U6IFwibm93cmFwXCIsXG4gICAgICAgICAgb3ZlcmZsb3c6IFwiaGlkZGVuXCIsXG4gICAgICAgICAgdGV4dE92ZXJmbG93OiBcImVsbGlwc2lzXCIsXG4gICAgICAgICAgbWF4V2lkdGg6IFwiMTAwJVwiLFxuICAgICAgICAgIGRpc3BsYXk6IFwiaW5saW5lLWJsb2NrXCIsXG4gICAgICAgICAgdmVydGljYWxBbGlnbjogXCJtaWRkbGVcIixcbiAgICAgICAgfSxcblxuICAgICAgICBcInAsIG9sLCB1bCwgZGwsIGxpXCI6IHtcbiAgICAgICAgICBmb250U2l6ZTogXCJpbmhlcml0XCIsXG4gICAgICAgIH0sXG5cbiAgICAgICAgXCImID4gdWwsICYgPiBvbFwiOiB7XG4gICAgICAgICAgZGlzcGxheTogXCJibG9ja1wiLFxuICAgICAgICAgIHdpZHRoOiBcImZpdC1jb250ZW50XCIsXG4gICAgICAgICAgdGV4dEFsaWduOiBcImxlZnRcIixcbiAgICAgICAgfSxcblxuICAgICAgICAvLyBFbnN1cmUgbmVzdGVkIGxpc3RzIHN0YXkgYXMgYmxvY2sgZWxlbWVudHNcbiAgICAgICAgXCJsaSA+IHVsLCBsaSA+IG9sXCI6IHtcbiAgICAgICAgICBkaXNwbGF5OiBcImJsb2NrXCIsXG4gICAgICAgIH0sXG5cbiAgICAgICAgLy8gQWxsb3cgbG9uZyBMYXRleCBmb3JtdWxhcyB0aGF0IGFyZSBub3QgaW5saW5lIChpLmUuIGVpdGhlciBmcm9tIGBzdC5sYXRleGBcbiAgICAgICAgLy8gb3IgaW4gdGhlaXIgb3duIHBhcmFncmFwaCBpbnNpZGUgYHN0Lm1hcmtkb3duYCkgdG8gc2Nyb2xsIGhvcml6b250YWxseS5cbiAgICAgICAgXCIua2F0ZXgtZGlzcGxheVwiOiB7XG4gICAgICAgICAgb3ZlcmZsb3dYOiBcImF1dG9cIixcbiAgICAgICAgICBvdmVyZmxvd1k6IFwiaGlkZGVuXCIsXG4gICAgICAgIH0sXG5cbiAgICAgICAgXCIua2F0ZXhcIjoge1xuICAgICAgICAgIGZvbnRXZWlnaHQ6IHRoZW1lLmZvbnRXZWlnaHRzLm5vcm1hbCxcbiAgICAgICAgfSxcbiAgICAgIH1cbiAgICB9XG4gIClcblxuZXhwb3J0IGNvbnN0IFN0eWxlZExpbmtJY29uID0gc3R5bGVkLmEoKHsgdGhlbWUgfSkgPT4gKHtcbiAgLy8gY2VudGVyIGljb25cbiAgbGluZUhlaWdodDogMCxcbiAgZGlzcGxheTogXCJpbmxpbmUtZmxleFwiLFxuICBhbGlnbkl0ZW1zOiBcImNlbnRlclwiLFxuICBqdXN0aWZ5Q29udGVudDogXCJjZW50ZXJcIixcblxuICBzdmc6IHtcbiAgICAvLyBzYW1lIGNvbG9yIGFzIHRoZSB0b29sdGlwLWljb25cbiAgICBzdHJva2U6IHRoZW1lLmNvbG9ycy5mYWRlZFRleHQ2MCxcbiAgICBzdHJva2VXaWR0aDogMi4yNSxcbiAgfSxcblxuICBcIiY6aG92ZXIgc3ZnXCI6IHtcbiAgICBzdHJva2U6IHRoZW1lLmNvbG9ycy5ib2R5VGV4dCxcbiAgfSxcbn0pKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkSGVhZGluZ1dpdGhBY3Rpb25FbGVtZW50cyA9IHN0eWxlZC5kaXYoKHsgdGhlbWUgfSkgPT4gKHtcbiAgXCJoMSwgaDIsIGgzLCBoNCwgaDUsIGg2LCBzcGFuXCI6IHtcbiAgICBzY3JvbGxNYXJnaW5Ub3A6IHRoZW1lLnNpemVzLmhlYWRlckhlaWdodCxcbiAgfSxcbiAgLi4uc2hhcmVkTWFya2Rvd25TdHlsZSh0aGVtZSksXG5cbiAgLy8gYnJlYWstd29yZCAmIHByZXR0eSBtYWtlcyBtb3N0IGhlYWRpbmdzIGJyZWFrIGluIGEgbmljZXIgd2F5IHRoYW4gYnJlYWstYWxsIHdoaWxlIHN0aWxsXG4gIC8vIHByZXZlbnRpbmcgb3ZlcmZsb3dpbmcgb2YgdGhlIGNvbnRhaW5lciB0byB0aGUgc2lkZS4gTG9uZyBoZWFkaW5ncyB3aXRob3V0IHdoaXRlc3BhY2VzIG9yIGh5cGhlbnMgbWlnaHQgc3RpbGwgbG9vayB3ZWlyZFxuICB3b3JkQnJlYWs6IFwiYnJlYWstd29yZFwiLFxuICB0ZXh0V3JhcDogXCJwcmV0dHlcIixcblxuICAvLyBzaG93IGxpbmstaWNvbiB3aGVuIGhvdmVyaW5nIHNvbWV3aGVyZSBvdmVyIHRoZSBoZWFkaW5nXG4gIC8vIGVzbGludC1kaXNhYmxlLW5leHQtbGluZSBAdHlwZXNjcmlwdC1lc2xpbnQvbm8tZXhwbGljaXQtYW55IC0tIFRPRE86IFJlcGxhY2UgJ2FueScgd2l0aCBhIG1vcmUgc3BlY2lmaWMgdHlwZS5cbiAgW1N0eWxlZExpbmtJY29uIGFzIGFueV06IHtcbiAgICB2aXNpYmlsaXR5OiBcImhpZGRlblwiLFxuICB9LFxuXG4gIC8vIHdlIGhhdmUgdG8gc2V0IHRoZSBob3ZlciBoZXJlIHNvIHRoYXQgdGhlIGxpbmsgaWNvbiBiZWNvbWVzIHZpc2libGUgd2hlbiBob3ZlcmluZyBhbnl3aGVyZSBvdmVyIHRoZSBoZWFkaW5nXG4gIFwiJjpob3ZlclwiOiB7XG4gICAgLy8gZXNsaW50LWRpc2FibGUtbmV4dC1saW5lIEB0eXBlc2NyaXB0LWVzbGludC9uby1leHBsaWNpdC1hbnkgLS0gVE9ETzogUmVwbGFjZSAnYW55JyB3aXRoIGEgbW9yZSBzcGVjaWZpYyB0eXBlLlxuICAgIFtTdHlsZWRMaW5rSWNvbiBhcyBhbnldOiB7XG4gICAgICB2aXNpYmlsaXR5OiBcInZpc2libGVcIixcbiAgICB9LFxuICB9LFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRIZWFkaW5nQWN0aW9uRWxlbWVudHMgPSBzdHlsZWQuc3BhbigoeyB0aGVtZSB9KSA9PiAoe1xuICBtYXJnaW5MZWZ0OiB0aGVtZS5zcGFjaW5nLnNtLFxuICBkaXNwbGF5OiBcImlubGluZS1mbGV4XCIsXG4gIGdhcDogdGhlbWUuc3BhY2luZy5zbSxcblxuICB2ZXJ0aWNhbEFsaWduOiBcIm1pZGRsZVwiLFxuXG4gIFwiJiA+ICpcIjoge1xuICAgIC8vIHJlbW92ZSBtYXJnaW5zIG9mIGlubmVyIGVsZW1lbnRzIGFzIHRoZXkgYXJlIHdyYXBwZWQgaW4gYSBjb250YWluZXIgdGhhdCBhcHBsaWVzIHRoZSBtYXJnaW5cbiAgICBtYXJnaW5MZWZ0OiBcIjAgIWltcG9ydGFudFwiLFxuICB9LFxufSkpXG5cbmV4cG9ydCBpbnRlcmZhY2UgU3R5bGVkRGl2aWRlclByb3BzIHtcbiAgcmFpbmJvdzogYm9vbGVhblxuICBjb2xvcjogc3RyaW5nXG59XG5cbmV4cG9ydCBjb25zdCBTdHlsZWRIZWFkZXJEaXZpZGVyID0gc3R5bGVkLmhyPFN0eWxlZERpdmlkZXJQcm9wcz4oXG4gICh7IHRoZW1lLCByYWluYm93LCBjb2xvciB9KSA9PiB7XG4gICAgcmV0dXJuIHtcbiAgICAgIC8vIEhlaWdodCBuZWVkcyB0byBiZSAhaW1wb3J0YW50IGR1ZSB0byBnbG9iYWxTdHlsZXMudHN4IGhyIGhlaWdodCBvdmVycmlkZSAtIGxpbmUgIzE3MFxuICAgICAgaGVpZ2h0OiBgJHt0aGVtZS5zcGFjaW5nLnRocmVlWFN9ICFpbXBvcnRhbnRgLFxuICAgICAgbWFyZ2luVG9wOiB0aGVtZS5zcGFjaW5nLnNtLFxuICAgICAgbWFyZ2luQm90dG9tOiB0aGVtZS5zcGFjaW5nLm5vbmUsXG4gICAgICBib3JkZXI6IFwibm9uZVwiLFxuICAgICAgYm9yZGVyUmFkaXVzOiB0aGVtZS5yYWRpaS5mdWxsLFxuICAgICAgLi4uKHJhaW5ib3cgPyB7IGJhY2tncm91bmQ6IGNvbG9yIH0gOiB7IGJhY2tncm91bmRDb2xvcjogY29sb3IgfSksXG4gICAgfVxuICB9XG4pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRQcmVXcmFwcGVyID0gc3R5bGVkLmRpdigoeyB0aGVtZSB9KSA9PiAoe1xuICAvLyBTZXQgc3BhY2luZyBiZXR3ZWVuIHByZS1lbGVtZW50cyBpbnNpZGUgb2YgbWFya2Rvd24gc2ltaWxhciB0byBvdXIgZ2FwIHNwYWNpbmcgYmV0d2VlbiBlbGVtZW50c1xuICBtYXJnaW5Cb3R0b206IHRoZW1lLnNwYWNpbmcubGcsXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZEhlbHBJY29uV3JhcHBlciA9IHN0eWxlZC5zcGFuKHtcbiAgZGlzcGxheTogXCJpbmxpbmUtYmxvY2tcIixcbiAgdmVydGljYWxBbGlnbjogXCJtaWRkbGVcIixcbiAgdHJhbnNmb3JtOiBcInRyYW5zbGF0ZVkoLTAuMWVtKVwiLFxufSlcbiJdfQ== */"), StyledHeaderDivider = /* @__PURE__ */ createStyled("hr", process.env.NODE_ENV === "production" ? {
  target: "e1nzilvr2"
} : {
  target: "e1nzilvr2",
  label: "StyledHeaderDivider"
})(({
  theme: o,
  rainbow: E,
  color: A
}) => ({
  // Height needs to be !important due to globalStyles.tsx hr height override - line #170
  height: `${o.spacing.threeXS} !important`,
  marginTop: o.spacing.sm,
  marginBottom: o.spacing.none,
  border: "none",
  borderRadius: o.radii.full,
  ...E ? {
    background: A
  } : {
    backgroundColor: A
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledPreWrapper = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e1nzilvr1"
} : {
  target: "e1nzilvr1",
  label: "StyledPreWrapper"
})(({
  theme: o
}) => ({
  // Set spacing between pre-elements inside of markdown similar to our gap spacing between elements
  marginBottom: o.spacing.lg
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledHelpIconWrapper = /* @__PURE__ */ createStyled("span", process.env.NODE_ENV === "production" ? {
  target: "e1nzilvr0"
} : {
  target: "e1nzilvr0",
  label: "StyledHelpIconWrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "s36o2q",
  styles: "display:inline-block;vertical-align:middle;transform:translateY(-0.1em)"
} : {
  name: "s36o2q",
  styles: "display:inline-block;vertical-align:middle;transform:translateY(-0.1em)/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$e
}), LOAD_FAILED = Symbol("plugin_load_failed"), pluginCache = {
  katex: null,
  raw: null,
  emoji: null
}, loadingPromises = {
  katex: null,
  raw: null,
  emoji: null
}, loadKatexPlugin = () => import("./index-R0bDPfYF.js"), loadKatexStyles = once$1(() => {
  Promise.resolve().then(() => katex_min);
}), loadRehypeRaw = () => import("./index-BwqdV017.js"), loadRemarkEmoji = () => import("./index-CJA4Tdig.js");
function isLoadedPlugin(o) {
  return o !== null && o !== LOAD_FAILED;
}
function extractPlugin(o, E) {
  const A = [];
  let g = o, e = 0;
  for (; g && typeof g == "object" && "default" in g && e < 5; ) {
    const t = g.default;
    if (A.push(t), t === g)
      break;
    g = t, e += 1;
  }
  A.push(o);
  for (const t of A)
    if (typeof t == "function")
      return t;
  return console.warn(`[StreamlitMarkdown] Failed to load ${E} plugin`), LOAD_FAILED;
}
function wrapRehypePlugin(o, E) {
  return (A) => {
    const g = o(A);
    return (e, t) => {
      if (!e)
        return e;
      try {
        return g(e, t);
      } catch (c) {
        return console.error(`[StreamlitMarkdown] ${E} crashed while transforming`, c), e;
      }
    };
  };
}
function wrapRemarkPlugin(o, E) {
  return (A) => {
    const g = o(A);
    return (e, t) => {
      if (!e)
        return e;
      try {
        return g(e, t);
      } catch (c) {
        return console.error(`[StreamlitMarkdown] ${E} crashed while transforming`, c), e;
      }
    };
  };
}
function useLazyPlugin(o) {
  const {
    key: E,
    needed: A,
    load: g,
    pluginName: e,
    onBeforeLoad: t
  } = o, c = A ? pluginCache[E] : null, [n, h] = useState(null);
  return useEffect(() => {
    if (!A || c || n)
      return;
    const d = loadingPromises[E];
    if (d) {
      let M = !1;
      return d.then((S) => {
        M || h(() => S);
      }), () => {
        M = !0;
      };
    }
    t?.();
    let k = !1;
    const p = g().then((M) => extractPlugin(M, e)).then((M) => (pluginCache[E] = M, k || h(() => M), M)).catch(() => {
      const M = LOAD_FAILED;
      return pluginCache[E] = M, k || h(() => M), M;
    }).finally(() => {
      loadingPromises[E] = null;
    });
    return loadingPromises[E] = p, () => {
      k = !0;
    };
  }, [A, c, n, E, g, e, t]), A ? c ?? n : null;
}
const StreamlitSyntaxHighlighter$1 = lazy(() => import("./StreamlitSyntaxHighlighter-DSYWFRjz.js"));
function containsEmojiShortcodes(o) {
  return /:(?!material\/|streamlit:)[\w+-][\w_+-]*:/.test(o);
}
function containsMathSyntax(o) {
  return new RegExp("\\$\\$[\\s\\S]+?\\$\\$|\\$(?!\\s)[^$\\n]+?(?<!\\s)\\$").test(o);
}
var Tags = /* @__PURE__ */ ((o) => (o.H1 = "h1", o.H2 = "h2", o.H3 = "h3", o))(Tags || {});
function rehypeSetCodeInlineProperty() {
  return (o) => {
    visit(o, "element", (E, A, g) => {
      E.tagName === "code" && (g?.type === "element" && g.tagName === "pre" ? E.properties = {
        ...E.properties,
        inline: !1
      } : E.properties = {
        ...E.properties,
        inline: !0
      });
    });
  };
}
function createAnchorFromText(o) {
  if (!o)
    return "";
  const E = slugify(o);
  return E.length > 0 ? E : xxhash.h32(o, 43981).toString(16);
}
function transformLinkUri(o) {
  return o;
}
const scrollNodeIntoView = once$1((o) => {
  o.scrollIntoView(!0);
}), HeaderActionElements = ({
  elementId: o,
  help: E,
  hideAnchor: A
}) => {
  const g = useEmotionTheme();
  return !E && A ? /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {}) : /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledHeadingActionElements, { "data-testid": "stHeaderActionElements", children: [
    E && /* @__PURE__ */ jsxRuntimeExports.jsx(InlineTooltipIcon, { content: E }),
    o && !A && /* @__PURE__ */ jsxRuntimeExports.jsx(StyledLinkIcon, { href: `#${o}`, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Link2, { size: convertRemToPx(g.iconSizes.base) }) })
  ] });
}, HeadingWithActionElements = ({
  tag: o,
  anchor: E,
  help: A,
  hideAnchor: g,
  children: e,
  tagProps: t
}) => {
  const c = useContext(IsSidebarContext), n = useContext(IsDialogContext), [h, d] = useState(E), k = useCallback((gA) => {
    if (gA === null)
      return;
    const CA = E || createAnchorFromText(gA.textContent);
    d(CA);
    const IA = window.location.hash.slice(1);
    IA && IA === CA && scrollNodeIntoView(gA);
  }, [E]), p = c || n, M = /* @__PURE__ */ jsxRuntimeExports.jsx(HeaderActionElements, { elementId: h, help: A, hideAnchor: g || p }), S = p ? {} : {
    ref: k,
    id: h
  }, AA = o, H = /* @__PURE__ */ jsxRuntimeExports.jsxs(AA, { ...t, ...S, children: [
    e,
    M
  ] });
  return p ? H : /* @__PURE__ */ jsxRuntimeExports.jsx(StyledHeadingWithActionElements, { "data-testid": "stHeadingWithActionElements", children: H });
}, CustomHeading = ({
  node: o,
  children: E,
  ...A
}) => {
  const g = A["data-anchor"];
  return /* @__PURE__ */ jsxRuntimeExports.jsx(HeadingWithActionElements, { tag: o.tagName, anchor: g, tagProps: A, children: E });
}, CustomCodeTag = ({
  inline: o,
  className: E,
  children: A,
  ...g
}) => {
  const e = /language-(\w+)/.exec(E || ""), t = String(A ?? "").replace(/^\n/, "").replace(/\n$/, ""), c = e?.[1] || "";
  return o ? /* @__PURE__ */ jsxRuntimeExports.jsx(StyledInlineCode, { className: E, ...omit(g, "node"), children: A }) : /* @__PURE__ */ jsxRuntimeExports.jsx(ErrorBoundary, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Suspense, { fallback: /* @__PURE__ */ jsxRuntimeExports.jsx(Skeleton, { element: Skeleton$1.create({
    style: Skeleton$1.SkeletonStyle.ELEMENT
  }) }), children: /* @__PURE__ */ jsxRuntimeExports.jsx(StreamlitSyntaxHighlighter$1, { language: c, showLineNumbers: !1, children: t }) }) });
}, CustomPreTag = ({
  children: o
}) => /* @__PURE__ */ jsxRuntimeExports.jsx(StyledPreWrapper, { "data-testid": "stMarkdownPre", children: o }), CustomMediaTag = ({
  node: o,
  ...E
}) => {
  const A = useCrossOriginAttribute(E.src), g = o.tagName, e = {
    ...E,
    crossOrigin: A
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(g, { ...e });
}, HelpTextContext = React__default.createContext(void 0);
HelpTextContext.displayName = "HelpTextContext";
const CustomHelpIcon = ({
  children: o
}) => {
  const A = useContext(HelpTextContext) || (typeof o == "string" ? o : "");
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledHelpIconWrapper, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(InlineTooltipIcon, { content: A }) });
}, BASE_RENDERERS = {
  pre: CustomPreTag,
  code: CustomCodeTag,
  h1: CustomHeading,
  h2: CustomHeading,
  h3: CustomHeading,
  h4: CustomHeading,
  h5: CustomHeading,
  h6: CustomHeading,
  img: CustomMediaTag,
  video: CustomMediaTag,
  audio: CustomMediaTag,
  "streamlit-help-icon": CustomHelpIcon
};
function createColorMapping(o) {
  const {
    red: E,
    orange: A,
    yellow: g,
    green: e,
    blue: t,
    violet: c,
    purple: n,
    gray: h,
    primary: d
  } = getMarkdownTextColors(o), {
    redbg: k,
    orangebg: p,
    yellowbg: M,
    greenbg: S,
    bluebg: AA,
    violetbg: H,
    purplebg: gA,
    graybg: CA,
    primarybg: IA
  } = getMarkdownBgColors(o);
  return new Map(Object.entries({
    red: `color: ${E}`,
    orange: `color: ${A}`,
    yellow: `color: ${g}`,
    blue: `color: ${t}`,
    green: `color: ${e}`,
    violet: `color: ${c}`,
    gray: `color: ${h}`,
    grey: `color: ${h}`,
    primary: `color: ${d}`,
    // Gradient from red, orange, yellow, green, blue, violet, purple
    rainbow: `color: transparent; background-clip: text; -webkit-background-clip: text; background-image: linear-gradient(to right,
        ${E}, ${A}, ${g}, ${e}, ${t}, ${c}, ${n});`,
    "red-background": `background-color: ${k}`,
    "orange-background": `background-color: ${p}`,
    "yellow-background": `background-color: ${M}`,
    "blue-background": `background-color: ${AA}`,
    "green-background": `background-color: ${S}`,
    "violet-background": `background-color: ${H}`,
    "gray-background": `background-color: ${CA}`,
    "grey-background": `background-color: ${CA}`,
    "primary-background": `background-color: ${IA}`,
    // Gradient from red, orange, yellow, green, blue, violet, purple
    "rainbow-background": `background: linear-gradient(to right,
        ${k}, ${p}, ${M}, ${S}, ${AA}, ${H}, ${gA});`
  }));
}
function createRemarkHelpIcon() {
  return () => (o) => (visit(o, "textDirective", (E, A, g) => {
    if (String(E.name) === "help") {
      const t = E.data || (E.data = {});
      t.hName = "streamlit-help-icon", t.hProperties = t.hProperties || {};
      return;
    }
  }), o);
}
function createRemarkColoringAndSmall(o, E) {
  return () => (A) => (visit(A, "textDirective", (g, e, t) => {
    const c = String(g.name);
    if (c === "small") {
      const h = g.data || (g.data = {});
      h.hName = "span", h.hProperties = h.hProperties || {}, h.hProperties.style = `font-size: ${o.fontSizes.sm};`;
      return;
    }
    const n = c.match(/^(.+)-badge$/);
    if (n && E.has(n[1])) {
      const h = n[1];
      if (h === "rainbow")
        return;
      const d = E.get(h), k = E.get(`${h}-background`);
      if (d && k) {
        const p = g.data || (g.data = {});
        p.hName = "span", p.hProperties = p.hProperties || {}, p.hProperties.className = "stMarkdownBadge", p.hProperties.style = `${k}; ${d}; font-size: ${o.fontSizes.sm};`;
        return;
      }
    }
    if (E.has(c)) {
      const h = g.data || (g.data = {}), d = E.get(c);
      h.hName = "span", h.hProperties = h.hProperties || {}, h.hProperties.style = d, h.hProperties.className = "stMarkdownColoredText", d && (/background-color:/.test(d) || /background:/.test(d)) && (h.hProperties.className = "stMarkdownColoredBackground");
      return;
    }
    g.data?.hName || (g.type = "text", g.value = `:${c}`, g.data = {});
  }), A);
}
function createRemarkMaterialIcons(o) {
  return () => (E) => {
    function A(g, e) {
      return {
        type: "text",
        value: g,
        data: {
          hName: "span",
          hProperties: {
            role: "img",
            ariaLabel: e + " icon",
            // Prevent the icon text from being translated
            // this would break the icon display in the UI.
            // https://github.com/streamlit/streamlit/issues/10168
            translate: "no",
            // We need to use string-style CSS here so that it works
            // correctly with the rehype-raw plugin.
            style: `
            display: inline-block;
            font-family: ${o.genericFonts.iconFont};
            font-weight: ${o.fontWeights.normal};
            user-select: none;
            vertical-align: bottom;
            white-space: nowrap;
            word-wrap: normal;
            `
          },
          hChildren: [{
            type: "text",
            value: e
          }]
        }
      };
    }
    return findAndReplace(E, [[/:material_(\w+):/g, A]]), E;
  };
}
function createRemarkStreamlitLogo() {
  return () => (o) => {
    function E() {
      return {
        type: "text",
        value: "",
        data: {
          hName: "img",
          hProperties: {
            src: streamlitLogo,
            alt: "Streamlit logo",
            // We need to use string-style CSS here so that it works
            // correctly with the rehype-raw plugin.
            // The base of the Streamlit logo is curved, so move it down a bit to
            // make it look aligned with the text.
            style: "display: inline-block; user-select: none; height: 0.75em; vertical-align: baseline; margin-bottom: -0.05ex;"
          }
        }
      };
    }
    return findAndReplace(o, [[/:streamlit:/g, E]]), o;
  };
}
function createRemarkTypographicalSymbols() {
  return () => (o) => (visit(o, (E, A, g) => {
    if (!(g && (g.type === "link" || g.type === "linkReference")) && E.type === "text" && E.value) {
      const e = [[/(^|\s)<->(\s|$)/g, "$1↔$2"], [/(^|\s)->(\s|$)/g, "$1→$2"], [/(^|\s)<-(\s|$)/g, "$1←$2"], [/(^|\s)--(\s|$)/g, "$1—$2"], [/(^|\s)>=(\s|$)/g, "$1≥$2"], [/(^|\s)<=(\s|$)/g, "$1≤$2"], [/(^|\s)~=(\s|$)/g, "$1≈$2"]];
      let t = E.value;
      for (const [c, n] of e)
        t = t.replace(c, n);
      t !== E.value && (E.value = t);
    }
  }), o);
}
const BASE_REMARK_PLUGINS = [remarkMath, remarkGfm, remarkDirective, createRemarkHelpIcon(), createRemarkStreamlitLogo(), createRemarkTypographicalSymbols()], LABEL_DISALLOWED_ELEMENTS = [
  // Restricts table elements, headings, unordered/ordered lists, task lists, horizontal rules, & blockquotes
  // Note that images are allowed but have a max height equal to the text height
  "table",
  "thead",
  "tbody",
  "tr",
  "th",
  "td",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "ul",
  "ol",
  "li",
  "input",
  "hr",
  "blockquote"
], LINKS_DISALLOWED_ELEMENTS = [...LABEL_DISALLOWED_ELEMENTS, "a"];
function LinkWithTargetBlank(o) {
  const {
    href: E
  } = o;
  if (E?.startsWith("#")) {
    const {
      children: n,
      ...h
    } = o;
    return /* @__PURE__ */ jsxRuntimeExports.jsx("a", { ...omit(h, "node"), children: n });
  }
  const {
    title: A,
    children: g,
    target: e,
    rel: t,
    ...c
  } = o;
  return /* @__PURE__ */ jsxRuntimeExports.jsx("a", { href: E, title: A, target: e || "_blank", rel: t || "noopener noreferrer", ...omit(c, "node"), children: g });
}
const RenderedMarkdown = memo(function o({
  allowHTML: E,
  source: A,
  overrideComponents: g,
  isLabel: e,
  disableLinks: t,
  helpText: c
}) {
  const n = useEmotionTheme(), h = useMemo$1(() => containsMathSyntax(A), [A]), d = useMemo$1(() => containsEmojiShortcodes(A), [A]), k = useLazyPlugin({
    key: "katex",
    needed: h,
    load: loadKatexPlugin,
    pluginName: "rehype-katex",
    onBeforeLoad: loadKatexStyles
  }), p = useLazyPlugin({
    key: "raw",
    needed: E,
    load: loadRehypeRaw,
    pluginName: "rehype-raw"
  }), M = useLazyPlugin({
    key: "emoji",
    needed: d,
    load: loadRemarkEmoji,
    pluginName: "remark-emoji"
  }), S = useMemo$1(() => createColorMapping(n), [n]), AA = useMemo$1(() => isLoadedPlugin(k) ? wrapRehypePlugin(k, "rehype-katex") : null, [k]), H = useMemo$1(() => isLoadedPlugin(p) ? wrapRehypePlugin(p, "rehype-raw") : null, [p]), gA = useMemo$1(() => isLoadedPlugin(M) ? (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- unified's Plugin type is more complex than our wrapper expects
    wrapRemarkPlugin(M, "remark-emoji")
  ) : null, [M]), CA = useMemo$1(() => {
    const iA = [...BASE_REMARK_PLUGINS, createRemarkColoringAndSmall(n, S), createRemarkMaterialIcons(n)];
    return d && gA && iA.push(gA), iA;
  }, [n, S, d, gA]), IA = useMemo$1(() => {
    const iA = [];
    return h && AA && iA.push(AA), E && H && iA.push(H), iA.push(rehypeSetCodeInlineProperty), iA;
  }, [E, h, AA, H]), BA = useMemo$1(() => ({
    ...BASE_RENDERERS,
    a: LinkWithTargetBlank,
    ...g || {}
  }), [g]), QA = useMemo$1(() => A.replaceAll(":material/", ":material_"), [A]), EA = useMemo$1(() => e ? t ? LINKS_DISALLOWED_ELEMENTS : LABEL_DISALLOWED_ELEMENTS : [], [e, t]);
  return h && k === null || E && p === null || d && M === null ? /* @__PURE__ */ jsxRuntimeExports.jsx(ErrorBoundary, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Skeleton, { element: Skeleton$1.create({
    style: Skeleton$1.SkeletonStyle.ELEMENT
  }) }) }) : /* @__PURE__ */ jsxRuntimeExports.jsx(HelpTextContext.Provider, { value: c, children: /* @__PURE__ */ jsxRuntimeExports.jsx(ErrorBoundary, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    Markdown$2,
    {
      remarkPlugins: CA,
      rehypePlugins: IA,
      components: BA,
      urlTransform: transformLinkUri,
      disallowedElements: EA,
      unwrapDisallowed: !0,
      children: QA
    }
  ) }) });
}), StreamlitMarkdown = ({
  source: o,
  allowHTML: E,
  style: A,
  isCaption: g,
  isLabel: e,
  boldLabel: t,
  largerLabel: c,
  disableLinks: n,
  isToast: h,
  inheritFont: d,
  helpText: k
}) => {
  const p = useContext(IsDialogContext);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledStreamlitMarkdown, { isCaption: !!g, isInDialog: p, isLabel: e, inheritFont: d, boldLabel: t, largerLabel: c, isToast: h, style: A, "data-testid": g ? "stCaptionContainer" : "stMarkdownContainer", children: /* @__PURE__ */ jsxRuntimeExports.jsx(RenderedMarkdown, { source: o, allowHTML: E, isLabel: e, disableLinks: n, helpText: k }) });
}, StreamlitMarkdown$1 = memo(StreamlitMarkdown), isff = typeof navigator < "u" ? navigator.userAgent.toLowerCase().indexOf("firefox") > 0 : !1;
function addEvent(o, E, A, g) {
  o.addEventListener ? o.addEventListener(E, A, g) : o.attachEvent && o.attachEvent("on".concat(E), A);
}
function removeEvent(o, E, A, g) {
  o.removeEventListener ? o.removeEventListener(E, A, g) : o.detachEvent && o.detachEvent("on".concat(E), A);
}
function getMods(o, E) {
  const A = E.slice(0, E.length - 1);
  for (let g = 0; g < A.length; g++) A[g] = o[A[g].toLowerCase()];
  return A;
}
function getKeys(o) {
  typeof o != "string" && (o = ""), o = o.replace(/\s/g, "");
  const E = o.split(",");
  let A = E.lastIndexOf("");
  for (; A >= 0; )
    E[A - 1] += ",", E.splice(A, 1), A = E.lastIndexOf("");
  return E;
}
function compareArray(o, E) {
  const A = o.length >= E.length ? o : E, g = o.length >= E.length ? E : o;
  let e = !0;
  for (let t = 0; t < A.length; t++)
    g.indexOf(A[t]) === -1 && (e = !1);
  return e;
}
const _keyMap = {
  backspace: 8,
  "⌫": 8,
  tab: 9,
  clear: 12,
  enter: 13,
  "↩": 13,
  return: 13,
  esc: 27,
  escape: 27,
  space: 32,
  left: 37,
  up: 38,
  right: 39,
  down: 40,
  /// https://w3c.github.io/uievents/#events-keyboard-key-location
  arrowup: 38,
  arrowdown: 40,
  arrowleft: 37,
  arrowright: 39,
  del: 46,
  delete: 46,
  ins: 45,
  insert: 45,
  home: 36,
  end: 35,
  pageup: 33,
  pagedown: 34,
  capslock: 20,
  num_0: 96,
  num_1: 97,
  num_2: 98,
  num_3: 99,
  num_4: 100,
  num_5: 101,
  num_6: 102,
  num_7: 103,
  num_8: 104,
  num_9: 105,
  num_multiply: 106,
  num_add: 107,
  num_enter: 108,
  num_subtract: 109,
  num_decimal: 110,
  num_divide: 111,
  "⇪": 20,
  ",": 188,
  ".": 190,
  "/": 191,
  "`": 192,
  "-": isff ? 173 : 189,
  "=": isff ? 61 : 187,
  ";": isff ? 59 : 186,
  "'": 222,
  "{": 219,
  "}": 221,
  "[": 219,
  "]": 221,
  "\\": 220
}, _modifier = {
  // shiftKey
  "⇧": 16,
  shift: 16,
  // altKey
  "⌥": 18,
  alt: 18,
  option: 18,
  // ctrlKey
  "⌃": 17,
  ctrl: 17,
  control: 17,
  // metaKey
  "⌘": 91,
  cmd: 91,
  meta: 91,
  command: 91
}, modifierMap = {
  16: "shiftKey",
  18: "altKey",
  17: "ctrlKey",
  91: "metaKey",
  shiftKey: 16,
  ctrlKey: 17,
  altKey: 18,
  metaKey: 91
}, _mods = {
  16: !1,
  18: !1,
  17: !1,
  91: !1
}, _handlers = {};
for (let o = 1; o < 20; o++)
  _keyMap["f".concat(o)] = 111 + o;
let _downKeys = [], winListendFocus = null, _scope = "all";
const elementEventMap = /* @__PURE__ */ new Map(), code = (o) => _keyMap[o.toLowerCase()] || _modifier[o.toLowerCase()] || o.toUpperCase().charCodeAt(0), getKey = (o) => Object.keys(_keyMap).find((E) => _keyMap[E] === o), getModifier = (o) => Object.keys(_modifier).find((E) => _modifier[E] === o);
function setScope(o) {
  _scope = o || "all";
}
function getScope() {
  return _scope || "all";
}
function getPressedKeyCodes() {
  return _downKeys.slice(0);
}
function getPressedKeyString() {
  return _downKeys.map((o) => getKey(o) || getModifier(o) || String.fromCharCode(o));
}
function getAllKeyCodes() {
  const o = [];
  return Object.keys(_handlers).forEach((E) => {
    _handlers[E].forEach((A) => {
      let {
        key: g,
        scope: e,
        mods: t,
        shortcut: c
      } = A;
      o.push({
        scope: e,
        shortcut: c,
        mods: t,
        keys: g.split("+").map((n) => code(n))
      });
    });
  }), o;
}
function filter$2(o) {
  const E = o.target || o.srcElement, {
    tagName: A
  } = E;
  let g = !0;
  const e = A === "INPUT" && !["checkbox", "radio", "range", "button", "file", "reset", "submit", "color"].includes(E.type);
  return (E.isContentEditable || (e || A === "TEXTAREA" || A === "SELECT") && !E.readOnly) && (g = !1), g;
}
function isPressed(o) {
  return typeof o == "string" && (o = code(o)), _downKeys.indexOf(o) !== -1;
}
function deleteScope(o, E) {
  let A, g;
  o || (o = getScope());
  for (const e in _handlers)
    if (Object.prototype.hasOwnProperty.call(_handlers, e))
      for (A = _handlers[e], g = 0; g < A.length; )
        A[g].scope === o ? A.splice(g, 1).forEach((c) => {
          let {
            element: n
          } = c;
          return removeKeyEvent(n);
        }) : g++;
  getScope() === o && setScope(E || "all");
}
function clearModifier(o) {
  let E = o.keyCode || o.which || o.charCode;
  o.key && o.key.toLowerCase() === "capslock" && (E = code(o.key));
  const A = _downKeys.indexOf(E);
  if (A >= 0 && _downKeys.splice(A, 1), o.key && o.key.toLowerCase() === "meta" && _downKeys.splice(0, _downKeys.length), (E === 93 || E === 224) && (E = 91), E in _mods) {
    _mods[E] = !1;
    for (const g in _modifier) _modifier[g] === E && (hotkeys[g] = !1);
  }
}
function unbind(o) {
  if (typeof o > "u")
    Object.keys(_handlers).forEach((e) => {
      Array.isArray(_handlers[e]) && _handlers[e].forEach((t) => eachUnbind(t)), delete _handlers[e];
    }), removeKeyEvent(null);
  else if (Array.isArray(o))
    o.forEach((e) => {
      e.key && eachUnbind(e);
    });
  else if (typeof o == "object")
    o.key && eachUnbind(o);
  else if (typeof o == "string") {
    for (var E = arguments.length, A = new Array(E > 1 ? E - 1 : 0), g = 1; g < E; g++)
      A[g - 1] = arguments[g];
    let [e, t] = A;
    typeof e == "function" && (t = e, e = ""), eachUnbind({
      key: o,
      scope: e,
      method: t,
      splitKey: "+"
    });
  }
}
const eachUnbind = (o) => {
  let {
    key: E,
    scope: A,
    method: g,
    splitKey: e = "+"
  } = o;
  getKeys(E).forEach((c) => {
    const n = c.split(e), h = n.length, d = n[h - 1], k = d === "*" ? "*" : code(d);
    if (!_handlers[k]) return;
    A || (A = getScope());
    const p = h > 1 ? getMods(_modifier, n) : [], M = [];
    _handlers[k] = _handlers[k].filter((S) => {
      const H = (g ? S.method === g : !0) && S.scope === A && compareArray(S.mods, p);
      return H && M.push(S.element), !H;
    }), M.forEach((S) => removeKeyEvent(S));
  });
};
function eventHandler(o, E, A, g) {
  if (E.element !== g)
    return;
  let e;
  if (E.scope === A || E.scope === "all") {
    e = E.mods.length > 0;
    for (const t in _mods)
      Object.prototype.hasOwnProperty.call(_mods, t) && (!_mods[t] && E.mods.indexOf(+t) > -1 || _mods[t] && E.mods.indexOf(+t) === -1) && (e = !1);
    (E.mods.length === 0 && !_mods[16] && !_mods[18] && !_mods[17] && !_mods[91] || e || E.shortcut === "*") && (E.keys = [], E.keys = E.keys.concat(_downKeys), E.method(o, E) === !1 && (o.preventDefault ? o.preventDefault() : o.returnValue = !1, o.stopPropagation && o.stopPropagation(), o.cancelBubble && (o.cancelBubble = !0)));
  }
}
function dispatch(o, E) {
  const A = _handlers["*"];
  let g = o.keyCode || o.which || o.charCode;
  if (o.key && o.key.toLowerCase() === "capslock" || !hotkeys.filter.call(this, o)) return;
  if ((g === 93 || g === 224) && (g = 91), _downKeys.indexOf(g) === -1 && g !== 229 && _downKeys.push(g), ["metaKey", "ctrlKey", "altKey", "shiftKey"].forEach((n) => {
    const h = modifierMap[n];
    o[n] && _downKeys.indexOf(h) === -1 ? _downKeys.push(h) : !o[n] && _downKeys.indexOf(h) > -1 ? _downKeys.splice(_downKeys.indexOf(h), 1) : n === "metaKey" && o[n] && (_downKeys = _downKeys.filter((d) => d in modifierMap || d === g));
  }), g in _mods) {
    _mods[g] = !0;
    for (const n in _modifier)
      if (Object.prototype.hasOwnProperty.call(_modifier, n)) {
        const h = modifierMap[_modifier[n]];
        hotkeys[n] = o[h];
      }
    if (!A) return;
  }
  for (const n in _mods)
    Object.prototype.hasOwnProperty.call(_mods, n) && (_mods[n] = o[modifierMap[n]]);
  o.getModifierState && !(o.altKey && !o.ctrlKey) && o.getModifierState("AltGraph") && (_downKeys.indexOf(17) === -1 && _downKeys.push(17), _downKeys.indexOf(18) === -1 && _downKeys.push(18), _mods[17] = !0, _mods[18] = !0);
  const e = getScope();
  if (A)
    for (let n = 0; n < A.length; n++)
      A[n].scope === e && (o.type === "keydown" && A[n].keydown || o.type === "keyup" && A[n].keyup) && eventHandler(o, A[n], e, E);
  if (!(g in _handlers)) return;
  const t = _handlers[g], c = t.length;
  for (let n = 0; n < c; n++)
    if ((o.type === "keydown" && t[n].keydown || o.type === "keyup" && t[n].keyup) && t[n].key) {
      const h = t[n], {
        splitKey: d
      } = h, k = h.key.split(d), p = [];
      for (let M = 0; M < k.length; M++)
        p.push(code(k[M]));
      p.sort().join("") === _downKeys.sort().join("") && eventHandler(o, h, e, E);
    }
}
function hotkeys(o, E, A) {
  _downKeys = [];
  const g = getKeys(o);
  let e = [], t = "all", c = document, n = 0, h = !1, d = !0, k = "+", p = !1, M = !1;
  for (A === void 0 && typeof E == "function" && (A = E), Object.prototype.toString.call(E) === "[object Object]" && (E.scope && (t = E.scope), E.element && (c = E.element), E.keyup && (h = E.keyup), E.keydown !== void 0 && (d = E.keydown), E.capture !== void 0 && (p = E.capture), typeof E.splitKey == "string" && (k = E.splitKey), E.single === !0 && (M = !0)), typeof E == "string" && (t = E), M && unbind(o, t); n < g.length; n++)
    o = g[n].split(k), e = [], o.length > 1 && (e = getMods(_modifier, o)), o = o[o.length - 1], o = o === "*" ? "*" : code(o), o in _handlers || (_handlers[o] = []), _handlers[o].push({
      keyup: h,
      keydown: d,
      scope: t,
      mods: e,
      shortcut: g[n],
      method: A,
      key: g[n],
      splitKey: k,
      element: c
    });
  if (typeof c < "u" && window) {
    if (!elementEventMap.has(c)) {
      const S = function() {
        let H = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window.event;
        return dispatch(H, c);
      }, AA = function() {
        let H = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window.event;
        dispatch(H, c), clearModifier(H);
      };
      elementEventMap.set(c, {
        keydownListener: S,
        keyupListenr: AA,
        capture: p
      }), addEvent(c, "keydown", S, p), addEvent(c, "keyup", AA, p);
    }
    if (!winListendFocus) {
      const S = () => {
        _downKeys = [];
      };
      winListendFocus = {
        listener: S,
        capture: p
      }, addEvent(window, "focus", S, p);
    }
  }
}
function trigger(o) {
  let E = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "all";
  Object.keys(_handlers).forEach((A) => {
    _handlers[A].filter((e) => e.scope === E && e.shortcut === o).forEach((e) => {
      e && e.method && e.method();
    });
  });
}
function removeKeyEvent(o) {
  const E = Object.values(_handlers).flat();
  if (E.findIndex((g) => {
    let {
      element: e
    } = g;
    return e === o;
  }) < 0) {
    const {
      keydownListener: g,
      keyupListenr: e,
      capture: t
    } = elementEventMap.get(o) || {};
    g && e && (removeEvent(o, "keyup", e, t), removeEvent(o, "keydown", g, t), elementEventMap.delete(o));
  }
  if ((E.length <= 0 || elementEventMap.size <= 0) && (Object.keys(elementEventMap).forEach((e) => {
    const {
      keydownListener: t,
      keyupListenr: c,
      capture: n
    } = elementEventMap.get(e) || {};
    t && c && (removeEvent(e, "keyup", c, n), removeEvent(e, "keydown", t, n), elementEventMap.delete(e));
  }), elementEventMap.clear(), Object.keys(_handlers).forEach((e) => delete _handlers[e]), winListendFocus)) {
    const {
      listener: e,
      capture: t
    } = winListendFocus;
    removeEvent(window, "focus", e, t), winListendFocus = null;
  }
}
const _api = {
  getPressedKeyString,
  setScope,
  getScope,
  deleteScope,
  getPressedKeyCodes,
  getAllKeyCodes,
  isPressed,
  filter: filter$2,
  trigger,
  unbind,
  keyMap: _keyMap,
  modifier: _modifier,
  modifierMap
};
for (const o in _api)
  Object.prototype.hasOwnProperty.call(_api, o) && (hotkeys[o] = _api[o]);
if (typeof window < "u") {
  const o = window.hotkeys;
  hotkeys.noConflict = (E) => (E && window.hotkeys === hotkeys && (window.hotkeys = o), hotkeys), window.hotkeys = hotkeys;
}
const EDITABLE_TAGS = /* @__PURE__ */ new Set(["INPUT", "TEXTAREA", "SELECT"]), MODIFIER_TOKENS = /* @__PURE__ */ new Set(["ctrl", "cmd", "alt", "shift", "mod"]), SYSTEM_MODIFIERS = /* @__PURE__ */ new Set(["ctrl", "cmd", "alt", "mod"]), MODIFIER_ORDER = ["ctrl", "cmd", "alt", "shift", "mod"], MODIFIER_DISPLAY = {
  ctrl: "Ctrl",
  cmd: "⌘",
  alt: "Alt",
  shift: "Shift",
  mod: "Mod"
  // Placeholder, will be replaced by getModifierLabel
}, KEY_DISPLAY = {
  enter: "Enter",
  space: "Space",
  tab: "Tab",
  escape: "Esc",
  backspace: "Backspace",
  delete: "Delete",
  home: "Home",
  end: "End",
  pageup: "PageUp",
  pagedown: "PageDown",
  left: "←",
  right: "→",
  up: "↑",
  down: "↓"
}, NAVIGATION_KEYS = /* @__PURE__ */ new Set(["left", "right", "up", "down", "home", "end", "pageup", "pagedown", "backspace", "delete"]);
let filterConfigured = !1;
function getEditableEventTarget(o) {
  const E = o.composedPath?.();
  if (E?.length) {
    for (const g of E) {
      const e = g;
      if (e?.tagName && (EDITABLE_TAGS.has(e.tagName) || // Some environments (e.g. jsdom) expose contentEditable primarily via
      // the attribute, so we explicitly check both the property and the
      // attribute to reliably detect editable hosts.
      e.isContentEditable || e.getAttribute("contenteditable") === "true"))
        return e;
    }
    return null;
  }
  const A = o.target || o.srcElement;
  return A?.tagName && (EDITABLE_TAGS.has(A.tagName) || A.isContentEditable || A.getAttribute("contenteditable") === "true") ? A : null;
}
function isKeyboardEventFromEditableTarget(o) {
  return o ? !!getEditableEventTarget(o) : !1;
}
function ensureHotkeysFilterConfigured() {
  filterConfigured || (hotkeys.filter = (o) => {
    if (!getEditableEventTarget(o) || o.key === "Escape" || o.ctrlKey || o.metaKey || o.altKey)
      return !0;
    if (o.shiftKey) {
      const A = o.key ?? "";
      if (A.length > 1 && !/^[a-z0-9]$/i.test(A))
        return !0;
    }
    return !1;
  }, filterConfigured = !0);
}
function parseShortcutString(o) {
  if (!o)
    return;
  const E = o.split("+").map((e) => e.trim().toLowerCase()).filter(Boolean);
  if (E.length === 0)
    return;
  let A;
  for (let e = E.length - 1; e >= 0; e -= 1) {
    const t = E[e];
    if (!MODIFIER_TOKENS.has(t)) {
      A = t;
      break;
    }
  }
  const g = E.some((e) => SYSTEM_MODIFIERS.has(e));
  return {
    tokens: E,
    baseKey: A,
    hasSystemModifier: g
  };
}
function shouldBlockShortcutInInput(o, E) {
  if (!getEditableEventTarget(E) || o.hasSystemModifier)
    return !1;
  const g = o.baseKey;
  return !!(!g || g.length === 1 && /^[a-z0-9]$/i.test(g) || g === "space" || g === "tab" || g === "enter" || NAVIGATION_KEYS.has(g));
}
function toHotkeysSequenceFromTokens(o) {
  return o.map((E) => E === "cmd" ? "command" : E).join("+");
}
function buildSequences(o) {
  if (!o)
    return [];
  const {
    tokens: E
  } = o, g = isFromMac() ? "cmd" : "ctrl", e = E.map((c) => c === "cmd" || c === "ctrl" || c === "mod" ? g : c), t = Array.from(new Set(e));
  return [toHotkeysSequenceFromTokens(t)];
}
function getModifierLabel(o, E) {
  return o === "cmd" || o === "ctrl" || o === "mod" ? E ? MODIFIER_DISPLAY.cmd : MODIFIER_DISPLAY.ctrl : o === "alt" && E ? "⌥" : MODIFIER_DISPLAY[o];
}
function getKeyLabel(o) {
  return KEY_DISPLAY[o] ? KEY_DISPLAY[o] : (o.length === 1 || o.startsWith("f") && /^\d+$/.test(o.slice(1)), o.toUpperCase());
}
function formatShortcutForDisplay(o, E) {
  const A = parseShortcutString(o);
  if (!A)
    return;
  const g = E?.isMac ?? !1, e = [];
  if (MODIFIER_ORDER.forEach((t) => {
    if (A.tokens.includes(t)) {
      const c = getModifierLabel(t, g);
      c && e.push(c);
    }
  }), A.baseKey && e.push(getKeyLabel(A.baseKey)), e.length !== 0)
    return e.join(" + ");
}
function useRegisterShortcut({
  shortcut: o,
  disabled: E = !1,
  onActivate: A
}) {
  const g = useMemo$1(() => parseShortcutString(o), [o]), e = useMemo$1(() => buildSequences(g), [g]);
  useEffect(() => {
    if (!g || e.length === 0 || E)
      return;
    const t = (c, n) => {
      E || shouldBlockShortcutInInput(g, c) || (c.preventDefault(), A());
    };
    return e.forEach((c) => {
      hotkeys(c, t);
    }), () => {
      e.forEach((c) => {
        hotkeys.unbind(c, t);
      });
    };
  }, [g, e, E, A]);
}
var BaseButtonKind = /* @__PURE__ */ ((o) => (o.PRIMARY = "primary", o.SECONDARY = "secondary", o.TERTIARY = "tertiary", o.GHOST = "ghost", o.BORDERLESS_ICON = "borderlessIcon", o.BORDERLESS_ICON_ACTIVE = "borderlessIconActive", o.MINIMAL = "minimal", o.PRIMARY_FORM_SUBMIT = "primaryFormSubmit", o.SECONDARY_FORM_SUBMIT = "secondaryFormSubmit", o.TERTIARY_FORM_SUBMIT = "tertiaryFormSubmit", o.HEADER_BUTTON = "header", o.HEADER_NO_PADDING = "headerNoPadding", o.ELEMENT_TOOLBAR = "elementToolbar", o.PILLS = "pills", o.PILLS_ACTIVE = "pillsActive", o.SEGMENTED_CONTROL = "segmented_control", o.SEGMENTED_CONTROL_ACTIVE = "segmented_controlActive", o))(BaseButtonKind || {}), BaseButtonSize = /* @__PURE__ */ ((o) => (o.XSMALL = "xsmall", o.SMALL = "small", o.MEDIUM = "medium", o.LARGE = "large", o))(BaseButtonSize || {});
function getSizeStyle(o, E) {
  switch (o) {
    case "xsmall":
      return {
        padding: `${E.spacing.twoXS} ${E.spacing.sm}`,
        fontSize: E.fontSizes.sm
      };
    case "small":
      return {
        padding: `${E.spacing.twoXS} ${E.spacing.md}`
      };
    case "large":
      return {
        padding: `${E.spacing.md} ${E.spacing.md}`
      };
    default:
      return {
        padding: `${E.spacing.xs} ${E.spacing.md}`
      };
  }
}
const StyledBaseButton = /* @__PURE__ */ createStyled("button", process.env.NODE_ENV === "production" ? {
  target: "ef3psqc24"
} : {
  target: "ef3psqc24",
  label: "StyledBaseButton"
})(({
  containerWidth: o,
  size: E,
  theme: A
}) => ({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  fontWeight: A.fontWeights.normal,
  padding: `${A.spacing.xs} ${A.spacing.md}`,
  borderRadius: A.radii.button,
  minHeight: A.sizes.minElementHeight,
  margin: A.spacing.none,
  lineHeight: A.lineHeights.base,
  textTransform: "none",
  fontSize: "inherit",
  fontFamily: "inherit",
  color: "inherit",
  width: o ? "100%" : "auto",
  cursor: "pointer",
  userSelect: "none",
  "&:focus": {
    outline: "none"
  },
  "&:focus-visible": {
    // When focus-visible (e.g. if the button was focused via keyboard navigation)
    // we use the hover style of the respective button type (see below) and
    // additionally show a colored focus ring
    boxShadow: `0 0 0 0.2rem ${transparentize(A.colors.primary, 0.5)}`
  },
  ...getSizeStyle(E, A)
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledPrimaryButton = /* @__PURE__ */ createStyled(StyledBaseButton, process.env.NODE_ENV === "production" ? {
  target: "ef3psqc23"
} : {
  target: "ef3psqc23",
  label: "StyledPrimaryButton"
})(({
  theme: o
}) => ({
  backgroundColor: o.colors.primary,
  color: o.colors.white,
  border: `${o.sizes.borderWidth} solid ${o.colors.primary}`,
  "&:hover, &:focus-visible": {
    backgroundColor: darken(o.colors.primary, 0.15),
    borderColor: darken(o.colors.primary, 0.15)
  },
  "&:active": {
    backgroundColor: o.colors.primary,
    // Keep the border darker when clicked so that the button looks "pressed"
    borderColor: darken(o.colors.primary, 0.15)
  },
  "&:disabled, &:disabled:hover, &:disabled:active": {
    borderColor: o.colors.borderColor,
    backgroundColor: o.colors.transparent,
    color: o.colors.fadedText40,
    cursor: "not-allowed"
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledSecondaryButton = /* @__PURE__ */ createStyled(StyledBaseButton, process.env.NODE_ENV === "production" ? {
  target: "ef3psqc22"
} : {
  target: "ef3psqc22",
  label: "StyledSecondaryButton"
})(({
  theme: o
}) => ({
  backgroundColor: o.colors.lightenedBg05,
  border: `${o.sizes.borderWidth} solid ${o.colors.borderColor}`,
  "&:hover, &:focus-visible": {
    backgroundColor: o.colors.darkenedBgMix15
  },
  "&:active": {
    backgroundColor: o.colors.darkenedBgMix25
  },
  "&:disabled, &:disabled:hover, &:disabled:active": {
    borderColor: o.colors.borderColor,
    backgroundColor: o.colors.transparent,
    color: o.colors.fadedText40,
    cursor: "not-allowed"
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledTertiaryButton = /* @__PURE__ */ createStyled(StyledBaseButton, process.env.NODE_ENV === "production" ? {
  target: "ef3psqc21"
} : {
  target: "ef3psqc21",
  label: "StyledTertiaryButton"
})(({
  theme: o
}) => ({
  padding: o.spacing.none,
  backgroundColor: o.colors.transparent,
  border: "none",
  "&:hover, &:focus-visible": {
    color: o.colors.primary
  },
  "&:hover:not(:disabled), &:focus-visible:not(:disabled)": {
    // Also make colored text have the primary color on hover. Since text color is
    // applied as an inline style we need to use !important to override it.
    // Note that we're not doing this when disabled. We should probably do that as
    // well but we don't do it anywhere else.
    "span.stMarkdownColoredText": {
      color: "inherit !important"
    }
  },
  "&:active": {
    color: darken(o.colors.primary, 0.25)
  },
  "&:disabled, &:disabled:hover, &:disabled:active": {
    backgroundColor: o.colors.transparent,
    color: o.colors.fadedText40,
    cursor: "not-allowed"
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledGhostButton = /* @__PURE__ */ createStyled(StyledBaseButton, process.env.NODE_ENV === "production" ? {
  target: "ef3psqc20"
} : {
  target: "ef3psqc20",
  label: "StyledGhostButton"
})(({
  theme: o
}) => ({
  backgroundColor: o.colors.transparent,
  border: `${o.sizes.borderWidth} solid ${o.colors.transparent}`,
  "&:hover, &:focus-visible": {
    borderColor: o.colors.transparent,
    color: o.colors.primary
  },
  "&:active": {
    color: o.colors.primary,
    borderColor: o.colors.transparent,
    backgroundColor: o.colors.transparent
  },
  "&:disabled, &:disabled:hover, &:disabled:active": {
    backgroundColor: o.colors.gray30,
    borderColor: o.colors.transparent,
    color: o.colors.gray60
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledMinimalButton = /* @__PURE__ */ createStyled(StyledBaseButton, process.env.NODE_ENV === "production" ? {
  target: "ef3psqc19"
} : {
  target: "ef3psqc19",
  label: "StyledMinimalButton"
})(({
  theme: o
}) => ({
  backgroundColor: o.colors.transparent,
  border: "none",
  boxShadow: "none",
  padding: o.spacing.none,
  "&:hover, &:active, &:focus-visible": {
    color: o.colors.primary
  },
  "&:disabled, &:disabled:hover, &:disabled:active": {
    color: o.colors.fadedText40,
    cursor: "not-allowed"
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledPrimaryFormSubmitButton = /* @__PURE__ */ createStyled(StyledPrimaryButton, process.env.NODE_ENV === "production" ? {
  target: "ef3psqc18"
} : {
  target: "ef3psqc18",
  label: "StyledPrimaryFormSubmitButton"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledSecondaryFormSubmitButton = /* @__PURE__ */ createStyled(StyledSecondaryButton, process.env.NODE_ENV === "production" ? {
  target: "ef3psqc17"
} : {
  target: "ef3psqc17",
  label: "StyledSecondaryFormSubmitButton"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledTertiaryFormSubmitButton = /* @__PURE__ */ createStyled(StyledTertiaryButton, process.env.NODE_ENV === "production" ? {
  target: "ef3psqc16"
} : {
  target: "ef3psqc16",
  label: "StyledTertiaryFormSubmitButton"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledButtonGroupBaseButton = /* @__PURE__ */ createStyled(StyledBaseButton, process.env.NODE_ENV === "production" ? {
  target: "ef3psqc15"
} : {
  target: "ef3psqc15",
  label: "StyledButtonGroupBaseButton"
})(({
  theme: o
}) => ({
  background: o.colors.bgColor,
  border: `${o.sizes.borderWidth} solid ${o.colors.borderColor}`,
  fontSize: o.fontSizes.sm,
  lineHeight: o.lineHeights.base,
  fontWeight: o.fontWeights.normal,
  height: o.sizes.largeLogoHeight,
  minHeight: o.sizes.largeLogoHeight,
  maxWidth: o.sizes.contentMaxWidth,
  // show pills with long text in single line and use ellipsis for overflow
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  "&:hover, &:focus-visible": {
    backgroundColor: o.colors.darkenedBgMix15
  },
  "&:disabled, &:disabled:hover, &:disabled:active": {
    borderColor: o.colors.borderColor,
    backgroundColor: o.colors.transparent,
    color: o.colors.fadedText40,
    cursor: "not-allowed"
  },
  "& div": {
    textOverflow: "ellipsis",
    overflow: "hidden"
  },
  "& p": {
    textOverflow: "ellipsis",
    overflow: "hidden"
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledPillsButton = /* @__PURE__ */ createStyled(StyledButtonGroupBaseButton, process.env.NODE_ENV === "production" ? {
  target: "ef3psqc14"
} : {
  target: "ef3psqc14",
  label: "StyledPillsButton"
})(({
  theme: o,
  containerWidth: E
}) => ({
  borderRadius: o.radii.full,
  padding: `${o.spacing.twoXS} ${o.spacing.md}`,
  // When containerWidth is true, the buttons will stretch to fill the container.
  flex: E ? "1 1 fit-content" : ""
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledPillsButtonActive = /* @__PURE__ */ createStyled(StyledPillsButton, process.env.NODE_ENV === "production" ? {
  target: "ef3psqc13"
} : {
  target: "ef3psqc13",
  label: "StyledPillsButtonActive"
})(({
  theme: o
}) => ({
  backgroundColor: transparentize(o.colors.primary, 0.9),
  borderColor: o.colors.primary,
  color: o.colors.primary,
  "&:hover, &:focus-visible": {
    backgroundColor: transparentize(o.colors.primary, 0.8),
    borderColor: o.colors.primary,
    color: o.colors.primary
  },
  "&:disabled, &:disabled:hover, &:disabled:active": {
    borderColor: o.colors.borderColor,
    backgroundColor: o.colors.fadedText05,
    color: o.colors.fadedText40,
    cursor: "not-allowed"
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledSegmentedControlButton = /* @__PURE__ */ createStyled(StyledButtonGroupBaseButton, process.env.NODE_ENV === "production" ? {
  target: "ef3psqc12"
} : {
  target: "ef3psqc12",
  label: "StyledSegmentedControlButton"
})(({
  theme: o,
  containerWidth: E
}) => ({
  padding: `${o.spacing.twoXS} ${o.spacing.lg}`,
  borderRadius: "0",
  // When containerWidth is true, the buttons will stretch to fill the container.
  flex: E ? "1 1 fit-content" : "",
  maxWidth: "100%",
  marginRight: `-${o.sizes.borderWidth}`,
  // Add negative margin to overlap borders
  "&:first-child": {
    borderTopLeftRadius: o.radii.button,
    borderBottomLeftRadius: o.radii.button
  },
  "&:last-child": {
    borderTopRightRadius: o.radii.button,
    borderBottomRightRadius: o.radii.button,
    marginRight: o.spacing.none
    // Reset margin for the last child
  },
  "&:focus-visible": {
    // Make sure the focus ring isn't below the previous/next button.
    zIndex: o.zIndices.priority
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledSegmentedControlButtonActive = /* @__PURE__ */ createStyled(StyledSegmentedControlButton, process.env.NODE_ENV === "production" ? {
  target: "ef3psqc11"
} : {
  target: "ef3psqc11",
  label: "StyledSegmentedControlButtonActive"
})(({
  theme: o
}) => ({
  backgroundColor: transparentize(o.colors.primary, 0.9),
  borderColor: o.colors.primary,
  color: o.colors.primary,
  zIndex: o.zIndices.priority,
  "&:hover, &:focus-visible": {
    backgroundColor: transparentize(o.colors.primary, 0.8)
  },
  "&:disabled, &:disabled:hover, &:disabled:active": {
    borderColor: o.colors.borderColor,
    backgroundColor: o.colors.fadedText05,
    color: o.colors.fadedText40,
    cursor: "not-allowed"
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledHeaderButton = /* @__PURE__ */ createStyled(StyledBaseButton, process.env.NODE_ENV === "production" ? {
  target: "ef3psqc10"
} : {
  target: "ef3psqc10",
  label: "StyledHeaderButton"
})(({
  theme: o
}) => ({
  backgroundColor: o.colors.transparent,
  border: "none",
  padding: `0 ${o.spacing.sm}`,
  fontSize: o.fontSizes.sm,
  marginLeft: o.spacing.threeXS,
  marginRight: o.spacing.threeXS,
  lineHeight: o.lineHeights.none,
  minWidth: o.sizes.headerItemHeight,
  minHeight: o.sizes.headerItemHeight,
  "&:focus": {
    outline: "none"
  },
  "&:focus-visible": {
    boxShadow: `0 0 0 0.2rem ${transparentize(o.colors.gray90, 0.8)}`
  },
  "&:hover": {
    backgroundColor: o.colors.darkenedBgMix15
  },
  "&:active": {
    backgroundColor: o.colors.darkenedBgMix25
  },
  "&:disabled, &:disabled:hover, &:disabled:active": {
    backgroundColor: o.colors.gray30,
    borderColor: o.colors.transparent,
    color: o.colors.gray60
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2xpYi9zcmMvY29tcG9uZW50cy9zaGFyZWQvQmFzZUJ1dHRvbi9zdHlsZWQtY29tcG9uZW50cy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUF1V2tDIiwiZmlsZSI6Ii9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2xpYi9zcmMvY29tcG9uZW50cy9zaGFyZWQvQmFzZUJ1dHRvbi9zdHlsZWQtY29tcG9uZW50cy50cyIsInNvdXJjZXNDb250ZW50IjpbIi8qKlxuICogQ29weXJpZ2h0IChjKSBTdHJlYW1saXQgSW5jLiAoMjAxOC0yMDIyKSBTbm93Zmxha2UgSW5jLiAoMjAyMi0yMDI1KVxuICpcbiAqIExpY2Vuc2VkIHVuZGVyIHRoZSBBcGFjaGUgTGljZW5zZSwgVmVyc2lvbiAyLjAgKHRoZSBcIkxpY2Vuc2VcIik7XG4gKiB5b3UgbWF5IG5vdCB1c2UgdGhpcyBmaWxlIGV4Y2VwdCBpbiBjb21wbGlhbmNlIHdpdGggdGhlIExpY2Vuc2UuXG4gKiBZb3UgbWF5IG9idGFpbiBhIGNvcHkgb2YgdGhlIExpY2Vuc2UgYXRcbiAqXG4gKiAgICAgaHR0cDovL3d3dy5hcGFjaGUub3JnL2xpY2Vuc2VzL0xJQ0VOU0UtMi4wXG4gKlxuICogVW5sZXNzIHJlcXVpcmVkIGJ5IGFwcGxpY2FibGUgbGF3IG9yIGFncmVlZCB0byBpbiB3cml0aW5nLCBzb2Z0d2FyZVxuICogZGlzdHJpYnV0ZWQgdW5kZXIgdGhlIExpY2Vuc2UgaXMgZGlzdHJpYnV0ZWQgb24gYW4gXCJBUyBJU1wiIEJBU0lTLFxuICogV0lUSE9VVCBXQVJSQU5USUVTIE9SIENPTkRJVElPTlMgT0YgQU5ZIEtJTkQsIGVpdGhlciBleHByZXNzIG9yIGltcGxpZWQuXG4gKiBTZWUgdGhlIExpY2Vuc2UgZm9yIHRoZSBzcGVjaWZpYyBsYW5ndWFnZSBnb3Zlcm5pbmcgcGVybWlzc2lvbnMgYW5kXG4gKiBsaW1pdGF0aW9ucyB1bmRlciB0aGUgTGljZW5zZS5cbiAqL1xuXG5pbXBvcnQgeyBNb3VzZUV2ZW50LCBSZWFjdE5vZGUgfSBmcm9tIFwicmVhY3RcIlxuXG5pbXBvcnQgc3R5bGVkLCB7IENTU09iamVjdCB9IGZyb20gXCJAZW1vdGlvbi9zdHlsZWRcIlxuaW1wb3J0IHsgZGFya2VuLCB0cmFuc3BhcmVudGl6ZSB9IGZyb20gXCJjb2xvcjJrXCJcblxuaW1wb3J0IHsgRW1vdGlvblRoZW1lIH0gZnJvbSBcIn5saWIvdGhlbWVcIlxuXG5leHBvcnQgZW51bSBCYXNlQnV0dG9uS2luZCB7XG4gIFBSSU1BUlkgPSBcInByaW1hcnlcIixcbiAgU0VDT05EQVJZID0gXCJzZWNvbmRhcnlcIixcbiAgVEVSVElBUlkgPSBcInRlcnRpYXJ5XCIsXG4gIEdIT1NUID0gXCJnaG9zdFwiLFxuICBCT1JERVJMRVNTX0lDT04gPSBcImJvcmRlcmxlc3NJY29uXCIsXG4gIEJPUkRFUkxFU1NfSUNPTl9BQ1RJVkUgPSBcImJvcmRlcmxlc3NJY29uQWN0aXZlXCIsXG4gIE1JTklNQUwgPSBcIm1pbmltYWxcIixcbiAgUFJJTUFSWV9GT1JNX1NVQk1JVCA9IFwicHJpbWFyeUZvcm1TdWJtaXRcIixcbiAgU0VDT05EQVJZX0ZPUk1fU1VCTUlUID0gXCJzZWNvbmRhcnlGb3JtU3VibWl0XCIsXG4gIFRFUlRJQVJZX0ZPUk1fU1VCTUlUID0gXCJ0ZXJ0aWFyeUZvcm1TdWJtaXRcIixcbiAgSEVBREVSX0JVVFRPTiA9IFwiaGVhZGVyXCIsXG4gIEhFQURFUl9OT19QQURESU5HID0gXCJoZWFkZXJOb1BhZGRpbmdcIixcbiAgRUxFTUVOVF9UT09MQkFSID0gXCJlbGVtZW50VG9vbGJhclwiLFxuICBQSUxMUyA9IFwicGlsbHNcIixcbiAgUElMTFNfQUNUSVZFID0gXCJwaWxsc0FjdGl2ZVwiLFxuICBTRUdNRU5URURfQ09OVFJPTCA9IFwic2VnbWVudGVkX2NvbnRyb2xcIixcbiAgU0VHTUVOVEVEX0NPTlRST0xfQUNUSVZFID0gXCJzZWdtZW50ZWRfY29udHJvbEFjdGl2ZVwiLFxufVxuXG5leHBvcnQgZW51bSBCYXNlQnV0dG9uU2l6ZSB7XG4gIFhTTUFMTCA9IFwieHNtYWxsXCIsXG4gIFNNQUxMID0gXCJzbWFsbFwiLFxuICBNRURJVU0gPSBcIm1lZGl1bVwiLFxuICBMQVJHRSA9IFwibGFyZ2VcIixcbn1cblxuZXhwb3J0IGludGVyZmFjZSBCYXNlQnV0dG9uUHJvcHMge1xuICBraW5kOiBCYXNlQnV0dG9uS2luZFxuICBzaXplPzogQmFzZUJ1dHRvblNpemVcbiAgLy8gZXNsaW50LWRpc2FibGUtbmV4dC1saW5lIEB0eXBlc2NyaXB0LWVzbGludC9uby1leHBsaWNpdC1hbnkgLS0gVE9ETzogUmVwbGFjZSAnYW55JyB3aXRoIGEgbW9yZSBzcGVjaWZpYyB0eXBlLlxuICBvbkNsaWNrPzogKGV2ZW50OiBNb3VzZUV2ZW50PEhUTUxCdXR0b25FbGVtZW50PikgPT4gYW55XG4gIGRpc2FibGVkPzogYm9vbGVhblxuICAvLyBJZiB0cnVlLCB0aGUgYnV0dG9uIHNob3VsZCB0YWtlIHVwIGNvbnRhaW5lcidzIGZ1bGwgd2lkdGhcbiAgY29udGFpbmVyV2lkdGg/OiBib29sZWFuXG4gIGNoaWxkcmVuOiBSZWFjdE5vZGVcbiAgYXV0b0ZvY3VzPzogYm9vbGVhblxuICBcImRhdGEtdGVzdGlkXCI/OiBzdHJpbmdcbiAgXCJhcmlhLWxhYmVsXCI/OiBzdHJpbmdcbn1cblxudHlwZSBSZXF1aXJlZEJhc2VCdXR0b25Qcm9wcyA9IFJlcXVpcmVkPEJhc2VCdXR0b25Qcm9wcz5cblxuZnVuY3Rpb24gZ2V0U2l6ZVN0eWxlKHNpemU6IEJhc2VCdXR0b25TaXplLCB0aGVtZTogRW1vdGlvblRoZW1lKTogQ1NTT2JqZWN0IHtcbiAgc3dpdGNoIChzaXplKSB7XG4gICAgY2FzZSBCYXNlQnV0dG9uU2l6ZS5YU01BTEw6XG4gICAgICByZXR1cm4ge1xuICAgICAgICBwYWRkaW5nOiBgJHt0aGVtZS5zcGFjaW5nLnR3b1hTfSAke3RoZW1lLnNwYWNpbmcuc219YCxcbiAgICAgICAgZm9udFNpemU6IHRoZW1lLmZvbnRTaXplcy5zbSxcbiAgICAgIH1cbiAgICBjYXNlIEJhc2VCdXR0b25TaXplLlNNQUxMOlxuICAgICAgcmV0dXJuIHtcbiAgICAgICAgcGFkZGluZzogYCR7dGhlbWUuc3BhY2luZy50d29YU30gJHt0aGVtZS5zcGFjaW5nLm1kfWAsXG4gICAgICB9XG4gICAgY2FzZSBCYXNlQnV0dG9uU2l6ZS5MQVJHRTpcbiAgICAgIHJldHVybiB7XG4gICAgICAgIHBhZGRpbmc6IGAke3RoZW1lLnNwYWNpbmcubWR9ICR7dGhlbWUuc3BhY2luZy5tZH1gLFxuICAgICAgfVxuICAgIGRlZmF1bHQ6XG4gICAgICByZXR1cm4ge1xuICAgICAgICBwYWRkaW5nOiBgJHt0aGVtZS5zcGFjaW5nLnhzfSAke3RoZW1lLnNwYWNpbmcubWR9YCxcbiAgICAgIH1cbiAgfVxufVxuXG5leHBvcnQgY29uc3QgU3R5bGVkQmFzZUJ1dHRvbiA9IHN0eWxlZC5idXR0b248UmVxdWlyZWRCYXNlQnV0dG9uUHJvcHM+KFxuICAoeyBjb250YWluZXJXaWR0aCwgc2l6ZSwgdGhlbWUgfSkgPT4ge1xuICAgIHJldHVybiB7XG4gICAgICBkaXNwbGF5OiBcImlubGluZS1mbGV4XCIsXG4gICAgICBhbGlnbkl0ZW1zOiBcImNlbnRlclwiLFxuICAgICAganVzdGlmeUNvbnRlbnQ6IFwiY2VudGVyXCIsXG4gICAgICBmb250V2VpZ2h0OiB0aGVtZS5mb250V2VpZ2h0cy5ub3JtYWwsXG4gICAgICBwYWRkaW5nOiBgJHt0aGVtZS5zcGFjaW5nLnhzfSAke3RoZW1lLnNwYWNpbmcubWR9YCxcbiAgICAgIGJvcmRlclJhZGl1czogdGhlbWUucmFkaWkuYnV0dG9uLFxuICAgICAgbWluSGVpZ2h0OiB0aGVtZS5zaXplcy5taW5FbGVtZW50SGVpZ2h0LFxuICAgICAgbWFyZ2luOiB0aGVtZS5zcGFjaW5nLm5vbmUsXG4gICAgICBsaW5lSGVpZ2h0OiB0aGVtZS5saW5lSGVpZ2h0cy5iYXNlLFxuICAgICAgdGV4dFRyYW5zZm9ybTogXCJub25lXCIsXG4gICAgICBmb250U2l6ZTogXCJpbmhlcml0XCIsXG4gICAgICBmb250RmFtaWx5OiBcImluaGVyaXRcIixcbiAgICAgIGNvbG9yOiBcImluaGVyaXRcIixcbiAgICAgIHdpZHRoOiBjb250YWluZXJXaWR0aCA/IFwiMTAwJVwiIDogXCJhdXRvXCIsXG4gICAgICBjdXJzb3I6IFwicG9pbnRlclwiLFxuICAgICAgdXNlclNlbGVjdDogXCJub25lXCIsXG4gICAgICBcIiY6Zm9jdXNcIjoge1xuICAgICAgICBvdXRsaW5lOiBcIm5vbmVcIixcbiAgICAgIH0sXG4gICAgICBcIiY6Zm9jdXMtdmlzaWJsZVwiOiB7XG4gICAgICAgIC8vIFdoZW4gZm9jdXMtdmlzaWJsZSAoZS5nLiBpZiB0aGUgYnV0dG9uIHdhcyBmb2N1c2VkIHZpYSBrZXlib2FyZCBuYXZpZ2F0aW9uKVxuICAgICAgICAvLyB3ZSB1c2UgdGhlIGhvdmVyIHN0eWxlIG9mIHRoZSByZXNwZWN0aXZlIGJ1dHRvbiB0eXBlIChzZWUgYmVsb3cpIGFuZFxuICAgICAgICAvLyBhZGRpdGlvbmFsbHkgc2hvdyBhIGNvbG9yZWQgZm9jdXMgcmluZ1xuICAgICAgICBib3hTaGFkb3c6IGAwIDAgMCAwLjJyZW0gJHt0cmFuc3BhcmVudGl6ZSh0aGVtZS5jb2xvcnMucHJpbWFyeSwgMC41KX1gLFxuICAgICAgfSxcbiAgICAgIC4uLmdldFNpemVTdHlsZShzaXplLCB0aGVtZSksXG4gICAgfVxuICB9XG4pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRQcmltYXJ5QnV0dG9uID0gc3R5bGVkKFxuICBTdHlsZWRCYXNlQnV0dG9uXG4pPFJlcXVpcmVkQmFzZUJ1dHRvblByb3BzPigoeyB0aGVtZSB9KSA9PiAoe1xuICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5wcmltYXJ5LFxuICBjb2xvcjogdGhlbWUuY29sb3JzLndoaXRlLFxuICBib3JkZXI6IGAke3RoZW1lLnNpemVzLmJvcmRlcldpZHRofSBzb2xpZCAke3RoZW1lLmNvbG9ycy5wcmltYXJ5fWAsXG4gIFwiJjpob3ZlciwgJjpmb2N1cy12aXNpYmxlXCI6IHtcbiAgICBiYWNrZ3JvdW5kQ29sb3I6IGRhcmtlbih0aGVtZS5jb2xvcnMucHJpbWFyeSwgMC4xNSksXG4gICAgYm9yZGVyQ29sb3I6IGRhcmtlbih0aGVtZS5jb2xvcnMucHJpbWFyeSwgMC4xNSksXG4gIH0sXG4gIFwiJjphY3RpdmVcIjoge1xuICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLnByaW1hcnksXG4gICAgLy8gS2VlcCB0aGUgYm9yZGVyIGRhcmtlciB3aGVuIGNsaWNrZWQgc28gdGhhdCB0aGUgYnV0dG9uIGxvb2tzIFwicHJlc3NlZFwiXG4gICAgYm9yZGVyQ29sb3I6IGRhcmtlbih0aGVtZS5jb2xvcnMucHJpbWFyeSwgMC4xNSksXG4gIH0sXG4gIFwiJjpkaXNhYmxlZCwgJjpkaXNhYmxlZDpob3ZlciwgJjpkaXNhYmxlZDphY3RpdmVcIjoge1xuICAgIGJvcmRlckNvbG9yOiB0aGVtZS5jb2xvcnMuYm9yZGVyQ29sb3IsXG4gICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnQsXG4gICAgY29sb3I6IHRoZW1lLmNvbG9ycy5mYWRlZFRleHQ0MCxcbiAgICBjdXJzb3I6IFwibm90LWFsbG93ZWRcIixcbiAgfSxcbn0pKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkU2Vjb25kYXJ5QnV0dG9uID0gc3R5bGVkKFxuICBTdHlsZWRCYXNlQnV0dG9uXG4pPFJlcXVpcmVkQmFzZUJ1dHRvblByb3BzPigoeyB0aGVtZSB9KSA9PiAoe1xuICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5saWdodGVuZWRCZzA1LFxuICBib3JkZXI6IGAke3RoZW1lLnNpemVzLmJvcmRlcldpZHRofSBzb2xpZCAke3RoZW1lLmNvbG9ycy5ib3JkZXJDb2xvcn1gLFxuICBcIiY6aG92ZXIsICY6Zm9jdXMtdmlzaWJsZVwiOiB7XG4gICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMuZGFya2VuZWRCZ01peDE1LFxuICB9LFxuICBcIiY6YWN0aXZlXCI6IHtcbiAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5kYXJrZW5lZEJnTWl4MjUsXG4gIH0sXG4gIFwiJjpkaXNhYmxlZCwgJjpkaXNhYmxlZDpob3ZlciwgJjpkaXNhYmxlZDphY3RpdmVcIjoge1xuICAgIGJvcmRlckNvbG9yOiB0aGVtZS5jb2xvcnMuYm9yZGVyQ29sb3IsXG4gICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnQsXG4gICAgY29sb3I6IHRoZW1lLmNvbG9ycy5mYWRlZFRleHQ0MCxcbiAgICBjdXJzb3I6IFwibm90LWFsbG93ZWRcIixcbiAgfSxcbn0pKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkVGVydGlhcnlCdXR0b24gPSBzdHlsZWQoXG4gIFN0eWxlZEJhc2VCdXR0b25cbik8UmVxdWlyZWRCYXNlQnV0dG9uUHJvcHM+KCh7IHRoZW1lIH0pID0+IHtcbiAgcmV0dXJuIHtcbiAgICBwYWRkaW5nOiB0aGVtZS5zcGFjaW5nLm5vbmUsXG4gICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnQsXG4gICAgYm9yZGVyOiBcIm5vbmVcIixcbiAgICBcIiY6aG92ZXIsICY6Zm9jdXMtdmlzaWJsZVwiOiB7XG4gICAgICBjb2xvcjogdGhlbWUuY29sb3JzLnByaW1hcnksXG4gICAgfSxcbiAgICBcIiY6aG92ZXI6bm90KDpkaXNhYmxlZCksICY6Zm9jdXMtdmlzaWJsZTpub3QoOmRpc2FibGVkKVwiOiB7XG4gICAgICAvLyBBbHNvIG1ha2UgY29sb3JlZCB0ZXh0IGhhdmUgdGhlIHByaW1hcnkgY29sb3Igb24gaG92ZXIuIFNpbmNlIHRleHQgY29sb3IgaXNcbiAgICAgIC8vIGFwcGxpZWQgYXMgYW4gaW5saW5lIHN0eWxlIHdlIG5lZWQgdG8gdXNlICFpbXBvcnRhbnQgdG8gb3ZlcnJpZGUgaXQuXG4gICAgICAvLyBOb3RlIHRoYXQgd2UncmUgbm90IGRvaW5nIHRoaXMgd2hlbiBkaXNhYmxlZC4gV2Ugc2hvdWxkIHByb2JhYmx5IGRvIHRoYXQgYXNcbiAgICAgIC8vIHdlbGwgYnV0IHdlIGRvbid0IGRvIGl0IGFueXdoZXJlIGVsc2UuXG4gICAgICBcInNwYW4uc3RNYXJrZG93bkNvbG9yZWRUZXh0XCI6IHtcbiAgICAgICAgY29sb3I6IFwiaW5oZXJpdCAhaW1wb3J0YW50XCIsXG4gICAgICB9LFxuICAgIH0sXG4gICAgXCImOmFjdGl2ZVwiOiB7XG4gICAgICBjb2xvcjogZGFya2VuKHRoZW1lLmNvbG9ycy5wcmltYXJ5LCAwLjI1KSxcbiAgICB9LFxuICAgIFwiJjpkaXNhYmxlZCwgJjpkaXNhYmxlZDpob3ZlciwgJjpkaXNhYmxlZDphY3RpdmVcIjoge1xuICAgICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnQsXG4gICAgICBjb2xvcjogdGhlbWUuY29sb3JzLmZhZGVkVGV4dDQwLFxuICAgICAgY3Vyc29yOiBcIm5vdC1hbGxvd2VkXCIsXG4gICAgfSxcbiAgfVxufSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZEdob3N0QnV0dG9uID0gc3R5bGVkKFxuICBTdHlsZWRCYXNlQnV0dG9uXG4pPFJlcXVpcmVkQmFzZUJ1dHRvblByb3BzPigoeyB0aGVtZSB9KSA9PiAoe1xuICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy50cmFuc3BhcmVudCxcbiAgYm9yZGVyOiBgJHt0aGVtZS5zaXplcy5ib3JkZXJXaWR0aH0gc29saWQgJHt0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnR9YCxcbiAgXCImOmhvdmVyLCAmOmZvY3VzLXZpc2libGVcIjoge1xuICAgIGJvcmRlckNvbG9yOiB0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnQsXG4gICAgY29sb3I6IHRoZW1lLmNvbG9ycy5wcmltYXJ5LFxuICB9LFxuICBcIiY6YWN0aXZlXCI6IHtcbiAgICBjb2xvcjogdGhlbWUuY29sb3JzLnByaW1hcnksXG4gICAgYm9yZGVyQ29sb3I6IHRoZW1lLmNvbG9ycy50cmFuc3BhcmVudCxcbiAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy50cmFuc3BhcmVudCxcbiAgfSxcbiAgXCImOmRpc2FibGVkLCAmOmRpc2FibGVkOmhvdmVyLCAmOmRpc2FibGVkOmFjdGl2ZVwiOiB7XG4gICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMuZ3JheTMwLFxuICAgIGJvcmRlckNvbG9yOiB0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnQsXG4gICAgY29sb3I6IHRoZW1lLmNvbG9ycy5ncmF5NjAsXG4gIH0sXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZE1pbmltYWxCdXR0b24gPSBzdHlsZWQoXG4gIFN0eWxlZEJhc2VCdXR0b25cbik8UmVxdWlyZWRCYXNlQnV0dG9uUHJvcHM+KCh7IHRoZW1lIH0pID0+ICh7XG4gIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLnRyYW5zcGFyZW50LFxuICBib3JkZXI6IFwibm9uZVwiLFxuICBib3hTaGFkb3c6IFwibm9uZVwiLFxuICBwYWRkaW5nOiB0aGVtZS5zcGFjaW5nLm5vbmUsXG4gIFwiJjpob3ZlciwgJjphY3RpdmUsICY6Zm9jdXMtdmlzaWJsZVwiOiB7XG4gICAgY29sb3I6IHRoZW1lLmNvbG9ycy5wcmltYXJ5LFxuICB9LFxuICBcIiY6ZGlzYWJsZWQsICY6ZGlzYWJsZWQ6aG92ZXIsICY6ZGlzYWJsZWQ6YWN0aXZlXCI6IHtcbiAgICBjb2xvcjogdGhlbWUuY29sb3JzLmZhZGVkVGV4dDQwLFxuICAgIGN1cnNvcjogXCJub3QtYWxsb3dlZFwiLFxuICB9LFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRQcmltYXJ5Rm9ybVN1Ym1pdEJ1dHRvbiA9XG4gIHN0eWxlZChTdHlsZWRQcmltYXJ5QnV0dG9uKTxSZXF1aXJlZEJhc2VCdXR0b25Qcm9wcz4oKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkU2Vjb25kYXJ5Rm9ybVN1Ym1pdEJ1dHRvbiA9IHN0eWxlZChcbiAgU3R5bGVkU2Vjb25kYXJ5QnV0dG9uXG4pPFJlcXVpcmVkQmFzZUJ1dHRvblByb3BzPigpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRUZXJ0aWFyeUZvcm1TdWJtaXRCdXR0b24gPSBzdHlsZWQoXG4gIFN0eWxlZFRlcnRpYXJ5QnV0dG9uXG4pPFJlcXVpcmVkQmFzZUJ1dHRvblByb3BzPigpXG5cbmNvbnN0IFN0eWxlZEJ1dHRvbkdyb3VwQmFzZUJ1dHRvbiA9IHN0eWxlZChcbiAgU3R5bGVkQmFzZUJ1dHRvblxuKTxSZXF1aXJlZEJhc2VCdXR0b25Qcm9wcz4oKHsgdGhlbWUgfSkgPT4ge1xuICByZXR1cm4ge1xuICAgIGJhY2tncm91bmQ6IHRoZW1lLmNvbG9ycy5iZ0NvbG9yLFxuICAgIGJvcmRlcjogYCR7dGhlbWUuc2l6ZXMuYm9yZGVyV2lkdGh9IHNvbGlkICR7dGhlbWUuY29sb3JzLmJvcmRlckNvbG9yfWAsXG4gICAgZm9udFNpemU6IHRoZW1lLmZvbnRTaXplcy5zbSxcbiAgICBsaW5lSGVpZ2h0OiB0aGVtZS5saW5lSGVpZ2h0cy5iYXNlLFxuICAgIGZvbnRXZWlnaHQ6IHRoZW1lLmZvbnRXZWlnaHRzLm5vcm1hbCxcbiAgICBoZWlnaHQ6IHRoZW1lLnNpemVzLmxhcmdlTG9nb0hlaWdodCxcbiAgICBtaW5IZWlnaHQ6IHRoZW1lLnNpemVzLmxhcmdlTG9nb0hlaWdodCxcbiAgICBtYXhXaWR0aDogdGhlbWUuc2l6ZXMuY29udGVudE1heFdpZHRoLFxuXG4gICAgLy8gc2hvdyBwaWxscyB3aXRoIGxvbmcgdGV4dCBpbiBzaW5nbGUgbGluZSBhbmQgdXNlIGVsbGlwc2lzIGZvciBvdmVyZmxvd1xuICAgIHdoaXRlU3BhY2U6IFwibm93cmFwXCIsXG4gICAgb3ZlcmZsb3c6IFwiaGlkZGVuXCIsXG4gICAgdGV4dE92ZXJmbG93OiBcImVsbGlwc2lzXCIsXG5cbiAgICBcIiY6aG92ZXIsICY6Zm9jdXMtdmlzaWJsZVwiOiB7XG4gICAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5kYXJrZW5lZEJnTWl4MTUsXG4gICAgfSxcbiAgICBcIiY6ZGlzYWJsZWQsICY6ZGlzYWJsZWQ6aG92ZXIsICY6ZGlzYWJsZWQ6YWN0aXZlXCI6IHtcbiAgICAgIGJvcmRlckNvbG9yOiB0aGVtZS5jb2xvcnMuYm9yZGVyQ29sb3IsXG4gICAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy50cmFuc3BhcmVudCxcbiAgICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMuZmFkZWRUZXh0NDAsXG4gICAgICBjdXJzb3I6IFwibm90LWFsbG93ZWRcIixcbiAgICB9LFxuXG4gICAgXCImIGRpdlwiOiB7XG4gICAgICB0ZXh0T3ZlcmZsb3c6IFwiZWxsaXBzaXNcIixcbiAgICAgIG92ZXJmbG93OiBcImhpZGRlblwiLFxuICAgIH0sXG4gICAgXCImIHBcIjoge1xuICAgICAgdGV4dE92ZXJmbG93OiBcImVsbGlwc2lzXCIsXG4gICAgICBvdmVyZmxvdzogXCJoaWRkZW5cIixcbiAgICB9LFxuICB9XG59KVxuXG5leHBvcnQgY29uc3QgU3R5bGVkUGlsbHNCdXR0b24gPSBzdHlsZWQoXG4gIFN0eWxlZEJ1dHRvbkdyb3VwQmFzZUJ1dHRvblxuKTxSZXF1aXJlZEJhc2VCdXR0b25Qcm9wcz4oKHsgdGhlbWUsIGNvbnRhaW5lcldpZHRoIH0pID0+IHtcbiAgcmV0dXJuIHtcbiAgICBib3JkZXJSYWRpdXM6IHRoZW1lLnJhZGlpLmZ1bGwsXG4gICAgcGFkZGluZzogYCR7dGhlbWUuc3BhY2luZy50d29YU30gJHt0aGVtZS5zcGFjaW5nLm1kfWAsXG4gICAgLy8gV2hlbiBjb250YWluZXJXaWR0aCBpcyB0cnVlLCB0aGUgYnV0dG9ucyB3aWxsIHN0cmV0Y2ggdG8gZmlsbCB0aGUgY29udGFpbmVyLlxuICAgIGZsZXg6IGNvbnRhaW5lcldpZHRoID8gXCIxIDEgZml0LWNvbnRlbnRcIiA6IFwiXCIsXG4gIH1cbn0pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRQaWxsc0J1dHRvbkFjdGl2ZSA9IHN0eWxlZChcbiAgU3R5bGVkUGlsbHNCdXR0b25cbik8UmVxdWlyZWRCYXNlQnV0dG9uUHJvcHM+KCh7IHRoZW1lIH0pID0+IHtcbiAgcmV0dXJuIHtcbiAgICBiYWNrZ3JvdW5kQ29sb3I6IHRyYW5zcGFyZW50aXplKHRoZW1lLmNvbG9ycy5wcmltYXJ5LCAwLjkpLFxuICAgIGJvcmRlckNvbG9yOiB0aGVtZS5jb2xvcnMucHJpbWFyeSxcbiAgICBjb2xvcjogdGhlbWUuY29sb3JzLnByaW1hcnksXG4gICAgXCImOmhvdmVyLCAmOmZvY3VzLXZpc2libGVcIjoge1xuICAgICAgYmFja2dyb3VuZENvbG9yOiB0cmFuc3BhcmVudGl6ZSh0aGVtZS5jb2xvcnMucHJpbWFyeSwgMC44KSxcbiAgICAgIGJvcmRlckNvbG9yOiB0aGVtZS5jb2xvcnMucHJpbWFyeSxcbiAgICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMucHJpbWFyeSxcbiAgICB9LFxuICAgIFwiJjpkaXNhYmxlZCwgJjpkaXNhYmxlZDpob3ZlciwgJjpkaXNhYmxlZDphY3RpdmVcIjoge1xuICAgICAgYm9yZGVyQ29sb3I6IHRoZW1lLmNvbG9ycy5ib3JkZXJDb2xvcixcbiAgICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLmZhZGVkVGV4dDA1LFxuICAgICAgY29sb3I6IHRoZW1lLmNvbG9ycy5mYWRlZFRleHQ0MCxcbiAgICAgIGN1cnNvcjogXCJub3QtYWxsb3dlZFwiLFxuICAgIH0sXG4gIH1cbn0pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRTZWdtZW50ZWRDb250cm9sQnV0dG9uID0gc3R5bGVkKFxuICBTdHlsZWRCdXR0b25Hcm91cEJhc2VCdXR0b25cbik8UmVxdWlyZWRCYXNlQnV0dG9uUHJvcHM+KCh7IHRoZW1lLCBjb250YWluZXJXaWR0aCB9KSA9PiB7XG4gIHJldHVybiB7XG4gICAgcGFkZGluZzogYCR7dGhlbWUuc3BhY2luZy50d29YU30gJHt0aGVtZS5zcGFjaW5nLmxnfWAsXG4gICAgYm9yZGVyUmFkaXVzOiBcIjBcIixcbiAgICAvLyBXaGVuIGNvbnRhaW5lcldpZHRoIGlzIHRydWUsIHRoZSBidXR0b25zIHdpbGwgc3RyZXRjaCB0byBmaWxsIHRoZSBjb250YWluZXIuXG4gICAgZmxleDogY29udGFpbmVyV2lkdGggPyBcIjEgMSBmaXQtY29udGVudFwiIDogXCJcIixcbiAgICBtYXhXaWR0aDogXCIxMDAlXCIsXG4gICAgbWFyZ2luUmlnaHQ6IGAtJHt0aGVtZS5zaXplcy5ib3JkZXJXaWR0aH1gLCAvLyBBZGQgbmVnYXRpdmUgbWFyZ2luIHRvIG92ZXJsYXAgYm9yZGVyc1xuXG4gICAgXCImOmZpcnN0LWNoaWxkXCI6IHtcbiAgICAgIGJvcmRlclRvcExlZnRSYWRpdXM6IHRoZW1lLnJhZGlpLmJ1dHRvbixcbiAgICAgIGJvcmRlckJvdHRvbUxlZnRSYWRpdXM6IHRoZW1lLnJhZGlpLmJ1dHRvbixcbiAgICB9LFxuICAgIFwiJjpsYXN0LWNoaWxkXCI6IHtcbiAgICAgIGJvcmRlclRvcFJpZ2h0UmFkaXVzOiB0aGVtZS5yYWRpaS5idXR0b24sXG4gICAgICBib3JkZXJCb3R0b21SaWdodFJhZGl1czogdGhlbWUucmFkaWkuYnV0dG9uLFxuICAgICAgbWFyZ2luUmlnaHQ6IHRoZW1lLnNwYWNpbmcubm9uZSwgLy8gUmVzZXQgbWFyZ2luIGZvciB0aGUgbGFzdCBjaGlsZFxuICAgIH0sXG4gICAgXCImOmZvY3VzLXZpc2libGVcIjoge1xuICAgICAgLy8gTWFrZSBzdXJlIHRoZSBmb2N1cyByaW5nIGlzbid0IGJlbG93IHRoZSBwcmV2aW91cy9uZXh0IGJ1dHRvbi5cbiAgICAgIHpJbmRleDogdGhlbWUuekluZGljZXMucHJpb3JpdHksXG4gICAgfSxcbiAgfVxufSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZFNlZ21lbnRlZENvbnRyb2xCdXR0b25BY3RpdmUgPSBzdHlsZWQoXG4gIFN0eWxlZFNlZ21lbnRlZENvbnRyb2xCdXR0b25cbik8UmVxdWlyZWRCYXNlQnV0dG9uUHJvcHM+KCh7IHRoZW1lIH0pID0+IHtcbiAgcmV0dXJuIHtcbiAgICBiYWNrZ3JvdW5kQ29sb3I6IHRyYW5zcGFyZW50aXplKHRoZW1lLmNvbG9ycy5wcmltYXJ5LCAwLjkpLFxuICAgIGJvcmRlckNvbG9yOiB0aGVtZS5jb2xvcnMucHJpbWFyeSxcbiAgICBjb2xvcjogdGhlbWUuY29sb3JzLnByaW1hcnksXG4gICAgekluZGV4OiB0aGVtZS56SW5kaWNlcy5wcmlvcml0eSxcbiAgICBcIiY6aG92ZXIsICY6Zm9jdXMtdmlzaWJsZVwiOiB7XG4gICAgICBiYWNrZ3JvdW5kQ29sb3I6IHRyYW5zcGFyZW50aXplKHRoZW1lLmNvbG9ycy5wcmltYXJ5LCAwLjgpLFxuICAgIH0sXG4gICAgXCImOmRpc2FibGVkLCAmOmRpc2FibGVkOmhvdmVyLCAmOmRpc2FibGVkOmFjdGl2ZVwiOiB7XG4gICAgICBib3JkZXJDb2xvcjogdGhlbWUuY29sb3JzLmJvcmRlckNvbG9yLFxuICAgICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMuZmFkZWRUZXh0MDUsXG4gICAgICBjb2xvcjogdGhlbWUuY29sb3JzLmZhZGVkVGV4dDQwLFxuICAgICAgY3Vyc29yOiBcIm5vdC1hbGxvd2VkXCIsXG4gICAgfSxcbiAgfVxufSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZEhlYWRlckJ1dHRvbiA9IHN0eWxlZChcbiAgU3R5bGVkQmFzZUJ1dHRvblxuKTxSZXF1aXJlZEJhc2VCdXR0b25Qcm9wcz4oKHsgdGhlbWUgfSkgPT4ge1xuICByZXR1cm4ge1xuICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLnRyYW5zcGFyZW50LFxuICAgIGJvcmRlcjogXCJub25lXCIsXG4gICAgcGFkZGluZzogYDAgJHt0aGVtZS5zcGFjaW5nLnNtfWAsXG4gICAgZm9udFNpemU6IHRoZW1lLmZvbnRTaXplcy5zbSxcbiAgICBtYXJnaW5MZWZ0OiB0aGVtZS5zcGFjaW5nLnRocmVlWFMsXG4gICAgbWFyZ2luUmlnaHQ6IHRoZW1lLnNwYWNpbmcudGhyZWVYUyxcblxuICAgIGxpbmVIZWlnaHQ6IHRoZW1lLmxpbmVIZWlnaHRzLm5vbmUsXG5cbiAgICBtaW5XaWR0aDogdGhlbWUuc2l6ZXMuaGVhZGVySXRlbUhlaWdodCxcbiAgICBtaW5IZWlnaHQ6IHRoZW1lLnNpemVzLmhlYWRlckl0ZW1IZWlnaHQsXG5cbiAgICBcIiY6Zm9jdXNcIjoge1xuICAgICAgb3V0bGluZTogXCJub25lXCIsXG4gICAgfSxcbiAgICBcIiY6Zm9jdXMtdmlzaWJsZVwiOiB7XG4gICAgICBib3hTaGFkb3c6IGAwIDAgMCAwLjJyZW0gJHt0cmFuc3BhcmVudGl6ZSh0aGVtZS5jb2xvcnMuZ3JheTkwLCAwLjgpfWAsXG4gICAgfSxcbiAgICBcIiY6aG92ZXJcIjoge1xuICAgICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMuZGFya2VuZWRCZ01peDE1LFxuICAgIH0sXG4gICAgXCImOmFjdGl2ZVwiOiB7XG4gICAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5kYXJrZW5lZEJnTWl4MjUsXG4gICAgfSxcbiAgICBcIiY6ZGlzYWJsZWQsICY6ZGlzYWJsZWQ6aG92ZXIsICY6ZGlzYWJsZWQ6YWN0aXZlXCI6IHtcbiAgICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLmdyYXkzMCxcbiAgICAgIGJvcmRlckNvbG9yOiB0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnQsXG4gICAgICBjb2xvcjogdGhlbWUuY29sb3JzLmdyYXk2MCxcbiAgICB9LFxuICB9XG59KVxuXG4vLyBUYWtlIG91dCBwYWRkaW5nIGZvciB0aGlzIHNwZWNpZmljIGJ1dHRvbiwgc28gd2UgY2FuIGVuc3VyZSBpdCdzIDMyeDMycHggbGlrZSBvdGhlciBidXR0b25zIGluIENvbW11bml0eSBDbG91ZFxuZXhwb3J0IGNvbnN0IFN0eWxlZEhlYWRlck5vUGFkZGluZ0J1dHRvbiA9IHN0eWxlZChcbiAgU3R5bGVkSGVhZGVyQnV0dG9uXG4pPFJlcXVpcmVkQmFzZUJ1dHRvblByb3BzPigoKSA9PiB7XG4gIHJldHVybiB7XG4gICAgcGFkZGluZzogMCxcbiAgfVxufSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZEJvcmRlcmxlc3NJY29uQnV0dG9uID0gc3R5bGVkKFxuICBTdHlsZWRCYXNlQnV0dG9uXG4pPFJlcXVpcmVkQmFzZUJ1dHRvblByb3BzPigoeyBzaXplLCB0aGVtZSB9KSA9PiB7XG4gIGNvbnN0IGljb25QYWRkaW5nOiBSZWNvcmQ8QmFzZUJ1dHRvblNpemUsIHN0cmluZz4gPSB7XG4gICAgW0Jhc2VCdXR0b25TaXplLlhTTUFMTF06IHRoZW1lLnNwYWNpbmcudGhyZWVYUyxcbiAgICBbQmFzZUJ1dHRvblNpemUuU01BTExdOiB0aGVtZS5zcGFjaW5nLnR3b1hTLFxuICAgIFtCYXNlQnV0dG9uU2l6ZS5NRURJVU1dOiB0aGVtZS5zcGFjaW5nLm1kLFxuICAgIFtCYXNlQnV0dG9uU2l6ZS5MQVJHRV06IHRoZW1lLnNwYWNpbmcubGcsXG4gIH1cblxuICByZXR1cm4ge1xuICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLnRyYW5zcGFyZW50LFxuICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMuZmFkZWRUZXh0NjAsXG4gICAgcGFkZGluZzogaWNvblBhZGRpbmdbc2l6ZV0sXG4gICAgbWFyZ2luTGVmdDogdGhlbWUuc3BhY2luZy5ub25lLFxuICAgIG1hcmdpblJpZ2h0OiB0aGVtZS5zcGFjaW5nLm5vbmUsXG5cbiAgICAvLyBLZWVwcyB0aGUgYnV0dG9ucyBmcm9tIHN0YWNraW5nIHdoZW4gaW4gY29udGFpbmVyV2lkdGggbW9kZS5cbiAgICAvLyBUaGVzZSBidXR0b25zIHNob3VsZCBzdGF5IHRvZ2V0aGVyIGFuZCBub3Qgc3RyZXRjaCB0byBmaWxsIHRoZSBjb250YWluZXIuXG4gICAgZmxleDogXCIwIDAgZml0LWNvbnRlbnRcIixcblxuICAgIGJvcmRlcjogXCJub25lXCIsXG4gICAgZGlzcGxheTogXCJmbGV4XCIsXG4gICAgbWluSGVpZ2h0OiBcInVuc2V0XCIsXG5cbiAgICBcIiY6Zm9jdXNcIjoge1xuICAgICAgYm94U2hhZG93OiBcIm5vbmVcIixcbiAgICAgIG91dGxpbmU6IFwibm9uZVwiLFxuICAgIH0sXG4gICAgXCImOmhvdmVyXCI6IHtcbiAgICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMuYm9keVRleHQsXG4gICAgfSxcbiAgICBcIiY6ZGlzYWJsZWQsICY6ZGlzYWJsZWQ6aG92ZXIsICY6ZGlzYWJsZWQ6YWN0aXZlXCI6IHtcbiAgICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMuZmFkZWRUZXh0MTAsXG4gICAgICBjdXJzb3I6IFwibm90LWFsbG93ZWRcIixcblxuICAgICAgLy8gRm9yIGltYWdlIGNvbnRlbnRcbiAgICAgIGltZzoge1xuICAgICAgICBvcGFjaXR5OiAwLjQsXG4gICAgICB9LFxuICAgIH0sXG4gIH1cbn0pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRCb3JkZXJsZXNzSWNvbkJ1dHRvbkFjdGl2ZSA9IHN0eWxlZChcbiAgU3R5bGVkQm9yZGVybGVzc0ljb25CdXR0b25cbik8UmVxdWlyZWRCYXNlQnV0dG9uUHJvcHM+KCh7IHRoZW1lIH0pID0+IHtcbiAgcmV0dXJuIHtcbiAgICBjb2xvcjogdGhlbWUuY29sb3JzLmJvZHlUZXh0LFxuICAgIFwiJjpkaXNhYmxlZCwgJjpkaXNhYmxlZDpob3ZlciwgJjpkaXNhYmxlZDphY3RpdmVcIjoge1xuICAgICAgY29sb3I6IHRoZW1lLmNvbG9ycy5mYWRlZFRleHQ0MCxcbiAgICB9LFxuICB9XG59KVxuXG5leHBvcnQgY29uc3QgU3R5bGVkVG9vbHRpcE5vcm1hbCA9IHN0eWxlZC5kaXYoKHsgdGhlbWUgfSkgPT4gKHtcbiAgZGlzcGxheTogXCJibG9ja1wiLFxuICBbYEBtZWRpYSAobWF4LXdpZHRoOiAke3RoZW1lLmJyZWFrcG9pbnRzLnNtfSlgXToge1xuICAgIGRpc3BsYXk6IFwibm9uZVwiLFxuICB9LFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRUb29sdGlwTW9iaWxlID0gc3R5bGVkLmRpdigoeyB0aGVtZSB9KSA9PiAoe1xuICBkaXNwbGF5OiBcIm5vbmVcIixcbiAgW2BAbWVkaWEgKG1heC13aWR0aDogJHt0aGVtZS5icmVha3BvaW50cy5zbX0pYF06IHtcbiAgICBkaXNwbGF5OiBcImJsb2NrXCIsXG4gIH0sXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZEVsZW1lbnRUb29sYmFyQnV0dG9uID0gc3R5bGVkKFxuICBTdHlsZWRCYXNlQnV0dG9uXG4pPFJlcXVpcmVkQmFzZUJ1dHRvblByb3BzPigoeyB0aGVtZSB9KSA9PiB7XG4gIHJldHVybiB7XG4gICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnQsXG4gICAgYm9yZGVyOiBcIm5vbmVcIixcbiAgICBwYWRkaW5nOiB0aGVtZS5zcGFjaW5nLnR3b1hTLFxuICAgIGZvbnRTaXplOiB0aGVtZS5mb250U2l6ZXMudHdvU20sXG4gICAgbWFyZ2luTGVmdDogdGhlbWUuc3BhY2luZy5ub25lLFxuICAgIG1hcmdpblJpZ2h0OiB0aGVtZS5zcGFjaW5nLm5vbmUsXG4gICAgZGlzcGxheTogXCJmbGV4XCIsXG4gICAgZ2FwOiB0aGVtZS5zcGFjaW5nLnhzLFxuICAgIGFsaWduSXRlbXM6IFwiY2VudGVyXCIsXG4gICAgbWluSGVpZ2h0OiBcInVuc2V0XCIsXG4gICAgLy8gbGluZSBoZWlnaHQgc2hvdWxkIGJlIHRoZSBzYW1lIGFzIHRoZSBpY29uIHNpemVcbiAgICBsaW5lSGVpZ2h0OiB0aGVtZS5pY29uU2l6ZXMubWQsXG4gICAgd2lkdGg6IFwiYXV0b1wiLFxuXG4gICAgXCImOmZvY3VzXCI6IHtcbiAgICAgIG91dGxpbmU6IFwibm9uZVwiLFxuICAgICAgYm9yZGVyOiBcIm5vbmVcIixcbiAgICAgIGJveFNoYWRvdzogXCJub25lXCIsXG4gICAgfSxcbiAgICBcIiY6Zm9jdXMtdmlzaWJsZVwiOiB7XG4gICAgICBvdXRsaW5lOiBcIm5vbmVcIixcbiAgICAgIGJvcmRlcjogXCJub25lXCIsXG4gICAgICBib3hTaGFkb3c6IFwibm9uZVwiLFxuICAgICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMuZGFya2VuZWRCZ01peDI1LFxuICAgIH0sXG4gICAgXCImOmhvdmVyXCI6IHtcbiAgICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLmRhcmtlbmVkQmdNaXgxNSxcbiAgICB9LFxuICAgIFwiJjphY3RpdmVcIjoge1xuICAgICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMuZGFya2VuZWRCZ01peDI1LFxuICAgIH0sXG4gICAgXCImOmRpc2FibGVkLCAmOmRpc2FibGVkOmhvdmVyLCAmOmRpc2FibGVkOmFjdGl2ZVwiOiB7XG4gICAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5ncmF5MzAsXG4gICAgICBib3JkZXJDb2xvcjogdGhlbWUuY29sb3JzLnRyYW5zcGFyZW50LFxuICAgICAgY29sb3I6IHRoZW1lLmNvbG9ycy5ncmF5NjAsXG4gICAgfSxcbiAgfVxufSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZEJ1dHRvbkdyb3VwID0gc3R5bGVkLmRpdjx7IGNvbnRhaW5lcldpZHRoOiBib29sZWFuIH0+KFxuICAoeyBjb250YWluZXJXaWR0aCB9KSA9PiAoe1xuICAgIHdpZHRoOiBjb250YWluZXJXaWR0aCA/IFwiMTAwJVwiIDogXCJhdXRvXCIsXG4gIH0pXG4pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRCdXR0b25MYWJlbCA9IHN0eWxlZC5kaXYoKCkgPT4gKHtcbiAgZGlzcGxheTogXCJmbGV4XCIsXG4gIGFsaWduSXRlbXM6IFwiY2VudGVyXCIsXG4gIGp1c3RpZnlDb250ZW50OiBcImNlbnRlclwiLFxuICB3aWR0aDogXCIxMDAlXCIsXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZEJ1dHRvbk1haW5MYWJlbCA9IHN0eWxlZC5zcGFuKCh7IHRoZW1lIH0pID0+ICh7XG4gIGRpc3BsYXk6IFwiaW5saW5lLWZsZXhcIixcbiAgYWxpZ25JdGVtczogXCJjZW50ZXJcIixcbiAganVzdGlmeUNvbnRlbnQ6IFwiY2VudGVyXCIsXG4gIGdhcDogdGhlbWUuc3BhY2luZy5zbSxcbiAgbWluV2lkdGg6IDAsXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZEJ1dHRvblNob3J0Y3V0ID0gc3R5bGVkLmtiZCgoeyB0aGVtZSB9KSA9PiAoe1xuICBkaXNwbGF5OiBcImlubGluZS1mbGV4XCIsXG4gIGFsaWduSXRlbXM6IFwiY2VudGVyXCIsXG4gIGp1c3RpZnlDb250ZW50OiBcImNlbnRlclwiLFxuICB3aGl0ZVNwYWNlOiBcIm5vd3JhcFwiLFxuICBmb250U2l6ZTogdGhlbWUuZm9udFNpemVzLnNtLFxuICBvcGFjaXR5OiAwLjYsXG4gIGZvbnRGYW1pbHk6IFwiaW5oZXJpdFwiLFxuICBsaW5lSGVpZ2h0OiB0aGVtZS5saW5lSGVpZ2h0cy50aWdodCxcbiAgbGV0dGVyU3BhY2luZzogXCIwLjAxZW1cIixcbn0pKVxuIl19 */"), StyledHeaderNoPaddingButton = /* @__PURE__ */ createStyled(StyledHeaderButton, process.env.NODE_ENV === "production" ? {
  target: "ef3psqc9"
} : {
  target: "ef3psqc9",
  label: "StyledHeaderNoPaddingButton"
})(() => ({
  padding: 0
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledBorderlessIconButton = /* @__PURE__ */ createStyled(StyledBaseButton, process.env.NODE_ENV === "production" ? {
  target: "ef3psqc8"
} : {
  target: "ef3psqc8",
  label: "StyledBorderlessIconButton"
})(({
  size: o,
  theme: E
}) => {
  const A = {
    xsmall: E.spacing.threeXS,
    small: E.spacing.twoXS,
    medium: E.spacing.md,
    large: E.spacing.lg
  };
  return {
    backgroundColor: E.colors.transparent,
    color: E.colors.fadedText60,
    padding: A[o],
    marginLeft: E.spacing.none,
    marginRight: E.spacing.none,
    // Keeps the buttons from stacking when in containerWidth mode.
    // These buttons should stay together and not stretch to fill the container.
    flex: "0 0 fit-content",
    border: "none",
    display: "flex",
    minHeight: "unset",
    "&:focus": {
      boxShadow: "none",
      outline: "none"
    },
    "&:hover": {
      color: E.colors.bodyText
    },
    "&:disabled, &:disabled:hover, &:disabled:active": {
      color: E.colors.fadedText10,
      cursor: "not-allowed",
      // For image content
      img: {
        opacity: 0.4
      }
    }
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledBorderlessIconButtonActive = /* @__PURE__ */ createStyled(StyledBorderlessIconButton, process.env.NODE_ENV === "production" ? {
  target: "ef3psqc7"
} : {
  target: "ef3psqc7",
  label: "StyledBorderlessIconButtonActive"
})(({
  theme: o
}) => ({
  color: o.colors.bodyText,
  "&:disabled, &:disabled:hover, &:disabled:active": {
    color: o.colors.fadedText40
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledTooltipNormal = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "ef3psqc6"
} : {
  target: "ef3psqc6",
  label: "StyledTooltipNormal"
})(({
  theme: o
}) => ({
  display: "block",
  [`@media (max-width: ${o.breakpoints.sm})`]: {
    display: "none"
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledTooltipMobile = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "ef3psqc5"
} : {
  target: "ef3psqc5",
  label: "StyledTooltipMobile"
})(({
  theme: o
}) => ({
  display: "none",
  [`@media (max-width: ${o.breakpoints.sm})`]: {
    display: "block"
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledElementToolbarButton = /* @__PURE__ */ createStyled(StyledBaseButton, process.env.NODE_ENV === "production" ? {
  target: "ef3psqc4"
} : {
  target: "ef3psqc4",
  label: "StyledElementToolbarButton"
})(({
  theme: o
}) => ({
  backgroundColor: o.colors.transparent,
  border: "none",
  padding: o.spacing.twoXS,
  fontSize: o.fontSizes.twoSm,
  marginLeft: o.spacing.none,
  marginRight: o.spacing.none,
  display: "flex",
  gap: o.spacing.xs,
  alignItems: "center",
  minHeight: "unset",
  // line height should be the same as the icon size
  lineHeight: o.iconSizes.md,
  width: "auto",
  "&:focus": {
    outline: "none",
    border: "none",
    boxShadow: "none"
  },
  "&:focus-visible": {
    outline: "none",
    border: "none",
    boxShadow: "none",
    backgroundColor: o.colors.darkenedBgMix25
  },
  "&:hover": {
    backgroundColor: o.colors.darkenedBgMix15
  },
  "&:active": {
    backgroundColor: o.colors.darkenedBgMix25
  },
  "&:disabled, &:disabled:hover, &:disabled:active": {
    backgroundColor: o.colors.gray30,
    borderColor: o.colors.transparent,
    color: o.colors.gray60
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2xpYi9zcmMvY29tcG9uZW50cy9zaGFyZWQvQmFzZUJ1dHRvbi9zdHlsZWQtY29tcG9uZW50cy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUF5ZDBDIiwiZmlsZSI6Ii9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2xpYi9zcmMvY29tcG9uZW50cy9zaGFyZWQvQmFzZUJ1dHRvbi9zdHlsZWQtY29tcG9uZW50cy50cyIsInNvdXJjZXNDb250ZW50IjpbIi8qKlxuICogQ29weXJpZ2h0IChjKSBTdHJlYW1saXQgSW5jLiAoMjAxOC0yMDIyKSBTbm93Zmxha2UgSW5jLiAoMjAyMi0yMDI1KVxuICpcbiAqIExpY2Vuc2VkIHVuZGVyIHRoZSBBcGFjaGUgTGljZW5zZSwgVmVyc2lvbiAyLjAgKHRoZSBcIkxpY2Vuc2VcIik7XG4gKiB5b3UgbWF5IG5vdCB1c2UgdGhpcyBmaWxlIGV4Y2VwdCBpbiBjb21wbGlhbmNlIHdpdGggdGhlIExpY2Vuc2UuXG4gKiBZb3UgbWF5IG9idGFpbiBhIGNvcHkgb2YgdGhlIExpY2Vuc2UgYXRcbiAqXG4gKiAgICAgaHR0cDovL3d3dy5hcGFjaGUub3JnL2xpY2Vuc2VzL0xJQ0VOU0UtMi4wXG4gKlxuICogVW5sZXNzIHJlcXVpcmVkIGJ5IGFwcGxpY2FibGUgbGF3IG9yIGFncmVlZCB0byBpbiB3cml0aW5nLCBzb2Z0d2FyZVxuICogZGlzdHJpYnV0ZWQgdW5kZXIgdGhlIExpY2Vuc2UgaXMgZGlzdHJpYnV0ZWQgb24gYW4gXCJBUyBJU1wiIEJBU0lTLFxuICogV0lUSE9VVCBXQVJSQU5USUVTIE9SIENPTkRJVElPTlMgT0YgQU5ZIEtJTkQsIGVpdGhlciBleHByZXNzIG9yIGltcGxpZWQuXG4gKiBTZWUgdGhlIExpY2Vuc2UgZm9yIHRoZSBzcGVjaWZpYyBsYW5ndWFnZSBnb3Zlcm5pbmcgcGVybWlzc2lvbnMgYW5kXG4gKiBsaW1pdGF0aW9ucyB1bmRlciB0aGUgTGljZW5zZS5cbiAqL1xuXG5pbXBvcnQgeyBNb3VzZUV2ZW50LCBSZWFjdE5vZGUgfSBmcm9tIFwicmVhY3RcIlxuXG5pbXBvcnQgc3R5bGVkLCB7IENTU09iamVjdCB9IGZyb20gXCJAZW1vdGlvbi9zdHlsZWRcIlxuaW1wb3J0IHsgZGFya2VuLCB0cmFuc3BhcmVudGl6ZSB9IGZyb20gXCJjb2xvcjJrXCJcblxuaW1wb3J0IHsgRW1vdGlvblRoZW1lIH0gZnJvbSBcIn5saWIvdGhlbWVcIlxuXG5leHBvcnQgZW51bSBCYXNlQnV0dG9uS2luZCB7XG4gIFBSSU1BUlkgPSBcInByaW1hcnlcIixcbiAgU0VDT05EQVJZID0gXCJzZWNvbmRhcnlcIixcbiAgVEVSVElBUlkgPSBcInRlcnRpYXJ5XCIsXG4gIEdIT1NUID0gXCJnaG9zdFwiLFxuICBCT1JERVJMRVNTX0lDT04gPSBcImJvcmRlcmxlc3NJY29uXCIsXG4gIEJPUkRFUkxFU1NfSUNPTl9BQ1RJVkUgPSBcImJvcmRlcmxlc3NJY29uQWN0aXZlXCIsXG4gIE1JTklNQUwgPSBcIm1pbmltYWxcIixcbiAgUFJJTUFSWV9GT1JNX1NVQk1JVCA9IFwicHJpbWFyeUZvcm1TdWJtaXRcIixcbiAgU0VDT05EQVJZX0ZPUk1fU1VCTUlUID0gXCJzZWNvbmRhcnlGb3JtU3VibWl0XCIsXG4gIFRFUlRJQVJZX0ZPUk1fU1VCTUlUID0gXCJ0ZXJ0aWFyeUZvcm1TdWJtaXRcIixcbiAgSEVBREVSX0JVVFRPTiA9IFwiaGVhZGVyXCIsXG4gIEhFQURFUl9OT19QQURESU5HID0gXCJoZWFkZXJOb1BhZGRpbmdcIixcbiAgRUxFTUVOVF9UT09MQkFSID0gXCJlbGVtZW50VG9vbGJhclwiLFxuICBQSUxMUyA9IFwicGlsbHNcIixcbiAgUElMTFNfQUNUSVZFID0gXCJwaWxsc0FjdGl2ZVwiLFxuICBTRUdNRU5URURfQ09OVFJPTCA9IFwic2VnbWVudGVkX2NvbnRyb2xcIixcbiAgU0VHTUVOVEVEX0NPTlRST0xfQUNUSVZFID0gXCJzZWdtZW50ZWRfY29udHJvbEFjdGl2ZVwiLFxufVxuXG5leHBvcnQgZW51bSBCYXNlQnV0dG9uU2l6ZSB7XG4gIFhTTUFMTCA9IFwieHNtYWxsXCIsXG4gIFNNQUxMID0gXCJzbWFsbFwiLFxuICBNRURJVU0gPSBcIm1lZGl1bVwiLFxuICBMQVJHRSA9IFwibGFyZ2VcIixcbn1cblxuZXhwb3J0IGludGVyZmFjZSBCYXNlQnV0dG9uUHJvcHMge1xuICBraW5kOiBCYXNlQnV0dG9uS2luZFxuICBzaXplPzogQmFzZUJ1dHRvblNpemVcbiAgLy8gZXNsaW50LWRpc2FibGUtbmV4dC1saW5lIEB0eXBlc2NyaXB0LWVzbGludC9uby1leHBsaWNpdC1hbnkgLS0gVE9ETzogUmVwbGFjZSAnYW55JyB3aXRoIGEgbW9yZSBzcGVjaWZpYyB0eXBlLlxuICBvbkNsaWNrPzogKGV2ZW50OiBNb3VzZUV2ZW50PEhUTUxCdXR0b25FbGVtZW50PikgPT4gYW55XG4gIGRpc2FibGVkPzogYm9vbGVhblxuICAvLyBJZiB0cnVlLCB0aGUgYnV0dG9uIHNob3VsZCB0YWtlIHVwIGNvbnRhaW5lcidzIGZ1bGwgd2lkdGhcbiAgY29udGFpbmVyV2lkdGg/OiBib29sZWFuXG4gIGNoaWxkcmVuOiBSZWFjdE5vZGVcbiAgYXV0b0ZvY3VzPzogYm9vbGVhblxuICBcImRhdGEtdGVzdGlkXCI/OiBzdHJpbmdcbiAgXCJhcmlhLWxhYmVsXCI/OiBzdHJpbmdcbn1cblxudHlwZSBSZXF1aXJlZEJhc2VCdXR0b25Qcm9wcyA9IFJlcXVpcmVkPEJhc2VCdXR0b25Qcm9wcz5cblxuZnVuY3Rpb24gZ2V0U2l6ZVN0eWxlKHNpemU6IEJhc2VCdXR0b25TaXplLCB0aGVtZTogRW1vdGlvblRoZW1lKTogQ1NTT2JqZWN0IHtcbiAgc3dpdGNoIChzaXplKSB7XG4gICAgY2FzZSBCYXNlQnV0dG9uU2l6ZS5YU01BTEw6XG4gICAgICByZXR1cm4ge1xuICAgICAgICBwYWRkaW5nOiBgJHt0aGVtZS5zcGFjaW5nLnR3b1hTfSAke3RoZW1lLnNwYWNpbmcuc219YCxcbiAgICAgICAgZm9udFNpemU6IHRoZW1lLmZvbnRTaXplcy5zbSxcbiAgICAgIH1cbiAgICBjYXNlIEJhc2VCdXR0b25TaXplLlNNQUxMOlxuICAgICAgcmV0dXJuIHtcbiAgICAgICAgcGFkZGluZzogYCR7dGhlbWUuc3BhY2luZy50d29YU30gJHt0aGVtZS5zcGFjaW5nLm1kfWAsXG4gICAgICB9XG4gICAgY2FzZSBCYXNlQnV0dG9uU2l6ZS5MQVJHRTpcbiAgICAgIHJldHVybiB7XG4gICAgICAgIHBhZGRpbmc6IGAke3RoZW1lLnNwYWNpbmcubWR9ICR7dGhlbWUuc3BhY2luZy5tZH1gLFxuICAgICAgfVxuICAgIGRlZmF1bHQ6XG4gICAgICByZXR1cm4ge1xuICAgICAgICBwYWRkaW5nOiBgJHt0aGVtZS5zcGFjaW5nLnhzfSAke3RoZW1lLnNwYWNpbmcubWR9YCxcbiAgICAgIH1cbiAgfVxufVxuXG5leHBvcnQgY29uc3QgU3R5bGVkQmFzZUJ1dHRvbiA9IHN0eWxlZC5idXR0b248UmVxdWlyZWRCYXNlQnV0dG9uUHJvcHM+KFxuICAoeyBjb250YWluZXJXaWR0aCwgc2l6ZSwgdGhlbWUgfSkgPT4ge1xuICAgIHJldHVybiB7XG4gICAgICBkaXNwbGF5OiBcImlubGluZS1mbGV4XCIsXG4gICAgICBhbGlnbkl0ZW1zOiBcImNlbnRlclwiLFxuICAgICAganVzdGlmeUNvbnRlbnQ6IFwiY2VudGVyXCIsXG4gICAgICBmb250V2VpZ2h0OiB0aGVtZS5mb250V2VpZ2h0cy5ub3JtYWwsXG4gICAgICBwYWRkaW5nOiBgJHt0aGVtZS5zcGFjaW5nLnhzfSAke3RoZW1lLnNwYWNpbmcubWR9YCxcbiAgICAgIGJvcmRlclJhZGl1czogdGhlbWUucmFkaWkuYnV0dG9uLFxuICAgICAgbWluSGVpZ2h0OiB0aGVtZS5zaXplcy5taW5FbGVtZW50SGVpZ2h0LFxuICAgICAgbWFyZ2luOiB0aGVtZS5zcGFjaW5nLm5vbmUsXG4gICAgICBsaW5lSGVpZ2h0OiB0aGVtZS5saW5lSGVpZ2h0cy5iYXNlLFxuICAgICAgdGV4dFRyYW5zZm9ybTogXCJub25lXCIsXG4gICAgICBmb250U2l6ZTogXCJpbmhlcml0XCIsXG4gICAgICBmb250RmFtaWx5OiBcImluaGVyaXRcIixcbiAgICAgIGNvbG9yOiBcImluaGVyaXRcIixcbiAgICAgIHdpZHRoOiBjb250YWluZXJXaWR0aCA/IFwiMTAwJVwiIDogXCJhdXRvXCIsXG4gICAgICBjdXJzb3I6IFwicG9pbnRlclwiLFxuICAgICAgdXNlclNlbGVjdDogXCJub25lXCIsXG4gICAgICBcIiY6Zm9jdXNcIjoge1xuICAgICAgICBvdXRsaW5lOiBcIm5vbmVcIixcbiAgICAgIH0sXG4gICAgICBcIiY6Zm9jdXMtdmlzaWJsZVwiOiB7XG4gICAgICAgIC8vIFdoZW4gZm9jdXMtdmlzaWJsZSAoZS5nLiBpZiB0aGUgYnV0dG9uIHdhcyBmb2N1c2VkIHZpYSBrZXlib2FyZCBuYXZpZ2F0aW9uKVxuICAgICAgICAvLyB3ZSB1c2UgdGhlIGhvdmVyIHN0eWxlIG9mIHRoZSByZXNwZWN0aXZlIGJ1dHRvbiB0eXBlIChzZWUgYmVsb3cpIGFuZFxuICAgICAgICAvLyBhZGRpdGlvbmFsbHkgc2hvdyBhIGNvbG9yZWQgZm9jdXMgcmluZ1xuICAgICAgICBib3hTaGFkb3c6IGAwIDAgMCAwLjJyZW0gJHt0cmFuc3BhcmVudGl6ZSh0aGVtZS5jb2xvcnMucHJpbWFyeSwgMC41KX1gLFxuICAgICAgfSxcbiAgICAgIC4uLmdldFNpemVTdHlsZShzaXplLCB0aGVtZSksXG4gICAgfVxuICB9XG4pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRQcmltYXJ5QnV0dG9uID0gc3R5bGVkKFxuICBTdHlsZWRCYXNlQnV0dG9uXG4pPFJlcXVpcmVkQmFzZUJ1dHRvblByb3BzPigoeyB0aGVtZSB9KSA9PiAoe1xuICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5wcmltYXJ5LFxuICBjb2xvcjogdGhlbWUuY29sb3JzLndoaXRlLFxuICBib3JkZXI6IGAke3RoZW1lLnNpemVzLmJvcmRlcldpZHRofSBzb2xpZCAke3RoZW1lLmNvbG9ycy5wcmltYXJ5fWAsXG4gIFwiJjpob3ZlciwgJjpmb2N1cy12aXNpYmxlXCI6IHtcbiAgICBiYWNrZ3JvdW5kQ29sb3I6IGRhcmtlbih0aGVtZS5jb2xvcnMucHJpbWFyeSwgMC4xNSksXG4gICAgYm9yZGVyQ29sb3I6IGRhcmtlbih0aGVtZS5jb2xvcnMucHJpbWFyeSwgMC4xNSksXG4gIH0sXG4gIFwiJjphY3RpdmVcIjoge1xuICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLnByaW1hcnksXG4gICAgLy8gS2VlcCB0aGUgYm9yZGVyIGRhcmtlciB3aGVuIGNsaWNrZWQgc28gdGhhdCB0aGUgYnV0dG9uIGxvb2tzIFwicHJlc3NlZFwiXG4gICAgYm9yZGVyQ29sb3I6IGRhcmtlbih0aGVtZS5jb2xvcnMucHJpbWFyeSwgMC4xNSksXG4gIH0sXG4gIFwiJjpkaXNhYmxlZCwgJjpkaXNhYmxlZDpob3ZlciwgJjpkaXNhYmxlZDphY3RpdmVcIjoge1xuICAgIGJvcmRlckNvbG9yOiB0aGVtZS5jb2xvcnMuYm9yZGVyQ29sb3IsXG4gICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnQsXG4gICAgY29sb3I6IHRoZW1lLmNvbG9ycy5mYWRlZFRleHQ0MCxcbiAgICBjdXJzb3I6IFwibm90LWFsbG93ZWRcIixcbiAgfSxcbn0pKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkU2Vjb25kYXJ5QnV0dG9uID0gc3R5bGVkKFxuICBTdHlsZWRCYXNlQnV0dG9uXG4pPFJlcXVpcmVkQmFzZUJ1dHRvblByb3BzPigoeyB0aGVtZSB9KSA9PiAoe1xuICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5saWdodGVuZWRCZzA1LFxuICBib3JkZXI6IGAke3RoZW1lLnNpemVzLmJvcmRlcldpZHRofSBzb2xpZCAke3RoZW1lLmNvbG9ycy5ib3JkZXJDb2xvcn1gLFxuICBcIiY6aG92ZXIsICY6Zm9jdXMtdmlzaWJsZVwiOiB7XG4gICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMuZGFya2VuZWRCZ01peDE1LFxuICB9LFxuICBcIiY6YWN0aXZlXCI6IHtcbiAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5kYXJrZW5lZEJnTWl4MjUsXG4gIH0sXG4gIFwiJjpkaXNhYmxlZCwgJjpkaXNhYmxlZDpob3ZlciwgJjpkaXNhYmxlZDphY3RpdmVcIjoge1xuICAgIGJvcmRlckNvbG9yOiB0aGVtZS5jb2xvcnMuYm9yZGVyQ29sb3IsXG4gICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnQsXG4gICAgY29sb3I6IHRoZW1lLmNvbG9ycy5mYWRlZFRleHQ0MCxcbiAgICBjdXJzb3I6IFwibm90LWFsbG93ZWRcIixcbiAgfSxcbn0pKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkVGVydGlhcnlCdXR0b24gPSBzdHlsZWQoXG4gIFN0eWxlZEJhc2VCdXR0b25cbik8UmVxdWlyZWRCYXNlQnV0dG9uUHJvcHM+KCh7IHRoZW1lIH0pID0+IHtcbiAgcmV0dXJuIHtcbiAgICBwYWRkaW5nOiB0aGVtZS5zcGFjaW5nLm5vbmUsXG4gICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnQsXG4gICAgYm9yZGVyOiBcIm5vbmVcIixcbiAgICBcIiY6aG92ZXIsICY6Zm9jdXMtdmlzaWJsZVwiOiB7XG4gICAgICBjb2xvcjogdGhlbWUuY29sb3JzLnByaW1hcnksXG4gICAgfSxcbiAgICBcIiY6aG92ZXI6bm90KDpkaXNhYmxlZCksICY6Zm9jdXMtdmlzaWJsZTpub3QoOmRpc2FibGVkKVwiOiB7XG4gICAgICAvLyBBbHNvIG1ha2UgY29sb3JlZCB0ZXh0IGhhdmUgdGhlIHByaW1hcnkgY29sb3Igb24gaG92ZXIuIFNpbmNlIHRleHQgY29sb3IgaXNcbiAgICAgIC8vIGFwcGxpZWQgYXMgYW4gaW5saW5lIHN0eWxlIHdlIG5lZWQgdG8gdXNlICFpbXBvcnRhbnQgdG8gb3ZlcnJpZGUgaXQuXG4gICAgICAvLyBOb3RlIHRoYXQgd2UncmUgbm90IGRvaW5nIHRoaXMgd2hlbiBkaXNhYmxlZC4gV2Ugc2hvdWxkIHByb2JhYmx5IGRvIHRoYXQgYXNcbiAgICAgIC8vIHdlbGwgYnV0IHdlIGRvbid0IGRvIGl0IGFueXdoZXJlIGVsc2UuXG4gICAgICBcInNwYW4uc3RNYXJrZG93bkNvbG9yZWRUZXh0XCI6IHtcbiAgICAgICAgY29sb3I6IFwiaW5oZXJpdCAhaW1wb3J0YW50XCIsXG4gICAgICB9LFxuICAgIH0sXG4gICAgXCImOmFjdGl2ZVwiOiB7XG4gICAgICBjb2xvcjogZGFya2VuKHRoZW1lLmNvbG9ycy5wcmltYXJ5LCAwLjI1KSxcbiAgICB9LFxuICAgIFwiJjpkaXNhYmxlZCwgJjpkaXNhYmxlZDpob3ZlciwgJjpkaXNhYmxlZDphY3RpdmVcIjoge1xuICAgICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnQsXG4gICAgICBjb2xvcjogdGhlbWUuY29sb3JzLmZhZGVkVGV4dDQwLFxuICAgICAgY3Vyc29yOiBcIm5vdC1hbGxvd2VkXCIsXG4gICAgfSxcbiAgfVxufSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZEdob3N0QnV0dG9uID0gc3R5bGVkKFxuICBTdHlsZWRCYXNlQnV0dG9uXG4pPFJlcXVpcmVkQmFzZUJ1dHRvblByb3BzPigoeyB0aGVtZSB9KSA9PiAoe1xuICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy50cmFuc3BhcmVudCxcbiAgYm9yZGVyOiBgJHt0aGVtZS5zaXplcy5ib3JkZXJXaWR0aH0gc29saWQgJHt0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnR9YCxcbiAgXCImOmhvdmVyLCAmOmZvY3VzLXZpc2libGVcIjoge1xuICAgIGJvcmRlckNvbG9yOiB0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnQsXG4gICAgY29sb3I6IHRoZW1lLmNvbG9ycy5wcmltYXJ5LFxuICB9LFxuICBcIiY6YWN0aXZlXCI6IHtcbiAgICBjb2xvcjogdGhlbWUuY29sb3JzLnByaW1hcnksXG4gICAgYm9yZGVyQ29sb3I6IHRoZW1lLmNvbG9ycy50cmFuc3BhcmVudCxcbiAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy50cmFuc3BhcmVudCxcbiAgfSxcbiAgXCImOmRpc2FibGVkLCAmOmRpc2FibGVkOmhvdmVyLCAmOmRpc2FibGVkOmFjdGl2ZVwiOiB7XG4gICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMuZ3JheTMwLFxuICAgIGJvcmRlckNvbG9yOiB0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnQsXG4gICAgY29sb3I6IHRoZW1lLmNvbG9ycy5ncmF5NjAsXG4gIH0sXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZE1pbmltYWxCdXR0b24gPSBzdHlsZWQoXG4gIFN0eWxlZEJhc2VCdXR0b25cbik8UmVxdWlyZWRCYXNlQnV0dG9uUHJvcHM+KCh7IHRoZW1lIH0pID0+ICh7XG4gIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLnRyYW5zcGFyZW50LFxuICBib3JkZXI6IFwibm9uZVwiLFxuICBib3hTaGFkb3c6IFwibm9uZVwiLFxuICBwYWRkaW5nOiB0aGVtZS5zcGFjaW5nLm5vbmUsXG4gIFwiJjpob3ZlciwgJjphY3RpdmUsICY6Zm9jdXMtdmlzaWJsZVwiOiB7XG4gICAgY29sb3I6IHRoZW1lLmNvbG9ycy5wcmltYXJ5LFxuICB9LFxuICBcIiY6ZGlzYWJsZWQsICY6ZGlzYWJsZWQ6aG92ZXIsICY6ZGlzYWJsZWQ6YWN0aXZlXCI6IHtcbiAgICBjb2xvcjogdGhlbWUuY29sb3JzLmZhZGVkVGV4dDQwLFxuICAgIGN1cnNvcjogXCJub3QtYWxsb3dlZFwiLFxuICB9LFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRQcmltYXJ5Rm9ybVN1Ym1pdEJ1dHRvbiA9XG4gIHN0eWxlZChTdHlsZWRQcmltYXJ5QnV0dG9uKTxSZXF1aXJlZEJhc2VCdXR0b25Qcm9wcz4oKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkU2Vjb25kYXJ5Rm9ybVN1Ym1pdEJ1dHRvbiA9IHN0eWxlZChcbiAgU3R5bGVkU2Vjb25kYXJ5QnV0dG9uXG4pPFJlcXVpcmVkQmFzZUJ1dHRvblByb3BzPigpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRUZXJ0aWFyeUZvcm1TdWJtaXRCdXR0b24gPSBzdHlsZWQoXG4gIFN0eWxlZFRlcnRpYXJ5QnV0dG9uXG4pPFJlcXVpcmVkQmFzZUJ1dHRvblByb3BzPigpXG5cbmNvbnN0IFN0eWxlZEJ1dHRvbkdyb3VwQmFzZUJ1dHRvbiA9IHN0eWxlZChcbiAgU3R5bGVkQmFzZUJ1dHRvblxuKTxSZXF1aXJlZEJhc2VCdXR0b25Qcm9wcz4oKHsgdGhlbWUgfSkgPT4ge1xuICByZXR1cm4ge1xuICAgIGJhY2tncm91bmQ6IHRoZW1lLmNvbG9ycy5iZ0NvbG9yLFxuICAgIGJvcmRlcjogYCR7dGhlbWUuc2l6ZXMuYm9yZGVyV2lkdGh9IHNvbGlkICR7dGhlbWUuY29sb3JzLmJvcmRlckNvbG9yfWAsXG4gICAgZm9udFNpemU6IHRoZW1lLmZvbnRTaXplcy5zbSxcbiAgICBsaW5lSGVpZ2h0OiB0aGVtZS5saW5lSGVpZ2h0cy5iYXNlLFxuICAgIGZvbnRXZWlnaHQ6IHRoZW1lLmZvbnRXZWlnaHRzLm5vcm1hbCxcbiAgICBoZWlnaHQ6IHRoZW1lLnNpemVzLmxhcmdlTG9nb0hlaWdodCxcbiAgICBtaW5IZWlnaHQ6IHRoZW1lLnNpemVzLmxhcmdlTG9nb0hlaWdodCxcbiAgICBtYXhXaWR0aDogdGhlbWUuc2l6ZXMuY29udGVudE1heFdpZHRoLFxuXG4gICAgLy8gc2hvdyBwaWxscyB3aXRoIGxvbmcgdGV4dCBpbiBzaW5nbGUgbGluZSBhbmQgdXNlIGVsbGlwc2lzIGZvciBvdmVyZmxvd1xuICAgIHdoaXRlU3BhY2U6IFwibm93cmFwXCIsXG4gICAgb3ZlcmZsb3c6IFwiaGlkZGVuXCIsXG4gICAgdGV4dE92ZXJmbG93OiBcImVsbGlwc2lzXCIsXG5cbiAgICBcIiY6aG92ZXIsICY6Zm9jdXMtdmlzaWJsZVwiOiB7XG4gICAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5kYXJrZW5lZEJnTWl4MTUsXG4gICAgfSxcbiAgICBcIiY6ZGlzYWJsZWQsICY6ZGlzYWJsZWQ6aG92ZXIsICY6ZGlzYWJsZWQ6YWN0aXZlXCI6IHtcbiAgICAgIGJvcmRlckNvbG9yOiB0aGVtZS5jb2xvcnMuYm9yZGVyQ29sb3IsXG4gICAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy50cmFuc3BhcmVudCxcbiAgICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMuZmFkZWRUZXh0NDAsXG4gICAgICBjdXJzb3I6IFwibm90LWFsbG93ZWRcIixcbiAgICB9LFxuXG4gICAgXCImIGRpdlwiOiB7XG4gICAgICB0ZXh0T3ZlcmZsb3c6IFwiZWxsaXBzaXNcIixcbiAgICAgIG92ZXJmbG93OiBcImhpZGRlblwiLFxuICAgIH0sXG4gICAgXCImIHBcIjoge1xuICAgICAgdGV4dE92ZXJmbG93OiBcImVsbGlwc2lzXCIsXG4gICAgICBvdmVyZmxvdzogXCJoaWRkZW5cIixcbiAgICB9LFxuICB9XG59KVxuXG5leHBvcnQgY29uc3QgU3R5bGVkUGlsbHNCdXR0b24gPSBzdHlsZWQoXG4gIFN0eWxlZEJ1dHRvbkdyb3VwQmFzZUJ1dHRvblxuKTxSZXF1aXJlZEJhc2VCdXR0b25Qcm9wcz4oKHsgdGhlbWUsIGNvbnRhaW5lcldpZHRoIH0pID0+IHtcbiAgcmV0dXJuIHtcbiAgICBib3JkZXJSYWRpdXM6IHRoZW1lLnJhZGlpLmZ1bGwsXG4gICAgcGFkZGluZzogYCR7dGhlbWUuc3BhY2luZy50d29YU30gJHt0aGVtZS5zcGFjaW5nLm1kfWAsXG4gICAgLy8gV2hlbiBjb250YWluZXJXaWR0aCBpcyB0cnVlLCB0aGUgYnV0dG9ucyB3aWxsIHN0cmV0Y2ggdG8gZmlsbCB0aGUgY29udGFpbmVyLlxuICAgIGZsZXg6IGNvbnRhaW5lcldpZHRoID8gXCIxIDEgZml0LWNvbnRlbnRcIiA6IFwiXCIsXG4gIH1cbn0pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRQaWxsc0J1dHRvbkFjdGl2ZSA9IHN0eWxlZChcbiAgU3R5bGVkUGlsbHNCdXR0b25cbik8UmVxdWlyZWRCYXNlQnV0dG9uUHJvcHM+KCh7IHRoZW1lIH0pID0+IHtcbiAgcmV0dXJuIHtcbiAgICBiYWNrZ3JvdW5kQ29sb3I6IHRyYW5zcGFyZW50aXplKHRoZW1lLmNvbG9ycy5wcmltYXJ5LCAwLjkpLFxuICAgIGJvcmRlckNvbG9yOiB0aGVtZS5jb2xvcnMucHJpbWFyeSxcbiAgICBjb2xvcjogdGhlbWUuY29sb3JzLnByaW1hcnksXG4gICAgXCImOmhvdmVyLCAmOmZvY3VzLXZpc2libGVcIjoge1xuICAgICAgYmFja2dyb3VuZENvbG9yOiB0cmFuc3BhcmVudGl6ZSh0aGVtZS5jb2xvcnMucHJpbWFyeSwgMC44KSxcbiAgICAgIGJvcmRlckNvbG9yOiB0aGVtZS5jb2xvcnMucHJpbWFyeSxcbiAgICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMucHJpbWFyeSxcbiAgICB9LFxuICAgIFwiJjpkaXNhYmxlZCwgJjpkaXNhYmxlZDpob3ZlciwgJjpkaXNhYmxlZDphY3RpdmVcIjoge1xuICAgICAgYm9yZGVyQ29sb3I6IHRoZW1lLmNvbG9ycy5ib3JkZXJDb2xvcixcbiAgICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLmZhZGVkVGV4dDA1LFxuICAgICAgY29sb3I6IHRoZW1lLmNvbG9ycy5mYWRlZFRleHQ0MCxcbiAgICAgIGN1cnNvcjogXCJub3QtYWxsb3dlZFwiLFxuICAgIH0sXG4gIH1cbn0pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRTZWdtZW50ZWRDb250cm9sQnV0dG9uID0gc3R5bGVkKFxuICBTdHlsZWRCdXR0b25Hcm91cEJhc2VCdXR0b25cbik8UmVxdWlyZWRCYXNlQnV0dG9uUHJvcHM+KCh7IHRoZW1lLCBjb250YWluZXJXaWR0aCB9KSA9PiB7XG4gIHJldHVybiB7XG4gICAgcGFkZGluZzogYCR7dGhlbWUuc3BhY2luZy50d29YU30gJHt0aGVtZS5zcGFjaW5nLmxnfWAsXG4gICAgYm9yZGVyUmFkaXVzOiBcIjBcIixcbiAgICAvLyBXaGVuIGNvbnRhaW5lcldpZHRoIGlzIHRydWUsIHRoZSBidXR0b25zIHdpbGwgc3RyZXRjaCB0byBmaWxsIHRoZSBjb250YWluZXIuXG4gICAgZmxleDogY29udGFpbmVyV2lkdGggPyBcIjEgMSBmaXQtY29udGVudFwiIDogXCJcIixcbiAgICBtYXhXaWR0aDogXCIxMDAlXCIsXG4gICAgbWFyZ2luUmlnaHQ6IGAtJHt0aGVtZS5zaXplcy5ib3JkZXJXaWR0aH1gLCAvLyBBZGQgbmVnYXRpdmUgbWFyZ2luIHRvIG92ZXJsYXAgYm9yZGVyc1xuXG4gICAgXCImOmZpcnN0LWNoaWxkXCI6IHtcbiAgICAgIGJvcmRlclRvcExlZnRSYWRpdXM6IHRoZW1lLnJhZGlpLmJ1dHRvbixcbiAgICAgIGJvcmRlckJvdHRvbUxlZnRSYWRpdXM6IHRoZW1lLnJhZGlpLmJ1dHRvbixcbiAgICB9LFxuICAgIFwiJjpsYXN0LWNoaWxkXCI6IHtcbiAgICAgIGJvcmRlclRvcFJpZ2h0UmFkaXVzOiB0aGVtZS5yYWRpaS5idXR0b24sXG4gICAgICBib3JkZXJCb3R0b21SaWdodFJhZGl1czogdGhlbWUucmFkaWkuYnV0dG9uLFxuICAgICAgbWFyZ2luUmlnaHQ6IHRoZW1lLnNwYWNpbmcubm9uZSwgLy8gUmVzZXQgbWFyZ2luIGZvciB0aGUgbGFzdCBjaGlsZFxuICAgIH0sXG4gICAgXCImOmZvY3VzLXZpc2libGVcIjoge1xuICAgICAgLy8gTWFrZSBzdXJlIHRoZSBmb2N1cyByaW5nIGlzbid0IGJlbG93IHRoZSBwcmV2aW91cy9uZXh0IGJ1dHRvbi5cbiAgICAgIHpJbmRleDogdGhlbWUuekluZGljZXMucHJpb3JpdHksXG4gICAgfSxcbiAgfVxufSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZFNlZ21lbnRlZENvbnRyb2xCdXR0b25BY3RpdmUgPSBzdHlsZWQoXG4gIFN0eWxlZFNlZ21lbnRlZENvbnRyb2xCdXR0b25cbik8UmVxdWlyZWRCYXNlQnV0dG9uUHJvcHM+KCh7IHRoZW1lIH0pID0+IHtcbiAgcmV0dXJuIHtcbiAgICBiYWNrZ3JvdW5kQ29sb3I6IHRyYW5zcGFyZW50aXplKHRoZW1lLmNvbG9ycy5wcmltYXJ5LCAwLjkpLFxuICAgIGJvcmRlckNvbG9yOiB0aGVtZS5jb2xvcnMucHJpbWFyeSxcbiAgICBjb2xvcjogdGhlbWUuY29sb3JzLnByaW1hcnksXG4gICAgekluZGV4OiB0aGVtZS56SW5kaWNlcy5wcmlvcml0eSxcbiAgICBcIiY6aG92ZXIsICY6Zm9jdXMtdmlzaWJsZVwiOiB7XG4gICAgICBiYWNrZ3JvdW5kQ29sb3I6IHRyYW5zcGFyZW50aXplKHRoZW1lLmNvbG9ycy5wcmltYXJ5LCAwLjgpLFxuICAgIH0sXG4gICAgXCImOmRpc2FibGVkLCAmOmRpc2FibGVkOmhvdmVyLCAmOmRpc2FibGVkOmFjdGl2ZVwiOiB7XG4gICAgICBib3JkZXJDb2xvcjogdGhlbWUuY29sb3JzLmJvcmRlckNvbG9yLFxuICAgICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMuZmFkZWRUZXh0MDUsXG4gICAgICBjb2xvcjogdGhlbWUuY29sb3JzLmZhZGVkVGV4dDQwLFxuICAgICAgY3Vyc29yOiBcIm5vdC1hbGxvd2VkXCIsXG4gICAgfSxcbiAgfVxufSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZEhlYWRlckJ1dHRvbiA9IHN0eWxlZChcbiAgU3R5bGVkQmFzZUJ1dHRvblxuKTxSZXF1aXJlZEJhc2VCdXR0b25Qcm9wcz4oKHsgdGhlbWUgfSkgPT4ge1xuICByZXR1cm4ge1xuICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLnRyYW5zcGFyZW50LFxuICAgIGJvcmRlcjogXCJub25lXCIsXG4gICAgcGFkZGluZzogYDAgJHt0aGVtZS5zcGFjaW5nLnNtfWAsXG4gICAgZm9udFNpemU6IHRoZW1lLmZvbnRTaXplcy5zbSxcbiAgICBtYXJnaW5MZWZ0OiB0aGVtZS5zcGFjaW5nLnRocmVlWFMsXG4gICAgbWFyZ2luUmlnaHQ6IHRoZW1lLnNwYWNpbmcudGhyZWVYUyxcblxuICAgIGxpbmVIZWlnaHQ6IHRoZW1lLmxpbmVIZWlnaHRzLm5vbmUsXG5cbiAgICBtaW5XaWR0aDogdGhlbWUuc2l6ZXMuaGVhZGVySXRlbUhlaWdodCxcbiAgICBtaW5IZWlnaHQ6IHRoZW1lLnNpemVzLmhlYWRlckl0ZW1IZWlnaHQsXG5cbiAgICBcIiY6Zm9jdXNcIjoge1xuICAgICAgb3V0bGluZTogXCJub25lXCIsXG4gICAgfSxcbiAgICBcIiY6Zm9jdXMtdmlzaWJsZVwiOiB7XG4gICAgICBib3hTaGFkb3c6IGAwIDAgMCAwLjJyZW0gJHt0cmFuc3BhcmVudGl6ZSh0aGVtZS5jb2xvcnMuZ3JheTkwLCAwLjgpfWAsXG4gICAgfSxcbiAgICBcIiY6aG92ZXJcIjoge1xuICAgICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMuZGFya2VuZWRCZ01peDE1LFxuICAgIH0sXG4gICAgXCImOmFjdGl2ZVwiOiB7XG4gICAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5kYXJrZW5lZEJnTWl4MjUsXG4gICAgfSxcbiAgICBcIiY6ZGlzYWJsZWQsICY6ZGlzYWJsZWQ6aG92ZXIsICY6ZGlzYWJsZWQ6YWN0aXZlXCI6IHtcbiAgICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLmdyYXkzMCxcbiAgICAgIGJvcmRlckNvbG9yOiB0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnQsXG4gICAgICBjb2xvcjogdGhlbWUuY29sb3JzLmdyYXk2MCxcbiAgICB9LFxuICB9XG59KVxuXG4vLyBUYWtlIG91dCBwYWRkaW5nIGZvciB0aGlzIHNwZWNpZmljIGJ1dHRvbiwgc28gd2UgY2FuIGVuc3VyZSBpdCdzIDMyeDMycHggbGlrZSBvdGhlciBidXR0b25zIGluIENvbW11bml0eSBDbG91ZFxuZXhwb3J0IGNvbnN0IFN0eWxlZEhlYWRlck5vUGFkZGluZ0J1dHRvbiA9IHN0eWxlZChcbiAgU3R5bGVkSGVhZGVyQnV0dG9uXG4pPFJlcXVpcmVkQmFzZUJ1dHRvblByb3BzPigoKSA9PiB7XG4gIHJldHVybiB7XG4gICAgcGFkZGluZzogMCxcbiAgfVxufSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZEJvcmRlcmxlc3NJY29uQnV0dG9uID0gc3R5bGVkKFxuICBTdHlsZWRCYXNlQnV0dG9uXG4pPFJlcXVpcmVkQmFzZUJ1dHRvblByb3BzPigoeyBzaXplLCB0aGVtZSB9KSA9PiB7XG4gIGNvbnN0IGljb25QYWRkaW5nOiBSZWNvcmQ8QmFzZUJ1dHRvblNpemUsIHN0cmluZz4gPSB7XG4gICAgW0Jhc2VCdXR0b25TaXplLlhTTUFMTF06IHRoZW1lLnNwYWNpbmcudGhyZWVYUyxcbiAgICBbQmFzZUJ1dHRvblNpemUuU01BTExdOiB0aGVtZS5zcGFjaW5nLnR3b1hTLFxuICAgIFtCYXNlQnV0dG9uU2l6ZS5NRURJVU1dOiB0aGVtZS5zcGFjaW5nLm1kLFxuICAgIFtCYXNlQnV0dG9uU2l6ZS5MQVJHRV06IHRoZW1lLnNwYWNpbmcubGcsXG4gIH1cblxuICByZXR1cm4ge1xuICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLnRyYW5zcGFyZW50LFxuICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMuZmFkZWRUZXh0NjAsXG4gICAgcGFkZGluZzogaWNvblBhZGRpbmdbc2l6ZV0sXG4gICAgbWFyZ2luTGVmdDogdGhlbWUuc3BhY2luZy5ub25lLFxuICAgIG1hcmdpblJpZ2h0OiB0aGVtZS5zcGFjaW5nLm5vbmUsXG5cbiAgICAvLyBLZWVwcyB0aGUgYnV0dG9ucyBmcm9tIHN0YWNraW5nIHdoZW4gaW4gY29udGFpbmVyV2lkdGggbW9kZS5cbiAgICAvLyBUaGVzZSBidXR0b25zIHNob3VsZCBzdGF5IHRvZ2V0aGVyIGFuZCBub3Qgc3RyZXRjaCB0byBmaWxsIHRoZSBjb250YWluZXIuXG4gICAgZmxleDogXCIwIDAgZml0LWNvbnRlbnRcIixcblxuICAgIGJvcmRlcjogXCJub25lXCIsXG4gICAgZGlzcGxheTogXCJmbGV4XCIsXG4gICAgbWluSGVpZ2h0OiBcInVuc2V0XCIsXG5cbiAgICBcIiY6Zm9jdXNcIjoge1xuICAgICAgYm94U2hhZG93OiBcIm5vbmVcIixcbiAgICAgIG91dGxpbmU6IFwibm9uZVwiLFxuICAgIH0sXG4gICAgXCImOmhvdmVyXCI6IHtcbiAgICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMuYm9keVRleHQsXG4gICAgfSxcbiAgICBcIiY6ZGlzYWJsZWQsICY6ZGlzYWJsZWQ6aG92ZXIsICY6ZGlzYWJsZWQ6YWN0aXZlXCI6IHtcbiAgICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMuZmFkZWRUZXh0MTAsXG4gICAgICBjdXJzb3I6IFwibm90LWFsbG93ZWRcIixcblxuICAgICAgLy8gRm9yIGltYWdlIGNvbnRlbnRcbiAgICAgIGltZzoge1xuICAgICAgICBvcGFjaXR5OiAwLjQsXG4gICAgICB9LFxuICAgIH0sXG4gIH1cbn0pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRCb3JkZXJsZXNzSWNvbkJ1dHRvbkFjdGl2ZSA9IHN0eWxlZChcbiAgU3R5bGVkQm9yZGVybGVzc0ljb25CdXR0b25cbik8UmVxdWlyZWRCYXNlQnV0dG9uUHJvcHM+KCh7IHRoZW1lIH0pID0+IHtcbiAgcmV0dXJuIHtcbiAgICBjb2xvcjogdGhlbWUuY29sb3JzLmJvZHlUZXh0LFxuICAgIFwiJjpkaXNhYmxlZCwgJjpkaXNhYmxlZDpob3ZlciwgJjpkaXNhYmxlZDphY3RpdmVcIjoge1xuICAgICAgY29sb3I6IHRoZW1lLmNvbG9ycy5mYWRlZFRleHQ0MCxcbiAgICB9LFxuICB9XG59KVxuXG5leHBvcnQgY29uc3QgU3R5bGVkVG9vbHRpcE5vcm1hbCA9IHN0eWxlZC5kaXYoKHsgdGhlbWUgfSkgPT4gKHtcbiAgZGlzcGxheTogXCJibG9ja1wiLFxuICBbYEBtZWRpYSAobWF4LXdpZHRoOiAke3RoZW1lLmJyZWFrcG9pbnRzLnNtfSlgXToge1xuICAgIGRpc3BsYXk6IFwibm9uZVwiLFxuICB9LFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRUb29sdGlwTW9iaWxlID0gc3R5bGVkLmRpdigoeyB0aGVtZSB9KSA9PiAoe1xuICBkaXNwbGF5OiBcIm5vbmVcIixcbiAgW2BAbWVkaWEgKG1heC13aWR0aDogJHt0aGVtZS5icmVha3BvaW50cy5zbX0pYF06IHtcbiAgICBkaXNwbGF5OiBcImJsb2NrXCIsXG4gIH0sXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZEVsZW1lbnRUb29sYmFyQnV0dG9uID0gc3R5bGVkKFxuICBTdHlsZWRCYXNlQnV0dG9uXG4pPFJlcXVpcmVkQmFzZUJ1dHRvblByb3BzPigoeyB0aGVtZSB9KSA9PiB7XG4gIHJldHVybiB7XG4gICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnQsXG4gICAgYm9yZGVyOiBcIm5vbmVcIixcbiAgICBwYWRkaW5nOiB0aGVtZS5zcGFjaW5nLnR3b1hTLFxuICAgIGZvbnRTaXplOiB0aGVtZS5mb250U2l6ZXMudHdvU20sXG4gICAgbWFyZ2luTGVmdDogdGhlbWUuc3BhY2luZy5ub25lLFxuICAgIG1hcmdpblJpZ2h0OiB0aGVtZS5zcGFjaW5nLm5vbmUsXG4gICAgZGlzcGxheTogXCJmbGV4XCIsXG4gICAgZ2FwOiB0aGVtZS5zcGFjaW5nLnhzLFxuICAgIGFsaWduSXRlbXM6IFwiY2VudGVyXCIsXG4gICAgbWluSGVpZ2h0OiBcInVuc2V0XCIsXG4gICAgLy8gbGluZSBoZWlnaHQgc2hvdWxkIGJlIHRoZSBzYW1lIGFzIHRoZSBpY29uIHNpemVcbiAgICBsaW5lSGVpZ2h0OiB0aGVtZS5pY29uU2l6ZXMubWQsXG4gICAgd2lkdGg6IFwiYXV0b1wiLFxuXG4gICAgXCImOmZvY3VzXCI6IHtcbiAgICAgIG91dGxpbmU6IFwibm9uZVwiLFxuICAgICAgYm9yZGVyOiBcIm5vbmVcIixcbiAgICAgIGJveFNoYWRvdzogXCJub25lXCIsXG4gICAgfSxcbiAgICBcIiY6Zm9jdXMtdmlzaWJsZVwiOiB7XG4gICAgICBvdXRsaW5lOiBcIm5vbmVcIixcbiAgICAgIGJvcmRlcjogXCJub25lXCIsXG4gICAgICBib3hTaGFkb3c6IFwibm9uZVwiLFxuICAgICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMuZGFya2VuZWRCZ01peDI1LFxuICAgIH0sXG4gICAgXCImOmhvdmVyXCI6IHtcbiAgICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLmRhcmtlbmVkQmdNaXgxNSxcbiAgICB9LFxuICAgIFwiJjphY3RpdmVcIjoge1xuICAgICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMuZGFya2VuZWRCZ01peDI1LFxuICAgIH0sXG4gICAgXCImOmRpc2FibGVkLCAmOmRpc2FibGVkOmhvdmVyLCAmOmRpc2FibGVkOmFjdGl2ZVwiOiB7XG4gICAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5ncmF5MzAsXG4gICAgICBib3JkZXJDb2xvcjogdGhlbWUuY29sb3JzLnRyYW5zcGFyZW50LFxuICAgICAgY29sb3I6IHRoZW1lLmNvbG9ycy5ncmF5NjAsXG4gICAgfSxcbiAgfVxufSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZEJ1dHRvbkdyb3VwID0gc3R5bGVkLmRpdjx7IGNvbnRhaW5lcldpZHRoOiBib29sZWFuIH0+KFxuICAoeyBjb250YWluZXJXaWR0aCB9KSA9PiAoe1xuICAgIHdpZHRoOiBjb250YWluZXJXaWR0aCA/IFwiMTAwJVwiIDogXCJhdXRvXCIsXG4gIH0pXG4pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRCdXR0b25MYWJlbCA9IHN0eWxlZC5kaXYoKCkgPT4gKHtcbiAgZGlzcGxheTogXCJmbGV4XCIsXG4gIGFsaWduSXRlbXM6IFwiY2VudGVyXCIsXG4gIGp1c3RpZnlDb250ZW50OiBcImNlbnRlclwiLFxuICB3aWR0aDogXCIxMDAlXCIsXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZEJ1dHRvbk1haW5MYWJlbCA9IHN0eWxlZC5zcGFuKCh7IHRoZW1lIH0pID0+ICh7XG4gIGRpc3BsYXk6IFwiaW5saW5lLWZsZXhcIixcbiAgYWxpZ25JdGVtczogXCJjZW50ZXJcIixcbiAganVzdGlmeUNvbnRlbnQ6IFwiY2VudGVyXCIsXG4gIGdhcDogdGhlbWUuc3BhY2luZy5zbSxcbiAgbWluV2lkdGg6IDAsXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZEJ1dHRvblNob3J0Y3V0ID0gc3R5bGVkLmtiZCgoeyB0aGVtZSB9KSA9PiAoe1xuICBkaXNwbGF5OiBcImlubGluZS1mbGV4XCIsXG4gIGFsaWduSXRlbXM6IFwiY2VudGVyXCIsXG4gIGp1c3RpZnlDb250ZW50OiBcImNlbnRlclwiLFxuICB3aGl0ZVNwYWNlOiBcIm5vd3JhcFwiLFxuICBmb250U2l6ZTogdGhlbWUuZm9udFNpemVzLnNtLFxuICBvcGFjaXR5OiAwLjYsXG4gIGZvbnRGYW1pbHk6IFwiaW5oZXJpdFwiLFxuICBsaW5lSGVpZ2h0OiB0aGVtZS5saW5lSGVpZ2h0cy50aWdodCxcbiAgbGV0dGVyU3BhY2luZzogXCIwLjAxZW1cIixcbn0pKVxuIl19 */"), StyledButtonGroup = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "ef3psqc3"
} : {
  target: "ef3psqc3",
  label: "StyledButtonGroup"
})(({
  containerWidth: o
}) => ({
  width: o ? "100%" : "auto"
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledButtonLabel = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "ef3psqc2"
} : {
  target: "ef3psqc2",
  label: "StyledButtonLabel"
})(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "100%"
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledButtonMainLabel = /* @__PURE__ */ createStyled("span", process.env.NODE_ENV === "production" ? {
  target: "ef3psqc1"
} : {
  target: "ef3psqc1",
  label: "StyledButtonMainLabel"
})(({
  theme: o
}) => ({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  gap: o.spacing.sm,
  minWidth: 0
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledButtonShortcut = /* @__PURE__ */ createStyled("kbd", process.env.NODE_ENV === "production" ? {
  target: "ef3psqc0"
} : {
  target: "ef3psqc0",
  label: "StyledButtonShortcut"
})(({
  theme: o
}) => ({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  whiteSpace: "nowrap",
  fontSize: o.fontSizes.sm,
  opacity: 0.6,
  fontFamily: "inherit",
  lineHeight: o.lineHeights.tight,
  letterSpacing: "0.01em"
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), DynamicButtonLabel = ({
  icon: o,
  label: E,
  iconSize: A,
  useSmallerFont: g = !1,
  shortcut: e
}) => {
  const t = useMemo$1(() => formatShortcutForDisplay(e, {
    isMac: isFromMac()
  }), [e]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledButtonLabel, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledButtonMainLabel, { "data-has-shortcut": !!t, children: [
    o && /* @__PURE__ */ jsxRuntimeExports.jsx(DynamicIcon, { size: A ?? "lg", iconValue: o }),
    E && /* @__PURE__ */ jsxRuntimeExports.jsx(StreamlitMarkdown$1, { source: E, allowHTML: !1, isLabel: !0, largerLabel: !g, disableLinks: !0 }),
    t && /* @__PURE__ */ jsxRuntimeExports.jsx(StyledButtonShortcut, { "aria-label": `Shortcut ${t}`, children: t })
  ] }) });
};
function BaseButton(o) {
  const {
    kind: E,
    size: A,
    disabled: g,
    onClick: e,
    containerWidth: t,
    children: c,
    autoFocus: n
  } = o;
  let h = StyledPrimaryButton;
  return E === BaseButtonKind.SECONDARY ? h = StyledSecondaryButton : E === BaseButtonKind.TERTIARY ? h = StyledTertiaryButton : E === BaseButtonKind.GHOST ? h = StyledGhostButton : E === BaseButtonKind.PILLS ? h = StyledPillsButton : E === BaseButtonKind.PILLS_ACTIVE ? h = StyledPillsButtonActive : E === BaseButtonKind.SEGMENTED_CONTROL ? h = StyledSegmentedControlButton : E === BaseButtonKind.SEGMENTED_CONTROL_ACTIVE ? h = StyledSegmentedControlButtonActive : E === BaseButtonKind.BORDERLESS_ICON ? h = StyledBorderlessIconButton : E === BaseButtonKind.BORDERLESS_ICON_ACTIVE ? h = StyledBorderlessIconButtonActive : E === BaseButtonKind.MINIMAL ? h = StyledMinimalButton : E === BaseButtonKind.PRIMARY_FORM_SUBMIT ? h = StyledPrimaryFormSubmitButton : E === BaseButtonKind.SECONDARY_FORM_SUBMIT ? h = StyledSecondaryFormSubmitButton : E === BaseButtonKind.TERTIARY_FORM_SUBMIT ? h = StyledTertiaryFormSubmitButton : E === BaseButtonKind.HEADER_BUTTON ? h = StyledHeaderButton : E === BaseButtonKind.HEADER_NO_PADDING ? h = StyledHeaderNoPaddingButton : E === BaseButtonKind.ELEMENT_TOOLBAR && (h = StyledElementToolbarButton), /* @__PURE__ */ jsxRuntimeExports.jsx(h, { kind: E, size: A ?? BaseButtonSize.MEDIUM, containerWidth: t || !1, disabled: g || !1, onClick: e || (() => {
  }), autoFocus: n || !1, "data-testid": o["data-testid"] ?? `stBaseButton-${E}`, "aria-label": o["aria-label"] ?? "", children: c });
}
function BaseButtonTooltip({
  children: o,
  help: E,
  placement: A,
  containerWidth: g
}) {
  return E ? /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(StyledTooltipNormal, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(TooltipIcon, { content: E, placement: A || Placement.TOP, containerWidth: g, children: o }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(StyledTooltipMobile, { children: o })
  ] }) : o;
}
const StyledModalButton = /* @__PURE__ */ createStyled("span", process.env.NODE_ENV === "production" ? {
  target: "e18cebhv0"
} : {
  target: "e18cebhv0",
  label: "StyledModalButton"
})(({
  theme: o
}) => ({
  marginRight: o.spacing.twoXS
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2xpYi9zcmMvY29tcG9uZW50cy9zaGFyZWQvTW9kYWwvc3R5bGVkLWNvbXBvbmVudHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBa0JpQyIsImZpbGUiOiIvaG9tZS9ydW5uZXIvd29yay9zdGxpdGUvc3RsaXRlL3N0cmVhbWxpdC9mcm9udGVuZC9saWIvc3JjL2NvbXBvbmVudHMvc2hhcmVkL01vZGFsL3N0eWxlZC1jb21wb25lbnRzLnRzIiwic291cmNlc0NvbnRlbnQiOlsiLyoqXG4gKiBDb3B5cmlnaHQgKGMpIFN0cmVhbWxpdCBJbmMuICgyMDE4LTIwMjIpIFNub3dmbGFrZSBJbmMuICgyMDIyLTIwMjUpXG4gKlxuICogTGljZW5zZWQgdW5kZXIgdGhlIEFwYWNoZSBMaWNlbnNlLCBWZXJzaW9uIDIuMCAodGhlIFwiTGljZW5zZVwiKTtcbiAqIHlvdSBtYXkgbm90IHVzZSB0aGlzIGZpbGUgZXhjZXB0IGluIGNvbXBsaWFuY2Ugd2l0aCB0aGUgTGljZW5zZS5cbiAqIFlvdSBtYXkgb2J0YWluIGEgY29weSBvZiB0aGUgTGljZW5zZSBhdFxuICpcbiAqICAgICBodHRwOi8vd3d3LmFwYWNoZS5vcmcvbGljZW5zZXMvTElDRU5TRS0yLjBcbiAqXG4gKiBVbmxlc3MgcmVxdWlyZWQgYnkgYXBwbGljYWJsZSBsYXcgb3IgYWdyZWVkIHRvIGluIHdyaXRpbmcsIHNvZnR3YXJlXG4gKiBkaXN0cmlidXRlZCB1bmRlciB0aGUgTGljZW5zZSBpcyBkaXN0cmlidXRlZCBvbiBhbiBcIkFTIElTXCIgQkFTSVMsXG4gKiBXSVRIT1VUIFdBUlJBTlRJRVMgT1IgQ09ORElUSU9OUyBPRiBBTlkgS0lORCwgZWl0aGVyIGV4cHJlc3Mgb3IgaW1wbGllZC5cbiAqIFNlZSB0aGUgTGljZW5zZSBmb3IgdGhlIHNwZWNpZmljIGxhbmd1YWdlIGdvdmVybmluZyBwZXJtaXNzaW9ucyBhbmRcbiAqIGxpbWl0YXRpb25zIHVuZGVyIHRoZSBMaWNlbnNlLlxuICovXG5cbmltcG9ydCBzdHlsZWQgZnJvbSBcIkBlbW90aW9uL3N0eWxlZFwiXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRNb2RhbEJ1dHRvbiA9IHN0eWxlZC5zcGFuKCh7IHRoZW1lIH0pID0+ICh7XG4gIG1hcmdpblJpZ2h0OiB0aGVtZS5zcGFjaW5nLnR3b1hTLFxufSkpXG4iXX0= */");
function ModalHeader({
  children: o,
  overrides: E
}) {
  const {
    genericFonts: A,
    fontSizes: g,
    spacing: e,
    fontWeights: t,
    lineHeights: c
  } = useEmotionTheme();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ModalHeader$1, { style: {
    marginTop: e.none,
    marginLeft: e.none,
    marginRight: e.none,
    marginBottom: e.none,
    paddingTop: e.twoXL,
    paddingRight: e.twoXL,
    paddingBottom: e.md,
    paddingLeft: e.twoXL,
    fontFamily: A.bodyFont,
    fontSize: g.xl,
    fontWeight: t.bold,
    margin: e.none,
    lineHeight: c.small,
    textTransform: "none",
    display: "flex",
    alignItems: "center",
    maxHeight: "80vh",
    flexDirection: "row",
    ...E
  }, children: o });
}
function ModalBody$1({
  children: o
}) {
  const {
    colors: E,
    fontSizes: A,
    spacing: g
  } = useEmotionTheme();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ModalBody$2, { style: {
    marginTop: g.none,
    marginLeft: g.none,
    marginRight: g.none,
    marginBottom: g.none,
    paddingTop: g.md,
    paddingRight: g.twoXL,
    paddingBottom: g.twoXL,
    paddingLeft: g.twoXL,
    color: E.bodyText,
    fontSize: A.md
  }, children: o });
}
function ModalFooter({
  children: o
}) {
  const {
    spacing: E
  } = useEmotionTheme();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ModalFooter$1, { style: {
    marginTop: E.none,
    marginLeft: E.none,
    marginRight: E.none,
    marginBottom: E.none,
    paddingTop: E.md,
    paddingRight: E.md,
    paddingBottom: E.md,
    paddingLeft: E.md
  }, children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: o }) });
}
const ModalButton = (o) => /* @__PURE__ */ jsxRuntimeExports.jsx(StyledModalButton, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(BaseButton, { ...o }) });
function calculateModalSize(o, E, A) {
  return o === "large" ? "80rem" : o === "medium" && E && A ? `calc(${E} + ${A})` : o === "auto" ? SIZE$2.auto : SIZE$2.default;
}
function Modal(o) {
  const {
    spacing: E,
    radii: A,
    colors: g,
    sizes: e
  } = useEmotionTheme(), t = {
    Root: {
      style: {
        background: g.darkenedBgMix25
      },
      props: {
        className: "stDialog",
        "data-testid": "stDialog"
      }
    },
    DialogContainer: {
      style: {
        alignItems: "start",
        paddingTop: E.threeXL
      }
    },
    Dialog: {
      style: {
        borderBottomRightRadius: A.xxl,
        borderBottomLeftRadius: A.xxl,
        borderTopRightRadius: A.xxl,
        borderTopLeftRadius: A.xxl,
        // make sure the modal is not too small on mobile
        minWidth: e.minPopupWidth
      }
    },
    Close: {
      style: {
        top: `calc(${E.twoXL} + .375rem)`,
        // Trying to center the button on the available space.
        right: E.twoXL
      }
    }
  }, c = calculateModalSize(o.size, e.contentMaxWidth, E.lg), n = merge$1(t, o.overrides), h = {
    ...o,
    size: c
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Modal$1, { ...h, overrides: n });
}
const StyledDialogTitle = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "eh5ke330"
} : {
  target: "eh5ke330",
  label: "StyledDialogTitle"
})(({
  theme: o
}) => ({
  // Add right margin to prevent overlap with close button
  marginRight: o.spacing.threeXL
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2xpYi9zcmMvY29tcG9uZW50cy9lbGVtZW50cy9EaWFsb2cvc3R5bGVkLWNvbXBvbmVudHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBa0JpQyIsImZpbGUiOiIvaG9tZS9ydW5uZXIvd29yay9zdGxpdGUvc3RsaXRlL3N0cmVhbWxpdC9mcm9udGVuZC9saWIvc3JjL2NvbXBvbmVudHMvZWxlbWVudHMvRGlhbG9nL3N0eWxlZC1jb21wb25lbnRzLnRzIiwic291cmNlc0NvbnRlbnQiOlsiLyoqXG4gKiBDb3B5cmlnaHQgKGMpIFN0cmVhbWxpdCBJbmMuICgyMDE4LTIwMjIpIFNub3dmbGFrZSBJbmMuICgyMDIyLTIwMjUpXG4gKlxuICogTGljZW5zZWQgdW5kZXIgdGhlIEFwYWNoZSBMaWNlbnNlLCBWZXJzaW9uIDIuMCAodGhlIFwiTGljZW5zZVwiKTtcbiAqIHlvdSBtYXkgbm90IHVzZSB0aGlzIGZpbGUgZXhjZXB0IGluIGNvbXBsaWFuY2Ugd2l0aCB0aGUgTGljZW5zZS5cbiAqIFlvdSBtYXkgb2J0YWluIGEgY29weSBvZiB0aGUgTGljZW5zZSBhdFxuICpcbiAqICAgICBodHRwOi8vd3d3LmFwYWNoZS5vcmcvbGljZW5zZXMvTElDRU5TRS0yLjBcbiAqXG4gKiBVbmxlc3MgcmVxdWlyZWQgYnkgYXBwbGljYWJsZSBsYXcgb3IgYWdyZWVkIHRvIGluIHdyaXRpbmcsIHNvZnR3YXJlXG4gKiBkaXN0cmlidXRlZCB1bmRlciB0aGUgTGljZW5zZSBpcyBkaXN0cmlidXRlZCBvbiBhbiBcIkFTIElTXCIgQkFTSVMsXG4gKiBXSVRIT1VUIFdBUlJBTlRJRVMgT1IgQ09ORElUSU9OUyBPRiBBTlkgS0lORCwgZWl0aGVyIGV4cHJlc3Mgb3IgaW1wbGllZC5cbiAqIFNlZSB0aGUgTGljZW5zZSBmb3IgdGhlIHNwZWNpZmljIGxhbmd1YWdlIGdvdmVybmluZyBwZXJtaXNzaW9ucyBhbmRcbiAqIGxpbWl0YXRpb25zIHVuZGVyIHRoZSBMaWNlbnNlLlxuICovXG5cbmltcG9ydCBzdHlsZWQgZnJvbSBcIkBlbW90aW9uL3N0eWxlZFwiXG5cbmV4cG9ydCBjb25zdCBTdHlsZWREaWFsb2dUaXRsZSA9IHN0eWxlZC5kaXYoKHsgdGhlbWUgfSkgPT4gKHtcbiAgLy8gQWRkIHJpZ2h0IG1hcmdpbiB0byBwcmV2ZW50IG92ZXJsYXAgd2l0aCBjbG9zZSBidXR0b25cbiAgbWFyZ2luUmlnaHQ6IHRoZW1lLnNwYWNpbmcudGhyZWVYTCxcbn0pKVxuIl19 */");
function mapDialogWidthToModalSize(o) {
  switch (o) {
    case Block$1.Dialog.DialogWidth.MEDIUM:
      return "medium";
    case Block$1.Dialog.DialogWidth.LARGE:
      return "large";
    case Block$1.Dialog.DialogWidth.SMALL:
      return "default";
    default:
      return assertNever(o), "default";
  }
}
const Dialog = ({
  element: o,
  deltaMsgReceivedAt: E,
  children: A,
  widgetMgr: g,
  fragmentId: e
}) => {
  const {
    title: t,
    dismissible: c,
    width: n,
    isOpen: h,
    id: d
  } = o, [k, p] = useState(!1);
  useEffect(() => {
    notNullOrUndefined(h) && p(h);
  }, [h, E]);
  const M = useCallback(() => {
    p(!1), d && g && g.setTriggerValue(
      {
        id: d,
        formId: ""
      },
      // WidgetInfo object - dialogs are not compatible with forms
      {
        fromUi: !0
      },
      e
    );
  }, [d, g, e]), S = useCallback((AA) => {
    if (k && AA.key.toLowerCase() === "r" && !o.dismissible) {
      const H = AA.target;
      if (H && (H.isContentEditable || H.tagName === "INPUT" || H.tagName === "TEXTAREA" || H.tagName === "SELECT"))
        return;
      AA.preventDefault(), AA.stopPropagation();
    }
  }, [k, o.dismissible]);
  return useEffect(() => {
    if (k && !o.dismissible)
      return document.addEventListener("keydown", S, !0), () => {
        document.removeEventListener("keydown", S, !0);
      };
  }, [k, o.dismissible, S]), k ? /* @__PURE__ */ jsxRuntimeExports.jsxs(Modal, { isOpen: !0, closeable: c, onClose: M, size: mapDialogWidthToModalSize(n), children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalHeader, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledDialogTitle, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(StreamlitMarkdown$1, { source: t, allowHTML: !1, isLabel: !0, inheritFont: !0 }) }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalBody$1, { children: A })
  ] }) : /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {});
};
function DialogWithProvider(o) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(IsDialogContext.Provider, { value: !0, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Dialog, { ...o }) });
}
const Dialog$1 = memo(DialogWithProvider);
function _EMOTION_STRINGIFIED_CSS_ERROR__$d() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const StyledExpandableContainer = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "eqpbllx5"
} : {
  target: "eqpbllx5",
  label: "StyledExpandableContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "1d3w5wq",
  styles: "width:100%"
} : {
  name: "1d3w5wq",
  styles: "width:100%/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$d
}), BORDER_SIZE = 1, StyledDetails = /* @__PURE__ */ createStyled("details", process.env.NODE_ENV === "production" ? {
  target: "eqpbllx4"
} : {
  target: "eqpbllx4",
  label: "StyledDetails"
})(({
  isStale: o,
  theme: E
}) => ({
  marginBottom: 0,
  marginTop: 0,
  width: "100%",
  borderStyle: "solid",
  borderWidth: E.sizes.borderWidth,
  borderColor: E.colors.borderColor,
  borderRadius: E.radii.default,
  ...o ? {
    borderColor: E.colors.borderColorLight,
    transition: `border ${STALE_TRANSITION_PARAMS}`
  } : {}
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledSummaryHeading = /* @__PURE__ */ createStyled("span", process.env.NODE_ENV === "production" ? {
  target: "eqpbllx3"
} : {
  target: "eqpbllx3",
  label: "StyledSummaryHeading"
})(({
  theme: o
}) => ({
  display: "flex",
  alignItems: "center",
  flexGrow: 1,
  minWidth: 0,
  width: "100%",
  maxWidth: "100%",
  overflow: "hidden",
  gap: o.spacing.sm
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledSummaryLabelWrapper = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "eqpbllx2"
} : {
  target: "eqpbllx2",
  label: "StyledSummaryLabelWrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "xomnir",
  styles: "display:flex;width:100%;flex-grow:1;overflow:hidden"
} : {
  name: "xomnir",
  styles: "display:flex;width:100%;flex-grow:1;overflow:hidden/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$d
}), StyledSummary = /* @__PURE__ */ createStyled("summary", process.env.NODE_ENV === "production" ? {
  target: "eqpbllx1"
} : {
  target: "eqpbllx1",
  label: "StyledSummary"
})(({
  theme: o,
  isStale: E,
  expanded: A
}) => ({
  position: "relative",
  display: "flex",
  width: "100%",
  // Prevent chevron/user icon from overlapping content by ensuring
  // children can shrink and the summary can clip excess inline overflow.
  minWidth: 0,
  overflow: "hidden",
  "&:focus": {
    outline: "none"
  },
  "&:focus-visible": {
    boxShadow: `0 0 0 0.2rem ${transparentize(o.colors.primary, 0.5)}`
  },
  fontSize: "inherit",
  paddingLeft: o.spacing.md,
  paddingRight: o.spacing.md,
  paddingTop: o.spacing.twoXS,
  paddingBottom: o.spacing.twoXS,
  minHeight: `calc(${o.sizes.minElementHeight} - 2 * ${o.sizes.borderWidth})`,
  alignItems: "center",
  cursor: "pointer",
  listStyleType: "none",
  "&::-webkit-details-marker": {
    display: "none"
  },
  backgroundColor: A ? o.colors.bgMix : "transparent",
  // When expanded, only round the top corners
  borderRadius: A ? `${o.radii.default} ${o.radii.default} 0 0` : o.radii.default,
  // Animate border-radius changes when expanding/collapsing to match the animation of
  // the expander content. Use a delay when collapsing because the content first needs
  // to slide up.
  transition: A ? "border-radius 200ms cubic-bezier(0.23, 1, 0.32, 1), background-color 150ms ease" : "border-radius 200ms cubic-bezier(0.23, 1, 0.32, 1) 300ms, background-color 150ms ease",
  "&:hover, &:focus-visible": {
    backgroundColor: o.colors.darkenedBgMix15
  },
  "&:active": {
    backgroundColor: o.colors.darkenedBgMix25
  },
  ...E && STALE_STYLES
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledDetailsPanel = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "eqpbllx0"
} : {
  target: "eqpbllx0",
  label: "StyledDetailsPanel"
})(({
  theme: o
}) => ({
  padding: o.spacing.lg,
  borderTop: `${o.sizes.borderWidth} solid ${o.colors.borderColor}`
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), ExpanderIcon = (o) => {
  const {
    icon: E
  } = o, A = {
    ":material/check:": "stExpanderIconCheck",
    ":material/error:": "stExpanderIconError",
    spinner: "stExpanderIconSpinner"
  };
  return E ? /* @__PURE__ */ jsxRuntimeExports.jsx(DynamicIcon, { size: "lg", iconValue: E, testid: A[E] || "stExpanderIcon" }) : /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {});
}, Expander = ({
  element: o,
  isStale: E,
  children: A
}) => {
  const {
    label: g,
    expanded: e
  } = o, [t, c] = useState(e || !1), [n, h] = useState(!1), d = useRef(null), k = useRef(null), p = useRef(null), M = useRef(null), S = useRef(null);
  useEffect(() => {
    notNullOrUndefined(e) && (c(e), d.current && (d.current.open = e));
  }, [g, e]);
  const AA = (EA) => {
    d.current && (d.current.open = EA, p.current = null, d.current.style.height = "", d.current.style.overflow = "");
  }, H = (EA, oA, iA) => {
    const aA = iA > oA;
    p.current && (p.current.cancel(), M.current && (clearTimeout(M.current), M.current = null));
    const tA = EA.animate({
      height: [`${oA}px`, `${iA}px`]
    }, {
      duration: 500,
      easing: "cubic-bezier(0.23, 1, 0.32, 1)"
    });
    tA.addEventListener("finish", () => AA(aA)), p.current = tA;
  }, gA = (EA) => {
    EA.preventDefault(), c(!t);
    const oA = d.current;
    if (!oA || !k.current)
      return;
    oA.style.overflow = "hidden";
    const iA = oA.getBoundingClientRect().height, aA = k.current.getBoundingClientRect().height;
    t ? H(oA, iA, aA + 2 * BORDER_SIZE) : (oA.style.height = `${iA}px`, oA.open = !0, window.requestAnimationFrame(() => {
      H(
        oA,
        iA,
        aA + 2 * BORDER_SIZE + 5
        // Arbitrary size of 5px
      ), M.current = setTimeout(() => {
        if (!S.current)
          return;
        const tA = (
          // eslint-disable-next-line streamlit-custom/no-force-reflow-access -- Existing usage
          S.current.getBoundingClientRect().height
        );
        H(oA, iA, aA + tA + 2 * BORDER_SIZE);
      }, 100);
    }));
  }, CA = () => {
    h(!0);
  }, IA = () => {
    h(!1);
  }, BA = !o.icon || n, QA = o.icon && !n;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledExpandableContainer, { className: "stExpander", "data-testid": "stExpander", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledDetails, { isStale: E, ref: d, onMouseEnter: CA, onMouseLeave: IA, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(StyledSummary, { onClick: gA, ref: k, isStale: E, expanded: t, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledSummaryHeading, { children: [
      BA && /* @__PURE__ */ jsxRuntimeExports.jsx(DynamicIcon, { iconValue: t ? ":material/keyboard_arrow_down:" : ":material/keyboard_arrow_right:", size: "lg" }),
      QA && /* @__PURE__ */ jsxRuntimeExports.jsx(ExpanderIcon, { icon: o.icon }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(StyledSummaryLabelWrapper, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(StreamlitMarkdown$1, { source: g, allowHTML: !1, isLabel: !0, largerLabel: !0 }) })
    ] }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(StyledDetailsPanel, { "data-testid": "stExpanderDetails", ref: S, children: A })
  ] }) });
}, Expander$1 = memo(Expander), Box = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "epl6yf30"
} : {
  target: "epl6yf30",
  label: "Box"
})(({
  width: o = "100%",
  height: E
}) => ({
  width: o,
  height: E
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), getBorderColor = (o, E) => {
  let A = o.widgetBorderColor ?? o.secondaryBg;
  return E && (A = o.primary), A;
}, useResizeObserver = (o, E = []) => {
  const A = useRef(null), [g, e] = useState([]), t = useCallback(() => {
    if (!A.current)
      return [];
    const c = A.current.getBoundingClientRect();
    return o.map((n) => c[n]);
  }, [o]);
  return useEffect(() => {
    if (!A.current)
      return;
    e(t());
    let c;
    const n = new ResizeObserver(() => {
      c = window.requestAnimationFrame(() => {
        e(t());
      });
    });
    return n.observe(A.current), () => {
      n.disconnect(), c && cancelAnimationFrame(c);
    };
  }, [o, t, ...E]), {
    values: g,
    elementRef: A
  };
}, useCalculatedDimensions = (o = [], E = -1) => {
  const {
    values: [A, g],
    elementRef: e
  } = useResizeObserver(useMemo$1(() => ["width", "height"], []), o);
  return {
    width: A || E,
    height: g || E,
    elementRef: e
  };
}, StyledPopoverLabelContainer = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e1pbrot51"
} : {
  target: "e1pbrot51",
  label: "StyledPopoverLabelContainer"
})(({
  theme: o
}) => ({
  display: "flex",
  alignItems: "center",
  gap: o.spacing.threeXS,
  // This is a hacky way to offset the "padding" of the expansion svg
  // icon. Reason is that we want to use the same padding to the right side
  // as the text on the left side. The alternative would be to overwrite the
  // right padding of the button, which would also be hacky and involve slightly
  // more logic.
  // If the padding of the icon changes, this value needs to be adjusted.
  // Also, if we want to apply the same adjustment for other elements, we should
  // consider putting this into a theme variable or creating a shared styled component.
  // The SVG icon we are using seems to have an internal padding of around 25%.
  marginRight: `calc(-${o.iconSizes.lg} * 0.25)`
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledPopoverExpansionIcon = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e1pbrot50"
} : {
  target: "e1pbrot50",
  label: "StyledPopoverExpansionIcon"
})(({
  theme: o
}) => ({
  display: "inline-flex",
  // Small hack to better align the expansion icon with the label.
  marginTop: o.spacing.threeXS
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), Popover = ({
  element: o,
  empty: E,
  children: A,
  stretchWidth: g
}) => {
  const [e, t] = useState(!1), c = useContext(IsSidebarContext), n = useEmotionTheme(), h = hasLightBackgroundColor(n), {
    width: d,
    elementRef: k
  } = useCalculatedDimensions();
  let p = BaseButtonKind.SECONDARY;
  return o.type === "primary" ? p = BaseButtonKind.PRIMARY : o.type === "tertiary" && (p = BaseButtonKind.TERTIARY), /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { "data-testid": "stPopover", className: "stPopover", ref: k, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    Popover$2,
    {
      triggerType: TRIGGER_TYPE.click,
      placement: PLACEMENT.bottomLeft,
      content: () => A,
      isOpen: e,
      onClickOutside: () => t(!1),
      onClick: () => e ? t(!1) : void 0,
      onEsc: () => t(!1),
      ignoreBoundary: c,
      renderAll: !0,
      overrides: {
        Body: {
          props: {
            "data-testid": "stPopoverBody"
          },
          style: () => ({
            marginRight: n.spacing.lg,
            marginBottom: n.spacing.lg,
            maxHeight: "70vh",
            overflow: "auto",
            maxWidth: `calc(${n.sizes.contentMaxWidth} - 2*${n.spacing.lg})`,
            minWidth: g ? (
              // If width="stretch", we use the container width as minimum:
              `${Math.max(d, 160)}px`
            ) : n.sizes.minPopupWidth,
            [`@media (max-width: ${n.breakpoints.sm})`]: {
              maxWidth: `calc(100% - ${n.spacing.threeXL})`
            },
            borderTopLeftRadius: n.radii.xl,
            borderTopRightRadius: n.radii.xl,
            borderBottomRightRadius: n.radii.xl,
            borderBottomLeftRadius: n.radii.xl,
            borderLeftWidth: n.sizes.borderWidth,
            borderRightWidth: n.sizes.borderWidth,
            borderTopWidth: n.sizes.borderWidth,
            borderBottomWidth: n.sizes.borderWidth,
            paddingRight: `calc(${n.spacing.twoXL} - ${n.sizes.borderWidth})`,
            // 1px to account for border.
            paddingLeft: `calc(${n.spacing.twoXL} - ${n.sizes.borderWidth})`,
            paddingBottom: `calc(${n.spacing.twoXL} - ${n.sizes.borderWidth})`,
            paddingTop: `calc(${n.spacing.twoXL} - ${n.sizes.borderWidth})`,
            borderLeftStyle: "solid",
            borderRightStyle: "solid",
            borderTopStyle: "solid",
            borderBottomStyle: "solid",
            borderLeftColor: n.colors.borderColor,
            borderRightColor: n.colors.borderColor,
            borderTopColor: n.colors.borderColor,
            borderBottomColor: n.colors.borderColor,
            boxShadow: h ? "0px 4px 16px rgba(0, 0, 0, 0.16)" : "0px 4px 16px rgba(0, 0, 0, 0.7)"
          })
        }
      },
      children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(BaseButtonTooltip, { help: o.help, containerWidth: !0, children: /* @__PURE__ */ jsxRuntimeExports.jsx(BaseButton, { "data-testid": "stPopoverButton", kind: p, size: BaseButtonSize.SMALL, disabled: E || o.disabled, containerWidth: !0, onClick: () => t(!e), children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledPopoverLabelContainer, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(DynamicButtonLabel, { icon: o.icon, label: o.label }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(StyledPopoverExpansionIcon, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(DynamicIcon, { iconValue: e ? ":material/expand_less:" : ":material/expand_more:", size: "lg" }) })
      ] }) }) }) })
    }
  ) });
}, Popover$1 = memo(Popover);
var ORIENTATION = {
  vertical: "vertical",
  horizontal: "horizontal"
}, FILL = {
  fixed: "fixed",
  intrinsic: "intrinsic"
}, getTabId = function o(E, A) {
  return "tabs-".concat(E, "-tab-").concat(A);
}, getTabPanelId = function o(E, A) {
  return "tabs-".concat(E, "-tabpanel-").concat(A);
}, isHorizontal = function o(E) {
  return E === ORIENTATION.horizontal;
}, isVertical = function o(E) {
  return E === ORIENTATION.vertical;
}, isRTL = function o(E) {
  return E === "rtl";
}, isIntrinsic = function o(E) {
  return E === FILL.intrinsic;
}, isFixed = function o(E) {
  return E === FILL.fixed;
};
function ownKeys$e(o, E) {
  var A = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var g = Object.getOwnPropertySymbols(o);
    E && (g = g.filter(function(e) {
      return Object.getOwnPropertyDescriptor(o, e).enumerable;
    })), A.push.apply(A, g);
  }
  return A;
}
function _objectSpread$c(o) {
  for (var E = 1; E < arguments.length; E++) {
    var A = arguments[E] != null ? arguments[E] : {};
    E % 2 ? ownKeys$e(Object(A), !0).forEach(function(g) {
      _defineProperty$f(o, g, A[g]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(A)) : ownKeys$e(Object(A)).forEach(function(g) {
      Object.defineProperty(o, g, Object.getOwnPropertyDescriptor(A, g));
    });
  }
  return o;
}
function _defineProperty$f(o, E, A) {
  return E in o ? Object.defineProperty(o, E, { value: A, enumerable: !0, configurable: !0, writable: !0 }) : o[E] = A, o;
}
var StyledRoot$1 = styled("div", function(o) {
  o.$theme;
  var E = o.$orientation, A = E === void 0 ? ORIENTATION.horizontal : E, g = {
    // Creates a stacking context so we can use z-index on the TabHighlight
    // without affecting anything outside of this element.
    transform: "scale(1)"
  };
  return isVertical(A) && (g.display = "flex"), g;
});
StyledRoot$1.displayName = "StyledRoot";
StyledRoot$1.displayName = "StyledRoot";
var StyledTabBar = styled("div", function(o) {
  var E = o.$hasEndEnhancer, A = o.$orientation;
  return E || !isHorizontal(A) ? {
    display: "flex"
  } : {};
});
StyledTabBar.displayName = "StyledTabBar";
StyledTabBar.displayName = "StyledTabBar";
var StyledTabList = styled("div", function(o) {
  var E = o.$theme, A = o.$fill, g = A === void 0 ? FILL.intrinsic : A, e = o.$orientation, t = e === void 0 ? ORIENTATION.horizontal : e, c = {
    position: "relative",
    display: "flex",
    flexWrap: "nowrap",
    flexGrow: 1
  };
  return isHorizontal(t) ? (c.flexDirection = "row", c.paddingBottom = "5px", c.marginBottom = "-5px") : (c.flexDirection = "column", isRTL(E.direction) ? (c.paddingLeft = "5px", c.marginLeft = "-5px") : (c.paddingRight = "5px", c.marginRight = "-5px")), isIntrinsic(g) && (c["::-webkit-scrollbar"] = {
    display: "none"
  }, c["-ms-overflow-style"] = "none", c.scrollbarWidth = "none", isHorizontal(t) ? c.overflowX = "scroll" : c.overflowY = "scroll"), c;
});
StyledTabList.displayName = "StyledTabList";
StyledTabList.displayName = "StyledTabList";
var StyledTab = styled("button", function(o) {
  var E = o.$theme, A = o.$orientation, g = A === void 0 ? ORIENTATION.horizontal : A, e = o.$fill, t = e === void 0 ? FILL.intrinsic : e, c = o.$focusVisible, n = c === void 0 ? !1 : c;
  o.$isActive;
  var h = _objectSpread$c({
    cursor: "pointer",
    WebkitAppearance: "none",
    marginLeft: "0",
    marginRight: "0",
    marginTop: "0",
    marginBottom: "0",
    boxSizing: "border-box",
    display: "inline-flex",
    alignItems: "center",
    paddingLeft: E.sizing.scale600,
    paddingTop: E.sizing.scale600,
    paddingRight: E.sizing.scale600,
    paddingBottom: E.sizing.scale600,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    borderRightWidth: 0,
    borderBottomWidth: 0,
    borderLeftStyle: "none",
    borderTopStyle: "none",
    borderRightStyle: "none",
    borderBottomStyle: "none",
    color: E.colors.contentPrimary,
    background: E.colors.backgroundPrimary,
    transitionProperty: "background",
    transitionDuration: E.animation.timing200,
    transitionTimingFunction: E.animation.linearCurve,
    outline: "none",
    outlineOffset: "-3px",
    ":disabled": {
      cursor: "not-allowed",
      color: E.colors.contentStateDisabled
    },
    ":hover": {
      background: E.colors.backgroundSecondary
    },
    ":disabled:hover": {
      background: "none"
    }
  }, E.typography.LabelSmall);
  return n && (h.outline = "3px solid ".concat(E.colors.accent)), isFixed(t) && (h.flexGrow = 1, h.flexBasis = 0), isHorizontal(g) ? h.justifyContent = "center" : h.justifyContent = "flex-end", h;
});
StyledTab.displayName = "StyledTab";
StyledTab.displayName = "StyledTab";
var StyledEndEnhancerContainer = styled("div", function(o) {
  var E = o.$theme, A = E.direction === "rtl" ? "marginRight" : "marginLeft";
  return _defineProperty$f({
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end"
  }, A, E.sizing.scale600);
});
StyledEndEnhancerContainer.displayName = "StyledEndEnhancerContainer";
StyledEndEnhancerContainer.displayName = "StyledEndEnhancerContainer";
var StyledArtworkContainer = styled("div", function(o) {
  var E = o.$theme;
  o.$orientation;
  var A = {
    display: "flex"
  };
  return isRTL(E.direction) ? A.marginLeft = E.sizing.scale300 : A.marginRight = E.sizing.scale300, A;
});
StyledArtworkContainer.displayName = "StyledArtworkContainer";
StyledArtworkContainer.displayName = "StyledArtworkContainer";
var StyledTabBorder = styled("div", function(o) {
  var E = o.$theme, A = o.$orientation, g = A === void 0 ? ORIENTATION.horizontal : A, e = {
    backgroundColor: E.colors.borderOpaque,
    position: "relative"
  };
  return isHorizontal(g) ? e.height = "5px" : e.width = "5px", e;
});
StyledTabBorder.displayName = "StyledTabBorder";
StyledTabBorder.displayName = "StyledTabBorder";
var StyledTabHighlight = styled("div", function(o) {
  var E = o.$theme, A = o.$orientation, g = A === void 0 ? ORIENTATION.horizontal : A, e = o.$length, t = e === void 0 ? 0 : e, c = o.$distance, n = c === void 0 ? 0 : c, h = o.$animate, d = h === void 0 ? !1 : h, k = {
    backgroundColor: E.colors.borderSelected,
    position: "absolute",
    zIndex: 1
  };
  return isHorizontal(g) ? (k.bottom = "0px", k.left = "0px", k.height = "5px", k.width = "".concat(t, "px"), k.transform = "translateX(".concat(n, "px)")) : (k.transform = "translateY(".concat(n, "px)"), k.width = "5px", k.height = "".concat(t, "px"), isRTL(E.direction) ? k.left = "0px" : k.right = "0px"), d && (k.transitionProperty = "all", k.transitionDuration = E.animation.timing400, k.transitionTimingFunction = E.animation.easeInOutQuinticCurve), k;
});
StyledTabHighlight.displayName = "StyledTabHighlight";
StyledTabHighlight.displayName = "StyledTabHighlight";
var StyledTabPanel = styled("div", function(o) {
  var E = o.$theme, A = o.$pad, g = A === void 0 ? !0 : A, e = {
    flexGrow: 1,
    // only used in vertical orientation
    outline: "none"
  };
  return g && (e.paddingTop = E.sizing.scale600, e.paddingRight = E.sizing.scale600, e.paddingBottom = E.sizing.scale600, e.paddingLeft = E.sizing.scale600), e;
});
StyledTabPanel.displayName = "StyledTabPanel";
StyledTabPanel.displayName = "StyledTabPanel";
var _excluded$j = ["childKey", "childIndex", "activeKey", "orientation", "activeTabRef", "updateHighlight", "parseKeyDown", "activateOnFocus", "uid", "disabled", "sharedStylingProps", "onChange"], _excluded2$4 = ["artwork", "overrides", "tabRef", "onClick", "title"], _excluded3$1 = ["childKey", "childIndex", "activeKey", "uid", "sharedStylingProps", "renderAll"];
function ownKeys$d(o, E) {
  var A = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var g = Object.getOwnPropertySymbols(o);
    E && (g = g.filter(function(e) {
      return Object.getOwnPropertyDescriptor(o, e).enumerable;
    })), A.push.apply(A, g);
  }
  return A;
}
function _objectSpread$b(o) {
  for (var E = 1; E < arguments.length; E++) {
    var A = arguments[E] != null ? arguments[E] : {};
    E % 2 ? ownKeys$d(Object(A), !0).forEach(function(g) {
      _defineProperty$e(o, g, A[g]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(A)) : ownKeys$d(Object(A)).forEach(function(g) {
      Object.defineProperty(o, g, Object.getOwnPropertyDescriptor(A, g));
    });
  }
  return o;
}
function _defineProperty$e(o, E, A) {
  return E in o ? Object.defineProperty(o, E, { value: A, enumerable: !0, configurable: !0, writable: !0 }) : o[E] = A, o;
}
function _toConsumableArray$1(o) {
  return _arrayWithoutHoles$1(o) || _iterableToArray$1(o) || _unsupportedIterableToArray$e(o) || _nonIterableSpread$1();
}
function _nonIterableSpread$1() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _iterableToArray$1(o) {
  if (typeof Symbol < "u" && o[Symbol.iterator] != null || o["@@iterator"] != null) return Array.from(o);
}
function _arrayWithoutHoles$1(o) {
  if (Array.isArray(o)) return _arrayLikeToArray$e(o);
}
function _objectWithoutProperties$h(o, E) {
  if (o == null) return {};
  var A = _objectWithoutPropertiesLoose$g(o, E), g, e;
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    for (e = 0; e < t.length; e++)
      g = t[e], !(E.indexOf(g) >= 0) && Object.prototype.propertyIsEnumerable.call(o, g) && (A[g] = o[g]);
  }
  return A;
}
function _objectWithoutPropertiesLoose$g(o, E) {
  if (o == null) return {};
  var A = {}, g = Object.keys(o), e, t;
  for (t = 0; t < g.length; t++)
    e = g[t], !(E.indexOf(e) >= 0) && (A[e] = o[e]);
  return A;
}
function _extends$j() {
  return _extends$j = Object.assign ? Object.assign.bind() : function(o) {
    for (var E = 1; E < arguments.length; E++) {
      var A = arguments[E];
      for (var g in A)
        Object.prototype.hasOwnProperty.call(A, g) && (o[g] = A[g]);
    }
    return o;
  }, _extends$j.apply(this, arguments);
}
function _slicedToArray$f(o, E) {
  return _arrayWithHoles$e(o) || _iterableToArrayLimit$e(o, E) || _unsupportedIterableToArray$e(o, E) || _nonIterableRest$e();
}
function _nonIterableRest$e() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$e(o, E) {
  if (o) {
    if (typeof o == "string") return _arrayLikeToArray$e(o, E);
    var A = Object.prototype.toString.call(o).slice(8, -1);
    if (A === "Object" && o.constructor && (A = o.constructor.name), A === "Map" || A === "Set") return Array.from(o);
    if (A === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(A)) return _arrayLikeToArray$e(o, E);
  }
}
function _arrayLikeToArray$e(o, E) {
  (E == null || E > o.length) && (E = o.length);
  for (var A = 0, g = new Array(E); A < E; A++)
    g[A] = o[A];
  return g;
}
function _iterableToArrayLimit$e(o, E) {
  var A = o == null ? null : typeof Symbol < "u" && o[Symbol.iterator] || o["@@iterator"];
  if (A != null) {
    var g = [], e = !0, t = !1, c, n;
    try {
      for (A = A.call(o); !(e = (c = A.next()).done) && (g.push(c.value), !(E && g.length === E)); e = !0)
        ;
    } catch (h) {
      t = !0, n = h;
    } finally {
      try {
        !e && A.return != null && A.return();
      } finally {
        if (t) throw n;
      }
    }
    return g;
  }
}
function _arrayWithHoles$e(o) {
  if (Array.isArray(o)) return o;
}
var KEYBOARD_ACTION = {
  next: "next",
  previous: "previous"
}, getLayoutParams = function o(E, A) {
  return E ? isVertical(A) ? {
    length: E.clientHeight,
    distance: E.offsetTop
  } : {
    length: E.clientWidth,
    distance: E.offsetLeft
  } : {
    length: 0,
    distance: 0
  };
}, scrollParentToCentreTarget = function o(E) {
  var A = E.parentNode.getBoundingClientRect(), g = A.x, e = A.y, t = A.width, c = A.height, n = E.getBoundingClientRect(), h = n.x, d = n.y, k = n.width, p = n.height, M = {
    x: h - g + k / 2,
    y: d - e + p / 2
  }, S = E.parentNode, AA = S.scrollLeft, H = S.scrollTop, gA = {
    x: AA + M.x - t / 2,
    y: H + M.y - c / 2
  };
  E.parentNode.scroll(gA.x, gA.y);
};
function RenderEnhancer(o) {
  var E = o.Enhancer;
  return typeof E == "string" ? E : reactIsExports$1.isValidElementType(E) ? /* @__PURE__ */ React.createElement(E, null) : E;
}
function Tabs$2(o) {
  var E = o.activeKey, A = E === void 0 ? "0" : E, g = o.disabled, e = g === void 0 ? !1 : g, t = o.children, c = o.fill, n = c === void 0 ? FILL.intrinsic : c, h = o.activateOnFocus, d = h === void 0 ? !0 : h, k = o.onChange, p = o.orientation, M = p === void 0 ? ORIENTATION.horizontal : p, S = o.overrides, AA = S === void 0 ? {} : S, H = o.renderAll, gA = H === void 0 ? !1 : H, CA = o.uid, IA = CA === void 0 ? null : CA, BA = o.endEnhancer, QA = useUID(), EA = IA || QA, oA = AA.Root, iA = AA.TabList, aA = AA.TabHighlight, tA = AA.TabBorder, eA = getOverrides(oA, StyledRoot$1), cA = _slicedToArray$f(eA, 2), DA = cA[0], nA = cA[1], wA = getOverrides(iA, StyledTabList), lA = _slicedToArray$f(wA, 2), NA = lA[0], RA = lA[1], KA = getOverrides(aA, StyledTabHighlight), vA = _slicedToArray$f(KA, 2), GA = vA[0], FA = vA[1], HA = getOverrides(tA, StyledTabBorder), sA = _slicedToArray$f(HA, 2), mA = sA[0], xA = sA[1], hA = getOverrides(AA.EndEnhancerContainer, StyledEndEnhancerContainer), MA = _slicedToArray$f(hA, 2), YA = MA[0], LA = MA[1], WA = React.useState(0), zA = _slicedToArray$f(WA, 2), ZA = zA[0], Ag = zA[1];
  React.useEffect(function() {
    Ag(ZA + 1);
  }, [A]);
  var UA = React.useRef(), ig = React.useState({
    length: 0,
    distance: 0
  }), og = _slicedToArray$f(ig, 2), PA = og[0], Gg = og[1], gg = React.useCallback(function() {
    UA.current && Gg(getLayoutParams(UA.current, M));
  }, [UA.current, M]);
  React.useEffect(gg, [UA.current, M]), React.useEffect(function() {
    UA.current && (isHorizontal(M) ? (
      // @ts-expect-error todo(flow->ts) maybe parentElement?
      UA.current.parentNode.scrollWidth > // @ts-expect-error todo(flow->ts) maybe parentElement?
      UA.current.parentNode.clientWidth
    ) : (
      // @ts-expect-error todo(flow->ts) maybe parentElement?
      UA.current.parentNode.scrollHeight > // @ts-expect-error todo(flow->ts) maybe parentElement?
      UA.current.parentNode.clientHeight
    )) && (ZA > 1 ? UA.current.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
      inline: "nearest"
    }) : scrollParentToCentreTarget(UA.current));
  }, [UA.current]);
  var eg = {
    $orientation: M,
    $fill: n
  }, Dg = useStyletron(), rg = _slicedToArray$f(Dg, 2), cg = rg[1], hg = React.useCallback(function(Cg) {
    if (isHorizontal(M))
      if (isRTL(cg.direction))
        switch (Cg.keyCode) {
          case 39:
            return KEYBOARD_ACTION.previous;
          case 37:
            return KEYBOARD_ACTION.next;
          default:
            return null;
        }
      else
        switch (Cg.keyCode) {
          case 37:
            return KEYBOARD_ACTION.previous;
          case 39:
            return KEYBOARD_ACTION.next;
          default:
            return null;
        }
    else
      switch (Cg.keyCode) {
        case 38:
          return KEYBOARD_ACTION.previous;
        case 40:
          return KEYBOARD_ACTION.next;
        default:
          return null;
      }
  }, [M, cg.direction]);
  return /* @__PURE__ */ React.createElement(DA, _extends$j({}, eg, nA), /* @__PURE__ */ React.createElement(StyledTabBar, {
    $hasEndEnhancer: !!BA,
    $orientation: M
  }, /* @__PURE__ */ React.createElement(NA, _extends$j({
    "data-baseweb": "tab-list",
    role: "tablist",
    "aria-orientation": M
  }, eg, RA), React.Children.map(t, function(Cg, dA) {
    if (Cg)
      return /* @__PURE__ */ React.createElement(InternalTab, _extends$j({
        childKey: Cg.key,
        childIndex: dA,
        activeKey: A,
        orientation: M,
        activeTabRef: UA,
        updateHighlight: gg,
        parseKeyDown: hg,
        activateOnFocus: d,
        uid: EA,
        disabled: e,
        sharedStylingProps: eg,
        onChange: k
      }, Cg.props));
  }), /* @__PURE__ */ React.createElement(GA, _extends$j({
    "data-baseweb": "tab-highlight",
    $length: PA.length,
    $distance: PA.distance,
    $animate: ZA > 1,
    "aria-hidden": "true",
    role: "presentation"
  }, eg, FA))), M === ORIENTATION.horizontal && BA !== null && BA !== void 0 && /* @__PURE__ */ React.createElement(YA, _extends$j({}, LA, {
    $orientation: M
  }), /* @__PURE__ */ React.createElement(RenderEnhancer, {
    Enhancer: BA
  }))), /* @__PURE__ */ React.createElement(mA, _extends$j({
    "data-baseweb": "tab-border",
    "aria-hidden": "true",
    role: "presentation"
  }, eg, xA)), React.Children.map(t, function(Cg, dA) {
    if (Cg)
      return /* @__PURE__ */ React.createElement(InternalTabPanel, _extends$j({
        childKey: Cg.key,
        childIndex: dA,
        activeKey: A,
        uid: EA,
        sharedStylingProps: eg,
        renderAll: gA
      }, Cg.props));
  }));
}
function InternalTab(o) {
  var E = o.childKey, A = o.childIndex, g = o.activeKey, e = o.orientation, t = o.activeTabRef, c = o.updateHighlight, n = o.parseKeyDown, h = o.activateOnFocus, d = o.uid, k = o.disabled, p = o.sharedStylingProps, M = o.onChange, S = _objectWithoutProperties$h(o, _excluded$j), AA = E || String(A), H = AA == g, gA = S.artwork, CA = S.overrides, IA = CA === void 0 ? {} : CA, BA = S.tabRef, QA = S.onClick, EA = S.title, oA = _objectWithoutProperties$h(S, _excluded2$4), iA = React.useRef();
  React.useImperativeHandle(BA, function() {
    return H ? t.current : iA.current;
  });
  var aA = React.useRef({
    length: 0,
    distance: 0
  });
  React.useEffect(function() {
    aA.current = getLayoutParams(H ? t.current : iA.current, e);
  }), React.useEffect(function() {
    if (window.ResizeObserver) {
      var hA = new window.ResizeObserver(function(MA) {
        if (MA[0] && MA[0].target) {
          var YA = getLayoutParams(MA[0].target, e);
          (YA.length !== aA.current.length || YA.distance !== aA.current.distance) && c();
        }
      });
      return hA.observe(H ? t.current : iA.current), function() {
        hA.disconnect();
      };
    }
  }, [g, e]), React.useEffect(c, [EA]);
  var tA = IA.Tab, eA = IA.ArtworkContainer, cA = getOverrides(tA, StyledTab), DA = _slicedToArray$f(cA, 2), nA = DA[0], wA = DA[1], lA = getOverrides(eA, StyledArtworkContainer), NA = _slicedToArray$f(lA, 2), RA = NA[0], KA = NA[1], vA = React.useState(!1), GA = _slicedToArray$f(vA, 2), FA = GA[0], HA = GA[1], sA = React.useCallback(function(hA) {
    isFocusVisible(hA) && HA(!0);
  }, []), mA = React.useCallback(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    function(hA) {
      FA !== !1 && HA(!1);
    },
    [FA]
  ), xA = React.useCallback(function(hA) {
    var MA = _toConsumableArray$1(hA.target.parentNode.childNodes).filter(function(zA) {
      return !zA.disabled && zA.getAttribute("role") === "tab";
    });
    if (MA.length !== 1) {
      var YA = MA.indexOf(hA.target), LA = n(hA);
      if (LA) {
        var WA;
        LA === KEYBOARD_ACTION.previous ? MA[YA - 1] ? WA = MA[YA - 1] : WA = MA[MA.length - 1] : LA === KEYBOARD_ACTION.next && (MA[YA + 1] ? WA = MA[YA + 1] : WA = MA[0]), WA && (WA.focus(), h && WA.click()), isVertical(e) && hA.preventDefault();
      }
    }
  });
  return /* @__PURE__ */ React.createElement(nA, _extends$j({
    "data-baseweb": "tab",
    key: AA,
    id: getTabId(d, AA),
    role: "tab",
    onKeyDown: xA,
    "aria-selected": H,
    "aria-controls": getTabPanelId(d, AA),
    tabIndex: H ? "0" : "-1",
    ref: H ? t : iA,
    disabled: !H && k,
    type: "button",
    $focusVisible: FA,
    $isActive: H
  }, p, oA, wA, {
    onClick: function(MA) {
      typeof M == "function" && M({
        activeKey: AA
      }), typeof QA == "function" && QA(MA);
    },
    onFocus: forkFocus(_objectSpread$b(_objectSpread$b({}, oA), wA), sA),
    onBlur: forkBlur(_objectSpread$b(_objectSpread$b({}, oA), wA), mA)
  }), gA ? /* @__PURE__ */ React.createElement(RA, _extends$j({
    "data-baseweb": "artwork-container"
  }, p, KA), /* @__PURE__ */ React.createElement(gA, {
    size: 20,
    color: "contentPrimary"
  })) : null, EA || AA);
}
function InternalTabPanel(o) {
  var E = o.childKey, A = o.childIndex, g = o.activeKey, e = o.uid, t = o.sharedStylingProps, c = o.renderAll, n = _objectWithoutProperties$h(o, _excluded3$1), h = E || String(A), d = h == g, k = n.overrides, p = k === void 0 ? {} : k, M = n.children, S = p.TabPanel, AA = getOverrides(S, StyledTabPanel), H = _slicedToArray$f(AA, 2), gA = H[0], CA = H[1];
  return /* @__PURE__ */ React.createElement(gA, _extends$j({
    "data-baseweb": "tab-panel",
    key: h,
    role: "tabpanel",
    id: getTabPanelId(e, h),
    "aria-labelledby": getTabId(e, h),
    hidden: !d
  }, t, CA), d || c ? M : null);
}
function Tab(o) {
  return null;
}
function getClassnamePrefix(o) {
  return o === Direction.HORIZONTAL ? "stHorizontalBlock" : "stVerticalBlock";
}
function shouldComponentBeEnabled(o, E) {
  return o !== "empty" || E !== ScriptRunState.RUNNING;
}
function isElementStale(o, E, A, g) {
  return E === ScriptRunState.RERUN_REQUESTED ? !0 : E === ScriptRunState.RUNNING ? g?.length ? !!(o.fragmentId && g.includes(o.fragmentId) && o.scriptRunId !== A) : o.scriptRunId !== A : !1;
}
function isComponentStale(o, E, A, g, e) {
  return !o || isElementStale(E, A, g, e);
}
function assignDividerColor(o, E) {
  const A = getDividerColors(E), g = Object.keys(A), {
    blue: e,
    green: t,
    orange: c,
    red: n,
    violet: h,
    yellow: d
  } = A, k = {
    blue: e,
    green: t,
    orange: c,
    red: n,
    violet: h,
    yellow: d
  }, p = Object.keys(k);
  let M = 0;
  for (const S of ElementsSetVisitor.collectElements(o)) {
    const AA = S.heading?.divider;
    if (S.type === "heading" && AA)
      if (AA === "auto") {
        const H = p[M];
        S.heading.divider = k[H], M += 1, M === p.length && (M = 0);
      } else g.includes(AA) && (S.heading.divider = A[AA]);
  }
}
function convertKeyToClassName(o) {
  return o ? "st-key-" + o.trim().replace(/[^a-zA-Z0-9_-]/g, "-") : "";
}
function getKeyFromId(o) {
  if (!o || !isValidElementId(o))
    return;
  const A = o.split("-").slice(2).join("-");
  return A === "None" ? void 0 : A;
}
function backwardsCompatibleColumnGapSize(o) {
  if (o.gapConfig?.gapSize)
    return o.gapConfig.gapSize;
  if (o.gap) {
    if (o.gap === "small")
      return streamlit.GapSize.SMALL;
    if (o.gap === "medium")
      return streamlit.GapSize.MEDIUM;
    if (o.gap === "large")
      return streamlit.GapSize.LARGE;
  }
  return streamlit.GapSize.SMALL;
}
function checkFlexContainerBackwardsCompatibile(o) {
  return !!(o.flexContainer || o.vertical || o.horizontal);
}
function getActivateScrollToBottomBackwardsCompatible(o) {
  return !!((o.deltaBlock.heightConfig?.pixelHeight || // This is deprecated, but we have some integrations that
  // cache messages so we are keeping this here to make sure the
  // frontend is backwards compatible with the old messages.
  o.deltaBlock.vertical?.height) && o.children.some((A) => A instanceof BlockNode && A.deltaBlock.type === "chatMessage"));
}
function getBorderBackwardsCompatible(o) {
  return o.flexContainer?.border || o.vertical?.border || !1;
}
const StyledTabContainer = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "esjhkag0"
} : {
  target: "esjhkag0",
  label: "StyledTabContainer"
})(({
  theme: o,
  isOverflowing: E,
  tabHeight: A,
  width: g,
  flex: e
}) => ({
  ...E ? {
    position: "relative",
    "::after": {
      content: '" "',
      position: "absolute",
      zIndex: o.zIndices.priority,
      top: 0,
      right: 0,
      pointerEvents: "none",
      backgroundImage: `linear-gradient(to right, ${transparentize(o.colors.bgColor, 1)}, ${o.colors.bgColor})`,
      width: o.spacing.lg,
      height: A
    }
  } : {},
  ...g && {
    width: g
  },
  ...e && {
    flex: e
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
function Tabs(o) {
  const {
    widgetsDisabled: E,
    node: A,
    isStale: g,
    width: e,
    flex: t
  } = o, {
    scriptRunState: c,
    scriptRunId: n,
    fragmentIdsThisRun: h
  } = useContext(ScriptRunContext), d = A.deltaBlock?.tabContainer?.defaultTabIndex ?? 0;
  let k = [];
  const [p, M] = useState(d), [S, AA] = useState(() => A.children[d]?.deltaBlock?.tab?.label ?? "0"), H = useRef(null), gA = useEmotionTheme(), [CA, IA] = useState(!1);
  useEffect(() => {
    k.indexOf(S) === -1 && (M(d), AA(k[d]));
  }, [k]), useEffect(() => {
    if (H.current) {
      const {
        scrollWidth: oA,
        clientWidth: iA
      } = H.current;
      IA(oA > iA);
    }
    const EA = k.indexOf(S);
    EA !== -1 ? (M(EA), AA(k[EA])) : (M(d), AA(k[d]));
  }, [A.children.length]);
  const BA = gA.sizes.tabHeight, QA = gA.spacing.threeXS;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledTabContainer, { className: "stTabs", "data-testid": "stTabs", isOverflowing: CA, tabHeight: BA, width: e, flex: t, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    Tabs$2,
    {
      activateOnFocus: !0,
      activeKey: p,
      onChange: ({
        activeKey: EA
      }) => {
        M(EA), AA(k[EA]);
      },
      renderAll: !0,
      overrides: {
        TabHighlight: {
          style: () => ({
            backgroundColor: gA.colors.primary,
            height: QA
          })
        },
        TabBorder: {
          style: () => ({
            backgroundColor: gA.colors.borderColorLight,
            height: QA
          })
        },
        TabList: {
          props: {
            ref: H
          },
          style: () => ({
            gap: gA.spacing.lg,
            marginBottom: `-${QA}`,
            paddingBottom: QA,
            overflowY: "hidden",
            ...g && STALE_STYLES
          })
        },
        Root: {
          style: () => ({
            // resetting transform to fix full screen wrapper
            transform: "none"
          })
        }
      },
      children: A.children.map((EA, oA) => {
        oA === 0 && (k = []);
        const iA = isElementStale(EA, c, n, h), aA = {
          ...o,
          isStale: g || iA,
          widgetsDisabled: E,
          node: EA
        };
        let tA = oA.toString();
        aA.node.deltaBlock?.tab?.label && (tA = aA.node.deltaBlock.tab.label), k[oA] = tA;
        const eA = p.toString() === oA.toString(), cA = oA === A.children.length - 1;
        return /* @__PURE__ */ jsxRuntimeExports.jsx(
          Tab,
          {
            "data-testid": "stTab",
            title: /* @__PURE__ */ jsxRuntimeExports.jsx(StreamlitMarkdown$1, { source: tA, allowHTML: !1, isLabel: !0 }),
            disabled: !g && iA,
            overrides: {
              TabPanel: {
                style: () => ({
                  paddingLeft: gA.spacing.none,
                  paddingRight: gA.spacing.none,
                  paddingBottom: gA.spacing.none,
                  paddingTop: gA.spacing.lg
                })
              },
              Tab: {
                style: () => ({
                  height: BA,
                  whiteSpace: "nowrap",
                  paddingLeft: gA.spacing.none,
                  paddingRight: gA.spacing.none,
                  paddingTop: gA.spacing.none,
                  paddingBottom: gA.spacing.none,
                  fontSize: gA.fontSizes.sm,
                  background: "transparent",
                  color: gA.colors.bodyText,
                  ":focus": {
                    outline: "none",
                    color: gA.colors.primary,
                    background: "none"
                  },
                  ":hover": {
                    color: gA.colors.primary,
                    background: "none"
                  },
                  ...eA ? {
                    color: gA.colors.primary
                  } : {},
                  // Add minimal required padding to hide the overscroll gradient
                  // This is calculated based on the width of the gradient (spacing.lg)
                  ...CA && cA ? {
                    paddingRight: `calc(${gA.spacing.lg} * 0.6)`
                  } : {},
                  // Apply stale effect if only this specific
                  // tab is stale but not the entire tab container.
                  ...!g && iA && STALE_STYLES
                })
              }
            },
            children: o.renderTabContent(aA)
          },
          oA
        );
      })
    }
  ) });
}
const Tabs$1 = memo(Tabs), FormsContext = createContext(null);
FormsContext.displayName = "FormsContext";
const useRequiredContext = (o) => {
  const E = useContext(o);
  if (E == null)
    throw new Error(`useRequiredContext: ${o.displayName ?? "context"} not found`);
  return E;
};
function _EMOTION_STRINGIFIED_CSS_ERROR__$c() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const StyledFormSubmitContent = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e10yg2by2"
} : {
  target: "e10yg2by2",
  label: "StyledFormSubmitContent"
})(process.env.NODE_ENV === "production" ? {
  name: "zjik7",
  styles: "display:flex"
} : {
  name: "zjik7",
  styles: "display:flex/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$c
}), StyledForm = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e10yg2by1"
} : {
  target: "e10yg2by1",
  label: "StyledForm"
})(({
  theme: o,
  border: E,
  overflow: A
}) => ({
  ...E && {
    border: `${o.sizes.borderWidth} solid ${o.colors.borderColor}`,
    borderRadius: o.radii.default,
    padding: `calc(${o.spacing.lg} - ${o.sizes.borderWidth})`
  },
  width: "100%",
  height: "100%",
  overflow: A
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledErrorContainer = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e10yg2by0"
} : {
  target: "e10yg2by0",
  label: "StyledErrorContainer"
})(({
  theme: o
}) => ({
  marginTop: o.spacing.lg
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledAlertContent = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e1eexb541"
} : {
  target: "e1eexb541",
  label: "StyledAlertContent"
})(({
  theme: o
}) => ({
  display: "flex",
  gap: o.spacing.sm,
  width: "100%",
  [`${StyledCodeBlock} code`]: {
    paddingRight: o.spacing.lg
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2xpYi9zcmMvY29tcG9uZW50cy9lbGVtZW50cy9BbGVydEVsZW1lbnQvc3R5bGVkLWNvbXBvbmVudHMudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQW9Ca0MiLCJmaWxlIjoiL2hvbWUvcnVubmVyL3dvcmsvc3RsaXRlL3N0bGl0ZS9zdHJlYW1saXQvZnJvbnRlbmQvbGliL3NyYy9jb21wb25lbnRzL2VsZW1lbnRzL0FsZXJ0RWxlbWVudC9zdHlsZWQtY29tcG9uZW50cy50c3giLCJzb3VyY2VzQ29udGVudCI6WyIvKipcbiAqIENvcHlyaWdodCAoYykgU3RyZWFtbGl0IEluYy4gKDIwMTgtMjAyMikgU25vd2ZsYWtlIEluYy4gKDIwMjItMjAyNSlcbiAqXG4gKiBMaWNlbnNlZCB1bmRlciB0aGUgQXBhY2hlIExpY2Vuc2UsIFZlcnNpb24gMi4wICh0aGUgXCJMaWNlbnNlXCIpO1xuICogeW91IG1heSBub3QgdXNlIHRoaXMgZmlsZSBleGNlcHQgaW4gY29tcGxpYW5jZSB3aXRoIHRoZSBMaWNlbnNlLlxuICogWW91IG1heSBvYnRhaW4gYSBjb3B5IG9mIHRoZSBMaWNlbnNlIGF0XG4gKlxuICogICAgIGh0dHA6Ly93d3cuYXBhY2hlLm9yZy9saWNlbnNlcy9MSUNFTlNFLTIuMFxuICpcbiAqIFVubGVzcyByZXF1aXJlZCBieSBhcHBsaWNhYmxlIGxhdyBvciBhZ3JlZWQgdG8gaW4gd3JpdGluZywgc29mdHdhcmVcbiAqIGRpc3RyaWJ1dGVkIHVuZGVyIHRoZSBMaWNlbnNlIGlzIGRpc3RyaWJ1dGVkIG9uIGFuIFwiQVMgSVNcIiBCQVNJUyxcbiAqIFdJVEhPVVQgV0FSUkFOVElFUyBPUiBDT05ESVRJT05TIE9GIEFOWSBLSU5ELCBlaXRoZXIgZXhwcmVzcyBvciBpbXBsaWVkLlxuICogU2VlIHRoZSBMaWNlbnNlIGZvciB0aGUgc3BlY2lmaWMgbGFuZ3VhZ2UgZ292ZXJuaW5nIHBlcm1pc3Npb25zIGFuZFxuICogbGltaXRhdGlvbnMgdW5kZXIgdGhlIExpY2Vuc2UuXG4gKi9cblxuaW1wb3J0IHN0eWxlZCBmcm9tIFwiQGVtb3Rpb24vc3R5bGVkXCJcblxuaW1wb3J0IHsgU3R5bGVkQ29kZUJsb2NrIH0gZnJvbSBcIn5saWIvY29tcG9uZW50cy9lbGVtZW50cy9Db2RlQmxvY2svc3R5bGVkLWNvbXBvbmVudHNcIlxuXG5leHBvcnQgY29uc3QgU3R5bGVkQWxlcnRDb250ZW50ID0gc3R5bGVkLmRpdigoeyB0aGVtZSB9KSA9PiAoe1xuICBkaXNwbGF5OiBcImZsZXhcIixcbiAgZ2FwOiB0aGVtZS5zcGFjaW5nLnNtLFxuICB3aWR0aDogXCIxMDAlXCIsXG5cbiAgW2Ake1N0eWxlZENvZGVCbG9ja30gY29kZWBdOiB7XG4gICAgcGFkZGluZ1JpZ2h0OiB0aGVtZS5zcGFjaW5nLmxnLFxuICB9LFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRBbGVydEljb24gPSBzdHlsZWQuZGl2KCh7IHRoZW1lIH0pID0+ICh7XG4gIHBvc2l0aW9uOiBcInJlbGF0aXZlXCIsXG4gIHRvcDogdGhlbWUuc3BhY2luZy50aHJlZVhTLFxufSkpXG4iXX0= */"), StyledAlertIcon = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e1eexb540"
} : {
  target: "e1eexb540",
  label: "StyledAlertIcon"
})(({
  theme: o
}) => ({
  position: "relative",
  top: o.spacing.threeXS
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2xpYi9zcmMvY29tcG9uZW50cy9lbGVtZW50cy9BbGVydEVsZW1lbnQvc3R5bGVkLWNvbXBvbmVudHMudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQThCK0IiLCJmaWxlIjoiL2hvbWUvcnVubmVyL3dvcmsvc3RsaXRlL3N0bGl0ZS9zdHJlYW1saXQvZnJvbnRlbmQvbGliL3NyYy9jb21wb25lbnRzL2VsZW1lbnRzL0FsZXJ0RWxlbWVudC9zdHlsZWQtY29tcG9uZW50cy50c3giLCJzb3VyY2VzQ29udGVudCI6WyIvKipcbiAqIENvcHlyaWdodCAoYykgU3RyZWFtbGl0IEluYy4gKDIwMTgtMjAyMikgU25vd2ZsYWtlIEluYy4gKDIwMjItMjAyNSlcbiAqXG4gKiBMaWNlbnNlZCB1bmRlciB0aGUgQXBhY2hlIExpY2Vuc2UsIFZlcnNpb24gMi4wICh0aGUgXCJMaWNlbnNlXCIpO1xuICogeW91IG1heSBub3QgdXNlIHRoaXMgZmlsZSBleGNlcHQgaW4gY29tcGxpYW5jZSB3aXRoIHRoZSBMaWNlbnNlLlxuICogWW91IG1heSBvYnRhaW4gYSBjb3B5IG9mIHRoZSBMaWNlbnNlIGF0XG4gKlxuICogICAgIGh0dHA6Ly93d3cuYXBhY2hlLm9yZy9saWNlbnNlcy9MSUNFTlNFLTIuMFxuICpcbiAqIFVubGVzcyByZXF1aXJlZCBieSBhcHBsaWNhYmxlIGxhdyBvciBhZ3JlZWQgdG8gaW4gd3JpdGluZywgc29mdHdhcmVcbiAqIGRpc3RyaWJ1dGVkIHVuZGVyIHRoZSBMaWNlbnNlIGlzIGRpc3RyaWJ1dGVkIG9uIGFuIFwiQVMgSVNcIiBCQVNJUyxcbiAqIFdJVEhPVVQgV0FSUkFOVElFUyBPUiBDT05ESVRJT05TIE9GIEFOWSBLSU5ELCBlaXRoZXIgZXhwcmVzcyBvciBpbXBsaWVkLlxuICogU2VlIHRoZSBMaWNlbnNlIGZvciB0aGUgc3BlY2lmaWMgbGFuZ3VhZ2UgZ292ZXJuaW5nIHBlcm1pc3Npb25zIGFuZFxuICogbGltaXRhdGlvbnMgdW5kZXIgdGhlIExpY2Vuc2UuXG4gKi9cblxuaW1wb3J0IHN0eWxlZCBmcm9tIFwiQGVtb3Rpb24vc3R5bGVkXCJcblxuaW1wb3J0IHsgU3R5bGVkQ29kZUJsb2NrIH0gZnJvbSBcIn5saWIvY29tcG9uZW50cy9lbGVtZW50cy9Db2RlQmxvY2svc3R5bGVkLWNvbXBvbmVudHNcIlxuXG5leHBvcnQgY29uc3QgU3R5bGVkQWxlcnRDb250ZW50ID0gc3R5bGVkLmRpdigoeyB0aGVtZSB9KSA9PiAoe1xuICBkaXNwbGF5OiBcImZsZXhcIixcbiAgZ2FwOiB0aGVtZS5zcGFjaW5nLnNtLFxuICB3aWR0aDogXCIxMDAlXCIsXG5cbiAgW2Ake1N0eWxlZENvZGVCbG9ja30gY29kZWBdOiB7XG4gICAgcGFkZGluZ1JpZ2h0OiB0aGVtZS5zcGFjaW5nLmxnLFxuICB9LFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRBbGVydEljb24gPSBzdHlsZWQuZGl2KCh7IHRoZW1lIH0pID0+ICh7XG4gIHBvc2l0aW9uOiBcInJlbGF0aXZlXCIsXG4gIHRvcDogdGhlbWUuc3BhY2luZy50aHJlZVhTLFxufSkpXG4iXX0= */");
function AlertElement({
  icon: o,
  body: E,
  kind: A
}) {
  const g = useEmotionTheme(), e = {
    // Fix issue #6394 - Need to account for icon size (iconSizes.lg) + gap when icon present
    width: o ? `calc(100% - (${g.iconSizes.lg} + ${g.spacing.sm}))` : "100%"
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "stAlert", "data-testid": "stAlert", children: /* @__PURE__ */ jsxRuntimeExports.jsx(AlertContainer, { kind: A, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledAlertContent, { children: [
    o && /* @__PURE__ */ jsxRuntimeExports.jsx(StyledAlertIcon, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(DynamicIcon, { iconValue: o, size: "lg", testid: "stAlertDynamicIcon" }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(StreamlitMarkdown$1, { source: E, allowHTML: !1, style: e })
  ] }) }) });
}
const AlertElement$1 = memo(AlertElement);
function getAlertElementKind(o) {
  switch (o) {
    case Alert.Format.ERROR:
      return Kind.ERROR;
    case Alert.Format.INFO:
      return Kind.INFO;
    case Alert.Format.SUCCESS:
      return Kind.SUCCESS;
    case Alert.Format.WARNING:
      return Kind.WARNING;
    default:
      throw new Error(`Unexpected alert type: ${o}`);
  }
}
const MISSING_SUBMIT_BUTTON_WARNING = `**Missing Submit Button**

This form has no submit button, which means that user interactions will never be sent to your Streamlit app.

To create a submit button, use the \`st.form_submit_button()\` function.

For more information, refer to the [documentation for forms](https://docs.streamlit.io/develop/api-reference/execution-flow/st.form).`;
function Form(o) {
  const {
    formId: E,
    widgetMgr: A,
    children: g,
    clearOnSubmit: e,
    enterToSubmit: t,
    border: c,
    overflow: n
  } = o, {
    formsData: h
  } = useRequiredContext(FormsContext), d = h.submitButtons.get(E), k = d !== void 0 && d.length > 0, {
    scriptRunState: p
  } = useContext(ScriptRunContext), M = p === ScriptRunState.NOT_RUNNING;
  useEffect(() => {
    A.setFormSubmitBehaviors(E, e, t);
  }, [A, E, e, t]);
  const [S, AA] = useState(!1);
  k && S ? AA(!1) : !k && !S && M && AA(!0);
  let H;
  return S && (H = /* @__PURE__ */ jsxRuntimeExports.jsx(StyledErrorContainer, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(AlertElement$1, { body: MISSING_SUBMIT_BUTTON_WARNING, kind: Kind.ERROR }) })), /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledForm, { className: "stForm", "data-testid": "stForm", border: c, overflow: n, children: [
    g,
    H
  ] });
}
const Form$1 = memo(Form);
function squareStepper(o, E) {
  const A = Math.sign(E - o), g = Math.sqrt(Math.abs(E - o)), e = o + g * A;
  return A > 0 ? Math.min(E, e) : Math.max(E, e);
}
function step(o, E, A, g) {
  let e = o;
  for (let t = 0; t < g; t++)
    e = A(e, E);
  return e;
}
function useScrollAnimation(o, E, A, g) {
  const e = useRef(0), t = useCallback((n, h, d = Date.now()) => {
    cancelAnimationFrame(e.current), e.current = requestAnimationFrame(() => {
      if (o) {
        const k = o.scrollHeight - o.offsetHeight;
        let p = step(n, k, squareStepper, (Date.now() - d) / 5);
        Math.abs(k - p) < 1.5 && (p = k), o.scrollTop = p, k === p ? E() : t(n, h + 1, d);
      }
    });
  }, [e, E, o]), c = useCallback(() => {
    cancelAnimationFrame(e.current), E();
  }, [E]);
  useLayoutEffect$1(() => {
    if (!(!o || !A || !g))
      return t(o.scrollTop, 1), o ? (o.addEventListener("pointerdown", c, {
        passive: !0
      }), o.addEventListener("wheel", c, {
        passive: !0
      }), () => {
        o.removeEventListener("pointerdown", c), o.removeEventListener("wheel", c), cancelAnimationFrame(e.current);
      }) : () => cancelAnimationFrame(e.current);
  }, [t, e, c, o, A, g]);
}
function debounce(o, E) {
  let A = 0, g = null;
  return (...e) => {
    const t = Date.now();
    t - A > E ? (o(...e), A = t) : (g && clearTimeout(g), g = setTimeout(() => {
      o(...e), A = Date.now();
    }, Math.max(0, E - t + A)));
  };
}
const DEFAULT_DEBOUNCE_MS = 100;
function useScrollSpy(o, E, A) {
  const g = useRef(E), e = useMemo$1(() => (
    // eslint-disable-next-line react-hooks/refs -- TODO: Do not access ref during render
    debounce((c) => {
      g.current(c);
    }, DEFAULT_DEBOUNCE_MS)
  ), [g]), t = useCallback(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace 'any' with a more specific type.
    (c) => {
      c.timeStampLow = Date.now(), e(c);
    },
    [e]
  );
  useLayoutEffect$1(() => !o || !A ? () => {
  } : (o.addEventListener("scroll", t, {
    passive: !0
  }), t({
    target: o
  }), () => o.removeEventListener("scroll", t)), [t, o, A]);
}
function useStateRef(o) {
  const [E, A] = useState(o), g = useRef(o);
  return g.current = E, [E, A, g];
}
const DEFAULT_BOTTOM_THRESHOLD = 1, SCROLL_DECISION_DURATION = 34, MIN_CHECK_INTERVAL = 17;
function setImmediateInterval(o, E) {
  return o(), setInterval(o, E);
}
function isAtBottom({
  scrollHeight: o,
  offsetHeight: E,
  scrollTop: A
}) {
  return o - A - E < DEFAULT_BOTTOM_THRESHOLD;
}
function useScrollToBottom(o) {
  const E = useRef(null), [A, g, e] = useStateRef(!1), [t, c, n] = useStateRef(!0);
  useEffect(() => {
    g(!0);
  }, [g]);
  const h = useRef(0), d = useRef(0), k = useRef(0), p = useCallback(() => {
    h.current = Date.now(), n.current || g(!1), c(!1);
  }, [h, n, c, g]), M = useCallback(({
    timeStampLow: S
  }) => {
    const {
      current: AA
    } = E, H = n.current;
    if (S <= h.current || !AA)
      return;
    const gA = isAtBottom(AA), {
      // eslint-disable-next-line streamlit-custom/no-force-reflow-access -- Existing usage
      offsetHeight: CA,
      // eslint-disable-next-line streamlit-custom/no-force-reflow-access -- Existing usage
      scrollHeight: IA
    } = AA, {
      current: BA
    } = d, {
      current: QA
    } = k, EA = CA !== BA, oA = IA !== QA;
    if (EA && (d.current = CA), oA && (k.current = IA), !EA && !oA) {
      const iA = H || gA;
      e.current !== iA && g(iA);
    } else e.current && (c(!0), g(!0));
  }, [h, d, k, n, e, c, g]);
  return useEffect(() => {
    if (E.current && o) {
      let S = 0;
      const AA = setImmediateInterval(() => {
        const {
          current: H
        } = E, gA = n.current;
        e.current && H ? isAtBottom(H) ? S = 0 : S ? Date.now() - S > SCROLL_DECISION_DURATION && (gA || (c(!0), g(!0)), S = 0) : S = Date.now() : H && // eslint-disable-next-line streamlit-custom/no-force-reflow-access -- Existing usage
        H.scrollHeight <= H.offsetHeight && !e.current && g(!0);
      }, MIN_CHECK_INTERVAL);
      return () => clearInterval(AA);
    }
  }, [E, A, t, n, e, g, c, o]), useEffect(() => {
    const S = E.current;
    if (S && o) {
      const AA = () => {
        k.current = S.scrollHeight;
      };
      return S.addEventListener("focus", AA, {
        capture: !0,
        passive: !0
      }), () => {
        S.removeEventListener("focus", AA, {
          capture: !0
        });
      };
    }
  }, [E, o]), useScrollSpy(E.current, M, o), useScrollAnimation(
    // eslint-disable-next-line react-hooks/refs -- TODO: Do not access ref during render
    E.current,
    p,
    t,
    o
  ), E;
}
const Maybe = memo(function o({
  children: E
}) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: E });
}, (o, E) => !(o.enable || E.enable)), ViewStateContext = createContext({
  isFullScreen: !1,
  setFullScreen: () => {
  }
});
ViewStateContext.displayName = "ViewStateContext";
const StyledDocSummary = /* @__PURE__ */ createStyled("span", process.env.NODE_ENV === "production" ? {
  target: "ejycmjn10"
} : {
  target: "ejycmjn10",
  label: "StyledDocSummary"
})(({
  theme: o
}) => ({
  "& > *": {
    marginRight: o.spacing.sm
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledDocName = /* @__PURE__ */ createStyled("span", process.env.NODE_ENV === "production" ? {
  target: "ejycmjn9"
} : {
  target: "ejycmjn9",
  label: "StyledDocName"
})(({
  theme: o
}) => ({
  fontWeight: o.fontWeights.codeBold
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2xpYi9zcmMvY29tcG9uZW50cy9lbGVtZW50cy9Eb2NTdHJpbmcvc3R5bGVkLWNvbXBvbmVudHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBd0I2QiIsImZpbGUiOiIvaG9tZS9ydW5uZXIvd29yay9zdGxpdGUvc3RsaXRlL3N0cmVhbWxpdC9mcm9udGVuZC9saWIvc3JjL2NvbXBvbmVudHMvZWxlbWVudHMvRG9jU3RyaW5nL3N0eWxlZC1jb21wb25lbnRzLnRzIiwic291cmNlc0NvbnRlbnQiOlsiLyoqXG4gKiBDb3B5cmlnaHQgKGMpIFN0cmVhbWxpdCBJbmMuICgyMDE4LTIwMjIpIFNub3dmbGFrZSBJbmMuICgyMDIyLTIwMjUpXG4gKlxuICogTGljZW5zZWQgdW5kZXIgdGhlIEFwYWNoZSBMaWNlbnNlLCBWZXJzaW9uIDIuMCAodGhlIFwiTGljZW5zZVwiKTtcbiAqIHlvdSBtYXkgbm90IHVzZSB0aGlzIGZpbGUgZXhjZXB0IGluIGNvbXBsaWFuY2Ugd2l0aCB0aGUgTGljZW5zZS5cbiAqIFlvdSBtYXkgb2J0YWluIGEgY29weSBvZiB0aGUgTGljZW5zZSBhdFxuICpcbiAqICAgICBodHRwOi8vd3d3LmFwYWNoZS5vcmcvbGljZW5zZXMvTElDRU5TRS0yLjBcbiAqXG4gKiBVbmxlc3MgcmVxdWlyZWQgYnkgYXBwbGljYWJsZSBsYXcgb3IgYWdyZWVkIHRvIGluIHdyaXRpbmcsIHNvZnR3YXJlXG4gKiBkaXN0cmlidXRlZCB1bmRlciB0aGUgTGljZW5zZSBpcyBkaXN0cmlidXRlZCBvbiBhbiBcIkFTIElTXCIgQkFTSVMsXG4gKiBXSVRIT1VUIFdBUlJBTlRJRVMgT1IgQ09ORElUSU9OUyBPRiBBTlkgS0lORCwgZWl0aGVyIGV4cHJlc3Mgb3IgaW1wbGllZC5cbiAqIFNlZSB0aGUgTGljZW5zZSBmb3IgdGhlIHNwZWNpZmljIGxhbmd1YWdlIGdvdmVybmluZyBwZXJtaXNzaW9ucyBhbmRcbiAqIGxpbWl0YXRpb25zIHVuZGVyIHRoZSBMaWNlbnNlLlxuICovXG5cbmltcG9ydCBzdHlsZWQgZnJvbSBcIkBlbW90aW9uL3N0eWxlZFwiXG5cbmV4cG9ydCBjb25zdCBTdHlsZWREb2NTdW1tYXJ5ID0gc3R5bGVkLnNwYW4oKHsgdGhlbWUgfSkgPT4gKHtcbiAgXCImID4gKlwiOiB7XG4gICAgbWFyZ2luUmlnaHQ6IHRoZW1lLnNwYWNpbmcuc20sXG4gIH0sXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZERvY05hbWUgPSBzdHlsZWQuc3BhbigoeyB0aGVtZSB9KSA9PiAoe1xuICBmb250V2VpZ2h0OiB0aGVtZS5mb250V2VpZ2h0cy5jb2RlQm9sZCxcbn0pKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkRG9jVHlwZSA9IHN0eWxlZC5zcGFuKCh7IHRoZW1lIH0pID0+ICh7XG4gIGNvbG9yOiB0aGVtZS5jb2xvcnMuY29kZVRleHRDb2xvcixcbn0pKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkRG9jVmFsdWUgPSBzdHlsZWQuc3BhbigpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWREb2NDb250YWluZXIgPSBzdHlsZWQuc3BhbigoeyB0aGVtZSB9KSA9PiAoe1xuICBkaXNwbGF5OiBcImZsZXhcIixcbiAgZmxleERpcmVjdGlvbjogXCJjb2x1bW5cIixcbiAgYm9yZGVyUmFkaXVzOiB0aGVtZS5yYWRpaS5kZWZhdWx0LFxuICBib3JkZXI6IGAke3RoZW1lLnNpemVzLmJvcmRlcldpZHRofSBzb2xpZCAke3RoZW1lLmNvbG9ycy5ib3JkZXJDb2xvcn1gLFxuICBmb250RmFtaWx5OiB0aGVtZS5nZW5lcmljRm9udHMuY29kZUZvbnQsXG4gIGZvbnRTaXplOiB0aGVtZS5mb250U2l6ZXMuY29kZUZvbnRTaXplLFxuICBmb250V2VpZ2h0OiB0aGVtZS5mb250V2VpZ2h0cy5jb2RlLFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWREb2NIZWFkZXIgPSBzdHlsZWQuZGl2KCh7IHRoZW1lIH0pID0+ICh7XG4gIHBhZGRpbmc6IGAke3RoZW1lLnNwYWNpbmcuc219ICR7dGhlbWUuc3BhY2luZy5sZ31gLFxuICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5iZ01peCxcbiAgYm9yZGVyQm90dG9tOiBgJHt0aGVtZS5zaXplcy5ib3JkZXJXaWR0aH0gc29saWQgJHt0aGVtZS5jb2xvcnMuYm9yZGVyQ29sb3J9YCxcbiAgLy8gQWRkIHJvdW5kZWQgY29ybmVycyB0byB0aGUgdG9wIG9mIHRoZSBjb250YWluZXIgdG8gcHJldmVudCB0aGUgYmFja2dyb3VuZFxuICAvLyBjb2xvciBmcm9tIGJsZWVkaW5nIGludG8gdGhlIHN1cnJvdW5kaW5nIGFyZWEuXG4gIGJvcmRlclRvcExlZnRSYWRpdXM6IHRoZW1lLnJhZGlpLmRlZmF1bHQsXG4gIGJvcmRlclRvcFJpZ2h0UmFkaXVzOiB0aGVtZS5yYWRpaS5kZWZhdWx0LFxuICBmb250U2l6ZTogdGhlbWUuZm9udFNpemVzLmNvZGVGb250U2l6ZSxcbiAgb3ZlcmZsb3c6IFwiYXV0b1wiLFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWREb2NTdHJpbmcgPSBzdHlsZWQuZGl2KCh7IHRoZW1lIH0pID0+ICh7XG4gIHdoaXRlU3BhY2U6IFwicHJlXCIsXG4gIG92ZXJmbG93OiBcImF1dG9cIixcbiAgbWF4SGVpZ2h0OiBcIjMwLjVyZW1cIiwgLy8gVGhlIGV4dHJhIDAuNXJlbSBpcyB0byBzaG93IGEgbGl0dGxlIG9mIHRoZSBvdmVyZmxvd2luZyBsaW5lLlxuICBwYWRkaW5nOiBgJHt0aGVtZS5zcGFjaW5nLnNtfSAke3RoZW1lLnNwYWNpbmcubGd9YCxcbiAgZm9udFNpemU6IHRoZW1lLmZvbnRTaXplcy5jb2RlRm9udFNpemUsXG5cbiAgXCImOm5vdCg6bGFzdC1jaGlsZClcIjoge1xuICAgIGJvcmRlckJvdHRvbTogYCR7dGhlbWUuc2l6ZXMuYm9yZGVyV2lkdGh9IHNvbGlkICR7dGhlbWUuY29sb3JzLmJvcmRlckNvbG9yfWAsXG4gIH0sXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZE1lbWJlcnNUYWJsZSA9IHN0eWxlZC50YWJsZSgoeyB0aGVtZSB9KSA9PiAoe1xuICB3aWR0aDogXCIxMDAlXCIsXG4gIGZvbnRTaXplOiB0aGVtZS5mb250U2l6ZXMuY29kZUZvbnRTaXplLFxuICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5iZ01peCxcbiAgdGFibGVMYXlvdXQ6IFwiZml4ZWRcIiwgLy8gRml4IHRhYmxlIHRvIGNvbnRhaW5lcidzIGJvdW5kYXJpZXMuXG4gIGJvcmRlckNvbGxhcHNlOiBcImNvbGxhcHNlXCIsXG4gIC8vIEFkZCByb3VuZGVkIGNvcm5lcnMgdG8gdGhlIGJvdHRvbSBvZiB0aGUgdGFibGUgdG8gbWF0Y2ggY29udGFpbmVyXG4gIGJvcmRlckJvdHRvbUxlZnRSYWRpdXM6IHRoZW1lLnJhZGlpLmRlZmF1bHQsXG4gIGJvcmRlckJvdHRvbVJpZ2h0UmFkaXVzOiB0aGVtZS5yYWRpaS5kZWZhdWx0LFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRNZW1iZXJzUm93ID0gc3R5bGVkLnRyKCh7IHRoZW1lIH0pID0+ICh7XG4gIFwiJjpub3QoOmxhc3QtY2hpbGQpXCI6IHtcbiAgICBib3JkZXJCb3R0b206IGAke3RoZW1lLnNpemVzLmJvcmRlcldpZHRofSBzb2xpZCAke3RoZW1lLmNvbG9ycy5ib3JkZXJDb2xvcn1gLFxuICB9LFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRNZW1iZXJzU3VtbWFyeUNlbGwgPSBzdHlsZWQudGQoKHsgdGhlbWUgfSkgPT4gKHtcbiAgd2lkdGg6IFwiMzAlXCIsXG4gIG92ZXJmbG93OiBcImF1dG9cIixcbiAgcGFkZGluZzogYCR7dGhlbWUuc3BhY2luZy5zbX0gJHt0aGVtZS5zcGFjaW5nLmxnfWAsXG5cbiAgXCImID4gKlwiOiB7XG4gICAgbWFyZ2luUmlnaHQ6IHRoZW1lLnNwYWNpbmcuc20sXG4gIH0sXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZE1lbWJlcnNEZXRhaWxzQ2VsbCA9IHN0eWxlZC50ZCgoeyB0aGVtZSB9KSA9PiAoe1xuICB3aWR0aDogXCI3MCVcIixcbiAgb3ZlcmZsb3c6IFwiYXV0b1wiLFxuICBwYWRkaW5nOiBgJHt0aGVtZS5zcGFjaW5nLnNtfSAke3RoZW1lLnNwYWNpbmcubGd9YCxcbn0pKVxuIl19 */"), StyledDocType = /* @__PURE__ */ createStyled("span", process.env.NODE_ENV === "production" ? {
  target: "ejycmjn8"
} : {
  target: "ejycmjn8",
  label: "StyledDocType"
})(({
  theme: o
}) => ({
  color: o.colors.codeTextColor
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledDocValue = /* @__PURE__ */ createStyled("span", process.env.NODE_ENV === "production" ? {
  target: "ejycmjn7"
} : {
  target: "ejycmjn7",
  label: "StyledDocValue"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledDocContainer = /* @__PURE__ */ createStyled("span", process.env.NODE_ENV === "production" ? {
  target: "ejycmjn6"
} : {
  target: "ejycmjn6",
  label: "StyledDocContainer"
})(({
  theme: o
}) => ({
  display: "flex",
  flexDirection: "column",
  borderRadius: o.radii.default,
  border: `${o.sizes.borderWidth} solid ${o.colors.borderColor}`,
  fontFamily: o.genericFonts.codeFont,
  fontSize: o.fontSizes.codeFontSize,
  fontWeight: o.fontWeights.code
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledDocHeader = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "ejycmjn5"
} : {
  target: "ejycmjn5",
  label: "StyledDocHeader"
})(({
  theme: o
}) => ({
  padding: `${o.spacing.sm} ${o.spacing.lg}`,
  backgroundColor: o.colors.bgMix,
  borderBottom: `${o.sizes.borderWidth} solid ${o.colors.borderColor}`,
  // Add rounded corners to the top of the container to prevent the background
  // color from bleeding into the surrounding area.
  borderTopLeftRadius: o.radii.default,
  borderTopRightRadius: o.radii.default,
  fontSize: o.fontSizes.codeFontSize,
  overflow: "auto"
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledDocString = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "ejycmjn4"
} : {
  target: "ejycmjn4",
  label: "StyledDocString"
})(({
  theme: o
}) => ({
  whiteSpace: "pre",
  overflow: "auto",
  maxHeight: "30.5rem",
  // The extra 0.5rem is to show a little of the overflowing line.
  padding: `${o.spacing.sm} ${o.spacing.lg}`,
  fontSize: o.fontSizes.codeFontSize,
  "&:not(:last-child)": {
    borderBottom: `${o.sizes.borderWidth} solid ${o.colors.borderColor}`
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledMembersTable = /* @__PURE__ */ createStyled("table", process.env.NODE_ENV === "production" ? {
  target: "ejycmjn3"
} : {
  target: "ejycmjn3",
  label: "StyledMembersTable"
})(({
  theme: o
}) => ({
  width: "100%",
  fontSize: o.fontSizes.codeFontSize,
  backgroundColor: o.colors.bgMix,
  tableLayout: "fixed",
  // Fix table to container's boundaries.
  borderCollapse: "collapse",
  // Add rounded corners to the bottom of the table to match container
  borderBottomLeftRadius: o.radii.default,
  borderBottomRightRadius: o.radii.default
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledMembersRow = /* @__PURE__ */ createStyled("tr", process.env.NODE_ENV === "production" ? {
  target: "ejycmjn2"
} : {
  target: "ejycmjn2",
  label: "StyledMembersRow"
})(({
  theme: o
}) => ({
  "&:not(:last-child)": {
    borderBottom: `${o.sizes.borderWidth} solid ${o.colors.borderColor}`
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledMembersSummaryCell = /* @__PURE__ */ createStyled("td", process.env.NODE_ENV === "production" ? {
  target: "ejycmjn1"
} : {
  target: "ejycmjn1",
  label: "StyledMembersSummaryCell"
})(({
  theme: o
}) => ({
  width: "30%",
  overflow: "auto",
  padding: `${o.spacing.sm} ${o.spacing.lg}`,
  "& > *": {
    marginRight: o.spacing.sm
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledMembersDetailsCell = /* @__PURE__ */ createStyled("td", process.env.NODE_ENV === "production" ? {
  target: "ejycmjn0"
} : {
  target: "ejycmjn0",
  label: "StyledMembersDetailsCell"
})(({
  theme: o
}) => ({
  width: "70%",
  overflow: "auto",
  padding: `${o.spacing.sm} ${o.spacing.lg}`
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
function DocString({
  element: o
}) {
  const {
    name: E,
    type: A,
    value: g,
    docString: e,
    members: t
  } = o;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledDocContainer, { className: "stHelp", "data-testid": "stHelp", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(StyledDocHeader, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledDocSummary, { children: [
      E ? /* @__PURE__ */ jsxRuntimeExports.jsx(StyledDocName, { "data-testid": "stHelpName", children: E }) : null,
      A ? /* @__PURE__ */ jsxRuntimeExports.jsx(StyledDocType, { "data-testid": "stHelpType", children: A }) : null,
      g ? /* @__PURE__ */ jsxRuntimeExports.jsx(StyledDocValue, { "data-testid": "stHelpValue", children: g }) : null
    ] }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(StyledDocString, { "data-testid": "stHelpDoc", children: e || "No docs available" }),
    t.length > 0 ? /* @__PURE__ */ jsxRuntimeExports.jsx(StyledMembersTable, { "data-testid": "stHelpMembersTable", children: t.map((c) => /* @__PURE__ */ jsxRuntimeExports.jsx(Member, { member: c }, c.name)) }) : null
  ] });
}
function Member({
  member: o
}) {
  const {
    name: E,
    type: A,
    value: g,
    docString: e
  } = o;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledMembersRow, { "data-testid": "stHelpMember", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledMembersSummaryCell, { children: [
      E ? /* @__PURE__ */ jsxRuntimeExports.jsx(StyledDocName, { "data-testid": "stHelpMemberDocName", children: E }) : null,
      A ? /* @__PURE__ */ jsxRuntimeExports.jsx(StyledDocType, { "data-testid": "stHelpMemberDocType", children: A }) : null
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(StyledMembersDetailsCell, { children: g ? /* @__PURE__ */ jsxRuntimeExports.jsx(StyledDocValue, { "data-testid": "stHelpMemberDocValue", children: g }) : /* @__PURE__ */ jsxRuntimeExports.jsx(StyledDocValue, { "data-testid": "stHelpMemberDocString", children: e || "No docs available" }) })
  ] });
}
const DocString$1 = memo(DocString);
function useTimeout(o, E) {
  const A = useRef(null), g = useRef(o);
  useEffect(() => {
    g.current = o;
  }, [o]);
  const e = useCallback(() => {
    A.current && (clearTimeout(A.current), A.current = null), E !== null && (A.current = setTimeout(() => {
      g.current();
    }, E));
  }, [E]);
  useEffect(() => (e(), () => {
    A.current && (clearTimeout(A.current), A.current = null);
  }), [e]);
  const t = useCallback(() => {
    A.current && (clearTimeout(A.current), A.current = null);
  }, []), c = useCallback(() => {
    e();
  }, [e]);
  return {
    clear: t,
    restart: c
  };
}
const LOG$b = loglevelExports$1.getLogger("useCopyToClipboard"), useCopyToClipboard = ({
  timeout: o = 2e3
} = {}) => {
  const [E, A] = useState(!1), {
    restart: g
  } = useTimeout(useCallback(() => {
    A(!1);
  }, []), E ? o : null), e = useCallback((c) => {
    (async () => {
      try {
        await navigator.clipboard.writeText(c), A(!0), g();
      } catch (h) {
        LOG$b.error("Failed to copy text to clipboard:", h), A(!1);
      }
    })();
  }, [g]);
  return {
    isCopied: E,
    copyToClipboard: e,
    label: E ? "Copied" : "Copy to clipboard"
  };
};
function _EMOTION_STRINGIFIED_CSS_ERROR__$b() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const StyledStackTraceRow = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e1dl0tyv7"
} : {
  target: "e1dl0tyv7",
  label: "StyledStackTraceRow"
})(({
  theme: o
}) => ({
  marginTop: o.spacing.sm,
  "&:first-of-type": {
    marginTop: 0
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledMessageType = /* @__PURE__ */ createStyled("span", process.env.NODE_ENV === "production" ? {
  target: "e1dl0tyv6"
} : {
  target: "e1dl0tyv6",
  label: "StyledMessageType"
})(({
  theme: o
}) => ({
  fontWeight: o.fontWeights.bold
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledStackTraceTitle = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e1dl0tyv5"
} : {
  target: "e1dl0tyv5",
  label: "StyledStackTraceTitle"
})(({
  theme: o
}) => ({
  marginBottom: o.spacing.sm
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledStackTraceContent = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e1dl0tyv4"
} : {
  target: "e1dl0tyv4",
  label: "StyledStackTraceContent"
})(process.env.NODE_ENV === "production" ? {
  name: "1flqko7",
  styles: "display:inline-block;min-width:100%"
} : {
  name: "1flqko7",
  styles: "display:inline-block;min-width:100%/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2xpYi9zcmMvY29tcG9uZW50cy9lbGVtZW50cy9FeGNlcHRpb25FbGVtZW50L3N0eWxlZC1jb21wb25lbnRzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQW1DdUMiLCJmaWxlIjoiL2hvbWUvcnVubmVyL3dvcmsvc3RsaXRlL3N0bGl0ZS9zdHJlYW1saXQvZnJvbnRlbmQvbGliL3NyYy9jb21wb25lbnRzL2VsZW1lbnRzL0V4Y2VwdGlvbkVsZW1lbnQvc3R5bGVkLWNvbXBvbmVudHMudHMiLCJzb3VyY2VzQ29udGVudCI6WyIvKipcbiAqIENvcHlyaWdodCAoYykgU3RyZWFtbGl0IEluYy4gKDIwMTgtMjAyMikgU25vd2ZsYWtlIEluYy4gKDIwMjItMjAyNSlcbiAqXG4gKiBMaWNlbnNlZCB1bmRlciB0aGUgQXBhY2hlIExpY2Vuc2UsIFZlcnNpb24gMi4wICh0aGUgXCJMaWNlbnNlXCIpO1xuICogeW91IG1heSBub3QgdXNlIHRoaXMgZmlsZSBleGNlcHQgaW4gY29tcGxpYW5jZSB3aXRoIHRoZSBMaWNlbnNlLlxuICogWW91IG1heSBvYnRhaW4gYSBjb3B5IG9mIHRoZSBMaWNlbnNlIGF0XG4gKlxuICogICAgIGh0dHA6Ly93d3cuYXBhY2hlLm9yZy9saWNlbnNlcy9MSUNFTlNFLTIuMFxuICpcbiAqIFVubGVzcyByZXF1aXJlZCBieSBhcHBsaWNhYmxlIGxhdyBvciBhZ3JlZWQgdG8gaW4gd3JpdGluZywgc29mdHdhcmVcbiAqIGRpc3RyaWJ1dGVkIHVuZGVyIHRoZSBMaWNlbnNlIGlzIGRpc3RyaWJ1dGVkIG9uIGFuIFwiQVMgSVNcIiBCQVNJUyxcbiAqIFdJVEhPVVQgV0FSUkFOVElFUyBPUiBDT05ESVRJT05TIE9GIEFOWSBLSU5ELCBlaXRoZXIgZXhwcmVzcyBvciBpbXBsaWVkLlxuICogU2VlIHRoZSBMaWNlbnNlIGZvciB0aGUgc3BlY2lmaWMgbGFuZ3VhZ2UgZ292ZXJuaW5nIHBlcm1pc3Npb25zIGFuZFxuICogbGltaXRhdGlvbnMgdW5kZXIgdGhlIExpY2Vuc2UuXG4gKi9cblxuaW1wb3J0IHN0eWxlZCBmcm9tIFwiQGVtb3Rpb24vc3R5bGVkXCJcblxuZXhwb3J0IGNvbnN0IFN0eWxlZFN0YWNrVHJhY2VSb3cgPSBzdHlsZWQuZGl2KCh7IHRoZW1lIH0pID0+ICh7XG4gIG1hcmdpblRvcDogdGhlbWUuc3BhY2luZy5zbSxcbiAgXCImOmZpcnN0LW9mLXR5cGVcIjoge1xuICAgIG1hcmdpblRvcDogMCxcbiAgfSxcbn0pKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkTWVzc2FnZVR5cGUgPSBzdHlsZWQuc3BhbigoeyB0aGVtZSB9KSA9PiAoe1xuICBmb250V2VpZ2h0OiB0aGVtZS5mb250V2VpZ2h0cy5ib2xkLFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRTdGFja1RyYWNlVGl0bGUgPSBzdHlsZWQuZGl2KCh7IHRoZW1lIH0pID0+ICh7XG4gIG1hcmdpbkJvdHRvbTogdGhlbWUuc3BhY2luZy5zbSxcbn0pKVxuXG4vLyBUaGlzIGV4dHJhIGRpdiBtYWtlcyBzdXJlIHRoYXQgd2UgYWxzbyBoYXZlIGEgcGFkZGluZyBvbiB0aGUgcmlnaHQgc2lkZSBvZiB0aGUgc3RhY2tcbi8vIHRyYWNlIHdoZW4gc2Nyb2xsZWQgdG8gdGhlIHJpZ2h0LlxuZXhwb3J0IGNvbnN0IFN0eWxlZFN0YWNrVHJhY2VDb250ZW50ID0gc3R5bGVkLmRpdih7XG4gIGRpc3BsYXk6IFwiaW5saW5lLWJsb2NrXCIsXG4gIG1pbldpZHRoOiBcIjEwMCVcIixcbn0pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRFeGNlcHRpb25NZXNzYWdlID0gc3R5bGVkLmRpdih7XG4gIHdvcmRXcmFwOiBcImJyZWFrLXdvcmRcIixcbn0pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRFeGNlcHRpb25MaW5rcyA9IHN0eWxlZC5kaXYoKHsgdGhlbWUgfSkgPT4gKHtcbiAgZm9udFNpemU6IHRoZW1lLmZvbnRTaXplcy5zbSxcbiAgZGlzcGxheTogXCJmbGV4XCIsXG4gIGdhcDogdGhlbWUuc3BhY2luZy5tZCxcbiAganVzdGlmeUNvbnRlbnQ6IFwiZmxleC1lbmRcIixcbiAgdW5kZXJsaW5lOiB0cnVlLFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRFeGNlcHRpb25Db3B5QnV0dG9uID0gc3R5bGVkLmJ1dHRvbih7XG4gIGFsbDogXCJ1bnNldFwiLFxuICBmb250OiBcImluaGVyaXRcIixcbiAgdGV4dERlY29yYXRpb246IFwidW5kZXJsaW5lXCIsXG59KVxuXG5leHBvcnQgY29uc3QgU3R5bGVkRXhjZXB0aW9uV3JhcHBlciA9IHN0eWxlZC5kaXYoKHsgdGhlbWUgfSkgPT4gKHtcbiAgZGlzcGxheTogXCJmbGV4XCIsXG4gIGZsZXhEaXJlY3Rpb246IFwiY29sdW1uXCIsXG4gIGdhcDogdGhlbWUuc3BhY2luZy5sZyxcbn0pKVxuIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$b
}), StyledExceptionMessage = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e1dl0tyv3"
} : {
  target: "e1dl0tyv3",
  label: "StyledExceptionMessage"
})(process.env.NODE_ENV === "production" ? {
  name: "10s3lzp",
  styles: "word-wrap:break-word"
} : {
  name: "10s3lzp",
  styles: "word-wrap:break-word/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$b
}), StyledExceptionLinks = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e1dl0tyv2"
} : {
  target: "e1dl0tyv2",
  label: "StyledExceptionLinks"
})(({
  theme: o
}) => ({
  fontSize: o.fontSizes.sm,
  display: "flex",
  gap: o.spacing.md,
  justifyContent: "flex-end",
  underline: !0
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledExceptionCopyButton = /* @__PURE__ */ createStyled("button", process.env.NODE_ENV === "production" ? {
  target: "e1dl0tyv1"
} : {
  target: "e1dl0tyv1",
  label: "StyledExceptionCopyButton"
})(process.env.NODE_ENV === "production" ? {
  name: "x9hjea",
  styles: "all:unset;font:inherit;text-decoration:underline"
} : {
  name: "x9hjea",
  styles: "all:unset;font:inherit;text-decoration:underline/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$b
}), StyledExceptionWrapper = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e1dl0tyv0"
} : {
  target: "e1dl0tyv0",
  label: "StyledExceptionWrapper"
})(({
  theme: o
}) => ({
  display: "flex",
  flexDirection: "column",
  gap: o.spacing.lg
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
loglevelExports$1.getLogger("ExceptionElement");
function isNonEmptyString(o) {
  return notNullOrUndefined(o) && o !== "";
}
function ExceptionMessage({
  type: o,
  message: E,
  messageIsMarkdown: A
}) {
  if (A) {
    let g = E ?? "";
    return o.length !== 0 && (g = `**${o}**: ${g}`), /* @__PURE__ */ jsxRuntimeExports.jsx(StreamlitMarkdown$1, { source: g, allowHTML: !1 });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(StyledMessageType, { children: o }),
    o.length !== 0 && ": ",
    isNonEmptyString(E) ? E : null
  ] });
}
function StackTrace({
  stackTrace: o
}) {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(StyledStackTraceTitle, { children: "Traceback:" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(StyledStackTrace, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledStackTraceContent, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledCode, { wrapLines: !1, children: o.map((E, A) => /* @__PURE__ */ jsxRuntimeExports.jsx(
      StyledStackTraceRow,
      {
        "data-testid": "stExceptionTraceRow",
        children: E
      },
      A
    )) }) }) })
  ] });
}
function ExceptionElement({
  element: o
}) {
  const E = `${o.type}: ${o.message}`, A = `${E}

${o.stackTrace?.join(`
`)}`, g = `https://www.google.com/search?q=${encodeURIComponent(E)}`, e = `https://chatgpt.com/?q=${encodeURIComponent(A)}`, {
    copyToClipboard: t
  } = useCopyToClipboard(), c = useCallback(() => {
    t(A);
  }, [t, A]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "stException", "data-testid": "stException", children: /* @__PURE__ */ jsxRuntimeExports.jsx(AlertContainer, { kind: o.isWarning ? Kind.WARNING : Kind.ERROR, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledExceptionWrapper, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(StyledExceptionMessage, { "data-testid": "stExceptionMessage", children: /* @__PURE__ */ jsxRuntimeExports.jsx(ExceptionMessage, { type: o.type, message: o.message, messageIsMarkdown: o.messageIsMarkdown }) }),
    o.stackTrace && o.stackTrace.length > 0 ? /* @__PURE__ */ jsxRuntimeExports.jsx(StackTrace, { stackTrace: o.stackTrace }) : null,
    isLocalhost() && /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledExceptionLinks, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(StyledExceptionCopyButton, { onClick: c, children: "Copy" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("a", { href: g, target: "_blank", rel: "noopener noreferrer", children: "Ask Google" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("a", { href: e, target: "_blank", rel: "noopener noreferrer", children: "Ask ChatGPT" })
    ] })
  ] }) }) });
}
const ExceptionElement$1 = memo(ExceptionElement), SINGLE_BADGE_REGEX = /^:\w+-badge\[((?:\\.|[^\]\\])*)\]$/;
function Markdown({
  element: o
}) {
  const {
    allowHtml: E,
    body: A,
    elementType: g,
    help: e,
    isCaption: t
  } = o, c = g === Markdown$3.Type.LATEX, n = g === Markdown$3.Type.NATIVE && SINGLE_BADGE_REGEX.test(A.trim());
  let h;
  if (e && n)
    h = /* @__PURE__ */ jsxRuntimeExports.jsx(BaseButtonTooltip, { help: e, containerWidth: !1, children: /* @__PURE__ */ jsxRuntimeExports.jsx(StreamlitMarkdown$1, { isCaption: t, source: A, allowHTML: E }) });
  else if (e && c)
    h = /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledLabelHelpWrapper, { isLatex: c, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(StreamlitMarkdown$1, { isCaption: t, source: A, allowHTML: E }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(InlineTooltipIcon, { content: e, isLatex: c })
    ] });
  else {
    const d = e ? `${A} :help[]` : A;
    h = /* @__PURE__ */ jsxRuntimeExports.jsx(StyledLabelHelpWrapper, { isLatex: c, children: /* @__PURE__ */ jsxRuntimeExports.jsx(StreamlitMarkdown$1, { isCaption: t, source: d, allowHTML: E, helpText: e }) });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "stMarkdown", "data-testid": "stMarkdown", children: h });
}
const Markdown$1 = memo(Markdown), StyledText = /* @__PURE__ */ createStyled("span", process.env.NODE_ENV === "production" ? {
  target: "exotz4b1"
} : {
  target: "exotz4b1",
  label: "StyledText"
})(({
  theme: o
}) => ({
  fontFamily: o.genericFonts.bodyFont,
  color: o.colors.bodyText,
  whiteSpace: "pre-line",
  whiteSpaceCollapse: "preserve",
  wordBreak: "break-word",
  display: "inline-block",
  verticalAlign: "middle",
  width: "100%"
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledInlineHelpIcon = /* @__PURE__ */ createStyled("span", process.env.NODE_ENV === "production" ? {
  target: "exotz4b0"
} : {
  target: "exotz4b0",
  label: "StyledInlineHelpIcon"
})(({
  theme: o
}) => ({
  display: "inline-block",
  verticalAlign: "middle",
  marginLeft: o.spacing.twoXS,
  // Fine-tune vertical positioning for perfect visual centering
  transform: "translateY(-0.05em)"
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
function TextElement({
  element: o
}) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledLabelHelpWrapper, { className: "stText", "data-testid": "stText", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledText, { children: [
    o.body,
    o.help && /* @__PURE__ */ jsxRuntimeExports.jsx(StyledInlineHelpIcon, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(InlineTooltipIcon, { content: o.help }) })
  ] }) });
}
const TextElement$1 = memo(TextElement), katex_min = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null
}, Symbol.toStringTag, { value: "Module" }));
function makeMarkdownHeading(o, E) {
  switch (o.toLowerCase()) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-enum-comparison -- TODO: Fix this
    case Tags.H1:
      return `# ${E}`;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-enum-comparison -- TODO: Fix this
    case Tags.H2:
      return `## ${E}`;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-enum-comparison -- TODO: Fix this
    case Tags.H3:
      return `### ${E}`;
    default:
      throw new Error(`Unrecognized tag for header: ${o}`);
  }
}
const OVERRIDE_COMPONENTS = {
  p: Fragment,
  h1: Fragment,
  h2: Fragment,
  h3: Fragment,
  h4: Fragment,
  h5: Fragment,
  h6: Fragment
};
function Heading(o) {
  const {
    element: E
  } = o, {
    tag: A,
    anchor: g,
    body: e,
    help: t,
    hideAnchor: c,
    divider: n
  } = E, h = useContext(IsDialogContext), [d, ...k] = e.split(`
`);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "stHeading", "data-testid": "stHeading", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledStreamlitMarkdown, { isCaption: !1, isInDialog: h, "data-testid": "stMarkdownContainer", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(HeadingWithActionElements, { anchor: g, help: t, hideAnchor: c, tag: A, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        RenderedMarkdown,
        {
          allowHTML: !1,
          source: makeMarkdownHeading(A, d),
          overrideComponents: OVERRIDE_COMPONENTS
        }
      ) }),
      k.length > 0 && /* @__PURE__ */ jsxRuntimeExports.jsx(RenderedMarkdown, { source: k.join(`
`), allowHTML: !1 })
    ] }),
    n && /* @__PURE__ */ jsxRuntimeExports.jsx(StyledHeaderDivider, { "data-testid": "stHeadingDivider", rainbow: n.includes("linear"), color: n })
  ] });
}
const StyledCheckbox$1 = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "edwcd611"
} : {
  target: "edwcd611",
  label: "StyledCheckbox"
})(({
  theme: o
}) => ({
  display: "flex",
  alignItems: "center",
  minHeight: o.sizes.smallElementHeight
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledContent = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "edwcd610"
} : {
  target: "edwcd610",
  label: "StyledContent"
})(({
  visibility: o
}) => ({
  display: o === LabelVisibilityOptions.Collapsed ? "none" : "flex",
  visibility: o === LabelVisibilityOptions.Hidden ? "hidden" : "visible",
  verticalAlign: "middle",
  flexDirection: "row",
  alignItems: "center"
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
function _EMOTION_STRINGIFIED_CSS_ERROR__$a() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
function translateGapWidth(o, E) {
  let A = E.spacing.lg;
  return o === streamlit.GapSize.MEDIUM ? A = E.spacing.threeXL : o === streamlit.GapSize.LARGE ? A = E.spacing.fourXL : o === streamlit.GapSize.NONE && (A = E.spacing.none), A;
}
const StyledSpace = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e1f1d6gn4"
} : {
  target: "e1f1d6gn4",
  label: "StyledSpace"
})(process.env.NODE_ENV === "production" ? {
  name: "w1atjl",
  styles: "width:100%;height:100%"
} : {
  name: "w1atjl",
  styles: "width:100%;height:100%/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$a
}), GLOBAL_ELEMENTS = ["balloons", "snow"], StyledElementContainer = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e1f1d6gn3"
} : {
  target: "e1f1d6gn3",
  label: "StyledElementContainer"
})(({
  theme: o,
  isStale: E,
  width: A,
  height: g,
  elementType: e,
  overflow: t,
  flex: c,
  minWidth: n,
  textAlign: h
}) => ({
  width: A,
  height: g,
  textAlign: h,
  maxWidth: "100%",
  // Important so that individual elements don't take up too much space
  // in horizontal layouts. Particularly when an element uses the full screen wrapper.
  // Some components support zero width (e.g. iframe).
  minWidth: A === "0px" ? 0 : n ?? "1rem",
  // Allows to have absolutely-positioned nodes inside app elements, like
  // floating buttons.
  position: "relative",
  overflow: t,
  flex: c,
  "@media print": {
    overflow: "visible"
  },
  ":has(> .stCacheSpinner)": {
    height: o.spacing.none,
    overflow: "visible",
    visibility: "visible",
    marginBottom: `-${o.spacing.lg}`,
    zIndex: o.zIndices.cacheSpinner
  },
  ":has(> .stPageLink)": {
    marginTop: `-${o.spacing.xs}`,
    marginBottom: `-${o.spacing.xs}`
  },
  ...E && e !== "skeleton" && STALE_STYLES,
  ...e === "empty" ? {
    // Use display: none for empty elements to avoid the flexbox gap.
    display: "none"
  } : {},
  ...e === "space" ? {
    // Space elements should have minimal cross-axis dimensions.
    // The FlexContext logic in StyledElementContainerLayoutWrapper handles
    // the primary dimension (width for horizontal, height for vertical).
    minWidth: 0,
    minHeight: 0
  } : {},
  ...GLOBAL_ELEMENTS.includes(e) ? {
    // Global elements are rendered in their delta position, but they
    // are not part of the flexbox layout. We apply a negative margin
    // to remove the flexbox gap. display: none does not work for these,
    // since they needs to be visible.
    marginBottom: `-${o.spacing.lg}`
  } : {}
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledColumn = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e1f1d6gn2"
} : {
  target: "e1f1d6gn2",
  label: "StyledColumn"
})(({
  theme: o,
  weight: E,
  gap: A,
  showBorder: g,
  verticalAlignment: e
}) => {
  const {
    VerticalAlignment: t
  } = Block$1.Column, c = E * 100, n = translateGapWidth(A, o), h = n === o.spacing.none ? `${c}%` : `calc(${c}% - ${n})`;
  return {
    // Calculate width based on percentage, but fill all available space,
    // e.g. if it overflows to next row.
    width: h,
    flex: `1 1 ${h}`,
    [`@media (max-width: ${o.breakpoints.columns})`]: {
      minWidth: `calc(100% - ${o.spacing.twoXL})`
    },
    ...e === t.BOTTOM && {
      marginTop: "auto",
      // Add margin to the first checkbox/toggle within the column to align it
      // better with other input widgets.
      [`& ${StyledElementContainer}:last-of-type > ${StyledCheckbox$1}`]: {
        marginBottom: o.spacing.sm
      }
    },
    ...e === t.TOP && {
      // Add margin to the first checkbox/toggle within the column to align it
      // better with other input widgets.
      [`& ${StyledElementContainer}:first-of-type > ${StyledCheckbox$1}`]: {
        marginTop: o.spacing.sm
      }
    },
    ...e === t.CENTER && {
      marginTop: "auto",
      marginBottom: "auto"
    },
    ...g && {
      border: `${o.sizes.borderWidth} solid ${o.colors.borderColor}`,
      borderRadius: o.radii.default,
      padding: `calc(${o.spacing.lg} - ${o.sizes.borderWidth})`
    }
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), getAlignItems = (o) => {
  switch (o) {
    case Block$1.FlexContainer.Align.ALIGN_START:
      return "start";
    case Block$1.FlexContainer.Align.ALIGN_CENTER:
      return "center";
    case Block$1.FlexContainer.Align.ALIGN_END:
      return "end";
    case Block$1.FlexContainer.Align.STRETCH:
      return "stretch";
    case Block$1.FlexContainer.Align.ALIGN_UNDEFINED:
    case void 0:
    case null:
      return "stretch";
    default:
      assertNever(o);
  }
}, getJustifyContent = (o) => {
  switch (o) {
    case Block$1.FlexContainer.Justify.JUSTIFY_START:
      return "start";
    case Block$1.FlexContainer.Justify.JUSTIFY_CENTER:
      return "center";
    case Block$1.FlexContainer.Justify.JUSTIFY_END:
      return "end";
    case Block$1.FlexContainer.Justify.SPACE_BETWEEN:
      return "space-between";
    case Block$1.FlexContainer.Justify.JUSTIFY_UNDEFINED:
    case void 0:
    case null:
      return "start";
    default:
      assertNever(o);
  }
}, StyledFlexContainerBlock = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e1f1d6gn1"
} : {
  target: "e1f1d6gn1",
  label: "StyledFlexContainerBlock"
})(({
  theme: o,
  direction: E,
  gap: A,
  flex: g,
  $wrap: e,
  height: t,
  border: c,
  align: n,
  justify: h,
  overflow: d
}) => {
  let k;
  return A !== void 0 && (k = translateGapWidth(A, o)), {
    display: "flex",
    gap: k,
    width: "100%",
    maxWidth: "100%",
    height: t ?? "auto",
    minWidth: "1rem",
    flexDirection: E,
    flex: g,
    alignItems: getAlignItems(n),
    justifyContent: getJustifyContent(h),
    flexWrap: e ? "wrap" : "nowrap",
    ...c && {
      border: `${o.sizes.borderWidth} solid ${o.colors.borderColor}`,
      borderRadius: o.radii.default,
      padding: `calc(${o.spacing.lg} - ${o.sizes.borderWidth})`
    },
    overflow: d
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledLayoutWrapper = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e1f1d6gn0"
} : {
  target: "e1f1d6gn0",
  label: "StyledLayoutWrapper"
})(({
  width: o,
  height: E,
  flex: A
}) => ({
  display: "flex",
  // This shouldn't matter since this is a wrapper and should only have one child.
  // However, adding it here to be explicit.
  flexDirection: "column",
  width: o,
  maxWidth: "100%",
  minWidth: "1rem",
  height: E,
  flex: A
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), LARGE_STRETCH_BEHAVIOR$1 = [
  "graphvizChart",
  "arrowVegaLiteChart",
  "deckGlJsonChart",
  "plotlyChart",
  "docString",
  "arrowDataFrame",
  "json",
  "audioInput",
  "fileUploader",
  "cameraInput",
  "audio",
  "video",
  "code",
  // also includes st.echo
  "buttonGroup",
  "iframe"
], MEDIUM_STRETCH_BEHAVIOR$1 = [
  "dateInput",
  "radio",
  "slider",
  // also includes st.select_slider
  "textArea",
  "progress",
  "multiselect",
  "selectbox",
  "timeInput",
  "numberInput",
  "textInput"
], WIDTH_STRETCH_OVERRIDE = [
  // Because of how width is handled for custom components, we need the
  // element wrapper to be full width.
  "componentInstance",
  // Without this style, the skeleton width relies on the flex container that
  // wraps the page contents having align-items: stretch. There was a regression
  // where this default was changed. It is more robust to ensure that the skeleton
  // has this width.
  "skeleton"
], VISIBLE_OVERFLOW_OVERRIDE = [
  // TODO(lwilby): Some elements need overflow to be visible in webkit. Will investigate
  // if we can remove this custom handling in future layouts work.
  "iframe",
  "arrowDataFrame",
  "deckGlJsonChart",
  "arrowVegaLiteChart",
  "graphvizChart"
], StyledElementContainerLayoutWrapper = ({
  node: o,
  ...E
}) => {
  const {
    isInHorizontalLayout: A,
    isInRoot: g
  } = useRequiredContext(FlexContext);
  let e;
  LARGE_STRETCH_BEHAVIOR$1.includes(o.element.type ?? "") ? e = "14rem" : MEDIUM_STRETCH_BEHAVIOR$1.includes(o.element.type ?? "") && (e = "8rem"), o.element.type === "buttonGroup" && o.element.buttonGroup?.style === ButtonGroup$1.Style.BORDERLESS && (e = "fit-content");
  const t = useMemo$1(() => {
    const n = {};
    if (WIDTH_STRETCH_OVERRIDE.includes(o.element.type ?? "") && (n.width = "100%"), VISIBLE_OVERFLOW_OVERRIDE.includes(o.element.type ?? "") && (n.overflow = "visible"), o.element.type === "textArea")
      return o.element.heightConfig?.useStretch ? {
        height: "100%",
        flex: "1 1 8rem"
      } : A ? {
        height: "auto"
      } : {
        height: "auto",
        // Content height text area in vertical layout cannot have flex.
        flex: ""
      };
    if (o.element.type === "arrowVegaLiteChart")
      return o.element.widthConfig?.useContent && g && (n.width = "100%"), A && !o.element.widthConfig && (n.flex = "1 1 14rem"), n;
    if (o.element.type === "arrowDataFrame")
      return o.element.widthConfig?.useContent && g && (n.width = "100%"), n;
    if (o.element.type === "imgs") {
      const h = !o.element.widthConfig || o.element.widthConfig.useStretch;
      n.width = h ? "100%" : "auto";
    }
    return n;
  }, [o.element.type, o.element.heightConfig?.useStretch, A, g, o.element.widthConfig]);
  let c = useLayoutStyles({
    element: o.element,
    subElement: o.element?.type && o.element[o.element.type] || void 0,
    styleOverrides: t,
    minStretchBehavior: e
  });
  return o.element.type === "space" && (A ? c = {
    ...c,
    height: "auto"
  } : c = {
    ...c,
    width: "auto"
  }), /* @__PURE__ */ jsxRuntimeExports.jsx(StyledElementContainer, { ...E, ...c });
}, ArrowTable = lazy(() => import("./index-DwedDN1c.js")), ArrowVegaLiteChart = lazy(() => import("./index-47jAZmzN.js")), Audio = lazy(() => import("./index-C6MBr137.js")), Balloons = lazy(() => import("./index-BrYfiXJ9.js")), DeckGlJsonChart = lazy(() => import("./index-Cp-N8m1m.js")), GraphVizChart = lazy(() => import("./index-NPM6VaN3.js")), Html = lazy(() => import("./index-CAtZcI5-.js")), IFrame = lazy(() => import("./index-CF9SDiIL.js")), ImageList = lazy(() => import("./index-Cbq5ClnA.js")), Json = lazy(() => import("./index-YOustUZZ.js")), LinkButton = lazy(() => import("./index-DNE2UpRK.js")), Metric = lazy(() => import("./index-D_5mY4iN.js")), PageLink = lazy(() => import("./index-lGTf3abu.js")), PlotlyChart = lazy(() => import("./index-D3vT_IC-.js")), Progress = lazy(() => import("./index-DttfDE80.js")), Snow = lazy(() => import("./index-BHN72E4J.js")), Spinner = lazy(() => import("./index-DfPnrVLL.js")), StreamlitSyntaxHighlighter = lazy(() => import("./StreamlitSyntaxHighlighter-DSYWFRjz.js")), Toast = lazy(() => import("./index-BYGDMULw.js")), Video = lazy(() => import("./index-CY18be0x.js")), AudioInput = lazy(() => import("./index-G4vqu33f.js")), ArrowDataFrame = lazy(() => import("./index-nXfHwIms.js")), Button = lazy(() => import("./index-Do4wh7Iw.js")), ButtonGroup = lazy(() => import("./index-h-ZgFEXT.js")), ComponentInstance = lazy(() => import("./index-D5L-gN8f.js").then((o) => ({
  default: o.ComponentInstance
}))), CameraInput = lazy(() => import("./index-b6W2ubHd.js")), ChatInput = lazy(() => import("./index-CFA5JkEa.js")), Checkbox = lazy(() => import("./index-BGCCnxH2.js")), ColorPicker = lazy(() => import("./index-BSOGSXpv.js")), DateInput = lazy(() => import("./index-D7zRUNKG.js")), DateTimeInput = lazy(() => import("./index-Fvxtopfe.js")), DownloadButton = lazy(() => import("./index-Q4xI4OhR.js")), FileUploader = lazy(() => import("./index-BVuioNdm.js")), FormSubmitContent = lazy(() => import("./index-CxZCITs0.js").then((o) => ({
  default: o.FormSubmitContent
}))), Multiselect = lazy(() => import("./index-tU7dWFCN.js")), NumberInput = lazy(() => import("./index-CucLKMvI.js")), Radio = lazy(() => import("./index-10RiWKwV.js")), Selectbox$1 = lazy(() => import("./index-BVhYQGzc.js")), Slider = lazy(() => import("./index-KWOwopwF.js")), TextArea = lazy(() => import("./index-CceTm1nk.js")), TextInput = lazy(() => import("./index-D8RPh1xj.js")), TimeInput = lazy(() => import("./index-Bck9VlwE.js")), BidiComponent = lazy(() => import("./index-CaWaI2PT.js"));
function hideIfStale(o, E) {
  return o ? /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {}) : E;
}
const RawElementNodeRenderer = (o) => {
  const {
    node: E
  } = o;
  if (!E)
    throw new Error("ElementNode not found.");
  const A = {
    disableFullscreenMode: o.disableFullscreenMode,
    widthConfig: E.element.widthConfig,
    heightConfig: E.element.heightConfig
  }, g = {
    ...A,
    widgetMgr: o.widgetMgr,
    disabled: o.widgetsDisabled,
    fragmentId: E.fragmentId,
    componentRegistry: o.componentRegistry
  };
  switch (E.element.type) {
    case "alert": {
      const e = E.element.alert;
      return /* @__PURE__ */ jsxRuntimeExports.jsx(AlertElement$1, { icon: e.icon, body: e.body, kind: getAlertElementKind(e.format), ...A });
    }
    case "arrowTable": {
      const e = E.element.arrowTable;
      return /* @__PURE__ */ jsxRuntimeExports.jsx(ArrowTable, { element: e, data: E.quiverElement, ...A });
    }
    case "audio":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(Audio, { element: E.element.audio, endpoints: o.endpoints, ...A, elementMgr: o.widgetMgr });
    case "balloons":
      return hideIfStale(o.isStale, /* @__PURE__ */ jsxRuntimeExports.jsx(Balloons, { scriptRunId: E.scriptRunId }));
    case "code": {
      const e = E.element.code;
      return /* @__PURE__ */ jsxRuntimeExports.jsx(StreamlitSyntaxHighlighter, { language: e.language, showLineNumbers: e.showLineNumbers, wrapLines: e.wrapLines, children: e.codeText });
    }
    case "deckGlJsonChart":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(DeckGlJsonChart, { element: E.element.deckGlJsonChart, ...g });
    case "docString":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(DocString$1, { element: E.element.docString, ...A });
    case "empty":
      return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "stEmpty", "data-testid": "stEmpty" });
    case "exception":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(ExceptionElement$1, { element: E.element.exception, ...A });
    case "graphvizChart":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(GraphVizChart, { element: E.element.graphvizChart, ...A });
    case "heading":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(Heading, { element: E.element.heading, ...A });
    case "iframe":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(IFrame, { element: E.element.iframe, ...A });
    case "imgs":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(ImageList, { element: E.element.imgs, endpoints: o.endpoints, ...A });
    case "json":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(Json, { element: E.element.json, ...A });
    case "markdown":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(Markdown$1, { element: E.element.markdown, ...A });
    case "metric":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(Metric, { element: E.element.metric, ...A });
    case "html":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(Html, { element: E.element.html, ...A });
    case "pageLink": {
      const e = E.element.pageLink, t = g.disabled || e.disabled;
      return /* @__PURE__ */ jsxRuntimeExports.jsx(PageLink, { element: e, disabled: t, ...A });
    }
    case "progress":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(Progress, { element: E.element.progress, ...A });
    case "skeleton":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(Skeleton, { element: E.element.skeleton });
    case "snow":
      return hideIfStale(o.isStale, /* @__PURE__ */ jsxRuntimeExports.jsx(Snow, { scriptRunId: E.scriptRunId }));
    case "space":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledSpace, { className: "stSpace", "data-testid": "stSpace" });
    case "spinner":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(Spinner, { element: E.element.spinner, ...A });
    case "text":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(TextElement$1, { element: E.element.text, ...A });
    case "video":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(Video, { element: E.element.video, endpoints: o.endpoints, ...A, elementMgr: o.widgetMgr });
    // Events:
    case "toast": {
      const e = E.element.toast;
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        Toast,
        {
          element: e,
          ...A
        },
        E.scriptRunId
      );
    }
    // Widgets:
    case "arrowDataFrame": {
      const e = E.element.arrowDataFrame;
      return g.disabled = g.disabled || e.disabled, /* @__PURE__ */ jsxRuntimeExports.jsx(
        ArrowDataFrame,
        {
          element: e,
          data: E.quiverElement,
          ...g
        },
        e.id || void 0
      );
    }
    case "arrowVegaLiteChart": {
      const e = E.vegaLiteChartElement;
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        ArrowVegaLiteChart,
        {
          element: e,
          ...g
        },
        e.id || void 0
      );
    }
    case "audioInput": {
      const e = E.element.audioInput;
      return g.disabled = g.disabled || e.disabled, /* @__PURE__ */ jsxRuntimeExports.jsx(AudioInput, { uploadClient: o.uploadClient, element: e, ...g }, e.id);
    }
    case "button": {
      const e = E.element.button;
      return g.disabled = g.disabled || e.disabled, e.isFormSubmitter ? /* @__PURE__ */ jsxRuntimeExports.jsx(FormSubmitContent, { element: e, ...g }) : /* @__PURE__ */ jsxRuntimeExports.jsx(Button, { element: e, ...g });
    }
    case "buttonGroup": {
      const e = E.element.buttonGroup;
      return g.disabled = g.disabled || e.disabled, /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonGroup, { element: e, ...g }, e.id);
    }
    case "downloadButton": {
      const e = E.element.downloadButton;
      return g.disabled = g.disabled || e.disabled, /* @__PURE__ */ jsxRuntimeExports.jsx(DownloadButton, { endpoints: o.endpoints, element: e, ...g }, e.id);
    }
    case "cameraInput": {
      const e = E.element.cameraInput;
      return g.disabled = g.disabled || e.disabled, /* @__PURE__ */ jsxRuntimeExports.jsx(CameraInput, { element: e, uploadClient: o.uploadClient, ...g }, e.id);
    }
    case "chatInput": {
      const e = E.element.chatInput;
      return g.disabled = g.disabled || e.disabled, /* @__PURE__ */ jsxRuntimeExports.jsx(ChatInput, { element: e, uploadClient: o.uploadClient, ...g }, e.id);
    }
    case "checkbox": {
      const e = E.element.checkbox;
      return g.disabled = g.disabled || e.disabled, /* @__PURE__ */ jsxRuntimeExports.jsx(Checkbox, { element: e, ...g }, e.id);
    }
    case "colorPicker": {
      const e = E.element.colorPicker;
      return g.disabled = g.disabled || e.disabled, /* @__PURE__ */ jsxRuntimeExports.jsx(ColorPicker, { element: e, ...g }, e.id);
    }
    case "componentInstance":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(ComponentInstance, { element: E.element.componentInstance, ...g });
    case "dateInput": {
      const e = E.element.dateInput;
      return g.disabled = g.disabled || e.disabled, /* @__PURE__ */ jsxRuntimeExports.jsx(DateInput, { element: e, ...g }, e.id);
    }
    case "fileUploader": {
      const e = E.element.fileUploader;
      return g.disabled = g.disabled || e.disabled, /* @__PURE__ */ jsxRuntimeExports.jsx(FileUploader, { element: e, uploadClient: o.uploadClient, ...g }, e.id);
    }
    case "linkButton": {
      const e = E.element.linkButton;
      return /* @__PURE__ */ jsxRuntimeExports.jsx(LinkButton, { element: e, ...A });
    }
    case "multiselect": {
      const e = E.element.multiselect;
      return g.disabled = g.disabled || e.disabled, /* @__PURE__ */ jsxRuntimeExports.jsx(Multiselect, { element: e, ...g }, e.id);
    }
    case "numberInput": {
      const e = E.element.numberInput;
      return g.disabled = g.disabled || e.disabled, /* @__PURE__ */ jsxRuntimeExports.jsx(NumberInput, { element: e, ...g }, e.id);
    }
    case "plotlyChart": {
      const e = E.element.plotlyChart;
      return /* @__PURE__ */ jsxRuntimeExports.jsx(PlotlyChart, { element: e, ...g }, e.id);
    }
    case "radio": {
      const e = E.element.radio;
      return g.disabled = g.disabled || e.disabled, /* @__PURE__ */ jsxRuntimeExports.jsx(Radio, { element: e, ...g }, e.id);
    }
    case "selectbox": {
      const e = E.element.selectbox;
      return g.disabled = g.disabled || e.disabled, /* @__PURE__ */ jsxRuntimeExports.jsx(Selectbox$1, { element: e, ...g }, e.id);
    }
    case "slider": {
      const e = E.element.slider;
      return g.disabled = g.disabled || e.disabled, /* @__PURE__ */ jsxRuntimeExports.jsx(Slider, { element: e, ...g }, e.id);
    }
    case "textArea": {
      const e = E.element.textArea;
      return g.disabled = g.disabled || e.disabled, /* @__PURE__ */ jsxRuntimeExports.jsx(TextArea, { element: e, outerElement: E.element, ...g }, e.id);
    }
    case "textInput": {
      const e = E.element.textInput;
      return g.disabled = g.disabled || e.disabled, /* @__PURE__ */ jsxRuntimeExports.jsx(TextInput, { element: e, ...g }, e.id);
    }
    case "dateTimeInput": {
      const e = E.element.dateTimeInput;
      return g.disabled = g.disabled || e.disabled, /* @__PURE__ */ jsxRuntimeExports.jsx(DateTimeInput, { element: e, ...g }, e.id);
    }
    case "timeInput": {
      const e = E.element.timeInput;
      return g.disabled = g.disabled || e.disabled, /* @__PURE__ */ jsxRuntimeExports.jsx(TimeInput, { element: e, ...g }, e.id);
    }
    case "bidiComponent": {
      const e = E.element.bidiComponent;
      return /* @__PURE__ */ jsxRuntimeExports.jsx(BidiComponent, { element: e, ...g }, e.id);
    }
    default:
      throw new Error(`Unrecognized Element type ${E.element.type}`);
  }
}, ElementNodeRenderer = (o) => {
  const {
    isFullScreen: E
  } = useContext(ViewStateContext), {
    scriptRunState: A,
    scriptRunId: g,
    fragmentIdsThisRun: e
  } = useContext(ScriptRunContext), {
    node: t
  } = o, c = t.element.type || "", n = shouldComponentBeEnabled(c, A), h = isComponentStale(n, t, A, g, e), d = getElementId(t.element), k = getKeyFromId(d);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Maybe, { enable: n, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    StyledElementContainerLayoutWrapper,
    {
      className: classNames("stElementContainer", "element-container", convertKeyToClassName(k)),
      "data-testid": "stElementContainer",
      "data-stale": h,
      isStale: h && !E,
      elementType: c,
      node: t,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(ErrorBoundary, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Suspense, { fallback: /* @__PURE__ */ jsxRuntimeExports.jsx(Skeleton, { element: Skeleton$1.create({
        style: Skeleton$1.SkeletonStyle.ELEMENT
      }) }), children: /* @__PURE__ */ jsxRuntimeExports.jsx(RawElementNodeRenderer, { ...o, isStale: h }) }) })
    }
  ) });
};
class RenderNodeVisitor {
  constructor(E) {
    this.props = E, this.elementKeySet = /* @__PURE__ */ new Set(), this.reactElements = [], this.index = 0;
  }
  getCurrentKey(E) {
    const A = E || this.index.toString();
    return this.index += 1, A;
  }
  visitBlockNode(E) {
    const A = {
      ...this.props,
      node: E
    }, g = this.getCurrentKey(), e = /* @__PURE__ */ jsxRuntimeExports.jsx(BlockNodeRenderer, { ...A }, g);
    return this.reactElements.push(e), e;
  }
  visitElementNode(E) {
    const A = {
      ...this.props,
      node: E
    }, g = this.getCurrentKey(getElementId(E.element));
    if (this.elementKeySet.has(g))
      return null;
    this.elementKeySet.add(g);
    const e = /* @__PURE__ */ jsxRuntimeExports.jsx(ElementNodeRenderer, { ...A }, g);
    return this.reactElements.push(e), e;
  }
  /**
   * Convenience method to render all children of a block as React elements.
   *
   * This is the primary entry point for rendering - it creates a visitor,
   * traverses all children, and returns the accumulated React elements.
   *
   * @param props - Block props containing the node to render
   * @param disableFullscreenMode - Whether to disable fullscreen mode for elements
   * @returns Array of React elements ready to render (may include nulls for duplicates)
   *
   * @example
   * const ChildRenderer = (props) => {
   *   return <>{RenderNodeVisitor.collectReactElements(props, false)}</>
   * }
   */
  static collectReactElements(E) {
    if (!E.node.children)
      return [];
    const A = new RenderNodeVisitor(E);
    return E.node.children.forEach((g) => g.accept(A)), A.reactElements;
  }
}
const ChildRenderer = (o) => (assignDividerColor(o.node, useEmotionTheme()), /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: RenderNodeVisitor.collectReactElements(o) })), getLayoutSubElement = (o) => {
  const E = o.type, A = E ? o[E] : void 0;
  if (!A || typeof A != "object") return;
  const g = A, e = {
    useContainerWidth: g.useContainerWidth,
    height: g.height,
    width: g.width,
    widthConfig: g.widthConfig
  };
  if (!(e.useContainerWidth === void 0 && e.height === void 0 && e.width === void 0 && e.widthConfig === void 0))
    return e;
}, ContainerContentsWrapper = (o) => {
  const E = useContext(FlexContext), A = {
    direction: Direction.VERTICAL,
    flex: 1,
    gap: streamlit.GapSize.SMALL,
    height: o.height,
    // eslint-disable-next-line streamlit-custom/no-hardcoded-theme-values
    border: !1
  }, g = getKeyFromId(o.node.deltaBlock.id);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(FlexContextProvider, { direction: Direction.VERTICAL, isRoot: o.isRoot, parentContext: E, children: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledFlexContainerBlock, { ...A, className: classNames(getClassnamePrefix(Direction.VERTICAL), convertKeyToClassName(g)), "data-testid": getClassnamePrefix(Direction.VERTICAL), children: /* @__PURE__ */ jsxRuntimeExports.jsx(ChildRenderer, { ...o }) }) });
}, FlexBoxContainer = (o) => {
  const E = getDirectionOfBlock(o.node.deltaBlock), A = useContext(FlexContext), g = getActivateScrollToBottomBackwardsCompatible(o.node), e = useScrollToBottom(g), t = useLayoutStyles({
    element: o.node.deltaBlock,
    subElement: getLayoutSubElement(o.node.deltaBlock)
  }), c = {
    gap: (
      // This is backwards compatible with old proto messages since previously
      // the gap size was defaulted to small.
      o.node.deltaBlock.flexContainer?.gapConfig?.gapSize ?? streamlit.GapSize.SMALL
    ),
    direction: E,
    // This is also backwards compatible since previously wrap was not added
    // to the flex container.
    $wrap: o.node.deltaBlock.flexContainer?.wrap ?? !1,
    overflow: t.overflow,
    border: getBorderBackwardsCompatible(o.node.deltaBlock),
    // We need the height on the container for scrolling.
    height: t.height,
    // Flex properties are set on the LayoutWrapper.
    flex: "1",
    align: o.node.deltaBlock.flexContainer?.align,
    justify: o.node.deltaBlock.flexContainer?.justify
  }, n = getKeyFromId(o.node.deltaBlock.id), h = o.node.deltaBlock.widthConfig?.pixelWidth ?? void 0, d = o.node.deltaBlock.widthConfig?.useContent ?? !1, k = (o.node.deltaBlock.widthConfig?.pixelWidth ?? 0) > 0 || (o.node.deltaBlock.widthConfig?.remWidth ?? 0) > 0;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(FlexContextProvider, { direction: E, parentWidth: h, hasContentWidth: d, hasFixedWidth: k, parentContext: A, children: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledFlexContainerBlock, { ...c, className: classNames(getClassnamePrefix(E), convertKeyToClassName(n)), "data-testid": getClassnamePrefix(E), ref: e, "data-test-scroll-behavior": g ? "scroll-to-bottom" : "normal", children: /* @__PURE__ */ jsxRuntimeExports.jsx(ChildRenderer, { ...o }) }) });
}, LARGE_STRETCH_BEHAVIOR = ["tabContainer"], MEDIUM_STRETCH_BEHAVIOR = ["chatInput"], BlockNodeRenderer = (o) => {
  const {
    node: E
  } = o, {
    scriptRunState: A,
    scriptRunId: g,
    fragmentIdsThisRun: e
  } = useContext(ScriptRunContext);
  let t;
  LARGE_STRETCH_BEHAVIOR.includes(E.deltaBlock.type ?? "") ? t = "14rem" : MEDIUM_STRETCH_BEHAVIOR.includes(E.deltaBlock.type ?? "") ? t = "8rem" : E.deltaBlock.type === "chatMessage" ? E.isEmpty && (t = "8rem") : (E.deltaBlock.type === "flexContainer" || E.deltaBlock.column || E.deltaBlock.expandable) && (E.isEmpty || (t = "8rem"));
  const c = useLayoutStyles({
    element: E.deltaBlock,
    subElement: getLayoutSubElement(E.deltaBlock),
    minStretchBehavior: t
  });
  if (E.isEmpty && !E.deltaBlock.allowEmpty)
    return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {});
  const n = shouldComponentBeEnabled("", A), h = isComponentStale(n, E, A, g, e), d = {
    ...o,
    node: E
  }, k = o.disableFullscreenMode || notNullOrUndefined(E.deltaBlock.dialog) || notNullOrUndefined(E.deltaBlock.popover);
  let p;
  const M = /* @__PURE__ */ jsxRuntimeExports.jsx(ContainerContentsWrapper, { ...d, disableFullscreenMode: k, height: "100%" });
  if (checkFlexContainerBackwardsCompatibile(E.deltaBlock) && (p = /* @__PURE__ */ jsxRuntimeExports.jsx(FlexBoxContainer, { ...d })), E.deltaBlock.dialog)
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Dialog$1, { element: E.deltaBlock.dialog, deltaMsgReceivedAt: E.deltaMsgReceivedAt, widgetMgr: o.widgetMgr, fragmentId: E.fragmentId, children: M });
  if (E.deltaBlock.expandable && (p = /* @__PURE__ */ jsxRuntimeExports.jsx(Expander$1, { isStale: h, element: E.deltaBlock.expandable, children: M })), E.deltaBlock.popover && (p = /* @__PURE__ */ jsxRuntimeExports.jsx(Popover$1, { empty: E.isEmpty, element: E.deltaBlock.popover, stretchWidth: shouldWidthStretch(E.deltaBlock.widthConfig), children: M })), E.deltaBlock.type === "form") {
    const {
      formId: S,
      clearOnSubmit: AA,
      enterToSubmit: H,
      border: gA
    } = E.deltaBlock.form;
    p = /* @__PURE__ */ jsxRuntimeExports.jsx(Form$1, { formId: S, clearOnSubmit: AA, enterToSubmit: H, widgetMgr: o.widgetMgr, border: gA, overflow: c.overflow, children: M });
  }
  if (E.deltaBlock.chatMessage && (p = /* @__PURE__ */ jsxRuntimeExports.jsx(ChatMessage$1, { element: E.deltaBlock.chatMessage, endpoints: o.endpoints, children: M })), E.deltaBlock.column)
    return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledColumn, { weight: E.deltaBlock.column.weight ?? 0, gap: backwardsCompatibleColumnGapSize(E.deltaBlock.column), verticalAlignment: E.deltaBlock.column.verticalAlignment ?? void 0, showBorder: E.deltaBlock.column.showBorder ?? !1, className: "stColumn", "data-testid": "stColumn", children: M });
  if (E.deltaBlock.tabContainer) {
    const AA = {
      ...d,
      isStale: h,
      renderTabContent: (H) => /* @__PURE__ */ jsxRuntimeExports.jsx(ContainerContentsWrapper, { ...H, height: "auto" }),
      width: c.width,
      flex: c.flex
    };
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Tabs$1, { ...AA });
  }
  return p ? /* @__PURE__ */ jsxRuntimeExports.jsx(StyledLayoutWrapper, { "data-testid": "stLayoutWrapper", ...c, children: p }) : M;
}, DownloadContext = createContext({
  requestDeferredFile: void 0
});
DownloadContext.displayName = "DownloadContext";
const NavigationContext = createContext({
  pageLinkBaseUrl: "",
  currentPageScriptHash: "",
  onPageChange: () => {
  },
  navSections: [],
  appPages: []
});
NavigationContext.displayName = "NavigationContext";
process.env.NODE_ENV;
const StyledDataFrameOverlay = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e1v116lc1"
} : {
  target: "e1v116lc1",
  label: "StyledDataFrameOverlay"
})(({
  theme: o
}) => ({
  position: "fixed",
  top: 0,
  left: 0,
  zIndex: o.zIndices.tablePortal,
  lineHeight: "100%",
  ...!hasLightBackgroundColor(o) && {
    "& input[type='date'], & input[type='time'], & input[type='datetime-local']": {
      "&::-webkit-calendar-picker-indicator": {
        filter: "brightness(0) invert(1)",
        opacity: 1
      }
    }
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledErrorMessage = /* @__PURE__ */ createStyled("small", process.env.NODE_ENV === "production" ? {
  target: "e1v116lc0"
} : {
  target: "e1v116lc0",
  label: "StyledErrorMessage"
})(({
  theme: o
}) => ({
  color: o.colors.redTextColor,
  fontSize: o.fontSizes.sm,
  marginTop: o.spacing.twoXS,
  display: "block"
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2xpYi9zcmMvc3R5bGVkLWNvbXBvbmVudHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBMkRrQyIsImZpbGUiOiIvaG9tZS9ydW5uZXIvd29yay9zdGxpdGUvc3RsaXRlL3N0cmVhbWxpdC9mcm9udGVuZC9saWIvc3JjL3N0eWxlZC1jb21wb25lbnRzLnRzIiwic291cmNlc0NvbnRlbnQiOlsiLyoqXG4gKiBDb3B5cmlnaHQgKGMpIFN0cmVhbWxpdCBJbmMuICgyMDE4LTIwMjIpIFNub3dmbGFrZSBJbmMuICgyMDIyLTIwMjUpXG4gKlxuICogTGljZW5zZWQgdW5kZXIgdGhlIEFwYWNoZSBMaWNlbnNlLCBWZXJzaW9uIDIuMCAodGhlIFwiTGljZW5zZVwiKTtcbiAqIHlvdSBtYXkgbm90IHVzZSB0aGlzIGZpbGUgZXhjZXB0IGluIGNvbXBsaWFuY2Ugd2l0aCB0aGUgTGljZW5zZS5cbiAqIFlvdSBtYXkgb2J0YWluIGEgY29weSBvZiB0aGUgTGljZW5zZSBhdFxuICpcbiAqICAgICBodHRwOi8vd3d3LmFwYWNoZS5vcmcvbGljZW5zZXMvTElDRU5TRS0yLjBcbiAqXG4gKiBVbmxlc3MgcmVxdWlyZWQgYnkgYXBwbGljYWJsZSBsYXcgb3IgYWdyZWVkIHRvIGluIHdyaXRpbmcsIHNvZnR3YXJlXG4gKiBkaXN0cmlidXRlZCB1bmRlciB0aGUgTGljZW5zZSBpcyBkaXN0cmlidXRlZCBvbiBhbiBcIkFTIElTXCIgQkFTSVMsXG4gKiBXSVRIT1VUIFdBUlJBTlRJRVMgT1IgQ09ORElUSU9OUyBPRiBBTlkgS0lORCwgZWl0aGVyIGV4cHJlc3Mgb3IgaW1wbGllZC5cbiAqIFNlZSB0aGUgTGljZW5zZSBmb3IgdGhlIHNwZWNpZmljIGxhbmd1YWdlIGdvdmVybmluZyBwZXJtaXNzaW9ucyBhbmRcbiAqIGxpbWl0YXRpb25zIHVuZGVyIHRoZSBMaWNlbnNlLlxuICovXG5cbmltcG9ydCBzdHlsZWQgZnJvbSBcIkBlbW90aW9uL3N0eWxlZFwiXG5cbmltcG9ydCB7IGhhc0xpZ2h0QmFja2dyb3VuZENvbG9yIH0gZnJvbSBcIkBzdHJlYW1saXQvbGliXCJcblxuZXhwb3J0IGNvbnN0IFN0eWxlZEFwcCA9IHN0eWxlZC5kaXYoKHsgdGhlbWUgfSkgPT4gKHtcbiAgcG9zaXRpb246IFwiYWJzb2x1dGVcIixcbiAgYmFja2dyb3VuZDogdGhlbWUuY29sb3JzLmJnQ29sb3IsXG4gIGNvbG9yOiB0aGVtZS5jb2xvcnMuYm9keVRleHQsXG4gIHRvcDogdGhlbWUuc3BhY2luZy5ub25lLFxuICBsZWZ0OiB0aGVtZS5zcGFjaW5nLm5vbmUsXG4gIHJpZ2h0OiB0aGVtZS5zcGFjaW5nLm5vbmUsXG4gIGJvdHRvbTogdGhlbWUuc3BhY2luZy5ub25lLFxuICBvdmVyZmxvdzogXCJoaWRkZW5cIixcbiAgXCJAbWVkaWEgcHJpbnRcIjoge1xuICAgIGZsb2F0OiBcIm5vbmVcIixcbiAgICBoZWlnaHQ6IHRoZW1lLnNpemVzLmZ1bGwsXG4gICAgcG9zaXRpb246IFwic3RhdGljXCIsXG4gICAgb3ZlcmZsb3c6IFwidmlzaWJsZVwiLFxuICB9LFxufSkpXG5cbi8qKlxuICogVGhlIGdsaWRlLWRhdGEtZ3JpZCByZXF1aXJlcyBvbmUgcm9vdCBsZXZlbCBwb3J0YWwgZWxlbWVudCBmb3IgcmVuZGVyaW5nIHRoZSBjZWxsIG92ZXJsYXlzOlxuICogaHR0cHM6Ly9naXRodWIuY29tL2dsaWRlYXBwcy9nbGlkZS1kYXRhLWdyaWQvYmxvYi9tYWluL3BhY2thZ2VzL2NvcmUvQVBJLm1kI2h0bWxjc3MtcHJlcmVxdWlzaXRlc1xuICogVGhpcyBpcyBhZGRlZCB0byB0aGUgYm9keSBpbiBUaGVtZWRBcHAuXG4gKi9cbmV4cG9ydCBjb25zdCBTdHlsZWREYXRhRnJhbWVPdmVybGF5ID0gc3R5bGVkLmRpdigoeyB0aGVtZSB9KSA9PiAoe1xuICBwb3NpdGlvbjogXCJmaXhlZFwiLFxuICB0b3A6IDAsXG4gIGxlZnQ6IDAsXG4gIHpJbmRleDogdGhlbWUuekluZGljZXMudGFibGVQb3J0YWwsXG4gIGxpbmVIZWlnaHQ6IFwiMTAwJVwiLFxuICAuLi4oIWhhc0xpZ2h0QmFja2dyb3VuZENvbG9yKHRoZW1lKSAmJiB7XG4gICAgXCImIGlucHV0W3R5cGU9J2RhdGUnXSwgJiBpbnB1dFt0eXBlPSd0aW1lJ10sICYgaW5wdXRbdHlwZT0nZGF0ZXRpbWUtbG9jYWwnXVwiOlxuICAgICAge1xuICAgICAgICBcIiY6Oi13ZWJraXQtY2FsZW5kYXItcGlja2VyLWluZGljYXRvclwiOiB7XG4gICAgICAgICAgZmlsdGVyOiBcImJyaWdodG5lc3MoMCkgaW52ZXJ0KDEpXCIsXG4gICAgICAgICAgb3BhY2l0eTogMSxcbiAgICAgICAgfSxcbiAgICAgIH0sXG4gIH0pLFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRFcnJvck1lc3NhZ2UgPSBzdHlsZWQuc21hbGwoKHsgdGhlbWUgfSkgPT4gKHtcbiAgY29sb3I6IHRoZW1lLmNvbG9ycy5yZWRUZXh0Q29sb3IsXG4gIGZvbnRTaXplOiB0aGVtZS5mb250U2l6ZXMuc20sXG4gIG1hcmdpblRvcDogdGhlbWUuc3BhY2luZy50d29YUyxcbiAgZGlzcGxheTogXCJibG9ja1wiLFxufSkpXG4iXX0= */"), PortalContext = createContext(null);
PortalContext.displayName = "PortalContext";
const PortalProvider = ({
  children: o
}) => {
  const E = useRef(null), A = useCallback(() => E.current, []);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(PortalContext.Provider, { value: A, children: [
    o,
    /* @__PURE__ */ jsxRuntimeExports.jsx(StyledDataFrameOverlay, { "data-testid": "portal", id: "portal", ref: E })
  ] });
}, SidebarConfigContext = createContext({
  initialSidebarState: PageConfig.SidebarState.AUTO,
  appLogo: null,
  sidebarChevronDownshift: 0,
  expandSidebarNav: !1,
  hideSidebarNav: !1
});
SidebarConfigContext.displayName = "SidebarConfigContext";
const ThemeContext = createContext({
  activeTheme: getDefaultTheme(),
  setTheme: () => {
  },
  availableThemes: []
});
ThemeContext.displayName = "ThemeContext";
function ThemeProvider({
  theme: o,
  baseuiTheme: E,
  children: A
}) {
  return (
    // Type error coming from BaseUI "property children doesn't exist"
    // @ts-expect-error
    /* @__PURE__ */ jsxRuntimeExports.jsx(ThemeProvider$1, { theme: E || baseuiLightTheme, children: /* @__PURE__ */ jsxRuntimeExports.jsx(ThemeProvider$2, { theme: o, children: A }) })
  );
}
const CopyButton = ({
  text: o
}) => {
  const E = useEmotionTheme(), A = useRef(null), {
    isCopied: g,
    copyToClipboard: e,
    label: t
  } = useCopyToClipboard(), c = useCallback(() => {
    e(o);
  }, [e, o]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledCopyButton, { "data-testid": "stCodeCopyButton", title: t, "aria-label": t, type: "button", ref: A, onClick: c, children: g ? /* @__PURE__ */ jsxRuntimeExports.jsx(Check, { size: convertRemToPx(E.iconSizes.base) }) : /* @__PURE__ */ jsxRuntimeExports.jsx(Copy, { size: convertRemToPx(E.iconSizes.base) }) });
}, CopyButton$1 = memo(CopyButton);
function StreamlitErrorCodeBlock({
  children: o
}) {
  const E = typeof o == "string" && o.trim().length > 0;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledCodeBlock, { className: "stErrorCodeBlock", "data-testid": "stErrorCodeBlock", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(StyledPre, { wrapLines: !1, children: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledCode, { wrapLines: !1, children: o }) }),
    E && /* @__PURE__ */ jsxRuntimeExports.jsx(StyledCopyButtonContainer, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(CopyButton$1, { text: o }) })
  ] });
}
const StreamlitErrorCodeBlock$1 = memo(StreamlitErrorCodeBlock);
function iconToUrl(o) {
  const E = /^:(.+)\/(.+):$/, A = o.match(E);
  return A === null ? "" : `https://fonts.gstatic.com/s/i/short-term/release/materialsymbolsrounded/${A[2]}/default/24px.svg`;
}
function handleFavicon(o, E, A) {
  const g = (c) => {
    overwriteFavicon(c), E({
      type: "SET_PAGE_FAVICON",
      favicon: c
    });
  };
  if (o.startsWith(":material")) {
    g(iconToUrl(o));
    return;
  }
  const e = "emoji:";
  if (o.startsWith(e)) {
    const c = o.substring(e.length), n = createEmojiDataUrl(c);
    g(n);
    return;
  }
  /^:[a-zA-Z0-9_+-]+:$/.test(o) ? convertShortcodeToEmoji(o).then((c) => {
    g(c ? createEmojiDataUrl(c) : A.buildMediaURL(o));
  }).catch(() => {
    g(A.buildMediaURL(o));
  }) : g(A.buildMediaURL(o));
}
function createEmojiDataUrl(o) {
  return `data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'><text y='.9em' font-size='90'>${o}</text></svg>`;
}
function overwriteFavicon(o) {
  const E = document.querySelector("link[rel='shortcut icon']");
  E && (E.href = o);
}
async function convertShortcodeToEmoji(o) {
  const E = await import("./index-R1QyBsfg.js"), A = o.replace(/-/g, "_"), g = E.get(A);
  return g && g !== A && E.has(g) ? g : "";
}
function _EMOTION_STRINGIFIED_CSS_ERROR__$9() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const StyledWidgetLabel = /* @__PURE__ */ createStyled("label", process.env.NODE_ENV === "production" ? {
  target: "e1y5xkzn3"
} : {
  target: "e1y5xkzn3",
  label: "StyledWidgetLabel"
})(({
  disabled: o,
  labelVisibility: E,
  theme: A
}) => ({
  fontSize: A.fontSizes.sm,
  color: o ? A.colors.fadedText40 : A.colors.bodyText,
  display: E === LabelVisibilityOptions.Collapsed ? "none" : "flex",
  visibility: E === LabelVisibilityOptions.Hidden ? "hidden" : "visible",
  marginBottom: A.spacing.twoXS,
  height: "auto",
  minHeight: A.fontSizes.xl,
  verticalAlign: "middle",
  flexDirection: "row",
  alignItems: "center"
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledWidgetLabelHelp = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e1y5xkzn2"
} : {
  target: "e1y5xkzn2",
  label: "StyledWidgetLabelHelp"
})(process.env.NODE_ENV === "production" ? {
  name: "1h97c9v",
  styles: "display:flex;flex-direction:row;justify-content:flex-end;flex:1"
} : {
  name: "1h97c9v",
  styles: "display:flex;flex-direction:row;justify-content:flex-end;flex:1/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$9
}), StyledWidgetInstructions = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e1y5xkzn1"
} : {
  target: "e1y5xkzn1",
  label: "StyledWidgetInstructions"
})(({
  theme: o
}) => ({
  fontSize: o.fontSizes.twoSm,
  color: o.colors.fadedText60,
  margin: o.spacing.none,
  textAlign: "right",
  position: "absolute",
  bottom: o.spacing.threeXS,
  right: `calc(${o.fontSizes.mdLg} * 0.5)`
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledWidgetLabelHelpInline = /* @__PURE__ */ createStyled("label", process.env.NODE_ENV === "production" ? {
  target: "e1y5xkzn0"
} : {
  target: "e1y5xkzn0",
  label: "StyledWidgetLabelHelpInline"
})(({
  theme: o
}) => ({
  marginLeft: o.spacing.xs,
  position: "relative",
  display: "flex",
  flexDirection: "row"
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
function WidgetLabel({
  label: o,
  children: E,
  disabled: A,
  labelVisibility: g,
  htmlFor: e
}) {
  return isNullOrUndefined(o) ? /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {}) : (
    // we use aria-hidden to disable ARIA for StyleWidgetLabel, because each
    // widget should have its own aria-label and/or implement accessibility.
    /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledWidgetLabel, { "data-testid": "stWidgetLabel", "aria-hidden": "true", disabled: A, labelVisibility: g, htmlFor: e, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(StreamlitMarkdown$1, { source: o, allowHTML: !1, isLabel: !0 }),
      E
    ] })
  );
}
var _excluded$i = ["title", "size", "color", "overrides"];
function _extends$i() {
  return _extends$i = Object.assign ? Object.assign.bind() : function(o) {
    for (var E = 1; E < arguments.length; E++) {
      var A = arguments[E];
      for (var g in A)
        Object.prototype.hasOwnProperty.call(A, g) && (o[g] = A[g]);
    }
    return o;
  }, _extends$i.apply(this, arguments);
}
function _objectWithoutProperties$g(o, E) {
  if (o == null) return {};
  var A = _objectWithoutPropertiesLoose$f(o, E), g, e;
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    for (e = 0; e < t.length; e++)
      g = t[e], !(E.indexOf(g) >= 0) && Object.prototype.propertyIsEnumerable.call(o, g) && (A[g] = o[g]);
  }
  return A;
}
function _objectWithoutPropertiesLoose$f(o, E) {
  if (o == null) return {};
  var A = {}, g = Object.keys(o), e, t;
  for (t = 0; t < g.length; t++)
    e = g[t], !(E.indexOf(e) >= 0) && (A[e] = o[e]);
  return A;
}
function _slicedToArray$e(o, E) {
  return _arrayWithHoles$d(o) || _iterableToArrayLimit$d(o, E) || _unsupportedIterableToArray$d(o, E) || _nonIterableRest$d();
}
function _nonIterableRest$d() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$d(o, E) {
  if (o) {
    if (typeof o == "string") return _arrayLikeToArray$d(o, E);
    var A = Object.prototype.toString.call(o).slice(8, -1);
    if (A === "Object" && o.constructor && (A = o.constructor.name), A === "Map" || A === "Set") return Array.from(o);
    if (A === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(A)) return _arrayLikeToArray$d(o, E);
  }
}
function _arrayLikeToArray$d(o, E) {
  (E == null || E > o.length) && (E = o.length);
  for (var A = 0, g = new Array(E); A < E; A++)
    g[A] = o[A];
  return g;
}
function _iterableToArrayLimit$d(o, E) {
  var A = o == null ? null : typeof Symbol < "u" && o[Symbol.iterator] || o["@@iterator"];
  if (A != null) {
    var g = [], e = !0, t = !1, c, n;
    try {
      for (A = A.call(o); !(e = (c = A.next()).done) && (g.push(c.value), !(E && g.length === E)); e = !0)
        ;
    } catch (h) {
      t = !0, n = h;
    } finally {
      try {
        !e && A.return != null && A.return();
      } finally {
        if (t) throw n;
      }
    }
    return g;
  }
}
function _arrayWithHoles$d(o) {
  if (Array.isArray(o)) return o;
}
function ChevronDown(o, E) {
  var A = useStyletron(), g = _slicedToArray$e(A, 2), e = g[1], t = o.title, c = t === void 0 ? "Down" : t, n = o.size, h = o.color, d = o.overrides, k = d === void 0 ? {} : d, p = _objectWithoutProperties$g(o, _excluded$i), M = mergeOverride(
    // Icons from the theme target the SVG override in the underlying Icon component
    {
      component: e.icons && e.icons.ChevronDown ? e.icons.ChevronDown : null
    },
    k && k.Svg ? toObjectOverride(k.Svg) : {}
  );
  return /* @__PURE__ */ React.createElement(Icon$1, _extends$i({
    viewBox: "0 0 24 24",
    ref: E,
    title: c,
    size: n,
    color: h,
    overrides: {
      Svg: M
    }
  }, p), /* @__PURE__ */ React.createElement("path", {
    transform: "rotate(270, 12, 12)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 12C9 12.2652 9.10536 12.5196 9.29289 12.7071L13.2929 16.7071C13.6834 17.0976 14.3166 17.0976 14.7071 16.7071C15.0976 16.3166 15.0976 15.6834 14.7071 15.2929L11.4142 12L14.7071 8.70711C15.0976 8.31658 15.0976 7.68342 14.7071 7.29289C14.3166 6.90237 13.6834 6.90237 13.2929 7.29289L9.29289 11.2929C9.10536 11.4804 9 11.7348 9 12Z"
  }));
}
const ChevronDown$1 = /* @__PURE__ */ React.forwardRef(ChevronDown);
var _excluded$h = ["title", "size", "color", "overrides"];
function _extends$h() {
  return _extends$h = Object.assign ? Object.assign.bind() : function(o) {
    for (var E = 1; E < arguments.length; E++) {
      var A = arguments[E];
      for (var g in A)
        Object.prototype.hasOwnProperty.call(A, g) && (o[g] = A[g]);
    }
    return o;
  }, _extends$h.apply(this, arguments);
}
function _objectWithoutProperties$f(o, E) {
  if (o == null) return {};
  var A = _objectWithoutPropertiesLoose$e(o, E), g, e;
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    for (e = 0; e < t.length; e++)
      g = t[e], !(E.indexOf(g) >= 0) && Object.prototype.propertyIsEnumerable.call(o, g) && (A[g] = o[g]);
  }
  return A;
}
function _objectWithoutPropertiesLoose$e(o, E) {
  if (o == null) return {};
  var A = {}, g = Object.keys(o), e, t;
  for (t = 0; t < g.length; t++)
    e = g[t], !(E.indexOf(e) >= 0) && (A[e] = o[e]);
  return A;
}
function _slicedToArray$d(o, E) {
  return _arrayWithHoles$c(o) || _iterableToArrayLimit$c(o, E) || _unsupportedIterableToArray$c(o, E) || _nonIterableRest$c();
}
function _nonIterableRest$c() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$c(o, E) {
  if (o) {
    if (typeof o == "string") return _arrayLikeToArray$c(o, E);
    var A = Object.prototype.toString.call(o).slice(8, -1);
    if (A === "Object" && o.constructor && (A = o.constructor.name), A === "Map" || A === "Set") return Array.from(o);
    if (A === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(A)) return _arrayLikeToArray$c(o, E);
  }
}
function _arrayLikeToArray$c(o, E) {
  (E == null || E > o.length) && (E = o.length);
  for (var A = 0, g = new Array(E); A < E; A++)
    g[A] = o[A];
  return g;
}
function _iterableToArrayLimit$c(o, E) {
  var A = o == null ? null : typeof Symbol < "u" && o[Symbol.iterator] || o["@@iterator"];
  if (A != null) {
    var g = [], e = !0, t = !1, c, n;
    try {
      for (A = A.call(o); !(e = (c = A.next()).done) && (g.push(c.value), !(E && g.length === E)); e = !0)
        ;
    } catch (h) {
      t = !0, n = h;
    } finally {
      try {
        !e && A.return != null && A.return();
      } finally {
        if (t) throw n;
      }
    }
    return g;
  }
}
function _arrayWithHoles$c(o) {
  if (Array.isArray(o)) return o;
}
function DeleteAlt(o, E) {
  var A = useStyletron(), g = _slicedToArray$d(A, 2), e = g[1], t = o.title, c = t === void 0 ? "Delete Alt" : t, n = o.size, h = o.color, d = o.overrides, k = d === void 0 ? {} : d, p = _objectWithoutProperties$f(o, _excluded$h), M = mergeOverride(
    // Icons from the theme target the SVG override in the underlying Icon component
    {
      component: e.icons && e.icons.DeleteAlt ? e.icons.DeleteAlt : null
    },
    k && k.Svg ? toObjectOverride(k.Svg) : {}
  );
  return /* @__PURE__ */ React.createElement(Icon$1, _extends$h({
    viewBox: "0 0 24 24",
    ref: E,
    title: c,
    size: n,
    color: h,
    overrides: {
      Svg: M
    }
  }, p), /* @__PURE__ */ React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 20C16.4183 20 20 16.4183 20 12C20 7.58173 16.4183 4 12 4C7.58173 4 4 7.58173 4 12C4 16.4183 7.58173 20 12 20ZM10.0303 8.96967C9.73743 8.67679 9.26257 8.67679 8.96967 8.96967C8.67676 9.26257 8.67676 9.73743 8.96967 10.0303L10.9393 12L8.96967 13.9697C8.67676 14.2626 8.67676 14.7374 8.96967 15.0303C9.26257 15.3232 9.73743 15.3232 10.0303 15.0303L12 13.0607L13.9697 15.0303C14.2626 15.3232 14.7374 15.3232 15.0303 15.0303C15.3232 14.7374 15.3232 14.2626 15.0303 13.9697L13.0607 12L15.0303 10.0303C15.3232 9.73743 15.3232 9.26257 15.0303 8.96967C14.7374 8.67679 14.2626 8.67679 13.9697 8.96967L12 10.9393L10.0303 8.96967Z"
  }));
}
const DeleteAlt$1 = /* @__PURE__ */ React.forwardRef(DeleteAlt);
var _excluded$g = ["title", "size", "color", "overrides"];
function _extends$g() {
  return _extends$g = Object.assign ? Object.assign.bind() : function(o) {
    for (var E = 1; E < arguments.length; E++) {
      var A = arguments[E];
      for (var g in A)
        Object.prototype.hasOwnProperty.call(A, g) && (o[g] = A[g]);
    }
    return o;
  }, _extends$g.apply(this, arguments);
}
function _objectWithoutProperties$e(o, E) {
  if (o == null) return {};
  var A = _objectWithoutPropertiesLoose$d(o, E), g, e;
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    for (e = 0; e < t.length; e++)
      g = t[e], !(E.indexOf(g) >= 0) && Object.prototype.propertyIsEnumerable.call(o, g) && (A[g] = o[g]);
  }
  return A;
}
function _objectWithoutPropertiesLoose$d(o, E) {
  if (o == null) return {};
  var A = {}, g = Object.keys(o), e, t;
  for (t = 0; t < g.length; t++)
    e = g[t], !(E.indexOf(e) >= 0) && (A[e] = o[e]);
  return A;
}
function _slicedToArray$c(o, E) {
  return _arrayWithHoles$b(o) || _iterableToArrayLimit$b(o, E) || _unsupportedIterableToArray$b(o, E) || _nonIterableRest$b();
}
function _nonIterableRest$b() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$b(o, E) {
  if (o) {
    if (typeof o == "string") return _arrayLikeToArray$b(o, E);
    var A = Object.prototype.toString.call(o).slice(8, -1);
    if (A === "Object" && o.constructor && (A = o.constructor.name), A === "Map" || A === "Set") return Array.from(o);
    if (A === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(A)) return _arrayLikeToArray$b(o, E);
  }
}
function _arrayLikeToArray$b(o, E) {
  (E == null || E > o.length) && (E = o.length);
  for (var A = 0, g = new Array(E); A < E; A++)
    g[A] = o[A];
  return g;
}
function _iterableToArrayLimit$b(o, E) {
  var A = o == null ? null : typeof Symbol < "u" && o[Symbol.iterator] || o["@@iterator"];
  if (A != null) {
    var g = [], e = !0, t = !1, c, n;
    try {
      for (A = A.call(o); !(e = (c = A.next()).done) && (g.push(c.value), !(E && g.length === E)); e = !0)
        ;
    } catch (h) {
      t = !0, n = h;
    } finally {
      try {
        !e && A.return != null && A.return();
      } finally {
        if (t) throw n;
      }
    }
    return g;
  }
}
function _arrayWithHoles$b(o) {
  if (Array.isArray(o)) return o;
}
function Search(o, E) {
  var A = useStyletron(), g = _slicedToArray$c(A, 2), e = g[1], t = o.title, c = t === void 0 ? "Search" : t, n = o.size, h = o.color, d = o.overrides, k = d === void 0 ? {} : d, p = _objectWithoutProperties$e(o, _excluded$g), M = mergeOverride(
    // Icons from the theme target the SVG override in the underlying Icon component
    {
      component: e.icons && e.icons.Search ? e.icons.Search : null
    },
    k && k.Svg ? toObjectOverride(k.Svg) : {}
  );
  return /* @__PURE__ */ React.createElement(Icon$1, _extends$g({
    viewBox: "0 0 24 24",
    ref: E,
    title: c,
    size: n,
    color: h,
    overrides: {
      Svg: M
    }
  }, p), /* @__PURE__ */ React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 6C8.79086 6 7 7.79086 7 10C7 12.2091 8.79086 14 11 14C13.2091 14 15 12.2091 15 10C15 7.79086 13.2091 6 11 6ZM5 10C5 6.68629 7.68629 4 11 4C14.3137 4 17 6.68629 17 10C17 11.2958 16.5892 12.4957 15.8907 13.4765L19.7071 17.2929C20.0976 17.6834 20.0976 18.3166 19.7071 18.7071C19.3166 19.0976 18.6834 19.0976 18.2929 18.7071L14.4765 14.8907C13.4957 15.5892 12.2958 16 11 16C7.68629 16 5 13.3137 5 10Z"
  }));
}
const SearchIconComponent = /* @__PURE__ */ React.forwardRef(Search);
var _excluded$f = ["title", "size", "color", "overrides"];
function _extends$f() {
  return _extends$f = Object.assign ? Object.assign.bind() : function(o) {
    for (var E = 1; E < arguments.length; E++) {
      var A = arguments[E];
      for (var g in A)
        Object.prototype.hasOwnProperty.call(A, g) && (o[g] = A[g]);
    }
    return o;
  }, _extends$f.apply(this, arguments);
}
function _objectWithoutProperties$d(o, E) {
  if (o == null) return {};
  var A = _objectWithoutPropertiesLoose$c(o, E), g, e;
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    for (e = 0; e < t.length; e++)
      g = t[e], !(E.indexOf(g) >= 0) && Object.prototype.propertyIsEnumerable.call(o, g) && (A[g] = o[g]);
  }
  return A;
}
function _objectWithoutPropertiesLoose$c(o, E) {
  if (o == null) return {};
  var A = {}, g = Object.keys(o), e, t;
  for (t = 0; t < g.length; t++)
    e = g[t], !(E.indexOf(e) >= 0) && (A[e] = o[e]);
  return A;
}
function _slicedToArray$b(o, E) {
  return _arrayWithHoles$a(o) || _iterableToArrayLimit$a(o, E) || _unsupportedIterableToArray$a(o, E) || _nonIterableRest$a();
}
function _nonIterableRest$a() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$a(o, E) {
  if (o) {
    if (typeof o == "string") return _arrayLikeToArray$a(o, E);
    var A = Object.prototype.toString.call(o).slice(8, -1);
    if (A === "Object" && o.constructor && (A = o.constructor.name), A === "Map" || A === "Set") return Array.from(o);
    if (A === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(A)) return _arrayLikeToArray$a(o, E);
  }
}
function _arrayLikeToArray$a(o, E) {
  (E == null || E > o.length) && (E = o.length);
  for (var A = 0, g = new Array(E); A < E; A++)
    g[A] = o[A];
  return g;
}
function _iterableToArrayLimit$a(o, E) {
  var A = o == null ? null : typeof Symbol < "u" && o[Symbol.iterator] || o["@@iterator"];
  if (A != null) {
    var g = [], e = !0, t = !1, c, n;
    try {
      for (A = A.call(o); !(e = (c = A.next()).done) && (g.push(c.value), !(E && g.length === E)); e = !0)
        ;
    } catch (h) {
      t = !0, n = h;
    } finally {
      try {
        !e && A.return != null && A.return();
      } finally {
        if (t) throw n;
      }
    }
    return g;
  }
}
function _arrayWithHoles$a(o) {
  if (Array.isArray(o)) return o;
}
function TriangleDown(o, E) {
  var A = useStyletron(), g = _slicedToArray$b(A, 2), e = g[1], t = o.title, c = t === void 0 ? "Triangle Down" : t, n = o.size, h = o.color, d = o.overrides, k = d === void 0 ? {} : d, p = _objectWithoutProperties$d(o, _excluded$f), M = mergeOverride(
    // Icons from the theme target the SVG override in the underlying Icon component
    {
      component: e.icons && e.icons.TriangleDown ? e.icons.TriangleDown : null
    },
    k && k.Svg ? toObjectOverride(k.Svg) : {}
  );
  return /* @__PURE__ */ React.createElement(Icon$1, _extends$f({
    viewBox: "0 0 24 24",
    ref: E,
    title: c,
    size: n,
    color: h,
    overrides: {
      Svg: M
    }
  }, p), /* @__PURE__ */ React.createElement("path", {
    d: "M12.7071 15.2929L17.1464 10.8536C17.4614 10.5386 17.2383 10 16.7929 10L7.20711 10C6.76165 10 6.53857 10.5386 6.85355 10.8536L11.2929 15.2929C11.6834 15.6834 12.3166 15.6834 12.7071 15.2929Z"
  }));
}
const TriangleDownIcon = /* @__PURE__ */ React.forwardRef(TriangleDown);
var CUSTOM_INPUT_TYPE = {
  textarea: "textarea"
}, ADJOINED = {
  none: "none",
  left: "left",
  right: "right",
  both: "both"
}, SIZE$1 = {
  mini: "mini",
  default: "default",
  compact: "compact",
  large: "large"
}, ENHANCER_POSITION = {
  start: "start",
  end: "end"
}, TYPE = {
  select: "select",
  search: "search"
}, STATE_CHANGE_TYPE = Object.freeze({
  select: "select",
  remove: "remove",
  clear: "clear"
}), STATE_CHANGE_TYPES = {
  click: "click",
  moveUp: "moveUp",
  moveDown: "moveDown",
  mouseEnter: "mouseEnter",
  focus: "focus",
  reset: "reset",
  character: "character",
  enter: "enter"
}, KEY_STRINGS = {
  ArrowUp: "ArrowUp",
  ArrowDown: "ArrowDown",
  ArrowLeft: "ArrowLeft",
  ArrowRight: "ArrowRight",
  Enter: "Enter",
  Home: "Home",
  End: "End"
}, OPTION_LIST_SIZE = {
  default: "default",
  compact: "compact"
}, _excluded$e = ["item"];
function _objectWithoutProperties$c(o, E) {
  if (o == null) return {};
  var A = _objectWithoutPropertiesLoose$b(o, E), g, e;
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    for (e = 0; e < t.length; e++)
      g = t[e], !(E.indexOf(g) >= 0) && Object.prototype.propertyIsEnumerable.call(o, g) && (A[g] = o[g]);
  }
  return A;
}
function _objectWithoutPropertiesLoose$b(o, E) {
  if (o == null) return {};
  var A = {}, g = Object.keys(o), e, t;
  for (t = 0; t < g.length; t++)
    e = g[t], !(E.indexOf(e) >= 0) && (A[e] = o[e]);
  return A;
}
function ownKeys$c(o, E) {
  var A = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var g = Object.getOwnPropertySymbols(o);
    E && (g = g.filter(function(e) {
      return Object.getOwnPropertyDescriptor(o, e).enumerable;
    })), A.push.apply(A, g);
  }
  return A;
}
function _objectSpread$a(o) {
  for (var E = 1; E < arguments.length; E++) {
    var A = arguments[E] != null ? arguments[E] : {};
    E % 2 ? ownKeys$c(Object(A), !0).forEach(function(g) {
      _defineProperty$d(o, g, A[g]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(A)) : ownKeys$c(Object(A)).forEach(function(g) {
      Object.defineProperty(o, g, Object.getOwnPropertyDescriptor(A, g));
    });
  }
  return o;
}
function _defineProperty$d(o, E, A) {
  return E in o ? Object.defineProperty(o, E, { value: A, enumerable: !0, configurable: !0, writable: !0 }) : o[E] = A, o;
}
var StyledList = styled("ul", function(o) {
  var E = o.$theme, A = o.$isFocusVisible;
  return {
    backgroundColor: E.colors.menuFill,
    position: "relative",
    marginTop: 0,
    marginBottom: 0,
    marginLeft: 0,
    marginRight: 0,
    paddingTop: E.sizing.scale300,
    paddingBottom: E.sizing.scale300,
    paddingLeft: 0,
    paddingRight: 0,
    borderTopLeftRadius: E.borders.popoverBorderRadius,
    borderTopRightRadius: E.borders.popoverBorderRadius,
    borderBottomRightRadius: E.borders.popoverBorderRadius,
    borderBottomLeftRadius: E.borders.popoverBorderRadius,
    boxShadow: E.lighting.shadow600,
    overflow: "auto",
    ":focus": {
      outline: A ? "3px solid ".concat(E.colors.accent) : "none"
    }
  };
});
StyledList.displayName = "StyledList";
StyledList.displayName = "StyledList";
function getFontColor(o) {
  return o.$disabled ? o.$theme.colors.menuFontDisabled : o.$isHighlighted && o.$isFocused ? o.$theme.colors.menuFontHighlighted : o.$isHighlighted && !o.$isFocused ? o.$theme.colors.menuFontSelected : o.$theme.colors.menuFontDefault;
}
function getBackgroundColor(o) {
  return o.$disabled ? "transparent" : o.$isHighlighted ? o.$theme.colors.menuFillHover : "transparent";
}
var StyledEmptyState = styled("li", function(o) {
  var E = o.$theme, A = o.$size;
  return _objectSpread$a(_objectSpread$a({}, A === OPTION_LIST_SIZE.compact ? E.typography.font100 : E.typography.font200), {}, {
    position: "relative",
    display: "block",
    color: E.colors.menuFontDisabled,
    textAlign: "center",
    cursor: "not-allowed",
    backgroundColor: "transparent",
    marginBottom: 0,
    paddingTop: E.sizing.scale800,
    paddingBottom: E.sizing.scale800,
    paddingRight: E.sizing.scale800,
    paddingLeft: E.sizing.scale800
  });
});
StyledEmptyState.displayName = "StyledEmptyState";
StyledEmptyState.displayName = "StyledEmptyState";
var StyledOptgroupHeader = styled("li", function(o) {
  var E = o.$theme.sizing.scale300, A = o.$theme.sizing.scale200;
  return _objectSpread$a(_objectSpread$a({}, o.$theme.typography.font250), {}, {
    color: o.$theme.colors.contentPrimary,
    paddingTop: A,
    paddingBottom: A,
    paddingRight: E,
    paddingLeft: E
  });
});
StyledOptgroupHeader.displayName = "StyledOptgroupHeader";
StyledOptgroupHeader.displayName = "StyledOptgroupHeader";
var StyledListItemAnchor = styled("a", function(o) {
  return {
    display: "block",
    color: getFontColor(o)
  };
});
StyledListItemAnchor.displayName = "StyledListItemAnchor";
StyledListItemAnchor.displayName = "StyledListItemAnchor";
var StyledListItemElement = styled("li", function(o) {
  var E = o.$disabled, A = o.$theme, g = o.$size;
  return _objectSpread$a(_objectSpread$a({}, g === OPTION_LIST_SIZE.compact ? A.typography.font100 : A.typography.font200), {}, {
    boxSizing: "border-box",
    position: "relative",
    display: "block",
    color: getFontColor(o),
    cursor: E ? "not-allowed" : "pointer",
    backgroundColor: getBackgroundColor(o),
    transitionProperty: "color, background-color",
    transitionDuration: A.animation.timing200,
    transitionTimingFunction: A.animation.easeOutCurve,
    marginBottom: 0,
    paddingTop: g === OPTION_LIST_SIZE.compact ? A.sizing.scale100 : A.sizing.scale300,
    paddingBottom: g === OPTION_LIST_SIZE.compact ? A.sizing.scale100 : A.sizing.scale300,
    paddingRight: g === OPTION_LIST_SIZE.compact ? A.sizing.scale900 : A.sizing.scale600,
    paddingLeft: g === OPTION_LIST_SIZE.compact ? A.sizing.scale900 : A.sizing.scale600,
    ":focus": {
      outline: "none"
    }
  });
});
StyledListItemElement.displayName = "StyledListItemElement";
StyledListItemElement.displayName = "StyledListItemElement";
var StyledListItem = withWrapper(StyledListItemElement, function(o) {
  return (
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    (function(A) {
      A.item;
      var g = _objectWithoutProperties$c(A, _excluded$e);
      return /* @__PURE__ */ React.createElement(o, g);
    })
  );
}), StyledListItemProfile = styled("li", function(o) {
  var E = o.$theme;
  return {
    position: "relative",
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    paddingTop: E.sizing.scale300,
    paddingBottom: E.sizing.scale300,
    paddingRight: E.sizing.scale800,
    paddingLeft: E.sizing.scale800,
    transitionProperty: "color, background-color",
    transitionDuration: E.animation.timing200,
    transitionTimingFunction: E.animation.easeOutCurve,
    ":hover": {
      backgroundColor: E.colors.menuFillHover
    }
  };
});
StyledListItemProfile.displayName = "StyledListItemProfile";
StyledListItemProfile.displayName = "StyledListItemProfile";
var StyledProfileImgContainer = styled("div", {
  width: "60px",
  height: "60px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center"
});
StyledProfileImgContainer.displayName = "StyledProfileImgContainer";
StyledProfileImgContainer.displayName = "StyledProfileImgContainer";
var StyledProfileImg = styled("img", {
  width: "100%",
  height: "100%",
  borderTopLeftRadius: "50%",
  borderTopRightRadius: "50%",
  borderBottomRightRadius: "50%",
  borderBottomLeftRadius: "50%"
});
StyledProfileImg.displayName = "StyledProfileImg";
StyledProfileImg.displayName = "StyledProfileImg";
var StyledProfileLabelsContainer = styled("div", function(o) {
  var E = o.$theme, A = E.direction, g = E.sizing;
  return _objectSpread$a({
    alignSelf: A === "rtl" ? "flex-end" : "flex-start",
    display: "flex",
    flexDirection: "column"
  }, A === "rtl" ? {
    marginRight: g.scale600
  } : {
    marginLeft: g.scale600
  });
});
StyledProfileLabelsContainer.displayName = "StyledProfileLabelsContainer";
StyledProfileLabelsContainer.displayName = "StyledProfileLabelsContainer";
var StyledProfileTitle = styled("h6", function(o) {
  var E = o.$theme;
  return _objectSpread$a(_objectSpread$a({}, E.typography.font350), {}, {
    color: E.colors.contentPrimary,
    marginTop: 0,
    marginBottom: 0,
    marginLeft: 0,
    marginRight: 0
  });
});
StyledProfileTitle.displayName = "StyledProfileTitle";
StyledProfileTitle.displayName = "StyledProfileTitle";
var StyledProfileSubtitle = styled("p", function(o) {
  var E = o.$theme;
  return _objectSpread$a(_objectSpread$a({}, E.typography.font200), {}, {
    color: E.colors.contentPrimary,
    marginTop: 0,
    marginBottom: 0,
    marginLeft: 0,
    marginRight: 0
  });
});
StyledProfileSubtitle.displayName = "StyledProfileSubtitle";
StyledProfileSubtitle.displayName = "StyledProfileSubtitle";
var StyledProfileBody = styled("p", function(o) {
  var E = o.$theme;
  return _objectSpread$a(_objectSpread$a({}, E.typography.font100), {}, {
    color: E.colors.contentPrimary,
    marginTop: 0,
    marginBottom: 0,
    marginLeft: 0,
    marginRight: 0
  });
});
StyledProfileBody.displayName = "StyledProfileBody";
StyledProfileBody.displayName = "StyledProfileBody";
var StyledMenuDivider$1 = styled("li", function(o) {
  var E = o.$theme;
  return {
    color: E.colors.contentPrimary,
    borderBottomWidth: E.borders.border300.borderWidth,
    borderBottomStyle: E.borders.border300.borderStyle,
    borderBottomColor: E.borders.border300.borderColor,
    marginTop: E.sizing.scale100,
    marginBottom: E.sizing.scale100,
    marginLeft: E.sizing.scale500,
    marginRight: E.sizing.scale500,
    listStyle: "none",
    height: 0
  };
});
StyledMenuDivider$1.displayName = "StyledMenuDivider";
StyledProfileBody.displayName = "StyledMenuDivider";
var NestedMenuContext = /* @__PURE__ */ React.createContext({
  addMenuToNesting: function o() {
  },
  removeMenuFromNesting: function o() {
  },
  // @ts-expect-error todo(flow->ts): incorrect default value
  getParentMenu: function o() {
  },
  // @ts-expect-error todo(flow->ts): incorrect default value
  getChildMenu: function o() {
  },
  nestedMenuHoverIndex: -1,
  isNestedMenuVisible: function o() {
    return !1;
  },
  mountRef: {
    current: null
  }
});
function _extends$e() {
  return _extends$e = Object.assign ? Object.assign.bind() : function(o) {
    for (var E = 1; E < arguments.length; E++) {
      var A = arguments[E];
      for (var g in A)
        Object.prototype.hasOwnProperty.call(A, g) && (o[g] = A[g]);
    }
    return o;
  }, _extends$e.apply(this, arguments);
}
function _slicedToArray$a(o, E) {
  return _arrayWithHoles$9(o) || _iterableToArrayLimit$9(o, E) || _unsupportedIterableToArray$9(o, E) || _nonIterableRest$9();
}
function _nonIterableRest$9() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$9(o, E) {
  if (o) {
    if (typeof o == "string") return _arrayLikeToArray$9(o, E);
    var A = Object.prototype.toString.call(o).slice(8, -1);
    if (A === "Object" && o.constructor && (A = o.constructor.name), A === "Map" || A === "Set") return Array.from(o);
    if (A === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(A)) return _arrayLikeToArray$9(o, E);
  }
}
function _arrayLikeToArray$9(o, E) {
  (E == null || E > o.length) && (E = o.length);
  for (var A = 0, g = new Array(E); A < E; A++)
    g[A] = o[A];
  return g;
}
function _iterableToArrayLimit$9(o, E) {
  var A = o == null ? null : typeof Symbol < "u" && o[Symbol.iterator] || o["@@iterator"];
  if (A != null) {
    var g = [], e = !0, t = !1, c, n;
    try {
      for (A = A.call(o); !(e = (c = A.next()).done) && (g.push(c.value), !(E && g.length === E)); e = !0)
        ;
    } catch (h) {
      t = !0, n = h;
    } finally {
      try {
        !e && A.return != null && A.return();
      } finally {
        if (t) throw n;
      }
    }
    return g;
  }
}
function _arrayWithHoles$9(o) {
  if (Array.isArray(o)) return o;
}
var MaybeChildMenu = function o(E) {
  if (!E.getChildMenu)
    return E.children;
  var A = E.getChildMenu(E.item);
  if (!A)
    return E.children;
  var g = E.overrides, e = g === void 0 ? {} : g, t = getOverrides(e.ChildMenuPopover, Popover$2), c = _slicedToArray$a(t, 2), n = c[0], h = c[1];
  return /* @__PURE__ */ React.createElement(NestedMenuContext.Consumer, null, function(d) {
    return /* @__PURE__ */ React.createElement(n, _extends$e({
      focusLock: !1,
      autoFocus: !1,
      isOpen: E.isOpen,
      renderAll: E.renderAll,
      content: A,
      ignoreBoundary: !0,
      mountNode: d.mountRef.current ? d.mountRef.current : void 0,
      onClick: E.onClick,
      onMouseEnterDelay: 30,
      onMouseLeaveDelay: 30,
      onEsc: E.resetParentMenu,
      placement: "rightTop"
    }, h, {
      overrides: mergeOverrides({
        Body: {
          props: {
            // Trap tabbing when focused on a child menu. Popover mounts the element at the end of
            // the html body by default. If a user was to tab to the next element it would navigate
            // to elements not within the immediate area surrounding the menu.
            onKeyDown: function(p) {
              p.keyCode === 9 && p.preventDefault();
            }
          }
        }
      }, h.overrides)
    }), E.children);
  });
}, _excluded$d = ["getChildMenu", "getItemLabel", "item", "onClick", "onMouseEnter", "overrides", "renderHrefAsAnchor", "resetMenu", "size", "$isHighlighted", "renderAll"];
function ownKeys$b(o, E) {
  var A = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var g = Object.getOwnPropertySymbols(o);
    E && (g = g.filter(function(e) {
      return Object.getOwnPropertyDescriptor(o, e).enumerable;
    })), A.push.apply(A, g);
  }
  return A;
}
function _objectSpread$9(o) {
  for (var E = 1; E < arguments.length; E++) {
    var A = arguments[E] != null ? arguments[E] : {};
    E % 2 ? ownKeys$b(Object(A), !0).forEach(function(g) {
      _defineProperty$c(o, g, A[g]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(A)) : ownKeys$b(Object(A)).forEach(function(g) {
      Object.defineProperty(o, g, Object.getOwnPropertyDescriptor(A, g));
    });
  }
  return o;
}
function _defineProperty$c(o, E, A) {
  return E in o ? Object.defineProperty(o, E, { value: A, enumerable: !0, configurable: !0, writable: !0 }) : o[E] = A, o;
}
function _extends$d() {
  return _extends$d = Object.assign ? Object.assign.bind() : function(o) {
    for (var E = 1; E < arguments.length; E++) {
      var A = arguments[E];
      for (var g in A)
        Object.prototype.hasOwnProperty.call(A, g) && (o[g] = A[g]);
    }
    return o;
  }, _extends$d.apply(this, arguments);
}
function _slicedToArray$9(o, E) {
  return _arrayWithHoles$8(o) || _iterableToArrayLimit$8(o, E) || _unsupportedIterableToArray$8(o, E) || _nonIterableRest$8();
}
function _nonIterableRest$8() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$8(o, E) {
  if (o) {
    if (typeof o == "string") return _arrayLikeToArray$8(o, E);
    var A = Object.prototype.toString.call(o).slice(8, -1);
    if (A === "Object" && o.constructor && (A = o.constructor.name), A === "Map" || A === "Set") return Array.from(o);
    if (A === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(A)) return _arrayLikeToArray$8(o, E);
  }
}
function _arrayLikeToArray$8(o, E) {
  (E == null || E > o.length) && (E = o.length);
  for (var A = 0, g = new Array(E); A < E; A++)
    g[A] = o[A];
  return g;
}
function _iterableToArrayLimit$8(o, E) {
  var A = o == null ? null : typeof Symbol < "u" && o[Symbol.iterator] || o["@@iterator"];
  if (A != null) {
    var g = [], e = !0, t = !1, c, n;
    try {
      for (A = A.call(o); !(e = (c = A.next()).done) && (g.push(c.value), !(E && g.length === E)); e = !0)
        ;
    } catch (h) {
      t = !0, n = h;
    } finally {
      try {
        !e && A.return != null && A.return();
      } finally {
        if (t) throw n;
      }
    }
    return g;
  }
}
function _arrayWithHoles$8(o) {
  if (Array.isArray(o)) return o;
}
function _objectWithoutProperties$b(o, E) {
  if (o == null) return {};
  var A = _objectWithoutPropertiesLoose$a(o, E), g, e;
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    for (e = 0; e < t.length; e++)
      g = t[e], !(E.indexOf(g) >= 0) && Object.prototype.propertyIsEnumerable.call(o, g) && (A[g] = o[g]);
  }
  return A;
}
function _objectWithoutPropertiesLoose$a(o, E) {
  if (o == null) return {};
  var A = {}, g = Object.keys(o), e, t;
  for (t = 0; t < g.length; t++)
    e = g[t], !(E.indexOf(e) >= 0) && (A[e] = o[e]);
  return A;
}
function OptionList(o, E) {
  var A = o.getChildMenu, g = o.getItemLabel, e = g === void 0 ? function(wA) {
    return wA ? wA.label : "";
  } : g, t = o.item, c = o.onClick, n = c === void 0 ? function() {
  } : c, h = o.onMouseEnter, d = h === void 0 ? function() {
  } : h, k = o.overrides, p = k === void 0 ? {} : k, M = o.renderHrefAsAnchor, S = M === void 0 ? !0 : M, AA = o.resetMenu, H = AA === void 0 ? function() {
  } : AA, gA = o.size, CA = gA === void 0 ? OPTION_LIST_SIZE.default : gA, IA = o.$isHighlighted, BA = o.renderAll, QA = _objectWithoutProperties$b(o, _excluded$d), EA = getOverrides(p.ListItem, StyledListItem), oA = _slicedToArray$9(EA, 2), iA = oA[0], aA = oA[1], tA = getOverrides(p.ListItemAnchor, StyledListItemAnchor), eA = _slicedToArray$9(tA, 2), cA = eA[0], DA = eA[1], nA = function(lA) {
    return lA.href && S ? /* @__PURE__ */ React.createElement(cA, _extends$d({
      $item: lA,
      href: lA.href
    }, DA), e(lA)) : /* @__PURE__ */ React.createElement(React.Fragment, null, e(lA));
  };
  return /* @__PURE__ */ React.createElement(LocaleContext.Consumer, null, function(wA) {
    return /* @__PURE__ */ React.createElement(MaybeChildMenu, {
      getChildMenu: A,
      isOpen: !!IA,
      item: t,
      resetParentMenu: H,
      renderAll: BA,
      onClick: n,
      overrides: p
    }, /* @__PURE__ */ React.createElement(iA, _extends$d({
      ref: E,
      "aria-label": A && A(t) ? wA.menu.parentMenuItemAriaLabel : null,
      item: t,
      onClick: n,
      onMouseEnter: d,
      $size: CA,
      $isHighlighted: IA
    }, QA, aA), nA(_objectSpread$9({
      isHighlighted: IA
    }, t))));
  });
}
function areEqualShallow(o, E) {
  if (!o || !E) return !1;
  for (var A in o)
    if (o[A] !== E[A])
      return !1;
  return !0;
}
function compare(o, E) {
  return o.$isHighlighted === E.$isHighlighted && o.$isFocused === E.$isFocused && areEqualShallow(o.item, E.item) && areEqualShallow(o.overrides, E.overrides) && o.size === E.size && o.getItemLabel === E.getItemLabel && o.getChildMenu === E.getChildMenu && o.resetMenu === E.resetMenu;
}
var forwarded = /* @__PURE__ */ React.forwardRef(OptionList);
forwarded.displayName = "OptionList";
const OptionList$1 = /* @__PURE__ */ React.memo(forwarded, compare);
var _excluded$c = ["disabled", "isFocused", "isHighlighted", "resetMenu"];
function _objectWithoutProperties$a(o, E) {
  if (o == null) return {};
  var A = _objectWithoutPropertiesLoose$9(o, E), g, e;
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    for (e = 0; e < t.length; e++)
      g = t[e], !(E.indexOf(g) >= 0) && Object.prototype.propertyIsEnumerable.call(o, g) && (A[g] = o[g]);
  }
  return A;
}
function _objectWithoutPropertiesLoose$9(o, E) {
  if (o == null) return {};
  var A = {}, g = Object.keys(o), e, t;
  for (t = 0; t < g.length; t++)
    e = g[t], !(E.indexOf(e) >= 0) && (A[e] = o[e]);
  return A;
}
function _extends$c() {
  return _extends$c = Object.assign ? Object.assign.bind() : function(o) {
    for (var E = 1; E < arguments.length; E++) {
      var A = arguments[E];
      for (var g in A)
        Object.prototype.hasOwnProperty.call(A, g) && (o[g] = A[g]);
    }
    return o;
  }, _extends$c.apply(this, arguments);
}
function _slicedToArray$8(o, E) {
  return _arrayWithHoles$7(o) || _iterableToArrayLimit$7(o, E) || _unsupportedIterableToArray$7(o, E) || _nonIterableRest$7();
}
function _nonIterableRest$7() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$7(o, E) {
  if (o) {
    if (typeof o == "string") return _arrayLikeToArray$7(o, E);
    var A = Object.prototype.toString.call(o).slice(8, -1);
    if (A === "Object" && o.constructor && (A = o.constructor.name), A === "Map" || A === "Set") return Array.from(o);
    if (A === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(A)) return _arrayLikeToArray$7(o, E);
  }
}
function _arrayLikeToArray$7(o, E) {
  (E == null || E > o.length) && (E = o.length);
  for (var A = 0, g = new Array(E); A < E; A++)
    g[A] = o[A];
  return g;
}
function _iterableToArrayLimit$7(o, E) {
  var A = o == null ? null : typeof Symbol < "u" && o[Symbol.iterator] || o["@@iterator"];
  if (A != null) {
    var g = [], e = !0, t = !1, c, n;
    try {
      for (A = A.call(o); !(e = (c = A.next()).done) && (g.push(c.value), !(E && g.length === E)); e = !0)
        ;
    } catch (h) {
      t = !0, n = h;
    } finally {
      try {
        !e && A.return != null && A.return();
      } finally {
        if (t) throw n;
      }
    }
    return g;
  }
}
function _arrayWithHoles$7(o) {
  if (Array.isArray(o)) return o;
}
function Menu(o) {
  var E = o.overrides, A = E === void 0 ? {} : E, g = o["aria-label"], e = g === void 0 ? "Menu" : g, t = o.rootRef, c = t === void 0 ? /* @__PURE__ */ React.createRef() : t, n = o.focusMenu, h = n === void 0 ? function() {
  } : n, d = o.unfocusMenu, k = d === void 0 ? function() {
  } : d, p = o.handleMouseLeave, M = p === void 0 ? function() {
  } : p, S = o.handleKeyDown, AA = S === void 0 ? function(Ag) {
  } : S, H = o.renderAll, gA = H === void 0 ? !1 : H, CA = React.useState(!1), IA = _slicedToArray$8(CA, 2), BA = IA[0], QA = IA[1], EA = function(UA) {
    isFocusVisible(UA) && QA(!0);
  }, oA = function(UA) {
    BA !== !1 && QA(!1);
  }, iA = getOverrides(A.List, StyledList), aA = _slicedToArray$8(iA, 2), tA = aA[0], eA = aA[1], cA = getOverrides(A.Option, OptionList$1), DA = _slicedToArray$8(cA, 2), nA = DA[0], wA = DA[1], lA = getOverrides(A.EmptyState, StyledEmptyState), NA = _slicedToArray$8(lA, 2), RA = NA[0], KA = NA[1], vA = getOverrides(A.OptgroupHeader, StyledOptgroupHeader), GA = _slicedToArray$8(vA, 2), FA = GA[0], HA = GA[1], sA = getOverrides(A.MenuDivider, StyledMenuDivider$1), mA = _slicedToArray$8(sA, 2), xA = mA[0], hA = mA[1], MA = Array.isArray(o.items) ? {
    __ungrouped: o.items
  } : o.items, YA = Object.keys(MA), LA = YA.reduce(function(Ag, UA) {
    var ig = _slicedToArray$8(Ag, 2), og = ig[0], PA = ig[1];
    UA !== "__ungrouped" && og.push(/* @__PURE__ */ React.createElement(FA, _extends$c({
      key: UA
    }, HA), UA));
    var Gg = MA[UA].map(function(gg, eg) {
      PA = PA + 1;
      var Dg = o.getRequiredItemProps, rg = Dg === void 0 ? function(OA, VA) {
        return {};
      } : Dg;
      if (gg.divider === !0)
        return /* @__PURE__ */ React.createElement(xA, hA);
      var cg = rg(gg, PA), hg = cg.disabled, Cg = cg.isFocused, dA = cg.isHighlighted, pA = cg.resetMenu, XA = pA === void 0 ? function() {
      } : pA, jA = _objectWithoutProperties$a(cg, _excluded$c);
      return /* @__PURE__ */ React.createElement(nA, _extends$c({
        renderAll: gA,
        key: PA,
        item: gg,
        overrides: o.overrides,
        resetMenu: XA,
        role: "option",
        $disabled: hg,
        $isFocused: Cg,
        $isHighlighted: dA,
        "aria-disabled": hg,
        "aria-selected": dA && Cg
      }, jA, wA));
    });
    return [og.concat(Gg), PA];
  }, [[], -1]), WA = _slicedToArray$8(LA, 1), zA = WA[0], ZA = YA.every(function(Ag) {
    return !MA[Ag].length;
  });
  return /* @__PURE__ */ React.createElement(LocaleContext.Consumer, null, function(Ag) {
    return /* @__PURE__ */ React.createElement(tA, _extends$c({
      "aria-activedescendant": o.activedescendantId || null,
      role: "listbox",
      "aria-label": e,
      ref: c,
      onMouseEnter: h,
      onMouseLeave: M,
      onMouseOver: h,
      onFocus: forkFocus({
        onFocus: h
      }, EA),
      onBlur: forkBlur({
        onBlur: k
      }, oA),
      onKeyDown: function(ig) {
        o.isFocused && AA(ig);
      },
      tabIndex: 0,
      "data-baseweb": "menu",
      $isFocusVisible: BA
    }, eA), ZA ? /* @__PURE__ */ React.createElement(RA, _extends$c({
      "aria-live": "polite",
      "aria-atomic": !0
    }, KA), o.noResultsMsg || Ag.menu.noResultsMsg) : zA);
  });
}
function scrollItemIntoView(o, E, A, g) {
  var e = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "auto";
  if (o) {
    var t = o.getBoundingClientRect(), c = E.getBoundingClientRect();
    if (t.bottom > c.bottom)
      if (g)
        E.scrollTop = E.scrollHeight - c.height;
      else {
        var n = o.offsetTop + t.height;
        E.scrollTop = n - (e === "center" ? Math.round((c.height + t.height) / 2) : c.height);
      }
    else t.top < c.top && (A ? E.scrollTop = 0 : E.scrollTop = o.offsetTop - (e === "center" ? Math.round((c.height - t.height) / 2) : 0));
  }
}
function _typeof$7(o) {
  "@babel/helpers - typeof";
  return _typeof$7 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(E) {
    return typeof E;
  } : function(E) {
    return E && typeof Symbol == "function" && E.constructor === Symbol && E !== Symbol.prototype ? "symbol" : typeof E;
  }, _typeof$7(o);
}
var _excluded$b = ["disabled"], _excluded2$3 = ["initialState", "stateReducer", "children", "onItemSelect", "addMenuToNesting", "removeMenuFromNesting", "getParentMenu", "getChildMenu", "forceHighlight"];
function _extends$b() {
  return _extends$b = Object.assign ? Object.assign.bind() : function(o) {
    for (var E = 1; E < arguments.length; E++) {
      var A = arguments[E];
      for (var g in A)
        Object.prototype.hasOwnProperty.call(A, g) && (o[g] = A[g]);
    }
    return o;
  }, _extends$b.apply(this, arguments);
}
function _objectWithoutProperties$9(o, E) {
  if (o == null) return {};
  var A = _objectWithoutPropertiesLoose$8(o, E), g, e;
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    for (e = 0; e < t.length; e++)
      g = t[e], !(E.indexOf(g) >= 0) && Object.prototype.propertyIsEnumerable.call(o, g) && (A[g] = o[g]);
  }
  return A;
}
function _objectWithoutPropertiesLoose$8(o, E) {
  if (o == null) return {};
  var A = {}, g = Object.keys(o), e, t;
  for (t = 0; t < g.length; t++)
    e = g[t], !(E.indexOf(e) >= 0) && (A[e] = o[e]);
  return A;
}
function ownKeys$a(o, E) {
  var A = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var g = Object.getOwnPropertySymbols(o);
    E && (g = g.filter(function(e) {
      return Object.getOwnPropertyDescriptor(o, e).enumerable;
    })), A.push.apply(A, g);
  }
  return A;
}
function _objectSpread$8(o) {
  for (var E = 1; E < arguments.length; E++) {
    var A = arguments[E] != null ? arguments[E] : {};
    E % 2 ? ownKeys$a(Object(A), !0).forEach(function(g) {
      _defineProperty$b(o, g, A[g]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(A)) : ownKeys$a(Object(A)).forEach(function(g) {
      Object.defineProperty(o, g, Object.getOwnPropertyDescriptor(A, g));
    });
  }
  return o;
}
function _classCallCheck$5(o, E) {
  if (!(o instanceof E))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$5(o, E) {
  for (var A = 0; A < E.length; A++) {
    var g = E[A];
    g.enumerable = g.enumerable || !1, g.configurable = !0, "value" in g && (g.writable = !0), Object.defineProperty(o, g.key, g);
  }
}
function _createClass$5(o, E, A) {
  return E && _defineProperties$5(o.prototype, E), Object.defineProperty(o, "prototype", { writable: !1 }), o;
}
function _inherits$5(o, E) {
  if (typeof E != "function" && E !== null)
    throw new TypeError("Super expression must either be null or a function");
  o.prototype = Object.create(E && E.prototype, { constructor: { value: o, writable: !0, configurable: !0 } }), Object.defineProperty(o, "prototype", { writable: !1 }), E && _setPrototypeOf$5(o, E);
}
function _setPrototypeOf$5(o, E) {
  return _setPrototypeOf$5 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(g, e) {
    return g.__proto__ = e, g;
  }, _setPrototypeOf$5(o, E);
}
function _createSuper$5(o) {
  var E = _isNativeReflectConstruct$5();
  return function() {
    var g = _getPrototypeOf$5(o), e;
    if (E) {
      var t = _getPrototypeOf$5(this).constructor;
      e = Reflect.construct(g, arguments, t);
    } else
      e = g.apply(this, arguments);
    return _possibleConstructorReturn$5(this, e);
  };
}
function _possibleConstructorReturn$5(o, E) {
  if (E && (_typeof$7(E) === "object" || typeof E == "function"))
    return E;
  if (E !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$6(o);
}
function _assertThisInitialized$6(o) {
  if (o === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return o;
}
function _isNativeReflectConstruct$5() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function _getPrototypeOf$5(o) {
  return _getPrototypeOf$5 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(A) {
    return A.__proto__ || Object.getPrototypeOf(A);
  }, _getPrototypeOf$5(o);
}
function _defineProperty$b(o, E, A) {
  return E in o ? Object.defineProperty(o, E, { value: A, enumerable: !0, configurable: !0, writable: !0 }) : o[E] = A, o;
}
var DEFAULT_PROPS = {
  // keeping it in defaultProps to satisfy Flow
  initialState: {
    // We start the index at -1 to indicate that no highlighting exists initially
    highlightedIndex: -1,
    isFocused: !1
  },
  typeAhead: !0,
  keyboardControlNode: {
    current: null
  },
  stateReducer: function(o, E) {
    return E;
  },
  onItemSelect: function o() {
  },
  getRequiredItemProps: function o() {
    return {};
  },
  children: function o() {
    return null;
  },
  // from nested-menus context
  addMenuToNesting: function o() {
  },
  removeMenuFromNesting: function o() {
  },
  getParentMenu: function o() {
  },
  getChildMenu: function o() {
  },
  nestedMenuHoverIndex: -1,
  isNestedMenuVisible: function o() {
    return !1;
  },
  forceHighlight: !1
}, MenuStatefulContainerInner = /* @__PURE__ */ (function(o) {
  _inherits$5(A, o);
  var E = _createSuper$5(A);
  function A() {
    var g;
    _classCallCheck$5(this, A);
    for (var e = arguments.length, t = new Array(e), c = 0; c < e; c++)
      t[c] = arguments[c];
    return g = E.call.apply(E, [this].concat(t)), _defineProperty$b(_assertThisInitialized$6(g), "state", _objectSpread$8(_objectSpread$8({}, g.constructor.defaultProps.initialState), g.props.initialState)), _defineProperty$b(_assertThisInitialized$6(g), "rootRef", /* @__PURE__ */ React.createRef()), _defineProperty$b(_assertThisInitialized$6(g), "keyboardControlNode", g.props.keyboardControlNode.current), _defineProperty$b(_assertThisInitialized$6(g), "refList", []), _defineProperty$b(_assertThisInitialized$6(g), "optionIds", []), _defineProperty$b(_assertThisInitialized$6(g), "typeAheadChars", ""), _defineProperty$b(_assertThisInitialized$6(g), "typeAheadTimeOut", null), _defineProperty$b(_assertThisInitialized$6(g), "onKeyDown", function(n) {
      switch (n.key) {
        case KEY_STRINGS.ArrowUp:
        case KEY_STRINGS.ArrowDown:
        case KEY_STRINGS.ArrowLeft:
        case KEY_STRINGS.ArrowRight:
        case KEY_STRINGS.Home:
        case KEY_STRINGS.End:
          g.handleArrowKey(n);
          break;
        case KEY_STRINGS.Enter:
          if (n.keyCode === 229)
            break;
          g.handleEnterKey(n);
          break;
        default:
          g.props.typeAhead && (clearTimeout(g.typeAheadTimeOut), g.handleAlphaDown(n));
          break;
      }
    }), _defineProperty$b(_assertThisInitialized$6(g), "handleAlphaDown", function(n) {
      var h = g.props.rootRef ? g.props.rootRef : g.rootRef, d = g.state.highlightedIndex;
      g.typeAheadChars += n.key, g.typeAheadTimeOut = setTimeout(function() {
        g.typeAheadChars = "";
      }, 500);
      var k = d, p = g.getItems();
      if (!(p.length === 0 || !("label" in p[0]))) {
        for (var M = !0, S = 0; S < p.length; S++) {
          var AA = p[S].label;
          if (AA && AA.toUpperCase && AA.toUpperCase().indexOf(g.typeAheadChars.toUpperCase()) === 0) {
            k = S, M = !1;
            break;
          }
        }
        if (M)
          for (var H = 0; H < p.length; H++) {
            var gA = p[H].label;
            if (gA && gA.toUpperCase && gA.toUpperCase().indexOf(g.typeAheadChars.toUpperCase()) > 0) {
              k = H;
              break;
            }
          }
        g.internalSetState(STATE_CHANGE_TYPES.character, {
          highlightedIndex: k
        }), g.refList[k] && scrollItemIntoView(g.refList[k].current, h.current, k === 0, k === p.length - 1);
      }
    }), _defineProperty$b(_assertThisInitialized$6(g), "handleArrowKey", function(n) {
      var h = g.props.rootRef ? g.props.rootRef : g.rootRef, d = g.state.highlightedIndex, k = d;
      if (n.key === KEY_STRINGS.ArrowUp)
        n.preventDefault(), k = Math.max(0, d - 1), g.internalSetState(STATE_CHANGE_TYPES.moveUp, {
          highlightedIndex: k
        });
      else if (n.key === KEY_STRINGS.ArrowDown)
        n.preventDefault(), k = Math.min(d + 1, g.getItems().length - 1), g.internalSetState(STATE_CHANGE_TYPES.moveDown, {
          highlightedIndex: k
        });
      else if (n.key === KEY_STRINGS.Home)
        n.preventDefault(), k = 0, g.internalSetState(STATE_CHANGE_TYPES.moveUp, {
          highlightedIndex: k
        });
      else if (n.key === KEY_STRINGS.End)
        n.preventDefault(), k = g.getItems().length - 1, g.internalSetState(STATE_CHANGE_TYPES.moveDown, {
          highlightedIndex: k
        });
      else if (n.key === KEY_STRINGS.ArrowLeft) {
        if (g.props.getParentMenu) {
          var p = g.props.getParentMenu(h);
          p && p.current && p.current.focus();
        }
      } else if (n.key === KEY_STRINGS.ArrowRight && g.props.getChildMenu) {
        var M = g.props.getChildMenu(h);
        M && M.current && M.current.focus();
      }
      g.refList[k] && scrollItemIntoView(g.refList[k].current, h.current, k === 0, k === g.getItems().length - 1);
    }), _defineProperty$b(_assertThisInitialized$6(g), "handleEnterKey", function(n) {
      var h = g.props.onItemSelect, d = g.state.highlightedIndex, k = g.getItems();
      k[d] && h && !k[d].disabled && (n.preventDefault(), h({
        item: k[d],
        event: n
      }));
    }), _defineProperty$b(_assertThisInitialized$6(g), "handleItemClick", function(n, h, d) {
      g.props.onItemSelect && !h.disabled && (g.props.onItemSelect({
        item: h,
        event: d
      }), g.internalSetState(STATE_CHANGE_TYPES.click, {
        highlightedIndex: n,
        activedescendantId: g.optionIds[n]
      }));
    }), _defineProperty$b(_assertThisInitialized$6(g), "handleMouseEnter", function(n) {
      g.internalSetState(STATE_CHANGE_TYPES.mouseEnter, {
        highlightedIndex: n,
        activedescendantId: g.optionIds[n]
      });
    }), _defineProperty$b(_assertThisInitialized$6(g), "handleMouseLeave", function(n) {
    }), _defineProperty$b(_assertThisInitialized$6(g), "getRequiredItemProps", function(n, h) {
      var d = g.refList[h];
      d || (d = /* @__PURE__ */ React.createRef(), g.refList[h] = d, g.optionIds[h] = g.props.uidSeed(h));
      var k = g.props.getRequiredItemProps(n, h), p = k.disabled, M = _objectWithoutProperties$9(k, _excluded$b), S = typeof p == "boolean" ? p : !!n.disabled;
      return _objectSpread$8(_objectSpread$8({
        id: M.id || g.optionIds[h],
        disabled: S,
        ref: d,
        isFocused: g.state.isFocused,
        isHighlighted: g.state.highlightedIndex === h,
        resetMenu: g.resetMenu
      }, S ? {} : {
        onClick: g.handleItemClick.bind(_assertThisInitialized$6(g), h, n),
        onMouseEnter: g.handleMouseEnter.bind(_assertThisInitialized$6(g), h)
      }), M);
    }), _defineProperty$b(_assertThisInitialized$6(g), "focusMenu", function(n) {
      var h = g.props.rootRef ? g.props.rootRef : g.rootRef;
      !g.state.isFocused && h.current && // @ts-expect-error
      h.current.contains(n.target) && (g.state.highlightedIndex < 0 ? g.internalSetState(STATE_CHANGE_TYPES.focus, {
        isFocused: !0,
        highlightedIndex: 0
      }) : g.internalSetState(STATE_CHANGE_TYPES.focus, {
        isFocused: !0
      }), h.current.focus());
    }), _defineProperty$b(_assertThisInitialized$6(g), "unfocusMenu", function() {
      g.internalSetState(STATE_CHANGE_TYPES.focus, {
        isFocused: !1
      });
    }), _defineProperty$b(_assertThisInitialized$6(g), "resetMenu", function() {
      g.internalSetState(STATE_CHANGE_TYPES.reset, {
        isFocused: !1,
        highlightedIndex: -1,
        activedescendantId: null
      });
    }), g;
  }
  return _createClass$5(A, [{
    key: "getItems",
    value: function() {
      var e = this;
      if (Array.isArray(this.props.items))
        return this.props.items;
      var t = Object.keys(this.props.items);
      return t.reduce(function(c, n) {
        return c.concat(e.props.items[n]);
      }, []);
    }
  }, {
    key: "componentDidMount",
    value: function() {
      var e = this.props.rootRef ? this.props.rootRef : this.rootRef;
      typeof document < "u" && (e.current && this.state.highlightedIndex > -1 && this.refList[this.state.highlightedIndex] && scrollItemIntoView(this.refList[this.state.highlightedIndex].current, e.current, this.state.highlightedIndex === 0, this.state.highlightedIndex === this.getItems().length - 1, "center"), this.state.isFocused && this.keyboardControlNode && this.keyboardControlNode.addEventListener("keydown", this.onKeyDown)), this.props.addMenuToNesting && this.props.addMenuToNesting(e);
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      var e = this.props.rootRef ? this.props.rootRef : this.rootRef;
      typeof document < "u" && this.keyboardControlNode && this.keyboardControlNode.removeEventListener("keydown", this.onKeyDown), this.props.removeMenuFromNesting && this.props.removeMenuFromNesting(e);
    }
  }, {
    key: "componentDidUpdate",
    value: function(e, t) {
      typeof document < "u" && (!t.isFocused && this.state.isFocused ? this.keyboardControlNode && this.keyboardControlNode.addEventListener("keydown", this.onKeyDown) : t.isFocused && !this.state.isFocused && this.keyboardControlNode && this.keyboardControlNode.removeEventListener("keydown", this.onKeyDown));
      var c = this.getItems().length;
      this.props.forceHighlight && this.state.highlightedIndex === -1 && c > 0 && this.internalSetState(STATE_CHANGE_TYPES.enter, {
        highlightedIndex: 0
      }), c === 0 && this.state.highlightedIndex !== -1 ? this.internalSetState(STATE_CHANGE_TYPES.enter, {
        highlightedIndex: -1
      }) : this.state.highlightedIndex >= c && this.internalSetState(STATE_CHANGE_TYPES.enter, {
        highlightedIndex: 0
      }), this.props.isNestedMenuVisible && this.props.nestedMenuHoverIndex !== e.nestedMenuHoverIndex && !this.props.isNestedMenuVisible(this.rootRef) && !this.props.forceHighlight && this.setState({
        highlightedIndex: -1
      });
    }
    // One array to hold all list item refs
  }, {
    key: "internalSetState",
    value: (
      // Internal set state function that will also invoke stateReducer
      function(e, t) {
        var c = this.props.stateReducer;
        this.props.onActiveDescendantChange && typeof t.highlightedIndex == "number" && this.state.highlightedIndex !== t.highlightedIndex && this.props.onActiveDescendantChange(this.optionIds[t.highlightedIndex]), this.setState(c(e, t, this.state));
      }
    )
  }, {
    key: "render",
    value: function() {
      var e = this, t = this.props;
      t.initialState, t.stateReducer, t.children, t.onItemSelect, t.addMenuToNesting, t.removeMenuFromNesting, t.getParentMenu, t.getChildMenu, t.forceHighlight;
      var c = _objectWithoutProperties$9(t, _excluded2$3);
      return this.props.children(_objectSpread$8(_objectSpread$8({}, c), {}, {
        rootRef: this.props.rootRef ? this.props.rootRef : this.rootRef,
        activedescendantId: this.optionIds[this.state.highlightedIndex],
        getRequiredItemProps: function(h, d) {
          return e.getRequiredItemProps(h, d);
        },
        handleMouseLeave: this.handleMouseLeave,
        highlightedIndex: this.state.highlightedIndex,
        isFocused: this.state.isFocused,
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        handleKeyDown: this.props.keyboardControlNode.current ? function(n) {
        } : this.onKeyDown,
        focusMenu: this.focusMenu,
        unfocusMenu: this.unfocusMenu
      }));
    }
  }]), A;
})(React.Component);
_defineProperty$b(MenuStatefulContainerInner, "defaultProps", DEFAULT_PROPS);
var MenuStatefulContainer = function o(E) {
  return /* @__PURE__ */ React.createElement(MenuStatefulContainerInner, _extends$b({
    uidSeed: useUIDSeed()
  }, E));
};
MenuStatefulContainer.defaultProps = DEFAULT_PROPS;
function _typeof$6(o) {
  "@babel/helpers - typeof";
  return _typeof$6 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(E) {
    return typeof E;
  } : function(E) {
    return E && typeof Symbol == "function" && E.constructor === Symbol && E !== Symbol.prototype ? "symbol" : typeof E;
  }, _typeof$6(o);
}
var _excluded$a = ["overrides"];
function _extends$a() {
  return _extends$a = Object.assign ? Object.assign.bind() : function(o) {
    for (var E = 1; E < arguments.length; E++) {
      var A = arguments[E];
      for (var g in A)
        Object.prototype.hasOwnProperty.call(A, g) && (o[g] = A[g]);
    }
    return o;
  }, _extends$a.apply(this, arguments);
}
function _objectWithoutProperties$8(o, E) {
  if (o == null) return {};
  var A = _objectWithoutPropertiesLoose$7(o, E), g, e;
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    for (e = 0; e < t.length; e++)
      g = t[e], !(E.indexOf(g) >= 0) && Object.prototype.propertyIsEnumerable.call(o, g) && (A[g] = o[g]);
  }
  return A;
}
function _objectWithoutPropertiesLoose$7(o, E) {
  if (o == null) return {};
  var A = {}, g = Object.keys(o), e, t;
  for (t = 0; t < g.length; t++)
    e = g[t], !(E.indexOf(e) >= 0) && (A[e] = o[e]);
  return A;
}
function _classCallCheck$4(o, E) {
  if (!(o instanceof E))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$4(o, E) {
  for (var A = 0; A < E.length; A++) {
    var g = E[A];
    g.enumerable = g.enumerable || !1, g.configurable = !0, "value" in g && (g.writable = !0), Object.defineProperty(o, g.key, g);
  }
}
function _createClass$4(o, E, A) {
  return E && _defineProperties$4(o.prototype, E), Object.defineProperty(o, "prototype", { writable: !1 }), o;
}
function _inherits$4(o, E) {
  if (typeof E != "function" && E !== null)
    throw new TypeError("Super expression must either be null or a function");
  o.prototype = Object.create(E && E.prototype, { constructor: { value: o, writable: !0, configurable: !0 } }), Object.defineProperty(o, "prototype", { writable: !1 }), E && _setPrototypeOf$4(o, E);
}
function _setPrototypeOf$4(o, E) {
  return _setPrototypeOf$4 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(g, e) {
    return g.__proto__ = e, g;
  }, _setPrototypeOf$4(o, E);
}
function _createSuper$4(o) {
  var E = _isNativeReflectConstruct$4();
  return function() {
    var g = _getPrototypeOf$4(o), e;
    if (E) {
      var t = _getPrototypeOf$4(this).constructor;
      e = Reflect.construct(g, arguments, t);
    } else
      e = g.apply(this, arguments);
    return _possibleConstructorReturn$4(this, e);
  };
}
function _possibleConstructorReturn$4(o, E) {
  if (E && (_typeof$6(E) === "object" || typeof E == "function"))
    return E;
  if (E !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$5(o);
}
function _assertThisInitialized$5(o) {
  if (o === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return o;
}
function _isNativeReflectConstruct$4() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function _getPrototypeOf$4(o) {
  return _getPrototypeOf$4 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(A) {
    return A.__proto__ || Object.getPrototypeOf(A);
  }, _getPrototypeOf$4(o);
}
var StatefulMenu = /* @__PURE__ */ (function(o) {
  _inherits$4(A, o);
  var E = _createSuper$4(A);
  function A() {
    return _classCallCheck$4(this, A), E.apply(this, arguments);
  }
  return _createClass$4(A, [{
    key: "render",
    value: function() {
      var e = this.props, t = e.overrides, c = _objectWithoutProperties$8(e, _excluded$a);
      return /* @__PURE__ */ React.createElement(NestedMenuContext.Consumer, null, function(n) {
        return (
          //$FlowExpectedError[cannot-spread-inexact]
          /* @__PURE__ */ React.createElement(MenuStatefulContainer, _extends$a({}, n, c), function(h) {
            return /* @__PURE__ */ React.createElement(Menu, _extends$a({}, h, {
              overrides: t
            }));
          })
        );
      });
    }
  }]), A;
})(React.PureComponent);
function ownKeys$9(o, E) {
  var A = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var g = Object.getOwnPropertySymbols(o);
    E && (g = g.filter(function(e) {
      return Object.getOwnPropertyDescriptor(o, e).enumerable;
    })), A.push.apply(A, g);
  }
  return A;
}
function _objectSpread$7(o) {
  for (var E = 1; E < arguments.length; E++) {
    var A = arguments[E] != null ? arguments[E] : {};
    E % 2 ? ownKeys$9(Object(A), !0).forEach(function(g) {
      _defineProperty$a(o, g, A[g]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(A)) : ownKeys$9(Object(A)).forEach(function(g) {
      Object.defineProperty(o, g, Object.getOwnPropertyDescriptor(A, g));
    });
  }
  return o;
}
function _defineProperty$a(o, E, A) {
  return E in o ? Object.defineProperty(o, E, { value: A, enumerable: !0, configurable: !0, writable: !0 }) : o[E] = A, o;
}
function getFont() {
  var o, E = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : SIZE$1.default, A = arguments.length > 1 ? arguments[1] : void 0;
  return (o = {}, _defineProperty$a(o, SIZE$1.mini, A.font100), _defineProperty$a(o, SIZE$1.compact, A.font200), _defineProperty$a(o, SIZE$1.default, A.font300), _defineProperty$a(o, SIZE$1.large, A.font400), o)[E];
}
function getBorderRadius(o, E) {
  var A = E.inputBorderRadius;
  return o === SIZE$1.mini && (A = E.inputBorderRadiusMini), {
    borderTopLeftRadius: A,
    borderBottomLeftRadius: A,
    borderTopRightRadius: A,
    borderBottomRightRadius: A
  };
}
function getControlPadding(o) {
  var E, A, g, e, t, c = o.$theme, n = o.$theme.sizing, h = o.$size, d = h === void 0 ? SIZE$1.default : h, k = o.$type, p = o.$multi, M = o.$isEmpty, S = k === TYPE.search, AA = S ? "calc(".concat(n.scale1000, " - ").concat(n.scale0, ")") : n.scale400, H = c.direction === "rtl" ? "paddingRight" : "paddingLeft", gA = c.direction === "rtl" ? "paddingLeft" : "paddingRight";
  return (t = {}, _defineProperty$a(t, SIZE$1.mini, (E = {
    // `sizing.scale0` based on the multi value component (Tag) top and bottom margin
    paddingTop: p && !M ? 0 : n.scale100,
    paddingBottom: p && !M ? 0 : n.scale100
  }, _defineProperty$a(E, H, p && !M ? "calc(".concat(AA, " - ").concat(n.scale0, ")") : AA), _defineProperty$a(E, gA, "0"), E)), _defineProperty$a(t, SIZE$1.compact, (A = {
    // `sizing.scale0` based on the multi value component (Tag) top and bottom margin
    paddingTop: p && !M ? "calc(".concat(n.scale100, " - ").concat(n.scale0, ")") : n.scale200,
    paddingBottom: p && !M ? "calc(".concat(n.scale100, " - ").concat(n.scale0, ")") : n.scale200
  }, _defineProperty$a(A, H, p && !M ? "calc(".concat(AA, " - ").concat(n.scale0, ")") : AA), _defineProperty$a(A, gA, "0"), A)), _defineProperty$a(t, SIZE$1.default, (g = {
    // `sizing.scale0` based on the multi value component (Tag) top and bottom margin
    paddingTop: p && !M ? "calc(".concat(n.scale400, " - ").concat(n.scale0, ")") : n.scale400,
    paddingBottom: p && !M ? "calc(".concat(n.scale400, " - ").concat(n.scale0, ")") : n.scale400
  }, _defineProperty$a(g, H, p && !M ? "calc(".concat(AA, " + ").concat(n.scale0, ")") : AA), _defineProperty$a(g, gA, 0), g)), _defineProperty$a(t, SIZE$1.large, (e = {
    // `sizing.scale0` based on the multi value component (Tag) top and bottom margin
    paddingTop: p && !M ? "calc(".concat(n.scale600, " - ").concat(n.scale0, ")") : n.scale550,
    paddingBottom: p && !M ? "calc(".concat(n.scale600, " - ").concat(n.scale0, ")") : n.scale550
  }, _defineProperty$a(e, H, p && !M ? "calc(".concat(AA, " - ").concat(n.scale0, ")") : AA), _defineProperty$a(e, gA, 0), e)), t)[d];
}
var StyledDropdownContainer = styled("div", function(o) {
  return {
    width: "".concat(String(o.$width), "px")
  };
});
StyledDropdownContainer.displayName = "StyledDropdownContainer";
StyledDropdownContainer.displayName = "StyledDropdownContainer";
var StyledDropdown = StyledList, StyledDropdownListItem = StyledListItem, StyledOptionContent = styled("div", function(o) {
  var E = o.$isHighlighted, A = o.$selected, g = o.$disabled, e = o.$theme;
  return {
    cursor: g ? "not-allowed" : "pointer",
    color: A && !E ? e.colors.menuFontSelected : null,
    fontWeight: A ? "bold" : "normal"
  };
});
StyledOptionContent.displayName = "StyledOptionContent";
StyledOptionContent.displayName = "StyledOptionContent";
var StyledRoot = styled("div", function(o) {
  var E = o.$theme.typography, A = o.$size;
  return _objectSpread$7(_objectSpread$7({}, getFont(A, E)), {}, {
    boxSizing: "border-box",
    position: "relative",
    width: "100%"
  });
});
StyledRoot.displayName = "StyledRoot";
StyledRoot.displayName = "StyledRoot";
function getControlContainerColors(o, E, A, g, e, t) {
  return o ? {
    color: t.inputTextDisabled,
    borderLeftColor: t.inputFillDisabled,
    borderRightColor: t.inputFillDisabled,
    borderTopColor: t.inputFillDisabled,
    borderBottomColor: t.inputFillDisabled,
    backgroundColor: t.inputFillDisabled
  } : E || A ? {
    color: t.contentPrimary,
    borderLeftColor: t.borderSelected,
    borderRightColor: t.borderSelected,
    borderTopColor: t.borderSelected,
    borderBottomColor: t.borderSelected,
    backgroundColor: t.inputFillActive
  } : e ? {
    color: t.contentPrimary,
    borderLeftColor: t.inputBorderError,
    borderRightColor: t.inputBorderError,
    borderTopColor: t.inputBorderError,
    borderBottomColor: t.inputBorderError,
    backgroundColor: t.inputFillError
  } : g ? {
    color: t.contentPrimary,
    borderLeftColor: t.inputBorderPositive,
    borderRightColor: t.inputBorderPositive,
    borderTopColor: t.inputBorderPositive,
    borderBottomColor: t.inputBorderPositive,
    backgroundColor: t.inputFillPositive
  } : {
    color: t.contentPrimary,
    borderLeftColor: t.inputBorder,
    borderRightColor: t.inputBorder,
    borderTopColor: t.inputBorder,
    borderBottomColor: t.inputBorder,
    backgroundColor: t.inputFill
  };
}
var StyledControlContainer = styled("div", function(o) {
  var E = o.$disabled, A = o.$error, g = o.$positive, e = o.$isFocused, t = o.$isPseudoFocused, c = o.$type, n = o.$searchable, h = o.$size, d = o.$theme, k = d.borders, p = d.colors, M = d.animation;
  return _objectSpread$7(_objectSpread$7({}, getBorderRadius(h, k)), {}, {
    boxSizing: "border-box",
    overflow: "hidden",
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    cursor: E ? "not-allowed" : n || c === TYPE.search ? "text" : "pointer",
    borderLeftWidth: "2px",
    borderRightWidth: "2px",
    borderTopWidth: "2px",
    borderBottomWidth: "2px",
    borderLeftStyle: "solid",
    borderRightStyle: "solid",
    borderTopStyle: "solid",
    borderBottomStyle: "solid",
    transitionProperty: "border, box-shadow, background-color",
    transitionDuration: M.timing200,
    transitionTimingFunction: M.easeOutCurve
  }, getControlContainerColors(E, e, t, g, A, p));
});
StyledControlContainer.displayName = "StyledControlContainer";
StyledControlContainer.displayName = "StyledControlContainer";
var StyledValueContainer = styled("div", function(o) {
  var E = getControlPadding(o);
  return _objectSpread$7({
    boxSizing: "border-box",
    position: "relative",
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: "0%",
    display: "flex",
    alignItems: "center",
    flexWrap: o.$multi ? "wrap" : "nowrap",
    overflow: "hidden"
  }, E);
});
StyledValueContainer.displayName = "StyledValueContainer";
StyledValueContainer.displayName = "StyledValueContainer";
var StyledPlaceholder = styled("div", function(o) {
  var E = o.$disabled, A = o.$theme.colors;
  return {
    color: E ? A.inputPlaceholderDisabled : A.inputPlaceholder,
    maxWidth: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  };
});
StyledPlaceholder.displayName = "StyledPlaceholder";
StyledPlaceholder.displayName = "StyledPlaceholder";
var StyledSingleValue = styled("div", function(o) {
  var E, A = o.$searchable, g = o.$size, e = o.$theme, t = o.$theme.typography, c = getFont(g, t), n = e.direction === "rtl" ? "marginRight" : "marginLeft";
  return _objectSpread$7((E = {
    lineHeight: A ? "inherit" : c.lineHeight,
    boxSizing: "border-box"
  }, _defineProperty$a(E, n, e.sizing.scale0), _defineProperty$a(E, "height", "100%"), _defineProperty$a(E, "maxWidth", "100%"), E), ellipsisText);
});
StyledSingleValue.displayName = "StyledSingleValue";
StyledSingleValue.displayName = "StyledSingleValue";
var StyledInputContainer = styled("div", function(o) {
  var E = o.$size, A = o.$searchable, g = o.$theme, e = g.typography, t = g.sizing, c = o.$isEmpty, n = getFont(E, e);
  return {
    position: "relative",
    display: "inline-block",
    maxWidth: "100%",
    backgroundColor: "transparent",
    borderLeftStyle: "none",
    borderTopStyle: "none",
    borderRightStyle: "none",
    borderBottomStyle: "none",
    boxShadow: "none",
    boxSizing: "border-box",
    outline: "none",
    marginTop: 0,
    marginBottom: 0,
    marginLeft: c ? 0 : t.scale0,
    marginRight: 0,
    paddingTop: 0,
    paddingBottom: 0,
    paddingLeft: 0,
    paddingRight: 0,
    height: String(A ? "auto" : n.lineHeight),
    maxHeight: String(n.lineHeight)
  };
});
StyledInputContainer.displayName = "StyledInputContainer";
StyledInputContainer.displayName = "StyledInputContainer";
var StyledInput = styled("input", function(o) {
  var E = o.$theme, A = E.colors, g = E.typography, e = o.$size, t = o.$searchable, c = o.$width;
  return _objectSpread$7(_objectSpread$7({}, getFont(e, g)), {}, {
    color: A.contentPrimary,
    boxSizing: "content-box",
    width: t ? c || "100%" : "1px",
    maxWidth: "100%",
    background: "transparent",
    borderLeftStyle: "none",
    borderTopStyle: "none",
    borderRightStyle: "none",
    borderBottomStyle: "none",
    boxShadow: "none",
    display: "inline-block",
    outline: "none",
    marginTop: "0",
    marginBottom: "0",
    marginLeft: "0",
    marginRight: "0",
    paddingTop: "0",
    paddingBottom: "0",
    paddingLeft: "0",
    paddingRight: "0"
  });
});
StyledInput.displayName = "StyledInput";
StyledInput.displayName = "StyledInput";
var StyledInputSizer = styled("div", function(o) {
  var E, A = o.$size, g = o.$theme, e = o.$theme.typography, t = g.direction === "rtl" ? "right" : "left";
  return _objectSpread$7(_objectSpread$7({}, getFont(A, e)), {}, (E = {
    position: "absolute",
    top: 0
  }, _defineProperty$a(E, t, 0), _defineProperty$a(E, "visibility", "hidden"), _defineProperty$a(E, "height", 0), _defineProperty$a(E, "overflow", "scroll"), _defineProperty$a(E, "whiteSpace", "pre"), E));
});
StyledInputSizer.displayName = "StyledInputSizer";
StyledInputSizer.displayName = "StyledInputSizer";
var StyledIconsContainer = styled("div", function(o) {
  var E = o.$theme, A = o.$theme.sizing, g = E.direction === "rtl" ? "paddingLeft" : "paddingRight";
  return _defineProperty$a({
    boxSizing: "border-box",
    position: "relative",
    display: "flex",
    flexShrink: 0,
    alignItems: "center",
    alignSelf: "stretch"
  }, g, A.scale500);
});
StyledIconsContainer.displayName = "StyledIconsContainer";
StyledIconsContainer.displayName = "StyledIconsContainer";
function getSvgStyles(o) {
  var E = o.$theme;
  return {
    display: "inline-block",
    fill: "currentColor",
    color: "currentColor",
    height: E.sizing.scale600,
    width: E.sizing.scale600
  };
}
var StyledSelectArrow = styled("svg", function(o) {
  var E, A = o.$theme, g = o.$disabled, e = o.$size, t = A.colors, c = (E = {}, _defineProperty$a(E, SIZE$1.mini, 16), _defineProperty$a(E, SIZE$1.compact, 16), _defineProperty$a(E, SIZE$1.default, 20), _defineProperty$a(E, SIZE$1.large, 24), E), n = c[SIZE$1.default];
  return e && (n = c[e]), _objectSpread$7(_objectSpread$7({}, getSvgStyles({
    $theme: A
  })), {}, {
    color: g ? t.inputTextDisabled : t.contentPrimary,
    cursor: g ? "not-allowed" : "pointer",
    height: "".concat(n, "px"),
    width: "".concat(n, "px")
  });
});
StyledSelectArrow.displayName = "StyledSelectArrow";
StyledSelectArrow.displayName = "StyledSelectArrow";
var StyledClearIcon = styled("svg", function(o) {
  var E, A = o.$theme, g = o.$size, e = A.colors, t = (E = {}, _defineProperty$a(E, SIZE$1.mini, 15), _defineProperty$a(E, SIZE$1.compact, 15), _defineProperty$a(E, SIZE$1.default, 18), _defineProperty$a(E, SIZE$1.large, 22), E), c = t[SIZE$1.default];
  return g && (c = t[g]), _objectSpread$7(_objectSpread$7({}, getSvgStyles({
    $theme: A
  })), {}, {
    color: e.contentPrimary,
    cursor: "pointer",
    height: "".concat(c, "px"),
    width: "".concat(c, "px")
  });
});
StyledClearIcon.displayName = "StyledClearIcon";
StyledClearIcon.displayName = "StyledClearIcon";
var StyledLoadingIndicator = withStyle(StyledSpinner, function(o) {
  var E = o.$theme;
  return {
    borderTopWidth: "2px",
    borderRightWidth: "2px",
    borderBottomWidth: "2px",
    borderLeftWidth: "2px",
    borderRightColor: E.colors.borderOpaque,
    borderBottomColor: E.colors.borderOpaque,
    borderLeftColor: E.colors.borderOpaque,
    width: "16px",
    height: "16px"
  };
});
StyledLoadingIndicator.displayName = "StyledLoadingIndicator";
StyledLoadingIndicator.displayName = "StyledLoadingIndicator";
var StyledSearchIconContainer = styled("div", function(o) {
  var E, A = o.$disabled, g = o.$theme, e = g.colors, t = g.sizing, c = g.direction === "rtl" ? "right" : "left";
  return _objectSpread$7(_objectSpread$7({}, getSvgStyles(o)), {}, (E = {
    color: A ? e.inputTextDisabled : e.contentPrimary,
    cursor: A ? "not-allowed" : "pointer",
    position: "absolute",
    top: 0
  }, _defineProperty$a(E, c, t.scale500), _defineProperty$a(E, "display", "flex"), _defineProperty$a(E, "alignItems", "center"), _defineProperty$a(E, "height", "100%"), E));
});
StyledSearchIconContainer.displayName = "StyledSearchIconContainer";
StyledSearchIconContainer.displayName = "StyledSearchIconContainer";
function _typeof$5(o) {
  "@babel/helpers - typeof";
  return _typeof$5 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(E) {
    return typeof E;
  } : function(E) {
    return E && typeof Symbol == "function" && E.constructor === Symbol && E !== Symbol.prototype ? "symbol" : typeof E;
  }, _typeof$5(o);
}
var _excluded$9 = ["overrides", "inputRef"];
function _extends$9() {
  return _extends$9 = Object.assign ? Object.assign.bind() : function(o) {
    for (var E = 1; E < arguments.length; E++) {
      var A = arguments[E];
      for (var g in A)
        Object.prototype.hasOwnProperty.call(A, g) && (o[g] = A[g]);
    }
    return o;
  }, _extends$9.apply(this, arguments);
}
function ownKeys$8(o, E) {
  var A = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var g = Object.getOwnPropertySymbols(o);
    E && (g = g.filter(function(e) {
      return Object.getOwnPropertyDescriptor(o, e).enumerable;
    })), A.push.apply(A, g);
  }
  return A;
}
function _objectSpread$6(o) {
  for (var E = 1; E < arguments.length; E++) {
    var A = arguments[E] != null ? arguments[E] : {};
    E % 2 ? ownKeys$8(Object(A), !0).forEach(function(g) {
      _defineProperty$9(o, g, A[g]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(A)) : ownKeys$8(Object(A)).forEach(function(g) {
      Object.defineProperty(o, g, Object.getOwnPropertyDescriptor(A, g));
    });
  }
  return o;
}
function _slicedToArray$7(o, E) {
  return _arrayWithHoles$6(o) || _iterableToArrayLimit$6(o, E) || _unsupportedIterableToArray$6(o, E) || _nonIterableRest$6();
}
function _nonIterableRest$6() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$6(o, E) {
  if (o) {
    if (typeof o == "string") return _arrayLikeToArray$6(o, E);
    var A = Object.prototype.toString.call(o).slice(8, -1);
    if (A === "Object" && o.constructor && (A = o.constructor.name), A === "Map" || A === "Set") return Array.from(o);
    if (A === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(A)) return _arrayLikeToArray$6(o, E);
  }
}
function _arrayLikeToArray$6(o, E) {
  (E == null || E > o.length) && (E = o.length);
  for (var A = 0, g = new Array(E); A < E; A++)
    g[A] = o[A];
  return g;
}
function _iterableToArrayLimit$6(o, E) {
  var A = o == null ? null : typeof Symbol < "u" && o[Symbol.iterator] || o["@@iterator"];
  if (A != null) {
    var g = [], e = !0, t = !1, c, n;
    try {
      for (A = A.call(o); !(e = (c = A.next()).done) && (g.push(c.value), !(E && g.length === E)); e = !0)
        ;
    } catch (h) {
      t = !0, n = h;
    } finally {
      try {
        !e && A.return != null && A.return();
      } finally {
        if (t) throw n;
      }
    }
    return g;
  }
}
function _arrayWithHoles$6(o) {
  if (Array.isArray(o)) return o;
}
function _objectWithoutProperties$7(o, E) {
  if (o == null) return {};
  var A = _objectWithoutPropertiesLoose$6(o, E), g, e;
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    for (e = 0; e < t.length; e++)
      g = t[e], !(E.indexOf(g) >= 0) && Object.prototype.propertyIsEnumerable.call(o, g) && (A[g] = o[g]);
  }
  return A;
}
function _objectWithoutPropertiesLoose$6(o, E) {
  if (o == null) return {};
  var A = {}, g = Object.keys(o), e, t;
  for (t = 0; t < g.length; t++)
    e = g[t], !(E.indexOf(e) >= 0) && (A[e] = o[e]);
  return A;
}
function _classCallCheck$3(o, E) {
  if (!(o instanceof E))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$3(o, E) {
  for (var A = 0; A < E.length; A++) {
    var g = E[A];
    g.enumerable = g.enumerable || !1, g.configurable = !0, "value" in g && (g.writable = !0), Object.defineProperty(o, g.key, g);
  }
}
function _createClass$3(o, E, A) {
  return E && _defineProperties$3(o.prototype, E), Object.defineProperty(o, "prototype", { writable: !1 }), o;
}
function _inherits$3(o, E) {
  if (typeof E != "function" && E !== null)
    throw new TypeError("Super expression must either be null or a function");
  o.prototype = Object.create(E && E.prototype, { constructor: { value: o, writable: !0, configurable: !0 } }), Object.defineProperty(o, "prototype", { writable: !1 }), E && _setPrototypeOf$3(o, E);
}
function _setPrototypeOf$3(o, E) {
  return _setPrototypeOf$3 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(g, e) {
    return g.__proto__ = e, g;
  }, _setPrototypeOf$3(o, E);
}
function _createSuper$3(o) {
  var E = _isNativeReflectConstruct$3();
  return function() {
    var g = _getPrototypeOf$3(o), e;
    if (E) {
      var t = _getPrototypeOf$3(this).constructor;
      e = Reflect.construct(g, arguments, t);
    } else
      e = g.apply(this, arguments);
    return _possibleConstructorReturn$3(this, e);
  };
}
function _possibleConstructorReturn$3(o, E) {
  if (E && (_typeof$5(E) === "object" || typeof E == "function"))
    return E;
  if (E !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$4(o);
}
function _assertThisInitialized$4(o) {
  if (o === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return o;
}
function _isNativeReflectConstruct$3() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function _getPrototypeOf$3(o) {
  return _getPrototypeOf$3 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(A) {
    return A.__proto__ || Object.getPrototypeOf(A);
  }, _getPrototypeOf$3(o);
}
function _defineProperty$9(o, E, A) {
  return E in o ? Object.defineProperty(o, E, { value: A, enumerable: !0, configurable: !0, writable: !0 }) : o[E] = A, o;
}
var AutosizeInput = /* @__PURE__ */ (function(o) {
  _inherits$3(A, o);
  var E = _createSuper$3(A);
  function A() {
    var g;
    _classCallCheck$3(this, A);
    for (var e = arguments.length, t = new Array(e), c = 0; c < e; c++)
      t[c] = arguments[c];
    return g = E.call.apply(E, [this].concat(t)), _defineProperty$9(_assertThisInitialized$4(g), "mounted", void 0), _defineProperty$9(_assertThisInitialized$4(g), "sizer", void 0), _defineProperty$9(_assertThisInitialized$4(g), "state", {
      inputWidth: 5
    }), _defineProperty$9(_assertThisInitialized$4(g), "sizerRef", function(n) {
      g.sizer = n;
    }), g;
  }
  return _createClass$3(A, [{
    key: "componentDidMount",
    value: function() {
      this.mounted = !0, this.updateInputWidth();
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  }, {
    key: "componentDidUpdate",
    value: function(e, t) {
      this.updateInputWidth();
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.mounted = !1;
    }
  }, {
    key: "updateInputWidth",
    value: function() {
      if (!(!this.mounted || !this.sizer || typeof this.sizer.scrollWidth > "u")) {
        var e = this.sizer.scrollWidth + 2;
        e !== this.state.inputWidth && this.sizer.scrollWidth !== this.state.inputWidth && this.setState({
          inputWidth: e
        });
      }
    }
  }, {
    key: "render",
    value: function() {
      var e = this.props, t = e.overrides, c = t === void 0 ? {} : t, n = e.inputRef, h = _objectWithoutProperties$7(e, _excluded$9), d = getOverrides(c.Input, StyledInput), k = _slicedToArray$7(d, 2), p = k[0], M = k[1], S = [this.props.defaultValue, this.props.value, ""].reduce(function(H, gA) {
        return H ?? gA;
      }), AA = _objectSpread$6(_objectSpread$6({}, h), {}, {
        $width: "".concat(this.state.inputWidth, "px")
      });
      return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(p, _extends$9({}, AA, {
        ref: n
      }, M)), /* @__PURE__ */ React.createElement(StyledInputSizer, {
        $size: this.props.$size,
        ref: this.sizerRef,
        $style: M.$style ? M.$style : null
      }, S));
    }
  }]), A;
})(React.Component);
_defineProperty$9(AutosizeInput, "defaultProps", {
  inputRef: /* @__PURE__ */ React.createRef(),
  value: "",
  overrides: {}
});
function ownKeys$7(o, E) {
  var A = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var g = Object.getOwnPropertySymbols(o);
    E && (g = g.filter(function(e) {
      return Object.getOwnPropertyDescriptor(o, e).enumerable;
    })), A.push.apply(A, g);
  }
  return A;
}
function _objectSpread$5(o) {
  for (var E = 1; E < arguments.length; E++) {
    var A = arguments[E] != null ? arguments[E] : {};
    E % 2 ? ownKeys$7(Object(A), !0).forEach(function(g) {
      _defineProperty$8(o, g, A[g]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(A)) : ownKeys$7(Object(A)).forEach(function(g) {
      Object.defineProperty(o, g, Object.getOwnPropertyDescriptor(A, g));
    });
  }
  return o;
}
function _defineProperty$8(o, E, A) {
  return E in o ? Object.defineProperty(o, E, { value: A, enumerable: !0, configurable: !0, writable: !0 }) : o[E] = A, o;
}
var escapeRegExp = function o(E) {
  return E.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}, isValid = function o(E) {
  return typeof E < "u" && E !== null && E !== "";
}, defaultProps$1 = {
  filterOption: null,
  ignoreCase: !0,
  labelKey: "label",
  matchPos: "any",
  matchProp: "any",
  trimFilter: !0,
  valueKey: "value"
}, filterOptions = function o(E, A, g, e) {
  var t = _objectSpread$5(_objectSpread$5({}, defaultProps$1), e);
  t.ignoreCase && (A = A.toLowerCase()), t.trimFilter && (A = A.trim());
  var c = (g || []).reduce(function(h, d) {
    return h.add(d[t.valueKey]), h;
  }, /* @__PURE__ */ new Set()), n = new RegExp("".concat(t.matchPos === "start" ? "^" : "").concat(escapeRegExp(A)), t.ignoreCase ? "i" : "");
  return E.filter(function(h) {
    if (c.has(h[t.valueKey])) return !1;
    if (t.filterOption) return t.filterOption.call(void 0, h, A);
    if (!A) return !0;
    var d = h[t.valueKey], k = h[t.labelKey], p = isValid(d), M = isValid(k);
    if (!p && !M)
      return !1;
    var S = p ? String(d) : null, AA = M ? String(k) : null;
    return S && t.matchProp !== "label" && n.test(S) || AA && t.matchProp !== "value" && n.test(AA);
  });
}, defaultProps = {
  "aria-label": null,
  "aria-describedby": null,
  "aria-errormessage": null,
  "aria-labelledby": null,
  autoFocus: !1,
  backspaceRemoves: !0,
  clearable: !0,
  closeOnSelect: !0,
  creatable: !1,
  deleteRemoves: !0,
  disabled: !1,
  error: !1,
  positive: !1,
  escapeClearsValue: !0,
  filterOptions,
  filterOutSelected: !0,
  getOptionLabel: null,
  getValueLabel: null,
  ignoreCase: !0,
  isLoading: !1,
  labelKey: "label",
  maxDropdownHeight: "40vh",
  multi: !1,
  onBlur: function o() {
  },
  onBlurResetsInput: !0,
  onChange: function o() {
  },
  onFocus: function o() {
  },
  onInputChange: function o() {
  },
  onCloseResetsInput: !0,
  onSelectResetsInput: !0,
  onOpen: null,
  onClose: null,
  openOnClick: !0,
  startOpen: !1,
  options: [],
  overrides: {},
  required: !1,
  searchable: !0,
  size: SIZE$1.default,
  type: TYPE.select,
  value: [],
  valueKey: "id"
};
function _typeof$4(o) {
  "@babel/helpers - typeof";
  return _typeof$4 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(E) {
    return typeof E;
  } : function(E) {
    return E && typeof Symbol == "function" && E.constructor === Symbol && E !== Symbol.prototype ? "symbol" : typeof E;
  }, _typeof$4(o);
}
var _excluded$8 = ["overrides"];
function ownKeys$6(o, E) {
  var A = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var g = Object.getOwnPropertySymbols(o);
    E && (g = g.filter(function(e) {
      return Object.getOwnPropertyDescriptor(o, e).enumerable;
    })), A.push.apply(A, g);
  }
  return A;
}
function _objectSpread$4(o) {
  for (var E = 1; E < arguments.length; E++) {
    var A = arguments[E] != null ? arguments[E] : {};
    E % 2 ? ownKeys$6(Object(A), !0).forEach(function(g) {
      _defineProperty$7(o, g, A[g]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(A)) : ownKeys$6(Object(A)).forEach(function(g) {
      Object.defineProperty(o, g, Object.getOwnPropertyDescriptor(A, g));
    });
  }
  return o;
}
function _objectWithoutProperties$6(o, E) {
  if (o == null) return {};
  var A = _objectWithoutPropertiesLoose$5(o, E), g, e;
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    for (e = 0; e < t.length; e++)
      g = t[e], !(E.indexOf(g) >= 0) && Object.prototype.propertyIsEnumerable.call(o, g) && (A[g] = o[g]);
  }
  return A;
}
function _objectWithoutPropertiesLoose$5(o, E) {
  if (o == null) return {};
  var A = {}, g = Object.keys(o), e, t;
  for (t = 0; t < g.length; t++)
    e = g[t], !(E.indexOf(e) >= 0) && (A[e] = o[e]);
  return A;
}
function _extends$8() {
  return _extends$8 = Object.assign ? Object.assign.bind() : function(o) {
    for (var E = 1; E < arguments.length; E++) {
      var A = arguments[E];
      for (var g in A)
        Object.prototype.hasOwnProperty.call(A, g) && (o[g] = A[g]);
    }
    return o;
  }, _extends$8.apply(this, arguments);
}
function _slicedToArray$6(o, E) {
  return _arrayWithHoles$5(o) || _iterableToArrayLimit$5(o, E) || _unsupportedIterableToArray$5(o, E) || _nonIterableRest$5();
}
function _nonIterableRest$5() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$5(o, E) {
  if (o) {
    if (typeof o == "string") return _arrayLikeToArray$5(o, E);
    var A = Object.prototype.toString.call(o).slice(8, -1);
    if (A === "Object" && o.constructor && (A = o.constructor.name), A === "Map" || A === "Set") return Array.from(o);
    if (A === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(A)) return _arrayLikeToArray$5(o, E);
  }
}
function _arrayLikeToArray$5(o, E) {
  (E == null || E > o.length) && (E = o.length);
  for (var A = 0, g = new Array(E); A < E; A++)
    g[A] = o[A];
  return g;
}
function _iterableToArrayLimit$5(o, E) {
  var A = o == null ? null : typeof Symbol < "u" && o[Symbol.iterator] || o["@@iterator"];
  if (A != null) {
    var g = [], e = !0, t = !1, c, n;
    try {
      for (A = A.call(o); !(e = (c = A.next()).done) && (g.push(c.value), !(E && g.length === E)); e = !0)
        ;
    } catch (h) {
      t = !0, n = h;
    } finally {
      try {
        !e && A.return != null && A.return();
      } finally {
        if (t) throw n;
      }
    }
    return g;
  }
}
function _arrayWithHoles$5(o) {
  if (Array.isArray(o)) return o;
}
function _classCallCheck$2(o, E) {
  if (!(o instanceof E))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$2(o, E) {
  for (var A = 0; A < E.length; A++) {
    var g = E[A];
    g.enumerable = g.enumerable || !1, g.configurable = !0, "value" in g && (g.writable = !0), Object.defineProperty(o, g.key, g);
  }
}
function _createClass$2(o, E, A) {
  return E && _defineProperties$2(o.prototype, E), Object.defineProperty(o, "prototype", { writable: !1 }), o;
}
function _inherits$2(o, E) {
  if (typeof E != "function" && E !== null)
    throw new TypeError("Super expression must either be null or a function");
  o.prototype = Object.create(E && E.prototype, { constructor: { value: o, writable: !0, configurable: !0 } }), Object.defineProperty(o, "prototype", { writable: !1 }), E && _setPrototypeOf$2(o, E);
}
function _setPrototypeOf$2(o, E) {
  return _setPrototypeOf$2 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(g, e) {
    return g.__proto__ = e, g;
  }, _setPrototypeOf$2(o, E);
}
function _createSuper$2(o) {
  var E = _isNativeReflectConstruct$2();
  return function() {
    var g = _getPrototypeOf$2(o), e;
    if (E) {
      var t = _getPrototypeOf$2(this).constructor;
      e = Reflect.construct(g, arguments, t);
    } else
      e = g.apply(this, arguments);
    return _possibleConstructorReturn$2(this, e);
  };
}
function _possibleConstructorReturn$2(o, E) {
  if (E && (_typeof$4(E) === "object" || typeof E == "function"))
    return E;
  if (E !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$3(o);
}
function _assertThisInitialized$3(o) {
  if (o === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return o;
}
function _isNativeReflectConstruct$2() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function _getPrototypeOf$2(o) {
  return _getPrototypeOf$2 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(A) {
    return A.__proto__ || Object.getPrototypeOf(A);
  }, _getPrototypeOf$2(o);
}
function _defineProperty$7(o, E, A) {
  return E in o ? Object.defineProperty(o, E, { value: A, enumerable: !0, configurable: !0, writable: !0 }) : o[E] = A, o;
}
function groupOptions(o) {
  return o.reduce(function(E, A) {
    return A.__optgroup ? (E[A.__optgroup] || (E[A.__optgroup] = []), E[A.__optgroup].push(A)) : E.__ungrouped.push(A), E;
  }, {
    __ungrouped: []
  });
}
var SelectDropdown = /* @__PURE__ */ (function(o) {
  _inherits$2(A, o);
  var E = _createSuper$2(A);
  function A() {
    var g;
    _classCallCheck$2(this, A);
    for (var e = arguments.length, t = new Array(e), c = 0; c < e; c++)
      t[c] = arguments[c];
    return g = E.call.apply(E, [this].concat(t)), _defineProperty$7(_assertThisInitialized$3(g), "getItemLabel", function(n) {
      var h = g.props, d = h.getOptionLabel, k = h.overrides, p = k === void 0 ? {} : k, M = h.value, S = h.valueKey, AA = getOverrides(p.OptionContent, StyledOptionContent), H = _slicedToArray$6(AA, 2), gA = H[0], CA = H[1], IA;
      Array.isArray(M) ? IA = !!M.find(function(QA) {
        return QA && QA[S] === n[S];
      }) : IA = M[S] === n[S];
      var BA = {
        $selected: IA,
        $disabled: n.disabled,
        $isHighlighted: n.isHighlighted
      };
      return /* @__PURE__ */ React.createElement(gA, _extends$8({
        "aria-readonly": n.disabled,
        "aria-selected": IA,
        key: n[S]
      }, g.getSharedProps(), BA, CA), d({
        option: n,
        optionState: BA
      }));
    }), _defineProperty$7(_assertThisInitialized$3(g), "onMouseDown", function(n) {
      n.nativeEvent.stopImmediatePropagation();
    }), _defineProperty$7(_assertThisInitialized$3(g), "getHighlightedIndex", function() {
      var n = g.props, h = n.value, d = n.options, k = n.valueKey, p = {};
      if (Array.isArray(h) && h.length > 0 ? p = h[0] : h instanceof Array || (p = h), Object.keys(p).length > 0) {
        var M = d.findIndex(function(S) {
          return S && S[k] === p[k];
        });
        return M === -1 ? 0 : M;
      }
      return 0;
    }), g;
  }
  return _createClass$2(A, [{
    key: "getSharedProps",
    value: function() {
      var e = this.props, t = e.error, c = e.isLoading, n = e.multi, h = e.required, d = e.size, k = e.searchable, p = e.type, M = e.width;
      return {
        $error: t,
        $isLoading: c,
        $multi: n,
        $required: h,
        $searchable: k,
        $size: d,
        $type: p,
        $width: M
      };
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  }, {
    key: "render",
    value: function() {
      var e = this, t = this.props, c = t.maxDropdownHeight, n = t.multi, h = t.noResultsMsg, d = t.onItemSelect, k = t.options, p = k === void 0 ? [] : k, M = t.overrides, S = M === void 0 ? {} : M, AA = t.size, H = getOverrides(S.DropdownContainer, StyledDropdownContainer), gA = _slicedToArray$6(H, 2), CA = gA[0], IA = gA[1], BA = getOverrides(S.DropdownListItem, StyledDropdownListItem), QA = _slicedToArray$6(BA, 2), EA = QA[0], oA = QA[1], iA = getOverrides(S.StatefulMenu, StatefulMenu), aA = _slicedToArray$6(iA, 2), tA = aA[0], eA = aA[1], cA = eA.overrides, DA = cA === void 0 ? {} : cA, nA = _objectWithoutProperties$6(eA, _excluded$8), wA = this.getHighlightedIndex(), lA = groupOptions(p);
      return /* @__PURE__ */ React.createElement(CA, _extends$8({
        "data-no-focus-lock": !0,
        ref: this.props.innerRef
      }, this.getSharedProps(), IA), /* @__PURE__ */ React.createElement(tA, _extends$8({
        noResultsMsg: h,
        onActiveDescendantChange: function(RA) {
          e.props.onActiveDescendantChange && e.props.onActiveDescendantChange(RA);
        },
        onItemSelect: d,
        items: lA,
        size: AA,
        initialState: {
          isFocused: !0,
          highlightedIndex: wA
        },
        typeAhead: !1,
        keyboardControlNode: this.props.keyboardControlNode,
        forceHighlight: !0,
        overrides: mergeOverrides({
          List: {
            component: StyledDropdown,
            style: function(RA) {
              return {
                maxHeight: RA.$maxHeight || null
              };
            },
            props: {
              id: this.props.id ? this.props.id : null,
              $maxHeight: c,
              "aria-multiselectable": n
            }
          },
          Option: {
            props: {
              getItemLabel: this.getItemLabel,
              // figure out why the onClick handler is not
              // triggered without this temporary fix
              onMouseDown: this.onMouseDown,
              overrides: {
                ListItem: {
                  component: EA,
                  props: _objectSpread$4(_objectSpread$4({}, oA), {}, {
                    role: "option"
                  }),
                  // slightly hacky way to handle the list item style overrides
                  // since the menu component doesn't provide a top level overrides for it
                  style: oA.$style
                }
              },
              renderHrefAsAnchor: !1
            }
          }
        }, _objectSpread$4({
          List: S.Dropdown || {},
          Option: S.DropdownOption || {}
        }, DA))
      }, nA)));
    }
  }]), A;
})(React.Component);
function ownKeys$5(o, E) {
  var A = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var g = Object.getOwnPropertySymbols(o);
    E && (g = g.filter(function(e) {
      return Object.getOwnPropertyDescriptor(o, e).enumerable;
    })), A.push.apply(A, g);
  }
  return A;
}
function _objectSpread$3(o) {
  for (var E = 1; E < arguments.length; E++) {
    var A = arguments[E] != null ? arguments[E] : {};
    E % 2 ? ownKeys$5(Object(A), !0).forEach(function(g) {
      _defineProperty$6(o, g, A[g]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(A)) : ownKeys$5(Object(A)).forEach(function(g) {
      Object.defineProperty(o, g, Object.getOwnPropertyDescriptor(A, g));
    });
  }
  return o;
}
function _defineProperty$6(o, E, A) {
  return E in o ? Object.defineProperty(o, E, { value: A, enumerable: !0, configurable: !0, writable: !0 }) : o[E] = A, o;
}
function groupedOptionsToArray(o) {
  return Object.keys(o).reduce(function(E, A) {
    var g = o[A];
    return E.concat(g.map(function(e) {
      return _objectSpread$3(_objectSpread$3({}, e), {}, {
        __optgroup: A
      });
    }));
  }, []);
}
function normalizeOptions(o) {
  return o ? Array.isArray(o) ? o : groupedOptionsToArray(o) : [];
}
var expandValue = function o(E, A) {
  if (!A.options) return E;
  for (var g = normalizeOptions(A.options), e = 0; e < g.length; e++)
    if (String(g[e][A.valueKey]) === String(E[A.valueKey]))
      return g[e];
  return E;
};
function _typeof$3(o) {
  "@babel/helpers - typeof";
  return _typeof$3 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(E) {
    return typeof E;
  } : function(E) {
    return E && typeof Symbol == "function" && E.constructor === Symbol && E !== Symbol.prototype ? "symbol" : typeof E;
  }, _typeof$3(o);
}
var _excluded$7 = ["$size"], _excluded2$2 = ["$size"];
function _objectWithoutProperties$5(o, E) {
  if (o == null) return {};
  var A = _objectWithoutPropertiesLoose$4(o, E), g, e;
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    for (e = 0; e < t.length; e++)
      g = t[e], !(E.indexOf(g) >= 0) && Object.prototype.propertyIsEnumerable.call(o, g) && (A[g] = o[g]);
  }
  return A;
}
function _objectWithoutPropertiesLoose$4(o, E) {
  if (o == null) return {};
  var A = {}, g = Object.keys(o), e, t;
  for (t = 0; t < g.length; t++)
    e = g[t], !(E.indexOf(e) >= 0) && (A[e] = o[e]);
  return A;
}
function _extends$7() {
  return _extends$7 = Object.assign ? Object.assign.bind() : function(o) {
    for (var E = 1; E < arguments.length; E++) {
      var A = arguments[E];
      for (var g in A)
        Object.prototype.hasOwnProperty.call(A, g) && (o[g] = A[g]);
    }
    return o;
  }, _extends$7.apply(this, arguments);
}
function _slicedToArray$5(o, E) {
  return _arrayWithHoles$4(o) || _iterableToArrayLimit$4(o, E) || _unsupportedIterableToArray$4(o, E) || _nonIterableRest$4();
}
function _nonIterableRest$4() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _iterableToArrayLimit$4(o, E) {
  var A = o == null ? null : typeof Symbol < "u" && o[Symbol.iterator] || o["@@iterator"];
  if (A != null) {
    var g = [], e = !0, t = !1, c, n;
    try {
      for (A = A.call(o); !(e = (c = A.next()).done) && (g.push(c.value), !(E && g.length === E)); e = !0)
        ;
    } catch (h) {
      t = !0, n = h;
    } finally {
      try {
        !e && A.return != null && A.return();
      } finally {
        if (t) throw n;
      }
    }
    return g;
  }
}
function _arrayWithHoles$4(o) {
  if (Array.isArray(o)) return o;
}
function _toConsumableArray(o) {
  return _arrayWithoutHoles(o) || _iterableToArray(o) || _unsupportedIterableToArray$4(o) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$4(o, E) {
  if (o) {
    if (typeof o == "string") return _arrayLikeToArray$4(o, E);
    var A = Object.prototype.toString.call(o).slice(8, -1);
    if (A === "Object" && o.constructor && (A = o.constructor.name), A === "Map" || A === "Set") return Array.from(o);
    if (A === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(A)) return _arrayLikeToArray$4(o, E);
  }
}
function _iterableToArray(o) {
  if (typeof Symbol < "u" && o[Symbol.iterator] != null || o["@@iterator"] != null) return Array.from(o);
}
function _arrayWithoutHoles(o) {
  if (Array.isArray(o)) return _arrayLikeToArray$4(o);
}
function _arrayLikeToArray$4(o, E) {
  (E == null || E > o.length) && (E = o.length);
  for (var A = 0, g = new Array(E); A < E; A++)
    g[A] = o[A];
  return g;
}
function _classCallCheck$1(o, E) {
  if (!(o instanceof E))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$1(o, E) {
  for (var A = 0; A < E.length; A++) {
    var g = E[A];
    g.enumerable = g.enumerable || !1, g.configurable = !0, "value" in g && (g.writable = !0), Object.defineProperty(o, g.key, g);
  }
}
function _createClass$1(o, E, A) {
  return E && _defineProperties$1(o.prototype, E), Object.defineProperty(o, "prototype", { writable: !1 }), o;
}
function _inherits$1(o, E) {
  if (typeof E != "function" && E !== null)
    throw new TypeError("Super expression must either be null or a function");
  o.prototype = Object.create(E && E.prototype, { constructor: { value: o, writable: !0, configurable: !0 } }), Object.defineProperty(o, "prototype", { writable: !1 }), E && _setPrototypeOf$1(o, E);
}
function _setPrototypeOf$1(o, E) {
  return _setPrototypeOf$1 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(g, e) {
    return g.__proto__ = e, g;
  }, _setPrototypeOf$1(o, E);
}
function _createSuper$1(o) {
  var E = _isNativeReflectConstruct$1();
  return function() {
    var g = _getPrototypeOf$1(o), e;
    if (E) {
      var t = _getPrototypeOf$1(this).constructor;
      e = Reflect.construct(g, arguments, t);
    } else
      e = g.apply(this, arguments);
    return _possibleConstructorReturn$1(this, e);
  };
}
function _possibleConstructorReturn$1(o, E) {
  if (E && (_typeof$3(E) === "object" || typeof E == "function"))
    return E;
  if (E !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$2(o);
}
function _assertThisInitialized$2(o) {
  if (o === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return o;
}
function _isNativeReflectConstruct$1() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function _getPrototypeOf$1(o) {
  return _getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(A) {
    return A.__proto__ || Object.getPrototypeOf(A);
  }, _getPrototypeOf$1(o);
}
function _defineProperty$5(o, E, A) {
  return E in o ? Object.defineProperty(o, E, { value: A, enumerable: !0, configurable: !0, writable: !0 }) : o[E] = A, o;
}
function Noop() {
  return null;
}
var isClick = function o(E) {
  return E.type === "click";
}, isLeftClick = function o(E) {
  return E.button !== null && E.button !== void 0 && E.button === 0;
}, containsNode = function o(E, A) {
  if (typeof document < "u")
    return A && E && E.contains(A);
};
function isInteractive(o, E) {
  if (o instanceof Element)
    for (var A = o; A && A !== E; ) {
      var g = A.getAttribute("role");
      if (g === "button" || g === "link")
        return !0;
      A.tagName && (A = A.parentElement);
    }
  return !1;
}
var Select$1 = /* @__PURE__ */ (function(o) {
  _inherits$1(A, o);
  var E = _createSuper$1(A);
  function A(g) {
    var e;
    return _classCallCheck$1(this, A), e = E.call(this, g), _defineProperty$5(_assertThisInitialized$2(e), "anchor", /* @__PURE__ */ React.createRef()), _defineProperty$5(_assertThisInitialized$2(e), "dropdown", /* @__PURE__ */ React.createRef()), _defineProperty$5(_assertThisInitialized$2(e), "input", void 0), _defineProperty$5(_assertThisInitialized$2(e), "dragging", void 0), _defineProperty$5(_assertThisInitialized$2(e), "focusAfterClear", void 0), _defineProperty$5(_assertThisInitialized$2(e), "openAfterFocus", void 0), _defineProperty$5(_assertThisInitialized$2(e), "justSelected", void 0), _defineProperty$5(_assertThisInitialized$2(e), "options", []), _defineProperty$5(_assertThisInitialized$2(e), "state", {
      activeDescendant: null,
      inputValue: "",
      isFocused: !1,
      isOpen: e.props.startOpen,
      isPseudoFocused: !1
    }), _defineProperty$5(_assertThisInitialized$2(e), "isItMounted", !1), _defineProperty$5(_assertThisInitialized$2(e), "handleTouchOutside", function(t) {
      containsNode(e.dropdown.current, t.target) || containsNode(e.anchor.current, t.target) || e.closeMenu();
    }), _defineProperty$5(_assertThisInitialized$2(e), "handleTouchMove", function() {
      return e.dragging = !0;
    }), _defineProperty$5(_assertThisInitialized$2(e), "handleTouchStart", function() {
      return e.dragging = !1;
    }), _defineProperty$5(_assertThisInitialized$2(e), "handleTouchEnd", function(t) {
      e.dragging || e.handleClick(t);
    }), _defineProperty$5(_assertThisInitialized$2(e), "handleClick", function(t) {
      if (!(e.props.disabled || !isClick(t) && !isLeftClick(t))) {
        if (t.target === e.input) {
          e.state.isFocused || (e.openAfterFocus = e.props.openOnClick, e.focus()), e.state.isOpen || e.setState({
            isOpen: !0,
            isFocused: !0,
            isPseudoFocused: !1
          });
          return;
        }
        if (!(e.input && isInteractive(t.target, e.input))) {
          if (!e.props.searchable) {
            e.focus(), e.state.isOpen ? e.setState({
              isOpen: !1,
              isFocused: !1
            }) : e.setState({
              isOpen: !0,
              isFocused: !0
            });
            return;
          }
          e.state.isFocused ? (e.focus(), e.input && (e.input.value = ""), e.setState(function(c) {
            return {
              isOpen: !e.focusAfterClear && !c.isOpen,
              isPseudoFocused: !1
            };
          }), e.focusAfterClear = !1) : (e.focusAfterClear = !1, e.openAfterFocus = e.props.openOnClick, e.focus());
        }
      }
    }), _defineProperty$5(_assertThisInitialized$2(e), "handleInputFocus", function(t) {
      if (!e.props.disabled) {
        e.props.onFocus && e.props.onFocus(t);
        var c = e.state.isOpen || e.openAfterFocus;
        c = !e.focusAfterClear && c, e.setState({
          isFocused: !0,
          isOpen: !!c
        }), e.focusAfterClear = !1, e.openAfterFocus = !1;
      }
    }), _defineProperty$5(_assertThisInitialized$2(e), "handleBlur", function(t) {
      if (t.relatedTarget) {
        if (containsNode(e.anchor.current, t.relatedTarget) || containsNode(e.dropdown.current, t.relatedTarget))
          return;
      } else if (containsNode(e.anchor.current, t.target))
        return;
      e.props.onBlur && e.props.onBlur(t), e.isItMounted && e.setState({
        isFocused: !1,
        isOpen: !1,
        isPseudoFocused: !1,
        inputValue: e.props.onBlurResetsInput ? "" : e.state.inputValue
      });
    }), _defineProperty$5(_assertThisInitialized$2(e), "handleClickOutside", function(t) {
      if (e.justSelected) {
        e.justSelected = !1;
        return;
      }
      if (!containsNode(e.dropdown.current, t.target)) {
        var c = e.state.isFocused || e.state.isPseudoFocused;
        c && !containsNode(e.anchor.current, t.target) && e.handleBlur(t);
      }
    }), _defineProperty$5(_assertThisInitialized$2(e), "handleInputChange", function(t) {
      var c = t.target.value;
      e.setState({
        inputValue: c,
        isOpen: !0,
        isPseudoFocused: !1
      }), e.props.onInputChange && e.props.onInputChange(t);
    }), _defineProperty$5(_assertThisInitialized$2(e), "handleKeyDown", function(t) {
      if (!e.props.disabled)
        switch (t.keyCode) {
          case 8:
            !e.state.inputValue && e.props.backspaceRemoves && (t.preventDefault(), e.backspaceValue());
            break;
          case 9:
            e.setState(function(c) {
              return {
                isPseudoFocused: !1,
                isFocused: !1,
                isOpen: !1,
                inputValue: !e.props.onCloseResetsInput || !e.props.onBlurResetsInput ? c.inputValue : ""
              };
            });
            break;
          case 27:
            !e.state.isOpen && e.props.clearable && e.props.escapeClearsValue && (e.clearValue(t), e.setState({
              isFocused: !1,
              isPseudoFocused: !1
            }));
            break;
          case 32:
            if (e.props.searchable)
              break;
            t.preventDefault(), e.state.isOpen || e.setState({
              isOpen: !0
            });
            break;
          case 38:
            t.preventDefault(), e.state.isOpen || e.setState({
              isOpen: !0
            });
            break;
          case 40:
            t.preventDefault(), e.state.isOpen || e.setState({
              isOpen: !0
            });
            break;
          case 33:
            t.preventDefault(), e.state.isOpen || e.setState({
              isOpen: !0
            });
            break;
          case 34:
            t.preventDefault(), e.state.isOpen || e.setState({
              isOpen: !0
            });
            break;
          case 35:
            if (t.shiftKey)
              break;
            t.preventDefault(), e.state.isOpen || e.setState({
              isOpen: !0
            });
            break;
          case 36:
            if (t.shiftKey)
              break;
            t.preventDefault(), e.state.isOpen || e.setState({
              isOpen: !0
            });
            break;
          case 46:
            !e.state.inputValue && e.props.deleteRemoves && (t.preventDefault(), e.popValue());
            break;
        }
    }), _defineProperty$5(_assertThisInitialized$2(e), "getOptionLabel", function(t, c) {
      var n = c.option;
      return n.isCreatable ? "".concat(t.select.create, " “").concat(n[e.props.labelKey], "”") : n[e.props.labelKey];
    }), _defineProperty$5(_assertThisInitialized$2(e), "getValueLabel", function(t) {
      var c = t.option;
      return c[e.props.labelKey];
    }), _defineProperty$5(_assertThisInitialized$2(e), "handleActiveDescendantChange", function(t) {
      t ? e.setState({
        activeDescendant: t
      }) : e.setState({
        activeDescendant: null
      });
    }), _defineProperty$5(_assertThisInitialized$2(e), "handleInputRef", function(t) {
      e.input = t, typeof e.props.inputRef == "function" ? e.props.inputRef(t) : e.props.inputRef && (e.props.inputRef.current = t), e.props.controlRef && typeof e.props.controlRef == "function" && e.props.controlRef(t);
    }), _defineProperty$5(_assertThisInitialized$2(e), "selectValue", function(t) {
      var c = t.item;
      if (!c.disabled) {
        e.justSelected = !0;
        var n = e.props.onSelectResetsInput ? "" : e.state.inputValue;
        e.props.multi ? e.setState({
          inputValue: n,
          isOpen: !e.props.closeOnSelect
        }, function() {
          var h = e.props.value;
          h.some(function(d) {
            return d[e.props.valueKey] === c[e.props.valueKey];
          }) ? e.removeValue(c) : e.addValue(c);
        }) : (e.focus(), e.setState({
          inputValue: n,
          isOpen: !e.props.closeOnSelect,
          isFocused: !0,
          isPseudoFocused: !1
        }, function() {
          e.setValue([c], c, STATE_CHANGE_TYPE.select);
        }));
      }
    }), _defineProperty$5(_assertThisInitialized$2(e), "addValue", function(t) {
      var c = _toConsumableArray(e.props.value);
      e.setValue(c.concat(t), t, STATE_CHANGE_TYPE.select);
    }), _defineProperty$5(_assertThisInitialized$2(e), "backspaceValue", function() {
      var t = e.popValue();
      if (t) {
        var c = e.props.value.length, n = e.props.getValueLabel || e.getValueLabel, h = n({
          option: t,
          index: c - 1
        });
        if (!e.props.backspaceClearsInputValue && typeof h == "string") {
          var d = h.slice(0, -1);
          e.setState({
            inputValue: d,
            isOpen: !0
          });
        }
      }
    }), _defineProperty$5(_assertThisInitialized$2(e), "popValue", function() {
      var t = _toConsumableArray(e.props.value), c = t.length;
      if (c && t[c - 1].clearableValue !== !1) {
        var n = t.pop();
        return e.setValue(t, n, STATE_CHANGE_TYPE.remove), n;
      }
    }), _defineProperty$5(_assertThisInitialized$2(e), "removeValue", function(t) {
      var c = _toConsumableArray(e.props.value);
      e.setValue(c.filter(function(n) {
        return n[e.props.valueKey] !== t[e.props.valueKey];
      }), t, STATE_CHANGE_TYPE.remove), e.focus();
    }), _defineProperty$5(_assertThisInitialized$2(e), "clearValue", function(t) {
      if (!(isClick(t) && !isLeftClick(t))) {
        if (e.props.value) {
          var c = e.props.value.filter(function(n) {
            return n.clearableValue === !1;
          });
          e.setValue(c, null, STATE_CHANGE_TYPE.clear);
        }
        e.setState({
          inputValue: "",
          isOpen: !1
        }), e.focus(), e.focusAfterClear = !0;
      }
    }), _defineProperty$5(_assertThisInitialized$2(e), "shouldShowPlaceholder", function() {
      return !(e.state.inputValue || e.props.value && e.props.value.length);
    }), _defineProperty$5(_assertThisInitialized$2(e), "shouldShowValue", function() {
      return !e.state.inputValue;
    }), e.options = normalizeOptions(g.options), e;
  }
  return _createClass$1(A, [{
    key: "componentDidMount",
    value: function() {
      this.props.autoFocus && this.focus(), this.isItMounted = !0;
      var e = this.props.controlRef;
      e && typeof e != "function" && (e.current = {
        setDropdownOpen: this.handleDropdownOpen.bind(this),
        setInputValue: this.handleSetInputValue.bind(this),
        setInputFocus: this.handleSetInputFocus.bind(this),
        setInputBlur: this.handleSetInputBlur.bind(this),
        // `focus` & `blur` below are for backwards compatibility and may be removed. Use setInputFocus and setInputBlur instead.
        focus: this.handleSetInputFocus.bind(this),
        blur: this.handleSetInputBlur.bind(this)
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function(e, t) {
      var c = this;
      typeof document < "u" && (t.isOpen !== this.state.isOpen && (this.state.isOpen ? (this.props.onOpen && this.props.onOpen(), document.addEventListener("touchstart", this.handleTouchOutside)) : (this.props.onClose && this.props.onClose(), document.removeEventListener("touchstart", this.handleTouchOutside))), !t.isFocused && this.state.isFocused && setTimeout(function() {
        return document.addEventListener("click", c.handleClickOutside);
      }, 0));
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      typeof document < "u" && (document.removeEventListener("touchstart", this.handleTouchOutside), document.removeEventListener("click", this.handleClickOutside)), this.isItMounted = !1;
    }
  }, {
    key: "focus",
    value: function() {
      this.input && this.input.focus();
    }
  }, {
    key: "handleDropdownOpen",
    value: function(e) {
      this.setState({
        isOpen: e
      });
    }
  }, {
    key: "handleSetInputValue",
    value: function(e) {
      this.setState({
        inputValue: e
      });
    }
  }, {
    key: "handleSetInputFocus",
    value: function() {
      this.input.focus();
    }
  }, {
    key: "handleSetInputBlur",
    value: function() {
      this.input.blur();
    }
    // Handle touch outside on mobile to dismiss menu, ensures that the
    // touch target is not within the anchor DOM node.
  }, {
    key: "closeMenu",
    value: function() {
      this.props.onCloseResetsInput ? this.setState({
        inputValue: "",
        isOpen: !1,
        isPseudoFocused: this.state.isFocused && !this.props.multi
      }) : this.setState({
        isOpen: !1,
        isPseudoFocused: this.state.isFocused && !this.props.multi
      });
    }
  }, {
    key: "getValueArray",
    value: (
      /**
       * Extends the value into an array from the given options
       */
      function(e) {
        var t = this;
        if (!Array.isArray(e)) {
          if (e == null) return [];
          e = [e];
        }
        return e.map(function(c) {
          return expandValue(c, t.props);
        });
      }
    )
  }, {
    key: "setValue",
    value: function(e, t, c) {
      this.props.onChange && this.props.onChange({
        value: e,
        option: t,
        type: c
      });
    }
  }, {
    key: "renderLoading",
    value: function() {
      if (this.props.isLoading) {
        var e = this.props.overrides, t = e === void 0 ? {} : e, c = getOverrides(t.LoadingIndicator, StyledLoadingIndicator), n = _slicedToArray$5(c, 2), h = n[0], d = n[1];
        return /* @__PURE__ */ React.createElement(h, _extends$7({
          role: "status"
        }, d), /* @__PURE__ */ React.createElement("span", {
          style: {
            position: "absolute",
            width: "1px",
            height: "1px",
            padding: 0,
            margin: "-1px",
            overflow: "hidden",
            clip: "rect(0,0,0,0)",
            whiteSpace: "nowrap",
            border: 0
          }
        }, "Loading"));
      }
    }
  }, {
    key: "renderValue",
    value: function(e) {
      var t = this, c = this.props.overrides, n = c === void 0 ? {} : c, h = this.getSharedProps(), d = this.props.getValueLabel || this.getValueLabel, k = this.props.valueComponent || Noop;
      if (!e.length)
        return null;
      if (this.props.multi)
        return e.map(function(p, M) {
          var S = h.$disabled || p.clearableValue === !1;
          return /* @__PURE__ */ React.createElement(k, _extends$7({
            value: p,
            key: "value-".concat(M, "-").concat(p[t.props.valueKey]),
            removeValue: function() {
              return t.removeValue(p);
            },
            disabled: S,
            overrides: {
              Tag: n.Tag,
              MultiValue: n.MultiValue
            }
          }, h, {
            $disabled: S
          }), d({
            option: p,
            index: M
          }));
        });
      if (this.shouldShowValue())
        return /* @__PURE__ */ React.createElement(k, _extends$7({
          value: e[0][this.props.valueKey],
          disabled: this.props.disabled,
          overrides: {
            SingleValue: n.SingleValue
          }
        }, h), d({
          option: e[0]
        }));
    }
  }, {
    key: "renderInput",
    value: function(e) {
      var t = this, c = this.props.overrides, n = c === void 0 ? {} : c, h = getOverrides(n.InputContainer, StyledInputContainer), d = _slicedToArray$5(h, 2), k = d[0], p = d[1], M = this.getSharedProps(), S = this.state.isOpen, AA = this.getValueArray(this.props.value).map(function(CA) {
        return CA[t.props.labelKey];
      }).join(", "), H = AA.length ? "Selected ".concat(AA, ". ") : "", gA = "".concat(H).concat(this.props["aria-label"] || "");
      return this.props.searchable ? /* @__PURE__ */ React.createElement(k, _extends$7({}, M, p), /* @__PURE__ */ React.createElement(AutosizeInput, _extends$7({
        "aria-activedescendant": this.state.activeDescendant,
        "aria-autocomplete": "list",
        "aria-controls": this.state.isOpen ? e : null,
        "aria-describedby": this.props["aria-describedby"],
        "aria-errormessage": this.props["aria-errormessage"],
        "aria-disabled": this.props.disabled || null,
        "aria-expanded": S,
        "aria-haspopup": "listbox",
        "aria-label": gA,
        "aria-labelledby": this.props["aria-labelledby"],
        "aria-required": this.props.required || null,
        disabled: this.props.disabled || null,
        id: this.props.id || null,
        inputRef: this.handleInputRef,
        onChange: this.handleInputChange,
        onFocus: this.handleInputFocus,
        overrides: {
          Input: n.Input
        },
        required: this.props.required && !this.props.value.length || null,
        role: "combobox",
        value: this.state.inputValue,
        tabIndex: 0
      }, M))) : /* @__PURE__ */ React.createElement(k, _extends$7({
        "aria-activedescendant": this.state.activeDescendant,
        "aria-describedby": this.props["aria-describedby"],
        "aria-errormessage": this.props["aria-errormessage"],
        "aria-disabled": this.props.disabled,
        "aria-labelledby": this.props["aria-labelledby"],
        "aria-owns": this.state.isOpen ? e : null,
        "aria-required": this.props.required || null,
        onFocus: this.handleInputFocus,
        tabIndex: 0
      }, M, p), /* @__PURE__ */ React.createElement("input", _extends$7({
        "aria-hidden": !0,
        id: this.props.id || null,
        ref: this.handleInputRef,
        style: {
          opacity: 0,
          width: 0,
          overflow: "hidden",
          border: "none",
          padding: 0
        },
        tabIndex: -1
      }, n.Input ? n.Input.props ? (
        // $FlowExpectedError[not-an-object]
        n.Input.props
      ) : {} : {})));
    }
  }, {
    key: "renderClear",
    value: function() {
      var e, t = !!(this.props.value && this.props.value.length || this.state.inputValue);
      if (!(!this.props.clearable || this.props.disabled || this.props.isLoading || !t)) {
        var c = this.getSharedProps();
        c.$size;
        var n = _objectWithoutProperties$5(c, _excluded$7), h = this.props.overrides, d = h === void 0 ? {} : h, k = getOverrides(d.ClearIcon, DeleteAlt$1), p = _slicedToArray$5(k, 2), M = p[0], S = p[1], AA = this.props.multi ? "Clear all" : "Clear value", H = (e = {}, _defineProperty$5(e, SIZE$1.mini, 15), _defineProperty$5(e, SIZE$1.compact, 15), _defineProperty$5(e, SIZE$1.default, 18), _defineProperty$5(e, SIZE$1.large, 22), e);
        return /* @__PURE__ */ React.createElement(M, _extends$7({
          title: AA,
          "aria-label": AA,
          onClick: this.clearValue,
          role: "button",
          size: H[this.props.size] || H[SIZE$1.default]
        }, n, S));
      }
    }
  }, {
    key: "renderArrow",
    value: function() {
      var e;
      if (this.props.type !== TYPE.select)
        return null;
      var t = this.getSharedProps();
      t.$size;
      var c = _objectWithoutProperties$5(t, _excluded2$2), n = this.props.overrides, h = n === void 0 ? {} : n, d = getOverrides(h.SelectArrow, TriangleDownIcon), k = _slicedToArray$5(d, 2), p = k[0], M = k[1];
      M.overrides = mergeOverrides({
        Svg: {
          style: function(H) {
            var gA = H.$theme, CA = H.$disabled;
            return {
              color: CA ? gA.colors.inputTextDisabled : gA.colors.contentPrimary
            };
          }
        }
      }, M.overrides);
      var S = (e = {}, _defineProperty$5(e, SIZE$1.mini, 16), _defineProperty$5(e, SIZE$1.compact, 16), _defineProperty$5(e, SIZE$1.default, 20), _defineProperty$5(e, SIZE$1.large, 24), e);
      return /* @__PURE__ */ React.createElement(p, _extends$7({
        size: S[this.props.size] || S[SIZE$1.default],
        title: "open"
      }, c, M));
    }
  }, {
    key: "renderSearch",
    value: function() {
      if (this.props.type !== TYPE.search)
        return null;
      var e = this.props.overrides, t = e === void 0 ? {} : e, c = getOverrides(t.SearchIconContainer, StyledSearchIconContainer), n = _slicedToArray$5(c, 2), h = n[0], d = n[1], k = getOverrides(t.SearchIcon, SearchIconComponent), p = _slicedToArray$5(k, 2), M = p[0], S = p[1], AA = this.getSharedProps();
      return /* @__PURE__ */ React.createElement(h, _extends$7({}, AA, d), /* @__PURE__ */ React.createElement(M, _extends$7({
        size: 16,
        title: "search"
      }, AA, S)));
    }
  }, {
    key: "filterOptions",
    value: function(e) {
      var t = this, c = this.state.inputValue.trim();
      this.props.filterOptions && (this.options = this.props.filterOptions(this.options, c, e, {
        valueKey: this.props.valueKey,
        labelKey: this.props.labelKey
      }));
      var n = this.props.ignoreCase ? function(d) {
        return d[t.props.labelKey].toLowerCase() !== c.toLowerCase().trim();
      } : function(d) {
        return d[t.props.labelKey] !== c.trim();
      };
      if (c && this.props.creatable && this.options.concat(this.props.value).every(n)) {
        var h;
        this.options.push((h = {
          id: c
        }, _defineProperty$5(h, this.props.labelKey, c), _defineProperty$5(h, this.props.valueKey, c), _defineProperty$5(h, "isCreatable", !0), h));
      }
      return this.options;
    }
  }, {
    key: "getSharedProps",
    value: function() {
      var e = this.props, t = e.clearable, c = e.creatable, n = e.disabled, h = e.error, d = e.positive, k = e.isLoading, p = e.multi, M = e.required, S = e.size, AA = e.searchable, H = e.type, gA = e.value, CA = this.state, IA = CA.isOpen, BA = CA.isFocused, QA = CA.isPseudoFocused;
      return {
        $clearable: t,
        $creatable: c,
        $disabled: n,
        $error: h,
        $positive: d,
        $isFocused: BA,
        $isLoading: k,
        $isOpen: IA,
        $isPseudoFocused: QA,
        $multi: p,
        $required: M,
        $searchable: AA,
        $size: S,
        $type: H,
        $isEmpty: !this.getValueArray(gA).length
      };
    }
  }, {
    key: "render",
    value: function() {
      var e = this;
      this.options = normalizeOptions(this.props.options);
      var t = this.props, c = t.overrides, n = c === void 0 ? {} : c, h = t.type, d = t.multi, k = t.noResultsMsg, p = t.value, M = t.filterOutSelected;
      process.env.NODE_ENV !== "production" && p && !Array.isArray(p) && console.warn("The Select component expects an array as the value prop. For more information, please visit the docs at https://baseweb.design/components/select/");
      var S = getOverrides(n.Root, StyledRoot), AA = _slicedToArray$5(S, 2), H = AA[0], gA = AA[1], CA = getOverrides(n.ControlContainer, StyledControlContainer), IA = _slicedToArray$5(CA, 2), BA = IA[0], QA = IA[1], EA = getOverrides(n.ValueContainer, StyledValueContainer), oA = _slicedToArray$5(EA, 2), iA = oA[0], aA = oA[1], tA = getOverrides(n.IconsContainer, StyledIconsContainer), eA = _slicedToArray$5(tA, 2), cA = eA[0], DA = eA[1], nA = getOverrides(n.Popover, Popover$2), wA = _slicedToArray$5(nA, 2), lA = wA[0], NA = wA[1], RA = getOverrides(n.Placeholder, StyledPlaceholder), KA = _slicedToArray$5(RA, 2), vA = KA[0], GA = KA[1], FA = this.getSharedProps(), HA = this.getValueArray(p), sA = this.filterOptions(d && M ? HA : null), mA = this.state.isOpen;
      return FA.$isOpen = mA, process.env.NODE_ENV !== "production" && this.props.error && this.props.positive && console.warn("[Select] `error` and `positive` are both set to `true`. `error` will take precedence but this may not be what you want."), /* @__PURE__ */ React.createElement(UIDConsumer, null, function(xA) {
        return /* @__PURE__ */ React.createElement(LocaleContext.Consumer, null, function(hA) {
          return /* @__PURE__ */ React.createElement(
            lA,
            _extends$7({
              innerRef: function(YA) {
                YA && (e.anchor = YA.anchorRef);
              },
              accessibilityType: ACCESSIBILITY_TYPE.none,
              autoFocus: !1,
              focusLock: !1,
              mountNode: e.props.mountNode,
              onEsc: function() {
                return e.closeMenu();
              },
              isOpen: mA,
              popoverMargin: 0,
              content: function() {
                var YA = {
                  error: e.props.error,
                  positive: e.props.positive,
                  getOptionLabel: e.props.getOptionLabel || e.getOptionLabel.bind(e, hA),
                  id: xA,
                  isLoading: e.props.isLoading,
                  labelKey: e.props.labelKey,
                  maxDropdownHeight: e.props.maxDropdownHeight,
                  multi: d,
                  noResultsMsg: k,
                  onActiveDescendantChange: e.handleActiveDescendantChange,
                  onItemSelect: e.selectValue,
                  options: sA,
                  overrides: n,
                  required: e.props.required,
                  searchable: e.props.searchable,
                  size: e.props.size,
                  type: h,
                  value: HA,
                  valueKey: e.props.valueKey,
                  width: e.anchor.current ? e.anchor.current.clientWidth : null,
                  keyboardControlNode: e.anchor
                };
                return /* @__PURE__ */ React.createElement(SelectDropdown, _extends$7({
                  innerRef: e.dropdown
                }, YA));
              },
              placement: PLACEMENT.bottom
            }, NA),
            /* @__PURE__ */ React.createElement(H, _extends$7({
              onBlur: e.handleBlur,
              "data-baseweb": "select"
            }, FA, gA), /* @__PURE__ */ React.createElement(BA, _extends$7({
              onKeyDown: e.handleKeyDown,
              onClick: e.handleClick,
              onTouchEnd: e.handleTouchEnd,
              onTouchMove: e.handleTouchMove,
              onTouchStart: e.handleTouchStart
            }, FA, QA), h === TYPE.search ? e.renderSearch() : null, /* @__PURE__ */ React.createElement(iA, _extends$7({}, FA, aA), e.renderValue(HA), e.renderInput(xA), e.shouldShowPlaceholder() ? /* @__PURE__ */ React.createElement(vA, _extends$7({}, FA, GA), typeof e.props.placeholder < "u" ? e.props.placeholder : hA.select.placeholder) : null), /* @__PURE__ */ React.createElement(cA, _extends$7({}, FA, DA), e.renderLoading(), e.renderClear(), h === TYPE.select ? e.renderArrow() : null)))
          );
        });
      });
    }
  }]), A;
})(React.Component);
_defineProperty$5(Select$1, "defaultProps", defaultProps);
var tint$1 = { exports: {} }, _curry = { exports: {} }, hasRequired_curry;
function require_curry() {
  return hasRequired_curry || (hasRequired_curry = 1, (function(o, E) {
    E.__esModule = !0, E.default = g;
    function A(e, t, c) {
      return function() {
        var h = c.concat(Array.prototype.slice.call(arguments));
        return h.length >= t ? e.apply(this, h) : A(e, t, h);
      };
    }
    function g(e) {
      return A(e, e.length, []);
    }
    o.exports = E.default;
  })(_curry, _curry.exports)), _curry.exports;
}
var mix = { exports: {} }, rgba = { exports: {} }, parseToRgb = { exports: {} }, _hslToRgb = { exports: {} }, hasRequired_hslToRgb;
function require_hslToRgb() {
  return hasRequired_hslToRgb || (hasRequired_hslToRgb = 1, (function(o, E) {
    E.__esModule = !0, E.default = void 0;
    function A(c) {
      return Math.round(c * 255);
    }
    function g(c, n, h) {
      return A(c) + "," + A(n) + "," + A(h);
    }
    function e(c, n, h, d) {
      if (d === void 0 && (d = g), n === 0)
        return d(h, h, h);
      var k = (c % 360 + 360) % 360 / 60, p = (1 - Math.abs(2 * h - 1)) * n, M = p * (1 - Math.abs(k % 2 - 1)), S = 0, AA = 0, H = 0;
      k >= 0 && k < 1 ? (S = p, AA = M) : k >= 1 && k < 2 ? (S = M, AA = p) : k >= 2 && k < 3 ? (AA = p, H = M) : k >= 3 && k < 4 ? (AA = M, H = p) : k >= 4 && k < 5 ? (S = M, H = p) : k >= 5 && k < 6 && (S = p, H = M);
      var gA = h - p / 2, CA = S + gA, IA = AA + gA, BA = H + gA;
      return d(CA, IA, BA);
    }
    var t = e;
    E.default = t, o.exports = E.default;
  })(_hslToRgb, _hslToRgb.exports)), _hslToRgb.exports;
}
var _nameToHex = { exports: {} }, hasRequired_nameToHex;
function require_nameToHex() {
  return hasRequired_nameToHex || (hasRequired_nameToHex = 1, (function(o, E) {
    E.__esModule = !0, E.default = void 0;
    var A = {
      aliceblue: "f0f8ff",
      antiquewhite: "faebd7",
      aqua: "00ffff",
      aquamarine: "7fffd4",
      azure: "f0ffff",
      beige: "f5f5dc",
      bisque: "ffe4c4",
      black: "000",
      blanchedalmond: "ffebcd",
      blue: "0000ff",
      blueviolet: "8a2be2",
      brown: "a52a2a",
      burlywood: "deb887",
      cadetblue: "5f9ea0",
      chartreuse: "7fff00",
      chocolate: "d2691e",
      coral: "ff7f50",
      cornflowerblue: "6495ed",
      cornsilk: "fff8dc",
      crimson: "dc143c",
      cyan: "00ffff",
      darkblue: "00008b",
      darkcyan: "008b8b",
      darkgoldenrod: "b8860b",
      darkgray: "a9a9a9",
      darkgreen: "006400",
      darkgrey: "a9a9a9",
      darkkhaki: "bdb76b",
      darkmagenta: "8b008b",
      darkolivegreen: "556b2f",
      darkorange: "ff8c00",
      darkorchid: "9932cc",
      darkred: "8b0000",
      darksalmon: "e9967a",
      darkseagreen: "8fbc8f",
      darkslateblue: "483d8b",
      darkslategray: "2f4f4f",
      darkslategrey: "2f4f4f",
      darkturquoise: "00ced1",
      darkviolet: "9400d3",
      deeppink: "ff1493",
      deepskyblue: "00bfff",
      dimgray: "696969",
      dimgrey: "696969",
      dodgerblue: "1e90ff",
      firebrick: "b22222",
      floralwhite: "fffaf0",
      forestgreen: "228b22",
      fuchsia: "ff00ff",
      gainsboro: "dcdcdc",
      ghostwhite: "f8f8ff",
      gold: "ffd700",
      goldenrod: "daa520",
      gray: "808080",
      green: "008000",
      greenyellow: "adff2f",
      grey: "808080",
      honeydew: "f0fff0",
      hotpink: "ff69b4",
      indianred: "cd5c5c",
      indigo: "4b0082",
      ivory: "fffff0",
      khaki: "f0e68c",
      lavender: "e6e6fa",
      lavenderblush: "fff0f5",
      lawngreen: "7cfc00",
      lemonchiffon: "fffacd",
      lightblue: "add8e6",
      lightcoral: "f08080",
      lightcyan: "e0ffff",
      lightgoldenrodyellow: "fafad2",
      lightgray: "d3d3d3",
      lightgreen: "90ee90",
      lightgrey: "d3d3d3",
      lightpink: "ffb6c1",
      lightsalmon: "ffa07a",
      lightseagreen: "20b2aa",
      lightskyblue: "87cefa",
      lightslategray: "789",
      lightslategrey: "789",
      lightsteelblue: "b0c4de",
      lightyellow: "ffffe0",
      lime: "0f0",
      limegreen: "32cd32",
      linen: "faf0e6",
      magenta: "f0f",
      maroon: "800000",
      mediumaquamarine: "66cdaa",
      mediumblue: "0000cd",
      mediumorchid: "ba55d3",
      mediumpurple: "9370db",
      mediumseagreen: "3cb371",
      mediumslateblue: "7b68ee",
      mediumspringgreen: "00fa9a",
      mediumturquoise: "48d1cc",
      mediumvioletred: "c71585",
      midnightblue: "191970",
      mintcream: "f5fffa",
      mistyrose: "ffe4e1",
      moccasin: "ffe4b5",
      navajowhite: "ffdead",
      navy: "000080",
      oldlace: "fdf5e6",
      olive: "808000",
      olivedrab: "6b8e23",
      orange: "ffa500",
      orangered: "ff4500",
      orchid: "da70d6",
      palegoldenrod: "eee8aa",
      palegreen: "98fb98",
      paleturquoise: "afeeee",
      palevioletred: "db7093",
      papayawhip: "ffefd5",
      peachpuff: "ffdab9",
      peru: "cd853f",
      pink: "ffc0cb",
      plum: "dda0dd",
      powderblue: "b0e0e6",
      purple: "800080",
      rebeccapurple: "639",
      red: "f00",
      rosybrown: "bc8f8f",
      royalblue: "4169e1",
      saddlebrown: "8b4513",
      salmon: "fa8072",
      sandybrown: "f4a460",
      seagreen: "2e8b57",
      seashell: "fff5ee",
      sienna: "a0522d",
      silver: "c0c0c0",
      skyblue: "87ceeb",
      slateblue: "6a5acd",
      slategray: "708090",
      slategrey: "708090",
      snow: "fffafa",
      springgreen: "00ff7f",
      steelblue: "4682b4",
      tan: "d2b48c",
      teal: "008080",
      thistle: "d8bfd8",
      tomato: "ff6347",
      turquoise: "40e0d0",
      violet: "ee82ee",
      wheat: "f5deb3",
      white: "fff",
      whitesmoke: "f5f5f5",
      yellow: "ff0",
      yellowgreen: "9acd32"
    };
    function g(t) {
      if (typeof t != "string") return t;
      var c = t.toLowerCase();
      return A[c] ? "#" + A[c] : t;
    }
    var e = g;
    E.default = e, o.exports = E.default;
  })(_nameToHex, _nameToHex.exports)), _nameToHex.exports;
}
var _errors = { exports: {} }, hasRequired_errors;
function require_errors() {
  return hasRequired_errors || (hasRequired_errors = 1, (function(o, E) {
    E.__esModule = !0, E.default = void 0;
    function A(S) {
      if (S === void 0)
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return S;
    }
    function g(S, AA) {
      S.prototype = Object.create(AA.prototype), S.prototype.constructor = S, h(S, AA);
    }
    function e(S) {
      var AA = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
      return e = function(gA) {
        if (gA === null || !n(gA)) return gA;
        if (typeof gA != "function")
          throw new TypeError("Super expression must either be null or a function");
        if (typeof AA < "u") {
          if (AA.has(gA)) return AA.get(gA);
          AA.set(gA, CA);
        }
        function CA() {
          return t(gA, arguments, d(this).constructor);
        }
        return CA.prototype = Object.create(gA.prototype, { constructor: { value: CA, enumerable: !1, writable: !0, configurable: !0 } }), h(CA, gA);
      }, e(S);
    }
    function t(S, AA, H) {
      return c() ? t = Reflect.construct : t = function(CA, IA, BA) {
        var QA = [null];
        QA.push.apply(QA, IA);
        var EA = Function.bind.apply(CA, QA), oA = new EA();
        return BA && h(oA, BA.prototype), oA;
      }, t.apply(null, arguments);
    }
    function c() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
      if (typeof Proxy == "function") return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    function n(S) {
      return Function.toString.call(S).indexOf("[native code]") !== -1;
    }
    function h(S, AA) {
      return h = Object.setPrototypeOf || function(gA, CA) {
        return gA.__proto__ = CA, gA;
      }, h(S, AA);
    }
    function d(S) {
      return d = Object.setPrototypeOf ? Object.getPrototypeOf : function(H) {
        return H.__proto__ || Object.getPrototypeOf(H);
      }, d(S);
    }
    var k = {
      1: `Passed invalid arguments to hsl, please pass multiple numbers e.g. hsl(360, 0.75, 0.4) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75 }).

`,
      2: `Passed invalid arguments to hsla, please pass multiple numbers e.g. hsla(360, 0.75, 0.4, 0.7) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75, alpha: 0.7 }).

`,
      3: `Passed an incorrect argument to a color function, please pass a string representation of a color.

`,
      4: `Couldn't generate valid rgb string from %s, it returned %s.

`,
      5: `Couldn't parse the color string. Please provide the color as a string in hex, rgb, rgba, hsl or hsla notation.

`,
      6: `Passed invalid arguments to rgb, please pass multiple numbers e.g. rgb(255, 205, 100) or an object e.g. rgb({ red: 255, green: 205, blue: 100 }).

`,
      7: `Passed invalid arguments to rgba, please pass multiple numbers e.g. rgb(255, 205, 100, 0.75) or an object e.g. rgb({ red: 255, green: 205, blue: 100, alpha: 0.75 }).

`,
      8: `Passed invalid argument to toColorString, please pass a RgbColor, RgbaColor, HslColor or HslaColor object.

`,
      9: `Please provide a number of steps to the modularScale helper.

`,
      10: `Please pass a number or one of the predefined scales to the modularScale helper as the ratio.

`,
      11: `Invalid value passed as base to modularScale, expected number or em string but got "%s"

`,
      12: `Expected a string ending in "px" or a number passed as the first argument to %s(), got "%s" instead.

`,
      13: `Expected a string ending in "px" or a number passed as the second argument to %s(), got "%s" instead.

`,
      14: `Passed invalid pixel value ("%s") to %s(), please pass a value like "12px" or 12.

`,
      15: `Passed invalid base value ("%s") to %s(), please pass a value like "12px" or 12.

`,
      16: `You must provide a template to this method.

`,
      17: `You passed an unsupported selector state to this method.

`,
      18: `minScreen and maxScreen must be provided as stringified numbers with the same units.

`,
      19: `fromSize and toSize must be provided as stringified numbers with the same units.

`,
      20: `expects either an array of objects or a single object with the properties prop, fromSize, and toSize.

`,
      21: "expects the objects in the first argument array to have the properties `prop`, `fromSize`, and `toSize`.\n\n",
      22: "expects the first argument object to have the properties `prop`, `fromSize`, and `toSize`.\n\n",
      23: `fontFace expects a name of a font-family.

`,
      24: `fontFace expects either the path to the font file(s) or a name of a local copy.

`,
      25: `fontFace expects localFonts to be an array.

`,
      26: `fontFace expects fileFormats to be an array.

`,
      27: `radialGradient requries at least 2 color-stops to properly render.

`,
      28: `Please supply a filename to retinaImage() as the first argument.

`,
      29: `Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.

`,
      30: "Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n",
      31: `The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation

`,
      32: `To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])
To pass a single animation please supply them in simple values, e.g. animation('rotate', '2s')

`,
      33: `The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation

`,
      34: `borderRadius expects a radius value as a string or number as the second argument.

`,
      35: `borderRadius expects one of "top", "bottom", "left" or "right" as the first argument.

`,
      36: `Property must be a string value.

`,
      37: `Syntax Error at %s.

`,
      38: `Formula contains a function that needs parentheses at %s.

`,
      39: `Formula is missing closing parenthesis at %s.

`,
      40: `Formula has too many closing parentheses at %s.

`,
      41: `All values in a formula must have the same unit or be unitless.

`,
      42: `Please provide a number of steps to the modularScale helper.

`,
      43: `Please pass a number or one of the predefined scales to the modularScale helper as the ratio.

`,
      44: `Invalid value passed as base to modularScale, expected number or em/rem string but got %s.

`,
      45: `Passed invalid argument to hslToColorString, please pass a HslColor or HslaColor object.

`,
      46: `Passed invalid argument to rgbToColorString, please pass a RgbColor or RgbaColor object.

`,
      47: `minScreen and maxScreen must be provided as stringified numbers with the same units.

`,
      48: `fromSize and toSize must be provided as stringified numbers with the same units.

`,
      49: `Expects either an array of objects or a single object with the properties prop, fromSize, and toSize.

`,
      50: `Expects the objects in the first argument array to have the properties prop, fromSize, and toSize.

`,
      51: `Expects the first argument object to have the properties prop, fromSize, and toSize.

`,
      52: `fontFace expects either the path to the font file(s) or a name of a local copy.

`,
      53: `fontFace expects localFonts to be an array.

`,
      54: `fontFace expects fileFormats to be an array.

`,
      55: `fontFace expects a name of a font-family.

`,
      56: `linearGradient requries at least 2 color-stops to properly render.

`,
      57: `radialGradient requries at least 2 color-stops to properly render.

`,
      58: `Please supply a filename to retinaImage() as the first argument.

`,
      59: `Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.

`,
      60: "Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n",
      61: `Property must be a string value.

`,
      62: `borderRadius expects a radius value as a string or number as the second argument.

`,
      63: `borderRadius expects one of "top", "bottom", "left" or "right" as the first argument.

`,
      64: `The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation.

`,
      65: `To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s').

`,
      66: `The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation.

`,
      67: `You must provide a template to this method.

`,
      68: `You passed an unsupported selector state to this method.

`,
      69: `Expected a string ending in "px" or a number passed as the first argument to %s(), got %s instead.

`,
      70: `Expected a string ending in "px" or a number passed as the second argument to %s(), got %s instead.

`,
      71: `Passed invalid pixel value %s to %s(), please pass a value like "12px" or 12.

`,
      72: `Passed invalid base value %s to %s(), please pass a value like "12px" or 12.

`,
      73: `Please provide a valid CSS variable.

`,
      74: `CSS variable not found.

`,
      75: `fromSize and toSize must be provided as stringified numbers with the same units as minScreen and maxScreen.
`
    };
    function p() {
      for (var S = arguments.length, AA = new Array(S), H = 0; H < S; H++)
        AA[H] = arguments[H];
      var gA = AA[0], CA = [], IA;
      for (IA = 1; IA < AA.length; IA += 1)
        CA.push(AA[IA]);
      return CA.forEach(function(BA) {
        gA = gA.replace(/%[a-z]/, BA);
      }), gA;
    }
    var M = /* @__PURE__ */ (function(S) {
      g(AA, S);
      function AA(H) {
        var gA;
        if (process.env.NODE_ENV === "production")
          gA = S.call(this, "An error occurred. See https://github.com/styled-components/polished/blob/main/src/internalHelpers/errors.md#" + H + " for more information.") || this;
        else {
          for (var CA = arguments.length, IA = new Array(CA > 1 ? CA - 1 : 0), BA = 1; BA < CA; BA++)
            IA[BA - 1] = arguments[BA];
          gA = S.call(this, p.apply(void 0, [k[H]].concat(IA))) || this;
        }
        return A(gA);
      }
      return AA;
    })(/* @__PURE__ */ e(Error));
    E.default = M, o.exports = E.default;
  })(_errors, _errors.exports)), _errors.exports;
}
var hasRequiredParseToRgb;
function requireParseToRgb() {
  return hasRequiredParseToRgb || (hasRequiredParseToRgb = 1, (function(o, E) {
    E.__esModule = !0, E.default = AA;
    var A = /* @__PURE__ */ t(/* @__PURE__ */ require_hslToRgb()), g = /* @__PURE__ */ t(/* @__PURE__ */ require_nameToHex()), e = /* @__PURE__ */ t(/* @__PURE__ */ require_errors());
    function t(H) {
      return H && H.__esModule ? H : { default: H };
    }
    var c = /^#[a-fA-F0-9]{6}$/, n = /^#[a-fA-F0-9]{8}$/, h = /^#[a-fA-F0-9]{3}$/, d = /^#[a-fA-F0-9]{4}$/, k = /^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/i, p = /^rgba\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*([-+]?[0-9]*[.]?[0-9]+)\s*\)$/i, M = /^hsl\(\s*(\d{0,3}[.]?[0-9]+)\s*,\s*(\d{1,3}[.]?[0-9]?)%\s*,\s*(\d{1,3}[.]?[0-9]?)%\s*\)$/i, S = /^hsla\(\s*(\d{0,3}[.]?[0-9]+)\s*,\s*(\d{1,3}[.]?[0-9]?)%\s*,\s*(\d{1,3}[.]?[0-9]?)%\s*,\s*([-+]?[0-9]*[.]?[0-9]+)\s*\)$/i;
    function AA(H) {
      if (typeof H != "string")
        throw new e.default(3);
      var gA = (0, g.default)(H);
      if (gA.match(c))
        return {
          red: parseInt("" + gA[1] + gA[2], 16),
          green: parseInt("" + gA[3] + gA[4], 16),
          blue: parseInt("" + gA[5] + gA[6], 16)
        };
      if (gA.match(n)) {
        var CA = parseFloat((parseInt("" + gA[7] + gA[8], 16) / 255).toFixed(2));
        return {
          red: parseInt("" + gA[1] + gA[2], 16),
          green: parseInt("" + gA[3] + gA[4], 16),
          blue: parseInt("" + gA[5] + gA[6], 16),
          alpha: CA
        };
      }
      if (gA.match(h))
        return {
          red: parseInt("" + gA[1] + gA[1], 16),
          green: parseInt("" + gA[2] + gA[2], 16),
          blue: parseInt("" + gA[3] + gA[3], 16)
        };
      if (gA.match(d)) {
        var IA = parseFloat((parseInt("" + gA[4] + gA[4], 16) / 255).toFixed(2));
        return {
          red: parseInt("" + gA[1] + gA[1], 16),
          green: parseInt("" + gA[2] + gA[2], 16),
          blue: parseInt("" + gA[3] + gA[3], 16),
          alpha: IA
        };
      }
      var BA = k.exec(gA);
      if (BA)
        return {
          red: parseInt("" + BA[1], 10),
          green: parseInt("" + BA[2], 10),
          blue: parseInt("" + BA[3], 10)
        };
      var QA = p.exec(gA.substring(0, 50));
      if (QA)
        return {
          red: parseInt("" + QA[1], 10),
          green: parseInt("" + QA[2], 10),
          blue: parseInt("" + QA[3], 10),
          alpha: parseFloat("" + QA[4])
        };
      var EA = M.exec(gA);
      if (EA) {
        var oA = parseInt("" + EA[1], 10), iA = parseInt("" + EA[2], 10) / 100, aA = parseInt("" + EA[3], 10) / 100, tA = "rgb(" + (0, A.default)(oA, iA, aA) + ")", eA = k.exec(tA);
        if (!eA)
          throw new e.default(4, gA, tA);
        return {
          red: parseInt("" + eA[1], 10),
          green: parseInt("" + eA[2], 10),
          blue: parseInt("" + eA[3], 10)
        };
      }
      var cA = S.exec(gA.substring(0, 50));
      if (cA) {
        var DA = parseInt("" + cA[1], 10), nA = parseInt("" + cA[2], 10) / 100, wA = parseInt("" + cA[3], 10) / 100, lA = "rgb(" + (0, A.default)(DA, nA, wA) + ")", NA = k.exec(lA);
        if (!NA)
          throw new e.default(4, gA, lA);
        return {
          red: parseInt("" + NA[1], 10),
          green: parseInt("" + NA[2], 10),
          blue: parseInt("" + NA[3], 10),
          alpha: parseFloat("" + cA[4])
        };
      }
      throw new e.default(5);
    }
    o.exports = E.default;
  })(parseToRgb, parseToRgb.exports)), parseToRgb.exports;
}
var rgb = { exports: {} }, _reduceHexValue = { exports: {} }, hasRequired_reduceHexValue;
function require_reduceHexValue() {
  return hasRequired_reduceHexValue || (hasRequired_reduceHexValue = 1, (function(o, E) {
    E.__esModule = !0, E.default = void 0;
    var A = function(t) {
      return t.length === 7 && t[1] === t[2] && t[3] === t[4] && t[5] === t[6] ? "#" + t[1] + t[3] + t[5] : t;
    }, g = A;
    E.default = g, o.exports = E.default;
  })(_reduceHexValue, _reduceHexValue.exports)), _reduceHexValue.exports;
}
var _numberToHex = { exports: {} }, hasRequired_numberToHex;
function require_numberToHex() {
  return hasRequired_numberToHex || (hasRequired_numberToHex = 1, (function(o, E) {
    E.__esModule = !0, E.default = void 0;
    function A(e) {
      var t = e.toString(16);
      return t.length === 1 ? "0" + t : t;
    }
    var g = A;
    E.default = g, o.exports = E.default;
  })(_numberToHex, _numberToHex.exports)), _numberToHex.exports;
}
var hasRequiredRgb;
function requireRgb() {
  return hasRequiredRgb || (hasRequiredRgb = 1, (function(o, E) {
    E.__esModule = !0, E.default = c;
    var A = /* @__PURE__ */ t(/* @__PURE__ */ require_reduceHexValue()), g = /* @__PURE__ */ t(/* @__PURE__ */ require_numberToHex()), e = /* @__PURE__ */ t(/* @__PURE__ */ require_errors());
    function t(n) {
      return n && n.__esModule ? n : { default: n };
    }
    function c(n, h, d) {
      if (typeof n == "number" && typeof h == "number" && typeof d == "number")
        return (0, A.default)("#" + (0, g.default)(n) + (0, g.default)(h) + (0, g.default)(d));
      if (typeof n == "object" && h === void 0 && d === void 0)
        return (0, A.default)("#" + (0, g.default)(n.red) + (0, g.default)(n.green) + (0, g.default)(n.blue));
      throw new e.default(6);
    }
    o.exports = E.default;
  })(rgb, rgb.exports)), rgb.exports;
}
var hasRequiredRgba;
function requireRgba() {
  return hasRequiredRgba || (hasRequiredRgba = 1, (function(o, E) {
    E.__esModule = !0, E.default = c;
    var A = /* @__PURE__ */ t(/* @__PURE__ */ requireParseToRgb()), g = /* @__PURE__ */ t(/* @__PURE__ */ requireRgb()), e = /* @__PURE__ */ t(/* @__PURE__ */ require_errors());
    function t(n) {
      return n && n.__esModule ? n : { default: n };
    }
    function c(n, h, d, k) {
      if (typeof n == "string" && typeof h == "number") {
        var p = (0, A.default)(n);
        return "rgba(" + p.red + "," + p.green + "," + p.blue + "," + h + ")";
      } else {
        if (typeof n == "number" && typeof h == "number" && typeof d == "number" && typeof k == "number")
          return k >= 1 ? (0, g.default)(n, h, d) : "rgba(" + n + "," + h + "," + d + "," + k + ")";
        if (typeof n == "object" && h === void 0 && d === void 0 && k === void 0)
          return n.alpha >= 1 ? (0, g.default)(n.red, n.green, n.blue) : "rgba(" + n.red + "," + n.green + "," + n.blue + "," + n.alpha + ")";
      }
      throw new e.default(7);
    }
    o.exports = E.default;
  })(rgba, rgba.exports)), rgba.exports;
}
var hasRequiredMix;
function requireMix() {
  return hasRequiredMix || (hasRequiredMix = 1, (function(o, E) {
    E.__esModule = !0, E.default = void 0;
    var A = /* @__PURE__ */ t(/* @__PURE__ */ require_curry()), g = /* @__PURE__ */ t(/* @__PURE__ */ requireRgba()), e = /* @__PURE__ */ t(/* @__PURE__ */ requireParseToRgb());
    function t(k) {
      return k && k.__esModule ? k : { default: k };
    }
    function c() {
      return c = Object.assign || function(k) {
        for (var p = 1; p < arguments.length; p++) {
          var M = arguments[p];
          for (var S in M)
            Object.prototype.hasOwnProperty.call(M, S) && (k[S] = M[S]);
        }
        return k;
      }, c.apply(this, arguments);
    }
    function n(k, p, M) {
      if (p === "transparent") return M;
      if (M === "transparent") return p;
      if (k === 0) return M;
      var S = (0, e.default)(p), AA = c({}, S, {
        alpha: typeof S.alpha == "number" ? S.alpha : 1
      }), H = (0, e.default)(M), gA = c({}, H, {
        alpha: typeof H.alpha == "number" ? H.alpha : 1
      }), CA = AA.alpha - gA.alpha, IA = parseFloat(k) * 2 - 1, BA = IA * CA === -1 ? IA : IA + CA, QA = 1 + IA * CA, EA = (BA / QA + 1) / 2, oA = 1 - EA, iA = {
        red: Math.floor(AA.red * EA + gA.red * oA),
        green: Math.floor(AA.green * EA + gA.green * oA),
        blue: Math.floor(AA.blue * EA + gA.blue * oA),
        alpha: AA.alpha * (parseFloat(k) / 1) + gA.alpha * (1 - parseFloat(k) / 1)
      };
      return (0, g.default)(iA);
    }
    var h = /* @__PURE__ */ (0, A.default)(n), d = h;
    E.default = d, o.exports = E.default;
  })(mix, mix.exports)), mix.exports;
}
var hasRequiredTint;
function requireTint() {
  return hasRequiredTint || (hasRequiredTint = 1, (function(o, E) {
    E.__esModule = !0, E.default = void 0;
    var A = /* @__PURE__ */ e(/* @__PURE__ */ require_curry()), g = /* @__PURE__ */ e(/* @__PURE__ */ requireMix());
    function e(h) {
      return h && h.__esModule ? h : { default: h };
    }
    function t(h, d) {
      return d === "transparent" ? d : (0, g.default)(parseFloat(h), "rgb(255, 255, 255)", d);
    }
    var c = /* @__PURE__ */ (0, A.default)(t), n = c;
    E.default = n, o.exports = E.default;
  })(tint$1, tint$1.exports)), tint$1.exports;
}
var tintExports = /* @__PURE__ */ requireTint();
const tint = /* @__PURE__ */ getDefaultExportFromCjs(tintExports);
var shade$1 = { exports: {} }, hasRequiredShade;
function requireShade() {
  return hasRequiredShade || (hasRequiredShade = 1, (function(o, E) {
    E.__esModule = !0, E.default = void 0;
    var A = /* @__PURE__ */ e(/* @__PURE__ */ require_curry()), g = /* @__PURE__ */ e(/* @__PURE__ */ requireMix());
    function e(h) {
      return h && h.__esModule ? h : { default: h };
    }
    function t(h, d) {
      return d === "transparent" ? d : (0, g.default)(parseFloat(h), "rgb(0, 0, 0)", d);
    }
    var c = /* @__PURE__ */ (0, A.default)(t), n = c;
    E.default = n, o.exports = E.default;
  })(shade$1, shade$1.exports)), shade$1.exports;
}
var shadeExports = /* @__PURE__ */ requireShade();
const shade = /* @__PURE__ */ getDefaultExportFromCjs(shadeExports);
var SIZE = {
  small: "small",
  medium: "medium",
  large: "large"
}, VARIANT = Object.freeze({
  solid: "solid",
  light: "light",
  outlined: "outlined"
}), KIND = {
  custom: "custom",
  // semantic
  neutral: "neutral",
  primary: "primary",
  accent: "accent",
  positive: "positive",
  warning: "warning",
  negative: "negative",
  // primitive
  black: "black",
  blue: "blue",
  green: "green",
  red: "red",
  yellow: "yellow",
  orange: "orange",
  purple: "purple",
  brown: "brown"
}, _neutralColorStates, _primaryColorStates, _accentColorStates, _positiveColorStates, _warningColorStates, _negativeColorStates, _orangeColorStates, _purpleColorStates, _brownColorStates, _customColorStates, _colorMap;
function ownKeys$4(o, E) {
  var A = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var g = Object.getOwnPropertySymbols(o);
    E && (g = g.filter(function(e) {
      return Object.getOwnPropertyDescriptor(o, e).enumerable;
    })), A.push.apply(A, g);
  }
  return A;
}
function _objectSpread$2(o) {
  for (var E = 1; E < arguments.length; E++) {
    var A = arguments[E] != null ? arguments[E] : {};
    E % 2 ? ownKeys$4(Object(A), !0).forEach(function(g) {
      _defineProperty$4(o, g, A[g]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(A)) : ownKeys$4(Object(A)).forEach(function(g) {
      Object.defineProperty(o, g, Object.getOwnPropertyDescriptor(A, g));
    });
  }
  return o;
}
function _defineProperty$4(o, E, A) {
  return E in o ? Object.defineProperty(o, E, { value: A, enumerable: !0, configurable: !0, writable: !0 }) : o[E] = A, o;
}
function customOnRamp(o, E) {
  switch (E) {
    case "0":
      return "white";
    case "50":
      return tint(0.8, o);
    case "100":
      return tint(0.6, o);
    case "200":
      return tint(0.4, o);
    case "300":
      return tint(0.2, o);
    case "400":
      return o;
    case "500":
      return shade(0.2, o);
    case "600":
      return shade(0.4, o);
    case "700":
      return shade(0.6, o);
    case "800":
      return shade(0.8, o);
    case "1000":
      return "black";
    default:
      return o;
  }
}
var COLOR_STATE = {
  disabled: "disabled",
  solid: "solid",
  outline: "outline"
}, pick = function o(E, A, g) {
  return E.name && E.name.includes("dark") ? g : A;
}, neutralColorStates = (_neutralColorStates = {}, _defineProperty$4(_neutralColorStates, COLOR_STATE.disabled, function(o, E) {
  return {
    color: o.colors.tagNeutralFontDisabled,
    backgroundColor: null,
    borderColor: o.colors.tagNeutralOutlinedDisabled
  };
}), _defineProperty$4(_neutralColorStates, COLOR_STATE.solid, function(o, E) {
  return {
    color: o.colors.tagNeutralSolidFont,
    backgroundColor: o.colors.tagNeutralSolidBackground,
    borderColor: null
  };
}), _defineProperty$4(_neutralColorStates, COLOR_STATE.outline, function(o, E) {
  return {
    color: o.colors.tagNeutralOutlinedFont,
    backgroundColor: null,
    borderColor: o.colors.tagNeutralOutlinedBackground
  };
}), _neutralColorStates), primaryColorStates = (_primaryColorStates = {}, _defineProperty$4(_primaryColorStates, COLOR_STATE.disabled, function(o, E) {
  return {
    color: o.colors.tagPrimaryFontDisabled,
    backgroundColor: null,
    borderColor: o.colors.tagPrimaryOutlinedDisabled
  };
}), _defineProperty$4(_primaryColorStates, COLOR_STATE.solid, function(o, E) {
  return {
    color: o.colors.tagPrimarySolidFont,
    backgroundColor: o.colors.tagPrimarySolidBackground,
    borderColor: null
  };
}), _defineProperty$4(_primaryColorStates, COLOR_STATE.outline, function(o, E) {
  return {
    color: o.colors.tagPrimaryOutlinedFont,
    backgroundColor: null,
    borderColor: o.colors.tagPrimaryOutlinedBackground
  };
}), _primaryColorStates), accentColorStates = (_accentColorStates = {}, _defineProperty$4(_accentColorStates, COLOR_STATE.disabled, function(o, E) {
  return {
    color: o.colors.tagAccentFontDisabled,
    backgroundColor: null,
    borderColor: o.colors.tagAccentOutlinedDisabled
  };
}), _defineProperty$4(_accentColorStates, COLOR_STATE.solid, function(o, E) {
  return {
    color: o.colors.tagAccentSolidFont,
    backgroundColor: o.colors.tagAccentSolidBackground,
    borderColor: null
  };
}), _defineProperty$4(_accentColorStates, COLOR_STATE.outline, function(o, E) {
  return {
    color: o.colors.tagAccentOutlinedFont,
    backgroundColor: null,
    borderColor: o.colors.tagAccentOutlinedBackground
  };
}), _accentColorStates), positiveColorStates = (_positiveColorStates = {}, _defineProperty$4(_positiveColorStates, COLOR_STATE.disabled, function(o, E) {
  return {
    color: o.colors.tagPositiveFontDisabled,
    backgroundColor: null,
    borderColor: o.colors.tagPositiveOutlinedDisabled
  };
}), _defineProperty$4(_positiveColorStates, COLOR_STATE.solid, function(o, E) {
  return {
    color: o.colors.tagPositiveSolidFont,
    backgroundColor: o.colors.tagPositiveSolidBackground,
    borderColor: null
  };
}), _defineProperty$4(_positiveColorStates, COLOR_STATE.outline, function(o, E) {
  return {
    color: o.colors.tagPositiveOutlinedFont,
    backgroundColor: null,
    borderColor: o.colors.tagPositiveOutlinedBackground
  };
}), _positiveColorStates), warningColorStates = (_warningColorStates = {}, _defineProperty$4(_warningColorStates, COLOR_STATE.disabled, function(o, E) {
  return {
    color: o.colors.tagWarningFontDisabled,
    backgroundColor: null,
    borderColor: o.colors.tagWarningOutlinedDisabled
  };
}), _defineProperty$4(_warningColorStates, COLOR_STATE.solid, function(o, E) {
  return {
    color: o.colors.tagWarningSolidFont,
    backgroundColor: o.colors.tagWarningSolidBackground,
    borderColor: null
  };
}), _defineProperty$4(_warningColorStates, COLOR_STATE.outline, function(o, E) {
  return {
    color: o.colors.tagWarningOutlinedFont,
    backgroundColor: null,
    borderColor: o.colors.tagWarningOutlinedBackground
  };
}), _warningColorStates), negativeColorStates = (_negativeColorStates = {}, _defineProperty$4(_negativeColorStates, COLOR_STATE.disabled, function(o, E) {
  return {
    color: o.colors.tagNegativeFontDisabled,
    backgroundColor: null,
    borderColor: o.colors.tagNegativeOutlinedDisabled
  };
}), _defineProperty$4(_negativeColorStates, COLOR_STATE.solid, function(o, E) {
  return {
    color: o.colors.tagNegativeSolidFont,
    backgroundColor: o.colors.tagNegativeSolidBackground,
    borderColor: null
  };
}), _defineProperty$4(_negativeColorStates, COLOR_STATE.outline, function(o, E) {
  return {
    color: o.colors.tagNegativeOutlinedFont,
    backgroundColor: null,
    borderColor: o.colors.tagNegativeOutlinedBackground
  };
}), _negativeColorStates), orangeColorStates = (_orangeColorStates = {}, _defineProperty$4(_orangeColorStates, COLOR_STATE.disabled, function(o, E) {
  return {
    color: pick(o, colors$1.orange200, colors$1.orange600),
    backgroundColor: null,
    borderColor: pick(o, colors$1.orange200, colors$1.orange700)
  };
}), _defineProperty$4(_orangeColorStates, COLOR_STATE.solid, function(o, E) {
  return {
    color: colors$1.white,
    backgroundColor: pick(o, colors$1.orange400, colors$1.orange500),
    borderColor: null
  };
}), _defineProperty$4(_orangeColorStates, COLOR_STATE.outline, function(o, E) {
  return {
    color: pick(o, colors$1.orange400, colors$1.orange300),
    backgroundColor: null,
    borderColor: pick(o, colors$1.orange200, colors$1.orange500)
  };
}), _orangeColorStates), purpleColorStates = (_purpleColorStates = {}, _defineProperty$4(_purpleColorStates, COLOR_STATE.disabled, function(o, E) {
  return {
    color: pick(o, colors$1.purple200, colors$1.purple600),
    backgroundColor: null,
    borderColor: pick(o, colors$1.purple200, colors$1.purple700)
  };
}), _defineProperty$4(_purpleColorStates, COLOR_STATE.solid, function(o, E) {
  return {
    color: colors$1.white,
    backgroundColor: pick(o, colors$1.purple400, colors$1.purple500),
    borderColor: null
  };
}), _defineProperty$4(_purpleColorStates, COLOR_STATE.outline, function(o, E) {
  return {
    color: pick(o, colors$1.purple400, colors$1.purple300),
    backgroundColor: null,
    borderColor: pick(o, colors$1.purple200, colors$1.purple500)
  };
}), _purpleColorStates), brownColorStates = (_brownColorStates = {}, _defineProperty$4(_brownColorStates, COLOR_STATE.disabled, function(o, E) {
  return {
    color: pick(o, colors$1.brown200, colors$1.brown600),
    backgroundColor: null,
    borderColor: pick(o, colors$1.brown200, colors$1.brown700)
  };
}), _defineProperty$4(_brownColorStates, COLOR_STATE.solid, function(o, E) {
  return {
    color: colors$1.white,
    backgroundColor: pick(o, colors$1.brown400, colors$1.brown500),
    borderColor: null
  };
}), _defineProperty$4(_brownColorStates, COLOR_STATE.outline, function(o, E) {
  return {
    color: pick(o, colors$1.brown400, colors$1.brown300),
    backgroundColor: null,
    borderColor: pick(o, colors$1.brown200, colors$1.brown500)
  };
}), _brownColorStates), customColorStates = (_customColorStates = {}, _defineProperty$4(_customColorStates, COLOR_STATE.disabled, function(o, E) {
  return {
    color: customOnRamp(E, o.colors.tagFontDisabledRampUnit),
    backgroundColor: null,
    borderColor: customOnRamp(E, o.colors.tagSolidDisabledRampUnit)
  };
}), _defineProperty$4(_customColorStates, COLOR_STATE.solid, function(o, E) {
  return {
    color: customOnRamp(E, o.colors.tagSolidFontRampUnit),
    backgroundColor: customOnRamp(E, o.colors.tagSolidRampUnit),
    borderColor: null
  };
}), _defineProperty$4(_customColorStates, COLOR_STATE.outline, function(o, E) {
  return {
    color: customOnRamp(E, o.colors.tagOutlinedFontRampUnit),
    backgroundColor: null,
    borderColor: customOnRamp(E, o.colors.tagOutlinedRampUnit)
  };
}), _customColorStates), colorMap = (_colorMap = {}, _defineProperty$4(_colorMap, KIND.neutral, neutralColorStates), _defineProperty$4(_colorMap, KIND.primary, primaryColorStates), _defineProperty$4(_colorMap, KIND.accent, accentColorStates), _defineProperty$4(_colorMap, KIND.positive, positiveColorStates), _defineProperty$4(_colorMap, KIND.warning, warningColorStates), _defineProperty$4(_colorMap, KIND.negative, negativeColorStates), _defineProperty$4(_colorMap, KIND.black, primaryColorStates), _defineProperty$4(_colorMap, KIND.blue, accentColorStates), _defineProperty$4(_colorMap, KIND.green, positiveColorStates), _defineProperty$4(_colorMap, KIND.red, negativeColorStates), _defineProperty$4(_colorMap, KIND.yellow, warningColorStates), _defineProperty$4(_colorMap, KIND.orange, orangeColorStates), _defineProperty$4(_colorMap, KIND.purple, purpleColorStates), _defineProperty$4(_colorMap, KIND.brown, brownColorStates), _defineProperty$4(_colorMap, KIND.custom, customColorStates), _colorMap), getColorStateFromProps = function o(E) {
  return E.$disabled ? COLOR_STATE.disabled : E.$variant === VARIANT.solid ? COLOR_STATE.solid : COLOR_STATE.outline;
}, Action$1 = styled("span", function(o) {
  var E, A, g = o.$theme, e = o.$disabled, t = o.$size, c = t === void 0 ? SIZE.small : t, n = g.direction === "rtl" ? "borderBottomLeftRadius" : "borderBottomRightRadius", h = g.direction === "rtl" ? "borderTopLeftRadius" : "borderTopRightRadius", d = g.direction === "rtl" ? "marginRight" : "marginLeft";
  return A = {
    alignItems: "center"
  }, _defineProperty$4(A, n, g.borders.useRoundedCorners ? g.borders.radius400 : 0), _defineProperty$4(A, h, g.borders.useRoundedCorners ? g.borders.radius400 : 0), _defineProperty$4(A, "cursor", e ? "not-allowed" : "pointer"), _defineProperty$4(A, "display", "flex"), _defineProperty$4(A, d, (E = {}, _defineProperty$4(E, SIZE.small, "8px"), _defineProperty$4(E, SIZE.medium, "12px"), _defineProperty$4(E, SIZE.large, "16px"), E)[c]), _defineProperty$4(A, "outline", "none"), _defineProperty$4(A, "transitionProperty", "all"), _defineProperty$4(A, "transitionDuration", "background-color"), _defineProperty$4(A, "transitionTimingFunction", g.animation.easeOutCurve), A;
});
Action$1.displayName = "Action";
Action$1.displayName = "Action";
var StartEnhancerContainer = styled("div", function(o) {
  var E = o.$theme, A = o.$size, g = A === void 0 ? SIZE.small : A, e = E.sizing.scale300;
  g === SIZE.medium ? e = E.sizing.scale400 : g === SIZE.large && (e = E.sizing.scale600);
  var t = E.direction === "rtl" ? "paddingLeft" : "paddingRight";
  return _defineProperty$4({
    alignItems: "center",
    display: "flex"
  }, t, e);
});
StartEnhancerContainer.displayName = "StartEnhancerContainer";
StartEnhancerContainer.displayName = "StartEnhancerContainer";
var Text = styled("span", function(o) {
  var E = o.$theme;
  return {
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    maxWidth: o.$theme.sizing.scale3200,
    order: E.direction === "rtl" ? 1 : 0
  };
});
Text.displayName = "Text";
Text.displayName = "Text";
var Root$1 = styled("span", function(o) {
  var E, A, g, e = o.$theme, t = o.$kind, c = t === void 0 ? KIND.primary : t, n = o.$clickable, h = o.$variant, d = o.$disabled, k = o.$closeable, p = o.$isFocusVisible, M = o.$color, S = o.$size, AA = S === void 0 ? SIZE.small : S, H = e.borders.tagBorderRadius, gA = (E = {}, _defineProperty$4(E, SIZE.small, e.sizing.scale300), _defineProperty$4(E, SIZE.medium, e.sizing.scale500), _defineProperty$4(E, SIZE.large, e.sizing.scale600), E)[AA], CA = !d && h === VARIANT.solid ? 0 : "2px", IA = colorMap[c][getColorStateFromProps(o)](e, M), BA = IA.color, QA = IA.backgroundColor, EA = IA.borderColor;
  return _objectSpread$2(_objectSpread$2({}, (A = {}, _defineProperty$4(A, SIZE.small, e.typography.LabelSmall), _defineProperty$4(A, SIZE.medium, e.typography.LabelMedium), _defineProperty$4(A, SIZE.large, e.typography.LabelLarge), A)[AA]), {}, {
    alignItems: "center",
    color: BA,
    backgroundColor: QA,
    borderLeftColor: EA,
    borderRightColor: EA,
    borderTopColor: EA,
    borderBottomColor: EA,
    borderLeftStyle: "solid",
    borderRightStyle: "solid",
    borderTopStyle: "solid",
    borderBottomStyle: "solid",
    borderLeftWidth: CA,
    borderRightWidth: CA,
    borderTopWidth: CA,
    borderBottomWidth: CA,
    borderTopLeftRadius: H,
    borderTopRightRadius: H,
    borderBottomRightRadius: H,
    borderBottomLeftRadius: H,
    boxSizing: "border-box",
    cursor: d ? "not-allowed" : n ? "pointer" : "default",
    display: "inline-flex",
    height: (g = {}, _defineProperty$4(g, SIZE.small, "24px"), _defineProperty$4(g, SIZE.medium, "32px"), _defineProperty$4(g, SIZE.large, "40px"), g)[AA],
    justifyContent: "space-between",
    marginTop: "5px",
    marginBottom: "5px",
    marginLeft: "5px",
    marginRight: "5px",
    paddingTop: e.sizing.scale0,
    paddingBottom: e.sizing.scale0,
    paddingLeft: gA,
    paddingRight: gA,
    outline: "none",
    ":hover": d || !n ? {} : {
      boxShadow: "inset 0px 0px 100px ".concat(pick(e, "rgba(0, 0, 0, 0.08)", "rgba(255, 255, 255, 0.2)"))
    },
    ":focus": d || !n && !k ? {} : {
      boxShadow: p ? "0 0 0 3px ".concat(c === KIND.accent ? e.colors.primaryA : e.colors.accent) : "none"
    }
  });
});
Root$1.displayName = "Root";
Root$1.displayName = "Root";
function _typeof$2(o) {
  "@babel/helpers - typeof";
  return _typeof$2 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(E) {
    return typeof E;
  } : function(E) {
    return E && typeof Symbol == "function" && E.constructor === Symbol && E !== Symbol.prototype ? "symbol" : typeof E;
  }, _typeof$2(o);
}
var JOINABLE_TYPES = /* @__PURE__ */ new Set(["string", "number"]);
function getTextFromChildren(o) {
  var E = React.Children.toArray(o).filter(function(g) {
    return g != null;
  });
  if (!E.length)
    return null;
  var A = E.every(function(g) {
    return JOINABLE_TYPES.has(_typeof$2(g));
  });
  return A ? E.join("") : null;
}
function _defineProperty$3(o, E, A) {
  return E in o ? Object.defineProperty(o, E, { value: A, enumerable: !0, configurable: !0, writable: !0 }) : o[E] = A, o;
}
function _slicedToArray$4(o, E) {
  return _arrayWithHoles$3(o) || _iterableToArrayLimit$3(o, E) || _unsupportedIterableToArray$3(o, E) || _nonIterableRest$3();
}
function _nonIterableRest$3() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$3(o, E) {
  if (o) {
    if (typeof o == "string") return _arrayLikeToArray$3(o, E);
    var A = Object.prototype.toString.call(o).slice(8, -1);
    if (A === "Object" && o.constructor && (A = o.constructor.name), A === "Map" || A === "Set") return Array.from(o);
    if (A === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(A)) return _arrayLikeToArray$3(o, E);
  }
}
function _arrayLikeToArray$3(o, E) {
  (E == null || E > o.length) && (E = o.length);
  for (var A = 0, g = new Array(E); A < E; A++)
    g[A] = o[A];
  return g;
}
function _iterableToArrayLimit$3(o, E) {
  var A = o == null ? null : typeof Symbol < "u" && o[Symbol.iterator] || o["@@iterator"];
  if (A != null) {
    var g = [], e = !0, t = !1, c, n;
    try {
      for (A = A.call(o); !(e = (c = A.next()).done) && (g.push(c.value), !(E && g.length === E)); e = !0)
        ;
    } catch (h) {
      t = !0, n = h;
    } finally {
      try {
        !e && A.return != null && A.return();
      } finally {
        if (t) throw n;
      }
    }
    return g;
  }
}
function _arrayWithHoles$3(o) {
  if (Array.isArray(o)) return o;
}
function _extends$6() {
  return _extends$6 = Object.assign ? Object.assign.bind() : function(o) {
    for (var E = 1; E < arguments.length; E++) {
      var A = arguments[E];
      for (var g in A)
        Object.prototype.hasOwnProperty.call(A, g) && (o[g] = A[g]);
    }
    return o;
  }, _extends$6.apply(this, arguments);
}
var ModifiedViewBoxDeleteIcon = function o(E) {
  return /* @__PURE__ */ React.createElement(DeleteIcon, _extends$6({
    viewBox: "5 5 13.186 13.186"
  }, E));
}, Tag = /* @__PURE__ */ React.forwardRef(function(o, E) {
  var A, g = o.children, e = o.closeable, t = e === void 0 ? !0 : e, c = o.color, n = o.size, h = n === void 0 ? SIZE.small : n, d = o.disabled, k = d === void 0 ? !1 : d, p = o.isFocused, M = p === void 0 ? !1 : p, S = o.isHovered, AA = S === void 0 ? !1 : S, H = o.kind, gA = H === void 0 ? KIND.primary : H, CA = o.onActionClick, IA = CA === void 0 ? function(OA) {
  } : CA, BA = o.onActionKeyDown, QA = BA === void 0 ? function(OA) {
  } : BA, EA = o.onClick, oA = EA === void 0 ? null : EA, iA = o.onKeyDown, aA = iA === void 0 ? null : iA, tA = o.overrides, eA = tA === void 0 ? {} : tA, cA = o.startEnhancer, DA = o.title, nA = o.variant, wA = nA === void 0 ? VARIANT.light : nA, lA = React.useState(!1), NA = _slicedToArray$4(lA, 2), RA = NA[0], KA = NA[1];
  function vA(OA) {
    isFocusVisible(OA) && KA(!0);
  }
  function GA(OA) {
    RA !== !1 && KA(!1);
  }
  function FA(OA) {
    if (OA.currentTarget === OA.target) {
      var VA = OA.key;
      oA && VA === "Enter" && oA(OA), t && (VA === "Backspace" || VA === "Delete") && (IA(OA), QA(OA)), aA && aA(OA);
    }
  }
  var HA = getOverrides(eA.Root, Root$1), sA = _slicedToArray$4(HA, 2), mA = sA[0], xA = sA[1], hA = getOverrides(eA.Action, Action$1), MA = _slicedToArray$4(hA, 2), YA = MA[0], LA = MA[1], WA = getOverrides(eA.ActionIcon, ModifiedViewBoxDeleteIcon), zA = _slicedToArray$4(WA, 2), ZA = zA[0], Ag = zA[1], UA = getOverrides(eA.StartEnhancerContainer, StartEnhancerContainer), ig = _slicedToArray$4(UA, 2), og = ig[0], PA = ig[1], Gg = getOverrides(eA.Text, Text), gg = _slicedToArray$4(Gg, 2), eg = gg[0], Dg = gg[1], rg = typeof oA == "function", cg = k ? {} : {
    onClick: oA,
    onKeyDown: FA
  }, hg = k ? {} : {
    onClick: function(VA) {
      VA.stopPropagation(), IA(VA);
    }
  }, Cg = {
    $clickable: rg,
    $closeable: t,
    $color: c,
    $disabled: k,
    $isFocused: M,
    $isHovered: AA,
    $kind: gA,
    $variant: wA,
    $isFocusVisible: RA,
    $size: h
  }, dA = DA || getTextFromChildren(g), pA = (rg || t) && !k, XA = (A = {}, _defineProperty$3(A, SIZE.small, 12), _defineProperty$3(A, SIZE.medium, 16), _defineProperty$3(A, SIZE.large, 20), A)[h], jA = cA;
  return /* @__PURE__ */ React.createElement(
    mA,
    _extends$6({
      ref: E,
      "data-baseweb": "tag",
      "aria-label": pA && t ? "".concat(typeof g == "string" ? "".concat(g, ", ") : "", "close by backspace") : null,
      "aria-disabled": k ? !0 : null,
      role: pA ? "button" : null,
      tabIndex: pA ? 0 : null
    }, cg, Cg, xA, {
      onFocus: forkFocus(xA, vA),
      onBlur: forkBlur(xA, GA)
    }),
    jA && // @ts-expect-error todo(flow->ts) it is not expected to be a number
    jA !== 0 && /* @__PURE__ */ React.createElement(og, PA, /* @__PURE__ */ React.createElement(jA, null)),
    /* @__PURE__ */ React.createElement(eg, _extends$6({
      title: dA
    }, Dg), g),
    t ? /* @__PURE__ */ React.createElement(YA, _extends$6({
      "aria-hidden": !0,
      role: "presentation"
    }, hg, Cg, LA), /* @__PURE__ */ React.createElement(ZA, _extends$6({
      size: XA
    }, Ag))) : null
  );
});
Tag.displayName = "Tag";
var _excluded$6 = ["overrides", "removeValue"];
function _extends$5() {
  return _extends$5 = Object.assign ? Object.assign.bind() : function(o) {
    for (var E = 1; E < arguments.length; E++) {
      var A = arguments[E];
      for (var g in A)
        Object.prototype.hasOwnProperty.call(A, g) && (o[g] = A[g]);
    }
    return o;
  }, _extends$5.apply(this, arguments);
}
function _slicedToArray$3(o, E) {
  return _arrayWithHoles$2(o) || _iterableToArrayLimit$2(o, E) || _unsupportedIterableToArray$2(o, E) || _nonIterableRest$2();
}
function _nonIterableRest$2() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$2(o, E) {
  if (o) {
    if (typeof o == "string") return _arrayLikeToArray$2(o, E);
    var A = Object.prototype.toString.call(o).slice(8, -1);
    if (A === "Object" && o.constructor && (A = o.constructor.name), A === "Map" || A === "Set") return Array.from(o);
    if (A === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(A)) return _arrayLikeToArray$2(o, E);
  }
}
function _arrayLikeToArray$2(o, E) {
  (E == null || E > o.length) && (E = o.length);
  for (var A = 0, g = new Array(E); A < E; A++)
    g[A] = o[A];
  return g;
}
function _iterableToArrayLimit$2(o, E) {
  var A = o == null ? null : typeof Symbol < "u" && o[Symbol.iterator] || o["@@iterator"];
  if (A != null) {
    var g = [], e = !0, t = !1, c, n;
    try {
      for (A = A.call(o); !(e = (c = A.next()).done) && (g.push(c.value), !(E && g.length === E)); e = !0)
        ;
    } catch (h) {
      t = !0, n = h;
    } finally {
      try {
        !e && A.return != null && A.return();
      } finally {
        if (t) throw n;
      }
    }
    return g;
  }
}
function _arrayWithHoles$2(o) {
  if (Array.isArray(o)) return o;
}
function _objectWithoutProperties$4(o, E) {
  if (o == null) return {};
  var A = _objectWithoutPropertiesLoose$3(o, E), g, e;
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    for (e = 0; e < t.length; e++)
      g = t[e], !(E.indexOf(g) >= 0) && Object.prototype.propertyIsEnumerable.call(o, g) && (A[g] = o[g]);
  }
  return A;
}
function _objectWithoutPropertiesLoose$3(o, E) {
  if (o == null) return {};
  var A = {}, g = Object.keys(o), e, t;
  for (t = 0; t < g.length; t++)
    e = g[t], !(E.indexOf(e) >= 0) && (A[e] = o[e]);
  return A;
}
function MultiValue(o) {
  var E = o.overrides, A = E === void 0 ? {} : E, g = o.removeValue, e = _objectWithoutProperties$4(o, _excluded$6), t = getOverrides(A.Tag || A.MultiValue, Tag), c = _slicedToArray$3(t, 2), n = c[0], h = c[1];
  return /* @__PURE__ */ React.createElement(n, _extends$5({
    variant: VARIANT.solid,
    overrides: {
      Root: {
        style: function(k) {
          var p = k.$theme.sizing;
          return {
            marginRight: p.scale0,
            marginBottom: p.scale0,
            marginLeft: p.scale0,
            marginTop: p.scale0
          };
        }
      }
    },
    onActionClick: g
  }, e, h), o.children);
}
var _excluded$5 = ["overrides"];
function _extends$4() {
  return _extends$4 = Object.assign ? Object.assign.bind() : function(o) {
    for (var E = 1; E < arguments.length; E++) {
      var A = arguments[E];
      for (var g in A)
        Object.prototype.hasOwnProperty.call(A, g) && (o[g] = A[g]);
    }
    return o;
  }, _extends$4.apply(this, arguments);
}
function _slicedToArray$2(o, E) {
  return _arrayWithHoles$1(o) || _iterableToArrayLimit$1(o, E) || _unsupportedIterableToArray$1(o, E) || _nonIterableRest$1();
}
function _nonIterableRest$1() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$1(o, E) {
  if (o) {
    if (typeof o == "string") return _arrayLikeToArray$1(o, E);
    var A = Object.prototype.toString.call(o).slice(8, -1);
    if (A === "Object" && o.constructor && (A = o.constructor.name), A === "Map" || A === "Set") return Array.from(o);
    if (A === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(A)) return _arrayLikeToArray$1(o, E);
  }
}
function _arrayLikeToArray$1(o, E) {
  (E == null || E > o.length) && (E = o.length);
  for (var A = 0, g = new Array(E); A < E; A++)
    g[A] = o[A];
  return g;
}
function _iterableToArrayLimit$1(o, E) {
  var A = o == null ? null : typeof Symbol < "u" && o[Symbol.iterator] || o["@@iterator"];
  if (A != null) {
    var g = [], e = !0, t = !1, c, n;
    try {
      for (A = A.call(o); !(e = (c = A.next()).done) && (g.push(c.value), !(E && g.length === E)); e = !0)
        ;
    } catch (h) {
      t = !0, n = h;
    } finally {
      try {
        !e && A.return != null && A.return();
      } finally {
        if (t) throw n;
      }
    }
    return g;
  }
}
function _arrayWithHoles$1(o) {
  if (Array.isArray(o)) return o;
}
function _objectWithoutProperties$3(o, E) {
  if (o == null) return {};
  var A = _objectWithoutPropertiesLoose$2(o, E), g, e;
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    for (e = 0; e < t.length; e++)
      g = t[e], !(E.indexOf(g) >= 0) && Object.prototype.propertyIsEnumerable.call(o, g) && (A[g] = o[g]);
  }
  return A;
}
function _objectWithoutPropertiesLoose$2(o, E) {
  if (o == null) return {};
  var A = {}, g = Object.keys(o), e, t;
  for (t = 0; t < g.length; t++)
    e = g[t], !(E.indexOf(e) >= 0) && (A[e] = o[e]);
  return A;
}
function Value(o) {
  var E = o.overrides, A = E === void 0 ? {} : E, g = _objectWithoutProperties$3(o, _excluded$5), e = getOverrides(A.SingleValue, StyledSingleValue), t = _slicedToArray$2(e, 2), c = t[0], n = t[1];
  return /* @__PURE__ */ React.createElement(c, _extends$4({}, g, n), o.children);
}
function _extends$3() {
  return _extends$3 = Object.assign ? Object.assign.bind() : function(o) {
    for (var E = 1; E < arguments.length; E++) {
      var A = arguments[E];
      for (var g in A)
        Object.prototype.hasOwnProperty.call(A, g) && (o[g] = A[g]);
    }
    return o;
  }, _extends$3.apply(this, arguments);
}
function Select(o) {
  return /* @__PURE__ */ React.createElement(Select$1, _extends$3({}, o, {
    valueComponent: o.multi ? MultiValue : Value
  }));
}
function _assertThisInitialized$1(o) {
  if (o === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return o;
}
var safeIsNaN = Number.isNaN || function o(E) {
  return typeof E == "number" && E !== E;
};
function isEqual(o, E) {
  return !!(o === E || safeIsNaN(o) && safeIsNaN(E));
}
function areInputsEqual(o, E) {
  if (o.length !== E.length)
    return !1;
  for (var A = 0; A < o.length; A++)
    if (!isEqual(o[A], E[A]))
      return !1;
  return !0;
}
function memoizeOne(o, E) {
  E === void 0 && (E = areInputsEqual);
  var A, g = [], e, t = !1;
  function c() {
    for (var n = [], h = 0; h < arguments.length; h++)
      n[h] = arguments[h];
    return t && A === this && E(n, g) || (e = o.apply(this, n), t = !0, A = this, g = n), e;
  }
  return c;
}
var hasNativePerformanceNow = typeof performance == "object" && typeof performance.now == "function", now = hasNativePerformanceNow ? function() {
  return performance.now();
} : function() {
  return Date.now();
};
function cancelTimeout(o) {
  cancelAnimationFrame(o.id);
}
function requestTimeout(o, E) {
  var A = now();
  function g() {
    now() - A >= E ? o.call(null) : e.id = requestAnimationFrame(g);
  }
  var e = {
    id: requestAnimationFrame(g)
  };
  return e;
}
var size = -1;
function getScrollbarSize(o) {
  if (o === void 0 && (o = !1), size === -1 || o) {
    var E = document.createElement("div"), A = E.style;
    A.width = "50px", A.height = "50px", A.overflow = "scroll", document.body.appendChild(E), size = E.offsetWidth - E.clientWidth, document.body.removeChild(E);
  }
  return size;
}
var cachedRTLResult = null;
function getRTLOffsetType(o) {
  if (o === void 0 && (o = !1), cachedRTLResult === null || o) {
    var E = document.createElement("div"), A = E.style;
    A.width = "50px", A.height = "50px", A.overflow = "scroll", A.direction = "rtl";
    var g = document.createElement("div"), e = g.style;
    return e.width = "100px", e.height = "100px", E.appendChild(g), document.body.appendChild(E), E.scrollLeft > 0 ? cachedRTLResult = "positive-descending" : (E.scrollLeft = 1, E.scrollLeft === 0 ? cachedRTLResult = "negative" : cachedRTLResult = "positive-ascending"), document.body.removeChild(E), cachedRTLResult;
  }
  return cachedRTLResult;
}
process.env.NODE_ENV;
var IS_SCROLLING_DEBOUNCE_INTERVAL$1 = 150, defaultItemKey$1 = function o(E, A) {
  return E;
}, devWarningsDirection = null, devWarningsTagName$1 = null;
process.env.NODE_ENV !== "production" && typeof window < "u" && typeof window.WeakSet < "u" && (devWarningsDirection = /* @__PURE__ */ new WeakSet(), devWarningsTagName$1 = /* @__PURE__ */ new WeakSet());
function createListComponent(o) {
  var E, A = o.getItemOffset, g = o.getEstimatedTotalSize, e = o.getItemSize, t = o.getOffsetForIndexAndAlignment, c = o.getStartIndexForOffset, n = o.getStopIndexForStartIndex, h = o.initInstanceProps, d = o.shouldResetStyleCacheOnItemSizeChange, k = o.validateProps;
  return E = /* @__PURE__ */ (function(p) {
    _inheritsLoose(M, p);
    function M(AA) {
      var H;
      return H = p.call(this, AA) || this, H._instanceProps = h(H.props, _assertThisInitialized$1(H)), H._outerRef = void 0, H._resetIsScrollingTimeoutId = null, H.state = {
        instance: _assertThisInitialized$1(H),
        isScrolling: !1,
        scrollDirection: "forward",
        scrollOffset: typeof H.props.initialScrollOffset == "number" ? H.props.initialScrollOffset : 0,
        scrollUpdateWasRequested: !1
      }, H._callOnItemsRendered = void 0, H._callOnItemsRendered = memoizeOne(function(gA, CA, IA, BA) {
        return H.props.onItemsRendered({
          overscanStartIndex: gA,
          overscanStopIndex: CA,
          visibleStartIndex: IA,
          visibleStopIndex: BA
        });
      }), H._callOnScroll = void 0, H._callOnScroll = memoizeOne(function(gA, CA, IA) {
        return H.props.onScroll({
          scrollDirection: gA,
          scrollOffset: CA,
          scrollUpdateWasRequested: IA
        });
      }), H._getItemStyle = void 0, H._getItemStyle = function(gA) {
        var CA = H.props, IA = CA.direction, BA = CA.itemSize, QA = CA.layout, EA = H._getItemStyleCache(d && BA, d && QA, d && IA), oA;
        if (EA.hasOwnProperty(gA))
          oA = EA[gA];
        else {
          var iA = A(H.props, gA, H._instanceProps), aA = e(H.props, gA, H._instanceProps), tA = IA === "horizontal" || QA === "horizontal", eA = IA === "rtl", cA = tA ? iA : 0;
          EA[gA] = oA = {
            position: "absolute",
            left: eA ? void 0 : cA,
            right: eA ? cA : void 0,
            top: tA ? 0 : iA,
            height: tA ? "100%" : aA,
            width: tA ? aA : "100%"
          };
        }
        return oA;
      }, H._getItemStyleCache = void 0, H._getItemStyleCache = memoizeOne(function(gA, CA, IA) {
        return {};
      }), H._onScrollHorizontal = function(gA) {
        var CA = gA.currentTarget, IA = CA.clientWidth, BA = CA.scrollLeft, QA = CA.scrollWidth;
        H.setState(function(EA) {
          if (EA.scrollOffset === BA)
            return null;
          var oA = H.props.direction, iA = BA;
          if (oA === "rtl")
            switch (getRTLOffsetType()) {
              case "negative":
                iA = -BA;
                break;
              case "positive-descending":
                iA = QA - IA - BA;
                break;
            }
          return iA = Math.max(0, Math.min(iA, QA - IA)), {
            isScrolling: !0,
            scrollDirection: EA.scrollOffset < iA ? "forward" : "backward",
            scrollOffset: iA,
            scrollUpdateWasRequested: !1
          };
        }, H._resetIsScrollingDebounced);
      }, H._onScrollVertical = function(gA) {
        var CA = gA.currentTarget, IA = CA.clientHeight, BA = CA.scrollHeight, QA = CA.scrollTop;
        H.setState(function(EA) {
          if (EA.scrollOffset === QA)
            return null;
          var oA = Math.max(0, Math.min(QA, BA - IA));
          return {
            isScrolling: !0,
            scrollDirection: EA.scrollOffset < oA ? "forward" : "backward",
            scrollOffset: oA,
            scrollUpdateWasRequested: !1
          };
        }, H._resetIsScrollingDebounced);
      }, H._outerRefSetter = function(gA) {
        var CA = H.props.outerRef;
        H._outerRef = gA, typeof CA == "function" ? CA(gA) : CA != null && typeof CA == "object" && CA.hasOwnProperty("current") && (CA.current = gA);
      }, H._resetIsScrollingDebounced = function() {
        H._resetIsScrollingTimeoutId !== null && cancelTimeout(H._resetIsScrollingTimeoutId), H._resetIsScrollingTimeoutId = requestTimeout(H._resetIsScrolling, IS_SCROLLING_DEBOUNCE_INTERVAL$1);
      }, H._resetIsScrolling = function() {
        H._resetIsScrollingTimeoutId = null, H.setState({
          isScrolling: !1
        }, function() {
          H._getItemStyleCache(-1, null);
        });
      }, H;
    }
    M.getDerivedStateFromProps = function(H, gA) {
      return validateSharedProps$1(H, gA), k(H), null;
    };
    var S = M.prototype;
    return S.scrollTo = function(H) {
      H = Math.max(0, H), this.setState(function(gA) {
        return gA.scrollOffset === H ? null : {
          scrollDirection: gA.scrollOffset < H ? "forward" : "backward",
          scrollOffset: H,
          scrollUpdateWasRequested: !0
        };
      }, this._resetIsScrollingDebounced);
    }, S.scrollToItem = function(H, gA) {
      gA === void 0 && (gA = "auto");
      var CA = this.props, IA = CA.itemCount, BA = CA.layout, QA = this.state.scrollOffset;
      H = Math.max(0, Math.min(H, IA - 1));
      var EA = 0;
      if (this._outerRef) {
        var oA = this._outerRef;
        BA === "vertical" ? EA = oA.scrollWidth > oA.clientWidth ? getScrollbarSize() : 0 : EA = oA.scrollHeight > oA.clientHeight ? getScrollbarSize() : 0;
      }
      this.scrollTo(t(this.props, H, gA, QA, this._instanceProps, EA));
    }, S.componentDidMount = function() {
      var H = this.props, gA = H.direction, CA = H.initialScrollOffset, IA = H.layout;
      if (typeof CA == "number" && this._outerRef != null) {
        var BA = this._outerRef;
        gA === "horizontal" || IA === "horizontal" ? BA.scrollLeft = CA : BA.scrollTop = CA;
      }
      this._callPropsCallbacks();
    }, S.componentDidUpdate = function() {
      var H = this.props, gA = H.direction, CA = H.layout, IA = this.state, BA = IA.scrollOffset, QA = IA.scrollUpdateWasRequested;
      if (QA && this._outerRef != null) {
        var EA = this._outerRef;
        if (gA === "horizontal" || CA === "horizontal")
          if (gA === "rtl")
            switch (getRTLOffsetType()) {
              case "negative":
                EA.scrollLeft = -BA;
                break;
              case "positive-ascending":
                EA.scrollLeft = BA;
                break;
              default:
                var oA = EA.clientWidth, iA = EA.scrollWidth;
                EA.scrollLeft = iA - oA - BA;
                break;
            }
          else
            EA.scrollLeft = BA;
        else
          EA.scrollTop = BA;
      }
      this._callPropsCallbacks();
    }, S.componentWillUnmount = function() {
      this._resetIsScrollingTimeoutId !== null && cancelTimeout(this._resetIsScrollingTimeoutId);
    }, S.render = function() {
      var H = this.props, gA = H.children, CA = H.className, IA = H.direction, BA = H.height, QA = H.innerRef, EA = H.innerElementType, oA = H.innerTagName, iA = H.itemCount, aA = H.itemData, tA = H.itemKey, eA = tA === void 0 ? defaultItemKey$1 : tA, cA = H.layout, DA = H.outerElementType, nA = H.outerTagName, wA = H.style, lA = H.useIsScrolling, NA = H.width, RA = this.state.isScrolling, KA = IA === "horizontal" || cA === "horizontal", vA = KA ? this._onScrollHorizontal : this._onScrollVertical, GA = this._getRangeToRender(), FA = GA[0], HA = GA[1], sA = [];
      if (iA > 0)
        for (var mA = FA; mA <= HA; mA++)
          sA.push(createElement(gA, {
            data: aA,
            key: eA(mA, aA),
            index: mA,
            isScrolling: lA ? RA : void 0,
            style: this._getItemStyle(mA)
          }));
      var xA = g(this.props, this._instanceProps);
      return createElement(DA || nA || "div", {
        className: CA,
        onScroll: vA,
        ref: this._outerRefSetter,
        style: _extends$C({
          position: "relative",
          height: BA,
          width: NA,
          overflow: "auto",
          WebkitOverflowScrolling: "touch",
          willChange: "transform",
          direction: IA
        }, wA)
      }, createElement(EA || oA || "div", {
        children: sA,
        ref: QA,
        style: {
          height: KA ? "100%" : xA,
          pointerEvents: RA ? "none" : void 0,
          width: KA ? xA : "100%"
        }
      }));
    }, S._callPropsCallbacks = function() {
      if (typeof this.props.onItemsRendered == "function") {
        var H = this.props.itemCount;
        if (H > 0) {
          var gA = this._getRangeToRender(), CA = gA[0], IA = gA[1], BA = gA[2], QA = gA[3];
          this._callOnItemsRendered(CA, IA, BA, QA);
        }
      }
      if (typeof this.props.onScroll == "function") {
        var EA = this.state, oA = EA.scrollDirection, iA = EA.scrollOffset, aA = EA.scrollUpdateWasRequested;
        this._callOnScroll(oA, iA, aA);
      }
    }, S._getRangeToRender = function() {
      var H = this.props, gA = H.itemCount, CA = H.overscanCount, IA = this.state, BA = IA.isScrolling, QA = IA.scrollDirection, EA = IA.scrollOffset;
      if (gA === 0)
        return [0, 0, 0, 0];
      var oA = c(this.props, EA, this._instanceProps), iA = n(this.props, oA, EA, this._instanceProps), aA = !BA || QA === "backward" ? Math.max(1, CA) : 1, tA = !BA || QA === "forward" ? Math.max(1, CA) : 1;
      return [Math.max(0, oA - aA), Math.max(0, Math.min(gA - 1, iA + tA)), oA, iA];
    }, M;
  })(PureComponent), E.defaultProps = {
    direction: "ltr",
    itemData: void 0,
    layout: "vertical",
    overscanCount: 2,
    useIsScrolling: !1
  }, E;
}
var validateSharedProps$1 = function o(E, A) {
  var g = E.children, e = E.direction, t = E.height, c = E.layout, n = E.innerTagName, h = E.outerTagName, d = E.width, k = A.instance;
  if (process.env.NODE_ENV !== "production") {
    (n != null || h != null) && devWarningsTagName$1 && !devWarningsTagName$1.has(k) && (devWarningsTagName$1.add(k), console.warn("The innerTagName and outerTagName props have been deprecated. Please use the innerElementType and outerElementType props instead."));
    var p = e === "horizontal" || c === "horizontal";
    switch (e) {
      case "horizontal":
      case "vertical":
        devWarningsDirection && !devWarningsDirection.has(k) && (devWarningsDirection.add(k), console.warn('The direction prop should be either "ltr" (default) or "rtl". Please use the layout prop to specify "vertical" (default) or "horizontal" orientation.'));
        break;
      case "ltr":
      case "rtl":
        break;
      default:
        throw Error('An invalid "direction" prop has been specified. Value should be either "ltr" or "rtl". ' + ('"' + e + '" was specified.'));
    }
    switch (c) {
      case "horizontal":
      case "vertical":
        break;
      default:
        throw Error('An invalid "layout" prop has been specified. Value should be either "horizontal" or "vertical". ' + ('"' + c + '" was specified.'));
    }
    if (g == null)
      throw Error('An invalid "children" prop has been specified. Value should be a React component. ' + ('"' + (g === null ? "null" : typeof g) + '" was specified.'));
    if (p && typeof d != "number")
      throw Error('An invalid "width" prop has been specified. Horizontal lists must specify a number for width. ' + ('"' + (d === null ? "null" : typeof d) + '" was specified.'));
    if (!p && typeof t != "number")
      throw Error('An invalid "height" prop has been specified. Vertical lists must specify a number for height. ' + ('"' + (t === null ? "null" : typeof t) + '" was specified.'));
  }
}, FixedSizeList = /* @__PURE__ */ createListComponent({
  getItemOffset: function o(E, A) {
    var g = E.itemSize;
    return A * g;
  },
  getItemSize: function o(E, A) {
    var g = E.itemSize;
    return g;
  },
  getEstimatedTotalSize: function o(E) {
    var A = E.itemCount, g = E.itemSize;
    return g * A;
  },
  getOffsetForIndexAndAlignment: function o(E, A, g, e, t, c) {
    var n = E.direction, h = E.height, d = E.itemCount, k = E.itemSize, p = E.layout, M = E.width, S = n === "horizontal" || p === "horizontal", AA = S ? M : h, H = Math.max(0, d * k - AA), gA = Math.min(H, A * k), CA = Math.max(0, A * k - AA + k + c);
    switch (g === "smart" && (e >= CA - AA && e <= gA + AA ? g = "auto" : g = "center"), g) {
      case "start":
        return gA;
      case "end":
        return CA;
      case "center": {
        var IA = Math.round(CA + (gA - CA) / 2);
        return IA < Math.ceil(AA / 2) ? 0 : IA > H + Math.floor(AA / 2) ? H : IA;
      }
      case "auto":
      default:
        return e >= CA && e <= gA ? e : e < CA ? CA : gA;
    }
  },
  getStartIndexForOffset: function o(E, A) {
    var g = E.itemCount, e = E.itemSize;
    return Math.max(0, Math.min(g - 1, Math.floor(A / e)));
  },
  getStopIndexForStartIndex: function o(E, A, g) {
    var e = E.direction, t = E.height, c = E.itemCount, n = E.itemSize, h = E.layout, d = E.width, k = e === "horizontal" || h === "horizontal", p = A * n, M = k ? d : t, S = Math.ceil((M + g - p) / n);
    return Math.max(0, Math.min(
      c - 1,
      A + S - 1
      // -1 is because stop index is inclusive
    ));
  },
  initInstanceProps: function o(E) {
  },
  shouldResetStyleCacheOnItemSizeChange: !0,
  validateProps: function o(E) {
    var A = E.itemSize;
    if (process.env.NODE_ENV !== "production" && typeof A != "number")
      throw Error('An invalid "itemSize" prop has been specified. Value should be a number. ' + ('"' + (A === null ? "null" : typeof A) + '" was specified.'));
  }
});
const ThemedStyledDropdownListItem = /* @__PURE__ */ createStyled(StyledDropdownListItem, process.env.NODE_ENV === "production" ? {
  shouldForwardProp: isPropValid,
  target: "e1811lun0"
} : {
  shouldForwardProp: isPropValid,
  target: "e1811lun0",
  label: "ThemedStyledDropdownListItem"
})(({
  theme: o,
  $isHighlighted: E
}) => ({
  display: "flex",
  alignItems: "center",
  paddingTop: o.spacing.none,
  paddingBottom: o.spacing.none,
  paddingLeft: o.spacing.lg,
  paddingRight: o.spacing.lg,
  background: E ? o.colors.darkenedBgMix15 : void 0,
  fontWeight: o.fontWeights.normal,
  // Override the default itemSize set on the component's JSX
  // on mobile, so we can make list items taller and scrollable
  [`@media (max-width: ${o.breakpoints.md})`]: {
    minHeight: o.sizes.dropdownItemHeight,
    height: "auto !important"
  },
  "&:hover, &:active, &:focus-visible": {
    background: o.colors.darkenedBgMix15
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
function FixedSizeListItem(o) {
  const {
    data: E,
    index: A,
    style: g
  } = o, {
    item: e,
    overrides: t,
    ...c
  } = E[A].props, n = e.isCreatable ? `Add: ${e.label}` : e.label;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ThemedStyledDropdownListItem, { style: g, ...c, children: /* @__PURE__ */ jsxRuntimeExports.jsx(OverflowTooltip, { content: n, placement: Placement.AUTO, children: n }) }, e.value);
}
const VirtualDropdown = forwardRef((o, E) => {
  const A = useEmotionTheme(), g = Children.toArray(o.children);
  if (!g[0]?.props.item) {
    const t = g[0] ? g[0].props : {};
    return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledList, { $style: {
      height: A.sizes.emptyDropdownHeight,
      paddingBottom: A.spacing.none,
      paddingTop: A.spacing.none,
      paddingLeft: A.spacing.none,
      paddingRight: A.spacing.none,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      // Somehow this adds an additional shadow, even though we already have
      // one on the popover, so we need to remove it here.
      boxShadow: "none"
    }, ref: E, "data-testid": "stSelectboxVirtualDropdownEmpty", children: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledEmptyState, { $style: {
      paddingBottom: A.spacing.none,
      paddingTop: A.spacing.none,
      paddingLeft: A.spacing.none,
      paddingRight: A.spacing.none,
      color: A.colors.fadedText60
    }, ...t }) });
  }
  const e = Math.min(convertRemToPx(A.sizes.maxDropdownHeight), g.length * convertRemToPx(A.sizes.dropdownItemHeight));
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledList, { ref: E, $style: {
    paddingTop: 0,
    paddingBottom: 0,
    // Somehow this adds an additional shadow, even though we already have
    // one on the popover, so we need to remove it here.
    boxShadow: "none"
  }, "data-testid": "stSelectboxVirtualDropdown", children: /* @__PURE__ */ jsxRuntimeExports.jsx(FixedSizeList, { width: "100%", height: e, itemCount: g.length, itemData: g, itemKey: (t, c) => {
    const {
      id: n,
      value: h
    } = c[t].props.item;
    return n ?? h;
  }, itemSize: convertRemToPx(A.sizes.dropdownItemHeight), children: FixedSizeListItem }) });
});
VirtualDropdown.displayName = "VirtualDropdown";
const SCORE_MIN = -1 / 0, SCORE_MAX = 1 / 0, SCORE_GAP_LEADING = -5e-3, SCORE_GAP_TRAILING = -5e-3, SCORE_GAP_INNER = -0.01, SCORE_MATCH_CONSECUTIVE = 1, SCORE_MATCH_SLASH = 0.9, SCORE_MATCH_WORD = 0.8, SCORE_MATCH_CAPITAL = 0.7, SCORE_MATCH_DOT = 0.6;
function islower(o) {
  return o.toLowerCase() === o;
}
function isupper(o) {
  return o.toUpperCase() === o;
}
function precomputeBonus(o) {
  const E = o.length, A = new Array(E);
  let g = "/";
  for (let e = 0; e < E; e++) {
    const t = o[e];
    g === "/" ? A[e] = SCORE_MATCH_SLASH : g === "-" || g === "_" || g === " " ? A[e] = SCORE_MATCH_WORD : g === "." ? A[e] = SCORE_MATCH_DOT : islower(g) && isupper(t) ? A[e] = SCORE_MATCH_CAPITAL : A[e] = 0, g = t;
  }
  return A;
}
function compute(o, E, A, g, e = !1) {
  const t = o.length, c = E.length, n = e ? o : o.toLowerCase(), h = e ? E : E.toLowerCase(), d = precomputeBonus(E);
  for (let k = 0; k < t; k++) {
    A[k] = new Array(c), g[k] = new Array(c);
    let p = SCORE_MIN;
    const M = k === t - 1 ? SCORE_GAP_TRAILING : SCORE_GAP_INNER;
    for (let S = 0; S < c; S++)
      if (n[k] === h[S]) {
        let AA = SCORE_MIN;
        k ? S && (AA = Math.max(
          g[k - 1][S - 1] + d[S],
          /* consecutive match, doesn't stack with matchBonus */
          A[k - 1][S - 1] + SCORE_MATCH_CONSECUTIVE
        )) : AA = S * SCORE_GAP_LEADING + d[S], A[k][S] = AA, g[k][S] = p = Math.max(AA, p + M);
      } else
        A[k][S] = SCORE_MIN, g[k][S] = p = p + M;
  }
}
function score(o, E, A = !1) {
  const g = o.length, e = E.length;
  if (!g || !e) return SCORE_MIN;
  if (o === E || !A && e === g)
    return SCORE_MAX;
  if (e > 1024)
    return SCORE_MIN;
  const t = new Array(g), c = new Array(g);
  return compute(o, E, t, c, A), c[g - 1][e - 1];
}
function hasMatch(o, E) {
  o = o.toLowerCase(), E = E.toLowerCase();
  const A = o.length;
  for (let g = 0, e = 0; g < A; g += 1)
    if (e = E.indexOf(o[g], e) + 1, e === 0) return !1;
  return !0;
}
function fuzzyFilterSelectOptions(o, E) {
  if (!E)
    return o;
  const A = o.filter((g) => hasMatch(E, g.label));
  return sortBy(
    A,
    // Use the negative score to sort the list in a stable manner
    // This ensures highest score is first
    (g) => -score(E, g.label)
  );
}
var uaParser$1 = { exports: {} }, uaParser = uaParser$1.exports, hasRequiredUaParser;
function requireUaParser() {
  return hasRequiredUaParser || (hasRequiredUaParser = 1, (function(o, E) {
    (function(A, g) {
      var e = "1.0.41", t = "", c = "?", n = "function", h = "undefined", d = "object", k = "string", p = "major", M = "model", S = "name", AA = "type", H = "vendor", gA = "version", CA = "architecture", IA = "console", BA = "mobile", QA = "tablet", EA = "smarttv", oA = "wearable", iA = "embedded", aA = 500, tA = "Amazon", eA = "Apple", cA = "ASUS", DA = "BlackBerry", nA = "Browser", wA = "Chrome", lA = "Edge", NA = "Firefox", RA = "Google", KA = "Honor", vA = "Huawei", GA = "Lenovo", FA = "LG", HA = "Microsoft", sA = "Motorola", mA = "Nvidia", xA = "OnePlus", hA = "Opera", MA = "OPPO", YA = "Samsung", LA = "Sharp", WA = "Sony", zA = "Xiaomi", ZA = "Zebra", Ag = "Facebook", UA = "Chromium OS", ig = "Mac OS", og = " Browser", PA = function(VA, $A) {
        var fA = {};
        for (var yA in VA)
          $A[yA] && $A[yA].length % 2 === 0 ? fA[yA] = $A[yA].concat(VA[yA]) : fA[yA] = VA[yA];
        return fA;
      }, Gg = function(VA) {
        for (var $A = {}, fA = 0; fA < VA.length; fA++)
          $A[VA[fA].toUpperCase()] = VA[fA];
        return $A;
      }, gg = function(VA, $A) {
        return typeof VA === k ? eg($A).indexOf(eg(VA)) !== -1 : !1;
      }, eg = function(VA) {
        return VA.toLowerCase();
      }, Dg = function(VA) {
        return typeof VA === k ? VA.replace(/[^\d\.]/g, t).split(".")[0] : g;
      }, rg = function(VA, $A) {
        if (typeof VA === k)
          return VA = VA.replace(/^\s\s*/, t), typeof $A === h ? VA : VA.substring(0, aA);
      }, cg = function(VA, $A) {
        for (var fA = 0, yA, bA, kA, JA, uA, TA; fA < $A.length && !uA; ) {
          var Bg = $A[fA], ng = $A[fA + 1];
          for (yA = bA = 0; yA < Bg.length && !uA && Bg[yA]; )
            if (uA = Bg[yA++].exec(VA), uA)
              for (kA = 0; kA < ng.length; kA++)
                TA = uA[++bA], JA = ng[kA], typeof JA === d && JA.length > 0 ? JA.length === 2 ? typeof JA[1] == n ? this[JA[0]] = JA[1].call(this, TA) : this[JA[0]] = JA[1] : JA.length === 3 ? typeof JA[1] === n && !(JA[1].exec && JA[1].test) ? this[JA[0]] = TA ? JA[1].call(this, TA, JA[2]) : g : this[JA[0]] = TA ? TA.replace(JA[1], JA[2]) : g : JA.length === 4 && (this[JA[0]] = TA ? JA[3].call(this, TA.replace(JA[1], JA[2])) : g) : this[JA] = TA || g;
          fA += 2;
        }
      }, hg = function(VA, $A) {
        for (var fA in $A)
          if (typeof $A[fA] === d && $A[fA].length > 0) {
            for (var yA = 0; yA < $A[fA].length; yA++)
              if (gg($A[fA][yA], VA))
                return fA === c ? g : fA;
          } else if (gg($A[fA], VA))
            return fA === c ? g : fA;
        return $A.hasOwnProperty("*") ? $A["*"] : VA;
      }, Cg = {
        "1.0": "/8",
        "1.2": "/1",
        "1.3": "/3",
        "2.0": "/412",
        "2.0.2": "/416",
        "2.0.3": "/417",
        "2.0.4": "/419",
        "?": "/"
      }, dA = {
        ME: "4.90",
        "NT 3.11": "NT3.51",
        "NT 4.0": "NT4.0",
        2e3: "NT 5.0",
        XP: ["NT 5.1", "NT 5.2"],
        Vista: "NT 6.0",
        7: "NT 6.1",
        8: "NT 6.2",
        "8.1": "NT 6.3",
        10: ["NT 6.4", "NT 10.0"],
        RT: "ARM"
      }, pA = {
        browser: [
          [
            /\b(?:crmo|crios)\/([\w\.]+)/i
            // Chrome for Android/iOS
          ],
          [gA, [S, "Chrome"]],
          [
            /edg(?:e|ios|a)?\/([\w\.]+)/i
            // Microsoft Edge
          ],
          [gA, [S, "Edge"]],
          [
            // Presto based
            /(opera mini)\/([-\w\.]+)/i,
            // Opera Mini
            /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
            // Opera Mobi/Tablet
            /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i
            // Opera
          ],
          [S, gA],
          [
            /opios[\/ ]+([\w\.]+)/i
            // Opera mini on iphone >= 8.0
          ],
          [gA, [S, hA + " Mini"]],
          [
            /\bop(?:rg)?x\/([\w\.]+)/i
            // Opera GX
          ],
          [gA, [S, hA + " GX"]],
          [
            /\bopr\/([\w\.]+)/i
            // Opera Webkit
          ],
          [gA, [S, hA]],
          [
            // Mixed
            /\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i
            // Baidu
          ],
          [gA, [S, "Baidu"]],
          [
            /\b(?:mxbrowser|mxios|myie2)\/?([-\w\.]*)\b/i
            // Maxthon
          ],
          [gA, [S, "Maxthon"]],
          [
            /(kindle)\/([\w\.]+)/i,
            // Kindle
            /(lunascape|maxthon|netfront|jasmine|blazer|sleipnir)[\/ ]?([\w\.]*)/i,
            // Lunascape/Maxthon/Netfront/Jasmine/Blazer/Sleipnir
            // Trident based
            /(avant|iemobile|slim(?:browser|boat|jet))[\/ ]?([\d\.]*)/i,
            // Avant/IEMobile/SlimBrowser/SlimBoat/Slimjet
            /(?:ms|\()(ie) ([\w\.]+)/i,
            // Internet Explorer
            // Blink/Webkit/KHTML based                                         // Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
            /(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|duckduckgo|klar|helio|(?=comodo_)?dragon)\/([-\w\.]+)/i,
            // Rekonq/Puffin/Brave/Whale/QQBrowserLite/QQ//Vivaldi/DuckDuckGo/Klar/Helio/Dragon
            /(heytap|ovi|115)browser\/([\d\.]+)/i,
            // HeyTap/Ovi/115
            /(weibo)__([\d\.]+)/i
            // Weibo
          ],
          [S, gA],
          [
            /quark(?:pc)?\/([-\w\.]+)/i
            // Quark
          ],
          [gA, [S, "Quark"]],
          [
            /\bddg\/([\w\.]+)/i
            // DuckDuckGo
          ],
          [gA, [S, "DuckDuckGo"]],
          [
            /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i
            // UCBrowser
          ],
          [gA, [S, "UC" + nA]],
          [
            /microm.+\bqbcore\/([\w\.]+)/i,
            // WeChat Desktop for Windows Built-in Browser
            /\bqbcore\/([\w\.]+).+microm/i,
            /micromessenger\/([\w\.]+)/i
            // WeChat
          ],
          [gA, [S, "WeChat"]],
          [
            /konqueror\/([\w\.]+)/i
            // Konqueror
          ],
          [gA, [S, "Konqueror"]],
          [
            /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i
            // IE11
          ],
          [gA, [S, "IE"]],
          [
            /ya(?:search)?browser\/([\w\.]+)/i
            // Yandex
          ],
          [gA, [S, "Yandex"]],
          [
            /slbrowser\/([\w\.]+)/i
            // Smart Lenovo Browser
          ],
          [gA, [S, "Smart Lenovo " + nA]],
          [
            /(avast|avg)\/([\w\.]+)/i
            // Avast/AVG Secure Browser
          ],
          [[S, /(.+)/, "$1 Secure " + nA], gA],
          [
            /\bfocus\/([\w\.]+)/i
            // Firefox Focus
          ],
          [gA, [S, NA + " Focus"]],
          [
            /\bopt\/([\w\.]+)/i
            // Opera Touch
          ],
          [gA, [S, hA + " Touch"]],
          [
            /coc_coc\w+\/([\w\.]+)/i
            // Coc Coc Browser
          ],
          [gA, [S, "Coc Coc"]],
          [
            /dolfin\/([\w\.]+)/i
            // Dolphin
          ],
          [gA, [S, "Dolphin"]],
          [
            /coast\/([\w\.]+)/i
            // Opera Coast
          ],
          [gA, [S, hA + " Coast"]],
          [
            /miuibrowser\/([\w\.]+)/i
            // MIUI Browser
          ],
          [gA, [S, "MIUI" + og]],
          [
            /fxios\/([\w\.-]+)/i
            // Firefox for iOS
          ],
          [gA, [S, NA]],
          [
            /\bqihoobrowser\/?([\w\.]*)/i
            // 360
          ],
          [gA, [S, "360"]],
          [
            /\b(qq)\/([\w\.]+)/i
            // QQ
          ],
          [[S, /(.+)/, "$1Browser"], gA],
          [
            /(oculus|sailfish|huawei|vivo|pico)browser\/([\w\.]+)/i
          ],
          [[S, /(.+)/, "$1" + og], gA],
          [
            // Oculus/Sailfish/HuaweiBrowser/VivoBrowser/PicoBrowser
            /samsungbrowser\/([\w\.]+)/i
            // Samsung Internet
          ],
          [gA, [S, YA + " Internet"]],
          [
            /metasr[\/ ]?([\d\.]+)/i
            // Sogou Explorer
          ],
          [gA, [S, "Sogou Explorer"]],
          [
            /(sogou)mo\w+\/([\d\.]+)/i
            // Sogou Mobile
          ],
          [[S, "Sogou Mobile"], gA],
          [
            /(electron)\/([\w\.]+) safari/i,
            // Electron-based App
            /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
            // Tesla
            /m?(qqbrowser|2345(?=browser|chrome|explorer))\w*[\/ ]?v?([\w\.]+)/i
            // QQ/2345
          ],
          [S, gA],
          [
            /(lbbrowser|rekonq)/i,
            // LieBao Browser/Rekonq
            /\[(linkedin)app\]/i
            // LinkedIn App for iOS & Android
          ],
          [S],
          [
            /ome\/([\w\.]+) \w* ?(iron) saf/i,
            // Iron
            /ome\/([\w\.]+).+qihu (360)[es]e/i
            // 360
          ],
          [gA, S],
          [
            // WebView
            /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i
            // Facebook App for iOS & Android
          ],
          [[S, Ag], gA],
          [
            /(Klarna)\/([\w\.]+)/i,
            // Klarna Shopping Browser for iOS & Android
            /(kakao(?:talk|story))[\/ ]([\w\.]+)/i,
            // Kakao App
            /(naver)\(.*?(\d+\.[\w\.]+).*\)/i,
            // Naver InApp
            /(daum)apps[\/ ]([\w\.]+)/i,
            // Daum App
            /safari (line)\/([\w\.]+)/i,
            // Line App for iOS
            /\b(line)\/([\w\.]+)\/iab/i,
            // Line App for Android
            /(alipay)client\/([\w\.]+)/i,
            // Alipay
            /(twitter)(?:and| f.+e\/([\w\.]+))/i,
            // Twitter
            /(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i
            // Chromium/Instagram/Snapchat
          ],
          [S, gA],
          [
            /\bgsa\/([\w\.]+) .*safari\//i
            // Google Search Appliance on iOS
          ],
          [gA, [S, "GSA"]],
          [
            /musical_ly(?:.+app_?version\/|_)([\w\.]+)/i
            // TikTok
          ],
          [gA, [S, "TikTok"]],
          [
            /headlesschrome(?:\/([\w\.]+)| )/i
            // Chrome Headless
          ],
          [gA, [S, wA + " Headless"]],
          [
            / wv\).+(chrome)\/([\w\.]+)/i
            // Chrome WebView
          ],
          [[S, wA + " WebView"], gA],
          [
            /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i
            // Android Browser
          ],
          [gA, [S, "Android " + nA]],
          [
            /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i
            // Chrome/OmniWeb/Arora/Tizen/Nokia
          ],
          [S, gA],
          [
            /version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i
            // Mobile Safari
          ],
          [gA, [S, "Mobile Safari"]],
          [
            /version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i
            // Safari & Safari Mobile
          ],
          [gA, S],
          [
            /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i
            // Safari < 3.0
          ],
          [S, [gA, hg, Cg]],
          [
            /(webkit|khtml)\/([\w\.]+)/i
          ],
          [S, gA],
          [
            // Gecko based
            /(navigator|netscape\d?)\/([-\w\.]+)/i
            // Netscape
          ],
          [[S, "Netscape"], gA],
          [
            /(wolvic|librewolf)\/([\w\.]+)/i
            // Wolvic/LibreWolf
          ],
          [S, gA],
          [
            /mobile vr; rv:([\w\.]+)\).+firefox/i
            // Firefox Reality
          ],
          [gA, [S, NA + " Reality"]],
          [
            /ekiohf.+(flow)\/([\w\.]+)/i,
            // Flow
            /(swiftfox)/i,
            // Swiftfox
            /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror)[\/ ]?([\w\.\+]+)/i,
            // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror
            /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
            // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
            /(firefox)\/([\w\.]+)/i,
            // Other Firefox-based
            /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
            // Mozilla
            // Other
            /(amaya|dillo|doris|icab|ladybird|lynx|mosaic|netsurf|obigo|polaris|w3m|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
            // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Obigo/Mosaic/Go/ICE/UP.Browser/Ladybird
            /\b(links) \(([\w\.]+)/i
            // Links
          ],
          [S, [gA, /_/g, "."]],
          [
            /(cobalt)\/([\w\.]+)/i
            // Cobalt
          ],
          [S, [gA, /master.|lts./, ""]]
        ],
        cpu: [
          [
            /\b((amd|x|x86[-_]?|wow|win)64)\b/i
            // AMD64 (x64)
          ],
          [[CA, "amd64"]],
          [
            /(ia32(?=;))/i,
            // IA32 (quicktime)
            /\b((i[346]|x)86)(pc)?\b/i
            // IA32 (x86)
          ],
          [[CA, "ia32"]],
          [
            /\b(aarch64|arm(v?[89]e?l?|_?64))\b/i
            // ARM64
          ],
          [[CA, "arm64"]],
          [
            /\b(arm(v[67])?ht?n?[fl]p?)\b/i
            // ARMHF
          ],
          [[CA, "armhf"]],
          [
            // PocketPC mistakenly identified as PowerPC
            /( (ce|mobile); ppc;|\/[\w\.]+arm\b)/i
          ],
          [[CA, "arm"]],
          [
            /((ppc|powerpc)(64)?)( mac|;|\))/i
            // PowerPC
          ],
          [[CA, /ower/, t, eg]],
          [
            / sun4\w[;\)]/i
            // SPARC
          ],
          [[CA, "sparc"]],
          [
            /\b(avr32|ia64(?=;)|68k(?=\))|\barm(?=v([1-7]|[5-7]1)l?|;|eabi)|(irix|mips|sparc)(64)?\b|pa-risc)/i
            // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
          ],
          [[CA, eg]]
        ],
        device: [
          [
            //////////////////////////
            // MOBILES & TABLETS
            /////////////////////////
            // Samsung
            /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
          ],
          [M, [H, YA], [AA, QA]],
          [
            /\b((?:s[cgp]h|gt|sm)-(?![lr])\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,
            /samsung[- ]((?!sm-[lr])[-\w]+)/i,
            /sec-(sgh\w+)/i
          ],
          [M, [H, YA], [AA, BA]],
          [
            // Apple
            /(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i
            // iPod/iPhone
          ],
          [M, [H, eA], [AA, BA]],
          [
            /\((ipad);[-\w\),; ]+apple/i,
            // iPad
            /applecoremedia\/[\w\.]+ \((ipad)/i,
            /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
          ],
          [M, [H, eA], [AA, QA]],
          [
            /(macintosh);/i
          ],
          [M, [H, eA]],
          [
            // Sharp
            /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
          ],
          [M, [H, LA], [AA, BA]],
          [
            // Honor
            /\b((?:brt|eln|hey2?|gdi|jdn)-a?[lnw]09|(?:ag[rm]3?|jdn2|kob2)-a?[lw]0[09]hn)(?: bui|\)|;)/i
          ],
          [M, [H, KA], [AA, QA]],
          [
            /honor([-\w ]+)[;\)]/i
          ],
          [M, [H, KA], [AA, BA]],
          [
            // Huawei
            /\b((?:ag[rs][2356]?k?|bah[234]?|bg[2o]|bt[kv]|cmr|cpn|db[ry]2?|jdn2|got|kob2?k?|mon|pce|scm|sht?|[tw]gr|vrd)-[ad]?[lw][0125][09]b?|605hw|bg2-u03|(?:gem|fdr|m2|ple|t1)-[7a]0[1-4][lu]|t1-a2[13][lw]|mediapad[\w\. ]*(?= bui|\)))\b(?!.+d\/s)/i
          ],
          [M, [H, vA], [AA, QA]],
          [
            /(?:huawei)([-\w ]+)[;\)]/i,
            /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
          ],
          [M, [H, vA], [AA, BA]],
          [
            // Xiaomi
            /oid[^\)]+; (2[\dbc]{4}(182|283|rp\w{2})[cgl]|m2105k81a?c)(?: bui|\))/i,
            /\b((?:red)?mi[-_ ]?pad[\w- ]*)(?: bui|\))/i
            // Mi Pad tablets
          ],
          [[M, /_/g, " "], [H, zA], [AA, QA]],
          [
            /\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i,
            // Xiaomi POCO
            /\b; (\w+) build\/hm\1/i,
            // Xiaomi Hongmi 'numeric' models
            /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
            // Xiaomi Hongmi
            /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
            // Xiaomi Redmi
            /oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i,
            // Xiaomi Redmi 'numeric' models
            /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite|pro)?)(?: bui|\))/i,
            // Xiaomi Mi
            / ([\w ]+) miui\/v?\d/i
          ],
          [[M, /_/g, " "], [H, zA], [AA, BA]],
          [
            // OPPO
            /; (\w+) bui.+ oppo/i,
            /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
          ],
          [M, [H, MA], [AA, BA]],
          [
            /\b(opd2(\d{3}a?))(?: bui|\))/i
          ],
          [M, [H, hg, { OnePlus: ["304", "403", "203"], "*": MA }], [AA, QA]],
          [
            // Vivo
            /vivo (\w+)(?: bui|\))/i,
            /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
          ],
          [M, [H, "Vivo"], [AA, BA]],
          [
            // Realme
            /\b(rmx[1-3]\d{3})(?: bui|;|\))/i
          ],
          [M, [H, "Realme"], [AA, BA]],
          [
            // Motorola
            /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
            /\bmot(?:orola)?[- ](\w*)/i,
            /((?:moto(?! 360)[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
          ],
          [M, [H, sA], [AA, BA]],
          [
            /\b(mz60\d|xoom[2 ]{0,2}) build\//i
          ],
          [M, [H, sA], [AA, QA]],
          [
            // LG
            /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
          ],
          [M, [H, FA], [AA, QA]],
          [
            /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
            /\blg[-e;\/ ]+((?!browser|netcast|android tv|watch)\w+)/i,
            /\blg-?([\d\w]+) bui/i
          ],
          [M, [H, FA], [AA, BA]],
          [
            // Lenovo
            /(ideatab[-\w ]+|602lv|d-42a|a101lv|a2109a|a3500-hv|s[56]000|pb-6505[my]|tb-?x?\d{3,4}(?:f[cu]|xu|[av])|yt\d?-[jx]?\d+[lfmx])( bui|;|\)|\/)/i,
            /lenovo ?(b[68]0[08]0-?[hf]?|tab(?:[\w- ]+?)|tb[\w-]{6,7})( bui|;|\)|\/)/i
          ],
          [M, [H, GA], [AA, QA]],
          [
            // Nokia
            /(nokia) (t[12][01])/i
          ],
          [H, M, [AA, QA]],
          [
            /(?:maemo|nokia).*(n900|lumia \d+|rm-\d+)/i,
            /nokia[-_ ]?(([-\w\. ]*))/i
          ],
          [[M, /_/g, " "], [AA, BA], [H, "Nokia"]],
          [
            // Google
            /(pixel (c|tablet))\b/i
            // Google Pixel C/Tablet
          ],
          [M, [H, RA], [AA, QA]],
          [
            /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i
            // Google Pixel
          ],
          [M, [H, RA], [AA, BA]],
          [
            // Sony
            /droid.+; (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
          ],
          [M, [H, WA], [AA, BA]],
          [
            /sony tablet [ps]/i,
            /\b(?:sony)?sgp\w+(?: bui|\))/i
          ],
          [[M, "Xperia Tablet"], [H, WA], [AA, QA]],
          [
            // OnePlus
            / (kb2005|in20[12]5|be20[12][59])\b/i,
            /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
          ],
          [M, [H, xA], [AA, BA]],
          [
            // Amazon
            /(alexa)webm/i,
            /(kf[a-z]{2}wi|aeo(?!bc)\w\w)( bui|\))/i,
            // Kindle Fire without Silk / Echo Show
            /(kf[a-z]+)( bui|\)).+silk\//i
            // Kindle Fire HD
          ],
          [M, [H, tA], [AA, QA]],
          [
            /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i
            // Fire Phone
          ],
          [[M, /(.+)/g, "Fire Phone $1"], [H, tA], [AA, BA]],
          [
            // BlackBerry
            /(playbook);[-\w\),; ]+(rim)/i
            // BlackBerry PlayBook
          ],
          [M, H, [AA, QA]],
          [
            /\b((?:bb[a-f]|st[hv])100-\d)/i,
            /\(bb10; (\w+)/i
            // BlackBerry 10
          ],
          [M, [H, DA], [AA, BA]],
          [
            // Asus
            /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
          ],
          [M, [H, cA], [AA, QA]],
          [
            / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
          ],
          [M, [H, cA], [AA, BA]],
          [
            // HTC
            /(nexus 9)/i
            // HTC Nexus 9
          ],
          [M, [H, "HTC"], [AA, QA]],
          [
            /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
            // HTC
            // ZTE
            /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
            /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i
            // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
          ],
          [H, [M, /_/g, " "], [AA, BA]],
          [
            // TCL
            /droid [\w\.]+; ((?:8[14]9[16]|9(?:0(?:48|60|8[01])|1(?:3[27]|66)|2(?:6[69]|9[56])|466))[gqswx])\w*(\)| bui)/i
          ],
          [M, [H, "TCL"], [AA, QA]],
          [
            // itel
            /(itel) ((\w+))/i
          ],
          [[H, eg], M, [AA, hg, { tablet: ["p10001l", "w7001"], "*": "mobile" }]],
          [
            // Acer
            /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
          ],
          [M, [H, "Acer"], [AA, QA]],
          [
            // Meizu
            /droid.+; (m[1-5] note) bui/i,
            /\bmz-([-\w]{2,})/i
          ],
          [M, [H, "Meizu"], [AA, BA]],
          [
            // Ulefone
            /; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i
          ],
          [M, [H, "Ulefone"], [AA, BA]],
          [
            // Energizer
            /; (energy ?\w+)(?: bui|\))/i,
            /; energizer ([\w ]+)(?: bui|\))/i
          ],
          [M, [H, "Energizer"], [AA, BA]],
          [
            // Cat
            /; cat (b35);/i,
            /; (b15q?|s22 flip|s48c|s62 pro)(?: bui|\))/i
          ],
          [M, [H, "Cat"], [AA, BA]],
          [
            // Smartfren
            /((?:new )?andromax[\w- ]+)(?: bui|\))/i
          ],
          [M, [H, "Smartfren"], [AA, BA]],
          [
            // Nothing
            /droid.+; (a(?:015|06[35]|142p?))/i
          ],
          [M, [H, "Nothing"], [AA, BA]],
          [
            // Archos
            /; (x67 5g|tikeasy \w+|ac[1789]\d\w+)( b|\))/i,
            /archos ?(5|gamepad2?|([\w ]*[t1789]|hello) ?\d+[\w ]*)( b|\))/i
          ],
          [M, [H, "Archos"], [AA, QA]],
          [
            /archos ([\w ]+)( b|\))/i,
            /; (ac[3-6]\d\w{2,8})( b|\))/i
          ],
          [M, [H, "Archos"], [AA, BA]],
          [
            // MIXED
            /(imo) (tab \w+)/i,
            // IMO
            /(infinix) (x1101b?)/i
            // Infinix XPad
          ],
          [H, M, [AA, QA]],
          [
            /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus(?! zenw)|dell|jolla|meizu|motorola|polytron|infinix|tecno|micromax|advan)[-_ ]?([-\w]*)/i,
            // BlackBerry/BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron/Infinix/Tecno/Micromax/Advan
            /; (hmd|imo) ([\w ]+?)(?: bui|\))/i,
            // HMD/IMO
            /(hp) ([\w ]+\w)/i,
            // HP iPAQ
            /(microsoft); (lumia[\w ]+)/i,
            // Microsoft Lumia
            /(lenovo)[-_ ]?([-\w ]+?)(?: bui|\)|\/)/i,
            // Lenovo
            /(oppo) ?([\w ]+) bui/i
            // OPPO
          ],
          [H, M, [AA, BA]],
          [
            /(kobo)\s(ereader|touch)/i,
            // Kobo
            /(hp).+(touchpad(?!.+tablet)|tablet)/i,
            // HP TouchPad
            /(kindle)\/([\w\.]+)/i,
            // Kindle
            /(nook)[\w ]+build\/(\w+)/i,
            // Nook
            /(dell) (strea[kpr\d ]*[\dko])/i,
            // Dell Streak
            /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,
            // Le Pan Tablets
            /(trinity)[- ]*(t\d{3}) bui/i,
            // Trinity Tablets
            /(gigaset)[- ]+(q\w{1,9}) bui/i,
            // Gigaset Tablets
            /(vodafone) ([\w ]+)(?:\)| bui)/i
            // Vodafone
          ],
          [H, M, [AA, QA]],
          [
            /(surface duo)/i
            // Surface Duo
          ],
          [M, [H, HA], [AA, QA]],
          [
            /droid [\d\.]+; (fp\du?)(?: b|\))/i
            // Fairphone
          ],
          [M, [H, "Fairphone"], [AA, BA]],
          [
            /(u304aa)/i
            // AT&T
          ],
          [M, [H, "AT&T"], [AA, BA]],
          [
            /\bsie-(\w*)/i
            // Siemens
          ],
          [M, [H, "Siemens"], [AA, BA]],
          [
            /\b(rct\w+) b/i
            // RCA Tablets
          ],
          [M, [H, "RCA"], [AA, QA]],
          [
            /\b(venue[\d ]{2,7}) b/i
            // Dell Venue Tablets
          ],
          [M, [H, "Dell"], [AA, QA]],
          [
            /\b(q(?:mv|ta)\w+) b/i
            // Verizon Tablet
          ],
          [M, [H, "Verizon"], [AA, QA]],
          [
            /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i
            // Barnes & Noble Tablet
          ],
          [M, [H, "Barnes & Noble"], [AA, QA]],
          [
            /\b(tm\d{3}\w+) b/i
          ],
          [M, [H, "NuVision"], [AA, QA]],
          [
            /\b(k88) b/i
            // ZTE K Series Tablet
          ],
          [M, [H, "ZTE"], [AA, QA]],
          [
            /\b(nx\d{3}j) b/i
            // ZTE Nubia
          ],
          [M, [H, "ZTE"], [AA, BA]],
          [
            /\b(gen\d{3}) b.+49h/i
            // Swiss GEN Mobile
          ],
          [M, [H, "Swiss"], [AA, BA]],
          [
            /\b(zur\d{3}) b/i
            // Swiss ZUR Tablet
          ],
          [M, [H, "Swiss"], [AA, QA]],
          [
            /\b((zeki)?tb.*\b) b/i
            // Zeki Tablets
          ],
          [M, [H, "Zeki"], [AA, QA]],
          [
            /\b([yr]\d{2}) b/i,
            /\b(dragon[- ]+touch |dt)(\w{5}) b/i
            // Dragon Touch Tablet
          ],
          [[H, "Dragon Touch"], M, [AA, QA]],
          [
            /\b(ns-?\w{0,9}) b/i
            // Insignia Tablets
          ],
          [M, [H, "Insignia"], [AA, QA]],
          [
            /\b((nxa|next)-?\w{0,9}) b/i
            // NextBook Tablets
          ],
          [M, [H, "NextBook"], [AA, QA]],
          [
            /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i
            // Voice Xtreme Phones
          ],
          [[H, "Voice"], M, [AA, BA]],
          [
            /\b(lvtel\-)?(v1[12]) b/i
            // LvTel Phones
          ],
          [[H, "LvTel"], M, [AA, BA]],
          [
            /\b(ph-1) /i
            // Essential PH-1
          ],
          [M, [H, "Essential"], [AA, BA]],
          [
            /\b(v(100md|700na|7011|917g).*\b) b/i
            // Envizen Tablets
          ],
          [M, [H, "Envizen"], [AA, QA]],
          [
            /\b(trio[-\w\. ]+) b/i
            // MachSpeed Tablets
          ],
          [M, [H, "MachSpeed"], [AA, QA]],
          [
            /\btu_(1491) b/i
            // Rotor Tablets
          ],
          [M, [H, "Rotor"], [AA, QA]],
          [
            /((?:tegranote|shield t(?!.+d tv))[\w- ]*?)(?: b|\))/i
            // Nvidia Tablets
          ],
          [M, [H, mA], [AA, QA]],
          [
            /(sprint) (\w+)/i
            // Sprint Phones
          ],
          [H, M, [AA, BA]],
          [
            /(kin\.[onetw]{3})/i
            // Microsoft Kin
          ],
          [[M, /\./g, " "], [H, HA], [AA, BA]],
          [
            /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i
            // Zebra
          ],
          [M, [H, ZA], [AA, QA]],
          [
            /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
          ],
          [M, [H, ZA], [AA, BA]],
          [
            ///////////////////
            // SMARTTVS
            ///////////////////
            /smart-tv.+(samsung)/i
            // Samsung
          ],
          [H, [AA, EA]],
          [
            /hbbtv.+maple;(\d+)/i
          ],
          [[M, /^/, "SmartTV"], [H, YA], [AA, EA]],
          [
            /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i
            // LG SmartTV
          ],
          [[H, FA], [AA, EA]],
          [
            /(apple) ?tv/i
            // Apple TV
          ],
          [H, [M, eA + " TV"], [AA, EA]],
          [
            /crkey/i
            // Google Chromecast
          ],
          [[M, wA + "cast"], [H, RA], [AA, EA]],
          [
            /droid.+aft(\w+)( bui|\))/i
            // Fire TV
          ],
          [M, [H, tA], [AA, EA]],
          [
            /(shield \w+ tv)/i
            // Nvidia Shield TV
          ],
          [M, [H, mA], [AA, EA]],
          [
            /\(dtv[\);].+(aquos)/i,
            /(aquos-tv[\w ]+)\)/i
            // Sharp
          ],
          [M, [H, LA], [AA, EA]],
          [
            /(bravia[\w ]+)( bui|\))/i
            // Sony
          ],
          [M, [H, WA], [AA, EA]],
          [
            /(mi(tv|box)-?\w+) bui/i
            // Xiaomi
          ],
          [M, [H, zA], [AA, EA]],
          [
            /Hbbtv.*(technisat) (.*);/i
            // TechniSAT
          ],
          [H, M, [AA, EA]],
          [
            /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
            // Roku
            /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i
            // HbbTV devices
          ],
          [[H, rg], [M, rg], [AA, EA]],
          [
            // SmartTV from Unidentified Vendors
            /droid.+; ([\w- ]+) (?:android tv|smart[- ]?tv)/i
          ],
          [M, [AA, EA]],
          [
            /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i
          ],
          [[AA, EA]],
          [
            ///////////////////
            // CONSOLES
            ///////////////////
            /(ouya)/i,
            // Ouya
            /(nintendo) ([wids3utch]+)/i
            // Nintendo
          ],
          [H, M, [AA, IA]],
          [
            /droid.+; (shield)( bui|\))/i
            // Nvidia Portable
          ],
          [M, [H, mA], [AA, IA]],
          [
            /(playstation \w+)/i
            // Playstation
          ],
          [M, [H, WA], [AA, IA]],
          [
            /\b(xbox(?: one)?(?!; xbox))[\); ]/i
            // Microsoft Xbox
          ],
          [M, [H, HA], [AA, IA]],
          [
            ///////////////////
            // WEARABLES
            ///////////////////
            /\b(sm-[lr]\d\d[0156][fnuw]?s?|gear live)\b/i
            // Samsung Galaxy Watch
          ],
          [M, [H, YA], [AA, oA]],
          [
            /((pebble))app/i,
            // Pebble
            /(asus|google|lg|oppo) ((pixel |zen)?watch[\w ]*)( bui|\))/i
            // Asus ZenWatch / LG Watch / Pixel Watch
          ],
          [H, M, [AA, oA]],
          [
            /(ow(?:19|20)?we?[1-3]{1,3})/i
            // Oppo Watch
          ],
          [M, [H, MA], [AA, oA]],
          [
            /(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i
            // Apple Watch
          ],
          [M, [H, eA], [AA, oA]],
          [
            /(opwwe\d{3})/i
            // OnePlus Watch
          ],
          [M, [H, xA], [AA, oA]],
          [
            /(moto 360)/i
            // Motorola 360
          ],
          [M, [H, sA], [AA, oA]],
          [
            /(smartwatch 3)/i
            // Sony SmartWatch
          ],
          [M, [H, WA], [AA, oA]],
          [
            /(g watch r)/i
            // LG G Watch R
          ],
          [M, [H, FA], [AA, oA]],
          [
            /droid.+; (wt63?0{2,3})\)/i
          ],
          [M, [H, ZA], [AA, oA]],
          [
            ///////////////////
            // XR
            ///////////////////
            /droid.+; (glass) \d/i
            // Google Glass
          ],
          [M, [H, RA], [AA, oA]],
          [
            /(pico) (4|neo3(?: link|pro)?)/i
            // Pico
          ],
          [H, M, [AA, oA]],
          [
            /; (quest( \d| pro)?)/i
            // Oculus Quest
          ],
          [M, [H, Ag], [AA, oA]],
          [
            ///////////////////
            // EMBEDDED
            ///////////////////
            /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i
            // Tesla
          ],
          [H, [AA, iA]],
          [
            /(aeobc)\b/i
            // Echo Dot
          ],
          [M, [H, tA], [AA, iA]],
          [
            /(homepod).+mac os/i
            // Apple HomePod
          ],
          [M, [H, eA], [AA, iA]],
          [
            /windows iot/i
          ],
          [[AA, iA]],
          [
            ////////////////////
            // MIXED (GENERIC)
            ///////////////////
            /droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+? mobile safari/i
            // Android Phones from Unidentified Vendors
          ],
          [M, [AA, BA]],
          [
            /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i
            // Android Tablets from Unidentified Vendors
          ],
          [M, [AA, QA]],
          [
            /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i
            // Unidentifiable Tablet
          ],
          [[AA, QA]],
          [
            /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i
            // Unidentifiable Mobile
          ],
          [[AA, BA]],
          [
            /droid .+?; ([\w\. -]+)( bui|\))/i
            // Generic Android Device
          ],
          [M, [H, "Generic"]]
        ],
        engine: [
          [
            /windows.+ edge\/([\w\.]+)/i
            // EdgeHTML
          ],
          [gA, [S, lA + "HTML"]],
          [
            /(arkweb)\/([\w\.]+)/i
            // ArkWeb
          ],
          [S, gA],
          [
            /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i
            // Blink
          ],
          [gA, [S, "Blink"]],
          [
            /(presto)\/([\w\.]+)/i,
            // Presto
            /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna|servo)\/([\w\.]+)/i,
            // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m/Goanna/Servo
            /ekioh(flow)\/([\w\.]+)/i,
            // Flow
            /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
            // KHTML/Tasman/Links
            /(icab)[\/ ]([23]\.[\d\.]+)/i,
            // iCab
            /\b(libweb)/i
            // LibWeb
          ],
          [S, gA],
          [
            /ladybird\//i
          ],
          [[S, "LibWeb"]],
          [
            /rv\:([\w\.]{1,9})\b.+(gecko)/i
            // Gecko
          ],
          [gA, S]
        ],
        os: [
          [
            // Windows
            /microsoft (windows) (vista|xp)/i
            // Windows (iTunes)
          ],
          [S, gA],
          [
            /(windows (?:phone(?: os)?|mobile|iot))[\/ ]?([\d\.\w ]*)/i
            // Windows Phone
          ],
          [S, [gA, hg, dA]],
          [
            /windows nt 6\.2; (arm)/i,
            // Windows RT
            /windows[\/ ]([ntce\d\. ]+\w)(?!.+xbox)/i,
            /(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i
          ],
          [[gA, hg, dA], [S, "Windows"]],
          [
            // iOS/macOS
            /[adehimnop]{4,7}\b(?:.*os ([\w]+) like mac|; opera)/i,
            // iOS
            /(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i,
            /cfnetwork\/.+darwin/i
          ],
          [[gA, /_/g, "."], [S, "iOS"]],
          [
            /(mac os x) ?([\w\. ]*)/i,
            /(macintosh|mac_powerpc\b)(?!.+haiku)/i
            // Mac OS
          ],
          [[S, ig], [gA, /_/g, "."]],
          [
            // Mobile OSes
            /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i
            // Android-x86/HarmonyOS
          ],
          [gA, S],
          [
            /(ubuntu) ([\w\.]+) like android/i
            // Ubuntu Touch
          ],
          [[S, /(.+)/, "$1 Touch"], gA],
          [
            // Android/Blackberry/WebOS/QNX/Bada/RIM/KaiOS/Maemo/MeeGo/S40/Sailfish OS/OpenHarmony/Tizen
            /(android|bada|blackberry|kaios|maemo|meego|openharmony|qnx|rim tablet os|sailfish|series40|symbian|tizen|webos)\w*[-\/; ]?([\d\.]*)/i
          ],
          [S, gA],
          [
            /\(bb(10);/i
            // BlackBerry 10
          ],
          [gA, [S, DA]],
          [
            /(?:symbian ?os|symbos|s60(?=;)|series ?60)[-\/ ]?([\w\.]*)/i
            // Symbian
          ],
          [gA, [S, "Symbian"]],
          [
            /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i
            // Firefox OS
          ],
          [gA, [S, NA + " OS"]],
          [
            /web0s;.+rt(tv)/i,
            /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i
            // WebOS
          ],
          [gA, [S, "webOS"]],
          [
            /watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i
            // watchOS
          ],
          [gA, [S, "watchOS"]],
          [
            // Google Chromecast
            /crkey\/([\d\.]+)/i
            // Google Chromecast
          ],
          [gA, [S, wA + "cast"]],
          [
            /(cros) [\w]+(?:\)| ([\w\.]+)\b)/i
            // Chromium OS
          ],
          [[S, UA], gA],
          [
            // Smart TVs
            /panasonic;(viera)/i,
            // Panasonic Viera
            /(netrange)mmh/i,
            // Netrange
            /(nettv)\/(\d+\.[\w\.]+)/i,
            // NetTV
            // Console
            /(nintendo|playstation) ([wids345portablevuch]+)/i,
            // Nintendo/Playstation
            /(xbox); +xbox ([^\);]+)/i,
            // Microsoft Xbox (360, One, X, S, Series X, Series S)
            // Other
            /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
            // Joli/Palm
            /(mint)[\/\(\) ]?(\w*)/i,
            // Mint
            /(mageia|vectorlinux)[; ]/i,
            // Mageia/VectorLinux
            /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
            // Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware/Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus/Raspbian/Plan9/Minix/RISCOS/Contiki/Deepin/Manjaro/elementary/Sabayon/Linspire
            /(hurd|linux)(?: arm\w*| x86\w*| ?)([\w\.]*)/i,
            // Hurd/Linux
            /(gnu) ?([\w\.]*)/i,
            // GNU
            /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
            // FreeBSD/NetBSD/OpenBSD/PC-BSD/GhostBSD/DragonFly
            /(haiku) (\w+)/i
            // Haiku
          ],
          [S, gA],
          [
            /(sunos) ?([\w\.\d]*)/i
            // Solaris
          ],
          [[S, "Solaris"], gA],
          [
            /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
            // Solaris
            /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,
            // AIX
            /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i,
            // BeOS/OS2/AmigaOS/MorphOS/OpenVMS/Fuchsia/HP-UX/SerenityOS
            /(unix) ?([\w\.]*)/i
            // UNIX
          ],
          [S, gA]
        ]
      }, XA = function(VA, $A) {
        if (typeof VA === d && ($A = VA, VA = g), !(this instanceof XA))
          return new XA(VA, $A).getResult();
        var fA = typeof A !== h && A.navigator ? A.navigator : g, yA = VA || (fA && fA.userAgent ? fA.userAgent : t), bA = fA && fA.userAgentData ? fA.userAgentData : g, kA = $A ? PA(pA, $A) : pA, JA = fA && fA.userAgent == yA;
        return this.getBrowser = function() {
          var uA = {};
          return uA[S] = g, uA[gA] = g, cg.call(uA, yA, kA.browser), uA[p] = Dg(uA[gA]), JA && fA && fA.brave && typeof fA.brave.isBrave == n && (uA[S] = "Brave"), uA;
        }, this.getCPU = function() {
          var uA = {};
          return uA[CA] = g, cg.call(uA, yA, kA.cpu), uA;
        }, this.getDevice = function() {
          var uA = {};
          return uA[H] = g, uA[M] = g, uA[AA] = g, cg.call(uA, yA, kA.device), JA && !uA[AA] && bA && bA.mobile && (uA[AA] = BA), JA && uA[M] == "Macintosh" && fA && typeof fA.standalone !== h && fA.maxTouchPoints && fA.maxTouchPoints > 2 && (uA[M] = "iPad", uA[AA] = QA), uA;
        }, this.getEngine = function() {
          var uA = {};
          return uA[S] = g, uA[gA] = g, cg.call(uA, yA, kA.engine), uA;
        }, this.getOS = function() {
          var uA = {};
          return uA[S] = g, uA[gA] = g, cg.call(uA, yA, kA.os), JA && !uA[S] && bA && bA.platform && bA.platform != "Unknown" && (uA[S] = bA.platform.replace(/chrome os/i, UA).replace(/macos/i, ig)), uA;
        }, this.getResult = function() {
          return {
            ua: this.getUA(),
            browser: this.getBrowser(),
            engine: this.getEngine(),
            os: this.getOS(),
            device: this.getDevice(),
            cpu: this.getCPU()
          };
        }, this.getUA = function() {
          return yA;
        }, this.setUA = function(uA) {
          return yA = typeof uA === k && uA.length > aA ? rg(uA, aA) : uA, this;
        }, this.setUA(yA), this;
      };
      XA.VERSION = e, XA.BROWSER = Gg([S, gA, p]), XA.CPU = Gg([CA]), XA.DEVICE = Gg([M, H, AA, IA, BA, EA, QA, oA, iA]), XA.ENGINE = XA.OS = Gg([S, gA]), o.exports && (E = o.exports = XA), E.UAParser = XA;
      var jA = typeof A !== h && (A.jQuery || A.Zepto);
      if (jA && !jA.ua) {
        var OA = new XA();
        jA.ua = OA.getResult(), jA.ua.get = function() {
          return OA.getUA();
        }, jA.ua.set = function(VA) {
          OA.setUA(VA);
          var $A = OA.getResult();
          for (var fA in $A)
            jA.ua[fA] = $A[fA];
        };
      }
    })(typeof window == "object" ? window : uaParser);
  })(uaParser$1, uaParser$1.exports)), uaParser$1.exports;
}
var uaParserExports = requireUaParser();
const UAParser = /* @__PURE__ */ getDefaultExportFromCjs(uaParserExports), parser = new UAParser();
function isMobile() {
  return parser.getResult().device.type === "mobile";
}
function useSelectCommon(o) {
  const {
    options: E,
    isMulti: A,
    acceptNewOptions: g,
    placeholderInput: e
  } = o, t = useMemo$1(() => E.map((S, AA) => ({
    label: S,
    value: S,
    // We are using an id because if multiple options are equal,
    // we have observed weird UI glitches
    id: `${S}_${AA}`
  })), [E]), {
    placeholder: c,
    shouldDisable: n
  } = useMemo$1(() => getSelectPlaceholder(e, E, g, A), [g, A, E, e]), h = E.length > 10, d = isMobile() && !h && !g ? "readonly" : null, k = useMemo$1(() => (S) => isNullOrUndefined(S) ? [] : [{
    label: S,
    value: S
  }], []), p = useMemo$1(() => (S) => S.map((AA) => ({
    label: AA,
    value: AA
  })), []), M = useMemo$1(() => (S) => (AA, H) => {
    const gA = Array.isArray(S) ? (
      // We need to manually filter for previously selected options here
      AA.filter((CA) => !S.includes(CA.value))
    ) : AA;
    return fuzzyFilterSelectOptions(gA, H);
  }, []);
  return {
    selectOptions: t,
    placeholder: c,
    disabled: n,
    inputReadOnly: d,
    valueToUiSingle: k,
    valuesToUiMulti: p,
    createFilterOptions: M
  };
}
const Selectbox = ({
  disabled: o,
  value: E,
  onChange: A,
  options: g,
  label: e,
  labelVisibility: t,
  help: c,
  placeholder: n,
  clearable: h,
  acceptNewOptions: d
}) => {
  const k = useEmotionTheme(), p = useContext(IsSidebarContext), [M, S] = useState(E), AA = useRef(M);
  useEffect(() => {
    S(E);
  }, [E]);
  const H = useCallback((cA) => {
    if (cA.type === "remove") {
      AA.current = cA.option?.value, S(null);
      return;
    }
    if (AA.current = null, cA.type === "clear") {
      S(null), A(null);
      return;
    }
    const [DA] = cA.value;
    S(DA.value), A(DA.value);
  }, [A]), gA = useCallback(() => {
    AA.current !== null && S(AA.current);
  }, []), CA = g, {
    placeholder: IA,
    disabled: BA,
    selectOptions: QA,
    inputReadOnly: EA,
    valueToUiSingle: oA,
    createFilterOptions: iA
  } = useSelectCommon({
    options: CA,
    isMulti: !1,
    acceptNewOptions: d,
    placeholderInput: n
  }), aA = o || BA, tA = useMemo$1(() => iA(), [iA]), eA = oA(M);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "stSelectbox", "data-testid": "stSelectbox", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(WidgetLabel, { label: e, labelVisibility: t, disabled: aA, children: c && /* @__PURE__ */ jsxRuntimeExports.jsx(StyledWidgetLabelHelp, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(TooltipIcon, { content: c, placement: Placement.TOP_RIGHT }) }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Select, { creatable: d, disabled: aA, labelKey: "label", "aria-label": e || "", onChange: H, onBlur: gA, options: QA, filterOptions: tA, clearable: h || !1, escapeClearsValue: h || !1, value: eA, valueKey: "value", placeholder: IA, ignoreCase: !1, overrides: {
      Root: {
        style: () => ({
          lineHeight: k.lineHeights.inputWidget,
          fontWeight: k.fontWeights.normal
        })
      },
      Dropdown: {
        component: VirtualDropdown
      },
      ClearIcon: {
        props: {
          overrides: {
            Svg: {
              style: {
                color: k.colors.grayTextColor,
                // Setting this width and height makes the clear-icon align with dropdown arrows
                padding: k.spacing.threeXS,
                height: k.sizes.clearIconSize,
                width: k.sizes.clearIconSize,
                ":hover": {
                  fill: k.colors.bodyText
                }
              }
            }
          }
        }
      },
      ControlContainer: {
        style: ({
          $isFocused: cA
        }) => {
          const DA = getBorderColor(k.colors, cA);
          return {
            height: k.sizes.minElementHeight,
            // Baseweb requires long-hand props, short-hand leads to weird bugs & warnings.
            borderLeftWidth: k.sizes.borderWidth,
            borderRightWidth: k.sizes.borderWidth,
            borderTopWidth: k.sizes.borderWidth,
            borderBottomWidth: k.sizes.borderWidth,
            borderTopColor: DA,
            borderRightColor: DA,
            borderBottomColor: DA,
            borderLeftColor: DA
          };
        }
      },
      IconsContainer: {
        style: () => ({
          paddingRight: k.spacing.sm
        })
      },
      Placeholder: {
        style: () => ({
          color: aA ? k.colors.fadedText40 : k.colors.fadedText60
        })
      },
      ValueContainer: {
        style: () => ({
          // Baseweb requires long-hand props, short-hand leads to weird bugs & warnings.
          paddingRight: k.spacing.sm,
          paddingLeft: k.spacing.md,
          paddingBottom: k.spacing.sm,
          paddingTop: k.spacing.sm
        })
      },
      Input: {
        props: {
          readOnly: EA
        },
        style: () => ({
          lineHeight: k.lineHeights.inputWidget
        })
      },
      // Nudge the dropdown menu by 1px so the focus state doesn't get cut off
      Popover: {
        props: {
          ignoreBoundary: p,
          overrides: {
            Body: {
              style: () => ({
                marginTop: k.spacing.px
              })
            }
          }
        }
      },
      SingleValue: {
        style: () => ({
          // remove margin from select value so that there is no jumpb, e.g. when pressing backspace on a selected option and removing a character.
          marginLeft: k.spacing.none
        })
      },
      SelectArrow: {
        component: ChevronDown$1,
        props: {
          style: {
            ...aA && {
              cursor: "not-allowed"
            }
          },
          overrides: {
            Svg: {
              style: () => ({
                width: k.iconSizes.xl,
                height: k.iconSizes.xl
              })
            }
          }
        }
      }
    } })
  ] });
}, UISelectbox = memo(Selectbox);
class CircularBuffer {
  /**
   * Creates an instance of CircularBuffer.
   * @param {number} size - The size of the buffer.
   */
  constructor(E) {
    this._buffer = new Array(E), this._size = E, this._index = 0, this._wrappedCount = 0;
  }
  /**
   * Adds a value to the buffer.
   * @param {T} value - The value to add to the buffer.
   */
  push(E) {
    this._buffer[this._index] = E, this._index = (this._index + 1) % this._size, this._index === 0 && (this._wrappedCount = this._wrappedCount + 1);
  }
  /**
   * Gets the current state of the buffer.
   * @returns {readonly T[]} The buffer array.
   */
  get buffer() {
    return this._buffer;
  }
  /**
   * Gets the total number of entries written to the buffer.
   * @returns {number} The total number of written entries.
   */
  get totalWrittenEntries() {
    return this._wrappedCount * this._size + this._index;
  }
}
const handleRender = (o, E, A, g, e, t) => {
  window.__streamlit_profiles__ = window.__streamlit_profiles__ || {}, window.__streamlit_profiles__[o] = window.__streamlit_profiles__[o] || // Use a CircularBuffer to limit the number of profiles stored in memory to
  // prevent any potential memory leaks.
  // 1000 is an arbitrary number that should be enough to store more than
  // enough entries for debugging purposes without consuming too much memory.
  new CircularBuffer(1e3), window.__streamlit_profiles__[o].push({
    phase: E,
    actualDuration: A,
    baseDuration: g,
    startTime: e,
    commitTime: t
  });
}, Profiler = ({
  id: o,
  children: E
}) => /* @__PURE__ */ jsxRuntimeExports.jsx(Profiler$1, { id: o, onRender: handleRender, children: E }), WindowDimensionsContext = createContext(null);
WindowDimensionsContext.displayName = "WindowDimensionsContext";
const useWindowDimensions = () => {
  const o = useEmotionTheme(), [E, A] = useState({
    fullWidth: 0,
    fullHeight: 0,
    innerWidth: 0,
    innerHeight: 0
  }), g = useCallback(() => {
    const t = convertRemToPx(o.spacing.md), c = convertRemToPx(o.sizes.fullScreenHeaderHeight), {
      innerWidth: n,
      innerHeight: h
    } = window;
    return {
      fullWidth: n - t * 2,
      // Left and right
      fullHeight: h - (t + c),
      // Bottom and Top
      innerWidth: n,
      innerHeight: h
    };
  }, [o.sizes.fullScreenHeaderHeight, o.spacing.md]), e = useCallback(() => {
    A(g());
  }, [g]);
  return useEffect(() => (window.addEventListener("resize", e), () => {
    window.removeEventListener("resize", e);
  }), [e]), useLayoutEffect$1(() => {
    e();
  }, [e]), E;
}, WindowDimensionsProvider = ({
  children: o
}) => {
  const E = useWindowDimensions();
  if (useContext(WindowDimensionsContext))
    throw new Error("WindowDimensionsProvider should only be used once per app. If you need to read window dimensions, utilize `useWindowDimensionsContext()` instead.");
  return /* @__PURE__ */ jsxRuntimeExports.jsx(WindowDimensionsContext.Provider, { value: E, children: o });
}, useWindowDimensionsContext = () => useRequiredContext(WindowDimensionsContext);
var commonjsGlobal = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, loglevel$1 = { exports: {} }, loglevel = loglevel$1.exports, hasRequiredLoglevel;
function requireLoglevel() {
  return hasRequiredLoglevel || (hasRequiredLoglevel = 1, (function(o) {
    (function(E, A) {
      o.exports ? o.exports = A() : E.log = A();
    })(loglevel, function() {
      var E = function() {
      }, A = "undefined", g = typeof window !== A && typeof window.navigator !== A && /Trident\/|MSIE /.test(window.navigator.userAgent), e = ["trace", "debug", "info", "warn", "error"], t = {}, c = null;
      function n(H, gA) {
        var CA = H[gA];
        if (typeof CA.bind == "function") return CA.bind(H);
        try {
          return Function.prototype.bind.call(CA, H);
        } catch {
          return function() {
            return Function.prototype.apply.apply(CA, [H, arguments]);
          };
        }
      }
      function h() {
        console.log && (console.log.apply ? console.log.apply(console, arguments) : Function.prototype.apply.apply(console.log, [console, arguments])), console.trace && console.trace();
      }
      function d(H) {
        return H === "debug" && (H = "log"), typeof console === A ? !1 : H === "trace" && g ? h : console[H] !== void 0 ? n(console, H) : console.log !== void 0 ? n(console, "log") : E;
      }
      function k() {
        for (var H = this.getLevel(), gA = 0; gA < e.length; gA++) {
          var CA = e[gA];
          this[CA] = gA < H ? E : this.methodFactory(CA, H, this.name);
        }
        if (this.log = this.debug, typeof console === A && H < this.levels.SILENT) return "No console available for logging";
      }
      function p(H) {
        return function() {
          typeof console !== A && (k.call(this), this[H].apply(this, arguments));
        };
      }
      function M(H, gA, CA) {
        return d(H) || p.apply(this, arguments);
      }
      function S(H, gA) {
        var CA = this, IA, BA, QA, EA = "loglevel";
        typeof H == "string" ? EA += ":" + H : typeof H == "symbol" && (EA = void 0);
        function oA(cA) {
          var DA = (e[cA] || "silent").toUpperCase();
          if (!(typeof window === A || !EA)) {
            try {
              window.localStorage[EA] = DA;
              return;
            } catch {
            }
            try {
              window.document.cookie = encodeURIComponent(EA) + "=" + DA + ";";
            } catch {
            }
          }
        }
        function iA() {
          var cA;
          if (!(typeof window === A || !EA)) {
            try {
              cA = window.localStorage[EA];
            } catch {
            }
            if (typeof cA === A) try {
              var DA = window.document.cookie, nA = encodeURIComponent(EA), wA = DA.indexOf(nA + "=");
              wA !== -1 && (cA = /^([^;]+)/.exec(DA.slice(wA + nA.length + 1))[1]);
            } catch {
            }
            return CA.levels[cA] === void 0 && (cA = void 0), cA;
          }
        }
        function aA() {
          if (!(typeof window === A || !EA)) {
            try {
              window.localStorage.removeItem(EA);
            } catch {
            }
            try {
              window.document.cookie = encodeURIComponent(EA) + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC";
            } catch {
            }
          }
        }
        function tA(cA) {
          var DA = cA;
          if (typeof DA == "string" && CA.levels[DA.toUpperCase()] !== void 0 && (DA = CA.levels[DA.toUpperCase()]), typeof DA == "number" && DA >= 0 && DA <= CA.levels.SILENT) return DA;
          throw new TypeError("log.setLevel() called with invalid level: " + cA);
        }
        CA.name = H, CA.levels = { TRACE: 0, DEBUG: 1, INFO: 2, WARN: 3, ERROR: 4, SILENT: 5 }, CA.methodFactory = gA || M, CA.getLevel = function() {
          return QA ?? BA ?? IA;
        }, CA.setLevel = function(cA, DA) {
          return QA = tA(cA), DA !== !1 && oA(QA), k.call(CA);
        }, CA.setDefaultLevel = function(cA) {
          BA = tA(cA), iA() || CA.setLevel(cA, !1);
        }, CA.resetLevel = function() {
          QA = null, aA(), k.call(CA);
        }, CA.enableAll = function(cA) {
          CA.setLevel(CA.levels.TRACE, cA);
        }, CA.disableAll = function(cA) {
          CA.setLevel(CA.levels.SILENT, cA);
        }, CA.rebuild = function() {
          if (c !== CA && (IA = tA(c.getLevel())), k.call(CA), c === CA) for (var cA in t) t[cA].rebuild();
        }, IA = tA(c ? c.getLevel() : "WARN");
        var eA = iA();
        eA != null && (QA = tA(eA)), k.call(CA);
      }
      c = new S(), c.getLogger = function(H) {
        if (typeof H != "symbol" && typeof H != "string" || H === "") throw new TypeError("You must supply a name when creating a logger.");
        var gA = t[H];
        return gA || (gA = t[H] = new S(H, c.methodFactory)), gA;
      };
      var AA = typeof window !== A ? window.log : void 0;
      return c.noConflict = function() {
        return typeof window !== A && window.log === c && (window.log = AA), c;
      }, c.getLoggers = function() {
        return t;
      }, c.default = c, c;
    });
  })(loglevel$1)), loglevel$1.exports;
}
var loglevelExports = requireLoglevel(), ConnectionState$1 = /* @__PURE__ */ ((o) => (o.CONNECTED = "CONNECTED", o.DISCONNECTED_FOREVER = "DISCONNECTED_FOREVER", o.INITIAL = "INITIAL", o.PINGING_SERVER = "PINGING_SERVER", o.CONNECTING = "CONNECTING", o.STATIC_CONNECTING = "STATIC_CONNECTING", o.STATIC_CONNECTED = "STATIC_CONNECTED", o))(ConnectionState$1 || {});
process.env.NODE_ENV;
var indexMinimal = {}, minimal$1 = {}, aspromise, hasRequiredAspromise;
function requireAspromise() {
  if (hasRequiredAspromise) return aspromise;
  hasRequiredAspromise = 1, aspromise = o;
  function o(E, A) {
    for (var g = new Array(arguments.length - 1), e = 0, t = 2, c = !0; t < arguments.length; ) g[e++] = arguments[t++];
    return new Promise(function(n, h) {
      g[e] = function(d) {
        if (c) if (c = !1, d) h(d);
        else {
          for (var k = new Array(arguments.length - 1), p = 0; p < k.length; ) k[p++] = arguments[p];
          n.apply(null, k);
        }
      };
      try {
        E.apply(A || null, g);
      } catch (d) {
        c && (c = !1, h(d));
      }
    });
  }
  return aspromise;
}
var base64 = {}, hasRequiredBase64;
function requireBase64() {
  return hasRequiredBase64 || (hasRequiredBase64 = 1, (function(o) {
    var E = o;
    E.length = function(c) {
      var n = c.length;
      if (!n) return 0;
      for (var h = 0; --n % 4 > 1 && c.charAt(n) === "="; ) ++h;
      return Math.ceil(c.length * 3) / 4 - h;
    };
    for (var A = new Array(64), g = new Array(123), e = 0; e < 64; ) g[A[e] = e < 26 ? e + 65 : e < 52 ? e + 71 : e < 62 ? e - 4 : e - 59 | 43] = e++;
    E.encode = function(c, n, h) {
      for (var d = null, k = [], p = 0, M = 0, S; n < h; ) {
        var AA = c[n++];
        switch (M) {
          case 0:
            k[p++] = A[AA >> 2], S = (AA & 3) << 4, M = 1;
            break;
          case 1:
            k[p++] = A[S | AA >> 4], S = (AA & 15) << 2, M = 2;
            break;
          case 2:
            k[p++] = A[S | AA >> 6], k[p++] = A[AA & 63], M = 0;
            break;
        }
        p > 8191 && ((d || (d = [])).push(String.fromCharCode.apply(String, k)), p = 0);
      }
      return M && (k[p++] = A[S], k[p++] = 61, M === 1 && (k[p++] = 61)), d ? (p && d.push(String.fromCharCode.apply(String, k.slice(0, p))), d.join("")) : String.fromCharCode.apply(String, k.slice(0, p));
    };
    var t = "invalid encoding";
    E.decode = function(c, n, h) {
      for (var d = h, k = 0, p, M = 0; M < c.length; ) {
        var S = c.charCodeAt(M++);
        if (S === 61 && k > 1) break;
        if ((S = g[S]) === void 0) throw Error(t);
        switch (k) {
          case 0:
            p = S, k = 1;
            break;
          case 1:
            n[h++] = p << 2 | (S & 48) >> 4, p = S, k = 2;
            break;
          case 2:
            n[h++] = (p & 15) << 4 | (S & 60) >> 2, p = S, k = 3;
            break;
          case 3:
            n[h++] = (p & 3) << 6 | S, k = 0;
            break;
        }
      }
      if (k === 1) throw Error(t);
      return h - d;
    }, E.test = function(c) {
      return /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/.test(c);
    };
  })(base64)), base64;
}
var eventemitter, hasRequiredEventemitter;
function requireEventemitter() {
  if (hasRequiredEventemitter) return eventemitter;
  hasRequiredEventemitter = 1, eventemitter = o;
  function o() {
    this._listeners = {};
  }
  return o.prototype.on = function(E, A, g) {
    return (this._listeners[E] || (this._listeners[E] = [])).push({ fn: A, ctx: g || this }), this;
  }, o.prototype.off = function(E, A) {
    if (E === void 0) this._listeners = {};
    else if (A === void 0) this._listeners[E] = [];
    else for (var g = this._listeners[E], e = 0; e < g.length; ) g[e].fn === A ? g.splice(e, 1) : ++e;
    return this;
  }, o.prototype.emit = function(E) {
    var A = this._listeners[E];
    if (A) {
      for (var g = [], e = 1; e < arguments.length; ) g.push(arguments[e++]);
      for (e = 0; e < A.length; ) A[e].fn.apply(A[e++].ctx, g);
    }
    return this;
  }, eventemitter;
}
var float, hasRequiredFloat;
function requireFloat() {
  if (hasRequiredFloat) return float;
  hasRequiredFloat = 1, float = o(o);
  function o(t) {
    return typeof Float32Array < "u" ? (function() {
      var c = new Float32Array([-0]), n = new Uint8Array(c.buffer), h = n[3] === 128;
      function d(S, AA, H) {
        c[0] = S, AA[H] = n[0], AA[H + 1] = n[1], AA[H + 2] = n[2], AA[H + 3] = n[3];
      }
      function k(S, AA, H) {
        c[0] = S, AA[H] = n[3], AA[H + 1] = n[2], AA[H + 2] = n[1], AA[H + 3] = n[0];
      }
      t.writeFloatLE = h ? d : k, t.writeFloatBE = h ? k : d;
      function p(S, AA) {
        return n[0] = S[AA], n[1] = S[AA + 1], n[2] = S[AA + 2], n[3] = S[AA + 3], c[0];
      }
      function M(S, AA) {
        return n[3] = S[AA], n[2] = S[AA + 1], n[1] = S[AA + 2], n[0] = S[AA + 3], c[0];
      }
      t.readFloatLE = h ? p : M, t.readFloatBE = h ? M : p;
    })() : (function() {
      function c(h, d, k, p) {
        var M = d < 0 ? 1 : 0;
        if (M && (d = -d), d === 0) h(1 / d > 0 ? (
          /* positive */
          0
        ) : (
          /* negative 0 */
          2147483648
        ), k, p);
        else if (isNaN(d)) h(2143289344, k, p);
        else if (d > 34028234663852886e22) h((M << 31 | 2139095040) >>> 0, k, p);
        else if (d < 11754943508222875e-54) h((M << 31 | Math.round(d / 1401298464324817e-60)) >>> 0, k, p);
        else {
          var S = Math.floor(Math.log(d) / Math.LN2), AA = Math.round(d * Math.pow(2, -S) * 8388608) & 8388607;
          h((M << 31 | S + 127 << 23 | AA) >>> 0, k, p);
        }
      }
      t.writeFloatLE = c.bind(null, E), t.writeFloatBE = c.bind(null, A);
      function n(h, d, k) {
        var p = h(d, k), M = (p >> 31) * 2 + 1, S = p >>> 23 & 255, AA = p & 8388607;
        return S === 255 ? AA ? NaN : M * (1 / 0) : S === 0 ? M * 1401298464324817e-60 * AA : M * Math.pow(2, S - 150) * (AA + 8388608);
      }
      t.readFloatLE = n.bind(null, g), t.readFloatBE = n.bind(null, e);
    })(), typeof Float64Array < "u" ? (function() {
      var c = new Float64Array([-0]), n = new Uint8Array(c.buffer), h = n[7] === 128;
      function d(S, AA, H) {
        c[0] = S, AA[H] = n[0], AA[H + 1] = n[1], AA[H + 2] = n[2], AA[H + 3] = n[3], AA[H + 4] = n[4], AA[H + 5] = n[5], AA[H + 6] = n[6], AA[H + 7] = n[7];
      }
      function k(S, AA, H) {
        c[0] = S, AA[H] = n[7], AA[H + 1] = n[6], AA[H + 2] = n[5], AA[H + 3] = n[4], AA[H + 4] = n[3], AA[H + 5] = n[2], AA[H + 6] = n[1], AA[H + 7] = n[0];
      }
      t.writeDoubleLE = h ? d : k, t.writeDoubleBE = h ? k : d;
      function p(S, AA) {
        return n[0] = S[AA], n[1] = S[AA + 1], n[2] = S[AA + 2], n[3] = S[AA + 3], n[4] = S[AA + 4], n[5] = S[AA + 5], n[6] = S[AA + 6], n[7] = S[AA + 7], c[0];
      }
      function M(S, AA) {
        return n[7] = S[AA], n[6] = S[AA + 1], n[5] = S[AA + 2], n[4] = S[AA + 3], n[3] = S[AA + 4], n[2] = S[AA + 5], n[1] = S[AA + 6], n[0] = S[AA + 7], c[0];
      }
      t.readDoubleLE = h ? p : M, t.readDoubleBE = h ? M : p;
    })() : (function() {
      function c(h, d, k, p, M, S) {
        var AA = p < 0 ? 1 : 0;
        if (AA && (p = -p), p === 0) h(0, M, S + d), h(1 / p > 0 ? (
          /* positive */
          0
        ) : (
          /* negative 0 */
          2147483648
        ), M, S + k);
        else if (isNaN(p)) h(0, M, S + d), h(2146959360, M, S + k);
        else if (p > 17976931348623157e292) h(0, M, S + d), h((AA << 31 | 2146435072) >>> 0, M, S + k);
        else {
          var H;
          if (p < 22250738585072014e-324) H = p / 5e-324, h(H >>> 0, M, S + d), h((AA << 31 | H / 4294967296) >>> 0, M, S + k);
          else {
            var gA = Math.floor(Math.log(p) / Math.LN2);
            gA === 1024 && (gA = 1023), H = p * Math.pow(2, -gA), h(H * 4503599627370496 >>> 0, M, S + d), h((AA << 31 | gA + 1023 << 20 | H * 1048576 & 1048575) >>> 0, M, S + k);
          }
        }
      }
      t.writeDoubleLE = c.bind(null, E, 0, 4), t.writeDoubleBE = c.bind(null, A, 4, 0);
      function n(h, d, k, p, M) {
        var S = h(p, M + d), AA = h(p, M + k), H = (AA >> 31) * 2 + 1, gA = AA >>> 20 & 2047, CA = 4294967296 * (AA & 1048575) + S;
        return gA === 2047 ? CA ? NaN : H * (1 / 0) : gA === 0 ? H * 5e-324 * CA : H * Math.pow(2, gA - 1075) * (CA + 4503599627370496);
      }
      t.readDoubleLE = n.bind(null, g, 0, 4), t.readDoubleBE = n.bind(null, e, 4, 0);
    })(), t;
  }
  function E(t, c, n) {
    c[n] = t & 255, c[n + 1] = t >>> 8 & 255, c[n + 2] = t >>> 16 & 255, c[n + 3] = t >>> 24;
  }
  function A(t, c, n) {
    c[n] = t >>> 24, c[n + 1] = t >>> 16 & 255, c[n + 2] = t >>> 8 & 255, c[n + 3] = t & 255;
  }
  function g(t, c) {
    return (t[c] | t[c + 1] << 8 | t[c + 2] << 16 | t[c + 3] << 24) >>> 0;
  }
  function e(t, c) {
    return (t[c] << 24 | t[c + 1] << 16 | t[c + 2] << 8 | t[c + 3]) >>> 0;
  }
  return float;
}
var inquire_1, hasRequiredInquire;
function requireInquire() {
  if (hasRequiredInquire) return inquire_1;
  hasRequiredInquire = 1, inquire_1 = inquire;
  function inquire(moduleName) {
    try {
      var mod = eval("quire".replace(/^/, "re"))(moduleName);
      if (mod && (mod.length || Object.keys(mod).length)) return mod;
    } catch (o) {
    }
    return null;
  }
  return inquire_1;
}
var utf8 = {}, hasRequiredUtf8;
function requireUtf8() {
  return hasRequiredUtf8 || (hasRequiredUtf8 = 1, (function(o) {
    var E = o;
    E.length = function(A) {
      for (var g = 0, e = 0, t = 0; t < A.length; ++t) e = A.charCodeAt(t), e < 128 ? g += 1 : e < 2048 ? g += 2 : (e & 64512) === 55296 && (A.charCodeAt(t + 1) & 64512) === 56320 ? (++t, g += 4) : g += 3;
      return g;
    }, E.read = function(A, g, e) {
      var t = e - g;
      if (t < 1) return "";
      for (var c = null, n = [], h = 0, d; g < e; ) d = A[g++], d < 128 ? n[h++] = d : d > 191 && d < 224 ? n[h++] = (d & 31) << 6 | A[g++] & 63 : d > 239 && d < 365 ? (d = ((d & 7) << 18 | (A[g++] & 63) << 12 | (A[g++] & 63) << 6 | A[g++] & 63) - 65536, n[h++] = 55296 + (d >> 10), n[h++] = 56320 + (d & 1023)) : n[h++] = (d & 15) << 12 | (A[g++] & 63) << 6 | A[g++] & 63, h > 8191 && ((c || (c = [])).push(String.fromCharCode.apply(String, n)), h = 0);
      return c ? (h && c.push(String.fromCharCode.apply(String, n.slice(0, h))), c.join("")) : String.fromCharCode.apply(String, n.slice(0, h));
    }, E.write = function(A, g, e) {
      for (var t = e, c, n, h = 0; h < A.length; ++h) c = A.charCodeAt(h), c < 128 ? g[e++] = c : c < 2048 ? (g[e++] = c >> 6 | 192, g[e++] = c & 63 | 128) : (c & 64512) === 55296 && ((n = A.charCodeAt(h + 1)) & 64512) === 56320 ? (c = 65536 + ((c & 1023) << 10) + (n & 1023), ++h, g[e++] = c >> 18 | 240, g[e++] = c >> 12 & 63 | 128, g[e++] = c >> 6 & 63 | 128, g[e++] = c & 63 | 128) : (g[e++] = c >> 12 | 224, g[e++] = c >> 6 & 63 | 128, g[e++] = c & 63 | 128);
      return e - t;
    };
  })(utf8)), utf8;
}
var pool_1, hasRequiredPool;
function requirePool() {
  if (hasRequiredPool) return pool_1;
  hasRequiredPool = 1, pool_1 = o;
  function o(E, A, g) {
    var e = g || 8192, t = e >>> 1, c = null, n = e;
    return function(h) {
      if (h < 1 || h > t) return E(h);
      n + h > e && (c = E(e), n = 0);
      var d = A.call(c, n, n += h);
      return n & 7 && (n = (n | 7) + 1), d;
    };
  }
  return pool_1;
}
var longbits, hasRequiredLongbits;
function requireLongbits() {
  if (hasRequiredLongbits) return longbits;
  hasRequiredLongbits = 1, longbits = E;
  var o = requireMinimal$1();
  function E(t, c) {
    this.lo = t >>> 0, this.hi = c >>> 0;
  }
  var A = E.zero = new E(0, 0);
  A.toNumber = function() {
    return 0;
  }, A.zzEncode = A.zzDecode = function() {
    return this;
  }, A.length = function() {
    return 1;
  };
  var g = E.zeroHash = "\0\0\0\0\0\0\0\0";
  E.fromNumber = function(t) {
    if (t === 0) return A;
    var c = t < 0;
    c && (t = -t);
    var n = t >>> 0, h = (t - n) / 4294967296 >>> 0;
    return c && (h = ~h >>> 0, n = ~n >>> 0, ++n > 4294967295 && (n = 0, ++h > 4294967295 && (h = 0))), new E(n, h);
  }, E.from = function(t) {
    if (typeof t == "number") return E.fromNumber(t);
    if (o.isString(t)) if (o.Long) t = o.Long.fromString(t);
    else return E.fromNumber(parseInt(t, 10));
    return t.low || t.high ? new E(t.low >>> 0, t.high >>> 0) : A;
  }, E.prototype.toNumber = function(t) {
    if (!t && this.hi >>> 31) {
      var c = ~this.lo + 1 >>> 0, n = ~this.hi >>> 0;
      return c || (n = n + 1 >>> 0), -(c + n * 4294967296);
    }
    return this.lo + this.hi * 4294967296;
  }, E.prototype.toLong = function(t) {
    return o.Long ? new o.Long(this.lo | 0, this.hi | 0, !!t) : { low: this.lo | 0, high: this.hi | 0, unsigned: !!t };
  };
  var e = String.prototype.charCodeAt;
  return E.fromHash = function(t) {
    return t === g ? A : new E((e.call(t, 0) | e.call(t, 1) << 8 | e.call(t, 2) << 16 | e.call(t, 3) << 24) >>> 0, (e.call(t, 4) | e.call(t, 5) << 8 | e.call(t, 6) << 16 | e.call(t, 7) << 24) >>> 0);
  }, E.prototype.toHash = function() {
    return String.fromCharCode(this.lo & 255, this.lo >>> 8 & 255, this.lo >>> 16 & 255, this.lo >>> 24, this.hi & 255, this.hi >>> 8 & 255, this.hi >>> 16 & 255, this.hi >>> 24);
  }, E.prototype.zzEncode = function() {
    var t = this.hi >> 31;
    return this.hi = ((this.hi << 1 | this.lo >>> 31) ^ t) >>> 0, this.lo = (this.lo << 1 ^ t) >>> 0, this;
  }, E.prototype.zzDecode = function() {
    var t = -(this.lo & 1);
    return this.lo = ((this.lo >>> 1 | this.hi << 31) ^ t) >>> 0, this.hi = (this.hi >>> 1 ^ t) >>> 0, this;
  }, E.prototype.length = function() {
    var t = this.lo, c = (this.lo >>> 28 | this.hi << 4) >>> 0, n = this.hi >>> 24;
    return n === 0 ? c === 0 ? t < 16384 ? t < 128 ? 1 : 2 : t < 2097152 ? 3 : 4 : c < 16384 ? c < 128 ? 5 : 6 : c < 2097152 ? 7 : 8 : n < 128 ? 9 : 10;
  }, longbits;
}
var hasRequiredMinimal$1;
function requireMinimal$1() {
  return hasRequiredMinimal$1 || (hasRequiredMinimal$1 = 1, (function(o) {
    var E = o;
    E.asPromise = requireAspromise(), E.base64 = requireBase64(), E.EventEmitter = requireEventemitter(), E.float = requireFloat(), E.inquire = requireInquire(), E.utf8 = requireUtf8(), E.pool = requirePool(), E.LongBits = requireLongbits(), E.isNode = !!(typeof commonjsGlobal < "u" && commonjsGlobal && commonjsGlobal.process && commonjsGlobal.process.versions && commonjsGlobal.process.versions.node), E.global = E.isNode && commonjsGlobal || typeof window < "u" && window || typeof self < "u" && self || minimal$1, E.emptyArray = Object.freeze ? Object.freeze([]) : (
      /* istanbul ignore next */
      []
    ), E.emptyObject = Object.freeze ? Object.freeze({}) : (
      /* istanbul ignore next */
      {}
    ), E.isInteger = Number.isInteger || /* istanbul ignore next */
    function(e) {
      return typeof e == "number" && isFinite(e) && Math.floor(e) === e;
    }, E.isString = function(e) {
      return typeof e == "string" || e instanceof String;
    }, E.isObject = function(e) {
      return e && typeof e == "object";
    }, E.isset = /**
    * Checks if a property on a message is considered to be present.
    * @param {Object} obj Plain object or message instance
    * @param {string} prop Property name
    * @returns {boolean} `true` if considered to be present, otherwise `false`
    */
    E.isSet = function(e, t) {
      var c = e[t];
      return c != null && e.hasOwnProperty(t) ? typeof c != "object" || (Array.isArray(c) ? c.length : Object.keys(c).length) > 0 : !1;
    }, E.Buffer = (function() {
      try {
        var e = E.inquire("buffer").Buffer;
        return e.prototype.utf8Write ? e : (
          /* istanbul ignore next */
          null
        );
      } catch {
        return null;
      }
    })(), E._Buffer_from = null, E._Buffer_allocUnsafe = null, E.newBuffer = function(e) {
      return typeof e == "number" ? E.Buffer ? E._Buffer_allocUnsafe(e) : new E.Array(e) : E.Buffer ? E._Buffer_from(e) : typeof Uint8Array > "u" ? e : new Uint8Array(e);
    }, E.Array = typeof Uint8Array < "u" ? Uint8Array : Array, E.Long = /* istanbul ignore next */
    E.global.dcodeIO && /* istanbul ignore next */
    E.global.dcodeIO.Long || /* istanbul ignore next */
    E.global.Long || E.inquire("long"), E.key2Re = /^true|false|0|1$/, E.key32Re = /^-?(?:0|[1-9][0-9]*)$/, E.key64Re = /^(?:[\\x00-\\xff]{8}|-?(?:0|[1-9][0-9]*))$/, E.longToHash = function(e) {
      return e ? E.LongBits.from(e).toHash() : E.LongBits.zeroHash;
    }, E.longFromHash = function(e, t) {
      var c = E.LongBits.fromHash(e);
      return E.Long ? E.Long.fromBits(c.lo, c.hi, t) : c.toNumber(!!t);
    };
    function A(e, t, c) {
      for (var n = Object.keys(t), h = 0; h < n.length; ++h) (e[n[h]] === void 0 || !c) && (e[n[h]] = t[n[h]]);
      return e;
    }
    E.merge = A, E.lcFirst = function(e) {
      return e.charAt(0).toLowerCase() + e.substring(1);
    };
    function g(e) {
      function t(c, n) {
        if (!(this instanceof t)) return new t(c, n);
        Object.defineProperty(this, "message", { get: function() {
          return c;
        } }), Error.captureStackTrace ? Error.captureStackTrace(this, t) : Object.defineProperty(this, "stack", { value: new Error().stack || "" }), n && A(this, n);
      }
      return t.prototype = Object.create(Error.prototype, { constructor: { value: t, writable: !0, enumerable: !1, configurable: !0 }, name: {
        get: function() {
          return e;
        },
        set: void 0,
        enumerable: !1,
        // configurable: false would accurately preserve the behavior of
        // the original, but I'm guessing that was not intentional.
        // For an actual error subclass, this property would
        // be configurable.
        configurable: !0
      }, toString: { value: function() {
        return this.name + ": " + this.message;
      }, writable: !0, enumerable: !1, configurable: !0 } }), t;
    }
    E.newError = g, E.ProtocolError = g("ProtocolError"), E.oneOfGetter = function(e) {
      for (var t = {}, c = 0; c < e.length; ++c) t[e[c]] = 1;
      return function() {
        for (var n = Object.keys(this), h = n.length - 1; h > -1; --h) if (t[n[h]] === 1 && this[n[h]] !== void 0 && this[n[h]] !== null) return n[h];
      };
    }, E.oneOfSetter = function(e) {
      return function(t) {
        for (var c = 0; c < e.length; ++c) e[c] !== t && delete this[e[c]];
      };
    }, E.toJSONOptions = { longs: String, enums: String, bytes: String, json: !0 }, E._configure = function() {
      var e = E.Buffer;
      if (!e) {
        E._Buffer_from = E._Buffer_allocUnsafe = null;
        return;
      }
      E._Buffer_from = e.from !== Uint8Array.from && e.from || /* istanbul ignore next */
      function(t, c) {
        return new e(t, c);
      }, E._Buffer_allocUnsafe = e.allocUnsafe || /* istanbul ignore next */
      function(t) {
        return new e(t);
      };
    };
  })(minimal$1)), minimal$1;
}
var writer, hasRequiredWriter;
function requireWriter() {
  if (hasRequiredWriter) return writer;
  hasRequiredWriter = 1, writer = h;
  var o = requireMinimal$1(), E, A = o.LongBits, g = o.base64, e = o.utf8;
  function t(gA, CA, IA) {
    this.fn = gA, this.len = CA, this.next = void 0, this.val = IA;
  }
  function c() {
  }
  function n(gA) {
    this.head = gA.head, this.tail = gA.tail, this.len = gA.len, this.next = gA.states;
  }
  function h() {
    this.len = 0, this.head = new t(c, 0, 0), this.tail = this.head, this.states = null;
  }
  var d = function() {
    return o.Buffer ? function() {
      return (h.create = function() {
        return new E();
      })();
    } : function() {
      return new h();
    };
  };
  h.create = d(), h.alloc = function(gA) {
    return new o.Array(gA);
  }, o.Array !== Array && (h.alloc = o.pool(h.alloc, o.Array.prototype.subarray)), h.prototype._push = function(gA, CA, IA) {
    return this.tail = this.tail.next = new t(gA, CA, IA), this.len += CA, this;
  };
  function k(gA, CA, IA) {
    CA[IA] = gA & 255;
  }
  function p(gA, CA, IA) {
    for (; gA > 127; ) CA[IA++] = gA & 127 | 128, gA >>>= 7;
    CA[IA] = gA;
  }
  function M(gA, CA) {
    this.len = gA, this.next = void 0, this.val = CA;
  }
  M.prototype = Object.create(t.prototype), M.prototype.fn = p, h.prototype.uint32 = function(gA) {
    return this.len += (this.tail = this.tail.next = new M((gA = gA >>> 0) < 128 ? 1 : gA < 16384 ? 2 : gA < 2097152 ? 3 : gA < 268435456 ? 4 : 5, gA)).len, this;
  }, h.prototype.int32 = function(gA) {
    return gA < 0 ? this._push(S, 10, A.fromNumber(gA)) : this.uint32(gA);
  }, h.prototype.sint32 = function(gA) {
    return this.uint32((gA << 1 ^ gA >> 31) >>> 0);
  };
  function S(gA, CA, IA) {
    for (; gA.hi; ) CA[IA++] = gA.lo & 127 | 128, gA.lo = (gA.lo >>> 7 | gA.hi << 25) >>> 0, gA.hi >>>= 7;
    for (; gA.lo > 127; ) CA[IA++] = gA.lo & 127 | 128, gA.lo = gA.lo >>> 7;
    CA[IA++] = gA.lo;
  }
  h.prototype.uint64 = function(gA) {
    var CA = A.from(gA);
    return this._push(S, CA.length(), CA);
  }, h.prototype.int64 = h.prototype.uint64, h.prototype.sint64 = function(gA) {
    var CA = A.from(gA).zzEncode();
    return this._push(S, CA.length(), CA);
  }, h.prototype.bool = function(gA) {
    return this._push(k, 1, gA ? 1 : 0);
  };
  function AA(gA, CA, IA) {
    CA[IA] = gA & 255, CA[IA + 1] = gA >>> 8 & 255, CA[IA + 2] = gA >>> 16 & 255, CA[IA + 3] = gA >>> 24;
  }
  h.prototype.fixed32 = function(gA) {
    return this._push(AA, 4, gA >>> 0);
  }, h.prototype.sfixed32 = h.prototype.fixed32, h.prototype.fixed64 = function(gA) {
    var CA = A.from(gA);
    return this._push(AA, 4, CA.lo)._push(AA, 4, CA.hi);
  }, h.prototype.sfixed64 = h.prototype.fixed64, h.prototype.float = function(gA) {
    return this._push(o.float.writeFloatLE, 4, gA);
  }, h.prototype.double = function(gA) {
    return this._push(o.float.writeDoubleLE, 8, gA);
  };
  var H = o.Array.prototype.set ? function(gA, CA, IA) {
    CA.set(gA, IA);
  } : function(gA, CA, IA) {
    for (var BA = 0; BA < gA.length; ++BA) CA[IA + BA] = gA[BA];
  };
  return h.prototype.bytes = function(gA) {
    var CA = gA.length >>> 0;
    if (!CA) return this._push(k, 1, 0);
    if (o.isString(gA)) {
      var IA = h.alloc(CA = g.length(gA));
      g.decode(gA, IA, 0), gA = IA;
    }
    return this.uint32(CA)._push(H, CA, gA);
  }, h.prototype.string = function(gA) {
    var CA = e.length(gA);
    return CA ? this.uint32(CA)._push(e.write, CA, gA) : this._push(k, 1, 0);
  }, h.prototype.fork = function() {
    return this.states = new n(this), this.head = this.tail = new t(c, 0, 0), this.len = 0, this;
  }, h.prototype.reset = function() {
    return this.states ? (this.head = this.states.head, this.tail = this.states.tail, this.len = this.states.len, this.states = this.states.next) : (this.head = this.tail = new t(c, 0, 0), this.len = 0), this;
  }, h.prototype.ldelim = function() {
    var gA = this.head, CA = this.tail, IA = this.len;
    return this.reset().uint32(IA), IA && (this.tail.next = gA.next, this.tail = CA, this.len += IA), this;
  }, h.prototype.finish = function() {
    for (var gA = this.head.next, CA = this.constructor.alloc(this.len), IA = 0; gA; ) gA.fn(gA.val, CA, IA), IA += gA.len, gA = gA.next;
    return CA;
  }, h._configure = function(gA) {
    E = gA, h.create = d(), E._configure();
  }, writer;
}
var writer_buffer, hasRequiredWriter_buffer;
function requireWriter_buffer() {
  if (hasRequiredWriter_buffer) return writer_buffer;
  hasRequiredWriter_buffer = 1, writer_buffer = A;
  var o = requireWriter();
  (A.prototype = Object.create(o.prototype)).constructor = A;
  var E = requireMinimal$1();
  function A() {
    o.call(this);
  }
  A._configure = function() {
    A.alloc = E._Buffer_allocUnsafe, A.writeBytesBuffer = E.Buffer && E.Buffer.prototype instanceof Uint8Array && E.Buffer.prototype.set.name === "set" ? function(e, t, c) {
      t.set(e, c);
    } : function(e, t, c) {
      if (e.copy) e.copy(t, c, 0, e.length);
      else for (var n = 0; n < e.length; ) t[c++] = e[n++];
    };
  }, A.prototype.bytes = function(e) {
    E.isString(e) && (e = E._Buffer_from(e, "base64"));
    var t = e.length >>> 0;
    return this.uint32(t), t && this._push(A.writeBytesBuffer, t, e), this;
  };
  function g(e, t, c) {
    e.length < 40 ? E.utf8.write(e, t, c) : t.utf8Write ? t.utf8Write(e, c) : t.write(e, c);
  }
  return A.prototype.string = function(e) {
    var t = E.Buffer.byteLength(e);
    return this.uint32(t), t && this._push(g, t, e), this;
  }, A._configure(), writer_buffer;
}
var reader, hasRequiredReader;
function requireReader() {
  if (hasRequiredReader) return reader;
  hasRequiredReader = 1, reader = t;
  var o = requireMinimal$1(), E, A = o.LongBits, g = o.utf8;
  function e(p, M) {
    return RangeError("index out of range: " + p.pos + " + " + (M || 1) + " > " + p.len);
  }
  function t(p) {
    this.buf = p, this.pos = 0, this.len = p.length;
  }
  var c = typeof Uint8Array < "u" ? function(p) {
    if (p instanceof Uint8Array || Array.isArray(p)) return new t(p);
    throw Error("illegal buffer");
  } : function(p) {
    if (Array.isArray(p)) return new t(p);
    throw Error("illegal buffer");
  }, n = function() {
    return o.Buffer ? function(p) {
      return (t.create = function(M) {
        return o.Buffer.isBuffer(M) ? new E(M) : c(M);
      })(p);
    } : c;
  };
  t.create = n(), t.prototype._slice = o.Array.prototype.subarray || /* istanbul ignore next */
  o.Array.prototype.slice, t.prototype.uint32 = /* @__PURE__ */ (function() {
    var p = 4294967295;
    return function() {
      if (p = (this.buf[this.pos] & 127) >>> 0, this.buf[this.pos++] < 128 || (p = (p | (this.buf[this.pos] & 127) << 7) >>> 0, this.buf[this.pos++] < 128) || (p = (p | (this.buf[this.pos] & 127) << 14) >>> 0, this.buf[this.pos++] < 128) || (p = (p | (this.buf[this.pos] & 127) << 21) >>> 0, this.buf[this.pos++] < 128) || (p = (p | (this.buf[this.pos] & 15) << 28) >>> 0, this.buf[this.pos++] < 128)) return p;
      if ((this.pos += 5) > this.len) throw this.pos = this.len, e(this, 10);
      return p;
    };
  })(), t.prototype.int32 = function() {
    return this.uint32() | 0;
  }, t.prototype.sint32 = function() {
    var p = this.uint32();
    return p >>> 1 ^ -(p & 1) | 0;
  };
  function h() {
    var p = new A(0, 0), M = 0;
    if (this.len - this.pos > 4) {
      for (; M < 4; ++M) if (p.lo = (p.lo | (this.buf[this.pos] & 127) << M * 7) >>> 0, this.buf[this.pos++] < 128) return p;
      if (p.lo = (p.lo | (this.buf[this.pos] & 127) << 28) >>> 0, p.hi = (p.hi | (this.buf[this.pos] & 127) >> 4) >>> 0, this.buf[this.pos++] < 128) return p;
      M = 0;
    } else {
      for (; M < 3; ++M) {
        if (this.pos >= this.len) throw e(this);
        if (p.lo = (p.lo | (this.buf[this.pos] & 127) << M * 7) >>> 0, this.buf[this.pos++] < 128) return p;
      }
      return p.lo = (p.lo | (this.buf[this.pos++] & 127) << M * 7) >>> 0, p;
    }
    if (this.len - this.pos > 4) {
      for (; M < 5; ++M) if (p.hi = (p.hi | (this.buf[this.pos] & 127) << M * 7 + 3) >>> 0, this.buf[this.pos++] < 128) return p;
    } else for (; M < 5; ++M) {
      if (this.pos >= this.len) throw e(this);
      if (p.hi = (p.hi | (this.buf[this.pos] & 127) << M * 7 + 3) >>> 0, this.buf[this.pos++] < 128) return p;
    }
    throw Error("invalid varint encoding");
  }
  t.prototype.bool = function() {
    return this.uint32() !== 0;
  };
  function d(p, M) {
    return (p[M - 4] | p[M - 3] << 8 | p[M - 2] << 16 | p[M - 1] << 24) >>> 0;
  }
  t.prototype.fixed32 = function() {
    if (this.pos + 4 > this.len) throw e(this, 4);
    return d(this.buf, this.pos += 4);
  }, t.prototype.sfixed32 = function() {
    if (this.pos + 4 > this.len) throw e(this, 4);
    return d(this.buf, this.pos += 4) | 0;
  };
  function k() {
    if (this.pos + 8 > this.len) throw e(this, 8);
    return new A(d(this.buf, this.pos += 4), d(this.buf, this.pos += 4));
  }
  return t.prototype.float = function() {
    if (this.pos + 4 > this.len) throw e(this, 4);
    var p = o.float.readFloatLE(this.buf, this.pos);
    return this.pos += 4, p;
  }, t.prototype.double = function() {
    if (this.pos + 8 > this.len) throw e(this, 4);
    var p = o.float.readDoubleLE(this.buf, this.pos);
    return this.pos += 8, p;
  }, t.prototype.bytes = function() {
    var p = this.uint32(), M = this.pos, S = this.pos + p;
    if (S > this.len) throw e(this, p);
    if (this.pos += p, Array.isArray(this.buf)) return this.buf.slice(M, S);
    if (M === S) {
      var AA = o.Buffer;
      return AA ? AA.alloc(0) : new this.buf.constructor(0);
    }
    return this._slice.call(this.buf, M, S);
  }, t.prototype.string = function() {
    var p = this.bytes();
    return g.read(p, 0, p.length);
  }, t.prototype.skip = function(p) {
    if (typeof p == "number") {
      if (this.pos + p > this.len) throw e(this, p);
      this.pos += p;
    } else do
      if (this.pos >= this.len) throw e(this);
    while (this.buf[this.pos++] & 128);
    return this;
  }, t.prototype.skipType = function(p) {
    switch (p) {
      case 0:
        this.skip();
        break;
      case 1:
        this.skip(8);
        break;
      case 2:
        this.skip(this.uint32());
        break;
      case 3:
        for (; (p = this.uint32() & 7) !== 4; ) this.skipType(p);
        break;
      case 5:
        this.skip(4);
        break;
      /* istanbul ignore next */
      default:
        throw Error("invalid wire type " + p + " at offset " + this.pos);
    }
    return this;
  }, t._configure = function(p) {
    E = p, t.create = n(), E._configure();
    var M = o.Long ? "toLong" : (
      /* istanbul ignore next */
      "toNumber"
    );
    o.merge(t.prototype, { int64: function() {
      return h.call(this)[M](!1);
    }, uint64: function() {
      return h.call(this)[M](!0);
    }, sint64: function() {
      return h.call(this).zzDecode()[M](!1);
    }, fixed64: function() {
      return k.call(this)[M](!0);
    }, sfixed64: function() {
      return k.call(this)[M](!1);
    } });
  }, reader;
}
var reader_buffer, hasRequiredReader_buffer;
function requireReader_buffer() {
  if (hasRequiredReader_buffer) return reader_buffer;
  hasRequiredReader_buffer = 1, reader_buffer = A;
  var o = requireReader();
  (A.prototype = Object.create(o.prototype)).constructor = A;
  var E = requireMinimal$1();
  function A(g) {
    o.call(this, g);
  }
  return A._configure = function() {
    E.Buffer && (A.prototype._slice = E.Buffer.prototype.slice);
  }, A.prototype.string = function() {
    var g = this.uint32();
    return this.buf.utf8Slice ? this.buf.utf8Slice(this.pos, this.pos = Math.min(this.pos + g, this.len)) : this.buf.toString("utf-8", this.pos, this.pos = Math.min(this.pos + g, this.len));
  }, A._configure(), reader_buffer;
}
var rpc = {}, service$1, hasRequiredService$1;
function requireService$1() {
  if (hasRequiredService$1) return service$1;
  hasRequiredService$1 = 1, service$1 = E;
  var o = requireMinimal$1();
  (E.prototype = Object.create(o.EventEmitter.prototype)).constructor = E;
  function E(A, g, e) {
    if (typeof A != "function") throw TypeError("rpcImpl must be a function");
    o.EventEmitter.call(this), this.rpcImpl = A, this.requestDelimited = !!g, this.responseDelimited = !!e;
  }
  return E.prototype.rpcCall = function A(g, e, t, c, n) {
    if (!c) throw TypeError("request must be specified");
    var h = this;
    if (!n) return o.asPromise(A, h, g, e, t, c);
    if (!h.rpcImpl) {
      setTimeout(function() {
        n(Error("already ended"));
      }, 0);
      return;
    }
    try {
      return h.rpcImpl(g, e[h.requestDelimited ? "encodeDelimited" : "encode"](c).finish(), function(d, k) {
        if (d) return h.emit("error", d, g), n(d);
        if (k === null) {
          h.end(
            /* endedByRPC */
            !0
          );
          return;
        }
        if (!(k instanceof t)) try {
          k = t[h.responseDelimited ? "decodeDelimited" : "decode"](k);
        } catch (p) {
          return h.emit("error", p, g), n(p);
        }
        return h.emit("data", k, g), n(null, k);
      });
    } catch (d) {
      h.emit("error", d, g), setTimeout(function() {
        n(d);
      }, 0);
      return;
    }
  }, E.prototype.end = function(A) {
    return this.rpcImpl && (A || this.rpcImpl(null, null, null), this.rpcImpl = null, this.emit("end").off()), this;
  }, service$1;
}
var hasRequiredRpc;
function requireRpc() {
  return hasRequiredRpc || (hasRequiredRpc = 1, (function(o) {
    var E = o;
    E.Service = requireService$1();
  })(rpc)), rpc;
}
var roots, hasRequiredRoots;
function requireRoots() {
  return hasRequiredRoots || (hasRequiredRoots = 1, roots = {}), roots;
}
var hasRequiredIndexMinimal;
function requireIndexMinimal() {
  return hasRequiredIndexMinimal || (hasRequiredIndexMinimal = 1, (function(o) {
    var E = o;
    E.build = "minimal", E.Writer = requireWriter(), E.BufferWriter = requireWriter_buffer(), E.Reader = requireReader(), E.BufferReader = requireReader_buffer(), E.util = requireMinimal$1(), E.rpc = requireRpc(), E.roots = requireRoots(), E.configure = A;
    function A() {
      E.util._configure(), E.Writer._configure(E.BufferWriter), E.Reader._configure(E.BufferReader);
    }
    A();
  })(indexMinimal)), indexMinimal;
}
var minimal, hasRequiredMinimal;
function requireMinimal() {
  return hasRequiredMinimal || (hasRequiredMinimal = 1, minimal = requireIndexMinimal()), minimal;
}
var minimalExports = requireMinimal();
const $Reader = minimalExports.Reader, $Writer = minimalExports.Writer, $util = minimalExports.util, $root = minimalExports.roots.default || (minimalExports.roots.default = {});
$root.Alert = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.body = "", o.prototype.format = 0, o.prototype.icon = "", o.prototype.widthConfig = null, o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, A) {
    return A || (A = $Writer.create()), E.body != null && Object.hasOwnProperty.call(E, "body") && A.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(E.body), E.format != null && Object.hasOwnProperty.call(E, "format") && A.uint32(
      /* id 2, wireType 0 =*/
      16
    ).int32(E.format), E.icon != null && Object.hasOwnProperty.call(E, "icon") && A.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(E.icon), E.widthConfig != null && Object.hasOwnProperty.call(E, "widthConfig") && $root.streamlit.WidthConfig.encode(E.widthConfig, A.uint32(
      /* id 4, wireType 2 =*/
      34
    ).fork()).ldelim(), A;
  }, o.decode = function(E, A, g) {
    E instanceof $Reader || (E = $Reader.create(E));
    let e = A === void 0 ? E.len : E.pos + A, t = new $root.Alert();
    for (; E.pos < e; ) {
      let c = E.uint32();
      if (c === g) break;
      switch (c >>> 3) {
        case 1: {
          t.body = E.string();
          break;
        }
        case 2: {
          t.format = E.int32();
          break;
        }
        case 3: {
          t.icon = E.string();
          break;
        }
        case 4: {
          t.widthConfig = $root.streamlit.WidthConfig.decode(E, E.uint32());
          break;
        }
        default:
          E.skipType(c & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(E) {
    if (E instanceof $root.Alert) return E;
    let A = new $root.Alert();
    switch (E.body != null && (A.body = String(E.body)), E.format) {
      default:
        if (typeof E.format == "number") {
          A.format = E.format;
          break;
        }
        break;
      case "UNUSED":
      case 0:
        A.format = 0;
        break;
      case "ERROR":
      case 1:
        A.format = 1;
        break;
      case "WARNING":
      case 2:
        A.format = 2;
        break;
      case "INFO":
      case 3:
        A.format = 3;
        break;
      case "SUCCESS":
      case 4:
        A.format = 4;
        break;
    }
    if (E.icon != null && (A.icon = String(E.icon)), E.widthConfig != null) {
      if (typeof E.widthConfig != "object") throw TypeError(".Alert.widthConfig: object expected");
      A.widthConfig = $root.streamlit.WidthConfig.fromObject(E.widthConfig);
    }
    return A;
  }, o.toObject = function(E, A) {
    A || (A = {});
    let g = {};
    return A.defaults && (g.body = "", g.format = A.enums === String ? "UNUSED" : 0, g.icon = "", g.widthConfig = null), E.body != null && E.hasOwnProperty("body") && (g.body = E.body), E.format != null && E.hasOwnProperty("format") && (g.format = A.enums === String ? $root.Alert.Format[E.format] === void 0 ? E.format : $root.Alert.Format[E.format] : E.format), E.icon != null && E.hasOwnProperty("icon") && (g.icon = E.icon), E.widthConfig != null && E.hasOwnProperty("widthConfig") && (g.widthConfig = $root.streamlit.WidthConfig.toObject(E.widthConfig, A)), g;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/Alert";
  }, o.Format = (function() {
    const E = {}, A = Object.create(E);
    return A[E[0] = "UNUSED"] = 0, A[E[1] = "ERROR"] = 1, A[E[2] = "WARNING"] = 2, A[E[3] = "INFO"] = 3, A[E[4] = "SUCCESS"] = 4, A;
  })(), o;
})();
$root.streamlit = (() => {
  const o = {};
  return o.WidthConfig = (function() {
    function E(g) {
      if (g) for (let e = Object.keys(g), t = 0; t < e.length; ++t) g[e[t]] != null && (this[e[t]] = g[e[t]]);
    }
    E.prototype.useStretch = null, E.prototype.useContent = null, E.prototype.pixelWidth = null, E.prototype.remWidth = null;
    let A;
    return Object.defineProperty(E.prototype, "widthSpec", { get: $util.oneOfGetter(A = ["useStretch", "useContent", "pixelWidth", "remWidth"]), set: $util.oneOfSetter(A) }), E.create = function(g) {
      return new E(g);
    }, E.encode = function(g, e) {
      return e || (e = $Writer.create()), g.useStretch != null && Object.hasOwnProperty.call(g, "useStretch") && e.uint32(
        /* id 1, wireType 0 =*/
        8
      ).bool(g.useStretch), g.useContent != null && Object.hasOwnProperty.call(g, "useContent") && e.uint32(
        /* id 2, wireType 0 =*/
        16
      ).bool(g.useContent), g.pixelWidth != null && Object.hasOwnProperty.call(g, "pixelWidth") && e.uint32(
        /* id 3, wireType 0 =*/
        24
      ).uint32(g.pixelWidth), g.remWidth != null && Object.hasOwnProperty.call(g, "remWidth") && e.uint32(
        /* id 4, wireType 5 =*/
        37
      ).float(g.remWidth), e;
    }, E.decode = function(g, e, t) {
      g instanceof $Reader || (g = $Reader.create(g));
      let c = e === void 0 ? g.len : g.pos + e, n = new $root.streamlit.WidthConfig();
      for (; g.pos < c; ) {
        let h = g.uint32();
        if (h === t) break;
        switch (h >>> 3) {
          case 1: {
            n.useStretch = g.bool();
            break;
          }
          case 2: {
            n.useContent = g.bool();
            break;
          }
          case 3: {
            n.pixelWidth = g.uint32();
            break;
          }
          case 4: {
            n.remWidth = g.float();
            break;
          }
          default:
            g.skipType(h & 7);
            break;
        }
      }
      return n;
    }, E.fromObject = function(g) {
      if (g instanceof $root.streamlit.WidthConfig) return g;
      let e = new $root.streamlit.WidthConfig();
      return g.useStretch != null && (e.useStretch = !!g.useStretch), g.useContent != null && (e.useContent = !!g.useContent), g.pixelWidth != null && (e.pixelWidth = g.pixelWidth >>> 0), g.remWidth != null && (e.remWidth = Number(g.remWidth)), e;
    }, E.toObject = function(g, e) {
      e || (e = {});
      let t = {};
      return g.useStretch != null && g.hasOwnProperty("useStretch") && (t.useStretch = g.useStretch, e.oneofs && (t.widthSpec = "useStretch")), g.useContent != null && g.hasOwnProperty("useContent") && (t.useContent = g.useContent, e.oneofs && (t.widthSpec = "useContent")), g.pixelWidth != null && g.hasOwnProperty("pixelWidth") && (t.pixelWidth = g.pixelWidth, e.oneofs && (t.widthSpec = "pixelWidth")), g.remWidth != null && g.hasOwnProperty("remWidth") && (t.remWidth = e.json && !isFinite(g.remWidth) ? String(g.remWidth) : g.remWidth, e.oneofs && (t.widthSpec = "remWidth")), t;
    }, E.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, E.getTypeUrl = function(g) {
      return g === void 0 && (g = "type.googleapis.com"), g + "/streamlit.WidthConfig";
    }, E;
  })(), o.HeightConfig = (function() {
    function E(g) {
      if (g) for (let e = Object.keys(g), t = 0; t < e.length; ++t) g[e[t]] != null && (this[e[t]] = g[e[t]]);
    }
    E.prototype.useStretch = null, E.prototype.useContent = null, E.prototype.pixelHeight = null, E.prototype.remHeight = null;
    let A;
    return Object.defineProperty(E.prototype, "heightSpec", { get: $util.oneOfGetter(A = ["useStretch", "useContent", "pixelHeight", "remHeight"]), set: $util.oneOfSetter(A) }), E.create = function(g) {
      return new E(g);
    }, E.encode = function(g, e) {
      return e || (e = $Writer.create()), g.useStretch != null && Object.hasOwnProperty.call(g, "useStretch") && e.uint32(
        /* id 1, wireType 0 =*/
        8
      ).bool(g.useStretch), g.useContent != null && Object.hasOwnProperty.call(g, "useContent") && e.uint32(
        /* id 2, wireType 0 =*/
        16
      ).bool(g.useContent), g.pixelHeight != null && Object.hasOwnProperty.call(g, "pixelHeight") && e.uint32(
        /* id 3, wireType 0 =*/
        24
      ).uint32(g.pixelHeight), g.remHeight != null && Object.hasOwnProperty.call(g, "remHeight") && e.uint32(
        /* id 4, wireType 5 =*/
        37
      ).float(g.remHeight), e;
    }, E.decode = function(g, e, t) {
      g instanceof $Reader || (g = $Reader.create(g));
      let c = e === void 0 ? g.len : g.pos + e, n = new $root.streamlit.HeightConfig();
      for (; g.pos < c; ) {
        let h = g.uint32();
        if (h === t) break;
        switch (h >>> 3) {
          case 1: {
            n.useStretch = g.bool();
            break;
          }
          case 2: {
            n.useContent = g.bool();
            break;
          }
          case 3: {
            n.pixelHeight = g.uint32();
            break;
          }
          case 4: {
            n.remHeight = g.float();
            break;
          }
          default:
            g.skipType(h & 7);
            break;
        }
      }
      return n;
    }, E.fromObject = function(g) {
      if (g instanceof $root.streamlit.HeightConfig) return g;
      let e = new $root.streamlit.HeightConfig();
      return g.useStretch != null && (e.useStretch = !!g.useStretch), g.useContent != null && (e.useContent = !!g.useContent), g.pixelHeight != null && (e.pixelHeight = g.pixelHeight >>> 0), g.remHeight != null && (e.remHeight = Number(g.remHeight)), e;
    }, E.toObject = function(g, e) {
      e || (e = {});
      let t = {};
      return g.useStretch != null && g.hasOwnProperty("useStretch") && (t.useStretch = g.useStretch, e.oneofs && (t.heightSpec = "useStretch")), g.useContent != null && g.hasOwnProperty("useContent") && (t.useContent = g.useContent, e.oneofs && (t.heightSpec = "useContent")), g.pixelHeight != null && g.hasOwnProperty("pixelHeight") && (t.pixelHeight = g.pixelHeight, e.oneofs && (t.heightSpec = "pixelHeight")), g.remHeight != null && g.hasOwnProperty("remHeight") && (t.remHeight = e.json && !isFinite(g.remHeight) ? String(g.remHeight) : g.remHeight, e.oneofs && (t.heightSpec = "remHeight")), t;
    }, E.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, E.getTypeUrl = function(g) {
      return g === void 0 && (g = "type.googleapis.com"), g + "/streamlit.HeightConfig";
    }, E;
  })(), o.GapSize = (function() {
    const E = {}, A = Object.create(E);
    return A[E[0] = "GAP_UNDEFINED"] = 0, A[E[1] = "SMALL"] = 1, A[E[2] = "MEDIUM"] = 2, A[E[3] = "LARGE"] = 3, A[E[4] = "NONE"] = 4, A;
  })(), o.GapConfig = (function() {
    function E(g) {
      if (g) for (let e = Object.keys(g), t = 0; t < e.length; ++t) g[e[t]] != null && (this[e[t]] = g[e[t]]);
    }
    E.prototype.gapSize = null;
    let A;
    return Object.defineProperty(E.prototype, "gapSpec", { get: $util.oneOfGetter(A = ["gapSize"]), set: $util.oneOfSetter(A) }), E.create = function(g) {
      return new E(g);
    }, E.encode = function(g, e) {
      return e || (e = $Writer.create()), g.gapSize != null && Object.hasOwnProperty.call(g, "gapSize") && e.uint32(
        /* id 1, wireType 0 =*/
        8
      ).int32(g.gapSize), e;
    }, E.decode = function(g, e, t) {
      g instanceof $Reader || (g = $Reader.create(g));
      let c = e === void 0 ? g.len : g.pos + e, n = new $root.streamlit.GapConfig();
      for (; g.pos < c; ) {
        let h = g.uint32();
        if (h === t) break;
        h >>> 3 === 1 ? n.gapSize = g.int32() : g.skipType(h & 7);
      }
      return n;
    }, E.fromObject = function(g) {
      if (g instanceof $root.streamlit.GapConfig) return g;
      let e = new $root.streamlit.GapConfig();
      switch (g.gapSize) {
        default:
          if (typeof g.gapSize == "number") {
            e.gapSize = g.gapSize;
            break;
          }
          break;
        case "GAP_UNDEFINED":
        case 0:
          e.gapSize = 0;
          break;
        case "SMALL":
        case 1:
          e.gapSize = 1;
          break;
        case "MEDIUM":
        case 2:
          e.gapSize = 2;
          break;
        case "LARGE":
        case 3:
          e.gapSize = 3;
          break;
        case "NONE":
        case 4:
          e.gapSize = 4;
          break;
      }
      return e;
    }, E.toObject = function(g, e) {
      e || (e = {});
      let t = {};
      return g.gapSize != null && g.hasOwnProperty("gapSize") && (t.gapSize = e.enums === String ? $root.streamlit.GapSize[g.gapSize] === void 0 ? g.gapSize : $root.streamlit.GapSize[g.gapSize] : g.gapSize, e.oneofs && (t.gapSpec = "gapSize")), t;
    }, E.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, E.getTypeUrl = function(g) {
      return g === void 0 && (g = "type.googleapis.com"), g + "/streamlit.GapConfig";
    }, E;
  })(), o.TextAlignmentConfig = (function() {
    function E(A) {
      if (A) for (let g = Object.keys(A), e = 0; e < g.length; ++e) A[g[e]] != null && (this[g[e]] = A[g[e]]);
    }
    return E.prototype.alignment = 0, E.create = function(A) {
      return new E(A);
    }, E.encode = function(A, g) {
      return g || (g = $Writer.create()), A.alignment != null && Object.hasOwnProperty.call(A, "alignment") && g.uint32(
        /* id 1, wireType 0 =*/
        8
      ).int32(A.alignment), g;
    }, E.decode = function(A, g, e) {
      A instanceof $Reader || (A = $Reader.create(A));
      let t = g === void 0 ? A.len : A.pos + g, c = new $root.streamlit.TextAlignmentConfig();
      for (; A.pos < t; ) {
        let n = A.uint32();
        if (n === e) break;
        n >>> 3 === 1 ? c.alignment = A.int32() : A.skipType(n & 7);
      }
      return c;
    }, E.fromObject = function(A) {
      if (A instanceof $root.streamlit.TextAlignmentConfig) return A;
      let g = new $root.streamlit.TextAlignmentConfig();
      switch (A.alignment) {
        default:
          if (typeof A.alignment == "number") {
            g.alignment = A.alignment;
            break;
          }
          break;
        case "UNSPECIFIED":
        case 0:
          g.alignment = 0;
          break;
        case "LEFT":
        case 1:
          g.alignment = 1;
          break;
        case "CENTER":
        case 2:
          g.alignment = 2;
          break;
        case "RIGHT":
        case 3:
          g.alignment = 3;
          break;
        case "JUSTIFY":
        case 4:
          g.alignment = 4;
          break;
      }
      return g;
    }, E.toObject = function(A, g) {
      g || (g = {});
      let e = {};
      return g.defaults && (e.alignment = g.enums === String ? "UNSPECIFIED" : 0), A.alignment != null && A.hasOwnProperty("alignment") && (e.alignment = g.enums === String ? $root.streamlit.TextAlignmentConfig.Alignment[A.alignment] === void 0 ? A.alignment : $root.streamlit.TextAlignmentConfig.Alignment[A.alignment] : A.alignment), e;
    }, E.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, E.getTypeUrl = function(A) {
      return A === void 0 && (A = "type.googleapis.com"), A + "/streamlit.TextAlignmentConfig";
    }, E.Alignment = (function() {
      const A = {}, g = Object.create(A);
      return g[A[0] = "UNSPECIFIED"] = 0, g[A[1] = "LEFT"] = 1, g[A[2] = "CENTER"] = 2, g[A[3] = "RIGHT"] = 3, g[A[4] = "JUSTIFY"] = 4, g;
    })(), E;
  })(), o;
})();
$root.AppPage = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.pageScriptHash = "", o.prototype.pageName = "", o.prototype.icon = "", o.prototype.isDefault = !1, o.prototype.sectionHeader = "", o.prototype.urlPathname = "", o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, A) {
    return A || (A = $Writer.create()), E.pageScriptHash != null && Object.hasOwnProperty.call(E, "pageScriptHash") && A.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(E.pageScriptHash), E.pageName != null && Object.hasOwnProperty.call(E, "pageName") && A.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(E.pageName), E.icon != null && Object.hasOwnProperty.call(E, "icon") && A.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(E.icon), E.isDefault != null && Object.hasOwnProperty.call(E, "isDefault") && A.uint32(
      /* id 4, wireType 0 =*/
      32
    ).bool(E.isDefault), E.sectionHeader != null && Object.hasOwnProperty.call(E, "sectionHeader") && A.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(E.sectionHeader), E.urlPathname != null && Object.hasOwnProperty.call(E, "urlPathname") && A.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(E.urlPathname), A;
  }, o.decode = function(E, A, g) {
    E instanceof $Reader || (E = $Reader.create(E));
    let e = A === void 0 ? E.len : E.pos + A, t = new $root.AppPage();
    for (; E.pos < e; ) {
      let c = E.uint32();
      if (c === g) break;
      switch (c >>> 3) {
        case 1: {
          t.pageScriptHash = E.string();
          break;
        }
        case 2: {
          t.pageName = E.string();
          break;
        }
        case 3: {
          t.icon = E.string();
          break;
        }
        case 4: {
          t.isDefault = E.bool();
          break;
        }
        case 5: {
          t.sectionHeader = E.string();
          break;
        }
        case 6: {
          t.urlPathname = E.string();
          break;
        }
        default:
          E.skipType(c & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(E) {
    if (E instanceof $root.AppPage) return E;
    let A = new $root.AppPage();
    return E.pageScriptHash != null && (A.pageScriptHash = String(E.pageScriptHash)), E.pageName != null && (A.pageName = String(E.pageName)), E.icon != null && (A.icon = String(E.icon)), E.isDefault != null && (A.isDefault = !!E.isDefault), E.sectionHeader != null && (A.sectionHeader = String(E.sectionHeader)), E.urlPathname != null && (A.urlPathname = String(E.urlPathname)), A;
  }, o.toObject = function(E, A) {
    A || (A = {});
    let g = {};
    return A.defaults && (g.pageScriptHash = "", g.pageName = "", g.icon = "", g.isDefault = !1, g.sectionHeader = "", g.urlPathname = ""), E.pageScriptHash != null && E.hasOwnProperty("pageScriptHash") && (g.pageScriptHash = E.pageScriptHash), E.pageName != null && E.hasOwnProperty("pageName") && (g.pageName = E.pageName), E.icon != null && E.hasOwnProperty("icon") && (g.icon = E.icon), E.isDefault != null && E.hasOwnProperty("isDefault") && (g.isDefault = E.isDefault), E.sectionHeader != null && E.hasOwnProperty("sectionHeader") && (g.sectionHeader = E.sectionHeader), E.urlPathname != null && E.hasOwnProperty("urlPathname") && (g.urlPathname = E.urlPathname), g;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/AppPage";
  }, o;
})();
$root.Arrow = (() => {
  function o(A) {
    if (this.columnOrder = [], this.selectionMode = [], A) for (let g = Object.keys(A), e = 0; e < g.length; ++e) A[g[e]] != null && (this[g[e]] = A[g[e]]);
  }
  o.prototype.data = $util.newBuffer([]), o.prototype.styler = null, o.prototype.width = 0, o.prototype.height = 0, o.prototype.useContainerWidth = !1, o.prototype.id = "", o.prototype.columns = "", o.prototype.editingMode = 0, o.prototype.disabled = !1, o.prototype.formId = "", o.prototype.columnOrder = $util.emptyArray, o.prototype.selectionMode = $util.emptyArray, o.prototype.rowHeight = null, o.prototype.borderMode = 0, o.prototype.placeholder = null;
  let E;
  return Object.defineProperty(o.prototype, "_rowHeight", { get: $util.oneOfGetter(E = ["rowHeight"]), set: $util.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_placeholder", { get: $util.oneOfGetter(E = ["placeholder"]), set: $util.oneOfSetter(E) }), o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    if (g || (g = $Writer.create()), A.data != null && Object.hasOwnProperty.call(A, "data") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).bytes(A.data), A.styler != null && Object.hasOwnProperty.call(A, "styler") && $root.Styler.encode(A.styler, g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), A.width != null && Object.hasOwnProperty.call(A, "width") && g.uint32(
      /* id 3, wireType 0 =*/
      24
    ).uint32(A.width), A.height != null && Object.hasOwnProperty.call(A, "height") && g.uint32(
      /* id 4, wireType 0 =*/
      32
    ).uint32(A.height), A.useContainerWidth != null && Object.hasOwnProperty.call(A, "useContainerWidth") && g.uint32(
      /* id 5, wireType 0 =*/
      40
    ).bool(A.useContainerWidth), A.id != null && Object.hasOwnProperty.call(A, "id") && g.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(A.id), A.columns != null && Object.hasOwnProperty.call(A, "columns") && g.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(A.columns), A.editingMode != null && Object.hasOwnProperty.call(A, "editingMode") && g.uint32(
      /* id 8, wireType 0 =*/
      64
    ).int32(A.editingMode), A.disabled != null && Object.hasOwnProperty.call(A, "disabled") && g.uint32(
      /* id 9, wireType 0 =*/
      72
    ).bool(A.disabled), A.formId != null && Object.hasOwnProperty.call(A, "formId") && g.uint32(
      /* id 10, wireType 2 =*/
      82
    ).string(A.formId), A.columnOrder != null && A.columnOrder.length) for (let e = 0; e < A.columnOrder.length; ++e) g.uint32(
      /* id 11, wireType 2 =*/
      90
    ).string(A.columnOrder[e]);
    if (A.selectionMode != null && A.selectionMode.length) {
      g.uint32(
        /* id 12, wireType 2 =*/
        98
      ).fork();
      for (let e = 0; e < A.selectionMode.length; ++e) g.int32(A.selectionMode[e]);
      g.ldelim();
    }
    return A.rowHeight != null && Object.hasOwnProperty.call(A, "rowHeight") && g.uint32(
      /* id 13, wireType 0 =*/
      104
    ).uint32(A.rowHeight), A.borderMode != null && Object.hasOwnProperty.call(A, "borderMode") && g.uint32(
      /* id 14, wireType 0 =*/
      112
    ).int32(A.borderMode), A.placeholder != null && Object.hasOwnProperty.call(A, "placeholder") && g.uint32(
      /* id 15, wireType 2 =*/
      122
    ).string(A.placeholder), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader || (A = $Reader.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root.Arrow();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.data = A.bytes();
          break;
        }
        case 2: {
          c.styler = $root.Styler.decode(A, A.uint32());
          break;
        }
        case 3: {
          c.width = A.uint32();
          break;
        }
        case 4: {
          c.height = A.uint32();
          break;
        }
        case 5: {
          c.useContainerWidth = A.bool();
          break;
        }
        case 6: {
          c.id = A.string();
          break;
        }
        case 7: {
          c.columns = A.string();
          break;
        }
        case 8: {
          c.editingMode = A.int32();
          break;
        }
        case 9: {
          c.disabled = A.bool();
          break;
        }
        case 10: {
          c.formId = A.string();
          break;
        }
        case 11: {
          c.columnOrder && c.columnOrder.length || (c.columnOrder = []), c.columnOrder.push(A.string());
          break;
        }
        case 12: {
          if (c.selectionMode && c.selectionMode.length || (c.selectionMode = []), (n & 7) === 2) {
            let h = A.uint32() + A.pos;
            for (; A.pos < h; ) c.selectionMode.push(A.int32());
          } else c.selectionMode.push(A.int32());
          break;
        }
        case 13: {
          c.rowHeight = A.uint32();
          break;
        }
        case 14: {
          c.borderMode = A.int32();
          break;
        }
        case 15: {
          c.placeholder = A.string();
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root.Arrow) return A;
    let g = new $root.Arrow();
    if (A.data != null && (typeof A.data == "string" ? $util.base64.decode(A.data, g.data = $util.newBuffer($util.base64.length(A.data)), 0) : A.data.length >= 0 && (g.data = A.data)), A.styler != null) {
      if (typeof A.styler != "object") throw TypeError(".Arrow.styler: object expected");
      g.styler = $root.Styler.fromObject(A.styler);
    }
    switch (A.width != null && (g.width = A.width >>> 0), A.height != null && (g.height = A.height >>> 0), A.useContainerWidth != null && (g.useContainerWidth = !!A.useContainerWidth), A.id != null && (g.id = String(A.id)), A.columns != null && (g.columns = String(A.columns)), A.editingMode) {
      default:
        if (typeof A.editingMode == "number") {
          g.editingMode = A.editingMode;
          break;
        }
        break;
      case "READ_ONLY":
      case 0:
        g.editingMode = 0;
        break;
      case "FIXED":
      case 1:
        g.editingMode = 1;
        break;
      case "DYNAMIC":
      case 2:
        g.editingMode = 2;
        break;
    }
    if (A.disabled != null && (g.disabled = !!A.disabled), A.formId != null && (g.formId = String(A.formId)), A.columnOrder) {
      if (!Array.isArray(A.columnOrder)) throw TypeError(".Arrow.columnOrder: array expected");
      g.columnOrder = [];
      for (let e = 0; e < A.columnOrder.length; ++e) g.columnOrder[e] = String(A.columnOrder[e]);
    }
    if (A.selectionMode) {
      if (!Array.isArray(A.selectionMode)) throw TypeError(".Arrow.selectionMode: array expected");
      g.selectionMode = [];
      for (let e = 0; e < A.selectionMode.length; ++e) switch (A.selectionMode[e]) {
        default:
          if (typeof A.selectionMode[e] == "number") {
            g.selectionMode[e] = A.selectionMode[e];
            break;
          }
        case "SINGLE_ROW":
        case 0:
          g.selectionMode[e] = 0;
          break;
        case "MULTI_ROW":
        case 1:
          g.selectionMode[e] = 1;
          break;
        case "SINGLE_COLUMN":
        case 2:
          g.selectionMode[e] = 2;
          break;
        case "MULTI_COLUMN":
        case 3:
          g.selectionMode[e] = 3;
          break;
        case "SINGLE_CELL":
        case 4:
          g.selectionMode[e] = 4;
          break;
        case "MULTI_CELL":
        case 5:
          g.selectionMode[e] = 5;
          break;
      }
    }
    switch (A.rowHeight != null && (g.rowHeight = A.rowHeight >>> 0), A.borderMode) {
      default:
        if (typeof A.borderMode == "number") {
          g.borderMode = A.borderMode;
          break;
        }
        break;
      case "ALL":
      case 0:
        g.borderMode = 0;
        break;
      case "NONE":
      case 1:
        g.borderMode = 1;
        break;
      case "HORIZONTAL":
      case 2:
        g.borderMode = 2;
        break;
    }
    return A.placeholder != null && (g.placeholder = String(A.placeholder)), g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    if ((g.arrays || g.defaults) && (e.columnOrder = [], e.selectionMode = []), g.defaults && (g.bytes === String ? e.data = "" : (e.data = [], g.bytes !== Array && (e.data = $util.newBuffer(e.data))), e.styler = null, e.width = 0, e.height = 0, e.useContainerWidth = !1, e.id = "", e.columns = "", e.editingMode = g.enums === String ? "READ_ONLY" : 0, e.disabled = !1, e.formId = "", e.borderMode = g.enums === String ? "ALL" : 0), A.data != null && A.hasOwnProperty("data") && (e.data = g.bytes === String ? $util.base64.encode(A.data, 0, A.data.length) : g.bytes === Array ? Array.prototype.slice.call(A.data) : A.data), A.styler != null && A.hasOwnProperty("styler") && (e.styler = $root.Styler.toObject(A.styler, g)), A.width != null && A.hasOwnProperty("width") && (e.width = A.width), A.height != null && A.hasOwnProperty("height") && (e.height = A.height), A.useContainerWidth != null && A.hasOwnProperty("useContainerWidth") && (e.useContainerWidth = A.useContainerWidth), A.id != null && A.hasOwnProperty("id") && (e.id = A.id), A.columns != null && A.hasOwnProperty("columns") && (e.columns = A.columns), A.editingMode != null && A.hasOwnProperty("editingMode") && (e.editingMode = g.enums === String ? $root.Arrow.EditingMode[A.editingMode] === void 0 ? A.editingMode : $root.Arrow.EditingMode[A.editingMode] : A.editingMode), A.disabled != null && A.hasOwnProperty("disabled") && (e.disabled = A.disabled), A.formId != null && A.hasOwnProperty("formId") && (e.formId = A.formId), A.columnOrder && A.columnOrder.length) {
      e.columnOrder = [];
      for (let t = 0; t < A.columnOrder.length; ++t) e.columnOrder[t] = A.columnOrder[t];
    }
    if (A.selectionMode && A.selectionMode.length) {
      e.selectionMode = [];
      for (let t = 0; t < A.selectionMode.length; ++t) e.selectionMode[t] = g.enums === String ? $root.Arrow.SelectionMode[A.selectionMode[t]] === void 0 ? A.selectionMode[t] : $root.Arrow.SelectionMode[A.selectionMode[t]] : A.selectionMode[t];
    }
    return A.rowHeight != null && A.hasOwnProperty("rowHeight") && (e.rowHeight = A.rowHeight, g.oneofs && (e._rowHeight = "rowHeight")), A.borderMode != null && A.hasOwnProperty("borderMode") && (e.borderMode = g.enums === String ? $root.Arrow.BorderMode[A.borderMode] === void 0 ? A.borderMode : $root.Arrow.BorderMode[A.borderMode] : A.borderMode), A.placeholder != null && A.hasOwnProperty("placeholder") && (e.placeholder = A.placeholder, g.oneofs && (e._placeholder = "placeholder")), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/Arrow";
  }, o.EditingMode = (function() {
    const A = {}, g = Object.create(A);
    return g[A[0] = "READ_ONLY"] = 0, g[A[1] = "FIXED"] = 1, g[A[2] = "DYNAMIC"] = 2, g;
  })(), o.SelectionMode = (function() {
    const A = {}, g = Object.create(A);
    return g[A[0] = "SINGLE_ROW"] = 0, g[A[1] = "MULTI_ROW"] = 1, g[A[2] = "SINGLE_COLUMN"] = 2, g[A[3] = "MULTI_COLUMN"] = 3, g[A[4] = "SINGLE_CELL"] = 4, g[A[5] = "MULTI_CELL"] = 5, g;
  })(), o.BorderMode = (function() {
    const A = {}, g = Object.create(A);
    return g[A[0] = "ALL"] = 0, g[A[1] = "NONE"] = 1, g[A[2] = "HORIZONTAL"] = 2, g;
  })(), o;
})();
$root.Styler = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.uuid = "", o.prototype.caption = "", o.prototype.styles = "", o.prototype.displayValues = $util.newBuffer([]), o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, A) {
    return A || (A = $Writer.create()), E.uuid != null && Object.hasOwnProperty.call(E, "uuid") && A.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(E.uuid), E.caption != null && Object.hasOwnProperty.call(E, "caption") && A.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(E.caption), E.styles != null && Object.hasOwnProperty.call(E, "styles") && A.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(E.styles), E.displayValues != null && Object.hasOwnProperty.call(E, "displayValues") && A.uint32(
      /* id 4, wireType 2 =*/
      34
    ).bytes(E.displayValues), A;
  }, o.decode = function(E, A, g) {
    E instanceof $Reader || (E = $Reader.create(E));
    let e = A === void 0 ? E.len : E.pos + A, t = new $root.Styler();
    for (; E.pos < e; ) {
      let c = E.uint32();
      if (c === g) break;
      switch (c >>> 3) {
        case 1: {
          t.uuid = E.string();
          break;
        }
        case 2: {
          t.caption = E.string();
          break;
        }
        case 3: {
          t.styles = E.string();
          break;
        }
        case 4: {
          t.displayValues = E.bytes();
          break;
        }
        default:
          E.skipType(c & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(E) {
    if (E instanceof $root.Styler) return E;
    let A = new $root.Styler();
    return E.uuid != null && (A.uuid = String(E.uuid)), E.caption != null && (A.caption = String(E.caption)), E.styles != null && (A.styles = String(E.styles)), E.displayValues != null && (typeof E.displayValues == "string" ? $util.base64.decode(E.displayValues, A.displayValues = $util.newBuffer($util.base64.length(E.displayValues)), 0) : E.displayValues.length >= 0 && (A.displayValues = E.displayValues)), A;
  }, o.toObject = function(E, A) {
    A || (A = {});
    let g = {};
    return A.defaults && (g.uuid = "", g.caption = "", g.styles = "", A.bytes === String ? g.displayValues = "" : (g.displayValues = [], A.bytes !== Array && (g.displayValues = $util.newBuffer(g.displayValues)))), E.uuid != null && E.hasOwnProperty("uuid") && (g.uuid = E.uuid), E.caption != null && E.hasOwnProperty("caption") && (g.caption = E.caption), E.styles != null && E.hasOwnProperty("styles") && (g.styles = E.styles), E.displayValues != null && E.hasOwnProperty("displayValues") && (g.displayValues = A.bytes === String ? $util.base64.encode(E.displayValues, 0, E.displayValues.length) : A.bytes === Array ? Array.prototype.slice.call(E.displayValues) : E.displayValues), g;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/Styler";
  }, o;
})();
$root.ArrowData = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.data = $util.newBuffer([]), o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, A) {
    return A || (A = $Writer.create()), E.data != null && Object.hasOwnProperty.call(E, "data") && A.uint32(
      /* id 1, wireType 2 =*/
      10
    ).bytes(E.data), A;
  }, o.decode = function(E, A, g) {
    E instanceof $Reader || (E = $Reader.create(E));
    let e = A === void 0 ? E.len : E.pos + A, t = new $root.ArrowData();
    for (; E.pos < e; ) {
      let c = E.uint32();
      if (c === g) break;
      c >>> 3 === 1 ? t.data = E.bytes() : E.skipType(c & 7);
    }
    return t;
  }, o.fromObject = function(E) {
    if (E instanceof $root.ArrowData) return E;
    let A = new $root.ArrowData();
    return E.data != null && (typeof E.data == "string" ? $util.base64.decode(E.data, A.data = $util.newBuffer($util.base64.length(E.data)), 0) : E.data.length >= 0 && (A.data = E.data)), A;
  }, o.toObject = function(E, A) {
    A || (A = {});
    let g = {};
    return A.defaults && (A.bytes === String ? g.data = "" : (g.data = [], A.bytes !== Array && (g.data = $util.newBuffer(g.data)))), E.data != null && E.hasOwnProperty("data") && (g.data = A.bytes === String ? $util.base64.encode(E.data, 0, E.data.length) : A.bytes === Array ? Array.prototype.slice.call(E.data) : E.data), g;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/ArrowData";
  }, o;
})();
$root.ArrowNamedDataSet = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.name = "", o.prototype.hasName = !1, o.prototype.data = null, o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, A) {
    return A || (A = $Writer.create()), E.name != null && Object.hasOwnProperty.call(E, "name") && A.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(E.name), E.data != null && Object.hasOwnProperty.call(E, "data") && $root.Arrow.encode(E.data, A.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), E.hasName != null && Object.hasOwnProperty.call(E, "hasName") && A.uint32(
      /* id 3, wireType 0 =*/
      24
    ).bool(E.hasName), A;
  }, o.decode = function(E, A, g) {
    E instanceof $Reader || (E = $Reader.create(E));
    let e = A === void 0 ? E.len : E.pos + A, t = new $root.ArrowNamedDataSet();
    for (; E.pos < e; ) {
      let c = E.uint32();
      if (c === g) break;
      switch (c >>> 3) {
        case 1: {
          t.name = E.string();
          break;
        }
        case 3: {
          t.hasName = E.bool();
          break;
        }
        case 2: {
          t.data = $root.Arrow.decode(E, E.uint32());
          break;
        }
        default:
          E.skipType(c & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(E) {
    if (E instanceof $root.ArrowNamedDataSet) return E;
    let A = new $root.ArrowNamedDataSet();
    if (E.name != null && (A.name = String(E.name)), E.hasName != null && (A.hasName = !!E.hasName), E.data != null) {
      if (typeof E.data != "object") throw TypeError(".ArrowNamedDataSet.data: object expected");
      A.data = $root.Arrow.fromObject(E.data);
    }
    return A;
  }, o.toObject = function(E, A) {
    A || (A = {});
    let g = {};
    return A.defaults && (g.name = "", g.data = null, g.hasName = !1), E.name != null && E.hasOwnProperty("name") && (g.name = E.name), E.data != null && E.hasOwnProperty("data") && (g.data = $root.Arrow.toObject(E.data, A)), E.hasName != null && E.hasOwnProperty("hasName") && (g.hasName = E.hasName), g;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/ArrowNamedDataSet";
  }, o;
})();
$root.ArrowVegaLiteChart = (() => {
  function o(E) {
    if (this.datasets = [], this.selectionMode = [], E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.spec = "", o.prototype.data = null, o.prototype.datasets = $util.emptyArray, o.prototype.useContainerWidth = !1, o.prototype.theme = "", o.prototype.id = "", o.prototype.selectionMode = $util.emptyArray, o.prototype.formId = "", o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, A) {
    if (A || (A = $Writer.create()), E.spec != null && Object.hasOwnProperty.call(E, "spec") && A.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(E.spec), E.data != null && Object.hasOwnProperty.call(E, "data") && $root.Arrow.encode(E.data, A.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), E.datasets != null && E.datasets.length) for (let g = 0; g < E.datasets.length; ++g) $root.ArrowNamedDataSet.encode(E.datasets[g], A.uint32(
      /* id 4, wireType 2 =*/
      34
    ).fork()).ldelim();
    if (E.useContainerWidth != null && Object.hasOwnProperty.call(E, "useContainerWidth") && A.uint32(
      /* id 5, wireType 0 =*/
      40
    ).bool(E.useContainerWidth), E.theme != null && Object.hasOwnProperty.call(E, "theme") && A.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(E.theme), E.id != null && Object.hasOwnProperty.call(E, "id") && A.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(E.id), E.selectionMode != null && E.selectionMode.length) for (let g = 0; g < E.selectionMode.length; ++g) A.uint32(
      /* id 8, wireType 2 =*/
      66
    ).string(E.selectionMode[g]);
    return E.formId != null && Object.hasOwnProperty.call(E, "formId") && A.uint32(
      /* id 9, wireType 2 =*/
      74
    ).string(E.formId), A;
  }, o.decode = function(E, A, g) {
    E instanceof $Reader || (E = $Reader.create(E));
    let e = A === void 0 ? E.len : E.pos + A, t = new $root.ArrowVegaLiteChart();
    for (; E.pos < e; ) {
      let c = E.uint32();
      if (c === g) break;
      switch (c >>> 3) {
        case 1: {
          t.spec = E.string();
          break;
        }
        case 2: {
          t.data = $root.Arrow.decode(E, E.uint32());
          break;
        }
        case 4: {
          t.datasets && t.datasets.length || (t.datasets = []), t.datasets.push($root.ArrowNamedDataSet.decode(E, E.uint32()));
          break;
        }
        case 5: {
          t.useContainerWidth = E.bool();
          break;
        }
        case 6: {
          t.theme = E.string();
          break;
        }
        case 7: {
          t.id = E.string();
          break;
        }
        case 8: {
          t.selectionMode && t.selectionMode.length || (t.selectionMode = []), t.selectionMode.push(E.string());
          break;
        }
        case 9: {
          t.formId = E.string();
          break;
        }
        default:
          E.skipType(c & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(E) {
    if (E instanceof $root.ArrowVegaLiteChart) return E;
    let A = new $root.ArrowVegaLiteChart();
    if (E.spec != null && (A.spec = String(E.spec)), E.data != null) {
      if (typeof E.data != "object") throw TypeError(".ArrowVegaLiteChart.data: object expected");
      A.data = $root.Arrow.fromObject(E.data);
    }
    if (E.datasets) {
      if (!Array.isArray(E.datasets)) throw TypeError(".ArrowVegaLiteChart.datasets: array expected");
      A.datasets = [];
      for (let g = 0; g < E.datasets.length; ++g) {
        if (typeof E.datasets[g] != "object") throw TypeError(".ArrowVegaLiteChart.datasets: object expected");
        A.datasets[g] = $root.ArrowNamedDataSet.fromObject(E.datasets[g]);
      }
    }
    if (E.useContainerWidth != null && (A.useContainerWidth = !!E.useContainerWidth), E.theme != null && (A.theme = String(E.theme)), E.id != null && (A.id = String(E.id)), E.selectionMode) {
      if (!Array.isArray(E.selectionMode)) throw TypeError(".ArrowVegaLiteChart.selectionMode: array expected");
      A.selectionMode = [];
      for (let g = 0; g < E.selectionMode.length; ++g) A.selectionMode[g] = String(E.selectionMode[g]);
    }
    return E.formId != null && (A.formId = String(E.formId)), A;
  }, o.toObject = function(E, A) {
    A || (A = {});
    let g = {};
    if ((A.arrays || A.defaults) && (g.datasets = [], g.selectionMode = []), A.defaults && (g.spec = "", g.data = null, g.useContainerWidth = !1, g.theme = "", g.id = "", g.formId = ""), E.spec != null && E.hasOwnProperty("spec") && (g.spec = E.spec), E.data != null && E.hasOwnProperty("data") && (g.data = $root.Arrow.toObject(E.data, A)), E.datasets && E.datasets.length) {
      g.datasets = [];
      for (let e = 0; e < E.datasets.length; ++e) g.datasets[e] = $root.ArrowNamedDataSet.toObject(E.datasets[e], A);
    }
    if (E.useContainerWidth != null && E.hasOwnProperty("useContainerWidth") && (g.useContainerWidth = E.useContainerWidth), E.theme != null && E.hasOwnProperty("theme") && (g.theme = E.theme), E.id != null && E.hasOwnProperty("id") && (g.id = E.id), E.selectionMode && E.selectionMode.length) {
      g.selectionMode = [];
      for (let e = 0; e < E.selectionMode.length; ++e) g.selectionMode[e] = E.selectionMode[e];
    }
    return E.formId != null && E.hasOwnProperty("formId") && (g.formId = E.formId), g;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/ArrowVegaLiteChart";
  }, o;
})();
$root.Audio = (() => {
  function o(A) {
    if (A) for (let g = Object.keys(A), e = 0; e < g.length; ++e) A[g[e]] != null && (this[g[e]] = A[g[e]]);
  }
  o.prototype.url = "", o.prototype.startTime = 0, o.prototype.endTime = 0, o.prototype.loop = !1, o.prototype.autoplay = !1, o.prototype.id = "", o.prototype.widthConfig = null;
  let E;
  return Object.defineProperty(o.prototype, "_widthConfig", { get: $util.oneOfGetter(E = ["widthConfig"]), set: $util.oneOfSetter(E) }), o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    return g || (g = $Writer.create()), A.startTime != null && Object.hasOwnProperty.call(A, "startTime") && g.uint32(
      /* id 3, wireType 0 =*/
      24
    ).int32(A.startTime), A.url != null && Object.hasOwnProperty.call(A, "url") && g.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(A.url), A.endTime != null && Object.hasOwnProperty.call(A, "endTime") && g.uint32(
      /* id 6, wireType 0 =*/
      48
    ).int32(A.endTime), A.loop != null && Object.hasOwnProperty.call(A, "loop") && g.uint32(
      /* id 7, wireType 0 =*/
      56
    ).bool(A.loop), A.autoplay != null && Object.hasOwnProperty.call(A, "autoplay") && g.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(A.autoplay), A.id != null && Object.hasOwnProperty.call(A, "id") && g.uint32(
      /* id 9, wireType 2 =*/
      74
    ).string(A.id), A.widthConfig != null && Object.hasOwnProperty.call(A, "widthConfig") && $root.streamlit.WidthConfig.encode(A.widthConfig, g.uint32(
      /* id 10, wireType 2 =*/
      82
    ).fork()).ldelim(), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader || (A = $Reader.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root.Audio();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 5: {
          c.url = A.string();
          break;
        }
        case 3: {
          c.startTime = A.int32();
          break;
        }
        case 6: {
          c.endTime = A.int32();
          break;
        }
        case 7: {
          c.loop = A.bool();
          break;
        }
        case 8: {
          c.autoplay = A.bool();
          break;
        }
        case 9: {
          c.id = A.string();
          break;
        }
        case 10: {
          c.widthConfig = $root.streamlit.WidthConfig.decode(A, A.uint32());
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root.Audio) return A;
    let g = new $root.Audio();
    if (A.url != null && (g.url = String(A.url)), A.startTime != null && (g.startTime = A.startTime | 0), A.endTime != null && (g.endTime = A.endTime | 0), A.loop != null && (g.loop = !!A.loop), A.autoplay != null && (g.autoplay = !!A.autoplay), A.id != null && (g.id = String(A.id)), A.widthConfig != null) {
      if (typeof A.widthConfig != "object") throw TypeError(".Audio.widthConfig: object expected");
      g.widthConfig = $root.streamlit.WidthConfig.fromObject(A.widthConfig);
    }
    return g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    return g.defaults && (e.startTime = 0, e.url = "", e.endTime = 0, e.loop = !1, e.autoplay = !1, e.id = ""), A.startTime != null && A.hasOwnProperty("startTime") && (e.startTime = A.startTime), A.url != null && A.hasOwnProperty("url") && (e.url = A.url), A.endTime != null && A.hasOwnProperty("endTime") && (e.endTime = A.endTime), A.loop != null && A.hasOwnProperty("loop") && (e.loop = A.loop), A.autoplay != null && A.hasOwnProperty("autoplay") && (e.autoplay = A.autoplay), A.id != null && A.hasOwnProperty("id") && (e.id = A.id), A.widthConfig != null && A.hasOwnProperty("widthConfig") && (e.widthConfig = $root.streamlit.WidthConfig.toObject(A.widthConfig, g), g.oneofs && (e._widthConfig = "widthConfig")), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/Audio";
  }, o;
})();
$root.AudioInput = (() => {
  function o(A) {
    if (A) for (let g = Object.keys(A), e = 0; e < g.length; ++e) A[g[e]] != null && (this[g[e]] = A[g[e]]);
  }
  o.prototype.id = "", o.prototype.label = "", o.prototype.help = "", o.prototype.formId = "", o.prototype.disabled = !1, o.prototype.labelVisibility = null, o.prototype.sampleRate = null;
  let E;
  return Object.defineProperty(o.prototype, "_sampleRate", { get: $util.oneOfGetter(E = ["sampleRate"]), set: $util.oneOfSetter(E) }), o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    return g || (g = $Writer.create()), A.id != null && Object.hasOwnProperty.call(A, "id") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(A.id), A.label != null && Object.hasOwnProperty.call(A, "label") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(A.label), A.help != null && Object.hasOwnProperty.call(A, "help") && g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(A.help), A.formId != null && Object.hasOwnProperty.call(A, "formId") && g.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(A.formId), A.disabled != null && Object.hasOwnProperty.call(A, "disabled") && g.uint32(
      /* id 5, wireType 0 =*/
      40
    ).bool(A.disabled), A.labelVisibility != null && Object.hasOwnProperty.call(A, "labelVisibility") && $root.LabelVisibilityMessage.encode(A.labelVisibility, g.uint32(
      /* id 6, wireType 2 =*/
      50
    ).fork()).ldelim(), A.sampleRate != null && Object.hasOwnProperty.call(A, "sampleRate") && g.uint32(
      /* id 7, wireType 0 =*/
      56
    ).int32(A.sampleRate), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader || (A = $Reader.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root.AudioInput();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.id = A.string();
          break;
        }
        case 2: {
          c.label = A.string();
          break;
        }
        case 3: {
          c.help = A.string();
          break;
        }
        case 4: {
          c.formId = A.string();
          break;
        }
        case 5: {
          c.disabled = A.bool();
          break;
        }
        case 6: {
          c.labelVisibility = $root.LabelVisibilityMessage.decode(A, A.uint32());
          break;
        }
        case 7: {
          c.sampleRate = A.int32();
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root.AudioInput) return A;
    let g = new $root.AudioInput();
    if (A.id != null && (g.id = String(A.id)), A.label != null && (g.label = String(A.label)), A.help != null && (g.help = String(A.help)), A.formId != null && (g.formId = String(A.formId)), A.disabled != null && (g.disabled = !!A.disabled), A.labelVisibility != null) {
      if (typeof A.labelVisibility != "object") throw TypeError(".AudioInput.labelVisibility: object expected");
      g.labelVisibility = $root.LabelVisibilityMessage.fromObject(A.labelVisibility);
    }
    return A.sampleRate != null && (g.sampleRate = A.sampleRate | 0), g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    return g.defaults && (e.id = "", e.label = "", e.help = "", e.formId = "", e.disabled = !1, e.labelVisibility = null), A.id != null && A.hasOwnProperty("id") && (e.id = A.id), A.label != null && A.hasOwnProperty("label") && (e.label = A.label), A.help != null && A.hasOwnProperty("help") && (e.help = A.help), A.formId != null && A.hasOwnProperty("formId") && (e.formId = A.formId), A.disabled != null && A.hasOwnProperty("disabled") && (e.disabled = A.disabled), A.labelVisibility != null && A.hasOwnProperty("labelVisibility") && (e.labelVisibility = $root.LabelVisibilityMessage.toObject(A.labelVisibility, g)), A.sampleRate != null && A.hasOwnProperty("sampleRate") && (e.sampleRate = A.sampleRate, g.oneofs && (e._sampleRate = "sampleRate")), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/AudioInput";
  }, o;
})();
$root.LabelVisibilityMessage = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.value = 0, o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, A) {
    return A || (A = $Writer.create()), E.value != null && Object.hasOwnProperty.call(E, "value") && A.uint32(
      /* id 1, wireType 0 =*/
      8
    ).int32(E.value), A;
  }, o.decode = function(E, A, g) {
    E instanceof $Reader || (E = $Reader.create(E));
    let e = A === void 0 ? E.len : E.pos + A, t = new $root.LabelVisibilityMessage();
    for (; E.pos < e; ) {
      let c = E.uint32();
      if (c === g) break;
      c >>> 3 === 1 ? t.value = E.int32() : E.skipType(c & 7);
    }
    return t;
  }, o.fromObject = function(E) {
    if (E instanceof $root.LabelVisibilityMessage) return E;
    let A = new $root.LabelVisibilityMessage();
    switch (E.value) {
      default:
        if (typeof E.value == "number") {
          A.value = E.value;
          break;
        }
        break;
      case "VISIBLE":
      case 0:
        A.value = 0;
        break;
      case "HIDDEN":
      case 1:
        A.value = 1;
        break;
      case "COLLAPSED":
      case 2:
        A.value = 2;
        break;
    }
    return A;
  }, o.toObject = function(E, A) {
    A || (A = {});
    let g = {};
    return A.defaults && (g.value = A.enums === String ? "VISIBLE" : 0), E.value != null && E.hasOwnProperty("value") && (g.value = A.enums === String ? $root.LabelVisibilityMessage.LabelVisibilityOptions[E.value] === void 0 ? E.value : $root.LabelVisibilityMessage.LabelVisibilityOptions[E.value] : E.value), g;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/LabelVisibilityMessage";
  }, o.LabelVisibilityOptions = (function() {
    const E = {}, A = Object.create(E);
    return A[E[0] = "VISIBLE"] = 0, A[E[1] = "HIDDEN"] = 1, A[E[2] = "COLLAPSED"] = 2, A;
  })(), o;
})();
$root.AuthRedirect = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.url = "", o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, A) {
    return A || (A = $Writer.create()), E.url != null && Object.hasOwnProperty.call(E, "url") && A.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(E.url), A;
  }, o.decode = function(E, A, g) {
    E instanceof $Reader || (E = $Reader.create(E));
    let e = A === void 0 ? E.len : E.pos + A, t = new $root.AuthRedirect();
    for (; E.pos < e; ) {
      let c = E.uint32();
      if (c === g) break;
      c >>> 3 === 1 ? t.url = E.string() : E.skipType(c & 7);
    }
    return t;
  }, o.fromObject = function(E) {
    if (E instanceof $root.AuthRedirect) return E;
    let A = new $root.AuthRedirect();
    return E.url != null && (A.url = String(E.url)), A;
  }, o.toObject = function(E, A) {
    A || (A = {});
    let g = {};
    return A.defaults && (g.url = ""), E.url != null && E.hasOwnProperty("url") && (g.url = E.url), g;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/AuthRedirect";
  }, o;
})();
$root.AutoRerun = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.interval = 0, o.prototype.fragmentId = "", o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, A) {
    return A || (A = $Writer.create()), E.interval != null && Object.hasOwnProperty.call(E, "interval") && A.uint32(
      /* id 1, wireType 5 =*/
      13
    ).float(E.interval), E.fragmentId != null && Object.hasOwnProperty.call(E, "fragmentId") && A.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(E.fragmentId), A;
  }, o.decode = function(E, A, g) {
    E instanceof $Reader || (E = $Reader.create(E));
    let e = A === void 0 ? E.len : E.pos + A, t = new $root.AutoRerun();
    for (; E.pos < e; ) {
      let c = E.uint32();
      if (c === g) break;
      switch (c >>> 3) {
        case 1: {
          t.interval = E.float();
          break;
        }
        case 2: {
          t.fragmentId = E.string();
          break;
        }
        default:
          E.skipType(c & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(E) {
    if (E instanceof $root.AutoRerun) return E;
    let A = new $root.AutoRerun();
    return E.interval != null && (A.interval = Number(E.interval)), E.fragmentId != null && (A.fragmentId = String(E.fragmentId)), A;
  }, o.toObject = function(E, A) {
    A || (A = {});
    let g = {};
    return A.defaults && (g.interval = 0, g.fragmentId = ""), E.interval != null && E.hasOwnProperty("interval") && (g.interval = A.json && !isFinite(E.interval) ? String(E.interval) : E.interval), E.fragmentId != null && E.hasOwnProperty("fragmentId") && (g.fragmentId = E.fragmentId), g;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/AutoRerun";
  }, o;
})();
$root.BackMsg = (() => {
  function o(A) {
    if (A) for (let g = Object.keys(A), e = 0; e < g.length; ++e) A[g[e]] != null && (this[g[e]] = A[g[e]]);
  }
  o.prototype.clearCache = null, o.prototype.setRunOnSave = null, o.prototype.stopScript = null, o.prototype.rerunScript = null, o.prototype.loadGitInfo = null, o.prototype.debugDisconnectWebsocket = null, o.prototype.debugShutdownRuntime = null, o.prototype.fileUrlsRequest = null, o.prototype.appHeartbeat = null, o.prototype.deferredFileRequest = null, o.prototype.debugLastBackmsgId = "";
  let E;
  return Object.defineProperty(o.prototype, "type", { get: $util.oneOfGetter(E = ["clearCache", "setRunOnSave", "stopScript", "rerunScript", "loadGitInfo", "debugDisconnectWebsocket", "debugShutdownRuntime", "fileUrlsRequest", "appHeartbeat", "deferredFileRequest"]), set: $util.oneOfSetter(E) }), o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    return g || (g = $Writer.create()), A.clearCache != null && Object.hasOwnProperty.call(A, "clearCache") && g.uint32(
      /* id 5, wireType 0 =*/
      40
    ).bool(A.clearCache), A.setRunOnSave != null && Object.hasOwnProperty.call(A, "setRunOnSave") && g.uint32(
      /* id 6, wireType 0 =*/
      48
    ).bool(A.setRunOnSave), A.stopScript != null && Object.hasOwnProperty.call(A, "stopScript") && g.uint32(
      /* id 7, wireType 0 =*/
      56
    ).bool(A.stopScript), A.rerunScript != null && Object.hasOwnProperty.call(A, "rerunScript") && $root.ClientState.encode(A.rerunScript, g.uint32(
      /* id 11, wireType 2 =*/
      90
    ).fork()).ldelim(), A.loadGitInfo != null && Object.hasOwnProperty.call(A, "loadGitInfo") && g.uint32(
      /* id 12, wireType 0 =*/
      96
    ).bool(A.loadGitInfo), A.debugLastBackmsgId != null && Object.hasOwnProperty.call(A, "debugLastBackmsgId") && g.uint32(
      /* id 13, wireType 2 =*/
      106
    ).string(A.debugLastBackmsgId), A.debugDisconnectWebsocket != null && Object.hasOwnProperty.call(A, "debugDisconnectWebsocket") && g.uint32(
      /* id 14, wireType 0 =*/
      112
    ).bool(A.debugDisconnectWebsocket), A.debugShutdownRuntime != null && Object.hasOwnProperty.call(A, "debugShutdownRuntime") && g.uint32(
      /* id 15, wireType 0 =*/
      120
    ).bool(A.debugShutdownRuntime), A.fileUrlsRequest != null && Object.hasOwnProperty.call(A, "fileUrlsRequest") && $root.FileURLsRequest.encode(A.fileUrlsRequest, g.uint32(
      /* id 16, wireType 2 =*/
      130
    ).fork()).ldelim(), A.appHeartbeat != null && Object.hasOwnProperty.call(A, "appHeartbeat") && g.uint32(
      /* id 17, wireType 0 =*/
      136
    ).bool(A.appHeartbeat), A.deferredFileRequest != null && Object.hasOwnProperty.call(A, "deferredFileRequest") && $root.DeferredFileRequest.encode(A.deferredFileRequest, g.uint32(
      /* id 18, wireType 2 =*/
      146
    ).fork()).ldelim(), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader || (A = $Reader.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root.BackMsg();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 5: {
          c.clearCache = A.bool();
          break;
        }
        case 6: {
          c.setRunOnSave = A.bool();
          break;
        }
        case 7: {
          c.stopScript = A.bool();
          break;
        }
        case 11: {
          c.rerunScript = $root.ClientState.decode(A, A.uint32());
          break;
        }
        case 12: {
          c.loadGitInfo = A.bool();
          break;
        }
        case 14: {
          c.debugDisconnectWebsocket = A.bool();
          break;
        }
        case 15: {
          c.debugShutdownRuntime = A.bool();
          break;
        }
        case 16: {
          c.fileUrlsRequest = $root.FileURLsRequest.decode(A, A.uint32());
          break;
        }
        case 17: {
          c.appHeartbeat = A.bool();
          break;
        }
        case 18: {
          c.deferredFileRequest = $root.DeferredFileRequest.decode(A, A.uint32());
          break;
        }
        case 13: {
          c.debugLastBackmsgId = A.string();
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root.BackMsg) return A;
    let g = new $root.BackMsg();
    if (A.clearCache != null && (g.clearCache = !!A.clearCache), A.setRunOnSave != null && (g.setRunOnSave = !!A.setRunOnSave), A.stopScript != null && (g.stopScript = !!A.stopScript), A.rerunScript != null) {
      if (typeof A.rerunScript != "object") throw TypeError(".BackMsg.rerunScript: object expected");
      g.rerunScript = $root.ClientState.fromObject(A.rerunScript);
    }
    if (A.loadGitInfo != null && (g.loadGitInfo = !!A.loadGitInfo), A.debugDisconnectWebsocket != null && (g.debugDisconnectWebsocket = !!A.debugDisconnectWebsocket), A.debugShutdownRuntime != null && (g.debugShutdownRuntime = !!A.debugShutdownRuntime), A.fileUrlsRequest != null) {
      if (typeof A.fileUrlsRequest != "object") throw TypeError(".BackMsg.fileUrlsRequest: object expected");
      g.fileUrlsRequest = $root.FileURLsRequest.fromObject(A.fileUrlsRequest);
    }
    if (A.appHeartbeat != null && (g.appHeartbeat = !!A.appHeartbeat), A.deferredFileRequest != null) {
      if (typeof A.deferredFileRequest != "object") throw TypeError(".BackMsg.deferredFileRequest: object expected");
      g.deferredFileRequest = $root.DeferredFileRequest.fromObject(A.deferredFileRequest);
    }
    return A.debugLastBackmsgId != null && (g.debugLastBackmsgId = String(A.debugLastBackmsgId)), g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    return g.defaults && (e.debugLastBackmsgId = ""), A.clearCache != null && A.hasOwnProperty("clearCache") && (e.clearCache = A.clearCache, g.oneofs && (e.type = "clearCache")), A.setRunOnSave != null && A.hasOwnProperty("setRunOnSave") && (e.setRunOnSave = A.setRunOnSave, g.oneofs && (e.type = "setRunOnSave")), A.stopScript != null && A.hasOwnProperty("stopScript") && (e.stopScript = A.stopScript, g.oneofs && (e.type = "stopScript")), A.rerunScript != null && A.hasOwnProperty("rerunScript") && (e.rerunScript = $root.ClientState.toObject(A.rerunScript, g), g.oneofs && (e.type = "rerunScript")), A.loadGitInfo != null && A.hasOwnProperty("loadGitInfo") && (e.loadGitInfo = A.loadGitInfo, g.oneofs && (e.type = "loadGitInfo")), A.debugLastBackmsgId != null && A.hasOwnProperty("debugLastBackmsgId") && (e.debugLastBackmsgId = A.debugLastBackmsgId), A.debugDisconnectWebsocket != null && A.hasOwnProperty("debugDisconnectWebsocket") && (e.debugDisconnectWebsocket = A.debugDisconnectWebsocket, g.oneofs && (e.type = "debugDisconnectWebsocket")), A.debugShutdownRuntime != null && A.hasOwnProperty("debugShutdownRuntime") && (e.debugShutdownRuntime = A.debugShutdownRuntime, g.oneofs && (e.type = "debugShutdownRuntime")), A.fileUrlsRequest != null && A.hasOwnProperty("fileUrlsRequest") && (e.fileUrlsRequest = $root.FileURLsRequest.toObject(A.fileUrlsRequest, g), g.oneofs && (e.type = "fileUrlsRequest")), A.appHeartbeat != null && A.hasOwnProperty("appHeartbeat") && (e.appHeartbeat = A.appHeartbeat, g.oneofs && (e.type = "appHeartbeat")), A.deferredFileRequest != null && A.hasOwnProperty("deferredFileRequest") && (e.deferredFileRequest = $root.DeferredFileRequest.toObject(A.deferredFileRequest, g), g.oneofs && (e.type = "deferredFileRequest")), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/BackMsg";
  }, o;
})();
$root.DeferredFileRequest = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.fileId = "", o.prototype.sessionId = "", o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, A) {
    return A || (A = $Writer.create()), E.fileId != null && Object.hasOwnProperty.call(E, "fileId") && A.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(E.fileId), E.sessionId != null && Object.hasOwnProperty.call(E, "sessionId") && A.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(E.sessionId), A;
  }, o.decode = function(E, A, g) {
    E instanceof $Reader || (E = $Reader.create(E));
    let e = A === void 0 ? E.len : E.pos + A, t = new $root.DeferredFileRequest();
    for (; E.pos < e; ) {
      let c = E.uint32();
      if (c === g) break;
      switch (c >>> 3) {
        case 1: {
          t.fileId = E.string();
          break;
        }
        case 2: {
          t.sessionId = E.string();
          break;
        }
        default:
          E.skipType(c & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(E) {
    if (E instanceof $root.DeferredFileRequest) return E;
    let A = new $root.DeferredFileRequest();
    return E.fileId != null && (A.fileId = String(E.fileId)), E.sessionId != null && (A.sessionId = String(E.sessionId)), A;
  }, o.toObject = function(E, A) {
    A || (A = {});
    let g = {};
    return A.defaults && (g.fileId = "", g.sessionId = ""), E.fileId != null && E.hasOwnProperty("fileId") && (g.fileId = E.fileId), E.sessionId != null && E.hasOwnProperty("sessionId") && (g.sessionId = E.sessionId), g;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/DeferredFileRequest";
  }, o;
})();
$root.ContextInfo = (() => {
  function o(A) {
    if (A) for (let g = Object.keys(A), e = 0; e < g.length; ++e) A[g[e]] != null && (this[g[e]] = A[g[e]]);
  }
  o.prototype.timezone = null, o.prototype.timezoneOffset = null, o.prototype.locale = null, o.prototype.url = null, o.prototype.isEmbedded = null, o.prototype.colorScheme = null;
  let E;
  return Object.defineProperty(o.prototype, "_timezone", { get: $util.oneOfGetter(E = ["timezone"]), set: $util.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_timezoneOffset", { get: $util.oneOfGetter(E = ["timezoneOffset"]), set: $util.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_locale", { get: $util.oneOfGetter(E = ["locale"]), set: $util.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_url", { get: $util.oneOfGetter(E = ["url"]), set: $util.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_isEmbedded", { get: $util.oneOfGetter(E = ["isEmbedded"]), set: $util.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_colorScheme", { get: $util.oneOfGetter(E = ["colorScheme"]), set: $util.oneOfSetter(E) }), o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    return g || (g = $Writer.create()), A.timezone != null && Object.hasOwnProperty.call(A, "timezone") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(A.timezone), A.timezoneOffset != null && Object.hasOwnProperty.call(A, "timezoneOffset") && g.uint32(
      /* id 2, wireType 0 =*/
      16
    ).int32(A.timezoneOffset), A.locale != null && Object.hasOwnProperty.call(A, "locale") && g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(A.locale), A.url != null && Object.hasOwnProperty.call(A, "url") && g.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(A.url), A.isEmbedded != null && Object.hasOwnProperty.call(A, "isEmbedded") && g.uint32(
      /* id 5, wireType 0 =*/
      40
    ).bool(A.isEmbedded), A.colorScheme != null && Object.hasOwnProperty.call(A, "colorScheme") && g.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(A.colorScheme), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader || (A = $Reader.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root.ContextInfo();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.timezone = A.string();
          break;
        }
        case 2: {
          c.timezoneOffset = A.int32();
          break;
        }
        case 3: {
          c.locale = A.string();
          break;
        }
        case 4: {
          c.url = A.string();
          break;
        }
        case 5: {
          c.isEmbedded = A.bool();
          break;
        }
        case 6: {
          c.colorScheme = A.string();
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root.ContextInfo) return A;
    let g = new $root.ContextInfo();
    return A.timezone != null && (g.timezone = String(A.timezone)), A.timezoneOffset != null && (g.timezoneOffset = A.timezoneOffset | 0), A.locale != null && (g.locale = String(A.locale)), A.url != null && (g.url = String(A.url)), A.isEmbedded != null && (g.isEmbedded = !!A.isEmbedded), A.colorScheme != null && (g.colorScheme = String(A.colorScheme)), g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    return A.timezone != null && A.hasOwnProperty("timezone") && (e.timezone = A.timezone, g.oneofs && (e._timezone = "timezone")), A.timezoneOffset != null && A.hasOwnProperty("timezoneOffset") && (e.timezoneOffset = A.timezoneOffset, g.oneofs && (e._timezoneOffset = "timezoneOffset")), A.locale != null && A.hasOwnProperty("locale") && (e.locale = A.locale, g.oneofs && (e._locale = "locale")), A.url != null && A.hasOwnProperty("url") && (e.url = A.url, g.oneofs && (e._url = "url")), A.isEmbedded != null && A.hasOwnProperty("isEmbedded") && (e.isEmbedded = A.isEmbedded, g.oneofs && (e._isEmbedded = "isEmbedded")), A.colorScheme != null && A.hasOwnProperty("colorScheme") && (e.colorScheme = A.colorScheme, g.oneofs && (e._colorScheme = "colorScheme")), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/ContextInfo";
  }, o;
})();
$root.ClientState = (() => {
  function o(E) {
    if (this.cachedMessageHashes = [], E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.queryString = "", o.prototype.widgetStates = null, o.prototype.pageScriptHash = "", o.prototype.pageName = "", o.prototype.fragmentId = "", o.prototype.isAutoRerun = !1, o.prototype.cachedMessageHashes = $util.emptyArray, o.prototype.contextInfo = null, o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, A) {
    if (A || (A = $Writer.create()), E.queryString != null && Object.hasOwnProperty.call(E, "queryString") && A.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(E.queryString), E.widgetStates != null && Object.hasOwnProperty.call(E, "widgetStates") && $root.WidgetStates.encode(E.widgetStates, A.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), E.pageScriptHash != null && Object.hasOwnProperty.call(E, "pageScriptHash") && A.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(E.pageScriptHash), E.pageName != null && Object.hasOwnProperty.call(E, "pageName") && A.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(E.pageName), E.fragmentId != null && Object.hasOwnProperty.call(E, "fragmentId") && A.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(E.fragmentId), E.isAutoRerun != null && Object.hasOwnProperty.call(E, "isAutoRerun") && A.uint32(
      /* id 6, wireType 0 =*/
      48
    ).bool(E.isAutoRerun), E.cachedMessageHashes != null && E.cachedMessageHashes.length) for (let g = 0; g < E.cachedMessageHashes.length; ++g) A.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(E.cachedMessageHashes[g]);
    return E.contextInfo != null && Object.hasOwnProperty.call(E, "contextInfo") && $root.ContextInfo.encode(E.contextInfo, A.uint32(
      /* id 8, wireType 2 =*/
      66
    ).fork()).ldelim(), A;
  }, o.decode = function(E, A, g) {
    E instanceof $Reader || (E = $Reader.create(E));
    let e = A === void 0 ? E.len : E.pos + A, t = new $root.ClientState();
    for (; E.pos < e; ) {
      let c = E.uint32();
      if (c === g) break;
      switch (c >>> 3) {
        case 1: {
          t.queryString = E.string();
          break;
        }
        case 2: {
          t.widgetStates = $root.WidgetStates.decode(E, E.uint32());
          break;
        }
        case 3: {
          t.pageScriptHash = E.string();
          break;
        }
        case 4: {
          t.pageName = E.string();
          break;
        }
        case 5: {
          t.fragmentId = E.string();
          break;
        }
        case 6: {
          t.isAutoRerun = E.bool();
          break;
        }
        case 7: {
          t.cachedMessageHashes && t.cachedMessageHashes.length || (t.cachedMessageHashes = []), t.cachedMessageHashes.push(E.string());
          break;
        }
        case 8: {
          t.contextInfo = $root.ContextInfo.decode(E, E.uint32());
          break;
        }
        default:
          E.skipType(c & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(E) {
    if (E instanceof $root.ClientState) return E;
    let A = new $root.ClientState();
    if (E.queryString != null && (A.queryString = String(E.queryString)), E.widgetStates != null) {
      if (typeof E.widgetStates != "object") throw TypeError(".ClientState.widgetStates: object expected");
      A.widgetStates = $root.WidgetStates.fromObject(E.widgetStates);
    }
    if (E.pageScriptHash != null && (A.pageScriptHash = String(E.pageScriptHash)), E.pageName != null && (A.pageName = String(E.pageName)), E.fragmentId != null && (A.fragmentId = String(E.fragmentId)), E.isAutoRerun != null && (A.isAutoRerun = !!E.isAutoRerun), E.cachedMessageHashes) {
      if (!Array.isArray(E.cachedMessageHashes)) throw TypeError(".ClientState.cachedMessageHashes: array expected");
      A.cachedMessageHashes = [];
      for (let g = 0; g < E.cachedMessageHashes.length; ++g) A.cachedMessageHashes[g] = String(E.cachedMessageHashes[g]);
    }
    if (E.contextInfo != null) {
      if (typeof E.contextInfo != "object") throw TypeError(".ClientState.contextInfo: object expected");
      A.contextInfo = $root.ContextInfo.fromObject(E.contextInfo);
    }
    return A;
  }, o.toObject = function(E, A) {
    A || (A = {});
    let g = {};
    if ((A.arrays || A.defaults) && (g.cachedMessageHashes = []), A.defaults && (g.queryString = "", g.widgetStates = null, g.pageScriptHash = "", g.pageName = "", g.fragmentId = "", g.isAutoRerun = !1, g.contextInfo = null), E.queryString != null && E.hasOwnProperty("queryString") && (g.queryString = E.queryString), E.widgetStates != null && E.hasOwnProperty("widgetStates") && (g.widgetStates = $root.WidgetStates.toObject(E.widgetStates, A)), E.pageScriptHash != null && E.hasOwnProperty("pageScriptHash") && (g.pageScriptHash = E.pageScriptHash), E.pageName != null && E.hasOwnProperty("pageName") && (g.pageName = E.pageName), E.fragmentId != null && E.hasOwnProperty("fragmentId") && (g.fragmentId = E.fragmentId), E.isAutoRerun != null && E.hasOwnProperty("isAutoRerun") && (g.isAutoRerun = E.isAutoRerun), E.cachedMessageHashes && E.cachedMessageHashes.length) {
      g.cachedMessageHashes = [];
      for (let e = 0; e < E.cachedMessageHashes.length; ++e) g.cachedMessageHashes[e] = E.cachedMessageHashes[e];
    }
    return E.contextInfo != null && E.hasOwnProperty("contextInfo") && (g.contextInfo = $root.ContextInfo.toObject(E.contextInfo, A)), g;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/ClientState";
  }, o;
})();
$root.WidgetStates = (() => {
  function o(E) {
    if (this.widgets = [], E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.widgets = $util.emptyArray, o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, A) {
    if (A || (A = $Writer.create()), E.widgets != null && E.widgets.length) for (let g = 0; g < E.widgets.length; ++g) $root.WidgetState.encode(E.widgets[g], A.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim();
    return A;
  }, o.decode = function(E, A, g) {
    E instanceof $Reader || (E = $Reader.create(E));
    let e = A === void 0 ? E.len : E.pos + A, t = new $root.WidgetStates();
    for (; E.pos < e; ) {
      let c = E.uint32();
      if (c === g) break;
      c >>> 3 === 1 ? (t.widgets && t.widgets.length || (t.widgets = []), t.widgets.push($root.WidgetState.decode(E, E.uint32()))) : E.skipType(c & 7);
    }
    return t;
  }, o.fromObject = function(E) {
    if (E instanceof $root.WidgetStates) return E;
    let A = new $root.WidgetStates();
    if (E.widgets) {
      if (!Array.isArray(E.widgets)) throw TypeError(".WidgetStates.widgets: array expected");
      A.widgets = [];
      for (let g = 0; g < E.widgets.length; ++g) {
        if (typeof E.widgets[g] != "object") throw TypeError(".WidgetStates.widgets: object expected");
        A.widgets[g] = $root.WidgetState.fromObject(E.widgets[g]);
      }
    }
    return A;
  }, o.toObject = function(E, A) {
    A || (A = {});
    let g = {};
    if ((A.arrays || A.defaults) && (g.widgets = []), E.widgets && E.widgets.length) {
      g.widgets = [];
      for (let e = 0; e < E.widgets.length; ++e) g.widgets[e] = $root.WidgetState.toObject(E.widgets[e], A);
    }
    return g;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/WidgetStates";
  }, o;
})();
$root.WidgetState = (() => {
  function o(A) {
    if (A) for (let g = Object.keys(A), e = 0; e < g.length; ++e) A[g[e]] != null && (this[g[e]] = A[g[e]]);
  }
  o.prototype.id = "", o.prototype.triggerValue = null, o.prototype.boolValue = null, o.prototype.doubleValue = null, o.prototype.intValue = null, o.prototype.stringValue = null, o.prototype.doubleArrayValue = null, o.prototype.intArrayValue = null, o.prototype.stringArrayValue = null, o.prototype.jsonValue = null, o.prototype.arrowValue = null, o.prototype.bytesValue = null, o.prototype.fileUploaderStateValue = null, o.prototype.stringTriggerValue = null, o.prototype.chatInputValue = null, o.prototype.jsonTriggerValue = null;
  let E;
  return Object.defineProperty(o.prototype, "value", { get: $util.oneOfGetter(E = ["triggerValue", "boolValue", "doubleValue", "intValue", "stringValue", "doubleArrayValue", "intArrayValue", "stringArrayValue", "jsonValue", "arrowValue", "bytesValue", "fileUploaderStateValue", "stringTriggerValue", "chatInputValue", "jsonTriggerValue"]), set: $util.oneOfSetter(E) }), o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    return g || (g = $Writer.create()), A.id != null && Object.hasOwnProperty.call(A, "id") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(A.id), A.triggerValue != null && Object.hasOwnProperty.call(A, "triggerValue") && g.uint32(
      /* id 2, wireType 0 =*/
      16
    ).bool(A.triggerValue), A.boolValue != null && Object.hasOwnProperty.call(A, "boolValue") && g.uint32(
      /* id 3, wireType 0 =*/
      24
    ).bool(A.boolValue), A.doubleValue != null && Object.hasOwnProperty.call(A, "doubleValue") && g.uint32(
      /* id 4, wireType 1 =*/
      33
    ).double(A.doubleValue), A.intValue != null && Object.hasOwnProperty.call(A, "intValue") && g.uint32(
      /* id 5, wireType 0 =*/
      40
    ).sint64(A.intValue), A.stringValue != null && Object.hasOwnProperty.call(A, "stringValue") && g.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(A.stringValue), A.doubleArrayValue != null && Object.hasOwnProperty.call(A, "doubleArrayValue") && $root.DoubleArray.encode(A.doubleArrayValue, g.uint32(
      /* id 7, wireType 2 =*/
      58
    ).fork()).ldelim(), A.intArrayValue != null && Object.hasOwnProperty.call(A, "intArrayValue") && $root.SInt64Array.encode(A.intArrayValue, g.uint32(
      /* id 8, wireType 2 =*/
      66
    ).fork()).ldelim(), A.stringArrayValue != null && Object.hasOwnProperty.call(A, "stringArrayValue") && $root.StringArray.encode(A.stringArrayValue, g.uint32(
      /* id 9, wireType 2 =*/
      74
    ).fork()).ldelim(), A.jsonValue != null && Object.hasOwnProperty.call(A, "jsonValue") && g.uint32(
      /* id 10, wireType 2 =*/
      82
    ).string(A.jsonValue), A.arrowValue != null && Object.hasOwnProperty.call(A, "arrowValue") && $root.ArrowTable.encode(A.arrowValue, g.uint32(
      /* id 11, wireType 2 =*/
      90
    ).fork()).ldelim(), A.bytesValue != null && Object.hasOwnProperty.call(A, "bytesValue") && g.uint32(
      /* id 12, wireType 2 =*/
      98
    ).bytes(A.bytesValue), A.fileUploaderStateValue != null && Object.hasOwnProperty.call(A, "fileUploaderStateValue") && $root.FileUploaderState.encode(A.fileUploaderStateValue, g.uint32(
      /* id 13, wireType 2 =*/
      106
    ).fork()).ldelim(), A.stringTriggerValue != null && Object.hasOwnProperty.call(A, "stringTriggerValue") && $root.StringTriggerValue.encode(A.stringTriggerValue, g.uint32(
      /* id 14, wireType 2 =*/
      114
    ).fork()).ldelim(), A.chatInputValue != null && Object.hasOwnProperty.call(A, "chatInputValue") && $root.ChatInputValue.encode(A.chatInputValue, g.uint32(
      /* id 15, wireType 2 =*/
      122
    ).fork()).ldelim(), A.jsonTriggerValue != null && Object.hasOwnProperty.call(A, "jsonTriggerValue") && g.uint32(
      /* id 16, wireType 2 =*/
      130
    ).string(A.jsonTriggerValue), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader || (A = $Reader.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root.WidgetState();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.id = A.string();
          break;
        }
        case 2: {
          c.triggerValue = A.bool();
          break;
        }
        case 3: {
          c.boolValue = A.bool();
          break;
        }
        case 4: {
          c.doubleValue = A.double();
          break;
        }
        case 5: {
          c.intValue = A.sint64();
          break;
        }
        case 6: {
          c.stringValue = A.string();
          break;
        }
        case 7: {
          c.doubleArrayValue = $root.DoubleArray.decode(A, A.uint32());
          break;
        }
        case 8: {
          c.intArrayValue = $root.SInt64Array.decode(A, A.uint32());
          break;
        }
        case 9: {
          c.stringArrayValue = $root.StringArray.decode(A, A.uint32());
          break;
        }
        case 10: {
          c.jsonValue = A.string();
          break;
        }
        case 11: {
          c.arrowValue = $root.ArrowTable.decode(A, A.uint32());
          break;
        }
        case 12: {
          c.bytesValue = A.bytes();
          break;
        }
        case 13: {
          c.fileUploaderStateValue = $root.FileUploaderState.decode(A, A.uint32());
          break;
        }
        case 14: {
          c.stringTriggerValue = $root.StringTriggerValue.decode(A, A.uint32());
          break;
        }
        case 15: {
          c.chatInputValue = $root.ChatInputValue.decode(A, A.uint32());
          break;
        }
        case 16: {
          c.jsonTriggerValue = A.string();
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root.WidgetState) return A;
    let g = new $root.WidgetState();
    if (A.id != null && (g.id = String(A.id)), A.triggerValue != null && (g.triggerValue = !!A.triggerValue), A.boolValue != null && (g.boolValue = !!A.boolValue), A.doubleValue != null && (g.doubleValue = Number(A.doubleValue)), A.intValue != null && ($util.Long ? (g.intValue = $util.Long.fromValue(A.intValue)).unsigned = !1 : typeof A.intValue == "string" ? g.intValue = parseInt(A.intValue, 10) : typeof A.intValue == "number" ? g.intValue = A.intValue : typeof A.intValue == "object" && (g.intValue = new $util.LongBits(A.intValue.low >>> 0, A.intValue.high >>> 0).toNumber())), A.stringValue != null && (g.stringValue = String(A.stringValue)), A.doubleArrayValue != null) {
      if (typeof A.doubleArrayValue != "object") throw TypeError(".WidgetState.doubleArrayValue: object expected");
      g.doubleArrayValue = $root.DoubleArray.fromObject(A.doubleArrayValue);
    }
    if (A.intArrayValue != null) {
      if (typeof A.intArrayValue != "object") throw TypeError(".WidgetState.intArrayValue: object expected");
      g.intArrayValue = $root.SInt64Array.fromObject(A.intArrayValue);
    }
    if (A.stringArrayValue != null) {
      if (typeof A.stringArrayValue != "object") throw TypeError(".WidgetState.stringArrayValue: object expected");
      g.stringArrayValue = $root.StringArray.fromObject(A.stringArrayValue);
    }
    if (A.jsonValue != null && (g.jsonValue = String(A.jsonValue)), A.arrowValue != null) {
      if (typeof A.arrowValue != "object") throw TypeError(".WidgetState.arrowValue: object expected");
      g.arrowValue = $root.ArrowTable.fromObject(A.arrowValue);
    }
    if (A.bytesValue != null && (typeof A.bytesValue == "string" ? $util.base64.decode(A.bytesValue, g.bytesValue = $util.newBuffer($util.base64.length(A.bytesValue)), 0) : A.bytesValue.length >= 0 && (g.bytesValue = A.bytesValue)), A.fileUploaderStateValue != null) {
      if (typeof A.fileUploaderStateValue != "object") throw TypeError(".WidgetState.fileUploaderStateValue: object expected");
      g.fileUploaderStateValue = $root.FileUploaderState.fromObject(A.fileUploaderStateValue);
    }
    if (A.stringTriggerValue != null) {
      if (typeof A.stringTriggerValue != "object") throw TypeError(".WidgetState.stringTriggerValue: object expected");
      g.stringTriggerValue = $root.StringTriggerValue.fromObject(A.stringTriggerValue);
    }
    if (A.chatInputValue != null) {
      if (typeof A.chatInputValue != "object") throw TypeError(".WidgetState.chatInputValue: object expected");
      g.chatInputValue = $root.ChatInputValue.fromObject(A.chatInputValue);
    }
    return A.jsonTriggerValue != null && (g.jsonTriggerValue = String(A.jsonTriggerValue)), g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    return g.defaults && (e.id = ""), A.id != null && A.hasOwnProperty("id") && (e.id = A.id), A.triggerValue != null && A.hasOwnProperty("triggerValue") && (e.triggerValue = A.triggerValue, g.oneofs && (e.value = "triggerValue")), A.boolValue != null && A.hasOwnProperty("boolValue") && (e.boolValue = A.boolValue, g.oneofs && (e.value = "boolValue")), A.doubleValue != null && A.hasOwnProperty("doubleValue") && (e.doubleValue = g.json && !isFinite(A.doubleValue) ? String(A.doubleValue) : A.doubleValue, g.oneofs && (e.value = "doubleValue")), A.intValue != null && A.hasOwnProperty("intValue") && (typeof A.intValue == "number" ? e.intValue = g.longs === String ? String(A.intValue) : A.intValue : e.intValue = g.longs === String ? $util.Long.prototype.toString.call(A.intValue) : g.longs === Number ? new $util.LongBits(A.intValue.low >>> 0, A.intValue.high >>> 0).toNumber() : A.intValue, g.oneofs && (e.value = "intValue")), A.stringValue != null && A.hasOwnProperty("stringValue") && (e.stringValue = A.stringValue, g.oneofs && (e.value = "stringValue")), A.doubleArrayValue != null && A.hasOwnProperty("doubleArrayValue") && (e.doubleArrayValue = $root.DoubleArray.toObject(A.doubleArrayValue, g), g.oneofs && (e.value = "doubleArrayValue")), A.intArrayValue != null && A.hasOwnProperty("intArrayValue") && (e.intArrayValue = $root.SInt64Array.toObject(A.intArrayValue, g), g.oneofs && (e.value = "intArrayValue")), A.stringArrayValue != null && A.hasOwnProperty("stringArrayValue") && (e.stringArrayValue = $root.StringArray.toObject(A.stringArrayValue, g), g.oneofs && (e.value = "stringArrayValue")), A.jsonValue != null && A.hasOwnProperty("jsonValue") && (e.jsonValue = A.jsonValue, g.oneofs && (e.value = "jsonValue")), A.arrowValue != null && A.hasOwnProperty("arrowValue") && (e.arrowValue = $root.ArrowTable.toObject(A.arrowValue, g), g.oneofs && (e.value = "arrowValue")), A.bytesValue != null && A.hasOwnProperty("bytesValue") && (e.bytesValue = g.bytes === String ? $util.base64.encode(A.bytesValue, 0, A.bytesValue.length) : g.bytes === Array ? Array.prototype.slice.call(A.bytesValue) : A.bytesValue, g.oneofs && (e.value = "bytesValue")), A.fileUploaderStateValue != null && A.hasOwnProperty("fileUploaderStateValue") && (e.fileUploaderStateValue = $root.FileUploaderState.toObject(A.fileUploaderStateValue, g), g.oneofs && (e.value = "fileUploaderStateValue")), A.stringTriggerValue != null && A.hasOwnProperty("stringTriggerValue") && (e.stringTriggerValue = $root.StringTriggerValue.toObject(A.stringTriggerValue, g), g.oneofs && (e.value = "stringTriggerValue")), A.chatInputValue != null && A.hasOwnProperty("chatInputValue") && (e.chatInputValue = $root.ChatInputValue.toObject(A.chatInputValue, g), g.oneofs && (e.value = "chatInputValue")), A.jsonTriggerValue != null && A.hasOwnProperty("jsonTriggerValue") && (e.jsonTriggerValue = A.jsonTriggerValue, g.oneofs && (e.value = "jsonTriggerValue")), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/WidgetState";
  }, o;
})();
$root.StringArray = (() => {
  function o(E) {
    if (this.data = [], E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.data = $util.emptyArray, o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, A) {
    if (A || (A = $Writer.create()), E.data != null && E.data.length) for (let g = 0; g < E.data.length; ++g) A.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(E.data[g]);
    return A;
  }, o.decode = function(E, A, g) {
    E instanceof $Reader || (E = $Reader.create(E));
    let e = A === void 0 ? E.len : E.pos + A, t = new $root.StringArray();
    for (; E.pos < e; ) {
      let c = E.uint32();
      if (c === g) break;
      c >>> 3 === 1 ? (t.data && t.data.length || (t.data = []), t.data.push(E.string())) : E.skipType(c & 7);
    }
    return t;
  }, o.fromObject = function(E) {
    if (E instanceof $root.StringArray) return E;
    let A = new $root.StringArray();
    if (E.data) {
      if (!Array.isArray(E.data)) throw TypeError(".StringArray.data: array expected");
      A.data = [];
      for (let g = 0; g < E.data.length; ++g) A.data[g] = String(E.data[g]);
    }
    return A;
  }, o.toObject = function(E, A) {
    A || (A = {});
    let g = {};
    if ((A.arrays || A.defaults) && (g.data = []), E.data && E.data.length) {
      g.data = [];
      for (let e = 0; e < E.data.length; ++e) g.data[e] = E.data[e];
    }
    return g;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/StringArray";
  }, o;
})();
$root.DoubleArray = (() => {
  function o(E) {
    if (this.data = [], E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.data = $util.emptyArray, o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, A) {
    if (A || (A = $Writer.create()), E.data != null && E.data.length) {
      A.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork();
      for (let g = 0; g < E.data.length; ++g) A.double(E.data[g]);
      A.ldelim();
    }
    return A;
  }, o.decode = function(E, A, g) {
    E instanceof $Reader || (E = $Reader.create(E));
    let e = A === void 0 ? E.len : E.pos + A, t = new $root.DoubleArray();
    for (; E.pos < e; ) {
      let c = E.uint32();
      if (c === g) break;
      switch (c >>> 3) {
        case 1: {
          if (t.data && t.data.length || (t.data = []), (c & 7) === 2) {
            let n = E.uint32() + E.pos;
            for (; E.pos < n; ) t.data.push(E.double());
          } else t.data.push(E.double());
          break;
        }
        default:
          E.skipType(c & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(E) {
    if (E instanceof $root.DoubleArray) return E;
    let A = new $root.DoubleArray();
    if (E.data) {
      if (!Array.isArray(E.data)) throw TypeError(".DoubleArray.data: array expected");
      A.data = [];
      for (let g = 0; g < E.data.length; ++g) A.data[g] = Number(E.data[g]);
    }
    return A;
  }, o.toObject = function(E, A) {
    A || (A = {});
    let g = {};
    if ((A.arrays || A.defaults) && (g.data = []), E.data && E.data.length) {
      g.data = [];
      for (let e = 0; e < E.data.length; ++e) g.data[e] = A.json && !isFinite(E.data[e]) ? String(E.data[e]) : E.data[e];
    }
    return g;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/DoubleArray";
  }, o;
})();
$root.Int32Array = (() => {
  function o(E) {
    if (this.data = [], E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.data = $util.emptyArray, o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, A) {
    if (A || (A = $Writer.create()), E.data != null && E.data.length) {
      A.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork();
      for (let g = 0; g < E.data.length; ++g) A.int32(E.data[g]);
      A.ldelim();
    }
    return A;
  }, o.decode = function(E, A, g) {
    E instanceof $Reader || (E = $Reader.create(E));
    let e = A === void 0 ? E.len : E.pos + A, t = new $root.Int32Array();
    for (; E.pos < e; ) {
      let c = E.uint32();
      if (c === g) break;
      switch (c >>> 3) {
        case 1: {
          if (t.data && t.data.length || (t.data = []), (c & 7) === 2) {
            let n = E.uint32() + E.pos;
            for (; E.pos < n; ) t.data.push(E.int32());
          } else t.data.push(E.int32());
          break;
        }
        default:
          E.skipType(c & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(E) {
    if (E instanceof $root.Int32Array) return E;
    let A = new $root.Int32Array();
    if (E.data) {
      if (!Array.isArray(E.data)) throw TypeError(".Int32Array.data: array expected");
      A.data = [];
      for (let g = 0; g < E.data.length; ++g) A.data[g] = E.data[g] | 0;
    }
    return A;
  }, o.toObject = function(E, A) {
    A || (A = {});
    let g = {};
    if ((A.arrays || A.defaults) && (g.data = []), E.data && E.data.length) {
      g.data = [];
      for (let e = 0; e < E.data.length; ++e) g.data[e] = E.data[e];
    }
    return g;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/Int32Array";
  }, o;
})();
$root.Int64Array = (() => {
  function o(E) {
    if (this.data = [], E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.data = $util.emptyArray, o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, A) {
    if (A || (A = $Writer.create()), E.data != null && E.data.length) {
      A.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork();
      for (let g = 0; g < E.data.length; ++g) A.int64(E.data[g]);
      A.ldelim();
    }
    return A;
  }, o.decode = function(E, A, g) {
    E instanceof $Reader || (E = $Reader.create(E));
    let e = A === void 0 ? E.len : E.pos + A, t = new $root.Int64Array();
    for (; E.pos < e; ) {
      let c = E.uint32();
      if (c === g) break;
      switch (c >>> 3) {
        case 1: {
          if (t.data && t.data.length || (t.data = []), (c & 7) === 2) {
            let n = E.uint32() + E.pos;
            for (; E.pos < n; ) t.data.push(E.int64());
          } else t.data.push(E.int64());
          break;
        }
        default:
          E.skipType(c & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(E) {
    if (E instanceof $root.Int64Array) return E;
    let A = new $root.Int64Array();
    if (E.data) {
      if (!Array.isArray(E.data)) throw TypeError(".Int64Array.data: array expected");
      A.data = [];
      for (let g = 0; g < E.data.length; ++g) $util.Long ? (A.data[g] = $util.Long.fromValue(E.data[g])).unsigned = !1 : typeof E.data[g] == "string" ? A.data[g] = parseInt(E.data[g], 10) : typeof E.data[g] == "number" ? A.data[g] = E.data[g] : typeof E.data[g] == "object" && (A.data[g] = new $util.LongBits(E.data[g].low >>> 0, E.data[g].high >>> 0).toNumber());
    }
    return A;
  }, o.toObject = function(E, A) {
    A || (A = {});
    let g = {};
    if ((A.arrays || A.defaults) && (g.data = []), E.data && E.data.length) {
      g.data = [];
      for (let e = 0; e < E.data.length; ++e) typeof E.data[e] == "number" ? g.data[e] = A.longs === String ? String(E.data[e]) : E.data[e] : g.data[e] = A.longs === String ? $util.Long.prototype.toString.call(E.data[e]) : A.longs === Number ? new $util.LongBits(E.data[e].low >>> 0, E.data[e].high >>> 0).toNumber() : E.data[e];
    }
    return g;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/Int64Array";
  }, o;
})();
$root.SInt64Array = (() => {
  function o(E) {
    if (this.data = [], E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.data = $util.emptyArray, o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, A) {
    if (A || (A = $Writer.create()), E.data != null && E.data.length) {
      A.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork();
      for (let g = 0; g < E.data.length; ++g) A.sint64(E.data[g]);
      A.ldelim();
    }
    return A;
  }, o.decode = function(E, A, g) {
    E instanceof $Reader || (E = $Reader.create(E));
    let e = A === void 0 ? E.len : E.pos + A, t = new $root.SInt64Array();
    for (; E.pos < e; ) {
      let c = E.uint32();
      if (c === g) break;
      switch (c >>> 3) {
        case 1: {
          if (t.data && t.data.length || (t.data = []), (c & 7) === 2) {
            let n = E.uint32() + E.pos;
            for (; E.pos < n; ) t.data.push(E.sint64());
          } else t.data.push(E.sint64());
          break;
        }
        default:
          E.skipType(c & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(E) {
    if (E instanceof $root.SInt64Array) return E;
    let A = new $root.SInt64Array();
    if (E.data) {
      if (!Array.isArray(E.data)) throw TypeError(".SInt64Array.data: array expected");
      A.data = [];
      for (let g = 0; g < E.data.length; ++g) $util.Long ? (A.data[g] = $util.Long.fromValue(E.data[g])).unsigned = !1 : typeof E.data[g] == "string" ? A.data[g] = parseInt(E.data[g], 10) : typeof E.data[g] == "number" ? A.data[g] = E.data[g] : typeof E.data[g] == "object" && (A.data[g] = new $util.LongBits(E.data[g].low >>> 0, E.data[g].high >>> 0).toNumber());
    }
    return A;
  }, o.toObject = function(E, A) {
    A || (A = {});
    let g = {};
    if ((A.arrays || A.defaults) && (g.data = []), E.data && E.data.length) {
      g.data = [];
      for (let e = 0; e < E.data.length; ++e) typeof E.data[e] == "number" ? g.data[e] = A.longs === String ? String(E.data[e]) : E.data[e] : g.data[e] = A.longs === String ? $util.Long.prototype.toString.call(E.data[e]) : A.longs === Number ? new $util.LongBits(E.data[e].low >>> 0, E.data[e].high >>> 0).toNumber() : E.data[e];
    }
    return g;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/SInt64Array";
  }, o;
})();
$root.UInt32Array = (() => {
  function o(E) {
    if (this.data = [], E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.data = $util.emptyArray, o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, A) {
    if (A || (A = $Writer.create()), E.data != null && E.data.length) {
      A.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork();
      for (let g = 0; g < E.data.length; ++g) A.uint32(E.data[g]);
      A.ldelim();
    }
    return A;
  }, o.decode = function(E, A, g) {
    E instanceof $Reader || (E = $Reader.create(E));
    let e = A === void 0 ? E.len : E.pos + A, t = new $root.UInt32Array();
    for (; E.pos < e; ) {
      let c = E.uint32();
      if (c === g) break;
      switch (c >>> 3) {
        case 1: {
          if (t.data && t.data.length || (t.data = []), (c & 7) === 2) {
            let n = E.uint32() + E.pos;
            for (; E.pos < n; ) t.data.push(E.uint32());
          } else t.data.push(E.uint32());
          break;
        }
        default:
          E.skipType(c & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(E) {
    if (E instanceof $root.UInt32Array) return E;
    let A = new $root.UInt32Array();
    if (E.data) {
      if (!Array.isArray(E.data)) throw TypeError(".UInt32Array.data: array expected");
      A.data = [];
      for (let g = 0; g < E.data.length; ++g) A.data[g] = E.data[g] >>> 0;
    }
    return A;
  }, o.toObject = function(E, A) {
    A || (A = {});
    let g = {};
    if ((A.arrays || A.defaults) && (g.data = []), E.data && E.data.length) {
      g.data = [];
      for (let e = 0; e < E.data.length; ++e) g.data[e] = E.data[e];
    }
    return g;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/UInt32Array";
  }, o;
})();
$root.StringTriggerValue = (() => {
  function o(A) {
    if (A) for (let g = Object.keys(A), e = 0; e < g.length; ++e) A[g[e]] != null && (this[g[e]] = A[g[e]]);
  }
  o.prototype.data = null;
  let E;
  return Object.defineProperty(o.prototype, "_data", { get: $util.oneOfGetter(E = ["data"]), set: $util.oneOfSetter(E) }), o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    return g || (g = $Writer.create()), A.data != null && Object.hasOwnProperty.call(A, "data") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(A.data), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader || (A = $Reader.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root.StringTriggerValue();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      n >>> 3 === 1 ? c.data = A.string() : A.skipType(n & 7);
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root.StringTriggerValue) return A;
    let g = new $root.StringTriggerValue();
    return A.data != null && (g.data = String(A.data)), g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    return A.data != null && A.hasOwnProperty("data") && (e.data = A.data, g.oneofs && (e._data = "data")), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/StringTriggerValue";
  }, o;
})();
$root.FileURLsRequest = (() => {
  function o(E) {
    if (this.fileNames = [], E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.requestId = "", o.prototype.fileNames = $util.emptyArray, o.prototype.sessionId = "", o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, A) {
    if (A || (A = $Writer.create()), E.requestId != null && Object.hasOwnProperty.call(E, "requestId") && A.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(E.requestId), E.fileNames != null && E.fileNames.length) for (let g = 0; g < E.fileNames.length; ++g) A.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(E.fileNames[g]);
    return E.sessionId != null && Object.hasOwnProperty.call(E, "sessionId") && A.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(E.sessionId), A;
  }, o.decode = function(E, A, g) {
    E instanceof $Reader || (E = $Reader.create(E));
    let e = A === void 0 ? E.len : E.pos + A, t = new $root.FileURLsRequest();
    for (; E.pos < e; ) {
      let c = E.uint32();
      if (c === g) break;
      switch (c >>> 3) {
        case 1: {
          t.requestId = E.string();
          break;
        }
        case 2: {
          t.fileNames && t.fileNames.length || (t.fileNames = []), t.fileNames.push(E.string());
          break;
        }
        case 3: {
          t.sessionId = E.string();
          break;
        }
        default:
          E.skipType(c & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(E) {
    if (E instanceof $root.FileURLsRequest) return E;
    let A = new $root.FileURLsRequest();
    if (E.requestId != null && (A.requestId = String(E.requestId)), E.fileNames) {
      if (!Array.isArray(E.fileNames)) throw TypeError(".FileURLsRequest.fileNames: array expected");
      A.fileNames = [];
      for (let g = 0; g < E.fileNames.length; ++g) A.fileNames[g] = String(E.fileNames[g]);
    }
    return E.sessionId != null && (A.sessionId = String(E.sessionId)), A;
  }, o.toObject = function(E, A) {
    A || (A = {});
    let g = {};
    if ((A.arrays || A.defaults) && (g.fileNames = []), A.defaults && (g.requestId = "", g.sessionId = ""), E.requestId != null && E.hasOwnProperty("requestId") && (g.requestId = E.requestId), E.fileNames && E.fileNames.length) {
      g.fileNames = [];
      for (let e = 0; e < E.fileNames.length; ++e) g.fileNames[e] = E.fileNames[e];
    }
    return E.sessionId != null && E.hasOwnProperty("sessionId") && (g.sessionId = E.sessionId), g;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/FileURLsRequest";
  }, o;
})();
$root.FileURLs = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.fileId = "", o.prototype.uploadUrl = "", o.prototype.deleteUrl = "", o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, A) {
    return A || (A = $Writer.create()), E.fileId != null && Object.hasOwnProperty.call(E, "fileId") && A.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(E.fileId), E.uploadUrl != null && Object.hasOwnProperty.call(E, "uploadUrl") && A.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(E.uploadUrl), E.deleteUrl != null && Object.hasOwnProperty.call(E, "deleteUrl") && A.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(E.deleteUrl), A;
  }, o.decode = function(E, A, g) {
    E instanceof $Reader || (E = $Reader.create(E));
    let e = A === void 0 ? E.len : E.pos + A, t = new $root.FileURLs();
    for (; E.pos < e; ) {
      let c = E.uint32();
      if (c === g) break;
      switch (c >>> 3) {
        case 1: {
          t.fileId = E.string();
          break;
        }
        case 2: {
          t.uploadUrl = E.string();
          break;
        }
        case 3: {
          t.deleteUrl = E.string();
          break;
        }
        default:
          E.skipType(c & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(E) {
    if (E instanceof $root.FileURLs) return E;
    let A = new $root.FileURLs();
    return E.fileId != null && (A.fileId = String(E.fileId)), E.uploadUrl != null && (A.uploadUrl = String(E.uploadUrl)), E.deleteUrl != null && (A.deleteUrl = String(E.deleteUrl)), A;
  }, o.toObject = function(E, A) {
    A || (A = {});
    let g = {};
    return A.defaults && (g.fileId = "", g.uploadUrl = "", g.deleteUrl = ""), E.fileId != null && E.hasOwnProperty("fileId") && (g.fileId = E.fileId), E.uploadUrl != null && E.hasOwnProperty("uploadUrl") && (g.uploadUrl = E.uploadUrl), E.deleteUrl != null && E.hasOwnProperty("deleteUrl") && (g.deleteUrl = E.deleteUrl), g;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/FileURLs";
  }, o;
})();
$root.FileURLsResponse = (() => {
  function o(E) {
    if (this.fileUrls = [], E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.responseId = "", o.prototype.fileUrls = $util.emptyArray, o.prototype.errorMsg = "", o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, A) {
    if (A || (A = $Writer.create()), E.responseId != null && Object.hasOwnProperty.call(E, "responseId") && A.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(E.responseId), E.fileUrls != null && E.fileUrls.length) for (let g = 0; g < E.fileUrls.length; ++g) $root.FileURLs.encode(E.fileUrls[g], A.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim();
    return E.errorMsg != null && Object.hasOwnProperty.call(E, "errorMsg") && A.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(E.errorMsg), A;
  }, o.decode = function(E, A, g) {
    E instanceof $Reader || (E = $Reader.create(E));
    let e = A === void 0 ? E.len : E.pos + A, t = new $root.FileURLsResponse();
    for (; E.pos < e; ) {
      let c = E.uint32();
      if (c === g) break;
      switch (c >>> 3) {
        case 1: {
          t.responseId = E.string();
          break;
        }
        case 2: {
          t.fileUrls && t.fileUrls.length || (t.fileUrls = []), t.fileUrls.push($root.FileURLs.decode(E, E.uint32()));
          break;
        }
        case 3: {
          t.errorMsg = E.string();
          break;
        }
        default:
          E.skipType(c & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(E) {
    if (E instanceof $root.FileURLsResponse) return E;
    let A = new $root.FileURLsResponse();
    if (E.responseId != null && (A.responseId = String(E.responseId)), E.fileUrls) {
      if (!Array.isArray(E.fileUrls)) throw TypeError(".FileURLsResponse.fileUrls: array expected");
      A.fileUrls = [];
      for (let g = 0; g < E.fileUrls.length; ++g) {
        if (typeof E.fileUrls[g] != "object") throw TypeError(".FileURLsResponse.fileUrls: object expected");
        A.fileUrls[g] = $root.FileURLs.fromObject(E.fileUrls[g]);
      }
    }
    return E.errorMsg != null && (A.errorMsg = String(E.errorMsg)), A;
  }, o.toObject = function(E, A) {
    A || (A = {});
    let g = {};
    if ((A.arrays || A.defaults) && (g.fileUrls = []), A.defaults && (g.responseId = "", g.errorMsg = ""), E.responseId != null && E.hasOwnProperty("responseId") && (g.responseId = E.responseId), E.fileUrls && E.fileUrls.length) {
      g.fileUrls = [];
      for (let e = 0; e < E.fileUrls.length; ++e) g.fileUrls[e] = $root.FileURLs.toObject(E.fileUrls[e], A);
    }
    return E.errorMsg != null && E.hasOwnProperty("errorMsg") && (g.errorMsg = E.errorMsg), g;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/FileURLsResponse";
  }, o;
})();
$root.UploadedFileInfo = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.id = $util.Long ? $util.Long.fromBits(0, 0, !1) : 0, o.prototype.name = "", o.prototype.size = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, o.prototype.fileId = "", o.prototype.fileUrls = null, o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, A) {
    return A || (A = $Writer.create()), E.id != null && Object.hasOwnProperty.call(E, "id") && A.uint32(
      /* id 1, wireType 0 =*/
      8
    ).sint64(E.id), E.name != null && Object.hasOwnProperty.call(E, "name") && A.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(E.name), E.size != null && Object.hasOwnProperty.call(E, "size") && A.uint32(
      /* id 3, wireType 0 =*/
      24
    ).uint64(E.size), E.fileId != null && Object.hasOwnProperty.call(E, "fileId") && A.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(E.fileId), E.fileUrls != null && Object.hasOwnProperty.call(E, "fileUrls") && $root.FileURLs.encode(E.fileUrls, A.uint32(
      /* id 5, wireType 2 =*/
      42
    ).fork()).ldelim(), A;
  }, o.decode = function(E, A, g) {
    E instanceof $Reader || (E = $Reader.create(E));
    let e = A === void 0 ? E.len : E.pos + A, t = new $root.UploadedFileInfo();
    for (; E.pos < e; ) {
      let c = E.uint32();
      if (c === g) break;
      switch (c >>> 3) {
        case 1: {
          t.id = E.sint64();
          break;
        }
        case 2: {
          t.name = E.string();
          break;
        }
        case 3: {
          t.size = E.uint64();
          break;
        }
        case 4: {
          t.fileId = E.string();
          break;
        }
        case 5: {
          t.fileUrls = $root.FileURLs.decode(E, E.uint32());
          break;
        }
        default:
          E.skipType(c & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(E) {
    if (E instanceof $root.UploadedFileInfo) return E;
    let A = new $root.UploadedFileInfo();
    if (E.id != null && ($util.Long ? (A.id = $util.Long.fromValue(E.id)).unsigned = !1 : typeof E.id == "string" ? A.id = parseInt(E.id, 10) : typeof E.id == "number" ? A.id = E.id : typeof E.id == "object" && (A.id = new $util.LongBits(E.id.low >>> 0, E.id.high >>> 0).toNumber())), E.name != null && (A.name = String(E.name)), E.size != null && ($util.Long ? (A.size = $util.Long.fromValue(E.size)).unsigned = !0 : typeof E.size == "string" ? A.size = parseInt(E.size, 10) : typeof E.size == "number" ? A.size = E.size : typeof E.size == "object" && (A.size = new $util.LongBits(E.size.low >>> 0, E.size.high >>> 0).toNumber(!0))), E.fileId != null && (A.fileId = String(E.fileId)), E.fileUrls != null) {
      if (typeof E.fileUrls != "object") throw TypeError(".UploadedFileInfo.fileUrls: object expected");
      A.fileUrls = $root.FileURLs.fromObject(E.fileUrls);
    }
    return A;
  }, o.toObject = function(E, A) {
    A || (A = {});
    let g = {};
    if (A.defaults) {
      if ($util.Long) {
        let e = new $util.Long(0, 0, !1);
        g.id = A.longs === String ? e.toString() : A.longs === Number ? e.toNumber() : e;
      } else g.id = A.longs === String ? "0" : 0;
      if (g.name = "", $util.Long) {
        let e = new $util.Long(0, 0, !0);
        g.size = A.longs === String ? e.toString() : A.longs === Number ? e.toNumber() : e;
      } else g.size = A.longs === String ? "0" : 0;
      g.fileId = "", g.fileUrls = null;
    }
    return E.id != null && E.hasOwnProperty("id") && (typeof E.id == "number" ? g.id = A.longs === String ? String(E.id) : E.id : g.id = A.longs === String ? $util.Long.prototype.toString.call(E.id) : A.longs === Number ? new $util.LongBits(E.id.low >>> 0, E.id.high >>> 0).toNumber() : E.id), E.name != null && E.hasOwnProperty("name") && (g.name = E.name), E.size != null && E.hasOwnProperty("size") && (typeof E.size == "number" ? g.size = A.longs === String ? String(E.size) : E.size : g.size = A.longs === String ? $util.Long.prototype.toString.call(E.size) : A.longs === Number ? new $util.LongBits(E.size.low >>> 0, E.size.high >>> 0).toNumber(!0) : E.size), E.fileId != null && E.hasOwnProperty("fileId") && (g.fileId = E.fileId), E.fileUrls != null && E.hasOwnProperty("fileUrls") && (g.fileUrls = $root.FileURLs.toObject(E.fileUrls, A)), g;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/UploadedFileInfo";
  }, o;
})();
$root.FileUploaderState = (() => {
  function o(E) {
    if (this.uploadedFileInfo = [], E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.maxFileId = $util.Long ? $util.Long.fromBits(0, 0, !1) : 0, o.prototype.uploadedFileInfo = $util.emptyArray, o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, A) {
    if (A || (A = $Writer.create()), E.maxFileId != null && Object.hasOwnProperty.call(E, "maxFileId") && A.uint32(
      /* id 1, wireType 0 =*/
      8
    ).sint64(E.maxFileId), E.uploadedFileInfo != null && E.uploadedFileInfo.length) for (let g = 0; g < E.uploadedFileInfo.length; ++g) $root.UploadedFileInfo.encode(E.uploadedFileInfo[g], A.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim();
    return A;
  }, o.decode = function(E, A, g) {
    E instanceof $Reader || (E = $Reader.create(E));
    let e = A === void 0 ? E.len : E.pos + A, t = new $root.FileUploaderState();
    for (; E.pos < e; ) {
      let c = E.uint32();
      if (c === g) break;
      switch (c >>> 3) {
        case 1: {
          t.maxFileId = E.sint64();
          break;
        }
        case 2: {
          t.uploadedFileInfo && t.uploadedFileInfo.length || (t.uploadedFileInfo = []), t.uploadedFileInfo.push($root.UploadedFileInfo.decode(E, E.uint32()));
          break;
        }
        default:
          E.skipType(c & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(E) {
    if (E instanceof $root.FileUploaderState) return E;
    let A = new $root.FileUploaderState();
    if (E.maxFileId != null && ($util.Long ? (A.maxFileId = $util.Long.fromValue(E.maxFileId)).unsigned = !1 : typeof E.maxFileId == "string" ? A.maxFileId = parseInt(E.maxFileId, 10) : typeof E.maxFileId == "number" ? A.maxFileId = E.maxFileId : typeof E.maxFileId == "object" && (A.maxFileId = new $util.LongBits(E.maxFileId.low >>> 0, E.maxFileId.high >>> 0).toNumber())), E.uploadedFileInfo) {
      if (!Array.isArray(E.uploadedFileInfo)) throw TypeError(".FileUploaderState.uploadedFileInfo: array expected");
      A.uploadedFileInfo = [];
      for (let g = 0; g < E.uploadedFileInfo.length; ++g) {
        if (typeof E.uploadedFileInfo[g] != "object") throw TypeError(".FileUploaderState.uploadedFileInfo: object expected");
        A.uploadedFileInfo[g] = $root.UploadedFileInfo.fromObject(E.uploadedFileInfo[g]);
      }
    }
    return A;
  }, o.toObject = function(E, A) {
    A || (A = {});
    let g = {};
    if ((A.arrays || A.defaults) && (g.uploadedFileInfo = []), A.defaults) if ($util.Long) {
      let e = new $util.Long(0, 0, !1);
      g.maxFileId = A.longs === String ? e.toString() : A.longs === Number ? e.toNumber() : e;
    } else g.maxFileId = A.longs === String ? "0" : 0;
    if (E.maxFileId != null && E.hasOwnProperty("maxFileId") && (typeof E.maxFileId == "number" ? g.maxFileId = A.longs === String ? String(E.maxFileId) : E.maxFileId : g.maxFileId = A.longs === String ? $util.Long.prototype.toString.call(E.maxFileId) : A.longs === Number ? new $util.LongBits(E.maxFileId.low >>> 0, E.maxFileId.high >>> 0).toNumber() : E.maxFileId), E.uploadedFileInfo && E.uploadedFileInfo.length) {
      g.uploadedFileInfo = [];
      for (let e = 0; e < E.uploadedFileInfo.length; ++e) g.uploadedFileInfo[e] = $root.UploadedFileInfo.toObject(E.uploadedFileInfo[e], A);
    }
    return g;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/FileUploaderState";
  }, o;
})();
$root.ChatInputValue = (() => {
  function o(A) {
    if (A) for (let g = Object.keys(A), e = 0; e < g.length; ++e) A[g[e]] != null && (this[g[e]] = A[g[e]]);
  }
  o.prototype.data = null, o.prototype.fileUploaderState = null, o.prototype.audioFileInfo = null;
  let E;
  return Object.defineProperty(o.prototype, "_data", { get: $util.oneOfGetter(E = ["data"]), set: $util.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_fileUploaderState", { get: $util.oneOfGetter(E = ["fileUploaderState"]), set: $util.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_audioFileInfo", { get: $util.oneOfGetter(E = ["audioFileInfo"]), set: $util.oneOfSetter(E) }), o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    return g || (g = $Writer.create()), A.data != null && Object.hasOwnProperty.call(A, "data") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(A.data), A.fileUploaderState != null && Object.hasOwnProperty.call(A, "fileUploaderState") && $root.FileUploaderState.encode(A.fileUploaderState, g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), A.audioFileInfo != null && Object.hasOwnProperty.call(A, "audioFileInfo") && $root.UploadedFileInfo.encode(A.audioFileInfo, g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).fork()).ldelim(), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader || (A = $Reader.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root.ChatInputValue();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.data = A.string();
          break;
        }
        case 2: {
          c.fileUploaderState = $root.FileUploaderState.decode(A, A.uint32());
          break;
        }
        case 3: {
          c.audioFileInfo = $root.UploadedFileInfo.decode(A, A.uint32());
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root.ChatInputValue) return A;
    let g = new $root.ChatInputValue();
    if (A.data != null && (g.data = String(A.data)), A.fileUploaderState != null) {
      if (typeof A.fileUploaderState != "object") throw TypeError(".ChatInputValue.fileUploaderState: object expected");
      g.fileUploaderState = $root.FileUploaderState.fromObject(A.fileUploaderState);
    }
    if (A.audioFileInfo != null) {
      if (typeof A.audioFileInfo != "object") throw TypeError(".ChatInputValue.audioFileInfo: object expected");
      g.audioFileInfo = $root.UploadedFileInfo.fromObject(A.audioFileInfo);
    }
    return g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    return A.data != null && A.hasOwnProperty("data") && (e.data = A.data, g.oneofs && (e._data = "data")), A.fileUploaderState != null && A.hasOwnProperty("fileUploaderState") && (e.fileUploaderState = $root.FileUploaderState.toObject(A.fileUploaderState, g), g.oneofs && (e._fileUploaderState = "fileUploaderState")), A.audioFileInfo != null && A.hasOwnProperty("audioFileInfo") && (e.audioFileInfo = $root.UploadedFileInfo.toObject(A.audioFileInfo, g), g.oneofs && (e._audioFileInfo = "audioFileInfo")), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/ChatInputValue";
  }, o;
})();
$root.ComponentInstance = (() => {
  function o(A) {
    if (this.specialArgs = [], A) for (let g = Object.keys(A), e = 0; e < g.length; ++e) A[g[e]] != null && (this[g[e]] = A[g[e]]);
  }
  o.prototype.id = "", o.prototype.jsonArgs = "", o.prototype.specialArgs = $util.emptyArray, o.prototype.componentName = "", o.prototype.url = "", o.prototype.formId = "", o.prototype.tabIndex = null;
  let E;
  return Object.defineProperty(o.prototype, "_tabIndex", { get: $util.oneOfGetter(E = ["tabIndex"]), set: $util.oneOfSetter(E) }), o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    if (g || (g = $Writer.create()), A.id != null && Object.hasOwnProperty.call(A, "id") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(A.id), A.jsonArgs != null && Object.hasOwnProperty.call(A, "jsonArgs") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(A.jsonArgs), A.specialArgs != null && A.specialArgs.length) for (let e = 0; e < A.specialArgs.length; ++e) $root.SpecialArg.encode(A.specialArgs[e], g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).fork()).ldelim();
    return A.componentName != null && Object.hasOwnProperty.call(A, "componentName") && g.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(A.componentName), A.url != null && Object.hasOwnProperty.call(A, "url") && g.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(A.url), A.formId != null && Object.hasOwnProperty.call(A, "formId") && g.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(A.formId), A.tabIndex != null && Object.hasOwnProperty.call(A, "tabIndex") && g.uint32(
      /* id 7, wireType 0 =*/
      56
    ).int32(A.tabIndex), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader || (A = $Reader.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root.ComponentInstance();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.id = A.string();
          break;
        }
        case 2: {
          c.jsonArgs = A.string();
          break;
        }
        case 3: {
          c.specialArgs && c.specialArgs.length || (c.specialArgs = []), c.specialArgs.push($root.SpecialArg.decode(A, A.uint32()));
          break;
        }
        case 4: {
          c.componentName = A.string();
          break;
        }
        case 5: {
          c.url = A.string();
          break;
        }
        case 6: {
          c.formId = A.string();
          break;
        }
        case 7: {
          c.tabIndex = A.int32();
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root.ComponentInstance) return A;
    let g = new $root.ComponentInstance();
    if (A.id != null && (g.id = String(A.id)), A.jsonArgs != null && (g.jsonArgs = String(A.jsonArgs)), A.specialArgs) {
      if (!Array.isArray(A.specialArgs)) throw TypeError(".ComponentInstance.specialArgs: array expected");
      g.specialArgs = [];
      for (let e = 0; e < A.specialArgs.length; ++e) {
        if (typeof A.specialArgs[e] != "object") throw TypeError(".ComponentInstance.specialArgs: object expected");
        g.specialArgs[e] = $root.SpecialArg.fromObject(A.specialArgs[e]);
      }
    }
    return A.componentName != null && (g.componentName = String(A.componentName)), A.url != null && (g.url = String(A.url)), A.formId != null && (g.formId = String(A.formId)), A.tabIndex != null && (g.tabIndex = A.tabIndex | 0), g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    if ((g.arrays || g.defaults) && (e.specialArgs = []), g.defaults && (e.id = "", e.jsonArgs = "", e.componentName = "", e.url = "", e.formId = ""), A.id != null && A.hasOwnProperty("id") && (e.id = A.id), A.jsonArgs != null && A.hasOwnProperty("jsonArgs") && (e.jsonArgs = A.jsonArgs), A.specialArgs && A.specialArgs.length) {
      e.specialArgs = [];
      for (let t = 0; t < A.specialArgs.length; ++t) e.specialArgs[t] = $root.SpecialArg.toObject(A.specialArgs[t], g);
    }
    return A.componentName != null && A.hasOwnProperty("componentName") && (e.componentName = A.componentName), A.url != null && A.hasOwnProperty("url") && (e.url = A.url), A.formId != null && A.hasOwnProperty("formId") && (e.formId = A.formId), A.tabIndex != null && A.hasOwnProperty("tabIndex") && (e.tabIndex = A.tabIndex, g.oneofs && (e._tabIndex = "tabIndex")), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/ComponentInstance";
  }, o;
})();
$root.SpecialArg = (() => {
  function o(A) {
    if (A) for (let g = Object.keys(A), e = 0; e < g.length; ++e) A[g[e]] != null && (this[g[e]] = A[g[e]]);
  }
  o.prototype.key = "", o.prototype.arrowDataframe = null, o.prototype.bytes = null;
  let E;
  return Object.defineProperty(o.prototype, "value", { get: $util.oneOfGetter(E = ["arrowDataframe", "bytes"]), set: $util.oneOfSetter(E) }), o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    return g || (g = $Writer.create()), A.key != null && Object.hasOwnProperty.call(A, "key") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(A.key), A.arrowDataframe != null && Object.hasOwnProperty.call(A, "arrowDataframe") && $root.ArrowDataframe.encode(A.arrowDataframe, g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), A.bytes != null && Object.hasOwnProperty.call(A, "bytes") && g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).bytes(A.bytes), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader || (A = $Reader.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root.SpecialArg();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.key = A.string();
          break;
        }
        case 2: {
          c.arrowDataframe = $root.ArrowDataframe.decode(A, A.uint32());
          break;
        }
        case 3: {
          c.bytes = A.bytes();
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root.SpecialArg) return A;
    let g = new $root.SpecialArg();
    if (A.key != null && (g.key = String(A.key)), A.arrowDataframe != null) {
      if (typeof A.arrowDataframe != "object") throw TypeError(".SpecialArg.arrowDataframe: object expected");
      g.arrowDataframe = $root.ArrowDataframe.fromObject(A.arrowDataframe);
    }
    return A.bytes != null && (typeof A.bytes == "string" ? $util.base64.decode(A.bytes, g.bytes = $util.newBuffer($util.base64.length(A.bytes)), 0) : A.bytes.length >= 0 && (g.bytes = A.bytes)), g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    return g.defaults && (e.key = ""), A.key != null && A.hasOwnProperty("key") && (e.key = A.key), A.arrowDataframe != null && A.hasOwnProperty("arrowDataframe") && (e.arrowDataframe = $root.ArrowDataframe.toObject(A.arrowDataframe, g), g.oneofs && (e.value = "arrowDataframe")), A.bytes != null && A.hasOwnProperty("bytes") && (e.bytes = g.bytes === String ? $util.base64.encode(A.bytes, 0, A.bytes.length) : g.bytes === Array ? Array.prototype.slice.call(A.bytes) : A.bytes, g.oneofs && (e.value = "bytes")), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/SpecialArg";
  }, o;
})();
$root.ArrowDataframe = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.data = null, o.prototype.height = 0, o.prototype.width = 0, o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, A) {
    return A || (A = $Writer.create()), E.data != null && Object.hasOwnProperty.call(E, "data") && $root.ArrowTable.encode(E.data, A.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim(), E.height != null && Object.hasOwnProperty.call(E, "height") && A.uint32(
      /* id 2, wireType 0 =*/
      16
    ).uint32(E.height), E.width != null && Object.hasOwnProperty.call(E, "width") && A.uint32(
      /* id 3, wireType 0 =*/
      24
    ).uint32(E.width), A;
  }, o.decode = function(E, A, g) {
    E instanceof $Reader || (E = $Reader.create(E));
    let e = A === void 0 ? E.len : E.pos + A, t = new $root.ArrowDataframe();
    for (; E.pos < e; ) {
      let c = E.uint32();
      if (c === g) break;
      switch (c >>> 3) {
        case 1: {
          t.data = $root.ArrowTable.decode(E, E.uint32());
          break;
        }
        case 2: {
          t.height = E.uint32();
          break;
        }
        case 3: {
          t.width = E.uint32();
          break;
        }
        default:
          E.skipType(c & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(E) {
    if (E instanceof $root.ArrowDataframe) return E;
    let A = new $root.ArrowDataframe();
    if (E.data != null) {
      if (typeof E.data != "object") throw TypeError(".ArrowDataframe.data: object expected");
      A.data = $root.ArrowTable.fromObject(E.data);
    }
    return E.height != null && (A.height = E.height >>> 0), E.width != null && (A.width = E.width >>> 0), A;
  }, o.toObject = function(E, A) {
    A || (A = {});
    let g = {};
    return A.defaults && (g.data = null, g.height = 0, g.width = 0), E.data != null && E.hasOwnProperty("data") && (g.data = $root.ArrowTable.toObject(E.data, A)), E.height != null && E.hasOwnProperty("height") && (g.height = E.height), E.width != null && E.hasOwnProperty("width") && (g.width = E.width), g;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/ArrowDataframe";
  }, o;
})();
$root.ArrowTable = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.data = $util.newBuffer([]), o.prototype.index = $util.newBuffer([]), o.prototype.columns = $util.newBuffer([]), o.prototype.styler = null, o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, A) {
    return A || (A = $Writer.create()), E.data != null && Object.hasOwnProperty.call(E, "data") && A.uint32(
      /* id 1, wireType 2 =*/
      10
    ).bytes(E.data), E.index != null && Object.hasOwnProperty.call(E, "index") && A.uint32(
      /* id 2, wireType 2 =*/
      18
    ).bytes(E.index), E.columns != null && Object.hasOwnProperty.call(E, "columns") && A.uint32(
      /* id 3, wireType 2 =*/
      26
    ).bytes(E.columns), E.styler != null && Object.hasOwnProperty.call(E, "styler") && $root.ArrowTableStyler.encode(E.styler, A.uint32(
      /* id 5, wireType 2 =*/
      42
    ).fork()).ldelim(), A;
  }, o.decode = function(E, A, g) {
    E instanceof $Reader || (E = $Reader.create(E));
    let e = A === void 0 ? E.len : E.pos + A, t = new $root.ArrowTable();
    for (; E.pos < e; ) {
      let c = E.uint32();
      if (c === g) break;
      switch (c >>> 3) {
        case 1: {
          t.data = E.bytes();
          break;
        }
        case 2: {
          t.index = E.bytes();
          break;
        }
        case 3: {
          t.columns = E.bytes();
          break;
        }
        case 5: {
          t.styler = $root.ArrowTableStyler.decode(E, E.uint32());
          break;
        }
        default:
          E.skipType(c & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(E) {
    if (E instanceof $root.ArrowTable) return E;
    let A = new $root.ArrowTable();
    if (E.data != null && (typeof E.data == "string" ? $util.base64.decode(E.data, A.data = $util.newBuffer($util.base64.length(E.data)), 0) : E.data.length >= 0 && (A.data = E.data)), E.index != null && (typeof E.index == "string" ? $util.base64.decode(E.index, A.index = $util.newBuffer($util.base64.length(E.index)), 0) : E.index.length >= 0 && (A.index = E.index)), E.columns != null && (typeof E.columns == "string" ? $util.base64.decode(E.columns, A.columns = $util.newBuffer($util.base64.length(E.columns)), 0) : E.columns.length >= 0 && (A.columns = E.columns)), E.styler != null) {
      if (typeof E.styler != "object") throw TypeError(".ArrowTable.styler: object expected");
      A.styler = $root.ArrowTableStyler.fromObject(E.styler);
    }
    return A;
  }, o.toObject = function(E, A) {
    A || (A = {});
    let g = {};
    return A.defaults && (A.bytes === String ? g.data = "" : (g.data = [], A.bytes !== Array && (g.data = $util.newBuffer(g.data))), A.bytes === String ? g.index = "" : (g.index = [], A.bytes !== Array && (g.index = $util.newBuffer(g.index))), A.bytes === String ? g.columns = "" : (g.columns = [], A.bytes !== Array && (g.columns = $util.newBuffer(g.columns))), g.styler = null), E.data != null && E.hasOwnProperty("data") && (g.data = A.bytes === String ? $util.base64.encode(E.data, 0, E.data.length) : A.bytes === Array ? Array.prototype.slice.call(E.data) : E.data), E.index != null && E.hasOwnProperty("index") && (g.index = A.bytes === String ? $util.base64.encode(E.index, 0, E.index.length) : A.bytes === Array ? Array.prototype.slice.call(E.index) : E.index), E.columns != null && E.hasOwnProperty("columns") && (g.columns = A.bytes === String ? $util.base64.encode(E.columns, 0, E.columns.length) : A.bytes === Array ? Array.prototype.slice.call(E.columns) : E.columns), E.styler != null && E.hasOwnProperty("styler") && (g.styler = $root.ArrowTableStyler.toObject(E.styler, A)), g;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/ArrowTable";
  }, o;
})();
$root.ArrowTableStyler = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.uuid = "", o.prototype.caption = "", o.prototype.styles = "", o.prototype.displayValues = $util.newBuffer([]), o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, A) {
    return A || (A = $Writer.create()), E.uuid != null && Object.hasOwnProperty.call(E, "uuid") && A.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(E.uuid), E.caption != null && Object.hasOwnProperty.call(E, "caption") && A.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(E.caption), E.styles != null && Object.hasOwnProperty.call(E, "styles") && A.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(E.styles), E.displayValues != null && Object.hasOwnProperty.call(E, "displayValues") && A.uint32(
      /* id 4, wireType 2 =*/
      34
    ).bytes(E.displayValues), A;
  }, o.decode = function(E, A, g) {
    E instanceof $Reader || (E = $Reader.create(E));
    let e = A === void 0 ? E.len : E.pos + A, t = new $root.ArrowTableStyler();
    for (; E.pos < e; ) {
      let c = E.uint32();
      if (c === g) break;
      switch (c >>> 3) {
        case 1: {
          t.uuid = E.string();
          break;
        }
        case 2: {
          t.caption = E.string();
          break;
        }
        case 3: {
          t.styles = E.string();
          break;
        }
        case 4: {
          t.displayValues = E.bytes();
          break;
        }
        default:
          E.skipType(c & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(E) {
    if (E instanceof $root.ArrowTableStyler) return E;
    let A = new $root.ArrowTableStyler();
    return E.uuid != null && (A.uuid = String(E.uuid)), E.caption != null && (A.caption = String(E.caption)), E.styles != null && (A.styles = String(E.styles)), E.displayValues != null && (typeof E.displayValues == "string" ? $util.base64.decode(E.displayValues, A.displayValues = $util.newBuffer($util.base64.length(E.displayValues)), 0) : E.displayValues.length >= 0 && (A.displayValues = E.displayValues)), A;
  }, o.toObject = function(E, A) {
    A || (A = {});
    let g = {};
    return A.defaults && (g.uuid = "", g.caption = "", g.styles = "", A.bytes === String ? g.displayValues = "" : (g.displayValues = [], A.bytes !== Array && (g.displayValues = $util.newBuffer(g.displayValues)))), E.uuid != null && E.hasOwnProperty("uuid") && (g.uuid = E.uuid), E.caption != null && E.hasOwnProperty("caption") && (g.caption = E.caption), E.styles != null && E.hasOwnProperty("styles") && (g.styles = E.styles), E.displayValues != null && E.hasOwnProperty("displayValues") && (g.displayValues = A.bytes === String ? $util.base64.encode(E.displayValues, 0, E.displayValues.length) : A.bytes === Array ? Array.prototype.slice.call(E.displayValues) : E.displayValues), g;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/ArrowTableStyler";
  }, o;
})();
$root.Balloons = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.show = !1, o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, A) {
    return A || (A = $Writer.create()), E.show != null && Object.hasOwnProperty.call(E, "show") && A.uint32(
      /* id 3, wireType 0 =*/
      24
    ).bool(E.show), A;
  }, o.decode = function(E, A, g) {
    E instanceof $Reader || (E = $Reader.create(E));
    let e = A === void 0 ? E.len : E.pos + A, t = new $root.Balloons();
    for (; E.pos < e; ) {
      let c = E.uint32();
      if (c === g) break;
      c >>> 3 === 3 ? t.show = E.bool() : E.skipType(c & 7);
    }
    return t;
  }, o.fromObject = function(E) {
    if (E instanceof $root.Balloons) return E;
    let A = new $root.Balloons();
    return E.show != null && (A.show = !!E.show), A;
  }, o.toObject = function(E, A) {
    A || (A = {});
    let g = {};
    return A.defaults && (g.show = !1), E.show != null && E.hasOwnProperty("show") && (g.show = E.show), g;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/Balloons";
  }, o;
})();
$root.MixedData = (() => {
  function o(E) {
    if (this.arrowBlobs = {}, E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.json = "", o.prototype.arrowBlobs = $util.emptyObject, o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, A) {
    if (A || (A = $Writer.create()), E.json != null && Object.hasOwnProperty.call(E, "json") && A.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(E.json), E.arrowBlobs != null && Object.hasOwnProperty.call(E, "arrowBlobs")) for (let g = Object.keys(E.arrowBlobs), e = 0; e < g.length; ++e) A.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork().uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g[e]), $root.ArrowData.encode(E.arrowBlobs[g[e]], A.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim().ldelim();
    return A;
  }, o.decode = function(E, A, g) {
    E instanceof $Reader || (E = $Reader.create(E));
    let e = A === void 0 ? E.len : E.pos + A, t = new $root.MixedData(), c, n;
    for (; E.pos < e; ) {
      let h = E.uint32();
      if (h === g) break;
      switch (h >>> 3) {
        case 1: {
          t.json = E.string();
          break;
        }
        case 2: {
          t.arrowBlobs === $util.emptyObject && (t.arrowBlobs = {});
          let d = E.uint32() + E.pos;
          for (c = "", n = null; E.pos < d; ) {
            let k = E.uint32();
            switch (k >>> 3) {
              case 1:
                c = E.string();
                break;
              case 2:
                n = $root.ArrowData.decode(E, E.uint32());
                break;
              default:
                E.skipType(k & 7);
                break;
            }
          }
          t.arrowBlobs[c] = n;
          break;
        }
        default:
          E.skipType(h & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(E) {
    if (E instanceof $root.MixedData) return E;
    let A = new $root.MixedData();
    if (E.json != null && (A.json = String(E.json)), E.arrowBlobs) {
      if (typeof E.arrowBlobs != "object") throw TypeError(".MixedData.arrowBlobs: object expected");
      A.arrowBlobs = {};
      for (let g = Object.keys(E.arrowBlobs), e = 0; e < g.length; ++e) {
        if (typeof E.arrowBlobs[g[e]] != "object") throw TypeError(".MixedData.arrowBlobs: object expected");
        A.arrowBlobs[g[e]] = $root.ArrowData.fromObject(E.arrowBlobs[g[e]]);
      }
    }
    return A;
  }, o.toObject = function(E, A) {
    A || (A = {});
    let g = {};
    (A.objects || A.defaults) && (g.arrowBlobs = {}), A.defaults && (g.json = ""), E.json != null && E.hasOwnProperty("json") && (g.json = E.json);
    let e;
    if (E.arrowBlobs && (e = Object.keys(E.arrowBlobs)).length) {
      g.arrowBlobs = {};
      for (let t = 0; t < e.length; ++t) g.arrowBlobs[e[t]] = $root.ArrowData.toObject(E.arrowBlobs[e[t]], A);
    }
    return g;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/MixedData";
  }, o;
})();
$root.BidiComponent = (() => {
  function o(A) {
    if (A) for (let g = Object.keys(A), e = 0; e < g.length; ++e) A[g[e]] != null && (this[g[e]] = A[g[e]]);
  }
  o.prototype.id = "", o.prototype.componentName = "", o.prototype.jsContent = null, o.prototype.jsSourcePath = null, o.prototype.formId = "", o.prototype.htmlContent = null, o.prototype.cssContent = null, o.prototype.cssSourcePath = null, o.prototype.isolateStyles = !1, o.prototype.json = null, o.prototype.arrowData = null, o.prototype.bytes = null, o.prototype.mixed = null;
  let E;
  return Object.defineProperty(o.prototype, "_jsContent", { get: $util.oneOfGetter(E = ["jsContent"]), set: $util.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_jsSourcePath", { get: $util.oneOfGetter(E = ["jsSourcePath"]), set: $util.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_htmlContent", { get: $util.oneOfGetter(E = ["htmlContent"]), set: $util.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_cssContent", { get: $util.oneOfGetter(E = ["cssContent"]), set: $util.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_cssSourcePath", { get: $util.oneOfGetter(E = ["cssSourcePath"]), set: $util.oneOfSetter(E) }), Object.defineProperty(o.prototype, "data", { get: $util.oneOfGetter(E = ["json", "arrowData", "bytes", "mixed"]), set: $util.oneOfSetter(E) }), o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    return g || (g = $Writer.create()), A.id != null && Object.hasOwnProperty.call(A, "id") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(A.id), A.componentName != null && Object.hasOwnProperty.call(A, "componentName") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(A.componentName), A.jsContent != null && Object.hasOwnProperty.call(A, "jsContent") && g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(A.jsContent), A.jsSourcePath != null && Object.hasOwnProperty.call(A, "jsSourcePath") && g.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(A.jsSourcePath), A.formId != null && Object.hasOwnProperty.call(A, "formId") && g.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(A.formId), A.htmlContent != null && Object.hasOwnProperty.call(A, "htmlContent") && g.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(A.htmlContent), A.cssContent != null && Object.hasOwnProperty.call(A, "cssContent") && g.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(A.cssContent), A.cssSourcePath != null && Object.hasOwnProperty.call(A, "cssSourcePath") && g.uint32(
      /* id 8, wireType 2 =*/
      66
    ).string(A.cssSourcePath), A.isolateStyles != null && Object.hasOwnProperty.call(A, "isolateStyles") && g.uint32(
      /* id 9, wireType 0 =*/
      72
    ).bool(A.isolateStyles), A.json != null && Object.hasOwnProperty.call(A, "json") && g.uint32(
      /* id 10, wireType 2 =*/
      82
    ).string(A.json), A.arrowData != null && Object.hasOwnProperty.call(A, "arrowData") && $root.ArrowData.encode(A.arrowData, g.uint32(
      /* id 11, wireType 2 =*/
      90
    ).fork()).ldelim(), A.bytes != null && Object.hasOwnProperty.call(A, "bytes") && g.uint32(
      /* id 12, wireType 2 =*/
      98
    ).bytes(A.bytes), A.mixed != null && Object.hasOwnProperty.call(A, "mixed") && $root.MixedData.encode(A.mixed, g.uint32(
      /* id 13, wireType 2 =*/
      106
    ).fork()).ldelim(), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader || (A = $Reader.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root.BidiComponent();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.id = A.string();
          break;
        }
        case 2: {
          c.componentName = A.string();
          break;
        }
        case 3: {
          c.jsContent = A.string();
          break;
        }
        case 4: {
          c.jsSourcePath = A.string();
          break;
        }
        case 5: {
          c.formId = A.string();
          break;
        }
        case 6: {
          c.htmlContent = A.string();
          break;
        }
        case 7: {
          c.cssContent = A.string();
          break;
        }
        case 8: {
          c.cssSourcePath = A.string();
          break;
        }
        case 9: {
          c.isolateStyles = A.bool();
          break;
        }
        case 10: {
          c.json = A.string();
          break;
        }
        case 11: {
          c.arrowData = $root.ArrowData.decode(A, A.uint32());
          break;
        }
        case 12: {
          c.bytes = A.bytes();
          break;
        }
        case 13: {
          c.mixed = $root.MixedData.decode(A, A.uint32());
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root.BidiComponent) return A;
    let g = new $root.BidiComponent();
    if (A.id != null && (g.id = String(A.id)), A.componentName != null && (g.componentName = String(A.componentName)), A.jsContent != null && (g.jsContent = String(A.jsContent)), A.jsSourcePath != null && (g.jsSourcePath = String(A.jsSourcePath)), A.formId != null && (g.formId = String(A.formId)), A.htmlContent != null && (g.htmlContent = String(A.htmlContent)), A.cssContent != null && (g.cssContent = String(A.cssContent)), A.cssSourcePath != null && (g.cssSourcePath = String(A.cssSourcePath)), A.isolateStyles != null && (g.isolateStyles = !!A.isolateStyles), A.json != null && (g.json = String(A.json)), A.arrowData != null) {
      if (typeof A.arrowData != "object") throw TypeError(".BidiComponent.arrowData: object expected");
      g.arrowData = $root.ArrowData.fromObject(A.arrowData);
    }
    if (A.bytes != null && (typeof A.bytes == "string" ? $util.base64.decode(A.bytes, g.bytes = $util.newBuffer($util.base64.length(A.bytes)), 0) : A.bytes.length >= 0 && (g.bytes = A.bytes)), A.mixed != null) {
      if (typeof A.mixed != "object") throw TypeError(".BidiComponent.mixed: object expected");
      g.mixed = $root.MixedData.fromObject(A.mixed);
    }
    return g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    return g.defaults && (e.id = "", e.componentName = "", e.formId = "", e.isolateStyles = !1), A.id != null && A.hasOwnProperty("id") && (e.id = A.id), A.componentName != null && A.hasOwnProperty("componentName") && (e.componentName = A.componentName), A.jsContent != null && A.hasOwnProperty("jsContent") && (e.jsContent = A.jsContent, g.oneofs && (e._jsContent = "jsContent")), A.jsSourcePath != null && A.hasOwnProperty("jsSourcePath") && (e.jsSourcePath = A.jsSourcePath, g.oneofs && (e._jsSourcePath = "jsSourcePath")), A.formId != null && A.hasOwnProperty("formId") && (e.formId = A.formId), A.htmlContent != null && A.hasOwnProperty("htmlContent") && (e.htmlContent = A.htmlContent, g.oneofs && (e._htmlContent = "htmlContent")), A.cssContent != null && A.hasOwnProperty("cssContent") && (e.cssContent = A.cssContent, g.oneofs && (e._cssContent = "cssContent")), A.cssSourcePath != null && A.hasOwnProperty("cssSourcePath") && (e.cssSourcePath = A.cssSourcePath, g.oneofs && (e._cssSourcePath = "cssSourcePath")), A.isolateStyles != null && A.hasOwnProperty("isolateStyles") && (e.isolateStyles = A.isolateStyles), A.json != null && A.hasOwnProperty("json") && (e.json = A.json, g.oneofs && (e.data = "json")), A.arrowData != null && A.hasOwnProperty("arrowData") && (e.arrowData = $root.ArrowData.toObject(A.arrowData, g), g.oneofs && (e.data = "arrowData")), A.bytes != null && A.hasOwnProperty("bytes") && (e.bytes = g.bytes === String ? $util.base64.encode(A.bytes, 0, A.bytes.length) : g.bytes === Array ? Array.prototype.slice.call(A.bytes) : A.bytes, g.oneofs && (e.data = "bytes")), A.mixed != null && A.hasOwnProperty("mixed") && (e.mixed = $root.MixedData.toObject(A.mixed, g), g.oneofs && (e.data = "mixed")), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/BidiComponent";
  }, o;
})();
$root.Block = (() => {
  function o(A) {
    if (A) for (let g = Object.keys(A), e = 0; e < g.length; ++e) A[g[e]] != null && (this[g[e]] = A[g[e]]);
  }
  o.prototype.vertical = null, o.prototype.horizontal = null, o.prototype.column = null, o.prototype.expandable = null, o.prototype.form = null, o.prototype.tabContainer = null, o.prototype.tab = null, o.prototype.chatMessage = null, o.prototype.popover = null, o.prototype.dialog = null, o.prototype.flexContainer = null, o.prototype.allowEmpty = !1, o.prototype.id = null, o.prototype.heightConfig = null, o.prototype.widthConfig = null;
  let E;
  return Object.defineProperty(o.prototype, "type", { get: $util.oneOfGetter(E = ["vertical", "horizontal", "column", "expandable", "form", "tabContainer", "tab", "chatMessage", "popover", "dialog", "flexContainer"]), set: $util.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_id", { get: $util.oneOfGetter(E = ["id"]), set: $util.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_heightConfig", { get: $util.oneOfGetter(E = ["heightConfig"]), set: $util.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_widthConfig", { get: $util.oneOfGetter(E = ["widthConfig"]), set: $util.oneOfSetter(E) }), o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    return g || (g = $Writer.create()), A.vertical != null && Object.hasOwnProperty.call(A, "vertical") && $root.Block.Vertical.encode(A.vertical, g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim(), A.horizontal != null && Object.hasOwnProperty.call(A, "horizontal") && $root.Block.Horizontal.encode(A.horizontal, g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), A.column != null && Object.hasOwnProperty.call(A, "column") && $root.Block.Column.encode(A.column, g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).fork()).ldelim(), A.expandable != null && Object.hasOwnProperty.call(A, "expandable") && $root.Block.Expandable.encode(A.expandable, g.uint32(
      /* id 4, wireType 2 =*/
      34
    ).fork()).ldelim(), A.form != null && Object.hasOwnProperty.call(A, "form") && $root.Block.Form.encode(A.form, g.uint32(
      /* id 5, wireType 2 =*/
      42
    ).fork()).ldelim(), A.tabContainer != null && Object.hasOwnProperty.call(A, "tabContainer") && $root.Block.TabContainer.encode(A.tabContainer, g.uint32(
      /* id 6, wireType 2 =*/
      50
    ).fork()).ldelim(), A.tab != null && Object.hasOwnProperty.call(A, "tab") && $root.Block.Tab.encode(A.tab, g.uint32(
      /* id 7, wireType 2 =*/
      58
    ).fork()).ldelim(), A.allowEmpty != null && Object.hasOwnProperty.call(A, "allowEmpty") && g.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(A.allowEmpty), A.chatMessage != null && Object.hasOwnProperty.call(A, "chatMessage") && $root.Block.ChatMessage.encode(A.chatMessage, g.uint32(
      /* id 9, wireType 2 =*/
      74
    ).fork()).ldelim(), A.popover != null && Object.hasOwnProperty.call(A, "popover") && $root.Block.Popover.encode(A.popover, g.uint32(
      /* id 10, wireType 2 =*/
      82
    ).fork()).ldelim(), A.dialog != null && Object.hasOwnProperty.call(A, "dialog") && $root.Block.Dialog.encode(A.dialog, g.uint32(
      /* id 11, wireType 2 =*/
      90
    ).fork()).ldelim(), A.id != null && Object.hasOwnProperty.call(A, "id") && g.uint32(
      /* id 12, wireType 2 =*/
      98
    ).string(A.id), A.flexContainer != null && Object.hasOwnProperty.call(A, "flexContainer") && $root.Block.FlexContainer.encode(A.flexContainer, g.uint32(
      /* id 13, wireType 2 =*/
      106
    ).fork()).ldelim(), A.heightConfig != null && Object.hasOwnProperty.call(A, "heightConfig") && $root.streamlit.HeightConfig.encode(A.heightConfig, g.uint32(
      /* id 14, wireType 2 =*/
      114
    ).fork()).ldelim(), A.widthConfig != null && Object.hasOwnProperty.call(A, "widthConfig") && $root.streamlit.WidthConfig.encode(A.widthConfig, g.uint32(
      /* id 15, wireType 2 =*/
      122
    ).fork()).ldelim(), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader || (A = $Reader.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root.Block();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.vertical = $root.Block.Vertical.decode(A, A.uint32());
          break;
        }
        case 2: {
          c.horizontal = $root.Block.Horizontal.decode(A, A.uint32());
          break;
        }
        case 3: {
          c.column = $root.Block.Column.decode(A, A.uint32());
          break;
        }
        case 4: {
          c.expandable = $root.Block.Expandable.decode(A, A.uint32());
          break;
        }
        case 5: {
          c.form = $root.Block.Form.decode(A, A.uint32());
          break;
        }
        case 6: {
          c.tabContainer = $root.Block.TabContainer.decode(A, A.uint32());
          break;
        }
        case 7: {
          c.tab = $root.Block.Tab.decode(A, A.uint32());
          break;
        }
        case 9: {
          c.chatMessage = $root.Block.ChatMessage.decode(A, A.uint32());
          break;
        }
        case 10: {
          c.popover = $root.Block.Popover.decode(A, A.uint32());
          break;
        }
        case 11: {
          c.dialog = $root.Block.Dialog.decode(A, A.uint32());
          break;
        }
        case 13: {
          c.flexContainer = $root.Block.FlexContainer.decode(A, A.uint32());
          break;
        }
        case 8: {
          c.allowEmpty = A.bool();
          break;
        }
        case 12: {
          c.id = A.string();
          break;
        }
        case 14: {
          c.heightConfig = $root.streamlit.HeightConfig.decode(A, A.uint32());
          break;
        }
        case 15: {
          c.widthConfig = $root.streamlit.WidthConfig.decode(A, A.uint32());
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root.Block) return A;
    let g = new $root.Block();
    if (A.vertical != null) {
      if (typeof A.vertical != "object") throw TypeError(".Block.vertical: object expected");
      g.vertical = $root.Block.Vertical.fromObject(A.vertical);
    }
    if (A.horizontal != null) {
      if (typeof A.horizontal != "object") throw TypeError(".Block.horizontal: object expected");
      g.horizontal = $root.Block.Horizontal.fromObject(A.horizontal);
    }
    if (A.column != null) {
      if (typeof A.column != "object") throw TypeError(".Block.column: object expected");
      g.column = $root.Block.Column.fromObject(A.column);
    }
    if (A.expandable != null) {
      if (typeof A.expandable != "object") throw TypeError(".Block.expandable: object expected");
      g.expandable = $root.Block.Expandable.fromObject(A.expandable);
    }
    if (A.form != null) {
      if (typeof A.form != "object") throw TypeError(".Block.form: object expected");
      g.form = $root.Block.Form.fromObject(A.form);
    }
    if (A.tabContainer != null) {
      if (typeof A.tabContainer != "object") throw TypeError(".Block.tabContainer: object expected");
      g.tabContainer = $root.Block.TabContainer.fromObject(A.tabContainer);
    }
    if (A.tab != null) {
      if (typeof A.tab != "object") throw TypeError(".Block.tab: object expected");
      g.tab = $root.Block.Tab.fromObject(A.tab);
    }
    if (A.chatMessage != null) {
      if (typeof A.chatMessage != "object") throw TypeError(".Block.chatMessage: object expected");
      g.chatMessage = $root.Block.ChatMessage.fromObject(A.chatMessage);
    }
    if (A.popover != null) {
      if (typeof A.popover != "object") throw TypeError(".Block.popover: object expected");
      g.popover = $root.Block.Popover.fromObject(A.popover);
    }
    if (A.dialog != null) {
      if (typeof A.dialog != "object") throw TypeError(".Block.dialog: object expected");
      g.dialog = $root.Block.Dialog.fromObject(A.dialog);
    }
    if (A.flexContainer != null) {
      if (typeof A.flexContainer != "object") throw TypeError(".Block.flexContainer: object expected");
      g.flexContainer = $root.Block.FlexContainer.fromObject(A.flexContainer);
    }
    if (A.allowEmpty != null && (g.allowEmpty = !!A.allowEmpty), A.id != null && (g.id = String(A.id)), A.heightConfig != null) {
      if (typeof A.heightConfig != "object") throw TypeError(".Block.heightConfig: object expected");
      g.heightConfig = $root.streamlit.HeightConfig.fromObject(A.heightConfig);
    }
    if (A.widthConfig != null) {
      if (typeof A.widthConfig != "object") throw TypeError(".Block.widthConfig: object expected");
      g.widthConfig = $root.streamlit.WidthConfig.fromObject(A.widthConfig);
    }
    return g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    return g.defaults && (e.allowEmpty = !1), A.vertical != null && A.hasOwnProperty("vertical") && (e.vertical = $root.Block.Vertical.toObject(A.vertical, g), g.oneofs && (e.type = "vertical")), A.horizontal != null && A.hasOwnProperty("horizontal") && (e.horizontal = $root.Block.Horizontal.toObject(A.horizontal, g), g.oneofs && (e.type = "horizontal")), A.column != null && A.hasOwnProperty("column") && (e.column = $root.Block.Column.toObject(A.column, g), g.oneofs && (e.type = "column")), A.expandable != null && A.hasOwnProperty("expandable") && (e.expandable = $root.Block.Expandable.toObject(A.expandable, g), g.oneofs && (e.type = "expandable")), A.form != null && A.hasOwnProperty("form") && (e.form = $root.Block.Form.toObject(A.form, g), g.oneofs && (e.type = "form")), A.tabContainer != null && A.hasOwnProperty("tabContainer") && (e.tabContainer = $root.Block.TabContainer.toObject(A.tabContainer, g), g.oneofs && (e.type = "tabContainer")), A.tab != null && A.hasOwnProperty("tab") && (e.tab = $root.Block.Tab.toObject(A.tab, g), g.oneofs && (e.type = "tab")), A.allowEmpty != null && A.hasOwnProperty("allowEmpty") && (e.allowEmpty = A.allowEmpty), A.chatMessage != null && A.hasOwnProperty("chatMessage") && (e.chatMessage = $root.Block.ChatMessage.toObject(A.chatMessage, g), g.oneofs && (e.type = "chatMessage")), A.popover != null && A.hasOwnProperty("popover") && (e.popover = $root.Block.Popover.toObject(A.popover, g), g.oneofs && (e.type = "popover")), A.dialog != null && A.hasOwnProperty("dialog") && (e.dialog = $root.Block.Dialog.toObject(A.dialog, g), g.oneofs && (e.type = "dialog")), A.id != null && A.hasOwnProperty("id") && (e.id = A.id, g.oneofs && (e._id = "id")), A.flexContainer != null && A.hasOwnProperty("flexContainer") && (e.flexContainer = $root.Block.FlexContainer.toObject(A.flexContainer, g), g.oneofs && (e.type = "flexContainer")), A.heightConfig != null && A.hasOwnProperty("heightConfig") && (e.heightConfig = $root.streamlit.HeightConfig.toObject(A.heightConfig, g), g.oneofs && (e._heightConfig = "heightConfig")), A.widthConfig != null && A.hasOwnProperty("widthConfig") && (e.widthConfig = $root.streamlit.WidthConfig.toObject(A.widthConfig, g), g.oneofs && (e._widthConfig = "widthConfig")), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/Block";
  }, o.Vertical = (function() {
    function A(g) {
      if (g) for (let e = Object.keys(g), t = 0; t < e.length; ++t) g[e[t]] != null && (this[e[t]] = g[e[t]]);
    }
    return A.prototype.border = !1, A.prototype.height = 0, A.create = function(g) {
      return new A(g);
    }, A.encode = function(g, e) {
      return e || (e = $Writer.create()), g.border != null && Object.hasOwnProperty.call(g, "border") && e.uint32(
        /* id 1, wireType 0 =*/
        8
      ).bool(g.border), g.height != null && Object.hasOwnProperty.call(g, "height") && e.uint32(
        /* id 2, wireType 0 =*/
        16
      ).uint32(g.height), e;
    }, A.decode = function(g, e, t) {
      g instanceof $Reader || (g = $Reader.create(g));
      let c = e === void 0 ? g.len : g.pos + e, n = new $root.Block.Vertical();
      for (; g.pos < c; ) {
        let h = g.uint32();
        if (h === t) break;
        switch (h >>> 3) {
          case 1: {
            n.border = g.bool();
            break;
          }
          case 2: {
            n.height = g.uint32();
            break;
          }
          default:
            g.skipType(h & 7);
            break;
        }
      }
      return n;
    }, A.fromObject = function(g) {
      if (g instanceof $root.Block.Vertical) return g;
      let e = new $root.Block.Vertical();
      return g.border != null && (e.border = !!g.border), g.height != null && (e.height = g.height >>> 0), e;
    }, A.toObject = function(g, e) {
      e || (e = {});
      let t = {};
      return e.defaults && (t.border = !1, t.height = 0), g.border != null && g.hasOwnProperty("border") && (t.border = g.border), g.height != null && g.hasOwnProperty("height") && (t.height = g.height), t;
    }, A.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, A.getTypeUrl = function(g) {
      return g === void 0 && (g = "type.googleapis.com"), g + "/Block.Vertical";
    }, A;
  })(), o.Horizontal = (function() {
    function A(g) {
      if (g) for (let e = Object.keys(g), t = 0; t < e.length; ++t) g[e[t]] != null && (this[e[t]] = g[e[t]]);
    }
    return A.prototype.gap = "", A.create = function(g) {
      return new A(g);
    }, A.encode = function(g, e) {
      return e || (e = $Writer.create()), g.gap != null && Object.hasOwnProperty.call(g, "gap") && e.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(g.gap), e;
    }, A.decode = function(g, e, t) {
      g instanceof $Reader || (g = $Reader.create(g));
      let c = e === void 0 ? g.len : g.pos + e, n = new $root.Block.Horizontal();
      for (; g.pos < c; ) {
        let h = g.uint32();
        if (h === t) break;
        h >>> 3 === 1 ? n.gap = g.string() : g.skipType(h & 7);
      }
      return n;
    }, A.fromObject = function(g) {
      if (g instanceof $root.Block.Horizontal) return g;
      let e = new $root.Block.Horizontal();
      return g.gap != null && (e.gap = String(g.gap)), e;
    }, A.toObject = function(g, e) {
      e || (e = {});
      let t = {};
      return e.defaults && (t.gap = ""), g.gap != null && g.hasOwnProperty("gap") && (t.gap = g.gap), t;
    }, A.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, A.getTypeUrl = function(g) {
      return g === void 0 && (g = "type.googleapis.com"), g + "/Block.Horizontal";
    }, A;
  })(), o.FlexContainer = (function() {
    function A(g) {
      if (g) for (let e = Object.keys(g), t = 0; t < e.length; ++t) g[e[t]] != null && (this[e[t]] = g[e[t]]);
    }
    return A.prototype.border = !1, A.prototype.gapConfig = null, A.prototype.scale = 0, A.prototype.direction = 0, A.prototype.wrap = !1, A.prototype.justify = 0, A.prototype.align = 0, A.create = function(g) {
      return new A(g);
    }, A.encode = function(g, e) {
      return e || (e = $Writer.create()), g.border != null && Object.hasOwnProperty.call(g, "border") && e.uint32(
        /* id 1, wireType 0 =*/
        8
      ).bool(g.border), g.gapConfig != null && Object.hasOwnProperty.call(g, "gapConfig") && $root.streamlit.GapConfig.encode(g.gapConfig, e.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), g.scale != null && Object.hasOwnProperty.call(g, "scale") && e.uint32(
        /* id 3, wireType 5 =*/
        29
      ).float(g.scale), g.direction != null && Object.hasOwnProperty.call(g, "direction") && e.uint32(
        /* id 4, wireType 0 =*/
        32
      ).int32(g.direction), g.wrap != null && Object.hasOwnProperty.call(g, "wrap") && e.uint32(
        /* id 5, wireType 0 =*/
        40
      ).bool(g.wrap), g.justify != null && Object.hasOwnProperty.call(g, "justify") && e.uint32(
        /* id 7, wireType 0 =*/
        56
      ).int32(g.justify), g.align != null && Object.hasOwnProperty.call(g, "align") && e.uint32(
        /* id 8, wireType 0 =*/
        64
      ).int32(g.align), e;
    }, A.decode = function(g, e, t) {
      g instanceof $Reader || (g = $Reader.create(g));
      let c = e === void 0 ? g.len : g.pos + e, n = new $root.Block.FlexContainer();
      for (; g.pos < c; ) {
        let h = g.uint32();
        if (h === t) break;
        switch (h >>> 3) {
          case 1: {
            n.border = g.bool();
            break;
          }
          case 2: {
            n.gapConfig = $root.streamlit.GapConfig.decode(g, g.uint32());
            break;
          }
          case 3: {
            n.scale = g.float();
            break;
          }
          case 4: {
            n.direction = g.int32();
            break;
          }
          case 5: {
            n.wrap = g.bool();
            break;
          }
          case 7: {
            n.justify = g.int32();
            break;
          }
          case 8: {
            n.align = g.int32();
            break;
          }
          default:
            g.skipType(h & 7);
            break;
        }
      }
      return n;
    }, A.fromObject = function(g) {
      if (g instanceof $root.Block.FlexContainer) return g;
      let e = new $root.Block.FlexContainer();
      if (g.border != null && (e.border = !!g.border), g.gapConfig != null) {
        if (typeof g.gapConfig != "object") throw TypeError(".Block.FlexContainer.gapConfig: object expected");
        e.gapConfig = $root.streamlit.GapConfig.fromObject(g.gapConfig);
      }
      switch (g.scale != null && (e.scale = Number(g.scale)), g.direction) {
        default:
          if (typeof g.direction == "number") {
            e.direction = g.direction;
            break;
          }
          break;
        case "DIRECTION_UNDEFINED":
        case 0:
          e.direction = 0;
          break;
        case "VERTICAL":
        case 1:
          e.direction = 1;
          break;
        case "HORIZONTAL":
        case 2:
          e.direction = 2;
          break;
      }
      switch (g.wrap != null && (e.wrap = !!g.wrap), g.justify) {
        default:
          if (typeof g.justify == "number") {
            e.justify = g.justify;
            break;
          }
          break;
        case "JUSTIFY_UNDEFINED":
        case 0:
          e.justify = 0;
          break;
        case "JUSTIFY_START":
        case 1:
          e.justify = 1;
          break;
        case "JUSTIFY_END":
        case 2:
          e.justify = 2;
          break;
        case "JUSTIFY_CENTER":
        case 3:
          e.justify = 3;
          break;
        case "SPACE_BETWEEN":
        case 4:
          e.justify = 4;
          break;
      }
      switch (g.align) {
        default:
          if (typeof g.align == "number") {
            e.align = g.align;
            break;
          }
          break;
        case "ALIGN_UNDEFINED":
        case 0:
          e.align = 0;
          break;
        case "ALIGN_START":
        case 1:
          e.align = 1;
          break;
        case "ALIGN_END":
        case 2:
          e.align = 2;
          break;
        case "ALIGN_CENTER":
        case 3:
          e.align = 3;
          break;
        case "STRETCH":
        case 4:
          e.align = 4;
          break;
      }
      return e;
    }, A.toObject = function(g, e) {
      e || (e = {});
      let t = {};
      return e.defaults && (t.border = !1, t.gapConfig = null, t.scale = 0, t.direction = e.enums === String ? "DIRECTION_UNDEFINED" : 0, t.wrap = !1, t.justify = e.enums === String ? "JUSTIFY_UNDEFINED" : 0, t.align = e.enums === String ? "ALIGN_UNDEFINED" : 0), g.border != null && g.hasOwnProperty("border") && (t.border = g.border), g.gapConfig != null && g.hasOwnProperty("gapConfig") && (t.gapConfig = $root.streamlit.GapConfig.toObject(g.gapConfig, e)), g.scale != null && g.hasOwnProperty("scale") && (t.scale = e.json && !isFinite(g.scale) ? String(g.scale) : g.scale), g.direction != null && g.hasOwnProperty("direction") && (t.direction = e.enums === String ? $root.Block.FlexContainer.Direction[g.direction] === void 0 ? g.direction : $root.Block.FlexContainer.Direction[g.direction] : g.direction), g.wrap != null && g.hasOwnProperty("wrap") && (t.wrap = g.wrap), g.justify != null && g.hasOwnProperty("justify") && (t.justify = e.enums === String ? $root.Block.FlexContainer.Justify[g.justify] === void 0 ? g.justify : $root.Block.FlexContainer.Justify[g.justify] : g.justify), g.align != null && g.hasOwnProperty("align") && (t.align = e.enums === String ? $root.Block.FlexContainer.Align[g.align] === void 0 ? g.align : $root.Block.FlexContainer.Align[g.align] : g.align), t;
    }, A.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, A.getTypeUrl = function(g) {
      return g === void 0 && (g = "type.googleapis.com"), g + "/Block.FlexContainer";
    }, A.Direction = (function() {
      const g = {}, e = Object.create(g);
      return e[g[0] = "DIRECTION_UNDEFINED"] = 0, e[g[1] = "VERTICAL"] = 1, e[g[2] = "HORIZONTAL"] = 2, e;
    })(), A.Justify = (function() {
      const g = {}, e = Object.create(g);
      return e[g[0] = "JUSTIFY_UNDEFINED"] = 0, e[g[1] = "JUSTIFY_START"] = 1, e[g[2] = "JUSTIFY_END"] = 2, e[g[3] = "JUSTIFY_CENTER"] = 3, e[g[4] = "SPACE_BETWEEN"] = 4, e;
    })(), A.Align = (function() {
      const g = {}, e = Object.create(g);
      return e[g[0] = "ALIGN_UNDEFINED"] = 0, e[g[1] = "ALIGN_START"] = 1, e[g[2] = "ALIGN_END"] = 2, e[g[3] = "ALIGN_CENTER"] = 3, e[g[4] = "STRETCH"] = 4, e;
    })(), A;
  })(), o.Column = (function() {
    function A(e) {
      if (e) for (let t = Object.keys(e), c = 0; c < t.length; ++c) e[t[c]] != null && (this[t[c]] = e[t[c]]);
    }
    A.prototype.weight = 0, A.prototype.gap = "", A.prototype.verticalAlignment = 0, A.prototype.showBorder = !1, A.prototype.gapConfig = null;
    let g;
    return Object.defineProperty(A.prototype, "_gapConfig", { get: $util.oneOfGetter(g = ["gapConfig"]), set: $util.oneOfSetter(g) }), A.create = function(e) {
      return new A(e);
    }, A.encode = function(e, t) {
      return t || (t = $Writer.create()), e.weight != null && Object.hasOwnProperty.call(e, "weight") && t.uint32(
        /* id 1, wireType 1 =*/
        9
      ).double(e.weight), e.gap != null && Object.hasOwnProperty.call(e, "gap") && t.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(e.gap), e.verticalAlignment != null && Object.hasOwnProperty.call(e, "verticalAlignment") && t.uint32(
        /* id 3, wireType 0 =*/
        24
      ).int32(e.verticalAlignment), e.showBorder != null && Object.hasOwnProperty.call(e, "showBorder") && t.uint32(
        /* id 4, wireType 0 =*/
        32
      ).bool(e.showBorder), e.gapConfig != null && Object.hasOwnProperty.call(e, "gapConfig") && $root.streamlit.GapConfig.encode(e.gapConfig, t.uint32(
        /* id 5, wireType 2 =*/
        42
      ).fork()).ldelim(), t;
    }, A.decode = function(e, t, c) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, h = new $root.Block.Column();
      for (; e.pos < n; ) {
        let d = e.uint32();
        if (d === c) break;
        switch (d >>> 3) {
          case 1: {
            h.weight = e.double();
            break;
          }
          case 2: {
            h.gap = e.string();
            break;
          }
          case 3: {
            h.verticalAlignment = e.int32();
            break;
          }
          case 4: {
            h.showBorder = e.bool();
            break;
          }
          case 5: {
            h.gapConfig = $root.streamlit.GapConfig.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(d & 7);
            break;
        }
      }
      return h;
    }, A.fromObject = function(e) {
      if (e instanceof $root.Block.Column) return e;
      let t = new $root.Block.Column();
      switch (e.weight != null && (t.weight = Number(e.weight)), e.gap != null && (t.gap = String(e.gap)), e.verticalAlignment) {
        default:
          if (typeof e.verticalAlignment == "number") {
            t.verticalAlignment = e.verticalAlignment;
            break;
          }
          break;
        case "TOP":
        case 0:
          t.verticalAlignment = 0;
          break;
        case "CENTER":
        case 1:
          t.verticalAlignment = 1;
          break;
        case "BOTTOM":
        case 2:
          t.verticalAlignment = 2;
          break;
      }
      if (e.showBorder != null && (t.showBorder = !!e.showBorder), e.gapConfig != null) {
        if (typeof e.gapConfig != "object") throw TypeError(".Block.Column.gapConfig: object expected");
        t.gapConfig = $root.streamlit.GapConfig.fromObject(e.gapConfig);
      }
      return t;
    }, A.toObject = function(e, t) {
      t || (t = {});
      let c = {};
      return t.defaults && (c.weight = 0, c.gap = "", c.verticalAlignment = t.enums === String ? "TOP" : 0, c.showBorder = !1), e.weight != null && e.hasOwnProperty("weight") && (c.weight = t.json && !isFinite(e.weight) ? String(e.weight) : e.weight), e.gap != null && e.hasOwnProperty("gap") && (c.gap = e.gap), e.verticalAlignment != null && e.hasOwnProperty("verticalAlignment") && (c.verticalAlignment = t.enums === String ? $root.Block.Column.VerticalAlignment[e.verticalAlignment] === void 0 ? e.verticalAlignment : $root.Block.Column.VerticalAlignment[e.verticalAlignment] : e.verticalAlignment), e.showBorder != null && e.hasOwnProperty("showBorder") && (c.showBorder = e.showBorder), e.gapConfig != null && e.hasOwnProperty("gapConfig") && (c.gapConfig = $root.streamlit.GapConfig.toObject(e.gapConfig, t), t.oneofs && (c._gapConfig = "gapConfig")), c;
    }, A.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, A.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/Block.Column";
    }, A.VerticalAlignment = (function() {
      const e = {}, t = Object.create(e);
      return t[e[0] = "TOP"] = 0, t[e[1] = "CENTER"] = 1, t[e[2] = "BOTTOM"] = 2, t;
    })(), A;
  })(), o.Expandable = (function() {
    function A(e) {
      if (e) for (let t = Object.keys(e), c = 0; c < t.length; ++c) e[t[c]] != null && (this[t[c]] = e[t[c]]);
    }
    A.prototype.label = "", A.prototype.expanded = null, A.prototype.icon = "";
    let g;
    return Object.defineProperty(A.prototype, "_expanded", { get: $util.oneOfGetter(g = ["expanded"]), set: $util.oneOfSetter(g) }), A.create = function(e) {
      return new A(e);
    }, A.encode = function(e, t) {
      return t || (t = $Writer.create()), e.label != null && Object.hasOwnProperty.call(e, "label") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.label), e.expanded != null && Object.hasOwnProperty.call(e, "expanded") && t.uint32(
        /* id 2, wireType 0 =*/
        16
      ).bool(e.expanded), e.icon != null && Object.hasOwnProperty.call(e, "icon") && t.uint32(
        /* id 3, wireType 2 =*/
        26
      ).string(e.icon), t;
    }, A.decode = function(e, t, c) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, h = new $root.Block.Expandable();
      for (; e.pos < n; ) {
        let d = e.uint32();
        if (d === c) break;
        switch (d >>> 3) {
          case 1: {
            h.label = e.string();
            break;
          }
          case 2: {
            h.expanded = e.bool();
            break;
          }
          case 3: {
            h.icon = e.string();
            break;
          }
          default:
            e.skipType(d & 7);
            break;
        }
      }
      return h;
    }, A.fromObject = function(e) {
      if (e instanceof $root.Block.Expandable) return e;
      let t = new $root.Block.Expandable();
      return e.label != null && (t.label = String(e.label)), e.expanded != null && (t.expanded = !!e.expanded), e.icon != null && (t.icon = String(e.icon)), t;
    }, A.toObject = function(e, t) {
      t || (t = {});
      let c = {};
      return t.defaults && (c.label = "", c.icon = ""), e.label != null && e.hasOwnProperty("label") && (c.label = e.label), e.expanded != null && e.hasOwnProperty("expanded") && (c.expanded = e.expanded, t.oneofs && (c._expanded = "expanded")), e.icon != null && e.hasOwnProperty("icon") && (c.icon = e.icon), c;
    }, A.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, A.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/Block.Expandable";
    }, A;
  })(), o.Dialog = (function() {
    function A(e) {
      if (e) for (let t = Object.keys(e), c = 0; c < t.length; ++c) e[t[c]] != null && (this[t[c]] = e[t[c]]);
    }
    A.prototype.title = "", A.prototype.dismissible = !1, A.prototype.width = 0, A.prototype.isOpen = null, A.prototype.id = "";
    let g;
    return Object.defineProperty(A.prototype, "_isOpen", { get: $util.oneOfGetter(g = ["isOpen"]), set: $util.oneOfSetter(g) }), A.create = function(e) {
      return new A(e);
    }, A.encode = function(e, t) {
      return t || (t = $Writer.create()), e.title != null && Object.hasOwnProperty.call(e, "title") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.title), e.dismissible != null && Object.hasOwnProperty.call(e, "dismissible") && t.uint32(
        /* id 2, wireType 0 =*/
        16
      ).bool(e.dismissible), e.width != null && Object.hasOwnProperty.call(e, "width") && t.uint32(
        /* id 3, wireType 0 =*/
        24
      ).int32(e.width), e.isOpen != null && Object.hasOwnProperty.call(e, "isOpen") && t.uint32(
        /* id 4, wireType 0 =*/
        32
      ).bool(e.isOpen), e.id != null && Object.hasOwnProperty.call(e, "id") && t.uint32(
        /* id 5, wireType 2 =*/
        42
      ).string(e.id), t;
    }, A.decode = function(e, t, c) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, h = new $root.Block.Dialog();
      for (; e.pos < n; ) {
        let d = e.uint32();
        if (d === c) break;
        switch (d >>> 3) {
          case 1: {
            h.title = e.string();
            break;
          }
          case 2: {
            h.dismissible = e.bool();
            break;
          }
          case 3: {
            h.width = e.int32();
            break;
          }
          case 4: {
            h.isOpen = e.bool();
            break;
          }
          case 5: {
            h.id = e.string();
            break;
          }
          default:
            e.skipType(d & 7);
            break;
        }
      }
      return h;
    }, A.fromObject = function(e) {
      if (e instanceof $root.Block.Dialog) return e;
      let t = new $root.Block.Dialog();
      switch (e.title != null && (t.title = String(e.title)), e.dismissible != null && (t.dismissible = !!e.dismissible), e.width) {
        default:
          if (typeof e.width == "number") {
            t.width = e.width;
            break;
          }
          break;
        case "SMALL":
        case 0:
          t.width = 0;
          break;
        case "LARGE":
        case 1:
          t.width = 1;
          break;
        case "MEDIUM":
        case 2:
          t.width = 2;
          break;
      }
      return e.isOpen != null && (t.isOpen = !!e.isOpen), e.id != null && (t.id = String(e.id)), t;
    }, A.toObject = function(e, t) {
      t || (t = {});
      let c = {};
      return t.defaults && (c.title = "", c.dismissible = !1, c.width = t.enums === String ? "SMALL" : 0, c.id = ""), e.title != null && e.hasOwnProperty("title") && (c.title = e.title), e.dismissible != null && e.hasOwnProperty("dismissible") && (c.dismissible = e.dismissible), e.width != null && e.hasOwnProperty("width") && (c.width = t.enums === String ? $root.Block.Dialog.DialogWidth[e.width] === void 0 ? e.width : $root.Block.Dialog.DialogWidth[e.width] : e.width), e.isOpen != null && e.hasOwnProperty("isOpen") && (c.isOpen = e.isOpen, t.oneofs && (c._isOpen = "isOpen")), e.id != null && e.hasOwnProperty("id") && (c.id = e.id), c;
    }, A.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, A.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/Block.Dialog";
    }, A.DialogWidth = (function() {
      const e = {}, t = Object.create(e);
      return t[e[0] = "SMALL"] = 0, t[e[1] = "LARGE"] = 1, t[e[2] = "MEDIUM"] = 2, t;
    })(), A;
  })(), o.Form = (function() {
    function A(g) {
      if (g) for (let e = Object.keys(g), t = 0; t < e.length; ++t) g[e[t]] != null && (this[e[t]] = g[e[t]]);
    }
    return A.prototype.formId = "", A.prototype.clearOnSubmit = !1, A.prototype.border = !1, A.prototype.enterToSubmit = !1, A.create = function(g) {
      return new A(g);
    }, A.encode = function(g, e) {
      return e || (e = $Writer.create()), g.formId != null && Object.hasOwnProperty.call(g, "formId") && e.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(g.formId), g.clearOnSubmit != null && Object.hasOwnProperty.call(g, "clearOnSubmit") && e.uint32(
        /* id 2, wireType 0 =*/
        16
      ).bool(g.clearOnSubmit), g.border != null && Object.hasOwnProperty.call(g, "border") && e.uint32(
        /* id 3, wireType 0 =*/
        24
      ).bool(g.border), g.enterToSubmit != null && Object.hasOwnProperty.call(g, "enterToSubmit") && e.uint32(
        /* id 4, wireType 0 =*/
        32
      ).bool(g.enterToSubmit), e;
    }, A.decode = function(g, e, t) {
      g instanceof $Reader || (g = $Reader.create(g));
      let c = e === void 0 ? g.len : g.pos + e, n = new $root.Block.Form();
      for (; g.pos < c; ) {
        let h = g.uint32();
        if (h === t) break;
        switch (h >>> 3) {
          case 1: {
            n.formId = g.string();
            break;
          }
          case 2: {
            n.clearOnSubmit = g.bool();
            break;
          }
          case 3: {
            n.border = g.bool();
            break;
          }
          case 4: {
            n.enterToSubmit = g.bool();
            break;
          }
          default:
            g.skipType(h & 7);
            break;
        }
      }
      return n;
    }, A.fromObject = function(g) {
      if (g instanceof $root.Block.Form) return g;
      let e = new $root.Block.Form();
      return g.formId != null && (e.formId = String(g.formId)), g.clearOnSubmit != null && (e.clearOnSubmit = !!g.clearOnSubmit), g.border != null && (e.border = !!g.border), g.enterToSubmit != null && (e.enterToSubmit = !!g.enterToSubmit), e;
    }, A.toObject = function(g, e) {
      e || (e = {});
      let t = {};
      return e.defaults && (t.formId = "", t.clearOnSubmit = !1, t.border = !1, t.enterToSubmit = !1), g.formId != null && g.hasOwnProperty("formId") && (t.formId = g.formId), g.clearOnSubmit != null && g.hasOwnProperty("clearOnSubmit") && (t.clearOnSubmit = g.clearOnSubmit), g.border != null && g.hasOwnProperty("border") && (t.border = g.border), g.enterToSubmit != null && g.hasOwnProperty("enterToSubmit") && (t.enterToSubmit = g.enterToSubmit), t;
    }, A.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, A.getTypeUrl = function(g) {
      return g === void 0 && (g = "type.googleapis.com"), g + "/Block.Form";
    }, A;
  })(), o.TabContainer = (function() {
    function A(g) {
      if (g) for (let e = Object.keys(g), t = 0; t < e.length; ++t) g[e[t]] != null && (this[e[t]] = g[e[t]]);
    }
    return A.prototype.defaultTabIndex = 0, A.create = function(g) {
      return new A(g);
    }, A.encode = function(g, e) {
      return e || (e = $Writer.create()), g.defaultTabIndex != null && Object.hasOwnProperty.call(g, "defaultTabIndex") && e.uint32(
        /* id 1, wireType 0 =*/
        8
      ).int32(g.defaultTabIndex), e;
    }, A.decode = function(g, e, t) {
      g instanceof $Reader || (g = $Reader.create(g));
      let c = e === void 0 ? g.len : g.pos + e, n = new $root.Block.TabContainer();
      for (; g.pos < c; ) {
        let h = g.uint32();
        if (h === t) break;
        h >>> 3 === 1 ? n.defaultTabIndex = g.int32() : g.skipType(h & 7);
      }
      return n;
    }, A.fromObject = function(g) {
      if (g instanceof $root.Block.TabContainer) return g;
      let e = new $root.Block.TabContainer();
      return g.defaultTabIndex != null && (e.defaultTabIndex = g.defaultTabIndex | 0), e;
    }, A.toObject = function(g, e) {
      e || (e = {});
      let t = {};
      return e.defaults && (t.defaultTabIndex = 0), g.defaultTabIndex != null && g.hasOwnProperty("defaultTabIndex") && (t.defaultTabIndex = g.defaultTabIndex), t;
    }, A.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, A.getTypeUrl = function(g) {
      return g === void 0 && (g = "type.googleapis.com"), g + "/Block.TabContainer";
    }, A;
  })(), o.Tab = (function() {
    function A(g) {
      if (g) for (let e = Object.keys(g), t = 0; t < e.length; ++t) g[e[t]] != null && (this[e[t]] = g[e[t]]);
    }
    return A.prototype.label = "", A.create = function(g) {
      return new A(g);
    }, A.encode = function(g, e) {
      return e || (e = $Writer.create()), g.label != null && Object.hasOwnProperty.call(g, "label") && e.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(g.label), e;
    }, A.decode = function(g, e, t) {
      g instanceof $Reader || (g = $Reader.create(g));
      let c = e === void 0 ? g.len : g.pos + e, n = new $root.Block.Tab();
      for (; g.pos < c; ) {
        let h = g.uint32();
        if (h === t) break;
        h >>> 3 === 1 ? n.label = g.string() : g.skipType(h & 7);
      }
      return n;
    }, A.fromObject = function(g) {
      if (g instanceof $root.Block.Tab) return g;
      let e = new $root.Block.Tab();
      return g.label != null && (e.label = String(g.label)), e;
    }, A.toObject = function(g, e) {
      e || (e = {});
      let t = {};
      return e.defaults && (t.label = ""), g.label != null && g.hasOwnProperty("label") && (t.label = g.label), t;
    }, A.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, A.getTypeUrl = function(g) {
      return g === void 0 && (g = "type.googleapis.com"), g + "/Block.Tab";
    }, A;
  })(), o.Popover = (function() {
    function A(g) {
      if (g) for (let e = Object.keys(g), t = 0; t < e.length; ++t) g[e[t]] != null && (this[e[t]] = g[e[t]]);
    }
    return A.prototype.label = "", A.prototype.useContainerWidth = !1, A.prototype.help = "", A.prototype.disabled = !1, A.prototype.icon = "", A.prototype.type = "", A.create = function(g) {
      return new A(g);
    }, A.encode = function(g, e) {
      return e || (e = $Writer.create()), g.label != null && Object.hasOwnProperty.call(g, "label") && e.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(g.label), g.useContainerWidth != null && Object.hasOwnProperty.call(g, "useContainerWidth") && e.uint32(
        /* id 2, wireType 0 =*/
        16
      ).bool(g.useContainerWidth), g.help != null && Object.hasOwnProperty.call(g, "help") && e.uint32(
        /* id 3, wireType 2 =*/
        26
      ).string(g.help), g.disabled != null && Object.hasOwnProperty.call(g, "disabled") && e.uint32(
        /* id 4, wireType 0 =*/
        32
      ).bool(g.disabled), g.icon != null && Object.hasOwnProperty.call(g, "icon") && e.uint32(
        /* id 5, wireType 2 =*/
        42
      ).string(g.icon), g.type != null && Object.hasOwnProperty.call(g, "type") && e.uint32(
        /* id 6, wireType 2 =*/
        50
      ).string(g.type), e;
    }, A.decode = function(g, e, t) {
      g instanceof $Reader || (g = $Reader.create(g));
      let c = e === void 0 ? g.len : g.pos + e, n = new $root.Block.Popover();
      for (; g.pos < c; ) {
        let h = g.uint32();
        if (h === t) break;
        switch (h >>> 3) {
          case 1: {
            n.label = g.string();
            break;
          }
          case 2: {
            n.useContainerWidth = g.bool();
            break;
          }
          case 3: {
            n.help = g.string();
            break;
          }
          case 4: {
            n.disabled = g.bool();
            break;
          }
          case 5: {
            n.icon = g.string();
            break;
          }
          case 6: {
            n.type = g.string();
            break;
          }
          default:
            g.skipType(h & 7);
            break;
        }
      }
      return n;
    }, A.fromObject = function(g) {
      if (g instanceof $root.Block.Popover) return g;
      let e = new $root.Block.Popover();
      return g.label != null && (e.label = String(g.label)), g.useContainerWidth != null && (e.useContainerWidth = !!g.useContainerWidth), g.help != null && (e.help = String(g.help)), g.disabled != null && (e.disabled = !!g.disabled), g.icon != null && (e.icon = String(g.icon)), g.type != null && (e.type = String(g.type)), e;
    }, A.toObject = function(g, e) {
      e || (e = {});
      let t = {};
      return e.defaults && (t.label = "", t.useContainerWidth = !1, t.help = "", t.disabled = !1, t.icon = "", t.type = ""), g.label != null && g.hasOwnProperty("label") && (t.label = g.label), g.useContainerWidth != null && g.hasOwnProperty("useContainerWidth") && (t.useContainerWidth = g.useContainerWidth), g.help != null && g.hasOwnProperty("help") && (t.help = g.help), g.disabled != null && g.hasOwnProperty("disabled") && (t.disabled = g.disabled), g.icon != null && g.hasOwnProperty("icon") && (t.icon = g.icon), g.type != null && g.hasOwnProperty("type") && (t.type = g.type), t;
    }, A.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, A.getTypeUrl = function(g) {
      return g === void 0 && (g = "type.googleapis.com"), g + "/Block.Popover";
    }, A;
  })(), o.ChatMessage = (function() {
    function A(g) {
      if (g) for (let e = Object.keys(g), t = 0; t < e.length; ++t) g[e[t]] != null && (this[e[t]] = g[e[t]]);
    }
    return A.prototype.name = "", A.prototype.avatar = "", A.prototype.avatarType = 0, A.create = function(g) {
      return new A(g);
    }, A.encode = function(g, e) {
      return e || (e = $Writer.create()), g.name != null && Object.hasOwnProperty.call(g, "name") && e.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(g.name), g.avatar != null && Object.hasOwnProperty.call(g, "avatar") && e.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(g.avatar), g.avatarType != null && Object.hasOwnProperty.call(g, "avatarType") && e.uint32(
        /* id 3, wireType 0 =*/
        24
      ).int32(g.avatarType), e;
    }, A.decode = function(g, e, t) {
      g instanceof $Reader || (g = $Reader.create(g));
      let c = e === void 0 ? g.len : g.pos + e, n = new $root.Block.ChatMessage();
      for (; g.pos < c; ) {
        let h = g.uint32();
        if (h === t) break;
        switch (h >>> 3) {
          case 1: {
            n.name = g.string();
            break;
          }
          case 2: {
            n.avatar = g.string();
            break;
          }
          case 3: {
            n.avatarType = g.int32();
            break;
          }
          default:
            g.skipType(h & 7);
            break;
        }
      }
      return n;
    }, A.fromObject = function(g) {
      if (g instanceof $root.Block.ChatMessage) return g;
      let e = new $root.Block.ChatMessage();
      switch (g.name != null && (e.name = String(g.name)), g.avatar != null && (e.avatar = String(g.avatar)), g.avatarType) {
        default:
          if (typeof g.avatarType == "number") {
            e.avatarType = g.avatarType;
            break;
          }
          break;
        case "IMAGE":
        case 0:
          e.avatarType = 0;
          break;
        case "EMOJI":
        case 1:
          e.avatarType = 1;
          break;
        case "ICON":
        case 2:
          e.avatarType = 2;
          break;
      }
      return e;
    }, A.toObject = function(g, e) {
      e || (e = {});
      let t = {};
      return e.defaults && (t.name = "", t.avatar = "", t.avatarType = e.enums === String ? "IMAGE" : 0), g.name != null && g.hasOwnProperty("name") && (t.name = g.name), g.avatar != null && g.hasOwnProperty("avatar") && (t.avatar = g.avatar), g.avatarType != null && g.hasOwnProperty("avatarType") && (t.avatarType = e.enums === String ? $root.Block.ChatMessage.AvatarType[g.avatarType] === void 0 ? g.avatarType : $root.Block.ChatMessage.AvatarType[g.avatarType] : g.avatarType), t;
    }, A.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, A.getTypeUrl = function(g) {
      return g === void 0 && (g = "type.googleapis.com"), g + "/Block.ChatMessage";
    }, A.AvatarType = (function() {
      const g = {}, e = Object.create(g);
      return e[g[0] = "IMAGE"] = 0, e[g[1] = "EMOJI"] = 1, e[g[2] = "ICON"] = 2, e;
    })(), A;
  })(), o;
})();
$root.BokehChart = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.figure = "", o.prototype.useContainerWidth = !1, o.prototype.elementId = "", o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, A) {
    return A || (A = $Writer.create()), E.figure != null && Object.hasOwnProperty.call(E, "figure") && A.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(E.figure), E.useContainerWidth != null && Object.hasOwnProperty.call(E, "useContainerWidth") && A.uint32(
      /* id 2, wireType 0 =*/
      16
    ).bool(E.useContainerWidth), E.elementId != null && Object.hasOwnProperty.call(E, "elementId") && A.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(E.elementId), A;
  }, o.decode = function(E, A, g) {
    E instanceof $Reader || (E = $Reader.create(E));
    let e = A === void 0 ? E.len : E.pos + A, t = new $root.BokehChart();
    for (; E.pos < e; ) {
      let c = E.uint32();
      if (c === g) break;
      switch (c >>> 3) {
        case 1: {
          t.figure = E.string();
          break;
        }
        case 2: {
          t.useContainerWidth = E.bool();
          break;
        }
        case 3: {
          t.elementId = E.string();
          break;
        }
        default:
          E.skipType(c & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(E) {
    if (E instanceof $root.BokehChart) return E;
    let A = new $root.BokehChart();
    return E.figure != null && (A.figure = String(E.figure)), E.useContainerWidth != null && (A.useContainerWidth = !!E.useContainerWidth), E.elementId != null && (A.elementId = String(E.elementId)), A;
  }, o.toObject = function(E, A) {
    A || (A = {});
    let g = {};
    return A.defaults && (g.figure = "", g.useContainerWidth = !1, g.elementId = ""), E.figure != null && E.hasOwnProperty("figure") && (g.figure = E.figure), E.useContainerWidth != null && E.hasOwnProperty("useContainerWidth") && (g.useContainerWidth = E.useContainerWidth), E.elementId != null && E.hasOwnProperty("elementId") && (g.elementId = E.elementId), g;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/BokehChart";
  }, o;
})();
$root.Button = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.id = "", o.prototype.label = "", o.prototype.default = !1, o.prototype.help = "", o.prototype.formId = "", o.prototype.isFormSubmitter = !1, o.prototype.type = "", o.prototype.disabled = !1, o.prototype.useContainerWidth = !1, o.prototype.icon = "", o.prototype.shortcut = "", o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, A) {
    return A || (A = $Writer.create()), E.id != null && Object.hasOwnProperty.call(E, "id") && A.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(E.id), E.label != null && Object.hasOwnProperty.call(E, "label") && A.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(E.label), E.default != null && Object.hasOwnProperty.call(E, "default") && A.uint32(
      /* id 3, wireType 0 =*/
      24
    ).bool(E.default), E.help != null && Object.hasOwnProperty.call(E, "help") && A.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(E.help), E.formId != null && Object.hasOwnProperty.call(E, "formId") && A.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(E.formId), E.isFormSubmitter != null && Object.hasOwnProperty.call(E, "isFormSubmitter") && A.uint32(
      /* id 6, wireType 0 =*/
      48
    ).bool(E.isFormSubmitter), E.type != null && Object.hasOwnProperty.call(E, "type") && A.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(E.type), E.disabled != null && Object.hasOwnProperty.call(E, "disabled") && A.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(E.disabled), E.useContainerWidth != null && Object.hasOwnProperty.call(E, "useContainerWidth") && A.uint32(
      /* id 9, wireType 0 =*/
      72
    ).bool(E.useContainerWidth), E.icon != null && Object.hasOwnProperty.call(E, "icon") && A.uint32(
      /* id 10, wireType 2 =*/
      82
    ).string(E.icon), E.shortcut != null && Object.hasOwnProperty.call(E, "shortcut") && A.uint32(
      /* id 11, wireType 2 =*/
      90
    ).string(E.shortcut), A;
  }, o.decode = function(E, A, g) {
    E instanceof $Reader || (E = $Reader.create(E));
    let e = A === void 0 ? E.len : E.pos + A, t = new $root.Button();
    for (; E.pos < e; ) {
      let c = E.uint32();
      if (c === g) break;
      switch (c >>> 3) {
        case 1: {
          t.id = E.string();
          break;
        }
        case 2: {
          t.label = E.string();
          break;
        }
        case 3: {
          t.default = E.bool();
          break;
        }
        case 4: {
          t.help = E.string();
          break;
        }
        case 5: {
          t.formId = E.string();
          break;
        }
        case 6: {
          t.isFormSubmitter = E.bool();
          break;
        }
        case 7: {
          t.type = E.string();
          break;
        }
        case 8: {
          t.disabled = E.bool();
          break;
        }
        case 9: {
          t.useContainerWidth = E.bool();
          break;
        }
        case 10: {
          t.icon = E.string();
          break;
        }
        case 11: {
          t.shortcut = E.string();
          break;
        }
        default:
          E.skipType(c & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(E) {
    if (E instanceof $root.Button) return E;
    let A = new $root.Button();
    return E.id != null && (A.id = String(E.id)), E.label != null && (A.label = String(E.label)), E.default != null && (A.default = !!E.default), E.help != null && (A.help = String(E.help)), E.formId != null && (A.formId = String(E.formId)), E.isFormSubmitter != null && (A.isFormSubmitter = !!E.isFormSubmitter), E.type != null && (A.type = String(E.type)), E.disabled != null && (A.disabled = !!E.disabled), E.useContainerWidth != null && (A.useContainerWidth = !!E.useContainerWidth), E.icon != null && (A.icon = String(E.icon)), E.shortcut != null && (A.shortcut = String(E.shortcut)), A;
  }, o.toObject = function(E, A) {
    A || (A = {});
    let g = {};
    return A.defaults && (g.id = "", g.label = "", g.default = !1, g.help = "", g.formId = "", g.isFormSubmitter = !1, g.type = "", g.disabled = !1, g.useContainerWidth = !1, g.icon = "", g.shortcut = ""), E.id != null && E.hasOwnProperty("id") && (g.id = E.id), E.label != null && E.hasOwnProperty("label") && (g.label = E.label), E.default != null && E.hasOwnProperty("default") && (g.default = E.default), E.help != null && E.hasOwnProperty("help") && (g.help = E.help), E.formId != null && E.hasOwnProperty("formId") && (g.formId = E.formId), E.isFormSubmitter != null && E.hasOwnProperty("isFormSubmitter") && (g.isFormSubmitter = E.isFormSubmitter), E.type != null && E.hasOwnProperty("type") && (g.type = E.type), E.disabled != null && E.hasOwnProperty("disabled") && (g.disabled = E.disabled), E.useContainerWidth != null && E.hasOwnProperty("useContainerWidth") && (g.useContainerWidth = E.useContainerWidth), E.icon != null && E.hasOwnProperty("icon") && (g.icon = E.icon), E.shortcut != null && E.hasOwnProperty("shortcut") && (g.shortcut = E.shortcut), g;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/Button";
  }, o;
})();
$root.ButtonGroup = (() => {
  function o(A) {
    if (this.options = [], this.default = [], this.value = [], A) for (let g = Object.keys(A), e = 0; e < g.length; ++e) A[g[e]] != null && (this[g[e]] = A[g[e]]);
  }
  o.prototype.id = "", o.prototype.options = $util.emptyArray, o.prototype.default = $util.emptyArray, o.prototype.disabled = !1, o.prototype.clickMode = 0, o.prototype.formId = "", o.prototype.value = $util.emptyArray, o.prototype.setValue = !1, o.prototype.selectionVisualization = 0, o.prototype.style = 0, o.prototype.label = "", o.prototype.labelVisibility = null, o.prototype.help = null;
  let E;
  return Object.defineProperty(o.prototype, "_help", { get: $util.oneOfGetter(E = ["help"]), set: $util.oneOfSetter(E) }), o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    if (g || (g = $Writer.create()), A.id != null && Object.hasOwnProperty.call(A, "id") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(A.id), A.options != null && A.options.length) for (let e = 0; e < A.options.length; ++e) $root.ButtonGroup.Option.encode(A.options[e], g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim();
    if (A.default != null && A.default.length) {
      g.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork();
      for (let e = 0; e < A.default.length; ++e) g.uint32(A.default[e]);
      g.ldelim();
    }
    if (A.disabled != null && Object.hasOwnProperty.call(A, "disabled") && g.uint32(
      /* id 4, wireType 0 =*/
      32
    ).bool(A.disabled), A.clickMode != null && Object.hasOwnProperty.call(A, "clickMode") && g.uint32(
      /* id 5, wireType 0 =*/
      40
    ).int32(A.clickMode), A.formId != null && Object.hasOwnProperty.call(A, "formId") && g.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(A.formId), A.value != null && A.value.length) {
      g.uint32(
        /* id 7, wireType 2 =*/
        58
      ).fork();
      for (let e = 0; e < A.value.length; ++e) g.uint32(A.value[e]);
      g.ldelim();
    }
    return A.setValue != null && Object.hasOwnProperty.call(A, "setValue") && g.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(A.setValue), A.selectionVisualization != null && Object.hasOwnProperty.call(A, "selectionVisualization") && g.uint32(
      /* id 9, wireType 0 =*/
      72
    ).int32(A.selectionVisualization), A.style != null && Object.hasOwnProperty.call(A, "style") && g.uint32(
      /* id 10, wireType 0 =*/
      80
    ).int32(A.style), A.label != null && Object.hasOwnProperty.call(A, "label") && g.uint32(
      /* id 11, wireType 2 =*/
      90
    ).string(A.label), A.labelVisibility != null && Object.hasOwnProperty.call(A, "labelVisibility") && $root.LabelVisibilityMessage.encode(A.labelVisibility, g.uint32(
      /* id 12, wireType 2 =*/
      98
    ).fork()).ldelim(), A.help != null && Object.hasOwnProperty.call(A, "help") && g.uint32(
      /* id 13, wireType 2 =*/
      106
    ).string(A.help), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader || (A = $Reader.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root.ButtonGroup();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.id = A.string();
          break;
        }
        case 2: {
          c.options && c.options.length || (c.options = []), c.options.push($root.ButtonGroup.Option.decode(A, A.uint32()));
          break;
        }
        case 3: {
          if (c.default && c.default.length || (c.default = []), (n & 7) === 2) {
            let h = A.uint32() + A.pos;
            for (; A.pos < h; ) c.default.push(A.uint32());
          } else c.default.push(A.uint32());
          break;
        }
        case 4: {
          c.disabled = A.bool();
          break;
        }
        case 5: {
          c.clickMode = A.int32();
          break;
        }
        case 6: {
          c.formId = A.string();
          break;
        }
        case 7: {
          if (c.value && c.value.length || (c.value = []), (n & 7) === 2) {
            let h = A.uint32() + A.pos;
            for (; A.pos < h; ) c.value.push(A.uint32());
          } else c.value.push(A.uint32());
          break;
        }
        case 8: {
          c.setValue = A.bool();
          break;
        }
        case 9: {
          c.selectionVisualization = A.int32();
          break;
        }
        case 10: {
          c.style = A.int32();
          break;
        }
        case 11: {
          c.label = A.string();
          break;
        }
        case 12: {
          c.labelVisibility = $root.LabelVisibilityMessage.decode(A, A.uint32());
          break;
        }
        case 13: {
          c.help = A.string();
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root.ButtonGroup) return A;
    let g = new $root.ButtonGroup();
    if (A.id != null && (g.id = String(A.id)), A.options) {
      if (!Array.isArray(A.options)) throw TypeError(".ButtonGroup.options: array expected");
      g.options = [];
      for (let e = 0; e < A.options.length; ++e) {
        if (typeof A.options[e] != "object") throw TypeError(".ButtonGroup.options: object expected");
        g.options[e] = $root.ButtonGroup.Option.fromObject(A.options[e]);
      }
    }
    if (A.default) {
      if (!Array.isArray(A.default)) throw TypeError(".ButtonGroup.default: array expected");
      g.default = [];
      for (let e = 0; e < A.default.length; ++e) g.default[e] = A.default[e] >>> 0;
    }
    switch (A.disabled != null && (g.disabled = !!A.disabled), A.clickMode) {
      default:
        if (typeof A.clickMode == "number") {
          g.clickMode = A.clickMode;
          break;
        }
        break;
      case "SINGLE_SELECT":
      case 0:
        g.clickMode = 0;
        break;
      case "MULTI_SELECT":
      case 1:
        g.clickMode = 1;
        break;
    }
    if (A.formId != null && (g.formId = String(A.formId)), A.value) {
      if (!Array.isArray(A.value)) throw TypeError(".ButtonGroup.value: array expected");
      g.value = [];
      for (let e = 0; e < A.value.length; ++e) g.value[e] = A.value[e] >>> 0;
    }
    switch (A.setValue != null && (g.setValue = !!A.setValue), A.selectionVisualization) {
      default:
        if (typeof A.selectionVisualization == "number") {
          g.selectionVisualization = A.selectionVisualization;
          break;
        }
        break;
      case "ONLY_SELECTED":
      case 0:
        g.selectionVisualization = 0;
        break;
      case "ALL_UP_TO_SELECTED":
      case 1:
        g.selectionVisualization = 1;
        break;
    }
    switch (A.style) {
      default:
        if (typeof A.style == "number") {
          g.style = A.style;
          break;
        }
        break;
      case "SEGMENTED_CONTROL":
      case 0:
        g.style = 0;
        break;
      case "PILLS":
      case 1:
        g.style = 1;
        break;
      case "BORDERLESS":
      case 2:
        g.style = 2;
        break;
    }
    if (A.label != null && (g.label = String(A.label)), A.labelVisibility != null) {
      if (typeof A.labelVisibility != "object") throw TypeError(".ButtonGroup.labelVisibility: object expected");
      g.labelVisibility = $root.LabelVisibilityMessage.fromObject(A.labelVisibility);
    }
    return A.help != null && (g.help = String(A.help)), g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    if ((g.arrays || g.defaults) && (e.options = [], e.default = [], e.value = []), g.defaults && (e.id = "", e.disabled = !1, e.clickMode = g.enums === String ? "SINGLE_SELECT" : 0, e.formId = "", e.setValue = !1, e.selectionVisualization = g.enums === String ? "ONLY_SELECTED" : 0, e.style = g.enums === String ? "SEGMENTED_CONTROL" : 0, e.label = "", e.labelVisibility = null), A.id != null && A.hasOwnProperty("id") && (e.id = A.id), A.options && A.options.length) {
      e.options = [];
      for (let t = 0; t < A.options.length; ++t) e.options[t] = $root.ButtonGroup.Option.toObject(A.options[t], g);
    }
    if (A.default && A.default.length) {
      e.default = [];
      for (let t = 0; t < A.default.length; ++t) e.default[t] = A.default[t];
    }
    if (A.disabled != null && A.hasOwnProperty("disabled") && (e.disabled = A.disabled), A.clickMode != null && A.hasOwnProperty("clickMode") && (e.clickMode = g.enums === String ? $root.ButtonGroup.ClickMode[A.clickMode] === void 0 ? A.clickMode : $root.ButtonGroup.ClickMode[A.clickMode] : A.clickMode), A.formId != null && A.hasOwnProperty("formId") && (e.formId = A.formId), A.value && A.value.length) {
      e.value = [];
      for (let t = 0; t < A.value.length; ++t) e.value[t] = A.value[t];
    }
    return A.setValue != null && A.hasOwnProperty("setValue") && (e.setValue = A.setValue), A.selectionVisualization != null && A.hasOwnProperty("selectionVisualization") && (e.selectionVisualization = g.enums === String ? $root.ButtonGroup.SelectionVisualization[A.selectionVisualization] === void 0 ? A.selectionVisualization : $root.ButtonGroup.SelectionVisualization[A.selectionVisualization] : A.selectionVisualization), A.style != null && A.hasOwnProperty("style") && (e.style = g.enums === String ? $root.ButtonGroup.Style[A.style] === void 0 ? A.style : $root.ButtonGroup.Style[A.style] : A.style), A.label != null && A.hasOwnProperty("label") && (e.label = A.label), A.labelVisibility != null && A.hasOwnProperty("labelVisibility") && (e.labelVisibility = $root.LabelVisibilityMessage.toObject(A.labelVisibility, g)), A.help != null && A.hasOwnProperty("help") && (e.help = A.help, g.oneofs && (e._help = "help")), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/ButtonGroup";
  }, o.ClickMode = (function() {
    const A = {}, g = Object.create(A);
    return g[A[0] = "SINGLE_SELECT"] = 0, g[A[1] = "MULTI_SELECT"] = 1, g;
  })(), o.Option = (function() {
    function A(e) {
      if (e) for (let t = Object.keys(e), c = 0; c < t.length; ++c) e[t[c]] != null && (this[t[c]] = e[t[c]]);
    }
    A.prototype.content = "", A.prototype.selectedContent = null, A.prototype.contentIcon = null, A.prototype.selectedContentIcon = null;
    let g;
    return Object.defineProperty(A.prototype, "_selectedContent", { get: $util.oneOfGetter(g = ["selectedContent"]), set: $util.oneOfSetter(g) }), Object.defineProperty(A.prototype, "_contentIcon", { get: $util.oneOfGetter(g = ["contentIcon"]), set: $util.oneOfSetter(g) }), Object.defineProperty(A.prototype, "_selectedContentIcon", { get: $util.oneOfGetter(g = ["selectedContentIcon"]), set: $util.oneOfSetter(g) }), A.create = function(e) {
      return new A(e);
    }, A.encode = function(e, t) {
      return t || (t = $Writer.create()), e.content != null && Object.hasOwnProperty.call(e, "content") && t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.content), e.selectedContent != null && Object.hasOwnProperty.call(e, "selectedContent") && t.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(e.selectedContent), e.contentIcon != null && Object.hasOwnProperty.call(e, "contentIcon") && t.uint32(
        /* id 3, wireType 2 =*/
        26
      ).string(e.contentIcon), e.selectedContentIcon != null && Object.hasOwnProperty.call(e, "selectedContentIcon") && t.uint32(
        /* id 4, wireType 2 =*/
        34
      ).string(e.selectedContentIcon), t;
    }, A.decode = function(e, t, c) {
      e instanceof $Reader || (e = $Reader.create(e));
      let n = t === void 0 ? e.len : e.pos + t, h = new $root.ButtonGroup.Option();
      for (; e.pos < n; ) {
        let d = e.uint32();
        if (d === c) break;
        switch (d >>> 3) {
          case 1: {
            h.content = e.string();
            break;
          }
          case 2: {
            h.selectedContent = e.string();
            break;
          }
          case 3: {
            h.contentIcon = e.string();
            break;
          }
          case 4: {
            h.selectedContentIcon = e.string();
            break;
          }
          default:
            e.skipType(d & 7);
            break;
        }
      }
      return h;
    }, A.fromObject = function(e) {
      if (e instanceof $root.ButtonGroup.Option) return e;
      let t = new $root.ButtonGroup.Option();
      return e.content != null && (t.content = String(e.content)), e.selectedContent != null && (t.selectedContent = String(e.selectedContent)), e.contentIcon != null && (t.contentIcon = String(e.contentIcon)), e.selectedContentIcon != null && (t.selectedContentIcon = String(e.selectedContentIcon)), t;
    }, A.toObject = function(e, t) {
      t || (t = {});
      let c = {};
      return t.defaults && (c.content = ""), e.content != null && e.hasOwnProperty("content") && (c.content = e.content), e.selectedContent != null && e.hasOwnProperty("selectedContent") && (c.selectedContent = e.selectedContent, t.oneofs && (c._selectedContent = "selectedContent")), e.contentIcon != null && e.hasOwnProperty("contentIcon") && (c.contentIcon = e.contentIcon, t.oneofs && (c._contentIcon = "contentIcon")), e.selectedContentIcon != null && e.hasOwnProperty("selectedContentIcon") && (c.selectedContentIcon = e.selectedContentIcon, t.oneofs && (c._selectedContentIcon = "selectedContentIcon")), c;
    }, A.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, A.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/ButtonGroup.Option";
    }, A;
  })(), o.SelectionVisualization = (function() {
    const A = {}, g = Object.create(A);
    return g[A[0] = "ONLY_SELECTED"] = 0, g[A[1] = "ALL_UP_TO_SELECTED"] = 1, g;
  })(), o.Style = (function() {
    const A = {}, g = Object.create(A);
    return g[A[0] = "SEGMENTED_CONTROL"] = 0, g[A[1] = "PILLS"] = 1, g[A[2] = "BORDERLESS"] = 2, g;
  })(), o;
})();
$root.CameraInput = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.id = "", o.prototype.label = "", o.prototype.help = "", o.prototype.formId = "", o.prototype.disabled = !1, o.prototype.labelVisibility = null, o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, A) {
    return A || (A = $Writer.create()), E.id != null && Object.hasOwnProperty.call(E, "id") && A.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(E.id), E.label != null && Object.hasOwnProperty.call(E, "label") && A.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(E.label), E.help != null && Object.hasOwnProperty.call(E, "help") && A.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(E.help), E.formId != null && Object.hasOwnProperty.call(E, "formId") && A.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(E.formId), E.disabled != null && Object.hasOwnProperty.call(E, "disabled") && A.uint32(
      /* id 5, wireType 0 =*/
      40
    ).bool(E.disabled), E.labelVisibility != null && Object.hasOwnProperty.call(E, "labelVisibility") && $root.LabelVisibilityMessage.encode(E.labelVisibility, A.uint32(
      /* id 6, wireType 2 =*/
      50
    ).fork()).ldelim(), A;
  }, o.decode = function(E, A, g) {
    E instanceof $Reader || (E = $Reader.create(E));
    let e = A === void 0 ? E.len : E.pos + A, t = new $root.CameraInput();
    for (; E.pos < e; ) {
      let c = E.uint32();
      if (c === g) break;
      switch (c >>> 3) {
        case 1: {
          t.id = E.string();
          break;
        }
        case 2: {
          t.label = E.string();
          break;
        }
        case 3: {
          t.help = E.string();
          break;
        }
        case 4: {
          t.formId = E.string();
          break;
        }
        case 5: {
          t.disabled = E.bool();
          break;
        }
        case 6: {
          t.labelVisibility = $root.LabelVisibilityMessage.decode(E, E.uint32());
          break;
        }
        default:
          E.skipType(c & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(E) {
    if (E instanceof $root.CameraInput) return E;
    let A = new $root.CameraInput();
    if (E.id != null && (A.id = String(E.id)), E.label != null && (A.label = String(E.label)), E.help != null && (A.help = String(E.help)), E.formId != null && (A.formId = String(E.formId)), E.disabled != null && (A.disabled = !!E.disabled), E.labelVisibility != null) {
      if (typeof E.labelVisibility != "object") throw TypeError(".CameraInput.labelVisibility: object expected");
      A.labelVisibility = $root.LabelVisibilityMessage.fromObject(E.labelVisibility);
    }
    return A;
  }, o.toObject = function(E, A) {
    A || (A = {});
    let g = {};
    return A.defaults && (g.id = "", g.label = "", g.help = "", g.formId = "", g.disabled = !1, g.labelVisibility = null), E.id != null && E.hasOwnProperty("id") && (g.id = E.id), E.label != null && E.hasOwnProperty("label") && (g.label = E.label), E.help != null && E.hasOwnProperty("help") && (g.help = E.help), E.formId != null && E.hasOwnProperty("formId") && (g.formId = E.formId), E.disabled != null && E.hasOwnProperty("disabled") && (g.disabled = E.disabled), E.labelVisibility != null && E.hasOwnProperty("labelVisibility") && (g.labelVisibility = $root.LabelVisibilityMessage.toObject(E.labelVisibility, A)), g;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/CameraInput";
  }, o;
})();
$root.ChatInput = (() => {
  function o(A) {
    if (this.fileType = [], A) for (let g = Object.keys(A), e = 0; e < g.length; ++e) A[g[e]] != null && (this[g[e]] = A[g[e]]);
  }
  o.prototype.id = "", o.prototype.placeholder = "", o.prototype.maxChars = 0, o.prototype.disabled = !1, o.prototype.value = "", o.prototype.setValue = !1, o.prototype.default = "", o.prototype.position = 0, o.prototype.acceptFile = 0, o.prototype.fileType = $util.emptyArray, o.prototype.maxUploadSizeMb = 0, o.prototype.acceptAudio = !1, o.prototype.audioSampleRate = null;
  let E;
  return Object.defineProperty(o.prototype, "_audioSampleRate", { get: $util.oneOfGetter(E = ["audioSampleRate"]), set: $util.oneOfSetter(E) }), o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    if (g || (g = $Writer.create()), A.id != null && Object.hasOwnProperty.call(A, "id") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(A.id), A.placeholder != null && Object.hasOwnProperty.call(A, "placeholder") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(A.placeholder), A.maxChars != null && Object.hasOwnProperty.call(A, "maxChars") && g.uint32(
      /* id 3, wireType 0 =*/
      24
    ).uint32(A.maxChars), A.disabled != null && Object.hasOwnProperty.call(A, "disabled") && g.uint32(
      /* id 4, wireType 0 =*/
      32
    ).bool(A.disabled), A.value != null && Object.hasOwnProperty.call(A, "value") && g.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(A.value), A.setValue != null && Object.hasOwnProperty.call(A, "setValue") && g.uint32(
      /* id 6, wireType 0 =*/
      48
    ).bool(A.setValue), A.default != null && Object.hasOwnProperty.call(A, "default") && g.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(A.default), A.position != null && Object.hasOwnProperty.call(A, "position") && g.uint32(
      /* id 8, wireType 0 =*/
      64
    ).int32(A.position), A.acceptFile != null && Object.hasOwnProperty.call(A, "acceptFile") && g.uint32(
      /* id 9, wireType 0 =*/
      72
    ).int32(A.acceptFile), A.fileType != null && A.fileType.length) for (let e = 0; e < A.fileType.length; ++e) g.uint32(
      /* id 10, wireType 2 =*/
      82
    ).string(A.fileType[e]);
    return A.maxUploadSizeMb != null && Object.hasOwnProperty.call(A, "maxUploadSizeMb") && g.uint32(
      /* id 11, wireType 0 =*/
      88
    ).int32(A.maxUploadSizeMb), A.acceptAudio != null && Object.hasOwnProperty.call(A, "acceptAudio") && g.uint32(
      /* id 12, wireType 0 =*/
      96
    ).bool(A.acceptAudio), A.audioSampleRate != null && Object.hasOwnProperty.call(A, "audioSampleRate") && g.uint32(
      /* id 13, wireType 0 =*/
      104
    ).int32(A.audioSampleRate), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader || (A = $Reader.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root.ChatInput();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.id = A.string();
          break;
        }
        case 2: {
          c.placeholder = A.string();
          break;
        }
        case 3: {
          c.maxChars = A.uint32();
          break;
        }
        case 4: {
          c.disabled = A.bool();
          break;
        }
        case 5: {
          c.value = A.string();
          break;
        }
        case 6: {
          c.setValue = A.bool();
          break;
        }
        case 7: {
          c.default = A.string();
          break;
        }
        case 8: {
          c.position = A.int32();
          break;
        }
        case 9: {
          c.acceptFile = A.int32();
          break;
        }
        case 10: {
          c.fileType && c.fileType.length || (c.fileType = []), c.fileType.push(A.string());
          break;
        }
        case 11: {
          c.maxUploadSizeMb = A.int32();
          break;
        }
        case 12: {
          c.acceptAudio = A.bool();
          break;
        }
        case 13: {
          c.audioSampleRate = A.int32();
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root.ChatInput) return A;
    let g = new $root.ChatInput();
    switch (A.id != null && (g.id = String(A.id)), A.placeholder != null && (g.placeholder = String(A.placeholder)), A.maxChars != null && (g.maxChars = A.maxChars >>> 0), A.disabled != null && (g.disabled = !!A.disabled), A.value != null && (g.value = String(A.value)), A.setValue != null && (g.setValue = !!A.setValue), A.default != null && (g.default = String(A.default)), A.position) {
      default:
        if (typeof A.position == "number") {
          g.position = A.position;
          break;
        }
        break;
      case "BOTTOM":
      case 0:
        g.position = 0;
        break;
    }
    switch (A.acceptFile) {
      default:
        if (typeof A.acceptFile == "number") {
          g.acceptFile = A.acceptFile;
          break;
        }
        break;
      case "NONE":
      case 0:
        g.acceptFile = 0;
        break;
      case "SINGLE":
      case 1:
        g.acceptFile = 1;
        break;
      case "MULTIPLE":
      case 2:
        g.acceptFile = 2;
        break;
      case "DIRECTORY":
      case 3:
        g.acceptFile = 3;
        break;
    }
    if (A.fileType) {
      if (!Array.isArray(A.fileType)) throw TypeError(".ChatInput.fileType: array expected");
      g.fileType = [];
      for (let e = 0; e < A.fileType.length; ++e) g.fileType[e] = String(A.fileType[e]);
    }
    return A.maxUploadSizeMb != null && (g.maxUploadSizeMb = A.maxUploadSizeMb | 0), A.acceptAudio != null && (g.acceptAudio = !!A.acceptAudio), A.audioSampleRate != null && (g.audioSampleRate = A.audioSampleRate | 0), g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    if ((g.arrays || g.defaults) && (e.fileType = []), g.defaults && (e.id = "", e.placeholder = "", e.maxChars = 0, e.disabled = !1, e.value = "", e.setValue = !1, e.default = "", e.position = g.enums === String ? "BOTTOM" : 0, e.acceptFile = g.enums === String ? "NONE" : 0, e.maxUploadSizeMb = 0, e.acceptAudio = !1), A.id != null && A.hasOwnProperty("id") && (e.id = A.id), A.placeholder != null && A.hasOwnProperty("placeholder") && (e.placeholder = A.placeholder), A.maxChars != null && A.hasOwnProperty("maxChars") && (e.maxChars = A.maxChars), A.disabled != null && A.hasOwnProperty("disabled") && (e.disabled = A.disabled), A.value != null && A.hasOwnProperty("value") && (e.value = A.value), A.setValue != null && A.hasOwnProperty("setValue") && (e.setValue = A.setValue), A.default != null && A.hasOwnProperty("default") && (e.default = A.default), A.position != null && A.hasOwnProperty("position") && (e.position = g.enums === String ? $root.ChatInput.Position[A.position] === void 0 ? A.position : $root.ChatInput.Position[A.position] : A.position), A.acceptFile != null && A.hasOwnProperty("acceptFile") && (e.acceptFile = g.enums === String ? $root.ChatInput.AcceptFile[A.acceptFile] === void 0 ? A.acceptFile : $root.ChatInput.AcceptFile[A.acceptFile] : A.acceptFile), A.fileType && A.fileType.length) {
      e.fileType = [];
      for (let t = 0; t < A.fileType.length; ++t) e.fileType[t] = A.fileType[t];
    }
    return A.maxUploadSizeMb != null && A.hasOwnProperty("maxUploadSizeMb") && (e.maxUploadSizeMb = A.maxUploadSizeMb), A.acceptAudio != null && A.hasOwnProperty("acceptAudio") && (e.acceptAudio = A.acceptAudio), A.audioSampleRate != null && A.hasOwnProperty("audioSampleRate") && (e.audioSampleRate = A.audioSampleRate, g.oneofs && (e._audioSampleRate = "audioSampleRate")), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/ChatInput";
  }, o.Position = (function() {
    const A = {}, g = Object.create(A);
    return g[A[0] = "BOTTOM"] = 0, g;
  })(), o.AcceptFile = (function() {
    const A = {}, g = Object.create(A);
    return g[A[0] = "NONE"] = 0, g[A[1] = "SINGLE"] = 1, g[A[2] = "MULTIPLE"] = 2, g[A[3] = "DIRECTORY"] = 3, g;
  })(), o;
})();
$root.Checkbox = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.id = "", o.prototype.label = "", o.prototype.default = !1, o.prototype.help = "", o.prototype.formId = "", o.prototype.value = !1, o.prototype.setValue = !1, o.prototype.disabled = !1, o.prototype.labelVisibility = null, o.prototype.type = 0, o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, A) {
    return A || (A = $Writer.create()), E.id != null && Object.hasOwnProperty.call(E, "id") && A.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(E.id), E.label != null && Object.hasOwnProperty.call(E, "label") && A.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(E.label), E.default != null && Object.hasOwnProperty.call(E, "default") && A.uint32(
      /* id 3, wireType 0 =*/
      24
    ).bool(E.default), E.help != null && Object.hasOwnProperty.call(E, "help") && A.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(E.help), E.formId != null && Object.hasOwnProperty.call(E, "formId") && A.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(E.formId), E.value != null && Object.hasOwnProperty.call(E, "value") && A.uint32(
      /* id 6, wireType 0 =*/
      48
    ).bool(E.value), E.setValue != null && Object.hasOwnProperty.call(E, "setValue") && A.uint32(
      /* id 7, wireType 0 =*/
      56
    ).bool(E.setValue), E.disabled != null && Object.hasOwnProperty.call(E, "disabled") && A.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(E.disabled), E.labelVisibility != null && Object.hasOwnProperty.call(E, "labelVisibility") && $root.LabelVisibilityMessage.encode(E.labelVisibility, A.uint32(
      /* id 9, wireType 2 =*/
      74
    ).fork()).ldelim(), E.type != null && Object.hasOwnProperty.call(E, "type") && A.uint32(
      /* id 10, wireType 0 =*/
      80
    ).int32(E.type), A;
  }, o.decode = function(E, A, g) {
    E instanceof $Reader || (E = $Reader.create(E));
    let e = A === void 0 ? E.len : E.pos + A, t = new $root.Checkbox();
    for (; E.pos < e; ) {
      let c = E.uint32();
      if (c === g) break;
      switch (c >>> 3) {
        case 1: {
          t.id = E.string();
          break;
        }
        case 2: {
          t.label = E.string();
          break;
        }
        case 3: {
          t.default = E.bool();
          break;
        }
        case 4: {
          t.help = E.string();
          break;
        }
        case 5: {
          t.formId = E.string();
          break;
        }
        case 6: {
          t.value = E.bool();
          break;
        }
        case 7: {
          t.setValue = E.bool();
          break;
        }
        case 8: {
          t.disabled = E.bool();
          break;
        }
        case 9: {
          t.labelVisibility = $root.LabelVisibilityMessage.decode(E, E.uint32());
          break;
        }
        case 10: {
          t.type = E.int32();
          break;
        }
        default:
          E.skipType(c & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(E) {
    if (E instanceof $root.Checkbox) return E;
    let A = new $root.Checkbox();
    if (E.id != null && (A.id = String(E.id)), E.label != null && (A.label = String(E.label)), E.default != null && (A.default = !!E.default), E.help != null && (A.help = String(E.help)), E.formId != null && (A.formId = String(E.formId)), E.value != null && (A.value = !!E.value), E.setValue != null && (A.setValue = !!E.setValue), E.disabled != null && (A.disabled = !!E.disabled), E.labelVisibility != null) {
      if (typeof E.labelVisibility != "object") throw TypeError(".Checkbox.labelVisibility: object expected");
      A.labelVisibility = $root.LabelVisibilityMessage.fromObject(E.labelVisibility);
    }
    switch (E.type) {
      default:
        if (typeof E.type == "number") {
          A.type = E.type;
          break;
        }
        break;
      case "DEFAULT":
      case 0:
        A.type = 0;
        break;
      case "TOGGLE":
      case 1:
        A.type = 1;
        break;
    }
    return A;
  }, o.toObject = function(E, A) {
    A || (A = {});
    let g = {};
    return A.defaults && (g.id = "", g.label = "", g.default = !1, g.help = "", g.formId = "", g.value = !1, g.setValue = !1, g.disabled = !1, g.labelVisibility = null, g.type = A.enums === String ? "DEFAULT" : 0), E.id != null && E.hasOwnProperty("id") && (g.id = E.id), E.label != null && E.hasOwnProperty("label") && (g.label = E.label), E.default != null && E.hasOwnProperty("default") && (g.default = E.default), E.help != null && E.hasOwnProperty("help") && (g.help = E.help), E.formId != null && E.hasOwnProperty("formId") && (g.formId = E.formId), E.value != null && E.hasOwnProperty("value") && (g.value = E.value), E.setValue != null && E.hasOwnProperty("setValue") && (g.setValue = E.setValue), E.disabled != null && E.hasOwnProperty("disabled") && (g.disabled = E.disabled), E.labelVisibility != null && E.hasOwnProperty("labelVisibility") && (g.labelVisibility = $root.LabelVisibilityMessage.toObject(E.labelVisibility, A)), E.type != null && E.hasOwnProperty("type") && (g.type = A.enums === String ? $root.Checkbox.StyleType[E.type] === void 0 ? E.type : $root.Checkbox.StyleType[E.type] : E.type), g;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/Checkbox";
  }, o.StyleType = (function() {
    const E = {}, A = Object.create(E);
    return A[E[0] = "DEFAULT"] = 0, A[E[1] = "TOGGLE"] = 1, A;
  })(), o;
})();
$root.Code = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.codeText = "", o.prototype.language = "", o.prototype.showLineNumbers = !1, o.prototype.wrapLines = !1, o.prototype.height = 0, o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, A) {
    return A || (A = $Writer.create()), E.codeText != null && Object.hasOwnProperty.call(E, "codeText") && A.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(E.codeText), E.language != null && Object.hasOwnProperty.call(E, "language") && A.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(E.language), E.showLineNumbers != null && Object.hasOwnProperty.call(E, "showLineNumbers") && A.uint32(
      /* id 3, wireType 0 =*/
      24
    ).bool(E.showLineNumbers), E.wrapLines != null && Object.hasOwnProperty.call(E, "wrapLines") && A.uint32(
      /* id 4, wireType 0 =*/
      32
    ).bool(E.wrapLines), E.height != null && Object.hasOwnProperty.call(E, "height") && A.uint32(
      /* id 5, wireType 0 =*/
      40
    ).uint32(E.height), A;
  }, o.decode = function(E, A, g) {
    E instanceof $Reader || (E = $Reader.create(E));
    let e = A === void 0 ? E.len : E.pos + A, t = new $root.Code();
    for (; E.pos < e; ) {
      let c = E.uint32();
      if (c === g) break;
      switch (c >>> 3) {
        case 1: {
          t.codeText = E.string();
          break;
        }
        case 2: {
          t.language = E.string();
          break;
        }
        case 3: {
          t.showLineNumbers = E.bool();
          break;
        }
        case 4: {
          t.wrapLines = E.bool();
          break;
        }
        case 5: {
          t.height = E.uint32();
          break;
        }
        default:
          E.skipType(c & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(E) {
    if (E instanceof $root.Code) return E;
    let A = new $root.Code();
    return E.codeText != null && (A.codeText = String(E.codeText)), E.language != null && (A.language = String(E.language)), E.showLineNumbers != null && (A.showLineNumbers = !!E.showLineNumbers), E.wrapLines != null && (A.wrapLines = !!E.wrapLines), E.height != null && (A.height = E.height >>> 0), A;
  }, o.toObject = function(E, A) {
    A || (A = {});
    let g = {};
    return A.defaults && (g.codeText = "", g.language = "", g.showLineNumbers = !1, g.wrapLines = !1, g.height = 0), E.codeText != null && E.hasOwnProperty("codeText") && (g.codeText = E.codeText), E.language != null && E.hasOwnProperty("language") && (g.language = E.language), E.showLineNumbers != null && E.hasOwnProperty("showLineNumbers") && (g.showLineNumbers = E.showLineNumbers), E.wrapLines != null && E.hasOwnProperty("wrapLines") && (g.wrapLines = E.wrapLines), E.height != null && E.hasOwnProperty("height") && (g.height = E.height), g;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/Code";
  }, o;
})();
$root.ColorPicker = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.id = "", o.prototype.label = "", o.prototype.default = "", o.prototype.help = "", o.prototype.formId = "", o.prototype.value = "", o.prototype.setValue = !1, o.prototype.disabled = !1, o.prototype.labelVisibility = null, o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, A) {
    return A || (A = $Writer.create()), E.id != null && Object.hasOwnProperty.call(E, "id") && A.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(E.id), E.label != null && Object.hasOwnProperty.call(E, "label") && A.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(E.label), E.default != null && Object.hasOwnProperty.call(E, "default") && A.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(E.default), E.help != null && Object.hasOwnProperty.call(E, "help") && A.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(E.help), E.formId != null && Object.hasOwnProperty.call(E, "formId") && A.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(E.formId), E.value != null && Object.hasOwnProperty.call(E, "value") && A.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(E.value), E.setValue != null && Object.hasOwnProperty.call(E, "setValue") && A.uint32(
      /* id 7, wireType 0 =*/
      56
    ).bool(E.setValue), E.disabled != null && Object.hasOwnProperty.call(E, "disabled") && A.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(E.disabled), E.labelVisibility != null && Object.hasOwnProperty.call(E, "labelVisibility") && $root.LabelVisibilityMessage.encode(E.labelVisibility, A.uint32(
      /* id 9, wireType 2 =*/
      74
    ).fork()).ldelim(), A;
  }, o.decode = function(E, A, g) {
    E instanceof $Reader || (E = $Reader.create(E));
    let e = A === void 0 ? E.len : E.pos + A, t = new $root.ColorPicker();
    for (; E.pos < e; ) {
      let c = E.uint32();
      if (c === g) break;
      switch (c >>> 3) {
        case 1: {
          t.id = E.string();
          break;
        }
        case 2: {
          t.label = E.string();
          break;
        }
        case 3: {
          t.default = E.string();
          break;
        }
        case 4: {
          t.help = E.string();
          break;
        }
        case 5: {
          t.formId = E.string();
          break;
        }
        case 6: {
          t.value = E.string();
          break;
        }
        case 7: {
          t.setValue = E.bool();
          break;
        }
        case 8: {
          t.disabled = E.bool();
          break;
        }
        case 9: {
          t.labelVisibility = $root.LabelVisibilityMessage.decode(E, E.uint32());
          break;
        }
        default:
          E.skipType(c & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(E) {
    if (E instanceof $root.ColorPicker) return E;
    let A = new $root.ColorPicker();
    if (E.id != null && (A.id = String(E.id)), E.label != null && (A.label = String(E.label)), E.default != null && (A.default = String(E.default)), E.help != null && (A.help = String(E.help)), E.formId != null && (A.formId = String(E.formId)), E.value != null && (A.value = String(E.value)), E.setValue != null && (A.setValue = !!E.setValue), E.disabled != null && (A.disabled = !!E.disabled), E.labelVisibility != null) {
      if (typeof E.labelVisibility != "object") throw TypeError(".ColorPicker.labelVisibility: object expected");
      A.labelVisibility = $root.LabelVisibilityMessage.fromObject(E.labelVisibility);
    }
    return A;
  }, o.toObject = function(E, A) {
    A || (A = {});
    let g = {};
    return A.defaults && (g.id = "", g.label = "", g.default = "", g.help = "", g.formId = "", g.value = "", g.setValue = !1, g.disabled = !1, g.labelVisibility = null), E.id != null && E.hasOwnProperty("id") && (g.id = E.id), E.label != null && E.hasOwnProperty("label") && (g.label = E.label), E.default != null && E.hasOwnProperty("default") && (g.default = E.default), E.help != null && E.hasOwnProperty("help") && (g.help = E.help), E.formId != null && E.hasOwnProperty("formId") && (g.formId = E.formId), E.value != null && E.hasOwnProperty("value") && (g.value = E.value), E.setValue != null && E.hasOwnProperty("setValue") && (g.setValue = E.setValue), E.disabled != null && E.hasOwnProperty("disabled") && (g.disabled = E.disabled), E.labelVisibility != null && E.hasOwnProperty("labelVisibility") && (g.labelVisibility = $root.LabelVisibilityMessage.toObject(E.labelVisibility, A)), g;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/ColorPicker";
  }, o;
})();
$root.DataFrame = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.data = null, o.prototype.index = null, o.prototype.columns = null, o.prototype.style = null, o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, A) {
    return A || (A = $Writer.create()), E.data != null && Object.hasOwnProperty.call(E, "data") && $root.Table.encode(E.data, A.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim(), E.index != null && Object.hasOwnProperty.call(E, "index") && $root.Index.encode(E.index, A.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), E.columns != null && Object.hasOwnProperty.call(E, "columns") && $root.Index.encode(E.columns, A.uint32(
      /* id 3, wireType 2 =*/
      26
    ).fork()).ldelim(), E.style != null && Object.hasOwnProperty.call(E, "style") && $root.TableStyle.encode(E.style, A.uint32(
      /* id 4, wireType 2 =*/
      34
    ).fork()).ldelim(), A;
  }, o.decode = function(E, A, g) {
    E instanceof $Reader || (E = $Reader.create(E));
    let e = A === void 0 ? E.len : E.pos + A, t = new $root.DataFrame();
    for (; E.pos < e; ) {
      let c = E.uint32();
      if (c === g) break;
      switch (c >>> 3) {
        case 1: {
          t.data = $root.Table.decode(E, E.uint32());
          break;
        }
        case 2: {
          t.index = $root.Index.decode(E, E.uint32());
          break;
        }
        case 3: {
          t.columns = $root.Index.decode(E, E.uint32());
          break;
        }
        case 4: {
          t.style = $root.TableStyle.decode(E, E.uint32());
          break;
        }
        default:
          E.skipType(c & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(E) {
    if (E instanceof $root.DataFrame) return E;
    let A = new $root.DataFrame();
    if (E.data != null) {
      if (typeof E.data != "object") throw TypeError(".DataFrame.data: object expected");
      A.data = $root.Table.fromObject(E.data);
    }
    if (E.index != null) {
      if (typeof E.index != "object") throw TypeError(".DataFrame.index: object expected");
      A.index = $root.Index.fromObject(E.index);
    }
    if (E.columns != null) {
      if (typeof E.columns != "object") throw TypeError(".DataFrame.columns: object expected");
      A.columns = $root.Index.fromObject(E.columns);
    }
    if (E.style != null) {
      if (typeof E.style != "object") throw TypeError(".DataFrame.style: object expected");
      A.style = $root.TableStyle.fromObject(E.style);
    }
    return A;
  }, o.toObject = function(E, A) {
    A || (A = {});
    let g = {};
    return A.defaults && (g.data = null, g.index = null, g.columns = null, g.style = null), E.data != null && E.hasOwnProperty("data") && (g.data = $root.Table.toObject(E.data, A)), E.index != null && E.hasOwnProperty("index") && (g.index = $root.Index.toObject(E.index, A)), E.columns != null && E.hasOwnProperty("columns") && (g.columns = $root.Index.toObject(E.columns, A)), E.style != null && E.hasOwnProperty("style") && (g.style = $root.TableStyle.toObject(E.style, A)), g;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/DataFrame";
  }, o;
})();
$root.Index = (() => {
  function o(A) {
    if (A) for (let g = Object.keys(A), e = 0; e < g.length; ++e) A[g[e]] != null && (this[g[e]] = A[g[e]]);
  }
  o.prototype.plainIndex = null, o.prototype.rangeIndex = null, o.prototype.multiIndex = null, o.prototype.datetimeIndex = null, o.prototype.timedeltaIndex = null, o.prototype.int_64Index = null, o.prototype.float_64Index = null;
  let E;
  return Object.defineProperty(o.prototype, "type", { get: $util.oneOfGetter(E = ["plainIndex", "rangeIndex", "multiIndex", "datetimeIndex", "timedeltaIndex", "int_64Index", "float_64Index"]), set: $util.oneOfSetter(E) }), o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    return g || (g = $Writer.create()), A.plainIndex != null && Object.hasOwnProperty.call(A, "plainIndex") && $root.PlainIndex.encode(A.plainIndex, g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim(), A.rangeIndex != null && Object.hasOwnProperty.call(A, "rangeIndex") && $root.RangeIndex.encode(A.rangeIndex, g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), A.multiIndex != null && Object.hasOwnProperty.call(A, "multiIndex") && $root.MultiIndex.encode(A.multiIndex, g.uint32(
      /* id 4, wireType 2 =*/
      34
    ).fork()).ldelim(), A.datetimeIndex != null && Object.hasOwnProperty.call(A, "datetimeIndex") && $root.DatetimeIndex.encode(A.datetimeIndex, g.uint32(
      /* id 6, wireType 2 =*/
      50
    ).fork()).ldelim(), A.timedeltaIndex != null && Object.hasOwnProperty.call(A, "timedeltaIndex") && $root.TimedeltaIndex.encode(A.timedeltaIndex, g.uint32(
      /* id 7, wireType 2 =*/
      58
    ).fork()).ldelim(), A.int_64Index != null && Object.hasOwnProperty.call(A, "int_64Index") && $root.Int64Index.encode(A.int_64Index, g.uint32(
      /* id 9, wireType 2 =*/
      74
    ).fork()).ldelim(), A.float_64Index != null && Object.hasOwnProperty.call(A, "float_64Index") && $root.Float64Index.encode(A.float_64Index, g.uint32(
      /* id 11, wireType 2 =*/
      90
    ).fork()).ldelim(), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader || (A = $Reader.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root.Index();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.plainIndex = $root.PlainIndex.decode(A, A.uint32());
          break;
        }
        case 2: {
          c.rangeIndex = $root.RangeIndex.decode(A, A.uint32());
          break;
        }
        case 4: {
          c.multiIndex = $root.MultiIndex.decode(A, A.uint32());
          break;
        }
        case 6: {
          c.datetimeIndex = $root.DatetimeIndex.decode(A, A.uint32());
          break;
        }
        case 7: {
          c.timedeltaIndex = $root.TimedeltaIndex.decode(A, A.uint32());
          break;
        }
        case 9: {
          c.int_64Index = $root.Int64Index.decode(A, A.uint32());
          break;
        }
        case 11: {
          c.float_64Index = $root.Float64Index.decode(A, A.uint32());
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root.Index) return A;
    let g = new $root.Index();
    if (A.plainIndex != null) {
      if (typeof A.plainIndex != "object") throw TypeError(".Index.plainIndex: object expected");
      g.plainIndex = $root.PlainIndex.fromObject(A.plainIndex);
    }
    if (A.rangeIndex != null) {
      if (typeof A.rangeIndex != "object") throw TypeError(".Index.rangeIndex: object expected");
      g.rangeIndex = $root.RangeIndex.fromObject(A.rangeIndex);
    }
    if (A.multiIndex != null) {
      if (typeof A.multiIndex != "object") throw TypeError(".Index.multiIndex: object expected");
      g.multiIndex = $root.MultiIndex.fromObject(A.multiIndex);
    }
    if (A.datetimeIndex != null) {
      if (typeof A.datetimeIndex != "object") throw TypeError(".Index.datetimeIndex: object expected");
      g.datetimeIndex = $root.DatetimeIndex.fromObject(A.datetimeIndex);
    }
    if (A.timedeltaIndex != null) {
      if (typeof A.timedeltaIndex != "object") throw TypeError(".Index.timedeltaIndex: object expected");
      g.timedeltaIndex = $root.TimedeltaIndex.fromObject(A.timedeltaIndex);
    }
    if (A.int_64Index != null) {
      if (typeof A.int_64Index != "object") throw TypeError(".Index.int_64Index: object expected");
      g.int_64Index = $root.Int64Index.fromObject(A.int_64Index);
    }
    if (A.float_64Index != null) {
      if (typeof A.float_64Index != "object") throw TypeError(".Index.float_64Index: object expected");
      g.float_64Index = $root.Float64Index.fromObject(A.float_64Index);
    }
    return g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    return A.plainIndex != null && A.hasOwnProperty("plainIndex") && (e.plainIndex = $root.PlainIndex.toObject(A.plainIndex, g), g.oneofs && (e.type = "plainIndex")), A.rangeIndex != null && A.hasOwnProperty("rangeIndex") && (e.rangeIndex = $root.RangeIndex.toObject(A.rangeIndex, g), g.oneofs && (e.type = "rangeIndex")), A.multiIndex != null && A.hasOwnProperty("multiIndex") && (e.multiIndex = $root.MultiIndex.toObject(A.multiIndex, g), g.oneofs && (e.type = "multiIndex")), A.datetimeIndex != null && A.hasOwnProperty("datetimeIndex") && (e.datetimeIndex = $root.DatetimeIndex.toObject(A.datetimeIndex, g), g.oneofs && (e.type = "datetimeIndex")), A.timedeltaIndex != null && A.hasOwnProperty("timedeltaIndex") && (e.timedeltaIndex = $root.TimedeltaIndex.toObject(A.timedeltaIndex, g), g.oneofs && (e.type = "timedeltaIndex")), A.int_64Index != null && A.hasOwnProperty("int_64Index") && (e.int_64Index = $root.Int64Index.toObject(A.int_64Index, g), g.oneofs && (e.type = "int_64Index")), A.float_64Index != null && A.hasOwnProperty("float_64Index") && (e.float_64Index = $root.Float64Index.toObject(A.float_64Index, g), g.oneofs && (e.type = "float_64Index")), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/Index";
  }, o;
})();
$root.PlainIndex = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.data = null, o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, A) {
    return A || (A = $Writer.create()), E.data != null && Object.hasOwnProperty.call(E, "data") && $root.AnyArray.encode(E.data, A.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim(), A;
  }, o.decode = function(E, A, g) {
    E instanceof $Reader || (E = $Reader.create(E));
    let e = A === void 0 ? E.len : E.pos + A, t = new $root.PlainIndex();
    for (; E.pos < e; ) {
      let c = E.uint32();
      if (c === g) break;
      c >>> 3 === 1 ? t.data = $root.AnyArray.decode(E, E.uint32()) : E.skipType(c & 7);
    }
    return t;
  }, o.fromObject = function(E) {
    if (E instanceof $root.PlainIndex) return E;
    let A = new $root.PlainIndex();
    if (E.data != null) {
      if (typeof E.data != "object") throw TypeError(".PlainIndex.data: object expected");
      A.data = $root.AnyArray.fromObject(E.data);
    }
    return A;
  }, o.toObject = function(E, A) {
    A || (A = {});
    let g = {};
    return A.defaults && (g.data = null), E.data != null && E.hasOwnProperty("data") && (g.data = $root.AnyArray.toObject(E.data, A)), g;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/PlainIndex";
  }, o;
})();
$root.RangeIndex = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.start = $util.Long ? $util.Long.fromBits(0, 0, !1) : 0, o.prototype.stop = $util.Long ? $util.Long.fromBits(0, 0, !1) : 0, o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, A) {
    return A || (A = $Writer.create()), E.start != null && Object.hasOwnProperty.call(E, "start") && A.uint32(
      /* id 1, wireType 0 =*/
      8
    ).int64(E.start), E.stop != null && Object.hasOwnProperty.call(E, "stop") && A.uint32(
      /* id 2, wireType 0 =*/
      16
    ).int64(E.stop), A;
  }, o.decode = function(E, A, g) {
    E instanceof $Reader || (E = $Reader.create(E));
    let e = A === void 0 ? E.len : E.pos + A, t = new $root.RangeIndex();
    for (; E.pos < e; ) {
      let c = E.uint32();
      if (c === g) break;
      switch (c >>> 3) {
        case 1: {
          t.start = E.int64();
          break;
        }
        case 2: {
          t.stop = E.int64();
          break;
        }
        default:
          E.skipType(c & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(E) {
    if (E instanceof $root.RangeIndex) return E;
    let A = new $root.RangeIndex();
    return E.start != null && ($util.Long ? (A.start = $util.Long.fromValue(E.start)).unsigned = !1 : typeof E.start == "string" ? A.start = parseInt(E.start, 10) : typeof E.start == "number" ? A.start = E.start : typeof E.start == "object" && (A.start = new $util.LongBits(E.start.low >>> 0, E.start.high >>> 0).toNumber())), E.stop != null && ($util.Long ? (A.stop = $util.Long.fromValue(E.stop)).unsigned = !1 : typeof E.stop == "string" ? A.stop = parseInt(E.stop, 10) : typeof E.stop == "number" ? A.stop = E.stop : typeof E.stop == "object" && (A.stop = new $util.LongBits(E.stop.low >>> 0, E.stop.high >>> 0).toNumber())), A;
  }, o.toObject = function(E, A) {
    A || (A = {});
    let g = {};
    if (A.defaults) {
      if ($util.Long) {
        let e = new $util.Long(0, 0, !1);
        g.start = A.longs === String ? e.toString() : A.longs === Number ? e.toNumber() : e;
      } else g.start = A.longs === String ? "0" : 0;
      if ($util.Long) {
        let e = new $util.Long(0, 0, !1);
        g.stop = A.longs === String ? e.toString() : A.longs === Number ? e.toNumber() : e;
      } else g.stop = A.longs === String ? "0" : 0;
    }
    return E.start != null && E.hasOwnProperty("start") && (typeof E.start == "number" ? g.start = A.longs === String ? String(E.start) : E.start : g.start = A.longs === String ? $util.Long.prototype.toString.call(E.start) : A.longs === Number ? new $util.LongBits(E.start.low >>> 0, E.start.high >>> 0).toNumber() : E.start), E.stop != null && E.hasOwnProperty("stop") && (typeof E.stop == "number" ? g.stop = A.longs === String ? String(E.stop) : E.stop : g.stop = A.longs === String ? $util.Long.prototype.toString.call(E.stop) : A.longs === Number ? new $util.LongBits(E.stop.low >>> 0, E.stop.high >>> 0).toNumber() : E.stop), g;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/RangeIndex";
  }, o;
})();
$root.MultiIndex = (() => {
  function o(E) {
    if (this.levels = [], this.labels = [], E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.levels = $util.emptyArray, o.prototype.labels = $util.emptyArray, o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, A) {
    if (A || (A = $Writer.create()), E.levels != null && E.levels.length) for (let g = 0; g < E.levels.length; ++g) $root.Index.encode(E.levels[g], A.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim();
    if (E.labels != null && E.labels.length) for (let g = 0; g < E.labels.length; ++g) $root.Int32Array.encode(E.labels[g], A.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim();
    return A;
  }, o.decode = function(E, A, g) {
    E instanceof $Reader || (E = $Reader.create(E));
    let e = A === void 0 ? E.len : E.pos + A, t = new $root.MultiIndex();
    for (; E.pos < e; ) {
      let c = E.uint32();
      if (c === g) break;
      switch (c >>> 3) {
        case 1: {
          t.levels && t.levels.length || (t.levels = []), t.levels.push($root.Index.decode(E, E.uint32()));
          break;
        }
        case 2: {
          t.labels && t.labels.length || (t.labels = []), t.labels.push($root.Int32Array.decode(E, E.uint32()));
          break;
        }
        default:
          E.skipType(c & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(E) {
    if (E instanceof $root.MultiIndex) return E;
    let A = new $root.MultiIndex();
    if (E.levels) {
      if (!Array.isArray(E.levels)) throw TypeError(".MultiIndex.levels: array expected");
      A.levels = [];
      for (let g = 0; g < E.levels.length; ++g) {
        if (typeof E.levels[g] != "object") throw TypeError(".MultiIndex.levels: object expected");
        A.levels[g] = $root.Index.fromObject(E.levels[g]);
      }
    }
    if (E.labels) {
      if (!Array.isArray(E.labels)) throw TypeError(".MultiIndex.labels: array expected");
      A.labels = [];
      for (let g = 0; g < E.labels.length; ++g) {
        if (typeof E.labels[g] != "object") throw TypeError(".MultiIndex.labels: object expected");
        A.labels[g] = $root.Int32Array.fromObject(E.labels[g]);
      }
    }
    return A;
  }, o.toObject = function(E, A) {
    A || (A = {});
    let g = {};
    if ((A.arrays || A.defaults) && (g.levels = [], g.labels = []), E.levels && E.levels.length) {
      g.levels = [];
      for (let e = 0; e < E.levels.length; ++e) g.levels[e] = $root.Index.toObject(E.levels[e], A);
    }
    if (E.labels && E.labels.length) {
      g.labels = [];
      for (let e = 0; e < E.labels.length; ++e) g.labels[e] = $root.Int32Array.toObject(E.labels[e], A);
    }
    return g;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/MultiIndex";
  }, o;
})();
$root.DatetimeIndex = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.data = null, o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, A) {
    return A || (A = $Writer.create()), E.data != null && Object.hasOwnProperty.call(E, "data") && $root.StringArray.encode(E.data, A.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim(), A;
  }, o.decode = function(E, A, g) {
    E instanceof $Reader || (E = $Reader.create(E));
    let e = A === void 0 ? E.len : E.pos + A, t = new $root.DatetimeIndex();
    for (; E.pos < e; ) {
      let c = E.uint32();
      if (c === g) break;
      c >>> 3 === 1 ? t.data = $root.StringArray.decode(E, E.uint32()) : E.skipType(c & 7);
    }
    return t;
  }, o.fromObject = function(E) {
    if (E instanceof $root.DatetimeIndex) return E;
    let A = new $root.DatetimeIndex();
    if (E.data != null) {
      if (typeof E.data != "object") throw TypeError(".DatetimeIndex.data: object expected");
      A.data = $root.StringArray.fromObject(E.data);
    }
    return A;
  }, o.toObject = function(E, A) {
    A || (A = {});
    let g = {};
    return A.defaults && (g.data = null), E.data != null && E.hasOwnProperty("data") && (g.data = $root.StringArray.toObject(E.data, A)), g;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/DatetimeIndex";
  }, o;
})();
$root.TimedeltaIndex = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.data = null, o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, A) {
    return A || (A = $Writer.create()), E.data != null && Object.hasOwnProperty.call(E, "data") && $root.Int64Array.encode(E.data, A.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim(), A;
  }, o.decode = function(E, A, g) {
    E instanceof $Reader || (E = $Reader.create(E));
    let e = A === void 0 ? E.len : E.pos + A, t = new $root.TimedeltaIndex();
    for (; E.pos < e; ) {
      let c = E.uint32();
      if (c === g) break;
      c >>> 3 === 1 ? t.data = $root.Int64Array.decode(E, E.uint32()) : E.skipType(c & 7);
    }
    return t;
  }, o.fromObject = function(E) {
    if (E instanceof $root.TimedeltaIndex) return E;
    let A = new $root.TimedeltaIndex();
    if (E.data != null) {
      if (typeof E.data != "object") throw TypeError(".TimedeltaIndex.data: object expected");
      A.data = $root.Int64Array.fromObject(E.data);
    }
    return A;
  }, o.toObject = function(E, A) {
    A || (A = {});
    let g = {};
    return A.defaults && (g.data = null), E.data != null && E.hasOwnProperty("data") && (g.data = $root.Int64Array.toObject(E.data, A)), g;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/TimedeltaIndex";
  }, o;
})();
$root.Int64Index = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.data = null, o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, A) {
    return A || (A = $Writer.create()), E.data != null && Object.hasOwnProperty.call(E, "data") && $root.Int64Array.encode(E.data, A.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim(), A;
  }, o.decode = function(E, A, g) {
    E instanceof $Reader || (E = $Reader.create(E));
    let e = A === void 0 ? E.len : E.pos + A, t = new $root.Int64Index();
    for (; E.pos < e; ) {
      let c = E.uint32();
      if (c === g) break;
      c >>> 3 === 1 ? t.data = $root.Int64Array.decode(E, E.uint32()) : E.skipType(c & 7);
    }
    return t;
  }, o.fromObject = function(E) {
    if (E instanceof $root.Int64Index) return E;
    let A = new $root.Int64Index();
    if (E.data != null) {
      if (typeof E.data != "object") throw TypeError(".Int64Index.data: object expected");
      A.data = $root.Int64Array.fromObject(E.data);
    }
    return A;
  }, o.toObject = function(E, A) {
    A || (A = {});
    let g = {};
    return A.defaults && (g.data = null), E.data != null && E.hasOwnProperty("data") && (g.data = $root.Int64Array.toObject(E.data, A)), g;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/Int64Index";
  }, o;
})();
$root.Float64Index = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.data = null, o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, A) {
    return A || (A = $Writer.create()), E.data != null && Object.hasOwnProperty.call(E, "data") && $root.DoubleArray.encode(E.data, A.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim(), A;
  }, o.decode = function(E, A, g) {
    E instanceof $Reader || (E = $Reader.create(E));
    let e = A === void 0 ? E.len : E.pos + A, t = new $root.Float64Index();
    for (; E.pos < e; ) {
      let c = E.uint32();
      if (c === g) break;
      c >>> 3 === 1 ? t.data = $root.DoubleArray.decode(E, E.uint32()) : E.skipType(c & 7);
    }
    return t;
  }, o.fromObject = function(E) {
    if (E instanceof $root.Float64Index) return E;
    let A = new $root.Float64Index();
    if (E.data != null) {
      if (typeof E.data != "object") throw TypeError(".Float64Index.data: object expected");
      A.data = $root.DoubleArray.fromObject(E.data);
    }
    return A;
  }, o.toObject = function(E, A) {
    A || (A = {});
    let g = {};
    return A.defaults && (g.data = null), E.data != null && E.hasOwnProperty("data") && (g.data = $root.DoubleArray.toObject(E.data, A)), g;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/Float64Index";
  }, o;
})();
$root.CSSStyle = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.property = "", o.prototype.value = "", o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, A) {
    return A || (A = $Writer.create()), E.property != null && Object.hasOwnProperty.call(E, "property") && A.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(E.property), E.value != null && Object.hasOwnProperty.call(E, "value") && A.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(E.value), A;
  }, o.decode = function(E, A, g) {
    E instanceof $Reader || (E = $Reader.create(E));
    let e = A === void 0 ? E.len : E.pos + A, t = new $root.CSSStyle();
    for (; E.pos < e; ) {
      let c = E.uint32();
      if (c === g) break;
      switch (c >>> 3) {
        case 1: {
          t.property = E.string();
          break;
        }
        case 2: {
          t.value = E.string();
          break;
        }
        default:
          E.skipType(c & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(E) {
    if (E instanceof $root.CSSStyle) return E;
    let A = new $root.CSSStyle();
    return E.property != null && (A.property = String(E.property)), E.value != null && (A.value = String(E.value)), A;
  }, o.toObject = function(E, A) {
    A || (A = {});
    let g = {};
    return A.defaults && (g.property = "", g.value = ""), E.property != null && E.hasOwnProperty("property") && (g.property = E.property), E.value != null && E.hasOwnProperty("value") && (g.value = E.value), g;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/CSSStyle";
  }, o;
})();
$root.CellStyle = (() => {
  function o(E) {
    if (this.css = [], E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.css = $util.emptyArray, o.prototype.displayValue = "", o.prototype.hasDisplayValue = !1, o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, A) {
    if (A || (A = $Writer.create()), E.css != null && E.css.length) for (let g = 0; g < E.css.length; ++g) $root.CSSStyle.encode(E.css[g], A.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim();
    return E.displayValue != null && Object.hasOwnProperty.call(E, "displayValue") && A.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(E.displayValue), E.hasDisplayValue != null && Object.hasOwnProperty.call(E, "hasDisplayValue") && A.uint32(
      /* id 3, wireType 0 =*/
      24
    ).bool(E.hasDisplayValue), A;
  }, o.decode = function(E, A, g) {
    E instanceof $Reader || (E = $Reader.create(E));
    let e = A === void 0 ? E.len : E.pos + A, t = new $root.CellStyle();
    for (; E.pos < e; ) {
      let c = E.uint32();
      if (c === g) break;
      switch (c >>> 3) {
        case 1: {
          t.css && t.css.length || (t.css = []), t.css.push($root.CSSStyle.decode(E, E.uint32()));
          break;
        }
        case 2: {
          t.displayValue = E.string();
          break;
        }
        case 3: {
          t.hasDisplayValue = E.bool();
          break;
        }
        default:
          E.skipType(c & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(E) {
    if (E instanceof $root.CellStyle) return E;
    let A = new $root.CellStyle();
    if (E.css) {
      if (!Array.isArray(E.css)) throw TypeError(".CellStyle.css: array expected");
      A.css = [];
      for (let g = 0; g < E.css.length; ++g) {
        if (typeof E.css[g] != "object") throw TypeError(".CellStyle.css: object expected");
        A.css[g] = $root.CSSStyle.fromObject(E.css[g]);
      }
    }
    return E.displayValue != null && (A.displayValue = String(E.displayValue)), E.hasDisplayValue != null && (A.hasDisplayValue = !!E.hasDisplayValue), A;
  }, o.toObject = function(E, A) {
    A || (A = {});
    let g = {};
    if ((A.arrays || A.defaults) && (g.css = []), A.defaults && (g.displayValue = "", g.hasDisplayValue = !1), E.css && E.css.length) {
      g.css = [];
      for (let e = 0; e < E.css.length; ++e) g.css[e] = $root.CSSStyle.toObject(E.css[e], A);
    }
    return E.displayValue != null && E.hasOwnProperty("displayValue") && (g.displayValue = E.displayValue), E.hasDisplayValue != null && E.hasOwnProperty("hasDisplayValue") && (g.hasDisplayValue = E.hasDisplayValue), g;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/CellStyle";
  }, o;
})();
$root.CellStyleArray = (() => {
  function o(E) {
    if (this.styles = [], E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.styles = $util.emptyArray, o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, A) {
    if (A || (A = $Writer.create()), E.styles != null && E.styles.length) for (let g = 0; g < E.styles.length; ++g) $root.CellStyle.encode(E.styles[g], A.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim();
    return A;
  }, o.decode = function(E, A, g) {
    E instanceof $Reader || (E = $Reader.create(E));
    let e = A === void 0 ? E.len : E.pos + A, t = new $root.CellStyleArray();
    for (; E.pos < e; ) {
      let c = E.uint32();
      if (c === g) break;
      c >>> 3 === 1 ? (t.styles && t.styles.length || (t.styles = []), t.styles.push($root.CellStyle.decode(E, E.uint32()))) : E.skipType(c & 7);
    }
    return t;
  }, o.fromObject = function(E) {
    if (E instanceof $root.CellStyleArray) return E;
    let A = new $root.CellStyleArray();
    if (E.styles) {
      if (!Array.isArray(E.styles)) throw TypeError(".CellStyleArray.styles: array expected");
      A.styles = [];
      for (let g = 0; g < E.styles.length; ++g) {
        if (typeof E.styles[g] != "object") throw TypeError(".CellStyleArray.styles: object expected");
        A.styles[g] = $root.CellStyle.fromObject(E.styles[g]);
      }
    }
    return A;
  }, o.toObject = function(E, A) {
    A || (A = {});
    let g = {};
    if ((A.arrays || A.defaults) && (g.styles = []), E.styles && E.styles.length) {
      g.styles = [];
      for (let e = 0; e < E.styles.length; ++e) g.styles[e] = $root.CellStyle.toObject(E.styles[e], A);
    }
    return g;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/CellStyleArray";
  }, o;
})();
$root.AnyArray = (() => {
  function o(A) {
    if (A) for (let g = Object.keys(A), e = 0; e < g.length; ++e) A[g[e]] != null && (this[g[e]] = A[g[e]]);
  }
  o.prototype.strings = null, o.prototype.doubles = null, o.prototype.int64s = null, o.prototype.datetimes = null, o.prototype.timedeltas = null;
  let E;
  return Object.defineProperty(o.prototype, "type", { get: $util.oneOfGetter(E = ["strings", "doubles", "int64s", "datetimes", "timedeltas"]), set: $util.oneOfSetter(E) }), o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    return g || (g = $Writer.create()), A.strings != null && Object.hasOwnProperty.call(A, "strings") && $root.StringArray.encode(A.strings, g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim(), A.doubles != null && Object.hasOwnProperty.call(A, "doubles") && $root.DoubleArray.encode(A.doubles, g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), A.int64s != null && Object.hasOwnProperty.call(A, "int64s") && $root.Int64Array.encode(A.int64s, g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).fork()).ldelim(), A.datetimes != null && Object.hasOwnProperty.call(A, "datetimes") && $root.StringArray.encode(A.datetimes, g.uint32(
      /* id 4, wireType 2 =*/
      34
    ).fork()).ldelim(), A.timedeltas != null && Object.hasOwnProperty.call(A, "timedeltas") && $root.Int64Array.encode(A.timedeltas, g.uint32(
      /* id 5, wireType 2 =*/
      42
    ).fork()).ldelim(), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader || (A = $Reader.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root.AnyArray();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.strings = $root.StringArray.decode(A, A.uint32());
          break;
        }
        case 2: {
          c.doubles = $root.DoubleArray.decode(A, A.uint32());
          break;
        }
        case 3: {
          c.int64s = $root.Int64Array.decode(A, A.uint32());
          break;
        }
        case 4: {
          c.datetimes = $root.StringArray.decode(A, A.uint32());
          break;
        }
        case 5: {
          c.timedeltas = $root.Int64Array.decode(A, A.uint32());
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root.AnyArray) return A;
    let g = new $root.AnyArray();
    if (A.strings != null) {
      if (typeof A.strings != "object") throw TypeError(".AnyArray.strings: object expected");
      g.strings = $root.StringArray.fromObject(A.strings);
    }
    if (A.doubles != null) {
      if (typeof A.doubles != "object") throw TypeError(".AnyArray.doubles: object expected");
      g.doubles = $root.DoubleArray.fromObject(A.doubles);
    }
    if (A.int64s != null) {
      if (typeof A.int64s != "object") throw TypeError(".AnyArray.int64s: object expected");
      g.int64s = $root.Int64Array.fromObject(A.int64s);
    }
    if (A.datetimes != null) {
      if (typeof A.datetimes != "object") throw TypeError(".AnyArray.datetimes: object expected");
      g.datetimes = $root.StringArray.fromObject(A.datetimes);
    }
    if (A.timedeltas != null) {
      if (typeof A.timedeltas != "object") throw TypeError(".AnyArray.timedeltas: object expected");
      g.timedeltas = $root.Int64Array.fromObject(A.timedeltas);
    }
    return g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    return A.strings != null && A.hasOwnProperty("strings") && (e.strings = $root.StringArray.toObject(A.strings, g), g.oneofs && (e.type = "strings")), A.doubles != null && A.hasOwnProperty("doubles") && (e.doubles = $root.DoubleArray.toObject(A.doubles, g), g.oneofs && (e.type = "doubles")), A.int64s != null && A.hasOwnProperty("int64s") && (e.int64s = $root.Int64Array.toObject(A.int64s, g), g.oneofs && (e.type = "int64s")), A.datetimes != null && A.hasOwnProperty("datetimes") && (e.datetimes = $root.StringArray.toObject(A.datetimes, g), g.oneofs && (e.type = "datetimes")), A.timedeltas != null && A.hasOwnProperty("timedeltas") && (e.timedeltas = $root.Int64Array.toObject(A.timedeltas, g), g.oneofs && (e.type = "timedeltas")), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/AnyArray";
  }, o;
})();
$root.Table = (() => {
  function o(E) {
    if (this.cols = [], E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.cols = $util.emptyArray, o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, A) {
    if (A || (A = $Writer.create()), E.cols != null && E.cols.length) for (let g = 0; g < E.cols.length; ++g) $root.AnyArray.encode(E.cols[g], A.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim();
    return A;
  }, o.decode = function(E, A, g) {
    E instanceof $Reader || (E = $Reader.create(E));
    let e = A === void 0 ? E.len : E.pos + A, t = new $root.Table();
    for (; E.pos < e; ) {
      let c = E.uint32();
      if (c === g) break;
      c >>> 3 === 1 ? (t.cols && t.cols.length || (t.cols = []), t.cols.push($root.AnyArray.decode(E, E.uint32()))) : E.skipType(c & 7);
    }
    return t;
  }, o.fromObject = function(E) {
    if (E instanceof $root.Table) return E;
    let A = new $root.Table();
    if (E.cols) {
      if (!Array.isArray(E.cols)) throw TypeError(".Table.cols: array expected");
      A.cols = [];
      for (let g = 0; g < E.cols.length; ++g) {
        if (typeof E.cols[g] != "object") throw TypeError(".Table.cols: object expected");
        A.cols[g] = $root.AnyArray.fromObject(E.cols[g]);
      }
    }
    return A;
  }, o.toObject = function(E, A) {
    A || (A = {});
    let g = {};
    if ((A.arrays || A.defaults) && (g.cols = []), E.cols && E.cols.length) {
      g.cols = [];
      for (let e = 0; e < E.cols.length; ++e) g.cols[e] = $root.AnyArray.toObject(E.cols[e], A);
    }
    return g;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/Table";
  }, o;
})();
$root.TableStyle = (() => {
  function o(E) {
    if (this.cols = [], E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.cols = $util.emptyArray, o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, A) {
    if (A || (A = $Writer.create()), E.cols != null && E.cols.length) for (let g = 0; g < E.cols.length; ++g) $root.CellStyleArray.encode(E.cols[g], A.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim();
    return A;
  }, o.decode = function(E, A, g) {
    E instanceof $Reader || (E = $Reader.create(E));
    let e = A === void 0 ? E.len : E.pos + A, t = new $root.TableStyle();
    for (; E.pos < e; ) {
      let c = E.uint32();
      if (c === g) break;
      c >>> 3 === 1 ? (t.cols && t.cols.length || (t.cols = []), t.cols.push($root.CellStyleArray.decode(E, E.uint32()))) : E.skipType(c & 7);
    }
    return t;
  }, o.fromObject = function(E) {
    if (E instanceof $root.TableStyle) return E;
    let A = new $root.TableStyle();
    if (E.cols) {
      if (!Array.isArray(E.cols)) throw TypeError(".TableStyle.cols: array expected");
      A.cols = [];
      for (let g = 0; g < E.cols.length; ++g) {
        if (typeof E.cols[g] != "object") throw TypeError(".TableStyle.cols: object expected");
        A.cols[g] = $root.CellStyleArray.fromObject(E.cols[g]);
      }
    }
    return A;
  }, o.toObject = function(E, A) {
    A || (A = {});
    let g = {};
    if ((A.arrays || A.defaults) && (g.cols = []), E.cols && E.cols.length) {
      g.cols = [];
      for (let e = 0; e < E.cols.length; ++e) g.cols[e] = $root.CellStyleArray.toObject(E.cols[e], A);
    }
    return g;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/TableStyle";
  }, o;
})();
$root.DateInput = (() => {
  function o(E) {
    if (this.default = [], this.value = [], E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.id = "", o.prototype.label = "", o.prototype.default = $util.emptyArray, o.prototype.min = "", o.prototype.max = "", o.prototype.isRange = !1, o.prototype.help = "", o.prototype.formId = "", o.prototype.value = $util.emptyArray, o.prototype.setValue = !1, o.prototype.disabled = !1, o.prototype.labelVisibility = null, o.prototype.format = "", o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, A) {
    if (A || (A = $Writer.create()), E.id != null && Object.hasOwnProperty.call(E, "id") && A.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(E.id), E.label != null && Object.hasOwnProperty.call(E, "label") && A.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(E.label), E.default != null && E.default.length) for (let g = 0; g < E.default.length; ++g) A.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(E.default[g]);
    if (E.min != null && Object.hasOwnProperty.call(E, "min") && A.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(E.min), E.max != null && Object.hasOwnProperty.call(E, "max") && A.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(E.max), E.isRange != null && Object.hasOwnProperty.call(E, "isRange") && A.uint32(
      /* id 6, wireType 0 =*/
      48
    ).bool(E.isRange), E.help != null && Object.hasOwnProperty.call(E, "help") && A.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(E.help), E.formId != null && Object.hasOwnProperty.call(E, "formId") && A.uint32(
      /* id 8, wireType 2 =*/
      66
    ).string(E.formId), E.value != null && E.value.length) for (let g = 0; g < E.value.length; ++g) A.uint32(
      /* id 9, wireType 2 =*/
      74
    ).string(E.value[g]);
    return E.setValue != null && Object.hasOwnProperty.call(E, "setValue") && A.uint32(
      /* id 10, wireType 0 =*/
      80
    ).bool(E.setValue), E.disabled != null && Object.hasOwnProperty.call(E, "disabled") && A.uint32(
      /* id 11, wireType 0 =*/
      88
    ).bool(E.disabled), E.labelVisibility != null && Object.hasOwnProperty.call(E, "labelVisibility") && $root.LabelVisibilityMessage.encode(E.labelVisibility, A.uint32(
      /* id 12, wireType 2 =*/
      98
    ).fork()).ldelim(), E.format != null && Object.hasOwnProperty.call(E, "format") && A.uint32(
      /* id 13, wireType 2 =*/
      106
    ).string(E.format), A;
  }, o.decode = function(E, A, g) {
    E instanceof $Reader || (E = $Reader.create(E));
    let e = A === void 0 ? E.len : E.pos + A, t = new $root.DateInput();
    for (; E.pos < e; ) {
      let c = E.uint32();
      if (c === g) break;
      switch (c >>> 3) {
        case 1: {
          t.id = E.string();
          break;
        }
        case 2: {
          t.label = E.string();
          break;
        }
        case 3: {
          t.default && t.default.length || (t.default = []), t.default.push(E.string());
          break;
        }
        case 4: {
          t.min = E.string();
          break;
        }
        case 5: {
          t.max = E.string();
          break;
        }
        case 6: {
          t.isRange = E.bool();
          break;
        }
        case 7: {
          t.help = E.string();
          break;
        }
        case 8: {
          t.formId = E.string();
          break;
        }
        case 9: {
          t.value && t.value.length || (t.value = []), t.value.push(E.string());
          break;
        }
        case 10: {
          t.setValue = E.bool();
          break;
        }
        case 11: {
          t.disabled = E.bool();
          break;
        }
        case 12: {
          t.labelVisibility = $root.LabelVisibilityMessage.decode(E, E.uint32());
          break;
        }
        case 13: {
          t.format = E.string();
          break;
        }
        default:
          E.skipType(c & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(E) {
    if (E instanceof $root.DateInput) return E;
    let A = new $root.DateInput();
    if (E.id != null && (A.id = String(E.id)), E.label != null && (A.label = String(E.label)), E.default) {
      if (!Array.isArray(E.default)) throw TypeError(".DateInput.default: array expected");
      A.default = [];
      for (let g = 0; g < E.default.length; ++g) A.default[g] = String(E.default[g]);
    }
    if (E.min != null && (A.min = String(E.min)), E.max != null && (A.max = String(E.max)), E.isRange != null && (A.isRange = !!E.isRange), E.help != null && (A.help = String(E.help)), E.formId != null && (A.formId = String(E.formId)), E.value) {
      if (!Array.isArray(E.value)) throw TypeError(".DateInput.value: array expected");
      A.value = [];
      for (let g = 0; g < E.value.length; ++g) A.value[g] = String(E.value[g]);
    }
    if (E.setValue != null && (A.setValue = !!E.setValue), E.disabled != null && (A.disabled = !!E.disabled), E.labelVisibility != null) {
      if (typeof E.labelVisibility != "object") throw TypeError(".DateInput.labelVisibility: object expected");
      A.labelVisibility = $root.LabelVisibilityMessage.fromObject(E.labelVisibility);
    }
    return E.format != null && (A.format = String(E.format)), A;
  }, o.toObject = function(E, A) {
    A || (A = {});
    let g = {};
    if ((A.arrays || A.defaults) && (g.default = [], g.value = []), A.defaults && (g.id = "", g.label = "", g.min = "", g.max = "", g.isRange = !1, g.help = "", g.formId = "", g.setValue = !1, g.disabled = !1, g.labelVisibility = null, g.format = ""), E.id != null && E.hasOwnProperty("id") && (g.id = E.id), E.label != null && E.hasOwnProperty("label") && (g.label = E.label), E.default && E.default.length) {
      g.default = [];
      for (let e = 0; e < E.default.length; ++e) g.default[e] = E.default[e];
    }
    if (E.min != null && E.hasOwnProperty("min") && (g.min = E.min), E.max != null && E.hasOwnProperty("max") && (g.max = E.max), E.isRange != null && E.hasOwnProperty("isRange") && (g.isRange = E.isRange), E.help != null && E.hasOwnProperty("help") && (g.help = E.help), E.formId != null && E.hasOwnProperty("formId") && (g.formId = E.formId), E.value && E.value.length) {
      g.value = [];
      for (let e = 0; e < E.value.length; ++e) g.value[e] = E.value[e];
    }
    return E.setValue != null && E.hasOwnProperty("setValue") && (g.setValue = E.setValue), E.disabled != null && E.hasOwnProperty("disabled") && (g.disabled = E.disabled), E.labelVisibility != null && E.hasOwnProperty("labelVisibility") && (g.labelVisibility = $root.LabelVisibilityMessage.toObject(E.labelVisibility, A)), E.format != null && E.hasOwnProperty("format") && (g.format = E.format), g;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/DateInput";
  }, o;
})();
$root.DateTimeInput = (() => {
  function o(E) {
    if (this.default = [], this.value = [], E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.id = "", o.prototype.label = "", o.prototype.default = $util.emptyArray, o.prototype.min = "", o.prototype.max = "", o.prototype.help = "", o.prototype.formId = "", o.prototype.value = $util.emptyArray, o.prototype.setValue = !1, o.prototype.disabled = !1, o.prototype.labelVisibility = null, o.prototype.format = "", o.prototype.step = $util.Long ? $util.Long.fromBits(0, 0, !1) : 0, o.prototype.isRange = !1, o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, A) {
    if (A || (A = $Writer.create()), E.id != null && Object.hasOwnProperty.call(E, "id") && A.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(E.id), E.label != null && Object.hasOwnProperty.call(E, "label") && A.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(E.label), E.default != null && E.default.length) for (let g = 0; g < E.default.length; ++g) A.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(E.default[g]);
    if (E.min != null && Object.hasOwnProperty.call(E, "min") && A.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(E.min), E.max != null && Object.hasOwnProperty.call(E, "max") && A.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(E.max), E.help != null && Object.hasOwnProperty.call(E, "help") && A.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(E.help), E.formId != null && Object.hasOwnProperty.call(E, "formId") && A.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(E.formId), E.value != null && E.value.length) for (let g = 0; g < E.value.length; ++g) A.uint32(
      /* id 8, wireType 2 =*/
      66
    ).string(E.value[g]);
    return E.setValue != null && Object.hasOwnProperty.call(E, "setValue") && A.uint32(
      /* id 9, wireType 0 =*/
      72
    ).bool(E.setValue), E.disabled != null && Object.hasOwnProperty.call(E, "disabled") && A.uint32(
      /* id 10, wireType 0 =*/
      80
    ).bool(E.disabled), E.labelVisibility != null && Object.hasOwnProperty.call(E, "labelVisibility") && $root.LabelVisibilityMessage.encode(E.labelVisibility, A.uint32(
      /* id 11, wireType 2 =*/
      90
    ).fork()).ldelim(), E.format != null && Object.hasOwnProperty.call(E, "format") && A.uint32(
      /* id 12, wireType 2 =*/
      98
    ).string(E.format), E.step != null && Object.hasOwnProperty.call(E, "step") && A.uint32(
      /* id 13, wireType 0 =*/
      104
    ).int64(E.step), E.isRange != null && Object.hasOwnProperty.call(E, "isRange") && A.uint32(
      /* id 14, wireType 0 =*/
      112
    ).bool(E.isRange), A;
  }, o.decode = function(E, A, g) {
    E instanceof $Reader || (E = $Reader.create(E));
    let e = A === void 0 ? E.len : E.pos + A, t = new $root.DateTimeInput();
    for (; E.pos < e; ) {
      let c = E.uint32();
      if (c === g) break;
      switch (c >>> 3) {
        case 1: {
          t.id = E.string();
          break;
        }
        case 2: {
          t.label = E.string();
          break;
        }
        case 3: {
          t.default && t.default.length || (t.default = []), t.default.push(E.string());
          break;
        }
        case 4: {
          t.min = E.string();
          break;
        }
        case 5: {
          t.max = E.string();
          break;
        }
        case 6: {
          t.help = E.string();
          break;
        }
        case 7: {
          t.formId = E.string();
          break;
        }
        case 8: {
          t.value && t.value.length || (t.value = []), t.value.push(E.string());
          break;
        }
        case 9: {
          t.setValue = E.bool();
          break;
        }
        case 10: {
          t.disabled = E.bool();
          break;
        }
        case 11: {
          t.labelVisibility = $root.LabelVisibilityMessage.decode(E, E.uint32());
          break;
        }
        case 12: {
          t.format = E.string();
          break;
        }
        case 13: {
          t.step = E.int64();
          break;
        }
        case 14: {
          t.isRange = E.bool();
          break;
        }
        default:
          E.skipType(c & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(E) {
    if (E instanceof $root.DateTimeInput) return E;
    let A = new $root.DateTimeInput();
    if (E.id != null && (A.id = String(E.id)), E.label != null && (A.label = String(E.label)), E.default) {
      if (!Array.isArray(E.default)) throw TypeError(".DateTimeInput.default: array expected");
      A.default = [];
      for (let g = 0; g < E.default.length; ++g) A.default[g] = String(E.default[g]);
    }
    if (E.min != null && (A.min = String(E.min)), E.max != null && (A.max = String(E.max)), E.help != null && (A.help = String(E.help)), E.formId != null && (A.formId = String(E.formId)), E.value) {
      if (!Array.isArray(E.value)) throw TypeError(".DateTimeInput.value: array expected");
      A.value = [];
      for (let g = 0; g < E.value.length; ++g) A.value[g] = String(E.value[g]);
    }
    if (E.setValue != null && (A.setValue = !!E.setValue), E.disabled != null && (A.disabled = !!E.disabled), E.labelVisibility != null) {
      if (typeof E.labelVisibility != "object") throw TypeError(".DateTimeInput.labelVisibility: object expected");
      A.labelVisibility = $root.LabelVisibilityMessage.fromObject(E.labelVisibility);
    }
    return E.format != null && (A.format = String(E.format)), E.step != null && ($util.Long ? (A.step = $util.Long.fromValue(E.step)).unsigned = !1 : typeof E.step == "string" ? A.step = parseInt(E.step, 10) : typeof E.step == "number" ? A.step = E.step : typeof E.step == "object" && (A.step = new $util.LongBits(E.step.low >>> 0, E.step.high >>> 0).toNumber())), E.isRange != null && (A.isRange = !!E.isRange), A;
  }, o.toObject = function(E, A) {
    A || (A = {});
    let g = {};
    if ((A.arrays || A.defaults) && (g.default = [], g.value = []), A.defaults) {
      if (g.id = "", g.label = "", g.min = "", g.max = "", g.help = "", g.formId = "", g.setValue = !1, g.disabled = !1, g.labelVisibility = null, g.format = "", $util.Long) {
        let e = new $util.Long(0, 0, !1);
        g.step = A.longs === String ? e.toString() : A.longs === Number ? e.toNumber() : e;
      } else g.step = A.longs === String ? "0" : 0;
      g.isRange = !1;
    }
    if (E.id != null && E.hasOwnProperty("id") && (g.id = E.id), E.label != null && E.hasOwnProperty("label") && (g.label = E.label), E.default && E.default.length) {
      g.default = [];
      for (let e = 0; e < E.default.length; ++e) g.default[e] = E.default[e];
    }
    if (E.min != null && E.hasOwnProperty("min") && (g.min = E.min), E.max != null && E.hasOwnProperty("max") && (g.max = E.max), E.help != null && E.hasOwnProperty("help") && (g.help = E.help), E.formId != null && E.hasOwnProperty("formId") && (g.formId = E.formId), E.value && E.value.length) {
      g.value = [];
      for (let e = 0; e < E.value.length; ++e) g.value[e] = E.value[e];
    }
    return E.setValue != null && E.hasOwnProperty("setValue") && (g.setValue = E.setValue), E.disabled != null && E.hasOwnProperty("disabled") && (g.disabled = E.disabled), E.labelVisibility != null && E.hasOwnProperty("labelVisibility") && (g.labelVisibility = $root.LabelVisibilityMessage.toObject(E.labelVisibility, A)), E.format != null && E.hasOwnProperty("format") && (g.format = E.format), E.step != null && E.hasOwnProperty("step") && (typeof E.step == "number" ? g.step = A.longs === String ? String(E.step) : E.step : g.step = A.longs === String ? $util.Long.prototype.toString.call(E.step) : A.longs === Number ? new $util.LongBits(E.step.low >>> 0, E.step.high >>> 0).toNumber() : E.step), E.isRange != null && E.hasOwnProperty("isRange") && (g.isRange = E.isRange), g;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/DateTimeInput";
  }, o;
})();
$root.DeckGlJsonChart = (() => {
  function o(E) {
    if (this.selectionMode = [], E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.json = "", o.prototype.tooltip = "", o.prototype.useContainerWidth = !1, o.prototype.id = "", o.prototype.mapboxToken = "", o.prototype.width = 0, o.prototype.height = 0, o.prototype.selectionMode = $util.emptyArray, o.prototype.formId = "", o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, A) {
    if (A || (A = $Writer.create()), E.json != null && Object.hasOwnProperty.call(E, "json") && A.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(E.json), E.tooltip != null && Object.hasOwnProperty.call(E, "tooltip") && A.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(E.tooltip), E.useContainerWidth != null && Object.hasOwnProperty.call(E, "useContainerWidth") && A.uint32(
      /* id 4, wireType 0 =*/
      32
    ).bool(E.useContainerWidth), E.id != null && Object.hasOwnProperty.call(E, "id") && A.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(E.id), E.mapboxToken != null && Object.hasOwnProperty.call(E, "mapboxToken") && A.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(E.mapboxToken), E.width != null && Object.hasOwnProperty.call(E, "width") && A.uint32(
      /* id 7, wireType 0 =*/
      56
    ).uint32(E.width), E.height != null && Object.hasOwnProperty.call(E, "height") && A.uint32(
      /* id 8, wireType 0 =*/
      64
    ).uint32(E.height), E.selectionMode != null && E.selectionMode.length) {
      A.uint32(
        /* id 9, wireType 2 =*/
        74
      ).fork();
      for (let g = 0; g < E.selectionMode.length; ++g) A.int32(E.selectionMode[g]);
      A.ldelim();
    }
    return E.formId != null && Object.hasOwnProperty.call(E, "formId") && A.uint32(
      /* id 10, wireType 2 =*/
      82
    ).string(E.formId), A;
  }, o.decode = function(E, A, g) {
    E instanceof $Reader || (E = $Reader.create(E));
    let e = A === void 0 ? E.len : E.pos + A, t = new $root.DeckGlJsonChart();
    for (; E.pos < e; ) {
      let c = E.uint32();
      if (c === g) break;
      switch (c >>> 3) {
        case 1: {
          t.json = E.string();
          break;
        }
        case 2: {
          t.tooltip = E.string();
          break;
        }
        case 4: {
          t.useContainerWidth = E.bool();
          break;
        }
        case 5: {
          t.id = E.string();
          break;
        }
        case 6: {
          t.mapboxToken = E.string();
          break;
        }
        case 7: {
          t.width = E.uint32();
          break;
        }
        case 8: {
          t.height = E.uint32();
          break;
        }
        case 9: {
          if (t.selectionMode && t.selectionMode.length || (t.selectionMode = []), (c & 7) === 2) {
            let n = E.uint32() + E.pos;
            for (; E.pos < n; ) t.selectionMode.push(E.int32());
          } else t.selectionMode.push(E.int32());
          break;
        }
        case 10: {
          t.formId = E.string();
          break;
        }
        default:
          E.skipType(c & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(E) {
    if (E instanceof $root.DeckGlJsonChart) return E;
    let A = new $root.DeckGlJsonChart();
    if (E.json != null && (A.json = String(E.json)), E.tooltip != null && (A.tooltip = String(E.tooltip)), E.useContainerWidth != null && (A.useContainerWidth = !!E.useContainerWidth), E.id != null && (A.id = String(E.id)), E.mapboxToken != null && (A.mapboxToken = String(E.mapboxToken)), E.width != null && (A.width = E.width >>> 0), E.height != null && (A.height = E.height >>> 0), E.selectionMode) {
      if (!Array.isArray(E.selectionMode)) throw TypeError(".DeckGlJsonChart.selectionMode: array expected");
      A.selectionMode = [];
      for (let g = 0; g < E.selectionMode.length; ++g) switch (E.selectionMode[g]) {
        default:
          if (typeof E.selectionMode[g] == "number") {
            A.selectionMode[g] = E.selectionMode[g];
            break;
          }
        case "SINGLE_OBJECT":
        case 0:
          A.selectionMode[g] = 0;
          break;
        case "MULTI_OBJECT":
        case 1:
          A.selectionMode[g] = 1;
          break;
      }
    }
    return E.formId != null && (A.formId = String(E.formId)), A;
  }, o.toObject = function(E, A) {
    A || (A = {});
    let g = {};
    if ((A.arrays || A.defaults) && (g.selectionMode = []), A.defaults && (g.json = "", g.tooltip = "", g.useContainerWidth = !1, g.id = "", g.mapboxToken = "", g.width = 0, g.height = 0, g.formId = ""), E.json != null && E.hasOwnProperty("json") && (g.json = E.json), E.tooltip != null && E.hasOwnProperty("tooltip") && (g.tooltip = E.tooltip), E.useContainerWidth != null && E.hasOwnProperty("useContainerWidth") && (g.useContainerWidth = E.useContainerWidth), E.id != null && E.hasOwnProperty("id") && (g.id = E.id), E.mapboxToken != null && E.hasOwnProperty("mapboxToken") && (g.mapboxToken = E.mapboxToken), E.width != null && E.hasOwnProperty("width") && (g.width = E.width), E.height != null && E.hasOwnProperty("height") && (g.height = E.height), E.selectionMode && E.selectionMode.length) {
      g.selectionMode = [];
      for (let e = 0; e < E.selectionMode.length; ++e) g.selectionMode[e] = A.enums === String ? $root.DeckGlJsonChart.SelectionMode[E.selectionMode[e]] === void 0 ? E.selectionMode[e] : $root.DeckGlJsonChart.SelectionMode[E.selectionMode[e]] : E.selectionMode[e];
    }
    return E.formId != null && E.hasOwnProperty("formId") && (g.formId = E.formId), g;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/DeckGlJsonChart";
  }, o.SelectionMode = (function() {
    const E = {}, A = Object.create(E);
    return A[E[0] = "SINGLE_OBJECT"] = 0, A[E[1] = "MULTI_OBJECT"] = 1, A;
  })(), o;
})();
$root.Delta = (() => {
  function o(A) {
    if (A) for (let g = Object.keys(A), e = 0; e < g.length; ++e) A[g[e]] != null && (this[g[e]] = A[g[e]]);
  }
  o.prototype.newElement = null, o.prototype.addBlock = null, o.prototype.addRows = null, o.prototype.arrowAddRows = null, o.prototype.fragmentId = "";
  let E;
  return Object.defineProperty(o.prototype, "type", { get: $util.oneOfGetter(E = ["newElement", "addBlock", "addRows", "arrowAddRows"]), set: $util.oneOfSetter(E) }), o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    return g || (g = $Writer.create()), A.newElement != null && Object.hasOwnProperty.call(A, "newElement") && $root.Element.encode(A.newElement, g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).fork()).ldelim(), A.addRows != null && Object.hasOwnProperty.call(A, "addRows") && $root.NamedDataSet.encode(A.addRows, g.uint32(
      /* id 5, wireType 2 =*/
      42
    ).fork()).ldelim(), A.addBlock != null && Object.hasOwnProperty.call(A, "addBlock") && $root.Block.encode(A.addBlock, g.uint32(
      /* id 6, wireType 2 =*/
      50
    ).fork()).ldelim(), A.arrowAddRows != null && Object.hasOwnProperty.call(A, "arrowAddRows") && $root.ArrowNamedDataSet.encode(A.arrowAddRows, g.uint32(
      /* id 7, wireType 2 =*/
      58
    ).fork()).ldelim(), A.fragmentId != null && Object.hasOwnProperty.call(A, "fragmentId") && g.uint32(
      /* id 8, wireType 2 =*/
      66
    ).string(A.fragmentId), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader || (A = $Reader.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root.Delta();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 3: {
          c.newElement = $root.Element.decode(A, A.uint32());
          break;
        }
        case 6: {
          c.addBlock = $root.Block.decode(A, A.uint32());
          break;
        }
        case 5: {
          c.addRows = $root.NamedDataSet.decode(A, A.uint32());
          break;
        }
        case 7: {
          c.arrowAddRows = $root.ArrowNamedDataSet.decode(A, A.uint32());
          break;
        }
        case 8: {
          c.fragmentId = A.string();
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root.Delta) return A;
    let g = new $root.Delta();
    if (A.newElement != null) {
      if (typeof A.newElement != "object") throw TypeError(".Delta.newElement: object expected");
      g.newElement = $root.Element.fromObject(A.newElement);
    }
    if (A.addBlock != null) {
      if (typeof A.addBlock != "object") throw TypeError(".Delta.addBlock: object expected");
      g.addBlock = $root.Block.fromObject(A.addBlock);
    }
    if (A.addRows != null) {
      if (typeof A.addRows != "object") throw TypeError(".Delta.addRows: object expected");
      g.addRows = $root.NamedDataSet.fromObject(A.addRows);
    }
    if (A.arrowAddRows != null) {
      if (typeof A.arrowAddRows != "object") throw TypeError(".Delta.arrowAddRows: object expected");
      g.arrowAddRows = $root.ArrowNamedDataSet.fromObject(A.arrowAddRows);
    }
    return A.fragmentId != null && (g.fragmentId = String(A.fragmentId)), g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    return g.defaults && (e.fragmentId = ""), A.newElement != null && A.hasOwnProperty("newElement") && (e.newElement = $root.Element.toObject(A.newElement, g), g.oneofs && (e.type = "newElement")), A.addRows != null && A.hasOwnProperty("addRows") && (e.addRows = $root.NamedDataSet.toObject(A.addRows, g), g.oneofs && (e.type = "addRows")), A.addBlock != null && A.hasOwnProperty("addBlock") && (e.addBlock = $root.Block.toObject(A.addBlock, g), g.oneofs && (e.type = "addBlock")), A.arrowAddRows != null && A.hasOwnProperty("arrowAddRows") && (e.arrowAddRows = $root.ArrowNamedDataSet.toObject(A.arrowAddRows, g), g.oneofs && (e.type = "arrowAddRows")), A.fragmentId != null && A.hasOwnProperty("fragmentId") && (e.fragmentId = A.fragmentId), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/Delta";
  }, o;
})();
$root.Element = (() => {
  function o(A) {
    if (A) for (let g = Object.keys(A), e = 0; e < g.length; ++e) A[g[e]] != null && (this[g[e]] = A[g[e]]);
  }
  o.prototype.heightConfig = null, o.prototype.widthConfig = null, o.prototype.textAlignmentConfig = null, o.prototype.alert = null, o.prototype.arrowDataFrame = null, o.prototype.arrowTable = null, o.prototype.arrowVegaLiteChart = null, o.prototype.audio = null, o.prototype.audioInput = null, o.prototype.balloons = null, o.prototype.bidiComponent = null, o.prototype.bokehChart = null, o.prototype.button = null, o.prototype.buttonGroup = null, o.prototype.downloadButton = null, o.prototype.cameraInput = null, o.prototype.chatInput = null, o.prototype.checkbox = null, o.prototype.colorPicker = null, o.prototype.componentInstance = null, o.prototype.dataFrame = null, o.prototype.table = null, o.prototype.dateInput = null, o.prototype.deckGlJsonChart = null, o.prototype.docString = null, o.prototype.empty = null, o.prototype.exception = null, o.prototype.favicon = null, o.prototype.fileUploader = null, o.prototype.graphvizChart = null, o.prototype.html = null, o.prototype.iframe = null, o.prototype.imgs = null, o.prototype.json = null, o.prototype.linkButton = null, o.prototype.markdown = null, o.prototype.metric = null, o.prototype.multiselect = null, o.prototype.numberInput = null, o.prototype.pageLink = null, o.prototype.plotlyChart = null, o.prototype.progress = null, o.prototype.radio = null, o.prototype.selectbox = null, o.prototype.skeleton = null, o.prototype.slider = null, o.prototype.snow = null, o.prototype.space = null, o.prototype.spinner = null, o.prototype.text = null, o.prototype.textArea = null, o.prototype.textInput = null, o.prototype.timeInput = null, o.prototype.dateTimeInput = null, o.prototype.toast = null, o.prototype.vegaLiteChart = null, o.prototype.video = null, o.prototype.heading = null, o.prototype.code = null;
  let E;
  return Object.defineProperty(o.prototype, "_heightConfig", { get: $util.oneOfGetter(E = ["heightConfig"]), set: $util.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_widthConfig", { get: $util.oneOfGetter(E = ["widthConfig"]), set: $util.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_textAlignmentConfig", { get: $util.oneOfGetter(E = ["textAlignmentConfig"]), set: $util.oneOfSetter(E) }), Object.defineProperty(o.prototype, "type", { get: $util.oneOfGetter(E = ["alert", "arrowDataFrame", "arrowTable", "arrowVegaLiteChart", "audio", "audioInput", "balloons", "bidiComponent", "bokehChart", "button", "buttonGroup", "downloadButton", "cameraInput", "chatInput", "checkbox", "colorPicker", "componentInstance", "dataFrame", "table", "dateInput", "deckGlJsonChart", "docString", "empty", "exception", "favicon", "fileUploader", "graphvizChart", "html", "iframe", "imgs", "json", "linkButton", "markdown", "metric", "multiselect", "numberInput", "pageLink", "plotlyChart", "progress", "radio", "selectbox", "skeleton", "slider", "snow", "space", "spinner", "text", "textArea", "textInput", "timeInput", "dateTimeInput", "toast", "vegaLiteChart", "video", "heading", "code"]), set: $util.oneOfSetter(E) }), o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    return g || (g = $Writer.create()), A.text != null && Object.hasOwnProperty.call(A, "text") && $root.Text.encode(A.text, g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim(), A.empty != null && Object.hasOwnProperty.call(A, "empty") && $root.Empty.encode(A.empty, g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), A.dataFrame != null && Object.hasOwnProperty.call(A, "dataFrame") && $root.DataFrame.encode(A.dataFrame, g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).fork()).ldelim(), A.progress != null && Object.hasOwnProperty.call(A, "progress") && $root.Progress.encode(A.progress, g.uint32(
      /* id 5, wireType 2 =*/
      42
    ).fork()).ldelim(), A.imgs != null && Object.hasOwnProperty.call(A, "imgs") && $root.ImageList.encode(A.imgs, g.uint32(
      /* id 6, wireType 2 =*/
      50
    ).fork()).ldelim(), A.docString != null && Object.hasOwnProperty.call(A, "docString") && $root.DocString.encode(A.docString, g.uint32(
      /* id 7, wireType 2 =*/
      58
    ).fork()).ldelim(), A.exception != null && Object.hasOwnProperty.call(A, "exception") && $root.Exception.encode(A.exception, g.uint32(
      /* id 8, wireType 2 =*/
      66
    ).fork()).ldelim(), A.vegaLiteChart != null && Object.hasOwnProperty.call(A, "vegaLiteChart") && $root.VegaLiteChart.encode(A.vegaLiteChart, g.uint32(
      /* id 10, wireType 2 =*/
      82
    ).fork()).ldelim(), A.table != null && Object.hasOwnProperty.call(A, "table") && $root.DataFrame.encode(A.table, g.uint32(
      /* id 11, wireType 2 =*/
      90
    ).fork()).ldelim(), A.balloons != null && Object.hasOwnProperty.call(A, "balloons") && $root.Balloons.encode(A.balloons, g.uint32(
      /* id 12, wireType 2 =*/
      98
    ).fork()).ldelim(), A.audio != null && Object.hasOwnProperty.call(A, "audio") && $root.Audio.encode(A.audio, g.uint32(
      /* id 13, wireType 2 =*/
      106
    ).fork()).ldelim(), A.video != null && Object.hasOwnProperty.call(A, "video") && $root.Video.encode(A.video, g.uint32(
      /* id 14, wireType 2 =*/
      114
    ).fork()).ldelim(), A.plotlyChart != null && Object.hasOwnProperty.call(A, "plotlyChart") && $root.PlotlyChart.encode(A.plotlyChart, g.uint32(
      /* id 16, wireType 2 =*/
      130
    ).fork()).ldelim(), A.bokehChart != null && Object.hasOwnProperty.call(A, "bokehChart") && $root.BokehChart.encode(A.bokehChart, g.uint32(
      /* id 17, wireType 2 =*/
      138
    ).fork()).ldelim(), A.graphvizChart != null && Object.hasOwnProperty.call(A, "graphvizChart") && $root.GraphVizChart.encode(A.graphvizChart, g.uint32(
      /* id 18, wireType 2 =*/
      146
    ).fork()).ldelim(), A.button != null && Object.hasOwnProperty.call(A, "button") && $root.Button.encode(A.button, g.uint32(
      /* id 19, wireType 2 =*/
      154
    ).fork()).ldelim(), A.checkbox != null && Object.hasOwnProperty.call(A, "checkbox") && $root.Checkbox.encode(A.checkbox, g.uint32(
      /* id 20, wireType 2 =*/
      162
    ).fork()).ldelim(), A.slider != null && Object.hasOwnProperty.call(A, "slider") && $root.Slider.encode(A.slider, g.uint32(
      /* id 21, wireType 2 =*/
      170
    ).fork()).ldelim(), A.textArea != null && Object.hasOwnProperty.call(A, "textArea") && $root.TextArea.encode(A.textArea, g.uint32(
      /* id 22, wireType 2 =*/
      178
    ).fork()).ldelim(), A.radio != null && Object.hasOwnProperty.call(A, "radio") && $root.Radio.encode(A.radio, g.uint32(
      /* id 23, wireType 2 =*/
      186
    ).fork()).ldelim(), A.textInput != null && Object.hasOwnProperty.call(A, "textInput") && $root.TextInput.encode(A.textInput, g.uint32(
      /* id 24, wireType 2 =*/
      194
    ).fork()).ldelim(), A.selectbox != null && Object.hasOwnProperty.call(A, "selectbox") && $root.Selectbox.encode(A.selectbox, g.uint32(
      /* id 25, wireType 2 =*/
      202
    ).fork()).ldelim(), A.timeInput != null && Object.hasOwnProperty.call(A, "timeInput") && $root.TimeInput.encode(A.timeInput, g.uint32(
      /* id 26, wireType 2 =*/
      210
    ).fork()).ldelim(), A.dateInput != null && Object.hasOwnProperty.call(A, "dateInput") && $root.DateInput.encode(A.dateInput, g.uint32(
      /* id 27, wireType 2 =*/
      218
    ).fork()).ldelim(), A.multiselect != null && Object.hasOwnProperty.call(A, "multiselect") && $root.MultiSelect.encode(A.multiselect, g.uint32(
      /* id 28, wireType 2 =*/
      226
    ).fork()).ldelim(), A.markdown != null && Object.hasOwnProperty.call(A, "markdown") && $root.Markdown.encode(A.markdown, g.uint32(
      /* id 29, wireType 2 =*/
      234
    ).fork()).ldelim(), A.alert != null && Object.hasOwnProperty.call(A, "alert") && $root.Alert.encode(A.alert, g.uint32(
      /* id 30, wireType 2 =*/
      242
    ).fork()).ldelim(), A.json != null && Object.hasOwnProperty.call(A, "json") && $root.Json.encode(A.json, g.uint32(
      /* id 31, wireType 2 =*/
      250
    ).fork()).ldelim(), A.numberInput != null && Object.hasOwnProperty.call(A, "numberInput") && $root.NumberInput.encode(A.numberInput, g.uint32(
      /* id 32, wireType 2 =*/
      258
    ).fork()).ldelim(), A.fileUploader != null && Object.hasOwnProperty.call(A, "fileUploader") && $root.FileUploader.encode(A.fileUploader, g.uint32(
      /* id 33, wireType 2 =*/
      266
    ).fork()).ldelim(), A.deckGlJsonChart != null && Object.hasOwnProperty.call(A, "deckGlJsonChart") && $root.DeckGlJsonChart.encode(A.deckGlJsonChart, g.uint32(
      /* id 34, wireType 2 =*/
      274
    ).fork()).ldelim(), A.colorPicker != null && Object.hasOwnProperty.call(A, "colorPicker") && $root.ColorPicker.encode(A.colorPicker, g.uint32(
      /* id 35, wireType 2 =*/
      282
    ).fork()).ldelim(), A.favicon != null && Object.hasOwnProperty.call(A, "favicon") && $root.Favicon.encode(A.favicon, g.uint32(
      /* id 36, wireType 2 =*/
      290
    ).fork()).ldelim(), A.componentInstance != null && Object.hasOwnProperty.call(A, "componentInstance") && $root.ComponentInstance.encode(A.componentInstance, g.uint32(
      /* id 37, wireType 2 =*/
      298
    ).fork()).ldelim(), A.iframe != null && Object.hasOwnProperty.call(A, "iframe") && $root.IFrame.encode(A.iframe, g.uint32(
      /* id 38, wireType 2 =*/
      306
    ).fork()).ldelim(), A.arrowTable != null && Object.hasOwnProperty.call(A, "arrowTable") && $root.Arrow.encode(A.arrowTable, g.uint32(
      /* id 39, wireType 2 =*/
      314
    ).fork()).ldelim(), A.arrowDataFrame != null && Object.hasOwnProperty.call(A, "arrowDataFrame") && $root.Arrow.encode(A.arrowDataFrame, g.uint32(
      /* id 40, wireType 2 =*/
      322
    ).fork()).ldelim(), A.arrowVegaLiteChart != null && Object.hasOwnProperty.call(A, "arrowVegaLiteChart") && $root.ArrowVegaLiteChart.encode(A.arrowVegaLiteChart, g.uint32(
      /* id 41, wireType 2 =*/
      330
    ).fork()).ldelim(), A.metric != null && Object.hasOwnProperty.call(A, "metric") && $root.Metric.encode(A.metric, g.uint32(
      /* id 42, wireType 2 =*/
      338
    ).fork()).ldelim(), A.downloadButton != null && Object.hasOwnProperty.call(A, "downloadButton") && $root.DownloadButton.encode(A.downloadButton, g.uint32(
      /* id 43, wireType 2 =*/
      346
    ).fork()).ldelim(), A.spinner != null && Object.hasOwnProperty.call(A, "spinner") && $root.Spinner.encode(A.spinner, g.uint32(
      /* id 44, wireType 2 =*/
      354
    ).fork()).ldelim(), A.cameraInput != null && Object.hasOwnProperty.call(A, "cameraInput") && $root.CameraInput.encode(A.cameraInput, g.uint32(
      /* id 45, wireType 2 =*/
      362
    ).fork()).ldelim(), A.snow != null && Object.hasOwnProperty.call(A, "snow") && $root.Snow.encode(A.snow, g.uint32(
      /* id 46, wireType 2 =*/
      370
    ).fork()).ldelim(), A.heading != null && Object.hasOwnProperty.call(A, "heading") && $root.Heading.encode(A.heading, g.uint32(
      /* id 47, wireType 2 =*/
      378
    ).fork()).ldelim(), A.code != null && Object.hasOwnProperty.call(A, "code") && $root.Code.encode(A.code, g.uint32(
      /* id 48, wireType 2 =*/
      386
    ).fork()).ldelim(), A.chatInput != null && Object.hasOwnProperty.call(A, "chatInput") && $root.ChatInput.encode(A.chatInput, g.uint32(
      /* id 49, wireType 2 =*/
      394
    ).fork()).ldelim(), A.toast != null && Object.hasOwnProperty.call(A, "toast") && $root.Toast.encode(A.toast, g.uint32(
      /* id 50, wireType 2 =*/
      402
    ).fork()).ldelim(), A.linkButton != null && Object.hasOwnProperty.call(A, "linkButton") && $root.LinkButton.encode(A.linkButton, g.uint32(
      /* id 51, wireType 2 =*/
      410
    ).fork()).ldelim(), A.skeleton != null && Object.hasOwnProperty.call(A, "skeleton") && $root.Skeleton.encode(A.skeleton, g.uint32(
      /* id 52, wireType 2 =*/
      418
    ).fork()).ldelim(), A.pageLink != null && Object.hasOwnProperty.call(A, "pageLink") && $root.PageLink.encode(A.pageLink, g.uint32(
      /* id 53, wireType 2 =*/
      426
    ).fork()).ldelim(), A.html != null && Object.hasOwnProperty.call(A, "html") && $root.Html.encode(A.html, g.uint32(
      /* id 54, wireType 2 =*/
      434
    ).fork()).ldelim(), A.buttonGroup != null && Object.hasOwnProperty.call(A, "buttonGroup") && $root.ButtonGroup.encode(A.buttonGroup, g.uint32(
      /* id 55, wireType 2 =*/
      442
    ).fork()).ldelim(), A.audioInput != null && Object.hasOwnProperty.call(A, "audioInput") && $root.AudioInput.encode(A.audioInput, g.uint32(
      /* id 56, wireType 2 =*/
      450
    ).fork()).ldelim(), A.heightConfig != null && Object.hasOwnProperty.call(A, "heightConfig") && $root.streamlit.HeightConfig.encode(A.heightConfig, g.uint32(
      /* id 57, wireType 2 =*/
      458
    ).fork()).ldelim(), A.widthConfig != null && Object.hasOwnProperty.call(A, "widthConfig") && $root.streamlit.WidthConfig.encode(A.widthConfig, g.uint32(
      /* id 58, wireType 2 =*/
      466
    ).fork()).ldelim(), A.bidiComponent != null && Object.hasOwnProperty.call(A, "bidiComponent") && $root.BidiComponent.encode(A.bidiComponent, g.uint32(
      /* id 59, wireType 2 =*/
      474
    ).fork()).ldelim(), A.space != null && Object.hasOwnProperty.call(A, "space") && $root.Space.encode(A.space, g.uint32(
      /* id 60, wireType 2 =*/
      482
    ).fork()).ldelim(), A.textAlignmentConfig != null && Object.hasOwnProperty.call(A, "textAlignmentConfig") && $root.streamlit.TextAlignmentConfig.encode(A.textAlignmentConfig, g.uint32(
      /* id 61, wireType 2 =*/
      490
    ).fork()).ldelim(), A.dateTimeInput != null && Object.hasOwnProperty.call(A, "dateTimeInput") && $root.DateTimeInput.encode(A.dateTimeInput, g.uint32(
      /* id 62, wireType 2 =*/
      498
    ).fork()).ldelim(), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader || (A = $Reader.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root.Element();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 57: {
          c.heightConfig = $root.streamlit.HeightConfig.decode(A, A.uint32());
          break;
        }
        case 58: {
          c.widthConfig = $root.streamlit.WidthConfig.decode(A, A.uint32());
          break;
        }
        case 61: {
          c.textAlignmentConfig = $root.streamlit.TextAlignmentConfig.decode(A, A.uint32());
          break;
        }
        case 30: {
          c.alert = $root.Alert.decode(A, A.uint32());
          break;
        }
        case 40: {
          c.arrowDataFrame = $root.Arrow.decode(A, A.uint32());
          break;
        }
        case 39: {
          c.arrowTable = $root.Arrow.decode(A, A.uint32());
          break;
        }
        case 41: {
          c.arrowVegaLiteChart = $root.ArrowVegaLiteChart.decode(A, A.uint32());
          break;
        }
        case 13: {
          c.audio = $root.Audio.decode(A, A.uint32());
          break;
        }
        case 56: {
          c.audioInput = $root.AudioInput.decode(A, A.uint32());
          break;
        }
        case 12: {
          c.balloons = $root.Balloons.decode(A, A.uint32());
          break;
        }
        case 59: {
          c.bidiComponent = $root.BidiComponent.decode(A, A.uint32());
          break;
        }
        case 17: {
          c.bokehChart = $root.BokehChart.decode(A, A.uint32());
          break;
        }
        case 19: {
          c.button = $root.Button.decode(A, A.uint32());
          break;
        }
        case 55: {
          c.buttonGroup = $root.ButtonGroup.decode(A, A.uint32());
          break;
        }
        case 43: {
          c.downloadButton = $root.DownloadButton.decode(A, A.uint32());
          break;
        }
        case 45: {
          c.cameraInput = $root.CameraInput.decode(A, A.uint32());
          break;
        }
        case 49: {
          c.chatInput = $root.ChatInput.decode(A, A.uint32());
          break;
        }
        case 20: {
          c.checkbox = $root.Checkbox.decode(A, A.uint32());
          break;
        }
        case 35: {
          c.colorPicker = $root.ColorPicker.decode(A, A.uint32());
          break;
        }
        case 37: {
          c.componentInstance = $root.ComponentInstance.decode(A, A.uint32());
          break;
        }
        case 3: {
          c.dataFrame = $root.DataFrame.decode(A, A.uint32());
          break;
        }
        case 11: {
          c.table = $root.DataFrame.decode(A, A.uint32());
          break;
        }
        case 27: {
          c.dateInput = $root.DateInput.decode(A, A.uint32());
          break;
        }
        case 34: {
          c.deckGlJsonChart = $root.DeckGlJsonChart.decode(A, A.uint32());
          break;
        }
        case 7: {
          c.docString = $root.DocString.decode(A, A.uint32());
          break;
        }
        case 2: {
          c.empty = $root.Empty.decode(A, A.uint32());
          break;
        }
        case 8: {
          c.exception = $root.Exception.decode(A, A.uint32());
          break;
        }
        case 36: {
          c.favicon = $root.Favicon.decode(A, A.uint32());
          break;
        }
        case 33: {
          c.fileUploader = $root.FileUploader.decode(A, A.uint32());
          break;
        }
        case 18: {
          c.graphvizChart = $root.GraphVizChart.decode(A, A.uint32());
          break;
        }
        case 54: {
          c.html = $root.Html.decode(A, A.uint32());
          break;
        }
        case 38: {
          c.iframe = $root.IFrame.decode(A, A.uint32());
          break;
        }
        case 6: {
          c.imgs = $root.ImageList.decode(A, A.uint32());
          break;
        }
        case 31: {
          c.json = $root.Json.decode(A, A.uint32());
          break;
        }
        case 51: {
          c.linkButton = $root.LinkButton.decode(A, A.uint32());
          break;
        }
        case 29: {
          c.markdown = $root.Markdown.decode(A, A.uint32());
          break;
        }
        case 42: {
          c.metric = $root.Metric.decode(A, A.uint32());
          break;
        }
        case 28: {
          c.multiselect = $root.MultiSelect.decode(A, A.uint32());
          break;
        }
        case 32: {
          c.numberInput = $root.NumberInput.decode(A, A.uint32());
          break;
        }
        case 53: {
          c.pageLink = $root.PageLink.decode(A, A.uint32());
          break;
        }
        case 16: {
          c.plotlyChart = $root.PlotlyChart.decode(A, A.uint32());
          break;
        }
        case 5: {
          c.progress = $root.Progress.decode(A, A.uint32());
          break;
        }
        case 23: {
          c.radio = $root.Radio.decode(A, A.uint32());
          break;
        }
        case 25: {
          c.selectbox = $root.Selectbox.decode(A, A.uint32());
          break;
        }
        case 52: {
          c.skeleton = $root.Skeleton.decode(A, A.uint32());
          break;
        }
        case 21: {
          c.slider = $root.Slider.decode(A, A.uint32());
          break;
        }
        case 46: {
          c.snow = $root.Snow.decode(A, A.uint32());
          break;
        }
        case 60: {
          c.space = $root.Space.decode(A, A.uint32());
          break;
        }
        case 44: {
          c.spinner = $root.Spinner.decode(A, A.uint32());
          break;
        }
        case 1: {
          c.text = $root.Text.decode(A, A.uint32());
          break;
        }
        case 22: {
          c.textArea = $root.TextArea.decode(A, A.uint32());
          break;
        }
        case 24: {
          c.textInput = $root.TextInput.decode(A, A.uint32());
          break;
        }
        case 26: {
          c.timeInput = $root.TimeInput.decode(A, A.uint32());
          break;
        }
        case 62: {
          c.dateTimeInput = $root.DateTimeInput.decode(A, A.uint32());
          break;
        }
        case 50: {
          c.toast = $root.Toast.decode(A, A.uint32());
          break;
        }
        case 10: {
          c.vegaLiteChart = $root.VegaLiteChart.decode(A, A.uint32());
          break;
        }
        case 14: {
          c.video = $root.Video.decode(A, A.uint32());
          break;
        }
        case 47: {
          c.heading = $root.Heading.decode(A, A.uint32());
          break;
        }
        case 48: {
          c.code = $root.Code.decode(A, A.uint32());
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root.Element) return A;
    let g = new $root.Element();
    if (A.heightConfig != null) {
      if (typeof A.heightConfig != "object") throw TypeError(".Element.heightConfig: object expected");
      g.heightConfig = $root.streamlit.HeightConfig.fromObject(A.heightConfig);
    }
    if (A.widthConfig != null) {
      if (typeof A.widthConfig != "object") throw TypeError(".Element.widthConfig: object expected");
      g.widthConfig = $root.streamlit.WidthConfig.fromObject(A.widthConfig);
    }
    if (A.textAlignmentConfig != null) {
      if (typeof A.textAlignmentConfig != "object") throw TypeError(".Element.textAlignmentConfig: object expected");
      g.textAlignmentConfig = $root.streamlit.TextAlignmentConfig.fromObject(A.textAlignmentConfig);
    }
    if (A.alert != null) {
      if (typeof A.alert != "object") throw TypeError(".Element.alert: object expected");
      g.alert = $root.Alert.fromObject(A.alert);
    }
    if (A.arrowDataFrame != null) {
      if (typeof A.arrowDataFrame != "object") throw TypeError(".Element.arrowDataFrame: object expected");
      g.arrowDataFrame = $root.Arrow.fromObject(A.arrowDataFrame);
    }
    if (A.arrowTable != null) {
      if (typeof A.arrowTable != "object") throw TypeError(".Element.arrowTable: object expected");
      g.arrowTable = $root.Arrow.fromObject(A.arrowTable);
    }
    if (A.arrowVegaLiteChart != null) {
      if (typeof A.arrowVegaLiteChart != "object") throw TypeError(".Element.arrowVegaLiteChart: object expected");
      g.arrowVegaLiteChart = $root.ArrowVegaLiteChart.fromObject(A.arrowVegaLiteChart);
    }
    if (A.audio != null) {
      if (typeof A.audio != "object") throw TypeError(".Element.audio: object expected");
      g.audio = $root.Audio.fromObject(A.audio);
    }
    if (A.audioInput != null) {
      if (typeof A.audioInput != "object") throw TypeError(".Element.audioInput: object expected");
      g.audioInput = $root.AudioInput.fromObject(A.audioInput);
    }
    if (A.balloons != null) {
      if (typeof A.balloons != "object") throw TypeError(".Element.balloons: object expected");
      g.balloons = $root.Balloons.fromObject(A.balloons);
    }
    if (A.bidiComponent != null) {
      if (typeof A.bidiComponent != "object") throw TypeError(".Element.bidiComponent: object expected");
      g.bidiComponent = $root.BidiComponent.fromObject(A.bidiComponent);
    }
    if (A.bokehChart != null) {
      if (typeof A.bokehChart != "object") throw TypeError(".Element.bokehChart: object expected");
      g.bokehChart = $root.BokehChart.fromObject(A.bokehChart);
    }
    if (A.button != null) {
      if (typeof A.button != "object") throw TypeError(".Element.button: object expected");
      g.button = $root.Button.fromObject(A.button);
    }
    if (A.buttonGroup != null) {
      if (typeof A.buttonGroup != "object") throw TypeError(".Element.buttonGroup: object expected");
      g.buttonGroup = $root.ButtonGroup.fromObject(A.buttonGroup);
    }
    if (A.downloadButton != null) {
      if (typeof A.downloadButton != "object") throw TypeError(".Element.downloadButton: object expected");
      g.downloadButton = $root.DownloadButton.fromObject(A.downloadButton);
    }
    if (A.cameraInput != null) {
      if (typeof A.cameraInput != "object") throw TypeError(".Element.cameraInput: object expected");
      g.cameraInput = $root.CameraInput.fromObject(A.cameraInput);
    }
    if (A.chatInput != null) {
      if (typeof A.chatInput != "object") throw TypeError(".Element.chatInput: object expected");
      g.chatInput = $root.ChatInput.fromObject(A.chatInput);
    }
    if (A.checkbox != null) {
      if (typeof A.checkbox != "object") throw TypeError(".Element.checkbox: object expected");
      g.checkbox = $root.Checkbox.fromObject(A.checkbox);
    }
    if (A.colorPicker != null) {
      if (typeof A.colorPicker != "object") throw TypeError(".Element.colorPicker: object expected");
      g.colorPicker = $root.ColorPicker.fromObject(A.colorPicker);
    }
    if (A.componentInstance != null) {
      if (typeof A.componentInstance != "object") throw TypeError(".Element.componentInstance: object expected");
      g.componentInstance = $root.ComponentInstance.fromObject(A.componentInstance);
    }
    if (A.dataFrame != null) {
      if (typeof A.dataFrame != "object") throw TypeError(".Element.dataFrame: object expected");
      g.dataFrame = $root.DataFrame.fromObject(A.dataFrame);
    }
    if (A.table != null) {
      if (typeof A.table != "object") throw TypeError(".Element.table: object expected");
      g.table = $root.DataFrame.fromObject(A.table);
    }
    if (A.dateInput != null) {
      if (typeof A.dateInput != "object") throw TypeError(".Element.dateInput: object expected");
      g.dateInput = $root.DateInput.fromObject(A.dateInput);
    }
    if (A.deckGlJsonChart != null) {
      if (typeof A.deckGlJsonChart != "object") throw TypeError(".Element.deckGlJsonChart: object expected");
      g.deckGlJsonChart = $root.DeckGlJsonChart.fromObject(A.deckGlJsonChart);
    }
    if (A.docString != null) {
      if (typeof A.docString != "object") throw TypeError(".Element.docString: object expected");
      g.docString = $root.DocString.fromObject(A.docString);
    }
    if (A.empty != null) {
      if (typeof A.empty != "object") throw TypeError(".Element.empty: object expected");
      g.empty = $root.Empty.fromObject(A.empty);
    }
    if (A.exception != null) {
      if (typeof A.exception != "object") throw TypeError(".Element.exception: object expected");
      g.exception = $root.Exception.fromObject(A.exception);
    }
    if (A.favicon != null) {
      if (typeof A.favicon != "object") throw TypeError(".Element.favicon: object expected");
      g.favicon = $root.Favicon.fromObject(A.favicon);
    }
    if (A.fileUploader != null) {
      if (typeof A.fileUploader != "object") throw TypeError(".Element.fileUploader: object expected");
      g.fileUploader = $root.FileUploader.fromObject(A.fileUploader);
    }
    if (A.graphvizChart != null) {
      if (typeof A.graphvizChart != "object") throw TypeError(".Element.graphvizChart: object expected");
      g.graphvizChart = $root.GraphVizChart.fromObject(A.graphvizChart);
    }
    if (A.html != null) {
      if (typeof A.html != "object") throw TypeError(".Element.html: object expected");
      g.html = $root.Html.fromObject(A.html);
    }
    if (A.iframe != null) {
      if (typeof A.iframe != "object") throw TypeError(".Element.iframe: object expected");
      g.iframe = $root.IFrame.fromObject(A.iframe);
    }
    if (A.imgs != null) {
      if (typeof A.imgs != "object") throw TypeError(".Element.imgs: object expected");
      g.imgs = $root.ImageList.fromObject(A.imgs);
    }
    if (A.json != null) {
      if (typeof A.json != "object") throw TypeError(".Element.json: object expected");
      g.json = $root.Json.fromObject(A.json);
    }
    if (A.linkButton != null) {
      if (typeof A.linkButton != "object") throw TypeError(".Element.linkButton: object expected");
      g.linkButton = $root.LinkButton.fromObject(A.linkButton);
    }
    if (A.markdown != null) {
      if (typeof A.markdown != "object") throw TypeError(".Element.markdown: object expected");
      g.markdown = $root.Markdown.fromObject(A.markdown);
    }
    if (A.metric != null) {
      if (typeof A.metric != "object") throw TypeError(".Element.metric: object expected");
      g.metric = $root.Metric.fromObject(A.metric);
    }
    if (A.multiselect != null) {
      if (typeof A.multiselect != "object") throw TypeError(".Element.multiselect: object expected");
      g.multiselect = $root.MultiSelect.fromObject(A.multiselect);
    }
    if (A.numberInput != null) {
      if (typeof A.numberInput != "object") throw TypeError(".Element.numberInput: object expected");
      g.numberInput = $root.NumberInput.fromObject(A.numberInput);
    }
    if (A.pageLink != null) {
      if (typeof A.pageLink != "object") throw TypeError(".Element.pageLink: object expected");
      g.pageLink = $root.PageLink.fromObject(A.pageLink);
    }
    if (A.plotlyChart != null) {
      if (typeof A.plotlyChart != "object") throw TypeError(".Element.plotlyChart: object expected");
      g.plotlyChart = $root.PlotlyChart.fromObject(A.plotlyChart);
    }
    if (A.progress != null) {
      if (typeof A.progress != "object") throw TypeError(".Element.progress: object expected");
      g.progress = $root.Progress.fromObject(A.progress);
    }
    if (A.radio != null) {
      if (typeof A.radio != "object") throw TypeError(".Element.radio: object expected");
      g.radio = $root.Radio.fromObject(A.radio);
    }
    if (A.selectbox != null) {
      if (typeof A.selectbox != "object") throw TypeError(".Element.selectbox: object expected");
      g.selectbox = $root.Selectbox.fromObject(A.selectbox);
    }
    if (A.skeleton != null) {
      if (typeof A.skeleton != "object") throw TypeError(".Element.skeleton: object expected");
      g.skeleton = $root.Skeleton.fromObject(A.skeleton);
    }
    if (A.slider != null) {
      if (typeof A.slider != "object") throw TypeError(".Element.slider: object expected");
      g.slider = $root.Slider.fromObject(A.slider);
    }
    if (A.snow != null) {
      if (typeof A.snow != "object") throw TypeError(".Element.snow: object expected");
      g.snow = $root.Snow.fromObject(A.snow);
    }
    if (A.space != null) {
      if (typeof A.space != "object") throw TypeError(".Element.space: object expected");
      g.space = $root.Space.fromObject(A.space);
    }
    if (A.spinner != null) {
      if (typeof A.spinner != "object") throw TypeError(".Element.spinner: object expected");
      g.spinner = $root.Spinner.fromObject(A.spinner);
    }
    if (A.text != null) {
      if (typeof A.text != "object") throw TypeError(".Element.text: object expected");
      g.text = $root.Text.fromObject(A.text);
    }
    if (A.textArea != null) {
      if (typeof A.textArea != "object") throw TypeError(".Element.textArea: object expected");
      g.textArea = $root.TextArea.fromObject(A.textArea);
    }
    if (A.textInput != null) {
      if (typeof A.textInput != "object") throw TypeError(".Element.textInput: object expected");
      g.textInput = $root.TextInput.fromObject(A.textInput);
    }
    if (A.timeInput != null) {
      if (typeof A.timeInput != "object") throw TypeError(".Element.timeInput: object expected");
      g.timeInput = $root.TimeInput.fromObject(A.timeInput);
    }
    if (A.dateTimeInput != null) {
      if (typeof A.dateTimeInput != "object") throw TypeError(".Element.dateTimeInput: object expected");
      g.dateTimeInput = $root.DateTimeInput.fromObject(A.dateTimeInput);
    }
    if (A.toast != null) {
      if (typeof A.toast != "object") throw TypeError(".Element.toast: object expected");
      g.toast = $root.Toast.fromObject(A.toast);
    }
    if (A.vegaLiteChart != null) {
      if (typeof A.vegaLiteChart != "object") throw TypeError(".Element.vegaLiteChart: object expected");
      g.vegaLiteChart = $root.VegaLiteChart.fromObject(A.vegaLiteChart);
    }
    if (A.video != null) {
      if (typeof A.video != "object") throw TypeError(".Element.video: object expected");
      g.video = $root.Video.fromObject(A.video);
    }
    if (A.heading != null) {
      if (typeof A.heading != "object") throw TypeError(".Element.heading: object expected");
      g.heading = $root.Heading.fromObject(A.heading);
    }
    if (A.code != null) {
      if (typeof A.code != "object") throw TypeError(".Element.code: object expected");
      g.code = $root.Code.fromObject(A.code);
    }
    return g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    return A.text != null && A.hasOwnProperty("text") && (e.text = $root.Text.toObject(A.text, g), g.oneofs && (e.type = "text")), A.empty != null && A.hasOwnProperty("empty") && (e.empty = $root.Empty.toObject(A.empty, g), g.oneofs && (e.type = "empty")), A.dataFrame != null && A.hasOwnProperty("dataFrame") && (e.dataFrame = $root.DataFrame.toObject(A.dataFrame, g), g.oneofs && (e.type = "dataFrame")), A.progress != null && A.hasOwnProperty("progress") && (e.progress = $root.Progress.toObject(A.progress, g), g.oneofs && (e.type = "progress")), A.imgs != null && A.hasOwnProperty("imgs") && (e.imgs = $root.ImageList.toObject(A.imgs, g), g.oneofs && (e.type = "imgs")), A.docString != null && A.hasOwnProperty("docString") && (e.docString = $root.DocString.toObject(A.docString, g), g.oneofs && (e.type = "docString")), A.exception != null && A.hasOwnProperty("exception") && (e.exception = $root.Exception.toObject(A.exception, g), g.oneofs && (e.type = "exception")), A.vegaLiteChart != null && A.hasOwnProperty("vegaLiteChart") && (e.vegaLiteChart = $root.VegaLiteChart.toObject(A.vegaLiteChart, g), g.oneofs && (e.type = "vegaLiteChart")), A.table != null && A.hasOwnProperty("table") && (e.table = $root.DataFrame.toObject(A.table, g), g.oneofs && (e.type = "table")), A.balloons != null && A.hasOwnProperty("balloons") && (e.balloons = $root.Balloons.toObject(A.balloons, g), g.oneofs && (e.type = "balloons")), A.audio != null && A.hasOwnProperty("audio") && (e.audio = $root.Audio.toObject(A.audio, g), g.oneofs && (e.type = "audio")), A.video != null && A.hasOwnProperty("video") && (e.video = $root.Video.toObject(A.video, g), g.oneofs && (e.type = "video")), A.plotlyChart != null && A.hasOwnProperty("plotlyChart") && (e.plotlyChart = $root.PlotlyChart.toObject(A.plotlyChart, g), g.oneofs && (e.type = "plotlyChart")), A.bokehChart != null && A.hasOwnProperty("bokehChart") && (e.bokehChart = $root.BokehChart.toObject(A.bokehChart, g), g.oneofs && (e.type = "bokehChart")), A.graphvizChart != null && A.hasOwnProperty("graphvizChart") && (e.graphvizChart = $root.GraphVizChart.toObject(A.graphvizChart, g), g.oneofs && (e.type = "graphvizChart")), A.button != null && A.hasOwnProperty("button") && (e.button = $root.Button.toObject(A.button, g), g.oneofs && (e.type = "button")), A.checkbox != null && A.hasOwnProperty("checkbox") && (e.checkbox = $root.Checkbox.toObject(A.checkbox, g), g.oneofs && (e.type = "checkbox")), A.slider != null && A.hasOwnProperty("slider") && (e.slider = $root.Slider.toObject(A.slider, g), g.oneofs && (e.type = "slider")), A.textArea != null && A.hasOwnProperty("textArea") && (e.textArea = $root.TextArea.toObject(A.textArea, g), g.oneofs && (e.type = "textArea")), A.radio != null && A.hasOwnProperty("radio") && (e.radio = $root.Radio.toObject(A.radio, g), g.oneofs && (e.type = "radio")), A.textInput != null && A.hasOwnProperty("textInput") && (e.textInput = $root.TextInput.toObject(A.textInput, g), g.oneofs && (e.type = "textInput")), A.selectbox != null && A.hasOwnProperty("selectbox") && (e.selectbox = $root.Selectbox.toObject(A.selectbox, g), g.oneofs && (e.type = "selectbox")), A.timeInput != null && A.hasOwnProperty("timeInput") && (e.timeInput = $root.TimeInput.toObject(A.timeInput, g), g.oneofs && (e.type = "timeInput")), A.dateInput != null && A.hasOwnProperty("dateInput") && (e.dateInput = $root.DateInput.toObject(A.dateInput, g), g.oneofs && (e.type = "dateInput")), A.multiselect != null && A.hasOwnProperty("multiselect") && (e.multiselect = $root.MultiSelect.toObject(A.multiselect, g), g.oneofs && (e.type = "multiselect")), A.markdown != null && A.hasOwnProperty("markdown") && (e.markdown = $root.Markdown.toObject(A.markdown, g), g.oneofs && (e.type = "markdown")), A.alert != null && A.hasOwnProperty("alert") && (e.alert = $root.Alert.toObject(A.alert, g), g.oneofs && (e.type = "alert")), A.json != null && A.hasOwnProperty("json") && (e.json = $root.Json.toObject(A.json, g), g.oneofs && (e.type = "json")), A.numberInput != null && A.hasOwnProperty("numberInput") && (e.numberInput = $root.NumberInput.toObject(A.numberInput, g), g.oneofs && (e.type = "numberInput")), A.fileUploader != null && A.hasOwnProperty("fileUploader") && (e.fileUploader = $root.FileUploader.toObject(A.fileUploader, g), g.oneofs && (e.type = "fileUploader")), A.deckGlJsonChart != null && A.hasOwnProperty("deckGlJsonChart") && (e.deckGlJsonChart = $root.DeckGlJsonChart.toObject(A.deckGlJsonChart, g), g.oneofs && (e.type = "deckGlJsonChart")), A.colorPicker != null && A.hasOwnProperty("colorPicker") && (e.colorPicker = $root.ColorPicker.toObject(A.colorPicker, g), g.oneofs && (e.type = "colorPicker")), A.favicon != null && A.hasOwnProperty("favicon") && (e.favicon = $root.Favicon.toObject(A.favicon, g), g.oneofs && (e.type = "favicon")), A.componentInstance != null && A.hasOwnProperty("componentInstance") && (e.componentInstance = $root.ComponentInstance.toObject(A.componentInstance, g), g.oneofs && (e.type = "componentInstance")), A.iframe != null && A.hasOwnProperty("iframe") && (e.iframe = $root.IFrame.toObject(A.iframe, g), g.oneofs && (e.type = "iframe")), A.arrowTable != null && A.hasOwnProperty("arrowTable") && (e.arrowTable = $root.Arrow.toObject(A.arrowTable, g), g.oneofs && (e.type = "arrowTable")), A.arrowDataFrame != null && A.hasOwnProperty("arrowDataFrame") && (e.arrowDataFrame = $root.Arrow.toObject(A.arrowDataFrame, g), g.oneofs && (e.type = "arrowDataFrame")), A.arrowVegaLiteChart != null && A.hasOwnProperty("arrowVegaLiteChart") && (e.arrowVegaLiteChart = $root.ArrowVegaLiteChart.toObject(A.arrowVegaLiteChart, g), g.oneofs && (e.type = "arrowVegaLiteChart")), A.metric != null && A.hasOwnProperty("metric") && (e.metric = $root.Metric.toObject(A.metric, g), g.oneofs && (e.type = "metric")), A.downloadButton != null && A.hasOwnProperty("downloadButton") && (e.downloadButton = $root.DownloadButton.toObject(A.downloadButton, g), g.oneofs && (e.type = "downloadButton")), A.spinner != null && A.hasOwnProperty("spinner") && (e.spinner = $root.Spinner.toObject(A.spinner, g), g.oneofs && (e.type = "spinner")), A.cameraInput != null && A.hasOwnProperty("cameraInput") && (e.cameraInput = $root.CameraInput.toObject(A.cameraInput, g), g.oneofs && (e.type = "cameraInput")), A.snow != null && A.hasOwnProperty("snow") && (e.snow = $root.Snow.toObject(A.snow, g), g.oneofs && (e.type = "snow")), A.heading != null && A.hasOwnProperty("heading") && (e.heading = $root.Heading.toObject(A.heading, g), g.oneofs && (e.type = "heading")), A.code != null && A.hasOwnProperty("code") && (e.code = $root.Code.toObject(A.code, g), g.oneofs && (e.type = "code")), A.chatInput != null && A.hasOwnProperty("chatInput") && (e.chatInput = $root.ChatInput.toObject(A.chatInput, g), g.oneofs && (e.type = "chatInput")), A.toast != null && A.hasOwnProperty("toast") && (e.toast = $root.Toast.toObject(A.toast, g), g.oneofs && (e.type = "toast")), A.linkButton != null && A.hasOwnProperty("linkButton") && (e.linkButton = $root.LinkButton.toObject(A.linkButton, g), g.oneofs && (e.type = "linkButton")), A.skeleton != null && A.hasOwnProperty("skeleton") && (e.skeleton = $root.Skeleton.toObject(A.skeleton, g), g.oneofs && (e.type = "skeleton")), A.pageLink != null && A.hasOwnProperty("pageLink") && (e.pageLink = $root.PageLink.toObject(A.pageLink, g), g.oneofs && (e.type = "pageLink")), A.html != null && A.hasOwnProperty("html") && (e.html = $root.Html.toObject(A.html, g), g.oneofs && (e.type = "html")), A.buttonGroup != null && A.hasOwnProperty("buttonGroup") && (e.buttonGroup = $root.ButtonGroup.toObject(A.buttonGroup, g), g.oneofs && (e.type = "buttonGroup")), A.audioInput != null && A.hasOwnProperty("audioInput") && (e.audioInput = $root.AudioInput.toObject(A.audioInput, g), g.oneofs && (e.type = "audioInput")), A.heightConfig != null && A.hasOwnProperty("heightConfig") && (e.heightConfig = $root.streamlit.HeightConfig.toObject(A.heightConfig, g), g.oneofs && (e._heightConfig = "heightConfig")), A.widthConfig != null && A.hasOwnProperty("widthConfig") && (e.widthConfig = $root.streamlit.WidthConfig.toObject(A.widthConfig, g), g.oneofs && (e._widthConfig = "widthConfig")), A.bidiComponent != null && A.hasOwnProperty("bidiComponent") && (e.bidiComponent = $root.BidiComponent.toObject(A.bidiComponent, g), g.oneofs && (e.type = "bidiComponent")), A.space != null && A.hasOwnProperty("space") && (e.space = $root.Space.toObject(A.space, g), g.oneofs && (e.type = "space")), A.textAlignmentConfig != null && A.hasOwnProperty("textAlignmentConfig") && (e.textAlignmentConfig = $root.streamlit.TextAlignmentConfig.toObject(A.textAlignmentConfig, g), g.oneofs && (e._textAlignmentConfig = "textAlignmentConfig")), A.dateTimeInput != null && A.hasOwnProperty("dateTimeInput") && (e.dateTimeInput = $root.DateTimeInput.toObject(A.dateTimeInput, g), g.oneofs && (e.type = "dateTimeInput")), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/Element";
  }, o;
})();
$root.DownloadButton = (() => {
  function o(A) {
    if (A) for (let g = Object.keys(A), e = 0; e < g.length; ++e) A[g[e]] != null && (this[g[e]] = A[g[e]]);
  }
  o.prototype.id = "", o.prototype.label = "", o.prototype.default = !1, o.prototype.help = "", o.prototype.formId = "", o.prototype.url = "", o.prototype.disabled = !1, o.prototype.useContainerWidth = !1, o.prototype.type = "", o.prototype.icon = "", o.prototype.ignoreRerun = !1, o.prototype.deferredFileId = null, o.prototype.shortcut = "";
  let E;
  return Object.defineProperty(o.prototype, "_deferredFileId", { get: $util.oneOfGetter(E = ["deferredFileId"]), set: $util.oneOfSetter(E) }), o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    return g || (g = $Writer.create()), A.id != null && Object.hasOwnProperty.call(A, "id") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(A.id), A.label != null && Object.hasOwnProperty.call(A, "label") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(A.label), A.default != null && Object.hasOwnProperty.call(A, "default") && g.uint32(
      /* id 3, wireType 0 =*/
      24
    ).bool(A.default), A.help != null && Object.hasOwnProperty.call(A, "help") && g.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(A.help), A.formId != null && Object.hasOwnProperty.call(A, "formId") && g.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(A.formId), A.url != null && Object.hasOwnProperty.call(A, "url") && g.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(A.url), A.disabled != null && Object.hasOwnProperty.call(A, "disabled") && g.uint32(
      /* id 7, wireType 0 =*/
      56
    ).bool(A.disabled), A.useContainerWidth != null && Object.hasOwnProperty.call(A, "useContainerWidth") && g.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(A.useContainerWidth), A.type != null && Object.hasOwnProperty.call(A, "type") && g.uint32(
      /* id 9, wireType 2 =*/
      74
    ).string(A.type), A.icon != null && Object.hasOwnProperty.call(A, "icon") && g.uint32(
      /* id 10, wireType 2 =*/
      82
    ).string(A.icon), A.ignoreRerun != null && Object.hasOwnProperty.call(A, "ignoreRerun") && g.uint32(
      /* id 11, wireType 0 =*/
      88
    ).bool(A.ignoreRerun), A.deferredFileId != null && Object.hasOwnProperty.call(A, "deferredFileId") && g.uint32(
      /* id 12, wireType 2 =*/
      98
    ).string(A.deferredFileId), A.shortcut != null && Object.hasOwnProperty.call(A, "shortcut") && g.uint32(
      /* id 13, wireType 2 =*/
      106
    ).string(A.shortcut), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader || (A = $Reader.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root.DownloadButton();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.id = A.string();
          break;
        }
        case 2: {
          c.label = A.string();
          break;
        }
        case 3: {
          c.default = A.bool();
          break;
        }
        case 4: {
          c.help = A.string();
          break;
        }
        case 5: {
          c.formId = A.string();
          break;
        }
        case 6: {
          c.url = A.string();
          break;
        }
        case 7: {
          c.disabled = A.bool();
          break;
        }
        case 8: {
          c.useContainerWidth = A.bool();
          break;
        }
        case 9: {
          c.type = A.string();
          break;
        }
        case 10: {
          c.icon = A.string();
          break;
        }
        case 11: {
          c.ignoreRerun = A.bool();
          break;
        }
        case 12: {
          c.deferredFileId = A.string();
          break;
        }
        case 13: {
          c.shortcut = A.string();
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root.DownloadButton) return A;
    let g = new $root.DownloadButton();
    return A.id != null && (g.id = String(A.id)), A.label != null && (g.label = String(A.label)), A.default != null && (g.default = !!A.default), A.help != null && (g.help = String(A.help)), A.formId != null && (g.formId = String(A.formId)), A.url != null && (g.url = String(A.url)), A.disabled != null && (g.disabled = !!A.disabled), A.useContainerWidth != null && (g.useContainerWidth = !!A.useContainerWidth), A.type != null && (g.type = String(A.type)), A.icon != null && (g.icon = String(A.icon)), A.ignoreRerun != null && (g.ignoreRerun = !!A.ignoreRerun), A.deferredFileId != null && (g.deferredFileId = String(A.deferredFileId)), A.shortcut != null && (g.shortcut = String(A.shortcut)), g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    return g.defaults && (e.id = "", e.label = "", e.default = !1, e.help = "", e.formId = "", e.url = "", e.disabled = !1, e.useContainerWidth = !1, e.type = "", e.icon = "", e.ignoreRerun = !1, e.shortcut = ""), A.id != null && A.hasOwnProperty("id") && (e.id = A.id), A.label != null && A.hasOwnProperty("label") && (e.label = A.label), A.default != null && A.hasOwnProperty("default") && (e.default = A.default), A.help != null && A.hasOwnProperty("help") && (e.help = A.help), A.formId != null && A.hasOwnProperty("formId") && (e.formId = A.formId), A.url != null && A.hasOwnProperty("url") && (e.url = A.url), A.disabled != null && A.hasOwnProperty("disabled") && (e.disabled = A.disabled), A.useContainerWidth != null && A.hasOwnProperty("useContainerWidth") && (e.useContainerWidth = A.useContainerWidth), A.type != null && A.hasOwnProperty("type") && (e.type = A.type), A.icon != null && A.hasOwnProperty("icon") && (e.icon = A.icon), A.ignoreRerun != null && A.hasOwnProperty("ignoreRerun") && (e.ignoreRerun = A.ignoreRerun), A.deferredFileId != null && A.hasOwnProperty("deferredFileId") && (e.deferredFileId = A.deferredFileId, g.oneofs && (e._deferredFileId = "deferredFileId")), A.shortcut != null && A.hasOwnProperty("shortcut") && (e.shortcut = A.shortcut), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/DownloadButton";
  }, o;
})();
$root.DocString = (() => {
  function o(E) {
    if (this.members = [], E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.docString = "", o.prototype.type = "", o.prototype.name = "", o.prototype.value = "", o.prototype.members = $util.emptyArray, o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, A) {
    if (A || (A = $Writer.create()), E.docString != null && Object.hasOwnProperty.call(E, "docString") && A.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(E.docString), E.type != null && Object.hasOwnProperty.call(E, "type") && A.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(E.type), E.name != null && Object.hasOwnProperty.call(E, "name") && A.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(E.name), E.value != null && Object.hasOwnProperty.call(E, "value") && A.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(E.value), E.members != null && E.members.length) for (let g = 0; g < E.members.length; ++g) $root.Member.encode(E.members[g], A.uint32(
      /* id 8, wireType 2 =*/
      66
    ).fork()).ldelim();
    return A;
  }, o.decode = function(E, A, g) {
    E instanceof $Reader || (E = $Reader.create(E));
    let e = A === void 0 ? E.len : E.pos + A, t = new $root.DocString();
    for (; E.pos < e; ) {
      let c = E.uint32();
      if (c === g) break;
      switch (c >>> 3) {
        case 3: {
          t.docString = E.string();
          break;
        }
        case 4: {
          t.type = E.string();
          break;
        }
        case 6: {
          t.name = E.string();
          break;
        }
        case 7: {
          t.value = E.string();
          break;
        }
        case 8: {
          t.members && t.members.length || (t.members = []), t.members.push($root.Member.decode(E, E.uint32()));
          break;
        }
        default:
          E.skipType(c & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(E) {
    if (E instanceof $root.DocString) return E;
    let A = new $root.DocString();
    if (E.docString != null && (A.docString = String(E.docString)), E.type != null && (A.type = String(E.type)), E.name != null && (A.name = String(E.name)), E.value != null && (A.value = String(E.value)), E.members) {
      if (!Array.isArray(E.members)) throw TypeError(".DocString.members: array expected");
      A.members = [];
      for (let g = 0; g < E.members.length; ++g) {
        if (typeof E.members[g] != "object") throw TypeError(".DocString.members: object expected");
        A.members[g] = $root.Member.fromObject(E.members[g]);
      }
    }
    return A;
  }, o.toObject = function(E, A) {
    A || (A = {});
    let g = {};
    if ((A.arrays || A.defaults) && (g.members = []), A.defaults && (g.docString = "", g.type = "", g.name = "", g.value = ""), E.docString != null && E.hasOwnProperty("docString") && (g.docString = E.docString), E.type != null && E.hasOwnProperty("type") && (g.type = E.type), E.name != null && E.hasOwnProperty("name") && (g.name = E.name), E.value != null && E.hasOwnProperty("value") && (g.value = E.value), E.members && E.members.length) {
      g.members = [];
      for (let e = 0; e < E.members.length; ++e) g.members[e] = $root.Member.toObject(E.members[e], A);
    }
    return g;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/DocString";
  }, o;
})();
$root.Member = (() => {
  function o(A) {
    if (A) for (let g = Object.keys(A), e = 0; e < g.length; ++e) A[g[e]] != null && (this[g[e]] = A[g[e]]);
  }
  o.prototype.name = "", o.prototype.type = "", o.prototype.value = null, o.prototype.docString = null;
  let E;
  return Object.defineProperty(o.prototype, "contents", { get: $util.oneOfGetter(E = ["value", "docString"]), set: $util.oneOfSetter(E) }), o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    return g || (g = $Writer.create()), A.name != null && Object.hasOwnProperty.call(A, "name") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(A.name), A.type != null && Object.hasOwnProperty.call(A, "type") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(A.type), A.value != null && Object.hasOwnProperty.call(A, "value") && g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(A.value), A.docString != null && Object.hasOwnProperty.call(A, "docString") && g.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(A.docString), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader || (A = $Reader.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root.Member();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.name = A.string();
          break;
        }
        case 2: {
          c.type = A.string();
          break;
        }
        case 3: {
          c.value = A.string();
          break;
        }
        case 4: {
          c.docString = A.string();
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root.Member) return A;
    let g = new $root.Member();
    return A.name != null && (g.name = String(A.name)), A.type != null && (g.type = String(A.type)), A.value != null && (g.value = String(A.value)), A.docString != null && (g.docString = String(A.docString)), g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    return g.defaults && (e.name = "", e.type = ""), A.name != null && A.hasOwnProperty("name") && (e.name = A.name), A.type != null && A.hasOwnProperty("type") && (e.type = A.type), A.value != null && A.hasOwnProperty("value") && (e.value = A.value, g.oneofs && (e.contents = "value")), A.docString != null && A.hasOwnProperty("docString") && (e.docString = A.docString, g.oneofs && (e.contents = "docString")), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/Member";
  }, o;
})();
$root.Empty = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, A) {
    return A || (A = $Writer.create()), A;
  }, o.decode = function(E, A, g) {
    E instanceof $Reader || (E = $Reader.create(E));
    let e = A === void 0 ? E.len : E.pos + A, t = new $root.Empty();
    for (; E.pos < e; ) {
      let c = E.uint32();
      if (c === g) break;
      switch (c >>> 3) {
        default:
          E.skipType(c & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(E) {
    return E instanceof $root.Empty ? E : new $root.Empty();
  }, o.toObject = function() {
    return {};
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/Empty";
  }, o;
})();
$root.Exception = (() => {
  function o(E) {
    if (this.stackTrace = [], E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.type = "", o.prototype.message = "", o.prototype.messageIsMarkdown = !1, o.prototype.stackTrace = $util.emptyArray, o.prototype.isWarning = !1, o.prototype.widthConfig = null, o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, A) {
    if (A || (A = $Writer.create()), E.type != null && Object.hasOwnProperty.call(E, "type") && A.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(E.type), E.message != null && Object.hasOwnProperty.call(E, "message") && A.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(E.message), E.stackTrace != null && E.stackTrace.length) for (let g = 0; g < E.stackTrace.length; ++g) A.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(E.stackTrace[g]);
    return E.messageIsMarkdown != null && Object.hasOwnProperty.call(E, "messageIsMarkdown") && A.uint32(
      /* id 4, wireType 0 =*/
      32
    ).bool(E.messageIsMarkdown), E.isWarning != null && Object.hasOwnProperty.call(E, "isWarning") && A.uint32(
      /* id 5, wireType 0 =*/
      40
    ).bool(E.isWarning), E.widthConfig != null && Object.hasOwnProperty.call(E, "widthConfig") && $root.streamlit.WidthConfig.encode(E.widthConfig, A.uint32(
      /* id 6, wireType 2 =*/
      50
    ).fork()).ldelim(), A;
  }, o.decode = function(E, A, g) {
    E instanceof $Reader || (E = $Reader.create(E));
    let e = A === void 0 ? E.len : E.pos + A, t = new $root.Exception();
    for (; E.pos < e; ) {
      let c = E.uint32();
      if (c === g) break;
      switch (c >>> 3) {
        case 1: {
          t.type = E.string();
          break;
        }
        case 2: {
          t.message = E.string();
          break;
        }
        case 4: {
          t.messageIsMarkdown = E.bool();
          break;
        }
        case 3: {
          t.stackTrace && t.stackTrace.length || (t.stackTrace = []), t.stackTrace.push(E.string());
          break;
        }
        case 5: {
          t.isWarning = E.bool();
          break;
        }
        case 6: {
          t.widthConfig = $root.streamlit.WidthConfig.decode(E, E.uint32());
          break;
        }
        default:
          E.skipType(c & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(E) {
    if (E instanceof $root.Exception) return E;
    let A = new $root.Exception();
    if (E.type != null && (A.type = String(E.type)), E.message != null && (A.message = String(E.message)), E.messageIsMarkdown != null && (A.messageIsMarkdown = !!E.messageIsMarkdown), E.stackTrace) {
      if (!Array.isArray(E.stackTrace)) throw TypeError(".Exception.stackTrace: array expected");
      A.stackTrace = [];
      for (let g = 0; g < E.stackTrace.length; ++g) A.stackTrace[g] = String(E.stackTrace[g]);
    }
    if (E.isWarning != null && (A.isWarning = !!E.isWarning), E.widthConfig != null) {
      if (typeof E.widthConfig != "object") throw TypeError(".Exception.widthConfig: object expected");
      A.widthConfig = $root.streamlit.WidthConfig.fromObject(E.widthConfig);
    }
    return A;
  }, o.toObject = function(E, A) {
    A || (A = {});
    let g = {};
    if ((A.arrays || A.defaults) && (g.stackTrace = []), A.defaults && (g.type = "", g.message = "", g.messageIsMarkdown = !1, g.isWarning = !1, g.widthConfig = null), E.type != null && E.hasOwnProperty("type") && (g.type = E.type), E.message != null && E.hasOwnProperty("message") && (g.message = E.message), E.stackTrace && E.stackTrace.length) {
      g.stackTrace = [];
      for (let e = 0; e < E.stackTrace.length; ++e) g.stackTrace[e] = E.stackTrace[e];
    }
    return E.messageIsMarkdown != null && E.hasOwnProperty("messageIsMarkdown") && (g.messageIsMarkdown = E.messageIsMarkdown), E.isWarning != null && E.hasOwnProperty("isWarning") && (g.isWarning = E.isWarning), E.widthConfig != null && E.hasOwnProperty("widthConfig") && (g.widthConfig = $root.streamlit.WidthConfig.toObject(E.widthConfig, A)), g;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/Exception";
  }, o;
})();
$root.Favicon = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.url = "", o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, A) {
    return A || (A = $Writer.create()), E.url != null && Object.hasOwnProperty.call(E, "url") && A.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(E.url), A;
  }, o.decode = function(E, A, g) {
    E instanceof $Reader || (E = $Reader.create(E));
    let e = A === void 0 ? E.len : E.pos + A, t = new $root.Favicon();
    for (; E.pos < e; ) {
      let c = E.uint32();
      if (c === g) break;
      c >>> 3 === 1 ? t.url = E.string() : E.skipType(c & 7);
    }
    return t;
  }, o.fromObject = function(E) {
    if (E instanceof $root.Favicon) return E;
    let A = new $root.Favicon();
    return E.url != null && (A.url = String(E.url)), A;
  }, o.toObject = function(E, A) {
    A || (A = {});
    let g = {};
    return A.defaults && (g.url = ""), E.url != null && E.hasOwnProperty("url") && (g.url = E.url), g;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/Favicon";
  }, o;
})();
$root.FileUploader = (() => {
  function o(E) {
    if (this.type = [], E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.id = "", o.prototype.label = "", o.prototype.type = $util.emptyArray, o.prototype.maxUploadSizeMb = 0, o.prototype.multipleFiles = !1, o.prototype.help = "", o.prototype.formId = "", o.prototype.disabled = !1, o.prototype.labelVisibility = null, o.prototype.acceptDirectory = !1, o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, A) {
    if (A || (A = $Writer.create()), E.id != null && Object.hasOwnProperty.call(E, "id") && A.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(E.id), E.label != null && Object.hasOwnProperty.call(E, "label") && A.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(E.label), E.type != null && E.type.length) for (let g = 0; g < E.type.length; ++g) A.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(E.type[g]);
    return E.maxUploadSizeMb != null && Object.hasOwnProperty.call(E, "maxUploadSizeMb") && A.uint32(
      /* id 4, wireType 0 =*/
      32
    ).int32(E.maxUploadSizeMb), E.multipleFiles != null && Object.hasOwnProperty.call(E, "multipleFiles") && A.uint32(
      /* id 6, wireType 0 =*/
      48
    ).bool(E.multipleFiles), E.help != null && Object.hasOwnProperty.call(E, "help") && A.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(E.help), E.formId != null && Object.hasOwnProperty.call(E, "formId") && A.uint32(
      /* id 8, wireType 2 =*/
      66
    ).string(E.formId), E.disabled != null && Object.hasOwnProperty.call(E, "disabled") && A.uint32(
      /* id 9, wireType 0 =*/
      72
    ).bool(E.disabled), E.labelVisibility != null && Object.hasOwnProperty.call(E, "labelVisibility") && $root.LabelVisibilityMessage.encode(E.labelVisibility, A.uint32(
      /* id 10, wireType 2 =*/
      82
    ).fork()).ldelim(), E.acceptDirectory != null && Object.hasOwnProperty.call(E, "acceptDirectory") && A.uint32(
      /* id 11, wireType 0 =*/
      88
    ).bool(E.acceptDirectory), A;
  }, o.decode = function(E, A, g) {
    E instanceof $Reader || (E = $Reader.create(E));
    let e = A === void 0 ? E.len : E.pos + A, t = new $root.FileUploader();
    for (; E.pos < e; ) {
      let c = E.uint32();
      if (c === g) break;
      switch (c >>> 3) {
        case 1: {
          t.id = E.string();
          break;
        }
        case 2: {
          t.label = E.string();
          break;
        }
        case 3: {
          t.type && t.type.length || (t.type = []), t.type.push(E.string());
          break;
        }
        case 4: {
          t.maxUploadSizeMb = E.int32();
          break;
        }
        case 6: {
          t.multipleFiles = E.bool();
          break;
        }
        case 7: {
          t.help = E.string();
          break;
        }
        case 8: {
          t.formId = E.string();
          break;
        }
        case 9: {
          t.disabled = E.bool();
          break;
        }
        case 10: {
          t.labelVisibility = $root.LabelVisibilityMessage.decode(E, E.uint32());
          break;
        }
        case 11: {
          t.acceptDirectory = E.bool();
          break;
        }
        default:
          E.skipType(c & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(E) {
    if (E instanceof $root.FileUploader) return E;
    let A = new $root.FileUploader();
    if (E.id != null && (A.id = String(E.id)), E.label != null && (A.label = String(E.label)), E.type) {
      if (!Array.isArray(E.type)) throw TypeError(".FileUploader.type: array expected");
      A.type = [];
      for (let g = 0; g < E.type.length; ++g) A.type[g] = String(E.type[g]);
    }
    if (E.maxUploadSizeMb != null && (A.maxUploadSizeMb = E.maxUploadSizeMb | 0), E.multipleFiles != null && (A.multipleFiles = !!E.multipleFiles), E.help != null && (A.help = String(E.help)), E.formId != null && (A.formId = String(E.formId)), E.disabled != null && (A.disabled = !!E.disabled), E.labelVisibility != null) {
      if (typeof E.labelVisibility != "object") throw TypeError(".FileUploader.labelVisibility: object expected");
      A.labelVisibility = $root.LabelVisibilityMessage.fromObject(E.labelVisibility);
    }
    return E.acceptDirectory != null && (A.acceptDirectory = !!E.acceptDirectory), A;
  }, o.toObject = function(E, A) {
    A || (A = {});
    let g = {};
    if ((A.arrays || A.defaults) && (g.type = []), A.defaults && (g.id = "", g.label = "", g.maxUploadSizeMb = 0, g.multipleFiles = !1, g.help = "", g.formId = "", g.disabled = !1, g.labelVisibility = null, g.acceptDirectory = !1), E.id != null && E.hasOwnProperty("id") && (g.id = E.id), E.label != null && E.hasOwnProperty("label") && (g.label = E.label), E.type && E.type.length) {
      g.type = [];
      for (let e = 0; e < E.type.length; ++e) g.type[e] = E.type[e];
    }
    return E.maxUploadSizeMb != null && E.hasOwnProperty("maxUploadSizeMb") && (g.maxUploadSizeMb = E.maxUploadSizeMb), E.multipleFiles != null && E.hasOwnProperty("multipleFiles") && (g.multipleFiles = E.multipleFiles), E.help != null && E.hasOwnProperty("help") && (g.help = E.help), E.formId != null && E.hasOwnProperty("formId") && (g.formId = E.formId), E.disabled != null && E.hasOwnProperty("disabled") && (g.disabled = E.disabled), E.labelVisibility != null && E.hasOwnProperty("labelVisibility") && (g.labelVisibility = $root.LabelVisibilityMessage.toObject(E.labelVisibility, A)), E.acceptDirectory != null && E.hasOwnProperty("acceptDirectory") && (g.acceptDirectory = E.acceptDirectory), g;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/FileUploader";
  }, o;
})();
$root.GraphVizChart = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.spec = "", o.prototype.useContainerWidth = !1, o.prototype.elementId = "", o.prototype.engine = "", o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, A) {
    return A || (A = $Writer.create()), E.spec != null && Object.hasOwnProperty.call(E, "spec") && A.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(E.spec), E.useContainerWidth != null && Object.hasOwnProperty.call(E, "useContainerWidth") && A.uint32(
      /* id 4, wireType 0 =*/
      32
    ).bool(E.useContainerWidth), E.elementId != null && Object.hasOwnProperty.call(E, "elementId") && A.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(E.elementId), E.engine != null && Object.hasOwnProperty.call(E, "engine") && A.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(E.engine), A;
  }, o.decode = function(E, A, g) {
    E instanceof $Reader || (E = $Reader.create(E));
    let e = A === void 0 ? E.len : E.pos + A, t = new $root.GraphVizChart();
    for (; E.pos < e; ) {
      let c = E.uint32();
      if (c === g) break;
      switch (c >>> 3) {
        case 1: {
          t.spec = E.string();
          break;
        }
        case 4: {
          t.useContainerWidth = E.bool();
          break;
        }
        case 5: {
          t.elementId = E.string();
          break;
        }
        case 6: {
          t.engine = E.string();
          break;
        }
        default:
          E.skipType(c & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(E) {
    if (E instanceof $root.GraphVizChart) return E;
    let A = new $root.GraphVizChart();
    return E.spec != null && (A.spec = String(E.spec)), E.useContainerWidth != null && (A.useContainerWidth = !!E.useContainerWidth), E.elementId != null && (A.elementId = String(E.elementId)), E.engine != null && (A.engine = String(E.engine)), A;
  }, o.toObject = function(E, A) {
    A || (A = {});
    let g = {};
    return A.defaults && (g.spec = "", g.useContainerWidth = !1, g.elementId = "", g.engine = ""), E.spec != null && E.hasOwnProperty("spec") && (g.spec = E.spec), E.useContainerWidth != null && E.hasOwnProperty("useContainerWidth") && (g.useContainerWidth = E.useContainerWidth), E.elementId != null && E.hasOwnProperty("elementId") && (g.elementId = E.elementId), E.engine != null && E.hasOwnProperty("engine") && (g.engine = E.engine), g;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/GraphVizChart";
  }, o;
})();
$root.Html = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.body = "", o.prototype.unsafeAllowJavascript = !1, o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, A) {
    return A || (A = $Writer.create()), E.body != null && Object.hasOwnProperty.call(E, "body") && A.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(E.body), E.unsafeAllowJavascript != null && Object.hasOwnProperty.call(E, "unsafeAllowJavascript") && A.uint32(
      /* id 2, wireType 0 =*/
      16
    ).bool(E.unsafeAllowJavascript), A;
  }, o.decode = function(E, A, g) {
    E instanceof $Reader || (E = $Reader.create(E));
    let e = A === void 0 ? E.len : E.pos + A, t = new $root.Html();
    for (; E.pos < e; ) {
      let c = E.uint32();
      if (c === g) break;
      switch (c >>> 3) {
        case 1: {
          t.body = E.string();
          break;
        }
        case 2: {
          t.unsafeAllowJavascript = E.bool();
          break;
        }
        default:
          E.skipType(c & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(E) {
    if (E instanceof $root.Html) return E;
    let A = new $root.Html();
    return E.body != null && (A.body = String(E.body)), E.unsafeAllowJavascript != null && (A.unsafeAllowJavascript = !!E.unsafeAllowJavascript), A;
  }, o.toObject = function(E, A) {
    A || (A = {});
    let g = {};
    return A.defaults && (g.body = "", g.unsafeAllowJavascript = !1), E.body != null && E.hasOwnProperty("body") && (g.body = E.body), E.unsafeAllowJavascript != null && E.hasOwnProperty("unsafeAllowJavascript") && (g.unsafeAllowJavascript = E.unsafeAllowJavascript), g;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/Html";
  }, o;
})();
$root.IFrame = (() => {
  function o(A) {
    if (A) for (let g = Object.keys(A), e = 0; e < g.length; ++e) A[g[e]] != null && (this[g[e]] = A[g[e]]);
  }
  o.prototype.src = null, o.prototype.srcdoc = null, o.prototype.width = 0, o.prototype.hasWidth = !1, o.prototype.height = 0, o.prototype.scrolling = !1, o.prototype.tabIndex = null;
  let E;
  return Object.defineProperty(o.prototype, "type", { get: $util.oneOfGetter(E = ["src", "srcdoc"]), set: $util.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_tabIndex", { get: $util.oneOfGetter(E = ["tabIndex"]), set: $util.oneOfSetter(E) }), o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    return g || (g = $Writer.create()), A.src != null && Object.hasOwnProperty.call(A, "src") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(A.src), A.srcdoc != null && Object.hasOwnProperty.call(A, "srcdoc") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(A.srcdoc), A.width != null && Object.hasOwnProperty.call(A, "width") && g.uint32(
      /* id 3, wireType 5 =*/
      29
    ).float(A.width), A.hasWidth != null && Object.hasOwnProperty.call(A, "hasWidth") && g.uint32(
      /* id 4, wireType 0 =*/
      32
    ).bool(A.hasWidth), A.height != null && Object.hasOwnProperty.call(A, "height") && g.uint32(
      /* id 5, wireType 5 =*/
      45
    ).float(A.height), A.scrolling != null && Object.hasOwnProperty.call(A, "scrolling") && g.uint32(
      /* id 7, wireType 0 =*/
      56
    ).bool(A.scrolling), A.tabIndex != null && Object.hasOwnProperty.call(A, "tabIndex") && g.uint32(
      /* id 8, wireType 0 =*/
      64
    ).int32(A.tabIndex), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader || (A = $Reader.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root.IFrame();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.src = A.string();
          break;
        }
        case 2: {
          c.srcdoc = A.string();
          break;
        }
        case 3: {
          c.width = A.float();
          break;
        }
        case 4: {
          c.hasWidth = A.bool();
          break;
        }
        case 5: {
          c.height = A.float();
          break;
        }
        case 7: {
          c.scrolling = A.bool();
          break;
        }
        case 8: {
          c.tabIndex = A.int32();
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root.IFrame) return A;
    let g = new $root.IFrame();
    return A.src != null && (g.src = String(A.src)), A.srcdoc != null && (g.srcdoc = String(A.srcdoc)), A.width != null && (g.width = Number(A.width)), A.hasWidth != null && (g.hasWidth = !!A.hasWidth), A.height != null && (g.height = Number(A.height)), A.scrolling != null && (g.scrolling = !!A.scrolling), A.tabIndex != null && (g.tabIndex = A.tabIndex | 0), g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    return g.defaults && (e.width = 0, e.hasWidth = !1, e.height = 0, e.scrolling = !1), A.src != null && A.hasOwnProperty("src") && (e.src = A.src, g.oneofs && (e.type = "src")), A.srcdoc != null && A.hasOwnProperty("srcdoc") && (e.srcdoc = A.srcdoc, g.oneofs && (e.type = "srcdoc")), A.width != null && A.hasOwnProperty("width") && (e.width = g.json && !isFinite(A.width) ? String(A.width) : A.width), A.hasWidth != null && A.hasOwnProperty("hasWidth") && (e.hasWidth = A.hasWidth), A.height != null && A.hasOwnProperty("height") && (e.height = g.json && !isFinite(A.height) ? String(A.height) : A.height), A.scrolling != null && A.hasOwnProperty("scrolling") && (e.scrolling = A.scrolling), A.tabIndex != null && A.hasOwnProperty("tabIndex") && (e.tabIndex = A.tabIndex, g.oneofs && (e._tabIndex = "tabIndex")), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/IFrame";
  }, o;
})();
$root.Image = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.url = "", o.prototype.caption = "", o.prototype.markup = "", o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, A) {
    return A || (A = $Writer.create()), E.caption != null && Object.hasOwnProperty.call(E, "caption") && A.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(E.caption), E.url != null && Object.hasOwnProperty.call(E, "url") && A.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(E.url), E.markup != null && Object.hasOwnProperty.call(E, "markup") && A.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(E.markup), A;
  }, o.decode = function(E, A, g) {
    E instanceof $Reader || (E = $Reader.create(E));
    let e = A === void 0 ? E.len : E.pos + A, t = new $root.Image();
    for (; E.pos < e; ) {
      let c = E.uint32();
      if (c === g) break;
      switch (c >>> 3) {
        case 3: {
          t.url = E.string();
          break;
        }
        case 2: {
          t.caption = E.string();
          break;
        }
        case 4: {
          t.markup = E.string();
          break;
        }
        default:
          E.skipType(c & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(E) {
    if (E instanceof $root.Image) return E;
    let A = new $root.Image();
    return E.url != null && (A.url = String(E.url)), E.caption != null && (A.caption = String(E.caption)), E.markup != null && (A.markup = String(E.markup)), A;
  }, o.toObject = function(E, A) {
    A || (A = {});
    let g = {};
    return A.defaults && (g.caption = "", g.url = "", g.markup = ""), E.caption != null && E.hasOwnProperty("caption") && (g.caption = E.caption), E.url != null && E.hasOwnProperty("url") && (g.url = E.url), E.markup != null && E.hasOwnProperty("markup") && (g.markup = E.markup), g;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/Image";
  }, o;
})();
$root.ImageList = (() => {
  function o(E) {
    if (this.imgs = [], E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.imgs = $util.emptyArray, o.prototype.width = 0, o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, A) {
    if (A || (A = $Writer.create()), E.imgs != null && E.imgs.length) for (let g = 0; g < E.imgs.length; ++g) $root.Image.encode(E.imgs[g], A.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim();
    return E.width != null && Object.hasOwnProperty.call(E, "width") && A.uint32(
      /* id 2, wireType 0 =*/
      16
    ).int32(E.width), A;
  }, o.decode = function(E, A, g) {
    E instanceof $Reader || (E = $Reader.create(E));
    let e = A === void 0 ? E.len : E.pos + A, t = new $root.ImageList();
    for (; E.pos < e; ) {
      let c = E.uint32();
      if (c === g) break;
      switch (c >>> 3) {
        case 1: {
          t.imgs && t.imgs.length || (t.imgs = []), t.imgs.push($root.Image.decode(E, E.uint32()));
          break;
        }
        case 2: {
          t.width = E.int32();
          break;
        }
        default:
          E.skipType(c & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(E) {
    if (E instanceof $root.ImageList) return E;
    let A = new $root.ImageList();
    if (E.imgs) {
      if (!Array.isArray(E.imgs)) throw TypeError(".ImageList.imgs: array expected");
      A.imgs = [];
      for (let g = 0; g < E.imgs.length; ++g) {
        if (typeof E.imgs[g] != "object") throw TypeError(".ImageList.imgs: object expected");
        A.imgs[g] = $root.Image.fromObject(E.imgs[g]);
      }
    }
    return E.width != null && (A.width = E.width | 0), A;
  }, o.toObject = function(E, A) {
    A || (A = {});
    let g = {};
    if ((A.arrays || A.defaults) && (g.imgs = []), A.defaults && (g.width = 0), E.imgs && E.imgs.length) {
      g.imgs = [];
      for (let e = 0; e < E.imgs.length; ++e) g.imgs[e] = $root.Image.toObject(E.imgs[e], A);
    }
    return E.width != null && E.hasOwnProperty("width") && (g.width = E.width), g;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/ImageList";
  }, o;
})();
$root.Json = (() => {
  function o(A) {
    if (A) for (let g = Object.keys(A), e = 0; e < g.length; ++e) A[g[e]] != null && (this[g[e]] = A[g[e]]);
  }
  o.prototype.body = "", o.prototype.expanded = !1, o.prototype.maxExpandDepth = null;
  let E;
  return Object.defineProperty(o.prototype, "_maxExpandDepth", { get: $util.oneOfGetter(E = ["maxExpandDepth"]), set: $util.oneOfSetter(E) }), o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    return g || (g = $Writer.create()), A.body != null && Object.hasOwnProperty.call(A, "body") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(A.body), A.expanded != null && Object.hasOwnProperty.call(A, "expanded") && g.uint32(
      /* id 2, wireType 0 =*/
      16
    ).bool(A.expanded), A.maxExpandDepth != null && Object.hasOwnProperty.call(A, "maxExpandDepth") && g.uint32(
      /* id 3, wireType 0 =*/
      24
    ).int32(A.maxExpandDepth), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader || (A = $Reader.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root.Json();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.body = A.string();
          break;
        }
        case 2: {
          c.expanded = A.bool();
          break;
        }
        case 3: {
          c.maxExpandDepth = A.int32();
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root.Json) return A;
    let g = new $root.Json();
    return A.body != null && (g.body = String(A.body)), A.expanded != null && (g.expanded = !!A.expanded), A.maxExpandDepth != null && (g.maxExpandDepth = A.maxExpandDepth | 0), g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    return g.defaults && (e.body = "", e.expanded = !1), A.body != null && A.hasOwnProperty("body") && (e.body = A.body), A.expanded != null && A.hasOwnProperty("expanded") && (e.expanded = A.expanded), A.maxExpandDepth != null && A.hasOwnProperty("maxExpandDepth") && (e.maxExpandDepth = A.maxExpandDepth, g.oneofs && (e._maxExpandDepth = "maxExpandDepth")), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/Json";
  }, o;
})();
$root.LinkButton = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.id = "", o.prototype.label = "", o.prototype.help = "", o.prototype.url = "", o.prototype.disabled = !1, o.prototype.useContainerWidth = !1, o.prototype.type = "", o.prototype.icon = "", o.prototype.shortcut = "", o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, A) {
    return A || (A = $Writer.create()), E.id != null && Object.hasOwnProperty.call(E, "id") && A.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(E.id), E.label != null && Object.hasOwnProperty.call(E, "label") && A.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(E.label), E.help != null && Object.hasOwnProperty.call(E, "help") && A.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(E.help), E.url != null && Object.hasOwnProperty.call(E, "url") && A.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(E.url), E.disabled != null && Object.hasOwnProperty.call(E, "disabled") && A.uint32(
      /* id 7, wireType 0 =*/
      56
    ).bool(E.disabled), E.useContainerWidth != null && Object.hasOwnProperty.call(E, "useContainerWidth") && A.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(E.useContainerWidth), E.type != null && Object.hasOwnProperty.call(E, "type") && A.uint32(
      /* id 9, wireType 2 =*/
      74
    ).string(E.type), E.icon != null && Object.hasOwnProperty.call(E, "icon") && A.uint32(
      /* id 10, wireType 2 =*/
      82
    ).string(E.icon), E.shortcut != null && Object.hasOwnProperty.call(E, "shortcut") && A.uint32(
      /* id 11, wireType 2 =*/
      90
    ).string(E.shortcut), A;
  }, o.decode = function(E, A, g) {
    E instanceof $Reader || (E = $Reader.create(E));
    let e = A === void 0 ? E.len : E.pos + A, t = new $root.LinkButton();
    for (; E.pos < e; ) {
      let c = E.uint32();
      if (c === g) break;
      switch (c >>> 3) {
        case 1: {
          t.id = E.string();
          break;
        }
        case 2: {
          t.label = E.string();
          break;
        }
        case 4: {
          t.help = E.string();
          break;
        }
        case 6: {
          t.url = E.string();
          break;
        }
        case 7: {
          t.disabled = E.bool();
          break;
        }
        case 8: {
          t.useContainerWidth = E.bool();
          break;
        }
        case 9: {
          t.type = E.string();
          break;
        }
        case 10: {
          t.icon = E.string();
          break;
        }
        case 11: {
          t.shortcut = E.string();
          break;
        }
        default:
          E.skipType(c & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(E) {
    if (E instanceof $root.LinkButton) return E;
    let A = new $root.LinkButton();
    return E.id != null && (A.id = String(E.id)), E.label != null && (A.label = String(E.label)), E.help != null && (A.help = String(E.help)), E.url != null && (A.url = String(E.url)), E.disabled != null && (A.disabled = !!E.disabled), E.useContainerWidth != null && (A.useContainerWidth = !!E.useContainerWidth), E.type != null && (A.type = String(E.type)), E.icon != null && (A.icon = String(E.icon)), E.shortcut != null && (A.shortcut = String(E.shortcut)), A;
  }, o.toObject = function(E, A) {
    A || (A = {});
    let g = {};
    return A.defaults && (g.id = "", g.label = "", g.help = "", g.url = "", g.disabled = !1, g.useContainerWidth = !1, g.type = "", g.icon = "", g.shortcut = ""), E.id != null && E.hasOwnProperty("id") && (g.id = E.id), E.label != null && E.hasOwnProperty("label") && (g.label = E.label), E.help != null && E.hasOwnProperty("help") && (g.help = E.help), E.url != null && E.hasOwnProperty("url") && (g.url = E.url), E.disabled != null && E.hasOwnProperty("disabled") && (g.disabled = E.disabled), E.useContainerWidth != null && E.hasOwnProperty("useContainerWidth") && (g.useContainerWidth = E.useContainerWidth), E.type != null && E.hasOwnProperty("type") && (g.type = E.type), E.icon != null && E.hasOwnProperty("icon") && (g.icon = E.icon), E.shortcut != null && E.hasOwnProperty("shortcut") && (g.shortcut = E.shortcut), g;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/LinkButton";
  }, o;
})();
$root.NumberInput = (() => {
  function o(A) {
    if (A) for (let g = Object.keys(A), e = 0; e < g.length; ++e) A[g[e]] != null && (this[g[e]] = A[g[e]]);
  }
  o.prototype.id = "", o.prototype.label = "", o.prototype.formId = "", o.prototype.format = "", o.prototype.hasMin = !1, o.prototype.hasMax = !1, o.prototype.dataType = 0, o.prototype.default = null, o.prototype.step = 0, o.prototype.min = 0, o.prototype.max = 0, o.prototype.help = "", o.prototype.value = null, o.prototype.setValue = !1, o.prototype.disabled = !1, o.prototype.labelVisibility = null, o.prototype.placeholder = "", o.prototype.icon = "";
  let E;
  return Object.defineProperty(o.prototype, "_default", { get: $util.oneOfGetter(E = ["default"]), set: $util.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_value", { get: $util.oneOfGetter(E = ["value"]), set: $util.oneOfSetter(E) }), o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    return g || (g = $Writer.create()), A.id != null && Object.hasOwnProperty.call(A, "id") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(A.id), A.label != null && Object.hasOwnProperty.call(A, "label") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(A.label), A.formId != null && Object.hasOwnProperty.call(A, "formId") && g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(A.formId), A.format != null && Object.hasOwnProperty.call(A, "format") && g.uint32(
      /* id 8, wireType 2 =*/
      66
    ).string(A.format), A.hasMin != null && Object.hasOwnProperty.call(A, "hasMin") && g.uint32(
      /* id 11, wireType 0 =*/
      88
    ).bool(A.hasMin), A.hasMax != null && Object.hasOwnProperty.call(A, "hasMax") && g.uint32(
      /* id 12, wireType 0 =*/
      96
    ).bool(A.hasMax), A.dataType != null && Object.hasOwnProperty.call(A, "dataType") && g.uint32(
      /* id 13, wireType 0 =*/
      104
    ).int32(A.dataType), A.default != null && Object.hasOwnProperty.call(A, "default") && g.uint32(
      /* id 14, wireType 1 =*/
      113
    ).double(A.default), A.step != null && Object.hasOwnProperty.call(A, "step") && g.uint32(
      /* id 15, wireType 1 =*/
      121
    ).double(A.step), A.min != null && Object.hasOwnProperty.call(A, "min") && g.uint32(
      /* id 16, wireType 1 =*/
      129
    ).double(A.min), A.max != null && Object.hasOwnProperty.call(A, "max") && g.uint32(
      /* id 17, wireType 1 =*/
      137
    ).double(A.max), A.help != null && Object.hasOwnProperty.call(A, "help") && g.uint32(
      /* id 18, wireType 2 =*/
      146
    ).string(A.help), A.value != null && Object.hasOwnProperty.call(A, "value") && g.uint32(
      /* id 19, wireType 1 =*/
      153
    ).double(A.value), A.setValue != null && Object.hasOwnProperty.call(A, "setValue") && g.uint32(
      /* id 20, wireType 0 =*/
      160
    ).bool(A.setValue), A.disabled != null && Object.hasOwnProperty.call(A, "disabled") && g.uint32(
      /* id 21, wireType 0 =*/
      168
    ).bool(A.disabled), A.labelVisibility != null && Object.hasOwnProperty.call(A, "labelVisibility") && $root.LabelVisibilityMessage.encode(A.labelVisibility, g.uint32(
      /* id 22, wireType 2 =*/
      178
    ).fork()).ldelim(), A.placeholder != null && Object.hasOwnProperty.call(A, "placeholder") && g.uint32(
      /* id 23, wireType 2 =*/
      186
    ).string(A.placeholder), A.icon != null && Object.hasOwnProperty.call(A, "icon") && g.uint32(
      /* id 24, wireType 2 =*/
      194
    ).string(A.icon), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader || (A = $Reader.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root.NumberInput();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.id = A.string();
          break;
        }
        case 2: {
          c.label = A.string();
          break;
        }
        case 3: {
          c.formId = A.string();
          break;
        }
        case 8: {
          c.format = A.string();
          break;
        }
        case 11: {
          c.hasMin = A.bool();
          break;
        }
        case 12: {
          c.hasMax = A.bool();
          break;
        }
        case 13: {
          c.dataType = A.int32();
          break;
        }
        case 14: {
          c.default = A.double();
          break;
        }
        case 15: {
          c.step = A.double();
          break;
        }
        case 16: {
          c.min = A.double();
          break;
        }
        case 17: {
          c.max = A.double();
          break;
        }
        case 18: {
          c.help = A.string();
          break;
        }
        case 19: {
          c.value = A.double();
          break;
        }
        case 20: {
          c.setValue = A.bool();
          break;
        }
        case 21: {
          c.disabled = A.bool();
          break;
        }
        case 22: {
          c.labelVisibility = $root.LabelVisibilityMessage.decode(A, A.uint32());
          break;
        }
        case 23: {
          c.placeholder = A.string();
          break;
        }
        case 24: {
          c.icon = A.string();
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root.NumberInput) return A;
    let g = new $root.NumberInput();
    switch (A.id != null && (g.id = String(A.id)), A.label != null && (g.label = String(A.label)), A.formId != null && (g.formId = String(A.formId)), A.format != null && (g.format = String(A.format)), A.hasMin != null && (g.hasMin = !!A.hasMin), A.hasMax != null && (g.hasMax = !!A.hasMax), A.dataType) {
      default:
        if (typeof A.dataType == "number") {
          g.dataType = A.dataType;
          break;
        }
        break;
      case "INT":
      case 0:
        g.dataType = 0;
        break;
      case "FLOAT":
      case 1:
        g.dataType = 1;
        break;
    }
    if (A.default != null && (g.default = Number(A.default)), A.step != null && (g.step = Number(A.step)), A.min != null && (g.min = Number(A.min)), A.max != null && (g.max = Number(A.max)), A.help != null && (g.help = String(A.help)), A.value != null && (g.value = Number(A.value)), A.setValue != null && (g.setValue = !!A.setValue), A.disabled != null && (g.disabled = !!A.disabled), A.labelVisibility != null) {
      if (typeof A.labelVisibility != "object") throw TypeError(".NumberInput.labelVisibility: object expected");
      g.labelVisibility = $root.LabelVisibilityMessage.fromObject(A.labelVisibility);
    }
    return A.placeholder != null && (g.placeholder = String(A.placeholder)), A.icon != null && (g.icon = String(A.icon)), g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    return g.defaults && (e.id = "", e.label = "", e.formId = "", e.format = "", e.hasMin = !1, e.hasMax = !1, e.dataType = g.enums === String ? "INT" : 0, e.step = 0, e.min = 0, e.max = 0, e.help = "", e.setValue = !1, e.disabled = !1, e.labelVisibility = null, e.placeholder = "", e.icon = ""), A.id != null && A.hasOwnProperty("id") && (e.id = A.id), A.label != null && A.hasOwnProperty("label") && (e.label = A.label), A.formId != null && A.hasOwnProperty("formId") && (e.formId = A.formId), A.format != null && A.hasOwnProperty("format") && (e.format = A.format), A.hasMin != null && A.hasOwnProperty("hasMin") && (e.hasMin = A.hasMin), A.hasMax != null && A.hasOwnProperty("hasMax") && (e.hasMax = A.hasMax), A.dataType != null && A.hasOwnProperty("dataType") && (e.dataType = g.enums === String ? $root.NumberInput.DataType[A.dataType] === void 0 ? A.dataType : $root.NumberInput.DataType[A.dataType] : A.dataType), A.default != null && A.hasOwnProperty("default") && (e.default = g.json && !isFinite(A.default) ? String(A.default) : A.default, g.oneofs && (e._default = "default")), A.step != null && A.hasOwnProperty("step") && (e.step = g.json && !isFinite(A.step) ? String(A.step) : A.step), A.min != null && A.hasOwnProperty("min") && (e.min = g.json && !isFinite(A.min) ? String(A.min) : A.min), A.max != null && A.hasOwnProperty("max") && (e.max = g.json && !isFinite(A.max) ? String(A.max) : A.max), A.help != null && A.hasOwnProperty("help") && (e.help = A.help), A.value != null && A.hasOwnProperty("value") && (e.value = g.json && !isFinite(A.value) ? String(A.value) : A.value, g.oneofs && (e._value = "value")), A.setValue != null && A.hasOwnProperty("setValue") && (e.setValue = A.setValue), A.disabled != null && A.hasOwnProperty("disabled") && (e.disabled = A.disabled), A.labelVisibility != null && A.hasOwnProperty("labelVisibility") && (e.labelVisibility = $root.LabelVisibilityMessage.toObject(A.labelVisibility, g)), A.placeholder != null && A.hasOwnProperty("placeholder") && (e.placeholder = A.placeholder), A.icon != null && A.hasOwnProperty("icon") && (e.icon = A.icon), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/NumberInput";
  }, o.DataType = (function() {
    const A = {}, g = Object.create(A);
    return g[A[0] = "INT"] = 0, g[A[1] = "FLOAT"] = 1, g;
  })(), o;
})();
$root.Markdown = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.body = "", o.prototype.allowHtml = !1, o.prototype.isCaption = !1, o.prototype.elementType = 0, o.prototype.help = "", o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, A) {
    return A || (A = $Writer.create()), E.body != null && Object.hasOwnProperty.call(E, "body") && A.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(E.body), E.allowHtml != null && Object.hasOwnProperty.call(E, "allowHtml") && A.uint32(
      /* id 2, wireType 0 =*/
      16
    ).bool(E.allowHtml), E.isCaption != null && Object.hasOwnProperty.call(E, "isCaption") && A.uint32(
      /* id 3, wireType 0 =*/
      24
    ).bool(E.isCaption), E.elementType != null && Object.hasOwnProperty.call(E, "elementType") && A.uint32(
      /* id 4, wireType 0 =*/
      32
    ).int32(E.elementType), E.help != null && Object.hasOwnProperty.call(E, "help") && A.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(E.help), A;
  }, o.decode = function(E, A, g) {
    E instanceof $Reader || (E = $Reader.create(E));
    let e = A === void 0 ? E.len : E.pos + A, t = new $root.Markdown();
    for (; E.pos < e; ) {
      let c = E.uint32();
      if (c === g) break;
      switch (c >>> 3) {
        case 1: {
          t.body = E.string();
          break;
        }
        case 2: {
          t.allowHtml = E.bool();
          break;
        }
        case 3: {
          t.isCaption = E.bool();
          break;
        }
        case 4: {
          t.elementType = E.int32();
          break;
        }
        case 5: {
          t.help = E.string();
          break;
        }
        default:
          E.skipType(c & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(E) {
    if (E instanceof $root.Markdown) return E;
    let A = new $root.Markdown();
    switch (E.body != null && (A.body = String(E.body)), E.allowHtml != null && (A.allowHtml = !!E.allowHtml), E.isCaption != null && (A.isCaption = !!E.isCaption), E.elementType) {
      default:
        if (typeof E.elementType == "number") {
          A.elementType = E.elementType;
          break;
        }
        break;
      case "UNSPECIFIED":
      case 0:
        A.elementType = 0;
        break;
      case "NATIVE":
      case 1:
        A.elementType = 1;
        break;
      case "CAPTION":
      case 2:
        A.elementType = 2;
        break;
      case "CODE":
      case 3:
        A.elementType = 3;
        break;
      case "LATEX":
      case 4:
        A.elementType = 4;
        break;
      case "DIVIDER":
      case 5:
        A.elementType = 5;
        break;
    }
    return E.help != null && (A.help = String(E.help)), A;
  }, o.toObject = function(E, A) {
    A || (A = {});
    let g = {};
    return A.defaults && (g.body = "", g.allowHtml = !1, g.isCaption = !1, g.elementType = A.enums === String ? "UNSPECIFIED" : 0, g.help = ""), E.body != null && E.hasOwnProperty("body") && (g.body = E.body), E.allowHtml != null && E.hasOwnProperty("allowHtml") && (g.allowHtml = E.allowHtml), E.isCaption != null && E.hasOwnProperty("isCaption") && (g.isCaption = E.isCaption), E.elementType != null && E.hasOwnProperty("elementType") && (g.elementType = A.enums === String ? $root.Markdown.Type[E.elementType] === void 0 ? E.elementType : $root.Markdown.Type[E.elementType] : E.elementType), E.help != null && E.hasOwnProperty("help") && (g.help = E.help), g;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/Markdown";
  }, o.Type = (function() {
    const E = {}, A = Object.create(E);
    return A[E[0] = "UNSPECIFIED"] = 0, A[E[1] = "NATIVE"] = 1, A[E[2] = "CAPTION"] = 2, A[E[3] = "CODE"] = 3, A[E[4] = "LATEX"] = 4, A[E[5] = "DIVIDER"] = 5, A;
  })(), o;
})();
$root.Metric = (() => {
  function o(E) {
    if (this.chartData = [], E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.label = "", o.prototype.body = "", o.prototype.delta = "", o.prototype.direction = 0, o.prototype.color = 0, o.prototype.help = "", o.prototype.labelVisibility = null, o.prototype.showBorder = !1, o.prototype.chartData = $util.emptyArray, o.prototype.chartType = 0, o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, A) {
    if (A || (A = $Writer.create()), E.label != null && Object.hasOwnProperty.call(E, "label") && A.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(E.label), E.body != null && Object.hasOwnProperty.call(E, "body") && A.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(E.body), E.delta != null && Object.hasOwnProperty.call(E, "delta") && A.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(E.delta), E.direction != null && Object.hasOwnProperty.call(E, "direction") && A.uint32(
      /* id 4, wireType 0 =*/
      32
    ).int32(E.direction), E.color != null && Object.hasOwnProperty.call(E, "color") && A.uint32(
      /* id 5, wireType 0 =*/
      40
    ).int32(E.color), E.help != null && Object.hasOwnProperty.call(E, "help") && A.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(E.help), E.labelVisibility != null && Object.hasOwnProperty.call(E, "labelVisibility") && $root.LabelVisibilityMessage.encode(E.labelVisibility, A.uint32(
      /* id 7, wireType 2 =*/
      58
    ).fork()).ldelim(), E.showBorder != null && Object.hasOwnProperty.call(E, "showBorder") && A.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(E.showBorder), E.chartData != null && E.chartData.length) {
      A.uint32(
        /* id 9, wireType 2 =*/
        74
      ).fork();
      for (let g = 0; g < E.chartData.length; ++g) A.double(E.chartData[g]);
      A.ldelim();
    }
    return E.chartType != null && Object.hasOwnProperty.call(E, "chartType") && A.uint32(
      /* id 10, wireType 0 =*/
      80
    ).int32(E.chartType), A;
  }, o.decode = function(E, A, g) {
    E instanceof $Reader || (E = $Reader.create(E));
    let e = A === void 0 ? E.len : E.pos + A, t = new $root.Metric();
    for (; E.pos < e; ) {
      let c = E.uint32();
      if (c === g) break;
      switch (c >>> 3) {
        case 1: {
          t.label = E.string();
          break;
        }
        case 2: {
          t.body = E.string();
          break;
        }
        case 3: {
          t.delta = E.string();
          break;
        }
        case 4: {
          t.direction = E.int32();
          break;
        }
        case 5: {
          t.color = E.int32();
          break;
        }
        case 6: {
          t.help = E.string();
          break;
        }
        case 7: {
          t.labelVisibility = $root.LabelVisibilityMessage.decode(E, E.uint32());
          break;
        }
        case 8: {
          t.showBorder = E.bool();
          break;
        }
        case 9: {
          if (t.chartData && t.chartData.length || (t.chartData = []), (c & 7) === 2) {
            let n = E.uint32() + E.pos;
            for (; E.pos < n; ) t.chartData.push(E.double());
          } else t.chartData.push(E.double());
          break;
        }
        case 10: {
          t.chartType = E.int32();
          break;
        }
        default:
          E.skipType(c & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(E) {
    if (E instanceof $root.Metric) return E;
    let A = new $root.Metric();
    switch (E.label != null && (A.label = String(E.label)), E.body != null && (A.body = String(E.body)), E.delta != null && (A.delta = String(E.delta)), E.direction) {
      default:
        if (typeof E.direction == "number") {
          A.direction = E.direction;
          break;
        }
        break;
      case "DOWN":
      case 0:
        A.direction = 0;
        break;
      case "UP":
      case 1:
        A.direction = 1;
        break;
      case "NONE":
      case 2:
        A.direction = 2;
        break;
    }
    switch (E.color) {
      default:
        if (typeof E.color == "number") {
          A.color = E.color;
          break;
        }
        break;
      case "RED":
      case 0:
        A.color = 0;
        break;
      case "GREEN":
      case 1:
        A.color = 1;
        break;
      case "GRAY":
      case 2:
        A.color = 2;
        break;
    }
    if (E.help != null && (A.help = String(E.help)), E.labelVisibility != null) {
      if (typeof E.labelVisibility != "object") throw TypeError(".Metric.labelVisibility: object expected");
      A.labelVisibility = $root.LabelVisibilityMessage.fromObject(E.labelVisibility);
    }
    if (E.showBorder != null && (A.showBorder = !!E.showBorder), E.chartData) {
      if (!Array.isArray(E.chartData)) throw TypeError(".Metric.chartData: array expected");
      A.chartData = [];
      for (let g = 0; g < E.chartData.length; ++g) A.chartData[g] = Number(E.chartData[g]);
    }
    switch (E.chartType) {
      default:
        if (typeof E.chartType == "number") {
          A.chartType = E.chartType;
          break;
        }
        break;
      case "LINE":
      case 0:
        A.chartType = 0;
        break;
      case "BAR":
      case 1:
        A.chartType = 1;
        break;
      case "AREA":
      case 2:
        A.chartType = 2;
        break;
    }
    return A;
  }, o.toObject = function(E, A) {
    A || (A = {});
    let g = {};
    if ((A.arrays || A.defaults) && (g.chartData = []), A.defaults && (g.label = "", g.body = "", g.delta = "", g.direction = A.enums === String ? "DOWN" : 0, g.color = A.enums === String ? "RED" : 0, g.help = "", g.labelVisibility = null, g.showBorder = !1, g.chartType = A.enums === String ? "LINE" : 0), E.label != null && E.hasOwnProperty("label") && (g.label = E.label), E.body != null && E.hasOwnProperty("body") && (g.body = E.body), E.delta != null && E.hasOwnProperty("delta") && (g.delta = E.delta), E.direction != null && E.hasOwnProperty("direction") && (g.direction = A.enums === String ? $root.Metric.MetricDirection[E.direction] === void 0 ? E.direction : $root.Metric.MetricDirection[E.direction] : E.direction), E.color != null && E.hasOwnProperty("color") && (g.color = A.enums === String ? $root.Metric.MetricColor[E.color] === void 0 ? E.color : $root.Metric.MetricColor[E.color] : E.color), E.help != null && E.hasOwnProperty("help") && (g.help = E.help), E.labelVisibility != null && E.hasOwnProperty("labelVisibility") && (g.labelVisibility = $root.LabelVisibilityMessage.toObject(E.labelVisibility, A)), E.showBorder != null && E.hasOwnProperty("showBorder") && (g.showBorder = E.showBorder), E.chartData && E.chartData.length) {
      g.chartData = [];
      for (let e = 0; e < E.chartData.length; ++e) g.chartData[e] = A.json && !isFinite(E.chartData[e]) ? String(E.chartData[e]) : E.chartData[e];
    }
    return E.chartType != null && E.hasOwnProperty("chartType") && (g.chartType = A.enums === String ? $root.Metric.ChartType[E.chartType] === void 0 ? E.chartType : $root.Metric.ChartType[E.chartType] : E.chartType), g;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/Metric";
  }, o.MetricDirection = (function() {
    const E = {}, A = Object.create(E);
    return A[E[0] = "DOWN"] = 0, A[E[1] = "UP"] = 1, A[E[2] = "NONE"] = 2, A;
  })(), o.MetricColor = (function() {
    const E = {}, A = Object.create(E);
    return A[E[0] = "RED"] = 0, A[E[1] = "GREEN"] = 1, A[E[2] = "GRAY"] = 2, A;
  })(), o.ChartType = (function() {
    const E = {}, A = Object.create(E);
    return A[E[0] = "LINE"] = 0, A[E[1] = "BAR"] = 1, A[E[2] = "AREA"] = 2, A;
  })(), o;
})();
$root.MultiSelect = (() => {
  function o(A) {
    if (this.default = [], this.options = [], this.value = [], this.rawValues = [], A) for (let g = Object.keys(A), e = 0; e < g.length; ++e) A[g[e]] != null && (this[g[e]] = A[g[e]]);
  }
  o.prototype.id = "", o.prototype.label = "", o.prototype.default = $util.emptyArray, o.prototype.options = $util.emptyArray, o.prototype.help = "", o.prototype.formId = "", o.prototype.value = $util.emptyArray, o.prototype.rawValues = $util.emptyArray, o.prototype.setValue = !1, o.prototype.disabled = !1, o.prototype.labelVisibility = null, o.prototype.maxSelections = 0, o.prototype.placeholder = "", o.prototype.acceptNewOptions = null;
  let E;
  return Object.defineProperty(o.prototype, "_acceptNewOptions", { get: $util.oneOfGetter(E = ["acceptNewOptions"]), set: $util.oneOfSetter(E) }), o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    if (g || (g = $Writer.create()), A.id != null && Object.hasOwnProperty.call(A, "id") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(A.id), A.label != null && Object.hasOwnProperty.call(A, "label") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(A.label), A.default != null && A.default.length) {
      g.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork();
      for (let e = 0; e < A.default.length; ++e) g.int32(A.default[e]);
      g.ldelim();
    }
    if (A.options != null && A.options.length) for (let e = 0; e < A.options.length; ++e) g.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(A.options[e]);
    if (A.help != null && Object.hasOwnProperty.call(A, "help") && g.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(A.help), A.formId != null && Object.hasOwnProperty.call(A, "formId") && g.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(A.formId), A.value != null && A.value.length) {
      g.uint32(
        /* id 7, wireType 2 =*/
        58
      ).fork();
      for (let e = 0; e < A.value.length; ++e) g.int32(A.value[e]);
      g.ldelim();
    }
    if (A.setValue != null && Object.hasOwnProperty.call(A, "setValue") && g.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(A.setValue), A.disabled != null && Object.hasOwnProperty.call(A, "disabled") && g.uint32(
      /* id 9, wireType 0 =*/
      72
    ).bool(A.disabled), A.labelVisibility != null && Object.hasOwnProperty.call(A, "labelVisibility") && $root.LabelVisibilityMessage.encode(A.labelVisibility, g.uint32(
      /* id 10, wireType 2 =*/
      82
    ).fork()).ldelim(), A.maxSelections != null && Object.hasOwnProperty.call(A, "maxSelections") && g.uint32(
      /* id 11, wireType 0 =*/
      88
    ).int32(A.maxSelections), A.placeholder != null && Object.hasOwnProperty.call(A, "placeholder") && g.uint32(
      /* id 12, wireType 2 =*/
      98
    ).string(A.placeholder), A.acceptNewOptions != null && Object.hasOwnProperty.call(A, "acceptNewOptions") && g.uint32(
      /* id 13, wireType 0 =*/
      104
    ).bool(A.acceptNewOptions), A.rawValues != null && A.rawValues.length) for (let e = 0; e < A.rawValues.length; ++e) g.uint32(
      /* id 14, wireType 2 =*/
      114
    ).string(A.rawValues[e]);
    return g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader || (A = $Reader.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root.MultiSelect();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.id = A.string();
          break;
        }
        case 2: {
          c.label = A.string();
          break;
        }
        case 3: {
          if (c.default && c.default.length || (c.default = []), (n & 7) === 2) {
            let h = A.uint32() + A.pos;
            for (; A.pos < h; ) c.default.push(A.int32());
          } else c.default.push(A.int32());
          break;
        }
        case 4: {
          c.options && c.options.length || (c.options = []), c.options.push(A.string());
          break;
        }
        case 5: {
          c.help = A.string();
          break;
        }
        case 6: {
          c.formId = A.string();
          break;
        }
        case 7: {
          if (c.value && c.value.length || (c.value = []), (n & 7) === 2) {
            let h = A.uint32() + A.pos;
            for (; A.pos < h; ) c.value.push(A.int32());
          } else c.value.push(A.int32());
          break;
        }
        case 14: {
          c.rawValues && c.rawValues.length || (c.rawValues = []), c.rawValues.push(A.string());
          break;
        }
        case 8: {
          c.setValue = A.bool();
          break;
        }
        case 9: {
          c.disabled = A.bool();
          break;
        }
        case 10: {
          c.labelVisibility = $root.LabelVisibilityMessage.decode(A, A.uint32());
          break;
        }
        case 11: {
          c.maxSelections = A.int32();
          break;
        }
        case 12: {
          c.placeholder = A.string();
          break;
        }
        case 13: {
          c.acceptNewOptions = A.bool();
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root.MultiSelect) return A;
    let g = new $root.MultiSelect();
    if (A.id != null && (g.id = String(A.id)), A.label != null && (g.label = String(A.label)), A.default) {
      if (!Array.isArray(A.default)) throw TypeError(".MultiSelect.default: array expected");
      g.default = [];
      for (let e = 0; e < A.default.length; ++e) g.default[e] = A.default[e] | 0;
    }
    if (A.options) {
      if (!Array.isArray(A.options)) throw TypeError(".MultiSelect.options: array expected");
      g.options = [];
      for (let e = 0; e < A.options.length; ++e) g.options[e] = String(A.options[e]);
    }
    if (A.help != null && (g.help = String(A.help)), A.formId != null && (g.formId = String(A.formId)), A.value) {
      if (!Array.isArray(A.value)) throw TypeError(".MultiSelect.value: array expected");
      g.value = [];
      for (let e = 0; e < A.value.length; ++e) g.value[e] = A.value[e] | 0;
    }
    if (A.rawValues) {
      if (!Array.isArray(A.rawValues)) throw TypeError(".MultiSelect.rawValues: array expected");
      g.rawValues = [];
      for (let e = 0; e < A.rawValues.length; ++e) g.rawValues[e] = String(A.rawValues[e]);
    }
    if (A.setValue != null && (g.setValue = !!A.setValue), A.disabled != null && (g.disabled = !!A.disabled), A.labelVisibility != null) {
      if (typeof A.labelVisibility != "object") throw TypeError(".MultiSelect.labelVisibility: object expected");
      g.labelVisibility = $root.LabelVisibilityMessage.fromObject(A.labelVisibility);
    }
    return A.maxSelections != null && (g.maxSelections = A.maxSelections | 0), A.placeholder != null && (g.placeholder = String(A.placeholder)), A.acceptNewOptions != null && (g.acceptNewOptions = !!A.acceptNewOptions), g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    if ((g.arrays || g.defaults) && (e.default = [], e.options = [], e.value = [], e.rawValues = []), g.defaults && (e.id = "", e.label = "", e.help = "", e.formId = "", e.setValue = !1, e.disabled = !1, e.labelVisibility = null, e.maxSelections = 0, e.placeholder = ""), A.id != null && A.hasOwnProperty("id") && (e.id = A.id), A.label != null && A.hasOwnProperty("label") && (e.label = A.label), A.default && A.default.length) {
      e.default = [];
      for (let t = 0; t < A.default.length; ++t) e.default[t] = A.default[t];
    }
    if (A.options && A.options.length) {
      e.options = [];
      for (let t = 0; t < A.options.length; ++t) e.options[t] = A.options[t];
    }
    if (A.help != null && A.hasOwnProperty("help") && (e.help = A.help), A.formId != null && A.hasOwnProperty("formId") && (e.formId = A.formId), A.value && A.value.length) {
      e.value = [];
      for (let t = 0; t < A.value.length; ++t) e.value[t] = A.value[t];
    }
    if (A.setValue != null && A.hasOwnProperty("setValue") && (e.setValue = A.setValue), A.disabled != null && A.hasOwnProperty("disabled") && (e.disabled = A.disabled), A.labelVisibility != null && A.hasOwnProperty("labelVisibility") && (e.labelVisibility = $root.LabelVisibilityMessage.toObject(A.labelVisibility, g)), A.maxSelections != null && A.hasOwnProperty("maxSelections") && (e.maxSelections = A.maxSelections), A.placeholder != null && A.hasOwnProperty("placeholder") && (e.placeholder = A.placeholder), A.acceptNewOptions != null && A.hasOwnProperty("acceptNewOptions") && (e.acceptNewOptions = A.acceptNewOptions, g.oneofs && (e._acceptNewOptions = "acceptNewOptions")), A.rawValues && A.rawValues.length) {
      e.rawValues = [];
      for (let t = 0; t < A.rawValues.length; ++t) e.rawValues[t] = A.rawValues[t];
    }
    return e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/MultiSelect";
  }, o;
})();
$root.PageLink = (() => {
  function o(A) {
    if (A) for (let g = Object.keys(A), e = 0; e < g.length; ++e) A[g[e]] != null && (this[g[e]] = A[g[e]]);
  }
  o.prototype.page = "", o.prototype.label = "", o.prototype.icon = "", o.prototype.pageScriptHash = "", o.prototype.help = "", o.prototype.useContainerWidth = null, o.prototype.disabled = !1, o.prototype.external = !1, o.prototype.queryString = "";
  let E;
  return Object.defineProperty(o.prototype, "_useContainerWidth", { get: $util.oneOfGetter(E = ["useContainerWidth"]), set: $util.oneOfSetter(E) }), o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    return g || (g = $Writer.create()), A.page != null && Object.hasOwnProperty.call(A, "page") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(A.page), A.label != null && Object.hasOwnProperty.call(A, "label") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(A.label), A.icon != null && Object.hasOwnProperty.call(A, "icon") && g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(A.icon), A.pageScriptHash != null && Object.hasOwnProperty.call(A, "pageScriptHash") && g.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(A.pageScriptHash), A.help != null && Object.hasOwnProperty.call(A, "help") && g.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(A.help), A.useContainerWidth != null && Object.hasOwnProperty.call(A, "useContainerWidth") && g.uint32(
      /* id 6, wireType 0 =*/
      48
    ).bool(A.useContainerWidth), A.disabled != null && Object.hasOwnProperty.call(A, "disabled") && g.uint32(
      /* id 7, wireType 0 =*/
      56
    ).bool(A.disabled), A.external != null && Object.hasOwnProperty.call(A, "external") && g.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(A.external), A.queryString != null && Object.hasOwnProperty.call(A, "queryString") && g.uint32(
      /* id 9, wireType 2 =*/
      74
    ).string(A.queryString), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader || (A = $Reader.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root.PageLink();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.page = A.string();
          break;
        }
        case 2: {
          c.label = A.string();
          break;
        }
        case 3: {
          c.icon = A.string();
          break;
        }
        case 4: {
          c.pageScriptHash = A.string();
          break;
        }
        case 5: {
          c.help = A.string();
          break;
        }
        case 6: {
          c.useContainerWidth = A.bool();
          break;
        }
        case 7: {
          c.disabled = A.bool();
          break;
        }
        case 8: {
          c.external = A.bool();
          break;
        }
        case 9: {
          c.queryString = A.string();
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root.PageLink) return A;
    let g = new $root.PageLink();
    return A.page != null && (g.page = String(A.page)), A.label != null && (g.label = String(A.label)), A.icon != null && (g.icon = String(A.icon)), A.pageScriptHash != null && (g.pageScriptHash = String(A.pageScriptHash)), A.help != null && (g.help = String(A.help)), A.useContainerWidth != null && (g.useContainerWidth = !!A.useContainerWidth), A.disabled != null && (g.disabled = !!A.disabled), A.external != null && (g.external = !!A.external), A.queryString != null && (g.queryString = String(A.queryString)), g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    return g.defaults && (e.page = "", e.label = "", e.icon = "", e.pageScriptHash = "", e.help = "", e.disabled = !1, e.external = !1, e.queryString = ""), A.page != null && A.hasOwnProperty("page") && (e.page = A.page), A.label != null && A.hasOwnProperty("label") && (e.label = A.label), A.icon != null && A.hasOwnProperty("icon") && (e.icon = A.icon), A.pageScriptHash != null && A.hasOwnProperty("pageScriptHash") && (e.pageScriptHash = A.pageScriptHash), A.help != null && A.hasOwnProperty("help") && (e.help = A.help), A.useContainerWidth != null && A.hasOwnProperty("useContainerWidth") && (e.useContainerWidth = A.useContainerWidth, g.oneofs && (e._useContainerWidth = "useContainerWidth")), A.disabled != null && A.hasOwnProperty("disabled") && (e.disabled = A.disabled), A.external != null && A.hasOwnProperty("external") && (e.external = A.external), A.queryString != null && A.hasOwnProperty("queryString") && (e.queryString = A.queryString), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/PageLink";
  }, o;
})();
$root.PlotlyChart = (() => {
  function o(A) {
    if (this.selectionMode = [], A) for (let g = Object.keys(A), e = 0; e < g.length; ++e) A[g[e]] != null && (this[g[e]] = A[g[e]]);
  }
  o.prototype.useContainerWidth = !1, o.prototype.theme = "", o.prototype.id = "", o.prototype.selectionMode = $util.emptyArray, o.prototype.formId = "", o.prototype.spec = "", o.prototype.config = "", o.prototype.url = null, o.prototype.figure = null;
  let E;
  return Object.defineProperty(o.prototype, "chart", { get: $util.oneOfGetter(E = ["url", "figure"]), set: $util.oneOfSetter(E) }), o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    if (g || (g = $Writer.create()), A.url != null && Object.hasOwnProperty.call(A, "url") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(A.url), A.figure != null && Object.hasOwnProperty.call(A, "figure") && $root.Figure.encode(A.figure, g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), A.useContainerWidth != null && Object.hasOwnProperty.call(A, "useContainerWidth") && g.uint32(
      /* id 5, wireType 0 =*/
      40
    ).bool(A.useContainerWidth), A.theme != null && Object.hasOwnProperty.call(A, "theme") && g.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(A.theme), A.id != null && Object.hasOwnProperty.call(A, "id") && g.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(A.id), A.selectionMode != null && A.selectionMode.length) {
      g.uint32(
        /* id 8, wireType 2 =*/
        66
      ).fork();
      for (let e = 0; e < A.selectionMode.length; ++e) g.int32(A.selectionMode[e]);
      g.ldelim();
    }
    return A.formId != null && Object.hasOwnProperty.call(A, "formId") && g.uint32(
      /* id 9, wireType 2 =*/
      74
    ).string(A.formId), A.spec != null && Object.hasOwnProperty.call(A, "spec") && g.uint32(
      /* id 10, wireType 2 =*/
      82
    ).string(A.spec), A.config != null && Object.hasOwnProperty.call(A, "config") && g.uint32(
      /* id 11, wireType 2 =*/
      90
    ).string(A.config), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader || (A = $Reader.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root.PlotlyChart();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 5: {
          c.useContainerWidth = A.bool();
          break;
        }
        case 6: {
          c.theme = A.string();
          break;
        }
        case 7: {
          c.id = A.string();
          break;
        }
        case 8: {
          if (c.selectionMode && c.selectionMode.length || (c.selectionMode = []), (n & 7) === 2) {
            let h = A.uint32() + A.pos;
            for (; A.pos < h; ) c.selectionMode.push(A.int32());
          } else c.selectionMode.push(A.int32());
          break;
        }
        case 9: {
          c.formId = A.string();
          break;
        }
        case 10: {
          c.spec = A.string();
          break;
        }
        case 11: {
          c.config = A.string();
          break;
        }
        case 1: {
          c.url = A.string();
          break;
        }
        case 2: {
          c.figure = $root.Figure.decode(A, A.uint32());
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root.PlotlyChart) return A;
    let g = new $root.PlotlyChart();
    if (A.useContainerWidth != null && (g.useContainerWidth = !!A.useContainerWidth), A.theme != null && (g.theme = String(A.theme)), A.id != null && (g.id = String(A.id)), A.selectionMode) {
      if (!Array.isArray(A.selectionMode)) throw TypeError(".PlotlyChart.selectionMode: array expected");
      g.selectionMode = [];
      for (let e = 0; e < A.selectionMode.length; ++e) switch (A.selectionMode[e]) {
        default:
          if (typeof A.selectionMode[e] == "number") {
            g.selectionMode[e] = A.selectionMode[e];
            break;
          }
        case "POINTS":
        case 0:
          g.selectionMode[e] = 0;
          break;
        case "BOX":
        case 1:
          g.selectionMode[e] = 1;
          break;
        case "LASSO":
        case 2:
          g.selectionMode[e] = 2;
          break;
      }
    }
    if (A.formId != null && (g.formId = String(A.formId)), A.spec != null && (g.spec = String(A.spec)), A.config != null && (g.config = String(A.config)), A.url != null && (g.url = String(A.url)), A.figure != null) {
      if (typeof A.figure != "object") throw TypeError(".PlotlyChart.figure: object expected");
      g.figure = $root.Figure.fromObject(A.figure);
    }
    return g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    if ((g.arrays || g.defaults) && (e.selectionMode = []), g.defaults && (e.useContainerWidth = !1, e.theme = "", e.id = "", e.formId = "", e.spec = "", e.config = ""), A.url != null && A.hasOwnProperty("url") && (e.url = A.url, g.oneofs && (e.chart = "url")), A.figure != null && A.hasOwnProperty("figure") && (e.figure = $root.Figure.toObject(A.figure, g), g.oneofs && (e.chart = "figure")), A.useContainerWidth != null && A.hasOwnProperty("useContainerWidth") && (e.useContainerWidth = A.useContainerWidth), A.theme != null && A.hasOwnProperty("theme") && (e.theme = A.theme), A.id != null && A.hasOwnProperty("id") && (e.id = A.id), A.selectionMode && A.selectionMode.length) {
      e.selectionMode = [];
      for (let t = 0; t < A.selectionMode.length; ++t) e.selectionMode[t] = g.enums === String ? $root.PlotlyChart.SelectionMode[A.selectionMode[t]] === void 0 ? A.selectionMode[t] : $root.PlotlyChart.SelectionMode[A.selectionMode[t]] : A.selectionMode[t];
    }
    return A.formId != null && A.hasOwnProperty("formId") && (e.formId = A.formId), A.spec != null && A.hasOwnProperty("spec") && (e.spec = A.spec), A.config != null && A.hasOwnProperty("config") && (e.config = A.config), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/PlotlyChart";
  }, o.SelectionMode = (function() {
    const A = {}, g = Object.create(A);
    return g[A[0] = "POINTS"] = 0, g[A[1] = "BOX"] = 1, g[A[2] = "LASSO"] = 2, g;
  })(), o;
})();
$root.Figure = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.spec = "", o.prototype.config = "", o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, A) {
    return A || (A = $Writer.create()), E.spec != null && Object.hasOwnProperty.call(E, "spec") && A.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(E.spec), E.config != null && Object.hasOwnProperty.call(E, "config") && A.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(E.config), A;
  }, o.decode = function(E, A, g) {
    E instanceof $Reader || (E = $Reader.create(E));
    let e = A === void 0 ? E.len : E.pos + A, t = new $root.Figure();
    for (; E.pos < e; ) {
      let c = E.uint32();
      if (c === g) break;
      switch (c >>> 3) {
        case 1: {
          t.spec = E.string();
          break;
        }
        case 2: {
          t.config = E.string();
          break;
        }
        default:
          E.skipType(c & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(E) {
    if (E instanceof $root.Figure) return E;
    let A = new $root.Figure();
    return E.spec != null && (A.spec = String(E.spec)), E.config != null && (A.config = String(E.config)), A;
  }, o.toObject = function(E, A) {
    A || (A = {});
    let g = {};
    return A.defaults && (g.spec = "", g.config = ""), E.spec != null && E.hasOwnProperty("spec") && (g.spec = E.spec), E.config != null && E.hasOwnProperty("config") && (g.config = E.config), g;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/Figure";
  }, o;
})();
$root.Progress = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.value = 0, o.prototype.text = "", o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, A) {
    return A || (A = $Writer.create()), E.value != null && Object.hasOwnProperty.call(E, "value") && A.uint32(
      /* id 1, wireType 0 =*/
      8
    ).uint32(E.value), E.text != null && Object.hasOwnProperty.call(E, "text") && A.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(E.text), A;
  }, o.decode = function(E, A, g) {
    E instanceof $Reader || (E = $Reader.create(E));
    let e = A === void 0 ? E.len : E.pos + A, t = new $root.Progress();
    for (; E.pos < e; ) {
      let c = E.uint32();
      if (c === g) break;
      switch (c >>> 3) {
        case 1: {
          t.value = E.uint32();
          break;
        }
        case 2: {
          t.text = E.string();
          break;
        }
        default:
          E.skipType(c & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(E) {
    if (E instanceof $root.Progress) return E;
    let A = new $root.Progress();
    return E.value != null && (A.value = E.value >>> 0), E.text != null && (A.text = String(E.text)), A;
  }, o.toObject = function(E, A) {
    A || (A = {});
    let g = {};
    return A.defaults && (g.value = 0, g.text = ""), E.value != null && E.hasOwnProperty("value") && (g.value = E.value), E.text != null && E.hasOwnProperty("text") && (g.text = E.text), g;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/Progress";
  }, o;
})();
$root.Snow = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.show = !1, o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, A) {
    return A || (A = $Writer.create()), E.show != null && Object.hasOwnProperty.call(E, "show") && A.uint32(
      /* id 1, wireType 0 =*/
      8
    ).bool(E.show), A;
  }, o.decode = function(E, A, g) {
    E instanceof $Reader || (E = $Reader.create(E));
    let e = A === void 0 ? E.len : E.pos + A, t = new $root.Snow();
    for (; E.pos < e; ) {
      let c = E.uint32();
      if (c === g) break;
      c >>> 3 === 1 ? t.show = E.bool() : E.skipType(c & 7);
    }
    return t;
  }, o.fromObject = function(E) {
    if (E instanceof $root.Snow) return E;
    let A = new $root.Snow();
    return E.show != null && (A.show = !!E.show), A;
  }, o.toObject = function(E, A) {
    A || (A = {});
    let g = {};
    return A.defaults && (g.show = !1), E.show != null && E.hasOwnProperty("show") && (g.show = E.show), g;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/Snow";
  }, o;
})();
$root.Spinner = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.text = "", o.prototype.cache = !1, o.prototype.showTime = !1, o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, A) {
    return A || (A = $Writer.create()), E.text != null && Object.hasOwnProperty.call(E, "text") && A.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(E.text), E.cache != null && Object.hasOwnProperty.call(E, "cache") && A.uint32(
      /* id 2, wireType 0 =*/
      16
    ).bool(E.cache), E.showTime != null && Object.hasOwnProperty.call(E, "showTime") && A.uint32(
      /* id 3, wireType 0 =*/
      24
    ).bool(E.showTime), A;
  }, o.decode = function(E, A, g) {
    E instanceof $Reader || (E = $Reader.create(E));
    let e = A === void 0 ? E.len : E.pos + A, t = new $root.Spinner();
    for (; E.pos < e; ) {
      let c = E.uint32();
      if (c === g) break;
      switch (c >>> 3) {
        case 1: {
          t.text = E.string();
          break;
        }
        case 2: {
          t.cache = E.bool();
          break;
        }
        case 3: {
          t.showTime = E.bool();
          break;
        }
        default:
          E.skipType(c & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(E) {
    if (E instanceof $root.Spinner) return E;
    let A = new $root.Spinner();
    return E.text != null && (A.text = String(E.text)), E.cache != null && (A.cache = !!E.cache), E.showTime != null && (A.showTime = !!E.showTime), A;
  }, o.toObject = function(E, A) {
    A || (A = {});
    let g = {};
    return A.defaults && (g.text = "", g.cache = !1, g.showTime = !1), E.text != null && E.hasOwnProperty("text") && (g.text = E.text), E.cache != null && E.hasOwnProperty("cache") && (g.cache = E.cache), E.showTime != null && E.hasOwnProperty("showTime") && (g.showTime = E.showTime), g;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/Spinner";
  }, o;
})();
$root.Radio = (() => {
  function o(A) {
    if (this.options = [], this.captions = [], A) for (let g = Object.keys(A), e = 0; e < g.length; ++e) A[g[e]] != null && (this[g[e]] = A[g[e]]);
  }
  o.prototype.id = "", o.prototype.label = "", o.prototype.default = null, o.prototype.options = $util.emptyArray, o.prototype.help = "", o.prototype.formId = "", o.prototype.value = null, o.prototype.setValue = !1, o.prototype.disabled = !1, o.prototype.horizontal = !1, o.prototype.labelVisibility = null, o.prototype.captions = $util.emptyArray;
  let E;
  return Object.defineProperty(o.prototype, "_default", { get: $util.oneOfGetter(E = ["default"]), set: $util.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_value", { get: $util.oneOfGetter(E = ["value"]), set: $util.oneOfSetter(E) }), o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    if (g || (g = $Writer.create()), A.id != null && Object.hasOwnProperty.call(A, "id") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(A.id), A.label != null && Object.hasOwnProperty.call(A, "label") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(A.label), A.default != null && Object.hasOwnProperty.call(A, "default") && g.uint32(
      /* id 3, wireType 0 =*/
      24
    ).int32(A.default), A.options != null && A.options.length) for (let e = 0; e < A.options.length; ++e) g.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(A.options[e]);
    if (A.help != null && Object.hasOwnProperty.call(A, "help") && g.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(A.help), A.formId != null && Object.hasOwnProperty.call(A, "formId") && g.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(A.formId), A.value != null && Object.hasOwnProperty.call(A, "value") && g.uint32(
      /* id 7, wireType 0 =*/
      56
    ).int32(A.value), A.setValue != null && Object.hasOwnProperty.call(A, "setValue") && g.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(A.setValue), A.disabled != null && Object.hasOwnProperty.call(A, "disabled") && g.uint32(
      /* id 9, wireType 0 =*/
      72
    ).bool(A.disabled), A.horizontal != null && Object.hasOwnProperty.call(A, "horizontal") && g.uint32(
      /* id 10, wireType 0 =*/
      80
    ).bool(A.horizontal), A.labelVisibility != null && Object.hasOwnProperty.call(A, "labelVisibility") && $root.LabelVisibilityMessage.encode(A.labelVisibility, g.uint32(
      /* id 11, wireType 2 =*/
      90
    ).fork()).ldelim(), A.captions != null && A.captions.length) for (let e = 0; e < A.captions.length; ++e) g.uint32(
      /* id 12, wireType 2 =*/
      98
    ).string(A.captions[e]);
    return g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader || (A = $Reader.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root.Radio();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.id = A.string();
          break;
        }
        case 2: {
          c.label = A.string();
          break;
        }
        case 3: {
          c.default = A.int32();
          break;
        }
        case 4: {
          c.options && c.options.length || (c.options = []), c.options.push(A.string());
          break;
        }
        case 5: {
          c.help = A.string();
          break;
        }
        case 6: {
          c.formId = A.string();
          break;
        }
        case 7: {
          c.value = A.int32();
          break;
        }
        case 8: {
          c.setValue = A.bool();
          break;
        }
        case 9: {
          c.disabled = A.bool();
          break;
        }
        case 10: {
          c.horizontal = A.bool();
          break;
        }
        case 11: {
          c.labelVisibility = $root.LabelVisibilityMessage.decode(A, A.uint32());
          break;
        }
        case 12: {
          c.captions && c.captions.length || (c.captions = []), c.captions.push(A.string());
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root.Radio) return A;
    let g = new $root.Radio();
    if (A.id != null && (g.id = String(A.id)), A.label != null && (g.label = String(A.label)), A.default != null && (g.default = A.default | 0), A.options) {
      if (!Array.isArray(A.options)) throw TypeError(".Radio.options: array expected");
      g.options = [];
      for (let e = 0; e < A.options.length; ++e) g.options[e] = String(A.options[e]);
    }
    if (A.help != null && (g.help = String(A.help)), A.formId != null && (g.formId = String(A.formId)), A.value != null && (g.value = A.value | 0), A.setValue != null && (g.setValue = !!A.setValue), A.disabled != null && (g.disabled = !!A.disabled), A.horizontal != null && (g.horizontal = !!A.horizontal), A.labelVisibility != null) {
      if (typeof A.labelVisibility != "object") throw TypeError(".Radio.labelVisibility: object expected");
      g.labelVisibility = $root.LabelVisibilityMessage.fromObject(A.labelVisibility);
    }
    if (A.captions) {
      if (!Array.isArray(A.captions)) throw TypeError(".Radio.captions: array expected");
      g.captions = [];
      for (let e = 0; e < A.captions.length; ++e) g.captions[e] = String(A.captions[e]);
    }
    return g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    if ((g.arrays || g.defaults) && (e.options = [], e.captions = []), g.defaults && (e.id = "", e.label = "", e.help = "", e.formId = "", e.setValue = !1, e.disabled = !1, e.horizontal = !1, e.labelVisibility = null), A.id != null && A.hasOwnProperty("id") && (e.id = A.id), A.label != null && A.hasOwnProperty("label") && (e.label = A.label), A.default != null && A.hasOwnProperty("default") && (e.default = A.default, g.oneofs && (e._default = "default")), A.options && A.options.length) {
      e.options = [];
      for (let t = 0; t < A.options.length; ++t) e.options[t] = A.options[t];
    }
    if (A.help != null && A.hasOwnProperty("help") && (e.help = A.help), A.formId != null && A.hasOwnProperty("formId") && (e.formId = A.formId), A.value != null && A.hasOwnProperty("value") && (e.value = A.value, g.oneofs && (e._value = "value")), A.setValue != null && A.hasOwnProperty("setValue") && (e.setValue = A.setValue), A.disabled != null && A.hasOwnProperty("disabled") && (e.disabled = A.disabled), A.horizontal != null && A.hasOwnProperty("horizontal") && (e.horizontal = A.horizontal), A.labelVisibility != null && A.hasOwnProperty("labelVisibility") && (e.labelVisibility = $root.LabelVisibilityMessage.toObject(A.labelVisibility, g)), A.captions && A.captions.length) {
      e.captions = [];
      for (let t = 0; t < A.captions.length; ++t) e.captions[t] = A.captions[t];
    }
    return e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/Radio";
  }, o;
})();
$root.Selectbox = (() => {
  function o(A) {
    if (this.options = [], A) for (let g = Object.keys(A), e = 0; e < g.length; ++e) A[g[e]] != null && (this[g[e]] = A[g[e]]);
  }
  o.prototype.id = "", o.prototype.label = "", o.prototype.default = null, o.prototype.options = $util.emptyArray, o.prototype.help = "", o.prototype.formId = "", o.prototype.value = null, o.prototype.rawValue = null, o.prototype.setValue = !1, o.prototype.disabled = !1, o.prototype.labelVisibility = null, o.prototype.placeholder = "", o.prototype.acceptNewOptions = null;
  let E;
  return Object.defineProperty(o.prototype, "_default", { get: $util.oneOfGetter(E = ["default"]), set: $util.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_value", { get: $util.oneOfGetter(E = ["value"]), set: $util.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_rawValue", { get: $util.oneOfGetter(E = ["rawValue"]), set: $util.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_acceptNewOptions", { get: $util.oneOfGetter(E = ["acceptNewOptions"]), set: $util.oneOfSetter(E) }), o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    if (g || (g = $Writer.create()), A.id != null && Object.hasOwnProperty.call(A, "id") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(A.id), A.label != null && Object.hasOwnProperty.call(A, "label") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(A.label), A.default != null && Object.hasOwnProperty.call(A, "default") && g.uint32(
      /* id 3, wireType 0 =*/
      24
    ).int32(A.default), A.options != null && A.options.length) for (let e = 0; e < A.options.length; ++e) g.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(A.options[e]);
    return A.help != null && Object.hasOwnProperty.call(A, "help") && g.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(A.help), A.formId != null && Object.hasOwnProperty.call(A, "formId") && g.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(A.formId), A.value != null && Object.hasOwnProperty.call(A, "value") && g.uint32(
      /* id 7, wireType 0 =*/
      56
    ).int32(A.value), A.setValue != null && Object.hasOwnProperty.call(A, "setValue") && g.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(A.setValue), A.disabled != null && Object.hasOwnProperty.call(A, "disabled") && g.uint32(
      /* id 9, wireType 0 =*/
      72
    ).bool(A.disabled), A.labelVisibility != null && Object.hasOwnProperty.call(A, "labelVisibility") && $root.LabelVisibilityMessage.encode(A.labelVisibility, g.uint32(
      /* id 10, wireType 2 =*/
      82
    ).fork()).ldelim(), A.placeholder != null && Object.hasOwnProperty.call(A, "placeholder") && g.uint32(
      /* id 11, wireType 2 =*/
      90
    ).string(A.placeholder), A.acceptNewOptions != null && Object.hasOwnProperty.call(A, "acceptNewOptions") && g.uint32(
      /* id 12, wireType 0 =*/
      96
    ).bool(A.acceptNewOptions), A.rawValue != null && Object.hasOwnProperty.call(A, "rawValue") && g.uint32(
      /* id 13, wireType 2 =*/
      106
    ).string(A.rawValue), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader || (A = $Reader.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root.Selectbox();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.id = A.string();
          break;
        }
        case 2: {
          c.label = A.string();
          break;
        }
        case 3: {
          c.default = A.int32();
          break;
        }
        case 4: {
          c.options && c.options.length || (c.options = []), c.options.push(A.string());
          break;
        }
        case 5: {
          c.help = A.string();
          break;
        }
        case 6: {
          c.formId = A.string();
          break;
        }
        case 7: {
          c.value = A.int32();
          break;
        }
        case 13: {
          c.rawValue = A.string();
          break;
        }
        case 8: {
          c.setValue = A.bool();
          break;
        }
        case 9: {
          c.disabled = A.bool();
          break;
        }
        case 10: {
          c.labelVisibility = $root.LabelVisibilityMessage.decode(A, A.uint32());
          break;
        }
        case 11: {
          c.placeholder = A.string();
          break;
        }
        case 12: {
          c.acceptNewOptions = A.bool();
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root.Selectbox) return A;
    let g = new $root.Selectbox();
    if (A.id != null && (g.id = String(A.id)), A.label != null && (g.label = String(A.label)), A.default != null && (g.default = A.default | 0), A.options) {
      if (!Array.isArray(A.options)) throw TypeError(".Selectbox.options: array expected");
      g.options = [];
      for (let e = 0; e < A.options.length; ++e) g.options[e] = String(A.options[e]);
    }
    if (A.help != null && (g.help = String(A.help)), A.formId != null && (g.formId = String(A.formId)), A.value != null && (g.value = A.value | 0), A.rawValue != null && (g.rawValue = String(A.rawValue)), A.setValue != null && (g.setValue = !!A.setValue), A.disabled != null && (g.disabled = !!A.disabled), A.labelVisibility != null) {
      if (typeof A.labelVisibility != "object") throw TypeError(".Selectbox.labelVisibility: object expected");
      g.labelVisibility = $root.LabelVisibilityMessage.fromObject(A.labelVisibility);
    }
    return A.placeholder != null && (g.placeholder = String(A.placeholder)), A.acceptNewOptions != null && (g.acceptNewOptions = !!A.acceptNewOptions), g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    if ((g.arrays || g.defaults) && (e.options = []), g.defaults && (e.id = "", e.label = "", e.help = "", e.formId = "", e.setValue = !1, e.disabled = !1, e.labelVisibility = null, e.placeholder = ""), A.id != null && A.hasOwnProperty("id") && (e.id = A.id), A.label != null && A.hasOwnProperty("label") && (e.label = A.label), A.default != null && A.hasOwnProperty("default") && (e.default = A.default, g.oneofs && (e._default = "default")), A.options && A.options.length) {
      e.options = [];
      for (let t = 0; t < A.options.length; ++t) e.options[t] = A.options[t];
    }
    return A.help != null && A.hasOwnProperty("help") && (e.help = A.help), A.formId != null && A.hasOwnProperty("formId") && (e.formId = A.formId), A.value != null && A.hasOwnProperty("value") && (e.value = A.value, g.oneofs && (e._value = "value")), A.setValue != null && A.hasOwnProperty("setValue") && (e.setValue = A.setValue), A.disabled != null && A.hasOwnProperty("disabled") && (e.disabled = A.disabled), A.labelVisibility != null && A.hasOwnProperty("labelVisibility") && (e.labelVisibility = $root.LabelVisibilityMessage.toObject(A.labelVisibility, g)), A.placeholder != null && A.hasOwnProperty("placeholder") && (e.placeholder = A.placeholder), A.acceptNewOptions != null && A.hasOwnProperty("acceptNewOptions") && (e.acceptNewOptions = A.acceptNewOptions, g.oneofs && (e._acceptNewOptions = "acceptNewOptions")), A.rawValue != null && A.hasOwnProperty("rawValue") && (e.rawValue = A.rawValue, g.oneofs && (e._rawValue = "rawValue")), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/Selectbox";
  }, o;
})();
$root.Skeleton = (() => {
  function o(A) {
    if (A) for (let g = Object.keys(A), e = 0; e < g.length; ++e) A[g[e]] != null && (this[g[e]] = A[g[e]]);
  }
  o.prototype.style = 0, o.prototype.height = null;
  let E;
  return Object.defineProperty(o.prototype, "_height", { get: $util.oneOfGetter(E = ["height"]), set: $util.oneOfSetter(E) }), o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    return g || (g = $Writer.create()), A.style != null && Object.hasOwnProperty.call(A, "style") && g.uint32(
      /* id 1, wireType 0 =*/
      8
    ).int32(A.style), A.height != null && Object.hasOwnProperty.call(A, "height") && g.uint32(
      /* id 2, wireType 0 =*/
      16
    ).int32(A.height), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader || (A = $Reader.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root.Skeleton();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.style = A.int32();
          break;
        }
        case 2: {
          c.height = A.int32();
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root.Skeleton) return A;
    let g = new $root.Skeleton();
    switch (A.style) {
      default:
        if (typeof A.style == "number") {
          g.style = A.style;
          break;
        }
        break;
      case "ELEMENT":
      case 0:
        g.style = 0;
        break;
      case "APP":
      case 1:
        g.style = 1;
        break;
    }
    return A.height != null && (g.height = A.height | 0), g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    return g.defaults && (e.style = g.enums === String ? "ELEMENT" : 0), A.style != null && A.hasOwnProperty("style") && (e.style = g.enums === String ? $root.Skeleton.SkeletonStyle[A.style] === void 0 ? A.style : $root.Skeleton.SkeletonStyle[A.style] : A.style), A.height != null && A.hasOwnProperty("height") && (e.height = A.height, g.oneofs && (e._height = "height")), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/Skeleton";
  }, o.SkeletonStyle = (function() {
    const A = {}, g = Object.create(A);
    return g[A[0] = "ELEMENT"] = 0, g[A[1] = "APP"] = 1, g;
  })(), o;
})();
$root.Slider = (() => {
  function o(E) {
    if (this.default = [], this.value = [], this.options = [], E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.id = "", o.prototype.formId = "", o.prototype.label = "", o.prototype.format = "", o.prototype.dataType = 0, o.prototype.default = $util.emptyArray, o.prototype.min = 0, o.prototype.max = 0, o.prototype.step = 0, o.prototype.value = $util.emptyArray, o.prototype.setValue = !1, o.prototype.options = $util.emptyArray, o.prototype.help = "", o.prototype.disabled = !1, o.prototype.labelVisibility = null, o.prototype.type = 0, o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, A) {
    if (A || (A = $Writer.create()), E.id != null && Object.hasOwnProperty.call(E, "id") && A.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(E.id), E.formId != null && Object.hasOwnProperty.call(E, "formId") && A.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(E.formId), E.label != null && Object.hasOwnProperty.call(E, "label") && A.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(E.label), E.format != null && Object.hasOwnProperty.call(E, "format") && A.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(E.format), E.dataType != null && Object.hasOwnProperty.call(E, "dataType") && A.uint32(
      /* id 5, wireType 0 =*/
      40
    ).int32(E.dataType), E.default != null && E.default.length) {
      A.uint32(
        /* id 6, wireType 2 =*/
        50
      ).fork();
      for (let g = 0; g < E.default.length; ++g) A.double(E.default[g]);
      A.ldelim();
    }
    if (E.min != null && Object.hasOwnProperty.call(E, "min") && A.uint32(
      /* id 7, wireType 1 =*/
      57
    ).double(E.min), E.max != null && Object.hasOwnProperty.call(E, "max") && A.uint32(
      /* id 8, wireType 1 =*/
      65
    ).double(E.max), E.step != null && Object.hasOwnProperty.call(E, "step") && A.uint32(
      /* id 9, wireType 1 =*/
      73
    ).double(E.step), E.value != null && E.value.length) {
      A.uint32(
        /* id 10, wireType 2 =*/
        82
      ).fork();
      for (let g = 0; g < E.value.length; ++g) A.double(E.value[g]);
      A.ldelim();
    }
    if (E.setValue != null && Object.hasOwnProperty.call(E, "setValue") && A.uint32(
      /* id 11, wireType 0 =*/
      88
    ).bool(E.setValue), E.options != null && E.options.length) for (let g = 0; g < E.options.length; ++g) A.uint32(
      /* id 13, wireType 2 =*/
      106
    ).string(E.options[g]);
    return E.help != null && Object.hasOwnProperty.call(E, "help") && A.uint32(
      /* id 14, wireType 2 =*/
      114
    ).string(E.help), E.disabled != null && Object.hasOwnProperty.call(E, "disabled") && A.uint32(
      /* id 15, wireType 0 =*/
      120
    ).bool(E.disabled), E.labelVisibility != null && Object.hasOwnProperty.call(E, "labelVisibility") && $root.LabelVisibilityMessage.encode(E.labelVisibility, A.uint32(
      /* id 16, wireType 2 =*/
      130
    ).fork()).ldelim(), E.type != null && Object.hasOwnProperty.call(E, "type") && A.uint32(
      /* id 17, wireType 0 =*/
      136
    ).int32(E.type), A;
  }, o.decode = function(E, A, g) {
    E instanceof $Reader || (E = $Reader.create(E));
    let e = A === void 0 ? E.len : E.pos + A, t = new $root.Slider();
    for (; E.pos < e; ) {
      let c = E.uint32();
      if (c === g) break;
      switch (c >>> 3) {
        case 1: {
          t.id = E.string();
          break;
        }
        case 2: {
          t.formId = E.string();
          break;
        }
        case 3: {
          t.label = E.string();
          break;
        }
        case 4: {
          t.format = E.string();
          break;
        }
        case 5: {
          t.dataType = E.int32();
          break;
        }
        case 6: {
          if (t.default && t.default.length || (t.default = []), (c & 7) === 2) {
            let n = E.uint32() + E.pos;
            for (; E.pos < n; ) t.default.push(E.double());
          } else t.default.push(E.double());
          break;
        }
        case 7: {
          t.min = E.double();
          break;
        }
        case 8: {
          t.max = E.double();
          break;
        }
        case 9: {
          t.step = E.double();
          break;
        }
        case 10: {
          if (t.value && t.value.length || (t.value = []), (c & 7) === 2) {
            let n = E.uint32() + E.pos;
            for (; E.pos < n; ) t.value.push(E.double());
          } else t.value.push(E.double());
          break;
        }
        case 11: {
          t.setValue = E.bool();
          break;
        }
        case 13: {
          t.options && t.options.length || (t.options = []), t.options.push(E.string());
          break;
        }
        case 14: {
          t.help = E.string();
          break;
        }
        case 15: {
          t.disabled = E.bool();
          break;
        }
        case 16: {
          t.labelVisibility = $root.LabelVisibilityMessage.decode(E, E.uint32());
          break;
        }
        case 17: {
          t.type = E.int32();
          break;
        }
        default:
          E.skipType(c & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(E) {
    if (E instanceof $root.Slider) return E;
    let A = new $root.Slider();
    switch (E.id != null && (A.id = String(E.id)), E.formId != null && (A.formId = String(E.formId)), E.label != null && (A.label = String(E.label)), E.format != null && (A.format = String(E.format)), E.dataType) {
      default:
        if (typeof E.dataType == "number") {
          A.dataType = E.dataType;
          break;
        }
        break;
      case "INT":
      case 0:
        A.dataType = 0;
        break;
      case "FLOAT":
      case 1:
        A.dataType = 1;
        break;
      case "DATETIME":
      case 2:
        A.dataType = 2;
        break;
      case "DATE":
      case 3:
        A.dataType = 3;
        break;
      case "TIME":
      case 4:
        A.dataType = 4;
        break;
    }
    if (E.default) {
      if (!Array.isArray(E.default)) throw TypeError(".Slider.default: array expected");
      A.default = [];
      for (let g = 0; g < E.default.length; ++g) A.default[g] = Number(E.default[g]);
    }
    if (E.min != null && (A.min = Number(E.min)), E.max != null && (A.max = Number(E.max)), E.step != null && (A.step = Number(E.step)), E.value) {
      if (!Array.isArray(E.value)) throw TypeError(".Slider.value: array expected");
      A.value = [];
      for (let g = 0; g < E.value.length; ++g) A.value[g] = Number(E.value[g]);
    }
    if (E.setValue != null && (A.setValue = !!E.setValue), E.options) {
      if (!Array.isArray(E.options)) throw TypeError(".Slider.options: array expected");
      A.options = [];
      for (let g = 0; g < E.options.length; ++g) A.options[g] = String(E.options[g]);
    }
    if (E.help != null && (A.help = String(E.help)), E.disabled != null && (A.disabled = !!E.disabled), E.labelVisibility != null) {
      if (typeof E.labelVisibility != "object") throw TypeError(".Slider.labelVisibility: object expected");
      A.labelVisibility = $root.LabelVisibilityMessage.fromObject(E.labelVisibility);
    }
    switch (E.type) {
      default:
        if (typeof E.type == "number") {
          A.type = E.type;
          break;
        }
        break;
      case "UNSPECIFIED":
      case 0:
        A.type = 0;
        break;
      case "SLIDER":
      case 1:
        A.type = 1;
        break;
      case "SELECT_SLIDER":
      case 2:
        A.type = 2;
        break;
    }
    return A;
  }, o.toObject = function(E, A) {
    A || (A = {});
    let g = {};
    if ((A.arrays || A.defaults) && (g.default = [], g.value = [], g.options = []), A.defaults && (g.id = "", g.formId = "", g.label = "", g.format = "", g.dataType = A.enums === String ? "INT" : 0, g.min = 0, g.max = 0, g.step = 0, g.setValue = !1, g.help = "", g.disabled = !1, g.labelVisibility = null, g.type = A.enums === String ? "UNSPECIFIED" : 0), E.id != null && E.hasOwnProperty("id") && (g.id = E.id), E.formId != null && E.hasOwnProperty("formId") && (g.formId = E.formId), E.label != null && E.hasOwnProperty("label") && (g.label = E.label), E.format != null && E.hasOwnProperty("format") && (g.format = E.format), E.dataType != null && E.hasOwnProperty("dataType") && (g.dataType = A.enums === String ? $root.Slider.DataType[E.dataType] === void 0 ? E.dataType : $root.Slider.DataType[E.dataType] : E.dataType), E.default && E.default.length) {
      g.default = [];
      for (let e = 0; e < E.default.length; ++e) g.default[e] = A.json && !isFinite(E.default[e]) ? String(E.default[e]) : E.default[e];
    }
    if (E.min != null && E.hasOwnProperty("min") && (g.min = A.json && !isFinite(E.min) ? String(E.min) : E.min), E.max != null && E.hasOwnProperty("max") && (g.max = A.json && !isFinite(E.max) ? String(E.max) : E.max), E.step != null && E.hasOwnProperty("step") && (g.step = A.json && !isFinite(E.step) ? String(E.step) : E.step), E.value && E.value.length) {
      g.value = [];
      for (let e = 0; e < E.value.length; ++e) g.value[e] = A.json && !isFinite(E.value[e]) ? String(E.value[e]) : E.value[e];
    }
    if (E.setValue != null && E.hasOwnProperty("setValue") && (g.setValue = E.setValue), E.options && E.options.length) {
      g.options = [];
      for (let e = 0; e < E.options.length; ++e) g.options[e] = E.options[e];
    }
    return E.help != null && E.hasOwnProperty("help") && (g.help = E.help), E.disabled != null && E.hasOwnProperty("disabled") && (g.disabled = E.disabled), E.labelVisibility != null && E.hasOwnProperty("labelVisibility") && (g.labelVisibility = $root.LabelVisibilityMessage.toObject(E.labelVisibility, A)), E.type != null && E.hasOwnProperty("type") && (g.type = A.enums === String ? $root.Slider.Type[E.type] === void 0 ? E.type : $root.Slider.Type[E.type] : E.type), g;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/Slider";
  }, o.DataType = (function() {
    const E = {}, A = Object.create(E);
    return A[E[0] = "INT"] = 0, A[E[1] = "FLOAT"] = 1, A[E[2] = "DATETIME"] = 2, A[E[3] = "DATE"] = 3, A[E[4] = "TIME"] = 4, A;
  })(), o.Type = (function() {
    const E = {}, A = Object.create(E);
    return A[E[0] = "UNSPECIFIED"] = 0, A[E[1] = "SLIDER"] = 1, A[E[2] = "SELECT_SLIDER"] = 2, A;
  })(), o;
})();
$root.Space = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, A) {
    return A || (A = $Writer.create()), A;
  }, o.decode = function(E, A, g) {
    E instanceof $Reader || (E = $Reader.create(E));
    let e = A === void 0 ? E.len : E.pos + A, t = new $root.Space();
    for (; E.pos < e; ) {
      let c = E.uint32();
      if (c === g) break;
      switch (c >>> 3) {
        default:
          E.skipType(c & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(E) {
    return E instanceof $root.Space ? E : new $root.Space();
  }, o.toObject = function() {
    return {};
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/Space";
  }, o;
})();
$root.Text = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.body = "", o.prototype.help = "", o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, A) {
    return A || (A = $Writer.create()), E.body != null && Object.hasOwnProperty.call(E, "body") && A.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(E.body), E.help != null && Object.hasOwnProperty.call(E, "help") && A.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(E.help), A;
  }, o.decode = function(E, A, g) {
    E instanceof $Reader || (E = $Reader.create(E));
    let e = A === void 0 ? E.len : E.pos + A, t = new $root.Text();
    for (; E.pos < e; ) {
      let c = E.uint32();
      if (c === g) break;
      switch (c >>> 3) {
        case 1: {
          t.body = E.string();
          break;
        }
        case 2: {
          t.help = E.string();
          break;
        }
        default:
          E.skipType(c & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(E) {
    if (E instanceof $root.Text) return E;
    let A = new $root.Text();
    return E.body != null && (A.body = String(E.body)), E.help != null && (A.help = String(E.help)), A;
  }, o.toObject = function(E, A) {
    A || (A = {});
    let g = {};
    return A.defaults && (g.body = "", g.help = ""), E.body != null && E.hasOwnProperty("body") && (g.body = E.body), E.help != null && E.hasOwnProperty("help") && (g.help = E.help), g;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/Text";
  }, o;
})();
$root.TextArea = (() => {
  function o(A) {
    if (A) for (let g = Object.keys(A), e = 0; e < g.length; ++e) A[g[e]] != null && (this[g[e]] = A[g[e]]);
  }
  o.prototype.id = "", o.prototype.label = "", o.prototype.default = null, o.prototype.height = 0, o.prototype.maxChars = 0, o.prototype.help = "", o.prototype.formId = "", o.prototype.value = null, o.prototype.setValue = !1, o.prototype.placeholder = "", o.prototype.disabled = !1, o.prototype.labelVisibility = null;
  let E;
  return Object.defineProperty(o.prototype, "_default", { get: $util.oneOfGetter(E = ["default"]), set: $util.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_value", { get: $util.oneOfGetter(E = ["value"]), set: $util.oneOfSetter(E) }), o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    return g || (g = $Writer.create()), A.id != null && Object.hasOwnProperty.call(A, "id") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(A.id), A.label != null && Object.hasOwnProperty.call(A, "label") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(A.label), A.default != null && Object.hasOwnProperty.call(A, "default") && g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(A.default), A.height != null && Object.hasOwnProperty.call(A, "height") && g.uint32(
      /* id 4, wireType 0 =*/
      32
    ).uint32(A.height), A.maxChars != null && Object.hasOwnProperty.call(A, "maxChars") && g.uint32(
      /* id 5, wireType 0 =*/
      40
    ).uint32(A.maxChars), A.help != null && Object.hasOwnProperty.call(A, "help") && g.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(A.help), A.formId != null && Object.hasOwnProperty.call(A, "formId") && g.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(A.formId), A.value != null && Object.hasOwnProperty.call(A, "value") && g.uint32(
      /* id 8, wireType 2 =*/
      66
    ).string(A.value), A.setValue != null && Object.hasOwnProperty.call(A, "setValue") && g.uint32(
      /* id 9, wireType 0 =*/
      72
    ).bool(A.setValue), A.placeholder != null && Object.hasOwnProperty.call(A, "placeholder") && g.uint32(
      /* id 10, wireType 2 =*/
      82
    ).string(A.placeholder), A.disabled != null && Object.hasOwnProperty.call(A, "disabled") && g.uint32(
      /* id 11, wireType 0 =*/
      88
    ).bool(A.disabled), A.labelVisibility != null && Object.hasOwnProperty.call(A, "labelVisibility") && $root.LabelVisibilityMessage.encode(A.labelVisibility, g.uint32(
      /* id 12, wireType 2 =*/
      98
    ).fork()).ldelim(), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader || (A = $Reader.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root.TextArea();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.id = A.string();
          break;
        }
        case 2: {
          c.label = A.string();
          break;
        }
        case 3: {
          c.default = A.string();
          break;
        }
        case 4: {
          c.height = A.uint32();
          break;
        }
        case 5: {
          c.maxChars = A.uint32();
          break;
        }
        case 6: {
          c.help = A.string();
          break;
        }
        case 7: {
          c.formId = A.string();
          break;
        }
        case 8: {
          c.value = A.string();
          break;
        }
        case 9: {
          c.setValue = A.bool();
          break;
        }
        case 10: {
          c.placeholder = A.string();
          break;
        }
        case 11: {
          c.disabled = A.bool();
          break;
        }
        case 12: {
          c.labelVisibility = $root.LabelVisibilityMessage.decode(A, A.uint32());
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root.TextArea) return A;
    let g = new $root.TextArea();
    if (A.id != null && (g.id = String(A.id)), A.label != null && (g.label = String(A.label)), A.default != null && (g.default = String(A.default)), A.height != null && (g.height = A.height >>> 0), A.maxChars != null && (g.maxChars = A.maxChars >>> 0), A.help != null && (g.help = String(A.help)), A.formId != null && (g.formId = String(A.formId)), A.value != null && (g.value = String(A.value)), A.setValue != null && (g.setValue = !!A.setValue), A.placeholder != null && (g.placeholder = String(A.placeholder)), A.disabled != null && (g.disabled = !!A.disabled), A.labelVisibility != null) {
      if (typeof A.labelVisibility != "object") throw TypeError(".TextArea.labelVisibility: object expected");
      g.labelVisibility = $root.LabelVisibilityMessage.fromObject(A.labelVisibility);
    }
    return g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    return g.defaults && (e.id = "", e.label = "", e.height = 0, e.maxChars = 0, e.help = "", e.formId = "", e.setValue = !1, e.placeholder = "", e.disabled = !1, e.labelVisibility = null), A.id != null && A.hasOwnProperty("id") && (e.id = A.id), A.label != null && A.hasOwnProperty("label") && (e.label = A.label), A.default != null && A.hasOwnProperty("default") && (e.default = A.default, g.oneofs && (e._default = "default")), A.height != null && A.hasOwnProperty("height") && (e.height = A.height), A.maxChars != null && A.hasOwnProperty("maxChars") && (e.maxChars = A.maxChars), A.help != null && A.hasOwnProperty("help") && (e.help = A.help), A.formId != null && A.hasOwnProperty("formId") && (e.formId = A.formId), A.value != null && A.hasOwnProperty("value") && (e.value = A.value, g.oneofs && (e._value = "value")), A.setValue != null && A.hasOwnProperty("setValue") && (e.setValue = A.setValue), A.placeholder != null && A.hasOwnProperty("placeholder") && (e.placeholder = A.placeholder), A.disabled != null && A.hasOwnProperty("disabled") && (e.disabled = A.disabled), A.labelVisibility != null && A.hasOwnProperty("labelVisibility") && (e.labelVisibility = $root.LabelVisibilityMessage.toObject(A.labelVisibility, g)), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/TextArea";
  }, o;
})();
$root.TextInput = (() => {
  function o(A) {
    if (A) for (let g = Object.keys(A), e = 0; e < g.length; ++e) A[g[e]] != null && (this[g[e]] = A[g[e]]);
  }
  o.prototype.id = "", o.prototype.label = "", o.prototype.default = null, o.prototype.type = 0, o.prototype.maxChars = 0, o.prototype.help = "", o.prototype.formId = "", o.prototype.value = null, o.prototype.setValue = !1, o.prototype.autocomplete = "", o.prototype.placeholder = "", o.prototype.disabled = !1, o.prototype.labelVisibility = null, o.prototype.icon = "";
  let E;
  return Object.defineProperty(o.prototype, "_default", { get: $util.oneOfGetter(E = ["default"]), set: $util.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_value", { get: $util.oneOfGetter(E = ["value"]), set: $util.oneOfSetter(E) }), o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    return g || (g = $Writer.create()), A.id != null && Object.hasOwnProperty.call(A, "id") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(A.id), A.label != null && Object.hasOwnProperty.call(A, "label") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(A.label), A.default != null && Object.hasOwnProperty.call(A, "default") && g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(A.default), A.type != null && Object.hasOwnProperty.call(A, "type") && g.uint32(
      /* id 4, wireType 0 =*/
      32
    ).int32(A.type), A.maxChars != null && Object.hasOwnProperty.call(A, "maxChars") && g.uint32(
      /* id 5, wireType 0 =*/
      40
    ).uint32(A.maxChars), A.help != null && Object.hasOwnProperty.call(A, "help") && g.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(A.help), A.formId != null && Object.hasOwnProperty.call(A, "formId") && g.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(A.formId), A.value != null && Object.hasOwnProperty.call(A, "value") && g.uint32(
      /* id 8, wireType 2 =*/
      66
    ).string(A.value), A.setValue != null && Object.hasOwnProperty.call(A, "setValue") && g.uint32(
      /* id 9, wireType 0 =*/
      72
    ).bool(A.setValue), A.autocomplete != null && Object.hasOwnProperty.call(A, "autocomplete") && g.uint32(
      /* id 10, wireType 2 =*/
      82
    ).string(A.autocomplete), A.placeholder != null && Object.hasOwnProperty.call(A, "placeholder") && g.uint32(
      /* id 11, wireType 2 =*/
      90
    ).string(A.placeholder), A.disabled != null && Object.hasOwnProperty.call(A, "disabled") && g.uint32(
      /* id 12, wireType 0 =*/
      96
    ).bool(A.disabled), A.labelVisibility != null && Object.hasOwnProperty.call(A, "labelVisibility") && $root.LabelVisibilityMessage.encode(A.labelVisibility, g.uint32(
      /* id 13, wireType 2 =*/
      106
    ).fork()).ldelim(), A.icon != null && Object.hasOwnProperty.call(A, "icon") && g.uint32(
      /* id 14, wireType 2 =*/
      114
    ).string(A.icon), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader || (A = $Reader.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root.TextInput();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.id = A.string();
          break;
        }
        case 2: {
          c.label = A.string();
          break;
        }
        case 3: {
          c.default = A.string();
          break;
        }
        case 4: {
          c.type = A.int32();
          break;
        }
        case 5: {
          c.maxChars = A.uint32();
          break;
        }
        case 6: {
          c.help = A.string();
          break;
        }
        case 7: {
          c.formId = A.string();
          break;
        }
        case 8: {
          c.value = A.string();
          break;
        }
        case 9: {
          c.setValue = A.bool();
          break;
        }
        case 10: {
          c.autocomplete = A.string();
          break;
        }
        case 11: {
          c.placeholder = A.string();
          break;
        }
        case 12: {
          c.disabled = A.bool();
          break;
        }
        case 13: {
          c.labelVisibility = $root.LabelVisibilityMessage.decode(A, A.uint32());
          break;
        }
        case 14: {
          c.icon = A.string();
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root.TextInput) return A;
    let g = new $root.TextInput();
    switch (A.id != null && (g.id = String(A.id)), A.label != null && (g.label = String(A.label)), A.default != null && (g.default = String(A.default)), A.type) {
      default:
        if (typeof A.type == "number") {
          g.type = A.type;
          break;
        }
        break;
      case "DEFAULT":
      case 0:
        g.type = 0;
        break;
      case "PASSWORD":
      case 1:
        g.type = 1;
        break;
    }
    if (A.maxChars != null && (g.maxChars = A.maxChars >>> 0), A.help != null && (g.help = String(A.help)), A.formId != null && (g.formId = String(A.formId)), A.value != null && (g.value = String(A.value)), A.setValue != null && (g.setValue = !!A.setValue), A.autocomplete != null && (g.autocomplete = String(A.autocomplete)), A.placeholder != null && (g.placeholder = String(A.placeholder)), A.disabled != null && (g.disabled = !!A.disabled), A.labelVisibility != null) {
      if (typeof A.labelVisibility != "object") throw TypeError(".TextInput.labelVisibility: object expected");
      g.labelVisibility = $root.LabelVisibilityMessage.fromObject(A.labelVisibility);
    }
    return A.icon != null && (g.icon = String(A.icon)), g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    return g.defaults && (e.id = "", e.label = "", e.type = g.enums === String ? "DEFAULT" : 0, e.maxChars = 0, e.help = "", e.formId = "", e.setValue = !1, e.autocomplete = "", e.placeholder = "", e.disabled = !1, e.labelVisibility = null, e.icon = ""), A.id != null && A.hasOwnProperty("id") && (e.id = A.id), A.label != null && A.hasOwnProperty("label") && (e.label = A.label), A.default != null && A.hasOwnProperty("default") && (e.default = A.default, g.oneofs && (e._default = "default")), A.type != null && A.hasOwnProperty("type") && (e.type = g.enums === String ? $root.TextInput.Type[A.type] === void 0 ? A.type : $root.TextInput.Type[A.type] : A.type), A.maxChars != null && A.hasOwnProperty("maxChars") && (e.maxChars = A.maxChars), A.help != null && A.hasOwnProperty("help") && (e.help = A.help), A.formId != null && A.hasOwnProperty("formId") && (e.formId = A.formId), A.value != null && A.hasOwnProperty("value") && (e.value = A.value, g.oneofs && (e._value = "value")), A.setValue != null && A.hasOwnProperty("setValue") && (e.setValue = A.setValue), A.autocomplete != null && A.hasOwnProperty("autocomplete") && (e.autocomplete = A.autocomplete), A.placeholder != null && A.hasOwnProperty("placeholder") && (e.placeholder = A.placeholder), A.disabled != null && A.hasOwnProperty("disabled") && (e.disabled = A.disabled), A.labelVisibility != null && A.hasOwnProperty("labelVisibility") && (e.labelVisibility = $root.LabelVisibilityMessage.toObject(A.labelVisibility, g)), A.icon != null && A.hasOwnProperty("icon") && (e.icon = A.icon), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/TextInput";
  }, o.Type = (function() {
    const A = {}, g = Object.create(A);
    return g[A[0] = "DEFAULT"] = 0, g[A[1] = "PASSWORD"] = 1, g;
  })(), o;
})();
$root.TimeInput = (() => {
  function o(A) {
    if (A) for (let g = Object.keys(A), e = 0; e < g.length; ++e) A[g[e]] != null && (this[g[e]] = A[g[e]]);
  }
  o.prototype.id = "", o.prototype.label = "", o.prototype.default = null, o.prototype.help = "", o.prototype.formId = "", o.prototype.value = null, o.prototype.setValue = !1, o.prototype.disabled = !1, o.prototype.labelVisibility = null, o.prototype.step = $util.Long ? $util.Long.fromBits(0, 0, !1) : 0;
  let E;
  return Object.defineProperty(o.prototype, "_default", { get: $util.oneOfGetter(E = ["default"]), set: $util.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_value", { get: $util.oneOfGetter(E = ["value"]), set: $util.oneOfSetter(E) }), o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    return g || (g = $Writer.create()), A.id != null && Object.hasOwnProperty.call(A, "id") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(A.id), A.label != null && Object.hasOwnProperty.call(A, "label") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(A.label), A.default != null && Object.hasOwnProperty.call(A, "default") && g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(A.default), A.help != null && Object.hasOwnProperty.call(A, "help") && g.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(A.help), A.formId != null && Object.hasOwnProperty.call(A, "formId") && g.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(A.formId), A.value != null && Object.hasOwnProperty.call(A, "value") && g.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(A.value), A.setValue != null && Object.hasOwnProperty.call(A, "setValue") && g.uint32(
      /* id 7, wireType 0 =*/
      56
    ).bool(A.setValue), A.disabled != null && Object.hasOwnProperty.call(A, "disabled") && g.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(A.disabled), A.labelVisibility != null && Object.hasOwnProperty.call(A, "labelVisibility") && $root.LabelVisibilityMessage.encode(A.labelVisibility, g.uint32(
      /* id 9, wireType 2 =*/
      74
    ).fork()).ldelim(), A.step != null && Object.hasOwnProperty.call(A, "step") && g.uint32(
      /* id 10, wireType 0 =*/
      80
    ).int64(A.step), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader || (A = $Reader.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root.TimeInput();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.id = A.string();
          break;
        }
        case 2: {
          c.label = A.string();
          break;
        }
        case 3: {
          c.default = A.string();
          break;
        }
        case 4: {
          c.help = A.string();
          break;
        }
        case 5: {
          c.formId = A.string();
          break;
        }
        case 6: {
          c.value = A.string();
          break;
        }
        case 7: {
          c.setValue = A.bool();
          break;
        }
        case 8: {
          c.disabled = A.bool();
          break;
        }
        case 9: {
          c.labelVisibility = $root.LabelVisibilityMessage.decode(A, A.uint32());
          break;
        }
        case 10: {
          c.step = A.int64();
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root.TimeInput) return A;
    let g = new $root.TimeInput();
    if (A.id != null && (g.id = String(A.id)), A.label != null && (g.label = String(A.label)), A.default != null && (g.default = String(A.default)), A.help != null && (g.help = String(A.help)), A.formId != null && (g.formId = String(A.formId)), A.value != null && (g.value = String(A.value)), A.setValue != null && (g.setValue = !!A.setValue), A.disabled != null && (g.disabled = !!A.disabled), A.labelVisibility != null) {
      if (typeof A.labelVisibility != "object") throw TypeError(".TimeInput.labelVisibility: object expected");
      g.labelVisibility = $root.LabelVisibilityMessage.fromObject(A.labelVisibility);
    }
    return A.step != null && ($util.Long ? (g.step = $util.Long.fromValue(A.step)).unsigned = !1 : typeof A.step == "string" ? g.step = parseInt(A.step, 10) : typeof A.step == "number" ? g.step = A.step : typeof A.step == "object" && (g.step = new $util.LongBits(A.step.low >>> 0, A.step.high >>> 0).toNumber())), g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    if (g.defaults) if (e.id = "", e.label = "", e.help = "", e.formId = "", e.setValue = !1, e.disabled = !1, e.labelVisibility = null, $util.Long) {
      let t = new $util.Long(0, 0, !1);
      e.step = g.longs === String ? t.toString() : g.longs === Number ? t.toNumber() : t;
    } else e.step = g.longs === String ? "0" : 0;
    return A.id != null && A.hasOwnProperty("id") && (e.id = A.id), A.label != null && A.hasOwnProperty("label") && (e.label = A.label), A.default != null && A.hasOwnProperty("default") && (e.default = A.default, g.oneofs && (e._default = "default")), A.help != null && A.hasOwnProperty("help") && (e.help = A.help), A.formId != null && A.hasOwnProperty("formId") && (e.formId = A.formId), A.value != null && A.hasOwnProperty("value") && (e.value = A.value, g.oneofs && (e._value = "value")), A.setValue != null && A.hasOwnProperty("setValue") && (e.setValue = A.setValue), A.disabled != null && A.hasOwnProperty("disabled") && (e.disabled = A.disabled), A.labelVisibility != null && A.hasOwnProperty("labelVisibility") && (e.labelVisibility = $root.LabelVisibilityMessage.toObject(A.labelVisibility, g)), A.step != null && A.hasOwnProperty("step") && (typeof A.step == "number" ? e.step = g.longs === String ? String(A.step) : A.step : e.step = g.longs === String ? $util.Long.prototype.toString.call(A.step) : g.longs === Number ? new $util.LongBits(A.step.low >>> 0, A.step.high >>> 0).toNumber() : A.step), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/TimeInput";
  }, o;
})();
$root.Toast = (() => {
  function o(A) {
    if (A) for (let g = Object.keys(A), e = 0; e < g.length; ++e) A[g[e]] != null && (this[g[e]] = A[g[e]]);
  }
  o.prototype.body = "", o.prototype.icon = "", o.prototype.duration = null;
  let E;
  return Object.defineProperty(o.prototype, "_duration", { get: $util.oneOfGetter(E = ["duration"]), set: $util.oneOfSetter(E) }), o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    return g || (g = $Writer.create()), A.body != null && Object.hasOwnProperty.call(A, "body") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(A.body), A.icon != null && Object.hasOwnProperty.call(A, "icon") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(A.icon), A.duration != null && Object.hasOwnProperty.call(A, "duration") && g.uint32(
      /* id 3, wireType 0 =*/
      24
    ).int32(A.duration), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader || (A = $Reader.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root.Toast();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.body = A.string();
          break;
        }
        case 2: {
          c.icon = A.string();
          break;
        }
        case 3: {
          c.duration = A.int32();
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root.Toast) return A;
    let g = new $root.Toast();
    return A.body != null && (g.body = String(A.body)), A.icon != null && (g.icon = String(A.icon)), A.duration != null && (g.duration = A.duration | 0), g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    return g.defaults && (e.body = "", e.icon = ""), A.body != null && A.hasOwnProperty("body") && (e.body = A.body), A.icon != null && A.hasOwnProperty("icon") && (e.icon = A.icon), A.duration != null && A.hasOwnProperty("duration") && (e.duration = A.duration, g.oneofs && (e._duration = "duration")), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/Toast";
  }, o;
})();
$root.VegaLiteChart = (() => {
  function o(E) {
    if (this.datasets = [], E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.spec = "", o.prototype.data = null, o.prototype.datasets = $util.emptyArray, o.prototype.useContainerWidth = !1, o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, A) {
    if (A || (A = $Writer.create()), E.spec != null && Object.hasOwnProperty.call(E, "spec") && A.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(E.spec), E.data != null && Object.hasOwnProperty.call(E, "data") && $root.DataFrame.encode(E.data, A.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), E.datasets != null && E.datasets.length) for (let g = 0; g < E.datasets.length; ++g) $root.NamedDataSet.encode(E.datasets[g], A.uint32(
      /* id 4, wireType 2 =*/
      34
    ).fork()).ldelim();
    return E.useContainerWidth != null && Object.hasOwnProperty.call(E, "useContainerWidth") && A.uint32(
      /* id 5, wireType 0 =*/
      40
    ).bool(E.useContainerWidth), A;
  }, o.decode = function(E, A, g) {
    E instanceof $Reader || (E = $Reader.create(E));
    let e = A === void 0 ? E.len : E.pos + A, t = new $root.VegaLiteChart();
    for (; E.pos < e; ) {
      let c = E.uint32();
      if (c === g) break;
      switch (c >>> 3) {
        case 1: {
          t.spec = E.string();
          break;
        }
        case 2: {
          t.data = $root.DataFrame.decode(E, E.uint32());
          break;
        }
        case 4: {
          t.datasets && t.datasets.length || (t.datasets = []), t.datasets.push($root.NamedDataSet.decode(E, E.uint32()));
          break;
        }
        case 5: {
          t.useContainerWidth = E.bool();
          break;
        }
        default:
          E.skipType(c & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(E) {
    if (E instanceof $root.VegaLiteChart) return E;
    let A = new $root.VegaLiteChart();
    if (E.spec != null && (A.spec = String(E.spec)), E.data != null) {
      if (typeof E.data != "object") throw TypeError(".VegaLiteChart.data: object expected");
      A.data = $root.DataFrame.fromObject(E.data);
    }
    if (E.datasets) {
      if (!Array.isArray(E.datasets)) throw TypeError(".VegaLiteChart.datasets: array expected");
      A.datasets = [];
      for (let g = 0; g < E.datasets.length; ++g) {
        if (typeof E.datasets[g] != "object") throw TypeError(".VegaLiteChart.datasets: object expected");
        A.datasets[g] = $root.NamedDataSet.fromObject(E.datasets[g]);
      }
    }
    return E.useContainerWidth != null && (A.useContainerWidth = !!E.useContainerWidth), A;
  }, o.toObject = function(E, A) {
    A || (A = {});
    let g = {};
    if ((A.arrays || A.defaults) && (g.datasets = []), A.defaults && (g.spec = "", g.data = null, g.useContainerWidth = !1), E.spec != null && E.hasOwnProperty("spec") && (g.spec = E.spec), E.data != null && E.hasOwnProperty("data") && (g.data = $root.DataFrame.toObject(E.data, A)), E.datasets && E.datasets.length) {
      g.datasets = [];
      for (let e = 0; e < E.datasets.length; ++e) g.datasets[e] = $root.NamedDataSet.toObject(E.datasets[e], A);
    }
    return E.useContainerWidth != null && E.hasOwnProperty("useContainerWidth") && (g.useContainerWidth = E.useContainerWidth), g;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/VegaLiteChart";
  }, o;
})();
$root.NamedDataSet = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.name = "", o.prototype.hasName = !1, o.prototype.data = null, o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, A) {
    return A || (A = $Writer.create()), E.name != null && Object.hasOwnProperty.call(E, "name") && A.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(E.name), E.data != null && Object.hasOwnProperty.call(E, "data") && $root.DataFrame.encode(E.data, A.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), E.hasName != null && Object.hasOwnProperty.call(E, "hasName") && A.uint32(
      /* id 3, wireType 0 =*/
      24
    ).bool(E.hasName), A;
  }, o.decode = function(E, A, g) {
    E instanceof $Reader || (E = $Reader.create(E));
    let e = A === void 0 ? E.len : E.pos + A, t = new $root.NamedDataSet();
    for (; E.pos < e; ) {
      let c = E.uint32();
      if (c === g) break;
      switch (c >>> 3) {
        case 1: {
          t.name = E.string();
          break;
        }
        case 3: {
          t.hasName = E.bool();
          break;
        }
        case 2: {
          t.data = $root.DataFrame.decode(E, E.uint32());
          break;
        }
        default:
          E.skipType(c & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(E) {
    if (E instanceof $root.NamedDataSet) return E;
    let A = new $root.NamedDataSet();
    if (E.name != null && (A.name = String(E.name)), E.hasName != null && (A.hasName = !!E.hasName), E.data != null) {
      if (typeof E.data != "object") throw TypeError(".NamedDataSet.data: object expected");
      A.data = $root.DataFrame.fromObject(E.data);
    }
    return A;
  }, o.toObject = function(E, A) {
    A || (A = {});
    let g = {};
    return A.defaults && (g.name = "", g.data = null, g.hasName = !1), E.name != null && E.hasOwnProperty("name") && (g.name = E.name), E.data != null && E.hasOwnProperty("data") && (g.data = $root.DataFrame.toObject(E.data, A)), E.hasName != null && E.hasOwnProperty("hasName") && (g.hasName = E.hasName), g;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/NamedDataSet";
  }, o;
})();
$root.SubtitleTrack = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.label = "", o.prototype.url = "", o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, A) {
    return A || (A = $Writer.create()), E.label != null && Object.hasOwnProperty.call(E, "label") && A.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(E.label), E.url != null && Object.hasOwnProperty.call(E, "url") && A.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(E.url), A;
  }, o.decode = function(E, A, g) {
    E instanceof $Reader || (E = $Reader.create(E));
    let e = A === void 0 ? E.len : E.pos + A, t = new $root.SubtitleTrack();
    for (; E.pos < e; ) {
      let c = E.uint32();
      if (c === g) break;
      switch (c >>> 3) {
        case 1: {
          t.label = E.string();
          break;
        }
        case 2: {
          t.url = E.string();
          break;
        }
        default:
          E.skipType(c & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(E) {
    if (E instanceof $root.SubtitleTrack) return E;
    let A = new $root.SubtitleTrack();
    return E.label != null && (A.label = String(E.label)), E.url != null && (A.url = String(E.url)), A;
  }, o.toObject = function(E, A) {
    A || (A = {});
    let g = {};
    return A.defaults && (g.label = "", g.url = ""), E.label != null && E.hasOwnProperty("label") && (g.label = E.label), E.url != null && E.hasOwnProperty("url") && (g.url = E.url), g;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/SubtitleTrack";
  }, o;
})();
$root.Video = (() => {
  function o(A) {
    if (this.subtitles = [], A) for (let g = Object.keys(A), e = 0; e < g.length; ++e) A[g[e]] != null && (this[g[e]] = A[g[e]]);
  }
  o.prototype.url = "", o.prototype.startTime = 0, o.prototype.type = 0, o.prototype.subtitles = $util.emptyArray, o.prototype.endTime = 0, o.prototype.loop = !1, o.prototype.autoplay = !1, o.prototype.muted = !1, o.prototype.id = "", o.prototype.widthConfig = null;
  let E;
  return Object.defineProperty(o.prototype, "_widthConfig", { get: $util.oneOfGetter(E = ["widthConfig"]), set: $util.oneOfSetter(E) }), o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    if (g || (g = $Writer.create()), A.startTime != null && Object.hasOwnProperty.call(A, "startTime") && g.uint32(
      /* id 3, wireType 0 =*/
      24
    ).int32(A.startTime), A.type != null && Object.hasOwnProperty.call(A, "type") && g.uint32(
      /* id 5, wireType 0 =*/
      40
    ).int32(A.type), A.url != null && Object.hasOwnProperty.call(A, "url") && g.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(A.url), A.subtitles != null && A.subtitles.length) for (let e = 0; e < A.subtitles.length; ++e) $root.SubtitleTrack.encode(A.subtitles[e], g.uint32(
      /* id 7, wireType 2 =*/
      58
    ).fork()).ldelim();
    return A.endTime != null && Object.hasOwnProperty.call(A, "endTime") && g.uint32(
      /* id 8, wireType 0 =*/
      64
    ).int32(A.endTime), A.loop != null && Object.hasOwnProperty.call(A, "loop") && g.uint32(
      /* id 9, wireType 0 =*/
      72
    ).bool(A.loop), A.autoplay != null && Object.hasOwnProperty.call(A, "autoplay") && g.uint32(
      /* id 10, wireType 0 =*/
      80
    ).bool(A.autoplay), A.muted != null && Object.hasOwnProperty.call(A, "muted") && g.uint32(
      /* id 11, wireType 0 =*/
      88
    ).bool(A.muted), A.id != null && Object.hasOwnProperty.call(A, "id") && g.uint32(
      /* id 12, wireType 2 =*/
      98
    ).string(A.id), A.widthConfig != null && Object.hasOwnProperty.call(A, "widthConfig") && $root.streamlit.WidthConfig.encode(A.widthConfig, g.uint32(
      /* id 13, wireType 2 =*/
      106
    ).fork()).ldelim(), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader || (A = $Reader.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root.Video();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 6: {
          c.url = A.string();
          break;
        }
        case 3: {
          c.startTime = A.int32();
          break;
        }
        case 5: {
          c.type = A.int32();
          break;
        }
        case 7: {
          c.subtitles && c.subtitles.length || (c.subtitles = []), c.subtitles.push($root.SubtitleTrack.decode(A, A.uint32()));
          break;
        }
        case 8: {
          c.endTime = A.int32();
          break;
        }
        case 9: {
          c.loop = A.bool();
          break;
        }
        case 10: {
          c.autoplay = A.bool();
          break;
        }
        case 11: {
          c.muted = A.bool();
          break;
        }
        case 12: {
          c.id = A.string();
          break;
        }
        case 13: {
          c.widthConfig = $root.streamlit.WidthConfig.decode(A, A.uint32());
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root.Video) return A;
    let g = new $root.Video();
    switch (A.url != null && (g.url = String(A.url)), A.startTime != null && (g.startTime = A.startTime | 0), A.type) {
      default:
        if (typeof A.type == "number") {
          g.type = A.type;
          break;
        }
        break;
      case "UNUSED":
      case 0:
        g.type = 0;
        break;
      case "NATIVE":
      case 1:
        g.type = 1;
        break;
      case "YOUTUBE_IFRAME":
      case 2:
        g.type = 2;
        break;
    }
    if (A.subtitles) {
      if (!Array.isArray(A.subtitles)) throw TypeError(".Video.subtitles: array expected");
      g.subtitles = [];
      for (let e = 0; e < A.subtitles.length; ++e) {
        if (typeof A.subtitles[e] != "object") throw TypeError(".Video.subtitles: object expected");
        g.subtitles[e] = $root.SubtitleTrack.fromObject(A.subtitles[e]);
      }
    }
    if (A.endTime != null && (g.endTime = A.endTime | 0), A.loop != null && (g.loop = !!A.loop), A.autoplay != null && (g.autoplay = !!A.autoplay), A.muted != null && (g.muted = !!A.muted), A.id != null && (g.id = String(A.id)), A.widthConfig != null) {
      if (typeof A.widthConfig != "object") throw TypeError(".Video.widthConfig: object expected");
      g.widthConfig = $root.streamlit.WidthConfig.fromObject(A.widthConfig);
    }
    return g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    if ((g.arrays || g.defaults) && (e.subtitles = []), g.defaults && (e.startTime = 0, e.type = g.enums === String ? "UNUSED" : 0, e.url = "", e.endTime = 0, e.loop = !1, e.autoplay = !1, e.muted = !1, e.id = ""), A.startTime != null && A.hasOwnProperty("startTime") && (e.startTime = A.startTime), A.type != null && A.hasOwnProperty("type") && (e.type = g.enums === String ? $root.Video.Type[A.type] === void 0 ? A.type : $root.Video.Type[A.type] : A.type), A.url != null && A.hasOwnProperty("url") && (e.url = A.url), A.subtitles && A.subtitles.length) {
      e.subtitles = [];
      for (let t = 0; t < A.subtitles.length; ++t) e.subtitles[t] = $root.SubtitleTrack.toObject(A.subtitles[t], g);
    }
    return A.endTime != null && A.hasOwnProperty("endTime") && (e.endTime = A.endTime), A.loop != null && A.hasOwnProperty("loop") && (e.loop = A.loop), A.autoplay != null && A.hasOwnProperty("autoplay") && (e.autoplay = A.autoplay), A.muted != null && A.hasOwnProperty("muted") && (e.muted = A.muted), A.id != null && A.hasOwnProperty("id") && (e.id = A.id), A.widthConfig != null && A.hasOwnProperty("widthConfig") && (e.widthConfig = $root.streamlit.WidthConfig.toObject(A.widthConfig, g), g.oneofs && (e._widthConfig = "widthConfig")), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/Video";
  }, o.Type = (function() {
    const A = {}, g = Object.create(A);
    return g[A[0] = "UNUSED"] = 0, g[A[1] = "NATIVE"] = 1, g[A[2] = "YOUTUBE_IFRAME"] = 2, g;
  })(), o;
})();
$root.Heading = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.tag = "", o.prototype.anchor = "", o.prototype.body = "", o.prototype.help = "", o.prototype.hideAnchor = !1, o.prototype.divider = "", o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, A) {
    return A || (A = $Writer.create()), E.tag != null && Object.hasOwnProperty.call(E, "tag") && A.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(E.tag), E.anchor != null && Object.hasOwnProperty.call(E, "anchor") && A.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(E.anchor), E.body != null && Object.hasOwnProperty.call(E, "body") && A.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(E.body), E.help != null && Object.hasOwnProperty.call(E, "help") && A.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(E.help), E.hideAnchor != null && Object.hasOwnProperty.call(E, "hideAnchor") && A.uint32(
      /* id 5, wireType 0 =*/
      40
    ).bool(E.hideAnchor), E.divider != null && Object.hasOwnProperty.call(E, "divider") && A.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(E.divider), A;
  }, o.decode = function(E, A, g) {
    E instanceof $Reader || (E = $Reader.create(E));
    let e = A === void 0 ? E.len : E.pos + A, t = new $root.Heading();
    for (; E.pos < e; ) {
      let c = E.uint32();
      if (c === g) break;
      switch (c >>> 3) {
        case 1: {
          t.tag = E.string();
          break;
        }
        case 2: {
          t.anchor = E.string();
          break;
        }
        case 3: {
          t.body = E.string();
          break;
        }
        case 4: {
          t.help = E.string();
          break;
        }
        case 5: {
          t.hideAnchor = E.bool();
          break;
        }
        case 6: {
          t.divider = E.string();
          break;
        }
        default:
          E.skipType(c & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(E) {
    if (E instanceof $root.Heading) return E;
    let A = new $root.Heading();
    return E.tag != null && (A.tag = String(E.tag)), E.anchor != null && (A.anchor = String(E.anchor)), E.body != null && (A.body = String(E.body)), E.help != null && (A.help = String(E.help)), E.hideAnchor != null && (A.hideAnchor = !!E.hideAnchor), E.divider != null && (A.divider = String(E.divider)), A;
  }, o.toObject = function(E, A) {
    A || (A = {});
    let g = {};
    return A.defaults && (g.tag = "", g.anchor = "", g.body = "", g.help = "", g.hideAnchor = !1, g.divider = ""), E.tag != null && E.hasOwnProperty("tag") && (g.tag = E.tag), E.anchor != null && E.hasOwnProperty("anchor") && (g.anchor = E.anchor), E.body != null && E.hasOwnProperty("body") && (g.body = E.body), E.help != null && E.hasOwnProperty("help") && (g.help = E.help), E.hideAnchor != null && E.hasOwnProperty("hideAnchor") && (g.hideAnchor = E.hideAnchor), E.divider != null && E.hasOwnProperty("divider") && (g.divider = E.divider), g;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/Heading";
  }, o;
})();
$root.ForwardMsg = (() => {
  function o(A) {
    if (A) for (let g = Object.keys(A), e = 0; e < g.length; ++e) A[g[e]] != null && (this[g[e]] = A[g[e]]);
  }
  o.prototype.hash = "", o.prototype.metadata = null, o.prototype.newSession = null, o.prototype.delta = null, o.prototype.pageInfoChanged = null, o.prototype.pageConfigChanged = null, o.prototype.scriptFinished = null, o.prototype.gitInfoChanged = null, o.prototype.pageProfile = null, o.prototype.sessionStatusChanged = null, o.prototype.sessionEvent = null, o.prototype.navigation = null, o.prototype.pageNotFound = null, o.prototype.pagesChanged = null, o.prototype.fileUrlsResponse = null, o.prototype.autoRerun = null, o.prototype.logo = null, o.prototype.authRedirect = null, o.prototype.parentMessage = null, o.prototype.refHash = null, o.prototype.deferredFileResponse = null, o.prototype.debugLastBackmsgId = "";
  let E;
  return Object.defineProperty(o.prototype, "type", { get: $util.oneOfGetter(E = ["newSession", "delta", "pageInfoChanged", "pageConfigChanged", "scriptFinished", "gitInfoChanged", "pageProfile", "sessionStatusChanged", "sessionEvent", "navigation", "pageNotFound", "pagesChanged", "fileUrlsResponse", "autoRerun", "logo", "authRedirect", "parentMessage", "refHash", "deferredFileResponse"]), set: $util.oneOfSetter(E) }), o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    return g || (g = $Writer.create()), A.hash != null && Object.hasOwnProperty.call(A, "hash") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(A.hash), A.metadata != null && Object.hasOwnProperty.call(A, "metadata") && $root.ForwardMsgMetadata.encode(A.metadata, g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), A.newSession != null && Object.hasOwnProperty.call(A, "newSession") && $root.NewSession.encode(A.newSession, g.uint32(
      /* id 4, wireType 2 =*/
      34
    ).fork()).ldelim(), A.delta != null && Object.hasOwnProperty.call(A, "delta") && $root.Delta.encode(A.delta, g.uint32(
      /* id 5, wireType 2 =*/
      42
    ).fork()).ldelim(), A.scriptFinished != null && Object.hasOwnProperty.call(A, "scriptFinished") && g.uint32(
      /* id 6, wireType 0 =*/
      48
    ).int32(A.scriptFinished), A.sessionStatusChanged != null && Object.hasOwnProperty.call(A, "sessionStatusChanged") && $root.SessionStatus.encode(A.sessionStatusChanged, g.uint32(
      /* id 9, wireType 2 =*/
      74
    ).fork()).ldelim(), A.sessionEvent != null && Object.hasOwnProperty.call(A, "sessionEvent") && $root.SessionEvent.encode(A.sessionEvent, g.uint32(
      /* id 10, wireType 2 =*/
      82
    ).fork()).ldelim(), A.refHash != null && Object.hasOwnProperty.call(A, "refHash") && g.uint32(
      /* id 11, wireType 2 =*/
      90
    ).string(A.refHash), A.pageInfoChanged != null && Object.hasOwnProperty.call(A, "pageInfoChanged") && $root.PageInfo.encode(A.pageInfoChanged, g.uint32(
      /* id 12, wireType 2 =*/
      98
    ).fork()).ldelim(), A.pageConfigChanged != null && Object.hasOwnProperty.call(A, "pageConfigChanged") && $root.PageConfig.encode(A.pageConfigChanged, g.uint32(
      /* id 13, wireType 2 =*/
      106
    ).fork()).ldelim(), A.gitInfoChanged != null && Object.hasOwnProperty.call(A, "gitInfoChanged") && $root.GitInfo.encode(A.gitInfoChanged, g.uint32(
      /* id 14, wireType 2 =*/
      114
    ).fork()).ldelim(), A.pageNotFound != null && Object.hasOwnProperty.call(A, "pageNotFound") && $root.PageNotFound.encode(A.pageNotFound, g.uint32(
      /* id 15, wireType 2 =*/
      122
    ).fork()).ldelim(), A.pagesChanged != null && Object.hasOwnProperty.call(A, "pagesChanged") && $root.PagesChanged.encode(A.pagesChanged, g.uint32(
      /* id 16, wireType 2 =*/
      130
    ).fork()).ldelim(), A.debugLastBackmsgId != null && Object.hasOwnProperty.call(A, "debugLastBackmsgId") && g.uint32(
      /* id 17, wireType 2 =*/
      138
    ).string(A.debugLastBackmsgId), A.pageProfile != null && Object.hasOwnProperty.call(A, "pageProfile") && $root.PageProfile.encode(A.pageProfile, g.uint32(
      /* id 18, wireType 2 =*/
      146
    ).fork()).ldelim(), A.fileUrlsResponse != null && Object.hasOwnProperty.call(A, "fileUrlsResponse") && $root.FileURLsResponse.encode(A.fileUrlsResponse, g.uint32(
      /* id 19, wireType 2 =*/
      154
    ).fork()).ldelim(), A.parentMessage != null && Object.hasOwnProperty.call(A, "parentMessage") && $root.ParentMessage.encode(A.parentMessage, g.uint32(
      /* id 20, wireType 2 =*/
      162
    ).fork()).ldelim(), A.autoRerun != null && Object.hasOwnProperty.call(A, "autoRerun") && $root.AutoRerun.encode(A.autoRerun, g.uint32(
      /* id 21, wireType 2 =*/
      170
    ).fork()).ldelim(), A.logo != null && Object.hasOwnProperty.call(A, "logo") && $root.Logo.encode(A.logo, g.uint32(
      /* id 22, wireType 2 =*/
      178
    ).fork()).ldelim(), A.navigation != null && Object.hasOwnProperty.call(A, "navigation") && $root.Navigation.encode(A.navigation, g.uint32(
      /* id 23, wireType 2 =*/
      186
    ).fork()).ldelim(), A.authRedirect != null && Object.hasOwnProperty.call(A, "authRedirect") && $root.AuthRedirect.encode(A.authRedirect, g.uint32(
      /* id 24, wireType 2 =*/
      194
    ).fork()).ldelim(), A.deferredFileResponse != null && Object.hasOwnProperty.call(A, "deferredFileResponse") && $root.DeferredFileResponse.encode(A.deferredFileResponse, g.uint32(
      /* id 25, wireType 2 =*/
      202
    ).fork()).ldelim(), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader || (A = $Reader.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root.ForwardMsg();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.hash = A.string();
          break;
        }
        case 2: {
          c.metadata = $root.ForwardMsgMetadata.decode(A, A.uint32());
          break;
        }
        case 4: {
          c.newSession = $root.NewSession.decode(A, A.uint32());
          break;
        }
        case 5: {
          c.delta = $root.Delta.decode(A, A.uint32());
          break;
        }
        case 12: {
          c.pageInfoChanged = $root.PageInfo.decode(A, A.uint32());
          break;
        }
        case 13: {
          c.pageConfigChanged = $root.PageConfig.decode(A, A.uint32());
          break;
        }
        case 6: {
          c.scriptFinished = A.int32();
          break;
        }
        case 14: {
          c.gitInfoChanged = $root.GitInfo.decode(A, A.uint32());
          break;
        }
        case 18: {
          c.pageProfile = $root.PageProfile.decode(A, A.uint32());
          break;
        }
        case 9: {
          c.sessionStatusChanged = $root.SessionStatus.decode(A, A.uint32());
          break;
        }
        case 10: {
          c.sessionEvent = $root.SessionEvent.decode(A, A.uint32());
          break;
        }
        case 23: {
          c.navigation = $root.Navigation.decode(A, A.uint32());
          break;
        }
        case 15: {
          c.pageNotFound = $root.PageNotFound.decode(A, A.uint32());
          break;
        }
        case 16: {
          c.pagesChanged = $root.PagesChanged.decode(A, A.uint32());
          break;
        }
        case 19: {
          c.fileUrlsResponse = $root.FileURLsResponse.decode(A, A.uint32());
          break;
        }
        case 21: {
          c.autoRerun = $root.AutoRerun.decode(A, A.uint32());
          break;
        }
        case 22: {
          c.logo = $root.Logo.decode(A, A.uint32());
          break;
        }
        case 24: {
          c.authRedirect = $root.AuthRedirect.decode(A, A.uint32());
          break;
        }
        case 20: {
          c.parentMessage = $root.ParentMessage.decode(A, A.uint32());
          break;
        }
        case 11: {
          c.refHash = A.string();
          break;
        }
        case 25: {
          c.deferredFileResponse = $root.DeferredFileResponse.decode(A, A.uint32());
          break;
        }
        case 17: {
          c.debugLastBackmsgId = A.string();
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root.ForwardMsg) return A;
    let g = new $root.ForwardMsg();
    if (A.hash != null && (g.hash = String(A.hash)), A.metadata != null) {
      if (typeof A.metadata != "object") throw TypeError(".ForwardMsg.metadata: object expected");
      g.metadata = $root.ForwardMsgMetadata.fromObject(A.metadata);
    }
    if (A.newSession != null) {
      if (typeof A.newSession != "object") throw TypeError(".ForwardMsg.newSession: object expected");
      g.newSession = $root.NewSession.fromObject(A.newSession);
    }
    if (A.delta != null) {
      if (typeof A.delta != "object") throw TypeError(".ForwardMsg.delta: object expected");
      g.delta = $root.Delta.fromObject(A.delta);
    }
    if (A.pageInfoChanged != null) {
      if (typeof A.pageInfoChanged != "object") throw TypeError(".ForwardMsg.pageInfoChanged: object expected");
      g.pageInfoChanged = $root.PageInfo.fromObject(A.pageInfoChanged);
    }
    if (A.pageConfigChanged != null) {
      if (typeof A.pageConfigChanged != "object") throw TypeError(".ForwardMsg.pageConfigChanged: object expected");
      g.pageConfigChanged = $root.PageConfig.fromObject(A.pageConfigChanged);
    }
    switch (A.scriptFinished) {
      default:
        if (typeof A.scriptFinished == "number") {
          g.scriptFinished = A.scriptFinished;
          break;
        }
        break;
      case "FINISHED_SUCCESSFULLY":
      case 0:
        g.scriptFinished = 0;
        break;
      case "FINISHED_WITH_COMPILE_ERROR":
      case 1:
        g.scriptFinished = 1;
        break;
      case "FINISHED_EARLY_FOR_RERUN":
      case 2:
        g.scriptFinished = 2;
        break;
      case "FINISHED_FRAGMENT_RUN_SUCCESSFULLY":
      case 3:
        g.scriptFinished = 3;
        break;
    }
    if (A.gitInfoChanged != null) {
      if (typeof A.gitInfoChanged != "object") throw TypeError(".ForwardMsg.gitInfoChanged: object expected");
      g.gitInfoChanged = $root.GitInfo.fromObject(A.gitInfoChanged);
    }
    if (A.pageProfile != null) {
      if (typeof A.pageProfile != "object") throw TypeError(".ForwardMsg.pageProfile: object expected");
      g.pageProfile = $root.PageProfile.fromObject(A.pageProfile);
    }
    if (A.sessionStatusChanged != null) {
      if (typeof A.sessionStatusChanged != "object") throw TypeError(".ForwardMsg.sessionStatusChanged: object expected");
      g.sessionStatusChanged = $root.SessionStatus.fromObject(A.sessionStatusChanged);
    }
    if (A.sessionEvent != null) {
      if (typeof A.sessionEvent != "object") throw TypeError(".ForwardMsg.sessionEvent: object expected");
      g.sessionEvent = $root.SessionEvent.fromObject(A.sessionEvent);
    }
    if (A.navigation != null) {
      if (typeof A.navigation != "object") throw TypeError(".ForwardMsg.navigation: object expected");
      g.navigation = $root.Navigation.fromObject(A.navigation);
    }
    if (A.pageNotFound != null) {
      if (typeof A.pageNotFound != "object") throw TypeError(".ForwardMsg.pageNotFound: object expected");
      g.pageNotFound = $root.PageNotFound.fromObject(A.pageNotFound);
    }
    if (A.pagesChanged != null) {
      if (typeof A.pagesChanged != "object") throw TypeError(".ForwardMsg.pagesChanged: object expected");
      g.pagesChanged = $root.PagesChanged.fromObject(A.pagesChanged);
    }
    if (A.fileUrlsResponse != null) {
      if (typeof A.fileUrlsResponse != "object") throw TypeError(".ForwardMsg.fileUrlsResponse: object expected");
      g.fileUrlsResponse = $root.FileURLsResponse.fromObject(A.fileUrlsResponse);
    }
    if (A.autoRerun != null) {
      if (typeof A.autoRerun != "object") throw TypeError(".ForwardMsg.autoRerun: object expected");
      g.autoRerun = $root.AutoRerun.fromObject(A.autoRerun);
    }
    if (A.logo != null) {
      if (typeof A.logo != "object") throw TypeError(".ForwardMsg.logo: object expected");
      g.logo = $root.Logo.fromObject(A.logo);
    }
    if (A.authRedirect != null) {
      if (typeof A.authRedirect != "object") throw TypeError(".ForwardMsg.authRedirect: object expected");
      g.authRedirect = $root.AuthRedirect.fromObject(A.authRedirect);
    }
    if (A.parentMessage != null) {
      if (typeof A.parentMessage != "object") throw TypeError(".ForwardMsg.parentMessage: object expected");
      g.parentMessage = $root.ParentMessage.fromObject(A.parentMessage);
    }
    if (A.refHash != null && (g.refHash = String(A.refHash)), A.deferredFileResponse != null) {
      if (typeof A.deferredFileResponse != "object") throw TypeError(".ForwardMsg.deferredFileResponse: object expected");
      g.deferredFileResponse = $root.DeferredFileResponse.fromObject(A.deferredFileResponse);
    }
    return A.debugLastBackmsgId != null && (g.debugLastBackmsgId = String(A.debugLastBackmsgId)), g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    return g.defaults && (e.hash = "", e.metadata = null, e.debugLastBackmsgId = ""), A.hash != null && A.hasOwnProperty("hash") && (e.hash = A.hash), A.metadata != null && A.hasOwnProperty("metadata") && (e.metadata = $root.ForwardMsgMetadata.toObject(A.metadata, g)), A.newSession != null && A.hasOwnProperty("newSession") && (e.newSession = $root.NewSession.toObject(A.newSession, g), g.oneofs && (e.type = "newSession")), A.delta != null && A.hasOwnProperty("delta") && (e.delta = $root.Delta.toObject(A.delta, g), g.oneofs && (e.type = "delta")), A.scriptFinished != null && A.hasOwnProperty("scriptFinished") && (e.scriptFinished = g.enums === String ? $root.ForwardMsg.ScriptFinishedStatus[A.scriptFinished] === void 0 ? A.scriptFinished : $root.ForwardMsg.ScriptFinishedStatus[A.scriptFinished] : A.scriptFinished, g.oneofs && (e.type = "scriptFinished")), A.sessionStatusChanged != null && A.hasOwnProperty("sessionStatusChanged") && (e.sessionStatusChanged = $root.SessionStatus.toObject(A.sessionStatusChanged, g), g.oneofs && (e.type = "sessionStatusChanged")), A.sessionEvent != null && A.hasOwnProperty("sessionEvent") && (e.sessionEvent = $root.SessionEvent.toObject(A.sessionEvent, g), g.oneofs && (e.type = "sessionEvent")), A.refHash != null && A.hasOwnProperty("refHash") && (e.refHash = A.refHash, g.oneofs && (e.type = "refHash")), A.pageInfoChanged != null && A.hasOwnProperty("pageInfoChanged") && (e.pageInfoChanged = $root.PageInfo.toObject(A.pageInfoChanged, g), g.oneofs && (e.type = "pageInfoChanged")), A.pageConfigChanged != null && A.hasOwnProperty("pageConfigChanged") && (e.pageConfigChanged = $root.PageConfig.toObject(A.pageConfigChanged, g), g.oneofs && (e.type = "pageConfigChanged")), A.gitInfoChanged != null && A.hasOwnProperty("gitInfoChanged") && (e.gitInfoChanged = $root.GitInfo.toObject(A.gitInfoChanged, g), g.oneofs && (e.type = "gitInfoChanged")), A.pageNotFound != null && A.hasOwnProperty("pageNotFound") && (e.pageNotFound = $root.PageNotFound.toObject(A.pageNotFound, g), g.oneofs && (e.type = "pageNotFound")), A.pagesChanged != null && A.hasOwnProperty("pagesChanged") && (e.pagesChanged = $root.PagesChanged.toObject(A.pagesChanged, g), g.oneofs && (e.type = "pagesChanged")), A.debugLastBackmsgId != null && A.hasOwnProperty("debugLastBackmsgId") && (e.debugLastBackmsgId = A.debugLastBackmsgId), A.pageProfile != null && A.hasOwnProperty("pageProfile") && (e.pageProfile = $root.PageProfile.toObject(A.pageProfile, g), g.oneofs && (e.type = "pageProfile")), A.fileUrlsResponse != null && A.hasOwnProperty("fileUrlsResponse") && (e.fileUrlsResponse = $root.FileURLsResponse.toObject(A.fileUrlsResponse, g), g.oneofs && (e.type = "fileUrlsResponse")), A.parentMessage != null && A.hasOwnProperty("parentMessage") && (e.parentMessage = $root.ParentMessage.toObject(A.parentMessage, g), g.oneofs && (e.type = "parentMessage")), A.autoRerun != null && A.hasOwnProperty("autoRerun") && (e.autoRerun = $root.AutoRerun.toObject(A.autoRerun, g), g.oneofs && (e.type = "autoRerun")), A.logo != null && A.hasOwnProperty("logo") && (e.logo = $root.Logo.toObject(A.logo, g), g.oneofs && (e.type = "logo")), A.navigation != null && A.hasOwnProperty("navigation") && (e.navigation = $root.Navigation.toObject(A.navigation, g), g.oneofs && (e.type = "navigation")), A.authRedirect != null && A.hasOwnProperty("authRedirect") && (e.authRedirect = $root.AuthRedirect.toObject(A.authRedirect, g), g.oneofs && (e.type = "authRedirect")), A.deferredFileResponse != null && A.hasOwnProperty("deferredFileResponse") && (e.deferredFileResponse = $root.DeferredFileResponse.toObject(A.deferredFileResponse, g), g.oneofs && (e.type = "deferredFileResponse")), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/ForwardMsg";
  }, o.ScriptFinishedStatus = (function() {
    const A = {}, g = Object.create(A);
    return g[A[0] = "FINISHED_SUCCESSFULLY"] = 0, g[A[1] = "FINISHED_WITH_COMPILE_ERROR"] = 1, g[A[2] = "FINISHED_EARLY_FOR_RERUN"] = 2, g[A[3] = "FINISHED_FRAGMENT_RUN_SUCCESSFULLY"] = 3, g;
  })(), o;
})();
$root.DeferredFileResponse = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.fileId = "", o.prototype.url = "", o.prototype.errorMsg = "", o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, A) {
    return A || (A = $Writer.create()), E.fileId != null && Object.hasOwnProperty.call(E, "fileId") && A.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(E.fileId), E.url != null && Object.hasOwnProperty.call(E, "url") && A.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(E.url), E.errorMsg != null && Object.hasOwnProperty.call(E, "errorMsg") && A.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(E.errorMsg), A;
  }, o.decode = function(E, A, g) {
    E instanceof $Reader || (E = $Reader.create(E));
    let e = A === void 0 ? E.len : E.pos + A, t = new $root.DeferredFileResponse();
    for (; E.pos < e; ) {
      let c = E.uint32();
      if (c === g) break;
      switch (c >>> 3) {
        case 1: {
          t.fileId = E.string();
          break;
        }
        case 2: {
          t.url = E.string();
          break;
        }
        case 3: {
          t.errorMsg = E.string();
          break;
        }
        default:
          E.skipType(c & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(E) {
    if (E instanceof $root.DeferredFileResponse) return E;
    let A = new $root.DeferredFileResponse();
    return E.fileId != null && (A.fileId = String(E.fileId)), E.url != null && (A.url = String(E.url)), E.errorMsg != null && (A.errorMsg = String(E.errorMsg)), A;
  }, o.toObject = function(E, A) {
    A || (A = {});
    let g = {};
    return A.defaults && (g.fileId = "", g.url = "", g.errorMsg = ""), E.fileId != null && E.hasOwnProperty("fileId") && (g.fileId = E.fileId), E.url != null && E.hasOwnProperty("url") && (g.url = E.url), E.errorMsg != null && E.hasOwnProperty("errorMsg") && (g.errorMsg = E.errorMsg), g;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/DeferredFileResponse";
  }, o;
})();
$root.ForwardMsgMetadata = (() => {
  function o(E) {
    if (this.deltaPath = [], E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.cacheable = !1, o.prototype.deltaPath = $util.emptyArray, o.prototype.elementDimensionSpec = null, o.prototype.activeScriptHash = "", o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, A) {
    if (A || (A = $Writer.create()), E.cacheable != null && Object.hasOwnProperty.call(E, "cacheable") && A.uint32(
      /* id 1, wireType 0 =*/
      8
    ).bool(E.cacheable), E.deltaPath != null && E.deltaPath.length) {
      A.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork();
      for (let g = 0; g < E.deltaPath.length; ++g) A.uint32(E.deltaPath[g]);
      A.ldelim();
    }
    return E.elementDimensionSpec != null && Object.hasOwnProperty.call(E, "elementDimensionSpec") && $root.ElementDimensionSpec.encode(E.elementDimensionSpec, A.uint32(
      /* id 3, wireType 2 =*/
      26
    ).fork()).ldelim(), E.activeScriptHash != null && Object.hasOwnProperty.call(E, "activeScriptHash") && A.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(E.activeScriptHash), A;
  }, o.decode = function(E, A, g) {
    E instanceof $Reader || (E = $Reader.create(E));
    let e = A === void 0 ? E.len : E.pos + A, t = new $root.ForwardMsgMetadata();
    for (; E.pos < e; ) {
      let c = E.uint32();
      if (c === g) break;
      switch (c >>> 3) {
        case 1: {
          t.cacheable = E.bool();
          break;
        }
        case 2: {
          if (t.deltaPath && t.deltaPath.length || (t.deltaPath = []), (c & 7) === 2) {
            let n = E.uint32() + E.pos;
            for (; E.pos < n; ) t.deltaPath.push(E.uint32());
          } else t.deltaPath.push(E.uint32());
          break;
        }
        case 3: {
          t.elementDimensionSpec = $root.ElementDimensionSpec.decode(E, E.uint32());
          break;
        }
        case 4: {
          t.activeScriptHash = E.string();
          break;
        }
        default:
          E.skipType(c & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(E) {
    if (E instanceof $root.ForwardMsgMetadata) return E;
    let A = new $root.ForwardMsgMetadata();
    if (E.cacheable != null && (A.cacheable = !!E.cacheable), E.deltaPath) {
      if (!Array.isArray(E.deltaPath)) throw TypeError(".ForwardMsgMetadata.deltaPath: array expected");
      A.deltaPath = [];
      for (let g = 0; g < E.deltaPath.length; ++g) A.deltaPath[g] = E.deltaPath[g] >>> 0;
    }
    if (E.elementDimensionSpec != null) {
      if (typeof E.elementDimensionSpec != "object") throw TypeError(".ForwardMsgMetadata.elementDimensionSpec: object expected");
      A.elementDimensionSpec = $root.ElementDimensionSpec.fromObject(E.elementDimensionSpec);
    }
    return E.activeScriptHash != null && (A.activeScriptHash = String(E.activeScriptHash)), A;
  }, o.toObject = function(E, A) {
    A || (A = {});
    let g = {};
    if ((A.arrays || A.defaults) && (g.deltaPath = []), A.defaults && (g.cacheable = !1, g.elementDimensionSpec = null, g.activeScriptHash = ""), E.cacheable != null && E.hasOwnProperty("cacheable") && (g.cacheable = E.cacheable), E.deltaPath && E.deltaPath.length) {
      g.deltaPath = [];
      for (let e = 0; e < E.deltaPath.length; ++e) g.deltaPath[e] = E.deltaPath[e];
    }
    return E.elementDimensionSpec != null && E.hasOwnProperty("elementDimensionSpec") && (g.elementDimensionSpec = $root.ElementDimensionSpec.toObject(E.elementDimensionSpec, A)), E.activeScriptHash != null && E.hasOwnProperty("activeScriptHash") && (g.activeScriptHash = E.activeScriptHash), g;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/ForwardMsgMetadata";
  }, o;
})();
$root.ElementDimensionSpec = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.width = 0, o.prototype.height = 0, o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, A) {
    return A || (A = $Writer.create()), E.width != null && Object.hasOwnProperty.call(E, "width") && A.uint32(
      /* id 1, wireType 0 =*/
      8
    ).uint32(E.width), E.height != null && Object.hasOwnProperty.call(E, "height") && A.uint32(
      /* id 2, wireType 0 =*/
      16
    ).uint32(E.height), A;
  }, o.decode = function(E, A, g) {
    E instanceof $Reader || (E = $Reader.create(E));
    let e = A === void 0 ? E.len : E.pos + A, t = new $root.ElementDimensionSpec();
    for (; E.pos < e; ) {
      let c = E.uint32();
      if (c === g) break;
      switch (c >>> 3) {
        case 1: {
          t.width = E.uint32();
          break;
        }
        case 2: {
          t.height = E.uint32();
          break;
        }
        default:
          E.skipType(c & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(E) {
    if (E instanceof $root.ElementDimensionSpec) return E;
    let A = new $root.ElementDimensionSpec();
    return E.width != null && (A.width = E.width >>> 0), E.height != null && (A.height = E.height >>> 0), A;
  }, o.toObject = function(E, A) {
    A || (A = {});
    let g = {};
    return A.defaults && (g.width = 0, g.height = 0), E.width != null && E.hasOwnProperty("width") && (g.width = E.width), E.height != null && E.hasOwnProperty("height") && (g.height = E.height), g;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/ElementDimensionSpec";
  }, o;
})();
$root.ForwardMsgList = (() => {
  function o(E) {
    if (this.messages = [], E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.messages = $util.emptyArray, o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, A) {
    if (A || (A = $Writer.create()), E.messages != null && E.messages.length) for (let g = 0; g < E.messages.length; ++g) $root.ForwardMsg.encode(E.messages[g], A.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim();
    return A;
  }, o.decode = function(E, A, g) {
    E instanceof $Reader || (E = $Reader.create(E));
    let e = A === void 0 ? E.len : E.pos + A, t = new $root.ForwardMsgList();
    for (; E.pos < e; ) {
      let c = E.uint32();
      if (c === g) break;
      c >>> 3 === 1 ? (t.messages && t.messages.length || (t.messages = []), t.messages.push($root.ForwardMsg.decode(E, E.uint32()))) : E.skipType(c & 7);
    }
    return t;
  }, o.fromObject = function(E) {
    if (E instanceof $root.ForwardMsgList) return E;
    let A = new $root.ForwardMsgList();
    if (E.messages) {
      if (!Array.isArray(E.messages)) throw TypeError(".ForwardMsgList.messages: array expected");
      A.messages = [];
      for (let g = 0; g < E.messages.length; ++g) {
        if (typeof E.messages[g] != "object") throw TypeError(".ForwardMsgList.messages: object expected");
        A.messages[g] = $root.ForwardMsg.fromObject(E.messages[g]);
      }
    }
    return A;
  }, o.toObject = function(E, A) {
    A || (A = {});
    let g = {};
    if ((A.arrays || A.defaults) && (g.messages = []), E.messages && E.messages.length) {
      g.messages = [];
      for (let e = 0; e < E.messages.length; ++e) g.messages[e] = $root.ForwardMsg.toObject(E.messages[e], A);
    }
    return g;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/ForwardMsgList";
  }, o;
})();
$root.GitInfo = (() => {
  function o(E) {
    if (this.untrackedFiles = [], this.uncommittedFiles = [], E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.repository = "", o.prototype.branch = "", o.prototype.module = "", o.prototype.untrackedFiles = $util.emptyArray, o.prototype.uncommittedFiles = $util.emptyArray, o.prototype.state = 0, o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, A) {
    if (A || (A = $Writer.create()), E.repository != null && Object.hasOwnProperty.call(E, "repository") && A.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(E.repository), E.branch != null && Object.hasOwnProperty.call(E, "branch") && A.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(E.branch), E.module != null && Object.hasOwnProperty.call(E, "module") && A.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(E.module), E.untrackedFiles != null && E.untrackedFiles.length) for (let g = 0; g < E.untrackedFiles.length; ++g) A.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(E.untrackedFiles[g]);
    if (E.uncommittedFiles != null && E.uncommittedFiles.length) for (let g = 0; g < E.uncommittedFiles.length; ++g) A.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(E.uncommittedFiles[g]);
    return E.state != null && Object.hasOwnProperty.call(E, "state") && A.uint32(
      /* id 6, wireType 0 =*/
      48
    ).int32(E.state), A;
  }, o.decode = function(E, A, g) {
    E instanceof $Reader || (E = $Reader.create(E));
    let e = A === void 0 ? E.len : E.pos + A, t = new $root.GitInfo();
    for (; E.pos < e; ) {
      let c = E.uint32();
      if (c === g) break;
      switch (c >>> 3) {
        case 1: {
          t.repository = E.string();
          break;
        }
        case 2: {
          t.branch = E.string();
          break;
        }
        case 3: {
          t.module = E.string();
          break;
        }
        case 4: {
          t.untrackedFiles && t.untrackedFiles.length || (t.untrackedFiles = []), t.untrackedFiles.push(E.string());
          break;
        }
        case 5: {
          t.uncommittedFiles && t.uncommittedFiles.length || (t.uncommittedFiles = []), t.uncommittedFiles.push(E.string());
          break;
        }
        case 6: {
          t.state = E.int32();
          break;
        }
        default:
          E.skipType(c & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(E) {
    if (E instanceof $root.GitInfo) return E;
    let A = new $root.GitInfo();
    if (E.repository != null && (A.repository = String(E.repository)), E.branch != null && (A.branch = String(E.branch)), E.module != null && (A.module = String(E.module)), E.untrackedFiles) {
      if (!Array.isArray(E.untrackedFiles)) throw TypeError(".GitInfo.untrackedFiles: array expected");
      A.untrackedFiles = [];
      for (let g = 0; g < E.untrackedFiles.length; ++g) A.untrackedFiles[g] = String(E.untrackedFiles[g]);
    }
    if (E.uncommittedFiles) {
      if (!Array.isArray(E.uncommittedFiles)) throw TypeError(".GitInfo.uncommittedFiles: array expected");
      A.uncommittedFiles = [];
      for (let g = 0; g < E.uncommittedFiles.length; ++g) A.uncommittedFiles[g] = String(E.uncommittedFiles[g]);
    }
    switch (E.state) {
      default:
        if (typeof E.state == "number") {
          A.state = E.state;
          break;
        }
        break;
      case "DEFAULT":
      case 0:
        A.state = 0;
        break;
      case "HEAD_DETACHED":
      case 1:
        A.state = 1;
        break;
      case "AHEAD_OF_REMOTE":
      case 2:
        A.state = 2;
        break;
    }
    return A;
  }, o.toObject = function(E, A) {
    A || (A = {});
    let g = {};
    if ((A.arrays || A.defaults) && (g.untrackedFiles = [], g.uncommittedFiles = []), A.defaults && (g.repository = "", g.branch = "", g.module = "", g.state = A.enums === String ? "DEFAULT" : 0), E.repository != null && E.hasOwnProperty("repository") && (g.repository = E.repository), E.branch != null && E.hasOwnProperty("branch") && (g.branch = E.branch), E.module != null && E.hasOwnProperty("module") && (g.module = E.module), E.untrackedFiles && E.untrackedFiles.length) {
      g.untrackedFiles = [];
      for (let e = 0; e < E.untrackedFiles.length; ++e) g.untrackedFiles[e] = E.untrackedFiles[e];
    }
    if (E.uncommittedFiles && E.uncommittedFiles.length) {
      g.uncommittedFiles = [];
      for (let e = 0; e < E.uncommittedFiles.length; ++e) g.uncommittedFiles[e] = E.uncommittedFiles[e];
    }
    return E.state != null && E.hasOwnProperty("state") && (g.state = A.enums === String ? $root.GitInfo.GitStates[E.state] === void 0 ? E.state : $root.GitInfo.GitStates[E.state] : E.state), g;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/GitInfo";
  }, o.GitStates = (function() {
    const E = {}, A = Object.create(E);
    return A[E[0] = "DEFAULT"] = 0, A[E[1] = "HEAD_DETACHED"] = 1, A[E[2] = "AHEAD_OF_REMOTE"] = 2, A;
  })(), o;
})();
$root.Logo = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.image = "", o.prototype.link = "", o.prototype.iconImage = "", o.prototype.size = "", o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, A) {
    return A || (A = $Writer.create()), E.image != null && Object.hasOwnProperty.call(E, "image") && A.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(E.image), E.link != null && Object.hasOwnProperty.call(E, "link") && A.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(E.link), E.iconImage != null && Object.hasOwnProperty.call(E, "iconImage") && A.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(E.iconImage), E.size != null && Object.hasOwnProperty.call(E, "size") && A.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(E.size), A;
  }, o.decode = function(E, A, g) {
    E instanceof $Reader || (E = $Reader.create(E));
    let e = A === void 0 ? E.len : E.pos + A, t = new $root.Logo();
    for (; E.pos < e; ) {
      let c = E.uint32();
      if (c === g) break;
      switch (c >>> 3) {
        case 1: {
          t.image = E.string();
          break;
        }
        case 2: {
          t.link = E.string();
          break;
        }
        case 3: {
          t.iconImage = E.string();
          break;
        }
        case 4: {
          t.size = E.string();
          break;
        }
        default:
          E.skipType(c & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(E) {
    if (E instanceof $root.Logo) return E;
    let A = new $root.Logo();
    return E.image != null && (A.image = String(E.image)), E.link != null && (A.link = String(E.link)), E.iconImage != null && (A.iconImage = String(E.iconImage)), E.size != null && (A.size = String(E.size)), A;
  }, o.toObject = function(E, A) {
    A || (A = {});
    let g = {};
    return A.defaults && (g.image = "", g.link = "", g.iconImage = "", g.size = ""), E.image != null && E.hasOwnProperty("image") && (g.image = E.image), E.link != null && E.hasOwnProperty("link") && (g.link = E.link), E.iconImage != null && E.hasOwnProperty("iconImage") && (g.iconImage = E.iconImage), E.size != null && E.hasOwnProperty("size") && (g.size = E.size), g;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/Logo";
  }, o;
})();
$root.Navigation = (() => {
  function o(E) {
    if (this.sections = [], this.appPages = [], E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.sections = $util.emptyArray, o.prototype.appPages = $util.emptyArray, o.prototype.position = 0, o.prototype.pageScriptHash = "", o.prototype.expanded = !1, o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, A) {
    if (A || (A = $Writer.create()), E.sections != null && E.sections.length) for (let g = 0; g < E.sections.length; ++g) A.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(E.sections[g]);
    if (E.appPages != null && E.appPages.length) for (let g = 0; g < E.appPages.length; ++g) $root.AppPage.encode(E.appPages[g], A.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim();
    return E.position != null && Object.hasOwnProperty.call(E, "position") && A.uint32(
      /* id 3, wireType 0 =*/
      24
    ).int32(E.position), E.pageScriptHash != null && Object.hasOwnProperty.call(E, "pageScriptHash") && A.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(E.pageScriptHash), E.expanded != null && Object.hasOwnProperty.call(E, "expanded") && A.uint32(
      /* id 5, wireType 0 =*/
      40
    ).bool(E.expanded), A;
  }, o.decode = function(E, A, g) {
    E instanceof $Reader || (E = $Reader.create(E));
    let e = A === void 0 ? E.len : E.pos + A, t = new $root.Navigation();
    for (; E.pos < e; ) {
      let c = E.uint32();
      if (c === g) break;
      switch (c >>> 3) {
        case 1: {
          t.sections && t.sections.length || (t.sections = []), t.sections.push(E.string());
          break;
        }
        case 2: {
          t.appPages && t.appPages.length || (t.appPages = []), t.appPages.push($root.AppPage.decode(E, E.uint32()));
          break;
        }
        case 3: {
          t.position = E.int32();
          break;
        }
        case 4: {
          t.pageScriptHash = E.string();
          break;
        }
        case 5: {
          t.expanded = E.bool();
          break;
        }
        default:
          E.skipType(c & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(E) {
    if (E instanceof $root.Navigation) return E;
    let A = new $root.Navigation();
    if (E.sections) {
      if (!Array.isArray(E.sections)) throw TypeError(".Navigation.sections: array expected");
      A.sections = [];
      for (let g = 0; g < E.sections.length; ++g) A.sections[g] = String(E.sections[g]);
    }
    if (E.appPages) {
      if (!Array.isArray(E.appPages)) throw TypeError(".Navigation.appPages: array expected");
      A.appPages = [];
      for (let g = 0; g < E.appPages.length; ++g) {
        if (typeof E.appPages[g] != "object") throw TypeError(".Navigation.appPages: object expected");
        A.appPages[g] = $root.AppPage.fromObject(E.appPages[g]);
      }
    }
    switch (E.position) {
      default:
        if (typeof E.position == "number") {
          A.position = E.position;
          break;
        }
        break;
      case "HIDDEN":
      case 0:
        A.position = 0;
        break;
      case "SIDEBAR":
      case 1:
        A.position = 1;
        break;
      case "TOP":
      case 2:
        A.position = 2;
        break;
    }
    return E.pageScriptHash != null && (A.pageScriptHash = String(E.pageScriptHash)), E.expanded != null && (A.expanded = !!E.expanded), A;
  }, o.toObject = function(E, A) {
    A || (A = {});
    let g = {};
    if ((A.arrays || A.defaults) && (g.sections = [], g.appPages = []), A.defaults && (g.position = A.enums === String ? "HIDDEN" : 0, g.pageScriptHash = "", g.expanded = !1), E.sections && E.sections.length) {
      g.sections = [];
      for (let e = 0; e < E.sections.length; ++e) g.sections[e] = E.sections[e];
    }
    if (E.appPages && E.appPages.length) {
      g.appPages = [];
      for (let e = 0; e < E.appPages.length; ++e) g.appPages[e] = $root.AppPage.toObject(E.appPages[e], A);
    }
    return E.position != null && E.hasOwnProperty("position") && (g.position = A.enums === String ? $root.Navigation.Position[E.position] === void 0 ? E.position : $root.Navigation.Position[E.position] : E.position), E.pageScriptHash != null && E.hasOwnProperty("pageScriptHash") && (g.pageScriptHash = E.pageScriptHash), E.expanded != null && E.hasOwnProperty("expanded") && (g.expanded = E.expanded), g;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/Navigation";
  }, o.Position = (function() {
    const E = {}, A = Object.create(E);
    return A[E[0] = "HIDDEN"] = 0, A[E[1] = "SIDEBAR"] = 1, A[E[2] = "TOP"] = 2, A;
  })(), o;
})();
$root.NewSession = (() => {
  function o(E) {
    if (this.appPages = [], this.fragmentIdsThisRun = [], E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.initialize = null, o.prototype.scriptRunId = "", o.prototype.name = "", o.prototype.mainScriptPath = "", o.prototype.config = null, o.prototype.customTheme = null, o.prototype.appPages = $util.emptyArray, o.prototype.pageScriptHash = "", o.prototype.fragmentIdsThisRun = $util.emptyArray, o.prototype.mainScriptHash = "", o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, A) {
    if (A || (A = $Writer.create()), E.initialize != null && Object.hasOwnProperty.call(E, "initialize") && $root.Initialize.encode(E.initialize, A.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim(), E.scriptRunId != null && Object.hasOwnProperty.call(E, "scriptRunId") && A.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(E.scriptRunId), E.name != null && Object.hasOwnProperty.call(E, "name") && A.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(E.name), E.mainScriptPath != null && Object.hasOwnProperty.call(E, "mainScriptPath") && A.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(E.mainScriptPath), E.config != null && Object.hasOwnProperty.call(E, "config") && $root.Config.encode(E.config, A.uint32(
      /* id 6, wireType 2 =*/
      50
    ).fork()).ldelim(), E.customTheme != null && Object.hasOwnProperty.call(E, "customTheme") && $root.CustomThemeConfig.encode(E.customTheme, A.uint32(
      /* id 7, wireType 2 =*/
      58
    ).fork()).ldelim(), E.appPages != null && E.appPages.length) for (let g = 0; g < E.appPages.length; ++g) $root.AppPage.encode(E.appPages[g], A.uint32(
      /* id 8, wireType 2 =*/
      66
    ).fork()).ldelim();
    if (E.pageScriptHash != null && Object.hasOwnProperty.call(E, "pageScriptHash") && A.uint32(
      /* id 9, wireType 2 =*/
      74
    ).string(E.pageScriptHash), E.fragmentIdsThisRun != null && E.fragmentIdsThisRun.length) for (let g = 0; g < E.fragmentIdsThisRun.length; ++g) A.uint32(
      /* id 10, wireType 2 =*/
      82
    ).string(E.fragmentIdsThisRun[g]);
    return E.mainScriptHash != null && Object.hasOwnProperty.call(E, "mainScriptHash") && A.uint32(
      /* id 11, wireType 2 =*/
      90
    ).string(E.mainScriptHash), A;
  }, o.decode = function(E, A, g) {
    E instanceof $Reader || (E = $Reader.create(E));
    let e = A === void 0 ? E.len : E.pos + A, t = new $root.NewSession();
    for (; E.pos < e; ) {
      let c = E.uint32();
      if (c === g) break;
      switch (c >>> 3) {
        case 1: {
          t.initialize = $root.Initialize.decode(E, E.uint32());
          break;
        }
        case 2: {
          t.scriptRunId = E.string();
          break;
        }
        case 3: {
          t.name = E.string();
          break;
        }
        case 4: {
          t.mainScriptPath = E.string();
          break;
        }
        case 6: {
          t.config = $root.Config.decode(E, E.uint32());
          break;
        }
        case 7: {
          t.customTheme = $root.CustomThemeConfig.decode(E, E.uint32());
          break;
        }
        case 8: {
          t.appPages && t.appPages.length || (t.appPages = []), t.appPages.push($root.AppPage.decode(E, E.uint32()));
          break;
        }
        case 9: {
          t.pageScriptHash = E.string();
          break;
        }
        case 10: {
          t.fragmentIdsThisRun && t.fragmentIdsThisRun.length || (t.fragmentIdsThisRun = []), t.fragmentIdsThisRun.push(E.string());
          break;
        }
        case 11: {
          t.mainScriptHash = E.string();
          break;
        }
        default:
          E.skipType(c & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(E) {
    if (E instanceof $root.NewSession) return E;
    let A = new $root.NewSession();
    if (E.initialize != null) {
      if (typeof E.initialize != "object") throw TypeError(".NewSession.initialize: object expected");
      A.initialize = $root.Initialize.fromObject(E.initialize);
    }
    if (E.scriptRunId != null && (A.scriptRunId = String(E.scriptRunId)), E.name != null && (A.name = String(E.name)), E.mainScriptPath != null && (A.mainScriptPath = String(E.mainScriptPath)), E.config != null) {
      if (typeof E.config != "object") throw TypeError(".NewSession.config: object expected");
      A.config = $root.Config.fromObject(E.config);
    }
    if (E.customTheme != null) {
      if (typeof E.customTheme != "object") throw TypeError(".NewSession.customTheme: object expected");
      A.customTheme = $root.CustomThemeConfig.fromObject(E.customTheme);
    }
    if (E.appPages) {
      if (!Array.isArray(E.appPages)) throw TypeError(".NewSession.appPages: array expected");
      A.appPages = [];
      for (let g = 0; g < E.appPages.length; ++g) {
        if (typeof E.appPages[g] != "object") throw TypeError(".NewSession.appPages: object expected");
        A.appPages[g] = $root.AppPage.fromObject(E.appPages[g]);
      }
    }
    if (E.pageScriptHash != null && (A.pageScriptHash = String(E.pageScriptHash)), E.fragmentIdsThisRun) {
      if (!Array.isArray(E.fragmentIdsThisRun)) throw TypeError(".NewSession.fragmentIdsThisRun: array expected");
      A.fragmentIdsThisRun = [];
      for (let g = 0; g < E.fragmentIdsThisRun.length; ++g) A.fragmentIdsThisRun[g] = String(E.fragmentIdsThisRun[g]);
    }
    return E.mainScriptHash != null && (A.mainScriptHash = String(E.mainScriptHash)), A;
  }, o.toObject = function(E, A) {
    A || (A = {});
    let g = {};
    if ((A.arrays || A.defaults) && (g.appPages = [], g.fragmentIdsThisRun = []), A.defaults && (g.initialize = null, g.scriptRunId = "", g.name = "", g.mainScriptPath = "", g.config = null, g.customTheme = null, g.pageScriptHash = "", g.mainScriptHash = ""), E.initialize != null && E.hasOwnProperty("initialize") && (g.initialize = $root.Initialize.toObject(E.initialize, A)), E.scriptRunId != null && E.hasOwnProperty("scriptRunId") && (g.scriptRunId = E.scriptRunId), E.name != null && E.hasOwnProperty("name") && (g.name = E.name), E.mainScriptPath != null && E.hasOwnProperty("mainScriptPath") && (g.mainScriptPath = E.mainScriptPath), E.config != null && E.hasOwnProperty("config") && (g.config = $root.Config.toObject(E.config, A)), E.customTheme != null && E.hasOwnProperty("customTheme") && (g.customTheme = $root.CustomThemeConfig.toObject(E.customTheme, A)), E.appPages && E.appPages.length) {
      g.appPages = [];
      for (let e = 0; e < E.appPages.length; ++e) g.appPages[e] = $root.AppPage.toObject(E.appPages[e], A);
    }
    if (E.pageScriptHash != null && E.hasOwnProperty("pageScriptHash") && (g.pageScriptHash = E.pageScriptHash), E.fragmentIdsThisRun && E.fragmentIdsThisRun.length) {
      g.fragmentIdsThisRun = [];
      for (let e = 0; e < E.fragmentIdsThisRun.length; ++e) g.fragmentIdsThisRun[e] = E.fragmentIdsThisRun[e];
    }
    return E.mainScriptHash != null && E.hasOwnProperty("mainScriptHash") && (g.mainScriptHash = E.mainScriptHash), g;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/NewSession";
  }, o;
})();
$root.Initialize = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.userInfo = null, o.prototype.environmentInfo = null, o.prototype.sessionStatus = null, o.prototype.commandLine = "", o.prototype.sessionId = "", o.prototype.isHello = !1, o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, A) {
    return A || (A = $Writer.create()), E.userInfo != null && Object.hasOwnProperty.call(E, "userInfo") && $root.UserInfo.encode(E.userInfo, A.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim(), E.environmentInfo != null && Object.hasOwnProperty.call(E, "environmentInfo") && $root.EnvironmentInfo.encode(E.environmentInfo, A.uint32(
      /* id 3, wireType 2 =*/
      26
    ).fork()).ldelim(), E.sessionStatus != null && Object.hasOwnProperty.call(E, "sessionStatus") && $root.SessionStatus.encode(E.sessionStatus, A.uint32(
      /* id 4, wireType 2 =*/
      34
    ).fork()).ldelim(), E.commandLine != null && Object.hasOwnProperty.call(E, "commandLine") && A.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(E.commandLine), E.sessionId != null && Object.hasOwnProperty.call(E, "sessionId") && A.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(E.sessionId), E.isHello != null && Object.hasOwnProperty.call(E, "isHello") && A.uint32(
      /* id 7, wireType 0 =*/
      56
    ).bool(E.isHello), A;
  }, o.decode = function(E, A, g) {
    E instanceof $Reader || (E = $Reader.create(E));
    let e = A === void 0 ? E.len : E.pos + A, t = new $root.Initialize();
    for (; E.pos < e; ) {
      let c = E.uint32();
      if (c === g) break;
      switch (c >>> 3) {
        case 1: {
          t.userInfo = $root.UserInfo.decode(E, E.uint32());
          break;
        }
        case 3: {
          t.environmentInfo = $root.EnvironmentInfo.decode(E, E.uint32());
          break;
        }
        case 4: {
          t.sessionStatus = $root.SessionStatus.decode(E, E.uint32());
          break;
        }
        case 5: {
          t.commandLine = E.string();
          break;
        }
        case 6: {
          t.sessionId = E.string();
          break;
        }
        case 7: {
          t.isHello = E.bool();
          break;
        }
        default:
          E.skipType(c & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(E) {
    if (E instanceof $root.Initialize) return E;
    let A = new $root.Initialize();
    if (E.userInfo != null) {
      if (typeof E.userInfo != "object") throw TypeError(".Initialize.userInfo: object expected");
      A.userInfo = $root.UserInfo.fromObject(E.userInfo);
    }
    if (E.environmentInfo != null) {
      if (typeof E.environmentInfo != "object") throw TypeError(".Initialize.environmentInfo: object expected");
      A.environmentInfo = $root.EnvironmentInfo.fromObject(E.environmentInfo);
    }
    if (E.sessionStatus != null) {
      if (typeof E.sessionStatus != "object") throw TypeError(".Initialize.sessionStatus: object expected");
      A.sessionStatus = $root.SessionStatus.fromObject(E.sessionStatus);
    }
    return E.commandLine != null && (A.commandLine = String(E.commandLine)), E.sessionId != null && (A.sessionId = String(E.sessionId)), E.isHello != null && (A.isHello = !!E.isHello), A;
  }, o.toObject = function(E, A) {
    A || (A = {});
    let g = {};
    return A.defaults && (g.userInfo = null, g.environmentInfo = null, g.sessionStatus = null, g.commandLine = "", g.sessionId = "", g.isHello = !1), E.userInfo != null && E.hasOwnProperty("userInfo") && (g.userInfo = $root.UserInfo.toObject(E.userInfo, A)), E.environmentInfo != null && E.hasOwnProperty("environmentInfo") && (g.environmentInfo = $root.EnvironmentInfo.toObject(E.environmentInfo, A)), E.sessionStatus != null && E.hasOwnProperty("sessionStatus") && (g.sessionStatus = $root.SessionStatus.toObject(E.sessionStatus, A)), E.commandLine != null && E.hasOwnProperty("commandLine") && (g.commandLine = E.commandLine), E.sessionId != null && E.hasOwnProperty("sessionId") && (g.sessionId = E.sessionId), E.isHello != null && E.hasOwnProperty("isHello") && (g.isHello = E.isHello), g;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/Initialize";
  }, o;
})();
$root.Config = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.gatherUsageStats = !1, o.prototype.maxCachedMessageAge = 0, o.prototype.mapboxToken = "", o.prototype.allowRunOnSave = !1, o.prototype.hideTopBar = !1, o.prototype.hideSidebarNav = !1, o.prototype.toolbarMode = 0, o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, A) {
    return A || (A = $Writer.create()), E.gatherUsageStats != null && Object.hasOwnProperty.call(E, "gatherUsageStats") && A.uint32(
      /* id 2, wireType 0 =*/
      16
    ).bool(E.gatherUsageStats), E.maxCachedMessageAge != null && Object.hasOwnProperty.call(E, "maxCachedMessageAge") && A.uint32(
      /* id 3, wireType 0 =*/
      24
    ).int32(E.maxCachedMessageAge), E.mapboxToken != null && Object.hasOwnProperty.call(E, "mapboxToken") && A.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(E.mapboxToken), E.allowRunOnSave != null && Object.hasOwnProperty.call(E, "allowRunOnSave") && A.uint32(
      /* id 5, wireType 0 =*/
      40
    ).bool(E.allowRunOnSave), E.hideTopBar != null && Object.hasOwnProperty.call(E, "hideTopBar") && A.uint32(
      /* id 6, wireType 0 =*/
      48
    ).bool(E.hideTopBar), E.hideSidebarNav != null && Object.hasOwnProperty.call(E, "hideSidebarNav") && A.uint32(
      /* id 7, wireType 0 =*/
      56
    ).bool(E.hideSidebarNav), E.toolbarMode != null && Object.hasOwnProperty.call(E, "toolbarMode") && A.uint32(
      /* id 8, wireType 0 =*/
      64
    ).int32(E.toolbarMode), A;
  }, o.decode = function(E, A, g) {
    E instanceof $Reader || (E = $Reader.create(E));
    let e = A === void 0 ? E.len : E.pos + A, t = new $root.Config();
    for (; E.pos < e; ) {
      let c = E.uint32();
      if (c === g) break;
      switch (c >>> 3) {
        case 2: {
          t.gatherUsageStats = E.bool();
          break;
        }
        case 3: {
          t.maxCachedMessageAge = E.int32();
          break;
        }
        case 4: {
          t.mapboxToken = E.string();
          break;
        }
        case 5: {
          t.allowRunOnSave = E.bool();
          break;
        }
        case 6: {
          t.hideTopBar = E.bool();
          break;
        }
        case 7: {
          t.hideSidebarNav = E.bool();
          break;
        }
        case 8: {
          t.toolbarMode = E.int32();
          break;
        }
        default:
          E.skipType(c & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(E) {
    if (E instanceof $root.Config) return E;
    let A = new $root.Config();
    switch (E.gatherUsageStats != null && (A.gatherUsageStats = !!E.gatherUsageStats), E.maxCachedMessageAge != null && (A.maxCachedMessageAge = E.maxCachedMessageAge | 0), E.mapboxToken != null && (A.mapboxToken = String(E.mapboxToken)), E.allowRunOnSave != null && (A.allowRunOnSave = !!E.allowRunOnSave), E.hideTopBar != null && (A.hideTopBar = !!E.hideTopBar), E.hideSidebarNav != null && (A.hideSidebarNav = !!E.hideSidebarNav), E.toolbarMode) {
      default:
        if (typeof E.toolbarMode == "number") {
          A.toolbarMode = E.toolbarMode;
          break;
        }
        break;
      case "AUTO":
      case 0:
        A.toolbarMode = 0;
        break;
      case "DEVELOPER":
      case 1:
        A.toolbarMode = 1;
        break;
      case "VIEWER":
      case 2:
        A.toolbarMode = 2;
        break;
      case "MINIMAL":
      case 3:
        A.toolbarMode = 3;
        break;
    }
    return A;
  }, o.toObject = function(E, A) {
    A || (A = {});
    let g = {};
    return A.defaults && (g.gatherUsageStats = !1, g.maxCachedMessageAge = 0, g.mapboxToken = "", g.allowRunOnSave = !1, g.hideTopBar = !1, g.hideSidebarNav = !1, g.toolbarMode = A.enums === String ? "AUTO" : 0), E.gatherUsageStats != null && E.hasOwnProperty("gatherUsageStats") && (g.gatherUsageStats = E.gatherUsageStats), E.maxCachedMessageAge != null && E.hasOwnProperty("maxCachedMessageAge") && (g.maxCachedMessageAge = E.maxCachedMessageAge), E.mapboxToken != null && E.hasOwnProperty("mapboxToken") && (g.mapboxToken = E.mapboxToken), E.allowRunOnSave != null && E.hasOwnProperty("allowRunOnSave") && (g.allowRunOnSave = E.allowRunOnSave), E.hideTopBar != null && E.hasOwnProperty("hideTopBar") && (g.hideTopBar = E.hideTopBar), E.hideSidebarNav != null && E.hasOwnProperty("hideSidebarNav") && (g.hideSidebarNav = E.hideSidebarNav), E.toolbarMode != null && E.hasOwnProperty("toolbarMode") && (g.toolbarMode = A.enums === String ? $root.Config.ToolbarMode[E.toolbarMode] === void 0 ? E.toolbarMode : $root.Config.ToolbarMode[E.toolbarMode] : E.toolbarMode), g;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/Config";
  }, o.ToolbarMode = (function() {
    const E = {}, A = Object.create(E);
    return A[E[0] = "AUTO"] = 0, A[E[1] = "DEVELOPER"] = 1, A[E[2] = "VIEWER"] = 2, A[E[3] = "MINIMAL"] = 3, A;
  })(), o;
})();
$root.CustomThemeConfig = (() => {
  function o(A) {
    if (this.fontFaces = [], this.fontSources = [], this.headingFontSizes = [], this.headingFontWeights = [], this.chartCategoricalColors = [], this.chartSequentialColors = [], A) for (let g = Object.keys(A), e = 0; e < g.length; ++e) A[g[e]] != null && (this[g[e]] = A[g[e]]);
  }
  o.prototype.primaryColor = "", o.prototype.secondaryBackgroundColor = "", o.prototype.backgroundColor = "", o.prototype.textColor = "", o.prototype.font = 0, o.prototype.base = 0, o.prototype.widgetBackgroundColor = "", o.prototype.widgetBorderColor = "", o.prototype.radii = null, o.prototype.headingFont = "", o.prototype.bodyFont = "", o.prototype.codeFont = "", o.prototype.fontFaces = $util.emptyArray, o.prototype.fontSources = $util.emptyArray, o.prototype.fontSizes = null, o.prototype.skeletonBackgroundColor = "", o.prototype.baseRadius = null, o.prototype.buttonRadius = null, o.prototype.borderColor = null, o.prototype.dataframeBorderColor = null, o.prototype.showWidgetBorder = null, o.prototype.linkColor = null, o.prototype.linkUnderline = null, o.prototype.baseFontSize = null, o.prototype.baseFontWeight = null, o.prototype.codeFontWeight = null, o.prototype.codeFontSize = null, o.prototype.headingFontSizes = $util.emptyArray, o.prototype.headingFontWeights = $util.emptyArray, o.prototype.showSidebarBorder = null, o.prototype.codeTextColor = null, o.prototype.codeBackgroundColor = null, o.prototype.dataframeHeaderBackgroundColor = null, o.prototype.chartCategoricalColors = $util.emptyArray, o.prototype.chartSequentialColors = $util.emptyArray, o.prototype.redColor = null, o.prototype.orangeColor = null, o.prototype.yellowColor = null, o.prototype.blueColor = null, o.prototype.greenColor = null, o.prototype.violetColor = null, o.prototype.grayColor = null, o.prototype.redBackgroundColor = null, o.prototype.orangeBackgroundColor = null, o.prototype.yellowBackgroundColor = null, o.prototype.blueBackgroundColor = null, o.prototype.greenBackgroundColor = null, o.prototype.violetBackgroundColor = null, o.prototype.grayBackgroundColor = null, o.prototype.redTextColor = null, o.prototype.orangeTextColor = null, o.prototype.yellowTextColor = null, o.prototype.blueTextColor = null, o.prototype.greenTextColor = null, o.prototype.violetTextColor = null, o.prototype.grayTextColor = null, o.prototype.sidebar = null, o.prototype.light = null, o.prototype.dark = null;
  let E;
  return Object.defineProperty(o.prototype, "_baseRadius", { get: $util.oneOfGetter(E = ["baseRadius"]), set: $util.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_buttonRadius", { get: $util.oneOfGetter(E = ["buttonRadius"]), set: $util.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_borderColor", { get: $util.oneOfGetter(E = ["borderColor"]), set: $util.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_dataframeBorderColor", { get: $util.oneOfGetter(E = ["dataframeBorderColor"]), set: $util.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_showWidgetBorder", { get: $util.oneOfGetter(E = ["showWidgetBorder"]), set: $util.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_linkColor", { get: $util.oneOfGetter(E = ["linkColor"]), set: $util.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_linkUnderline", { get: $util.oneOfGetter(E = ["linkUnderline"]), set: $util.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_baseFontSize", { get: $util.oneOfGetter(E = ["baseFontSize"]), set: $util.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_baseFontWeight", { get: $util.oneOfGetter(E = ["baseFontWeight"]), set: $util.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_codeFontWeight", { get: $util.oneOfGetter(E = ["codeFontWeight"]), set: $util.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_codeFontSize", { get: $util.oneOfGetter(E = ["codeFontSize"]), set: $util.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_showSidebarBorder", { get: $util.oneOfGetter(E = ["showSidebarBorder"]), set: $util.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_codeTextColor", { get: $util.oneOfGetter(E = ["codeTextColor"]), set: $util.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_codeBackgroundColor", { get: $util.oneOfGetter(E = ["codeBackgroundColor"]), set: $util.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_dataframeHeaderBackgroundColor", { get: $util.oneOfGetter(E = ["dataframeHeaderBackgroundColor"]), set: $util.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_redColor", { get: $util.oneOfGetter(E = ["redColor"]), set: $util.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_orangeColor", { get: $util.oneOfGetter(E = ["orangeColor"]), set: $util.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_yellowColor", { get: $util.oneOfGetter(E = ["yellowColor"]), set: $util.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_blueColor", { get: $util.oneOfGetter(E = ["blueColor"]), set: $util.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_greenColor", { get: $util.oneOfGetter(E = ["greenColor"]), set: $util.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_violetColor", { get: $util.oneOfGetter(E = ["violetColor"]), set: $util.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_grayColor", { get: $util.oneOfGetter(E = ["grayColor"]), set: $util.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_redBackgroundColor", { get: $util.oneOfGetter(E = ["redBackgroundColor"]), set: $util.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_orangeBackgroundColor", { get: $util.oneOfGetter(E = ["orangeBackgroundColor"]), set: $util.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_yellowBackgroundColor", { get: $util.oneOfGetter(E = ["yellowBackgroundColor"]), set: $util.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_blueBackgroundColor", { get: $util.oneOfGetter(E = ["blueBackgroundColor"]), set: $util.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_greenBackgroundColor", { get: $util.oneOfGetter(E = ["greenBackgroundColor"]), set: $util.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_violetBackgroundColor", { get: $util.oneOfGetter(E = ["violetBackgroundColor"]), set: $util.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_grayBackgroundColor", { get: $util.oneOfGetter(E = ["grayBackgroundColor"]), set: $util.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_redTextColor", { get: $util.oneOfGetter(E = ["redTextColor"]), set: $util.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_orangeTextColor", { get: $util.oneOfGetter(E = ["orangeTextColor"]), set: $util.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_yellowTextColor", { get: $util.oneOfGetter(E = ["yellowTextColor"]), set: $util.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_blueTextColor", { get: $util.oneOfGetter(E = ["blueTextColor"]), set: $util.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_greenTextColor", { get: $util.oneOfGetter(E = ["greenTextColor"]), set: $util.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_violetTextColor", { get: $util.oneOfGetter(E = ["violetTextColor"]), set: $util.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_grayTextColor", { get: $util.oneOfGetter(E = ["grayTextColor"]), set: $util.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_sidebar", { get: $util.oneOfGetter(E = ["sidebar"]), set: $util.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_light", { get: $util.oneOfGetter(E = ["light"]), set: $util.oneOfSetter(E) }), Object.defineProperty(o.prototype, "_dark", { get: $util.oneOfGetter(E = ["dark"]), set: $util.oneOfSetter(E) }), o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    if (g || (g = $Writer.create()), A.primaryColor != null && Object.hasOwnProperty.call(A, "primaryColor") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(A.primaryColor), A.secondaryBackgroundColor != null && Object.hasOwnProperty.call(A, "secondaryBackgroundColor") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(A.secondaryBackgroundColor), A.backgroundColor != null && Object.hasOwnProperty.call(A, "backgroundColor") && g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(A.backgroundColor), A.textColor != null && Object.hasOwnProperty.call(A, "textColor") && g.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(A.textColor), A.font != null && Object.hasOwnProperty.call(A, "font") && g.uint32(
      /* id 5, wireType 0 =*/
      40
    ).int32(A.font), A.base != null && Object.hasOwnProperty.call(A, "base") && g.uint32(
      /* id 6, wireType 0 =*/
      48
    ).int32(A.base), A.widgetBackgroundColor != null && Object.hasOwnProperty.call(A, "widgetBackgroundColor") && g.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(A.widgetBackgroundColor), A.widgetBorderColor != null && Object.hasOwnProperty.call(A, "widgetBorderColor") && g.uint32(
      /* id 8, wireType 2 =*/
      66
    ).string(A.widgetBorderColor), A.radii != null && Object.hasOwnProperty.call(A, "radii") && $root.Radii.encode(A.radii, g.uint32(
      /* id 9, wireType 2 =*/
      74
    ).fork()).ldelim(), A.headingFont != null && Object.hasOwnProperty.call(A, "headingFont") && g.uint32(
      /* id 12, wireType 2 =*/
      98
    ).string(A.headingFont), A.bodyFont != null && Object.hasOwnProperty.call(A, "bodyFont") && g.uint32(
      /* id 13, wireType 2 =*/
      106
    ).string(A.bodyFont), A.codeFont != null && Object.hasOwnProperty.call(A, "codeFont") && g.uint32(
      /* id 14, wireType 2 =*/
      114
    ).string(A.codeFont), A.fontFaces != null && A.fontFaces.length) for (let e = 0; e < A.fontFaces.length; ++e) $root.FontFace.encode(A.fontFaces[e], g.uint32(
      /* id 15, wireType 2 =*/
      122
    ).fork()).ldelim();
    if (A.fontSizes != null && Object.hasOwnProperty.call(A, "fontSizes") && $root.FontSizes.encode(A.fontSizes, g.uint32(
      /* id 16, wireType 2 =*/
      130
    ).fork()).ldelim(), A.skeletonBackgroundColor != null && Object.hasOwnProperty.call(A, "skeletonBackgroundColor") && g.uint32(
      /* id 17, wireType 2 =*/
      138
    ).string(A.skeletonBackgroundColor), A.baseRadius != null && Object.hasOwnProperty.call(A, "baseRadius") && g.uint32(
      /* id 18, wireType 2 =*/
      146
    ).string(A.baseRadius), A.borderColor != null && Object.hasOwnProperty.call(A, "borderColor") && g.uint32(
      /* id 19, wireType 2 =*/
      154
    ).string(A.borderColor), A.showWidgetBorder != null && Object.hasOwnProperty.call(A, "showWidgetBorder") && g.uint32(
      /* id 20, wireType 0 =*/
      160
    ).bool(A.showWidgetBorder), A.linkColor != null && Object.hasOwnProperty.call(A, "linkColor") && g.uint32(
      /* id 21, wireType 2 =*/
      170
    ).string(A.linkColor), A.baseFontSize != null && Object.hasOwnProperty.call(A, "baseFontSize") && g.uint32(
      /* id 22, wireType 0 =*/
      176
    ).int32(A.baseFontSize), A.showSidebarBorder != null && Object.hasOwnProperty.call(A, "showSidebarBorder") && g.uint32(
      /* id 23, wireType 0 =*/
      184
    ).bool(A.showSidebarBorder), A.sidebar != null && Object.hasOwnProperty.call(A, "sidebar") && $root.CustomThemeConfig.encode(A.sidebar, g.uint32(
      /* id 24, wireType 2 =*/
      194
    ).fork()).ldelim(), A.codeBackgroundColor != null && Object.hasOwnProperty.call(A, "codeBackgroundColor") && g.uint32(
      /* id 25, wireType 2 =*/
      202
    ).string(A.codeBackgroundColor), A.buttonRadius != null && Object.hasOwnProperty.call(A, "buttonRadius") && g.uint32(
      /* id 26, wireType 2 =*/
      210
    ).string(A.buttonRadius), A.dataframeBorderColor != null && Object.hasOwnProperty.call(A, "dataframeBorderColor") && g.uint32(
      /* id 27, wireType 2 =*/
      218
    ).string(A.dataframeBorderColor), A.codeFontSize != null && Object.hasOwnProperty.call(A, "codeFontSize") && g.uint32(
      /* id 28, wireType 2 =*/
      226
    ).string(A.codeFontSize), A.linkUnderline != null && Object.hasOwnProperty.call(A, "linkUnderline") && g.uint32(
      /* id 29, wireType 0 =*/
      232
    ).bool(A.linkUnderline), A.baseFontWeight != null && Object.hasOwnProperty.call(A, "baseFontWeight") && g.uint32(
      /* id 30, wireType 0 =*/
      240
    ).int32(A.baseFontWeight), A.dataframeHeaderBackgroundColor != null && Object.hasOwnProperty.call(A, "dataframeHeaderBackgroundColor") && g.uint32(
      /* id 31, wireType 2 =*/
      250
    ).string(A.dataframeHeaderBackgroundColor), A.codeFontWeight != null && Object.hasOwnProperty.call(A, "codeFontWeight") && g.uint32(
      /* id 32, wireType 0 =*/
      256
    ).int32(A.codeFontWeight), A.chartCategoricalColors != null && A.chartCategoricalColors.length) for (let e = 0; e < A.chartCategoricalColors.length; ++e) g.uint32(
      /* id 33, wireType 2 =*/
      266
    ).string(A.chartCategoricalColors[e]);
    if (A.headingFontWeights != null && A.headingFontWeights.length) {
      g.uint32(
        /* id 34, wireType 2 =*/
        274
      ).fork();
      for (let e = 0; e < A.headingFontWeights.length; ++e) g.int32(A.headingFontWeights[e]);
      g.ldelim();
    }
    if (A.headingFontSizes != null && A.headingFontSizes.length) for (let e = 0; e < A.headingFontSizes.length; ++e) g.uint32(
      /* id 35, wireType 2 =*/
      282
    ).string(A.headingFontSizes[e]);
    if (A.chartSequentialColors != null && A.chartSequentialColors.length) for (let e = 0; e < A.chartSequentialColors.length; ++e) g.uint32(
      /* id 36, wireType 2 =*/
      290
    ).string(A.chartSequentialColors[e]);
    if (A.fontSources != null && A.fontSources.length) for (let e = 0; e < A.fontSources.length; ++e) $root.FontSource.encode(A.fontSources[e], g.uint32(
      /* id 37, wireType 2 =*/
      298
    ).fork()).ldelim();
    return A.redColor != null && Object.hasOwnProperty.call(A, "redColor") && g.uint32(
      /* id 38, wireType 2 =*/
      306
    ).string(A.redColor), A.orangeColor != null && Object.hasOwnProperty.call(A, "orangeColor") && g.uint32(
      /* id 39, wireType 2 =*/
      314
    ).string(A.orangeColor), A.yellowColor != null && Object.hasOwnProperty.call(A, "yellowColor") && g.uint32(
      /* id 40, wireType 2 =*/
      322
    ).string(A.yellowColor), A.blueColor != null && Object.hasOwnProperty.call(A, "blueColor") && g.uint32(
      /* id 41, wireType 2 =*/
      330
    ).string(A.blueColor), A.greenColor != null && Object.hasOwnProperty.call(A, "greenColor") && g.uint32(
      /* id 42, wireType 2 =*/
      338
    ).string(A.greenColor), A.violetColor != null && Object.hasOwnProperty.call(A, "violetColor") && g.uint32(
      /* id 43, wireType 2 =*/
      346
    ).string(A.violetColor), A.grayColor != null && Object.hasOwnProperty.call(A, "grayColor") && g.uint32(
      /* id 44, wireType 2 =*/
      354
    ).string(A.grayColor), A.redBackgroundColor != null && Object.hasOwnProperty.call(A, "redBackgroundColor") && g.uint32(
      /* id 45, wireType 2 =*/
      362
    ).string(A.redBackgroundColor), A.orangeBackgroundColor != null && Object.hasOwnProperty.call(A, "orangeBackgroundColor") && g.uint32(
      /* id 46, wireType 2 =*/
      370
    ).string(A.orangeBackgroundColor), A.yellowBackgroundColor != null && Object.hasOwnProperty.call(A, "yellowBackgroundColor") && g.uint32(
      /* id 47, wireType 2 =*/
      378
    ).string(A.yellowBackgroundColor), A.blueBackgroundColor != null && Object.hasOwnProperty.call(A, "blueBackgroundColor") && g.uint32(
      /* id 48, wireType 2 =*/
      386
    ).string(A.blueBackgroundColor), A.greenBackgroundColor != null && Object.hasOwnProperty.call(A, "greenBackgroundColor") && g.uint32(
      /* id 49, wireType 2 =*/
      394
    ).string(A.greenBackgroundColor), A.violetBackgroundColor != null && Object.hasOwnProperty.call(A, "violetBackgroundColor") && g.uint32(
      /* id 50, wireType 2 =*/
      402
    ).string(A.violetBackgroundColor), A.grayBackgroundColor != null && Object.hasOwnProperty.call(A, "grayBackgroundColor") && g.uint32(
      /* id 51, wireType 2 =*/
      410
    ).string(A.grayBackgroundColor), A.redTextColor != null && Object.hasOwnProperty.call(A, "redTextColor") && g.uint32(
      /* id 52, wireType 2 =*/
      418
    ).string(A.redTextColor), A.orangeTextColor != null && Object.hasOwnProperty.call(A, "orangeTextColor") && g.uint32(
      /* id 53, wireType 2 =*/
      426
    ).string(A.orangeTextColor), A.yellowTextColor != null && Object.hasOwnProperty.call(A, "yellowTextColor") && g.uint32(
      /* id 54, wireType 2 =*/
      434
    ).string(A.yellowTextColor), A.blueTextColor != null && Object.hasOwnProperty.call(A, "blueTextColor") && g.uint32(
      /* id 55, wireType 2 =*/
      442
    ).string(A.blueTextColor), A.greenTextColor != null && Object.hasOwnProperty.call(A, "greenTextColor") && g.uint32(
      /* id 56, wireType 2 =*/
      450
    ).string(A.greenTextColor), A.violetTextColor != null && Object.hasOwnProperty.call(A, "violetTextColor") && g.uint32(
      /* id 57, wireType 2 =*/
      458
    ).string(A.violetTextColor), A.grayTextColor != null && Object.hasOwnProperty.call(A, "grayTextColor") && g.uint32(
      /* id 58, wireType 2 =*/
      466
    ).string(A.grayTextColor), A.codeTextColor != null && Object.hasOwnProperty.call(A, "codeTextColor") && g.uint32(
      /* id 59, wireType 2 =*/
      474
    ).string(A.codeTextColor), A.light != null && Object.hasOwnProperty.call(A, "light") && $root.CustomThemeConfig.encode(A.light, g.uint32(
      /* id 60, wireType 2 =*/
      482
    ).fork()).ldelim(), A.dark != null && Object.hasOwnProperty.call(A, "dark") && $root.CustomThemeConfig.encode(A.dark, g.uint32(
      /* id 61, wireType 2 =*/
      490
    ).fork()).ldelim(), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader || (A = $Reader.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root.CustomThemeConfig();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.primaryColor = A.string();
          break;
        }
        case 2: {
          c.secondaryBackgroundColor = A.string();
          break;
        }
        case 3: {
          c.backgroundColor = A.string();
          break;
        }
        case 4: {
          c.textColor = A.string();
          break;
        }
        case 5: {
          c.font = A.int32();
          break;
        }
        case 6: {
          c.base = A.int32();
          break;
        }
        case 7: {
          c.widgetBackgroundColor = A.string();
          break;
        }
        case 8: {
          c.widgetBorderColor = A.string();
          break;
        }
        case 9: {
          c.radii = $root.Radii.decode(A, A.uint32());
          break;
        }
        case 12: {
          c.headingFont = A.string();
          break;
        }
        case 13: {
          c.bodyFont = A.string();
          break;
        }
        case 14: {
          c.codeFont = A.string();
          break;
        }
        case 15: {
          c.fontFaces && c.fontFaces.length || (c.fontFaces = []), c.fontFaces.push($root.FontFace.decode(A, A.uint32()));
          break;
        }
        case 37: {
          c.fontSources && c.fontSources.length || (c.fontSources = []), c.fontSources.push($root.FontSource.decode(A, A.uint32()));
          break;
        }
        case 16: {
          c.fontSizes = $root.FontSizes.decode(A, A.uint32());
          break;
        }
        case 17: {
          c.skeletonBackgroundColor = A.string();
          break;
        }
        case 18: {
          c.baseRadius = A.string();
          break;
        }
        case 26: {
          c.buttonRadius = A.string();
          break;
        }
        case 19: {
          c.borderColor = A.string();
          break;
        }
        case 27: {
          c.dataframeBorderColor = A.string();
          break;
        }
        case 20: {
          c.showWidgetBorder = A.bool();
          break;
        }
        case 21: {
          c.linkColor = A.string();
          break;
        }
        case 29: {
          c.linkUnderline = A.bool();
          break;
        }
        case 22: {
          c.baseFontSize = A.int32();
          break;
        }
        case 30: {
          c.baseFontWeight = A.int32();
          break;
        }
        case 32: {
          c.codeFontWeight = A.int32();
          break;
        }
        case 28: {
          c.codeFontSize = A.string();
          break;
        }
        case 35: {
          c.headingFontSizes && c.headingFontSizes.length || (c.headingFontSizes = []), c.headingFontSizes.push(A.string());
          break;
        }
        case 34: {
          if (c.headingFontWeights && c.headingFontWeights.length || (c.headingFontWeights = []), (n & 7) === 2) {
            let h = A.uint32() + A.pos;
            for (; A.pos < h; ) c.headingFontWeights.push(A.int32());
          } else c.headingFontWeights.push(A.int32());
          break;
        }
        case 23: {
          c.showSidebarBorder = A.bool();
          break;
        }
        case 59: {
          c.codeTextColor = A.string();
          break;
        }
        case 25: {
          c.codeBackgroundColor = A.string();
          break;
        }
        case 31: {
          c.dataframeHeaderBackgroundColor = A.string();
          break;
        }
        case 33: {
          c.chartCategoricalColors && c.chartCategoricalColors.length || (c.chartCategoricalColors = []), c.chartCategoricalColors.push(A.string());
          break;
        }
        case 36: {
          c.chartSequentialColors && c.chartSequentialColors.length || (c.chartSequentialColors = []), c.chartSequentialColors.push(A.string());
          break;
        }
        case 38: {
          c.redColor = A.string();
          break;
        }
        case 39: {
          c.orangeColor = A.string();
          break;
        }
        case 40: {
          c.yellowColor = A.string();
          break;
        }
        case 41: {
          c.blueColor = A.string();
          break;
        }
        case 42: {
          c.greenColor = A.string();
          break;
        }
        case 43: {
          c.violetColor = A.string();
          break;
        }
        case 44: {
          c.grayColor = A.string();
          break;
        }
        case 45: {
          c.redBackgroundColor = A.string();
          break;
        }
        case 46: {
          c.orangeBackgroundColor = A.string();
          break;
        }
        case 47: {
          c.yellowBackgroundColor = A.string();
          break;
        }
        case 48: {
          c.blueBackgroundColor = A.string();
          break;
        }
        case 49: {
          c.greenBackgroundColor = A.string();
          break;
        }
        case 50: {
          c.violetBackgroundColor = A.string();
          break;
        }
        case 51: {
          c.grayBackgroundColor = A.string();
          break;
        }
        case 52: {
          c.redTextColor = A.string();
          break;
        }
        case 53: {
          c.orangeTextColor = A.string();
          break;
        }
        case 54: {
          c.yellowTextColor = A.string();
          break;
        }
        case 55: {
          c.blueTextColor = A.string();
          break;
        }
        case 56: {
          c.greenTextColor = A.string();
          break;
        }
        case 57: {
          c.violetTextColor = A.string();
          break;
        }
        case 58: {
          c.grayTextColor = A.string();
          break;
        }
        case 24: {
          c.sidebar = $root.CustomThemeConfig.decode(A, A.uint32());
          break;
        }
        case 60: {
          c.light = $root.CustomThemeConfig.decode(A, A.uint32());
          break;
        }
        case 61: {
          c.dark = $root.CustomThemeConfig.decode(A, A.uint32());
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root.CustomThemeConfig) return A;
    let g = new $root.CustomThemeConfig();
    switch (A.primaryColor != null && (g.primaryColor = String(A.primaryColor)), A.secondaryBackgroundColor != null && (g.secondaryBackgroundColor = String(A.secondaryBackgroundColor)), A.backgroundColor != null && (g.backgroundColor = String(A.backgroundColor)), A.textColor != null && (g.textColor = String(A.textColor)), A.font) {
      default:
        if (typeof A.font == "number") {
          g.font = A.font;
          break;
        }
        break;
      case "SANS_SERIF":
      case 0:
        g.font = 0;
        break;
      case "SERIF":
      case 1:
        g.font = 1;
        break;
      case "MONOSPACE":
      case 2:
        g.font = 2;
        break;
    }
    switch (A.base) {
      default:
        if (typeof A.base == "number") {
          g.base = A.base;
          break;
        }
        break;
      case "LIGHT":
      case 0:
        g.base = 0;
        break;
      case "DARK":
      case 1:
        g.base = 1;
        break;
    }
    if (A.widgetBackgroundColor != null && (g.widgetBackgroundColor = String(A.widgetBackgroundColor)), A.widgetBorderColor != null && (g.widgetBorderColor = String(A.widgetBorderColor)), A.radii != null) {
      if (typeof A.radii != "object") throw TypeError(".CustomThemeConfig.radii: object expected");
      g.radii = $root.Radii.fromObject(A.radii);
    }
    if (A.headingFont != null && (g.headingFont = String(A.headingFont)), A.bodyFont != null && (g.bodyFont = String(A.bodyFont)), A.codeFont != null && (g.codeFont = String(A.codeFont)), A.fontFaces) {
      if (!Array.isArray(A.fontFaces)) throw TypeError(".CustomThemeConfig.fontFaces: array expected");
      g.fontFaces = [];
      for (let e = 0; e < A.fontFaces.length; ++e) {
        if (typeof A.fontFaces[e] != "object") throw TypeError(".CustomThemeConfig.fontFaces: object expected");
        g.fontFaces[e] = $root.FontFace.fromObject(A.fontFaces[e]);
      }
    }
    if (A.fontSources) {
      if (!Array.isArray(A.fontSources)) throw TypeError(".CustomThemeConfig.fontSources: array expected");
      g.fontSources = [];
      for (let e = 0; e < A.fontSources.length; ++e) {
        if (typeof A.fontSources[e] != "object") throw TypeError(".CustomThemeConfig.fontSources: object expected");
        g.fontSources[e] = $root.FontSource.fromObject(A.fontSources[e]);
      }
    }
    if (A.fontSizes != null) {
      if (typeof A.fontSizes != "object") throw TypeError(".CustomThemeConfig.fontSizes: object expected");
      g.fontSizes = $root.FontSizes.fromObject(A.fontSizes);
    }
    if (A.skeletonBackgroundColor != null && (g.skeletonBackgroundColor = String(A.skeletonBackgroundColor)), A.baseRadius != null && (g.baseRadius = String(A.baseRadius)), A.buttonRadius != null && (g.buttonRadius = String(A.buttonRadius)), A.borderColor != null && (g.borderColor = String(A.borderColor)), A.dataframeBorderColor != null && (g.dataframeBorderColor = String(A.dataframeBorderColor)), A.showWidgetBorder != null && (g.showWidgetBorder = !!A.showWidgetBorder), A.linkColor != null && (g.linkColor = String(A.linkColor)), A.linkUnderline != null && (g.linkUnderline = !!A.linkUnderline), A.baseFontSize != null && (g.baseFontSize = A.baseFontSize | 0), A.baseFontWeight != null && (g.baseFontWeight = A.baseFontWeight | 0), A.codeFontWeight != null && (g.codeFontWeight = A.codeFontWeight | 0), A.codeFontSize != null && (g.codeFontSize = String(A.codeFontSize)), A.headingFontSizes) {
      if (!Array.isArray(A.headingFontSizes)) throw TypeError(".CustomThemeConfig.headingFontSizes: array expected");
      g.headingFontSizes = [];
      for (let e = 0; e < A.headingFontSizes.length; ++e) g.headingFontSizes[e] = String(A.headingFontSizes[e]);
    }
    if (A.headingFontWeights) {
      if (!Array.isArray(A.headingFontWeights)) throw TypeError(".CustomThemeConfig.headingFontWeights: array expected");
      g.headingFontWeights = [];
      for (let e = 0; e < A.headingFontWeights.length; ++e) g.headingFontWeights[e] = A.headingFontWeights[e] | 0;
    }
    if (A.showSidebarBorder != null && (g.showSidebarBorder = !!A.showSidebarBorder), A.codeTextColor != null && (g.codeTextColor = String(A.codeTextColor)), A.codeBackgroundColor != null && (g.codeBackgroundColor = String(A.codeBackgroundColor)), A.dataframeHeaderBackgroundColor != null && (g.dataframeHeaderBackgroundColor = String(A.dataframeHeaderBackgroundColor)), A.chartCategoricalColors) {
      if (!Array.isArray(A.chartCategoricalColors)) throw TypeError(".CustomThemeConfig.chartCategoricalColors: array expected");
      g.chartCategoricalColors = [];
      for (let e = 0; e < A.chartCategoricalColors.length; ++e) g.chartCategoricalColors[e] = String(A.chartCategoricalColors[e]);
    }
    if (A.chartSequentialColors) {
      if (!Array.isArray(A.chartSequentialColors)) throw TypeError(".CustomThemeConfig.chartSequentialColors: array expected");
      g.chartSequentialColors = [];
      for (let e = 0; e < A.chartSequentialColors.length; ++e) g.chartSequentialColors[e] = String(A.chartSequentialColors[e]);
    }
    if (A.redColor != null && (g.redColor = String(A.redColor)), A.orangeColor != null && (g.orangeColor = String(A.orangeColor)), A.yellowColor != null && (g.yellowColor = String(A.yellowColor)), A.blueColor != null && (g.blueColor = String(A.blueColor)), A.greenColor != null && (g.greenColor = String(A.greenColor)), A.violetColor != null && (g.violetColor = String(A.violetColor)), A.grayColor != null && (g.grayColor = String(A.grayColor)), A.redBackgroundColor != null && (g.redBackgroundColor = String(A.redBackgroundColor)), A.orangeBackgroundColor != null && (g.orangeBackgroundColor = String(A.orangeBackgroundColor)), A.yellowBackgroundColor != null && (g.yellowBackgroundColor = String(A.yellowBackgroundColor)), A.blueBackgroundColor != null && (g.blueBackgroundColor = String(A.blueBackgroundColor)), A.greenBackgroundColor != null && (g.greenBackgroundColor = String(A.greenBackgroundColor)), A.violetBackgroundColor != null && (g.violetBackgroundColor = String(A.violetBackgroundColor)), A.grayBackgroundColor != null && (g.grayBackgroundColor = String(A.grayBackgroundColor)), A.redTextColor != null && (g.redTextColor = String(A.redTextColor)), A.orangeTextColor != null && (g.orangeTextColor = String(A.orangeTextColor)), A.yellowTextColor != null && (g.yellowTextColor = String(A.yellowTextColor)), A.blueTextColor != null && (g.blueTextColor = String(A.blueTextColor)), A.greenTextColor != null && (g.greenTextColor = String(A.greenTextColor)), A.violetTextColor != null && (g.violetTextColor = String(A.violetTextColor)), A.grayTextColor != null && (g.grayTextColor = String(A.grayTextColor)), A.sidebar != null) {
      if (typeof A.sidebar != "object") throw TypeError(".CustomThemeConfig.sidebar: object expected");
      g.sidebar = $root.CustomThemeConfig.fromObject(A.sidebar);
    }
    if (A.light != null) {
      if (typeof A.light != "object") throw TypeError(".CustomThemeConfig.light: object expected");
      g.light = $root.CustomThemeConfig.fromObject(A.light);
    }
    if (A.dark != null) {
      if (typeof A.dark != "object") throw TypeError(".CustomThemeConfig.dark: object expected");
      g.dark = $root.CustomThemeConfig.fromObject(A.dark);
    }
    return g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    if ((g.arrays || g.defaults) && (e.fontFaces = [], e.chartCategoricalColors = [], e.headingFontWeights = [], e.headingFontSizes = [], e.chartSequentialColors = [], e.fontSources = []), g.defaults && (e.primaryColor = "", e.secondaryBackgroundColor = "", e.backgroundColor = "", e.textColor = "", e.font = g.enums === String ? "SANS_SERIF" : 0, e.base = g.enums === String ? "LIGHT" : 0, e.widgetBackgroundColor = "", e.widgetBorderColor = "", e.radii = null, e.headingFont = "", e.bodyFont = "", e.codeFont = "", e.fontSizes = null, e.skeletonBackgroundColor = ""), A.primaryColor != null && A.hasOwnProperty("primaryColor") && (e.primaryColor = A.primaryColor), A.secondaryBackgroundColor != null && A.hasOwnProperty("secondaryBackgroundColor") && (e.secondaryBackgroundColor = A.secondaryBackgroundColor), A.backgroundColor != null && A.hasOwnProperty("backgroundColor") && (e.backgroundColor = A.backgroundColor), A.textColor != null && A.hasOwnProperty("textColor") && (e.textColor = A.textColor), A.font != null && A.hasOwnProperty("font") && (e.font = g.enums === String ? $root.CustomThemeConfig.FontFamily[A.font] === void 0 ? A.font : $root.CustomThemeConfig.FontFamily[A.font] : A.font), A.base != null && A.hasOwnProperty("base") && (e.base = g.enums === String ? $root.CustomThemeConfig.BaseTheme[A.base] === void 0 ? A.base : $root.CustomThemeConfig.BaseTheme[A.base] : A.base), A.widgetBackgroundColor != null && A.hasOwnProperty("widgetBackgroundColor") && (e.widgetBackgroundColor = A.widgetBackgroundColor), A.widgetBorderColor != null && A.hasOwnProperty("widgetBorderColor") && (e.widgetBorderColor = A.widgetBorderColor), A.radii != null && A.hasOwnProperty("radii") && (e.radii = $root.Radii.toObject(A.radii, g)), A.headingFont != null && A.hasOwnProperty("headingFont") && (e.headingFont = A.headingFont), A.bodyFont != null && A.hasOwnProperty("bodyFont") && (e.bodyFont = A.bodyFont), A.codeFont != null && A.hasOwnProperty("codeFont") && (e.codeFont = A.codeFont), A.fontFaces && A.fontFaces.length) {
      e.fontFaces = [];
      for (let t = 0; t < A.fontFaces.length; ++t) e.fontFaces[t] = $root.FontFace.toObject(A.fontFaces[t], g);
    }
    if (A.fontSizes != null && A.hasOwnProperty("fontSizes") && (e.fontSizes = $root.FontSizes.toObject(A.fontSizes, g)), A.skeletonBackgroundColor != null && A.hasOwnProperty("skeletonBackgroundColor") && (e.skeletonBackgroundColor = A.skeletonBackgroundColor), A.baseRadius != null && A.hasOwnProperty("baseRadius") && (e.baseRadius = A.baseRadius, g.oneofs && (e._baseRadius = "baseRadius")), A.borderColor != null && A.hasOwnProperty("borderColor") && (e.borderColor = A.borderColor, g.oneofs && (e._borderColor = "borderColor")), A.showWidgetBorder != null && A.hasOwnProperty("showWidgetBorder") && (e.showWidgetBorder = A.showWidgetBorder, g.oneofs && (e._showWidgetBorder = "showWidgetBorder")), A.linkColor != null && A.hasOwnProperty("linkColor") && (e.linkColor = A.linkColor, g.oneofs && (e._linkColor = "linkColor")), A.baseFontSize != null && A.hasOwnProperty("baseFontSize") && (e.baseFontSize = A.baseFontSize, g.oneofs && (e._baseFontSize = "baseFontSize")), A.showSidebarBorder != null && A.hasOwnProperty("showSidebarBorder") && (e.showSidebarBorder = A.showSidebarBorder, g.oneofs && (e._showSidebarBorder = "showSidebarBorder")), A.sidebar != null && A.hasOwnProperty("sidebar") && (e.sidebar = $root.CustomThemeConfig.toObject(A.sidebar, g), g.oneofs && (e._sidebar = "sidebar")), A.codeBackgroundColor != null && A.hasOwnProperty("codeBackgroundColor") && (e.codeBackgroundColor = A.codeBackgroundColor, g.oneofs && (e._codeBackgroundColor = "codeBackgroundColor")), A.buttonRadius != null && A.hasOwnProperty("buttonRadius") && (e.buttonRadius = A.buttonRadius, g.oneofs && (e._buttonRadius = "buttonRadius")), A.dataframeBorderColor != null && A.hasOwnProperty("dataframeBorderColor") && (e.dataframeBorderColor = A.dataframeBorderColor, g.oneofs && (e._dataframeBorderColor = "dataframeBorderColor")), A.codeFontSize != null && A.hasOwnProperty("codeFontSize") && (e.codeFontSize = A.codeFontSize, g.oneofs && (e._codeFontSize = "codeFontSize")), A.linkUnderline != null && A.hasOwnProperty("linkUnderline") && (e.linkUnderline = A.linkUnderline, g.oneofs && (e._linkUnderline = "linkUnderline")), A.baseFontWeight != null && A.hasOwnProperty("baseFontWeight") && (e.baseFontWeight = A.baseFontWeight, g.oneofs && (e._baseFontWeight = "baseFontWeight")), A.dataframeHeaderBackgroundColor != null && A.hasOwnProperty("dataframeHeaderBackgroundColor") && (e.dataframeHeaderBackgroundColor = A.dataframeHeaderBackgroundColor, g.oneofs && (e._dataframeHeaderBackgroundColor = "dataframeHeaderBackgroundColor")), A.codeFontWeight != null && A.hasOwnProperty("codeFontWeight") && (e.codeFontWeight = A.codeFontWeight, g.oneofs && (e._codeFontWeight = "codeFontWeight")), A.chartCategoricalColors && A.chartCategoricalColors.length) {
      e.chartCategoricalColors = [];
      for (let t = 0; t < A.chartCategoricalColors.length; ++t) e.chartCategoricalColors[t] = A.chartCategoricalColors[t];
    }
    if (A.headingFontWeights && A.headingFontWeights.length) {
      e.headingFontWeights = [];
      for (let t = 0; t < A.headingFontWeights.length; ++t) e.headingFontWeights[t] = A.headingFontWeights[t];
    }
    if (A.headingFontSizes && A.headingFontSizes.length) {
      e.headingFontSizes = [];
      for (let t = 0; t < A.headingFontSizes.length; ++t) e.headingFontSizes[t] = A.headingFontSizes[t];
    }
    if (A.chartSequentialColors && A.chartSequentialColors.length) {
      e.chartSequentialColors = [];
      for (let t = 0; t < A.chartSequentialColors.length; ++t) e.chartSequentialColors[t] = A.chartSequentialColors[t];
    }
    if (A.fontSources && A.fontSources.length) {
      e.fontSources = [];
      for (let t = 0; t < A.fontSources.length; ++t) e.fontSources[t] = $root.FontSource.toObject(A.fontSources[t], g);
    }
    return A.redColor != null && A.hasOwnProperty("redColor") && (e.redColor = A.redColor, g.oneofs && (e._redColor = "redColor")), A.orangeColor != null && A.hasOwnProperty("orangeColor") && (e.orangeColor = A.orangeColor, g.oneofs && (e._orangeColor = "orangeColor")), A.yellowColor != null && A.hasOwnProperty("yellowColor") && (e.yellowColor = A.yellowColor, g.oneofs && (e._yellowColor = "yellowColor")), A.blueColor != null && A.hasOwnProperty("blueColor") && (e.blueColor = A.blueColor, g.oneofs && (e._blueColor = "blueColor")), A.greenColor != null && A.hasOwnProperty("greenColor") && (e.greenColor = A.greenColor, g.oneofs && (e._greenColor = "greenColor")), A.violetColor != null && A.hasOwnProperty("violetColor") && (e.violetColor = A.violetColor, g.oneofs && (e._violetColor = "violetColor")), A.grayColor != null && A.hasOwnProperty("grayColor") && (e.grayColor = A.grayColor, g.oneofs && (e._grayColor = "grayColor")), A.redBackgroundColor != null && A.hasOwnProperty("redBackgroundColor") && (e.redBackgroundColor = A.redBackgroundColor, g.oneofs && (e._redBackgroundColor = "redBackgroundColor")), A.orangeBackgroundColor != null && A.hasOwnProperty("orangeBackgroundColor") && (e.orangeBackgroundColor = A.orangeBackgroundColor, g.oneofs && (e._orangeBackgroundColor = "orangeBackgroundColor")), A.yellowBackgroundColor != null && A.hasOwnProperty("yellowBackgroundColor") && (e.yellowBackgroundColor = A.yellowBackgroundColor, g.oneofs && (e._yellowBackgroundColor = "yellowBackgroundColor")), A.blueBackgroundColor != null && A.hasOwnProperty("blueBackgroundColor") && (e.blueBackgroundColor = A.blueBackgroundColor, g.oneofs && (e._blueBackgroundColor = "blueBackgroundColor")), A.greenBackgroundColor != null && A.hasOwnProperty("greenBackgroundColor") && (e.greenBackgroundColor = A.greenBackgroundColor, g.oneofs && (e._greenBackgroundColor = "greenBackgroundColor")), A.violetBackgroundColor != null && A.hasOwnProperty("violetBackgroundColor") && (e.violetBackgroundColor = A.violetBackgroundColor, g.oneofs && (e._violetBackgroundColor = "violetBackgroundColor")), A.grayBackgroundColor != null && A.hasOwnProperty("grayBackgroundColor") && (e.grayBackgroundColor = A.grayBackgroundColor, g.oneofs && (e._grayBackgroundColor = "grayBackgroundColor")), A.redTextColor != null && A.hasOwnProperty("redTextColor") && (e.redTextColor = A.redTextColor, g.oneofs && (e._redTextColor = "redTextColor")), A.orangeTextColor != null && A.hasOwnProperty("orangeTextColor") && (e.orangeTextColor = A.orangeTextColor, g.oneofs && (e._orangeTextColor = "orangeTextColor")), A.yellowTextColor != null && A.hasOwnProperty("yellowTextColor") && (e.yellowTextColor = A.yellowTextColor, g.oneofs && (e._yellowTextColor = "yellowTextColor")), A.blueTextColor != null && A.hasOwnProperty("blueTextColor") && (e.blueTextColor = A.blueTextColor, g.oneofs && (e._blueTextColor = "blueTextColor")), A.greenTextColor != null && A.hasOwnProperty("greenTextColor") && (e.greenTextColor = A.greenTextColor, g.oneofs && (e._greenTextColor = "greenTextColor")), A.violetTextColor != null && A.hasOwnProperty("violetTextColor") && (e.violetTextColor = A.violetTextColor, g.oneofs && (e._violetTextColor = "violetTextColor")), A.grayTextColor != null && A.hasOwnProperty("grayTextColor") && (e.grayTextColor = A.grayTextColor, g.oneofs && (e._grayTextColor = "grayTextColor")), A.codeTextColor != null && A.hasOwnProperty("codeTextColor") && (e.codeTextColor = A.codeTextColor, g.oneofs && (e._codeTextColor = "codeTextColor")), A.light != null && A.hasOwnProperty("light") && (e.light = $root.CustomThemeConfig.toObject(A.light, g), g.oneofs && (e._light = "light")), A.dark != null && A.hasOwnProperty("dark") && (e.dark = $root.CustomThemeConfig.toObject(A.dark, g), g.oneofs && (e._dark = "dark")), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/CustomThemeConfig";
  }, o.BaseTheme = (function() {
    const A = {}, g = Object.create(A);
    return g[A[0] = "LIGHT"] = 0, g[A[1] = "DARK"] = 1, g;
  })(), o.FontFamily = (function() {
    const A = {}, g = Object.create(A);
    return g[A[0] = "SANS_SERIF"] = 0, g[A[1] = "SERIF"] = 1, g[A[2] = "MONOSPACE"] = 2, g;
  })(), o;
})();
$root.FontFace = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.url = "", o.prototype.family = "", o.prototype.weight = 0, o.prototype.weightRange = "", o.prototype.style = "", o.prototype.unicodeRange = "", o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, A) {
    return A || (A = $Writer.create()), E.url != null && Object.hasOwnProperty.call(E, "url") && A.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(E.url), E.family != null && Object.hasOwnProperty.call(E, "family") && A.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(E.family), E.weight != null && Object.hasOwnProperty.call(E, "weight") && A.uint32(
      /* id 3, wireType 0 =*/
      24
    ).int32(E.weight), E.style != null && Object.hasOwnProperty.call(E, "style") && A.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(E.style), E.weightRange != null && Object.hasOwnProperty.call(E, "weightRange") && A.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(E.weightRange), E.unicodeRange != null && Object.hasOwnProperty.call(E, "unicodeRange") && A.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(E.unicodeRange), A;
  }, o.decode = function(E, A, g) {
    E instanceof $Reader || (E = $Reader.create(E));
    let e = A === void 0 ? E.len : E.pos + A, t = new $root.FontFace();
    for (; E.pos < e; ) {
      let c = E.uint32();
      if (c === g) break;
      switch (c >>> 3) {
        case 1: {
          t.url = E.string();
          break;
        }
        case 2: {
          t.family = E.string();
          break;
        }
        case 3: {
          t.weight = E.int32();
          break;
        }
        case 5: {
          t.weightRange = E.string();
          break;
        }
        case 4: {
          t.style = E.string();
          break;
        }
        case 6: {
          t.unicodeRange = E.string();
          break;
        }
        default:
          E.skipType(c & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(E) {
    if (E instanceof $root.FontFace) return E;
    let A = new $root.FontFace();
    return E.url != null && (A.url = String(E.url)), E.family != null && (A.family = String(E.family)), E.weight != null && (A.weight = E.weight | 0), E.weightRange != null && (A.weightRange = String(E.weightRange)), E.style != null && (A.style = String(E.style)), E.unicodeRange != null && (A.unicodeRange = String(E.unicodeRange)), A;
  }, o.toObject = function(E, A) {
    A || (A = {});
    let g = {};
    return A.defaults && (g.url = "", g.family = "", g.weight = 0, g.style = "", g.weightRange = "", g.unicodeRange = ""), E.url != null && E.hasOwnProperty("url") && (g.url = E.url), E.family != null && E.hasOwnProperty("family") && (g.family = E.family), E.weight != null && E.hasOwnProperty("weight") && (g.weight = E.weight), E.style != null && E.hasOwnProperty("style") && (g.style = E.style), E.weightRange != null && E.hasOwnProperty("weightRange") && (g.weightRange = E.weightRange), E.unicodeRange != null && E.hasOwnProperty("unicodeRange") && (g.unicodeRange = E.unicodeRange), g;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/FontFace";
  }, o;
})();
$root.FontSource = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.configName = "", o.prototype.sourceUrl = "", o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, A) {
    return A || (A = $Writer.create()), E.configName != null && Object.hasOwnProperty.call(E, "configName") && A.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(E.configName), E.sourceUrl != null && Object.hasOwnProperty.call(E, "sourceUrl") && A.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(E.sourceUrl), A;
  }, o.decode = function(E, A, g) {
    E instanceof $Reader || (E = $Reader.create(E));
    let e = A === void 0 ? E.len : E.pos + A, t = new $root.FontSource();
    for (; E.pos < e; ) {
      let c = E.uint32();
      if (c === g) break;
      switch (c >>> 3) {
        case 1: {
          t.configName = E.string();
          break;
        }
        case 2: {
          t.sourceUrl = E.string();
          break;
        }
        default:
          E.skipType(c & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(E) {
    if (E instanceof $root.FontSource) return E;
    let A = new $root.FontSource();
    return E.configName != null && (A.configName = String(E.configName)), E.sourceUrl != null && (A.sourceUrl = String(E.sourceUrl)), A;
  }, o.toObject = function(E, A) {
    A || (A = {});
    let g = {};
    return A.defaults && (g.configName = "", g.sourceUrl = ""), E.configName != null && E.hasOwnProperty("configName") && (g.configName = E.configName), E.sourceUrl != null && E.hasOwnProperty("sourceUrl") && (g.sourceUrl = E.sourceUrl), g;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/FontSource";
  }, o;
})();
$root.Radii = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.baseWidgetRadius = 0, o.prototype.checkboxRadius = 0, o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, A) {
    return A || (A = $Writer.create()), E.baseWidgetRadius != null && Object.hasOwnProperty.call(E, "baseWidgetRadius") && A.uint32(
      /* id 1, wireType 0 =*/
      8
    ).int32(E.baseWidgetRadius), E.checkboxRadius != null && Object.hasOwnProperty.call(E, "checkboxRadius") && A.uint32(
      /* id 2, wireType 0 =*/
      16
    ).int32(E.checkboxRadius), A;
  }, o.decode = function(E, A, g) {
    E instanceof $Reader || (E = $Reader.create(E));
    let e = A === void 0 ? E.len : E.pos + A, t = new $root.Radii();
    for (; E.pos < e; ) {
      let c = E.uint32();
      if (c === g) break;
      switch (c >>> 3) {
        case 1: {
          t.baseWidgetRadius = E.int32();
          break;
        }
        case 2: {
          t.checkboxRadius = E.int32();
          break;
        }
        default:
          E.skipType(c & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(E) {
    if (E instanceof $root.Radii) return E;
    let A = new $root.Radii();
    return E.baseWidgetRadius != null && (A.baseWidgetRadius = E.baseWidgetRadius | 0), E.checkboxRadius != null && (A.checkboxRadius = E.checkboxRadius | 0), A;
  }, o.toObject = function(E, A) {
    A || (A = {});
    let g = {};
    return A.defaults && (g.baseWidgetRadius = 0, g.checkboxRadius = 0), E.baseWidgetRadius != null && E.hasOwnProperty("baseWidgetRadius") && (g.baseWidgetRadius = E.baseWidgetRadius), E.checkboxRadius != null && E.hasOwnProperty("checkboxRadius") && (g.checkboxRadius = E.checkboxRadius), g;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/Radii";
  }, o;
})();
$root.FontSizes = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.tinyFontSize = 0, o.prototype.smallFontSize = 0, o.prototype.baseFontSize = 0, o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, A) {
    return A || (A = $Writer.create()), E.tinyFontSize != null && Object.hasOwnProperty.call(E, "tinyFontSize") && A.uint32(
      /* id 1, wireType 0 =*/
      8
    ).int32(E.tinyFontSize), E.smallFontSize != null && Object.hasOwnProperty.call(E, "smallFontSize") && A.uint32(
      /* id 2, wireType 0 =*/
      16
    ).int32(E.smallFontSize), E.baseFontSize != null && Object.hasOwnProperty.call(E, "baseFontSize") && A.uint32(
      /* id 3, wireType 0 =*/
      24
    ).int32(E.baseFontSize), A;
  }, o.decode = function(E, A, g) {
    E instanceof $Reader || (E = $Reader.create(E));
    let e = A === void 0 ? E.len : E.pos + A, t = new $root.FontSizes();
    for (; E.pos < e; ) {
      let c = E.uint32();
      if (c === g) break;
      switch (c >>> 3) {
        case 1: {
          t.tinyFontSize = E.int32();
          break;
        }
        case 2: {
          t.smallFontSize = E.int32();
          break;
        }
        case 3: {
          t.baseFontSize = E.int32();
          break;
        }
        default:
          E.skipType(c & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(E) {
    if (E instanceof $root.FontSizes) return E;
    let A = new $root.FontSizes();
    return E.tinyFontSize != null && (A.tinyFontSize = E.tinyFontSize | 0), E.smallFontSize != null && (A.smallFontSize = E.smallFontSize | 0), E.baseFontSize != null && (A.baseFontSize = E.baseFontSize | 0), A;
  }, o.toObject = function(E, A) {
    A || (A = {});
    let g = {};
    return A.defaults && (g.tinyFontSize = 0, g.smallFontSize = 0, g.baseFontSize = 0), E.tinyFontSize != null && E.hasOwnProperty("tinyFontSize") && (g.tinyFontSize = E.tinyFontSize), E.smallFontSize != null && E.hasOwnProperty("smallFontSize") && (g.smallFontSize = E.smallFontSize), E.baseFontSize != null && E.hasOwnProperty("baseFontSize") && (g.baseFontSize = E.baseFontSize), g;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/FontSizes";
  }, o;
})();
$root.UserInfo = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.installationId = "", o.prototype.installationIdV3 = "", o.prototype.installationIdV4 = "", o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, A) {
    return A || (A = $Writer.create()), E.installationId != null && Object.hasOwnProperty.call(E, "installationId") && A.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(E.installationId), E.installationIdV3 != null && Object.hasOwnProperty.call(E, "installationIdV3") && A.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(E.installationIdV3), E.installationIdV4 != null && Object.hasOwnProperty.call(E, "installationIdV4") && A.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(E.installationIdV4), A;
  }, o.decode = function(E, A, g) {
    E instanceof $Reader || (E = $Reader.create(E));
    let e = A === void 0 ? E.len : E.pos + A, t = new $root.UserInfo();
    for (; E.pos < e; ) {
      let c = E.uint32();
      if (c === g) break;
      switch (c >>> 3) {
        case 1: {
          t.installationId = E.string();
          break;
        }
        case 5: {
          t.installationIdV3 = E.string();
          break;
        }
        case 6: {
          t.installationIdV4 = E.string();
          break;
        }
        default:
          E.skipType(c & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(E) {
    if (E instanceof $root.UserInfo) return E;
    let A = new $root.UserInfo();
    return E.installationId != null && (A.installationId = String(E.installationId)), E.installationIdV3 != null && (A.installationIdV3 = String(E.installationIdV3)), E.installationIdV4 != null && (A.installationIdV4 = String(E.installationIdV4)), A;
  }, o.toObject = function(E, A) {
    A || (A = {});
    let g = {};
    return A.defaults && (g.installationId = "", g.installationIdV3 = "", g.installationIdV4 = ""), E.installationId != null && E.hasOwnProperty("installationId") && (g.installationId = E.installationId), E.installationIdV3 != null && E.hasOwnProperty("installationIdV3") && (g.installationIdV3 = E.installationIdV3), E.installationIdV4 != null && E.hasOwnProperty("installationIdV4") && (g.installationIdV4 = E.installationIdV4), g;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/UserInfo";
  }, o;
})();
$root.EnvironmentInfo = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.streamlitVersion = "", o.prototype.pythonVersion = "", o.prototype.serverOs = "", o.prototype.hasDisplay = !1, o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, A) {
    return A || (A = $Writer.create()), E.streamlitVersion != null && Object.hasOwnProperty.call(E, "streamlitVersion") && A.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(E.streamlitVersion), E.pythonVersion != null && Object.hasOwnProperty.call(E, "pythonVersion") && A.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(E.pythonVersion), E.serverOs != null && Object.hasOwnProperty.call(E, "serverOs") && A.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(E.serverOs), E.hasDisplay != null && Object.hasOwnProperty.call(E, "hasDisplay") && A.uint32(
      /* id 4, wireType 0 =*/
      32
    ).bool(E.hasDisplay), A;
  }, o.decode = function(E, A, g) {
    E instanceof $Reader || (E = $Reader.create(E));
    let e = A === void 0 ? E.len : E.pos + A, t = new $root.EnvironmentInfo();
    for (; E.pos < e; ) {
      let c = E.uint32();
      if (c === g) break;
      switch (c >>> 3) {
        case 1: {
          t.streamlitVersion = E.string();
          break;
        }
        case 2: {
          t.pythonVersion = E.string();
          break;
        }
        case 3: {
          t.serverOs = E.string();
          break;
        }
        case 4: {
          t.hasDisplay = E.bool();
          break;
        }
        default:
          E.skipType(c & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(E) {
    if (E instanceof $root.EnvironmentInfo) return E;
    let A = new $root.EnvironmentInfo();
    return E.streamlitVersion != null && (A.streamlitVersion = String(E.streamlitVersion)), E.pythonVersion != null && (A.pythonVersion = String(E.pythonVersion)), E.serverOs != null && (A.serverOs = String(E.serverOs)), E.hasDisplay != null && (A.hasDisplay = !!E.hasDisplay), A;
  }, o.toObject = function(E, A) {
    A || (A = {});
    let g = {};
    return A.defaults && (g.streamlitVersion = "", g.pythonVersion = "", g.serverOs = "", g.hasDisplay = !1), E.streamlitVersion != null && E.hasOwnProperty("streamlitVersion") && (g.streamlitVersion = E.streamlitVersion), E.pythonVersion != null && E.hasOwnProperty("pythonVersion") && (g.pythonVersion = E.pythonVersion), E.serverOs != null && E.hasOwnProperty("serverOs") && (g.serverOs = E.serverOs), E.hasDisplay != null && E.hasOwnProperty("hasDisplay") && (g.hasDisplay = E.hasDisplay), g;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/EnvironmentInfo";
  }, o;
})();
$root.SessionStatus = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.runOnSave = !1, o.prototype.scriptIsRunning = !1, o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, A) {
    return A || (A = $Writer.create()), E.runOnSave != null && Object.hasOwnProperty.call(E, "runOnSave") && A.uint32(
      /* id 1, wireType 0 =*/
      8
    ).bool(E.runOnSave), E.scriptIsRunning != null && Object.hasOwnProperty.call(E, "scriptIsRunning") && A.uint32(
      /* id 2, wireType 0 =*/
      16
    ).bool(E.scriptIsRunning), A;
  }, o.decode = function(E, A, g) {
    E instanceof $Reader || (E = $Reader.create(E));
    let e = A === void 0 ? E.len : E.pos + A, t = new $root.SessionStatus();
    for (; E.pos < e; ) {
      let c = E.uint32();
      if (c === g) break;
      switch (c >>> 3) {
        case 1: {
          t.runOnSave = E.bool();
          break;
        }
        case 2: {
          t.scriptIsRunning = E.bool();
          break;
        }
        default:
          E.skipType(c & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(E) {
    if (E instanceof $root.SessionStatus) return E;
    let A = new $root.SessionStatus();
    return E.runOnSave != null && (A.runOnSave = !!E.runOnSave), E.scriptIsRunning != null && (A.scriptIsRunning = !!E.scriptIsRunning), A;
  }, o.toObject = function(E, A) {
    A || (A = {});
    let g = {};
    return A.defaults && (g.runOnSave = !1, g.scriptIsRunning = !1), E.runOnSave != null && E.hasOwnProperty("runOnSave") && (g.runOnSave = E.runOnSave), E.scriptIsRunning != null && E.hasOwnProperty("scriptIsRunning") && (g.scriptIsRunning = E.scriptIsRunning), g;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/SessionStatus";
  }, o;
})();
$root.PageConfig = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.title = "", o.prototype.favicon = "", o.prototype.layout = 0, o.prototype.initialSidebarState = 0, o.prototype.menuItems = null, o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, A) {
    return A || (A = $Writer.create()), E.title != null && Object.hasOwnProperty.call(E, "title") && A.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(E.title), E.favicon != null && Object.hasOwnProperty.call(E, "favicon") && A.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(E.favicon), E.layout != null && Object.hasOwnProperty.call(E, "layout") && A.uint32(
      /* id 3, wireType 0 =*/
      24
    ).int32(E.layout), E.initialSidebarState != null && Object.hasOwnProperty.call(E, "initialSidebarState") && A.uint32(
      /* id 4, wireType 0 =*/
      32
    ).int32(E.initialSidebarState), E.menuItems != null && Object.hasOwnProperty.call(E, "menuItems") && $root.PageConfig.MenuItems.encode(E.menuItems, A.uint32(
      /* id 5, wireType 2 =*/
      42
    ).fork()).ldelim(), A;
  }, o.decode = function(E, A, g) {
    E instanceof $Reader || (E = $Reader.create(E));
    let e = A === void 0 ? E.len : E.pos + A, t = new $root.PageConfig();
    for (; E.pos < e; ) {
      let c = E.uint32();
      if (c === g) break;
      switch (c >>> 3) {
        case 1: {
          t.title = E.string();
          break;
        }
        case 2: {
          t.favicon = E.string();
          break;
        }
        case 3: {
          t.layout = E.int32();
          break;
        }
        case 4: {
          t.initialSidebarState = E.int32();
          break;
        }
        case 5: {
          t.menuItems = $root.PageConfig.MenuItems.decode(E, E.uint32());
          break;
        }
        default:
          E.skipType(c & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(E) {
    if (E instanceof $root.PageConfig) return E;
    let A = new $root.PageConfig();
    switch (E.title != null && (A.title = String(E.title)), E.favicon != null && (A.favicon = String(E.favicon)), E.layout) {
      default:
        if (typeof E.layout == "number") {
          A.layout = E.layout;
          break;
        }
        break;
      case "CENTERED":
      case 0:
        A.layout = 0;
        break;
      case "WIDE":
      case 1:
        A.layout = 1;
        break;
      case "LAYOUT_UNSET":
      case 2:
        A.layout = 2;
        break;
    }
    switch (E.initialSidebarState) {
      default:
        if (typeof E.initialSidebarState == "number") {
          A.initialSidebarState = E.initialSidebarState;
          break;
        }
        break;
      case "AUTO":
      case 0:
        A.initialSidebarState = 0;
        break;
      case "EXPANDED":
      case 1:
        A.initialSidebarState = 1;
        break;
      case "COLLAPSED":
      case 2:
        A.initialSidebarState = 2;
        break;
      case "SIDEBAR_UNSET":
      case 3:
        A.initialSidebarState = 3;
        break;
    }
    if (E.menuItems != null) {
      if (typeof E.menuItems != "object") throw TypeError(".PageConfig.menuItems: object expected");
      A.menuItems = $root.PageConfig.MenuItems.fromObject(E.menuItems);
    }
    return A;
  }, o.toObject = function(E, A) {
    A || (A = {});
    let g = {};
    return A.defaults && (g.title = "", g.favicon = "", g.layout = A.enums === String ? "CENTERED" : 0, g.initialSidebarState = A.enums === String ? "AUTO" : 0, g.menuItems = null), E.title != null && E.hasOwnProperty("title") && (g.title = E.title), E.favicon != null && E.hasOwnProperty("favicon") && (g.favicon = E.favicon), E.layout != null && E.hasOwnProperty("layout") && (g.layout = A.enums === String ? $root.PageConfig.Layout[E.layout] === void 0 ? E.layout : $root.PageConfig.Layout[E.layout] : E.layout), E.initialSidebarState != null && E.hasOwnProperty("initialSidebarState") && (g.initialSidebarState = A.enums === String ? $root.PageConfig.SidebarState[E.initialSidebarState] === void 0 ? E.initialSidebarState : $root.PageConfig.SidebarState[E.initialSidebarState] : E.initialSidebarState), E.menuItems != null && E.hasOwnProperty("menuItems") && (g.menuItems = $root.PageConfig.MenuItems.toObject(E.menuItems, A)), g;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/PageConfig";
  }, o.MenuItems = (function() {
    function E(A) {
      if (A) for (let g = Object.keys(A), e = 0; e < g.length; ++e) A[g[e]] != null && (this[g[e]] = A[g[e]]);
    }
    return E.prototype.getHelpUrl = "", E.prototype.hideGetHelp = !1, E.prototype.reportABugUrl = "", E.prototype.hideReportABug = !1, E.prototype.aboutSectionMd = "", E.prototype.clearAboutMd = !1, E.create = function(A) {
      return new E(A);
    }, E.encode = function(A, g) {
      return g || (g = $Writer.create()), A.getHelpUrl != null && Object.hasOwnProperty.call(A, "getHelpUrl") && g.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(A.getHelpUrl), A.hideGetHelp != null && Object.hasOwnProperty.call(A, "hideGetHelp") && g.uint32(
        /* id 2, wireType 0 =*/
        16
      ).bool(A.hideGetHelp), A.reportABugUrl != null && Object.hasOwnProperty.call(A, "reportABugUrl") && g.uint32(
        /* id 3, wireType 2 =*/
        26
      ).string(A.reportABugUrl), A.hideReportABug != null && Object.hasOwnProperty.call(A, "hideReportABug") && g.uint32(
        /* id 4, wireType 0 =*/
        32
      ).bool(A.hideReportABug), A.aboutSectionMd != null && Object.hasOwnProperty.call(A, "aboutSectionMd") && g.uint32(
        /* id 5, wireType 2 =*/
        42
      ).string(A.aboutSectionMd), A.clearAboutMd != null && Object.hasOwnProperty.call(A, "clearAboutMd") && g.uint32(
        /* id 6, wireType 0 =*/
        48
      ).bool(A.clearAboutMd), g;
    }, E.decode = function(A, g, e) {
      A instanceof $Reader || (A = $Reader.create(A));
      let t = g === void 0 ? A.len : A.pos + g, c = new $root.PageConfig.MenuItems();
      for (; A.pos < t; ) {
        let n = A.uint32();
        if (n === e) break;
        switch (n >>> 3) {
          case 1: {
            c.getHelpUrl = A.string();
            break;
          }
          case 2: {
            c.hideGetHelp = A.bool();
            break;
          }
          case 3: {
            c.reportABugUrl = A.string();
            break;
          }
          case 4: {
            c.hideReportABug = A.bool();
            break;
          }
          case 5: {
            c.aboutSectionMd = A.string();
            break;
          }
          case 6: {
            c.clearAboutMd = A.bool();
            break;
          }
          default:
            A.skipType(n & 7);
            break;
        }
      }
      return c;
    }, E.fromObject = function(A) {
      if (A instanceof $root.PageConfig.MenuItems) return A;
      let g = new $root.PageConfig.MenuItems();
      return A.getHelpUrl != null && (g.getHelpUrl = String(A.getHelpUrl)), A.hideGetHelp != null && (g.hideGetHelp = !!A.hideGetHelp), A.reportABugUrl != null && (g.reportABugUrl = String(A.reportABugUrl)), A.hideReportABug != null && (g.hideReportABug = !!A.hideReportABug), A.aboutSectionMd != null && (g.aboutSectionMd = String(A.aboutSectionMd)), A.clearAboutMd != null && (g.clearAboutMd = !!A.clearAboutMd), g;
    }, E.toObject = function(A, g) {
      g || (g = {});
      let e = {};
      return g.defaults && (e.getHelpUrl = "", e.hideGetHelp = !1, e.reportABugUrl = "", e.hideReportABug = !1, e.aboutSectionMd = "", e.clearAboutMd = !1), A.getHelpUrl != null && A.hasOwnProperty("getHelpUrl") && (e.getHelpUrl = A.getHelpUrl), A.hideGetHelp != null && A.hasOwnProperty("hideGetHelp") && (e.hideGetHelp = A.hideGetHelp), A.reportABugUrl != null && A.hasOwnProperty("reportABugUrl") && (e.reportABugUrl = A.reportABugUrl), A.hideReportABug != null && A.hasOwnProperty("hideReportABug") && (e.hideReportABug = A.hideReportABug), A.aboutSectionMd != null && A.hasOwnProperty("aboutSectionMd") && (e.aboutSectionMd = A.aboutSectionMd), A.clearAboutMd != null && A.hasOwnProperty("clearAboutMd") && (e.clearAboutMd = A.clearAboutMd), e;
    }, E.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, E.getTypeUrl = function(A) {
      return A === void 0 && (A = "type.googleapis.com"), A + "/PageConfig.MenuItems";
    }, E;
  })(), o.Layout = (function() {
    const E = {}, A = Object.create(E);
    return A[E[0] = "CENTERED"] = 0, A[E[1] = "WIDE"] = 1, A[E[2] = "LAYOUT_UNSET"] = 2, A;
  })(), o.SidebarState = (function() {
    const E = {}, A = Object.create(E);
    return A[E[0] = "AUTO"] = 0, A[E[1] = "EXPANDED"] = 1, A[E[2] = "COLLAPSED"] = 2, A[E[3] = "SIDEBAR_UNSET"] = 3, A;
  })(), o;
})();
$root.PageInfo = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.queryString = "", o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, A) {
    return A || (A = $Writer.create()), E.queryString != null && Object.hasOwnProperty.call(E, "queryString") && A.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(E.queryString), A;
  }, o.decode = function(E, A, g) {
    E instanceof $Reader || (E = $Reader.create(E));
    let e = A === void 0 ? E.len : E.pos + A, t = new $root.PageInfo();
    for (; E.pos < e; ) {
      let c = E.uint32();
      if (c === g) break;
      c >>> 3 === 1 ? t.queryString = E.string() : E.skipType(c & 7);
    }
    return t;
  }, o.fromObject = function(E) {
    if (E instanceof $root.PageInfo) return E;
    let A = new $root.PageInfo();
    return E.queryString != null && (A.queryString = String(E.queryString)), A;
  }, o.toObject = function(E, A) {
    A || (A = {});
    let g = {};
    return A.defaults && (g.queryString = ""), E.queryString != null && E.hasOwnProperty("queryString") && (g.queryString = E.queryString), g;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/PageInfo";
  }, o;
})();
$root.PageProfile = (() => {
  function o(E) {
    if (this.commands = [], this.config = [], this.attributions = [], E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.commands = $util.emptyArray, o.prototype.execTime = $util.Long ? $util.Long.fromBits(0, 0, !1) : 0, o.prototype.prepTime = $util.Long ? $util.Long.fromBits(0, 0, !1) : 0, o.prototype.config = $util.emptyArray, o.prototype.uncaughtException = "", o.prototype.attributions = $util.emptyArray, o.prototype.os = "", o.prototype.timezone = "", o.prototype.headless = !1, o.prototype.isFragmentRun = !1, o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, A) {
    if (A || (A = $Writer.create()), E.commands != null && E.commands.length) for (let g = 0; g < E.commands.length; ++g) $root.Command.encode(E.commands[g], A.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim();
    if (E.execTime != null && Object.hasOwnProperty.call(E, "execTime") && A.uint32(
      /* id 2, wireType 0 =*/
      16
    ).int64(E.execTime), E.prepTime != null && Object.hasOwnProperty.call(E, "prepTime") && A.uint32(
      /* id 3, wireType 0 =*/
      24
    ).int64(E.prepTime), E.config != null && E.config.length) for (let g = 0; g < E.config.length; ++g) A.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(E.config[g]);
    if (E.uncaughtException != null && Object.hasOwnProperty.call(E, "uncaughtException") && A.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(E.uncaughtException), E.attributions != null && E.attributions.length) for (let g = 0; g < E.attributions.length; ++g) A.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(E.attributions[g]);
    return E.os != null && Object.hasOwnProperty.call(E, "os") && A.uint32(
      /* id 8, wireType 2 =*/
      66
    ).string(E.os), E.timezone != null && Object.hasOwnProperty.call(E, "timezone") && A.uint32(
      /* id 9, wireType 2 =*/
      74
    ).string(E.timezone), E.headless != null && Object.hasOwnProperty.call(E, "headless") && A.uint32(
      /* id 10, wireType 0 =*/
      80
    ).bool(E.headless), E.isFragmentRun != null && Object.hasOwnProperty.call(E, "isFragmentRun") && A.uint32(
      /* id 11, wireType 0 =*/
      88
    ).bool(E.isFragmentRun), A;
  }, o.decode = function(E, A, g) {
    E instanceof $Reader || (E = $Reader.create(E));
    let e = A === void 0 ? E.len : E.pos + A, t = new $root.PageProfile();
    for (; E.pos < e; ) {
      let c = E.uint32();
      if (c === g) break;
      switch (c >>> 3) {
        case 1: {
          t.commands && t.commands.length || (t.commands = []), t.commands.push($root.Command.decode(E, E.uint32()));
          break;
        }
        case 2: {
          t.execTime = E.int64();
          break;
        }
        case 3: {
          t.prepTime = E.int64();
          break;
        }
        case 5: {
          t.config && t.config.length || (t.config = []), t.config.push(E.string());
          break;
        }
        case 6: {
          t.uncaughtException = E.string();
          break;
        }
        case 7: {
          t.attributions && t.attributions.length || (t.attributions = []), t.attributions.push(E.string());
          break;
        }
        case 8: {
          t.os = E.string();
          break;
        }
        case 9: {
          t.timezone = E.string();
          break;
        }
        case 10: {
          t.headless = E.bool();
          break;
        }
        case 11: {
          t.isFragmentRun = E.bool();
          break;
        }
        default:
          E.skipType(c & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(E) {
    if (E instanceof $root.PageProfile) return E;
    let A = new $root.PageProfile();
    if (E.commands) {
      if (!Array.isArray(E.commands)) throw TypeError(".PageProfile.commands: array expected");
      A.commands = [];
      for (let g = 0; g < E.commands.length; ++g) {
        if (typeof E.commands[g] != "object") throw TypeError(".PageProfile.commands: object expected");
        A.commands[g] = $root.Command.fromObject(E.commands[g]);
      }
    }
    if (E.execTime != null && ($util.Long ? (A.execTime = $util.Long.fromValue(E.execTime)).unsigned = !1 : typeof E.execTime == "string" ? A.execTime = parseInt(E.execTime, 10) : typeof E.execTime == "number" ? A.execTime = E.execTime : typeof E.execTime == "object" && (A.execTime = new $util.LongBits(E.execTime.low >>> 0, E.execTime.high >>> 0).toNumber())), E.prepTime != null && ($util.Long ? (A.prepTime = $util.Long.fromValue(E.prepTime)).unsigned = !1 : typeof E.prepTime == "string" ? A.prepTime = parseInt(E.prepTime, 10) : typeof E.prepTime == "number" ? A.prepTime = E.prepTime : typeof E.prepTime == "object" && (A.prepTime = new $util.LongBits(E.prepTime.low >>> 0, E.prepTime.high >>> 0).toNumber())), E.config) {
      if (!Array.isArray(E.config)) throw TypeError(".PageProfile.config: array expected");
      A.config = [];
      for (let g = 0; g < E.config.length; ++g) A.config[g] = String(E.config[g]);
    }
    if (E.uncaughtException != null && (A.uncaughtException = String(E.uncaughtException)), E.attributions) {
      if (!Array.isArray(E.attributions)) throw TypeError(".PageProfile.attributions: array expected");
      A.attributions = [];
      for (let g = 0; g < E.attributions.length; ++g) A.attributions[g] = String(E.attributions[g]);
    }
    return E.os != null && (A.os = String(E.os)), E.timezone != null && (A.timezone = String(E.timezone)), E.headless != null && (A.headless = !!E.headless), E.isFragmentRun != null && (A.isFragmentRun = !!E.isFragmentRun), A;
  }, o.toObject = function(E, A) {
    A || (A = {});
    let g = {};
    if ((A.arrays || A.defaults) && (g.commands = [], g.config = [], g.attributions = []), A.defaults) {
      if ($util.Long) {
        let e = new $util.Long(0, 0, !1);
        g.execTime = A.longs === String ? e.toString() : A.longs === Number ? e.toNumber() : e;
      } else g.execTime = A.longs === String ? "0" : 0;
      if ($util.Long) {
        let e = new $util.Long(0, 0, !1);
        g.prepTime = A.longs === String ? e.toString() : A.longs === Number ? e.toNumber() : e;
      } else g.prepTime = A.longs === String ? "0" : 0;
      g.uncaughtException = "", g.os = "", g.timezone = "", g.headless = !1, g.isFragmentRun = !1;
    }
    if (E.commands && E.commands.length) {
      g.commands = [];
      for (let e = 0; e < E.commands.length; ++e) g.commands[e] = $root.Command.toObject(E.commands[e], A);
    }
    if (E.execTime != null && E.hasOwnProperty("execTime") && (typeof E.execTime == "number" ? g.execTime = A.longs === String ? String(E.execTime) : E.execTime : g.execTime = A.longs === String ? $util.Long.prototype.toString.call(E.execTime) : A.longs === Number ? new $util.LongBits(E.execTime.low >>> 0, E.execTime.high >>> 0).toNumber() : E.execTime), E.prepTime != null && E.hasOwnProperty("prepTime") && (typeof E.prepTime == "number" ? g.prepTime = A.longs === String ? String(E.prepTime) : E.prepTime : g.prepTime = A.longs === String ? $util.Long.prototype.toString.call(E.prepTime) : A.longs === Number ? new $util.LongBits(E.prepTime.low >>> 0, E.prepTime.high >>> 0).toNumber() : E.prepTime), E.config && E.config.length) {
      g.config = [];
      for (let e = 0; e < E.config.length; ++e) g.config[e] = E.config[e];
    }
    if (E.uncaughtException != null && E.hasOwnProperty("uncaughtException") && (g.uncaughtException = E.uncaughtException), E.attributions && E.attributions.length) {
      g.attributions = [];
      for (let e = 0; e < E.attributions.length; ++e) g.attributions[e] = E.attributions[e];
    }
    return E.os != null && E.hasOwnProperty("os") && (g.os = E.os), E.timezone != null && E.hasOwnProperty("timezone") && (g.timezone = E.timezone), E.headless != null && E.hasOwnProperty("headless") && (g.headless = E.headless), E.isFragmentRun != null && E.hasOwnProperty("isFragmentRun") && (g.isFragmentRun = E.isFragmentRun), g;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/PageProfile";
  }, o;
})();
$root.Argument = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.k = "", o.prototype.t = "", o.prototype.m = "", o.prototype.p = 0, o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, A) {
    return A || (A = $Writer.create()), E.k != null && Object.hasOwnProperty.call(E, "k") && A.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(E.k), E.t != null && Object.hasOwnProperty.call(E, "t") && A.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(E.t), E.m != null && Object.hasOwnProperty.call(E, "m") && A.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(E.m), E.p != null && Object.hasOwnProperty.call(E, "p") && A.uint32(
      /* id 5, wireType 0 =*/
      40
    ).int32(E.p), A;
  }, o.decode = function(E, A, g) {
    E instanceof $Reader || (E = $Reader.create(E));
    let e = A === void 0 ? E.len : E.pos + A, t = new $root.Argument();
    for (; E.pos < e; ) {
      let c = E.uint32();
      if (c === g) break;
      switch (c >>> 3) {
        case 1: {
          t.k = E.string();
          break;
        }
        case 2: {
          t.t = E.string();
          break;
        }
        case 3: {
          t.m = E.string();
          break;
        }
        case 5: {
          t.p = E.int32();
          break;
        }
        default:
          E.skipType(c & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(E) {
    if (E instanceof $root.Argument) return E;
    let A = new $root.Argument();
    return E.k != null && (A.k = String(E.k)), E.t != null && (A.t = String(E.t)), E.m != null && (A.m = String(E.m)), E.p != null && (A.p = E.p | 0), A;
  }, o.toObject = function(E, A) {
    A || (A = {});
    let g = {};
    return A.defaults && (g.k = "", g.t = "", g.m = "", g.p = 0), E.k != null && E.hasOwnProperty("k") && (g.k = E.k), E.t != null && E.hasOwnProperty("t") && (g.t = E.t), E.m != null && E.hasOwnProperty("m") && (g.m = E.m), E.p != null && E.hasOwnProperty("p") && (g.p = E.p), g;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/Argument";
  }, o;
})();
$root.Command = (() => {
  function o(E) {
    if (this.args = [], E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.name = "", o.prototype.args = $util.emptyArray, o.prototype.time = $util.Long ? $util.Long.fromBits(0, 0, !1) : 0, o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, A) {
    if (A || (A = $Writer.create()), E.name != null && Object.hasOwnProperty.call(E, "name") && A.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(E.name), E.args != null && E.args.length) for (let g = 0; g < E.args.length; ++g) $root.Argument.encode(E.args[g], A.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim();
    return E.time != null && Object.hasOwnProperty.call(E, "time") && A.uint32(
      /* id 4, wireType 0 =*/
      32
    ).int64(E.time), A;
  }, o.decode = function(E, A, g) {
    E instanceof $Reader || (E = $Reader.create(E));
    let e = A === void 0 ? E.len : E.pos + A, t = new $root.Command();
    for (; E.pos < e; ) {
      let c = E.uint32();
      if (c === g) break;
      switch (c >>> 3) {
        case 1: {
          t.name = E.string();
          break;
        }
        case 2: {
          t.args && t.args.length || (t.args = []), t.args.push($root.Argument.decode(E, E.uint32()));
          break;
        }
        case 4: {
          t.time = E.int64();
          break;
        }
        default:
          E.skipType(c & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(E) {
    if (E instanceof $root.Command) return E;
    let A = new $root.Command();
    if (E.name != null && (A.name = String(E.name)), E.args) {
      if (!Array.isArray(E.args)) throw TypeError(".Command.args: array expected");
      A.args = [];
      for (let g = 0; g < E.args.length; ++g) {
        if (typeof E.args[g] != "object") throw TypeError(".Command.args: object expected");
        A.args[g] = $root.Argument.fromObject(E.args[g]);
      }
    }
    return E.time != null && ($util.Long ? (A.time = $util.Long.fromValue(E.time)).unsigned = !1 : typeof E.time == "string" ? A.time = parseInt(E.time, 10) : typeof E.time == "number" ? A.time = E.time : typeof E.time == "object" && (A.time = new $util.LongBits(E.time.low >>> 0, E.time.high >>> 0).toNumber())), A;
  }, o.toObject = function(E, A) {
    A || (A = {});
    let g = {};
    if ((A.arrays || A.defaults) && (g.args = []), A.defaults) if (g.name = "", $util.Long) {
      let e = new $util.Long(0, 0, !1);
      g.time = A.longs === String ? e.toString() : A.longs === Number ? e.toNumber() : e;
    } else g.time = A.longs === String ? "0" : 0;
    if (E.name != null && E.hasOwnProperty("name") && (g.name = E.name), E.args && E.args.length) {
      g.args = [];
      for (let e = 0; e < E.args.length; ++e) g.args[e] = $root.Argument.toObject(E.args[e], A);
    }
    return E.time != null && E.hasOwnProperty("time") && (typeof E.time == "number" ? g.time = A.longs === String ? String(E.time) : E.time : g.time = A.longs === String ? $util.Long.prototype.toString.call(E.time) : A.longs === Number ? new $util.LongBits(E.time.low >>> 0, E.time.high >>> 0).toNumber() : E.time), g;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/Command";
  }, o;
})();
$root.PageNotFound = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.pageName = "", o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, A) {
    return A || (A = $Writer.create()), E.pageName != null && Object.hasOwnProperty.call(E, "pageName") && A.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(E.pageName), A;
  }, o.decode = function(E, A, g) {
    E instanceof $Reader || (E = $Reader.create(E));
    let e = A === void 0 ? E.len : E.pos + A, t = new $root.PageNotFound();
    for (; E.pos < e; ) {
      let c = E.uint32();
      if (c === g) break;
      c >>> 3 === 1 ? t.pageName = E.string() : E.skipType(c & 7);
    }
    return t;
  }, o.fromObject = function(E) {
    if (E instanceof $root.PageNotFound) return E;
    let A = new $root.PageNotFound();
    return E.pageName != null && (A.pageName = String(E.pageName)), A;
  }, o.toObject = function(E, A) {
    A || (A = {});
    let g = {};
    return A.defaults && (g.pageName = ""), E.pageName != null && E.hasOwnProperty("pageName") && (g.pageName = E.pageName), g;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/PageNotFound";
  }, o;
})();
$root.PagesChanged = (() => {
  function o(E) {
    if (this.appPages = [], E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.appPages = $util.emptyArray, o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, A) {
    if (A || (A = $Writer.create()), E.appPages != null && E.appPages.length) for (let g = 0; g < E.appPages.length; ++g) $root.AppPage.encode(E.appPages[g], A.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim();
    return A;
  }, o.decode = function(E, A, g) {
    E instanceof $Reader || (E = $Reader.create(E));
    let e = A === void 0 ? E.len : E.pos + A, t = new $root.PagesChanged();
    for (; E.pos < e; ) {
      let c = E.uint32();
      if (c === g) break;
      c >>> 3 === 1 ? (t.appPages && t.appPages.length || (t.appPages = []), t.appPages.push($root.AppPage.decode(E, E.uint32()))) : E.skipType(c & 7);
    }
    return t;
  }, o.fromObject = function(E) {
    if (E instanceof $root.PagesChanged) return E;
    let A = new $root.PagesChanged();
    if (E.appPages) {
      if (!Array.isArray(E.appPages)) throw TypeError(".PagesChanged.appPages: array expected");
      A.appPages = [];
      for (let g = 0; g < E.appPages.length; ++g) {
        if (typeof E.appPages[g] != "object") throw TypeError(".PagesChanged.appPages: object expected");
        A.appPages[g] = $root.AppPage.fromObject(E.appPages[g]);
      }
    }
    return A;
  }, o.toObject = function(E, A) {
    A || (A = {});
    let g = {};
    if ((A.arrays || A.defaults) && (g.appPages = []), E.appPages && E.appPages.length) {
      g.appPages = [];
      for (let e = 0; e < E.appPages.length; ++e) g.appPages[e] = $root.AppPage.toObject(E.appPages[e], A);
    }
    return g;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/PagesChanged";
  }, o;
})();
$root.ParentMessage = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.message = "", o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, A) {
    return A || (A = $Writer.create()), E.message != null && Object.hasOwnProperty.call(E, "message") && A.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(E.message), A;
  }, o.decode = function(E, A, g) {
    E instanceof $Reader || (E = $Reader.create(E));
    let e = A === void 0 ? E.len : E.pos + A, t = new $root.ParentMessage();
    for (; E.pos < e; ) {
      let c = E.uint32();
      if (c === g) break;
      c >>> 3 === 1 ? t.message = E.string() : E.skipType(c & 7);
    }
    return t;
  }, o.fromObject = function(E) {
    if (E instanceof $root.ParentMessage) return E;
    let A = new $root.ParentMessage();
    return E.message != null && (A.message = String(E.message)), A;
  }, o.toObject = function(E, A) {
    A || (A = {});
    let g = {};
    return A.defaults && (g.message = ""), E.message != null && E.hasOwnProperty("message") && (g.message = E.message), g;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/ParentMessage";
  }, o;
})();
$root.SessionEvent = (() => {
  function o(A) {
    if (A) for (let g = Object.keys(A), e = 0; e < g.length; ++e) A[g[e]] != null && (this[g[e]] = A[g[e]]);
  }
  o.prototype.scriptChangedOnDisk = null, o.prototype.scriptWasManuallyStopped = null, o.prototype.scriptCompilationException = null;
  let E;
  return Object.defineProperty(o.prototype, "type", { get: $util.oneOfGetter(E = ["scriptChangedOnDisk", "scriptWasManuallyStopped", "scriptCompilationException"]), set: $util.oneOfSetter(E) }), o.create = function(A) {
    return new o(A);
  }, o.encode = function(A, g) {
    return g || (g = $Writer.create()), A.scriptChangedOnDisk != null && Object.hasOwnProperty.call(A, "scriptChangedOnDisk") && g.uint32(
      /* id 1, wireType 0 =*/
      8
    ).bool(A.scriptChangedOnDisk), A.scriptWasManuallyStopped != null && Object.hasOwnProperty.call(A, "scriptWasManuallyStopped") && g.uint32(
      /* id 2, wireType 0 =*/
      16
    ).bool(A.scriptWasManuallyStopped), A.scriptCompilationException != null && Object.hasOwnProperty.call(A, "scriptCompilationException") && $root.Exception.encode(A.scriptCompilationException, g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).fork()).ldelim(), g;
  }, o.decode = function(A, g, e) {
    A instanceof $Reader || (A = $Reader.create(A));
    let t = g === void 0 ? A.len : A.pos + g, c = new $root.SessionEvent();
    for (; A.pos < t; ) {
      let n = A.uint32();
      if (n === e) break;
      switch (n >>> 3) {
        case 1: {
          c.scriptChangedOnDisk = A.bool();
          break;
        }
        case 2: {
          c.scriptWasManuallyStopped = A.bool();
          break;
        }
        case 3: {
          c.scriptCompilationException = $root.Exception.decode(A, A.uint32());
          break;
        }
        default:
          A.skipType(n & 7);
          break;
      }
    }
    return c;
  }, o.fromObject = function(A) {
    if (A instanceof $root.SessionEvent) return A;
    let g = new $root.SessionEvent();
    if (A.scriptChangedOnDisk != null && (g.scriptChangedOnDisk = !!A.scriptChangedOnDisk), A.scriptWasManuallyStopped != null && (g.scriptWasManuallyStopped = !!A.scriptWasManuallyStopped), A.scriptCompilationException != null) {
      if (typeof A.scriptCompilationException != "object") throw TypeError(".SessionEvent.scriptCompilationException: object expected");
      g.scriptCompilationException = $root.Exception.fromObject(A.scriptCompilationException);
    }
    return g;
  }, o.toObject = function(A, g) {
    g || (g = {});
    let e = {};
    return A.scriptChangedOnDisk != null && A.hasOwnProperty("scriptChangedOnDisk") && (e.scriptChangedOnDisk = A.scriptChangedOnDisk, g.oneofs && (e.type = "scriptChangedOnDisk")), A.scriptWasManuallyStopped != null && A.hasOwnProperty("scriptWasManuallyStopped") && (e.scriptWasManuallyStopped = A.scriptWasManuallyStopped, g.oneofs && (e.type = "scriptWasManuallyStopped")), A.scriptCompilationException != null && A.hasOwnProperty("scriptCompilationException") && (e.scriptCompilationException = $root.Exception.toObject(A.scriptCompilationException, g), g.oneofs && (e.type = "scriptCompilationException")), e;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(A) {
    return A === void 0 && (A = "type.googleapis.com"), A + "/SessionEvent";
  }, o;
})();
$root.MetricsEvent = (() => {
  function o(E) {
    if (this.commands = [], this.config = [], this.attributions = [], E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.event = "", o.prototype.anonymousId = "", o.prototype.machineIdV3 = "", o.prototype.machineIdV4 = "", o.prototype.reportHash = "", o.prototype.dev = !1, o.prototype.source = "", o.prototype.streamlitVersion = "", o.prototype.isHello = !1, o.prototype.appId = "", o.prototype.sessionId = "", o.prototype.pythonVersion = "", o.prototype.serverOs = "", o.prototype.hasDisplay = !1, o.prototype.isWebdriver = !1, o.prototype.hostedAt = "", o.prototype.owner = "", o.prototype.repo = "", o.prototype.branch = "", o.prototype.mainModule = "", o.prototype.creatorId = "", o.prototype.contextPageUrl = "", o.prototype.contextPageTitle = "", o.prototype.contextPagePath = "", o.prototype.contextPageReferrer = "", o.prototype.contextPageSearch = "", o.prototype.contextLocale = "", o.prototype.contextUserAgent = "", o.prototype.label = "", o.prototype.commands = $util.emptyArray, o.prototype.execTime = $util.Long ? $util.Long.fromBits(0, 0, !1) : 0, o.prototype.prepTime = $util.Long ? $util.Long.fromBits(0, 0, !1) : 0, o.prototype.config = $util.emptyArray, o.prototype.uncaughtException = "", o.prototype.attributions = $util.emptyArray, o.prototype.os = "", o.prototype.timezone = "", o.prototype.headless = !1, o.prototype.isFragmentRun = !1, o.prototype.numPages = $util.Long ? $util.Long.fromBits(0, 0, !1) : 0, o.prototype.pageScriptHash = "", o.prototype.activeTheme = "", o.prototype.totalLoadTime = $util.Long ? $util.Long.fromBits(0, 0, !1) : 0, o.prototype.browserInfo = null, o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, A) {
    if (A || (A = $Writer.create()), E.event != null && Object.hasOwnProperty.call(E, "event") && A.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(E.event), E.anonymousId != null && Object.hasOwnProperty.call(E, "anonymousId") && A.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(E.anonymousId), E.machineIdV3 != null && Object.hasOwnProperty.call(E, "machineIdV3") && A.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(E.machineIdV3), E.reportHash != null && Object.hasOwnProperty.call(E, "reportHash") && A.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(E.reportHash), E.dev != null && Object.hasOwnProperty.call(E, "dev") && A.uint32(
      /* id 5, wireType 0 =*/
      40
    ).bool(E.dev), E.source != null && Object.hasOwnProperty.call(E, "source") && A.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(E.source), E.streamlitVersion != null && Object.hasOwnProperty.call(E, "streamlitVersion") && A.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(E.streamlitVersion), E.isHello != null && Object.hasOwnProperty.call(E, "isHello") && A.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(E.isHello), E.hostedAt != null && Object.hasOwnProperty.call(E, "hostedAt") && A.uint32(
      /* id 9, wireType 2 =*/
      74
    ).string(E.hostedAt), E.owner != null && Object.hasOwnProperty.call(E, "owner") && A.uint32(
      /* id 10, wireType 2 =*/
      82
    ).string(E.owner), E.repo != null && Object.hasOwnProperty.call(E, "repo") && A.uint32(
      /* id 11, wireType 2 =*/
      90
    ).string(E.repo), E.branch != null && Object.hasOwnProperty.call(E, "branch") && A.uint32(
      /* id 12, wireType 2 =*/
      98
    ).string(E.branch), E.mainModule != null && Object.hasOwnProperty.call(E, "mainModule") && A.uint32(
      /* id 13, wireType 2 =*/
      106
    ).string(E.mainModule), E.creatorId != null && Object.hasOwnProperty.call(E, "creatorId") && A.uint32(
      /* id 14, wireType 2 =*/
      114
    ).string(E.creatorId), E.contextPageUrl != null && Object.hasOwnProperty.call(E, "contextPageUrl") && A.uint32(
      /* id 15, wireType 2 =*/
      122
    ).string(E.contextPageUrl), E.contextPageTitle != null && Object.hasOwnProperty.call(E, "contextPageTitle") && A.uint32(
      /* id 16, wireType 2 =*/
      130
    ).string(E.contextPageTitle), E.contextPagePath != null && Object.hasOwnProperty.call(E, "contextPagePath") && A.uint32(
      /* id 17, wireType 2 =*/
      138
    ).string(E.contextPagePath), E.contextPageReferrer != null && Object.hasOwnProperty.call(E, "contextPageReferrer") && A.uint32(
      /* id 18, wireType 2 =*/
      146
    ).string(E.contextPageReferrer), E.contextPageSearch != null && Object.hasOwnProperty.call(E, "contextPageSearch") && A.uint32(
      /* id 19, wireType 2 =*/
      154
    ).string(E.contextPageSearch), E.contextLocale != null && Object.hasOwnProperty.call(E, "contextLocale") && A.uint32(
      /* id 20, wireType 2 =*/
      162
    ).string(E.contextLocale), E.contextUserAgent != null && Object.hasOwnProperty.call(E, "contextUserAgent") && A.uint32(
      /* id 21, wireType 2 =*/
      170
    ).string(E.contextUserAgent), E.label != null && Object.hasOwnProperty.call(E, "label") && A.uint32(
      /* id 22, wireType 2 =*/
      178
    ).string(E.label), E.commands != null && E.commands.length) for (let g = 0; g < E.commands.length; ++g) $root.Command.encode(E.commands[g], A.uint32(
      /* id 23, wireType 2 =*/
      186
    ).fork()).ldelim();
    if (E.execTime != null && Object.hasOwnProperty.call(E, "execTime") && A.uint32(
      /* id 24, wireType 0 =*/
      192
    ).int64(E.execTime), E.prepTime != null && Object.hasOwnProperty.call(E, "prepTime") && A.uint32(
      /* id 25, wireType 0 =*/
      200
    ).int64(E.prepTime), E.config != null && E.config.length) for (let g = 0; g < E.config.length; ++g) A.uint32(
      /* id 26, wireType 2 =*/
      210
    ).string(E.config[g]);
    if (E.uncaughtException != null && Object.hasOwnProperty.call(E, "uncaughtException") && A.uint32(
      /* id 27, wireType 2 =*/
      218
    ).string(E.uncaughtException), E.attributions != null && E.attributions.length) for (let g = 0; g < E.attributions.length; ++g) A.uint32(
      /* id 28, wireType 2 =*/
      226
    ).string(E.attributions[g]);
    return E.os != null && Object.hasOwnProperty.call(E, "os") && A.uint32(
      /* id 29, wireType 2 =*/
      234
    ).string(E.os), E.timezone != null && Object.hasOwnProperty.call(E, "timezone") && A.uint32(
      /* id 30, wireType 2 =*/
      242
    ).string(E.timezone), E.headless != null && Object.hasOwnProperty.call(E, "headless") && A.uint32(
      /* id 31, wireType 0 =*/
      248
    ).bool(E.headless), E.isFragmentRun != null && Object.hasOwnProperty.call(E, "isFragmentRun") && A.uint32(
      /* id 32, wireType 0 =*/
      256
    ).bool(E.isFragmentRun), E.appId != null && Object.hasOwnProperty.call(E, "appId") && A.uint32(
      /* id 33, wireType 2 =*/
      266
    ).string(E.appId), E.numPages != null && Object.hasOwnProperty.call(E, "numPages") && A.uint32(
      /* id 34, wireType 0 =*/
      272
    ).int64(E.numPages), E.sessionId != null && Object.hasOwnProperty.call(E, "sessionId") && A.uint32(
      /* id 35, wireType 2 =*/
      282
    ).string(E.sessionId), E.pythonVersion != null && Object.hasOwnProperty.call(E, "pythonVersion") && A.uint32(
      /* id 36, wireType 2 =*/
      290
    ).string(E.pythonVersion), E.pageScriptHash != null && Object.hasOwnProperty.call(E, "pageScriptHash") && A.uint32(
      /* id 37, wireType 2 =*/
      298
    ).string(E.pageScriptHash), E.activeTheme != null && Object.hasOwnProperty.call(E, "activeTheme") && A.uint32(
      /* id 38, wireType 2 =*/
      306
    ).string(E.activeTheme), E.totalLoadTime != null && Object.hasOwnProperty.call(E, "totalLoadTime") && A.uint32(
      /* id 39, wireType 0 =*/
      312
    ).int64(E.totalLoadTime), E.browserInfo != null && Object.hasOwnProperty.call(E, "browserInfo") && $root.BrowserInfo.encode(E.browserInfo, A.uint32(
      /* id 40, wireType 2 =*/
      322
    ).fork()).ldelim(), E.machineIdV4 != null && Object.hasOwnProperty.call(E, "machineIdV4") && A.uint32(
      /* id 41, wireType 2 =*/
      330
    ).string(E.machineIdV4), E.serverOs != null && Object.hasOwnProperty.call(E, "serverOs") && A.uint32(
      /* id 42, wireType 2 =*/
      338
    ).string(E.serverOs), E.hasDisplay != null && Object.hasOwnProperty.call(E, "hasDisplay") && A.uint32(
      /* id 43, wireType 0 =*/
      344
    ).bool(E.hasDisplay), E.isWebdriver != null && Object.hasOwnProperty.call(E, "isWebdriver") && A.uint32(
      /* id 44, wireType 0 =*/
      352
    ).bool(E.isWebdriver), A;
  }, o.decode = function(E, A, g) {
    E instanceof $Reader || (E = $Reader.create(E));
    let e = A === void 0 ? E.len : E.pos + A, t = new $root.MetricsEvent();
    for (; E.pos < e; ) {
      let c = E.uint32();
      if (c === g) break;
      switch (c >>> 3) {
        case 1: {
          t.event = E.string();
          break;
        }
        case 2: {
          t.anonymousId = E.string();
          break;
        }
        case 3: {
          t.machineIdV3 = E.string();
          break;
        }
        case 41: {
          t.machineIdV4 = E.string();
          break;
        }
        case 4: {
          t.reportHash = E.string();
          break;
        }
        case 5: {
          t.dev = E.bool();
          break;
        }
        case 6: {
          t.source = E.string();
          break;
        }
        case 7: {
          t.streamlitVersion = E.string();
          break;
        }
        case 8: {
          t.isHello = E.bool();
          break;
        }
        case 33: {
          t.appId = E.string();
          break;
        }
        case 35: {
          t.sessionId = E.string();
          break;
        }
        case 36: {
          t.pythonVersion = E.string();
          break;
        }
        case 42: {
          t.serverOs = E.string();
          break;
        }
        case 43: {
          t.hasDisplay = E.bool();
          break;
        }
        case 44: {
          t.isWebdriver = E.bool();
          break;
        }
        case 9: {
          t.hostedAt = E.string();
          break;
        }
        case 10: {
          t.owner = E.string();
          break;
        }
        case 11: {
          t.repo = E.string();
          break;
        }
        case 12: {
          t.branch = E.string();
          break;
        }
        case 13: {
          t.mainModule = E.string();
          break;
        }
        case 14: {
          t.creatorId = E.string();
          break;
        }
        case 15: {
          t.contextPageUrl = E.string();
          break;
        }
        case 16: {
          t.contextPageTitle = E.string();
          break;
        }
        case 17: {
          t.contextPagePath = E.string();
          break;
        }
        case 18: {
          t.contextPageReferrer = E.string();
          break;
        }
        case 19: {
          t.contextPageSearch = E.string();
          break;
        }
        case 20: {
          t.contextLocale = E.string();
          break;
        }
        case 21: {
          t.contextUserAgent = E.string();
          break;
        }
        case 22: {
          t.label = E.string();
          break;
        }
        case 23: {
          t.commands && t.commands.length || (t.commands = []), t.commands.push($root.Command.decode(E, E.uint32()));
          break;
        }
        case 24: {
          t.execTime = E.int64();
          break;
        }
        case 25: {
          t.prepTime = E.int64();
          break;
        }
        case 26: {
          t.config && t.config.length || (t.config = []), t.config.push(E.string());
          break;
        }
        case 27: {
          t.uncaughtException = E.string();
          break;
        }
        case 28: {
          t.attributions && t.attributions.length || (t.attributions = []), t.attributions.push(E.string());
          break;
        }
        case 29: {
          t.os = E.string();
          break;
        }
        case 30: {
          t.timezone = E.string();
          break;
        }
        case 31: {
          t.headless = E.bool();
          break;
        }
        case 32: {
          t.isFragmentRun = E.bool();
          break;
        }
        case 34: {
          t.numPages = E.int64();
          break;
        }
        case 37: {
          t.pageScriptHash = E.string();
          break;
        }
        case 38: {
          t.activeTheme = E.string();
          break;
        }
        case 39: {
          t.totalLoadTime = E.int64();
          break;
        }
        case 40: {
          t.browserInfo = $root.BrowserInfo.decode(E, E.uint32());
          break;
        }
        default:
          E.skipType(c & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(E) {
    if (E instanceof $root.MetricsEvent) return E;
    let A = new $root.MetricsEvent();
    if (E.event != null && (A.event = String(E.event)), E.anonymousId != null && (A.anonymousId = String(E.anonymousId)), E.machineIdV3 != null && (A.machineIdV3 = String(E.machineIdV3)), E.machineIdV4 != null && (A.machineIdV4 = String(E.machineIdV4)), E.reportHash != null && (A.reportHash = String(E.reportHash)), E.dev != null && (A.dev = !!E.dev), E.source != null && (A.source = String(E.source)), E.streamlitVersion != null && (A.streamlitVersion = String(E.streamlitVersion)), E.isHello != null && (A.isHello = !!E.isHello), E.appId != null && (A.appId = String(E.appId)), E.sessionId != null && (A.sessionId = String(E.sessionId)), E.pythonVersion != null && (A.pythonVersion = String(E.pythonVersion)), E.serverOs != null && (A.serverOs = String(E.serverOs)), E.hasDisplay != null && (A.hasDisplay = !!E.hasDisplay), E.isWebdriver != null && (A.isWebdriver = !!E.isWebdriver), E.hostedAt != null && (A.hostedAt = String(E.hostedAt)), E.owner != null && (A.owner = String(E.owner)), E.repo != null && (A.repo = String(E.repo)), E.branch != null && (A.branch = String(E.branch)), E.mainModule != null && (A.mainModule = String(E.mainModule)), E.creatorId != null && (A.creatorId = String(E.creatorId)), E.contextPageUrl != null && (A.contextPageUrl = String(E.contextPageUrl)), E.contextPageTitle != null && (A.contextPageTitle = String(E.contextPageTitle)), E.contextPagePath != null && (A.contextPagePath = String(E.contextPagePath)), E.contextPageReferrer != null && (A.contextPageReferrer = String(E.contextPageReferrer)), E.contextPageSearch != null && (A.contextPageSearch = String(E.contextPageSearch)), E.contextLocale != null && (A.contextLocale = String(E.contextLocale)), E.contextUserAgent != null && (A.contextUserAgent = String(E.contextUserAgent)), E.label != null && (A.label = String(E.label)), E.commands) {
      if (!Array.isArray(E.commands)) throw TypeError(".MetricsEvent.commands: array expected");
      A.commands = [];
      for (let g = 0; g < E.commands.length; ++g) {
        if (typeof E.commands[g] != "object") throw TypeError(".MetricsEvent.commands: object expected");
        A.commands[g] = $root.Command.fromObject(E.commands[g]);
      }
    }
    if (E.execTime != null && ($util.Long ? (A.execTime = $util.Long.fromValue(E.execTime)).unsigned = !1 : typeof E.execTime == "string" ? A.execTime = parseInt(E.execTime, 10) : typeof E.execTime == "number" ? A.execTime = E.execTime : typeof E.execTime == "object" && (A.execTime = new $util.LongBits(E.execTime.low >>> 0, E.execTime.high >>> 0).toNumber())), E.prepTime != null && ($util.Long ? (A.prepTime = $util.Long.fromValue(E.prepTime)).unsigned = !1 : typeof E.prepTime == "string" ? A.prepTime = parseInt(E.prepTime, 10) : typeof E.prepTime == "number" ? A.prepTime = E.prepTime : typeof E.prepTime == "object" && (A.prepTime = new $util.LongBits(E.prepTime.low >>> 0, E.prepTime.high >>> 0).toNumber())), E.config) {
      if (!Array.isArray(E.config)) throw TypeError(".MetricsEvent.config: array expected");
      A.config = [];
      for (let g = 0; g < E.config.length; ++g) A.config[g] = String(E.config[g]);
    }
    if (E.uncaughtException != null && (A.uncaughtException = String(E.uncaughtException)), E.attributions) {
      if (!Array.isArray(E.attributions)) throw TypeError(".MetricsEvent.attributions: array expected");
      A.attributions = [];
      for (let g = 0; g < E.attributions.length; ++g) A.attributions[g] = String(E.attributions[g]);
    }
    if (E.os != null && (A.os = String(E.os)), E.timezone != null && (A.timezone = String(E.timezone)), E.headless != null && (A.headless = !!E.headless), E.isFragmentRun != null && (A.isFragmentRun = !!E.isFragmentRun), E.numPages != null && ($util.Long ? (A.numPages = $util.Long.fromValue(E.numPages)).unsigned = !1 : typeof E.numPages == "string" ? A.numPages = parseInt(E.numPages, 10) : typeof E.numPages == "number" ? A.numPages = E.numPages : typeof E.numPages == "object" && (A.numPages = new $util.LongBits(E.numPages.low >>> 0, E.numPages.high >>> 0).toNumber())), E.pageScriptHash != null && (A.pageScriptHash = String(E.pageScriptHash)), E.activeTheme != null && (A.activeTheme = String(E.activeTheme)), E.totalLoadTime != null && ($util.Long ? (A.totalLoadTime = $util.Long.fromValue(E.totalLoadTime)).unsigned = !1 : typeof E.totalLoadTime == "string" ? A.totalLoadTime = parseInt(E.totalLoadTime, 10) : typeof E.totalLoadTime == "number" ? A.totalLoadTime = E.totalLoadTime : typeof E.totalLoadTime == "object" && (A.totalLoadTime = new $util.LongBits(E.totalLoadTime.low >>> 0, E.totalLoadTime.high >>> 0).toNumber())), E.browserInfo != null) {
      if (typeof E.browserInfo != "object") throw TypeError(".MetricsEvent.browserInfo: object expected");
      A.browserInfo = $root.BrowserInfo.fromObject(E.browserInfo);
    }
    return A;
  }, o.toObject = function(E, A) {
    A || (A = {});
    let g = {};
    if ((A.arrays || A.defaults) && (g.commands = [], g.config = [], g.attributions = []), A.defaults) {
      if (g.event = "", g.anonymousId = "", g.machineIdV3 = "", g.reportHash = "", g.dev = !1, g.source = "", g.streamlitVersion = "", g.isHello = !1, g.hostedAt = "", g.owner = "", g.repo = "", g.branch = "", g.mainModule = "", g.creatorId = "", g.contextPageUrl = "", g.contextPageTitle = "", g.contextPagePath = "", g.contextPageReferrer = "", g.contextPageSearch = "", g.contextLocale = "", g.contextUserAgent = "", g.label = "", $util.Long) {
        let e = new $util.Long(0, 0, !1);
        g.execTime = A.longs === String ? e.toString() : A.longs === Number ? e.toNumber() : e;
      } else g.execTime = A.longs === String ? "0" : 0;
      if ($util.Long) {
        let e = new $util.Long(0, 0, !1);
        g.prepTime = A.longs === String ? e.toString() : A.longs === Number ? e.toNumber() : e;
      } else g.prepTime = A.longs === String ? "0" : 0;
      if (g.uncaughtException = "", g.os = "", g.timezone = "", g.headless = !1, g.isFragmentRun = !1, g.appId = "", $util.Long) {
        let e = new $util.Long(0, 0, !1);
        g.numPages = A.longs === String ? e.toString() : A.longs === Number ? e.toNumber() : e;
      } else g.numPages = A.longs === String ? "0" : 0;
      if (g.sessionId = "", g.pythonVersion = "", g.pageScriptHash = "", g.activeTheme = "", $util.Long) {
        let e = new $util.Long(0, 0, !1);
        g.totalLoadTime = A.longs === String ? e.toString() : A.longs === Number ? e.toNumber() : e;
      } else g.totalLoadTime = A.longs === String ? "0" : 0;
      g.browserInfo = null, g.machineIdV4 = "", g.serverOs = "", g.hasDisplay = !1, g.isWebdriver = !1;
    }
    if (E.event != null && E.hasOwnProperty("event") && (g.event = E.event), E.anonymousId != null && E.hasOwnProperty("anonymousId") && (g.anonymousId = E.anonymousId), E.machineIdV3 != null && E.hasOwnProperty("machineIdV3") && (g.machineIdV3 = E.machineIdV3), E.reportHash != null && E.hasOwnProperty("reportHash") && (g.reportHash = E.reportHash), E.dev != null && E.hasOwnProperty("dev") && (g.dev = E.dev), E.source != null && E.hasOwnProperty("source") && (g.source = E.source), E.streamlitVersion != null && E.hasOwnProperty("streamlitVersion") && (g.streamlitVersion = E.streamlitVersion), E.isHello != null && E.hasOwnProperty("isHello") && (g.isHello = E.isHello), E.hostedAt != null && E.hasOwnProperty("hostedAt") && (g.hostedAt = E.hostedAt), E.owner != null && E.hasOwnProperty("owner") && (g.owner = E.owner), E.repo != null && E.hasOwnProperty("repo") && (g.repo = E.repo), E.branch != null && E.hasOwnProperty("branch") && (g.branch = E.branch), E.mainModule != null && E.hasOwnProperty("mainModule") && (g.mainModule = E.mainModule), E.creatorId != null && E.hasOwnProperty("creatorId") && (g.creatorId = E.creatorId), E.contextPageUrl != null && E.hasOwnProperty("contextPageUrl") && (g.contextPageUrl = E.contextPageUrl), E.contextPageTitle != null && E.hasOwnProperty("contextPageTitle") && (g.contextPageTitle = E.contextPageTitle), E.contextPagePath != null && E.hasOwnProperty("contextPagePath") && (g.contextPagePath = E.contextPagePath), E.contextPageReferrer != null && E.hasOwnProperty("contextPageReferrer") && (g.contextPageReferrer = E.contextPageReferrer), E.contextPageSearch != null && E.hasOwnProperty("contextPageSearch") && (g.contextPageSearch = E.contextPageSearch), E.contextLocale != null && E.hasOwnProperty("contextLocale") && (g.contextLocale = E.contextLocale), E.contextUserAgent != null && E.hasOwnProperty("contextUserAgent") && (g.contextUserAgent = E.contextUserAgent), E.label != null && E.hasOwnProperty("label") && (g.label = E.label), E.commands && E.commands.length) {
      g.commands = [];
      for (let e = 0; e < E.commands.length; ++e) g.commands[e] = $root.Command.toObject(E.commands[e], A);
    }
    if (E.execTime != null && E.hasOwnProperty("execTime") && (typeof E.execTime == "number" ? g.execTime = A.longs === String ? String(E.execTime) : E.execTime : g.execTime = A.longs === String ? $util.Long.prototype.toString.call(E.execTime) : A.longs === Number ? new $util.LongBits(E.execTime.low >>> 0, E.execTime.high >>> 0).toNumber() : E.execTime), E.prepTime != null && E.hasOwnProperty("prepTime") && (typeof E.prepTime == "number" ? g.prepTime = A.longs === String ? String(E.prepTime) : E.prepTime : g.prepTime = A.longs === String ? $util.Long.prototype.toString.call(E.prepTime) : A.longs === Number ? new $util.LongBits(E.prepTime.low >>> 0, E.prepTime.high >>> 0).toNumber() : E.prepTime), E.config && E.config.length) {
      g.config = [];
      for (let e = 0; e < E.config.length; ++e) g.config[e] = E.config[e];
    }
    if (E.uncaughtException != null && E.hasOwnProperty("uncaughtException") && (g.uncaughtException = E.uncaughtException), E.attributions && E.attributions.length) {
      g.attributions = [];
      for (let e = 0; e < E.attributions.length; ++e) g.attributions[e] = E.attributions[e];
    }
    return E.os != null && E.hasOwnProperty("os") && (g.os = E.os), E.timezone != null && E.hasOwnProperty("timezone") && (g.timezone = E.timezone), E.headless != null && E.hasOwnProperty("headless") && (g.headless = E.headless), E.isFragmentRun != null && E.hasOwnProperty("isFragmentRun") && (g.isFragmentRun = E.isFragmentRun), E.appId != null && E.hasOwnProperty("appId") && (g.appId = E.appId), E.numPages != null && E.hasOwnProperty("numPages") && (typeof E.numPages == "number" ? g.numPages = A.longs === String ? String(E.numPages) : E.numPages : g.numPages = A.longs === String ? $util.Long.prototype.toString.call(E.numPages) : A.longs === Number ? new $util.LongBits(E.numPages.low >>> 0, E.numPages.high >>> 0).toNumber() : E.numPages), E.sessionId != null && E.hasOwnProperty("sessionId") && (g.sessionId = E.sessionId), E.pythonVersion != null && E.hasOwnProperty("pythonVersion") && (g.pythonVersion = E.pythonVersion), E.pageScriptHash != null && E.hasOwnProperty("pageScriptHash") && (g.pageScriptHash = E.pageScriptHash), E.activeTheme != null && E.hasOwnProperty("activeTheme") && (g.activeTheme = E.activeTheme), E.totalLoadTime != null && E.hasOwnProperty("totalLoadTime") && (typeof E.totalLoadTime == "number" ? g.totalLoadTime = A.longs === String ? String(E.totalLoadTime) : E.totalLoadTime : g.totalLoadTime = A.longs === String ? $util.Long.prototype.toString.call(E.totalLoadTime) : A.longs === Number ? new $util.LongBits(E.totalLoadTime.low >>> 0, E.totalLoadTime.high >>> 0).toNumber() : E.totalLoadTime), E.browserInfo != null && E.hasOwnProperty("browserInfo") && (g.browserInfo = $root.BrowserInfo.toObject(E.browserInfo, A)), E.machineIdV4 != null && E.hasOwnProperty("machineIdV4") && (g.machineIdV4 = E.machineIdV4), E.serverOs != null && E.hasOwnProperty("serverOs") && (g.serverOs = E.serverOs), E.hasDisplay != null && E.hasOwnProperty("hasDisplay") && (g.hasDisplay = E.hasDisplay), E.isWebdriver != null && E.hasOwnProperty("isWebdriver") && (g.isWebdriver = E.isWebdriver), g;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/MetricsEvent";
  }, o;
})();
$root.BrowserInfo = (() => {
  function o(E) {
    if (E) for (let A = Object.keys(E), g = 0; g < A.length; ++g) E[A[g]] != null && (this[A[g]] = E[A[g]]);
  }
  return o.prototype.browserName = "", o.prototype.browserVersion = "", o.prototype.deviceType = "", o.prototype.os = "", o.create = function(E) {
    return new o(E);
  }, o.encode = function(E, A) {
    return A || (A = $Writer.create()), E.browserName != null && Object.hasOwnProperty.call(E, "browserName") && A.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(E.browserName), E.browserVersion != null && Object.hasOwnProperty.call(E, "browserVersion") && A.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(E.browserVersion), E.deviceType != null && Object.hasOwnProperty.call(E, "deviceType") && A.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(E.deviceType), E.os != null && Object.hasOwnProperty.call(E, "os") && A.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(E.os), A;
  }, o.decode = function(E, A, g) {
    E instanceof $Reader || (E = $Reader.create(E));
    let e = A === void 0 ? E.len : E.pos + A, t = new $root.BrowserInfo();
    for (; E.pos < e; ) {
      let c = E.uint32();
      if (c === g) break;
      switch (c >>> 3) {
        case 1: {
          t.browserName = E.string();
          break;
        }
        case 2: {
          t.browserVersion = E.string();
          break;
        }
        case 3: {
          t.deviceType = E.string();
          break;
        }
        case 4: {
          t.os = E.string();
          break;
        }
        default:
          E.skipType(c & 7);
          break;
      }
    }
    return t;
  }, o.fromObject = function(E) {
    if (E instanceof $root.BrowserInfo) return E;
    let A = new $root.BrowserInfo();
    return E.browserName != null && (A.browserName = String(E.browserName)), E.browserVersion != null && (A.browserVersion = String(E.browserVersion)), E.deviceType != null && (A.deviceType = String(E.deviceType)), E.os != null && (A.os = String(E.os)), A;
  }, o.toObject = function(E, A) {
    A || (A = {});
    let g = {};
    return A.defaults && (g.browserName = "", g.browserVersion = "", g.deviceType = "", g.os = ""), E.browserName != null && E.hasOwnProperty("browserName") && (g.browserName = E.browserName), E.browserVersion != null && E.hasOwnProperty("browserVersion") && (g.browserVersion = E.browserVersion), E.deviceType != null && E.hasOwnProperty("deviceType") && (g.deviceType = E.deviceType), E.os != null && E.hasOwnProperty("os") && (g.os = E.os), g;
  }, o.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, o.getTypeUrl = function(E) {
    return E === void 0 && (E = "type.googleapis.com"), E + "/BrowserInfo";
  }, o;
})();
$root.openmetrics = (() => {
  const o = {};
  return o.MetricSet = (function() {
    function E(A) {
      if (this.metricFamilies = [], A) for (let g = Object.keys(A), e = 0; e < g.length; ++e) A[g[e]] != null && (this[g[e]] = A[g[e]]);
    }
    return E.prototype.metricFamilies = $util.emptyArray, E.create = function(A) {
      return new E(A);
    }, E.encode = function(A, g) {
      if (g || (g = $Writer.create()), A.metricFamilies != null && A.metricFamilies.length) for (let e = 0; e < A.metricFamilies.length; ++e) $root.openmetrics.MetricFamily.encode(A.metricFamilies[e], g.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim();
      return g;
    }, E.decode = function(A, g, e) {
      A instanceof $Reader || (A = $Reader.create(A));
      let t = g === void 0 ? A.len : A.pos + g, c = new $root.openmetrics.MetricSet();
      for (; A.pos < t; ) {
        let n = A.uint32();
        if (n === e) break;
        n >>> 3 === 1 ? (c.metricFamilies && c.metricFamilies.length || (c.metricFamilies = []), c.metricFamilies.push($root.openmetrics.MetricFamily.decode(A, A.uint32()))) : A.skipType(n & 7);
      }
      return c;
    }, E.fromObject = function(A) {
      if (A instanceof $root.openmetrics.MetricSet) return A;
      let g = new $root.openmetrics.MetricSet();
      if (A.metricFamilies) {
        if (!Array.isArray(A.metricFamilies)) throw TypeError(".openmetrics.MetricSet.metricFamilies: array expected");
        g.metricFamilies = [];
        for (let e = 0; e < A.metricFamilies.length; ++e) {
          if (typeof A.metricFamilies[e] != "object") throw TypeError(".openmetrics.MetricSet.metricFamilies: object expected");
          g.metricFamilies[e] = $root.openmetrics.MetricFamily.fromObject(A.metricFamilies[e]);
        }
      }
      return g;
    }, E.toObject = function(A, g) {
      g || (g = {});
      let e = {};
      if ((g.arrays || g.defaults) && (e.metricFamilies = []), A.metricFamilies && A.metricFamilies.length) {
        e.metricFamilies = [];
        for (let t = 0; t < A.metricFamilies.length; ++t) e.metricFamilies[t] = $root.openmetrics.MetricFamily.toObject(A.metricFamilies[t], g);
      }
      return e;
    }, E.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, E.getTypeUrl = function(A) {
      return A === void 0 && (A = "type.googleapis.com"), A + "/openmetrics.MetricSet";
    }, E;
  })(), o.MetricFamily = (function() {
    function E(A) {
      if (this.metrics = [], A) for (let g = Object.keys(A), e = 0; e < g.length; ++e) A[g[e]] != null && (this[g[e]] = A[g[e]]);
    }
    return E.prototype.name = "", E.prototype.type = 0, E.prototype.unit = "", E.prototype.help = "", E.prototype.metrics = $util.emptyArray, E.create = function(A) {
      return new E(A);
    }, E.encode = function(A, g) {
      if (g || (g = $Writer.create()), A.name != null && Object.hasOwnProperty.call(A, "name") && g.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(A.name), A.type != null && Object.hasOwnProperty.call(A, "type") && g.uint32(
        /* id 2, wireType 0 =*/
        16
      ).int32(A.type), A.unit != null && Object.hasOwnProperty.call(A, "unit") && g.uint32(
        /* id 3, wireType 2 =*/
        26
      ).string(A.unit), A.help != null && Object.hasOwnProperty.call(A, "help") && g.uint32(
        /* id 4, wireType 2 =*/
        34
      ).string(A.help), A.metrics != null && A.metrics.length) for (let e = 0; e < A.metrics.length; ++e) $root.Metric.encode(A.metrics[e], g.uint32(
        /* id 5, wireType 2 =*/
        42
      ).fork()).ldelim();
      return g;
    }, E.decode = function(A, g, e) {
      A instanceof $Reader || (A = $Reader.create(A));
      let t = g === void 0 ? A.len : A.pos + g, c = new $root.openmetrics.MetricFamily();
      for (; A.pos < t; ) {
        let n = A.uint32();
        if (n === e) break;
        switch (n >>> 3) {
          case 1: {
            c.name = A.string();
            break;
          }
          case 2: {
            c.type = A.int32();
            break;
          }
          case 3: {
            c.unit = A.string();
            break;
          }
          case 4: {
            c.help = A.string();
            break;
          }
          case 5: {
            c.metrics && c.metrics.length || (c.metrics = []), c.metrics.push($root.Metric.decode(A, A.uint32()));
            break;
          }
          default:
            A.skipType(n & 7);
            break;
        }
      }
      return c;
    }, E.fromObject = function(A) {
      if (A instanceof $root.openmetrics.MetricFamily) return A;
      let g = new $root.openmetrics.MetricFamily();
      switch (A.name != null && (g.name = String(A.name)), A.type) {
        default:
          if (typeof A.type == "number") {
            g.type = A.type;
            break;
          }
          break;
        case "UNKNOWN":
        case 0:
          g.type = 0;
          break;
        case "GAUGE":
        case 1:
          g.type = 1;
          break;
        case "COUNTER":
        case 2:
          g.type = 2;
          break;
        case "STATE_SET":
        case 3:
          g.type = 3;
          break;
        case "INFO":
        case 4:
          g.type = 4;
          break;
        case "HISTOGRAM":
        case 5:
          g.type = 5;
          break;
        case "GAUGE_HISTOGRAM":
        case 6:
          g.type = 6;
          break;
        case "SUMMARY":
        case 7:
          g.type = 7;
          break;
      }
      if (A.unit != null && (g.unit = String(A.unit)), A.help != null && (g.help = String(A.help)), A.metrics) {
        if (!Array.isArray(A.metrics)) throw TypeError(".openmetrics.MetricFamily.metrics: array expected");
        g.metrics = [];
        for (let e = 0; e < A.metrics.length; ++e) {
          if (typeof A.metrics[e] != "object") throw TypeError(".openmetrics.MetricFamily.metrics: object expected");
          g.metrics[e] = $root.Metric.fromObject(A.metrics[e]);
        }
      }
      return g;
    }, E.toObject = function(A, g) {
      g || (g = {});
      let e = {};
      if ((g.arrays || g.defaults) && (e.metrics = []), g.defaults && (e.name = "", e.type = g.enums === String ? "UNKNOWN" : 0, e.unit = "", e.help = ""), A.name != null && A.hasOwnProperty("name") && (e.name = A.name), A.type != null && A.hasOwnProperty("type") && (e.type = g.enums === String ? $root.openmetrics.MetricType[A.type] === void 0 ? A.type : $root.openmetrics.MetricType[A.type] : A.type), A.unit != null && A.hasOwnProperty("unit") && (e.unit = A.unit), A.help != null && A.hasOwnProperty("help") && (e.help = A.help), A.metrics && A.metrics.length) {
        e.metrics = [];
        for (let t = 0; t < A.metrics.length; ++t) e.metrics[t] = $root.Metric.toObject(A.metrics[t], g);
      }
      return e;
    }, E.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, E.getTypeUrl = function(A) {
      return A === void 0 && (A = "type.googleapis.com"), A + "/openmetrics.MetricFamily";
    }, E;
  })(), o.MetricType = (function() {
    const E = {}, A = Object.create(E);
    return A[E[0] = "UNKNOWN"] = 0, A[E[1] = "GAUGE"] = 1, A[E[2] = "COUNTER"] = 2, A[E[3] = "STATE_SET"] = 3, A[E[4] = "INFO"] = 4, A[E[5] = "HISTOGRAM"] = 5, A[E[6] = "GAUGE_HISTOGRAM"] = 6, A[E[7] = "SUMMARY"] = 7, A;
  })(), o.Metric = (function() {
    function E(A) {
      if (this.labels = [], this.metricPoints = [], A) for (let g = Object.keys(A), e = 0; e < g.length; ++e) A[g[e]] != null && (this[g[e]] = A[g[e]]);
    }
    return E.prototype.labels = $util.emptyArray, E.prototype.metricPoints = $util.emptyArray, E.create = function(A) {
      return new E(A);
    }, E.encode = function(A, g) {
      if (g || (g = $Writer.create()), A.labels != null && A.labels.length) for (let e = 0; e < A.labels.length; ++e) $root.openmetrics.Label.encode(A.labels[e], g.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim();
      if (A.metricPoints != null && A.metricPoints.length) for (let e = 0; e < A.metricPoints.length; ++e) $root.openmetrics.MetricPoint.encode(A.metricPoints[e], g.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim();
      return g;
    }, E.decode = function(A, g, e) {
      A instanceof $Reader || (A = $Reader.create(A));
      let t = g === void 0 ? A.len : A.pos + g, c = new $root.openmetrics.Metric();
      for (; A.pos < t; ) {
        let n = A.uint32();
        if (n === e) break;
        switch (n >>> 3) {
          case 1: {
            c.labels && c.labels.length || (c.labels = []), c.labels.push($root.openmetrics.Label.decode(A, A.uint32()));
            break;
          }
          case 2: {
            c.metricPoints && c.metricPoints.length || (c.metricPoints = []), c.metricPoints.push($root.openmetrics.MetricPoint.decode(A, A.uint32()));
            break;
          }
          default:
            A.skipType(n & 7);
            break;
        }
      }
      return c;
    }, E.fromObject = function(A) {
      if (A instanceof $root.openmetrics.Metric) return A;
      let g = new $root.openmetrics.Metric();
      if (A.labels) {
        if (!Array.isArray(A.labels)) throw TypeError(".openmetrics.Metric.labels: array expected");
        g.labels = [];
        for (let e = 0; e < A.labels.length; ++e) {
          if (typeof A.labels[e] != "object") throw TypeError(".openmetrics.Metric.labels: object expected");
          g.labels[e] = $root.openmetrics.Label.fromObject(A.labels[e]);
        }
      }
      if (A.metricPoints) {
        if (!Array.isArray(A.metricPoints)) throw TypeError(".openmetrics.Metric.metricPoints: array expected");
        g.metricPoints = [];
        for (let e = 0; e < A.metricPoints.length; ++e) {
          if (typeof A.metricPoints[e] != "object") throw TypeError(".openmetrics.Metric.metricPoints: object expected");
          g.metricPoints[e] = $root.openmetrics.MetricPoint.fromObject(A.metricPoints[e]);
        }
      }
      return g;
    }, E.toObject = function(A, g) {
      g || (g = {});
      let e = {};
      if ((g.arrays || g.defaults) && (e.labels = [], e.metricPoints = []), A.labels && A.labels.length) {
        e.labels = [];
        for (let t = 0; t < A.labels.length; ++t) e.labels[t] = $root.openmetrics.Label.toObject(A.labels[t], g);
      }
      if (A.metricPoints && A.metricPoints.length) {
        e.metricPoints = [];
        for (let t = 0; t < A.metricPoints.length; ++t) e.metricPoints[t] = $root.openmetrics.MetricPoint.toObject(A.metricPoints[t], g);
      }
      return e;
    }, E.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, E.getTypeUrl = function(A) {
      return A === void 0 && (A = "type.googleapis.com"), A + "/openmetrics.Metric";
    }, E;
  })(), o.Label = (function() {
    function E(A) {
      if (A) for (let g = Object.keys(A), e = 0; e < g.length; ++e) A[g[e]] != null && (this[g[e]] = A[g[e]]);
    }
    return E.prototype.name = "", E.prototype.value = "", E.create = function(A) {
      return new E(A);
    }, E.encode = function(A, g) {
      return g || (g = $Writer.create()), A.name != null && Object.hasOwnProperty.call(A, "name") && g.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(A.name), A.value != null && Object.hasOwnProperty.call(A, "value") && g.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(A.value), g;
    }, E.decode = function(A, g, e) {
      A instanceof $Reader || (A = $Reader.create(A));
      let t = g === void 0 ? A.len : A.pos + g, c = new $root.openmetrics.Label();
      for (; A.pos < t; ) {
        let n = A.uint32();
        if (n === e) break;
        switch (n >>> 3) {
          case 1: {
            c.name = A.string();
            break;
          }
          case 2: {
            c.value = A.string();
            break;
          }
          default:
            A.skipType(n & 7);
            break;
        }
      }
      return c;
    }, E.fromObject = function(A) {
      if (A instanceof $root.openmetrics.Label) return A;
      let g = new $root.openmetrics.Label();
      return A.name != null && (g.name = String(A.name)), A.value != null && (g.value = String(A.value)), g;
    }, E.toObject = function(A, g) {
      g || (g = {});
      let e = {};
      return g.defaults && (e.name = "", e.value = ""), A.name != null && A.hasOwnProperty("name") && (e.name = A.name), A.value != null && A.hasOwnProperty("value") && (e.value = A.value), e;
    }, E.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, E.getTypeUrl = function(A) {
      return A === void 0 && (A = "type.googleapis.com"), A + "/openmetrics.Label";
    }, E;
  })(), o.MetricPoint = (function() {
    function E(g) {
      if (g) for (let e = Object.keys(g), t = 0; t < e.length; ++t) g[e[t]] != null && (this[e[t]] = g[e[t]]);
    }
    E.prototype.unknownValue = null, E.prototype.gaugeValue = null, E.prototype.counterValue = null, E.prototype.histogramValue = null, E.prototype.stateSetValue = null, E.prototype.infoValue = null, E.prototype.summaryValue = null, E.prototype.timestamp = null;
    let A;
    return Object.defineProperty(E.prototype, "value", { get: $util.oneOfGetter(A = ["unknownValue", "gaugeValue", "counterValue", "histogramValue", "stateSetValue", "infoValue", "summaryValue"]), set: $util.oneOfSetter(A) }), E.create = function(g) {
      return new E(g);
    }, E.encode = function(g, e) {
      return e || (e = $Writer.create()), g.unknownValue != null && Object.hasOwnProperty.call(g, "unknownValue") && $root.openmetrics.UnknownValue.encode(g.unknownValue, e.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), g.gaugeValue != null && Object.hasOwnProperty.call(g, "gaugeValue") && $root.openmetrics.GaugeValue.encode(g.gaugeValue, e.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), g.counterValue != null && Object.hasOwnProperty.call(g, "counterValue") && $root.openmetrics.CounterValue.encode(g.counterValue, e.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork()).ldelim(), g.histogramValue != null && Object.hasOwnProperty.call(g, "histogramValue") && $root.openmetrics.HistogramValue.encode(g.histogramValue, e.uint32(
        /* id 4, wireType 2 =*/
        34
      ).fork()).ldelim(), g.stateSetValue != null && Object.hasOwnProperty.call(g, "stateSetValue") && $root.openmetrics.StateSetValue.encode(g.stateSetValue, e.uint32(
        /* id 5, wireType 2 =*/
        42
      ).fork()).ldelim(), g.infoValue != null && Object.hasOwnProperty.call(g, "infoValue") && $root.openmetrics.InfoValue.encode(g.infoValue, e.uint32(
        /* id 6, wireType 2 =*/
        50
      ).fork()).ldelim(), g.summaryValue != null && Object.hasOwnProperty.call(g, "summaryValue") && $root.openmetrics.SummaryValue.encode(g.summaryValue, e.uint32(
        /* id 7, wireType 2 =*/
        58
      ).fork()).ldelim(), g.timestamp != null && Object.hasOwnProperty.call(g, "timestamp") && $root.google.protobuf.Timestamp.encode(g.timestamp, e.uint32(
        /* id 8, wireType 2 =*/
        66
      ).fork()).ldelim(), e;
    }, E.decode = function(g, e, t) {
      g instanceof $Reader || (g = $Reader.create(g));
      let c = e === void 0 ? g.len : g.pos + e, n = new $root.openmetrics.MetricPoint();
      for (; g.pos < c; ) {
        let h = g.uint32();
        if (h === t) break;
        switch (h >>> 3) {
          case 1: {
            n.unknownValue = $root.openmetrics.UnknownValue.decode(g, g.uint32());
            break;
          }
          case 2: {
            n.gaugeValue = $root.openmetrics.GaugeValue.decode(g, g.uint32());
            break;
          }
          case 3: {
            n.counterValue = $root.openmetrics.CounterValue.decode(g, g.uint32());
            break;
          }
          case 4: {
            n.histogramValue = $root.openmetrics.HistogramValue.decode(g, g.uint32());
            break;
          }
          case 5: {
            n.stateSetValue = $root.openmetrics.StateSetValue.decode(g, g.uint32());
            break;
          }
          case 6: {
            n.infoValue = $root.openmetrics.InfoValue.decode(g, g.uint32());
            break;
          }
          case 7: {
            n.summaryValue = $root.openmetrics.SummaryValue.decode(g, g.uint32());
            break;
          }
          case 8: {
            n.timestamp = $root.google.protobuf.Timestamp.decode(g, g.uint32());
            break;
          }
          default:
            g.skipType(h & 7);
            break;
        }
      }
      return n;
    }, E.fromObject = function(g) {
      if (g instanceof $root.openmetrics.MetricPoint) return g;
      let e = new $root.openmetrics.MetricPoint();
      if (g.unknownValue != null) {
        if (typeof g.unknownValue != "object") throw TypeError(".openmetrics.MetricPoint.unknownValue: object expected");
        e.unknownValue = $root.openmetrics.UnknownValue.fromObject(g.unknownValue);
      }
      if (g.gaugeValue != null) {
        if (typeof g.gaugeValue != "object") throw TypeError(".openmetrics.MetricPoint.gaugeValue: object expected");
        e.gaugeValue = $root.openmetrics.GaugeValue.fromObject(g.gaugeValue);
      }
      if (g.counterValue != null) {
        if (typeof g.counterValue != "object") throw TypeError(".openmetrics.MetricPoint.counterValue: object expected");
        e.counterValue = $root.openmetrics.CounterValue.fromObject(g.counterValue);
      }
      if (g.histogramValue != null) {
        if (typeof g.histogramValue != "object") throw TypeError(".openmetrics.MetricPoint.histogramValue: object expected");
        e.histogramValue = $root.openmetrics.HistogramValue.fromObject(g.histogramValue);
      }
      if (g.stateSetValue != null) {
        if (typeof g.stateSetValue != "object") throw TypeError(".openmetrics.MetricPoint.stateSetValue: object expected");
        e.stateSetValue = $root.openmetrics.StateSetValue.fromObject(g.stateSetValue);
      }
      if (g.infoValue != null) {
        if (typeof g.infoValue != "object") throw TypeError(".openmetrics.MetricPoint.infoValue: object expected");
        e.infoValue = $root.openmetrics.InfoValue.fromObject(g.infoValue);
      }
      if (g.summaryValue != null) {
        if (typeof g.summaryValue != "object") throw TypeError(".openmetrics.MetricPoint.summaryValue: object expected");
        e.summaryValue = $root.openmetrics.SummaryValue.fromObject(g.summaryValue);
      }
      if (g.timestamp != null) {
        if (typeof g.timestamp != "object") throw TypeError(".openmetrics.MetricPoint.timestamp: object expected");
        e.timestamp = $root.google.protobuf.Timestamp.fromObject(g.timestamp);
      }
      return e;
    }, E.toObject = function(g, e) {
      e || (e = {});
      let t = {};
      return e.defaults && (t.timestamp = null), g.unknownValue != null && g.hasOwnProperty("unknownValue") && (t.unknownValue = $root.openmetrics.UnknownValue.toObject(g.unknownValue, e), e.oneofs && (t.value = "unknownValue")), g.gaugeValue != null && g.hasOwnProperty("gaugeValue") && (t.gaugeValue = $root.openmetrics.GaugeValue.toObject(g.gaugeValue, e), e.oneofs && (t.value = "gaugeValue")), g.counterValue != null && g.hasOwnProperty("counterValue") && (t.counterValue = $root.openmetrics.CounterValue.toObject(g.counterValue, e), e.oneofs && (t.value = "counterValue")), g.histogramValue != null && g.hasOwnProperty("histogramValue") && (t.histogramValue = $root.openmetrics.HistogramValue.toObject(g.histogramValue, e), e.oneofs && (t.value = "histogramValue")), g.stateSetValue != null && g.hasOwnProperty("stateSetValue") && (t.stateSetValue = $root.openmetrics.StateSetValue.toObject(g.stateSetValue, e), e.oneofs && (t.value = "stateSetValue")), g.infoValue != null && g.hasOwnProperty("infoValue") && (t.infoValue = $root.openmetrics.InfoValue.toObject(g.infoValue, e), e.oneofs && (t.value = "infoValue")), g.summaryValue != null && g.hasOwnProperty("summaryValue") && (t.summaryValue = $root.openmetrics.SummaryValue.toObject(g.summaryValue, e), e.oneofs && (t.value = "summaryValue")), g.timestamp != null && g.hasOwnProperty("timestamp") && (t.timestamp = $root.google.protobuf.Timestamp.toObject(g.timestamp, e)), t;
    }, E.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, E.getTypeUrl = function(g) {
      return g === void 0 && (g = "type.googleapis.com"), g + "/openmetrics.MetricPoint";
    }, E;
  })(), o.UnknownValue = (function() {
    function E(g) {
      if (g) for (let e = Object.keys(g), t = 0; t < e.length; ++t) g[e[t]] != null && (this[e[t]] = g[e[t]]);
    }
    E.prototype.doubleValue = null, E.prototype.intValue = null;
    let A;
    return Object.defineProperty(E.prototype, "value", { get: $util.oneOfGetter(A = ["doubleValue", "intValue"]), set: $util.oneOfSetter(A) }), E.create = function(g) {
      return new E(g);
    }, E.encode = function(g, e) {
      return e || (e = $Writer.create()), g.doubleValue != null && Object.hasOwnProperty.call(g, "doubleValue") && e.uint32(
        /* id 1, wireType 1 =*/
        9
      ).double(g.doubleValue), g.intValue != null && Object.hasOwnProperty.call(g, "intValue") && e.uint32(
        /* id 2, wireType 0 =*/
        16
      ).int64(g.intValue), e;
    }, E.decode = function(g, e, t) {
      g instanceof $Reader || (g = $Reader.create(g));
      let c = e === void 0 ? g.len : g.pos + e, n = new $root.openmetrics.UnknownValue();
      for (; g.pos < c; ) {
        let h = g.uint32();
        if (h === t) break;
        switch (h >>> 3) {
          case 1: {
            n.doubleValue = g.double();
            break;
          }
          case 2: {
            n.intValue = g.int64();
            break;
          }
          default:
            g.skipType(h & 7);
            break;
        }
      }
      return n;
    }, E.fromObject = function(g) {
      if (g instanceof $root.openmetrics.UnknownValue) return g;
      let e = new $root.openmetrics.UnknownValue();
      return g.doubleValue != null && (e.doubleValue = Number(g.doubleValue)), g.intValue != null && ($util.Long ? (e.intValue = $util.Long.fromValue(g.intValue)).unsigned = !1 : typeof g.intValue == "string" ? e.intValue = parseInt(g.intValue, 10) : typeof g.intValue == "number" ? e.intValue = g.intValue : typeof g.intValue == "object" && (e.intValue = new $util.LongBits(g.intValue.low >>> 0, g.intValue.high >>> 0).toNumber())), e;
    }, E.toObject = function(g, e) {
      e || (e = {});
      let t = {};
      return g.doubleValue != null && g.hasOwnProperty("doubleValue") && (t.doubleValue = e.json && !isFinite(g.doubleValue) ? String(g.doubleValue) : g.doubleValue, e.oneofs && (t.value = "doubleValue")), g.intValue != null && g.hasOwnProperty("intValue") && (typeof g.intValue == "number" ? t.intValue = e.longs === String ? String(g.intValue) : g.intValue : t.intValue = e.longs === String ? $util.Long.prototype.toString.call(g.intValue) : e.longs === Number ? new $util.LongBits(g.intValue.low >>> 0, g.intValue.high >>> 0).toNumber() : g.intValue, e.oneofs && (t.value = "intValue")), t;
    }, E.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, E.getTypeUrl = function(g) {
      return g === void 0 && (g = "type.googleapis.com"), g + "/openmetrics.UnknownValue";
    }, E;
  })(), o.GaugeValue = (function() {
    function E(g) {
      if (g) for (let e = Object.keys(g), t = 0; t < e.length; ++t) g[e[t]] != null && (this[e[t]] = g[e[t]]);
    }
    E.prototype.doubleValue = null, E.prototype.intValue = null;
    let A;
    return Object.defineProperty(E.prototype, "value", { get: $util.oneOfGetter(A = ["doubleValue", "intValue"]), set: $util.oneOfSetter(A) }), E.create = function(g) {
      return new E(g);
    }, E.encode = function(g, e) {
      return e || (e = $Writer.create()), g.doubleValue != null && Object.hasOwnProperty.call(g, "doubleValue") && e.uint32(
        /* id 1, wireType 1 =*/
        9
      ).double(g.doubleValue), g.intValue != null && Object.hasOwnProperty.call(g, "intValue") && e.uint32(
        /* id 2, wireType 0 =*/
        16
      ).int64(g.intValue), e;
    }, E.decode = function(g, e, t) {
      g instanceof $Reader || (g = $Reader.create(g));
      let c = e === void 0 ? g.len : g.pos + e, n = new $root.openmetrics.GaugeValue();
      for (; g.pos < c; ) {
        let h = g.uint32();
        if (h === t) break;
        switch (h >>> 3) {
          case 1: {
            n.doubleValue = g.double();
            break;
          }
          case 2: {
            n.intValue = g.int64();
            break;
          }
          default:
            g.skipType(h & 7);
            break;
        }
      }
      return n;
    }, E.fromObject = function(g) {
      if (g instanceof $root.openmetrics.GaugeValue) return g;
      let e = new $root.openmetrics.GaugeValue();
      return g.doubleValue != null && (e.doubleValue = Number(g.doubleValue)), g.intValue != null && ($util.Long ? (e.intValue = $util.Long.fromValue(g.intValue)).unsigned = !1 : typeof g.intValue == "string" ? e.intValue = parseInt(g.intValue, 10) : typeof g.intValue == "number" ? e.intValue = g.intValue : typeof g.intValue == "object" && (e.intValue = new $util.LongBits(g.intValue.low >>> 0, g.intValue.high >>> 0).toNumber())), e;
    }, E.toObject = function(g, e) {
      e || (e = {});
      let t = {};
      return g.doubleValue != null && g.hasOwnProperty("doubleValue") && (t.doubleValue = e.json && !isFinite(g.doubleValue) ? String(g.doubleValue) : g.doubleValue, e.oneofs && (t.value = "doubleValue")), g.intValue != null && g.hasOwnProperty("intValue") && (typeof g.intValue == "number" ? t.intValue = e.longs === String ? String(g.intValue) : g.intValue : t.intValue = e.longs === String ? $util.Long.prototype.toString.call(g.intValue) : e.longs === Number ? new $util.LongBits(g.intValue.low >>> 0, g.intValue.high >>> 0).toNumber() : g.intValue, e.oneofs && (t.value = "intValue")), t;
    }, E.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, E.getTypeUrl = function(g) {
      return g === void 0 && (g = "type.googleapis.com"), g + "/openmetrics.GaugeValue";
    }, E;
  })(), o.CounterValue = (function() {
    function E(g) {
      if (g) for (let e = Object.keys(g), t = 0; t < e.length; ++t) g[e[t]] != null && (this[e[t]] = g[e[t]]);
    }
    E.prototype.doubleValue = null, E.prototype.intValue = null, E.prototype.created = null, E.prototype.exemplar = null;
    let A;
    return Object.defineProperty(E.prototype, "total", { get: $util.oneOfGetter(A = ["doubleValue", "intValue"]), set: $util.oneOfSetter(A) }), E.create = function(g) {
      return new E(g);
    }, E.encode = function(g, e) {
      return e || (e = $Writer.create()), g.doubleValue != null && Object.hasOwnProperty.call(g, "doubleValue") && e.uint32(
        /* id 1, wireType 1 =*/
        9
      ).double(g.doubleValue), g.intValue != null && Object.hasOwnProperty.call(g, "intValue") && e.uint32(
        /* id 2, wireType 0 =*/
        16
      ).uint64(g.intValue), g.created != null && Object.hasOwnProperty.call(g, "created") && $root.google.protobuf.Timestamp.encode(g.created, e.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork()).ldelim(), g.exemplar != null && Object.hasOwnProperty.call(g, "exemplar") && $root.openmetrics.Exemplar.encode(g.exemplar, e.uint32(
        /* id 4, wireType 2 =*/
        34
      ).fork()).ldelim(), e;
    }, E.decode = function(g, e, t) {
      g instanceof $Reader || (g = $Reader.create(g));
      let c = e === void 0 ? g.len : g.pos + e, n = new $root.openmetrics.CounterValue();
      for (; g.pos < c; ) {
        let h = g.uint32();
        if (h === t) break;
        switch (h >>> 3) {
          case 1: {
            n.doubleValue = g.double();
            break;
          }
          case 2: {
            n.intValue = g.uint64();
            break;
          }
          case 3: {
            n.created = $root.google.protobuf.Timestamp.decode(g, g.uint32());
            break;
          }
          case 4: {
            n.exemplar = $root.openmetrics.Exemplar.decode(g, g.uint32());
            break;
          }
          default:
            g.skipType(h & 7);
            break;
        }
      }
      return n;
    }, E.fromObject = function(g) {
      if (g instanceof $root.openmetrics.CounterValue) return g;
      let e = new $root.openmetrics.CounterValue();
      if (g.doubleValue != null && (e.doubleValue = Number(g.doubleValue)), g.intValue != null && ($util.Long ? (e.intValue = $util.Long.fromValue(g.intValue)).unsigned = !0 : typeof g.intValue == "string" ? e.intValue = parseInt(g.intValue, 10) : typeof g.intValue == "number" ? e.intValue = g.intValue : typeof g.intValue == "object" && (e.intValue = new $util.LongBits(g.intValue.low >>> 0, g.intValue.high >>> 0).toNumber(!0))), g.created != null) {
        if (typeof g.created != "object") throw TypeError(".openmetrics.CounterValue.created: object expected");
        e.created = $root.google.protobuf.Timestamp.fromObject(g.created);
      }
      if (g.exemplar != null) {
        if (typeof g.exemplar != "object") throw TypeError(".openmetrics.CounterValue.exemplar: object expected");
        e.exemplar = $root.openmetrics.Exemplar.fromObject(g.exemplar);
      }
      return e;
    }, E.toObject = function(g, e) {
      e || (e = {});
      let t = {};
      return e.defaults && (t.created = null, t.exemplar = null), g.doubleValue != null && g.hasOwnProperty("doubleValue") && (t.doubleValue = e.json && !isFinite(g.doubleValue) ? String(g.doubleValue) : g.doubleValue, e.oneofs && (t.total = "doubleValue")), g.intValue != null && g.hasOwnProperty("intValue") && (typeof g.intValue == "number" ? t.intValue = e.longs === String ? String(g.intValue) : g.intValue : t.intValue = e.longs === String ? $util.Long.prototype.toString.call(g.intValue) : e.longs === Number ? new $util.LongBits(g.intValue.low >>> 0, g.intValue.high >>> 0).toNumber(!0) : g.intValue, e.oneofs && (t.total = "intValue")), g.created != null && g.hasOwnProperty("created") && (t.created = $root.google.protobuf.Timestamp.toObject(g.created, e)), g.exemplar != null && g.hasOwnProperty("exemplar") && (t.exemplar = $root.openmetrics.Exemplar.toObject(g.exemplar, e)), t;
    }, E.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, E.getTypeUrl = function(g) {
      return g === void 0 && (g = "type.googleapis.com"), g + "/openmetrics.CounterValue";
    }, E;
  })(), o.HistogramValue = (function() {
    function E(g) {
      if (this.buckets = [], g) for (let e = Object.keys(g), t = 0; t < e.length; ++t) g[e[t]] != null && (this[e[t]] = g[e[t]]);
    }
    E.prototype.doubleValue = null, E.prototype.intValue = null, E.prototype.count = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, E.prototype.created = null, E.prototype.buckets = $util.emptyArray;
    let A;
    return Object.defineProperty(E.prototype, "sum", { get: $util.oneOfGetter(A = ["doubleValue", "intValue"]), set: $util.oneOfSetter(A) }), E.create = function(g) {
      return new E(g);
    }, E.encode = function(g, e) {
      if (e || (e = $Writer.create()), g.doubleValue != null && Object.hasOwnProperty.call(g, "doubleValue") && e.uint32(
        /* id 1, wireType 1 =*/
        9
      ).double(g.doubleValue), g.intValue != null && Object.hasOwnProperty.call(g, "intValue") && e.uint32(
        /* id 2, wireType 0 =*/
        16
      ).int64(g.intValue), g.count != null && Object.hasOwnProperty.call(g, "count") && e.uint32(
        /* id 3, wireType 0 =*/
        24
      ).uint64(g.count), g.created != null && Object.hasOwnProperty.call(g, "created") && $root.google.protobuf.Timestamp.encode(g.created, e.uint32(
        /* id 4, wireType 2 =*/
        34
      ).fork()).ldelim(), g.buckets != null && g.buckets.length) for (let t = 0; t < g.buckets.length; ++t) $root.openmetrics.HistogramValue.Bucket.encode(g.buckets[t], e.uint32(
        /* id 5, wireType 2 =*/
        42
      ).fork()).ldelim();
      return e;
    }, E.decode = function(g, e, t) {
      g instanceof $Reader || (g = $Reader.create(g));
      let c = e === void 0 ? g.len : g.pos + e, n = new $root.openmetrics.HistogramValue();
      for (; g.pos < c; ) {
        let h = g.uint32();
        if (h === t) break;
        switch (h >>> 3) {
          case 1: {
            n.doubleValue = g.double();
            break;
          }
          case 2: {
            n.intValue = g.int64();
            break;
          }
          case 3: {
            n.count = g.uint64();
            break;
          }
          case 4: {
            n.created = $root.google.protobuf.Timestamp.decode(g, g.uint32());
            break;
          }
          case 5: {
            n.buckets && n.buckets.length || (n.buckets = []), n.buckets.push($root.openmetrics.HistogramValue.Bucket.decode(g, g.uint32()));
            break;
          }
          default:
            g.skipType(h & 7);
            break;
        }
      }
      return n;
    }, E.fromObject = function(g) {
      if (g instanceof $root.openmetrics.HistogramValue) return g;
      let e = new $root.openmetrics.HistogramValue();
      if (g.doubleValue != null && (e.doubleValue = Number(g.doubleValue)), g.intValue != null && ($util.Long ? (e.intValue = $util.Long.fromValue(g.intValue)).unsigned = !1 : typeof g.intValue == "string" ? e.intValue = parseInt(g.intValue, 10) : typeof g.intValue == "number" ? e.intValue = g.intValue : typeof g.intValue == "object" && (e.intValue = new $util.LongBits(g.intValue.low >>> 0, g.intValue.high >>> 0).toNumber())), g.count != null && ($util.Long ? (e.count = $util.Long.fromValue(g.count)).unsigned = !0 : typeof g.count == "string" ? e.count = parseInt(g.count, 10) : typeof g.count == "number" ? e.count = g.count : typeof g.count == "object" && (e.count = new $util.LongBits(g.count.low >>> 0, g.count.high >>> 0).toNumber(!0))), g.created != null) {
        if (typeof g.created != "object") throw TypeError(".openmetrics.HistogramValue.created: object expected");
        e.created = $root.google.protobuf.Timestamp.fromObject(g.created);
      }
      if (g.buckets) {
        if (!Array.isArray(g.buckets)) throw TypeError(".openmetrics.HistogramValue.buckets: array expected");
        e.buckets = [];
        for (let t = 0; t < g.buckets.length; ++t) {
          if (typeof g.buckets[t] != "object") throw TypeError(".openmetrics.HistogramValue.buckets: object expected");
          e.buckets[t] = $root.openmetrics.HistogramValue.Bucket.fromObject(g.buckets[t]);
        }
      }
      return e;
    }, E.toObject = function(g, e) {
      e || (e = {});
      let t = {};
      if ((e.arrays || e.defaults) && (t.buckets = []), e.defaults) {
        if ($util.Long) {
          let c = new $util.Long(0, 0, !0);
          t.count = e.longs === String ? c.toString() : e.longs === Number ? c.toNumber() : c;
        } else t.count = e.longs === String ? "0" : 0;
        t.created = null;
      }
      if (g.doubleValue != null && g.hasOwnProperty("doubleValue") && (t.doubleValue = e.json && !isFinite(g.doubleValue) ? String(g.doubleValue) : g.doubleValue, e.oneofs && (t.sum = "doubleValue")), g.intValue != null && g.hasOwnProperty("intValue") && (typeof g.intValue == "number" ? t.intValue = e.longs === String ? String(g.intValue) : g.intValue : t.intValue = e.longs === String ? $util.Long.prototype.toString.call(g.intValue) : e.longs === Number ? new $util.LongBits(g.intValue.low >>> 0, g.intValue.high >>> 0).toNumber() : g.intValue, e.oneofs && (t.sum = "intValue")), g.count != null && g.hasOwnProperty("count") && (typeof g.count == "number" ? t.count = e.longs === String ? String(g.count) : g.count : t.count = e.longs === String ? $util.Long.prototype.toString.call(g.count) : e.longs === Number ? new $util.LongBits(g.count.low >>> 0, g.count.high >>> 0).toNumber(!0) : g.count), g.created != null && g.hasOwnProperty("created") && (t.created = $root.google.protobuf.Timestamp.toObject(g.created, e)), g.buckets && g.buckets.length) {
        t.buckets = [];
        for (let c = 0; c < g.buckets.length; ++c) t.buckets[c] = $root.openmetrics.HistogramValue.Bucket.toObject(g.buckets[c], e);
      }
      return t;
    }, E.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, E.getTypeUrl = function(g) {
      return g === void 0 && (g = "type.googleapis.com"), g + "/openmetrics.HistogramValue";
    }, E.Bucket = (function() {
      function g(e) {
        if (e) for (let t = Object.keys(e), c = 0; c < t.length; ++c) e[t[c]] != null && (this[t[c]] = e[t[c]]);
      }
      return g.prototype.count = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, g.prototype.upperBound = 0, g.prototype.exemplar = null, g.create = function(e) {
        return new g(e);
      }, g.encode = function(e, t) {
        return t || (t = $Writer.create()), e.count != null && Object.hasOwnProperty.call(e, "count") && t.uint32(
          /* id 1, wireType 0 =*/
          8
        ).uint64(e.count), e.upperBound != null && Object.hasOwnProperty.call(e, "upperBound") && t.uint32(
          /* id 2, wireType 1 =*/
          17
        ).double(e.upperBound), e.exemplar != null && Object.hasOwnProperty.call(e, "exemplar") && $root.openmetrics.Exemplar.encode(e.exemplar, t.uint32(
          /* id 3, wireType 2 =*/
          26
        ).fork()).ldelim(), t;
      }, g.decode = function(e, t, c) {
        e instanceof $Reader || (e = $Reader.create(e));
        let n = t === void 0 ? e.len : e.pos + t, h = new $root.openmetrics.HistogramValue.Bucket();
        for (; e.pos < n; ) {
          let d = e.uint32();
          if (d === c) break;
          switch (d >>> 3) {
            case 1: {
              h.count = e.uint64();
              break;
            }
            case 2: {
              h.upperBound = e.double();
              break;
            }
            case 3: {
              h.exemplar = $root.openmetrics.Exemplar.decode(e, e.uint32());
              break;
            }
            default:
              e.skipType(d & 7);
              break;
          }
        }
        return h;
      }, g.fromObject = function(e) {
        if (e instanceof $root.openmetrics.HistogramValue.Bucket) return e;
        let t = new $root.openmetrics.HistogramValue.Bucket();
        if (e.count != null && ($util.Long ? (t.count = $util.Long.fromValue(e.count)).unsigned = !0 : typeof e.count == "string" ? t.count = parseInt(e.count, 10) : typeof e.count == "number" ? t.count = e.count : typeof e.count == "object" && (t.count = new $util.LongBits(e.count.low >>> 0, e.count.high >>> 0).toNumber(!0))), e.upperBound != null && (t.upperBound = Number(e.upperBound)), e.exemplar != null) {
          if (typeof e.exemplar != "object") throw TypeError(".openmetrics.HistogramValue.Bucket.exemplar: object expected");
          t.exemplar = $root.openmetrics.Exemplar.fromObject(e.exemplar);
        }
        return t;
      }, g.toObject = function(e, t) {
        t || (t = {});
        let c = {};
        if (t.defaults) {
          if ($util.Long) {
            let n = new $util.Long(0, 0, !0);
            c.count = t.longs === String ? n.toString() : t.longs === Number ? n.toNumber() : n;
          } else c.count = t.longs === String ? "0" : 0;
          c.upperBound = 0, c.exemplar = null;
        }
        return e.count != null && e.hasOwnProperty("count") && (typeof e.count == "number" ? c.count = t.longs === String ? String(e.count) : e.count : c.count = t.longs === String ? $util.Long.prototype.toString.call(e.count) : t.longs === Number ? new $util.LongBits(e.count.low >>> 0, e.count.high >>> 0).toNumber(!0) : e.count), e.upperBound != null && e.hasOwnProperty("upperBound") && (c.upperBound = t.json && !isFinite(e.upperBound) ? String(e.upperBound) : e.upperBound), e.exemplar != null && e.hasOwnProperty("exemplar") && (c.exemplar = $root.openmetrics.Exemplar.toObject(e.exemplar, t)), c;
      }, g.prototype.toJSON = function() {
        return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
      }, g.getTypeUrl = function(e) {
        return e === void 0 && (e = "type.googleapis.com"), e + "/openmetrics.HistogramValue.Bucket";
      }, g;
    })(), E;
  })(), o.Exemplar = (function() {
    function E(A) {
      if (this.label = [], A) for (let g = Object.keys(A), e = 0; e < g.length; ++e) A[g[e]] != null && (this[g[e]] = A[g[e]]);
    }
    return E.prototype.value = 0, E.prototype.timestamp = null, E.prototype.label = $util.emptyArray, E.create = function(A) {
      return new E(A);
    }, E.encode = function(A, g) {
      if (g || (g = $Writer.create()), A.value != null && Object.hasOwnProperty.call(A, "value") && g.uint32(
        /* id 1, wireType 1 =*/
        9
      ).double(A.value), A.timestamp != null && Object.hasOwnProperty.call(A, "timestamp") && $root.google.protobuf.Timestamp.encode(A.timestamp, g.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), A.label != null && A.label.length) for (let e = 0; e < A.label.length; ++e) $root.openmetrics.Label.encode(A.label[e], g.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork()).ldelim();
      return g;
    }, E.decode = function(A, g, e) {
      A instanceof $Reader || (A = $Reader.create(A));
      let t = g === void 0 ? A.len : A.pos + g, c = new $root.openmetrics.Exemplar();
      for (; A.pos < t; ) {
        let n = A.uint32();
        if (n === e) break;
        switch (n >>> 3) {
          case 1: {
            c.value = A.double();
            break;
          }
          case 2: {
            c.timestamp = $root.google.protobuf.Timestamp.decode(A, A.uint32());
            break;
          }
          case 3: {
            c.label && c.label.length || (c.label = []), c.label.push($root.openmetrics.Label.decode(A, A.uint32()));
            break;
          }
          default:
            A.skipType(n & 7);
            break;
        }
      }
      return c;
    }, E.fromObject = function(A) {
      if (A instanceof $root.openmetrics.Exemplar) return A;
      let g = new $root.openmetrics.Exemplar();
      if (A.value != null && (g.value = Number(A.value)), A.timestamp != null) {
        if (typeof A.timestamp != "object") throw TypeError(".openmetrics.Exemplar.timestamp: object expected");
        g.timestamp = $root.google.protobuf.Timestamp.fromObject(A.timestamp);
      }
      if (A.label) {
        if (!Array.isArray(A.label)) throw TypeError(".openmetrics.Exemplar.label: array expected");
        g.label = [];
        for (let e = 0; e < A.label.length; ++e) {
          if (typeof A.label[e] != "object") throw TypeError(".openmetrics.Exemplar.label: object expected");
          g.label[e] = $root.openmetrics.Label.fromObject(A.label[e]);
        }
      }
      return g;
    }, E.toObject = function(A, g) {
      g || (g = {});
      let e = {};
      if ((g.arrays || g.defaults) && (e.label = []), g.defaults && (e.value = 0, e.timestamp = null), A.value != null && A.hasOwnProperty("value") && (e.value = g.json && !isFinite(A.value) ? String(A.value) : A.value), A.timestamp != null && A.hasOwnProperty("timestamp") && (e.timestamp = $root.google.protobuf.Timestamp.toObject(A.timestamp, g)), A.label && A.label.length) {
        e.label = [];
        for (let t = 0; t < A.label.length; ++t) e.label[t] = $root.openmetrics.Label.toObject(A.label[t], g);
      }
      return e;
    }, E.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, E.getTypeUrl = function(A) {
      return A === void 0 && (A = "type.googleapis.com"), A + "/openmetrics.Exemplar";
    }, E;
  })(), o.StateSetValue = (function() {
    function E(A) {
      if (this.states = [], A) for (let g = Object.keys(A), e = 0; e < g.length; ++e) A[g[e]] != null && (this[g[e]] = A[g[e]]);
    }
    return E.prototype.states = $util.emptyArray, E.create = function(A) {
      return new E(A);
    }, E.encode = function(A, g) {
      if (g || (g = $Writer.create()), A.states != null && A.states.length) for (let e = 0; e < A.states.length; ++e) $root.openmetrics.StateSetValue.State.encode(A.states[e], g.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim();
      return g;
    }, E.decode = function(A, g, e) {
      A instanceof $Reader || (A = $Reader.create(A));
      let t = g === void 0 ? A.len : A.pos + g, c = new $root.openmetrics.StateSetValue();
      for (; A.pos < t; ) {
        let n = A.uint32();
        if (n === e) break;
        n >>> 3 === 1 ? (c.states && c.states.length || (c.states = []), c.states.push($root.openmetrics.StateSetValue.State.decode(A, A.uint32()))) : A.skipType(n & 7);
      }
      return c;
    }, E.fromObject = function(A) {
      if (A instanceof $root.openmetrics.StateSetValue) return A;
      let g = new $root.openmetrics.StateSetValue();
      if (A.states) {
        if (!Array.isArray(A.states)) throw TypeError(".openmetrics.StateSetValue.states: array expected");
        g.states = [];
        for (let e = 0; e < A.states.length; ++e) {
          if (typeof A.states[e] != "object") throw TypeError(".openmetrics.StateSetValue.states: object expected");
          g.states[e] = $root.openmetrics.StateSetValue.State.fromObject(A.states[e]);
        }
      }
      return g;
    }, E.toObject = function(A, g) {
      g || (g = {});
      let e = {};
      if ((g.arrays || g.defaults) && (e.states = []), A.states && A.states.length) {
        e.states = [];
        for (let t = 0; t < A.states.length; ++t) e.states[t] = $root.openmetrics.StateSetValue.State.toObject(A.states[t], g);
      }
      return e;
    }, E.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, E.getTypeUrl = function(A) {
      return A === void 0 && (A = "type.googleapis.com"), A + "/openmetrics.StateSetValue";
    }, E.State = (function() {
      function A(g) {
        if (g) for (let e = Object.keys(g), t = 0; t < e.length; ++t) g[e[t]] != null && (this[e[t]] = g[e[t]]);
      }
      return A.prototype.enabled = !1, A.prototype.name = "", A.create = function(g) {
        return new A(g);
      }, A.encode = function(g, e) {
        return e || (e = $Writer.create()), g.enabled != null && Object.hasOwnProperty.call(g, "enabled") && e.uint32(
          /* id 1, wireType 0 =*/
          8
        ).bool(g.enabled), g.name != null && Object.hasOwnProperty.call(g, "name") && e.uint32(
          /* id 2, wireType 2 =*/
          18
        ).string(g.name), e;
      }, A.decode = function(g, e, t) {
        g instanceof $Reader || (g = $Reader.create(g));
        let c = e === void 0 ? g.len : g.pos + e, n = new $root.openmetrics.StateSetValue.State();
        for (; g.pos < c; ) {
          let h = g.uint32();
          if (h === t) break;
          switch (h >>> 3) {
            case 1: {
              n.enabled = g.bool();
              break;
            }
            case 2: {
              n.name = g.string();
              break;
            }
            default:
              g.skipType(h & 7);
              break;
          }
        }
        return n;
      }, A.fromObject = function(g) {
        if (g instanceof $root.openmetrics.StateSetValue.State) return g;
        let e = new $root.openmetrics.StateSetValue.State();
        return g.enabled != null && (e.enabled = !!g.enabled), g.name != null && (e.name = String(g.name)), e;
      }, A.toObject = function(g, e) {
        e || (e = {});
        let t = {};
        return e.defaults && (t.enabled = !1, t.name = ""), g.enabled != null && g.hasOwnProperty("enabled") && (t.enabled = g.enabled), g.name != null && g.hasOwnProperty("name") && (t.name = g.name), t;
      }, A.prototype.toJSON = function() {
        return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
      }, A.getTypeUrl = function(g) {
        return g === void 0 && (g = "type.googleapis.com"), g + "/openmetrics.StateSetValue.State";
      }, A;
    })(), E;
  })(), o.InfoValue = (function() {
    function E(A) {
      if (this.info = [], A) for (let g = Object.keys(A), e = 0; e < g.length; ++e) A[g[e]] != null && (this[g[e]] = A[g[e]]);
    }
    return E.prototype.info = $util.emptyArray, E.create = function(A) {
      return new E(A);
    }, E.encode = function(A, g) {
      if (g || (g = $Writer.create()), A.info != null && A.info.length) for (let e = 0; e < A.info.length; ++e) $root.openmetrics.Label.encode(A.info[e], g.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim();
      return g;
    }, E.decode = function(A, g, e) {
      A instanceof $Reader || (A = $Reader.create(A));
      let t = g === void 0 ? A.len : A.pos + g, c = new $root.openmetrics.InfoValue();
      for (; A.pos < t; ) {
        let n = A.uint32();
        if (n === e) break;
        n >>> 3 === 1 ? (c.info && c.info.length || (c.info = []), c.info.push($root.openmetrics.Label.decode(A, A.uint32()))) : A.skipType(n & 7);
      }
      return c;
    }, E.fromObject = function(A) {
      if (A instanceof $root.openmetrics.InfoValue) return A;
      let g = new $root.openmetrics.InfoValue();
      if (A.info) {
        if (!Array.isArray(A.info)) throw TypeError(".openmetrics.InfoValue.info: array expected");
        g.info = [];
        for (let e = 0; e < A.info.length; ++e) {
          if (typeof A.info[e] != "object") throw TypeError(".openmetrics.InfoValue.info: object expected");
          g.info[e] = $root.openmetrics.Label.fromObject(A.info[e]);
        }
      }
      return g;
    }, E.toObject = function(A, g) {
      g || (g = {});
      let e = {};
      if ((g.arrays || g.defaults) && (e.info = []), A.info && A.info.length) {
        e.info = [];
        for (let t = 0; t < A.info.length; ++t) e.info[t] = $root.openmetrics.Label.toObject(A.info[t], g);
      }
      return e;
    }, E.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, E.getTypeUrl = function(A) {
      return A === void 0 && (A = "type.googleapis.com"), A + "/openmetrics.InfoValue";
    }, E;
  })(), o.SummaryValue = (function() {
    function E(g) {
      if (this.quantile = [], g) for (let e = Object.keys(g), t = 0; t < e.length; ++t) g[e[t]] != null && (this[e[t]] = g[e[t]]);
    }
    E.prototype.doubleValue = null, E.prototype.intValue = null, E.prototype.count = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, E.prototype.created = null, E.prototype.quantile = $util.emptyArray;
    let A;
    return Object.defineProperty(E.prototype, "sum", { get: $util.oneOfGetter(A = ["doubleValue", "intValue"]), set: $util.oneOfSetter(A) }), E.create = function(g) {
      return new E(g);
    }, E.encode = function(g, e) {
      if (e || (e = $Writer.create()), g.doubleValue != null && Object.hasOwnProperty.call(g, "doubleValue") && e.uint32(
        /* id 1, wireType 1 =*/
        9
      ).double(g.doubleValue), g.intValue != null && Object.hasOwnProperty.call(g, "intValue") && e.uint32(
        /* id 2, wireType 0 =*/
        16
      ).int64(g.intValue), g.count != null && Object.hasOwnProperty.call(g, "count") && e.uint32(
        /* id 3, wireType 0 =*/
        24
      ).uint64(g.count), g.created != null && Object.hasOwnProperty.call(g, "created") && $root.google.protobuf.Timestamp.encode(g.created, e.uint32(
        /* id 4, wireType 2 =*/
        34
      ).fork()).ldelim(), g.quantile != null && g.quantile.length) for (let t = 0; t < g.quantile.length; ++t) $root.openmetrics.SummaryValue.Quantile.encode(g.quantile[t], e.uint32(
        /* id 5, wireType 2 =*/
        42
      ).fork()).ldelim();
      return e;
    }, E.decode = function(g, e, t) {
      g instanceof $Reader || (g = $Reader.create(g));
      let c = e === void 0 ? g.len : g.pos + e, n = new $root.openmetrics.SummaryValue();
      for (; g.pos < c; ) {
        let h = g.uint32();
        if (h === t) break;
        switch (h >>> 3) {
          case 1: {
            n.doubleValue = g.double();
            break;
          }
          case 2: {
            n.intValue = g.int64();
            break;
          }
          case 3: {
            n.count = g.uint64();
            break;
          }
          case 4: {
            n.created = $root.google.protobuf.Timestamp.decode(g, g.uint32());
            break;
          }
          case 5: {
            n.quantile && n.quantile.length || (n.quantile = []), n.quantile.push($root.openmetrics.SummaryValue.Quantile.decode(g, g.uint32()));
            break;
          }
          default:
            g.skipType(h & 7);
            break;
        }
      }
      return n;
    }, E.fromObject = function(g) {
      if (g instanceof $root.openmetrics.SummaryValue) return g;
      let e = new $root.openmetrics.SummaryValue();
      if (g.doubleValue != null && (e.doubleValue = Number(g.doubleValue)), g.intValue != null && ($util.Long ? (e.intValue = $util.Long.fromValue(g.intValue)).unsigned = !1 : typeof g.intValue == "string" ? e.intValue = parseInt(g.intValue, 10) : typeof g.intValue == "number" ? e.intValue = g.intValue : typeof g.intValue == "object" && (e.intValue = new $util.LongBits(g.intValue.low >>> 0, g.intValue.high >>> 0).toNumber())), g.count != null && ($util.Long ? (e.count = $util.Long.fromValue(g.count)).unsigned = !0 : typeof g.count == "string" ? e.count = parseInt(g.count, 10) : typeof g.count == "number" ? e.count = g.count : typeof g.count == "object" && (e.count = new $util.LongBits(g.count.low >>> 0, g.count.high >>> 0).toNumber(!0))), g.created != null) {
        if (typeof g.created != "object") throw TypeError(".openmetrics.SummaryValue.created: object expected");
        e.created = $root.google.protobuf.Timestamp.fromObject(g.created);
      }
      if (g.quantile) {
        if (!Array.isArray(g.quantile)) throw TypeError(".openmetrics.SummaryValue.quantile: array expected");
        e.quantile = [];
        for (let t = 0; t < g.quantile.length; ++t) {
          if (typeof g.quantile[t] != "object") throw TypeError(".openmetrics.SummaryValue.quantile: object expected");
          e.quantile[t] = $root.openmetrics.SummaryValue.Quantile.fromObject(g.quantile[t]);
        }
      }
      return e;
    }, E.toObject = function(g, e) {
      e || (e = {});
      let t = {};
      if ((e.arrays || e.defaults) && (t.quantile = []), e.defaults) {
        if ($util.Long) {
          let c = new $util.Long(0, 0, !0);
          t.count = e.longs === String ? c.toString() : e.longs === Number ? c.toNumber() : c;
        } else t.count = e.longs === String ? "0" : 0;
        t.created = null;
      }
      if (g.doubleValue != null && g.hasOwnProperty("doubleValue") && (t.doubleValue = e.json && !isFinite(g.doubleValue) ? String(g.doubleValue) : g.doubleValue, e.oneofs && (t.sum = "doubleValue")), g.intValue != null && g.hasOwnProperty("intValue") && (typeof g.intValue == "number" ? t.intValue = e.longs === String ? String(g.intValue) : g.intValue : t.intValue = e.longs === String ? $util.Long.prototype.toString.call(g.intValue) : e.longs === Number ? new $util.LongBits(g.intValue.low >>> 0, g.intValue.high >>> 0).toNumber() : g.intValue, e.oneofs && (t.sum = "intValue")), g.count != null && g.hasOwnProperty("count") && (typeof g.count == "number" ? t.count = e.longs === String ? String(g.count) : g.count : t.count = e.longs === String ? $util.Long.prototype.toString.call(g.count) : e.longs === Number ? new $util.LongBits(g.count.low >>> 0, g.count.high >>> 0).toNumber(!0) : g.count), g.created != null && g.hasOwnProperty("created") && (t.created = $root.google.protobuf.Timestamp.toObject(g.created, e)), g.quantile && g.quantile.length) {
        t.quantile = [];
        for (let c = 0; c < g.quantile.length; ++c) t.quantile[c] = $root.openmetrics.SummaryValue.Quantile.toObject(g.quantile[c], e);
      }
      return t;
    }, E.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, E.getTypeUrl = function(g) {
      return g === void 0 && (g = "type.googleapis.com"), g + "/openmetrics.SummaryValue";
    }, E.Quantile = (function() {
      function g(e) {
        if (e) for (let t = Object.keys(e), c = 0; c < t.length; ++c) e[t[c]] != null && (this[t[c]] = e[t[c]]);
      }
      return g.prototype.quantile = 0, g.prototype.value = 0, g.create = function(e) {
        return new g(e);
      }, g.encode = function(e, t) {
        return t || (t = $Writer.create()), e.quantile != null && Object.hasOwnProperty.call(e, "quantile") && t.uint32(
          /* id 1, wireType 1 =*/
          9
        ).double(e.quantile), e.value != null && Object.hasOwnProperty.call(e, "value") && t.uint32(
          /* id 2, wireType 1 =*/
          17
        ).double(e.value), t;
      }, g.decode = function(e, t, c) {
        e instanceof $Reader || (e = $Reader.create(e));
        let n = t === void 0 ? e.len : e.pos + t, h = new $root.openmetrics.SummaryValue.Quantile();
        for (; e.pos < n; ) {
          let d = e.uint32();
          if (d === c) break;
          switch (d >>> 3) {
            case 1: {
              h.quantile = e.double();
              break;
            }
            case 2: {
              h.value = e.double();
              break;
            }
            default:
              e.skipType(d & 7);
              break;
          }
        }
        return h;
      }, g.fromObject = function(e) {
        if (e instanceof $root.openmetrics.SummaryValue.Quantile) return e;
        let t = new $root.openmetrics.SummaryValue.Quantile();
        return e.quantile != null && (t.quantile = Number(e.quantile)), e.value != null && (t.value = Number(e.value)), t;
      }, g.toObject = function(e, t) {
        t || (t = {});
        let c = {};
        return t.defaults && (c.quantile = 0, c.value = 0), e.quantile != null && e.hasOwnProperty("quantile") && (c.quantile = t.json && !isFinite(e.quantile) ? String(e.quantile) : e.quantile), e.value != null && e.hasOwnProperty("value") && (c.value = t.json && !isFinite(e.value) ? String(e.value) : e.value), c;
      }, g.prototype.toJSON = function() {
        return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
      }, g.getTypeUrl = function(e) {
        return e === void 0 && (e = "type.googleapis.com"), e + "/openmetrics.SummaryValue.Quantile";
      }, g;
    })(), E;
  })(), o;
})();
$root.google = (() => {
  const o = {};
  return o.protobuf = (function() {
    const E = {};
    return E.Timestamp = (function() {
      function A(g) {
        if (g) for (let e = Object.keys(g), t = 0; t < e.length; ++t) g[e[t]] != null && (this[e[t]] = g[e[t]]);
      }
      return A.prototype.seconds = $util.Long ? $util.Long.fromBits(0, 0, !1) : 0, A.prototype.nanos = 0, A.create = function(g) {
        return new A(g);
      }, A.encode = function(g, e) {
        return e || (e = $Writer.create()), g.seconds != null && Object.hasOwnProperty.call(g, "seconds") && e.uint32(
          /* id 1, wireType 0 =*/
          8
        ).int64(g.seconds), g.nanos != null && Object.hasOwnProperty.call(g, "nanos") && e.uint32(
          /* id 2, wireType 0 =*/
          16
        ).int32(g.nanos), e;
      }, A.decode = function(g, e, t) {
        g instanceof $Reader || (g = $Reader.create(g));
        let c = e === void 0 ? g.len : g.pos + e, n = new $root.google.protobuf.Timestamp();
        for (; g.pos < c; ) {
          let h = g.uint32();
          if (h === t) break;
          switch (h >>> 3) {
            case 1: {
              n.seconds = g.int64();
              break;
            }
            case 2: {
              n.nanos = g.int32();
              break;
            }
            default:
              g.skipType(h & 7);
              break;
          }
        }
        return n;
      }, A.fromObject = function(g) {
        if (g instanceof $root.google.protobuf.Timestamp) return g;
        let e = new $root.google.protobuf.Timestamp();
        return g.seconds != null && ($util.Long ? (e.seconds = $util.Long.fromValue(g.seconds)).unsigned = !1 : typeof g.seconds == "string" ? e.seconds = parseInt(g.seconds, 10) : typeof g.seconds == "number" ? e.seconds = g.seconds : typeof g.seconds == "object" && (e.seconds = new $util.LongBits(g.seconds.low >>> 0, g.seconds.high >>> 0).toNumber())), g.nanos != null && (e.nanos = g.nanos | 0), e;
      }, A.toObject = function(g, e) {
        e || (e = {});
        let t = {};
        if (e.defaults) {
          if ($util.Long) {
            let c = new $util.Long(0, 0, !1);
            t.seconds = e.longs === String ? c.toString() : e.longs === Number ? c.toNumber() : c;
          } else t.seconds = e.longs === String ? "0" : 0;
          t.nanos = 0;
        }
        return g.seconds != null && g.hasOwnProperty("seconds") && (typeof g.seconds == "number" ? t.seconds = e.longs === String ? String(g.seconds) : g.seconds : t.seconds = e.longs === String ? $util.Long.prototype.toString.call(g.seconds) : e.longs === Number ? new $util.LongBits(g.seconds.low >>> 0, g.seconds.high >>> 0).toNumber() : g.seconds), g.nanos != null && g.hasOwnProperty("nanos") && (t.nanos = g.nanos), t;
      }, A.prototype.toJSON = function() {
        return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
      }, A.getTypeUrl = function(g) {
        return g === void 0 && (g = "type.googleapis.com"), g + "/google.protobuf.Timestamp";
      }, A;
    })(), E;
  })(), o;
})();
$root.RootContainer = (() => {
  const o = {}, E = Object.create(o);
  return E[o[0] = "MAIN"] = 0, E[o[1] = "SIDEBAR"] = 1, E[o[2] = "EVENT"] = 2, E[o[3] = "BOTTOM"] = 3, E;
})();
typeof Promise.withResolvers > "u" && (Promise.withResolvers = () => {
  let o, E;
  const A = new Promise((g, e) => {
    o = g, E = e;
  });
  return { resolve: o, reject: E, promise: A };
});
loglevelExports.getLogger("StaticConnection");
loglevelExports.getLogger("DoInitPings");
loglevelExports.getLogger("ForwardMessageCache");
loglevelExports.getLogger("WebsocketConnection");
loglevelExports.getLogger("ConnectionManager");
loglevelExports.getLogger("DefaultStreamlitEndpoints");
const LOG$a = loglevelExports$1.getLogger("ConnectionManager");
class ConnectionManager {
  props;
  connectionState = ConnectionState$1.INITIAL;
  constructor(E) {
    this.props = E, this.connect();
  }
  /**
   * Indicates whether we're connected to the server.
   */
  isConnected() {
    return this.connectionState === ConnectionState$1.CONNECTED;
  }
  /**
   * Return the BaseUriParts for the server we're connected to,
   * if we are connected to a server.
   */
  getBaseUriParts() {
    if (this.connectionState === ConnectionState$1.CONNECTED) {
      const E = new URL("https://stlite.invalid/");
      return E.pathname = this.props.kernel.basePath, E;
    }
  }
  sendMessage(E) {
    if (this.isConnected()) {
      const A = BackMsg.create(E), g = BackMsg.encode(A).finish();
      this.props.kernel.sendWebSocketMessage(g);
    } else
      LOG$a.error(`Cannot send message when server is disconnected: ${E}`);
  }
  /**
   * Increment the runCount on our message cache, and clear entries
   * whose age is greater than the max.
   */
  incrementMessageCacheRunCount(E, A) {
  }
  getCachedMessageHashes() {
    return [];
  }
  /**
   * Establish either a WebsocketConnection or StaticConnection
   * based on query params.
   */
  async connect() {
    const E = "_stcore/stream";
    try {
      this.props.kernel.onWebSocketMessage((A) => {
        if (typeof A == "string") {
          LOG$a.error("Unexpected payload type.");
          return;
        }
        this.handleMessage(A);
      }), await this.props.kernel.loaded, console.debug("The kernel has been loaded. Start connecting."), this.props.onHostConfigResp(this.props.kernel.hostConfigResponse), await this.props.kernel.connectWebSocket("/" + E), this.setConnectionState(ConnectionState$1.CONNECTED);
    } catch (A) {
      const g = A instanceof Error ? A : new Error(`${A}`);
      LOG$a.error(`Client Error: Websocket connection - ${g.message}`), this.props.sendClientError("Failed to establish websocket connection", g.message, "Connection Manager"), this.setConnectionState(ConnectionState$1.DISCONNECTED_FOREVER, g.message);
    }
  }
  disconnect() {
  }
  setConnectionState = (E, A) => {
    this.connectionState !== E && (this.connectionState = E, this.props.connectionStateChanged(E)), A && this.props.onConnectionError({
      message: A
    });
  };
  // Stlite: the following properties and methods are copied from WebsocketConnection.tsx
  /**
   * To guarantee packet transmission order, this is the index of the last
   * dispatched incoming message.
   */
  lastDispatchedMessageIndex = -1;
  /**
   * And this is the index of the next message we receive.
   */
  nextMessageIndex = 0;
  /**
   * This dictionary stores received messages that we haven't sent out yet
   * (because we're still decoding previous messages)
   */
  messageQueue = {};
  async handleMessage(E) {
    const A = this.nextMessageIndex;
    this.nextMessageIndex += 1;
    const g = new Uint8Array(E), e = ForwardMsg.decode(g);
    if (e.type === "refHash")
      throw new Error("Unexpected cache reference message.");
    for (this.messageQueue[A] = e; this.lastDispatchedMessageIndex + 1 in this.messageQueue; ) {
      const t = this.lastDispatchedMessageIndex + 1;
      this.props.onMessage(this.messageQueue[t]), delete this.messageQueue[t], this.lastDispatchedMessageIndex = t;
    }
  }
}
const MEDIA_ENDPOINT$1 = "/media";
function resolveStliteObjectUrl(o, E) {
  return o.sendHttpRequest({
    method: "GET",
    path: E,
    headers: {},
    body: ""
  }).then(({
    statusCode: A,
    headers: g,
    body: e
  }) => {
    if (A !== 200)
      throw new Error(`Failed to fetch media object: ${A}`);
    const t = g.get("Content-Type"), c = new Blob([e], t ? {
      type: t
    } : void 0);
    return URL.createObjectURL(c);
  });
}
function resolveStliteObjectUrlIfNeeded(o, E) {
  return E.startsWith(MEDIA_ENDPOINT$1) ? resolveStliteObjectUrl(o, E) : Promise.resolve(E);
}
function resolveLogo(o, E) {
  return Promise.all([resolveStliteObjectUrlIfNeeded(o, E.image), resolveStliteObjectUrlIfNeeded(o, E.iconImage)]).then(([A, g]) => ({
    ...E,
    image: A,
    iconImage: g
  }));
}
function useStliteResolvedLogo(o) {
  const E = useStliteKernel(), [A, g] = useState(null);
  return useEffect(() => {
    if (o == null)
      return;
    let e = !1;
    const t = [];
    return resolveLogo(E, o).then((c) => {
      e || (t.push(c.image), t.push(c.iconImage), g(c));
    }), () => {
      t.forEach((c) => {
        URL.revokeObjectURL(c);
      }), e = !0;
    };
  }, [E, o]), A;
}
function useStliteMediaObjectUrl(o) {
  const E = useStliteKernel(), [A, g] = useState(o);
  return useEffect(() => {
    if (E == null || !o.startsWith(MEDIA_ENDPOINT$1))
      return;
    let e = !1;
    const t = [];
    return resolveStliteObjectUrl(E, o).then((c) => {
      e || (t.push(c), g(c));
    }), () => {
      e = !0, t.forEach((c) => {
        URL.revokeObjectURL(c);
      });
    };
  }, [E, o]), A;
}
function useStliteMediaObjects(o) {
  const [E, A] = useState(o.filter((e) => e.url == null || !e.url.startsWith(MEDIA_ENDPOINT$1))), g = useStliteKernel();
  return useEffect(() => {
    if (g == null)
      return;
    let e = !1;
    const t = [], c = o.map((n) => n.url == null || !n.url.startsWith(MEDIA_ENDPOINT$1) ? n : resolveStliteObjectUrl(g, n.url).then((h) => e ? n : (t.push(h), {
      ...n,
      url: h
    })));
    return Promise.all(c).then((n) => {
      e || A(n);
    }), () => {
      e = !0, t.forEach((n) => {
        URL.revokeObjectURL(n);
      });
    };
  }, [g, o]), E;
}
function extractCustomComponentPath(o, E) {
  const A = new URL(E), g = new URL(o, "https://stlite.invalid/");
  if (A.hostname !== g.hostname)
    return null;
  const e = g.pathname.replace(/\/$/, ""), t = new RegExp(`^${e}(/.*?$)`), c = A.pathname.match(t);
  return c == null ? null : c[1] + A.search + A.hash;
}
function getParentPath(o) {
  const E = o.split("/").slice(0, -1).join("/");
  return E.startsWith("/") ? E : "/" + E;
}
function getRelativePath(o, E, A) {
  const g = getParentPath(E);
  if (!(A.host === o && A.pathname.startsWith(g)))
    return null;
  const t = A.pathname.slice(g.length);
  return t.startsWith("/") ? t.slice(1) : t;
}
var lib = {}, activitymonitor = {}, ArrayExt;
(function(o) {
  function E(iA, aA, tA = 0, eA = -1) {
    let cA = iA.length;
    if (cA === 0)
      return -1;
    tA < 0 ? tA = Math.max(0, tA + cA) : tA = Math.min(tA, cA - 1), eA < 0 ? eA = Math.max(0, eA + cA) : eA = Math.min(eA, cA - 1);
    let DA;
    eA < tA ? DA = eA + 1 + (cA - tA) : DA = eA - tA + 1;
    for (let nA = 0; nA < DA; ++nA) {
      let wA = (tA + nA) % cA;
      if (iA[wA] === aA)
        return wA;
    }
    return -1;
  }
  o.firstIndexOf = E;
  function A(iA, aA, tA = -1, eA = 0) {
    let cA = iA.length;
    if (cA === 0)
      return -1;
    tA < 0 ? tA = Math.max(0, tA + cA) : tA = Math.min(tA, cA - 1), eA < 0 ? eA = Math.max(0, eA + cA) : eA = Math.min(eA, cA - 1);
    let DA;
    tA < eA ? DA = tA + 1 + (cA - eA) : DA = tA - eA + 1;
    for (let nA = 0; nA < DA; ++nA) {
      let wA = (tA - nA + cA) % cA;
      if (iA[wA] === aA)
        return wA;
    }
    return -1;
  }
  o.lastIndexOf = A;
  function g(iA, aA, tA = 0, eA = -1) {
    let cA = iA.length;
    if (cA === 0)
      return -1;
    tA < 0 ? tA = Math.max(0, tA + cA) : tA = Math.min(tA, cA - 1), eA < 0 ? eA = Math.max(0, eA + cA) : eA = Math.min(eA, cA - 1);
    let DA;
    eA < tA ? DA = eA + 1 + (cA - tA) : DA = eA - tA + 1;
    for (let nA = 0; nA < DA; ++nA) {
      let wA = (tA + nA) % cA;
      if (aA(iA[wA], wA))
        return wA;
    }
    return -1;
  }
  o.findFirstIndex = g;
  function e(iA, aA, tA = -1, eA = 0) {
    let cA = iA.length;
    if (cA === 0)
      return -1;
    tA < 0 ? tA = Math.max(0, tA + cA) : tA = Math.min(tA, cA - 1), eA < 0 ? eA = Math.max(0, eA + cA) : eA = Math.min(eA, cA - 1);
    let DA;
    tA < eA ? DA = tA + 1 + (cA - eA) : DA = tA - eA + 1;
    for (let nA = 0; nA < DA; ++nA) {
      let wA = (tA - nA + cA) % cA;
      if (aA(iA[wA], wA))
        return wA;
    }
    return -1;
  }
  o.findLastIndex = e;
  function t(iA, aA, tA = 0, eA = -1) {
    let cA = g(iA, aA, tA, eA);
    return cA !== -1 ? iA[cA] : void 0;
  }
  o.findFirstValue = t;
  function c(iA, aA, tA = -1, eA = 0) {
    let cA = e(iA, aA, tA, eA);
    return cA !== -1 ? iA[cA] : void 0;
  }
  o.findLastValue = c;
  function n(iA, aA, tA, eA = 0, cA = -1) {
    let DA = iA.length;
    if (DA === 0)
      return 0;
    eA < 0 ? eA = Math.max(0, eA + DA) : eA = Math.min(eA, DA - 1), cA < 0 ? cA = Math.max(0, cA + DA) : cA = Math.min(cA, DA - 1);
    let nA = eA, wA = cA - eA + 1;
    for (; wA > 0; ) {
      let lA = wA >> 1, NA = nA + lA;
      tA(iA[NA], aA) < 0 ? (nA = NA + 1, wA -= lA + 1) : wA = lA;
    }
    return nA;
  }
  o.lowerBound = n;
  function h(iA, aA, tA, eA = 0, cA = -1) {
    let DA = iA.length;
    if (DA === 0)
      return 0;
    eA < 0 ? eA = Math.max(0, eA + DA) : eA = Math.min(eA, DA - 1), cA < 0 ? cA = Math.max(0, cA + DA) : cA = Math.min(cA, DA - 1);
    let nA = eA, wA = cA - eA + 1;
    for (; wA > 0; ) {
      let lA = wA >> 1, NA = nA + lA;
      tA(iA[NA], aA) > 0 ? wA = lA : (nA = NA + 1, wA -= lA + 1);
    }
    return nA;
  }
  o.upperBound = h;
  function d(iA, aA, tA) {
    if (iA === aA)
      return !0;
    if (iA.length !== aA.length)
      return !1;
    for (let eA = 0, cA = iA.length; eA < cA; ++eA)
      if (tA ? !tA(iA[eA], aA[eA]) : iA[eA] !== aA[eA])
        return !1;
    return !0;
  }
  o.shallowEqual = d;
  function k(iA, aA = {}) {
    let { start: tA, stop: eA, step: cA } = aA;
    if (cA === void 0 && (cA = 1), cA === 0)
      throw new Error("Slice `step` cannot be zero.");
    let DA = iA.length;
    tA === void 0 ? tA = cA < 0 ? DA - 1 : 0 : tA < 0 ? tA = Math.max(tA + DA, cA < 0 ? -1 : 0) : tA >= DA && (tA = cA < 0 ? DA - 1 : DA), eA === void 0 ? eA = cA < 0 ? -1 : DA : eA < 0 ? eA = Math.max(eA + DA, cA < 0 ? -1 : 0) : eA >= DA && (eA = cA < 0 ? DA - 1 : DA);
    let nA;
    cA < 0 && eA >= tA || cA > 0 && tA >= eA ? nA = 0 : cA < 0 ? nA = Math.floor((eA - tA + 1) / cA + 1) : nA = Math.floor((eA - tA - 1) / cA + 1);
    let wA = [];
    for (let lA = 0; lA < nA; ++lA)
      wA[lA] = iA[tA + lA * cA];
    return wA;
  }
  o.slice = k;
  function p(iA, aA, tA) {
    let eA = iA.length;
    if (eA <= 1 || (aA < 0 ? aA = Math.max(0, aA + eA) : aA = Math.min(aA, eA - 1), tA < 0 ? tA = Math.max(0, tA + eA) : tA = Math.min(tA, eA - 1), aA === tA))
      return;
    let cA = iA[aA], DA = aA < tA ? 1 : -1;
    for (let nA = aA; nA !== tA; nA += DA)
      iA[nA] = iA[nA + DA];
    iA[tA] = cA;
  }
  o.move = p;
  function M(iA, aA = 0, tA = -1) {
    let eA = iA.length;
    if (!(eA <= 1))
      for (aA < 0 ? aA = Math.max(0, aA + eA) : aA = Math.min(aA, eA - 1), tA < 0 ? tA = Math.max(0, tA + eA) : tA = Math.min(tA, eA - 1); aA < tA; ) {
        let cA = iA[aA], DA = iA[tA];
        iA[aA++] = DA, iA[tA--] = cA;
      }
  }
  o.reverse = M;
  function S(iA, aA, tA = 0, eA = -1) {
    let cA = iA.length;
    if (cA <= 1 || (tA < 0 ? tA = Math.max(0, tA + cA) : tA = Math.min(tA, cA - 1), eA < 0 ? eA = Math.max(0, eA + cA) : eA = Math.min(eA, cA - 1), tA >= eA))
      return;
    let DA = eA - tA + 1;
    if (aA > 0 ? aA = aA % DA : aA < 0 && (aA = (aA % DA + DA) % DA), aA === 0)
      return;
    let nA = tA + aA;
    M(iA, tA, nA - 1), M(iA, nA, eA), M(iA, tA, eA);
  }
  o.rotate = S;
  function AA(iA, aA, tA = 0, eA = -1) {
    let cA = iA.length;
    if (cA === 0)
      return;
    tA < 0 ? tA = Math.max(0, tA + cA) : tA = Math.min(tA, cA - 1), eA < 0 ? eA = Math.max(0, eA + cA) : eA = Math.min(eA, cA - 1);
    let DA;
    eA < tA ? DA = eA + 1 + (cA - tA) : DA = eA - tA + 1;
    for (let nA = 0; nA < DA; ++nA)
      iA[(tA + nA) % cA] = aA;
  }
  o.fill = AA;
  function H(iA, aA, tA) {
    let eA = iA.length;
    aA < 0 ? aA = Math.max(0, aA + eA) : aA = Math.min(aA, eA);
    for (let cA = eA; cA > aA; --cA)
      iA[cA] = iA[cA - 1];
    iA[aA] = tA;
  }
  o.insert = H;
  function gA(iA, aA) {
    let tA = iA.length;
    if (aA < 0 && (aA += tA), aA < 0 || aA >= tA)
      return;
    let eA = iA[aA];
    for (let cA = aA + 1; cA < tA; ++cA)
      iA[cA - 1] = iA[cA];
    return iA.length = tA - 1, eA;
  }
  o.removeAt = gA;
  function CA(iA, aA, tA = 0, eA = -1) {
    let cA = E(iA, aA, tA, eA);
    return cA !== -1 && gA(iA, cA), cA;
  }
  o.removeFirstOf = CA;
  function IA(iA, aA, tA = -1, eA = 0) {
    let cA = A(iA, aA, tA, eA);
    return cA !== -1 && gA(iA, cA), cA;
  }
  o.removeLastOf = IA;
  function BA(iA, aA, tA = 0, eA = -1) {
    let cA = iA.length;
    if (cA === 0)
      return 0;
    tA < 0 ? tA = Math.max(0, tA + cA) : tA = Math.min(tA, cA - 1), eA < 0 ? eA = Math.max(0, eA + cA) : eA = Math.min(eA, cA - 1);
    let DA = 0;
    for (let nA = 0; nA < cA; ++nA)
      tA <= eA && nA >= tA && nA <= eA && iA[nA] === aA || eA < tA && (nA <= eA || nA >= tA) && iA[nA] === aA ? DA++ : DA > 0 && (iA[nA - DA] = iA[nA]);
    return DA > 0 && (iA.length = cA - DA), DA;
  }
  o.removeAllOf = BA;
  function QA(iA, aA, tA = 0, eA = -1) {
    let cA, DA = g(iA, aA, tA, eA);
    return DA !== -1 && (cA = gA(iA, DA)), { index: DA, value: cA };
  }
  o.removeFirstWhere = QA;
  function EA(iA, aA, tA = -1, eA = 0) {
    let cA, DA = e(iA, aA, tA, eA);
    return DA !== -1 && (cA = gA(iA, DA)), { index: DA, value: cA };
  }
  o.removeLastWhere = EA;
  function oA(iA, aA, tA = 0, eA = -1) {
    let cA = iA.length;
    if (cA === 0)
      return 0;
    tA < 0 ? tA = Math.max(0, tA + cA) : tA = Math.min(tA, cA - 1), eA < 0 ? eA = Math.max(0, eA + cA) : eA = Math.min(eA, cA - 1);
    let DA = 0;
    for (let nA = 0; nA < cA; ++nA)
      tA <= eA && nA >= tA && nA <= eA && aA(iA[nA], nA) || eA < tA && (nA <= eA || nA >= tA) && aA(iA[nA], nA) ? DA++ : DA > 0 && (iA[nA - DA] = iA[nA]);
    return DA > 0 && (iA.length = cA - DA), DA;
  }
  o.removeAllWhere = oA;
})(ArrayExt || (ArrayExt = {}));
function* chain(...o) {
  for (const E of o)
    yield* E;
}
function* empty() {
}
function* enumerate(o, E = 0) {
  for (const A of o)
    yield [E++, A];
}
function* filter$1(o, E) {
  let A = 0;
  for (const g of o)
    E(g, A++) && (yield g);
}
function find(o, E) {
  let A = 0;
  for (const g of o)
    if (E(g, A++))
      return g;
}
function findIndex(o, E) {
  let A = 0;
  for (const g of o)
    if (E(g, A++))
      return A - 1;
  return -1;
}
function min(o, E) {
  let A;
  for (const g of o) {
    if (A === void 0) {
      A = g;
      continue;
    }
    E(g, A) < 0 && (A = g);
  }
  return A;
}
function max(o, E) {
  let A;
  for (const g of o) {
    if (A === void 0) {
      A = g;
      continue;
    }
    E(g, A) > 0 && (A = g);
  }
  return A;
}
function minmax(o, E) {
  let A = !0, g, e;
  for (const t of o)
    A ? (g = t, e = t, A = !1) : E(t, g) < 0 ? g = t : E(t, e) > 0 && (e = t);
  return A ? void 0 : [g, e];
}
function toArray$1(o) {
  return Array.from(o);
}
function toObject(o) {
  const E = {};
  for (const [A, g] of o)
    E[A] = g;
  return E;
}
function each(o, E) {
  let A = 0;
  for (const g of o)
    if (E(g, A++) === !1)
      return;
}
function every(o, E) {
  let A = 0;
  for (const g of o)
    if (E(g, A++) === !1)
      return !1;
  return !0;
}
function some(o, E) {
  let A = 0;
  for (const g of o)
    if (E(g, A++))
      return !0;
  return !1;
}
function* map(o, E) {
  let A = 0;
  for (const g of o)
    yield E(g, A++);
}
function* range(o, E, A) {
  E === void 0 ? (E = o, o = 0, A = 1) : A === void 0 && (A = 1);
  const g = Private$2.rangeLength(o, E, A);
  for (let e = 0; e < g; e++)
    yield o + A * e;
}
var Private$2;
(function(o) {
  function E(A, g, e) {
    return e === 0 ? 1 / 0 : A > g && e > 0 || A < g && e < 0 ? 0 : Math.ceil((g - A) / e);
  }
  o.rangeLength = E;
})(Private$2 || (Private$2 = {}));
function reduce(o, E, A) {
  const g = o[Symbol.iterator]();
  let e = 0, t = g.next();
  if (t.done && A === void 0)
    throw new TypeError("Reduce of empty iterable with no initial value.");
  if (t.done)
    return A;
  let c = g.next();
  if (c.done && A === void 0)
    return t.value;
  if (c.done)
    return E(A, t.value, e++);
  let n;
  A === void 0 ? n = E(t.value, c.value, e++) : n = E(E(A, t.value, e++), c.value, e++);
  let h;
  for (; !(h = g.next()).done; )
    n = E(n, h.value, e++);
  return n;
}
function* repeat(o, E) {
  for (; 0 < E--; )
    yield o;
}
function* once(o) {
  yield o;
}
function* retro(o) {
  if (typeof o.retro == "function")
    yield* o.retro();
  else
    for (let E = o.length - 1; E > -1; E--)
      yield o[E];
}
function topologicSort(o) {
  let E = [], A = /* @__PURE__ */ new Set(), g = /* @__PURE__ */ new Map();
  for (const c of o)
    e(c);
  for (const [c] of g)
    t(c);
  return E;
  function e(c) {
    let [n, h] = c, d = g.get(h);
    d ? d.push(n) : g.set(h, [n]);
  }
  function t(c) {
    if (A.has(c))
      return;
    A.add(c);
    let n = g.get(c);
    if (n)
      for (const h of n)
        t(h);
    E.push(c);
  }
}
function* stride(o, E) {
  let A = 0;
  for (const g of o)
    A++ % E === 0 && (yield g);
}
var StringExt;
(function(o) {
  function E(c, n, h = 0) {
    let d = new Array(n.length);
    for (let k = 0, p = h, M = n.length; k < M; ++k, ++p) {
      if (p = c.indexOf(n[k], p), p === -1)
        return null;
      d[k] = p;
    }
    return d;
  }
  o.findIndices = E;
  function A(c, n, h = 0) {
    let d = E(c, n, h);
    if (!d)
      return null;
    let k = 0;
    for (let p = 0, M = d.length; p < M; ++p) {
      let S = d[p] - h;
      k += S * S;
    }
    return { score: k, indices: d };
  }
  o.matchSumOfSquares = A;
  function g(c, n, h = 0) {
    let d = E(c, n, h);
    if (!d)
      return null;
    let k = 0, p = h - 1;
    for (let M = 0, S = d.length; M < S; ++M) {
      let AA = d[M];
      k += AA - p - 1, p = AA;
    }
    return { score: k, indices: d };
  }
  o.matchSumOfDeltas = g;
  function e(c, n, h) {
    let d = [], k = 0, p = 0, M = n.length;
    for (; k < M; ) {
      let S = n[k], AA = n[k];
      for (; ++k < M && n[k] === AA + 1; )
        AA++;
      p < S && d.push(c.slice(p, S)), S < AA + 1 && d.push(h(c.slice(S, AA + 1))), p = AA + 1;
    }
    return p < c.length && d.push(c.slice(p)), d;
  }
  o.highlight = e;
  function t(c, n) {
    return c < n ? -1 : c > n ? 1 : 0;
  }
  o.cmp = t;
})(StringExt || (StringExt = {}));
function* take(o, E) {
  if (E < 1)
    return;
  const A = o[Symbol.iterator]();
  let g;
  for (; 0 < E-- && !(g = A.next()).done; )
    yield g.value;
}
function* zip(...o) {
  const E = o.map((g) => g[Symbol.iterator]());
  let A = E.map((g) => g.next());
  for (; every(A, (g) => !g.done); A = E.map((g) => g.next()))
    yield A.map((g) => g.value);
}
const index_es6$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get ArrayExt() {
    return ArrayExt;
  },
  get StringExt() {
    return StringExt;
  },
  chain,
  each,
  empty,
  enumerate,
  every,
  filter: filter$1,
  find,
  findIndex,
  map,
  max,
  min,
  minmax,
  once,
  range,
  reduce,
  repeat,
  retro,
  some,
  stride,
  take,
  toArray: toArray$1,
  toObject,
  topologicSort,
  zip
}, Symbol.toStringTag, { value: "Module" }));
var JSONExt;
(function(o) {
  o.emptyObject = Object.freeze({}), o.emptyArray = Object.freeze([]);
  function E(k) {
    return k === null || typeof k == "boolean" || typeof k == "number" || typeof k == "string";
  }
  o.isPrimitive = E;
  function A(k) {
    return Array.isArray(k);
  }
  o.isArray = A;
  function g(k) {
    return !E(k) && !A(k);
  }
  o.isObject = g;
  function e(k, p) {
    if (k === p)
      return !0;
    if (E(k) || E(p))
      return !1;
    let M = A(k), S = A(p);
    return M !== S ? !1 : M && S ? c(k, p) : n(k, p);
  }
  o.deepEqual = e;
  function t(k) {
    return E(k) ? k : A(k) ? h(k) : d(k);
  }
  o.deepCopy = t;
  function c(k, p) {
    if (k === p)
      return !0;
    if (k.length !== p.length)
      return !1;
    for (let M = 0, S = k.length; M < S; ++M)
      if (!e(k[M], p[M]))
        return !1;
    return !0;
  }
  function n(k, p) {
    if (k === p)
      return !0;
    for (let M in k)
      if (k[M] !== void 0 && !(M in p))
        return !1;
    for (let M in p)
      if (p[M] !== void 0 && !(M in k))
        return !1;
    for (let M in k) {
      let S = k[M], AA = p[M];
      if (!(S === void 0 && AA === void 0) && (S === void 0 || AA === void 0 || !e(S, AA)))
        return !1;
    }
    return !0;
  }
  function h(k) {
    let p = new Array(k.length);
    for (let M = 0, S = k.length; M < S; ++M)
      p[M] = t(k[M]);
    return p;
  }
  function d(k) {
    let p = {};
    for (let M in k) {
      let S = k[M];
      S !== void 0 && (p[M] = t(S));
    }
    return p;
  }
})(JSONExt || (JSONExt = {}));
var Private$1;
(function(o) {
  class E {
    constructor(n) {
      var h, d, k, p;
      this._activated = !1, this._promise = null, this._service = null, this.id = n.id, this.description = (h = n.description) !== null && h !== void 0 ? h : "", this.activate = n.activate, this.deactivate = (d = n.deactivate) !== null && d !== void 0 ? d : null, this.provides = (k = n.provides) !== null && k !== void 0 ? k : null, this.autoStart = (p = n.autoStart) !== null && p !== void 0 ? p : !1, this.requires = n.requires ? n.requires.slice() : [], this.optional = n.optional ? n.optional.slice() : [];
    }
    /**
     * Whether the plugin has been activated.
     */
    get activated() {
      return this._activated;
    }
    set activated(n) {
      this._activated = n;
    }
    /**
     * The resolved service for the plugin, or `null`.
     */
    get service() {
      return this._service;
    }
    set service(n) {
      this._service = n;
    }
    /**
     * The pending resolver promise, or `null`.
     */
    get promise() {
      return this._promise;
    }
    set promise(n) {
      this._promise = n;
    }
  }
  function A(c) {
    return new E(c);
  }
  o.createPluginData = A;
  function g(c, n, h) {
    const d = [...c.requires, ...c.optional], k = (M) => {
      if (M === c.provides)
        return !0;
      const S = h.get(M);
      if (!S)
        return !1;
      const AA = n.get(S), H = [...AA.requires, ...AA.optional];
      return H.length === 0 ? !1 : (p.push(S), H.some(k) ? !0 : (p.pop(), !1));
    };
    if (!c.provides || d.length === 0)
      return;
    const p = [c.id];
    if (d.some(k))
      throw new ReferenceError(`Cycle detected: ${p.join(" -> ")}.`);
  }
  o.ensureNoCycle = g;
  function e(c, n, h) {
    const d = new Array(), k = (H) => {
      const gA = n.get(H), CA = [...gA.requires, ...gA.optional];
      d.push(...CA.reduce((IA, BA) => {
        const QA = h.get(BA);
        return QA && IA.push([H, QA]), IA;
      }, []));
    };
    for (const H of n.keys())
      k(H);
    const p = d.filter((H) => H[1] === c);
    let M = 0;
    for (; p.length > M; ) {
      const H = p.length, gA = new Set(p.map((CA) => CA[0]));
      for (const CA of gA)
        d.filter((IA) => IA[1] === CA).forEach((IA) => {
          p.includes(IA) || p.push(IA);
        });
      M = H;
    }
    const S = topologicSort(p), AA = S.findIndex((H) => H === c);
    return AA === -1 ? [c] : S.slice(0, AA + 1);
  }
  o.findDependents = e;
  function t(c, n) {
    const h = /* @__PURE__ */ new Set();
    for (const d of c.keys())
      c.get(d).autoStart === !0 && h.add(d);
    if (n.startPlugins)
      for (const d of n.startPlugins)
        h.add(d);
    if (n.ignorePlugins)
      for (const d of n.ignorePlugins)
        h.delete(d);
    return Array.from(h);
  }
  o.collectStartupPlugins = t;
})(Private$1 || (Private$1 = {}));
let PromiseDelegate$1 = class {
  /**
   * Construct a new promise delegate.
   */
  constructor() {
    this.promise = new Promise((E, A) => {
      this._resolve = E, this._reject = A;
    });
  }
  /**
   * Resolve the wrapped promise with the given value.
   *
   * @param value - The value to use for resolving the promise.
   */
  resolve(E) {
    let A = this._resolve;
    A(E);
  }
  /**
   * Reject the wrapped promise with the given value.
   *
   * @reason - The reason for rejecting the promise.
   */
  reject(E) {
    let A = this._reject;
    A(E);
  }
};
function fallbackRandomValues(o) {
  let E = 0;
  for (let A = 0, g = o.length; A < g; ++A)
    A % 4 === 0 && (E = Math.random() * 4294967295 >>> 0), o[A] = E & 255, E >>>= 8;
}
var Random;
(function(o) {
  o.getRandomValues = (() => {
    const E = typeof window < "u" && (window.crypto || window.msCrypto) || null;
    return E && typeof E.getRandomValues == "function" ? function(g) {
      return E.getRandomValues(g);
    } : fallbackRandomValues;
  })();
})(Random || (Random = {}));
function uuid4Factory(o) {
  const E = new Uint8Array(16), A = new Array(256);
  for (let g = 0; g < 16; ++g)
    A[g] = "0" + g.toString(16);
  for (let g = 16; g < 256; ++g)
    A[g] = g.toString(16);
  return function() {
    return o(E), E[6] = 64 | E[6] & 15, E[8] = 128 | E[8] & 63, A[E[0]] + A[E[1]] + A[E[2]] + A[E[3]] + "-" + A[E[4]] + A[E[5]] + "-" + A[E[6]] + A[E[7]] + "-" + A[E[8]] + A[E[9]] + "-" + A[E[10]] + A[E[11]] + A[E[12]] + A[E[13]] + A[E[14]] + A[E[15]];
  };
}
var UUID;
(function(o) {
  o.uuid4 = uuid4Factory(Random.getRandomValues);
})(UUID || (UUID = {}));
let Signal$1 = class {
  /**
   * Construct a new signal.
   *
   * @param sender - The sender which owns the signal.
   */
  constructor(E) {
    this.sender = E;
  }
  /**
   * Connect a slot to the signal.
   *
   * @param slot - The slot to invoke when the signal is emitted.
   *
   * @param thisArg - The `this` context for the slot. If provided,
   *   this must be a non-primitive object.
   *
   * @returns `true` if the connection succeeds, `false` otherwise.
   */
  connect(E, A) {
    return Private.connect(this, E, A);
  }
  /**
   * Disconnect a slot from the signal.
   *
   * @param slot - The slot to disconnect from the signal.
   *
   * @param thisArg - The `this` context for the slot. If provided,
   *   this must be a non-primitive object.
   *
   * @returns `true` if the connection is removed, `false` otherwise.
   */
  disconnect(E, A) {
    return Private.disconnect(this, E, A);
  }
  /**
   * Emit the signal and invoke the connected slots.
   *
   * @param args - The args to pass to the connected slots.
   *
   * #### Notes
   * Slots are invoked synchronously in connection order.
   *
   * Exceptions thrown by connected slots will be caught and logged.
   */
  emit(E) {
    Private.emit(this, E);
  }
};
(function(o) {
  function E(h, d) {
    Private.disconnectBetween(h, d);
  }
  o.disconnectBetween = E;
  function A(h) {
    Private.disconnectSender(h);
  }
  o.disconnectSender = A;
  function g(h) {
    Private.disconnectReceiver(h);
  }
  o.disconnectReceiver = g;
  function e(h) {
    Private.disconnectAll(h);
  }
  o.disconnectAll = e;
  function t(h) {
    Private.disconnectAll(h);
  }
  o.clearData = t;
  function c() {
    return Private.exceptionHandler;
  }
  o.getExceptionHandler = c;
  function n(h) {
    let d = Private.exceptionHandler;
    return Private.exceptionHandler = h, d;
  }
  o.setExceptionHandler = n;
})(Signal$1 || (Signal$1 = {}));
class Stream extends Signal$1 {
  constructor() {
    super(...arguments), this._pending = new PromiseDelegate$1();
  }
  /**
   * Return an async iterator that yields every emission.
   */
  async *[Symbol.asyncIterator]() {
    let E = this._pending;
    for (; ; )
      try {
        const { args: A, next: g } = await E.promise;
        E = g, yield A;
      } catch {
        return;
      }
  }
  /**
   * Emit the signal, invoke the connected slots, and yield the emission.
   *
   * @param args - The args to pass to the connected slots.
   */
  emit(E) {
    const A = this._pending, g = this._pending = new PromiseDelegate$1();
    A.resolve({ args: E, next: g }), super.emit(E);
  }
  /**
   * Stop the stream's async iteration.
   */
  stop() {
    this._pending.promise.catch(() => {
    }), this._pending.reject("stop"), this._pending = new PromiseDelegate$1();
  }
}
var Private;
(function(o) {
  o.exceptionHandler = (IA) => {
    console.error(IA);
  };
  function E(IA, BA, QA) {
    QA = QA || void 0;
    let EA = h.get(IA.sender);
    if (EA || (EA = [], h.set(IA.sender, EA)), M(EA, IA, BA, QA))
      return !1;
    let oA = QA || BA, iA = d.get(oA);
    iA || (iA = [], d.set(oA, iA));
    let aA = { signal: IA, slot: BA, thisArg: QA };
    return EA.push(aA), iA.push(aA), !0;
  }
  o.connect = E;
  function A(IA, BA, QA) {
    QA = QA || void 0;
    let EA = h.get(IA.sender);
    if (!EA || EA.length === 0)
      return !1;
    let oA = M(EA, IA, BA, QA);
    if (!oA)
      return !1;
    let iA = QA || BA, aA = d.get(iA);
    return oA.signal = null, AA(EA), AA(aA), !0;
  }
  o.disconnect = A;
  function g(IA, BA) {
    let QA = h.get(IA);
    if (!QA || QA.length === 0)
      return;
    let EA = d.get(BA);
    if (!(!EA || EA.length === 0)) {
      for (const oA of EA)
        oA.signal && oA.signal.sender === IA && (oA.signal = null);
      AA(QA), AA(EA);
    }
  }
  o.disconnectBetween = g;
  function e(IA) {
    let BA = h.get(IA);
    if (!(!BA || BA.length === 0)) {
      for (const QA of BA) {
        if (!QA.signal)
          continue;
        let EA = QA.thisArg || QA.slot;
        QA.signal = null, AA(d.get(EA));
      }
      AA(BA);
    }
  }
  o.disconnectSender = e;
  function t(IA) {
    let BA = d.get(IA);
    if (!(!BA || BA.length === 0)) {
      for (const QA of BA) {
        if (!QA.signal)
          continue;
        let EA = QA.signal.sender;
        QA.signal = null, AA(h.get(EA));
      }
      AA(BA);
    }
  }
  o.disconnectReceiver = t;
  function c(IA) {
    e(IA), t(IA);
  }
  o.disconnectAll = c;
  function n(IA, BA) {
    let QA = h.get(IA.sender);
    if (!(!QA || QA.length === 0))
      for (let EA = 0, oA = QA.length; EA < oA; ++EA) {
        let iA = QA[EA];
        iA.signal === IA && S(iA, BA);
      }
  }
  o.emit = n;
  const h = /* @__PURE__ */ new WeakMap(), d = /* @__PURE__ */ new WeakMap(), k = /* @__PURE__ */ new Set(), p = typeof requestAnimationFrame == "function" ? requestAnimationFrame : setImmediate;
  function M(IA, BA, QA, EA) {
    return find(IA, (oA) => oA.signal === BA && oA.slot === QA && oA.thisArg === EA);
  }
  function S(IA, BA) {
    let { signal: QA, slot: EA, thisArg: oA } = IA;
    try {
      EA.call(oA, QA.sender, BA);
    } catch (iA) {
      o.exceptionHandler(iA);
    }
  }
  function AA(IA) {
    k.size === 0 && p(H), k.add(IA);
  }
  function H() {
    k.forEach(gA), k.clear();
  }
  function gA(IA) {
    ArrayExt.removeAllWhere(IA, CA);
  }
  function CA(IA) {
    return IA.signal === null;
  }
})(Private || (Private = {}));
const index_es6 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get Signal() {
    return Signal$1;
  },
  Stream
}, Symbol.toStringTag, { value: "Module" })), require$$0$2 = /* @__PURE__ */ getAugmentedNamespace(index_es6);
var hasRequiredActivitymonitor;
function requireActivitymonitor() {
  if (hasRequiredActivitymonitor) return activitymonitor;
  hasRequiredActivitymonitor = 1, Object.defineProperty(activitymonitor, "__esModule", { value: !0 }), activitymonitor.ActivityMonitor = void 0;
  const o = require$$0$2;
  class E {
    /**
     * Construct a new activity monitor.
     */
    constructor(g) {
      this._timer = -1, this._timeout = -1, this._isDisposed = !1, this._activityStopped = new o.Signal(this), g.signal.connect(this._onSignalFired, this), this._timeout = g.timeout || 1e3;
    }
    /**
     * A signal emitted when activity has ceased.
     */
    get activityStopped() {
      return this._activityStopped;
    }
    /**
     * The timeout associated with the monitor, in milliseconds.
     */
    get timeout() {
      return this._timeout;
    }
    set timeout(g) {
      this._timeout = g;
    }
    /**
     * Test whether the monitor has been disposed.
     *
     * #### Notes
     * This is a read-only property.
     */
    get isDisposed() {
      return this._isDisposed;
    }
    /**
     * Dispose of the resources used by the activity monitor.
     */
    dispose() {
      this._isDisposed || (this._isDisposed = !0, o.Signal.clearData(this));
    }
    /**
     * A signal handler for the monitored signal.
     */
    _onSignalFired(g, e) {
      clearTimeout(this._timer), this._sender = g, this._args = e, this._timer = setTimeout(() => {
        this._activityStopped.emit({
          sender: this._sender,
          args: this._args
        });
      }, this._timeout);
    }
  }
  return activitymonitor.ActivityMonitor = E, activitymonitor;
}
var interfaces = {}, hasRequiredInterfaces;
function requireInterfaces() {
  return hasRequiredInterfaces || (hasRequiredInterfaces = 1, Object.defineProperty(interfaces, "__esModule", { value: !0 })), interfaces;
}
var lru = {}, hasRequiredLru;
function requireLru() {
  if (hasRequiredLru) return lru;
  hasRequiredLru = 1, Object.defineProperty(lru, "__esModule", { value: !0 }), lru.LruCache = void 0;
  const o = 128;
  class E {
    constructor(g = {}) {
      this._map = /* @__PURE__ */ new Map(), this._maxSize = g?.maxSize || o;
    }
    /**
     * Return the current size of the cache.
     */
    get size() {
      return this._map.size;
    }
    /**
     * Clear the values in the cache.
     */
    clear() {
      this._map.clear();
    }
    /**
     * Get a value (or null) from the cache, pushing the item to the front of the cache.
     */
    get(g) {
      const e = this._map.get(g) || null;
      return e != null && (this._map.delete(g), this._map.set(g, e)), e;
    }
    /**
     * Set a value in the cache, potentially evicting an old item.
     */
    set(g, e) {
      this._map.size >= this._maxSize && this._map.delete(this._map.keys().next().value), this._map.set(g, e);
    }
  }
  return lru.LruCache = E, lru;
}
var markdowncodeblocks = {}, hasRequiredMarkdowncodeblocks;
function requireMarkdowncodeblocks() {
  if (hasRequiredMarkdowncodeblocks) return markdowncodeblocks;
  hasRequiredMarkdowncodeblocks = 1, Object.defineProperty(markdowncodeblocks, "__esModule", { value: !0 }), markdowncodeblocks.MarkdownCodeBlocks = void 0;
  var o;
  return (function(E) {
    E.CODE_BLOCK_MARKER = "```";
    const A = [
      ".markdown",
      ".mdown",
      ".mkdn",
      ".md",
      ".mkd",
      ".mdwn",
      ".mdtxt",
      ".mdtext",
      ".text",
      ".txt",
      ".Rmd"
    ];
    class g {
      constructor(n) {
        this.startLine = n, this.code = "", this.endLine = -1;
      }
    }
    E.MarkdownCodeBlock = g;
    function e(c) {
      return A.indexOf(c) > -1;
    }
    E.isMarkdown = e;
    function t(c) {
      if (!c || c === "")
        return [];
      const n = c.split(`
`), h = [];
      let d = null;
      for (let k = 0; k < n.length; k++) {
        const p = n[k], M = p.indexOf(E.CODE_BLOCK_MARKER) === 0, S = d != null;
        if (!(!M && !S))
          if (S)
            d && (M ? (d.endLine = k - 1, h.push(d), d = null) : d.code += p + `
`);
          else {
            d = new g(k);
            const AA = p.indexOf(E.CODE_BLOCK_MARKER), H = p.lastIndexOf(E.CODE_BLOCK_MARKER);
            AA !== H && (d.code = p.substring(AA + E.CODE_BLOCK_MARKER.length, H), d.endLine = k, h.push(d), d = null);
          }
      }
      return h;
    }
    E.findMarkdownCodeBlocks = t;
  })(o || (markdowncodeblocks.MarkdownCodeBlocks = o = {})), markdowncodeblocks;
}
var pageconfig = {}, dist$2 = { exports: {} };
const require$$0$1 = /* @__PURE__ */ getAugmentedNamespace(index_es6$1);
var dist$1 = dist$2.exports, hasRequiredDist$1;
function requireDist$1() {
  return hasRequiredDist$1 || (hasRequiredDist$1 = 1, (function(o, E) {
    (function(A, g) {
      g(E, require$$0$1);
    })(dist$1, (function(A, g) {
      A.JSONExt = void 0, (function(p) {
        p.emptyObject = Object.freeze({}), p.emptyArray = Object.freeze([]);
        function M(EA) {
          return EA === null || typeof EA == "boolean" || typeof EA == "number" || typeof EA == "string";
        }
        p.isPrimitive = M;
        function S(EA) {
          return Array.isArray(EA);
        }
        p.isArray = S;
        function AA(EA) {
          return !M(EA) && !S(EA);
        }
        p.isObject = AA;
        function H(EA, oA) {
          if (EA === oA)
            return !0;
          if (M(EA) || M(oA))
            return !1;
          let iA = S(EA), aA = S(oA);
          return iA !== aA ? !1 : iA && aA ? CA(EA, oA) : IA(EA, oA);
        }
        p.deepEqual = H;
        function gA(EA) {
          return M(EA) ? EA : S(EA) ? BA(EA) : QA(EA);
        }
        p.deepCopy = gA;
        function CA(EA, oA) {
          if (EA === oA)
            return !0;
          if (EA.length !== oA.length)
            return !1;
          for (let iA = 0, aA = EA.length; iA < aA; ++iA)
            if (!H(EA[iA], oA[iA]))
              return !1;
          return !0;
        }
        function IA(EA, oA) {
          if (EA === oA)
            return !0;
          for (let iA in EA)
            if (EA[iA] !== void 0 && !(iA in oA))
              return !1;
          for (let iA in oA)
            if (oA[iA] !== void 0 && !(iA in EA))
              return !1;
          for (let iA in EA) {
            let aA = EA[iA], tA = oA[iA];
            if (!(aA === void 0 && tA === void 0) && (aA === void 0 || tA === void 0 || !H(aA, tA)))
              return !1;
          }
          return !0;
        }
        function BA(EA) {
          let oA = new Array(EA.length);
          for (let iA = 0, aA = EA.length; iA < aA; ++iA)
            oA[iA] = gA(EA[iA]);
          return oA;
        }
        function QA(EA) {
          let oA = {};
          for (let iA in EA) {
            let aA = EA[iA];
            aA !== void 0 && (oA[iA] = gA(aA));
          }
          return oA;
        }
      })(A.JSONExt || (A.JSONExt = {}));
      class e {
        constructor() {
          this._types = [], this._values = [];
        }
        /**
         * Get an array of the MIME types contained within the dataset.
         *
         * @returns A new array of the MIME types, in order of insertion.
         */
        types() {
          return this._types.slice();
        }
        /**
         * Test whether the dataset has an entry for the given type.
         *
         * @param mime - The MIME type of interest.
         *
         * @returns `true` if the dataset contains a value for the given
         *   MIME type, `false` otherwise.
         */
        hasData(M) {
          return this._types.indexOf(M) !== -1;
        }
        /**
         * Get the data value for the given MIME type.
         *
         * @param mime - The MIME type of interest.
         *
         * @returns The value for the given MIME type, or `undefined` if
         *   the dataset does not contain a value for the type.
         */
        getData(M) {
          let S = this._types.indexOf(M);
          return S !== -1 ? this._values[S] : void 0;
        }
        /**
         * Set the data value for the given MIME type.
         *
         * @param mime - The MIME type of interest.
         *
         * @param data - The data value for the given MIME type.
         *
         * #### Notes
         * This will overwrite any previous entry for the MIME type.
         */
        setData(M, S) {
          this.clearData(M), this._types.push(M), this._values.push(S);
        }
        /**
         * Remove the data entry for the given MIME type.
         *
         * @param mime - The MIME type of interest.
         *
         * #### Notes
         * This is a no-op if there is no entry for the given MIME type.
         */
        clearData(M) {
          let S = this._types.indexOf(M);
          S !== -1 && (this._types.splice(S, 1), this._values.splice(S, 1));
        }
        /**
         * Remove all data entries from the dataset.
         */
        clear() {
          this._types.length = 0, this._values.length = 0;
        }
      }
      class t {
        constructor(M = {}) {
          this._application = null, this._validatePlugin = () => !0, this._plugins = /* @__PURE__ */ new Map(), this._services = /* @__PURE__ */ new Map(), M.validatePlugin && (console.info("Plugins may be rejected by the custom validation plugin method."), this._validatePlugin = M.validatePlugin);
        }
        /**
         * The application object.
         *
         * It will be provided as first argument to the
         * plugins activation and deactivation functions.
         *
         * It can only be set once.
         *
         * By default, it is `null`.
         */
        get application() {
          return this._application;
        }
        set application(M) {
          if (this._application !== null)
            throw Error("PluginRegistry.application is already set. It cannot be overridden.");
          this._application = M;
        }
        /**
         * The list of all the deferred plugins.
         */
        get deferredPlugins() {
          return Array.from(this._plugins).filter(([M, S]) => S.autoStart === "defer").map(([M, S]) => M);
        }
        /**
         * Get a plugin description.
         *
         * @param id - The ID of the plugin of interest.
         *
         * @returns The plugin description.
         */
        getPluginDescription(M) {
          var S, AA;
          return (AA = (S = this._plugins.get(M)) === null || S === void 0 ? void 0 : S.description) !== null && AA !== void 0 ? AA : "";
        }
        /**
         * Test whether a plugin is registered with the application.
         *
         * @param id - The ID of the plugin of interest.
         *
         * @returns `true` if the plugin is registered, `false` otherwise.
         */
        hasPlugin(M) {
          return this._plugins.has(M);
        }
        /**
         * Test whether a plugin is activated with the application.
         *
         * @param id - The ID of the plugin of interest.
         *
         * @returns `true` if the plugin is activated, `false` otherwise.
         */
        isPluginActivated(M) {
          var S, AA;
          return (AA = (S = this._plugins.get(M)) === null || S === void 0 ? void 0 : S.activated) !== null && AA !== void 0 ? AA : !1;
        }
        /**
         * List the IDs of the plugins registered with the application.
         *
         * @returns A new array of the registered plugin IDs.
         */
        listPlugins() {
          return Array.from(this._plugins.keys());
        }
        /**
         * Register a plugin with the application.
         *
         * @param plugin - The plugin to register.
         *
         * #### Notes
         * An error will be thrown if a plugin with the same ID is already
         * registered, or if the plugin has a circular dependency.
         *
         * If the plugin provides a service which has already been provided
         * by another plugin, the new service will override the old service.
         */
        registerPlugin(M) {
          if (this._plugins.has(M.id))
            throw new TypeError(`Plugin '${M.id}' is already registered.`);
          if (!this._validatePlugin(M))
            throw new Error(`Plugin '${M.id}' is not valid.`);
          const S = c.createPluginData(M);
          c.ensureNoCycle(S, this._plugins, this._services), S.provides && this._services.set(S.provides, S.id), this._plugins.set(S.id, S);
        }
        /**
         * Register multiple plugins with the application.
         *
         * @param plugins - The plugins to register.
         *
         * #### Notes
         * This calls `registerPlugin()` for each of the given plugins.
         */
        registerPlugins(M) {
          for (const S of M)
            this.registerPlugin(S);
        }
        /**
         * Deregister a plugin with the application.
         *
         * @param id - The ID of the plugin of interest.
         *
         * @param force - Whether to deregister the plugin even if it is active.
         */
        deregisterPlugin(M, S) {
          const AA = this._plugins.get(M);
          if (AA) {
            if (AA.activated && !S)
              throw new Error(`Plugin '${M}' is still active.`);
            this._plugins.delete(M);
          }
        }
        /**
         * Activate the plugin with the given ID.
         *
         * @param id - The ID of the plugin of interest.
         *
         * @returns A promise which resolves when the plugin is activated
         *   or rejects with an error if it cannot be activated.
         */
        async activatePlugin(M) {
          const S = this._plugins.get(M);
          if (!S)
            throw new ReferenceError(`Plugin '${M}' is not registered.`);
          if (S.activated)
            return;
          if (S.promise)
            return S.promise;
          const AA = S.requires.map((gA) => this.resolveRequiredService(gA)), H = S.optional.map((gA) => this.resolveOptionalService(gA));
          return S.promise = Promise.all([...AA, ...H]).then((gA) => S.activate.apply(void 0, [this.application, ...gA])).then((gA) => {
            S.service = gA, S.activated = !0, S.promise = null;
          }).catch((gA) => {
            throw S.promise = null, gA;
          }), S.promise;
        }
        /**
         * Activate all the deferred plugins.
         *
         * @returns A promise which will resolve when each plugin is activated
         * or rejects with an error if one cannot be activated.
         */
        async activatePlugins(M, S = {}) {
          switch (M) {
            case "defer": {
              const AA = this.deferredPlugins.filter((H) => this._plugins.get(H).autoStart).map((H) => this.activatePlugin(H));
              await Promise.all(AA);
              break;
            }
            case "startUp": {
              const H = c.collectStartupPlugins(this._plugins, S).map(async (gA) => {
                try {
                  return await this.activatePlugin(gA);
                } catch (CA) {
                  console.error(`Plugin '${gA}' failed to activate.`, CA);
                }
              });
              await Promise.all(H);
              break;
            }
          }
        }
        /**
         * Deactivate the plugin and its downstream dependents if and only if the
         * plugin and its dependents all support `deactivate`.
         *
         * @param id - The ID of the plugin of interest.
         *
         * @returns A list of IDs of downstream plugins deactivated with this one.
         */
        async deactivatePlugin(M) {
          const S = this._plugins.get(M);
          if (!S)
            throw new ReferenceError(`Plugin '${M}' is not registered.`);
          if (!S.activated)
            return [];
          if (!S.deactivate)
            throw new TypeError(`Plugin '${M}'#deactivate() method missing`);
          const AA = c.findDependents(M, this._plugins, this._services), H = AA.map((gA) => this._plugins.get(gA));
          for (const gA of H)
            if (!gA.deactivate)
              throw new TypeError(`Plugin ${gA.id}#deactivate() method missing (depends on ${M})`);
          for (const gA of H) {
            const CA = [...gA.requires, ...gA.optional].map((IA) => {
              const BA = this._services.get(IA);
              return BA ? this._plugins.get(BA).service : null;
            });
            await gA.deactivate(this.application, ...CA), gA.service = null, gA.activated = !1;
          }
          return AA.pop(), AA;
        }
        /**
         * Resolve a required service of a given type.
         *
         * @param token - The token for the service type of interest.
         *
         * @returns A promise which resolves to an instance of the requested
         *   service, or rejects with an error if it cannot be resolved.
         *
         * #### Notes
         * Services are singletons. The same instance will be returned each
         * time a given service token is resolved.
         *
         * If the plugin which provides the service has not been activated,
         * resolving the service will automatically activate the plugin.
         *
         * User code will not typically call this method directly. Instead,
         * the required services for the user's plugins will be resolved
         * automatically when the plugin is activated.
         */
        async resolveRequiredService(M) {
          const S = this._services.get(M);
          if (!S)
            throw new TypeError(`No provider for: ${M.name}.`);
          const AA = this._plugins.get(S);
          return AA.activated || await this.activatePlugin(S), AA.service;
        }
        /**
         * Resolve an optional service of a given type.
         *
         * @param token - The token for the service type of interest.
         *
         * @returns A promise which resolves to an instance of the requested
         *   service, or `null` if it cannot be resolved.
         *
         * #### Notes
         * Services are singletons. The same instance will be returned each
         * time a given service token is resolved.
         *
         * If the plugin which provides the service has not been activated,
         * resolving the service will automatically activate the plugin.
         *
         * User code will not typically call this method directly. Instead,
         * the optional services for the user's plugins will be resolved
         * automatically when the plugin is activated.
         */
        async resolveOptionalService(M) {
          const S = this._services.get(M);
          if (!S)
            return null;
          const AA = this._plugins.get(S);
          if (!AA.activated)
            try {
              await this.activatePlugin(S);
            } catch (H) {
              return console.error(H), null;
            }
          return AA.service;
        }
      }
      var c;
      (function(p) {
        class M {
          constructor(IA) {
            var BA, QA, EA, oA;
            this._activated = !1, this._promise = null, this._service = null, this.id = IA.id, this.description = (BA = IA.description) !== null && BA !== void 0 ? BA : "", this.activate = IA.activate, this.deactivate = (QA = IA.deactivate) !== null && QA !== void 0 ? QA : null, this.provides = (EA = IA.provides) !== null && EA !== void 0 ? EA : null, this.autoStart = (oA = IA.autoStart) !== null && oA !== void 0 ? oA : !1, this.requires = IA.requires ? IA.requires.slice() : [], this.optional = IA.optional ? IA.optional.slice() : [];
          }
          /**
           * Whether the plugin has been activated.
           */
          get activated() {
            return this._activated;
          }
          set activated(IA) {
            this._activated = IA;
          }
          /**
           * The resolved service for the plugin, or `null`.
           */
          get service() {
            return this._service;
          }
          set service(IA) {
            this._service = IA;
          }
          /**
           * The pending resolver promise, or `null`.
           */
          get promise() {
            return this._promise;
          }
          set promise(IA) {
            this._promise = IA;
          }
        }
        function S(CA) {
          return new M(CA);
        }
        p.createPluginData = S;
        function AA(CA, IA, BA) {
          const QA = [...CA.requires, ...CA.optional], EA = (iA) => {
            if (iA === CA.provides)
              return !0;
            const aA = BA.get(iA);
            if (!aA)
              return !1;
            const tA = IA.get(aA), eA = [...tA.requires, ...tA.optional];
            return eA.length === 0 ? !1 : (oA.push(aA), eA.some(EA) ? !0 : (oA.pop(), !1));
          };
          if (!CA.provides || QA.length === 0)
            return;
          const oA = [CA.id];
          if (QA.some(EA))
            throw new ReferenceError(`Cycle detected: ${oA.join(" -> ")}.`);
        }
        p.ensureNoCycle = AA;
        function H(CA, IA, BA) {
          const QA = new Array(), EA = (eA) => {
            const cA = IA.get(eA), DA = [...cA.requires, ...cA.optional];
            QA.push(...DA.reduce((nA, wA) => {
              const lA = BA.get(wA);
              return lA && nA.push([eA, lA]), nA;
            }, []));
          };
          for (const eA of IA.keys())
            EA(eA);
          const oA = QA.filter((eA) => eA[1] === CA);
          let iA = 0;
          for (; oA.length > iA; ) {
            const eA = oA.length, cA = new Set(oA.map((DA) => DA[0]));
            for (const DA of cA)
              QA.filter((nA) => nA[1] === DA).forEach((nA) => {
                oA.includes(nA) || oA.push(nA);
              });
            iA = eA;
          }
          const aA = g.topologicSort(oA), tA = aA.findIndex((eA) => eA === CA);
          return tA === -1 ? [CA] : aA.slice(0, tA + 1);
        }
        p.findDependents = H;
        function gA(CA, IA) {
          const BA = /* @__PURE__ */ new Set();
          for (const QA of CA.keys())
            CA.get(QA).autoStart === !0 && BA.add(QA);
          if (IA.startPlugins)
            for (const QA of IA.startPlugins)
              BA.add(QA);
          if (IA.ignorePlugins)
            for (const QA of IA.ignorePlugins)
              BA.delete(QA);
          return Array.from(BA);
        }
        p.collectStartupPlugins = gA;
      })(c || (c = {}));
      class n {
        /**
         * Construct a new promise delegate.
         */
        constructor() {
          this.promise = new Promise((M, S) => {
            this._resolve = M, this._reject = S;
          });
        }
        /**
         * Resolve the wrapped promise with the given value.
         *
         * @param value - The value to use for resolving the promise.
         */
        resolve(M) {
          let S = this._resolve;
          S(M);
        }
        /**
         * Reject the wrapped promise with the given value.
         *
         * @reason - The reason for rejecting the promise.
         */
        reject(M) {
          let S = this._reject;
          S(M);
        }
      }
      class h {
        /**
         * Construct a new token.
         *
         * @param name - A human readable name for the token.
         * @param description - Token purpose description for documentation.
         */
        constructor(M, S) {
          this.name = M, this.description = S ?? "", this._tokenStructuralPropertyT = null;
        }
      }
      function d(p) {
        let M = 0;
        for (let S = 0, AA = p.length; S < AA; ++S)
          S % 4 === 0 && (M = Math.random() * 4294967295 >>> 0), p[S] = M & 255, M >>>= 8;
      }
      A.Random = void 0, (function(p) {
        p.getRandomValues = (() => {
          const M = typeof window < "u" && (window.crypto || window.msCrypto) || null;
          return M && typeof M.getRandomValues == "function" ? function(AA) {
            return M.getRandomValues(AA);
          } : d;
        })();
      })(A.Random || (A.Random = {}));
      function k(p) {
        const M = new Uint8Array(16), S = new Array(256);
        for (let AA = 0; AA < 16; ++AA)
          S[AA] = "0" + AA.toString(16);
        for (let AA = 16; AA < 256; ++AA)
          S[AA] = AA.toString(16);
        return function() {
          return p(M), M[6] = 64 | M[6] & 15, M[8] = 128 | M[8] & 63, S[M[0]] + S[M[1]] + S[M[2]] + S[M[3]] + "-" + S[M[4]] + S[M[5]] + "-" + S[M[6]] + S[M[7]] + "-" + S[M[8]] + S[M[9]] + "-" + S[M[10]] + S[M[11]] + S[M[12]] + S[M[13]] + S[M[14]] + S[M[15]];
        };
      }
      A.UUID = void 0, (function(p) {
        p.uuid4 = k(A.Random.getRandomValues);
      })(A.UUID || (A.UUID = {})), A.MimeData = e, A.PluginRegistry = t, A.PromiseDelegate = n, A.Token = h;
    }));
  })(dist$2, dist$2.exports)), dist$2.exports;
}
var minimist, hasRequiredMinimist;
function requireMinimist() {
  if (hasRequiredMinimist) return minimist;
  hasRequiredMinimist = 1;
  function o(g, e) {
    var t = g;
    e.slice(0, -1).forEach(function(n) {
      t = t[n] || {};
    });
    var c = e[e.length - 1];
    return c in t;
  }
  function E(g) {
    return typeof g == "number" || /^0x[0-9a-f]+$/i.test(g) ? !0 : /^[-+]?(?:\d+(?:\.\d*)?|\.\d+)(e[-+]?\d+)?$/.test(g);
  }
  function A(g, e) {
    return e === "constructor" && typeof g[e] == "function" || e === "__proto__";
  }
  return minimist = function(g, e) {
    e || (e = {});
    var t = {
      bools: {},
      strings: {},
      unknownFn: null
    };
    typeof e.unknown == "function" && (t.unknownFn = e.unknown), typeof e.boolean == "boolean" && e.boolean ? t.allBools = !0 : [].concat(e.boolean).filter(Boolean).forEach(function(iA) {
      t.bools[iA] = !0;
    });
    var c = {};
    function n(iA) {
      return c[iA].some(function(aA) {
        return t.bools[aA];
      });
    }
    Object.keys(e.alias || {}).forEach(function(iA) {
      c[iA] = [].concat(e.alias[iA]), c[iA].forEach(function(aA) {
        c[aA] = [iA].concat(c[iA].filter(function(tA) {
          return aA !== tA;
        }));
      });
    }), [].concat(e.string).filter(Boolean).forEach(function(iA) {
      t.strings[iA] = !0, c[iA] && [].concat(c[iA]).forEach(function(aA) {
        t.strings[aA] = !0;
      });
    });
    var h = e.default || {}, d = { _: [] };
    function k(iA, aA) {
      return t.allBools && /^--[^=]+$/.test(aA) || t.strings[iA] || t.bools[iA] || c[iA];
    }
    function p(iA, aA, tA) {
      for (var eA = iA, cA = 0; cA < aA.length - 1; cA++) {
        var DA = aA[cA];
        if (A(eA, DA))
          return;
        eA[DA] === void 0 && (eA[DA] = {}), (eA[DA] === Object.prototype || eA[DA] === Number.prototype || eA[DA] === String.prototype) && (eA[DA] = {}), eA[DA] === Array.prototype && (eA[DA] = []), eA = eA[DA];
      }
      var nA = aA[aA.length - 1];
      A(eA, nA) || ((eA === Object.prototype || eA === Number.prototype || eA === String.prototype) && (eA = {}), eA === Array.prototype && (eA = []), eA[nA] === void 0 || t.bools[nA] || typeof eA[nA] == "boolean" ? eA[nA] = tA : Array.isArray(eA[nA]) ? eA[nA].push(tA) : eA[nA] = [eA[nA], tA]);
    }
    function M(iA, aA, tA) {
      if (!(tA && t.unknownFn && !k(iA, tA) && t.unknownFn(tA) === !1)) {
        var eA = !t.strings[iA] && E(aA) ? Number(aA) : aA;
        p(d, iA.split("."), eA), (c[iA] || []).forEach(function(cA) {
          p(d, cA.split("."), eA);
        });
      }
    }
    Object.keys(t.bools).forEach(function(iA) {
      M(iA, h[iA] === void 0 ? !1 : h[iA]);
    });
    var S = [];
    g.indexOf("--") !== -1 && (S = g.slice(g.indexOf("--") + 1), g = g.slice(0, g.indexOf("--")));
    for (var AA = 0; AA < g.length; AA++) {
      var H = g[AA], gA, CA;
      if (/^--.+=/.test(H)) {
        var IA = H.match(/^--([^=]+)=([\s\S]*)$/);
        gA = IA[1];
        var BA = IA[2];
        t.bools[gA] && (BA = BA !== "false"), M(gA, BA, H);
      } else if (/^--no-.+/.test(H))
        gA = H.match(/^--no-(.+)/)[1], M(gA, !1, H);
      else if (/^--.+/.test(H))
        gA = H.match(/^--(.+)/)[1], CA = g[AA + 1], CA !== void 0 && !/^(-|--)[^-]/.test(CA) && !t.bools[gA] && !t.allBools && (!c[gA] || !n(gA)) ? (M(gA, CA, H), AA += 1) : /^(true|false)$/.test(CA) ? (M(gA, CA === "true", H), AA += 1) : M(gA, t.strings[gA] ? "" : !0, H);
      else if (/^-[^-]+/.test(H)) {
        for (var QA = H.slice(1, -1).split(""), EA = !1, oA = 0; oA < QA.length; oA++) {
          if (CA = H.slice(oA + 2), CA === "-") {
            M(QA[oA], CA, H);
            continue;
          }
          if (/[A-Za-z]/.test(QA[oA]) && CA[0] === "=") {
            M(QA[oA], CA.slice(1), H), EA = !0;
            break;
          }
          if (/[A-Za-z]/.test(QA[oA]) && /-?\d+(\.\d*)?(e-?\d+)?$/.test(CA)) {
            M(QA[oA], CA, H), EA = !0;
            break;
          }
          if (QA[oA + 1] && QA[oA + 1].match(/\W/)) {
            M(QA[oA], H.slice(oA + 2), H), EA = !0;
            break;
          } else
            M(QA[oA], t.strings[QA[oA]] ? "" : !0, H);
        }
        gA = H.slice(-1)[0], !EA && gA !== "-" && (g[AA + 1] && !/^(-|--)[^-]/.test(g[AA + 1]) && !t.bools[gA] && (!c[gA] || !n(gA)) ? (M(gA, g[AA + 1], H), AA += 1) : g[AA + 1] && /^(true|false)$/.test(g[AA + 1]) ? (M(gA, g[AA + 1] === "true", H), AA += 1) : M(gA, t.strings[gA] ? "" : !0, H));
      } else if ((!t.unknownFn || t.unknownFn(H) !== !1) && d._.push(t.strings._ || !E(H) ? H : Number(H)), e.stopEarly) {
        d._.push.apply(d._, g.slice(AA + 1));
        break;
      }
    }
    return Object.keys(h).forEach(function(iA) {
      o(d, iA.split(".")) || (p(d, iA.split("."), h[iA]), (c[iA] || []).forEach(function(aA) {
        p(d, aA.split("."), h[iA]);
      }));
    }), e["--"] ? d["--"] = S.slice() : S.forEach(function(iA) {
      d._.push(iA);
    }), d;
  }, minimist;
}
var url = {}, pathBrowserify, hasRequiredPathBrowserify;
function requirePathBrowserify() {
  if (hasRequiredPathBrowserify) return pathBrowserify;
  hasRequiredPathBrowserify = 1;
  function o(e) {
    if (typeof e != "string")
      throw new TypeError("Path must be a string. Received " + JSON.stringify(e));
  }
  function E(e, t) {
    for (var c = "", n = 0, h = -1, d = 0, k, p = 0; p <= e.length; ++p) {
      if (p < e.length)
        k = e.charCodeAt(p);
      else {
        if (k === 47)
          break;
        k = 47;
      }
      if (k === 47) {
        if (!(h === p - 1 || d === 1)) if (h !== p - 1 && d === 2) {
          if (c.length < 2 || n !== 2 || c.charCodeAt(c.length - 1) !== 46 || c.charCodeAt(c.length - 2) !== 46) {
            if (c.length > 2) {
              var M = c.lastIndexOf("/");
              if (M !== c.length - 1) {
                M === -1 ? (c = "", n = 0) : (c = c.slice(0, M), n = c.length - 1 - c.lastIndexOf("/")), h = p, d = 0;
                continue;
              }
            } else if (c.length === 2 || c.length === 1) {
              c = "", n = 0, h = p, d = 0;
              continue;
            }
          }
          t && (c.length > 0 ? c += "/.." : c = "..", n = 2);
        } else
          c.length > 0 ? c += "/" + e.slice(h + 1, p) : c = e.slice(h + 1, p), n = p - h - 1;
        h = p, d = 0;
      } else k === 46 && d !== -1 ? ++d : d = -1;
    }
    return c;
  }
  function A(e, t) {
    var c = t.dir || t.root, n = t.base || (t.name || "") + (t.ext || "");
    return c ? c === t.root ? c + n : c + e + n : n;
  }
  var g = {
    // path.resolve([from ...], to)
    resolve: function() {
      for (var t = "", c = !1, n, h = arguments.length - 1; h >= -1 && !c; h--) {
        var d;
        h >= 0 ? d = arguments[h] : (n === void 0 && (n = process.cwd()), d = n), o(d), d.length !== 0 && (t = d + "/" + t, c = d.charCodeAt(0) === 47);
      }
      return t = E(t, !c), c ? t.length > 0 ? "/" + t : "/" : t.length > 0 ? t : ".";
    },
    normalize: function(t) {
      if (o(t), t.length === 0) return ".";
      var c = t.charCodeAt(0) === 47, n = t.charCodeAt(t.length - 1) === 47;
      return t = E(t, !c), t.length === 0 && !c && (t = "."), t.length > 0 && n && (t += "/"), c ? "/" + t : t;
    },
    isAbsolute: function(t) {
      return o(t), t.length > 0 && t.charCodeAt(0) === 47;
    },
    join: function() {
      if (arguments.length === 0)
        return ".";
      for (var t, c = 0; c < arguments.length; ++c) {
        var n = arguments[c];
        o(n), n.length > 0 && (t === void 0 ? t = n : t += "/" + n);
      }
      return t === void 0 ? "." : g.normalize(t);
    },
    relative: function(t, c) {
      if (o(t), o(c), t === c || (t = g.resolve(t), c = g.resolve(c), t === c)) return "";
      for (var n = 1; n < t.length && t.charCodeAt(n) === 47; ++n)
        ;
      for (var h = t.length, d = h - n, k = 1; k < c.length && c.charCodeAt(k) === 47; ++k)
        ;
      for (var p = c.length, M = p - k, S = d < M ? d : M, AA = -1, H = 0; H <= S; ++H) {
        if (H === S) {
          if (M > S) {
            if (c.charCodeAt(k + H) === 47)
              return c.slice(k + H + 1);
            if (H === 0)
              return c.slice(k + H);
          } else d > S && (t.charCodeAt(n + H) === 47 ? AA = H : H === 0 && (AA = 0));
          break;
        }
        var gA = t.charCodeAt(n + H), CA = c.charCodeAt(k + H);
        if (gA !== CA)
          break;
        gA === 47 && (AA = H);
      }
      var IA = "";
      for (H = n + AA + 1; H <= h; ++H)
        (H === h || t.charCodeAt(H) === 47) && (IA.length === 0 ? IA += ".." : IA += "/..");
      return IA.length > 0 ? IA + c.slice(k + AA) : (k += AA, c.charCodeAt(k) === 47 && ++k, c.slice(k));
    },
    _makeLong: function(t) {
      return t;
    },
    dirname: function(t) {
      if (o(t), t.length === 0) return ".";
      for (var c = t.charCodeAt(0), n = c === 47, h = -1, d = !0, k = t.length - 1; k >= 1; --k)
        if (c = t.charCodeAt(k), c === 47) {
          if (!d) {
            h = k;
            break;
          }
        } else
          d = !1;
      return h === -1 ? n ? "/" : "." : n && h === 1 ? "//" : t.slice(0, h);
    },
    basename: function(t, c) {
      if (c !== void 0 && typeof c != "string") throw new TypeError('"ext" argument must be a string');
      o(t);
      var n = 0, h = -1, d = !0, k;
      if (c !== void 0 && c.length > 0 && c.length <= t.length) {
        if (c.length === t.length && c === t) return "";
        var p = c.length - 1, M = -1;
        for (k = t.length - 1; k >= 0; --k) {
          var S = t.charCodeAt(k);
          if (S === 47) {
            if (!d) {
              n = k + 1;
              break;
            }
          } else
            M === -1 && (d = !1, M = k + 1), p >= 0 && (S === c.charCodeAt(p) ? --p === -1 && (h = k) : (p = -1, h = M));
        }
        return n === h ? h = M : h === -1 && (h = t.length), t.slice(n, h);
      } else {
        for (k = t.length - 1; k >= 0; --k)
          if (t.charCodeAt(k) === 47) {
            if (!d) {
              n = k + 1;
              break;
            }
          } else h === -1 && (d = !1, h = k + 1);
        return h === -1 ? "" : t.slice(n, h);
      }
    },
    extname: function(t) {
      o(t);
      for (var c = -1, n = 0, h = -1, d = !0, k = 0, p = t.length - 1; p >= 0; --p) {
        var M = t.charCodeAt(p);
        if (M === 47) {
          if (!d) {
            n = p + 1;
            break;
          }
          continue;
        }
        h === -1 && (d = !1, h = p + 1), M === 46 ? c === -1 ? c = p : k !== 1 && (k = 1) : c !== -1 && (k = -1);
      }
      return c === -1 || h === -1 || // We saw a non-dot character immediately before the dot
      k === 0 || // The (right-most) trimmed path component is exactly '..'
      k === 1 && c === h - 1 && c === n + 1 ? "" : t.slice(c, h);
    },
    format: function(t) {
      if (t === null || typeof t != "object")
        throw new TypeError('The "pathObject" argument must be of type Object. Received type ' + typeof t);
      return A("/", t);
    },
    parse: function(t) {
      o(t);
      var c = { root: "", dir: "", base: "", ext: "", name: "" };
      if (t.length === 0) return c;
      var n = t.charCodeAt(0), h = n === 47, d;
      h ? (c.root = "/", d = 1) : d = 0;
      for (var k = -1, p = 0, M = -1, S = !0, AA = t.length - 1, H = 0; AA >= d; --AA) {
        if (n = t.charCodeAt(AA), n === 47) {
          if (!S) {
            p = AA + 1;
            break;
          }
          continue;
        }
        M === -1 && (S = !1, M = AA + 1), n === 46 ? k === -1 ? k = AA : H !== 1 && (H = 1) : k !== -1 && (H = -1);
      }
      return k === -1 || M === -1 || // We saw a non-dot character immediately before the dot
      H === 0 || // The (right-most) trimmed path component is exactly '..'
      H === 1 && k === M - 1 && k === p + 1 ? M !== -1 && (p === 0 && h ? c.base = c.name = t.slice(1, M) : c.base = c.name = t.slice(p, M)) : (p === 0 && h ? (c.name = t.slice(1, k), c.base = t.slice(1, M)) : (c.name = t.slice(p, k), c.base = t.slice(p, M)), c.ext = t.slice(k, M)), p > 0 ? c.dir = t.slice(0, p - 1) : h && (c.dir = "/"), c;
    },
    sep: "/",
    delimiter: ":",
    win32: null,
    posix: null
  };
  return g.posix = g, pathBrowserify = g, pathBrowserify;
}
var requiresPort, hasRequiredRequiresPort;
function requireRequiresPort() {
  return hasRequiredRequiresPort || (hasRequiredRequiresPort = 1, requiresPort = function(E, A) {
    if (A = A.split(":")[0], E = +E, !E) return !1;
    switch (A) {
      case "http":
      case "ws":
        return E !== 80;
      case "https":
      case "wss":
        return E !== 443;
      case "ftp":
        return E !== 21;
      case "gopher":
        return E !== 70;
      case "file":
        return !1;
    }
    return E !== 0;
  }), requiresPort;
}
var querystringify = {}, hasRequiredQuerystringify;
function requireQuerystringify() {
  if (hasRequiredQuerystringify) return querystringify;
  hasRequiredQuerystringify = 1;
  var o = Object.prototype.hasOwnProperty, E;
  function A(c) {
    try {
      return decodeURIComponent(c.replace(/\+/g, " "));
    } catch {
      return null;
    }
  }
  function g(c) {
    try {
      return encodeURIComponent(c);
    } catch {
      return null;
    }
  }
  function e(c) {
    for (var n = /([^=?#&]+)=?([^&]*)/g, h = {}, d; d = n.exec(c); ) {
      var k = A(d[1]), p = A(d[2]);
      k === null || p === null || k in h || (h[k] = p);
    }
    return h;
  }
  function t(c, n) {
    n = n || "";
    var h = [], d, k;
    typeof n != "string" && (n = "?");
    for (k in c)
      if (o.call(c, k)) {
        if (d = c[k], !d && (d === null || d === E || isNaN(d)) && (d = ""), k = g(k), d = g(d), k === null || d === null) continue;
        h.push(k + "=" + d);
      }
    return h.length ? n + h.join("&") : "";
  }
  return querystringify.stringify = t, querystringify.parse = e, querystringify;
}
var urlParse, hasRequiredUrlParse;
function requireUrlParse() {
  if (hasRequiredUrlParse) return urlParse;
  hasRequiredUrlParse = 1;
  var o = requireRequiresPort(), E = requireQuerystringify(), A = /^[\x00-\x20\u00a0\u1680\u2000-\u200a\u2028\u2029\u202f\u205f\u3000\ufeff]+/, g = /[\n\r\t]/g, e = /^[A-Za-z][A-Za-z0-9+-.]*:\/\//, t = /:\d+$/, c = /^([a-z][a-z0-9.+-]*:)?(\/\/)?([\\/]+)?([\S\s]*)/i, n = /^[a-zA-Z]:/;
  function h(IA) {
    return (IA || "").toString().replace(A, "");
  }
  var d = [
    ["#", "hash"],
    // Extract from the back.
    ["?", "query"],
    // Extract from the back.
    function(BA, QA) {
      return M(QA.protocol) ? BA.replace(/\\/g, "/") : BA;
    },
    ["/", "pathname"],
    // Extract from the back.
    ["@", "auth", 1],
    // Extract from the front.
    [NaN, "host", void 0, 1, 1],
    // Set left over value.
    [/:(\d*)$/, "port", void 0, 1],
    // RegExp the back.
    [NaN, "hostname", void 0, 1, 1]
    // Set left over.
  ], k = { hash: 1, query: 1 };
  function p(IA) {
    var BA;
    typeof window < "u" ? BA = window : typeof commonjsGlobal$1 < "u" ? BA = commonjsGlobal$1 : typeof self < "u" ? BA = self : BA = {};
    var QA = BA.location || {};
    IA = IA || QA;
    var EA = {}, oA = typeof IA, iA;
    if (IA.protocol === "blob:")
      EA = new H(unescape(IA.pathname), {});
    else if (oA === "string") {
      EA = new H(IA, {});
      for (iA in k) delete EA[iA];
    } else if (oA === "object") {
      for (iA in IA)
        iA in k || (EA[iA] = IA[iA]);
      EA.slashes === void 0 && (EA.slashes = e.test(IA.href));
    }
    return EA;
  }
  function M(IA) {
    return IA === "file:" || IA === "ftp:" || IA === "http:" || IA === "https:" || IA === "ws:" || IA === "wss:";
  }
  function S(IA, BA) {
    IA = h(IA), IA = IA.replace(g, ""), BA = BA || {};
    var QA = c.exec(IA), EA = QA[1] ? QA[1].toLowerCase() : "", oA = !!QA[2], iA = !!QA[3], aA = 0, tA;
    return oA ? iA ? (tA = QA[2] + QA[3] + QA[4], aA = QA[2].length + QA[3].length) : (tA = QA[2] + QA[4], aA = QA[2].length) : iA ? (tA = QA[3] + QA[4], aA = QA[3].length) : tA = QA[4], EA === "file:" ? aA >= 2 && (tA = tA.slice(2)) : M(EA) ? tA = QA[4] : EA ? oA && (tA = tA.slice(2)) : aA >= 2 && M(BA.protocol) && (tA = QA[4]), {
      protocol: EA,
      slashes: oA || M(EA),
      slashesCount: aA,
      rest: tA
    };
  }
  function AA(IA, BA) {
    if (IA === "") return BA;
    for (var QA = (BA || "/").split("/").slice(0, -1).concat(IA.split("/")), EA = QA.length, oA = QA[EA - 1], iA = !1, aA = 0; EA--; )
      QA[EA] === "." ? QA.splice(EA, 1) : QA[EA] === ".." ? (QA.splice(EA, 1), aA++) : aA && (EA === 0 && (iA = !0), QA.splice(EA, 1), aA--);
    return iA && QA.unshift(""), (oA === "." || oA === "..") && QA.push(""), QA.join("/");
  }
  function H(IA, BA, QA) {
    if (IA = h(IA), IA = IA.replace(g, ""), !(this instanceof H))
      return new H(IA, BA, QA);
    var EA, oA, iA, aA, tA, eA, cA = d.slice(), DA = typeof BA, nA = this, wA = 0;
    for (DA !== "object" && DA !== "string" && (QA = BA, BA = null), QA && typeof QA != "function" && (QA = E.parse), BA = p(BA), oA = S(IA || "", BA), EA = !oA.protocol && !oA.slashes, nA.slashes = oA.slashes || EA && BA.slashes, nA.protocol = oA.protocol || BA.protocol || "", IA = oA.rest, (oA.protocol === "file:" && (oA.slashesCount !== 2 || n.test(IA)) || !oA.slashes && (oA.protocol || oA.slashesCount < 2 || !M(nA.protocol))) && (cA[3] = [/(.*)/, "pathname"]); wA < cA.length; wA++) {
      if (aA = cA[wA], typeof aA == "function") {
        IA = aA(IA, nA);
        continue;
      }
      iA = aA[0], eA = aA[1], iA !== iA ? nA[eA] = IA : typeof iA == "string" ? (tA = iA === "@" ? IA.lastIndexOf(iA) : IA.indexOf(iA), ~tA && (typeof aA[2] == "number" ? (nA[eA] = IA.slice(0, tA), IA = IA.slice(tA + aA[2])) : (nA[eA] = IA.slice(tA), IA = IA.slice(0, tA)))) : (tA = iA.exec(IA)) && (nA[eA] = tA[1], IA = IA.slice(0, tA.index)), nA[eA] = nA[eA] || EA && aA[3] && BA[eA] || "", aA[4] && (nA[eA] = nA[eA].toLowerCase());
    }
    QA && (nA.query = QA(nA.query)), EA && BA.slashes && nA.pathname.charAt(0) !== "/" && (nA.pathname !== "" || BA.pathname !== "") && (nA.pathname = AA(nA.pathname, BA.pathname)), nA.pathname.charAt(0) !== "/" && M(nA.protocol) && (nA.pathname = "/" + nA.pathname), o(nA.port, nA.protocol) || (nA.host = nA.hostname, nA.port = ""), nA.username = nA.password = "", nA.auth && (tA = nA.auth.indexOf(":"), ~tA ? (nA.username = nA.auth.slice(0, tA), nA.username = encodeURIComponent(decodeURIComponent(nA.username)), nA.password = nA.auth.slice(tA + 1), nA.password = encodeURIComponent(decodeURIComponent(nA.password))) : nA.username = encodeURIComponent(decodeURIComponent(nA.auth)), nA.auth = nA.password ? nA.username + ":" + nA.password : nA.username), nA.origin = nA.protocol !== "file:" && M(nA.protocol) && nA.host ? nA.protocol + "//" + nA.host : "null", nA.href = nA.toString();
  }
  function gA(IA, BA, QA) {
    var EA = this;
    switch (IA) {
      case "query":
        typeof BA == "string" && BA.length && (BA = (QA || E.parse)(BA)), EA[IA] = BA;
        break;
      case "port":
        EA[IA] = BA, o(BA, EA.protocol) ? BA && (EA.host = EA.hostname + ":" + BA) : (EA.host = EA.hostname, EA[IA] = "");
        break;
      case "hostname":
        EA[IA] = BA, EA.port && (BA += ":" + EA.port), EA.host = BA;
        break;
      case "host":
        EA[IA] = BA, t.test(BA) ? (BA = BA.split(":"), EA.port = BA.pop(), EA.hostname = BA.join(":")) : (EA.hostname = BA, EA.port = "");
        break;
      case "protocol":
        EA.protocol = BA.toLowerCase(), EA.slashes = !QA;
        break;
      case "pathname":
      case "hash":
        if (BA) {
          var oA = IA === "pathname" ? "/" : "#";
          EA[IA] = BA.charAt(0) !== oA ? oA + BA : BA;
        } else
          EA[IA] = BA;
        break;
      case "username":
      case "password":
        EA[IA] = encodeURIComponent(BA);
        break;
      case "auth":
        var iA = BA.indexOf(":");
        ~iA ? (EA.username = BA.slice(0, iA), EA.username = encodeURIComponent(decodeURIComponent(EA.username)), EA.password = BA.slice(iA + 1), EA.password = encodeURIComponent(decodeURIComponent(EA.password))) : EA.username = encodeURIComponent(decodeURIComponent(BA));
    }
    for (var aA = 0; aA < d.length; aA++) {
      var tA = d[aA];
      tA[4] && (EA[tA[1]] = EA[tA[1]].toLowerCase());
    }
    return EA.auth = EA.password ? EA.username + ":" + EA.password : EA.username, EA.origin = EA.protocol !== "file:" && M(EA.protocol) && EA.host ? EA.protocol + "//" + EA.host : "null", EA.href = EA.toString(), EA;
  }
  function CA(IA) {
    (!IA || typeof IA != "function") && (IA = E.stringify);
    var BA, QA = this, EA = QA.host, oA = QA.protocol;
    oA && oA.charAt(oA.length - 1) !== ":" && (oA += ":");
    var iA = oA + (QA.protocol && QA.slashes || M(QA.protocol) ? "//" : "");
    return QA.username ? (iA += QA.username, QA.password && (iA += ":" + QA.password), iA += "@") : QA.password ? (iA += ":" + QA.password, iA += "@") : QA.protocol !== "file:" && M(QA.protocol) && !EA && QA.pathname !== "/" && (iA += "@"), (EA[EA.length - 1] === ":" || t.test(QA.hostname) && !QA.port) && (EA += ":"), iA += EA + QA.pathname, BA = typeof QA.query == "object" ? IA(QA.query) : QA.query, BA && (iA += BA.charAt(0) !== "?" ? "?" + BA : BA), QA.hash && (iA += QA.hash), iA;
  }
  return H.prototype = { set: gA, toString: CA }, H.extractProtocol = S, H.location = p, H.trimLeft = h, H.qs = E, urlParse = H, urlParse;
}
var hasRequiredUrl;
function requireUrl() {
  if (hasRequiredUrl) return url;
  hasRequiredUrl = 1;
  var o = url && url.__importDefault || function(e) {
    return e && e.__esModule ? e : { default: e };
  };
  Object.defineProperty(url, "__esModule", { value: !0 }), url.URLExt = void 0;
  const E = requirePathBrowserify(), A = o(requireUrlParse());
  var g;
  return (function(e) {
    function t(S) {
      if (typeof document < "u" && document) {
        const AA = document.createElement("a");
        return AA.href = S, AA;
      }
      return (0, A.default)(S);
    }
    e.parse = t;
    function c(S) {
      return (0, A.default)(S).hostname;
    }
    e.getHostName = c;
    function n(S) {
      return S && t(S).toString();
    }
    e.normalize = n;
    function h(...S) {
      let AA = (0, A.default)(S[0], {});
      const H = AA.protocol === "" && AA.slashes;
      H && (AA = (0, A.default)(S[0], "https:" + S[0]));
      const gA = `${H ? "" : AA.protocol}${AA.slashes ? "//" : ""}${AA.auth}${AA.auth ? "@" : ""}${AA.host}`, CA = E.posix.join(`${gA && AA.pathname[0] !== "/" ? "/" : ""}${AA.pathname}`, ...S.slice(1));
      return `${gA}${CA === "." ? "" : CA}`;
    }
    e.join = h;
    function d(S) {
      return h(...S.split("/").map(encodeURIComponent));
    }
    e.encodeParts = d;
    function k(S) {
      const AA = Object.keys(S).filter((H) => H.length > 0);
      return AA.length ? "?" + AA.map((H) => {
        const gA = encodeURIComponent(String(S[H]));
        return H + (gA ? "=" + gA : "");
      }).join("&") : "";
    }
    e.objectToQueryString = k;
    function p(S) {
      return S.replace(/^\?/, "").split("&").reduce((AA, H) => {
        const [gA, CA] = H.split("=");
        return gA.length > 0 && (AA[gA] = decodeURIComponent(CA || "")), AA;
      }, {});
    }
    e.queryStringToObject = p;
    function M(S, AA = !1) {
      const { protocol: H } = t(S);
      return (!H || S.toLowerCase().indexOf(H) !== 0) && (AA ? S.indexOf("//") !== 0 : S.indexOf("/") !== 0);
    }
    e.isLocal = M;
  })(g || (url.URLExt = g = {})), url;
}
var hasRequiredPageconfig;
function requirePageconfig() {
  if (hasRequiredPageconfig) return pageconfig;
  hasRequiredPageconfig = 1;
  var __importDefault = pageconfig && pageconfig.__importDefault || function(o) {
    return o && o.__esModule ? o : { default: o };
  };
  Object.defineProperty(pageconfig, "__esModule", { value: !0 }), pageconfig.PageConfig = void 0;
  const coreutils_1 = requireDist$1(), minimist_1 = __importDefault(requireMinimist()), url_1 = /* @__PURE__ */ requireUrl();
  var PageConfig;
  return (function(PageConfig) {
    function getOption(name) {
      if (configData)
        return configData[name] || getBodyData(name);
      configData = /* @__PURE__ */ Object.create(null);
      let found = !1;
      if (typeof document < "u" && document) {
        const o = document.getElementById("jupyter-config-data");
        o && (configData = JSON.parse(o.textContent || ""), found = !0);
      }
      if (!found && typeof process < "u" && process.argv)
        try {
          const cli = (0, minimist_1.default)(process.argv.slice(2)), path = requirePathBrowserify();
          let fullPath = "";
          "jupyter-config-data" in cli ? fullPath = path.resolve(cli["jupyter-config-data"]) : "JUPYTER_CONFIG_DATA" in process.env && (fullPath = path.resolve(process.env.JUPYTER_CONFIG_DATA)), fullPath && (configData = eval("require")(fullPath));
        } catch (o) {
          console.error(o);
        }
      if (!coreutils_1.JSONExt.isObject(configData))
        configData = /* @__PURE__ */ Object.create(null);
      else
        for (const o in configData)
          typeof configData[o] != "string" && (configData[o] = JSON.stringify(configData[o]));
      return configData[name] || getBodyData(name);
    }
    PageConfig.getOption = getOption;
    function setOption(o, E) {
      const A = getOption(o);
      return configData[o] = E, A;
    }
    PageConfig.setOption = setOption;
    function getBaseUrl() {
      return url_1.URLExt.normalize(getOption("baseUrl") || "/");
    }
    PageConfig.getBaseUrl = getBaseUrl;
    function getTreeUrl() {
      return url_1.URLExt.join(getBaseUrl(), getOption("treeUrl"));
    }
    PageConfig.getTreeUrl = getTreeUrl;
    function getShareUrl() {
      return url_1.URLExt.normalize(getOption("shareUrl") || getBaseUrl());
    }
    PageConfig.getShareUrl = getShareUrl;
    function getTreeShareUrl() {
      return url_1.URLExt.normalize(url_1.URLExt.join(getShareUrl(), getOption("treeUrl")));
    }
    PageConfig.getTreeShareUrl = getTreeShareUrl;
    function getUrl(o) {
      var E, A, g, e;
      let t = o.toShare ? getShareUrl() : getBaseUrl();
      const c = (E = o.mode) !== null && E !== void 0 ? E : getOption("mode"), n = (A = o.workspace) !== null && A !== void 0 ? A : getOption("workspace"), h = c === "single-document" ? "doc" : "lab";
      t = url_1.URLExt.join(t, h), n !== PageConfig.defaultWorkspace && (t = url_1.URLExt.join(t, "workspaces", encodeURIComponent((g = getOption("workspace")) !== null && g !== void 0 ? g : PageConfig.defaultWorkspace)));
      const d = (e = o.treePath) !== null && e !== void 0 ? e : getOption("treePath");
      return d && (t = url_1.URLExt.join(t, "tree", url_1.URLExt.encodeParts(d))), t;
    }
    PageConfig.getUrl = getUrl, PageConfig.defaultWorkspace = "default";
    function getWsUrl(o) {
      let E = getOption("wsUrl");
      if (!E) {
        if (o = o ? url_1.URLExt.normalize(o) : getBaseUrl(), o.indexOf("http") !== 0)
          return "";
        E = "ws" + o.slice(4);
      }
      return url_1.URLExt.normalize(E);
    }
    PageConfig.getWsUrl = getWsUrl;
    function getNBConvertURL({ path: o, format: E, download: A }) {
      const g = url_1.URLExt.encodeParts(o), e = url_1.URLExt.join(getBaseUrl(), "nbconvert", E, g);
      return A ? e + "?download=true" : e;
    }
    PageConfig.getNBConvertURL = getNBConvertURL;
    function getToken() {
      return getOption("token") || getBodyData("jupyterApiToken");
    }
    PageConfig.getToken = getToken;
    function getNotebookVersion() {
      const o = getOption("notebookVersion");
      return o === "" ? [0, 0, 0] : JSON.parse(o);
    }
    PageConfig.getNotebookVersion = getNotebookVersion;
    let configData = null;
    function getBodyData(o) {
      if (typeof document > "u" || !document.body)
        return "";
      const E = document.body.dataset[o];
      return typeof E > "u" ? "" : decodeURIComponent(E);
    }
    (function(o) {
      function E(e) {
        try {
          const t = getOption(e);
          if (t)
            return JSON.parse(t);
        } catch (t) {
          console.warn(`Unable to parse ${e}.`, t);
        }
        return [];
      }
      o.deferred = E("deferredExtensions"), o.disabled = E("disabledExtensions");
      function A(e) {
        const t = e.indexOf(":");
        let c = "";
        return t !== -1 && (c = e.slice(0, t)), o.deferred.some((n) => n === e || c && n === c);
      }
      o.isDeferred = A;
      function g(e) {
        const t = e.indexOf(":");
        let c = "";
        return t !== -1 && (c = e.slice(0, t)), o.disabled.some((n) => n === e || c && n === c);
      }
      o.isDisabled = g;
    })(PageConfig.Extension || (PageConfig.Extension = {}));
  })(PageConfig || (pageconfig.PageConfig = PageConfig = {})), pageconfig;
}
var path$1 = {}, hasRequiredPath$1;
function requirePath$1() {
  if (hasRequiredPath$1) return path$1;
  hasRequiredPath$1 = 1, Object.defineProperty(path$1, "__esModule", { value: !0 }), path$1.PathExt = void 0;
  const o = requirePathBrowserify();
  var E;
  return (function(A) {
    function g(...S) {
      const AA = o.posix.join(...S);
      return AA === "." ? "" : M(AA);
    }
    A.join = g;
    function e(...S) {
      const AA = o.posix.join(...S);
      return AA === "." ? "" : AA;
    }
    A.joinWithLeadingSlash = e;
    function t(S, AA) {
      return o.posix.basename(S, AA);
    }
    A.basename = t;
    function c(S) {
      const AA = M(o.posix.dirname(S));
      return AA === "." ? "" : AA;
    }
    A.dirname = c;
    function n(S) {
      return o.posix.extname(S);
    }
    A.extname = n;
    function h(S) {
      return S === "" ? "" : M(o.posix.normalize(S));
    }
    A.normalize = h;
    function d(...S) {
      return M(o.posix.resolve(...S));
    }
    A.resolve = d;
    function k(S, AA) {
      return M(o.posix.relative(S, AA));
    }
    A.relative = k;
    function p(S) {
      return S.length > 0 && S.indexOf(".") !== 0 && (S = `.${S}`), S;
    }
    A.normalizeExtension = p;
    function M(S) {
      return S.indexOf("/") === 0 && (S = S.slice(1)), S;
    }
    A.removeSlash = M;
  })(E || (path$1.PathExt = E = {})), path$1;
}
var signal = {}, hasRequiredSignal$1;
function requireSignal$1() {
  if (hasRequiredSignal$1) return signal;
  hasRequiredSignal$1 = 1, Object.defineProperty(signal, "__esModule", { value: !0 }), signal.signalToPromise = E;
  const o = requireDist$1();
  function E(A, g) {
    const e = new o.PromiseDelegate();
    function t() {
      A.disconnect(c);
    }
    function c(n, h) {
      t(), e.resolve([n, h]);
    }
    return A.connect(c), (g ?? 0) > 0 && setTimeout(() => {
      t(), e.reject(`Signal not emitted within ${g} ms.`);
    }, g), e.promise;
  }
  return signal;
}
var text = {}, hasRequiredText;
function requireText() {
  if (hasRequiredText) return text;
  hasRequiredText = 1, Object.defineProperty(text, "__esModule", { value: !0 }), text.Text = void 0;
  var o;
  return (function(E) {
    function g(n, h) {
      return n;
    }
    E.jsIndexToCharIndex = g;
    function e(n, h) {
      return n;
    }
    E.charIndexToJsIndex = e;
    function t(n, h = !1) {
      return n.replace(/^(\w)|[\s-_:]+(\w)/g, function(d, k, p) {
        return p ? p.toUpperCase() : h ? k.toUpperCase() : k.toLowerCase();
      });
    }
    E.camelCase = t;
    function c(n) {
      return (n || "").toLowerCase().split(" ").map((h) => h.charAt(0).toUpperCase() + h.slice(1)).join(" ");
    }
    E.titleCase = c;
  })(o || (text.Text = o = {})), text;
}
var time = {}, hasRequiredTime;
function requireTime() {
  if (hasRequiredTime) return time;
  hasRequiredTime = 1, Object.defineProperty(time, "__esModule", { value: !0 }), time.Time = void 0;
  const o = [
    { name: "years", milliseconds: 365 * 24 * 60 * 60 * 1e3 },
    { name: "months", milliseconds: 720 * 60 * 60 * 1e3 },
    { name: "days", milliseconds: 1440 * 60 * 1e3 },
    { name: "hours", milliseconds: 3600 * 1e3 },
    { name: "minutes", milliseconds: 60 * 1e3 },
    { name: "seconds", milliseconds: 1e3 }
  ];
  var E;
  return (function(A) {
    function g(t, c = "long") {
      const n = document.documentElement.lang || "en", h = new Intl.RelativeTimeFormat(n, {
        numeric: "auto",
        style: c
      }), d = new Date(t).getTime() - Date.now();
      for (let k of o) {
        const p = Math.ceil(d / k.milliseconds);
        if (p !== 0)
          return h.format(p, k.name);
      }
      return h.format(0, "seconds");
    }
    A.formatHuman = g;
    function e(t) {
      const c = document.documentElement.lang || "en";
      return new Intl.DateTimeFormat(c, {
        dateStyle: "short",
        timeStyle: "short"
      }).format(new Date(t));
    }
    A.format = e;
  })(E || (time.Time = E = {})), time;
}
var hasRequiredLib;
function requireLib() {
  return hasRequiredLib || (hasRequiredLib = 1, (function(o) {
    var E = lib && lib.__createBinding || (Object.create ? (function(g, e, t, c) {
      c === void 0 && (c = t);
      var n = Object.getOwnPropertyDescriptor(e, t);
      (!n || ("get" in n ? !e.__esModule : n.writable || n.configurable)) && (n = { enumerable: !0, get: function() {
        return e[t];
      } }), Object.defineProperty(g, c, n);
    }) : (function(g, e, t, c) {
      c === void 0 && (c = t), g[c] = e[t];
    })), A = lib && lib.__exportStar || function(g, e) {
      for (var t in g) t !== "default" && !Object.prototype.hasOwnProperty.call(e, t) && E(e, g, t);
    };
    Object.defineProperty(o, "__esModule", { value: !0 }), A(/* @__PURE__ */ requireActivitymonitor(), o), A(/* @__PURE__ */ requireInterfaces(), o), A(/* @__PURE__ */ requireLru(), o), A(/* @__PURE__ */ requireMarkdowncodeblocks(), o), A(/* @__PURE__ */ requirePageconfig(), o), A(/* @__PURE__ */ requirePath$1(), o), A(/* @__PURE__ */ requireSignal$1(), o), A(/* @__PURE__ */ requireText(), o), A(/* @__PURE__ */ requireTime(), o), A(/* @__PURE__ */ requireUrl(), o);
  })(lib)), lib;
}
var libExports = /* @__PURE__ */ requireLib();
function manipulateIFrameDocument(o, E, A) {
  const g = [], e = E.getElementsByTagName("script");
  for (const c of e) {
    if (c.src === "")
      continue;
    const n = getRelativePath(window.location.host, window.location.pathname, new URL(c.src));
    if (n == null)
      continue;
    const h = libExports.URLExt.join(A, n), d = o.sendHttpRequest({
      method: "GET",
      headers: {},
      path: h,
      body: ""
    }).then(({
      statusCode: k,
      headers: p,
      body: M
    }) => {
      if (k !== 200)
        return;
      const S = p.get("Content-Type");
      return new Blob([M], S ? {
        type: S
      } : void 0).text().then((H) => {
        const gA = E.createElement("script");
        gA.text = H, gA.type = "text/javascript", gA.setAttribute("data-stlite", ""), c.replaceWith(gA);
      });
    });
    g.push(d);
  }
  const t = E.querySelectorAll("link[rel=stylesheet]");
  for (const c of t) {
    const n = getRelativePath(window.location.host, window.location.pathname, new URL(c.href));
    if (n == null)
      continue;
    const h = libExports.URLExt.join(A, n), d = o.sendHttpRequest({
      method: "GET",
      headers: {},
      path: h,
      body: ""
    }).then(({
      statusCode: k,
      headers: p,
      body: M
    }) => {
      if (k !== 200)
        return;
      const S = p.get("Content-Type");
      return new Blob([M], S ? {
        type: S
      } : void 0).text().then((H) => {
        const gA = E.createElement("style");
        gA.innerHTML = H, gA.setAttribute("data-stlite", ""), c.replaceWith(gA);
      });
    });
    g.push(d);
  }
  return Promise.all(g).then();
}
const InnerIFrame = React__default.forwardRef(({
  src: o,
  IframeComponent: E,
  ...A
}, g) => {
  const e = useStliteKernel(), [t, c] = useState();
  useEffect(() => {
    if (e == null || !o.startsWith("/component"))
      return;
    let h = !1;
    return e.sendHttpRequest({
      method: "GET",
      path: o,
      headers: {},
      body: ""
    }).then(({
      statusCode: d,
      headers: k,
      body: p
    }) => {
      if (h || d !== 200)
        return;
      const M = k.get("Content-Type");
      new Blob([p], M ? {
        type: M
      } : void 0).text().then((AA) => {
        h || c(AA);
      });
    }), () => {
      h = !0;
    };
  }, [e, o]);
  const n = useCallback((h) => {
    const k = h.target.contentWindow?.document;
    if (k == null) {
      console.warn("document not found in iframe");
      return;
    }
    manipulateIFrameDocument(e, k, getParentPath(o));
  }, [e, o]);
  return jsxRuntimeExports.jsx(E, {
    ...A,
    srcDoc: t,
    onLoad: n,
    ref: g
  });
});
InnerIFrame.displayName = "InnerIFrame";
const CustomComponentIFrame = React__default.forwardRef((o, E) => {
  const A = useStliteKernel(), g = useMemo$1(() => extractCustomComponentPath(A.basePath, o.src), [A.basePath, o.src]);
  return g == null ? jsxRuntimeExports.jsx("iframe", {
    ...o,
    ref: E
  }) : jsxRuntimeExports.jsx(InnerIFrame, {
    ...o,
    src: g,
    ref: E
  });
});
CustomComponentIFrame.displayName = "StliteCustomComponentIFrame";
const LOG$9 = loglevelExports$1.getLogger("ComponentRegistry");
class ComponentRegistry {
  constructor(E) {
    this.msgListeners = /* @__PURE__ */ new Map(), this.registerListener = (A, g) => {
      this.msgListeners.has(A) && LOG$9.warn("MessageEventSource registered multiple times!", A), this.msgListeners.set(A, g);
    }, this.deregisterListener = (A) => {
      this.msgListeners.delete(A) || LOG$9.warn("Could not deregister unregistered MessageEventSource!");
    }, this.checkSourceUrlResponse = (A, g) => this.endpoints.checkSourceUrlResponse(A, "Custom Component", g), this.sendTimeoutError = (A, g) => {
      this.endpoints.sendClientErrorToHost("Custom Component", "Request Timeout", "Your app is having trouble loading the component.", A, g);
    }, this.getComponentURL = (A, g) => this.endpoints.buildComponentURL(A, g), this.getBidiComponentURL = (A, g) => this.endpoints.buildBidiComponentURL(A, g), this.onMessageEvent = (A) => {
      if (isNullOrUndefined(A.data) || !Object.hasOwn(A.data, "isStreamlitMessage"))
        return;
      if (isNullOrUndefined(A.source)) {
        LOG$9.warn("Received component message with no eventSource!", A.data);
        return;
      }
      const g = this.msgListeners.get(A.source);
      if (isNullOrUndefined(g) || typeof g != "function") {
        LOG$9.warn("Received component message for unregistered ComponentInstance!", A.data);
        return;
      }
      const {
        type: e
      } = A.data;
      if (isNullOrUndefined(e)) {
        LOG$9.warn("Received Streamlit message with no type!", A.data);
        return;
      }
      g(e, A.data);
    }, this.endpoints = E, window.addEventListener("message", this.onMessageEvent);
  }
}
const byteToHex = [];
for (let o = 0; o < 256; ++o)
  byteToHex.push((o + 256).toString(16).slice(1));
function unsafeStringify(o, E = 0) {
  return (byteToHex[o[E + 0]] + byteToHex[o[E + 1]] + byteToHex[o[E + 2]] + byteToHex[o[E + 3]] + "-" + byteToHex[o[E + 4]] + byteToHex[o[E + 5]] + "-" + byteToHex[o[E + 6]] + byteToHex[o[E + 7]] + "-" + byteToHex[o[E + 8]] + byteToHex[o[E + 9]] + "-" + byteToHex[o[E + 10]] + byteToHex[o[E + 11]] + byteToHex[o[E + 12]] + byteToHex[o[E + 13]] + byteToHex[o[E + 14]] + byteToHex[o[E + 15]]).toLowerCase();
}
let getRandomValues;
const rnds8 = new Uint8Array(16);
function rng() {
  if (!getRandomValues) {
    if (typeof crypto > "u" || !crypto.getRandomValues)
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    getRandomValues = crypto.getRandomValues.bind(crypto);
  }
  return getRandomValues(rnds8);
}
const randomUUID = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), native = { randomUUID };
function _v4(o, E, A) {
  o = o || {};
  const g = o.random ?? o.rng?.() ?? rng();
  if (g.length < 16)
    throw new Error("Random bytes length must be >= 16");
  return g[6] = g[6] & 15 | 64, g[8] = g[8] & 63 | 128, unsafeStringify(g);
}
function v4(o, E, A) {
  return native.randomUUID && !o ? native.randomUUID() : _v4(o);
}
var __typeError = (o) => {
  throw TypeError(o);
}, __accessCheck = (o, E, A) => E.has(o) || __typeError("Cannot " + A), __privateGet = (o, E, A) => (__accessCheck(o, E, "read from private field"), A ? A.call(o) : E.get(o)), __privateAdd = (o, E, A) => E.has(o) ? __typeError("Cannot add the same private member more than once") : E instanceof WeakSet ? E.add(o) : E.set(o, A), __privateSet = (o, E, A, g) => (__accessCheck(o, E, "write to private field"), E.set(o, A), A), __privateMethod = (o, E, A) => (__accessCheck(o, E, "access private method"), A), MAX_CHUNK_SIZE = 65536;
function* chunk(o) {
  if (o.byteLength <= MAX_CHUNK_SIZE) {
    yield o;
    return;
  }
  let E = 0;
  for (; E < o.byteLength; ) {
    const A = Math.min(o.byteLength - E, MAX_CHUNK_SIZE), g = o.buffer.slice(E, E + A);
    E += g.byteLength, yield new Uint8Array(g);
  }
}
var alphabet = "abcdefghijklmnopqrstuvwxyz0123456789";
function createBoundary() {
  let o = 16, E = "";
  for (; o--; )
    E += alphabet[Math.random() * alphabet.length << 0];
  return E;
}
var escapeName = (o) => String(o).replace(/\r/g, "%0D").replace(/\n/g, "%0A").replace(/"/g, "%22"), isFunction = (o) => typeof o == "function", isReadableStreamFallback = (o) => !!o && typeof o == "object" && !Array.isArray(o) && isFunction(o.getReader), isAsyncIterable = (o) => isFunction(o[Symbol.asyncIterator]);
async function* readStream(o) {
  const E = o.getReader();
  for (; ; ) {
    const { done: A, value: g } = await E.read();
    if (A)
      break;
    yield g;
  }
}
async function* chunkStream(o) {
  for await (const E of o)
    yield* chunk(E);
}
var getStreamIterator = (o) => {
  if (isAsyncIterable(o))
    return chunkStream(o);
  if (isReadableStreamFallback(o))
    return chunkStream(readStream(o));
  throw new TypeError(
    "Unsupported data source: Expected either ReadableStream or async iterable."
  );
}, isFile = (o) => !!(o && typeof o == "object" && isFunction(o.constructor) && o[Symbol.toStringTag] === "File" && isFunction(o.stream) && o.name != null), isFormData = (o) => !!(o && isFunction(o.constructor) && o[Symbol.toStringTag] === "FormData" && isFunction(o.append) && isFunction(o.getAll) && isFunction(o.entries) && isFunction(o[Symbol.iterator])), getType = (o) => Object.prototype.toString.call(o).slice(8, -1).toLowerCase();
function isPlainObject(o) {
  if (getType(o) !== "object")
    return !1;
  const E = Object.getPrototypeOf(o);
  return E == null ? !0 : E.constructor?.toString?.() === Object.toString();
}
var normalizeValue = (o) => String(o).replace(/\r|\n/g, (E, A, g) => E === "\r" && g[A + 1] !== `
` || E === `
` && g[A - 1] !== "\r" ? `\r
` : E);
function getProperty(o, E) {
  if (typeof E == "string") {
    for (const [A, g] of Object.entries(o))
      if (E.toLowerCase() === A.toLowerCase())
        return g;
  }
}
var proxyHeaders = (o) => new Proxy(
  o,
  {
    get: (E, A) => getProperty(E, A),
    has: (E, A) => getProperty(E, A) !== void 0
  }
), defaultOptions = {
  enableAdditionalHeaders: !1
}, readonlyProp = { writable: !1, configurable: !1 }, _CRLF, _CRLF_BYTES, _CRLF_BYTES_LENGTH, _DASHES, _encoder, _footer, _form, _options, _FormDataEncoder_instances, getFieldHeader_fn, getContentLength_fn, FormDataEncoder = class {
  constructor(o, E, A) {
    if (__privateAdd(this, _FormDataEncoder_instances), __privateAdd(this, _CRLF, `\r
`), __privateAdd(this, _CRLF_BYTES), __privateAdd(this, _CRLF_BYTES_LENGTH), __privateAdd(this, _DASHES, "-".repeat(2)), __privateAdd(this, _encoder, new TextEncoder()), __privateAdd(this, _footer), __privateAdd(this, _form), __privateAdd(this, _options), !isFormData(o))
      throw new TypeError("Expected first argument to be a FormData instance.");
    let g;
    if (isPlainObject(E) ? A = E : g = E, g || (g = `form-data-encoder-${createBoundary()}`), typeof g != "string")
      throw new TypeError("Expected boundary argument to be a string.");
    if (A && !isPlainObject(A))
      throw new TypeError("Expected options argument to be an object.");
    __privateSet(this, _form, Array.from(o.entries())), __privateSet(this, _options, { ...defaultOptions, ...A }), __privateSet(this, _CRLF_BYTES, __privateGet(this, _encoder).encode(__privateGet(this, _CRLF))), __privateSet(this, _CRLF_BYTES_LENGTH, __privateGet(this, _CRLF_BYTES).byteLength), this.boundary = g, this.contentType = `multipart/form-data; boundary=${this.boundary}`, __privateSet(this, _footer, __privateGet(this, _encoder).encode(
      `${__privateGet(this, _DASHES)}${this.boundary}${__privateGet(this, _DASHES)}${__privateGet(this, _CRLF).repeat(2)}`
    ));
    const e = {
      "Content-Type": this.contentType
    }, t = __privateMethod(this, _FormDataEncoder_instances, getContentLength_fn).call(this);
    t && (this.contentLength = t, e["Content-Length"] = t), this.headers = proxyHeaders(Object.freeze(e)), Object.defineProperties(this, {
      boundary: readonlyProp,
      contentType: readonlyProp,
      contentLength: readonlyProp,
      headers: readonlyProp
    });
  }
  /**
   * Creates an iterator allowing to go through form-data parts (with metadata).
   * This method **will not** read the files and **will not** split values big into smaller chunks.
   *
   * Using this method, you can convert form-data content into Blob:
   *
   * @example
   *
   * ```ts
   * import {Readable} from "stream"
   *
   * import {FormDataEncoder} from "form-data-encoder"
   *
   * import {FormData} from "formdata-polyfill/esm-min.js"
   * import {fileFrom} from "fetch-blob/form.js"
   * import {File} from "fetch-blob/file.js"
   * import {Blob} from "fetch-blob"
   *
   * import fetch from "node-fetch"
   *
   * const form = new FormData()
   *
   * form.set("field", "Just a random string")
   * form.set("file", new File(["Using files is class amazing"]))
   * form.set("fileFromPath", await fileFrom("path/to/a/file.txt"))
   *
   * const encoder = new FormDataEncoder(form)
   *
   * const options = {
   *   method: "post",
   *   body: new Blob(encoder, {type: encoder.contentType})
   * }
   *
   * const response = await fetch("https://httpbin.org/post", options)
   *
   * console.log(await response.json())
   * ```
   */
  *values() {
    for (const [o, E] of __privateGet(this, _form)) {
      const A = isFile(E) ? E : __privateGet(this, _encoder).encode(normalizeValue(E));
      yield __privateMethod(this, _FormDataEncoder_instances, getFieldHeader_fn).call(this, o, A), yield A, yield __privateGet(this, _CRLF_BYTES);
    }
    yield __privateGet(this, _footer);
  }
  /**
   * Creates an async iterator allowing to perform the encoding by portions.
   * This method reads through files and splits big values into smaller pieces (65536 bytes per each).
   *
   * @example
   *
   * ```ts
   * import {Readable} from "stream"
   *
   * import {FormData, File, fileFromPath} from "formdata-node"
   * import {FormDataEncoder} from "form-data-encoder"
   *
   * import fetch from "node-fetch"
   *
   * const form = new FormData()
   *
   * form.set("field", "Just a random string")
   * form.set("file", new File(["Using files is class amazing"], "file.txt"))
   * form.set("fileFromPath", await fileFromPath("path/to/a/file.txt"))
   *
   * const encoder = new FormDataEncoder(form)
   *
   * const options = {
   *   method: "post",
   *   headers: encoder.headers,
   *   body: Readable.from(encoder.encode()) // or Readable.from(encoder)
   * }
   *
   * const response = await fetch("https://httpbin.org/post", options)
   *
   * console.log(await response.json())
   * ```
   */
  async *encode() {
    for (const o of this.values())
      isFile(o) ? yield* getStreamIterator(o.stream()) : yield* chunk(o);
  }
  /**
   * Creates an iterator allowing to read through the encoder data using for...of loops
   */
  [Symbol.iterator]() {
    return this.values();
  }
  /**
   * Creates an **async** iterator allowing to read through the encoder data using for-await...of loops
   */
  [Symbol.asyncIterator]() {
    return this.encode();
  }
};
_CRLF = /* @__PURE__ */ new WeakMap();
_CRLF_BYTES = /* @__PURE__ */ new WeakMap();
_CRLF_BYTES_LENGTH = /* @__PURE__ */ new WeakMap();
_DASHES = /* @__PURE__ */ new WeakMap();
_encoder = /* @__PURE__ */ new WeakMap();
_footer = /* @__PURE__ */ new WeakMap();
_form = /* @__PURE__ */ new WeakMap();
_options = /* @__PURE__ */ new WeakMap();
_FormDataEncoder_instances = /* @__PURE__ */ new WeakSet();
getFieldHeader_fn = function(o, E) {
  let A = "";
  if (A += `${__privateGet(this, _DASHES)}${this.boundary}${__privateGet(this, _CRLF)}`, A += `Content-Disposition: form-data; name="${escapeName(o)}"`, isFile(E) && (A += `; filename="${escapeName(E.name)}"${__privateGet(this, _CRLF)}`, A += `Content-Type: ${E.type || "application/octet-stream"}`), __privateGet(this, _options).enableAdditionalHeaders === !0) {
    const g = isFile(E) ? E.size : E.byteLength;
    g != null && !isNaN(g) && (A += `${__privateGet(this, _CRLF)}Content-Length: ${g}`);
  }
  return __privateGet(this, _encoder).encode(`${A}${__privateGet(this, _CRLF).repeat(2)}`);
};
getContentLength_fn = function() {
  let o = 0;
  for (const [E, A] of __privateGet(this, _form)) {
    const g = isFile(A) ? A : __privateGet(this, _encoder).encode(normalizeValue(A)), e = isFile(g) ? g.size : g.byteLength;
    if (e == null || isNaN(e))
      return;
    o += __privateMethod(this, _FormDataEncoder_instances, getFieldHeader_fn).call(this, E, g).byteLength, o += e, o += __privateGet(this, _CRLF_BYTES_LENGTH);
  }
  return String(o + __privateGet(this, _footer).byteLength);
};
const LOG$8 = loglevelExports$1.getLogger("FileUploadClient");
class FileUploadClient {
  constructor(E) {
    this.formsWithPendingRequests = /* @__PURE__ */ new Map(), this.pendingFileURLsRequests = /* @__PURE__ */ new Map(), this.sessionInfo = E.sessionInfo, this.endpoints = E.endpoints, this.pendingFormUploadsChanged = E.formsWithPendingRequestsChanged, this.requestFileURLs = E.requestFileURLs;
  }
  setKernel(E) {
    this.kernel = E;
  }
  /**
   * Upload a file to the given URL. It will be associated with this browser's
   * sessionID.
   *
   * @param widget: the FileUploader widget that's doing the upload.
   * @param fileUploadUrl: the URL to upload the file to.
   * @param file: the files to upload.
   * @param onUploadProgress: an optional function that will be called repeatedly with progress events during the upload.
   * @param signal: an optional AbortSignal that can be used to cancel the in-progress upload.
   *
   * @return a Promise<void> that resolves with a void promise when the upload is complete.
   */
  async uploadFile(E, A, g, e, t) {
    this.offsetPendingRequestCount(E.formId, 1);
    const c = new FormData();
    c.append(g.name, g);
    const n = new FormDataEncoder(c);
    return new Blob(n, {
      type: n.contentType
    }).arrayBuffer().then((d) => {
      if (this.kernel == null)
        throw new Error("Kernel not ready");
      return this.kernel.sendHttpRequest({
        method: "PUT",
        path: A,
        body: d,
        headers: {
          ...n.headers
        }
      }, t).then((k) => {
        if (Math.floor(k.statusCode / 100) !== 2)
          throw new Error(`Unexpected status code ${k.statusCode} when uploading file.`);
      }).finally(() => this.offsetPendingRequestCount(E.formId, -1));
    });
  }
  /**
   * Request that the file at the given URL is deleted.
   * @param fileUrl: the URL of the file to delete.
   */
  deleteFile(E) {
    if (this.kernel == null)
      throw new Error("Kernel not ready");
    return this.kernel.sendHttpRequest({
      method: "DELETE",
      path: E,
      body: "",
      headers: {}
    }).then((A) => {
      if (Math.floor(A.statusCode / 100) !== 2)
        throw new Error(`Unexpected status code ${A.statusCode} when uploading file.`);
    });
  }
  /**
   * Request that the app fetch URLs to upload/delete/get the given files. Once
   * this is done, the app should call this class' onFileURLsResponse to
   * signify completion.
   *
   * @param files: An array of files.
   *
   * @return a Promise<FileURLsResponse.IFileURLs[]> resolving to a list of
   * URLs for uploading and deleting the given files.
   */
  fetchFileURLs(E) {
    if (!this.requestFileURLs)
      return Promise.resolve([]);
    const A = Promise.withResolvers(), g = v4();
    return this.pendingFileURLsRequests.set(g, A), this.requestFileURLs(g, E), A.promise;
  }
  /**
   * Callback to be called by the app once the file URLs corresponding to a
   * call to this.requestFileURLs has been received.
   *
   * @param resp: the FileURLsResponse corresponding to a call to
   * this.requestFileURLs.
   */
  onFileURLsResponse(E) {
    const A = E.responseId, g = this.pendingFileURLsRequests.get(A);
    g ? (E.errorMsg ? g.reject(E.errorMsg) : g.resolve(E.fileUrls || []), this.pendingFileURLsRequests.delete(A)) : LOG$8.warn("fileURLsResponse received for nonexistent request, ignoring.");
  }
  getFormIdSet() {
    return new Set(this.formsWithPendingRequests.keys());
  }
  offsetPendingRequestCount(E, A) {
    if (A === 0 || !isValidFormId(E))
      return;
    const g = this.formsWithPendingRequests.get(E) ?? 0, e = g + A;
    if (e < 0)
      throw new Error(`Can't offset pendingRequestCount below 0 (formId=${E}, curCount=${g}, offset=${A})`);
    const t = this.getFormIdSet();
    e === 0 ? this.formsWithPendingRequests.delete(E) : this.formsWithPendingRequests.set(E, e);
    const c = this.getFormIdSet();
    isEqual$1(c, t) || this.pendingFormUploadsChanged(c);
  }
}
const arrayComparator = (o, E) => o.length !== E.length ? !1 : o.every((A, g) => Object.is(A, E[g])), useExecuteWhenChanged = (o, E, A = arrayComparator) => {
  const [g, e] = useState(E);
  A(g, E) || (e(E), o());
}, measureScrollbarGutterSize = () => {
  const o = document.createElement("div");
  o.style.position = "absolute", o.style.top = "-9999px", o.style.left = "-9999px", o.style.visibility = "hidden", o.style.overflow = "scroll", o.style.width = "50px", o.style.height = "50px", document.body.appendChild(o);
  const E = document.createElement("div");
  E.style.width = "100%", E.style.height = "100%", o.appendChild(E);
  const A = o.offsetWidth - E.offsetWidth;
  return o.remove(), A;
}, useScrollbarGutterSize = () => {
  const o = window.devicePixelRatio;
  return useMemo$1(() => measureScrollbarGutterSize(), [o]);
}, HOST_COMM_VERSION = 1;
class HostCommunicationManager {
  constructor(E) {
    this.openHostCommunication = () => {
      window.addEventListener("message", this.receiveHostMessage), this.sendMessageToHost({
        type: "GUEST_READY",
        streamlitExecutionStartedAt: this.props.streamlitExecutionStartedAt,
        guestReadyAt: Date.now()
      });
    }, this.closeHostCommunication = () => {
      window.removeEventListener("message", this.receiveHostMessage);
    }, this.resetAuthToken = () => {
      this.deferredAuthToken = Promise.withResolvers();
    }, this.claimAuthToken = () => this.deferredAuthToken.promise, this.setAllowedOrigins = ({
      allowedOrigins: A,
      useExternalAuthToken: g
    }) => {
      g || this.deferredAuthToken.resolve(void 0), A?.length && (this.allowedOrigins = A, this.openHostCommunication());
    }, this.sendMessageToSameOriginHost = (A) => {
      window.parent.postMessage({
        stCommVersion: HOST_COMM_VERSION,
        ...A
      }, window.location.origin);
    }, this.sendMessageToHost = (A) => {
      window.parent.postMessage({
        stCommVersion: HOST_COMM_VERSION,
        ...A
      }, "*");
    }, this.receiveHostMessage = (A) => {
      const g = A.data;
      if (!(g.stCommVersion !== HOST_COMM_VERSION || !this.allowedOrigins.find((e) => isValidOrigin(e, A.origin)))) {
        if (g.type === "CLOSE_MODAL" && this.props.closeModal(), g.type === "STOP_SCRIPT" && this.props.stopScript(), g.type === "RERUN_SCRIPT" && this.props.rerunScript(), g.type === "CLEAR_CACHE" && this.props.clearCache(), g.type === "REQUEST_PAGE_CHANGE" && this.props.pageChanged(g.pageScriptHash), g.type === "SEND_APP_HEARTBEAT" && this.props.sendAppHeartbeat(), g.type === "SET_INPUTS_DISABLED" && this.props.setInputsDisabled(g.disabled), g.type === "SET_AUTH_TOKEN" && this.deferredAuthToken.resolve(g.authToken), g.type === "SET_FILE_UPLOAD_CLIENT_CONFIG") {
          const {
            prefix: e,
            headers: t
          } = g;
          this.props.fileUploadClientConfigChanged({
            prefix: e,
            headers: t
          });
        }
        g.type === "SET_IS_OWNER" && this.props.isOwnerChanged(g.isOwner), g.type === "SET_MENU_ITEMS" && this.props.hostMenuItemsChanged(g.items), g.type === "SET_METADATA" && this.props.deployedAppMetadataChanged(g.metadata), g.type === "SET_PAGE_LINK_BASE_URL" && this.props.pageLinkBaseUrlChanged(g.pageLinkBaseUrl), g.type === "SET_SIDEBAR_CHEVRON_DOWNSHIFT" && this.props.sidebarChevronDownshiftChanged(g.sidebarChevronDownshift), g.type === "SET_SIDEBAR_NAV_VISIBILITY" && this.props.hostHideSidebarNavChanged(g.hidden), g.type === "SET_TOOLBAR_ITEMS" && this.props.hostToolbarItemsChanged(g.items), g.type === "UPDATE_FROM_QUERY_PARAMS" && (this.props.queryParamsChanged(g.queryParams), this.props.sendRerunBackMsg()), g.type === "UPDATE_HASH" && (window.location.hash = g.hash), g.type === "SET_CUSTOM_THEME_CONFIG" && this.props.themeChanged(g.themeName, g.themeInfo), g.type === "RESTART_WEBSOCKET_CONNECTION" && this.props.restartWebsocketConnection(), g.type === "TERMINATE_WEBSOCKET_CONNECTION" && this.props.terminateWebsocketConnection();
      }
    }, this.props = E, this.allowedOrigins = [], this.deferredAuthToken = Promise.withResolvers();
  }
}
class SessionInfo {
  /** Return the current SessionInfo props. Throw an error if the props are undefined. */
  get current() {
    if (!this._current)
      throw new Error("Tried to use SessionInfo before it was initialized");
    return this._current;
  }
  /** Return the previous SessionInfo props. They may be undefined! */
  get last() {
    return this._last;
  }
  /**
   * Initialize `SessionInfo.current` with the given props and copy its
   * previous props to `SessionInfo.last`.
   */
  setCurrent(E) {
    this._last = notNullOrUndefined(this._current) ? {
      ...this._current
    } : void 0, this._current = notNullOrUndefined(E) ? {
      ...E
    } : void 0;
  }
  /** Marks `SessionInfo.current` as not connected and copy its previous props to `SessionInfo.last`. */
  disconnect() {
    this._current && this.setCurrent({
      ...this._current,
      isConnected: !1
    });
  }
  /** True if `SessionInfo.current` exists. */
  get isSet() {
    return notNullOrUndefined(this._current);
  }
  /** True if `SessionInfo.current` refers to a "streamlit hello" session. */
  get isHello() {
    return notNullOrUndefined(this._current) && this._current.isHello;
  }
  /** Create SessionInfo Props from the relevant bits of an initialize message. */
  static propsFromNewSessionMessage(E) {
    const A = E.initialize, g = E.config, e = A.userInfo, t = A.environmentInfo;
    return {
      appId: hashString(e.installationIdV3 + E.mainScriptPath),
      sessionId: A.sessionId,
      streamlitVersion: t.streamlitVersion,
      pythonVersion: t.pythonVersion,
      serverOS: t.serverOs,
      hasDisplay: t.hasDisplay,
      installationId: e.installationId,
      installationIdV3: e.installationIdV3,
      installationIdV4: e.installationIdV4,
      maxCachedMessageAge: g.maxCachedMessageAge,
      isHello: A.isHello,
      // We assume we are always connected because the message came directly from the server.
      isConnected: !0
    };
  }
}
const measure = (o, E, A) => performance.measure(o, E, A), mark = (o) => performance.mark(o);
class Timer {
  constructor() {
    this.duration = 0, this.startTime = 0, this.running = !1;
  }
  /** True if the timer is currently running */
  get isRunning() {
    return this.running;
  }
  /** Remaining time before timeout, or 0 if the timer is not running */
  get remainingTime() {
    if (!this.running)
      return 0;
    const E = Date.now() - this.startTime;
    return Math.max(this.duration - E, 0);
  }
  /**
   * Starts the Timer with the given callback.
   * If the Timer is already running, it will be canceled first.
   */
  setTimeout(E, A) {
    this.cancel(), this.startTime = Date.now(), this.duration = A, this.running = !0, this.timerHandle = window.setTimeout(() => {
      this.running = !1, E();
    }, A);
  }
  /** Cancels the Timer. If the Timer is not already running, this is a no-op. */
  cancel() {
    this.timerHandle !== void 0 && (window.clearTimeout(this.timerHandle), this.timerHandle = void 0, this.running = !1);
  }
}
var src = { exports: {} }, indexLight = { exports: {} }, types = {}, util = { exports: {} }, codegen_1, hasRequiredCodegen;
function requireCodegen() {
  if (hasRequiredCodegen) return codegen_1;
  hasRequiredCodegen = 1, codegen_1 = o;
  function o(E, A) {
    typeof E == "string" && (A = E, E = void 0);
    var g = [];
    function e(c) {
      if (typeof c != "string") {
        var n = t();
        if (o.verbose && console.log("codegen: " + n), n = "return " + n, c) {
          for (var h = Object.keys(c), d = new Array(h.length + 1), k = new Array(h.length), p = 0; p < h.length; )
            d[p] = h[p], k[p] = c[h[p++]];
          return d[p] = n, Function.apply(null, d).apply(null, k);
        }
        return Function(n)();
      }
      for (var M = new Array(arguments.length - 1), S = 0; S < M.length; )
        M[S] = arguments[++S];
      if (S = 0, c = c.replace(/%([%dfijs])/g, function(H, gA) {
        var CA = M[S++];
        switch (gA) {
          case "d":
          case "f":
            return String(Number(CA));
          case "i":
            return String(Math.floor(CA));
          case "j":
            return JSON.stringify(CA);
          case "s":
            return String(CA);
        }
        return "%";
      }), S !== M.length)
        throw Error("parameter count mismatch");
      return g.push(c), e;
    }
    function t(c) {
      return "function " + (c || A || "") + "(" + (E && E.join(",") || "") + `){
  ` + g.join(`
  `) + `
}`;
    }
    return e.toString = t, e;
  }
  return o.verbose = !1, codegen_1;
}
var fetch_1, hasRequiredFetch;
function requireFetch() {
  if (hasRequiredFetch) return fetch_1;
  hasRequiredFetch = 1, fetch_1 = g;
  var o = requireAspromise$1(), E = requireInquire$1(), A = E("fs");
  function g(e, t, c) {
    return typeof t == "function" ? (c = t, t = {}) : t || (t = {}), c ? !t.xhr && A && A.readFile ? A.readFile(e, function(h, d) {
      return h && typeof XMLHttpRequest < "u" ? g.xhr(e, t, c) : h ? c(h) : c(null, t.binary ? d : d.toString("utf8"));
    }) : g.xhr(e, t, c) : o(g, this, e, t);
  }
  return g.xhr = function(t, c, n) {
    var h = new XMLHttpRequest();
    h.onreadystatechange = function() {
      if (h.readyState === 4) {
        if (h.status !== 0 && h.status !== 200)
          return n(Error("status " + h.status));
        if (c.binary) {
          var k = h.response;
          if (!k) {
            k = [];
            for (var p = 0; p < h.responseText.length; ++p)
              k.push(h.responseText.charCodeAt(p) & 255);
          }
          return n(null, typeof Uint8Array < "u" ? new Uint8Array(k) : k);
        }
        return n(null, h.responseText);
      }
    }, c.binary && ("overrideMimeType" in h && h.overrideMimeType("text/plain; charset=x-user-defined"), h.responseType = "arraybuffer"), h.open("GET", t), h.send();
  }, fetch_1;
}
var path = {}, hasRequiredPath;
function requirePath() {
  return hasRequiredPath || (hasRequiredPath = 1, (function(o) {
    var E = o, A = (
      /**
       * Tests if the specified path is absolute.
       * @param {string} path Path to test
       * @returns {boolean} `true` if path is absolute
       */
      E.isAbsolute = function(t) {
        return /^(?:\/|\w+:)/.test(t);
      }
    ), g = (
      /**
       * Normalizes the specified path.
       * @param {string} path Path to normalize
       * @returns {string} Normalized path
       */
      E.normalize = function(t) {
        t = t.replace(/\\/g, "/").replace(/\/{2,}/g, "/");
        var c = t.split("/"), n = A(t), h = "";
        n && (h = c.shift() + "/");
        for (var d = 0; d < c.length; )
          c[d] === ".." ? d > 0 && c[d - 1] !== ".." ? c.splice(--d, 2) : n ? c.splice(d, 1) : ++d : c[d] === "." ? c.splice(d, 1) : ++d;
        return h + c.join("/");
      }
    );
    E.resolve = function(t, c, n) {
      return n || (c = g(c)), A(c) ? c : (n || (t = g(t)), (t = t.replace(/(?:\/|^)[^/]+$/, "")).length ? g(t + "/" + c) : c);
    };
  })(path)), path;
}
var namespace, hasRequiredNamespace;
function requireNamespace() {
  if (hasRequiredNamespace) return namespace;
  hasRequiredNamespace = 1, namespace = h;
  var o = requireObject();
  ((h.prototype = Object.create(o.prototype)).constructor = h).className = "Namespace";
  var E = requireField(), A = requireUtil(), g = requireOneof(), e, t, c;
  h.fromJSON = function(p, M) {
    return new h(p, M.options).addJSON(M.nested);
  };
  function n(k, p) {
    if (k && k.length) {
      for (var M = {}, S = 0; S < k.length; ++S)
        M[k[S].name] = k[S].toJSON(p);
      return M;
    }
  }
  h.arrayToJSON = n, h.isReservedId = function(p, M) {
    if (p) {
      for (var S = 0; S < p.length; ++S)
        if (typeof p[S] != "string" && p[S][0] <= M && p[S][1] > M)
          return !0;
    }
    return !1;
  }, h.isReservedName = function(p, M) {
    if (p) {
      for (var S = 0; S < p.length; ++S)
        if (p[S] === M)
          return !0;
    }
    return !1;
  };
  function h(k, p) {
    o.call(this, k, p), this.nested = void 0, this._nestedArray = null, this._lookupCache = {}, this._needsRecursiveFeatureResolution = !0, this._needsRecursiveResolve = !0;
  }
  function d(k) {
    k._nestedArray = null, k._lookupCache = {};
    for (var p = k; p = p.parent; )
      p._lookupCache = {};
    return k;
  }
  return Object.defineProperty(h.prototype, "nestedArray", {
    get: function() {
      return this._nestedArray || (this._nestedArray = A.toArray(this.nested));
    }
  }), h.prototype.toJSON = function(p) {
    return A.toObject([
      "options",
      this.options,
      "nested",
      n(this.nestedArray, p)
    ]);
  }, h.prototype.addJSON = function(p) {
    var M = this;
    if (p)
      for (var S = Object.keys(p), AA = 0, H; AA < S.length; ++AA)
        H = p[S[AA]], M.add(
          // most to least likely
          (H.fields !== void 0 ? e.fromJSON : H.values !== void 0 ? c.fromJSON : H.methods !== void 0 ? t.fromJSON : H.id !== void 0 ? E.fromJSON : h.fromJSON)(S[AA], H)
        );
    return this;
  }, h.prototype.get = function(p) {
    return this.nested && this.nested[p] || null;
  }, h.prototype.getEnum = function(p) {
    if (this.nested && this.nested[p] instanceof c)
      return this.nested[p].values;
    throw Error("no such enum: " + p);
  }, h.prototype.add = function(p) {
    if (!(p instanceof E && p.extend !== void 0 || p instanceof e || p instanceof g || p instanceof c || p instanceof t || p instanceof h))
      throw TypeError("object must be a valid nested object");
    if (!this.nested)
      this.nested = {};
    else {
      var M = this.get(p.name);
      if (M)
        if (M instanceof h && p instanceof h && !(M instanceof e || M instanceof t)) {
          for (var S = M.nestedArray, AA = 0; AA < S.length; ++AA)
            p.add(S[AA]);
          this.remove(M), this.nested || (this.nested = {}), p.setOptions(M.options, !0);
        } else
          throw Error("duplicate name '" + p.name + "' in " + this);
    }
    this.nested[p.name] = p, this instanceof e || this instanceof t || this instanceof c || this instanceof E || p._edition || (p._edition = p._defaultEdition), this._needsRecursiveFeatureResolution = !0, this._needsRecursiveResolve = !0;
    for (var H = this; H = H.parent; )
      H._needsRecursiveFeatureResolution = !0, H._needsRecursiveResolve = !0;
    return p.onAdd(this), d(this);
  }, h.prototype.remove = function(p) {
    if (!(p instanceof o))
      throw TypeError("object must be a ReflectionObject");
    if (p.parent !== this)
      throw Error(p + " is not a member of " + this);
    return delete this.nested[p.name], Object.keys(this.nested).length || (this.nested = void 0), p.onRemove(this), d(this);
  }, h.prototype.define = function(p, M) {
    if (A.isString(p))
      p = p.split(".");
    else if (!Array.isArray(p))
      throw TypeError("illegal path");
    if (p && p.length && p[0] === "")
      throw Error("path must be relative");
    for (var S = this; p.length > 0; ) {
      var AA = p.shift();
      if (S.nested && S.nested[AA]) {
        if (S = S.nested[AA], !(S instanceof h))
          throw Error("path conflicts with non-namespace objects");
      } else
        S.add(S = new h(AA));
    }
    return M && S.addJSON(M), S;
  }, h.prototype.resolveAll = function() {
    if (!this._needsRecursiveResolve) return this;
    this._resolveFeaturesRecursive(this._edition);
    var p = this.nestedArray, M = 0;
    for (this.resolve(); M < p.length; )
      p[M] instanceof h ? p[M++].resolveAll() : p[M++].resolve();
    return this._needsRecursiveResolve = !1, this;
  }, h.prototype._resolveFeaturesRecursive = function(p) {
    return this._needsRecursiveFeatureResolution ? (this._needsRecursiveFeatureResolution = !1, p = this._edition || p, o.prototype._resolveFeaturesRecursive.call(this, p), this.nestedArray.forEach((M) => {
      M._resolveFeaturesRecursive(p);
    }), this) : this;
  }, h.prototype.lookup = function(p, M, S) {
    if (typeof M == "boolean" ? (S = M, M = void 0) : M && !Array.isArray(M) && (M = [M]), A.isString(p) && p.length) {
      if (p === ".")
        return this.root;
      p = p.split(".");
    } else if (!p.length)
      return this;
    var AA = p.join(".");
    if (p[0] === "")
      return this.root.lookup(p.slice(1), M);
    var H = this.root._fullyQualifiedObjects && this.root._fullyQualifiedObjects["." + AA];
    if (H && (!M || M.indexOf(H.constructor) > -1) || (H = this._lookupImpl(p, AA), H && (!M || M.indexOf(H.constructor) > -1)))
      return H;
    if (S)
      return null;
    for (var gA = this; gA.parent; ) {
      if (H = gA.parent._lookupImpl(p, AA), H && (!M || M.indexOf(H.constructor) > -1))
        return H;
      gA = gA.parent;
    }
    return null;
  }, h.prototype._lookupImpl = function(p, M) {
    if (Object.prototype.hasOwnProperty.call(this._lookupCache, M))
      return this._lookupCache[M];
    var S = this.get(p[0]), AA = null;
    if (S)
      p.length === 1 ? AA = S : S instanceof h && (p = p.slice(1), AA = S._lookupImpl(p, p.join(".")));
    else
      for (var H = 0; H < this.nestedArray.length; ++H)
        this._nestedArray[H] instanceof h && (S = this._nestedArray[H]._lookupImpl(p, M)) && (AA = S);
    return this._lookupCache[M] = AA, AA;
  }, h.prototype.lookupType = function(p) {
    var M = this.lookup(p, [e]);
    if (!M)
      throw Error("no such type: " + p);
    return M;
  }, h.prototype.lookupEnum = function(p) {
    var M = this.lookup(p, [c]);
    if (!M)
      throw Error("no such Enum '" + p + "' in " + this);
    return M;
  }, h.prototype.lookupTypeOrEnum = function(p) {
    var M = this.lookup(p, [e, c]);
    if (!M)
      throw Error("no such Type or Enum '" + p + "' in " + this);
    return M;
  }, h.prototype.lookupService = function(p) {
    var M = this.lookup(p, [t]);
    if (!M)
      throw Error("no such Service '" + p + "' in " + this);
    return M;
  }, h._configure = function(k, p, M) {
    e = k, t = p, c = M;
  }, namespace;
}
var mapfield, hasRequiredMapfield;
function requireMapfield() {
  if (hasRequiredMapfield) return mapfield;
  hasRequiredMapfield = 1, mapfield = g;
  var o = requireField();
  ((g.prototype = Object.create(o.prototype)).constructor = g).className = "MapField";
  var E = requireTypes(), A = requireUtil();
  function g(e, t, c, n, h, d) {
    if (o.call(this, e, t, n, void 0, void 0, h, d), !A.isString(c))
      throw TypeError("keyType must be a string");
    this.keyType = c, this.resolvedKeyType = null, this.map = !0;
  }
  return g.fromJSON = function(t, c) {
    return new g(t, c.id, c.keyType, c.type, c.options, c.comment);
  }, g.prototype.toJSON = function(t) {
    var c = t ? !!t.keepComments : !1;
    return A.toObject([
      "keyType",
      this.keyType,
      "type",
      this.type,
      "id",
      this.id,
      "extend",
      this.extend,
      "options",
      this.options,
      "comment",
      c ? this.comment : void 0
    ]);
  }, g.prototype.resolve = function() {
    if (this.resolved)
      return this;
    if (E.mapKey[this.keyType] === void 0)
      throw Error("invalid key type: " + this.keyType);
    return o.prototype.resolve.call(this);
  }, g.d = function(t, c, n) {
    return typeof n == "function" ? n = A.decorateType(n).name : n && typeof n == "object" && (n = A.decorateEnum(n).name), function(d, k) {
      A.decorateType(d.constructor).add(new g(k, t, c, n));
    };
  }, mapfield;
}
var method, hasRequiredMethod;
function requireMethod() {
  if (hasRequiredMethod) return method;
  hasRequiredMethod = 1, method = A;
  var o = requireObject();
  ((A.prototype = Object.create(o.prototype)).constructor = A).className = "Method";
  var E = requireUtil();
  function A(g, e, t, c, n, h, d, k, p) {
    if (E.isObject(n) ? (d = n, n = h = void 0) : E.isObject(h) && (d = h, h = void 0), !(e === void 0 || E.isString(e)))
      throw TypeError("type must be a string");
    if (!E.isString(t))
      throw TypeError("requestType must be a string");
    if (!E.isString(c))
      throw TypeError("responseType must be a string");
    o.call(this, g, d), this.type = e || "rpc", this.requestType = t, this.requestStream = n ? !0 : void 0, this.responseType = c, this.responseStream = h ? !0 : void 0, this.resolvedRequestType = null, this.resolvedResponseType = null, this.comment = k, this.parsedOptions = p;
  }
  return A.fromJSON = function(e, t) {
    return new A(e, t.type, t.requestType, t.responseType, t.requestStream, t.responseStream, t.options, t.comment, t.parsedOptions);
  }, A.prototype.toJSON = function(e) {
    var t = e ? !!e.keepComments : !1;
    return E.toObject([
      "type",
      this.type !== "rpc" && /* istanbul ignore next */
      this.type || void 0,
      "requestType",
      this.requestType,
      "requestStream",
      this.requestStream,
      "responseType",
      this.responseType,
      "responseStream",
      this.responseStream,
      "options",
      this.options,
      "comment",
      t ? this.comment : void 0,
      "parsedOptions",
      this.parsedOptions
    ]);
  }, A.prototype.resolve = function() {
    return this.resolved ? this : (this.resolvedRequestType = this.parent.lookupType(this.requestType), this.resolvedResponseType = this.parent.lookupType(this.responseType), o.prototype.resolve.call(this));
  }, method;
}
var service, hasRequiredService;
function requireService() {
  if (hasRequiredService) return service;
  hasRequiredService = 1, service = e;
  var o = requireNamespace();
  ((e.prototype = Object.create(o.prototype)).constructor = e).className = "Service";
  var E = requireMethod(), A = requireUtil(), g = requireRpc$1();
  function e(c, n) {
    o.call(this, c, n), this.methods = {}, this._methodsArray = null;
  }
  e.fromJSON = function(n, h) {
    var d = new e(n, h.options);
    if (h.methods)
      for (var k = Object.keys(h.methods), p = 0; p < k.length; ++p)
        d.add(E.fromJSON(k[p], h.methods[k[p]]));
    return h.nested && d.addJSON(h.nested), h.edition && (d._edition = h.edition), d.comment = h.comment, d._defaultEdition = "proto3", d;
  }, e.prototype.toJSON = function(n) {
    var h = o.prototype.toJSON.call(this, n), d = n ? !!n.keepComments : !1;
    return A.toObject([
      "edition",
      this._editionToJSON(),
      "options",
      h && h.options || void 0,
      "methods",
      o.arrayToJSON(this.methodsArray, n) || /* istanbul ignore next */
      {},
      "nested",
      h && h.nested || void 0,
      "comment",
      d ? this.comment : void 0
    ]);
  }, Object.defineProperty(e.prototype, "methodsArray", {
    get: function() {
      return this._methodsArray || (this._methodsArray = A.toArray(this.methods));
    }
  });
  function t(c) {
    return c._methodsArray = null, c;
  }
  return e.prototype.get = function(n) {
    return this.methods[n] || o.prototype.get.call(this, n);
  }, e.prototype.resolveAll = function() {
    if (!this._needsRecursiveResolve) return this;
    o.prototype.resolve.call(this);
    for (var n = this.methodsArray, h = 0; h < n.length; ++h)
      n[h].resolve();
    return this;
  }, e.prototype._resolveFeaturesRecursive = function(n) {
    return this._needsRecursiveFeatureResolution ? (n = this._edition || n, o.prototype._resolveFeaturesRecursive.call(this, n), this.methodsArray.forEach((h) => {
      h._resolveFeaturesRecursive(n);
    }), this) : this;
  }, e.prototype.add = function(n) {
    if (this.get(n.name))
      throw Error("duplicate name '" + n.name + "' in " + this);
    return n instanceof E ? (this.methods[n.name] = n, n.parent = this, t(this)) : o.prototype.add.call(this, n);
  }, e.prototype.remove = function(n) {
    if (n instanceof E) {
      if (this.methods[n.name] !== n)
        throw Error(n + " is not a member of " + this);
      return delete this.methods[n.name], n.parent = null, t(this);
    }
    return o.prototype.remove.call(this, n);
  }, e.prototype.create = function(n, h, d) {
    for (var k = new g.Service(n, h, d), p = 0, M; p < /* initializes */
    this.methodsArray.length; ++p) {
      var S = A.lcFirst((M = this._methodsArray[p]).resolve().name).replace(/[^$\w_]/g, "");
      k[S] = A.codegen(["r", "c"], A.isReserved(S) ? S + "_" : S)("return this.rpcCall(m,q,s,r,c)")({
        m: M,
        q: M.resolvedRequestType.ctor,
        s: M.resolvedResponseType.ctor
      });
    }
    return k;
  }, service;
}
var message, hasRequiredMessage;
function requireMessage() {
  if (hasRequiredMessage) return message;
  hasRequiredMessage = 1, message = E;
  var o = requireMinimal$3();
  function E(A) {
    if (A)
      for (var g = Object.keys(A), e = 0; e < g.length; ++e)
        this[g[e]] = A[g[e]];
  }
  return E.create = function(g) {
    return this.$type.create(g);
  }, E.encode = function(g, e) {
    return this.$type.encode(g, e);
  }, E.encodeDelimited = function(g, e) {
    return this.$type.encodeDelimited(g, e);
  }, E.decode = function(g) {
    return this.$type.decode(g);
  }, E.decodeDelimited = function(g) {
    return this.$type.decodeDelimited(g);
  }, E.verify = function(g) {
    return this.$type.verify(g);
  }, E.fromObject = function(g) {
    return this.$type.fromObject(g);
  }, E.toObject = function(g, e) {
    return this.$type.toObject(g, e);
  }, E.prototype.toJSON = function() {
    return this.$type.toObject(this, o.toJSONOptions);
  }, message;
}
var decoder_1, hasRequiredDecoder;
function requireDecoder() {
  if (hasRequiredDecoder) return decoder_1;
  hasRequiredDecoder = 1, decoder_1 = e;
  var o = require_enum(), E = requireTypes(), A = requireUtil();
  function g(t) {
    return "missing required '" + t.name + "'";
  }
  function e(t) {
    for (var c = A.codegen(["r", "l", "e"], t.name + "$decode")("if(!(r instanceof Reader))")("r=Reader.create(r)")("var c=l===undefined?r.len:r.pos+l,m=new this.ctor" + (t.fieldsArray.filter(function(M) {
      return M.map;
    }).length ? ",k,value" : ""))("while(r.pos<c){")("var t=r.uint32()")("if(t===e)")("break")("switch(t>>>3){"), n = 0; n < /* initializes */
    t.fieldsArray.length; ++n) {
      var h = t._fieldsArray[n].resolve(), d = h.resolvedType instanceof o ? "int32" : h.type, k = "m" + A.safeProp(h.name);
      c("case %i: {", h.id), h.map ? (c("if(%s===util.emptyObject)", k)("%s={}", k)("var c2 = r.uint32()+r.pos"), E.defaults[h.keyType] !== void 0 ? c("k=%j", E.defaults[h.keyType]) : c("k=null"), E.defaults[d] !== void 0 ? c("value=%j", E.defaults[d]) : c("value=null"), c("while(r.pos<c2){")("var tag2=r.uint32()")("switch(tag2>>>3){")("case 1: k=r.%s(); break", h.keyType)("case 2:"), E.basic[d] === void 0 ? c("value=types[%i].decode(r,r.uint32())", n) : c("value=r.%s()", d), c("break")("default:")("r.skipType(tag2&7)")("break")("}")("}"), E.long[h.keyType] !== void 0 ? c('%s[typeof k==="object"?util.longToHash(k):k]=value', k) : c("%s[k]=value", k)) : h.repeated ? (c("if(!(%s&&%s.length))", k, k)("%s=[]", k), E.packed[d] !== void 0 && c("if((t&7)===2){")("var c2=r.uint32()+r.pos")("while(r.pos<c2)")("%s.push(r.%s())", k, d)("}else"), E.basic[d] === void 0 ? c(h.delimited ? "%s.push(types[%i].decode(r,undefined,((t&~7)|4)))" : "%s.push(types[%i].decode(r,r.uint32()))", k, n) : c("%s.push(r.%s())", k, d)) : E.basic[d] === void 0 ? c(h.delimited ? "%s=types[%i].decode(r,undefined,((t&~7)|4))" : "%s=types[%i].decode(r,r.uint32())", k, n) : c("%s=r.%s()", k, d), c("break")("}");
    }
    for (c("default:")("r.skipType(t&7)")("break")("}")("}"), n = 0; n < t._fieldsArray.length; ++n) {
      var p = t._fieldsArray[n];
      p.required && c("if(!m.hasOwnProperty(%j))", p.name)("throw util.ProtocolError(%j,{instance:m})", g(p));
    }
    return c("return m");
  }
  return decoder_1;
}
var verifier_1, hasRequiredVerifier;
function requireVerifier() {
  if (hasRequiredVerifier) return verifier_1;
  hasRequiredVerifier = 1, verifier_1 = t;
  var o = require_enum(), E = requireUtil();
  function A(c, n) {
    return c.name + ": " + n + (c.repeated && n !== "array" ? "[]" : c.map && n !== "object" ? "{k:" + c.keyType + "}" : "") + " expected";
  }
  function g(c, n, h, d) {
    if (n.resolvedType)
      if (n.resolvedType instanceof o) {
        c("switch(%s){", d)("default:")("return%j", A(n, "enum value"));
        for (var k = Object.keys(n.resolvedType.values), p = 0; p < k.length; ++p) c("case %i:", n.resolvedType.values[k[p]]);
        c("break")("}");
      } else
        c("{")("var e=types[%i].verify(%s);", h, d)("if(e)")("return%j+e", n.name + ".")("}");
    else
      switch (n.type) {
        case "int32":
        case "uint32":
        case "sint32":
        case "fixed32":
        case "sfixed32":
          c("if(!util.isInteger(%s))", d)("return%j", A(n, "integer"));
          break;
        case "int64":
        case "uint64":
        case "sint64":
        case "fixed64":
        case "sfixed64":
          c("if(!util.isInteger(%s)&&!(%s&&util.isInteger(%s.low)&&util.isInteger(%s.high)))", d, d, d, d)("return%j", A(n, "integer|Long"));
          break;
        case "float":
        case "double":
          c('if(typeof %s!=="number")', d)("return%j", A(n, "number"));
          break;
        case "bool":
          c('if(typeof %s!=="boolean")', d)("return%j", A(n, "boolean"));
          break;
        case "string":
          c("if(!util.isString(%s))", d)("return%j", A(n, "string"));
          break;
        case "bytes":
          c('if(!(%s&&typeof %s.length==="number"||util.isString(%s)))', d, d, d)("return%j", A(n, "buffer"));
          break;
      }
    return c;
  }
  function e(c, n, h) {
    switch (n.keyType) {
      case "int32":
      case "uint32":
      case "sint32":
      case "fixed32":
      case "sfixed32":
        c("if(!util.key32Re.test(%s))", h)("return%j", A(n, "integer key"));
        break;
      case "int64":
      case "uint64":
      case "sint64":
      case "fixed64":
      case "sfixed64":
        c("if(!util.key64Re.test(%s))", h)("return%j", A(n, "integer|Long key"));
        break;
      case "bool":
        c("if(!util.key2Re.test(%s))", h)("return%j", A(n, "boolean key"));
        break;
    }
    return c;
  }
  function t(c) {
    var n = E.codegen(["m"], c.name + "$verify")('if(typeof m!=="object"||m===null)')("return%j", "object expected"), h = c.oneofsArray, d = {};
    h.length && n("var p={}");
    for (var k = 0; k < /* initializes */
    c.fieldsArray.length; ++k) {
      var p = c._fieldsArray[k].resolve(), M = "m" + E.safeProp(p.name);
      if (p.optional && n("if(%s!=null&&m.hasOwnProperty(%j)){", M, p.name), p.map)
        n("if(!util.isObject(%s))", M)("return%j", A(p, "object"))("var k=Object.keys(%s)", M)("for(var i=0;i<k.length;++i){"), e(n, p, "k[i]"), g(n, p, k, M + "[k[i]]")("}");
      else if (p.repeated)
        n("if(!Array.isArray(%s))", M)("return%j", A(p, "array"))("for(var i=0;i<%s.length;++i){", M), g(n, p, k, M + "[i]")("}");
      else {
        if (p.partOf) {
          var S = E.safeProp(p.partOf.name);
          d[p.partOf.name] === 1 && n("if(p%s===1)", S)("return%j", p.partOf.name + ": multiple values"), d[p.partOf.name] = 1, n("p%s=1", S);
        }
        g(n, p, k, M);
      }
      p.optional && n("}");
    }
    return n("return null");
  }
  return verifier_1;
}
var converter = {}, hasRequiredConverter;
function requireConverter() {
  return hasRequiredConverter || (hasRequiredConverter = 1, (function(o) {
    var E = o, A = require_enum(), g = requireUtil();
    function e(c, n, h, d) {
      var k = !1;
      if (n.resolvedType)
        if (n.resolvedType instanceof A) {
          c("switch(d%s){", d);
          for (var p = n.resolvedType.values, M = Object.keys(p), S = 0; S < M.length; ++S)
            p[M[S]] === n.typeDefault && !k && (c("default:")('if(typeof(d%s)==="number"){m%s=d%s;break}', d, d, d), n.repeated || c("break"), k = !0), c("case%j:", M[S])("case %i:", p[M[S]])("m%s=%j", d, p[M[S]])("break");
          c("}");
        } else c('if(typeof d%s!=="object")', d)("throw TypeError(%j)", n.fullName + ": object expected")("m%s=types[%i].fromObject(d%s)", d, h, d);
      else {
        var AA = !1;
        switch (n.type) {
          case "double":
          case "float":
            c("m%s=Number(d%s)", d, d);
            break;
          case "uint32":
          case "fixed32":
            c("m%s=d%s>>>0", d, d);
            break;
          case "int32":
          case "sint32":
          case "sfixed32":
            c("m%s=d%s|0", d, d);
            break;
          case "uint64":
            AA = !0;
          // eslint-disable-next-line no-fallthrough
          case "int64":
          case "sint64":
          case "fixed64":
          case "sfixed64":
            c("if(util.Long)")("(m%s=util.Long.fromValue(d%s)).unsigned=%j", d, d, AA)('else if(typeof d%s==="string")', d)("m%s=parseInt(d%s,10)", d, d)('else if(typeof d%s==="number")', d)("m%s=d%s", d, d)('else if(typeof d%s==="object")', d)("m%s=new util.LongBits(d%s.low>>>0,d%s.high>>>0).toNumber(%s)", d, d, d, AA ? "true" : "");
            break;
          case "bytes":
            c('if(typeof d%s==="string")', d)("util.base64.decode(d%s,m%s=util.newBuffer(util.base64.length(d%s)),0)", d, d, d)("else if(d%s.length >= 0)", d)("m%s=d%s", d, d);
            break;
          case "string":
            c("m%s=String(d%s)", d, d);
            break;
          case "bool":
            c("m%s=Boolean(d%s)", d, d);
            break;
        }
      }
      return c;
    }
    E.fromObject = function(n) {
      var h = n.fieldsArray, d = g.codegen(["d"], n.name + "$fromObject")("if(d instanceof this.ctor)")("return d");
      if (!h.length) return d("return new this.ctor");
      d("var m=new this.ctor");
      for (var k = 0; k < h.length; ++k) {
        var p = h[k].resolve(), M = g.safeProp(p.name);
        p.map ? (d("if(d%s){", M)('if(typeof d%s!=="object")', M)("throw TypeError(%j)", p.fullName + ": object expected")("m%s={}", M)("for(var ks=Object.keys(d%s),i=0;i<ks.length;++i){", M), e(
          d,
          p,
          /* not sorted */
          k,
          M + "[ks[i]]"
        )("}")("}")) : p.repeated ? (d("if(d%s){", M)("if(!Array.isArray(d%s))", M)("throw TypeError(%j)", p.fullName + ": array expected")("m%s=[]", M)("for(var i=0;i<d%s.length;++i){", M), e(
          d,
          p,
          /* not sorted */
          k,
          M + "[i]"
        )("}")("}")) : (p.resolvedType instanceof A || d("if(d%s!=null){", M), e(
          d,
          p,
          /* not sorted */
          k,
          M
        ), p.resolvedType instanceof A || d("}"));
      }
      return d("return m");
    };
    function t(c, n, h, d) {
      if (n.resolvedType)
        n.resolvedType instanceof A ? c("d%s=o.enums===String?(types[%i].values[m%s]===undefined?m%s:types[%i].values[m%s]):m%s", d, h, d, d, h, d, d) : c("d%s=types[%i].toObject(m%s,o)", d, h, d);
      else {
        var k = !1;
        switch (n.type) {
          case "double":
          case "float":
            c("d%s=o.json&&!isFinite(m%s)?String(m%s):m%s", d, d, d, d);
            break;
          case "uint64":
            k = !0;
          // eslint-disable-next-line no-fallthrough
          case "int64":
          case "sint64":
          case "fixed64":
          case "sfixed64":
            c('if(typeof m%s==="number")', d)("d%s=o.longs===String?String(m%s):m%s", d, d, d)("else")("d%s=o.longs===String?util.Long.prototype.toString.call(m%s):o.longs===Number?new util.LongBits(m%s.low>>>0,m%s.high>>>0).toNumber(%s):m%s", d, d, d, d, k ? "true" : "", d);
            break;
          case "bytes":
            c("d%s=o.bytes===String?util.base64.encode(m%s,0,m%s.length):o.bytes===Array?Array.prototype.slice.call(m%s):m%s", d, d, d, d, d);
            break;
          default:
            c("d%s=m%s", d, d);
            break;
        }
      }
      return c;
    }
    E.toObject = function(n) {
      var h = n.fieldsArray.slice().sort(g.compareFieldsById);
      if (!h.length)
        return g.codegen()("return {}");
      for (var d = g.codegen(["m", "o"], n.name + "$toObject")("if(!o)")("o={}")("var d={}"), k = [], p = [], M = [], S = 0; S < h.length; ++S)
        h[S].partOf || (h[S].resolve().repeated ? k : h[S].map ? p : M).push(h[S]);
      if (k.length) {
        for (d("if(o.arrays||o.defaults){"), S = 0; S < k.length; ++S) d("d%s=[]", g.safeProp(k[S].name));
        d("}");
      }
      if (p.length) {
        for (d("if(o.objects||o.defaults){"), S = 0; S < p.length; ++S) d("d%s={}", g.safeProp(p[S].name));
        d("}");
      }
      if (M.length) {
        for (d("if(o.defaults){"), S = 0; S < M.length; ++S) {
          var AA = M[S], H = g.safeProp(AA.name);
          if (AA.resolvedType instanceof A) d("d%s=o.enums===String?%j:%j", H, AA.resolvedType.valuesById[AA.typeDefault], AA.typeDefault);
          else if (AA.long) d("if(util.Long){")("var n=new util.Long(%i,%i,%j)", AA.typeDefault.low, AA.typeDefault.high, AA.typeDefault.unsigned)("d%s=o.longs===String?n.toString():o.longs===Number?n.toNumber():n", H)("}else")("d%s=o.longs===String?%j:%i", H, AA.typeDefault.toString(), AA.typeDefault.toNumber());
          else if (AA.bytes) {
            var gA = "[" + Array.prototype.slice.call(AA.typeDefault).join(",") + "]";
            d("if(o.bytes===String)d%s=%j", H, String.fromCharCode.apply(String, AA.typeDefault))("else{")("d%s=%s", H, gA)("if(o.bytes!==Array)d%s=util.newBuffer(d%s)", H, H)("}");
          } else d("d%s=%j", H, AA.typeDefault);
        }
        d("}");
      }
      var CA = !1;
      for (S = 0; S < h.length; ++S) {
        var AA = h[S], IA = n._fieldsArray.indexOf(AA), H = g.safeProp(AA.name);
        AA.map ? (CA || (CA = !0, d("var ks2")), d("if(m%s&&(ks2=Object.keys(m%s)).length){", H, H)("d%s={}", H)("for(var j=0;j<ks2.length;++j){"), t(
          d,
          AA,
          /* sorted */
          IA,
          H + "[ks2[j]]"
        )("}")) : AA.repeated ? (d("if(m%s&&m%s.length){", H, H)("d%s=[]", H)("for(var j=0;j<m%s.length;++j){", H), t(
          d,
          AA,
          /* sorted */
          IA,
          H + "[j]"
        )("}")) : (d("if(m%s!=null&&m.hasOwnProperty(%j)){", H, AA.name), t(
          d,
          AA,
          /* sorted */
          IA,
          H
        ), AA.partOf && d("if(o.oneofs)")("d%s=%j", g.safeProp(AA.partOf.name), AA.name)), d("}");
      }
      return d("return d");
    };
  })(converter)), converter;
}
var wrappers = {}, hasRequiredWrappers;
function requireWrappers() {
  return hasRequiredWrappers || (hasRequiredWrappers = 1, (function(o) {
    var E = o, A = requireMessage();
    E[".google.protobuf.Any"] = {
      fromObject: function(g) {
        if (g && g["@type"]) {
          var e = g["@type"].substring(g["@type"].lastIndexOf("/") + 1), t = this.lookup(e);
          if (t) {
            var c = g["@type"].charAt(0) === "." ? g["@type"].slice(1) : g["@type"];
            return c.indexOf("/") === -1 && (c = "/" + c), this.create({
              type_url: c,
              value: t.encode(t.fromObject(g)).finish()
            });
          }
        }
        return this.fromObject(g);
      },
      toObject: function(g, e) {
        var t = "type.googleapis.com/", c = "", n = "";
        if (e && e.json && g.type_url && g.value) {
          n = g.type_url.substring(g.type_url.lastIndexOf("/") + 1), c = g.type_url.substring(0, g.type_url.lastIndexOf("/") + 1);
          var h = this.lookup(n);
          h && (g = h.decode(g.value));
        }
        if (!(g instanceof this.ctor) && g instanceof A) {
          var d = g.$type.toObject(g, e), k = g.$type.fullName[0] === "." ? g.$type.fullName.slice(1) : g.$type.fullName;
          return c === "" && (c = t), n = c + k, d["@type"] = n, d;
        }
        return this.toObject(g, e);
      }
    };
  })(wrappers)), wrappers;
}
var type, hasRequiredType;
function requireType() {
  if (hasRequiredType) return type;
  hasRequiredType = 1, type = H;
  var o = requireNamespace();
  ((H.prototype = Object.create(o.prototype)).constructor = H).className = "Type";
  var E = require_enum(), A = requireOneof(), g = requireField(), e = requireMapfield(), t = requireService(), c = requireMessage(), n = requireReader$1(), h = requireWriter$1(), d = requireUtil(), k = requireEncoder(), p = requireDecoder(), M = requireVerifier(), S = requireConverter(), AA = requireWrappers();
  function H(CA, IA) {
    o.call(this, CA, IA), this.fields = {}, this.oneofs = void 0, this.extensions = void 0, this.reserved = void 0, this.group = void 0, this._fieldsById = null, this._fieldsArray = null, this._oneofsArray = null, this._ctor = null;
  }
  Object.defineProperties(H.prototype, {
    /**
     * Message fields by id.
     * @name Type#fieldsById
     * @type {Object.<number,Field>}
     * @readonly
     */
    fieldsById: {
      get: function() {
        if (this._fieldsById)
          return this._fieldsById;
        this._fieldsById = {};
        for (var CA = Object.keys(this.fields), IA = 0; IA < CA.length; ++IA) {
          var BA = this.fields[CA[IA]], QA = BA.id;
          if (this._fieldsById[QA])
            throw Error("duplicate id " + QA + " in " + this);
          this._fieldsById[QA] = BA;
        }
        return this._fieldsById;
      }
    },
    /**
     * Fields of this message as an array for iteration.
     * @name Type#fieldsArray
     * @type {Field[]}
     * @readonly
     */
    fieldsArray: {
      get: function() {
        return this._fieldsArray || (this._fieldsArray = d.toArray(this.fields));
      }
    },
    /**
     * Oneofs of this message as an array for iteration.
     * @name Type#oneofsArray
     * @type {OneOf[]}
     * @readonly
     */
    oneofsArray: {
      get: function() {
        return this._oneofsArray || (this._oneofsArray = d.toArray(this.oneofs));
      }
    },
    /**
     * The registered constructor, if any registered, otherwise a generic constructor.
     * Assigning a function replaces the internal constructor. If the function does not extend {@link Message} yet, its prototype will be setup accordingly and static methods will be populated. If it already extends {@link Message}, it will just replace the internal constructor.
     * @name Type#ctor
     * @type {Constructor<{}>}
     */
    ctor: {
      get: function() {
        return this._ctor || (this.ctor = H.generateConstructor(this)());
      },
      set: function(CA) {
        var IA = CA.prototype;
        IA instanceof c || ((CA.prototype = new c()).constructor = CA, d.merge(CA.prototype, IA)), CA.$type = CA.prototype.$type = this, d.merge(CA, c, !0), this._ctor = CA;
        for (var BA = 0; BA < /* initializes */
        this.fieldsArray.length; ++BA)
          this._fieldsArray[BA].resolve();
        var QA = {};
        for (BA = 0; BA < /* initializes */
        this.oneofsArray.length; ++BA)
          QA[this._oneofsArray[BA].resolve().name] = {
            get: d.oneOfGetter(this._oneofsArray[BA].oneof),
            set: d.oneOfSetter(this._oneofsArray[BA].oneof)
          };
        BA && Object.defineProperties(CA.prototype, QA);
      }
    }
  }), H.generateConstructor = function(IA) {
    for (var BA = d.codegen(["p"], IA.name), QA = 0, EA; QA < IA.fieldsArray.length; ++QA)
      (EA = IA._fieldsArray[QA]).map ? BA("this%s={}", d.safeProp(EA.name)) : EA.repeated && BA("this%s=[]", d.safeProp(EA.name));
    return BA("if(p)for(var ks=Object.keys(p),i=0;i<ks.length;++i)if(p[ks[i]]!=null)")("this[ks[i]]=p[ks[i]]");
  };
  function gA(CA) {
    return CA._fieldsById = CA._fieldsArray = CA._oneofsArray = null, delete CA.encode, delete CA.decode, delete CA.verify, CA;
  }
  return H.fromJSON = function(IA, BA) {
    var QA = new H(IA, BA.options);
    QA.extensions = BA.extensions, QA.reserved = BA.reserved;
    for (var EA = Object.keys(BA.fields), oA = 0; oA < EA.length; ++oA)
      QA.add(
        (typeof BA.fields[EA[oA]].keyType < "u" ? e.fromJSON : g.fromJSON)(EA[oA], BA.fields[EA[oA]])
      );
    if (BA.oneofs)
      for (EA = Object.keys(BA.oneofs), oA = 0; oA < EA.length; ++oA)
        QA.add(A.fromJSON(EA[oA], BA.oneofs[EA[oA]]));
    if (BA.nested)
      for (EA = Object.keys(BA.nested), oA = 0; oA < EA.length; ++oA) {
        var iA = BA.nested[EA[oA]];
        QA.add(
          // most to least likely
          (iA.id !== void 0 ? g.fromJSON : iA.fields !== void 0 ? H.fromJSON : iA.values !== void 0 ? E.fromJSON : iA.methods !== void 0 ? t.fromJSON : o.fromJSON)(EA[oA], iA)
        );
      }
    return BA.extensions && BA.extensions.length && (QA.extensions = BA.extensions), BA.reserved && BA.reserved.length && (QA.reserved = BA.reserved), BA.group && (QA.group = !0), BA.comment && (QA.comment = BA.comment), BA.edition && (QA._edition = BA.edition), QA._defaultEdition = "proto3", QA;
  }, H.prototype.toJSON = function(IA) {
    var BA = o.prototype.toJSON.call(this, IA), QA = IA ? !!IA.keepComments : !1;
    return d.toObject([
      "edition",
      this._editionToJSON(),
      "options",
      BA && BA.options || void 0,
      "oneofs",
      o.arrayToJSON(this.oneofsArray, IA),
      "fields",
      o.arrayToJSON(this.fieldsArray.filter(function(EA) {
        return !EA.declaringField;
      }), IA) || {},
      "extensions",
      this.extensions && this.extensions.length ? this.extensions : void 0,
      "reserved",
      this.reserved && this.reserved.length ? this.reserved : void 0,
      "group",
      this.group || void 0,
      "nested",
      BA && BA.nested || void 0,
      "comment",
      QA ? this.comment : void 0
    ]);
  }, H.prototype.resolveAll = function() {
    if (!this._needsRecursiveResolve) return this;
    o.prototype.resolveAll.call(this);
    var IA = this.oneofsArray;
    for (QA = 0; QA < IA.length; )
      IA[QA++].resolve();
    for (var BA = this.fieldsArray, QA = 0; QA < BA.length; )
      BA[QA++].resolve();
    return this;
  }, H.prototype._resolveFeaturesRecursive = function(IA) {
    return this._needsRecursiveFeatureResolution ? (IA = this._edition || IA, o.prototype._resolveFeaturesRecursive.call(this, IA), this.oneofsArray.forEach((BA) => {
      BA._resolveFeatures(IA);
    }), this.fieldsArray.forEach((BA) => {
      BA._resolveFeatures(IA);
    }), this) : this;
  }, H.prototype.get = function(IA) {
    return this.fields[IA] || this.oneofs && this.oneofs[IA] || this.nested && this.nested[IA] || null;
  }, H.prototype.add = function(IA) {
    if (this.get(IA.name))
      throw Error("duplicate name '" + IA.name + "' in " + this);
    if (IA instanceof g && IA.extend === void 0) {
      if (this._fieldsById ? (
        /* istanbul ignore next */
        this._fieldsById[IA.id]
      ) : this.fieldsById[IA.id])
        throw Error("duplicate id " + IA.id + " in " + this);
      if (this.isReservedId(IA.id))
        throw Error("id " + IA.id + " is reserved in " + this);
      if (this.isReservedName(IA.name))
        throw Error("name '" + IA.name + "' is reserved in " + this);
      return IA.parent && IA.parent.remove(IA), this.fields[IA.name] = IA, IA.message = this, IA.onAdd(this), gA(this);
    }
    return IA instanceof A ? (this.oneofs || (this.oneofs = {}), this.oneofs[IA.name] = IA, IA.onAdd(this), gA(this)) : o.prototype.add.call(this, IA);
  }, H.prototype.remove = function(IA) {
    if (IA instanceof g && IA.extend === void 0) {
      if (!this.fields || this.fields[IA.name] !== IA)
        throw Error(IA + " is not a member of " + this);
      return delete this.fields[IA.name], IA.parent = null, IA.onRemove(this), gA(this);
    }
    if (IA instanceof A) {
      if (!this.oneofs || this.oneofs[IA.name] !== IA)
        throw Error(IA + " is not a member of " + this);
      return delete this.oneofs[IA.name], IA.parent = null, IA.onRemove(this), gA(this);
    }
    return o.prototype.remove.call(this, IA);
  }, H.prototype.isReservedId = function(IA) {
    return o.isReservedId(this.reserved, IA);
  }, H.prototype.isReservedName = function(IA) {
    return o.isReservedName(this.reserved, IA);
  }, H.prototype.create = function(IA) {
    return new this.ctor(IA);
  }, H.prototype.setup = function() {
    for (var IA = this.fullName, BA = [], QA = 0; QA < /* initializes */
    this.fieldsArray.length; ++QA)
      BA.push(this._fieldsArray[QA].resolve().resolvedType);
    this.encode = k(this)({
      Writer: h,
      types: BA,
      util: d
    }), this.decode = p(this)({
      Reader: n,
      types: BA,
      util: d
    }), this.verify = M(this)({
      types: BA,
      util: d
    }), this.fromObject = S.fromObject(this)({
      types: BA,
      util: d
    }), this.toObject = S.toObject(this)({
      types: BA,
      util: d
    });
    var EA = AA[IA];
    if (EA) {
      var oA = Object.create(this);
      oA.fromObject = this.fromObject, this.fromObject = EA.fromObject.bind(oA), oA.toObject = this.toObject, this.toObject = EA.toObject.bind(oA);
    }
    return this;
  }, H.prototype.encode = function(IA, BA) {
    return this.setup().encode(IA, BA);
  }, H.prototype.encodeDelimited = function(IA, BA) {
    return this.encode(IA, BA && BA.len ? BA.fork() : BA).ldelim();
  }, H.prototype.decode = function(IA, BA) {
    return this.setup().decode(IA, BA);
  }, H.prototype.decodeDelimited = function(IA) {
    return IA instanceof n || (IA = n.create(IA)), this.decode(IA, IA.uint32());
  }, H.prototype.verify = function(IA) {
    return this.setup().verify(IA);
  }, H.prototype.fromObject = function(IA) {
    return this.setup().fromObject(IA);
  }, H.prototype.toObject = function(IA, BA) {
    return this.setup().toObject(IA, BA);
  }, H.d = function(IA) {
    return function(QA) {
      d.decorateType(QA, IA);
    };
  }, type;
}
var root, hasRequiredRoot;
function requireRoot() {
  if (hasRequiredRoot) return root;
  hasRequiredRoot = 1, root = h;
  var o = requireNamespace();
  ((h.prototype = Object.create(o.prototype)).constructor = h).className = "Root";
  var E = requireField(), A = require_enum(), g = requireOneof(), e = requireUtil(), t, c, n;
  function h(M) {
    o.call(this, "", M), this.deferred = [], this.files = [], this._edition = "proto2", this._fullyQualifiedObjects = {};
  }
  h.fromJSON = function(S, AA) {
    return AA || (AA = new h()), S.options && AA.setOptions(S.options), AA.addJSON(S.nested).resolveAll();
  }, h.prototype.resolvePath = e.path.resolve, h.prototype.fetch = e.fetch;
  function d() {
  }
  h.prototype.load = function M(S, AA, H) {
    typeof AA == "function" && (H = AA, AA = void 0);
    var gA = this;
    if (!H)
      return e.asPromise(M, gA, S, AA);
    var CA = H === d;
    function IA(tA, eA) {
      if (H) {
        if (CA)
          throw tA;
        eA && eA.resolveAll();
        var cA = H;
        H = null, cA(tA, eA);
      }
    }
    function BA(tA) {
      var eA = tA.lastIndexOf("google/protobuf/");
      if (eA > -1) {
        var cA = tA.substring(eA);
        if (cA in n) return cA;
      }
      return null;
    }
    function QA(tA, eA) {
      try {
        if (e.isString(eA) && eA.charAt(0) === "{" && (eA = JSON.parse(eA)), !e.isString(eA))
          gA.setOptions(eA.options).addJSON(eA.nested);
        else {
          c.filename = tA;
          var cA = c(eA, gA, AA), DA, nA = 0;
          if (cA.imports)
            for (; nA < cA.imports.length; ++nA)
              (DA = BA(cA.imports[nA]) || gA.resolvePath(tA, cA.imports[nA])) && EA(DA);
          if (cA.weakImports)
            for (nA = 0; nA < cA.weakImports.length; ++nA)
              (DA = BA(cA.weakImports[nA]) || gA.resolvePath(tA, cA.weakImports[nA])) && EA(DA, !0);
        }
      } catch (wA) {
        IA(wA);
      }
      !CA && !oA && IA(null, gA);
    }
    function EA(tA, eA) {
      if (tA = BA(tA) || tA, !(gA.files.indexOf(tA) > -1)) {
        if (gA.files.push(tA), tA in n) {
          CA ? QA(tA, n[tA]) : (++oA, setTimeout(function() {
            --oA, QA(tA, n[tA]);
          }));
          return;
        }
        if (CA) {
          var cA;
          try {
            cA = e.fs.readFileSync(tA).toString("utf8");
          } catch (DA) {
            eA || IA(DA);
            return;
          }
          QA(tA, cA);
        } else
          ++oA, gA.fetch(tA, function(DA, nA) {
            if (--oA, !!H) {
              if (DA) {
                eA ? oA || IA(null, gA) : IA(DA);
                return;
              }
              QA(tA, nA);
            }
          });
      }
    }
    var oA = 0;
    e.isString(S) && (S = [S]);
    for (var iA = 0, aA; iA < S.length; ++iA)
      (aA = gA.resolvePath("", S[iA])) && EA(aA);
    return CA ? (gA.resolveAll(), gA) : (oA || IA(null, gA), gA);
  }, h.prototype.loadSync = function(S, AA) {
    if (!e.isNode)
      throw Error("not supported");
    return this.load(S, AA, d);
  }, h.prototype.resolveAll = function() {
    if (!this._needsRecursiveResolve) return this;
    if (this.deferred.length)
      throw Error("unresolvable extensions: " + this.deferred.map(function(S) {
        return "'extend " + S.extend + "' in " + S.parent.fullName;
      }).join(", "));
    return o.prototype.resolveAll.call(this);
  };
  var k = /^[A-Z]/;
  function p(M, S) {
    var AA = S.parent.lookup(S.extend);
    if (AA) {
      var H = new E(S.fullName, S.id, S.type, S.rule, void 0, S.options);
      return AA.get(H.name) || (H.declaringField = S, S.extensionField = H, AA.add(H)), !0;
    }
    return !1;
  }
  return h.prototype._handleAdd = function(S) {
    if (S instanceof E)
      /* an extension field (implies not part of a oneof) */
      S.extend !== void 0 && /* not already handled */
      !S.extensionField && (p(this, S) || this.deferred.push(S));
    else if (S instanceof A)
      k.test(S.name) && (S.parent[S.name] = S.values);
    else if (!(S instanceof g)) {
      if (S instanceof t)
        for (var AA = 0; AA < this.deferred.length; )
          p(this, this.deferred[AA]) ? this.deferred.splice(AA, 1) : ++AA;
      for (var H = 0; H < /* initializes */
      S.nestedArray.length; ++H)
        this._handleAdd(S._nestedArray[H]);
      k.test(S.name) && (S.parent[S.name] = S);
    }
    (S instanceof t || S instanceof A || S instanceof E) && (this._fullyQualifiedObjects[S.fullName] = S);
  }, h.prototype._handleRemove = function(S) {
    if (S instanceof E) {
      if (
        /* an extension field */
        S.extend !== void 0
      )
        if (
          /* already handled */
          S.extensionField
        )
          S.extensionField.parent.remove(S.extensionField), S.extensionField = null;
        else {
          var AA = this.deferred.indexOf(S);
          AA > -1 && this.deferred.splice(AA, 1);
        }
    } else if (S instanceof A)
      k.test(S.name) && delete S.parent[S.name];
    else if (S instanceof o) {
      for (var H = 0; H < /* initializes */
      S.nestedArray.length; ++H)
        this._handleRemove(S._nestedArray[H]);
      k.test(S.name) && delete S.parent[S.name];
    }
    delete this._fullyQualifiedObjects[S.fullName];
  }, h._configure = function(M, S, AA) {
    t = M, c = S, n = AA;
  }, root;
}
var hasRequiredUtil;
function requireUtil() {
  if (hasRequiredUtil) return util.exports;
  hasRequiredUtil = 1;
  var o = util.exports = requireMinimal$3(), E = requireRoots$1(), A, g;
  o.codegen = requireCodegen(), o.fetch = requireFetch(), o.path = requirePath(), o.fs = o.inquire("fs"), o.toArray = function(d) {
    if (d) {
      for (var k = Object.keys(d), p = new Array(k.length), M = 0; M < k.length; )
        p[M] = d[k[M++]];
      return p;
    }
    return [];
  }, o.toObject = function(d) {
    for (var k = {}, p = 0; p < d.length; ) {
      var M = d[p++], S = d[p++];
      S !== void 0 && (k[M] = S);
    }
    return k;
  };
  var e = /\\/g, t = /"/g;
  o.isReserved = function(d) {
    return /^(?:do|if|in|for|let|new|try|var|case|else|enum|eval|false|null|this|true|void|with|break|catch|class|const|super|throw|while|yield|delete|export|import|public|return|static|switch|typeof|default|extends|finally|package|private|continue|debugger|function|arguments|interface|protected|implements|instanceof)$/.test(d);
  }, o.safeProp = function(d) {
    return !/^[$\w_]+$/.test(d) || o.isReserved(d) ? '["' + d.replace(e, "\\\\").replace(t, '\\"') + '"]' : "." + d;
  }, o.ucFirst = function(d) {
    return d.charAt(0).toUpperCase() + d.substring(1);
  };
  var c = /_([a-z])/g;
  o.camelCase = function(d) {
    return d.substring(0, 1) + d.substring(1).replace(c, function(k, p) {
      return p.toUpperCase();
    });
  }, o.compareFieldsById = function(d, k) {
    return d.id - k.id;
  }, o.decorateType = function(d, k) {
    if (d.$type)
      return k && d.$type.name !== k && (o.decorateRoot.remove(d.$type), d.$type.name = k, o.decorateRoot.add(d.$type)), d.$type;
    A || (A = requireType());
    var p = new A(k || d.name);
    return o.decorateRoot.add(p), p.ctor = d, Object.defineProperty(d, "$type", { value: p, enumerable: !1 }), Object.defineProperty(d.prototype, "$type", { value: p, enumerable: !1 }), p;
  };
  var n = 0;
  return o.decorateEnum = function(d) {
    if (d.$type)
      return d.$type;
    g || (g = require_enum());
    var k = new g("Enum" + n++, d);
    return o.decorateRoot.add(k), Object.defineProperty(d, "$type", { value: k, enumerable: !1 }), k;
  }, o.setProperty = function(d, k, p, M) {
    function S(AA, H, gA) {
      var CA = H.shift();
      if (CA === "__proto__" || CA === "prototype")
        return AA;
      if (H.length > 0)
        AA[CA] = S(AA[CA] || {}, H, gA);
      else {
        var IA = AA[CA];
        if (IA && M)
          return AA;
        IA && (gA = [].concat(IA).concat(gA)), AA[CA] = gA;
      }
      return AA;
    }
    if (typeof d != "object")
      throw TypeError("dst must be an object");
    if (!k)
      throw TypeError("path must be specified");
    return k = k.split("."), S(d, k, p);
  }, Object.defineProperty(o, "decorateRoot", {
    get: function() {
      return E.decorated || (E.decorated = new (requireRoot())());
    }
  }), util.exports;
}
var hasRequiredTypes;
function requireTypes() {
  return hasRequiredTypes || (hasRequiredTypes = 1, (function(o) {
    var E = o, A = requireUtil(), g = [
      "double",
      // 0
      "float",
      // 1
      "int32",
      // 2
      "uint32",
      // 3
      "sint32",
      // 4
      "fixed32",
      // 5
      "sfixed32",
      // 6
      "int64",
      // 7
      "uint64",
      // 8
      "sint64",
      // 9
      "fixed64",
      // 10
      "sfixed64",
      // 11
      "bool",
      // 12
      "string",
      // 13
      "bytes"
      // 14
    ];
    function e(t, c) {
      var n = 0, h = {};
      for (c |= 0; n < t.length; ) h[g[n + c]] = t[n++];
      return h;
    }
    E.basic = e([
      /* double   */
      1,
      /* float    */
      5,
      /* int32    */
      0,
      /* uint32   */
      0,
      /* sint32   */
      0,
      /* fixed32  */
      5,
      /* sfixed32 */
      5,
      /* int64    */
      0,
      /* uint64   */
      0,
      /* sint64   */
      0,
      /* fixed64  */
      1,
      /* sfixed64 */
      1,
      /* bool     */
      0,
      /* string   */
      2,
      /* bytes    */
      2
    ]), E.defaults = e([
      /* double   */
      0,
      /* float    */
      0,
      /* int32    */
      0,
      /* uint32   */
      0,
      /* sint32   */
      0,
      /* fixed32  */
      0,
      /* sfixed32 */
      0,
      /* int64    */
      0,
      /* uint64   */
      0,
      /* sint64   */
      0,
      /* fixed64  */
      0,
      /* sfixed64 */
      0,
      /* bool     */
      !1,
      /* string   */
      "",
      /* bytes    */
      A.emptyArray,
      /* message  */
      null
    ]), E.long = e([
      /* int64    */
      0,
      /* uint64   */
      0,
      /* sint64   */
      0,
      /* fixed64  */
      1,
      /* sfixed64 */
      1
    ], 7), E.mapKey = e([
      /* int32    */
      0,
      /* uint32   */
      0,
      /* sint32   */
      0,
      /* fixed32  */
      5,
      /* sfixed32 */
      5,
      /* int64    */
      0,
      /* uint64   */
      0,
      /* sint64   */
      0,
      /* fixed64  */
      1,
      /* sfixed64 */
      1,
      /* bool     */
      0,
      /* string   */
      2
    ], 2), E.packed = e([
      /* double   */
      1,
      /* float    */
      5,
      /* int32    */
      0,
      /* uint32   */
      0,
      /* sint32   */
      0,
      /* fixed32  */
      5,
      /* sfixed32 */
      5,
      /* int64    */
      0,
      /* uint64   */
      0,
      /* sint64   */
      0,
      /* fixed64  */
      1,
      /* sfixed64 */
      1,
      /* bool     */
      0
    ]);
  })(types)), types;
}
var field, hasRequiredField;
function requireField() {
  if (hasRequiredField) return field;
  hasRequiredField = 1, field = c;
  var o = requireObject();
  ((c.prototype = Object.create(o.prototype)).constructor = c).className = "Field";
  var E = require_enum(), A = requireTypes(), g = requireUtil(), e, t = /^required|optional|repeated$/;
  c.fromJSON = function(h, d) {
    var k = new c(h, d.id, d.type, d.rule, d.extend, d.options, d.comment);
    return d.edition && (k._edition = d.edition), k._defaultEdition = "proto3", k;
  };
  function c(n, h, d, k, p, M, S) {
    if (g.isObject(k) ? (S = p, M = k, k = p = void 0) : g.isObject(p) && (S = M, M = p, p = void 0), o.call(this, n, M), !g.isInteger(h) || h < 0)
      throw TypeError("id must be a non-negative integer");
    if (!g.isString(d))
      throw TypeError("type must be a string");
    if (k !== void 0 && !t.test(k = k.toString().toLowerCase()))
      throw TypeError("rule must be a string rule");
    if (p !== void 0 && !g.isString(p))
      throw TypeError("extend must be a string");
    k === "proto3_optional" && (k = "optional"), this.rule = k && k !== "optional" ? k : void 0, this.type = d, this.id = h, this.extend = p || void 0, this.repeated = k === "repeated", this.map = !1, this.message = null, this.partOf = null, this.typeDefault = null, this.defaultValue = null, this.long = g.Long ? A.long[d] !== void 0 : (
      /* istanbul ignore next */
      !1
    ), this.bytes = d === "bytes", this.resolvedType = null, this.extensionField = null, this.declaringField = null, this.comment = S;
  }
  return Object.defineProperty(c.prototype, "required", {
    get: function() {
      return this._features.field_presence === "LEGACY_REQUIRED";
    }
  }), Object.defineProperty(c.prototype, "optional", {
    get: function() {
      return !this.required;
    }
  }), Object.defineProperty(c.prototype, "delimited", {
    get: function() {
      return this.resolvedType instanceof e && this._features.message_encoding === "DELIMITED";
    }
  }), Object.defineProperty(c.prototype, "packed", {
    get: function() {
      return this._features.repeated_field_encoding === "PACKED";
    }
  }), Object.defineProperty(c.prototype, "hasPresence", {
    get: function() {
      return this.repeated || this.map ? !1 : this.partOf || // oneofs
      this.declaringField || this.extensionField || // extensions
      this._features.field_presence !== "IMPLICIT";
    }
  }), c.prototype.setOption = function(h, d, k) {
    return o.prototype.setOption.call(this, h, d, k);
  }, c.prototype.toJSON = function(h) {
    var d = h ? !!h.keepComments : !1;
    return g.toObject([
      "edition",
      this._editionToJSON(),
      "rule",
      this.rule !== "optional" && this.rule || void 0,
      "type",
      this.type,
      "id",
      this.id,
      "extend",
      this.extend,
      "options",
      this.options,
      "comment",
      d ? this.comment : void 0
    ]);
  }, c.prototype.resolve = function() {
    if (this.resolved)
      return this;
    if ((this.typeDefault = A.defaults[this.type]) === void 0 ? (this.resolvedType = (this.declaringField ? this.declaringField.parent : this.parent).lookupTypeOrEnum(this.type), this.resolvedType instanceof e ? this.typeDefault = null : this.typeDefault = this.resolvedType.values[Object.keys(this.resolvedType.values)[0]]) : this.options && this.options.proto3_optional && (this.typeDefault = null), this.options && this.options.default != null && (this.typeDefault = this.options.default, this.resolvedType instanceof E && typeof this.typeDefault == "string" && (this.typeDefault = this.resolvedType.values[this.typeDefault])), this.options && (this.options.packed !== void 0 && this.resolvedType && !(this.resolvedType instanceof E) && delete this.options.packed, Object.keys(this.options).length || (this.options = void 0)), this.long)
      this.typeDefault = g.Long.fromNumber(this.typeDefault, this.type.charAt(0) === "u"), Object.freeze && Object.freeze(this.typeDefault);
    else if (this.bytes && typeof this.typeDefault == "string") {
      var h;
      g.base64.test(this.typeDefault) ? g.base64.decode(this.typeDefault, h = g.newBuffer(g.base64.length(this.typeDefault)), 0) : g.utf8.write(this.typeDefault, h = g.newBuffer(g.utf8.length(this.typeDefault)), 0), this.typeDefault = h;
    }
    return this.map ? this.defaultValue = g.emptyObject : this.repeated ? this.defaultValue = g.emptyArray : this.defaultValue = this.typeDefault, this.parent instanceof e && (this.parent.ctor.prototype[this.name] = this.defaultValue), o.prototype.resolve.call(this);
  }, c.prototype._inferLegacyProtoFeatures = function(h) {
    if (h !== "proto2" && h !== "proto3")
      return {};
    var d = {};
    if (this.rule === "required" && (d.field_presence = "LEGACY_REQUIRED"), this.parent && A.defaults[this.type] === void 0) {
      var k = this.parent.get(this.type.split(".").pop());
      k && k instanceof e && k.group && (d.message_encoding = "DELIMITED");
    }
    return this.getOption("packed") === !0 ? d.repeated_field_encoding = "PACKED" : this.getOption("packed") === !1 && (d.repeated_field_encoding = "EXPANDED"), d;
  }, c.prototype._resolveFeatures = function(h) {
    return o.prototype._resolveFeatures.call(this, this._edition || h);
  }, c.d = function(h, d, k, p) {
    return typeof d == "function" ? d = g.decorateType(d).name : d && typeof d == "object" && (d = g.decorateEnum(d).name), function(S, AA) {
      g.decorateType(S.constructor).add(new c(AA, h, d, k, { default: p }));
    };
  }, c._configure = function(h) {
    e = h;
  }, field;
}
var oneof, hasRequiredOneof;
function requireOneof() {
  if (hasRequiredOneof) return oneof;
  hasRequiredOneof = 1, oneof = g;
  var o = requireObject();
  ((g.prototype = Object.create(o.prototype)).constructor = g).className = "OneOf";
  var E = requireField(), A = requireUtil();
  function g(t, c, n, h) {
    if (Array.isArray(c) || (n = c, c = void 0), o.call(this, t, n), !(c === void 0 || Array.isArray(c)))
      throw TypeError("fieldNames must be an Array");
    this.oneof = c || [], this.fieldsArray = [], this.comment = h;
  }
  g.fromJSON = function(c, n) {
    return new g(c, n.oneof, n.options, n.comment);
  }, g.prototype.toJSON = function(c) {
    var n = c ? !!c.keepComments : !1;
    return A.toObject([
      "options",
      this.options,
      "oneof",
      this.oneof,
      "comment",
      n ? this.comment : void 0
    ]);
  };
  function e(t) {
    if (t.parent)
      for (var c = 0; c < t.fieldsArray.length; ++c)
        t.fieldsArray[c].parent || t.parent.add(t.fieldsArray[c]);
  }
  return g.prototype.add = function(c) {
    if (!(c instanceof E))
      throw TypeError("field must be a Field");
    return c.parent && c.parent !== this.parent && c.parent.remove(c), this.oneof.push(c.name), this.fieldsArray.push(c), c.partOf = this, e(this), this;
  }, g.prototype.remove = function(c) {
    if (!(c instanceof E))
      throw TypeError("field must be a Field");
    var n = this.fieldsArray.indexOf(c);
    if (n < 0)
      throw Error(c + " is not a member of " + this);
    return this.fieldsArray.splice(n, 1), n = this.oneof.indexOf(c.name), n > -1 && this.oneof.splice(n, 1), c.partOf = null, this;
  }, g.prototype.onAdd = function(c) {
    o.prototype.onAdd.call(this, c);
    for (var n = this, h = 0; h < this.oneof.length; ++h) {
      var d = c.get(this.oneof[h]);
      d && !d.partOf && (d.partOf = n, n.fieldsArray.push(d));
    }
    e(this);
  }, g.prototype.onRemove = function(c) {
    for (var n = 0, h; n < this.fieldsArray.length; ++n)
      (h = this.fieldsArray[n]).parent && h.parent.remove(h);
    o.prototype.onRemove.call(this, c);
  }, Object.defineProperty(g.prototype, "isProto3Optional", {
    get: function() {
      if (this.fieldsArray == null || this.fieldsArray.length !== 1)
        return !1;
      var t = this.fieldsArray[0];
      return t.options != null && t.options.proto3_optional === !0;
    }
  }), g.d = function() {
    for (var c = new Array(arguments.length), n = 0; n < arguments.length; )
      c[n] = arguments[n++];
    return function(d, k) {
      A.decorateType(d.constructor).add(new g(k, c)), Object.defineProperty(d, k, {
        get: A.oneOfGetter(c),
        set: A.oneOfSetter(c)
      });
    };
  }, oneof;
}
var object, hasRequiredObject;
function requireObject() {
  if (hasRequiredObject) return object;
  hasRequiredObject = 1, object = c, c.className = "ReflectionObject";
  const o = requireOneof();
  var E = requireUtil(), A, g = { enum_type: "OPEN", field_presence: "EXPLICIT", json_format: "ALLOW", message_encoding: "LENGTH_PREFIXED", repeated_field_encoding: "PACKED", utf8_validation: "VERIFY" }, e = { enum_type: "CLOSED", field_presence: "EXPLICIT", json_format: "LEGACY_BEST_EFFORT", message_encoding: "LENGTH_PREFIXED", repeated_field_encoding: "EXPANDED", utf8_validation: "NONE" }, t = { enum_type: "OPEN", field_presence: "IMPLICIT", json_format: "ALLOW", message_encoding: "LENGTH_PREFIXED", repeated_field_encoding: "PACKED", utf8_validation: "VERIFY" };
  function c(n, h) {
    if (!E.isString(n))
      throw TypeError("name must be a string");
    if (h && !E.isObject(h))
      throw TypeError("options must be an object");
    this.options = h, this.parsedOptions = null, this.name = n, this._edition = null, this._defaultEdition = "proto2", this._features = {}, this._featuresResolved = !1, this.parent = null, this.resolved = !1, this.comment = null, this.filename = null;
  }
  return Object.defineProperties(c.prototype, {
    /**
     * Reference to the root namespace.
     * @name ReflectionObject#root
     * @type {Root}
     * @readonly
     */
    root: {
      get: function() {
        for (var n = this; n.parent !== null; )
          n = n.parent;
        return n;
      }
    },
    /**
     * Full name including leading dot.
     * @name ReflectionObject#fullName
     * @type {string}
     * @readonly
     */
    fullName: {
      get: function() {
        for (var n = [this.name], h = this.parent; h; )
          n.unshift(h.name), h = h.parent;
        return n.join(".");
      }
    }
  }), c.prototype.toJSON = /* istanbul ignore next */
  function() {
    throw Error();
  }, c.prototype.onAdd = function(h) {
    this.parent && this.parent !== h && this.parent.remove(this), this.parent = h, this.resolved = !1;
    var d = h.root;
    d instanceof A && d._handleAdd(this);
  }, c.prototype.onRemove = function(h) {
    var d = h.root;
    d instanceof A && d._handleRemove(this), this.parent = null, this.resolved = !1;
  }, c.prototype.resolve = function() {
    return this.resolved ? this : (this.root instanceof A && (this.resolved = !0), this);
  }, c.prototype._resolveFeaturesRecursive = function(h) {
    return this._resolveFeatures(this._edition || h);
  }, c.prototype._resolveFeatures = function(h) {
    if (!this._featuresResolved) {
      var d = {};
      if (!h)
        throw new Error("Unknown edition for " + this.fullName);
      var k = Object.assign(
        this.options ? Object.assign({}, this.options.features) : {},
        this._inferLegacyProtoFeatures(h)
      );
      if (this._edition) {
        if (h === "proto2")
          d = Object.assign({}, e);
        else if (h === "proto3")
          d = Object.assign({}, t);
        else if (h === "2023")
          d = Object.assign({}, g);
        else
          throw new Error("Unknown edition: " + h);
        this._features = Object.assign(d, k || {}), this._featuresResolved = !0;
        return;
      }
      if (this.partOf instanceof o) {
        var p = Object.assign({}, this.partOf._features);
        this._features = Object.assign(p, k || {});
      } else if (!this.declaringField) if (this.parent) {
        var M = Object.assign({}, this.parent._features);
        this._features = Object.assign(M, k || {});
      } else
        throw new Error("Unable to find a parent for " + this.fullName);
      this.extensionField && (this.extensionField._features = this._features), this._featuresResolved = !0;
    }
  }, c.prototype._inferLegacyProtoFeatures = function() {
    return {};
  }, c.prototype.getOption = function(h) {
    if (this.options)
      return this.options[h];
  }, c.prototype.setOption = function(h, d, k) {
    return this.options || (this.options = {}), /^features\./.test(h) ? E.setProperty(this.options, h, d, k) : (!k || this.options[h] === void 0) && (this.getOption(h) !== d && (this.resolved = !1), this.options[h] = d), this;
  }, c.prototype.setParsedOption = function(h, d, k) {
    this.parsedOptions || (this.parsedOptions = []);
    var p = this.parsedOptions;
    if (k) {
      var M = p.find(function(H) {
        return Object.prototype.hasOwnProperty.call(H, h);
      });
      if (M) {
        var S = M[h];
        E.setProperty(S, k, d);
      } else
        M = {}, M[h] = E.setProperty({}, k, d), p.push(M);
    } else {
      var AA = {};
      AA[h] = d, p.push(AA);
    }
    return this;
  }, c.prototype.setOptions = function(h, d) {
    if (h)
      for (var k = Object.keys(h), p = 0; p < k.length; ++p)
        this.setOption(k[p], h[k[p]], d);
    return this;
  }, c.prototype.toString = function() {
    var h = this.constructor.className, d = this.fullName;
    return d.length ? h + " " + d : h;
  }, c.prototype._editionToJSON = function() {
    if (!(!this._edition || this._edition === "proto3"))
      return this._edition;
  }, c._configure = function(n) {
    A = n;
  }, object;
}
var _enum, hasRequired_enum;
function require_enum() {
  if (hasRequired_enum) return _enum;
  hasRequired_enum = 1, _enum = g;
  var o = requireObject();
  ((g.prototype = Object.create(o.prototype)).constructor = g).className = "Enum";
  var E = requireNamespace(), A = requireUtil();
  function g(e, t, c, n, h, d) {
    if (o.call(this, e, c), t && typeof t != "object")
      throw TypeError("values must be an object");
    if (this.valuesById = {}, this.values = Object.create(this.valuesById), this.comment = n, this.comments = h || {}, this.valuesOptions = d, this._valuesFeatures = {}, this.reserved = void 0, t)
      for (var k = Object.keys(t), p = 0; p < k.length; ++p)
        typeof t[k[p]] == "number" && (this.valuesById[this.values[k[p]] = t[k[p]]] = k[p]);
  }
  return g.prototype._resolveFeatures = function(t) {
    return t = this._edition || t, o.prototype._resolveFeatures.call(this, t), Object.keys(this.values).forEach((c) => {
      var n = Object.assign({}, this._features);
      this._valuesFeatures[c] = Object.assign(n, this.valuesOptions && this.valuesOptions[c] && this.valuesOptions[c].features);
    }), this;
  }, g.fromJSON = function(t, c) {
    var n = new g(t, c.values, c.options, c.comment, c.comments);
    return n.reserved = c.reserved, c.edition && (n._edition = c.edition), n._defaultEdition = "proto3", n;
  }, g.prototype.toJSON = function(t) {
    var c = t ? !!t.keepComments : !1;
    return A.toObject([
      "edition",
      this._editionToJSON(),
      "options",
      this.options,
      "valuesOptions",
      this.valuesOptions,
      "values",
      this.values,
      "reserved",
      this.reserved && this.reserved.length ? this.reserved : void 0,
      "comment",
      c ? this.comment : void 0,
      "comments",
      c ? this.comments : void 0
    ]);
  }, g.prototype.add = function(t, c, n, h) {
    if (!A.isString(t))
      throw TypeError("name must be a string");
    if (!A.isInteger(c))
      throw TypeError("id must be an integer");
    if (this.values[t] !== void 0)
      throw Error("duplicate name '" + t + "' in " + this);
    if (this.isReservedId(c))
      throw Error("id " + c + " is reserved in " + this);
    if (this.isReservedName(t))
      throw Error("name '" + t + "' is reserved in " + this);
    if (this.valuesById[c] !== void 0) {
      if (!(this.options && this.options.allow_alias))
        throw Error("duplicate id " + c + " in " + this);
      this.values[t] = c;
    } else
      this.valuesById[this.values[t] = c] = t;
    return h && (this.valuesOptions === void 0 && (this.valuesOptions = {}), this.valuesOptions[t] = h || null), this.comments[t] = n || null, this;
  }, g.prototype.remove = function(t) {
    if (!A.isString(t))
      throw TypeError("name must be a string");
    var c = this.values[t];
    if (c == null)
      throw Error("name '" + t + "' does not exist in " + this);
    return delete this.valuesById[c], delete this.values[t], delete this.comments[t], this.valuesOptions && delete this.valuesOptions[t], this;
  }, g.prototype.isReservedId = function(t) {
    return E.isReservedId(this.reserved, t);
  }, g.prototype.isReservedName = function(t) {
    return E.isReservedName(this.reserved, t);
  }, _enum;
}
var encoder_1, hasRequiredEncoder;
function requireEncoder() {
  if (hasRequiredEncoder) return encoder_1;
  hasRequiredEncoder = 1, encoder_1 = e;
  var o = require_enum(), E = requireTypes(), A = requireUtil();
  function g(t, c, n, h) {
    return c.delimited ? t("types[%i].encode(%s,w.uint32(%i)).uint32(%i)", n, h, (c.id << 3 | 3) >>> 0, (c.id << 3 | 4) >>> 0) : t("types[%i].encode(%s,w.uint32(%i).fork()).ldelim()", n, h, (c.id << 3 | 2) >>> 0);
  }
  function e(t) {
    for (var c = A.codegen(["m", "w"], t.name + "$encode")("if(!w)")("w=Writer.create()"), n, h, d = (
      /* initializes */
      t.fieldsArray.slice().sort(A.compareFieldsById)
    ), n = 0; n < d.length; ++n) {
      var k = d[n].resolve(), p = t._fieldsArray.indexOf(k), M = k.resolvedType instanceof o ? "int32" : k.type, S = E.basic[M];
      h = "m" + A.safeProp(k.name), k.map ? (c("if(%s!=null&&Object.hasOwnProperty.call(m,%j)){", h, k.name)("for(var ks=Object.keys(%s),i=0;i<ks.length;++i){", h)("w.uint32(%i).fork().uint32(%i).%s(ks[i])", (k.id << 3 | 2) >>> 0, 8 | E.mapKey[k.keyType], k.keyType), S === void 0 ? c("types[%i].encode(%s[ks[i]],w.uint32(18).fork()).ldelim().ldelim()", p, h) : c(".uint32(%i).%s(%s[ks[i]]).ldelim()", 16 | S, M, h), c("}")("}")) : k.repeated ? (c("if(%s!=null&&%s.length){", h, h), k.packed && E.packed[M] !== void 0 ? c("w.uint32(%i).fork()", (k.id << 3 | 2) >>> 0)("for(var i=0;i<%s.length;++i)", h)("w.%s(%s[i])", M, h)("w.ldelim()") : (c("for(var i=0;i<%s.length;++i)", h), S === void 0 ? g(c, k, p, h + "[i]") : c("w.uint32(%i).%s(%s[i])", (k.id << 3 | S) >>> 0, M, h)), c("}")) : (k.optional && c("if(%s!=null&&Object.hasOwnProperty.call(m,%j))", h, k.name), S === void 0 ? g(c, k, p, h) : c("w.uint32(%i).%s(%s)", (k.id << 3 | S) >>> 0, M, h));
    }
    return c("return w");
  }
  return encoder_1;
}
var hasRequiredIndexLight;
function requireIndexLight() {
  if (hasRequiredIndexLight) return indexLight.exports;
  hasRequiredIndexLight = 1;
  var o = indexLight.exports = requireIndexMinimal$1();
  o.build = "light";
  function E(g, e, t) {
    return typeof e == "function" ? (t = e, e = new o.Root()) : e || (e = new o.Root()), e.load(g, t);
  }
  o.load = E;
  function A(g, e) {
    return e || (e = new o.Root()), e.loadSync(g);
  }
  return o.loadSync = A, o.encoder = requireEncoder(), o.decoder = requireDecoder(), o.verifier = requireVerifier(), o.converter = requireConverter(), o.ReflectionObject = requireObject(), o.Namespace = requireNamespace(), o.Root = requireRoot(), o.Enum = require_enum(), o.Type = requireType(), o.Field = requireField(), o.OneOf = requireOneof(), o.MapField = requireMapfield(), o.Service = requireService(), o.Method = requireMethod(), o.Message = requireMessage(), o.wrappers = requireWrappers(), o.types = requireTypes(), o.util = requireUtil(), o.ReflectionObject._configure(o.Root), o.Namespace._configure(o.Type, o.Service, o.Enum), o.Root._configure(o.Type), o.Field._configure(o.Type), indexLight.exports;
}
var tokenize_1, hasRequiredTokenize;
function requireTokenize() {
  if (hasRequiredTokenize) return tokenize_1;
  hasRequiredTokenize = 1, tokenize_1 = k;
  var o = /[\s{}=;:[\],'"()<>]/g, E = /(?:"([^"\\]*(?:\\.[^"\\]*)*)")/g, A = /(?:'([^'\\]*(?:\\.[^'\\]*)*)')/g, g = /^ *[*/]+ */, e = /^\s*\*?\/*/, t = /\n/g, c = /\s/, n = /\\(.?)/g, h = {
    0: "\0",
    r: "\r",
    n: `
`,
    t: "	"
  };
  function d(p) {
    return p.replace(n, function(M, S) {
      switch (S) {
        case "\\":
        case "":
          return S;
        default:
          return h[S] || "";
      }
    });
  }
  k.unescape = d;
  function k(p, M) {
    p = p.toString();
    var S = 0, AA = p.length, H = 1, gA = 0, CA = {}, IA = [], BA = null;
    function QA(lA) {
      return Error("illegal " + lA + " (line " + H + ")");
    }
    function EA() {
      var lA = BA === "'" ? A : E;
      lA.lastIndex = S - 1;
      var NA = lA.exec(p);
      if (!NA)
        throw QA("string");
      return S = lA.lastIndex, cA(BA), BA = null, d(NA[1]);
    }
    function oA(lA) {
      return p.charAt(lA);
    }
    function iA(lA, NA, RA) {
      var KA = {
        type: p.charAt(lA++),
        lineEmpty: !1,
        leading: RA
      }, vA;
      M ? vA = 2 : vA = 3;
      var GA = lA - vA, FA;
      do
        if (--GA < 0 || (FA = p.charAt(GA)) === `
`) {
          KA.lineEmpty = !0;
          break;
        }
      while (FA === " " || FA === "	");
      for (var HA = p.substring(lA, NA).split(t), sA = 0; sA < HA.length; ++sA)
        HA[sA] = HA[sA].replace(M ? e : g, "").trim();
      KA.text = HA.join(`
`).trim(), CA[H] = KA, gA = H;
    }
    function aA(lA) {
      var NA = tA(lA), RA = p.substring(lA, NA), KA = /^\s*\/\//.test(RA);
      return KA;
    }
    function tA(lA) {
      for (var NA = lA; NA < AA && oA(NA) !== `
`; )
        NA++;
      return NA;
    }
    function eA() {
      if (IA.length > 0)
        return IA.shift();
      if (BA)
        return EA();
      var lA, NA, RA, KA, vA, GA = S === 0;
      do {
        if (S === AA)
          return null;
        for (lA = !1; c.test(RA = oA(S)); )
          if (RA === `
` && (GA = !0, ++H), ++S === AA)
            return null;
        if (oA(S) === "/") {
          if (++S === AA)
            throw QA("comment");
          if (oA(S) === "/")
            if (M) {
              if (KA = S, vA = !1, aA(S - 1)) {
                vA = !0;
                do
                  if (S = tA(S), S === AA || (S++, !GA))
                    break;
                while (aA(S));
              } else
                S = Math.min(AA, tA(S) + 1);
              vA && (iA(KA, S, GA), GA = !0), H++, lA = !0;
            } else {
              for (vA = oA(KA = S + 1) === "/"; oA(++S) !== `
`; )
                if (S === AA)
                  return null;
              ++S, vA && (iA(KA, S - 1, GA), GA = !0), ++H, lA = !0;
            }
          else if ((RA = oA(S)) === "*") {
            KA = S + 1, vA = M || oA(KA) === "*";
            do {
              if (RA === `
` && ++H, ++S === AA)
                throw QA("comment");
              NA = RA, RA = oA(S);
            } while (NA !== "*" || RA !== "/");
            ++S, vA && (iA(KA, S - 2, GA), GA = !0), lA = !0;
          } else
            return "/";
        }
      } while (lA);
      var FA = S;
      o.lastIndex = 0;
      var HA = o.test(oA(FA++));
      if (!HA)
        for (; FA < AA && !o.test(oA(FA)); )
          ++FA;
      var sA = p.substring(S, S = FA);
      return (sA === '"' || sA === "'") && (BA = sA), sA;
    }
    function cA(lA) {
      IA.push(lA);
    }
    function DA() {
      if (!IA.length) {
        var lA = eA();
        if (lA === null)
          return null;
        cA(lA);
      }
      return IA[0];
    }
    function nA(lA, NA) {
      var RA = DA(), KA = RA === lA;
      if (KA)
        return eA(), !0;
      if (!NA)
        throw QA("token '" + RA + "', '" + lA + "' expected");
      return !1;
    }
    function wA(lA) {
      var NA = null, RA;
      return lA === void 0 ? (RA = CA[H - 1], delete CA[H - 1], RA && (M || RA.type === "*" || RA.lineEmpty) && (NA = RA.leading ? RA.text : null)) : (gA < lA && DA(), RA = CA[lA], delete CA[lA], RA && !RA.lineEmpty && (M || RA.type === "/") && (NA = RA.leading ? null : RA.text)), NA;
    }
    return Object.defineProperty({
      next: eA,
      peek: DA,
      push: cA,
      skip: nA,
      cmnt: wA
    }, "line", {
      get: function() {
        return H;
      }
    });
  }
  return tokenize_1;
}
var parse_1, hasRequiredParse;
function requireParse() {
  if (hasRequiredParse) return parse_1;
  hasRequiredParse = 1, parse_1 = EA, EA.filename = null, EA.defaults = { keepCase: !1 };
  var o = requireTokenize(), E = requireRoot(), A = requireType(), g = requireField(), e = requireMapfield(), t = requireOneof(), c = require_enum(), n = requireService(), h = requireMethod(), d = requireObject(), k = requireTypes(), p = requireUtil(), M = /^[1-9][0-9]*$/, S = /^-?[1-9][0-9]*$/, AA = /^0[x][0-9a-fA-F]+$/, H = /^-?0[x][0-9a-fA-F]+$/, gA = /^0[0-7]+$/, CA = /^-?0[0-7]+$/, IA = /^(?![eE])[0-9]*(?:\.[0-9]*)?(?:[eE][+-]?[0-9]+)?$/, BA = /^[a-zA-Z_][a-zA-Z_0-9]*$/, QA = /^(?:\.?[a-zA-Z_][a-zA-Z_0-9]*)(?:\.[a-zA-Z_][a-zA-Z_0-9]*)*$/;
  function EA(oA, iA, aA) {
    iA instanceof E || (aA = iA, iA = new E()), aA || (aA = EA.defaults);
    var tA = aA.preferTrailingComment || !1, eA = o(oA, aA.alternateCommentMode || !1), cA = eA.next, DA = eA.push, nA = eA.peek, wA = eA.skip, lA = eA.cmnt, NA = !0, RA, KA, vA, GA = "proto2", FA = iA, HA = [], sA = {}, mA = aA.keepCase ? function(yA) {
      return yA;
    } : p.camelCase;
    function xA() {
      HA.forEach((yA) => {
        yA._edition = GA, Object.keys(sA).forEach((bA) => {
          yA.getOption(bA) === void 0 && yA.setOption(bA, sA[bA], !0);
        });
      });
    }
    function hA(yA, bA, kA) {
      var JA = EA.filename;
      return kA || (EA.filename = null), Error("illegal " + (bA || "token") + " '" + yA + "' (" + (JA ? JA + ", " : "") + "line " + eA.line + ")");
    }
    function MA() {
      var yA = [], bA;
      do {
        if ((bA = cA()) !== '"' && bA !== "'")
          throw hA(bA);
        yA.push(cA()), wA(bA), bA = nA();
      } while (bA === '"' || bA === "'");
      return yA.join("");
    }
    function YA(yA) {
      var bA = cA();
      switch (bA) {
        case "'":
        case '"':
          return DA(bA), MA();
        case "true":
        case "TRUE":
          return !0;
        case "false":
        case "FALSE":
          return !1;
      }
      try {
        return WA(
          bA,
          /* insideTryCatch */
          !0
        );
      } catch {
        if (QA.test(bA))
          return bA;
        throw hA(bA, "value");
      }
    }
    function LA(yA, bA) {
      var kA, JA;
      do
        if (bA && ((kA = nA()) === '"' || kA === "'")) {
          var uA = MA();
          if (yA.push(uA), GA >= 2023)
            throw hA(uA, "id");
        } else
          try {
            yA.push([JA = zA(cA()), wA("to", !0) ? zA(cA()) : JA]);
          } catch (Bg) {
            if (bA && QA.test(kA) && GA >= 2023)
              yA.push(kA);
            else
              throw Bg;
          }
      while (wA(",", !0));
      var TA = { options: void 0 };
      TA.setOption = function(Bg, ng) {
        this.options === void 0 && (this.options = {}), this.options[Bg] = ng;
      }, PA(
        TA,
        function(ng) {
          if (ng === "option")
            Cg(TA, ng), wA(";");
          else
            throw hA(ng);
        },
        function() {
          jA(TA);
        }
      );
    }
    function WA(yA, bA) {
      var kA = 1;
      switch (yA.charAt(0) === "-" && (kA = -1, yA = yA.substring(1)), yA) {
        case "inf":
        case "INF":
        case "Inf":
          return kA * (1 / 0);
        case "nan":
        case "NAN":
        case "Nan":
        case "NaN":
          return NaN;
        case "0":
          return 0;
      }
      if (M.test(yA))
        return kA * parseInt(yA, 10);
      if (AA.test(yA))
        return kA * parseInt(yA, 16);
      if (gA.test(yA))
        return kA * parseInt(yA, 8);
      if (IA.test(yA))
        return kA * parseFloat(yA);
      throw hA(yA, "number", bA);
    }
    function zA(yA, bA) {
      switch (yA) {
        case "max":
        case "MAX":
        case "Max":
          return 536870911;
        case "0":
          return 0;
      }
      if (!bA && yA.charAt(0) === "-")
        throw hA(yA, "id");
      if (S.test(yA))
        return parseInt(yA, 10);
      if (H.test(yA))
        return parseInt(yA, 16);
      if (CA.test(yA))
        return parseInt(yA, 8);
      throw hA(yA, "id");
    }
    function ZA() {
      if (RA !== void 0)
        throw hA("package");
      if (RA = cA(), !QA.test(RA))
        throw hA(RA, "name");
      FA = FA.define(RA), wA(";");
    }
    function Ag() {
      var yA = nA(), bA;
      switch (yA) {
        case "weak":
          bA = vA || (vA = []), cA();
          break;
        case "public":
          cA();
        // eslint-disable-next-line no-fallthrough
        default:
          bA = KA || (KA = []);
          break;
      }
      yA = MA(), wA(";"), bA.push(yA);
    }
    function UA() {
      if (wA("="), GA = MA(), GA < 2023)
        throw hA(GA, "syntax");
      wA(";");
    }
    function ig() {
      if (wA("="), GA = MA(), !["2023"].includes(GA))
        throw hA(GA, "edition");
      wA(";");
    }
    function og(yA, bA) {
      switch (bA) {
        case "option":
          return Cg(yA, bA), wA(";"), !0;
        case "message":
          return Gg(yA, bA), !0;
        case "enum":
          return cg(yA, bA), !0;
        case "service":
          return OA(yA, bA), !0;
        case "extend":
          return $A(yA, bA), !0;
      }
      return !1;
    }
    function PA(yA, bA, kA) {
      var JA = eA.line;
      if (yA && (typeof yA.comment != "string" && (yA.comment = lA()), yA.filename = EA.filename), wA("{", !0)) {
        for (var uA; (uA = cA()) !== "}"; )
          bA(uA);
        wA(";", !0);
      } else
        kA && kA(), wA(";"), yA && (typeof yA.comment != "string" || tA) && (yA.comment = lA(JA) || yA.comment);
    }
    function Gg(yA, bA) {
      if (!BA.test(bA = cA()))
        throw hA(bA, "type name");
      var kA = new A(bA);
      PA(kA, function(uA) {
        if (!og(kA, uA))
          switch (uA) {
            case "map":
              Dg(kA);
              break;
            case "required":
              if (GA !== "proto2")
                throw hA(uA);
            /* eslint-disable no-fallthrough */
            case "repeated":
              gg(kA, uA);
              break;
            case "optional":
              if (GA === "proto3")
                gg(kA, "proto3_optional");
              else {
                if (GA !== "proto2")
                  throw hA(uA);
                gg(kA, "optional");
              }
              break;
            case "oneof":
              rg(kA, uA);
              break;
            case "extensions":
              LA(kA.extensions || (kA.extensions = []));
              break;
            case "reserved":
              LA(kA.reserved || (kA.reserved = []), !0);
              break;
            default:
              if (GA === "proto2" || !QA.test(uA))
                throw hA(uA);
              DA(uA), gg(kA, "optional");
              break;
          }
      }), yA.add(kA), yA === FA && HA.push(kA);
    }
    function gg(yA, bA, kA) {
      var JA = cA();
      if (JA === "group") {
        eg(yA, bA);
        return;
      }
      for (; JA.endsWith(".") || nA().startsWith("."); )
        JA += cA();
      if (!QA.test(JA))
        throw hA(JA, "type");
      var uA = cA();
      if (!BA.test(uA))
        throw hA(uA, "name");
      uA = mA(uA), wA("=");
      var TA = new g(uA, zA(cA()), JA, bA, kA);
      if (PA(TA, function(sg) {
        if (sg === "option")
          Cg(TA, sg), wA(";");
        else
          throw hA(sg);
      }, function() {
        jA(TA);
      }), bA === "proto3_optional") {
        var Bg = new t("_" + uA);
        TA.setOption("proto3_optional", !0), Bg.add(TA), yA.add(Bg);
      } else
        yA.add(TA);
      yA === FA && HA.push(TA);
    }
    function eg(yA, bA) {
      if (GA >= 2023)
        throw hA("group");
      var kA = cA();
      if (!BA.test(kA))
        throw hA(kA, "name");
      var JA = p.lcFirst(kA);
      kA === JA && (kA = p.ucFirst(kA)), wA("=");
      var uA = zA(cA()), TA = new A(kA);
      TA.group = !0;
      var Bg = new g(JA, uA, kA, bA);
      Bg.filename = EA.filename, PA(TA, function(sg) {
        switch (sg) {
          case "option":
            Cg(TA, sg), wA(";");
            break;
          case "required":
          case "repeated":
            gg(TA, sg);
            break;
          case "optional":
            GA === "proto3" ? gg(TA, "proto3_optional") : gg(TA, "optional");
            break;
          case "message":
            Gg(TA, sg);
            break;
          case "enum":
            cg(TA, sg);
            break;
          case "reserved":
            LA(TA.reserved || (TA.reserved = []), !0);
            break;
          /* istanbul ignore next */
          default:
            throw hA(sg);
        }
      }), yA.add(TA).add(Bg);
    }
    function Dg(yA) {
      wA("<");
      var bA = cA();
      if (k.mapKey[bA] === void 0)
        throw hA(bA, "type");
      wA(",");
      var kA = cA();
      if (!QA.test(kA))
        throw hA(kA, "type");
      wA(">");
      var JA = cA();
      if (!BA.test(JA))
        throw hA(JA, "name");
      wA("=");
      var uA = new e(mA(JA), zA(cA()), bA, kA);
      PA(uA, function(Bg) {
        if (Bg === "option")
          Cg(uA, Bg), wA(";");
        else
          throw hA(Bg);
      }, function() {
        jA(uA);
      }), yA.add(uA);
    }
    function rg(yA, bA) {
      if (!BA.test(bA = cA()))
        throw hA(bA, "name");
      var kA = new t(mA(bA));
      PA(kA, function(uA) {
        uA === "option" ? (Cg(kA, uA), wA(";")) : (DA(uA), gg(kA, "optional"));
      }), yA.add(kA);
    }
    function cg(yA, bA) {
      if (!BA.test(bA = cA()))
        throw hA(bA, "name");
      var kA = new c(bA);
      PA(kA, function(uA) {
        switch (uA) {
          case "option":
            Cg(kA, uA), wA(";");
            break;
          case "reserved":
            LA(kA.reserved || (kA.reserved = []), !0), kA.reserved === void 0 && (kA.reserved = []);
            break;
          default:
            hg(kA, uA);
        }
      }), yA.add(kA), yA === FA && HA.push(kA);
    }
    function hg(yA, bA) {
      if (!BA.test(bA))
        throw hA(bA, "name");
      wA("=");
      var kA = zA(cA(), !0), JA = {
        options: void 0
      };
      JA.getOption = function(uA) {
        return this.options[uA];
      }, JA.setOption = function(uA, TA) {
        d.prototype.setOption.call(JA, uA, TA);
      }, JA.setParsedOption = function() {
      }, PA(JA, function(TA) {
        if (TA === "option")
          Cg(JA, TA), wA(";");
        else
          throw hA(TA);
      }, function() {
        jA(JA);
      }), yA.add(bA, kA, JA.comment, JA.parsedOptions || JA.options);
    }
    function Cg(yA, bA) {
      var kA, JA, uA = !0;
      for (bA === "option" && (bA = cA()); bA !== "="; ) {
        if (bA === "(") {
          var TA = cA();
          wA(")"), bA = "(" + TA + ")";
        }
        if (uA) {
          if (uA = !1, bA.includes(".") && !bA.includes("(")) {
            var Bg = bA.split(".");
            kA = Bg[0] + ".", bA = Bg[1];
            continue;
          }
          kA = bA;
        } else
          JA = JA ? JA += bA : bA;
        bA = cA();
      }
      var ng = JA ? kA.concat(JA) : kA, sg = dA(yA, ng);
      JA = JA && JA[0] === "." ? JA.slice(1) : JA, kA = kA && kA[kA.length - 1] === "." ? kA.slice(0, -1) : kA, XA(yA, kA, sg, JA);
    }
    function dA(yA, bA) {
      if (wA("{", !0)) {
        for (var kA = {}; !wA("}", !0); ) {
          if (!BA.test(fA = cA()))
            throw hA(fA, "name");
          if (fA === null)
            throw hA(fA, "end of input");
          var JA, uA = fA;
          if (wA(":", !0), nA() === "{")
            JA = dA(yA, bA + "." + fA);
          else if (nA() === "[") {
            JA = [];
            var TA;
            if (wA("[", !0)) {
              do
                TA = YA(), JA.push(TA);
              while (wA(",", !0));
              wA("]"), typeof TA < "u" && pA(yA, bA + "." + fA, TA);
            }
          } else
            JA = YA(), pA(yA, bA + "." + fA, JA);
          var Bg = kA[uA];
          Bg && (JA = [].concat(Bg).concat(JA)), kA[uA] = JA, wA(",", !0), wA(";", !0);
        }
        return kA;
      }
      var ng = YA();
      return pA(yA, bA, ng), ng;
    }
    function pA(yA, bA, kA) {
      if (FA === yA && /^features\./.test(bA)) {
        sA[bA] = kA;
        return;
      }
      yA.setOption && yA.setOption(bA, kA);
    }
    function XA(yA, bA, kA, JA) {
      yA.setParsedOption && yA.setParsedOption(bA, kA, JA);
    }
    function jA(yA) {
      if (wA("[", !0)) {
        do
          Cg(yA, "option");
        while (wA(",", !0));
        wA("]");
      }
      return yA;
    }
    function OA(yA, bA) {
      if (!BA.test(bA = cA()))
        throw hA(bA, "service name");
      var kA = new n(bA);
      PA(kA, function(uA) {
        if (!og(kA, uA))
          if (uA === "rpc")
            VA(kA, uA);
          else
            throw hA(uA);
      }), yA.add(kA), yA === FA && HA.push(kA);
    }
    function VA(yA, bA) {
      var kA = lA(), JA = bA;
      if (!BA.test(bA = cA()))
        throw hA(bA, "name");
      var uA = bA, TA, Bg, ng, sg;
      if (wA("("), wA("stream", !0) && (Bg = !0), !QA.test(bA = cA()) || (TA = bA, wA(")"), wA("returns"), wA("("), wA("stream", !0) && (sg = !0), !QA.test(bA = cA())))
        throw hA(bA);
      ng = bA, wA(")");
      var Rg = new h(uA, JA, TA, ng, Bg, sg);
      Rg.comment = kA, PA(Rg, function(Yg) {
        if (Yg === "option")
          Cg(Rg, Yg), wA(";");
        else
          throw hA(Yg);
      }), yA.add(Rg);
    }
    function $A(yA, bA) {
      if (!QA.test(bA = cA()))
        throw hA(bA, "reference");
      var kA = bA;
      PA(null, function(uA) {
        switch (uA) {
          case "required":
          case "repeated":
            gg(yA, uA, kA);
            break;
          case "optional":
            GA === "proto3" ? gg(yA, "proto3_optional", kA) : gg(yA, "optional", kA);
            break;
          default:
            if (GA === "proto2" || !QA.test(uA))
              throw hA(uA);
            DA(uA), gg(yA, "optional", kA);
            break;
        }
      });
    }
    for (var fA; (fA = cA()) !== null; )
      switch (fA) {
        case "package":
          if (!NA)
            throw hA(fA);
          ZA();
          break;
        case "import":
          if (!NA)
            throw hA(fA);
          Ag();
          break;
        case "syntax":
          if (!NA)
            throw hA(fA);
          UA();
          break;
        case "edition":
          if (!NA)
            throw hA(fA);
          ig();
          break;
        case "option":
          Cg(FA, fA), wA(";", !0);
          break;
        default:
          if (og(FA, fA)) {
            NA = !1;
            continue;
          }
          throw hA(fA);
      }
    return xA(), EA.filename = null, {
      package: RA,
      imports: KA,
      weakImports: vA,
      root: iA
    };
  }
  return parse_1;
}
var common_1, hasRequiredCommon;
function requireCommon() {
  if (hasRequiredCommon) return common_1;
  hasRequiredCommon = 1, common_1 = E;
  var o = /\/|\./;
  function E(g, e) {
    o.test(g) || (g = "google/protobuf/" + g + ".proto", e = { nested: { google: { nested: { protobuf: { nested: e } } } } }), E[g] = e;
  }
  E("any", {
    /**
     * Properties of a google.protobuf.Any message.
     * @interface IAny
     * @type {Object}
     * @property {string} [typeUrl]
     * @property {Uint8Array} [bytes]
     * @memberof common
     */
    Any: {
      fields: {
        type_url: {
          type: "string",
          id: 1
        },
        value: {
          type: "bytes",
          id: 2
        }
      }
    }
  });
  var A;
  return E("duration", {
    /**
     * Properties of a google.protobuf.Duration message.
     * @interface IDuration
     * @type {Object}
     * @property {number|Long} [seconds]
     * @property {number} [nanos]
     * @memberof common
     */
    Duration: A = {
      fields: {
        seconds: {
          type: "int64",
          id: 1
        },
        nanos: {
          type: "int32",
          id: 2
        }
      }
    }
  }), E("timestamp", {
    /**
     * Properties of a google.protobuf.Timestamp message.
     * @interface ITimestamp
     * @type {Object}
     * @property {number|Long} [seconds]
     * @property {number} [nanos]
     * @memberof common
     */
    Timestamp: A
  }), E("empty", {
    /**
     * Properties of a google.protobuf.Empty message.
     * @interface IEmpty
     * @memberof common
     */
    Empty: {
      fields: {}
    }
  }), E("struct", {
    /**
     * Properties of a google.protobuf.Struct message.
     * @interface IStruct
     * @type {Object}
     * @property {Object.<string,IValue>} [fields]
     * @memberof common
     */
    Struct: {
      fields: {
        fields: {
          keyType: "string",
          type: "Value",
          id: 1
        }
      }
    },
    /**
     * Properties of a google.protobuf.Value message.
     * @interface IValue
     * @type {Object}
     * @property {string} [kind]
     * @property {0} [nullValue]
     * @property {number} [numberValue]
     * @property {string} [stringValue]
     * @property {boolean} [boolValue]
     * @property {IStruct} [structValue]
     * @property {IListValue} [listValue]
     * @memberof common
     */
    Value: {
      oneofs: {
        kind: {
          oneof: [
            "nullValue",
            "numberValue",
            "stringValue",
            "boolValue",
            "structValue",
            "listValue"
          ]
        }
      },
      fields: {
        nullValue: {
          type: "NullValue",
          id: 1
        },
        numberValue: {
          type: "double",
          id: 2
        },
        stringValue: {
          type: "string",
          id: 3
        },
        boolValue: {
          type: "bool",
          id: 4
        },
        structValue: {
          type: "Struct",
          id: 5
        },
        listValue: {
          type: "ListValue",
          id: 6
        }
      }
    },
    NullValue: {
      values: {
        NULL_VALUE: 0
      }
    },
    /**
     * Properties of a google.protobuf.ListValue message.
     * @interface IListValue
     * @type {Object}
     * @property {Array.<IValue>} [values]
     * @memberof common
     */
    ListValue: {
      fields: {
        values: {
          rule: "repeated",
          type: "Value",
          id: 1
        }
      }
    }
  }), E("wrappers", {
    /**
     * Properties of a google.protobuf.DoubleValue message.
     * @interface IDoubleValue
     * @type {Object}
     * @property {number} [value]
     * @memberof common
     */
    DoubleValue: {
      fields: {
        value: {
          type: "double",
          id: 1
        }
      }
    },
    /**
     * Properties of a google.protobuf.FloatValue message.
     * @interface IFloatValue
     * @type {Object}
     * @property {number} [value]
     * @memberof common
     */
    FloatValue: {
      fields: {
        value: {
          type: "float",
          id: 1
        }
      }
    },
    /**
     * Properties of a google.protobuf.Int64Value message.
     * @interface IInt64Value
     * @type {Object}
     * @property {number|Long} [value]
     * @memberof common
     */
    Int64Value: {
      fields: {
        value: {
          type: "int64",
          id: 1
        }
      }
    },
    /**
     * Properties of a google.protobuf.UInt64Value message.
     * @interface IUInt64Value
     * @type {Object}
     * @property {number|Long} [value]
     * @memberof common
     */
    UInt64Value: {
      fields: {
        value: {
          type: "uint64",
          id: 1
        }
      }
    },
    /**
     * Properties of a google.protobuf.Int32Value message.
     * @interface IInt32Value
     * @type {Object}
     * @property {number} [value]
     * @memberof common
     */
    Int32Value: {
      fields: {
        value: {
          type: "int32",
          id: 1
        }
      }
    },
    /**
     * Properties of a google.protobuf.UInt32Value message.
     * @interface IUInt32Value
     * @type {Object}
     * @property {number} [value]
     * @memberof common
     */
    UInt32Value: {
      fields: {
        value: {
          type: "uint32",
          id: 1
        }
      }
    },
    /**
     * Properties of a google.protobuf.BoolValue message.
     * @interface IBoolValue
     * @type {Object}
     * @property {boolean} [value]
     * @memberof common
     */
    BoolValue: {
      fields: {
        value: {
          type: "bool",
          id: 1
        }
      }
    },
    /**
     * Properties of a google.protobuf.StringValue message.
     * @interface IStringValue
     * @type {Object}
     * @property {string} [value]
     * @memberof common
     */
    StringValue: {
      fields: {
        value: {
          type: "string",
          id: 1
        }
      }
    },
    /**
     * Properties of a google.protobuf.BytesValue message.
     * @interface IBytesValue
     * @type {Object}
     * @property {Uint8Array} [value]
     * @memberof common
     */
    BytesValue: {
      fields: {
        value: {
          type: "bytes",
          id: 1
        }
      }
    }
  }), E("field_mask", {
    /**
     * Properties of a google.protobuf.FieldMask message.
     * @interface IDoubleValue
     * @type {Object}
     * @property {number} [value]
     * @memberof common
     */
    FieldMask: {
      fields: {
        paths: {
          rule: "repeated",
          type: "string",
          id: 1
        }
      }
    }
  }), E.get = function(e) {
    return E[e] || null;
  }, common_1;
}
var hasRequiredSrc;
function requireSrc() {
  if (hasRequiredSrc) return src.exports;
  hasRequiredSrc = 1;
  var o = src.exports = requireIndexLight();
  return o.build = "full", o.tokenize = requireTokenize(), o.parse = requireParse(), o.common = requireCommon(), o.Root._configure(o.Type, o.parse, o.common), src.exports;
}
var protobufjs, hasRequiredProtobufjs;
function requireProtobufjs() {
  return hasRequiredProtobufjs || (hasRequiredProtobufjs = 1, protobufjs = requireSrc()), protobufjs;
}
var protobufjsExports = requireProtobufjs(), dist = {}, Collector = {}, hasRequiredCollector;
function requireCollector() {
  if (hasRequiredCollector) return Collector;
  hasRequiredCollector = 1, Object.defineProperty(Collector, "__esModule", { value: !0 }), Collector.Collector = void 0;
  let o = class {
    /**
     * Create a new collector.
     *
     * @param signal The signal to emit.
     */
    constructor(A) {
      this.emit = (...g) => {
        A.emitCollecting(this, g);
      };
    }
  };
  return Collector.Collector = o, Collector;
}
var CollectorArray = {}, hasRequiredCollectorArray;
function requireCollectorArray() {
  if (hasRequiredCollectorArray) return CollectorArray;
  hasRequiredCollectorArray = 1, Object.defineProperty(CollectorArray, "__esModule", { value: !0 }), CollectorArray.CollectorArray = void 0;
  const o = requireCollector();
  let E = class extends o.Collector {
    constructor() {
      super(...arguments), this.result = [];
    }
    handleResult(g) {
      return this.result.push(g), !0;
    }
    /**
     * Get the list of results from the signal handlers.
     */
    getResult() {
      return this.result;
    }
    /**
     * Reset the result
     */
    reset() {
      this.result.length = 0;
    }
  };
  return CollectorArray.CollectorArray = E, CollectorArray;
}
var CollectorLast = {}, hasRequiredCollectorLast;
function requireCollectorLast() {
  if (hasRequiredCollectorLast) return CollectorLast;
  hasRequiredCollectorLast = 1, Object.defineProperty(CollectorLast, "__esModule", { value: !0 }), CollectorLast.CollectorLast = void 0;
  const o = requireCollector();
  let E = class extends o.Collector {
    handleResult(g) {
      return this.result = g, !0;
    }
    /**
     * Get the result of the last signal handler.
     */
    getResult() {
      return this.result;
    }
    /**
     * Reset the result
     */
    reset() {
      delete this.result;
    }
  };
  return CollectorLast.CollectorLast = E, CollectorLast;
}
var CollectorUntil0 = {}, hasRequiredCollectorUntil0;
function requireCollectorUntil0() {
  if (hasRequiredCollectorUntil0) return CollectorUntil0;
  hasRequiredCollectorUntil0 = 1, Object.defineProperty(CollectorUntil0, "__esModule", { value: !0 }), CollectorUntil0.CollectorUntil0 = void 0;
  const o = requireCollector();
  let E = class extends o.Collector {
    constructor() {
      super(...arguments), this.result = !1;
    }
    handleResult(g) {
      return this.result = g, this.result;
    }
    /**
     * Get the result of the last signal handler.
     */
    getResult() {
      return this.result;
    }
    /**
     * Reset the result
     */
    reset() {
      this.result = !1;
    }
  };
  return CollectorUntil0.CollectorUntil0 = E, CollectorUntil0;
}
var CollectorWhile0 = {}, hasRequiredCollectorWhile0;
function requireCollectorWhile0() {
  if (hasRequiredCollectorWhile0) return CollectorWhile0;
  hasRequiredCollectorWhile0 = 1, Object.defineProperty(CollectorWhile0, "__esModule", { value: !0 }), CollectorWhile0.CollectorWhile0 = void 0;
  const o = requireCollector();
  let E = class extends o.Collector {
    constructor() {
      super(...arguments), this.result = !1;
    }
    handleResult(g) {
      return this.result = g, !this.result;
    }
    /**
     * Get the result of the last signal handler.
     */
    getResult() {
      return this.result;
    }
    /**
     * Reset the result
     */
    reset() {
      this.result = !1;
    }
  };
  return CollectorWhile0.CollectorWhile0 = E, CollectorWhile0;
}
var Signal = {}, SignalConnection = {}, hasRequiredSignalConnection;
function requireSignalConnection() {
  if (hasRequiredSignalConnection) return SignalConnection;
  hasRequiredSignalConnection = 1, Object.defineProperty(SignalConnection, "__esModule", { value: !0 }), SignalConnection.SignalConnectionImpl = void 0;
  class o {
    /**
     * @param link The actual link of the connection.
     */
    constructor(A) {
      this.link = A;
    }
    disconnect() {
      return this.link.unlink();
    }
    set enabled(A) {
      this.link.setEnabled(A);
    }
    get enabled() {
      return this.link.isEnabled();
    }
  }
  return SignalConnection.SignalConnectionImpl = o, SignalConnection;
}
var SignalLink = {}, hasRequiredSignalLink;
function requireSignalLink() {
  if (hasRequiredSignalLink) return SignalLink;
  hasRequiredSignalLink = 1, Object.defineProperty(SignalLink, "__esModule", { value: !0 }), SignalLink.SignalLink = void 0;
  let o = class nI {
    constructor(A, g, e) {
      this.enabled = !0, this.newLink = !1, this.prev = A ?? this, this.next = g ?? this, this.order = e.order, this.isPublic = e.isPublic, this.callback = e.callback, this.onUnlink = e.onUnlink;
    }
    isEnabled() {
      return this.enabled && !this.newLink;
    }
    setEnabled(A) {
      this.enabled = A;
    }
    unlink() {
      return this.callback ? (delete this.callback, this.next.prev = this.prev, this.prev.next = this.next, this.onUnlink(), !0) : !1;
    }
    insert(A) {
      const { order: g } = A;
      let e = this.prev;
      for (; e !== this && !(e.order <= g); )
        e = e.prev;
      const t = new nI(e, e.next, A);
      return e.next = t, t.next.prev = t, t;
    }
  };
  return SignalLink.SignalLink = o, SignalLink;
}
var hasRequiredSignal;
function requireSignal() {
  if (hasRequiredSignal) return Signal;
  hasRequiredSignal = 1, Object.defineProperty(Signal, "__esModule", { value: !0 }), Signal.Signal = void 0;
  const o = requireSignalConnection(), E = requireSignalLink(), A = { order: 0, isPublic: !0, onUnlink() {
  } };
  let g = class {
    constructor() {
      this.head = new E.SignalLink(null, null, A), this.hasNewLinks = !1, this.emitDepth = 0, this.connectionsCount = 0, this.onUnlink = () => {
        this.connectionsCount--;
      };
    }
    /**
     * @returns The number of connections on this signal.
     */
    getConnectionsCount() {
      return this.connectionsCount;
    }
    /**
     * @returns true if this signal has connections.
     */
    hasConnections() {
      return this.connectionsCount > 0;
    }
    /**
     * Subscribe to this signal.
     *
     * @param callback This callback will be run when emit() is called.
     * @param options Configure options for the connection
     */
    connect(t, { order: c = 0, isPublic: n = !0 } = {}) {
      this.connectionsCount++;
      const h = this.head.insert({ callback: t, order: c, isPublic: n, onUnlink: this.onUnlink });
      return this.emitDepth > 0 && (this.hasNewLinks = !0, h.newLink = !0), new o.SignalConnectionImpl(h);
    }
    /**
     * Unsubscribe from this signal with the original callback instance.
     * While you can use this method, the SignalConnection returned by connect() will not be updated!
     *
     * @param callback The callback you passed to connect().
     */
    disconnect(t) {
      for (let c = this.head.next; c !== this.head; c = c.next)
        if (c.callback === t)
          return c.unlink(), !0;
      return !1;
    }
    /**
     * Disconnect all handlers from this signal event.
     */
    disconnectAll() {
      let { next: t } = this.head;
      for (; t !== this.head; )
        t.isPublic && t.unlink(), t = t.next;
    }
    /**
     * Publish this signal event (call all handlers).
     */
    emit(...t) {
      this.emitDepth++;
      for (let c = this.head.next; c !== this.head; c = c.next)
        c.isEnabled() && c.callback && c.callback.apply(null, t);
      this.emitDepth--, this.unsetNewLink();
    }
    emitCollecting(t, c) {
      this.emitDepth++;
      for (let n = this.head.next; n !== this.head; n = n.next)
        if (n.isEnabled() && n.callback) {
          const h = n.callback.apply(null, c);
          if (!t.handleResult(h))
            break;
        }
      this.emitDepth--, this.unsetNewLink();
    }
    unsetNewLink() {
      if (this.hasNewLinks && this.emitDepth === 0) {
        for (let t = this.head.next; t !== this.head; t = t.next)
          t.newLink = !1;
        this.hasNewLinks = !1;
      }
    }
  };
  return Signal.Signal = g, Signal;
}
var SignalConnections = {}, hasRequiredSignalConnections;
function requireSignalConnections() {
  if (hasRequiredSignalConnections) return SignalConnections;
  hasRequiredSignalConnections = 1, Object.defineProperty(SignalConnections, "__esModule", { value: !0 }), SignalConnections.SignalConnections = void 0;
  let o = class {
    constructor() {
      this.list = [];
    }
    /**
     * Add a connection to the list.
     * @param connection
     */
    add(A) {
      this.list.push(A);
    }
    /**
     * Disconnect all connections in the list and empty the list.
     */
    disconnectAll() {
      for (const A of this.list)
        A.disconnect();
      this.list = [];
    }
    /**
     * @returns The number of connections in this list.
     */
    getCount() {
      return this.list.length;
    }
    /**
     * @returns true if this list is empty.
     */
    isEmpty() {
      return this.list.length === 0;
    }
  };
  return SignalConnections.SignalConnections = o, SignalConnections;
}
var hasRequiredDist;
function requireDist() {
  return hasRequiredDist || (hasRequiredDist = 1, (function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 }), o.SignalConnections = o.Signal = o.CollectorWhile0 = o.CollectorUntil0 = o.CollectorLast = o.CollectorArray = o.Collector = void 0;
    var E = requireCollector();
    Object.defineProperty(o, "Collector", { enumerable: !0, get: function() {
      return E.Collector;
    } });
    var A = requireCollectorArray();
    Object.defineProperty(o, "CollectorArray", { enumerable: !0, get: function() {
      return A.CollectorArray;
    } });
    var g = requireCollectorLast();
    Object.defineProperty(o, "CollectorLast", { enumerable: !0, get: function() {
      return g.CollectorLast;
    } });
    var e = requireCollectorUntil0();
    Object.defineProperty(o, "CollectorUntil0", { enumerable: !0, get: function() {
      return e.CollectorUntil0;
    } });
    var t = requireCollectorWhile0();
    Object.defineProperty(o, "CollectorWhile0", { enumerable: !0, get: function() {
      return t.CollectorWhile0;
    } });
    var c = requireSignal();
    Object.defineProperty(o, "Signal", { enumerable: !0, get: function() {
      return c.Signal;
    } });
    var n = requireSignalConnections();
    Object.defineProperty(o, "SignalConnections", { enumerable: !0, get: function() {
      return n.SignalConnections;
    } });
  })(dist)), dist;
}
var distExports = requireDist();
function createFormsData() {
  return {
    formsWithPendingChanges: /* @__PURE__ */ new Set(),
    formsWithUploads: /* @__PURE__ */ new Set(),
    submitButtons: /* @__PURE__ */ new Map()
  };
}
const LOG$7 = loglevelExports$1.getLogger("WidgetStateManager");
class WidgetStateDict {
  constructor() {
    this.widgetStates = /* @__PURE__ */ new Map();
  }
  /**
   * Create a new WidgetState proto for the widget with the given ID,
   * overwriting any that currently exists.
   */
  createState(E) {
    const A = new WidgetState({
      id: E
    });
    return this.widgetStates.set(E, A), A;
  }
  /** Return the WidgetState for the given widgetID if it exists. */
  getState(E) {
    return this.widgetStates.get(E);
  }
  /** Remove the WidgetState proto with the given id, if it exists. */
  deleteState(E) {
    this.widgetStates.delete(E);
  }
  /** Remove the state of widgets that are not contained in `activeIds`. */
  removeInactive(E) {
    this.widgetStates.forEach((A, g) => {
      E.has(g) || this.widgetStates.delete(g);
    });
  }
  /** Remove all widget states. */
  clear() {
    this.widgetStates.clear();
  }
  get isEmpty() {
    return this.widgetStates.size === 0;
  }
  createWidgetStatesMsg() {
    const E = new WidgetStates();
    return this.widgetStates.forEach((A) => E.widgets.push(A)), E;
  }
  /**
   * Copy the contents of another WidgetStateDict into this one, overwriting
   * any values with duplicate keys.
   */
  copyFrom(E) {
    E.widgetStates.forEach((A, g) => {
      this.widgetStates.set(g, A);
    });
  }
  /** Call a function for each value in the dict. */
  forEach(E) {
    this.widgetStates.forEach(E);
  }
}
class FormState {
  constructor() {
    this.widgetStates = new WidgetStateDict(), this.clearOnSubmit = !1, this.enterToSubmit = !0, this.formCleared = new distExports.Signal();
  }
  /** True if the form has a non-empty WidgetStateDict. */
  get hasPendingChanges() {
    return !this.widgetStates.isEmpty;
  }
}
class WidgetStateManager {
  constructor(E) {
    this.widgetStates = new WidgetStateDict(), this.forms = /* @__PURE__ */ new Map(), this.elementStates = /* @__PURE__ */ new Map(), this.pendingTriggerIds = /* @__PURE__ */ new Set(), this.triggerFlushResolvers = [], this.flushScheduled = !1, this.hasFragmentIdConflict = !1, this.props = E, this.formsData = createFormsData();
  }
  /**
   * Register a function that will be called when the given form is cleared.
   * Returns an object that can be used to de-register the listener.
   */
  addFormClearedListener(E, A) {
    return this.getOrCreateFormState(E).formCleared.connect(A);
  }
  /**
   * Register a Form, and assign its clearOnSubmit & enterToSubmit values.
   * The `Form` element calls this when it's first mounted.
   */
  setFormSubmitBehaviors(E, A, g = !0) {
    const e = this.getOrCreateFormState(E);
    e.clearOnSubmit = A, e.enterToSubmit = g;
  }
  /**
   * Commit pending changes for widgets that belong to the given form,
   * and send a rerunBackMsg to the server.
   */
  submitForm(E, A, g) {
    if (!isValidFormId(E))
      throw new Error(`invalid formID '${E}'`);
    const e = this.getOrCreateFormState(E), t = this.formsData.submitButtons.get(E);
    let c;
    g !== void 0 ? c = g : t !== void 0 && t.length > 0 && (c = t[0]), c && (this.createWidgetState(c, {
      fromUi: !0
    }).triggerValue = !0), this.widgetStates.copyFrom(e.widgetStates), e.widgetStates.clear(), this.sendUpdateWidgetsMessage(A), this.syncFormsWithPendingChanges(), c && this.deleteWidgetState(c.id), e.clearOnSubmit && e.formCleared.emit();
  }
  setChatInputValue(E, A, g, e) {
    this.createWidgetState(E, g).chatInputValue = new ChatInputValue(A), this.pendingTriggerIds.add(E.id), this.scheduleFlush(e);
  }
  /**
   * 1. Boolean trigger
   *    setTriggerValue(widgetInfo, { fromUi: true }, fragmentId)
   *
   * 2. Payload (JSON-encoded) trigger
   *    setTriggerValue(widgetInfo, { fromUi: true }, fragmentId, payload)
   *
   *    `payload` can be any JSON-serialisable value. For Bidi Component v2
   *    we always transport payloads via the protobuf `json_trigger_value`
   *    field as a JSON-stringified array of payload objects. Multiple calls
   *    within the same macrotask are batched into that array. If `payload`
   *    is omitted (or `undefined`) we fall back to the boolean
   *    `trigger_value=true` behaviour.
   */
  setTriggerValue(E, A, g, e) {
    let t = this.getWidgetState(E);
    if (t === void 0 && (t = this.createWidgetState(E, A)), e === void 0)
      t.triggerValue = !0;
    else {
      const c = e;
      try {
        if (isNullOrUndefined(t.jsonTriggerValue))
          t.jsonTriggerValue = JSON.stringify([c]);
        else {
          const n = t.jsonTriggerValue, h = JSON.parse(n), d = Array.isArray(h) ? h : [h];
          d.push(c), t.jsonTriggerValue = JSON.stringify(d);
        }
      } catch (n) {
        LOG$7.error("Failed to parse or stringify widgetState.jsonTriggerValue:", n), t.jsonTriggerValue = JSON.stringify([t.jsonTriggerValue, c]);
      }
    }
    return this.pendingTriggerIds.add(E.id), new Promise((c) => {
      this.triggerFlushResolvers.push(c), this.scheduleFlush(g);
    });
  }
  getBoolValue(E) {
    const A = this.getWidgetState(E);
    if (notNullOrUndefined(A) && A.value === "boolValue")
      return A.boolValue;
  }
  setBoolValue(E, A, g, e) {
    this.createWidgetState(E, g).boolValue = A, this.onWidgetValueChanged(E.formId, g, e);
  }
  getIntValue(E) {
    const A = this.getWidgetState(E);
    if (notNullOrUndefined(A) && A.value === "intValue")
      return requireNumberInt(A.intValue);
  }
  setIntValue(E, A, g, e) {
    this.createWidgetState(E, g).intValue = A, this.onWidgetValueChanged(E.formId, g, e);
  }
  getDoubleValue(E) {
    const A = this.getWidgetState(E);
    if (notNullOrUndefined(A) && A.value === "doubleValue")
      return A.doubleValue;
  }
  setDoubleValue(E, A, g, e) {
    this.createWidgetState(E, g).doubleValue = A, this.onWidgetValueChanged(E.formId, g, e);
  }
  getStringValue(E) {
    const A = this.getWidgetState(E);
    if (notNullOrUndefined(A) && A.value === "stringValue")
      return A.stringValue;
  }
  setStringValue(E, A, g, e) {
    this.createWidgetState(E, g).stringValue = A, this.onWidgetValueChanged(E.formId, g, e);
  }
  setStringArrayValue(E, A, g, e) {
    this.createWidgetState(E, g).stringArrayValue = new StringArray({
      data: A
    }), this.onWidgetValueChanged(E.formId, g, e);
  }
  getStringArrayValue(E) {
    const A = this.getWidgetState(E);
    if (notNullOrUndefined(A) && A.value === "stringArrayValue" && notNullOrUndefined(A.stringArrayValue) && notNullOrUndefined(A.stringArrayValue.data))
      return A.stringArrayValue.data;
  }
  getDoubleArrayValue(E) {
    const A = this.getWidgetState(E);
    if (notNullOrUndefined(A) && A.value === "doubleArrayValue" && notNullOrUndefined(A.doubleArrayValue) && notNullOrUndefined(A.doubleArrayValue.data))
      return A.doubleArrayValue.data;
  }
  setDoubleArrayValue(E, A, g, e) {
    this.createWidgetState(E, g).doubleArrayValue = new DoubleArray({
      data: A
    }), this.onWidgetValueChanged(E.formId, g, e);
  }
  getIntArrayValue(E) {
    const A = this.getWidgetState(E);
    if (notNullOrUndefined(A) && A.value === "intArrayValue" && notNullOrUndefined(A.intArrayValue) && notNullOrUndefined(A.intArrayValue.data))
      return A.intArrayValue.data.map(requireNumberInt);
  }
  setIntArrayValue(E, A, g, e) {
    this.createWidgetState(E, g).intArrayValue = new SInt64Array({
      data: A
    }), this.onWidgetValueChanged(E.formId, g, e);
  }
  getJsonValue(E) {
    const A = this.getWidgetState(E);
    if (notNullOrUndefined(A) && A.value === "jsonValue")
      return A.jsonValue;
  }
  setJsonValue(E, A, g, e) {
    this.createWidgetState(E, g).jsonValue = JSON.stringify(A), this.onWidgetValueChanged(E.formId, g, e);
  }
  setArrowValue(E, A, g, e) {
    this.createWidgetState(E, g).arrowValue = A, this.onWidgetValueChanged(E.formId, g, e);
  }
  getArrowValue(E) {
    const A = this.getWidgetState(E);
    if (notNullOrUndefined(A) && A.value === "arrowValue" && notNullOrUndefined(A.arrowValue))
      return A.arrowValue;
  }
  setBytesValue(E, A, g, e) {
    this.createWidgetState(E, g).bytesValue = A, this.onWidgetValueChanged(E.formId, g, e);
  }
  getBytesValue(E) {
    const A = this.getWidgetState(E);
    if (notNullOrUndefined(A) && A.value === "bytesValue")
      return A.bytesValue;
  }
  setFileUploaderStateValue(E, A, g, e) {
    this.createWidgetState(E, g).fileUploaderStateValue = A, this.onWidgetValueChanged(E.formId, g, e);
  }
  getFileUploaderStateValue(E) {
    const A = this.getWidgetState(E);
    if (notNullOrUndefined(A) && A.value === "fileUploaderStateValue")
      return A.fileUploaderStateValue;
  }
  /**
   * Perform housekeeping every time a widget value changes.
   * - If the widget does not belong to a form, and the value update came from
   *   a user action, send the "updateWidgets" message
   * - If the widget belongs to a form, dispatch the "pendingFormsChanged"
   *   callback if needed.
   *
   * Called by every "setValue" function.
   */
  onWidgetValueChanged(E, A, g) {
    isValidFormId(E) ? this.syncFormsWithPendingChanges() : A.fromUi && this.scheduleFlush(g);
  }
  /**
   * Update FormsData.formsWithPendingChanges with the current set of forms
   * that have pending changes. This is called after widget values are updated.
   */
  syncFormsWithPendingChanges() {
    const E = /* @__PURE__ */ new Set();
    this.forms.forEach((A, g) => {
      A.hasPendingChanges && E.add(g);
    }), this.updateFormsData((A) => {
      A.formsWithPendingChanges = E;
    });
  }
  sendUpdateWidgetsMessage(E, A = void 0) {
    this.props.sendRerunBackMsg(this.widgetStates.createWidgetStatesMsg(), E, void 0, A);
  }
  getActiveWidgetStates(E) {
    const A = new WidgetStates();
    return this.widgetStates.forEach((g) => {
      E.has(g.id) && A.widgets.push(g);
    }), A;
  }
  /**
   * Remove the state of widgets that are not contained in `activeIds`.
   * This is called when a script finishes running, so that we don't retain
   * data for widgets that have been removed from the app.
   */
  removeInactive(E) {
    this.widgetStates.removeInactive(E), this.forms.forEach((A) => A.widgetStates.removeInactive(E)), this.elementStates.forEach((A, g) => {
      E.has(g) || this.deleteElementState(g);
    });
  }
  /**
   * Create and return a new WidgetState proto for the given widget ID,
   * overwriting any that currently exists. If the widget belongs to a form,
   * the WidgetState will be created inside the form's WidgetStateDict.
   */
  createWidgetState(E, A) {
    return (isValidFormId(E.formId) && A.fromUi ? this.getOrCreateFormState(E.formId).widgetStates : this.widgetStates).createState(E.id);
  }
  /**
   * Get the WidgetState proto for the given widget ID, if it exists.
   */
  getWidgetState(E) {
    if (isValidFormId(E.formId)) {
      const A = this.forms.get(E.formId)?.widgetStates.getState(E.id);
      if (notNullOrUndefined(A))
        return A;
    }
    return this.widgetStates.getState(E.id);
  }
  /**
   * Remove the WidgetState proto with the given id, if it exists
   */
  deleteWidgetState(E) {
    this.widgetStates.deleteState(E);
  }
  /** Return the FormState for the given form. Create it if it doesn't exist. */
  getOrCreateFormState(E) {
    let A = this.forms.get(E);
    return notNullOrUndefined(A) || (A = new FormState(), this.forms.set(E, A)), A;
  }
  /** Store the IDs of all forms with in-progress uploads. */
  setFormsWithUploadsInProgress(E) {
    this.updateFormsData((A) => {
      A.formsWithUploads = E;
    });
  }
  /**
   * Helper function to determine whether a form allows enter to submit
   * for input elements (st.number_input, st.text_input, etc.)
   * If in form, checks form's enterToSubmit paramf first, otherwise default
   * behavior: Must have 1st submit button enabled to allow
   */
  allowFormEnterToSubmit(E) {
    if (!isValidFormId(E)) return !1;
    const A = this.forms.get(E);
    if (A && !A.enterToSubmit) return !1;
    const e = this.formsData.submitButtons.get(E)?.[0];
    return e ? !e.disabled : !1;
  }
  /**
   * Called by FormSubmitButton on creation. Add the SubmitButtonProto for
   * the given form and update FormsData.
   */
  addSubmitButton(E, A) {
    const g = this.formsData.submitButtons.get(E);
    if (g === void 0)
      this.setSubmitButtons(E, [A]);
    else {
      const e = Object.assign([], g);
      e.push(A), this.setSubmitButtons(E, e);
    }
  }
  /**
   * Called by FormSubmitButton on creation. Remove the SubmitButtonProto for
   * the given form, and update FormsData.
   */
  removeSubmitButton(E, A) {
    const g = this.formsData.submitButtons.get(E);
    if (g !== void 0) {
      const e = Object.assign([], g), t = e.indexOf(A, 0);
      t > -1 && e.splice(t, 1), this.setSubmitButtons(E, e);
    }
  }
  setSubmitButtons(E, A) {
    if (A.length < 0)
      throw new Error(`Bad submitButtons length ${A.length} (must be >= 0)`);
    this.updateFormsData((g) => {
      g.submitButtons.set(E, A);
    });
  }
  /**
   * Produce a new FormsData with the given recipe, and fire off the
   * formsDataChanged callback with that new data.
   */
  updateFormsData(E) {
    const A = produce(this.formsData, E);
    this.formsData !== A && (this.formsData = A, this.props.formsDataChanged(this.formsData));
  }
  /**
   * Get the element state value for the given element ID and key, if it exists.
   * This is a frontend-only state that is never sent to the server.
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace 'any' with a more specific type.
  getElementState(E, A) {
    return this.elementStates.get(E)?.get(A);
  }
  /**
   * Sets the state of an element identified by its ID and its key.
   * This is a frontend-only state that is never sent to the server.
   * It can be used to store element state to restore the state
   * of an element in situations where an element is removed and re-added.
   *
   * @param {string} elementId - The unique identifier of the element.
   * @param {string} key - The key to set
   * @param {any} value - The value to set for the element's state.
   * @returns {void}
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace 'any' with a more specific type.
  setElementState(E, A, g) {
    this.elementStates.has(E) || this.elementStates.set(E, /* @__PURE__ */ new Map()), this.elementStates.get(E).set(A, g);
  }
  /**
   * Deletes the state associated with a specific element by ID. If a key is provided,
   * only the state corresponding to that key is removed. If no key is specified, all states
   * associated with the element ID are removed.
   */
  deleteElementState(E, A) {
    notNullOrUndefined(A) ? this.elementStates.get(E)?.delete(A) : this.elementStates.delete(E);
  }
  /**
   * Schedule a macrotask-level flush of pending widget updates (triggers and
   * regular value changes). Multiple calls within the same macrotask will be
   * coalesced into a single `updateWidgets` message.
   */
  scheduleFlush(E) {
    this.scheduledFragmentId === void 0 && (this.scheduledFragmentId = E), this.scheduledFragmentId !== void 0 && E !== void 0 && E !== this.scheduledFragmentId && !this.hasFragmentIdConflict && (LOG$7.warn("Unexpected state: Multiple different fragmentIds detected in a single batch of widget updates. Proceeding with flushing updates using fragmentId '%s' for this batch.", this.scheduledFragmentId), this.hasFragmentIdConflict = !0), !this.flushScheduled && (this.flushScheduled = !0, setTimeout(() => {
      this.sendUpdateWidgetsMessage(this.scheduledFragmentId), this.pendingTriggerIds.forEach((A) => this.deleteWidgetState(A)), this.pendingTriggerIds.clear(), this.triggerFlushResolvers.forEach((A) => A()), this.triggerFlushResolvers = [], this.flushScheduled = !1, this.scheduledFragmentId = void 0, this.hasFragmentIdConflict = !1;
    }, 0));
  }
}
function requireNumberInt(o) {
  if (typeof o == "number")
    return o;
  const E = protobufjsExports.util.LongBits.from(o).toNumber();
  if (Number.isSafeInteger(E))
    return E;
  throw new Error(
    // eslint-disable-next-line @typescript-eslint/no-base-to-string, @typescript-eslint/restrict-template-expressions -- TODO: Fix this
    `value ${o} cannot be converted to number without a loss of precision!`
  );
}
class ReactHotkeys extends React__default.Component {
  constructor(E) {
    super(E), this.isKeyDown = !1, this.handle = void 0, this.onKeyDown = this.onKeyDown.bind(this), this.onKeyUp = this.onKeyUp.bind(this), this.handleKeyUpEvent = this.handleKeyUpEvent.bind(this), this.handle = {};
  }
  componentDidMount() {
    var {
      filter: E,
      splitKey: A
    } = this.props;
    E && (hotkeys.filter = E), hotkeys.unbind(this.props.keyName), hotkeys(this.props.keyName, {
      splitKey: A
    }, this.onKeyDown), document && document.body.addEventListener("keyup", this.handleKeyUpEvent);
  }
  componentWillUnmount() {
    hotkeys.unbind(this.props.keyName), this.isKeyDown = !0, this.handle = {}, document && document.body.removeEventListener("keyup", this.handleKeyUpEvent);
  }
  onKeyUp(E, A) {
    var {
      onKeyUp: g,
      disabled: e
    } = this.props;
    !e && g && g(A.shortcut, E, A);
  }
  onKeyDown(E, A) {
    var {
      onKeyDown: g,
      allowRepeat: e,
      disabled: t
    } = this.props;
    this.isKeyDown && !e || (this.isKeyDown = !0, this.handle = A, !t && g && g(A.shortcut, E, A));
  }
  handleKeyUpEvent(E) {
    this.isKeyDown && (this.isKeyDown = !1, !(this.props.keyName && this.props.keyName.indexOf(this.handle.shortcut) < 0) && (this.onKeyUp(E, this.handle), this.handle = {}));
  }
  render() {
    return this.props.children || null;
  }
}
ReactHotkeys.defaultProps = {
  filter(o) {
    var E = o.target || o.srcElement, A = E.tagName;
    return !(E.isContentEditable || A === "INPUT" || A === "SELECT" || A === "TEXTAREA");
  }
};
ReactHotkeys.propTypes = {
  keyName: propTypesExports.string,
  filter: propTypesExports.func,
  onKeyDown: propTypesExports.func,
  onKeyUp: propTypesExports.func,
  disabled: propTypesExports.bool,
  splitKey: propTypesExports.string
};
function EventContainer({
  children: o
}) {
  const E = useEmotionTheme();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      ToasterContainer,
      {
        placement: PLACEMENT$1.topRight,
        autoHideDuration: 4 * 1e3,
        overrides: {
          Root: {
            style: {
              // Avoids blocking the header
              top: E.sizes.headerHeight,
              zIndex: E.zIndices.toast
            },
            props: {
              "data-testid": "stToastContainer",
              className: "stToastContainer"
            }
          }
        }
      }
    ),
    o
  ] });
}
const StyledLogoContainer = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "ezrtsby6"
} : {
  target: "ezrtsby6",
  label: "StyledLogoContainer"
})(({
  theme: o
}) => ({
  marginLeft: o.spacing.lg
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2FwcC9zcmMvY29tcG9uZW50cy9IZWFkZXIvc3R5bGVkLWNvbXBvbmVudHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBb0JtQyIsImZpbGUiOiIvaG9tZS9ydW5uZXIvd29yay9zdGxpdGUvc3RsaXRlL3N0cmVhbWxpdC9mcm9udGVuZC9hcHAvc3JjL2NvbXBvbmVudHMvSGVhZGVyL3N0eWxlZC1jb21wb25lbnRzLnRzIiwic291cmNlc0NvbnRlbnQiOlsiLyoqXG4gKiBDb3B5cmlnaHQgKGMpIFN0cmVhbWxpdCBJbmMuICgyMDE4LTIwMjIpIFNub3dmbGFrZSBJbmMuICgyMDIyLTIwMjUpXG4gKlxuICogTGljZW5zZWQgdW5kZXIgdGhlIEFwYWNoZSBMaWNlbnNlLCBWZXJzaW9uIDIuMCAodGhlIFwiTGljZW5zZVwiKTtcbiAqIHlvdSBtYXkgbm90IHVzZSB0aGlzIGZpbGUgZXhjZXB0IGluIGNvbXBsaWFuY2Ugd2l0aCB0aGUgTGljZW5zZS5cbiAqIFlvdSBtYXkgb2J0YWluIGEgY29weSBvZiB0aGUgTGljZW5zZSBhdFxuICpcbiAqICAgICBodHRwOi8vd3d3LmFwYWNoZS5vcmcvbGljZW5zZXMvTElDRU5TRS0yLjBcbiAqXG4gKiBVbmxlc3MgcmVxdWlyZWQgYnkgYXBwbGljYWJsZSBsYXcgb3IgYWdyZWVkIHRvIGluIHdyaXRpbmcsIHNvZnR3YXJlXG4gKiBkaXN0cmlidXRlZCB1bmRlciB0aGUgTGljZW5zZSBpcyBkaXN0cmlidXRlZCBvbiBhbiBcIkFTIElTXCIgQkFTSVMsXG4gKiBXSVRIT1VUIFdBUlJBTlRJRVMgT1IgQ09ORElUSU9OUyBPRiBBTlkgS0lORCwgZWl0aGVyIGV4cHJlc3Mgb3IgaW1wbGllZC5cbiAqIFNlZSB0aGUgTGljZW5zZSBmb3IgdGhlIHNwZWNpZmljIGxhbmd1YWdlIGdvdmVybmluZyBwZXJtaXNzaW9ucyBhbmRcbiAqIGxpbWl0YXRpb25zIHVuZGVyIHRoZSBMaWNlbnNlLlxuICovXG5cbmltcG9ydCBzdHlsZWQgZnJvbSBcIkBlbW90aW9uL3N0eWxlZFwiXG5cbmltcG9ydCB7IEVtb3Rpb25UaGVtZSB9IGZyb20gXCJAc3RyZWFtbGl0L2xpYlwiXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRMb2dvQ29udGFpbmVyID0gc3R5bGVkLmRpdigoeyB0aGVtZSB9KSA9PiAoe1xuICBtYXJnaW5MZWZ0OiB0aGVtZS5zcGFjaW5nLmxnLFxufSkpXG5cbmV4cG9ydCBpbnRlcmZhY2UgU3R5bGVkSGVhZGVyUHJvcHMge1xuICBpc1RyYW5zcGFyZW50QmFja2dyb3VuZD86IGJvb2xlYW5cbn1cblxuZXhwb3J0IGNvbnN0IFN0eWxlZEhlYWRlciA9IHN0eWxlZC5oZWFkZXI8U3R5bGVkSGVhZGVyUHJvcHM+KFxuICAoeyB0aGVtZSwgaXNUcmFuc3BhcmVudEJhY2tncm91bmQgfSkgPT4gKHtcbiAgICBwb3NpdGlvbjogXCJhYnNvbHV0ZVwiLFxuICAgIHRvcDogMCxcbiAgICBsZWZ0OiAwLFxuICAgIHJpZ2h0OiAwLFxuICAgIGRpc3BsYXk6IFwiZmxleFwiLFxuICAgIGFsaWduSXRlbXM6IFwiY2VudGVyXCIsXG4gICAgaGVpZ2h0OiB0aGVtZS5zaXplcy5oZWFkZXJIZWlnaHQsXG4gICAgbWluSGVpZ2h0OiB0aGVtZS5zaXplcy5oZWFkZXJIZWlnaHQsXG4gICAgd2lkdGg6IFwiMTAwJVwiLFxuICAgIGJhY2tncm91bmQ6IGlzVHJhbnNwYXJlbnRCYWNrZ3JvdW5kID8gXCJ0cmFuc3BhcmVudFwiIDogdGhlbWUuY29sb3JzLmJnQ29sb3IsXG4gICAgb3V0bGluZTogXCJub25lXCIsXG4gICAgekluZGV4OiB0aGVtZS56SW5kaWNlcy5oZWFkZXIsXG4gICAgcG9pbnRlckV2ZW50czogaXNUcmFuc3BhcmVudEJhY2tncm91bmQgPyBcIm5vbmVcIiA6IFwiYXV0b1wiLFxuICAgIGZvbnRTaXplOiB0aGVtZS5mb250U2l6ZXMuc20sXG4gICAgXCJAbWVkaWEgcHJpbnRcIjoge1xuICAgICAgcG9zaXRpb246IFwiYWJzb2x1dGVcIixcbiAgICAgIGJhY2tncm91bmQ6IFwidHJhbnNwYXJlbnRcIixcbiAgICAgIC8vIEhpZGUgYWxsIGRlc2NlbmRhbnRzIGJ5IGRlZmF1bHRcbiAgICAgIFwiJiAqXCI6IHtcbiAgICAgICAgZGlzcGxheTogXCJub25lICFpbXBvcnRhbnRcIixcbiAgICAgIH0sXG4gICAgICAvLyBTaG93IHRoZSBsb2dvIGNvbnRhaW5lciBhbmQgaXRzIHBhcmVudHMvY29udGVudHNcbiAgICAgIFtgJiAke1N0eWxlZExvZ29Db250YWluZXJ9LCAmICR7U3R5bGVkTG9nb0NvbnRhaW5lcn0gKiwgJiA6aGFzKCR7U3R5bGVkTG9nb0NvbnRhaW5lcn0pYF06XG4gICAgICAgIHtcbiAgICAgICAgICBkaXNwbGF5OiBcImZsZXggIWltcG9ydGFudFwiLFxuICAgICAgICB9LFxuICAgICAgW2AmICR7U3R5bGVkTG9nb0NvbnRhaW5lcn0gaW1nYF06IHtcbiAgICAgICAgZGlzcGxheTogXCJibG9jayAhaW1wb3J0YW50XCIsXG4gICAgICB9LFxuICAgIH0sXG4gIH0pXG4pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRIZWFkZXJUb29sYmFyID0gc3R5bGVkLmRpdjx7XG4gIHRoZW1lOiBFbW90aW9uVGhlbWVcbn0+KCh7IHRoZW1lIH0pID0+ICh7XG4gIGRpc3BsYXk6IFwiZmxleFwiLFxuICBhbGlnbkl0ZW1zOiBcImNlbnRlclwiLFxuICBoZWlnaHQ6IFwiMTAwJVwiLFxuICB3aWR0aDogXCIxMDAlXCIsXG4gIHBhZGRpbmc6IDAsXG4gIHBvaW50ZXJFdmVudHM6IFwiYXV0b1wiLFxuICBwb3NpdGlvbjogXCJyZWxhdGl2ZVwiLFxuICB6SW5kZXg6IHRoZW1lLnpJbmRpY2VzLmhlYWRlcixcbn0pKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkT3BlblNpZGViYXJCdXR0b24gPSBzdHlsZWQuZGl2KCh7IHRoZW1lIH0pID0+ICh7XG4gIGRpc3BsYXk6IFwiZmxleFwiLFxuICBhbGlnbkl0ZW1zOiBcImNlbnRlclwiLFxuICBqdXN0aWZ5Q29udGVudDogXCJjZW50ZXJcIixcbiAgbWFyZ2luTGVmdDogdGhlbWUuc3BhY2luZy5sZyxcbiAgW2BAbWVkaWEgcHJpbnRgXToge1xuICAgIGRpc3BsYXk6IFwibm9uZVwiLFxuICB9LFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRIZWFkZXJDb250ZW50ID0gc3R5bGVkLmRpdigoKSA9PiAoe1xuICBmbGV4U2hyaW5rOiAwLFxuICBkaXNwbGF5OiBcImZsZXhcIixcbiAgYWxpZ25JdGVtczogXCJjZW50ZXJcIixcbiAganVzdGlmeUNvbnRlbnQ6IFwic3BhY2UtYmV0d2VlblwiLFxuICB3aWR0aDogXCIxMDAlXCIsXG4gIG1hcmdpbjogMCxcbiAgYm9yZGVyOiAwLFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRIZWFkZXJMZWZ0U2VjdGlvbiA9IHN0eWxlZC5kaXYoKCkgPT4gKHtcbiAgZGlzcGxheTogXCJmbGV4XCIsXG4gIGFsaWduSXRlbXM6IFwiY2VudGVyXCIsXG4gIC8vIFByZXZlbnQgdGhlIGxvZ28gYXJlYSBmcm9tIHNocmlua2luZyB3aGVuIFRvcE5hdidzIG92ZXJmbG93IGNvbnRhaW5lciBleHBhbmRzLlxuICAvLyBXaXRob3V0IHRoaXMsIHRoZSBsb2dvIHdvdWxkIHNocmluayBkdWUgdG8gaXRzIG1heFdpZHRoOiAxMDAlIHN0eWxlLlxuICBmbGV4U2hyaW5rOiAwLFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRIZWFkZXJSaWdodFNlY3Rpb24gPSBzdHlsZWQuZGl2KCh7IHRoZW1lIH0pID0+ICh7XG4gIGZsZXhTaHJpbms6IDAsXG4gIGRpc3BsYXk6IFwiZmxleFwiLFxuICBhbGlnbkl0ZW1zOiBcImNlbnRlclwiLFxuICBqdXN0aWZ5Q29udGVudDogXCJmbGV4LWVuZFwiLFxuICBtYXJnaW5MZWZ0OiBcImF1dG9cIixcbiAgaGVpZ2h0OiBcIjEwMCVcIixcbiAgbWluV2lkdGg6IHRoZW1lLnNpemVzLmhlYWRlclJpZ2h0Q29udGVudE1heFdpZHRoLFxuICBtYXJnaW5SaWdodDogdGhlbWUuc3BhY2luZy5sZyxcbn0pKVxuIl19 */"), StyledHeader$2 = /* @__PURE__ */ createStyled("header", process.env.NODE_ENV === "production" ? {
  target: "ezrtsby5"
} : {
  target: "ezrtsby5",
  label: "StyledHeader"
})(({
  theme: o,
  isTransparentBackground: E
}) => ({
  position: "absolute",
  top: 0,
  left: 0,
  right: 0,
  display: "flex",
  alignItems: "center",
  height: o.sizes.headerHeight,
  minHeight: o.sizes.headerHeight,
  width: "100%",
  background: E ? "transparent" : o.colors.bgColor,
  outline: "none",
  zIndex: o.zIndices.header,
  pointerEvents: E ? "none" : "auto",
  fontSize: o.fontSizes.sm,
  "@media print": {
    position: "absolute",
    background: "transparent",
    // Hide all descendants by default
    "& *": {
      display: "none !important"
    },
    // Show the logo container and its parents/contents
    [`& ${StyledLogoContainer}, & ${StyledLogoContainer} *, & :has(${StyledLogoContainer})`]: {
      display: "flex !important"
    },
    [`& ${StyledLogoContainer} img`]: {
      display: "block !important"
    }
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledHeaderToolbar = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "ezrtsby4"
} : {
  target: "ezrtsby4",
  label: "StyledHeaderToolbar"
})(({
  theme: o
}) => ({
  display: "flex",
  alignItems: "center",
  height: "100%",
  width: "100%",
  padding: 0,
  pointerEvents: "auto",
  position: "relative",
  zIndex: o.zIndices.header
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledOpenSidebarButton = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "ezrtsby3"
} : {
  target: "ezrtsby3",
  label: "StyledOpenSidebarButton"
})(({
  theme: o
}) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  marginLeft: o.spacing.lg,
  "@media print": {
    display: "none"
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledHeaderContent = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "ezrtsby2"
} : {
  target: "ezrtsby2",
  label: "StyledHeaderContent"
})(() => ({
  flexShrink: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  width: "100%",
  margin: 0,
  border: 0
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledHeaderLeftSection = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "ezrtsby1"
} : {
  target: "ezrtsby1",
  label: "StyledHeaderLeftSection"
})(() => ({
  display: "flex",
  alignItems: "center",
  // Prevent the logo area from shrinking when TopNav's overflow container expands.
  // Without this, the logo would shrink due to its maxWidth: 100% style.
  flexShrink: 0
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledHeaderRightSection = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "ezrtsby0"
} : {
  target: "ezrtsby0",
  label: "StyledHeaderRightSection"
})(({
  theme: o
}) => ({
  flexShrink: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  marginLeft: "auto",
  height: "100%",
  minWidth: o.sizes.headerRightContentMaxWidth,
  marginRight: o.spacing.lg
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), Header = ({
  hasSidebar: o,
  isSidebarOpen: E,
  onToggleSidebar: A,
  navigation: g,
  rightContent: e,
  logoComponent: t,
  showToolbar: c
}) => {
  const {
    activeTheme: n
  } = useContext(ThemeContext), h = t && !E, d = o && !E, k = c && e, p = h || d || g || k;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledHeader$2, { className: "stAppHeader", "data-testid": "stHeader", isTransparentBackground: !p, children: p ? /* @__PURE__ */ jsxRuntimeExports.jsx(StyledHeaderToolbar, { className: "stAppToolbar", "data-testid": "stToolbar", theme: n.emotion, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledHeaderContent, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledHeaderLeftSection, { children: [
      h ? /* @__PURE__ */ jsxRuntimeExports.jsx(StyledLogoContainer, { children: t }) : null,
      d && /* @__PURE__ */ jsxRuntimeExports.jsx(StyledOpenSidebarButton, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(BaseButton, { kind: BaseButtonKind.HEADER_NO_PADDING, onClick: A, "data-testid": "stExpandSidebarButton", children: /* @__PURE__ */ jsxRuntimeExports.jsx(DynamicIcon, { size: "xl", iconValue: ":material/keyboard_double_arrow_right:", color: n.emotion.colors.fadedText60 }) }) })
    ] }),
    g,
    k ? /* @__PURE__ */ jsxRuntimeExports.jsx(StyledHeaderRightSection, { children: e }) : null
  ] }) }) : null });
};
function _EMOTION_STRINGIFIED_CSS_ERROR__$8() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const getSidebarHorizontalSpacing = (o, E) => `max(
    ${E}px,
    calc(${o.spacing.xl} - ${E}px)
  )`, StyledSidebar = /* @__PURE__ */ createStyled("section", process.env.NODE_ENV === "production" ? {
  target: "eczjsme8"
} : {
  target: "eczjsme8",
  label: "StyledSidebar"
})(({
  theme: o,
  isCollapsed: E,
  adjustTop: A,
  sidebarWidth: g,
  windowInnerWidth: e
}) => {
  const t = E ? 0 : Math.min(200, e), c = E ? 0 : Math.min(600, e * 0.9);
  return {
    position: "relative",
    // Nudge the sidebar by 2px so the header decoration doesn't go below it
    top: A ? o.sizes.headerDecorationHeight : o.spacing.none,
    backgroundColor: o.colors.bgColor,
    // Since the sidebar can have a different theme (+ background)
    // we need to explicitly set the font color and color scheme
    // here again so that it is inherited correctly by all sidebar elements:
    color: o.colors.bodyText,
    colorScheme: hasLightBackgroundColor(o) ? "light" : "dark",
    zIndex: o.zIndices.header + 1,
    minWidth: t,
    maxWidth: c,
    transform: E ? `translateX(-${g}px)` : "none",
    transition: "transform 300ms, min-width 300ms, max-width 300ms",
    "&:focus": {
      outline: "none"
    },
    [`@media (max-width: ${o.breakpoints.md})`]: {
      boxShadow: `-2rem 0 2rem 2rem ${E ? "transparent" : "#00000029"}`
    },
    "@media print": {
      display: E ? "none" : "initial",
      // set to auto, otherwise the sidebar does not take up the whole page
      height: "auto !important",
      // set maxHeight to little bit less than 100%, otherwise the sidebar might start a mostly blank page
      maxHeight: "99%",
      // on Chrome, sth. adds a box-shadow in printing mode which looks weird
      boxShadow: "none"
    }
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledSidebarUserContent = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "eczjsme7"
} : {
  target: "eczjsme7",
  label: "StyledSidebarUserContent"
})(({
  hasPageNavAbove: o,
  theme: E
}) => ({
  paddingTop: o ? E.spacing.twoXL : 0,
  paddingBottom: E.sizes.sidebarTopSpace
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledSidebarContent = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "eczjsme6"
} : {
  target: "eczjsme6",
  label: "StyledSidebarContent"
})(({
  theme: o,
  scrollbarGutterSize: E
}) => ({
  position: "relative",
  height: "100%",
  width: "100%",
  overflow: "auto",
  /**
   * Ensure that space is reserved for scrollbars, even when they are not
   * visible. This is necessary to prevent layout shifts when the scrollbars
   * appear and disappear.
   *
   * We utilize both-edges so that things look visually centered and aligned.
   *
   * @see https://github.com/streamlit/streamlit/issues/10310
   */
  scrollbarGutter: "stable both-edges",
  paddingLeft: getSidebarHorizontalSpacing(o, E),
  paddingRight: getSidebarHorizontalSpacing(o, E)
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), RESIZE_HANDLE_WIDTH = "8px", StyledResizeHandle = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "eczjsme5"
} : {
  target: "eczjsme5",
  label: "StyledResizeHandle"
})(({
  theme: o
}) => ({
  position: "absolute",
  width: RESIZE_HANDLE_WIDTH,
  height: "100%",
  cursor: "col-resize",
  zIndex: o.zIndices.sidebarMobile,
  backgroundImage: o.showSidebarBorder ? `linear-gradient(to right, transparent 20%, ${o.colors.borderColor} 28%, transparent 36%)` : "none",
  "&:hover": {
    backgroundImage: `linear-gradient(to right, transparent 20%, ${o.colors.borderColor} 28%, transparent 44%)`
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledSidebarHeaderContainer = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "eczjsme4"
} : {
  target: "eczjsme4",
  label: "StyledSidebarHeaderContainer"
})(({
  theme: o
}) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginBottom: o.spacing.lg,
  height: o.sizes.headerHeight
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledLogoLink = /* @__PURE__ */ createStyled("a", process.env.NODE_ENV === "production" ? {
  target: "eczjsme3"
} : {
  target: "eczjsme3",
  label: "StyledLogoLink"
})(process.env.NODE_ENV === "production" ? {
  name: "t02jc9",
  styles: "&:hover{opacity:0.7;}"
} : {
  name: "t02jc9",
  styles: "&:hover{opacity:0.7;}/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$8
});
function translateLogoHeight(o, E) {
  return E === "small" ? o.sizes.smallLogoHeight : E === "large" ? o.sizes.largeLogoHeight : o.sizes.defaultLogoHeight;
}
const StyledLogo = /* @__PURE__ */ createStyled("img", process.env.NODE_ENV === "production" ? {
  target: "eczjsme2"
} : {
  target: "eczjsme2",
  label: "StyledLogo"
})(({
  theme: o,
  size: E
}) => ({
  height: translateLogoHeight(o, E),
  // Extra margin to align small logo with sidebar collapse arrow
  marginTop: E == "small" ? o.spacing.xs : o.spacing.twoXS,
  marginBottom: E == "small" ? o.spacing.xs : o.spacing.twoXS,
  marginLeft: o.spacing.none,
  zIndex: o.zIndices.header,
  objectFit: "contain",
  objectPosition: "left",
  verticalAlign: "middle",
  maxWidth: "100%"
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2FwcC9zcmMvY29tcG9uZW50cy9TaWRlYmFyL3N0eWxlZC1jb21wb25lbnRzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWdMMEIiLCJmaWxlIjoiL2hvbWUvcnVubmVyL3dvcmsvc3RsaXRlL3N0bGl0ZS9zdHJlYW1saXQvZnJvbnRlbmQvYXBwL3NyYy9jb21wb25lbnRzL1NpZGViYXIvc3R5bGVkLWNvbXBvbmVudHMudHMiLCJzb3VyY2VzQ29udGVudCI6WyIvKipcbiAqIENvcHlyaWdodCAoYykgU3RyZWFtbGl0IEluYy4gKDIwMTgtMjAyMikgU25vd2ZsYWtlIEluYy4gKDIwMjItMjAyNSlcbiAqXG4gKiBMaWNlbnNlZCB1bmRlciB0aGUgQXBhY2hlIExpY2Vuc2UsIFZlcnNpb24gMi4wICh0aGUgXCJMaWNlbnNlXCIpO1xuICogeW91IG1heSBub3QgdXNlIHRoaXMgZmlsZSBleGNlcHQgaW4gY29tcGxpYW5jZSB3aXRoIHRoZSBMaWNlbnNlLlxuICogWW91IG1heSBvYnRhaW4gYSBjb3B5IG9mIHRoZSBMaWNlbnNlIGF0XG4gKlxuICogICAgIGh0dHA6Ly93d3cuYXBhY2hlLm9yZy9saWNlbnNlcy9MSUNFTlNFLTIuMFxuICpcbiAqIFVubGVzcyByZXF1aXJlZCBieSBhcHBsaWNhYmxlIGxhdyBvciBhZ3JlZWQgdG8gaW4gd3JpdGluZywgc29mdHdhcmVcbiAqIGRpc3RyaWJ1dGVkIHVuZGVyIHRoZSBMaWNlbnNlIGlzIGRpc3RyaWJ1dGVkIG9uIGFuIFwiQVMgSVNcIiBCQVNJUyxcbiAqIFdJVEhPVVQgV0FSUkFOVElFUyBPUiBDT05ESVRJT05TIE9GIEFOWSBLSU5ELCBlaXRoZXIgZXhwcmVzcyBvciBpbXBsaWVkLlxuICogU2VlIHRoZSBMaWNlbnNlIGZvciB0aGUgc3BlY2lmaWMgbGFuZ3VhZ2UgZ292ZXJuaW5nIHBlcm1pc3Npb25zIGFuZFxuICogbGltaXRhdGlvbnMgdW5kZXIgdGhlIExpY2Vuc2UuXG4gKi9cblxuaW1wb3J0IHN0eWxlZCBmcm9tIFwiQGVtb3Rpb24vc3R5bGVkXCJcblxuaW1wb3J0IHsgRW1vdGlvblRoZW1lLCBoYXNMaWdodEJhY2tncm91bmRDb2xvciB9IGZyb20gXCJAc3RyZWFtbGl0L2xpYlwiXG5cbi8qKlxuICogUmV0dXJucyB0aGUgaG9yaXpvbnRhbCBzcGFjaW5nIGZvciB0aGUgc2lkZWJhciwgdGFraW5nIGludG8gY29uc2lkZXJhdGlvblxuICogdGhlIHNjcm9sbGJhciBndXR0ZXJzIChvbmUgb24gZWFjaCBzaWRlKSB3aGljaCBhcmUgcHJlc2VudCB3aGVuIHRoZSBPU1xuICogZG9lc24ndCBzdXBwb3J0IG92ZXJsYXkgc2Nyb2xsYmFycy5cbiAqXG4gKiBAcGFyYW0gdGhlbWUgVGhlIHRoZW1lIHRvIHVzZS5cbiAqIEByZXR1cm5zIFRoZSBob3Jpem9udGFsIHNwYWNpbmcgZm9yIHRoZSBzaWRlYmFyLlxuICovXG5leHBvcnQgY29uc3QgZ2V0U2lkZWJhckhvcml6b250YWxTcGFjaW5nID0gKFxuICB0aGVtZTogRW1vdGlvblRoZW1lLFxuICBzY3JvbGxiYXJHdXR0ZXJTaXplOiBudW1iZXJcbik6IHN0cmluZyA9PiB7XG4gIC8vIFRoaXMgc2hvdWxkIGJlIG1heCgwcHgsIC4uLiksIGJ1dCB0aGVyZSdzIGEgQ2hyb21lIGJ1ZyB0aGF0XG4gIC8vIGNhdXNlcyBjb250ZW50IHRvIGNsaXAgd2hlbiBzY3JvbGxiYXItZ3V0dGVyIGlzIHNldCB0byBcInN0YWJsZSBib3RoLWVkZ2VzXCIuXG4gIC8vIFNvIHdlIGNoYW5nZSB0aGUgbWluIGZyb20gMHB4IHRvIHNjcm9sbGJhckd1dHRlclNpemUgdG8gYWNjb3VudCBmb3IgdGhhdC5cbiAgLy8gQ2hyb21lIGJ1ZzogaHR0cHM6Ly9pc3N1ZXMuY2hyb21pdW0ub3JnL2lzc3Vlcy80MDA2NDg3OVxuICByZXR1cm4gYG1heChcbiAgICAke3Njcm9sbGJhckd1dHRlclNpemV9cHgsXG4gICAgY2FsYygke3RoZW1lLnNwYWNpbmcueGx9IC0gJHtzY3JvbGxiYXJHdXR0ZXJTaXplfXB4KVxuICApYFxufVxuXG5leHBvcnQgaW50ZXJmYWNlIFN0eWxlZFNpZGViYXJQcm9wcyB7XG4gIGlzQ29sbGFwc2VkOiBib29sZWFuXG4gIGFkanVzdFRvcDogYm9vbGVhblxuICBzaWRlYmFyV2lkdGg6IHN0cmluZ1xuICB3aW5kb3dJbm5lcldpZHRoOiBudW1iZXJcbn1cblxuZXhwb3J0IGNvbnN0IFN0eWxlZFNpZGViYXIgPSBzdHlsZWQuc2VjdGlvbjxTdHlsZWRTaWRlYmFyUHJvcHM+KFxuICAoeyB0aGVtZSwgaXNDb2xsYXBzZWQsIGFkanVzdFRvcCwgc2lkZWJhcldpZHRoLCB3aW5kb3dJbm5lcldpZHRoIH0pID0+IHtcbiAgICBjb25zdCBtaW5XaWR0aCA9IGlzQ29sbGFwc2VkID8gMCA6IE1hdGgubWluKDIwMCwgd2luZG93SW5uZXJXaWR0aClcbiAgICBjb25zdCBtYXhXaWR0aCA9IGlzQ29sbGFwc2VkID8gMCA6IE1hdGgubWluKDYwMCwgd2luZG93SW5uZXJXaWR0aCAqIDAuOSlcblxuICAgIHJldHVybiB7XG4gICAgICBwb3NpdGlvbjogXCJyZWxhdGl2ZVwiLFxuICAgICAgLy8gTnVkZ2UgdGhlIHNpZGViYXIgYnkgMnB4IHNvIHRoZSBoZWFkZXIgZGVjb3JhdGlvbiBkb2Vzbid0IGdvIGJlbG93IGl0XG4gICAgICB0b3A6IGFkanVzdFRvcCA/IHRoZW1lLnNpemVzLmhlYWRlckRlY29yYXRpb25IZWlnaHQgOiB0aGVtZS5zcGFjaW5nLm5vbmUsXG4gICAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5iZ0NvbG9yLFxuICAgICAgLy8gU2luY2UgdGhlIHNpZGViYXIgY2FuIGhhdmUgYSBkaWZmZXJlbnQgdGhlbWUgKCsgYmFja2dyb3VuZClcbiAgICAgIC8vIHdlIG5lZWQgdG8gZXhwbGljaXRseSBzZXQgdGhlIGZvbnQgY29sb3IgYW5kIGNvbG9yIHNjaGVtZVxuICAgICAgLy8gaGVyZSBhZ2FpbiBzbyB0aGF0IGl0IGlzIGluaGVyaXRlZCBjb3JyZWN0bHkgYnkgYWxsIHNpZGViYXIgZWxlbWVudHM6XG4gICAgICBjb2xvcjogdGhlbWUuY29sb3JzLmJvZHlUZXh0LFxuICAgICAgY29sb3JTY2hlbWU6IGhhc0xpZ2h0QmFja2dyb3VuZENvbG9yKHRoZW1lKSA/IFwibGlnaHRcIiA6IFwiZGFya1wiLFxuICAgICAgekluZGV4OiB0aGVtZS56SW5kaWNlcy5oZWFkZXIgKyAxLFxuXG4gICAgICBtaW5XaWR0aCxcbiAgICAgIG1heFdpZHRoLFxuICAgICAgdHJhbnNmb3JtOiBpc0NvbGxhcHNlZCA/IGB0cmFuc2xhdGVYKC0ke3NpZGViYXJXaWR0aH1weClgIDogXCJub25lXCIsXG4gICAgICB0cmFuc2l0aW9uOiBcInRyYW5zZm9ybSAzMDBtcywgbWluLXdpZHRoIDMwMG1zLCBtYXgtd2lkdGggMzAwbXNcIixcblxuICAgICAgXCImOmZvY3VzXCI6IHtcbiAgICAgICAgb3V0bGluZTogXCJub25lXCIsXG4gICAgICB9LFxuXG4gICAgICBbYEBtZWRpYSAobWF4LXdpZHRoOiAke3RoZW1lLmJyZWFrcG9pbnRzLm1kfSlgXToge1xuICAgICAgICBib3hTaGFkb3c6IGAtMnJlbSAwIDJyZW0gMnJlbSAke1xuICAgICAgICAgIGlzQ29sbGFwc2VkID8gXCJ0cmFuc3BhcmVudFwiIDogXCIjMDAwMDAwMjlcIlxuICAgICAgICB9YCxcbiAgICAgIH0sXG5cbiAgICAgIFtgQG1lZGlhIHByaW50YF06IHtcbiAgICAgICAgZGlzcGxheTogaXNDb2xsYXBzZWQgPyBcIm5vbmVcIiA6IFwiaW5pdGlhbFwiLFxuICAgICAgICAvLyBzZXQgdG8gYXV0bywgb3RoZXJ3aXNlIHRoZSBzaWRlYmFyIGRvZXMgbm90IHRha2UgdXAgdGhlIHdob2xlIHBhZ2VcbiAgICAgICAgaGVpZ2h0OiBcImF1dG8gIWltcG9ydGFudFwiLFxuICAgICAgICAvLyBzZXQgbWF4SGVpZ2h0IHRvIGxpdHRsZSBiaXQgbGVzcyB0aGFuIDEwMCUsIG90aGVyd2lzZSB0aGUgc2lkZWJhciBtaWdodCBzdGFydCBhIG1vc3RseSBibGFuayBwYWdlXG4gICAgICAgIG1heEhlaWdodDogXCI5OSVcIixcbiAgICAgICAgLy8gb24gQ2hyb21lLCBzdGguIGFkZHMgYSBib3gtc2hhZG93IGluIHByaW50aW5nIG1vZGUgd2hpY2ggbG9va3Mgd2VpcmRcbiAgICAgICAgYm94U2hhZG93OiBcIm5vbmVcIixcbiAgICAgIH0sXG4gICAgfVxuICB9XG4pXG5cbmV4cG9ydCBpbnRlcmZhY2UgU3R5bGVkU2lkZWJhclVzZXJDb250ZW50UHJvcHMge1xuICBoYXNQYWdlTmF2QWJvdmU6IGJvb2xlYW5cbn1cblxuZXhwb3J0IGNvbnN0IFN0eWxlZFNpZGViYXJVc2VyQ29udGVudCA9XG4gIHN0eWxlZC5kaXY8U3R5bGVkU2lkZWJhclVzZXJDb250ZW50UHJvcHM+KCh7IGhhc1BhZ2VOYXZBYm92ZSwgdGhlbWUgfSkgPT4gKHtcbiAgICBwYWRkaW5nVG9wOiBoYXNQYWdlTmF2QWJvdmUgPyB0aGVtZS5zcGFjaW5nLnR3b1hMIDogMCxcbiAgICBwYWRkaW5nQm90dG9tOiB0aGVtZS5zaXplcy5zaWRlYmFyVG9wU3BhY2UsXG4gIH0pKVxuXG5leHBvcnQgaW50ZXJmYWNlIFN0eWxlZFNpZGViYXJDb250ZW50UHJvcHMge1xuICBzY3JvbGxiYXJHdXR0ZXJTaXplOiBudW1iZXJcbn1cblxuZXhwb3J0IGNvbnN0IFN0eWxlZFNpZGViYXJDb250ZW50ID0gc3R5bGVkLmRpdjxTdHlsZWRTaWRlYmFyQ29udGVudFByb3BzPihcbiAgKHsgdGhlbWUsIHNjcm9sbGJhckd1dHRlclNpemUgfSkgPT4gKHtcbiAgICBwb3NpdGlvbjogXCJyZWxhdGl2ZVwiLFxuICAgIGhlaWdodDogXCIxMDAlXCIsXG4gICAgd2lkdGg6IFwiMTAwJVwiLFxuICAgIG92ZXJmbG93OiBcImF1dG9cIixcbiAgICAvKipcbiAgICAgKiBFbnN1cmUgdGhhdCBzcGFjZSBpcyByZXNlcnZlZCBmb3Igc2Nyb2xsYmFycywgZXZlbiB3aGVuIHRoZXkgYXJlIG5vdFxuICAgICAqIHZpc2libGUuIFRoaXMgaXMgbmVjZXNzYXJ5IHRvIHByZXZlbnQgbGF5b3V0IHNoaWZ0cyB3aGVuIHRoZSBzY3JvbGxiYXJzXG4gICAgICogYXBwZWFyIGFuZCBkaXNhcHBlYXIuXG4gICAgICpcbiAgICAgKiBXZSB1dGlsaXplIGJvdGgtZWRnZXMgc28gdGhhdCB0aGluZ3MgbG9vayB2aXN1YWxseSBjZW50ZXJlZCBhbmQgYWxpZ25lZC5cbiAgICAgKlxuICAgICAqIEBzZWUgaHR0cHM6Ly9naXRodWIuY29tL3N0cmVhbWxpdC9zdHJlYW1saXQvaXNzdWVzLzEwMzEwXG4gICAgICovXG4gICAgc2Nyb2xsYmFyR3V0dGVyOiBcInN0YWJsZSBib3RoLWVkZ2VzXCIsXG4gICAgcGFkZGluZ0xlZnQ6IGdldFNpZGViYXJIb3Jpem9udGFsU3BhY2luZyh0aGVtZSwgc2Nyb2xsYmFyR3V0dGVyU2l6ZSksXG4gICAgcGFkZGluZ1JpZ2h0OiBnZXRTaWRlYmFySG9yaXpvbnRhbFNwYWNpbmcodGhlbWUsIHNjcm9sbGJhckd1dHRlclNpemUpLFxuICB9KVxuKVxuXG5leHBvcnQgY29uc3QgUkVTSVpFX0hBTkRMRV9XSURUSCA9IFwiOHB4XCJcblxuZXhwb3J0IGNvbnN0IFN0eWxlZFJlc2l6ZUhhbmRsZSA9IHN0eWxlZC5kaXYoKHsgdGhlbWUgfSkgPT4gKHtcbiAgcG9zaXRpb246IFwiYWJzb2x1dGVcIixcbiAgd2lkdGg6IFJFU0laRV9IQU5ETEVfV0lEVEgsXG4gIGhlaWdodDogXCIxMDAlXCIsXG4gIGN1cnNvcjogXCJjb2wtcmVzaXplXCIsXG4gIHpJbmRleDogdGhlbWUuekluZGljZXMuc2lkZWJhck1vYmlsZSxcbiAgYmFja2dyb3VuZEltYWdlOiB0aGVtZS5zaG93U2lkZWJhckJvcmRlclxuICAgID8gYGxpbmVhci1ncmFkaWVudCh0byByaWdodCwgdHJhbnNwYXJlbnQgMjAlLCAke3RoZW1lLmNvbG9ycy5ib3JkZXJDb2xvcn0gMjglLCB0cmFuc3BhcmVudCAzNiUpYFxuICAgIDogXCJub25lXCIsXG5cbiAgXCImOmhvdmVyXCI6IHtcbiAgICBiYWNrZ3JvdW5kSW1hZ2U6IGBsaW5lYXItZ3JhZGllbnQodG8gcmlnaHQsIHRyYW5zcGFyZW50IDIwJSwgJHt0aGVtZS5jb2xvcnMuYm9yZGVyQ29sb3J9IDI4JSwgdHJhbnNwYXJlbnQgNDQlKWAsXG4gIH0sXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZFNpZGViYXJIZWFkZXJDb250YWluZXIgPSBzdHlsZWQuZGl2KCh7IHRoZW1lIH0pID0+ICh7XG4gIGRpc3BsYXk6IFwiZmxleFwiLFxuICBqdXN0aWZ5Q29udGVudDogXCJzcGFjZS1iZXR3ZWVuXCIsXG4gIGFsaWduSXRlbXM6IFwiY2VudGVyXCIsXG4gIG1hcmdpbkJvdHRvbTogdGhlbWUuc3BhY2luZy5sZyxcbiAgaGVpZ2h0OiB0aGVtZS5zaXplcy5oZWFkZXJIZWlnaHQsXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZExvZ29MaW5rID0gc3R5bGVkLmEoe1xuICBcIiY6aG92ZXJcIjoge1xuICAgIG9wYWNpdHk6IFwiMC43XCIsXG4gIH0sXG59KVxuXG5leHBvcnQgaW50ZXJmYWNlIFN0eWxlZExvZ29Qcm9wcyB7XG4gIHNpemU6IHN0cmluZ1xuICBzaWRlYmFyV2lkdGg/OiBzdHJpbmdcbn1cblxuLy8gZXNsaW50LWRpc2FibGUtbmV4dC1saW5lIEB0eXBlc2NyaXB0LWVzbGludC9uby1leHBsaWNpdC1hbnkgLS0gVE9ETzogUmVwbGFjZSAnYW55JyB3aXRoIGEgbW9yZSBzcGVjaWZpYyB0eXBlLlxuZnVuY3Rpb24gdHJhbnNsYXRlTG9nb0hlaWdodCh0aGVtZTogYW55LCBzaXplOiBzdHJpbmcpOiBzdHJpbmcge1xuICBpZiAoc2l6ZSA9PT0gXCJzbWFsbFwiKSB7XG4gICAgcmV0dXJuIHRoZW1lLnNpemVzLnNtYWxsTG9nb0hlaWdodFxuICB9IGVsc2UgaWYgKHNpemUgPT09IFwibGFyZ2VcIikge1xuICAgIHJldHVybiB0aGVtZS5zaXplcy5sYXJnZUxvZ29IZWlnaHRcbiAgfVxuICAvLyBEZWZhdWx0IGxvZ28gc2l6ZVxuICByZXR1cm4gdGhlbWUuc2l6ZXMuZGVmYXVsdExvZ29IZWlnaHRcbn1cblxuZXhwb3J0IGNvbnN0IFN0eWxlZExvZ28gPSBzdHlsZWQuaW1nPFN0eWxlZExvZ29Qcm9wcz4oKHsgdGhlbWUsIHNpemUgfSkgPT4gKHtcbiAgaGVpZ2h0OiB0cmFuc2xhdGVMb2dvSGVpZ2h0KHRoZW1lLCBzaXplKSxcbiAgLy8gRXh0cmEgbWFyZ2luIHRvIGFsaWduIHNtYWxsIGxvZ28gd2l0aCBzaWRlYmFyIGNvbGxhcHNlIGFycm93XG4gIG1hcmdpblRvcDogc2l6ZSA9PSBcInNtYWxsXCIgPyB0aGVtZS5zcGFjaW5nLnhzIDogdGhlbWUuc3BhY2luZy50d29YUyxcbiAgbWFyZ2luQm90dG9tOiBzaXplID09IFwic21hbGxcIiA/IHRoZW1lLnNwYWNpbmcueHMgOiB0aGVtZS5zcGFjaW5nLnR3b1hTLFxuICBtYXJnaW5MZWZ0OiB0aGVtZS5zcGFjaW5nLm5vbmUsXG4gIHpJbmRleDogdGhlbWUuekluZGljZXMuaGVhZGVyLFxuICBvYmplY3RGaXQ6IFwiY29udGFpblwiLFxuICBvYmplY3RQb3NpdGlvbjogXCJsZWZ0XCIsXG4gIHZlcnRpY2FsQWxpZ246IFwibWlkZGxlXCIsXG4gIG1heFdpZHRoOiBgMTAwJWAsXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZE5vTG9nb1NwYWNlciA9IHN0eWxlZC5kaXYoKHsgdGhlbWUgfSkgPT4gKHtcbiAgaGVpZ2h0OiB0aGVtZS5zaXplcy5sYXJnZUxvZ29IZWlnaHQsXG59KSlcblxuZXhwb3J0IGludGVyZmFjZSBTdHlsZWRDb2xsYXBzZVNpZGViYXJCdXR0b25Qcm9wcyB7XG4gIHNob3dTaWRlYmFyQ29sbGFwc2U6IGJvb2xlYW5cbn1cblxuZXhwb3J0IGNvbnN0IFN0eWxlZENvbGxhcHNlU2lkZWJhckJ1dHRvbiA9XG4gIHN0eWxlZC5kaXY8U3R5bGVkQ29sbGFwc2VTaWRlYmFyQnV0dG9uUHJvcHM+KFxuICAgICh7IHNob3dTaWRlYmFyQ29sbGFwc2UsIHRoZW1lIH0pID0+IHtcbiAgICAgIHJldHVybiB7XG4gICAgICAgIGRpc3BsYXk6IFwiaW5saW5lXCIsXG4gICAgICAgIHZpc2liaWxpdHk6IHNob3dTaWRlYmFyQ29sbGFwc2UgPyBcInZpc2libGVcIiA6IFwiaGlkZGVuXCIsXG4gICAgICAgIG1hcmdpbkxlZnQ6IHRoZW1lLnNwYWNpbmcuc20sXG4gICAgICAgIHRyYW5zaXRpb246IFwibGVmdCAzMDBtc1wiLFxuICAgICAgICB0cmFuc2l0aW9uRGVsYXk6IFwibGVmdCAzMDBtc1wiLFxuICAgICAgICBjb2xvcjogaGFzTGlnaHRCYWNrZ3JvdW5kQ29sb3IodGhlbWUpXG4gICAgICAgICAgPyB0aGVtZS5jb2xvcnMuZmFkZWRUZXh0NjBcbiAgICAgICAgICA6IHRoZW1lLmNvbG9ycy5ib2R5VGV4dCxcbiAgICAgICAgbGluZUhlaWdodDogXCIwXCIsXG5cbiAgICAgICAgW2BAbWVkaWEgcHJpbnRgXToge1xuICAgICAgICAgIC8vIEFsd2F5cyBoaWRlIHRoZSBjb2xsYXBzZSBidXR0b24gb24gcHJpbnQ6XG4gICAgICAgICAgdmlzaWJpbGl0eTogXCJoaWRkZW5cIixcbiAgICAgICAgfSxcblxuICAgICAgICBbYEBtZWRpYSAobWF4LXdpZHRoOiAke3RoZW1lLmJyZWFrcG9pbnRzLnNtfSlgXToge1xuICAgICAgICAgIC8vIEFsd2F5cyBzaG93IHRoZSBjb2xsYXBzZSBidXR0b24gb24gc21hbGwgc2NyZWVuczpcbiAgICAgICAgICB2aXNpYmlsaXR5OiBcInZpc2libGVcIixcbiAgICAgICAgfSxcbiAgICAgIH1cbiAgICB9XG4gIClcbiJdfQ== */"), StyledNoLogoSpacer = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "eczjsme1"
} : {
  target: "eczjsme1",
  label: "StyledNoLogoSpacer"
})(({
  theme: o
}) => ({
  height: o.sizes.largeLogoHeight
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledCollapseSidebarButton = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "eczjsme0"
} : {
  target: "eczjsme0",
  label: "StyledCollapseSidebarButton"
})(({
  showSidebarCollapse: o,
  theme: E
}) => ({
  display: "inline",
  visibility: o ? "visible" : "hidden",
  marginLeft: E.spacing.sm,
  transition: "left 300ms",
  transitionDelay: "left 300ms",
  color: hasLightBackgroundColor(E) ? E.colors.fadedText60 : E.colors.bodyText,
  lineHeight: "0",
  "@media print": {
    // Always hide the collapse button on print:
    visibility: "hidden"
  },
  [`@media (max-width: ${E.breakpoints.sm})`]: {
    // Always show the collapse button on small screens:
    visibility: "visible"
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), LOG$6 = loglevelExports$1.getLogger("LogoComponent"), LogoComponent = ({
  appLogo: o,
  endpoints: E,
  collapsed: A = !1,
  componentName: g = "Logo",
  dataTestId: e = "stLogo"
}) => {
  const {
    resourceCrossOriginMode: t
  } = useContext(LibConfigContext);
  if (o = useStliteResolvedLogo(o), !o)
    return null;
  const c = (p) => {
    LOG$6.error(`Client Error: ${g} source error - ${p}`), E.sendClientErrorToHost(g, "Logo source failed to load", "onerror triggered", p);
  }, n = A && o.iconImage ? o.iconImage : o.image, h = E.buildMediaURL(n), d = getCrossOriginAttribute(t, n), k = /* @__PURE__ */ jsxRuntimeExports.jsx(
    StyledLogo,
    {
      src: h,
      size: o.size,
      alt: "Logo",
      className: "stLogo",
      "data-testid": e,
      onError: (p) => c(h),
      crossOrigin: d
    }
  );
  return o.link ? /* @__PURE__ */ jsxRuntimeExports.jsx(StyledLogoLink, { href: o.link, target: "_blank", rel: "noreferrer", "data-testid": "stLogoLink", children: k }) : /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: k });
}, getNavTextColor = (o, E, A = !1, g) => {
  if (A)
    return o.colors.fadedText40;
  if (g)
    return o.colors.bodyText;
  const e = hasLightBackgroundColor(o);
  return E ? o.colors.bodyText : e ? transparentize(o.colors.bodyText, 0.2) : transparentize(o.colors.bodyText, 0.25);
}, StyledSidebarNavContainer = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e10lwvl920"
} : {
  target: "e10lwvl920",
  label: "StyledSidebarNavContainer"
})(({
  theme: o
}) => ({
  position: "relative",
  fontFamily: o.genericFonts.bodyFont
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledSidebarNavItems = /* @__PURE__ */ createStyled("ul", process.env.NODE_ENV === "production" ? {
  target: "e10lwvl919"
} : {
  target: "e10lwvl919",
  label: "StyledSidebarNavItems"
})(({
  theme: o
}) => ({
  listStyle: "none",
  margin: o.spacing.none,
  paddingBottom: o.spacing.threeXS,
  paddingTop: o.spacing.none,
  paddingRight: o.spacing.none,
  paddingLeft: o.spacing.none
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledSidebarNavLinkContainer = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e10lwvl918"
} : {
  target: "e10lwvl918",
  label: "StyledSidebarNavLinkContainer"
})(({
  disabled: o
}) => ({
  display: "flex",
  flexDirection: "column",
  cursor: o ? "not-allowed" : "pointer"
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2FwcC9zcmMvY29tcG9uZW50cy9OYXZpZ2F0aW9uL3N0eWxlZC1jb21wb25lbnRzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQXlFRSIsImZpbGUiOiIvaG9tZS9ydW5uZXIvd29yay9zdGxpdGUvc3RsaXRlL3N0cmVhbWxpdC9mcm9udGVuZC9hcHAvc3JjL2NvbXBvbmVudHMvTmF2aWdhdGlvbi9zdHlsZWQtY29tcG9uZW50cy50cyIsInNvdXJjZXNDb250ZW50IjpbIi8qKlxuICogQ29weXJpZ2h0IChjKSBTdHJlYW1saXQgSW5jLiAoMjAxOC0yMDIyKSBTbm93Zmxha2UgSW5jLiAoMjAyMi0yMDI1KVxuICpcbiAqIExpY2Vuc2VkIHVuZGVyIHRoZSBBcGFjaGUgTGljZW5zZSwgVmVyc2lvbiAyLjAgKHRoZSBcIkxpY2Vuc2VcIik7XG4gKiB5b3UgbWF5IG5vdCB1c2UgdGhpcyBmaWxlIGV4Y2VwdCBpbiBjb21wbGlhbmNlIHdpdGggdGhlIExpY2Vuc2UuXG4gKiBZb3UgbWF5IG9idGFpbiBhIGNvcHkgb2YgdGhlIExpY2Vuc2UgYXRcbiAqXG4gKiAgICAgaHR0cDovL3d3dy5hcGFjaGUub3JnL2xpY2Vuc2VzL0xJQ0VOU0UtMi4wXG4gKlxuICogVW5sZXNzIHJlcXVpcmVkIGJ5IGFwcGxpY2FibGUgbGF3IG9yIGFncmVlZCB0byBpbiB3cml0aW5nLCBzb2Z0d2FyZVxuICogZGlzdHJpYnV0ZWQgdW5kZXIgdGhlIExpY2Vuc2UgaXMgZGlzdHJpYnV0ZWQgb24gYW4gXCJBUyBJU1wiIEJBU0lTLFxuICogV0lUSE9VVCBXQVJSQU5USUVTIE9SIENPTkRJVElPTlMgT0YgQU5ZIEtJTkQsIGVpdGhlciBleHByZXNzIG9yIGltcGxpZWQuXG4gKiBTZWUgdGhlIExpY2Vuc2UgZm9yIHRoZSBzcGVjaWZpYyBsYW5ndWFnZSBnb3Zlcm5pbmcgcGVybWlzc2lvbnMgYW5kXG4gKiBsaW1pdGF0aW9ucyB1bmRlciB0aGUgTGljZW5zZS5cbiAqL1xuXG5pbXBvcnQgc3R5bGVkIGZyb20gXCJAZW1vdGlvbi9zdHlsZWRcIlxuaW1wb3J0IHsgdHJhbnNwYXJlbnRpemUgfSBmcm9tIFwiY29sb3Iya1wiXG5cbmltcG9ydCB7IEVtb3Rpb25UaGVtZSwgaGFzTGlnaHRCYWNrZ3JvdW5kQ29sb3IgfSBmcm9tIFwiQHN0cmVhbWxpdC9saWJcIlxuXG4vKipcbiAqIFJldHVybnMgdGhlIGNvbG9yIG9mIHRoZSB0ZXh0IGluIHRoZSBzaWRlYmFyIG5hdi5cbiAqXG4gKiBAcGFyYW0gdGhlbWUgVGhlIHRoZW1lIHRvIHVzZS5cbiAqIEBwYXJhbSBpc0FjdGl2ZSBXaGV0aGVyIHRoZSBuYXYgdGV4dCBzaG91bGQgc2hvdyBhcyBhY3RpdmUuXG4gKiBAcmV0dXJucyBUaGUgY29sb3Igb2YgdGhlIHRleHQgaW4gdGhlIHNpZGViYXIgbmF2LlxuICovXG5leHBvcnQgY29uc3QgZ2V0TmF2VGV4dENvbG9yID0gKFxuICB0aGVtZTogRW1vdGlvblRoZW1lLFxuICBpc0FjdGl2ZTogYm9vbGVhbixcbiAgZGlzYWJsZWQ6IGJvb2xlYW4gPSBmYWxzZSxcbiAgaXNUb3BOYXY/OiBib29sZWFuXG4pOiBzdHJpbmcgPT4ge1xuICBpZiAoZGlzYWJsZWQpIHtcbiAgICByZXR1cm4gdGhlbWUuY29sb3JzLmZhZGVkVGV4dDQwXG4gIH1cblxuICBpZiAoaXNUb3BOYXYpIHtcbiAgICByZXR1cm4gdGhlbWUuY29sb3JzLmJvZHlUZXh0XG4gIH1cblxuICBjb25zdCBpc0xpZ2h0VGhlbWUgPSBoYXNMaWdodEJhY2tncm91bmRDb2xvcih0aGVtZSlcblxuICBpZiAoaXNBY3RpdmUpIHtcbiAgICByZXR1cm4gdGhlbWUuY29sb3JzLmJvZHlUZXh0XG4gIH1cbiAgcmV0dXJuIGlzTGlnaHRUaGVtZVxuICAgID8gdHJhbnNwYXJlbnRpemUodGhlbWUuY29sb3JzLmJvZHlUZXh0LCAwLjIpXG4gICAgOiB0cmFuc3BhcmVudGl6ZSh0aGVtZS5jb2xvcnMuYm9keVRleHQsIDAuMjUpXG59XG5cbmV4cG9ydCBjb25zdCBTdHlsZWRTaWRlYmFyTmF2Q29udGFpbmVyID0gc3R5bGVkLmRpdigoeyB0aGVtZSB9KSA9PiAoe1xuICBwb3NpdGlvbjogXCJyZWxhdGl2ZVwiLFxuICBmb250RmFtaWx5OiB0aGVtZS5nZW5lcmljRm9udHMuYm9keUZvbnQsXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZFNpZGViYXJOYXZJdGVtcyA9IHN0eWxlZC51bCgoeyB0aGVtZSB9KSA9PiB7XG4gIHJldHVybiB7XG4gICAgbGlzdFN0eWxlOiBcIm5vbmVcIixcbiAgICBtYXJnaW46IHRoZW1lLnNwYWNpbmcubm9uZSxcbiAgICBwYWRkaW5nQm90dG9tOiB0aGVtZS5zcGFjaW5nLnRocmVlWFMsXG4gICAgcGFkZGluZ1RvcDogdGhlbWUuc3BhY2luZy5ub25lLFxuICAgIHBhZGRpbmdSaWdodDogdGhlbWUuc3BhY2luZy5ub25lLFxuICAgIHBhZGRpbmdMZWZ0OiB0aGVtZS5zcGFjaW5nLm5vbmUsXG4gIH1cbn0pXG5cbmV4cG9ydCBpbnRlcmZhY2UgU3R5bGVkU2lkZWJhck5hdkxpbmtDb250YWluZXJQcm9wcyB7XG4gIGRpc2FibGVkOiBib29sZWFuXG59XG5cbmV4cG9ydCBjb25zdCBTdHlsZWRTaWRlYmFyTmF2TGlua0NvbnRhaW5lciA9XG4gIHN0eWxlZC5kaXY8U3R5bGVkU2lkZWJhck5hdkxpbmtDb250YWluZXJQcm9wcz4oKHsgZGlzYWJsZWQgfSkgPT4gKHtcbiAgICBkaXNwbGF5OiBcImZsZXhcIixcbiAgICBmbGV4RGlyZWN0aW9uOiBcImNvbHVtblwiLFxuICAgIGN1cnNvcjogZGlzYWJsZWQgPyBcIm5vdC1hbGxvd2VkXCIgOiBcInBvaW50ZXJcIixcbiAgfSkpXG5cbmV4cG9ydCBpbnRlcmZhY2UgU3R5bGVkU2lkZWJhck5hdkljb25Qcm9wcyB7XG4gIGlzQWN0aXZlOiBib29sZWFuXG59XG5cbmV4cG9ydCBjb25zdCBTdHlsZWRTaWRlYmFyTmF2SWNvbiA9IHN0eWxlZC5zcGFuPFN0eWxlZFNpZGViYXJOYXZJY29uUHJvcHM+KFxuICAoeyB0aGVtZSwgaXNBY3RpdmUgfSkgPT4ge1xuICAgIHJldHVybiB7XG4gICAgICBkaXNwbGF5OiBcImlubGluZS1mbGV4XCIsXG4gICAgICAvLyBBcHBseSBhIGRpZmZlcmVudCBmb250IHdlaWdodCB0byB0aGUgaWNvbiBpZiBpdCBpcyBhY3RpdmVcbiAgICAgIC8vIFRoZSBpY29uIGlzIGluIGEgc3BhbiBlbGVtZW50LlxuICAgICAgc3Bhbjoge1xuICAgICAgICBmb250V2VpZ2h0OiBpc0FjdGl2ZVxuICAgICAgICAgID8gdGhlbWUuZm9udFdlaWdodHMuYm9sZFxuICAgICAgICAgIDogdGhlbWUuZm9udFdlaWdodHMubm9ybWFsLFxuICAgICAgfSxcbiAgICB9XG4gIH1cbilcblxuZXhwb3J0IGNvbnN0IFN0eWxlZFNpZGViYXJOYXZMaW5rTGlzdEl0ZW0gPSBzdHlsZWQubGkoKHsgdGhlbWUgfSkgPT4gKHtcbiAgbWFyZ2luVG9wOiB0aGVtZS5zcGFjaW5nLnRocmVlWFMsXG4gIG1hcmdpbkJvdHRvbTogdGhlbWUuc3BhY2luZy50aHJlZVhTLFxufSkpXG5cbmV4cG9ydCBpbnRlcmZhY2UgU3R5bGVkU2lkZWJhck5hdkxpbmtQcm9wcyB7XG4gIGlzQWN0aXZlOiBib29sZWFuXG4gIGRpc2FibGVkOiBib29sZWFuXG4gIGlzVG9wTmF2PzogYm9vbGVhblxuICBsYWJlbD86IHN0cmluZ1xufVxuXG5leHBvcnQgY29uc3QgU3R5bGVkU2lkZWJhck5hdkxpbmsgPSBzdHlsZWQuYTxTdHlsZWRTaWRlYmFyTmF2TGlua1Byb3BzPihcbiAgKHsgdGhlbWUsIGlzQWN0aXZlLCBkaXNhYmxlZCB9KSA9PiB7XG4gICAgY29uc3QgZGVmYXVsdFBhZ2VMaW5rU3R5bGVzID0ge1xuICAgICAgdGV4dERlY29yYXRpb246IFwibm9uZVwiLFxuICAgICAgZm9udFdlaWdodDogaXNBY3RpdmUgPyB0aGVtZS5mb250V2VpZ2h0cy5ib2xkIDogdGhlbWUuZm9udFdlaWdodHMubm9ybWFsLFxuICAgIH1cblxuICAgIHJldHVybiB7XG4gICAgICAuLi5kZWZhdWx0UGFnZUxpbmtTdHlsZXMsXG4gICAgICBkaXNwbGF5OiBcImZsZXhcIixcbiAgICAgIGZsZXhEaXJlY3Rpb246IFwicm93XCIsXG4gICAgICBhbGlnbkl0ZW1zOiBcImNlbnRlclwiLFxuICAgICAgZ2FwOiB0aGVtZS5zcGFjaW5nLnNtLFxuICAgICAgYm9yZGVyUmFkaXVzOiB0aGVtZS5yYWRpaS5kZWZhdWx0LFxuICAgICAgcGFkZGluZ0xlZnQ6IHRoZW1lLnNwYWNpbmcuc20sXG4gICAgICBwYWRkaW5nUmlnaHQ6IHRoZW1lLnNwYWNpbmcuc20sXG5cbiAgICAgIG1hcmdpblRvcDogdGhlbWUuc3BhY2luZy50aHJlZVhTLFxuICAgICAgbWFyZ2luQm90dG9tOiB0aGVtZS5zcGFjaW5nLnRocmVlWFMsXG4gICAgICBsaW5lSGVpZ2h0OiB0aGVtZS5saW5lSGVpZ2h0cy5tZW51SXRlbSxcblxuICAgICAgY29sb3I6IGdldE5hdlRleHRDb2xvcih0aGVtZSwgaXNBY3RpdmUpLFxuICAgICAgYmFja2dyb3VuZENvbG9yOiBpc0FjdGl2ZSA/IHRoZW1lLmNvbG9ycy5kYXJrZW5lZEJnTWl4MjUgOiBcInRyYW5zcGFyZW50XCIsXG5cbiAgICAgIC4uLihkaXNhYmxlZCAmJiB7XG4gICAgICAgIHBvaW50ZXJFdmVudHM6IFwibm9uZVwiLFxuICAgICAgfSksXG5cbiAgICAgIFwiJjpob3ZlclwiOiB7XG4gICAgICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLmRhcmtlbmVkQmdNaXgxNSxcbiAgICAgIH0sXG5cbiAgICAgIFwiJjphY3RpdmUsJjp2aXNpdGVkLCY6aG92ZXJcIjoge1xuICAgICAgICAuLi5kZWZhdWx0UGFnZUxpbmtTdHlsZXMsXG4gICAgICB9LFxuXG4gICAgICBcIiY6Zm9jdXNcIjoge1xuICAgICAgICBvdXRsaW5lOiBcIm5vbmVcIixcbiAgICAgIH0sXG5cbiAgICAgIFwiJjpmb2N1cy12aXNpYmxlXCI6IHtcbiAgICAgICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMuZGFya2VuZWRCZ01peDE1LFxuICAgICAgfSxcblxuICAgICAgW2BAbWVkaWEgcHJpbnRgXToge1xuICAgICAgICBwYWRkaW5nTGVmdDogdGhlbWUuc3BhY2luZy5ub25lLFxuICAgICAgfSxcbiAgICB9XG4gIH1cbilcblxuZXhwb3J0IGNvbnN0IFN0eWxlZFNpZGViYXJMaW5rVGV4dCA9IHN0eWxlZC5zcGFuPFN0eWxlZFNpZGViYXJOYXZMaW5rUHJvcHM+KFxuICAoeyBpc0FjdGl2ZSwgdGhlbWUsIGRpc2FibGVkLCBpc1RvcE5hdiwgbGFiZWwgfSkgPT4ge1xuICAgIHJldHVybiB7XG4gICAgICBjb2xvcjogZ2V0TmF2VGV4dENvbG9yKHRoZW1lLCBpc0FjdGl2ZSwgZGlzYWJsZWQsIGlzVG9wTmF2KSxcbiAgICAgIGZvbnRTaXplOiB0aGVtZS5mb250U2l6ZXMuc20sXG4gICAgICBvdmVyZmxvdzogXCJoaWRkZW5cIixcbiAgICAgIHdoaXRlU3BhY2U6IFwibm93cmFwXCIsXG4gICAgICB0ZXh0T3ZlcmZsb3c6IFwiZWxsaXBzaXNcIixcbiAgICAgIGRpc3BsYXk6IFwidGFibGUtY2VsbFwiLFxuICAgICAgLyogUHNldWRvLWVsZW1lbnQgdG8gcmVzZXJ2ZSBib2xkIHdpZHRoICovXG4gICAgICBcIiY6OmFmdGVyXCI6IHtcbiAgICAgICAgY29udGVudDogYFwiJHtsYWJlbH1cImAgLyogZHVwbGljYXRlIHRleHQgKi8sXG4gICAgICAgIGZvbnRXZWlnaHQ6IHRoZW1lLmZvbnRXZWlnaHRzLmJvbGQgLyogYm9sZCB2ZXJzaW9uICovLFxuICAgICAgICB2aXNpYmlsaXR5OiBcImhpZGRlblwiIC8qIG9jY3VwaWVzIHNwYWNlLCBub3QgdmlzaWJsZSAqLyxcbiAgICAgICAgZGlzcGxheTogXCJibG9ja1wiLFxuICAgICAgICB3aWR0aDogXCJmaXQtY29udGVudFwiLFxuICAgICAgICBoZWlnaHQ6IDAsXG4gICAgICB9LFxuICAgIH1cbiAgfVxuKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkQ2hldnJvbkNvbnRhaW5lciA9IHN0eWxlZC5kaXY8eyBpc0V4cGFuZGVkOiBib29sZWFuIH0+KFxuICAoeyBpc0V4cGFuZGVkIH0pID0+ICh7XG4gICAgdmlzaWJpbGl0eTogXCJoaWRkZW5cIixcbiAgICBkaXNwbGF5OiBcImZsZXhcIixcbiAgICBhbGlnbkl0ZW1zOiBcImNlbnRlclwiLFxuICAgIGp1c3RpZnlDb250ZW50OiBcImNlbnRlclwiLFxuICAgIHRyYW5zZm9ybTogaXNFeHBhbmRlZCA/IFwicm90YXRlKDBkZWcpXCIgOiBcInJvdGF0ZSgtOTBkZWcpXCIsXG4gICAgdHJhbnNpdGlvbjogXCJ0cmFuc2Zvcm0gMjAwbXMgZWFzZVwiLFxuICAgIGZsZXhTaHJpbms6IDAsXG4gIH0pXG4pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWROYXZTZWN0aW9uSGVhZGVyVGV4dCA9IHN0eWxlZC5zcGFuKCgpID0+ICh7XG4gIG92ZXJmbG93OiBcImhpZGRlblwiLFxuICB3aGl0ZVNwYWNlOiBcIm5vd3JhcFwiLFxuICB0ZXh0T3ZlcmZsb3c6IFwiZWxsaXBzaXNcIixcbiAgbWluV2lkdGg6IDAsXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZFNpZGViYXJOYXZTZWN0aW9uSGVhZGVyID0gc3R5bGVkLmhlYWRlcjx7XG4gIGlzRXhwYW5kZWQ6IGJvb2xlYW5cbn0+KCh7IHRoZW1lIH0pID0+IHtcbiAgcmV0dXJuIHtcbiAgICBmb250U2l6ZTogdGhlbWUuZm9udFNpemVzLnNtLFxuICAgIGZvbnRXZWlnaHQ6IHRoZW1lLmZvbnRXZWlnaHRzLnNlbWlCb2xkLFxuICAgIGNvbG9yOiBnZXROYXZUZXh0Q29sb3IodGhlbWUsIGZhbHNlKSxcbiAgICBsaW5lSGVpZ2h0OiB0aGVtZS5saW5lSGVpZ2h0cy5zbWFsbCxcbiAgICBwYWRkaW5nUmlnaHQ6IHRoZW1lLnNwYWNpbmcuc20sXG4gICAgbWFyZ2luVG9wOiB0aGVtZS5zcGFjaW5nLnNtLFxuICAgIG1hcmdpbkJvdHRvbTogdGhlbWUuc3BhY2luZy50d29YUyxcbiAgICBkaXNwbGF5OiBcImZsZXhcIixcbiAgICBmbGV4RGlyZWN0aW9uOiBcInJvd1wiLFxuICAgIGFsaWduSXRlbXM6IFwiY2VudGVyXCIsXG4gICAgZ2FwOiB0aGVtZS5zcGFjaW5nLnNtLFxuICAgIGN1cnNvcjogXCJwb2ludGVyXCIsXG4gICAgdXNlclNlbGVjdDogXCJub25lXCIsXG4gICAgXCImOmhvdmVyXCI6IHtcbiAgICAgIFtgJiA+ICR7U3R5bGVkQ2hldnJvbkNvbnRhaW5lcn1gXToge1xuICAgICAgICB2aXNpYmlsaXR5OiBcInZpc2libGVcIixcbiAgICAgIH0sXG4gICAgfSxcbiAgfVxufSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZFZpZXdCdXR0b24gPSBzdHlsZWQuYnV0dG9uKCh7IHRoZW1lIH0pID0+IHtcbiAgcmV0dXJuIHtcbiAgICBmb250U2l6ZTogdGhlbWUuZm9udFNpemVzLnNtLFxuICAgIGZvbnRGYW1pbHk6IFwiaW5oZXJpdFwiLFxuICAgIGxpbmVIZWlnaHQ6IHRoZW1lLmxpbmVIZWlnaHRzLmJhc2UsXG4gICAgY29sb3I6IGdldE5hdlRleHRDb2xvcih0aGVtZSwgdHJ1ZSksXG4gICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnQsXG4gICAgYm9yZGVyOiBcIm5vbmVcIixcbiAgICBib3JkZXJSYWRpdXM6IHRoZW1lLnJhZGlpLmRlZmF1bHQsXG4gICAgbWFyZ2luVG9wOiB0aGVtZS5zcGFjaW5nLnR3b1hTLFxuICAgIG1hcmdpbkxlZnQ6IHRoZW1lLnNwYWNpbmcubm9uZSxcbiAgICBtYXJnaW5Cb3R0b206IHRoZW1lLnNwYWNpbmcubm9uZSxcbiAgICBtYXJnaW5SaWdodDogdGhlbWUuc3BhY2luZy5ub25lLFxuICAgIHBhZGRpbmc6IGAke3RoZW1lLnNwYWNpbmcudGhyZWVYU30gJHt0aGVtZS5zcGFjaW5nLnNtfWAsXG4gICAgXCImOmhvdmVyLCAmOmFjdGl2ZSwgJjpmb2N1c1wiOiB7XG4gICAgICBib3JkZXI6IFwibm9uZVwiLFxuICAgICAgb3V0bGluZTogXCJub25lXCIsXG4gICAgICBib3hTaGFkb3c6IFwibm9uZVwiLFxuICAgIH0sXG4gICAgXCImOmhvdmVyXCI6IHtcbiAgICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLmRhcmtlbmVkQmdNaXgxNSxcbiAgICB9LFxuICB9XG59KVxuXG5leHBvcnQgY29uc3QgU3R5bGVkU2lkZWJhck5hdlNlcGFyYXRvciA9IHN0eWxlZC5kaXYoKHsgdGhlbWUgfSkgPT4gKHtcbiAgcGFkZGluZ1RvcDogdGhlbWUuc3BhY2luZy5sZyxcbiAgYm9yZGVyQm90dG9tOiBgJHt0aGVtZS5zaXplcy5ib3JkZXJXaWR0aH0gc29saWQgJHt0aGVtZS5jb2xvcnMuYm9yZGVyQ29sb3J9YCxcbn0pKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkTmF2U2VjdGlvbkNvbnRhaW5lciA9IHN0eWxlZC5kaXYoKHsgdGhlbWUgfSkgPT4gKHtcbiAgXCImOm5vdCg6Zmlyc3QtY2hpbGQpXCI6IHtcbiAgICBtYXJnaW5Ub3A6IHRoZW1lLnNwYWNpbmcubGcsXG4gIH0sXG59KSlcblxuLy8gVG9wTmF2IHN0eWxlZCBjb21wb25lbnRzXG5leHBvcnQgY29uc3QgU3R5bGVkT3ZlcmZsb3dDb250YWluZXIgPSBzdHlsZWQuZGl2KCh7IHRoZW1lIH0pID0+ICh7XG4gIGRpc3BsYXk6IFwiZmxleFwiLFxuICBhbGlnbkl0ZW1zOiBcImNlbnRlclwiLFxuICB3aWR0aDogXCIxMDAlXCIsXG4gIGZsZXhTaHJpbms6IDEsXG4gIG92ZXJmbG93OiBcImhpZGRlblwiLFxuICBwYWRkaW5nOiBgMCAke3RoZW1lLnNwYWNpbmcubGd9YCxcbn0pKVxuXG5pbnRlcmZhY2UgU3R5bGVkTmF2U2VjdGlvblByb3BzIHtcbiAgaXNPcGVuOiBib29sZWFuXG59XG5cbmV4cG9ydCBjb25zdCBTdHlsZWROYXZTZWN0aW9uID0gc3R5bGVkLmRpdjxTdHlsZWROYXZTZWN0aW9uUHJvcHM+KFxuICAoeyB0aGVtZSwgaXNPcGVuIH0pID0+ICh7XG4gICAgZGlzcGxheTogXCJmbGV4XCIsXG4gICAgYWxpZ25JdGVtczogXCJjZW50ZXJcIixcbiAgICBqdXN0aWZ5Q29udGVudDogXCJjZW50ZXJcIixcbiAgICBjdXJzb3I6IFwicG9pbnRlclwiLFxuICAgIHBvc2l0aW9uOiBcInJlbGF0aXZlXCIsXG4gICAgbGluZUhlaWdodDogdGhlbWUubGluZUhlaWdodHMubWVudUl0ZW0sXG4gICAgZm9udFNpemU6IHRoZW1lLmZvbnRTaXplcy5zbSxcbiAgICBwYWRkaW5nOiBgMCAke3RoZW1lLnNwYWNpbmcuc219YCxcbiAgICBjb2xvcjogZ2V0TmF2VGV4dENvbG9yKHRoZW1lLCBmYWxzZSwgZmFsc2UsIHRydWUpLFxuICAgIGJvcmRlclJhZGl1czogdGhlbWUucmFkaWkuZGVmYXVsdCxcbiAgICBtYXJnaW5SaWdodDogdGhlbWUuc3BhY2luZy50d29YUyxcbiAgICBcIiY6bm90KDpmaXJzdC1vZi10eXBlKVwiOiB7XG4gICAgICBtYXJnaW5MZWZ0OiB0aGVtZS5zcGFjaW5nLnR3b1hTLFxuICAgIH0sXG4gICAgLi4uKGlzT3BlbiA/IHsgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMuZGFya2VuZWRCZ01peDI1IH0gOiB7fSksXG4gICAgXCImOmhvdmVyXCI6IHtcbiAgICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLmRhcmtlbmVkQmdNaXgxNSxcbiAgICB9LFxuICB9KVxuKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkVG9wTmF2TGlua0NvbnRhaW5lciA9IHN0eWxlZC5kaXYoKHsgdGhlbWUgfSkgPT4gKHtcbiAgbWFyZ2luUmlnaHQ6IHRoZW1lLnNwYWNpbmcudHdvWFMsXG4gIFwiJjpub3QoOmZpcnN0LW9mLXR5cGUpXCI6IHtcbiAgICBtYXJnaW5MZWZ0OiB0aGVtZS5zcGFjaW5nLnR3b1hTLFxuICB9LFxufSkpXG5cbi8vIFRoaXMgaXMgc3BlY2lmaWNhbGx5IGZvciB1c2UgaW4gVG9wTmF2U2VjdGlvbidzIHBvcG92ZXIgbWVudVxuZXhwb3J0IGNvbnN0IFN0eWxlZFRvcE5hdlNpZGViYXJOYXZMaW5rQ29udGFpbmVyID0gc3R5bGVkLmRpdigoeyB0aGVtZSB9KSA9PiAoe1xuICBtYXJnaW46IGAke3RoZW1lLnNwYWNpbmcudHdvWFN9ICR7dGhlbWUuc3BhY2luZy5zbX1gLFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWROYXZTZWN0aW9uVGV4dCA9IHN0eWxlZC5zcGFuKCgpID0+ICh7XG4gIHdoaXRlU3BhY2U6IFwibm93cmFwXCIsXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZFNlY3Rpb25OYW1lID0gc3R5bGVkLmRpdigoeyB0aGVtZSB9KSA9PiAoe1xuICBtYXJnaW5MZWZ0OiB0aGVtZS5zcGFjaW5nLnNtLFxuICBtYXJnaW5Ub3A6IHRoZW1lLnNwYWNpbmcuc20sXG4gIG1hcmdpbkJvdHRvbTogdGhlbWUuc3BhY2luZy5zbSxcbn0pKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkUG9wb3ZlckNvbnRlbnQgPSBzdHlsZWQuZGl2KCh7IHRoZW1lIH0pID0+ICh7XG4gIHBhZGRpbmc6IGAke3RoZW1lLnNwYWNpbmcudHdvWFN9IDBgLFxuICBmb250U2l6ZTogdGhlbWUuZm9udFNpemVzLnNtLFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRJY29uQ29udGFpbmVyID0gc3R5bGVkLmRpdigoeyB0aGVtZSB9KSA9PiAoe1xuICBtYXJnaW5MZWZ0OiB0aGVtZS5zcGFjaW5nLnR3b1hTLFxufSkpXG4iXX0= */"), StyledSidebarNavIcon = /* @__PURE__ */ createStyled("span", process.env.NODE_ENV === "production" ? {
  target: "e10lwvl917"
} : {
  target: "e10lwvl917",
  label: "StyledSidebarNavIcon"
})(({
  theme: o,
  isActive: E
}) => ({
  display: "inline-flex",
  // Apply a different font weight to the icon if it is active
  // The icon is in a span element.
  span: {
    fontWeight: E ? o.fontWeights.bold : o.fontWeights.normal
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledSidebarNavLinkListItem = /* @__PURE__ */ createStyled("li", process.env.NODE_ENV === "production" ? {
  target: "e10lwvl916"
} : {
  target: "e10lwvl916",
  label: "StyledSidebarNavLinkListItem"
})(({
  theme: o
}) => ({
  marginTop: o.spacing.threeXS,
  marginBottom: o.spacing.threeXS
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledSidebarNavLink = /* @__PURE__ */ createStyled("a", process.env.NODE_ENV === "production" ? {
  target: "e10lwvl915"
} : {
  target: "e10lwvl915",
  label: "StyledSidebarNavLink"
})(({
  theme: o,
  isActive: E,
  disabled: A
}) => {
  const g = {
    textDecoration: "none",
    fontWeight: E ? o.fontWeights.bold : o.fontWeights.normal
  };
  return {
    ...g,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: o.spacing.sm,
    borderRadius: o.radii.default,
    paddingLeft: o.spacing.sm,
    paddingRight: o.spacing.sm,
    marginTop: o.spacing.threeXS,
    marginBottom: o.spacing.threeXS,
    lineHeight: o.lineHeights.menuItem,
    color: getNavTextColor(o, E),
    backgroundColor: E ? o.colors.darkenedBgMix25 : "transparent",
    ...A && {
      pointerEvents: "none"
    },
    "&:hover": {
      backgroundColor: o.colors.darkenedBgMix15
    },
    "&:active,&:visited,&:hover": {
      ...g
    },
    "&:focus": {
      outline: "none"
    },
    "&:focus-visible": {
      backgroundColor: o.colors.darkenedBgMix15
    },
    "@media print": {
      paddingLeft: o.spacing.none
    }
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledSidebarLinkText = /* @__PURE__ */ createStyled("span", process.env.NODE_ENV === "production" ? {
  target: "e10lwvl914"
} : {
  target: "e10lwvl914",
  label: "StyledSidebarLinkText"
})(({
  isActive: o,
  theme: E,
  disabled: A,
  isTopNav: g,
  label: e
}) => ({
  color: getNavTextColor(E, o, A, g),
  fontSize: E.fontSizes.sm,
  overflow: "hidden",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis",
  display: "table-cell",
  /* Pseudo-element to reserve bold width */
  "&::after": {
    content: `"${e}"`,
    fontWeight: E.fontWeights.bold,
    visibility: "hidden",
    display: "block",
    width: "fit-content",
    height: 0
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledChevronContainer = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e10lwvl913"
} : {
  target: "e10lwvl913",
  label: "StyledChevronContainer"
})(({
  isExpanded: o
}) => ({
  visibility: "hidden",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  transform: o ? "rotate(0deg)" : "rotate(-90deg)",
  transition: "transform 200ms ease",
  flexShrink: 0
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledNavSectionHeaderText = /* @__PURE__ */ createStyled("span", process.env.NODE_ENV === "production" ? {
  target: "e10lwvl912"
} : {
  target: "e10lwvl912",
  label: "StyledNavSectionHeaderText"
})(() => ({
  overflow: "hidden",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis",
  minWidth: 0
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledSidebarNavSectionHeader = /* @__PURE__ */ createStyled("header", process.env.NODE_ENV === "production" ? {
  target: "e10lwvl911"
} : {
  target: "e10lwvl911",
  label: "StyledSidebarNavSectionHeader"
})(({
  theme: o
}) => ({
  fontSize: o.fontSizes.sm,
  fontWeight: o.fontWeights.semiBold,
  color: getNavTextColor(o, !1),
  lineHeight: o.lineHeights.small,
  paddingRight: o.spacing.sm,
  marginTop: o.spacing.sm,
  marginBottom: o.spacing.twoXS,
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  gap: o.spacing.sm,
  cursor: "pointer",
  userSelect: "none",
  "&:hover": {
    [`& > ${StyledChevronContainer}`]: {
      visibility: "visible"
    }
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledViewButton = /* @__PURE__ */ createStyled("button", process.env.NODE_ENV === "production" ? {
  target: "e10lwvl910"
} : {
  target: "e10lwvl910",
  label: "StyledViewButton"
})(({
  theme: o
}) => ({
  fontSize: o.fontSizes.sm,
  fontFamily: "inherit",
  lineHeight: o.lineHeights.base,
  color: getNavTextColor(o, !0),
  backgroundColor: o.colors.transparent,
  border: "none",
  borderRadius: o.radii.default,
  marginTop: o.spacing.twoXS,
  marginLeft: o.spacing.none,
  marginBottom: o.spacing.none,
  marginRight: o.spacing.none,
  padding: `${o.spacing.threeXS} ${o.spacing.sm}`,
  "&:hover, &:active, &:focus": {
    border: "none",
    outline: "none",
    boxShadow: "none"
  },
  "&:hover": {
    backgroundColor: o.colors.darkenedBgMix15
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledSidebarNavSeparator = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e10lwvl99"
} : {
  target: "e10lwvl99",
  label: "StyledSidebarNavSeparator"
})(({
  theme: o
}) => ({
  paddingTop: o.spacing.lg,
  borderBottom: `${o.sizes.borderWidth} solid ${o.colors.borderColor}`
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledNavSectionContainer = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e10lwvl98"
} : {
  target: "e10lwvl98",
  label: "StyledNavSectionContainer"
})(({
  theme: o
}) => ({
  "&:not(:first-child)": {
    marginTop: o.spacing.lg
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledOverflowContainer = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e10lwvl97"
} : {
  target: "e10lwvl97",
  label: "StyledOverflowContainer"
})(({
  theme: o
}) => ({
  display: "flex",
  alignItems: "center",
  width: "100%",
  flexShrink: 1,
  overflow: "hidden",
  padding: `0 ${o.spacing.lg}`
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledNavSection = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e10lwvl96"
} : {
  target: "e10lwvl96",
  label: "StyledNavSection"
})(({
  theme: o,
  isOpen: E
}) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
  position: "relative",
  lineHeight: o.lineHeights.menuItem,
  fontSize: o.fontSizes.sm,
  padding: `0 ${o.spacing.sm}`,
  color: getNavTextColor(o, !1, !1, !0),
  borderRadius: o.radii.default,
  marginRight: o.spacing.twoXS,
  "&:not(:first-of-type)": {
    marginLeft: o.spacing.twoXS
  },
  ...E ? {
    backgroundColor: o.colors.darkenedBgMix25
  } : {},
  "&:hover": {
    backgroundColor: o.colors.darkenedBgMix15
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledTopNavLinkContainer = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e10lwvl95"
} : {
  target: "e10lwvl95",
  label: "StyledTopNavLinkContainer"
})(({
  theme: o
}) => ({
  marginRight: o.spacing.twoXS,
  "&:not(:first-of-type)": {
    marginLeft: o.spacing.twoXS
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledTopNavSidebarNavLinkContainer = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e10lwvl94"
} : {
  target: "e10lwvl94",
  label: "StyledTopNavSidebarNavLinkContainer"
})(({
  theme: o
}) => ({
  margin: `${o.spacing.twoXS} ${o.spacing.sm}`
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledNavSectionText = /* @__PURE__ */ createStyled("span", process.env.NODE_ENV === "production" ? {
  target: "e10lwvl93"
} : {
  target: "e10lwvl93",
  label: "StyledNavSectionText"
})(() => ({
  whiteSpace: "nowrap"
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledSectionName = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e10lwvl92"
} : {
  target: "e10lwvl92",
  label: "StyledSectionName"
})(({
  theme: o
}) => ({
  marginLeft: o.spacing.sm,
  marginTop: o.spacing.sm,
  marginBottom: o.spacing.sm
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledPopoverContent = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e10lwvl91"
} : {
  target: "e10lwvl91",
  label: "StyledPopoverContent"
})(({
  theme: o
}) => ({
  padding: `${o.spacing.twoXS} 0`,
  fontSize: o.fontSizes.sm
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledIconContainer = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e10lwvl90"
} : {
  target: "e10lwvl90",
  label: "StyledIconContainer"
})(({
  theme: o
}) => ({
  marginLeft: o.spacing.twoXS
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), NavSection = ({
  header: o = "",
  children: E,
  isExpanded: A,
  onToggle: g
}) => /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledNavSectionContainer, { children: [
  o && /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledSidebarNavSectionHeader, { "data-testid": "stNavSectionHeader", onClick: g, isExpanded: A, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(StyledNavSectionHeaderText, { children: o }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(StyledChevronContainer, { isExpanded: A, children: /* @__PURE__ */ jsxRuntimeExports.jsx(DynamicIcon, { iconValue: ":material/expand_more:", size: "lg" }) })
  ] }),
  A && E
] }), SidebarNavLink = ({
  isActive: o,
  pageUrl: E,
  icon: A,
  onClick: g,
  isTopNav: e,
  isInDropdown: t,
  children: c,
  widgetsDisabled: n
}) => {
  const h = useEmotionTheme(), d = n;
  let k;
  e && t ? k = "stTopNavDropdownLink" : e ? k = "stTopNavLink" : k = "stSidebarNavLink";
  const p = e ? "stTopNavLinkContainer" : "stSidebarNavLinkContainer";
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledSidebarNavLinkContainer, { disabled: d, "data-testid": p, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledSidebarNavLink, { "data-testid": k, isActive: o, disabled: d, href: E, onClick: g, "aria-current": o ? "page" : void 0, children: [
    A?.length ? /* @__PURE__ */ jsxRuntimeExports.jsx(StyledSidebarNavIcon, { isActive: o, children: /* @__PURE__ */ jsxRuntimeExports.jsx(DynamicIcon, { size: "base", iconValue: A, color: !o && isMaterialIcon(A) ? (
      // Apply color with opacity on material icons
      // But we don't want to apply opacity on emoji icons
      h.colors.fadedText60
    ) : h.colors.bodyText }) }) : null,
    /* @__PURE__ */ jsxRuntimeExports.jsx(StyledSidebarLinkText, { isActive: o, disabled: d, isTopNav: e, label: c, children: c })
  ] }) });
};
function shouldShowNavigation(o, E) {
  return o.length <= 1 ? !1 : (E.length === 0 || E.length > 1, !0);
}
function groupPagesBySection(o) {
  return groupBy(o, (E) => E.sectionHeader || "");
}
function hasNonEmptySections(o) {
  return Object.keys(o).some((E) => E !== "");
}
function processNavigationStructure(o) {
  if (!hasNonEmptySections(o))
    return {
      individualPages: Object.values(o).flat(),
      sections: {}
    };
  const A = o[""] || [], g = {};
  return Object.entries(o).forEach(([e, t]) => {
    e && e !== "" && e !== "undefined" && (g[e] = t);
  }), {
    individualPages: A,
    sections: g
  };
}
const COLLAPSE_THRESHOLD = 12, NUM_PAGES_TO_SHOW_WHEN_COLLAPSED = 10, LOG$5 = loglevelExports$1.getLogger("SidebarNav");
function NavLink({
  pageUrl: o,
  page: E,
  isActive: A,
  onClick: g,
  widgetsDisabled: e
}) {
  const t = E.pageName;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledSidebarNavLinkListItem, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(SidebarNavLink, { isActive: A, pageUrl: o, icon: E.icon, onClick: g, widgetsDisabled: e, children: t }) });
}
function generateNavSections(o, E, A, g, e, t) {
  const c = [];
  let n = t;
  return Object.entries(o).forEach(([h, d]) => {
    const k = [...d];
    let p = k;
    const M = g[h];
    if (E) {
      const S = NUM_PAGES_TO_SHOW_WHEN_COLLAPSED - n;
      S <= 0 ? p = [] : k.length > S && (p = k.slice(0, S));
    }
    M && (n += p.length), p.length > 0 && c.push(/* @__PURE__ */ jsxRuntimeExports.jsx(NavSection, { header: h, isExpanded: M, onToggle: () => e(h), children: p.map(A) }, h));
  }), {
    sections: c,
    updatedPageCount: n
  };
}
const SidebarNav = ({
  endpoints: o,
  collapseSidebar: E,
  hasSidebarElements: A,
  widgetsDisabled: g
}) => {
  const [e, t] = useState(!1), {
    expandSidebarNav: c
  } = useContext(SidebarConfigContext), {
    pageLinkBaseUrl: n,
    appPages: h,
    onPageChange: d,
    currentPageScriptHash: k
  } = useContext(NavigationContext), p = `stSidebarSectionsState-${n}`, [M, S] = useState(null), AA = useMemo$1(() => processNavigationStructure(groupPagesBySection(h)), [h]), H = useMemo$1(() => {
    if (!(Object.keys(AA.sections).length > 0))
      return h.length;
    let aA = AA.individualPages.length;
    return Object.entries(AA.sections).forEach(([tA, eA]) => {
      M?.[tA] && (aA += eA.length);
    }), aA;
  }, [h.length, M, AA]);
  useEffect(() => {
    const iA = localStorageAvailable() && window.localStorage.getItem("sidebarNavState") === "expanded";
    !e && (c || iA) && t(!0);
  }, [e, c]), useEffect(() => {
    if (localStorageAvailable()) {
      const iA = window.localStorage.getItem(p);
      let aA = {};
      if (iA)
        try {
          aA = JSON.parse(iA);
        } catch (eA) {
          aA = {}, LOG$5.warn("Could not parse sidebar nav state from localStorage", eA);
        }
      const tA = Object.keys(AA.sections).reduce((eA, cA) => (eA[cA] = aA[cA] ?? !0, eA), {});
      S(tA);
    } else {
      const iA = Object.keys(AA.sections).reduce((aA, tA) => (aA[tA] = !0, aA), {});
      S(iA);
    }
  }, [AA.sections, p]), useEffect(() => {
    localStorageAvailable() && M && window.localStorage.setItem(p, JSON.stringify(M));
  }, [M, p]);
  const gA = useCallback((iA) => {
    S((aA) => aA ? {
      ...aA,
      [iA]: !aA[iA]
    } : null);
  }, []), CA = useCallback(() => {
    const iA = !e;
    localStorageAvailable() && (iA ? window.localStorage.setItem("sidebarNavState", "expanded") : window.localStorage.removeItem("sidebarNavState")), t(iA);
  }, [e]), IA = useCallback((iA, aA) => {
    const tA = o.buildAppPageURL(n, iA), eA = iA.pageScriptHash === k;
    return /* @__PURE__ */ jsxRuntimeExports.jsx(NavLink, { pageUrl: tA, page: iA, isActive: eA, onClick: (cA) => {
      cA.preventDefault(), d(iA.pageScriptHash), isMobile() && E();
    }, widgetsDisabled: g }, `${iA.pageName}-${aA}`);
  }, [E, k, o, d, n, g]);
  if (!M)
    return null;
  const BA = [], QA = A && H > COLLAPSE_THRESHOLD && !c, EA = QA && !e;
  let oA = 0;
  if (AA.individualPages.length > 0) {
    const iA = EA ? AA.individualPages.slice(0, NUM_PAGES_TO_SHOW_WHEN_COLLAPSED) : AA.individualPages;
    BA.push(...iA.map(IA)), oA += iA.length;
  }
  if (Object.keys(AA.sections).length > 0) {
    const iA = generateNavSections(AA.sections, EA, IA, M, gA, oA);
    BA.push(...iA.sections);
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledSidebarNavContainer, { "data-testid": "stSidebarNav", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(StyledSidebarNavItems, { "data-testid": "stSidebarNavItems", children: BA }),
    QA && /* @__PURE__ */ jsxRuntimeExports.jsx(StyledViewButton, { onClick: CA, "data-testid": "stSidebarNavViewButton", children: e ? "View less" : `View ${H - NUM_PAGES_TO_SHOW_WHEN_COLLAPSED} more` }),
    A && /* @__PURE__ */ jsxRuntimeExports.jsx(StyledSidebarNavSeparator, { "data-testid": "stSidebarNavSeparator" })
  ] });
};
function _extends$2() {
  return _extends$2 = Object.assign ? Object.assign.bind() : function(o) {
    for (var E = 1; E < arguments.length; E++) {
      var A = arguments[E];
      for (var g in A) ({}).hasOwnProperty.call(A, g) && (o[g] = A[g]);
    }
    return o;
  }, _extends$2.apply(null, arguments);
}
function _typeof$1(o) {
  "@babel/helpers - typeof";
  return _typeof$1 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(E) {
    return typeof E;
  } : function(E) {
    return E && typeof Symbol == "function" && E.constructor === Symbol && E !== Symbol.prototype ? "symbol" : typeof E;
  }, _typeof$1(o);
}
function toPrimitive$1(o, E) {
  if (_typeof$1(o) != "object" || !o) return o;
  var A = o[Symbol.toPrimitive];
  if (A !== void 0) {
    var g = A.call(o, E);
    if (_typeof$1(g) != "object") return g;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (E === "string" ? String : Number)(o);
}
function toPropertyKey$1(o) {
  var E = toPrimitive$1(o, "string");
  return _typeof$1(E) == "symbol" ? E : E + "";
}
function _defineProperty$2(o, E, A) {
  return (E = toPropertyKey$1(E)) in o ? Object.defineProperty(o, E, {
    value: A,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : o[E] = A, o;
}
function ownKeys$3(o, E) {
  var A = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var g = Object.getOwnPropertySymbols(o);
    E && (g = g.filter(function(e) {
      return Object.getOwnPropertyDescriptor(o, e).enumerable;
    })), A.push.apply(A, g);
  }
  return A;
}
function _objectSpread2$1(o) {
  for (var E = 1; E < arguments.length; E++) {
    var A = arguments[E] != null ? arguments[E] : {};
    E % 2 ? ownKeys$3(Object(A), !0).forEach(function(g) {
      _defineProperty$2(o, g, A[g]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(A)) : ownKeys$3(Object(A)).forEach(function(g) {
      Object.defineProperty(o, g, Object.getOwnPropertyDescriptor(A, g));
    });
  }
  return o;
}
function _arrayWithHoles(o) {
  if (Array.isArray(o)) return o;
}
function _iterableToArrayLimit(o, E) {
  var A = o == null ? null : typeof Symbol < "u" && o[Symbol.iterator] || o["@@iterator"];
  if (A != null) {
    var g, e, t, c, n = [], h = !0, d = !1;
    try {
      if (t = (A = A.call(o)).next, E !== 0) for (; !(h = (g = t.call(A)).done) && (n.push(g.value), n.length !== E); h = !0) ;
    } catch (k) {
      d = !0, e = k;
    } finally {
      try {
        if (!h && A.return != null && (c = A.return(), Object(c) !== c)) return;
      } finally {
        if (d) throw e;
      }
    }
    return n;
  }
}
function _arrayLikeToArray(o, E) {
  (E == null || E > o.length) && (E = o.length);
  for (var A = 0, g = Array(E); A < E; A++) g[A] = o[A];
  return g;
}
function _unsupportedIterableToArray(o, E) {
  if (o) {
    if (typeof o == "string") return _arrayLikeToArray(o, E);
    var A = {}.toString.call(o).slice(8, -1);
    return A === "Object" && o.constructor && (A = o.constructor.name), A === "Map" || A === "Set" ? Array.from(o) : A === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(A) ? _arrayLikeToArray(o, E) : void 0;
  }
}
function _nonIterableRest() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _slicedToArray$1(o, E) {
  return _arrayWithHoles(o) || _iterableToArrayLimit(o, E) || _unsupportedIterableToArray(o, E) || _nonIterableRest();
}
function _objectWithoutPropertiesLoose$1(o, E) {
  if (o == null) return {};
  var A = {};
  for (var g in o) if ({}.hasOwnProperty.call(o, g)) {
    if (E.indexOf(g) !== -1) continue;
    A[g] = o[g];
  }
  return A;
}
function _objectWithoutProperties$2(o, E) {
  if (o == null) return {};
  var A, g, e = _objectWithoutPropertiesLoose$1(o, E);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    for (g = 0; g < t.length; g++) A = t[g], E.indexOf(A) === -1 && {}.propertyIsEnumerable.call(o, A) && (e[A] = o[A]);
  }
  return e;
}
function _extends$1() {
  return _extends$1 = Object.assign ? Object.assign.bind() : function(o) {
    for (var E = 1; E < arguments.length; E++) {
      var A = arguments[E];
      for (var g in A) ({}).hasOwnProperty.call(A, g) && (o[g] = A[g]);
    }
    return o;
  }, _extends$1.apply(null, arguments);
}
var REACT_ELEMENT_TYPE_18 = Symbol.for("react.element"), REACT_ELEMENT_TYPE_19 = Symbol.for("react.transitional.element"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function isFragment(o) {
  return (
    // Base object type
    o && _typeof$g(o) === "object" && // React Element type
    (o.$$typeof === REACT_ELEMENT_TYPE_18 || o.$$typeof === REACT_ELEMENT_TYPE_19) && // React Fragment type
    o.type === REACT_FRAGMENT_TYPE
  );
}
function toArray(o) {
  var E = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, A = [];
  return React__default.Children.forEach(o, function(g) {
    g == null && !E.keepEmpty || (Array.isArray(g) ? A = A.concat(toArray(g)) : isFragment(g) && g.props ? A = A.concat(toArray(g.props.children, E)) : A.push(g));
  }), A;
}
var preWarningFns = [];
function warning(o, E) {
  if (process.env.NODE_ENV !== "production" && console !== void 0) {
    var A = preWarningFns.reduce(function(g, e) {
      return e(g ?? "", "warning");
    }, E);
    A && console.error("Warning: ".concat(A));
  }
}
function _typeof(o) {
  "@babel/helpers - typeof";
  return _typeof = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(E) {
    return typeof E;
  } : function(E) {
    return E && typeof Symbol == "function" && E.constructor === Symbol && E !== Symbol.prototype ? "symbol" : typeof E;
  }, _typeof(o);
}
function toPrimitive(o, E) {
  if (_typeof(o) != "object" || !o) return o;
  var A = o[Symbol.toPrimitive];
  if (A !== void 0) {
    var g = A.call(o, E);
    if (_typeof(g) != "object") return g;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (E === "string" ? String : Number)(o);
}
function toPropertyKey(o) {
  var E = toPrimitive(o, "string");
  return _typeof(E) == "symbol" ? E : E + "";
}
function _defineProperty$1(o, E, A) {
  return (E = toPropertyKey(E)) in o ? Object.defineProperty(o, E, {
    value: A,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : o[E] = A, o;
}
function ownKeys$2(o, E) {
  var A = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var g = Object.getOwnPropertySymbols(o);
    E && (g = g.filter(function(e) {
      return Object.getOwnPropertyDescriptor(o, e).enumerable;
    })), A.push.apply(A, g);
  }
  return A;
}
function _objectSpread2(o) {
  for (var E = 1; E < arguments.length; E++) {
    var A = arguments[E] != null ? arguments[E] : {};
    E % 2 ? ownKeys$2(Object(A), !0).forEach(function(g) {
      _defineProperty$1(o, g, A[g]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(A)) : ownKeys$2(Object(A)).forEach(function(g) {
      Object.defineProperty(o, g, Object.getOwnPropertyDescriptor(A, g));
    });
  }
  return o;
}
function isDOM(o) {
  return o instanceof HTMLElement || o instanceof SVGElement;
}
function getDOM(o) {
  return o && _typeof$g(o) === "object" && isDOM(o.nativeElement) ? o.nativeElement : isDOM(o) ? o : null;
}
function findDOMNode(o) {
  var E = getDOM(o);
  if (E)
    return E;
  if (o instanceof React__default.Component) {
    var A;
    return (A = ReactDOM.findDOMNode) === null || A === void 0 ? void 0 : A.call(ReactDOM, o);
  }
  return null;
}
var reactIs = { exports: {} }, reactIs_production_min = {};
var hasRequiredReactIs_production_min;
function requireReactIs_production_min() {
  if (hasRequiredReactIs_production_min) return reactIs_production_min;
  hasRequiredReactIs_production_min = 1;
  var o = Symbol.for("react.element"), E = Symbol.for("react.portal"), A = Symbol.for("react.fragment"), g = Symbol.for("react.strict_mode"), e = Symbol.for("react.profiler"), t = Symbol.for("react.provider"), c = Symbol.for("react.context"), n = Symbol.for("react.server_context"), h = Symbol.for("react.forward_ref"), d = Symbol.for("react.suspense"), k = Symbol.for("react.suspense_list"), p = Symbol.for("react.memo"), M = Symbol.for("react.lazy"), S = Symbol.for("react.offscreen"), AA;
  AA = Symbol.for("react.module.reference");
  function H(gA) {
    if (typeof gA == "object" && gA !== null) {
      var CA = gA.$$typeof;
      switch (CA) {
        case o:
          switch (gA = gA.type, gA) {
            case A:
            case e:
            case g:
            case d:
            case k:
              return gA;
            default:
              switch (gA = gA && gA.$$typeof, gA) {
                case n:
                case c:
                case h:
                case M:
                case p:
                case t:
                  return gA;
                default:
                  return CA;
              }
          }
        case E:
          return CA;
      }
    }
  }
  return reactIs_production_min.ContextConsumer = c, reactIs_production_min.ContextProvider = t, reactIs_production_min.Element = o, reactIs_production_min.ForwardRef = h, reactIs_production_min.Fragment = A, reactIs_production_min.Lazy = M, reactIs_production_min.Memo = p, reactIs_production_min.Portal = E, reactIs_production_min.Profiler = e, reactIs_production_min.StrictMode = g, reactIs_production_min.Suspense = d, reactIs_production_min.SuspenseList = k, reactIs_production_min.isAsyncMode = function() {
    return !1;
  }, reactIs_production_min.isConcurrentMode = function() {
    return !1;
  }, reactIs_production_min.isContextConsumer = function(gA) {
    return H(gA) === c;
  }, reactIs_production_min.isContextProvider = function(gA) {
    return H(gA) === t;
  }, reactIs_production_min.isElement = function(gA) {
    return typeof gA == "object" && gA !== null && gA.$$typeof === o;
  }, reactIs_production_min.isForwardRef = function(gA) {
    return H(gA) === h;
  }, reactIs_production_min.isFragment = function(gA) {
    return H(gA) === A;
  }, reactIs_production_min.isLazy = function(gA) {
    return H(gA) === M;
  }, reactIs_production_min.isMemo = function(gA) {
    return H(gA) === p;
  }, reactIs_production_min.isPortal = function(gA) {
    return H(gA) === E;
  }, reactIs_production_min.isProfiler = function(gA) {
    return H(gA) === e;
  }, reactIs_production_min.isStrictMode = function(gA) {
    return H(gA) === g;
  }, reactIs_production_min.isSuspense = function(gA) {
    return H(gA) === d;
  }, reactIs_production_min.isSuspenseList = function(gA) {
    return H(gA) === k;
  }, reactIs_production_min.isValidElementType = function(gA) {
    return typeof gA == "string" || typeof gA == "function" || gA === A || gA === e || gA === g || gA === d || gA === k || gA === S || typeof gA == "object" && gA !== null && (gA.$$typeof === M || gA.$$typeof === p || gA.$$typeof === t || gA.$$typeof === c || gA.$$typeof === h || gA.$$typeof === AA || gA.getModuleId !== void 0);
  }, reactIs_production_min.typeOf = H, reactIs_production_min;
}
var reactIs_development = {};
var hasRequiredReactIs_development;
function requireReactIs_development() {
  return hasRequiredReactIs_development || (hasRequiredReactIs_development = 1, process.env.NODE_ENV !== "production" && (function() {
    var o = Symbol.for("react.element"), E = Symbol.for("react.portal"), A = Symbol.for("react.fragment"), g = Symbol.for("react.strict_mode"), e = Symbol.for("react.profiler"), t = Symbol.for("react.provider"), c = Symbol.for("react.context"), n = Symbol.for("react.server_context"), h = Symbol.for("react.forward_ref"), d = Symbol.for("react.suspense"), k = Symbol.for("react.suspense_list"), p = Symbol.for("react.memo"), M = Symbol.for("react.lazy"), S = Symbol.for("react.offscreen"), AA = !1, H = !1, gA = !1, CA = !1, IA = !1, BA;
    BA = Symbol.for("react.module.reference");
    function QA(UA) {
      return !!(typeof UA == "string" || typeof UA == "function" || UA === A || UA === e || IA || UA === g || UA === d || UA === k || CA || UA === S || AA || H || gA || typeof UA == "object" && UA !== null && (UA.$$typeof === M || UA.$$typeof === p || UA.$$typeof === t || UA.$$typeof === c || UA.$$typeof === h || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      UA.$$typeof === BA || UA.getModuleId !== void 0));
    }
    function EA(UA) {
      if (typeof UA == "object" && UA !== null) {
        var ig = UA.$$typeof;
        switch (ig) {
          case o:
            var og = UA.type;
            switch (og) {
              case A:
              case e:
              case g:
              case d:
              case k:
                return og;
              default:
                var PA = og && og.$$typeof;
                switch (PA) {
                  case n:
                  case c:
                  case h:
                  case M:
                  case p:
                  case t:
                    return PA;
                  default:
                    return ig;
                }
            }
          case E:
            return ig;
        }
      }
    }
    var oA = c, iA = t, aA = o, tA = h, eA = A, cA = M, DA = p, nA = E, wA = e, lA = g, NA = d, RA = k, KA = !1, vA = !1;
    function GA(UA) {
      return KA || (KA = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function FA(UA) {
      return vA || (vA = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function HA(UA) {
      return EA(UA) === c;
    }
    function sA(UA) {
      return EA(UA) === t;
    }
    function mA(UA) {
      return typeof UA == "object" && UA !== null && UA.$$typeof === o;
    }
    function xA(UA) {
      return EA(UA) === h;
    }
    function hA(UA) {
      return EA(UA) === A;
    }
    function MA(UA) {
      return EA(UA) === M;
    }
    function YA(UA) {
      return EA(UA) === p;
    }
    function LA(UA) {
      return EA(UA) === E;
    }
    function WA(UA) {
      return EA(UA) === e;
    }
    function zA(UA) {
      return EA(UA) === g;
    }
    function ZA(UA) {
      return EA(UA) === d;
    }
    function Ag(UA) {
      return EA(UA) === k;
    }
    reactIs_development.ContextConsumer = oA, reactIs_development.ContextProvider = iA, reactIs_development.Element = aA, reactIs_development.ForwardRef = tA, reactIs_development.Fragment = eA, reactIs_development.Lazy = cA, reactIs_development.Memo = DA, reactIs_development.Portal = nA, reactIs_development.Profiler = wA, reactIs_development.StrictMode = lA, reactIs_development.Suspense = NA, reactIs_development.SuspenseList = RA, reactIs_development.isAsyncMode = GA, reactIs_development.isConcurrentMode = FA, reactIs_development.isContextConsumer = HA, reactIs_development.isContextProvider = sA, reactIs_development.isElement = mA, reactIs_development.isForwardRef = xA, reactIs_development.isFragment = hA, reactIs_development.isLazy = MA, reactIs_development.isMemo = YA, reactIs_development.isPortal = LA, reactIs_development.isProfiler = WA, reactIs_development.isStrictMode = zA, reactIs_development.isSuspense = ZA, reactIs_development.isSuspenseList = Ag, reactIs_development.isValidElementType = QA, reactIs_development.typeOf = EA;
  })()), reactIs_development;
}
var hasRequiredReactIs;
function requireReactIs() {
  return hasRequiredReactIs || (hasRequiredReactIs = 1, process.env.NODE_ENV === "production" ? reactIs.exports = requireReactIs_production_min() : reactIs.exports = requireReactIs_development()), reactIs.exports;
}
var reactIsExports = requireReactIs();
function useMemo(o, E, A) {
  var g = React.useRef({});
  return (!("value" in g.current) || A(g.current.condition, E)) && (g.current.value = o(), g.current.condition = E), g.current.value;
}
var ReactMajorVersion = Number(version.split(".")[0]), fillRef = function o(E, A) {
  typeof E == "function" ? E(A) : _typeof$g(E) === "object" && E && "current" in E && (E.current = A);
}, composeRef = function o() {
  for (var E = arguments.length, A = new Array(E), g = 0; g < E; g++)
    A[g] = arguments[g];
  var e = A.filter(Boolean);
  return e.length <= 1 ? e[0] : function(t) {
    A.forEach(function(c) {
      fillRef(c, t);
    });
  };
}, useComposeRef = function o() {
  for (var E = arguments.length, A = new Array(E), g = 0; g < E; g++)
    A[g] = arguments[g];
  return useMemo(function() {
    return composeRef.apply(void 0, A);
  }, A, function(e, t) {
    return e.length !== t.length || e.every(function(c, n) {
      return c !== t[n];
    });
  });
}, supportRef = function o(E) {
  var A, g;
  if (!E)
    return !1;
  if (isReactElement(E) && ReactMajorVersion >= 19)
    return !0;
  var e = reactIsExports.isMemo(E) ? E.type.type : E.type;
  return !(typeof e == "function" && !((A = e.prototype) !== null && A !== void 0 && A.render) && e.$$typeof !== reactIsExports.ForwardRef || typeof E == "function" && !((g = E.prototype) !== null && g !== void 0 && g.render) && E.$$typeof !== reactIsExports.ForwardRef);
};
function isReactElement(o) {
  return /* @__PURE__ */ isValidElement(o) && !isFragment(o);
}
var getNodeRef = function o(E) {
  if (E && isReactElement(E)) {
    var A = E;
    return A.props.propertyIsEnumerable("ref") ? A.props.ref : A.ref;
  }
  return null;
}, CollectionContext = /* @__PURE__ */ React.createContext(null);
function Collection(o) {
  var E = o.children, A = o.onBatchResize, g = React.useRef(0), e = React.useRef([]), t = React.useContext(CollectionContext), c = React.useCallback(function(n, h, d) {
    g.current += 1;
    var k = g.current;
    e.current.push({
      size: n,
      element: h,
      data: d
    }), Promise.resolve().then(function() {
      k === g.current && (A?.(e.current), e.current = []);
    }), t?.(n, h, d);
  }, [A, t]);
  return /* @__PURE__ */ React.createElement(CollectionContext.Provider, {
    value: c
  }, E);
}
var MapShim = (function() {
  if (typeof Map < "u")
    return Map;
  function o(E, A) {
    var g = -1;
    return E.some(function(e, t) {
      return e[0] === A ? (g = t, !0) : !1;
    }), g;
  }
  return (
    /** @class */
    (function() {
      function E() {
        this.__entries__ = [];
      }
      return Object.defineProperty(E.prototype, "size", {
        /**
         * @returns {boolean}
         */
        get: function() {
          return this.__entries__.length;
        },
        enumerable: !0,
        configurable: !0
      }), E.prototype.get = function(A) {
        var g = o(this.__entries__, A), e = this.__entries__[g];
        return e && e[1];
      }, E.prototype.set = function(A, g) {
        var e = o(this.__entries__, A);
        ~e ? this.__entries__[e][1] = g : this.__entries__.push([A, g]);
      }, E.prototype.delete = function(A) {
        var g = this.__entries__, e = o(g, A);
        ~e && g.splice(e, 1);
      }, E.prototype.has = function(A) {
        return !!~o(this.__entries__, A);
      }, E.prototype.clear = function() {
        this.__entries__.splice(0);
      }, E.prototype.forEach = function(A, g) {
        g === void 0 && (g = null);
        for (var e = 0, t = this.__entries__; e < t.length; e++) {
          var c = t[e];
          A.call(g, c[1], c[0]);
        }
      }, E;
    })()
  );
})(), isBrowser = typeof window < "u" && typeof document < "u" && window.document === document, global$1 = (function() {
  return typeof global < "u" && global.Math === Math ? global : typeof self < "u" && self.Math === Math ? self : typeof window < "u" && window.Math === Math ? window : Function("return this")();
})(), requestAnimationFrame$1 = (function() {
  return typeof requestAnimationFrame == "function" ? requestAnimationFrame.bind(global$1) : function(o) {
    return setTimeout(function() {
      return o(Date.now());
    }, 1e3 / 60);
  };
})(), trailingTimeout = 2;
function throttle(o, E) {
  var A = !1, g = !1, e = 0;
  function t() {
    A && (A = !1, o()), g && n();
  }
  function c() {
    requestAnimationFrame$1(t);
  }
  function n() {
    var h = Date.now();
    if (A) {
      if (h - e < trailingTimeout)
        return;
      g = !0;
    } else
      A = !0, g = !1, setTimeout(c, E);
    e = h;
  }
  return n;
}
var REFRESH_DELAY = 20, transitionKeys = ["top", "right", "bottom", "left", "width", "height", "size", "weight"], mutationObserverSupported = typeof MutationObserver < "u", ResizeObserverController = (
  /** @class */
  (function() {
    function o() {
      this.connected_ = !1, this.mutationEventsAdded_ = !1, this.mutationsObserver_ = null, this.observers_ = [], this.onTransitionEnd_ = this.onTransitionEnd_.bind(this), this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
    }
    return o.prototype.addObserver = function(E) {
      ~this.observers_.indexOf(E) || this.observers_.push(E), this.connected_ || this.connect_();
    }, o.prototype.removeObserver = function(E) {
      var A = this.observers_, g = A.indexOf(E);
      ~g && A.splice(g, 1), !A.length && this.connected_ && this.disconnect_();
    }, o.prototype.refresh = function() {
      var E = this.updateObservers_();
      E && this.refresh();
    }, o.prototype.updateObservers_ = function() {
      var E = this.observers_.filter(function(A) {
        return A.gatherActive(), A.hasActive();
      });
      return E.forEach(function(A) {
        return A.broadcastActive();
      }), E.length > 0;
    }, o.prototype.connect_ = function() {
      !isBrowser || this.connected_ || (document.addEventListener("transitionend", this.onTransitionEnd_), window.addEventListener("resize", this.refresh), mutationObserverSupported ? (this.mutationsObserver_ = new MutationObserver(this.refresh), this.mutationsObserver_.observe(document, {
        attributes: !0,
        childList: !0,
        characterData: !0,
        subtree: !0
      })) : (document.addEventListener("DOMSubtreeModified", this.refresh), this.mutationEventsAdded_ = !0), this.connected_ = !0);
    }, o.prototype.disconnect_ = function() {
      !isBrowser || !this.connected_ || (document.removeEventListener("transitionend", this.onTransitionEnd_), window.removeEventListener("resize", this.refresh), this.mutationsObserver_ && this.mutationsObserver_.disconnect(), this.mutationEventsAdded_ && document.removeEventListener("DOMSubtreeModified", this.refresh), this.mutationsObserver_ = null, this.mutationEventsAdded_ = !1, this.connected_ = !1);
    }, o.prototype.onTransitionEnd_ = function(E) {
      var A = E.propertyName, g = A === void 0 ? "" : A, e = transitionKeys.some(function(t) {
        return !!~g.indexOf(t);
      });
      e && this.refresh();
    }, o.getInstance = function() {
      return this.instance_ || (this.instance_ = new o()), this.instance_;
    }, o.instance_ = null, o;
  })()
), defineConfigurable = (function(o, E) {
  for (var A = 0, g = Object.keys(E); A < g.length; A++) {
    var e = g[A];
    Object.defineProperty(o, e, {
      value: E[e],
      enumerable: !1,
      writable: !1,
      configurable: !0
    });
  }
  return o;
}), getWindowOf = (function(o) {
  var E = o && o.ownerDocument && o.ownerDocument.defaultView;
  return E || global$1;
}), emptyRect = createRectInit(0, 0, 0, 0);
function toFloat(o) {
  return parseFloat(o) || 0;
}
function getBordersSize(o) {
  for (var E = [], A = 1; A < arguments.length; A++)
    E[A - 1] = arguments[A];
  return E.reduce(function(g, e) {
    var t = o["border-" + e + "-width"];
    return g + toFloat(t);
  }, 0);
}
function getPaddings(o) {
  for (var E = ["top", "right", "bottom", "left"], A = {}, g = 0, e = E; g < e.length; g++) {
    var t = e[g], c = o["padding-" + t];
    A[t] = toFloat(c);
  }
  return A;
}
function getSVGContentRect(o) {
  var E = o.getBBox();
  return createRectInit(0, 0, E.width, E.height);
}
function getHTMLElementContentRect(o) {
  var E = o.clientWidth, A = o.clientHeight;
  if (!E && !A)
    return emptyRect;
  var g = getWindowOf(o).getComputedStyle(o), e = getPaddings(g), t = e.left + e.right, c = e.top + e.bottom, n = toFloat(g.width), h = toFloat(g.height);
  if (g.boxSizing === "border-box" && (Math.round(n + t) !== E && (n -= getBordersSize(g, "left", "right") + t), Math.round(h + c) !== A && (h -= getBordersSize(g, "top", "bottom") + c)), !isDocumentElement(o)) {
    var d = Math.round(n + t) - E, k = Math.round(h + c) - A;
    Math.abs(d) !== 1 && (n -= d), Math.abs(k) !== 1 && (h -= k);
  }
  return createRectInit(e.left, e.top, n, h);
}
var isSVGGraphicsElement = /* @__PURE__ */ (function() {
  return typeof SVGGraphicsElement < "u" ? function(o) {
    return o instanceof getWindowOf(o).SVGGraphicsElement;
  } : function(o) {
    return o instanceof getWindowOf(o).SVGElement && typeof o.getBBox == "function";
  };
})();
function isDocumentElement(o) {
  return o === getWindowOf(o).document.documentElement;
}
function getContentRect(o) {
  return isBrowser ? isSVGGraphicsElement(o) ? getSVGContentRect(o) : getHTMLElementContentRect(o) : emptyRect;
}
function createReadOnlyRect(o) {
  var E = o.x, A = o.y, g = o.width, e = o.height, t = typeof DOMRectReadOnly < "u" ? DOMRectReadOnly : Object, c = Object.create(t.prototype);
  return defineConfigurable(c, {
    x: E,
    y: A,
    width: g,
    height: e,
    top: A,
    right: E + g,
    bottom: e + A,
    left: E
  }), c;
}
function createRectInit(o, E, A, g) {
  return { x: o, y: E, width: A, height: g };
}
var ResizeObservation = (
  /** @class */
  (function() {
    function o(E) {
      this.broadcastWidth = 0, this.broadcastHeight = 0, this.contentRect_ = createRectInit(0, 0, 0, 0), this.target = E;
    }
    return o.prototype.isActive = function() {
      var E = getContentRect(this.target);
      return this.contentRect_ = E, E.width !== this.broadcastWidth || E.height !== this.broadcastHeight;
    }, o.prototype.broadcastRect = function() {
      var E = this.contentRect_;
      return this.broadcastWidth = E.width, this.broadcastHeight = E.height, E;
    }, o;
  })()
), ResizeObserverEntry = (
  /** @class */
  /* @__PURE__ */ (function() {
    function o(E, A) {
      var g = createReadOnlyRect(A);
      defineConfigurable(this, { target: E, contentRect: g });
    }
    return o;
  })()
), ResizeObserverSPI = (
  /** @class */
  (function() {
    function o(E, A, g) {
      if (this.activeObservations_ = [], this.observations_ = new MapShim(), typeof E != "function")
        throw new TypeError("The callback provided as parameter 1 is not a function.");
      this.callback_ = E, this.controller_ = A, this.callbackCtx_ = g;
    }
    return o.prototype.observe = function(E) {
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      if (!(typeof Element > "u" || !(Element instanceof Object))) {
        if (!(E instanceof getWindowOf(E).Element))
          throw new TypeError('parameter 1 is not of type "Element".');
        var A = this.observations_;
        A.has(E) || (A.set(E, new ResizeObservation(E)), this.controller_.addObserver(this), this.controller_.refresh());
      }
    }, o.prototype.unobserve = function(E) {
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      if (!(typeof Element > "u" || !(Element instanceof Object))) {
        if (!(E instanceof getWindowOf(E).Element))
          throw new TypeError('parameter 1 is not of type "Element".');
        var A = this.observations_;
        A.has(E) && (A.delete(E), A.size || this.controller_.removeObserver(this));
      }
    }, o.prototype.disconnect = function() {
      this.clearActive(), this.observations_.clear(), this.controller_.removeObserver(this);
    }, o.prototype.gatherActive = function() {
      var E = this;
      this.clearActive(), this.observations_.forEach(function(A) {
        A.isActive() && E.activeObservations_.push(A);
      });
    }, o.prototype.broadcastActive = function() {
      if (this.hasActive()) {
        var E = this.callbackCtx_, A = this.activeObservations_.map(function(g) {
          return new ResizeObserverEntry(g.target, g.broadcastRect());
        });
        this.callback_.call(E, A, E), this.clearActive();
      }
    }, o.prototype.clearActive = function() {
      this.activeObservations_.splice(0);
    }, o.prototype.hasActive = function() {
      return this.activeObservations_.length > 0;
    }, o;
  })()
), observers = typeof WeakMap < "u" ? /* @__PURE__ */ new WeakMap() : new MapShim(), ResizeObserver$2 = (
  /** @class */
  /* @__PURE__ */ (function() {
    function o(E) {
      if (!(this instanceof o))
        throw new TypeError("Cannot call a class as a function.");
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      var A = ResizeObserverController.getInstance(), g = new ResizeObserverSPI(E, A, this);
      observers.set(this, g);
    }
    return o;
  })()
);
[
  "observe",
  "unobserve",
  "disconnect"
].forEach(function(o) {
  ResizeObserver$2.prototype[o] = function() {
    var E;
    return (E = observers.get(this))[o].apply(E, arguments);
  };
});
var index = (function() {
  return typeof global$1.ResizeObserver < "u" ? global$1.ResizeObserver : ResizeObserver$2;
})(), elementListeners = /* @__PURE__ */ new Map();
function onResize(o) {
  o.forEach(function(E) {
    var A, g = E.target;
    (A = elementListeners.get(g)) === null || A === void 0 || A.forEach(function(e) {
      return e(g);
    });
  });
}
var resizeObserver = new index(onResize);
process.env.NODE_ENV;
process.env.NODE_ENV;
function observe(o, E) {
  elementListeners.has(o) || (elementListeners.set(o, /* @__PURE__ */ new Set()), resizeObserver.observe(o)), elementListeners.get(o).add(E);
}
function unobserve(o, E) {
  elementListeners.has(o) && (elementListeners.get(o).delete(E), elementListeners.get(o).size || (resizeObserver.unobserve(o), elementListeners.delete(o)));
}
function _classCallCheck(o, E) {
  if (!(o instanceof E)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(o, E) {
  for (var A = 0; A < E.length; A++) {
    var g = E[A];
    g.enumerable = g.enumerable || !1, g.configurable = !0, "value" in g && (g.writable = !0), Object.defineProperty(o, toPropertyKey(g.key), g);
  }
}
function _createClass(o, E, A) {
  return E && _defineProperties(o.prototype, E), Object.defineProperty(o, "prototype", {
    writable: !1
  }), o;
}
function _setPrototypeOf(o, E) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(A, g) {
    return A.__proto__ = g, A;
  }, _setPrototypeOf(o, E);
}
function _inherits(o, E) {
  if (typeof E != "function" && E !== null) throw new TypeError("Super expression must either be null or a function");
  o.prototype = Object.create(E && E.prototype, {
    constructor: {
      value: o,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(o, "prototype", {
    writable: !1
  }), E && _setPrototypeOf(o, E);
}
function _getPrototypeOf(o) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(E) {
    return E.__proto__ || Object.getPrototypeOf(E);
  }, _getPrototypeOf(o);
}
function _isNativeReflectConstruct() {
  try {
    var o = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (_isNativeReflectConstruct = function() {
    return !!o;
  })();
}
function _assertThisInitialized(o) {
  if (o === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return o;
}
function _possibleConstructorReturn(o, E) {
  if (E && (_typeof(E) == "object" || typeof E == "function")) return E;
  if (E !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(o);
}
function _createSuper(o) {
  var E = _isNativeReflectConstruct();
  return function() {
    var A, g = _getPrototypeOf(o);
    if (E) {
      var e = _getPrototypeOf(this).constructor;
      A = Reflect.construct(g, arguments, e);
    } else A = g.apply(this, arguments);
    return _possibleConstructorReturn(this, A);
  };
}
var DomWrapper = /* @__PURE__ */ (function(o) {
  _inherits(A, o);
  var E = _createSuper(A);
  function A() {
    return _classCallCheck(this, A), E.apply(this, arguments);
  }
  return _createClass(A, [{
    key: "render",
    value: function() {
      return this.props.children;
    }
  }]), A;
})(React.Component);
function SingleObserver(o, E) {
  var A = o.children, g = o.disabled, e = React.useRef(null), t = React.useRef(null), c = React.useContext(CollectionContext), n = typeof A == "function", h = n ? A(e) : A, d = React.useRef({
    width: -1,
    height: -1,
    offsetWidth: -1,
    offsetHeight: -1
  }), k = !n && /* @__PURE__ */ React.isValidElement(h) && supportRef(h), p = k ? getNodeRef(h) : null, M = useComposeRef(p, e), S = function() {
    var CA;
    return findDOMNode(e.current) || // Support `nativeElement` format
    (e.current && _typeof(e.current) === "object" ? findDOMNode((CA = e.current) === null || CA === void 0 ? void 0 : CA.nativeElement) : null) || findDOMNode(t.current);
  };
  React.useImperativeHandle(E, function() {
    return S();
  });
  var AA = React.useRef(o);
  AA.current = o;
  var H = React.useCallback(function(gA) {
    var CA = AA.current, IA = CA.onResize, BA = CA.data, QA = gA.getBoundingClientRect(), EA = QA.width, oA = QA.height, iA = gA.offsetWidth, aA = gA.offsetHeight, tA = Math.floor(EA), eA = Math.floor(oA);
    if (d.current.width !== tA || d.current.height !== eA || d.current.offsetWidth !== iA || d.current.offsetHeight !== aA) {
      var cA = {
        width: tA,
        height: eA,
        offsetWidth: iA,
        offsetHeight: aA
      };
      d.current = cA;
      var DA = iA === Math.round(EA) ? EA : iA, nA = aA === Math.round(oA) ? oA : aA, wA = _objectSpread2(_objectSpread2({}, cA), {}, {
        offsetWidth: DA,
        offsetHeight: nA
      });
      c?.(wA, gA, BA), IA && Promise.resolve().then(function() {
        IA(wA, gA);
      });
    }
  }, []);
  return React.useEffect(function() {
    var gA = S();
    return gA && !g && observe(gA, H), function() {
      return unobserve(gA, H);
    };
  }, [e.current, g]), /* @__PURE__ */ React.createElement(DomWrapper, {
    ref: t
  }, k ? /* @__PURE__ */ React.cloneElement(h, {
    ref: M
  }) : h);
}
var RefSingleObserver = /* @__PURE__ */ React.forwardRef(SingleObserver);
process.env.NODE_ENV !== "production" && (RefSingleObserver.displayName = "SingleObserver");
var INTERNAL_PREFIX_KEY = "rc-observer-key";
function ResizeObserver$1(o, E) {
  var A = o.children, g = typeof A == "function" ? [A] : toArray(A);
  return process.env.NODE_ENV !== "production" && (g.length > 1 ? warning(!1, "Find more than one child node with `children` in ResizeObserver. Please use ResizeObserver.Collection instead.") : g.length === 0 && warning(!1, "`children` of ResizeObserver is empty. Nothing is in observe.")), g.map(function(e, t) {
    var c = e?.key || "".concat(INTERNAL_PREFIX_KEY, "-").concat(t);
    return /* @__PURE__ */ React.createElement(RefSingleObserver, _extends$1({}, o, {
      key: c,
      ref: t === 0 ? E : void 0
    }), e);
  });
}
var RefResizeObserver = /* @__PURE__ */ React.forwardRef(ResizeObserver$1);
process.env.NODE_ENV !== "production" && (RefResizeObserver.displayName = "ResizeObserver");
RefResizeObserver.Collection = Collection;
function canUseDom() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
var useInternalLayoutEffect = process.env.NODE_ENV !== "test" && canUseDom() ? React.useLayoutEffect : React.useEffect, useLayoutEffect = function o(E, A) {
  var g = React.useRef(!0);
  useInternalLayoutEffect(function() {
    return E(g.current);
  }, A), useInternalLayoutEffect(function() {
    return g.current = !1, function() {
      g.current = !0;
    };
  }, []);
}, _excluded$4 = ["prefixCls", "invalidate", "item", "renderItem", "responsive", "responsiveDisabled", "registerSize", "itemKey", "className", "style", "children", "display", "order", "component"], UNDEFINED = void 0;
function InternalItem(o, E) {
  var A = o.prefixCls, g = o.invalidate, e = o.item, t = o.renderItem, c = o.responsive, n = o.responsiveDisabled, h = o.registerSize, d = o.itemKey, k = o.className, p = o.style, M = o.children, S = o.display, AA = o.order, H = o.component, gA = H === void 0 ? "div" : H, CA = _objectWithoutProperties$2(o, _excluded$4), IA = c && !S;
  function BA(aA) {
    h(d, aA);
  }
  React.useEffect(function() {
    return function() {
      BA(null);
    };
  }, []);
  var QA = t && e !== UNDEFINED ? t(e, {
    index: AA
  }) : M, EA;
  g || (EA = {
    opacity: IA ? 0 : 1,
    height: IA ? 0 : UNDEFINED,
    overflowY: IA ? "hidden" : UNDEFINED,
    order: c ? AA : UNDEFINED,
    pointerEvents: IA ? "none" : UNDEFINED,
    position: IA ? "absolute" : UNDEFINED
  });
  var oA = {};
  IA && (oA["aria-hidden"] = !0);
  var iA = /* @__PURE__ */ React.createElement(gA, _extends$2({
    className: classNames(!g && A, k),
    style: _objectSpread2$1(_objectSpread2$1({}, EA), p)
  }, oA, CA, {
    ref: E
  }), QA);
  return c && (iA = /* @__PURE__ */ React.createElement(RefResizeObserver, {
    onResize: function(tA) {
      var eA = tA.offsetWidth;
      BA(eA);
    },
    disabled: n
  }, iA)), iA;
}
var Item = /* @__PURE__ */ React.forwardRef(InternalItem);
Item.displayName = "Item";
function useEvent(o) {
  var E = React.useRef();
  E.current = o;
  var A = React.useCallback(function() {
    for (var g, e = arguments.length, t = new Array(e), c = 0; c < e; c++)
      t[c] = arguments[c];
    return (g = E.current) === null || g === void 0 ? void 0 : g.call.apply(g, [E].concat(t));
  }, []);
  return A;
}
var raf = function o(E) {
  return +setTimeout(E, 16);
}, caf = function o(E) {
  return clearTimeout(E);
};
typeof window < "u" && "requestAnimationFrame" in window && (raf = function(E) {
  return window.requestAnimationFrame(E);
}, caf = function(E) {
  return window.cancelAnimationFrame(E);
});
var rafUUID = 0, rafIds = /* @__PURE__ */ new Map();
function cleanup(o) {
  rafIds.delete(o);
}
var wrapperRaf = function o(E) {
  var A = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
  rafUUID += 1;
  var g = rafUUID;
  function e(t) {
    if (t === 0)
      cleanup(g), E();
    else {
      var c = raf(function() {
        e(t - 1);
      });
      rafIds.set(g, c);
    }
  }
  return e(A), g;
};
wrapperRaf.cancel = function(o) {
  var E = rafIds.get(o);
  return cleanup(o), caf(E);
};
process.env.NODE_ENV !== "production" && (wrapperRaf.ids = function() {
  return rafIds;
});
function channelUpdate(o) {
  if (typeof MessageChannel > "u")
    wrapperRaf(o);
  else {
    var E = new MessageChannel();
    E.port1.onmessage = function() {
      return o();
    }, E.port2.postMessage(void 0);
  }
}
function useBatcher() {
  var o = React.useRef(null), E = function(g) {
    o.current || (o.current = [], channelUpdate(function() {
      unstable_batchedUpdates(function() {
        o.current.forEach(function(e) {
          e();
        }), o.current = null;
      });
    })), o.current.push(g);
  };
  return E;
}
function useEffectState(o, E) {
  var A = React.useState(E), g = _slicedToArray$1(A, 2), e = g[0], t = g[1], c = useEvent(function(n) {
    o(function() {
      t(n);
    });
  });
  return [e, c];
}
var OverflowContext = /* @__PURE__ */ React__default.createContext(null), _excluded$3 = ["component"], _excluded2$1 = ["className"], _excluded3 = ["className"], InternalRawItem = function o(E, A) {
  var g = React.useContext(OverflowContext);
  if (!g) {
    var e = E.component, t = e === void 0 ? "div" : e, c = _objectWithoutProperties$2(E, _excluded$3);
    return /* @__PURE__ */ React.createElement(t, _extends$2({}, c, {
      ref: A
    }));
  }
  var n = g.className, h = _objectWithoutProperties$2(g, _excluded2$1), d = E.className, k = _objectWithoutProperties$2(E, _excluded3);
  return /* @__PURE__ */ React.createElement(OverflowContext.Provider, {
    value: null
  }, /* @__PURE__ */ React.createElement(Item, _extends$2({
    ref: A,
    className: classNames(n, d)
  }, h, k)));
}, RawItem = /* @__PURE__ */ React.forwardRef(InternalRawItem);
RawItem.displayName = "RawItem";
var _excluded$2 = ["prefixCls", "data", "renderItem", "renderRawItem", "itemKey", "itemWidth", "ssr", "style", "className", "maxCount", "renderRest", "renderRawRest", "prefix", "suffix", "component", "itemComponent", "onVisibleChange"], RESPONSIVE = "responsive", INVALIDATE = "invalidate";
function defaultRenderRest(o) {
  return "+ ".concat(o.length, " ...");
}
function Overflow(o, E) {
  var A = o.prefixCls, g = A === void 0 ? "rc-overflow" : A, e = o.data, t = e === void 0 ? [] : e, c = o.renderItem, n = o.renderRawItem, h = o.itemKey, d = o.itemWidth, k = d === void 0 ? 10 : d, p = o.ssr, M = o.style, S = o.className, AA = o.maxCount, H = o.renderRest, gA = o.renderRawRest, CA = o.prefix, IA = o.suffix, BA = o.component, QA = BA === void 0 ? "div" : BA, EA = o.itemComponent, oA = o.onVisibleChange, iA = _objectWithoutProperties$2(o, _excluded$2), aA = p === "full", tA = useBatcher(), eA = useEffectState(tA, null), cA = _slicedToArray$1(eA, 2), DA = cA[0], nA = cA[1], wA = DA || 0, lA = useEffectState(tA, /* @__PURE__ */ new Map()), NA = _slicedToArray$1(lA, 2), RA = NA[0], KA = NA[1], vA = useEffectState(tA, 0), GA = _slicedToArray$1(vA, 2), FA = GA[0], HA = GA[1], sA = useEffectState(tA, 0), mA = _slicedToArray$1(sA, 2), xA = mA[0], hA = mA[1], MA = useEffectState(tA, 0), YA = _slicedToArray$1(MA, 2), LA = YA[0], WA = YA[1], zA = useEffectState(tA, 0), ZA = _slicedToArray$1(zA, 2), Ag = ZA[0], UA = ZA[1], ig = useState(null), og = _slicedToArray$1(ig, 2), PA = og[0], Gg = og[1], gg = useState(null), eg = _slicedToArray$1(gg, 2), Dg = eg[0], rg = eg[1], cg = React.useMemo(function() {
    return Dg === null && aA ? Number.MAX_SAFE_INTEGER : Dg || 0;
  }, [Dg, DA]), hg = useState(!1), Cg = _slicedToArray$1(hg, 2), dA = Cg[0], pA = Cg[1], XA = "".concat(g, "-item"), jA = Math.max(FA, xA), OA = AA === RESPONSIVE, VA = t.length && OA, $A = AA === INVALIDATE, fA = VA || typeof AA == "number" && t.length > AA, yA = useMemo$1(function() {
    var Ig = t;
    return VA ? DA === null && aA ? Ig = t : Ig = t.slice(0, Math.min(t.length, wA / k)) : typeof AA == "number" && (Ig = t.slice(0, AA)), Ig;
  }, [t, k, DA, AA, VA]), bA = useMemo$1(function() {
    return VA ? t.slice(cg + 1) : t.slice(yA.length);
  }, [t, yA, VA, cg]), kA = useCallback(function(Ig, tg) {
    var Ng;
    return typeof h == "function" ? h(Ig) : (Ng = h && Ig?.[h]) !== null && Ng !== void 0 ? Ng : tg;
  }, [h]), JA = useCallback(c || function(Ig) {
    return Ig;
  }, [c]);
  function uA(Ig, tg, Ng) {
    Dg === Ig && (tg === void 0 || tg === PA) || (rg(Ig), Ng || (pA(Ig < t.length - 1), oA?.(Ig)), tg !== void 0 && Gg(tg));
  }
  function TA(Ig, tg) {
    nA(tg.clientWidth);
  }
  function Bg(Ig, tg) {
    KA(function(Ng) {
      var bg = new Map(Ng);
      return tg === null ? bg.delete(Ig) : bg.set(Ig, tg), bg;
    });
  }
  function ng(Ig, tg) {
    hA(tg), HA(xA);
  }
  function sg(Ig, tg) {
    WA(tg);
  }
  function Rg(Ig, tg) {
    UA(tg);
  }
  function mg(Ig) {
    return RA.get(kA(yA[Ig], Ig));
  }
  useLayoutEffect(function() {
    if (wA && typeof jA == "number" && yA) {
      var Ig = LA + Ag, tg = yA.length, Ng = tg - 1;
      if (!tg) {
        uA(0, null);
        return;
      }
      for (var bg = 0; bg < tg; bg += 1) {
        var rA = mg(bg);
        if (aA && (rA = rA || 0), rA === void 0) {
          uA(bg - 1, void 0, !0);
          break;
        }
        if (Ig += rA, // Only one means `totalWidth` is the final width
        Ng === 0 && Ig <= wA || // Last two width will be the final width
        bg === Ng - 1 && Ig + mg(Ng) <= wA) {
          uA(Ng, null);
          break;
        } else if (Ig + jA > wA) {
          uA(bg - 1, Ig - rA - Ag + xA);
          break;
        }
      }
      IA && mg(0) + Ag > wA && Gg(null);
    }
  }, [wA, RA, xA, LA, Ag, kA, yA]);
  var Yg = dA && !!bA.length, gI = {};
  PA !== null && VA && (gI = {
    position: "absolute",
    left: PA,
    top: 0
  });
  var Jg = {
    prefixCls: XA,
    responsive: VA,
    component: EA,
    invalidate: $A
  }, II = n ? function(Ig, tg) {
    var Ng = kA(Ig, tg);
    return /* @__PURE__ */ React.createElement(OverflowContext.Provider, {
      key: Ng,
      value: _objectSpread2$1(_objectSpread2$1({}, Jg), {}, {
        order: tg,
        item: Ig,
        itemKey: Ng,
        registerSize: Bg,
        display: tg <= cg
      })
    }, n(Ig, tg));
  } : function(Ig, tg) {
    var Ng = kA(Ig, tg);
    return /* @__PURE__ */ React.createElement(Item, _extends$2({}, Jg, {
      order: tg,
      key: Ng,
      item: Ig,
      renderItem: JA,
      itemKey: Ng,
      registerSize: Bg,
      display: tg <= cg
    }));
  }, CI = {
    order: Yg ? cg : Number.MAX_SAFE_INTEGER,
    className: "".concat(XA, "-rest"),
    registerSize: ng,
    display: Yg
  }, Xg = H || defaultRenderRest, BI = gA ? /* @__PURE__ */ React.createElement(OverflowContext.Provider, {
    value: _objectSpread2$1(_objectSpread2$1({}, Jg), CI)
  }, gA(bA)) : /* @__PURE__ */ React.createElement(Item, _extends$2({}, Jg, CI), typeof Xg == "function" ? Xg(bA) : Xg), qg = /* @__PURE__ */ React.createElement(QA, _extends$2({
    className: classNames(!$A && g, S),
    style: M,
    ref: E
  }, iA), CA && /* @__PURE__ */ React.createElement(Item, _extends$2({}, Jg, {
    responsive: OA,
    responsiveDisabled: !VA,
    order: -1,
    className: "".concat(XA, "-prefix"),
    registerSize: sg,
    display: !0
  }), CA), yA.map(II), fA ? BI : null, IA && /* @__PURE__ */ React.createElement(Item, _extends$2({}, Jg, {
    responsive: OA,
    responsiveDisabled: !VA,
    order: cg,
    className: "".concat(XA, "-suffix"),
    registerSize: Rg,
    display: !0,
    style: gI
  }), IA));
  return OA ? /* @__PURE__ */ React.createElement(RefResizeObserver, {
    onResize: TA,
    disabled: !VA
  }, qg) : qg;
}
var ForwardOverflow = /* @__PURE__ */ React.forwardRef(Overflow);
ForwardOverflow.displayName = "Overflow";
ForwardOverflow.Item = RawItem;
ForwardOverflow.RESPONSIVE = RESPONSIVE;
ForwardOverflow.INVALIDATE = INVALIDATE;
function _objectWithoutProperties$1(o, E) {
  if (o == null) return {};
  var A, g, e = _objectWithoutPropertiesLoose$q(o, E);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    for (g = 0; g < t.length; g++) A = t[g], E.indexOf(A) === -1 && {}.propertyIsEnumerable.call(o, A) && (e[A] = o[A]);
  }
  return e;
}
var _excluded$1 = ["children", "iconAttrs", "iconVerticalAlign", "iconViewBox", "size", "title"];
function ownKeys$1(o, E) {
  var A = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var g = Object.getOwnPropertySymbols(o);
    E && (g = g.filter(function(e) {
      return Object.getOwnPropertyDescriptor(o, e).enumerable;
    })), A.push.apply(A, g);
  }
  return A;
}
function _objectSpread$1(o) {
  for (var E = 1; E < arguments.length; E++) {
    var A = arguments[E] != null ? arguments[E] : {};
    E % 2 ? ownKeys$1(Object(A), !0).forEach(function(g) {
      _defineProperty$u(o, g, A[g]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(A)) : ownKeys$1(Object(A)).forEach(function(g) {
      Object.defineProperty(o, g, Object.getOwnPropertyDescriptor(A, g));
    });
  }
  return o;
}
var EmotionIconBaseBase = /* @__PURE__ */ React.forwardRef(function(o, E) {
  var A = o.children, g = o.iconAttrs;
  o.iconVerticalAlign;
  var e = o.iconViewBox, t = o.size, c = o.title, n = _objectWithoutProperties$1(o, _excluded$1), h = _objectSpread$1(_objectSpread$1({
    viewBox: e,
    height: o.height !== void 0 ? o.height : t,
    width: o.width !== void 0 ? o.width : t,
    "aria-hidden": c == null ? "true" : void 0,
    focusable: "false",
    role: c != null ? "img" : void 0
  }, g), n);
  return /* @__PURE__ */ React.createElement("svg", _extends$C({}, h, {
    ref: E
  }), c && /* @__PURE__ */ React.createElement("title", {
    key: "icon-title"
  }, c), A);
}), EmotionIconBase = /* @__PURE__ */ createStyled(EmotionIconBaseBase, process.env.NODE_ENV === "production" ? {
  target: "ex0cdmw0"
} : {
  target: "ex0cdmw0",
  label: "EmotionIconBase"
})("display:inline-block;vertical-align:", function(o) {
  return o.iconVerticalAlign;
}, ";overflow:hidden;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")), AccessibilityNew = /* @__PURE__ */ React.forwardRef(function(o, E) {
  var A = {
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  };
  return /* @__PURE__ */ React.createElement(EmotionIconBase, _extends$C({
    iconAttrs: A,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, o, {
    ref: E
  }), /* @__PURE__ */ React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M20.5 6c-2.61.7-5.67 1-8.5 1s-5.89-.3-8.5-1L3 8c1.86.5 4 .83 6 1v13h2v-6h2v6h2V9c2-.17 4.14-.5 6-1l-.5-2zM12 6c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z"
  }));
});
AccessibilityNew.displayName = "AccessibilityNew";
var AccessibleForward = /* @__PURE__ */ React.forwardRef(function(o, E) {
  var A = {
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  };
  return /* @__PURE__ */ React.createElement(EmotionIconBase, _extends$C({
    iconAttrs: A,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, o, {
    ref: E
  }), /* @__PURE__ */ React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /* @__PURE__ */ React.createElement("circle", {
    cx: 18,
    cy: 4.54,
    r: 2
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M15 17h-2c0 1.65-1.35 3-3 3s-3-1.35-3-3 1.35-3 3-3v-2c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5zm3-3.5h-1.86l1.67-3.67C18.42 8.5 17.44 7 15.96 7h-5.2c-.81 0-1.54.47-1.87 1.2L8.22 10l1.92.53.65-1.53H13l-1.83 4.1c-.6 1.33.39 2.9 1.85 2.9H18v5h2v-5.5c0-1.1-.9-2-2-2z"
  }));
});
AccessibleForward.displayName = "AccessibleForward";
var DirectionsBike = /* @__PURE__ */ React.forwardRef(function(o, E) {
  var A = {
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  };
  return /* @__PURE__ */ React.createElement(EmotionIconBase, _extends$C({
    iconAttrs: A,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, o, {
    ref: E
  }), /* @__PURE__ */ React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M15.5 5.5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM5 12c-2.8 0-5 2.2-5 5s2.2 5 5 5 5-2.2 5-5-2.2-5-5-5zm0 8.5c-1.9 0-3.5-1.6-3.5-3.5s1.6-3.5 3.5-3.5 3.5 1.6 3.5 3.5-1.6 3.5-3.5 3.5zm5.8-10l2.4-2.4.8.8c1.3 1.3 3 2.1 5.1 2.1V9c-1.5 0-2.7-.6-3.6-1.5l-1.9-1.9c-.5-.4-1-.6-1.6-.6s-1.1.2-1.4.6L7.8 8.4c-.4.4-.6.9-.6 1.4 0 .6.2 1.1.6 1.4L11 14v5h2v-6.2l-2.2-2.3zM19 12c-2.8 0-5 2.2-5 5s2.2 5 5 5 5-2.2 5-5-2.2-5-5-5zm0 8.5c-1.9 0-3.5-1.6-3.5-3.5s1.6-3.5 3.5-3.5 3.5 1.6 3.5 3.5-1.6 3.5-3.5 3.5z"
  }));
});
DirectionsBike.displayName = "DirectionsBike";
var DirectionsRun = /* @__PURE__ */ React.forwardRef(function(o, E) {
  var A = {
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  };
  return /* @__PURE__ */ React.createElement(EmotionIconBase, _extends$C({
    iconAttrs: A,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, o, {
    ref: E
  }), /* @__PURE__ */ React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M13.49 5.48c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm-3.6 13.9l1-4.4 2.1 2v6h2v-7.5l-2.1-2 .6-3c1.3 1.5 3.3 2.5 5.5 2.5v-2c-1.9 0-3.5-1-4.3-2.4l-1-1.6c-.4-.6-1-1-1.7-1-.3 0-.5.1-.8.1l-5.2 2.2v4.7h2v-3.4l1.8-.7-1.6 8.1-4.9-1-.4 2 7 1.4z"
  }));
});
DirectionsRun.displayName = "DirectionsRun";
var KeyboardArrowDown = /* @__PURE__ */ React.forwardRef(function(o, E) {
  var A = {
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  };
  return /* @__PURE__ */ React.createElement(EmotionIconBase, _extends$C({
    iconAttrs: A,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, o, {
    ref: E
  }), /* @__PURE__ */ React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"
  }));
});
KeyboardArrowDown.displayName = "KeyboardArrowDown";
var KeyboardArrowUp = /* @__PURE__ */ React.forwardRef(function(o, E) {
  var A = {
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  };
  return /* @__PURE__ */ React.createElement(EmotionIconBase, _extends$C({
    iconAttrs: A,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, o, {
    ref: E
  }), /* @__PURE__ */ React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6 1.41 1.41z"
  }));
});
KeyboardArrowUp.displayName = "KeyboardArrowUp";
var Pool = /* @__PURE__ */ React.forwardRef(function(o, E) {
  var A = {
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  };
  return /* @__PURE__ */ React.createElement(EmotionIconBase, _extends$C({
    iconAttrs: A,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, o, {
    ref: E
  }), /* @__PURE__ */ React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M10 8l-3.25 3.25c.31.12.56.27.77.39.37.23.59.36 1.15.36s.78-.13 1.15-.36c.46-.27 1.08-.64 2.19-.64s1.73.37 2.18.64c.37.22.6.36 1.15.36.55 0 .78-.13 1.15-.36.12-.07.26-.15.41-.23L10.48 5C8.93 3.45 7.5 2.99 5 3v2.5c1.82-.01 2.89.39 4 1.5l1 1zm12 8.5h-.02.02zm-16.65-1c.55 0 .78.14 1.15.36.45.27 1.07.64 2.18.64s1.73-.37 2.18-.64c.37-.23.59-.36 1.15-.36.55 0 .78.14 1.15.36.45.27 1.07.64 2.18.64s1.73-.37 2.18-.64c.37-.23.59-.36 1.15-.36.55 0 .78.14 1.15.36.45.27 1.06.63 2.16.64v-2c-.55 0-.78-.14-1.15-.36-.45-.27-1.07-.64-2.18-.64s-1.73.37-2.18.64c-.37.23-.6.36-1.15.36s-.78-.14-1.15-.36c-.45-.27-1.07-.64-2.18-.64s-1.73.37-2.18.64c-.37.23-.59.36-1.15.36-.55 0-.78-.14-1.15-.36-.45-.27-1.07-.64-2.18-.64s-1.73.37-2.18.64c-.37.23-.59.36-1.15.36v2c1.11 0 1.73-.37 2.2-.64.37-.23.6-.36 1.15-.36zM18.67 18c-1.11 0-1.73.37-2.18.64-.37.23-.6.36-1.15.36-.55 0-.78-.14-1.15-.36-.45-.27-1.07-.64-2.18-.64s-1.73.37-2.19.64c-.37.23-.59.36-1.15.36s-.78-.13-1.15-.36c-.45-.27-1.07-.64-2.18-.64s-1.73.37-2.19.64c-.37.23-.59.36-1.15.36v2c1.11 0 1.73-.37 2.19-.64.37-.23.6-.36 1.15-.36.55 0 .78.13 1.15.36.45.27 1.07.64 2.18.64s1.73-.37 2.19-.64c.37-.23.59-.36 1.15-.36.55 0 .78.14 1.15.36.45.27 1.07.64 2.18.64s1.72-.37 2.18-.64c.37-.23.59-.36 1.15-.36.55 0 .78.14 1.15.36.45.27 1.07.64 2.18.64v-2c-.56 0-.78-.13-1.15-.36-.45-.27-1.07-.64-2.18-.64z"
  }), /* @__PURE__ */ React.createElement("circle", {
    cx: 16.5,
    cy: 5.5,
    r: 2.5
  }));
});
Pool.displayName = "Pool";
var Rowing = /* @__PURE__ */ React.forwardRef(function(o, E) {
  var A = {
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  };
  return /* @__PURE__ */ React.createElement(EmotionIconBase, _extends$C({
    iconAttrs: A,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, o, {
    ref: E
  }), /* @__PURE__ */ React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M8.5 14.5L4 19l1.5 1.5L9 17h2l-2.5-2.5zM15 1c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 20.01L18 24l-2.99-3.01V19.5l-7.1-7.09c-.31.05-.61.07-.91.07v-2.16c1.66.03 3.61-.87 4.67-2.04l1.4-1.55c.19-.21.43-.38.69-.5.29-.14.62-.23.96-.23h.03C15.99 6.01 17 7.02 17 8.26v5.75c0 .84-.35 1.61-.92 2.16l-3.58-3.58v-2.27c-.63.52-1.43 1.02-2.29 1.39L16.5 18H18l3 3.01z"
  }));
});
Rowing.displayName = "Rowing";
const TopNavSection = ({
  title: o,
  sections: E,
  handlePageChange: A,
  endpoints: g,
  pageLinkBaseUrl: e,
  currentPageScriptHash: t,
  hideChevron: c = !1,
  widgetsDisabled: n
}) => {
  const [h, d] = useState(!1), k = useEmotionTheme(), p = hasLightBackgroundColor(k), M = E.length > 1;
  return isNullOrUndefined(E) || E.length === 0 || E[0].length === 0 ? null : /* @__PURE__ */ jsxRuntimeExports.jsx(
    Popover$2,
    {
      triggerType: TRIGGER_TYPE.click,
      placement: PLACEMENT.bottomLeft,
      content: () => /* @__PURE__ */ jsxRuntimeExports.jsx(StyledPopoverContent, { "data-testid": "stTopNavPopover", children: E.map((S, AA) => {
        const H = S[0].sectionHeader;
        return S.map((gA, CA) => {
          const IA = (QA) => (QA.preventDefault(), gA.pageScriptHash && A(gA.pageScriptHash), d(!1), !1), BA = String(gA.pageName || "");
          return /* @__PURE__ */ jsxRuntimeExports.jsxs(React__default.Fragment, { children: [
            CA === 0 && M && /* @__PURE__ */ jsxRuntimeExports.jsx(StyledSectionName, { children: H }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(StyledTopNavSidebarNavLinkContainer, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(SidebarNavLink, { ...gA, icon: gA.icon || null, isTopNav: !0, isInDropdown: !0, isActive: t === gA.pageScriptHash, onClick: IA, pageUrl: g.buildAppPageURL(e, gA), widgetsDisabled: n, children: BA }) })
          ] }, `${gA.pageScriptHash}-${BA}`);
        });
      }) }),
      isOpen: h,
      onClickOutside: () => d(!1),
      onClick: () => h ? d(!1) : void 0,
      onEsc: () => d(!1),
      renderAll: !0,
      overrides: {
        Body: {
          style: () => ({
            marginTop: k.spacing.sm,
            marginRight: k.spacing.lg,
            marginBottom: k.spacing.lg,
            maxHeight: "70vh",
            minWidth: "8rem",
            overflow: "auto",
            maxWidth: `calc(${k.sizes.contentMaxWidth} - 2*${k.spacing.lg})`,
            borderTopLeftRadius: k.radii.xl,
            borderTopRightRadius: k.radii.xl,
            borderBottomRightRadius: k.radii.xl,
            borderBottomLeftRadius: k.radii.xl,
            borderLeftWidth: k.sizes.borderWidth,
            borderRightWidth: k.sizes.borderWidth,
            borderTopWidth: k.sizes.borderWidth,
            borderBottomWidth: k.sizes.borderWidth,
            borderLeftStyle: "solid",
            borderRightStyle: "solid",
            borderTopStyle: "solid",
            borderBottomStyle: "solid",
            borderLeftColor: k.colors.borderColor,
            borderRightColor: k.colors.borderColor,
            borderTopColor: k.colors.borderColor,
            borderBottomColor: k.colors.borderColor,
            boxShadow: p ? "0px 4px 16px rgba(0, 0, 0, 0.16)" : "0px 4px 16px rgba(0, 0, 0, 0.7)",
            [`@media (max-width: ${k.breakpoints.sm})`]: {
              maxWidth: `calc(100% - ${k.spacing.threeXL})`
            }
          })
        }
      },
      children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledNavSection, { tabIndex: 0, onClick: () => d(!h), isOpen: h, "data-testid": "stTopNavSection", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(StyledNavSectionText, { children: o }),
        !c && /* @__PURE__ */ jsxRuntimeExports.jsx(StyledIconContainer, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Icon$2, { content: h ? KeyboardArrowUp : KeyboardArrowDown, size: "lg" }) })
      ] }) })
    }
  );
}, TopNav = ({
  endpoints: o,
  widgetsDisabled: E
}) => {
  const {
    pageLinkBaseUrl: A,
    currentPageScriptHash: g,
    appPages: e,
    onPageChange: t
  } = useContext(NavigationContext), {
    data: c,
    itemKey: n
  } = useMemo$1(() => {
    const k = groupPagesBySection(e), p = processNavigationStructure(k);
    return {
      data: [...p.individualPages, ...Object.entries(p.sections).map(([AA, H]) => H)],
      itemKey: (AA) => Array.isArray(AA) ? AA[0]?.sectionHeader ?? "" : AA.pageScriptHash ?? ""
    };
  }, [e]), h = useCallback((k, p) => Array.isArray(k) ? /* @__PURE__ */ jsxRuntimeExports.jsx(TopNavSection, { sections: [k], title: k[0].sectionHeader || "", handlePageChange: t, endpoints: o, pageLinkBaseUrl: A, currentPageScriptHash: g, widgetsDisabled: E }) : /* @__PURE__ */ jsxRuntimeExports.jsx(StyledTopNavLinkContainer, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(SidebarNavLink, { isTopNav: !0, isInDropdown: !1, isActive: g === k.pageScriptHash, icon: k.icon, pageUrl: o.buildAppPageURL(A, k), onClick: (M) => {
    M.preventDefault(), k.pageScriptHash && t(k.pageScriptHash);
  }, widgetsDisabled: E, children: String(k.pageName) }) }), [t, o, A, g, E]), d = useCallback((k) => {
    if (isNullOrUndefined(k))
      return null;
    const M = `${k.flat().length} more`, S = k.map((AA) => Array.isArray(AA) ? AA : [AA]);
    return /* @__PURE__ */ jsxRuntimeExports.jsx(TopNavSection, { hideChevron: !0, sections: S, title: M, handlePageChange: t, endpoints: o, pageLinkBaseUrl: A, currentPageScriptHash: g, widgetsDisabled: E });
  }, [t, o, A, g, E]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ForwardOverflow, { component: StyledOverflowContainer, itemKey: n, data: c, maxCount: "responsive", renderItem: h, renderRest: d });
};
var __assign$1 = function() {
  return __assign$1 = Object.assign || function(o) {
    for (var E, A = 1, g = arguments.length; A < g; A++) {
      E = arguments[A];
      for (var e in E) Object.prototype.hasOwnProperty.call(E, e) && (o[e] = E[e]);
    }
    return o;
  }, __assign$1.apply(this, arguments);
}, rowSizeBase = {
  width: "100%",
  height: "10px",
  top: "0px",
  left: "0px",
  cursor: "row-resize"
}, colSizeBase = {
  width: "10px",
  height: "100%",
  top: "0px",
  left: "0px",
  cursor: "col-resize"
}, edgeBase = {
  width: "20px",
  height: "20px",
  position: "absolute",
  zIndex: 1
}, styles = {
  top: __assign$1(__assign$1({}, rowSizeBase), { top: "-5px" }),
  right: __assign$1(__assign$1({}, colSizeBase), { left: void 0, right: "-5px" }),
  bottom: __assign$1(__assign$1({}, rowSizeBase), { top: void 0, bottom: "-5px" }),
  left: __assign$1(__assign$1({}, colSizeBase), { left: "-5px" }),
  topRight: __assign$1(__assign$1({}, edgeBase), { right: "-10px", top: "-10px", cursor: "ne-resize" }),
  bottomRight: __assign$1(__assign$1({}, edgeBase), { right: "-10px", bottom: "-10px", cursor: "se-resize" }),
  bottomLeft: __assign$1(__assign$1({}, edgeBase), { left: "-10px", bottom: "-10px", cursor: "sw-resize" }),
  topLeft: __assign$1(__assign$1({}, edgeBase), { left: "-10px", top: "-10px", cursor: "nw-resize" })
}, Resizer = memo(function(o) {
  var E = o.onResizeStart, A = o.direction, g = o.children, e = o.replaceStyles, t = o.className, c = useCallback(function(d) {
    E(d, A);
  }, [E, A]), n = useCallback(function(d) {
    E(d, A);
  }, [E, A]), h = useMemo$1(function() {
    return __assign$1(__assign$1({ position: "absolute", userSelect: "none" }, styles[A]), e ?? {});
  }, [e, A]);
  return jsxRuntimeExports.jsx("div", { className: t || void 0, style: h, onMouseDown: c, onTouchStart: n, children: g });
}), __extends = /* @__PURE__ */ (function() {
  var o = function(E, A) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(g, e) {
      g.__proto__ = e;
    } || function(g, e) {
      for (var t in e) Object.prototype.hasOwnProperty.call(e, t) && (g[t] = e[t]);
    }, o(E, A);
  };
  return function(E, A) {
    if (typeof A != "function" && A !== null)
      throw new TypeError("Class extends value " + String(A) + " is not a constructor or null");
    o(E, A);
    function g() {
      this.constructor = E;
    }
    E.prototype = A === null ? Object.create(A) : (g.prototype = A.prototype, new g());
  };
})(), __assign = function() {
  return __assign = Object.assign || function(o) {
    for (var E, A = 1, g = arguments.length; A < g; A++) {
      E = arguments[A];
      for (var e in E) Object.prototype.hasOwnProperty.call(E, e) && (o[e] = E[e]);
    }
    return o;
  }, __assign.apply(this, arguments);
}, DEFAULT_SIZE = {
  width: "auto",
  height: "auto"
}, clamp = function(o, E, A) {
  return Math.max(Math.min(o, A), E);
}, snap = function(o, E, A) {
  var g = Math.round(o / E);
  return g * E + A * (g - 1);
}, hasDirection = function(o, E) {
  return new RegExp(o, "i").test(E);
}, isTouchEvent = function(o) {
  return !!(o.touches && o.touches.length);
}, isMouseEvent = function(o) {
  return !!((o.clientX || o.clientX === 0) && (o.clientY || o.clientY === 0));
}, findClosestSnap = function(o, E, A) {
  A === void 0 && (A = 0);
  var g = E.reduce(function(t, c, n) {
    return Math.abs(c - o) < Math.abs(E[t] - o) ? n : t;
  }, 0), e = Math.abs(E[g] - o);
  return A === 0 || e < A ? E[g] : o;
}, getStringSize = function(o) {
  return o = o.toString(), o === "auto" || o.endsWith("px") || o.endsWith("%") || o.endsWith("vh") || o.endsWith("vw") || o.endsWith("vmax") || o.endsWith("vmin") ? o : "".concat(o, "px");
}, getPixelSize = function(o, E, A, g) {
  if (o && typeof o == "string") {
    if (o.endsWith("px"))
      return Number(o.replace("px", ""));
    if (o.endsWith("%")) {
      var e = Number(o.replace("%", "")) / 100;
      return E * e;
    }
    if (o.endsWith("vw")) {
      var e = Number(o.replace("vw", "")) / 100;
      return A * e;
    }
    if (o.endsWith("vh")) {
      var e = Number(o.replace("vh", "")) / 100;
      return g * e;
    }
  }
  return o;
}, calculateNewMax = function(o, E, A, g, e, t, c) {
  return g = getPixelSize(g, o.width, E, A), e = getPixelSize(e, o.height, E, A), t = getPixelSize(t, o.width, E, A), c = getPixelSize(c, o.height, E, A), {
    maxWidth: typeof g > "u" ? void 0 : Number(g),
    maxHeight: typeof e > "u" ? void 0 : Number(e),
    minWidth: typeof t > "u" ? void 0 : Number(t),
    minHeight: typeof c > "u" ? void 0 : Number(c)
  };
}, normalizeToPair = function(o) {
  return Array.isArray(o) ? o : [o, o];
}, definedProps = [
  "as",
  "ref",
  "style",
  "className",
  "grid",
  "gridGap",
  "snap",
  "bounds",
  "boundsByDirection",
  "size",
  "defaultSize",
  "minWidth",
  "minHeight",
  "maxWidth",
  "maxHeight",
  "lockAspectRatio",
  "lockAspectRatioExtraWidth",
  "lockAspectRatioExtraHeight",
  "enable",
  "handleStyles",
  "handleClasses",
  "handleWrapperStyle",
  "handleWrapperClass",
  "children",
  "onResizeStart",
  "onResize",
  "onResizeStop",
  "handleComponent",
  "scale",
  "resizeRatio",
  "snapGap"
], baseClassName = "__resizable_base__", Resizable = (
  /** @class */
  (function(o) {
    __extends(E, o);
    function E(A) {
      var g, e, t, c, n = o.call(this, A) || this;
      return n.ratio = 1, n.resizable = null, n.parentLeft = 0, n.parentTop = 0, n.resizableLeft = 0, n.resizableRight = 0, n.resizableTop = 0, n.resizableBottom = 0, n.targetLeft = 0, n.targetTop = 0, n.delta = {
        width: 0,
        height: 0
      }, n.appendBase = function() {
        if (!n.resizable || !n.window)
          return null;
        var h = n.parentNode;
        if (!h)
          return null;
        var d = n.window.document.createElement("div");
        return d.style.width = "100%", d.style.height = "100%", d.style.position = "absolute", d.style.transform = "scale(0, 0)", d.style.left = "0", d.style.flex = "0 0 100%", d.classList ? d.classList.add(baseClassName) : d.className += baseClassName, h.appendChild(d), d;
      }, n.removeBase = function(h) {
        var d = n.parentNode;
        d && d.removeChild(h);
      }, n.state = {
        isResizing: !1,
        width: (e = (g = n.propsSize) === null || g === void 0 ? void 0 : g.width) !== null && e !== void 0 ? e : "auto",
        height: (c = (t = n.propsSize) === null || t === void 0 ? void 0 : t.height) !== null && c !== void 0 ? c : "auto",
        direction: "right",
        original: {
          x: 0,
          y: 0,
          width: 0,
          height: 0
        },
        backgroundStyle: {
          height: "100%",
          width: "100%",
          backgroundColor: "rgba(0,0,0,0)",
          cursor: "auto",
          opacity: 0,
          position: "fixed",
          zIndex: 9999,
          top: "0",
          left: "0",
          bottom: "0",
          right: "0"
        },
        flexBasis: void 0
      }, n.onResizeStart = n.onResizeStart.bind(n), n.onMouseMove = n.onMouseMove.bind(n), n.onMouseUp = n.onMouseUp.bind(n), n;
    }
    return Object.defineProperty(E.prototype, "parentNode", {
      get: function() {
        return this.resizable ? this.resizable.parentNode : null;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(E.prototype, "window", {
      get: function() {
        return !this.resizable || !this.resizable.ownerDocument ? null : this.resizable.ownerDocument.defaultView;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(E.prototype, "propsSize", {
      get: function() {
        return this.props.size || this.props.defaultSize || DEFAULT_SIZE;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(E.prototype, "size", {
      get: function() {
        var A = 0, g = 0;
        if (this.resizable && this.window) {
          var e = this.resizable.offsetWidth, t = this.resizable.offsetHeight, c = this.resizable.style.position;
          c !== "relative" && (this.resizable.style.position = "relative"), A = this.resizable.style.width !== "auto" ? this.resizable.offsetWidth : e, g = this.resizable.style.height !== "auto" ? this.resizable.offsetHeight : t, this.resizable.style.position = c;
        }
        return { width: A, height: g };
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(E.prototype, "sizeStyle", {
      get: function() {
        var A = this, g = this.props.size, e = function(n) {
          var h;
          if (typeof A.state[n] > "u" || A.state[n] === "auto")
            return "auto";
          if (A.propsSize && A.propsSize[n] && (!((h = A.propsSize[n]) === null || h === void 0) && h.toString().endsWith("%"))) {
            if (A.state[n].toString().endsWith("%"))
              return A.state[n].toString();
            var d = A.getParentSize(), k = Number(A.state[n].toString().replace("px", "")), p = k / d[n] * 100;
            return "".concat(p, "%");
          }
          return getStringSize(A.state[n]);
        }, t = g && typeof g.width < "u" && !this.state.isResizing ? getStringSize(g.width) : e("width"), c = g && typeof g.height < "u" && !this.state.isResizing ? getStringSize(g.height) : e("height");
        return { width: t, height: c };
      },
      enumerable: !1,
      configurable: !0
    }), E.prototype.getParentSize = function() {
      if (!this.parentNode)
        return this.window ? { width: this.window.innerWidth, height: this.window.innerHeight } : { width: 0, height: 0 };
      var A = this.appendBase();
      if (!A)
        return { width: 0, height: 0 };
      var g = !1, e = this.parentNode.style.flexWrap;
      e !== "wrap" && (g = !0, this.parentNode.style.flexWrap = "wrap"), A.style.position = "relative", A.style.minWidth = "100%", A.style.minHeight = "100%";
      var t = {
        width: A.offsetWidth,
        height: A.offsetHeight
      };
      return g && (this.parentNode.style.flexWrap = e), this.removeBase(A), t;
    }, E.prototype.bindEvents = function() {
      this.window && (this.window.addEventListener("mouseup", this.onMouseUp), this.window.addEventListener("mousemove", this.onMouseMove), this.window.addEventListener("mouseleave", this.onMouseUp), this.window.addEventListener("touchmove", this.onMouseMove, {
        capture: !0,
        passive: !1
      }), this.window.addEventListener("touchend", this.onMouseUp));
    }, E.prototype.unbindEvents = function() {
      this.window && (this.window.removeEventListener("mouseup", this.onMouseUp), this.window.removeEventListener("mousemove", this.onMouseMove), this.window.removeEventListener("mouseleave", this.onMouseUp), this.window.removeEventListener("touchmove", this.onMouseMove, !0), this.window.removeEventListener("touchend", this.onMouseUp));
    }, E.prototype.componentDidMount = function() {
      if (!(!this.resizable || !this.window)) {
        var A = this.window.getComputedStyle(this.resizable);
        this.setState({
          width: this.state.width || this.size.width,
          height: this.state.height || this.size.height,
          flexBasis: A.flexBasis !== "auto" ? A.flexBasis : void 0
        });
      }
    }, E.prototype.componentWillUnmount = function() {
      this.window && this.unbindEvents();
    }, E.prototype.createSizeForCssProperty = function(A, g) {
      var e = this.propsSize && this.propsSize[g];
      return this.state[g] === "auto" && this.state.original[g] === A && (typeof e > "u" || e === "auto") ? "auto" : A;
    }, E.prototype.calculateNewMaxFromBoundary = function(A, g) {
      var e = this.props.boundsByDirection, t = this.state.direction, c = e && hasDirection("left", t), n = e && hasDirection("top", t), h, d;
      if (this.props.bounds === "parent") {
        var k = this.parentNode;
        k && (h = c ? this.resizableRight - this.parentLeft : k.offsetWidth + (this.parentLeft - this.resizableLeft), d = n ? this.resizableBottom - this.parentTop : k.offsetHeight + (this.parentTop - this.resizableTop));
      } else this.props.bounds === "window" ? this.window && (h = c ? this.resizableRight : this.window.innerWidth - this.resizableLeft, d = n ? this.resizableBottom : this.window.innerHeight - this.resizableTop) : this.props.bounds && (h = c ? this.resizableRight - this.targetLeft : this.props.bounds.offsetWidth + (this.targetLeft - this.resizableLeft), d = n ? this.resizableBottom - this.targetTop : this.props.bounds.offsetHeight + (this.targetTop - this.resizableTop));
      return h && Number.isFinite(h) && (A = A && A < h ? A : h), d && Number.isFinite(d) && (g = g && g < d ? g : d), { maxWidth: A, maxHeight: g };
    }, E.prototype.calculateNewSizeFromDirection = function(A, g) {
      var e = this.props.scale || 1, t = normalizeToPair(this.props.resizeRatio || 1), c = t[0], n = t[1], h = this.state, d = h.direction, k = h.original, p = this.props, M = p.lockAspectRatio, S = p.lockAspectRatioExtraHeight, AA = p.lockAspectRatioExtraWidth, H = k.width, gA = k.height, CA = S || 0, IA = AA || 0;
      return hasDirection("right", d) && (H = k.width + (A - k.x) * c / e, M && (gA = (H - IA) / this.ratio + CA)), hasDirection("left", d) && (H = k.width - (A - k.x) * c / e, M && (gA = (H - IA) / this.ratio + CA)), hasDirection("bottom", d) && (gA = k.height + (g - k.y) * n / e, M && (H = (gA - CA) * this.ratio + IA)), hasDirection("top", d) && (gA = k.height - (g - k.y) * n / e, M && (H = (gA - CA) * this.ratio + IA)), { newWidth: H, newHeight: gA };
    }, E.prototype.calculateNewSizeFromAspectRatio = function(A, g, e, t) {
      var c = this.props, n = c.lockAspectRatio, h = c.lockAspectRatioExtraHeight, d = c.lockAspectRatioExtraWidth, k = typeof t.width > "u" ? 10 : t.width, p = typeof e.width > "u" || e.width < 0 ? A : e.width, M = typeof t.height > "u" ? 10 : t.height, S = typeof e.height > "u" || e.height < 0 ? g : e.height, AA = h || 0, H = d || 0;
      if (n) {
        var gA = (M - AA) * this.ratio + H, CA = (S - AA) * this.ratio + H, IA = (k - H) / this.ratio + AA, BA = (p - H) / this.ratio + AA, QA = Math.max(k, gA), EA = Math.min(p, CA), oA = Math.max(M, IA), iA = Math.min(S, BA);
        A = clamp(A, QA, EA), g = clamp(g, oA, iA);
      } else
        A = clamp(A, k, p), g = clamp(g, M, S);
      return { newWidth: A, newHeight: g };
    }, E.prototype.setBoundingClientRect = function() {
      var A = 1 / (this.props.scale || 1);
      if (this.props.bounds === "parent") {
        var g = this.parentNode;
        if (g) {
          var e = g.getBoundingClientRect();
          this.parentLeft = e.left * A, this.parentTop = e.top * A;
        }
      }
      if (this.props.bounds && typeof this.props.bounds != "string") {
        var t = this.props.bounds.getBoundingClientRect();
        this.targetLeft = t.left * A, this.targetTop = t.top * A;
      }
      if (this.resizable) {
        var c = this.resizable.getBoundingClientRect(), n = c.left, h = c.top, d = c.right, k = c.bottom;
        this.resizableLeft = n * A, this.resizableRight = d * A, this.resizableTop = h * A, this.resizableBottom = k * A;
      }
    }, E.prototype.onResizeStart = function(A, g) {
      if (!(!this.resizable || !this.window)) {
        var e = 0, t = 0;
        if (A.nativeEvent && isMouseEvent(A.nativeEvent) ? (e = A.nativeEvent.clientX, t = A.nativeEvent.clientY) : A.nativeEvent && isTouchEvent(A.nativeEvent) && (e = A.nativeEvent.touches[0].clientX, t = A.nativeEvent.touches[0].clientY), this.props.onResizeStart && this.resizable) {
          var c = this.props.onResizeStart(A, g, this.resizable);
          if (c === !1)
            return;
        }
        this.props.size && (typeof this.props.size.height < "u" && this.props.size.height !== this.state.height && this.setState({ height: this.props.size.height }), typeof this.props.size.width < "u" && this.props.size.width !== this.state.width && this.setState({ width: this.props.size.width })), this.ratio = typeof this.props.lockAspectRatio == "number" ? this.props.lockAspectRatio : this.size.width / this.size.height;
        var n, h = this.window.getComputedStyle(this.resizable);
        if (h.flexBasis !== "auto") {
          var d = this.parentNode;
          if (d) {
            var k = this.window.getComputedStyle(d).flexDirection;
            this.flexDir = k.startsWith("row") ? "row" : "column", n = h.flexBasis;
          }
        }
        this.setBoundingClientRect(), this.bindEvents();
        var p = {
          original: {
            x: e,
            y: t,
            width: this.size.width,
            height: this.size.height
          },
          isResizing: !0,
          backgroundStyle: __assign(__assign({}, this.state.backgroundStyle), { cursor: this.window.getComputedStyle(A.target).cursor || "auto" }),
          direction: g,
          flexBasis: n
        };
        this.setState(p);
      }
    }, E.prototype.onMouseMove = function(A) {
      var g = this;
      if (!(!this.state.isResizing || !this.resizable || !this.window)) {
        if (this.window.TouchEvent && isTouchEvent(A))
          try {
            A.preventDefault(), A.stopPropagation();
          } catch {
          }
        var e = this.props, t = e.maxWidth, c = e.maxHeight, n = e.minWidth, h = e.minHeight, d = isTouchEvent(A) ? A.touches[0].clientX : A.clientX, k = isTouchEvent(A) ? A.touches[0].clientY : A.clientY, p = this.state, M = p.direction, S = p.original, AA = p.width, H = p.height, gA = this.getParentSize(), CA = calculateNewMax(gA, this.window.innerWidth, this.window.innerHeight, t, c, n, h);
        t = CA.maxWidth, c = CA.maxHeight, n = CA.minWidth, h = CA.minHeight;
        var IA = this.calculateNewSizeFromDirection(d, k), BA = IA.newHeight, QA = IA.newWidth, EA = this.calculateNewMaxFromBoundary(t, c);
        this.props.snap && this.props.snap.x && (QA = findClosestSnap(QA, this.props.snap.x, this.props.snapGap)), this.props.snap && this.props.snap.y && (BA = findClosestSnap(BA, this.props.snap.y, this.props.snapGap));
        var oA = this.calculateNewSizeFromAspectRatio(QA, BA, { width: EA.maxWidth, height: EA.maxHeight }, { width: n, height: h });
        if (QA = oA.newWidth, BA = oA.newHeight, this.props.grid) {
          var iA = snap(QA, this.props.grid[0], this.props.gridGap ? this.props.gridGap[0] : 0), aA = snap(BA, this.props.grid[1], this.props.gridGap ? this.props.gridGap[1] : 0), tA = this.props.snapGap || 0, eA = tA === 0 || Math.abs(iA - QA) <= tA ? iA : QA, cA = tA === 0 || Math.abs(aA - BA) <= tA ? aA : BA;
          QA = eA, BA = cA;
        }
        var DA = {
          width: QA - S.width,
          height: BA - S.height
        };
        if (this.delta = DA, AA && typeof AA == "string") {
          if (AA.endsWith("%")) {
            var nA = QA / gA.width * 100;
            QA = "".concat(nA, "%");
          } else if (AA.endsWith("vw")) {
            var wA = QA / this.window.innerWidth * 100;
            QA = "".concat(wA, "vw");
          } else if (AA.endsWith("vh")) {
            var lA = QA / this.window.innerHeight * 100;
            QA = "".concat(lA, "vh");
          }
        }
        if (H && typeof H == "string") {
          if (H.endsWith("%")) {
            var nA = BA / gA.height * 100;
            BA = "".concat(nA, "%");
          } else if (H.endsWith("vw")) {
            var wA = BA / this.window.innerWidth * 100;
            BA = "".concat(wA, "vw");
          } else if (H.endsWith("vh")) {
            var lA = BA / this.window.innerHeight * 100;
            BA = "".concat(lA, "vh");
          }
        }
        var NA = {
          width: this.createSizeForCssProperty(QA, "width"),
          height: this.createSizeForCssProperty(BA, "height")
        };
        this.flexDir === "row" ? NA.flexBasis = NA.width : this.flexDir === "column" && (NA.flexBasis = NA.height);
        var RA = this.state.width !== NA.width, KA = this.state.height !== NA.height, vA = this.state.flexBasis !== NA.flexBasis, GA = RA || KA || vA;
        GA && flushSync(function() {
          g.setState(NA);
        }), this.props.onResize && GA && this.props.onResize(A, M, this.resizable, DA);
      }
    }, E.prototype.onMouseUp = function(A) {
      var g, e, t = this.state, c = t.isResizing, n = t.direction;
      t.original, !(!c || !this.resizable) && (this.props.onResizeStop && this.props.onResizeStop(A, n, this.resizable, this.delta), this.props.size && this.setState({ width: (g = this.props.size.width) !== null && g !== void 0 ? g : "auto", height: (e = this.props.size.height) !== null && e !== void 0 ? e : "auto" }), this.unbindEvents(), this.setState({
        isResizing: !1,
        backgroundStyle: __assign(__assign({}, this.state.backgroundStyle), { cursor: "auto" })
      }));
    }, E.prototype.updateSize = function(A) {
      var g, e;
      this.setState({ width: (g = A.width) !== null && g !== void 0 ? g : "auto", height: (e = A.height) !== null && e !== void 0 ? e : "auto" });
    }, E.prototype.renderResizer = function() {
      var A = this, g = this.props, e = g.enable, t = g.handleStyles, c = g.handleClasses, n = g.handleWrapperStyle, h = g.handleWrapperClass, d = g.handleComponent;
      if (!e)
        return null;
      var k = Object.keys(e).map(function(p) {
        return e[p] !== !1 ? jsxRuntimeExports.jsx(Resizer, { direction: p, onResizeStart: A.onResizeStart, replaceStyles: t && t[p], className: c && c[p], children: d && d[p] ? d[p] : null }, p) : null;
      });
      return jsxRuntimeExports.jsx("div", { className: h, style: n, children: k });
    }, E.prototype.render = function() {
      var A = this, g = Object.keys(this.props).reduce(function(c, n) {
        return definedProps.indexOf(n) !== -1 || (c[n] = A.props[n]), c;
      }, {}), e = __assign(__assign(__assign({ position: "relative", userSelect: this.state.isResizing ? "none" : "auto" }, this.props.style), this.sizeStyle), { maxWidth: this.props.maxWidth, maxHeight: this.props.maxHeight, minWidth: this.props.minWidth, minHeight: this.props.minHeight, boxSizing: "border-box", flexShrink: 0 });
      this.state.flexBasis && (e.flexBasis = this.state.flexBasis);
      var t = this.props.as || "div";
      return jsxRuntimeExports.jsxs(t, __assign({ style: e, className: this.props.className }, g, {
        // `ref` is after `extendsProps` to ensure this one wins over a version
        // passed in
        ref: function(c) {
          c && (A.resizable = c);
        },
        children: [this.state.isResizing && jsxRuntimeExports.jsx("div", { style: this.state.backgroundStyle }), this.props.children, this.renderResizer()]
      }));
    }, E.defaultProps = {
      as: "div",
      onResizeStart: function() {
      },
      onResize: function() {
      },
      onResizeStop: function() {
      },
      enable: {
        top: !0,
        right: !0,
        bottom: !0,
        left: !0,
        topRight: !0,
        bottomRight: !0,
        bottomLeft: !0,
        topLeft: !0
      },
      style: {},
      grid: [1, 1],
      gridGap: [0, 0],
      lockAspectRatio: !1,
      lockAspectRatioExtraWidth: 0,
      lockAspectRatioExtraHeight: 0,
      scale: 1,
      resizeRatio: 1,
      snapGap: 0
    }, E;
  })(PureComponent)
);
const DEFAULT_WIDTH = "256";
function calculateMaxBreakpoint(o) {
  return parseInt(o, 10) - 0.02;
}
const Sidebar = ({
  endpoints: o,
  children: E,
  hasElements: A,
  isCollapsed: g,
  onToggleCollapse: e,
  widgetsDisabled: t
}) => {
  const c = useEmotionTheme(), n = calculateMaxBreakpoint(c.breakpoints.md), {
    innerWidth: h
  } = useWindowDimensionsContext(), {
    appPages: d,
    navSections: k
  } = useContext(NavigationContext), {
    hideSidebarNav: p,
    appLogo: M
  } = useContext(SidebarConfigContext), S = useScrollbarGutterSize(), AA = useRef(null), H = localStorageAvailable() ? window.localStorage.getItem("sidebarWidth") : void 0, [gA, CA] = useState(H || DEFAULT_WIDTH), [IA, BA] = useState(h ?? 1 / 0), [QA, EA] = useState(!1), oA = useCallback(() => {
    EA(!0);
  }, []), iA = useCallback(() => {
    EA(!1);
  }, []), aA = useCallback((wA) => {
    const lA = wA.toString();
    CA(lA), localStorageAvailable() && window.localStorage.setItem("sidebarWidth", lA);
  }, []), tA = useCallback((wA, lA, NA, RA) => {
    if (NA) {
      const KA = NA.clientWidth || NA.offsetWidth;
      aA(KA);
    }
  }, [aA]);
  useExecuteWhenChanged(() => {
    h < IA && h <= n && (g || e(!0, !1)), BA(h);
  }, [h]), useEffect(() => {
    const wA = (lA) => {
      if (AA && window) {
        const {
          current: NA
        } = AA;
        NA && !NA.contains(lA.target) && h <= n && (g || e(!0));
      }
    };
    return document.addEventListener("mousedown", wA), () => {
      document.removeEventListener("mousedown", wA);
    };
  }, [IA, n, g, e, h]);
  function eA() {
    CA(DEFAULT_WIDTH), localStorageAvailable() && window.localStorage.setItem("sidebarWidth", DEFAULT_WIDTH);
  }
  const cA = useCallback(() => {
    e(!g);
  }, [g, e]), DA = () => M ? /* @__PURE__ */ jsxRuntimeExports.jsx(LogoComponent, { appLogo: M, endpoints: o, collapsed: g, componentName: "Sidebar Logo", dataTestId: "stSidebarLogo" }) : /* @__PURE__ */ jsxRuntimeExports.jsx(StyledNoLogoSpacer, { "data-testid": "stLogoSpacer" }), nA = shouldShowNavigation(d, k) && !p;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Resizable,
    {
      className: "stSidebar",
      "data-testid": "stSidebar",
      "aria-expanded": !g,
      enable: {
        top: !1,
        right: !0,
        bottom: !1,
        left: !1
      },
      handleStyles: {
        right: {
          width: RESIZE_HANDLE_WIDTH,
          right: "-6px"
        }
      },
      handleComponent: {
        right: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledResizeHandle, { onDoubleClick: eA })
      },
      size: {
        width: gA,
        height: "auto"
      },
      as: StyledSidebar,
      onResizeStop: tA,
      isCollapsed: g,
      sidebarWidth: gA,
      windowInnerWidth: h,
      children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledSidebarContent, { "data-testid": "stSidebarContent", ref: AA, onMouseOver: oA, onMouseOut: iA, scrollbarGutterSize: S, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledSidebarHeaderContainer, { "data-testid": "stSidebarHeader", children: [
          DA(),
          /* @__PURE__ */ jsxRuntimeExports.jsx(StyledCollapseSidebarButton, { showSidebarCollapse: QA, "data-testid": "stSidebarCollapseButton", children: /* @__PURE__ */ jsxRuntimeExports.jsx(BaseButton, { kind: BaseButtonKind.HEADER_NO_PADDING, onClick: cA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(DynamicIcon, { size: "xl", iconValue: ":material/keyboard_double_arrow_left:", color: c.colors.fadedText60 }) }) })
        ] }),
        nA && /* @__PURE__ */ jsxRuntimeExports.jsx(SidebarNav, { endpoints: o, collapseSidebar: cA, hasSidebarElements: A, widgetsDisabled: t }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(StyledSidebarUserContent, { hasPageNavAbove: nA, "data-testid": "stSidebarUserContent", children: E })
      ] })
    }
  );
};
function SidebarWithProvider(o) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(IsSidebarContext.Provider, { value: !0, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Sidebar, { ...o }) });
}
const ThemedSidebar = ({
  children: o,
  ...E
}) => {
  const {
    activeTheme: A
  } = useContext(ThemeContext), g = createSidebarTheme(A);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ThemeProvider, { theme: g.emotion, baseuiTheme: g.basewebTheme, children: /* @__PURE__ */ jsxRuntimeExports.jsx(SidebarWithProvider, { ...E, children: o }) });
};
function shouldCollapse(o, E, A) {
  switch (o) {
    case PageConfig.SidebarState.EXPANDED:
      return !1;
    case PageConfig.SidebarState.COLLAPSED:
      return !0;
    case PageConfig.SidebarState.AUTO:
    default:
      return A <= E;
  }
}
const getSidebarCollapsedKey = (o) => `stSidebarCollapsed-${o}`, getSavedSidebarState = (o) => {
  if (!localStorageAvailable())
    return null;
  const E = window.localStorage.getItem(getSidebarCollapsedKey(o));
  return E === null ? null : E === "true";
}, saveSidebarState = (o, E) => {
  localStorageAvailable() && window.localStorage.setItem(getSidebarCollapsedKey(o), E.toString());
};
function _EMOTION_STRINGIFIED_CSS_ERROR__$7() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const StyledAppViewContainer = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "ea3mdgi10"
} : {
  target: "ea3mdgi10",
  label: "StyledAppViewContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "1yiq2ps",
  styles: "display:flex;flex-direction:row;justify-content:flex-start;align-items:stretch;align-content:flex-start;position:absolute;top:0;left:0;right:0;bottom:0;overflow:hidden;@media print{overflow:visible;}"
} : {
  name: "1yiq2ps",
  styles: "display:flex;flex-direction:row;justify-content:flex-start;align-items:stretch;align-content:flex-start;position:absolute;top:0;left:0;right:0;bottom:0;overflow:hidden;@media print{overflow:visible;}/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$7
}), StyledAppViewMain = /* @__PURE__ */ createStyled("section", process.env.NODE_ENV === "production" ? {
  target: "ea3mdgi9"
} : {
  target: "ea3mdgi9",
  label: "StyledAppViewMain"
})(({
  disableScrolling: o,
  theme: E
}) => ({
  display: "flex",
  flexDirection: "column",
  width: E.sizes.full,
  overflow: o ? "hidden" : "auto",
  alignItems: "center",
  height: "100dvh",
  "&:focus": {
    outline: "none"
  },
  // Added so sidebar overlays main app content on
  // smaller screen sizes, except when printing
  "@media not print": {
    [`@media (max-width: ${E.breakpoints.md})`]: {
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      height: "100dvh"
    }
  },
  "@media print": {
    // print multiple pages if app is scrollable in Safari
    overflow: "visible"
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledStickyBottomContainer = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "ea3mdgi8"
} : {
  target: "ea3mdgi8",
  label: "StyledStickyBottomContainer"
})(({
  theme: o
}) => ({
  position: "sticky",
  left: 0,
  bottom: 0,
  width: "100%",
  zIndex: o.zIndices.bottom,
  // move the bottom container to the end of pages in print-mode so that nothing
  // (e.g. a floating chat-input) overlays the actual app content
  "@media print": {
    position: "static"
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2FwcC9zcmMvY29tcG9uZW50cy9BcHBWaWV3L3N0eWxlZC1jb21wb25lbnRzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQTZFMkMiLCJmaWxlIjoiL2hvbWUvcnVubmVyL3dvcmsvc3RsaXRlL3N0bGl0ZS9zdHJlYW1saXQvZnJvbnRlbmQvYXBwL3NyYy9jb21wb25lbnRzL0FwcFZpZXcvc3R5bGVkLWNvbXBvbmVudHMudHMiLCJzb3VyY2VzQ29udGVudCI6WyIvKipcbiAqIENvcHlyaWdodCAoYykgU3RyZWFtbGl0IEluYy4gKDIwMTgtMjAyMikgU25vd2ZsYWtlIEluYy4gKDIwMjItMjAyNSlcbiAqXG4gKiBMaWNlbnNlZCB1bmRlciB0aGUgQXBhY2hlIExpY2Vuc2UsIFZlcnNpb24gMi4wICh0aGUgXCJMaWNlbnNlXCIpO1xuICogeW91IG1heSBub3QgdXNlIHRoaXMgZmlsZSBleGNlcHQgaW4gY29tcGxpYW5jZSB3aXRoIHRoZSBMaWNlbnNlLlxuICogWW91IG1heSBvYnRhaW4gYSBjb3B5IG9mIHRoZSBMaWNlbnNlIGF0XG4gKlxuICogICAgIGh0dHA6Ly93d3cuYXBhY2hlLm9yZy9saWNlbnNlcy9MSUNFTlNFLTIuMFxuICpcbiAqIFVubGVzcyByZXF1aXJlZCBieSBhcHBsaWNhYmxlIGxhdyBvciBhZ3JlZWQgdG8gaW4gd3JpdGluZywgc29mdHdhcmVcbiAqIGRpc3RyaWJ1dGVkIHVuZGVyIHRoZSBMaWNlbnNlIGlzIGRpc3RyaWJ1dGVkIG9uIGFuIFwiQVMgSVNcIiBCQVNJUyxcbiAqIFdJVEhPVVQgV0FSUkFOVElFUyBPUiBDT05ESVRJT05TIE9GIEFOWSBLSU5ELCBlaXRoZXIgZXhwcmVzcyBvciBpbXBsaWVkLlxuICogU2VlIHRoZSBMaWNlbnNlIGZvciB0aGUgc3BlY2lmaWMgbGFuZ3VhZ2UgZ292ZXJuaW5nIHBlcm1pc3Npb25zIGFuZFxuICogbGltaXRhdGlvbnMgdW5kZXIgdGhlIExpY2Vuc2UuXG4gKi9cblxuaW1wb3J0IHN0eWxlZCwgeyBDU1NPYmplY3QgfSBmcm9tIFwiQGVtb3Rpb24vc3R5bGVkXCJcblxuaW1wb3J0IHsgRW1vdGlvblRoZW1lIH0gZnJvbSBcIkBzdHJlYW1saXQvbGliXCJcblxuZXhwb3J0IGNvbnN0IFN0eWxlZEFwcFZpZXdDb250YWluZXIgPSBzdHlsZWQuZGl2KHtcbiAgZGlzcGxheTogXCJmbGV4XCIsXG4gIGZsZXhEaXJlY3Rpb246IFwicm93XCIsXG4gIGp1c3RpZnlDb250ZW50OiBcImZsZXgtc3RhcnRcIixcbiAgYWxpZ25JdGVtczogXCJzdHJldGNoXCIsXG4gIGFsaWduQ29udGVudDogXCJmbGV4LXN0YXJ0XCIsXG4gIHBvc2l0aW9uOiBcImFic29sdXRlXCIsXG4gIHRvcDogMCxcbiAgbGVmdDogMCxcbiAgcmlnaHQ6IDAsXG4gIGJvdHRvbTogMCxcbiAgb3ZlcmZsb3c6IFwiaGlkZGVuXCIsXG5cbiAgXCJAbWVkaWEgcHJpbnRcIjoge1xuICAgIC8vIHByaW50IG11bHRpcGxlIHBhZ2VzIGlmIGFwcCBpcyBzY3JvbGxhYmxlIGluIFNhZmFyaVxuICAgIG92ZXJmbG93OiBcInZpc2libGVcIixcbiAgfSxcbn0pXG5cbmV4cG9ydCBpbnRlcmZhY2UgU3R5bGVkQXBwVmlld01haW5Qcm9wcyB7XG4gIGlzRW1iZWRkZWQ6IGJvb2xlYW5cbiAgZGlzYWJsZVNjcm9sbGluZzogYm9vbGVhblxufVxuXG5leHBvcnQgY29uc3QgU3R5bGVkQXBwVmlld01haW4gPSBzdHlsZWQuc2VjdGlvbjxTdHlsZWRBcHBWaWV3TWFpblByb3BzPihcbiAgKHsgZGlzYWJsZVNjcm9sbGluZywgdGhlbWUgfSkgPT4gKHtcbiAgICBkaXNwbGF5OiBcImZsZXhcIixcbiAgICBmbGV4RGlyZWN0aW9uOiBcImNvbHVtblwiLFxuICAgIHdpZHRoOiB0aGVtZS5zaXplcy5mdWxsLFxuICAgIG92ZXJmbG93OiBkaXNhYmxlU2Nyb2xsaW5nID8gXCJoaWRkZW5cIiA6IFwiYXV0b1wiLFxuICAgIGFsaWduSXRlbXM6IFwiY2VudGVyXCIsXG4gICAgaGVpZ2h0OiBgMTAwZHZoYCxcblxuICAgIFwiJjpmb2N1c1wiOiB7XG4gICAgICBvdXRsaW5lOiBcIm5vbmVcIixcbiAgICB9LFxuXG4gICAgLy8gQWRkZWQgc28gc2lkZWJhciBvdmVybGF5cyBtYWluIGFwcCBjb250ZW50IG9uXG4gICAgLy8gc21hbGxlciBzY3JlZW4gc2l6ZXMsIGV4Y2VwdCB3aGVuIHByaW50aW5nXG4gICAgXCJAbWVkaWEgbm90IHByaW50XCI6IHtcbiAgICAgIFtgQG1lZGlhIChtYXgtd2lkdGg6ICR7dGhlbWUuYnJlYWtwb2ludHMubWR9KWBdOiB7XG4gICAgICAgIHBvc2l0aW9uOiBcImFic29sdXRlXCIsXG4gICAgICAgIHRvcDogMCxcbiAgICAgICAgbGVmdDogMCxcbiAgICAgICAgcmlnaHQ6IDAsXG4gICAgICAgIGJvdHRvbTogMCxcbiAgICAgICAgaGVpZ2h0OiBgMTAwZHZoYCxcbiAgICAgIH0sXG4gICAgfSxcblxuICAgIFwiQG1lZGlhIHByaW50XCI6IHtcbiAgICAgIC8vIHByaW50IG11bHRpcGxlIHBhZ2VzIGlmIGFwcCBpcyBzY3JvbGxhYmxlIGluIFNhZmFyaVxuICAgICAgb3ZlcmZsb3c6IFwidmlzaWJsZVwiLFxuICAgIH0sXG4gIH0pXG4pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRTdGlja3lCb3R0b21Db250YWluZXIgPSBzdHlsZWQuZGl2KCh7IHRoZW1lIH0pID0+ICh7XG4gIHBvc2l0aW9uOiBcInN0aWNreVwiLFxuICBsZWZ0OiAwLFxuICBib3R0b206IDAsXG4gIHdpZHRoOiBcIjEwMCVcIixcbiAgekluZGV4OiB0aGVtZS56SW5kaWNlcy5ib3R0b20sXG5cbiAgLy8gbW92ZSB0aGUgYm90dG9tIGNvbnRhaW5lciB0byB0aGUgZW5kIG9mIHBhZ2VzIGluIHByaW50LW1vZGUgc28gdGhhdCBub3RoaW5nXG4gIC8vIChlLmcuIGEgZmxvYXRpbmcgY2hhdC1pbnB1dCkgb3ZlcmxheXMgdGhlIGFjdHVhbCBhcHAgY29udGVudFxuICBcIkBtZWRpYSBwcmludFwiOiB7XG4gICAgcG9zaXRpb246IFwic3RhdGljXCIsXG4gIH0sXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZElubmVyQm90dG9tQ29udGFpbmVyID0gc3R5bGVkLmRpdigoeyB0aGVtZSB9KSA9PiAoe1xuICBwb3NpdGlvbjogXCJyZWxhdGl2ZVwiLFxuICBib3R0b206IDAsXG4gIHdpZHRoOiBcIjEwMCVcIixcbiAgbWluV2lkdGg6IFwiMTAwJVwiLFxuICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5iZ0NvbG9yLFxuICBkaXNwbGF5OiBcImZsZXhcIixcbiAgZmxleERpcmVjdGlvbjogXCJjb2x1bW5cIixcbiAgYWxpZ25JdGVtczogXCJjZW50ZXJcIixcbn0pKVxuXG4vKipcbiAqIEFkZHMgdGhlIENTUyBxdWVyeSBmb3Igd2lkZSBtb2RlLlxuICovXG5jb25zdCBhcHBseVdpZGVNb2RlUGFkZGluZyA9ICh0aGVtZTogRW1vdGlvblRoZW1lKTogQ1NTT2JqZWN0ID0+IHtcbiAgcmV0dXJuIHtcbiAgICAvLyBJbmNyZWFzZSBzaWRlIHBhZGRpbmcsIGlmIGxheW91dCA9IHdpZGUgYW5kIHRoZSBzY3JlZW4gaXMgd2lkZSBlbm91Z2hcbiAgICAvLyBUaGUgY2FsY3VsYXRpb24gaXMgdXNlZCB0byBtYWtlIHN1cmUgdGhhdCB3aWRlIG1vZGUgYWx3YXlzIGhhcyB0aGUgc2FtZSBvciBsYXJnZXJcbiAgICAvLyBjb250ZW50IGNvbXBhcmVkIHRvIGNlbnRlcmVkIG1vZGUuXG4gICAgW2BAbWVkaWEgKG1pbi13aWR0aDogY2FsYygke3RoZW1lLnNpemVzLmNvbnRlbnRNYXhXaWR0aH0gKyAyICogKCR7dGhlbWUuc2l6ZXMud2lkZVNpZGVQYWRkaW5nfSAtICR7dGhlbWUuc3BhY2luZy5sZ30pKSlgXTpcbiAgICAgIHtcbiAgICAgICAgcGFkZGluZ0xlZnQ6IHRoZW1lLnNpemVzLndpZGVTaWRlUGFkZGluZyxcbiAgICAgICAgcGFkZGluZ1JpZ2h0OiB0aGVtZS5zaXplcy53aWRlU2lkZVBhZGRpbmcsXG4gICAgICB9LFxuICAgIG1pbldpZHRoOiBcImF1dG9cIixcbiAgICBtYXhXaWR0aDogXCJpbml0aWFsXCIsXG4gIH1cbn1cblxuZXhwb3J0IGludGVyZmFjZSBTdHlsZWRBcHBWaWV3QmxvY2tDb250YWluZXJQcm9wcyB7XG4gIGlzV2lkZU1vZGU6IGJvb2xlYW5cbiAgaGFzQm90dG9tOiBib29sZWFuXG4gIHNob3dQYWRkaW5nOiBib29sZWFuXG4gIGhhc0hlYWRlcjogYm9vbGVhblxuICBzaG93VG9vbGJhcjogYm9vbGVhblxuICBoYXNUb3BOYXY6IGJvb2xlYW5cbiAgaGFzU2lkZWJhcjogYm9vbGVhblxuICBlbWJlZGRlZDogYm9vbGVhblxufVxuXG5leHBvcnQgY29uc3QgU3R5bGVkQXBwVmlld0Jsb2NrQ29udGFpbmVyID1cbiAgc3R5bGVkLmRpdjxTdHlsZWRBcHBWaWV3QmxvY2tDb250YWluZXJQcm9wcz4oXG4gICAgKHtcbiAgICAgIGhhc0JvdHRvbSxcbiAgICAgIGlzV2lkZU1vZGUsXG4gICAgICBzaG93UGFkZGluZyxcbiAgICAgIGhhc0hlYWRlcixcbiAgICAgIHNob3dUb29sYmFyLFxuICAgICAgaGFzVG9wTmF2LFxuICAgICAgaGFzU2lkZWJhcixcbiAgICAgIGVtYmVkZGVkLFxuICAgICAgdGhlbWUsXG4gICAgfSkgPT4ge1xuICAgICAgY29uc3QgbGl0dGxlUGFkZGluZyA9IFwiMi4yNXJlbVwiXG5cbiAgICAgIC8vIFRvcCBwYWRkaW5nIGxvZ2ljIHBlciBzcGVjaWZpY2F0aW9uOlxuICAgICAgbGV0IHRvcFBhZGRpbmcgPSBsaXR0bGVQYWRkaW5nIC8vIERlZmF1bHQ6IDIuMjVyZW1cblxuICAgICAgaWYgKCFlbWJlZGRlZCkge1xuICAgICAgICAvLyBOb24tZW1iZWRkZWQgYXBwcyBhbHdheXMgZ2V0IDZyZW0gb3IgOHJlbVxuICAgICAgICB0b3BQYWRkaW5nID0gaGFzVG9wTmF2ID8gXCI4cmVtXCIgOiBcIjZyZW1cIlxuICAgICAgfSBlbHNlIGlmIChzaG93UGFkZGluZyB8fCBzaG93VG9vbGJhcikge1xuICAgICAgICAvLyA2cmVtIGlmIGVtYmVkZGVkIHdpdGggc2hvd19wYWRkaW5nIG9yIHNob3dfdG9vbGJhclxuICAgICAgICB0b3BQYWRkaW5nID0gXCI2cmVtXCJcbiAgICAgIH0gZWxzZSBpZiAoaGFzSGVhZGVyIHx8IGhhc1NpZGViYXIpIHtcbiAgICAgICAgLy8gNC41cmVtIGlmIGVtYmVkZGVkIHdpdGggaGVhZGVyIGJ1dCBubyBwYWRkaW5nL3Rvb2xiYXJcbiAgICAgICAgdG9wUGFkZGluZyA9IFwiNC41cmVtXCJcbiAgICAgIH1cbiAgICAgIC8vIE90aGVyd2lzZSB1c2UgZGVmYXVsdDogMi4yNXJlbSBpZiBlbWJlZGRlZCB3aXRoIG5vIGhlYWRlciBhbmQgbm8gcGFkZGluZy90b29sYmFyXG5cbiAgICAgIGNvbnN0IGJvdHRvbUVtYmVkUGFkZGluZyA9XG4gICAgICAgIHNob3dQYWRkaW5nICYmICFoYXNCb3R0b20gPyBcIjEwcmVtXCIgOiB0aGVtZS5zcGFjaW5nLmxnXG5cbiAgICAgIHJldHVybiB7XG4gICAgICAgIHdpZHRoOiB0aGVtZS5zaXplcy5mdWxsLFxuICAgICAgICBwYWRkaW5nTGVmdDogdGhlbWUuc3BhY2luZy5sZyxcbiAgICAgICAgcGFkZGluZ1JpZ2h0OiB0aGVtZS5zcGFjaW5nLmxnLFxuICAgICAgICBwYWRkaW5nVG9wOiB0b3BQYWRkaW5nLFxuICAgICAgICBwYWRkaW5nQm90dG9tOiBib3R0b21FbWJlZFBhZGRpbmcsXG4gICAgICAgIG1heFdpZHRoOiB0aGVtZS5zaXplcy5jb250ZW50TWF4V2lkdGgsXG4gICAgICAgIC4uLihpc1dpZGVNb2RlICYmIGFwcGx5V2lkZU1vZGVQYWRkaW5nKHRoZW1lKSksXG4gICAgICAgIFtgQG1lZGlhIHByaW50YF06IHtcbiAgICAgICAgICBwYWRkaW5nVG9wOiBsaXR0bGVQYWRkaW5nLFxuICAgICAgICB9LFxuICAgICAgfVxuICAgIH1cbiAgKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkU2lkZWJhckJsb2NrQ29udGFpbmVyID0gc3R5bGVkLmRpdigoeyB0aGVtZSB9KSA9PiB7XG4gIHJldHVybiB7XG4gICAgd2lkdGg6IHRoZW1lLnNpemVzLmZ1bGwsXG4gIH1cbn0pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRFdmVudEJsb2NrQ29udGFpbmVyID0gc3R5bGVkLmRpdih7XG4gIGRpc3BsYXk6IFwibm9uZVwiLFxufSlcblxuZXhwb3J0IGludGVyZmFjZSBTdHlsZWRCb3R0b21CbG9ja0NvbnRhaW5lclByb3BzIHtcbiAgaXNXaWRlTW9kZTogYm9vbGVhblxuICBzaG93UGFkZGluZzogYm9vbGVhblxufVxuXG5leHBvcnQgY29uc3QgU3R5bGVkQm90dG9tQmxvY2tDb250YWluZXIgPVxuICBzdHlsZWQuZGl2PFN0eWxlZEJvdHRvbUJsb2NrQ29udGFpbmVyUHJvcHM+KFxuICAgICh7IGlzV2lkZU1vZGUsIHNob3dQYWRkaW5nLCB0aGVtZSB9KSA9PiB7XG4gICAgICByZXR1cm4ge1xuICAgICAgICB3aWR0aDogdGhlbWUuc2l6ZXMuZnVsbCxcbiAgICAgICAgcGFkZGluZ0xlZnQ6IHRoZW1lLnNwYWNpbmcubGcsXG4gICAgICAgIHBhZGRpbmdSaWdodDogdGhlbWUuc3BhY2luZy5sZyxcbiAgICAgICAgcGFkZGluZ1RvcDogdGhlbWUuc3BhY2luZy5sZyxcbiAgICAgICAgcGFkZGluZ0JvdHRvbTogc2hvd1BhZGRpbmdcbiAgICAgICAgICA/IHRoZW1lLnNpemVzLmFwcERlZmF1bHRCb3R0b21QYWRkaW5nXG4gICAgICAgICAgOiB0aGVtZS5zcGFjaW5nLnRocmVlWEwsXG4gICAgICAgIG1heFdpZHRoOiB0aGVtZS5zaXplcy5jb250ZW50TWF4V2lkdGgsXG4gICAgICAgIC4uLihpc1dpZGVNb2RlICYmIGFwcGx5V2lkZU1vZGVQYWRkaW5nKHRoZW1lKSksXG4gICAgICAgIFtgQG1lZGlhIHByaW50YF06IHtcbiAgICAgICAgICBwYWRkaW5nVG9wOiB0aGVtZS5zcGFjaW5nLm5vbmUsXG4gICAgICAgIH0sXG4gICAgICB9XG4gICAgfVxuICApXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRBcHBWaWV3QmxvY2tTcGFjZXIgPSBzdHlsZWQuZGl2KCh7IHRoZW1lIH0pID0+IHtcbiAgcmV0dXJuIHtcbiAgICB3aWR0aDogdGhlbWUuc2l6ZXMuZnVsbCxcbiAgICBmbGV4R3JvdzogMSxcbiAgfVxufSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZElGcmFtZVJlc2l6ZXJBbmNob3IgPSBzdHlsZWQuZGl2KCh7IHRoZW1lIH0pID0+ICh7XG4gIHBvc2l0aW9uOiBcInJlbGF0aXZlXCIsXG4gIGJvdHRvbTogdGhlbWUuc3BhY2luZy5ub25lLFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRNYWluQ29udGVudCA9IHN0eWxlZC5kaXYoKHsgdGhlbWUgfSkgPT4gKHtcbiAgd2lkdGg6IHRoZW1lLnNpemVzLmZ1bGwsXG4gIG1pbldpZHRoOiAwLFxuICBoZWlnaHQ6IGAxMDBkdmhgLFxuXG4gIC8vIEFwcGx5IHJlbGF0aXZlIHBvc2l0aW9uaW5nIG9ubHkgb24gZGVza3RvcCB0byBmaXggaGVhZGVyIHBvc2l0aW9uaW5nIHdoZW4gc2lkZWJhciBvcGVucy5cbiAgLy8gT24gbW9iaWxlLCByZWxhdGl2ZSBwb3NpdGlvbmluZyBpcyBvbWl0dGVkIHRvIGFsbG93IHRoZSBzaWRlYmFyIHRvIHByb3Blcmx5IG92ZXJsYXlcbiAgLy8gdGhlIGFwcCBjb250ZW50IGZvciBzdC5uYXZpZ2F0aW9uKHBvc2l0aW9uPSd0b3AnKSBmdW5jdGlvbmFsaXR5ICgjMTEzNDkpLlxuICAvLyBXaXRob3V0IHRoaXMgY29uZGl0aW9uYWwgcG9zaXRpb25pbmcsIHRoZSBzaWRlYmFyIHdvdWxkIG92ZXJsYXAgdGhlIHRvcCBuYXZpZ2F0aW9uXG4gIC8vIHdoZW4gb3BlbmVkIG9uIGRlc2t0b3AgZGV2aWNlcy5cbiAgW2BAbWVkaWEgKG1pbi13aWR0aDogJHt0aGVtZS5icmVha3BvaW50cy5tZH0pYF06IHtcbiAgICBwb3NpdGlvbjogXCJyZWxhdGl2ZVwiLFxuICB9LFxufSkpXG4iXX0= */"), StyledInnerBottomContainer = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "ea3mdgi7"
} : {
  target: "ea3mdgi7",
  label: "StyledInnerBottomContainer"
})(({
  theme: o
}) => ({
  position: "relative",
  bottom: 0,
  width: "100%",
  minWidth: "100%",
  backgroundColor: o.colors.bgColor,
  display: "flex",
  flexDirection: "column",
  alignItems: "center"
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), applyWideModePadding = (o) => ({
  // Increase side padding, if layout = wide and the screen is wide enough
  // The calculation is used to make sure that wide mode always has the same or larger
  // content compared to centered mode.
  [`@media (min-width: calc(${o.sizes.contentMaxWidth} + 2 * (${o.sizes.wideSidePadding} - ${o.spacing.lg})))`]: {
    paddingLeft: o.sizes.wideSidePadding,
    paddingRight: o.sizes.wideSidePadding
  },
  minWidth: "auto",
  maxWidth: "initial"
}), StyledAppViewBlockContainer = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "ea3mdgi6"
} : {
  target: "ea3mdgi6",
  label: "StyledAppViewBlockContainer"
})(({
  hasBottom: o,
  isWideMode: E,
  showPadding: A,
  hasHeader: g,
  showToolbar: e,
  hasTopNav: t,
  hasSidebar: c,
  embedded: n,
  theme: h
}) => {
  const d = "2.25rem";
  let k = d;
  n ? A || e ? k = "6rem" : (g || c) && (k = "4.5rem") : k = t ? "8rem" : "6rem";
  const p = A && !o ? "10rem" : h.spacing.lg;
  return {
    width: h.sizes.full,
    paddingLeft: h.spacing.lg,
    paddingRight: h.spacing.lg,
    paddingTop: k,
    paddingBottom: p,
    maxWidth: h.sizes.contentMaxWidth,
    ...E && applyWideModePadding(h),
    "@media print": {
      paddingTop: d
    }
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledSidebarBlockContainer = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "ea3mdgi5"
} : {
  target: "ea3mdgi5",
  label: "StyledSidebarBlockContainer"
})(({
  theme: o
}) => ({
  width: o.sizes.full
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledEventBlockContainer = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "ea3mdgi4"
} : {
  target: "ea3mdgi4",
  label: "StyledEventBlockContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "eivff4",
  styles: "display:none"
} : {
  name: "eivff4",
  styles: "display:none/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$7
}), StyledBottomBlockContainer = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "ea3mdgi3"
} : {
  target: "ea3mdgi3",
  label: "StyledBottomBlockContainer"
})(({
  isWideMode: o,
  showPadding: E,
  theme: A
}) => ({
  width: A.sizes.full,
  paddingLeft: A.spacing.lg,
  paddingRight: A.spacing.lg,
  paddingTop: A.spacing.lg,
  paddingBottom: E ? A.sizes.appDefaultBottomPadding : A.spacing.threeXL,
  maxWidth: A.sizes.contentMaxWidth,
  ...o && applyWideModePadding(A),
  "@media print": {
    paddingTop: A.spacing.none
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledAppViewBlockSpacer = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "ea3mdgi2"
} : {
  target: "ea3mdgi2",
  label: "StyledAppViewBlockSpacer"
})(({
  theme: o
}) => ({
  width: o.sizes.full,
  flexGrow: 1
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledIFrameResizerAnchor = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "ea3mdgi1"
} : {
  target: "ea3mdgi1",
  label: "StyledIFrameResizerAnchor"
})(({
  theme: o
}) => ({
  position: "relative",
  bottom: o.spacing.none
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledMainContent = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "ea3mdgi0"
} : {
  target: "ea3mdgi0",
  label: "StyledMainContent"
})(({
  theme: o
}) => ({
  width: o.sizes.full,
  minWidth: 0,
  height: "100dvh",
  // Apply relative positioning only on desktop to fix header positioning when sidebar opens.
  // On mobile, relative positioning is omitted to allow the sidebar to properly overlay
  // the app content for st.navigation(position='top') functionality (#11349).
  // Without this conditional positioning, the sidebar would overlap the top navigation
  // when opened on desktop devices.
  [`@media (min-width: ${o.breakpoints.md})`]: {
    position: "relative"
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
function ScrollToBottomContainer(o) {
  const {
    className: E,
    tabIndex: A,
    children: g,
    isEmbedded: e,
    disableScrolling: t
  } = o, c = useScrollToBottom(!0);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledAppViewMain, { tabIndex: A, className: E, isEmbedded: e, disableScrolling: t, ref: c, "data-testid": "stAppScrollToBottomContainer", children: g });
}
function AppView(o) {
  const {
    elements: E,
    widgetMgr: A,
    uploadClient: g,
    sendMessageToHost: e,
    endpoints: t,
    navigationPosition: c,
    topRightContent: n,
    wideMode: h,
    embedded: d,
    showPadding: k,
    disableScrolling: p,
    addScriptFinishedHandler: M,
    removeScriptFinishedHandler: S,
    widgetsDisabled: AA,
    showToolbar: H,
    disableFullscreenMode: gA,
    componentRegistry: CA
  } = o;
  useEffect(() => {
    const LA = () => {
      e({
        type: "UPDATE_HASH",
        hash: window.location.hash
      });
    };
    return window.addEventListener("hashchange", LA, !1), () => window.removeEventListener("hashchange", LA, !1);
  }, [e]);
  const {
    activeTheme: IA
  } = useContext(ThemeContext), {
    appPages: BA,
    navSections: QA,
    pageLinkBaseUrl: EA
  } = useContext(NavigationContext), {
    initialSidebarState: oA,
    appLogo: iA,
    hideSidebarNav: aA
  } = useContext(SidebarConfigContext), {
    innerWidth: tA
  } = useWindowDimensionsContext(), eA = h ? "wide" : "narrow", cA = !E.sidebar.isEmpty, DA = !E.event.isEmpty, nA = !E.bottom.isEmpty, [wA, lA] = useState(!1), NA = tA > 0 && (cA || c === Navigation.Position.SIDEBAR && !aA && BA.length > 1 || wA);
  useEffect(() => {
    NA && aA && !wA && lA(!0);
  }, [NA, aA, wA]);
  const RA = useCallback(() => {
    !cA && wA && lA(!1);
  }, [cA, wA]);
  useEffect(() => (M(RA), () => {
    S(RA);
  }), [RA, M, S]);
  const KA = nA ? ScrollToBottomContainer : StyledAppViewMain, vA = (LA) => /* @__PURE__ */ jsxRuntimeExports.jsx(ContainerContentsWrapper, { node: LA, endpoints: t, widgetMgr: A, widgetsDisabled: AA, uploadClient: g, disableFullscreenMode: gA, componentRegistry: CA, height: "auto", isRoot: !0 }), [GA, FA] = useState(() => {
    const LA = getSavedSidebarState(EA);
    return LA !== null ? LA : shouldCollapse(oA, parseInt(IA.emotion.breakpoints.md, 10), tA);
  });
  useExecuteWhenChanged(() => {
    if (tA > 0 && NA) {
      const LA = getSavedSidebarState(EA);
      FA(LA !== null ? LA : shouldCollapse(oA, parseInt(IA.emotion.breakpoints.md, 10), tA));
    }
  }, [tA, NA, oA, IA.emotion.breakpoints.md, EA]);
  const HA = useCallback((LA, WA = !0) => {
    FA(LA), WA && saveSidebarState(EA, LA);
  }, [EA]), sA = useCallback(() => {
    HA(!GA, !0);
  }, [HA, GA]), mA = iA ? /* @__PURE__ */ jsxRuntimeExports.jsx(LogoComponent, { appLogo: iA, endpoints: t, collapsed: GA || !NA, componentName: "Header Logo", dataTestId: "stHeaderLogo" }) : null, xA = mA && (!NA || GA), hA = NA && GA, MA = c === Navigation.Position.TOP && shouldShowNavigation(BA, QA), YA = xA || hA || MA || H;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledAppViewContainer, { className: "stAppViewContainer appview-container", "data-testid": "stAppViewContainer", "data-layout": eA, children: [
    NA && /* @__PURE__ */ jsxRuntimeExports.jsx(Profiler, { id: "Sidebar", children: /* @__PURE__ */ jsxRuntimeExports.jsx(ThemedSidebar, { endpoints: t, hasElements: cA, isCollapsed: GA, onToggleCollapse: HA, widgetsDisabled: AA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledSidebarBlockContainer, { children: vA(E.sidebar) }) }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledMainContent, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Header, { hasSidebar: NA, isSidebarOpen: NA && !GA, onToggleSidebar: sA, navigation: c === Navigation.Position.TOP && shouldShowNavigation(BA, QA) ? /* @__PURE__ */ jsxRuntimeExports.jsx(TopNav, { endpoints: t, widgetsDisabled: AA }) : null, rightContent: n, logoComponent: mA, showToolbar: H }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(KA, { tabIndex: 0, isEmbedded: d, disableScrolling: p, className: "stMain", "data-testid": "stMain", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Profiler, { id: "Main", children: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledAppViewBlockContainer, { className: "stMainBlockContainer block-container", "data-testid": "stMainBlockContainer", isWideMode: h, showPadding: k, hasBottom: nA, hasHeader: YA, hasSidebar: NA, showToolbar: H, hasTopNav: MA, embedded: d, children: vA(E.main) }) }),
        !nA && /* @__PURE__ */ jsxRuntimeExports.jsx(StyledIFrameResizerAnchor, { "data-testid": "stAppIframeResizerAnchor", "data-iframe-height": !0 }),
        nA && /* @__PURE__ */ jsxRuntimeExports.jsxs(Profiler, { id: "Bottom", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(StyledAppViewBlockSpacer, {}),
          /* @__PURE__ */ jsxRuntimeExports.jsx(StyledStickyBottomContainer, { className: "stBottom", "data-testid": "stBottom", children: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledInnerBottomContainer, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledBottomBlockContainer, { "data-testid": "stBottomBlockContainer", isWideMode: h, showPadding: k, children: vA(E.bottom) }) }) })
        ] })
      ] })
    ] }),
    DA && /* @__PURE__ */ jsxRuntimeExports.jsx(Profiler, { id: "Event", children: /* @__PURE__ */ jsxRuntimeExports.jsx(EventContainer, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledEventBlockContainer, { className: "stEvent", "data-testid": "stEvent", children: vA(E.event) }) }) })
  ] }) });
}
const DeployButtonContainer = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e17vllj40"
} : {
  target: "e17vllj40",
  label: "DeployButtonContainer"
})(({
  theme: o
}) => ({
  display: "flex",
  gap: o.spacing.sm,
  alignItems: "center",
  lineHeight: o.iconSizes.md
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2FwcC9zcmMvY29tcG9uZW50cy9EZXBsb3lCdXR0b24vc3R5bGVkLWNvbXBvbmVudHMudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWtCcUMiLCJmaWxlIjoiL2hvbWUvcnVubmVyL3dvcmsvc3RsaXRlL3N0bGl0ZS9zdHJlYW1saXQvZnJvbnRlbmQvYXBwL3NyYy9jb21wb25lbnRzL0RlcGxveUJ1dHRvbi9zdHlsZWQtY29tcG9uZW50cy50c3giLCJzb3VyY2VzQ29udGVudCI6WyIvKipcbiAqIENvcHlyaWdodCAoYykgU3RyZWFtbGl0IEluYy4gKDIwMTgtMjAyMikgU25vd2ZsYWtlIEluYy4gKDIwMjItMjAyNSlcbiAqXG4gKiBMaWNlbnNlZCB1bmRlciB0aGUgQXBhY2hlIExpY2Vuc2UsIFZlcnNpb24gMi4wICh0aGUgXCJMaWNlbnNlXCIpO1xuICogeW91IG1heSBub3QgdXNlIHRoaXMgZmlsZSBleGNlcHQgaW4gY29tcGxpYW5jZSB3aXRoIHRoZSBMaWNlbnNlLlxuICogWW91IG1heSBvYnRhaW4gYSBjb3B5IG9mIHRoZSBMaWNlbnNlIGF0XG4gKlxuICogICAgIGh0dHA6Ly93d3cuYXBhY2hlLm9yZy9saWNlbnNlcy9MSUNFTlNFLTIuMFxuICpcbiAqIFVubGVzcyByZXF1aXJlZCBieSBhcHBsaWNhYmxlIGxhdyBvciBhZ3JlZWQgdG8gaW4gd3JpdGluZywgc29mdHdhcmVcbiAqIGRpc3RyaWJ1dGVkIHVuZGVyIHRoZSBMaWNlbnNlIGlzIGRpc3RyaWJ1dGVkIG9uIGFuIFwiQVMgSVNcIiBCQVNJUyxcbiAqIFdJVEhPVVQgV0FSUkFOVElFUyBPUiBDT05ESVRJT05TIE9GIEFOWSBLSU5ELCBlaXRoZXIgZXhwcmVzcyBvciBpbXBsaWVkLlxuICogU2VlIHRoZSBMaWNlbnNlIGZvciB0aGUgc3BlY2lmaWMgbGFuZ3VhZ2UgZ292ZXJuaW5nIHBlcm1pc3Npb25zIGFuZFxuICogbGltaXRhdGlvbnMgdW5kZXIgdGhlIExpY2Vuc2UuXG4gKi9cblxuaW1wb3J0IHN0eWxlZCBmcm9tIFwiQGVtb3Rpb24vc3R5bGVkXCJcblxuZXhwb3J0IGNvbnN0IERlcGxveUJ1dHRvbkNvbnRhaW5lciA9IHN0eWxlZC5kaXYoKHsgdGhlbWUgfSkgPT4gKHtcbiAgZGlzcGxheTogXCJmbGV4XCIsXG4gIGdhcDogdGhlbWUuc3BhY2luZy5zbSxcbiAgYWxpZ25JdGVtczogXCJjZW50ZXJcIixcbiAgbGluZUhlaWdodDogdGhlbWUuaWNvblNpemVzLm1kLFxufSkpXG4iXX0= */"), DeployButton = ({
  onClick: o
}) => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "stAppDeployButton", "data-testid": "stAppDeployButton", children: /* @__PURE__ */ jsxRuntimeExports.jsx(BaseButton, { kind: BaseButtonKind.HEADER_BUTTON, onClick: o, children: /* @__PURE__ */ jsxRuntimeExports.jsx(DeployButtonContainer, { children: /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: "Deploy" }) }) }) });
var MoreVert = /* @__PURE__ */ React.forwardRef(function(o, E) {
  var A = {
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  };
  return /* @__PURE__ */ React.createElement(EmotionIconBase, _extends$C({
    iconAttrs: A,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, o, {
    ref: E
  }), /* @__PURE__ */ React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
  }));
});
MoreVert.displayName = "MoreVert";
const BLOB_TYPE = "video/webm", LOG$4 = loglevelExports$1.getLogger("ScreenCastRecorder");
class ScreenCastRecorder {
  /** True if the current browser likely supports screencasts. */
  static isSupportedBrowser() {
    try {
      return notNullOrUndefined(navigator.mediaDevices) && notNullOrUndefined(navigator.mediaDevices.getUserMedia) && notNullOrUndefined(navigator.mediaDevices.getDisplayMedia) && MediaRecorder.isTypeSupported(BLOB_TYPE);
    } catch {
      return !1;
    }
  }
  constructor({
    recordAudio: E,
    onErrorOrStop: A
  }) {
    this.recordAudio = E, this.onErrorOrStopCallback = A, this.inputStream = null, this.recordedChunks = [], this.mediaRecorder = null;
  }
  /**
   * This asynchronous method will initialize the screen recording object asking
   * for permissions to the user which are needed to start recording.
   */
  async initialize() {
    let A = (await navigator.mediaDevices.getDisplayMedia({
      video: !0
    })).getTracks();
    if (this.recordAudio) {
      const g = await navigator.mediaDevices.getUserMedia({
        video: !1,
        audio: !0
      });
      A = A.concat(g.getAudioTracks());
    }
    this.recordedChunks = [], this.inputStream = new MediaStream(A), this.mediaRecorder = new MediaRecorder(this.inputStream, {
      mimeType: BLOB_TYPE
    }), this.mediaRecorder.ondataavailable = (g) => this.recordedChunks.push(g.data);
  }
  getState() {
    return this.mediaRecorder ? this.mediaRecorder.state : "inactive";
  }
  /**
   * This method will start the screen recording if the user has granted permissions
   * and the mediaRecorder has been initialized
   *
   * @returns {boolean}
   */
  start() {
    if (!this.mediaRecorder)
      return LOG$4.warn("ScreenCastRecorder.start: mediaRecorder is null"), !1;
    const E = (A) => {
      LOG$4.warn(`mediaRecorder.start threw an error: ${A}`);
    };
    this.mediaRecorder.onerror = (A) => {
      E(A), this.onErrorOrStopCallback();
    }, this.mediaRecorder.onstop = () => this.onErrorOrStopCallback();
    try {
      this.mediaRecorder.start();
    } catch (A) {
      return E(A), !1;
    }
    return !0;
  }
  /**
   * This method will stop recording and then return the generated Blob
   *
   * @returns {(Promise|undefined)}
   *  A Promise which will return the generated Blob
   *  Undefined if the MediaRecorder could not initialize
   */
  stop() {
    if (!this.mediaRecorder)
      return;
    let E;
    const A = new Promise((g) => {
      E = g;
    });
    return this.mediaRecorder.onstop = () => E(), this.mediaRecorder.stop(), this.inputStream && (this.inputStream.getTracks().forEach((g) => g.stop()), this.inputStream = null), A.then(() => this.buildOutputBlob());
  }
  buildOutputBlob() {
    return new Blob(this.recordedChunks, {
      type: BLOB_TYPE
    });
  }
}
function _EMOTION_STRINGIFIED_CSS_ERROR__$6() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const recordingIndicatorPulse = (o) => keyframes`
0% {
  box-shadow: 0 0 ${o.spacing.twoXS} ${o.colors.redTextColor};
}
50% {
  box-shadow: 0 0 ${o.spacing.sm} ${o.spacing.twoXS} ${o.colors.redTextColor};
}
100% {
  box-shadow: 0 0 ${o.spacing.twoXS} ${o.colors.redTextColor};
}`, StyledRecordingIndicator = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e16jpq808"
} : {
  target: "e16jpq808",
  label: "StyledRecordingIndicator"
})(({
  theme: o
}) => ({
  position: "absolute",
  bottom: o.spacing.lg,
  right: o.spacing.sm,
  width: o.spacing.sm,
  height: o.spacing.sm,
  backgroundColor: o.colors.redTextColor,
  borderRadius: o.radii.full,
  boxShadow: `0 0 ${o.spacing.twoXS} ${o.colors.redTextColor}`,
  animation: `${recordingIndicatorPulse(o)} 2s linear infinite`
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledMenuDivider = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e16jpq807"
} : {
  target: "e16jpq807",
  label: "StyledMenuDivider"
})(({
  theme: o
}) => ({
  borderTop: `${o.sizes.borderWidth} solid ${o.colors.borderColor}`,
  margin: `${o.spacing.sm} ${o.spacing.none}`
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledMenuItemShortcut = /* @__PURE__ */ createStyled("span", process.env.NODE_ENV === "production" ? {
  target: "e16jpq806"
} : {
  target: "e16jpq806",
  label: "StyledMenuItemShortcut"
})(({
  isRecording: o,
  theme: E
}) => ({
  color: o ? E.colors.redTextColor : E.colors.fadedText60,
  fontSize: E.fontSizes.sm,
  marginTop: E.spacing.twoXS,
  fontVariant: "small-caps",
  textTransform: "uppercase"
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledMenuItem = /* @__PURE__ */ createStyled("ul", process.env.NODE_ENV === "production" ? {
  target: "e16jpq805"
} : {
  target: "e16jpq805",
  label: "StyledMenuItem"
})(({
  isDisabled: o,
  isRecording: E,
  theme: A
}) => {
  const g = o ? {
    backgroundColor: A.colors.transparent,
    color: A.colors.fadedText60,
    cursor: "not-allowed"
  } : {
    "&:focus": {
      backgroundColor: A.colors.primary,
      color: A.colors.white
    }
  }, e = E && {
    color: A.colors.redTextColor,
    fontWeight: A.fontWeights.bold
  };
  return {
    display: "block",
    flexDirection: "row",
    alignItems: "flex-start",
    padding: A.spacing.none,
    cursor: "pointer",
    ...e || {},
    ...g,
    "@media print": {
      display: "none !important"
    }
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledCoreItem = /* @__PURE__ */ createStyled("li", process.env.NODE_ENV === "production" ? {
  target: "e16jpq804"
} : {
  target: "e16jpq804",
  label: "StyledCoreItem"
})(({
  isHighlighted: o,
  styleProps: E,
  theme: A
}) => {
  const g = o && {
    "&:hover": {
      backgroundColor: A.colors.darkenedBgMix15
    }
  }, e = E?.margin || 0, t = E?.padding || `${A.spacing.twoXS} ${A.spacing.twoXL}`, c = E?.backgroundColor || A.colors.bgColor, n = E?.fontSize || A.fontSizes.md;
  return {
    margin: e,
    padding: t,
    backgroundColor: c,
    fontSize: n,
    ...g || {},
    display: "block"
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledDevItem = /* @__PURE__ */ createStyled("li", process.env.NODE_ENV === "production" ? {
  target: "e16jpq803"
} : {
  target: "e16jpq803",
  label: "StyledDevItem"
})(({
  isHighlighted: o,
  styleProps: E,
  theme: A
}) => {
  const g = o && {
    "&:hover": {
      // Whatever color we use here as the hover state, we want to transparentize it
      // to its full extend, so you can see the underlying color of the menu.
      backgroundColor: transparentize(A.colors.darkenedBgMix15, 1)
    }
  }, e = E?.margin || 0, t = E?.padding || `${A.spacing.twoXS} ${A.spacing.twoXL}`, c = E?.backgroundColor || A.colors.secondaryBg, n = E?.fontSize || A.fontSizes.md;
  return {
    margin: e,
    padding: t,
    backgroundColor: c,
    fontSize: n,
    ...g || {},
    display: "block"
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledMenuItemLabel = /* @__PURE__ */ createStyled("span", process.env.NODE_ENV === "production" ? {
  target: "e16jpq802"
} : {
  target: "e16jpq802",
  label: "StyledMenuItemLabel"
})(({
  theme: o
}) => ({
  marginRight: o.spacing.md,
  flexGrow: 1
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledMenuContainer = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e16jpq801"
} : {
  target: "e16jpq801",
  label: "StyledMenuContainer"
})(({
  theme: o
}) => ({
  // We start by adding border radius to all menus
  ul: {
    borderRadius: o.radii.default
  },
  // This selects the standard menu only if there's another menu below.
  // We use this to override the bottom border radius on the last item if the developer options menu is visible.
  "& > ul[role=listbox]:not(:last-child)": {
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0
  },
  // This selects the developer options menu, if it exists.
  // We use this to override the top border radius.
  "ul[role=listbox] ~ ul[role=listbox]": {
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    boxShadow: "none",
    borderTop: "none"
  },
  "@media print": {
    display: "none"
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2FwcC9zcmMvY29tcG9uZW50cy9NYWluTWVudS9zdHlsZWQtY29tcG9uZW50cy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFzS21DIiwiZmlsZSI6Ii9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2FwcC9zcmMvY29tcG9uZW50cy9NYWluTWVudS9zdHlsZWQtY29tcG9uZW50cy50cyIsInNvdXJjZXNDb250ZW50IjpbIi8qKlxuICogQ29weXJpZ2h0IChjKSBTdHJlYW1saXQgSW5jLiAoMjAxOC0yMDIyKSBTbm93Zmxha2UgSW5jLiAoMjAyMi0yMDI1KVxuICpcbiAqIExpY2Vuc2VkIHVuZGVyIHRoZSBBcGFjaGUgTGljZW5zZSwgVmVyc2lvbiAyLjAgKHRoZSBcIkxpY2Vuc2VcIik7XG4gKiB5b3UgbWF5IG5vdCB1c2UgdGhpcyBmaWxlIGV4Y2VwdCBpbiBjb21wbGlhbmNlIHdpdGggdGhlIExpY2Vuc2UuXG4gKiBZb3UgbWF5IG9idGFpbiBhIGNvcHkgb2YgdGhlIExpY2Vuc2UgYXRcbiAqXG4gKiAgICAgaHR0cDovL3d3dy5hcGFjaGUub3JnL2xpY2Vuc2VzL0xJQ0VOU0UtMi4wXG4gKlxuICogVW5sZXNzIHJlcXVpcmVkIGJ5IGFwcGxpY2FibGUgbGF3IG9yIGFncmVlZCB0byBpbiB3cml0aW5nLCBzb2Z0d2FyZVxuICogZGlzdHJpYnV0ZWQgdW5kZXIgdGhlIExpY2Vuc2UgaXMgZGlzdHJpYnV0ZWQgb24gYW4gXCJBUyBJU1wiIEJBU0lTLFxuICogV0lUSE9VVCBXQVJSQU5USUVTIE9SIENPTkRJVElPTlMgT0YgQU5ZIEtJTkQsIGVpdGhlciBleHByZXNzIG9yIGltcGxpZWQuXG4gKiBTZWUgdGhlIExpY2Vuc2UgZm9yIHRoZSBzcGVjaWZpYyBsYW5ndWFnZSBnb3Zlcm5pbmcgcGVybWlzc2lvbnMgYW5kXG4gKiBsaW1pdGF0aW9ucyB1bmRlciB0aGUgTGljZW5zZS5cbiAqL1xuXG5pbXBvcnQgeyBrZXlmcmFtZXMgfSBmcm9tIFwiQGVtb3Rpb24vcmVhY3RcIlxuaW1wb3J0IHsgS2V5ZnJhbWVzIH0gZnJvbSBcIkBlbW90aW9uL3NlcmlhbGl6ZVwiXG5pbXBvcnQgc3R5bGVkIGZyb20gXCJAZW1vdGlvbi9zdHlsZWRcIlxuaW1wb3J0IHsgdHJhbnNwYXJlbnRpemUgfSBmcm9tIFwiY29sb3Iya1wiXG5cbmltcG9ydCB7IEVtb3Rpb25UaGVtZSB9IGZyb20gXCJAc3RyZWFtbGl0L2xpYlwiXG5cbmNvbnN0IHJlY29yZGluZ0luZGljYXRvclB1bHNlID0gKHRoZW1lOiBFbW90aW9uVGhlbWUpOiBLZXlmcmFtZXMgPT4ga2V5ZnJhbWVzYFxuMCUge1xuICBib3gtc2hhZG93OiAwIDAgJHt0aGVtZS5zcGFjaW5nLnR3b1hTfSAke3RoZW1lLmNvbG9ycy5yZWRUZXh0Q29sb3J9O1xufVxuNTAlIHtcbiAgYm94LXNoYWRvdzogMCAwICR7dGhlbWUuc3BhY2luZy5zbX0gJHt0aGVtZS5zcGFjaW5nLnR3b1hTfSAke3RoZW1lLmNvbG9ycy5yZWRUZXh0Q29sb3J9O1xufVxuMTAwJSB7XG4gIGJveC1zaGFkb3c6IDAgMCAke3RoZW1lLnNwYWNpbmcudHdvWFN9ICR7dGhlbWUuY29sb3JzLnJlZFRleHRDb2xvcn07XG59YFxuXG5leHBvcnQgY29uc3QgU3R5bGVkUmVjb3JkaW5nSW5kaWNhdG9yID0gc3R5bGVkLmRpdigoeyB0aGVtZSB9KSA9PiAoe1xuICBwb3NpdGlvbjogXCJhYnNvbHV0ZVwiLFxuICBib3R0b206IHRoZW1lLnNwYWNpbmcubGcsXG4gIHJpZ2h0OiB0aGVtZS5zcGFjaW5nLnNtLFxuICB3aWR0aDogdGhlbWUuc3BhY2luZy5zbSxcbiAgaGVpZ2h0OiB0aGVtZS5zcGFjaW5nLnNtLFxuICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5yZWRUZXh0Q29sb3IsXG4gIGJvcmRlclJhZGl1czogdGhlbWUucmFkaWkuZnVsbCxcbiAgYm94U2hhZG93OiBgMCAwICR7dGhlbWUuc3BhY2luZy50d29YU30gJHt0aGVtZS5jb2xvcnMucmVkVGV4dENvbG9yfWAsXG4gIGFuaW1hdGlvbjogYCR7cmVjb3JkaW5nSW5kaWNhdG9yUHVsc2UodGhlbWUpfSAycyBsaW5lYXIgaW5maW5pdGVgLFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRNZW51RGl2aWRlciA9IHN0eWxlZC5kaXYoKHsgdGhlbWUgfSkgPT4gKHtcbiAgYm9yZGVyVG9wOiBgJHt0aGVtZS5zaXplcy5ib3JkZXJXaWR0aH0gc29saWQgJHt0aGVtZS5jb2xvcnMuYm9yZGVyQ29sb3J9YCxcbiAgbWFyZ2luOiBgJHt0aGVtZS5zcGFjaW5nLnNtfSAke3RoZW1lLnNwYWNpbmcubm9uZX1gLFxufSkpXG5cbmV4cG9ydCBpbnRlcmZhY2UgSXRlbVByb3BzIHtcbiAgaXNEaXNhYmxlZDogYm9vbGVhblxuICBpc1JlY29yZGluZzogYm9vbGVhblxufVxuXG5leHBvcnQgaW50ZXJmYWNlIEl0ZW1TdHlsZVByb3BzIHtcbiAgaXNIaWdobGlnaHRlZDogYm9vbGVhblxuICBzdHlsZVByb3BzPzogUmVhY3QuQ1NTUHJvcGVydGllc1xufVxuXG5leHBvcnQgY29uc3QgU3R5bGVkTWVudUl0ZW1TaG9ydGN1dCA9IHN0eWxlZC5zcGFuPEl0ZW1Qcm9wcz4oXG4gICh7IGlzUmVjb3JkaW5nLCB0aGVtZSB9KSA9PiB7XG4gICAgcmV0dXJuIHtcbiAgICAgIGNvbG9yOiBpc1JlY29yZGluZ1xuICAgICAgICA/IHRoZW1lLmNvbG9ycy5yZWRUZXh0Q29sb3JcbiAgICAgICAgOiB0aGVtZS5jb2xvcnMuZmFkZWRUZXh0NjAsXG4gICAgICBmb250U2l6ZTogdGhlbWUuZm9udFNpemVzLnNtLFxuICAgICAgbWFyZ2luVG9wOiB0aGVtZS5zcGFjaW5nLnR3b1hTLFxuICAgICAgZm9udFZhcmlhbnQ6IFwic21hbGwtY2Fwc1wiLFxuICAgICAgdGV4dFRyYW5zZm9ybTogXCJ1cHBlcmNhc2VcIixcbiAgICB9XG4gIH1cbilcblxuZXhwb3J0IGNvbnN0IFN0eWxlZE1lbnVJdGVtID0gc3R5bGVkLnVsPEl0ZW1Qcm9wcz4oXG4gICh7IGlzRGlzYWJsZWQsIGlzUmVjb3JkaW5nLCB0aGVtZSB9KSA9PiB7XG4gICAgY29uc3QgZGlzYWJsZWRTdHlsZXMgPSBpc0Rpc2FibGVkXG4gICAgICA/IHtcbiAgICAgICAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy50cmFuc3BhcmVudCxcbiAgICAgICAgICBjb2xvcjogdGhlbWUuY29sb3JzLmZhZGVkVGV4dDYwLFxuICAgICAgICAgIGN1cnNvcjogXCJub3QtYWxsb3dlZFwiLFxuICAgICAgICB9XG4gICAgICA6IHtcbiAgICAgICAgICBcIiY6Zm9jdXNcIjoge1xuICAgICAgICAgICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMucHJpbWFyeSxcbiAgICAgICAgICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMud2hpdGUsXG4gICAgICAgICAgfSxcbiAgICAgICAgfVxuXG4gICAgY29uc3QgcmVjb3JkaW5nU3R5bGVzID0gaXNSZWNvcmRpbmcgJiYge1xuICAgICAgY29sb3I6IHRoZW1lLmNvbG9ycy5yZWRUZXh0Q29sb3IsXG4gICAgICBmb250V2VpZ2h0OiB0aGVtZS5mb250V2VpZ2h0cy5ib2xkLFxuICAgIH1cblxuICAgIHJldHVybiB7XG4gICAgICBkaXNwbGF5OiBcImJsb2NrXCIsXG4gICAgICBmbGV4RGlyZWN0aW9uOiBcInJvd1wiLFxuICAgICAgYWxpZ25JdGVtczogXCJmbGV4LXN0YXJ0XCIsXG4gICAgICBwYWRkaW5nOiB0aGVtZS5zcGFjaW5nLm5vbmUsXG4gICAgICBjdXJzb3I6IFwicG9pbnRlclwiLFxuICAgICAgLi4uKHJlY29yZGluZ1N0eWxlcyB8fCB7fSksXG4gICAgICAuLi5kaXNhYmxlZFN0eWxlcyxcbiAgICAgIFwiQG1lZGlhIHByaW50XCI6IHtcbiAgICAgICAgZGlzcGxheTogXCJub25lICFpbXBvcnRhbnRcIixcbiAgICAgIH0sXG4gICAgfVxuICB9XG4pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRDb3JlSXRlbSA9IHN0eWxlZC5saTxJdGVtU3R5bGVQcm9wcz4oXG4gICh7IGlzSGlnaGxpZ2h0ZWQsIHN0eWxlUHJvcHMsIHRoZW1lIH0pID0+IHtcbiAgICBjb25zdCBoaWdobGlnaHRlZFN0eWxlcyA9IGlzSGlnaGxpZ2h0ZWQgJiYge1xuICAgICAgXCImOmhvdmVyXCI6IHtcbiAgICAgICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMuZGFya2VuZWRCZ01peDE1LFxuICAgICAgfSxcbiAgICB9XG5cbiAgICBjb25zdCBtYXJnaW4gPSBzdHlsZVByb3BzPy5tYXJnaW4gfHwgMFxuICAgIGNvbnN0IHBhZGRpbmcgPVxuICAgICAgc3R5bGVQcm9wcz8ucGFkZGluZyB8fCBgJHt0aGVtZS5zcGFjaW5nLnR3b1hTfSAke3RoZW1lLnNwYWNpbmcudHdvWEx9YFxuICAgIGNvbnN0IGJhY2tncm91bmRDb2xvciA9IHN0eWxlUHJvcHM/LmJhY2tncm91bmRDb2xvciB8fCB0aGVtZS5jb2xvcnMuYmdDb2xvclxuICAgIGNvbnN0IGZvbnRTaXplID0gc3R5bGVQcm9wcz8uZm9udFNpemUgfHwgdGhlbWUuZm9udFNpemVzLm1kXG5cbiAgICByZXR1cm4ge1xuICAgICAgbWFyZ2luLFxuICAgICAgcGFkZGluZyxcbiAgICAgIGJhY2tncm91bmRDb2xvcixcbiAgICAgIGZvbnRTaXplLFxuICAgICAgLi4uKGhpZ2hsaWdodGVkU3R5bGVzIHx8IHt9KSxcbiAgICAgIGRpc3BsYXk6IFwiYmxvY2tcIixcbiAgICB9XG4gIH1cbilcblxuZXhwb3J0IGNvbnN0IFN0eWxlZERldkl0ZW0gPSBzdHlsZWQubGk8SXRlbVN0eWxlUHJvcHM+KFxuICAoeyBpc0hpZ2hsaWdodGVkLCBzdHlsZVByb3BzLCB0aGVtZSB9KSA9PiB7XG4gICAgY29uc3QgaGlnaGxpZ2h0ZWRTdHlsZXMgPSBpc0hpZ2hsaWdodGVkICYmIHtcbiAgICAgIFwiJjpob3ZlclwiOiB7XG4gICAgICAgIC8vIFdoYXRldmVyIGNvbG9yIHdlIHVzZSBoZXJlIGFzIHRoZSBob3ZlciBzdGF0ZSwgd2Ugd2FudCB0byB0cmFuc3BhcmVudGl6ZSBpdFxuICAgICAgICAvLyB0byBpdHMgZnVsbCBleHRlbmQsIHNvIHlvdSBjYW4gc2VlIHRoZSB1bmRlcmx5aW5nIGNvbG9yIG9mIHRoZSBtZW51LlxuICAgICAgICBiYWNrZ3JvdW5kQ29sb3I6IHRyYW5zcGFyZW50aXplKHRoZW1lLmNvbG9ycy5kYXJrZW5lZEJnTWl4MTUsIDEpLFxuICAgICAgfSxcbiAgICB9XG4gICAgY29uc3QgbWFyZ2luID0gc3R5bGVQcm9wcz8ubWFyZ2luIHx8IDBcbiAgICBjb25zdCBwYWRkaW5nID1cbiAgICAgIHN0eWxlUHJvcHM/LnBhZGRpbmcgfHwgYCR7dGhlbWUuc3BhY2luZy50d29YU30gJHt0aGVtZS5zcGFjaW5nLnR3b1hMfWBcbiAgICBjb25zdCBiYWNrZ3JvdW5kQ29sb3IgPVxuICAgICAgc3R5bGVQcm9wcz8uYmFja2dyb3VuZENvbG9yIHx8IHRoZW1lLmNvbG9ycy5zZWNvbmRhcnlCZ1xuICAgIGNvbnN0IGZvbnRTaXplID0gc3R5bGVQcm9wcz8uZm9udFNpemUgfHwgdGhlbWUuZm9udFNpemVzLm1kXG4gICAgcmV0dXJuIHtcbiAgICAgIG1hcmdpbixcbiAgICAgIHBhZGRpbmcsXG4gICAgICBiYWNrZ3JvdW5kQ29sb3IsXG4gICAgICBmb250U2l6ZSxcbiAgICAgIC4uLihoaWdobGlnaHRlZFN0eWxlcyB8fCB7fSksXG4gICAgICBkaXNwbGF5OiBcImJsb2NrXCIsXG4gICAgfVxuICB9XG4pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRNZW51SXRlbUxhYmVsID0gc3R5bGVkLnNwYW4oKHsgdGhlbWUgfSkgPT4gKHtcbiAgbWFyZ2luUmlnaHQ6IHRoZW1lLnNwYWNpbmcubWQsXG4gIGZsZXhHcm93OiAxLFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRNZW51Q29udGFpbmVyID0gc3R5bGVkLmRpdigoeyB0aGVtZSB9KSA9PiAoe1xuICAvLyBXZSBzdGFydCBieSBhZGRpbmcgYm9yZGVyIHJhZGl1cyB0byBhbGwgbWVudXNcbiAgdWw6IHtcbiAgICBib3JkZXJSYWRpdXM6IHRoZW1lLnJhZGlpLmRlZmF1bHQsXG4gIH0sXG5cbiAgLy8gVGhpcyBzZWxlY3RzIHRoZSBzdGFuZGFyZCBtZW51IG9ubHkgaWYgdGhlcmUncyBhbm90aGVyIG1lbnUgYmVsb3cuXG4gIC8vIFdlIHVzZSB0aGlzIHRvIG92ZXJyaWRlIHRoZSBib3R0b20gYm9yZGVyIHJhZGl1cyBvbiB0aGUgbGFzdCBpdGVtIGlmIHRoZSBkZXZlbG9wZXIgb3B0aW9ucyBtZW51IGlzIHZpc2libGUuXG4gIFwiJiA+IHVsW3JvbGU9bGlzdGJveF06bm90KDpsYXN0LWNoaWxkKVwiOiB7XG4gICAgYm9yZGVyQm90dG9tTGVmdFJhZGl1czogMCxcbiAgICBib3JkZXJCb3R0b21SaWdodFJhZGl1czogMCxcbiAgfSxcblxuICAvLyBUaGlzIHNlbGVjdHMgdGhlIGRldmVsb3BlciBvcHRpb25zIG1lbnUsIGlmIGl0IGV4aXN0cy5cbiAgLy8gV2UgdXNlIHRoaXMgdG8gb3ZlcnJpZGUgdGhlIHRvcCBib3JkZXIgcmFkaXVzLlxuICBcInVsW3JvbGU9bGlzdGJveF0gfiB1bFtyb2xlPWxpc3Rib3hdXCI6IHtcbiAgICBib3JkZXJUb3BMZWZ0UmFkaXVzOiAwLFxuICAgIGJvcmRlclRvcFJpZ2h0UmFkaXVzOiAwLFxuICAgIGJveFNoYWRvdzogXCJub25lXCIsXG4gICAgYm9yZGVyVG9wOiBcIm5vbmVcIixcbiAgfSxcbiAgXCJAbWVkaWEgcHJpbnRcIjoge1xuICAgIGRpc3BsYXk6IFwibm9uZVwiLFxuICB9LFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRNYWluTWVudUNvbnRhaW5lciA9IHN0eWxlZC5zcGFuKHtcbiAgbGluZUhlaWdodDogXCJpbml0aWFsXCIsXG59KVxuIl19 */"), StyledMainMenuContainer = /* @__PURE__ */ createStyled("span", process.env.NODE_ENV === "production" ? {
  target: "e16jpq800"
} : {
  target: "e16jpq800",
  label: "StyledMainMenuContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "hwawmg",
  styles: "line-height:initial"
} : {
  name: "hwawmg",
  styles: "line-height:initial/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$6
}), SCREENCAST_LABEL = {
  COUNTDOWN: "Cancel screencast",
  RECORDING: "Stop recording"
}, getOpenInWindowCallback = (o) => () => {
  window.open(o, "_blank");
};
function buildMenuItemComponent(o, E) {
  const A = forwardRef(({
    item: g,
    "aria-selected": e,
    onClick: t,
    onMouseEnter: c,
    $disabled: n,
    $isHighlighted: h
  }, d) => {
    const {
      label: k,
      shortcut: p,
      hasDividerAbove: M,
      styleProps: S,
      noHighlight: AA,
      interactions: H
    } = g, gA = {
      isDisabled: n,
      isRecording: !!g.stopRecordingIndicator
    }, CA = {
      isHighlighted: !AA && h,
      styleProps: S
    }, IA = H || (n ? {} : {
      onClick: (BA) => {
        E.enqueue("menuClick", {
          label: k
        }), t(BA);
      },
      onMouseEnter: c
    });
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      M && /* @__PURE__ */ jsxRuntimeExports.jsx(StyledMenuDivider, { "data-testid": "stMainMenuDivider" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(StyledMenuItem, { ref: d, role: "option", "aria-selected": e, "aria-disabled": n, ...gA, ...IA, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(o, { ...CA, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(StyledMenuItemLabel, { ...gA, children: k }),
        p && /* @__PURE__ */ jsxRuntimeExports.jsx(StyledMenuItemShortcut, { ...gA, children: p })
      ] }) })
    ] });
  });
  return A.displayName = "MenuItem", A;
}
const SubMenu = (o) => {
  const {
    colors: E,
    sizes: A,
    spacing: g
  } = useEmotionTheme(), e = o.isDevMenu ? StyledDevItem : StyledCoreItem;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StatefulMenu, { items: o.menuItems, onItemSelect: ({
    item: t
  }) => {
    t.onClick(), o.closeMenu();
  }, overrides: {
    Option: buildMenuItemComponent(e, o.metricsMgr),
    List: {
      props: {
        "data-testid": "stMainMenuList"
      },
      style: {
        backgroundColor: "inherit",
        borderBottomRadius: 0,
        borderTopRadius: 0,
        borderLeftRadius: 0,
        borderRightRadius: 0,
        paddingBottom: g.sm,
        paddingTop: g.sm,
        ":focus": {
          outline: "none"
        },
        border: `${A.borderWidth} solid ${E.borderColor}`
      }
    }
  } });
};
function getDevMenuItems(o, E) {
  const A = [], g = [E.developerOptions, E.clearCache];
  let e = null;
  for (const t of g)
    t && (t !== E.DIVIDER && (e === E.DIVIDER ? A.push({
      ...t,
      hasDividerAbove: !0
    }) : A.push(t)), e = t);
  return notNullOrUndefined(e) && (e.styleProps = {
    margin: `0 0 -${o.spacing.sm} 0`,
    padding: `${o.spacing.twoXS} ${o.spacing.none} ${o.spacing.twoXS} ${o.spacing.twoXL}`
  }), A;
}
function getPreferredMenuOrder(o, E, A) {
  let g;
  if (o.toolbarMode == Config.ToolbarMode.MINIMAL) {
    for (g = [A.report, A.community, A.DIVIDER, ...E.length > 0 ? E : [A.DIVIDER], A.about], g = g.filter((e) => e); g.length > 0 && g[0] == A.DIVIDER; )
      g.shift();
    for (; g.length > 0 && g.at(g.length - 1) == A.DIVIDER; )
      g.pop();
    return g;
  }
  return [A.rerun, A.settings, A.DIVIDER, A.print, ...ScreenCastRecorder.isSupportedBrowser() ? [A.recordScreencast] : [], A.DIVIDER, A.report, A.community, ...E.length > 0 ? E : [A.DIVIDER], A.about];
}
function MainMenu(o) {
  const E = useEmotionTheme(), A = !o.isServerConnected, g = {
    DIVIDER: {
      isDivider: !0
    },
    rerun: {
      disabled: A,
      onClick: o.quickRerunCallback,
      label: "Rerun",
      shortcut: "r"
    },
    print: {
      onClick: o.printCallback,
      label: "Print"
    },
    recordScreencast: {
      onClick: o.screencastCallback,
      label: SCREENCAST_LABEL[o.screenCastState] || "Record a screencast",
      shortcut: SCREENCAST_LABEL[o.screenCastState] ? "esc" : "",
      stopRecordingIndicator: !!SCREENCAST_LABEL[o.screenCastState]
    },
    ...!o.menuItems?.hideGetHelp && o.menuItems?.getHelpUrl && {
      community: {
        onClick: getOpenInWindowCallback(o.menuItems?.getHelpUrl),
        label: "Get help"
      }
    },
    ...!o.menuItems?.hideReportABug && o.menuItems?.reportABugUrl && {
      report: {
        onClick: getOpenInWindowCallback(o.menuItems?.reportABugUrl),
        label: "Report a bug"
      }
    },
    settings: {
      onClick: o.settingsCallback,
      label: "Settings"
    },
    ...o.menuItems?.aboutSectionMd && {
      about: {
        onClick: o.aboutCallback,
        label: "About"
      }
    }
  }, e = {
    DIVIDER: {},
    developerOptions: {
      label: "Developer options",
      noHighlight: !0,
      interactions: {},
      styleProps: {
        fontSize: convertRemToPx(E.fontSizes.twoSm),
        margin: `-${E.spacing.sm} 0 0 0`,
        padding: `${E.spacing.twoXS} ${E.spacing.none} ${E.spacing.twoXS} ${E.spacing.twoXL}`,
        pointerEvents: "none"
      }
    },
    clearCache: {
      disabled: A,
      onClick: o.clearCacheCallback,
      label: "Clear cache",
      shortcut: "c"
    }
  }, t = o.hostMenuItems.map((k) => k.type === "separator" ? g.DIVIDER : k.key === "reportBug" && o.menuItems?.hideGetHelp || k.key === "about" && o.menuItems?.aboutSectionMd !== "" ? null : {
    onClick: () => o.sendMessageToHost({
      type: "MENU_ITEM_CALLBACK",
      key: k.key
    }),
    label: k.label
  }, []), c = getPreferredMenuOrder(o, t, g), n = [];
  let h = null;
  for (const k of c)
    k && (k !== g.DIVIDER && (h === g.DIVIDER ? n.push({
      ...k,
      hasDividerAbove: !0
    }) : n.push(k)), h = k);
  const d = o.developmentMode ? getDevMenuItems(E, e) : [];
  return n.length == 0 && d.length == 0 ? /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {}) : /* @__PURE__ */ jsxRuntimeExports.jsx(StatefulPopover, { focusLock: !0, placement: PLACEMENT.bottomRight, content: ({
    close: k
  }) => /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledMenuContainer, { children: [
    n.length != 0 && /* @__PURE__ */ jsxRuntimeExports.jsx(SubMenu, { menuItems: n, closeMenu: k, isDevMenu: !1, metricsMgr: o.metricsMgr }),
    d.length != 0 && /* @__PURE__ */ jsxRuntimeExports.jsx(SubMenu, { menuItems: d, closeMenu: k, isDevMenu: !0, metricsMgr: o.metricsMgr })
  ] }), overrides: {
    Body: {
      props: {
        "data-testid": "stMainMenuPopover",
        className: "stMainMenuPopover"
      }
    }
  }, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledMainMenuContainer, { id: "MainMenu", className: "stMainMenu", "data-testid": "stMainMenu", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(BaseButton, { kind: BaseButtonKind.HEADER_NO_PADDING, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Icon$2, { content: MoreVert, size: "lg" }) }),
    o.screenCastState === "RECORDING" && /* @__PURE__ */ jsxRuntimeExports.jsx(StyledRecordingIndicator, {})
  ] }) });
}
const MainMenu$1 = memo(MainMenu);
function hasClass(o, E) {
  return o.classList ? !!E && o.classList.contains(E) : (" " + (o.className.baseVal || o.className) + " ").indexOf(" " + E + " ") !== -1;
}
function addClass(o, E) {
  o.classList ? o.classList.add(E) : hasClass(o, E) || (typeof o.className == "string" ? o.className = o.className + " " + E : o.setAttribute("class", (o.className && o.className.baseVal || "") + " " + E));
}
function replaceClassName(o, E) {
  return o.replace(new RegExp("(^|\\s)" + E + "(?:\\s|$)", "g"), "$1").replace(/\s+/g, " ").replace(/^\s*|\s*$/g, "");
}
function removeClass$1(o, E) {
  o.classList ? o.classList.remove(E) : typeof o.className == "string" ? o.className = replaceClassName(o.className, E) : o.setAttribute("class", replaceClassName(o.className && o.className.baseVal || "", E));
}
const config = {
  disabled: !1
};
var timeoutsShape = process.env.NODE_ENV !== "production" ? PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
  enter: PropTypes.number,
  exit: PropTypes.number,
  appear: PropTypes.number
}).isRequired]) : null, classNamesShape = process.env.NODE_ENV !== "production" ? PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
  enter: PropTypes.string,
  exit: PropTypes.string,
  active: PropTypes.string
}), PropTypes.shape({
  enter: PropTypes.string,
  enterDone: PropTypes.string,
  enterActive: PropTypes.string,
  exit: PropTypes.string,
  exitDone: PropTypes.string,
  exitActive: PropTypes.string
})]) : null;
const TransitionGroupContext = React__default.createContext(null);
var forceReflow = function o(E) {
  return E.scrollTop;
}, UNMOUNTED = "unmounted", EXITED = "exited", ENTERING = "entering", ENTERED = "entered", EXITING = "exiting", Transition = /* @__PURE__ */ (function(o) {
  _inheritsLoose(E, o);
  function E(g, e) {
    var t;
    t = o.call(this, g, e) || this;
    var c = e, n = c && !c.isMounting ? g.enter : g.appear, h;
    return t.appearStatus = null, g.in ? n ? (h = EXITED, t.appearStatus = ENTERING) : h = ENTERED : g.unmountOnExit || g.mountOnEnter ? h = UNMOUNTED : h = EXITED, t.state = {
      status: h
    }, t.nextCallback = null, t;
  }
  E.getDerivedStateFromProps = function(e, t) {
    var c = e.in;
    return c && t.status === UNMOUNTED ? {
      status: EXITED
    } : null;
  };
  var A = E.prototype;
  return A.componentDidMount = function() {
    this.updateStatus(!0, this.appearStatus);
  }, A.componentDidUpdate = function(e) {
    var t = null;
    if (e !== this.props) {
      var c = this.state.status;
      this.props.in ? c !== ENTERING && c !== ENTERED && (t = ENTERING) : (c === ENTERING || c === ENTERED) && (t = EXITING);
    }
    this.updateStatus(!1, t);
  }, A.componentWillUnmount = function() {
    this.cancelNextCallback();
  }, A.getTimeouts = function() {
    var e = this.props.timeout, t, c, n;
    return t = c = n = e, e != null && typeof e != "number" && (t = e.exit, c = e.enter, n = e.appear !== void 0 ? e.appear : c), {
      exit: t,
      enter: c,
      appear: n
    };
  }, A.updateStatus = function(e, t) {
    if (e === void 0 && (e = !1), t !== null)
      if (this.cancelNextCallback(), t === ENTERING) {
        if (this.props.unmountOnExit || this.props.mountOnEnter) {
          var c = this.props.nodeRef ? this.props.nodeRef.current : ReactDOM.findDOMNode(this);
          c && forceReflow(c);
        }
        this.performEnter(e);
      } else
        this.performExit();
    else this.props.unmountOnExit && this.state.status === EXITED && this.setState({
      status: UNMOUNTED
    });
  }, A.performEnter = function(e) {
    var t = this, c = this.props.enter, n = this.context ? this.context.isMounting : e, h = this.props.nodeRef ? [n] : [ReactDOM.findDOMNode(this), n], d = h[0], k = h[1], p = this.getTimeouts(), M = n ? p.appear : p.enter;
    if (!e && !c || config.disabled) {
      this.safeSetState({
        status: ENTERED
      }, function() {
        t.props.onEntered(d);
      });
      return;
    }
    this.props.onEnter(d, k), this.safeSetState({
      status: ENTERING
    }, function() {
      t.props.onEntering(d, k), t.onTransitionEnd(M, function() {
        t.safeSetState({
          status: ENTERED
        }, function() {
          t.props.onEntered(d, k);
        });
      });
    });
  }, A.performExit = function() {
    var e = this, t = this.props.exit, c = this.getTimeouts(), n = this.props.nodeRef ? void 0 : ReactDOM.findDOMNode(this);
    if (!t || config.disabled) {
      this.safeSetState({
        status: EXITED
      }, function() {
        e.props.onExited(n);
      });
      return;
    }
    this.props.onExit(n), this.safeSetState({
      status: EXITING
    }, function() {
      e.props.onExiting(n), e.onTransitionEnd(c.exit, function() {
        e.safeSetState({
          status: EXITED
        }, function() {
          e.props.onExited(n);
        });
      });
    });
  }, A.cancelNextCallback = function() {
    this.nextCallback !== null && (this.nextCallback.cancel(), this.nextCallback = null);
  }, A.safeSetState = function(e, t) {
    t = this.setNextCallback(t), this.setState(e, t);
  }, A.setNextCallback = function(e) {
    var t = this, c = !0;
    return this.nextCallback = function(n) {
      c && (c = !1, t.nextCallback = null, e(n));
    }, this.nextCallback.cancel = function() {
      c = !1;
    }, this.nextCallback;
  }, A.onTransitionEnd = function(e, t) {
    this.setNextCallback(t);
    var c = this.props.nodeRef ? this.props.nodeRef.current : ReactDOM.findDOMNode(this), n = e == null && !this.props.addEndListener;
    if (!c || n) {
      setTimeout(this.nextCallback, 0);
      return;
    }
    if (this.props.addEndListener) {
      var h = this.props.nodeRef ? [this.nextCallback] : [c, this.nextCallback], d = h[0], k = h[1];
      this.props.addEndListener(d, k);
    }
    e != null && setTimeout(this.nextCallback, e);
  }, A.render = function() {
    var e = this.state.status;
    if (e === UNMOUNTED)
      return null;
    var t = this.props, c = t.children;
    t.in, t.mountOnEnter, t.unmountOnExit, t.appear, t.enter, t.exit, t.timeout, t.addEndListener, t.onEnter, t.onEntering, t.onEntered, t.onExit, t.onExiting, t.onExited, t.nodeRef;
    var n = _objectWithoutPropertiesLoose$q(t, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);
    return (
      // allows for nested Transitions
      /* @__PURE__ */ React__default.createElement(TransitionGroupContext.Provider, {
        value: null
      }, typeof c == "function" ? c(e, n) : React__default.cloneElement(React__default.Children.only(c), n))
    );
  }, E;
})(React__default.Component);
Transition.contextType = TransitionGroupContext;
Transition.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */
  nodeRef: PropTypes.shape({
    current: typeof Element > "u" ? PropTypes.any : function(o, E, A, g, e, t) {
      var c = o[E];
      return PropTypes.instanceOf(c && "ownerDocument" in c ? c.ownerDocument.defaultView.Element : Element)(o, E, A, g, e, t);
    }
  }),
  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,
  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,
  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,
  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,
  /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */
  appear: PropTypes.bool,
  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,
  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,
  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function o(E) {
    var A = timeoutsShape;
    E.addEndListener || (A = A.isRequired);
    for (var g = arguments.length, e = new Array(g > 1 ? g - 1 : 0), t = 1; t < g; t++)
      e[t - 1] = arguments[t];
    return A.apply(void 0, [E].concat(e));
  },
  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,
  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,
  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,
  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,
  /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,
  /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,
  /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func
} : {};
function noop() {
}
Transition.defaultProps = {
  in: !1,
  mountOnEnter: !1,
  unmountOnExit: !1,
  appear: !1,
  enter: !0,
  exit: !0,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = UNMOUNTED;
Transition.EXITED = EXITED;
Transition.ENTERING = ENTERING;
Transition.ENTERED = ENTERED;
Transition.EXITING = EXITING;
var _addClass = function o(E, A) {
  return E && A && A.split(" ").forEach(function(g) {
    return addClass(E, g);
  });
}, removeClass = function o(E, A) {
  return E && A && A.split(" ").forEach(function(g) {
    return removeClass$1(E, g);
  });
}, CSSTransition = /* @__PURE__ */ (function(o) {
  _inheritsLoose(E, o);
  function E() {
    for (var g, e = arguments.length, t = new Array(e), c = 0; c < e; c++)
      t[c] = arguments[c];
    return g = o.call.apply(o, [this].concat(t)) || this, g.appliedClasses = {
      appear: {},
      enter: {},
      exit: {}
    }, g.onEnter = function(n, h) {
      var d = g.resolveArguments(n, h), k = d[0], p = d[1];
      g.removeClasses(k, "exit"), g.addClass(k, p ? "appear" : "enter", "base"), g.props.onEnter && g.props.onEnter(n, h);
    }, g.onEntering = function(n, h) {
      var d = g.resolveArguments(n, h), k = d[0], p = d[1], M = p ? "appear" : "enter";
      g.addClass(k, M, "active"), g.props.onEntering && g.props.onEntering(n, h);
    }, g.onEntered = function(n, h) {
      var d = g.resolveArguments(n, h), k = d[0], p = d[1], M = p ? "appear" : "enter";
      g.removeClasses(k, M), g.addClass(k, M, "done"), g.props.onEntered && g.props.onEntered(n, h);
    }, g.onExit = function(n) {
      var h = g.resolveArguments(n), d = h[0];
      g.removeClasses(d, "appear"), g.removeClasses(d, "enter"), g.addClass(d, "exit", "base"), g.props.onExit && g.props.onExit(n);
    }, g.onExiting = function(n) {
      var h = g.resolveArguments(n), d = h[0];
      g.addClass(d, "exit", "active"), g.props.onExiting && g.props.onExiting(n);
    }, g.onExited = function(n) {
      var h = g.resolveArguments(n), d = h[0];
      g.removeClasses(d, "exit"), g.addClass(d, "exit", "done"), g.props.onExited && g.props.onExited(n);
    }, g.resolveArguments = function(n, h) {
      return g.props.nodeRef ? [g.props.nodeRef.current, n] : [n, h];
    }, g.getClassNames = function(n) {
      var h = g.props.classNames, d = typeof h == "string", k = d && h ? h + "-" : "", p = d ? "" + k + n : h[n], M = d ? p + "-active" : h[n + "Active"], S = d ? p + "-done" : h[n + "Done"];
      return {
        baseClassName: p,
        activeClassName: M,
        doneClassName: S
      };
    }, g;
  }
  var A = E.prototype;
  return A.addClass = function(e, t, c) {
    var n = this.getClassNames(t)[c + "ClassName"], h = this.getClassNames("enter"), d = h.doneClassName;
    t === "appear" && c === "done" && d && (n += " " + d), c === "active" && e && forceReflow(e), n && (this.appliedClasses[t][c] = n, _addClass(e, n));
  }, A.removeClasses = function(e, t) {
    var c = this.appliedClasses[t], n = c.base, h = c.active, d = c.done;
    this.appliedClasses[t] = {}, n && removeClass(e, n), h && removeClass(e, h), d && removeClass(e, d);
  }, A.render = function() {
    var e = this.props;
    e.classNames;
    var t = _objectWithoutPropertiesLoose$q(e, ["classNames"]);
    return /* @__PURE__ */ React__default.createElement(Transition, _extends$C({}, t, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  }, E;
})(React__default.Component);
CSSTransition.defaultProps = {
  classNames: ""
};
CSSTransition.propTypes = process.env.NODE_ENV !== "production" ? _extends$C({}, Transition.propTypes, {
  /**
   * The animation classNames applied to the component as it appears, enters,
   * exits or has finished the transition. A single name can be provided, which
   * will be suffixed for each stage, e.g. `classNames="fade"` applies:
   *
   * - `fade-appear`, `fade-appear-active`, `fade-appear-done`
   * - `fade-enter`, `fade-enter-active`, `fade-enter-done`
   * - `fade-exit`, `fade-exit-active`, `fade-exit-done`
   *
   * A few details to note about how these classes are applied:
   *
   * 1. They are _joined_ with the ones that are already defined on the child
   *    component, so if you want to add some base styles, you can use
   *    `className` without worrying that it will be overridden.
   *
   * 2. If the transition component mounts with `in={false}`, no classes are
   *    applied yet. You might be expecting `*-exit-done`, but if you think
   *    about it, a component cannot finish exiting if it hasn't entered yet.
   *
   * 2. `fade-appear-done` and `fade-enter-done` will _both_ be applied. This
   *    allows you to define different behavior for when appearing is done and
   *    when regular entering is done, using selectors like
   *    `.fade-enter-done:not(.fade-appear-done)`. For example, you could apply
   *    an epic entrance animation when element first appears in the DOM using
   *    [Animate.css](https://daneden.github.io/animate.css/). Otherwise you can
   *    simply use `fade-enter-done` for defining both cases.
   *
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  appearDone: 'my-done-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  enterDone: 'my-done-enter',
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   *  exitDone: 'my-done-exit',
   * }}
   * ```
   *
   * If you want to set these classes using CSS Modules:
   *
   * ```js
   * import styles from './styles.css';
   * ```
   *
   * you might want to use camelCase in your CSS file, that way could simply
   * spread them instead of listing them one by one:
   *
   * ```js
   * classNames={{ ...styles }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  appearDone?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  enterDone?: string,
   *  exit?: string,
   *  exitActive?: string,
   *  exitDone?: string,
   * }}
   */
  classNames: classNamesShape,
  /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEnter: PropTypes.func,
  /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,
  /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntered: PropTypes.func,
  /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExit: PropTypes.func,
  /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExiting: PropTypes.func,
  /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** and the `exit-done` class is added to the DOM node.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExited: PropTypes.func
}) : {};
var ConnectionState = /* @__PURE__ */ ((o) => (o.CONNECTED = "CONNECTED", o.DISCONNECTED_FOREVER = "DISCONNECTED_FOREVER", o.INITIAL = "INITIAL", o.PINGING_SERVER = "PINGING_SERVER", o.CONNECTING = "CONNECTING", o.STATIC_CONNECTING = "STATIC_CONNECTING", o.STATIC_CONNECTED = "STATIC_CONNECTED", o))(ConnectionState || {});
const IS_DEV_ENV = process.env.NODE_ENV === "development";
typeof Promise.withResolvers > "u" && (Promise.withResolvers = () => {
  let o, E;
  const A = new Promise((g, e) => {
    o = g, E = e;
  });
  return {
    resolve: o,
    reject: E,
    promise: A
  };
});
function u(o) {
  const E = document.cookie.match(`\\b${o}=([^;]*)\\b`);
  return E ? E[1] : void 0;
}
function m$1(o) {
  return o != null;
}
const i = /\/+$/, l = /^\/+/;
function f({
  hostname: o,
  port: E,
  pathname: A,
  protocol: g
}, e) {
  const t = s(A, e);
  return `${g}//${o}${E ? `:${E}` : ""}/${t}`;
}
function s(o, E) {
  return o = o.replace(i, "").replace(l, ""), E = E.replace(i, "").replace(l, ""), o.length === 0 ? E : `${o}/${E}`;
}
loglevelExports$1.getLogger("StaticConnection");
const FINAL_SLASH_RE = /\/+$/, INITIAL_SLASH_RE = /^\/+/;
function parseUriIntoBaseParts(o) {
  const E = new URL(window.location.href === "about:blank" ? "" : window.location.href);
  return E.pathname = E.pathname.replace(FINAL_SLASH_RE, "").replace(INITIAL_SLASH_RE, ""), E;
}
loglevelExports$1.getLogger("DoInitPings");
loglevelExports$1.getLogger("ForwardMessageCache");
loglevelExports$1.getLogger("WebsocketConnection");
loglevelExports$1.getLogger("ConnectionManager");
const LOG$3 = loglevelExports$1.getLogger("DefaultStreamlitEndpoints"), MEDIA_ENDPOINT = "/media", UPLOAD_FILE_ENDPOINT = "/_stcore/upload_file", COMPONENT_ENDPOINT_BASE = "/component", BIDI_COMPONENT_ENDPOINT_BASE = "/_stcore/bidi-components";
class DefaultStreamlitEndpoints {
  constructor(E) {
    this.getServerUri = E.getServerUri, this.csrfEnabled = E.csrfEnabled, this.sendClientError = E.sendClientError, this.staticConfigUrl = null;
  }
  setStaticConfigUrl(E) {
    this.staticConfigUrl = E;
  }
  sendClientErrorToHost(E, A, g, e, t) {
    this.sendClientError(E, A, g, e, t);
  }
  /**
   * Check the source of a component for successful response (for those without onerror event)
   * If the response is not ok, or fetch otherwise fails, send an error to the host.
   */
  async checkSourceUrlResponse(E, A, g) {
    const e = g ? `${A} ${g}` : A;
    try {
      const t = await fetch(E);
      t.ok || (LOG$3.error(`Client Error: ${e} source error - ${t.status}`), this.sendClientErrorToHost(A, t.status, t.statusText, E, g));
    } catch (t) {
      const c = t instanceof Error ? t.message : "Unknown Error";
      LOG$3.error(`Client Error: ${e} fetch error - ${c}`), this.sendClientErrorToHost(A, "Error fetching source", c, E, g);
    }
  }
  buildComponentURL(E, A) {
    return f(this.requireServerUri(), `${COMPONENT_ENDPOINT_BASE}/${E}/${A}`);
  }
  buildBidiComponentURL(E, A) {
    return f(this.requireServerUri(), `${BIDI_COMPONENT_ENDPOINT_BASE}/${E}/${A}`);
  }
  setFileUploadClientConfig({
    prefix: E,
    headers: A
  }) {
    this.fileUploadClientConfig = {
      prefix: E,
      headers: A
    };
  }
  /**
   * If we are using a static connection, return S3 URL for that file. Otherwise, return null.
   */
  buildStaticUrl(E) {
    const g = new URLSearchParams(document.location.search).get("staticAppId");
    return `${this.staticConfigUrl}/${g}${E}`;
  }
  /**
   * Construct a URL for a media file. If the `staticConfigUrl` is set, we have a static app
   * and will serve media from S3. If the url is relative and starts with  "/media",
   * assume it's being served from Streamlit and construct it appropriately.
   * Otherwise leave it alone.
   */
  buildMediaURL(E) {
    return this.staticConfigUrl && E.startsWith(MEDIA_ENDPOINT) ? this.buildStaticUrl(E) : E.startsWith(MEDIA_ENDPOINT) ? f(this.requireServerUri(), E) : E;
  }
  /**
   * Construct a URL for a download file.
   * @param url a relative or absolute URL. If `url` is absolute, it will be
   * returned unchanged. Otherwise, the return value will be a URL for fetching
   * the media file from the connected Streamlit instance. The target server can
   * be changed by setting window.__streamlit?.DOWNLOAD_ASSETS_BASE_URL.
   */
  buildDownloadUrl(E) {
    if (!E.startsWith(MEDIA_ENDPOINT))
      return E;
    const A = window.__streamlit?.DOWNLOAD_ASSETS_BASE_URL;
    return f(A ? parseUriIntoBaseParts() : this.requireServerUri(), E);
  }
  /**
   * Construct a URL for uploading a file. If the `fileUploadClientConfig`
   * exists, we build URL by prefixing URL with prefix from the config,
   * otherwise if the `fileUploadClientConfig` is not present, if URL is
   * relative and starts with "/_stcore/upload_file", assume we're uploading
   * the file to the Streamlit Tornado server and construct the URL
   * appropriately. Otherwise, we're probably uploading the file to some
   * external service, so we leave the URL alone.
   */
  buildFileUploadURL(E) {
    return this.fileUploadClientConfig ? s(this.fileUploadClientConfig.prefix, E) : E.startsWith(UPLOAD_FILE_ENDPOINT) ? f(this.requireServerUri(), E) : E;
  }
  /** Construct a URL for an app page in a multi-page app. */
  buildAppPageURL(E, A) {
    const g = A.urlPathname, e = A.isDefault ? "" : g;
    if (typeof E == "string" && E.length > 0)
      return `${E}/${e}`;
    const {
      port: t,
      protocol: c
    } = window.location, {
      pathname: n,
      hostname: h
    } = this.requireServerUri(), d = t ? `:${t}` : "", k = n === "/" ? "/" : `${n}/`;
    return `${c}//${h}${d}${k}${e}`;
  }
  async uploadFileUploaderFile(E, A, g, e, t) {
    const c = new FormData(), {
      name: n,
      webkitRelativePath: h
    } = A, d = h || n;
    c.append(n, A, d);
    const k = this.getAdditionalHeaders(), p = this.buildFileUploadURL(E);
    try {
      await this.csrfRequest(p, {
        signal: t,
        method: "PUT",
        data: c,
        responseType: "text",
        headers: k,
        onUploadProgress: e
      });
    } catch (M) {
      LOG$3.error(`Client Error: File uploader error on file upload - ${M}`);
      const S = M instanceof Error ? M.message : "Unknown Error";
      throw this.sendClientErrorToHost("File Uploader", "Error uploading file", S, p), M;
    }
  }
  getAdditionalHeaders() {
    let E = {};
    return this.fileUploadClientConfig && (E = {
      ...E,
      ...this.fileUploadClientConfig.headers
    }), E;
  }
  /**
   * Send an HTTP DELETE request to the given URL.
   */
  async deleteFileAtURL(E, A) {
    const g = this.getAdditionalHeaders(), e = this.buildFileUploadURL(E);
    try {
      await this.csrfRequest(e, {
        method: "DELETE",
        data: {
          sessionId: A
        },
        headers: g
      });
    } catch (t) {
      LOG$3.error(`Client Error: File uploader error on file delete - ${t}`);
      const c = t instanceof Error ? t.message : "Unknown Error";
      throw this.sendClientErrorToHost("File Uploader", "Error deleting file", c, e), t;
    }
  }
  /**
   * Fetch the server URI. If our server is disconnected, default to the most
   * recent cached value of the URI. If we're disconnected and have no cached
   * value, throw an Error.
   */
  requireServerUri() {
    const E = this.getServerUri();
    if (m$1(E))
      return this.cachedServerUri = E, E;
    if (m$1(this.cachedServerUri))
      return this.cachedServerUri;
    throw new Error("not connected to a server!");
  }
  /**
   * Wrapper around axios.request to update the request config with
   * CSRF headers if client has CSRF protection enabled.
   * Uses dynamic import to load axios only when needed (file upload/delete operations).
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace 'any' with a more specific type.
  async csrfRequest(E, A) {
    if (A.url = E, this.csrfEnabled) {
      const e = u("_streamlit_xsrf");
      m$1(e) && (A.headers = {
        "X-Xsrftoken": e,
        ...A.headers || {}
      }, A.withCredentials = !0);
    }
    const {
      default: g
    } = await import("./index-B_94eI3S.js");
    return g.request(A);
  }
}
var Ellipses = /* @__PURE__ */ React.forwardRef(function(o, E) {
  var A = {
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  };
  return /* @__PURE__ */ React.createElement(EmotionIconBase, _extends$C({
    iconAttrs: A,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 8 8"
  }, o, {
    ref: E
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M0 3v2h2V3H0zm3 0v2h2V3H3zm3 0v2h2V3H6z"
  }));
});
Ellipses.displayName = "Ellipses";
var Warning = /* @__PURE__ */ React.forwardRef(function(o, E) {
  var A = {
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  };
  return /* @__PURE__ */ React.createElement(EmotionIconBase, _extends$C({
    iconAttrs: A,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 8 8"
  }, o, {
    ref: E
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M3.09 0c-.06 0-.1.04-.13.09L.02 6.9c-.02.05-.03.13-.03.19v.81c0 .05.04.09.09.09h6.81c.05 0 .09-.04.09-.09v-.81c0-.05-.01-.14-.03-.19L4.01.09A.142.142 0 003.88 0h-.81zM3 3h1v2H3V3zm0 3h1v1H3V6z"
  }));
});
Warning.displayName = "Warning";
const CONNECTING_LABEL = "Connecting", CONNECTING_TOOLTIP_TEXT = "Connecting to Streamlit server", CONNECTING_STATIC_TOOLTIP_TEXT = "Connecting to static app", ERROR_LABEL = "Error", ERROR_TOOLTIP_TEXT = "Unable to connect to Streamlit server";
function getConnectionStateUI(o) {
  switch (o) {
    case ConnectionState.INITIAL:
    case ConnectionState.PINGING_SERVER:
    case ConnectionState.CONNECTING:
      return {
        icon: Ellipses,
        label: CONNECTING_LABEL,
        tooltip: CONNECTING_TOOLTIP_TEXT
      };
    case ConnectionState.CONNECTED:
      return;
    case ConnectionState.STATIC_CONNECTING:
      return {
        icon: Ellipses,
        label: CONNECTING_LABEL,
        tooltip: CONNECTING_STATIC_TOOLTIP_TEXT
      };
    case ConnectionState.STATIC_CONNECTED:
      return;
    case ConnectionState.DISCONNECTED_FOREVER:
    default:
      return {
        icon: Warning,
        label: ERROR_LABEL,
        tooltip: ERROR_TOOLTIP_TEXT
      };
  }
}
const newYearsRunning = "data:image/gif;base64,R0lGODlhlgCWAPf/AP+tGf8Z1uAA76UI5oII5r0A7psI5s4A74wJ5dYA78UA794JShDKvd0JUu1CKhnLveYQN+9rGv8fzoYQ1u9zGuYjMuYKQhDWu/ecCegZMfeUDgif0wl75v8fxfaMEAFj7+85KYwRzAmE3hK5xYIR3/B7G/dOLPaEEHcz7gmM3q0I5gmU1v8evf8bs+1MK/5ERc0Icyw6+/+qIc0Ia9UIX/4XSEeSzv8jRPNSIP0nOC5n7Alz55wXrf+aMJkp7Lko5jGgzfYbr+9jHfBKIYk26RGtzf9pcv8ooWdH7TaRzvUWokKezP82PvwugQJa9hnlsP9Bq9QVYPelCOYIOjqizA3fu+YZOldG7psTtROiz4RG5v+MQkpY7QFr7nBX4P97Y/9ZjP8xvfaEH/1FOj46915U8Foy9eZjMUJY7f0mkIgp731V4GMz8CPHvdwOzgNR9ymjy6UYpqUr6NwI3v0uXmsz75gx6/8dW7UH7lJW7jSvxHBj3rwI2v5AUq0r5fAdWP8psVxr20o09+EdRl1f3v+YIeZ7MVIz9RUZ5v+MIcYAff8ub/4NUscioPh4KeIzPt4JQv86XiS6wyetxd5GSvRmLMkI3soI1NwqVvcjRdsZr4xD5Tpj78AYvv42SpU65/N7EMUpkCxW8ckk4mtr285EYxY+//sNXd0lkagZub0seSE8/BZn7P1CLqcdmyFn7P8cbi1G9Rx64ec4MT5D8pgVwf42MHlH5RpK99Enfh1X8RrWunZG78UheeMnZ8YMgL0LkWN01kRj66cQzvwtUtddUS944dY6XP4xkJsR0++QGqghqP4ef0Z42fcSkB2Q1s8Sa+EpQzpX7BBW9cwas9si3sY6ZvQjoaoplkpG8P06bPxGXv1lWddSSjN/0/NaK7wdrqUbxd4dnysd6eEreVVz1ld/0tYye/UQf1SSyf9Of/56QphG3P57OjZp2fxJcHd0z/EWcadD3YFj1DE63vlkQmeRxEAp2+UTkTNX1rhG1U2wvEBG1pdpzlRKzgAAACH/C05FVFNDQVBFMi4wAwEAAAAh+QQJBAD/ACwAAAAAlgCWAAAI/QD/CRxIsKDBgwgTKlzIsKHDhxAjSpxIsaLFixgzatzIsaPHjyBDihxJsqTJkyhTqlzJsqXLlzBjypxJs6bNmzhz6tzJs6fPn0CDCh1KtKjRo0iTKl3KtKnTp1CjSp1KtarVq1izat3KtavXr2DDih1LtqzZs2jTql3Ltq3bt3Djyp1Lt67du3jz6t3Lt6/fv4ADCx5MuLDhw4gTK17MuLHjx5AjS55MubLly5gza97MubPnz6BDix5NurTp06hTq17NurXr14sbUG4gWzLtBZNp145Me/ZuyLpz97b9G3hxx8OJH2+c3Phyxs2dCxf+PHZ169cTR0eeXft26N8nmXc/HB78eMPlFQcn7vt84fTe3ROGH386e+rKfeO/z196/v7GIRUQACH5BAkEAP8ALFMAUgANACgAAAhuAP8JHEjw34KCCBc0QFiwQYODDP85hBhR4sKKDisKdHgxYkaMHz12jEgjJEOTCB3S0NhgpcaSLj3GPDmTIY2SFWFq/Icz582XNRH+9BmU4M2iA4f6BIpU4FGgO5XalCq0KU+qVZlCJRrV6tOKAQEAIfkECQQA/wAsWgBGAAkAGgAACEsA/wkc+G/BAoIDDSIseHChwYYEFzRwqBChxIX/Gly0OBFhg48LQYYUSZDkQJMDaaDM2NEjjZAqF8ZEqPKlTJsEa968iTNnz5QYAwIAIfkECQQA/wAsXwA2AAgAGQAACFAA/wkc+G8KQYFTIB0saJBgwoUWpjQcOMUCxIWQLCgkqBGjRY6QFhxcAGnjwJALF4gkqHLlwJYjXb6U+W9Bg4UNbI68SbCBz4M/gQYdOHRgQAAh+QQJBAD/ACxkADYAAwAGAAAIFAD//bPwD9IUC1MgTDFo0ALCfwEBACH5BAkEAP8ALGMANgAFAAcAAAgdAP/9mwJJ4D9IFgRamALh30JIUxJCTOiwoEGKAQEAIfkECQQA/wAsLwA1ADoASQAACJUA/wkcSLCgwYMIEyaEZAGSwocQIyac4lCixYsJG1qYgrEjRoaQpkCo6LHkw4YhU5pcmZEhRQssYxaEBBKmzJsCG+Lc+Y8kz59AgwodSrSo0aNIkypdyrSp06dQo0qdSrWq1atYs2rdyrWr169gw4odS7as2bNo06pdy7at27dw48qdS7eu3bt4uaLSujcrub5XAV8NCAAh+QQJBAD/ACwrADQAQABKAAAIuQD/CRxIsKDBgwgTKiRoYcHChxAjPoQESaLFiwstQLIAoSLGjx8dbqRoAaRJi5AWaJzS0ePJlwpHTrEwxSXMmwVTjtSoEadPgTxJ2vzpM2VJokh1Il36zyHTp1CjSp1KtarVq1izat3KtavXr2DDih1LtqzZs2jTql3Ltq3bt3Djyp1Lt67du3jz6t3Lt6/fv4ADCx7YhFxbVG0Ns22CeC0qxWshq33Mllxjx4kPS0Zr+XDiy2lBlw0IACH5BAkEAP8ALCgAMwBEAD8AAAi9AP8JHEiwoMGDCBMqPLgA0sKHECNK/AdpwcSLGCE6tOAwo8ePFCFx3AiyZMQFFkdOgSTSpMuEDRtCgmBh5cubDDnWFMkSp8+BFXnyRPnzJkqeHClaLIoz6AILS5niJNpRqk+UUa1e1cq1q9evYMOKHUu2rNmzaNOqXcu2rdu3cOPKnUu3rt27ePPq3cu3r9+/gAML/ttkb2G9TQ7jVTxYLuO7TcghfmyXcl3JkxGj2os5L7LOd8mBvouM892AACH5BAkEAP8ALCcAMgBGADMAAAi4AP8JHEiwoMGDCBMqRLhgwcKHECNKHNjQ4cSLGB9ahGQxo8ePAhv+42gBpMmMCyBZgARpZMeTMA02EMlSJQSWFl7G3Dmz4sopKlnuHFqwYU0LQFcSXTqQJE6OFZnGrMhygVKoDaROdZiSY8uQWneKjBqWaFSdZWEuyJqWaQO2bePKnUu3rt27ePPq3cu3r9+/gAMLHky4sOHDiBMrXsy4sePHkCNLnky5smXFTR43UQe5SWbHnxsHBAAh+QQJBAD/ACwnACoATgA7AAAI+wD/CRxIsKDBgwgTKlxIY6HDhxAjMqTRUKLFiw5nVES4EaPHjwIpghxJsqTJkyhTqlzJcmSDhCJbrlyw4OXBmDJT0lTYMSdDhTtpLvBJcobGhEL/QYJElGTPfzb/LVhqgamFnU1LNti6syokr5CGZiXJtcHUpVMgUB2LcmjYqnDZ6jwLN2xSuSCFng1rt2ZUvBfNDp1KWODQv/9wAn4YFCvHGYsjJnV8MzLErYgtPzSacKtmi0cRZv5MurTp06gLPk0tkQZk1o8TvoZt0Ohs2rhz697Nu7fv38CDCx9OvLjx48iTK1/OvLnz57mbKJeOvIk66sabWE+uHXlAACH5BAkEAP8ALCYAKQBQAD4AAAj9AP8JHEiwoMGDCBMqXPhvxgyGECNKnHhwBg2KGDNCdJiQhkWNIEMOdHgRYUmRKDF6TMmypcuXMGPKlPlw5swGDUxytBmzwYKcBz2e5OlywQKFQ4kurInQ6FGjkJSinAHjY9MFUSEd/bdVasadAnMC5YoVkoWsRr2ypIHT5z9IZuOmVZuyrdO4U+LSffkU7tmzXPcWLRtXq9GxgkH6hKrV8GGciRX/JGs47D/EDZlGXgg0rVOkYDcz9JlzcsLQojmPxZw6YVXNBSG3nugQ9kC2SWczhKG7t+/frW0Dx4h6uMHiI4UbF4icIO/lB2FIh069uvXr2LNr3869u/fv4CrDix9Pvrz58+jTq0+IzHx792nei0fWBEyaJvK/I9u/f/x+/O7l5x95AQEAIfkECQQA/wAsJQAoAFIAPwAACP0A/wkcSLCgwYMIEypcKBAGw4cQI0pcOGPGxIsYH8JwmLBixo8gC8LwiHAGDYshU2asiPIgDZUwL5qMSbOmzZs4c+oEOYPjzpsNGpQ82fInzaBCXZI0WnPBAoUvmWosarCB039On0oFuXEkVYJZ/0HSupVn0ZdJsY6FZEFs2LIqkV5lC4nuVbgqachdOwUCXbxN1dK1AAkrYJpZ69ZdMHZB2sMfrTpdy9gp0qiQMQZ9mpXsv6AFT2aGmLSz5Y4VfY5e6Fhg647/Nq5m2EDvwMezFXpNCDp3xK5fBerF7Juh7OLIkyvPHHz5xKXOSzb/11N1dILHEXa9fnA794kwQBR9H0++vPnz6NOrX8++vfv38OPLn0+/vv376JHV168/PrIjyPAHX4ABXoNMGu4RCGB/Cf4XYBoMNhhhfAjCFxAAIfkECQQA/wAsHwAnAFkARgAACP0A/wkcSLCgwYMIEypciBAGw4cQI0qc+A+GQ4oYM0q0uHDGRY0gQxrkmHDGDJEoU8IwWZJlypcaTZ5ESAOmTYwub+rcybOnz59AJ3r8GJRngwYIZZIsuvMo0oM0cjLduWCBwplTISr6tfRggwVIq1rNqtKi1IJi/0EaSxalQ6z/aj79twCSXQtq07a12YDGV6t1LUASXHXvTb9Hq96FYBeSYZ6AGwvGy/axTbGN7YqdaxnlX8V1Nx+t2VlkYrp6/yHl/O9s6YdPxW5u2fU1xKMCcdOGoci2QbgEnQ5k7fuh2YR9i2e0uJKmX+UUtxKFTr26dd/Ar4d0rT3h9ILMgbszDO+dq3iF5BEq+n6eoPn2GrfCn0+/vv37+PPr38+/v///AAYooERHHGGQgQMOhGCCDA64oIINCvRgggX+k4ZBF+53BDJHgKGEgdcgE+CGR1zjYYb/kXhEGteMuOE/HV6ThogaHshhiy06aGGEMKI4kI8DAsnjkPdVSCRBQtoXEAAh+QQJBAD/ACweACYAWwBIAAAI/QD/CRxIsKDBgwgTKlyo8BfDhxAjSpwoEIYiihgzYry4EIZHjSBDIvxlsSMMkShTKvqYcMaMlDBFejyJ0OXLmDgx2myZs+dElz6DCh1KNGjJokgZzuSYVGiDBjVnzGw69GlCGkCpSnQIcYHABQug1tS6dSVLhA3CfvVKViVJjzcPgv23ABLbtilPxv1Hg+9AsJAgWfhnVy3enDSepiUsuPHcw4gVg60LAdIUu5CHAg5sITDdzEEnBx4N1iromGnT2i1c+mnf0yIV0138+F+D1wOzwqYIdXLpuwZdTt090bTpmjN/MSXO8LZY2xCXM4eb8DhziiTNIqTB/XpGRW+lvecEL768+Zx7z+elqT4ijPQEh7dXyh7h2fkKYZBsSB4/f4b9+YdQgAJupFyBCCao4IIMNujggxBGKOGEFFbI0BEWInQEhgRtmOFBHH4o4oj/eNghICQOhGGIInrIokDXXBPhEYAcAYWHMWZI4xHX8MhjhRsGCYWMFm6I4oY9EvkgjQbtiKGSSzb5ZIoC/VgQlBNieQ0qVHY5IZNUvvgPliKSuWBAACH5BAkEAP8ALB4AJgBbAEkAAAj9AP8JHEiwoMGDCBMqXJjwl6JfDCNKnEix4j9FMCxq3GjxIUMYIDmKHInwFwxFC0OSXLkSY8aEM2awnEkSpEyEMW/S3GkRRkyYPINW/Cm0qNGjSIWehJi0aUqQKJ0ebdAA5wyQL6UWpZqQBlGtE5lGrPpvQYMFQMGGfagSIVW0ZeGqJfnQpc+EC9AugCR37sqMOgXSIJgXkuF/fM365UmjQWO9hi1Akpx3cdDGbwtDgDSFr2WjZ/dGPtz3M8/ChhObJWuaJdXQe2PnfT249crXcSsPdFzwqm2NZM3mXQ3z6tLfFbn+U47zH0iHyCc6lst6YdToAm0m5I1do0OsCL1piO9u0SF08jvrol/PnmXg9n+zwo/Y1iD4+R/l2z+JP//1gw+J1d9B5ylU4IAGecTQfwgO9AswDDZIUYQSVmjhhRhmqOGGHHbo4YdaAQJiQkccdISIHwKCIkErjsiiizD+U2KMLLb4j4o0ElSijQNd4yGOMxJ0zZAbAnLiiSIO6SOIRgJyzYlLpogklC6qWCKUTkaJ4YkGWZkkhzgWZOQ/WtLoZEFldhhkj+KkmeObRa4ZI49kwlknnG5WGBAAIfkECQQA/wAsHAAeAGUAUgAACP0A/wkcSLCgwYMIEypcyPAfMGANI0qcSLHiwYcWM2rcyLGjR48YP4ocSTEkyZMoU6pcybKly5cwYxKE8QuGzJsSYdjEKZMmQxgzdvJ8WVMowqBDY+o0anDGjKQ9Z0BLOIPG04kPIUK16PTqQRoVTW6lWHWs2bNoNer8lZZnUJ1tBULU2rFBg6NSkcZ1SJej3YRWve51eJBtxAUCFyy4ixDsYIW/ijIt2EBxYsSPM0oGKrigZUgLIGXmaLOz48sWIFn4B9ry6I407Fb+FxqS7dSuX8OWrTi0BQi2Rese2ft26tWYh4tUHDx0b8bKNdot3lyx7NPRK06n3RvzXegC/WlMzo6QsWXrCrsuJc9w+2yq/5YaZp/wr0DwkC+O5lwfv0axaf3yVmcDxYbdRn0FSNN49GkUGYMNRiihQAQOB2BHUrF3IUNOJbTehD9BGB9cIC70IUJrlZhQTfOtqIiKK4o4UIswzqgIjTVOhGOOPPYI4oY+KpRVkEQuBGSRFyWI5JLZAcIkQ4C0cJCTT/5DZUGAXMlklAa1oGWVBEkJ5pgCRfklmWWKOVCWaHb5j5oFXSPONUuyeeY1QdBZZJZZBuFknmR6yaefQYDJ56BkmmmloHrueeah/xRKpJmPSilpm2teOlCjT8IpkJycYionpk9ySaqVBvlpqKefnioHEKCuhppjQAAh+QQJBAD/ACwcAB0AZgBTAAAI/QD/CRxIsKDBgwgTKlzIUOCvUA0jSpxIsaLBXw8tatxoEaJFjBxDikwI7NfIkyg5PjSZsqVLhiBfypxJs6bNmzhz6tyJEppPnkAj/gy6EwY0hj6jENXp86jCKDOWMh2KMAoNiyU9SqUIjYbTgzSsUvzVS+tWilHEVq2IkeVZtFffyp1Lt2LTukG7UqWbFWWDBVXD7qUbKqbIBYARho2LdyAwhDAkJkac+KDSxgyN3k1IWSBizCE1+wzLGTCk06BHHr08sAHBBactQPoHqXPqkw1yNxhEG5Js36cr3x6Zm/Kg2BCAD3+JuLaF5KiFL0cJG9KgKb5hL+A9XeTf5rX9rddGrLt7yM7aa3v+55qgWvMR23+2rThKV6PwIy74+2//039NfZWfQvyt15CABLmFmV4J5XYSRmbRFSBrBZU30kqNwdDLYAOOBAN+HYYoYkQUwpdRSl7lV1hJFUGVkH0ILgdMhAfGSNBmI9Zo40A+RZbjQtCAqNCHP2bmS0M+FgkZkUqG1uSTUEaZEFlSfsRilRQV9uSJWD3ZF5YSzQjmcC2EMeZELABykJpnFsRmQWG00GZBaRrUwptzIiRnnnwilKaZfSZUJ0FlBiroP3saFMQ/18wJiJmJDhTENZOeWSYLd5oZBJ58xvloEHcu2meaf25q6D+k/gNImqaeyTkCqgatCsiiooJJKqeoqonrqYjiWiufkQp0jTiN8lqQEuIYO+quhu7KLJirHhTEr22+Kq2yBE07ZkAAIfkECQQA/wAsFwAaAG4AWwAACP0A/wkcSLCgwYMIEypcyBBhL1UNI0qcSLFixIcWM2rcyHFgr48dQ4pMqKqXRpAjU6pEWbGXL5MqY4Z8CLNiLmgyc3JkqbOnT48vfwr1eXOo0aNIkypdyrSpU5lRoj6dqjAKJqpLpS6MGuUk1oxRfHWtOrYlxK8WuVZtYNHlx7NoKVotazBKg6sTX/KMK/duQrYUb8LlW9Eu4cOIE2/Vqniw0aiY6B4u+XHvxgULEN5Vq1jgw1yWMy4Y9NdwZ4M1C0pWmPkfpAWQEq4+nVAsZNaDYrsmTbtjVNumD8J2bUF375BdJfMWCCl38d2vj6ts0GDQ6H/Fi0OAVNy49JGY/a1DGg8JQnbv31XCdr59u+v0Ork7bz4eM3zw4seff219EOD7HIXnGn+6ZdbaQIwBKFFr14233EGb/abgRJgZeOBBXIU124QIXSfQhVUh5BhtUf1n0AImbuQLDKpAlBpivyVIEIoPbtQLaDR1Bo1tSZn0ImEacijkkBNtCF9lKsl432c/MqQkgpFNSFOTW+GFEGf3lTRiRFhiKBaRRX65lS9ghtmQkWWq5gtOaY7EZptwximnRLmQqRILRH6US0p4gvkWUn0idWNGORoVqKCq7NnWln5SedGcGFHFQhhxFSoppQYdmhSjTGkqUBgtzDmQpwVNmimpokaEaqqsajSN6aoTiQPnq6ViKpESrQqEJ6pB/NNrrrX+42kQxF4D7KivAoJnGL8ei1AYLETLLLHOHhRttIAwWy1CtELLAiDNHrurQdC2AMg/oTr7qqfRCgssrAeZa1C4ZcJrULoEBSEOvdsmpISs/QackKkUiYMPq6TyWy3BBVErMK8CL+RwxBRXrKqtFlOksMUblxkQACH5BAkEAP8ALBUAFQB1AGIAAAj9AP8JHEiwoMGDCBMqXMhwYamGECNKnEixIsFSDy1q3Mix48BS1o55HEmyJEKMJlOmzMjxGEiVMDtiZKkxZMybG0uJ3GgTp0+KIHdaPHbM2s+jEYNqLIq0KUOXQicWfeS0asKQRitiymq1K0GiXL2KHWoN09izFreiXcu2rdu3cOPKPYgpmlmONOeSHHRX48y8ehVi6psQE9+aLgEHLmx34eGKRHUqXozQMGGDjydiZUpZIt9BCQdlhngMU6nLnSEaBo2QtcStqFM3FC27tu2DKMfWjR33r8uwSD/zlosxZNCeHiG5Lija8u1/D4uWHqk8tOHnBqMSHG4QkkDlFv1CY1dtd7BCC4MgCEw/vuNgu58TVocEKXx7j6CX//M+EBKE+ur9V919e4lWHXr//YcggSYNotyDCibIH4MpIUhfhPtRCBMkVvjnYXoDatiRcgoOMgWJDzqon4gVqfjPfybyF55+o7HYEH/zsReacDZ6duCKBAnHF3c99ufahAvxRmRq8bUGJGREiaRdauXVOJCBI20lnVKTxTVYXVVt+Vdn7401U5FoNvUkhdI1uCR20k3JkJUDOSfib0RRROeV5lFYnEtpXcfYm5SNGWg0DIF5n6EaNZYogQ91qVqfaZpEaKWYZipRByzcCZxKHXTQkKiUlfapSaQuFGpqyHnF6qlVeUL20lipNtWmrKem2apmgGoqUKwWnQnTqwfV6tRveEnaEbEFGdvUrDnlNlEHYTDk7D/MOiVsshWF2qlCqzYrlrSpXYvUtr5G6xan5k4UxD9KwKSsVd42+21ESojzbrrimvvuvvyC2+m9AwVhMMABG8RuGK+yEATBCavKAqdhsABxxAlRGyrDF2OMUL2cWuywx/0qXPHAJBPkrbMNkxxuRBYbhHCa9Up0cRBKaJIyRUGIs/PPFGULkTj4YHxtxwURXTS/LxNkMNDiHjQz1Ak9TfXVWC+LdNbYNjS10e06zXXVX49ddpoBAQAh+QQJBAD/ACwSABIAewBnAAAI/QD/CRxIsKDBgwgTKlzIsKHAYsUcSpxIsaLFiw8jYtzIsaNHghA/ihxJcmG3bhpLqhwZ8mPLlTA9vuR48ljMmxwh2ux4EqdPjMW6eex2LOXPow1RCuVIiRLSpw5ROsXYFKpVk0U3Np16tWvBk0stVvVKliClUhe3ll37T63YR2zXjo1Ld2JTuHXzNpyrt6/fv4ADCy4I0ehgj48Sd4SI0vBhjo+i0SQ68/HCR5gYRotMNWhYyw0TZ1YYTbJYSt0o7QTtMDJehKVPu2U9sbTpg6UHUdzKlTZF2wl173602vdv4cYtOk5+tXDQiJ+hbh5t2Xlj1G2fbt5sXChl1LP9Ow6yAtv2a+ZOeX8cBCH4I+TMDfYmeH4hJIFWIMAvuD8+Q8wAKmQFewJZ0J9/GCWWGHAIQUIeBJC0h+BIkt0mEHxWOOjgP/rpN6FK44X4jwUZQgiBBRB+uFKIHUYYoQUbqhhTi1ZMYeI/98k4o4YlskegjiOxB4mQGebnoH4DAinSgO1BmKFwuu0Xm0D1KbmQcB6SKGF501lpkY8cHjhQha5V6aWAyIlpkJlmIrhdcOR5pN58xgE4pUEiyrkVWN7ViYliTzVFGWPLCaYgWYMWduZNlS1q4aLheXTnmer99ihBpbX54UmRNsRdQptpimBNhf73p0IByhhUUT1ZdP3oZaL6Rmh0FREXmorOdfSqXx2opOhHsa7VQa8llaojsQ4hu+hEwyar7F98/dTsQtMK1ulNzyJUrbXFxZWtT9cyBF5d34JLp0So0bqsWdGiS9S6CaW2EVhHbcvWuzkZ29Cw5Rpkr0D94pQuTVlxxC9D3/77U2MyqVvRwQr9q/DC3V70q1UB44SSSBf/pQRJz3FcEsQcfayEEuJ8zLG+wto7cUJBoFwsy3/1Wm4Q/+CMU8eWNZttEEDrvDNt/B7MAgvwflT00UcnbXDRYWTs9L4+D9v01BLZ7K/V/yCNNdUS9+r11wdpLdHVBAkNb9FSFzT2QECLkzTJH8VM9t3SRbZdkDjO4E3Qt2ojJA4++PitcBBvJ0Q43uUmrtDifhsEdOSUV67Xy5ZHLHXglmMOd+Z/OzQ56J7DzXnkegt0OugLje50QAAh+QQJBAD/ACwPAA8AgQBuAAAI/QD/CRxIsKDBgwgTKlzIsKFBQ4YcSpxIsaLFiwchYtzIsaNHhhAjfhxJsqRDQ2dEmlzJMqLKjxpZyiwZcyTKmTht1vSY8kzOnxwh+vyYEqjRiyGJnhl6tKlElC8xLnVK9WlRjkuZVt16sGfHqVzDdtVqEazYswOzbjzjgizasGovdnP7lmvcim1d1K3Llm5DF9328u2mV7DhiX0PK3YIeLHjxzsfS06ZVLLkkJEtk3RACcTXnlE1l5z1CCto0Rg7M3xE+uKZuWZRW3TwiNLC1mWz+pXtkPQshbgpzm27m7dE1qURPnpUgWLe4sYn+k7Y3HlgyT1Cf2QevSNml939936HKhZ5eIFCod49itzB+YK6s3bDMdJKdYMVkP9+3/Vf3+sdWWFFQsvtx99Cftnm0ID/CMjgQfcdWBEltNGmkIMCQfCghJs9Qtt0CAn4DwSDQMChTKUlN1CEVkAASYsjlrjhiStVMIiNGYzYIiQutjgjjTXaJ6OLEBBpIpBAOcijkSMiaVSRJfIooxWDOClTBQ7u2KKGAtoYoZX1iaihhgTZV1B+AxkIJkUMZokhQr6xtiZHIjb4I0EpztKZgnNSZOODdx6kJkGFrQkihF9iRBhb/iFJSZwIVWDjR20NpxZ0qHVmYVPxnfYeZ4M6tZR6lfWJ03imFqQiTf9oZ/1YW6Otmqp/w1UUnEEFzuqfbrbKquqmYknQwU89xTbRIyD4StAseqIlQU7FYqocZwxR6OyzFGELUrEcAauQe2cJm+2wC2Em7UIU8mmZtg5JwG5GpXYErmjuSiRuQt/pStC7C9WLb3b6FnQvQ/4+5kKhWxWc0MCPvXauTPwepLDBD3MVMbSE5VYxVRfnBKtrxgYMH6Maj8RwdyEjlvJF7pLb0MlnrYyYqxi13G7EHUMrs0NelSRszgLh7LKoGyN0lc8TG5Q0zEYdvRF5zlqkxD9TY3WTR/FqpoQ4SnQtjndF45uZzx0A7dDUXXdtk9PejU2Su+8yrVAQapvkNkZ3z+P07MVB/NN3Tll710NV4g4tUBAsBPH3qTSj9rOww3bAAlWBR9dyB5izMDnljWvWMuSGN2XI4OfZDPrmIle0t9KYD4t66vbCzfo/ocMu8T9mEyS5QYun/njuuvNOt8i/lzS8rrLbHizwBCmBj/ILH/Q6Qs6I8zz0+0aMeEPOXI897ghNrxA+vzjzfUKJT0Q+M+d/9Ev78Ktee/yxM9Q7/QMlfdD9+IPfkOL9yx/wABhA/zmEf/DTX0IQeD65LZCB2FPgAwtYEQhSECEEDFhAAAAh+QQJBAD/ACwPAA4AggBwAAAI/QD/CRxIsKDBgwgTKlzIsKFBZcocSpxIsaLFiwkhYtzIsaNHhsrEfBxJsmRFMSFNqlwpMGJJMTBZyiyp8WWJmTg91hxZwlDOnxshiuTZE6jRkzE/UvB5tKlDmEM7GopAwalVhmIM3ey49KpXhSW2cqRwpurXswR7Ruh4Zi3atwKXur14Rgjcu0vtYhRS9y7cCFMx9vX79wxdIS4Iw61r2OK3xorR8o1MWSLjypgXPs7MmTLKnZ0xwwzpMjTmnqNNr3TAmqvWElFVm2y9EXCEsLIv0lY4y8EsjIC75tbtgNLCWb8tti0LeXhF1skRIlfOd7LzjcijG5xVQXvDMzj9Bl/nmD2h94aP9WYGTXL6eIwQ44sU+/5sxJBQi37t7aD+P5g9USCXYc3l1Ftv/qU1lSF8RSBeRxVUIF13CCZo0FoOWtdRBhJK556FClVyUGISWSGQFSiaB6JuLlACwj/nDZRBiv9YAcGKJrnAGmuPvIhQijaaiKNK5RHU4Yk2QmIiBCgKOeRKEVYwiIQQVAkBJFXa+ORMUTaZ5JVabpmTFTOCWSUkNYr5k41nBonikWqWFCGKTNbpZpRxmmRFBSbS6eQ/ERb0YZ4XddjkjGSah1xxhG7EJ5K8LcoaiY1OFOEgA8GpUH8HFShmkQcF6lF1hs2FY3Eg+IYQnh6lt/0cWf+YlaCOuwFViYNLLYWbfzpSalWuqKEUW6UrQfVZacTGqNM/7FGm4UeDEvvPcp4yFC1BvfmIlgQSAEWWg6Y6VKF0jL7FbU4DykoRqpvW+lW3FsHbUIDCPefuQQ74+q68Ep2L1WtMYZRvQ/p65W+//CKEH2wdueCwbAkzdPBBEBmS0kcFczbxQhsXFF+zxEasUMcExSftQSSjLHLJbz14VcoEwUzYZe82JDNhz1a28kw0U7RcZjvPlPNEuH50s2o/Kwer0Ud35uBGuZLEbdAFNX3U02PRxzTVA5HMNUu2cdST1ltLrPKvhqiLkX4mTc1xxBJ0cFW9G0F119cG/inxjxJ6b8R2R6nlxvfgzgC+K+BJyeR2R0HsPThJf3cEUQ84Ld413gM9/lLiH5nsVLcrs/BP4zihZBLIP50bcQtBtJ4Taad/PnUHcncgulOoDzd13LTfflTuEM9Ou1eej+c2t70Tr/s/cPP+j9wnY7S7QedCH32/zE80fEGkX3+55Q5ZP1DrfUe/O+YOBVF+yFZ7nzr6AjkjjvtmG+R7Qs44gw/9CJHMQvcKcQYz+Ec9hNxvIc74xQAJuJD/TQQdCmRgSSAYDwlacCPtu+DIuNYCDW6wIQD0YNXSF0IRMg9vrDPhCCVSQg9msIUXzODoYChBGbrOhDIUCA1VyJAbCPKwIjvMU0AAACH5BAkEAP8ALA8ADgCCAHAAAAj9AP8JHEiwoMGDCBMqXMiwoUEMyhxKnEixosWLCTVgwMixo8ePDDVEBEmypEmKHjRoOMmypcCNJj0oO+GypkkMMEvKtMnzI0STJ8T0HMpR5UiQYoISXVpRpAeSJWgynepQ5tOPJbJS3crQg1KPWSlwHZsw6UcKYsmqLRgUlEe0a+MO1Moxwpm0cteGrRshQl65aPFWFOL3b1y0hjAKOWNYbt/CFIVIbuxYCOXLEiMsxsx54eTOoCkbzRmas1VlpEtfPqHMQ0rVLV04wBqUNWyXDhy44Ji1hNnbFl3sXpibI1q6wIMXVwhitsUIgUskx5jbOUIQs0AMJgx9esfc2v0Rzsoe+Qxh7x+xhz+4XqJky6ClHDWJHT1HnKiVrbxqf+1Gox4kJRRZuQ1nn2sz9VaCWJAN1Zxu/RUkBigLomVXgx1VUMF12S0XoUFiUaAZhhhpmNB47X2YEIn/DDFRBgJlYAWM16mIkXCyWXdQBhVYIZAVPtp4kgtDVEceQjL+A4EVEAiJ2z8pbjgQkEs2uWSSTtakoYY+MgkBBJBAMMiSWfK0ZY8ZfBnml02WOZSMVIL55T80utkTk14uCaQVUtrJEpdU4nlljyb6eVIFPP4DJJYCFTpQfYZm+OOMe/ZpUIcQRspRoYkmBMKDurmoaUVbDmSpQgYWBF+kuc2S/ZCjHS1m1z+CCZmjAymaCitHkvUV3T/SqYijjkNBd5xvX/VHZKpUZVVba/qN2pNVIv0k7UCusrQSTqHNWlJz1xYkYl8VgYtQdXJJIAFRFYpYkYcHFShXAOvy1BtcFqGbkGzMjlVvRf8ylFRvFwlH7EFEphuwQ/Q2FGBtHQnXUL9cNTyRuiFBKxVHLuBAMWcLM2QxQhBBxJ9HOAAnQQASYZxQydGGS1DICq2sEE6pyfzPyAvxfJAUcX1Gls0LuQwaYYyRxTJDRHfLYmNLM3Xhc/hiFrXUTzcUGEhG9/fYRceRRC/NwFVtEcFid90z2WOZfVEJbpk0tkNNz8zVXhz+CciSumwPRLPa7CKX98ZyA16Qz/8Y3pASYBGOkUyOD20R40o401GyHsm0EnBKdF454x2J4RVIIm1eE98ftfCP56CDFGBJ1fI098xXL975SQjepAzQVK1LdhD/AM+TSCdxu1XDIbPQQhCqDx9zSbwzNTbqHXSwFQam98e3BNV3wAJV1mo/Pfdj4dzf3Op2P1b0sPlu0NjWW6/zRWPXnvi68s9P984TVW9Q8/oTiLpmJ5H8DaQFt5vfygZoEgTqjIABVAviGOIMy0WwZgf53kIqaMELFqRuA2GB8DbIDA8eDiEabAg6nFFCEypEeRNBBzpg4MKSoCMe8aghSXKowL5B6bBl9vvfDxUyQSEOESE+HAjzjvi+JApkeUz84EQAGMUiImSETFRcQqAYRRAyJAhY/KEVFULFKFIEjGa8SBnDFRAAIfkECQQA/wAsDwAOAIIAiAAACP0A/wkcSLCgwYMIEypcyLChQQwYHEqcSLGixYsJIWLcyLGjR4YaIn4cSbIkRQ0oTapcKVCKSQ8aPLCcWVJjSQ8yaersaHMkzp1AN2JIOfKEmBNBk1ZEqaEoUqVQHcbM2bEEKDFRszLE+ZQjKKtawyb00HVjiRJi0xo0WvYiBQpq4w48cXYjhQhw5cb9CmpjBLx65ZZ4i/FvYL2ELwqJcFju3bwUhUhuLNcw5csO/wrBzHnh5M6gKYfsGZozTJQiS5s+3VS1yiEuhnQ8cULZCaquTTpwwdHq0ba5JcZm6KA4RgpfgQeXOMS4QhAOLuJ9i3b5xd3RE4IAYfHvdOsc/YtnPwhiFveJki2D51j+PPmKkjeDlpK65Pb1G+lDTIkbv1iXQ01F1j/VZYWdf/9MxdZXcEEGlHi8ITiXGAy+pV5HFVSA0HbQjSchQWjddeFGFVihnXkfMsSYQbJJlIFAVmSg4YYpXoSDCy44h1AFGZj4T481mgRbc8W5Z5AVJloBgY9B6vaPkf/MKFCPECz5z5JANslShlz+o6SSkHzJpJYrcVmiklVCAgEkL5K5U49Uqlmll24ChWaVS2IpZZ0lZRgjknn+aSafJvn5I6AEZVhQeYRyNCOSPZa456IdRtjoRYr+OOmi4g15aUVdCrQpQpYSJF+jRSaUaUeLGeb9YI2wibfjqhy1Ot1X/ygH3o05QvUWBVaxpYyEN7ao1VW34cTUpzqxBlF9n0I5UlMYuNSZd/Z5yOw/eI3YkAPSDiRrXAEEENRZj1Wk40HFlSpWABLsRBeD1/WaEGzuhmWuRfs2RBaFBVKEo7EJuYCDXOVWlPBWHvzG0Y0NHUxuvBPByxAGMP30sMG59evQwghBpMxQI0nsGsgMWZyQfiRvS5DHKcNckBT0uWyQyjEvZG1ai6mFMkI4X+stVDIf9DNnQzdWtE7YVvRrZ0szvaJF1H0UNH4WXsTXSOVSjPWrFJ2l60VdS3S1WnVxRJtJZTd09D9R67T1RmypBG/cAv4VLYHXStEVMEYas/32yzKf7ZASs409EU7DImwR4kogTjdWHy0bXOSYO9MRTv1hZPlMd3vUwj+YS/5R4B49q1O5MBuuUBCRm4RS5xxBtLNS5i7Nwj9B7EQUSdVqlTDfArHQQhCj6xRSayTdHtTde8fbQQdZkYYf9B1IMH1U1oPXNbx7h0UztMuVDf72WjlfWu43R/8P9TaTzXr778dfMdwTaW9Q7/YPdPfgCYEfQY5nOpf9D28VaUEBPzW//pELgQZxxgIdeLOD7G4hzsggBY1WNBZcEIPM2GBBdCcRZ6AjhCJUiAcngg50/CKFJEFHPOIBw5HQMH6uqyFFADiQ5GDpEGgQ9OEPK9gQ5A3xZhD8x/GOOMKJCPGIPNwfE/NGPIYskYlR3B//hpjFgzxxihIJwhbB6EQymvGMaEyjGtfIxja68Y1wjKMc50jHOtrxjnjMox73yMc+pnAKUwBKQAAAIfkECQQA/wAsDwAOAIIAiAAACP0A/wkcSLCgwYMIEypcyLChQQwYHEqcSLGixYsJIWLcyLGjR4YaIn4cSbIkRQ0oTapcKVCKSQ8aPLCcWVJjSQ8yaersaHMkzp1AN2JIOfKEmBNBk1ZEqaEoUqVQHcbM2bEEKDFRszLE+ZQjKKtawyb00HVjiRJi0xo0WvYiBQpq4w48cXYjhQhw5cb9CmpjBLx65ZZ4i/FvYL2ELwqJcFju3bwUhUhuLNcw5csO/wrBzHnh5M6gKYfsGZozTJQiS5s+3VS1yiEuhnQ8cULZCaquTTpwwdHq0ba5JcZm6KA4RgpfgQeXOMS4QhAOLuJ9i3b5xd3RE4IAYfHvdOsc/YtnPwhiFveJki2D51j+PPmKkjeDlpK65Pb1G+lDTKkcf1aXQ0111D99aYWdf/9MdRVdaEEWlHi8ISgQVnSB8tZdJFVQAULbQTeehAQNdpdmHlVghXbmgcgQYwbJJlEGAlmRwYYcqngRDi644BxCFWRw4j8+2mgSbM0V555BVpxoBQQ/CqnbP0f+Q6NAPkLA5D9MBukkSxp2+c+SS0ICZpNbrtSliUtaCQkEkMBY5k4+VrmmlV++CVSaVjKZ5ZR2lqShjEnqCeiZfZr0J5CBEqRhQeUVyhGNSfpoIp+MehihoxctCiSljIpHJKYVeSkQpwhdSpB8jhqZkKYdLWb9mIM2wiYej6xy5Op0X/3Tn3U46gjVhVaxpYyEOLqo1YI4sQaqTqxBVB+oUY7UFAYudeadfR8u+w9e6knkQLQDzRpXABIEddZjFe14UHGmihVAADtVONh1viYEW7thwWuRvg2RJUauFuVobEIu4CDXuxUhvJUHv3GEY0MGj8uvQworhAFMPzlccG4TN1TxQRApM9RIEbv28UInF6TfyNoS1DHKLxMkBX0tG5QyQjfLHNdiauXscsyUXeuux0AHzWJnRc8kNEUXIp1Vt0xTUF1HPgf31tEU8TXSu0mrlthFZ+26b9UFkR1VXRzRZhLXFMfc9Uxab8SWSu+Wi/JB5P5mxaBHGa9Ndsp5W6TEbGJLhNOwBwv+jxKDy43VR0wtx/jkjW+ULOREzVS3Ry38E8TkJPXtEWkssf0zRZ9XLm1MJDlbLVTwAs2C5ztlPhK1WiH8MgstBNG5TiG1RtLrSdVNbrkddJAV6evVLcHzyUfFvHVcS0Cu8lrN/OxybB8vAfb/cf/Py97/A37NCZt+ut3oUzz+RN8bFET7LltvdkHsD9T7/Ohzff9ELVAdqNRHv7T8jyBKcEYB72aQ2S3EGRBcIN5ixgIHPhAdEiwbQizIEGeggxkZXEgFJ4IOdPwihCRBRzzigcKRsLB/b2sh0RjyOxniLIY1tKHNHBIEDoHqUCD/690PNSiRHP7wgLQb4vhiSBAhDhGJnuOfDqEoECMqUSJBkOIVAbjFLnrxi2AMY0WmAAExLoSMZlQIGtOIEDJagI1thMAU4GiQNdKRIG68Y0HsqMd/kHGOfRQIH/U4yDvmMZB+lCMiC0nHQwaSkXD8IyITOUlIsnEKlixJQAAAIfkECQQA/wAsDwAOAIIAiAAACP0A/wkcSLCgwYMIEypcyLChQQwYHEqcSLGixYsJIWLcyLGjR4YaIn4cSbIkRQ0oTapcydKDBg8sY5LEIEUkSQ8wZersqPFmzp1AL2JIOfKEmBNBk1ZEqaEoUqVQHb78ybEEKDFRszLE+ZQjqBJawyr00HVjCati0xY0WvYiBQpq4w48AXYjhQhy834FtTFCBLh545agUNei38By3wKuKCSCEMSJ/14U8hhy3MOWMzv0W1mz54SUP4vOHLLn6M8uS58WjTP16pVDXAzpaLT1a5YOXHgtcaL37YuyGToY7pbw1d8YhxBXCMLBxb9vCyOvmNt5QhAgDPt9O53jcOsH/UHMyj6RMubuHMWTD8+48+eaK7Gj31gTYkqs8+NK+Td06tF/fGlVXX7/THUVXWAtFtR3uhEoEFZ0gaIYXiNVUAFC2DUHnoMEDXYXZx5VYMV143HIEIUFzSZRBgJZkcGFGJp4EQ4uuODcegZVkMGI/+woo0mxKTccjgVZMSIEVkDw40pDFgSjQDtCMIiSSPq4JEsWZvlPkhB02aWRV8qUpYhcQgIBJEmGCdSOUZ7Z5ZZqApUkl0giaWGcK1no4pxdsmmFlniWpGePRoL5z4VPCiReoBzBCOaOiRqE3XC6qchoRYO+yByDll5K0Z0CRYqQc50K5B6eTSIEakeNHab9oIyxfafqqhy1Ct1X/7Q1H402QqWYVWzB1NSuwYV14Ak4MeWpTMKiBJFNyxI5UlM0jXbeR80tW9Bf1zrkgLQDyRpXAAEEddZbKEq03Ki5yUXuThEOdtGACQXp7kXlOkSWGLhaVGOpBxWr1rsUEbwQTkfpShGNDOGQl8EOQYwQBi7h1BGNDr+Wr0QSFwSRMkONlLHGGzPUMUH1hawtQSWb3HJBUsC3ckEnH1TzQPup1djALxt0M2J+pZtVzz4TbVm3mRkdU9AWKfaZ0ksLPRF3H/18G7oXnRWgR+RCfRrVF32lMEZdc+w1VGdxxJZJZTd08tkr7aX2f2xb/U/Pdv6vhKBHFqvUdkIdByDBRUrQNjZFOCnzsEWFK1H4Rmt7pOxvjlf++EZ9S05UTH9v1MI/lvs0E7QsdX433AMFocTnJaFEFU8Q5QxVuUSz8E8QO00+UrVD024QCywEwbpMm5Mke1JdCz64BB1kZVp+XUsgfQfNQxU7gckrH1bMpCNXtvLMb+/93UVL/0/1Sr3pvemn/zN4VBCweJrvEoVfEO46xa+kZtlT9D5BLQgC/mKiPsj0jyQtuNxK9GfAvGWmgPNxIEGU4AyVMBB6B0FfQpzBQZNcsDsnA15DOkgSCE6ndhJxBjrQMZIPykiEElnhLz5iwpkNBB3xYCFHXGhDgr7EwyPxW59majgau9kuKzwUTd4GCL8M7G9+DgmeVojIP7gFcIpOXA3q/jE8+D3xaVtkIlSS2ECKXBGLX7SMBAUiwLBQ8WFbHEgXx5jFH7Vximnk0BzTV8ceWlB+fvRgHgMJxD4SsoWG9IIXDrmRGiKBkRghIyQv8sZJUkSSlrykITNpkUpysiGY/CQoBylKh4SylAoJIior4slVHuSUrjQILGM5kFbSspabvGVCbKnLWfaSlLosiCqDmUpediQgACH5BAkEAP8ALA8ADgCCAHkAAAj9AP8JHEiwoMGDCBMqXMiwoUEMGBxKnEixosWLCSFi3Mixo0eGGiJ+HEmyJEUNKE2qXClQikkPGjywnFlSY0kPMmnq7GhzJM6dQDdiSDnyhJgTQZNWRKmhKFKlUB3GzNmxBCgxUbMyxPmUIyirWsMm9NB1Y4kSYtMaNFr2IgUKauMOPHF2I4UIcOXG/QpqYwS8euWWeIvxb2C9hC8KiXBY7t28FIVIbizXMOXLDv8Kwcx54eTOoCmH7BmaM8zRpUHjPJ165RAXHo2ubs3SgQsHG7+e2E37ooshDB3gdkvBKtbeF4cIX7jcIt63aJFftD0cIQgQsyr+fS6do/DqBv2xg4i8mHH3juITjidfWopIk9fPb3QPMeVx+WpdDp169F9frdTh989UJRj11T+QBfUdbAIKhBVdoLx1l3keVVCBddc112BBg01IIUcVWKHeLOttqNCHAwEnUQYCWZHBhdaZeBEOLtwGnkEVZCDiPzrKaNJryglXokFWiGgFBDv6aBJuQ/4Do0A6QoDkP0j2qCRLFmb5z5FHQsJlkleulGWIR0oJCQSQsBjmTjpGeaaUW64JVJlSIomkhXKKGaKOXFbpopZ5lmShiHxCMNCFTwqEXaAgtuiiFSEmWlCGtv2jIqMV4cmjpJMueCmmEwHqZEO4fSrQZpgKmZCmHZXH/ViCMr72HUKicuTqWwe2JR+Nt0EloVVsydTUrr+JddVuODEFKk3CogTRe8s2OVJTGLgEmmUjgXDjsm9hK5ED0g40a1wBBBDUWd1WpOFBwjGoVrk7QTjYdMopBKRc5lqUb0NkiXGgb+4mVCy5+0oE71YeHKXrRDSaehAOeh1scMEIYQDTTxzRCHFrFDMk8UEQKTPUSBtz3HFCHxtE38jLFnQyyi+35F7LB6UM80LWprXYuzEPZPNl26XVs89DVzTITN5iVjRFgyxw9IlJOyRhZ0tTBMkgkCwUtUSJefQzZVgvlK5FZ/3n9deBXQ2mQV1bpBtJ5Vb9D9ozXZ1QXRv+sWVS3A79LLdFYSPEF0d67023QCcfzpGXawtEV3QcYWz40DYHIMFFSjgEwSCGrrVwRTgpE7FFmSuReUNHHlR4R8r2ZvrrpzeEZOOSs07UTHx31MI/sF+UOkGzjUQaS7kTTVEQSuy+EQRWDhQTSc/mrJS5L7PwTxAqZcC887d/VK1W8HbMAgtBWG9SBmr+MxS0I0kfVNzlXi5BB0Bpn/7w58Utwf4d0F+/ms8SEPwsdzmlMI9FUnCfdPhGwP1BRXv/SCByqGeQ+F3Of0lBX3fgV0FzFfCB2wsNBSUyP4NgTyfoSx9lBkiRDw6kBUE44UxC2BgWkqQFsVsJ+joXmOLk9UaDAvybQJTgDJUcUIAHMZ9CnMHE89FwgSfrgBKXWESSADF/CJniQpyBjip6xH5XGt9E0IGOX3zkijQzCDrigY6OHDGNCInHF3loMsygMTWK02IGnyjCpckwKinkmEPIpxU+Uq1qMNTKDvE4EeVl5Y5K+9sfofJGziiuIIlUpCELkoc8iOWSBIlhWCBpkDyUISygxOQoN0mQU/ZGlIpUoUHK4MreODIqlSwILeHYEQgeZJe83Agp/1HLYF4klwIpgxeMyREwEsQLSGCmMGX5j2hKEyPOvOYZqalNjCCzm9jUSkAAACH5BAkEAP8ALA8ADgCCAHMAAAj9AP8JHEiwoMGDCBMqXMiwoUEMGBxKnEixosWLCSFi3Mixo0eGGiJ+HEmyJEUNKE2qXClQikkPGjywnFlSY0kPMmnq7GhzJM6dQDdiSDnyhJgTQZNWRKmhKFKlUB3GzNmxBCgxUbMyxPmUI6gSWsMq9NB1YwmrYtMWNFr2IgUKauMOPHF2I4UIcvN+BbUxQgS4eeOWeIvRb+C8hC0KiSDksNy7gCsKaew4ruHKmB36pZy5c8LJcUV6Hk0wpGjSnmGiPI0aM06mrVcOcTGk44kTyk5QjW3SgQuOVo+25S2RNkMHyDFS+DqcuMQhyRWCcHDx71uwzi/6pp4QBAiLfv2tZ+eInPtBELO+T5x8eTxH9OrPSwY9Wgrrkd7db7QPMeVu/WK5NNRUZP2DXVbbAfjPVGx9BVdkQJX3m4JzieHgW+11VEEFCHk3nXkUEgTWXRluVIEVHJ6XXogM4WVQbQ6laAWK0rF4EQ4uuBBdQhlYIVCPNpo0G3TIxWcQkBBYAUGQK1Fn5D8cyqikkv8kaUUGTM604YZX/qMkBJBMiWWWWm55JZgQoOkjmUDNmKaaXrK5U49fvjnjhnKydCKdSSbZYwZb5llSoHTOOFCUBU030ISCUiRljyemeN6HjDZqEZ7/AFojckNaWlGgAkm6UKUEcZZnkQlh2tFihkEY/Rs00PwTK0KzlYcQqKuG99ZX/zTXGawJ4agjVG9RYBVbyrQGLEI4wqjVVbq9RlRmsEZBmmqm3RdYFLOa9ORITWHgErVRYEIffiB6+k80UURxhosTOfDtQLbGFUAAQZVwBiZRPFLRjgchR2pYAUiwE11fsWstRQ5Ap9BsA2uFr0UTN0SWhWC1W1GODLmAg1z3VhTyVh4IN1AUDVDUbEMf22vwRAUzhAFMPxGEMiYT4dhyaxU7NDJCECkzFEIoq0zczwzFnBB/QyPUQAM4s9lz0lMXJIV9C0GdstQvU73QuAw1MMhMi6mFNEJKe/T02CuFl1bVB53N0SBbLwQvRSX+Ygb3RnSzrdDdExXr2d4bLTCI3wi5bdF1H6Xt2SCQKCT4RXuNdG/XmUFyuOSuUnSWrxddLpHjQQ2y5kGgGMvRbSaJ3pDc/xDukeYJncXXRmypVLDsAsEtAeYmDQIB4iKCPlHNrcNOkNykS6SEQzOePhfrHeGULMgWPa/E8w0ZapBR4E4b2/bkOyNR9Abh9B9GsNG0u0ct/EM+9xV1WRDyHkGkbUn3Tt38QkHYHkf+VJqY1ERcWcHX3ljwjyCoJANjEoj4PoLABOILeP9gQQuCED+dhKQpJQFbUnb3O4N1oANZ6QmASCiBE6IQKip0z+UK9ruwXG1/sREdDU9oQ+fUKNAgNDShujrSv6rFDINDfF3sJtJCgzgwiUCUQP8o8kKCbPCJUNyd8jDSAvqpa4pQDMwWE6IE84VRiQZh4EKcwcYzKgR2LFDjGpnhRrQhRI4McQY66FjHhsRxIuhAxy/6qBJ0xCMehDQJIrUijLch0T3CaKRYxiiQDqImkpPkXSVjI0mCOYSDl8xDJh2ywUu+bSKW7EweREkwTRIEi6qc5CMTUkpVslJirnwlLCuThzK00iKprIwviROEXQamDMMkTjDzgsxEkqSZzvxIMqPZkWnOJCAAIfkECQQA/wAsDwAOAIIAcAAACP0A/wkcSLCgwYMIEypcyLChQQwYHEqcSLGixYsJIWLcyLGjR4YaIn4cSbIkRQ0oTapcKVCKSQ8aPLCcWVJjSQ8yaersaHMkzp1AN2JIOfKEmBNBk1ZEqaEoUqVQHcbM2bEEKDFRszLE+ZQjKKtawyb00HVjiRJi0xo0WvYiBQpq4w48cXYjhQhw5cb9CmpjBLx65ZZ4i/FvYL2ELwqJcFju3bwUhUhuLNcw5csO/wrBzHnh5M6gKYfsGZozTJQiS5s+3VS1yiEuPJ44oewEVdcmHbhwYPbqbNwXXQxh6IA3Rgpf2wKfOKT4QucW8b5Fu/yibuMIQYCYVfGv9Ooc/YtjN7gdROTFjHHHGVk+ofnzm0FLSe0qDo+P2sFznA8xpSserugXl0tDxWQNgGldJ6BAMRXjiitnfIUWZECJF9uCA6lSylmgvHVXeh5VUEF22kGHoUETevdRBVa4N8t7Jy4EYkHDOZSBQFZkMGJ2MWKEgwu7jWdQBRm0+E+RPb4mnHgwGmRFixBYAUGSLPHW5D87ClQkBINMGSWSVM4k4pj/SAnBmWc+GaZOY7JoJiQQQCLlmkEVuWWcZ5ZJZ1BSmhlllCLuyZKIOfZ5pp1WkCmoSYQe+aSaWEZK0HaLdrSjmkVmeVCJulXKUaM6KgSCeLDV6GlFgQqkqUIXFhT9n6fFXUlQqh2hxxiFScImHkKK1urdW1/9o5x+P+4GlYdWsaXMiT+ampVvOLF26k6sQZTatP/I+lFTGLgEmmXsCYntW+BK5IC2Au0aVxhhBHUWuRWZeFBxrabF7k50fYWrucYmBFu9YrVrkcANkSVGsBYB6SxCLuAg170UQbwQTkcNO9GPDTm8LsEOSZwRTD9x9KPGqnHckMcPYaDMUCORXLLJCqFcEH8sY1sQzDHjPJAU89l8kMwIAU2Qt2ktppbQBCF9mIoBn6wzZeVi9vRMTFPkYWdTUz2j1RRQ15HSuMFrEV8jsZt1aYlddJbFF5ktEdhR1cXRbyW57fTPWv6RvRFbKtkd889nr0SX1xuFbJLfQcMcBiAXpdER3RzhtOzDFjmehuN7Y7UtUbhd7jnmhRvOEVM6IY6R5Z6TJDpPpK1kOtwFXXO5SSjd5hFERCvVrs5H/HPNTpyP1K1Wi/8D8xGAXNO7TiG1RlLuQZnNLuOAMB5V6/pJX33111+bvdmAQBE4Szx7v5zb03OvFfSl7W7Q9O1a73Pbphsf//wRGz+R+gT9jn/S0qOI/AZyBNm5xhg6IIn0xieRI4AONAksG+wEpQNj2IuBA0kDM/53soMMECHM0CAHEwK05DWEGb8YId4OsrwTMoMcKmwIIFrYkHjYMIYmseEfcFiSeED8b4I8vNtCaBjExDWEiEV8n0OUl0QjHtF/TbzZRJDYRCD6LooApEgBsSgQK/qOijz0okDAyMWGMLGMFiGjpwICACH5BAkEAP8ALA8ADgCCAHAAAAj9AP8JHEiwoMGDCBMqXMiwoUEMGBxKnEixosWLCSFi3Mixo0eGGiJ+HEmyJEUNKE2qXClQikkPGjywnFlSY0kPMmnq7GhzJM6dQDdiSDnyhJgTQZNWRKmhKFKlUB3GzNmxBCgxUbMyxPmUIyirWsMm9NB1Y4kSYtMaNFr2IgUKauMOPHF2I4UIcOXG/QpqYwS8euWWeIvxb2C9hC8KiXBY7t28FIVIbizXMOXLDv8Kwcx54eTOoCmH7BmaM0yUIkubPt1UtcohLjyeOKHsBFXXJh24cGD26mzcF10MYeiAN0YKX9sCnzik+ELnFvG+Rbv8om7jCEGAmFXxr/TqHP2LYze4HUTkxYxd18IysnxC8+c3g5aS+h8PHh+1g+dIHyLKYiEEuF9cLg2lgRgh3FeKWNcNKFBMpWCBxRlWwQUZUOLF5uBA2LhyhhjIvWWZRxVUkJ120G1oEFp3jchRBVa8Nwt8Ki6UnkHDOZSBQFZkYGJ2NWKEgwu7jWdQBRnE+E+SQb4mnHg0GmRFjBBYAUGTLPEW5T8/CpQkBINcWSWTWM5U4pn/WAnBmmtOWaZOZ8KoJiQQQGLlm0El+WWda6aJZ1BWqllllSX+yVKJPQa6pp5WoGmoSYguOaWbXFZK0HaPdvSjm0l2eRCKumX6IoxLekqeeLDlKGpFhQpk/WpCGhYkn6jFbUlQqx2hx9iFTcImHkKO5urdW1/9o9x+Q+4G1VsUWMWWMioOqWpWvuHE2qo7sQZRfdja+lFTGLgEmosegWAktv+IeKNEDngr0K9xQQFFUGeJWFGKBxUXa1ry7kTXV7yyq2xCsO0r1rwWIdwQWWIUaxGR0yLkAg5y9UuRxQvhdNSxEw3ZEMXxKuwQxhnB9BNHQ4KsmsgNkfwQBsoMNZLKK7OskMsF9SczugXZfLPPA0lBH88H4YyQ0QSJm9ZiaiFNkNOHecdvy0BTRu5lVc8kdUXMdpa11utSNN1HUONmr0V8jSTv16UldtFZHF+0tkRlR1UXR7/+lTQ31UVrlfZGbKm0981Fs70SXdRxdLJJgx9tc90INdFR3op7AG3FFknehOSAY/UtUbg1gczmm3dk7eetzdQ4Rsj8I3rpPt3GE2krrQ45QaO3XhJKss+utFLzAt267jSBPlK4WvULiEFgHIEM8TOFlPpIvwe1trxg/HOE4SrRvt/a20PRfFTeV3c99mEJze1yc0MRPvRQVV9a8AatnT33RDuOc7/45y8Q/XSzGfz8d76LGeR5A+SMDoxBkgKSZHSl4QQD1Xa7Py2QX/0TCOz8xxCfZW8hTYgH5zjouKIl0CCLGCEJe4aQEx4kHovwxQpH5sIXxnCGKonHH+KBQ5ND/IGDFewh3xZSQyEOBHJFNOI/uIeMNCgxIbdDxgefWL+JJBGHQbziCoP4jyZS8WkZlOIX/5dBgWhxjC08IxoPSMKAAAAh+QQJBAD/ACwPACsAZwBTAAAI/QD/CRxIsKDBgwgTEpwQQqHDhxAjSpyoMMSECRQzatzIseDFjx1Dihy58CNDkihTTjSJUaXLlwYtymwJsyZMmTZz3gzRUKfPn0CDCh1KtKjRo0iTKl3KtKnTp1CjSp1KtarVq1izat3KtavXr2DDih1LFiEYMGVHnk070shGtGwFrqUIxm3cf2DUUVQH9y5eun3vzoVoJPBduxEH+1WsMK/fgnUfMn5s2CzixxMrY5bsdfJmyYU/0w2dWDPbuqYNRlZ92jPkg6vTonYYe6Bjjdriplb47p+23KITanv3+7fWs7sl9iZO/OtsgrUhMqf896BevcHxXjeoTt077J+yUSP/1z077LPd05uHjn78euihzxYGH746+/L0MYtX7TZ5WLT+EVReQb1tpQN7hQUoIHfvNJEVJwfi1Z5K7xRolQ7G6PDcewRBGGFG0UFknFQfaqRZfgdpQwdwZYVIHooH0XGMbAjBiBAddPiy2YAR0YEJHRwq5OMfQSYEJFd8FXneQzbGRZpDTZ4W0XfhKcjjY5c9ZOFiCgoUpVi3KfclWK4l5N1iWU6ppHVbrilQm1kFBAAh+QQJBAD/ACwPACkAZwBVAAAI/QD/CRxIsKDBgwgTEpygsKHDhxAjSmw4geHEixgzaiw4gcQ/jxtDihxJkAQJAiQYWiTJsqXDkx1hrnRJs6bAjihNprTJ0+UEAjGBzuxJdGPFnziHFl06kWHKo0yjGoUqtSrGilazat3KtavXr2DDih1LtqzZs2jTql3Ltq3bt3Djyp1Lt67du3jz6l1rxMhekX3/As7oV/C/wBMRC1YMkfHixIUNH47s0PHjiJb/Zj64WTNlhJ01PwwtWeHn0o3nkkYNejVrg31PJ3RtN3Zj2bLr2m6IO7du0pZpG9x2eSLxbcRfK9z2Djnyt7tDvvvnPLnc6AKFC3Re2m9u78qsBwY+beSdEeusY9suH761eu1737NvD3u8+vbgC9737Tl4fsn/jXYaemzpoANB7yVmkHkEosWJDpwYMxl2IzHHFicRckIhfQM9eCBG8FHXoFgPaoSbQ9tEcoxnB5n3kIrxgRZRJH1gkt50ERFzDDEcOkQMJp702BCPcYWI2mr8xZekQDi+tmR2I7L4kIXpSfTkbxI1aRh821x5nZdMggmdmNsJqZCLZiIU5VoBAQAh+QQJBAD/ACwPACgAaABWAAAI/QD/CRxIsKDBgwgTEpygsKHDhxAjSmw4geHEixgzajRY0SKBjSBDiiw4gURJiyNTqoTIkAQJAi7/VVxJs+bClyVxVgxhs+fKnDBPovRJdGNJAkCHFl06MUSIjjhNKmVKteHTjh1lTq3KVSHWrV3DHmSYVaxZh055nl2LUC3bt3Djyp1Lt67du3jz6t3Lt6/fv4ADCx5MuLDhw4gTK17M98sXxiG/cIMcOeNjyv8cX9SMWfJEz5gFXo7IOTToh6dNSyxtejJq16EHpkbIOnbm17Y35/5MuPZuh5JH/34tvOHsztyKJ/R9m3Fwh7AJMj/sOPpB38ch9qGs/OHkPtbVhxPkBr4PeMDPQ34nH/5v9YLZFbKP/bj7v8nt6T8Oz61/fu6OBXjff79JtoVjRvQnHnzBpbegdJ5VF19nzUGY3H3DSWiQZwT+pQNtFeJWUId1cfIhhA5CxB95fHEijA4miqahSizuxcmNxujw3oME3QjjiZuRaFAfxdx1IycbdUeied3YhaRG2SnoUB/HOIeQkAK9QGVuUkLkySPb8ajQl8SIOeZgE4o53XgZCoklYvYZ1CV9WM6pWkRv9pZnnoKteWWYyE1k52J+JsTnboOaOdChcgUEACH5BAkEAP8ALA8AIABpAF4AAAj9AP8JHEiwoMGDCBP+w6KwocOHECNKdIiFIcKKFidq3MgxYq1/Hw/WytixpMmTKFOqXMmypcuXMGPKnElzY4iaOCVWTBgixASIJHO+3Ilwwk+BRy8GFSrU6E+nCYkynfpvAol/JK4OvEm1a1WfWEkQIPF0Qk+uXqc6HZuVgNOeab1abUuWbNW4cie4bZsUL9OeTq3uhepX6NnAiNEWpnl2IGKBihez5LHUMVizkmVKNQj3X+OLPDKXDP3w80EspEXL7HxatevXsGPLnk2bZeXaL3lQTqgbt8rUB3v7ngl8uPHjyJMrX868ufPn0KO73rJFuknq1q9zrJ4d+0Tv1v3BQxQf/jv37P/IK1Qv/fxD9tHhG5Qf3z1C+vHf20cfcT//98nh9999Ag44X4ECIbgcdf4dxF6DyjHokH8K+ibhevtVSFA95WnEYT0cGqgQiCSGiNuFJn1IYoTkabgietU1uM4/M4qYYIwGraOjiQMyKOEWNdp4IHXcABmkkDf6CKGIP1K3zpLtpTdkdUcex0l/KA6EXZXI6XClg1L2xyWXrgnzDydoTglljjnWQ2ZmaAgjDCde6pCkhg6BOBsnc9KZHp7PyYkmnXZuhKeerqFpZ6Ea+fcmQS9U8oJoc57ZEXs6PvTCGZmZqd1Bjxr0whiUDJhpRC9QMgaSmj4yNymrDTGBHKD8CRhqfQ/dCt2aAq3DI4y80qhrc8EK9Gt4xdL4n4vDBpissMBudCysBflK7YjJBQQAIfkECQQA/wAsDwAfAGoAXwAACP0A/wkcSLCgwYMIE/JIyLChw4cQI0osiAVLQiw8LE7cyLHjxIq1Lmr0SLKkyZEHa6E0ybKly5cwY8qcSbOmzZs4c+psGKLnzp8NeWRMGGJCxJVAYWZEOnBCUYETjCKsuDBp0qhGSUQVWdXqTxL/CPybAHagT69eixolS4LAWqdn0V7FSqAtCa0kioaQKzfq3btut/LtC3hCXamDrfZUy1Yr1sRAFzPGijUuZJyLm1IWuPfyzIVMOW916tmm0ND/zmaeWrqkUJ6cLVN83fqmbIJCu9auGXK379/AgwuvjXr4Z9oHkRtnqdxg8+Ul4zDkEUc39OvYs2vfzr279+/g/cOLF79ly3iWPWScZ2meY/v1/3q8j7hFPfx/9Sfmvy+wh377/O33kID8+ReRDPPdJx9EC/JHEIEINejgQAY2BOGED1WIIYPcXbhhQ/IB+GGGHkYoYoElGuShhuHVl+BBLPb3InghgviihBNVAl+MD+lYST0jJlTJOpX8qON1LrLUzj+VtPNjdzU+OCNDTi7Jn3pTLmnliPnF2M6XW2LoIoL+9RBmkAMhuIV8bKL5oJpkullQjWSuGWSZBrFpHo/QcSJRiDfuyZ0wAnGiQ0KC0uelcGgIJAwnfqo45kRefhkcF8KgAamhh8Y36UtOBifMqJB2GqWbmW6qQ6Qc4Qhw0ZO1PQrpPzp0utGMfBL0TT1jtIaGrCR5aKlDu5ZGqEl85mrQGN/0OuGwEI1BiQtyNiStA9UyxMR2dmZ7UIoDnekguOGOeGJC0DroKrriwjclQu2eR25B8YqX3kTprrduQ/mOt69D9Wbbr7cCBSxcQAAh+QQJBAD/ACwPAB4AbwBgAAAI/QD/CRxIsKDBgwgR8uCRcCDDhhAjSpxIsSLBhf+wJFz40KLHjyA/8sDS8SDJkChTqjSpESGWlytjyvyIpVbCWi1n6tzJs6fPn0CDCh1KtKjRowTjYGwYIgTSpxsX5izY1OlEjiWh6hw5teCErwLBuiTJI45WqBNI/Ps6IeHLrGeLsv1Hou3ApnHjhgBLgkBatV+r5j3L9m/fuoGtDiZM4nBjxIsHf23st27kvHv31m1c+DLSELWqFh6N17NRwWE7/1Ns2idcgpnXsm7NU6nUhKVRmxRolvZHpUohWtVtkKPvkL0plj7IMY6r40JtNjSbHLr169izaz96crvRpQr9X3tPaTvq+JnBG/J4fj5mnPfT17cn6ny+/fv48+vfz7+///8NySADgDIJSGCBIA14IEEGWtTgggI9OJGEEP6jIEUUQphhQhsueKFEHR4YYkEjivghQiWKCOKJFTrYYkgszpfiixzOSONBAsaIoo4e2rghj/vlGFGMMvRQoZABsmijQZUc+ZEj/1QC5Y0ROSKlle3ch2RKUDriZZZBUrikQF5O2eKAOhppJJUMomlQD2L0YGZreRjECScF5ljkP4WsqR0XBukwk4A9ENonmzvm2IMyiNaIZpEyFIIfnglaaJCh//gJXRllIERpQa+smKGBQF4njDD/3AmqLDhaSrNRD5IWNCdtXKCKhjCq/iNoomPyaZAjclrHRa24cqLDp21uGZOXpt6aK4m97ldrrXc+m1K0lTRpGqDF6rrrtQdpilC22mrVaUHCODvQtwnGuKhE33xz1rkEoSEQsgLpwKpHOiZC0TcuyLsYoEP14C9FJrgwRqMUKewAwxM9nF+00OVRJ7oopSgujTPOyvFEcLJpI7NUllrQxhqaTJDHPVokBssE9hrsmSr/CrFEwN5c5X4BAQAh+QQJBAD/ACwPAB0AbwBhAAAI/QD/CRxIsKDBgwgRxomTcCAPVw0jSpxIsaJFgjx4SIyj8aLHjyBBZvzX8WDGkiFTqlwpMCOWhiNZypzpEctLhDZv0tzJE6dOg7V+9hxKtKjRo0iTKl3KFCTDplBVxnHF42nCECE8ooxKk6NLhFizUsSScSrXoTxsJpzAVmBbnCetnm3alu2EhDa3zl3KlsQ/EncHYt27N0RbAhNIKP7HNizhuRMMK1aMGHBksY8hJyZBQLHdzI/7TgYMujBWu5PtBi7dNKxh1aoHs2bq2K1qgZhnE9VL0HBW2bqJTj15VWztg0KDX3TllXdv3MANEneuPCHzf3IlRi8YF2L1o7X9Ii505f27+fPo06tvSn19UeIIY7qnKd9k9vlSqcJsj//iwvsEjdcfS+RJxFx5AxZVYIIMNujggxBGKOGEjwEgA4U0yXAhhjMBAJKHHBYkA4gWWRhiQSaWuOGJBK1I0YgsouhiRDDG2KKKNhKUokQ75ihQjQ316OM/JDYE5JAVFYnkREomqOGSF1k4I5QRSVnRk0ha2CRCQgq0pYQafnmjQVieqGWVU3ZJkSMxitkQm45UQmVCjtQZJ5tOHhkSnCXUGeGZOk4ZkRh+5njhl4X8I8acRF44ZSGJKNNDdXnkURAnnHSo4ab/yKDMepYalOlMI24qQyGJMjpQmKV+qvJqoB6GWYig7o360aFkWpnqd2WUkRCmBr3CZKkGmUhrcL4WhIYw/9g60CuyHIRrRbMatOh3eXDxDxfCAOssmaW6Ka1BiTgy6XdccCtMt5zoIG24OxF63rLSdHsQoEhyqy6m34akZkSVyDmbtstmqkO7Kwm6a0IBC3xWsgTtO5C7KekpUCGuAvzNwxAPpO0/zBakg7AeIVrRNyhnlq5SqFpkggsuvBqRCyaMIXNDDjz474ChEmQvSBYblPF5HQ8U8q3iCpQIlUkL1MO1Q+5cUKRLHnsQnj4GndDQMWqdULk+Sn2QGFCzKDZC5958ENhqjw1hQAAh+QQJBAD/ACwPABwAcABiAAAI/QD/CRxIsKDBgwgRukpYcCHDhxAjSpxIcWAcHg4ZxnEVp6LHjyBDXuTx8GLIkyhTGuRBkiHLlipjyqT4MiEWljNz6nyIpadNLDuDChUI9OfQo0iTKl3KtKnTp0pdwYRK1SNHqQ9DhLDasWrOkTgPap0wkeUyjBm9ymRZ9OCEEGT/vbX5sqvanW3dkp3A9+fUu0z5kvhHIq5ArYC9wiVLojEJAnLfIk5M9e0ExwQa85VMWa1gx5oNd64q+LLm0YrHfr7Mdytqp1pVb549+fXS2ANnx3VtW+jfgmP/1e69U2pNhJNxI2xpl/hEjjxMMnSt/OBx589dLWwOcXhBlhv9MWI/WqvkxrTjqaJPz769e7W/3ye9vlL+zrDLo9uXGd7l+v0hXaXRRgCmpN1/DSFYIEUKEnTggkk1COGEFFZo4YUYZgiADBnmtGGHHoIEAIgHyTBiRR+SWFCKE7GoIkEntsjhiyvOGJGLNApk44075vgPjgkB6aOQNfp4UIwMEWkkREgu2aKFSjqZpIlSerRhk1NWeaVEQmKpIZUPeRkllGAG2eOPZ0rkSI5eQrSmI2tWyZAjJcDpSCUQbpnSm3XGWaGeA41pkBh0Ljlim4X8IwZxZRzEiU5UnllIIsr0QFweeRj0qExXykAlAMq4l2lBm85koomFyJCqnEeeCvsoqzUe6umq2HnxUKkfHWpQp/8kil0ZSCQkzEGvyMIjkB+m2VujBXExLCe4/lMsQrq26CtBiWCH6T/OCjPsPzpM+WpEZybiSKjO5eGss9BGG6irORE6nrNoQEttmUuqK0y3nIQbk6AGVUIBapl2K80//fqLkpfXJlTJw14FaxC934KbkpCFoPtQJd9U5YXEBHEhUMUD6TCtlQg1/NA3LFMmckIKx1SIyg+Z4IILsErkggkO5BxRzxQC3F4ZoxJEcq7KYjs0swShcTRFAFsqZ5sGKbOolEInIrWTVB+ULddJH3S1kUIPVKmhYXvtJ41lE6SxzwmZC/dDY08YEAAh+QQJBAD/ACwPABQAcQBqAAAI/QD/CRxIsKDBgwgLqkrI8N/ChhAjSpxIEaGqXg8rqspYsaPHjxE5TrwoEqTJkyhTqlzJsqXLlzBjypxJs6bNmzhzCnQlkafOnwxdueIBUahPoEgL8sBGlOGyo0mj/lvWNCEPqlKz8tjKkGtWrViwIMTi9SvLkhDFJgxrtuXFtnANbuwldSPauFnf4i2KTefdvQSNVkUYIkRHV30BH566dTDBwoYlbmUqVLHHOI0ThpgwQeCEyAcbP7V8Ui1Czv84dx5blvRLziT+kVgtsLDrmoU7k9i9O/Vn27dnbobNe/Zv0MFnEi+OOrnN5cad28yterdq5NJZQoasujvk7C/9awH3/Xk1dvAfHRf8Ph49SKGZCUf+jrDpMvcIEVO9z3B+e6VL4XeQUVBF9B9BVw2FTYECflRLQ08hBp5eODHoml15/dXgWRttaJB6KGnoXnyheZjSaFbxYKGJPQ3l1IosRmRUUBLGWBFiMA5UmY03yrggjy/lCOSQRBZp5JEydeiRiIABIMNHGGrE5F5OfnQMlKr4Ah4AH3GJ5EAyeElRlV8KROZEZ5b5j5gSpVmmmwzB+eWTaNKpppl2NiTnm3kitOebEf15p56DesSmh4IWmpCThyoaaJh1Ospom32a+eWkhBqUaIyYLlrppgg5AmhHojoiqqMMOVKCqY5Ugv0opCiVuuqpnMI6EKgEiaFqW2UcJM1LXDYqUCH/iKFYGb0aJAwnLkFaaSGJKNODZWXkYRCzLDEqA6QAKCOdtQVh21KYYRYig7moHqRtp+kWNKmT51aKFy8QidvlmpqS+w+xpCHhBRIJCXPQK7K88iicVcp7rEFccPEPGvb+84rBfuKLJr8EJeJatf9wIYzHAumgJ7nCMlRpIo54S1oeeXjMhTsQe8puSrre1rAwMftp650s5/HxshGfhCtBlVCAl7UuC8wJJyKnJCzGCVUidVQAM+yxwCE7LW8hKjdUyTdI8fIvwwKhYZAOrzTdUclQN/TN222BixDaLRXSdkMmU7jgQrsSuWCCA3xHBDiLQweHrLIobapxcocXhAbWXSpc0LSMH9SwSSUbpIyxiuKaCOWFZn7Q4oMWzvmdhf8jbemSI4Qy6q0n1HXgCb1OO0OnmxgQACH5BAkEAP8ALA8AEQBxAG0AAAj9AP8JHEiwoMGDCAdas5awocOHECNKnPjQmiqKBBdi3MixY8KFpTiC9Eiy5EaLHFWhNMmyZUJVMDeqCumypk2BFzHCzHmzp8+fQIMKHUq0qNGjSJMqXVoUW0SnTKNiWwa1IbarUaVi4+EQa1amWx1S5fp16TIeZBHyWFaWJUOOaNMWjNu25EKNGOUaxKK3rsiFPKPe9TtwZ1SYpfASLqvy4tvFB70WDQw58tW+BUOEwCi5skSnW9Ei1Lw5Io+rqD1jHItZoOYJrksfRLu1quqNrQVOgL0bttq1t33uJvFv90DSwYO+Lk6iOfEJpGUn7/l6gpoJzntrni60t3MSxv25D+2tJgR43+KBkiYfojzy9DVrRQ/Ru/52+Dbly6aPfLN0/Lg11N9/AHJWW273vTebQLYVOBBqYQkYG4ED0eagQRBSFEItCY2V2oUkcWjVh9xZ9BhRDXp2F2BZObbYYC2qdCKI/+TW0YozFnhaQzY6xFCOAI6V0Gls0dgRiZYZ6VFnlqWoJETYqOJkQUw++dSUBEWJpZUkbcnll2CGKeaYRa2kE3wAyPCXTEDeluZGpSR2kmLcAbCRIT3QhBGd08lgJ0Uy9HAjn8G9OZGhIukp3p8SIUomQY46FOmjAqnZqKWUQoqppJtmOtCkBoHqKaMNieopRKSeeqiVpqrK/WmqrkaUJqwJtTrmrLJ2KhCtX+Iq6UG2PulrrboGi5AjmfLqELKOIBvrsiU060glNA7rEbPROiusnwUZS5AYjpRQVhllHCQMGjbZyWsh/4hRGbkHocGJTdzqWkgiygj6bh4GzevSrDJwC4Ay4pVbkDA3+elnITIw/CxCAFv7cLcCB+ywarw8hO5BrMj6D6wA/8Muxl4gkdDGBb3yiiyoKhyqmrp6ZnJBeSAsjDQF6fBKrR8fOjJBidxWBr9ccHGuQP4SK/FDuibiCMGq5SG1MEYLk/TLS5MEbnBc1Cyv0rFKXbPRX7fkLUGVUEAYv3mQ/Q8ncLNE688JVWJ3VDOIE1S00QPpYBKohUDtUCXfJMXLLSUbxO8/KPft984YrSvRN5QjlfFBiyOks98tFUL3Qya44MLEErlgggOkR4S6kmcnB29BfHsUbNDTva43Scbqm1zeenMhe0TKuJucFwj5zpG3ieiuqrIH0b58zAkJf2rr/+T7PEVOTw+9Q4Kn3lD23jskvZEBAQAh+QQJBAD/ACwPAAsAcgBzAAAI/QD/CRxIsKDBgwj/5TqXsKHDhxAjSpz48BxDigktYtzIsWPBc6EuelR4LtfIkygdLjR5EmTKlzAJhgp1MlfImDhThlJF02MomzmDjpzZc+NMoUg7HlW6NKnTiDOxcQyFrejTqw5DNZKKUatVrGANbm20sdHXsGgHksXYaGvat3Djyp1Lt67du3jz6n2ZKuKyvWFTLevrUDBhwFdTYXmY6jDihgtRKnZscPJjhxZBiuRYK1WthrUWX364kKjHWp8Roqa8caVGuD+JnoX4ObVB1ENDhmQpl6hbu0R5bq6rdW1cr6ZHx93aVLnAwWiNOx84eJlthCEmYBQ8PWJjLJ79EU4YL7EzlurdveMWT/5f+4PmG6eneN3gBBL/SNxPuHo+TBIA5oefQNqF4F9O42kH4IL5jReCgQfGlOCCFCaoXYQ5Uaghhkjpp+GFHMaUnQ/Z3beghSGm9KCFCJh433spjpTMgwNZqN2NMWJUX0EJugdijhINBt6OA2UnUHYQwicQayEO9p1DF04wI3+KAfkcehPRiNBkgv1l5UbJFIZlelGh5aVzNvlGF1mzxZULT7LVZZZZ/7QZ1kKa7XQaTrI1l1ZmkY1UZUJMQjXTOTzFNZxHliEEXqER2ZTZotMZ1hB3Nb12IHSXctpShMt4SuiZX04U6kOhglNqUKSu6v3qq7DGKits0k1U63QAyDCVnQ3R6V+uRrnUlZ+4blSMDLw2RKxzMgBA0TEybMHUgcBOtIUMlBqa7WjOTiRDMSMl+quuEfWA7VDCpkcuRIZ821JJ45bbw7YTBTpftQ3J8C05KGX2K0T49svvqt3OOlLBQAZscEe5IrwwRw1LpPDD/0QM8LoEOQyrxQ1pXDHGsnKM0MQTR+TIwx4/dLIjJ1MskSMlsOxIJTmK3NHKMbf8pc0lNyQGzHYhUcZBaAiTk7MpF/KPGIiVMbRBRefU7D8g/1NIIsr08JjTBUUdU8P6Iq1Mek93LXXDhciQtssPgW0z2yNPnavaVed1Cy8P/qGB0CsSV2wQ2FaPxsstXiTkNUGvJM7KxSTrWjdiSBiUBxf/6F2QDnwnhPREAChdUCKjlZHHP5MLQ/k/nLTd7NTeGpSII2NfJvrkXBQtTcerp9zRz8rRLozlceseax5lcEEIGkWnDlPPDVVCgV5D51H6P9JwosNLHnvefCU0x4W35FyEP5DyJ5VcSOwOVfLNW3ffEnlBo/9zOkE6YM4wQto/9M3+aH1vkOgNqV/mXlKI/D3EBC5wAdw24gITOGCBGHmglZgXobINZH4eoaBAQDcdoRlEfBl8XEG05hwkFO6D8bsfRJTBtBIiBIMY0eBAEkFCuAnPdQuUIUFa6DIdGBIka2zz4Qx1tjAh/hCCFHkdEifCQyAFBAAh+QQJBAD/ACwPAAcAdgB3AAAI/QD/CRxIsKDBgwj/oUrIsKHDhxAjSoyIquLEhwsvatzI0SCqUBk7ErQosqRJh6jEnRT4UeXKlzBRNQpZMpQ4mjBzipy5UlwonUBLimvUyCRRnEGTRiRatGQjl0qjSiTqlKrUqw+Z7rSKtWvCRuA6gvVK9iu4sBvBcS3L9p9atBfftp0r8Gxau3TbnoUrEW9evRr3/h1MuLDhw4gTK17MuHHSVBAhO05I8mSqcJIZXs48uWBFkCvDhavVUHRnyjJlmhxdula4mEil+hzalGOtYaQTul5pE2Tsq0zXXqyVLLfB4smq2qz4uytTuReTJyy+9enTn4QbUQPLNy/Y4Iv9BdPdq7b2ab1nzZ8XCPl11+7r2WN2n3CCdImY40cWfdt4wQkARtTfZvpFNJp/BSEwAQkCkTCBbriZVuBE9x1EAoMXMohQcfRNeBIJBGCo4T8PPuihTgCKCCKGEyhY4YkrKZjhijQGCCNQM+Z4o1IO5jjijjAB2OKCOQoJ5Er2DUmCjD22eORKydj4T5MI/FOliU9OhGCCC1qJZZYSXdZffdIZuaFAHWa5GWsMmZgkhJypSaBE9iU0mmj5gcnRiwZhlkqc8XFHFqCdPefXXGipRxhtRG03WHrw/eVTcIpKtGVJ6WmV12cyDVXSbQylOdV2mjaXFHMphZbKpQK5Jv3qVDM9xRZzL1326kCXGeXTR6ZOlqedv4qUEq0F/kloQX/C5mGyDf3ZiZ5KHQvttNRWa+21iKmVFowAyHBXYJWu161Gmk4knocAaFSMDOE6JJx+MqQrkREyFMORdu12Nq5E655z77vxyQuREVJ8sRW33kLUQw/+Huxhwg8VA4ARTnmKLsQNLYzdTr1Oti9DPchAsUmznSgwQzJs0TFFoE0bMjkrQ1TZtNzELPPMdH38ErEr4ZxzvI75nFe3JzekM7YIEQ3R0QIVja3SRh/EdGK83OIQFxNBnRDTUz/kCNIFOe31P458DfZGjpRQtiOVgKl1R1+nXXa1b//TdUJi/qRNWBlIHISGMEqlK/Y/hfwjxmJIlOE3GkoBjbFAhSSiTA+MlaF4QYwHRbQMQAOgzHqXE5R5UvHGW4gMpxv2ySY6scLR5nVT67pGSneL+uOI3WJ1Q6MX9Artdhu0OeGOVd03Qlgb9Mrys0c0fNje4s4YLwblgTUavf+jw+8PCS4RAIUXlIhjlv9jPRfJS/N96YMnhHsijnzeWBl55EEIGlwIo3737MOU92Tnw97SgHY2gdDPfvhDAyc0J72GVIICiFFc/dD3DwXuDyZiCx9DKsFBuuyuIBNM3j8WiEHpFUJ+DvwGW7Rwi6pVTyAiHIgOtmeSwWnQId/IIVmoh5A8gjBkhtzTSSFu6BATuMAFSvmEnlxgAgckRYk5CSJdnHgeHazvSV64gkFiWMMGEmR8p0GCF7bIxY7cjSCUC+NBrLeS9hVEGYebDA/XeJIzfjGNBRSeRMCYR4LYsSBx7GPTvIiQyTVGC3NMSOhoR8iDwO9Gi8xaIwspyI48spIbCaSeAgIAIfkECQQA/wAsDwAFAHcAeQAACP0A/wkcSLCgwYMHxWlCyLChw4cQI0qcyFDTQooQLWLcyLGjQU3iPFYMKbKkSYcWG50cCPLiypcvLbo0KROmzZOaqMWkNvOmz405e3rkKfSn0YjUdOJUerSpxKRMhyZ1ShUitU5RO06tyrXhVqlZu4oViLWTyKthx4q96rGTWbVwB7p9u7ETOLpxx87luDdv3E7h+Lr1+3cwRsCE8+KV2Dex48eQI0ueTLmy5cuRSRb1OCxiZ8wILZJcOWxYrYfDwn0GXbBlUNLDkjksfXOzT5k802KM7TAZ75gKR1fNCVVksuMNkS+VqVAtVKwej8s+KL0kVKK2uaK1uzjidITK/bVezwl5ruHE3LHqdtwYLuC561l3NS8fYefVVLvXH5j6N0MEE+yG336olVbdQQAiIJFvyag2IIGohWcQASSQIBAJCoJ3HG0QbvTdQSQQ8A+FFmr4YIcmVWhhhQMpGCCKPwFoIYkUjgjgBAbAGCOGKpKoIgIZ6vhTj0QK6ZSKFZJopFE3IoDkjxMEueRJEySD4QRXPinllCYZEOVAFcr4j4JbcjnRhwZFqSCGZnZkoH8GAShQlC9SJ9CJXPYHJ4ICIZBMnQYx2GZBelIkJ3ixOTiocbOlFpiO7VGFJ2hX3XXeX//o59hzV2kq1lzgZBpZbklB1xGaJpn3VV4WkRr9n3eT/oMqY9splZ1PISlU00mxTepbrA+NN5Zrt1LUX0McnkUcSFw1Z5NqjT5akkyioRjOD6mgJi1OwaGY2kPhXGsTs4vyV+656Kar7roQXjqRp/UBIINgdcErn7wbgdOIvQi5FaqQAGz0xRYq1WukDAFPdI4MW2hlKoz4TlQMAAXXtSqKCUdkhAxGnMUvaBFDtIUMFYsn5LwRcQNAx2ddDGHIDjEsnMkAo9zQyOQsBzBEyqxTskjkqSsDGK9OtOu56hjxM9DOJgbzSrrCpNFj8maM0zU2dQtZ1RI9PVDATceEtWRcQ+T1P1ZnXWxEt0CURx4Tld1Q2gKdLRkvbf47xAVGciPktd0POcLuQXRDJLgjgg/ukSMlIO5IJYv23dHhjSeOruSAIyQG444h4cVBXKDRVMCF/1PIP2JUhkQZB6Eh+lEI/2PzQIUkokwPlq1u0Os/VS1D7AAoA9knD7FeEO9GIYxwITIwPzw7PrHSke+So8uK9BtxLW/zs0+mRd4NIU/QKxyRbpDvpmOGN/gG7W2QDq+8gn3cyp8/b/eX8WJQHoT843pB8Osa2uJ2uoIkAjO6e1s23CcNilCPIvhLhCOEd5kylGGBhHCd+OamvNJ1ZHOg4R8aQte12CluIBYkxAJDt8GXZA4hlaCAZFj3Ni7sDQ3S4IRPClfAhrhU4od5YR8K82DDgTTQJmcrBAUdUolvqEULeNNfQeD2D/cRRAei0MFJStfDh3zji2LRAkOMhxAdmNEohejiQ0zgAhcchXiLcoEJHOCTT8DRJq/QImHoWB89ltBMSEDC/pCIP4McUD6ea58VTfJCgeAOkQd5mwsjoozUgQZvCKEiIwt5kEQ88oR+m8ghQWm/iViSlARpZEFudxkxFk8kqiSIBFvpyoZYcHqcdMgSUdmRWfLSI6csV0AAACH5BAkEAP8ALBgABQBxAHkAAAj9AP8JHEiwoMGCbtwcXMiwocOHECNKfJhwosSKFjNq3DgQI8eFHj+KHGnQzShNJAkmVJiyJcmEo1yudEnzo5tLMi+xrMnToptOO0eexNmzqESdLW8aXQrxklOSlzrNYUqV4ahOREU+rcrV4KWYWq92HTswataNTs+S5XqJj9qJl350WrtW7ke3dNfy2btRLp+8ejsN07j3B2CyP/hm5DP3MNm/ixM7nky5suXLmDNr3sx5LMagJAdDHNAZYcjQA0Q3HJa6dMeVUlsOSEa6Yeuap2Wa1IR05DADDg38prkSNE+TQN9aNJAM+ELmzqH+LF71K1blEqEzZD4SZ/LcVP2t74WcMbpBA+Y1pv2qFHDcTowrM3Z7FXtePpIPz5dr3zXVxH/1l9ltXZHn30CsDccQAgxmROCBDqUmXHoENRgRc6k9CGFD2i2EAAkkCEQCAtvRRtuGyzFEAgEhrhjic82h6BIB/4TIYoUkyljThy26aOOHFuroEpAgslgkiEEKSZOPPt6oZE8gNvnikzQxOGKURiJJZUsITGAlj1gCuSVJBgSJJIj/kJjjmBIl8w+FA4k5IpsOmginQBYyOAFDbv5TG50qJHhnnHGued6JdP4T6J8SJVnQhAkmutGgAmWoGoTzkaUChG3Bh99kfxnomFlY/SAgV34FOOpPc3z1/c+pfNaE33WwHgfUTWKJRNugwqHFX2xcFWeSbH0+d6l6V/0kkHFJCetShqtRetQo0y0Fnm8aFgTtSzrNdOAwgT4UbrPU+bfpQ8OAixuzVJ4r6bvwxivvvKX5RRi9BilmUXz4EsTvvnb1+yofYGXUVsHz1sfRv/Q6hbBF1vUblVa1PomrSMk23BjF8+r0MFrssnltRqzGW21KJ031rrcvhUzlyBqxTKfMLae0SWVudODyRjRvRIQWEZVxhbU781w0RFoQAdEVeQgJ80RAP5TH0AIzdAsvUlet9dZcd+01Q0h4cRAXXHy9EBJIjI2GwPJIhEQZBq1dtRzy2PFQ2gXMyQ2RLmx+UndPrLDyCitmQxT4vEk/pHdBfGt9y+MMlW2QKK8MzjXWBTH9DxeL/0N54QK9/U8ehGQjuTSgH/T21GSj0XnqBDFNtuSwFyR06YTQwnntBaUtNNn/oCEN6oXfchDTedBOvNdaaMGL8bYLRPtAouggytZRH99Q9dfP+8knvB/khzxygM/TK3SObxT3WqNtUNMQVV81EtATlHz4/9RvP9W1P78Q/PgLoAAHqJGbPQRuoCOCARuCt8ItkIEI/Nr3IuI+CboNIgEBACH5BAkEAP8ALBgABQBzAHsAAAj9AP8JHEiwoMGCc+YcXMiwocOHECNKjJhwosSKFjNq3IhQIUeGGD+KHAkyJMl/cy55PMny5BxLK0kmjNmy5saULV/StMlzok6WKXf2HPrQkiWWRokqlWj06EijQpdKJdiUZNKpWBde/Vg1q1eqfJxytBT2q1mBl8puDCv2rNcCP7jycXuWj921P+bSNcsnr0Y+ePTu9QpY8MS7g/n+DZy4sePHkCNLnky5suWvGKNyHBCR8+WOmjcOGDDs4WjPnwXODMpygAHUC0nzNDlbp0qSA5I5fG2g5uqpL7tyNECcIfHeLi/BnJm1KdmPx40j5/oPKu3mZH+k3TjdYHGuzv1fJiYL1/Beu2SFPy48uK9dBaNSn2dsPvXor/Xl/xs9rLtBBABmJJt+nY2WjH8EBRiRAcmcBhuBu313EAIkECAQAQhI59qDEEKE4EAVkvAPARVK92GHH1loYYkDKYiiTRSqSEKII1Lo4ost2RgiiSGScCOONfW4I4tA9kTikTNaWCRPAFKY5JM+LpkjgD5WuaONUp5kgIsVOvlPhhlmaVFvJ34ZZZRiCtifawwp2KRxAnEopYNlChTml3d6Z0BpaQqkwgAqZPQjQbwNM2CfGtW532iBosgHXF81qp9ReSF23j/57eXce409ql11jTmXVFtj2uRpWqR6FZRKWw3H/eZCElqUnnrArZbqZnW+JlJT4km12nUfndbQoeCxFppMx4pm6LD3ybQcsJb9KSlDxI70a7KQTcuQtDZBu6S2iIYr7rjklvuZXQX8Ze5Bff2VabmP/gXpugOltxYfCtBb3XNr3TourRMB/K+/TBHcp8ABtzqwVdgWydpTBmfZ61M4jfuwsw2jyFxyJ30ymbcabSzSJx5LhISvIIecsUNEmFzGUiIDlXJERGwS0RVXoFwbSURoAdEVL+M4c0Q+P5RHzvo2pAUKDyGd9NNQRy311A4hcbJBXHBBNUNWH8QFLfT+II8fJl9NEBpP+yGPPBCZPZDWEenyiii6SCkHyT3asaKL3ltHxHe5RNzyENwG1Q310oIvRDhBuuiwt9S8GHRFHv9wkU1BoojS90BI5HxFNoSA/Y80my/UeRmEZMMFGmiXzhDOli/uOkFAX5G65a3PTtDJk1+hNeukb554QUBnQ7lAwVOtReCREy+Q7P9krkPULS/k9EGZa26uHSXrbpDacrDNk/ZS/iA22UNJTz6OcZk8/ECXQ5R98uby4rZAR0+0frnvDzS59//gRf/8B8ACGvCAJ6leQ663tZo9pHObw9sD7yc1CT4wgmXbmh3s4L6+iS8izXtIQAAAIfkECQQA/wAsGAAFAHUAfgAACP0A/wkcSLCgwYICEhxcyLChw4cQI0qcKGDORIkCBFzcyLHjwoQeGyawGLKkyYcjD5wkOFLhypcw/6WEmaBmzJsmbb5McIAkzp8cD1hyebKnSqBILwp9eeBo0qcQDyiwVNSSU6hYFwpVcFLB1axgC041qWAU1bBoCU4tUFKB27RwBSr4wbVjAUt146YtwNajgr569/LBY/cHn8BxCwzmiIcvYrgF8BDeqPhx3MkXJWO2zLmz58+gQ4seTbo02IoCNcIcEJG1aYMZfa4cQPshbdevByacM3O2AdwLa9/MCDWh0ARnSw4w4PA3c5q8ZT/laTV5RwPYGWJ/XnTO0ATE/cNKxWt943bt3P3+O64zrtsflipzTF8we8iyeJsSRfy3gGHO/rnl1ledRbYZXHgMdhdguV3mGIMN/iMcWBBGKBBtvzWEAAIkbDShhbZhSB9BG0rk3G0gmmjfQRwSIBABCKD3G3ApRjTiQASQ4GKOLi50Xo0w7fiPjiTGCCROLf6To44dwkhCiUfexCGHTPKoI5RR4mTlkjxmiRSXJDDp5U8bPslklU+OCdOGU5ppJQIwqrmSAVjmSOU/MRop50Ss3SjQlErquSefy61oEJRsanfhoAPdtpxDemJpEHY0yqnChxFJWt9yKDJ6nUO3qXCkYgdCJSqICvAxl2OIEVb9oWUHmOWWqpYp5lhejwll1Vu4XuRnSHwZNlZgIw3VFIHmPerjrw4JSB5cu9W0n3LMZnifUD2dVlFC0yqHaUHfBnUcVd3iFF5MnQYXLkc1RaeahZee2tAA8p4E3kjnNlgvQ/EO9y6j+3oq8MAEF2wwaf69+pDCBrN6kXwHFwTxRP6Vd3ABf9mFccRymeXRXRzL9VZHU/Va8FL3mTzwsSVtFTHKLVvsKU/lbtTUSnKUhtxKRp0khzwb3ZJVSzsN5fNGSNSBlbQ71bzRJ3ZMhAQSWaG2E28n2fGJ1FXnexJIJ20d0dRYxTbcHP96RAQREV1xRdfmpt3R2hC5naXXav7X/XbIDREhtEN78y344IQXbvAoQVNtUDZcHDzKDz9MVIfiBWWTzUaiAAm5HxKRXflFosSS+ZE/yJNz1A1RPtDlEemiiyivj/kz6je57rrhE+kyzcF0O8S6QboQ7jcKDP1OEOy3E058QXZbXpAoo+M+ENluX8E6LdKnfgUS1jOOffaAu+08+AxxXz0X2XxPvkFUV385LWioL/3yzIs/kPyFr+03+wIFPlDo0eMb2xbiP4MAMGJyENv6FuIHefghZziBnppGoY/NIeWAURrF4xAnEV6orn8RCZ00/hHACHHwIrdQWv0kIgpaSAN/A6MfQex2EfgZDAV/M0gBF8jDHjr6ECgDTN36PhHE8pFPaxDxnPSgNjYV4g6CScxeAjvoxMJBMSK3kKHgGngRHBruB5y7CC9+yJAiOiQgACH5BAkEAP8ALBgABQB3AH8AAAj9AP8JHEiwoMGCAgQcXMiwocOHECNKnChQQAKKERNi3Mixo0EBczwytCiypMmHCVKeHJhgzsWVMGO2PAAz5cuYOEuqXJnA0s2cQDkesETz5IGdQZNiPFDU5FClUCkObeqRKdWoWBkeUKDAqaWsYB0q+CqSa9ewaA2aLWvpbNq3AhXwcYtRQQG6cNMW+OGxANm8cAsU4MNxbwHAgAfj2YhHMOK8BfAsxjj4MeDJFCVjtsy5s+fPoEOLHk26dGeN/xTCHBCRtemFCUOuHuC6Ie3arwlabJngqscBBnAfpJ0TZFaLQ3ubBO4wuAGZc1CD7U0UL0YD2Blif270wJwDFv1Vo93adpTH7dq5V/2XHGlernP5HN6o3mB2j2PHMv352O5ewpbtZcldCvjmWWSbvYUHH41xlZtljR0234MFERfWhBQaRFtwDSGAAAkYWZihRLfdd5CHEjl324gUobfQhwQIRAAC6QUnHIspMkQACTHuGONCLuIYU4//8EgQikIGBeM/O/II4owkIJlkTh9+6KSPPEo5JVBYNunjllB5SYKTYCblYZROXhllmTh5WCWaWCIwI5swGSDljlb+QyONdG7EWn0FVckkn336CZyJBiHppnYC3djnbcx1OJCWBWHnKJ0qiCgRpQSpqGmhHAGqIW0qbPkfWqXiqMAogjmG/ZiEo5EHn3VvRSbfP7QCNlVbXeUKkaglCfbDXL6GlZJPVpXkXHocmdWWgce55BK0fgI7EIf4TcVfVAkl5F5JKzL0qVDJhSQeVNLNdmmj43Jkk7RCZpqqbfOalEB46VJYL0Py4pQvqPuCKvDABBdscJmCJRiRwgcTVBllGDZckKsUDRaxxP8UwGphG2Mcl4OFFUtwfh2R7DF7Ij8EMsZTiTRUyn0y5RS1FPnxmnc0S/SUSX7IsREKxuass8wlyeEzRSjUMZ1LPH1n0tET1YHEdN96VDVHdtgR9dRgkdT0thtlPRHX0Z5rr9kdaR0REmZ0/W9JsZlkBxERXcFGWG/+w432RkTQ/dAVbYOZN0Z+O2TGFSc/1PffiTfu+OOQN24eRXXcclA22WA8yih8SZT05ZlTFAsttAj5ww82r610QaFLFMvrsWyJus9QL7Q6Qa0/hEssu8fOZs9q44QLLrrgEjlFuEyD8eIO5U6Q7473DfRCzgvE+/CRT0/QFYhjXtDrxxsk9T+HHxJ66eE3xAYS3F+RzT1cpA9R+d7L3xASbLSPefX2D3Q34O77B+nQJ7/CEeRwVxDEQAh4vL4RQXsDQdw/JPi8WIgCcgYsyN0YAjuPGa1/DkFdz4ACPTqdDnVJ6SCYNse5iXyuIIeIyOtKV8IMVWNzGEEBLwzCPddhDdBjEIxgDClCOv6BCgVBjCBHjIiRcIAwIuFw4hMfUrspjiiDByGb/Ob2kPXZT2wPGd8Wg+cQLR6PjA6pw+0i98GIoMBy4Uud5+IoRzfCEXIoRBoWT9Y5iuzRigRhXkQCAgAh+QQJBAD/ACwYAAUAdwCAAAAI/QD/CRxIsKDBggIEHFzIsKHDhxAjSpwoUEACihETYtzIsaNBAXM8MrQosqTJhwlSnhyYYM7FlTBjtjwAM+XLmDhLqlyZwNLNnEA5HrBE8+SBnUGTYjxQ1ORQpVApDm3qkSnVqFgZHlCgwKmlrGAdKvgqkmvXsGgNmi1r6WzatwIV8HGLUUEBunDTFvjhsQDZvHALFODDcW8BwIAH49mIRzDivAXwLMY4+DHgyRQlY7bMubPnz6BDix5NunRnjf8UwhwQkbXphQlDrh7guiHt2q8JWmyZ4KrHAQZwH6SdE2RWi0N7mwTuMLgBmXNQg+1NFC9GA9gZYn9u9MCcAxb9VaPd2naUx+3auVf9lxxpXq5z+RzeqN5gdo9jxzL9+djuXsKW7WXJXQr45llkm72FBx+NcZWbZY0dNt+DBREX1oQUGkRbcA0hgAAJGFmYoUS33XeQhxI5d9uIFKG30IcECEQAAukFJxyLKTJEAAkx7hjjQi7iGFOP//BIEIpCBgXjPzvyCOKMJCCZZE4ffuikjzxKOSVQWDbp45ZQeUmCk2Am5WGUTl4ZZZk4eVglmlgiMCObMBkg5Y5W/kMjjXRuxFp9BVXJJJ99+gmciQYh6aZ2At3Y523MdTiQlgVh5yidKogoEaUEqahpoRwBqiFtKmz5H1ql4qjAKII5hv2YhKORB591b0Um3z+0AjZVW13lCpGoJQn2w1y+hpWST1aV5Fx6HJnVloHHueQStH4COxCH+E3FX1QJJeReSSsy9KlQyYUkHlTSzXZpo+NyZJO0Qmaaqm3zmpRAeOlSWC9D8uKUL6j7girwwAQXbHCZgiUYkcIHE1QZZRg2XJCrFA0WscT/FMBqYRtjHJeDhRVLcH4dkewxeyI/BDLGU4k0VMp9MuUUtRP94AdHKITlHc0SPWWSH3JslPN0PPcsc0lAY4RCHdO5xNN3JgVNUR1MZ2UTT9ty5IMPE1EdFklPZ42RD3ZMxMbX0cl0rkdcR8TG2cf9W1JsJvmgRkRm/sAdd3Frc2QHERCZYUaZcm9090OCn/wQEYc3dIjikEcu+eSQm0fR0gcJIgjGo3Q+EeYGaY5RDGSQIeQPqEvkdUGbTxRDLDHEsKXNN0vNUNUEtQ7RKrzDTifQtsdkiimrmEI5RcNjrAbgDule0CqTMz505getEgPxlE8/kBmPi07Q68cbVMfZgl/RuunhN/S2GVccckg26KfvkODv3yO/Q+u3f4j39x9EPvubK1380se8gtDvcQIZIOUYxziDDO4fCPye74ISCtM0ziB6O0jsYhGURoRGDsETTSM8aBna3SwnsosJCQGDutQF5XUpXAk44FKNzlkuIqAjSAQdEjtafvwjhiKZYViqUcMbSgQF2hOI+yRCutKdJBW5SaJAuIeR0glCgRjpxGtQUEADcsR5HQmHFvsXkXCQUSIhPOOI2qY+Mvqgiwt52/3IBpHVpW9rEcFd+NJ4OylGDoRH9CPkTnjE8NnscheM3CEvB0fF8QUjjVSjQZYnSYdEkiEBAQAh+QQJBAD/ACwYAAUAdwCAAAAI/QD/CRxIsKDBggIEHFzIsKHDhxAjSpwoUEACihETYtzIsaNBAXM8MrQosqTJhwlSnhyYYM7FlTBjtjwAM+XLmDhLqlyZwNLNnEA5HrBE8+SBnUGTYjxQ1ORQpVApDm3qkSnVqFgZHlCgwKmlrGAdKvgqkmvXsGgNmi1r6WzatwIV8HGLUUEBunDTFvjhsQDZvHALFODDcW8BwIAH49mIRzDivAXwLMY4+DHgyRQlY7bMubPnz6BDix5NunRnjf8UwhwQkbXphQlDrh7guiHt2q8JWmyZ4KrHAQZwH6SdE2RWi0N7mwTuMLgBmXNQg+1NFC9GA9gZYn9u9MCcAxb9VaPd2naUx+3auVf9lxxpXq5z+RzeqN5gdo9jxzL9+djuXsKW7WXJXQr45llkm72FBx+NcZWbZY0dNt+DBREX1oQUGkRbcA0hgAAJGFmYoUS33XeQhxI5d9uIFKG30IcECEQAAukFJxyLKTJEAAkx7hjjQi7iGFOP//BIEIpCBgXjPzvyCOKMJCCZZE4ffuikjzxKOSVQWDbp45ZQeUmCk2Am5WGUTl4ZZZk4eVglmlgiMCObMBkg5Y5W/kMjjXRuxFp9BVXJJJ99+gmciQYh6aZ2At3Y523MdTiQlgVh5yidKogoEaUEqahpoRwBqiFtKmz5H1ql4qjAKII5hv2YhKORB591b0Um3z+0AjZVW13lCpGoJQn2w1y+hpWST1aV5Fx6HJnVloHHueQStH4COxCH+E3FX1QJJeReSSsy9KlQyYUkHlTSzXZpo+NyZJO0Qmaaqm3zmpRAeOlSWC9D8uKUL6j7girwwAQXbHCZgiUYkcIHE1QZZRg2XJCrFA0WscT/FMBqYRtjHJeDhRVLcH4dkewxeyI/BDLGU4k0VMp9MuUUtRP9wNdGaoTlHc0SPWWSH35sVIexPPcsc0lAY4RCzlnxxtN3JsmBUR0oTPetR1dzJIcPE9UxNFgkPb3tRj5wLdHX0Z5rr9odmQ0RG2yA/W9JsZlUdkRs/pgR1tx0s002ERCZoTeYfGPEtEOCn/yQGoA7dIjikEcu+eSQm0eR1wcdIgjGo3Q+0dIHCbI5RTGQQYaQo9h8NtoDjS5RDLCfPqXNQUvdEOsCuf7QKrzDTifQtuNkiimrmEI5RcNjzPhDuhO0yuSMH27Q4wbFwLvxkzdOUOKiF+T78QVhLvghVwgke1DngAk3G4eYcQgZzeN0Ti5sCn7FPeWD/xDc42sev/7h+0feDvE4051Pf9IbSP8GckDKRU97A4nbP6hHENjFYHJuM4gEF2JBj/kheABsCO2ClpMLFip1qgtKB8FUjc5ZLiIowN0/BveQ2P2jgQ+qhg5fKBHQZBWEgBIhQ+lwWLCqGSRxFDFd9wymBiMekSP/C6EUp0hFjyTwIBsE4N0cUocsHm+LXPQi5bYGwxCCkIsyjNwHe3hFNVLEiZP7AQkl0sTjpXAiRGijx25GET1WkSDL+2ND/HiQgAAAIfkECQQA/wAsGAAFAHcAgAAACP0A/wkcSLCgwYICBBxcyLChw4cQI0qcKFBAAooRE2LcyLGjQQFzPDK0KLKkyYcJUp4cmGDOxZUwY7Y8ADPly5g4S6pcmcDSzZxAOR6wRPPkgZ1Bk2I8UNTkUKVQKQ5t6pEp1ahYGR5QoMCppaxgHSr4KpJr17BoDZota+ls2rcCFfBxi1FBAbpw0xb44bEA2bxwCxTgw3FvAcCAB+PZiEcw4rwF8CzGOPgx4MkUJWO2zLmz58+gQ4seTbp0Z43/FMIcEJG16YUJQ64e4Loh7dqvCVpsmeCqxwEGcB+knRNkVotDe5sE7jC4AZlzUIPtTRQvRgPYGWJ/bvTAnAMW/VWj3dp2lMft2rlX/ZccaV6uc/kc3qjeYHaPY8cy/fnY7l7Clu1lyV0K+OZZZJu9hQcfjXGVm2WNHTbfgwURF9aEFBpEW3ANIYAACRhZmKFEt913kIcSOXfbiBSht9CHBAhEAALpBScciykyRAAJMe4Y40Iu4hhTj//wSBCKQgYF4z878gjijCQgmWROH37opI88SjklUFg26eOWUHlJgpNgJuVhlE5eGWWZOHlYJZpYIjAjmzAZIOWOVv5DI410bsRafQVVySSfffoJnIkGIemmdgLd2OdtzHU4kJYFYeconSqIKBGlBKmoaaEcAaohbSps+R9apeKowCiCOYb9mISjkQefdW9FJt8/tAI2VVtd5QqRqCUJ9sNcvoaVkk9WleRcehyZ1ZaBx7nkErR+AjsQh/hNxV9UCSXkXkkrMvSpUMmFJB5U0s12aaPjcmSTtEJmmqpt85qUQHjpUlgvQ/LilC+o+4Iq8MAEF2xwmYIlGJHCBxNUGWUYNlyQqxQNFrHE/xTAamEbYxyXg4UVS3B+HZHsMXsiPwQyxlOJNFTKfSbrMrUT/eAHR2qE5R3NEj1lks0boWAszz0zZZIfN1OEQs5Z8cbTdybJgREKdUz3rUdXcySH1BLVUTVYJD297UZy+DDR19Gea6/aHZkdERtsgP1vSbGZ5APTD/7BHdbcdLO9kQ92QGRG3GDyjRHeDZlhxskPqUHEQ4szLvnklFfOeDVTo03QIYJgPMrnEy19kCCdUxQDGWQIOcoPfEXktUGlSxTD7KlPyfrNXDOkuUCxP7TK77PTiXTuMZliyu+WU2Q8xj487lDvBK1SueOIF3TIQTH8borl1f+j+D+cFxR88gW9rvgV9whUO1DnlFkH3GYcwvn67OfSPpiKH4J+VPdPCTcb8Zsf+R5SNcXF7x+CQN0AB9K9fwBQfgOhH/fs4DiDEO564hvf5Nx2EMItZHYx8JgfiLdAhrAOaDkJYaFWx7qkgLBM1ficeSSCAqFZLyK0+4cEH1SNHmZijiJqsCFBDhgRMpxuhwUT4hAjNxHUke5gQVwIEykCvRJa8YpYLAkHGeLBBfpgiwt5Xwm/CJHXLbBsrishCRtCtQEijYYNlFzSaEi+Fk4kipaz40SIEEeMtQ6IWWyc8wLJkD4eJCAAIfkECQQA/wAsGAAFAHcAgAAACP0A/wkcSLCgwYICBBxcyLChw4cQI0qcKFBAAooRE2LcyLGjQQFzPDK0KLKkyYcJUp4cmGDOxZUwY7Y8ADPly5g4S6pcmcDSzZxAOR6wRPPkgZ1Bk2I8UNTkUKVQKQ5t6pEp1ahYGR5QoMCppaxgHSr4KpJr17BoDZota+ls2rcCFfBxi1FBAbpw0xb44bEA2bxwCxTgw3FvAcCAB+PZiEcw4rwF8CzGOPgx4MkUJWO2zLmz58+gQ4seTbp0Z43/FMIcEJG16YUJQ64e4Loh7dqvCVpsmeCqxwEGcB+knRNkVotDe5sE7jC4AZlzUIPtTRQvRgPYGWJ/bvTAnAMW/VWj3dp2lMft2rlX/ZccaV6uc/kc3qjeYHaPY8cy/fnY7l7Clu1lyV0K+OZZZJu9hQcfjXGVm2WNHTbfgwURF9aEFBpEW3ANIYAACRhZmKFEt913kIcSOXfbiBSht9CHBAhEAALpBScciykyRAAJMe4Y40Iu4hhTj//wSBCKQgYF4z878gjijCQgmWROH37opI88SjklUFg26eOWUHlJgpNgJuVhlE5eGWWZOHlYJZpYIjAjmzAZIOWOVv5DI410bsRafQVVySSfffoJnIkGIemmdgLd2OdtzHU4kJYFYeconSqIKBGlBKmoaaEcAaohbSps+R9apeKowCiCOYb9mISjkQefdW9FJt8/tAI2VVtd5QqRqCUJ9sNcvoaVkk9WleRcehyZ1ZaBx7nkErR+AjsQh/hNxV9UCSXkXkkrMvSpUMmFJB5U0s12aaPjcmSTtEJmmqpt85qUQHjpUlgvQ/LilC+o+4Iq8MAEF2xwmYIlGJHCBxNUGWUYNlyQqxQNFrHE/xTAamEbYxyXg4UVS3B+HZHsMXsiPwQyxlOJNFTKfSbrMrUT/cDXRmqE5R3NEj1l0g9+bISCsTz3zJRJfgRNEQo5Z8UbT98hjREKdUz3rUdXcySHHBPVUTVYJEG97UZy+NB1WCCda6/aHZkdERtsgP1vSbGZ5IPbD/7BjTbbJs2NkQ9EQMSGGWX6/TdEZhB+skNqBO6Q4otHLvnklJ9s3tJfF3SIIBhXM8rlETF9kCCcU0RGDGQI+fnNEFFtUOkSxSB76lPaHLTSDGU+EOwPrbJKDL/TCTTXOZmyivGVU2SKKRgD/hDvBK1CeeNNH3TIQcD7Xnn1Aw3+z+YFyR7TOWB6/U/ih1whEO05neOL+1vWATf692Sj1Dnwgzn4IYfYn9Q5uQBg/AaHPtJFhXxTqtr+ricIMrAveQLhXvfQN5AHVs4H1DNI3L5nENTFgHJ402BDZPdBjCUNghKxGdCAUsI+rY51OSFhmarhOdBBRA26E8j1ICJDC2Y+iIY0nNrQCpI4iTjQgR6ToECKaDrSQU9gahiiQSBHkSei8IpYzGJOQriQDWLxbg8x3xXLBhExonBrocMi8cooxcqdMCJRRCEMWwdBm1EkjpWzI0WIoMSTzRGOWoSj4wLpEC46JCAAIfkECQQA/wAsGAAFAHcAgAAACP0A/wkcSLCgwYICBBxcyLChw4cQI0qcKFBAAooRE2LcyLGjQQFzPDK0KLKkyYcJUp4cmGDOxZUwY7Y8ADPly5g4S6pcmcDSzZxAOR6wRPPkgZ1Bk2I8UNTkUKVQKQ5t6pEp1ahYGR5QoMCppaxgHSr4KpJr17BoDZota+ls2rcCFfBxi1FBAbpw0xb44bEA2bxwCxTgw3FvAcCAB+PZiEcw4rwF8CzGOPgx4MkUJWO2zLmz58+gQ4seTbp0Z43/FMIcEJG16YUJQ64e4Loh7dqvCVpsmeCqxwEGcB+knRNkVotDe5sE7jC4AZlzUIPtTRQvRgPYGWJ/bvTAnAMW/VWj3dp2lMft2rlX/ZccaV6uc/kc3qjeYHaPY8cy/fnY7l7Clu1lyV0K+OZZZJu9hQcfjXGVm2WNHTbfgwURF9aEFBpEW3ANIYAACRhZmKFEt913kIcSOXfbiBSht9CHBAhEAALpBScciykyRAAJMe4Y40Iu4hhTj//wSBCKQgYF4z878gjijCQgmWROH37opI88SjklUFg26eOWUHlJgpNgJuVhlE5eGWWZOHlYJZpYIjAjmzAZIOWOVv5DI410bsRafQVVySSfffoJnIkGIemmdgLd2OdtzHU4kJYFYeconSqIKBGlBKmoaaEcAaohbSps+R9apeKowCiCOYb9mISjkQefdW9FJt8/tAI2VVtd5QqRqCUJ9sNcvoaVkk9WleRcehyZ1ZaBx7nkErR+AjsQh/hNxV9UCSXkXkkrMvSpUMmFJB5U0s12aaPjcmSTtEJmmqpt85qUQHjpUlgvQ/LilC+o+4Iq8MAEF2xwmYIlGJHCBxNUGWUYNlyQqxQNFrHE/xTAamEbYxyXg4UVS3B+HZHsMXsiPwQyxlOJNFTKfSbrMrUT/cDXRiiE5R3NEj1l0g9+bKSGsTz3zNTPQVOEQh3TucTTdyYlPREKQ2dlE0/bciSHHBPVwTRYJD2dNUZbdx0WSOfam3ZHPkjExtdYdeuvcSX5YEdEbP6wcfbaJv27kQ9VO5R3mX7/DZEZZpz8kBpEPJS44pBHLvnkileD0dIHHSIIxtWMYp5EVB8kyOYUkREDGUJ6fjNEmBdEukQxxI76lDYHLfVCcA/0+kOrrBKD73QCzXVOpqxSPOUUmWIKxoA/tDtBq0zOeOAGHXLQ771TTr1AbCSueUGxw+TLP+OPL6TX/yBuxhUCzZ6TL+f4Ys2WdeRtxiGH3PN8TLnADz+Y3btfNpRyjv6dg372w9/okpKLf+SigFNiWgCtJwgyuA95Atke9xBnvfZhUCCAI4IG9faPDhLkdDGYXNsWQsKFxC6FGPPD7T7YkFHUDigw7JPqVpeTF3uWqRqd+1xE1JCzgjzuIT68IIWACMTLFZEgiJOIBS3oMQ2m74hSHN3+QMW4hWBxIlukoRjHSMaTrLAhLaShD87IkDpYUXJyYGMbc4e8srFOjDNsSOuQJ0OJEPGDPLwj8mxGETW80WOEpIgIKSfEiRyyjATpIiQdIkeHBAQAIfkECQQA/wAsGAAFAHcAgAAACP0A/wkcSLCgwYICBBxcyLChw4cQI0qcKFBAAooRE2LcyLGjQQFzPDK0KLKkyYcJUp4cmGDOxZUwY7Y8ADPly5g4S6pcmcDSzZxAOR6wRPPkgZ1Bk2I8UNTkUKVQKQ5t6pEp1ahYGR5QoMCppaxgHSr4KpJr17BoDZota+ls2rcCFfBxi1FBAbpw0xb44bEA2bxwCxTgw3FvAcCAB+PZiEcw4rwF8CzGOPgx4MkUJWO2zLmz58+gQ4seTbp0Z43/FMIcEJG16YUJQ64e4Loh7dqvCVpsmeCqxwEGcB+knRNkVotDe5sE7jC4AZlzUIPtTRQvRgPYGWJ/bvTAnAMW/VWj3dp2lMft2rlX/ZccaV6uc/kc3qjeYHaPY8cy/fnY7l7Clu1lyV0K+OZZZJu9hQcfjXGVm2WNHTbfgwURF9aEFBpEW3ANIYAACRhZmKFEt913kIcSOXfbiBSht9CHBAhEAALpBScciykyRAAJMe4Y40Iu4hhTj//wSBCKQgYF4z878gjijCQgmWROH37opI88SjklUFg26eOWUHlJgpNgJuVhlE5eGWWZOHlYJZpYIjAjmzAZIOWOVv5DI410bsRafQVVySSfffoJnIkGIemmdgLd2OdtzHU4kJYFYeconSqIKBGlBKmoaaEcAaohbSps+R9apeKowCiCOYb9mISjkQefdW9FJt8/tAI2VVtd5QqRqCUJ9sNcvoaVkk9WleRcehyZ1ZaBx7nkErR+AjsQh/hNxV9UCSXkXkkrMvSpUMmFJB5U0s12aaPjcmSTtEJmmqpt85qUQHjpUlgvQ/LilC+o+4Iq8MAEF2xwmYIlGJHCBxNUGWUYNlyQqxQNFrHE/xTAamEbYxyXg4UVS3B+HZHsMXsiPwQyxlOJNFTKfSbrMrUT/cDXRiiE5R3NEj1l0g9+bKSGsTz3zNTPQVOEQh3TucTTdyYlPREKQ2dlE0/bciSHHBPVkTNYJD2dNUZbdx0WSOfam3ZHPkhUBxtg/1tSbCb50DZEbP7AHXdxa29kN956bym33xCZYcbJD6lBxEOHI+7445BHjng1GC190CGCYFzNKOZJRPXlmVNERgxkCMn5zRBZXlDoEsXgeulT2syX1AsxvbpEq6ziegwTEVMa0LTDZMoqw0tOkSmmUOQLQ5iY5kPVDbFe0CqRKw69QYccFEPu1Iu0PEHNU3i9QGwcjnlBrsPkiy/H/PM9jnUwbbgZVwgEO1DrW/M+/Hkbfsg90jNJLgbii3Osb30E2R+FyneIQ2RDKbkooAJZ9LbymQFzAYRJLsjxDw5yMElMs2D2BEGG++VkgAMU30FEOBATSu55RBjfP/SWPfSNriShYEgKSXO3FZc2ZHce80PwHpPD0cgOdTHhXaE4Nwok4gSIYKrG5joXERR8jSCNe8jr/uHCB0lRipWToeEkUsISekyG/xij6ATBxoMpbiFZpEgGjUfHOtoxKz1kSODs+DeH1AGNkJNDHhmiujqWDSK2q+MQCXlFyQlRImpoZOSc+BBJPs5mFFEDID2GSYrEUHJUnMgm73iQN5IyIoN0SEAAACH5BAkEAP8ALBgABQB3AIAAAAj9AP8JHEiwoMGCAgQcXMiwocOHECNKnChQQAKKERNi3Mixo0EBczwytCiypMmHCVKeHJhgzsWVMGO2PAAz5cuYOEuqXJnA0s2cQDkesETz5IGdQZNiPFDU5FClUCkObeqRKdWoWBkeUKDAqaWsYB0q+CqSa9ewaA2aLWvpbNq3AhXwcYtRQQG6cNMW+OGxANm8cAsU4MNxbwHAgAfj2YhHMOK8BfAsxjj4MeDJFCVjtsy5s+fPoEOLHk26dGeN/xTCHBCRtemFCUOuHuC6Ie3arwlabJngqscBBnAfpJ0TZFaLQ3ubBO4wuAGZc1CD7U0UL0YD2Blif270wJwDFv1Vo93adpTH7dq5V/2XHGlernP5HN6o3mB2j2PHMv352O5ewpbtZcldCvjmWWSbvYUHH41xlZtljR0234MFERfWhBQaRFtwDSGAAAkYWZihRLfdd5CHEjl324gUobfQhwQIRAAC6QUnHIspMkQACTHuGONCLuIYU4//8EgQikIGBeM/O/II4owkIJlkTh9+6KSPPEo5JVBYNunjllB5SYKTYCblYZROXhllmTh5WCWaWCIwI5swGSDljlb+QyONdG7EWn0FVckkn336CZyJBiHppnYC3djnbcx1OJCWBWHnKJ0qiCgRpQSpqGmhHAGqIW0qbPkfWqXiqMAogjmG/ZiEo5EHn3VvRSbfP7QCNlVbXeUKkaglCfbDXL6GlZJPVpXkXHocmdWWgce55BK0fgI7EIf4TcVfVAkl5F5JKzL0qVDJhSQeVNLNdmmj43Jkk7RCZpqqbfOalEB46VJYL0Py4pQvqPuCKvDABBdscJmCJRiRwgcTVBllGDZckKsUDRaxxP8UwGphG2Mcl4OFFUtwfh2R7DF7Ij8EMsZTiTRUyn0m6zK1E/3A10YohOUdzRI9ZdIPfmykhrE898zUz0FThEId07nE03cmJT0RCkNnZRNP23LkhxxTMw0WSU9njZEcXEvkdbTn2pt2Rz6YzcbX/5YUm0k+tA0RG2/+w13c2hvVfXfeW8bdN0RmmHHyQ2oQ8ZDhhzfu+OOQH14NRlQfdIggGFczinkSqXE2QZdjREYMZAi5OecQ1ZFzQZhPFMPrpUOUyWg28yX1QqsT1DpEq6zyegwTRVMa0LfDZMoqx0fkS+QCmWIKRZgwRIzwpPnt0O4FrQJ54lVbflAMvWsvUvT/kE/+g90PxIbhoRP0Oky+YLL8+Swu/c/6ZhwiUOwnkVNQ/MubUh3wlr8r3AN7JfHfQHzBwAaeL4Ajwt8h9JeUBkJQIBfMzQAlKAgEws9/y8vgiJgmwX8Iggz8g4kCQ5ih9KmvcBT8Rwoj5wM1JM4geYvhQEgHPI+f5EKBB8mFaex2EMB9731AAaJn/FA8ywhRNLW7GU56yJEnguZ0UszJ78pUjS6iDiIoyN1AGPcQ2MkQR13sIuVc+I/CSQSFKPQYG9tIxjd20IOguuFB6jgRPDLvj4AMJFaIyBAjAtJ6DanDHB9HNjB+jnmNTJ0gm8gQzwESaBIJ4yUpssiT2YwiROgkxj7JScVB7oudE+RE9KhKiBDyIQEBACH5BAkEAP8ALBgABQB3AIAAAAj9AP8JHEiwoMGCAgQcXMiwocOHECNKnChQQAKKERNi3Mixo0EBczwytCiypMmHCVKeHJhgzsWVMGO2PAAz5cuYOEuqXJnA0s2cQDkesETz5IGdQZNiPFDU5FClUCkObeqRKdWoWBkeUKDAqaWsYB0q+CqSa9ewaA2aLWvpbNq3AhXwcYtRQQG6cNMW+OGxANm8cAsU4MNxbwHAgAfj2YhHMOK8BfAsxjj4MeDJFCVjtsy5s+fPoEOLHk26dGeN/xTCHBCRtemFCUOuHuC6Ie3arwlabJngqscBBnAfpJ0TZFaLQ3ubBO4wuAGZc1CD7U0UL0YD2Blif270wJwDFv1Vo93adpTH7dq5V/2XHGlernP5HN6o3mB2j2PHMv352O5ewpbtZcldCvjmWWSbvYUHH41xlZtljR0234MFERfWhBQaRFtwDSGAAAkYWZihRLfdd5CHEjl324gUobfQhwQIRAAC6QUnHIspMkQACTHuGONCLuIYU4//8EgQikIGBeM/O/II4owkIJlkTh9+6KSPPEo5JVBYNunjllB5SYKTYCblYZROXhllmTh5WCWaWCIwI5swGSDljlb+QyONdG7EWn0FVckkn336CZyJBiHppnYC3djnbcx1OJCWBWHnKJ0qiCgRpQSpqGmhHAGqIW0qbPkfWqXiqMAogjmG/ZiEo5EHn3VvRSbfP7QCNlVbXeUKkaglCfbDXL6GlZJPVpXkXHocmdWWgce55BK0fgI7EIf4TcVfVAkl5F5JKzL0qVDJhSQeVNLNdmmj43Jkk7RCZpqqbfOalEB46VJYL0Py4pQvqPuCKvDABBdscJmCJRiRwgcTVBllGDZckKsUDRaxxP8UwGphG2Mcl4OFFUtwfh2R7DF7Ij8EMsZTiTRUyn0m6zK1E/3A10ZqhOUdzRI9ZdIPfmyEgrE898zUz0FThELOWfHG03cmJT0RCkM3/a1HV3MkhxxT1xEWSU9vu9HWE3kNFkjn2pt2Rz5IVAcbZ/9bUmwm+dA2RGz+wB13cWtv5IMdeOu9pdx+Q2SGGSc/pAYRDyGe+OOQRy554tVghILZBR0iCMbVjGKeREsfpDlGZMRABkTRhOb5zRBdbtDmE8Ug++kQZTKazXxJvRDmA8EO0SqryB7DRKmTBrTuMJmyivIQ0YFJQ8UfbIopFD2/UDTElOYD4w75XtAqki/OtOgHxQA8+CLRIVD2/7D/4PgDsYH46ATJDhMmzrefJApwH27GIQKhXUl8cRBf4G9Lb5PfIRYoQJP4goACMeAfHnhAgVhvRPIzwxXuoRQK/qEgBIRgbhJ4OM15LyYP/EcIp+S1DAJQEGRo4EoguEIKwS9+JRyIDEtCjiS5+UB8BtEbAAtiuuF5pIcMQSJp7nYQwZXPfh1RYgFD4wfkWUaK/8AiYHDHupgYkSPk0KJlPDeKLuJEeGWqRuc+FxE1VI0gjnvI7P6xw9yoUY2We+NADieRGMbQYzcUCB8pQgZBGPJgi1tIHClywsk58pGQfAsTGeJESNrtIXXgnSPlMEmGuC6SZIOIJidnRU/qUXJVlIgbIWnGh5wScjajyConF0uKECGQJ2PjRHAZyYYkspcS6aRDAgIAIfkECQQA/wAsGAAFAHcAgAAACP0A/wkcSLCgwYICBBxcyLChw4cQI0qcKFBAAooRE2LcyLGjQQFzPDK0KLKkyYcJUp4cmGDOxZUwY7Y8ADPly5g4S6pcmcDSzZxAOR6wRPPkgZ1Bk2I8UNTkUKVQKQ5t6pEp1ahYGR5QoMCppaxgHSr4KpJr17BoDZota+ls2rcCFfBxi1FBAbpw0xb44bEA2bxwCxTgw3FvAcCAB+PZiEcw4rwF8CzGOPgx4MkUJWO2zLmz58+gQ4seTbp0Z43/FMIcEJG16YUJQ64e4Loh7dqvCVpsmeCqxwEGcB+knRNkVotDe5sE7jC4AZlzUIPtTRQvRgPYGWJ/bvTAnAMW/VWj3dp2lMft2rlX/ZccaV6uc/kc3qjeYHaPY8cy/fnY7l7Clu1lyV0K+OZZZJu9hQcfjXGVm2WNHTbfgwURF9aEFBpEW3ANIYAACRhZmKFEt913kIcSOXfbiBSht9CHBAhEAALpBScciykyRAAJMe4Y40Iu4hhTj//wSBCKQgYF4z878gjijCQgmWROH37opI88SjklUFg26eOWUHlJgpNgJuVhlE5eGWWZOHlYJZpYIjAjmzAZIOWOVv5DI410bsRafQVVySSfffoJnIkGIemmdgLd2OdtzHU4kJYFYeconSqIKBGlBKmoaaEcAaohbSps+R9apeKowCiCOYb9mISjkQefdW9FJt8/tAI2VVtd5QqRqCUJ9sNcvoaVkk9WleRcehyZ1ZaBx7nkErR+AjsQh/hNxV9UCSXkXkkrMvSpUMmFJB5U0s12aaPjcmSTtEJmmqpt85qUQHjpUlgvQ/LilC+o+4Iq8MAEF2xwmYIlGJHCBxNUGWUYNlyQqxQNFrHE/xTAamEbYxyXg4UVS3B+HZHsMXsiPwQyxlOJNFTKfSbrMrUT+SEPRyiE5R3NEj1lks0b5Twdzz0zZZIcN1OEAhLTucTTd0djVEcd033rkdUc2fHJRHWwERZJT2+7kR12TOQ1WCCda6/aHW0dERtnY9Wtv8aVZAcREf6ZccXXbJv070ZE4P2QGWaU+TfgEOl98kOBP3TI4pBHLvnkkJunNNUGCZINxqPoY3lEdTCdOS0YxUALGRBFE9oP+vghUdeZUxRDLDHEEFEmo/0gj+tyOIQ5QYJItMrwtDdETEG4k4Z02TmZ4vwqEP2hOkOZTG+w8xT9Qb31ojXuUPAHQS85ESgIfhD4BcUyvCklaf/P9Ny/JjRBimteUAzinyS99u7jGPo/ervH3v6BOpP8wRcG+QMxMLElNuhNb4I43UoQ2L8/YAITf1AgAwVyvP49KIBXQB9Q/kAHDBaEfxRiwxX0dogrkEGEMfGF9hi4QSF5jXBXuAcByVDAmM+4D4UUmh/9rnCIzQmkh5T7R+DIZ5DC/eNx9yueR+LRkCiYxnxNbMjsbMcRX0CjITIEDdJAg0CClNEyugNaTvK3kXic0TOs+4HrgrJFjnzRM6PIoz4msjSDDPAhs0MdF0dUjVEUEiMoEKJADgFFiMSADBLEmCIX+UeJQPKFB0vkQpyIERgm8ZOgDCVYsLiQuIXybg+Bmyi1BhE2iA6UrITI7z7JPFneApRjjAgKZjm5pElkkpDzwxx/CcyT6Q6RpFwcXxApyol4r5kQSWZDAgIAIfkECQQA/wAsFwBPAHgANgAACP0A/wkcSLCgwYMIEypcyJCgPHkNDyKJSLGixYsX2X3COBGjx48gKX5idxEJm5AoU6r8R9Iim44rY8psyI5IRSRXZurceZDIpopmeAodqoXilZxDk87UYrOhGaRKo6YkUpThlWxSs6a81fAQVK1gL95CwRBr2LNoP+ZIyzbl2rZw48qdG1bfxZcHs9FS+YeuQn2Ab8IkSIvMxRix9jZ8ezBT2ocQI7L5KlAxxVWxYsWg6NjvwIcbNyocXPnyqtOxFvYl2NnzQI0tZ5qabSriIGIKM7V2HXP2xd0FM0XjPZAI14WWC64iLnXs8YOCDp72jbKzdeYHnw+8+o+W2YGx/ZbH/CP8H3DsBpEE9XrPbPKLqwX+iT/wNn30CI9eveLd8Mq+8f0RzXz21ffPffixp1dSfxCDCXAADoSgZ09dlY1e/u0034Ec4pdQTl5lc093ZKSm02oReiiQdttdIch376U0oYrGjWXQIQJ9B14M4oE0o3zoVXUQZQVp1iNGf0Cj0B++eDaSa/f9GBZoscl0JEZRSPkYZEKFZ6JCSh6kZV2A2UUREqT9E11DmqW2GV9gjTJKYBYhUYdBF1KkGS1fqohSmv+4eFFhtMToZ0W33DmkR4YeFOahkEYq6aSUYiTkh5XytElTCj2V6Uw+NYTTpzLVJBmpMYkmKqCoXvQpZER2topSlaLKCpI8qkaEAqu2MvSQWGT1alFkFrEoLE8oXHosT8YqFBAAIfkECQQA/wAsFgBPAHkANgAACP0A/wkcSLCgwYMIEypcyLAgO3YNDyKJSLGixYsY10C8OBGjx48gK7LbxPFKyJMoUwpcc/GKSZUwY1LUoqWiS5k4cyLUwpLiS51Agd7ymS2o0Zy3vES8UvSoU5W3hjLM1vSp1ZNSF1K9yhXkrY4Kq+bM0bXs2Apm08Ykq7Ztwz9u437MJLehvJIHadFSSddijmhd5cmrZRMsQb0XYymmyPZg37Ly2PXz+XPg3oq4FMeq2LjuwIcQSSqsLPByQ1O4Vq3CxfCxQNeeB25aI1qmKdSmKGYapDAH7Ngwb2P8PTATcc9fGZoumBs416+GCy4fqBpX85N9sztXGP3fVsQE/VfL3E33+HaDN6nSQiNw88c/8Af+qWHQOLHzlLPxy6Z3+km4cL02yB/GEVjcP+adRxV/7BlF4B+8EVSefJkEuJ1LVPHTX1AGTogfQyYtuBctsfinUoAAfmhQVgRdQQt/A7kXk4UqHhQVEt015V8sq8gIEo0GAekciwWRVhCPrP0oJEHxxTbbdkAuaZZkI+W0yn9SthXZQ0Ct5iNCf8QDZmz6CDYZRUgYKZZCPG725UCnYJSlTvqUeWZFaRr0IkWamejRH3HW2J13azZUIng1noQjQoVG5OdBgSYKnJiSAhdppZjiR+RBRmaqU1QgduppTFpsyqmoo6rE01KpAlUqG4iDtnrSkxHlKWtMG6F5K0zs9IRmrLtexKVFiwYbUq54GltWcso+V1FAACH5BAkEAP8ALBIATwB9ADYAAAj9AP8JHEiwoMGDCBMqXMgw4bx5DQ8SikixosWLGAk+xDgxo8ePICvO83KREK2QKFOqFLjnIpeOK2PKpOilJUUuXGbq3JlwD8mbPIMKFfizIc6hOYbq9AJzIZqTQpMqlcm0IRo0SqVOjdk04dOsW2US6npQWlYmYdOqrNFQq9q3HmtkUug24Vy4eA/e9Vg3r99/bDPm2Ku0n0uy/2iJmkk4Yo6+Q/vNM0yRULaysS7iirX4ImSBn5U+hBjxaMHMFXFtxiX4r8ONNhPmPE1Rte2KjUO7/jcydkxTuIBjzNS44OPdQk29AVl84HHkEhEX7GyQNXS/Y6UnPqhaeMy74P2vMyT7VRrqgap5Ep/bXLzsnLTQ5IN6HuMpRn/w1/gzsMYgg+u5ZxEXV0mjmCj07MRWYIANcsN6e7EnoEJo8IOGgWFl4t8NBUkokFw17LefeATGN58oZikl1z8eTshQTlcp9g9n9Sn4IWAuSnTQUxgKVKNMDOaIEFNjGYTVPykStFpM/CUUpIDaHYnQbSn98WRBI163xxpCNtkfcqORJpN1VV7pWpg8URkRI6cgxMh1/UhGWUSWGQQVQ0uSmVCbF70ZVj+1xHlRHmRJkySeNO7JZ59e5ohYjxVxJsqdAp2yaEaXQlkGQlJa9GOmB/mZEJtCugaqQaeWmlaqqkLHSKqqRXml1KtCVrWQaUHR6mJNRs2Wa6sG8WoUsGr5dutlxE61JUWEJjuVmHQ6O9RGFZWhnbQpUVtRkdjqBG1l3ULHbbiuXWtQQAAh+QQJBAD/ACwQAE8AfwA2AAAI/QD/CRxIsKDBgwgTKlzIcCE8eA0PEopIsaLFixgNkgqEUVjGjyBDYiQF0aIwLiJTqlxJkNRFNB5Zypx5cWNFmDQP5sjJc2AgjhTR9Cy4cyhPoA3RuDM6sCjTmYSQLpQm7ek/p1ZX/mxINSvWrConMuxq9StYkVEZilJZI1NDs2fjfqzBMIett3LzKmy7EC5Rt3oDG6QL0q/gwIAx5jCcs2TFkwdFraV5g3DFxXEfOm7IJWZByRdxicL10TBjo5opChP62SIuXa8LH04Ij+Q/lwpZE5zcEJdv3xcTCzx9mKRUlrjemCKdMYdwg5hnG1We8kbC6NIPBhKrkHdB5tn9ZxMSxt2g94G/wcsEXJR4+H/lBXYFTRD40ByDdrp/TxAnVVFV/XOeRYwUyEgNB9ZgGV2WCVSDc/y9RFU+0uRDH08KEpSJc/jd4JRbz0VoEFXSXJhVWw8WZJ11Dmai4IsZZoeGNO5UKNmAQ/EFoohB/fNfVZKpl6OD/zTII0HxyfffQDjOZOSR2kXl2UABDvjaKjQ9SZCW7yVJpUKvCSlSjAiRmR0puEFZZEFcylVbbTmJOWabgWm22Uy+6YIRI2W+109qqk0pUJMGhfmPngwVuOdZ8NSyTz8XQVYQWQ3pEosu9CykKEYIqimQoPIRmtCNODJySkh8QjkeQgFehGHjqYlq6ml2qSq06ayB1WorroLpyqtPY2Xl66/bMYTTU7D+KtBWxupm1LC42tQQqDwlq+xxCnWGrLICoakaStxadSdD1IZLE5wVrWruUOg+5uW6K43b0Lvw6pVWvdnRe1BAACH5BAkEAP8ALBAATwB/ADYAAAj9AP8JHEiwoMGDCBMqXMhwoTl7DQ96i0ixosWLGA2aM4dRWMaPIENi3HjRnTGRKFOqJMjRojt3K2PKHNkyojtOMw/myMlzoLlmFXX0LLhzKM+aDHXANCqwKFOZzcrZFPrU6dOVzYAmFXX1n9WuKbUuVIqyRkRbYGNmTZqyRqaGX9PKBWl2YQ60DOPO3Uuwhl6CeBXm+MuX742QhAsXrotxMFiIFo15NKhDV84biRE6Tmuvc8WbB0W9uqir9MfABjMPtRcsHUXQBS1XxDXN9EfVfB9yRHpwKUHZDXG9oQ2c4lfchTfyVjl8+O23CTcrZupcJGHp0xGuXVicIK7s4P0HZvVtkKvBacK/zyzKPnxEsQN1cNVFdSB6ozkyHUbunuDLf0rpslR3FjFSg4E1JJjgQIcx1lQFh/V3kVLuCKiLaEMtyGAmOfjF4UA78RdegBXK1eGHBB0W4T813KDgi+65o5QoFZbYlYte/bOihBEJJSOGpRHIU11m7cijQfDFJ59vQsrk4JEKZbWdfwLVN5Au9zmp0JM8JkmQlQZhqZ5KGiJUZngkQdlXQVzyZY856SyX0phktjkda+kE01NtdFJkp51udgbZezgVBGZCQf7TZEEGYgQoT4IO+hp5VS4aZqIKMcJIRmeq6SWAlDZUWmUHaRrSo+A1E2qVGQm5YClDryaEqppzzWoqreDFmimuufIaJVtX6eorS58WJGOww2pUrLGFMiVssj/ZhGyyLL3W7FCnUOuTnAi5s6y2OXGb0KrghiuudhOVa9RDFwnzrbooSUrRu/DONWW9qVYUEAAh+QQJBAD/ACwQAE8AfwBHAAAI/QD/CRxIsKDBgwgTKlzIcKGNdA0PeotIsaLFixgNprOB0VjGjyBDYrTB0aI3dyJTqlxJsNlFYx5Zypx5kWRFdzFpFsyhs+dAGy4p5vQpkCfRnkEbGkN5tGhTnTYmNnT36uk/W1ZnekuqkGpWo1lZck2oo6rIGxGxhmW5laFZkTUyNVS7tm7KGgxtgVW4165fgzfkKqSbMEffv4gFogV5OLFjwRgNh4VocujAV7p03mi8UG/ddKArLj346i3FaboyZ+T8j3VT0JSVMiVouiFq1CAJOy64EWLJhJb/1Vb4ZprxaRf7ut5NcuzKN7igf8wB+WAO3bt1vnmTkvX17An9m0lVOFwgd/DZt443WN54dJ1G46NvuF7gq4msahs/alju8vkGjUbVK0yplhEjCN5Rw4ILDoTWYgNlQh2ALw1YGmZE1QDhP5tJ6OFAPP0HIFXu5FdXh3096GAmGrbYIHjuyFLWhQY+FRiHOFIo1D8llvgPK7qwYtViKuqIUH32DThQjT3hZSRD6iHJ1HC67DeTkwhtqKNzA+mg0G0yvYiQhgDa9ORAWAqUZmK9/SYTcmGumR1ssdFkHJMRMTLmfPvYE5pQsw0U6JdV/oPnQQhiJOdR9vRZZ0TGIFkaRakBuVCiiup5pkBICjdoQ0HqUt4pmn5UqpHeBCeQlxiN2qbQqYhuih6siNIqq122GpTrrWHteiuXBbH61Cm8HhQVQzFa5euZQMlmFbHFtuSmQqrqBG20Ak1L7afWYputtsB16m1P4Cok7rgzbWSRMcCiy5K6lbnr06MRnSuvX23dC569+vYrEyL+OoaIKQAH/BciBRvsF8IKH5xww2EN/DDEWTFMccQWX2xVxho/JXHHG08Msk8cj0yyyCbP9HHKRJXM8r8u+xsQACH5BAkEAP8ALBAATwB/AEcAAAj9AP8JHEiwoMGDCBMqXMhw4ZIlDQ96i0ixosWLGA0+xGgso8ePIDEuSXLR2MSQKFOqHEjlojdZK2PKxGiDJEVjMGcazKGz58AkNiPm9DnQFlGfQRkae3V0IM+mM4EKHXrUKFSZSU4ulOXu6j+rXlcmTSiLacgaEcGGTZmVodmQNzI1VLu2LsgbDG3RRfjUrl+EcRfu3dn3r2GCeD8yOczYoNyMtgo33eeS6sBXrHTekDyX8+R9ECl662iQ1VuK01hN8zhYYGuoS0BTlEWaYOaK03LfhtwY4UOIYw3WHrib4Ztpx1dblPy698jQMt+8wfXGY47HCPX2PiodpWfX3/23t11YnGD17b2zai19EDlynU/jo2+4XuArmJgL5j56nWf4+Qjh9E9Z+f1TnkWMMHJHDQrWUENi/+AFoUA5MFEBgBfRdt8rmB0YU2ADbZZJf9j5h+FWG3p4lIiSSRhiJnE9+OAf6OHkTlmmqdhTYC6eKNSA7phmICu6XJVYjz4aVJ9AZZVFXFNoJblQVuMRlNOBus00oUFbUoQIIlcFN5Bl+u23koMKgWjRl2DqRIUNUg4UpZwYfTnTb9DF5IRMD6Jk50qgbdRTbsohiNCcH7GZ0j6M5qnUkmQilNpqOhLEyCkYIcrQnx8xymhlBnGIGpGV/nNpRgtGxKldS/5z0t9FrMR62kCnYPrRHQ0pymqrA2bkoa0LMRJsrm3GeZSwwSKbkK7G+gSsQs8etGqzOimbaLFriVnQcEdFW+e0YWprZaQ6efttXVI9epW5a2LrVboMkTsTuxUx65WjCnnDq0z0eukubOIKJ+989sJm0b4E/3uUoKJxeyK4C+PLkL5SFtyUxAwFvB3EAHqjMWMcY/jxYRZTm7DJFYeMMsgKr9ybyi4bBnPMdpVMM8kt3+yXzTrXnHPPdfEMdFgzDw1V0UYfhXTSPQnNdFNLPy2T0zcHBAAh+QQJBAD/ACwQAEsAfwA6AAAI/QD/CRxIsKDBgwgTHuRHT6HDhxAjSpxIcSJDfhUzatzIseM/evk8ihxJsuPFkihTqjRIr+HKgXr0aHz28iU9jDUFTgKSkWZOlDdd5oxZ8ZmsnylbIv0Hp6Isn0tF0rsnNCeQphKfLrVFsmXVmnCwRjy6teu9qEyzkkXKdaTXqHCgOpS19mdbqV9zwkkCkS7aux7H5c2Zpe8OkZkitnKrFO0zvnNH3kj8EHDHcWfRav53o/Liyg8Fj9u8+QYTh58V2jrtkJ5g0qU7Wk6IGTZpyhltzUY4rrfHNkXrDpTFamUO1hN1T3ztUU+bfRO1GtxRnCIrJ9VzJ9yt0PfImDL9Ixo1mD0iduwcuVfsPbpkzElpFQr/d9j8NCf3KyIXqH59e5R6wBFeSm8U+MZGTOSgWn+0eWdbRQWKtF9BymXkoF6QKVSfQQc+uNyFNT0mV0Hz/YOfEx2mpOA/bTEY2n9LjfiPX9QVhN9PCZ42oYUgRqUVXTuQVV5Fp9xhZA133PBHZwJ1xuRAOYrUI1p0VclKjTVNRpBp0eS44j86UjSlZrIEucMrpB13XEEKfjnZm5MlSRB7D1ZJ15UbLqVlZ19uNOZSR8nCAXH/sMJKF1Ex6eRlf6ok44xVDjTkSk+S1ChKSWSRhIxk5SnQdZOKVKlBuIl5KUliGVTiQB/kV9PSDXcopKV/NQXo4USjjhrRqRmBB59KTqQkZ2AwigTegMBOE+pDsR6k661tPIfsQ+MV5GlCrRb3AURFZlTDZtE+F5yqqx7EygeGOtRtRnd8e6t4B5VZkaFYFnTKKR01+65CjyFUrkOh4susQ/rua7BCAit0R8IHN0xQwQkx7LDDEk/8UIYJ/ZtSxRYnFNZD0iHFcccGfQyyxiWNTDJBJlMbFSwrO5TqXI+qpHLMtoqHcsw//SpRzTwvRdREzwAd9FDTQtTv0ZolrTTTQW8KNc+FSRQQACH5BAkEAP8ALBAALwB/AFYAAAj9AP8JHEiwoMGDCBMqTKKwocOHECNKnEgxCUOKGDNq3Mjxn8WOIEOK3Gjx4siTKFMW/KiypcuOLF/KnEmzps2bOHPq3MmTojdvPYOe/AlUqFGQP48q1ejN3dKnPpNCneqwKdWrCpsWxcp1oLutXbtaDdvVnVmyYc+ixWrW6dqrbd/CzSd3rtu6T/PdxbtUL9+8+ej+7St4sNHAhvsmXsy4seOZkiRlfPY4ZGSMlCt3lDSJ4rMUmkF2nvgsc+iNk0ZDfCaCpq26qSXKqvm6bpaIskDTbIUXzu2HImbvxpsFDnDhw4k/lMUBZCaIvIn/Vtgc5I3nDqOfFskk+5CHtf23P7zRXeH3hrbCi3dYXqP29RDbU2ylfmYbz6YJ7kB+kol86O/V1MaAEpV20A47UMTKB6y4l1CAN7Whx30QpcCfQAlKxOAHH2wEoVKRSaYaQvlhGJETKDoxDUX1fbgUZ5Kl9MaMTmjERH0FteLiYzOChONAOnJVnEMZGlQjfBJlkUWJBF0oUIpvqFRebT9ixWRw/yBYEIoy2XLjP1WS9cxszMmSYRcb3aGmmjf8cQMxAz33HxOz/FdXcBZyIEsXRapEHkH+zZLDje11Z2dXZe6Xk3/+FWToQExkEukNnmTy5lIWBqenljZF+s+jf5EZXII7sNIgTTcIBCpa0xGk6ClyaMqUKl/FLWmQcNURxOCRJ82KEHZYtVpQawnt2iucCVEKFWdk+SqQs0FJosdlKfEq0h3QHiVhGzGq5MQHK1J0B0LZBrXLgBSuphtBuTa04T+nNqQmRuPetMu56UZkYEHMRcRgF/EidEq94pY7FZP/6ElRF7Kw0udAA3NE8FW2HtSuRA8LdMpDEx/UMZIafWzQHRuDnCbHJp/8l7AHEUtTycQZ15AsCKsEs1yTsHwQazXd/FZsD9WcEix8jdjQZzQRXRezqwmdMkLdrvZ0RNTq6/TUA1UdUcVYJxS1vl2nNGTYJ+mcUEAAIfkECQQA/wAsEAAvAH8AVgAACP0A/wkcSLCgwYMIEyqUNEmhw4cQI0qcSJGiJEkVM2rcyLHjP0kjLnocSbLkRoYYTapcybLgpBENW8qc6RElzZs4c+rcybOnz59AgwodSrSo0aNIkypdyrSp06dQo0qdSrWq1atYs2rdyrWr169gw4odS7as2bNo06pdy9bogzYaV7SV2GZExixzI46wS3GF3LwQU05c8QwwxL0TU/y9aeIqzMQ6GzuWmKJwziFYi8R8mEKETsxXixSBKMKzThxZRz8sPdJTRNRYs+B1aNojEyYQYRueiNshDt0KW+0meNv3w1aShwvsvTG58oHMKw5xjnNXRcIHOXBoyUQ4RRyg/XnuGj/YckEOOyp2Wb8ReMHwPtu8lbgihcHtEz/oZ8XRPdK3dvGV0GID4QeREwh+4ERF3g0E31IPhNTSG05QuFErDR40hH9kvfHGSBm+96BSRcymkIEFLfhcQbKZeN9BClbYknfeUQeViwKxpl1BCt7UigPChVgVdiLIUqRA6W10x5J03HEDMU9C9090/9gyhgNcpdCZCNqhR1Nx0Dlw5Ri2NBikVaXJsmNP3XVXkC1TQncbE54wkYknxCCl5TNcapekTsXhRqVV9hXJ5T877NAFoMvFSRWOOZZm4J8zDUpVibIZZBqKAn3AygcsuZaQpUmpdpB9CekHqklRjkq4qlASRiXqQLMS9VaELalokieZLLWLfHDJtF9GdyB0Q1JPjBdsRNidF9EHXfC36ENLZpQnT09ka11fkB4a0XqsUHpQtdYWGxWk/7BGUaKJHgSLuUreiG66GnEqECwQwYuQvis6xO+4//ZrUMADC+zvVqYmhGpOp2g1QsIIaakTvlg9DFFlE2cV60ME0kTxZMya53HFAj6URccG/7MssykThOtEmbb8z3wUxZzyA3fJvJHNOlMEsUMBAQAh+QQJBAD/ACwQAC4AfwBXAAAI/QD/CRxIsKDBgwgTKnzAQKHDhxAjSpxIkSIDBrsqatzIsaNHBhceeBxJsuRIBgx3XWhosqXLlwcZYsQIs6ZNkigZMrzJs6fFnT6DCk0IdKjRo/9EIl3KtKnTp1CjSp1KtarVq1izat3KtavXr2DDih1LtqzZs2jTql3Ltq3bt3Djyp1Lt67du3jzSixKMYveiA+U9v0L8cGIillWEIZ4mOIKxYsdjmgc8XFQE2MnT4TsE3NmiSlSCB1CdkSRiKFHky1y+mEKEUNxlG3tUATskZ4iyl7tt3ZJT0wg7o4sMbhDHMMVtiI+kInxhMkRmljOXODzjZ6rDxzD0UT2oE/9Klo2yIFDTSbUJ+IgffTJrowSEx8sX7ELqx0coxNkv/S94IfjEWTeRB8U2EVH+k0VmEiUIcTZQANC5MSEBVaUnkD8YcXACP+19IYTH3LUyoUGDZHgW2+8QRKJ+313FWsPRViQE9oVVEQWGyQk40AfTEgjTNRR5yJXvRFk2z/0EVQhT62M4cA/LIK1gmiviTAgfhzdoSUddxDjZW7W/XMdlE6iNWUKsljJAZY2MQGmdQ6MMcYsY6RnC5Ri2aYmUkyMgV5B3D3nnJueeJKJl1SF9hoHVrIZlHNiRmqWYlWat8OlQhkX3Jhc0UZQpQM5atObY7GWRZEDifbPbQR1sc6kS8QoRCpWnhakKkIFfgDrDQq5aRWHXs06q1MLsvSSri7dEKtV/nXoUq4a3YHQslM94R58EclXEKsOfdDFgQc+pKVG1AplrbUVbYCqQEdG9O0O4SZ0BywbcenVuuxyG9GlO+woECz0diTtVqcipK9E/v4TsEMDy1tjRA3Lu/DDCEXsMMUXl9UgQrf6NLFYpgHYMU8fg6UZgA+SrPHGCaV8U8lfsdwyvjXB3JVhEm3gMsXGZosxQYH1lePPSTn7UME/G3000RzByLRGtToUEAAh+QQJBAD/ACwQACwAfwBZAAAI/QD/CRxIsKDBgwgTKvzHYKHDhxAjSpxIMeGFixUzatzIsSLGjiBDisx4scqFfydHqlzJUuCFKjBhtpxJsyKDiy9jnkxZs6fPgzdz6vxJtKjLl0hxGl1a80JQpUyj0lTKU6rVkTcbXt2KVSvXr2DDih1LtqzZs2jTql3Ltq3bt3Djyp1Lt67du3jz6t3Lt6/fv4ADCx5MuLDhw4jlMniQcUPih4srZnnskMEIihtWUK5MccXkzQpHXI64QrNPE3FFSzR9Wu7ohylSEB3iugjE2LNrwxZRFMdc2w5T8O7oCaJvuUWAKxxOvLjD46AhMnku5GGr6AKZTFcIPaGJ69j9/23XiDr8wDHkyxN9QjELa4IcOLRkgn4iDvVFn1TZJTHzwfgUddHFDhp1VxBtUu1yAX8QlWaQfBJ98IGAGxko1mINeYXQewJB+JATIEpIEXgDIXgWA5a15MQbIGrUSn0IDWGhX2+8ARKJBg2BX1nJOeRhQU6YR1ARGyj34EEfgBgkS+CVt6NanxEk3D8i/PiPiDW96MA/OMK1gmwihAkhgRrBcgcdZ9JBzJoDFTeeQK3EadeXwlUJIE2evEkfE5S8SOJ0MLZV551G0TfGm/+gN552njTqyZrEiEWnmByQSZR24mVKl2aD/lOppT1tNx2iahk5UJ3MgTqTc8glF9flqQIxN1AXWKoUaUKsnvWaQbIlROsHtt6KUKNkpbhWrv8ge9UFD0TGErDBlrXfA1WtJCG0E92BkLBgPeEtgxD5V5CsCtHaxT/nOnQHLBXRsZS33mL2aqzkljugqgbBwm672q41L70U7bADoQTpy5G7aWXh2EG9UmSlQPsu1G9CEwupUMQUY2yxQRUnpPHGBddlKsNFfeyWagt9SZTJbKGcMoc0sbyWyymvPNeuC7n3EzqKabjQBv9a7LNDC4PMEGMSKWz0P83Ka3S1EI28dNRST+1Q1QgFBAAh+QQJBAD/ACwQACoAfwBbAAAI/QD/CRxIsKDBgwgTKvz3YKHDhxAjSpxIMSGDhhUzatzIsSKDXQw6ihxJ0qPACxdKqlzJkiCDlChhtpxJM2PMKjBR1tzJ0+CIfyH/oaxCVGfPozwfKP14gahTpFBrLn3Z1GlMpVGzsryJ8+pFrWBFfqQaU2DQsGg1PmB6genZtHBNfm2LMa5dihff3t0bESvfv31/Ah5MuLDhw4gTK17MuLHjx5AjS55MubLly5gza97MubPnz6BDix5NurRp0V8rZjntMPXEDawXMhAsMcuK2LIproCNO+EIvQtX3OZpwvEI2g+HE3+MfGGKFEeLGy8C8flRHMypO0whAin2x9r9nXfvSAzid8dFwicc39GTp4fnezt8vxCHkIet5P9j8qK+QxP56ccER9LpJ1B/GZlQYE9PUGTbQRxw0BITY1CEw4JHPVHFLhJtoBxBEVLURRc7aBRfQUOEtcsFHEIknEESSvTBByNudOJeeQEVHIwROeHjjBQFOFCKhTEwW0tOvOGjRmNUmJAJN272xhsiCWmQCUQSlp5DMRrkhIEEFbGBegWxR9AHPn7JUoABYnjYagVx90+IZ36w0xit5GdlYytAJ8KfMZaoESyw0FEoHYiWJ9B7AxI0BiV7OtYndyJEKOhM7hFEYZObDlRho4tRWmlWL/DnpKf/nMqEe570Qf7Mq3TsNSmgHFza06r7/YMgZLdRKmGtttZE34CgJkamQKIOFGxLioKXHm8EQfePmQJ1AeRKzR5EX2HNRauQtXaWREe2BrX615GIkUsuWhesBdxI4ZZETKx/bfhASjPNGK9EdyBE711PBNwiRB4aRG1C1nbxj8IOEVrRvxkG3OBrcBL0Z0Qj7rBsQQ4/3C9iFVt8sEMa08kxMxxBPFgW0MaZUZcEoeyQygbBAuZDNi/U8c0I5awzzwn5DN52SAnd2HEO9XmUzMZ1e9CLPaEDGdLJLT11RA/yJLVjRka0QchAv6tQyzy7BhHLQAu0FkVfp43vRMemHdGWclcUd0IBAQAh+QQJBAD/ACwQACIAfwBjAAAI/QD/CRxIsKDBgwgTKhQIZ6HDhxAjSpxIMeGkSRUzatzIMeNFjB1Dihy5sCHJkyhTGoQDB6TKlzA7XoxJs2bNSSZt6txp8GIWnkBTPniAUFLQoyQfMCCKtKnKpU6jilQq8IJVqVg1Lr3w72pXplnDCnR50OqFKma9isXKMqdAokzNVpmrdi1bt/8kDX1wYdfZuXPtCib4YMRQBlYBo72gdOjgx3LPmt07giBGvI+DMtiFOK1ABv/AjmWZ2anSXV2t8lVItjRQx0s3/4PqOjPV0KBrP3asu/QDvb3vJhzRJrhU0sYfI0/OPOHy5mKfQ88qfbpOzNabts0eFg4Q7uD9w4sfT768+fPo06tfz769+/fw48uPSJviz/kK60vcgD9/5YlZrNBffhStwN+ACI2QG0QrCFiTCcyN8B+DOkEYYUQppFBhcyMUAVGGOuHAoYcOpSDCTiI2R+JCJobUB0QpMlfEigmdGBIxnjwUI4IL5bgQDkI81AqPnrzwo0MmjMHjP0xwZOGS/xiZkQlP2vSEfQ4WxAEHKr3Q5EQmDBHUE1WgFtEGWRK0JUVddLGDRjsWFCdPfpn5UIMGcSnRBx+0udGcYcU220JpCqTnQ04kyidFShIkZmYMMDDhSU68kahGYwyZ0BBVovfGGyE1ehCVpc3o0KEFOQHlQEVsQP1jQTYW9EGiqqbUqIWdunYfQS2uSdCiMY0h7D+aNreChiIkq+ebGsGyCCx0LELHtHQM9KKPA2Uq5XTHmijClsy+5Am2UXpJSSsviKrkl8F5+21QTLzgZUFKbjvuuH0QQ8y0YnWrLAfh2lQkk1FaJ6C3XAIccEw+5siubq8K5O5AC6tEzHQztmqQhv/EOlAXwJ50cULkDjZpQRwjBPIHJ/GbUL52SarbyAPRLBVjkarEcsvV2lXmai/xufNEsCDUc1hPJG3nQ2ga5LFCIHfxj9QOOVvR0TolnTRFG+w6ULIRtblDxQXBwkxGLut6ENgTje1rQcycvdEiuh64cUaoXQ4k90J0K1T0qgv97XffgB8kuN+FI3S4jCXutHeEJx90rE6PGyfhnYXCVHlwl99JOXSRJxSgTc40lzNEXSc+0IKoqz6baA9lYTfgt+3nNZRcURSx6w+ZyvtEuycUEAAh+QQJBAD/ACwQACAAfwBlAAAI/QD/CRxIsKDBgwgTKhQIZKHDhxAjSpxIMSEcIA0ratzIsWNFOHA8ihxJkuOkSSVTqhyJUeFJlCtjyoyIMeTMmzg/woGZs6fPhCc1Xsz4s6jPSRdtGl068gFQpEyjinzg9CBKnlKzTqSqtWvJBwx2eR1bkUHVC2LJqo1I9cK/C3DfVl2rNUlIpQfhXqhS5W1culmTYASCV+BcuFX2JnYLWGtDkAQlSaIKFjFfvo0zPxjRJmzYy4svUM7cWG/iKrsumKU6giBUoqSXttX71+lcgScJw47tk6pZtHIZI4S8m3fO0b/B3jZOl+s/58wBQ4/euA1n6l4LE7yOXaru7oD9BdsFT1dwcYjayWcnrJ7uxSTtjaYn2DL+z4sL4dv3WX+/Y8H+dZXEgAEWaOCBCCao4IIMNujggxBGKOGEFA5klkZZVOjQhRRtoOFCDLQ2URYrfAgiRSt4aGJCIzAg0Qol5mQCeCOICFGMMpJno0MppODTjDQWAVGPP+ooJI8i/ISDekculEKSHvUB0ZLkFdFkQlB6RIyUDlG54kNcKoSDEA+N8eU/nrywkJcJmWDmmZ50BOSZAjGxkQlz9vQERSQexAEHMb2g5kQ45OnTE6hJtAGOBP1JURdd7LARmwUZWlRqaT0Eo0GASvTBB5ByRKlaZrnookKMCtTpQ060+v0pRW8OZOlaDIQYkxNvtLrRGLEeZMKoCb7xhki9VjqrWlY6tGpBTtBJUBEbXFlQlgR90GqzK73ZikDHZpZhQU/+42i1H+DEq5nFYreCjyK026mkG8HSBCyLLELHvXQMJGWcBJ1r37pPivAnvDL1QQxBgr5ACa+D/mNmw9EFLPBSaTIB8T9qNuyJJ30YHAkx96oFsLscENxTmhin3F6JAQNassk38Rsnv9FJK5DEA8EcU75MWqkiQT7+Q61AXbyqEs8IhZnZjuAqVHS5JYWckMF02Woc0gJhrZVotcYEddRaj4XaA8Kt9OnXEi2CUNhaPeF2pg8tatDQCRXdxT93jjskb0Vs3+S22x1+S1C7EUG6g84FMcOMRvYyJ/jgdDt0+LiJL86R2rFl8XPTFS07kOULwbIQ5s6OrncTpSsEuuqpJ7Q6eDYbFHRPr2NXo0Pr+lR7dLfjnupMuzPXO+4+OaMe0wr1mZPx4HUN0QaPt35qRJunzmFEmrdu2PTUR09n2RHFrj1EyY5fkfgIBQQAIfkECQQA/wAsEAAeAH8AZwAACP0A/wkcSLCgwYMIEyocmGShw4cQI0qcSDFhw4oYM2rcWBGIR44gQ4rcCAfIyJMoQ5pMWFJPypcwIyZZqXASnJg4cxqcSfPgpJ86g+r0eFOo0aMES07KCOQi0qcRgVKc5LEn1KsoS37EypXig4Q/i3YdG/HBV59Lyap1aHatW4wMHlx4S3dh238XdtXdi9Ds3AuA8Z7lizTJzH9iEQIGXAVvXsJPDVeFk1agpH9n81bZXCUw5Mj/gCT+J2lEG7MMGHNu/NntA0mod6nunDfu4NZkF3euItv2a4I/TVrFnfMBA9mL52JeDlxrU+JBzRqXLZiBwpsenUKPKR1z3At3/be7PhtevNry5tc+MJ0e62iCsNs/JSp/Lc/h9aFK1i7xff6NhmUER0n/qVVVgUH5R1BT+CF40lYW8efggxBaNGFMh12on4QaCmUYhx3qBGKIJJZo4okopqjiiiy26OKLIcWFURYwKiQjRRvUmBADI1CUxQo67kjRCjkGedAI1kW0ApA6mWDeCD0qKZSTT0aUQgpTpjdCERBdmeWTXDqUgghG4dBemAuNCVIkEJmZXhFoJkQmSMT08ZCbRi5k50I4CPHQGEb24QmfDpkAqJEvbERlnv8wkZEJiwb1hI9MFsQBBy+9kOhEkD71BG8SbVApQZdS1EUXO2SEp0GRIiX9m14QLWkQphJ98MGpGq36VlzWJZnQqALR+pATxNpK0aEDtUoXAzy+5MQbxGY0BrIHdXriG2+ARG1B1vIFp0PCFuQEowMVsUGcBc1Z0AfEjpvSoYcqCxmNBalZKkHG4jTGC4Buu90KWIogMK2pZsTMIggjTMfCA9k5KEHTbiofwGOKcGnBMPVBDEGavkAJvxInKjFxFVv8lCeaOsrxPxJ70ofGkfSxMB1uUTwwBxgHhTLLPE/8T8WY4pwzTnsO+jBx6ApU8kBDv0TzmXAWSRCW/6g7UBf5nvQ0QnsSFuVBVCOE9Qdab32QzMt+DZnZ/7DNFXjMvkR22XXxJldMtqHOPdEiCLnd1ROAwwqRqAZZrRDWXfyTuENNwFKR3zgBDjiO9BIkcESn7tB0QcwwgxHCuFVuueEPaX4v555rxPe8UteLUbgDOfOQ4wqtTm7tDjHTxO0Jpb6Q77xzXl/SBoWtE/DiQekQwEIhD53yywMbUxrtQb+8ULJrGdGPQWUvXtyDi867r4MHL9CN27dOrnGUB6/cRMSb/9C38lMUP0IBAQAh+QQJBAD/ACwQAB4AfwBnAAAI/QD/CRxIsKDBgwgTKhyYZKHDhxAjSpxIMWESIBUzatzIsSIQIA07ihxJciMcjCVTquQYUuFJPStjyoyY5OLCSXBm6txp8CJKhJOC8hzK82POjT+JKvWYlCLIlkujQoQjlGlTqVhVTgKy9WrWrxEfJAx6FKzZiQ/EHpx0tq3EtG7jbmTw4ILcuw/h/ruwC69fhWntXhi8V+3fqDVr/vNKcPCFKoJ3MTiMteZHIFQJtvmnlu/jKqDtUq68uKxASSPapK37OfRovG1GrHYMGjLf1a/v0n686wLdtJIITtKTk3HumQ8Y9HYsWqxhgTgvKz7Oc7VywcldLn5KvTrc5HX99Xa/q1f8+Ljmz8t9gFo9WNMFJT13r9QofblUfN53m9j4Qvj7dZSYRif5F2BUlx1IFIAFgUSFgkUZOCCEMoEkIVQUrgRShl9NyKFU030IYhLNiGjiiSimqOKKLLbo4oswxvgVXRllIeNCNFK0wY0KMTACRVmswGOPFK2w45AIjTBZRCsIyZMJ6o3wI5NEQRllRCmkUKV7IxQBUZZbRumlQymIoBQO9I25UJkiRQIRmu4VoWZCZopERx8PwYmkQ3guhIMQD42xZx99JqRnQiYIuucLHFm5p0CeaGSCo0M9AaSTBXHAQUwvMDrRpFI9UUVfEW2AKUGaUtRFFztodP1oQZRG1RupDzVp0KYSffDBqhu9Khddky2Z0KkC4fqQE8jqSpGiA8WKFwM+xuTEG8hqNIanCIGq4htviMSsQdoeJqdDxhbkxKMEFbHBnAXVWdAHyJ67kqKKOjuajQWxmSpByur0whiCfnveClqKYDCurWrETBOLNNwwHXQMhGehAr1AicDqEVymCJomLFMkFHcqcqcDMYotdRtzLNULnpBMkMkSE3onHZHQsYhcGh/MgcdD9REpzPcJufGmO/OsU5+RRtoduwKlPJDRMUWcppxHEqTlP+4O1EW/KUmNEMV/TXnQ1Qht/UHXNycUiZt3RZsb2wN5fdYFyQmb0tldq8sd16h1zaQr3hOlbZDgbj1hOK0PmWpQ1gpt3cU/jzu0cEWEV2q4pRNtgC9BBke06g5QFzQ55ZUftjnnjD8E+r4FpcEMR6XjlUXV+WZU7kDOPBQ7Qa+jK7lDTfTuO0JNPCT88AYdrx7TBpHNk/LjSekQwUTlzqXYCtk6VBr0SV9r9d1HFORQSrgHbamnI2934sgPlKP4tPueXebpPyraRMy3D9G4+leUP0IBAQAh+QQJBAD/ACwQABQAfwBxAAAI/QD/CRxIsKDBgwgTKhworNzChxAjSpxIsWLCQIGEWdzIsaNHi+WafRxJsqTHZg5NqlzJ8qDIljBjypxJ02OgmjhzIsx4U6dPnYFQ/hxaUyjRo0gNJknK1GQSKiB7Np0KhMpSiuUaTt36DwgQis2aSeUq86pCOED0gDVHtmaSpwv1fG3b9inUhJPy0qXrdS7Hu3t9eu0I5G1gwZPUWqzq97DjSX0bO07aBq8eOJO5PniAcFJmzZw/T37AYJdoupsFXjB9WiWhjCE5kjZ9ofa/C6Fbf3wttqCNJL+7Lty1+kKV28R1l7Xr1fPAEf9C165CvYpt5WW7SpYkqc3mB9P9qx/HTrTNCO/giVcvvrky+aG1jcvH3R76QMhfJb83yeAB8drJRScgQYl59ZQNBr2030YPeFfaBbelllB+Vpk1UEjCjLVgRN9FB16HHImF0YayhSYhiUM9IAmKSamYG4sy6TdQdzDGOFiNP1lFhYw4yvQbXIv1uNGPHPUl5E9eAXZkSTwOVOGSJt2Y0FsIQllQUBTpuBBwVl6pVZYWdvkQIa9p+NBbYYq5ECEWcammj95U+eZUIZk5p0lf3skSRmzqyVKffgaqk4KCkhRISoUammGiJL02U38bZdEamTRBWtEGjBrEgH0TZbFCpppWtAKmoBI0AgMTrfApTSYoN/0CpxCtyip2sC6UQgo4tepqERHdmiutvD6Uggg56apcsLYS+1EkEeFAXhHIJqTssn1A5GypCTG7EA5CQDQGo31Uq9C1Co3xLbgeGZvpCxyZoC5NT1Tk6UEccNDSC+xS5O5PT1TBWkQbyEpQvRV10cUOHJFr0Ls6EffvQ6oaZO9EH3xgcEcMb9UfqqgqJLBAE0PkxMgVV3TuQBlzxcCmLTnxxsgcvXDyQfta+cYbI+VLc8pbQftQyAU5ge0/RWwQbUHTEvTByEKzlO+5M2cmaUHD/kOw0h/MhO+3Ube2Aq4ihD0xwhw1wUwTi6C9yCLa/sOsuAO9QInO5H09rAj1/pINUyRt//NCH/gGHrffut2N909/41sQuzqHyzffdGizCFd2i82B3jWF+48nhL/36d32Xo65TOJWC/dnRwtk+ECjt9S3btAWbRCu/yQtUBclr0SHQq/TVStBtCOEe9Ymsc377mSxnBnyA/V+FG4rt0S8SZHT5S94MVU8/URNIDQ5V0+E//BDARtke0K4d/GP+g+ZbdH3OYUf/qVTExS2RAbv0HpBaTCz0dqfqZ/9zvcQ/V2Nf2nwSPcckwVSzW4jQBtIAtu3kAUODSEWTIj7LmgQ/z1kghwkCAixk7oH4mSEunkVxII3ExSeRoUQ+1hMXCgaGEIMJ0ogz+8SMi+aJ+RQOdEDmACH1jGJOJCIL4JIAzlIGvpdEEIVKWEIH+KzKVJEiggJCAAh+QQJBAD/ACwQAA8AfwB2AAAI/QD/CRxIsKDBgwgTKiRIaKHDhxAjSpxIUaGXhhUzatzIsSIhLx1Dihy5kZBJkihTqjRIKBDGlTBjcgwUSKbNmxMDlauJsyfHlxXLlfNJtOJFkBrLNSvKVOLFPRvNNZ360CRQqlhJtuSZtWtImly9itWocyhRpGNJCiVqEm3aqUkytvz4FmuSJRVpnqw7lQqVuBN30uSLlQqQic3WEoZpwyEQIHommjO7eKWNJFQW6jlcWSzmzAkn6ZnUeaxfzhpBl8b5eONfvKtvQiZdEcjf2JU36/GLO+uDhKNR96ba5vdB2sOxPjCenO8DBruab0Ry8d/VjMsF7oouXeNRq2X9NS6PfqH8v13Mu0cEaRIsZYE2LsdVjfDCLvtV/pXnrh7l5SWGQUaQJP8Yd18VCFZxX38rzSfcP5JI8kBxD5SXIIIMFtWGhONZiOB+y6WX4U37VXGBgheEuCFBomVG34ghdbjfBQL91kZBm9l2V2MFvQcjRCE+sGCK/B10mF9J8EiQUGDtcd2PBU3423ghbsSkVR89CWWUxk34lXX/uLUlQg8QOCZTG4p4JkoPDnjjmimdBqdPdxk2502XXfZiRG3euVB8Gj22p58JKZmRX4MSWttCfxmq6KF9EpQkYI/qNNFrfzrqJ1gU3fZoVVtNlOenC120l6iUknrQdxnZ0P2MpqoK5AV1Pik2JhJMcRprSrruipJVvqaUZbAG+TgRIbcQSxBNxq5HCK7K/jMYR2L62p5MDKgJURbDnRpTthVt0K2WKDEwAkVZrNDbR9WuxABFK4jbW3U3jfBuRCuoe9MYI83arkojnItvTyaQBC1OAj+UQgoESzdCERAt3HBzDyssgk8FSwexQylc3FEkEOHQXREbK+TxxyA7JHK0DqWsEA5CPPRCtH30sdDKCo3BL80cZczyPzZnZMLOPT2Brr4FccDBSi/MPJEJPvv0hIISbYA0QUpT1EUXO2iEs0FRF3VfkQvla9DSEn3wwdYbhZ1Wtu/em9DVAqH9kBN4/qtNkdMDuf0WA+au5MQbeGv0AtEHQU3oG2+ExDfYfqdFskN2F+TEzwMVsUHJBp1M0Ad4X66S0zsjvhq3BXX8T9aff2BT0/yaPtwKDItgO9pda5RGE7wv0sQii2gzEMhBD/QCJY9LR3vHIiidO0yRuPzPC300bb3x0yfHfPNMVV99QTPz3Uck40e/SCSLpLX87Rw8j1PNQGevnrrML92++zKlbHPxsXE+0PYDwd9KpJcckmnOIAz7h+cE0gW9pYQOCiEgXxKGQIU00HUkCV4EJdiVwK0GggTh4FRSBLiVYDCDwquLgioUE7WdUCJNQEj60vKEGpJtIVbrHEQa2IV/nPTQIU1gRkVmKLUaGm0iG0AdQWwXka3tQIAFSUMaMuK72ChxiQt8yBNZF8UpbiSGncmCvCpYkcoN5AgPAWNC1Ii5NQLRi208CBwVMsc4EqSOBeSYT/DYm4A5hHY94WNs/PhHusVECd0h5B97gkaHRSRdOEFkc0oIkSTacSByq+Ql/wEuiYjxks+hiCXjSCOK+G+TEJkcKidySoUEBAAh+QQJBAD/ACwQAAgAfwB9AAAI/QD/CRxIsKDBgwgTKixIZKHDhxAjSpxIMSERLQ0ratzIsWPFix5DihzJUYuWWyRTqlxp8BZKljBjhry15qXMmzgh1szJsydCL158Cn2YMSTQoEOTHiRS1ChSpVAFMtUico/VqFj/XaTqcQ8hUlmxnrS5kVSgsFldrukYKNhZtFBpkq1YLhhcrEc51iXZ9G5EL3ueVjQ3EqPfioDBRsXI9DBFr4qHujTpuGIgs0lruqyssW05oUB3cta4t+dRwaNx2tBIyirq1DeXrKZ4mdAe2D2pyKZYzmxk3DmpUJlY9zPwkbMVUtEzXKI548dF2rDRPCEQPdGh2liyRKGe79n9oQqvrrF7eJhUgHCkMv08y+XYK+o27x6tHiDj6wttk/A7ef08tfEAQvEB6NMD/BmoUGNcyfTAA7soiJAPUxFxy0lerBXUWxw9KNAFEUqIUEMXqXULUF7tQUow0FH0YIS7gPjPBQOKmBBKQQEWyI52ETSdDUn8859BMcZYxYy7hGhjR9NxJ1yB/0jyT4JGVmFljEtKJ+R/kkgiYBtFXmCllVne1IaXL4o5Joi7PJhgmTAVWYWYMbrZxpv/MDfckHBOlGaMMv4zIJ554sddewX12KdCAr4II4TKCSlbcgPVdZlr/7xW5peCvoigXm6lGJpmlPW1pIeCEtrZP7cBNf3ZLUyZauOdOFFFYp9nqrqoSHwK5OWuKS0hHLA5UScssTL9uJ1GvSJ7EKLyDeusQ5RGS9+0GzUr0KTYrqftPz92Gwg8E8n2LbTO7rEjRbt1uxBkHEIUrrs/AXYbRejSS1CGQGlkQzPp6EuQWprGVNqSY63l046/AVhigwu3JmGFUKVoYKyy+gRYwcdRSJKiiPUrMEFtxTtRaCMTRAohHWmWskBf3bvRZAkxUCNFWWR3lUcYzUWQzRVtkJ3IPDd2EAMj4LxCdHmFFGvNFK0gNNMKO21HQiMwINEKS+M0xkg1cfwR1klH1DVOJoy0GU9lP5RCCjylLdKFPsM0QhEQ/r0dd2F12423QymI0JPcIRnW098LBR5SJBDhINLThyOekOCLM+6Q449nLKHlCuEgxENfL8TU1YtG0sdCmCs0xgsPebzr6RwR/rJAsFdkQug8PaH0QRxwwNILtUdkguy5V6HkQxucTVDvFHXRxQ4bpW4Q8T4VabbyAvku0QcfOB87ZzZrrbVC2P+j/UNOpM89RawTRL1fDCDNkhNvpL/RC+0jNDyyb7wRUv7Te99diiA5hJyvIE6YXUGKsIECEoRyBflA+hK4kvaFDnfAyVlBFMc8gqxPJvhjHQDDswK4ieCE2oPeRtLQBBY2YRFN0MYiBsI4zgnkBZQY4XlKGDgR/fROhTCJhA37ALwQ5o91wQNOD304lD4QMYkiHMg2+iDESGhDhtq4Cw9RyAEg5mSK/zhdEkn4jx76rotelInlxJgdB5bxhBBMI0tsGB4CMtAgcPsHBAfShQ+mZIYJoaNj2oZHhfTxA3/MYiAFmRX54UaRA4FkVmgUP5YgMpGOMd4DLhAT7l1yIk1ACCDh8oRSHs8hyTPIHg3ZvX904SFpSENFRpm7UupuIhvQ4ANXacjnybEgsdRIE0KJG13ukiI72EEHC3IEWXKEmKPJwtQKWZEDDuQID4EmQrSpQIU405vf7CZCwpkQcooTmABy4wZ7Ys7ojICQCCkhT7Dpnnc/PoRrPFFCfex5z3nuMyJZKB9LWuCeSkIkl+csyPgiMs2EAk0i0kyoQB6wUIYas5ucpIg6JfoQAnJUIxs9SEAAACH5BAkEAP8ALBAABgB/AH8AAAj9AP8JHEiwoMGDCBMqLGjHzsKHECNKnEixYsKGFjNq3Mgx4yciHUOKHLmRCBF2JFOqXHlwE0iWMGN23KRlk8ybOCdq0ZKzp0+Et9bw/EnU55pbRZMe9OGQ5Jo1SqMObNg0pJc1e6RKtUPkE0kvXrRK/Wgz5J6zYqUSoWkWbdqoO4duJEXqrVYtQTkGIhXMLtynHIP1TenD78SnYTUKJvkJo2GJXuYlzmhuZFciVR9D9OI2qstNmTU/PJtVadyyoifSDZT06BrUqScGgjfY6FOksS0GK/cTLODcPW1kJD0ZOM4lwivS7Wz85pLnFYPtrdu85xIqFHfDqz4yuUIq4P0pmqvNvaMNG0sWUtFTXunz9An1yG/v/jpH+PRXhteIHH9+kuuxZxEV0P33lh7gFWhgT23Eh+CCRLXR4EECQujTAxNaaBBTDr100wMP7KJhQT5wuBYRcQEWVmkbYSjQLiKOaJBDZO2EGFZnkQIPbxmFKOIFu1zwzy4PyJgQT1Bxthp5/9iQznn/YKdQiFXsUsU/QBZpJEfnvbceQZL8MyGQF1Rh5gVCbmneP/aBKYmEbcBYpplVPKGmTG28CWKQc1YBJJES3hlTkFaWGSSGGIY5EILY+SdoRXuSGaRARWYoEKPPQVkQk48a1AaGMBYZ6ndsIufdQNKREghaxT0q/WGRe4JoaXTBkHIWZ08JtdNJ/4Qm46cCAdtRXXtcddROm7jUmK8aBnoTTyA1VNiWec7aqUhSHvTmtSQ9ly23MaGnILgrnddlRhWSu9CTGiWo7kOnWvTeuxx9e5Cp9LbrqEHnpUMvXxT1t5Cm6u6xV0XI5btQjtRJZK7CCK3BGYsTOQnxQRJLnFE6zfh78UBa5OrTYlumSNR0I661U1LLachVslGRtiBTH3klFa4GlsisYhtd1Wp1cpRI0l6sZSRyftOORBdHun48kMwbxZUQA1pWlEV5zGlUk4cGMZDRBuVxJtImNh9EtdUrcOezSCaVXRADI1S0Atjc/RYSVQj+jeC1RCukjdMYI9ktkh1CGzRC3Hz3ZMJINpJU+EGIQ5RCCoozLhdOIxQR0eSVj11TT5lLLoJPi4/NNU6aP5TC6B1pExEOlrmNeuoKsd5RJJFABPvdXT2a+0I4CAHRCxA5Jug2fQD/0BjEL/T4o8lvBDhEJSYNvUYmTP+QD3KEZCdFWfhdEAccsNRH8xOZUPpPT1Q50QbiE0R+RV10sQP2Ca1fFKF8xy9Q+RP5wAfqtxH9GYZqXttbQvz3DwBCxAkQFGBF0CcQAz6GAXBjiRPeAEGNvICCBlEfuN7whpCAkCAijE0RaJcQBxbECU47SBE2wMKC2I4gH4AgDFfSvOb9aa85VyvI6hrown9IUCYfJN4JubMCyongiQC8n0bSkIYmWLEJi9DGIgaSu20U5AWUWGJ5mrg6EZBPijDBHUH6cL7zfXAgSmxPGc1YFDae74v/iN4/toE73GlDi66zCxmhyAE05gR5eUykgdJWxvIV0pAy+Z0X9dicGgpkjgOBJEsCmZ8VztAglPvHDQXShSOmhJMH+V1sIgdKhZTyAynJokIigcq3ZNA4taylVC7wAAyyBJan3OJjqvSANP3SlBNpAkKEaZcnODNGEYGfQUaZkFJ24R/XfAgVLaJM9jnze+8LIkGeKJH67UCTBdkmN7sJHHGOk5oPOef8DHKEI3NwhJ2pyQLdWmmRIgrEng/B50HSEMOJEHQh6iwoQiFyUIUqpKGdVJ1PAJqfwz2kiT2haHsselEGwkSj5eHoRTP6H1YuJHw5aUF+fBlNdzp0IAqM5kvfVrWI6HOmA+llRTbgUoUacyKWxClQgyrUiBAVIQEBACH5BAkEAP8ALBAABgB/AH8AAAj9AP8JHEiwoMGDCBMqLGjHzsKHECNKnEixYsKGFjNq3Mgx4yeHHUOKHKnxk0mSKFOqPLhp08qXMEO2dBmzpk2Jm7Tc3MkToZafPYP2XLNGqNGDPkCOJHq06cCGSjuu8VLUadOGn0iu2WPVqUmaHfeI7eqUSMuQYrmSbdqy6kZSgdZa/ek2Iyl4ceUe1cJ0Y7BgKX3onUi0bsW/JO18HEx4jxe/I9l9jMr4oZd5atl+IpK1ssS0Tfme9UyRlGmja36CJT2RFOKhRHWytvh659a+s2/ayJjWcO6YS3ZXND32980lyA+bJmWcZ/KJfwE3FylcIZUlVCjWnt7Rho0lC/2p6OF+FDn4hHrSky+PneP59Sqvbwz+Hj5J8eMtmrcvV88S//XxZ1Mb6OmRnYA9tUHgQfkhyNMDCzpokBxJ/dNZTQ88sIuEBVGIlVk5bcLUY5lp1MYDAu2yIYcGOfRVToVthdld5WikIYq7XLDhLiiy6NM/RXmxx3LSDZSODUf+E6BBD1zwxAVV/KNjjz5u5J154hEkyT8L6ghlFWCuWCVHuz03kCSSKNiGil+GOWZMbaSZIZtghsmjgm/ClKOTF/TJI4R4DpQeeEvmOdGce6ooEIoRCmSgeUgaVKShCJ24Jo//qEjlQdkh552kgRA3D5CUDqQginNm2OhhePVW/ViI7BDxD2UsniiQrR0xt0dhom3C2UdyvBloTC5l1ZBgVca5aqkhHXhQmsyOtF+0MX1nJrUpHXllRg1iq1CkGV1XqLcEpePeteRWNO5AwVWXLkXoGuSdud7eBW+8BYGL7ZDMUfTduwqJddpE3rkL8EBTFecvvQcTFGNG6ZhjMMB84WbTdhzCKBtPy3H4yUxGESehSWY1BRp/SSl24VGXPWafDxWONGlFhcFHYbAjdZxRzTajNLBGqfn27skaqZYQA5tOlAV3Cm/UkqwIMZDRBtxdJhIR7BydNERZrDAdzx2ZRKtADIxQ0QpUfy10RlAhNILUEq3gtU1jLLWxSHb++IBzQSOYHfdOJozE190d6Z2Q3xClkALgI+XE0whFRKQ44yKBfBPkiYvAU+BXZ81T5A+loHlH2kTEeUgnfQ66QqN3FEkkEOGAd+pvwr4QDkJA9AJEGBm6je0Jyb7QGLsvBDOzfXBUN0R6I0tp8hmZsPxDcuy90RMVdX0QBxys1EfxE5lwOk9PVCEmRBvMXRD3FXXRxQ4ajV+Q/D3leP5CchvU/UQffOD+RvSTC9KkBreEqG8g+4OIExbYv4qATyAB1AsDyrYSJ7xhgRp5wQMNIr5oveENIdkgQTrImiKsLiEJLIgTGoaQImzghAVpHUE+sMAVqqR4xZuecZZWENH9/YN9M/xATTS4OxFOZwWLE4ES9wc/jaQhDchoghSboI3SCQR22yjIC7phRO4gUXQi4F4TX/I6gvThjC/4HviS10XWgDGMQjnjGbX4D+j943evq2IVm6CXLy6RA2O8ye/qSEj+eA2M3QNkIGNiuyxmcTowFMgbB7LIlVgRPiZ0oUEW9w8ZCqQLDUzJJQ8CPNIgbpMKAaUQSbKIURokEq4kCwV/48pYNuUCD5jgSlZJEm0sojLmaxJM+sfLiaQBIb/UyxOWeb+FpM8gnkwIKLvwD2o+5IkW4WNPlrnMimyAhwRRokTct4NKFiQNR8iIFHd4EHFSpJxALMgR0rkRbW+yJgtpQ6VFUjgQei4EGQs5JguNeU2BDvSaEPHnQRViUEyGjicKJU/fHoLEnUR0OhOl6AFjctHmZJSiO2mBfU65EO3ZRKTr0WVEvrnQqFEkny0dCNIogs+YEiSX3gRnTC9gkUjalCIm/OlGfJqQgAAAIfkECQQA/wAsEAAGAH8AfwAACP0A/wkcSLCgwYMIEyosaMfOwocQI0qcSLFiwoYWM2rcyDHjJ4cdQ4ocqfGTSZIoU6o8uGnTypcwQ7Z0GbOmTYlaaN7cydNgzjU9g/ZcA1SoUYM+QI4kerTpwIZKO67xUtTp0YafSK7ZY9WpSZ0c94jt6pRIy5BiuZJt2rKqRlKk1lrVosWtRVLwAsltWtduxWDBUvrYO5Go34mASX6MSvjhVi8bA4v8RORj44le5qllS4Qd48sL0/Jdww4s6Ihw9QpdQ9f0adTwygU1rOV1xsQ8tzK1vdNGxrSHeb9c4rsi3LHCby5Z/hdu3OQ7mSPGDT1kcYVUllChSL16Rxs2/ZYspKLH+9Hl4hPqWW/+vHaO6durfK+ReHz5JMmXt4gev1w9SwB4n382taGeHtsR2FMbBh60n4I8PdAghAbJkdQ/Wdn0wAO7UFiQhVh1llNf/0C2mUZtPCDQLh16aJBDX23SF1Ga7YGXZBZxqOIuF3S4i4ouIlQbUF7YCBeOAqVjg5L/DGjQAxc8cUEV//QIZJAbgYceeQRJ8k+DLE5ZhZQtYsmRb9INJIkkDLYRZhVwwmlmTG2wuSGPYlbBI4sMzglTmFP2eIGEbRK0nnhO+jnRnYLyKJCKEwqEIHpLGoSkogel6CaL/7B45UHbLQeepYEcx1VwWDKo4p0bRvr9V15izUMVUTOxQ8Q/n3nY55euZhTXHrSt0VJlH8kx564xuZRVQ4OlyiamKiV40LPQjtRftTWFlya2KimpZUYPcrtQpRlll6i4BaUD37bo8rcQcde1WxG7BoGnLrqkXPrQtQmRK66RFYUnb2gATwRevAMTNJVmFvmbsMKGZZSOOQgnPCNP3XkoI2tBOefhJzMZdRyFdlDmGk+i+eeDHCZl2FRmkOHnw4Uj6VvYbuZZaOxIHmcUsXw78/ycRqyhim7KGuV0skAMfDpRFt4hx9GwCTGQ0QbeZSZSZ1U7DVEWK1T3c0cm5foPAyNUtALWYhtNEVQIjWC1RCuEbdMYS/7VRpIdKx80Qtp074S3SHUtnVHfcUuUQgo7mTCSjDyNUEREizf++Fk3SQ5RCiLw5PjW7PQ0+UOch6RNRJ+HdBJPRYyuUOembwMRDiKV7LKZkTyEgxAQvQARRopu08dCtC80hu8LzVyt7BsN/tDKzWI6fEYmOL+QHEFv9ERFYB/EAQcr9TH9RCakztMTek60gd0FfV9RF13soJH5BdHf0550sz8Q+BN98AH8G7GfXJpmtbklRH8C4R9EnMBA/1UEeQMR4F4YgLaVOOENDNTICyB4kPJh6w1vCAkH62e9y7TuIQosiBMelpAibMB1BoFdQT7AwBWqBHnIKyFvoFaQ0v25jyAOjMkGfTdC76yAcSJIIv/kp5E0IMOJTYiiNpowkNwxbyAvOEY9FHREzonge0x8SSTeQRDxie8FfYCg78YHHS9+UShmZOM/hje+bURiG9qIhDb2SEW5dFGJHAjjTez4D9nJ0Txh8yL4AinImOSukJCsDgwH4saBNHIlp8NP61xoEMb9Q4YD6UIQUZJJhDzyNYA7iCcRIsoPoKQJpTzIHhtTQeHE8h+3dMqgKLgSV5Kyj4TRE5Rg4j9fUgQZCAHmWp7AzDJBZH0xjIgou/APaj7EiRZR5k2YycyKbICHBEmiROC3g0sW5AhHyEgUkwPOcIIyIuX84TnTuZE0duyQbZ3MSAoH0gKIIFMh/2ThROy5kDTQU6AQIehCDorQhRJokqrkCUPN87eHHHEnE61ORS2KQJj0Uz4btehOPtqeVD6kezYhqXd4GZFvNrRqFMHnSwnSNIpkQaYz/ccDDCgRl+ZUIBewCER/SpETElUjQ01IQAAAIf8LWE1QIERhdGFYTVA8P3hwYWNrZXQgYmVnaW49Iu+7vyIgaWQ9Ilc1TTBNcENlaGlIenJlU3pOVGN6a2M5ZCI/Pgo8eDp4bXBtZXRhIHhtbG5zOng9ImFkb2JlOm5zOm1ldGEvIiB4OnhtcHRrPSJBZG9iZSBYTVAgQ29yZSA3LjEtYzAwMCA3OS5iMGY4YmU5LCAyMDIxLzEyLzA4LTE5OjExOjIyICAgICAgICAiPgogPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4KICA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIgogICAgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iCiAgICB4bWxuczpzdEV2dD0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL3NUeXBlL1Jlc291cmNlRXZlbnQjIgogICAgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiCiAgICB4bWxuczpkYz0iaHR0cDovL3B1cmwub3JnL2RjL2VsZW1lbnRzLzEuMS8iCiAgICB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iCiAgICB4bWxuczp4bXBETT0iaHR0cDovL25zLmFkb2JlLmNvbS94bXAvMS4wL0R5bmFtaWNNZWRpYS8iCiAgICB4bWxuczpzdERpbT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL3NUeXBlL0RpbWVuc2lvbnMjIgogICB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjRhMWM3NDIxLWVlMTQtNDc4Yi04OWQ4LTJhMTM4YzE0NDQ3OCIKICAgeG1wTU06RG9jdW1lbnRJRD0iMTM4ZWY5ZTItY2U0ZS00ODE5LTRmOTktMWJiYTAwMDAwMDQzIgogICB4bXBNTTpPcmlnaW5hbERvY3VtZW50SUQ9InhtcC5kaWQ6NGFkMWZlNDMtODM4NS00OTAyLWJkYTctYTU3MjViNzYyODlkIgogICB4bXA6TWV0YWRhdGFEYXRlPSIyMDIyLTEyLTA2VDE0OjM2OjA3LTA1OjAwIgogICB4bXA6TW9kaWZ5RGF0ZT0iMjAyMi0xMi0wNlQxNDozNjowNy0wNTowMCIKICAgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgMjIuNSAoMjAyMTA4MjUub3JpZy4zNzEgZjllNWUyZCkgIChNYWNpbnRvc2gpIgogICB4bXA6Q3JlYXRlRGF0ZT0iMjAyMi0xMi0wNlQxNDozNTozNC0wNTowMCIKICAgZGM6Zm9ybWF0PSJBbmltYXRlZCBHSUYiCiAgIHhtcERNOnZpZGVvRnJhbWVSYXRlPSIyNS4wMDAwMDAiCiAgIHhtcERNOnZpZGVvRmllbGRPcmRlcj0iUHJvZ3Jlc3NpdmUiCiAgIHhtcERNOnZpZGVvUGl4ZWxBc3BlY3RSYXRpbz0iMS8xIgogICB4bXBETTpzdGFydFRpbWVTY2FsZT0iMjUiCiAgIHhtcERNOnN0YXJ0VGltZVNhbXBsZVNpemU9IjEiPgogICA8eG1wTU06SGlzdG9yeT4KICAgIDxyZGY6U2VxPgogICAgIDxyZGY6bGkKICAgICAgc3RFdnQ6YWN0aW9uPSJzYXZlZCIKICAgICAgc3RFdnQ6aW5zdGFuY2VJRD0iMGYzYTEyZWQtNTRlOS1mYTUxLWY3YzYtNzIwZDAwMDAwMDcwIgogICAgICBzdEV2dDp3aGVuPSIyMDIyLTEyLTA2VDE0OjM2OjA3LTA1OjAwIgogICAgICBzdEV2dDpzb2Z0d2FyZUFnZW50PSJBZG9iZSBQaG90b3Nob3AgMjMuMiAoMjAyMjAxMjgub3JpZy41MjcgMjhkNWUxYSkgIChNYWNpbnRvc2gpIgogICAgICBzdEV2dDpjaGFuZ2VkPSIvIi8+CiAgICAgPHJkZjpsaQogICAgICBzdEV2dDphY3Rpb249ImNyZWF0ZWQiCiAgICAgIHN0RXZ0Omluc3RhbmNlSUQ9InhtcC5paWQ6ZmI2YTE2MjctZTY3Yy00ODk3LWJkNmQtZjE3NzViMzc3ZGEyIgogICAgICBzdEV2dDp3aGVuPSIyMDIyLTExLTI4VDE1OjE4OjUzLTA1OjAwIgogICAgICBzdEV2dDpzb2Z0d2FyZUFnZW50PSJBZG9iZSBQaG90b3Nob3AgMjIuNSAoMjAyMTA4MjUub3JpZy4zNzEgZjllNWUyZCkgIChNYWNpbnRvc2gpIi8+CiAgICAgPHJkZjpsaQogICAgICBzdEV2dDphY3Rpb249InNhdmVkIgogICAgICBzdEV2dDppbnN0YW5jZUlEPSJ4bXAuaWlkOjgxOTNkNGZmLTFiMjctNDhhMi05OTBjLWFkZjZiZDBmYTc4NSIKICAgICAgc3RFdnQ6d2hlbj0iMjAyMi0xMS0yOVQxMjowODoxMy0wNTowMCIKICAgICAgc3RFdnQ6c29mdHdhcmVBZ2VudD0iQWRvYmUgUGhvdG9zaG9wIDIyLjUgKDIwMjEwODI1Lm9yaWcuMzcxIGY5ZTVlMmQpICAoTWFjaW50b3NoKSIKICAgICAgc3RFdnQ6Y2hhbmdlZD0iL2NvbnRlbnQiLz4KICAgICA8cmRmOmxpCiAgICAgIHN0RXZ0OmFjdGlvbj0ic2F2ZWQiCiAgICAgIHN0RXZ0Omluc3RhbmNlSUQ9InhtcC5paWQ6NDQxNDMwYmUtNWMzYS00NTJkLTlkZTEtYzFiZWE0M2EwNzFhIgogICAgICBzdEV2dDp3aGVuPSIyMDIyLTEyLTA2VDE0OjM2OjAyLTA1OjAwIgogICAgICBzdEV2dDpzb2Z0d2FyZUFnZW50PSJBZG9iZSBQaG90b3Nob3AgMjMuMiAoMjAyMjAxMjgub3JpZy41MjcgMjhkNWUxYSkgIChNYWNpbnRvc2gpIgogICAgICBzdEV2dDpjaGFuZ2VkPSIvY29udGVudCIvPgogICAgIDxyZGY6bGkKICAgICAgc3RFdnQ6YWN0aW9uPSJkZXJpdmVkIgogICAgICBzdEV2dDpwYXJhbWV0ZXJzPSJzYXZlZCB0byBuZXcgbG9jYXRpb24iLz4KICAgICA8cmRmOmxpCiAgICAgIHN0RXZ0OmFjdGlvbj0ic2F2ZWQiCiAgICAgIHN0RXZ0Omluc3RhbmNlSUQ9InhtcC5paWQ6OTZmM2QyZGQtYzZhMC00NjJlLWEyYzEtMGNkMDNmNTNhYzI1IgogICAgICBzdEV2dDp3aGVuPSIyMDIyLTEyLTA2VDE0OjM2OjAyLTA1OjAwIgogICAgICBzdEV2dDpzb2Z0d2FyZUFnZW50PSJBZG9iZSBQaG90b3Nob3AgMjMuMiAoMjAyMjAxMjgub3JpZy41MjcgMjhkNWUxYSkgIChNYWNpbnRvc2gpIgogICAgICBzdEV2dDpjaGFuZ2VkPSIvIi8+CiAgICAgPHJkZjpsaQogICAgICBzdEV2dDphY3Rpb249InNhdmVkIgogICAgICBzdEV2dDppbnN0YW5jZUlEPSJ4bXAuaWlkOjE5OWNiMzllLTUyYmUtNDgwOC04YTQyLTkzZTEyOWJiMjk4NyIKICAgICAgc3RFdnQ6d2hlbj0iMjAyMi0xMi0wNlQxNDozNjowNy0wNTowMCIKICAgICAgc3RFdnQ6c29mdHdhcmVBZ2VudD0iQWRvYmUgUGhvdG9zaG9wIDIzLjIgKDIwMjIwMTI4Lm9yaWcuNTI3IDI4ZDVlMWEpICAoTWFjaW50b3NoKSIKICAgICAgc3RFdnQ6Y2hhbmdlZD0iLyIvPgogICAgIDxyZGY6bGkKICAgICAgc3RFdnQ6YWN0aW9uPSJzYXZlZCIKICAgICAgc3RFdnQ6aW5zdGFuY2VJRD0ieG1wLmlpZDo0YTFjNzQyMS1lZTE0LTQ3OGItODlkOC0yYTEzOGMxNDQ0NzgiCiAgICAgIHN0RXZ0OndoZW49IjIwMjItMTItMDZUMTQ6MzY6MDctMDU6MDAiCiAgICAgIHN0RXZ0OnNvZnR3YXJlQWdlbnQ9IkFkb2JlIFBob3Rvc2hvcCAyMy4yICgyMDIyMDEyOC5vcmlnLjUyNyAyOGQ1ZTFhKSAgKE1hY2ludG9zaCkiCiAgICAgIHN0RXZ0OmNoYW5nZWQ9Ii9tZXRhZGF0YSIvPgogICAgPC9yZGY6U2VxPgogICA8L3htcE1NOkhpc3Rvcnk+CiAgIDx4bXBNTTpEZXJpdmVkRnJvbQogICAgc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDowZmUzNzcxOS01NGE4LTQ3OTktYjkwZS1kMmQ1NDJiM2I4YzAiCiAgICBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjBmZTM3NzE5LTU0YTgtNDc5OS1iOTBlLWQyZDU0MmIzYjhjMCIKICAgIHN0UmVmOm9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDpmYjZhMTYyNy1lNjdjLTQ4OTctYmQ2ZC1mMTc3NWIzNzdkYTIiLz4KICAgPHhtcE1NOkluZ3JlZGllbnRzPgogICAgPHJkZjpCYWc+CiAgICAgPHJkZjpsaQogICAgICBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjJjNjJlMzcxLTg4ODAtNDEzMC1iZDc1LTJjNGUyZTc2ZTBiMiIKICAgICAgc3RSZWY6ZnJvbVBhcnQ9InRpbWU6MGQ3MjA3MjAwZjI0MDAwMCIKICAgICAgc3RSZWY6dG9QYXJ0PSJ0aW1lOjBkNzIwNzIwMGYyNDAwMDAiCiAgICAgIHN0UmVmOm1hc2tNYXJrZXJzPSJOb25lIi8+CiAgICA8L3JkZjpCYWc+CiAgIDwveG1wTU06SW5ncmVkaWVudHM+CiAgIDx4bXBNTTpQYW50cnk+CiAgICA8cmRmOkJhZz4KICAgICA8cmRmOmxpPgogICAgICA8cmRmOkRlc2NyaXB0aW9uCiAgICAgICBkYzpmb3JtYXQ9ImFwcGxpY2F0aW9uL3ZuZC5hZG9iZS5hZnRlcmVmZmVjdHMubGF5ZXIiCiAgICAgICB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjAwZDU5OTQxLTc5M2QtNDFiNC1iZWRkLTJjNmFlMzc5MjVmNSI+CiAgICAgIDxkYzp0aXRsZT4KICAgICAgIDxyZGY6QWx0PgogICAgICAgIDxyZGY6bGkgeG1sOmxhbmc9IngtZGVmYXVsdCI+UmlnaHQgMiBPdXRsaW5lczwvcmRmOmxpPgogICAgICAgPC9yZGY6QWx0PgogICAgICA8L2RjOnRpdGxlPgogICAgICA8L3JkZjpEZXNjcmlwdGlvbj4KICAgICA8L3JkZjpsaT4KICAgICA8cmRmOmxpPgogICAgICA8cmRmOkRlc2NyaXB0aW9uCiAgICAgICBkYzpmb3JtYXQ9ImFwcGxpY2F0aW9uL3ZuZC5hZG9iZS5hZnRlcmVmZmVjdHMuY29tcCIKICAgICAgIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6MDg1MDkzYTEtYWYyNy00YmM4LTllZDctYmVmZDg2OTg4MWRiIj4KICAgICAgPGRjOnRpdGxlPgogICAgICAgPHJkZjpBbHQ+CiAgICAgICAgPHJkZjpsaSB4bWw6bGFuZz0ieC1kZWZhdWx0Ij5QcmUtY29tcCAxPC9yZGY6bGk+CiAgICAgICA8L3JkZjpBbHQ+CiAgICAgIDwvZGM6dGl0bGU+CiAgICAgIDx4bXBNTTpJbmdyZWRpZW50cz4KICAgICAgIDxyZGY6QmFnPgogICAgICAgIDxyZGY6bGkKICAgICAgICAgc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDowMGQ1OTk0MS03OTNkLTQxYjQtYmVkZC0yYzZhZTM3OTI1ZjUiCiAgICAgICAgIHN0UmVmOmZyb21QYXJ0PSJ0aW1lOjBkMjg4Mjg4ZjI0MDAwMCIKICAgICAgICAgc3RSZWY6dG9QYXJ0PSJ0aW1lOjI3MjI3MmYyNDAwMDBkMjg4Mjg4ZjI0MDAwMCIKICAgICAgICAgc3RSZWY6bWFza01hcmtlcnM9Ik5vbmUiLz4KICAgICAgICA8cmRmOmxpCiAgICAgICAgIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6MDg1MjM3MWQtMzY2Ny00MDkzLThmZjUtNTkyYmU1MjhhZDhkIgogICAgICAgICBzdFJlZjpmcm9tUGFydD0idGltZToxMTIxMTJmMjQwMDAwZDQ0ODQ0OGYyNDAwMDAiCiAgICAgICAgIHN0UmVmOnRvUGFydD0idGltZToxMTIxMTJmMjQwMDAwZDQ0ODQ0OGYyNDAwMDAiCiAgICAgICAgIHN0UmVmOm1hc2tNYXJrZXJzPSJOb25lIi8+CiAgICAgICAgPHJkZjpsaQogICAgICAgICBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjBiOTlhOTU4LTc5MDQtNDQyMS04OTIzLTg2NTY1ZTI1NTM1MyIKICAgICAgICAgc3RSZWY6ZnJvbVBhcnQ9InRpbWU6MGQyODgyODhmMjQwMDAwIgogICAgICAgICBzdFJlZjp0b1BhcnQ9InRpbWU6MjcyMjcyZjI0MDAwMGQyODgyODhmMjQwMDAwIgogICAgICAgICBzdFJlZjptYXNrTWFya2Vycz0iTm9uZSIvPgogICAgICAgIDxyZGY6bGkKICAgICAgICAgc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDowZjI0MDViMC02OTJmLTQ5ZWEtODMzNy02NjMxMDI5Y2Q5NDUiCiAgICAgICAgIHN0UmVmOmZyb21QYXJ0PSJ0aW1lOjBkMjg4Mjg4ZjI0MDAwMCIKICAgICAgICAgc3RSZWY6dG9QYXJ0PSJ0aW1lOjI3MjI3MmYyNDAwMDBkMjg4Mjg4ZjI0MDAwMCIKICAgICAgICAgc3RSZWY6bWFza01hcmtlcnM9Ik5vbmUiLz4KICAgICAgICA8cmRmOmxpCiAgICAgICAgIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6MGY4NTk5NWUtNDJmNi00MWRhLTk3ODUtNjExMjE4OTBmNDlhIgogICAgICAgICBzdFJlZjpmcm9tUGFydD0idGltZToxMTIxMTJmMjQwMDAwZDQ0ODQ0OGYyNDAwMDAiCiAgICAgICAgIHN0UmVmOnRvUGFydD0idGltZToxMTIxMTJmMjQwMDAwZDQ0ODQ0OGYyNDAwMDAiCiAgICAgICAgIHN0UmVmOm1hc2tNYXJrZXJzPSJOb25lIi8+CiAgICAgICAgPHJkZjpsaQogICAgICAgICBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjE0ZDBkZjdiLWY2M2EtNDg2ZC1hOWVkLTAwNTE1NzZjYjBkZiIKICAgICAgICAgc3RSZWY6ZnJvbVBhcnQ9InRpbWU6MGQzNjgzNjhmMjQwMDAwIgogICAgICAgICBzdFJlZjp0b1BhcnQ9InRpbWU6MTkyMTkyZjI0MDAwMGQzNjgzNjhmMjQwMDAwIgogICAgICAgICBzdFJlZjptYXNrTWFya2Vycz0iTm9uZSIvPgogICAgICAgIDxyZGY6bGkKICAgICAgICAgc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDozOGM3MDI2Yi1jMzZlLTQ4MjgtODkwYi1iZjJlM2NlYWM3YmYiCiAgICAgICAgIHN0UmVmOmZyb21QYXJ0PSJ0aW1lOjBkMzY4MzY4ZjI0MDAwMCIKICAgICAgICAgc3RSZWY6dG9QYXJ0PSJ0aW1lOjE5MjE5MmYyNDAwMDBkMzY4MzY4ZjI0MDAwMCIKICAgICAgICAgc3RSZWY6bWFza01hcmtlcnM9Ik5vbmUiLz4KICAgICAgICA8cmRmOmxpCiAgICAgICAgIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6NTYwNTIzOTgtNmI3Zi00MzIzLTk4NzctZWE5YjlmNzY3NTBkIgogICAgICAgICBzdFJlZjpmcm9tUGFydD0idGltZTowZDM2ODM2OGYyNDAwMDAiCiAgICAgICAgIHN0UmVmOnRvUGFydD0idGltZToxOTIxOTJmMjQwMDAwZDM2ODM2OGYyNDAwMDAiCiAgICAgICAgIHN0UmVmOm1hc2tNYXJrZXJzPSJOb25lIi8+CiAgICAgICAgPHJkZjpsaQogICAgICAgICBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjU2Y2MxNjdjLTY3NDctNGRkMy04ODdhLTkxMDgyMTkzYmU2ZSIKICAgICAgICAgc3RSZWY6ZnJvbVBhcnQ9InRpbWU6MTEyMTEyZjI0MDAwMGQ0NDg0NDhmMjQwMDAwIgogICAgICAgICBzdFJlZjp0b1BhcnQ9InRpbWU6MTEyMTEyZjI0MDAwMGQ0NDg0NDhmMjQwMDAwIgogICAgICAgICBzdFJlZjptYXNrTWFya2Vycz0iTm9uZSIvPgogICAgICAgIDxyZGY6bGkKICAgICAgICAgc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo1YTFkNjE2My04MWI5LTRhYTgtYTBjNi04YmM4YjBhYWY3ZWYiCiAgICAgICAgIHN0UmVmOmZyb21QYXJ0PSJ0aW1lOjBkMjg4Mjg4ZjI0MDAwMCIKICAgICAgICAgc3RSZWY6dG9QYXJ0PSJ0aW1lOjI3MjI3MmYyNDAwMDBkMjg4Mjg4ZjI0MDAwMCIKICAgICAgICAgc3RSZWY6bWFza01hcmtlcnM9Ik5vbmUiLz4KICAgICAgICA8cmRmOmxpCiAgICAgICAgIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6NmZjN2NjZTgtNWUwZC00YzhkLWEyZDQtNmI0MWMyZjJhNDQ1IgogICAgICAgICBzdFJlZjpmcm9tUGFydD0idGltZTowZDI4ODI4OGYyNDAwMDAiCiAgICAgICAgIHN0UmVmOnRvUGFydD0idGltZToyNzIyNzJmMjQwMDAwZDI4ODI4OGYyNDAwMDAiCiAgICAgICAgIHN0UmVmOm1hc2tNYXJrZXJzPSJOb25lIi8+CiAgICAgICAgPHJkZjpsaQogICAgICAgICBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjc5YTc2OWJkLTViMDktNDFhZS1iNjY5LTJhODkyZmFjYzQ3MSIKICAgICAgICAgc3RSZWY6ZnJvbVBhcnQ9InRpbWU6MGQyODgyODhmMjQwMDAwIgogICAgICAgICBzdFJlZjp0b1BhcnQ9InRpbWU6MjcyMjcyZjI0MDAwMGQyODgyODhmMjQwMDAwIgogICAgICAgICBzdFJlZjptYXNrTWFya2Vycz0iTm9uZSIvPgogICAgICAgIDxyZGY6bGkKICAgICAgICAgc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo4NzAyZDBmYi0yMDVkLTRkYzItOWU1NC0wMWU0YzgyYzM0OGEiCiAgICAgICAgIHN0UmVmOmZyb21QYXJ0PSJ0aW1lOjBkMzY4MzY4ZjI0MDAwMCIKICAgICAgICAgc3RSZWY6dG9QYXJ0PSJ0aW1lOjE5MjE5MmYyNDAwMDBkMzY4MzY4ZjI0MDAwMCIKICAgICAgICAgc3RSZWY6bWFza01hcmtlcnM9Ik5vbmUiLz4KICAgICAgICA8cmRmOmxpCiAgICAgICAgIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6ODlkNTg1NWMtMjRhYi00NDlmLTllYmYtYTBkY2JmMTk3YTFmIgogICAgICAgICBzdFJlZjpmcm9tUGFydD0idGltZTowZDM2ODM2OGYyNDAwMDAiCiAgICAgICAgIHN0UmVmOnRvUGFydD0idGltZToxOTIxOTJmMjQwMDAwZDM2ODM2OGYyNDAwMDAiCiAgICAgICAgIHN0UmVmOm1hc2tNYXJrZXJzPSJOb25lIi8+CiAgICAgICAgPHJkZjpsaQogICAgICAgICBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjk0Zjc0ZWI0LTYyZTgtNDNiMS1iNjYxLTY2OWEyOWJhOTVmYyIKICAgICAgICAgc3RSZWY6ZnJvbVBhcnQ9InRpbWU6MGQxMjAxMjBmMjQwMDAwIgogICAgICAgICBzdFJlZjp0b1BhcnQ9InRpbWU6MGQxMjAxMjBmMjQwMDAwIgogICAgICAgICBzdFJlZjptYXNrTWFya2Vycz0iTm9uZSIvPgogICAgICAgIDxyZGY6bGkKICAgICAgICAgc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo5ZDBmYzc2NS1lNjQ1LTRjMjMtYjkwOC03MzYwMDBmY2RjNWIiCiAgICAgICAgIHN0UmVmOmZyb21QYXJ0PSJ0aW1lOjEyMDEyMGYyNDAwMDBkNDQwNDQwZjI0MDAwMCIKICAgICAgICAgc3RSZWY6dG9QYXJ0PSJ0aW1lOjEyMDEyMGYyNDAwMDBkNDQwNDQwZjI0MDAwMCIKICAgICAgICAgc3RSZWY6bWFza01hcmtlcnM9Ik5vbmUiLz4KICAgICAgICA8cmRmOmxpCiAgICAgICAgIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6YjA0MDU2MmEtZWY2Yi00NWY5LWI1MmItNjVmYzhjZDhiZWQ5IgogICAgICAgICBzdFJlZjpmcm9tUGFydD0idGltZTowZDM2ODM2OGYyNDAwMDAiCiAgICAgICAgIHN0UmVmOnRvUGFydD0idGltZToxOTIxOTJmMjQwMDAwZDM2ODM2OGYyNDAwMDAiCiAgICAgICAgIHN0UmVmOm1hc2tNYXJrZXJzPSJOb25lIi8+CiAgICAgICAgPHJkZjpsaQogICAgICAgICBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOmI3NGY4OTM0LTBlYmEtNGJiYy04NjkzLWVlMDIyZjVlZTJiYyIKICAgICAgICAgc3RSZWY6ZnJvbVBhcnQ9InRpbWU6MGQyODgyODhmMjQwMDAwIgogICAgICAgICBzdFJlZjp0b1BhcnQ9InRpbWU6MjcyMjcyZjI0MDAwMGQyODgyODhmMjQwMDAwIgogICAgICAgICBzdFJlZjptYXNrTWFya2Vycz0iTm9uZSIvPgogICAgICAgIDxyZGY6bGkKICAgICAgICAgc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpjOTVlY2ZiZC0yZWQ1LTQ4NGYtYjc5OS0xNmZhMjM4NmE5MWIiCiAgICAgICAgIHN0UmVmOmZyb21QYXJ0PSJ0aW1lOjBkMzY4MzY4ZjI0MDAwMCIKICAgICAgICAgc3RSZWY6dG9QYXJ0PSJ0aW1lOjE5MjE5MmYyNDAwMDBkMzY4MzY4ZjI0MDAwMCIKICAgICAgICAgc3RSZWY6bWFza01hcmtlcnM9Ik5vbmUiLz4KICAgICAgICA8cmRmOmxpCiAgICAgICAgIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6Y2Y2ZDA5OTUtNjZiNS00NTA2LTljOGEtMDZlMzI1OWIyMzk1IgogICAgICAgICBzdFJlZjpmcm9tUGFydD0idGltZTowZDM2ODM2OGYyNDAwMDAiCiAgICAgICAgIHN0UmVmOnRvUGFydD0idGltZToxOTIxOTJmMjQwMDAwZDM2ODM2OGYyNDAwMDAiCiAgICAgICAgIHN0UmVmOm1hc2tNYXJrZXJzPSJOb25lIi8+CiAgICAgICAgPHJkZjpsaQogICAgICAgICBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOmRhYjdmZDdkLWZlMWItNGZjMi1iZmUxLWI4OGM1MTU0ZmUyNSIKICAgICAgICAgc3RSZWY6ZnJvbVBhcnQ9InRpbWU6MGQyODgyODhmMjQwMDAwIgogICAgICAgICBzdFJlZjp0b1BhcnQ9InRpbWU6MjcyMjcyZjI0MDAwMGQyODgyODhmMjQwMDAwIgogICAgICAgICBzdFJlZjptYXNrTWFya2Vycz0iTm9uZSIvPgogICAgICAgPC9yZGY6QmFnPgogICAgICA8L3htcE1NOkluZ3JlZGllbnRzPgogICAgICA8L3JkZjpEZXNjcmlwdGlvbj4KICAgICA8L3JkZjpsaT4KICAgICA8cmRmOmxpPgogICAgICA8cmRmOkRlc2NyaXB0aW9uCiAgICAgICBkYzpmb3JtYXQ9ImFwcGxpY2F0aW9uL3ZuZC5hZG9iZS5hZnRlcmVmZmVjdHMubGF5ZXIiCiAgICAgICB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjA4NTIzNzFkLTM2NjctNDA5My04ZmY1LTU5MmJlNTI4YWQ4ZCI+CiAgICAgIDxkYzp0aXRsZT4KICAgICAgIDxyZGY6QWx0PgogICAgICAgIDxyZGY6bGkgeG1sOmxhbmc9IngtZGVmYXVsdCI+SW5uZXIgQ2VudGVyIEhvcml6b250YWwgT3V0bGluZXM8L3JkZjpsaT4KICAgICAgIDwvcmRmOkFsdD4KICAgICAgPC9kYzp0aXRsZT4KICAgICAgPC9yZGY6RGVzY3JpcHRpb24+CiAgICAgPC9yZGY6bGk+CiAgICAgPHJkZjpsaT4KICAgICAgPHJkZjpEZXNjcmlwdGlvbgogICAgICAgZGM6Zm9ybWF0PSJhcHBsaWNhdGlvbi92bmQuYWRvYmUuYWZ0ZXJlZmZlY3RzLmxheWVyIgogICAgICAgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDowYjk5YTk1OC03OTA0LTQ0MjEtODkyMy04NjU2NWUyNTUzNTMiPgogICAgICA8ZGM6dGl0bGU+CiAgICAgICA8cmRmOkFsdD4KICAgICAgICA8cmRmOmxpIHhtbDpsYW5nPSJ4LWRlZmF1bHQiPkJvdHRvbSBMZWZ0IE91dGxpbmVzPC9yZGY6bGk+CiAgICAgICA8L3JkZjpBbHQ+CiAgICAgIDwvZGM6dGl0bGU+CiAgICAgIDwvcmRmOkRlc2NyaXB0aW9uPgogICAgIDwvcmRmOmxpPgogICAgIDxyZGY6bGk+CiAgICAgIDxyZGY6RGVzY3JpcHRpb24KICAgICAgIGRjOmZvcm1hdD0iYXBwbGljYXRpb24vdm5kLmFkb2JlLmFmdGVyZWZmZWN0cy5sYXllciIKICAgICAgIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6MGYyNDA1YjAtNjkyZi00OWVhLTgzMzctNjYzMTAyOWNkOTQ1Ij4KICAgICAgPGRjOnRpdGxlPgogICAgICAgPHJkZjpBbHQ+CiAgICAgICAgPHJkZjpsaSB4bWw6bGFuZz0ieC1kZWZhdWx0Ij5Ub3AgMiBPdXRsaW5lczwvcmRmOmxpPgogICAgICAgPC9yZGY6QWx0PgogICAgICA8L2RjOnRpdGxlPgogICAgICA8L3JkZjpEZXNjcmlwdGlvbj4KICAgICA8L3JkZjpsaT4KICAgICA8cmRmOmxpPgogICAgICA8cmRmOkRlc2NyaXB0aW9uCiAgICAgICBkYzpmb3JtYXQ9ImFwcGxpY2F0aW9uL3ZuZC5hZG9iZS5hZnRlcmVmZmVjdHMubGF5ZXIiCiAgICAgICB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjBmODU5OTVlLTQyZjYtNDFkYS05Nzg1LTYxMTIxODkwZjQ5YSI+CiAgICAgIDxkYzp0aXRsZT4KICAgICAgIDxyZGY6QWx0PgogICAgICAgIDxyZGY6bGkgeG1sOmxhbmc9IngtZGVmYXVsdCI+SW5uZXIgRGlhZ29uYWwgTGVmdCBPdXRsaW5lczwvcmRmOmxpPgogICAgICAgPC9yZGY6QWx0PgogICAgICA8L2RjOnRpdGxlPgogICAgICA8L3JkZjpEZXNjcmlwdGlvbj4KICAgICA8L3JkZjpsaT4KICAgICA8cmRmOmxpPgogICAgICA8cmRmOkRlc2NyaXB0aW9uCiAgICAgICBkYzpmb3JtYXQ9ImFwcGxpY2F0aW9uL3ZuZC5hZG9iZS5hZnRlcmVmZmVjdHMubGF5ZXIiCiAgICAgICB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjE0ZDBkZjdiLWY2M2EtNDg2ZC1hOWVkLTAwNTE1NzZjYjBkZiI+CiAgICAgIDxkYzp0aXRsZT4KICAgICAgIDxyZGY6QWx0PgogICAgICAgIDxyZGY6bGkgeG1sOmxhbmc9IngtZGVmYXVsdCI+TWlkZGxlIEJvdHRvbSBSaWdodCBPdXRsaW5lczwvcmRmOmxpPgogICAgICAgPC9yZGY6QWx0PgogICAgICA8L2RjOnRpdGxlPgogICAgICA8L3JkZjpEZXNjcmlwdGlvbj4KICAgICA8L3JkZjpsaT4KICAgICA8cmRmOmxpPgogICAgICA8cmRmOkRlc2NyaXB0aW9uCiAgICAgICBkYzpmb3JtYXQ9ImFwcGxpY2F0aW9uL3ZuZC5hZG9iZS5hZnRlcmVmZmVjdHMubGF5ZXIiCiAgICAgICB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjE5NGVkN2JiLWE5ZjUtNDM4Ni1hMGY4LTU0MWI3NGYyZDE2NCI+CiAgICAgIDxkYzp0aXRsZT4KICAgICAgIDxyZGY6QWx0PgogICAgICAgIDxyZGY6bGkgeG1sOmxhbmc9IngtZGVmYXVsdCI+UHJlLWNvbXAgMjwvcmRmOmxpPgogICAgICAgPC9yZGY6QWx0PgogICAgICA8L2RjOnRpdGxlPgogICAgICA8eG1wTU06SW5ncmVkaWVudHM+CiAgICAgICA8cmRmOkJhZz4KICAgICAgICA8cmRmOmxpCiAgICAgICAgIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6NTYxYzdmYWYtOWU3My00NDM4LWIwMGYtZTkwZWQ3NDA1NjI4IgogICAgICAgICBzdFJlZjpmcm9tUGFydD0idGltZTowZDkwNDA3MTE2ODAwMGYyNTQwMTYwMDAwMDAiCiAgICAgICAgIHN0UmVmOnRvUGFydD0idGltZTowZDkwNDA3MTE2ODAwMGYyNTQwMTYwMDAwMDAiCiAgICAgICAgIHN0UmVmOm1hc2tNYXJrZXJzPSJOb25lIi8+CiAgICAgICA8L3JkZjpCYWc+CiAgICAgIDwveG1wTU06SW5ncmVkaWVudHM+CiAgICAgIDwvcmRmOkRlc2NyaXB0aW9uPgogICAgIDwvcmRmOmxpPgogICAgIDxyZGY6bGk+CiAgICAgIDxyZGY6RGVzY3JpcHRpb24KICAgICAgIGRjOmZvcm1hdD0iYXBwbGljYXRpb24vdm5kLmFkb2JlLmFmdGVyZWZmZWN0cy5sYXllciIKICAgICAgIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6MWQzMjg3ZmMtNzU3Zi00NmFmLTg4Y2QtOGIyMTc0MTQ2NmVkIj4KICAgICAgPGRjOnRpdGxlPgogICAgICAgPHJkZjpBbHQ+CiAgICAgICAgPHJkZjpsaSB4bWw6bGFuZz0ieC1kZWZhdWx0Ij5SaWdodCAyIE91dGxpbmVzPC9yZGY6bGk+CiAgICAgICA8L3JkZjpBbHQ+CiAgICAgIDwvZGM6dGl0bGU+CiAgICAgIDwvcmRmOkRlc2NyaXB0aW9uPgogICAgIDwvcmRmOmxpPgogICAgIDxyZGY6bGk+CiAgICAgIDxyZGY6RGVzY3JpcHRpb24KICAgICAgIGRjOmZvcm1hdD0iYXBwbGljYXRpb24vdm5kLmFkb2JlLmFmdGVyZWZmZWN0cy5sYXllciIKICAgICAgIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6MWUxNTdjYWQtZDBmNC00YzExLTg5NjYtZmI0MWViNjgzYWYzIj4KICAgICAgPGRjOnRpdGxlPgogICAgICAgPHJkZjpBbHQ+CiAgICAgICAgPHJkZjpsaSB4bWw6bGFuZz0ieC1kZWZhdWx0Ij5NaWRkbGUgVG9wIE91dGxpbmVzPC9yZGY6bGk+CiAgICAgICA8L3JkZjpBbHQ+CiAgICAgIDwvZGM6dGl0bGU+CiAgICAgIDwvcmRmOkRlc2NyaXB0aW9uPgogICAgIDwvcmRmOmxpPgogICAgIDxyZGY6bGk+CiAgICAgIDxyZGY6RGVzY3JpcHRpb24KICAgICAgIGRjOmZvcm1hdD0iYXBwbGljYXRpb24vdm5kLmFkb2JlLmFmdGVyZWZmZWN0cy5sYXllciIKICAgICAgIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6MjE5YTg2YjEtMTUzYy00MzFhLTk0MjctYmUzNzY2YmVlOGNkIj4KICAgICAgPGRjOnRpdGxlPgogICAgICAgPHJkZjpBbHQ+CiAgICAgICAgPHJkZjpsaSB4bWw6bGFuZz0ieC1kZWZhdWx0Ij5QcmUtY29tcCAxPC9yZGY6bGk+CiAgICAgICA8L3JkZjpBbHQ+CiAgICAgIDwvZGM6dGl0bGU+CiAgICAgIDx4bXBNTTpJbmdyZWRpZW50cz4KICAgICAgIDxyZGY6QmFnPgogICAgICAgIDxyZGY6bGkKICAgICAgICAgc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDowODUwOTNhMS1hZjI3LTRiYzgtOWVkNy1iZWZkODY5ODgxZGIiCiAgICAgICAgIHN0UmVmOmZyb21QYXJ0PSJ0aW1lOjBkNTYwNTYwZjI0MDAwMCIKICAgICAgICAgc3RSZWY6dG9QYXJ0PSJ0aW1lOjBkNTYwNTYwZjI0MDAwMCIKICAgICAgICAgc3RSZWY6bWFza01hcmtlcnM9Ik5vbmUiLz4KICAgICAgIDwvcmRmOkJhZz4KICAgICAgPC94bXBNTTpJbmdyZWRpZW50cz4KICAgICAgPC9yZGY6RGVzY3JpcHRpb24+CiAgICAgPC9yZGY6bGk+CiAgICAgPHJkZjpsaT4KICAgICAgPHJkZjpEZXNjcmlwdGlvbgogICAgICAgZGM6Zm9ybWF0PSJhcHBsaWNhdGlvbi92bmQuYWRvYmUuYWZ0ZXJlZmZlY3RzLmNvbXAiCiAgICAgICB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjJjNjJlMzcxLTg4ODAtNDEzMC1iZDc1LTJjNGUyZTc2ZTBiMiI+CiAgICAgIDxkYzp0aXRsZT4KICAgICAgIDxyZGY6QWx0PgogICAgICAgIDxyZGY6bGkgeG1sOmxhbmc9IngtZGVmYXVsdCI+Q29tcCAxPC9yZGY6bGk+CiAgICAgICA8L3JkZjpBbHQ+CiAgICAgIDwvZGM6dGl0bGU+CiAgICAgIDx4bXBNTTpJbmdyZWRpZW50cz4KICAgICAgIDxyZGY6QmFnPgogICAgICAgIDxyZGY6bGkKICAgICAgICAgc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDoxOTRlZDdiYi1hOWY1LTQzODYtYTBmOC01NDFiNzRmMmQxNjQiCiAgICAgICAgIHN0UmVmOmZyb21QYXJ0PSJ0aW1lOjBkOTA0MDcxMTY4MDAwZjI1NDAxNjAwMDAwMCIKICAgICAgICAgc3RSZWY6dG9QYXJ0PSJ0aW1lOjQ3MjQ3MmYyNDAwMDBkNDUyMDM1NTg0MDAwZjI1NDAxNjAwMDAwMCIKICAgICAgICAgc3RSZWY6bWFza01hcmtlcnM9Ik5vbmUiLz4KICAgICAgICA8cmRmOmxpCiAgICAgICAgIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6MjE5YTg2YjEtMTUzYy00MzFhLTk0MjctYmUzNzY2YmVlOGNkIgogICAgICAgICBzdFJlZjpmcm9tUGFydD0idGltZTowZDU2MDU2MGYyNDAwMDAiCiAgICAgICAgIHN0UmVmOnRvUGFydD0idGltZToyNzIyNzJmMjQwMDAwZDMzNjMzNmYyNDAwMDAiCiAgICAgICAgIHN0UmVmOm1hc2tNYXJrZXJzPSJOb25lIi8+CiAgICAgICAgPHJkZjpsaQogICAgICAgICBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjQ3OTc2MDVkLTI5NTUtNGM5Yi1iODkyLTUwYTI2NjQ4ZTc5MyIKICAgICAgICAgc3RSZWY6ZnJvbVBhcnQ9InRpbWU6MGQ3MjA3MjAwZjI0MDAwMCIKICAgICAgICAgc3RSZWY6dG9QYXJ0PSJ0aW1lOjBkNzIwNzIwMGYyNDAwMDAiCiAgICAgICAgIHN0UmVmOm1hc2tNYXJrZXJzPSJOb25lIi8+CiAgICAgICAgPHJkZjpsaQogICAgICAgICBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjU4NDljY2Q1LWZjM2UtNDBiMi05YTJkLTZlMDVjMTU4NDliNiIKICAgICAgICAgc3RSZWY6ZnJvbVBhcnQ9InRpbWU6MGQ3MjA3MjAwZjI0MDAwMCIKICAgICAgICAgc3RSZWY6dG9QYXJ0PSJ0aW1lOjBkNzIwNzIwMGYyNDAwMDAiCiAgICAgICAgIHN0UmVmOm1hc2tNYXJrZXJzPSJOb25lIi8+CiAgICAgICAgPHJkZjpsaQogICAgICAgICBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOmFlYjA0NzZlLTA3OTYtNGY0Yy1hNGMzLTc1N2UwNDViYzc5ZCIKICAgICAgICAgc3RSZWY6ZnJvbVBhcnQ9InRpbWU6MGQ0NzA4NzA0MDAwMDBmMjU0MDE2MDAwMDAwIgogICAgICAgICBzdFJlZjp0b1BhcnQ9InRpbWU6MGQzNzY2OTYzMjAwMDBmMjU0MDE2MDAwMDAwIgogICAgICAgICBzdFJlZjptYXNrTWFya2Vycz0iTm9uZSIvPgogICAgICAgIDxyZGY6bGkKICAgICAgICAgc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpiMGE3M2I5Yy1lNjYzLTQ0ZmEtODJmZi1mZWYzMDE0YmE2YmEiCiAgICAgICAgIHN0UmVmOmZyb21QYXJ0PSJ0aW1lOjBkNDcwODcwNDAwMDAwZjI1NDAxNjAwMDAwMCIKICAgICAgICAgc3RSZWY6dG9QYXJ0PSJ0aW1lOjYzMjYzMmYyNDAwMDBkMjM1NDM1MjAwMDAwZjI1NDAxNjAwMDAwMCIKICAgICAgICAgc3RSZWY6bWFza01hcmtlcnM9Ik5vbmUiLz4KICAgICAgICA8cmRmOmxpCiAgICAgICAgIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6YzViODBjZDQtMzE5Zi00YWZlLWJjNGMtNzM0ZDE5YjdhN2IxIgogICAgICAgICBzdFJlZjpmcm9tUGFydD0idGltZTowZDczNDU1NzgyNDAwMGYyNTQwMTYwMDAwMDAiCiAgICAgICAgIHN0UmVmOnRvUGFydD0idGltZTo3MjA3MmYyNDAwMDBkNDE2NDE2ZjI0MDAwMCIKICAgICAgICAgc3RSZWY6bWFza01hcmtlcnM9Ik5vbmUiLz4KICAgICAgICA8cmRmOmxpCiAgICAgICAgIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6YzY4ZDIzZTgtNWUxMC00MzlmLTk0NTEtOWIzMjcwODIyMjRmIgogICAgICAgICBzdFJlZjpmcm9tUGFydD0idGltZTowZDkwNDA3MTE2ODAwMGYyNTQwMTYwMDAwMDAiCiAgICAgICAgIHN0UmVmOnRvUGFydD0idGltZToyNDgyNDhmMjQwMDAwZDcyMzI1NjkzNDQwMGYyNTQwMTYwMDAwMDAiCiAgICAgICAgIHN0UmVmOm1hc2tNYXJrZXJzPSJOb25lIi8+CiAgICAgICA8L3JkZjpCYWc+CiAgICAgIDwveG1wTU06SW5ncmVkaWVudHM+CiAgICAgIDwvcmRmOkRlc2NyaXB0aW9uPgogICAgIDwvcmRmOmxpPgogICAgIDxyZGY6bGk+CiAgICAgIDxyZGY6RGVzY3JpcHRpb24KICAgICAgIGRjOmZvcm1hdD0iYXBwbGljYXRpb24vdm5kLmFkb2JlLmFmdGVyZWZmZWN0cy5sYXllciIKICAgICAgIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6MzQxYmZlODEtYWNlMi00YTBhLThmZjUtMDY1OTZhMTBkYzkzIj4KICAgICAgPGRjOnRpdGxlPgogICAgICAgPHJkZjpBbHQ+CiAgICAgICAgPHJkZjpsaSB4bWw6bGFuZz0ieC1kZWZhdWx0Ij5NaWRkbGUgQm90dG9tIFJpZ2h0IE91dGxpbmVzPC9yZGY6bGk+CiAgICAgICA8L3JkZjpBbHQ+CiAgICAgIDwvZGM6dGl0bGU+CiAgICAgIDwvcmRmOkRlc2NyaXB0aW9uPgogICAgIDwvcmRmOmxpPgogICAgIDxyZGY6bGk+CiAgICAgIDxyZGY6RGVzY3JpcHRpb24KICAgICAgIGRjOmZvcm1hdD0iYXBwbGljYXRpb24vdm5kLmFkb2JlLmFmdGVyZWZmZWN0cy5sYXllciIKICAgICAgIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6MzhjNzAyNmItYzM2ZS00ODI4LTg5MGItYmYyZTNjZWFjN2JmIj4KICAgICAgPGRjOnRpdGxlPgogICAgICAgPHJkZjpBbHQ+CiAgICAgICAgPHJkZjpsaSB4bWw6bGFuZz0ieC1kZWZhdWx0Ij5NaWRkbGUgVG9wIFJpZ2h0IE91dGxpbmVzPC9yZGY6bGk+CiAgICAgICA8L3JkZjpBbHQ+CiAgICAgIDwvZGM6dGl0bGU+CiAgICAgIDwvcmRmOkRlc2NyaXB0aW9uPgogICAgIDwvcmRmOmxpPgogICAgIDxyZGY6bGk+CiAgICAgIDxyZGY6RGVzY3JpcHRpb24KICAgICAgIGRjOmZvcm1hdD0iYXBwbGljYXRpb24vdm5kLmFkb2JlLmFmdGVyZWZmZWN0cy5sYXllciIKICAgICAgIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NDZmMjdjZjQtN2MxNi00ZTU4LTg1YmUtNDBjOTRmZmRiM2Q1Ij4KICAgICAgPGRjOnRpdGxlPgogICAgICAgPHJkZjpBbHQ+CiAgICAgICAgPHJkZjpsaSB4bWw6bGFuZz0ieC1kZWZhdWx0Ij5Cb3R0b20gTGVmdCBPdXRsaW5lczwvcmRmOmxpPgogICAgICAgPC9yZGY6QWx0PgogICAgICA8L2RjOnRpdGxlPgogICAgICA8L3JkZjpEZXNjcmlwdGlvbj4KICAgICA8L3JkZjpsaT4KICAgICA8cmRmOmxpPgogICAgICA8cmRmOkRlc2NyaXB0aW9uCiAgICAgICBkYzpmb3JtYXQ9ImFwcGxpY2F0aW9uL3ZuZC5hZG9iZS5hZnRlcmVmZmVjdHMubGF5ZXIiCiAgICAgICB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjQ3OTc2MDVkLTI5NTUtNGM5Yi1iODkyLTUwYTI2NjQ4ZTc5MyI+CiAgICAgIDxkYzp0aXRsZT4KICAgICAgIDxyZGY6QWx0PgogICAgICAgIDxyZGY6bGkgeG1sOmxhbmc9IngtZGVmYXVsdCI+QmxhY2sgU29saWQgMTwvcmRmOmxpPgogICAgICAgPC9yZGY6QWx0PgogICAgICA8L2RjOnRpdGxlPgogICAgICA8L3JkZjpEZXNjcmlwdGlvbj4KICAgICA8L3JkZjpsaT4KICAgICA8cmRmOmxpPgogICAgICA8cmRmOkRlc2NyaXB0aW9uCiAgICAgICBkYzpmb3JtYXQ9ImFwcGxpY2F0aW9uL3ZuZC5hZG9iZS5hZnRlcmVmZmVjdHMubGF5ZXIiCiAgICAgICB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjRmZmNkNTcyLWFkODAtNGQ4ZC1hYzA4LWRmN2Y1ZjEzOWMyNyI+CiAgICAgIDxkYzp0aXRsZT4KICAgICAgIDxyZGY6QWx0PgogICAgICAgIDxyZGY6bGkgeG1sOmxhbmc9IngtZGVmYXVsdCI+VG9wIDIgT3V0bGluZXM8L3JkZjpsaT4KICAgICAgIDwvcmRmOkFsdD4KICAgICAgPC9kYzp0aXRsZT4KICAgICAgPC9yZGY6RGVzY3JpcHRpb24+CiAgICAgPC9yZGY6bGk+CiAgICAgPHJkZjpsaT4KICAgICAgPHJkZjpEZXNjcmlwdGlvbgogICAgICAgZGM6Zm9ybWF0PSJhcHBsaWNhdGlvbi92bmQuYWRvYmUuYWZ0ZXJlZmZlY3RzLmxheWVyIgogICAgICAgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDo1NjA1MjM5OC02YjdmLTQzMjMtOTg3Ny1lYTliOWY3Njc1MGQiPgogICAgICA8ZGM6dGl0bGU+CiAgICAgICA8cmRmOkFsdD4KICAgICAgICA8cmRmOmxpIHhtbDpsYW5nPSJ4LWRlZmF1bHQiPk1pZGRsZSBCb3R0b20gT3V0bGluZXM8L3JkZjpsaT4KICAgICAgIDwvcmRmOkFsdD4KICAgICAgPC9kYzp0aXRsZT4KICAgICAgPC9yZGY6RGVzY3JpcHRpb24+CiAgICAgPC9yZGY6bGk+CiAgICAgPHJkZjpsaT4KICAgICAgPHJkZjpEZXNjcmlwdGlvbgogICAgICAgZGM6Zm9ybWF0PSJhcHBsaWNhdGlvbi92bmQuYWRvYmUuYWZ0ZXJlZmZlY3RzLmNvbXAiCiAgICAgICB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjU2MWM3ZmFmLTllNzMtNDQzOC1iMDBmLWU5MGVkNzQwNTYyOCI+CiAgICAgIDxkYzp0aXRsZT4KICAgICAgIDxyZGY6QWx0PgogICAgICAgIDxyZGY6bGkgeG1sOmxhbmc9IngtZGVmYXVsdCI+UHJlLWNvbXAgMjwvcmRmOmxpPgogICAgICAgPC9yZGY6QWx0PgogICAgICA8L2RjOnRpdGxlPgogICAgICA8eG1wTU06SW5ncmVkaWVudHM+CiAgICAgICA8cmRmOkJhZz4KICAgICAgICA8cmRmOmxpCiAgICAgICAgIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6MWQzMjg3ZmMtNzU3Zi00NmFmLTg4Y2QtOGIyMTc0MTQ2NmVkIgogICAgICAgICBzdFJlZjpmcm9tUGFydD0idGltZTowZDYxNTg5ODQ4MzIwMGYyNTQwMTYwMDAwMDAiCiAgICAgICAgIHN0UmVmOnRvUGFydD0idGltZToyNzIyNzJmMjQwMDAwZDYxNTg5ODQ4MzIwMGYyNTQwMTYwMDAwMDAiCiAgICAgICAgIHN0UmVmOm1hc2tNYXJrZXJzPSJOb25lIi8+CiAgICAgICAgPHJkZjpsaQogICAgICAgICBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjFlMTU3Y2FkLWQwZjQtNGMxMS04OTY2LWZiNDFlYjY4M2FmMyIKICAgICAgICAgc3RSZWY6ZnJvbVBhcnQ9InRpbWU6MGQ3MDA2NTUxNTUyMDBmMjU0MDE2MDAwMDAwIgogICAgICAgICBzdFJlZjp0b1BhcnQ9InRpbWU6MTkyMTkyZjI0MDAwMGQ3MDA2NTUxNTUyMDBmMjU0MDE2MDAwMDAwIgogICAgICAgICBzdFJlZjptYXNrTWFya2Vycz0iTm9uZSIvPgogICAgICAgIDxyZGY6bGkKICAgICAgICAgc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDozNDFiZmU4MS1hY2UyLTRhMGEtOGZmNS0wNjU5NmExMGRjOTMiCiAgICAgICAgIHN0UmVmOmZyb21QYXJ0PSJ0aW1lOjBkNzAwNjU1MTU1MjAwZjI1NDAxNjAwMDAwMCIKICAgICAgICAgc3RSZWY6dG9QYXJ0PSJ0aW1lOjE5MjE5MmYyNDAwMDBkNzAwNjU1MTU1MjAwZjI1NDAxNjAwMDAwMCIKICAgICAgICAgc3RSZWY6bWFza01hcmtlcnM9Ik5vbmUiLz4KICAgICAgICA8cmRmOmxpCiAgICAgICAgIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6NDZmMjdjZjQtN2MxNi00ZTU4LTg1YmUtNDBjOTRmZmRiM2Q1IgogICAgICAgICBzdFJlZjpmcm9tUGFydD0idGltZTowZDYxNTg5ODQ4MzIwMGYyNTQwMTYwMDAwMDAiCiAgICAgICAgIHN0UmVmOnRvUGFydD0idGltZToyNzIyNzJmMjQwMDAwZDYxNTg5ODQ4MzIwMGYyNTQwMTYwMDAwMDAiCiAgICAgICAgIHN0UmVmOm1hc2tNYXJrZXJzPSJOb25lIi8+CiAgICAgICAgPHJkZjpsaQogICAgICAgICBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjRmZmNkNTcyLWFkODAtNGQ4ZC1hYzA4LWRmN2Y1ZjEzOWMyNyIKICAgICAgICAgc3RSZWY6ZnJvbVBhcnQ9InRpbWU6MGQ2MTU4OTg0ODMyMDBmMjU0MDE2MDAwMDAwIgogICAgICAgICBzdFJlZjp0b1BhcnQ9InRpbWU6MjcyMjcyZjI0MDAwMGQ2MTU4OTg0ODMyMDBmMjU0MDE2MDAwMDAwIgogICAgICAgICBzdFJlZjptYXNrTWFya2Vycz0iTm9uZSIvPgogICAgICAgIDxyZGY6bGkKICAgICAgICAgc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo2MDk5ZWNmNC1lMGMyLTQzZjYtYWJjMi0yZDI5NzY1MTRiOTgiCiAgICAgICAgIHN0UmVmOmZyb21QYXJ0PSJ0aW1lOjBkNjE1ODk4NDgzMjAwZjI1NDAxNjAwMDAwMCIKICAgICAgICAgc3RSZWY6dG9QYXJ0PSJ0aW1lOjI3MjI3MmYyNDAwMDBkNjE1ODk4NDgzMjAwZjI1NDAxNjAwMDAwMCIKICAgICAgICAgc3RSZWY6bWFza01hcmtlcnM9Ik5vbmUiLz4KICAgICAgICA8cmRmOmxpCiAgICAgICAgIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6NjdjMGEyOWItOWIyNy00MjAwLTk3ODEtZGIxZTRiNTMxYTNjIgogICAgICAgICBzdFJlZjpmcm9tUGFydD0idGltZTowZDcwMDY1NTE1NTIwMGYyNTQwMTYwMDAwMDAiCiAgICAgICAgIHN0UmVmOnRvUGFydD0idGltZToxOTIxOTJmMjQwMDAwZDcwMDY1NTE1NTIwMGYyNTQwMTYwMDAwMDAiCiAgICAgICAgIHN0UmVmOm1hc2tNYXJrZXJzPSJOb25lIi8+CiAgICAgICAgPHJkZjpsaQogICAgICAgICBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjc5OTNjNzNhLTAzODgtNGExMy1iZTZiLTYxNmI5ZTdiYTU4ZSIKICAgICAgICAgc3RSZWY6ZnJvbVBhcnQ9InRpbWU6MGQ3MDA2NTUxNTUyMDBmMjU0MDE2MDAwMDAwIgogICAgICAgICBzdFJlZjp0b1BhcnQ9InRpbWU6MTkyMTkyZjI0MDAwMGQ3MDA2NTUxNTUyMDBmMjU0MDE2MDAwMDAwIgogICAgICAgICBzdFJlZjptYXNrTWFya2Vycz0iTm9uZSIvPgogICAgICAgIDxyZGY6bGkKICAgICAgICAgc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo3Y2FlMmNjYy02NjRjLTQwZjEtOTc2MC1hMTBkYzI2YzlmMTkiCiAgICAgICAgIHN0UmVmOmZyb21QYXJ0PSJ0aW1lOjExMjExMmYyNDAwMDBkNzg1NDExODI3MjAwZjI1NDAxNjAwMDAwMCIKICAgICAgICAgc3RSZWY6dG9QYXJ0PSJ0aW1lOjExMjExMmYyNDAwMDBkNzg1NDExODI3MjAwZjI1NDAxNjAwMDAwMCIKICAgICAgICAgc3RSZWY6bWFza01hcmtlcnM9Ik5vbmUiLz4KICAgICAgICA8cmRmOmxpCiAgICAgICAgIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6ODhiZTk5Y2ItYWQxOS00MTAwLWExMDctNjdiMTAyNmEyZGU5IgogICAgICAgICBzdFJlZjpmcm9tUGFydD0idGltZToxMTIxMTJmMjQwMDAwZDc4NTQxMTgyNzIwMGYyNTQwMTYwMDAwMDAiCiAgICAgICAgIHN0UmVmOnRvUGFydD0idGltZToxMTIxMTJmMjQwMDAwZDc4NTQxMTgyNzIwMGYyNTQwMTYwMDAwMDAiCiAgICAgICAgIHN0UmVmOm1hc2tNYXJrZXJzPSJOb25lIi8+CiAgICAgICAgPHJkZjpsaQogICAgICAgICBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjk2YzRjN2VmLTQwZDgtNGJiNC1iYzFlLWI4MGQ3NjU3YTE2OSIKICAgICAgICAgc3RSZWY6ZnJvbVBhcnQ9InRpbWU6MGQ2MTU4OTg0ODMyMDBmMjU0MDE2MDAwMDAwIgogICAgICAgICBzdFJlZjp0b1BhcnQ9InRpbWU6MjcyMjcyZjI0MDAwMGQ2MTU4OTg0ODMyMDBmMjU0MDE2MDAwMDAwIgogICAgICAgICBzdFJlZjptYXNrTWFya2Vycz0iTm9uZSIvPgogICAgICAgIDxyZGY6bGkKICAgICAgICAgc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo5ZTA1YzAwZS1lZTJkLTQ1NWEtOGJmMi0yYjZmYWQ5NThiYTEiCiAgICAgICAgIHN0UmVmOmZyb21QYXJ0PSJ0aW1lOjBkNjE1ODk4NDgzMjAwZjI1NDAxNjAwMDAwMCIKICAgICAgICAgc3RSZWY6dG9QYXJ0PSJ0aW1lOjI3MjI3MmYyNDAwMDBkNjE1ODk4NDgzMjAwZjI1NDAxNjAwMDAwMCIKICAgICAgICAgc3RSZWY6bWFza01hcmtlcnM9Ik5vbmUiLz4KICAgICAgICA8cmRmOmxpCiAgICAgICAgIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6YTI4OGM2YmEtZjZlNi00NzMyLTg5YWEtNzk0ODMwMjg1MmUyIgogICAgICAgICBzdFJlZjpmcm9tUGFydD0idGltZToxMjAxMjBmMjQwMDAwZDc3NjkzNjE2MDAwMGYyNTQwMTYwMDAwMDAiCiAgICAgICAgIHN0UmVmOnRvUGFydD0idGltZToxMjAxMjBmMjQwMDAwZDc3NjkzNjE2MDAwMGYyNTQwMTYwMDAwMDAiCiAgICAgICAgIHN0UmVmOm1hc2tNYXJrZXJzPSJOb25lIi8+CiAgICAgICAgPHJkZjpsaQogICAgICAgICBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOmE3NzllNGI2LTNmYTAtNGZhMC05M2IwLTk3YjBiYzY1YmU4OSIKICAgICAgICAgc3RSZWY6ZnJvbVBhcnQ9InRpbWU6MTEyMTEyZjI0MDAwMGQ3ODU0MTE4MjcyMDBmMjU0MDE2MDAwMDAwIgogICAgICAgICBzdFJlZjp0b1BhcnQ9InRpbWU6MTEyMTEyZjI0MDAwMGQ3ODU0MTE4MjcyMDBmMjU0MDE2MDAwMDAwIgogICAgICAgICBzdFJlZjptYXNrTWFya2Vycz0iTm9uZSIvPgogICAgICAgIDxyZGY6bGkKICAgICAgICAgc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDphYTRhMzc4ZC00ZmQ2LTQ1YTMtODkxZC00N2Y0NDRjYTQyZDQiCiAgICAgICAgIHN0UmVmOmZyb21QYXJ0PSJ0aW1lOjBkNzAwNjU1MTU1MjAwZjI1NDAxNjAwMDAwMCIKICAgICAgICAgc3RSZWY6dG9QYXJ0PSJ0aW1lOjE5MjE5MmYyNDAwMDBkNzAwNjU1MTU1MjAwZjI1NDAxNjAwMDAwMCIKICAgICAgICAgc3RSZWY6bWFza01hcmtlcnM9Ik5vbmUiLz4KICAgICAgICA8cmRmOmxpCiAgICAgICAgIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6YjY0MTBhMzAtNGIxNS00NzZmLWI3NWItZmFiYTdmNzFlZmYyIgogICAgICAgICBzdFJlZjpmcm9tUGFydD0idGltZTowZDYxNTg5ODQ4MzIwMGYyNTQwMTYwMDAwMDAiCiAgICAgICAgIHN0UmVmOnRvUGFydD0idGltZToyNzIyNzJmMjQwMDAwZDYxNTg5ODQ4MzIwMGYyNTQwMTYwMDAwMDAiCiAgICAgICAgIHN0UmVmOm1hc2tNYXJrZXJzPSJOb25lIi8+CiAgICAgICAgPHJkZjpsaQogICAgICAgICBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOmNlZGRmYmQxLWZlNzEtNGJiYi05Y2NlLTQzNDU5ZDI4Y2FlMyIKICAgICAgICAgc3RSZWY6ZnJvbVBhcnQ9InRpbWU6MGQ3MDA2NTUxNTUyMDBmMjU0MDE2MDAwMDAwIgogICAgICAgICBzdFJlZjp0b1BhcnQ9InRpbWU6MTkyMTkyZjI0MDAwMGQ3MDA2NTUxNTUyMDBmMjU0MDE2MDAwMDAwIgogICAgICAgICBzdFJlZjptYXNrTWFya2Vycz0iTm9uZSIvPgogICAgICAgIDxyZGY6bGkKICAgICAgICAgc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpkOWVmZDNkMS1mYWI1LTQ1NDctOWEwNy0xNWU3MGExNTU5MDMiCiAgICAgICAgIHN0UmVmOmZyb21QYXJ0PSJ0aW1lOjBkNzAwNjU1MTU1MjAwZjI1NDAxNjAwMDAwMCIKICAgICAgICAgc3RSZWY6dG9QYXJ0PSJ0aW1lOjE5MjE5MmYyNDAwMDBkNzAwNjU1MTU1MjAwZjI1NDAxNjAwMDAwMCIKICAgICAgICAgc3RSZWY6bWFza01hcmtlcnM9Ik5vbmUiLz4KICAgICAgICA8cmRmOmxpCiAgICAgICAgIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6ZTIwNzBkMTUtODBmZS00YzA2LWE1MDctYzBmZWI4NTg1ZmRmIgogICAgICAgICBzdFJlZjpmcm9tUGFydD0idGltZTowZDYxNTg5ODQ4MzIwMGYyNTQwMTYwMDAwMDAiCiAgICAgICAgIHN0UmVmOnRvUGFydD0idGltZToyNzIyNzJmMjQwMDAwZDYxNTg5ODQ4MzIwMGYyNTQwMTYwMDAwMDAiCiAgICAgICAgIHN0UmVmOm1hc2tNYXJrZXJzPSJOb25lIi8+CiAgICAgICAgPHJkZjpsaQogICAgICAgICBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOmZiNWRkN2VkLTA1ZjYtNDI3OS05ZGU5LTg5YzUyZjA4NGEwMiIKICAgICAgICAgc3RSZWY6ZnJvbVBhcnQ9InRpbWU6MGQ3MDA2NTUxNTUyMDBmMjU0MDE2MDAwMDAwIgogICAgICAgICBzdFJlZjp0b1BhcnQ9InRpbWU6MTkyMTkyZjI0MDAwMGQ3MDA2NTUxNTUyMDBmMjU0MDE2MDAwMDAwIgogICAgICAgICBzdFJlZjptYXNrTWFya2Vycz0iTm9uZSIvPgogICAgICAgIDxyZGY6bGkKICAgICAgICAgc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpmZGU3Nzc1Ny0wMTJhLTQxOGQtYjQ0MS04M2QzMWNiMTE1M2EiCiAgICAgICAgIHN0UmVmOmZyb21QYXJ0PSJ0aW1lOjBkMTIwMTIwZjI0MDAwMCIKICAgICAgICAgc3RSZWY6dG9QYXJ0PSJ0aW1lOjBkMTIwMTIwZjI0MDAwMCIKICAgICAgICAgc3RSZWY6bWFza01hcmtlcnM9Ik5vbmUiLz4KICAgICAgIDwvcmRmOkJhZz4KICAgICAgPC94bXBNTTpJbmdyZWRpZW50cz4KICAgICAgPC9yZGY6RGVzY3JpcHRpb24+CiAgICAgPC9yZGY6bGk+CiAgICAgPHJkZjpsaT4KICAgICAgPHJkZjpEZXNjcmlwdGlvbgogICAgICAgZGM6Zm9ybWF0PSJhcHBsaWNhdGlvbi92bmQuYWRvYmUuYWZ0ZXJlZmZlY3RzLmxheWVyIgogICAgICAgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDo1NmNjMTY3Yy02NzQ3LTRkZDMtODg3YS05MTA4MjE5M2JlNmUiPgogICAgICA8ZGM6dGl0bGU+CiAgICAgICA8cmRmOkFsdD4KICAgICAgICA8cmRmOmxpIHhtbDpsYW5nPSJ4LWRlZmF1bHQiPklubmVyIFZlcnRpY2FsIE91dGxpbmVzPC9yZGY6bGk+CiAgICAgICA8L3JkZjpBbHQ+CiAgICAgIDwvZGM6dGl0bGU+CiAgICAgIDwvcmRmOkRlc2NyaXB0aW9uPgogICAgIDwvcmRmOmxpPgogICAgIDxyZGY6bGk+CiAgICAgIDxyZGY6RGVzY3JpcHRpb24KICAgICAgIGRjOmZvcm1hdD0iYXBwbGljYXRpb24vdm5kLmFkb2JlLmFmdGVyZWZmZWN0cy5sYXllciIKICAgICAgIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NTg0OWNjZDUtZmMzZS00MGIyLTlhMmQtNmUwNWMxNTg0OWI2Ij4KICAgICAgPGRjOnRpdGxlPgogICAgICAgPHJkZjpBbHQ+CiAgICAgICAgPHJkZjpsaSB4bWw6bGFuZz0ieC1kZWZhdWx0Ij5XaGl0ZSBTb2xpZCAxPC9yZGY6bGk+CiAgICAgICA8L3JkZjpBbHQ+CiAgICAgIDwvZGM6dGl0bGU+CiAgICAgIDwvcmRmOkRlc2NyaXB0aW9uPgogICAgIDwvcmRmOmxpPgogICAgIDxyZGY6bGk+CiAgICAgIDxyZGY6RGVzY3JpcHRpb24KICAgICAgIGRjOmZvcm1hdD0iYXBwbGljYXRpb24vdm5kLmFkb2JlLmFmdGVyZWZmZWN0cy5sYXllciIKICAgICAgIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NWExZDYxNjMtODFiOS00YWE4LWEwYzYtOGJjOGIwYWFmN2VmIj4KICAgICAgPGRjOnRpdGxlPgogICAgICAgPHJkZjpBbHQ+CiAgICAgICAgPHJkZjpsaSB4bWw6bGFuZz0ieC1kZWZhdWx0Ij5Ub3AgUklnaHQgT3V0bGluZXM8L3JkZjpsaT4KICAgICAgIDwvcmRmOkFsdD4KICAgICAgPC9kYzp0aXRsZT4KICAgICAgPC9yZGY6RGVzY3JpcHRpb24+CiAgICAgPC9yZGY6bGk+CiAgICAgPHJkZjpsaT4KICAgICAgPHJkZjpEZXNjcmlwdGlvbgogICAgICAgZGM6Zm9ybWF0PSJhcHBsaWNhdGlvbi92bmQuYWRvYmUuYWZ0ZXJlZmZlY3RzLmxheWVyIgogICAgICAgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDo2MDk5ZWNmNC1lMGMyLTQzZjYtYWJjMi0yZDI5NzY1MTRiOTgiPgogICAgICA8ZGM6dGl0bGU+CiAgICAgICA8cmRmOkFsdD4KICAgICAgICA8cmRmOmxpIHhtbDpsYW5nPSJ4LWRlZmF1bHQiPlRvcCBMZWZ0IE91dGxpbmVzPC9yZGY6bGk+CiAgICAgICA8L3JkZjpBbHQ+CiAgICAgIDwvZGM6dGl0bGU+CiAgICAgIDwvcmRmOkRlc2NyaXB0aW9uPgogICAgIDwvcmRmOmxpPgogICAgIDxyZGY6bGk+CiAgICAgIDxyZGY6RGVzY3JpcHRpb24KICAgICAgIGRjOmZvcm1hdD0iYXBwbGljYXRpb24vdm5kLmFkb2JlLmFmdGVyZWZmZWN0cy5sYXllciIKICAgICAgIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NjdjMGEyOWItOWIyNy00MjAwLTk3ODEtZGIxZTRiNTMxYTNjIj4KICAgICAgPGRjOnRpdGxlPgogICAgICAgPHJkZjpBbHQ+CiAgICAgICAgPHJkZjpsaSB4bWw6bGFuZz0ieC1kZWZhdWx0Ij5NaWRkbGUgQm90dG9tIE91dGxpbmVzPC9yZGY6bGk+CiAgICAgICA8L3JkZjpBbHQ+CiAgICAgIDwvZGM6dGl0bGU+CiAgICAgIDwvcmRmOkRlc2NyaXB0aW9uPgogICAgIDwvcmRmOmxpPgogICAgIDxyZGY6bGk+CiAgICAgIDxyZGY6RGVzY3JpcHRpb24KICAgICAgIGRjOmZvcm1hdD0iYXBwbGljYXRpb24vdm5kLmFkb2JlLmFmdGVyZWZmZWN0cy5sYXllciIKICAgICAgIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NmZjN2NjZTgtNWUwZC00YzhkLWEyZDQtNmI0MWMyZjJhNDQ1Ij4KICAgICAgPGRjOnRpdGxlPgogICAgICAgPHJkZjpBbHQ+CiAgICAgICAgPHJkZjpsaSB4bWw6bGFuZz0ieC1kZWZhdWx0Ij5MZWZ0IDIgT3V0bGluZXM8L3JkZjpsaT4KICAgICAgIDwvcmRmOkFsdD4KICAgICAgPC9kYzp0aXRsZT4KICAgICAgPC9yZGY6RGVzY3JpcHRpb24+CiAgICAgPC9yZGY6bGk+CiAgICAgPHJkZjpsaT4KICAgICAgPHJkZjpEZXNjcmlwdGlvbgogICAgICAgZGM6Zm9ybWF0PSJhcHBsaWNhdGlvbi92bmQuYWRvYmUuYWZ0ZXJlZmZlY3RzLmxheWVyIgogICAgICAgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDo3OTkzYzczYS0wMzg4LTRhMTMtYmU2Yi02MTZiOWU3YmE1OGUiPgogICAgICA8ZGM6dGl0bGU+CiAgICAgICA8cmRmOkFsdD4KICAgICAgICA8cmRmOmxpIHhtbDpsYW5nPSJ4LWRlZmF1bHQiPk1pZGRsZSBCb3R0b20gTGVmdCBPdXRsaW5lczwvcmRmOmxpPgogICAgICAgPC9yZGY6QWx0PgogICAgICA8L2RjOnRpdGxlPgogICAgICA8L3JkZjpEZXNjcmlwdGlvbj4KICAgICA8L3JkZjpsaT4KICAgICA8cmRmOmxpPgogICAgICA8cmRmOkRlc2NyaXB0aW9uCiAgICAgICBkYzpmb3JtYXQ9ImFwcGxpY2F0aW9uL3ZuZC5hZG9iZS5hZnRlcmVmZmVjdHMubGF5ZXIiCiAgICAgICB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjc5YTc2OWJkLTViMDktNDFhZS1iNjY5LTJhODkyZmFjYzQ3MSI+CiAgICAgIDxkYzp0aXRsZT4KICAgICAgIDxyZGY6QWx0PgogICAgICAgIDxyZGY6bGkgeG1sOmxhbmc9IngtZGVmYXVsdCI+Qm90dG9tIFJpZ2h0IE91dGxpbmVzPC9yZGY6bGk+CiAgICAgICA8L3JkZjpBbHQ+CiAgICAgIDwvZGM6dGl0bGU+CiAgICAgIDwvcmRmOkRlc2NyaXB0aW9uPgogICAgIDwvcmRmOmxpPgogICAgIDxyZGY6bGk+CiAgICAgIDxyZGY6RGVzY3JpcHRpb24KICAgICAgIGRjOmZvcm1hdD0iYXBwbGljYXRpb24vdm5kLmFkb2JlLmFmdGVyZWZmZWN0cy5sYXllciIKICAgICAgIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6N2NhZTJjY2MtNjY0Yy00MGYxLTk3NjAtYTEwZGMyNmM5ZjE5Ij4KICAgICAgPGRjOnRpdGxlPgogICAgICAgPHJkZjpBbHQ+CiAgICAgICAgPHJkZjpsaSB4bWw6bGFuZz0ieC1kZWZhdWx0Ij5Jbm5lciBDZW50ZXIgSG9yaXpvbnRhbCBPdXRsaW5lczwvcmRmOmxpPgogICAgICAgPC9yZGY6QWx0PgogICAgICA8L2RjOnRpdGxlPgogICAgICA8L3JkZjpEZXNjcmlwdGlvbj4KICAgICA8L3JkZjpsaT4KICAgICA8cmRmOmxpPgogICAgICA8cmRmOkRlc2NyaXB0aW9uCiAgICAgICBkYzpmb3JtYXQ9ImFwcGxpY2F0aW9uL3ZuZC5hZG9iZS5hZnRlcmVmZmVjdHMubGF5ZXIiCiAgICAgICB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjg3MDJkMGZiLTIwNWQtNGRjMi05ZTU0LTAxZTRjODJjMzQ4YSI+CiAgICAgIDxkYzp0aXRsZT4KICAgICAgIDxyZGY6QWx0PgogICAgICAgIDxyZGY6bGkgeG1sOmxhbmc9IngtZGVmYXVsdCI+TWlkZGxlIEJvdHRvbSBMZWZ0IE91dGxpbmVzPC9yZGY6bGk+CiAgICAgICA8L3JkZjpBbHQ+CiAgICAgIDwvZGM6dGl0bGU+CiAgICAgIDwvcmRmOkRlc2NyaXB0aW9uPgogICAgIDwvcmRmOmxpPgogICAgIDxyZGY6bGk+CiAgICAgIDxyZGY6RGVzY3JpcHRpb24KICAgICAgIGRjOmZvcm1hdD0iYXBwbGljYXRpb24vdm5kLmFkb2JlLmFmdGVyZWZmZWN0cy5sYXllciIKICAgICAgIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6ODhiZTk5Y2ItYWQxOS00MTAwLWExMDctNjdiMTAyNmEyZGU5Ij4KICAgICAgPGRjOnRpdGxlPgogICAgICAgPHJkZjpBbHQ+CiAgICAgICAgPHJkZjpsaSB4bWw6bGFuZz0ieC1kZWZhdWx0Ij5Jbm5lciBEaWFnb25hbCBMZWZ0IE91dGxpbmVzPC9yZGY6bGk+CiAgICAgICA8L3JkZjpBbHQ+CiAgICAgIDwvZGM6dGl0bGU+CiAgICAgIDwvcmRmOkRlc2NyaXB0aW9uPgogICAgIDwvcmRmOmxpPgogICAgIDxyZGY6bGk+CiAgICAgIDxyZGY6RGVzY3JpcHRpb24KICAgICAgIGRjOmZvcm1hdD0iYXBwbGljYXRpb24vdm5kLmFkb2JlLmFmdGVyZWZmZWN0cy5sYXllciIKICAgICAgIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6ODlkNTg1NWMtMjRhYi00NDlmLTllYmYtYTBkY2JmMTk3YTFmIj4KICAgICAgPGRjOnRpdGxlPgogICAgICAgPHJkZjpBbHQ+CiAgICAgICAgPHJkZjpsaSB4bWw6bGFuZz0ieC1kZWZhdWx0Ij5NaWRkbGUgVG9wIExlZnQgT3V0bGluZXM8L3JkZjpsaT4KICAgICAgIDwvcmRmOkFsdD4KICAgICAgPC9kYzp0aXRsZT4KICAgICAgPC9yZGY6RGVzY3JpcHRpb24+CiAgICAgPC9yZGY6bGk+CiAgICAgPHJkZjpsaT4KICAgICAgPHJkZjpEZXNjcmlwdGlvbgogICAgICAgZGM6Zm9ybWF0PSJhcHBsaWNhdGlvbi92bmQuYWRvYmUuYWZ0ZXJlZmZlY3RzLmxheWVyIgogICAgICAgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDo5NGY3NGViNC02MmU4LTQzYjEtYjY2MS02NjlhMjliYTk1ZmMiPgogICAgICA8ZGM6dGl0bGU+CiAgICAgICA8cmRmOkFsdD4KICAgICAgICA8cmRmOmxpIHhtbDpsYW5nPSJ4LWRlZmF1bHQiPkxpbmUtMSBPdXRsaW5lczwvcmRmOmxpPgogICAgICAgPC9yZGY6QWx0PgogICAgICA8L2RjOnRpdGxlPgogICAgICA8L3JkZjpEZXNjcmlwdGlvbj4KICAgICA8L3JkZjpsaT4KICAgICA8cmRmOmxpPgogICAgICA8cmRmOkRlc2NyaXB0aW9uCiAgICAgICBkYzpmb3JtYXQ9ImFwcGxpY2F0aW9uL3ZuZC5hZG9iZS5hZnRlcmVmZmVjdHMubGF5ZXIiCiAgICAgICB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjk2YzRjN2VmLTQwZDgtNGJiNC1iYzFlLWI4MGQ3NjU3YTE2OSI+CiAgICAgIDxkYzp0aXRsZT4KICAgICAgIDxyZGY6QWx0PgogICAgICAgIDxyZGY6bGkgeG1sOmxhbmc9IngtZGVmYXVsdCI+TGF5ZXIgMTAgT3V0bGluZXM8L3JkZjpsaT4KICAgICAgIDwvcmRmOkFsdD4KICAgICAgPC9kYzp0aXRsZT4KICAgICAgPC9yZGY6RGVzY3JpcHRpb24+CiAgICAgPC9yZGY6bGk+CiAgICAgPHJkZjpsaT4KICAgICAgPHJkZjpEZXNjcmlwdGlvbgogICAgICAgZGM6Zm9ybWF0PSJhcHBsaWNhdGlvbi92bmQuYWRvYmUuYWZ0ZXJlZmZlY3RzLmxheWVyIgogICAgICAgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDo5ZDBmYzc2NS1lNjQ1LTRjMjMtYjkwOC03MzYwMDBmY2RjNWIiPgogICAgICA8ZGM6dGl0bGU+CiAgICAgICA8cmRmOkFsdD4KICAgICAgICA8cmRmOmxpIHhtbDpsYW5nPSJ4LWRlZmF1bHQiPklubmVyIERpYWdvbmFsIFJpZ2h0IE91dGxpbmVzPC9yZGY6bGk+CiAgICAgICA8L3JkZjpBbHQ+CiAgICAgIDwvZGM6dGl0bGU+CiAgICAgIDwvcmRmOkRlc2NyaXB0aW9uPgogICAgIDwvcmRmOmxpPgogICAgIDxyZGY6bGk+CiAgICAgIDxyZGY6RGVzY3JpcHRpb24KICAgICAgIGRjOmZvcm1hdD0iYXBwbGljYXRpb24vdm5kLmFkb2JlLmFmdGVyZWZmZWN0cy5sYXllciIKICAgICAgIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6OWUwNWMwMGUtZWUyZC00NTVhLThiZjItMmI2ZmFkOTU4YmExIj4KICAgICAgPGRjOnRpdGxlPgogICAgICAgPHJkZjpBbHQ+CiAgICAgICAgPHJkZjpsaSB4bWw6bGFuZz0ieC1kZWZhdWx0Ij5MZWZ0IDIgT3V0bGluZXM8L3JkZjpsaT4KICAgICAgIDwvcmRmOkFsdD4KICAgICAgPC9kYzp0aXRsZT4KICAgICAgPC9yZGY6RGVzY3JpcHRpb24+CiAgICAgPC9yZGY6bGk+CiAgICAgPHJkZjpsaT4KICAgICAgPHJkZjpEZXNjcmlwdGlvbgogICAgICAgZGM6Zm9ybWF0PSJhcHBsaWNhdGlvbi92bmQuYWRvYmUuYWZ0ZXJlZmZlY3RzLmxheWVyIgogICAgICAgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDphMjg4YzZiYS1mNmU2LTQ3MzItODlhYS03OTQ4MzAyODUyZTIiPgogICAgICA8ZGM6dGl0bGU+CiAgICAgICA8cmRmOkFsdD4KICAgICAgICA8cmRmOmxpIHhtbDpsYW5nPSJ4LWRlZmF1bHQiPklubmVyIERpYWdvbmFsIFJpZ2h0IE91dGxpbmVzPC9yZGY6bGk+CiAgICAgICA8L3JkZjpBbHQ+CiAgICAgIDwvZGM6dGl0bGU+CiAgICAgIDwvcmRmOkRlc2NyaXB0aW9uPgogICAgIDwvcmRmOmxpPgogICAgIDxyZGY6bGk+CiAgICAgIDxyZGY6RGVzY3JpcHRpb24KICAgICAgIGRjOmZvcm1hdD0iYXBwbGljYXRpb24vdm5kLmFkb2JlLmFmdGVyZWZmZWN0cy5sYXllciIKICAgICAgIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6YTc3OWU0YjYtM2ZhMC00ZmEwLTkzYjAtOTdiMGJjNjViZTg5Ij4KICAgICAgPGRjOnRpdGxlPgogICAgICAgPHJkZjpBbHQ+CiAgICAgICAgPHJkZjpsaSB4bWw6bGFuZz0ieC1kZWZhdWx0Ij5Jbm5lciBWZXJ0aWNhbCBPdXRsaW5lczwvcmRmOmxpPgogICAgICAgPC9yZGY6QWx0PgogICAgICA8L2RjOnRpdGxlPgogICAgICA8L3JkZjpEZXNjcmlwdGlvbj4KICAgICA8L3JkZjpsaT4KICAgICA8cmRmOmxpPgogICAgICA8cmRmOkRlc2NyaXB0aW9uCiAgICAgICBkYzpmb3JtYXQ9ImFwcGxpY2F0aW9uL3ZuZC5hZG9iZS5hZnRlcmVmZmVjdHMubGF5ZXIiCiAgICAgICB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOmFhNGEzNzhkLTRmZDYtNDVhMy04OTFkLTQ3ZjQ0NGNhNDJkNCI+CiAgICAgIDxkYzp0aXRsZT4KICAgICAgIDxyZGY6QWx0PgogICAgICAgIDxyZGY6bGkgeG1sOmxhbmc9IngtZGVmYXVsdCI+TWlkZGxlIFRvcCBMZWZ0IE91dGxpbmVzPC9yZGY6bGk+CiAgICAgICA8L3JkZjpBbHQ+CiAgICAgIDwvZGM6dGl0bGU+CiAgICAgIDwvcmRmOkRlc2NyaXB0aW9uPgogICAgIDwvcmRmOmxpPgogICAgIDxyZGY6bGk+CiAgICAgIDxyZGY6RGVzY3JpcHRpb24KICAgICAgIGRjOmZvcm1hdD0iYXBwbGljYXRpb24vdm5kLmFkb2JlLmFmdGVyZWZmZWN0cy5sYXllciIKICAgICAgIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6YWViMDQ3NmUtMDc5Ni00ZjRjLWE0YzMtNzU3ZTA0NWJjNzlkIj4KICAgICAgPGRjOnRpdGxlPgogICAgICAgPHJkZjpBbHQ+CiAgICAgICAgPHJkZjpsaSB4bWw6bGFuZz0ieC1kZWZhdWx0Ij5QcmUtY29tcCAxPC9yZGY6bGk+CiAgICAgICA8L3JkZjpBbHQ+CiAgICAgIDwvZGM6dGl0bGU+CiAgICAgIDx4bXBNTTpJbmdyZWRpZW50cz4KICAgICAgIDxyZGY6QmFnPgogICAgICAgIDxyZGY6bGkKICAgICAgICAgc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDowODUwOTNhMS1hZjI3LTRiYzgtOWVkNy1iZWZkODY5ODgxZGIiCiAgICAgICAgIHN0UmVmOmZyb21QYXJ0PSJ0aW1lOjBkNDcwODcwNDAwMDAwZjI1NDAxNjAwMDAwMCIKICAgICAgICAgc3RSZWY6dG9QYXJ0PSJ0aW1lOjBkNDcwODcwNDAwMDAwZjI1NDAxNjAwMDAwMCIKICAgICAgICAgc3RSZWY6bWFza01hcmtlcnM9Ik5vbmUiLz4KICAgICAgIDwvcmRmOkJhZz4KICAgICAgPC94bXBNTTpJbmdyZWRpZW50cz4KICAgICAgPC9yZGY6RGVzY3JpcHRpb24+CiAgICAgPC9yZGY6bGk+CiAgICAgPHJkZjpsaT4KICAgICAgPHJkZjpEZXNjcmlwdGlvbgogICAgICAgZGM6Zm9ybWF0PSJhcHBsaWNhdGlvbi92bmQuYWRvYmUuYWZ0ZXJlZmZlY3RzLmxheWVyIgogICAgICAgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDpiMDQwNTYyYS1lZjZiLTQ1ZjktYjUyYi02NWZjOGNkOGJlZDkiPgogICAgICA8ZGM6dGl0bGU+CiAgICAgICA8cmRmOkFsdD4KICAgICAgICA8cmRmOmxpIHhtbDpsYW5nPSJ4LWRlZmF1bHQiPk1pZGRsZSBUb3AgT3V0bGluZXM8L3JkZjpsaT4KICAgICAgIDwvcmRmOkFsdD4KICAgICAgPC9kYzp0aXRsZT4KICAgICAgPC9yZGY6RGVzY3JpcHRpb24+CiAgICAgPC9yZGY6bGk+CiAgICAgPHJkZjpsaT4KICAgICAgPHJkZjpEZXNjcmlwdGlvbgogICAgICAgZGM6Zm9ybWF0PSJhcHBsaWNhdGlvbi92bmQuYWRvYmUuYWZ0ZXJlZmZlY3RzLmxheWVyIgogICAgICAgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDpiMGE3M2I5Yy1lNjYzLTQ0ZmEtODJmZi1mZWYzMDE0YmE2YmEiPgogICAgICA8ZGM6dGl0bGU+CiAgICAgICA8cmRmOkFsdD4KICAgICAgICA8cmRmOmxpIHhtbDpsYW5nPSJ4LWRlZmF1bHQiPlByZS1jb21wIDE8L3JkZjpsaT4KICAgICAgIDwvcmRmOkFsdD4KICAgICAgPC9kYzp0aXRsZT4KICAgICAgPHhtcE1NOkluZ3JlZGllbnRzPgogICAgICAgPHJkZjpCYWc+CiAgICAgICAgPHJkZjpsaQogICAgICAgICBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjA4NTA5M2ExLWFmMjctNGJjOC05ZWQ3LWJlZmQ4Njk4ODFkYiIKICAgICAgICAgc3RSZWY6ZnJvbVBhcnQ9InRpbWU6MGQ0NzA4NzA0MDAwMDBmMjU0MDE2MDAwMDAwIgogICAgICAgICBzdFJlZjp0b1BhcnQ9InRpbWU6MGQ0NzA4NzA0MDAwMDBmMjU0MDE2MDAwMDAwIgogICAgICAgICBzdFJlZjptYXNrTWFya2Vycz0iTm9uZSIvPgogICAgICAgPC9yZGY6QmFnPgogICAgICA8L3htcE1NOkluZ3JlZGllbnRzPgogICAgICA8L3JkZjpEZXNjcmlwdGlvbj4KICAgICA8L3JkZjpsaT4KICAgICA8cmRmOmxpPgogICAgICA8cmRmOkRlc2NyaXB0aW9uCiAgICAgICBkYzpmb3JtYXQ9ImFwcGxpY2F0aW9uL3ZuZC5hZG9iZS5hZnRlcmVmZmVjdHMubGF5ZXIiCiAgICAgICB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOmI2NDEwYTMwLTRiMTUtNDc2Zi1iNzViLWZhYmE3ZjcxZWZmMiI+CiAgICAgIDxkYzp0aXRsZT4KICAgICAgIDxyZGY6QWx0PgogICAgICAgIDxyZGY6bGkgeG1sOmxhbmc9IngtZGVmYXVsdCI+VG9wIFJJZ2h0IE91dGxpbmVzPC9yZGY6bGk+CiAgICAgICA8L3JkZjpBbHQ+CiAgICAgIDwvZGM6dGl0bGU+CiAgICAgIDwvcmRmOkRlc2NyaXB0aW9uPgogICAgIDwvcmRmOmxpPgogICAgIDxyZGY6bGk+CiAgICAgIDxyZGY6RGVzY3JpcHRpb24KICAgICAgIGRjOmZvcm1hdD0iYXBwbGljYXRpb24vdm5kLmFkb2JlLmFmdGVyZWZmZWN0cy5sYXllciIKICAgICAgIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6Yjc0Zjg5MzQtMGViYS00YmJjLTg2OTMtZWUwMjJmNWVlMmJjIj4KICAgICAgPGRjOnRpdGxlPgogICAgICAgPHJkZjpBbHQ+CiAgICAgICAgPHJkZjpsaSB4bWw6bGFuZz0ieC1kZWZhdWx0Ij5MYXllciAxMCBPdXRsaW5lczwvcmRmOmxpPgogICAgICAgPC9yZGY6QWx0PgogICAgICA8L2RjOnRpdGxlPgogICAgICA8L3JkZjpEZXNjcmlwdGlvbj4KICAgICA8L3JkZjpsaT4KICAgICA8cmRmOmxpPgogICAgICA8cmRmOkRlc2NyaXB0aW9uCiAgICAgICBkYzpmb3JtYXQ9ImFwcGxpY2F0aW9uL3ZuZC5hZG9iZS5hZnRlcmVmZmVjdHMubGF5ZXIiCiAgICAgICB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOmM1YjgwY2Q0LTMxOWYtNGFmZS1iYzRjLTczNGQxOWI3YTdiMSI+CiAgICAgIDxkYzp0aXRsZT4KICAgICAgIDxyZGY6QWx0PgogICAgICAgIDxyZGY6bGkgeG1sOmxhbmc9IngtZGVmYXVsdCI+UHJlLWNvbXAgMjwvcmRmOmxpPgogICAgICAgPC9yZGY6QWx0PgogICAgICA8L2RjOnRpdGxlPgogICAgICA8eG1wTU06SW5ncmVkaWVudHM+CiAgICAgICA8cmRmOkJhZz4KICAgICAgICA8cmRmOmxpCiAgICAgICAgIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6NTYxYzdmYWYtOWU3My00NDM4LWIwMGYtZTkwZWQ3NDA1NjI4IgogICAgICAgICBzdFJlZjpmcm9tUGFydD0idGltZTowZDczNDU1NzgyNDAwMGYyNTQwMTYwMDAwMDAiCiAgICAgICAgIHN0UmVmOnRvUGFydD0idGltZTowZDczNDU1NzgyNDAwMGYyNTQwMTYwMDAwMDAiCiAgICAgICAgIHN0UmVmOm1hc2tNYXJrZXJzPSJOb25lIi8+CiAgICAgICA8L3JkZjpCYWc+CiAgICAgIDwveG1wTU06SW5ncmVkaWVudHM+CiAgICAgIDwvcmRmOkRlc2NyaXB0aW9uPgogICAgIDwvcmRmOmxpPgogICAgIDxyZGY6bGk+CiAgICAgIDxyZGY6RGVzY3JpcHRpb24KICAgICAgIGRjOmZvcm1hdD0iYXBwbGljYXRpb24vdm5kLmFkb2JlLmFmdGVyZWZmZWN0cy5sYXllciIKICAgICAgIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6YzY4ZDIzZTgtNWUxMC00MzlmLTk0NTEtOWIzMjcwODIyMjRmIj4KICAgICAgPGRjOnRpdGxlPgogICAgICAgPHJkZjpBbHQ+CiAgICAgICAgPHJkZjpsaSB4bWw6bGFuZz0ieC1kZWZhdWx0Ij5QcmUtY29tcCAyPC9yZGY6bGk+CiAgICAgICA8L3JkZjpBbHQ+CiAgICAgIDwvZGM6dGl0bGU+CiAgICAgIDx4bXBNTTpJbmdyZWRpZW50cz4KICAgICAgIDxyZGY6QmFnPgogICAgICAgIDxyZGY6bGkKICAgICAgICAgc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo1NjFjN2ZhZi05ZTczLTQ0MzgtYjAwZi1lOTBlZDc0MDU2MjgiCiAgICAgICAgIHN0UmVmOmZyb21QYXJ0PSJ0aW1lOjBkOTA0MDcxMTY4MDAwZjI1NDAxNjAwMDAwMCIKICAgICAgICAgc3RSZWY6dG9QYXJ0PSJ0aW1lOjBkOTA0MDcxMTY4MDAwZjI1NDAxNjAwMDAwMCIKICAgICAgICAgc3RSZWY6bWFza01hcmtlcnM9Ik5vbmUiLz4KICAgICAgIDwvcmRmOkJhZz4KICAgICAgPC94bXBNTTpJbmdyZWRpZW50cz4KICAgICAgPC9yZGY6RGVzY3JpcHRpb24+CiAgICAgPC9yZGY6bGk+CiAgICAgPHJkZjpsaT4KICAgICAgPHJkZjpEZXNjcmlwdGlvbgogICAgICAgZGM6Zm9ybWF0PSJhcHBsaWNhdGlvbi92bmQuYWRvYmUuYWZ0ZXJlZmZlY3RzLmxheWVyIgogICAgICAgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDpjOTVlY2ZiZC0yZWQ1LTQ4NGYtYjc5OS0xNmZhMjM4NmE5MWIiPgogICAgICA8ZGM6dGl0bGU+CiAgICAgICA8cmRmOkFsdD4KICAgICAgICA8cmRmOmxpIHhtbDpsYW5nPSJ4LWRlZmF1bHQiPk1pZGRsZSBMZWZ0IE91dGxpbmVzPC9yZGY6bGk+CiAgICAgICA8L3JkZjpBbHQ+CiAgICAgIDwvZGM6dGl0bGU+CiAgICAgIDwvcmRmOkRlc2NyaXB0aW9uPgogICAgIDwvcmRmOmxpPgogICAgIDxyZGY6bGk+CiAgICAgIDxyZGY6RGVzY3JpcHRpb24KICAgICAgIGRjOmZvcm1hdD0iYXBwbGljYXRpb24vdm5kLmFkb2JlLmFmdGVyZWZmZWN0cy5sYXllciIKICAgICAgIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6Y2VkZGZiZDEtZmU3MS00YmJiLTljY2UtNDM0NTlkMjhjYWUzIj4KICAgICAgPGRjOnRpdGxlPgogICAgICAgPHJkZjpBbHQ+CiAgICAgICAgPHJkZjpsaSB4bWw6bGFuZz0ieC1kZWZhdWx0Ij5NaWRkbGUgUmlnaHQgT3V0bGluZXM8L3JkZjpsaT4KICAgICAgIDwvcmRmOkFsdD4KICAgICAgPC9kYzp0aXRsZT4KICAgICAgPC9yZGY6RGVzY3JpcHRpb24+CiAgICAgPC9yZGY6bGk+CiAgICAgPHJkZjpsaT4KICAgICAgPHJkZjpEZXNjcmlwdGlvbgogICAgICAgZGM6Zm9ybWF0PSJhcHBsaWNhdGlvbi92bmQuYWRvYmUuYWZ0ZXJlZmZlY3RzLmxheWVyIgogICAgICAgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDpjZjZkMDk5NS02NmI1LTQ1MDYtOWM4YS0wNmUzMjU5YjIzOTUiPgogICAgICA8ZGM6dGl0bGU+CiAgICAgICA8cmRmOkFsdD4KICAgICAgICA8cmRmOmxpIHhtbDpsYW5nPSJ4LWRlZmF1bHQiPk1pZGRsZSBSaWdodCBPdXRsaW5lczwvcmRmOmxpPgogICAgICAgPC9yZGY6QWx0PgogICAgICA8L2RjOnRpdGxlPgogICAgICA8L3JkZjpEZXNjcmlwdGlvbj4KICAgICA8L3JkZjpsaT4KICAgICA8cmRmOmxpPgogICAgICA8cmRmOkRlc2NyaXB0aW9uCiAgICAgICBkYzpmb3JtYXQ9ImFwcGxpY2F0aW9uL3ZuZC5hZG9iZS5hZnRlcmVmZmVjdHMubGF5ZXIiCiAgICAgICB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOmQ5ZWZkM2QxLWZhYjUtNDU0Ny05YTA3LTE1ZTcwYTE1NTkwMyI+CiAgICAgIDxkYzp0aXRsZT4KICAgICAgIDxyZGY6QWx0PgogICAgICAgIDxyZGY6bGkgeG1sOmxhbmc9IngtZGVmYXVsdCI+TWlkZGxlIFRvcCBSaWdodCBPdXRsaW5lczwvcmRmOmxpPgogICAgICAgPC9yZGY6QWx0PgogICAgICA8L2RjOnRpdGxlPgogICAgICA8L3JkZjpEZXNjcmlwdGlvbj4KICAgICA8L3JkZjpsaT4KICAgICA8cmRmOmxpPgogICAgICA8cmRmOkRlc2NyaXB0aW9uCiAgICAgICBkYzpmb3JtYXQ9ImFwcGxpY2F0aW9uL3ZuZC5hZG9iZS5hZnRlcmVmZmVjdHMubGF5ZXIiCiAgICAgICB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOmRhYjdmZDdkLWZlMWItNGZjMi1iZmUxLWI4OGM1MTU0ZmUyNSI+CiAgICAgIDxkYzp0aXRsZT4KICAgICAgIDxyZGY6QWx0PgogICAgICAgIDxyZGY6bGkgeG1sOmxhbmc9IngtZGVmYXVsdCI+VG9wIExlZnQgT3V0bGluZXM8L3JkZjpsaT4KICAgICAgIDwvcmRmOkFsdD4KICAgICAgPC9kYzp0aXRsZT4KICAgICAgPC9yZGY6RGVzY3JpcHRpb24+CiAgICAgPC9yZGY6bGk+CiAgICAgPHJkZjpsaT4KICAgICAgPHJkZjpEZXNjcmlwdGlvbgogICAgICAgZGM6Zm9ybWF0PSJhcHBsaWNhdGlvbi92bmQuYWRvYmUuYWZ0ZXJlZmZlY3RzLmxheWVyIgogICAgICAgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDplMjA3MGQxNS04MGZlLTRjMDYtYTUwNy1jMGZlYjg1ODVmZGYiPgogICAgICA8ZGM6dGl0bGU+CiAgICAgICA8cmRmOkFsdD4KICAgICAgICA8cmRmOmxpIHhtbDpsYW5nPSJ4LWRlZmF1bHQiPkJvdHRvbSBSaWdodCBPdXRsaW5lczwvcmRmOmxpPgogICAgICAgPC9yZGY6QWx0PgogICAgICA8L2RjOnRpdGxlPgogICAgICA8L3JkZjpEZXNjcmlwdGlvbj4KICAgICA8L3JkZjpsaT4KICAgICA8cmRmOmxpPgogICAgICA8cmRmOkRlc2NyaXB0aW9uCiAgICAgICBkYzpmb3JtYXQ9ImFwcGxpY2F0aW9uL3ZuZC5hZG9iZS5hZnRlcmVmZmVjdHMubGF5ZXIiCiAgICAgICB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOmZiNWRkN2VkLTA1ZjYtNDI3OS05ZGU5LTg5YzUyZjA4NGEwMiI+CiAgICAgIDxkYzp0aXRsZT4KICAgICAgIDxyZGY6QWx0PgogICAgICAgIDxyZGY6bGkgeG1sOmxhbmc9IngtZGVmYXVsdCI+TWlkZGxlIExlZnQgT3V0bGluZXM8L3JkZjpsaT4KICAgICAgIDwvcmRmOkFsdD4KICAgICAgPC9kYzp0aXRsZT4KICAgICAgPC9yZGY6RGVzY3JpcHRpb24+CiAgICAgPC9yZGY6bGk+CiAgICAgPHJkZjpsaT4KICAgICAgPHJkZjpEZXNjcmlwdGlvbgogICAgICAgZGM6Zm9ybWF0PSJhcHBsaWNhdGlvbi92bmQuYWRvYmUuYWZ0ZXJlZmZlY3RzLmxheWVyIgogICAgICAgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDpmZGU3Nzc1Ny0wMTJhLTQxOGQtYjQ0MS04M2QzMWNiMTE1M2EiPgogICAgICA8ZGM6dGl0bGU+CiAgICAgICA8cmRmOkFsdD4KICAgICAgICA8cmRmOmxpIHhtbDpsYW5nPSJ4LWRlZmF1bHQiPkxpbmUtMSBPdXRsaW5lczwvcmRmOmxpPgogICAgICAgPC9yZGY6QWx0PgogICAgICA8L2RjOnRpdGxlPgogICAgICA8L3JkZjpEZXNjcmlwdGlvbj4KICAgICA8L3JkZjpsaT4KICAgIDwvcmRmOkJhZz4KICAgPC94bXBNTTpQYW50cnk+CiAgIDx4bXBETTp2aWRlb0ZyYW1lU2l6ZQogICAgc3REaW06dz0iMTUwIgogICAgc3REaW06aD0iMTUwIgogICAgc3REaW06dW5pdD0icGl4ZWwiLz4KICAgPHhtcERNOmR1cmF0aW9uCiAgICB4bXBETTp2YWx1ZT0iODAiCiAgICB4bXBETTpzY2FsZT0iMS8yNSIvPgogICA8eG1wRE06c3RhcnRUaW1lY29kZQogICAgeG1wRE06dGltZUZvcm1hdD0iMjVUaW1lY29kZSIKICAgIHhtcERNOnRpbWVWYWx1ZT0iMDA6MDA6MDA6MDciLz4KICAgPHhtcERNOmFsdFRpbWVjb2RlCiAgICB4bXBETTp0aW1lVmFsdWU9IjAwOjAwOjAwOjA3IgogICAgeG1wRE06dGltZUZvcm1hdD0iMjVUaW1lY29kZSIvPgogIDwvcmRmOkRlc2NyaXB0aW9uPgogPC9yZGY6UkRGPgo8L3g6eG1wbWV0YT4KPD94cGFja2V0IGVuZD0iciI/PgH//v38+/r5+Pf29fTz8vHw7+7t7Ovq6ejn5uXk4+Lh4N/e3dzb2tnY19bV1NPS0dDPzs3My8rJyMfGxcTDwsHAv769vLu6ubi3trW0s7KxsK+urayrqqmop6alpKOioaCfnp2cm5qZmJeWlZSTkpGQj46NjIuKiYiHhoWEg4KBgH9+fXx7enl4d3Z1dHNycXBvbm1sa2ppaGdmZWRjYmFgX15dXFtaWVhXVlVUU1JRUE9OTUxLSklIR0ZFRENCQUA/Pj08Ozo5ODc2NTQzMjEwLy4tLCsqKSgnJiUkIyIhIB8eHRwbGhkYFxYVFBMSERAPDg0MCwoJCAcGBQQDAgEAADs=";
function _EMOTION_STRINGIFIED_CSS_ERROR__$5() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const StyledConnectionStatus = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "en6cib67"
} : {
  target: "en6cib67",
  label: "StyledConnectionStatus"
})(({
  theme: o
}) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: o.colors.gray60
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledConnectionStatusLabel = /* @__PURE__ */ createStyled("label", process.env.NODE_ENV === "production" ? {
  target: "en6cib66"
} : {
  target: "en6cib66",
  label: "StyledConnectionStatusLabel"
})(({
  theme: o
}) => ({
  fontSize: o.fontSizes.sm,
  color: o.colors.gray60,
  textTransform: "uppercase",
  marginTop: o.spacing.none,
  marginRight: o.spacing.lg,
  marginBottom: o.spacing.none,
  marginLeft: o.spacing.sm,
  whiteSpace: "nowrap",
  maxWidth: o.sizes.appStatusMaxWidth,
  lineHeight: o.lineHeights.none
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledAppStatus = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "en6cib65"
} : {
  target: "en6cib65",
  label: "StyledAppStatus"
})(({
  theme: o
}) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  borderRadius: o.radii.md,
  margin: `0 ${o.spacing.sm} 0 0`,
  paddingLeft: o.spacing.sm,
  height: o.sizes.appRunningMen
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledAppStatusLabel = /* @__PURE__ */ createStyled("label", process.env.NODE_ENV === "production" ? {
  target: "en6cib64"
} : {
  target: "en6cib64",
  label: "StyledAppStatusLabel"
})(({
  isPrompt: o,
  theme: E
}) => ({
  fontSize: E.fontSizes.sm,
  color: o ? E.colors.bodyText : E.colors.gray60,
  textTransform: o ? "none" : "uppercase",
  margin: `0 0 0 ${E.spacing.sm}`,
  whiteSpace: "nowrap",
  maxWidth: E.sizes.appStatusMaxWidth,
  borderRadius: o ? E.radii.md : void 0
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledAppButtonContainer = /* @__PURE__ */ createStyled("span", process.env.NODE_ENV === "production" ? {
  target: "en6cib63"
} : {
  target: "en6cib63",
  label: "StyledAppButtonContainer"
})(({
  theme: o
}) => ({
  marginLeft: o.spacing.md,
  whiteSpace: "nowrap",
  color: o.colors.bodyText
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2FwcC9zcmMvY29tcG9uZW50cy9TdGF0dXNXaWRnZXQvc3R5bGVkLWNvbXBvbmVudHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBNEV3QyIsImZpbGUiOiIvaG9tZS9ydW5uZXIvd29yay9zdGxpdGUvc3RsaXRlL3N0cmVhbWxpdC9mcm9udGVuZC9hcHAvc3JjL2NvbXBvbmVudHMvU3RhdHVzV2lkZ2V0L3N0eWxlZC1jb21wb25lbnRzLnRzIiwic291cmNlc0NvbnRlbnQiOlsiLyoqXG4gKiBDb3B5cmlnaHQgKGMpIFN0cmVhbWxpdCBJbmMuICgyMDE4LTIwMjIpIFNub3dmbGFrZSBJbmMuICgyMDIyLTIwMjUpXG4gKlxuICogTGljZW5zZWQgdW5kZXIgdGhlIEFwYWNoZSBMaWNlbnNlLCBWZXJzaW9uIDIuMCAodGhlIFwiTGljZW5zZVwiKTtcbiAqIHlvdSBtYXkgbm90IHVzZSB0aGlzIGZpbGUgZXhjZXB0IGluIGNvbXBsaWFuY2Ugd2l0aCB0aGUgTGljZW5zZS5cbiAqIFlvdSBtYXkgb2J0YWluIGEgY29weSBvZiB0aGUgTGljZW5zZSBhdFxuICpcbiAqICAgICBodHRwOi8vd3d3LmFwYWNoZS5vcmcvbGljZW5zZXMvTElDRU5TRS0yLjBcbiAqXG4gKiBVbmxlc3MgcmVxdWlyZWQgYnkgYXBwbGljYWJsZSBsYXcgb3IgYWdyZWVkIHRvIGluIHdyaXRpbmcsIHNvZnR3YXJlXG4gKiBkaXN0cmlidXRlZCB1bmRlciB0aGUgTGljZW5zZSBpcyBkaXN0cmlidXRlZCBvbiBhbiBcIkFTIElTXCIgQkFTSVMsXG4gKiBXSVRIT1VUIFdBUlJBTlRJRVMgT1IgQ09ORElUSU9OUyBPRiBBTlkgS0lORCwgZWl0aGVyIGV4cHJlc3Mgb3IgaW1wbGllZC5cbiAqIFNlZSB0aGUgTGljZW5zZSBmb3IgdGhlIHNwZWNpZmljIGxhbmd1YWdlIGdvdmVybmluZyBwZXJtaXNzaW9ucyBhbmRcbiAqIGxpbWl0YXRpb25zIHVuZGVyIHRoZSBMaWNlbnNlLlxuICovXG5cbmltcG9ydCBzdHlsZWQgZnJvbSBcIkBlbW90aW9uL3N0eWxlZFwiXG5cbi8qXG4gIFwiQ29ubmVjdGlvblN0YXR1c1wiIHN0eWxlcyBhcmUgdXNlZCBmb3IgZGlzcGxheWluZ1xuICB0aGUgc3RhdHVzIG9mIG91ciBjb25uZWN0aW9uIHRvIHRoZSBzZXJ2ZXIgKGNvbm5lY3RlZCxcbiAgZGlzY29ubmVjdGVkLCBlcnJvciwgZXRjKS5cbiovXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRDb25uZWN0aW9uU3RhdHVzID0gc3R5bGVkLmRpdigoeyB0aGVtZSB9KSA9PiAoe1xuICBkaXNwbGF5OiBcImZsZXhcIixcbiAgYWxpZ25JdGVtczogXCJjZW50ZXJcIixcbiAganVzdGlmeUNvbnRlbnQ6IFwiY2VudGVyXCIsXG4gIGNvbG9yOiB0aGVtZS5jb2xvcnMuZ3JheTYwLFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRDb25uZWN0aW9uU3RhdHVzTGFiZWwgPSBzdHlsZWQubGFiZWwoKHsgdGhlbWUgfSkgPT4gKHtcbiAgZm9udFNpemU6IHRoZW1lLmZvbnRTaXplcy5zbSxcbiAgY29sb3I6IHRoZW1lLmNvbG9ycy5ncmF5NjAsXG4gIHRleHRUcmFuc2Zvcm06IFwidXBwZXJjYXNlXCIsXG4gIG1hcmdpblRvcDogdGhlbWUuc3BhY2luZy5ub25lLFxuICBtYXJnaW5SaWdodDogdGhlbWUuc3BhY2luZy5sZyxcbiAgbWFyZ2luQm90dG9tOiB0aGVtZS5zcGFjaW5nLm5vbmUsXG4gIG1hcmdpbkxlZnQ6IHRoZW1lLnNwYWNpbmcuc20sXG4gIHdoaXRlU3BhY2U6IFwibm93cmFwXCIsXG4gIG1heFdpZHRoOiB0aGVtZS5zaXplcy5hcHBTdGF0dXNNYXhXaWR0aCxcbiAgbGluZUhlaWdodDogdGhlbWUubGluZUhlaWdodHMubm9uZSxcbn0pKVxuXG4vKlxuICBcIkFwcFN0YXR1c1wiIHN0eWxlcyBhcmUgZm9yIGFwcC1yZWxhdGVkIHN0YXR1c2VzOlxuICB3aGV0aGVyIGl0J3MgcnVubmluZywgaWYgdGhlIHNvdXJjZSBmaWxlIGhhcyBjaGFuZ2VkIG9uIGRpc2ssXG4gIGV0Yy5cbiovXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRBcHBTdGF0dXMgPSBzdHlsZWQuZGl2KCh7IHRoZW1lIH0pID0+ICh7XG4gIGRpc3BsYXk6IFwiZmxleFwiLFxuICBhbGlnbkl0ZW1zOiBcImNlbnRlclwiLFxuICBqdXN0aWZ5Q29udGVudDogXCJjZW50ZXJcIixcbiAgYm9yZGVyUmFkaXVzOiB0aGVtZS5yYWRpaS5tZCxcbiAgbWFyZ2luOiBgMCAke3RoZW1lLnNwYWNpbmcuc219IDAgMGAsXG4gIHBhZGRpbmdMZWZ0OiB0aGVtZS5zcGFjaW5nLnNtLFxuICBoZWlnaHQ6IHRoZW1lLnNpemVzLmFwcFJ1bm5pbmdNZW4sXG59KSlcblxuZXhwb3J0IGludGVyZmFjZSBTdHlsZWRBcHBTdGF0dXNMYWJlbFByb3BzIHtcbiAgaXNQcm9tcHQ6IGJvb2xlYW5cbn1cblxuZXhwb3J0IGNvbnN0IFN0eWxlZEFwcFN0YXR1c0xhYmVsID0gc3R5bGVkLmxhYmVsPFN0eWxlZEFwcFN0YXR1c0xhYmVsUHJvcHM+KFxuICAoeyBpc1Byb21wdCwgdGhlbWUgfSkgPT4gKHtcbiAgICBmb250U2l6ZTogdGhlbWUuZm9udFNpemVzLnNtLFxuICAgIGNvbG9yOiBpc1Byb21wdCA/IHRoZW1lLmNvbG9ycy5ib2R5VGV4dCA6IHRoZW1lLmNvbG9ycy5ncmF5NjAsXG4gICAgdGV4dFRyYW5zZm9ybTogaXNQcm9tcHQgPyBcIm5vbmVcIiA6IFwidXBwZXJjYXNlXCIsXG4gICAgbWFyZ2luOiBgMCAwIDAgJHt0aGVtZS5zcGFjaW5nLnNtfWAsXG4gICAgd2hpdGVTcGFjZTogXCJub3dyYXBcIixcbiAgICBtYXhXaWR0aDogdGhlbWUuc2l6ZXMuYXBwU3RhdHVzTWF4V2lkdGgsXG4gICAgYm9yZGVyUmFkaXVzOiBpc1Byb21wdCA/IHRoZW1lLnJhZGlpLm1kIDogdW5kZWZpbmVkLFxuICB9KVxuKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkQXBwQnV0dG9uQ29udGFpbmVyID0gc3R5bGVkLnNwYW4oKHsgdGhlbWUgfSkgPT4gKHtcbiAgbWFyZ2luTGVmdDogdGhlbWUuc3BhY2luZy5tZCxcbiAgd2hpdGVTcGFjZTogXCJub3dyYXBcIixcbiAgY29sb3I6IHRoZW1lLmNvbG9ycy5ib2R5VGV4dCxcbn0pKVxuXG5leHBvcnQgaW50ZXJmYWNlIFN0eWxlZEFwcFJ1bm5pbmdJY29uUHJvcHMge1xuICBpc05ld1llYXJzOiBib29sZWFuXG59XG5cbmV4cG9ydCBjb25zdCBTdHlsZWRBcHBSdW5uaW5nSWNvbiA9IHN0eWxlZC5kaXY8U3R5bGVkQXBwUnVubmluZ0ljb25Qcm9wcz4oXG4gICh7IGlzTmV3WWVhcnMsIHRoZW1lIH0pID0+IHtcbiAgICAvLyBOZXcgeWVhcnMgZ2lmIGhhcyB1bmlxdWUgc3R5bGluZyAtIHJlZ3VsYXIgcnVubmluZyBtYW4gdW5jaGFuZ2VkXG4gICAgcmV0dXJuIHtcbiAgICAgIHdpZHRoOiBpc05ld1llYXJzID8gXCIyLjJyZW1cIiA6IHRoZW1lLnNpemVzLmFwcFJ1bm5pbmdNZW4sXG4gICAgICBoZWlnaHQ6IGlzTmV3WWVhcnMgPyBcIjIuMnJlbVwiIDogdGhlbWUuc2l6ZXMuYXBwUnVubmluZ01lbixcbiAgICAgIG1hcmdpblJpZ2h0OiBgLSR7dGhlbWUuc3BhY2luZy5zbX1gLFxuICAgICAgZGlzcGxheTogXCJmbGV4XCIsXG4gICAgICBhbGlnbkl0ZW1zOiBcImNlbnRlclwiLFxuICAgICAganVzdGlmeUNvbnRlbnQ6IFwiY2VudGVyXCIsXG4gICAgICB0cmFuc2l0aW9uOiBcIm9wYWNpdHkgMC4zcyBlYXNlLWluLW91dFwiLFxuICAgICAgY3Vyc29yOiBcIndhaXRcIixcbiAgICB9XG4gIH1cbilcblxuZXhwb3J0IGNvbnN0IFN0eWxlZFN0YXR1c1dpZGdldCA9IHN0eWxlZC5kaXYoe1xuICBcIiYuU3RhdHVzV2lkZ2V0LWFwcGVhclwiOiB7XG4gICAgb3BhY2l0eTogMCxcbiAgfSxcblxuICBcIiYuU3RhdHVzV2lkZ2V0LWFwcGVhci1hY3RpdmVcIjoge1xuICAgIG9wYWNpdHk6IDEsXG4gICAgdHJhbnNpdGlvbjogXCJvcGFjaXR5IDIwMG1zIGVhc2Utb3V0XCIsXG4gIH0sXG5cbiAgXCImLlN0YXR1c1dpZGdldC1lbnRlclwiOiB7XG4gICAgb3BhY2l0eTogMCxcbiAgfSxcblxuICBcIiYuU3RhdHVzV2lkZ2V0LWVudGVyLWFjdGl2ZVwiOiB7XG4gICAgb3BhY2l0eTogMSxcbiAgICB0cmFuc2l0aW9uOiBcIm9wYWNpdHkgMjAwbXMgZWFzZS1vdXRcIixcbiAgfSxcblxuICBcIiYuU3RhdHVzV2lkZ2V0LWV4aXRcIjoge1xuICAgIG9wYWNpdHk6IDEsXG4gIH0sXG5cbiAgXCImLlN0YXR1c1dpZGdldC1leGl0LWFjdGl2ZVwiOiB7XG4gICAgb3BhY2l0eTogMCxcbiAgICB0cmFuc2l0aW9uOiBcIm9wYWNpdHkgMjAwbXMgZWFzZS1vdXRcIixcbiAgfSxcbn0pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRTaG9ydGN1dExhYmVsID0gc3R5bGVkLmRpdih7XG4gIFwiJjo6Zmlyc3QtbGV0dGVyXCI6IHtcbiAgICB0ZXh0RGVjb3JhdGlvbjogXCJ1bmRlcmxpbmVcIixcbiAgfSxcbn0pXG4iXX0= */"), StyledAppRunningIcon = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "en6cib62"
} : {
  target: "en6cib62",
  label: "StyledAppRunningIcon"
})(({
  isNewYears: o,
  theme: E
}) => ({
  width: o ? "2.2rem" : E.sizes.appRunningMen,
  height: o ? "2.2rem" : E.sizes.appRunningMen,
  marginRight: `-${E.spacing.sm}`,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  transition: "opacity 0.3s ease-in-out",
  cursor: "wait"
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledStatusWidget = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "en6cib61"
} : {
  target: "en6cib61",
  label: "StyledStatusWidget"
})(process.env.NODE_ENV === "production" ? {
  name: "19or5k2",
  styles: "&.StatusWidget-appear{opacity:0;}&.StatusWidget-appear-active{opacity:1;transition:opacity 200ms ease-out;}&.StatusWidget-enter{opacity:0;}&.StatusWidget-enter-active{opacity:1;transition:opacity 200ms ease-out;}&.StatusWidget-exit{opacity:1;}&.StatusWidget-exit-active{opacity:0;transition:opacity 200ms ease-out;}"
} : {
  name: "19or5k2",
  styles: "&.StatusWidget-appear{opacity:0;}&.StatusWidget-appear-active{opacity:1;transition:opacity 200ms ease-out;}&.StatusWidget-enter{opacity:0;}&.StatusWidget-enter-active{opacity:1;transition:opacity 200ms ease-out;}&.StatusWidget-exit{opacity:1;}&.StatusWidget-exit-active{opacity:0;transition:opacity 200ms ease-out;}/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$5
}), StyledShortcutLabel = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "en6cib60"
} : {
  target: "en6cib60",
  label: "StyledShortcutLabel"
})(process.env.NODE_ENV === "production" ? {
  name: "jdyw56",
  styles: "&::first-letter{text-decoration:underline;}"
} : {
  name: "jdyw56",
  styles: "&::first-letter{text-decoration:underline;}/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$5
}), icons = [{
  component: AccessibleForward,
  name: "accessible-forward"
}, {
  component: AccessibilityNew,
  name: "accessibility-new"
}, {
  component: DirectionsBike,
  name: "directions-bike"
}, {
  component: DirectionsRun,
  name: "directions-run"
}, {
  component: Pool,
  name: "pool"
}, {
  component: Rowing,
  name: "rowing"
}], isNewYears = () => {
  const o = /* @__PURE__ */ new Date(), E = o.getMonth(), A = o.getDate();
  return E === 11 && A === 31 || E === 0 && A <= 6;
}, DEFAULT_SPEED = 200, IconRunning = () => {
  const [o, E] = useState(0), A = useEmotionTheme(), g = useMemo$1(() => isNewYears(), []);
  useEffect(() => {
    if (g) return;
    const c = setInterval(() => {
      E((n) => (n + 1) % icons.length);
    }, DEFAULT_SPEED);
    return () => clearInterval(c);
  }, [g]);
  const t = icons[o].component;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledAppRunningIcon, { isNewYears: g, "aria-label": "Running...", role: "img", "data-testid": "stStatusWidgetRunningIcon", children: g ? /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: newYearsRunning, alt: "New Year's Celebration", style: {
    width: "100%",
    height: "100%",
    objectFit: "contain"
  }, "data-testid": "stStatusWidgetNewYearsIcon" }) : /* @__PURE__ */ jsxRuntimeExports.jsx(t, { color: A.colors.fadedText60, "aria-hidden": "true", "data-testid": "stStatusWidgetRunningManIcon", style: {
    width: A.sizes.appRunningMen,
    height: A.sizes.appRunningMen
  } }) });
}, RUNNING_MAN_DISPLAY_DELAY_TIME_MS = 500, PromptButton = (o) => /* @__PURE__ */ jsxRuntimeExports.jsx(StyledAppButtonContainer, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(BaseButton, { kind: BaseButtonKind.HEADER_BUTTON, disabled: o.disabled, containerWidth: !0, onClick: o.onClick, children: o.title }) }), StatusWidget = ({
  connectionState: o,
  scriptRunState: E,
  rerunScript: A,
  stopScript: g,
  allowRunOnSave: e,
  showScriptChangedActions: t
}) => {
  const [c, n] = useState(!1), h = useRef(null), d = useRef(null), k = useEmotionTheme(), p = () => {
    e && A(!0);
  }, M = (tA, eA) => {
    tA === "a" && !isKeyboardEventFromEditableTarget(eA) && p();
  }, S = o === ConnectionState.CONNECTED, AA = useCallback((tA) => {
    d.current !== null && d.current.setTimeout(() => {
      n(!0);
    }, tA);
  }, []), H = () => {
    g();
  }, gA = () => {
    A(!1);
  };
  useEffect(() => {
    h.current === null && (h.current = new Timer()), d.current === null && (d.current = new Timer());
    const tA = h.current, eA = h.current;
    return () => {
      tA.cancel(), eA.cancel();
    };
  }, []), useEffect(() => {
    S && (E === ScriptRunState.RUNNING || E === ScriptRunState.RERUN_REQUESTED) && AA(RUNNING_MAN_DISPLAY_DELAY_TIME_MS), E === ScriptRunState.NOT_RUNNING && n(!1);
  }, [E, AA, S]);
  const CA = () => {
    const tA = E === ScriptRunState.STOP_REQUESTED;
    return c ? /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledAppStatus, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(IconRunning, {}),
      /* @__PURE__ */ jsxRuntimeExports.jsx(PromptButton, { title: tA ? "Stopping..." : "Stop", disabled: tA, onClick: H })
    ] }) : /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {});
  }, IA = () => {
    const tA = E === ScriptRunState.RERUN_REQUESTED;
    return /* @__PURE__ */ jsxRuntimeExports.jsx(ReactHotkeys, { keyName: "a", onKeyDown: M, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledAppStatus, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(DynamicIcon, { size: "lg", iconValue: ":material/info:", color: k.colors.fadedText60 }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(StyledAppStatusLabel, { isPrompt: !0, children: "File change." }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(PromptButton, { title: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledShortcutLabel, { children: "Rerun" }), disabled: tA, onClick: gA }),
      e && /* @__PURE__ */ jsxRuntimeExports.jsx(PromptButton, { title: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledShortcutLabel, { children: "Always rerun" }), disabled: tA, onClick: p })
    ] }) });
  }, BA = () => {
    const tA = getConnectionStateUI(o);
    return tA === void 0 ? null : /* @__PURE__ */ jsxRuntimeExports.jsx(Tooltip$1, { content: tA.tooltip, placement: Placement.BOTTOM, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledConnectionStatus, { className: "stConnectionStatus", "data-testid": "stConnectionStatus", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Icon$2, { size: "sm", content: tA.icon }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(StyledConnectionStatusLabel, { children: tA.label })
    ] }) });
  }, QA = () => {
    if (S) {
      if (E === ScriptRunState.RUNNING || E === ScriptRunState.RERUN_REQUESTED)
        return CA();
      if (t)
        return IA();
    }
    return BA();
  }, EA = useRef(), oA = EA.current;
  if (EA.current = QA(), isNullOrUndefined(EA.current) && isNullOrUndefined(oA))
    return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {});
  let iA, aA;
  return notNullOrUndefined(EA.current) ? (iA = !0, aA = EA.current) : (iA = !1, aA = oA), /* @__PURE__ */ jsxRuntimeExports.jsx(CSSTransition, { appear: !0, in: iA, timeout: 200, unmountOnExit: !0, classNames: "StatusWidget", children: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledStatusWidget, { className: "stStatusWidget", "data-testid": "stStatusWidget", children: aA }, "StatusWidget") });
}, StreamlitContextProvider = ({
  // ViewStateContext
  isFullScreen: o,
  setFullScreen: E,
  // LibConfigContext
  locale: A,
  mapboxToken: g,
  enforceDownloadInNewTab: e,
  resourceCrossOriginMode: t,
  // NavigationContext
  pageLinkBaseUrl: c,
  currentPageScriptHash: n,
  onPageChange: h,
  navSections: d,
  appPages: k,
  // SidebarConfigContext
  initialSidebarState: p,
  appLogo: M,
  sidebarChevronDownshift: S,
  expandSidebarNav: AA,
  hideSidebarNav: H,
  // ThemeContext
  activeTheme: gA,
  setTheme: CA,
  availableThemes: IA,
  // ScriptRunContext
  scriptRunState: BA,
  scriptRunId: QA,
  fragmentIdsThisRun: EA,
  // FormsContext
  formsData: oA,
  // DownloadContext
  requestDeferredFile: iA,
  // Children passed through
  children: aA
}) => {
  const tA = useMemo$1(() => ({
    locale: A,
    mapboxToken: g,
    enforceDownloadInNewTab: e,
    resourceCrossOriginMode: t
  }), [A, g, e, t]), eA = useMemo$1(() => ({
    initialSidebarState: p,
    appLogo: M,
    sidebarChevronDownshift: S,
    expandSidebarNav: AA,
    hideSidebarNav: H
  }), [p, M, S, AA, H]), cA = useMemo$1(() => ({
    activeTheme: gA,
    setTheme: CA,
    availableThemes: IA
  }), [gA, CA, IA]), DA = useMemo$1(() => ({
    pageLinkBaseUrl: c,
    currentPageScriptHash: n,
    onPageChange: h,
    navSections: d,
    appPages: k
  }), [c, n, h, d, k]), nA = useMemo$1(() => ({
    isFullScreen: o,
    setFullScreen: E
  }), [o, E]), wA = useMemo$1(() => ({
    scriptRunState: BA,
    scriptRunId: QA,
    fragmentIdsThisRun: EA
  }), [BA, QA, EA]), lA = {
    formsData: oA
  }, NA = useMemo$1(() => ({
    requestDeferredFile: iA
  }), [iA]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(LibConfigContext.Provider, { value: tA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(SidebarConfigContext.Provider, { value: eA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(ThemeContext.Provider, { value: cA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(NavigationContext.Provider, { value: DA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(DownloadContext.Provider, { value: NA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(ViewStateContext.Provider, { value: nA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(ScriptRunContext.Provider, { value: wA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(FormsContext.Provider, { value: lA, children: aA }) }) }) }) }) }) }) });
}, StreamlitContextProvider$1 = memo(StreamlitContextProvider);
var DialogType = /* @__PURE__ */ ((o) => (o.ABOUT = "about", o.CLEAR_CACHE = "clearCache", o.CONNECTION_ERROR = "connectionError", o.SETTINGS = "settings", o.SCRIPT_COMPILE_ERROR = "scriptCompileError", o.THEME_CREATOR = "themeCreator", o.WARNING = "warning", o.DEPLOY_ERROR = "deployError", o.DEPLOY_DIALOG = "deployDialog", o))(DialogType || {}), LevelContext = /* @__PURE__ */ React.createContext(0);
function ownKeys(o, E) {
  var A = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var g = Object.getOwnPropertySymbols(o);
    E && (g = g.filter(function(e) {
      return Object.getOwnPropertyDescriptor(o, e).enumerable;
    })), A.push.apply(A, g);
  }
  return A;
}
function _objectSpread(o) {
  for (var E = 1; E < arguments.length; E++) {
    var A = arguments[E] != null ? arguments[E] : {};
    E % 2 ? ownKeys(Object(A), !0).forEach(function(g) {
      _defineProperty(o, g, A[g]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(A)) : ownKeys(Object(A)).forEach(function(g) {
      Object.defineProperty(o, g, Object.getOwnPropertyDescriptor(A, g));
    });
  }
  return o;
}
function _defineProperty(o, E, A) {
  return E in o ? Object.defineProperty(o, E, { value: A, enumerable: !0, configurable: !0, writable: !0 }) : o[E] = A, o;
}
var Action = styled("div", function(o) {
  var E = o.$theme;
  return _objectSpread({}, E.typography.LabelMedium);
});
Action.displayName = "Action";
Action.displayName = "Action";
var Body = styled("div", function(o) {
  var E = o.$theme;
  return _objectSpread({
    marginBottom: E.sizing.scale600,
    color: E.colors.contentPrimary
  }, E.typography.ParagraphMedium);
});
Body.displayName = "Body";
Body.displayName = "Body";
var Contents = styled("div", function(o) {
  var E = o.$theme;
  return {
    marginLeft: E.sizing.scale600,
    marginTop: E.sizing.scale600,
    marginRight: E.sizing.scale600,
    marginBottom: E.sizing.scale600
  };
});
Contents.displayName = "Contents";
Contents.displayName = "Contents";
var HeaderImage = styled("img", function(o) {
  var E = o.$theme;
  return {
    borderTopLeftRadius: E.borders.surfaceBorderRadius,
    borderTopRightRadius: E.borders.surfaceBorderRadius,
    objectFit: "contain",
    maxWidth: "100%"
  };
});
HeaderImage.displayName = "HeaderImage";
HeaderImage.displayName = "HeaderImage";
var Root = styled("section", function(o) {
  var E = o.$theme;
  return {
    borderLeftWidth: "2px",
    borderTopWidth: "2px",
    borderRightWidth: "2px",
    borderBottomWidth: "2px",
    borderLeftStyle: "solid",
    borderTopStyle: "solid",
    borderRightStyle: "solid",
    borderBottomStyle: "solid",
    borderLeftColor: E.colors.borderOpaque,
    borderRightColor: E.colors.borderOpaque,
    borderTopColor: E.colors.borderOpaque,
    borderBottomColor: E.colors.borderOpaque,
    borderTopLeftRadius: E.borders.radius400,
    borderTopRightRadius: E.borders.radius400,
    borderBottomLeftRadius: E.borders.radius400,
    borderBottomRightRadius: E.borders.radius400,
    backgroundColor: E.colors.backgroundPrimary,
    overflow: "hidden"
  };
});
Root.displayName = "Root";
Root.displayName = "Root";
var Thumbnail = styled("img", function(o) {
  var E = o.$theme;
  return _objectSpread(_objectSpread({
    float: "right",
    height: E.sizing.scale2400,
    width: E.sizing.scale2400,
    objectFit: "cover",
    borderTopLeftRadius: E.borders.surfaceBorderRadius,
    borderTopRightRadius: E.borders.surfaceBorderRadius,
    borderBottomLeftRadius: E.borders.surfaceBorderRadius,
    borderBottomRightRadius: E.borders.surfaceBorderRadius
  }, expandBorderStyles(E.borders.border200)), {}, {
    margin: "0 0 ".concat(E.sizing.scale500, " ").concat(E.sizing.scale500)
  });
});
Thumbnail.displayName = "Thumbnail";
Thumbnail.displayName = "Thumbnail";
var Title = styled("h1", function(o) {
  var E = o.$theme;
  return _objectSpread(_objectSpread({}, E.typography.HeadingSmall), {}, {
    color: E.colors.contentPrimary,
    marginLeft: 0,
    marginTop: 0,
    marginRight: 0,
    marginBottom: E.sizing.scale500,
    paddingLeft: 0,
    paddingTop: 0,
    paddingRight: 0,
    paddingBottom: 0
  });
});
Title.displayName = "Title";
Title.displayName = "Title";
var _excluded = ["children"], _excluded2 = ["action", "children", "hasThumbnail", "headerImage", "thumbnail", "title", "overrides"];
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(o) {
    for (var E = 1; E < arguments.length; E++) {
      var A = arguments[E];
      for (var g in A)
        Object.prototype.hasOwnProperty.call(A, g) && (o[g] = A[g]);
    }
    return o;
  }, _extends.apply(this, arguments);
}
function _objectWithoutProperties(o, E) {
  if (o == null) return {};
  var A = _objectWithoutPropertiesLoose(o, E), g, e;
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    for (e = 0; e < t.length; e++)
      g = t[e], !(E.indexOf(g) >= 0) && Object.prototype.propertyIsEnumerable.call(o, g) && (A[g] = o[g]);
  }
  return A;
}
function _objectWithoutPropertiesLoose(o, E) {
  if (o == null) return {};
  var A = {}, g = Object.keys(o), e, t;
  for (t = 0; t < g.length; t++)
    e = g[t], !(E.indexOf(e) >= 0) && (A[e] = o[e]);
  return A;
}
function hasThumbnail(o) {
  return !!o.thumbnail;
}
var SemanticTitle = function o(E) {
  var A = E.children, g = _objectWithoutProperties(E, _excluded), e = ["", "h1", "h2", "h3", "h4", "h5", "h6"];
  return /* @__PURE__ */ React.createElement(LevelContext.Consumer, null, function(t) {
    return (
      // @ts-expect-error
      /* @__PURE__ */ React.createElement(Title, _extends({
        $as: e[t]
      }, g), A)
    );
  });
};
function Card(o) {
  var E = o.action, A = o.children, g = o.hasThumbnail, e = o.headerImage, t = o.thumbnail, c = o.title, n = o.overrides, h = _objectWithoutProperties(o, _excluded2), d = n.Action, k = n.Body, p = n.Contents, M = n.HeaderImage, S = n.Root, AA = n.Thumbnail, H = n.Title, gA = getOverride(d) || Action, CA = getOverride(k) || Body, IA = getOverride(p) || Contents, BA = getOverride(M) || HeaderImage, QA = getOverride(S) || Root, EA = getOverride(AA) || Thumbnail, oA = getOverride(H) || SemanticTitle, iA = typeof e == "string" ? {
    src: e
  } : e, aA = g(o);
  return /* @__PURE__ */ React.createElement(QA, _extends({
    "data-baseweb": "card"
  }, h, getOverrideProps(S)), e && /* @__PURE__ */ React.createElement(BA, _extends({}, iA, getOverrideProps(M))), /* @__PURE__ */ React.createElement(IA, getOverrideProps(p), t && /* @__PURE__ */ React.createElement(EA, _extends({
    src: t
  }, getOverrideProps(AA))), c && /* @__PURE__ */ React.createElement(oA, _extends({
    $hasThumbnail: aA
  }, getOverrideProps(H)), c), /* @__PURE__ */ React.createElement(CA, getOverrideProps(k), A), E && /* @__PURE__ */ React.createElement(gA, getOverrideProps(d), E)));
}
Card.defaultProps = {
  action: null,
  children: null,
  hasThumbnail,
  overrides: {}
};
const StreamlitLogo = "data:image/svg+xml,%3csvg%20width='32'%20height='19'%20viewBox='0%200%2032%2019'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20id='Group%202'%3e%3cpath%20id='path3858'%20d='M15.998%2011.078L10.3882%208.04522L0.650371%202.78157C0.641482%202.77247%200.623705%202.77248%200.614816%202.77248C0.259259%202.59975%20-0.105186%202.96338%200.0281476%203.32702L4.98994%2016.2698L4.99083%2016.2725C4.99616%2016.2852%205.00061%2016.298%205.00594%2016.3107C5.2095%2016.7934%205.65394%2017.0916%206.1375%2017.2089C6.17839%2017.218%206.20764%2017.2262%206.25673%2017.2362C6.30559%2017.2473%206.37394%2017.2625%206.43261%2017.2671C6.44239%2017.268%206.45128%2017.268%206.46106%2017.2689H6.46817C6.47528%2017.2698%206.48239%2017.2698%206.4895%2017.2707H6.49928C6.5055%2017.2716%206.51261%2017.2716%206.51883%2017.2716H6.53039C6.5375%2017.2725%206.54461%2017.2725%206.55172%2017.2725C12.8348%2017.9731%2019.1763%2017.9731%2025.4593%2017.2725C25.5349%2017.2725%2025.6087%2017.2689%2025.6798%2017.2616C25.7029%2017.2589%2025.7251%2017.2562%2025.7473%2017.2534C25.75%2017.2525%2025.7536%2017.2525%2025.7562%2017.2516C25.7713%2017.2498%2025.7864%2017.2471%2025.8016%2017.2443C25.8238%2017.2416%2025.846%2017.2371%2025.8682%2017.2325C25.9127%2017.2225%2025.9329%2017.2152%2025.9932%2017.194C26.0535%2017.1729%2026.1536%2017.1358%2026.2163%2017.1049C26.279%2017.074%2026.3224%2017.0443%2026.3749%2017.0107C26.4398%2016.9689%2026.5015%2016.9261%2026.5641%2016.8781C26.5911%2016.8569%2026.6096%2016.8434%2026.6291%2016.8243L26.6184%2016.818L15.998%2011.078Z'%20fill='%23FF2B2B'/%3e%3cpath%20id='path5063'%20d='M31.3616%202.78158H31.3527L21.6113%208.04524L27.0265%2016.2935L31.9758%203.32704V3.30886C32.1003%202.92704%2031.7181%202.58158%2031.3616%202.78158Z'%20fill='%237D353B'/%3e%3cpath%20id='path5101'%20d='M16.5171%200.278788C16.2682%20-0.0930318%2015.726%20-0.0930318%2015.486%200.278788L10.3882%208.04518L15.998%2011.0779L26.6291%2016.8242C26.6959%2016.7574%2026.7494%2016.6922%2026.806%2016.6234C26.886%2016.5225%2026.9607%2016.4143%2027.0265%2016.2934L21.6113%208.04518L16.5171%200.278788Z'%20fill='%23BD4043'/%3e%3c/g%3e%3c/svg%3e", Rocket = "data:image/svg+xml,%3csvg%20width='25'%20height='24'%20viewBox='0%200%2025%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20id='Frame'%3e%3cpath%20id='Vector'%20d='M5.95077%2010.7642L8.09076%2011.6685C8.34683%2011.157%208.61204%2010.6637%208.8864%2010.1887C9.16076%209.71374%209.46256%209.23875%209.79179%208.76376L8.25538%208.46232L5.95077%2010.7642ZM9.84666%2013.0387L12.9743%2016.1352C13.7426%2015.8429%2014.5656%2015.3954%2015.4436%2014.7925C16.3215%2014.1896%2017.1446%2013.5045%2017.9128%2012.7372C19.1931%2011.4584%2020.1946%2010.038%2020.917%208.47602C21.6395%206.91403%2021.955%205.47536%2021.8636%204.16C20.5466%204.06866%2019.1017%204.38379%2017.5287%205.10541C15.9557%205.82703%2014.529%206.82726%2013.2487%208.10608C12.4805%208.87337%2011.7946%209.69547%2011.191%2010.5724C10.5874%2011.4493%2010.1393%2012.2714%209.84666%2013.0387ZM14.7302%2011.2575C14.3096%2010.8373%2014.0992%2010.3212%2014.0992%209.70917C14.0992%209.09716%2014.3096%208.58107%2014.7302%208.16088C15.1509%207.7407%2015.6722%207.53061%2016.2941%207.53061C16.916%207.53061%2017.4373%207.7407%2017.8579%208.16088C18.2786%208.58107%2018.489%209.09716%2018.489%209.70917C18.489%2010.3212%2018.2786%2010.8373%2017.8579%2011.2575C17.4373%2011.6776%2016.916%2011.8877%2016.2941%2011.8877C15.6722%2011.8877%2015.1509%2011.6776%2014.7302%2011.2575ZM15.2515%2020.0539L17.5561%2017.752L17.2543%2016.2175C16.7788%2016.5463%2016.3032%2016.8432%2015.8277%2017.1081C15.3521%2017.373%2014.8583%2017.6333%2014.3461%2017.8891L15.2515%2020.0539ZM23.839%202.15956C24.1865%204.37009%2023.9716%206.52125%2023.1942%208.61304C22.4169%2010.7048%2021.0771%2012.7007%2019.1749%2014.6007L19.7236%2017.3136C19.7967%2017.679%2019.7784%2018.0352%2019.6687%2018.3823C19.559%2018.7294%2019.3761%2019.0309%2019.12%2019.2866L14.5108%2023.8904L12.2061%2018.4919L7.51461%2013.806L2.10974%2011.5041L6.69153%206.90033C6.9476%206.64457%207.25397%206.46188%207.61064%206.35227C7.9673%206.24265%208.32854%206.22438%208.69435%206.29746L11.4105%206.84553C13.3127%204.94556%2015.3064%203.6028%2017.3915%202.81724C19.4767%202.03168%2021.6258%201.81245%2023.839%202.15956ZM4.05769%2017.2862C4.69786%2016.6468%205.47978%2016.3225%206.40346%2016.3134C7.32713%2016.3042%208.10905%2016.6194%208.74922%2017.2588C9.38939%2017.8982%209.70491%2018.6792%209.69576%2019.6018C9.68662%2020.5243%209.36196%2021.3053%208.72179%2021.9448C8.26452%2022.4015%207.50089%2022.7943%206.43089%2023.1231C5.36089%2023.4519%203.88393%2023.7442%202%2024C2.25607%2022.1183%202.54872%2020.6431%202.87795%2019.5744C3.20718%2018.5056%203.60043%2017.7429%204.05769%2017.2862ZM5.62154%2018.8208C5.43863%2019.0035%205.25572%2019.3369%205.07282%2019.821C4.88991%2020.3051%204.76188%2020.7938%204.68872%2021.2871C5.18256%2021.214%205.67183%2021.0907%206.15653%2020.9171C6.64123%2020.7436%206.97504%2020.5655%207.15794%2020.3828C7.37743%2020.1635%207.49632%2019.8986%207.51461%2019.5881C7.5329%2019.2775%207.4323%2019.0126%207.21282%2018.7934C6.99333%2018.5741%206.72812%2018.4691%206.41718%2018.4782C6.10624%2018.4874%205.84102%2018.6015%205.62154%2018.8208Z'%20fill='%23A3A8B8'/%3e%3c/g%3e%3c/svg%3e", Snowflake = "data:image/svg+xml,%3csvg%20width='25'%20height='24'%20viewBox='0%200%2025%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20id='Logo-solid'%3e%3cpath%20id='inside'%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M13.5357%2012.1774L12.801%2012.912C12.7029%2013.0101%2012.5439%2013.0101%2012.4458%2012.912L11.7112%2012.1774C11.6131%2012.0794%2011.6131%2011.9203%2011.7112%2011.8223L12.4458%2011.0876C12.5439%2010.9894%2012.703%2010.9894%2012.8011%2011.0876L13.5357%2011.8222C13.6337%2011.9203%2013.6337%2012.0793%2013.5357%2012.1774ZM15.0724%2011.2524L13.3708%209.55073C12.9581%209.13804%2012.2889%209.13804%2011.8761%209.55073L10.1744%2011.2525C9.76154%2011.6653%209.76154%2012.3345%2010.1744%2012.7473L11.876%2014.4489C12.2887%2014.8616%2012.9579%2014.8616%2013.3707%2014.4489L15.0724%2012.7471C15.4852%2012.3343%2015.4852%2011.6651%2015.0724%2011.2524Z'%20fill='%2329B5E8'/%3e%3cpath%20id='petal%206'%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M9.79594%200C8.95801%200%208.2787%200.679312%208.2787%201.51724V4.65891L5.53731%203.07614C4.81165%202.65718%203.88372%202.9058%203.46476%203.63153C3.04579%204.35718%203.29441%205.28512%204.02007%205.70408L8.83304%208.48285C9.09497%208.69823%209.43036%208.82761%209.79594%208.82761C10.6339%208.82761%2011.3132%208.14829%2011.3132%207.31036V1.51724C11.3132%200.679312%2010.6339%200%209.79594%200Z'%20fill='%2329B5E8'/%3e%3cpath%20id='petal%205'%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M8.60315%2012.5758C8.61253%2012.553%208.62177%2012.5303%208.62997%2012.5071C8.63915%2012.4812%208.64722%2012.4552%208.65494%2012.429C8.66087%2012.4088%208.66673%2012.3888%208.67184%2012.3685C8.67887%2012.3405%208.6848%2012.3124%208.69018%2012.2841C8.69397%2012.2642%208.69756%2012.2443%208.7006%2012.2243C8.70473%2012.1967%208.70791%2012.1692%208.71046%2012.1414C8.71253%2012.1194%208.71425%2012.0975%208.71542%2012.0754C8.71666%2012.0503%208.71708%2012.0252%208.71708%2012C8.71708%2011.9748%208.71666%2011.9498%208.71542%2011.9246C8.71425%2011.9025%208.71253%2011.8805%208.71046%2011.8586C8.70791%2011.8309%208.70473%2011.8034%208.7006%2011.7756C8.69756%2011.7556%208.69397%2011.7358%208.69018%2011.7158C8.6848%2011.6876%208.67887%2011.6596%208.67184%2011.6315C8.66673%2011.6112%208.66087%2011.5912%208.65494%2011.5711C8.64722%2011.5449%208.63915%2011.5188%208.62997%2011.4929C8.62177%2011.4697%208.61253%2011.4469%208.60315%2011.4242C8.59418%2011.4023%208.58528%2011.3805%208.57522%2011.3589C8.56246%2011.3316%208.54825%2011.3049%208.53391%2011.2784C8.52722%2011.2661%208.52198%2011.2535%208.51501%2011.2414C8.51232%2011.2367%208.50901%2011.2325%208.50625%2011.2279C8.48956%2011.1996%208.47122%2011.1722%208.45259%2011.1449C8.44266%2011.1303%208.43308%2011.1152%208.42266%2011.1009C8.40466%2011.0765%208.38515%2011.0532%208.3657%2011.0298C8.35253%2011.014%208.3399%2010.9978%208.32625%2010.9826C8.30922%2010.9638%208.29087%2010.9462%208.27287%2010.9281C8.2548%2010.9101%208.23715%2010.8917%208.21839%2010.8747C8.20322%2010.8612%208.18701%2010.8485%208.17122%2010.8354C8.14777%2010.8158%208.12453%2010.7963%208.10004%2010.7784C8.08584%2010.7679%208.07073%2010.7583%208.05604%2010.7484C8.0288%2010.7298%208.00142%2010.7115%207.97308%2010.6947C7.96846%2010.6921%207.96432%2010.6887%207.95963%2010.6861L2.94265%207.78949C2.21693%207.37046%201.28899%207.61915%200.870026%208.3448C0.45106%209.07053%200.699681%209.99846%201.42541%2010.4174L4.16652%2012L1.42541%2013.5826C0.699681%2014.0016%200.45106%2014.9295%200.870026%2015.6552C1.28899%2016.3809%202.21693%2016.6295%202.94265%2016.2105L7.95963%2013.314C7.96432%2013.3112%207.96846%2013.308%207.97308%2013.3052C8.00142%2013.2885%208.0288%2013.2702%208.05604%2013.2516C8.07073%2013.2416%208.08584%2013.2321%208.10004%2013.2216C8.12453%2013.2036%208.14777%2013.1841%208.17122%2013.1646C8.18701%2013.1516%208.20322%2013.1389%208.21839%2013.1252C8.23708%2013.1083%208.2548%2013.0899%208.2728%2013.0719C8.29087%2013.0539%208.30922%2013.0361%208.32625%2013.0173C8.3399%2013.0023%208.35246%2012.986%208.36563%2012.9703C8.38515%2012.9469%208.40466%2012.9235%208.42266%2012.899C8.43308%2012.8848%208.4426%2012.8698%208.45253%2012.8551C8.47122%2012.8278%208.48956%2012.8004%208.50632%2012.7721C8.50908%2012.7674%208.51232%2012.7633%208.51501%2012.7586C8.52198%2012.7465%208.52722%2012.7339%208.53384%2012.7217C8.54825%2012.695%208.56246%2012.6684%208.57522%2012.641C8.58528%2012.6194%208.59418%2012.5976%208.60315%2012.5758Z'%20fill='%2329B5E8'/%3e%3cpath%20id='petal%204'%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M9.79594%2015.1724C9.43036%2015.1724%209.09504%2015.3017%208.83304%2015.5171L4.02007%2018.2958C3.29441%2018.7148%203.04579%2019.6427%203.46476%2020.3684C3.88372%2021.0941%204.81165%2021.3428%205.53731%2020.9238L8.2787%2019.3411V22.4827C8.2787%2023.3207%208.95801%2024%209.79594%2024C10.6339%2024%2011.3132%2023.3207%2011.3132%2022.4827V16.6896C11.3132%2015.8517%2010.6339%2015.1724%209.79594%2015.1724Z'%20fill='%2329B5E8'/%3e%3cpath%20id='petal%203'%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M21.2272%2018.2958L16.4142%2015.5171C16.1522%2015.3017%2015.8169%2015.1724%2015.4513%2015.1724C14.6134%2015.1724%2013.9341%2015.8517%2013.9341%2016.6896V22.4827C13.9341%2023.3207%2014.6134%2024%2015.4513%2024C16.2893%2024%2016.9686%2023.3207%2016.9686%2022.4827V19.3411L19.71%2020.9238C20.4356%2021.3428%2021.3636%2021.0941%2021.7826%2020.3684C22.2015%2019.6427%2021.9529%2018.7148%2021.2272%2018.2958Z'%20fill='%2329B5E8'/%3e%3cpath%20id='petal%202'%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M23.8219%2013.5826L21.0808%2012L23.8219%2010.4174C24.5476%209.99843%2024.7963%209.0705%2024.3773%208.34484C23.9584%207.61911%2023.0304%207.37049%2022.3047%207.78946L17.2877%2010.686C17.283%2010.6887%2017.2789%2010.692%2017.2743%2010.6947C17.2459%2010.7115%2017.2186%2010.7298%2017.1912%2010.7484C17.1766%2010.7584%2017.1615%2010.7679%2017.1473%2010.7784C17.1228%2010.7964%2017.0995%2010.8159%2017.0761%2010.8353C17.0603%2010.8484%2017.0441%2010.8611%2017.029%2010.8747C17.0101%2010.8917%2016.9926%2010.9101%2016.9745%2010.9282C16.9565%2010.9462%2016.9381%2010.9638%2016.921%2010.9826C16.9074%2010.9978%2016.8948%2011.014%2016.8817%2011.0297C16.8622%2011.0532%2016.8427%2011.0765%2016.8247%2011.101C16.8143%2011.1152%2016.8048%2011.1302%2016.7947%2011.1449C16.7761%2011.1722%2016.7578%2011.1995%2016.7411%2011.2279C16.7383%2011.2326%2016.735%2011.2366%2016.7323%2011.2414C16.7254%2011.2535%2016.7201%2011.2661%2016.7134%2011.2784C16.6991%2011.305%2016.6849%2011.3316%2016.6721%2011.359C16.6621%2011.3805%2016.6532%2011.4024%2016.6442%2011.4242C16.6348%2011.4469%2016.6256%2011.4697%2016.6174%2011.4928C16.6081%2011.5188%2016.6001%2011.5448%2016.5924%2011.5711C16.5865%2011.5911%2016.5806%2011.6112%2016.5756%2011.6315C16.5685%2011.6595%2016.5625%2011.6876%2016.5572%2011.7159C16.5534%2011.7358%2016.5498%2011.7557%2016.5468%2011.7757C16.5426%2011.8033%2016.5394%2011.8309%2016.5369%2011.8586C16.5348%2011.8805%2016.5331%2011.9025%2016.5319%2011.9246C16.5307%2011.9497%2016.5303%2011.9748%2016.5303%2012C16.5303%2012.0251%2016.5307%2012.0502%2016.5319%2012.0754C16.5331%2012.0975%2016.5348%2012.1194%2016.5369%2012.1415C16.5394%2012.1691%2016.5426%2012.1966%2016.5468%2012.2243C16.5498%2012.2444%2016.5534%2012.2642%2016.5572%2012.2841C16.5625%2012.3124%2016.5685%2012.3404%2016.5756%2012.3685C16.5806%2012.3888%2016.5865%2012.4088%2016.5924%2012.4289C16.6001%2012.4551%2016.6081%2012.4811%2016.6174%2012.5071C16.6256%2012.5303%2016.6348%2012.553%2016.6442%2012.5757C16.6532%2012.5976%2016.6621%2012.6194%2016.6721%2012.641C16.6849%2012.6684%2016.6991%2012.6951%2016.7135%2012.7217C16.7201%2012.7339%2016.7254%2012.7465%2016.7323%2012.7586C16.735%2012.7633%2016.7383%2012.7675%2016.741%2012.7721C16.7578%2012.8004%2016.7761%2012.8278%2016.7948%2012.8551C16.8048%2012.8697%2016.8143%2012.8849%2016.8247%2012.899C16.8427%2012.9235%2016.8622%2012.9469%2016.8818%2012.9703C16.8949%2012.986%2016.9074%2013.0022%2016.921%2013.0173C16.9381%2013.0361%2016.9565%2013.0538%2016.9746%2013.0719C16.9926%2013.0899%2017.0102%2013.1082%2017.029%2013.1252C17.0441%2013.1389%2017.0603%2013.1515%2017.0761%2013.1646C17.0995%2013.1842%2017.1228%2013.2037%2017.1473%2013.2216C17.1615%2013.2321%2017.1766%2013.2416%2017.1912%2013.2516C17.2186%2013.2702%2017.2459%2013.2885%2017.2743%2013.3053C17.2789%2013.308%2017.283%2013.3112%2017.2877%2013.314L22.3047%2016.2105C23.0304%2016.6295%2023.9584%2016.3809%2024.3773%2015.6552C24.7963%2014.9295%2024.5476%2014.0015%2023.8219%2013.5826Z'%20fill='%2329B5E8'/%3e%3cpath%20id='petal%201'%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M21.7826%203.63153C21.3636%202.90587%2020.4357%202.65718%2019.71%203.07614L16.9686%204.65891V1.51724C16.9686%200.679312%2016.2893%200%2015.4513%200C14.6134%200%2013.9341%200.679312%2013.9341%201.51724V7.31036C13.9341%208.14836%2014.6134%208.82761%2015.4513%208.82761C15.8169%208.82761%2016.1523%208.69823%2016.4142%208.48285L21.2272%205.70408C21.9529%205.28518%2022.2015%204.35718%2021.7826%203.63153Z'%20fill='%2329B5E8'/%3e%3c/g%3e%3c/svg%3e";
function DetachedHead() {
  return {
    title: "Unable to deploy",
    body: /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: "This Git tree is in a detached HEAD state." }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: "Please commit the latest changes and push to GitHub to continue." })
    ] })
  };
}
function ModuleIsNotAdded(o) {
  return {
    title: "Unable to deploy",
    body: /* @__PURE__ */ jsxRuntimeExports.jsx(StreamlitMarkdown$1, { source: `
The app's main file \`${o}\` has
not been pushed to GitHub. Please add it to continue.
`, allowHTML: !1 })
  };
}
const DEPLOY_URL = "https://share.streamlit.io/deploy", STREAMLIT_CLOUD_URL = "https://streamlit.io/cloud", STREAMLIT_COMMUNITY_CLOUD_DOCS_URL = "https://share.streamlit.io/cloud-getting-started", STREAMLIT_DEPLOY_TUTORIAL_URL = "https://share.streamlit.io/deployment-tutorial", SNOWFLAKE_LEARN_MORE_URL = "https://share.streamlit.io/sis-about", SNOWFLAKE_TRIAL_URL = "https://share.streamlit.io/snowflake-trial";
function _EMOTION_STRINGIFIED_CSS_ERROR__$4() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const StyledParagraph = /* @__PURE__ */ createStyled("p", process.env.NODE_ENV === "production" ? {
  target: "epbg7au0"
} : {
  target: "epbg7au0",
  label: "StyledParagraph"
})(process.env.NODE_ENV === "production" ? {
  name: "1aujq9w",
  styles: "text-align:justify"
} : {
  name: "1aujq9w",
  styles: "text-align:justify/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2FwcC9zcmMvY29tcG9uZW50cy9TdHJlYW1saXREaWFsb2cvRGVwbG95RXJyb3JEaWFsb2dzL3N0eWxlZC1jb21wb25lbnRzLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFrQitCIiwiZmlsZSI6Ii9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2FwcC9zcmMvY29tcG9uZW50cy9TdHJlYW1saXREaWFsb2cvRGVwbG95RXJyb3JEaWFsb2dzL3N0eWxlZC1jb21wb25lbnRzLnRzeCIsInNvdXJjZXNDb250ZW50IjpbIi8qKlxuICogQ29weXJpZ2h0IChjKSBTdHJlYW1saXQgSW5jLiAoMjAxOC0yMDIyKSBTbm93Zmxha2UgSW5jLiAoMjAyMi0yMDI1KVxuICpcbiAqIExpY2Vuc2VkIHVuZGVyIHRoZSBBcGFjaGUgTGljZW5zZSwgVmVyc2lvbiAyLjAgKHRoZSBcIkxpY2Vuc2VcIik7XG4gKiB5b3UgbWF5IG5vdCB1c2UgdGhpcyBmaWxlIGV4Y2VwdCBpbiBjb21wbGlhbmNlIHdpdGggdGhlIExpY2Vuc2UuXG4gKiBZb3UgbWF5IG9idGFpbiBhIGNvcHkgb2YgdGhlIExpY2Vuc2UgYXRcbiAqXG4gKiAgICAgaHR0cDovL3d3dy5hcGFjaGUub3JnL2xpY2Vuc2VzL0xJQ0VOU0UtMi4wXG4gKlxuICogVW5sZXNzIHJlcXVpcmVkIGJ5IGFwcGxpY2FibGUgbGF3IG9yIGFncmVlZCB0byBpbiB3cml0aW5nLCBzb2Z0d2FyZVxuICogZGlzdHJpYnV0ZWQgdW5kZXIgdGhlIExpY2Vuc2UgaXMgZGlzdHJpYnV0ZWQgb24gYW4gXCJBUyBJU1wiIEJBU0lTLFxuICogV0lUSE9VVCBXQVJSQU5USUVTIE9SIENPTkRJVElPTlMgT0YgQU5ZIEtJTkQsIGVpdGhlciBleHByZXNzIG9yIGltcGxpZWQuXG4gKiBTZWUgdGhlIExpY2Vuc2UgZm9yIHRoZSBzcGVjaWZpYyBsYW5ndWFnZSBnb3Zlcm5pbmcgcGVybWlzc2lvbnMgYW5kXG4gKiBsaW1pdGF0aW9ucyB1bmRlciB0aGUgTGljZW5zZS5cbiAqL1xuXG5pbXBvcnQgc3R5bGVkIGZyb20gXCJAZW1vdGlvbi9zdHlsZWRcIlxuXG5leHBvcnQgY29uc3QgU3R5bGVkUGFyYWdyYXBoID0gc3R5bGVkLnAoe1xuICB0ZXh0QWxpZ246IFwianVzdGlmeVwiLFxufSlcbiJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$4
});
function NoRepositoryDetected() {
  return {
    title: "Unable to deploy",
    body: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledParagraph, { children: [
      "The app’s code is not connected to a remote GitHub repository. To deploy on Streamlit Community Cloud, please put your code in a GitHub repository and publish the current branch. Read more in",
      " ",
      /* @__PURE__ */ jsxRuntimeExports.jsx("a", { href: STREAMLIT_COMMUNITY_CLOUD_DOCS_URL, rel: "noopener noreferrer", target: "_blank", children: "our documentation" }),
      "."
    ] })
  };
}
function DeployCard(o) {
  const {
    colors: E,
    spacing: A,
    radii: g,
    breakpoints: e,
    sizes: t
  } = useEmotionTheme(), {
    children: c
  } = o;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Card, { overrides: {
    Root: {
      style: {
        borderTopWidth: t.borderWidth,
        borderBottomWidth: t.borderWidth,
        borderLeftWidth: t.borderWidth,
        borderRightWidth: t.borderWidth,
        borderTopStyle: "solid",
        borderBottomStyle: "none",
        borderLeftStyle: "none",
        borderRightStyle: "solid",
        borderTopColor: E.borderColor,
        borderBottomColor: E.borderColor,
        borderLeftColor: E.borderColor,
        borderRightColor: E.borderColor,
        borderTopLeftRadius: "none",
        borderTopRightRadius: "none",
        borderBottomLeftRadius: "none",
        borderBottomRightRadius: "none",
        ":last-child": {
          borderRightStyle: "none",
          borderBottomRightRadius: g.xl
        },
        ":first-child": {
          borderBottomLeftRadius: g.xl
        },
        [`@media (max-width: ${e.md})`]: {
          ":last-child": {
            borderBottomLeftRadius: g.xl
          }
        }
      }
    },
    Contents: {
      style: {
        marginBottom: 0,
        marginTop: 0,
        marginLeft: 0,
        marginRight: 0,
        height: "100%"
      }
    },
    Body: {
      style: {
        padding: A.twoXL,
        marginBottom: 0,
        marginTop: 0,
        marginLeft: 0,
        marginRight: 0,
        height: "100%",
        display: "flex",
        flexDirection: "column",
        [`@media (max-width: ${e.md})`]: {
          padding: A.xl
        }
      }
    }
  }, children: c });
}
const Checkmark = "data:image/svg+xml,%3csvg%20width='12'%20height='9'%20viewBox='0%200%2012%209'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M4.00009%206.78L1.68676%204.46667C1.42676%204.20667%201.00676%204.20667%200.746758%204.46667C0.486758%204.72667%200.486758%205.14667%200.746758%205.40667L3.53342%208.19334C3.79342%208.45334%204.21342%208.45334%204.47342%208.19334L11.5268%201.14C11.7868%200.880005%2011.7868%200.460005%2011.5268%200.200005C11.2668%20-0.0599951%2010.8468%20-0.0599951%2010.5868%200.200005L4.00009%206.78Z'%20fill='%23808495'/%3e%3c/svg%3e", StyledHeader$1 = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e97l2ve4"
} : {
  target: "e97l2ve4",
  label: "StyledHeader"
})(({
  theme: o
}) => ({
  // We do not want to change the font for this based on theme.
  fontFamily: o.fonts.sansSerif,
  fontWeight: o.fontWeights.bold,
  fontSize: o.fontSizes.lg,
  marginTop: o.spacing.twoXL,
  marginBottom: o.spacing.twoXS,
  [`@media (max-width: ${o.breakpoints.md})`]: {
    marginTop: o.spacing.md
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledSubheader = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e97l2ve3"
} : {
  target: "e97l2ve3",
  label: "StyledSubheader"
})(({
  theme: o
}) => ({
  // We do not want to change the font for this based on theme.
  fontFamily: o.fonts.sansSerif,
  fontWeight: o.fontWeights.normal,
  fontSize: o.fontSizes.md,
  marginTop: o.spacing.twoXS,
  marginBottom: o.spacing.md,
  [`@media (max-width: ${o.breakpoints.md})`]: {
    marginTop: o.spacing.md
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledCardContainer = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e97l2ve2"
} : {
  target: "e97l2ve2",
  label: "StyledCardContainer"
})(({
  theme: o
}) => ({
  display: "grid",
  maxWidth: `calc(1.25 * ${o.sizes.contentMaxWidth})`,
  gridTemplateColumns: "1fr 1fr 1fr",
  gridGap: o.spacing.none,
  [`@media (max-width: ${o.breakpoints.md})`]: {
    gridTemplateColumns: "1fr"
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledElement = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e97l2ve1"
} : {
  target: "e97l2ve1",
  label: "StyledElement"
})(({
  theme: o
}) => ({
  display: "inline-flex",
  marginTop: o.spacing.sm,
  "& > span": {
    // We do not want to change the font for this based on theme.
    fontFamily: o.fonts.sansSerif,
    fontWeight: o.fontWeights.normal,
    fontSize: o.fontSizes.md,
    marginLeft: o.spacing.twoXL,
    color: o.colors.gray70
  },
  "& > img": {
    position: "absolute",
    marginTop: o.spacing.sm
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledActionsWrapper = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e97l2ve0"
} : {
  target: "e97l2ve0",
  label: "StyledActionsWrapper"
})(({
  theme: o
}) => ({
  display: "flex",
  marginTop: o.spacing.threeXL,
  "& > button": {
    marginRight: o.spacing.twoXL
  },
  [`@media (max-width: ${o.breakpoints.md})`]: {
    marginTop: o.spacing.xl
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
function DeployListElement(o) {
  const {
    children: E
  } = o;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledElement, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: Checkmark, alt: "Checkmark" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: E })
  ] });
}
function ModalBody({
  children: o
}) {
  const {
    colors: E,
    fontSizes: A,
    spacing: g
  } = useEmotionTheme();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ModalBody$2, { style: {
    marginTop: g.none,
    marginLeft: g.none,
    marginRight: g.none,
    marginBottom: g.none,
    paddingTop: g.md,
    paddingRight: g.none,
    paddingBottom: g.none,
    paddingLeft: g.none,
    color: E.bodyText,
    fontSize: A.md,
    overflowY: "auto"
  }, children: o });
}
function DeployModal(o) {
  const {
    children: E,
    onClose: A
  } = o;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Modal, { isOpen: !0, closeable: !0, onClose: A, size: "auto", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalHeader, { children: "Deploy this app using..." }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalBody, { children: E })
  ] });
}
const {
  GitStates
} = GitInfo, openUrl = (o) => {
  window.open(o, "_blank");
}, getDeployAppUrl = (o) => {
  if (o) {
    const E = new URL(DEPLOY_URL);
    return E.searchParams.set("repository", o.repository ?? ""), E.searchParams.set("branch", o.branch ?? ""), E.searchParams.set("mainModule", o.module ?? ""), E.toString();
  }
  return STREAMLIT_CLOUD_URL;
};
function DeployDialog(o) {
  const {
    gitInfo: E,
    onClose: A,
    metricsMgr: g,
    showDeployError: e,
    isDeployErrorModalOpen: t
  } = o, c = useCallback(() => {
    if (g.enqueue("menuClick", {
      label: "deployButtonInDialog"
    }), !E) {
      const S = NoRepositoryDetected();
      e(S.title, S.body);
      return;
    }
    const {
      repository: n,
      branch: h,
      module: d,
      untrackedFiles: k,
      state: p
    } = E;
    if ((!n || !h || !d) && p === GitStates.DEFAULT) {
      const S = NoRepositoryDetected();
      e(S.title, S.body);
      return;
    }
    if (p === GitStates.HEAD_DETACHED) {
      const S = DetachedHead();
      e(S.title, S.body);
      return;
    }
    if (d && k?.includes(d)) {
      const S = ModuleIsNotAdded(d);
      e(S.title, S.body);
      return;
    }
    t && A(), openUrl(getDeployAppUrl(E));
  }, [g, E, t, e, A]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(DeployModal, { onClose: A, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledCardContainer, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(DeployCard, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs(Body, { style: {
        flexGrow: 1
      }, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: StreamlitLogo, alt: "Streamlit Logo", "data-testid": "stDeployDialogCommunityCloudIcon" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(StyledHeader$1, { children: "Streamlit Community Cloud" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(StyledSubheader, { children: "For community, always free" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(DeployListElement, { children: "For personal hobbies and learning" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(DeployListElement, { children: "Deploy unlimited public apps" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(DeployListElement, { children: "Explore and learn from Streamlit’s community and popular apps" })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Action, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledActionsWrapper, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(BaseButton, { kind: BaseButtonKind.PRIMARY, onClick: c, children: "Deploy now" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(BaseButton, { onClick: () => {
          g.enqueue("menuClick", {
            label: "readMoreCommunityCloudInDeployDialog"
          }), openUrl(STREAMLIT_COMMUNITY_CLOUD_DOCS_URL);
        }, kind: BaseButtonKind.MINIMAL, children: "Learn more" })
      ] }) })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(DeployCard, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs(Body, { style: {
        flexGrow: 1
      }, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: Snowflake, alt: "Snowflake", "data-testid": "stDeployDialogSnowflakeDeploymentIcon" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(StyledHeader$1, { children: "Snowflake" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(StyledSubheader, { children: "For enterprise" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(DeployListElement, { children: "Enterprise-level security, support, and fully managed infrastructure" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(DeployListElement, { children: "Deploy unlimited private apps with role-based sharing" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(DeployListElement, { children: "Integrate with Snowflake’s full data stack" })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Action, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledActionsWrapper, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(BaseButton, { kind: BaseButtonKind.SECONDARY, onClick: () => {
          g.enqueue("menuClick", {
            label: "startTrialInDeployDialog"
          }), openUrl(SNOWFLAKE_TRIAL_URL);
        }, children: "Start trial" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(BaseButton, { onClick: () => {
          g.enqueue("menuClick", {
            label: "learnMoreSnowflakeInDeployDialog"
          }), openUrl(SNOWFLAKE_LEARN_MORE_URL);
        }, kind: BaseButtonKind.MINIMAL, children: "Learn more" })
      ] }) })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(DeployCard, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs(Body, { style: {
        flexGrow: 2
      }, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: Rocket, alt: "Rocket", "data-testid": "stDeployDialogCustomDeploymentIcon" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(StyledHeader$1, { children: "Other platforms" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(StyledSubheader, { children: "For custom deployment " }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(DeployListElement, { children: "Deploy on your own hardware or cloud service" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(DeployListElement, { children: "Set up and maintain your own authentication, resources, and costs" })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Action, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledActionsWrapper, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(BaseButton, { onClick: () => {
        g.enqueue("menuClick", {
          label: "readMoreDeployTutorialInDeployDialog"
        }), openUrl(STREAMLIT_DEPLOY_TUTORIAL_URL);
      }, kind: BaseButtonKind.MINIMAL, children: "Learn more" }) }) })
    ] })
  ] }) });
}
const StyledDialogBody = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e1x90zqc8"
} : {
  target: "e1x90zqc8",
  label: "StyledDialogBody"
})(({
  theme: o
}) => ({
  display: "grid",
  gap: o.spacing.twoXL,
  gridTemplateColumns: "1fr 1fr",
  margin: 0,
  padding: 0
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledFullRow = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e1x90zqc7"
} : {
  target: "e1x90zqc7",
  label: "StyledFullRow"
})(({
  theme: o
}) => ({
  gridColumnStart: 1,
  gridColumnEnd: -1,
  display: "grid",
  gap: o.spacing.xs
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledHeader = /* @__PURE__ */ createStyled("h2", process.env.NODE_ENV === "production" ? {
  target: "e1x90zqc6"
} : {
  target: "e1x90zqc6",
  label: "StyledHeader"
})(({
  theme: o
}) => ({
  paddingBottom: 0,
  paddingTop: 0,
  marginBottom: o.spacing.md,
  marginTop: "0",
  fontWeight: o.fontWeights.bold,
  fontSize: o.fontSizes.md,
  lineHeight: o.lineHeights.tight,
  color: o.colors.bodyText,
  display: "grid",
  gridAutoFlow: "row",
  gap: o.spacing.xs,
  // Override the default global style for a h2:first-of-type
  "&:first-of-type": {
    marginTop: 0
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledLabel = /* @__PURE__ */ createStyled("label", process.env.NODE_ENV === "production" ? {
  target: "e1x90zqc5"
} : {
  target: "e1x90zqc5",
  label: "StyledLabel"
})(({
  theme: o
}) => ({
  paddingBottom: 0,
  paddingTop: 0,
  marginBottom: 0,
  marginTop: 0,
  lineHeight: o.lineHeights.tight,
  fontSize: o.fontSizes.sm
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2FwcC9zcmMvY29tcG9uZW50cy9TdHJlYW1saXREaWFsb2cvc3R5bGVkLWNvbXBvbmVudHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBb0QyQiIsImZpbGUiOiIvaG9tZS9ydW5uZXIvd29yay9zdGxpdGUvc3RsaXRlL3N0cmVhbWxpdC9mcm9udGVuZC9hcHAvc3JjL2NvbXBvbmVudHMvU3RyZWFtbGl0RGlhbG9nL3N0eWxlZC1jb21wb25lbnRzLnRzIiwic291cmNlc0NvbnRlbnQiOlsiLyoqXG4gKiBDb3B5cmlnaHQgKGMpIFN0cmVhbWxpdCBJbmMuICgyMDE4LTIwMjIpIFNub3dmbGFrZSBJbmMuICgyMDIyLTIwMjUpXG4gKlxuICogTGljZW5zZWQgdW5kZXIgdGhlIEFwYWNoZSBMaWNlbnNlLCBWZXJzaW9uIDIuMCAodGhlIFwiTGljZW5zZVwiKTtcbiAqIHlvdSBtYXkgbm90IHVzZSB0aGlzIGZpbGUgZXhjZXB0IGluIGNvbXBsaWFuY2Ugd2l0aCB0aGUgTGljZW5zZS5cbiAqIFlvdSBtYXkgb2J0YWluIGEgY29weSBvZiB0aGUgTGljZW5zZSBhdFxuICpcbiAqICAgICBodHRwOi8vd3d3LmFwYWNoZS5vcmcvbGljZW5zZXMvTElDRU5TRS0yLjBcbiAqXG4gKiBVbmxlc3MgcmVxdWlyZWQgYnkgYXBwbGljYWJsZSBsYXcgb3IgYWdyZWVkIHRvIGluIHdyaXRpbmcsIHNvZnR3YXJlXG4gKiBkaXN0cmlidXRlZCB1bmRlciB0aGUgTGljZW5zZSBpcyBkaXN0cmlidXRlZCBvbiBhbiBcIkFTIElTXCIgQkFTSVMsXG4gKiBXSVRIT1VUIFdBUlJBTlRJRVMgT1IgQ09ORElUSU9OUyBPRiBBTlkgS0lORCwgZWl0aGVyIGV4cHJlc3Mgb3IgaW1wbGllZC5cbiAqIFNlZSB0aGUgTGljZW5zZSBmb3IgdGhlIHNwZWNpZmljIGxhbmd1YWdlIGdvdmVybmluZyBwZXJtaXNzaW9ucyBhbmRcbiAqIGxpbWl0YXRpb25zIHVuZGVyIHRoZSBMaWNlbnNlLlxuICovXG5cbmltcG9ydCBzdHlsZWQgZnJvbSBcIkBlbW90aW9uL3N0eWxlZFwiXG5cbmV4cG9ydCBjb25zdCBTdHlsZWREaWFsb2dCb2R5ID0gc3R5bGVkLmRpdigoeyB0aGVtZSB9KSA9PiAoe1xuICBkaXNwbGF5OiBcImdyaWRcIixcbiAgZ2FwOiB0aGVtZS5zcGFjaW5nLnR3b1hMLFxuICBncmlkVGVtcGxhdGVDb2x1bW5zOiBcIjFmciAxZnJcIixcbiAgbWFyZ2luOiAwLFxuICBwYWRkaW5nOiAwLFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRGdWxsUm93ID0gc3R5bGVkLmRpdigoeyB0aGVtZSB9KSA9PiAoe1xuICBncmlkQ29sdW1uU3RhcnQ6IDEsXG4gIGdyaWRDb2x1bW5FbmQ6IC0xLFxuICBkaXNwbGF5OiBcImdyaWRcIixcbiAgZ2FwOiB0aGVtZS5zcGFjaW5nLnhzLFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRIZWFkZXIgPSBzdHlsZWQuaDIoKHsgdGhlbWUgfSkgPT4gKHtcbiAgcGFkZGluZ0JvdHRvbTogMCxcbiAgcGFkZGluZ1RvcDogMCxcbiAgbWFyZ2luQm90dG9tOiB0aGVtZS5zcGFjaW5nLm1kLFxuICBtYXJnaW5Ub3A6IFwiMFwiLFxuICBmb250V2VpZ2h0OiB0aGVtZS5mb250V2VpZ2h0cy5ib2xkLFxuICBmb250U2l6ZTogdGhlbWUuZm9udFNpemVzLm1kLFxuICBsaW5lSGVpZ2h0OiB0aGVtZS5saW5lSGVpZ2h0cy50aWdodCxcbiAgY29sb3I6IHRoZW1lLmNvbG9ycy5ib2R5VGV4dCxcbiAgZGlzcGxheTogXCJncmlkXCIsXG4gIGdyaWRBdXRvRmxvdzogXCJyb3dcIixcbiAgZ2FwOiB0aGVtZS5zcGFjaW5nLnhzLFxuXG4gIC8vIE92ZXJyaWRlIHRoZSBkZWZhdWx0IGdsb2JhbCBzdHlsZSBmb3IgYSBoMjpmaXJzdC1vZi10eXBlXG4gIFwiJjpmaXJzdC1vZi10eXBlXCI6IHtcbiAgICBtYXJnaW5Ub3A6IDAsXG4gIH0sXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZExhYmVsID0gc3R5bGVkLmxhYmVsKCh7IHRoZW1lIH0pID0+ICh7XG4gIHBhZGRpbmdCb3R0b206IDAsXG4gIHBhZGRpbmdUb3A6IDAsXG4gIG1hcmdpbkJvdHRvbTogMCxcbiAgbWFyZ2luVG9wOiAwLFxuICBsaW5lSGVpZ2h0OiB0aGVtZS5saW5lSGVpZ2h0cy50aWdodCxcbiAgZm9udFNpemU6IHRoZW1lLmZvbnRTaXplcy5zbSxcbn0pKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkSHIgPSBzdHlsZWQuaHIoKHsgdGhlbWUgfSkgPT4gKHtcbiAgcGFkZGluZzogMCxcbiAgbWFyZ2luQm90dG9tOiAwLFxuICBtYXJnaW5MZWZ0OiBgLSR7dGhlbWUuc3BhY2luZy54bH1gLFxuICBtYXJnaW5SaWdodDogYC0ke3RoZW1lLnNwYWNpbmcueGx9YCxcbiAgbWFyZ2luVG9wOiAwLFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRCdXR0b25Db250YWluZXIgPSBzdHlsZWQuZGl2KCh7IHRoZW1lIH0pID0+ICh7XG4gIG1hcmdpblRvcDogdGhlbWUuc3BhY2luZy5tZCxcbn0pKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkQ2hlY2tib3ggPSBzdHlsZWQuaW5wdXQoKHsgdGhlbWUgfSkgPT4gKHtcbiAgbWFyZ2luUmlnaHQ6IHRoZW1lLnNwYWNpbmcueHMsXG4gIGFwcGVhcmFuY2U6IFwibm9uZVwiLFxuICBib3JkZXI6IGAke3RoZW1lLnNpemVzLmJvcmRlcldpZHRofSBzb2xpZCAke3RoZW1lLmNvbG9ycy5ib3JkZXJDb2xvcn1gLFxuICB3aWR0aDogdGhlbWUuZm9udFNpemVzLm1kLFxuICBoZWlnaHQ6IHRoZW1lLmZvbnRTaXplcy5tZCxcbiAgYm9yZGVyUmFkaXVzOiBgbWluKCR7dGhlbWUucmFkaWkubWR9LCAke3RoZW1lLnJhZGlpLm1heENoZWNrYm94fSlgLFxuICBkaXNwbGF5OiBcImlubGluZS1mbGV4XCIsXG4gIGFsaWduSXRlbXM6IFwiY2VudGVyXCIsXG4gIGp1c3RpZnlDb250ZW50OiBcImNlbnRlclwiLFxuICBwYWRkaW5nOiAwLFxuICB2ZXJ0aWNhbEFsaWduOiBcIm1pZGRsZVwiLFxuICBvdmVyZmxvdzogXCJoaWRkZW5cIixcblxuICBcIiY6Zm9jdXMtdmlzaWJsZVwiOiB7XG4gICAgb3V0bGluZTogYDJweCBzb2xpZCAke3RoZW1lLmNvbG9ycy5wcmltYXJ5fWAsXG4gIH0sXG5cbiAgXCImOmNoZWNrZWRcIjoge1xuICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLnByaW1hcnksXG5cbiAgICBcIiY6YWZ0ZXJcIjoge1xuICAgICAgY29udGVudDogJ1wi4pyTXCInLFxuICAgICAgZm9udEZhbWlseTogdGhlbWUuZm9udHMubW9ub3NwYWNlLFxuICAgICAgZm9udFNpemU6IHRoZW1lLmZvbnRTaXplcy5tZCxcbiAgICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMud2hpdGUsXG4gICAgICBsaW5lSGVpZ2h0OiB0aGVtZS5saW5lSGVpZ2h0cy5ub25lLFxuICAgIH0sXG4gIH0sXG5cbiAgXCImOmRpc2FibGVkXCI6IHtcbiAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5kYXJrZW5lZEJnTWl4MTUsXG4gIH0sXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZERlcGxveUVycm9yQ29udGVudCA9IHN0eWxlZC5kaXYoKHsgdGhlbWUgfSkgPT4gKHtcbiAgXCImID4gdWxcIjoge1xuICAgIHBhZGRpbmdMZWZ0OiB0aGVtZS5zcGFjaW5nLnR3b1hMLFxuICB9LFxufSkpXG5cbmludGVyZmFjZSBTdHlsZWRFcnJvclRleHRQcm9wcyB7XG4gIGhhc0NvZGVCZWxvdzogYm9vbGVhblxufVxuXG5leHBvcnQgY29uc3QgU3R5bGVkRXJyb3JUZXh0ID0gc3R5bGVkLmRpdjxTdHlsZWRFcnJvclRleHRQcm9wcz4oXG4gICh7IHRoZW1lLCBoYXNDb2RlQmVsb3cgfSkgPT4gKHtcbiAgICAuLi4oaGFzQ29kZUJlbG93ICYmIHtcbiAgICAgIG1hcmdpbkJvdHRvbTogdGhlbWUuc3BhY2luZy5sZyxcbiAgICB9KSxcbiAgfSlcbilcbiJdfQ== */");
process.env.NODE_ENV;
process.env.NODE_ENV;
const StyledCheckbox = /* @__PURE__ */ createStyled("input", process.env.NODE_ENV === "production" ? {
  target: "e1x90zqc2"
} : {
  target: "e1x90zqc2",
  label: "StyledCheckbox"
})(({
  theme: o
}) => ({
  marginRight: o.spacing.xs,
  appearance: "none",
  border: `${o.sizes.borderWidth} solid ${o.colors.borderColor}`,
  width: o.fontSizes.md,
  height: o.fontSizes.md,
  borderRadius: `min(${o.radii.md}, ${o.radii.maxCheckbox})`,
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  padding: 0,
  verticalAlign: "middle",
  overflow: "hidden",
  "&:focus-visible": {
    outline: `2px solid ${o.colors.primary}`
  },
  "&:checked": {
    backgroundColor: o.colors.primary,
    "&:after": {
      content: '"✓"',
      fontFamily: o.fonts.monospace,
      fontSize: o.fontSizes.md,
      color: o.colors.white,
      lineHeight: o.lineHeights.none
    }
  },
  "&:disabled": {
    backgroundColor: o.colors.darkenedBgMix15
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledDeployErrorContent = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e1x90zqc1"
} : {
  target: "e1x90zqc1",
  label: "StyledDeployErrorContent"
})(({
  theme: o
}) => ({
  "& > ul": {
    paddingLeft: o.spacing.twoXL
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledErrorText = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e1x90zqc0"
} : {
  target: "e1x90zqc0",
  label: "StyledErrorText"
})(({
  theme: o,
  hasCodeBelow: E
}) => ({
  ...E && {
    marginBottom: o.spacing.lg
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), SettingsDialog = memo(function o({
  isServerConnected: E,
  onClose: A,
  onSave: g,
  settings: e,
  allowRunOnSave: t,
  animateModal: c,
  metricsMgr: n,
  sessionInfo: h
}) {
  const {
    activeTheme: d,
    availableThemes: k,
    setTheme: p
  } = useContext(ThemeContext), M = useRef(e), S = useRef(!0), [AA, H] = useState({
    ...e
  }), gA = useCallback((QA, EA) => {
    H((oA) => ({
      ...oA,
      [QA]: EA
    }));
  }, []);
  useEffect(() => {
    if (S.current) {
      S.current = !1;
      return;
    }
    M.current = AA, g(M.current);
  }, [g, AA]);
  const CA = useCallback((QA) => {
    gA(QA.target.name, QA.target.checked);
  }, [gA]), IA = useCallback((QA) => {
    let EA;
    QA && (EA = k.find((oA) => oA.name.startsWith("Custom Theme") ? oA.displayName === QA : oA.name === QA)), EA === void 0 && (EA = k[0]), n.enqueue("menuClick", {
      label: "changeTheme"
    }), p(EA);
  }, [p, n, k]), BA = useCallback(() => k.map((QA) => QA.displayName ?? QA.name), [k]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Modal, { animate: c, isOpen: !0, onClose: A, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalHeader, { children: "Settings" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalBody$1, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledDialogBody, { children: [
      t && /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledFullRow, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(StyledHeader, { children: "Development" }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("label", { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(StyledCheckbox, { disabled: !E, type: "checkbox", name: "runOnSave", checked: AA.runOnSave && E, onChange: CA }),
          " ",
          "Run on save"
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(StreamlitMarkdown$1, { source: "Automatically updates the app when the underlying code is updated.", allowHTML: !1, isCaption: !0 })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledFullRow, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(StyledHeader, { children: "Appearance" }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("label", { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(StyledCheckbox, { type: "checkbox", name: "wideMode", checked: AA.wideMode, onChange: CA }),
          " ",
          "Wide mode"
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(StreamlitMarkdown$1, { source: " Turn on to make this app occupy the entire width of the screen.", allowHTML: !1, isCaption: !0 })
      ] }),
      !!k.length && /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledFullRow, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(StyledLabel, { children: "Choose app theme" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(UISelectbox, { options: BA(), disabled: d.name === CUSTOM_THEME_NAME, onChange: IA, value: d.displayName ?? d.name, placeholder: "", acceptNewOptions: !1 })
      ] }),
      h.isSet && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { "data-testid": "stVersionInfo", children: /* @__PURE__ */ jsxRuntimeExports.jsx(StreamlitMarkdown$1, { source: `Made with Streamlit ${h.current.streamlitVersion}`, allowHTML: !1, isCaption: !0 }) })
    ] }) })
  ] });
});
function StreamlitDialog(o) {
  switch (o.type) {
    case DialogType.ABOUT:
      return /* @__PURE__ */ jsxRuntimeExports.jsx(AboutDialog, { ...o });
    case DialogType.CLEAR_CACHE:
      return /* @__PURE__ */ jsxRuntimeExports.jsx(ClearCacheDialog, { ...o });
    case DialogType.SETTINGS:
      return /* @__PURE__ */ jsxRuntimeExports.jsx(SettingsDialog, { ...o });
    case DialogType.SCRIPT_COMPILE_ERROR:
      return /* @__PURE__ */ jsxRuntimeExports.jsx(ScriptCompileErrorDialog, { ...o });
    case DialogType.WARNING:
    case DialogType.CONNECTION_ERROR:
      return /* @__PURE__ */ jsxRuntimeExports.jsx(WarningDialog, { ...o });
    case DialogType.DEPLOY_DIALOG:
      return /* @__PURE__ */ jsxRuntimeExports.jsx(DeployDialog, { ...o });
    case DialogType.DEPLOY_ERROR:
      return /* @__PURE__ */ jsxRuntimeExports.jsx(DeployErrorDialog, { ...o });
    case void 0:
      return noDialog(o);
    default:
      return typeNotRecognizedDialog(o);
  }
}
function AboutDialog(o) {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Modal, { isOpen: !0, onClose: o.onClose, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalHeader, { children: "About" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalBody$1, { children: o.aboutSectionMd && /* @__PURE__ */ jsxRuntimeExports.jsx(StreamlitMarkdown$1, { source: o.aboutSectionMd, allowHTML: !1 }) })
  ] });
}
function ClearCacheDialog(o) {
  const A = ["**Are you sure you want to clear the app's function caches?**", "This will remove all cached entries from functions using", "`@st.cache_data` and `@st.cache_resource`."].join(`  
`);
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { "data-testid": "stClearCacheDialog", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Modal, { isOpen: !0, onClose: o.onClose, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalHeader, { children: "Clear caches" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalBody$1, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(StreamlitMarkdown$1, { source: A, allowHTML: !1 }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(ModalFooter, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(ModalButton, { kind: BaseButtonKind.GHOST, onClick: o.onClose, children: "Cancel" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(ModalButton, { autoFocus: !0, kind: BaseButtonKind.SECONDARY, onClick: o.confirmCallback, children: "Clear caches" })
    ] })
  ] }) });
}
function ScriptCompileErrorDialog(o) {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Modal, { isOpen: !0, onClose: o.onClose, size: "auto", autoFocus: !1, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalHeader, { children: "Script execution error" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalBody$1, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(StreamlitErrorCodeBlock$1, { children: o.exception?.message ? o.exception.message : "No message" }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalFooter, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(ModalButton, { kind: BaseButtonKind.SECONDARY, onClick: o.onClose, children: "Close" }) })
  ] });
}
function WarningDialog(o) {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Modal, { isOpen: !0, onClose: o.onClose, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalHeader, { children: o.title }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalBody$1, { children: o.msg })
  ] });
}
function DeployErrorDialog({
  title: o,
  msg: E,
  onClose: A,
  onContinue: g,
  onTryAgain: e
}) {
  const t = () => {
    A(), g && g();
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Modal, { isOpen: !0, onClose: A, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalHeader, { children: o }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalBody$1, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledDeployErrorContent, { children: E }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(ModalFooter, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(ModalButton, { kind: BaseButtonKind.GHOST, onClick: e, children: "Try again" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(ModalButton, { kind: BaseButtonKind.SECONDARY, onClick: t, children: g ? "Continue anyway" : "Close" })
    ] })
  ] });
}
function noDialog({
  onClose: o
}) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Modal, { isOpen: !1, onClose: o });
}
function typeNotRecognizedDialog(o) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Modal, { isOpen: !0, onClose: o.onClose, children: /* @__PURE__ */ jsxRuntimeExports.jsx(ModalBody$1, { children: `Dialog type "${o.type}" not recognized.` }) });
}
function parseLinks(o) {
  const E = [];
  let A = 0, g = 0;
  const e = /\[([^\]]+)\]\(([^)]+)\)/g;
  let t;
  for (; (t = e.exec(o)) !== null; )
    t.index > A && E.push(/* @__PURE__ */ jsxRuntimeExports.jsx(Fragment, { children: o.substring(A, t.index) }, g++)), E.push(/* @__PURE__ */ jsxRuntimeExports.jsx("a", { href: t[2], target: "_blank", rel: "noopener noreferrer", children: t[1] }, g++)), A = t.index + t[0].length;
  return A < o.length && E.push(/* @__PURE__ */ jsxRuntimeExports.jsx(Fragment, { children: o.substring(A) }, g++)), E;
}
function DialogErrorMessage({
  message: o,
  codeBlock: E
}) {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(StyledErrorText, { hasCodeBelow: !!E, children: parseLinks(o) }),
    E && /* @__PURE__ */ jsxRuntimeExports.jsx(StreamlitErrorCodeBlock$1, { children: E })
  ] });
}
const DialogErrorMessage$1 = memo(DialogErrorMessage);
function _EMOTION_STRINGIFIED_CSS_ERROR__$3() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const StyledActionButtonContainer = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e3g6aar2"
} : {
  target: "e3g6aar2",
  label: "StyledActionButtonContainer"
})(({
  theme: o
}) => ({
  display: "flex",
  gap: o.spacing.sm,
  alignItems: "center",
  // line height should be the same as the icon size
  lineHeight: o.iconSizes.md
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledActionButtonIcon = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e3g6aar1"
} : {
  target: "e3g6aar1",
  label: "StyledActionButtonIcon"
})(({
  theme: o,
  icon: E
}) => ({
  background: `url("${E}") no-repeat center / contain`,
  width: o.iconSizes.base,
  height: o.iconSizes.base
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledToolbarActions = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e3g6aar0"
} : {
  target: "e3g6aar0",
  label: "StyledToolbarActions"
})(process.env.NODE_ENV === "production" ? {
  name: "ye2gio",
  styles: "display:flex;align-items:center;flex-direction:row"
} : {
  name: "ye2gio",
  styles: "display:flex;align-items:center;flex-direction:row/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2FwcC9zcmMvY29tcG9uZW50cy9Ub29sYmFyQWN0aW9ucy9zdHlsZWQtY29tcG9uZW50cy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFzQ29DIiwiZmlsZSI6Ii9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2FwcC9zcmMvY29tcG9uZW50cy9Ub29sYmFyQWN0aW9ucy9zdHlsZWQtY29tcG9uZW50cy50cyIsInNvdXJjZXNDb250ZW50IjpbIi8qKlxuICogQ29weXJpZ2h0IChjKSBTdHJlYW1saXQgSW5jLiAoMjAxOC0yMDIyKSBTbm93Zmxha2UgSW5jLiAoMjAyMi0yMDI1KVxuICpcbiAqIExpY2Vuc2VkIHVuZGVyIHRoZSBBcGFjaGUgTGljZW5zZSwgVmVyc2lvbiAyLjAgKHRoZSBcIkxpY2Vuc2VcIik7XG4gKiB5b3UgbWF5IG5vdCB1c2UgdGhpcyBmaWxlIGV4Y2VwdCBpbiBjb21wbGlhbmNlIHdpdGggdGhlIExpY2Vuc2UuXG4gKiBZb3UgbWF5IG9idGFpbiBhIGNvcHkgb2YgdGhlIExpY2Vuc2UgYXRcbiAqXG4gKiAgICAgaHR0cDovL3d3dy5hcGFjaGUub3JnL2xpY2Vuc2VzL0xJQ0VOU0UtMi4wXG4gKlxuICogVW5sZXNzIHJlcXVpcmVkIGJ5IGFwcGxpY2FibGUgbGF3IG9yIGFncmVlZCB0byBpbiB3cml0aW5nLCBzb2Z0d2FyZVxuICogZGlzdHJpYnV0ZWQgdW5kZXIgdGhlIExpY2Vuc2UgaXMgZGlzdHJpYnV0ZWQgb24gYW4gXCJBUyBJU1wiIEJBU0lTLFxuICogV0lUSE9VVCBXQVJSQU5USUVTIE9SIENPTkRJVElPTlMgT0YgQU5ZIEtJTkQsIGVpdGhlciBleHByZXNzIG9yIGltcGxpZWQuXG4gKiBTZWUgdGhlIExpY2Vuc2UgZm9yIHRoZSBzcGVjaWZpYyBsYW5ndWFnZSBnb3Zlcm5pbmcgcGVybWlzc2lvbnMgYW5kXG4gKiBsaW1pdGF0aW9ucyB1bmRlciB0aGUgTGljZW5zZS5cbiAqL1xuXG5pbXBvcnQgc3R5bGVkIGZyb20gXCJAZW1vdGlvbi9zdHlsZWRcIlxuXG5leHBvcnQgY29uc3QgU3R5bGVkQWN0aW9uQnV0dG9uQ29udGFpbmVyID0gc3R5bGVkLmRpdigoeyB0aGVtZSB9KSA9PiAoe1xuICBkaXNwbGF5OiBcImZsZXhcIixcbiAgZ2FwOiB0aGVtZS5zcGFjaW5nLnNtLFxuICBhbGlnbkl0ZW1zOiBcImNlbnRlclwiLFxuICAvLyBsaW5lIGhlaWdodCBzaG91bGQgYmUgdGhlIHNhbWUgYXMgdGhlIGljb24gc2l6ZVxuICBsaW5lSGVpZ2h0OiB0aGVtZS5pY29uU2l6ZXMubWQsXG59KSlcblxuZXhwb3J0IGludGVyZmFjZSBTdHlsZWRBY3Rpb25CdXR0b25JY29uUHJvcHMge1xuICBpY29uOiBzdHJpbmdcbn1cblxuZXhwb3J0IGNvbnN0IFN0eWxlZEFjdGlvbkJ1dHRvbkljb24gPSBzdHlsZWQuZGl2PFN0eWxlZEFjdGlvbkJ1dHRvbkljb25Qcm9wcz4oXG4gICh7IHRoZW1lLCBpY29uIH0pID0+ICh7XG4gICAgYmFja2dyb3VuZDogYHVybChcIiR7aWNvbn1cIikgbm8tcmVwZWF0IGNlbnRlciAvIGNvbnRhaW5gLFxuICAgIHdpZHRoOiB0aGVtZS5pY29uU2l6ZXMuYmFzZSxcbiAgICBoZWlnaHQ6IHRoZW1lLmljb25TaXplcy5iYXNlLFxuICB9KVxuKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkVG9vbGJhckFjdGlvbnMgPSBzdHlsZWQuZGl2KHtcbiAgZGlzcGxheTogXCJmbGV4XCIsXG4gIGFsaWduSXRlbXM6IFwiY2VudGVyXCIsXG4gIGZsZXhEaXJlY3Rpb246IFwicm93XCIsXG59KVxuIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$3
});
function ActionButton({
  label: o,
  icon: E,
  onClick: A
}) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "stToolbarActionButton", "data-testid": "stToolbarActionButton", children: /* @__PURE__ */ jsxRuntimeExports.jsx(BaseButton, { onClick: A, kind: BaseButtonKind.HEADER_BUTTON, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledActionButtonContainer, { children: [
    E && /* @__PURE__ */ jsxRuntimeExports.jsx(StyledActionButtonIcon, { "data-testid": "stToolbarActionButtonIcon", icon: E }),
    o && /* @__PURE__ */ jsxRuntimeExports.jsx("span", { "data-testid": "stToolbarActionButtonLabel", children: o })
  ] }) }) });
}
function ToolbarActions({
  sendMessageToHost: o,
  hostToolbarItems: E,
  metricsMgr: A
}) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledToolbarActions, { className: "stToolbarActions", "data-testid": "stToolbarActions", children: E.map(({
    key: g,
    label: e,
    icon: t
  }) => /* @__PURE__ */ jsxRuntimeExports.jsx(ActionButton, { label: e, icon: t, onClick: () => {
    A.enqueue("menuClick", {
      label: g
    }), o({
      type: "TOOLBAR_ITEM_CALLBACK",
      key: g
    });
  } }, g)) });
}
const screencastCounterAnimation = keyframes`
0% {
  opacity: 0;
}
25% {
  opacity: 1;
}
100% {
  opacity: 0;
}`, StyledCountdown = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e7qru6u0"
} : {
  target: "e7qru6u0",
  label: "StyledCountdown"
})(({
  theme: o
}) => ({
  position: "fixed",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  top: 0,
  left: 0,
  width: o.sizes.full,
  height: o.sizes.full,
  fontSize: "40vh",
  color: o.colors.redTextColor,
  fontWeight: o.fontWeights.bold,
  opacity: "0.8",
  textShadow: `1px 1px 10px ${o.colors.grayTextColor}`,
  transition: "opacity 0.3s ease-in-out",
  animation: `${screencastCounterAnimation} 1s`
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), Countdown = ({
  countdown: o,
  endCallback: E
}) => {
  const [A, g] = useState(o), e = () => {
    const t = A - 1;
    t >= 0 && g(t), t === 0 && E();
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledCountdown, { "data-testid": "stCountdown", onAnimationEnd: e, children: /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: A }) }, `frame${A}`);
};
function _EMOTION_STRINGIFIED_CSS_ERROR__$2() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const StyledRecordAudioLabel = /* @__PURE__ */ createStyled("label", process.env.NODE_ENV === "production" ? {
  target: "emfz9mr1"
} : {
  target: "emfz9mr1",
  label: "StyledRecordAudioLabel"
})(process.env.NODE_ENV === "production" ? {
  name: "ti75j2",
  styles: "margin:0"
} : {
  name: "ti75j2",
  styles: "margin:0/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2FwcC9zcmMvaG9jcy93aXRoU2NyZWVuY2FzdC9jb21wb25lbnRzL1NjcmVlbmNhc3REaWFsb2cvc3R5bGVkLWNvbXBvbmVudHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBa0JzQyIsImZpbGUiOiIvaG9tZS9ydW5uZXIvd29yay9zdGxpdGUvc3RsaXRlL3N0cmVhbWxpdC9mcm9udGVuZC9hcHAvc3JjL2hvY3Mvd2l0aFNjcmVlbmNhc3QvY29tcG9uZW50cy9TY3JlZW5jYXN0RGlhbG9nL3N0eWxlZC1jb21wb25lbnRzLnRzIiwic291cmNlc0NvbnRlbnQiOlsiLyoqXG4gKiBDb3B5cmlnaHQgKGMpIFN0cmVhbWxpdCBJbmMuICgyMDE4LTIwMjIpIFNub3dmbGFrZSBJbmMuICgyMDIyLTIwMjUpXG4gKlxuICogTGljZW5zZWQgdW5kZXIgdGhlIEFwYWNoZSBMaWNlbnNlLCBWZXJzaW9uIDIuMCAodGhlIFwiTGljZW5zZVwiKTtcbiAqIHlvdSBtYXkgbm90IHVzZSB0aGlzIGZpbGUgZXhjZXB0IGluIGNvbXBsaWFuY2Ugd2l0aCB0aGUgTGljZW5zZS5cbiAqIFlvdSBtYXkgb2J0YWluIGEgY29weSBvZiB0aGUgTGljZW5zZSBhdFxuICpcbiAqICAgICBodHRwOi8vd3d3LmFwYWNoZS5vcmcvbGljZW5zZXMvTElDRU5TRS0yLjBcbiAqXG4gKiBVbmxlc3MgcmVxdWlyZWQgYnkgYXBwbGljYWJsZSBsYXcgb3IgYWdyZWVkIHRvIGluIHdyaXRpbmcsIHNvZnR3YXJlXG4gKiBkaXN0cmlidXRlZCB1bmRlciB0aGUgTGljZW5zZSBpcyBkaXN0cmlidXRlZCBvbiBhbiBcIkFTIElTXCIgQkFTSVMsXG4gKiBXSVRIT1VUIFdBUlJBTlRJRVMgT1IgQ09ORElUSU9OUyBPRiBBTlkgS0lORCwgZWl0aGVyIGV4cHJlc3Mgb3IgaW1wbGllZC5cbiAqIFNlZSB0aGUgTGljZW5zZSBmb3IgdGhlIHNwZWNpZmljIGxhbmd1YWdlIGdvdmVybmluZyBwZXJtaXNzaW9ucyBhbmRcbiAqIGxpbWl0YXRpb25zIHVuZGVyIHRoZSBMaWNlbnNlLlxuICovXG5cbmltcG9ydCBzdHlsZWQgZnJvbSBcIkBlbW90aW9uL3N0eWxlZFwiXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRSZWNvcmRBdWRpb0xhYmVsID0gc3R5bGVkLmxhYmVsKHtcbiAgbWFyZ2luOiAwLFxufSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZEluc3RydWN0aW9uID0gc3R5bGVkLnAoe1xuICBtYXJnaW46IDAsXG59KVxuIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$2
}), StyledInstruction = /* @__PURE__ */ createStyled("p", process.env.NODE_ENV === "production" ? {
  target: "emfz9mr0"
} : {
  target: "emfz9mr0",
  label: "StyledInstruction"
})(process.env.NODE_ENV === "production" ? {
  name: "ti75j2",
  styles: "margin:0"
} : {
  name: "ti75j2",
  styles: "margin:0/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2FwcC9zcmMvaG9jcy93aXRoU2NyZWVuY2FzdC9jb21wb25lbnRzL1NjcmVlbmNhc3REaWFsb2cvc3R5bGVkLWNvbXBvbmVudHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBc0JpQyIsImZpbGUiOiIvaG9tZS9ydW5uZXIvd29yay9zdGxpdGUvc3RsaXRlL3N0cmVhbWxpdC9mcm9udGVuZC9hcHAvc3JjL2hvY3Mvd2l0aFNjcmVlbmNhc3QvY29tcG9uZW50cy9TY3JlZW5jYXN0RGlhbG9nL3N0eWxlZC1jb21wb25lbnRzLnRzIiwic291cmNlc0NvbnRlbnQiOlsiLyoqXG4gKiBDb3B5cmlnaHQgKGMpIFN0cmVhbWxpdCBJbmMuICgyMDE4LTIwMjIpIFNub3dmbGFrZSBJbmMuICgyMDIyLTIwMjUpXG4gKlxuICogTGljZW5zZWQgdW5kZXIgdGhlIEFwYWNoZSBMaWNlbnNlLCBWZXJzaW9uIDIuMCAodGhlIFwiTGljZW5zZVwiKTtcbiAqIHlvdSBtYXkgbm90IHVzZSB0aGlzIGZpbGUgZXhjZXB0IGluIGNvbXBsaWFuY2Ugd2l0aCB0aGUgTGljZW5zZS5cbiAqIFlvdSBtYXkgb2J0YWluIGEgY29weSBvZiB0aGUgTGljZW5zZSBhdFxuICpcbiAqICAgICBodHRwOi8vd3d3LmFwYWNoZS5vcmcvbGljZW5zZXMvTElDRU5TRS0yLjBcbiAqXG4gKiBVbmxlc3MgcmVxdWlyZWQgYnkgYXBwbGljYWJsZSBsYXcgb3IgYWdyZWVkIHRvIGluIHdyaXRpbmcsIHNvZnR3YXJlXG4gKiBkaXN0cmlidXRlZCB1bmRlciB0aGUgTGljZW5zZSBpcyBkaXN0cmlidXRlZCBvbiBhbiBcIkFTIElTXCIgQkFTSVMsXG4gKiBXSVRIT1VUIFdBUlJBTlRJRVMgT1IgQ09ORElUSU9OUyBPRiBBTlkgS0lORCwgZWl0aGVyIGV4cHJlc3Mgb3IgaW1wbGllZC5cbiAqIFNlZSB0aGUgTGljZW5zZSBmb3IgdGhlIHNwZWNpZmljIGxhbmd1YWdlIGdvdmVybmluZyBwZXJtaXNzaW9ucyBhbmRcbiAqIGxpbWl0YXRpb25zIHVuZGVyIHRoZSBMaWNlbnNlLlxuICovXG5cbmltcG9ydCBzdHlsZWQgZnJvbSBcIkBlbW90aW9uL3N0eWxlZFwiXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRSZWNvcmRBdWRpb0xhYmVsID0gc3R5bGVkLmxhYmVsKHtcbiAgbWFyZ2luOiAwLFxufSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZEluc3RydWN0aW9uID0gc3R5bGVkLnAoe1xuICBtYXJnaW46IDAsXG59KVxuIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$2
}), ScreencastDialog = ({
  onClose: o,
  toggleRecordAudio: E,
  recordAudio: A,
  startRecording: g
}) => {
  const [e, t] = useState(A), c = useCallback((h) => {
    const {
      checked: d
    } = h.target;
    d !== e && (t(d), E());
  }, [e, E]), n = useCallback(() => {
    g(), o();
  }, [g, o]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Modal, { isOpen: !0, onClose: o, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalHeader, { children: "Record a screencast" }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(ModalBody$1, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: "This will record a video with the contents of your screen, so you can easily share what you're seeing with others." }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledRecordAudioLabel, { "data-testid": "stScreencastAudioCheckbox", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("input", { type: "checkbox", name: "recordAudio", checked: e, onChange: c }),
        " ",
        "Also record audio"
      ] }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(StyledInstruction, { "data-testid": "stScreencastInstruction", children: /* @__PURE__ */ jsxRuntimeExports.jsx(StreamlitMarkdown$1, { source: "Press `Esc` any time to stop recording.", allowHTML: !1 }) })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalFooter, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(ModalButton, { kind: BaseButtonKind.SECONDARY, onClick: n, children: "Start recording!" }) })
  ] });
}, StyledVideo = /* @__PURE__ */ createStyled("video", process.env.NODE_ENV === "production" ? {
  target: "ecutw1r6"
} : {
  target: "ecutw1r6",
  label: "StyledVideo"
})(({
  theme: o
}) => ({
  width: o.sizes.full,
  borderRadius: o.radii.md
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2FwcC9zcmMvaG9jcy93aXRoU2NyZWVuY2FzdC9jb21wb25lbnRzL1ZpZGVvUmVjb3JkZWREaWFsb2cvc3R5bGVkLWNvbXBvbmVudHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBa0IyQiIsImZpbGUiOiIvaG9tZS9ydW5uZXIvd29yay9zdGxpdGUvc3RsaXRlL3N0cmVhbWxpdC9mcm9udGVuZC9hcHAvc3JjL2hvY3Mvd2l0aFNjcmVlbmNhc3QvY29tcG9uZW50cy9WaWRlb1JlY29yZGVkRGlhbG9nL3N0eWxlZC1jb21wb25lbnRzLnRzIiwic291cmNlc0NvbnRlbnQiOlsiLyoqXG4gKiBDb3B5cmlnaHQgKGMpIFN0cmVhbWxpdCBJbmMuICgyMDE4LTIwMjIpIFNub3dmbGFrZSBJbmMuICgyMDIyLTIwMjUpXG4gKlxuICogTGljZW5zZWQgdW5kZXIgdGhlIEFwYWNoZSBMaWNlbnNlLCBWZXJzaW9uIDIuMCAodGhlIFwiTGljZW5zZVwiKTtcbiAqIHlvdSBtYXkgbm90IHVzZSB0aGlzIGZpbGUgZXhjZXB0IGluIGNvbXBsaWFuY2Ugd2l0aCB0aGUgTGljZW5zZS5cbiAqIFlvdSBtYXkgb2J0YWluIGEgY29weSBvZiB0aGUgTGljZW5zZSBhdFxuICpcbiAqICAgICBodHRwOi8vd3d3LmFwYWNoZS5vcmcvbGljZW5zZXMvTElDRU5TRS0yLjBcbiAqXG4gKiBVbmxlc3MgcmVxdWlyZWQgYnkgYXBwbGljYWJsZSBsYXcgb3IgYWdyZWVkIHRvIGluIHdyaXRpbmcsIHNvZnR3YXJlXG4gKiBkaXN0cmlidXRlZCB1bmRlciB0aGUgTGljZW5zZSBpcyBkaXN0cmlidXRlZCBvbiBhbiBcIkFTIElTXCIgQkFTSVMsXG4gKiBXSVRIT1VUIFdBUlJBTlRJRVMgT1IgQ09ORElUSU9OUyBPRiBBTlkgS0lORCwgZWl0aGVyIGV4cHJlc3Mgb3IgaW1wbGllZC5cbiAqIFNlZSB0aGUgTGljZW5zZSBmb3IgdGhlIHNwZWNpZmljIGxhbmd1YWdlIGdvdmVybmluZyBwZXJtaXNzaW9ucyBhbmRcbiAqIGxpbWl0YXRpb25zIHVuZGVyIHRoZSBMaWNlbnNlLlxuICovXG5cbmltcG9ydCBzdHlsZWQgZnJvbSBcIkBlbW90aW9uL3N0eWxlZFwiXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRWaWRlbyA9IHN0eWxlZC52aWRlbygoeyB0aGVtZSB9KSA9PiAoe1xuICB3aWR0aDogdGhlbWUuc2l6ZXMuZnVsbCxcbiAgYm9yZGVyUmFkaXVzOiB0aGVtZS5yYWRpaS5tZCxcbn0pKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkRGlhbG9nQ29udGFpbmVyID0gc3R5bGVkLmRpdigoeyB0aGVtZSB9KSA9PiAoe1xuICBkaXNwbGF5OiBcImZsZXhcIixcbiAgZmxleERpcmVjdGlvbjogXCJjb2x1bW5cIixcbiAgd2lkdGg6IHRoZW1lLnNpemVzLmZ1bGwsXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZFJvdyA9IHN0eWxlZC5kaXYoKHsgdGhlbWUgfSkgPT4gKHtcbiAgZGlzcGxheTogXCJmbGV4XCIsXG4gIGZsZXhEaXJlY3Rpb246IFwicm93XCIsXG4gIHBhZGRpbmdUb3A6IHRoZW1lLnNwYWNpbmcubWQsXG4gIHBhZGRpbmdCb3R0b206IHRoZW1lLnNwYWNpbmcubWQsXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZEZpcnN0Q29sdW1uID0gc3R5bGVkLmRpdigoeyB0aGVtZSB9KSA9PiAoe1xuICBwYWRkaW5nUmlnaHQ6IHRoZW1lLnNwYWNpbmcubGcsXG4gIHRleHRBbGlnbjogXCJyaWdodFwiLFxuICBjb2xvcjogdGhlbWUuY29sb3JzLmdyYXlUZXh0Q29sb3IsXG4gIGZvbnRXZWlnaHQ6IHRoZW1lLmZvbnRXZWlnaHRzLmJvbGQsXG4gIHdpZHRoOiBcIjZlbVwiLFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRTZWNvbmRDb2x1bW4gPSBzdHlsZWQuZGl2KCh7IHRoZW1lIH0pID0+ICh7XG4gIGZsZXg6IDEsXG4gIHBhZGRpbmdSaWdodDogdGhlbWUuc3BhY2luZy5sZyxcbiAgbWFyZ2luUmlnaHQ6IFwiNmVtXCIsXG4gIFtgQG1lZGlhIChtYXgtd2lkdGg6ICR7dGhlbWUuYnJlYWtwb2ludHMuc219KWBdOiB7XG4gICAgbWFyZ2luUmlnaHQ6IHRoZW1lLnNwYWNpbmcubm9uZSxcbiAgfSxcbn0pKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkVmlkZW9Gb3JtYXRJbnN0cnVjdGlvbnMgPSBzdHlsZWQucCgoeyB0aGVtZSB9KSA9PiAoe1xuICBtYXJnaW5Ub3A6IHRoZW1lLnNwYWNpbmcuc20sXG4gIG1hcmdpbkJvdHRvbTogdGhlbWUuc3BhY2luZy5ub25lLFxuICBmb250U2l6ZTogdGhlbWUuZm9udFNpemVzLnNtLFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWREb3dubG9hZEJ1dHRvbkNvbnRhaW5lciA9IHN0eWxlZC5kaXYoKHsgdGhlbWUgfSkgPT4gKHtcbiAgbWFyZ2luVG9wOiB0aGVtZS5zcGFjaW5nLnR3b1hTLFxufSkpXG4iXX0= */"), StyledDialogContainer = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "ecutw1r5"
} : {
  target: "ecutw1r5",
  label: "StyledDialogContainer"
})(({
  theme: o
}) => ({
  display: "flex",
  flexDirection: "column",
  width: o.sizes.full
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledRow = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "ecutw1r4"
} : {
  target: "ecutw1r4",
  label: "StyledRow"
})(({
  theme: o
}) => ({
  display: "flex",
  flexDirection: "row",
  paddingTop: o.spacing.md,
  paddingBottom: o.spacing.md
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledFirstColumn = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "ecutw1r3"
} : {
  target: "ecutw1r3",
  label: "StyledFirstColumn"
})(({
  theme: o
}) => ({
  paddingRight: o.spacing.lg,
  textAlign: "right",
  color: o.colors.grayTextColor,
  fontWeight: o.fontWeights.bold,
  width: "6em"
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledSecondColumn = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "ecutw1r2"
} : {
  target: "ecutw1r2",
  label: "StyledSecondColumn"
})(({
  theme: o
}) => ({
  flex: 1,
  paddingRight: o.spacing.lg,
  marginRight: "6em",
  [`@media (max-width: ${o.breakpoints.sm})`]: {
    marginRight: o.spacing.none
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledVideoFormatInstructions = /* @__PURE__ */ createStyled("p", process.env.NODE_ENV === "production" ? {
  target: "ecutw1r1"
} : {
  target: "ecutw1r1",
  label: "StyledVideoFormatInstructions"
})(({
  theme: o
}) => ({
  marginTop: o.spacing.sm,
  marginBottom: o.spacing.none,
  fontSize: o.fontSizes.sm
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledDownloadButtonContainer = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "ecutw1r0"
} : {
  target: "ecutw1r0",
  label: "StyledDownloadButtonContainer"
})(({
  theme: o
}) => ({
  marginTop: o.spacing.twoXS
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), VideoRecordedDialog = ({
  onClose: o,
  videoBlob: E,
  fileName: A
}) => {
  const g = URL.createObjectURL(E), e = () => {
    const t = document.createElement("a");
    t.setAttribute("href", g), t.setAttribute("download", `${A}.webm`), t.click(), o();
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Modal, { isOpen: !0, onClose: o, overrides: {
    Dialog: {
      style: {
        width: "80vw"
      }
    }
  }, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalHeader, { children: "Next steps" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalBody$1, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledDialogContainer, { "data-testid": "stVideoRecordedDialog", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledRow, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(StyledFirstColumn, { children: "Step 1" }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledSecondColumn, { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: "Preview your video below:" }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(StyledVideo, { src: g, controls: !0 })
        ] })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledRow, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(StyledFirstColumn, { children: "Step 2" }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledSecondColumn, { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(StyledDownloadButtonContainer, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(BaseButton, { kind: BaseButtonKind.SECONDARY, onClick: e, children: "Save video to disk" }) }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledVideoFormatInstructions, { children: [
            "This video is encoded in the",
            " ",
            /* @__PURE__ */ jsxRuntimeExports.jsx("a", { href: "https://www.webmproject.org/", children: "WebM format" }),
            ", which is only supported by newer video players. You can also play it by dragging the file directly into your browser."
          ] })
        ] })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledRow, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(StyledFirstColumn, { children: "Step 3" }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledSecondColumn, { children: [
          "Share your video with the world on Twitter, LinkedIn, YouTube, or just plain email!",
          " ",
          /* @__PURE__ */ jsxRuntimeExports.jsx("span", { role: "img", "aria-label": "Happy", children: "😀" })
        ] })
      ] })
    ] }) })
  ] });
};
function _EMOTION_STRINGIFIED_CSS_ERROR__$1() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const StyledScreenCastWarningDialog = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e16i1uly2"
} : {
  target: "e16i1uly2",
  label: "StyledScreenCastWarningDialog"
})(process.env.NODE_ENV === "production" ? {
  name: "zjik7",
  styles: "display:flex"
} : {
  name: "zjik7",
  styles: "display:flex/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1
}), StyledUnsupportedScreenCastIcon = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e16i1uly1"
} : {
  target: "e16i1uly1",
  label: "StyledUnsupportedScreenCastIcon"
})(({
  theme: o
}) => ({
  display: "flex",
  alignItems: "center",
  justifyItems: "center",
  marginRight: o.spacing.twoXL,
  marginLeft: o.spacing.sm,
  fontSize: o.fontSizes.fourXL
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledUnsupportedScreenCastExplanation = /* @__PURE__ */ createStyled("p", process.env.NODE_ENV === "production" ? {
  target: "e16i1uly0"
} : {
  target: "e16i1uly0",
  label: "StyledUnsupportedScreenCastExplanation"
})(({
  theme: o
}) => ({
  margin: o.spacing.none
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), UnsupportedBrowserDialog = ({
  onClose: o
}) => /* @__PURE__ */ jsxRuntimeExports.jsxs(Modal, { isOpen: !0, onClose: o, children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx(ModalHeader, { children: "Record a screencast" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx(ModalBody$1, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledScreenCastWarningDialog, { "data-testid": "stUnsupportedBrowserDialog", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(StyledUnsupportedScreenCastIcon, { children: /* @__PURE__ */ jsxRuntimeExports.jsx("span", { role: "img", "aria-label": "Alien Monster", children: "👾" }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(StyledUnsupportedScreenCastExplanation, { children: "Due to limitations with some browsers, this feature is only supported on recent desktop versions of Chrome, Firefox, and Edge." })
  ] }) })
] }), UnsupportedBrowserDialog$1 = memo(UnsupportedBrowserDialog), LOG$2 = loglevelExports$1.getLogger("withScreencast");
function withScreencast(o) {
  const E = (A) => {
    const {
      testOverride: g
    } = A, e = useRef(null), [t, c] = useState("streamlit-screencast"), [n, h] = useState(!1), [d, k] = useState(void 0), [p, M] = useState(g || "OFF"), S = useCallback(() => {
      h((QA) => !QA);
    }, []), AA = useCallback(async () => {
      if (!(p === "OFF" || isNullOrUndefined(e.current))) {
        if (p === "COUNTDOWN") {
          M("OFF");
          return;
        }
        if (p === "RECORDING") {
          const QA = e.current;
          if (!QA || QA.getState() === "inactive")
            M("OFF");
          else {
            const EA = await QA.stop();
            k(EA), M("PREVIEW_FILE");
          }
        }
      }
    }, [p]), H = useCallback(async () => {
      if (!ScreenCastRecorder.isSupportedBrowser()) {
        M("UNSUPPORTED");
        return;
      }
      e.current = new ScreenCastRecorder({
        recordAudio: n,
        onErrorOrStop: () => {
          AA().catch((QA) => LOG$2.warn(`withScreencast.stopRecording threw an error: ${QA}`));
        }
      });
      try {
        await e.current.initialize();
      } catch (QA) {
        LOG$2.warn(`ScreenCastRecorder.initialize error: ${QA}`), M("UNSUPPORTED");
        return;
      }
      M("COUNTDOWN");
    }, [n, AA]), gA = useCallback((QA) => {
      if (!ScreenCastRecorder.isSupportedBrowser()) {
        M("UNSUPPORTED");
        return;
      }
      if (p === "OFF") {
        c(QA), M("SETUP");
        return;
      }
      AA().catch((EA) => LOG$2.warn(`withScreencast.stopRecording threw an error: ${EA}`));
    }, [p, AA]), CA = useCallback(() => {
      if (isNullOrUndefined(e.current))
        throw new Error("Countdown finished but recorder is null");
      e.current.start() ? M("RECORDING") : AA().catch((EA) => LOG$2.warn(`withScreencast.stopRecording threw an error: ${EA}`));
    }, [AA]), IA = useCallback(() => {
      M("OFF");
    }, []), BA = {
      currentState: p,
      toggleRecordAudio: S,
      startRecording: gA,
      // triggers the setup/showDialog process
      // eslint-disable-next-line @typescript-eslint/no-misused-promises
      stopRecording: AA
    };
    return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "withScreencast", "data-testid": "stScreencast", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(o, { ...A, screenCast: BA }),
      p === "UNSUPPORTED" && /* @__PURE__ */ jsxRuntimeExports.jsx(UnsupportedBrowserDialog$1, { onClose: IA }),
      p === "SETUP" && /* @__PURE__ */ jsxRuntimeExports.jsx(
        ScreencastDialog,
        {
          recordAudio: n,
          onClose: IA,
          startRecording: H,
          toggleRecordAudio: S
        }
      ),
      p === "COUNTDOWN" && /* @__PURE__ */ jsxRuntimeExports.jsx(Countdown, { countdown: 3, endCallback: CA }),
      p === "PREVIEW_FILE" && d && /* @__PURE__ */ jsxRuntimeExports.jsx(VideoRecordedDialog, { onClose: IA, videoBlob: d, fileName: t })
    ] });
  };
  return E.displayName = `withScreencast(${o.displayName || o.name || "Component"})`, hoistNonReactStatics(E, o);
}
const useViewportSize = () => {
  const {
    activeTheme: o
  } = useContext(ThemeContext), {
    innerWidth: E
  } = useWindowDimensionsContext(), A = parseInt(o.emotion.breakpoints.md, 10);
  return {
    isMobile: E < A
  };
}, DEFAULT_METRICS_CONFIG = "https://data.streamlit.io/metrics.json", LOG$1 = loglevelExports$1.getLogger("MetricsManager");
class MetricsManager {
  constructor(E) {
    this.initialized = !1, this.actuallySendMetrics = !1, this.metricsUrl = void 0, this.sendMessageToHost = () => {
    }, this.anonymousId = "", this.pendingEvents = [], this.appHash = "Not initialized", this.metadata = {}, this.setAppHash = (A) => {
      this.appHash = A;
    }, this.setMetricsConfig = (A = "") => {
      this.metricsUrl = A;
    }, this.sessionInfo = E;
  }
  async initialize({
    gatherUsageStats: E,
    sendMessageToHost: A
  }) {
    this.sendMessageToHost = A, this.actuallySendMetrics = E && this.metricsUrl !== "off", this.getAnonymousId(), this.actuallySendMetrics && !this.metricsUrl && (await this.requestDefaultMetricsConfig(), this.metricsUrl || (LOG$1.error("Undefined metrics config - deactivating metrics tracking."), this.actuallySendMetrics = !1)), this.actuallySendMetrics && this.sendPendingEvents(), LOG$1.info("Gather usage stats: ", this.actuallySendMetrics), this.initialized = !0;
  }
  enqueue(E, A = {}) {
    if (!this.initialized || !this.sessionInfo.isSet) {
      this.pendingEvents.push([E, A]);
      return;
    }
    this.actuallySendMetrics && (this.pendingEvents.length && this.sendPendingEvents(), this.send(E, A));
  }
  setMetadata(E) {
    this.metadata = E;
  }
  // Fallback - Checks if cached in localStorage, otherwise fetches the config from a default URL
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace 'any' with a more specific type.
  async requestDefaultMetricsConfig() {
    const E = localStorageAvailable();
    if (E) {
      const A = window.localStorage.getItem("stMetricsConfig");
      if (A) {
        this.metricsUrl = A;
        return;
      }
    }
    try {
      const A = await fetch(DEFAULT_METRICS_CONFIG, {
        signal: AbortSignal.timeout(5e3)
      });
      if (!A.ok)
        this.metricsUrl = void 0, LOG$1.error("Failed to fetch metrics config: ", A.status);
      else {
        const g = await A.json();
        this.metricsUrl = g.url ?? void 0, E && this.metricsUrl && window.localStorage.setItem("stMetricsConfig", this.metricsUrl);
      }
    } catch (A) {
      LOG$1.error("Failed to fetch metrics config:", A);
    }
  }
  // The schema of metrics events (including key names and value types) should
  // only be changed when requested by the data team. This is why `reportHash`
  // retains its old name.
  send(E, A = {}) {
    const g = this.buildEventProto(E, A);
    IS_DEV_ENV ? LOG$1.info("[Dev mode] Not tracking stat datapoint: ", E, g) : this.metricsUrl === "postMessage" ? this.postMessageEvent(E, g) : this.track(g);
  }
  sendPendingEvents() {
    this.pendingEvents.forEach(([E, A]) => {
      this.send(E, A);
    }), this.pendingEvents = [];
  }
  async track(E) {
    const A = new Request(this.metricsUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(E.toJSON())
    });
    await fetch(A);
  }
  // Helper to send metrics events to host
  postMessageEvent(E, A) {
    this.sendMessageToHost({
      type: "METRICS_EVENT",
      eventName: E,
      data: A
    });
  }
  // Helper to build the event proto
  buildEventProto(E, A) {
    const g = new MetricsEvent({
      event: E,
      anonymousId: this.anonymousId,
      ...this.getHostTrackingData(),
      ...this.getInstallationData(),
      reportHash: this.appHash,
      dev: IS_DEV_ENV,
      source: "browser",
      streamlitVersion: this.sessionInfo.current.streamlitVersion,
      isHello: this.sessionInfo.isHello,
      appId: this.sessionInfo.current.appId,
      sessionId: this.sessionInfo.current.sessionId,
      pythonVersion: this.sessionInfo.current.pythonVersion,
      serverOs: this.sessionInfo.current.serverOS,
      hasDisplay: this.sessionInfo.current.hasDisplay,
      isWebdriver: isWebdriver(),
      ...this.getContextData()
    });
    if (E === "menuClick")
      g.label = A.label;
    else if (E === "pageProfile")
      return new MetricsEvent({
        ...g,
        ...A
      });
    return g;
  }
  // Get the installation IDs from the session
  getInstallationData() {
    return {
      machineIdV3: this.sessionInfo.current.installationIdV3,
      machineIdV4: this.sessionInfo.current.installationIdV4
    };
  }
  // Use the tracking data injected by the host of the app if included.
  getHostTrackingData() {
    return this.metadata ? pick$1(this.metadata, ["hostedAt", "owner", "repo", "branch", "mainModule", "creatorId"]) : {};
  }
  // Get context data for events
  getContextData() {
    return {
      contextPageUrl: window.location.href,
      contextPageTitle: document.title,
      contextPagePath: window.location.pathname,
      contextPageReferrer: document.referrer,
      contextPageSearch: window.location.search,
      contextLocale: window.navigator.language,
      contextUserAgent: window.navigator.userAgent
    };
  }
  /**
   * Get/Create user's anonymous ID
   * Checks if existing in cookie or localStorage, otherwise generates
   * a new UUID and stores it in both.
   */
  getAnonymousId() {
    if (!this.actuallySendMetrics) return;
    const E = "ajs_anonymous_id", A = localStorageAvailable(), g = getCookie(E), e = A ? window.localStorage.getItem(E) : null, t = /* @__PURE__ */ new Date();
    if (t.setFullYear((/* @__PURE__ */ new Date()).getFullYear() + 1), g)
      this.anonymousId = g, A && window.localStorage.setItem(E, g);
    else if (e) {
      try {
        this.anonymousId = JSON.parse(e);
      } catch {
        this.anonymousId = e;
      }
      setCookie(E, this.anonymousId, t);
    } else
      this.anonymousId = v4(), setCookie(E, this.anonymousId, t), A && window.localStorage.setItem(E, this.anonymousId);
  }
}
function isWebdriver() {
  return window.navigator?.webdriver ?? !1;
}
class SessionEventDispatcher {
  constructor() {
    this.onSessionEvent = new distExports.Signal();
  }
  /** Redispatches a ForwardMsg.SessionEvent via a signal. */
  handleSessionEventMsg(E) {
    this.onSessionEvent.emit(E);
  }
}
const StyledApp = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "erw9t6i0"
} : {
  target: "erw9t6i0",
  label: "StyledApp"
})(({
  theme: o
}) => {
  const E = hasLightBackgroundColor(o);
  return {
    position: "absolute",
    background: o.colors.bgColor,
    color: o.colors.bodyText,
    top: o.spacing.none,
    left: o.spacing.none,
    right: o.spacing.none,
    bottom: o.spacing.none,
    colorScheme: E ? "light" : "dark",
    overflow: "hidden",
    "@media print": {
      float: "none",
      height: o.sizes.full,
      position: "static",
      overflow: "visible"
    }
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
function getBrowserInfo() {
  const E = new UAParser().getResult();
  return {
    browserName: E.browser.name || "Unknown",
    browserVersion: E.browser.version || "Unknown",
    /**
     * 'desktop' is not a valid value for device.type in ua-parser-js.
     * We default to 'desktop' if the value is not present.
     * Possible options from ua-parser-js are:
     * 'mobile', 'tablet', 'smarttv', 'wearable', 'embedded', 'console'
     */
    deviceType: E.device.type || "desktop",
    os: E.os.name || "Unknown"
  };
}
const showDevelopmentOptions = (o, E) => E == Config.ToolbarMode.DEVELOPER ? !0 : Config.ToolbarMode.VIEWER == E || Config.ToolbarMode.MINIMAL == E ? !1 : o || isLocalhost();
function getTitle(o) {
  return o || "Streamlit";
}
class AppNavigation {
  constructor(E, A, g, e) {
    this.hostCommunicationMgr = E, this.onUpdatePageUrl = A, this.onPageNotFound = g, this.onPageIconChange = e, this.isPageIconSet = !1, this.isPageTitleSet = !1, this.hasSetDefaultFavicon = !1, this.mainScriptHash = null, this.appPages = [], this.mainPage = null, this.hideSidebarNav = null;
  }
  handleNewSession(E) {
    return this.mainScriptHash !== E.mainScriptHash && (this.isPageTitleSet = !1, this.isPageIconSet = !1, this.hasSetDefaultFavicon = !1), this.mainScriptHash = E.mainScriptHash, this.hideSidebarNav === null && (this.hideSidebarNav = E.config?.hideSidebarNav ?? null), document.title = getTitle(""), [{
      // Set current page script hash to handle SPA case
      currentPageScriptHash: E.pageScriptHash,
      hideSidebarNav: this.hideSidebarNav ?? !1
    }, () => {
    }];
  }
  handleNavigation(E) {
    const {
      sections: A,
      position: g,
      appPages: e
    } = E;
    this.appPages = e, this.hideSidebarNav = g === Navigation.Position.HIDDEN;
    const t = E.pageScriptHash, c = e.find((d) => d.pageScriptHash === t), n = e.find((d) => d.isDefault);
    this.mainPage = n;
    const h = c.urlPathname;
    if (!this.isPageTitleSet) {
      const d = getTitle(c.pageName);
      document.title = d, this.hostCommunicationMgr.sendMessageToHost({
        type: "SET_PAGE_TITLE",
        title: c.pageName ?? ""
      });
    }
    return !this.isPageIconSet && c.icon && this.onPageIconChange(c.icon), this.onUpdatePageUrl(n.urlPathname ?? "", h, c.isDefault ?? !1), [{
      appPages: e,
      navSections: A,
      hideSidebarNav: this.hideSidebarNav,
      expandSidebarNav: E.expanded,
      currentPageScriptHash: t
    }, () => {
      this.hostCommunicationMgr.sendMessageToHost({
        type: "SET_APP_PAGES",
        appPages: e
      }), this.hostCommunicationMgr.sendMessageToHost({
        type: "SET_CURRENT_PAGE_NAME",
        // Make sure we don't send the official page name for the main page
        // This command is used to update the URL in the url bar, so the main page
        // should not have a page name in the URL.
        currentPageName: c.isDefault ? "" : h,
        currentPageScriptHash: t
      });
    }];
  }
  handlePageNotFound(E) {
    return this.onPageNotFound(E), [{
      currentPageScriptHash: this.mainScriptHash ?? ""
    }, () => {
      this.hostCommunicationMgr.sendMessageToHost({
        type: "SET_CURRENT_PAGE_NAME",
        currentPageName: "",
        currentPageScriptHash: this.mainScriptHash ?? ""
      });
    }];
  }
  findPageByUrlPath(E) {
    return this.appPages.find((A) => (
      // The page name is embedded at the end of the URL path, and if not, we are in the main page.
      // See https://github.com/streamlit/streamlit/blob/1.19.0/frontend/src/App.tsx#L740
      E.endsWith("/" + A.urlPathname)
    )) ?? this.mainPage;
  }
  handlePageConfigChanged(E) {
    E.favicon && (this.isPageIconSet = !0), E.title && (this.isPageTitleSet = !0);
  }
  clearPageElements(E, A) {
    return E.filterMainScriptElements(A);
  }
}
const INITIAL_SCRIPT_RUN_ID = "<null>", LOG = loglevelExports$1.getLogger("App"), cI = class cI extends PureComponent {
  constructor(E) {
    super(E), this.sessionInfo = new SessionInfo(), this.metricsMgr = new MetricsManager(this.sessionInfo), this.sessionEventDispatcher = new SessionEventDispatcher(), this.embeddingId = generateUID$2(), this.deferredFileListeners = /* @__PURE__ */ new Map(), this.isInitializingConnectionManager = !0, this.hasReceivedNewSession = !1, this.showDeployError = (A, g, e) => {
      const t = {
        type: DialogType.DEPLOY_ERROR,
        title: A,
        msg: g,
        onContinue: e,
        onClose: () => {
        },
        onTryAgain: this.sendLoadGitInfoBackMsg
      };
      this.openDialog(t);
    }, this.handleThemeMessage = (A, g) => {
      const [, e, t] = createPresetThemes(), c = isPresetTheme(this.props.theme.activeTheme);
      A === e.name && c ? this.props.theme.setTheme(e) : A === t.name && c ? this.props.theme.setTheme(t) : g && this.props.theme.setImportedTheme(g);
    }, this.handleConnectionStateChanged = (A) => {
      if (LOG.info(`Connection state changed from ${this.state.connectionState} to ${A}`), A === ConnectionState.CONNECTED) {
        LOG.info("Reconnected to server."), this.state.connectionErrorDismissed && this.setState({
          connectionErrorDismissed: !1
        });
        const g = this.state.scriptRunState === ScriptRunState.RUNNING, e = this.state.scriptRunState === ScriptRunState.RERUN_REQUESTED;
        !this.sessionInfo.last || g || e || // Script is using fragments (fragments in last run or
        // fragment auto-reruns configured):
        this.state.fragmentIdsThisRun.length > 0 || this.state.autoReruns.length > 0 ? (LOG.info("Requesting a script run."), this.widgetMgr.sendUpdateWidgetsMessage(void 0), this.setState({
          dialog: null
        })) : this.state.dialog?.type === DialogType.CONNECTION_ERROR && this.setState({
          dialog: null
        }), this.hostCommunicationMgr.sendMessageToHost({
          type: "WEBSOCKET_CONNECTED"
        });
      } else
        this.state.connectionState === ConnectionState.CONNECTED && this.hostCommunicationMgr.sendMessageToHost({
          type: "WEBSOCKET_DISCONNECTED",
          attemptingToReconnect: A !== ConnectionState.DISCONNECTED_FOREVER
        }), this.sessionInfo.isSet && this.sessionInfo.disconnect();
      this.isInitializingConnectionManager ? this.setState({
        connectionState: A
      }) : flushSync(() => {
        this.setState({
          connectionState: A
        });
      });
    }, this.handleGitInfoChanged = (A) => {
      this.setState({
        gitInfo: A
      });
    }, this.handleCustomParentMessage = (A) => {
      this.state.appConfig.enableCustomParentMessages ? this.hostCommunicationMgr.sendMessageToHost({
        type: "CUSTOM_PARENT_MESSAGE",
        message: A.message
      }) : LOG.error("Sending messages to the host is disabled in line with the platform policy.");
    }, this.handleMessage = (A) => {
      const g = (e, t, c) => {
        const n = e[t];
        if (n in c)
          return c[n](e[n]);
        throw new Error(`Cannot handle ${t} "${n}".`);
      };
      try {
        g(A, "type", {
          newSession: (e) => this.handleNewSession(e),
          sessionStatusChanged: (e) => this.handleSessionStatusChanged(e),
          sessionEvent: (e) => this.handleSessionEvent(e),
          delta: (e) => this.handleDeltaMsg(e, A.metadata),
          pageConfigChanged: (e) => this.handlePageConfigChanged(e),
          pageInfoChanged: (e) => this.handlePageInfoChanged(e),
          // Deprecated protobuf option as navigation will always inform us of pages
          pagesChanged: (e) => {
          },
          pageNotFound: (e) => this.handlePageNotFound(e),
          gitInfoChanged: (e) => this.handleGitInfoChanged(e),
          scriptFinished: (e) => this.handleScriptFinished(e),
          pageProfile: (e) => this.handlePageProfileMsg(e),
          autoRerun: (e) => this.handleAutoRerun(e),
          fileUrlsResponse: (e) => this.uploadClient.onFileURLsResponse(e),
          deferredFileResponse: (e) => this.handleDeferredFileResponse(e),
          parentMessage: (e) => this.handleCustomParentMessage(e),
          logo: (e) => this.handleLogo(e, A.metadata),
          navigation: (e) => this.handleNavigation(e),
          authRedirect: (e) => {
            isInChildFrame() ? this.hostCommunicationMgr.sendMessageToSameOriginHost({
              type: "REDIRECT_TO_URL",
              url: e.url
            }) : window.location.href = e.url;
          }
        });
      } catch (e) {
        const t = ensureError(e);
        LOG.error(t), this.showError("Bad message format", {
          message: t.message
        });
      }
    }, this.handleLogo = (A, g) => {
      this.setState((e) => ({
        elements: e.elements.appRootWithLogo(A, {
          // Pass the current page & run ID for cleanup
          activeScriptHash: g.activeScriptHash,
          scriptRunId: e.scriptRunId
        })
      }));
    }, this.handlePageConfigChanged = (A) => {
      const {
        title: g,
        favicon: e,
        layout: t,
        initialSidebarState: c,
        menuItems: n
      } = A;
      this.appNavigation.handlePageConfigChanged(A), g && (this.hostCommunicationMgr.sendMessageToHost({
        type: "SET_PAGE_TITLE",
        title: g
      }), document.title = g), e && this.onPageIconChanged(e), t !== this.state.layout && t !== PageConfig.Layout.LAYOUT_UNSET && this.setState((h) => ({
        layout: t,
        userSettings: {
          ...h.userSettings,
          wideMode: t === PageConfig.Layout.WIDE
        }
      })), c !== this.state.initialSidebarState && c !== PageConfig.SidebarState.SIDEBAR_UNSET && this.setState(() => ({
        initialSidebarState: c
      })), n && this.setState((h) => (n.clearAboutMd && (n.aboutSectionMd = ""), {
        menuItems: {
          ...h.menuItems,
          ...n
        }
      }));
    }, this.handlePageInfoChanged = (A) => {
      const {
        queryString: g
      } = A, e = document.location.pathname + (g ? `?${g}` : "");
      window.history.pushState({}, "", e), this.setState({
        queryParams: g
      }), this.hostCommunicationMgr.sendMessageToHost({
        type: "SET_QUERY_PARAM",
        queryParams: g ? `?${g}` : ""
      });
    }, this.onPageNotFound = (A) => {
      const g = A ? `You have requested page /${A}, but no corresponding file was found in the app's pages/ directory` : "The page that you have requested does not seem to exist";
      this.showError("Page not found", {
        message: `${g}. Running the app's main page.`
      });
    }, this.handlePageNotFound = (A) => {
      const {
        pageName: g
      } = A;
      this.maybeSetState(this.appNavigation.handlePageNotFound(g));
    }, this.onPageIconChanged = (A) => {
      handleFavicon(A, this.hostCommunicationMgr.sendMessageToHost, this.endpoints);
    }, this.handleNavigation = (A) => {
      this.setState({
        navigationPosition: A.position
      }), this.maybeSetState(this.appNavigation.handleNavigation(A));
    }, this.handlePageProfileMsg = (A) => {
      const g = PageProfile.toObject(A), e = getBrowserInfo();
      this.metricsMgr.enqueue("pageProfile", {
        ...g,
        isFragmentRun: !!g.isFragmentRun,
        numPages: this.state.appPages?.length,
        pageScriptHash: this.state.currentPageScriptHash,
        activeTheme: this.props.theme?.activeTheme?.name,
        totalLoadTime: Math.round((performance.now() - this.state.latestRunTime) * 1e3),
        browserInfo: e
      });
    }, this.handleAutoRerun = (A) => {
      const g = setInterval(() => {
        this.widgetMgr.sendUpdateWidgetsMessage(A.fragmentId, !0);
      }, A.interval * 1e3);
      this.setState((e) => ({
        autoReruns: [...e.autoReruns, g]
      }));
    }, this.handleSessionStatusChanged = (A) => {
      this.setState((g) => {
        let {
          scriptRunState: e
        } = g, {
          dialog: t
        } = g;
        return A.scriptIsRunning && g.scriptRunState !== ScriptRunState.STOP_REQUESTED ? (e = ScriptRunState.RUNNING, notNullOrUndefined(t) && t.type === DialogType.SCRIPT_COMPILE_ERROR && (t = void 0)) : !A.scriptIsRunning && g.scriptRunState !== ScriptRunState.RERUN_REQUESTED && g.scriptRunState !== ScriptRunState.COMPILATION_ERROR && (e = ScriptRunState.NOT_RUNNING), {
          userSettings: {
            ...g.userSettings,
            runOnSave: !!A.runOnSave
          },
          dialog: t,
          scriptRunState: e,
          // Reset scriptChangedOnDisk when script starts running
          scriptChangedOnDisk: A.scriptIsRunning ? !1 : g.scriptChangedOnDisk
        };
      });
    }, this.handleSessionEvent = (A) => {
      if (this.sessionEventDispatcher.handleSessionEventMsg(A), A.type === "scriptCompilationException") {
        this.setState({
          scriptRunState: ScriptRunState.COMPILATION_ERROR
        });
        const g = {
          type: DialogType.SCRIPT_COMPILE_ERROR,
          exception: A.scriptCompilationException,
          onClose: () => {
          }
        };
        this.maybeShowErrorDialog(g, A.scriptCompilationException?.message ?? "No message");
      } else A.type === "scriptChangedOnDisk" && this.setState({
        scriptChangedOnDisk: !0
      });
    }, this.maybeUpdatePageUrl = (A, g, e) => {
      const t = this.getBaseUriParts();
      if (t) {
        let c;
        window.__streamlit?.MAIN_PAGE_BASE_URL ? c = parseUriIntoBaseParts(window.__streamlit.MAIN_PAGE_BASE_URL).pathname : c = t.pathname;
        const n = extractPageNameFromPathName(document.location.pathname, c);
        if ((n === "" ? A : n) !== g) {
          const d = e ? "" : g, k = this.state.queryParams || preserveEmbedQueryParams(), p = k ? `?${k}` : "", S = `${c === "/" ? "" : c}/${d}${p}`;
          if (window.location.protocol === "file:") {
            console.warn("Skipping history.pushState() due to file: protocol.");
            return;
          }
          const AA = S.endsWith("/") && S !== "/" ? S.slice(0, -1) : S;
          window.history.pushState({}, "", AA);
        }
      }
    }, this.handleNewSession = (A) => {
      const g = A.initialize;
      if (this.hasStreamlitVersionChanged(g)) {
        window.location.reload();
        return;
      }
      this.hasReceivedNewSession = !0, (!this.sessionInfo.isSet || !this.sessionInfo.current.isConnected) && this.handleInitialization(A);
      const {
        appHash: e,
        currentPageScriptHash: t
      } = this.state, {
        scriptRunId: c,
        name: n,
        mainScriptPath: h,
        fragmentIdsThisRun: d,
        pageScriptHash: k,
        mainScriptHash: p
      } = A;
      if (d.length)
        this.setState({
          fragmentIdsThisRun: d,
          latestRunTime: performance.now()
        });
      else {
        this.cleanupAutoReruns();
        const S = A.config, AA = A.customTheme;
        this.processThemeInput(AA), this.setState({
          allowRunOnSave: S.allowRunOnSave,
          hideTopBar: S.hideTopBar,
          toolbarMode: S.toolbarMode,
          latestRunTime: performance.now(),
          mainScriptHash: p,
          // If we're here, the fragmentIdsThisRun variable is always the
          // empty array.
          fragmentIdsThisRun: d
        }), this.maybeSetState(this.appNavigation.handleNewSession(A)), !this.appNavigation.hasSetDefaultFavicon && !this.appNavigation.isPageIconSet && (this.appNavigation.hasSetDefaultFavicon = !0, this.onPageIconChanged("./favicon.png"));
      }
      const M = hashString(this.sessionInfo.current.installationId + h);
      this.metricsMgr.setMetadata(this.state.deployedAppMetadata), this.metricsMgr.setAppHash(M), this.metricsMgr.enqueue("updateReport"), e === M && t === k ? this.setState({
        scriptRunId: c
      }) : this.clearAppState(M, c, n, p);
    }, this.handleInitialization = (A) => {
      const g = A.initialize, e = A.config;
      this.sessionInfo.setCurrent(SessionInfo.propsFromNewSessionMessage(A)), this.metricsMgr.initialize({
        gatherUsageStats: e.gatherUsageStats,
        sendMessageToHost: this.hostCommunicationMgr.sendMessageToHost
      }), this.handleSessionStatusChanged(g.sessionStatus);
    }, this.onHistoryChange = () => {
      const {
        currentPageScriptHash: A
      } = this.state, g = this.appNavigation.findPageByUrlPath(document.location.pathname), e = document.location.toString().includes("#"), t = g?.pageScriptHash === A;
      isNullOrUndefined(g) || e && t || this.onPageChange(g.pageScriptHash, void 0, !0);
    }, this.setAndSendTheme = (A) => {
      this.props.theme.setTheme(A), this.hostCommunicationMgr.sendMessageToHost({
        type: "SET_THEME_CONFIG",
        themeInfo: toExportedTheme(A.emotion)
      });
    }, this.createThemeHash = (A) => {
      if (!A)
        return "hash_for_undefined_custom_theme";
      const g = JSON.parse(JSON.stringify(A)), e = sortThemeInputKeys(g);
      return hashString(JSON.stringify(e));
    }, this.closeDialog = () => {
      this.state.dialog?.type === DialogType.CONNECTION_ERROR ? this.setState({
        dialog: void 0,
        connectionErrorDismissed: !0
      }) : this.setState({
        dialog: void 0
      });
    }, this.saveSettings = (A) => {
      const {
        runOnSave: g
      } = this.state.userSettings, {
        runOnSave: e
      } = A;
      if (this.setState({
        userSettings: A
      }), g !== e && this.isServerConnected()) {
        const t = new BackMsg({
          setRunOnSave: e
        });
        t.type = "setRunOnSave", this.sendBackMsg(t);
      }
    }, this.handleDeltaMsg = (A, g) => {
      this.setState((e) => ({
        elements: e.elements.applyDelta(e.scriptRunId, A, g)
      }));
    }, this.debugShutdownRuntime = () => {
      if (this.isServerConnected()) {
        const A = new BackMsg({
          debugShutdownRuntime: !0
        });
        A.type = "debugShutdownRuntime", this.sendBackMsg(A);
      }
    }, this.debugDisconnectWebsocket = () => {
      if (this.isServerConnected()) {
        const A = new BackMsg({
          debugDisconnectWebsocket: !0
        });
        A.type = "debugDisconnectWebsocket", this.sendBackMsg(A);
      }
    }, this.debugClearForwardMsgCache = () => {
      isLocalhost() && this.connectionManager?.websocketConnection?.cache.messages.clear();
    }, this.cleanupAutoReruns = () => {
      this.state.autoReruns.forEach((A) => {
        clearInterval(A);
      }), this.setState({
        autoReruns: []
      });
    }, this.rerunScript = (A = !1) => {
      if (this.closeDialog(), !this.isServerConnected()) {
        LOG.error("Cannot rerun script when disconnected from server.");
        return;
      }
      this.state.scriptRunState === ScriptRunState.RUNNING || this.state.scriptRunState === ScriptRunState.RERUN_REQUESTED || (this.setState({
        scriptRunState: ScriptRunState.RERUN_REQUESTED
      }), A === !0 && this.saveSettings({
        ...this.state.userSettings,
        runOnSave: !0
      }), this.widgetMgr.sendUpdateWidgetsMessage(void 0));
    }, this.sendLoadGitInfoBackMsg = () => {
      if (!this.isServerConnected()) {
        LOG.error("Cannot load git information when disconnected from server.");
        return;
      }
      this.sendBackMsg(new BackMsg({
        loadGitInfo: !0
      }));
    }, this.onPageChange = (A, g, e) => {
      const {
        elements: t,
        mainScriptHash: c
      } = this.state;
      this.cleanupAutoReruns();
      const n = this.appNavigation.clearPageElements(t, c), h = new Set(Array.from(n.getElements()).map((d) => getElementId(d)).filter(notUndefined));
      this.sendRerunBackMsg(this.widgetMgr.getActiveWidgetStates(h), void 0, A, void 0, g, e);
    }, this.isAppInReadyState = (A) => this.state.connectionState === ConnectionState.CONNECTED && this.state.scriptRunState === ScriptRunState.NOT_RUNNING && A.scriptRunState === ScriptRunState.RUNNING && A.connectionState === ConnectionState.CONNECTED, this.sendRerunBackMsg = (A, g, e, t, c, n) => {
      const h = this.getBaseUriParts();
      if (!h) {
        LOG.error("Cannot send rerun backMessage when disconnected from server.");
        return;
      }
      const {
        currentPageScriptHash: d
      } = this.state;
      let k = c ?? this.getQueryString(), p = "";
      const M = {
        timezone: getTimezone$1(),
        timezoneOffset: getTimezoneOffset(),
        locale: getLocaleLanguage(),
        url: getUrl(),
        isEmbedded: isEmbed(),
        colorScheme: this.getThemeColorScheme()
      };
      if (e) {
        if (e !== d && !n) {
          const AA = preserveEmbedQueryParams();
          k = getQueryString(c, AA), this.setState({
            queryParams: k
          }), this.hostCommunicationMgr.sendMessageToHost({
            type: "SET_QUERY_PARAM",
            queryParams: k
          });
        }
      } else if (d)
        e = d;
      else {
        let AA;
        window.__streamlit?.MAIN_PAGE_BASE_URL ? AA = parseUriIntoBaseParts(window.__streamlit.MAIN_PAGE_BASE_URL).pathname : AA = h.pathname, p = extractPageNameFromPathName(document.location.pathname, AA), e = "";
      }
      const S = this.connectionManager?.getCachedMessageHashes() ?? [];
      this.sendBackMsg(new BackMsg({
        rerunScript: {
          queryString: k,
          widgetStates: A,
          pageScriptHash: e,
          pageName: p,
          fragmentId: g,
          isAutoRerun: t,
          cachedMessageHashes: S,
          contextInfo: M
        }
      })), this.hasReceivedNewSession = !1;
    }, this.stopScript = () => {
      if (!this.isServerConnected()) {
        LOG.error("Cannot stop app when disconnected from server.");
        return;
      }
      if (this.state.scriptRunState === ScriptRunState.NOT_RUNNING || this.state.scriptRunState === ScriptRunState.STOP_REQUESTED)
        return;
      const A = new BackMsg({
        stopScript: !0
      });
      A.type = "stopScript", this.sendBackMsg(A), this.setState({
        scriptRunState: ScriptRunState.STOP_REQUESTED
      });
    }, this.openClearCacheDialog = () => {
      if (this.isServerConnected()) {
        const A = {
          type: DialogType.CLEAR_CACHE,
          confirmCallback: this.clearCache,
          defaultAction: this.clearCache,
          onClose: () => {
          }
        };
        this.openDialog(A);
      } else
        LOG.error("Cannot clear cache: disconnected from server");
    }, this.openDeployDialog = () => {
      const A = {
        type: DialogType.DEPLOY_DIALOG,
        onClose: this.closeDialog,
        showDeployError: this.showDeployError,
        isDeployErrorModalOpen: this.state.dialog?.type === DialogType.DEPLOY_ERROR,
        metricsMgr: this.metricsMgr,
        gitInfo: this.state.gitInfo
      };
      this.openDialog(A);
    }, this.clearCache = () => {
      if (this.closeDialog(), this.isServerConnected()) {
        const A = new BackMsg({
          clearCache: !0
        });
        A.type = "clearCache", this.sendBackMsg(A);
      } else
        LOG.error("Cannot clear cache: disconnected from server");
    }, this.sendAppHeartbeat = () => {
      if (this.isServerConnected()) {
        const A = new BackMsg({
          appHeartbeat: !0
        });
        A.type = "appHeartbeat", this.sendBackMsg(A);
      } else
        LOG.error("Cannot send app heartbeat: disconnected from server");
    }, this.sendBackMsg = (A) => {
      this.connectionManager ? (LOG.info(A), this.connectionManager.sendMessage(A)) : LOG.error(`Not connected. Cannot send back message: ${A}`);
    }, this.handleConnectionError = (A) => {
      this.state.connectionErrorDismissed || this.showError("Connection error", A, DialogType.CONNECTION_ERROR);
    }, this.isServerConnected = () => this.connectionManager ? this.connectionManager.isConnected() : !1, this.settingsCallback = (A = !0) => {
      const g = {
        type: DialogType.SETTINGS,
        sessionInfo: this.sessionInfo,
        isServerConnected: this.isServerConnected(),
        settings: this.state.userSettings,
        allowRunOnSave: this.state.allowRunOnSave,
        onSave: this.saveSettings,
        onClose: () => {
        },
        animateModal: A,
        metricsMgr: this.metricsMgr
      };
      this.openDialog(g);
    }, this.aboutCallback = () => {
      const {
        menuItems: A
      } = this.state, g = {
        type: DialogType.ABOUT,
        onClose: this.closeDialog,
        aboutSectionMd: A?.aboutSectionMd
      };
      this.openDialog(g);
    }, this.printCallback = () => {
      const {
        scriptRunState: A
      } = this.state;
      if (A !== ScriptRunState.NOT_RUNNING) {
        setTimeout(this.printCallback, 500);
        return;
      }
      let g;
      try {
        const e = getIFrameEnclosingApp(this.embeddingId);
        e?.contentWindow ? g = e.contentWindow.window : g = window;
      } catch {
        g = window;
      } finally {
        g || (g = window), g.print();
      }
    }, this.screencastCallback = () => {
      const {
        scriptName: A
      } = this.state, {
        startRecording: g
      } = this.props.screenCast, e = getScreencastTimestamp();
      g(`streamlit-${A}-${e}`);
    }, this.handleFullScreen = (A) => {
      this.setState({
        isFullScreen: A
      });
    }, this.setLibConfig = (A) => {
      this.setState({
        libConfig: A
      });
    }, this.setAppConfig = (A) => {
      this.setState({
        appConfig: A
      });
    }, this.addScriptFinishedHandler = (A) => {
      this.setState((g, e) => ({
        scriptFinishedHandlers: g.scriptFinishedHandlers.concat(A)
      }));
    }, this.removeScriptFinishedHandler = (A) => {
      this.setState((g, e) => ({
        scriptFinishedHandlers: g.scriptFinishedHandlers.filter((t) => t !== A)
      }));
    }, this.getBaseUriParts = () => this.connectionManager ? this.connectionManager.getBaseUriParts() : void 0, this.getQueryString = () => {
      const {
        queryParams: A
      } = this.state, g = A && A.length > 0 ? A : document.location.search;
      return g.startsWith("?") ? g.substring(1) : g;
    }, this.getThemeColorScheme = () => {
      const {
        activeTheme: A
      } = this.props.theme;
      return hasLightBackgroundColor(A.emotion) ? "light" : "dark";
    }, this.isInCloudEnvironment = () => {
      const {
        hostMenuItems: A
      } = this.state;
      return A && A?.length > 0;
    }, this.showDeployButton = () => showDevelopmentOptions(this.state.isOwner, this.state.toolbarMode) && !this.isInCloudEnvironment() && this.sessionInfo.isSet && !this.sessionInfo.isHello, this.deployButtonClicked = () => {
      this.metricsMgr.enqueue("menuClick", {
        label: "deployButtonInApp"
      }), this.sendLoadGitInfoBackMsg(), this.openDeployDialog();
    }, this.requestFileURLs = (A, g) => {
      const e = this.isServerConnected(), t = this.sessionInfo.isSet;
      if (e && t) {
        const c = new BackMsg({
          fileUrlsRequest: {
            requestId: A,
            fileNames: g.map((n) => n.name),
            sessionId: this.sessionInfo.current.sessionId
          }
        });
        c.type = "fileUrlsRequest", this.sendBackMsg(c);
      } else
        LOG.warn(`Cannot request file URLs (isServerConnected: ${e}, isSessionInfoSet: ${t})`), this.uploadClient.onFileURLsResponse({
          responseId: A,
          errorMsg: "Connection lost. Please wait for the app to reconnect, then try again."
        });
    }, this.requestDeferredFile = (A) => {
      const g = this.isServerConnected(), e = this.sessionInfo.isSet;
      if (!g || !e)
        return Promise.reject(new Error("Not connected to server or session not initialized"));
      const t = Promise.withResolvers(), c = this.deferredFileListeners.get(A) ?? /* @__PURE__ */ new Set(), n = (d) => {
        c.delete(n), t.resolve(d);
      };
      c.add(n), this.deferredFileListeners.set(A, c);
      const h = new BackMsg({
        deferredFileRequest: {
          fileId: A,
          sessionId: this.sessionInfo.current.sessionId
        }
      });
      return h.type = "deferredFileRequest", this.sendBackMsg(h), t.promise;
    }, this.handleDeferredFileResponse = (A) => {
      const g = this.deferredFileListeners.get(A.fileId);
      if (!(!g || g.size === 0)) {
        for (const e of Array.from(g))
          try {
            e(A);
          } catch {
          }
        this.deferredFileListeners.delete(A.fileId);
      }
    }, this.handleKeyDown = (A, g) => {
      if (!((A === "c" || A === "r") && isKeyboardEventFromEditableTarget(g)))
        switch (A) {
          case "c":
            showDevelopmentOptions(this.state.isOwner, this.state.toolbarMode) && this.openClearCacheDialog();
            break;
          case "r":
            this.rerunScript();
            break;
        }
    }, this.handleKeyUp = (A) => {
      A === "esc" && this.props.screenCast.stopRecording();
    }, this.hasAppDefinedMenuItems = () => {
      const {
        menuItems: A
      } = this.state;
      return !!(A?.aboutSectionMd || A?.getHelpUrl && !A?.hideGetHelp || A?.reportABugUrl && !A?.hideReportABug);
    }, this.shouldShowToolbar = (A, g) => {
      const e = !isEmbed() || isToolbarDisplayed();
      let t;
      return this.state.toolbarMode === Config.ToolbarMode.MINIMAL ? t = A.length > 0 || g.length > 0 || this.hasAppDefinedMenuItems() : t = !0, e && t;
    }, ensureHotkeysFilterConfigured(), enablePatches(), enableMapSet(), this.state = {
      connectionState: ConnectionState.INITIAL,
      elements: AppRoot.empty("", !0),
      // Blank Main Script Hash for initial render
      isFullScreen: !1,
      scriptName: "",
      scriptRunId: INITIAL_SCRIPT_RUN_ID,
      appHash: null,
      scriptRunState: ScriptRunState.NOT_RUNNING,
      userSettings: {
        wideMode: !1,
        runOnSave: !1
      },
      connectionErrorDismissed: !1,
      layout: PageConfig.Layout.CENTERED,
      initialSidebarState: PageConfig.SidebarState.AUTO,
      menuItems: void 0,
      allowRunOnSave: !0,
      scriptFinishedHandlers: [],
      // Initialize themeHash to empty string to ensure the first processThemeInput
      // call always processes the theme (whether null or custom theme from server).
      // This prevents the bug where a cached custom theme isn't cleared when the
      // server sends null, because null and undefined both hash to the same value.
      themeHash: "",
      gitInfo: null,
      formsData: createFormsData(),
      appPages: [],
      navSections: [],
      currentPageScriptHash: "",
      mainScriptHash: "",
      // We set hideTopBar to true by default because this information isn't
      // available on page load (we get it when the script begins to run), so
      // the user would see top bar elements for a few ms if this defaulted to
      // false. hideSidebarNav doesn't have this issue (app pages and the value
      // of the config option are received simultaneously), but we set it to
      // true as well for consistency.
      hideTopBar: !0,
      hideSidebarNav: !0,
      expandSidebarNav: !1,
      toolbarMode: Config.ToolbarMode.MINIMAL,
      latestRunTime: performance.now(),
      fragmentIdsThisRun: [],
      // Information sent from the host
      isOwner: !1,
      hostMenuItems: [],
      hostToolbarItems: [],
      hostHideSidebarNav: !1,
      sidebarChevronDownshift: 0,
      pageLinkBaseUrl: "",
      queryParams: "",
      deployedAppMetadata: {},
      libConfig: {},
      appConfig: {},
      autoReruns: [],
      inputsDisabled: !1,
      navigationPosition: Navigation.Position.SIDEBAR,
      scriptChangedOnDisk: !1
    }, this.connectionManager = null, this.widgetMgr = new WidgetStateManager({
      sendRerunBackMsg: this.sendRerunBackMsg,
      formsDataChanged: (A) => this.setState({
        formsData: A
      })
    }), this.hostCommunicationMgr = new HostCommunicationManager({
      streamlitExecutionStartedAt: E.streamlitExecutionStartedAt,
      sendRerunBackMsg: this.sendRerunBackMsg,
      closeModal: this.closeDialog,
      stopScript: this.stopScript,
      rerunScript: this.rerunScript,
      clearCache: this.clearCache,
      sendAppHeartbeat: this.sendAppHeartbeat,
      setInputsDisabled: (A) => {
        this.setState({
          inputsDisabled: A
        });
      },
      themeChanged: this.handleThemeMessage,
      pageChanged: (A) => this.onPageChange(A),
      isOwnerChanged: (A) => this.setState({
        isOwner: A
      }),
      fileUploadClientConfigChanged: (A) => {
        this.endpoints.setFileUploadClientConfig !== void 0 && this.endpoints.setFileUploadClientConfig(A);
      },
      hostMenuItemsChanged: (A) => {
        this.setState({
          hostMenuItems: A
        });
      },
      hostToolbarItemsChanged: (A) => {
        this.setState({
          hostToolbarItems: A
        });
      },
      hostHideSidebarNavChanged: (A) => {
        this.setState({
          hostHideSidebarNav: A
        });
      },
      sidebarChevronDownshiftChanged: (A) => {
        this.setState({
          sidebarChevronDownshift: A
        });
      },
      pageLinkBaseUrlChanged: (A) => {
        this.setState({
          pageLinkBaseUrl: A
        });
      },
      queryParamsChanged: (A) => {
        this.setState({
          queryParams: A
        });
      },
      deployedAppMetadataChanged: (A) => {
        this.setState({
          deployedAppMetadata: A
        });
      },
      restartWebsocketConnection: () => {
        this.connectionManager || (this.setState({
          scriptRunState: ScriptRunState.RERUN_REQUESTED
        }), this.initializeConnectionManager());
      },
      terminateWebsocketConnection: () => {
        this.connectionManager?.disconnect(), this.connectionManager = null;
      }
    }), this.endpoints = new DefaultStreamlitEndpoints({
      getServerUri: this.getBaseUriParts,
      csrfEnabled: !0,
      sendClientError: (A, g, e, t, c) => {
        this.hostCommunicationMgr.sendMessageToHost({
          type: "CLIENT_ERROR",
          component: A,
          error: g,
          message: e,
          source: t,
          customComponentName: c
        });
      }
    }), this.uploadClient = new FileUploadClient({
      sessionInfo: this.sessionInfo,
      endpoints: this.endpoints,
      // A form cannot be submitted if it contains a FileUploader widget
      // that's currently uploading. We write that state here, in response
      // to a FileUploadClient callback. The FormSubmitButton element
      // reads the state.
      formsWithPendingRequestsChanged: (A) => this.widgetMgr.setFormsWithUploadsInProgress(A),
      requestFileURLs: this.requestFileURLs
    }), this.componentRegistry = new ComponentRegistry(this.endpoints), this.appNavigation = new AppNavigation(this.hostCommunicationMgr, this.maybeUpdatePageUrl, this.onPageNotFound, this.onPageIconChanged), window.streamlitDebug = {
      clearForwardMsgCache: this.debugClearForwardMsgCache,
      disconnectWebsocket: this.debugDisconnectWebsocket,
      shutdownRuntime: this.debugShutdownRuntime
    };
  }
  initializeConnectionManager() {
    this.isInitializingConnectionManager = !0;
    const E = this.context?.kernel;
    if (E == null)
      throw new Error("Kernel is not set in the context.");
    this.connectionManager = new ConnectionManager({
      kernel: E,
      getLastSessionId: () => this.sessionInfo.last?.sessionId,
      endpoints: this.endpoints,
      onMessage: this.handleMessage,
      onConnectionError: this.handleConnectionError,
      connectionStateChanged: this.handleConnectionStateChanged,
      claimHostAuthToken: this.hostCommunicationMgr.claimAuthToken,
      resetHostAuthToken: this.hostCommunicationMgr.resetAuthToken,
      sendClientError: (A, g, e) => {
        this.hostCommunicationMgr.sendMessageToHost({
          type: "CLIENT_ERROR",
          component: "Websocket Connection",
          error: A,
          message: g,
          source: e
        });
      },
      onHostConfigResp: (A) => {
        const {
          allowedOrigins: g,
          useExternalAuthToken: e,
          disableFullscreenMode: t,
          enableCustomParentMessages: c,
          mapboxToken: n,
          enforceDownloadInNewTab: h,
          metricsUrl: d,
          blockErrorDialogs: k,
          setAnonymousCrossOriginPropertyOnMediaElements: p,
          resourceCrossOriginMode: M
        } = A, S = {
          allowedOrigins: g,
          useExternalAuthToken: e,
          enableCustomParentMessages: c,
          blockErrorDialogs: k
        }, AA = {
          mapboxToken: n,
          disableFullscreenMode: t,
          enforceDownloadInNewTab: h,
          resourceCrossOriginMode: M ?? p ? "anonymous" : void 0
        };
        this.metricsMgr.setMetricsConfig(d), this.hostCommunicationMgr.setAllowedOrigins(S), this.setAppConfig(S), this.setLibConfig(AA);
      }
    }), this.isInitializingConnectionManager = !1;
  }
  componentDidMount() {
    const E = this.context?.kernel;
    if (E == null)
      throw new Error("Kernel is not set in the context.");
    this.initializeConnectionManager(), mark(this.state.scriptRunState), this.hostCommunicationMgr.sendMessageToHost({
      type: "SCRIPT_RUN_STATE_CHANGED",
      scriptRunState: this.state.scriptRunState
    }), this.uploadClient.setKernel(E), isScrollingHidden() && document.body.classList.add("embedded"), isInChildFrame() && (window.iFrameResizer = {
      heightCalculationMethod: () => {
        const A = document.querySelectorAll("[data-iframe-height]"), g = Array.from(A).map((e) => (
          // eslint-disable-next-line streamlit-custom/no-force-reflow-access -- Existing usage
          Math.ceil(e.getBoundingClientRect().bottom)
        ));
        return Math.max(0, ...g);
      }
    }, import("./iframeResizer.contentWindow-9ByjY9IM.js").then((A) => A.i)), this.hostCommunicationMgr.sendMessageToHost({
      type: "SET_THEME_CONFIG",
      themeInfo: toExportedTheme(this.props.theme.activeTheme.emotion)
    }), this.metricsMgr.enqueue("viewReport"), window.addEventListener("popstate", this.onHistoryChange, !1);
  }
  componentDidUpdate(E, A) {
    if (window.prerenderReady === !1 && this.isAppInReadyState(A) && (window.prerenderReady = !0), this.state.scriptRunState !== A.scriptRunState) {
      if (mark(this.state.scriptRunState), this.state.scriptRunState === ScriptRunState.NOT_RUNNING)
        try {
          measure("script-run-cycle", ScriptRunState.RUNNING, ScriptRunState.NOT_RUNNING);
        } catch {
        }
      this.hostCommunicationMgr.sendMessageToHost({
        type: "SCRIPT_RUN_STATE_CHANGED",
        scriptRunState: this.state.scriptRunState
      });
    }
  }
  componentWillUnmount() {
    this.connectionManager?.disconnect(), this.hostCommunicationMgr.closeHostCommunication(), window.removeEventListener("popstate", this.onHistoryChange, !1);
  }
  /**
   * Checks whether to show error dialog or send error info
   * to be handled by the host.
   */
  maybeShowErrorDialog(E, A) {
    const {
      blockErrorDialogs: g
    } = this.state.appConfig;
    g || this.openDialog(E);
    const t = E.type === DialogType.SCRIPT_COMPILE_ERROR ? E.type : E.title;
    this.hostCommunicationMgr.sendMessageToHost({
      type: "CLIENT_ERROR_DIALOG",
      error: t,
      message: A
    });
  }
  showError(E, A, g = DialogType.WARNING) {
    LOG.error(A.message);
    const e = {
      type: g,
      title: E,
      msg: /* @__PURE__ */ jsxRuntimeExports.jsx(DialogErrorMessage$1, { message: A.message, codeBlock: A.codeBlock }),
      onClose: () => {
      }
    };
    this.maybeShowErrorDialog(e, A.message);
  }
  /**
   * Checks if the code version from the backend is different than the frontend
   */
  hasStreamlitVersionChanged(E) {
    let A;
    if (window.__streamlit?.ENABLE_RELOAD_BASED_ON_HARDCODED_STREAMLIT_VERSION === !0 ? A = PACKAGE_METADATA.version : this.sessionInfo.isSet && (A = this.sessionInfo.current.streamlitVersion), A) {
      const {
        environmentInfo: g
      } = E;
      if (notNullOrUndefined(g) && notNullOrUndefined(g.streamlitVersion))
        return A != g.streamlitVersion;
    }
    return !1;
  }
  maybeSetState(E) {
    if (E) {
      const [A, g] = E;
      this.setState(A, g);
    }
  }
  processThemeInput(E) {
    const A = this.createThemeHash(E);
    if (A === this.state.themeHash)
      return;
    this.setState({
      themeHash: A
    });
    const g = !isPresetTheme(this.props.theme.activeTheme);
    if (E) {
      const e = createCustomThemes(E);
      this.props.theme.addThemes(e, {
        keepPresetThemes: !1
      });
      const t = getCachedTheme(), c = mapCachedThemeToAvailableTheme(t, e);
      if (c)
        this.setAndSendTheme(c);
      else if (e.length > 1) {
        const n = e.findIndex((h) => h.name === CUSTOM_THEME_AUTO_NAME);
        this.setAndSendTheme(e[n]);
      } else
        this.setAndSendTheme(e[0]);
    } else if (this.props.theme.addThemes([]), g) {
      const e = getCachedTheme(), c = mapCachedThemeToAvailableTheme(e, [lightTheme, darkTheme]);
      c ? this.setAndSendTheme(c) : this.setAndSendTheme(getHostSpecifiedTheme());
    }
    (E?.fontFaces && E.fontFaces.length > 0 || E?.fontSources && E.fontSources.length > 0) && this.props.theme.setFonts(E);
  }
  /**
   * Handler for ForwardMsg.scriptFinished messages
   * @param status the ScriptFinishedStatus that the script finished with
   */
  handleScriptFinished(E) {
    (E === ForwardMsg.ScriptFinishedStatus.FINISHED_SUCCESSFULLY || E === ForwardMsg.ScriptFinishedStatus.FINISHED_EARLY_FOR_RERUN || E === ForwardMsg.ScriptFinishedStatus.FINISHED_FRAGMENT_RUN_SUCCESSFULLY) && (Promise.resolve().then(() => {
      this.state.scriptFinishedHandlers.forEach((A) => A());
    }), (E === ForwardMsg.ScriptFinishedStatus.FINISHED_SUCCESSFULLY || E === ForwardMsg.ScriptFinishedStatus.FINISHED_FRAGMENT_RUN_SUCCESSFULLY) && this.setState(({
      scriptRunId: A,
      fragmentIdsThisRun: g,
      elements: e
    }) => ({
      // Apply any pending elements that haven't been applied.
      elements: e.clearStaleNodes(A, g)
    }), () => {
      const A = new Set(
        // TODO: Update to match React best practices
        // eslint-disable-next-line @eslint-react/no-access-state-in-setstate
        Array.from(this.state.elements.getElements()).map((g) => getElementId(g)).filter(notUndefined)
      );
      this.widgetMgr.removeInactive(A);
    }), this.connectionManager !== null && E !== ForwardMsg.ScriptFinishedStatus.FINISHED_EARLY_FOR_RERUN && this.sessionInfo.isSet && // We only increment the message cache run count if we have received
    // a NewSession message after the latest rerun request. This is done
    // to ignore finished messages from previous script runs, which would
    // cause issues with deleting cached messages that are needed for the
    // current script run.
    this.hasReceivedNewSession && this.connectionManager.incrementMessageCacheRunCount(this.sessionInfo.current.maxCachedMessageAge, this.state.fragmentIdsThisRun));
  }
  /*
   * Clear all elements from the state.
   */
  clearAppState(E, A, g, e) {
    this.setState((t) => {
      const c = this.appNavigation.clearPageElements(t.elements, e);
      return {
        scriptRunId: A,
        scriptName: g,
        appHash: E,
        elements: c
      };
    }, () => {
      const t = new Set(
        // TODO: Update to match React best practices
        // eslint-disable-next-line @eslint-react/no-access-state-in-setstate
        Array.from(this.state.elements.getElements()).map((c) => getElementId(c)).filter(notUndefined)
      );
      this.widgetMgr.removeInactive(t);
    });
  }
  /**
   * Opens a dialog with the specified state.
   */
  openDialog(E) {
    this.setState({
      dialog: E
    });
  }
  render() {
    const {
      allowRunOnSave: E,
      connectionState: A,
      dialog: g,
      elements: e,
      initialSidebarState: t,
      menuItems: c,
      isFullScreen: n,
      scriptRunId: h,
      scriptRunState: d,
      userSettings: k,
      hideTopBar: p,
      hideSidebarNav: M,
      expandSidebarNav: S,
      currentPageScriptHash: AA,
      hostHideSidebarNav: H,
      pageLinkBaseUrl: gA,
      sidebarChevronDownshift: CA,
      hostMenuItems: IA,
      hostToolbarItems: BA,
      libConfig: QA,
      inputsDisabled: EA,
      appPages: oA,
      navSections: iA,
      navigationPosition: aA,
      scriptChangedOnDisk: tA
    } = this.state, eA = this.props.isMobileViewport ? Navigation.Position.SIDEBAR : aA, cA = showDevelopmentOptions(this.state.isOwner, this.state.toolbarMode), DA = classNames("stApp", getEmbeddingIdClassName(this.embeddingId), {
      "streamlit-embedded": isEmbed(),
      "streamlit-wide": k.wideMode
    }), nA = g ? StreamlitDialog({
      ...g,
      onClose: this.closeDialog
    }) : null, wA = this.shouldShowToolbar(IA, BA), lA = !isEmbed() || isPaddingDisplayed(), NA = isScrollingHidden();
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      StreamlitContextProvider$1,
      {
        initialSidebarState: t,
        pageLinkBaseUrl: gA,
        currentPageScriptHash: AA,
        onPageChange: this.onPageChange,
        navSections: iA,
        appPages: oA,
        appLogo: e.logo,
        sidebarChevronDownshift: CA,
        expandSidebarNav: S,
        hideSidebarNav: M || H || eA === Navigation.Position.TOP,
        isFullScreen: n,
        setFullScreen: this.handleFullScreen,
        activeTheme: this.props.theme.activeTheme,
        setTheme: this.setAndSendTheme,
        availableThemes: this.props.theme.availableThemes,
        fragmentIdsThisRun: this.state.fragmentIdsThisRun,
        locale: window.navigator.language,
        formsData: this.state.formsData,
        scriptRunState: d,
        scriptRunId: h,
        mapboxToken: QA.mapboxToken,
        enforceDownloadInNewTab: QA.enforceDownloadInNewTab,
        resourceCrossOriginMode: QA.resourceCrossOriginMode,
        requestDeferredFile: this.requestDeferredFile,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(ReactHotkeys, { keyName: "r,c,esc", onKeyDown: this.handleKeyDown, onKeyUp: this.handleKeyUp, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledApp, { className: DA, "data-testid": "stApp", "data-test-script-state": h == INITIAL_SCRIPT_RUN_ID ? "initial" : d, "data-test-connection-state": A, children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(AppView, { endpoints: this.endpoints, sendMessageToHost: this.hostCommunicationMgr.sendMessageToHost, elements: e, widgetMgr: this.widgetMgr, uploadClient: this.uploadClient, navigationPosition: eA, wideMode: k.wideMode, embedded: isEmbed(), showPadding: lA, disableScrolling: NA, addScriptFinishedHandler: this.addScriptFinishedHandler, removeScriptFinishedHandler: this.removeScriptFinishedHandler, widgetsDisabled: EA || A !== ConnectionState.CONNECTED, showToolbar: wA, disableFullscreenMode: QA.disableFullscreenMode, componentRegistry: this.componentRegistry, topRightContent: /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
            !p && /* @__PURE__ */ jsxRuntimeExports.jsx(StatusWidget, { connectionState: A, scriptRunState: d, rerunScript: this.rerunScript, stopScript: this.stopScript, allowRunOnSave: E, showScriptChangedActions: tA }),
            !p && /* @__PURE__ */ jsxRuntimeExports.jsx(ToolbarActions, { hostToolbarItems: BA, sendMessageToHost: this.hostCommunicationMgr.sendMessageToHost, metricsMgr: this.metricsMgr }),
            this.showDeployButton() && !tA && /* @__PURE__ */ jsxRuntimeExports.jsx(DeployButton, { onClick: this.deployButtonClicked }),
            !p && /* @__PURE__ */ jsxRuntimeExports.jsx(MainMenu$1, { isServerConnected: this.isServerConnected(), quickRerunCallback: this.rerunScript, clearCacheCallback: this.openClearCacheDialog, settingsCallback: this.settingsCallback, aboutCallback: this.aboutCallback, printCallback: this.printCallback, screencastCallback: this.screencastCallback, screenCastState: this.props.screenCast.currentState, hostMenuItems: IA, developmentMode: cA, sendMessageToHost: this.hostCommunicationMgr.sendMessageToHost, menuItems: c, metricsMgr: this.metricsMgr, toolbarMode: this.state.toolbarMode })
          ] }) }),
          nA
        ] }) })
      }
    );
  }
};
cI.contextType = StliteKernelContext;
let App = cI;
const AppWithScreenCast = withScreencast(App), AppWrapper = (o) => {
  const {
    isMobile: E
  } = useViewportSize();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(AppWithScreenCast, { ...o, isMobileViewport: E });
};
function useThemeManager() {
  const o = getDefaultTheme(), [E, A] = useState(o), [g, e] = useState(o.themeInput?.fontFaces ?? []), [t, c] = useState(null), [n, h] = useState(() => [...createPresetThemes(), ...isPresetTheme(o) ? [] : [o]]), d = (AA, H = {}) => {
    const {
      keepPresetThemes: gA = !0
    } = H;
    h([...gA ? createPresetThemes() : [], ...AA]);
  }, k = useCallback((AA) => {
    A((H) => AA !== H ? (AA.name === AUTO_THEME_NAME ? removeCachedTheme() : setCachedTheme(AA), AA) : H);
  }, [A]), p = useCallback(() => {
    E.name === AUTO_THEME_NAME && k(getHostSpecifiedTheme());
    const AA = n.filter((H) => H.name !== AUTO_THEME_NAME);
    h([createAutoTheme(), ...AA]);
  }, [E.name, n, k]), M = useCallback((AA) => {
    AA.fontFaces && e(AA.fontFaces);
    const H = [...AA.fontSources || [], ...AA.sidebar?.fontSources || []], gA = {};
    H.forEach((CA) => {
      CA.sourceUrl && CA.configName && (gA[CA.configName] = CA.sourceUrl);
    }), c(Object.keys(gA).length > 0 ? gA : null);
  }, [e, c]), S = useCallback((AA) => {
    M(AA);
    const H = new CustomThemeConfig(AA), gA = createTheme(CUSTOM_THEME_NAME, H);
    k(gA);
  }, [M, k]);
  return useEffect(() => {
    const AA = window.matchMedia("(prefers-color-scheme: dark)");
    return AA.addEventListener("change", p), window.addEventListener("afterprint", p), () => {
      window.removeEventListener("afterprint", p), AA.removeEventListener("change", p);
    };
  }, [E, n, p]), [{
    setTheme: k,
    activeTheme: E,
    addThemes: d,
    availableThemes: n,
    setFonts: M,
    setImportedTheme: S
  }, g, t];
}
const appStyles = (o) => /* @__PURE__ */ css("font-size:", o.fontSizes.baseFontSize, "px;*,*::before,*::after{box-sizing:border-box;}margin:0;font-family:", o.genericFonts.bodyFont, ";font-weight:", o.fontWeights.normal, ";line-height:", o.lineHeights.base, ";color:", o.colors.bodyText, ";background-color:", o.colors.bgColor, ";-webkit-text-size-adjust:100%;-webkit-tap-highlight-color:", transparentize(o.colors.black, 1), ';-webkit-font-smoothing:auto;[tabindex="-1"]:focus:not(:focus-visible){outline:0!important;}p,ol,ul,dl{margin:0 0 1rem 0;padding:0;font-size:1rem;font-weight:', o.fontWeights.normal, ';}ol ol,ul ul,ol ul,ul ol{margin-bottom:0;}a:not([href]):not([class]){&,&:hover{color:inherit;text-decoration:none;}}img,svg{vertical-align:middle;}input,button,select,optgroup,textarea{margin:0;font-family:inherit;line-height:inherit;font-size:inherit;}button,input{overflow:visible;}button,[role="button"]{&:not(:disabled){cursor:pointer;}}button,[type="button"],[type="reset"],[type="submit"]{-webkit-appearance:button;}[hidden]{display:none!important;}@supports (scrollbar-color: transparent transparent){*{scrollbar-width:thin;scrollbar-color:transparent transparent;}*:hover{scrollbar-color:', o.colors.fadedText40, " transparent;}}@supports not (scrollbar-color: transparent transparent){::-webkit-scrollbar{background:transparent;border-radius:", o.radii.full, ";height:6px;width:6px;}::-webkit-scrollbar:active{background:", o.colors.fadedText10, ";}:hover::-webkit-scrollbar-thumb:vertical,:hover::-webkit-scrollbar-thumb:horizontal{background:", o.colors.fadedText40, ";border-radius:", o.radii.full, ";}}" + (process.env.NODE_ENV === "production" ? "" : ";label:appStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const documentStyles = process.env.NODE_ENV === "production" ? {
  name: "cqykvy",
  styles: "html,body{height:100%;margin:0;}@media print{html{height:100%;print-color-adjust:exact;-webkit-print-color-adjust:exact;}}"
} : {
  name: "vld0b3-documentStyles",
  styles: "html,body{height:100%;margin:0;}@media print{html{height:100%;print-color-adjust:exact;-webkit-print-color-adjust:exact;}};label:documentStyles;/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvcGFja2FnZXMvcmVhY3Qvc3JjL2RvY3VtZW50U3R5bGVzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUVpQyIsImZpbGUiOiIvaG9tZS9ydW5uZXIvd29yay9zdGxpdGUvc3RsaXRlL3BhY2thZ2VzL3JlYWN0L3NyYy9kb2N1bWVudFN0eWxlcy50cyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGNzcyB9IGZyb20gXCJAZW1vdGlvbi9yZWFjdFwiO1xuXG5leHBvcnQgY29uc3QgZG9jdW1lbnRTdHlsZXMgPSBjc3NgXG4gIGh0bWwsXG4gIGJvZHkge1xuICAgIGhlaWdodDogMTAwJTtcbiAgICBtYXJnaW46IDA7XG4gIH1cblxuICBAbWVkaWEgcHJpbnQge1xuICAgIGh0bWwge1xuICAgICAgaGVpZ2h0OiAxMDAlO1xuICAgICAgLyogbWFrZSBiYWNrZ3JvdW5kLWNvbG9ycyBhcHBlYXIgYnkgZGVmYXVsdCAoZS5nLiB0aGUgc2lkZWJhciBiYWNrZ3JvdW5kLFxuICAgICAgICogd2lkZ2V0IGJhY2tncm91bmQsIG11bHRpLXNlbGVjdCBlbGVtZW50IGJhY2tncm91bmQsIC4uLikgKi9cbiAgICAgIHByaW50LWNvbG9yLWFkanVzdDogZXhhY3Q7XG4gICAgICAtd2Via2l0LXByaW50LWNvbG9yLWFkanVzdDogZXhhY3Q7XG4gICAgfVxuICB9XG5gO1xuIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
}, ALPHABET = "abcdefghijklmnopqrstuvwxyz";
let idCounter = 0;
function randomChars(o) {
  const {
    crypto: E
  } = globalThis;
  if (E?.getRandomValues) {
    const A = new Uint32Array(o);
    return E.getRandomValues(A), Array.from(A, (g) => ALPHABET[g % ALPHABET.length]).join("");
  }
  return Array.from({
    length: o
  }, () => ALPHABET[Math.floor(Math.random() * ALPHABET.length)]).join("");
}
function toAlphabeticString(o) {
  if (o === 0) return "a";
  const E = [];
  let A = o;
  for (; A > 0; )
    E.unshift(ALPHABET[A % ALPHABET.length]), A = Math.floor(A / ALPHABET.length);
  return E.join("");
}
function generateUniqueId(o = 8) {
  if (o <= 0) return "";
  const E = toAlphabeticString(idCounter++), A = toAlphabeticString(Date.now()), g = `${E}${A}${randomChars(o)}`;
  return g.length >= o ? g.slice(0, o) : `${g}${randomChars(o - g.length)}`;
}
function useUniqueId(o = 8) {
  return useMemo$1(() => generateUniqueId(o), [o]);
}
function RootStyleProvider(o) {
  const {
    children: E,
    theme: A,
    styleNonce: g,
    disableDocumentStyles: e
  } = o, t = useUniqueId(), c = useMemo$1(() => createCache({
    key: `st-${t}`,
    ...g && {
      nonce: g
    }
  }), [t, g]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    BaseProvider,
    {
      theme: A.basewebTheme,
      zIndex: A.emotion.zIndices.popup,
      overrides: {
        // BaseUI's LayersManager renders portal content (popovers, modals,
        // tooltips) into a LayersContainer that is a sibling of the app
        // content, not a descendant. In standard Streamlit, text styles
        // (font-family, font-size, etc.) are set on `body` so portals
        // inherit them. In stlite, these styles are scoped to the
        // stlite-root div (via appStyles) to avoid polluting the host page,
        // so the LayersContainer needs them explicitly.
        // Keep these in sync with the inheritable text styles in appStyles.ts.
        LayersContainer: {
          style: {
            fontFamily: A.emotion.genericFonts.bodyFont,
            fontSize: `${A.emotion.fontSizes.baseFontSize}px`,
            fontWeight: A.emotion.fontWeights.normal,
            lineHeight: A.emotion.lineHeights.base,
            color: A.emotion.colors.bodyText
          }
        }
      },
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(CacheProvider, { value: c, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(ThemeProvider$2, { theme: A.emotion, children: [
        !e && /* @__PURE__ */ jsxRuntimeExports.jsx(Global, { styles: documentStyles }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(ClassNames, { children: ({
          css: n,
          cx: h
        }) => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: h(n(
          // "appStyles" contains the styles that are applied to the app root.
          // In the original Streamlit, these were "globalStyles" applied to the body,
          // but in Stlite they are scoped to this root element to allow embedding.
          appStyles(A.emotion)
        ), "stlite-root"), children: E }) })
      ] }) })
    }
  );
}
const ThemedApp = ({
  styleNonce: o,
  streamlitExecutionStartedAt: E,
  disableDocumentStyles: A
}) => {
  const [g, e, t] = useThemeManager(), {
    activeTheme: c
  } = g;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(RootStyleProvider, { theme: c, styleNonce: o, disableDocumentStyles: A, children: /* @__PURE__ */ jsxRuntimeExports.jsx(WindowDimensionsProvider, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(PortalProvider, { children: [
    e.length > 0 && /* @__PURE__ */ jsxRuntimeExports.jsx(FontFaceDeclaration, { fontFaces: e }),
    t && /* @__PURE__ */ jsxRuntimeExports.jsx(FontSources, { fontSources: t }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(AppWrapper, { theme: g, streamlitExecutionStartedAt: E })
  ] }) }) });
};
class SequentialIDGenerator {
  constructor(E = "") {
    this.prefix = E, this.count = 0, this.offset = 374, this.msb = 1295, this.power = 2;
  }
  next() {
    const E = this.increment().toString(36);
    return this.prefix ? `${this.prefix}${E}` : E;
  }
  increment() {
    const E = this.count + this.offset;
    return E === this.msb && (this.offset += (this.msb + 1) * 9, this.msb = Math.pow(36, ++this.power) - 1), this.count++, E;
  }
}
const minMaxWidth = /(!?\(\s*min(-device-)?-width).+\(\s*max(-device)?-width/i, minWidth = /\(\s*min(-device)?-width/i, maxMinWidth = /(!?\(\s*max(-device)?-width).+\(\s*min(-device)?-width/i, maxWidth = /\(\s*max(-device)?-width/i, isMinWidth = _testQuery(minMaxWidth, maxMinWidth, minWidth), isMaxWidth = _testQuery(maxMinWidth, minMaxWidth, maxWidth), minMaxHeight = /(!?\(\s*min(-device)?-height).+\(\s*max(-device)?-height/i, minHeight = /\(\s*min(-device)?-height/i, maxMinHeight = /(!?\(\s*max(-device)?-height).+\(\s*min(-device)?-height/i, maxHeight = /\(\s*max(-device)?-height/i, isMinHeight = _testQuery(minMaxHeight, maxMinHeight, minHeight), isMaxHeight = _testQuery(maxMinHeight, minMaxHeight, maxHeight), isPrint = /print/i, isPrintOnly = /^print$/i, maxValue = Number.MAX_VALUE;
function _getQueryLength(o) {
  const E = /(-?\d*\.?\d+)(ch|em|ex|px|rem)/.exec(o);
  if (E === null)
    return maxValue;
  let A = E[1];
  switch (E[2]) {
    case "ch":
      A = parseFloat(A) * 8.8984375;
      break;
    case "em":
    case "rem":
      A = parseFloat(A) * 16;
      break;
    case "ex":
      A = parseFloat(A) * 8.296875;
      break;
    case "px":
      A = parseFloat(A);
      break;
  }
  return +A;
}
function _testQuery(o, E, A) {
  return function(g) {
    return o.test(g) ? !0 : E.test(g) ? !1 : A.test(g);
  };
}
function _testIsPrint(o, E) {
  const A = isPrint.test(o), g = isPrintOnly.test(o), e = isPrint.test(E), t = isPrintOnly.test(E);
  return A && e ? !g && t ? 1 : g && !t ? -1 : o.localeCompare(E) : A ? 1 : e ? -1 : null;
}
function sortCSSmq(o, E) {
  if (o === "")
    return -1;
  if (E === "")
    return 1;
  const A = _testIsPrint(o, E);
  if (A !== null)
    return A;
  const g = isMinWidth(o) || isMinHeight(o), e = isMaxWidth(o) || isMaxHeight(o), t = isMinWidth(E) || isMinHeight(E), c = isMaxWidth(E) || isMaxHeight(E);
  if (g && c)
    return -1;
  if (e && t)
    return 1;
  const n = _getQueryLength(o), h = _getQueryLength(E);
  return n === maxValue && h === maxValue ? o.localeCompare(E) : n === maxValue ? 1 : h === maxValue ? -1 : n > h ? e ? -1 : 1 : n < h ? e ? 1 : -1 : o.localeCompare(E);
}
class MultiCache {
  constructor(E, A, g) {
    this.idGenerator = E, this.onNewCache = A, this.onNewValue = g, this.sortedCacheKeys = [], this.caches = {};
  }
  getCache(E) {
    if (!this.caches[E]) {
      const A = new Cache(this.idGenerator, this.onNewValue);
      A.key = E, this.sortedCacheKeys.push(E), this.sortedCacheKeys.sort(sortCSSmq);
      const g = this.sortedCacheKeys.indexOf(E), e = g < this.sortedCacheKeys.length - 1 ? this.sortedCacheKeys[g + 1] : void 0;
      this.caches[E] = A, this.onNewCache(E, A, e);
    }
    return this.caches[E];
  }
  getSortedCacheKeys() {
    return this.sortedCacheKeys;
  }
}
class Cache {
  constructor(E, A) {
    this.cache = {}, this.idGenerator = E, this.onNewValue = A;
  }
  addValue(E, A) {
    const g = this.cache[E];
    if (g)
      return g;
    const e = this.idGenerator.next();
    return this.cache[E] = e, this.onNewValue(this, e, A), e;
  }
}
const uppercasePattern$1 = /[A-Z]/g, msPattern$1 = /^ms-/, cache$1 = {};
function hyphenateStyleName$2(o) {
  return o in cache$1 ? cache$1[o] : cache$1[o] = o.replace(uppercasePattern$1, "-$&").toLowerCase().replace(msPattern$1, "-ms-");
}
const shorthandMap = {
  // CSS 2.1: https://www.w3.org/TR/CSS2/propidx.html
  "list-style": ["list-style-type", "list-style-position", "list-style-image"],
  margin: ["margin-top", "margin-right", "margin-bottom", "margin-left"],
  outline: ["outline-width", "outline-style", "outline-color"],
  padding: ["padding-top", "padding-right", "padding-bottom", "padding-left"],
  // CSS Backgrounds and Borders Module Level 3: https://www.w3.org/TR/css3-background/
  background: ["background-image", "background-position", "background-size", "background-repeat", "background-origin", "background-clip", "background-attachment", "background-color"],
  border: ["border-top-width", "border-right-width", "border-bottom-width", "border-left-width", "border-width", "border-top-style", "border-right-style", "border-bottom-style", "border-left-style", "border-style", "border-top-color", "border-right-color", "border-bottom-color", "border-left-color", "border-color"],
  "border-color": ["border-top-color", "border-right-color", "border-bottom-color", "border-left-color"],
  "border-style": ["border-top-style", "border-right-style", "border-bottom-style", "border-left-style"],
  "border-width": ["border-top-width", "border-right-width", "border-bottom-width", "border-left-width"],
  "border-top": ["border-top-width", "border-top-style", "border-top-color"],
  "border-right": ["border-right-width", "border-right-style", "border-right-color"],
  "border-bottom": ["border-bottom-width", "border-bottom-style", "border-bottom-color"],
  "border-left": ["border-left-width", "border-left-style", "border-left-color"],
  "border-radius": ["border-top-left-radius", "border-top-right-radius", "border-bottom-right-radius", "border-bottom-left-radius"],
  "border-image": ["border-image-source", "border-image-slice", "border-image-width", "border-image-outset", "border-image-repeat"],
  // CSS Fonts Module Level 3: https://www.w3.org/TR/css3-fonts/
  font: ["font-style", "font-variant-ligatures", "font-variant-alternates", "font-variant-caps", "font-variant-numeric", "font-variant-east-asian", "font-variant", "font-weight", "font-stretch", "font-size", "line-height", "font-family"],
  "font-variant": ["font-variant-ligatures", "font-variant-alternates", "font-variant-caps", "font-variant-numeric", "font-variant-east-asian"],
  // CSS Flexible Box Layout Module Level 1: https://www.w3.org/TR/css3-flexbox-1/
  flex: ["flex-grow", "flex-shrink", "flex-basis"],
  "flex-flow": ["flex-direction", "flex-wrap"],
  // CSS Grid Layout Module Level 1: https://www.w3.org/TR/css-grid-1/
  grid: ["grid-template-rows", "grid-template-columns", "grid-template-areas", "grid-auto-rows", "grid-auto-columns", "grid-auto-flow"],
  "grid-template": ["grid-template-rows", "grid-template-columns", "grid-template-areas"],
  "grid-row": ["grid-row-start", "grid-row-end"],
  "grid-column": ["grid-column-start", "grid-column-end"],
  "grid-area": ["grid-row-start", "grid-column-start", "grid-row-end", "grid-column-end"],
  "grid-gap": ["grid-row-gap", "grid-column-gap"],
  // CSS Masking Module Level 1: https://www.w3.org/TR/css-masking/
  mask: ["mask-image", "mask-mode", "mask-position", "mask-size", "mask-repeat", "mask-origin", "mask-clip"],
  "mask-border": ["mask-border-source", "mask-border-slice", "mask-border-width", "mask-border-outset", "mask-border-repeat", "mask-border-mode"],
  // CSS Multi-column Layout Module: https://www.w3.org/TR/css3-multicol/
  columns: ["column-width", "column-count"],
  "column-rule": ["column-rule-width", "column-rule-style", "column-rule-color"],
  // CSS Scroll Snap Module Level 1: https://www.w3.org/TR/css-scroll-snap-1/
  "scroll-padding": ["scroll-padding-top", "scroll-padding-right", "scroll-padding-bottom", "scroll-padding-left"],
  "scroll-padding-block": ["scroll-padding-block-start", "scroll-padding-block-end"],
  "scroll-padding-inline": ["scroll-padding-inline-start", "scroll-padding-inline-end"],
  "scroll-snap-margin": ["scroll-snap-margin-top", "scroll-snap-margin-right", "scroll-snap-margin-bottom", "scroll-snap-margin-left"],
  "scroll-snap-margin-block": ["scroll-snap-margin-block-start", "scroll-snap-margin-block-end"],
  "scroll-snap-margin-inline": ["scroll-snap-margin-inline-start", "scroll-snap-margin-inline-end"],
  // CSS Speech Module: https://www.w3.org/TR/css3-speech/
  cue: ["cue-before", "cue-after"],
  pause: ["pause-before", "pause-after"],
  rest: ["rest-before", "rest-after"],
  // CSS Text Decoration Module Level 3: https://www.w3.org/TR/css-text-decor-3/
  "text-decoration": ["text-decoration-line", "text-decoration-style", "text-decoration-color"],
  "text-emphasis": ["text-emphasis-style", "text-emphasis-color"],
  // CSS Animations (WD): https://www.w3.org/TR/css3-animations
  animation: ["animation-name", "animation-duration", "animation-timing-function", "animation-delay", "animation-iteration-count", "animation-direction", "animation-fill-mode", "animation-play-state"],
  // CSS Transitions (WD): https://www.w3.org/TR/css3-transitions/
  transition: ["transition-property", "transition-duration", "transition-timing-function", "transition-delay"]
};
function validateNoMixedHand(o) {
  const E = Object.keys(o).reduce((g, e) => (g[hyphenateStyleName$2(e)] = e, g), {}), A = [];
  for (const g in E)
    if (g in shorthandMap) {
      for (const e of shorthandMap[g])
        if (e in E) {
          const t = E[e], c = E[g];
          A.push({
            shorthand: {
              property: c,
              value: o[c]
            },
            longhand: {
              property: t,
              value: o[t]
            }
          });
        }
    }
  return A;
}
function capitalizeString(o) {
  return o.charAt(0).toUpperCase() + o.slice(1);
}
function prefixProperty(o, E, A) {
  if (o.hasOwnProperty(E)) {
    for (var g = {}, e = o[E], t = capitalizeString(E), c = Object.keys(A), n = 0; n < c.length; n++) {
      var h = c[n];
      if (h === E)
        for (var d = 0; d < e.length; d++)
          g[e[d] + t] = A[E];
      g[h] = A[h];
    }
    return g;
  }
  return A;
}
function prefixValue$1(o, E, A, g, e) {
  for (var t = 0, c = o.length; t < c; ++t) {
    var n = o[t](E, A, g, e);
    if (n)
      return n;
  }
}
function addIfNew(o, E) {
  o.indexOf(E) === -1 && o.push(E);
}
function addNewValuesOnly(o, E) {
  if (Array.isArray(E))
    for (var A = 0, g = E.length; A < g; ++A)
      addIfNew(o, E[A]);
  else
    addIfNew(o, E);
}
function isObject(o) {
  return o instanceof Object && !Array.isArray(o);
}
function createPrefixer(o) {
  var E = o.prefixMap, A = o.plugins;
  return function g(e) {
    for (var t in e) {
      var c = e[t];
      if (isObject(c))
        e[t] = g(c);
      else if (Array.isArray(c)) {
        for (var n = [], h = 0, d = c.length; h < d; ++h) {
          var k = prefixValue$1(A, t, c[h], e, E);
          addNewValuesOnly(n, k || c[h]);
        }
        n.length > 0 && (e[t] = n);
      } else {
        var p = prefixValue$1(A, t, c, e, E);
        p && (e[t] = p), e = prefixProperty(E, t, e);
      }
    }
    return e;
  };
}
var w = ["Webkit"], m = ["Moz"], ms = ["ms"], wm = ["Webkit", "Moz"], wms = ["Webkit", "ms"], wmms = ["Webkit", "Moz", "ms"];
const data = {
  prefixMap: { appearance: wm, textEmphasisPosition: w, textEmphasis: w, textEmphasisStyle: w, textEmphasisColor: w, boxDecorationBreak: w, maskImage: w, maskMode: w, maskRepeat: w, maskPosition: w, maskClip: w, maskOrigin: w, maskSize: w, maskComposite: w, mask: w, maskBorderSource: w, maskBorderMode: w, maskBorderSlice: w, maskBorderWidth: w, maskBorderOutset: w, maskBorderRepeat: w, maskBorder: w, maskType: w, textDecorationStyle: w, textDecorationSkip: w, textDecorationLine: w, textDecorationColor: w, userSelect: wmms, backdropFilter: w, fontKerning: w, scrollSnapType: wms, scrollSnapPointsX: wms, scrollSnapPointsY: wms, scrollSnapDestination: wms, scrollSnapCoordinate: wms, clipPath: w, shapeImageThreshold: w, shapeImageMargin: w, shapeImageOutside: w, filter: w, hyphens: wms, flowInto: wms, flowFrom: wms, breakBefore: wms, breakAfter: wms, breakInside: wms, regionFragment: wms, writingMode: wms, textOrientation: w, tabSize: m, fontFeatureSettings: w, columnCount: w, columnFill: w, columnGap: w, columnRule: w, columnRuleColor: w, columnRuleStyle: w, columnRuleWidth: w, columns: w, columnSpan: w, columnWidth: w, wrapFlow: ms, wrapThrough: ms, wrapMargin: ms, textSizeAdjust: wms }
};
function backgroundClip(o, E) {
  if (typeof E == "string" && E === "text")
    return ["-webkit-text", "text"];
}
var prefixes$5 = ["-webkit-", "-moz-", ""], values$3 = {
  "zoom-in": !0,
  "zoom-out": !0,
  grab: !0,
  grabbing: !0
};
function cursor(o, E) {
  if (o === "cursor" && values$3.hasOwnProperty(E))
    return prefixes$5.map(function(A) {
      return A + E;
    });
}
var isPrefixedValue$1 = { exports: {} }, hasRequiredIsPrefixedValue;
function requireIsPrefixedValue() {
  return hasRequiredIsPrefixedValue || (hasRequiredIsPrefixedValue = 1, (function(o, E) {
    Object.defineProperty(E, "__esModule", {
      value: !0
    }), E.default = g;
    var A = /-webkit-|-moz-|-ms-/;
    function g(e) {
      return typeof e == "string" && A.test(e);
    }
    o.exports = E.default;
  })(isPrefixedValue$1, isPrefixedValue$1.exports)), isPrefixedValue$1.exports;
}
var isPrefixedValueExports = requireIsPrefixedValue();
const isPrefixedValue = /* @__PURE__ */ getDefaultExportFromCjs(isPrefixedValueExports);
var prefixes$4 = ["-webkit-", ""];
function crossFade(o, E) {
  if (typeof E == "string" && !isPrefixedValue(E) && E.indexOf("cross-fade(") > -1)
    return prefixes$4.map(function(A) {
      return E.replace(/cross-fade\(/g, A + "cross-fade(");
    });
}
var prefixes$3 = ["-webkit-", ""];
function filter(o, E) {
  if (typeof E == "string" && !isPrefixedValue(E) && E.indexOf("filter(") > -1)
    return prefixes$3.map(function(A) {
      return E.replace(/filter\(/g, A + "filter(");
    });
}
var values$2 = {
  flex: ["-webkit-box", "-moz-box", "-ms-flexbox", "-webkit-flex", "flex"],
  "inline-flex": ["-webkit-inline-box", "-moz-inline-box", "-ms-inline-flexbox", "-webkit-inline-flex", "inline-flex"]
};
function flex(o, E) {
  if (o === "display" && values$2.hasOwnProperty(E))
    return values$2[E];
}
var alternativeValues = {
  "space-around": "justify",
  "space-between": "justify",
  "flex-start": "start",
  "flex-end": "end",
  "wrap-reverse": "multiple",
  wrap: "multiple"
}, alternativeProps$1 = {
  alignItems: "WebkitBoxAlign",
  justifyContent: "WebkitBoxPack",
  flexWrap: "WebkitBoxLines",
  flexGrow: "WebkitBoxFlex"
};
function flexboxOld(o, E, A) {
  o === "flexDirection" && typeof E == "string" && (E.indexOf("column") > -1 ? A.WebkitBoxOrient = "vertical" : A.WebkitBoxOrient = "horizontal", E.indexOf("reverse") > -1 ? A.WebkitBoxDirection = "reverse" : A.WebkitBoxDirection = "normal"), alternativeProps$1.hasOwnProperty(o) && (A[alternativeProps$1[o]] = alternativeValues[E] || E);
}
var prefixes$2 = ["-webkit-", "-moz-", ""], values$1 = /linear-gradient|radial-gradient|repeating-linear-gradient|repeating-radial-gradient/gi;
function gradient(o, E) {
  if (typeof E == "string" && !isPrefixedValue(E) && values$1.test(E))
    return prefixes$2.map(function(A) {
      return E.replace(values$1, function(g) {
        return A + g;
      });
    });
}
var _slicedToArray = /* @__PURE__ */ (function() {
  function o(E, A) {
    var g = [], e = !0, t = !1, c = void 0;
    try {
      for (var n = E[Symbol.iterator](), h; !(e = (h = n.next()).done) && (g.push(h.value), !(A && g.length === A)); e = !0)
        ;
    } catch (d) {
      t = !0, c = d;
    } finally {
      try {
        !e && n.return && n.return();
      } finally {
        if (t) throw c;
      }
    }
    return g;
  }
  return function(E, A) {
    if (Array.isArray(E))
      return E;
    if (Symbol.iterator in Object(E))
      return o(E, A);
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
  };
})();
function isSimplePositionValue(o) {
  return typeof o == "number" && !isNaN(o);
}
function isComplexSpanValue(o) {
  return typeof o == "string" && o.includes("/");
}
var alignmentValues = ["center", "end", "start", "stretch"], displayValues = {
  "inline-grid": ["-ms-inline-grid", "inline-grid"],
  grid: ["-ms-grid", "grid"]
}, propertyConverters = {
  alignSelf: function o(E, A) {
    alignmentValues.indexOf(E) > -1 && (A.msGridRowAlign = E);
  },
  gridColumn: function o(E, A) {
    if (isSimplePositionValue(E))
      A.msGridColumn = E;
    else if (isComplexSpanValue(E)) {
      var g = E.split("/"), e = _slicedToArray(g, 2), t = e[0], c = e[1];
      propertyConverters.gridColumnStart(+t, A);
      var n = c.split(/ ?span /), h = _slicedToArray(n, 2), d = h[0], k = h[1];
      d === "" ? propertyConverters.gridColumnEnd(+t + +k, A) : propertyConverters.gridColumnEnd(+c, A);
    } else
      propertyConverters.gridColumnStart(E, A);
  },
  gridColumnEnd: function o(E, A) {
    var g = A.msGridColumn;
    isSimplePositionValue(E) && isSimplePositionValue(g) && (A.msGridColumnSpan = E - g);
  },
  gridColumnStart: function o(E, A) {
    isSimplePositionValue(E) && (A.msGridColumn = E);
  },
  gridRow: function o(E, A) {
    if (isSimplePositionValue(E))
      A.msGridRow = E;
    else if (isComplexSpanValue(E)) {
      var g = E.split("/"), e = _slicedToArray(g, 2), t = e[0], c = e[1];
      propertyConverters.gridRowStart(+t, A);
      var n = c.split(/ ?span /), h = _slicedToArray(n, 2), d = h[0], k = h[1];
      d === "" ? propertyConverters.gridRowEnd(+t + +k, A) : propertyConverters.gridRowEnd(+c, A);
    } else
      propertyConverters.gridRowStart(E, A);
  },
  gridRowEnd: function o(E, A) {
    var g = A.msGridRow;
    isSimplePositionValue(E) && isSimplePositionValue(g) && (A.msGridRowSpan = E - g);
  },
  gridRowStart: function o(E, A) {
    isSimplePositionValue(E) && (A.msGridRow = E);
  },
  gridTemplateColumns: function o(E, A) {
    A.msGridColumns = E;
  },
  gridTemplateRows: function o(E, A) {
    A.msGridRows = E;
  },
  justifySelf: function o(E, A) {
    alignmentValues.indexOf(E) > -1 && (A.msGridColumnAlign = E);
  }
};
function grid(o, E, A) {
  if (o === "display" && E in displayValues)
    return displayValues[E];
  if (o in propertyConverters) {
    var g = propertyConverters[o];
    g(E, A);
  }
}
var prefixes$1 = ["-webkit-", ""];
function imageSet(o, E) {
  if (typeof E == "string" && !isPrefixedValue(E) && E.indexOf("image-set(") > -1)
    return prefixes$1.map(function(A) {
      return E.replace(/image-set\(/g, A + "image-set(");
    });
}
var alternativeProps = {
  marginBlockStart: ["WebkitMarginBefore"],
  marginBlockEnd: ["WebkitMarginAfter"],
  marginInlineStart: ["WebkitMarginStart", "MozMarginStart"],
  marginInlineEnd: ["WebkitMarginEnd", "MozMarginEnd"],
  paddingBlockStart: ["WebkitPaddingBefore"],
  paddingBlockEnd: ["WebkitPaddingAfter"],
  paddingInlineStart: ["WebkitPaddingStart", "MozPaddingStart"],
  paddingInlineEnd: ["WebkitPaddingEnd", "MozPaddingEnd"],
  borderBlockStart: ["WebkitBorderBefore"],
  borderBlockStartColor: ["WebkitBorderBeforeColor"],
  borderBlockStartStyle: ["WebkitBorderBeforeStyle"],
  borderBlockStartWidth: ["WebkitBorderBeforeWidth"],
  borderBlockEnd: ["WebkitBorderAfter"],
  borderBlockEndColor: ["WebkitBorderAfterColor"],
  borderBlockEndStyle: ["WebkitBorderAfterStyle"],
  borderBlockEndWidth: ["WebkitBorderAfterWidth"],
  borderInlineStart: ["WebkitBorderStart", "MozBorderStart"],
  borderInlineStartColor: ["WebkitBorderStartColor", "MozBorderStartColor"],
  borderInlineStartStyle: ["WebkitBorderStartStyle", "MozBorderStartStyle"],
  borderInlineStartWidth: ["WebkitBorderStartWidth", "MozBorderStartWidth"],
  borderInlineEnd: ["WebkitBorderEnd", "MozBorderEnd"],
  borderInlineEndColor: ["WebkitBorderEndColor", "MozBorderEndColor"],
  borderInlineEndStyle: ["WebkitBorderEndStyle", "MozBorderEndStyle"],
  borderInlineEndWidth: ["WebkitBorderEndWidth", "MozBorderEndWidth"]
};
function logical(o, E, A) {
  if (Object.prototype.hasOwnProperty.call(alternativeProps, o))
    for (var g = alternativeProps[o], e = 0, t = g.length; e < t; ++e)
      A[g[e]] = E;
}
function position(o, E) {
  if (o === "position" && E === "sticky")
    return ["-webkit-sticky", "sticky"];
}
var prefixes = ["-webkit-", "-moz-", ""], properties$1 = {
  maxHeight: !0,
  maxWidth: !0,
  width: !0,
  height: !0,
  columnWidth: !0,
  minWidth: !0,
  minHeight: !0
}, values = {
  "min-content": !0,
  "max-content": !0,
  "fill-available": !0,
  "fit-content": !0,
  "contain-floats": !0
};
function sizing(o, E) {
  if (properties$1.hasOwnProperty(o) && values.hasOwnProperty(E))
    return prefixes.map(function(A) {
      return A + E;
    });
}
var hyphenateProperty$1 = { exports: {} }, uppercasePattern = /[A-Z]/g, msPattern = /^ms-/, cache = {};
function toHyphenLower(o) {
  return "-" + o.toLowerCase();
}
function hyphenateStyleName(o) {
  if (cache.hasOwnProperty(o))
    return cache[o];
  var E = o.replace(uppercasePattern, toHyphenLower);
  return cache[o] = msPattern.test(E) ? "-" + E : E;
}
const hyphenateStyleName$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: hyphenateStyleName
}, Symbol.toStringTag, { value: "Module" })), require$$0 = /* @__PURE__ */ getAugmentedNamespace(hyphenateStyleName$1);
var hasRequiredHyphenateProperty;
function requireHyphenateProperty() {
  return hasRequiredHyphenateProperty || (hasRequiredHyphenateProperty = 1, (function(o, E) {
    Object.defineProperty(E, "__esModule", {
      value: !0
    }), E.default = t;
    var A = require$$0, g = e(A);
    function e(c) {
      return c && c.__esModule ? c : { default: c };
    }
    function t(c) {
      return (0, g.default)(c);
    }
    o.exports = E.default;
  })(hyphenateProperty$1, hyphenateProperty$1.exports)), hyphenateProperty$1.exports;
}
var hyphenatePropertyExports = requireHyphenateProperty();
const hyphenateProperty = /* @__PURE__ */ getDefaultExportFromCjs(hyphenatePropertyExports);
var properties = {
  transition: !0,
  transitionProperty: !0,
  WebkitTransition: !0,
  WebkitTransitionProperty: !0,
  MozTransition: !0,
  MozTransitionProperty: !0
}, prefixMapping = {
  Webkit: "-webkit-",
  Moz: "-moz-",
  ms: "-ms-"
};
function prefixValue(o, E) {
  if (isPrefixedValue(o))
    return o;
  for (var A = o.split(/,(?![^()]*(?:\([^()]*\))?\))/g), g = 0, e = A.length; g < e; ++g) {
    var t = A[g], c = [t];
    for (var n in E) {
      var h = hyphenateProperty(n);
      if (t.indexOf(h) > -1 && h !== "order")
        for (var d = E[n], k = 0, p = d.length; k < p; ++k)
          c.unshift(t.replace(h, prefixMapping[d[k]] + h));
    }
    A[g] = c.join(",");
  }
  return A.join(",");
}
function transition(o, E, A, g) {
  if (typeof E == "string" && properties.hasOwnProperty(o)) {
    var e = prefixValue(E, g), t = e.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function(n) {
      return !/-moz-|-ms-/.test(n);
    }).join(",");
    if (o.indexOf("Webkit") > -1)
      return t;
    var c = e.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function(n) {
      return !/-webkit-|-ms-/.test(n);
    }).join(",");
    return o.indexOf("Moz") > -1 ? c : (A["Webkit" + capitalizeString(o)] = t, A["Moz" + capitalizeString(o)] = c, e);
  }
}
var plugins = [backgroundClip, crossFade, cursor, filter, flexboxOld, gradient, grid, imageSet, logical, position, sizing, transition, flex], prefix = createPrefixer({
  prefixMap: data.prefixMap,
  plugins
});
function injectStylePrefixed(o, E, A, g) {
  const e = o.getCache(A);
  let t = "";
  for (const c in E) {
    const n = E[c];
    if (n != null)
      if (typeof n != "object") {
        process.env.NODE_ENV !== "production" && validateValueType(n, c);
        const h = `${hyphenateStyleName$2(c)}:${n}`, d = `${g}${h}`, k = e.cache[d];
        if (k !== void 0) {
          t += " " + k;
          continue;
        } else {
          let p = "";
          const M = prefix({
            [c]: n
          });
          for (const AA in M) {
            const H = M[AA], gA = typeof H;
            if (gA === "string" || gA === "number") {
              const CA = `${hyphenateStyleName$2(AA)}:${H}`;
              CA !== h && (p += `${CA};`);
            } else if (Array.isArray(H)) {
              const CA = hyphenateStyleName$2(AA);
              for (let IA = 0; IA < H.length; IA++) {
                const BA = `${CA}:${H[IA]}`;
                BA !== h && (p += `${BA};`);
              }
            }
          }
          p += h;
          const S = e.addValue(d, {
            pseudo: g,
            block: p
          });
          t += " " + S;
        }
      } else
        c[0] === ":" ? t += " " + injectStylePrefixed(o, n, A, g + c) : c.substring(0, 6) === "@media" && (t += " " + injectStylePrefixed(o, n, c.substr(7), g));
  }
  if (process.env.NODE_ENV !== "production") {
    const c = validateNoMixedHand(E);
    c.length && c.forEach(({
      shorthand: n,
      longhand: h
    }) => {
      const d = JSON.stringify({
        [n.property]: n.value
      }), k = JSON.stringify({
        [h.property]: h.value
      });
      console.warn(`Styles \`${d}\` and \`${k}\` in object yielding class "${t.slice(1)}" may result in unexpected behavior. Mixing shorthand and longhand properties within the same style object is unsupported with atomic rendering.`);
    });
  }
  return t.slice(1);
}
function validateValueType(o, E) {
  if (o === null || Array.isArray(o) || typeof o != "number" && typeof o != "string")
    throw new Error(`Unsupported style value: ${JSON.stringify(o)} used in property ${JSON.stringify(E)}`);
}
const validAnimationState = /^(from|to|\+?(\d*\.)?\d+%)(\s*,\s*(from|to|\+?(\d*\.)?\d+%))*$/;
function validateKeyframesObject(o) {
  let E = !0;
  for (const A in o) {
    const g = o[A];
    validAnimationState.test(A) || (E = !1, console.warn(`Warning: property "${A}" in keyframes object ${JSON.stringify(o)} is not a valid. Must be "from", "to", or a percentage.`)), typeof g != "object" && (E = !1, console.warn(`Warning: value for "${A}" property in keyframes object ${JSON.stringify(o)} must be an object. Instead it was a ${typeof g}.`)), E || console.warn('Warning: object used as value for "animationName" style is invalid:', o);
  }
}
function atomicSelector(o, E) {
  let A = `.${o}`;
  return E && (A += E), A;
}
function keyframesToBlock(o) {
  process.env.NODE_ENV !== "production" && validateKeyframesObject(o), process.env.NODE_ENV !== "production" && typeof Object.getPrototypeOf(o) < "u" && Object.getPrototypeOf(o) !== Object.getPrototypeOf({}) && console.warn("Only plain objects should be used as animation values. Unexpectedly recieved:", o);
  let E = "";
  for (const A in o)
    E += `${A}{${declarationsToBlock(o[A])}}`;
  return E;
}
function declarationsToBlock(o) {
  let E = "";
  for (const A in o) {
    const g = o[A];
    (typeof g == "string" || typeof g == "number") && (E += `${hyphenateStyleName$2(A)}:${g};`);
  }
  return E.slice(0, -1);
}
function keyframesBlockToRule(o, E) {
  return `@keyframes ${o}{${E}}`;
}
function fontFaceBlockToRule(o, E) {
  return `@font-face{font-family:${o};${E}}`;
}
function styleBlockToRule(o, E) {
  return `${o}{${E}}`;
}
const insertRuleIntoDevtools = (o, E) => {
  const A = o.substring(1, o.indexOf(":") !== -1 ? o.indexOf(":") : o.length), g = {};
  for (const e of E.split(";"))
    e.trim() !== "" && !window.__STYLETRON_DEVTOOLS__.atomicMap[A] && (g[e.substring(0, e.indexOf(":"))] = e.substring(e.indexOf(":") + 1, e.length));
  window.__STYLETRON_DEVTOOLS__.atomicMap[A] = g;
}, hydrateDevtoolsRule = (o) => {
  const E = o.substring(0, 3), A = o.substring(4, o.length - 1);
  insertRuleIntoDevtools(E, A);
}, STYLES_HYDRATOR = /\.([^{:]+)(:[^{]+)?{(?:[^}]*;)?([^}]*?)}/g, KEYFRAMES_HYRDATOR = /@keyframes ([^{]+){((?:(?:from|to|(?:\d+\.?\d*%))\{(?:[^}])*})*)}/g, FONT_FACE_HYDRATOR = /@font-face\{font-family:([^;]+);([^}]*)\}/g;
function hydrateStyles(o, E, A) {
  let g;
  for (; g = E.exec(A); ) {
    const [, e, t, c] = g;
    process.env.NODE_ENV !== "production" && window.__STYLETRON_DEVTOOLS__ && hydrateDevtoolsRule(g[0]);
    const n = t ? `${t}${c}` : c;
    o.cache[n] = e, o.idGenerator.increment();
  }
}
function hydrate(o, E, A) {
  let g;
  for (; g = E.exec(A); ) {
    const [, e, t] = g;
    process.env.NODE_ENV !== "production" && window.__STYLETRON_DEVTOOLS__ && hydrateDevtoolsRule(g[0]), o.cache[t] = e, o.idGenerator.increment();
  }
}
class StyletronClient {
  constructor(E = {}) {
    this.styleElements = {};
    const A = new SequentialIDGenerator(E.prefix), g = (e, t, c) => {
      const {
        pseudo: n,
        block: h
      } = c, d = this.styleElements[e.key].sheet, k = atomicSelector(t, n), p = styleBlockToRule(k, h);
      try {
        d.insertRule(p, d.cssRules.length), process.env.NODE_ENV !== "production" && window.__STYLETRON_DEVTOOLS__ && insertRuleIntoDevtools(k, h);
      } catch {
        process.env.NODE_ENV !== "production" && console.warn(`Failed to inject CSS: "${p}". Perhaps this has invalid or un-prefixed properties?`);
      }
    };
    if (this.styleCache = new MultiCache(A, (e, t, c) => {
      const n = document.createElement("style");
      if (n.media = e, c === void 0)
        this.container.appendChild(n);
      else {
        const h = findSheetIndexWithMedia(this.container.children, c);
        this.container.insertBefore(n, this.container.children[h]);
      }
      this.styleElements[e] = n;
    }, g), this.keyframesCache = new Cache(new SequentialIDGenerator(E.prefix), (e, t, c) => {
      this.styleCache.getCache("");
      const n = this.styleElements[""].sheet, h = keyframesBlockToRule(t, keyframesToBlock(c));
      try {
        n.insertRule(h, n.cssRules.length);
      } catch {
        process.env.NODE_ENV !== "production" && console.warn(`Failed to inject CSS: "${h}". Perhaps this has invalid or un-prefixed properties?`);
      }
    }), this.fontFaceCache = new Cache(new SequentialIDGenerator(E.prefix), (e, t, c) => {
      this.styleCache.getCache("");
      const n = this.styleElements[""].sheet, h = fontFaceBlockToRule(t, declarationsToBlock(c));
      try {
        n.insertRule(h, n.cssRules.length);
      } catch {
        process.env.NODE_ENV !== "production" && console.warn(`Failed to inject CSS: "${h}". Perhaps this has invalid or un-prefixed properties?`);
      }
    }), E.container && (this.container = E.container), E.hydrate && E.hydrate.length > 0) {
      if (!this.container) {
        const e = E.hydrate[0].parentElement;
        e != null && (this.container = e);
      }
      for (let e = 0; e < E.hydrate.length; e++) {
        const t = E.hydrate[e], c = t.getAttribute("data-hydrate");
        if (c === "font-face") {
          hydrate(this.fontFaceCache, FONT_FACE_HYDRATOR, t.textContent);
          continue;
        }
        if (c === "keyframes") {
          hydrate(this.keyframesCache, KEYFRAMES_HYRDATOR, t.textContent);
          continue;
        }
        const n = t.media ? t.media : "";
        this.styleElements[n] = t;
        const h = new Cache(A, g);
        h.key = n, hydrateStyles(h, STYLES_HYDRATOR, t.textContent), this.styleCache.sortedCacheKeys.push(n), this.styleCache.caches[n] = h;
      }
    }
    if (!this.container) {
      if (document.head === null)
        throw new Error("No container provided and `document.head` was null");
      this.container = document.head;
    }
  }
  renderStyle(E) {
    return injectStylePrefixed(this.styleCache, E, "", "");
  }
  renderFontFace(E) {
    const A = declarationsToBlock(E);
    return this.fontFaceCache.addValue(A, E);
  }
  renderKeyframes(E) {
    const A = keyframesToBlock(E);
    return this.keyframesCache.addValue(A, E);
  }
}
function findSheetIndexWithMedia(o, E) {
  let A = 0;
  for (; A < o.length; A++) {
    const g = o[A];
    if (g.tagName === "STYLE" && g.media === E)
      return A;
  }
  return -1;
}
const engine = new StyletronClient({
  prefix: "st-"
});
process.env.NODE_ENV === "development" && log.setLevel(log.levels.DEBUG);
const streamlitExecutionStartedAt = Date.now();
function StliteApp(o) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StliteKernelProvider, { kernel: o.kernel, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Provider$1, { value: engine, children: /* @__PURE__ */ jsxRuntimeExports.jsx(ThemedApp, { styleNonce: o.styleNonce, streamlitExecutionStartedAt, disableDocumentStyles: o.disableDocumentStyles }) }) });
}
function r(o) {
  var E, A, g = "";
  if (typeof o == "string" || typeof o == "number") g += o;
  else if (typeof o == "object") if (Array.isArray(o)) {
    var e = o.length;
    for (E = 0; E < e; E++) o[E] && (A = r(o[E])) && (g && (g += " "), g += A);
  } else for (A in o) o[A] && (g && (g += " "), g += A);
  return g;
}
function clsx() {
  for (var o, E, A = 0, g = "", e = arguments.length; A < e; A++) (o = arguments[A]) && (E = r(o)) && (g && (g += " "), g += E);
  return g;
}
function Mt(o) {
  if (typeof document > "u") return;
  let E = document.head || document.getElementsByTagName("head")[0], A = document.createElement("style");
  A.type = "text/css", E.firstChild ? E.insertBefore(A, E.firstChild) : E.appendChild(A), A.styleSheet ? A.styleSheet.cssText = o : A.appendChild(document.createTextNode(o));
}
Mt(`:root{--toastify-color-light: #fff;--toastify-color-dark: #121212;--toastify-color-info: #3498db;--toastify-color-success: #07bc0c;--toastify-color-warning: #f1c40f;--toastify-color-error: hsl(6, 78%, 57%);--toastify-color-transparent: rgba(255, 255, 255, .7);--toastify-icon-color-info: var(--toastify-color-info);--toastify-icon-color-success: var(--toastify-color-success);--toastify-icon-color-warning: var(--toastify-color-warning);--toastify-icon-color-error: var(--toastify-color-error);--toastify-container-width: fit-content;--toastify-toast-width: 320px;--toastify-toast-offset: 16px;--toastify-toast-top: max(var(--toastify-toast-offset), env(safe-area-inset-top));--toastify-toast-right: max(var(--toastify-toast-offset), env(safe-area-inset-right));--toastify-toast-left: max(var(--toastify-toast-offset), env(safe-area-inset-left));--toastify-toast-bottom: max(var(--toastify-toast-offset), env(safe-area-inset-bottom));--toastify-toast-background: #fff;--toastify-toast-padding: 14px;--toastify-toast-min-height: 64px;--toastify-toast-max-height: 800px;--toastify-toast-bd-radius: 6px;--toastify-toast-shadow: 0px 4px 12px rgba(0, 0, 0, .1);--toastify-font-family: sans-serif;--toastify-z-index: 9999;--toastify-text-color-light: #757575;--toastify-text-color-dark: #fff;--toastify-text-color-info: #fff;--toastify-text-color-success: #fff;--toastify-text-color-warning: #fff;--toastify-text-color-error: #fff;--toastify-spinner-color: #616161;--toastify-spinner-color-empty-area: #e0e0e0;--toastify-color-progress-light: linear-gradient(to right, #4cd964, #5ac8fa, #007aff, #34aadc, #5856d6, #ff2d55);--toastify-color-progress-dark: #bb86fc;--toastify-color-progress-info: var(--toastify-color-info);--toastify-color-progress-success: var(--toastify-color-success);--toastify-color-progress-warning: var(--toastify-color-warning);--toastify-color-progress-error: var(--toastify-color-error);--toastify-color-progress-bgo: .2}.Toastify__toast-container{z-index:var(--toastify-z-index);-webkit-transform:translate3d(0,0,var(--toastify-z-index));position:fixed;width:var(--toastify-container-width);box-sizing:border-box;color:#fff;display:flex;flex-direction:column}.Toastify__toast-container--top-left{top:var(--toastify-toast-top);left:var(--toastify-toast-left)}.Toastify__toast-container--top-center{top:var(--toastify-toast-top);left:50%;transform:translate(-50%);align-items:center}.Toastify__toast-container--top-right{top:var(--toastify-toast-top);right:var(--toastify-toast-right);align-items:end}.Toastify__toast-container--bottom-left{bottom:var(--toastify-toast-bottom);left:var(--toastify-toast-left)}.Toastify__toast-container--bottom-center{bottom:var(--toastify-toast-bottom);left:50%;transform:translate(-50%);align-items:center}.Toastify__toast-container--bottom-right{bottom:var(--toastify-toast-bottom);right:var(--toastify-toast-right);align-items:end}.Toastify__toast{--y: 0;position:relative;touch-action:none;width:var(--toastify-toast-width);min-height:var(--toastify-toast-min-height);box-sizing:border-box;margin-bottom:1rem;padding:var(--toastify-toast-padding);border-radius:var(--toastify-toast-bd-radius);box-shadow:var(--toastify-toast-shadow);max-height:var(--toastify-toast-max-height);font-family:var(--toastify-font-family);z-index:0;display:flex;flex:1 auto;align-items:center;word-break:break-word}@media only screen and (max-width: 480px){.Toastify__toast-container{width:100vw;left:env(safe-area-inset-left);margin:0}.Toastify__toast-container--top-left,.Toastify__toast-container--top-center,.Toastify__toast-container--top-right{top:env(safe-area-inset-top);transform:translate(0)}.Toastify__toast-container--bottom-left,.Toastify__toast-container--bottom-center,.Toastify__toast-container--bottom-right{bottom:env(safe-area-inset-bottom);transform:translate(0)}.Toastify__toast-container--rtl{right:env(safe-area-inset-right);left:initial}.Toastify__toast{--toastify-toast-width: 100%;margin-bottom:0;border-radius:0}}.Toastify__toast-container[data-stacked=true]{width:var(--toastify-toast-width)}.Toastify__toast--stacked{position:absolute;width:100%;transform:translate3d(0,var(--y),0) scale(var(--s));transition:transform .3s}.Toastify__toast--stacked[data-collapsed] .Toastify__toast-body,.Toastify__toast--stacked[data-collapsed] .Toastify__close-button{transition:opacity .1s}.Toastify__toast--stacked[data-collapsed=false]{overflow:visible}.Toastify__toast--stacked[data-collapsed=true]:not(:last-child)>*{opacity:0}.Toastify__toast--stacked:after{content:"";position:absolute;left:0;right:0;height:calc(var(--g) * 1px);bottom:100%}.Toastify__toast--stacked[data-pos=top]{top:0}.Toastify__toast--stacked[data-pos=bot]{bottom:0}.Toastify__toast--stacked[data-pos=bot].Toastify__toast--stacked:before{transform-origin:top}.Toastify__toast--stacked[data-pos=top].Toastify__toast--stacked:before{transform-origin:bottom}.Toastify__toast--stacked:before{content:"";position:absolute;left:0;right:0;bottom:0;height:100%;transform:scaleY(3);z-index:-1}.Toastify__toast--rtl{direction:rtl}.Toastify__toast--close-on-click{cursor:pointer}.Toastify__toast-icon{margin-inline-end:10px;width:22px;flex-shrink:0;display:flex}.Toastify--animate{animation-fill-mode:both;animation-duration:.5s}.Toastify--animate-icon{animation-fill-mode:both;animation-duration:.3s}.Toastify__toast-theme--dark{background:var(--toastify-color-dark);color:var(--toastify-text-color-dark)}.Toastify__toast-theme--light,.Toastify__toast-theme--colored.Toastify__toast--default{background:var(--toastify-color-light);color:var(--toastify-text-color-light)}.Toastify__toast-theme--colored.Toastify__toast--info{color:var(--toastify-text-color-info);background:var(--toastify-color-info)}.Toastify__toast-theme--colored.Toastify__toast--success{color:var(--toastify-text-color-success);background:var(--toastify-color-success)}.Toastify__toast-theme--colored.Toastify__toast--warning{color:var(--toastify-text-color-warning);background:var(--toastify-color-warning)}.Toastify__toast-theme--colored.Toastify__toast--error{color:var(--toastify-text-color-error);background:var(--toastify-color-error)}.Toastify__progress-bar-theme--light{background:var(--toastify-color-progress-light)}.Toastify__progress-bar-theme--dark{background:var(--toastify-color-progress-dark)}.Toastify__progress-bar--info{background:var(--toastify-color-progress-info)}.Toastify__progress-bar--success{background:var(--toastify-color-progress-success)}.Toastify__progress-bar--warning{background:var(--toastify-color-progress-warning)}.Toastify__progress-bar--error{background:var(--toastify-color-progress-error)}.Toastify__progress-bar-theme--colored.Toastify__progress-bar--info,.Toastify__progress-bar-theme--colored.Toastify__progress-bar--success,.Toastify__progress-bar-theme--colored.Toastify__progress-bar--warning,.Toastify__progress-bar-theme--colored.Toastify__progress-bar--error{background:var(--toastify-color-transparent)}.Toastify__close-button{color:#fff;position:absolute;top:6px;right:6px;background:transparent;outline:none;border:none;padding:0;cursor:pointer;opacity:.7;transition:.3s ease;z-index:1}.Toastify__toast--rtl .Toastify__close-button{left:6px;right:unset}.Toastify__close-button--light{color:#000;opacity:.3}.Toastify__close-button>svg{fill:currentColor;height:16px;width:14px}.Toastify__close-button:hover,.Toastify__close-button:focus{opacity:1}@keyframes Toastify__trackProgress{0%{transform:scaleX(1)}to{transform:scaleX(0)}}.Toastify__progress-bar{position:absolute;bottom:0;left:0;width:100%;height:100%;z-index:1;opacity:.7;transform-origin:left}.Toastify__progress-bar--animated{animation:Toastify__trackProgress linear 1 forwards}.Toastify__progress-bar--controlled{transition:transform .2s}.Toastify__progress-bar--rtl{right:0;left:initial;transform-origin:right;border-bottom-left-radius:initial}.Toastify__progress-bar--wrp{position:absolute;overflow:hidden;bottom:0;left:0;width:100%;height:5px;border-bottom-left-radius:var(--toastify-toast-bd-radius);border-bottom-right-radius:var(--toastify-toast-bd-radius)}.Toastify__progress-bar--wrp[data-hidden=true]{opacity:0}.Toastify__progress-bar--bg{opacity:var(--toastify-color-progress-bgo);width:100%;height:100%}.Toastify__spinner{width:20px;height:20px;box-sizing:border-box;border:2px solid;border-radius:100%;border-color:var(--toastify-spinner-color-empty-area);border-right-color:var(--toastify-spinner-color);animation:Toastify__spin .65s linear infinite}@keyframes Toastify__bounceInRight{0%,60%,75%,90%,to{animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(3000px,0,0)}60%{opacity:1;transform:translate3d(-25px,0,0)}75%{transform:translate3d(10px,0,0)}90%{transform:translate3d(-5px,0,0)}to{transform:none}}@keyframes Toastify__bounceOutRight{20%{opacity:1;transform:translate3d(-20px,var(--y),0)}to{opacity:0;transform:translate3d(2000px,var(--y),0)}}@keyframes Toastify__bounceInLeft{0%,60%,75%,90%,to{animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(-3000px,0,0)}60%{opacity:1;transform:translate3d(25px,0,0)}75%{transform:translate3d(-10px,0,0)}90%{transform:translate3d(5px,0,0)}to{transform:none}}@keyframes Toastify__bounceOutLeft{20%{opacity:1;transform:translate3d(20px,var(--y),0)}to{opacity:0;transform:translate3d(-2000px,var(--y),0)}}@keyframes Toastify__bounceInUp{0%,60%,75%,90%,to{animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(0,3000px,0)}60%{opacity:1;transform:translate3d(0,-20px,0)}75%{transform:translate3d(0,10px,0)}90%{transform:translate3d(0,-5px,0)}to{transform:translateZ(0)}}@keyframes Toastify__bounceOutUp{20%{transform:translate3d(0,calc(var(--y) - 10px),0)}40%,45%{opacity:1;transform:translate3d(0,calc(var(--y) + 20px),0)}to{opacity:0;transform:translate3d(0,-2000px,0)}}@keyframes Toastify__bounceInDown{0%,60%,75%,90%,to{animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(0,-3000px,0)}60%{opacity:1;transform:translate3d(0,25px,0)}75%{transform:translate3d(0,-10px,0)}90%{transform:translate3d(0,5px,0)}to{transform:none}}@keyframes Toastify__bounceOutDown{20%{transform:translate3d(0,calc(var(--y) - 10px),0)}40%,45%{opacity:1;transform:translate3d(0,calc(var(--y) + 20px),0)}to{opacity:0;transform:translate3d(0,2000px,0)}}.Toastify__bounce-enter--top-left,.Toastify__bounce-enter--bottom-left{animation-name:Toastify__bounceInLeft}.Toastify__bounce-enter--top-right,.Toastify__bounce-enter--bottom-right{animation-name:Toastify__bounceInRight}.Toastify__bounce-enter--top-center{animation-name:Toastify__bounceInDown}.Toastify__bounce-enter--bottom-center{animation-name:Toastify__bounceInUp}.Toastify__bounce-exit--top-left,.Toastify__bounce-exit--bottom-left{animation-name:Toastify__bounceOutLeft}.Toastify__bounce-exit--top-right,.Toastify__bounce-exit--bottom-right{animation-name:Toastify__bounceOutRight}.Toastify__bounce-exit--top-center{animation-name:Toastify__bounceOutUp}.Toastify__bounce-exit--bottom-center{animation-name:Toastify__bounceOutDown}@keyframes Toastify__zoomIn{0%{opacity:0;transform:scale3d(.3,.3,.3)}50%{opacity:1}}@keyframes Toastify__zoomOut{0%{opacity:1}50%{opacity:0;transform:translate3d(0,var(--y),0) scale3d(.3,.3,.3)}to{opacity:0}}.Toastify__zoom-enter{animation-name:Toastify__zoomIn}.Toastify__zoom-exit{animation-name:Toastify__zoomOut}@keyframes Toastify__flipIn{0%{transform:perspective(400px) rotateX(90deg);animation-timing-function:ease-in;opacity:0}40%{transform:perspective(400px) rotateX(-20deg);animation-timing-function:ease-in}60%{transform:perspective(400px) rotateX(10deg);opacity:1}80%{transform:perspective(400px) rotateX(-5deg)}to{transform:perspective(400px)}}@keyframes Toastify__flipOut{0%{transform:translate3d(0,var(--y),0) perspective(400px)}30%{transform:translate3d(0,var(--y),0) perspective(400px) rotateX(-20deg);opacity:1}to{transform:translate3d(0,var(--y),0) perspective(400px) rotateX(90deg);opacity:0}}.Toastify__flip-enter{animation-name:Toastify__flipIn}.Toastify__flip-exit{animation-name:Toastify__flipOut}@keyframes Toastify__slideInRight{0%{transform:translate3d(110%,0,0);visibility:visible}to{transform:translate3d(0,var(--y),0)}}@keyframes Toastify__slideInLeft{0%{transform:translate3d(-110%,0,0);visibility:visible}to{transform:translate3d(0,var(--y),0)}}@keyframes Toastify__slideInUp{0%{transform:translate3d(0,110%,0);visibility:visible}to{transform:translate3d(0,var(--y),0)}}@keyframes Toastify__slideInDown{0%{transform:translate3d(0,-110%,0);visibility:visible}to{transform:translate3d(0,var(--y),0)}}@keyframes Toastify__slideOutRight{0%{transform:translate3d(0,var(--y),0)}to{visibility:hidden;transform:translate3d(110%,var(--y),0)}}@keyframes Toastify__slideOutLeft{0%{transform:translate3d(0,var(--y),0)}to{visibility:hidden;transform:translate3d(-110%,var(--y),0)}}@keyframes Toastify__slideOutDown{0%{transform:translate3d(0,var(--y),0)}to{visibility:hidden;transform:translate3d(0,500px,0)}}@keyframes Toastify__slideOutUp{0%{transform:translate3d(0,var(--y),0)}to{visibility:hidden;transform:translate3d(0,-500px,0)}}.Toastify__slide-enter--top-left,.Toastify__slide-enter--bottom-left{animation-name:Toastify__slideInLeft}.Toastify__slide-enter--top-right,.Toastify__slide-enter--bottom-right{animation-name:Toastify__slideInRight}.Toastify__slide-enter--top-center{animation-name:Toastify__slideInDown}.Toastify__slide-enter--bottom-center{animation-name:Toastify__slideInUp}.Toastify__slide-exit--top-left,.Toastify__slide-exit--bottom-left{animation-name:Toastify__slideOutLeft;animation-timing-function:ease-in;animation-duration:.3s}.Toastify__slide-exit--top-right,.Toastify__slide-exit--bottom-right{animation-name:Toastify__slideOutRight;animation-timing-function:ease-in;animation-duration:.3s}.Toastify__slide-exit--top-center{animation-name:Toastify__slideOutUp;animation-timing-function:ease-in;animation-duration:.3s}.Toastify__slide-exit--bottom-center{animation-name:Toastify__slideOutDown;animation-timing-function:ease-in;animation-duration:.3s}@keyframes Toastify__spin{0%{transform:rotate(0)}to{transform:rotate(360deg)}}
`);
var L = (o) => typeof o == "number" && !isNaN(o), N = (o) => typeof o == "string", P = (o) => typeof o == "function", mt = (o) => N(o) || L(o), B = (o) => N(o) || P(o) ? o : null, pt = (o, E) => o === !1 || L(o) && o > 0 ? o : E, z = (o) => isValidElement(o) || N(o) || P(o) || L(o);
function Z(o, E, A = 300) {
  let { scrollHeight: g, style: e } = o;
  requestAnimationFrame(() => {
    e.minHeight = "initial", e.height = g + "px", e.transition = `all ${A}ms`, requestAnimationFrame(() => {
      e.height = "0", e.padding = "0", e.margin = "0", setTimeout(E, A);
    });
  });
}
function $({ enter: o, exit: E, appendPosition: A = !1, collapse: g = !0, collapseDuration: e = 300 }) {
  return function({ children: t, position: c, preventExitTransition: n, done: h, nodeRef: d, isIn: k, playToast: p }) {
    let M = A ? `${o}--${c}` : o, S = A ? `${E}--${c}` : E, AA = useRef(0);
    return useLayoutEffect$1(() => {
      let H = d.current, gA = M.split(" "), CA = (IA) => {
        IA.target === d.current && (p(), H.removeEventListener("animationend", CA), H.removeEventListener("animationcancel", CA), AA.current === 0 && IA.type !== "animationcancel" && H.classList.remove(...gA));
      };
      H.classList.add(...gA), H.addEventListener("animationend", CA), H.addEventListener("animationcancel", CA);
    }, []), useEffect(() => {
      let H = d.current, gA = () => {
        H.removeEventListener("animationend", gA), g ? Z(H, h, e) : h();
      };
      k || (n ? gA() : (AA.current = 1, H.className += ` ${S}`, H.addEventListener("animationend", gA)));
    }, [k]), React__default.createElement(React__default.Fragment, null, t);
  };
}
function J(o, E) {
  return { content: tt(o.content, o.props), containerId: o.props.containerId, id: o.props.toastId, theme: o.props.theme, type: o.props.type, data: o.props.data || {}, isLoading: o.props.isLoading, icon: o.props.icon, reason: o.removalReason, status: E };
}
function tt(o, E, A = !1) {
  return isValidElement(o) && !N(o.type) ? cloneElement(o, { closeToast: E.closeToast, toastProps: E, data: E.data, isPaused: A }) : P(o) ? o({ closeToast: E.closeToast, toastProps: E, data: E.data, isPaused: A }) : o;
}
function yt({ closeToast: o, theme: E, ariaLabel: A = "close" }) {
  return React__default.createElement("button", { className: `Toastify__close-button Toastify__close-button--${E}`, type: "button", onClick: (g) => {
    g.stopPropagation(), o(!0);
  }, "aria-label": A }, React__default.createElement("svg", { "aria-hidden": "true", viewBox: "0 0 14 16" }, React__default.createElement("path", { fillRule: "evenodd", d: "M7.71 8.23l3.75 3.75-1.48 1.48-3.75-3.75-3.75 3.75L1 11.98l3.75-3.75L1 4.48 2.48 3l3.75 3.75L9.98 3l1.48 1.48-3.75 3.75z" })));
}
function gt({ delay: o, isRunning: E, closeToast: A, type: g = "default", hide: e, className: t, controlledProgress: c, progress: n, rtl: h, isIn: d, theme: k }) {
  let p = e || c && n === 0, M = { animationDuration: `${o}ms`, animationPlayState: E ? "running" : "paused" };
  c && (M.transform = `scaleX(${n})`);
  let S = clsx("Toastify__progress-bar", c ? "Toastify__progress-bar--controlled" : "Toastify__progress-bar--animated", `Toastify__progress-bar-theme--${k}`, `Toastify__progress-bar--${g}`, { "Toastify__progress-bar--rtl": h }), AA = P(t) ? t({ rtl: h, type: g, defaultClassName: S }) : clsx(S, t), H = { [c && n >= 1 ? "onTransitionEnd" : "onAnimationEnd"]: c && n < 1 ? null : () => {
    d && A();
  } };
  return React__default.createElement("div", { className: "Toastify__progress-bar--wrp", "data-hidden": p }, React__default.createElement("div", { className: `Toastify__progress-bar--bg Toastify__progress-bar-theme--${k} Toastify__progress-bar--${g}` }), React__default.createElement("div", { role: "progressbar", "aria-hidden": p ? "true" : "false", "aria-label": "notification timer", className: AA, style: M, ...H }));
}
var Xt = 1, at = () => `${Xt++}`;
function _t(o, E, A) {
  let g = 1, e = 0, t = [], c = [], n = E, h = /* @__PURE__ */ new Map(), d = /* @__PURE__ */ new Set(), k = (IA) => (d.add(IA), () => d.delete(IA)), p = () => {
    c = Array.from(h.values()), d.forEach((IA) => IA());
  }, M = ({ containerId: IA, toastId: BA, updateId: QA }) => {
    let EA = IA ? IA !== o : o !== 1, oA = h.has(BA) && QA == null;
    return EA || oA;
  }, S = (IA, BA) => {
    h.forEach((QA) => {
      var EA;
      (BA == null || BA === QA.props.toastId) && ((EA = QA.toggle) == null || EA.call(QA, IA));
    });
  }, AA = (IA) => {
    var BA, QA;
    (QA = (BA = IA.props) == null ? void 0 : BA.onClose) == null || QA.call(BA, IA.removalReason), IA.isActive = !1;
  }, H = (IA) => {
    if (IA == null) h.forEach(AA);
    else {
      let BA = h.get(IA);
      BA && AA(BA);
    }
    p();
  }, gA = () => {
    e -= t.length, t = [];
  }, CA = (IA) => {
    var BA, QA;
    let { toastId: EA, updateId: oA } = IA.props, iA = oA == null;
    IA.staleId && h.delete(IA.staleId), IA.isActive = !0, h.set(EA, IA), p(), A(J(IA, iA ? "added" : "updated")), iA && ((QA = (BA = IA.props).onOpen) == null || QA.call(BA));
  };
  return { id: o, props: n, observe: k, toggle: S, removeToast: H, toasts: h, clearQueue: gA, buildToast: (IA, BA) => {
    if (M(BA)) return;
    let { toastId: QA, updateId: EA, data: oA, staleId: iA, delay: aA } = BA, tA = EA == null;
    tA && e++;
    let eA = { ...n, style: n.toastStyle, key: g++, ...Object.fromEntries(Object.entries(BA).filter(([DA, nA]) => nA != null)), toastId: QA, updateId: EA, data: oA, isIn: !1, className: B(BA.className || n.toastClassName), progressClassName: B(BA.progressClassName || n.progressClassName), autoClose: BA.isLoading ? !1 : pt(BA.autoClose, n.autoClose), closeToast(DA) {
      h.get(QA).removalReason = DA, H(QA);
    }, deleteToast() {
      let DA = h.get(QA);
      if (DA != null) {
        if (A(J(DA, "removed")), h.delete(QA), e--, e < 0 && (e = 0), t.length > 0) {
          CA(t.shift());
          return;
        }
        p();
      }
    } };
    eA.closeButton = n.closeButton, BA.closeButton === !1 || z(BA.closeButton) ? eA.closeButton = BA.closeButton : BA.closeButton === !0 && (eA.closeButton = z(n.closeButton) ? n.closeButton : !0);
    let cA = { content: IA, props: eA, staleId: iA };
    n.limit && n.limit > 0 && e > n.limit && tA ? t.push(cA) : L(aA) ? setTimeout(() => {
      CA(cA);
    }, aA) : CA(cA);
  }, setProps(IA) {
    n = IA;
  }, setToggle: (IA, BA) => {
    let QA = h.get(IA);
    QA && (QA.toggle = BA);
  }, isToastActive: (IA) => {
    var BA;
    return (BA = h.get(IA)) == null ? void 0 : BA.isActive;
  }, getSnapshot: () => c };
}
var I = /* @__PURE__ */ new Map(), F = [], st = /* @__PURE__ */ new Set(), Vt = (o) => st.forEach((E) => E(o)), bt = () => I.size > 0;
function Qt() {
  F.forEach((o) => nt(o.content, o.options)), F = [];
}
var vt = (o, { containerId: E }) => {
  var A;
  return (A = I.get(E || 1)) == null ? void 0 : A.toasts.get(o);
};
function X(o, E) {
  var A;
  if (E) return !!((A = I.get(E)) != null && A.isToastActive(o));
  let g = !1;
  return I.forEach((e) => {
    e.isToastActive(o) && (g = !0);
  }), g;
}
function ht(o) {
  if (!bt()) {
    F = F.filter((E) => o != null && E.options.toastId !== o);
    return;
  }
  if (o == null || mt(o)) I.forEach((E) => {
    E.removeToast(o);
  });
  else if (o && ("containerId" in o || "id" in o)) {
    let E = I.get(o.containerId);
    E ? E.removeToast(o.id) : I.forEach((A) => {
      A.removeToast(o.id);
    });
  }
}
var Ct = (o = {}) => {
  I.forEach((E) => {
    E.props.limit && (!o.containerId || E.id === o.containerId) && E.clearQueue();
  });
};
function nt(o, E) {
  z(o) && (bt() || F.push({ content: o, options: E }), I.forEach((A) => {
    A.buildToast(o, E);
  }));
}
function xt(o) {
  var E;
  (E = I.get(o.containerId || 1)) == null || E.setToggle(o.id, o.fn);
}
function rt(o, E) {
  I.forEach((A) => {
    (E == null || !(E != null && E.containerId) || E?.containerId === A.id) && A.toggle(o, E?.id);
  });
}
function Et(o) {
  let E = o.containerId || 1;
  return { subscribe(A) {
    let g = _t(E, o, Vt);
    I.set(E, g);
    let e = g.observe(A);
    return Qt(), () => {
      e(), I.delete(E);
    };
  }, setProps(A) {
    var g;
    (g = I.get(E)) == null || g.setProps(A);
  }, getSnapshot() {
    var A;
    return (A = I.get(E)) == null ? void 0 : A.getSnapshot();
  } };
}
function Pt(o) {
  return st.add(o), () => {
    st.delete(o);
  };
}
function Wt(o) {
  return o && (N(o.toastId) || L(o.toastId)) ? o.toastId : at();
}
function U(o, E) {
  return nt(o, E), E.toastId;
}
function V(o, E) {
  return { ...E, type: E && E.type || o, toastId: Wt(E) };
}
function Q(o) {
  return (E, A) => U(E, V(o, A));
}
function y(o, E) {
  return U(o, V("default", E));
}
y.loading = (o, E) => U(o, V("default", { isLoading: !0, autoClose: !1, closeOnClick: !1, closeButton: !1, draggable: !1, ...E }));
function Gt(o, { pending: E, error: A, success: g }, e) {
  let t;
  E && (t = N(E) ? y.loading(E, e) : y.loading(E.render, { ...e, ...E }));
  let c = { isLoading: null, autoClose: null, closeOnClick: null, closeButton: null, draggable: null }, n = (d, k, p) => {
    if (k == null) {
      y.dismiss(t);
      return;
    }
    let M = { type: d, ...c, ...e, data: p }, S = N(k) ? { render: k } : k;
    return t ? y.update(t, { ...M, ...S }) : y(S.render, { ...M, ...S }), p;
  }, h = P(o) ? o() : o;
  return h.then((d) => n("success", g, d)).catch((d) => n("error", A, d)), h;
}
y.promise = Gt;
y.success = Q("success");
y.info = Q("info");
y.error = Q("error");
y.warning = Q("warning");
y.warn = y.warning;
y.dark = (o, E) => U(o, V("default", { theme: "dark", ...E }));
function qt(o) {
  ht(o);
}
y.dismiss = qt;
y.clearWaitingQueue = Ct;
y.isActive = X;
y.update = (o, E = {}) => {
  let A = vt(o, E);
  if (A) {
    let { props: g, content: e } = A, t = { delay: 100, ...g, ...E, toastId: E.toastId || o, updateId: at() };
    t.toastId !== o && (t.staleId = o);
    let c = t.render || e;
    delete t.render, U(c, t);
  }
};
y.done = (o) => {
  y.update(o, { progress: 1 });
};
y.onChange = Pt;
y.play = (o) => rt(!0, o);
y.pause = (o) => rt(!1, o);
function It(o) {
  var E;
  let { subscribe: A, getSnapshot: g, setProps: e } = useRef(Et(o)).current;
  e(o);
  let t = (E = useSyncExternalStore(A, g, g)) == null ? void 0 : E.slice();
  function c(n) {
    if (!t) return [];
    let h = /* @__PURE__ */ new Map();
    return o.newestOnTop && t.reverse(), t.forEach((d) => {
      let { position: k } = d.props;
      h.has(k) || h.set(k, []), h.get(k).push(d);
    }), Array.from(h, (d) => n(d[0], d[1]));
  }
  return { getToastToRender: c, isToastActive: X, count: t?.length };
}
function At(o) {
  let [E, A] = useState(!1), [g, e] = useState(!1), t = useRef(null), c = useRef({ start: 0, delta: 0, removalDistance: 0, canCloseOnClick: !0, canDrag: !1, didMove: !1 }).current, { autoClose: n, pauseOnHover: h, closeToast: d, onClick: k, closeOnClick: p } = o;
  xt({ id: o.toastId, containerId: o.containerId, fn: A }), useEffect(() => {
    if (o.pauseOnFocusLoss) return M(), () => {
      S();
    };
  }, [o.pauseOnFocusLoss]);
  function M() {
    document.hasFocus() || CA(), window.addEventListener("focus", gA), window.addEventListener("blur", CA);
  }
  function S() {
    window.removeEventListener("focus", gA), window.removeEventListener("blur", CA);
  }
  function AA(iA) {
    if (o.draggable === !0 || o.draggable === iA.pointerType) {
      IA();
      let aA = t.current;
      c.canCloseOnClick = !0, c.canDrag = !0, aA.style.transition = "none", o.draggableDirection === "x" ? (c.start = iA.clientX, c.removalDistance = aA.offsetWidth * (o.draggablePercent / 100)) : (c.start = iA.clientY, c.removalDistance = aA.offsetHeight * (o.draggablePercent === 80 ? o.draggablePercent * 1.5 : o.draggablePercent) / 100);
    }
  }
  function H(iA) {
    let { top: aA, bottom: tA, left: eA, right: cA } = t.current.getBoundingClientRect();
    iA.nativeEvent.type !== "touchend" && o.pauseOnHover && iA.clientX >= eA && iA.clientX <= cA && iA.clientY >= aA && iA.clientY <= tA ? CA() : gA();
  }
  function gA() {
    A(!0);
  }
  function CA() {
    A(!1);
  }
  function IA() {
    c.didMove = !1, document.addEventListener("pointermove", QA), document.addEventListener("pointerup", EA);
  }
  function BA() {
    document.removeEventListener("pointermove", QA), document.removeEventListener("pointerup", EA);
  }
  function QA(iA) {
    let aA = t.current;
    if (c.canDrag && aA) {
      c.didMove = !0, E && CA(), o.draggableDirection === "x" ? c.delta = iA.clientX - c.start : c.delta = iA.clientY - c.start, c.start !== iA.clientX && (c.canCloseOnClick = !1);
      let tA = o.draggableDirection === "x" ? `${c.delta}px, var(--y)` : `0, calc(${c.delta}px + var(--y))`;
      aA.style.transform = `translate3d(${tA},0)`, aA.style.opacity = `${1 - Math.abs(c.delta / c.removalDistance)}`;
    }
  }
  function EA() {
    BA();
    let iA = t.current;
    if (c.canDrag && c.didMove && iA) {
      if (c.canDrag = !1, Math.abs(c.delta) > c.removalDistance) {
        e(!0), o.closeToast(!0), o.collapseAll();
        return;
      }
      iA.style.transition = "transform 0.2s, opacity 0.2s", iA.style.removeProperty("transform"), iA.style.removeProperty("opacity");
    }
  }
  let oA = { onPointerDown: AA, onPointerUp: H };
  return n && h && (oA.onMouseEnter = CA, o.stacked || (oA.onMouseLeave = gA)), p && (oA.onClick = (iA) => {
    k && k(iA), c.canCloseOnClick && d(!0);
  }), { playToast: gA, pauseToast: CA, isRunning: E, preventExitTransition: g, toastRef: t, eventHandlers: oA };
}
var Ot = typeof window < "u" ? useLayoutEffect$1 : useEffect, G = ({ theme: o, type: E, isLoading: A, ...g }) => React__default.createElement("svg", { viewBox: "0 0 24 24", width: "100%", height: "100%", fill: o === "colored" ? "currentColor" : `var(--toastify-icon-color-${E})`, ...g });
function ao(o) {
  return React__default.createElement(G, { ...o }, React__default.createElement("path", { d: "M23.32 17.191L15.438 2.184C14.728.833 13.416 0 11.996 0c-1.42 0-2.733.833-3.443 2.184L.533 17.448a4.744 4.744 0 000 4.368C1.243 23.167 2.555 24 3.975 24h16.05C22.22 24 24 22.044 24 19.632c0-.904-.251-1.746-.68-2.44zm-9.622 1.46c0 1.033-.724 1.823-1.698 1.823s-1.698-.79-1.698-1.822v-.043c0-1.028.724-1.822 1.698-1.822s1.698.79 1.698 1.822v.043zm.039-12.285l-.84 8.06c-.057.581-.408.943-.897.943-.49 0-.84-.367-.896-.942l-.84-8.065c-.057-.624.25-1.095.779-1.095h1.91c.528.005.84.476.784 1.1z" }));
}
function so(o) {
  return React__default.createElement(G, { ...o }, React__default.createElement("path", { d: "M12 0a12 12 0 1012 12A12.013 12.013 0 0012 0zm.25 5a1.5 1.5 0 11-1.5 1.5 1.5 1.5 0 011.5-1.5zm2.25 13.5h-4a1 1 0 010-2h.75a.25.25 0 00.25-.25v-4.5a.25.25 0 00-.25-.25h-.75a1 1 0 010-2h1a2 2 0 012 2v4.75a.25.25 0 00.25.25h.75a1 1 0 110 2z" }));
}
function no(o) {
  return React__default.createElement(G, { ...o }, React__default.createElement("path", { d: "M12 0a12 12 0 1012 12A12.014 12.014 0 0012 0zm6.927 8.2l-6.845 9.289a1.011 1.011 0 01-1.43.188l-4.888-3.908a1 1 0 111.25-1.562l4.076 3.261 6.227-8.451a1 1 0 111.61 1.183z" }));
}
function ro(o) {
  return React__default.createElement(G, { ...o }, React__default.createElement("path", { d: "M11.983 0a12.206 12.206 0 00-8.51 3.653A11.8 11.8 0 000 12.207 11.779 11.779 0 0011.8 24h.214A12.111 12.111 0 0024 11.791 11.766 11.766 0 0011.983 0zM10.5 16.542a1.476 1.476 0 011.449-1.53h.027a1.527 1.527 0 011.523 1.47 1.475 1.475 0 01-1.449 1.53h-.027a1.529 1.529 0 01-1.523-1.47zM11 12.5v-6a1 1 0 012 0v6a1 1 0 11-2 0z" }));
}
function io() {
  return React__default.createElement("div", { className: "Toastify__spinner" });
}
var W = { info: so, warning: ao, success: no, error: ro, spinner: io }, lo = (o) => o in W;
function Nt({ theme: o, type: E, isLoading: A, icon: g }) {
  let e = null, t = { theme: o, type: E };
  return g === !1 || (P(g) ? e = g({ ...t, isLoading: A }) : isValidElement(g) ? e = cloneElement(g, t) : A ? e = W.spinner() : lo(E) && (e = W[E](t))), e;
}
var wt = (o) => {
  let { isRunning: E, preventExitTransition: A, toastRef: g, eventHandlers: e, playToast: t } = At(o), { closeButton: c, children: n, autoClose: h, onClick: d, type: k, hideProgressBar: p, closeToast: M, transition: S, position: AA, className: H, style: gA, progressClassName: CA, updateId: IA, role: BA, progress: QA, rtl: EA, toastId: oA, deleteToast: iA, isIn: aA, isLoading: tA, closeOnClick: eA, theme: cA, ariaLabel: DA } = o, nA = clsx("Toastify__toast", `Toastify__toast-theme--${cA}`, `Toastify__toast--${k}`, { "Toastify__toast--rtl": EA }, { "Toastify__toast--close-on-click": eA }), wA = P(H) ? H({ rtl: EA, position: AA, type: k, defaultClassName: nA }) : clsx(nA, H), lA = Nt(o), NA = !!QA || !h, RA = { closeToast: M, type: k, theme: cA }, KA = null;
  return c === !1 || (P(c) ? KA = c(RA) : isValidElement(c) ? KA = cloneElement(c, RA) : KA = yt(RA)), React__default.createElement(S, { isIn: aA, done: iA, position: AA, preventExitTransition: A, nodeRef: g, playToast: t }, React__default.createElement("div", { id: oA, tabIndex: 0, onClick: d, "data-in": aA, className: wA, ...e, style: gA, ref: g, ...aA && { role: BA, "aria-label": DA } }, lA != null && React__default.createElement("div", { className: clsx("Toastify__toast-icon", { "Toastify--animate-icon Toastify__zoom-enter": !tA }) }, lA), tt(n, o, !E), KA, !o.customProgressBar && React__default.createElement(gt, { ...IA && !NA ? { key: `p-${IA}` } : {}, rtl: EA, theme: cA, delay: h, isRunning: E, isIn: aA, closeToast: M, hide: p, type: k, className: CA, controlledProgress: NA, progress: QA || 0 })));
}, K = (o, E = !1) => ({ enter: `Toastify--animate Toastify__${o}-enter`, exit: `Toastify--animate Toastify__${o}-exit`, appendPosition: E }), lt = $(K("bounce", !0)), mo = $(K("slide", !0)), _o = { position: "top-right", transition: lt, autoClose: 5e3, closeButton: !0, pauseOnHover: !0, pauseOnFocusLoss: !0, draggable: "touch", draggablePercent: 80, draggableDirection: "x", role: "alert", theme: "light", "aria-label": "Notifications Alt+T", hotKeys: (o) => o.altKey && o.code === "KeyT" };
function Lt(o) {
  let E = { ..._o, ...o }, A = o.stacked, [g, e] = useState(!0), t = useRef(null), { getToastToRender: c, isToastActive: n, count: h } = It(E), { className: d, style: k, rtl: p, containerId: M, hotKeys: S } = E;
  function AA(gA) {
    let CA = clsx("Toastify__toast-container", `Toastify__toast-container--${gA}`, { "Toastify__toast-container--rtl": p });
    return P(d) ? d({ position: gA, rtl: p, defaultClassName: CA }) : clsx(CA, B(d));
  }
  function H() {
    A && (e(!0), y.play());
  }
  return Ot(() => {
    var gA;
    if (A) {
      let CA = t.current.querySelectorAll('[data-in="true"]'), IA = 12, BA = (gA = E.position) == null ? void 0 : gA.includes("top"), QA = 0, EA = 0;
      Array.from(CA).reverse().forEach((oA, iA) => {
        let aA = oA;
        aA.classList.add("Toastify__toast--stacked"), iA > 0 && (aA.dataset.collapsed = `${g}`), aA.dataset.pos || (aA.dataset.pos = BA ? "top" : "bot");
        let tA = QA * (g ? 0.2 : 1) + (g ? 0 : IA * iA);
        aA.style.setProperty("--y", `${BA ? tA : tA * -1}px`), aA.style.setProperty("--g", `${IA}`), aA.style.setProperty("--s", `${1 - (g ? EA : 0)}`), QA += aA.offsetHeight, EA += 0.025;
      });
    }
  }, [g, h, A]), useEffect(() => {
    function gA(CA) {
      var IA;
      let BA = t.current;
      S(CA) && ((IA = BA.querySelector('[tabIndex="0"]')) == null || IA.focus(), e(!1), y.pause()), CA.key === "Escape" && (document.activeElement === BA || BA != null && BA.contains(document.activeElement)) && (e(!0), y.play());
    }
    return document.addEventListener("keydown", gA), () => {
      document.removeEventListener("keydown", gA);
    };
  }, [S]), React__default.createElement("section", { ref: t, className: "Toastify", id: M, onMouseEnter: () => {
    A && (e(!1), y.pause());
  }, onMouseLeave: H, "aria-live": "polite", "aria-atomic": "false", "aria-relevant": "additions text", "aria-label": E["aria-label"] }, c((gA, CA) => {
    let IA = CA.length ? { ...k } : { ...k, pointerEvents: "none" };
    return React__default.createElement("div", { tabIndex: -1, className: AA(gA), "data-stacked": A, style: IA, key: `c-${gA}` }, CA.map(({ content: BA, props: QA }) => React__default.createElement(wt, { ...QA, stacked: A, collapseAll: H, isIn: n(QA.toastId, QA.containerId), key: `t-${QA.key}` }, BA)));
  }));
}
function ErrorToastContent(o) {
  const E = o;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { style: {
    width: "100%",
    padding: 0
  }, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: E.message }),
    E.error && /* @__PURE__ */ jsxRuntimeExports.jsx("pre", { style: {
      width: "100%",
      padding: 0,
      overflow: "scroll",
      maxHeight: 300
    }, children: /* @__PURE__ */ jsxRuntimeExports.jsx("code", { style: {
      padding: "16px"
    }, children: E.error.message }) })
  ] });
}
function stliteStyledPromiseToast(o, E, A) {
  const g = E.error;
  return y.promise(o, {
    pending: E.pending,
    success: E.success,
    error: typeof g == "string" ? {
      render({
        data: e
      }) {
        return e ? /* @__PURE__ */ jsxRuntimeExports.jsx(ErrorToastContent, { message: g, error: e }) : g;
      },
      autoClose: !1,
      closeOnClick: !1
    } : g
  }, {
    hideProgressBar: !0,
    position: "bottom-right",
    ...A
  });
}
function makeToastKernelEventListeners(o) {
  let E = null;
  const A = [];
  return {
    onLoadProgress: (S) => {
      const AA = y(S.detail, {
        position: "bottom-right",
        transition: mo,
        isLoading: !0,
        hideProgressBar: !0,
        closeButton: !1,
        containerId: o
      });
      A.push(AA), E && y.update(E, {
        isLoading: !1,
        autoClose: 3e3
      }), E = AA;
    },
    onLoadFinished: () => {
      A.forEach((S) => y.dismiss(S));
    },
    onLoadError: (S) => {
      y(/* @__PURE__ */ jsxRuntimeExports.jsx(ErrorToastContent, { message: "Error during booting up", error: S.detail }), {
        position: "bottom-right",
        type: "error",
        autoClose: !1,
        closeOnClick: !1,
        containerId: o
      });
    },
    onModuleAutoLoad: (S) => {
      const {
        promise: AA
      } = S.detail;
      stliteStyledPromiseToast(AA, {
        success: {
          render({
            data: H
          }) {
            return `Auto-loaded${H ? ": " + H.map((gA) => gA.name).join(", ") : " packages"}`;
          }
        },
        error: "Failed to auto-load packages",
        pending: "Auto-loading packages"
      }, {
        containerId: o
      });
    },
    onInstall: (S) => {
      const {
        requirements: AA,
        promise: H
      } = S.detail;
      stliteStyledPromiseToast(H, {
        pending: "Installing",
        success: `Successfully installed: ${AA.join(", ")}`,
        error: `Failed to install: ${AA.join(", ")}`
      }, {
        containerId: o
      });
    },
    onWriteFile: (S) => {
      const {
        path: AA,
        promise: H
      } = S.detail;
      stliteStyledPromiseToast(H, {
        error: `Failed to write file: ${AA}`
      }, {
        containerId: o
      });
    },
    onRenameFile: (S) => {
      const {
        oldPath: AA,
        newPath: H,
        promise: gA
      } = S.detail;
      stliteStyledPromiseToast(gA, {
        error: `Failed to rename file from ${AA} to ${H}`
      }, {
        containerId: o
      });
    },
    onUnlink: (S) => {
      const {
        path: AA,
        promise: H
      } = S.detail;
      stliteStyledPromiseToast(H, {
        error: `Failed to unlink: ${AA}`
      }, {
        containerId: o
      });
    },
    onReadFile: (S) => {
      const {
        path: AA,
        promise: H
      } = S.detail;
      stliteStyledPromiseToast(H, {
        error: `Failed to read file: ${AA}`
      }, {
        containerId: o
      });
    },
    onReboot: (S) => {
      const {
        promise: AA
      } = S.detail;
      stliteStyledPromiseToast(AA, {
        pending: "Rebooting",
        success: "Successfully rebooted",
        error: "Failed to reboot"
      }, {
        containerId: o
      });
    }
  };
}
function isDarkTheme() {
  const o = getDefaultTheme().name;
  return o === AUTO_THEME_NAME ? window.matchMedia("(prefers-color-scheme: dark)").matches : o === darkTheme.name;
}
function ToastContainer({
  toastContainerId: o
}) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Lt, { containerId: o, style: {
    zIndex: 999999,
    position: "absolute",
    overflow: "hidden"
  }, theme: isDarkTheme() ? "dark" : "light" });
}
function StliteAppWithToast(o) {
  const {
    kernel: E,
    disableProgressToasts: A,
    disableErrorToasts: g,
    disableModuleAutoLoadToasts: e
  } = o, t = useId(), {
    onLoadProgress: c,
    onLoadFinished: n,
    onLoadError: h,
    onModuleAutoLoad: d,
    onInstall: k,
    onWriteFile: p,
    onRenameFile: M,
    onUnlink: S,
    onReadFile: AA,
    onReboot: H
  } = useMemo$1(() => makeToastKernelEventListeners(t), [t]);
  return useEffect(() => {
    if (!A)
      return E.addEventListener("loadProgress", c), E.addEventListener("loadFinished", n), () => {
        E.removeEventListener("loadProgress", c), E.removeEventListener("loadFinished", n);
      };
  }, [E, A, c, n]), useEffect(() => {
    if (!g)
      return E.addEventListener("loadError", h), () => {
        E.removeEventListener("loadError", h);
      };
  }, [E, g, h]), useEffect(() => {
    if (!e)
      return E.addEventListener("moduleAutoLoad", d), () => {
        E.removeEventListener("moduleAutoLoad", d);
      };
  }, [E, e, d]), useEffect(() => (E.addEventListener("install", k), E.addEventListener("writeFile", p), E.addEventListener("renameFile", M), E.addEventListener("unlink", S), E.addEventListener("readFile", AA), E.addEventListener("reboot", H), () => {
    E.removeEventListener("install", k), E.removeEventListener("writeFile", p), E.removeEventListener("renameFile", M), E.removeEventListener("unlink", S), E.removeEventListener("readFile", AA), E.removeEventListener("reboot", H);
  }), [E, k, p, M, S, AA, H]), /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(StliteApp, { kernel: E, styleNonce: o.styleNonce, disableDocumentStyles: o.disableDocumentStyles }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ToastContainer, { toastContainerId: t })
  ] });
}
class PromiseDelegate {
  promise;
  resolveInternal;
  rejectInternal;
  constructor() {
    this.promise = new Promise((E, A) => {
      this.resolveInternal = E, this.rejectInternal = A;
    });
  }
  resolve(E) {
    this.resolveInternal(E);
  }
  reject(E) {
    this.rejectInternal(E);
  }
}
const workerBlobUrlCache = /* @__PURE__ */ new Map();
function getWorkerBlobUrl(o, E = !1) {
  const A = o.toString(), g = `${E ? "module" : "classic"}:${A}`, e = workerBlobUrlCache.get(g);
  if (e)
    return console.debug(`Using a cached worker blob URL for ${A}`), e;
  const t = E ? `import "${A}";` : `importScripts("${A}");`, c = new Blob([t], {
    type: E ? "text/javascript;type=module" : "text/javascript"
  }), n = URL.createObjectURL(c);
  return workerBlobUrlCache.set(g, n), n;
}
function isOpaqueOrigin() {
  return window.location.protocol === "file:" || window.location.origin === "null";
}
function isSameOrigin(o) {
  return isOpaqueOrigin() ? !1 : o.origin === window.location.origin;
}
function createWorker(o, E, A) {
  return E ? isOpaqueOrigin() ? (console.warn("SharedWorker is not supported on opaque origins (e.g. file:// protocol). Falling back to a regular Worker."), new Worker(o, A)) : typeof window.SharedWorker < "u" ? (console.debug("Using SharedWorker. Visit chrome://inspect/#workers (Chrome) or about:debugging#/runtime/this-firefox (Firefox) to see the console output of the worker."), new SharedWorker(o, A)) : (console.warn("SharedWorker is not supported in this browser. Falling back to a regular Worker."), new Worker(o, A)) : new Worker(o, A);
}
class CrossOriginWorkerMaker {
  worker;
  constructor(E, {
    shared: A,
    ...g
  }) {
    if (isSameOrigin(E))
      console.debug(`Loading a worker script from the same origin: ${E}`), this.worker = createWorker(E, A, g);
    else {
      console.debug(`Loading a worker script via blob URL wrapper: ${E.protocol === "data:" ? "data: URL" : E}`);
      const t = getWorkerBlobUrl(E, g.type === "module");
      this.worker = createWorker(t, A, g);
    }
  }
}
const LEADING_AND_TRAILING_SLASH_RE = new RegExp("^\\/+|(?<!\\/)\\/+$", "g");
function normalizeBasePath(o) {
  return o.replace(LEADING_AND_TRAILING_SLASH_RE, "");
}
function isPyodideConvertiblePrimitive(o) {
  return typeof o == "string" || typeof o == "number" || typeof o == "boolean" || o === null || o === void 0;
}
function isStreamlitConfig(o) {
  return typeof o == "object" && o != null && Object.entries(o).every(([E, A]) => typeof E == "string" && isPyodideConvertiblePrimitive(A));
}
function assertStreamlitConfig(o) {
  if (!isStreamlitConfig(o))
    throw new Error(`Invalid streamlitConfig: ${o}`);
}
const validateEnvKey = (o) => /^[A-Za-z_][A-Za-z0-9_]*$/.test(o);
function isSharedWorker(o) {
  return typeof window.SharedWorker < "u" && o instanceof SharedWorker;
}
class StliteKernel extends EventTarget {
  /**
   * Made public for advanced use cases as an unstable API.
   * You can use it but there is no stability guarantee for future releases.
   */
  _worker;
  _isDisposed = !1;
  _postMessageTarget;
  _loaded = new PromiseDelegate();
  _workerInitData;
  basePath;
  // TODO: Move this prop to outside this class. This is not a member of the kernel business logic, but just a globally referred value.
  hostConfigResponse;
  // Will be passed to ConnectionManager to call `onHostConfigResp` from it.
  addEventListener(E, A, g) {
    super.addEventListener(E, A, g);
  }
  removeEventListener(E, A, g) {
    super.removeEventListener(E, A, g);
  }
  dispatchEvent(E) {
    return super.dispatchEvent(E);
  }
  constructor(E) {
    if (super(), this.basePath = normalizeBasePath(E.basePath ?? window.location.pathname), this.hostConfigResponse = E.hostConfigResponse ?? {}, E.worker)
      this._worker = E.worker;
    else {
      const A = new CrossOriginWorkerMaker(new URL(
        /* @vite-ignore */
        "" + new URL("assets/worker-DAN7Os1o.js", import.meta.url).href,
        import.meta.url
      ), {
        /* @vite-ignore */
        // To avoid the Vite error: "[vite:worker-import-meta-url] Vite is unable to parse the worker options as the value is not static.To ignore this error, please use /* @vite-ignore */ in the worker options."
        type: E.workerType,
        shared: E.sharedWorker ?? !1
      });
      this._worker = A.worker;
    }
    isSharedWorker(this._worker) ? (this._worker.port.start(), this._postMessageTarget = this._worker.port) : this._postMessageTarget = this._worker, this._postMessageTarget.onmessage = (A) => {
      this._processWorkerMessage(A.data, A.ports[0]);
    }, E.streamlitConfig != null && assertStreamlitConfig(E.streamlitConfig), this._workerInitData = {
      entrypoint: E.entrypoint,
      files: E.files,
      archives: E.archives,
      requirements: E.requirements,
      prebuiltPackageNames: E.prebuiltPackageNames,
      pyodideUrl: E.pyodideUrl,
      wheels: E.wheelUrls,
      streamlitConfig: E.streamlitConfig,
      idbfsMountpoints: E.idbfsMountpoints,
      moduleAutoLoad: E.moduleAutoLoad ?? !1,
      env: E.env,
      languageServer: E.languageServer ?? !1
    };
  }
  get loaded() {
    return this._loaded.promise;
  }
  connectWebSocket(E) {
    return this._asyncPostMessage({
      type: "websocket:connect",
      data: {
        path: E
      }
    }).then();
  }
  sendWebSocketMessage(E) {
    return this._asyncPostMessage({
      type: "websocket:send",
      data: {
        payload: E
      }
    }).then();
  }
  handleWebSocketMessage = null;
  onWebSocketMessage(E) {
    this.handleWebSocketMessage = E;
  }
  sendHttpRequest(E, A) {
    return this._asyncPostMessage({
      type: "http:request",
      data: {
        request: E
      }
    }, "http:response", A).then((g) => ({
      ...g.response,
      headers: new Headers(Object.fromEntries(g.response.headers))
    }));
  }
  async writeFile(E, A, g) {
    await this.loaded;
    const e = this._asyncPostMessage({
      type: "file:write",
      data: {
        path: E,
        data: A,
        opts: g
      }
    });
    this.dispatchEvent(new CustomEvent("writeFile", {
      detail: {
        path: E,
        promise: e
      }
    })), await e;
  }
  async renameFile(E, A) {
    await this.loaded;
    const g = this._asyncPostMessage({
      type: "file:rename",
      data: {
        oldPath: E,
        newPath: A
      }
    });
    this.dispatchEvent(new CustomEvent("renameFile", {
      detail: {
        oldPath: E,
        newPath: A,
        promise: g
      }
    })), await g;
  }
  async readFile(E, A) {
    await this.loaded;
    const g = this._asyncPostMessage({
      type: "file:read",
      data: {
        path: E,
        opts: A
      }
    }, "reply:file:read").then((e) => e.content);
    return this.dispatchEvent(new CustomEvent("readFile", {
      detail: {
        path: E,
        promise: g
      }
    })), g;
  }
  async unlink(E) {
    await this.loaded, await this._asyncPostMessage({
      type: "file:unlink",
      data: {
        path: E
      }
    });
  }
  async install(E, A) {
    await this.loaded;
    const g = this._asyncPostMessage({
      type: "install",
      data: {
        requirements: E,
        options: A
      }
    });
    this.dispatchEvent(new CustomEvent("install", {
      detail: {
        requirements: E,
        promise: g
      }
    })), await g;
  }
  async addMockPackage(E, A, g, e) {
    await this.loaded, await this._asyncPostMessage({
      type: "add_mock_package",
      data: {
        name: E,
        version: A,
        modules: g,
        persistent: e
      }
    });
  }
  async setEnv(E) {
    Object.keys(E).forEach((A) => {
      if (!validateEnvKey(A))
        throw new Error(`Invalid environment variable name: "${A}"`);
    }), await this.loaded, await this._asyncPostMessage({
      type: "setEnv",
      data: {
        env: E
      }
    });
  }
  async getCodeCompletion(E, A) {
    if (!this._workerInitData.languageServer)
      throw new Error("Language server not loaded, please set languageServer=true to use this method");
    return await this.loaded, this._asyncPostMessage({
      type: "code_completion",
      data: {
        code: E,
        line: A.line,
        column: A.column
      }
    }, "reply:code_completion").then((g) => g.codeCompletions);
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async runPython(E) {
    return await this.loaded, this.loaded.then(() => this._asyncPostMessage({
      type: "run_python",
      data: {
        code: E
      }
    }, "reply:run_python")).then((A) => A.result);
  }
  /**
   * Reboot the Streamlit server.
   * Note that we also need to refresh (rerender) the frontend app after calling this method
   * to reflect the changes on the user-facing side.
   */
  async reboot(E) {
    await this.loaded, await this._asyncPostMessage({
      type: "reboot",
      data: {
        entrypoint: E
      }
    });
  }
  _asyncPostMessage(E, A, g) {
    let e = "reply", t;
    return typeof A == "string" ? (e = A, t = g) : A && (t = A), t && t.aborted ? Promise.reject(new DOMException("Aborted", "AbortError")) : new Promise((c, n) => {
      const h = new MessageChannel(), d = () => {
        h.port1.close(), n(new DOMException("Aborted", "AbortError"));
      };
      t && t.addEventListener("abort", d, {
        once: !0
      }), h.port1.onmessage = (k) => {
        t && t.removeEventListener("abort", d), h.port1.close();
        const p = k.data;
        if (p.error)
          n(p.error);
        else {
          if (p.type !== e)
            throw new Error(`Unexpected reply type "${p.type}"`);
          c(p.data);
        }
      }, this._postMessageTarget.postMessage(E, [h.port2]);
    });
  }
  /**
   * Process a message coming from the pyodide web worker.
   *
   * @param msg The worker message to process.
   */
  _processWorkerMessage(E, A) {
    switch (E.type) {
      case "event:envSetup": {
        this._postMessageTarget.postMessage({
          type: "initData",
          data: this._workerInitData
        });
        break;
      }
      case "event:loadProgress": {
        this.dispatchEvent(new CustomEvent("loadProgress", {
          detail: E.data.message
        }));
        break;
      }
      case "event:loadError": {
        this.dispatchEvent(new CustomEvent("loadError", {
          detail: E.data.error
        }));
        break;
      }
      case "event:loadFinished": {
        this._loaded.resolve(), this.dispatchEvent(new Event("loadFinished"));
        break;
      }
      case "websocket:message": {
        const {
          payload: g
        } = E.data;
        this.handleWebSocketMessage?.(g);
        break;
      }
      case "event:moduleAutoLoad": {
        if (A == null)
          throw new Error("Port is required for moduleAutoLoad event");
        const g = new Promise((e, t) => {
          A.onmessage = (c) => {
            const n = c.data;
            n.type === "moduleAutoLoad:success" ? e(n.data.loadedPackages) : t(n.error), A.close();
          };
        });
        this.dispatchEvent(new CustomEvent("moduleAutoLoad", {
          detail: {
            packagesToLoad: E.data.packagesToLoad,
            promise: g
          }
        }));
        break;
      }
    }
  }
  /**
   * Return whether the kernel is disposed.
   */
  get isDisposed() {
    return this._isDisposed;
  }
  /**
   * Dispose the kernel.
   */
  dispose() {
    this.isDisposed || (isSharedWorker(this._worker) ? this._worker.port.close() : this._worker.terminate(), this._isDisposed = !0);
  }
}
function createKernel(o) {
  return new StliteKernel({
    ...o,
    workerType: o.workerType ?? "module"
    // Default value is "module" because Vite loads the worker scripts as ES modules without bundling at dev time, so we need to specify the type as "module" for the "import" statements in the worker script to work.
  });
}
function useKernel(o) {
  const [E, A] = useState(null);
  return useEffect(() => {
    const g = createKernel(o);
    return A(g), () => {
      g.dispose();
    };
  }, []), E;
}
export {
  Video$1 as $,
  ADJOINED as A,
  BaseButtonKind as B,
  Checkbox$1 as C,
  DynamicButtonLabel as D,
  EmotionIconBase as E,
  Arrow$2 as F,
  range$1 as G,
  isNumericType as H,
  DataFrameCellType as I,
  useStliteMediaObjectUrl as J,
  useCrossOriginAttribute as K,
  loglevelExports$1 as L,
  useStliteMediaObjects as M,
  useRequiredContext as N,
  useCopyToClipboard as O,
  Placement as P,
  ensureError as Q,
  ErrorElement as R,
  StyledCheckbox$1 as S,
  TooltipIcon as T,
  UISelectbox as U,
  NavigationContext as V,
  DynamicIcon as W,
  toaster as X,
  AlertElement$1 as Y,
  Kind as Z,
  _extends$C as _,
  Box as a,
  isArrayLikeObject as a$,
  keyframes as a0,
  StyledWidgetInstructions as a1,
  isFromMac as a2,
  FormsContext as a3,
  StyledFormSubmitContent as a4,
  Form$1 as a5,
  isInForm as a6,
  WidgetLabel as a7,
  StyledWidgetLabelHelp as a8,
  isMaterialIcon as a9,
  Global as aA,
  getMetricColor as aB,
  convertRemToPx as aC,
  hexToRgb as aD,
  withWrapper as aE,
  blend as aF,
  find$1 as aG,
  parse$1 as aH,
  parse$2 as aI,
  normalize$1 as aJ,
  html$2 as aK,
  svg as aL,
  getCrossOriginAttribute as aM,
  ViewStateContext as aN,
  useWindowDimensionsContext as aO,
  toPropertyKey$2 as aP,
  _typeof$g as aQ,
  _assertThisInitialized$1 as aR,
  _setPrototypeOf$e as aS,
  LocaleContext as aT,
  shouldWidthStretch as aU,
  ButtonGroup$1 as aV,
  StyledButtonGroup as aW,
  LabelVisibilityMessage as aX,
  SetCache as aY,
  cacheHas as aZ,
  baseRest as a_,
  getBorderColor as aa,
  TextInput$1 as ab,
  getDefaultExportFromCjs as ac,
  darken as ad,
  PortalContext as ae,
  LibConfigContext as af,
  classNames as ag,
  styled as ah,
  isFocusVisible as ai,
  getOverride as aj,
  getOverrideProps as ak,
  mergeOverrides as al,
  CUSTOM_INPUT_TYPE as am,
  ChevronDown$1 as an,
  PLACEMENT as ao,
  Tooltip$1 as ap,
  Icon$2 as aq,
  IsSidebarContext as ar,
  useStliteKernel as as,
  DownloadContext as at,
  StyledErrorMessage as au,
  LabelVisibilityOptions as av,
  StyledWidgetLabel as aw,
  getMetricBackgroundColor as ax,
  getMetricTextColor as ay,
  Metric$1 as az,
  BaseButtonTooltip as b,
  compareFields as b$,
  useSelectCommon as b0,
  Select as b1,
  VirtualDropdown as b2,
  TYPE as b3,
  NumberInput$1 as b4,
  useStyletron as b5,
  mergeOverride as b6,
  toObjectOverride as b7,
  Icon$1 as b8,
  DeleteAlt$1 as b9,
  getGray90 as bA,
  getDivergingColorsArray as bB,
  keysToSnakeCase as bC,
  PlotlyChart$1 as bD,
  themeColors as bE,
  isMobile as bF,
  UploadedFileInfo as bG,
  FileUploaderState as bH,
  __awaiter as bI,
  PropTypes as bJ,
  isFromWindows as bK,
  ThemeContext$1 as bL,
  pick$1 as bM,
  Slider$1 as bN,
  zip$1 as bO,
  baseSlice as bP,
  baseToString as bQ,
  trimmedEndIndex as bR,
  util_bn_ as bS,
  util_int_ as bT,
  util_bit_ as bU,
  util_math_ as bV,
  util_buffer_ as bW,
  util_vector_ as bX,
  util_pretty_ as bY,
  util_interval_ as bZ,
  compareTypes as b_,
  forkBlur as ba,
  forkFocus as bb,
  addCssUnit as bc,
  convert as bd,
  visitParents as be,
  SKIP as bf,
  isDatetimeType as bg,
  isDateType as bh,
  getTimezone as bi,
  debounce$2 as bj,
  isEqual$1 as bk,
  shouldHeightStretch as bl,
  toExportedTheme as bm,
  ArrowDataframe as bn,
  useTimeout as bo,
  Skeleton as bp,
  Skeleton$1 as bq,
  CustomComponentIFrame as br,
  ComponentRegistry as bs,
  requirePropTypes as bt,
  merge$1 as bu,
  getIncreasingGreen as bv,
  getDecreasingRed as bw,
  getBlue80 as bx,
  getGray30 as by,
  getGray70 as bz,
  BaseButton as c,
  getMarkdownBgColors as c$,
  compareSchemas as c0,
  getAugmentedNamespace as c1,
  isStringType as c2,
  isTimeType as c3,
  isPeriodType as c4,
  isIntervalType as c5,
  isDurationType as c6,
  isDecimalType as c7,
  isFloatType as c8,
  isObjectType as c9,
  structuredClone$1 as cA,
  commonjsGlobal$1 as cB,
  root$4 as cC,
  toNumber as cD,
  isObject$3 as cE,
  identity as cF,
  arrayEach as cG,
  baseEach as cH,
  isArray as cI,
  arrayMap as cJ,
  baseMap as cK,
  baseIteratee as cL,
  StatefulPopover as cM,
  _defineProperty$u as cN,
  filterOptions as cO,
  isArrayLike as cP,
  isBuffer as cQ,
  isTypedArray as cR,
  isArguments as cS,
  getTag as cT,
  isPrototype as cU,
  baseKeys as cV,
  requireClassnames as cW,
  Vector as cX,
  getLuminance as cY,
  parseIconPackEntry as cZ,
  genericFonts as c_,
  isListType as ca,
  TimeUnit as cb,
  Struct as cc,
  AcceptFileValue as cd,
  assertNever as ce,
  chatInputAcceptFileProtoValueToEnum as cf,
  ThemeProvider$1 as cg,
  createThemedStyled as ch,
  createThemedUseStyletron as ci,
  createThemedWithStyle as cj,
  expandBorderStyles as ck,
  withStyle as cl,
  requireReactIs$1 as cm,
  tableFromIPC as cn,
  v4 as co,
  requireBrowser as cp,
  UIDConsumer as cq,
  Popover$2 as cr,
  StatefulMenu as cs,
  ACCESSIBILITY_TYPE as ct,
  ok as cu,
  stringify$1 as cv,
  stringify as cw,
  pointStart as cx,
  visit as cy,
  pointEnd as cz,
  BaseButtonSize as d,
  StliteAppWithToast as d$,
  isUnsignedIntegerType as d0,
  isIntegerType as d1,
  isBooleanType as d2,
  Field as d3,
  Null as d4,
  isRangeIndexType as d5,
  isEmptyType as d6,
  isBytesType as d7,
  isCategoricalType as d8,
  fontSizes as d9,
  from as dA,
  peek$1 as dB,
  delimit as dC,
  slice as dD,
  position$3 as dE,
  compile as dF,
  getRegisteredStyles as dG,
  serializeStyles as dH,
  registerStyles as dI,
  insertStyles as dJ,
  lighten as dK,
  mix$1 as dL,
  TRIGGER_TYPE as dM,
  StyledTooltipContentWrapper as dN,
  FlexContext as dO,
  useScrollbarGutterSize as dP,
  Resizable as dQ,
  streamlit as dR,
  StyledCodeBlock as dS,
  StyledPre as dT,
  StyledCopyButtonContainer as dU,
  CopyButton$1 as dV,
  propTypesExports as dW,
  index as dX,
  parseToRgba as dY,
  DeckGlJsonChart$1 as dZ,
  StliteApp as d_,
  mergeWith as da,
  _objectWithoutProperties$1 as db,
  stringify$2 as dc,
  rulesheet as dd,
  COMMENT as de,
  middleware as df,
  RULESET as dg,
  combine as dh,
  KEYFRAMES as di,
  serialize$2 as dj,
  copy as dk,
  replace$1 as dl,
  DECLARATION as dm,
  dealloc as dn,
  alloc as dp,
  hash$1 as dq,
  charat as dr,
  WEBKIT as ds,
  MS as dt,
  strlen as du,
  indexof as dv,
  MOZ as dw,
  match as dx,
  next as dy,
  token as dz,
  isNullOrUndefined as e,
  createKernel as e0,
  useKernel as e1,
  useCalculatedDimensions as f,
  useEmotionTheme as g,
  hoistNonReactStatics as h,
  isValidFormId as i,
  jsxRuntimeExports as j,
  hasLightBackgroundColor as k,
  StyledContent as l,
  labelVisibilityProtoValueToEnum as m,
  notNullOrUndefined as n,
  StreamlitMarkdown$1 as o,
  StyledWidgetLabelHelpInline as p,
  getOverrides as q,
  SIZE$1 as r,
  ENHANCER_POSITION as s,
  transparentize as t,
  useRegisterShortcut as u,
  createStyled as v,
  isPropValid as w,
  StyledDropdownListItem as x,
  toString$3 as y,
  findAndReplace as z
};
//# sourceMappingURL=index-CAGYsLgS.js.map
